(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 44642:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  /* eslint-disable no-prototype-builtins */
  var g =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    // eslint-disable-next-line no-undef
    (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
    {};

  var support = {
    searchParams: 'URLSearchParams' in g,
    iterable: 'Symbol' in g && 'iterator' in Symbol,
    blob:
      'FileReader' in g &&
      'Blob' in g &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in g,
    arrayBuffer: 'ArrayBuffer' in g
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        if (header.length != 2) {
          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
        }
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body._noBody) return
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      // eslint-disable-next-line no-self-assign
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._noBody = true;
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else if (support.blob) {
        return this.blob().then(readBlobAsArrayBuffer)
      } else {
        throw new Error('could not read as ArrayBuffer')
      }
    };

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || (function () {
      if ('AbortController' in g) {
        var ctrl = new AbortController();
        return ctrl.signal;
      }
    }());
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          try {
            headers.append(key, value);
          } catch (error) {
            console.warn('Response ' + error.message);
          }
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) {
      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
    }
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 200, statusText: ''});
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = g.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        // This check if specifically for when a user fetches a file locally from the file system
        // Only if the status is out of a normal range
        if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
          options.status = 200;
        } else {
          options.status = xhr.status;
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request timed out'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && g.location.href ? g.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
        var names = [];
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          names.push(normalizeName(name));
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        request.headers.forEach(function(value, name) {
          if (names.indexOf(name) === -1) {
            xhr.setRequestHeader(name, value);
          }
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!g.fetch) {
    g.fetch = fetch;
    g.Headers = Headers;
    g.Request = Request;
    g.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 45704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kZ": function() { return /* binding */ popperGenerator; }
});

// UNUSED EXPORTS: createPopper, detectOverflow

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
var getBoundingClientRect = __webpack_require__(50400);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
var getWindowScroll = __webpack_require__(82163);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === (0,getWindow/* default */.Z)(node) || !(0,instanceOf/* isHTMLElement */.Re)(node)) {
    return (0,getWindowScroll/* default */.Z)(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
var getWindowScrollBarX = __webpack_require__(4063);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
var getDocumentElement = __webpack_require__(67252);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
var isScrollParent = __webpack_require__(60611);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(138);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = (0,math/* round */.NM)(rect.width) / element.offsetWidth || 1;
  var scaleY = (0,math/* round */.NM)(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = (0,instanceOf/* isHTMLElement */.Re)(offsetParent);
  var offsetParentIsScaled = (0,instanceOf/* isHTMLElement */.Re)(offsetParent) && isElementScaled(offsetParent);
  var documentElement = (0,getDocumentElement/* default */.Z)(offsetParent);
  var rect = (0,getBoundingClientRect/* default */.Z)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,getNodeName/* default */.Z)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    (0,isScrollParent/* default */.Z)(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if ((0,instanceOf/* isHTMLElement */.Re)(offsetParent)) {
      offsets = (0,getBoundingClientRect/* default */.Z)(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = (0,getWindowScrollBarX/* default */.Z)(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
var getLayoutRect = __webpack_require__(40583);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js + 1 modules
var listScrollParents = __webpack_require__(31492);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(98552);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return enums/* modifierPhases.reduce */.xs.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: (0,instanceOf/* isElement */.kK)(reference) ? (0,listScrollParents/* default */.Z)(reference) : reference.contextElement ? (0,listScrollParents/* default */.Z)(reference.contextElement) : [],
          popper: (0,listScrollParents/* default */.Z)(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, (0,getOffsetParent/* default */.Z)(popper), state.options.strategy === 'fixed'),
          popper: (0,getLayoutRect/* default */.Z)(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ 94985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62556);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isShadowRoot */ .Zq)(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),

/***/ 50400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBoundingClientRect; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62556);
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(138);
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62057);
/* harmony import */ var _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67977);




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isHTMLElement */ .Re)(element)) {
    scaleX = element.offsetWidth > 0 ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(element) ? (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !(0,_isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

/***/ }),

/***/ 43062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getComputedStyle; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);

function getComputedStyle(element) {
  return (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element).getComputedStyle(element);
}

/***/ }),

/***/ 67252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDocumentElement; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62556);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return (((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),

/***/ 40583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLayoutRect; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50400);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),

/***/ 96333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getNodeName; }
/* harmony export */ });
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),

/***/ 98552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getOffsetParent; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
var getComputedStyle = __webpack_require__(43062);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf((0,getNodeName/* default */.Z)(element)) >= 0;
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
var userAgent = __webpack_require__(85918);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!(0,instanceOf/* isHTMLElement */.Re)(element) || // https://github.com/popperjs/popper-core/issues/837
  (0,getComputedStyle/* default */.Z)(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test((0,userAgent/* default */.Z)());
  var isIE = /Trident/i.test((0,userAgent/* default */.Z)());

  if (isIE && (0,instanceOf/* isHTMLElement */.Re)(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = (0,getComputedStyle/* default */.Z)(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = (0,getParentNode/* default */.Z)(element);

  if ((0,instanceOf/* isShadowRoot */.Zq)(currentNode)) {
    currentNode = currentNode.host;
  }

  while ((0,instanceOf/* isHTMLElement */.Re)(currentNode) && ['html', 'body'].indexOf((0,getNodeName/* default */.Z)(currentNode)) < 0) {
    var css = (0,getComputedStyle/* default */.Z)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = (0,getWindow/* default */.Z)(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && (0,getComputedStyle/* default */.Z)(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && ((0,getNodeName/* default */.Z)(offsetParent) === 'html' || (0,getNodeName/* default */.Z)(offsetParent) === 'body' && (0,getComputedStyle/* default */.Z)(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),

/***/ 95923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getParentNode; }
/* harmony export */ });
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96333);
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67252);
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62556);



function getParentNode(element) {
  if ((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__/* .isShadowRoot */ .Zq)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element) // fallback

  );
}

/***/ }),

/***/ 62057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindow; }
/* harmony export */ });
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),

/***/ 82163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindowScroll; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);

function getWindowScroll(node) {
  var win = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),

/***/ 4063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindowScrollBarX; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50400);
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67252);
/* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82163);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(element)).left + (0,_getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element).scrollLeft;
}

/***/ }),

/***/ 62556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; },
/* harmony export */   "kK": function() { return /* binding */ isElement; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);


function isElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),

/***/ 67977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLayoutViewport; }
/* harmony export */ });
/* harmony import */ var _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85918);

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test((0,_utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)());
}

/***/ }),

/***/ 60611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isScrollParent; }
/* harmony export */ });
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43062);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),

/***/ 31492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ listScrollParents; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
var isScrollParent = __webpack_require__(60611);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf((0,getNodeName/* default */.Z)(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if ((0,instanceOf/* isHTMLElement */.Re)(node) && (0,isScrollParent/* default */.Z)(node)) {
    return node;
  }

  return getScrollParent((0,getParentNode/* default */.Z)(node));
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = (0,getWindow/* default */.Z)(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], (0,isScrollParent/* default */.Z)(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents((0,getParentNode/* default */.Z)(target)));
}

/***/ }),

/***/ 87701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ start; },
/* harmony export */   "Ct": function() { return /* binding */ placements; },
/* harmony export */   "F2": function() { return /* binding */ right; },
/* harmony export */   "I": function() { return /* binding */ bottom; },
/* harmony export */   "Pj": function() { return /* binding */ viewport; },
/* harmony export */   "YP": function() { return /* binding */ reference; },
/* harmony export */   "bw": function() { return /* binding */ variationPlacements; },
/* harmony export */   "d7": function() { return /* binding */ auto; },
/* harmony export */   "k5": function() { return /* binding */ popper; },
/* harmony export */   "mv": function() { return /* binding */ basePlacements; },
/* harmony export */   "t$": function() { return /* binding */ left; },
/* harmony export */   "ut": function() { return /* binding */ end; },
/* harmony export */   "we": function() { return /* binding */ top; },
/* harmony export */   "xs": function() { return /* binding */ modifierPhases; },
/* harmony export */   "zV": function() { return /* binding */ clippingParents; }
/* harmony export */ });
/* unused harmony exports beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite */
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),

/***/ 66896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6206);
/* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40583);
/* harmony import */ var _dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94985);
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98552);
/* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11516);
/* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57516);
/* harmony import */ var _utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63293);
/* harmony import */ var _utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33706);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87701);








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return (0,_utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(typeof padding !== 'number' ? padding : (0,_utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(padding, _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .basePlacements */ .mv));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(state.placement);
  var axis = (0,_utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(basePlacement);
  var isVertical = [_enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = (0,_dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(arrowElement);
  var minProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we : _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$;
  var maxProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I : _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_7__/* .within */ .u)(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!(0,_dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),

/***/ 36531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87701);
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98552);
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62057);
/* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67252);
/* harmony import */ var _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43062);
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6206);
/* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14943);
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(x * dpr) / dpr || 0,
    y: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$;
  var sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we;
  var win = window;

  if (adaptive) {
    var offsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(popper)) {
      offsetParent = (0,_dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(popper);

      if ((0,_dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$ || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .end */ .ut) {
      sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .I;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$ || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .I) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .end */ .ut) {
      sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.placement),
    variation: (0,_utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),

/***/ 82372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),

/***/ 68855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modifiers_flip; }
});

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js
var getBasePlacement = __webpack_require__(6206);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js + 4 modules
var detectOverflow = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
var getVariation = __webpack_require__(14943);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums/* placements */.Ct : _options$allowedAutoP;
  var variation = (0,getVariation/* default */.Z)(placement);
  var placements = variation ? flipVariations ? enums/* variationPlacements */.bw : enums/* variationPlacements.filter */.bw.filter(function (placement) {
    return (0,getVariation/* default */.Z)(placement) === variation;
  }) : enums/* basePlacements */.mv;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = (0,detectOverflow/* default */.Z)(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[(0,getBasePlacement/* default */.Z)(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if ((0,getBasePlacement/* default */.Z)(placement) === enums/* auto */.d7) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = (0,getBasePlacement/* default */.Z)(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat((0,getBasePlacement/* default */.Z)(placement) === enums/* auto */.d7 ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = (0,getBasePlacement/* default */.Z)(placement);

    var isStartVariation = (0,getVariation/* default */.Z)(placement) === enums/* start */.BL;
    var isVertical = [enums/* top */.we, enums/* bottom */.I].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = (0,detectOverflow/* default */.Z)(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? enums/* right */.F2 : enums/* left */.t$ : isStartVariation ? enums/* bottom */.I : enums/* top */.we;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),

/***/ 19892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87701);
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6486);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [_enums_js__WEBPACK_IMPORTED_MODULE_0__/* .top */ .we, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .right */ .F2, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .bottom */ .I, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .left */ .t$].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),

/***/ 82122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6206);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87701);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(placement);
  var invertDistance = [_enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [_enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .placements.reduce */ .Ct.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),

/***/ 77421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72581);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = (0,_utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),

/***/ 394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modifiers_preventOverflow; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js
var getBasePlacement = __webpack_require__(6206);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
var getMainAxisFromPlacement = __webpack_require__(11516);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/within.js
var within = __webpack_require__(57516);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
var getLayoutRect = __webpack_require__(40583);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(98552);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js + 4 modules
var detectOverflow = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
var getVariation = __webpack_require__(14943);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
var getFreshSideObject = __webpack_require__(23607);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(138);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = (0,detectOverflow/* default */.Z)(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = (0,getBasePlacement/* default */.Z)(state.placement);
  var variation = (0,getVariation/* default */.Z)(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = (0,getMainAxisFromPlacement/* default */.Z)(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums/* top */.we : enums/* left */.t$;
    var altSide = mainAxis === 'y' ? enums/* bottom */.I : enums/* right */.F2;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums/* start */.BL ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums/* start */.BL ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? (0,getLayoutRect/* default */.Z)(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0,getFreshSideObject/* default */.Z)();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = (0,within/* within */.u)(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && (0,getOffsetParent/* default */.Z)(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = (0,within/* within */.u)(tether ? (0,math/* min */.VV)(min, tetherMin) : min, offset, tether ? (0,math/* max */.Fp)(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums/* top */.we : enums/* left */.t$;

    var _altSide = mainAxis === 'x' ? enums/* bottom */.I : enums/* right */.F2;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums/* top */.we, enums/* left */.t$].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? (0,within/* withinMaxClamp */.q)(_tetherMin, _offset, _tetherMax) : (0,within/* within */.u)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),

/***/ 72581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ computeOffsets; }
/* harmony export */ });
/* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6206);
/* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14943);
/* harmony import */ var _getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11516);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87701);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? (0,_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(placement) : null;
  var variation = placement ? (0,_getVariation_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? (0,_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .start */ .BL:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .end */ .ut:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),

/***/ 6486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detectOverflow; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
var getDocumentElement = __webpack_require__(67252);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
var getWindowScrollBarX = __webpack_require__(4063);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
var isLayoutViewport = __webpack_require__(67977);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = (0,getWindow/* default */.Z)(element);
  var html = (0,getDocumentElement/* default */.Z)(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = (0,isLayoutViewport/* default */.Z)();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + (0,getWindowScrollBarX/* default */.Z)(element),
    y: y
  };
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
var getComputedStyle = __webpack_require__(43062);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
var getWindowScroll = __webpack_require__(82163);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(138);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = (0,getDocumentElement/* default */.Z)(element);
  var winScroll = (0,getWindowScroll/* default */.Z)(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = (0,math/* max */.Fp)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = (0,math/* max */.Fp)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + (0,getWindowScrollBarX/* default */.Z)(element);
  var y = -winScroll.scrollTop;

  if ((0,getComputedStyle/* default */.Z)(body || html).direction === 'rtl') {
    x += (0,math/* max */.Fp)(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js + 1 modules
var listScrollParents = __webpack_require__(31492);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(98552);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
var getBoundingClientRect = __webpack_require__(50400);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js
var contains = __webpack_require__(94985);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = (0,getBoundingClientRect/* default */.Z)(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === enums/* viewport */.Pj ? rectToClientRect(getViewportRect(element, strategy)) : (0,instanceOf/* isElement */.kK)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect((0,getDocumentElement/* default */.Z)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = (0,listScrollParents/* default */.Z)((0,getParentNode/* default */.Z)(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf((0,getComputedStyle/* default */.Z)(element).position) >= 0;
  var clipperElement = canEscapeClipping && (0,instanceOf/* isHTMLElement */.Re)(element) ? (0,getOffsetParent/* default */.Z)(element) : element;

  if (!(0,instanceOf/* isElement */.kK)(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return (0,instanceOf/* isElement */.kK)(clippingParent) && (0,contains/* default */.Z)(clippingParent, clipperElement) && (0,getNodeName/* default */.Z)(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = (0,math/* max */.Fp)(rect.top, accRect.top);
    accRect.right = (0,math/* min */.VV)(rect.right, accRect.right);
    accRect.bottom = (0,math/* min */.VV)(rect.bottom, accRect.bottom);
    accRect.left = (0,math/* max */.Fp)(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js
var computeOffsets = __webpack_require__(72581);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
var mergePaddingObject = __webpack_require__(63293);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
var expandToHashMap = __webpack_require__(33706);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums/* clippingParents */.zV : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? enums/* viewport */.Pj : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums/* popper */.k5 : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = (0,mergePaddingObject/* default */.Z)(typeof padding !== 'number' ? padding : (0,expandToHashMap/* default */.Z)(padding, enums/* basePlacements */.mv));
  var altContext = elementContext === enums/* popper */.k5 ? enums/* reference */.YP : enums/* popper */.k5;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect((0,instanceOf/* isElement */.kK)(element) ? element : element.contextElement || (0,getDocumentElement/* default */.Z)(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = (0,getBoundingClientRect/* default */.Z)(state.elements.reference);
  var popperOffsets = (0,computeOffsets/* default */.Z)({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums/* popper */.k5 ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums/* popper */.k5 && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [enums/* right */.F2, enums/* bottom */.I].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums/* top */.we, enums/* bottom */.I].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),

/***/ 33706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ expandToHashMap; }
/* harmony export */ });
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),

/***/ 6206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBasePlacement; }
/* harmony export */ });

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),

/***/ 23607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFreshSideObject; }
/* harmony export */ });
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),

/***/ 11516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getMainAxisFromPlacement; }
/* harmony export */ });
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),

/***/ 14943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getVariation; }
/* harmony export */ });
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),

/***/ 138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fp": function() { return /* binding */ max; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "VV": function() { return /* binding */ min; }
/* harmony export */ });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),

/***/ 63293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergePaddingObject; }
/* harmony export */ });
/* harmony import */ var _getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23607);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, (0,_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), paddingObject);
}

/***/ }),

/***/ 85918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUAString; }
/* harmony export */ });
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

/***/ }),

/***/ 57516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ withinMaxClamp; },
/* harmony export */   "u": function() { return /* binding */ within; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);

function within(min, value, max) {
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .max */ .Fp)(min, (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .min */ .VV)(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),

/***/ 77236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; },
  "SI": function() { return /* binding */ unwrapResult; }
});

// UNUSED EXPORTS: MiddlewareArray, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, bindActionCreators, clearAllListeners, combineReducers, compose, createAction, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, nanoid, original, removeListener

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return redux/* compose */.qC;
    return redux/* compose.apply */.qC.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value === null || typeof value === "undefined" || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    for (var key in keysToDetect) {
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
            continue;
        }
        var result = detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) {
            return result;
        }
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return type === "undefined" || val === null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) {
            continue;
        }
        if (!isSerializable(nestedValue)) {
            return {
                keyPath: nestedPath,
                value: nestedValue
            };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) {
                return foundNestedSerializable;
            }
        }
    }
    return false;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject(reducer)) {
        rootReducer = (0,redux/* combineReducers */.UY)(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = redux/* applyMiddleware.apply */.md.apply(void 0, finalMiddleware);
    var finalCompose = redux/* compose */.qC;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var storeEnhancers = [middlewareEnhancer];
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(storeEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0,redux/* createStore */.MT)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isFSA(action) {
    return isPlainObject(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return immer_esm(initialState(), function () {
        }); };
    }
    else {
        var frozenInitialState_1 = immer_esm(initialState, function () {
        });
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (typeof result === "undefined") {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (typeof result === "undefined") {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    var initialState = typeof options.initialState == "function" ? options.initialState : immer_esm(options.initialState, function () {
    });
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, finalCaseReducers, actionMatchers, defaultCaseReducer);
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState2(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = state.ids.map(function (id) { return newKeys[id] || id; });
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function takeUpdatedModel(models, update, state) {
        if (!(update.id in state.entities)) {
            return false;
        }
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        delete state.entities[update.id];
        models.push(updated);
        return newKey !== update.id;
    }
    function updateManyMutably(updates, state) {
        var models = [];
        updates.forEach(function (update) { return takeUpdatedModel(models, update, state); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
function createAsyncThunk(typePrefix, payloadCreator, options) {
    var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
        payload: payload,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "fulfilled"
        })
    }); });
    var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "pending"
        })
    }); });
    var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
        payload: payload,
        error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            rejectedWithValue: !!payload,
            requestStatus: "rejected",
            aborted: (error == null ? void 0 : error.name) === "AbortError",
            condition: (error == null ? void 0 : error.name) === "ConditionError"
        })
    }); });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
        function class_1() {
            this.signal = {
                aborted: false,
                addEventListener: function () {
                },
                dispatchEvent: function () {
                    return false;
                },
                onabort: function () {
                },
                removeEventListener: function () {
                }
            };
        }
        class_1.prototype.abort = function () {
            if (false) {}
        };
        return class_1;
    }());
    function actionCreator(arg) {
        return function (dispatch, getState, extra) {
            var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
            var abortController = new AC();
            var abortReason;
            var abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({ name: "AbortError", message: abortReason || "Aborted" }); }); });
            var started = false;
            function abort(reason) {
                if (started) {
                    abortReason = reason;
                    abortController.abort();
                }
            }
            var promise = function () {
                return __async(this, null, function () {
                    var _a, _b, finalAction, conditionResult, err_1, skipDispatch;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 4, , 5]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                return [4 /*yield*/, conditionResult];
                            case 1:
                                conditionResult = _c.sent();
                                _c.label = 2;
                            case 2:
                                if (conditionResult === false) {
                                    throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                }
                                started = true;
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                return [4 /*yield*/, Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            rejectWithValue: function (value, meta) {
                                                return new RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function (value, meta) {
                                                return new FulfillWithMeta(value, meta);
                                            }
                                        })).then(function (result) {
                                            if (result instanceof RejectWithValue) {
                                                throw result;
                                            }
                                            if (result instanceof FulfillWithMeta) {
                                                return fulfilled(result.payload, requestId, arg, result.meta);
                                            }
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])];
                            case 3:
                                finalAction = _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _c.sent();
                                finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                return [3 /*break*/, 5];
                            case 5:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) {
                                    dispatch(finalAction);
                                }
                                return [2 /*return*/, finalAction];
                        }
                    });
                });
            }();
            return Object.assign(promise, {
                abort: abort,
                requestId: requestId,
                arg: arg,
                unwrap: function () {
                    return promise.then(unwrapResult);
                }
            });
        };
    }
    return Object.assign(actionCreator, {
        pending: pending,
        rejected: rejected,
        fulfilled: fulfilled,
        typePrefix: typePrefix
    });
}
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise, onError) {
    if (onError === void 0) { onError = noop; }
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
var promisifyAbortSignal = function (signal) {
    return catchRejection(new Promise(function (_, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
        }
        else {
            addAbortSignalListener(signal, notifyRejection);
        }
    }));
};
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise) {
        return catchRejection(Promise.race([promisifyAbortSignal(signal), promise]).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve) {
                        unsubscribe = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                    });
                    promises = [
                        promisifyAbortSignal(signal),
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.race(promises)];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/index.ts
F();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 58363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;

exports["default"] = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');

    if (acceptedFilesArray.length === 0) {
      return true;
    }

    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 25730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ (function(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ (function(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ (function(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ 2350:
/***/ (function() {



/***/ }),

/***/ 67389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * content-disposition
 * Copyright(c) 2014-2017 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

module.exports = contentDisposition
module.exports.parse = parse

/**
 * Module dependencies.
 * @private
 */

var basename = (__webpack_require__(1864).basename)
var Buffer = (__webpack_require__(89509).Buffer)

/**
 * RegExp to match non attr-char, *after* encodeURIComponent (i.e. not including "%")
 * @private
 */

var ENCODE_URL_ATTR_CHAR_REGEXP = /[\x00-\x20"'()*,/:;<=>?@[\\\]{}\x7f]/g // eslint-disable-line no-control-regex

/**
 * RegExp to match percent encoding escape.
 * @private
 */

var HEX_ESCAPE_REGEXP = /%[0-9A-Fa-f]{2}/
var HEX_ESCAPE_REPLACE_REGEXP = /%([0-9A-Fa-f]{2})/g

/**
 * RegExp to match non-latin1 characters.
 * @private
 */

var NON_LATIN1_REGEXP = /[^\x20-\x7e\xa0-\xff]/g

/**
 * RegExp to match quoted-pair in RFC 2616
 *
 * quoted-pair = "\" CHAR
 * CHAR        = <any US-ASCII character (octets 0 - 127)>
 * @private
 */

var QESC_REGEXP = /\\([\u0000-\u007f])/g // eslint-disable-line no-control-regex

/**
 * RegExp to match chars that must be quoted-pair in RFC 2616
 * @private
 */

var QUOTE_REGEXP = /([\\"])/g

/**
 * RegExp for various RFC 2616 grammar
 *
 * parameter     = token "=" ( token | quoted-string )
 * token         = 1*<any CHAR except CTLs or separators>
 * separators    = "(" | ")" | "<" | ">" | "@"
 *               | "," | ";" | ":" | "\" | <">
 *               | "/" | "[" | "]" | "?" | "="
 *               | "{" | "}" | SP | HT
 * quoted-string = ( <"> *(qdtext | quoted-pair ) <"> )
 * qdtext        = <any TEXT except <">>
 * quoted-pair   = "\" CHAR
 * CHAR          = <any US-ASCII character (octets 0 - 127)>
 * TEXT          = <any OCTET except CTLs, but including LWS>
 * LWS           = [CRLF] 1*( SP | HT )
 * CRLF          = CR LF
 * CR            = <US-ASCII CR, carriage return (13)>
 * LF            = <US-ASCII LF, linefeed (10)>
 * SP            = <US-ASCII SP, space (32)>
 * HT            = <US-ASCII HT, horizontal-tab (9)>
 * CTL           = <any US-ASCII control character (octets 0 - 31) and DEL (127)>
 * OCTET         = <any 8-bit sequence of data>
 * @private
 */

var PARAM_REGEXP = /;[\x09\x20]*([!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*=[\x09\x20]*("(?:[\x20!\x23-\x5b\x5d-\x7e\x80-\xff]|\\[\x20-\x7e])*"|[!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*/g // eslint-disable-line no-control-regex
var TEXT_REGEXP = /^[\x20-\x7e\x80-\xff]+$/
var TOKEN_REGEXP = /^[!#$%&'*+.0-9A-Z^_`a-z|~-]+$/

/**
 * RegExp for various RFC 5987 grammar
 *
 * ext-value     = charset  "'" [ language ] "'" value-chars
 * charset       = "UTF-8" / "ISO-8859-1" / mime-charset
 * mime-charset  = 1*mime-charsetc
 * mime-charsetc = ALPHA / DIGIT
 *               / "!" / "#" / "$" / "%" / "&"
 *               / "+" / "-" / "^" / "_" / "`"
 *               / "{" / "}" / "~"
 * language      = ( 2*3ALPHA [ extlang ] )
 *               / 4ALPHA
 *               / 5*8ALPHA
 * extlang       = *3( "-" 3ALPHA )
 * value-chars   = *( pct-encoded / attr-char )
 * pct-encoded   = "%" HEXDIG HEXDIG
 * attr-char     = ALPHA / DIGIT
 *               / "!" / "#" / "$" / "&" / "+" / "-" / "."
 *               / "^" / "_" / "`" / "|" / "~"
 * @private
 */

var EXT_VALUE_REGEXP = /^([A-Za-z0-9!#$%&+\-^_`{}~]+)'(?:[A-Za-z]{2,3}(?:-[A-Za-z]{3}){0,3}|[A-Za-z]{4,8}|)'((?:%[0-9A-Fa-f]{2}|[A-Za-z0-9!#$&+.^_`|~-])+)$/

/**
 * RegExp for various RFC 6266 grammar
 *
 * disposition-type = "inline" | "attachment" | disp-ext-type
 * disp-ext-type    = token
 * disposition-parm = filename-parm | disp-ext-parm
 * filename-parm    = "filename" "=" value
 *                  | "filename*" "=" ext-value
 * disp-ext-parm    = token "=" value
 *                  | ext-token "=" ext-value
 * ext-token        = <the characters in token, followed by "*">
 * @private
 */

var DISPOSITION_TYPE_REGEXP = /^([!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*(?:$|;)/ // eslint-disable-line no-control-regex

/**
 * Create an attachment Content-Disposition header.
 *
 * @param {string} [filename]
 * @param {object} [options]
 * @param {string} [options.type=attachment]
 * @param {string|boolean} [options.fallback=true]
 * @return {string}
 * @public
 */

function contentDisposition (filename, options) {
  var opts = options || {}

  // get type
  var type = opts.type || 'attachment'

  // get parameters
  var params = createparams(filename, opts.fallback)

  // format into string
  return format(new ContentDisposition(type, params))
}

/**
 * Create parameters object from filename and fallback.
 *
 * @param {string} [filename]
 * @param {string|boolean} [fallback=true]
 * @return {object}
 * @private
 */

function createparams (filename, fallback) {
  if (filename === undefined) {
    return
  }

  var params = {}

  if (typeof filename !== 'string') {
    throw new TypeError('filename must be a string')
  }

  // fallback defaults to true
  if (fallback === undefined) {
    fallback = true
  }

  if (typeof fallback !== 'string' && typeof fallback !== 'boolean') {
    throw new TypeError('fallback must be a string or boolean')
  }

  if (typeof fallback === 'string' && NON_LATIN1_REGEXP.test(fallback)) {
    throw new TypeError('fallback must be ISO-8859-1 string')
  }

  // restrict to file base name
  var name = basename(filename)

  // determine if name is suitable for quoted string
  var isQuotedString = TEXT_REGEXP.test(name)

  // generate fallback name
  var fallbackName = typeof fallback !== 'string'
    ? fallback && getlatin1(name)
    : basename(fallback)
  var hasFallback = typeof fallbackName === 'string' && fallbackName !== name

  // set extended filename parameter
  if (hasFallback || !isQuotedString || HEX_ESCAPE_REGEXP.test(name)) {
    params['filename*'] = name
  }

  // set filename parameter
  if (isQuotedString || hasFallback) {
    params.filename = hasFallback
      ? fallbackName
      : name
  }

  return params
}

/**
 * Format object to Content-Disposition header.
 *
 * @param {object} obj
 * @param {string} obj.type
 * @param {object} [obj.parameters]
 * @return {string}
 * @private
 */

function format (obj) {
  var parameters = obj.parameters
  var type = obj.type

  if (!type || typeof type !== 'string' || !TOKEN_REGEXP.test(type)) {
    throw new TypeError('invalid type')
  }

  // start with normalized type
  var string = String(type).toLowerCase()

  // append parameters
  if (parameters && typeof parameters === 'object') {
    var param
    var params = Object.keys(parameters).sort()

    for (var i = 0; i < params.length; i++) {
      param = params[i]

      var val = param.substr(-1) === '*'
        ? ustring(parameters[param])
        : qstring(parameters[param])

      string += '; ' + param + '=' + val
    }
  }

  return string
}

/**
 * Decode a RFC 5987 field value (gracefully).
 *
 * @param {string} str
 * @return {string}
 * @private
 */

function decodefield (str) {
  var match = EXT_VALUE_REGEXP.exec(str)

  if (!match) {
    throw new TypeError('invalid extended field value')
  }

  var charset = match[1].toLowerCase()
  var encoded = match[2]
  var value

  // to binary string
  var binary = encoded.replace(HEX_ESCAPE_REPLACE_REGEXP, pdecode)

  switch (charset) {
    case 'iso-8859-1':
      value = getlatin1(binary)
      break
    case 'utf-8':
      value = Buffer.from(binary, 'binary').toString('utf8')
      break
    default:
      throw new TypeError('unsupported charset in extended field')
  }

  return value
}

/**
 * Get ISO-8859-1 version of string.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function getlatin1 (val) {
  // simple Unicode -> ISO-8859-1 transformation
  return String(val).replace(NON_LATIN1_REGEXP, '?')
}

/**
 * Parse Content-Disposition header string.
 *
 * @param {string} string
 * @return {object}
 * @public
 */

function parse (string) {
  if (!string || typeof string !== 'string') {
    throw new TypeError('argument string is required')
  }

  var match = DISPOSITION_TYPE_REGEXP.exec(string)

  if (!match) {
    throw new TypeError('invalid type format')
  }

  // normalize type
  var index = match[0].length
  var type = match[1].toLowerCase()

  var key
  var names = []
  var params = {}
  var value

  // calculate index to start at
  index = PARAM_REGEXP.lastIndex = match[0].substr(-1) === ';'
    ? index - 1
    : index

  // match parameters
  while ((match = PARAM_REGEXP.exec(string))) {
    if (match.index !== index) {
      throw new TypeError('invalid parameter format')
    }

    index += match[0].length
    key = match[1].toLowerCase()
    value = match[2]

    if (names.indexOf(key) !== -1) {
      throw new TypeError('invalid duplicate parameter')
    }

    names.push(key)

    if (key.indexOf('*') + 1 === key.length) {
      // decode extended value
      key = key.slice(0, -1)
      value = decodefield(value)

      // overwrite existing value
      params[key] = value
      continue
    }

    if (typeof params[key] === 'string') {
      continue
    }

    if (value[0] === '"') {
      // remove quotes and escapes
      value = value
        .substr(1, value.length - 2)
        .replace(QESC_REGEXP, '$1')
    }

    params[key] = value
  }

  if (index !== -1 && index !== string.length) {
    throw new TypeError('invalid parameter format')
  }

  return new ContentDisposition(type, params)
}

/**
 * Percent decode a single character.
 *
 * @param {string} str
 * @param {string} hex
 * @return {string}
 * @private
 */

function pdecode (str, hex) {
  return String.fromCharCode(parseInt(hex, 16))
}

/**
 * Percent encode a single character.
 *
 * @param {string} char
 * @return {string}
 * @private
 */

function pencode (char) {
  return '%' + String(char)
    .charCodeAt(0)
    .toString(16)
    .toUpperCase()
}

/**
 * Quote a string for HTTP.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring (val) {
  var str = String(val)

  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"'
}

/**
 * Encode a Unicode string for HTTP (RFC 5987).
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function ustring (val) {
  var str = String(val)

  // percent encode as UTF-8
  var encoded = encodeURIComponent(str)
    .replace(ENCODE_URL_ATTR_CHAR_REGEXP, pencode)

  return 'UTF-8\'\'' + encoded
}

/**
 * Class for parsed Content-Disposition header for v8 optimization
 *
 * @public
 * @param {string} type
 * @param {object} parameters
 * @constructor
 */

function ContentDisposition (type, parameters) {
  this.type = type
  this.parameters = parameters
}


/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 54098:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 27484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),

/***/ 77989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,n){ true?module.exports=n(__webpack_require__(27484)):0}(this,(function(e){"use strict";function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=n(e),_={name:"fr-ca",weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),ordinal:function(e){return e},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"}};return i.default.locale(_,null,!0),_}));

/***/ }),

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n,i=this.utcOffset(),a=this.toDate(),u=a.toLocaleString("en-US",{timeZone:t}),f=Math.round((a-new Date(u))/1e3/60),s=15*-Math.round(a.getTimezoneOffset()/15)-f;if(!Number(s))n=this.utcOffset(0,e);else if(n=o(u,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(s,!0),e){var m=n.utcOffset();n=n.add(i-m,"minute")}return n.$x.$timezone=t,n},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 70178:
/***/ (function(module) {

!function(t,i){ true?module.exports=i():0}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var r=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),r.call(this,t)};var o=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else o.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s;if(0===u)return this.utc(f);var r=this.clone();if(f)return r.$offset=u,r.$u=!1,r;var o=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();return(r=this.local().add(u+o,t)).$offset=u,r.$x.$localOffset=o,r};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),

/***/ 25643:
/***/ (function(module) {

module.exports = false;



/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 47915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_js_1 = __webpack_require__(97790);
__exportStar(__webpack_require__(97790), exports);
// Default options
var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_js_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_js_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            var node = new node_js_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_js_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_js_1.Text("");
        var node = new node_js_1.CDATA([text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 97790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    function Node() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */
    function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */ (function (_super) {
    __extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}(NodeWithChildren));
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 2.5.9 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.9/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf,
    isFrozen = Object.isFrozen,
    getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
    seal = Object.seal,
    create = Object.create; // eslint-disable-line import/no-mutable-exports
  var _ref = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref.apply,
    construct = _ref.construct;
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }
  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;
    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);
    var property;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }
    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }
    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);
  var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }
    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.5.9';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      Element = window.Element,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      HTMLFormElement = window.HTMLFormElement,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      createDocumentFragment = _document.createDocumentFragment,
      getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}
    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
      ERB_EXPR$1 = ERB_EXPR,
      TMPLIT_EXPR$1 = TMPLIT_EXPR,
      DATA_ATTR$1 = DATA_ATTR,
      ARIA_ATTR$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
      CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    var ALLOW_SELF_CLOSE_IN_ATTR = true;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    var SAFE_FOR_XML = true;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    var SANITIZE_DOM = true;

    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Allowed XHTML+XML namespaces */
    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');
    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);

    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }
      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      var body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }
      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any ocurrence of processing instructions */
      if (currentNode.nodeType === 7) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }

        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            var childCount = childNodes.length;
            for (var i = childCount - 1; i >= 0; --i) {
              var childClone = cloneNode(childNodes[i], true);
              childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
              parentNode.insertBefore(childClone, getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);
      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };

    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */
    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);
      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */
      if (!attributes || _isClobbered(currentNode)) {
        return;
      }
      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;

        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);

          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }

        /* Work around a security issue with comments inside attributes */
        if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */
        _sanitizeElements(shadowNode);

        /* Check attributes next */
        _sanitizeAttributes(shadowNode);

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }
          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }
        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        _sanitizeElements(currentNode);

        /* Check attributes next */
        _sanitizeAttributes(currentNode);

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        oldNode = currentNode;
      }
      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 96504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 62988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var QueryHandler = __webpack_require__(61755);
var each = (__webpack_require__(26665).each);

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 38177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQuery = __webpack_require__(62988);
var Util = __webpack_require__(26665);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 61755:
/***/ (function(module) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 26665:
/***/ (function(module) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 24974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(38177);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 24429:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);
var round = __webpack_require__(63862);
var sign = __webpack_require__(29550);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = __webpack_require__(81618);
var $ObjectGPO = __webpack_require__(68899);
var $ReflectGPO = __webpack_require__(10443);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 68899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(68892);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ 10443:
/***/ (function(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ 81618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(10443);
var originalGetProto = __webpack_require__(68899);

var getDunderProto = __webpack_require__(96504);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ 40690:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 48824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 60885:
/***/ (function(__unused_webpack_module, exports) {

/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z}
 */
exports.CASE_SENSITIVE_TAG_NAMES = [
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'linearGradient',
  'radialGradient',
  'textPath'
];


/***/ }),

/***/ 38276:
/***/ (function(module) {

// constants
var HTML = 'html';
var HEAD = 'head';
var BODY = 'body';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;

// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var parseFromDocument = function () {
  throw new Error(
    'This browser does not support `document.implementation.createHTMLDocument`'
  );
};

var parseFromString = function () {
  throw new Error(
    'This browser does not support `DOMParser.prototype.parseFromString`'
  );
};

var DOMParser = typeof window === 'object' && window.DOMParser;

/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
if (typeof DOMParser === 'function') {
  var domParser = new DOMParser();
  var mimeType = 'text/html';

  /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromString = function (html, tagName) {
    if (tagName) {
      html = '<' + tagName + '>' + html + '</' + tagName + '>';
    }

    return domParser.parseFromString(html, mimeType);
  };

  parseFromDocument = parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
if (typeof document === 'object' && document.implementation) {
  var doc = document.implementation.createHTMLDocument();

  /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromDocument = function (html, tagName) {
    if (tagName) {
      var element = doc.documentElement.querySelector(tagName);
      element.innerHTML = html;
      return doc;
    }

    doc.documentElement.innerHTML = html;
    return doc;
  };
}

/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var template =
  typeof document === 'object' ? document.createElement('template') : {};

var parseFromTemplate;

if (template.content) {
  /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */
  parseFromTemplate = function (html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */
function domparser(html) {
  var firstTagName;
  var match = html.match(FIRST_TAG_REGEX);

  if (match && match[1]) {
    firstTagName = match[1].toLowerCase();
  }

  var doc;
  var element;
  var elements;

  switch (firstTagName) {
    case HTML:
      doc = parseFromString(html);

      // the created document may come with filler head/body elements,
      // so make sure to remove them if they don't actually exist
      if (!HEAD_TAG_REGEX.test(html)) {
        element = doc.querySelector(HEAD);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      if (!BODY_TAG_REGEX.test(html)) {
        element = doc.querySelector(BODY);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      return doc.querySelectorAll(HTML);

    case HEAD:
    case BODY:
      doc = parseFromDocument(html);
      elements = doc.querySelectorAll(firstTagName);

      // if there's a sibling element, then return both elements
      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
        return elements[0].parentNode.childNodes;
      }
      return elements;

    // low-level tag or text
    default:
      if (parseFromTemplate) {
        return parseFromTemplate(html);
      }
      element = parseFromDocument(html, BODY).querySelector(BODY);
      return element.childNodes;
  }
}

module.exports = domparser;


/***/ }),

/***/ 14152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domparser = __webpack_require__(38276);
var utilities = __webpack_require__(1507);

var formatDOM = utilities.formatDOM;

var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */
function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (html === '') {
    return [];
  }

  // match directive
  var match = html.match(DIRECTIVE_REGEX);
  var directive;

  if (match && match[1]) {
    directive = match[1];
  }

  return formatDOM(domparser(html), null, directive);
}

module.exports = HTMLDOMParser;


/***/ }),

/***/ 1507:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var domhandler = __webpack_require__(47915);
var constants = __webpack_require__(60885);

var CASE_SENSITIVE_TAG_NAMES = constants.CASE_SENSITIVE_TAG_NAMES;

var Comment = domhandler.Comment;
var Element = domhandler.Element;
var ProcessingInstruction = domhandler.ProcessingInstruction;
var Text = domhandler.Text;

var caseSensitiveTagNamesMap = {};
var tagName;

for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
  tagName = CASE_SENSITIVE_TAG_NAMES[i];
  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
}

/**
 * Gets case-sensitive tag name.
 *
 * @param {string} tagName - Tag name in lowercase.
 * @returns {string|undefined} - Case-sensitive tag name.
 */
function getCaseSensitiveTagName(tagName) {
  return caseSensitiveTagNamesMap[tagName];
}

/**
 * Formats DOM attributes to a hash map.
 *
 * @param {NamedNodeMap} attributes - List of attributes.
 * @returns {object} - Map of attribute name to value.
 */
function formatAttributes(attributes) {
  var result = {};
  var attribute;
  // `NamedNodeMap` is array-like
  for (var i = 0, len = attributes.length; i < len; i++) {
    attribute = attributes[i];
    result[attribute.name] = attribute.value;
  }
  return result;
}

/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param {string} tagName - Lowercase tag name.
 * @returns {string} - Formatted tag name.
 */
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}

/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param {NodeList} nodes - DOM nodes.
 * @param {Element|null} [parent=null] - Parent node.
 * @param {string} [directive] - Directive.
 * @returns {Array<Comment|Element|ProcessingInstruction|Text>}
 */
function formatDOM(nodes, parent, directive) {
  parent = parent || null;
  var result = [];
  var tagName;

  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    var current;

    // set the node data given the type
    switch (node.nodeType) {
      case 1:
        tagName = formatTagName(node.nodeName);
        // script, style, or tag
        current = new Element(tagName, formatAttributes(node.attributes));
        current.children = formatDOM(
          // template children are on content
          tagName === 'template' ? node.content.childNodes : node.childNodes,
          current
        );
        break;

      case 3:
        current = new Text(node.nodeValue);
        break;

      case 8:
        current = new Comment(node.nodeValue);
        break;

      default:
        continue;
    }

    // set previous node next
    var prev = result[index - 1] || null;
    if (prev) {
      prev.next = current;
    }

    // set properties for current node
    current.parent = parent;
    current.prev = prev;
    current.next = null;

    result.push(current);
  }

  if (directive) {
    current = new ProcessingInstruction(
      directive.substring(0, directive.indexOf(' ')).toLowerCase(),
      directive
    );
    current.next = result[0] || null;
    current.parent = parent;
    result.unshift(current);

    if (result[1]) {
      result[1].prev = result[0];
    }
  }

  return result;
}

exports.formatAttributes = formatAttributes;
exports.formatDOM = formatDOM;


/***/ }),

/***/ 30488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domhandler = __webpack_require__(47915);
var htmlToDOM = __webpack_require__(14152);

var attributesToProps = __webpack_require__(50484);
var domToReact = __webpack_require__(53670);

// support backwards compatibility for ES Module
htmlToDOM =
  /* istanbul ignore next */
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;

var domParserOptions = { lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;

// domhandler
HTMLReactParser.Comment = domhandler.Comment;
HTMLReactParser.Element = domhandler.Element;
HTMLReactParser.ProcessingInstruction = domhandler.ProcessingInstruction;
HTMLReactParser.Text = domhandler.Text;

// support CommonJS and ES Modules
module.exports = HTMLReactParser;
HTMLReactParser.default = HTMLReactParser;


/***/ }),

/***/ 50484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reactProperty = __webpack_require__(57744);
var utilities = __webpack_require__(74606);

// https://reactjs.org/docs/uncontrolled-components.html
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var UNCONTROLLED_COMPONENT_ATTRIBUTES = ['checked', 'value'];
var UNCONTROLLED_COMPONENT_NAMES = ['input', 'select', 'textarea'];

var VALUE_ONLY_INPUTS = {
  reset: true,
  submit: true
};

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @param {string} [nodeName] - DOM node name.
 * @returns - React props.
 */
module.exports = function attributesToProps(attributes, nodeName) {
  attributes = attributes || {};

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && VALUE_ONLY_INPUTS[attributes.type];

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML/SVG attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);

    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);

      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      if (
        UNCONTROLLED_COMPONENT_ATTRIBUTES.indexOf(propName) !== -1 &&
        UNCONTROLLED_COMPONENT_NAMES.indexOf(nodeName) !== -1 &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }

      props[propName] = attributeValue;

      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // transform inline style to object
  utilities.setStyleProp(attributes.style, props);

  return props;
};

/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}


/***/ }),

/***/ 53670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var attributesToProps = __webpack_require__(50484);
var utilities = __webpack_require__(74606);

var setStyleProp = utilities.setStyleProp;
var canTextBeChildOfNode = utilities.canTextBeChildOfNode;

/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */
function domToReact(nodes, options) {
  options = options || {};

  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;

  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;

      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        // We have a whitespace node that can't be nested in its parent
        // so skip it
        continue;
      }

      if (trim && isWhitespace) {
        // Trim is enabled and we have a whitespace node
        // so skip it
        continue;
      }

      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps(props, node.name);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact(node.children, options);
        }
        break;

      // skip all other cases (e.g., comment)
      default:
        continue;
    }

    // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return (
    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities.isCustomComponent(node.name, node.attribs)
  );
}

module.exports = domToReact;


/***/ }),

/***/ 74606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var styleToJS = (__webpack_require__(41476)["default"]);

/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

var styleToJSOptions = { reactCompat: true };

/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */
function setStyleProp(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}

/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;

// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);

/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */
function canTextBeChildOfNode(node) {
  return !elementsWithNoTextChildren.has(node.name);
}

module.exports = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp,
  canTextBeChildOfNode: canTextBeChildOfNode,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};


/***/ }),

/***/ 81580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Backend; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43144);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function createClassOnDemand(ClassOrObject) {
  if (!ClassOrObject) return null;
  if (typeof ClassOrObject === 'function') return new ClassOrObject();
  return ClassOrObject;
}

function getDefaults() {
  return {
    handleEmptyResourcesAsFailed: true,
    cacheHitMode: 'none'
    // reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000
    // refreshExpirationTime: 60 * 60 * 1000
  };
}

function handleCorrectReadFunction(backend, language, namespace, resolver) {
  var fc = backend.read.bind(backend);
  if (fc.length === 2) {
    // no callback
    try {
      var r = fc(language, namespace);
      if (r && typeof r.then === 'function') {
        // promise
        r.then(function (data) {
          return resolver(null, data);
        })["catch"](resolver);
      } else {
        // sync
        resolver(null, r);
      }
    } catch (err) {
      resolver(err);
    }
    return;
  }

  // normal with callback
  fc(language, namespace, resolver);
}
var Backend = /*#__PURE__*/function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Backend);
    this.backends = [];
    this.type = 'backend';
    this.allOptions = i18nextOptions;
    this.init(services, options);
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
      this.allOptions = i18nextOptions;
      this.options.backends && this.options.backends.forEach(function (b, i) {
        _this.backends[i] = _this.backends[i] || createClassOnDemand(b);
        _this.backends[i].init(services, _this.options.backendOptions && _this.options.backendOptions[i] || {}, i18nextOptions);
      });
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var _this2 = this;
      var bLen = this.backends.length;
      var loadPosition = function loadPosition(pos) {
        if (pos >= bLen) return callback(new Error('non of the backend loaded data', true)); // failed pass retry flag
        var isLastBackend = pos === bLen - 1;
        var lengthCheckAmount = _this2.options.handleEmptyResourcesAsFailed && !isLastBackend ? 0 : -1;
        var backend = _this2.backends[pos];
        if (backend.read) {
          handleCorrectReadFunction(backend, language, namespace, function (err, data, savedAt) {
            if (!err && data && Object.keys(data).length > lengthCheckAmount) {
              callback(null, data, pos);
              savePosition(pos - 1, data); // save one in front
              if (backend.save && _this2.options.cacheHitMode && ['refresh', 'refreshAndUpdateStore'].indexOf(_this2.options.cacheHitMode) > -1) {
                if (savedAt && _this2.options.refreshExpirationTime && savedAt + _this2.options.refreshExpirationTime > Date.now()) return;
                var nextBackend = _this2.backends[pos + 1];
                if (nextBackend && nextBackend.read) {
                  handleCorrectReadFunction(nextBackend, language, namespace, function (err, data) {
                    if (err) return;
                    if (!data) return;
                    if (Object.keys(data).length <= lengthCheckAmount) return;
                    savePosition(pos, data);
                    if (_this2.options.cacheHitMode !== 'refreshAndUpdateStore') return;
                    if (_this2.services && _this2.services.resourceStore) {
                      _this2.services.resourceStore.addResourceBundle(language, namespace, data);
                    }
                  });
                }
              }
            } else {
              loadPosition(pos + 1); // try load from next
            }
          });
        } else {
          loadPosition(pos + 1); // try load from next
        }
      };

      var savePosition = function savePosition(pos, data) {
        if (pos < 0) return;
        var backend = _this2.backends[pos];
        if (backend.save) {
          backend.save(language, namespace, data);
          savePosition(pos - 1, data);
        } else {
          savePosition(pos - 1, data);
        }
      };
      loadPosition(0);
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var clb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
      var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      this.backends.forEach(function (b) {
        if (!b.create) return;
        var fc = b.create.bind(b);
        if (fc.length < 6) {
          // no callback
          try {
            var r;
            if (fc.length === 5) {
              // future callback-less api for i18next-locize-backend
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              // promise
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              // sync
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
          return;
        }

        // normal with callback
        fc(languages, namespace, key, fallbackValue, clb /* unused callback */, opts);
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this3 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return; // avoid loading resources for cimode

      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this3.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';




/***/ }),

/***/ 70660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cache; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43144);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-classes-per-file */
var Storage = /*#__PURE__*/function () {
  function Storage(options) {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Storage);
    this.store = options.store;
  }
  return (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Storage, [{
    key: "setItem",
    value: function setItem(key, value) {
      if (this.store) {
        try {
          this.store.setItem(key, value);
        } catch (e) {
          // f.log('failed to set value for key "' + key + '" to localStorage.');
        }
      }
    }
  }, {
    key: "getItem",
    value: function getItem(key, value) {
      if (this.store) {
        try {
          return this.store.getItem(key, value);
        } catch (e) {
          // f.log('failed to get value for key "' + key + '" from localStorage.');
        }
      }
      return undefined;
    }
  }]);
}();
function getDefaults() {
  var store = null;
  try {
    store = window.localStorage;
  } catch (e) {
    if (typeof window !== 'undefined') {
      console.log('Failed to load local storage.', e);
    }
  }
  return {
    prefix: 'i18next_res_',
    expirationTime: 7 * 24 * 60 * 60 * 1000,
    defaultVersion: undefined,
    getVersion: undefined,
    versions: {},
    store: store
  };
}
var Cache = /*#__PURE__*/function () {
  function Cache(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Cache);
    this.init(services, options);
    this.type = 'backend';
  }
  return (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Cache, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options), options);
      this.storage = new Storage(this.options);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var nowMS = Date.now();
      if (!this.storage.store) {
        return callback(null, null);
      }
      var local = this.storage.getItem("".concat(this.options.prefix).concat(language, "-").concat(namespace));
      if (local) {
        local = JSON.parse(local);
        var version = this.getVersion(language, namespace);
        if (
        // expiration field is mandatory, and should not be expired
        local.i18nStamp && local.i18nStamp + this.options.expirationTime > nowMS &&
        // there should be no language version set, or if it is, it should match the one in translation
        version === local.i18nVersion) {
          var i18nStamp = local.i18nStamp;
          delete local.i18nVersion;
          delete local.i18nStamp;
          return callback(null, local, i18nStamp);
        }
      }
      return callback(null, null);
    }
  }, {
    key: "save",
    value: function save(language, namespace, data) {
      if (this.storage.store) {
        data.i18nStamp = Date.now();

        // language version (if set)
        var version = this.getVersion(language, namespace);
        if (version) {
          data.i18nVersion = version;
        }

        // save
        this.storage.setItem("".concat(this.options.prefix).concat(language, "-").concat(namespace), JSON.stringify(data));
      }
    }
  }, {
    key: "getVersion",
    value: function getVersion(language, namespace) {
      var _this$options$getVers, _this$options;
      return ((_this$options$getVers = (_this$options = this.options).getVersion) === null || _this$options$getVers === void 0 ? void 0 : _this$options$getVers.call(_this$options, language, namespace)) || this.options.versions[language] || this.options.defaultVersion;
    }
  }]);
}();
Cache.type = 'backend';




/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 18139:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 41143:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 29238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(27856)["default"]) || __webpack_require__(27856));

/***/ }),

/***/ 35823:
/***/ (function(module) {

module.exports = function(data, filename, mime, bom) {
    var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
    var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
}


/***/ }),

/***/ 80973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(71169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 83465:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;


/***/ }),

/***/ 91296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 60790:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, typeof iteratee == 'function' ? iteratee : identity, keysIn);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forIn;


/***/ }),

/***/ 29208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 99245:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;


/***/ }),

/***/ 16040:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  return object == null ? {} : basePickBy(object, getAllKeysIn(object), baseIteratee(predicate));
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = pickBy;


/***/ }),

/***/ 31468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 93096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 96633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);

  // Prevent prototype pollution:
  // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
  // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
  // https://github.com/lodash/lodash/security/advisories/GHSA-w36w-cm3g-pc62
  var index = -1,
      length = path.length;

  if (!length) {
    return true;
  }

  while (++index < length) {
    var key = toKey(path[index]);

    // Always block "__proto__" anywhere in the path if it's not expected
    if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
      return false;
    }

    // Block constructor/prototype as non-terminal traversal keys to prevent
    // escaping the object graph into built-in constructors and prototypes.
    if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
      return false;
    }
  }

  var obj = parent(object, path);
  return obj == null || delete obj[toKey(last(path))];
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 3522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.18.1';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`',
      INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);

      // Prevent prototype pollution:
      // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
      // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
      var index = -1,
          length = path.length;

      if (!length) {
        return true;
      }

      while (++index < length) {
        var key = toKey(path[index]);

        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
          return false;
        }

        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
          return false;
        }
      }

      var obj = parent(object, path);
      return obj == null || delete obj[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        baseAssignValue(result, pair[0], pair[1]);
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      arrayEach(importsKeys, function(key) {
        if (reForbiddenIdentifierChars.test(key)) {
          throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
        }
      });

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 59738:
/***/ (function(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ (function(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ 43678:
/***/ (function(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 52264:
/***/ (function(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ (function(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ (function(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 63862:
/***/ (function(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ 29550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43678);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ 24400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = (0,slicedToArray/* default */.Z)(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(r) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || (0,nonIterableRest/* default */.Z)();
}

;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,assertThisInitialized/* default */.Z)(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: this.store },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 23837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(12806);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32873:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-down.aa284948.svg","height":11,"width":20});

/***/ }),

/***/ 97274:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-up.f1d1d9a0.svg","height":10,"width":16});

/***/ }),

/***/ 12522:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-top-arrow.62e44c63.svg","height":20,"width":12});

/***/ }),

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 653:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close.8c2dae8d.svg","height":17,"width":17});

/***/ }),

/***/ 91883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download-dark-gray.44fffa51.svg","height":16,"width":14});

/***/ }),

/***/ 39306:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/email.b2f119d5.svg","height":20,"width":28});

/***/ }),

/***/ 23896:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/left-arrow.1d5a986e.svg","height":17,"width":10});

/***/ }),

/***/ 55619:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});

/***/ }),

/***/ 90683:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/out-off-stock.c843c55d.svg","height":16,"width":16});

/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-icon.92125abd.svg","height":22,"width":19});

/***/ }),

/***/ 40503:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/required-installation-icon.eb963704.svg","height":16,"width":16});

/***/ }),

/***/ 14074:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/right-arrow.94e30f19.svg","height":17,"width":10});

/***/ }),

/***/ 83790:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/search.9197ce09.svg","height":19,"width":18});

/***/ }),

/***/ 66773:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/share.c1bcda3a.svg","height":17,"width":14});

/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wish.b0a7483e.svg","height":14,"width":15});

/***/ }),

/***/ 62084:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wishlist-gray-filled.091dca10.svg","height":20,"width":23});

/***/ }),

/***/ 91:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/downloadData.213d89ce.svg","height":650,"width":650});

/***/ }),

/***/ 9358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/uploadImage.f2ce335b.svg","height":650,"width":650});

/***/ }),

/***/ 51334:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/crossButton.b8614cf0.svg","height":40,"width":40});

/***/ }),

/***/ 56575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/drag_indicator.1ab6ca43.svg","height":40,"width":40});

/***/ }),

/***/ 36513:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-missing.885b2d7c.png","height":248,"width":248,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAABlBMVEX+/v75+fmgSBYdAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHElEQVQImWNgQABGRkZGGA1mYTIYGBkZwDQ6AAAETwAaQfy18QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 59001:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/spinner.3693c331.svg","height":100,"width":100});

/***/ }),

/***/ 36562:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/swatch-missing.457436f1.jpeg","height":368,"width":368,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABAwUAAAAAAAAAAAAAAAAAARIUBBETIWH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AraT5m8K07uusAAP/2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 87942:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tickButton.c92822f4.svg","height":40,"width":40});

/***/ }),

/***/ 88871:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tooltip_questionmark.767dcfe9.svg","height":20,"width":20});

/***/ }),

/***/ 94020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AemGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Shared/ContainerComponent.jsx




const ContainerComponent = (param)=>{
    let { children , extraProps , item , count  } = param;
    const isTargetModule = (item === null || item === void 0 ? void 0 : item.contentType) === "target";
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timeOut = setTimeout(()=>{
            var ref;
            var ref1;
            const hashValue = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : "";
            if (hashValue) {
                var ref2;
                var ref3;
                const element = (ref3 = document.querySelector("[id='".concat(hashValue, "']"))) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const offsetTop = (ref4 = element === null || element === void 0 ? void 0 : (ref2 = element.parentNode) === null || ref2 === void 0 ? void 0 : ref2.offsetTop) !== null && ref4 !== void 0 ? ref4 : 0;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }, 1000);
        return ()=>{
            clearTimeout(timeOut);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-container".concat((extraProps === null || extraProps === void 0 ? void 0 : extraProps.fragment) === constants.FRAGMENT_TYPES.HEADER && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.hasGlobalNavigation) && count === 0 ? " desk-header-height" : "").concat(isTargetModule ? " hidden" : ""),
        id: (item === null || item === void 0 ? void 0 : item.customId) || (item === null || item === void 0 ? void 0 : item.containerId),
        children: children
    });
};
/* harmony default export */ var Shared_ContainerComponent = (ContainerComponent);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.mjs + 2 modules
var Spacer = __webpack_require__(38466);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(3171);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/ArrowControl.mjs + 5 modules
var ArrowControl = __webpack_require__(49885);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs + 2 modules
var AspectRatioKeeper = __webpack_require__(66737);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 4 modules
var Image = __webpack_require__(26191);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Video/Video.mjs + 3 modules
var Video = __webpack_require__(19770);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Portal/OptionalPortal.mjs
var OptionalPortal = __webpack_require__(94058);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/FocusTrap/FocusTrap.mjs
var FocusTrap = __webpack_require__(39003);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlayIcon.mjs
var PlayIcon = __webpack_require__(2722);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/VideoPlayer/VideoPlayer.mjs + 7 modules
var VideoPlayer = __webpack_require__(29705);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CloseIcon.mjs
var CloseIcon = __webpack_require__(61599);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Heroes/FullBleedHeroVideo/subcomponents/OverlayVideo/OverlayVideo.module.css.mjs
var classes = {
    "overlayVideoWrapper": "P6Dsh",
    "overlayVideoGrid": "lsW0V",
    "overlayVideoContainer": "_97HsA",
    "overlayVideoCloseIcon": "lULlf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Heroes/FullBleedHeroVideo/subcomponents/OverlayVideo/OverlayVideo.mjs





const OverlayVideo = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { onClose , closeCTA , zIndex , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(classes.overlayVideoWrapper, "kohler-overlay-video-root"),
        zIndex,
        ref
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: classes.overlayVideoGrid
    }, (onClose || closeCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        display: "flex",
        component: "button",
        type: "button",
        onClick: onClose,
        ...closeCTA,
        className: (0,clsx/* default */.Z)(classes.overlayVideoCloseIcon, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, null)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        component: "div",
        aspectRatio: "16:9",
        className: classes.overlayVideoContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(VideoPlayer/* VideoPlayer */.Y, {
        autoPlay: true,
        ...rest
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/subcomponents/VideoCard/VideoCard.mjs
"use client";




const VideoCard = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { video , closeCTA , optionalPortalTarget =".kohler-two-up-content-root"  } = props;
    const [openVideo, setOpenVideo] = (0,react.useState)(false);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Video/* Video */.n, {
        ref,
        ...video,
        controls: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "absolute",
        inset: "0",
        zIndex: 2,
        component: "button",
        type: "button",
        top: "50%",
        left: "50%",
        style: {
            transform: "translate(-50%, -50%)"
        },
        onClick: ()=>setOpenVideo(true)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PlayIcon/* PlayIcon */.o, {
        color: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto,
        withBoundingBox: true,
        size: "medium"
    })), openVideo && video && !video.autoPlay && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OptionalPortal/* OptionalPortal */.q, {
        target: optionalPortalTarget
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FocusTrap/* FocusTrap */.i, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayVideo, {
        zIndex: 105,
        ...video,
        autoPlay: true,
        muted: false,
        closeCTA: {
            onClick: (e)=>{
                var ref;
                setOpenVideo(false);
                closeCTA === null || closeCTA === void 0 ? void 0 : (ref = closeCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(closeCTA, e);
            }
        }
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/subcomponents/ContentCard/ContentCard.module.css.mjs
var ContentCard_module_css_classes = {
    "contentCard": "_0eu4F",
    "portraitCard": "_6eHtF"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/subcomponents/ContentCard/ContentCard.mjs





const ContentCard = (param)=>{
    let { aspectRatio , eyebrow , image , video , title , description , CTA , CTAs , isPortrait =false  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: (0,clsx/* default */.Z)(ContentCard_module_css_classes.contentCard, isPortrait && ContentCard_module_css_classes.portraitCard)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio
    }, image && !video && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image,
        position: "absolute",
        inset: "0"
    }), video && /* @__PURE__ */ /*#__PURE__*/ react.createElement(VideoCard, {
        video
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 15
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: eyebrow.component || "p",
        ...(0,helpers/* omitText */.rW)(eyebrow),
        size: "label-medium-m",
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, eyebrow.text), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "h3",
        ...(0,helpers/* omitText */.rW)(title),
        size: "h5",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, title.text)), !isPortrait && description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        ...(0,helpers/* omitText */.rW)(description),
        size: "paragraph-medium",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, description.text), !isPortrait && CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        ...(0,helpers/* omitText */.rW)(CTA),
        width: "fit-content",
        size: "medium"
    }, CTA.text), !isPortrait && CTAs && CTAs.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: "10px 20px",
        wrap: "wrap"
    }, CTAs.map((link, index)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(Link/* Link */.r, {
            key: (link === null || link === void 0 ? void 0 : (ref = link.text) === null || ref === void 0 ? void 0 : ref.toString()) || index,
            ...(0,helpers/* omitText */.rW)(link),
            size: "medium",
            width: "fit-content"
        }, link.text);
    }))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/TwoUpContent.module.css.mjs
var TwoUpContent_module_css_classes = {
    "twoUpContentWrapper": "Dxtl2",
    "twoUpContentHeaderContainer": "_75dML",
    "twoUpContentButtonContainer": "a0iMq",
    "twoUpContentButtonContainerCTA": "etikj",
    "twoUpContentButtonBottomContainer": "oGhsw",
    "twoUpContentCardsContainer": "JbJix",
    "twoUpContentCardsContainerLandscape": "dA-TT",
    "twoUpContentCardsContainer50": "_8W5y-",
    "twoUpContentCardsContainer40": "-icHa",
    "twoUpContentCardsContainer60": "yyOjg",
    "twoUpContentCardsContainerPortrait": "-E0Jy"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/TwoUpContent.utils.mjs

const imagesAspectRatio = {
    "50-50": {
        landscape: [
            "4:3",
            "4:3"
        ],
        portrait: [
            "3:4",
            "3:4"
        ]
    },
    "60-40": {
        landscape: [
            "4:3",
            "1:1"
        ],
        portrait: [
            "4:3",
            "1:1"
        ]
    },
    "40-60": {
        landscape: [
            "1:1",
            "4:3"
        ],
        portrait: [
            "1:1",
            "4:3"
        ]
    }
};
const twoUpContentCardsWrapperClassName = {
    "50-50": TwoUpContent_module_css_classes.twoUpContentCardsContainer50,
    "60-40": TwoUpContent_module_css_classes.twoUpContentCardsContainer60,
    "40-60": TwoUpContent_module_css_classes.twoUpContentCardsContainer40
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/TwoUpContent.mjs






const TwoUpContent = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , CTA , CTALink , type ="50-50" , imageOrientation ="landscape" , eyebrow , description , heading , mod , cards , topSpacer , bottomSpacer , sliderControls , className , ...rest } = props;
    const aspectRatio = imagesAspectRatio[type][imageOrientation];
    const isLandscape5050 = imageOrientation === "landscape" && type === "50-50";
    const isPortrait = imageOrientation === "portrait";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mod,
        ...rest,
        className: (0,clsx/* default */.Z)("kohler-two-up-content-root", TwoUpContent_module_css_classes.twoUpContentWrapper, className),
        component,
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary,
        ...rest,
        ref
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: "center-grid"
    }, isLandscape5050 && (eyebrow || heading || description || CTA || CTALink) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: TwoUpContent_module_css_classes.twoUpContentHeaderContainer
    }, (eyebrow || heading || description) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 35
    }, (eyebrow || heading) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 10
    }, eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(eyebrow.text) ? "div" : eyebrow.component || "p",
        size: "label-medium-m",
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        ...(0,helpers/* omitText */.rW)(eyebrow)
    }, eyebrow.text), heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        component: heading.component || "h3",
        size: "h2",
        ...(0,helpers/* omitText */.rW)(heading)
    }, heading.text)), description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        size: "paragraph-large",
        ...(0,helpers/* omitText */.rW)(description)
    }, description.text)), (CTA || CTALink) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 20,
        className: (0,clsx/* default */.Z)(TwoUpContent_module_css_classes.twoUpContentButtonContainer, !CTALink && CTA && TwoUpContent_module_css_classes.twoUpContentButtonContainerCTA)
    }, CTALink && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        ...(0,helpers/* omitText */.rW)(CTALink),
        size: "large"
    }, CTALink.text), CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        component: "a",
        ...(0,helpers/* omitText */.rW)(CTA),
        variant: "secondary",
        size: "large",
        className: TwoUpContent_module_css_classes.twoUpContentButtonContainerCTA
    }, CTA.text))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(twoUpContentCardsWrapperClassName[type], TwoUpContent_module_css_classes.twoUpContentCardsContainer, isLandscape5050 && TwoUpContent_module_css_classes.twoUpContentCardsContainerLandscape, isPortrait && TwoUpContent_module_css_classes.twoUpContentCardsContainerPortrait)
    }, cards && cards.length > 0 && cards.map((card, index)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(ContentCard, {
            key: ((ref = card.title) === null || ref === void 0 ? void 0 : ref.text) || index,
            ...card,
            aspectRatio: aspectRatio[index % 2],
            isPortrait
        });
    })), isPortrait && sliderControls && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        justify: "flex-end"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowControl/* ArrowControl */.l, {
        variant: "slider",
        direction: "left",
        ...sliderControls.leftControl
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowControl/* ArrowControl */.l, {
        variant: "slider",
        direction: "right",
        ...sliderControls.leftControl
    }))), isLandscape5050 && CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: TwoUpContent_module_css_classes.twoUpContentButtonBottomContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        component: "a",
        ...(0,helpers/* omitText */.rW)(CTA),
        fullWidth: true,
        variant: "secondary",
        size: "large"
    }, CTA.text))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.mjs + 6 modules
var Carousel = __webpack_require__(83022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/CarouselSlide/CarouselSlide.mjs
var CarouselSlide = __webpack_require__(7749);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/FeatureCardsWithModalSlider.module.css.mjs
var FeatureCardsWithModalSlider_module_css_classes = {
    "featureCardsWithModalSliderContainer": "-PUKx",
    "featureCardsWithModalSliderGrid": "TD97i",
    "featureCardsWithModalSliderContentContainer": "OH681",
    "videoCarouselSliderGrid": "FDn5U"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/PhotoOverlay/PhotoOverlay.mjs + 2 modules
var PhotoOverlay = __webpack_require__(3346);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ImageAction/ImageAction.mjs + 1 modules
var ImageAction = __webpack_require__(34647);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlusIcon.mjs
var PlusIcon = __webpack_require__(35114);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Modal/Modal.mjs + 2 modules
var Modal = __webpack_require__(80891);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/subcomponents/FeatureModalContentBlock/FeatureModalContentBlock.module.css.mjs
var FeatureModalContentBlock_module_css_classes = {
    "modalBlockRoot": "W8ETC",
    "modalBlockFull": "Fr-9P",
    "modalBlockContent": "Cas-o",
    "modalBlockContentFull": "zp9K7"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/subcomponents/FeatureModalContentBlock/FeatureModalContentBlock.mjs




const FeatureModalContentBlock = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { heading , copy , image , isFullWidth =true , className , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        ref,
        className: (0,clsx/* default */.Z)(className, FeatureModalContentBlock_module_css_classes.modalBlockRoot, isFullWidth && FeatureModalContentBlock_module_css_classes.modalBlockFull),
        ...rest
    }, image && /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio: isFullWidth ? "2:1" : "1:1"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), (heading || copy) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        style: {
            alignSelf: "center"
        },
        className: (0,clsx/* default */.Z)(FeatureModalContentBlock_module_css_classes.modalBlockContent, isFullWidth && FeatureModalContentBlock_module_css_classes.modalBlockContentFull)
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h4",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h5",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text), copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        ...(0,helpers/* omitText */.rW)(copy),
        size: "paragraph-medium",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, copy.text)));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/subcomponents/FeatureModal/FeatureModal.module.css.mjs
var FeatureModal_module_css_classes = {
    "modalRoot": "TQI56",
    "featureModalContentWrapper": "EYeYV",
    "featureModalContentBlockWrapper": "e7m2M",
    "blockWithImage": "Rdhf8",
    "blockWithoutImage": "ytWg9"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/subcomponents/FeatureModal/FeatureModal.mjs
"use client";





const FeatureModal = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { heading , content , className , onModalClose , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Modal/* Modal */.u, {
        zIndex: 105,
        className: (0,clsx/* default */.Z)(className, "kohler-feature-modal-root", FeatureModal_module_css_classes.modalRoot),
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 40,
        className: FeatureModal_module_css_classes.featureModalContentWrapper
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h3",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text), content && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: FeatureModal_module_css_classes.featureModalContentBlockWrapper
    }, content.map((block, index)=>{
        var ref, ref1;
        const nextHasImage = !!((ref = content[index + 1]) === null || ref === void 0 ? void 0 : ref.image);
        const isLast = index === content.length - 1;
        const gapClass = isLast ? null : nextHasImage ? FeatureModal_module_css_classes.blockWithImage : FeatureModal_module_css_classes.blockWithoutImage;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(FeatureModalContentBlock, {
            key: ((ref1 = block.heading) === null || ref1 === void 0 ? void 0 : ref1.text) || "modal-".concat(index),
            ...block,
            className: (0,clsx/* default */.Z)(gapClass)
        });
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/subcomponents/FeatureCard/FeatureCard.module.css.mjs
var FeatureCard_module_css_classes = {
    "featureCardContainer": "Z65-6",
    "featureCardContentContainer": "q-L0C",
    "featureCardOverlay": "F-7QD"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/subcomponents/FeatureCard/FeatureCard.mjs
"use client";






const FeatureCard = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { heading , modalContent , image , imageActionCTA , className , ...rest } = props;
    const [modalOpen, setModalOpen] = (0,react.useState)(false);
    const handleClick = ()=>{
        if (modalContent) {
            setModalOpen(true);
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(FeatureCard_module_css_classes.featureCardContainer, className, "kohler-feature-card-root"),
        component: "div",
        height: "100%",
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio: "10:16"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        className: FeatureCard_module_css_classes.featureCardOverlay,
        opacity: 30,
        direction: "bottom-top"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        justify: "space-between",
        gap: 10,
        align: "center",
        className: FeatureCard_module_css_classes.featureCardContentContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h3",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "label-regular-l",
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto
    }, heading.text), (imageActionCTA || modalContent) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ImageAction/* ImageAction */.H, {
        component: "button",
        type: "button",
        icon: PlusIcon/* PlusIcon */.p,
        "aria-label": "Expand feature card and open modal",
        ...imageActionCTA,
        onClick: (e)=>{
            var ref;
            imageActionCTA === null || imageActionCTA === void 0 ? void 0 : (ref = imageActionCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(imageActionCTA, e);
            handleClick();
        }
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), modalOpen && modalContent && /* @__PURE__ */ /*#__PURE__*/ react.createElement(FeatureModal, {
        portalProps: {
            target: ".kohler-feature-cards-with-modal-slider-root"
        },
        withinPortal: true,
        opened: modalOpen,
        ...modalContent,
        onClose: ()=>{
            var ref;
            (ref = modalContent.onModalClose) === null || ref === void 0 ? void 0 : ref.call(modalContent);
            setModalOpen(false);
        }
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/FeatureCardsWithModalSlider/FeatureCardsWithModalSlider.mjs





const FeatureCardsWithModalSlider = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="section" , mod ="white" , heading , cards , topSpacer , bottomSpacer , className , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        className: (0,clsx/* clsx */.W)("kohler-feature-cards-with-modal-slider-root", FeatureCardsWithModalSlider_module_css_classes.featureCardsWithModalSliderContainer, className),
        ref,
        mod,
        ...rest
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: FeatureCardsWithModalSlider_module_css_classes.featureCardsWithModalSliderGrid
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(FeatureCardsWithModalSlider_module_css_classes.featureCardsWithModalSliderContentContainer)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h2",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, heading.text)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(FeatureCardsWithModalSlider_module_css_classes.videoCarouselSliderGrid)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel/* Carousel */.l, {
        withControls: true,
        includeGapInSize: false,
        slideSize: 0,
        slideGap: "20px",
        align: "start",
        loop: false,
        containScroll: "trimSnaps",
        hideControlOnDisabled: false,
        carouselControlProps: {
            isOnPhoto: false,
            variant: "slider"
        }
    }, cards.map((card)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide/* CarouselSlide */.q, {
            key: card.heading.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FeatureCard, {
            ...card
        })))))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/RevealOnView/RevealOnView.module.css.mjs
var RevealOnView_module_css_classes = {
    "kohlerReveal": "RdhSv",
    "kohlerRevealHidden": "D-kpJ",
    "kohlerRevealVisible": "jPP9m"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/RevealOnView/RevealOnView.utils.mjs


function usePrefersReducedMotion(enabled) {
    const [prefersReducedMotion, setPrefersReducedMotion] = (0,react.useState)(false);
    (0,hooks/* useIsomorphicLayoutEffect */.LI)(()=>{
        if ( false || !enabled) return;
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        setPrefersReducedMotion(mediaQuery.matches);
        const handleChange = ()=>setPrefersReducedMotion(mediaQuery.matches);
        mediaQuery.addEventListener("change", handleChange);
        return ()=>mediaQuery.removeEventListener("change", handleChange);
    }, []);
    return prefersReducedMotion;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/RevealOnView/RevealOnView.mjs
"use client";




const RevealOnView = (param)=>{
    let { component: Component = "div" , delay =0 , enabled =false , duration =800 , ease ="ease-out" , opacityFrom =0 , transformFrom ="translateY(20px)" , once =true , threshold =0.15 , rootMargin ="0px 0px -10% 0px" , className , children , style: userStyle  } = param;
    const prefersReduce = usePrefersReducedMotion(enabled);
    const disabled = !enabled || prefersReduce;
    const ref = (0,react.useRef)(null);
    const [visible, setVisible] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (disabled) return;
        const el = ref.current;
        if (!el) return;
        if (typeof IntersectionObserver === "undefined") {
            setVisible(true);
            return;
        }
        const io = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                if (once) {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        io.disconnect();
                        break;
                    }
                } else {
                    setVisible(entry.isIntersecting);
                }
            }
        }, {
            threshold,
            rootMargin
        });
        io.observe(el);
        return ()=>io.disconnect();
    }, [
        disabled,
        once,
        threshold,
        rootMargin
    ]);
    const Comp = Component;
    const style = (0,react.useMemo)(()=>{
        const s = userStyle || {};
        if (disabled) {
            return s;
        }
        if (delay) s.transitionDelay = "".concat(delay, "ms");
        if (duration != null) s["--rov-duration"] = "".concat(duration, "ms");
        if (ease) s["--rov-ease"] = ease;
        if (opacityFrom != null) s["--rov-opacity-from"] = String(opacityFrom);
        if (transformFrom) s["--rov-transform-from"] = transformFrom;
        return s;
    }, [
        delay,
        duration,
        ease,
        opacityFrom,
        transformFrom,
        userStyle,
        disabled
    ]);
    if (disabled) {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, children);
    }
    return /*#__PURE__*/ react.createElement(Comp, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref,
        className: (0,clsx/* default */.Z)(RevealOnView_module_css_classes.kohlerReveal, visible ? RevealOnView_module_css_classes.kohlerRevealVisible : RevealOnView_module_css_classes.kohlerRevealHidden, className),
        style
    }, children);
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Heroes/ProductListHero/ProductListHero.module.css.mjs
var ProductListHero_module_css_classes = {
    "productListHero": "_3aifI",
    "productListHeroPaddings": "xA2z-",
    "productListHeroInnerWrapper": "GvaJ7",
    "productListHeroImageAspectRatio": "Sdu7N",
    "productListHeroProducts": "Kj7ux",
    "productListHeroContentWrapper": "FVM8l",
    "productListHeroCopyCTAWrapper": "AqXJ-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Heroes/ProductListHero/subcomponents/ProductItem/ProductItem.module.css.mjs
var ProductItem_module_css_classes = {
    "productListHeroProduct": "AG-KD"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Heroes/ProductListHero/subcomponents/ProductItem/ProductItem.mjs




const ProductItem = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { title , image , className , component ="a" , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: rest.href ? component : "div",
        ref,
        ...rest,
        direction: "column",
        gap: "15px",
        align: "center",
        borderRadius: "1px",
        className: (0,clsx/* default */.Z)("kohler-product-item-root", ProductItem_module_css_classes.productListHeroProduct, className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio: "1:1"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "h2",
        ...(0,helpers/* omitText */.rW)(title),
        size: "label-regular-m",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, title.text));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Heroes/ProductListHero/ProductListHero.mjs





const ProductListHero = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="section" , mod , heading , copy , image , CTAs , products , video , productsReveal , CTAsReveal , className , ...rest } = props;
    const { reveal: headingReveal , ...headingForTypography } = heading !== null && heading !== void 0 ? heading : {};
    const { reveal: copyReveal , ...copyForTypography } = copy !== null && copy !== void 0 ? copy : {};
    const { reveal: videoReveal , ...videoRest } = video !== null && video !== void 0 ? video : {};
    const { reveal: imageReveal , ...imageRest } = image !== null && image !== void 0 ? image : {};
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        ref,
        mod,
        className: (0,clsx/* clsx */.W)("kohler-product-list-hero-root", ProductListHero_module_css_classes.productListHero, className),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: ProductListHero_module_css_classes.productListHeroInnerWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: ProductListHero_module_css_classes.productListHeroContentWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...headingReveal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h1",
        ...(0,helpers/* omitText */.rW)(headingForTypography),
        size: "h2",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text)), (copy || CTAs) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: ProductListHero_module_css_classes.productListHeroCopyCTAWrapper
    }, copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...copyReveal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        ...(0,helpers/* omitText */.rW)(copyForTypography),
        size: "paragraph-large",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, copy.text)), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...CTAsReveal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center",
        columnGap: "40px",
        rowGap: "15px",
        justify: "center",
        wrap: "wrap"
    }, CTAs.map((CTA, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            size: "large",
            key: index,
            ...(0,helpers/* omitText */.rW)(CTA)
        }, CTA.text)))))), products && /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        style: {
            gridColumn: "1 / -1"
        },
        ...productsReveal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        className: (0,clsx/* clsx */.W)(ProductListHero_module_css_classes.productListHeroProducts, ProductListHero_module_css_classes.productListHeroPaddings)
    }, products.map((product)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            component: "li",
            key: product.title.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ProductItem, {
            ...product
        }))))), (video || image) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* clsx */.W)(ProductListHero_module_css_classes.productListHeroPaddings)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...videoReveal || imageReveal,
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        className: (0,clsx/* clsx */.W)(ProductListHero_module_css_classes.productListHeroImageAspectRatio)
    }, video ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Video/* Video */.n, {
        controls: false,
        loop: true,
        muted: true,
        autoPlay: true,
        playsInline: true,
        autoplayInView: true,
        decorative: true,
        ...videoRest
    }) : image && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...imageRest
    }))))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Banners/FullBleedExperience/FullBleedExperience.module.css.mjs
var FullBleedExperience_module_css_classes = {
    "fullBleedExperience": "_4gOBl",
    "fullBleedExperienceContentWrapper": "YNMGZ",
    "fullBleedExperienceMediaWrapper": "Fpxzd",
    "fullBleedExperienceImageAspectRatio": "_7rlg6",
    "fullBleedExperienceTopMiddle": "-KaRl",
    "revealHeadingTopMiddleMobile": "vFqTg",
    "fullBleedExperienceBottomMiddle": "qoCVW",
    "fullBleedExperienceContentHeading": "onj9l",
    "fullBleedExperienceContentCopy": "BCiBH"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Banners/FullBleedExperience/FullBleedExperience.utils.mjs
function getFullBleedExperienceTextPositionClass(classes, textPosition) {
    const positionClassMap = {
        "top-middle": classes.fullBleedExperienceTopMiddle,
        "bottom-middle": classes.fullBleedExperienceBottomMiddle
    };
    return positionClassMap[textPosition];
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Banners/FullBleedExperience/FullBleedExperience.mjs





const FullBleedExperience = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="section" , mod , heading , copy , image , video , textPlacement ="bottom-middle" , hasPhotoOverlay =true , gradientDirection ="tint" , opacity =35 , className , ...rest } = props;
    const { reveal: headingReveal , ...headingForTypography } = heading !== null && heading !== void 0 ? heading : {};
    const { reveal: copyReveal , ...copyForTypography } = copy !== null && copy !== void 0 ? copy : {};
    const isTopMiddle = textPlacement === "top-middle";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        ref,
        mod,
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary,
        className: (0,clsx/* clsx */.W)("kohler-full-bleed-experience-root", FullBleedExperience_module_css_classes.fullBleedExperience, className),
        position: "relative",
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, (video || image) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* clsx */.W)(FullBleedExperience_module_css_classes.fullBleedExperienceMediaWrapper)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        className: (0,clsx/* clsx */.W)(FullBleedExperience_module_css_classes.fullBleedExperienceImageAspectRatio),
        width: "100%",
        position: "relative"
    }, isTopMiddle && heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...headingReveal,
        className: FullBleedExperience_module_css_classes.revealHeadingTopMiddleMobile
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h2",
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto,
        ...(0,helpers/* omitText */.rW)(headingForTypography),
        textAlign: "center",
        size: "h2",
        className: (0,clsx/* clsx */.W)(FullBleedExperience_module_css_classes.fullBleedExperienceContentHeading, heading.className)
    }, heading.text)), video ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "0"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Video/* Video */.n, {
        controls: false,
        decorative: true,
        loop: true,
        muted: true,
        autoPlay: true,
        playsInline: true,
        autoplayInView: true,
        ...video
    })) : image && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        direction: gradientDirection,
        opacity: hasPhotoOverlay ? opacity : void 0,
        zIndex: 0
    }))), heading && copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(FullBleedExperience_module_css_classes.fullBleedExperienceContentWrapper, getFullBleedExperienceTextPositionClass(FullBleedExperience_module_css_classes, textPlacement))
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...headingReveal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h2",
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto,
        ...(0,helpers/* omitText */.rW)(headingForTypography),
        size: "h2",
        className: (0,clsx/* clsx */.W)(FullBleedExperience_module_css_classes.fullBleedExperienceContentHeading, heading.className)
    }, heading.text)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealOnView, {
        ...copyReveal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        ...(0,helpers/* omitText */.rW)(copyForTypography),
        size: "paragraph-large",
        className: (0,clsx/* clsx */.W)(FullBleedExperience_module_css_classes.fullBleedExperienceContentCopy, copy.className)
    }, copy.text)))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/VideoSlider/subcomponents/VideoCard/VideoCard.module.css.mjs
var VideoCard_module_css_classes = {
    "videoCardContainer": "Byn8S",
    "videoCardContentContainer": "i1Ljo",
    "videoCardOverlay": "R10BF"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/VideoSlider/subcomponents/VideoCard/VideoCard.mjs
"use client";






const VideoCard_VideoCard = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { heading , duration , video , image , className , ...rest } = props;
    const [isOverlayOpen, setIsOverlayOpen] = (0,react.useState)(false);
    const handleClick = ()=>{
        if (video) {
            setIsOverlayOpen(true);
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: (0,clsx/* default */.Z)(VideoCard_module_css_classes.videoCardContainer, className, "kohler-video-card-root"),
        component: "div",
        height: "100%",
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        component: video ? "button" : "div",
        type: video ? "button" : void 0,
        aspectRatio: "1:1",
        "aria-label": video ? "open fullscreen video" : void 0,
        onClick: handleClick
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        className: VideoCard_module_css_classes.videoCardOverlay,
        opacity: 10,
        direction: "tint"
    }, video && /* @__PURE__ */ /*#__PURE__*/ react.createElement(PlayIcon/* PlayIcon */.o, {
        color: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto,
        withBoundingBox: true,
        size: "medium"
    })), image ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Video/* Video */.n, {
        decorative: true,
        controls: false,
        ...video
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        justify: "space-between",
        gap: 15,
        className: VideoCard_module_css_classes.videoCardContentContainer
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h3",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h6",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, heading.text), duration && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(duration.text) ? "div" : duration.component || "p",
        ...(0,helpers/* omitText */.rW)(duration),
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "paragraph-medium"
    }, duration.text)), isOverlayOpen && video && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OptionalPortal/* OptionalPortal */.q, {
        target: ".kohler-video-slider-root"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FocusTrap/* FocusTrap */.i, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayVideo, {
        zIndex: 105,
        ...video,
        autoPlay: true,
        muted: false,
        closeCTA: {
            onClick: (e)=>{
                var ref, ref1, ref2;
                setIsOverlayOpen(false);
                video === null || video === void 0 ? void 0 : (ref = video.onClose) === null || ref === void 0 ? void 0 : ref.call(video);
                video === null || video === void 0 ? void 0 : (ref1 = video.closeCTA) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.onClick) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, e);
            }
        }
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/VideoSlider/VideoSlider.module.css.mjs
var VideoSlider_module_css_classes = {
    "videoSliderContainer": "vVK2Z",
    "videoSliderGrid": "bZLCY",
    "videoSliderContentContainer": "Tvvk6",
    "videoCarouselSliderGrid": "H0fGv"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/VideoSlider/VideoSlider.mjs





const VideoSlider = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="section" , mod ="white" , heading , cards , topSpacer , bottomSpacer , className , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        className: (0,clsx/* clsx */.W)("kohler-video-slider-root", VideoSlider_module_css_classes.videoSliderContainer, className),
        ref,
        mod,
        ...rest
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: VideoSlider_module_css_classes.videoSliderGrid
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(VideoSlider_module_css_classes.videoSliderContentContainer)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h2",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, heading.text)), (cards === null || cards === void 0 ? void 0 : cards.length) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(VideoSlider_module_css_classes.videoCarouselSliderGrid)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel/* Carousel */.l, {
        withControls: true,
        includeGapInSize: false,
        slideSize: 0,
        slideGap: "5px",
        align: "start",
        loop: false,
        containScroll: "trimSnaps",
        hideControlOnDisabled: false,
        carouselControlProps: {
            isOnPhoto: false,
            variant: "slider"
        }
    }, cards.map((card)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide/* CarouselSlide */.q, {
            key: card.heading.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(VideoCard_VideoCard, {
            ...card
        })))))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpFeaturedCards/subcomponents/ImageLink/ImageLink.module.css.mjs
var ImageLink_module_css_classes = {
    "imageLinkCardWrapper": "ejXJD",
    "imageLinkCardImageBackground": "XBFen",
    "imageLinkCardImageBackgroundMiddle": "_0AZ-n",
    "imageLinkCardImageBackgroundBottom": "uayjA",
    "imageLinkCardContentWrapper": "_9F0Fq",
    "imageLinkCardContentWrapperMiddle": "_3dEgn",
    "imageLinkCardContentWrapperBottom": "_4bQOU"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpFeaturedCards/subcomponents/ImageLink/ImageLink.mjs




const ImageLink = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { CTA , image , title , eyebrow , showCTA =true , opacity =35 , gradientDirection ="bottom-top" , position ="middle-center" , className , ...rest } = props;
    const isMiddleCenter = position === "middle-center";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        component: !showCTA && CTA ? "a" : "div",
        className: (0,clsx/* default */.Z)("kohler-image-link-card-root", ImageLink_module_css_classes.imageLinkCardWrapper, className),
        ...(0,helpers/* omitText */.rW)(CTA),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "figure",
        className: (0,clsx/* default */.Z)(ImageLink_module_css_classes.imageLinkCardImageBackground, isMiddleCenter && ImageLink_module_css_classes.imageLinkCardImageBackgroundMiddle, !isMiddleCenter && ImageLink_module_css_classes.imageLinkCardImageBackgroundBottom)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image,
        src: image.src,
        alt: image.alt
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        direction: gradientDirection,
        opacity,
        className: (0,clsx/* default */.Z)(ImageLink_module_css_classes.imageLinkCardContentWrapper, isMiddleCenter ? ImageLink_module_css_classes.imageLinkCardContentWrapperMiddle : ImageLink_module_css_classes.imageLinkCardContentWrapperBottom)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 10
    }, eyebrow && !isMiddleCenter && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: eyebrow.component || "h3",
        ...(0,helpers/* omitText */.rW)(eyebrow),
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto,
        size: "label-medium-s"
    }, eyebrow.text), title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto,
        size: isMiddleCenter ? "h4" : "h5",
        component: title.component || "h3",
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text)), showCTA && CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        size: "medium",
        ...(0,helpers/* omitText */.rW)(CTA),
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto
    }, CTA.text)))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpFeaturedCards/TwoUpFeaturedCards.module.css.mjs
var TwoUpFeaturedCards_module_css_classes = {
    "twoUpFeaturedCardsModuleRoot": "PFxhG",
    "twoUpFeaturedCardsModuleRootSpacious": "_0RFRp",
    "twoUpFeaturedCardsCardsWrapper": "XllYU",
    "twoUpFeaturedCardsCardsGridColumnSpacious": "WSsrT",
    "twoUpFeaturedCardsCardsWrapperSpacious": "GA9Al"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpFeaturedCards/TwoUpFeaturedCards.mjs





const TwoUpFeaturedCards = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="section" , mod ="white" , variant ="default" , cards , topSpacer , bottomSpacer , className , ...rest } = props;
    const isDefault = variant === "default";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        className: (0,clsx/* default */.Z)("kohler-two-up-featured-cards-root", TwoUpFeaturedCards_module_css_classes.twoUpFeaturedCardsModuleRoot, className, !isDefault && TwoUpFeaturedCards_module_css_classes.twoUpFeaturedCardsModuleRootSpacious),
        ref,
        mod,
        ...rest
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(!isDefault && TwoUpFeaturedCards_module_css_classes.twoUpFeaturedCardsCardsGridColumnSpacious)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(TwoUpFeaturedCards_module_css_classes.twoUpFeaturedCardsCardsWrapper, !isDefault && TwoUpFeaturedCards_module_css_classes.twoUpFeaturedCardsCardsWrapperSpacious)
    }, cards.map((card, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(ImageLink, {
            key: "".concat(card.CTA.href, "-").concat(index),
            ...card,
            position: isDefault ? "middle-center" : "bottom-center"
        }))))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/CompareSlider/CompareSlider.module.css.mjs
var CompareSlider_module_css_classes = {
    "compareSliderContainer": "kEa2J",
    "compareSliderGrid": "TddGY",
    "compareSliderContentContainer": "oLhNR",
    "compareCarouselSliderGrid": "CwktM"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs
var use_window_size = __webpack_require__(17677);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/breakpoints.mjs
var breakpoints = __webpack_require__(81060);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/subcomponent/ColorSwatchRadioGroup/ColorSwatchRadioGroup.mjs + 2 modules
var ColorSwatchRadioGroup = __webpack_require__(81843);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs + 2 modules
var Tooltip = __webpack_require__(23293);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CheckmarkIcon.mjs
var CheckmarkIcon = __webpack_require__(21421);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/TooltipInfoIcon.mjs
var TooltipInfoIcon = __webpack_require__(62794);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/CompareSlider/subcomponents/ExperienceCompareCard/ExperienceCompareCard.module.css.mjs
var ExperienceCompareCard_module_css_classes = {
    "experienceCompareCardContainer": "bJULn",
    "experienceCompareCardContentWrapper": "L4w7R",
    "experienceCompareCardFeaturesContainer": "xva-t",
    "experienceCompareCardColorSwatches": "ZslVy",
    "colorSwatchesPlaceholder": "OYiEQ",
    "experienceCompareCardTooltipPopover": "UHKtc",
    "experienceCompareCardTooltip": "_5QWKi",
    "experienceCompareCardDescriptionSmall": "P-Ht0",
    "experienceCompareCardDescriptionDefault": "E2DYn",
    "experienceCompareCardDescriptionLarge": "gaeuV"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/CompareSlider/subcomponents/ExperienceCompareCard/ExperienceCompareCard.mjs
"use client";





const ExperienceCompareCard = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { CTA , title , description , price , image , imagesByColor , features , colorSwatches , className , descriptionSize ="default" , hasSwatches =false , ...rest } = props;
    const descriptionSizeClasses = {
        small: ExperienceCompareCard_module_css_classes.experienceCompareCardDescriptionSmall,
        default: ExperienceCompareCard_module_css_classes.experienceCompareCardDescriptionDefault,
        large: ExperienceCompareCard_module_css_classes.experienceCompareCardDescriptionLarge
    };
    const isControlled = (colorSwatches === null || colorSwatches === void 0 ? void 0 : colorSwatches.value) !== void 0;
    const [internalColor, setInternalColor] = (0,react.useState)(colorSwatches === null || colorSwatches === void 0 ? void 0 : colorSwatches.defaultValue);
    const selectedColor = isControlled ? colorSwatches === null || colorSwatches === void 0 ? void 0 : colorSwatches.value : internalColor;
    const handleColorChange = (value)=>{
        var ref;
        if (!isControlled) setInternalColor(value);
        colorSwatches === null || colorSwatches === void 0 ? void 0 : (ref = colorSwatches.onChange) === null || ref === void 0 ? void 0 : ref.call(colorSwatches, value);
    };
    const resolvedImage = (0,react.useMemo)(()=>{
        if (!selectedColor) return image;
        const byMap = imagesByColor === null || imagesByColor === void 0 ? void 0 : imagesByColor[selectedColor];
        if (byMap) return byMap;
        return image;
    }, [
        selectedColor,
        imagesByColor,
        colorSwatches === null || colorSwatches === void 0 ? void 0 : colorSwatches.colors,
        image
    ]);
    const [openedTooltipIndex, setOpenedTooltipIndex] = (0,react.useState)(null);
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const isMobile = width > 0 && width < breakpoints/* BREAKPOINTS.s */.j.s;
    var ref2;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: (0,clsx/* default */.Z)(ExperienceCompareCard_module_css_classes.experienceCompareCardContainer, className, "kohler-experience-compare-card-root"),
        component: "div",
        height: "100%",
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio: "1:1"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...resolvedImage
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: ExperienceCompareCard_module_css_classes.experienceCompareCardContentWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 25
    }, (colorSwatches === null || colorSwatches === void 0 ? void 0 : (ref1 = colorSwatches.colors) === null || ref1 === void 0 ? void 0 : ref1.length) ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ColorSwatchRadioGroup/* ColorSwatchRadioGroup */.G, {
        radioGroupClassname: ExperienceCompareCard_module_css_classes.experienceCompareCardColorSwatches,
        "aria-label": "Choose color for ".concat((ref2 = title === null || title === void 0 ? void 0 : title.text) !== null && ref2 !== void 0 ? ref2 : "selection"),
        ...colorSwatches,
        value: isControlled ? colorSwatches.value : selectedColor,
        onChange: handleColorChange,
        direction: "row"
    }) : hasSwatches && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: ExperienceCompareCard_module_css_classes.colorSwatchesPlaceholder,
        "aria-hidden": "true"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 15
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "h3",
        ...(0,helpers/* omitText */.rW)(title),
        size: "label-regular-l",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, title.text), description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        ...(0,helpers/* omitText */.rW)(description),
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "paragraph-medium",
        className: descriptionSize ? descriptionSizeClasses[descriptionSize] : void 0
    }, description.text)), price && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(price.text) ? "div" : price.component || "p",
        ...(0,helpers/* omitText */.rW)(price),
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "label-medium-m"
    }, price.text))), features && features.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        margin: 0,
        className: ExperienceCompareCard_module_css_classes.experienceCompareCardFeaturesContainer
    }, features.map((param, index)=>/* @__PURE__ */ /*#__PURE__*/ {
        let { icon , tooltip , ...textProps } = param;
        return react.createElement(Flex/* Flex */.k, {
            key: "feature-".concat(index),
            gap: 10,
            align: "flex-start",
            component: "li",
            textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, null, icon !== null && icon !== void 0 ? icon : /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckmarkIcon/* CheckmarkIcon */.K, {
            size: 24,
            withBoundingBox: false
        })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(textProps.text) ? "div" : textProps.component || "p",
            ...(0,helpers/* omitText */.rW)(textProps),
            textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
            size: "label-regular-m"
        }, textProps.text), tooltip && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tooltip/* Tooltip */.u, {
            ...tooltip,
            position: isMobile ? "bottom" : "right",
            className: (0,clsx/* default */.Z)(ExperienceCompareCard_module_css_classes.experienceCompareCardTooltipPopover, tooltip.className),
            opened: openedTooltipIndex === index
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "button",
            className: ExperienceCompareCard_module_css_classes.experienceCompareCardTooltip,
            onClick: ()=>setOpenedTooltipIndex((prev)=>prev === index ? null : index),
            onBlur: ()=>setOpenedTooltipIndex(null),
            "aria-label": "More information"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(TooltipInfoIcon/* TooltipInfoIcon */.V, {
            size: 16,
            withBoundingBox: false
        }))));
    })), CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        component: "a",
        marginTop: "auto",
        variant: "secondary",
        size: "medium",
        fullWidth: true,
        ...(0,helpers/* omitText */.rW)(CTA)
    }, CTA.text)));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/SlidersAndCarousels/CompareSlider/CompareSlider.mjs





const CompareSlider = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="section" , mod ="white" , heading , cards , CTA , topSpacer , bottomSpacer , carouselProps , className , ...rest } = props;
    const descriptionSizesDesc = [
        "large",
        "default",
        "small"
    ];
    const maxDescriptionSize = descriptionSizesDesc.find((size)=>cards.some((card)=>card.descriptionSize === size));
    const hasSwatches = cards.some((card)=>{
        var ref, ref1;
        return (ref = card.colorSwatches) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.length;
    });
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        className: (0,clsx/* clsx */.W)("kohler-compare-slider-root", CompareSlider_module_css_classes.compareSliderContainer, className),
        ref,
        mod,
        ...rest
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: CompareSlider_module_css_classes.compareSliderGrid
    }, (heading || CTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(CompareSlider_module_css_classes.compareSliderContentContainer)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h2",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text), CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        component: "a",
        ...(0,helpers/* omitText */.rW)(CTA),
        variant: "secondary",
        size: "medium"
    }, CTA.text)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* clsx */.W)(CompareSlider_module_css_classes.compareCarouselSliderGrid)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel/* Carousel */.l, {
        withControls: true,
        includeGapInSize: false,
        slideSize: 0,
        slideGap: "20px",
        align: "start",
        loop: false,
        containScroll: "trimSnaps",
        hideControlOnDisabled: false,
        carouselControlProps: {
            isOnPhoto: false,
            variant: "slider"
        },
        dragIgnoreElementsList: [
            "span",
            "p",
            "ul",
            "li",
            "a",
            "button"
        ],
        ...carouselProps
    }, cards.map((card, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide/* CarouselSlide */.q, {
            key: card.title.text || "compare-card-".concat(index)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExperienceCompareCard, {
            ...card,
            descriptionSize: maxDescriptionSize !== null && maxDescriptionSize !== void 0 ? maxDescriptionSize : card.descriptionSize,
            hasSwatches
        })))))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Banners/LargeImageAndTextBlock/LargeImageAndTextBlock.module.css.mjs
var LargeImageAndTextBlock_module_css_classes = {
    "largeImageAndTextBlockContainerPadding": "GpjF-",
    "largeImageAndTextBlockTextContentTextAboveImage": "RCRmc",
    "largeImageAndTextBlockTextContentCenter": "utLRT",
    "largeImageAndTextBlockTextContentLeft": "zklNg",
    "largeImageAndTextBlockTextContentTextOverImage": "kfrAy",
    "largeImageAndTextBlockTextContentTextOverImageFullBleed": "QHcZY",
    "largeImageAndTextBlockCTAs": "MREqK",
    "largeImageAndTextBlockImageAspectRatioTextOverImage": "oTTcM",
    "largeImageAndTextBlockImageAspectRatioFullBleedTextOverImage": "Fvs1B",
    "largeImageAndTextBlockImageContainerTextOverImage": "_8pJGG",
    "largeImageAndTextBlockImageContainerFullBleedTextOverImage": "PMiBz",
    "largeImageAndTextBlockImageContainerTextAndImageBlocks": "J3V79",
    "largeImageAndTextBlockCopyWithinHeading": "wfz4D",
    "largeImageAndTextBlockCopyBelowHeading": "hlZxZ",
    "largeImageAndTextBlockImageAspectRatioTextAndImageBlocks": "jsY1q"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Banners/LargeImageAndTextBlock/LargeImageAndTextBlock.utils.mjs

const largeImageAndTextBlockTextPositionClasses = {
    center: LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockTextContentCenter,
    left: LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockTextContentLeft
};
const largeImageAndTextBlockImageAspectRatioClasses = {
    "text-over-image": LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockImageAspectRatioTextOverImage,
    "full-bleed-text-over-image": LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockImageAspectRatioFullBleedTextOverImage,
    "text-and-image-blocks": LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockImageAspectRatioTextAndImageBlocks
};
const largeImageAndTextBlockImageContainerClasses = {
    "text-over-image": LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockImageContainerTextOverImage,
    "full-bleed-text-over-image": LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockImageContainerFullBleedTextOverImage,
    "text-and-image-blocks": LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockImageContainerTextAndImageBlocks
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Banners/LargeImageAndTextBlock/LargeImageAndTextBlock.mjs





const LargeImageAndTextBlock = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { className , style , component ="div" , mod ="white" , textPlacement ="center" , showHeader =true , variant ="text-over-image" , heading , copy , CTAs , gradientDirection ="tint" , opacity =35 , topSpacer , bottomSpacer , image , video , ...rest } = props;
    const isTextOverImageVariant = variant === "text-over-image" || variant === "full-bleed-text-over-image";
    const isFullBleedTextOverImage = variant === "full-bleed-text-over-image";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        mod,
        component,
        ...rest,
        style: {
            overflow: "hidden",
            maxWidth: "100%",
            ...style
        },
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary,
        className: (0,clsx/* default */.Z)("kohler-large-image-and-text-block-root", className)
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)(!isFullBleedTextOverImage && LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockContainerPadding)
    }, isTextOverImageVariant ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(largeImageAndTextBlockImageContainerClasses[variant], largeImageAndTextBlockTextPositionClasses[textPlacement])
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        className: largeImageAndTextBlockImageAspectRatioClasses[variant]
    }, image ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        width: "100%",
        height: "100%",
        left: "0",
        top: "0",
        ...image,
        position: "absolute"
    }) : video && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Video/* Video */.n, {
        muted: true,
        autoPlay: true,
        decorative: true,
        controls: false,
        autoplayInView: false,
        loop: true,
        ...video,
        position: "absolute"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        direction: gradientDirection,
        opacity,
        style: {
            zIndex: 1
        }
    }, showHeader && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        position: "absolute",
        className: (0,clsx/* default */.Z)(isFullBleedTextOverImage ? LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockTextContentTextOverImageFullBleed : LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockTextContentTextOverImage, largeImageAndTextBlockTextPositionClasses[textPlacement]),
        align: textPlacement === "center" ? "center" : "flex-start",
        textAlign: textPlacement === "left" ? "left" : "center"
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(heading.text) ? "div" : heading.component || "h2",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto
    }, heading.text), copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        className: LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockCopyWithinHeading,
        ...(0,helpers/* omitText */.rW)(copy),
        size: "paragraph-large",
        textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto
    }, copy.text), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockCTAs,
        gap: "10px 30px",
        align: textPlacement === "left" ? "flex-start" : "center"
    }, CTAs.map((CTA)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            key: CTA.text,
            size: "large",
            ...(0,helpers/* omitText */.rW)(CTA),
            textColor: colors/* DsmColor.ContentOnPhoto */.k.ContentOnPhoto
        }, CTA.text))))))), copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockCopyBelowHeading),
        paddingBottom: isFullBleedTextOverImage ? "50px" : void 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        ...(0,helpers/* omitText */.rW)(copy),
        size: "paragraph-large",
        textAlign: textPlacement === "left" ? "left" : "center",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, copy.text))) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, showHeader && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        display: "flex",
        className: (0,clsx/* default */.Z)(LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockTextContentTextAboveImage, largeImageAndTextBlockTextPositionClasses[textPlacement]),
        textAlign: textPlacement === "left" ? "left" : "center",
        style: {
            alignItems: textPlacement === "left" ? "flex-start" : "center",
            flexDirection: "column"
        }
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(heading.text) ? "div" : heading.component || "h2",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text), copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        ...(0,helpers/* omitText */.rW)(copy),
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "paragraph-large"
    }, copy.text), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LargeImageAndTextBlock_module_css_classes.largeImageAndTextBlockCTAs,
        align: "flex-start",
        gap: "10px 30px",
        textAlign: textPlacement === "left" ? "left" : "center"
    }, CTAs.map((CTA)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            key: CTA.text,
            ...(0,helpers/* omitText */.rW)(CTA),
            size: "large"
        }, CTA.text)))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: largeImageAndTextBlockImageContainerClasses[variant]
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        className: largeImageAndTextBlockImageAspectRatioClasses[variant]
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        direction: gradientDirection,
        opacity
    }, image ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        width: "100%",
        height: "100%",
        left: "0",
        top: "0",
        ...image,
        position: "absolute"
    }) : video && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Video/* Video */.n, {
        muted: true,
        autoPlay: true,
        decorative: true,
        controls: false,
        autoplayInView: false,
        loop: true,
        ...video,
        position: "absolute"
    })))))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/TextBlocks/FAQ/FAQ.mjs + 1 modules
var FAQ = __webpack_require__(9421);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/utils.js
var HeaderNavTabs_utils = __webpack_require__(68446);
// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/DesignSystem/utils/teaserHelper.js
// Utilities for extracting and normalizing teaser data for DS mapping





/**
 * Strips HTML tags from a string.
 *
 * @param {string} html - The HTML string to strip.
 * @return {string} The plain text with HTML tags removed.
 */ function stripHtml(html) {
    if (!html) return "";
    return html.replace(/<[^>]+>/g, "").trim();
}
/**
 * Determines if an item is a teaser.
 *
 * Supports both `slingResourceType` and `:type` properties.
 *
 * @param {Object} item - The item to check.
 * @return {boolean} True if the item is a teaser, false otherwise.
 */ function isTeaser(item) {
    var ref;
    // Ensure a boolean is always returned
    return !!((item === null || item === void 0 ? void 0 : item.slingResourceType) === "teaser" || (item === null || item === void 0 ? void 0 : (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes("teaser")));
}
/**
 * Extracts and normalizes teaser data for Design System consumption.
 *
 * @param {Object} teaser - The teaser object to extract data from.
 * @param {string} [teaser.mainTitle] - The main title of the teaser.
 * @param {string} [teaser.title] - The title of the teaser.
 * @param {string} [teaser.description] - The description of the teaser.
 * @param {string} [teaser.fileReference] - The image file reference.
 * @param {Object} [teaser.imageResource] - The image resource object.
 * @param {string} [teaser.imageResource.fileReference] - The image file reference from imageResource.
 * @param {string} [teaser.imageResource.alt] - The alt text for the image.
 * @param {Array} [teaser.actions] - The array of CTA actions.
 * @param {string} [teaser.linkCTA] - The CTA link.
 * @param {string} [teaser.linkURL] - The fallback link URL.
 * @return {Object} The normalized teaser data:
 *
 */ function extractTeaserData(teaser) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const imageUrl = teaser.fileReference || ((ref = teaser.imageResource) === null || ref === void 0 ? void 0 : ref.fileReference) || "";
    const imageserverurl = (teaser === null || teaser === void 0 ? void 0 : (ref1 = teaser.imageResource) === null || ref1 === void 0 ? void 0 : ref1.imageServerUrl) || "";
    const imageID = (teaser === null || teaser === void 0 ? void 0 : (ref2 = teaser.imageResource) === null || ref2 === void 0 ? void 0 : ref2.assetID) || "";
    // Get CTA link
    let linkUrl = "";
    if (Array.isArray(teaser.actions) && teaser.actions.length > 0) {
        const action = teaser.actions.find((a)=>a.url || a.link);
        if (action) linkUrl = action.url || action.link;
    }
    if (!linkUrl) linkUrl = teaser.linkCTA || teaser.linkURL || "";
    return {
        title: stripHtml(teaser.title || teaser.mainTitle || ""),
        description: stripHtml(teaser.description || ""),
        imageUrl,
        linkUrl,
        alt: ((ref3 = teaser.imageResource) === null || ref3 === void 0 ? void 0 : ref3.alt) || "",
        ctaLabel: ((ref4 = teaser.actions) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.title) || ((ref6 = teaser.actions) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.text) || "",
        tryimageUrl: "".concat(imageserverurl).concat(imageID)
    };
}
/**
 * Maps an array of card data to the required card object structure for rendering.
 *
 * @param {Array<Object>} cards - The array of card data objects (from extractTeaserData).
 * @param {string} [pageType=""] - The page type string, used for tracking attributes in analytics.
 * @return {Array<Object>} The mapped array of card objects, each containing image, CTA, title, and description.
 */ function mapCards(cards) {
    let pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return cards.slice(0, 2).map((card)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const base = {
            image: {
                src: "".concat(card.tryimageUrl),
                alt: card === null || card === void 0 ? void 0 : card.alt,
                "data-mode": "smartcrop"
            },
            CTA: {
                text: (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel),
                href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(card === null || card === void 0 ? void 0 : card.linkUrl),
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "".concat(pageType, ":").concat((ref = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref === void 0 ? void 0 : ref.toLowerCase(), ":").concat((ref1 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                        eventName: "".concat(pageType, ":").concat((ref2 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), ":").concat((ref3 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                        eventType: "navigation",
                        internalLinkName: (ref4 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel)) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
                        internalLinkPosition: "".concat(pageType, ":teaser"),
                        internalLinkType: "".concat(pageType, ":").concat((ref5 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                        internalLinkURL: (card === null || card === void 0 ? void 0 : card.linkUrl) && "object" !== "undefined" ? "".concat(window.location.origin).concat(card === null || card === void 0 ? void 0 : (ref6 = card.linkUrl) === null || ref6 === void 0 ? void 0 : ref6.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                        internalLinkZoneName: "".concat(pageType, ":").concat((ref7 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()),
                        eventMsg: "n/a",
                        eventStatus: "n/a"
                    })
                }
            },
            title: {
                text: (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title),
                component: "h3"
            },
            description: {
                text: (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.description)
            }
        };
        return base;
    });
}
/**
 * Returns a valid HTML/custom element tag or undefined.
 *
 * @param {string} tag - The tag name to validate.
 * @return {string|undefined} The validated tag name, or undefined if invalid.
 */ function sanitizeTagOrUndefined(tag) {
    if (typeof tag !== "string" || !tag.trim()) return undefined;
    const t = tag.trim();
    return regex/* SANITIZE_TAG_OR_UNDEFINED_REGEX.test */.I1.test(t) ? t : undefined;
}
/**
 * Normalizes spacer sizes to the DS contract.
 *
 * @param {string} raw - The raw spacer value (alias or valid size).
 * @return {Object|undefined} An object with `{ size }` if valid, otherwise undefined.
 */ function normalizeSpacer(raw) {
    if (!raw) return undefined;
    const key = String(raw).toLowerCase().trim();
    const mapped = constants.SPACER_ALIAS[key] || key;
    const size = constants.VALID_SPACER_SIZES.has(mapped) ? mapped : "none";
    return {
        size
    };
}
/**
 * Title mapper that preserves component if valid, and drops if text is a React node.
 *
 * @param {Object} heading - The heading object.
 * @param {string|Object} heading.text - The heading text or React element.
 * @param {string} [heading.component] - The HTML tag for the heading.
 * @return {Object|undefined} Mapped heading object or undefined.
 */ function mapTitle(heading) {
    if (!heading) return undefined;
    const text = isObj(heading) ? heading.text : heading;
    if (!text) return undefined;
    const out = {
        ...isObj(heading) ? heading : {},
        text: text.replace(/<[^>]*>/g, "")
    };
    if (typeof text !== "object") {
        const comp = sanitizeTagOrUndefined(heading.component);
        if (comp) out.component = comp;
        else delete out.component;
    } else {
        delete out.component;
    }
    return Object.keys(out).length ? out : undefined;
}
/**
 * Detects if a string looks like HTML.
 *
 * @param {string} v - The string to check.
 * @return {boolean} True if the string contains HTML, false otherwise.
 */ function isHtmlString(v) {
    return typeof v === "string" && (regex/* HTML_STRING_REGEX_OPT1.test */.VL.test(v) || regex/* HTML_STRING_REGEX_OPT2.test */.X_.test(v));
}
/**
 * Text mapper for handling HTML strings, plain text, and React nodes.
 *
 * @param {Object} copy - The copy object.
 * @param {string|Object} copy.text - The text, HTML string, or React element.
 * @param {string} [copy.component] - The HTML tag for non-element text.
 * @return {Object|undefined} Mapped text object or undefined.
 */ function mapText(copy) {
    if (!copy) return undefined;
    const raw = isObj(copy) ? copy === null || copy === void 0 ? void 0 : copy.text : copy;
    if (!raw) return undefined;
    const text = isHtmlString(raw) ? /*#__PURE__*/ react.createElement("div", {
        className: "kohler-kds-style-inherit",
        dangerouslySetInnerHTML: {
            __html: raw
        }
    }) : raw;
    const isElement = /*#__PURE__*/ react.isValidElement(text);
    const comp = !isElement && typeof copy.component === "string" && copy.component.trim() ? copy.component.trim() : undefined;
    const out = {
        text
    };
    if (comp) out.component = comp;
    return out;
}
/**
 * Image mapper that defaults missing alt to '' and returns undefined without src.
 *
 * @param {Object} img - The image object.
 * @param {string} img.src - The image source URL.
 * @param {string} [img.alt] - Optional alt text.
 * @return {Object|undefined} Mapped image object with guaranteed `alt`, or undefined if no src provided.
 */ function mapImage(img) {
    var ref;
    return (img === null || img === void 0 ? void 0 : img.src) ? {
        ...img,
        src: (img === null || img === void 0 ? void 0 : img.imageModifiers) ? "".concat(img.src, "?").concat(img.imageModifiers) : img.src,
        alt: (ref = img === null || img === void 0 ? void 0 : img.alt) !== null && ref !== void 0 ? ref : "",
        "data-mode": (img === null || img === void 0 ? void 0 : img.s7PresetType) ? "smartcrop" : ""
    } : undefined;
}
const mapLink = (lnk)=>{
    if (!lnk) return undefined;
    return lnk;
};
const mapVideo = (video)=>{
    var ref;
    if (!video || !(video === null || video === void 0 ? void 0 : video.src) || (video === null || video === void 0 ? void 0 : (ref = video.src) === null || ref === void 0 ? void 0 : ref.length) === 0) return undefined;
    if (video.videoMobileLandscape || video.videoMobilePortrait) {
        const defaultVideoUrl = video.src;
        video.sources = [];
        if (video.videoMobileLandscape) {
            video.sources.push({
                src: video.videoMobileLandscape,
                media: "(max-height: 640px) and (orientation: landscape)"
            });
            delete video.videoMobileLandscape;
        }
        if (video.videoMobilePortrait) {
            video.sources.push({
                src: video.videoMobilePortrait,
                media: "(max-width: 640px) and (orientation: portrait)"
            });
            delete video.videoMobilePortrait;
        }
        video.sources.push({
            src: defaultVideoUrl
        });
    }
    return video;
};
const isObj = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
const findByType = (node, includes)=>{
    const test = (n)=>{
        return typeof (n === null || n === void 0 ? void 0 : n[":type"]) === "string" && n[":type"].toLowerCase().includes(includes.toLowerCase());
    };
    if (test(node)) return node;
    if (isObj(node === null || node === void 0 ? void 0 : node[":items"])) {
        for (const k of Object.keys(node[":items"])){
            const found = findByType(node[":items"][k], includes);
            if (found) return found;
        }
    }
    if (Array.isArray(node)) {
        for (const child of node){
            const found1 = findByType(child, includes);
            if (found1) return found1;
        }
    }
    if (isObj(node)) {
        for (const k1 of Object.keys(node)){
            if (k1 === ":items") continue;
            const v = node[k1];
            if (isObj(v) || Array.isArray(v)) {
                const found2 = findByType(v, includes);
                if (found2) return found2;
            }
        }
    }
    return undefined;
};
const asArray = (v)=>Array.isArray(v) ? v : v != null ? [
        v
    ] : [];
const pickStr = (v)=>typeof v === "string" && v.trim() !== "" ? v : undefined;
const mapOverlayDirection = (raw)=>{
    const v = String(raw !== null && raw !== void 0 ? raw : "").toLowerCase().replace(/\s+/g, "-");
    const allowed = new Set([
        "bottom-top",
        "top-bottom",
        "left-right",
        "right-left",
        "tint"
    ]);
    return allowed.has(v) ? v : undefined;
};
const mapOverlayOpacity = (raw)=>{
    const n = Number(raw);
    const allowed = new Set([
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45
    ]);
    return allowed.has(n) ? n : undefined;
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/twoUpContentMapper.js




/**
 * Maps two-up content container and its teaser children to props for the component.
 *
 * @param {Object} container - The container object, possibly with style/class info.
 * @param {Array} children - The child components, expected to include teasers.
 * @return {Object} Mapped props including heading, description, cards, and background.
 */ function mapTwoUpContentProps(container, children) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    // Defensive: filter only valid teasers
    const teasers = children.filter(isTeaser);
    // Explicitly identify main and card teasers
    const mainTeaser = teasers.length > 0 ? teasers[0] : {};
    const potentialCardTeasers = teasers.slice(1);
    if (teasers.length < 3) {
        // Correctly include the count in the warning
        console.warn("[TwoUpContent Mapper] Expected at least 3 teasers (1 main + 2 cards), got ".concat(teasers.length, ". Container:"), container.containerId || container);
    }
    // Take the first two potential cards
    const cardTeasers = potentialCardTeasers.slice(0, 2);
    // If less than 2 card teasers found, fill with empty objects
    while(cardTeasers.length < 2)cardTeasers.push({});
    // Map data using the identified teasers
    const mainTeaserData = extractTeaserData(mainTeaser);
    const { ctaLabel ="" , description ="" , linkUrl ="" , title =""  } = mainTeaserData;
    const cards = cardTeasers.map(extractTeaserData);
    // Optionally, map container-level styles
    const colors = container.appliedCssClassNames ? container.appliedCssClassNames.match(/\bbg-([a-z]+)\b/) : null;
    const background = colors ? colors[1] : null;
    const pageType = (mainTeaser === null || mainTeaser === void 0 ? void 0 : mainTeaser.pageType) || "";
    const cardsArray = mapCards(cards, pageType, constants.authorBaseUrl);
    return {
        mod: background,
        type: "50-50",
        imageOrientation: "landscape",
        heading: {
            text: title
        },
        description: {
            text: description
        },
        CTA: {
            href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(linkUrl),
            text: ctaLabel,
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "".concat(pageType, ":").concat((0,helper/* sanitizeInnerHtml */.KD0)(title).toLowerCase(), ":").concat((ref = (0,helper/* sanitizeInnerHtml */.KD0)(ctaLabel)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                    eventName: "".concat(pageType, ":").concat((ref1 = (0,helper/* sanitizeInnerHtml */.KD0)(title)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), ":").concat((ref2 = (0,helper/* sanitizeInnerHtml */.KD0)(ctaLabel)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                    eventType: "navigation",
                    internalLinkName: (ref3 = (0,helper/* sanitizeInnerHtml */.KD0)(ctaLabel)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(),
                    internalLinkPosition: "".concat(pageType, ":teaser"),
                    internalLinkType: "".concat(pageType, ":").concat((ref4 = (0,helper/* sanitizeInnerHtml */.KD0)(title)) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()),
                    internalLinkURL: linkUrl && "object" !== "undefined" ? "".concat(window.location.origin).concat(linkUrl === null || linkUrl === void 0 ? void 0 : linkUrl.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "".concat(pageType, ":").concat((ref5 = (0,helper/* sanitizeInnerHtml */.KD0)(title)) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                    eventMsg: "n/a",
                    eventStatus: "n/a"
                })
            }
        },
        cards: cardsArray
    };
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./utils/generate-smart-toilets-interactions.js
const PREFIX = "pxp:shop smart toilets:";
const defaultProps = {
    clickInternalLinks: "true",
    eventAction: "n/a",
    eventMsg: "n/a",
    eventName: "n/a",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: "n/a",
    internalLinkPosition: "n/a",
    internalLinkType: "n/a",
    internalLinkURL: "n/a",
    internalLinkZoneName: "n/a"
};
const generateInteractionProps = function(dynamicValue) {
    let overrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const propsWithFixedPrefix = "".concat(PREFIX).concat(dynamicValue).toLowerCase();
    const baseProps = {
        eventName: propsWithFixedPrefix,
        eventAction: propsWithFixedPrefix,
        internalLinkZoneName: propsWithFixedPrefix
    };
    const mergedProps = {
        ...defaultProps,
        ...baseProps,
        ...overrides
    };
    // Ensure all values are lowercase
    const finalProps = {};
    for(const key in mergedProps){
        if (Object.hasOwn(mergedProps, key)) {
            const value = mergedProps[key];
            finalProps[key] = typeof value === "string" ? value.toLowerCase() : value;
        }
    }
    return finalProps;
};

;// CONCATENATED MODULE: ./components/DesignSystem/analytics/featureCardSliderAnalytics.js


const handleModalInteractions = function(title, heading) {
    let isExpand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const interactionData = generateInteractionProps("".concat(title, ":").concat(isExpand ? "expand" : "close"), {
        internalLinkName: isExpand ? title : "close",
        internalLinkPosition: "pxp:".concat(heading),
        internalLinkType: "pxp:".concat(title),
        internalLinkZoneName: "pxp:shop smart toilets:".concat(heading)
    });
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
        ...interactionData
    });
};

;// CONCATENATED MODULE: ./components/DesignSystem/validators/featuredCardsWithModalSliderValidator.js
/**
 * Validates FeatureCardsWithModalSlider component props
 * @param {object} props - The props object to validate
 * @param {boolean} [throwOnError=false] - If true, throws an error on validation failure. If false, returns validation result
 * @return {{isValid: boolean, errors: string[]}} ValidationResult object containing isValid flag and array of error messages
 * @throws {Error} if throwOnError is true and validation fails
 */ const validateFeatureCardsWithModalSliderProps = function(props) {
    let throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const errors = [];
    // Check if props is an object
    if (!props || typeof props !== "object") {
        errors.push("Props must be an object");
        if (throwOnError) {
            throw new Error("FeatureCardsWithModalSlider validation failed:\n".concat(errors.join("\n")));
        }
        return {
            isValid: false,
            errors
        };
    }
    // Validate required heading
    if (!props.heading) {
        errors.push("heading is required");
    } else {
        if (typeof props.heading !== "object") {
            errors.push("heading must be an object");
        } else {
            if (!props.heading.text) {
                errors.push("heading.text is required");
            }
            if (typeof props.heading.text !== "string" && typeof props.heading.text !== "object") {
                errors.push("heading.text must be a string or React element");
            }
        }
    }
    // Validate required cards
    if (!props.cards) {
        errors.push("cards is required");
    } else if (!Array.isArray(props.cards)) {
        errors.push("cards must be an array");
    } else if (props.cards.length === 0) {
        errors.push("cards array must not be empty");
    } else {
        props.cards.forEach((card, index)=>{
            if (typeof card !== "object" || card === null) {
                errors.push("cards[".concat(index, "] must be an object"));
            } else {
                // Validate required image
                if (!card.image) {
                    errors.push("cards[".concat(index, "].image is required"));
                } else {
                    if (typeof card.image !== "object") {
                        errors.push("cards[".concat(index, "].image must be an object"));
                    } else {
                        if (!card.image.src) {
                            errors.push("cards[".concat(index, "].image.src is required"));
                        }
                    }
                }
                // Validate required heading
                if (!card.heading) {
                    errors.push("cards[".concat(index, "].heading is required"));
                } else {
                    if (typeof card.heading !== "object") {
                        errors.push("cards[".concat(index, "].heading must be an object"));
                    } else {
                        if (!card.heading.text) {
                            errors.push("cards[".concat(index, "].heading.text is required"));
                        }
                    }
                }
                // Validate optional imageActionCTA
                if (card.imageActionCTA !== undefined) {
                    if (typeof card.imageActionCTA !== "object" || card.imageActionCTA === null) {
                        errors.push("cards[".concat(index, "].imageActionCTA must be an object if provided"));
                    }
                }
                // Validate optional modalContent
                if (card.modalContent !== undefined) {
                    if (typeof card.modalContent !== "object" || card.modalContent === null) {
                        errors.push("cards[".concat(index, "].modalContent must be an object if provided"));
                    } else {
                        // Validate optional heading in modalContent
                        if (card.modalContent.heading !== undefined) {
                            if (typeof card.modalContent.heading !== "object" || card.modalContent.heading === null) {
                                errors.push("cards[".concat(index, "].modalContent.heading must be an object if provided"));
                            } else {
                                if (!card.modalContent.heading.text) {
                                    errors.push("cards[".concat(index, "].modalContent.heading.text is required when heading is provided"));
                                }
                            }
                        }
                        // Validate required content array
                        if (!card.modalContent.content) {
                            errors.push("cards[".concat(index, "].modalContent.content is required"));
                        } else if (!Array.isArray(card.modalContent.content)) {
                            errors.push("cards[".concat(index, "].modalContent.content must be an array"));
                        } else {
                            card.modalContent.content.forEach((contentBlock, contentIndex)=>{
                                if (typeof contentBlock !== "object" || contentBlock === null) {
                                    errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "] must be an object"));
                                } else {
                                    // Validate optional heading in content block
                                    if (contentBlock.heading !== undefined) {
                                        if (typeof contentBlock.heading !== "object" || contentBlock.heading === null) {
                                            errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].heading must be an object if provided"));
                                        } else {
                                            if (!contentBlock.heading.text) {
                                                errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].heading.text is required when heading is provided"));
                                            }
                                        }
                                    }
                                    // Validate optional copy in content block
                                    if (contentBlock.copy !== undefined) {
                                        if (typeof contentBlock.copy !== "object" || contentBlock.copy === null) {
                                            errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].copy must be an object if provided"));
                                        } else {
                                            if (!contentBlock.copy.text) {
                                                errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].copy.text is required when copy is provided"));
                                            }
                                        }
                                    }
                                    // Validate optional image in content block
                                    if (contentBlock.image !== undefined) {
                                        if (typeof contentBlock.image !== "object" || contentBlock.image === null) {
                                            errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].image must be an object if provided"));
                                        } else {
                                            if (!contentBlock.image.src) {
                                                errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].image.src is required when image is provided"));
                                            }
                                        }
                                    }
                                    // Validate optional isFullWidth
                                    if (contentBlock.isFullWidth !== undefined) {
                                        if (typeof contentBlock.isFullWidth !== "boolean") {
                                            errors.push("cards[".concat(index, "].modalContent.content[").concat(contentIndex, "].isFullWidth must be a boolean if provided"));
                                        }
                                    }
                                }
                            });
                        }
                        // Validate optional onModalClose
                        if (card.modalContent.onModalClose !== undefined) {
                            if (typeof card.modalContent.onModalClose !== "function") {
                                errors.push("cards[".concat(index, "].modalContent.onModalClose must be a function if provided"));
                            }
                        }
                    }
                }
            }
        });
    }
    // Validate optional topSpacer
    if (props.topSpacer !== undefined) {
        if (typeof props.topSpacer !== "object" || props.topSpacer === null) {
            errors.push("topSpacer must be an object if provided");
        }
    }
    // Validate optional bottomSpacer
    if (props.bottomSpacer !== undefined) {
        if (typeof props.bottomSpacer !== "object" || props.bottomSpacer === null) {
            errors.push("bottomSpacer must be an object if provided");
        }
    }
    const isValid = errors.length === 0;
    if (!isValid && throwOnError) {
        throw new Error("FeatureCardsWithModalSlider validation failed:\n".concat(errors.join("\n")));
    }
    return {
        isValid,
        errors
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/featureCardsSliderMapper.js




const mapModalContentSections = function() {
    let sections = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const mapped = sections.map((sec)=>{
        var ref;
        const heading = mapTitle(sec === null || sec === void 0 ? void 0 : (ref = sec.image) === null || ref === void 0 ? void 0 : ref.heading);
        const copy = mapText(sec === null || sec === void 0 ? void 0 : sec.copy);
        const image = mapImage((0,lodash.omit)(sec === null || sec === void 0 ? void 0 : sec.image, [
            "heading",
            "href"
        ]));
        const isFullWidth = typeof (sec === null || sec === void 0 ? void 0 : sec.isFullWidth) === "boolean" ? sec.isFullWidth : undefined;
        if (!heading && !copy && !image && isFullWidth === undefined) return undefined;
        return {
            ...heading ? {
                heading
            } : {},
            ...copy ? {
                copy
            } : {},
            ...image ? {
                image
            } : {},
            ...isFullWidth !== undefined ? {
                isFullWidth
            } : {}
        };
    }).filter(Boolean);
    return mapped.length ? mapped : undefined;
};
const mapModal = function(modal) {
    let mainHeading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!modal) return undefined;
    const heading = mapTitle(modal === null || modal === void 0 ? void 0 : modal.heading);
    const content = mapModalContentSections((modal === null || modal === void 0 ? void 0 : modal.content) || []);
    if (!heading && !content) return undefined;
    return {
        ...heading ? {
            heading
        } : {},
        ...content ? {
            content
        } : {},
        onModalClose: ()=>{
            return handleModalInteractions(heading === null || heading === void 0 ? void 0 : heading.text, mainHeading);
        }
    };
};
const mapCard = (card, mainTitle)=>{
    var ref, ref1, ref2;
    const { text: mainHeading = ""  } = mainTitle || {};
    const heading = mapTitle(card === null || card === void 0 ? void 0 : (ref = card.heading) === null || ref === void 0 ? void 0 : ref[0]);
    const image = mapImage(card === null || card === void 0 ? void 0 : (ref1 = card.image) === null || ref1 === void 0 ? void 0 : ref1[0]);
    const modalContent = mapModal(card === null || card === void 0 ? void 0 : (ref2 = card.modalContent) === null || ref2 === void 0 ? void 0 : ref2[0], mainHeading);
    const imageActionCTA = {
        onClick: ()=>{
            return handleModalInteractions(heading === null || heading === void 0 ? void 0 : heading.text, mainHeading, true);
        }
    };
    if (!heading && !image && !imageActionCTA) return undefined;
    return {
        ...heading ? {
            heading
        } : {},
        ...image ? {
            image
        } : {},
        ...modalContent ? {
            modalContent
        } : {},
        ...imageActionCTA ? {
            imageActionCTA
        } : {}
    };
};
/**
 * Maps Feature Cards With Modal Slider content container and its teaser children to props for the component.
 *
 * @param {Object} container - The container object, possibly with style/class info.
 * @return {Object} Mapped props including heading, description, cards, and background.
 */ function mapFeatureCardsSliderProps(container) {
    var ref, ref1, ref2;
    var ref3, ref4;
    const firstKey = (ref4 = container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref4 !== void 0 ? ref4 : Object.keys((ref3 = container === null || container === void 0 ? void 0 : container[":items"]) !== null && ref3 !== void 0 ? ref3 : {})[0];
    const node = firstKey ? container === null || container === void 0 ? void 0 : (ref1 = container[":items"]) === null || ref1 === void 0 ? void 0 : ref1[firstKey] : undefined;
    if (!node) return null;
    const basic = node.basic;
    const media = node.media;
    const mod = (basic === null || basic === void 0 ? void 0 : basic.mod) || "white";
    const heading = mapTitle(basic === null || basic === void 0 ? void 0 : basic.heading);
    const cards = (ref2 = asArray(media === null || media === void 0 ? void 0 : media.media)) === null || ref2 === void 0 ? void 0 : ref2.map((item)=>mapCard(item, heading)).filter(Boolean).map((item)=>({
            ...item
        }));
    const topSpacer = basic.topSpacer ? normalizeSpacer(basic.topSpacer.size) : undefined;
    const bottomSpacer = basic.bottomSpacer ? normalizeSpacer(basic.bottomSpacer.size) : undefined;
    const featuredCardsWithModalSliderProps = {
        ...mod ? {
            mod
        } : {},
        ...heading ? {
            heading
        } : {},
        ...topSpacer ? {
            topSpacer
        } : {},
        ...bottomSpacer ? {
            bottomSpacer
        } : {},
        ...(cards === null || cards === void 0 ? void 0 : cards.length) ? {
            cards
        } : {}
    };
    const { isValid , errors  } = validateFeatureCardsWithModalSliderProps(featuredCardsWithModalSliderProps);
    if (!isValid) {
        console.warn("featuredCardsWithModalSliderProps validation errors:", errors);
        return null;
    }
    return featuredCardsWithModalSliderProps;
}

;// CONCATENATED MODULE: ./components/DesignSystem/analytics/productLIstHeroAnalytics.js


const handleProductListHeroCTAClick = (evt, ctaText)=>{
    const interactionData = generateInteractionProps(ctaText, {
        internalLinkName: ctaText,
        internalLinkPosition: "pxp:shop smart toilets",
        internalLinkType: "pxp:".concat(ctaText)
    });
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
        ...interactionData
    });
};
const handleProductListHeroImageClick = (title)=>{
    const interactionData = generateInteractionProps(title, {
        internalLinkName: title,
        internalLinkPosition: "pxp:shop smart toilets",
        internalLinkType: "pxp:".concat(title)
    });
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
        ...interactionData
    });
};

// EXTERNAL MODULE: ./js/helperV2.js
var helperV2 = __webpack_require__(30696);
;// CONCATENATED MODULE: ./components/DesignSystem/validators/productListHeroValidator.js
/**
 * Validates ProductListHero component props
 * @param {object} props - The props object to validate
 * @param {boolean} [throwOnError=false] - If true, throws an error on validation failure. If false, returns validation result
 * @return {{isValid: boolean, errors: string[]}} ValidationResult object containing isValid flag and array of error messages
 * @throws {Error} if throwOnError is true and validation fails
 */ const validateProductListHeroProps = function(props) {
    let throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const errors = [];
    // Check if props is an object
    if (!props || typeof props !== "object") {
        errors.push("Props must be an object");
        if (throwOnError) {
            throw new Error("ProductListHero validation failed:\n".concat(errors.join("\n")));
        }
        return {
            isValid: false,
            errors
        };
    }
    // Validate required heading
    if (!props.heading) {
        errors.push("heading is required");
    } else {
        if (typeof props.heading !== "object") {
            errors.push("heading must be an object");
        } else {
            if (!props.heading.text) {
                errors.push("heading.text is required");
            }
            if (typeof props.heading.text !== "string" && typeof props.heading.text !== "object") {
                errors.push("heading.text must be a string or React element");
            }
        }
    }
    // Validate optional image
    if (props.image !== undefined) {
        if (typeof props.image !== "object" || props.image === null) {
            errors.push("image must be an object if provided");
        } else {
            if (!props.image.src) {
                errors.push("image.src is required when image is provided");
            }
        }
    }
    // Validate optional video
    if (props.video !== undefined) {
        if (typeof props.video !== "object" || props.video === null) {
            errors.push("video must be an object if provided");
        } else {
            if (!props.video.src) {
                errors.push("video.src is required when video is provided");
            }
        }
    }
    // Validate optional copy
    if (props.copy !== undefined) {
        if (typeof props.copy !== "object" || props.copy === null) {
            errors.push("copy must be an object if provided");
        } else {
            if (!props.copy.text) {
                errors.push("copy.text is required when copy is provided");
            }
            if (typeof props.copy.text !== "string" && typeof props.copy.text !== "object") {
                errors.push("copy.text must be a string or React element");
            }
        }
    }
    // Validate optional CTAs
    if (props.CTAs !== undefined) {
        if (!Array.isArray(props.CTAs)) {
            errors.push("CTAs must be an array if provided");
        } else {
            props.CTAs.forEach((cta, index)=>{
                if (typeof cta !== "object" || cta === null) {
                    errors.push("CTAs[".concat(index, "] must be an object"));
                } else {
                    if (!cta.text) {
                        errors.push("CTAs[".concat(index, "].text is required"));
                    }
                    if (!cta.href && !cta.onClick) {
                        errors.push("CTAs[".concat(index, "] must have either href or onClick"));
                    }
                }
            });
        }
    }
    // Validate optional products
    if (props.products !== undefined) {
        if (!Array.isArray(props.products)) {
            errors.push("products must be an array if provided");
        } else {
            props.products.forEach((product, index)=>{
                if (typeof product !== "object" || product === null) {
                    errors.push("products[".concat(index, "] must be an object"));
                } else {
                    // Validate required image
                    if (!product.image) {
                        errors.push("products[".concat(index, "].image is required"));
                    } else {
                        if (typeof product.image !== "object") {
                            errors.push("products[".concat(index, "].image must be an object"));
                        } else {
                            if (!product.image.src) {
                                errors.push("products[".concat(index, "].image.src is required"));
                            }
                        }
                    }
                    // Validate required title
                    if (!product.title) {
                        errors.push("products[".concat(index, "].title is required"));
                    } else {
                        if (typeof product.title !== "object") {
                            errors.push("products[".concat(index, "].title must be an object"));
                        } else {
                            if (!product.title.text) {
                                errors.push("products[".concat(index, "].title.text is required"));
                            }
                        }
                    }
                    // Validate href or onClick
                    if (!product.href && !product.onClick) {
                        errors.push("products[".concat(index, "] must have either href or onClick"));
                    }
                }
            });
        }
    }
    const isValid = errors.length === 0;
    if (!isValid && throwOnError) {
        throw new Error("ProductListHero validation failed:\n".concat(errors.join("\n")));
    }
    return {
        isValid,
        errors
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/productListHeroMapper.js






/**
 * Maps a “Product List Hero” AEM container node (provided via `children`) into KDS props.
 *
 * Reads the first child (`children[0]`) and maps:
 * - `mod` (defaults to `"white"`)
 * - `heading` via `mapTitle(basic.heading)`
 * - `copy` via `mapText(basic.copy)`
 * - `image` via `mapImage(basic.image)`
 * - `video` via `mapVideo(basic.video)`
 * - `CTAs` via `asArray(basic.cta) -> mapLink`
 * - `products` via `content.content`, each with:
 *    - `image` from `p.productImage`
 *    - `title` from `p.title` (uses `mapTitle`, accepts `'p'` by current behavior)
 *    - `href` from `p.href`
 *
 * Returns `null` if `children[0]` is absent. Omits keys whose mapped values are empty/undefined.
 *
 * @param {Object} container Unused container metadata (kept for signature parity).
 * @return {Object|null} Mapped props object or `null` if nothing to map.
 */ function mapProductListHeroProps(container) {
    try {
        var ref, ref1, ref2;
        var ref3, ref4;
        const firstKey = (ref4 = container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref4 !== void 0 ? ref4 : (ref1 = Object.keys((ref3 = container === null || container === void 0 ? void 0 : container[":items"]) !== null && ref3 !== void 0 ? ref3 : {})) === null || ref1 === void 0 ? void 0 : ref1[0];
        const node = firstKey ? container === null || container === void 0 ? void 0 : (ref2 = container[":items"]) === null || ref2 === void 0 ? void 0 : ref2[firstKey] : undefined;
        if (!node) return null;
        const basic = node.basic;
        const content = node.content;
        const heading = mapTitle(basic === null || basic === void 0 ? void 0 : basic.heading);
        const copy = mapText(basic === null || basic === void 0 ? void 0 : basic.copy);
        const heroImageSource = basic === null || basic === void 0 ? void 0 : basic.image;
        const video = mapVideo(basic === null || basic === void 0 ? void 0 : basic.video);
        const image = mapImage(heroImageSource);
        const mod = (basic === null || basic === void 0 ? void 0 : basic.mod) || "white";
        const CTAs = asArray(basic === null || basic === void 0 ? void 0 : basic.cta).map(mapLink).filter(Boolean).map((cta)=>({
                ...cta,
                onClick: (evt)=>handleProductListHeroCTAClick(evt, cta.text)
            }));
        const productItems = asArray(content === null || content === void 0 ? void 0 : content.content);
        const products = productItems.map((p)=>{
            var ref, ref1, ref2;
            const img = mapImage((0,lodash.omit)(p === null || p === void 0 ? void 0 : (ref = p.productImage) === null || ref === void 0 ? void 0 : ref[0], [
                "heading",
                "href"
            ]));
            const title = mapTitle(p === null || p === void 0 ? void 0 : (ref1 = p.title) === null || ref1 === void 0 ? void 0 : ref1[0]);
            const href = p === null || p === void 0 ? void 0 : p.href;
            const titleText = (0,helperV2/* sanitizeText */.oO)((0,helper/* sanitizeTextForAnalytics */.T68)(p === null || p === void 0 ? void 0 : (ref2 = p.title) === null || ref2 === void 0 ? void 0 : ref2.text));
            return img && title ? {
                image: img,
                title,
                href,
                onClick: ()=>handleProductListHeroImageClick(titleText)
            } : undefined;
        }).filter(Boolean);
        if (video) {
            video.loop = false;
        }
        if (heading) {
            heading.reveal = {
                enabled: true,
                delay: 300
            };
        }
        if (copy) {
            copy.reveal = {
                enabled: true,
                delay: 600
            };
        }
        let CTAsReveal;
        if ((CTAs === null || CTAs === void 0 ? void 0 : CTAs.length) > 0) {
            CTAsReveal = {
                enabled: true,
                delay: 600
            };
        }
        let productsReveal;
        if ((products === null || products === void 0 ? void 0 : products.length) > 0) {
            productsReveal = {
                enabled: true,
                delay: 900
            };
        }
        if (image) {
            image.reveal = {
                enabled: true,
                delay: 1000
            };
        }
        if (video) {
            video.reveal = {
                enabled: true,
                delay: 1000
            };
        }
        const productListHeroProps = {
            ...mod ? {
                mod
            } : {},
            ...heading ? {
                heading: {
                    ...heading
                }
            } : {},
            ...image ? {
                image
            } : {},
            ...video ? {
                video
            } : {},
            ...copy ? {
                copy
            } : {},
            ...CTAs.length ? {
                CTAs
            } : {},
            ...products.length ? {
                products
            } : {},
            ...CTAsReveal ? {
                CTAsReveal
            } : {},
            ...productsReveal ? {
                productsReveal
            } : {}
        };
        const { isValid , errors  } = validateProductListHeroProps(productListHeroProps);
        if (!isValid) {
            console.warn("productListHeroProps validation errors:", errors);
            return null;
        }
        return productListHeroProps;
    } catch (error) {
        console.error("Error mapping ProductListHero props:", error);
        return null;
    }
}

;// CONCATENATED MODULE: ./components/DesignSystem/validators/fullBleedExperienceValidator.js
// Valid values for PhotoOverlay props
const VALID_PHOTO_OVERLAY_DIRECTIONS = [
    "bottom-top",
    "top-bottom",
    "left-right",
    "right-left",
    "tint"
];
const VALID_PHOTO_OVERLAY_OPACITIES = [
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45
];
const VALID_TEXT_PLACEMENTS = [
    "bottom-middle",
    "top-middle"
];
/**
 * Validates FullBleedExperience component props
 * @param {object} props - The props object to validate
 * @param {boolean} [throwOnError=false] - If true, throws an error on validation failure. If false, returns validation result
 * @return {{isValid: boolean, errors: string[]}} ValidationResult object containing isValid flag and array of error messages
 * @throws {Error} if throwOnError is true and validation fails
 */ const validateFullBleedExperienceProps = function(props) {
    let throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const errors = [];
    // Check if props is an object
    if (!props || typeof props !== "object") {
        errors.push("Props must be an object");
        if (throwOnError) {
            throw new Error("FullBleedExperience validation failed:\n".concat(errors.join("\n")));
        }
        return {
            isValid: false,
            errors
        };
    }
    // Note: All props are optional, so we only validate structure when provided
    // Validate optional heading
    if (props.heading !== undefined) {
        if (typeof props.heading !== "object" || props.heading === null) {
            errors.push("heading must be an object if provided");
        } else {
            if (!props.heading.text) {
                errors.push("heading.text is required when heading is provided");
            }
            if (typeof props.heading.text !== "string" && typeof props.heading.text !== "object") {
                errors.push("heading.text must be a string or React element");
            }
            // Validate reveal if present
            if (props.heading.reveal !== undefined) {
                if (typeof props.heading.reveal !== "object" || props.heading.reveal === null) {
                    errors.push("heading.reveal must be an object if provided");
                }
            }
        }
    }
    // Validate optional image
    if (props.image !== undefined) {
        if (typeof props.image !== "object" || props.image === null) {
            errors.push("image must be an object if provided");
        } else {
            if (!props.image.src) {
                errors.push("image.src is required when image is provided");
            }
        }
    }
    // Validate optional video
    if (props.video !== undefined) {
        if (typeof props.video !== "object" || props.video === null) {
            errors.push("video must be an object if provided");
        } else {
            if (!props.video.src) {
                errors.push("video.src is required when video is provided");
            }
        }
    }
    // Validate optional copy
    if (props.copy !== undefined) {
        if (typeof props.copy !== "object" || props.copy === null) {
            errors.push("copy must be an object if provided");
        } else {
            if (!props.copy.text) {
                errors.push("copy.text is required when copy is provided");
            }
            if (typeof props.copy.text !== "string" && typeof props.copy.text !== "object") {
                errors.push("copy.text must be a string or React element");
            }
            // Validate reveal if present
            if (props.copy.reveal !== undefined) {
                if (typeof props.copy.reveal !== "object" || props.copy.reveal === null) {
                    errors.push("copy.reveal must be an object if provided");
                }
            }
        }
    }
    // Validate optional textPlacement
    if (props.textPlacement !== undefined) {
        if (!VALID_TEXT_PLACEMENTS.includes(props.textPlacement)) {
            errors.push("textPlacement must be one of: ".concat(VALID_TEXT_PLACEMENTS.join(", ")));
        }
    }
    // Validate optional hasPhotoOverlay
    if (props.hasPhotoOverlay !== undefined) {
        if (typeof props.hasPhotoOverlay !== "boolean") {
            errors.push("hasPhotoOverlay must be a boolean if provided");
        }
    }
    // Validate optional gradientDirection
    if (props.gradientDirection !== undefined) {
        if (!VALID_PHOTO_OVERLAY_DIRECTIONS.includes(props.gradientDirection)) {
            errors.push("gradientDirection must be one of: ".concat(VALID_PHOTO_OVERLAY_DIRECTIONS.join(", ")));
        }
    }
    // Validate optional opacity
    if (props.opacity !== undefined) {
        if (!VALID_PHOTO_OVERLAY_OPACITIES.includes(props.opacity)) {
            errors.push("opacity must be one of: ".concat(VALID_PHOTO_OVERLAY_OPACITIES.join(", ")));
        }
    }
    const isValid = errors.length === 0;
    if (!isValid && throwOnError) {
        throw new Error("FullBleedExperience validation failed:\n".concat(errors.join("\n")));
    }
    return {
        isValid,
        errors
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/fullBleedExperienceMapper.js


/**
 * Maps an AEM “full bleed experience” container into KDS props.
 *
 * Expects the first item in `:itemsOrder` to be `fullproductdisplay` and maps:
 * - `mod` (defaults to `"white"`)
 * - `heading` via `mapTitle`
 * - `image` via `mapImage` (prefers `media.image`, falls back to `content.image`)
 * - `video` via `mapVideo` (if present)
 * - `copy` via `mapText` (omitted if empty)
 * - `textPlacement` only if one of: `"bottom-middle" | "top-middle"`
 *
 * @param {Record<string, any>} container Raw AEM container node.
 * @return {Record<string, any> | null} Mapped props object or `null` if nothing to map.
 */ function mapFullBleedExperienceProps(container) {
    try {
        var ref, ref1, ref2, ref3;
        if (!container) return null;
        const node = ((ref1 = container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map(()=>{
            var ref;
            return container === null || container === void 0 ? void 0 : (ref = container[":items"]) === null || ref === void 0 ? void 0 : ref["fullproductdisplay"];
        })) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean)) || [];
        if (!node || !node.length) return null;
        const basic = node === null || node === void 0 ? void 0 : (ref2 = node[0]) === null || ref2 === void 0 ? void 0 : ref2.basic;
        const media = node === null || node === void 0 ? void 0 : (ref3 = node[0]) === null || ref3 === void 0 ? void 0 : ref3.media;
        const heading = mapTitle(basic === null || basic === void 0 ? void 0 : basic.heading);
        const copy = mapText(basic === null || basic === void 0 ? void 0 : basic.copy);
        const image = mapImage(basic === null || basic === void 0 ? void 0 : basic.image);
        const video = mapVideo((basic === null || basic === void 0 ? void 0 : basic.video) || (media === null || media === void 0 ? void 0 : media.video));
        const mod = pickStr(basic === null || basic === void 0 ? void 0 : basic.mod) || "white";
        const textPlacement = (()=>{
            const raw = pickStr(basic === null || basic === void 0 ? void 0 : basic.textPlacement);
            const ok = new Set([
                "bottom-middle",
                "top-middle"
            ]);
            return raw && ok.has(raw) ? raw : undefined;
        })();
        if (heading) {
            heading.reveal = {
                enabled: true,
                delay: 300
            };
        }
        if (copy) {
            copy.reveal = {
                enabled: true,
                delay: 600
            };
        }
        if (mod !== "black" && mod !== "charcoal") {
            if (heading) {
                heading.textColor = "black";
            }
            if (copy) {
                copy.textColor = "black";
            }
        }
        if (video) {
            video.loop = false;
        }
        const fullBleedExperienceProps = {
            ...mod ? {
                mod
            } : {},
            ...heading ? {
                heading
            } : {},
            ...image ? {
                image
            } : {},
            ...video ? {
                video
            } : {},
            ...copy ? {
                copy
            } : {},
            ...textPlacement ? {
                textPlacement
            } : {},
            hasPhotoOverlay: false
        };
        const { isValid , errors  } = validateFullBleedExperienceProps(fullBleedExperienceProps);
        if (!isValid) {
            console.warn("fullBleedExperienceProps validation errors:", errors);
            return null;
        }
        return fullBleedExperienceProps;
    } catch (error) {
        console.error("FullBleedExperience mapping error:", error);
        return null;
    }
}

;// CONCATENATED MODULE: ./components/DesignSystem/analytics/videoSliderAnalytics.js


const handleVideoClick = (heading, videoTitle, videoId, videoSrc)=>{
    const interactionData = generateInteractionProps(videoTitle, {
        eventName: "pxp:".concat(videoTitle, ":video play"),
        eventAction: "pxp:".concat(videoTitle, ":video play"),
        internalLinkName: "video play",
        internalLinkPosition: "pxp:".concat(heading, ":video teaser"),
        internalLinkType: "pxp:".concat(videoTitle),
        internalLinkZoneName: "pxp:shop smart toilets:compare models",
        videoId,
        videoName: videoTitle,
        videoType: "autoplay",
        internalLinkURL: videoSrc,
        eventType: "teaser"
    });
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
        ...interactionData
    });
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/videoSliderMapper.js


/**
 * Maps a “Video Slider” container into KDS props.
 *
 * Selects the first child from `:itemsOrder` (or first key in `:items`) and maps:
 * - `mod` (defaults to "white")
 * - `heading` via `mapTitle(basic.heading)`
 * - `topSpacer` / `bottomSpacer` via `normalizeSpacer` (read from node-level)
 * - `cards[]` from `media` (supports array or single object) where each card includes:
 *    - `heading` via `mapTitle(mediaItem.description || 'lorem ipsum')`
 *    - `video` via `mapVideo(mediaItem.video)` (with `closeCTA` passthrough)
 *    - `image` via `mapImage(mediaItem.image)`
 *    - `duration` via `mapText(mediaItem.duration)`
 *  A card is included if it has a `heading` AND (`video` OR `image`).
 *
 * Returns `null` if no child node exists. Omits empty keys.
 *
 * @param {Object} container AEM container node with `:itemsOrder` and `:items`.
 * @return {Object|null} Mapped props or `null`.
 */ function mapVideoSliderProps(container) {
    var ref, ref1, ref2;
    var ref3, ref4;
    const firstKey = (ref4 = container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref4 !== void 0 ? ref4 : Object.keys((ref3 = container === null || container === void 0 ? void 0 : container[":items"]) !== null && ref3 !== void 0 ? ref3 : {})[0];
    const node = firstKey ? container === null || container === void 0 ? void 0 : (ref1 = container[":items"]) === null || ref1 === void 0 ? void 0 : ref1[firstKey] : undefined;
    if (!node) return null;
    const basic = node.basic || {};
    var ref5, ref6;
    const mediaList = asArray((ref6 = (ref5 = node === null || node === void 0 ? void 0 : (ref2 = node.media) === null || ref2 === void 0 ? void 0 : ref2.media) !== null && ref5 !== void 0 ? ref5 : node === null || node === void 0 ? void 0 : node.media) !== null && ref6 !== void 0 ? ref6 : []);
    const mod = (basic === null || basic === void 0 ? void 0 : basic.mod) || "white";
    const heading = mapTitle(basic === null || basic === void 0 ? void 0 : basic.heading);
    var _size;
    const topSpacer = (node === null || node === void 0 ? void 0 : node.topSpacer) ? normalizeSpacer((_size = node.topSpacer.size) !== null && _size !== void 0 ? _size : node.topSpacer) : undefined;
    var _size1;
    const bottomSpacer = (node === null || node === void 0 ? void 0 : node.bottomSpacer) ? normalizeSpacer((_size1 = node.bottomSpacer.size) !== null && _size1 !== void 0 ? _size1 : node.bottomSpacer) : undefined;
    const cards = mediaList.map((c)=>{
        var ref, ref1, ref2;
        const videoRaw = (ref = asArray(c === null || c === void 0 ? void 0 : c.video)) === null || ref === void 0 ? void 0 : ref[0];
        const imageRaw = (ref1 = asArray(c === null || c === void 0 ? void 0 : c.image)) === null || ref1 === void 0 ? void 0 : ref1[0];
        const videoSrc = videoRaw === null || videoRaw === void 0 ? void 0 : videoRaw.src;
        const isScene7Image = typeof videoSrc === "string" && videoSrc.includes("is/image");
        const video = !isScene7Image && videoRaw ? mapVideo(videoRaw) : undefined;
        const imageCandidate = isScene7Image ? videoRaw : imageRaw;
        const image = imageCandidate ? mapImage(imageCandidate) : undefined;
        const title = mapTitle(c === null || c === void 0 ? void 0 : (ref2 = c.heading) === null || ref2 === void 0 ? void 0 : ref2[0]);
        const duration = mapText(c === null || c === void 0 ? void 0 : c.duration);
        const closeCTA = videoRaw === null || videoRaw === void 0 ? void 0 : videoRaw.closeCTA;
        // closeCTA.onClick = () => console.log("Close video")
        return title && (video || image) ? {
            heading: title,
            ...video ? {
                video,
                closeCTA
            } : {},
            ...image ? {
                image
            } : {},
            ...duration ? {
                duration
            } : {},
            onClick: ()=>handleVideoClick(heading.text, title.text, "".concat(title.text, "_video"), videoSrc)
        } : undefined;
    }).filter(Boolean);
    if (cards.length === 0) return null;
    return {
        ...mod ? {
            mod
        } : {},
        ...heading ? {
            heading
        } : {},
        ...cards.length ? {
            cards
        } : {},
        ...topSpacer ? {
            topSpacer
        } : {},
        ...bottomSpacer ? {
            bottomSpacer
        } : {}
    };
}

;// CONCATENATED MODULE: ./components/DesignSystem/analytics/twoUpfeatureCardsAnalytics.js


const handleCTAForFeatureCards = (title)=>{
    const interactionData = generateInteractionProps("".concat(title), {
        internalLinkName: title,
        internalLinkPosition: "pxp:shop smart toilets",
        internalLinkType: "pxp:".concat(title),
        internalLinkZoneName: "pxp:shop smart toilets:".concat(title)
    });
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
        ...interactionData
    });
};

;// CONCATENATED MODULE: ./components/DesignSystem/validators/twoUpFeaturedCardsValidator.js
// Valid values for component props
const VALID_VARIANTS = [
    "default",
    "spacious"
];
const twoUpFeaturedCardsValidator_VALID_PHOTO_OVERLAY_DIRECTIONS = [
    "bottom-top",
    "top-bottom",
    "left-right",
    "right-left",
    "tint"
];
const twoUpFeaturedCardsValidator_VALID_PHOTO_OVERLAY_OPACITIES = [
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45
];
/**
 * Validates TwoUpFeaturedCards component props
 * @param {object} props - The props object to validate
 * @param {boolean} [throwOnError=false] - If true, throws an error on validation failure. If false, returns validation result
 * @return {{isValid: boolean, errors: string[]}} ValidationResult object containing isValid flag and array of error messages
 * @throws {Error} if throwOnError is true and validation fails
 */ const validateTwoUpFeaturedCardsProps = function(props) {
    let throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const errors = [];
    // Check if props is an object
    if (!props || typeof props !== "object") {
        errors.push("Props must be an object");
        if (throwOnError) {
            throw new Error("TwoUpFeaturedCards validation failed:\n".concat(errors.join("\n")));
        }
        return {
            isValid: false,
            errors
        };
    }
    // Validate required cards
    if (!props.cards) {
        errors.push("cards is required");
    } else if (!Array.isArray(props.cards)) {
        errors.push("cards must be an array");
    } else if (props.cards.length === 0) {
        errors.push("cards array must not be empty");
    } else {
        props.cards.forEach((card, index)=>{
            if (typeof card !== "object" || card === null) {
                errors.push("cards[".concat(index, "] must be an object"));
            } else {
                // Validate required CTA
                if (!card.CTA) {
                    errors.push("cards[".concat(index, "].CTA is required"));
                } else {
                    if (typeof card.CTA !== "object") {
                        errors.push("cards[".concat(index, "].CTA must be an object"));
                    } else {
                        if (!card.CTA.text) {
                            errors.push("cards[".concat(index, "].CTA.text is required"));
                        }
                        if (!card.CTA.href && !card.CTA.onClick) {
                            errors.push("cards[".concat(index, "].CTA must have either href or onClick"));
                        }
                    }
                }
                // Validate required image
                if (!card.image) {
                    errors.push("cards[".concat(index, "].image is required"));
                } else {
                    if (typeof card.image !== "object") {
                        errors.push("cards[".concat(index, "].image must be an object"));
                    } else {
                        if (!card.image.src) {
                            errors.push("cards[".concat(index, "].image.src is required"));
                        }
                        if (!card.image.alt) {
                            errors.push("cards[".concat(index, "].image.alt is required"));
                        }
                    }
                }
                // Validate optional eyebrow
                if (card.eyebrow !== undefined) {
                    if (typeof card.eyebrow !== "object" || card.eyebrow === null) {
                        errors.push("cards[".concat(index, "].eyebrow must be an object if provided"));
                    } else {
                        if (!card.eyebrow.text) {
                            errors.push("cards[".concat(index, "].eyebrow.text is required when eyebrow is provided"));
                        }
                    }
                }
                // Validate optional title
                if (card.title !== undefined) {
                    if (typeof card.title !== "object" || card.title === null) {
                        errors.push("cards[".concat(index, "].title must be an object if provided"));
                    } else {
                        if (!card.title.text) {
                            errors.push("cards[".concat(index, "].title.text is required when title is provided"));
                        }
                    }
                }
                // Validate optional opacity
                if (card.opacity !== undefined) {
                    if (!twoUpFeaturedCardsValidator_VALID_PHOTO_OVERLAY_OPACITIES.includes(card.opacity)) {
                        errors.push("cards[".concat(index, "].opacity must be one of: ").concat(twoUpFeaturedCardsValidator_VALID_PHOTO_OVERLAY_OPACITIES.join(", ")));
                    }
                }
                // Validate optional gradientDirection
                if (card.gradientDirection !== undefined) {
                    if (!twoUpFeaturedCardsValidator_VALID_PHOTO_OVERLAY_DIRECTIONS.includes(card.gradientDirection)) {
                        errors.push("cards[".concat(index, "].gradientDirection must be one of: ").concat(twoUpFeaturedCardsValidator_VALID_PHOTO_OVERLAY_DIRECTIONS.join(", ")));
                    }
                }
                // Validate optional showCTA
                if (card.showCTA !== undefined) {
                    if (typeof card.showCTA !== "boolean") {
                        errors.push("cards[".concat(index, "].showCTA must be a boolean if provided"));
                    }
                }
            }
        });
    }
    // Validate optional variant
    if (props.variant !== undefined) {
        if (!VALID_VARIANTS.includes(props.variant)) {
            errors.push("variant must be one of: ".concat(VALID_VARIANTS.join(", ")));
        }
    }
    // Validate optional topSpacer
    if (props.topSpacer !== undefined) {
        if (typeof props.topSpacer !== "object" || props.topSpacer === null) {
            errors.push("topSpacer must be an object if provided");
        }
    }
    // Validate optional bottomSpacer
    if (props.bottomSpacer !== undefined) {
        if (typeof props.bottomSpacer !== "object" || props.bottomSpacer === null) {
            errors.push("bottomSpacer must be an object if provided");
        }
    }
    const isValid = errors.length === 0;
    if (!isValid && throwOnError) {
        throw new Error("TwoUpFeaturedCards validation failed:\n".concat(errors.join("\n")));
    }
    return {
        isValid,
        errors
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/twoUpFeaturedCardsMapper.js




/**
 * Maps a “Two-Up Featured Cards” AEM container into KDS props.
 *
 * Picks first child by `:itemsOrder` (fallback: first key in `:items`).
 * Produces:
 * - `mod` (defaults to "white")
 * - `variant` only when ∈ {"default","spacious"}
 * - `topSpacer` / `bottomSpacer` via `normalizeSpacer`
 * - `cards[]` (paired by index with `media` when present). Each card requires:
 *    - `image` from `media[index].image` OR `card.image`
 *    - `title` via `mapTitle(card.title)`
 *    - `CTA` from the first `card.cta` entry
 *    - Optional: `opacity`/`direction` (overlay), `showCTA` boolean
 *
 * Returns `null` when no child node is found. Omits empty keys.
 *
 * @param {Object} container AEM container node with `:itemsOrder` and `:items`.
 * @return {Object|null} Mapped props or `null`.
 */ function mapTwoUpFeaturedCardsProps(container) {
    try {
        var ref, ref1, ref2, ref3, ref4;
        var ref5, ref6;
        const firstKey = (ref6 = container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref6 !== void 0 ? ref6 : Object.keys((ref5 = container === null || container === void 0 ? void 0 : container[":items"]) !== null && ref5 !== void 0 ? ref5 : {})[0];
        const node = firstKey ? container === null || container === void 0 ? void 0 : (ref1 = container[":items"]) === null || ref1 === void 0 ? void 0 : ref1[firstKey] : undefined;
        if (!node) return null;
        const basic = node.basic;
        const cardsRaw = (ref2 = node.card) === null || ref2 === void 0 ? void 0 : ref2.cards;
        const mod = (basic === null || basic === void 0 ? void 0 : basic.mod) || "white";
        const variant = (()=>{
            const raw = pickStr(basic === null || basic === void 0 ? void 0 : basic.variant);
            const ok = new Set([
                "default",
                "spacious"
            ]);
            return raw && ok.has(raw) ? raw : undefined;
        })();
        var _size;
        const topSpacer = (basic === null || basic === void 0 ? void 0 : basic.topSpacer) ? normalizeSpacer((_size = basic.topSpacer.size) !== null && _size !== void 0 ? _size : node.topSpacer) : undefined;
        var _size1;
        const bottomSpacer = (basic === null || basic === void 0 ? void 0 : basic.bottomSpacer) ? normalizeSpacer((_size1 = basic.bottomSpacer.size) !== null && _size1 !== void 0 ? _size1 : basic.bottomSpacer) : undefined;
        if ((cardsRaw === null || cardsRaw === void 0 ? void 0 : cardsRaw.length) === 0) return null;
        const cards = (ref4 = (ref3 = cardsRaw === null || cardsRaw === void 0 ? void 0 : cardsRaw.filter((c)=>!c.CTA)) === null || ref3 === void 0 ? void 0 : ref3.map((c)=>{
            var ref, ref1, ref2, ref3;
            const image = mapImage(c === null || c === void 0 ? void 0 : (ref = c.image) === null || ref === void 0 ? void 0 : ref[0]);
            const CTA = mapLink(c === null || c === void 0 ? void 0 : (ref1 = c.cta) === null || ref1 === void 0 ? void 0 : ref1[0]);
            if (CTA) {
                CTA.onClick = ()=>handleCTAForFeatureCards(CTA.text);
                CTA.href = (0,HeaderNavTabs_utils/* modifyHref */.L9)(CTA.href);
                CTA.target = (CTA === null || CTA === void 0 ? void 0 : CTA.isNewTab) ? "_blank" : "_self";
            }
            const title = mapTitle(c === null || c === void 0 ? void 0 : (ref2 = c.title) === null || ref2 === void 0 ? void 0 : ref2[0]);
            const opacity = mapOverlayOpacity(c === null || c === void 0 ? void 0 : c.opacity);
            const direction = mapOverlayDirection(c === null || c === void 0 ? void 0 : c.gradientDirection);
            const eyebrow = mapText(c === null || c === void 0 ? void 0 : (ref3 = c.eyebrow) === null || ref3 === void 0 ? void 0 : ref3[0]);
            return image && title ? {
                image,
                showCTA: Boolean(CTA),
                title,
                ...eyebrow ? {
                    eyebrow
                } : {},
                ...CTA ? {
                    CTA
                } : {},
                ...opacity ? {
                    opacity
                } : {},
                ...direction ? {
                    direction
                } : {}
            } : undefined;
        })) === null || ref4 === void 0 ? void 0 : ref4.filter(Boolean);
        if (!cards || cards.length === 0) {
            return null;
        }
        const twoUpFeaturedCardsProp = {
            ...mod ? {
                mod
            } : {},
            ...variant ? {
                variant
            } : {},
            ...cards.length ? {
                cards
            } : {},
            ...topSpacer ? {
                topSpacer
            } : {},
            ...bottomSpacer ? {
                bottomSpacer
            } : {}
        };
        const { isValid , errors  } = validateTwoUpFeaturedCardsProps(twoUpFeaturedCardsProp);
        if (!isValid) {
            console.warn("twoUpFeaturedCardsProp validation errors:", errors);
            return null;
        }
        return twoUpFeaturedCardsProp;
    } catch (error) {
        console.error("Error in mapTwoUpFeaturedCardsProps:", error);
        return null;
    }
}

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/twoUpContentCXPMapper.js

/**
 * Maps a Two-Up Content (CXP) AEM container into KDS props.
 *
 * Picks the first child by `:itemsOrder` or first key in `:items`, then maps:
 * - `mod` (defaults to "white")
 * - `type` only when variant ∈ {"50-50","60-40","40-60"}
 * - `imageOrientation` only when ∈ {"landscape","portrait"}
 * - `heading`, `eyebrow` via `mapTitle`, `description` via `mapText`
 * - CTA buttons: `CTALink` (single link), `CTA` (first from `basic.cta`)
 * - `cards`: each requires `image` and `title`; includes optional `description`, `CTA`
 * - `topSpacer` / `bottomSpacer` via `normalizeSpacer`
 *
 * Returns `null` if no node is found. Omits keys with empty values.
 *
 * @param {Object} container AEM container node with `:itemsOrder` and `:items`.
 * @return {Object|null} Mapped props or `null` when nothing to map.
 */ function mapTwoUpContentCXPProps(container) {
    var ref, ref1, ref2;
    var ref3, ref4;
    const firstKey = (ref4 = container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref4 !== void 0 ? ref4 : Object.keys((ref3 = container === null || container === void 0 ? void 0 : container[":items"]) !== null && ref3 !== void 0 ? ref3 : {})[0];
    const node = firstKey ? container === null || container === void 0 ? void 0 : (ref1 = container[":items"]) === null || ref1 === void 0 ? void 0 : ref1[firstKey] : undefined;
    if (!node) return null;
    const basic = node.basic;
    const cardsRaw = (ref2 = node.card) === null || ref2 === void 0 ? void 0 : ref2.cards;
    const mod = pickStr(basic === null || basic === void 0 ? void 0 : basic.mod) || "white";
    const heading = mapTitle(basic === null || basic === void 0 ? void 0 : basic.heading);
    var ref5;
    const CTALink = mapLink((ref5 = basic === null || basic === void 0 ? void 0 : basic.CTALink) !== null && ref5 !== void 0 ? ref5 : basic === null || basic === void 0 ? void 0 : basic.ctaLink);
    const CTA = Array.isArray(basic === null || basic === void 0 ? void 0 : basic.cta) ? mapLink(basic.cta[0]) : mapLink(basic === null || basic === void 0 ? void 0 : basic.cta);
    const eyebrow = mapTitle(basic === null || basic === void 0 ? void 0 : basic.eyebrow);
    const description = mapText(basic === null || basic === void 0 ? void 0 : basic.description);
    const type = (()=>{
        const raw = pickStr(basic === null || basic === void 0 ? void 0 : basic.variant);
        const ok = new Set([
            "50-50",
            "60-40",
            "40-60"
        ]);
        return raw && ok.has(raw) ? raw : undefined;
    })();
    const imageOrientation = (()=>{
        const raw = pickStr(basic === null || basic === void 0 ? void 0 : basic.imageOrientation);
        const ok = new Set([
            "landscape",
            "portrait"
        ]);
        return raw && ok.has(raw) ? raw : undefined;
    })();
    var _size;
    const topSpacer = (basic === null || basic === void 0 ? void 0 : basic.topSpacer) ? normalizeSpacer((_size = basic.topSpacer.size) !== null && _size !== void 0 ? _size : basic.topSpacer) : undefined;
    var _size1;
    const bottomSpacer = (basic === null || basic === void 0 ? void 0 : basic.bottomSpacer) ? normalizeSpacer((_size1 = basic.bottomSpacer.size) !== null && _size1 !== void 0 ? _size1 : basic.bottomSpacer) : undefined;
    const cards = cardsRaw.map((c)=>{
        const image = mapImage(Array.isArray(c === null || c === void 0 ? void 0 : c.image) ? c.image[0] : c === null || c === void 0 ? void 0 : c.image);
        const title = mapTitle(Array.isArray(c === null || c === void 0 ? void 0 : c.title) ? c.title[0] : c === null || c === void 0 ? void 0 : c.title);
        const description = mapText(Array.isArray(c === null || c === void 0 ? void 0 : c.description) ? c.description[0] : c === null || c === void 0 ? void 0 : c.description);
        const CTA = mapLink(Array.isArray(c === null || c === void 0 ? void 0 : c.cta) ? c.cta[0] : c === null || c === void 0 ? void 0 : c.cta);
        if (!image || !title) return undefined;
        return {
            image,
            title,
            ...description ? {
                description
            } : {},
            ...CTA ? {
                CTA
            } : {}
        };
    }).filter(Boolean);
    return {
        ...mod ? {
            mod
        } : {},
        ...type ? {
            type
        } : {},
        ...imageOrientation ? {
            imageOrientation
        } : {},
        ...heading ? {
            heading
        } : {},
        ...eyebrow ? {
            eyebrow
        } : {},
        ...description ? {
            description
        } : {},
        ...CTALink ? {
            CTALink
        } : {},
        ...CTA ? {
            CTA
        } : {},
        ...cards.length ? {
            cards
        } : {},
        ...topSpacer ? {
            topSpacer
        } : {},
        ...bottomSpacer ? {
            bottomSpacer
        } : {}
    };
}

;// CONCATENATED MODULE: ./components/DesignSystem/analytics/compareSliderAnalytics.js


const handleLearnMoreClick = (type)=>{
    const interactionData = generateInteractionProps(type, {
        internalLinkName: type,
        internalLinkPosition: "pxp:product navigation",
        internalLinkType: "pxp:".concat(type),
        internalLinkZoneName: "pxp:shop smart toilets:compare models"
    });
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
        ...interactionData
    });
};

;// CONCATENATED MODULE: ./components/DesignSystem/validators/compareSliderValidator.js
/**
 * Validates CompareSlider component props
 * @param {object} props - The props object to validate
 * @param {boolean} [throwOnError=false] - If true, throws an error on validation failure. If false, returns validation result
 * @return {{isValid: boolean, errors: string[]}} ValidationResult object containing isValid flag and array of error messages
 * @throws {Error} if throwOnError is true and validation fails
 */ const validateCompareSliderProps = function(props) {
    let throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const errors = [];
    // Check if props is an object
    if (!props || typeof props !== "object") {
        errors.push("Props must be an object");
        if (throwOnError) {
            throw new Error("CompareSlider validation failed:\n".concat(errors.join("\n")));
        }
        return {
            isValid: false,
            errors
        };
    }
    // Validate required heading
    if (!props.heading) {
        errors.push("heading is required");
    } else {
        if (typeof props.heading !== "object") {
            errors.push("heading must be an object");
        } else {
            if (!props.heading.text) {
                errors.push("heading.text is required");
            }
            if (typeof props.heading.text !== "string" && typeof props.heading.text !== "object") {
                errors.push("heading.text must be a string or React element");
            }
        }
    }
    // Validate required cards
    if (!props.cards) {
        errors.push("cards is required");
    } else if (!Array.isArray(props.cards)) {
        errors.push("cards must be an array");
    } else if (props.cards.length === 0) {
        errors.push("cards array must not be empty");
    } else {
        props.cards.forEach((card, index)=>{
            if (typeof card !== "object" || card === null) {
                errors.push("cards[".concat(index, "] must be an object"));
            } else {
                // Validate required image
                if (!card.image) {
                    errors.push("cards[".concat(index, "].image is required"));
                } else {
                    if (typeof card.image !== "object") {
                        errors.push("cards[".concat(index, "].image must be an object"));
                    } else {
                        if (!card.image.src) {
                            errors.push("cards[".concat(index, "].image.src is required"));
                        }
                    }
                }
                // Validate required title
                if (!card.title) {
                    errors.push("cards[".concat(index, "].title is required"));
                } else {
                    if (typeof card.title !== "object") {
                        errors.push("cards[".concat(index, "].title must be an object"));
                    } else {
                        if (!card.title.text) {
                            errors.push("cards[".concat(index, "].title.text is required"));
                        }
                    }
                }
                // Validate optional description
                if (card.description !== undefined) {
                    if (typeof card.description !== "object" || card.description === null) {
                        errors.push("cards[".concat(index, "].description must be an object if provided"));
                    } else {
                        if (!card.description.text) {
                            errors.push("cards[".concat(index, "].description.text is required when description is provided"));
                        }
                    }
                }
                // Validate optional price
                if (card.price !== undefined) {
                    if (typeof card.price !== "object" || card.price === null) {
                        errors.push("cards[".concat(index, "].price must be an object if provided"));
                    } else {
                        if (!card.price.text) {
                            errors.push("cards[".concat(index, "].price.text is required when price is provided"));
                        }
                    }
                }
                // Validate optional features
                if (card.features !== undefined) {
                    if (!Array.isArray(card.features)) {
                        errors.push("cards[".concat(index, "].features must be an array if provided"));
                    } else {
                        card.features.forEach((feature, featureIndex)=>{
                            if (typeof feature !== "object" || feature === null) {
                                errors.push("cards[".concat(index, "].features[").concat(featureIndex, "] must be an object"));
                            } else {
                                if (!feature.text) {
                                    errors.push("cards[".concat(index, "].features[").concat(featureIndex, "].text is required"));
                                }
                            }
                        });
                    }
                }
                // Validate optional CTA
                if (card.CTA !== undefined) {
                    if (typeof card.CTA !== "object" || card.CTA === null) {
                        errors.push("cards[".concat(index, "].CTA must be an object if provided"));
                    } else {
                        if (!card.CTA.text) {
                            errors.push("cards[".concat(index, "].CTA.text is required when CTA is provided"));
                        }
                        if (!card.CTA.href && !card.CTA.onClick) {
                            errors.push("cards[".concat(index, "].CTA must have either href or onClick"));
                        }
                    }
                }
            }
        });
    }
    // Validate optional CTA
    if (props.CTA !== undefined) {
        if (typeof props.CTA !== "object" || props.CTA === null) {
            errors.push("CTA must be an object if provided");
        } else {
            if (!props.CTA.text) {
                errors.push("CTA.text is required when CTA is provided");
            }
            if (!props.CTA.href && !props.CTA.onClick) {
                errors.push("CTA must have either href or onClick");
            }
        }
    }
    // Validate optional topSpacer
    if (props.topSpacer !== undefined) {
        if (typeof props.topSpacer !== "object" || props.topSpacer === null) {
            errors.push("topSpacer must be an object if provided");
        }
    }
    // Validate optional bottomSpacer
    if (props.bottomSpacer !== undefined) {
        if (typeof props.bottomSpacer !== "object" || props.bottomSpacer === null) {
            errors.push("bottomSpacer must be an object if provided");
        }
    }
    const isValid = errors.length === 0;
    if (!isValid && throwOnError) {
        throw new Error("CompareSlider validation failed:\n".concat(errors.join("\n")));
    }
    return {
        isValid,
        errors
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/compareSliderMapper.js






/**
 * Maps a "Compare Slider" (AEM `mediacontentmodule`) container into `ICompareSliderProps`.
 *
 * Picks the first child by `:itemsOrder` (or first key in `:items`), then maps:
 * - `heading` via `mapTitle(basic.heading)`
 * - `CTA` via the first item of `basic.cta` (if any)
 * - `cards[]` from `card.cards` (array or single object), where each card includes:
 *    - `image` via `mapImage(cardItem.image)`
 *    - `title` via `mapTitle(cardItem.title)`
 *    - `description` via `mapText(cardItem.description)` (optional)
 *    - `price` via `mapText(cardItem.price)` (optional)
 *    - `features` via `mapText` for each feature item (optional)
 *    - `colorSwatches` (optional): maps `name` and `colors[]` (keeps { colorHex, colorName, value })
 *    - `CTA` via the first item of `cardItem.cta` (optional)
 * - `topSpacer` / `bottomSpacer` via `normalizeSpacer` (if present on the node/container)
 *
 * Omits keys with empty/invalid values. Returns `null` if no valid child node is found
 * or if no valid `cards` can be produced.
 *
 * @param {Object} container - The container object, possibly with style/class info.
 * @return {Object} Mapped props including heading, description, cards, and background.
 */ function mapCompareSliderProps(container) {
    try {
        var ref, ref1, ref2, ref3;
        if (!container || !isObj(container)) return null;
        const firstKey = ((ref = asArray(container[":itemsOrder"])) === null || ref === void 0 ? void 0 : ref[0]) || (container[":items"] ? Object.keys(container[":items"])[0] : undefined);
        const node = firstKey ? (ref1 = container[":items"]) === null || ref1 === void 0 ? void 0 : ref1[firstKey] : undefined;
        if (!node || !isObj(node)) return null;
        const basic = node.basic || {};
        const heading = mapTitle(basic.heading);
        const CTA = mapLink((ref2 = asArray(basic.cta)) === null || ref2 === void 0 ? void 0 : ref2[0]);
        const topSpacer = basic.topSpacer ? normalizeSpacer(basic.topSpacer.size) : undefined;
        const bottomSpacer = basic.bottomSpacer ? normalizeSpacer(basic.bottomSpacer.size) : undefined;
        const rawCards = (ref3 = node.card) === null || ref3 === void 0 ? void 0 : ref3.cards;
        const cardsArr = asArray(rawCards).map((cardItem)=>{
            var ref, ref1, ref2, ref3, ref4, ref5;
            if (!cardItem || !isObj(cardItem)) return null;
            const image = mapImage(((ref = cardItem.image) === null || ref === void 0 ? void 0 : ref[0]) || cardItem.image);
            const title = mapTitle((ref1 = cardItem.title) === null || ref1 === void 0 ? void 0 : ref1[0]);
            if (!image || !title) return null;
            const cardCTA = mapLink((ref2 = cardItem.cta) === null || ref2 === void 0 ? void 0 : ref2[0]);
            if (cardCTA) {
                cardCTA.onClick = ()=>handleLearnMoreClick((0,helper/* sanitizeTextForAnalytics */.T68)(title.text));
                cardCTA.target = (cardCTA === null || cardCTA === void 0 ? void 0 : cardCTA.isNewTab) ? "_blank" : "_self";
            }
            const description = mapText((ref3 = cardItem.description) === null || ref3 === void 0 ? void 0 : ref3[0]);
            const price = mapText((ref4 = cardItem.price) === null || ref4 === void 0 ? void 0 : ref4[0]);
            const features = asArray(cardItem.features).map((f)=>{
                const featureProps = mapText(f);
                if (f.featureicon) {
                    featureProps.icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: f.featureicon,
                        width: 20,
                        height: 20,
                        alt: f.featureAltText,
                        reveal: "default",
                        loading: "blank"
                    });
                }
                return featureProps;
            }).filter(Boolean);
            let colorSwatches = undefined;
            const rawColorSwatches = ((ref5 = cardItem.colorSwatches) === null || ref5 === void 0 ? void 0 : ref5[0]) || cardItem.colorSwatches;
            if (rawColorSwatches && isObj(rawColorSwatches)) {
                const name = pickStr(rawColorSwatches.name);
                const colors = asArray(rawColorSwatches.colors).map((c)=>{
                    if (!c || !isObj(c)) return null;
                    const colorHex = pickStr(c.colorHex);
                    const colorName = pickStr(c.colorName);
                    const value = pickStr(c.value) || pickStr(c.colorName);
                    if (!colorHex && !value) return null;
                    return {
                        ...colorHex ? {
                            colorHex
                        } : {},
                        ...colorName ? {
                            colorName
                        } : {},
                        ...value ? {
                            value
                        } : {}
                    };
                }).filter(Boolean);
                if (name || colors && colors.length) {
                    colorSwatches = {
                        name,
                        colors
                    };
                }
            }
            return {
                image,
                title,
                ...description ? {
                    description
                } : {},
                ...price ? {
                    price
                } : {},
                ...features && features.length ? {
                    features
                } : {},
                ...colorSwatches ? {
                    colorSwatches
                } : {},
                ...cardCTA ? {
                    CTA: cardCTA
                } : {}
            };
        }).filter(Boolean);
        if (!cardsArr.length) return null;
        const compareSliderProps = {
            heading,
            cards: cardsArr,
            ...CTA ? {
                CTA
            } : {},
            ...topSpacer ? {
                topSpacer
            } : {},
            ...bottomSpacer ? {
                bottomSpacer
            } : {}
        };
        const { isValid , errors  } = validateCompareSliderProps(compareSliderProps);
        if (!isValid) {
            console.warn("compareSliderProps validation errors:", errors);
            return null;
        }
        return compareSliderProps;
    } catch (error) {
        console.error("Error in mapCompareSliderProps:", error);
        return null;
    }
}
/* harmony default export */ var compareSliderMapper = (mapCompareSliderProps);

;// CONCATENATED MODULE: ./components/DesignSystem/validators/largeImageAndTextValidator.js
// Valid values for component props
const largeImageAndTextValidator_VALID_VARIANTS = [
    "text-over-image",
    "full-bleed-text-over-image",
    "text-and-image-blocks"
];
const largeImageAndTextValidator_VALID_TEXT_PLACEMENTS = [
    "center",
    "left"
];
const largeImageAndTextValidator_VALID_PHOTO_OVERLAY_DIRECTIONS = [
    "bottom-top",
    "top-bottom",
    "left-right",
    "right-left",
    "tint"
];
const largeImageAndTextValidator_VALID_PHOTO_OVERLAY_OPACITIES = [
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45
];
/**
 * Validates LargeImageAndTextBlock component props
 * @param {object} props - The props object to validate
 * @param {boolean} [throwOnError=false] - If true, throws an error on validation failure. If false, returns validation result
 * @return {{isValid: boolean, errors: string[]}} ValidationResult object containing isValid flag and array of error messages
 * @throws {Error} if throwOnError is true and validation fails
 */ const validateLargeImageAndTextBlockProps = function(props) {
    let throwOnError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const errors = [];
    // Check if props is an object
    if (!props || typeof props !== "object") {
        errors.push("Props must be an object");
        if (throwOnError) {
            throw new Error("LargeImageAndTextBlock validation failed:\n".concat(errors.join("\n")));
        }
        return {
            isValid: false,
            errors
        };
    }
    // Validate required image
    if (!props.image) {
        errors.push("image is required");
    } else {
        if (typeof props.image !== "object") {
            errors.push("image must be an object");
        } else {
            if (!props.image.src) {
                errors.push("image.src is required");
            }
        }
    }
    // Validate optional variant
    if (props.variant !== undefined) {
        if (!largeImageAndTextValidator_VALID_VARIANTS.includes(props.variant)) {
            errors.push("variant must be one of: ".concat(largeImageAndTextValidator_VALID_VARIANTS.join(", ")));
        }
    }
    // Validate optional textPlacement
    if (props.textPlacement !== undefined) {
        if (!largeImageAndTextValidator_VALID_TEXT_PLACEMENTS.includes(props.textPlacement)) {
            errors.push("textPlacement must be one of: ".concat(largeImageAndTextValidator_VALID_TEXT_PLACEMENTS.join(", ")));
        }
    }
    // Validate optional showHeader
    if (props.showHeader !== undefined) {
        if (typeof props.showHeader !== "boolean") {
            errors.push("showHeader must be a boolean if provided");
        }
    }
    // Validate optional heading
    if (props.heading !== undefined) {
        if (typeof props.heading !== "object" || props.heading === null) {
            errors.push("heading must be an object if provided");
        } else {
            if (!props.heading.text) {
                errors.push("heading.text is required when heading is provided");
            }
            if (typeof props.heading.text !== "string" && typeof props.heading.text !== "object") {
                errors.push("heading.text must be a string or React element");
            }
        }
    }
    // Validate optional copy
    if (props.copy !== undefined) {
        if (typeof props.copy !== "object" || props.copy === null) {
            errors.push("copy must be an object if provided");
        } else {
            if (!props.copy.text) {
                errors.push("copy.text is required when copy is provided");
            }
            if (typeof props.copy.text !== "string" && typeof props.copy.text !== "object") {
                errors.push("copy.text must be a string or React element");
            }
        }
    }
    // Validate optional CTAs
    if (props.CTAs !== undefined) {
        if (!Array.isArray(props.CTAs)) {
            errors.push("CTAs must be an array if provided");
        } else {
            props.CTAs.forEach((cta, index)=>{
                if (typeof cta !== "object" || cta === null) {
                    errors.push("CTAs[".concat(index, "] must be an object"));
                } else {
                    if (!cta.text) {
                        errors.push("CTAs[".concat(index, "].text is required"));
                    }
                    if (!cta.href && !cta.onClick) {
                        errors.push("CTAs[".concat(index, "] must have either href or onClick"));
                    }
                }
            });
        }
    }
    // Validate optional gradientDirection
    if (props.gradientDirection !== undefined) {
        if (!largeImageAndTextValidator_VALID_PHOTO_OVERLAY_DIRECTIONS.includes(props.gradientDirection)) {
            errors.push("gradientDirection must be one of: ".concat(largeImageAndTextValidator_VALID_PHOTO_OVERLAY_DIRECTIONS.join(", ")));
        }
    }
    // Validate optional opacity
    if (props.opacity !== undefined) {
        if (!largeImageAndTextValidator_VALID_PHOTO_OVERLAY_OPACITIES.includes(props.opacity)) {
            errors.push("opacity must be one of: ".concat(largeImageAndTextValidator_VALID_PHOTO_OVERLAY_OPACITIES.join(", ")));
        }
    }
    // Validate optional topSpacer
    if (props.topSpacer !== undefined) {
        if (typeof props.topSpacer !== "object" || props.topSpacer === null) {
            errors.push("topSpacer must be an object if provided");
        }
    }
    // Validate optional bottomSpacer
    if (props.bottomSpacer !== undefined) {
        if (typeof props.bottomSpacer !== "object" || props.bottomSpacer === null) {
            errors.push("bottomSpacer must be an object if provided");
        }
    }
    const isValid = errors.length === 0;
    if (!isValid && throwOnError) {
        throw new Error("LargeImageAndTextBlock validation failed:\n".concat(errors.join("\n")));
    }
    return {
        isValid,
        errors
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/largeImageAndTextMapper.js


/**
 * Maps an AEM "large image and text block" container into KDS props.
 *
 * Maps container data to ILargeImageAndTextBlockCombinedProps interface:
 * - `mod` - Theme modification (white, gray-100, gray-200, etc.)
 * - `variant` - Display variant (text-over-image, full-bleed-text-over-image, text-and-image-blocks)
 * - `textPlacement` - Text positioning (center, left)
 * - `image` - Image component properties (required)
 * - `showHeader` - Whether to show header section
 * - `heading` - Title/heading component properties
 * - `copy` - Body text component properties
 * - `CTAs` - Array of call-to-action links
 * - `gradientDirection` - Photo overlay gradient direction
 * - `opacity` - Photo overlay opacity level
 * - `topSpacer` - Spacer properties for top spacing
 * - `bottomSpacer` - Spacer properties for bottom spacing
 *
 * @param {Record<string, any>} container Raw AEM container node.
 * @return {Record<string, any> | null} Mapped props object or `null` if nothing to map.
 */ function mapLargeImageAndTextProps(container) {
    try {
        var ref;
        const itemsOrder = container[":itemsOrder"];
        if (!itemsOrder || !Array.isArray(itemsOrder) || itemsOrder.length === 0) {
            return null;
        }
        const firstItemKey = itemsOrder[0];
        const blockItem = (ref = container[":items"]) === null || ref === void 0 ? void 0 : ref[firstItemKey];
        if (!blockItem) return null;
        // Validate and extract mod (must be one of the allowed values)
        const validMods = new Set([
            "white",
            "gray-100",
            "gray-200",
            "gray-500",
            "slate",
            "charcoal",
            "black",
            "gray-light",
            "light-beige"
        ]);
        const modValue = pickStr(blockItem.mod);
        const mod = modValue && validMods.has(modValue) ? modValue : undefined;
        // Validate and extract variant (must be one of the allowed values)
        const validVariants = new Set([
            "text-over-image",
            "full-bleed-text-over-image",
            "text-and-image-blocks"
        ]);
        const variantValue = pickStr(blockItem.variant);
        const variant = variantValue && validVariants.has(variantValue) ? variantValue : "text-over-image";
        // Validate and extract text placement (center or left only)
        const validPlacements = new Set([
            "center",
            "left"
        ]);
        const placementValue = pickStr(blockItem.textPlacement);
        const textPlacement = placementValue && validPlacements.has(placementValue) ? placementValue : "center";
        // Extract show header flag (defaults to true)
        const showHeader = blockItem.showHeader !== false;
        // Extract heading - handle both array and single object
        const headingData = Array.isArray(blockItem.heading) ? blockItem.heading[0] : blockItem.heading;
        const heading = mapTitle(headingData);
        // Extract copy - handle both array and single object
        const copyData = Array.isArray(blockItem.copy) ? blockItem.copy[0] : blockItem.copy;
        const copy = mapText(copyData);
        // Extract image - handle both array and single object (REQUIRED)
        const imageData = Array.isArray(blockItem.image) ? blockItem.image[0] : blockItem.image;
        const image = mapImage(imageData);
        // Image is required - return null if not provided
        if (!image || !image.src) {
            return null;
        }
        // Ensure image has required alt property
        if (!image.alt) {
            image.alt = "";
        }
        // Extract gradient direction
        const gradientDirection = mapOverlayDirection(blockItem.gradientDirection);
        // Extract opacity
        const opacity = mapOverlayOpacity(blockItem.opacity);
        // Extract spacers
        const topSpacer = normalizeSpacer(blockItem.topSpacer);
        const bottomSpacer = normalizeSpacer(blockItem.bottomSpacer);
        // Extract CTAs - handle both array and single object
        const CTAs = [];
        const ctaData = blockItem.CTAs || blockItem.ctas || blockItem.actions;
        if (ctaData && Array.isArray(ctaData)) {
            ctaData.forEach((cta)=>{
                if (cta && (cta.href || cta.url || cta.link)) {
                    CTAs.push({
                        text: cta.text || cta.title || "",
                        href: cta.href || cta.url || cta.link
                    });
                }
            });
        }
        const largeImageAndTextProps = {
            image,
            variant,
            textPlacement
        };
        if (mod) largeImageAndTextProps.mod = mod;
        if (showHeader !== undefined && showHeader !== true) largeImageAndTextProps.showHeader = showHeader;
        if (heading) largeImageAndTextProps.heading = heading;
        if (copy) largeImageAndTextProps.copy = copy;
        if (CTAs.length > 0) largeImageAndTextProps.CTAs = CTAs;
        if (gradientDirection) largeImageAndTextProps.gradientDirection = gradientDirection;
        if (opacity !== undefined && opacity !== 35) largeImageAndTextProps.opacity = opacity;
        if (topSpacer && topSpacer.size && topSpacer.size !== "none") largeImageAndTextProps.topSpacer = topSpacer;
        if (bottomSpacer && bottomSpacer.size && bottomSpacer.size !== "none") largeImageAndTextProps.bottomSpacer = bottomSpacer;
        const { isValid , errors  } = validateLargeImageAndTextBlockProps(largeImageAndTextProps);
        if (!isValid) {
            console.warn("largeImageAndTextProps validation errors:", errors);
            return null;
        }
        return largeImageAndTextProps;
    } catch (error) {
        console.error("Error mapping LargeImageAndText props:", error);
        return null;
    }
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/faqLinkHandler.js


/**
 * Click handler for anchor tags inside FAQ description HTML.
 *
 * This function receives the DOM `click` Event and locates the nearest
 * anchor (`<a>`) target. Implement your data-layer / navigation logic
 * inside this function.
 *
 * Usage (example):
 * ```js
 * import { onFaqDescriptionLinkClick } from 'components/DesignSystem/utils/faqLinkHandler'
 * const container = document.querySelector('.faq-description')
 * container.addEventListener('click', onFaqDescriptionLinkClick)
 * ```
 *
 * @param {MouseEvent} event - Click event
 * @param {Object} meta - Optional metadata about the FAQ item (e.g. teaser info)
 */ function onFaqDescriptionLinkClick(event) {
    let meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!event || !event.target) return;
    const anchor = event.target.closest ? event.target.closest("a") : null;
    if (!anchor) return;
    const linkText = (anchor.textContent || "").trim();
    const url = anchor.href;
    try {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(meta === null || meta === void 0 ? void 0 : meta.pageType, ":").concat(meta === null || meta === void 0 ? void 0 : meta.mainTitle, ":").concat(linkText.toLowerCase()),
            eventMsg: "n/a",
            eventName: "".concat(meta === null || meta === void 0 ? void 0 : meta.pageType, ":").concat(meta === null || meta === void 0 ? void 0 : meta.mainTitle, ":").concat(linkText.toLowerCase()),
            eventStatus: "n/a",
            eventType: "teaser",
            internalLinkName: linkText.toLowerCase(),
            internalLinkPosition: "".concat(meta === null || meta === void 0 ? void 0 : meta.pageType, ":teaser"),
            internalLinkType: "".concat(meta === null || meta === void 0 ? void 0 : meta.pageType, ":").concat(meta === null || meta === void 0 ? void 0 : meta.mainTitle),
            internalLinkURL: (0,HeaderNavTabs_utils/* modifyHref */.L9)(url),
            internalLinkZoneName: "".concat(meta === null || meta === void 0 ? void 0 : meta.pageType, ":").concat(meta === null || meta === void 0 ? void 0 : meta.mainTitle)
        };
        if (!url.includes("tel:")) {
            (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Failed to push FAQ link analytics", e);
    }
}
/* harmony default export */ var faqLinkHandler = ((/* unused pure expression or super */ null && (onFaqDescriptionLinkClick)));

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/faqcomponentMapper.js




/**
 * Map an AEM FAQ container into props consumable by the `FAQ` component.
 *
 * Extracts the teaser description and accordion items and returns an object
 * shaped for the design-system `FAQ` component. Returns `null` for empty input.
 *
 * @param {Object} data - The AEM container data (may include `:items`, teaser, accordion)
 * @return {Object|null} Mapped props for the `FAQ` component, or `null` when input is falsy
 */ function mapFAQProps(data) {
    var ref, ref1, ref2;
    if (!data) return null;
    const accordion = (data === null || data === void 0 ? void 0 : (ref = data[":items"]) === null || ref === void 0 ? void 0 : ref.accordion) || {};
    const accordionProps = (accordion === null || accordion === void 0 ? void 0 : accordion.accordionProperties) || {};
    const accordionItems = accordionProps[":items"] || {};
    const itemsOrder = accordionProps[":itemsOrder"] || Object.keys(accordionItems);
    var _singleExpansion;
    const singleExpansion = (_singleExpansion = accordionProps.singleExpansion) !== null && _singleExpansion !== void 0 ? _singleExpansion : true;
    const expandedItems = accordionProps.expandedItems || [];
    const defaultExpandedIndices = expandedItems.map((key)=>itemsOrder.indexOf(key)).filter((i)=>i !== -1);
    const mod = data.appliedCssClassNames ? data.appliedCssClassNames.match(/\bbg-([a-z]+)\b/) : null;
    // Rewrite anchor hrefs that contain the internal link path using modifyHref
    const processDescriptionHrefs = function() {
        let html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return html.replace(/(<a\s[^>]*href=["'])([^"']*)/gi, (match, prefix, href)=>"".concat(prefix).concat((0,HeaderNavTabs_utils/* modifyHref */.L9)(href)));
    };
    // Clean HTML → plain text (basic)
    const stripHTML = function() {
        let html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return html.replace(/<[^>]*>/g, "").trim();
    };
    return {
        mod: mod ? mod[1] : null,
        showHeader: (accordion === null || accordion === void 0 ? void 0 : accordion.title) ? true : false,
        heading: {
            text: stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title) || ""
        },
        description: {
            // Provide a React element as `text` so consumers can render it directly.
            // The element uses `dangerouslySetInnerHTML` to preserve markup.
            text: /*#__PURE__*/ react.createElement("div", {
                dangerouslySetInnerHTML: {
                    __html: processDescriptionHrefs((0,helper/* removeHtmlSuffixFromAnchors */.Za4)((accordion === null || accordion === void 0 ? void 0 : accordion.description) || ""))
                },
                onClick: (e)=>onFaqDescriptionLinkClick(e, accordion)
            })
        },
        CTA: (accordion === null || accordion === void 0 ? void 0 : accordion.buttonLabel) ? {
            text: accordion.buttonLabel,
            href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(accordion.buttonHref),
            target: accordion.newTabButton === true ? "_blank" : "_self",
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: (accordion === null || accordion === void 0 ? void 0 : accordion.buttonhref) ? "true" : "false",
                    eventAction: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase(), ":").concat(accordion.buttonLabel.toLowerCase()),
                    eventMsg: "n/a",
                    eventName: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase(), ":").concat(accordion.buttonLabel.toLowerCase()),
                    eventStatus: "n/a",
                    eventType: "navigation",
                    internalLinkName: accordion.buttonLabel.toLowerCase(),
                    internalLinkPosition: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":button"),
                    internalLinkType: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase()),
                    internalLinkURL: accordion.buttonhref && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref1 = accordion.buttonHref) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase())
                })
            }
        } : null,
        CTALink: (accordion === null || accordion === void 0 ? void 0 : accordion.ctaLabel) ? {
            text: accordion.ctaLabel,
            href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(accordion.cta),
            target: accordion.newTab === true ? "_blank" : "_self",
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: accordion.cta ? "true" : "false",
                    eventAction: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase(), ":").concat(accordion.ctaLabel.toLowerCase()),
                    eventMsg: "n/a",
                    eventName: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase(), ":").concat(accordion.ctaLabel.toLowerCase()),
                    eventStatus: "n/a",
                    eventType: "navigation",
                    internalLinkName: accordion.ctaLabel.toLowerCase(),
                    internalLinkPosition: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":teaser"),
                    internalLinkType: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase()),
                    internalLinkURL: accordion.cta && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref2 = accordion.cta) === null || ref2 === void 0 ? void 0 : ref2.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "".concat(accordion === null || accordion === void 0 ? void 0 : accordion.pageType, ":").concat(stripHTML(accordion === null || accordion === void 0 ? void 0 : accordion.title).toLowerCase())
                })
            }
        } : null,
        singleExpansion,
        defaultExpandedIndices,
        topSpacer: accordionProps.topSpacer,
        bottomSpacer: accordionProps.bottomSpacer,
        accordions: itemsOrder.length ? itemsOrder.map((key)=>accordionItems[key]).filter(Boolean).map((item)=>{
            return {
                title: {
                    text: (item === null || item === void 0 ? void 0 : item["cq:panelTitle"]) || ""
                },
                children: /*#__PURE__*/ react.createElement("div", {
                    dangerouslySetInnerHTML: {
                        __html: processDescriptionHrefs((0,helper/* removeHtmlSuffixFromAnchors */.Za4)((item === null || item === void 0 ? void 0 : item.text) || ""))
                    },
                    onClick: (e)=>onFaqDescriptionLinkClick(e, accordion)
                })
            };
        }) : null
    };
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/faqAccordionHelper.js


/**
 * HOC that controls accordion open/close behaviour.
 *
 * When `singleExpansion` is true  → only one accordion open at a time.
 * When `singleExpansion` is false → each accordion toggles independently.
 * `defaultExpandedIndices` sets which accordions are open on first render.
 *
 * @param {React.ComponentType} Component - The DS component (e.g. FAQ)
 * @return {React.ComponentType} Wrapped component with controlled accordion behaviour
 */ function withSingleAccordion(Component) {
    return function AccordionWrapper(param) {
        let { accordions =[] , singleExpansion =false , defaultExpandedIndices =[] , ...rest } = param;
        const [openIndices, setOpenIndices] = (0,react.useState)(()=>new Set(defaultExpandedIndices));
        // Sync defaults into state when they arrive after initial mount
        (0,react.useEffect)(()=>{
            if (defaultExpandedIndices.length > 0) {
                setOpenIndices(new Set(defaultExpandedIndices));
            }
        }, [
            defaultExpandedIndices.join(",")
        ]);
        const makeToggle = (0,react.useCallback)((index)=>(isOpen)=>{
                setOpenIndices((prev)=>{
                    const next = singleExpansion ? new Set() : new Set(prev);
                    if (isOpen) {
                        next.add(index);
                    } else {
                        next.delete(index);
                    }
                    return next;
                });
            }, [
            singleExpansion
        ]);
        const controlledAccordions = (accordions || []).map((item, index)=>({
                ...item,
                open: openIndices.has(index),
                isDefaultOpen: openIndices.has(index),
                toggleCallback: makeToggle(index)
            }));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            ...rest,
            accordions: controlledAccordions
        });
    };
}

;// CONCATENATED MODULE: ./components/DesignSystem/registry.js












/**
 * Design System Component Registry
 *
 * Maps dsComponentType strings to their corresponding React components and
 * prop mappers. Used by getDSComponentForContainer to dynamically render
 * design system containers.
 *
 * @type {Object.<string, {component: React.ComponentType, mapper: Function}>}
 *
 */ const dsComponentRegistry = {
    twoUpContent: {
        component: TwoUpContent,
        mapper: mapTwoUpContentProps
    },
    featurecardsmodalslider: {
        component: FeatureCardsWithModalSlider,
        mapper: mapFeatureCardsSliderProps
    },
    productlisthero: {
        component: ProductListHero,
        mapper: mapProductListHeroProps
    },
    fullbleedexperience: {
        component: FullBleedExperience,
        mapper: mapFullBleedExperienceProps
    },
    twoupcontent: {
        component: TwoUpContent,
        mapper: mapTwoUpContentCXPProps
    },
    videoslider: {
        component: VideoSlider,
        mapper: mapVideoSliderProps
    },
    twoupfeaturedcards: {
        component: TwoUpFeaturedCards,
        mapper: mapTwoUpFeaturedCardsProps
    },
    compareslider: {
        component: CompareSlider,
        mapper: compareSliderMapper
    },
    largeimagetextblock: {
        component: LargeImageAndTextBlock,
        mapper: mapLargeImageAndTextProps
    },
    faqmodule: {
        // Wrapped with withSingleAccordion HOC to support controlled accordion behaviour:
        // - When singleExpansion is true, only one accordion can be open at a time
        // - Handles expandedItems from AEM to open specific accordions on page load
        component: withSingleAccordion(FAQ/* FAQ */.Z),
        mapper: mapFAQProps
    }
};

;// CONCATENATED MODULE: ./components/DesignSystem/utils/getDSComponentForContainer.js


/**
 * Returns a React component for a given design system container.
 *
 * Looks up the container's dsComponentType in the registry, maps its children and props,
 * and returns the corresponding React element.
 *
 * @param {Object} container - The container object, expected to have dsComponentType, :itemsOrder, and :items.
 * @return {React.ReactElement|null} The mapped React component, or null if not found or not mappable.
 */ function getDSComponentForContainer(container) {
    try {
        var ref;
        const key = resolveDSKey(container);
        if (!key) return null;
        const mapping = dsComponentRegistry[key];
        if (!mapping) return null;
        const { component: DSComponent , mapper  } = mapping;
        if (typeof mapper !== "function") return null;
        const children = (container === null || container === void 0 ? void 0 : (ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map((key)=>{
            var ref;
            return container === null || container === void 0 ? void 0 : (ref = container[":items"]) === null || ref === void 0 ? void 0 : ref[key];
        }).filter(Boolean)) || [];
        const props = mapper(container, children);
        if (!props) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DSComponent, {
            ...props
        });
    } catch (error) {
        console.error("Error in getDSComponentForContainer:", error);
        return null;
    }
}
/**
 * Resolves the registry key for a DS container.
 *
 * Prefers an explicit `dsComponentType` that exists in the registry.
 * Falls back to `containerId`. Returns `undefined` if neither is usable.
 *
 * @param {Object} container - The container to inspect.
 * @return {string|undefined} A registry key or `undefined` if unresolved.
 */ function resolveDSKey(container) {
    const fromExplicit = container === null || container === void 0 ? void 0 : container.dsComponentType;
    if (fromExplicit && dsComponentRegistry[fromExplicit]) return fromExplicit;
    const fromId = container === null || container === void 0 ? void 0 : container.containerId;
    if (fromId && dsComponentRegistry[fromId]) return fromId;
    return undefined;
}

;// CONCATENATED MODULE: ./components/AemGridColumn.jsx








const AemGridColumn = (props)=>{
    const { data , itemKey , count , eventHandler , containerId , ...extraProps } = props;
    const Element = modules/* default.Element */.ZP.Element;
    const scrollElementCondition = (item, key)=>{
        return (data === null || data === void 0 ? void 0 : data.columnClassNames) && (data === null || data === void 0 ? void 0 : data.columnClassNames[key]) && !(0,utils/* isTeaser */.j$)(item) && !(0,utils/* isBreadcrumb */.Z3)(item) && !(0,utils/* isCarousel */.C2)(item) && !(0,utils/* isAemForm */.np)(item) && !(0,utils/* isProductAccordion */.eq)(item) && !(0,utils/* isVideo */.Wv)(item) && !(0,utils/* isImage */.Or)(item) && !(0,utils/* isInPageSearch */.L8)(item) && !(0,utils/* isText */.Gs)(item) && !(0,utils/* isShopTheRoomCard */.ck)(item) && !(0,utils/* isProductcardV3 */.DN)(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
            var ref;
            const item = data === null || data === void 0 ? void 0 : (ref = data[":items"]) === null || ref === void 0 ? void 0 : ref[key];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: getDSComponentForContainer(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                    fullData: (data === null || data === void 0 ? void 0 : data[":items"]) && (data === null || data === void 0 ? void 0 : data[":items"]),
                    data: item,
                    itemKey: key ? key : itemKey,
                    count: count + 1,
                    containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                    eventHandler: eventHandler,
                    ...extraProps
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: scrollElementCondition(item, key),
                    wrapper: (children)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Element, {
                            className: "".concat((0,utils/* isImageV3 */.EE)(item) ? "image-v3 image" : "").concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNames) && ((0,utils/* isContainer */.Nm)(item) || (0,utils/* isTab */.wR)(item)) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNames) : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) : "").concat((0,utils/* isSlick */.bd)(item) ? "carousel-slick carousel ".concat((ref = item["carouselComponentProperties"]) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames, " ") : "").concat((data === null || data === void 0 ? void 0 : data.columnClassNames[key]) ? !(0,utils/* isSlick */.bd)(item) ? " ".concat(data === null || data === void 0 ? void 0 : data.columnClassNames[key], " ") : "" : "").concat((0,utils/* isSpacer */.MW)(item) ? "spacer separator" : "", " ").concat((0,utils/* isTab */.wR)(item) ? "tabs" : ""),
                            children: children
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: (0,utils/* isContainer */.Nm)(item) && key !== constants.COMPONENT_TYPES.ROOT_CONTAINER,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ContainerComponent, {
                                item: item,
                                extraProps: extraProps,
                                count: count,
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                            fullData: data[":items"] && data[":items"],
                            data: item,
                            itemKey: key ? key : itemKey,
                            count: count + 1,
                            containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                            eventHandler: eventHandler,
                            ...extraProps
                        })
                    })
                })
            }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : index);
        })
    });
};
/* harmony default export */ var components_AemGridColumn = (AemGridColumn);

;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher/analytics.js


const addDataLayerOnClick = function() {
    let datalayerPageName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", item = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const eventInfo = {
        clickInternalLinks: "".concat(item.linkToNewTab || constants.BRAND_NAME.annSacks || constants.BRAND_NAME.sterling || constants.BRAND_NAME.homeEnergy ? "false" : "true"),
        internalLinkPosition: "global header",
        internalLinkZoneName: "".concat(datalayerPageName).concat(datalayerPageName ? ":" : "", "global header"),
        internalLinkURL: "".concat((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")),
        internalLinkName: "brand sync:".concat(item.brandName.toLowerCase()),
        eventName: "brand sync",
        internalLinkType: "global header:navigation",
        eventType: "click",
        eventAction: "brand sync"
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher/index.jsx



const BrandSwitcher = (props)=>{
    const { data , datalayerPageName  } = props;
    const handleOnClick = (e, item)=>{
        var ref;
        addDataLayerOnClick(datalayerPageName, item);
        window.open((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""), "".concat((0,helper/* convertStringToBoolean */.mUs)(item.linkToNewTab) ? "_blank" : "_self"), item.linkRef ? "noreferrer" : "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "brand-switcher ".concat(datalayerPageName === "checkout" ? "checkout-brand" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-nav-panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "gbh-nav navbar navbar-xpand-sm navbar-dark justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "gbh-nav__list navbar-nav",
                    children: data.items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "gbh-nav__item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-data-layer gbh-nav--link ".concat(item.highlight && item.highlight === "true" ? "gbh-nav__link--active" : ""),
                                "aria-label": "".concat(item.brandName, ". Go to ").concat(item.brandName, "'s Home Page"),
                                onClick: (e)=>handleOnClick(e, item),
                                role: "link",
                                children: item.brandName
                            })
                        }, "brand-".concat(index)))
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandSwitcher = (BrandSwitcher);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
;// CONCATENATED MODULE: ./public/icons/left-arrow-white.svg
/* harmony default export */ var left_arrow_white = ({"src":"/_next/static/media/left-arrow-white.9ff895f4.svg","height":17,"width":10});
// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/index.module.scss
var index_module = __webpack_require__(4201);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(96352);
// EXTERNAL MODULE: ./components/core/AutoSuggestion/v1/AutoSuggestion.jsx
var AutoSuggestion = __webpack_require__(36130);
// EXTERNAL MODULE: ./components/FindStoreUtilNav/analytics.js
var analytics = __webpack_require__(90062);
// EXTERNAL MODULE: ./components/FindStore/v1/api.js
var api = __webpack_require__(2182);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.view.jsx






















const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const FindStoreUtilNavView = (props)=>{
    var ref;
    const { findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [isSubmit, setIsSubmit] = (0,react.useState)(false);
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const { utilityStoreDetails , utilityData , myStoreId , eventHandler: { callbacks: { toggleFindAStore =()=>{} , closeMenu =()=>{}  }  }  } = props;
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { general  } = config;
            var _allStoresPagePath;
            const url = await (0,utils_location/* getShortenedUrl */.Pp)((_allStoresPagePath = general.allStoresPagePath) !== null && _allStoresPagePath !== void 0 ? _allStoresPagePath : "/");
            const findStores = get_default()(config, "apiEndpoints.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            setConfigState({
                browseAllStoreUrl: url,
                findStores,
                brand
            });
            localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
            setbrowseAllStoreUrl(url);
        }).catch((err)=>console.log(err));
        props.getUtilityGeolocation();
    }, []);
    (0,react.useEffect)(()=>{
        (props === null || props === void 0 ? void 0 : props.active) ? (0,helper/* removeMavenoidChat */.N9B)() : (0,helper/* addMavenoidChat */.dVG)();
    }, [
        props === null || props === void 0 ? void 0 : props.active
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
        if (isSubmit === true) {
            props.redirect(zipCodeValue);
        }
    }, [
        isSubmit
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId === 0) {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId
    ]);
    const nearestStoreAddress = async ()=>{
        const { findStores , brand  } = configState;
        if (!findStores || (zipCodeValue === null || zipCodeValue === void 0 ? void 0 : zipCodeValue.length) < 3) return;
        const nearestStore = await (0,api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
        if (nearestStore !== undefined) {
            var ref;
            var ref1;
            const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
            var ref2;
            const utilityData = {
                ...nearestStoreData,
                EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
            };
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        } else {
            const utilityData1 = {};
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData1));
        }
    };
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper/* getCityList */.vzx)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleChange = (value)=>{
        setZipcodeValue(value);
    };
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode;
            setZipcodeValue((_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "");
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            var ref;
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    const onSubmit = async ()=>{
        let valid = true;
        const zipCodeErrObj = {
            show: false,
            message: ""
        };
        const { staticTexts: { validZipcode  }  } = props;
        const isValid = await (0,utils_location/* validateField */.OP)("zipCodeNumeric", zipCodeValue);
        if (isValid && zipCodeValue.length < 5) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: zipCodeValue
            }));
            zipCodeErrObj.show = true;
            zipCodeErrObj.message = validZipcode;
            valid = false;
        }
        if (valid) {
            setIsSubmit(true);
            toggleFindAStore();
            closeMenu();
        }
        if (findAStoreActive) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
        }
        setZipCodeError({
            ...zipCodeErrObj
        });
        (0,analytics/* addFindStoreAnalytics */.cY)(zipCodeValue, zipCodeErrObj);
    };
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav​:" + action,
            eventName: "find a store:utility nav​:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL: action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a",
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");
    const { staticTexts  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).findAStoreUtilNavWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-find-a-store ".concat(props.active ? "active" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "findstore-util-nav".concat(isSubmit ? "__activeMap" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                        handleModalClose: ()=>{
                            setInfoModal(false);
                        },
                        show: infoModal,
                        data: infoModalErrror,
                        labelledBy: "Geo-Location-error-message",
                        className: "message-modal",
                        staticTexts: staticTexts,
                        dataLayerPosition: "global header"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "findstore-util-nav__container findstore-util-nav__show-container",
                            children: [
                                lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "findstore-util-nav__mobile-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "button",
                                            tabIndex: "0",
                                            src: close_white/* default.src */.Z.src,
                                            alt: staticTexts.close,
                                            className: "findstore-util-nav__close",
                                            onClick: ()=>{
                                                (0,helper/* addMavenoidChat */.dVG)();
                                                toggleFindAStore();
                                                closeMenu();
                                                (0,helper/* toggeleBodyScroll */.wA4)(false);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "findstore-util-nav__menu",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: left_arrow_white.src,
                                                    alt: staticTexts.leftArrow
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    onClick: ()=>toggleFindAStore(),
                                                    children: staticTexts.menu
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "findstore-util-nav__content ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__content-text"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container kf-react-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row ml-0 mr-0",
                                            children: [
                                                !isEmpty_default()(utilityData && utilityData.EntityID) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-lg-7 findstore-util-nav__access-utility-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-7 findstore-util-nav__supply-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__store",
                                                                        children: myStoreId !== 0 ? staticTexts.myStoreText : staticTexts.closestStore
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__signStore",
                                                                        children: utilityData.LocationName
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-5 findstore-util-nav__address-container",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: utilityData.OpenUntil
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.AddressLine
                                                                            }),
                                                                            !isEmpty_default()(utilityData.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.AddressLine2
                                                                            }) : "",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.Locality + ", " + utilityData.AdminDistrict + " " + utilityData.PostalCode
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: (0,helper/* formatPhoneNumber */.unW)(utilityData.Phone)
                                                                    }),
                                                                    myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: myStoreUrl,
                                                                        className: "findstore-util-nav__view-store-detail gbh-data-layer",
                                                                        "data-gbh-data-layer": viewStoreAnalytics,
                                                                        onClick: ()=>{
                                                                            if (lib/* isMobile */.tq) closeMenu();
                                                                        },
                                                                        children: lib/* isMobile */.tq ? staticTexts.storeDetail : staticTexts.viewStoreDetail
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                        analyticsData: unsetMyStoreAnalytics,
                                                                        checked: myStoreId === utilityData.EntityID ? true : false,
                                                                        value: myStoreId === utilityData.EntityID ? staticTexts.myStore : staticTexts.setAsMyStore,
                                                                        id: "findstore-util-nav__my-store",
                                                                        onChange: (e)=>props.handleUtilityStoreCheck(e.target.checked ? utilityData.EntityID : 0)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 col-lg-6 findstore-util-nav__search-utility-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__location-content",
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.locationDescription)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-content",
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.zipCodeContent)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 findstore-util-nav__loc-search-container ".concat(!isEmpty_default()(utilityData) ? "col-lg-5" : "col-lg-6"),
                                                    children: [
                                                        !isEmpty_default()(utilityData) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "findstore-util-nav__not-your-store",
                                                            children: staticTexts.NotYourStore + "?"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classnames_default()({
                                                                "findstore-util-nav__input-container": true,
                                                                "findstore-util-nav__input-container-text": !isEmpty_default()(utilityData),
                                                                "findstore-util-nav__input-disabled-state": !zipCodeValue
                                                            }),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                                                    placeholderLabel: staticTexts.enterCityStateZip,
                                                                    selectedValue: zipCodeValue,
                                                                    handleChange: (selectedVal)=>handleChange(selectedVal),
                                                                    handleSelect: (selectedVal)=>handleChange(selectedVal),
                                                                    optionList: optionList,
                                                                    borderValue: "bottom"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "findstore-util-nav__submit",
                                                                    onClick: ()=>onSubmit(),
                                                                    disabled: zipCodeValue.length < 3,
                                                                    "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.submit,
                                                                    children: staticTexts.submit
                                                                })
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-error",
                                                            children: zipCodeError.message
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "findstore-util-nav__link-container ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__link-container-text"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__location-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__location-link",
                                                                        "aria-label": staticTexts.useLocation,
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        onClick: getGeoLocation,
                                                                        children: staticTexts.useLocation
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__view-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: browseAllStoreUrl,
                                                                        className: "findstore-util-nav__view-store-link ".concat(lib/* isMobile */.tq ? "view-all-stores-mobile" : "", " gbh-data-layer"),
                                                                        onClick: ()=>{
                                                                            (0,analytics/* headerViewAllStoreAnalytics */.Zj)(browseAllStoreUrl);
                                                                        },
                                                                        onClickCapture: ()=>{
                                                                            toggleFindAStore();
                                                                            closeMenu();
                                                                        },
                                                                        children: staticTexts.viewAllStore
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
FindStoreUtilNavView.defaultProps = {
    staticTexts: {}
};
FindStoreUtilNavView.propTypes = {
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var FindStoreUtilNav_view = (FindStoreUtilNavView);

// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/localization.js
var localization = __webpack_require__(26977);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.jsx













const FindStoreUtilNav = (param)=>{
    let { show , active , eventHandler , zipCodeContent  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { utilityStoreDetails , utilityData , userCity , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)(initialState);
    (0,react.useEffect)(()=>{
        setStaticTexts((prevVal)=>{
            let translations = (0,localization/* getTranslations */.F)(t);
            if (zipCodeContent && zipCodeContent.length) {
                translations = {
                    ...translations,
                    zipCodeContent
                };
            }
            return translations;
        });
        setInitalState();
    }, []);
    // useEffect(() => {
    //   document.querySelector(
    //     ".gbh-nav__findStore a.gbh-nav__findStore--link"
    //   ).innerText = "staticTexts.findStore"
    // }, [userCity, staticTexts.findStore])
    (0,react.useEffect)(()=>{
        if (state.myStoreId !== 0) getUtilityDataById();
        else if (state.userCity !== "") getUtilityDataByDistance();
    }, [
        state.utilityLocation,
        state.userCity
    ]);
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndpoints.findStores", ""),
                reverseGeo: get_default()(config, "apiEndpoints.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice/* setUtilityStoreDetails */.Hm)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const getUtilityDataByDistance = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataByDistance */.zO)(state);
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityDataById = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataById */.e)(state);
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityGeolocation = function() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            const { zipcode: utilityLocation = "" , city: userCity = ""  } = getLocation;
            const details = {
                utilityLocation,
                userCity
            };
            if (utilityLocation && userCity) {
                dispatch((0,locationSlice/* setCityLocation */.OX)(details));
                setState({
                    ...state,
                    ...details
                });
            }
        }).catch((err)=>{
            (0,helper/* getMyLocationByUserIP */.SAL)().then((getLocation)=>{
                const { zipcode: utilityLocation = "" , city: userCity = ""  } = getLocation;
                const details = {
                    utilityLocation,
                    userCity
                };
                if (utilityLocation && userCity) {
                    dispatch((0,locationSlice/* setCityLocation */.OX)(details));
                    setState({
                        ...state,
                        ...details
                    });
                }
            }).catch((error)=>{
                console.log(error);
            });
        });
    };
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
    };
    const redirect = (zipCodeValue)=>{
        const path = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue, "&queryAspath=").concat(state.findStoreUrl);
        const asPath = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue);
        router.push(path, asPath);
    };
    const { findStoreUrl  } = state;
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindStoreUtilNav_view, {
        staticTexts: staticTexts,
        getUtilityGeolocation: getUtilityGeolocation,
        redirect: (zipCodeValue)=>redirect(zipCodeValue),
        redirectUrl: (0,utils_location/* getShortenedUrl */.Pp)(findStoreUrl),
        handleUtilityStoreCheck: (entity)=>handleUtilityStoreCheck(entity),
        active: active,
        utilityStoreDetails: utilityStoreDetails,
        utilityData: utilityData,
        userCity: userCity,
        myStoreId: myStoreId,
        eventHandler: eventHandler
    });
};
/* harmony default export */ var v1_FindStoreUtilNav = (FindStoreUtilNav);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(30394);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var HeaderNavTabs_analytics = __webpack_require__(24897);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav.view/index.jsx










const MegaMenu = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7437).then(__webpack_require__.bind(__webpack_require__, 67437)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(67437)
            ]
    },
    suspense: true
});
const AuthUtilityNavView = (props)=>{
    const avatarIcon = "/icons/avatar.svg";
    const rightArrow = "/icons/right-white.svg";
    const iconUserSignin = "/icons/user-signin.svg";
    const { active , i18n , userMenuFragment , guestMenuFragment , isLoggedIn , logout , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const styleClass = classnames_default()({
        "auth-nav": true,
        "auth-nav--active": active
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        (0,HeaderNavTabs_analytics/* newdatalayerforSignIn */.UY)(themeChange);
    };
    const onClickSignUp = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
        (0,HeaderNavTabs_analytics/* newdataLayerForCreateAccount */.Lz)(themeChange);
    };
    const showMenuNav = ()=>{
        toggleAuthNav();
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    const signInEventInfo = JSON.stringify({
        eventName: "sign in start",
        eventAction: "sign in start",
        internalLinkName: "sign in start",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:sign in start",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    const signedInEventInfo = JSON.stringify({
        eventName: "global header:your kohler account",
        eventAction: "global header:your kohler account",
        internalLinkName: "your kohler account",
        internalLinkType: "global header: welcome back to your kohler",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:my account",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styleClass,
        "aria-expanded": active,
        children: [
            winWidth <= 1200 ? isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    tabIndex: "0",
                    "aria-label": "".concat(i18n.hi, " ").concat((0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)),
                    role: "button",
                    className: "auth-nav__sign-in-mobile",
                    onClick: ()=>{
                        toggleAuthNav();
                        onAuthMenuClick(!active);
                        setAuthNav(!active);
                        (0,helper/* toggeleBodyClass */.wMR)(true);
                        (0,HeaderNavTabs_analytics/* onclickForSignedFun */.Jm)(themeChange);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            name: "avatarIcon",
                            src: themeChange ? iconUserSignin : avatarIcon,
                            alt: i18n.signIn,
                            className: "gbh-data-layer auth-nav__sign-in-avatar",
                            "data-gbh-data-layer": signInEventInfo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            name: "loggedInUser",
                            className: "auth-nav__user",
                            children: [
                                i18n.hi,
                                ", ",
                                (0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: rightArrow,
                            alt: i18n.rightArrowAlt,
                            className: "auth-nav__sign-in-right-arrow"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: "Loading...",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                    userMenuFragment: userMenuFragment,
                    guestMenuFragment: guestMenuFragment,
                    isLoggedIn: isLoggedIn,
                    i18n: i18n,
                    user: user,
                    logout: logout,
                    toggleAuthNav: toggleAuthNav,
                    active: active,
                    handleSignin: onClickSignIn,
                    handleCreateAccount: onClickSignUp
                })
            }) : isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                tabIndex: "0",
                role: "button",
                "aria-label": active ? "".concat(i18n.user, " ").concat(i18n.expanded) : "".concat(i18n.user, " ").concat(i18n.collapsed),
                name: "loggedInUser",
                className: "auth-nav__user gbh-data-layer",
                onClick: showMenuNav,
                "data-gbh-data-layer": signedInEventInfo,
                children: [
                    i18n.hi,
                    ", ",
                    (0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                tabIndex: "0",
                role: "button",
                name: "avatarIcon",
                "aria-label": active ? "".concat(i18n.signIn, " ").concat(i18n.expanded) : "".concat(i18n.signIn, " ").concat(i18n.collapsed),
                src: avatarIcon,
                alt: i18n.signIn,
                onClick: showMenuNav,
                className: "gbh-data-layer",
                "data-gbh-data-layer": signInEventInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "auth-nav__menu ".concat(isLoggedIn ? "auth-nav__menu-expand" : "", " ").concat(active ? "auth-nav__menu-open" : ""),
                "aria-hidden": !active,
                children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "Loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                        userMenuFragment: userMenuFragment,
                        guestMenuFragment: guestMenuFragment,
                        isLoggedIn: isLoggedIn,
                        i18n: i18n,
                        user: user,
                        logout: logout,
                        toggleAuthNav: toggleAuthNav,
                        handleSignin: onClickSignIn,
                        handleCreateAccount: onClickSignUp,
                        onAuthMenuClick: onAuthMenuClick
                    })
                }) : null
            })
        ]
    });
};
AuthUtilityNavView.displayName = "AuthUtilityNavView";
/* harmony default export */ var AuthUtilityNav_view = (AuthUtilityNavView);

// EXTERNAL MODULE: ./i18n/useAuthUtilityNavi18n.js
var useAuthUtilityNavi18n = __webpack_require__(46967);
// EXTERNAL MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.module.scss
var AuthUtilityNav_index_module = __webpack_require__(50238);
var AuthUtilityNav_index_module_default = /*#__PURE__*/__webpack_require__.n(AuthUtilityNav_index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.jsx










// import useOnClickOutside from "@/hooks/useOnClickOutside"

const AuthUtilityNav = (props)=>{
    const { show , active , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const authNavMenuRef = (0,react.useRef)(null);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { guestMenuFragment , userMenuFragment  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    // useOnClickOutside(authNavMenuRef, toggleAuthNav)
    (0,react.useEffect)(()=>{
        if (show || lib/* isMobile */.tq) {
            (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
                const userFragment = get_default()(CONFIG, "general.signInFragment", "");
                const guestFragment = get_default()(CONFIG, "general.signUpFragment", "");
                const guestMenuPayload = {
                    reload: false,
                    path: guestFragment,
                    fragmentName: "guestMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(guestMenuPayload));
                const userMenuPayload = {
                    reload: false,
                    path: userFragment,
                    fragmentName: "userMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(userMenuPayload));
            });
        }
    }, [
        show
    ]);
    const staticTexts = (0,useAuthUtilityNavi18n/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "auth-widget auth-widget__menu position_unset ".concat((AuthUtilityNav_index_module_default()).authUtilityNavWrapper),
        ref: authNavMenuRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthUtilityNav_view, {
            show: show,
            active: active,
            toggleAuthNav: toggleAuthNav,
            i18n: staticTexts,
            userMenuFragment: userMenuFragment,
            guestMenuFragment: guestMenuFragment,
            isLoggedIn: isAuth,
            logout: ()=>dispatch((0,authSlice/* logout */.kS)()),
            setAuthNav: setAuthNav,
            onAuthMenuClick: onAuthMenuClick
        })
    });
};
/* harmony default export */ var v1_AuthUtilityNav = (AuthUtilityNav);

// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavLink.jsx


const CountryUtilNavLink = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , isMobile , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: languageLink,
        "aria-label": "".concat(countryName, " ").concat(language),
        className: "gbh-data-layer lang ".concat(isMobile && "mobile"),
        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"languageselector","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(languageLink, '","internalLinkName":"language select:').concat(isMobile ? language.toLowerCase() : languageAbbreviation.toLowerCase(), '","eventName":"language selector","internalLinkType":"homepage:navigation","eventType":"language selector","eventAction":"language selector"}'),
        rel: "noreferrer",
        children: isMobile ? language : languageAbbreviation
    });
};
/* harmony default export */ var v1_CountryUtilNavLink = (CountryUtilNavLink);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavLinks.jsx



const CountryUtilNavLinks = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: false,
                    datalayerPageName: datalayerPageName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: true,
                    datalayerPageName: datalayerPageName
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNavLinks = (CountryUtilNavLinks);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilContainer.jsx





const CountryUtilContainer = (props)=>{
    const { countryarea , activeTab , title , description , countryselectorItems , datalayerPageName  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [expanded, setExpanded] = (0,react.useState)([]);
    const handleExpand = (url, country)=>{
        if (!url) {
            if (expanded.includes(country)) {
                const exp = [
                    ...expanded
                ].filter((item)=>item !== country);
                setExpanded(exp);
            } else {
                const exp1 = [
                    ...expanded
                ];
                exp1.push(country);
                setExpanded(exp1);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: countryarea,
        className: "gbh-tab__content ".concat(activeTab === countryarea ? "gbh-tab__content--active" : "", " "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-lg-4 left d-none d-lg-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(description)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-lg-8 right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-12 p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-tab__list",
                                    role: "list",
                                    children: countryselectorItems && countryselectorItems.map(function(item, index) {
                                        var ref;
                                        if (!item.country) return null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            role: "listitem",
                                            className: "".concat(item.country).concat(winWidth <= 1200 && !item.countryLink ? " arrowdropdown" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: (ref = item.countryLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                    className: "gbh-data-layer gbh-tab__item--link",
                                                    role: "link",
                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"n/a","internalLinkName":"country select:').concat(item.countryName.toLowerCase(), '","eventName":"country selector","internalLinkType":"homepage:navigation","eventType":"country selector","eventAction":"country selector"}'),
                                                    "aria-current": "page",
                                                    onClick: ()=>handleExpand(item.countryLink, item.country),
                                                    children: [
                                                        item.countryName,
                                                        " "
                                                    ]
                                                }),
                                                (item.languageOneAbbreviation || item.languageTwoAbbreviation || item.languageThreeAbbreviation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    style: expanded.includes(item.country) ? {
                                                        display: "block"
                                                    } : {},
                                                    children: [
                                                        item.languageOneAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageOneLink,
                                                            language: item.languageOne,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageOneAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageTwoAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageTwoLink,
                                                            language: item.languageTwo,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageTwoAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageThreeAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageThreeLink,
                                                            language: item.languageThree,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageThreeAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(item.country, "+").concat(index));
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_CountryUtilContainer = (CountryUtilContainer);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavTabLink.jsx


const CountryUtilNavTabLink = (props)=>{
    const { activeTab , countryArea , onclickVal , countryAreaValue  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: ()=>{
            onclickVal(countryArea);
        },
        "data-tab": countryArea,
        role: "tab",
        tabIndex: "0",
        "data-region": "#".concat(countryArea),
        "aria-label": countryArea,
        className: "gbh-tabs__tab ".concat(activeTab === countryArea ? "gbh-tabs__tab--active" : ""),
        "data-testid": "countrySelectorSection_tabLink",
        children: countryAreaValue
    });
};
/* harmony default export */ var v1_CountryUtilNavTabLink = (CountryUtilNavTabLink);

// EXTERNAL MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.module.scss
var CountryUtilNav_module = __webpack_require__(19371);
var CountryUtilNav_module_default = /*#__PURE__*/__webpack_require__.n(CountryUtilNav_module);
;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.jsx






const CountryUtilNav = (props)=>{
    const { show , active , toggleCountryNav , eventHandler , countryselector , datalayerPageName , v3  } = props;
    const { callbacks: { setRegionNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [activeTab, setActiveTab] = (0,react.useState)("");
    const addCountrySelectorAnalytics = (type)=>{
        let eventInfo;
        if (type === "Americas") {
            eventInfo = getAmericaTabEventInfo(type);
        } else if (type === "Africa") {
            eventInfo = getAfricaTabEventInfo(type);
        } else if (type === "Asia") {
            eventInfo = getAsiaTabEventInfo(type);
        } else if (type === "Australasia") {
            eventInfo = getAustralasiaTabEventInfo(type);
        } else if (type === "Middle East") {
            eventInfo = getMiddleEastTabEventInfo(type);
        } else if (type === "Europe") {
            eventInfo = getEuropeTabEventInfo(type);
        }
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getAmericaTabEventInfo = (type)=>{
        if (type === "Americas") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:americas",
                eventName: "country select:americas",
                eventType: "navigation",
                internalLinkName: "americas",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAfricaTabEventInfo = (type)=>{
        if (type === "Africa") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:africa",
                eventName: "country select:africa",
                eventType: "navigation",
                internalLinkName: "africa",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAsiaTabEventInfo = (type)=>{
        if (type === "Asia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:asia",
                eventName: "country select:asia",
                eventType: "navigation",
                internalLinkName: "asia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAustralasiaTabEventInfo = (type)=>{
        if (type === "Australasia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:australasia",
                eventName: "country select:australasia",
                eventType: "navigation",
                internalLinkName: "australasia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getMiddleEastTabEventInfo = (type)=>{
        if (type === "Middle East") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:middle east",
                eventName: "country select:middle east",
                eventType: "navigation",
                internalLinkName: "middle east",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getEuropeTabEventInfo = (type)=>{
        if (type === "Europe") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:europe",
                eventName: "country select:europe",
                eventType: "navigation",
                internalLinkName: "europe",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    (0,react.useEffect)(()=>{
        if (winWidth <= 1200) {
            setActiveTab("");
        } else {
            setActiveTab("america");
        }
    }, [
        winWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CountryUtilNav_module_default()).countrySelectorMain,
        "data-testid": "countrySelectorSection",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "gbh_utheader",
            className: "gbh-countryselector ".concat(active ? "active" : ""),
            style: show ? {
                left: 0,
                display: "block"
            } : {
                display: "block"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab",
                    children: [
                        !v3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            "data-testid": "countrySelectorSection_menu",
                            className: "gbh-close-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>{
                                toggleCountryNav();
                                setRegionNav(false);
                            },
                            children: "Menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            role: "tablist",
                            "aria-multiselectable": "false",
                            className: "tablist",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "selection-bar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Americas"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "america",
                                        countryAreaValue: "Americas",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Africa"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "africa",
                                        countryAreaValue: "Africa",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Asia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "asia",
                                        countryAreaValue: "Asia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Australasia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "australia",
                                        countryAreaValue: "Australasia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Middle East"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "middleEast",
                                        countryAreaValue: "Middle East",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Europe"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "europe",
                                        countryAreaValue: "Europe",
                                        onclickVal: setActiveTab
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab__panels",
                    style: winWidth <= 1200 && activeTab ? {
                        display: "block"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            className: "gbh-back-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>setActiveTab(""),
                            children: "Region"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "america",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.americasItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "africa",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.africaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "asia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.asiaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "australia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.oceaniaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "middleEast",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.middleEastItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "europe",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.europeItems,
                            datalayerPageName: datalayerPageName
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNav = (CountryUtilNav);

// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./public/icons/cart-icon.svg
/* harmony default export */ var cart_icon = ({"src":"/_next/static/media/cart-icon.9accb288.svg","height":25,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-icon-empty.svg
/* harmony default export */ var cart_icon_empty = ({"src":"/_next/static/media/cart-icon-empty.02db72e9.svg","height":20,"width":26});
;// CONCATENATED MODULE: ./public/icons/cart-gray.svg
/* harmony default export */ var cart_gray = ({"src":"/_next/static/media/cart-gray.abab88ab.svg","height":20,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-filled.svg
/* harmony default export */ var cart_filled = ({"src":"/_next/static/media/cart-filled.4aa11106.svg","height":20,"width":25});
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx











const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  } , callbacks: { onClick  }  } , checkoutPage  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const getWidth = window.outerWidth === 0 ? window.innerWidth : lib/* isSafari */.G6 ? window.innerWidth : window.outerWidth;
    const [isMobile, setIsMobile] = (0,react.useState)((getWidth || width) <= 1200);
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const cartGrayFilledIconV3 = "/icons/cart-empty.svg";
    (0,react.useEffect)(()=>{
        !checkoutPage ? setIsMobile((getWidth && width) <= 1200) : setIsMobile(false);
    }, [
        getWidth,
        width,
        checkoutPage
    ]);
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator ".concat(cartCount > 0 && "cart-indicator__with-count"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"global header:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 100 && "cart-indicator__count--center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: isMobile ? cart_filled === null || cart_filled === void 0 ? void 0 : cart_filled.src : cart_icon === null || cart_icon === void 0 ? void 0 : cart_icon.src,
                        alt: "Cart"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cartGrayFilledIconV3 : cart_icon_empty.src,
                alt: "Cart"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cart_gray === null || cart_gray === void 0 ? void 0 : cart_gray.src : cart_icon_empty.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v1_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));

// EXTERNAL MODULE: ./components/Shared/index.module.scss
var Shared_index_module = __webpack_require__(3738);
var Shared_index_module_default = /*#__PURE__*/__webpack_require__.n(Shared_index_module);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./constants/api.js
var constants_api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss
var UtilityWidgets_module = __webpack_require__(84181);
var UtilityWidgets_module_default = /*#__PURE__*/__webpack_require__.n(UtilityWidgets_module);
;// CONCATENATED MODULE: ./components/Shared/helper.js
const getSrc = (themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)=>{
    if (!themeChange) {
        return favoritesPage && favoritesPage.length > 0 ? "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbi9XaXNobGlzdDwvdGl0bGU+CiAgICA8ZyBpZD0iQjEtQ29tcGFyZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24vV2lzaGxpc3QiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtOC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTguMTQwNjA3MTQsOS42ODg0ODE5NyBMNy41MDEsMTAuMzM0IEw2Ljg2MTU5MzY5LDkuNjg4NDgxOTcgQzUuMjkyNDIzNTIsOC4xMDM4MzkzNCAyLjc0NjI0NDc5LDguMTAzODM5MzQgMS4xNzcwNzQ2Myw5LjY4ODQ4MTk3IEMtMC4zNDg3ODE5NTgsMTEuMjI5MzgzOSAtMC4zOTYyNTE5NTksMTMuNzE4NTgzNCAxLjA2NDMyMjM2LDE1LjI5NzA0NDIgTDEuMTcwNzE4NTIsMTUuNDA4NTcwNyBMNy41MDExMTM0NCwyMS44MDE1MDMzIEwxMy44MDg0ODM5LDE1LjQzMjE5OTggTDEzLjkxNTE4NzgsMTUuMzIxMTQwOCBDMTUuMzk1NTk2OCwxMy43MjE3MTI1IDE1LjM1Mzk3MDMsMTEuMjMyNDAxIDEzLjgyNTEyNjIsOS42ODg0ODE5NyBDMTIuMjU1OTU2LDguMTAzODM5MzQgOS43MDk3NzczMSw4LjEwMzgzOTM0IDguMTQwNjA3MTQsOS42ODg0ODE5NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" : "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4=";
    } else {
        return favoritesPage && favoritesPage.length > 0 ? iconFavoriteBlack : iconFavorite;
    }
};

;// CONCATENATED MODULE: ./components/Shared/UtilityNavHeader.jsx

























const UtilityNavHeader = (param)=>{
    let { data , eventHandler , toggleMenu =()=>{}  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    const [favoritesPagePath, setFavoritesPagePath] = (0,react.useState)("/");
    const { ":items": { store: { zipCodeContent =""  } = {}  } = {}  } = data;
    const { findAStoreShow , findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const { store: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  } , callbacks: { // eslint-disable-next-line no-console
    setRegionNav =()=>console.log("Event Not Defined") , // eslint-disable-next-line no-console
    setAuthNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const [languageUrl, setLanguageUrl] = (0,react.useState)("");
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const { datalayerPageName , featureFlags ={} , globalConfig: { internationalization: { language ="en" , locale =constants.LOCALE_ENGLISH  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isMobile =  true && window.innerWidth <= 1200;
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const { favorites , saveToListLineItems  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [authNavShow, setAuthNavShow] = (0,react.useState)(false);
    const [authNavActive, setAuthNavActive] = (0,react.useState)(false);
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const [countryNavShow, setCountryNavShow] = (0,react.useState)(false);
    const [countryNavActive, setCountryNavActive] = (0,react.useState)(false);
    const [findAStoreMob, setFindAStoreMob] = (0,react.useState)([]);
    const [languageSwitcherUrl, setLanguageSwitcherUrl] = (0,react.useState)(false);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [myListsPagePath, setMyListsPagePath] = (0,react.useState)("/");
    eventHandler.callbacks.toggleFindAStore = ()=>{
        dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
    };
    (0,react.useEffect)(()=>{
        if (findAStoreShow) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(true));
        }
        if (authNavShow) {
            setAuthNavActive(true);
        }
        if (countryNavShow) {
            setCountryNavActive(true);
        }
    }, [
        findAStoreShow,
        authNavShow,
        countryNavShow
    ]);
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            setFavoritesPagePath("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
        } else {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const myFavPath = get_default()(config, "general.myFavoritesPagePath", "");
                setFavoritesPagePath(await (0,helper/* getShortenedUrl */.Ppy)(myFavPath !== null && myFavPath !== void 0 ? myFavPath : "/"));
            });
        }
        const shortenUrl = async ()=>{
            if (data === null || data === void 0 ? void 0 : data.enableLanguageSwitcher) {
                const shortendUrl = await (0,helper/* getShortenedUrl */.Ppy)(data === null || data === void 0 ? void 0 : data.languageUrl);
                setLanguageUrl(shortendUrl);
            }
        };
        shortenUrl();
    }, [
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        const shortenUrlLang = async ()=>{
            var ref, ref1;
            if ((ref = findAStoreMob[4]) === null || ref === void 0 ? void 0 : (ref1 = ref.utilitynavheader) === null || ref1 === void 0 ? void 0 : ref1.enableLanguageSwitcher) {
                var ref2, ref3;
                const shortenUrlLang = await (0,helper/* getShortenedUrl */.Ppy)((ref2 = findAStoreMob[4]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.utilitynavheader) === null || ref3 === void 0 ? void 0 : ref3.languageUrl);
                setLanguageUrl(shortenUrlLang);
            }
        };
        shortenUrlLang();
    }, [
        languageSwitcherUrl
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
            if (isSaveProductToList) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                    if (Object.keys(res[1]).length) {
                        setFavoritesPage(Object.keys(res[1]));
                    } else {
                        setFavoritesPage([]);
                    }
                });
            }
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (!findAStoreActive) {
            setTimeout(()=>{
                dispatch((0,locationSlice/* setFindAStoreShow */.T7)(false));
            }, 1000);
        }
        if (!authNavActive) {
            setTimeout(()=>{
                setAuthNavShow(false);
            }, 1000);
        }
        if (!countryNavActive) {
            if (winWidth <= 1200) {
                setCountryNavShow(false);
            } else {
                setTimeout(()=>{
                    setCountryNavShow(false);
                }, 1000);
            }
        }
    }, [
        findAStoreActive,
        authNavActive,
        countryNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (Object.keys(saveToListLineItems).length && isAuth) {
            setFavoritesPage(Object.keys(saveToListLineItems));
        } else {
            setFavoritesPage([]);
        }
    }, [
        Object.keys(saveToListLineItems).length
    ]);
    const toggleFindAStore = ()=>{
        var ref, ref1;
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)(((ref = data[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : ref1.findStore) || "Find a Store", themeChange);
        if (!findAStoreShow) {
            dispatch((0,locationSlice/* setFindAStoreShow */.T7)(true));
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            if (findAStoreActive) {
                dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
                (0,helper/* toggeleBodyScroll */.wA4)(false);
            } else {
                dispatch((0,locationSlice/* setFindAStoreShow */.T7)(false));
                (0,helper/* toggeleBodyScroll */.wA4)(false);
            }
        }
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    const iconFavorite = "/icons/favorites-icon.svg";
    const iconFavoriteBlack = "/icons/favorites-full-black.svg";
    const iconLocation = "/icons/location-icon.svg";
    const staticTexts = (0,useAuthUtilityNavi18n/* default */.Z)();
    const toggleAuthNav = ()=>{
        setAuthNavShow(!authNavActive);
        (0,helper/* toggeleBodyScroll */.wA4)(!authNavActive);
        setAuthNavActive(!authNavActive);
    };
    const toggleCountryNav = ()=>{
        if (!countryNavActive) {
            setCountryNavShow(true);
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            setCountryNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    const clickEvent = (e)=>{
        if (!(0,helper/* isElementExcluded */.G_Z)(e, [
            "header-container",
            "modal-popup",
            "auth-modal"
        ])) {
            !isMobile && setAuthNavActive(false);
            !isMobile && dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
            !isMobile && setCountryNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (findAStoreActive) {
            setAuthNavActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        findAStoreActive
    ]);
    (0,react.useEffect)(()=>{
        if (authNavActive) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        authNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (countryNavActive) {
            setAuthNavActive(false);
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        countryNavActive
    ]);
    const style = {
        display: "list-item"
    };
    const displayNone = {
        display: "none"
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = function(e) {
        let path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            if (path) setMyListsPagePath(path);
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
            e.stopPropagation();
            e.preventDefault();
        }
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.favorites, themeChange, favoritesPagePath);
        if (path && isAuth) {
            toggleMenu();
        }
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            window.location.href = myListsPagePath;
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const onAuthMenuClick = (payload)=>{
        setAuthNavActive(payload);
        setAuthNav(payload);
    };
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const getNavMobileData = async ()=>{
        const result = await (0,constants_api/* aemAxiosInstance */.Gb)({
            url: "".concat(constants.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(globalConfig.contentFragmentListConfig.map.mobileNavigationFooterLinks),
            method: "GET"
        });
        const commonTopics = JSON.parse(result.data.commonTopics);
        setFindAStoreMob(commonTopics);
    };
    const { contentFragmentListConfig: { map: fragmentList = {}  } = {}  } = globalConfig;
    (0,react.useEffect)(()=>{
        if (Object.keys(fragmentList).length) getNavMobileData();
    }, [
        fragmentList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            isMobile && findAStoreMob.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "gbh-nav__signin",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                            style: style
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "list",
                                                className: "utility-widgets utility-widgets__brand-switcher",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                    show: authNavShow,
                                                    active: authNavActive,
                                                    toggleAuthNav: toggleAuthNav,
                                                    setAuthNav: setAuthNav,
                                                    onAuthMenuClick: onAuthMenuClick
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "gbh-nav__findStore position_unset",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                            style: style
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "button",
                                                tabIndex: "0",
                                                "aria-live": "polite",
                                                "aria-labelledby": "find-ada",
                                                className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                                onClick: ()=>toggleFindAStore(),
                                                children: [
                                                    themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: iconLocation,
                                                        alt: ""
                                                    }) : null,
                                                    ((ref = findAStoreMob[2]) === null || ref === void 0 ? void 0 : ref.label) || "Find a Store"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                                show: findAStoreShow,
                                                active: findAStoreActive,
                                                eventHandler: eventHandler,
                                                zipCodeContent: zipCodeContent
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        role: "listitem",
                                        className: "wishlist-widget mobile_block position_unset",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                            style: style
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                            href: favoritesPagePath,
                                            "aria-label": "View your wishlist",
                                            className: "gbh-data-layer",
                                            onClick: (e)=>{
                                                onClickSignIn(e, favoritesPagePath);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "View your wishlist",
                                                    "aria-hidden": "true",
                                                    role: "presentation",
                                                    src: getSrc(themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)
                                                }),
                                                themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (ref1 = findAStoreMob[3]) === null || ref1 === void 0 ? void 0 : ref1.label
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        id: "country-ada",
                                        style: displayNone,
                                        children: [
                                            "Country Selector",
                                            " ",
                                            "United States" || (0),
                                            " -",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "gbh-nav__region region_arrowdropdown",
                                        id: "United States".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                        ...isOpen && !mainCategoryActive ? {
                                            style: style
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "button",
                                                tabIndex: "0",
                                                "aria-labelledby": "country-ada",
                                                "aria-expanded": countryNavActive,
                                                onClick: ()=>{
                                                    setRegionNav(true);
                                                    toggleCountryNav();
                                                },
                                                className: "gbh-data-layer gbh-nav__region--link active-country ".concat(data.enableLanguageSwitcher ? "selected-country" : "", " ").concat(countryNavActive ? "expand" : ""),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName, ':global header","internalLinkURL":"n/a","internalLinkName":"').concat((ref2 = "United States" || (0)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), " - ").concat((ref3 = (data === null || data === void 0 ? void 0 : data.language) || "EN") === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                                children: [
                                                    "United States" || (0),
                                                    " -",
                                                    " ",
                                                    ((ref4 = findAStoreMob[4]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.utilitynavheader) === null || ref5 === void 0 ? void 0 : ref5.language) || "EN"
                                                ]
                                            }),
                                            ((ref6 = findAStoreMob[4]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.utilitynavheader) === null || ref7 === void 0 ? void 0 : ref7.enableLanguageSwitcher) && locale !== constants.LOCALE_ENGLISH ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                href: languageUrl,
                                                rel: "noreferrer",
                                                "aria-label": (ref8 = findAStoreMob[4]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.utilitynavheader) === null || ref9 === void 0 ? void 0 : ref9.languageLabel,
                                                className: "country-selector",
                                                onClick: ()=>{
                                                    setLanguageSwitcherUrl(true);
                                                },
                                                children: (ref10 = findAStoreMob[4]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.utilitynavheader) === null || ref11 === void 0 ? void 0 : ref11.languageLabel
                                            }) : null,
                                            ((ref13 = findAStoreMob === null || findAStoreMob === void 0 ? void 0 : (ref12 = findAStoreMob[4]) === null || ref12 === void 0 ? void 0 : ref12.utilitynavheader[":items"]) === null || ref13 === void 0 ? void 0 : ref13.countryselector) && countryNavShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                                show: true,
                                                countryselector: (ref15 = (ref14 = findAStoreMob[4]) === null || ref14 === void 0 ? void 0 : ref14.utilitynavheader[":items"]) === null || ref15 === void 0 ? void 0 : ref15.countryselector,
                                                active: countryNavActive,
                                                eventHandler: eventHandler,
                                                toggleCountryNav: toggleCountryNav,
                                                datalayerPageName: datalayerPageName
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__findStore mobile_none",
                                ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-live": "polite",
                                        "aria-labelledby": "find-ada",
                                        className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                        onClick: ()=>toggleFindAStore(),
                                        children: [
                                            themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: iconLocation,
                                                alt: ""
                                            }) : null,
                                            ((ref16 = data[":items"]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.store) === null || ref17 === void 0 ? void 0 : ref17.findStore) || "Find a Store"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                        show: findAStoreShow,
                                        active: findAStoreActive,
                                        eventHandler: eventHandler,
                                        zipCodeContent: zipCodeContent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "country-ada",
                                style: displayNone,
                                children: [
                                    "Country Selector",
                                    " ",
                                    "United States" || (0),
                                    " -",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__region region_arrowdropdown mobile_none",
                                id: "United States".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                ...isOpen && !mainCategoryActive ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-labelledby": "country-ada",
                                        "aria-expanded": countryNavActive,
                                        onClick: ()=>{
                                            setRegionNav(true);
                                            toggleCountryNav();
                                        },
                                        className: "gbh-data-layer gbh-nav__region--link active-country ".concat(data.enableLanguageSwitcher ? "selected-country" : "", " ").concat(countryNavActive ? "expand" : ""),
                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName, ':global header","internalLinkURL":"n/a","internalLinkName":"').concat((ref18 = "United States" || (0)) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase(), " - ").concat((ref19 = (data === null || data === void 0 ? void 0 : data.language) || "EN") === null || ref19 === void 0 ? void 0 : ref19.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                        children: [
                                            "United States" || (0),
                                            " -",
                                            " ",
                                            (data === null || data === void 0 ? void 0 : data.language) || "EN"
                                        ]
                                    }),
                                    data.enableLanguageSwitcher && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        href: languageUrl,
                                        rel: "noreferrer",
                                        "aria-label": data.languageLabel,
                                        className: "country-selector",
                                        children: data.languageLabel
                                    }),
                                    ((ref20 = data[":items"]) === null || ref20 === void 0 ? void 0 : ref20.countryselector) && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                        show: countryNavShow,
                                        countryselector: (ref21 = data[":items"]) === null || ref21 === void 0 ? void 0 : ref21.countryselector,
                                        active: countryNavActive,
                                        eventHandler: eventHandler,
                                        toggleCountryNav: toggleCountryNav,
                                        datalayerPageName: datalayerPageName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin mobile_none",
                                ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                    style: style
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                show: authNavShow,
                                                active: authNavActive,
                                                toggleAuthNav: toggleAuthNav,
                                                setAuthNav: setAuthNav,
                                                onAuthMenuClick: onAuthMenuClick
                                            }),
                                            (winWidth > 1200 || themeChange) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "wishlist-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                            href: favoritesPagePath,
                                                            "aria-label": "View your wishlist",
                                                            className: "gbh-data-layer",
                                                            onClick: onClickSignIn,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    alt: "View your wishlist",
                                                                    "aria-hidden": "true",
                                                                    role: "presentation",
                                                                    src: getSrc(themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)
                                                                }),
                                                                themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: isSaveProductToList ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists : staticTexts.favorites
                                                                }) : null
                                                            ]
                                                        })
                                                    }),
                                                    (data === null || data === void 0 ? void 0 : data.linkCart) && !themeChange && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "cart-indicator-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_MiniCart, {
                                                            eventHandler: eventHandler,
                                                            source: "from desk"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_UtilityNavHeader = (UtilityNavHeader);

;// CONCATENATED MODULE: ./components/Shared/BrandHeaderFiller.jsx
/* provided dependency */ var process = __webpack_require__(34155);



// import cartEmptyIcon from "/icons/cart-icon-empty.svg"
const BrandHeaderFiller = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__findStore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-live": "polite",
                                    "aria-labelledby": "find-ada",
                                    className: "gbh-nav__findStore--link cmp-find-place",
                                    children: process.env.NEXT_PUBLIC_FIND_STORE_LABEL || "Find a Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__region region_arrowdropdown",
                                id: "United States" || 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-labelledby": "country-ada",
                                    "aria-expanded": "false",
                                    className: "gbh-nav__region--link active-country ",
                                    children: [
                                        "United States" || 0,
                                        " -",
                                        " ",
                                        "EN" || 0
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "UtilityWidgets_utilityWidgetsWrapper__Wz0ZS",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "auth-widget auth-widget__menu AuthUtilityNav_authUtilityNavWrapper__iJgYU",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "auth-nav",
                                                    "aria-expanded": "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            tabIndex: 0,
                                                            role: "button",
                                                            name: "avatarIcon",
                                                            "aria-label": "Sign In Collapsed",
                                                            src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTkgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+U2lnbiBJbiBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTmF2aWdhdGlvbi9EZXNrdG9wL1V0aWxpdHktQmFyL0xvZ2dlZC1PdXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzkxLjAwMDAwMCwgLTEzLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iVXRpbGl0eS1MaW5rcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOC4wMDAwMDAsIDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iU2lnbi1Jbi1JY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzEuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNiwxNy41IEMxOC40MTQyNzMzLDE3LjUgMjAuMzg0NDg5MSwxOS40MDEyMzY1IDIwLjQ5NTEwMiwyMS43ODgxNjQzIEwyMC41LDIyIEwyMC41LDI1IEwxOS41LDI1IEwxOS41LDIyIEMxOS41LDIwLjEzMTQzNjYgMTguMDM1NzIyNCwxOC42MDQ4NzM2IDE2LjE5MjAzNTIsMTguNTA1MTc4OSBMMTYsMTguNSBMNywxOC41IEM1LjEzMTQzNjYsMTguNSAzLjYwNDg3MzU1LDE5Ljk2NDI3NzYgMy41MDUxNzg4NiwyMS44MDc5NjQ4IEwzLjUsMjIgTDMuNSwyNSBMMi41LDI1IEwyLjUsMjIgQzIuNSwxOS41ODU3MjY3IDQuNDAxMjM2NTIsMTcuNjE1NTEwOSA2Ljc4ODE2NDMsMTcuNTA0ODk4IEw3LDE3LjUgTDE2LDE3LjUgWiBNMTEuNSw1LjUgQzE0LjI2MTQyMzcsNS41IDE2LjUsNy43Mzg1NzYyNSAxNi41LDEwLjUgQzE2LjUsMTMuMjYxNDIzNyAxNC4yNjE0MjM3LDE1LjUgMTEuNSwxNS41IEM4LjczODU3NjI1LDE1LjUgNi41LDEzLjI2MTQyMzcgNi41LDEwLjUgQzYuNSw3LjczODU3NjI1IDguNzM4NTc2MjUsNS41IDExLjUsNS41IFogTTExLjUsNi41IEM5LjI5MDg2MSw2LjUgNy41LDguMjkwODYxIDcuNSwxMC41IEM3LjUsMTIuNzA5MTM5IDkuMjkwODYxLDE0LjUgMTEuNSwxNC41IEMxMy43MDkxMzksMTQuNSAxNS41LDEyLjcwOTEzOSAxNS41LDEwLjUgQzE1LjUsOC4yOTA4NjEgMTMuNzA5MTM5LDYuNSAxMS41LDYuNSBaIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPiA=",
                                                            alt: "Sign In"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "auth-nav__menu ",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "wishlist-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    "aria-label": "View your wishlist",
                                                    className: "gbh-data-layer",
                                                    href: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "View your wishlist",
                                                        "aria-hidden": "true",
                                                        role: "presentation",
                                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="
                                                    })
                                                })
                                            }),
                                            process.env.NEXT_PUBLIC_DISABLE_CART_ICON === "true" ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "cart-indicator-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-indicator false",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "aria-label": "View your cart containing 0 item",
                                                        role: "link",
                                                        className: "gbh-data-layer",
                                                        href: "/en/cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/icons/cart-icon-empty.svg",
                                                            alt: "Cart"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeaderFiller = (BrandHeaderFiller);

;// CONCATENATED MODULE: ./components/Shared/CheckoutUtilityNavheader.jsx


const CheckoutUtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "listitem",
            className: "cart-indicator-widget__checkout",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_MiniCart, {
                checkoutPage: data === null || data === void 0 ? void 0 : data.linkCart,
                eventHandler: eventHandler,
                source: "from desk"
            })
        })
    });
};
/* harmony default export */ var CheckoutUtilityNavheader = (CheckoutUtilityNavHeader);

;// CONCATENATED MODULE: ./components/Shared/BrandHeader.jsx









const BrandHeader = (props)=>{
    const { data , eventHandler  } = props;
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isSsr = (0,useIsSsr/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                if (key === "brand_switcher" || key === "brand_switcher_copy") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandSwitcher, {
                        data: item,
                        datalayerPageName: datalayerPageName
                    }, key);
                }
                if (key === "utilitynavheader" || key === "utilitynavheader_v2") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeaderFiller, {}) : key === "utilitynavheader_v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutUtilityNavheader, {
                            data: item,
                            eventHandler: eventHandler
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_UtilityNavHeader, {
                            data: item,
                            eventHandler: eventHandler
                        })
                    }, key);
                }
                return null;
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeader = (BrandHeader);

;// CONCATENATED MODULE: ./public/icons/BLOK_LOGO.svg
/* harmony default export */ var BLOK_LOGO = ({"src":"/_next/static/media/BLOK_LOGO.00edf835.svg","height":35,"width":115});
;// CONCATENATED MODULE: ./components/Shared/HeaderNavLogo.jsx






const HeaderNavLogo = (props)=>{
    var ref;
    const { data ={} , columnClassNames ="" , eventHandler: { store: { brandLogoImg =""  } = {} , callbacks: { setBrandLogoImg =()=>{} , toggleMenu =()=>{}  }  } , v3 , isOpen , ariaControls =""  } = props;
    const hamburgericon = "/icons/icon-Hamburger.svg";
    (0,react.useEffect)(()=>{
        setBrandLogoImg(BLOK_LOGO === null || BLOK_LOGO === void 0 ? void 0 : BLOK_LOGO.src);
    }, []);
    const toggleMenuCall = ()=>{
        (0,helper/* removeMavenoidChat */.N9B)();
        toggleMenu();
        (0,HeaderNavTabs_analytics/* hamburgerMenuDatalayer */.w_)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "gbh-hamber-menu icon-Hamburger",
                tabIndex: "0",
                "aria-label": "Hamburger-menu",
                role: "button",
                onClick: toggleMenuCall,
                "aria-expanded": isOpen,
                "aria-controls": ariaControls,
                children: v3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: hamburgericon,
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "img",
                "aria-label": "The Bold Look of Kohler logo",
                tabIndex: "0",
                className: "cmp cmp-image ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    tabIndex: "-1",
                    href: data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                    title: data === null || data === void 0 ? void 0 : data.alt,
                    className: "cmp-image--link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: brandLogoImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(brandLogoImg),
                            alt: data === null || data === void 0 ? void 0 : data.alt
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_HeaderNavLogo = (HeaderNavLogo);

// EXTERNAL MODULE: ./components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(18377);
// EXTERNAL MODULE: ./hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83886);
;// CONCATENATED MODULE: ./components/Shared/ProductsNavTab.jsx












const ProductsNavTab = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { navOpen , setNavOpen , productNavigationItems , onClickNav , eventHandler: { store: { isOpen  }  } , datalayerPageName , selectedTab , hideMobImages , showMobileImages  } = props;
    const { locale , asPath  } = (0,next_router.useRouter)();
    const routerAsPath = "/" + locale + asPath;
    const [changePath, setChangePath] = (0,react.useState)();
    const [activeMainCategory, setActiveMainCategory] = (0,react.useState)("");
    const [activeSubCategory, setActiveSubCategory] = (0,react.useState)("");
    const isSsr = (0,useIsSsr/* default */.Z)();
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const onHoverMainCategory = (name)=>{
        setActiveMainCategory(name);
    };
    const onHoverSubCategory = (name)=>{
        setActiveSubCategory(name);
    };
    (0,react.useEffect)(()=>{
        setChangePath(routerAsPath);
    }, []);
    (0,react.useEffect)(()=>{
        if (!isOpen || !navOpen) {
            setActiveSubCategory("");
            setActiveMainCategory("");
        }
    }, [
        isOpen,
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        if (changePath !== routerAsPath) {
            setNavOpen("");
            setChangePath(routerAsPath);
        }
    }, [
        routerAsPath
    ]);
    (0,react.useEffect)(()=>{
        if (productNavigationItems && activeMainCategory) {
            productNavigationItems.map((mainCategory, i)=>{
                if ((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory) {
                    const subCategoryDetails = mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails;
                    if (subCategoryDetails) {
                        const childItem = (subCategoryDetails === null || subCategoryDetails === void 0 ? void 0 : subCategoryDetails.childItems[0]) || null;
                        if (childItem) {
                            const activeSubCategory = (childItem === null || childItem === void 0 ? void 0 : childItem.subCategory) || null;
                            if (activeSubCategory) {
                                setActiveSubCategory(activeSubCategory);
                            }
                        }
                    }
                }
            });
        }
    }, [
        activeMainCategory,
        productNavigationItems
    ]);
    const handleOnClick = (item)=>{
        onHoverMainCategory(!(!(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink)) ? item === null || item === void 0 ? void 0 : item.categoryName : "");
        const prodnavsubmenu = document.querySelector(".gbh-global-tab .cmp-tabs");
        prodnavsubmenu === null || prodnavsubmenu === void 0 ? void 0 : prodnavsubmenu.scroll(0, 0);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        tabIndex: "-1",
        className: "cmp-tabs__tabpanel ".concat(navOpen === t("kf.nav.label.products") ? "cmp-tabs__tabpanel--active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(constants.staticClasses.CONTAINER),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "globalnavigation aem-GridColumn aem-GridColumn--default--12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-product-menu ".concat(hideMobImages ? "hide-mobile-images" : "", " ").concat(navOpen === t("kf.nav.label.products") ? "open" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "gbh-pro-menu__inner",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex-column gbh-pro-menu__list nav",
                                            role: "tablist",
                                            "aria-label": "list of 6",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "gbh-mob-back-btn",
                                                    onClick: ()=>onClickNav({
                                                            "cq:panelTitle": navOpen
                                                        }),
                                                    children: "Menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "global-menu-selected",
                                                    children: t("kf.nav.label.products")
                                                }),
                                                productNavigationItems && productNavigationItems.map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "nav-item",
                                                        "data-tab": item === null || item === void 0 ? void 0 : item.categoryName,
                                                        role: "tab",
                                                        onClick: ()=>handleOnClick(item),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "gbh-data-layer nav-link ".concat((item === null || item === void 0 ? void 0 : item.categoryName) === activeMainCategory ? "link-active" : ""),
                                                            "aria-hidden": "false",
                                                            "aria-label": item === null || item === void 0 ? void 0 : item.categoryName,
                                                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"","internalLinkName":"products > ').concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase(), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                            "data-hover": "tab",
                                                            "data-target": "#submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            "aria-controls": "submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            rel: "noreferrer",
                                                            role: "tab",
                                                            tabIndex: "0",
                                                            href: !(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink) ? (0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.categoryLink) : null,
                                                            "aria-selected": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            "aria-expanded": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            children: item === null || item === void 0 ? void 0 : item.categoryName
                                                        })
                                                    }, "productNavigation-".concat(index));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-content gbh-pro-menu__cont",
                                            children: productNavigationItems && productNavigationItems.map((mainCategory, i)=>{
                                                var ref, ref1;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tab-pane fade ".concat((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory ? "active show" : ""),
                                                    role: "tabpanel",
                                                    "aria-labelledby": mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cmp-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "aem-Grid aem-Grid--12 aem-Grid--default--12 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "globalnavigation-subcategory aem-GridColumn aem-GridColumn--default--12",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                        className: "nav gbh-pro-collection gbh-two-column",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                className: "gbh-mob-back-btn",
                                                                                onClick: ()=>onHoverMainCategory(""),
                                                                                children: t("kf.nav.label.products")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "global-menu-selected sub-cat-select",
                                                                                children: mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName
                                                                            }),
                                                                            (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.map((subCategory, j)=>{
                                                                                var ref, ref1;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    className: "nav-item gbh-pro-collection__category-link",
                                                                                    onMouseOver: ()=>{
                                                                                        return onHoverSubCategory(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory);
                                                                                    },
                                                                                    children: routerAsPath === (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        "data-purelink": "true",
                                                                                        href: (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref1 = mainCategory.subCategoryDetails) === null || ref1 === void 0 ? void 0 : ref1.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }, "subCategory-".concat(j));
                                                                            }))
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "tab-content gbh-pro-collection-cont gbh-two-column",
                                                                        children: (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref1 = mainCategory.subCategoryDetails) === null || ref1 === void 0 ? void 0 : ref1.childItems.map((subCategory, j)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "tab-pane fade gbh-mob-col ".concat((subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory) === activeSubCategory ? "active show" : ""),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    href: (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                    className: "gbh-data-layer",
                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" > ').concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "hello gbh-subcattext",
                                                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                        }),
                                                                                        showMobileImages && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "cmp-image",
                                                                                            children: [
                                                                                                smartCrop.scriptStatus && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                                                                    imgUrl: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image with-crop",
                                                                                                    uniqueId: "subcatImage-".concat(j)
                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                    src: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image without-crop"
                                                                                                }, "subcatImage-".concat(j)),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    dangerouslySetInnerHTML: {
                                                                                                        __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.description)
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, "subcatInfo-".concat(j));
                                                                        }))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }, "mainCategory-".concat(i));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "gbh-promenu-close-btn icon-Close-Large",
                                            "aria-label": "close",
                                            role: "button",
                                            tabIndex: "0",
                                            onClick: ()=>{
                                                setNavOpen("");
                                                setActiveMainCategory("");
                                                setActiveSubCategory();
                                                (0,helper/* preventBodyScrollTab */.aCP)(false);
                                                (0,HeaderNavTabs_analytics/* addAnalyticsOnClose */.hJ)();
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "productbg ".concat(navOpen === t("kf.nav.label.products") ? "open" : "")
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_ProductsNavTab = (ProductsNavTab);

;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/index.jsx











const HeaderNavTabs = (props)=>{
    const { data , columnClassNames , eventHandler , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>{} , setMainCategory =()=>{}  }  } , wrapperId =""  } = props;
    const { pageIsInteractive , datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [productNavigationItems, setProductNavigationItems] = (0,react.useState)(null);
    const [hideMobImages, setHideMobImages] = (0,react.useState)(false);
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const [selectedTab, setTab] = (0,react.useState)("");
    const menuVisible = (0,react.useRef)(0);
    const [showMobileImages, setShowMobileImages] = (0,react.useState)(true);
    const dataRecursion = (0,react.useCallback)((data)=>{
        const { mainNavigation , categoryItems , hideMobileImages  } = data;
        if (data && mainNavigation === "Products") {
            setProductNavigationItems(categoryItems);
            setHideMobImages(hideMobileImages);
        }
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq && hideMobImages) {
            setShowMobileImages(false);
        } else {
            setShowMobileImages(true);
        }
    }, [
        hideMobImages,
        lib/* isMobile */.tq
    ]);
    const onClickNav = (data)=>{
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        if (navOpen !== data["cq:panelTitle"]) {
            setNavOpen(data["cq:panelTitle"]);
            if (!lib/* isMobile */.tq) {
                setNavOpen(data["cq:panelTitle"]);
            }
            setMainCategory({
                item: data["cq:panelTitle"]
            });
            menuVisible.current = 1;
            (0,helper/* preventBodyScrollTab */.aCP)(true);
            addHeaderNavTabAnalytics(data);
        } else {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    const addHeaderNavTabAnalytics = (data)=>{
        const eventInfo = {
            eventAction: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventName: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventType: "tab",
            internalLinkName: data["cq:panelTitle"].toLowerCase(),
            internalLinkPosition: "global header",
            internalLinkType: "global navigation",
            internalLinkZoneName: "global header",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !lib/* isMobile */.tq) && menuVisible.current) {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : "", " ").concat(isOpen ? "open" : ""),
        id: wrapperId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-tabs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                    "aria-label": "close button",
                    tabIndex: "0",
                    onClick: ()=>{
                        toggleMenu();
                        onClickNav({
                            "cq:panelTitle": navOpen
                        });
                        (0,HeaderNavTabs_analytics/* addAnalyticsOnClose */.hJ)();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    role: "tablist",
                    className: "cmp-tabs__tablist",
                    "aria-multiselectable": "false",
                    children: [
                        data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ".concat(selectedTab === item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                tabIndex: "0",
                                onClick: ()=>onClickNav(item),
                                children: item["cq:panelTitle"]
                            }, "navItem-".concat(index));
                        }),
                        (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab",
                                tabIndex: "0",
                                children: key
                            }, "navItem-".concat(index));
                        })
                    ]
                }),
                pageIsInteractive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ProductsNavTab, {
                    productNavigationItems: productNavigationItems,
                    navOpen: navOpen,
                    setNavOpen: (data)=>setNavOpen(data),
                    onClickNav: onClickNav,
                    isOpen: isOpen,
                    eventHandler: eventHandler,
                    datalayerPageName: datalayerPageName,
                    selectedTab: selectedTab,
                    hideMobImages: hideMobImages,
                    showMobileImages: showMobileImages
                }),
                data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                    var ref;
                    const items = data[":items"][key];
                    const item = (ref = items[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation;
                    if ((item === null || item === void 0 ? void 0 : item.mainNavigation) === "drawer" && navOpen === items["cq:panelTitle"]) {
                        var ref1, ref2, ref3, ref4;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            tabIndex: "-1",
                            className: "cmp-tabs__tabpanel ".concat(navOpen === items["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(constants.staticClasses.CONTAINER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "gbh-full-w-menu",
                                                    style: {
                                                        transition: "all 2s ease 0s"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "bg-dim",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gbh-full-w-menu__inner",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "gbh-full-max-width",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__left-cont",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "gbh-full-w-menu__left-cont__top",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "gbh-full-w-menu__left-cont__top__cont",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.mainTitle)
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "gbh-full-w-menu__left-cont__description",
                                                                                            style: {
                                                                                                transition: "none 0s ease 0s"
                                                                                            },
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.description)
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                            className: "gbh-mob-back-btn",
                                                                                            onClick: ()=>onClickNav({
                                                                                                    "cq:panelTitle": navOpen
                                                                                                }),
                                                                                            children: "Menu"
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : (ref1 = item.drawerItems) === null || ref1 === void 0 ? void 0 : ref1.map((navItem, index)=>{
                                                                                            var ref, ref1, ref2;
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                className: "nav-item ",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                    className: "gbh-data-layer nav-link".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? " extranal-sub-nav" : "", " "),
                                                                                                    target: "".concat(navItem.newTab ? "_blank" : "_self"),
                                                                                                    href: (ref = navItem.subNavLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "false" : "true", '","internalLinkPosition":"global header","internalLinkZoneName":"').concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.subNavLink) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", ""), '","internalLinkName":"').concat((ref2 = items["cq:panelTitle"]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), " > ").concat(navItem === null || navItem === void 0 ? void 0 : navItem.subNavName.toLowerCase(), '","eventName":"main dropdown  menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                                    rel: "".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "noreferrer" : ""),
                                                                                                    "data-hover": "tab",
                                                                                                    role: "link",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                __html: browser_default().sanitize(navItem.subNavName)
                                                                                                            }
                                                                                                        }),
                                                                                                        (navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "sub-cat-img",
                                                                                                            children: (item === null || item === void 0 ? void 0 : item.externalIconCheckbox) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                src: item === null || item === void 0 ? void 0 : item.externalIcon,
                                                                                                                alt: "external link",
                                                                                                                href: navItem.subNavLink
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }, "navItem-".concat(index));
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__right-img",
                                                                        children: (item === null || item === void 0 ? void 0 : (ref2 = item.drawerImage) === null || ref2 === void 0 ? void 0 : ref2.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                                            imgUrl: item === null || item === void 0 ? void 0 : (ref3 = item.drawerImage) === null || ref3 === void 0 ? void 0 : ref3.imageUrl,
                                                                            className: "cmp-image__image",
                                                                            alt: item === null || item === void 0 ? void 0 : (ref4 = item.drawerImage) === null || ref4 === void 0 ? void 0 : ref4.imageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "productbg"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }, "navTabs-".concat(index));
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Shared_HeaderNavTabs = (HeaderNavTabs);

// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx
var UtilityWidgets = __webpack_require__(55938);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/index.module.scss
var HeaderNavTabs_index_module = __webpack_require__(52498);
var HeaderNavTabs_index_module_default = /*#__PURE__*/__webpack_require__.n(HeaderNavTabs_index_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/icons/up-accordion.svg
/* harmony default export */ var up_accordion = ({"src":"/_next/static/media/up-accordion.297a82da.svg","height":30,"width":12});
;// CONCATENATED MODULE: ./public/icons/down-accordion.svg
/* harmony default export */ var down_accordion = ({"src":"/_next/static/media/down-accordion.cc6c07fa.svg","height":30,"width":12});
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/MenuItem/index.jsx





const externalicon = "/icons/externalicon.svg";
const externalIconWhite = "/icons/external link.svg";
const MenuItem = (props)=>{
    const { getInternalLinkURLS =()=>{} , itemLink ="" , itemLabel ="" , darkThemeFlag =false , selectedTab ="" , groupTitle ="" , servicesAnalyticsClick =()=>{}  } = props !== null && props !== void 0 ? props : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "nav-item",
        "data-nav-parent": (0,HeaderNavTabs_utils/* pureText */.$r)(groupTitle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: itemLink === null || itemLink === void 0 ? void 0 : itemLink.split(constants.internalLinkPath).join("").replace(".html", ""),
            onClick: ()=>servicesAnalyticsClick({
                    text: itemLabel,
                    link: itemLink,
                    Leveltwo: groupTitle,
                    L1: selectedTab
                }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "menu-labels",
                    dangerouslySetInnerHTML: {
                        __html: browser_default().sanitize(itemLabel)
                    }
                }),
                getInternalLinkURLS(itemLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "navigation-external-img",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: darkThemeFlag ? externalIconWhite : externalicon,
                        alt: "external-icon"
                    })
                }) : null
            ]
        })
    }, itemLabel + itemLink);
};
/* harmony default export */ var HeaderNavTabs_MenuItem = (MenuItem);

;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/NavigationAccordion/index.jsx



const NavigationAccordion = (props)=>{
    const isMobile =  true && window.innerWidth <= 1200;
    const { levelTwo: { groupLink ="" , mobileLabel ="" , groupTitle ="" , levelThreeNavMulti =[]  } = {} , getInternalLinkURLS =()=>{} , darkThemeFlag =false , selectedTab ="" , servicesAnalyticsClick =()=>{}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            groupLink && mobileLabel && isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_MenuItem, {
                getInternalLinkURLS: getInternalLinkURLS,
                itemLink: groupLink,
                itemLabel: mobileLabel,
                darkThemeFlag: darkThemeFlag,
                selectedTab: selectedTab,
                groupTitle: groupTitle,
                servicesAnalyticsClick: servicesAnalyticsClick
            }) : null,
            levelThreeNavMulti === null || levelThreeNavMulti === void 0 ? void 0 : levelThreeNavMulti.map((columnItems, index)=>{
                const { link ="" , label =""  } = columnItems;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(label)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_MenuItem, {
                        getInternalLinkURLS: getInternalLinkURLS,
                        itemLink: link,
                        itemLabel: label,
                        darkThemeFlag: darkThemeFlag,
                        selectedTab: selectedTab,
                        groupTitle: groupTitle,
                        servicesAnalyticsClick: servicesAnalyticsClick
                    })
                }, label + index);
            })
        ]
    });
};
/* harmony default export */ var HeaderNavTabs_NavigationAccordion = (NavigationAccordion);

// EXTERNAL MODULE: ./components/core/SmartCropImage/index.jsx
var SmartCropImage = __webpack_require__(1906);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/ImageBlock/index.jsx





const caretimg = "/icons/bold.svg";
const caretimgWhite = "/icons/bold-white.svg";
const ImageBlock = (props)=>{
    var ref;
    const { itemType , menuType , newTabImage , imageLink , ctaLabel , selectedTab , imageFileReference , imageAltText , imageTitle , imageCtaLink =(ref = (0,HeaderNavTabs_utils/* modifyHref */.L9)(imageCtaLink)) !== null && ref !== void 0 ? ref : null , newTabImageCta , darkThemeFlag , smartCrop  } = props;
    const sanitizedImageTitle = browser_default().sanitize(imageTitle);
    const levelTwoTitle = (0,HeaderNavTabs_utils/* pureText */.$r)(sanitizedImageTitle);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(itemType === null || itemType === void 0 ? void 0 : itemType.appliedCssClassNames, " ").concat(menuType),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                style: {
                    cursor: "pointer"
                },
                target: newTabImage ? "_blank" : "_self",
                href: imageLink ? (0,HeaderNavTabs_utils/* modifyHref */.L9)(imageLink) : null,
                rel: "noreferrer",
                onClick: (e)=>{
                    (0,HeaderNavTabs_analytics/* servicesAnalyticsClick */.yp)({
                        text: ctaLabel,
                        link: imageLink,
                        Leveltwo: levelTwoTitle,
                        L1: selectedTab,
                        imgcheck: true
                    });
                    (0,HeaderNavTabs_utils/* closestAnchorHref */.dV)(e) && e.preventDefault();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                    url: imageFileReference,
                    className: "cmp-image__image",
                    smartCrop: smartCrop,
                    altText: imageAltText !== null && imageAltText !== void 0 ? imageAltText : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: sanitizedImageTitle
                }
            }),
            ctaLabel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-cta",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "div-of-cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: imageCtaLink ? "" : "empty",
                            target: newTabImageCta ? "_blank" : "_self",
                            href: imageCtaLink,
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(ctaLabel)
                            },
                            onClick: (e)=>{
                                (0,HeaderNavTabs_analytics/* servicesAnalyticsClick */.yp)({
                                    text: ctaLabel,
                                    link: imageCtaLink,
                                    L1: selectedTab,
                                    Leveltwo: levelTwoTitle
                                });
                                (0,HeaderNavTabs_utils/* closestAnchorHref */.dV)(e) && e.preventDefault();
                            },
                            rel: "noreferrer"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cta-link-caret",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: darkThemeFlag ? caretimgWhite : caretimg,
                            alt: "caret-icon"
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var HeaderNavTabs_ImageBlock = (ImageBlock);

;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/TabPanel/index.jsx











const TabPanel = (props)=>{
    const { itemType , selectedId , levelOneLengthsArray , navOpen , selectedNavTabIndex , navTabIndex , setActiveIndex , setSelectedId , selectedTab , staticClasses , handleMouseLeave , smartCrop , darkThemeFlag , handleAccordionClick , getInternalLinkURLS , menuType , onClickNav , activeIndex , navTitle , levelOneNavMulti , multiCTA , firstImagesblock , secondImagesblock  } = props || {};
    const caretimg = "/icons/bold.svg";
    const externalicon = "/icons/externalicon.svg";
    const caretimgWhite = "/icons/bold-white.svg";
    const externalIconWhite = "/icons/external link.svg";
    const isMobile =  true && window.innerWidth <= 1200;
    (0,react.useEffect)(()=>{
        if (levelOneLengthsArray[selectedNavTabIndex] !== -1) {
            setActiveIndex(levelOneLengthsArray[selectedNavTabIndex]);
            setSelectedId(levelOneLengthsArray[selectedNavTabIndex]);
        }
    }, []);
    const [isClient, setIsClient] = (0,react.useState)(false);
    const [processedNav, setProcessedNav] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setIsClient(true);
    }, []);
    const processNavigationData = function() {
        let navData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return navData.map((levelOne)=>{
            var ref;
            return {
                ...levelOne,
                levelTwoNavMulti: (ref = levelOne.levelTwoNavMulti || []) === null || ref === void 0 ? void 0 : ref.map((levelTwo)=>{
                    var ref;
                    const { groupLink ="" , groupTitle ="" , levelThreeNavMulti =[]  } = levelTwo || {};
                    const hrefLink = groupLink ? (0,HeaderNavTabs_utils/* modifyHref */.L9)(groupLink) : null;
                    const isExternal = getInternalLinkURLS(groupLink);
                    const textNameList = (0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(groupTitle);
                    return {
                        ...levelTwo,
                        hrefLink,
                        isExternal,
                        textNameList,
                        levelThreeNavMulti: (ref = levelThreeNavMulti || []) === null || ref === void 0 ? void 0 : ref.map((levelThree)=>{
                            const { link ="" , label =""  } = levelThree || {};
                            return {
                                ...levelThree,
                                hrefLink: link ? (0,HeaderNavTabs_utils/* modifyHref */.L9)(link) : null,
                                isExternal: getInternalLinkURLS(link),
                                textNameList: (0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(label),
                                dataNavParent: (0,HeaderNavTabs_utils/* pureText */.$r)(groupTitle)
                            };
                        })
                    };
                })
            };
        });
    };
    (0,react.useEffect)(()=>{
        if (isClient && (levelOneNavMulti === null || levelOneNavMulti === void 0 ? void 0 : levelOneNavMulti.length)) {
            const processed = processNavigationData(levelOneNavMulti);
            setProcessedNav(processed);
        }
    }, [
        isClient,
        levelOneNavMulti
    ]);
    const { newTabFirstImage =false , firstImageLink ="" , ctaLabel: firstCtaLabel = "" , firstImageFileReference ="" , ctaLink: firstImageCtaLink = "" , altText: firstImageAltText = "" , firstImageTitle ="" , ctaNewTab: newTabFirstImageCta = false  } = firstImagesblock;
    const { newTabSecondImage =false , secondImageLink ="" , ctaLabel: secondCtaLabel = "" , secondImageFileReference ="" , ctaLink: secondImageCtaLink = "" , altText: secondImageAltText = "" , secondImageTitle ="" , ctaNewTab: newTabSecondImageCta = false  } = secondImagesblock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        tabIndex: "-1",
        className: "cmp-tabs__tabpanel ".concat(navOpen === itemType["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(staticClasses.CONTAINER),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-full-w-menu",
                                onMouseLeave: !isMobile ? handleMouseLeave : null,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-dim",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "gbh-full-w-menu__inner",
                                        id: "Mouse id",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "gbh-full-max-width",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "menu-container ".concat(darkThemeFlag ? "dark-theme" : "light-theme", " ").concat(menuType),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "gbh-full-w-menu__left-cont ".concat(menuType),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gbh-full-w-menu__left-cont__top",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "levelZero",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: "gbh-mob-back-btn ".concat((0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(selectedTab)),
                                                                            onClick: (e)=>{
                                                                                e.preventDefault();
                                                                                onClickNav({
                                                                                    "cq:panelTitle": navOpen
                                                                                }, "mobile back btn");
                                                                            },
                                                                            children: selectedTab
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "level-one-container",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "level-one-sub-container",
                                                                                children: [
                                                                                    navTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "group-title",
                                                                                        children: navTitle
                                                                                    }) : null,
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "level-one-nav-multi",
                                                                                        children: processedNav === null || processedNav === void 0 ? void 0 : processedNav.map((navItem, id)=>{
                                                                                            const { levelTwoNavMulti =[]  } = navItem || {};
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "levelTwoMapping ".concat(menuType + ((processedNav === null || processedNav === void 0 ? void 0 : processedNav.length) === 1 ? "-one-col" : "")),
                                                                                                children: levelTwoNavMulti === null || levelTwoNavMulti === void 0 ? void 0 : levelTwoNavMulti.map((levelTwo, index)=>{
                                                                                                    const { newTabGroup: newTab = false , groupTitle ="" , groupLink ="" , levelThreeNavMulti =[] , hrefLink , textNameList , isExternal  } = levelTwo || {};
                                                                                                    const carrotTitleClass = (groupTitle === null || groupTitle === void 0 ? void 0 : groupTitle.includes("carrot-icon")) ? "carot-title" : activeIndex === index && selectedId === id && (levelThreeNavMulti === null || levelThreeNavMulti === void 0 ? void 0 : levelThreeNavMulti.length) > 0 && navTabIndex !== null ? " tile-bg" : "";
                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                                        className: "".concat(textNameList).concat(carrotTitleClass),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                onClick: isMobile ? ()=>handleAccordionClick(index, id, navTabIndex) : null,
                                                                                                                className: "menu-item-tiles",
                                                                                                                "data-nav-parent": itemType["cq:panelTitle"],
                                                                                                                children: [
                                                                                                                    isMobile && (levelThreeNavMulti === null || levelThreeNavMulti === void 0 ? void 0 : levelThreeNavMulti.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "menuItems ".concat(menuType, " ").concat((groupTitle === null || groupTitle === void 0 ? void 0 : groupTitle.includes("carrot-icon")) ? "carot-icon" : ""),
                                                                                                                        dangerouslySetInnerHTML: {
                                                                                                                            __html: browser_default().sanitize(groupTitle)
                                                                                                                        }
                                                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                        target: newTab ? "_blank" : "_self",
                                                                                                                        className: "menuItems ".concat(menuType, " ").concat((groupTitle === null || groupTitle === void 0 ? void 0 : groupTitle.includes("carrot-icon")) ? "carot-icon" : "", "\n                                                          ").concat(hrefLink ? "" : "empty"),
                                                                                                                        "aria-label":  true && window.location.href.includes(hrefLink) ? "Current Page: ".concat((0,helper/* sanitizeText */.oOy)(groupTitle)) : (0,helper/* sanitizeText */.oOy)(groupTitle),
                                                                                                                        href: hrefLink,
                                                                                                                        dangerouslySetInnerHTML: {
                                                                                                                            __html: browser_default().sanitize(groupTitle)
                                                                                                                        },
                                                                                                                        onClick: (e)=>{
                                                                                                                            (0,HeaderNavTabs_analytics/* servicesAnalyticsClick */.yp)({
                                                                                                                                text: groupTitle,
                                                                                                                                link: groupLink,
                                                                                                                                Leveltwo: selectedTab
                                                                                                                            });
                                                                                                                            (0,HeaderNavTabs_utils/* closestAnchorHref */.dV)(e) && e.preventDefault();
                                                                                                                        },
                                                                                                                        rel: "noreferrer"
                                                                                                                    }),
                                                                                                                    isMobile && levelThreeNavMulti.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                        src: activeIndex === index && selectedId === id && navTabIndex !== null ? up_accordion : down_accordion,
                                                                                                                        alt: "down-accordion icon",
                                                                                                                        className: "toggleArrow"
                                                                                                                    }) : null,
                                                                                                                    (groupTitle === null || groupTitle === void 0 ? void 0 : groupTitle.includes("carrot-icon")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "navigation-img",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                            src: darkThemeFlag ? caretimgWhite : caretimg,
                                                                                                                            alt: "caret-icon"
                                                                                                                        })
                                                                                                                    }) : null,
                                                                                                                    isExternal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "navigation-external-img",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                            src: darkThemeFlag ? externalIconWhite : externalicon,
                                                                                                                            alt: "external-icon"
                                                                                                                        })
                                                                                                                    })
                                                                                                                ]
                                                                                                            }, index),
                                                                                                            activeIndex === index && selectedId === id && navTabIndex !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_NavigationAccordion, {
                                                                                                                darkThemeFlag: darkThemeFlag,
                                                                                                                levelTwo: levelTwo,
                                                                                                                getInternalLinkURLS: getInternalLinkURLS,
                                                                                                                selectedTab: selectedTab,
                                                                                                                servicesAnalyticsClick: HeaderNavTabs_analytics/* servicesAnalyticsClick */.yp
                                                                                                            }) : null,
                                                                                                            !isMobile ? levelThreeNavMulti === null || levelThreeNavMulti === void 0 ? void 0 : levelThreeNavMulti.map((columnItems, index)=>{
                                                                                                                const { newTab =false , link ="" , label ="" , hrefLink , isExternal =false , textNameList , dataNavParent  } = columnItems || {};
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                                    className: "nav-item ".concat(textNameList),
                                                                                                                    "data-nav-parent": dataNavParent,
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                                        target: newTab ? "_blank" : "_self",
                                                                                                                        role: "link",
                                                                                                                        "aria-label":  true && window.location.href.includes(hrefLink) ? "Current Page: ".concat((0,helper/* sanitizeText */.oOy)(label)) : (0,helper/* sanitizeText */.oOy)(label),
                                                                                                                        href: hrefLink,
                                                                                                                        onClick: (e)=>{
                                                                                                                            (0,HeaderNavTabs_analytics/* servicesAnalyticsClick */.yp)({
                                                                                                                                text: label,
                                                                                                                                link: link,
                                                                                                                                Leveltwo: groupTitle,
                                                                                                                                L1: selectedTab
                                                                                                                            });
                                                                                                                            (0,HeaderNavTabs_utils/* closestAnchorHref */.dV)(e) && e.preventDefault();
                                                                                                                        },
                                                                                                                        rel: "noreferrer",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                                className: "menu-labels ".concat(hrefLink ? "" : "empty"),
                                                                                                                                dangerouslySetInnerHTML: {
                                                                                                                                    __html: browser_default().sanitize(label)
                                                                                                                                }
                                                                                                                            }),
                                                                                                                            isExternal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                                className: "navigation-external-img",
                                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                                    src: darkThemeFlag ? externalIconWhite : externalicon,
                                                                                                                                    alt: "external-icon"
                                                                                                                                })
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                }, "navItem-".concat(index));
                                                                                                            }) : null
                                                                                                        ]
                                                                                                    }, navItem + index);
                                                                                                })
                                                                                            }, navItem + id);
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "gbh-full-w-menu__right-img",
                                                        children: [
                                                            (multiCTA === null || multiCTA === void 0 ? void 0 : multiCTA.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "right-img-cta",
                                                                children: multiCTA === null || multiCTA === void 0 ? void 0 : multiCTA.map((ctaItem, index)=>{
                                                                    var ref;
                                                                    const { ctaLink =(ref = (0,HeaderNavTabs_utils/* modifyHref */.L9)(ctaLink)) !== null && ref !== void 0 ? ref : null , ctaLabel ="" , newTabCTA =false  } = ctaItem;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                                                        className: "multicta",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                            className: "navigationcta",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "ctalable ".concat(ctaLink ? "" : "empty"),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        "aria-label": (0,helper/* sanitizeText */.oOy)(ctaLabel),
                                                                                        rel: "noreferrer",
                                                                                        target: newTabCTA ? "_blank" : "_self",
                                                                                        href: ctaLink,
                                                                                        onClick: (e)=>{
                                                                                            (0,HeaderNavTabs_analytics/* servicesAnalyticsClick */.yp)({
                                                                                                text: ctaItem.ctaLabel,
                                                                                                link: ctaItem === null || ctaItem === void 0 ? void 0 : ctaItem.ctaLink,
                                                                                                Leveltwo: selectedTab
                                                                                            });
                                                                                            (0,HeaderNavTabs_utils/* closestAnchorHref */.dV)(e) && e.preventDefault();
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(ctaItem.ctaLabel)
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    tabIndex: "-1",
                                                                                    className: "cta-img",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: darkThemeFlag ? caretimgWhite : caretimg,
                                                                                        alt: "caret-icon"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, "navItem-".concat(index));
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "block-images ".concat(menuType),
                                                                children: [
                                                                    firstImagesblock && firstImageFileReference ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_ImageBlock, {
                                                                        itemType: itemType,
                                                                        menuType: menuType,
                                                                        newTabImage: newTabFirstImage,
                                                                        imageLink: firstImageLink,
                                                                        ctaLabel: firstCtaLabel,
                                                                        selectedTab: selectedTab,
                                                                        imageFileReference: firstImageFileReference,
                                                                        smartCrop: smartCrop,
                                                                        imageAltText: firstImageAltText,
                                                                        imageTitle: firstImageTitle,
                                                                        imageCtaLink: firstImageCtaLink,
                                                                        newTabImageCta: newTabFirstImageCta,
                                                                        darkThemeFlag: darkThemeFlag
                                                                    }) : null,
                                                                    secondImagesblock && secondImageFileReference && (processedNav === null || processedNav === void 0 ? void 0 : processedNav.length) < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_ImageBlock, {
                                                                        itemType: itemType,
                                                                        menuType: menuType,
                                                                        newTabImage: newTabSecondImage,
                                                                        imageLink: secondImageLink,
                                                                        ctaLabel: secondCtaLabel,
                                                                        selectedTab: selectedTab,
                                                                        imageFileReference: secondImageFileReference,
                                                                        smartCrop: smartCrop,
                                                                        imageAltText: secondImageAltText,
                                                                        imageTitle: secondImageTitle,
                                                                        imageCtaLink: secondImageCtaLink,
                                                                        newTabImageCta: newTabSecondImageCta,
                                                                        darkThemeFlag: darkThemeFlag
                                                                    }) : null
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "productbg"
                            })
                        ]
                    })
                })
            })
        })
    }, "navTabs-".concat(navTabIndex));
};
/* harmony default export */ var HeaderNavTabs_TabPanel = (TabPanel);

;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/HeaderNavTabsV3/index.jsx












const HeaderNavTabsV3 = (props)=>{
    const { data , columnClassNames ="" , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>{} , setMainCategory =()=>{}  }  } , wrapperId =""  } = props || {};
    const element = data[":items"];
    const isMobile =  true && window.innerWidth <= 1200;
    const iconCloseMedium = "/icons/close-medium.svg";
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [selectedTab, setSelectedTab] = (0,react.useState)("");
    const [darkThemeFlag, setDarkThemeFlag] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const [selectedId, setSelectedId] = (0,react.useState)(null);
    const [selectedNavTabIndex, setSelectedNavTabIndex] = (0,react.useState)(null);
    const [showTab, setShowTab] = (0,react.useState)(false);
    const { globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general: { navigationHoverTiming =""  } = {}  } = globalConfig;
    let timerout;
    let timerout2;
    const menuVisible = (0,react.useRef)(0);
    const dataRecursion = (0,react.useCallback)((data)=>{
        if (data === null || data === void 0 ? void 0 : data[":itemsOrder"]) {
            var ref;
            data === null || data === void 0 ? void 0 : (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map((key, index)=>{
                const item = element[key];
                return dataRecursion(item);
            });
        }
    }, []);
    const onClickNav = (data, str, navTabIndex)=>{
        if (data) {
            if (selectedTab !== data["cq:panelTitle"]) {
                setSelectedTab(data["cq:panelTitle"]);
            }
            if (navOpen !== data["cq:panelTitle"]) {
                setNavOpen(data["cq:panelTitle"]);
                if (!isMobile) {
                    setNavOpen(data["cq:panelTitle"]);
                }
                setMainCategory({
                    item: data["cq:panelTitle"]
                });
                menuVisible.current = 1;
                (0,helper/* preventBodyScrollTab */.aCP)(true);
                // setSelectedNavTabIndex(null)
                setActiveIndex(null);
                setSelectedId(null);
                if (str === "title click") {
                    setShowTab(true);
                    setSelectedNavTabIndex(navTabIndex);
                }
                isMobile && str === "title click mob" && (0,HeaderNavTabs_analytics/* l1DatalayerclickMobile */.bL)(data["cq:panelTitle"]);
            } else {
                str === "mobile back btn" && (0,HeaderNavTabs_analytics/* backClickForMobile */.Ps)(selectedTab);
                setShowTab(false);
                setNavOpen("");
                setSelectedTab("");
                setMainCategory({
                    item: ""
                });
                menuVisible.current = 0;
                (0,helper/* preventBodyScrollTab */.aCP)(false);
            }
        }
    };
    const handleEnterClickForTab = (e)=>{
        if (e.keyCode === 13) {
            setTimeout(()=>onClickNav(element[e.target.id]), 50);
        }
    };
    const handleAccordionClick = (index, id, navTabIndex)=>{
        setActiveIndex(activeIndex === index && selectedId === id ? null : index);
        setSelectedId(selectedId === id && activeIndex === index ? null : id);
        setSelectedNavTabIndex(selectedNavTabIndex === navTabIndex ? null : navTabIndex);
    };
    const levelOneLengthsArray = [];
    const handleMouseLeave = ()=>{
        setNavOpen("");
        setSelectedTab("");
        setMainCategory({
            item: ""
        });
        menuVisible.current = 0;
        (0,helper/* preventBodyScrollTab */.aCP)(false);
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !isMobile) && menuVisible.current) {
            setNavOpen("");
            setSelectedTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    (0,react.useEffect)(()=>{
        const anchorElements = document.querySelectorAll(".gbh-full-w-menu__inner a:not([href])");
        anchorElements === null || anchorElements === void 0 ? void 0 : anchorElements.forEach((anchor)=>{
            anchor.style.textDecoration = "none";
            anchor.style.cursor = "default";
        });
        if (levelOneLengthsArray[selectedNavTabIndex] !== -1) {
            setActiveIndex(levelOneLengthsArray[selectedNavTabIndex]);
            setSelectedId(levelOneLengthsArray[selectedNavTabIndex]);
        }
    }, []);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        if (document === null || document === void 0 ? void 0 : (ref = document.getElementsByTagName) === null || ref === void 0 ? void 0 : (ref1 = ref.call(document, "body")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.className) === null || ref3 === void 0 ? void 0 : ref3.includes("nav-dark-theme")) {
            setDarkThemeFlag(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    const getInternalLinkURLS = (url)=>{
        if (true) {
            return !((url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "HEADER ID",
        className: (HeaderNavTabs_index_module_default()).headerNavV3Wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "gbh-global-tab", " ").concat(columnClassNames, " ").concat(isOpen ? "open" : ""),
            id: wrapperId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-tabs ".concat(darkThemeFlag ? "dark-theme" : "light-theme"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                        "aria-label": "close button",
                        tabIndex: "0",
                        onClick: ()=>{
                            toggleMenu();
                            isMobile && (0,HeaderNavTabs_analytics/* closeButtonDatalayer */.zw)(selectedTab);
                            onClickNav({
                                "cq:panelTitle": navOpen
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: iconCloseMedium,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        onMouseOver: (event)=>{
                            timerout = setTimeout(()=>{
                                if (!isMobile) {
                                    onClickNav(element[event.target.id]);
                                }
                            }, navigationHoverTiming);
                        },
                        onClick: !isMobile ? (event)=>{
                            onClickNav(element[event.target.id]);
                        } : null,
                        onMouseLeave: ()=>{
                            clearTimeout(timerout);
                            if (!isMobile) handleMouseLeave();
                        },
                        role: "tablist",
                        className: "cmp-tabs__tablist",
                        "aria-multiselectable": "false",
                        children: [
                            data[":itemsOrder"] && data[":itemsOrder"].map((key, navTabIndex)=>{
                                var ref, ref1;
                                const itemType = element[key];
                                const item = ((ref = itemType[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation) || itemType[":items"][(ref1 = Object.keys(itemType[":items"])) === null || ref1 === void 0 ? void 0 : ref1.find((key)=>key.includes("globalnavigation_v3"))];
                                const { firstImagesblock ={} , secondImagesblock ={} , navigationMenuType: menuType = "" , navTitle ="" , levelOneNavMulti =[] , multiCTA =[]  } = item || {};
                                levelOneLengthsArray.push((0,HeaderNavTabs_utils/* checkSingleNonEmptyLevelThreeNavMulti */.JI)(levelOneNavMulti));
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tab-panel-container ".concat((0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(itemType["cq:panelTitle"])),
                                    "aria-expanded": navOpen === itemType["cq:panelTitle"],
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onMouseOver: (event)=>{
                                                timerout2 = setTimeout(()=>{
                                                    if (!isMobile) {
                                                        onClickNav(element[event.target.id], "title click mob");
                                                    }
                                                }, navigationHoverTiming);
                                            },
                                            onMouseLeave: ()=>{
                                                clearTimeout(timerout2);
                                            },
                                            "aria-label": "Tab for ".concat(itemType["cq:panelTitle"], "  ").concat(navOpen === itemType["cq:panelTitle"] ? "expanded" : "collapsed"),
                                            id: key,
                                            onClick: (event)=>onClickNav(element[event.target.id], "title click", navTabIndex),
                                            onFocus: !isMobile ? ()=>{
                                                setNavOpen("");
                                            } : null,
                                            onFocusCapture: !isMobile ? ()=>setNavOpen("") : null,
                                            onKeyDown: (e)=>handleEnterClickForTab(e),
                                            role: "link",
                                            className: "cmp-tabs__tab ".concat(navOpen === itemType["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                            tabIndex: "0",
                                            children: itemType["cq:panelTitle"]
                                        }, "navItem-".concat(navTabIndex)),
                                        !isMobile || isMobile && showTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_TabPanel, {
                                            firstImagesblock: firstImagesblock,
                                            secondImagesblock: secondImagesblock,
                                            itemType: itemType,
                                            staticClasses: constants.staticClasses,
                                            handleMouseLeave: handleMouseLeave,
                                            onClickNav: onClickNav,
                                            navOpen: navOpen,
                                            darkThemeFlag: darkThemeFlag,
                                            menuType: menuType,
                                            selectedTab: selectedTab,
                                            navTitle: navTitle,
                                            levelOneNavMulti: levelOneNavMulti,
                                            activeIndex: activeIndex,
                                            getInternalLinkURLS: getInternalLinkURLS,
                                            multiCTA: multiCTA,
                                            handleAccordionClick: handleAccordionClick,
                                            smartCrop: smartCrop,
                                            navTabIndex: navTabIndex,
                                            levelOneLengthsArray: levelOneLengthsArray,
                                            selectedNavTabIndex: selectedNavTabIndex,
                                            setActiveIndex: setActiveIndex,
                                            setSelectedId: setSelectedId,
                                            selectedId: selectedId
                                        }) : null
                                    ]
                                }, key + navTabIndex);
                            }),
                            (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "tab",
                                    className: "cmp-tabs__tab",
                                    tabIndex: "0",
                                    children: key
                                }, "navItem-".concat(index));
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_UtilityNavHeader, {
                        data: element,
                        toggleMenu: toggleMenu,
                        eventHandler: props === null || props === void 0 ? void 0 : props.eventHandler
                    }) : null
                ]
            })
        })
    });
};
/* harmony default export */ var HeaderNavTabs_HeaderNavTabsV3 = (HeaderNavTabsV3);

;// CONCATENATED MODULE: ./components/Shared/HeaderNav.jsx













const HeaderNav = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data ={} , eventHandler , v3 =false  } = props;
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,genericSlice/* closeMenu */.Wj)()) : dispatch((0,genericSlice/* openMenu */.qn)());
    };
    const [scrollDir, setScrollDir] = (0,react.useState)("scrolling down");
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        const updateScrollDir = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            if (!document.body.classList.contains("gbh-of-scroll")) setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 1;
            ticking = false;
            setLastScrollY(lastScrollY);
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        const onScrollThrottle = throttle_default()(onScroll, 1000);
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout") {
            window.removeEventListener("scroll", onScrollThrottle);
            window.addEventListener("scroll", onScrollThrottle);
        }
        return ()=>window.removeEventListener("scroll", onScrollThrottle);
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (scrollDir === "scrolling down") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "nav-down", "nav-up");
        } else if (scrollDir === "scrolling up") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "nav-up", "nav-down");
        } else return;
    }, [
        scrollDir,
        lastScrollY
    ]);
    (0,react.useEffect)(()=>{
        if (lastScrollY < 200) {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-down");
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-up");
        }
    }, [
        lastScrollY,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames),
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key.includes("image")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavLogo, {
                    v3: v3,
                    data: item,
                    columnClassNames: "".concat(data.columnClassNames[key]),
                    eventHandler: eventHandler,
                    isOpen: isOpen,
                    ariaControls: constants.HEADER_NAV_TABS_WRAPPER_ID
                }, "logo-".concat(index));
            }
            if (key === null || key === void 0 ? void 0 : key.includes("tabs")) {
                if (v3) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_HeaderNavTabsV3, {
                        data: item,
                        columnClassNames: "".concat(data === null || data === void 0 ? void 0 : (ref = data.columnClassNames) === null || ref === void 0 ? void 0 : ref.key),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        wrapperId: constants.HEADER_NAV_TABS_WRAPPER_ID
                    }, "tabs-".concat(index));
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabs, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        wrapperId: constants.HEADER_NAV_TABS_WRAPPER_ID
                    }, "tabs-".concat(index));
                }
            }
            if (key === null || key === void 0 ? void 0 : key.includes("utilitywidgets")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        eventHandler: eventHandler
                    }) : null
                }, "utilitywidgets-".concat(index));
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_HeaderNav = (HeaderNav);

;// CONCATENATED MODULE: ./components/Default/Video/videoAnalytics.js


let analyticsTimer;
const pushClickEvent = (eventInfo)=>{
    var ref, ref1, ref2;
    const page = ((ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.getState) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "page")) || {};
    if (isEmpty_default()(page)) {
        analyticsTimer = setTimeout(()=>pushClickEvent(eventInfo), 500);
        return;
    }
    if (analyticsTimer) {
        clearTimeout(analyticsTimer);
    }
    Object.keys(eventInfo).forEach((key)=>{
        if (eventInfo[key].includes(":rm")) {
            let _eventInfo$key;
            eventInfo[key] = (_eventInfo$key = eventInfo[key]) === null || _eventInfo$key === void 0 ? void 0 : _eventInfo$key.replace(/:rm/g, "");
        }
    });
    // const { productInfo: tempInfo } = page
    if ((page === null || page === void 0 ? void 0 : (ref2 = page.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.pageId) === "home") {
        delete page.productInfo;
    }
    if (eventInfo) {
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo: eventInfo,
            page: page
        });
    }
};
const getComponentZone = (element)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className === "cmp-container");
    const zoneName = container === null || container === void 0 ? void 0 : container.getAttribute("id");
    if (zoneName) {
        return zoneName.toLowerCase().replaceAll("-", " ");
    } else {
        return "";
    }
};
const shareVideoDatalayer = (eventPageType, componentZone, componentLinkType, videoTitle)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventTypeTittle = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
    const eventtitle = eventTypeTittle === "locations" ? "location:kohler stores" : eventPageType;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        eventMsg: "n/a",
        eventName: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "share",
        internalLinkPosition: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase()),
        internalLinkType: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":").concat(videoTitle)
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const playVideoDatalayer = (element, video, setFavVideoIdCb, videoModalClose)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className.includes("cmp-teaser__image"));
    const nearestDatalayerAttribute = container === null || container === void 0 ? void 0 : container.getAttribute("data-gbh-data-layer");
    const videoIdAttribute = video;
    const jsonObject = nearestDatalayerAttribute ? JSON.parse(nearestDatalayerAttribute === null || nearestDatalayerAttribute === void 0 ? void 0 : nearestDatalayerAttribute.replaceAll(/(\r\n|\n|\r)/gm, "")) : {};
    if ((page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType) === "locations") {
        const pageType = "locations:kohler stores";
        jsonObject["internalLinkZoneName"] = pageType + ":" + getComponentZone(element);
        jsonObject["eventName"] = pageType + ":" + getComponentZone(element);
        jsonObject["internalLinkType"] = pageType + ":" + getComponentZone(element);
        jsonObject["internalLinkPosition"] = pageType + ":" + "teaser";
    } else {
        jsonObject["eventMsg"] = "n/a";
        jsonObject["eventStatus"] = "n/a";
        jsonObject["internalLinkZoneName"] = window.eventPageType + ":" + getComponentZone(element);
        jsonObject["eventName"] = jsonObject["eventName"].replaceAll("zoneForVideo", getComponentZone(element));
    }
    // splitting video id from URL
    const splitVideoId = decodeURI(videoIdAttribute).split("PAWEB/")[1];
    if (videoIdAttribute && undefined !== splitVideoId && null !== splitVideoId) {
        jsonObject["videoId"] = splitVideoId.toLowerCase();
        const favVideoId = splitVideoId.toLowerCase();
        setFavVideoIdCb && setFavVideoIdCb(favVideoId);
    }
    // condition to check when the video ends
    if (videoModalClose) {
        const { eventName =""  } = jsonObject;
        const closeEvent = "".concat(eventName, ":close");
        const videoJsonObject = {
            ...jsonObject,
            eventAction: closeEvent,
            eventName: closeEvent,
            internalLinkName: "close"
        };
        pushClickEvent(videoJsonObject);
    } else {
        jsonObject["eventName"] = jsonObject["eventAction"] = jsonObject["eventName"] + ":" + "video play";
        pushClickEvent(jsonObject);
    }
};
const getVideoFullScreenEventInfo = (eventPageType, videoName, videoId, componentPosition, enter)=>{
    return {
        clickInternalLinks: "true",
        eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName, ":full screen"),
        eventMsg: "n/a",
        eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName, ":full screen"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "full screen".concat(enter === "fullscreenEnter" ? "" : " minimize"),
        internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
        internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName),
        videoId: videoId,
        videoName: videoName
    };
};
const addVideoFullScreenDatalayer = (enter, eventPageType, videoName, videoId, componentPosition)=>{
    var ref;
    const eventInfo = getVideoFullScreenEventInfo(eventPageType, videoName, videoId, componentPosition, enter);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    // const { productInfo: tempInfo } = page
    if ((page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageId) === "home") {
        delete page.productInfo;
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./hooks/useScreenOrientation.js



/**
 *
 * @return {String}
 */ const useScreenOrientation = ()=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [orientation, setOrientation] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const getOrientation = ()=>{
            var ref, ref1;
            return (ref = window.screen) === null || ref === void 0 ? void 0 : (ref1 = ref.orientation) === null || ref1 === void 0 ? void 0 : ref1.type;
        };
        setOrientation(getOrientation());
        const updateOrientation = debounce_default()(()=>{
            setOrientation(getOrientation());
        }, 300);
        if (!isSsr) {
            window.addEventListener("resize", updateOrientation);
        }
        return ()=>{
            window.removeEventListener("resize", updateOrientation);
        };
    }, [
        isSsr
    ]);
    return orientation;
};
/* harmony default export */ var hooks_useScreenOrientation = (useScreenOrientation);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/analytics.js




const getEventInfo = function() {
    let pageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", mainTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", eventType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", zone = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", parseJson = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    const zoneName = zone ? zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ") : "zone";
    let internalLinkType = "";
    if (eventLabel === "print") {
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":print");
    } else {
        internalLinkType = "".concat(dataLayerLinkType);
    }
    const internalLinkZoneName = zone ? "".concat(pageType.toLowerCase(), ":").concat(zoneName) : "teaser";
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
        internalLinkZoneName,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(eventLabel),
        eventName: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share")),
        internalLinkType: internalLinkType,
        eventType: eventType,
        eventAction: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share"))
    };
    if (parseJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addDatalayerShare = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{}", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const page = window.pageObj || {};
    const eventInfo = JSON.parse(data);
    const dataLayerObj = {
        event: "cmp:click",
        page,
        eventInfo
    };
    if (isPdp) {
        const { productInfo  } = page;
        dataLayerObj["productInfo"] = productInfo;
    }
    window.adobeDataLayer.push(dataLayerObj);
};
const getDownloadEventInfo = function() {
    let downLoadLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    let eventInfo = {};
    if (downLoadLink) {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "".concat(downLoadLink),
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":download"),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    } else {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "n/a",
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(dataLayerLinkType),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    }
    return JSON.stringify(eventInfo);
};
const getTitleEventInfo = function() {
    let linkNewTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", componentLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", title = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    return '{"clickInternalLinks":"'.concat(linkNewTab || mainTitle.toLowerCase().includes("kohler canada") ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL || (0,helper/* getLinkFromHref */.OWN)(title), '","internalLinkName":"').concat(mainTitle.toLowerCase(), '","eventName":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '"}');
};
const addTeaserActionAnalytics = (param)=>{
    let { pageType ="" , componentPosition ="" , videoTitle ="" , link ="" , text ="" , eventName: eventNameDatalayer , dataLayerLinkType ="" , eventAction: eventActionDataLayer , productCategory ="" , productCollectionsName ="" , productRoom ="" , datalayerPageType ="" , mainTitle ="" , componentInfo =""  } = param;
    const eventTitle = (0,helper/* makingTextDatalayerReady */.S$e)(mainTitle);
    let internalLinkZoneName;
    let internalLinkName;
    const eventPageType = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
    const linkText = text === null || text === void 0 ? void 0 : text.toLowerCase();
    let eventAction = eventPageType ? "".concat(eventPageType, ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || eventTitle || "zone", ":").concat(linkText) : "".concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || eventTitle || "zone", ":").concat(linkText);
    let eventName = eventAction;
    if (videoTitle || eventPageType === "plp") {
        eventAction = "".concat(eventPageType, ":").concat(videoTitle, ":").concat(linkText);
        eventName = "".concat(eventPageType, ":").concat(videoTitle, ":").concat(linkText);
        internalLinkZoneName = "".concat(eventPageType, ":").concat(videoTitle);
    } else if (eventTitle) {
        internalLinkZoneName = "".concat(eventPageType, ":").concat(eventTitle);
    } else {
        internalLinkZoneName = "teaser";
    }
    let internalLinkPosition = eventPageType ? "".concat(eventPageType, ":").concat(componentPosition || "teaser") : componentPosition || "teaser";
    let internalLinkType = videoTitle.replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, "") ? "".concat("".concat(eventPageType, ":").concat(videoTitle.replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, ""))) : eventPageType ? "".concat(eventPageType, ":").concat(eventTitle) : "navigation";
    if (dataLayerLinkType.includes("social impact")) {
        eventName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")));
    }
    let eventType = "navigation";
    if (datalayerPageType.includes("locations")) {
        pageType = "locations:kohler stores";
        eventName = "".concat(eventPageType, ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(linkText);
        internalLinkZoneName = eventPageType;
        internalLinkPosition = "".concat(eventPageType, ":teaser");
        internalLinkType = "".concat(eventPageType, ":").concat(eventTitle);
    }
    const page = window.pageObj || {};
    if (text === "Apply Now" && eventActionDataLayer === null && eventPageType === "friends and family program") {
        eventAction = "".concat(constants.FRIENDS_AND_FAMILY_PROGRAM, ":").concat(constants.KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP, ":").concat(linkText);
        eventName = "".concat(constants.FRIENDS_AND_FAMILY_PROGRAM, ":").concat(constants.KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP, ":").concat(linkText);
        eventType = "teaser";
        internalLinkPosition = "".concat(constants.FRIENDS_AND_FAMILY_PROGRAM, ":teaser");
        internalLinkType = "".concat(constants.FRIENDS_AND_FAMILY_PROGRAM, ":").concat(constants.KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP);
        internalLinkZoneName = "".concat(constants.FRIENDS_AND_FAMILY_PROGRAM, ":").concat(constants.KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP);
        internalLinkName = linkText;
    } else if (text === "Apply Now" && eventActionDataLayer === null) {
        var ref, ref1;
        const datalayerPageType1 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
        const NewDatalayerPageType = datalayerPageType1 === "services" ? page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.subCategoryID : datalayerPageType1;
        eventAction = linkText;
        eventName = linkText;
        eventType = "promo banner";
        internalLinkPosition = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo banner");
        internalLinkType = eventPageType ? "".concat(eventPageType, ":").concat(eventTitle) : "navigation";
        internalLinkZoneName = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo details");
    } else if (text === constants.BUYING_GUIDE) {
        eventName = "".concat(eventPageType, ":").concat(constants.HERO_BANNER, ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(constants.HERO_BANNER, ":").concat(linkText);
        internalLinkName = "".concat(constants.BUYING_GUIDE.toLowerCase());
        internalLinkZoneName = "".concat(eventPageType, ":").concat(constants.HERO_BANNER);
    }
    if ((linkText === constants.BROWSE_ALL_KOHLER_STORES || text === constants.MORE_OPTIONS.LEARN_MORE) && datalayerPageType === "locations") {
        pageType = "".concat(constants.FIND_A_STORE, ":").concat(constants.PAGE_TYPES.LOCATION_LANDING_PAGE);
        eventName = "".concat(pageType, ":").concat(linkText);
        eventAction = "".concat(pageType, ":").concat(linkText);
        internalLinkPosition = constants.FIND_A_STORE;
        internalLinkType = "".concat(constants.FIND_A_STORE, ":").concat(text === constants.MORE_OPTIONS.LEARN_MORE && eventTitle || eventType);
        internalLinkZoneName = "".concat(pageType).concat(text === constants.MORE_OPTIONS.LEARN_MORE && ":" + eventTitle || "");
    }
    if (eventPageType === constants.HOW_TO_BECOME_A_KPN) {
        eventName = "".concat(eventPageType, ":").concat(text === constants.JOIN_NOW ? constants.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(text === constants.JOIN_NOW ? constants.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), ":").concat(linkText);
        internalLinkZoneName = "".concat(eventPageType, ":").concat(text === constants.JOIN_NOW ? constants.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase());
        eventType = "teaser";
        internalLinkPosition = "".concat(eventPageType, ":teaser");
    }
    if (window.eventPageType === "pdp" && text === "Shop Farmstead") {
        var ref2, ref3;
        eventName = "".concat((ref2 = window.eventPageType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), ":farmstead sink:").concat(linkText);
        eventAction = "".concat((ref3 = window.eventPageType) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), ":farmstead sink:").concat(linkText);
        eventType = "navigation";
        internalLinkPosition = "pdp:".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase());
        internalLinkType = "pdp:".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase());
        internalLinkZoneName = constants.PDP_DETAILS;
    }
    if (mainTitle === constants.GIFT_DESIGN) {
        eventType = constants.COMPONENT_TYPES.TEASER;
        internalLinkType = "".concat(eventPageType, ":").concat(constants.KOHLER_BATHROOM_DESIGN);
    }
    const eventInfo = {
        clickInternalLinks: (link === null || link === void 0 ? void 0 : link.startsWith("/")) || (link === null || link === void 0 ? void 0 : link.startsWith("#")) || (link === null || link === void 0 ? void 0 : link.includes(window.location.hostname)) ? "true" : "false",
        internalLinkPosition,
        internalLinkZoneName,
        internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(link)) : "n/a",
        internalLinkName: internalLinkName || "".concat(!text ? "explore more arrow" : linkText),
        eventName,
        internalLinkType,
        eventType,
        eventAction,
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const customDataLayer = {
        ...componentInfo ? {
            componentInfo: JSON.parse(componentInfo)
        } : {},
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click", {}, customDataLayer);
};
const addTeaserDescriptionAnalytic = function() {
    let target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isPlp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", pageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", internalLinkPositionNotPdp = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", preTitle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", mainTitle = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", linkURL = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", internalLinkTypeNotPdp = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "", sanitizeDescription = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "";
    return JSON.stringify({
        clickInternalLinks: target === "_blank" ? "false" : "true",
        internalLinkPosition: isPdp || isPlp ? pageType.toLowerCase() : internalLinkPositionNotPdp,
        internalLinkZoneName: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : mainTitle ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(mainTitle) : "teaser",
        internalLinkURL: linkURL,
        eventName: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : "".concat(pageType.toLowerCase(), ":").concat(mainTitle, ":").concat(sanitizeDescription),
        internalLinkType: isPdp ? "".concat(pageType.toLowerCase(), ":teaser") : isPlp ? "".concat(pageType.toLowerCase(), ":navigation") : internalLinkTypeNotPdp,
        eventType: isPdp || isPlp ? "navigation" : "teaser",
        internalLinkName: sanitizeDescription,
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventAction: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : "".concat(pageType.toLowerCase(), ":").concat(mainTitle, ":").concat(sanitizeDescription)
    });
};
const addTeaserAnalytic = function(e) {
    let linkNewTab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", linkURL = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", mainTitle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", pageType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", componentLinkType = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", title = arguments.length > 7 ? arguments[7] : void 0, datalayerLinkName = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "", containerIdName = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "", eventName = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : "", eventAction = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : "";
    e.preventDefault();
    return '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(datalayerLinkName, '","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventName || datalayerLinkName || "rm", '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType || mainTitle, '","eventType":"teaser","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventAction || datalayerLinkName || "rm", '"}');
};
const addTeaserLinkAnalytics = (teaserFullData, link, bodytitle, containerId, data, datalayerPageName, linkURL)=>{
    const { datalayerLinkName , fullData , mainTitle , eventAction , eventName , linkNewTab  } = data;
    const { teaser: { pretitle: teaserPretitle = "" , mainTitle: teaserMainTitle = ""  } = {}  } = teaserFullData || {};
    const page = window.pageObj || {};
    const { pageInfo: { pageUrl  } , productInfo  } = page;
    const pageType = window.eventPageType;
    const internalLinkName = (0,utils/* sanitizedTextAndEntities */.wq)(datalayerLinkName);
    if (pageType === "pdp") {
        var ref, ref1, ref2, ref3, ref4;
        const eventInfo = {
            eventAction: "pdp:".concat((fullData === null || fullData === void 0 ? void 0 : (ref = fullData.teaser) === null || ref === void 0 ? void 0 : ref.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref1 = fullData.teaser) === null || ref1 === void 0 ? void 0 : ref1.mainTitle : "product details", ":").concat((0,utils/* sanitizedTextAndEntities */.wq)(eventAction || mainTitle).toLowerCase().trim()),
            eventName: "pdp:".concat((fullData === null || fullData === void 0 ? void 0 : (ref2 = fullData.teaser) === null || ref2 === void 0 ? void 0 : ref2.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref3 = fullData.teaser) === null || ref3 === void 0 ? void 0 : ref3.mainTitle : "product details", ":").concat((0,utils/* sanitizedTextAndEntities */.wq)(eventName || mainTitle).toLowerCase().trim()),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:teaser",
            internalLinkZoneName: "pdp:".concat((0,utils/* sanitizedTextAndEntities */.wq)((fullData === null || fullData === void 0 ? void 0 : (ref4 = fullData.teaser) === null || ref4 === void 0 ? void 0 : ref4.mainTitle) || bodytitle).toLowerCase().trim()),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj = {
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        };
        window.adobeDataLayer.push(dataLayerObj);
    } else if (pageType === constants.INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR) {
        var ref5, ref6, ref7, ref8, ref9;
        const eventInfo1 = {
            eventAction: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref5 = fullData.teaser) === null || ref5 === void 0 ? void 0 : ref5.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref6 = fullData.teaser) === null || ref6 === void 0 ? void 0 : ref6.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle),
            eventName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref7 = fullData.teaser) === null || ref7 === void 0 ? void 0 : ref7.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref8 = fullData.teaser) === null || ref8 === void 0 ? void 0 : ref8.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventName || mainTitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(containerId.replaceAll("-", " ")),
            internalLinkZoneName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref9 = fullData.teaser) === null || ref9 === void 0 ? void 0 : ref9.mainTitle) || containerId.replaceAll("-", " ")),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj1 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo1
        };
        window.adobeDataLayer.push(dataLayerObj1);
    } else if (pageType === "home with shea mcgee") {
        const linkPosition = datalayerPageName.split(":")[0];
        const eventInfo2 = {
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
            internalLinkPosition: linkPosition,
            eventMsg: "n/a",
            internalLinkZoneName: "".concat(pageType, ":").concat(linkURL),
            internalLinkURL: "".concat(linkURL),
            internalLinkName: mainTitle,
            internalLinkType: "".concat(linkPosition, ":").concat(pageType),
            eventType: "navigation",
            eventAction: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle),
            eventName: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle)
        };
        const dataLayerObj2 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo2
        };
        window.adobeDataLayer.push(dataLayerObj2);
    } else if ((pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()) === constants.INSPIRATION_PAGE_NAME.PROJECT_GALLERY) {
        addProjectGalleryAnalytics(linkNewTab, pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), linkURL === null || linkURL === void 0 ? void 0 : linkURL.toLowerCase(), link, mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), teaserPretitle === null || teaserPretitle === void 0 ? void 0 : teaserPretitle.toLowerCase());
    } else if (pageType === "plp") {
        var ref10;
        const preTitle = (ref10 = document.querySelector(".cmp-teaser__pretitle p")) === null || ref10 === void 0 ? void 0 : ref10.textContent.toLowerCase();
        const eventInfo3 = {
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
            internalLinkPosition: pageType,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkZoneName: "".concat(pageType, ":").concat(linkURL),
            internalLinkURL: "".concat(window.location.origin).concat(link),
            internalLinkName: mainTitle,
            internalLinkType: "".concat(pageType, ":").concat(preTitle, ":").concat(linkURL),
            eventType: "carousel",
            eventAction: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle),
            eventName: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle)
        };
        const dataLayerObj3 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo3
        };
        window.adobeDataLayer.push(dataLayerObj3);
    } else if (pageType.toLowerCase().includes("my account")) {
        var ref11, ref12, ref13;
        const eventNameAction = "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref11 = fullData.teaser) === null || ref11 === void 0 ? void 0 : ref11.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref12 = fullData.teaser) === null || ref12 === void 0 ? void 0 : ref12.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle);
        const eventInfo4 = {
            eventAction: eventNameAction.replace(regex/* QUOT_REGEX */.RR, ""),
            eventName: eventNameAction.replace(regex/* QUOT_REGEX */.RR, ""),
            eventType: "teaser",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName).replace(regex/* QUOT_REGEX */.RR, ""),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(containerId.replaceAll("-", " ")),
            internalLinkZoneName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref13 = fullData.teaser) === null || ref13 === void 0 ? void 0 : ref13.mainTitle) || containerId.replaceAll("-", " ")),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj4 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo4
        };
        window.adobeDataLayer.push(dataLayerObj4);
    } else {
        const eventNameAction1 = "".concat(pageType, ":").concat(teaserMainTitle ? teaserMainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle);
        const internalLinkTypeAction = " ".concat(teaserMainTitle ? teaserMainTitle : containerId.replaceAll("-", " "));
        const eventInfo5 = {
            eventAction: eventNameAction1.replace(regex/* QUOT_REGEX */.RR, ""),
            eventName: eventNameAction1.replace(regex/* QUOT_REGEX */.RR, ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName).replace(regex/* QUOT_REGEX */.RR, ""),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(internalLinkTypeAction),
            internalLinkZoneName: "".concat(pageType, ":").concat(internalLinkTypeAction),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj5 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo5
        };
        window.adobeDataLayer.push(dataLayerObj5);
    }
};
const addProjectGalleryAnalytics = (linkNewTab, page, teaserTitle, linkUrl, mainTitle, teaserPretitle)=>{
    const title = (0,helper/* makingTextDatalayerReady */.S$e)(mainTitle);
    const eventInfo = {
        clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
        internalLinkPosition: "".concat(page, ":teaser"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkZoneName: "".concat(page, ":").concat(teaserPretitle || teaserTitle),
        internalLinkURL: "".concat(window.location.origin).concat(linkUrl),
        internalLinkName: title,
        internalLinkType: "".concat(page, ":").concat(teaserTitle),
        eventType: "navigation",
        eventAction: "".concat(page, ":").concat(teaserPretitle || teaserTitle, ":").concat(title),
        eventName: "".concat(page, ":").concat(teaserPretitle || teaserTitle, ":").concat(title)
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
};
const getCaptionLinkEventInfo = (pageType, linkTextToMatch, link)=>{
    if (linkTextToMatch === null || linkTextToMatch === void 0 ? void 0 : linkTextToMatch.toLowerCase().includes(constants.SHOP_THE_LOOK)) {
        return {
            clickInternalLinks: "true",
            eventAction: "".concat(pageType, ":shop by category:").concat(constants.SHOP_THE_LOOK),
            eventMsg: "n/a",
            eventName: "".concat(pageType, ":shop by category:").concat(constants.SHOP_THE_LOOK),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: constants.SHOP_THE_LOOK,
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":shop by category"),
            internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(link)) : "n/a",
            internalLinkZoneName: "".concat(pageType, ":shop by category")
        };
    }
    return {};
};

// EXTERNAL MODULE: ./context/CLPConfigContext.jsx
var CLPConfigContext = __webpack_require__(31895);
;// CONCATENATED MODULE: ./hooks/useConfig.js


const useConfig = ()=>{
    const context = (0,react.useContext)(CLPConfigContext/* ConfigContext */.E);
    if (context === null || context === undefined) {
        console.warn("ConfigContext is null or undefined");
        return {};
    }
    return context;
};

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Action.jsx












const Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , activeIndex =0 , setActive =()=>"" , item , bannerIndex =-1  } = props;
    const { scroll , findAPro , installationServices  } = constants.DEFAULT_SCROLL;
    const generalConfigData = useConfig();
    const shortLink = (0,helper/* getShortenedUrlwithGeneral */.vu1)(link, generalConfigData);
    const [general, setGeneral] = (0,react.useState)(generalConfigData);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageType: datalayerPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [actionLink, setActionLink] = (0,react.useState)(shortLink);
    const [target, setTarget] = (0,react.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (isEmpty_default()(generalConfigData)) {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                setGeneral(config === null || config === void 0 ? void 0 : config.general);
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(link) && !isEmpty_default()(general)) {
            const actLink = (0,helper/* getShortenedUrlwithGeneral */.vu1)(link, general);
            setActionLink(actLink);
        }
    }, [
        link,
        general
    ]);
    (0,react.useEffect)(()=>{
        if (!general) return;
        const hash = window.location.hash;
        if (!hash) return;
        const timeoutId = setTimeout(()=>{
            exploreMoreScroll(hash);
        }, 300);
        return ()=>clearTimeout(timeoutId);
    }, [
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType === "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    /**
   * Handles click events for action links within the Teaser component.
   *
   * - Handles hash links (e.g., `#section`) using Next.js shallow routing to prevent page refresh.
   * - Handles special KPN hash links (e.g., `#KPN::url`) for authentication flows and dispatches related actions.
   * - Sets the active teaser index and component info for UI state.
   * - Triggers login if the user is not authenticated and is on the "My Account" page.
   * - Calls `handleOnLinkClick` for non-hash links or specific hash links.
   * - Sends analytics data for the teaser action.
   *
   * @param {React.MouseEvent} event - The click event triggered by the user.
   */ const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        // Handle hash links to prevent page refresh
        if ((actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#")) && event.target.text !== constants.MORE_OPTIONS.WATCH_VIDEO && !(actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) && !(actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith(constants.SIGNUP_HASH))) {
            // Update URL using Next.js router (shallow routing)
            router.push("".concat(window.location.pathname).concat(actionLink), undefined, {
                shallow: true
            });
            exploreMoreScroll(event);
        }
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            event.stopPropagation();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,authSlice/* setHideCustomerSignupCTA */.n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,helper/* isAuthenticated */.$8e)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,helper/* isAuthenticated */.$8e)(url, 1, true);
                } else {
                    (0,helper/* isAuthenticated */.$8e)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        const componentInfo = event.target.getAttribute("data-gbh-component");
        setActive(currentIndex);
        if (router.pathname.includes(constants.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else if ((actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#")) && Object.values(constants.MORE_OPTIONS).includes(event.target.text)) {
            handleOnLinkClick(event);
        } else if (!(actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#"))) {
            // Only call handleOnLinkClick for non-hash links
            handleOnLinkClick(event);
        }
        addTeaserActionAnalytics({
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            mainTitle,
            componentInfo
        });
    };
    const exploreMoreScroll = (e)=>{
        let hash;
        if (typeof e === "string") {
            hash = e;
        } else if (e === null || e === void 0 ? void 0 : e.preventDefault) {
            e.preventDefault();
            hash = e.target.hash || e.target.getAttribute("href");
        }
        if (!hash || hash === "#") return;
        const element = document === null || document === void 0 ? void 0 : document.querySelector(hash);
        if (!element) {
            console.warn('Element with selector "'.concat(hash, '" not found'));
            return;
        }
        const offsetTop = (0,helper/* getOffsetTop */.oJS)(element) - (hash === constants.FIND_A_PRO_HASH ? findAPro : hash === constants.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const getComponentMessage = function() {
        let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (message && bannerIndex > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(bannerIndex + 1);
            return JSON.stringify(obj);
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            role: actionLink ? "link" : "button",
            "aria-describedby": id,
            href: actionLink,
            "aria-label": "".concat(text, " related to ").concat(mainTitle),
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: handleOnClick,
            "data-index": index,
            "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos),
            children: text
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType === "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ var v1_Action = (Action);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Description.jsx






const Description = (props)=>{
    const { linkURL ="" , linkURLRef ="" , linkNewTab ="" , description ="" , mainTitle ="" , componentPosition =null , componentLinkType =null , pageType: serverPageType = "" , linkDescription =false , general ={} , expandText ="" , collapseText ="" , disableExpandCollapse ="" , preTitle =""  } = props;
    const [shortenedLinkUrl, setShortenedLinkUrl] = (0,react.useState)("");
    const [pageType, setPageType] = (0,react.useState)(serverPageType);
    const [target, setTarget] = (0,react.useState)("");
    const [details, setDetails] = (0,react.useState)(description);
    const [isPdp, setIsPdp] = (0,react.useState)("");
    const [linkText, setLinkText] = (0,react.useState)("");
    const [productInfo, setProductInfo] = (0,react.useState)(null);
    const isPlp = pageType === "plp";
    const containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        window.expandText = expandText;
        window.collapseText = collapseText;
        window.disableExpandCollapse = disableExpandCollapse;
    }, [
        expandText,
        collapseText,
        disableExpandCollapse
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
        if (serverPageType !== (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp") {
            var ref3;
            setPageType(pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref3 = pageInfoDetails.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.contentType);
            setIsPdp(true);
        }
        if (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : pageInfoDetails.productInfo) {
            setProductInfo(pageInfoDetails.productInfo);
        }
    }, []);
    const internalLinkPositionNotPdp = "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser");
    const internalLinkTypeNotPdp = "".concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase());
    let sanitizeDescription = (0,helper/* sanitizeTextArticle */.pkm)(description).toLowerCase();
    (0,react.useEffect)(()=>{
        if (linkURL) {
            const short = !isEmpty_default()(general) ? (0,helper/* getShortenedUrlwithGeneral */.vu1)(linkURL, general) : linkURL;
            setShortenedLinkUrl(short || linkURL);
        }
        if (description) {
            const shortDetails = !isEmpty_default()(general) ? (0,helper/* getShortenedUrlwithGeneral */.vu1)(description, general) : description;
            setDetails(shortDetails || description);
        }
    }, [
        linkURL,
        description,
        general
    ]);
    (0,react.useEffect)(()=>{
        // pointerdown runs before click handlers in other scripts; use it to set the data attribute
        const handlePointerDown = (e)=>{
            const targetEl = e.target;
            if (targetEl && targetEl.tagName === "A") {
                const text = targetEl.textContent || "";
                const sanitizeDesc = text ? text.toLowerCase() : (targetEl.getAttribute("href") || "").toLowerCase();
                try {
                    const eventInfo = addTeaserDescriptionAnalytic(targetEl.getAttribute("target") || "", isPdp, isPlp, pageType, internalLinkPositionNotPdp, preTitle, mainTitle, linkURL, internalLinkTypeNotPdp, sanitizeDesc, text);
                    try {
                        const outer = containerRef.current && containerRef.current.closest ? containerRef.current.closest(".cmp-teaser__description") : null;
                        if (outer) outer.setAttribute("data-gbh-data-layer", eventInfo);
                    } catch (err) {
                    /* ignore DOM failures */ }
                } catch (err1) {
                    console.warn("Description: failed to build per-click analytics", err1);
                }
            }
        };
        const handleClick = (e)=>{
            const targetEl = e.target;
            if (targetEl && targetEl.tagName === "A") {
                setLinkText(targetEl.textContent || "");
            }
        };
        const container = containerRef.current;
        if (container) {
            container.addEventListener("pointerdown", handlePointerDown);
            container.addEventListener("click", handleClick);
        }
        return ()=>{
            if (container) {
                container.removeEventListener("pointerdown", handlePointerDown);
                container.removeEventListener("click", handleClick);
            }
        };
    }, []);
    sanitizeDescription = details.includes("href") ? linkText.toLowerCase() : sanitizeDescription;
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (linkNewTab) {
            setTarget("_blank");
        } else {
            setTarget("_self");
        }
    }, [
        linkNewTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__description",
        ...productInfo && {
            "data-gbh-data-layer-custom": JSON.stringify({
                productInfo
            })
        },
        "data-gbh-data-layer": addTeaserDescriptionAnalytic(target, isPdp, isPlp, pageType, internalLinkPositionNotPdp, preTitle, mainTitle, linkURL, internalLinkTypeNotPdp, sanitizeDescription),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: linkDescription,
            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: shortenedLinkUrl,
                    rel: linkURLRef ? "noreferrer" : "",
                    target: target,
                    children: children
                }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: containerRef,
                children: (0,helper/* sanitizeInnerHtml */.KD0)(details)
            })
        })
    });
};
/* harmony default export */ var v1_Description = (Description);

;// CONCATENATED MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react.useState(null);
  const callback = react.useRef(onChange);
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react.useRef(void 0);
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./utils/videoHelper.js



const onVolumeChange = (ref)=>{
    if (ref) {
        const { muted , volume  } = ref;
        if (volume === 0 && muted) {
            ref.setAttribute("volume", 1);
            ref.setAttribute("muted", false);
        }
    }
};
// will not work as the element is stacked behind. existing code also have same behavior
const onClickHeroVideo = (event, ref)=>{
    event.preventDefault();
    (ref === null || ref === void 0 ? void 0 : ref.paused) ? ref === null || ref === void 0 ? void 0 : ref.play() : ref === null || ref === void 0 ? void 0 : ref.pause();
};
const onVideoInteraction = (action, cbVideoPlayed, cbVideoPlaying, ref, video, autoPlay, setFavVideoIdCb, flagState)=>{
    cbVideoPlayed();
    if (action === constants.VIDEO_EVENTS.PLAY) {
        cbVideoPlaying(true);
        if (!autoPlay && !(flagState === null || flagState === void 0 ? void 0 : flagState.flag100)) {
            playVideoDatalayer(ref, video, setFavVideoIdCb);
        }
    }
    if (action === constants.VIDEO_EVENTS.PAUSE) {
        cbVideoPlaying(false);
    }
    if (action === constants.VIDEO_EVENTS.ENDED) {
        if (!autoPlay && !(flagState === null || flagState === void 0 ? void 0 : flagState.flag100)) {
            playVideoDatalayer(ref, video, setFavVideoIdCb);
        }
        ref.play();
    }
};
const onPlayVideoInModal = (event, pageType, videoContainerRef, videoRef)=>{
    if (pageType === "modalWindow") {
        var ref;
        event.preventDefault();
        if (videoContainerRef && !(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.classList) === null || ref === void 0 ? void 0 : ref.contains("open-video-module"))) {
            videoContainerRef.classList.add("open-video-module");
            document.body.classList.add("modal-open");
            videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
        }
    }
};
const onPlayVideo = function() {
    let videoRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbackFunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{}, videoDesktopPoster = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", videoMobilePoster = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", video = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isVideoPlaying = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
    } else {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    }
    if (video) {
        const callbackResponse = (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) ? true : false;
        callbackFunction && callbackFunction(callbackResponse);
    } else if (videoDesktopPoster || videoMobilePoster) {
        const callbackResponse1 = !isVideoPlaying;
        callbackFunction && callbackFunction(callbackResponse1);
    }
};
const onVideoPopupClose = (videoContainerRef, videoRef, video)=>{
    videoContainerRef.classList.remove("open-video-module");
    document.body.classList.remove("modal-open");
    videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    playVideoDatalayer(videoRef, video, null, true);
};
const onShareVideo = (e, shareVideoCallback, eventPageType, componentZone, componentLinkType, videoTitle)=>{
    shareVideoCallback && shareVideoCallback();
    if (window.shareSrcElement === undefined || window.shareSrcElement === null) {
        window.shareSrcElement = e.target.children[0];
    }
    shareVideoDatalayer(eventPageType, componentZone, componentLinkType, videoTitle);
};
const onFavVideo = function(event) {
    let asset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", caption = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoname = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", favVideoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", favRef = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, toasterContent = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
    const { successMessage ="" , unfavoriteSuccessMessage =""  } = toasterContent;
    let _$$closest;
    const id = event.target.getAttribute("data-id");
    const sharedZoneName = (_$$closest = $(void 0).closest(".cmp-container")) === null || _$$closest === void 0 ? void 0 : _$$closest.attr("id");
    if (id) {
        (0,helper/* removeFavorites */.NgF)([
            id
        ], favRef, unfavoriteSuccessMessage);
    } else {
        const assetUrl = asset;
        let _assetUrl;
        const url1 = (_assetUrl = assetUrl) !== null && _assetUrl !== void 0 && _assetUrl.startsWith("/") ? window.location.origin + assetUrl : assetUrl;
        (0,helper/* addMediaToFavorites */.iZV)("video", title, url1, successMessage, "", caption, sharedZoneName, videoname, favVideoId);
    }
};
const onPlayInspireVideo = function() {
    let inpageVideo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, inspireVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeBtnRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, addVideoDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    addVideoDataLayer("videoClick");
    addVideoDataLayer("videoPlay");
    inpageVideo === null || inpageVideo === void 0 ? void 0 : inpageVideo.pause();
    document.body.classList.add("modal-open");
    inspireVideo.style.display = "block";
    inspireVideo === null || inspireVideo === void 0 ? void 0 : inspireVideo.play();
    inspireVideo.muted = false;
    closeBtnRef.style.display = "block";
};
const onPlayInspireVideoClose = function() {
    let inpageVideo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, inspireVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeBtnRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, addVideoDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    addVideoDataLayer("videoClose");
    inspireVideo === null || inspireVideo === void 0 ? void 0 : inspireVideo.pause();
    document.body.classList.remove("modal-open");
    inspireVideo.muted = true;
    inspireVideo.style.display = "none";
    inpageVideo === null || inpageVideo === void 0 ? void 0 : inpageVideo.play();
    closeBtnRef.style.display = "none";
};

// EXTERNAL MODULE: ./components/cart/OrderSummary/SocialShare.jsx
var SocialShare = __webpack_require__(22006);
// EXTERNAL MODULE: ./components/Default/Video/v1/VideoControls.module.scss
var VideoControls_module = __webpack_require__(81146);
var VideoControls_module_default = /*#__PURE__*/__webpack_require__.n(VideoControls_module);
;// CONCATENATED MODULE: ./components/Default/Video/v1/VideoControls.jsx



const VideoControls = (param)=>{
    let { videoRef , id , setIsVideoPlaying , setVideoPlayed , flagState , onSeekSync , hasCaptions  } = param;
    const [playing, setPlaying] = (0,react.useState)(false);
    const [duration, setDuration] = (0,react.useState)(0);
    const [current, setCurrent] = (0,react.useState)(0);
    const [muted, setMuted] = (0,react.useState)(true);
    const [volume, setVolume] = (0,react.useState)(0);
    const [showCaptions, setShowCaptions] = (0,react.useState)(false);
    const [hasAudio, setHasAudio] = (0,react.useState)(false);
    const announcementRef = (0,react.useRef)(null);
    const formatTime = (sec)=>{
        if (!sec || isNaN(sec)) return "0:00";
        const minutes = Math.floor(sec / 60);
        const seconds = Math.floor(sec % 60).toString().padStart(2, "0");
        return "".concat(minutes, ":").concat(seconds);
    };
    (0,react.useEffect)(()=>{
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!video) return;
        // default start muted
        video.muted = true;
        video.volume = 0;
        // AUDIO DETECTION LOGIC
        const detectAudio = ()=>{
            var ref;
            const audioExists = (video === null || video === void 0 ? void 0 : (ref = video.audioTracks) === null || ref === void 0 ? void 0 : ref.length) > 0 || // Modern browsers
            (video === null || video === void 0 ? void 0 : video.webkitAudioDecodedByteCount) > 0 || // Safari / older Chromium
            (video === null || video === void 0 ? void 0 : video.mozHasAudio) || // Firefox
            (video === null || video === void 0 // IE/Edge legacy
             ? void 0 : video.msHasAudio);
            setHasAudio(!!audioExists);
        };
        const handleLoadedMetadata = ()=>{
            setDuration(video.duration || 0);
            detectAudio();
        };
        const handleTimeUpdate = ()=>setCurrent(video.currentTime || 0);
        const handlePlay = ()=>{
            setPlaying(true);
            setIsVideoPlaying === null || setIsVideoPlaying === void 0 ? void 0 : setIsVideoPlaying(true);
            setVideoPlayed === null || setVideoPlayed === void 0 ? void 0 : setVideoPlayed(true);
            if (announcementRef.current) {
                announcementRef.current.textContent = "Video is now playing";
            }
        };
        const handlePause = ()=>{
            setPlaying(false);
            if (announcementRef.current) {
                announcementRef.current.textContent = "Video is now paused";
            }
        };
        video.addEventListener("loadedmetadata", handleLoadedMetadata);
        video.addEventListener("timeupdate", handleTimeUpdate);
        video.addEventListener("play", handlePlay);
        video.addEventListener("pause", handlePause);
        return ()=>{
            video.removeEventListener("loadedmetadata", handleLoadedMetadata);
            video.removeEventListener("timeupdate", handleTimeUpdate);
            video.removeEventListener("play", handlePlay);
            video.removeEventListener("pause", handlePause);
        };
    }, [
        videoRef
    ]);
    const togglePlay = ()=>{
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!video) return;
        video.paused ? video.play() : video.pause();
    };
    const handleSeek = (e)=>{
        const time = Number(e.target.value);
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (video) {
            video.currentTime = time;
            onSeekSync === null || onSeekSync === void 0 ? void 0 : onSeekSync(time);
            setCurrent(time);
        }
    };
    const toggleMute = ()=>{
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!video) return;
        const newMuted = !muted;
        setMuted(newMuted);
        video.muted = newMuted;
        // If unmuting and volume is 0, restore to 0.5
        if (!newMuted && volume === 0) {
            video.volume = 0.5;
            setVolume(0.5);
        }
    };
    const handleVolumeChange = (e)=>{
        const newVolume = Number(e.target.value);
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!video) return;
        setVolume(newVolume);
        video.volume = newVolume;
        if (newVolume === 0) {
            video.muted = true;
            setMuted(true);
        } else {
            video.muted = false;
            setMuted(false);
        }
    };
    const toggleFullscreen = ()=>{
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!video) return;
        if (video.requestFullscreen) video.requestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    };
    const toggleCaptions = ()=>{
        const video = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!video) return;
        const tracks = video.textTracks || [];
        if (tracks.length > 0) {
            const newState = tracks[0].mode === "showing" ? "hidden" : "showing";
            for(let i = 0; i < tracks.length; i++){
                tracks[i].mode = newState;
            }
            setShowCaptions(newState === "showing");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (VideoControls_module_default()).VideoControls,
        role: "region",
        "aria-label": "Video player controls",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: announcementRef,
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                className: (VideoControls_module_default()).screenReaderAnnouncement
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (VideoControls_module_default()).playToggle,
                onClick: togglePlay,
                "aria-pressed": playing,
                "aria-label": playing ? "Pause video" : "Play video",
                children: playing ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "5",
                            y: "3",
                            width: "4",
                            height: "18"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "15",
                            y: "3",
                            width: "4",
                            height: "18"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                        points: "5 3 19 12 5 21"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (VideoControls_module_default()).progress,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "range",
                    min: "0",
                    max: duration || 0,
                    step: "0.1",
                    value: current,
                    onChange: handleSeek,
                    className: (VideoControls_module_default()).progressSlider,
                    "aria-label": "Video progress"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VideoControls_module_default()).time,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: formatTime(current)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (VideoControls_module_default()).timeSeparator,
                        children: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: formatTime(duration)
                    })
                ]
            }),
            hasAudio && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VideoControls_module_default()).audioControls,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (VideoControls_module_default()).muteButton,
                        onClick: toggleMute,
                        "aria-label": muted ? "Unmute audio" : "Mute audio",
                        children: muted ? "\uD83D\uDD07" : "\uD83D\uDD0A"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "range",
                        min: "0",
                        max: "1",
                        step: "0.05",
                        value: volume,
                        onChange: handleVolumeChange,
                        className: (VideoControls_module_default()).progressSlider,
                        "aria-label": "Audio volume"
                    })
                ]
            }),
            hasCaptions && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "".concat((VideoControls_module_default()).captions, " ").concat(showCaptions ? (VideoControls_module_default()).active : ""),
                onClick: toggleCaptions,
                children: "CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (VideoControls_module_default()).fullscreen,
                onClick: toggleFullscreen,
                "aria-label": "Full screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_VideoControls = (VideoControls);

// EXTERNAL MODULE: ./i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(81294);
;// CONCATENATED MODULE: ./components/Default/Video/v1/Video.jsx






















const Video_Video = (props)=>{
    const { data: { videoTitle ="" , videoMobile ="" , videoMobileLandscape ="" , videoMobilePoster ="" , videoDesktopPoster ="" , videoDesktop ="" , muteEnableAutoPlay ="false" , hideEnableAutoPlay ="false" , appliedCssClassNames ="" , items =[] , teaserProperties: { title ="" , description ="" , linkURLRef =false , linkCTA ="" , linkNewTab =false , videoPosterMobileLandscape ="" , controlType ="" , pageType ="" , componentPosition ="" , componentZone ="" , componentLinkType ="" , playsAboveFold ="false" , eventName ="" , dynamicTabName ="" , eventAction ="" , caption ="" , pretitle ="" , actionsEnabled =false , actions =[] , linkAll =false , dataLayerLinkType ="" , mainTitle ="" , enableFav =false , enableShare =false , linkDescription =false , propertiesPageType =""  } = {}  } = {}  } = props;
    const { eventPageType , toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const screenOrientation = hooks_useScreenOrientation();
    const [video, setVideo] = (0,react.useState)("");
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const [videoPlayed, setVideoPlayed] = (0,react.useState)(false);
    const [isVideoPlaying, setIsVideoPlaying] = (0,react.useState)(false);
    const [showSocialShare, setShowSocialShare] = (0,react.useState)(false);
    const [interactionState, setInteractionState] = (0,react.useState)("");
    const { ref: inViewRef , inView  } = useInView({
        threshold: 0.5
    });
    const videoContainerRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    const favEle = (0,react.useRef)(null);
    const [general, setGeneral] = (0,react.useState)(null);
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [showControls, setShowControls] = (0,react.useState)(false);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [isCallback, setIsCallback] = (0,react.useState)(false);
    const isTriggeredRef = (0,react.useRef)(true);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [flagState, setFlagState] = (0,react.useState)({
        flag25: false,
        flag75: false,
        flag50: false,
        flag100: false
    });
    const getVideoId = (video)=>{
        var ref, ref1;
        return (ref1 = (ref = decodeURI(video)) === null || ref === void 0 ? void 0 : ref.split(regex/* VIDEO_ID_REGEX */.JY)[1]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    };
    const videoId = getVideoId(video);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const videoName = "".concat(videoTitle.replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, "") || componentLinkType.toLowerCase().replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, "") || "hero video");
    (0,react.useEffect)(()=>{
        const handleFullscreenChange = ()=>{
            if (document.fullscreenElement === (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current)) {
                addVideoFullScreenDatalayer("fullscreenEnter", eventPageType, videoName, videoId, componentPosition);
            } else {
                addVideoFullScreenDatalayer("fullscreenExit", eventPageType, videoName, videoId, componentPosition);
            }
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return ()=>{
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, [
        eventPageType,
        videoId,
        videoName,
        componentPosition
    ]);
    (0,react.useEffect)(()=>{
        if (videoTitle) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(videoTitle);
            setDynamicId(dynamicId);
        }
    }, [
        videoTitle
    ]);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    const onTimeUpdate = (event)=>{
        const videoDuration = videoRef.current.duration;
        const percent25 = Math.floor(videoDuration * 0.25);
        const percent50 = Math.floor(videoDuration * 0.5);
        const percent75 = Math.floor(videoDuration * 0.75);
        const percent100 = Math.floor(videoDuration);
        const progressTime = Math.floor(videoRef.current.currentTime);
        if ((muteEnableAutoPlay === "true" ? percent100 - 1 : percent100) === progressTime && flagState.flag100 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag100: true
                }));
            addVideoDataLayer(100);
        } else if (percent75 <= progressTime && flagState.flag75 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag75: true
                }));
            addVideoDataLayer(75);
        } else if (percent50 <= progressTime && flagState.flag50 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag50: true
                }));
            addVideoDataLayer(50);
        } else if (percent25 <= progressTime && flagState.flag25 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag25: true
                }));
            addVideoDataLayer(25);
        }
    };
    const addVideoDataLayer = (percentViewed)=>{
        var ref;
        const { VIDEO_VIEWED , VIDEO_COMPLETE  } = constants.VIDEO_EVENTS;
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed === 100 ? "".concat(videoTitle, ":").concat(VIDEO_COMPLETE) : "".concat(percentViewed, "% ").concat(VIDEO_VIEWED)),
            eventMsg: "n/a",
            eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed === 100 ? "".concat(videoTitle, ":").concat(VIDEO_COMPLETE) : "".concat(percentViewed, "% ").concat(VIDEO_VIEWED)),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(percentViewed === 100 ? VIDEO_COMPLETE : "".concat(percentViewed, "% ").concat(VIDEO_VIEWED)),
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed === 100 ? videoTitle : componentPosition || "teaser"),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()).concat(percentViewed === 100 ? ":" + videoTitle : ""),
            videoId: videoId,
            videoName: videoName,
            videoType: "".concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated")
        };
        const page = window.pageObj || {};
        // const { productInfo: tempInfo } = page
        if ((page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageId) === "home") {
            delete page.productInfo;
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const { favSuccessMsg ="" , favErrorMsg ="" , removeItem =""  } = (0,useSearchi18n/* default */.Z)({});
    const setToasterMessage = async ()=>{
        setToasterContent({
            successMessage: favSuccessMsg,
            unfavoriteSuccessMessage: removeItem
        });
    };
    const getInitialFavoriteState = ()=>{
        dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((response)=>{
            const { textLineItems =[]  } = response;
            (0,helper/* checkIsFavorite */.GsT)(textLineItems);
            const id = favEle.current.getAttribute("data-id");
            if (id) {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: favErrorMsg,
                    isVisible: true
                }));
            } else {
                onFavVideo({});
            }
        });
    };
    const onFavVideo = (event)=>{
        var ref;
        (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
        (event === null || event === void 0 ? void 0 : event.stopPropagation) && (event === null || event === void 0 ? void 0 : event.stopPropagation());
        const { successMessage ="" , unfavoriteSuccessMessage =""  } = toasterContent;
        if (!isAuth) {
            handleLogin(event);
            return;
        }
        let _$$closest;
        const id = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("data-id");
        const sharedZoneName = (_$$closest = $(void 0).closest(".cmp-container")) === null || _$$closest === void 0 ? void 0 : _$$closest.attr("id");
        if (id) {
            (0,helper/* removeFavorites */.NgF)([
                id
            ], favEle, unfavoriteSuccessMessage);
        } else {
            const assetUrl = videoDesktop;
            let _assetUrl;
            const url = (_assetUrl = assetUrl) !== null && _assetUrl !== void 0 && _assetUrl.startsWith("/") ? window.location.origin + assetUrl : assetUrl;
            (0,helper/* addMediaToFavorites */.iZV)("video", title, url, successMessage, "", caption, sharedZoneName, checkVideoTitle, favVideoId);
        }
    };
    (0,react.useEffect)(()=>{
        if (!isTriggeredRef.current && isCallback && isAuth) {
            isTriggeredRef.current = true;
            setIsCallback(false);
            getInitialFavoriteState();
        }
    }, [
        isCallback,
        isAuth,
        isTriggeredRef
    ]);
    const handleLogin = ()=>{
        setIsCallback(true);
        isTriggeredRef.current = false;
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleLoadedMetadata = ()=>{
        var ref;
        const duration = ((ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.duration) || 0;
        // Enable controls if video is 5 seconds or longer
        if (duration >= constants.MIN_VIDEO_DURATION) {
            setShowControls(true);
        } else {
            setShowControls(false);
        }
    };
    const setVideoSource = (0,react.useCallback)(()=>{
        if (winWidth > 1023) {
            setVideo(videoDesktop);
        } else {
            if (screenOrientation === null || screenOrientation === void 0 ? void 0 : screenOrientation.includes("landscape")) {
                setVideo(videoMobileLandscape);
            } else {
                setVideo(videoMobile);
            }
        }
    }, [
        videoMobile,
        videoMobileLandscape,
        videoDesktop,
        screenOrientation,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            setVideoSource();
            if ((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) || videoPlayed && interactionState === constants.VIDEO_EVENTS.PLAY) {
                var ref;
                videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
            }
        } else {
            var ref1;
            videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        setVideoSource,
        inView
    ]);
    (0,react.useEffect)(()=>{
        if (isVideoPlaying) setVideoPlayed(true);
    }, [
        isVideoPlaying
    ]);
    const eventActionTabName = dynamicTabName || "zoneForVideo";
    const eventActionName = "".concat(dynamicTabName || "rm", ":video:rm");
    const [favVideoId, setFavVideoId] = (0,react.useState)("");
    const analyticEventData = {
        clickInternalLinks: true,
        internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
        internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser"),
        internalLinkURL: "n/a",
        internalLinkName: "n/a",
        eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        eventType: "informative",
        eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video"),
        videoId: "".concat(getVideoId(video)),
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const checkVideoTitle = videoTitle || componentLinkType.toLowerCase() || "hero video";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "video teaser ".concat(appliedCssClassNames),
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser".concat(controlType === "customControl" ? " gbh-custom-control" : "").concat(propertiesPageType === "modalWindow" ? " gbh-model-window" : "").concat((0,helper/* convertStringToBoolean */.mUs)(hideEnableAutoPlay) ? " gbh-hide-mute" : ""),
            ref: videoContainerRef,
            "aria-label": dynamicId !== null && dynamicId !== void 0 ? dynamicId : "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__image video_poster_height".concat(videoPlayed ? " video-played" : ""),
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ':\'hero banner\' ","internalLinkURL":"n/a","internalLinkName":"video play","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '",\n             "internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle ? videoTitle : componentLinkType.toLowerCase() || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","videoName":"').concat(videoTitle || componentLinkType.toLowerCase() || "hero video", '","videoId":"').concat(videoId, '","videoType": "').concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated", '"}'),
                    style: showSocialShare ? {
                        overflow: "visible"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "gbh-play-video desktop".concat(isVideoPlaying ? " active" : ""),
                            onClick: (event)=>{
                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "playinside desktop",
                                id: "videoinnerbtn-".concat(dynamicId),
                                "aria-label": isVideoPlaying ? "pause video" : "play video",
                                "aria-pressed": isVideoPlaying,
                                title: isVideoPlaying ? "Pause video" : "Play video",
                                onClick: ()=>{
                                    return onPlayVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, (res)=>{
                                        setIsVideoPlaying(res);
                                        setInteractionState(res ? constants.VIDEO_EVENTS.PAUSE : constants.VIDEO_EVENTS.PLAY);
                                    }, videoDesktopPoster, videoMobilePoster, video, isVideoPlaying);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "poster-img",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:1025)",
                                    srcSet: "".concat(videoDesktopPoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:640px) and (max-width:1024px)",
                                    srcSet: "".concat(videoPosterMobileLandscape)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width:639px)",
                                    srcSet: "".concat(videoMobilePoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(videoDesktopPoster),
                                    alt: "",
                                    className: "desktop-poster"
                                })
                            ]
                        }),
                        video && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                    ref: videoRef,
                                    id: "video-desktop-".concat(dynamicId),
                                    "aria-label": dynamicId !== null && dynamicId !== void 0 ? dynamicId : "",
                                    width: "100%",
                                    muted: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                                    autoPlay: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                                    loop: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                                    playsInline: true,
                                    preload: "metadata",
                                    onLoadedMetadata: handleLoadedMetadata,
                                    onLoadedData: ()=>{
                                        if ((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
                                            playVideoDatalayer(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (id)=>setFavVideoId(id));
                                        }
                                    },
                                    className: "hero-video videoelement".concat((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) ? " muted" : "").concat((0,helper/* convertStringToBoolean */.mUs)(playsAboveFold) ? "" : " lazy-video"),
                                    onClick: (event)=>{
                                        return onClickHeroVideo(event, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                    },
                                    onPlay: ()=>{
                                        return onVideoInteraction(constants.VIDEO_EVENTS.PLAY, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), (id)=>setFavVideoId(id), flagState);
                                    },
                                    onPause: ()=>{
                                        return onVideoInteraction(constants.VIDEO_EVENTS.PAUSE, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), flagState);
                                    },
                                    onEnded: ()=>{
                                        return onVideoInteraction(constants.VIDEO_EVENTS.ENDED, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), flagState);
                                    },
                                    onTimeUpdate: onTimeUpdate,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: video,
                                            type: "video/mp4"
                                        }),
                                        items.map((transcript, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                                label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                                kind: "subtitles",
                                                srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                                src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                                default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                            }, "video-track-".concat(dynamicId, "-").concat(index));
                                        })
                                    ]
                                }),
                                controlType === "defaultControl" && (!(0,helper/* convertStringToBoolean */.mUs)(hideEnableAutoPlay) || showControls) && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_VideoControls, {
                                    videoRef: videoRef,
                                    id: dynamicId,
                                    setIsVideoPlaying: setIsVideoPlaying,
                                    setVideoPlayed: setVideoPlayed,
                                    flagState: flagState,
                                    onSeekSync: (newTime)=>{
                                        if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) videoRef.current.currentTime = newTime;
                                    },
                                    hasCaptions: (items === null || items === void 0 ? void 0 : items.length) > 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-img-caption",
                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"n/a","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventName || eventActionName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle || componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventAction || eventActionName, '"}'),
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(caption)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vidio_popup_close_button",
                            onClick: ()=>{
                                return onVideoPopupClose(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                role: "button",
                                "aria-label": "close video player",
                                title: "Close video player",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\xd7"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__content",
                    children: [
                        pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__pretitle",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(pretitle)
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__title",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                            general: general,
                            linkURL: linkCTA,
                            linkURLRef: linkURLRef,
                            linkNewTab: linkNewTab,
                            description: description,
                            mainTitle: mainTitle,
                            componentPosition: componentPosition,
                            componentLinkType: componentLinkType,
                            pageType: pageType,
                            linkDescription: linkDescription
                        }),
                        actionsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__action-container",
                            children: actions.map((action, index)=>{
                                const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                    primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                    secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                    playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                    link: url,
                                    text: title,
                                    newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                    urlRef: urlRef,
                                    id: dynamicId,
                                    pageType: pageType,
                                    videoTitle: videoTitle,
                                    linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                    mainTitle: mainTitle,
                                    dataLayerLinkType: dataLayerLinkType,
                                    eventName: eventName,
                                    eventAction: eventAction,
                                    componentPosition: componentPosition,
                                    propertiesPageType: propertiesPageType,
                                    playVideoCTAcb: (event)=>{
                                        return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                    }
                                }, "video-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                            })
                        }),
                        (enableFav || enableShare) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__icons",
                            children: [
                                enableFav && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    ref: favEle,
                                    className: "favorite fav-video-trigger",
                                    "data-asset": videoDesktop,
                                    "data-url": videoDesktop,
                                    "aria-label": "add video to favorites",
                                    title: "Add video to favorites",
                                    onClick: (event)=>onFavVideo(event)
                                }),
                                enableShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "share share-video-trigger",
                                    "aria-label": showSocialShare ? "close share options" : "share video",
                                    "aria-expanded": showSocialShare,
                                    title: "Share video on social media",
                                    onClick: (e)=>onShareVideo(e, ()=>setShowSocialShare(!showSocialShare), eventPageType, componentZone, componentLinkType, videoTitle),
                                    children: showSocialShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-cmp",
                                        style: {
                                            display: "block"
                                        },
                                        role: "region",
                                        "aria-label": "Share options",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                            analyticEventData: analyticEventData,
                                            componentProp: {
                                                assetUrl: videoDesktop
                                            },
                                            enableDownload: false,
                                            videoComp: true
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Video = (/*#__PURE__*/react.memo(Video_Video));

// EXTERNAL MODULE: ./node_modules/overlayscrollbars-react/dist/overlayscrollbars-react.esm.js
var overlayscrollbars_react_esm = __webpack_require__(1861);
// EXTERNAL MODULE: ./components/core/Image/ImagePlaceHolder.jsx
var ImagePlaceHolder = __webpack_require__(61319);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/FavouritesUtility.jsx











const FavouritesUtility = (param)=>{
    let { title ="" , assetID ="" , imageServerUrl ="" , alt ="" , containerId: zone = ""  } = param;
    const isTriggeredRef = (0,react.useRef)(true);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [isFavourite, setIsFavourite] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const favEle = (0,react.useRef)(null);
    const { favorites: favoritesLabel , favSuccessMsg , favErrorMsg , removeItem  } = (0,useSearchi18n/* default */.Z)({});
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const dataUrl = assetID ? "".concat(imageServerUrl).concat(assetID) : "";
    const [isCallback, setIsCallback] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        const ogUrl = document.querySelector('meta[property="og:url"]') ? (ref = document.querySelector('meta[property="og:url"]')) === null || ref === void 0 ? void 0 : ref.content : "";
        const url = ogUrl ? ogUrl.replace(constants.publicWebsiteUrl, constants.baseUrl) : "/".concat(window.location.pathname.split(".")[0]);
        setPageUrl(url);
    }, []);
    const { toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    const getInitialFavoriteState = ()=>{
        dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((response)=>{
            const { textLineItems =[]  } = response;
            (0,helper/* checkIsFavorite */.GsT)(textLineItems);
            const id = favEle.current.getAttribute("data-id");
            if (id) {
                errorCallback();
            } else {
                onFavClick({});
            }
        });
    };
    (0,react.useEffect)(()=>{
        if (!isTriggeredRef.current && isCallback && isAuth) {
            isTriggeredRef.current = true;
            setIsCallback(false);
            getInitialFavoriteState();
        }
    }, [
        isCallback,
        isAuth,
        isTriggeredRef
    ]);
    const setToasterMessage = async ()=>{
        const { successMessage , unfavoriteSuccessMessage  } = content;
        setToasterContent({
            successMessage: successMessage ? await (0,utils_location/* getShortenedUrl */.Pp)(successMessage) : null,
            unfavoriteSuccessMessage: unfavoriteSuccessMessage ? await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage) : null
        });
    };
    const onFavClick = (event)=>{
        (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
        (event === null || event === void 0 ? void 0 : event.stopPropagation) && (event === null || event === void 0 ? void 0 : event.stopPropagation());
        let payload = {};
        const id = favEle.current.getAttribute("data-id");
        window.zoneName = zone;
        window.internalLinkType = title;
        if (!isAuth) {
            handleLogin();
            return;
        }
        // For images
        if (assetID) {
            payload = getPayload({
                type: "image"
            });
            if (!id) {
                postData(payload);
            }
        } else {
            Promise.all([
                (0,constants_api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_CONTENT_END_POINT)
                    }
                }),
                (0,constants_api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_IMG_END_POINT)
                    }
                })
            ]).then((response)=>{
                const [{ data  } = {}, { data: { fileReference  } = {}  }] = response;
                payload = getPayload({
                    type: "article",
                    content: data,
                    thumbnail: fileReference
                });
                !id && postData(payload);
            }).catch((error)=>{
                // eslint disable next-line no-console
                console.error(error);
            });
        }
        if (id) {
            dispatch((0,favoritesSlice/* removeItems */.Er)({
                ids: [
                    id
                ],
                section: payload === null || payload === void 0 ? void 0 : payload.section,
                imageName: payload === null || payload === void 0 ? void 0 : payload.imageName,
                isDataLayerNeeded: true
            })).unwrap().then((response)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: toasterContent.unfavoriteSuccessMessage || removeItem,
                    isVisible: true
                }));
                favEle.current.removeAttribute("data-id");
                favEle.current.classList.remove("favorite-filled");
            }).catch((error)=>{
                // eslint disable next-line no-console
                console.error(error);
            });
            return;
        }
    };
    const postData = (payload)=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* addMedia */.rA)(payload));
        } else {
            handleLogin();
        }
    };
    const getPayload = (param)=>{
        let { type , content , thumbnail  } = param;
        const payload = {
            type,
            content,
            thumbnail,
            successCallback,
            errorCallback,
            section: zone
        };
        if (type === "image") {
            payload["name"] = alt;
            payload["url"] = dataUrl;
            payload["section"] = "main content area";
            payload["imageName"] = assetID.includes("/") ? "".concat(assetID.split("/").at(1)).toLowerCase() : "".concat(assetID).toLowerCase();
        } else if (type === "article") {
            payload["caption"] = title;
            payload["name"] = content["jcr:title"];
            payload["description"] = content["searchDescription"];
            payload["articleType"] = content["eyeBrowText"];
            payload["thumbnail"] = thumbnail;
            payload["url"] = window.location.href;
        }
        return payload;
    };
    const handleLogin = ()=>{
        setIsCallback(true);
        isTriggeredRef.current = false;
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const successCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: toasterContent.successMessage || favSuccessMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    const errorCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: favErrorMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "favorite fav-trigger ".concat(isFavourite ? "favorite-filled" : ""),
        "aria-label": "favorite",
        "data-asset": assetID,
        "data-url": dataUrl,
        "data-title": alt,
        "data-internal-link-type": title,
        ref: favEle,
        onClick: (event)=>onFavClick(event),
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: favoritesLabel
            })
        ]
    });
};
/* harmony default export */ var v1_FavouritesUtility = (FavouritesUtility);

// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(13678);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/ShareUtility.jsx








const ShareUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , containerId: zone = ""  } = param;
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { share  } = (0,useSearchi18n/* default */.Z)({});
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) setPageUrl(window.location.href);
    }, [
        pageIsInteractive
    ]);
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(!showShare);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const { pageInfo: { contentType  }  } = getState && getState("page") || {};
        let eventInfo = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative");
        const isPdp = contentType === "pdp";
        if (isPdp) {
            const { internalLinkType , internalLinkZoneName , internalLinkURL  } = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true);
            const eventInfoObj = {
                clickInternalLinks: "true",
                eventAction: "pdp:product details:zone:share",
                eventName: "pdp:product details:zone:share",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "share",
                internalLinkPosition: "pdp",
                internalLinkType: "pdp:".concat(internalLinkType.split(":")[1] || ""),
                internalLinkZoneName: "pdp:".concat(internalLinkZoneName.split(":")[1] || ""),
                internalLinkURL: internalLinkURL || "n/a"
            };
            eventInfo = JSON.stringify(eventInfoObj);
        }
        addDatalayerShare(eventInfo, isPdp);
    };
    return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "share share-trigger",
                "aria-label": "share",
                tabIndex: "0",
                onClick: handleShare,
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: share
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "share-cmp",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                        showModal: showShare,
                        url: pageUrl,
                        onClose: ()=>setShowShare(false),
                        disableInstagram: true,
                        analyticData: getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true)
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var v1_ShareUtility = (ShareUtility);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/PrintUtility.jsx




const PrintUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , mainTitle =""  } = param;
    const { print  } = (0,useSearchi18n/* default */.Z)({});
    const handlePrint = ()=>{
        window.print();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        class: "print",
        onClick: ()=>handlePrint(),
        tabIndex: "0",
        "data-gbh-data-layer": getEventInfo(pageType, componentPosition, mainTitle, "print", "", "teaser"),
        "data-gbh-clickable": "true",
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: print
            })
        ]
    });
};
/* harmony default export */ var v1_PrintUtility = (PrintUtility);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/utils.js
const getDimensions = (ele)=>{
    const { height  } = ele.getBoundingClientRect();
    const offsetTop = ele.offsetTop;
    const offsetBottom = offsetTop + height;
    return {
        height,
        offsetTop,
        offsetBottom
    };
};
const FIND_A_PRO_RESULTS_PAGENAME = "kohler:services:find a pro results";

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/helper.js


const isPageNameFindAProResults = (pageType)=>{
    return FIND_A_PRO_RESULTS_PAGENAME.includes(pageType);
};
const isPressKitPageType = (pageType)=>pageType === constants.PRESS_KIT_PAGE_TYPE;

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/DownloadUtility.jsx







const DownloadUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , downLoadLink =null , mainTitle =""  } = param;
    const { download , downloadSuccess , downloadFailure  } = (0,useSearchi18n/* default */.Z)({});
    const [downloadUrl, setUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (downLoadLink) {
            updateUrl();
        }
    }, [
        downLoadLink
    ]);
    const updateUrl = async ()=>{
        const url = await (0,helper/* getShortenedUrl */.Ppy)(downLoadLink);
        if (isPressKitPageType) {
            var ref;
            setUrl("".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin).concat(url));
        } else {
            setUrl("".concat(constants.authorBaseUrl).concat(url));
        }
    };
    const downloadHandle = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        const getDownloadUrl = downloadUrl ? downloadUrl : window.location.href;
        (0,helper/* downloadArticle */.vIr)(getDownloadUrl, event, "", downloadSuccess, downloadFailure);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "download",
        "aria-label": "download",
        tabIndex: "0",
        children: downLoadLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: downLoadLink,
            className: "download-trigger",
            "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
            "data-gbh-clickable": "true",
            onClick: downloadHandle,
            children: [
                "\xa0",
                download
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "download-trigger",
                    "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
                    "data-gbh-clickable": "true",
                    onClick: downloadHandle,
                    children: download
                })
            ]
        })
    });
};
/* harmony default export */ var v1_DownloadUtility = (DownloadUtility);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Utilities.jsx







const Utilities = (param)=>{
    let { utilities =[] , title ="" , assetID ="" , imageServerUrl ="" , alt ="" , pageType ="" , dataLayerLinkType ="" , mainTitle ="" , downLoadLink ="" , containerId =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__icons",
        children: utilities.map((item, index)=>{
            switch(item === null || item === void 0 ? void 0 : item.utilitiesType){
                case constants.UTILITY_CONSTANTS.FAVOURITES:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FavouritesUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.SHARE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShareUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.PRINT:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PrintUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.DOWNLOAD:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DownloadUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle,
                        downLoadLink: downLoadLink
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                default:
                    return null;
            }
        })
    });
};
/* harmony default export */ var v1_Utilities = (Utilities);

// EXTERNAL MODULE: ./components/Default/CarouselSlick/v1/SlickSettings.js + 1 modules
var SlickSettings = __webpack_require__(42426);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Teaser.jsx
/* eslint-disable react/jsx-no-target-blank */ 


















const Teaser = (props)=>{
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const { pageIsInteractive , datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const generalConfigData = useConfig();
    const { data: { id ="" , appliedCssClassNamesCustom ="" , linkURLRef =false , linkNewTab =false , linkAll =false , linkTitle =false , linkImage =false , title ="" , description ="" , enableFav =false , enableShare =false , mainTitle ="" , componentPosition ="" , pageType ="" , linkDescription ="" , linkURL ="" , caption ="" , datalayerLinkName ="" , componentLinkType ="" , eventName ="" , eventAction ="" , actions =[] , downLoadLink =null , expandText ="" , collapseText ="" , disableExpandCollapse ="" , imageResource: { imageServerUrl ="" , assetID ="" , pretitle: preTitle = "" , urlModifiers ="" , alt =""  } = {} , utilities =[] , utilitiesEnabled =false , dataLayerLinkType =""  } = {} , fullData ={} , showEmptyPlaceholder =false , maxHeight ="" , containerId ="" , pageName ="" , bodytitle =""  } = props;
    const generatedLinkURL = (0,helper/* getShortenedUrlwithGeneral */.vu1)(linkURL, generalConfigData);
    const [parentActionLink, setParentActionLink] = (0,react.useState)(generatedLinkURL);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [appliedCssClassNamesCustoms, setAppliedCssClassNamesCustoms] = (0,react.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)(generalConfigData);
    const [innerCaption, setInnerCaption] = (0,react.useState)(false);
    const [isInsideImage, setIsInsideImage] = (0,react.useState)(false);
    const [activeIndex, setActive] = (0,react.useState)(0);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const isMobile =  true && window.innerWidth <= 768 // Example condition for mobile detection
    ;
    const isCaptionOnly = Boolean(title || description || (actions === null || actions === void 0 ? void 0 : actions.length) || preTitle || assetID || showEmptyPlaceholder);
    const containerIdName = containerId ? containerId.replace(/-/g, " ") : "zone";
    (0,react.useEffect)(()=>{
        fetchConfig();
        updateDynamicId();
        updateParentActionLink();
        updateComponentGroup();
        updateColumnClassNames();
        updateInnerCaption();
        checkUtilityPosition();
    }, [
        assetID,
        linkURL,
        fullData,
        appliedCssClassNamesCustom,
        isSsr,
        pageIsInteractive
    ]);
    const fetchConfig = async ()=>{
        if (isEmpty_default()(generalConfigData)) {
            const config = await (0,constants_config/* getConfig */.i)();
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        }
    };
    const updateDynamicId = ()=>{
        const dynamicId = assetID ? (0,helper/* createIdFromString */.ZT_)(assetID) : (0,helper/* createIdFromString */.ZT_)((0,helper/* getRandom */.sZz)() + "");
        setDynamicId(dynamicId);
    };
    const updateParentActionLink = async ()=>{
        if (linkURL) {
            const res = await (0,helper/* getShortenedUrl */.Ppy)(linkURL);
            const [resBeforeHash, resAfterHash] = (res !== null && res !== void 0 ? res : "").split("#");
            setParentActionLink(resBeforeHash && resAfterHash ? "".concat(resBeforeHash, "#").concat(encodeURIComponent(resAfterHash)) : res);
        }
    };
    const updateComponentGroup = ()=>{
        if (!isEmpty_default()(fullData)) {
            const newCssClassNames = Object.keys(fullData).map((key)=>fullData[key]["appliedCssClassNamesCustom"]);
            const newComponentGroup = Object.keys(fullData).map((key)=>fullData[key][":type"]);
            setAppliedCssClassNamesCustoms(newCssClassNames);
            setComponentGroup(newComponentGroup);
        }
    };
    const updateColumnClassNames = ()=>{
        let classNameCustom = "";
        if (componentGroup.length > 0) {
            if (shouldAddHeroBannerClasses()) {
                classNameCustom += addHeroBannerClasses();
            }
        }
        setColumnClassNames((prev)=>prev + classNameCustom);
    };
    const shouldAddHeroBannerClasses = ()=>{
        return componentGroup.some((a)=>{
            return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.TEASER);
        }) && appliedCssClassNamesCustoms.some((a)=>{
            return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-top");
        }) && !appliedCssClassNamesCustoms.some((a)=>{
            return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-bottom");
        });
    };
    const addHeroBannerClasses = ()=>{
        let classNameCustom = "";
        if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("hero-banner-top-only"))) {
            classNameCustom += " hero-banner-top-only ";
        }
        if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("paddingbasedbreadcrum")) && componentGroup.some((a)=>{
            return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
        })) {
            classNameCustom += " paddingbasedbreadcrum ";
        }
        if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("without-breadcrumb")) && !componentGroup.some((a)=>{
            return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
        })) {
            classNameCustom += " without-breadcrumb ";
        }
        return classNameCustom;
    };
    const updateInnerCaption = ()=>{
        if (!isSsr && pageIsInteractive) {
            const hasInnerCaption = constants.TEASER_CAPTION_CLASSES_LIST.some((classNames)=>{
                return classNames.split(" ").every((className)=>{
                    var ref;
                    return (ref = appliedCssClassNamesCustom === null || appliedCssClassNamesCustom === void 0 ? void 0 : appliedCssClassNamesCustom.trim()) === null || ref === void 0 ? void 0 : ref.includes(className);
                });
            });
            setInnerCaption(hasInnerCaption);
        }
    };
    const checkUtilityPosition = ()=>{
        const isInsideImage = constants.TEASER_CLASSES.some((item)=>appliedCssClassNamesCustom.includes(item));
        setIsInsideImage(isInsideImage);
    };
    const getDataLayerLinkType = ()=>{
        return mainTitle || title ? "".concat(pageType, ":").concat(mainTitle || title) : dataLayerLinkType;
    };
    const renderImage = ()=>{
        const renderDynamicImage = ()=>{
            const imageStyle = maxHeight && showEmptyPlaceholder && !assetID ? {
                maxHeight
            } : {};
            const imageUrl = assetID ? "".concat(imageServerUrl).concat(assetID) : constants.EMPTY_PIXEL;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                style: imageStyle,
                className: "fluidimage cmp-image__image",
                imgUrl: imageUrl,
                alt: alt,
                itemProp: "contentUrl",
                uniqueId: dynamicId,
                urlModifiers: urlModifiers,
                pageType: pageType
            });
        };
        const renderUtilities = ()=>{
            if (isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) > 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                    utilities: utilities,
                    title: title,
                    assetID: assetID,
                    imageServerUrl: imageServerUrl,
                    alt: alt,
                    pageType: pageType,
                    dataLayerLinkType: getDataLayerLinkType(),
                    mainTitle: mainTitle,
                    downLoadLink: downLoadLink,
                    containerId: containerId
                });
            }
            return null;
        };
        const renderCaption = ()=>{
            if (innerCaption && caption) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-img-caption",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
                });
            }
            return null;
        };
        const renderImageContent = ()=>{
            if (!isSsr) {
                if (assetID || showEmptyPlaceholder) {
                    return renderDynamicImage();
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceHolder/* default */.Z, {
                    assetID: assetID
                });
            }
            return null;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cq-dd-image cmp-teaser__image",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "s7responsiveContainer cmp-teaser__image cmp-image__image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                            condition: linkImage,
                            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: parentActionLink,
                                    target: linkNewTab ? "_blank" : "_self",
                                    "data-gbh-clickable": "true",
                                    rel: "noreferrer",
                                    children: children
                                }),
                            children: renderImageContent()
                        })
                    })
                }),
                renderUtilities(),
                renderCaption()
            ]
        });
    };
    const renderContent = ()=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser__content",
            style: isMobile && !(0,SlickSettings/* isProductFeatureLandscapeCarouselUpdatePage */.UD)(pageName) && !isPageNameFindAProResults(pageName) ? {
                width: "100%"
            } : {},
            children: [
                preTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-teaser__pretitle",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(preTitle)
                }),
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-teaser__title",
                    id: id,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: linkTitle,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: parentActionLink,
                                rel: linkURLRef ? "noreferrer" : "",
                                target: linkNewTab ? "_blank" : "_self",
                                "data-gbh-data-layer": getTitleEventInfo(linkNewTab, componentPosition, linkURL, mainTitle, pageType, componentLinkType, title),
                                "data-gbh-clickable": "true",
                                children: children
                            }),
                        children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                    })
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                    linkURLRef: linkURLRef,
                    general: general,
                    linkNewTab: linkNewTab,
                    description: description,
                    mainTitle: mainTitle,
                    componentPosition: componentPosition,
                    pageType: pageType,
                    linkDescription: linkDescription,
                    expandText: expandText,
                    collapseText: collapseText,
                    disableExpandCollapse: disableExpandCollapse,
                    preTitle: preTitle,
                    linkURL: linkURL
                }),
                (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-teaser__action-container",
                    children: actions.map((action, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                            playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(action.playVideoCTA),
                            primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(action.primaryCTA),
                            secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(action.secondaryCTA),
                            link: action.url,
                            text: action.title,
                            newTab: (0,helper/* convertStringToBoolean */.mUs)(action.newTab),
                            urlRef: action.urlRef,
                            id: id,
                            dataLayerLinkType: dataLayerLinkType,
                            pageType: pageType,
                            linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                            mainTitle: mainTitle,
                            index: index,
                            activeIndex: activeIndex,
                            setActive: setActive
                        }, "teaser-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)())))
                }) : null,
                !isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                    utilities: utilities,
                    title: title,
                    assetID: assetID,
                    imageServerUrl: imageServerUrl,
                    alt: alt,
                    pageType: pageType,
                    dataLayerLinkType: getDataLayerLinkType(),
                    mainTitle: mainTitle,
                    downLoadLink: downLoadLink,
                    containerId: containerId
                })
            ]
        });
    };
    const handleCaptionLinkClick = (event)=>{
        var ref;
        const linkElement = event.target.closest("a");
        if (!linkElement) return;
        const linkText = (ref = linkElement.textContent) === null || ref === void 0 ? void 0 : ref.trim();
        const linkHref = linkElement.getAttribute("href");
        if (linkText && linkHref) {
            const eventInfo = getCaptionLinkEventInfo(pageType, linkText, linkHref);
            if (eventInfo && Object.keys(eventInfo).length > 0) {
                (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "teaser ".concat(appliedCssClassNamesCustom || "").concat(columnClassNames),
        children: [
            isCaptionOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-teaser",
                "data-gbh-data-layer": (e)=>addTeaserAnalytic(e, linkNewTab, pageType, linkURL, datalayerLinkName, containerIdName, mainTitle, eventName, eventAction),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
                    condition: linkAll,
                    wrapper: (children)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                            href: parentActionLink,
                            target: linkNewTab ? "_blank" : "_self",
                            "data-gbh-clickable": "true",
                            rel: "noreferrer",
                            onClick: ()=>{
                                var ref;
                                return addTeaserLinkAnalytics(fullData, parentActionLink, bodytitle, containerId, props.data, datalayerPageName, fullData === null || fullData === void 0 ? void 0 : (ref = fullData.teaser) === null || ref === void 0 ? void 0 : ref.datalayerLinkName);
                            },
                            children: children
                        });
                    },
                    children: [
                        renderImage(),
                        (title || description || enableFav || enableShare || (actions === null || actions === void 0 ? void 0 : actions.length) || preTitle) && renderContent()
                    ]
                })
            }),
            !innerCaption && caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-img-caption",
                onClick: handleCaptionLinkClick,
                children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
            }) : null
        ]
    });
};
/* harmony default export */ var v1_Teaser = (Teaser);

;// CONCATENATED MODULE: ./components/Default/Carousel/v1/CarouselFiller.jsx



const CarouselFiller = (param)=>{
    let { itemsOrder =[] , items =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-carousel__whole",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-carousel__content",
            children: itemsOrder.map((itemOrder, i)=>{
                const item = items[itemOrder];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-carousel__item".concat(i === 0 ? " cmp-carousel__item--active" : ""),
                    role: "tabpanel",
                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                        data: item
                    })
                }, "carousel-".concat(i));
            })
        })
    });
};
/* harmony default export */ var v1_CarouselFiller = (CarouselFiller);

;// CONCATENATED MODULE: ./components/Default/Carousel/v1/Carousel.jsx










const Carousel_Carousel = (props)=>{
    const { data: { carouselComponentProperties: { appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , autoplay =false , id =""  } = {} , bodytitle ="" , texttitle ="" , description ="" , showSlideIndicators =true , slidertype =""  } = {} , fullData ={} , containerId ="" , configData ={}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [isOverlayScrollbar, setIsOverlayScrollbar] = (0,react.useState)(false);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [customClassNames, setCustomClassNames] = (0,react.useState)("");
    const [cmpCarouselCustomClass, setCmpCarouselCustomClass] = (0,react.useState)("");
    const [activeBanner, setActiveBanner] = (0,react.useState)(0);
    const scrollOptions = {
        className: "os-theme-dark cmp-carousel__whole",
        style: {
            height: "auto"
        },
        scrollbars: {
            visibility: "auto",
            autoHide: "never",
            clickScrolling: true,
            touchSupport: true,
            dragScrolling: true
        }
    };
    const showCarouselText = bodytitle || texttitle || description;
    const scrollerRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (scrollerRef.current) {
            setTimeout(()=>{
                document.querySelectorAll(".carousel-bottom-scroll").forEach((scrollDiv, index)=>{
                    let heightToSet = 0;
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".cmp-carousel__content").forEach((scrollDivContent, index)=>{
                        if (scrollDivContent && heightToSet < (scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight)) {
                            heightToSet = scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight;
                        }
                    });
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".os-content-glue").forEach((scrollDivglu, index)=>{
                        if (scrollDivglu && heightToSet > 0) {
                            scrollDivglu.style.height = heightToSet + "px";
                        }
                    });
                });
            }, 2000);
        }
    }, [
        scrollerRef.current
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-bottom-scroll")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small"))) {
            setIsOverlayScrollbar(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        const style = document.createElement("style");
        style.innerHTML = "\n    .bg-slate .carousel.carousel-seperator.carousel-bottom-scroll .os-scrollbar-track {\n      background-color: #888 !important;\n    }\n    .bg-slate .carousel.carousel-seperator.carousel-bottom-scroll .os-scrollbar-handle {\n      background-color: #fff !important;\n    }\n  ";
        document.head.appendChild(style);
        return ()=>{
            document.head.removeChild(style);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        itemsOrder.forEach((key, i)=>{
            var ref;
            const item = items[key];
            if ((item === null || item === void 0 ? void 0 : (ref = item.appliedCssClassNamesCustom) === null || ref === void 0 ? void 0 : ref.includes("hero-banner-des-medium-center")) && i === 0 && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("center-double-btn"))) {
                setCustomClassNames((className)=>className += " center-double-btn");
            }
        });
    }, [
        itemsOrder
    ]);
    (0,react.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("breadcrums-withcarosel paddingbasedbreadcrum"))) {
                setCustomClassNames((className)=>className += " breadcrums-withcarosel paddingbasedbreadcrum");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setCustomClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small")) && !(cmpCarouselCustomClass === null || cmpCarouselCustomClass === void 0 ? void 0 : cmpCarouselCustomClass.includes("carousel-btm-scroll-title-small"))) {
            setCmpCarouselCustomClass((className)=>className += " slide-scrollbar");
        }
    }, [
        appliedCssClassNames
    ]);
    const getNextBanner = ()=>{
        const nextBanner = activeBanner + 1;
        if (nextBanner < itemsOrder.length) {
            setActiveBanner(nextBanner);
        } else {
            setActiveBanner(0);
        }
    };
    const correctIDForDataLayer = id.startsWith("carousel-") ? containerId : id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "carousel ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(customClassNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-carousel".concat(cmpCarouselCustomClass),
            children: [
                showCarouselText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-carousel-text",
                    children: [
                        bodytitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__pretitle",
                            role: "heading",
                            "aria-level": "2",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(bodytitle)
                            }
                        }) : null,
                        texttitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__title",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(texttitle)
                            }
                        }) : null,
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__description",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(description)
                            }
                        }) : null
                    ]
                }) : null,
                !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: isOverlayScrollbar,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(overlayscrollbars_react_esm/* OverlayScrollbarsComponent */.E, {
                            options: scrollOptions,
                            ref: scrollerRef,
                            defer: true,
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cmp-carousel__content",
                        children: [
                            itemsOrder && itemsOrder.map((key, i)=>{
                                const item = items[key];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item".concat(i === activeBanner ? " cmp-carousel__item--active" : ""),
                                    role: "tabpanel",
                                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                        data: item,
                                        bodytitle: bodytitle,
                                        containerId: correctIDForDataLayer,
                                        configData: configData
                                    })
                                }, "carousel-".concat(i));
                            }),
                            (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cmp-carousel__actions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--previous",
                                        type: "button",
                                        "aria-label": "Previous",
                                        "data-cmp-hook-carousel": "previous",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Previous"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--next",
                                        type: "button",
                                        "aria-label": "Next",
                                        "data-cmp-hook-carousel": "next",
                                        onClick: getNextBanner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Next"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--pause",
                                        type: "button",
                                        "aria-label": "Pause",
                                        "data-cmp-hook-carousel": "pause",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Pause"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--play cmp-carousel__action--disabled",
                                        type: "button",
                                        "aria-label": "Play",
                                        "data-cmp-hook-carousel": "play",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Play"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (slidertype === "slideindicator" || showSlideIndicators) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                className: "".concat(slidertype === "slideindicator" || showSlideIndicators ? "cmp-carousel__indicators" : "cmp-carousel__hyphen"),
                                role: "tablist",
                                "aria-label": "Choose a slide to display",
                                "data-cmp-hook-carousel": "indicators",
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && itemsOrder.map((key, i, arr)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "cmp-carousel__indicator".concat(i === 0 ? " cmp-carousel__indicator--active" : ""),
                                        role: "tab",
                                        "aria-label": "Slide ".concat(i + 1),
                                        "data-cmp-hook-carousel": "indicator",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__indicator--activeNum",
                                                children: i + 1
                                            }),
                                            "/ ".concat(arr === null || arr === void 0 ? void 0 : arr.length)
                                        ]
                                    }, "carousel-".concat(i));
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselFiller, {
                    itemsOrder: itemsOrder,
                    items: items
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Carousel = (Carousel_Carousel);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./components/Default/CarouselSlick/v1/CarouselSlick.module.scss
var CarouselSlick_module = __webpack_require__(43419);
var CarouselSlick_module_default = /*#__PURE__*/__webpack_require__.n(CarouselSlick_module);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/Default/Image/v1/Image.jsx



const Image_Image = (props)=>{
    const { data: { id: uniqueId = "" , alt ="" , src: imgUrl = "" , imageComponentProperties ={
        src: "",
        alt: ""
    } , enableNoImage =false  } = {}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "eaem-bounding-div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-image",
                children: !enableNoImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                    uniqueId,
                    imgUrl: imgUrl || imageComponentProperties.src,
                    alt: alt || imageComponentProperties.alt,
                    className: "cmp-image__image transition"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                    alt: "image coming soon",
                    className: "no-image"
                })
            })
        })
    });
};
/* harmony default export */ var v1_Image = (Image_Image);

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/AnalyticCarouselSlick.js
const getDataLayerValues = function(isSSR) {
    let pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", linkName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (!isSSR && window) {
        var ref;
        const dataLayer = (ref = window === null || window === void 0 ? void 0 : window.adobeDataLayer) !== null && ref !== void 0 ? ref : {};
        var _page;
        const page = (_page = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.getState().page) !== null && _page !== void 0 ? _page : {};
        if (Object.keys(page).length) {
            const eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventMsg: "n/a",
                eventName: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventStatus: "n/a",
                eventType: "teaser",
                internalLinkName: "".concat(linkName.toLowerCase()),
                internalLinkPosition: "".concat(pageName, ":teaser"),
                internalLinkType: "".concat(pageName, ":").concat(linkName.toLowerCase()),
                internalLinkURL: "".concat(link),
                internalLinkZoneName: "".concat(pageName, ":").concat(title.toLowerCase())
            };
            return JSON.stringify(eventInfo);
        }
    }
    return "";
};
const addAnalyticsSlic = function(event) {
    let pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", datalayerTitleText = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", componentLinkType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", componentPosition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", link = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    const titleOptions = [
        "showerheads",
        "handshowers",
        "body sprays",
        "rainheads"
    ];
    event.stopPropagation();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    let eventInfo = {};
    if (titleOptions.some((title)=>datalayerTitleText === title)) {
        eventInfo = {
            eventAction: "pdp:complete the experience:".concat(datalayerTitleText),
            eventName: "pdp:complete the experience:".concat(datalayerTitleText),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: datalayerTitleText,
            internalLinkPosition: "pdp:teaser",
            internalLinkType: "pdp:".concat(datalayerTitleText),
            internalLinkZoneName: "pdp:complete the experience",
            internalLinkURL: link || "na",
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventName: "".concat(pageName, ":carousel:interaction"),
            eventAction: "".concat(pageName, ":carousel:interaction"),
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "carousel:".concat(datalayerTitleText || "rm"),
            internalLinkType: "".concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm"),
            internalLinkZoneName: "".concat(pageName, ":carousel"),
            clickInternalLinks: "true",
            eventType: "carousel",
            internalLinkURL: link || "na",
            internalLinkPosition: "".concat(pageName, ":").concat(componentPosition || "carousel")
        };
    }
    AnalyticCarouselSlick_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const AnalyticCarouselSlick_pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/CarouselSlick.jsx


















const CarouselSlick = (props)=>{
    var ref;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data , data: { carouselComponentProperties: { id ="" , autoplay =false , delay =constants["default"].SLICK.DEFAULT_DELAY , appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , accessibilityLabel =""  } = {} , pageName ="" , datalayerTitleText ="" , componentLinkType ="" , link: linkUrl = "" , componentPosition ="" , linkAll =false , isNewTab =false , bodytitle ="" , texttitle ="" , description ="" , actionsEnabled =false , text ="" , showSlideIndicators =false , centerMode =false  } = {} , fullData ={}  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const configData = useConfig();
    const generatedLinkURL = (0,helper/* getShortenedUrlwithGeneral */.vu1)(linkUrl, configData);
    const sliderDelay = 1500;
    const [slickSettings, setSlickSettings] = (0,react.useState)({});
    const [cardIndex, setCardIndex] = (0,react.useState)(0);
    const [sliderKey, setSliderKey] = (0,react.useState)("");
    const [cardCount, setCardCount] = (0,react.useState)(0);
    const [isDoubleFeatureContentCard, setIsDoubleFeatureContentCard] = (0,react.useState)(false);
    const [isSingleSlider, setIsSingleSlider] = (0,react.useState)(false);
    const [isSingleItemsSlider, setIsSingleItemsSlider] = (0,react.useState)(false);
    const [isFeatureContentSlider, setIsFeatureContentSlider] = (0,react.useState)(false);
    const [carouselVertical, setCarouselVertical] = (0,react.useState)(false);
    const [isInspiredThemeCarouselSlider, setIsInspiredThemeCarouselSlider] = (0,react.useState)(false);
    const [activeSlide, setActiveSlide] = (0,react.useState)(1);
    const [link, setLink] = (0,react.useState)(generatedLinkURL);
    const carouselHeaderInfoRef = (0,react.useRef)(null);
    const sliderRef = (0,react.useRef)(null);
    const sliderCounterRef = (0,react.useRef)(null);
    const [topContentHeight, setTopContentHeight] = (0,react.useState)(0);
    const [sliderImageHeight, setSliderImageHeight] = (0,react.useState)(0);
    const [countHeight, setCountHeight] = (0,react.useState)(0);
    const [arrowHeight, setArrowHeight] = (0,react.useState)(0);
    const [sliderRerenderKey, setSliderRerenderKey] = (0,react.useState)("");
    const [teaserImagePosition, setTeaserImagePosition] = (0,react.useState)({});
    const [counterParentHeight, setCounterParentHeight] = (0,react.useState)(0);
    let dynamicMediaTimer;
    const getImageHeight = (list)=>{
        if (dynamicMediaTimer) {
            clearTimeout(dynamicMediaTimer);
            dynamicMediaTimer = undefined;
        }
        // using query selector as s7responsiveImage is invoking functions on real dom elements ans was unable to get updated data using useRef
        const teaserImages = list.querySelectorAll(".slick-active .teaser .cmp-teaser__image .cmp-image");
        var ref;
        const teaserImageComponent = (ref = teaserImages[0]) !== null && ref !== void 0 ? ref : null;
        let teaserImage = null;
        if (teaserImageComponent) {
            teaserImage = teaserImageComponent.querySelector("img");
        }
        let imageUrl = null;
        if (teaserImage) {
            imageUrl = teaserImage === null || teaserImage === void 0 ? void 0 : teaserImage.currentSrc;
        }
        if (!window.s7responsiveImage || !imageUrl || imageUrl && imageUrl.startsWith("data:")) {
            dynamicMediaTimer = setTimeout(()=>getImageHeight(list), 200);
            return;
        }
        const imageHeight = teaserImageComponent === null || teaserImageComponent === void 0 ? void 0 : teaserImageComponent.offsetHeight;
        if (carouselVertical) {
            const teaserContent = list.querySelector(".cmp-teaser__content");
            const teaserContectHeight = teaserContent ? teaserContent.offsetHeight : 0;
            setTeaserImagePosition({
                imgHeight: imageHeight,
                ctHeight: teaserContectHeight
            });
        }
        if (imageHeight) setSliderImageHeight(imageHeight);
    };
    (0,react.useEffect)(()=>{
        const { current: { offsetHeight =0  } = {}  } = carouselHeaderInfoRef;
        if (offsetHeight > 0) {
            setTopContentHeight(offsetHeight);
        }
    }, [
        carouselHeaderInfoRef
    ]);
    (0,react.useEffect)(()=>{
        const { current: { innerSlider: { list  }  } = {}  } = sliderRef;
        if (list && sliderRerenderKey) {
            getImageHeight(list);
        }
    }, [
        sliderRef,
        sliderRerenderKey
    ]);
    (0,react.useEffect)(()=>{
        const handleWindowResize = ()=>{
            const { current: { innerSlider: { list  }  } = {}  } = sliderRef;
            getImageHeight(list);
            setCounterPosition();
        };
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    const setCounterPosition = ()=>{
        let countHeight = parseInt(topContentHeight) + parseInt(sliderImageHeight) + constants["default"].SLICK.COUNT_OFFSET;
        let sliderImageWithCounterHeight = 0;
        let sliderImageWithArrowHeight = 0;
        if (carouselVertical) {
            const ctHeight = teaserImagePosition === null || teaserImagePosition === void 0 ? void 0 : teaserImagePosition.ctHeight;
            const imgHeight = teaserImagePosition === null || teaserImagePosition === void 0 ? void 0 : teaserImagePosition.imgHeight;
            countHeight = ctHeight && imgHeight ? imgHeight - ctHeight - 70 : 0;
            if (lib/* isMobile */.tq) {
                countHeight = imgHeight ? imgHeight + topContentHeight - 80 : 0;
            }
            if ((window === null || window === void 0 ? void 0 : window.innerWidth) > 767) {
                countHeight = ctHeight && imgHeight ? imgHeight - ctHeight - 70 : 0;
            }
            sliderImageWithArrowHeight = parseInt(sliderImageHeight) + constants["default"].SLICK.ARROW_OFFSET;
        } else {
            var ref, ref1, ref2;
            sliderImageWithCounterHeight = (ref2 = sliderCounterRef === null || sliderCounterRef === void 0 ? void 0 : (ref = sliderCounterRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.parentElement) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".slick-active .teaser .cmp-teaser__image .cmp-image")) === null || ref2 === void 0 ? void 0 : ref2.offsetHeight;
            const topContentOffeset = topContentHeight !== null && topContentHeight !== void 0 ? topContentHeight : 0;
            if (sliderImageWithCounterHeight) countHeight = topContentOffeset + parseInt(sliderImageWithCounterHeight) + constants["default"].SLICK.COUNT_OFFSET;
            sliderImageWithArrowHeight = parseInt(sliderImageWithCounterHeight) + constants["default"].SLICK.ARROW_OFFSET;
        }
        setCountHeight(countHeight);
        if (winWidth <= 1023) {
            setArrowHeight(sliderImageWithArrowHeight);
        }
    };
    (0,react.useEffect)(()=>{
        var ref;
        const parent = (ref = sliderCounterRef.current) === null || ref === void 0 ? void 0 : ref.parentElement;
        if (!parent) return;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries){
                setCounterParentHeight(entry.contentRect.height);
            }
        });
        observer.observe(parent);
        return ()=>observer.disconnect();
    }, [
        sliderCounterRef
    ]);
    (0,react.useEffect)(()=>{
        setCounterPosition();
    }, [
        topContentHeight,
        sliderImageHeight,
        carouselVertical,
        teaserImagePosition,
        winWidth,
        counterParentHeight
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData) && (isDoubleFeatureContentCard || carouselVertical)) {
            const cardCount = Object.keys(fullData).length - 1;
            setCardCount(cardCount);
            Object.keys(fullData).forEach((key, index)=>{
                if (isEqual_default()(fullData[key], data)) {
                    setCardIndex(index + 1);
                }
            });
        }
    }, [
        fullData,
        isDoubleFeatureContentCard
    ]);
    (0,react.useEffect)(()=>{
        let timer;
        if (isDoubleFeatureContentCard) {
            if (cardIndex > 0 && cardCount > 0) {
                const delay = 1500 * (cardIndex - 1);
                timer = setTimeout(()=>{
                    setSlickSettings(()=>({
                            ...SlickSettings/* doubleFeatureContentCardSettings */.Cu,
                            autoplay: true,
                            speed: 2 * sliderDelay,
                            autoplaySpeed: cardCount * sliderDelay
                        }));
                    setSliderKey(cardIndex);
                }, delay);
            }
        }
        return ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        cardIndex,
        cardCount,
        isDoubleFeatureContentCard
    ]);
    const getSliderCount = ()=>{
        if (window) {
            return window.innerWidth > 1140 ? 4 : window.innerWidth > 640 ? 2 : 1;
        } else {
            return winWidth > 1140 ? 4 : winWidth > 640 ? 2 : 1;
        }
    };
    (0,react.useEffect)(()=>{
        if (isSingleSlider) {
            const slickSettings = (0,SlickSettings/* singleSliderSettings */.NW)(setActiveSlide, arrowHeight, autoplay, delay);
            setSlickSettings(slickSettings);
        }
        if (isSingleItemsSlider || isFeatureContentSlider) {
            const settings = (0,SlickSettings/* singleSliderSettings */.NW)(setActiveSlide, arrowHeight, autoplay, delay);
            const slickSettings1 = ()=>({
                    ...settings,
                    ...isSingleItemsSlider ? {
                        centerPadding: window.innerWidth > 1600 ? window.innerWidth / 8 : 72
                    } : {},
                    centerMode: (0,SlickSettings/* isProductFeatureLandscapeCarouselUpdatePage */.UD)(pageName) ? centerMode : window.innerWidth >= 640
                });
            setSlickSettings(slickSettings1());
        }
        if (isInspiredThemeCarouselSlider) {
            const settings1 = (0,SlickSettings/* singleSliderSettings */.NW)();
            const slickSettings2 = ()=>({
                    ...settings1,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    slidesToScroll: 1,
                    slidesToShow: getSliderCount()
                });
            setSlickSettings(slickSettings2());
        }
        if (carouselVertical) {
            const settings2 = (0,SlickSettings/* singleSliderSettings */.NW)(setActiveSlide);
            const slickSettings3 = ()=>({
                    ...settings2,
                    autoplay: true,
                    fade: true,
                    autoplaySpeed: 5000,
                    arrows: false
                });
            setSlickSettings(slickSettings3());
        }
    }, [
        isSingleSlider,
        isSingleItemsSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        carouselVertical,
        arrowHeight
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("two-column-layout")) {
            setIsDoubleFeatureContentCard(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("feature-collection-carousel")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("room-inspiration-carousel"))) {
            setIsSingleSlider(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-text-left-overlap")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("full-bleed-image-hover"))) {
            setIsSingleItemsSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("featured-content-carousel")) {
            setIsFeatureContentSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("inspired-theme-carousel")) {
            setIsInspiredThemeCarouselSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-vertical")) {
            setCarouselVertical(true);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (isEmpty_default()(configData)) {
            if (linkUrl) {
                (0,helper/* getShortenedUrl */.Ppy)(linkUrl).then((res)=>{
                    setLink(res);
                });
            }
        }
    }, [
        linkUrl
    ]);
    (0,react.useEffect)(()=>{
        let key = "slider-default";
        if (sliderKey) {
            key = "slider-".concat(sliderKey);
        }
        if (isSingleItemsSlider || isSingleSlider || isFeatureContentSlider || isInspiredThemeCarouselSlider || carouselVertical) {
            key = "slider-".concat(id ? id : appliedCssClassNames);
        }
        setSliderRerenderKey(key);
    }, [
        sliderKey,
        isSingleItemsSlider,
        isSingleSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        carouselVertical
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ".concat(carouselVertical ? (CarouselSlick_module_default()).CarouselSlickVertical : ""),
                role: "group",
                "aria-label": accessibilityLabel || undefined,
                "aria-roledescription": "carousel",
                "data-gbh-data-layer": '{"eventName":"'.concat(pageName, ':carousel:interaction","eventAction":"').concat(pageName, ':carousel:interaction","internalLinkName":"carousel:').concat(datalayerTitleText || "rm", '","internalLinkType":"').concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm", '","clickInternalLinks":"true","eventType":"carousel","internalLinkPosition":"').concat(pageName, ":").concat(componentPosition || "carousel", '"}'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: link,
                            onClick: (event)=>{
                                addAnalyticsSlic(event, pageName, datalayerTitleText, componentLinkType, componentPosition, link);
                            },
                            target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self"),
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "carousel-header-info",
                                ref: carouselHeaderInfoRef,
                                children: [
                                    bodytitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__pretitle",
                                        dangerouslySetInnerHTML: {
                                            __html: bodytitle
                                        }
                                    }),
                                    texttitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__title ".concat(carouselVertical ? "verticalCarouselTitle" : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: texttitle
                                        }
                                    }),
                                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__description ".concat(carouselVertical ? "verticalCarouselTitleDescription" : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: description
                                        }
                                    }),
                                    (0,helper/* convertStringToBoolean */.mUs)(actionsEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "cmp-carousel__action-container",
                                        children: [
                                            !(0,helper/* convertStringToBoolean */.mUs)(linkAll) && link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: link,
                                                className: "cmp-carousel__action-link",
                                                target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self"),
                                                "data-gbh-data-layer": getDataLayerValues(isSsr, pageName, link, (0,helper/* sanitizeTextArticle */.pkm)(texttitle), (0,helper/* sanitizeTextArticle */.pkm)(text)),
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(text)
                                            }),
                                            ((0,helper/* convertStringToBoolean */.mUs)(linkAll) || !link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cmp-carousel__action-link",
                                                dangerouslySetInnerHTML: {
                                                    __html: text
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                ...slickSettings,
                                className: "cmp-carousel-slick__content",
                                ref: sliderRef,
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((key, index, arr)=>{
                                    const item = items[key];
                                    const isActive = index === activeSlide;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "group",
                                        "aria-roledescription": "slide",
                                        tabIndex: isActive && index <= arr.length ? 0 : -1,
                                        "aria-hidden": isActive && index <= arr.length ? "false" : "true",
                                        "aria-label": "Slide ".concat(index + 1, " of ").concat(arr.length),
                                        children: [
                                            isDoubleFeatureContentCard && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
                                                data: item
                                            }) : null,
                                            isSingleItemsSlider || isSingleSlider || isFeatureContentSlider || isInspiredThemeCarouselSlider || carouselVertical ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                                                fullData: fullData,
                                                data: item,
                                                showEmptyPlaceholder: showSlideIndicators,
                                                maxHeight: sliderImageHeight,
                                                pageName: pageName
                                            }) : null
                                        ]
                                    }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cpm-carousel-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                                }))
                            }, "".concat(sliderRerenderKey)),
                            showSlideIndicators && !isDoubleFeatureContentCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "slider__counter",
                                style: {
                                    top: countHeight + "px"
                                },
                                ref: sliderCounterRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "current-count",
                                        children: activeSlide
                                    }),
                                    "/",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "total-count",
                                        children: data["carouselComponentProperties"] && ((ref = data["carouselComponentProperties"][":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length)
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hide",
                children: showSlideIndicators
            })
        ]
    });
};
/* harmony default export */ var v1_CarouselSlick = (CarouselSlick);

;// CONCATENATED MODULE: ./components/Shared/MainFooter/analytics.js

const addAnalyticsOnClick = function(eventInfoKey, item) {
    let quadrantTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", url = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    const internalLinkPosition = (0,helper/* sanitizeTextArticle */.pkm)(quadrantTitle.toLowerCase());
    let eventInfo;
    var ref1;
    const brandName = (ref1 = item === null || item === void 0 ? void 0 : (ref = item.brandNameOne) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref1 !== void 0 ? ref1 : "";
    switch(eventInfoKey){
        case "firstLink":
            eventInfo = {
                clickInternalLinks: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "false" : "true"),
                internalLinkPosition: "".concat(internalLinkPosition),
                internalLinkZoneName: "global footer",
                internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(url)) : "n/a",
                internalLinkName: "".concat(brandName),
                eventName: "footer menu:".concat(brandName),
                internalLinkType: "global footer:navigation",
                eventType: "footer submenu",
                eventAction: "footer menu:".concat(brandName)
            };
            break;
        case "linkThree":
            var ref2, ref3, ref4;
            eventInfo = {
                clickInternalLinks: "".concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? "false" : "true"),
                internalLinkPosition: "".concat(internalLinkPosition),
                internalLinkZoneName: "global footer",
                internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(url)) : "n/a",
                internalLinkName: "".concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameFour) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                eventName: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameFour) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                internalLinkType: "global footer:navigation",
                eventType: "footer submenu",
                eventAction: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameFour) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase())
            };
            break;
        case "oddEven":
            var ref5, ref6, ref7;
            eventInfo = {
                clickInternalLinks: "".concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? "false" : "true"),
                internalLinkPosition: "".concat(internalLinkPosition),
                internalLinkZoneName: "global footer",
                internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(url)) : "n/a",
                internalLinkName: "".concat(item === null || item === void 0 ? void 0 : (ref5 = item.brandNameTwo) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                eventName: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref6 = item.brandNameTwo) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase()),
                internalLinkType: "global footer:navigation",
                eventType: "footer submenu",
                eventAction: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref7 = item.brandNameTwo) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase())
            };
            break;
        default:
            eventInfo = null;
    }
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo !== null && eventInfo !== void 0 ? eventInfo : null);
};

;// CONCATENATED MODULE: ./components/Shared/MainFooter/index.jsx






const MainFooter = (props)=>{
    const { data , columnClassNames  } = props;
    const [gbhExpand, setGbhExpand] = (0,react.useState)([]);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const footerTitleRole = winWidth < 1024 ? "button" : "heading";
    const isExpanded = (key)=>gbhExpand.includes(key);
    const getExpandedClassname = (key)=>isExpanded(key) ? "gbh-expand" : "";
    const handleGbhExpand = (key)=>{
        if (!isExpanded(key)) {
            const newGbhExpand = [
                ...gbhExpand
            ];
            newGbhExpand.push(key);
            setGbhExpand(newGbhExpand);
        } else {
            const newGbhExpand1 = [
                ...gbhExpand
            ];
            const idx = gbhExpand.indexOf(key);
            newGbhExpand1.splice(idx, 1);
            setGbhExpand(newGbhExpand1);
        }
    };
    const handleOnLinkClick = (param)=>{
        let { linkName , item , quadrantTitle , windowFeature ="" , target , url =""  } = param;
        addAnalyticsOnClick(linkName, item, quadrantTitle, url);
        url && window.open(url, target, windowFeature);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((Shared_index_module_default()).mainFooterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "gbh-footer-main-nav main-footer",
                "aria-label": "Footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) === "descriptionOne" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleOne
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "gbh-find-store",
                                                role: "listitem",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescOne)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) === "linksOne" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksOne")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksOne"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksOne"),
                                                    "aria-controls": "footer-inner-links-linksOne",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleOne)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksOne") ? {
                                                        display: "none"
                                                    } : {},
                                                    id: "footer-inner-links-linksOne",
                                                    children: data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "gbh-data-layer",
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameOne).concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? " external link opens in a new tab" : ""),
                                                                    onClick: ()=>{
                                                                        var ref;
                                                                        return handleOnLinkClick({
                                                                            linkName: "firstLink",
                                                                            item,
                                                                            quadrantTitle: data === null || data === void 0 ? void 0 : data.quadrantTitleOne,
                                                                            target: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "_blank" : "_self"),
                                                                            windowFeature: "noreferrer",
                                                                            url: item === null || item === void 0 ? void 0 : (ref = item.brandLinkOne) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")
                                                                        });
                                                                    },
                                                                    tabIndex: "0",
                                                                    children: item === null || item === void 0 ? void 0 : item.brandNameOne
                                                                })
                                                            })
                                                        }, "gbh-footer-main-nav-link-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleTwo,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationTwo) === "descriptionTwo" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "footer-inner-head",
                                                role: "heading",
                                                "aria-level": "2",
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleTwo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescTwo)
                                                }
                                            })
                                        ]
                                    }),
                                    data.radioNavigationTwo === "linksTwo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksTwo")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksTwo"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksTwo"),
                                                    "aria-controls": "footer-inner-links-linksTwo",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleTwo)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksTwo") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsOne.length) > 4 ? "odd-even" : "",
                                                    id: "footer-inner-links-linksTwo",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsOne.map((item, index)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameTwo).concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? " external link opens in a new tab" : ""),
                                                                onClick: ()=>{
                                                                    var ref;
                                                                    return handleOnLinkClick({
                                                                        url: item === null || item === void 0 ? void 0 : (ref = item.brandLinkTwo) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                        linkName: "oddEven",
                                                                        quadrantTitle: data === null || data === void 0 ? void 0 : data.quadrantTitleTwo,
                                                                        item,
                                                                        windowFeature: "noreferrer",
                                                                        target: (item === null || item === void 0 ? void 0 : item.newTabTwo) ? "_blank" : "_self"
                                                                    });
                                                                },
                                                                tabIndex: "0",
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameTwo) && (item === null || item === void 0 ? void 0 : item.brandNameTwo)
                                                            })
                                                        }, "linksTwo-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleThree,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.descriptionThree) === "descriptionThree" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleThree
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescThree)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationThree) === "linksThree" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksThree")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksThree"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksThree"),
                                                    "aria-controls": "footer-inner-links-linksThree",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleThree)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksThree") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsTwo.length) > 4 ? "odd-even" : "",
                                                    id: "footer-inner-links-linksThree",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsTwo.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkThree) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabThree) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameThree).concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleThree.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkThree) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameThree) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameThree) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameThree) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                tabIndex: "0",
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameThree) && (item === null || item === void 0 ? void 0 : item.brandNameThree)
                                                            })
                                                        }, "linksThree-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleFour,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) === "descriptionFour" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleFour
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescFour)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) === "linksFour" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksFour")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksFour"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksFour"),
                                                    "aria-controls": "footer-inner-links-linksFour",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleFour)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksFour") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsThree.length) > 4 ? "odd-even" : "",
                                                    id: "footer-inner-links-linksFour",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsThree.map((item, index)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameFour).concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? " external link opens in a new tab" : ""),
                                                                onClick: ()=>{
                                                                    var ref;
                                                                    return handleOnLinkClick({
                                                                        url: item === null || item === void 0 ? void 0 : (ref = item.brandLinkFour) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                        linkName: "linkThree",
                                                                        item,
                                                                        quadrantTitle: data === null || data === void 0 ? void 0 : data.quadrantTitleFour,
                                                                        windowFeature: "noreferrer",
                                                                        target: (item === null || item === void 0 ? void 0 : item.newTabFour) ? "_blank" : "_self"
                                                                    });
                                                                },
                                                                tabIndex: "0",
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameFour) && (item === null || item === void 0 ? void 0 : item.brandNameFour)
                                                            })
                                                        }, "linksThree-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_MainFooter = (MainFooter);

// EXTERNAL MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(46394);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button_Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal_Modal = __webpack_require__(78145);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/SubscribeInfoModal.jsx






const SubscribeInfoModal = (props)=>{
    var ref, ref1, ref2;
    const { show , handleModalClose , handleModalMsg , homePagePath , className , staticTexts , modalContent: modalContent  } = props;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            const newsContent = document.querySelector(".newsletter__success");
            if (newsContent !== null) {
                var ref;
                const hrefLink = (ref = newsContent.childNodes[0]) === null || ref === void 0 ? void 0 : ref.childNodes[5];
                if (hrefLink !== null || hrefLink !== undefined) {
                    hrefLink.addEventListener("click", (e)=>{
                        handleModalMsg(hrefLink.getAttribute("href"));
                    });
                }
            }
        }, 200);
    }, [
        show
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            var ref, ref1, ref2;
            (ref2 = (ref1 = (ref = document.querySelector(".newsletter__success")) === null || ref === void 0 ? void 0 : ref.childNodes[0]) === null || ref1 === void 0 ? void 0 : ref1.childNodes[5]) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click");
        };
    }, []);
    const { getReady , signupSuccess , getStarted  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal["default"], {
        showModal: show,
        onModalClose: handleModalClose,
        modalTitle: getReady !== null && getReady !== void 0 ? getReady : "",
        describedBy: "newsletter-description",
        labelledBy: "newsletter-title",
        className: "".concat(className ? className : "", " newsletter"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "newsletter",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newsletter__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__thanks test-class",
                        id: "newsletter-title",
                        children: !isEmpty_default()(modalContent) ? (0,helper/* sanitizeInnerHtml */.KD0)(modalContent === null || modalContent === void 0 ? void 0 : (ref = modalContent.modalContent) === null || ref === void 0 ? void 0 : ref.title) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(getReady)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__success",
                        id: "newsletter-description",
                        children: !isEmpty_default()(modalContent) ? (0,helper/* sanitizeInnerHtml */.KD0)(modalContent === null || modalContent === void 0 ? void 0 : (ref1 = modalContent.modalContent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.description) === null || ref2 === void 0 ? void 0 : ref2.split("/content/kohler/us").join("").replace(".html", "")) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(signupSuccess)
                        })
                    }),
                     false && /*#__PURE__*/ 0
                ]
            })
        })
    });
};
/* harmony default export */ var NewsletterFooter_SubscribeInfoModal = (SubscribeInfoModal);

// EXTERNAL MODULE: ./components/Shared/NewsletterFooter/index.module.scss
var NewsletterFooter_index_module = __webpack_require__(62582);
var NewsletterFooter_index_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterFooter_index_module);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/localization.js
const getTranslations = (t)=>{
    return {
        thanks: t("kf.newsletter.label.thanks"),
        getReady: t("kf.newsletter.label.getReady"),
        signupSuccess: t("kf.newsletter.label.signupSuccess"),
        signUp: t("kf.newsletter.label.signUp"),
        getStarted: t("kf.newsletter.label.getStarted"),
        enterEmail: t("kf.newsletter.label.enterEmail"),
        validEmail: t("kf.newsletter.label.validEmail"),
        genError: t("kf.error.message.genericError"),
        alreadySubscribed: t("kf.newsletter.label.alreadySubscribed")
    };
};

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/newsLetterBody.js
const newsLetterBody = function(sBrandName, sEmailAddress) {
    let language = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en", additionalValues = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    const aValues = {
        AnnSacks: {
            "Subscribe Ann Sacks": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Ann Sacks"
        },
        Sterling: {
            "Subscribe Sterling Plumbing": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Sterling"
        },
        Kohler: {
            "Subscribe Kohler Kitchen and Bath": "TRUE",
            "Subscribe Kohler KB Website Interaction": "TRUE",
            "Kitchen Bath Recent Source": "Website Footer Email Signup_Kohler"
        },
        "kohler-canada": {
            "Subscribe Kohler Canada": "TRUE",
            "Kitchen Bath Recent Source": "Website Footer Email Signup_Canada_English",
            LanguagePref: language
        },
        Kallista: {
            "Subscribe Kallista": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Kallista"
        },
        Robern: {
            "Subscribe Sterling Plumbing": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Sterling"
        }
    };
    if (aValues[sBrandName]) {
        aValues[sBrandName]["EmailAddress"] = sEmailAddress;
        aValues[sBrandName]["Date Updated"] = new Date().toISOString();
    }
    if (additionalValues) {
        aValues[sBrandName] = {
            ...aValues[sBrandName],
            ...additionalValues
        };
    }
    const body = {
        keys: {
            SubscriberKey: sEmailAddress
        },
        values: aValues[sBrandName] || []
    };
    return [
        body
    ];
};
/* harmony default export */ var NewsletterFooter_newsLetterBody = (newsLetterBody);

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/NewsletterFooter.jsx















const NewsletterFooter = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [validationError, setValidationError] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [captchaActive, setCaptchaActive] = (0,react.useState)(false);
    const submitButton = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [siteName, setSiteName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [homePagePath, setHomePagePath] = (0,react.useState)("/");
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [isResetForm, setIsResetForm] = (0,react.useState)(false);
    const [isAlreadyExist, setIsAlreadyExist] = (0,react.useState)(false);
    const { subscribeModal  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data , columnClassNames  } = props;
    const addNewsletterSignupAnalytics = (status, message)=>{
        if (window.adobeDataLayer) {
            const eventInfo = {
                "@type": (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) + "/components/newslettersignin",
                eventMsg: message || "n/a",
                eventStatus: status,
                clickInternalLinks: "true",
                internalLinkPosition: "newslettersignin",
                internalLinkZoneName: "global footer",
                internalLinkURL: "n/a",
                internalLinkName: "newsletter submit",
                eventName: "newsletter submit",
                internalLinkType: "global footer:submit",
                eventType: "click",
                eventAction: "newsletter submit"
            };
            const page = window.pageObj || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    const subModalAnalytics = (msg, hreflink)=>{
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = {
                eventMsg: "n/a",
                eventStatus: "n/a",
                clickInternalLinks: "true",
                internalLinkPosition: "newsletter:signin complete",
                internalLinkZoneName: "newsletter submit:get ready",
                internalLinkURL: hreflink ? msg + hreflink : "n/a",
                internalLinkName: msg,
                eventName: "newsletter submit:get ready:".concat(msg),
                internalLinkType: "newsletter submit:get ready",
                eventType: "navigation",
                eventAction: "newsletter submit:get ready:".concat(msg)
            };
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (isResetForm) setEmail("");
        if (isAlreadyExist) setValidationError(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed);
    }, [
        isResetForm,
        isAlreadyExist
    ]);
    (0,react.useEffect)(()=>{
        setCaptchaActive(false);
        setStaticTexts(getTranslations(t));
        setInitalData();
    }, []);
    const handleModalClose = ()=>{
        subModalAnalytics("close");
        setIsShowModal(false);
    };
    const handleModalMsg = (hreflink)=>{
        subModalAnalytics("".concat(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(), ".com"), hreflink);
    };
    const setInitalData = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        setSiteName(get_default()(config, "general.siteName", ""));
        setLanguage(get_default()(config, "internationalization.language", "en"));
        setHomePagePath(await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.homepageUrl", "/")));
    };
    const getSubscriptionData = (email)=>{
        const body = NewsletterFooter_newsLetterBody(siteName, email, language);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                constants_api/* apim.post */.TH.post(constants.emailSubscribeEndPoint, body, {
                    params: {
                        brand: siteName
                    }
                }).then((response)=>{
                    if (response && response.data) {
                        var _resultMessages;
                        const isSuccess = (_resultMessages = response.data.resultMessages) !== null && _resultMessages !== void 0 ? _resultMessages : [];
                        if (isSuccess) {
                            setIsShowModal(true);
                            setIsResetForm(true);
                        }
                        setEmail("");
                        addNewsletterSignupAnalytics("success");
                    } else {
                        addNewsletterSignupAnalytics("failure", "news letter subscription api: error occured while fetching data from get url property");
                    // log.error(
                    //   "News letter subscription API: Error occured while fetching data from Get URL Property"
                    // )
                    }
                }).catch((err)=>{
                    var ref, ref1;
                    if (((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) === "Email address already subscribed") {
                        setIsAlreadyExist(true);
                        addNewsletterSignupAnalytics("failure", staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed.toLowerCase());
                    } else {
                        console.log(staticTexts.genError);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: staticTexts.genError,
                            isVisible: true
                        }));
                        addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
                    }
                });
            } else {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts.genError,
                    isVisible: true
                }));
                addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
            }
        }).catch(()=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts.genError,
                isVisible: true
            }));
            addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
        });
    };
    const onSubmit = async ()=>{
        if (email === "" || email == null || (email === null || email === void 0 ? void 0 : email.length) === 0) {
            setValidationError(staticTexts.enterEmail);
            addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
        }
        if ((email === null || email === void 0 ? void 0 : email.length) > 0) {
            const isValid = await (0,helper/* validateField */.OP$)("email", email);
            if (!isValid) {
                addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
                setValidationError(staticTexts.validEmail);
            } else {
                setValidationError("");
                getSubscriptionData(email);
            }
        }
        handleFocus();
    };
    const handleFocus = ()=>{
        // removing focus
        submitButton.current.blur();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((NewsletterFooter_index_module_default()).wrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "gbh-footer-newsletter-nav",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "gbh-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "gbh-footer-news-letter",
                                    "aria-label": data === null || data === void 0 ? void 0 : data.title,
                                    role: "list",
                                    children: [
                                        (data === null || data === void 0 ? void 0 : data.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: data === null || data === void 0 ? void 0 : data.title
                                        }) : null,
                                        (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.description),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-group newsletter-form-group",
                                            role: "listitem",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "newsletter_input",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-control",
                                                        type: "text",
                                                        "aria-label": data === null || data === void 0 ? void 0 : data.placeholder,
                                                        placeholder: data === null || data === void 0 ? void 0 : data.placeholder,
                                                        maxLength: "60",
                                                        id: "newsletter_input",
                                                        onChange: (e)=>setEmail(e.target.value),
                                                        value: email,
                                                        title: data === null || data === void 0 ? void 0 : data.placeholder,
                                                        "data-testid": "newsletter-input"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.submit) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    "aria-label": "Submit button. Tap or click here to subscribe for Koher newsletter to receive news and promotions.",
                                                    className: "btn btn-secondary ".concat(email.length ? "active-btn" : ""),
                                                    id: "newsletter_submit",
                                                    onClick: ()=>onSubmit(),
                                                    ref: submitButton,
                                                    "data-testid": "newsletter-submit",
                                                    children: data === null || data === void 0 ? void 0 : data.submit
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "listitem",
                                            className: "subsribe-error-container",
                                            children: validationError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                id: "subsribe-mail-error",
                                                tabIndex: "0",
                                                "data-testid": "email-error",
                                                children: (0,helper/* sanitizeDOMString */.TRt)(validationError)
                                            })
                                        })
                                    ]
                                })
                            }),
                            captchaActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_SubscribeInfoModal, {
                show: isShowModal,
                handleModalClose: handleModalClose,
                handleModalMsg: handleModalMsg,
                staticTexts: staticTexts,
                homePagePath: homePagePath,
                className: (NewsletterFooter_index_module_default()).wrapper,
                setEmail: setEmail,
                modalContent: subscribeModal
            })
        ]
    });
};
/* harmony default export */ var NewsletterFooter_NewsletterFooter = (NewsletterFooter);

;// CONCATENATED MODULE: ./components/Shared/AdditionalFooter.jsx





const AdditionalFooter = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    const { data , columnClassNames  } = props;
    const router = (0,next_router.useRouter)();
    const [location, setLocation] = (0,react.useState)("");
    const [docTitle, setDocTitle] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setLocation(window.location.href);
        setDocTitle(document.title);
    }, [
        router.pathname
    ]);
    const getHref = (item)=>{
        var ref;
        return item.link !== "#" ? {
            href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")
        } : "";
    };
    const getRole = (item)=>item.link !== "#" ? "link" : "button";
    const getDomLocation = (item)=>{
        if ((item === null || item === void 0 ? void 0 : item.link) === "#") {
            return "n/a";
        } else if (item === null || item === void 0 ? void 0 : item.link.includes("https")) {
            return item === null || item === void 0 ? void 0 : item.link.split("/content/kohler/us").join("").replace(".html", "");
        } else {
            if (true) return "".concat(window.location.origin).concat(item === null || item === void 0 ? void 0 : item.link.split("/content/kohler/us").join("").replace(".html", ""));
        }
    };
    const pushAnalyticsObjToDataLayer = function() {
        let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const page = window.pageObj || {};
        const event = "cmp:click";
        window.adobeDataLayer.push({
            event,
            eventInfo,
            page
        });
    };
    const handleDataLayerForFooter = (e, title, item)=>{
        const titleName = title === "Cookies Settings" ? e.target.innerText.toLowerCase() : title.toLowerCase();
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "global footer:".concat(browser_default().sanitize(titleName)),
            eventMsg: "n/a",
            eventName: "global footer:".concat(browser_default().sanitize(titleName)),
            eventStatus: "n/a",
            eventType: "footer menu-2",
            internalLinkName: "".concat(browser_default().sanitize(titleName)),
            internalLinkPosition: "global footer",
            internalLinkType: "global footer:navigation",
            internalLinkURL: "".concat(getDomLocation(item)),
            internalLinkZoneName: "global footer"
        };
        pushAnalyticsObjToDataLayer(eventInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((Shared_index_module_default()).additionalFooterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "additional-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-footer-add-nav",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "gbh-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "gbh-footer-add-panel",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-footer-nav__links",
                                    children: (data === null || data === void 0 ? void 0 : data.items) && (data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                id: item === null || item === void 0 ? void 0 : item.idLabel,
                                                className: item === null || item === void 0 ? void 0 : item.classLabel,
                                                "aria-label": item.linkLabel,
                                                target: item.newTab ? "_blank" : "_self",
                                                ...getHref(item),
                                                rel: "noreferrer",
                                                onClick: (e)=>handleDataLayerForFooter(e, item.linkLabel, item),
                                                role: getRole(item),
                                                tabIndex: 0,
                                                children: item.linkLabel
                                            })
                                        }, "additionalfooteritem-".concat(index));
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "gbh-copy__rights",
                                    children: data.copyright
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "gbh-social__links",
                                    children: [
                                        (data === null || data === void 0 ? void 0 : data.email) === "email" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__email",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                className: "gbh-data-layer",
                                                "aria-label": "Email corporate page link opens in a new tab",
                                                href: "mailto:?body=".concat(location, "&subject=").concat(docTitle),
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelEmail,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkEmail, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref = data.linkLabelEmail) === null || ref === void 0 ? void 0 : ref.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref1 = data.linkLabelEmail) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"global footer:"navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.facebook) === "facebook" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__facebook",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Facebook corporate page link opens in a new tab",
                                                href: data.linkFacebook,
                                                rel: "noreferrer noopener",
                                                title: data === null || data === void 0 ? void 0 : data.linkLabelFacebook,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkFacebook, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref2 = data.linkLabelFacebook) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref3 = data.linkLabelFacebook) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.twitter) === "twitter" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__twitter",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Twitter corporate page link opens in a new tab",
                                                href: data.linkTwitter,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelTwitter,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkTwitter, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref4 = data.linkLabelTwitter) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref5 = data.linkLabelTwitter) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.instagram) === "instagram" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__insta",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Instagram corporate page link opens in a new tab",
                                                href: data.linkInstagram,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelInstagram,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkInstagram, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref6 = data.linkLabelInstagram) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref7 = data.linkLabelInstagram) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.pinterest) === "pinterest" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__pintrest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Pinterest corporate page link opens in a new tab",
                                                href: data.linkPinterest,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelPinterest,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkPinterest, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref8 = data.linkLabelPinterest) === null || ref8 === void 0 ? void 0 : ref8.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref9 = data.linkLabelPinterest) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.youtube) === "youtube" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__youtube",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Youtube corporate page link opens in a new tab",
                                                href: data.linkYoutube,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelYoutube,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkYoutube, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref10 = data.linkLabelYoutube) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref11 = data.linkLabelYoutube) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.houzz) === "houzz" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__houzz",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Houzz corporate page link opens in a new tab",
                                                href: data.linkHouzz,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelHouzz,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkHouzz, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref12 = data.linkLabelHouzz) === null || ref12 === void 0 ? void 0 : ref12.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref13 = data.linkLabelHouzz) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.linkedin) === "linkedin" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__linkedin",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Linkedin corporate page link opens in a new tab",
                                                href: data.linkLinkedin,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelLinkedin,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkLinkedin, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref14 = data.linkLabelLinkedin) === null || ref14 === void 0 ? void 0 : ref14.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref15 = data.linkLabelLinkedin) === null || ref15 === void 0 ? void 0 : ref15.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_AdditionalFooter = (AdditionalFooter);

;// CONCATENATED MODULE: ./components/Default/Text/v1/analytics/constant.js
const PAGELOAD = "bathroom design services";
const DESIGNSERVICES = "design services credit details";

;// CONCATENATED MODULE: ./components/Default/Text/v1/analytics/index.js


const datalayerForLinkEvent = (e)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    const eventInfo = {
        clickInternalLinks: "false",
        eventAction: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES, ":").concat(textContent),
        eventMsg: "n/a",
        eventName: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES, ":").concat(textContent),
        eventStatus: "n/a",
        eventType: "help support",
        internalLinkName: textContent,
        internalLinkPosition: DESIGNSERVICES,
        internalLinkType: "".concat(PAGELOAD, ":email us"),
        internalLinkURL: href,
        internalLinkZoneName: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES)
    };
    if (textContent === "services@kohler.com") {
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
    }
};

;// CONCATENATED MODULE: ./components/Default/Text/v1/Text.jsx




const Text = (props)=>{
    const [dataVal, setDataVal] = (0,react.useState)("");
    const linkTextRef = (0,react.useRef)();
    const { data: { text ="" , appliedCssClassNames ="" , richText =false  } = {}  } = props;
    const removeHtmlExtension = async ()=>{
        const newData = await (0,helper/* getShortenedUrl */.Ppy)(text);
        setDataVal(newData);
    };
    (0,react.useEffect)(()=>{
        if (richText) {
            removeHtmlExtension();
        }
    }, [
        richText
    ]);
    (0,react.useEffect)(()=>{
        if (linkTextRef === null || linkTextRef === void 0 ? void 0 : linkTextRef.current) {
            var ref;
            linkTextRef === null || linkTextRef === void 0 ? void 0 : (ref = linkTextRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                    datalayerForLinkEvent(e);
                });
            });
            return ()=>{
                var ref;
                linkTextRef === null || linkTextRef === void 0 ? void 0 : (ref = linkTextRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                    item === null || item === void 0 ? void 0 : item.removeEventListener("click", (e)=>{
                        datalayerForLinkEvent(e);
                    });
                });
            };
        }
    }, [
        dataVal,
        text
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        ref: linkTextRef,
        children: richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: (0,helper/* sanitizeInnerHtml */.KD0)(dataVal)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "cmp-text__paragraph",
                "aria-label": text,
                children: text
            })
        })
    });
};
/* harmony default export */ var v1_Text = (Text);

;// CONCATENATED MODULE: ./components/Shared/Footer.jsx










const SitewideWarning = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7171).then(__webpack_require__.bind(__webpack_require__, 37171)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37171)
            ]
    },
    ssr: false
});
const Footer = (props)=>{
    const { data  } = props;
    const { siteWideWarning  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            var ref;
            const item = data[":items"][key];
            if (key === "mainfooter") {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_MainFooter, {
                            data: item,
                            columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                        }, "".concat(key, "-").concat(index)),
                        (siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SitewideWarning, {
                            isRendered: siteWideWarning.isRendered,
                            siteWideWarning: siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content
                        }, "".concat(key, "-").concat(index, "-SitewideWarning"))
                    ]
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("newslettersignin")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_NewsletterFooter, {
                    data: item,
                    columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("additionalfooter")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_AdditionalFooter, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.TEXT)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
        })
    });
};
/* harmony default export */ var Shared_Footer = (Footer);

;// CONCATENATED MODULE: ./utils/lazyLoadImage.js
const loadLazyImage = (srcRef, imgRef)=>{
    const newSourceRef = Array.isArray(srcRef === null || srcRef === void 0 ? void 0 : srcRef.current) ? srcRef === null || srcRef === void 0 ? void 0 : srcRef.current : [
        srcRef === null || srcRef === void 0 ? void 0 : srcRef.current
    ];
    if ((newSourceRef === null || newSourceRef === void 0 ? void 0 : newSourceRef.length) > 0) {
        newSourceRef.forEach((src, index)=>{
            if (src === null || src === void 0 ? void 0 : src.hasAttribute("data-srcset")) {
                var ref;
                (ref = newSourceRef[index]) === null || ref === void 0 ? void 0 : ref.setAttribute("srcset", src === null || src === void 0 ? void 0 : src.getAttribute("data-srcset"));
                src === null || src === void 0 ? void 0 : src.removeAttribute("data-srcset");
            }
        });
    }
    const newImageRef = Array.isArray(imgRef === null || imgRef === void 0 ? void 0 : imgRef.current) ? imgRef === null || imgRef === void 0 ? void 0 : imgRef.current : [
        imgRef === null || imgRef === void 0 ? void 0 : imgRef.current
    ];
    if ((newImageRef === null || newImageRef === void 0 ? void 0 : newImageRef.length) > 0) {
        newImageRef.forEach((img, index)=>{
            if (img === null || img === void 0 ? void 0 : img.hasAttribute("data-src")) {
                var ref;
                (ref = newImageRef[index]) === null || ref === void 0 ? void 0 : ref.setAttribute("src", img === null || img === void 0 ? void 0 : img.getAttribute("data-src"));
                img === null || img === void 0 ? void 0 : img.removeAttribute("data-src");
            }
        });
    }
};

;// CONCATENATED MODULE: ./components/Default/Image/v3/Image.jsx






const CustomImage = (props)=>{
    const { data  } = props;
    const { linkURL , newTab , fileReference , imageLazyLoad , defaultRenditions: imageModifiersScene7 , defaultImageURL , imageURLWithoutCrop , displayPopupTitle , imageComponentProperties: { alt , title  } , description , items  } = data;
    const pictureRef = (0,react.useRef)(null);
    const sourcesRef = (0,react.useRef)([]);
    const imageRef = (0,react.useRef)(null);
    const { ref: inViewRef , inView  } = useInView({
        threshold: 0
    });
    const placeholderImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const lazyLoadValue = (0,helper/* convertStringToBoolean */.mUs)(imageLazyLoad) ? "false" : "true";
    const finalSrcValue = "".concat(defaultImageURL ? defaultImageURL : imageURLWithoutCrop).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "");
    const content = (0,helper/* convertStringToBoolean */.mUs)(imageLazyLoad) && fileReference ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        ref: pictureRef,
        lazyload: lazyLoadValue,
        children: [
            items.map((obj, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    ref: (el)=>sourcesRef.current[index] = el,
                    media: "(min-width: ".concat(obj.deviceSize, ")"),
                    alt: alt || "true",
                    srcSet: placeholderImage,
                    "data-srcset": "".concat(obj.imageURL).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "")
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ref: imageRef,
                className: "cmp-image__image",
                src: placeholderImage,
                "data-src": finalSrcValue,
                alt: alt || "true",
                style: {
                    width: "100%"
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        lazyload: lazyLoadValue,
        children: [
            items.map((obj, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    ref: (el)=>sourcesRef.current[index] = el,
                    media: "(min-width: ".concat(obj.deviceSize, ")"),
                    alt: alt || "true",
                    srcSet: "".concat(obj.imageURL).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "")
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ref: imageRef,
                className: "cmp-image__image",
                src: finalSrcValue,
                alt: alt || "true",
                style: {
                    width: "100%"
                }
            })
        ]
    });
    (0,react.useEffect)(()=>{
        if (inView) {
            if ((0,helper/* convertStringToBoolean */.mUs)(imageLazyLoad)) {
                loadLazyImage(sourcesRef, imageRef);
            }
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cmp-image",
        itemScope: true,
        itemType: "https://schema.org/ImageObject",
        ref: inViewRef,
        children: [
            linkURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "cmp-image__link",
                href: linkURL,
                target: (0,helper/* convertStringToBoolean */.mUs)(newTab) ? "_blank" : "_self",
                rel: "noreferrer",
                children: content
            }) : content,
            !(0,helper/* convertStringToBoolean */.mUs)(displayPopupTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cmp-image__title",
                itemProp: "caption",
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(description)
                }
            }),
            (0,helper/* convertStringToBoolean */.mUs)(displayPopupTitle) && title && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "caption",
                content: title
            })
        ]
    });
};
/* harmony default export */ var v3_Image = (CustomImage);

// EXTERNAL MODULE: ./components/HelpSupport/v1/index.module.scss
var v1_index_module = __webpack_require__(95816);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
;// CONCATENATED MODULE: ./components/HelpSupport/v1/helpSupportAnalytics.js

const helpSupportAnalytics = (pageName, phoneNumber)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        internalLinkPosition: constants.HELP_SUPPORT,
        internalLinkZoneName: "".concat(pageName, ":").concat(constants.HELP_AND_SUPPORT),
        internalLinkURL: "tel:".concat(phoneNumber),
        internalLinkName: "".concat(phoneNumber),
        eventName: "".concat(pageName, ":").concat(constants.HELP_AND_SUPPORT, ":").concat(phoneNumber),
        internalLinkType: "".concat(pageName, ":").concat(constants.CALL_OUR_TEAM),
        eventType: "navigation",
        eventAction: "".concat(pageName, ":").concat(constants.HELP_AND_SUPPORT, ":").concat(phoneNumber),
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
};

;// CONCATENATED MODULE: ./components/HelpSupport/v1/HelpSupport.jsx






const HelpSupport = (param)=>{
    let { data  } = param;
    const { helpTitle ="" , helpDescription ="" , chatTitle ="" , chatDescription ="" , chatLink ="" , chatLinkRef =false , contactTitle ="" , contactDescription ="" , prodSupportTitle ="" , prodSupportDescription ="" , prodSupportItems =[] , chatText ="" , contactItems =[] , pageName ="" , enableChat =false  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (v1_index_module_default()).helpSupportWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "help-support ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gbh-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-title",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpTitle)
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-description",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpDescription)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-right",
                        children: [
                            chatTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatDescription)
                                        }
                                    }),
                                    chatLink && enableChat && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (0,helper/* removeAndCleanLink */.xEh)(chatLink),
                                        target: chatLinkRef ? "_blank" : "_self",
                                        rel: "noopener noreferrer",
                                        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(!chatLinkRef, '","internalLinkPosition":"help support","internalLinkZoneName":"').concat(pageName, ':help and support","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(chatLink), '","internalLinkName":"').concat(chatTitle, '","eventName":"').concat(pageName, ":help and support:").concat(chatTitle, '","internalLinkType":"').concat(pageName, ':navigation","eventType":"help support","eventAction":"').concat(pageName, ":help and support:").concat(chatTitle, '"}'),
                                        className: "gbh-data-layer",
                                        children: chatText
                                    })
                                ]
                            }),
                            contactTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactDescription)
                                        }
                                    }),
                                    contactItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "contact-number",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: contactItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(item.phoneNumber),
                                                        "data-gbh-data-layer": helpSupportAnalytics(pageName, item.phoneNumber),
                                                        className: "gbh-data-layer",
                                                        children: item.phoneNumber
                                                    })
                                                }, "".concat(item.phoneNumber, "+").concat(index)))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    prodSupportTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(prodSupportTitle)
                                        }
                                    }),
                                    prodSupportDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize((0,helper/* removeAndCleanLink */.xEh)(prodSupportDescription))
                                        }
                                    }),
                                    prodSupportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "support-links",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: prodSupportItems.map((item)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: item.isDisplayButton ? "chat-button" : "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: (0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.linkProdSup),
                                                        target: item.isNewTabProd ? "_blank" : "_self",
                                                        rel: "noopener noreferrer",
                                                        "data-gbh-data-layer": '{"clickInternalLinks": "'.concat(item.isNewTabProd ? "false" : "true", '", "internalLinkPosition": "help support", "internalLinkZoneName": "').concat(pageName, ':help and support", "internalLinkURL": "').concat((0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.linkProdSup), '", "internalLinkName": "').concat(item.labelProdSup, '", "eventName": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '", "internalLinkType": "').concat(pageName, ':product support", "eventType": "help support", "eventAction": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '"}'),
                                                        className: "gbh-data-layer",
                                                        children: item.labelProdSup
                                                    })
                                                }, item.labelProdSup);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_HelpSupport = (HelpSupport);

;// CONCATENATED MODULE: ./components/Default/Tab/v1/TabHelper.js


const that = {};
let dataLayerEnabled;
let dataLayer;
const getDataLayerId = (componentDataLayer)=>{
    return Object.keys(JSON.parse(componentDataLayer))[0];
};
const readData = function() {
    let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { dataset: data = {}  } = element;
    const options = [];
    let capitalized = constants.IS;
    capitalized = ((ref = capitalized === null || capitalized === void 0 ? void 0 : capitalized.charAt(0)) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (capitalized === null || capitalized === void 0 ? void 0 : capitalized.slice(1));
    const reserved = [
        "is",
        "hook" + capitalized
    ];
    for(const key in data){
        if (data && Object.prototype.hasOwnProperty.call(data, key)) {
            const value = data[key];
            if ((key === null || key === void 0 ? void 0 : key.indexOf(constants.NS)) === 0) {
                var ref1;
                const newKey = key === null || key === void 0 ? void 0 : key.slice(constants.NS.length);
                const finalKey = ((ref1 = newKey === null || newKey === void 0 ? void 0 : newKey.charAt(0)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) + (newKey === null || newKey === void 0 ? void 0 : newKey.substring(1));
                if ((reserved === null || reserved === void 0 ? void 0 : reserved.indexOf(finalKey)) === -1) {
                    options[finalKey] = value;
                }
            }
        }
    }
    return options;
};
const getActiveIndex = function() {
    let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (tabs) {
        return tabs === null || tabs === void 0 ? void 0 : tabs.findIndex((tab)=>{
            var ref, ref1;
            return tab === null || tab === void 0 ? void 0 : (ref = tab.classList) === null || ref === void 0 ? void 0 : ref.contains(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref1 = constants.selectors.active) === null || ref1 === void 0 ? void 0 : ref1.tab);
        });
    }
    return 0;
};
const cacheElements = function() {
    let wrapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    that._elements = {};
    that._elements.self = wrapper;
    const hooks = that === null || that === void 0 ? void 0 : (ref = that._elements) === null || ref === void 0 ? void 0 : (ref1 = ref.self) === null || ref1 === void 0 ? void 0 : ref1.querySelectorAll("[data-" + constants.NS + "-hook-" + constants.IS + "]");
    for (const hook of hooks){
        var ref2;
        if ((hook === null || hook === void 0 ? void 0 : hook.closest("." + constants.NS + "-" + constants.IS)) === (that === null || that === void 0 ? void 0 : (ref2 = that._elements) === null || ref2 === void 0 ? void 0 : ref2.self)) {
            var ref3;
            // only process own tab elements
            let capitalized = constants.IS;
            capitalized = ((ref3 = capitalized === null || capitalized === void 0 ? void 0 : capitalized.charAt(0)) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase()) + (capitalized === null || capitalized === void 0 ? void 0 : capitalized.slice(1));
            const key = hook === null || hook === void 0 ? void 0 : hook.dataset[constants.NS + "Hook" + capitalized];
            if (that === null || that === void 0 ? void 0 : that._elements[key]) {
                var ref4;
                if (!(Array === null || Array === void 0 ? void 0 : Array.isArray(that === null || that === void 0 ? void 0 : that._elements[key]))) {
                    const tmp = that === null || that === void 0 ? void 0 : that._elements[key];
                    that._elements[key] = [
                        tmp
                    ];
                }
                (ref4 = that === null || that === void 0 ? void 0 : that._elements[key]) === null || ref4 === void 0 ? void 0 : ref4.push(hook);
            } else {
                that._elements[key] = hook;
            }
        }
    }
};
const focusWithoutScroll = function() {
    let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const x = (window === null || window === void 0 ? void 0 : window.scrollX) || (window === null || window === void 0 ? void 0 : window.pageXOffset);
    const y = (window === null || window === void 0 ? void 0 : window.scrollY) || (window === null || window === void 0 ? void 0 : window.pageYOffset);
    element === null || element === void 0 ? void 0 : element.focus();
    window === null || window === void 0 ? void 0 : window.scrollTo(x, y);
};
const refreshActive = ()=>{
    const tabpanels = that === null || that === void 0 ? void 0 : that._elements["tabpanel"];
    const tabs = that === null || that === void 0 ? void 0 : that._elements["tab"];
    const headerTabs = document === null || document === void 0 ? void 0 : document.querySelectorAll(".header-mega-menu-container .cmp-tabs div.cmp-tabs__tabpanel");
    if (tabpanels) {
        if (Array.isArray(tabpanels)) {
            tabpanels === null || tabpanels === void 0 ? void 0 : tabpanels.forEach((tabpanel, i)=>{
                var ref, ref1;
                if (i === parseInt(that === null || that === void 0 ? void 0 : that._active) && !((ref = headerTabs[that === null || that === void 0 ? void 0 : that._active]) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("cmp-tabs__tabpanel--active"))) {
                    var ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                    tabpanel === null || tabpanel === void 0 ? void 0 : (ref2 = tabpanel.classList) === null || ref2 === void 0 ? void 0 : ref2.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref3 = constants.selectors.active) === null || ref3 === void 0 ? void 0 : ref3.tabpanel);
                    tabpanel === null || tabpanel === void 0 ? void 0 : tabpanel.removeAttribute("aria-hidden");
                    (ref4 = tabs[i]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref6 = constants.selectors.active) === null || ref6 === void 0 ? void 0 : ref6.tab);
                    (ref7 = tabs[i]) === null || ref7 === void 0 ? void 0 : ref7.setAttribute("aria-selected", true);
                    (ref8 = tabs[i]) === null || ref8 === void 0 ? void 0 : ref8.setAttribute("tabindex", "0");
                } else {
                    var ref9, ref10, ref11, ref12, ref13, ref14;
                    tabpanel === null || tabpanel === void 0 ? void 0 : (ref9 = tabpanel.classList) === null || ref9 === void 0 ? void 0 : ref9.remove(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref10 = constants.selectors.active) === null || ref10 === void 0 ? void 0 : ref10.tabpanel);
                    tabpanel === null || tabpanel === void 0 ? void 0 : tabpanel.setAttribute("aria-hidden", true);
                    (ref11 = tabs[i]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.classList) === null || ref12 === void 0 ? void 0 : ref12.remove(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref13 = constants.selectors.active) === null || ref13 === void 0 ? void 0 : ref13.tab);
                    (ref14 = tabs[i]) === null || ref14 === void 0 ? void 0 : ref14.setAttribute("aria-selected", false);
                }
            });
        } else {
            var // only one tab
            ref, ref1, ref2, ref3;
            tabpanels === null || tabpanels === void 0 ? void 0 : (ref = tabpanels.classList) === null || ref === void 0 ? void 0 : ref.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref1 = constants.selectors.active) === null || ref1 === void 0 ? void 0 : ref1.tabpanel);
            tabs === null || tabs === void 0 ? void 0 : (ref2 = tabs.classList) === null || ref2 === void 0 ? void 0 : ref2.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref3 = constants.selectors.active) === null || ref3 === void 0 ? void 0 : ref3.tab);
        }
    }
};
const TabHelper_navigate = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    that._active = index;
    refreshActive();
};
const navigateAndFocusTab = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const exActive = that === null || that === void 0 ? void 0 : that._active;
    TabHelper_navigate(index);
    focusWithoutScroll(that === null || that === void 0 ? void 0 : that._elements["tab"][index]);
    if (dataLayerEnabled) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const activeItem = getDataLayerId((ref1 = that === null || that === void 0 ? void 0 : (ref = that._elements) === null || ref === void 0 ? void 0 : ref.tabpanel[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataset) === null || ref2 === void 0 ? void 0 : ref2.gbhDataLayer);
        const exActiveItem = getDataLayerId((ref4 = that === null || that === void 0 ? void 0 : (ref3 = that._elements) === null || ref3 === void 0 ? void 0 : ref3.tabpanel[exActive]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.dataset) === null || ref5 === void 0 ? void 0 : ref5.gbhDataLayer);
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
            event: "cmp:show",
            eventInfo: {
                path: "component." + activeItem
            }
        });
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
            event: "cmp:hide",
            eventInfo: {
                path: "component." + exActiveItem
            }
        });
        const tabsId = that === null || that === void 0 ? void 0 : (ref6 = that._elements) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.self) === null || ref7 === void 0 ? void 0 : ref7.id;
        const uploadPayload = {
            component: {}
        };
        uploadPayload.component[tabsId] = {
            shownItems: [
                activeItem
            ]
        };
        const removePayload = {
            component: {}
        };
        removePayload.component[tabsId] = {
            shownItems: undefined
        };
        dataLayer.push(removePayload);
        dataLayer.push(uploadPayload);
    }
};
const onKeyDown = function() {
    let event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const index = that === null || that === void 0 ? void 0 : that._active;
    const lastIndex = ((ref = that === null || that === void 0 ? void 0 : that._elements["tab"]) === null || ref === void 0 ? void 0 : ref.length) - 1;
    const { ARROW_LEFT , ARROW_UP , ARROW_RIGHT , ARROW_DOWN , HOME , END  } = constants.keyCodes;
    const { keyCode =""  } = event;
    switch(keyCode){
        case ARROW_LEFT:
        case ARROW_UP:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (index > 0) {
                navigateAndFocusTab(index - 1);
            }
            break;
        case ARROW_RIGHT:
        case ARROW_DOWN:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (index < lastIndex) {
                navigateAndFocusTab(index + 1);
            }
            break;
        case HOME:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            navigateAndFocusTab(0);
            break;
        case END:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            navigateAndFocusTab(lastIndex);
            break;
        default:
            return;
    }
};
const bindEvents = ()=>{
    const tabs = that === null || that === void 0 ? void 0 : that._elements["tab"];
    if (tabs) {
        tabs === null || tabs === void 0 ? void 0 : tabs.forEach((tab, index)=>{
            tab.addEventListener("click", ()=>{
                navigateAndFocusTab(index);
            });
            tab.addEventListener("keydown", (event)=>{
                onKeyDown(event);
            });
        });
    }
};
const init = function() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var // prevents multiple initialization
    ref, ref1;
    that._config = config;
    config === null || config === void 0 ? void 0 : (ref = config.element) === null || ref === void 0 ? void 0 : ref.removeAttribute("data-" + constants.NS + "-is");
    cacheElements(config === null || config === void 0 ? void 0 : config.element);
    that._active = getActiveIndex(that === null || that === void 0 ? void 0 : that._elements["tab"]);
    if (that === null || that === void 0 ? void 0 : (ref1 = that._elements) === null || ref1 === void 0 ? void 0 : ref1.tabpanel) {
        refreshActive();
        bindEvents();
    }
};
const tabs = function() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (config === null || config === void 0 ? void 0 : config.element) {
        init(config);
    }
};
const onDocumentReady = ()=>{
    dataLayerEnabled = false;
    dataLayer = dataLayerEnabled ? (window === null || window === void 0 ? void 0 : window.adobeDataLayer) || [] : undefined;
    const elements = document === null || document === void 0 ? void 0 : document.querySelectorAll(constants.selectors === null || constants.selectors === void 0 ? void 0 : constants.selectors.self);
    elements === null || elements === void 0 ? void 0 : elements.forEach(function() {
        let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        tabs({
            element: element,
            options: readData(element)
        });
    });
    const MutationObserver = (window === null || window === void 0 ? void 0 : window.MutationObserver) || (window === null || window === void 0 ? void 0 : window.WebKitMutationObserver) || (window === null || window === void 0 ? void 0 : window.MozMutationObserver);
    const body = document === null || document === void 0 ? void 0 : document.querySelector("body");
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            var ref, ref1;
            // needed for IE
            const nodesArray = (ref = []) === null || ref === void 0 ? void 0 : (ref1 = ref.slice) === null || ref1 === void 0 ? void 0 : ref1.call(mutation.addedNodes);
            if ((nodesArray === null || nodesArray === void 0 ? void 0 : nodesArray.length) > 0) {
                nodesArray === null || nodesArray === void 0 ? void 0 : nodesArray.forEach((addedNode)=>{
                    if (addedNode === null || addedNode === void 0 ? void 0 : addedNode.querySelectorAll) {
                        var ref, ref1;
                        const elementsArray = (ref = []) === null || ref === void 0 ? void 0 : (ref1 = ref.slice) === null || ref1 === void 0 ? void 0 : ref1.call(addedNode === null || addedNode === void 0 ? void 0 : addedNode.querySelectorAll(constants.selectors === null || constants.selectors === void 0 ? void 0 : constants.selectors.self));
                        elementsArray === null || elementsArray === void 0 ? void 0 : elementsArray.forEach((element)=>{
                            tabs({
                                element: element,
                                options: readData(element)
                            });
                        });
                    }
                });
            }
        });
    });
    observer === null || observer === void 0 ? void 0 : observer.observe(body, {
        subtree: true,
        childList: true,
        characterData: true
    });
};
const getActiveHash = (cb)=>{
    var ref;
    const url = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
    const hashed = (browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize(url === null || url === void 0 ? void 0 : url.hash);
    if ((hashed === null || hashed === void 0 ? void 0 : hashed.length) === 0) {
        return false;
    }
    const hashValue = decodeURIComponent(hashed === null || hashed === void 0 ? void 0 : hashed.slice(1));
    if (hashValue !== "") {
        const tabElements = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs .cmp-tabs__tablist .cmp-tabs__tab");
        tabElements === null || tabElements === void 0 ? void 0 : tabElements.forEach(function() {
            let child = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const attr = child === null || child === void 0 ? void 0 : child.getAttribute("id");
            if (attr !== null) {
                var ref;
                child === null || child === void 0 ? void 0 : (ref = child.classList) === null || ref === void 0 ? void 0 : ref.remove("cmp-tabs__tab--active");
            }
            if (attr === hashValue) {
                var ref1;
                child === null || child === void 0 ? void 0 : (ref1 = child.classList) === null || ref1 === void 0 ? void 0 : ref1.add("cmp-tabs__tab--active");
            }
        });
        const tabPanelElements = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs .cmp-tabs__tabpanel");
        tabPanelElements === null || tabPanelElements === void 0 ? void 0 : tabPanelElements.forEach(function() {
            let child = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var ref;
            const attr = (ref = child === null || child === void 0 ? void 0 : child.getAttribute("data-hashid")) === null || ref === void 0 ? void 0 : ref.replaceAll("-", " ");
            if (attr !== null) {
                var ref1;
                child === null || child === void 0 ? void 0 : (ref1 = child.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("cmp-tabs__tabpanel--active");
            }
            if (attr === hashValue) {
                var ref2;
                child === null || child === void 0 ? void 0 : (ref2 = child.classList) === null || ref2 === void 0 ? void 0 : ref2.add("cmp-tabs__tabpanel--active");
                cb && cb(hashValue);
            }
        });
    }
};
const setTabAnimation = function() {
    let tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isTransitionDurationRemove = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const parent = tab === null || tab === void 0 ? void 0 : tab.closest(".tabs");
    const vertical = (parent === null || parent === void 0 ? void 0 : (ref = parent.classList) === null || ref === void 0 ? void 0 : ref.contains("vertical-tabs")) && ((ref1 = window === null || window === void 0 ? void 0 : window.matchMedia("(min-width: 1024px)")) === null || ref1 === void 0 ? void 0 : ref1.matches);
    const borderClr = (parent === null || parent === void 0 ? void 0 : (ref2 = parent.classList) === null || ref2 === void 0 ? void 0 : ref2.contains("bg-charcoal")) || (parent === null || parent === void 0 ? void 0 : (ref3 = parent.classList) === null || ref3 === void 0 ? void 0 : ref3.contains("bg-slate")) || ((ref4 = parent === null || parent === void 0 ? void 0 : parent.closest(".container")) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.contains("bg-charcoal")) || ((ref6 = parent === null || parent === void 0 ? void 0 : parent.closest(".container")) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.classList) === null || ref7 === void 0 ? void 0 : ref7.contains("bg-slate")) ? "#FFF" : "#212121";
    const tabList = tab === null || tab === void 0 ? void 0 : tab.parentElement;
    const selectionBar = tabList === null || tabList === void 0 ? void 0 : tabList.querySelector(".selectionBarcss");
    selectionBar.style.borderColor = borderClr;
    selectionBar.style.transitionDuration = isTransitionDurationRemove ? "0s" : ".5s";
    (ref8 = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs__tablist")) === null || ref8 === void 0 ? void 0 : ref8.forEach(function() {
        let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        element.style.position = "relative";
    });
    const rectTargetTab = tab === null || tab === void 0 ? void 0 : tab.getBoundingClientRect();
    const rectTabList = tabList === null || tabList === void 0 ? void 0 : tabList.getBoundingClientRect();
    if (vertical) {
        const selectionBarWidth = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.height) / (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.height);
        const selectionBarPosition = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.bottom) - (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.bottom);
        selectionBar.style.height = (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.height) + "px";
        selectionBar.style.transform = "matrix(1, 0, 0, ".concat(selectionBarWidth + (tabList === null || tabList === void 0 ? void 0 : tabList.scrollTop), ", 0, ").concat(selectionBarPosition, ")");
    } else {
        const selectionBarWidth1 = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.width) / (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.width);
        const selectionBarPosition1 = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.left) - (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.left);
        selectionBar.style.transform = "matrix(".concat(selectionBarWidth1, ", 0, 0, 1, ").concat(selectionBarPosition1 + (tabList === null || tabList === void 0 ? void 0 : tabList.scrollLeft), ", -1)");
    }
};
const handleResizeEvent = ()=>{
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach(function() {
        let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            const activeTab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
            if (activeTab) {
                setTabAnimation(activeTab, true);
            }
        }
    });
};
const handleHashchangeEvent = ()=>{
    getActiveHash();
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach(function() {
        let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            const activeTab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
            if (activeTab) {
                setTabAnimation(activeTab, false);
            }
        }
    });
};

;// CONCATENATED MODULE: ./components/Default/Tab/v1/TabAnalytics.js



const TabAnalytics_getComponentZone = (element)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className === "cmp-container");
    const zoneName = container === null || container === void 0 ? void 0 : container.getAttribute("id");
    if (zoneName) {
        if (zoneName === "color-material-finish" || zoneName === "colors-materials-finishes") {
            return "colors-materials-finishes";
        }
        return zoneName.toLowerCase().replaceAll("-", " ");
    } else {
        return "";
    }
};
const getSubMenuValue = (baseValue, isSupportPage, panelTitle)=>{
    if (baseValue) {
        return baseValue;
    }
    if (isSupportPage) {
        return "submenu";
    }
    return panelTitle || "submenu navigation link";
};
const TabAnalytics_getEventInfo = function() {
    let eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentLinkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", eventAction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventPageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", item = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var ref;
    const panelTitle = ((ref = item["cq:panelTitle"]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
    const isSupportPage = eventPageType.includes("support");
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    const isPageInspiration = eventPageType === constants.INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR;
    const isPageAboutUS = constants.INSPIRATION_PAGE_NAME.ABOUT_US_OUR_IMPACT === eventPageType;
    let zoneVal;
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach((tabs)=>{
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            zoneVal = TabAnalytics_getComponentZone(tabs === null || tabs === void 0 ? void 0 : tabs.parentElement);
        }
    });
    const subMenuValue = getSubMenuValue(eventName, isSupportPage, panelTitle);
    const subMenuAction = getSubMenuValue(eventAction, isSupportPage, panelTitle);
    const eventText = isPageInspiration ? "".concat(eventPageType, ":sub menu") : isPageAboutUS ? "".concat(eventPageType, ":sub menu") : "".concat(eventPageType, ":").concat(zoneVal, ":sub menu");
    return {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(eventPageType, ":tab"),
        internalLinkZoneName: eventText,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(panelTitle),
        eventName: "".concat(eventText, ":").concat(subMenuValue),
        internalLinkType: "".concat(eventPageType, ":").concat(componentLinkType || "navigation"),
        eventType: "tab",
        eventAction: "".concat(eventText, ":").concat(subMenuAction),
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
};
const handleTabClickDatalayer = function() {
    let eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentLinkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", eventAction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventPageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", item = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const eventInfo = TabAnalytics_getEventInfo(eventName, componentLinkType, eventAction, eventPageType, item);
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Default/Tab/v1/Tab.jsx











const Tab = (props)=>{
    var ref, ref1, ref2;
    const { data ={} , itemKey ="" , ...extraProps } = props;
    const [selectedTab, setTab] = (0,react.useState)("");
    const tabElement = (0,react.useRef)(null);
    const tabContainerRef = (0,react.useRef)(null);
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const tabNavigationItems = (0,react.useRef)([]);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const getDataLayerProps = (item)=>{
        return (0,utils/* recursiveDataFunction */.Qe)(item, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.TEASER);
    };
    const removeHash = ()=>{
        var ref, ref1;
        if (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : ref1.includes("#")) {
            var ref2;
            history === null || history === void 0 ? void 0 : history.replaceState(history === null || history === void 0 ? void 0 : history.state, "", (ref2 = window.location.href) === null || ref2 === void 0 ? void 0 : ref2.split("#")[0]);
        }
    };
    const onClickTab = (data, event)=>{
        removeHash();
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        const { currentTarget ={}  } = event;
        const clickedTab = currentTarget;
        // Move the tabbed navigation to the center of viewport when clicking
        clickedTab === null || clickedTab === void 0 ? void 0 : clickedTab.scrollIntoView({
            block: "nearest",
            inline: "center"
        });
    };
    (0,react.useEffect)(()=>{
        const selectedItemKey = data["activeItem"];
        setTab(data[":items"][selectedItemKey]["cq:panelTitle"]);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        // Extract tab items from the data
        const tabItemTitles = (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map(function() {
            let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            const item = data[":items"][key];
            return item["cq:panelTitle"];
        });
        // Extract the target tab item from the hash
        let tabItemFromHash = decodeURIComponent((browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize((ref1 = window.location.hash) === null || ref1 === void 0 ? void 0 : ref1.replace("#", "").replaceAll("-", " ")));
        // Set the tab if it's included in the tab items
        if (tabItemTitles === null || tabItemTitles === void 0 ? void 0 : tabItemTitles.includes(tabItemFromHash)) {
            setTab(tabItemFromHash);
        }
        // Event listener for hash changes
        const onHashChanged = ()=>{
            var ref;
            tabItemFromHash = decodeURIComponent((browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize((ref = window.location.hash) === null || ref === void 0 ? void 0 : ref.replace("#", "").replaceAll("-", " ")));
            if (tabItemTitles === null || tabItemTitles === void 0 ? void 0 : tabItemTitles.includes(tabItemFromHash)) {
                setTab(tabItemFromHash);
            }
        };
        // Add and remove event listener
        window.addEventListener("hashchange", onHashChanged);
        return ()=>{
            window.removeEventListener("hashchange", onHashChanged);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const selectionBar = document === null || document === void 0 ? void 0 : document.querySelectorAll(".selectionBarcss");
        if (!(selectionBar === null || selectionBar === void 0 ? void 0 : selectionBar.length)) {
            onDocumentReady();
            getActiveHash((hashValue)=>{
                setTab(hashValue);
            });
            window === null || window === void 0 ? void 0 : window.addEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.addEventListener("hashchange", handleHashchangeEvent);
        }
        return ()=>{
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.removeEventListener("hashchange", handleHashchangeEvent);
        };
    }, []);
    const getActiveTabIndex = (data)=>{
        var ref;
        return (ref = data[":itemsOrder"].map((key)=>{
            const item = data[":items"][key];
            const panelTitle = item["cq:panelTitle"] || "";
            return panelTitle;
        }).indexOf(selectedTab)) !== null && ref !== void 0 ? ref : "";
    };
    (0,react.useEffect)(()=>{
        if (data && selectedTab) {
            const activeTabIndex = getActiveTabIndex(data);
            if (activeTabIndex !== "") {
                const tabNavEl = tabNavigationItems === null || tabNavigationItems === void 0 ? void 0 : tabNavigationItems.current[activeTabIndex];
                setTabAnimation(tabNavEl);
            }
        }
    }, [
        data,
        selectedTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cmp-tabs",
        "data-cmp-is": "tabs",
        ref: tabContainerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                role: "tablist",
                className: "cmp-tabs__tablist",
                "aria-multiselectable": "false",
                ref: tabElement,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selectionBarcss".concat((data === null || data === void 0 ? void 0 : (ref = data.appliedCssClassNames) === null || ref === void 0 ? void 0 : ref.includes("vertical-tabs")) && winWidth >= 1024 ? " selectionBar-vertical" : " selectionBar-horizontal")
                    }),
                    data[":itemsOrder"] ? (ref1 = data[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.map(function() {
                        let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        const item = data[":items"][key];
                        const panelTitle = item["cq:panelTitle"] || "";
                        const dataLayerProps = getDataLayerProps(item);
                        const { eventName ="" , componentLinkType ="" , eventAction =""  } = dataLayerProps !== null && dataLayerProps !== void 0 ? dataLayerProps : {};
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            ref: (ref)=>{
                                tabNavigationItems.current[index] = ref;
                            },
                            role: "tab",
                            "aria-expanded": "false",
                            className: "cmp-tabs__tab ".concat(selectedTab === "" && index === 0 || selectedTab === panelTitle ? "cmp-tabs__tab--active" : ""),
                            id: panelTitle.replaceAll(" ", "-"),
                            tabIndex: "0",
                            "data-cmp-hook-tabs": "tab",
                            "data-gbh-clickable": "true",
                            onClick: (event)=>{
                                onClickTab(item, event);
                                handleTabClickDatalayer(eventName, componentLinkType, eventAction, eventPageType, item);
                            },
                            children: panelTitle
                        }, panelTitle);
                    }) : null
                ]
            }),
            data[":itemsOrder"] ? (ref2 = data[":itemsOrder"]) === null || ref2 === void 0 ? void 0 : ref2.map(function() {
                let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var ref;
                const item = data[":items"][key];
                const { id =""  } = item;
                const panelTitle = item["cq:panelTitle"] || "";
                const hashValue = panelTitle === null || panelTitle === void 0 ? void 0 : panelTitle.replaceAll(" ", "-");
                // set for rerendering child component when nested tabs are present for recalculating the active indicator
                const hasNestedTab = item[":itemsOrder"].some((childKey)=>{
                    const obj = item[":items"][childKey];
                    return (0,utils/* isTab */.wR)(obj);
                });
                const isShopTheRoom = item === null || item === void 0 ? void 0 : (ref = item[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.some((itemKey)=>{
                    const itemData = item[":items"][itemKey];
                    return (0,utils/* isShopTheRoomCard */.ck)(itemData);
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "tabpanel",
                    "aria-label": panelTitle,
                    "data-hashid": hashValue,
                    className: "cmp-tabs__tabpanel ".concat(selectedTab === panelTitle ? "cmp-tabs__tabpanel--active" : ""),
                    "data-cmp-hook-tabs": "tabpanel",
                    "aria-hidden": selectedTab !== panelTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: isShopTheRoom,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                            condition: (0,utils/* isContainer */.Nm)(item),
                            wrapper: (children)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "", " ").concat(item.appliedCssClassNames),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-container",
                                        children: (item === null || item === void 0 ? void 0 : item.gridClassNames) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: item === null || item === void 0 ? void 0 : item.gridClassNames,
                                            children: children
                                        }) : {
                                            children
                                        }
                                    })
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                ...hasNestedTab ? {
                                    key: selectedTab
                                } : {},
                                data: item,
                                containerId: id,
                                itemKey: key ? key : itemKey,
                                ...extraProps
                            })
                        })
                    })
                }, "navItem-".concat(index));
            }) : null
        ]
    });
};
/* harmony default export */ var v1_Tab = (Tab);

;// CONCATENATED MODULE: ./components/Shared/Embed.jsx








const Embed = (props)=>{
    const { data: { script ="" , matterportUrl ="" , visualIcon =false , html ="" , etype =""  } = {}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [stylesVal, setStylesVal] = (0,react.useState)([]);
    const [reloadStyles, setReloadStyles] = (0,react.useState)(false);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const etypeUppercase = etype === null || etype === void 0 ? void 0 : etype.toUpperCase();
    const datalayerRef = (0,react.useRef)();
    const servicesClick = (e)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        datalayerForCookie(textContent, href);
        window.open(href);
    };
    const datalayerForCookie = (text, url)=>{
        const textCont = (0,helper/* sanitizeTextForAnalytics */.T68)(text);
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "legal:cookie policy:".concat(textCont),
            eventMsg: "n/a",
            eventName: "legal:cookie policy:".concat(textCont),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(textCont),
            internalLinkPosition: "kohler:legal:cookie policy",
            internalLinkType: "kohler:legal:cookie policy:one trust",
            internalLinkURL: url,
            internalLinkZoneName: "kohler:legal:cookie policy:".concat(textCont)
        };
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
    };
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            const { styles =[]  } = (0,helper/* isEmbeddedStyles */.fM6)(script);
            setStylesVal(styles);
            if (!reloadStyles) {
                // This is to make sure any 3rdParty Component loaded to the page will get styles applied after loading
                setTimeout(function() {
                    setReloadStyles(true);
                    dispatch((0,genericSlice/* toggleSiteWideWarning */.jy)());
                }, 3000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        reloadStyles
    ]);
    (0,react.useEffect)(()=>{
        if (datalayerRef === null || datalayerRef === void 0 ? void 0 : datalayerRef.current) {
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                if ((item === null || item === void 0 ? void 0 : item.getAttribute("listener")) !== "true") {
                    item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                        servicesClick(e);
                    });
                }
            });
        }
        return ()=>{
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", servicesClick);
            });
        };
    }, [
        isSsr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: datalayerRef,
        children: [
            !isSsr && visualIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-visual-icons",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gbh-visual-icon-area",
                    tabIndex: "0",
                    role: "button",
                    "aria-label": constants.VISUALICON_ARIA_LABEL
                })
            }),
            !isSsr && etypeUppercase === constants.EMBED_TYPE_HTML && html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            }),
            !isSsr && etypeUppercase === constants.EMBED_TYPE_SCRIPT && (0,helper/* isEmbeddedElement */.cLX)(script) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                })
            }),
            pageIsInteractive && etypeUppercase === constants.EMBED_TYPE_SCRIPT && stylesVal.map((style, i)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        id: "embedStyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()),
                        children: style
                    })
                }, "embedStyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
            }),
            !isSsr && matterportUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal fade virtual-tour-popup",
                tabIndex: "-1",
                role: "dialog",
                "aria-labelledby": constants.MATTERPORT_ARIA_LABEL,
                "aria-hidden": "true",
                "data-keyboard": "false",
                "data-backdrop": "static",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-dialog",
                    role: "document",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "close",
                                    "data-dismiss": "modal",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "\xd7"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: matterportUrl,
                                    title: "",
                                    style: {
                                        width: "100%",
                                        height: "800px",
                                        border: "0"
                                    },
                                    allowFullScreen: true
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_Embed = (Embed);

;// CONCATENATED MODULE: ./components/Default/Spacer/v1/Spacer.jsx



const Spacer_Spacer = (param)=>{
    let { data  } = param;
    const { backgroundColor ="" , desktopHeight ="" , ipadHeight ="" , mobileHeight =""  } = data;
    const [style, setStyle] = (0,react.useState)({
        backgroundColor: backgroundColor,
        color: backgroundColor,
        height: desktopHeight
    });
    (0,react.useEffect)(()=>{
        if (lib/* isTablet */.Em) {
            setStyle((style)=>{
                return {
                    ...style,
                    height: ipadHeight
                };
            });
        }
        if (lib/* isMobile */.tq) {
            setStyle((style)=>{
                return {
                    ...style,
                    height: mobileHeight
                };
            });
        }
    }, [
        lib/* isTablet */.Em,
        lib/* isMobile */.tq
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-separator",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
            className: "cmp-separator__horizontal-rule",
            style: style
        })
    });
};
/* harmony default export */ var v1_Spacer = (Spacer_Spacer);

// EXTERNAL MODULE: ./components/Default/PromoBanner/v1/index.module.scss
var PromoBanner_v1_index_module = __webpack_require__(38326);
var PromoBanner_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(PromoBanner_v1_index_module);
;// CONCATENATED MODULE: ./components/Default/PromoBanner/v1/PromoBanner.jsx









const PromoBanner = (param)=>{
    let { data ={} , properties ={}  } = param;
    var ref, ref1, ref2, ref3;
    const promoBannerSettings = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false
    };
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
        (0,helper/* preventBodyScroll */.MVu)(true);
    };
    const [bannerIndex, setBannerIndex] = (0,react.useState)(0);
    const getComponentMessage = (message, index)=>{
        if (message && index > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(index + 1);
            return JSON.stringify(obj);
        }
    };
    const afterChangeHandler = (currentIndex)=>{
        setBannerIndex(currentIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PromoBanner_v1_index_module_default()).promoBannerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "carousel-slick carousel ".concat(data === null || data === void 0 ? void 0 : (ref = data.carouselComponentProperties) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames),
            role: "group",
            "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
            "aria-roledescription": "carousel",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "carousel", '","internalLinkZoneName":"').concat(data === null || data === void 0 ? void 0 : data.pageName.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "carousel", '","internalLinkURL":"n/a","internalLinkName":"carousel:rm","eventName":"').concat(data === null || data === void 0 ? void 0 : (ref1 = data.pageName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"carousel","eventAction":"').concat(data === null || data === void 0 ? void 0 : (ref2 = data.pageName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ",
                role: "group",
                "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
                "aria-roledescription": "carousel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                    ...promoBannerSettings,
                    className: "cmp-carousel-slick__content single-slider",
                    afterChange: afterChangeHandler,
                    children: data["carouselComponentProperties"][":itemsOrder"] && ((ref3 = data["carouselComponentProperties"][":itemsOrder"]) === null || ref3 === void 0 ? void 0 : ref3.map((key, index, arr)=>{
                        var ref;
                        const item = data["carouselComponentProperties"][":items"][key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "promo-banner",
                                style: {
                                    visibility: "visible"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-promo__description",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.description)
                                            }
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.actionsEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.actionItems) === null || ref === void 0 ? void 0 : ref.map((action, index)=>{
                                            return action.enablePopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: ()=>setPromoModal({
                                                        show: true,
                                                        modalContent: {
                                                            banner: item,
                                                            item: action,
                                                            count: index
                                                        }
                                                    }),
                                                "data-toggle": "modal",
                                                "data-target": "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index),
                                                className: "cmp-promo__action-link btn promo-banner-fragment",
                                                rel: "".concat(action.linkRef ? "noreferrer" : ""),
                                                "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos, bannerIndex),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "promo banner", '","internalLinkZoneName":"').concat(item === null || item === void 0 ? void 0 : item.pageType.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "global header", '","internalLinkURL":"n/a","internalLinkName":"').concat(action === null || action === void 0 ? void 0 : action.text, '","eventName":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventMsg":"n/a","eventStatus":"n/a","eventType":"promo banner","eventAction":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '"}'),
                                                "data-gbh-clickable": true,
                                                children: action === null || action === void 0 ? void 0 : action.text
                                            }, "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                                item: item,
                                                ...action,
                                                link: (action === null || action === void 0 ? void 0 : action.link) || (action === null || action === void 0 ? void 0 : action.ctaLink),
                                                newTab: action === null || action === void 0 ? void 0 : action.isNewTab,
                                                bannerIndex: bannerIndex
                                            }, "promo-banner-action-".concat(bannerIndex + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                        }))
                                    ]
                                })
                            })
                        }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cmp-promo-banner-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                    }))
                })
            })
        })
    });
};
/* harmony default export */ var v1_PromoBanner = (PromoBanner);

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
;// CONCATENATED MODULE: ./components/Default/AemForm.jsx






const AemForm = (props)=>{
    var ref;
    const { data: { formPath , submitType , thankyouMessage , useiframe , enableFocusOnFirstField , thankyouConfig  }  } = props;
    const [innerHtmlToSet, setInnerHtmlToSet] = (0,react.useState)("");
    const [formScripts, setFormScripts] = (0,react.useState)(null);
    const [noOfScripts, setNoOfScripts] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        (0,constants_api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: formPath + ".html"
            }
        }).then((res)=>{
            const scriptsList = [];
            let innerHTML = res.data;
            if ((location === null || location === void 0 ? void 0 : location.hostname) === "localhost") {
                innerHTML = innerHTML.split('rel="stylesheet" href="').join('rel="stylesheet" href="'.concat(constants.authorBaseUrl));
                innerHTML = innerHTML.split('<script src="').join('<script src="'.concat(constants.authorBaseUrl));
            }
            const doc = new DOMParser().parseFromString(innerHTML, "text/html");
            (0,helper/* extractScriptsFromDOM */.CZn)(doc, (item)=>scriptsList.push(item));
            setFormScripts(scriptsList);
            setInnerHtmlToSet(doc);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "aemFormInitialLoadJavascript",
                "data-nscript": "afterInteractive",
                children: 'const onAemFormScriptLoad = evnt => {\n    const formApp = evnt.detail.formApp\n    formApp.initializeAEMForm({\n      form: "true",\n      submitType: "'.concat(submitType, '",\n      thankyouConfig: "').concat(thankyouConfig, '",\n      thankyouMessage: "').concat(encodeURI(thankyouMessage), '",\n      thankyouPage: "",\n      useIframe: "').concat(useiframe, '",\n      height: "auto",\n      aemFormComponentPath: "aemform",\n      enableFocusOnFirstField: "').concat(enableFocusOnFirstField, '",\n    })\n    // remove the event listener after completion\n    window.removeEventListener("aemform-onscript-load", onAemFormScriptLoad)\n  };\n  window.addEventListener("aemform-onscript-load", onAemFormScriptLoad);')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/js/formapp.js"
            }),
            formScripts && formScripts.map((script, i)=>{
                if (!script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    id: "aemform-src-script-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    }
                }, "aemform-src-script-".concat(i));
                if (script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "aemform-innerscript-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    children: "".concat(script.innerHTML)
                }, "aemform-innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aemform aem-genericForm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aemformcontainer",
                    "data-form-page-path": formPath,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: innerHtmlToSet === null || innerHtmlToSet === void 0 ? void 0 : (ref = innerHtmlToSet.documentElement) === null || ref === void 0 ? void 0 : ref.innerHTML
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Default_AemForm = (AemForm);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./components/productCard/v1/ProductCard.view.jsx
var ProductCard_view = __webpack_require__(27221);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/productCard/v1/analytics.js
var v1_analytics = __webpack_require__(76735);
// EXTERNAL MODULE: ./components/productCard/v1/productCardHelper.js
var productCardHelper = __webpack_require__(69442);
// EXTERNAL MODULE: ./components/productCard/v1/index.module.scss
var productCard_v1_index_module = __webpack_require__(53613);
var productCard_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(productCard_v1_index_module);
;// CONCATENATED MODULE: ./components/productCard/v1/ProductCardService.jsx


















const ProductCardService = (props)=>{
    const { staticTexts ={} , imagePosition ="" , narrativeDescription , productFeatures =[] , productCategory ="" , badgeVal ="" , currencySign ="" , isNearestValueUpdated =Boolean , resetNearestValueUpdateFlag =()=>{} , cart ={} , price =Number , skuId ="" , images ="" , userZipCode ="" , slug ="" , getZipCode =()=>{} , customerBrand ="" , name: servicePlanName = ""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNotNearestError, setIsNotNearestError] = (0,react.useState)(false);
    const [isCheckAvailability, setIsCheckAvailability] = (0,react.useState)(true);
    const [checkZipCode, setCheckZipCode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [findaProLandingPagePath, setFindaProLandingPagePath] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            const { general  } = CONFIG;
            var ref;
            (0,helper/* getShortenedUrl */.Ppy)((ref = general === null || general === void 0 ? void 0 : general.findaProLandingPagePath) !== null && ref !== void 0 ? ref : "/").then((url)=>{
                setFindaProLandingPagePath(url);
            });
            var ref1;
            (0,helper/* getShortenedUrl */.Ppy)((ref1 = general === null || general === void 0 ? void 0 : general.cartLandingPagePath) !== null && ref1 !== void 0 ? ref1 : "/").then((url)=>{
                setCartUrl(url);
            });
            setSiteName((general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] : "");
        });
    }, []);
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const { altTextForServiceImg ="" , virtualService ="" , virtualTooltip ="" , nearestInPerson ="" , nearestService ="" , change ="" , zipcode: zipCode = "" , eligibleZipCodeSuccess ="" , eligibleZipCodeError ="" , discountPercentage ="" , off ="" , yourCart , itemAdded , itemsAdded , zipcodeEmptyError ="" , zipodeEmptyError ="" , validZipcode ="" , search =""  } = staticTexts;
    const installServices = productCategory === "Install Services";
    const designServices = productCategory === "Design Services";
    (0,react.useEffect)(()=>{
        if (isNearestValueUpdated && resetNearestValueUpdateFlag) {
            resetNearestValueUpdateFlag();
            if (!isNearest) {
                addZipcodeAnalytics("failure", eligibleZipCodeError.toLowerCase());
            } else {
                addZipcodeAnalytics("success");
            }
        }
    }, [
        isNearestValueUpdated
    ]);
    let discountedPrice = props.discountedPrice;
    let discountPercent = props.discountPercent;
    let discountType = "";
    if ((cart === null || cart === void 0 ? void 0 : cart.lineItems) && cart.lineItems.length > 0) {
        cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
            if (product.discountedPrice) {
                discountedPrice = (Number(get_default()(product.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                discountType = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
            if (discountPercent === 0) {
                discountedPrice = Number(get_default()(product.price, "discounted.value.centAmount", 0) / 100).toFixed(2);
                discountType = get_default()(product.price, "discounted.discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.price, "discounted.discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.price, "discounted.discount.obj.value.permyriad", 0)) / 100;
            }
        });
    }
    const productPrice = discountPercent > 0 ? discountedPrice : price;
    if (discountType === "") {
        var ref;
        discountType = badgeVal && ((ref = badgeVal === null || badgeVal === void 0 ? void 0 : badgeVal.split(" ")) === null || ref === void 0 ? void 0 : ref.includes("Percent")) ? "relative" : "absolute";
    }
    const getSaleOffer = "<p class='offer-percent'>".concat(discountType === "relative" ? discountPercent + discountPercentage : currencySign + discountPercent + "<span class='offer-percent-text'>" + off + "</span>", "</p>");
    const productAnalyticsData = {
        desc: productFeatures ? (0,helper/* sanitizeTextForAnalytics */.T68)(productFeatures.join(". ")) : "n/a",
        discountPrice: discountPercent > 0 ? discountedPrice : 0,
        discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
        unitPrice: price,
        category: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        color: "n/a",
        sku: skuId,
        name: (0,helper/* sanitizeTextForAnalytics */.T68)(props.name),
        image: images,
        customerFacingSKU: props.customerFacingSKU || (siteName ? siteName[0] + "-" + skuId : ""),
        skuInitials: props.customerFacingSKU ? props.customerFacingSKU.split("-")[0] + "-" : siteName ? siteName[0] + "-" : "",
        discountName: badgeVal,
        superSku: false,
        selectedColor: "n/a",
        productSaleable: true
    };
    const { desc ="n/a" , unitPrice =0 , discountPriceState , category , color , customerFacingSKU , name , discountName  } = productAnalyticsData;
    const serviceName = productCategory === "Design Services" ? "bathroom design services" : (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory);
    let globalDiscount = props.globalDiscount;
    const { productCouponCode , productCoupondiscount , globalDiscountNames , globalDiscountValues  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: cart,
        sku: skuId
    });
    let globalOffer = [
        discountName
    ];
    if ((globalDiscountNames === null || globalDiscountNames === void 0 ? void 0 : globalDiscountNames.length) && globalDiscountValues) {
        globalOffer = [
            discountName,
            ...globalDiscountNames
        ];
        globalDiscount += globalDiscountValues;
    }
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((price - globalDiscount).toFixed(2)) : 0,
        globalOffer: globalOffer.join("|") || "n/a",
        globalDiscount: globalDiscount ? Number(globalDiscount.toFixed(2)) : 0,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: Number(unitPrice) || "n/a",
        productCategory: category || "n/a",
        productColor: color || "n/a",
        productCoupondiscount: productCoupondiscount || 0,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: customerFacingSKU || "n/a",
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name || "n/a",
        quantity: quantity || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category || "n/a",
        productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
        itemType: "service" || 0
    };
    const getToasterMsg = (msg)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                msg,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: cartUrl,
                    children: yourCart
                }),
                "."
            ]
        });
    const handleCallback = async (res, msg)=>{
        if (productCategory === "Install Services") {
            const eventInfoObj = getEventInfoObject("add to cart");
            const { status , message ="n/a"  } = res;
            eventInfoObj.eventStatus = status === 200 ? "success" : "failure";
            if (status !== 200) {
                eventInfoObj.eventMsg = message ? (0,helper/* sanitizeTextForAnalytics */.T68)(message) : "n/a";
            }
            await (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfoObj, "cmp:click", null, null, productInfo);
        }
        if (productCategory === "Design Services") {
            await (0,v1_analytics/* callDesignServicesAddToCartAnalytics */.__)(res, productInfo, serviceName);
        }
        if (lib/* isMobile */.tq) showToaster(getToasterMsg(msg));
    };
    const addtoCart = async (items)=>{
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        const msg = totalAdded === 1 ? "".concat(totalAdded, " ").concat(itemAdded, " ") : "".concat(totalAdded, " ").concat(itemsAdded, " ");
        await (0,productCardHelper/* productCardAddToCart */.x)([
            ...items
        ], true, "", (res)=>handleCallback(res, msg), false);
    };
    const handleAddToCart = async ()=>{
        if (productCategory === "Design Services") {
            await addtoCart([
                {
                    sku: skuId,
                    quantity: quantity,
                    brand: customerBrand
                }
            ]);
        } else if (!isEmpty_default()(userZipCode)) {
            await addtoCart([
                {
                    sku: skuId,
                    quantity: quantity,
                    userZipCode: userZipCode,
                    brand: customerBrand
                }
            ]);
        }
    };
    const handleChange = async (qty)=>{
        if (qty && qty !== 0) {
            setQuantity(qty);
        }
    };
    const handleCheckAvailability = async ()=>{
        setZipCodeError({
            show: false,
            message: ""
        });
        let valid = true;
        let errorMessage = "";
        if (isEmpty_default()(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: zipcodeEmptyError
            });
            valid = false;
            errorMessage = zipodeEmptyError.toLowerCase();
        } else if (!(0,helper/* validateField */.OP$)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        } else if (!await (0,utils_location/* validateZip */.$8)(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        }
        if (valid) {
            getZipCode(checkZipCode, callBackZipCode, true);
        } else {
            addZipcodeAnalytics("failure", errorMessage);
        }
    };
    const handleChangeZipCode = (e)=>{
        const { value  } = e.target;
        if ((0,helper/* validateField */.OP$)("zipCodeNumeric", value) || value === "") {
            setCheckZipCode(value);
        }
        setIsNotNearestError(false);
        setZipCodeError({
            show: false,
            message: ""
        });
    };
    const zipCodeCheck = ()=>{
        if (!(0,helper/* validateField */.OP$)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
        } else {
            setZipCodeError({
                show: false,
                message: ""
            });
        }
    };
    const getEventInfoObject = (eventNameText, buttonName)=>{
        return {
            clickInternalLinks: "true",
            eventAction: "installation services:install service:" + eventNameText,
            eventName: "installation services:install service:" + eventNameText,
            eventType: "navigation",
            internalLinkName: buttonName !== null && buttonName !== void 0 ? buttonName : eventNameText,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkPosition: "find installation services",
            internalLinkType: "installation services:" + (eventNameText !== "check availability" || !checkZipCode ? "navigation" : checkZipCode),
            internalLinkURL: eventNameText === "find a pro" ? ((findaProLandingPagePath === null || findaProLandingPagePath === void 0 ? void 0 : findaProLandingPagePath.indexOf("http")) === -1 ? window.location.origin : "") + findaProLandingPagePath : "n/a",
            internalLinkZoneName: "installation services:" + productAnalyticsData.name
        };
    };
    const addZipcodeAnalytics = (status, message)=>{
        const eventInfoObj = getEventInfoObject("check availability", "search");
        eventInfoObj.eventMsg = message || "n/a";
        eventInfoObj.eventStatus = status;
        (0,v1_analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: {},
            productInfo,
            eventInfoObj,
            cartID: cart === null || cart === void 0 ? void 0 : cart.id
        });
    };
    const callBackZipCode = (isServiceAvailable)=>{
        setIsNearest(isServiceAvailable);
        setIsNotNearestError(!isServiceAvailable);
        setIsCheckAvailability(!isServiceAvailable);
        if (isServiceAvailable) sessionStorage.setItem("verifiedZip", checkZipCode);
    };
    (0,react.useEffect)(()=>{
        const isVerifiedZip = sessionStorage.getItem("verifiedZip");
        if (isVerifiedZip) {
            setIsNearest(true);
            setIsNotNearestError(false);
            setIsCheckAvailability(false);
            setCheckZipCode(isVerifiedZip);
        }
    }, []);
    const handleClickChangeBtn = ()=>{
        setIsCheckAvailability(true);
        setIsNearest(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (productCard_v1_index_module_default()).productCardWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-card-service",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "kf-react-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row ml-0 mr-0 no-gutters",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col product-card-service__details \n                  ".concat(imagePosition === "left" ? " product-card-service__details-align" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(productCategory === "Install Services" ? "product-card-service__details-header" : "product-card-service__service-install"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: "product-card-service__name",
                                                        children: servicePlanName
                                                    }),
                                                    productCategory === "Install Services" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "product-card-service__desc",
                                                        children: narrativeDescription
                                                    }) : null,
                                                    productCategory === "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-card-service__virtual-list",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: productFeatures.map((list, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: list
                                                                }, index))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-card-service__img-container \n                              ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " \n                              mobile-landscape-image"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: images,
                                                    className: "product-card-service__img",
                                                    alt: altTextForServiceImg
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__virtual-service \n                          ".concat(productCategory ? " product-card-service__virtual-service-zip" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "left",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "product-card-service__eligible-service-txt",
                                                                    children: designServices ? virtualService : isNearest ? nearestInPerson : nearestService
                                                                }),
                                                                isNearest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "product-card-service__zipcode",
                                                                            children: checkZipCode
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            tabIndex: "0",
                                                                            role: "link",
                                                                            className: "product-card-service__eligible-service-edit gbh-data-layer",
                                                                            "data-gbh-data-layer": JSON.stringify(getEventInfoObject("edit", "change")),
                                                                            "data-gbh-data-layer-custom": JSON.stringify({
                                                                                productInfo
                                                                            }),
                                                                            onClick: handleClickChangeBtn,
                                                                            children: [
                                                                                " ",
                                                                                change
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__price",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "product-card-service__price-value",
                                                                    value: productPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "product-card-service__discount-price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "product-card-service__offer-price",
                                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(getSaleOffer)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            className: "strike-through-price",
                                                                            value: price,
                                                                            displayType: "text",
                                                                            thousandSeparator: true,
                                                                            prefix: currencySign,
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                isCheckAvailability && installServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__zipcode-availability",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                    id: "zipCode-".concat((0,helper/* getRandom */.sZz)()),
                                                                    type: "text",
                                                                    maxLength: 60,
                                                                    placeholder: "".concat(zipCode),
                                                                    label: "".concat(zipCode),
                                                                    value: checkZipCode,
                                                                    customClass: "".concat(zipCodeError.show ? "product-card-service__zipcode-input-error" : ""),
                                                                    onKeyDown: (e)=>e.key === "Enter" && handleCheckAvailability(),
                                                                    onChange: handleChangeZipCode,
                                                                    onBlur: zipCodeCheck
                                                                }),
                                                                checkZipCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                    role: "button",
                                                                    className: "product-card-service__check-availability-cta",
                                                                    label: search,
                                                                    size: "small",
                                                                    type: " ",
                                                                    disabled: checkZipCode.length < 5,
                                                                    onClick: handleCheckAvailability
                                                                }) : null
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "product-card-service__zipcode-error",
                                                            children: zipCodeError.message
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service-container",
                                                    children: [
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "product-card-service__eligible-service-message",
                                                            children: designServices ? virtualTooltip : eligibleZipCodeSuccess
                                                        }) : null,
                                                        isNotNearestError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "error",
                                                            children: [
                                                                eligibleZipCodeError,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: findaProLandingPagePath,
                                                                    className: "product-card-service__find-a-pro gbh-data-layer",
                                                                    "data-gbh-data-layer": JSON.stringify(getEventInfoObject("find a pro")),
                                                                    "data-gbh-data-layer-custom": JSON.stringify({
                                                                        productInfo
                                                                    }),
                                                                    children: staticTexts.findaPro
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__price-and-cart",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-card-service__cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cartAction mx-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "quantity-selector-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                            doNotRequiredAnalyticsData: true,
                                                            productData: productAnalyticsData,
                                                            value: quantity,
                                                            onChange: handleChange,
                                                            isPDPQuantitySelector: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "add-to-cart-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                            role: "button",
                                                            label: staticTexts.addToCart,
                                                            onClick: handleAddToCart,
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true,
                                                            disabled: productCategory !== "Design Services" ? !isNearest : false
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card-service__img-container ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " product-card-service-main-image"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: images,
                                className: "product-card-service__img",
                                alt: altTextForServiceImg
                            })
                        })
                    ]
                })
            })
        })
    });
};
ProductCardService.defaultProps = {
    newTab: false,
    staticTexts: {}
};
ProductCardService.propTypes = {
    newTab: (prop_types_default()).bool,
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var v1_ProductCardService = (ProductCardService);

;// CONCATENATED MODULE: ./i18n/useProductCardi18n.js

const useProductCardi18n = (param)=>{
    let { componentProps  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        color: t("kf.productcard.color"),
        colors: t("kf.productcard.colors"),
        altText: t("kf.productCard.altText"),
        altTextForServiceImg: t("kf.productCard.altTextForServiceImg"),
        virtualService: t("kf.productCard.virtualService"),
        virtualTooltip: t("kf.productCard.virtualTooltip"),
        addToCart: t("kf.productCard.addToCart"),
        toolTipAlt: t("kf.productCard.toolTipAlt"),
        nearestService: t("kf.productCard.nearestService"),
        nearestInPerson: t("kf.productCard.nearestInPerson"),
        edit: t("kf.productCard.edit"),
        eligibleZipCodeSuccess: t("kf.productCard.eligibleZipCodeSuccess"),
        eligibleZipCodeError: t("kf.productCard.eligibleZipCodeError"),
        zipcode: t("kf.productCard.zipcode"),
        findaPro: t("kf.productCard.findaPro"),
        checkAvailability: t("kf.productCard.checkAvailability"),
        maxInventory: t("kf.productCard.maxInventory"),
        itemsAdded: t("kf.productCard.itemsAdded"),
        itemAdded: t("kf.productCard.itemAdded"),
        yourCart: t("kf.productCard.yourCart"),
        zipcodeEmptyError: t("kf.productCard.zipcodeEmptyError"),
        validZipcode: t("kf.productCard.validZipcode"),
        ariaLabel: {
            color: t("kf.productCard.aria.colors"),
            tooltip: t("kf.productCard.aria.tooltip"),
            editZip: t("kf.productCard.aria.label.editZip"),
            findPro: t("kf.productCard.aria.label.findPro")
        },
        discountPercentage: t("kf.productCard.discountPercentage"),
        off: t("kf.productCard.off"),
        lfLabel: t("annsacks.pdpTrimCalculator.label.LF"),
        sfLabel: t("annsacks.pdpTrimCalculator.label.SF"),
        boxLabel: t("annsacks.pdpProductSummary.label.perBox"),
        recentlyViewedColor: t("kf.productcard.color"),
        recentlyViewedColors: t("kf.productcard.colors"),
        search: t("kf.productCard.search")
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductCardi18n = (useProductCardi18n);

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./components/productCard/v1/ProductCard.jsx

















const ProductCard = (props)=>{
    const { data: authorData , data: { presetConfigs  }  } = props;
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [state] = (0,react.useState)({
        productSkuId: authorData.type === "productSku" ? get_default()(authorData, "productSkuId", "") : get_default()(authorData, "serviceSkuId", ""),
        newTab: get_default()(authorData, "newTab", false),
        skuType: get_default()(authorData, "type", ""),
        imagePosition: get_default()(authorData, "imagePosition", ""),
        jsonFileUrl: get_default()(authorData, "jsonFilePath", ""),
        swatchUrl: authorData.swatchUrl
    });
    const [productDetailData, setProductDetailData] = (0,react.useState)({});
    const [userZipCode, setUserZipCode] = (0,react.useState)("");
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNearestValueUpdated, setIsNearestValueUpdated] = (0,react.useState)(false);
    const [zipCodeData, setZipCodeData] = (0,react.useState)([]);
    const [info, setInfo] = (0,react.useState)({});
    const staticTexts = i18n_useProductCardi18n({});
    const persona = (0,helper/* getUserPersona */.shu)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const language = get_default()(config, "internationalization.language", "en");
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: state.jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _zipcode;
                    setZipCodeData((_zipcode = response.data.zipcode) !== null && _zipcode !== void 0 ? _zipcode : []);
                }
            }).catch((err)=>{
                console.error("Failed to get compare attributes JSON file", err);
            });
            const info = {
                locale: locale,
                language: language,
                currencySign: currencySign,
                currencyCode: currencyCode,
                brandName: brandName,
                lwAppName
            };
            setInfo(info);
        });
    }, []);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(info)) {
                fetchFromSku();
            }
        } catch (error) {
            console.error(error);
        }
        getUserLocation();
    }, [
        info
    ]);
    const getUserLocation = ()=>{
        (0,helper/* getLocationByCookies */.ngN)().then((getLocation)=>{
            var _zipcode;
            const userZipCode = (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "";
            checkUserZipCode(userZipCode);
        });
    };
    const checkUserZipCode = function(userZipCodeVal, callBack) {
        let needAnalytics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (!userZipCodeVal || isEmpty_default()(zipCodeData)) {
            return;
        }
        const isNearest = (0,productCardHelper/* findZipCodeMatch */.w)(userZipCodeVal, zipCodeData);
        setIsNearest(isNearest);
        setIsNearestValueUpdated(needAnalytics);
        if (callBack) callBack(isNearest);
    };
    const getZipCode = function(zipCodeVal, callback) {
        let needAnalytics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        setUserZipCode(zipCodeVal);
        checkUserZipCode(zipCodeVal, callback, needAnalytics);
    };
    const fetchFromSku = ()=>{
        const fl = [
            "id",
            "slug_s",
            "productName_s",
            "masterSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "productImageVariantImages.url_ss",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "Color.SKU.Details_ss",
            "ProductWebFeatures_ss",
            "ProductWebFeatures_s",
            "ProductExclusive_s",
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "title_s",
            "ProductNarrativeDescription_s",
            "priceList.".concat(persona, ".finalPrice_d"),
            "CustomerFacingBrand_s",
            "RegionBrandName_s",
            "productImages.labelWithUrl_ss"
        ];
        constants_api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: fl.join(","),
                q: "*:*",
                fq: [
                    'variantList.sku_ss:("'.concat(state.productSkuId, '")'),
                    'language_s:("'.concat(info.language, '")')
                ],
                collections: info.lwAppName.toLowerCase(),
                profilename: "profile_".concat(info.lwAppName.toLowerCase(), "_General")
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        }).then((res)=>{
            if (res && res.data) {
                const productData = get_default()(res.data, "response.docs[0]", {});
                setProductDetailData(productData);
            } else {
                console.error("Error occured while fetching product data");
            }
        });
    };
    const productCardProps = {};
    productCardProps.presetConfigs = presetConfigs !== null && presetConfigs !== void 0 ? presetConfigs : "";
    var _swatchUrl;
    productCardProps.swatchUrl = (_swatchUrl = state.swatchUrl) !== null && _swatchUrl !== void 0 ? _swatchUrl : "";
    if (productDetailData) {
        var ref;
        // get product images
        if (productDetailData["modifiedproductImageVariantImages.url_ss"]) {
            var ref1;
            const imageStrig = (ref1 = productDetailData["modifiedproductImageVariantImages.url_ss"]) === null || ref1 === void 0 ? void 0 : ref1.split("|");
            productCardProps.images = imageStrig.length ? imageStrig[imageStrig.length - 1] : "";
        } else if (productDetailData["productImages.url_ss"]) {
            var ref2;
            productCardProps.images = (ref2 = productDetailData["productImages.url_ss"][0]) !== null && ref2 !== void 0 ? ref2 : "";
        } else {
            productCardProps.images = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
        }
        // get product colors
        if (productDetailData["Color.SKU.Details_ss"]) {
            var ref3;
            const colors = (ref3 = productDetailData["Color.SKU.Details_ss"]) !== null && ref3 !== void 0 ? ref3 : [];
            productCardProps.colors = colors.filter((item)=>{
                const color = item.split("|");
                return color[4] === "false" || Date.parse(color[4]) > Date.now();
            });
        }
        // get product web features
        if (productDetailData["ProductWebFeatures_s"]) {
            var ref4;
            productCardProps.productFeatures = (ref4 = [
                productDetailData["ProductWebFeatures_s"]
            ]) !== null && ref4 !== void 0 ? ref4 : [];
        } else {
            var ref5;
            productCardProps.productFeatures = (ref5 = productDetailData["ProductWebFeatures_ss"]) !== null && ref5 !== void 0 ? ref5 : [];
        }
        productCardProps.currencySign = info.currencySign;
        productCardProps.productCategory = get_default()(productDetailData, "Product_Category", "");
        productCardProps.name = get_default()(productDetailData, "productName_s", "");
        productCardProps.brandName = get_default()(productDetailData, "RegionBrandName_s", "");
        productCardProps.description = get_default()(productDetailData, "title_s", "");
        productCardProps.narrativeDescription = get_default()(productDetailData, "ProductNarrativeDescription_s", "");
        productCardProps.price = get_default()(productDetailData, "priceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountedPrice = get_default()(productDetailData, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountPercent = parseInt(get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), 0));
        productCardProps.slug = get_default()(productDetailData, "slug_s", "");
        productCardProps.customerBrand = get_default()(productDetailData, "CustomerFacingBrand_s", "");
        let tempColorDetails = get_default()(productDetailData, "Color.SKU.Details_ss", null);
        if (tempColorDetails) {
            if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                tempColorDetails = tempColorDetails[0];
            }
            productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
        }
        productCardProps.badgeVal = get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), "");
        productCardProps.globalDiscount = productCardProps.price - get_default()(productDetailData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
        const productCategory = productCardProps === null || productCardProps === void 0 ? void 0 : (ref = productCardProps.productCategory) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        productCardProps.priceType = "";
        if (productCategory === "field tiles" || productCategory === "slabs" || productCategory === "mosaics") {
            productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sfLabel);
        }
        if (productCategory === "trims & moldings") {
            productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lfLabel);
        }
        if (productCategory === "grout") {
            productCardProps.priceType = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.boxLabel;
        }
    }
    const resetNearestValueUpdateFlag = ()=>{
        setIsNearestValueUpdated(false);
    };
    return state.skuType !== "productSku" && !isEmpty_default()(state.productSkuId) && !isEmpty_default()(productCardProps) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCardService, {
        ...productCardProps,
        imagePosition: state.imagePosition,
        newTab: state.newTab,
        staticTexts: staticTexts,
        currencySign: info.currencySign,
        userZipCode: userZipCode,
        isNearest: isNearest,
        skuId: state.productSkuId,
        getZipCode: getZipCode,
        resetNearestValueUpdateFlag: resetNearestValueUpdateFlag,
        isNearestValueUpdated: isNearestValueUpdated,
        cart: cart
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_view/* default */.Z, {
        ...productCardProps,
        product: productCardProps,
        i18n: staticTexts,
        currencySign: info.currencySign,
        presetConfigs: presetConfigs,
        title: productCardProps === null || productCardProps === void 0 ? void 0 : productCardProps.brandName,
        skuId: state.productSkuId
    });
};
/* harmony default export */ var v1_ProductCard = (ProductCard);

// EXTERNAL MODULE: ./components/productCard/v3/ProductCard.jsx
var v3_ProductCard = __webpack_require__(44685);
;// CONCATENATED MODULE: ./components/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    var ref, ref1, ref2;
    if (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : (ref1 = type.subCategory1) === null || ref1 === void 0 ? void 0 : ref1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : (ref2 = type.subCategory1) === null || ref2 === void 0 ? void 0 : ref2.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref3;
    return (ref3 = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref3 !== void 0 ? ref3 : "";
};
const getAnalyticsEventInfo = ()=>{
    var ref;
    const type = window.adobeDataLayer.length ? window.adobeDataLayer[0]["page"]["category"] : {};
    const eventFor = getEventFor(type);
    const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:close" : "".concat(eventFor, ":close");
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventName: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
    });
};
const productInfoNextEventInfo = ()=>{
    return '{"eventAction":"my account:register non kohler products:product information:next","eventName":"my account:register non kohler products:product information:next","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"next","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}';
};


;// CONCATENATED MODULE: ./components/FindingModelNumber/v1/FindingModelNumber.jsx











const FindingModelNumber = (param)=>{
    let { authorData ={}  } = param;
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { FindingModelModal: { show: isShowModelNumberModal  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [findingModelData, setFindingModelData] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
            el.addEventListener("click", showFindingModelPopupHandler);
        });
        findModelNumber();
        return ()=>{
            document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
                el.removeEventListener("click", showFindingModelPopupHandler);
            });
        };
    }, []);
    const showFindingModelPopupHandler = (e)=>{
        e.preventDefault();
        dispatch((0,genericSlice/* showFindingModelPopup */.RS)());
    };
    const findModelNumber = ()=>{
        if (!isEmpty_default()(authorData.findModelNumber)) {
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: authorData.findModelNumber
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _data;
                    setFindingModelData((_data = response.data) !== null && _data !== void 0 ? _data : {});
                } else {
                    console.error("Finding a model number: Error occured while fetching data from Get URL Property");
                }
            }).catch((err)=>console.error(err));
        }
    };
    const compareWidth = (a, b)=>{
        if (Number(a.width) > Number(b.width)) return -1;
        if (Number(a.width) < Number(b.width)) return 1;
        return 0;
    };
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "finding-model-number",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal["default"], {
            StickCloseButton: true,
            closeButtonAnalytics: getAnalyticsEventInfo(),
            needAnalyticsOnContentsLink: true,
            onModalClose: ()=>dispatch((0,genericSlice/* hideFindingModelPopup */._W)()),
            showModal: isShowModelNumberModal,
            children: !isEmpty_default()(findingModelData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: !isEmpty_default()(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) ? (0,helper/* sanitizeText */.oOy)(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-explanation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath) ? findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath : findingModelData === null || findingModelData === void 0 ? void 0 : (ref = findingModelData.smartcrop) === null || ref === void 0 ? void 0 : ref.sort(compareWidth),
                            width: "80%",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "finding-model-number__content ".concat((findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.style) === "des-bg-off-white" ? "finding-model-number__content-bg" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "description",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)((ref1 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.description) !== null && ref1 !== void 0 ? ref1 : "")
                            }),
                            (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "signUp-text",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": productInfoNextEventInfo(),
                                    type: "black",
                                    label: (ref2 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) !== null && ref2 !== void 0 ? ref2 : "",
                                    to: (ref3 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLink) !== null && ref3 !== void 0 ? ref3 : "",
                                    target: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.newTabLink) === "true" ? "_blank" : "_self"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_FindingModelNumber = (FindingModelNumber);

// EXTERNAL MODULE: ./components/InPageSearch/v1/InPageSearch.jsx + 31 modules
var InPageSearch = __webpack_require__(67848);
// EXTERNAL MODULE: ./components/Loader/index.jsx
var Loader = __webpack_require__(65277);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/localization.js
var MyList_localization = __webpack_require__(57493);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/helper.js
var MyList_helper = __webpack_require__(61171);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/ListInventoryCheckModal/index.jsx
var ListInventoryCheckModal = __webpack_require__(85619);
// EXTERNAL MODULE: ./components/ShareList/index.module.scss
var ShareList_index_module = __webpack_require__(49443);
var ShareList_index_module_default = /*#__PURE__*/__webpack_require__.n(ShareList_index_module);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
// EXTERNAL MODULE: ./components/SaveToList/index.jsx
var SaveToList = __webpack_require__(4165);
// EXTERNAL MODULE: ./components/Shared/DisplayDiscountPrice/index.jsx
var DisplayDiscountPrice = __webpack_require__(71025);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/ColorSwatchSelected/v1/index.jsx
var v1 = __webpack_require__(72927);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Shared_Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./public/icons/out-off-stock.svg
var out_off_stock = __webpack_require__(90683);
// EXTERNAL MODULE: ./public/icons/required-installation-icon.svg
var required_installation_icon = __webpack_require__(40503);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/ListRequiredItemModal/index.jsx + 1 modules
var ListRequiredItemModal = __webpack_require__(33413);
// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
// EXTERNAL MODULE: ./components/ShareListModal/index.jsx + 1 modules
var ShareListModal = __webpack_require__(66016);
;// CONCATENATED MODULE: ./components/ShareList/ShareListRowItem/ShareListRowItem.jsx






















const ShareListRowItem = (props)=>{
    var ref, ref1, ref2;
    const { general , productQtyObj , qtyChange , product , presetConfigs , listItemsPrice , addToCart , disableAddToCart , lessStock , outOfStock , handleSingleItemToCart , availColorCTA , discontinuedText , requiredItemsToInstall , staticText ={} , handleSingleItemToCartWithInstallItems , language , handleAddItemAndRemoveItemFromList , userListItemsSkus ={}  } = props;
    const { "productImages.url_ss": imageUrl , ProductBrandName_s: brandName , masterSKU_s: sku , ProductDescriptionProductShort_s: shortDescription , ProductIsRetail_s: isRetailExclusiveValue = false  } = product;
    const isRetailExclusive = isRetailExclusiveValue === "true" ? true : false;
    const requiredProductToInstall = ((ref = listItemsPrice["".concat(sku, "-RequiredAccessories")]) === null || ref === void 0 ? void 0 : ref.length) > 0 ? true : false;
    const [tileUrl, setTileUrl] = (0,react.useState)("");
    var ref3;
    const productBrandName = (ref3 = general === null || general === void 0 ? void 0 : general.siteName) !== null && ref3 !== void 0 ? ref3 : "";
    const [showShareListModal, setShowShareListModal] = (0,react.useState)(false);
    const [showRequiredProductsModal, setShowRequiredProductsModal] = (0,react.useState)(false);
    const [showTooltip, setShowTooltip] = (0,react.useState)();
    const [width] = (0,useWindowResize/* default */.Z)();
    const colors = (0,MyList_helper/* getColors */.EC)(product);
    const images = (0,MyList_helper/* getLineItemsProductImage */.Db)(product, sku);
    const { availableSkus =[]  } = (0,MyList_helper/* checkDiscontinuedStatus */.ef)(product);
    const isProductDiscontinued = availableSkus.length === 0;
    var ref4;
    const isSkuDiscontinued = (ref4 = product["productRegionAllVariantDiscontinued_b"]) !== null && ref4 !== void 0 ? ref4 : false;
    const showAddToCart = !disableAddToCart && !isSkuDiscontinued && (product === null || product === void 0 ? void 0 : product.stockStatus) !== "Out of Stock";
    const showAvailableColors = !isProductDiscontinued && isSkuDiscontinued && availableSkus.length > 0;
    const showActionButton = showAddToCart || showAvailableColors;
    const handleImageClick = (e)=>{
        if (e.target.className && e.target.className !== "checkbox__marker-icon") {
            e.stopPropagation();
            e.preventDefault();
            location.href = decodeURIComponent("".concat(tileUrl, "?skuId=").concat(sku));
        }
    };
    const handleShowRequiredProductsModalView = (showhide)=>{
        setShowRequiredProductsModal(showhide);
    };
    const handleProductNameClick = ()=>{
        location.href = decodeURIComponent("".concat(tileUrl, "?skuId=").concat(sku));
    };
    const handleAvailableColorsClick = ()=>{
        location.href = decodeURIComponent("".concat(tileUrl, "?skuId=").concat(sku));
    };
    const handleAddToCartWithInstallItems = (items)=>{
        setShowRequiredProductsModal(false);
        handleSingleItemToCartWithInstallItems(items, sku);
    };
    (0,react.useEffect)(()=>{
        var _ProductLocalCategory_s;
        const category = product.Product_Category ? product.Product_Category : (_ProductLocalCategory_s = product.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
        (0,helper/* getPDPUrl */.ir5)(category, product.slug_s).then((ret)=>setTileUrl(ret));
    }, [
        product
    ]);
    const getOutOffStockText = ()=>{
        if ((product === null || product === void 0 ? void 0 : product.stockStatus) === "Less Stock") {
            return "".concat(product === null || product === void 0 ? void 0 : product.inventory, " ").concat(lessStock);
        } else if ((product === null || product === void 0 ? void 0 : product.stockStatus) === "Out of Stock") {
            return outOfStock;
        }
        return "";
    };
    var ref5, _sku, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "row list-item no-gutters",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12 col-sm-6 mobile-full-width col-md-6 list-left ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "list-item__summary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            role: "button",
                            onClick: (e)=>handleImageClick(e),
                            "data-testid": "view-product",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "list-image-tile",
                                children: [
                                    (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl[0]) && (images === null || images === void 0 ? void 0 : images.length) > 0 ? images === null || images === void 0 ? void 0 : images.map((id, i)=>{
                                        const imgUrl = (0,utils/* getPresetUrl */.v$)(width, 0, general.swatchUrl, id, JSON.parse(presetConfigs));
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "list-image",
                                            id: id + "_IMG_" + i,
                                            role: "presentation",
                                            src: imgUrl,
                                            imgsrc: imgUrl
                                        }, id + "_IMG_" + i);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Image/* default */.Z, {
                                        className: "list-image",
                                        src: image_missing/* default */.Z,
                                        alt: "missing-image"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "list-item__share-icon",
                                        onClick: (e)=>{
                                            handleAddItemAndRemoveItemFromList(e, sku, false);
                                        },
                                        "data-testid": "itemShareIcon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Image/* default */.Z, {
                                            src: userListItemsSkus[sku] ? wishlist_gray_filled/* default */.Z === null || wishlist_gray_filled/* default */.Z === void 0 ? void 0 : wishlist_gray_filled/* default.src */.Z.src : wish/* default */.Z === null || wish/* default */.Z === void 0 ? void 0 : wish/* default.src */.Z.src,
                                            role: "presentation",
                                            alt: "close",
                                            width: "15",
                                            height: "14"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "list-item__specs list-item__specs-tabs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row no-gutters",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 list-item-desc__name",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat(colors && ((ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.name) === "Not Applicable" ? "visibilty" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1/* default */.Z, {
                                                colors: colors,
                                                cx: (classnames_default()),
                                                general: general,
                                                mobile: true,
                                                customText: staticText === null || staticText === void 0 ? void 0 : staticText.colorAndFinish
                                            })
                                        }),
                                        isSkuDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "list-item__badge",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "badge-discontinued",
                                                children: discontinuedText
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "list-item__brand__list",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "list-item__brand-name",
                                                children: productBrandName === null || productBrandName === void 0 ? void 0 : productBrandName.toUpperCase()
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "list-item__list-name",
                                            onClick: handleProductNameClick,
                                            children: brandName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "list-product-description-short",
                                            children: shortDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "list-product-description-short-sku",
                                            children: sku
                                        }),
                                        requiredProductToInstall ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "list-product-required-products-to-install",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "required-products-install",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "required-products-install-text",
                                                            onClick: ()=>{
                                                                handleShowRequiredProductsModalView(true);
                                                            },
                                                            children: requiredItemsToInstall
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-line"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "required-products-install-icon",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Image/* default */.Z, {
                                                            src: required_installation_icon/* default */.Z === null || required_installation_icon/* default */.Z === void 0 ? void 0 : required_installation_icon/* default.src */.Z.src,
                                                            role: "presentation",
                                                            alt: "close",
                                                            width: "16",
                                                            height: "16",
                                                            onMouseOver: ()=>setShowTooltip(true),
                                                            onMouseLeave: ()=>setShowTooltip(false)
                                                        }),
                                                        showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "tooltipWrapper",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                                message: staticText === null || staticText === void 0 ? void 0 : staticText.requiredItemsToInstallToolTip,
                                                                pageName: "list-details"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : null,
                                        (product === null || product === void 0 ? void 0 : product.stockStatus) === "Less Stock" || (product === null || product === void 0 ? void 0 : product.stockStatus) === "Out of Stock" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "out-off-stock",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "out-off-stock-icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Image/* default */.Z, {
                                                        src: out_off_stock/* default */.Z === null || out_off_stock/* default */.Z === void 0 ? void 0 : out_off_stock/* default.src */.Z.src,
                                                        role: "presentation",
                                                        alt: "close",
                                                        width: "16",
                                                        height: "16"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "out-off-stock-text",
                                                    children: getOutOffStockText()
                                                })
                                            ]
                                        }) : null,
                                        colors && ((ref2 = colors[0]) === null || ref2 === void 0 ? void 0 : ref2.name) === "Not Applicable" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1/* default */.Z, {
                                            colors: colors,
                                            cx: (classnames_default()),
                                            general: general,
                                            mobile: false,
                                            customText: staticText === null || staticText === void 0 ? void 0 : staticText.colorAndFinish
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12 col-sm-6 col-md-6 list-item__info print-right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row list-item__qty-price cart-qty-price-mobile mx-0 px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4 list-item__discount-container discount-container-padding ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "list-item__price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "list-details-price hide-mobile-price",
                                        children: disableAddToCart && isSkuDiscontinued || !listItemsPrice[sku] > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "-"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayDiscountPrice/* default */.Z, {
                                            formListDetails: true,
                                            price: listItemsPrice[sku],
                                            discountedPrice: listItemsPrice[(ref5 = "".concat(sku, "-discount")) !== null && ref5 !== void 0 ? ref5 : ""],
                                            currencySign: disableAddToCart ? "CAD $" : "$",
                                            "data-testid": "price-discount"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-4 list-item__qty",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "quantity-selector no-print small",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                            size: "small",
                                            value: (_sku = productQtyObj[sku]) !== null && _sku !== void 0 ? _sku : 1,
                                            onChange: (value)=>qtyChange(value, product)
                                        })
                                    }),
                                    showActionButton && !disableAddToCart && !isRetailExclusive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        role: "button",
                                        size: "small",
                                        flexible: true,
                                        type: isSkuDiscontinued ? "black" : "ghost",
                                        className: classnames_default()("quantity-selector__addToCard", {
                                            "quantity-selector__availableColor": isSkuDiscontinued
                                        }),
                                        onClick: ()=>{
                                            isSkuDiscontinued ? handleAvailableColorsClick() : handleSingleItemToCart(sku, isSkuDiscontinued ? availColorCTA : addToCart);
                                        },
                                        label: isSkuDiscontinued ? availColorCTA : addToCart
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-4 text-right list-item__total px-0 hide-price-popup-mobile ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "list-details-price hide-mobile-price",
                                    children: disableAddToCart && isSkuDiscontinued || !listItemsPrice[sku] > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "-"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayDiscountPrice/* default */.Z, {
                                        price: (0,MyList_helper/* getProductPrice */.mt)(product, productQtyObj, listItemsPrice),
                                        currencySign: disableAddToCart ? "CAD $" : "$"
                                    })
                                })
                            })
                        ]
                    }),
                    showActionButton && !disableAddToCart && !isRetailExclusive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        role: "button",
                        size: "small",
                        flexible: true,
                        type: isSkuDiscontinued ? "black" : "ghost",
                        className: classnames_default()("list-item__addToCard", {
                            "quantity-selector__availableColor": isSkuDiscontinued
                        }),
                        onClick: ()=>{
                            isSkuDiscontinued ? handleAvailableColorsClick() : handleSingleItemToCart(sku, isSkuDiscontinued ? availColorCTA : addToCart);
                        },
                        label: isSkuDiscontinued ? availColorCTA : addToCart
                    }) : null
                ]
            }),
            showRequiredProductsModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRequiredItemModal/* default */.Z, {
                staticTexts: staticText,
                showModal: showRequiredProductsModal,
                productRequiredAccessories: (ref6 = listItemsPrice["".concat(sku, "-RequiredAccessories")]) !== null && ref6 !== void 0 ? ref6 : [],
                listItemsPrice: listItemsPrice,
                customerFacingSKU: listItemsPrice["".concat(sku, "-customerFacingSKU")],
                productDetailData: product,
                onModalClose: ()=>{
                    handleShowRequiredProductsModalView(false);
                },
                handleAddToCartWithInstallItems: handleAddToCartWithInstallItems,
                isSkuDiscontinued: isSkuDiscontinued,
                productBackOrdered: (ref7 = listItemsPrice["".concat(sku, "-RegionIsBackorderable")]) !== null && ref7 !== void 0 ? ref7 : false
            }) : null,
            showShareListModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareListModal/* default */.Z, {
                showShareListModal: showShareListModal,
                URLToShare: (0,MyList_helper/* createSharedListUrl */.N6)(sku, language),
                onClose: ()=>{
                    setShowShareListModal(false);
                }
            }) : null
        ]
    });
};
ShareListRowItem.propTypes = {
    product: prop_types_default().shape({
        "productImages.url_ss": (prop_types_default()).array,
        ProductBrandName_s: (prop_types_default()).string,
        masterSKU_s: (prop_types_default()).string,
        ProductDescriptionProductShort_s: (prop_types_default()).string,
        ProductIsRetail_s: (prop_types_default()).string,
        Product_Category: (prop_types_default()).string,
        ProductLocalCategory_s: (prop_types_default()).string,
        slug_s: (prop_types_default()).string,
        stockStatus: (prop_types_default()).string,
        inventory: (prop_types_default()).number,
        productRegionAllVariantDiscontinued_b: (prop_types_default()).bool
    }),
    general: (prop_types_default()).object,
    productQtyObj: (prop_types_default()).object,
    qtyChange: (prop_types_default()).func,
    presetConfigs: (prop_types_default()).string,
    listItemsPrice: (prop_types_default()).object,
    addToCart: (prop_types_default()).string,
    disableAddToCart: (prop_types_default()).bool,
    lessStock: (prop_types_default()).string,
    outOfStock: (prop_types_default()).string,
    handleSingleItemToCart: (prop_types_default()).func,
    availColorCTA: (prop_types_default()).string,
    discontinuedText: (prop_types_default()).string,
    requiredItemsToInstall: (prop_types_default()).string,
    staticText: (prop_types_default()).object,
    handleSingleItemToCartWithInstallItems: (prop_types_default()).func,
    language: (prop_types_default()).string,
    handleAddItemAndRemoveItemFromList: (prop_types_default()).func,
    userListItemsSkus: (prop_types_default()).object
};
/* harmony default export */ var ShareListRowItem_ShareListRowItem = (ShareListRowItem);

// EXTERNAL MODULE: ./components/ListConfirmationModal/index.jsx + 1 modules
var ListConfirmationModal = __webpack_require__(63652);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/analytics.js
var MyList_analytics = __webpack_require__(68152);
// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
;// CONCATENATED MODULE: ./components/ShareList/index.jsx
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];



























const ShareList = (props)=>{
    const { list ={} , siteName ="" , setSelectedList =()=>{} , deleteListSuccess =()=>{}  } = props;
    const { access_token: accessToken , isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,MyList_localization/* getTranslations */.F)(t);
    const router = (0,next_router.useRouter)();
    const { itemPrice , quantity , total , item , listTotal , browseMoreProducts , backToTop , addToCart , moreOptions , lessStock , outOfStock , availColorCTA , discontinued , requiredItemsToInstall , Remove  } = staticText;
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general ={
        swatchUrl: constants["default"] === null || constants["default"] === void 0 ? void 0 : constants["default"].COLOR_FILE_URL,
        siteName: constants.EXCEPTIONAL_SITENAME.charAt(0).toUpperCase() + constants.EXCEPTIONAL_SITENAME.slice(1)
    } , internationalization: { language ="en" , currencyCode =""  } = {} , apiEndPointData: { map: { disableAddToCart =false  } = {}  } = {}  } = globalConfig;
    const { userListItemsSkus  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [receivedSku, setReceivedSku] = (0,react.useState)( false || []);
    const [showAddToList, setShowAddToList] = (0,react.useState)(false);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [isShareAll, setIsShareAll] = (0,react.useState)(false);
    const [currentSingleProductDelete, setCurrentSingleProductDelete] = (0,react.useState)([]);
    const [openRemoveSingleProduct, setOpenRemoveSingleProduct] = (0,react.useState)(false);
    const [checkedItems, setCheckedItem] = (0,react.useState)([]);
    const [productData, setProductData] = (0,react.useState)([]);
    const [allProductsData, setAllProductsData] = (0,react.useState)([]);
    const [baseData, setBaseData] = (0,react.useState)([]);
    const [productQtyObj, setProductQtyObj] = (0,react.useState)({});
    const [openConforMationModal, setOpenConfirmationModal] = (0,react.useState)(false);
    const [deletList, setDeleteList] = (0,react.useState)(false);
    const [emptyList, setEmptyList] = (0,react.useState)(false);
    const [showLoader, setShowLoader] = (0,react.useState)(false);
    const [currentListVal, setCurrentListVal] = (0,react.useState)({});
    const [persona, setPersona] = (0,react.useState)("");
    const [listItemsPrice, setListItemsPrice] = (0,react.useState)({});
    const [showInventoryCheckModal, setShowInventoryCheckModal] = (0,react.useState)(false);
    const [lessStockProducts, setLessStockProducts] = (0,react.useState)([]);
    const [outOfStockProducts, setOutOfStockProducts] = (0,react.useState)([]);
    const [InStockProducts, setInStockProducts] = (0,react.useState)([]);
    const [allItemsOutOfStock, setAllItemsOutOfStock] = (0,react.useState)(false);
    const [flewItemsLessStock, setFlewItemsLessStock] = (0,react.useState)(false);
    const [requiredInstallItems, setRequiredInstallItems] = (0,react.useState)([]);
    const [windowWidth, setWindowWidth] = (0,react.useState)( true ? window.innerWidth : 0);
    const [showShareListModal, setShowShareListModal] = (0,react.useState)(false);
    const [showDownloadedMessage, setShowDownloadedMessage] = (0,react.useState)(false);
    const [sharedListName, setSharedListName] = (0,react.useState)("");
    const moreOptionsRef = (0,react.useRef)(null);
    const dispatch = (0,es/* useDispatch */.I0)();
    const removeIcon = "/icons/removeIconList.svg";
    const shareIconImage = "/icons/shareimageIcon.svg";
    const getPresetConfigs = ()=>{
        var ref, ref1, ref2;
        var ref3;
        const config = (ref3 = window === null || window === void 0 ? void 0 : (ref = window.localStorage) === null || ref === void 0 ? void 0 : ref.getItem("caConfig-en")) !== null && ref3 !== void 0 ? ref3 : "{}";
        const favoritesPercentConfigs = ((ref1 = JSON.parse(config)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.presetConfigs) === null || ref2 === void 0 ? void 0 : ref2.favorites) || "{}";
        return JSON.stringify(favoritesPercentConfigs);
    };
    (0,react.useEffect)(()=>{
        if (false) {}
        let rafId = null;
        const handleResize = ()=>{
            // use rAF to avoid layout thrashing on rapid resizes
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(()=>{
                setWindowWidth(window.innerWidth);
            });
        };
        window.addEventListener("resize", handleResize);
        // ensure initial value is accurate (in case of hydration differences)
        setWindowWidth(window.innerWidth);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const { products , ListName  } = (router === null || router === void 0 ? void 0 : router.query) || {};
        if (!products) return;
        try {
            const b64 = Array.isArray(products) ? products[0] : products;
            // decode base64 (browser atob fallback to Buffer for safety)
            const decoded =  true && typeof window.atob === "function" ? window.atob(b64) : Buffer.from(b64, "base64").toString("utf-8");
            const decodedListName =  true && typeof window.atob === "function" ? window.atob(ListName) : Buffer.from(ListName, "base64").toString("utf-8");
            // try JSON parse first, otherwise treat as comma-separated string
            setSharedListName(decodedListName);
            let values = [];
            try {
                const parsed = JSON.parse(decoded);
                if (Array.isArray(parsed)) values = parsed;
                else if (typeof parsed === "string" || typeof parsed === "number") values = parsed.split(",").map((s)=>s.trim()).filter(Boolean);
            } catch (e) {
                values = decoded.split(",").map((s)=>s.trim()).filter(Boolean);
            }
            setCheckedItem(values);
            dispatch((0,favoritesSlice/* getSharedListProductData */.RD)(values)).unwrap().then((response)=>{
                const qtObject = {};
                const refinedResponse = [];
                values === null || values === void 0 ? void 0 : values.forEach((sku)=>{
                    qtObject[sku] = 1;
                    response.filter((productInfo)=>{
                        var ref;
                        if (productInfo["masterSKU_s"] === sku || ((ref = productInfo["variantList.sku_ss"]) === null || ref === void 0 ? void 0 : ref.indexOf(sku)) > -1) {
                            refinedResponse.push({
                                ...productInfo,
                                masterSKU_s: sku
                            });
                        }
                    });
                });
                setProductQtyObj(qtObject);
                setBaseData(refinedResponse);
                if (refinedResponse.length > 10) {
                    const records = refinedResponse.slice(0, 10);
                    setProductData(records);
                    setAllProductsData(refinedResponse.slice(10));
                } else {
                    setProductData(refinedResponse);
                    setAllProductsData([]);
                }
                setShowLoader(false);
            }).catch(()=>{});
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Failed to decode products query param", err);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                window.loginFavouriteCallback = null;
                setLoginFavouriteCallback(null);
                if (isShareAll) {
                    setShowAddToList(true);
                    setIsShareAll(false);
                } else {
                    handleSaveToListFunctionality("", res[0][1]);
                }
                getSkuPrice(baseData);
            });
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const handleAddItemAndRemoveItemFromList = (e, sku, shareAll)=>{
        e.preventDefault();
        e.stopPropagation();
        setReceivedSku(sku);
        setIsShareAll(shareAll);
        if (isAuth && shareAll) {
            setShowAddToList(true);
            setIsShareAll(false);
            return;
        }
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            handleSaveToListFunctionality(sku);
        }
    };
    const handleSaveToListFunctionality = function() {
        let sku = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", listSkuObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (isShareAll) {
            setShowAddToList(true);
            setIsShareAll(false);
            return;
        }
        const processingSku = sku || receivedSku;
        const listObj = Object.keys(listSkuObject).length ? listSkuObject : userListItemsSkus;
        if (listObj[processingSku]) {
            setCurrentSingleProductDelete([
                processingSku
            ]);
            setCurrentListVal(listObj[processingSku]);
            setOpenRemoveSingleProduct(true);
        } else {
            setShowAddToList(true);
        }
    };
    const closeMultiItemsDeleteFromList = ()=>{
        setOpenRemoveSingleProduct(false);
        setCurrentSingleProductDelete([]);
        setCurrentListVal({});
    };
    (0,react.useEffect)(()=>{
        const node = moreOptionsRef.current;
        if (!node) return;
        const observer = new window.IntersectionObserver((param)=>{
            let [entry] = param;
            if (entry.isIntersecting) {
                (0,helper/* removeMavenoidChat */.N9B)();
            } else {
                (0,helper/* addMavenoidChat */.dVG)();
            }
        }, {
            threshold: 0.1
        });
        observer.observe(node);
        return ()=>{
            observer.disconnect();
        };
    }, [
        checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.length
    ]);
    const handleInventoryCheckModalClose = ()=>{
        setShowInventoryCheckModal(false);
        setLessStockProducts([]);
        setOutOfStockProducts([]);
        setInStockProducts([]);
        setAllItemsOutOfStock(false);
        setFlewItemsLessStock(false);
        setRequiredInstallItems([]);
    };
    const handleAddToCart = async (ctaLabel)=>{
        setShowLoader(true);
        const results = await (0,cart/* getStock */.K5)(checkedItems.join(","), true);
        const discontinutedSkusProducts = [];
        const InStockProducts = [];
        const lessStockProducts = [];
        const outOfStockProducts = [];
        const listItems = [
            ...productData
        ];
        productData.forEach((product, inventoryIndex)=>{
            var ref;
            const inventoryObj = results === null || results === void 0 ? void 0 : (ref = results.results) === null || ref === void 0 ? void 0 : ref.find((inv)=>inv.sku === product.masterSKU_s);
            if (!(inventoryObj === null || inventoryObj === void 0 ? void 0 : inventoryObj.sku)) {
                const product1 = listItems[inventoryIndex];
                product1.inventory = 0;
                product1.stockStatus = "Out of Stock";
                outOfStockProducts.push(product1);
                listItems[inventoryIndex] = product1;
                return;
            }
            if ((product === null || product === void 0 ? void 0 : product["productRegionAllVariantDiscontinued_b"]) || (product === null || product === void 0 ? void 0 : product["ProductIsRetail_s"]) === "true") {
                discontinutedSkusProducts.push(product);
            } else if (productQtyObj[inventoryObj.sku] < inventoryObj.availableQuantity || productQtyObj[inventoryObj.sku] === inventoryObj.availableQuantity || listItemsPrice["".concat(inventoryObj.sku, "-RegionIsBackorderable")]) {
                product["inventory"] = inventoryObj === null || inventoryObj === void 0 ? void 0 : inventoryObj.availableQuantity;
                product["stockStatus"] = "In Stock";
                InStockProducts.push(product);
            } else if (productQtyObj[inventoryObj.sku] > (inventoryObj === null || inventoryObj === void 0 ? void 0 : inventoryObj.availableQuantity) && inventoryObj.availableQuantity > 0) {
                product["inventory"] = inventoryObj.availableQuantity;
                product["stockStatus"] = "Less Stock";
                lessStockProducts.push(product);
            } else {
                product["inventory"] = 0;
                product["stockStatus"] = "Out of Stock";
                outOfStockProducts.push(product);
            }
            listItems[inventoryIndex] = product;
            return product;
        });
        setInStockProducts(InStockProducts);
        setLessStockProducts(lessStockProducts);
        setOutOfStockProducts(outOfStockProducts);
        setProductData(listItems);
        const checkedItemsLength = listItems.length - discontinutedSkusProducts.length;
        if (checkedItemsLength === InStockProducts.length) {
            const filterCheckedItems = checkedItems.filter((item)=>{
                const selectedProduct = productData.find((product)=>product.masterSKU_s === item);
                if (selectedProduct && !selectedProduct["productRegionAllVariantDiscontinued_b"] && selectedProduct["ProductIsRetail_s"] !== "true") {
                    return true;
                }
            });
            const payload = filterCheckedItems.map((item)=>{
                return {
                    brand: "kohler",
                    isBundleProduct: item === null || item === void 0 ? void 0 : item.startsWith("BNDL"),
                    quantity: productQtyObj[item],
                    sku: item,
                    isBundle: listItemsPrice["".concat(item, "-ComboSKU")] || false,
                    backorder: listItemsPrice["".concat(item, "-RegionIsBackorderable")] || false
                };
            });
            setShowLoader(false);
            (0,shareCartHelper/* shareaddToCart */.J9)([
                ...payload
            ], "", ()=>{
                dispatch((0,genericSlice/* showPreviewCart */.z0)());
                handleSingleItemsAddToCartDataLayerSuccessFailure({
                    itemsObject: filterCheckedItems.map((item)=>({
                            productID: "K-".concat(item),
                            quantity: productQtyObj[item]
                        })),
                    eventStatus: "Success",
                    eventMsg: "",
                    handleSingleProduct: filterCheckedItems.length === 1,
                    ctaLabel,
                    productInfo: filterCheckedItems.length === 1 ? productData.find((p)=>p.masterSKU_s === filterCheckedItems[0]) : filterCheckedItems.map((sku)=>productData.find((p)=>p.masterSKU_s === sku)).filter(Boolean)
                });
            });
            handleInventoryCheckModalClose();
        } else if (checkedItemsLength === outOfStockProducts.length) {
            setShowLoader(false);
            setShowInventoryCheckModal(true);
            setAllItemsOutOfStock(true);
        } else if (checkedItemsLength === lessStockProducts.length + InStockProducts.length || checkedItemsLength === lessStockProducts.length + outOfStockProducts.length || checkedItemsLength === lessStockProducts.length + outOfStockProducts.length + InStockProducts.length) {
            setShowLoader(false);
            handleSingleItemsAddToCartDataLayerSuccessFailure({
                itemsObject: [
                    ...lessStockProducts.map((item)=>{
                        return {
                            productID: "K-".concat(item.masterSKU_s),
                            quantity: item === null || item === void 0 ? void 0 : item.inventory
                        };
                    }),
                    ...outOfStockProducts.map((item)=>({
                            productID: "K-".concat(item.masterSKU_s),
                            quantity: 0
                        }))
                ],
                eventStatus: "failure",
                eventMsg: lessStockProducts.length && outOfStockProducts.length ? "low inventory, no inventory" : lessStockProducts.length ? "low inventory" : "no inventory",
                handleSingleProduct: false,
                ctaLabel,
                productInfo: checkedItems.length === 1 ? productData.find((p)=>p.masterSKU_s === checkedItems[0]) : checkedItems.map((sku)=>productData.find((p)=>p.masterSKU_s === sku)).filter(Boolean)
            });
            setShowInventoryCheckModal(true);
            setFlewItemsLessStock(true);
        } else {
            setShowLoader(false);
        }
    };
    const handleAvailableItemsToCart = (ctaLabel)=>{
        setShowInventoryCheckModal(false);
        setShowLoader(false);
        const itemsObjForDataLayer = [];
        const payloadInStock = InStockProducts.map((item)=>{
            var ref;
            itemsObjForDataLayer.push({
                productID: "K-".concat(item.masterSKU_s),
                quantity: productQtyObj[item.masterSKU_s]
            });
            return {
                brand: "kohler",
                isBundleProduct: (ref = item.masterSKU_s) === null || ref === void 0 ? void 0 : ref.startsWith("BNDL"),
                quantity: productQtyObj[item.masterSKU_s],
                sku: item.masterSKU_s,
                isBundle: listItemsPrice["".concat(item.masterSKU_s, "-ComboSKU")] || false,
                backorder: listItemsPrice["".concat(item.masterSKU_s, "-RegionIsBackorderable")] || false
            };
        });
        const palloadLessStock = lessStockProducts.map((item)=>{
            var ref;
            itemsObjForDataLayer.push({
                productID: "K-".concat(item.masterSKU_s),
                quantity: item === null || item === void 0 ? void 0 : item.inventory
            });
            return {
                brand: "kohler",
                isBundleProduct: (ref = item.masterSKU_s) === null || ref === void 0 ? void 0 : ref.startsWith("BNDL"),
                quantity: item === null || item === void 0 ? void 0 : item.inventory,
                sku: item.masterSKU_s,
                isBundle: listItemsPrice["".concat(item.masterSKU_s, "-ComboSKU")] || false,
                backorder: listItemsPrice["".concat(item.masterSKU_s, "-RegionIsBackorderable")] || false
            };
        });
        const installItems = [];
        if ((requiredInstallItems === null || requiredInstallItems === void 0 ? void 0 : requiredInstallItems.length) > 0) {
            requiredInstallItems.forEach((item)=>{
                installItems.push({
                    brand: "kohler",
                    quantity: 1,
                    sku: item === null || item === void 0 ? void 0 : item.skuid
                });
                itemsObjForDataLayer.push({
                    productID: "K-".concat(item === null || item === void 0 ? void 0 : item.skuid),
                    quantity: 1
                });
            });
        }
        setShowLoader(false);
        if (installItems === null || installItems === void 0 ? void 0 : installItems.length) {
            const actualAddedSkus = [
                ...payloadInStock,
                ...palloadLessStock,
                ...installItems
            ].map((item)=>item.sku);
            (0,shareCartHelper/* shareaddToCart */.J9)([
                ...payloadInStock,
                ...palloadLessStock,
                ...installItems
            ], "", ()=>{
                dispatch((0,genericSlice/* showPreviewCart */.z0)());
                handleSingleItemsAddToCartDataLayerSuccessFailure({
                    itemsObject: itemsObjForDataLayer,
                    eventMsg: palloadLessStock.length > 0 ? "low inventory" : "",
                    ctaLabel,
                    productInfo: actualAddedSkus.map((sku)=>productData.find((p)=>p.masterSKU_s === sku)).filter(Boolean)
                });
            });
        } else {
            const actualAddedSkus1 = [
                ...payloadInStock,
                ...palloadLessStock
            ].map((item)=>item.sku);
            (0,shareCartHelper/* shareaddToCart */.J9)([
                ...payloadInStock,
                ...palloadLessStock
            ], "", ()=>{
                dispatch((0,genericSlice/* showPreviewCart */.z0)());
                handleSingleItemsAddToCartDataLayerSuccessFailure({
                    itemsObject: itemsObjForDataLayer,
                    eventMsg: palloadLessStock.length > 0 ? "low inventory" : "",
                    ctaLabel,
                    productInfo: actualAddedSkus1.map((sku)=>productData.find((p)=>p.masterSKU_s === sku)).filter(Boolean)
                });
            });
        }
        handleInventoryCheckModalClose();
    };
    const handleBrowseMoreProducts = ()=>{
        (0,MyList_analytics/* dataLayerShareListPageEvents */.$j)({
            name: sharedListName,
            persona: persona,
            actionType: "browse more products",
            productsCount: baseData.length,
            records: productData,
            quantityObject: productQtyObj,
            listItemsPrice,
            listTotalPrice: (0,MyList_helper/* getListTotalPrice */.eb)(baseData, productQtyObj, listItemsPrice)
        });
        router.push("/".concat(language).concat(routes/* PRODUCT_BEST_SELLERS */.RG));
    };
    const handleSingleItemToCartWithInstallItems = (items, sku)=>{
        setShowLoader(true);
        (0,cart/* getStock */.K5)(sku, true).then((inventory)=>{
            handleSingleItemToCartModal(inventory[0], sku, items);
        }).catch(()=>{
            setShowLoader(false);
        });
    };
    const handleShareListAddToListAnalytics = ()=>{
        let actionType = "save to list";
        let records = [];
        if (Array.isArray(receivedSku)) {
            actionType = "save all to list";
            records = [
                ...productData
            ];
        } else {
            records.push(productData.find((product)=>product.masterSKU_s === receivedSku));
        }
        (0,MyList_analytics/* dataLayerShareListPageEvents */.$j)({
            name: sharedListName,
            persona: persona,
            actionType: actionType,
            productsCount: baseData.length,
            eventType: "click",
            quantityObject: productQtyObj,
            records: records,
            listItemsPrice,
            listTotalPrice: (0,MyList_helper/* getListTotalPrice */.eb)(baseData, productQtyObj, listItemsPrice)
        });
    };
    const handleSingleItemsAddToCartDataLayerSuccessFailure = (data)=>{
        const { itemsObject =[] , eventMsg ="" , eventStatus ="Success" , handleSingleProduct =false , ctaLabel ="" , productInfo  } = data;
        let safeProductInfo = Array.isArray(productInfo) ? productInfo : productInfo ? [
            productInfo
        ] : [];
        // If single product, send object not array for productInfo and records
        if (handleSingleProduct && safeProductInfo.length === 1) {
            safeProductInfo = safeProductInfo[0];
        }
        (0,MyList_analytics/* dataLayerShareListPageEvents */.$j)({
            name: sharedListName,
            persona: persona,
            actionType: "add to cart",
            productsCount: baseData.length,
            eventStatus,
            eventType: "click",
            items: itemsObject,
            eventMsg,
            records: handleSingleProduct && safeProductInfo ? [
                safeProductInfo
            ] : Array.isArray(safeProductInfo) && safeProductInfo.length ? safeProductInfo : [],
            quantityObject: productQtyObj,
            handleSingleProduct,
            ctaLabel,
            productInfo: handleSingleProduct && safeProductInfo ? safeProductInfo : safeProductInfo,
            listItemsPrice,
            listTotalPrice: (0,MyList_helper/* getListTotalPrice */.eb)(baseData, productQtyObj, listItemsPrice)
        });
    };
    const handleSingleItemToCartModal = function(inventory, sku) {
        let items = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], ctaLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        if (productQtyObj[sku] < (inventory === null || inventory === void 0 ? void 0 : inventory.availableQuantity) || productQtyObj[sku] === (inventory === null || inventory === void 0 ? void 0 : inventory.availableQuantity) || listItemsPrice["".concat(sku, "-RegionIsBackorderable")]) {
            setShowLoader(false);
            const obj = {
                brand: "kohler",
                isBundleProduct: sku === null || sku === void 0 ? void 0 : sku.startsWith("BNDL"),
                quantity: productQtyObj[sku],
                sku: sku,
                isBundle: listItemsPrice["".concat(sku, "-ComboSKU")] || false
            };
            if (listItemsPrice["".concat(sku, "-RegionIsBackorderable")]) {
                obj.backorder = true;
            }
            const cartItems = [
                {
                    ...obj
                }
            ];
            if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
                items.forEach((item)=>{
                    const itemObj = {
                        brand: "kohler",
                        quantity: 1,
                        sku: item === null || item === void 0 ? void 0 : item.skuid
                    };
                    cartItems.push(itemObj);
                });
            }
            (0,shareCartHelper/* shareaddToCart */.J9)([
                ...cartItems
            ], "", ()=>{
                dispatch((0,genericSlice/* showPreviewCart */.z0)());
                const itemsObj = [
                    {
                        productID: "K-".concat(sku),
                        quantity: productQtyObj[sku]
                    }
                ];
                if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
                    items.forEach((item)=>{
                        const itemObj = {
                            quantity: 1,
                            productID: "k-".concat(item === null || item === void 0 ? void 0 : item.skuid)
                        };
                        itemsObj.push(itemObj);
                    });
                }
                handleSingleItemsAddToCartDataLayerSuccessFailure({
                    itemsObject: itemsObj,
                    handleSingleProduct: true,
                    ctaLabel: staticText.addToCart,
                    productInfo: [
                        productData.find((p)=>p.masterSKU_s === sku)
                    ].filter(Boolean)
                });
            });
        } else {
            (items === null || items === void 0 ? void 0 : items.length) > 0 ? setRequiredInstallItems(items) : setRequiredInstallItems([]);
            const lessStockProducts = [];
            const outOfStockProducts = [];
            let analyticsFired = false;
            const inventoryCheckedProducts = productData.map((product)=>{
                if (product.masterSKU_s === sku) {
                    if (productQtyObj[sku] > inventory.availableQuantity && inventory.availableQuantity > 0) {
                        product.inventory = inventory.availableQuantity;
                        product.stockStatus = "Less Stock";
                        setFlewItemsLessStock(true);
                        lessStockProducts.push(product);
                        if (!analyticsFired) {
                            handleSingleItemsAddToCartDataLayerSuccessFailure({
                                itemsObject: [
                                    {
                                        productID: "K-".concat(sku),
                                        quantity: productQtyObj[sku]
                                    }
                                ],
                                eventStatus: "failure",
                                eventMsg: "low inventory",
                                handleSingleProduct: true,
                                ctaLabel: staticText.addToCart,
                                productInfo: [
                                    productData.find((p)=>p.masterSKU_s === sku)
                                ].filter(Boolean),
                                records: [
                                    productData.find((p)=>p.masterSKU_s === sku)
                                ].filter(Boolean)
                            });
                            analyticsFired = true;
                        }
                        return product;
                    } else {
                        product.inventory = 0;
                        product.stockStatus = "Out of Stock";
                        outOfStockProducts.push(product);
                        setAllItemsOutOfStock(true);
                        if (!analyticsFired) {
                            handleSingleItemsAddToCartDataLayerSuccessFailure({
                                itemsObject: [
                                    {
                                        productID: "K-".concat(sku),
                                        quantity: productQtyObj[sku]
                                    }
                                ],
                                eventStatus: "failure",
                                eventMsg: "no inventory",
                                handleSingleProduct: true,
                                ctaLabel: staticText.addToCart,
                                productInfo: [
                                    productData.find((p)=>p.masterSKU_s === sku)
                                ].filter(Boolean),
                                records: [
                                    productData.find((p)=>p.masterSKU_s === sku)
                                ].filter(Boolean)
                            });
                            analyticsFired = true;
                        }
                        return product;
                    }
                } else {
                    return product;
                }
            });
            setLessStockProducts(lessStockProducts);
            setOutOfStockProducts(outOfStockProducts);
            setProductData(inventoryCheckedProducts);
            setShowLoader(false);
            setShowInventoryCheckModal(true);
        }
    };
    const handleSingleItemToCart = async (sku, ctaLabel)=>{
        setShowLoader(true);
        (0,cart/* getStock */.K5)(sku, true).then((inventory)=>{
            handleSingleItemToCartModal(inventory === null || inventory === void 0 ? void 0 : inventory.results[0], sku, [], ctaLabel);
        }).catch(()=>{
            setShowLoader(false);
        });
    };
    const handleLoadMoreProducts = ()=>{
        const nextrecords = productData.length + 10;
        if (nextrecords < baseData.length) {
            const records = baseData.slice(0, nextrecords);
            setProductData(records);
            setAllProductsData(baseData.slice(nextrecords));
        } else {
            const remainingRecords = baseData.slice(productData.length);
            const records1 = [
                ...productData,
                ...remainingRecords
            ];
            setProductData(records1);
            setAllProductsData([]);
        }
    };
    const getSkuPrice = async (baseData)=>{
        let skuString = "(";
        const listProductSkus = [];
        baseData.forEach((obj, index)=>{
            if (index === 0) {
                skuString += '"'.concat(obj["masterSKU_s"], '"');
            } else {
                skuString += ',"'.concat(obj["masterSKU_s"], '"');
            }
            listProductSkus.push(obj["masterSKU_s"]);
        });
        skuString += ")";
        const payload = {
            listProductSkus,
            skuString,
            currencyCode,
            persona
        };
        dispatch((0,favoritesSlice/* getProductBySlug */.Co)(payload)).unwrap().then((res)=>{
            setListItemsPrice(res);
        }).catch((err)=>{
            console.error(err);
        });
    };
    (0,react.useEffect)(()=>{
        if (baseData.length) getSkuPrice(baseData);
    }, [
        baseData
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken) {
            setPersona((0,helper/* getUserPersona */.shu)());
        }
    }, [
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (baseData.length > 10) {
            setProductData(baseData.slice(0, 10));
            setAllProductsData(baseData.slice(10));
        } else {
            setProductData(baseData);
        }
    }, [
        baseData
    ]);
    const qtyChange = async (qty, product)=>{
        setShowLoader(true);
        const sku = product["masterSKU_s"];
        const obj = {
            ...productQtyObj
        };
        obj[sku] = qty;
        setProductQtyObj(obj);
        setShowLoader(false);
    };
    const handleBackToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const closeModalWithOutDelete = ()=>{
        setOpenConfirmationModal(false);
        setDeleteList(false);
        setEmptyList(false);
    };
    const closeConfirmationModal = ()=>{
        setOpenConfirmationModal(false);
        setDeleteList(false);
        setEmptyList(false);
        deleteListSuccess();
    };
    const handleShareListModalClose = ()=>{
        setShowShareListModal(false);
        setShowDownloadedMessage(false);
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ShareList_index_module_default()).ShareListWrapper,
                "data-more": (checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.length) ? "show-more" : "hide-more",
                children: [
                    (productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "list-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "title-buttons-Row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "share-list-title",
                                    children: t("kf.share.list.shared.items", {
                                        number: productData === null || productData === void 0 ? void 0 : productData.length
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "buttons-Row",
                                    "data-CA-Action-Btn": disableAddToCart ? "CATBTN" : "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: disableAddToCart ? "button-one-ca" : "button-one",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                role: "button",
                                                size: "small",
                                                flexible: true,
                                                type: "ghost",
                                                className: "button",
                                                iconClass: "wish-icon",
                                                icon: wish/* default */.Z === null || wish/* default */.Z === void 0 ? void 0 : wish/* default.src */.Z.src,
                                                iconProps: {
                                                    width: "15",
                                                    height: "14",
                                                    alt: moreOptions
                                                },
                                                label: t("kf.share.list.shared.save.all.to.list"),
                                                onClick: (e)=>{
                                                    handleAddItemAndRemoveItemFromList(e, checkedItems, true);
                                                }
                                            })
                                        }),
                                        !disableAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "button-two",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                role: "button",
                                                size: "small",
                                                flexible: true,
                                                type: "ghost",
                                                className: "button cart-button",
                                                onClick: handleAddToCart,
                                                label: t("kf.share.list.shared.add.all.to.cart")
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }) : null,
                    (productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "list-landing",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "list-grid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row cart-items__th no-gutters ".concat((productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? "cart-table-header-list display-none" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-4 d-none d-sm-block text-left cart-items__td px-0 col-md-6 display-none",
                                                    "aria-hidden": "true",
                                                    children: item
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-sm-6 col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row mx-0 px-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-4 d-none d-sm-block cart-items__td cart-td-unit-price display-none",
                                                                "aria-hidden": "true",
                                                                children: itemPrice
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-4 d-none d-sm-block text-center cart-items__td px-0 display-none",
                                                                "aria-hidden": "true",
                                                                children: quantity
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-4 d-none d-sm-block text-right cart-items__td px-0 display-none",
                                                                "aria-hidden": "true",
                                                                children: total
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        (productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? productData.map((product, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareListRowItem_ShareListRowItem, {
                                                presetConfigs: getPresetConfigs(),
                                                product: product,
                                                general: general,
                                                persona: persona,
                                                siteName: siteName,
                                                productQtyObj: productQtyObj,
                                                checkedItems: checkedItems,
                                                disableAddToCart: disableAddToCart,
                                                list: list[0],
                                                addToCart: addToCart,
                                                listItemsPrice: listItemsPrice,
                                                qtyChange: (qty, product)=>{
                                                    qtyChange(qty, product);
                                                },
                                                lessStock: lessStock,
                                                outOfStock: outOfStock,
                                                handleSingleItemToCart: handleSingleItemToCart,
                                                handleSingleItemToCartWithInstallItems: handleSingleItemToCartWithInstallItems,
                                                availColorCTA: availColorCTA,
                                                discontinuedText: discontinued,
                                                requiredItemsToInstall: requiredItemsToInstall,
                                                staticText: staticText,
                                                removeIcon: removeIcon,
                                                Remove: Remove,
                                                listInfo: list,
                                                userListItemsSkus: userListItemsSkus,
                                                handleAddItemAndRemoveItemFromList: handleAddItemAndRemoveItemFromList,
                                                shareIcon: shareIconImage
                                            }, index);
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "list-footer",
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        windowWidth > 812 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "list-browse-more-text",
                                            onClick: handleBrowseMoreProducts,
                                            children: browseMoreProducts
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "list-total-text display-none",
                                            children: [
                                                listTotal,
                                                ":",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        paddingLeft: "20px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: (0,MyList_helper/* getListTotalPrice */.eb)(baseData, productQtyObj, listItemsPrice),
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: disableAddToCart ? "CAD $" : "$",
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                allProductsData.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "load-more-button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        label: staticText === null || staticText === void 0 ? void 0 : staticText.loadMore,
                                        role: "button",
                                        size: "small",
                                        flexible: true,
                                        type: "ghost",
                                        onClick: handleLoadMoreProducts
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "list-back-to-top",
                                    "show-more": checkedItems.length ? "showMore" : "hideMore",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        role: "link",
                                        className: "go-back-button",
                                        onClick: handleBackToTop,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "go-back-text",
                                                children: backToTop
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "go-back-image",
                                                "aria-hidden": "true",
                                                src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                                                alt: backToTop
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }) : null,
                    openConforMationModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                        list: currentListVal,
                        openConforMationModal: openConforMationModal,
                        noLineItems: emptyList,
                        deletefromListDetails: deletList,
                        closeConformationModal: closeConfirmationModal,
                        setSelectedList: setSelectedList,
                        closeModalWithOutDelete: closeModalWithOutDelete
                    }) : null,
                    openRemoveSingleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                        list: currentListVal,
                        openConforMationModal: openRemoveSingleProduct,
                        selectedItems: currentSingleProductDelete,
                        deleteFromList: true,
                        handleSuccessCallBack: closeMultiItemsDeleteFromList,
                        closeConformationModal: ()=>{
                            setOpenRemoveSingleProduct(false);
                        }
                    }) : null,
                    showLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : null,
                    showAddToList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                        productSku: receivedSku,
                        showListSaveAndCreate: showAddToList,
                        fromShareListPage: true,
                        listSaveAndCreateClose: ()=>{
                            setShowAddToList(false);
                        },
                        handleShareListAddToListAnalytics: handleShareListAddToListAnalytics
                    }) : null,
                    showInventoryCheckModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListInventoryCheckModal/* default */.Z, {
                        closeInventoryCheckModal: handleInventoryCheckModalClose,
                        general: general,
                        presetConfigs: getPresetConfigs(),
                        productData: [
                            ...lessStockProducts,
                            ...outOfStockProducts
                        ],
                        siteName: (ref = general === null || general === void 0 ? void 0 : general.siteName) !== null && ref !== void 0 ? ref : "",
                        productQtyObj: productQtyObj,
                        allItemsOutOfStock: allItemsOutOfStock,
                        flewItemsLessStock: flewItemsLessStock,
                        staticText: staticText,
                        handleAvailableItemsToCart: ()=>handleAvailableItemsToCart(staticText.addAvailableItemsToCart)
                    }) : null,
                    showShareListModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareListModal/* default */.Z, {
                        showShareListModal: showShareListModal,
                        showDownloadedMessage: showDownloadedMessage,
                        onClose: ()=>{
                            handleShareListModalClose();
                        }
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ShareList_index_module_default()).ShareListMoreOptionsWrapper,
                ref: moreOptionsRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        role: "button",
                        size: "small",
                        flexible: true,
                        type: "ghost",
                        className: "more-options-btns",
                        iconClass: "wish-icon",
                        icon: wish/* default */.Z === null || wish/* default */.Z === void 0 ? void 0 : wish/* default.src */.Z.src,
                        iconProps: {
                            width: "15",
                            height: "14",
                            alt: moreOptions
                        },
                        label: t("kf.share.list.shared.save.all.to.list"),
                        onClick: (e)=>{
                            handleAddItemAndRemoveItemFromList(e, checkedItems, true);
                        }
                    }),
                    !disableAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        role: "button",
                        size: "small",
                        flexible: true,
                        type: "ghost",
                        className: "more-options-btns cart-button",
                        onClick: handleAddToCart,
                        label: t("kf.share.list.shared.add.all.to.cart")
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ShareList = (ShareList);

;// CONCATENATED MODULE: ./components/Default/Title/DynamicTag.jsx

const DynamicTag = (param)=>{
    let { type , children , ...rest } = param;
    const Tag = /*#__PURE__*/ react.createElement(type, {
        ...rest
    }, children);
    return Tag;
};

;// CONCATENATED MODULE: ./components/Default/Title/index.jsx



const Title = (param)=>{
    let { data ={}  } = param;
    const { appliedCssClassNames ="" , text =""  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "title ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-title",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DynamicTag, {
                type: data === null || data === void 0 ? void 0 : data.type,
                className: "cmp-title__text",
                children: [
                    text,
                    " "
                ]
            })
        })
    });
};
/* harmony default export */ var Default_Title = (Title);

// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/SearchPanel/localization.js
var SearchPanel_localization = __webpack_require__(73846);
// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/DynamicSearch.view/index.module.scss
var DynamicSearch_view_index_module = __webpack_require__(31901);
var DynamicSearch_view_index_module_default = /*#__PURE__*/__webpack_require__.n(DynamicSearch_view_index_module);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(83790);
;// CONCATENATED MODULE: ./components/Default/DynamicSearch/v1/DynamicSearch.view/index.jsx






const SearchPanel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2857), __webpack_require__.e(2247), __webpack_require__.e(1976), __webpack_require__.e(9562), __webpack_require__.e(448), __webpack_require__.e(7845)]).then(__webpack_require__.bind(__webpack_require__, 47845)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47845)
            ]
    }
});


const DynamicSearch = (props)=>{
    const { showSearchBar =false , onToggle =()=>{}  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { searchHeader =""  } = (0,SearchPanel_localization/* getTranslations */.F)(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (DynamicSearch_view_index_module_default()).dynamicSearchViewWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "search-button gbh-data-layer",
                id: "search-side-panel__toggle",
                tabIndex: "0",
                role: "button",
                "aria-label": searchHeader,
                "data-gbh-data-layer": '{"eventAction":"internal search","eventName":"internal search","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"internal search magnifying glass button","internalLinkPosition":"global header","internalLinkType":"global navigation","internalLinkZoneName":"global header","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                onClick: onToggle,
                onKeyDown: (e)=>e.key === constants["default"].KEY.ENTER && onToggle(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "search-text",
                        children: searchHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "search-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            "aria-hidden": true,
                            src: search/* default */.Z === null || search/* default */.Z === void 0 ? void 0 : search/* default.src */.Z.src,
                            alt: lib/* isMobile */.tq ? "search-icon" : ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-side-panel__overlay ".concat(showSearchBar ? "search-side-panel__show-overlay" : "")
            }),
            showSearchBar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPanel, {
                ...props
            }) : null
        ]
    });
};
/* harmony default export */ var DynamicSearch_view = ((0,lib/* withOrientationChange */.Qe)(DynamicSearch));

// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/analytics.js
var DynamicSearch_v1_analytics = __webpack_require__(33507);
;// CONCATENATED MODULE: ./components/Default/DynamicSearch/v1/DynamicSearch.jsx












const DynamicSearch_DynamicSearch = (props)=>{
    var ref;
    const { presetConfigs ={} , disableParts =false , enablePotraitTile =false  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const persona = (0,helper/* getUserPersona */.shu)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const analyticsEventData = {};
    const currencySign = (0,react.useRef)("");
    const currencyCode = (0,react.useRef)("");
    const searchPagePath = (0,react.useRef)("");
    const knowledgeArticleUrl = (0,react.useRef)("");
    const domainListUrl = (0,react.useRef)("");
    const bodyRef = (0,react.useRef)(document.body);
    const htmlRef = (0,react.useRef)(document.getElementsByTagName("html")[0]);
    const [showSearchBar, setShowSearchBar] = (0,react.useState)(false);
    const [selectedData, setSelectedData] = (0,react.useState)({});
    const [searchString, setSearchString] = (0,react.useState)("");
    var ref1;
    const [searchHistory, setSearchHistory] = (0,react.useState)((ref1 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref1 !== void 0 ? ref1 : []);
    const [brandName, setBrandName] = (0,react.useState)("");
    const [searchTotal, setSearchTotal] = (0,react.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react.useState)("");
    const [category, setCategory] = (0,react.useState)("");
    const [tilesData, setTilesData] = (0,react.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react.useState)(false);
    const [xfLink, setXfLink] = (0,react.useState)("");
    const [promoLayout, setPromoLayout] = (0,react.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react.useState)(true);
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (showSearchBar) {
            var ref;
            setSearchHistory((ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        showSearchBar
    ]);
    (0,react.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = get_default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = get_default()(config, "internationalization.currencySign", "");
                    currencyCode.current = get_default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.searchPagePath", ""));
                    domainListUrl.current = get_default()(config, "general.domainMapping", "");
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isSsr,
        isGlobalConfigBlank
    ]);
    (0,react.useEffect)(()=>{
        if (searchTotal > 0 && selectedData.key) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    (0,react.useEffect)(()=>{
        if (brandName) {
            if (searchString.length >= 3) {
                getSearchResult(searchString);
            } else {
                setSearchTotal(0);
            }
            setProductsLoaded(false);
        }
    }, [
        searchString,
        brandName
    ]);
    const handleToggle = ()=>{
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.forEach((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.forEach((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearchBar(!showSearchBar);
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, null, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                searchTerm.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                const { payload: brandSearchPayload = {} , payload: { fusion: brandFusion = {} , fusion: { redirect: brandFusionRedirect = [] , exactMatch: brandFusionExactMatch = "" , partsCount: partsResponseNumFound = 0 , partsDocs: partsResponseDocs = [] , partsExactMatch: partsFusionExactMatch = ""  } , response: { numFound: brandResponseNumFound = 0 , docs: brandResponseDocs = []  }  } = {}  } = res;
                if (brandSearchPayload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (brandFusion && brandFusionRedirect && brandFusionRedirect[0]) {
                        redirectUrl = brandFusionRedirect[0];
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    } else if (brandResponseNumFound === 1 && brandFusionExactMatch) {
                        const d = brandResponseDocs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "?skuId=".concat(d.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(d.Product_Category, d.slug_s) + param;
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    } else if (partsResponseNumFound === 1 && partsFusionExactMatch) {
                        const d1 = partsResponseDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "&skuId=".concat(d1.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(null, d1.slug_s) + param1;
                        } else if (d1.url_s) {
                            redirectUrl = d1.url_s;
                        }
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    } else {
                        redirectUrl = (0,helper/* sanitizeUrl */.Nmg)(window.location.origin + (0,helper/* removeAndCleanLink */.xEh)(searchPagePath.current) + "?keyword=".concat(searchTerm.trim()));
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    }
                }
            // setProductsLoaded(true)
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("failure", "error occured while fetching search data", null, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                setProductsLoaded(true);
            });
        }
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchString(searchTerm.trim());
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const getSearchResult = (0,react.useCallback)(debounce_default()((searchString)=>getData(searchString), 2000), [
        brandName
    ]);
    const getData = (searchStr)=>{
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            Promise.all([
                dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                    searchStr.trim(),
                    brandName.toLowerCase(),
                    "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                    1,
                    ""
                ])),
                dispatch((0,productListSlice/* profileBrandTypeahead */.zw)([
                    searchStr.trim(),
                    brandName.toLowerCase()
                ]))
            ]).then(async (res)=>{
                const [{ payload: brandSearchPayload = {} , payload: { fusion: brandFusion = {} , fusion: { redirect: brandFusionRedirect = [] , exactMatch: brandFusionExactMatch = "" , fusionQueryId: brandFusionQueryId = "" , partsExactMatch: partsFusionExactMatch = "" , fusionQueryId: partsFusionQueryId = "" , partsCount: partsResponseNumFound = 0 , partsDocs: partsResponseDocs = []  } , response: { numFound: brandResponseNumFound = 0 , docs: brandResponseDocs = []  }  } = {}  }, { payload: brandTypeaheadPayload = {}  }] = res;
                if (brandSearchPayload && brandTypeaheadPayload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (brandFusion && brandFusionRedirect && brandFusionRedirect[0]) {
                        (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, brandFusionRedirect[0], null, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = brandFusionRedirect[0];
                    } else if (brandResponseNumFound === 1 && brandFusionExactMatch) {
                        const d = brandResponseDocs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "?skuId=".concat(d.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(d.Product_Category, d.slug_s) + param;
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                    } else if (partsResponseNumFound === 1 && partsFusionExactMatch) {
                        const d1 = partsResponseDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "&skuId=".concat(d1.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(null, d1.slug_s) + param1;
                        }
                    }
                    if (!brandFusionRedirect.length) {
                        let groups = [
                            {
                                key: "products",
                                fq: 'Products:("ct")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Products[1]", 0)
                            },
                            {
                                key: "parts",
                                count: get_default()(brandSearchPayload.fusion.partsCount, "partsCount", 0)
                            },
                            {
                                key: "technical",
                                fq: 'Technical:("ct")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Technical[1]", 0)
                            },
                            {
                                key: "inspiration",
                                fq: 'Inspiration:("Inspiration")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Inspiration[1]", 0)
                            },
                            {
                                key: "resource",
                                fq: 'Resource:("Resource")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Resource[1]", 0)
                            },
                            {
                                key: "help",
                                fq: 'Help:("sf")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Help[1]", 0)
                            }
                        ];
                        if (disableParts) {
                            groups = groups.filter((arr)=>{
                                return arr.key !== "parts";
                            });
                        }
                        // Calculating the total results
                        let total = 0;
                        const selected = groups.find((group)=>group.count > 0);
                        if (brandFusionExactMatch || partsFusionExactMatch) {
                            total = selected.key === "parts" ? partsResponseNumFound : brandResponseNumFound;
                        } else {
                            groups.forEach((group)=>total += group.count);
                        }
                        let sFusionQueryId = brandFusionQueryId !== null && brandFusionQueryId !== void 0 ? brandFusionQueryId : "";
                        sFusionQueryId = sFusionQueryId !== null && sFusionQueryId !== void 0 ? sFusionQueryId : partsFusionQueryId;
                        analyticsEventData.searchTotal = total;
                        analyticsEventData.redirectUrl = redirectUrl;
                        analyticsEventData.topSuggestedData = get_default()(brandTypeaheadPayload, "response.docs", []);
                        analyticsEventData.selectedData = selected;
                        analyticsEventData.searchString = searchStr.trim();
                        setSearchTotal(total);
                        setRedirectUrl(redirectUrl);
                        setTopSuggestedData(get_default()(brandTypeaheadPayload, "response.docs", []));
                        setFusionQueryId(sFusionQueryId);
                        (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, null, null, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        setSelectedData(selected);
                    }
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
        }
    };
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "masterCustomerFacingSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "urlName_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "layoutItems.Article_Type__c.value_s",
            "layoutItems.KM_Article_Content__c.value_s",
            "layoutItems.KBNA_3C_Image_Video__c.label_s",
            "layoutItems.KBNA_3C_Image_Video__c.value_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "primaryBundleSKU_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch(selected.key === "parts" ? (0,productListSlice/* profileServicePartsSearch */.n7)([
            searchString.trim(),
            fl.join(","),
            6
        ]) : (0,productListSlice/* profileBrandSearch */.R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearch_view, {
        xfLink: xfLink,
        promoLayout: promoLayout,
        searchTotal: searchTotal,
        searchString: searchString,
        showSearchBar: showSearchBar,
        onToggle: handleToggle,
        onRedirect: handleRedirect,
        onChange: handleChange,
        onDelete: handleDelete,
        onClearAll: handleClearAll,
        category: category,
        tilesData: tilesData,
        topSuggestedData: topSuggestedData,
        searchHistory: searchHistory,
        comparedProducts: (0,helper/* getCompareData */.p2C)(),
        removeFromCompare: product/* removeFromCompareProduct */.Zj,
        addToCompare: product/* addToCompareProduct */.dX,
        currencySign: currencySign.current,
        brand: brandName,
        favorites: (ref = (0,helper/* getFavouraties */.MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
        presetConfigs: presetConfigs,
        knowledgeArticleUrl: knowledgeArticleUrl.current,
        fusionQueryId: fusionQueryId,
        parent: "Dynamic Search",
        enablePotraitTile: enablePotraitTile,
        domainListUrl: domainListUrl.current,
        productsLoaded: productsLoaded
    });
};
/* harmony default export */ var v1_DynamicSearch = (DynamicSearch_DynamicSearch);

;// CONCATENATED MODULE: ./components/Default/Video/v2/Video.jsx














const v2_Video_Video = (props)=>{
    const { data: { videoTitle ="" , videoMobile ="" , videoMobileLandscape ="" , videoMobilePoster ="" , videoDesktopPoster ="" , videoDesktop ="" , muteEnableAutoPlay ="false" , hideEnableAutoPlay ="false" , alt ="" , appliedCssClassNames ="" , items =[] , enableLoop ="false" , blackBgCta ="false" , offWhiteBg ="false" , textLinkCta ="false" , textLinkCtaOffWhite ="false" , enablePopUPVideo ="false" , modalCta ="" , modalVideoDesktop ="" , modalVideoMobile ="" , modalVideoMobileLandscape ="" , actionsEnabled: videoActionsEnabled = "false" , teaserProperties: { title ="" , description ="" , linkURLRef =false , linkCTA ="" , linkNewTab =false , videoPosterMobileLandscape ="" , controlType ="" , pageType ="" , componentPosition ="" , componentZone ="" , componentLinkType ="" , playsAboveFold ="false" , eventName ="" , dynamicTabName ="" , eventAction ="" , caption ="" , pretitle ="" , actionsEnabled =false , actions =[] , linkAll =false , dataLayerLinkType ="" , mainTitle ="" , enableFav =false , enableShare =false , linkDescription =false , propertiesPageType =""  } = {}  } = {}  } = props;
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const screenOrientation = hooks_useScreenOrientation();
    const [video, setVideo] = (0,react.useState)("");
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const [videoPlayed, setVideoPlayed] = (0,react.useState)(false);
    const [isVideoPlaying, setIsVideoPlaying] = (0,react.useState)(false);
    const [showSocialShare, setShowSocialShare] = (0,react.useState)(false);
    const [isFavourited, setIsFavourited] = (0,react.useState)(false);
    const [modelVideo, setModalVideo] = (0,react.useState)("");
    const [favVideoId, setFavVideoId] = (0,react.useState)("");
    const [flagState, setFlagState] = (0,react.useState)({
        flag25: false,
        flag50: false,
        flag75: false,
        flag100: false
    });
    // Track if video was started by user
    const isUserInitiatedRef = (0,react.useRef)(false);
    const { ref: inViewRef , inView  } = useInView({
        threshold: 0.3
    });
    const videoContainerRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    const inspireRef = (0,react.useRef)(null);
    const closeBtnRef = (0,react.useRef)(null);
    const [general, setGeneral] = (0,react.useState)(null);
    const getVideoId = (video)=>{
        var ref, ref1;
        return (ref1 = (ref = decodeURI(video)) === null || ref === void 0 ? void 0 : ref.split("PAWEB/")[1]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (videoTitle) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(videoTitle);
            setDynamicId(dynamicId);
        }
    }, [
        videoTitle
    ]);
    const setVideoSource = (0,react.useCallback)(()=>{
        if (winWidth > 1023) {
            setVideo(videoDesktop);
            setModalVideo(modalVideoDesktop);
        } else {
            if (screenOrientation === null || screenOrientation === void 0 ? void 0 : screenOrientation.includes("landscape")) {
                setVideo(videoMobileLandscape);
                setModalVideo(modalVideoMobileLandscape);
            } else {
                setVideo(videoMobile);
                setModalVideo(modalVideoMobile);
            }
        }
    }, [
        videoMobile,
        videoMobileLandscape,
        videoDesktop,
        screenOrientation,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            var ref;
            setVideoSource();
            if (muteEnableAutoPlay === "true") videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        setVideoSource,
        inView
    ]);
    (0,react.useEffect)(()=>{
        if (isVideoPlaying) setVideoPlayed(true);
    }, [
        isVideoPlaying
    ]);
    const eventActionTabName = dynamicTabName || "zoneForVideo";
    const eventActionName = "".concat(dynamicTabName || "rm", ":video:rm");
    const onTimeUpdate = (event)=>{
        const videoDuration = inspireRef.current.duration;
        const percent100 = Math.floor(videoDuration);
        const currentTime = Math.floor(inspireRef.current.currentTime);
        if ((muteEnableAutoPlay === "true" ? percent100 - 1 : percent100) === currentTime && flagState.flag100 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag100: true
                }));
            addVideoDataLayer(100);
        }
    };
    const getCurrentVideoProgessPercent = ()=>{
        const videoDuration = inspireRef.current.duration;
        const progressTime = Math.floor(inspireRef.current.currentTime);
        return progressTime / videoDuration * 100;
    };
    const addVideoDataLayer = (percentViewed)=>{
        let eventActionName;
        let viewedPercentage;
        let internalLinkName;
        const { VIDEO_PLAY , VIDEO_PAUSE , VIDEO_VIEWED , VIDEO_COMPLETE , VIDEO_CLICK , PLAY_VIDEO , PAUSE_VIDEO , CLOSE_VIDEO , CLOSE  } = constants.VIDEO_EVENTS;
        if (percentViewed === VIDEO_CLICK) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(modalCta === null || modalCta === void 0 ? void 0 : modalCta.toLowerCase());
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = modalCta === null || modalCta === void 0 ? void 0 : modalCta.toLowerCase();
        } else if (percentViewed === PLAY_VIDEO) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(VIDEO_PLAY);
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = VIDEO_PLAY;
        } else if (percentViewed === PAUSE_VIDEO) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(VIDEO_PAUSE);
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = "".concat(viewedPercentage, "% ").concat(VIDEO_VIEWED);
        } else if (percentViewed === CLOSE_VIDEO) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(CLOSE);
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = CLOSE;
        } else {
            eventActionName = percentViewed === 100 ? "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle === null || videoTitle === void 0 ? void 0 : videoTitle.toLowerCase(), ":").concat(VIDEO_COMPLETE) : "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle === null || videoTitle === void 0 ? void 0 : videoTitle.toLowerCase(), ":").concat(percentViewed, "% ").concat(VIDEO_VIEWED);
            viewedPercentage = percentViewed;
            internalLinkName = viewedPercentage === 100 ? "".concat(VIDEO_COMPLETE) : "".concat(viewedPercentage, "% ").concat(VIDEO_VIEWED);
        }
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: eventActionName,
            eventMsg: "n/a",
            eventName: eventActionName,
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: internalLinkName,
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()),
            internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "navigation" || 0),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle === null || videoTitle === void 0 ? void 0 : videoTitle.toLowerCase()),
            videoId: "".concat(getVideoId(modelVideo)),
            videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video"),
            videoType: isUserInitiatedRef.current ? "user initiated" : "auto play"
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const productInfo = page.productInfo || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "inspire-video video teaser ".concat(appliedCssClassNames),
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser".concat(controlType === "customControl" ? " gbh-custom-control" : "").concat(propertiesPageType === "modalWindow" ? " gbh-model-window" : "").concat(hideEnableAutoPlay === "true" ? " gbh-hide-mute" : ""),
            ref: videoContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__image video_poster_height".concat(videoPlayed ? " video-played" : ""),
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"video play","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","videoName":"').concat(videoTitle || componentLinkType.toLowerCase() || "hero video", '","videoId": "').concat(getVideoId(modelVideo), '","videoType":"').concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated", '"}'),
                    style: showSocialShare ? {
                        overflow: "visible"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "gbh-play-video desktop".concat(isVideoPlaying ? " active" : ""),
                            onClick: (event)=>{
                                isUserInitiatedRef.current = true;
                                onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: !(hideEnableAutoPlay === "true") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "playinside desktop",
                                id: "videoinnerbtn-".concat(dynamicId),
                                "aria-label": "play video",
                                onClick: ()=>{
                                    isUserInitiatedRef.current = true;
                                    onPlayVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, (res)=>setIsVideoPlaying(res), videoDesktopPoster, videoMobilePoster, video, isVideoPlaying);
                                }
                            }) : null
                        }),
                        !video ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "poster-img",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:1025px)",
                                    srcSet: videoDesktopPoster
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:640px) and (max-width:1024px)",
                                    srcSet: videoPosterMobileLandscape
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width:639px)",
                                    srcSet: videoMobilePoster
                                }),
                                videoDesktopPoster ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: videoDesktopPoster,
                                    srcSet: videoDesktopPoster,
                                    alt: "",
                                    className: "desktop-poster"
                                }) : null
                            ]
                        }) : null,
                        video ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            ref: videoRef,
                            id: "video-desktop-".concat(dynamicId),
                            width: "100%",
                            muted: muteEnableAutoPlay === "true" ? true : false,
                            autoPlay: muteEnableAutoPlay === "true" ? true : false,
                            loop: muteEnableAutoPlay === "true" ? true : false,
                            playsInline: true,
                            preload: "metadata",
                            className: "hero-video inpage-video videoelement".concat(muteEnableAutoPlay === "true" ? " muted" : "").concat(playsAboveFold === "true" ? "" : " lazy-video"),
                            onVolumeChange: ()=>{
                                return onVolumeChange(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            onClick: (event)=>{
                                return onClickHeroVideo(event, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            ...controlType === "defaultControl" && hideEnableAutoPlay === "false" ? {
                                controls: true
                            } : {},
                            onPlay: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PLAY, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (id)=>setFavVideoId(id), flagState);
                            },
                            onPause: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PAUSE, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, flagState);
                            },
                            onEnded: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.ENDED, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, flagState);
                            },
                            onTimeUpdate: onTimeUpdate,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: video,
                                    type: "video/mp4"
                                }),
                                items.map((transcript, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                        label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                        kind: "subtitles",
                                        srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                        src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                        default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                    }, "video-track-".concat(dynamicId, "-").concat(index));
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            className: "hero-video inpage-video videoelement".concat(muteEnableAutoPlay === "true" ? " muted" : "").concat(playsAboveFold === "true" ? "" : " lazy-video")
                        }),
                        enableLoop === "true" && modelVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                    ref: inspireRef,
                                    className: "hero-video videoelement inspirevideo ".concat(muteEnableAutoPlay === "true" ? " muted" : "", " ").concat(playsAboveFold === "true" ? "" : "lazy-video"),
                                    "data-desktop-vid": "".concat(modalVideoDesktop),
                                    "data-mobile-vid": modalVideoMobile,
                                    "data-mobile-lscape-vid": modalVideoMobileLandscape,
                                    onVolumeChange: ()=>{
                                        return onVolumeChange(inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current);
                                    },
                                    id: "herovideo-desktop-1",
                                    width: "100%",
                                    playsInline: true,
                                    preload: "metadata",
                                    ...controlType === "defaultControl" && !(hideEnableAutoPlay === "false") ? {
                                        controls: true
                                    } : {},
                                    muted: muteEnableAutoPlay === "true" ? true : false,
                                    autoPlay: muteEnableAutoPlay === "true" ? true : false,
                                    loop: muteEnableAutoPlay === "true" ? true : false,
                                    onTimeUpdate: onTimeUpdate,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: modelVideo,
                                            type: "video/mp4"
                                        }),
                                        items.map((transcript, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                                label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                                kind: "subtitles",
                                                srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                                src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                                default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                            }, "video-track-".concat(dynamicId, "-").concat(index));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "vidio_popup_close_button inspired-video-popup-close",
                                    ref: closeBtnRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        role: "button",
                                        onClick: ()=>{
                                            onPlayInspireVideoClose(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current, closeBtnRef === null || closeBtnRef === void 0 ? void 0 : closeBtnRef.current, addVideoDataLayer);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true"
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        enableLoop === "false" && modelVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                    ref: inspireRef,
                                    className: "hero-video videoelement inspirevideo ".concat(muteEnableAutoPlay === "true" ? " muted" : "", " ").concat(playsAboveFold === "true" ? "" : "lazy-video"),
                                    "data-desktop-vid": "".concat(modalVideoDesktop),
                                    "data-mobile-vid": modalVideoMobile,
                                    "data-mobile-lscape-vid": modalVideoMobileLandscape,
                                    onVolumeChange: ()=>{
                                        return onVolumeChange(inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current);
                                    },
                                    id: "herovideo-desktop-1",
                                    width: "100%",
                                    playsInline: true,
                                    preload: "metadata",
                                    ...controlType === "defaultControl" && !(hideEnableAutoPlay === "false") ? {
                                        controls: true
                                    } : {},
                                    muted: muteEnableAutoPlay === "true" ? true : false,
                                    autoPlay: muteEnableAutoPlay === "true" ? true : false,
                                    loop: muteEnableAutoPlay === "true" ? true : false,
                                    onTimeUpdate: onTimeUpdate,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: modelVideo,
                                            type: "video/mp4"
                                        }),
                                        items.map((transcript, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                                label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                                kind: "subtitles",
                                                srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                                src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                                default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                            }, "video-track-".concat(dynamicId, "-").concat(index));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "vidio_popup_close_button inspired-video-popup-close",
                                    ref: closeBtnRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        role: "button",
                                        onClick: ()=>{
                                            return onPlayInspireVideoClose(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current, closeBtnRef === null || closeBtnRef === void 0 ? void 0 : closeBtnRef.current, addVideoDataLayer);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true"
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-img-caption",
                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"n/a","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventName || eventActionName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventAction || eventActionName, '"}'),
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__content",
                    children: [
                        pretitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__pretitle",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(pretitle)
                        }) : null,
                        title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__title",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                        }) : null,
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                            general: general,
                            linkURL: linkCTA,
                            linkURLRef: linkURLRef,
                            linkNewTab: linkNewTab,
                            description: description,
                            mainTitle: mainTitle,
                            componentPosition: componentPosition,
                            componentLinkType: componentLinkType,
                            pageType: pageType,
                            linkDescription: linkDescription
                        }) : null,
                        videoActionsEnabled === "true" || enablePopUPVideo === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__action-container",
                            children: [
                                actionsEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cta_link",
                                    children: actions.map((action, index)=>{
                                        const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                            primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                            secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                            playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                            link: url,
                                            text: title,
                                            newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                            urlRef: urlRef,
                                            id: dynamicId,
                                            pageType: pageType,
                                            linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                            mainTitle: mainTitle,
                                            dataLayerLinkType: dataLayerLinkType,
                                            eventName: eventName,
                                            eventAction: eventAction,
                                            componentPosition: componentPosition,
                                            propertiesPageType: propertiesPageType,
                                            playVideoCTAcb: (event)=>{
                                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                            }
                                        }, "video-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                    })
                                }) : null,
                                enablePopUPVideo === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "play_modal_video_cta",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "playVideoCta ".concat(textLinkCta === "true" ? "textLinkCta" : "", " ").concat(textLinkCtaOffWhite === "true" ? "textLinkCtaoffwhite" : "", " ").concat(blackBgCta === "true" ? "blackBgCta" : "", " ").concat(offWhiteBg === "true" ? "offWhiteBg" : ""),
                                        onClick: ()=>{
                                            isUserInitiatedRef.current = true;
                                            onPlayInspireVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current, closeBtnRef === null || closeBtnRef === void 0 ? void 0 : closeBtnRef.current, addVideoDataLayer);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: modalCta
                                        })
                                    })
                                }) : null
                            ]
                        }) : null,
                        enableFav || enableShare ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__icons",
                            children: [
                                enableFav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "favorite fav-video-trigger".concat(isFavourited ? " favorite-filled" : ""),
                                    tabIndex: "0",
                                    onClick: (event)=>onFavVideo(event, videoDesktop, videoDesktop, alt, componentLinkType || caption, videoTitle || componentLinkType.toLowerCase() || "hero video", "", favVideoId, (res)=>{
                                            setIsFavourited(res);
                                        })
                                }) : null,
                                enableShare ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "share share-video-trigger",
                                    tabIndex: "0",
                                    "aria-label": "share",
                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), '","internalLinkZoneName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((componentZone === null || componentZone === void 0 ? void 0 : componentZone.toLowerCase()) || "teaser", '","internalLinkURL":"n/a","internalLinkName":"share","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ':share", "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || "share", '","eventType":"navigation","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ':share"}'),
                                    "data-gbh-clickable": "true",
                                    onClick: (e)=>onShareVideo(e, ()=>setShowSocialShare(!showSocialShare)),
                                    children: showSocialShare ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-cmp",
                                        style: {
                                            display: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                            componentProp: {
                                                assetUrl: videoDesktop
                                            },
                                            enableDownload: false
                                        })
                                    }) : null
                                }) : null
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v2_Video = (/*#__PURE__*/react.memo(v2_Video_Video));

;// CONCATENATED MODULE: ./components/ImageCluster/v1/Image.jsx




const v1_Image_Image = (param)=>{
    let { imageData ={} , resource ={}  } = param;
    const { imageComponentProperties ={} , description ="" , areas =[] , link ="" , displayPopupTitle ="" , newTab ="false" , lazyThreshold =0 , widths =[]  } = imageData;
    const { id ="" , alt ="" , src ="" , smartCropRendition ="" , fileReference =""  } = imageComponentProperties;
    const DM_IMAGE = "image";
    const EAEM_DM_IMAGE = "eaem-image";
    const EAEM_BOUNDING_DIV_CSS = "eaem-bounding-div";
    const [imageDiv, setImageDiv] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (imageData) {
            init();
        }
    }, [
        imageData
    ]);
    const handleImageLoad = (event)=>{
        setImageDiv(event.target);
    };
    const init = ()=>{
        const elements = document.querySelectorAll('[data-cmp-is="image"]');
        elements.forEach((element)=>{
            const smatCropRend = element.attributes.getNamedItem("data-cmp-smartcroprendition");
            if (!smatCropRend || smatCropRend.value !== "SmartCrop:Auto") {
                return;
            }
            element.attributes.getNamedItem("data-cmp-is").value = EAEM_DM_IMAGE;
        });
        addImageClusterLazyLoad();
    };
    const addImageClusterLazyLoad = ()=>{
        document.querySelectorAll(".gbh-img-cluster, .image").forEach((component)=>{
            if (isImageInViewport(component) || isImageInViewport(component.querySelector(".gbh-img-left-half__inner"))) {
                const lazyImageDiv = component.querySelectorAll('[data-cmp-is="'.concat(EAEM_DM_IMAGE, '"]'));
                if (lazyImageDiv.length > 0) {
                    lazyImageDiv.forEach((childDiv)=>{
                        setImageDiv(childDiv);
                        showImage();
                    });
                }
            } else {
                addListenerForImageVisibilityCheck(component);
            }
        });
    };
    const showImage = ()=>{
        if (imageDiv.parentNode.classList.contains(EAEM_BOUNDING_DIV_CSS)) {
            return;
        }
        setImageDiv((prevImageDiv)=>({
                ...prevImageDiv,
                attributes: {
                    ...prevImageDiv.attributes,
                    "data-cmp-is": DM_IMAGE
                }
            }));
        const eaemDivWrapper = document.createElement("div");
        eaemDivWrapper.classList.add(EAEM_BOUNDING_DIV_CSS);
        imageDiv.parentNode.appendChild(eaemDivWrapper);
        eaemDivWrapper.appendChild(imageDiv);
    };
    const isImageInViewport = (component)=>{
        if (!component || component.length === 0) {
            return false;
        }
        const LAZY_THRESHOLD = 100;
        const el = component[0];
        const rect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
        return (rect === null || rect === void 0 ? void 0 : rect.top) >= 0 && (rect === null || rect === void 0 ? void 0 : rect.left) >= 0 && (rect === null || rect === void 0 ? void 0 : rect.bottom) - LAZY_THRESHOLD <= (window.innerHeight || document.documentElement.clientHeight) && (rect === null || rect === void 0 ? void 0 : rect.right) <= (window.innerWidth || document.documentElement.clientWidth);
    };
    const addListenerForImageVisibilityCheck = (component)=>{
        const scrollListen = ()=>{
            if (!isImageInViewport(component)) {
                return;
            }
            const lazyImageDiv = component.querySelectorAll('[data-cmp-is="'.concat(EAEM_DM_IMAGE, '"]'));
            if (lazyImageDiv.length > 0) {
                lazyImageDiv.forEach((childDiv)=>{
                    setImageDiv(childDiv);
                    showImage();
                });
            }
            document.removeEventListener("scroll", scrollListen);
        };
        document.addEventListener("scroll", scrollListen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "eaem-bounding-div",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-image",
            "data-cmp-smartcroprendition": smartCropRendition,
            "data-cmp-lazythreshold": lazyThreshold,
            "data-cmp-src": src,
            "data-cmp-widths": widths,
            "data-title": alt,
            id: id,
            "data-asset": fileReference,
            children: [
                link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "cmp-image__link",
                    href: link,
                    target: (0,helper/* convertStringToBoolean */.mUs)(newTab) ? "_blank" : "_self",
                    rel: "noreferrer"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        smartCropRendition !== "SmartCrop:Auto" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(src),
                            className: "cmp-image__image transition",
                            alt: alt,
                            onLoad: handleImageLoad
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                            imgUrl: src,
                            alt: alt,
                            className: "cmp-image__image transition",
                            uniqueId: "".concat(id),
                            itemProp: "contentUrl",
                            onLoad: handleImageLoad
                        }),
                        areas.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("map", {
                            children: areas === null || areas === void 0 ? void 0 : areas.map((area, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: area.shape,
                                    coords: area.coordinates,
                                    href: area.href,
                                    target: area.target,
                                    alt: area.alt,
                                    "data-cmp-relcoords": area.relativeCoordinates
                                }, "key-".concat(id)))
                        }) : null
                    ]
                }),
                !(0,helper/* convertStringToBoolean */.mUs)(displayPopupTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cmp-image__title",
                            itemProp: "caption"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(description)
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ImageCluster_v1_Image = (v1_Image_Image);

;// CONCATENATED MODULE: ./components/ImageCluster/v1/ImageCluster.jsx






const ImageCluster = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { data: { header ="" , description ="" , ctaLink ="" , ctaLabel ="" , newTab =false , pageType ="" , productCategory ="" , productCollectionsName ="" , productRoom ="" , componentLinkType ="" , tabName ="" , dataHeader ="" , componentPosition ="" , appliedCssClassNames =""  } , data ={}  } = props;
    const [imageData, setImageData] = (0,react.useState)([]);
    const [link, setCtaLink] = (0,react.useState)("");
    const [newappliedCssClassNames, setappliedCssClassNames] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (ctaLink) {
            getUrl();
        }
    }, [
        ctaLink
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNames) {
            setappliedCssClassNames(appliedCssClassNames);
        } else {
            setappliedCssClassNames("image-right gbh-img-desc-indent font-style-1 bg-off-white");
        }
    }, [
        appliedCssClassNames
    ]);
    (0,react.useEffect)(()=>{
        if (data) {
            fetchDataLayer(data);
        }
    }, [
        data
    ]);
    const getUrl = async ()=>{
        setCtaLink(await (0,helper/* getShortenedUrl */.Ppy)(ctaLink));
    };
    const fetchDataLayer = (data)=>{
        const result = (0,utils/* recursiveDataFunction */.Qe)(data, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.IMAGE);
        setImageData(result);
    };
    const getCustomDataLayer = ()=>{
        return JSON.stringify({
            productInfo: '{"productCategory":"'.concat(productCategory || "n/a"),
            productCollectionsName: "".concat(productCollectionsName || "n/a"),
            productRoom: "".concat(productRoom || "n/a")
        });
    };
    const getDataLayer = ()=>{
        return JSON.stringify({
            eventName: "".concat(pageType, ":teaser:").concat(ctaLabel.toLowerCase()),
            eventAction: "".concat(pageType, ":teaser:").concat(ctaLabel.toLowerCase()),
            internalLinkName: "".concat(ctaLabel.toLowerCase()),
            internalLinkType: "".concat(pageType, ":").concat(componentLinkType || tabName || "rm" || 0),
            internalLinkZoneName: "".concat(pageType, ":teaser"),
            clickInternalLinks: "".concat(newTab ? "false" : "true"),
            eventType: "navigation",
            internalLinkURL: "".concat(ctaLink),
            internalLinkPosition: "".concat(pageType, ":").concat(componentPosition || "image cluster")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "imagecluster container responsivegrid ".concat(newappliedCssClassNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-img-cluster",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gbh-img-container",
                id: "mainContent",
                role: "main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gbh-img-left-half",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gbh-img-left-half__inner",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "gbh-img-left__full img-pos-rel",
                                        children: ((ref = imageData[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.imageComponentProperties) === null || ref1 === void 0 ? void 0 : ref1.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCluster_v1_Image, {
                                            imageData: imageData[0]
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "gbh-img-left__half img-pos-rel",
                                        children: ((ref2 = imageData[1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.imageComponentProperties) === null || ref3 === void 0 ? void 0 : ref3.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCluster_v1_Image, {
                                            imageData: imageData[1]
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-img-left__half img-pos-rel",
                                children: ((ref4 = imageData[2]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.imageComponentProperties) === null || ref5 === void 0 ? void 0 : ref5.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCluster_v1_Image, {
                                    imageData: imageData[2]
                                }) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gbh-img-right-half",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-imgcluster-title",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(header)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-img-right__descrip",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(description)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh__btn--link",
                                href: link,
                                target: newTab ? "_blank" : "_self",
                                "data-gbh-clickable": "true",
                                rel: "noreferrer",
                                "data-gbh-data-layer": getDataLayer(),
                                "data-gbh-data-layer-custom": getCustomDataLayer(),
                                children: ctaLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-label": ctaLabel,
                                    "data-gbh-clickable": "true",
                                    children: ctaLabel
                                }) : null
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_ImageCluster = (ImageCluster);

// EXTERNAL MODULE: ./components/ShopTheRoomCard/v1/ShopTheRoomCard.jsx
var ShopTheRoomCard = __webpack_require__(75781);
;// CONCATENATED MODULE: ./i18n/useVirtuali18n.js

const useVirtuali18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        designers: t("kf.findpro.label.designers"),
        specialtiesTxt: t("kf.findpro.label.specialtiesTxt"),
        contactTxt: t("kf.findpro.label.contactTxt"),
        availableCTA: t("kf.findpro.label.availableCTA"),
        availableInMonths: t("kf.findpro.label.availableInMonths"),
        findaProText: t("kf.findpro.label.findaProText"),
        home: t("kf.findpro.label.home")
    };
    return i18n;
};
/* harmony default export */ var i18n_useVirtuali18n = (useVirtuali18n);

;// CONCATENATED MODULE: ./components/VirtualDesignerDetails/v1/analytics.js
const analytics_getEventInfo = (phone, url, partnerName, isEmail)=>{
    const internalLinkName = isEmail ? "services@kohler.com" : phone || partnerName;
    const type = phone ? "contact ".concat(isEmail ? "email" : "phone") : partnerName;
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "find a pro:designer:main content area:".concat(type),
        eventName: "find a pro:designer:main content area:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "find a pro results",
        internalLinkType: "find a pro:designer:".concat(partnerName, ":contact"),
        internalLinkURL: url,
        internalLinkZoneName: "find a pro:designer:main content area"
    });
};

;// CONCATENATED MODULE: ./components/VirtualDesignerDetails/v1/VirtualDesignerDetails.view.jsx





const VirtualDesignerDetailsView = (props)=>{
    const { data , staticTexts  } = props;
    const [breadCrumb, setBreadCrumb] = (0,react.useState)("");
    const contactRef = (0,react.useRef)(null);
    const { availableCTA ="" , userAlt ="" , specialtiesTxt ="" , contactTxt =""  } = staticTexts;
    let imageUrl = "";
    if (!imageUrl && data["desktop-banner-image"]) {
        imageUrl = data["desktop-banner-image"];
    } else if (!imageUrl) {
        imageUrl = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
    }
    (0,react.useEffect)(()=>{
        const element = document.getElementsByClassName("cmp-breadcrumb__list")[0];
        if (typeof element !== "undefined" && element !== null) {
            setBreadCrumb(element.innerHTML);
            document.querySelector(".breadcrumb").style.display = "none";
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (data.contactInfo) {
            if (contactRef.current) {
                const links = contactRef.current.querySelectorAll("a");
                links.forEach((link)=>{
                    link.classList.add("gbh-data-layer");
                    const phone = link.textContent;
                    const url = link.getAttribute("href");
                    const isEmail = url.includes("mailto");
                    link.setAttribute("data-gbh-data-layer", analytics_getEventInfo(phone, url, data === null || data === void 0 ? void 0 : data.proName, isEmail));
                });
            }
        }
    }, [
        data
    ]);
    const computeSocialMediaList = (0,react.useCallback)(()=>{
        const keyData = Object.keys(data);
        const socialMediaList = keyData.map((d)=>{
            const e = !d.match("@LastModified");
            if (e) {
                const matchedObjectKey = d.match("social-media-icon-path-");
                if (matchedObjectKey) {
                    const splitStr = matchedObjectKey["input"].split("-");
                    return {
                        icon: matchedObjectKey["input"],
                        alt: "social-media-alt-".concat(splitStr[4]),
                        redirectionLink: "social-media-redirection-link-".concat(splitStr[4]),
                        newTab: "newtab-".concat(splitStr[4])
                    };
                }
            }
            return null // Return null for non-matching keys
            ;
        }).filter((item)=>item !== null) // Filter out null values
        ;
        return socialMediaList;
    }, [
        data
    ]);
    const socialMediaList = computeSocialMediaList();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "virtual-designer-details",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row top-section ml-0 mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "virtual-designer-details__breadcrumb",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(breadCrumb)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "virtual-designer-details__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "virtual-designer-details__profile-section col-12 col-sm-12 col-md-5 col-lg-5 top-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "professional-name",
                                                children: data === null || data === void 0 ? void 0 : data.proName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "profile-details",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "professional-details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "professional-address",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "partner-address",
                                                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.address)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "professional-designation mt-5",
                                                                children: data === null || data === void 0 ? void 0 : data.jobTitle
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "professional-availability",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "availability-days",
                                                                    children: (data === null || data === void 0 ? void 0 : data.available) === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "available-btn",
                                                                        children: availableCTA
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "available-month",
                                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.duration)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-photography",
                                                        children: (data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: data === null || data === void 0 ? void 0 : data.image,
                                                            alt: userAlt
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cover-image-wrapper col-12 col-sm-12 col-md-7 col-lg-7 px-0 top-right",
                                        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    srcset: data["mobile-portrait-image"],
                                                    media: "(max-width: 489px)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    srcset: data["mobile-landscape-image"],
                                                    media: "(max-width: 992px)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "cover-image",
                                                    src: imageUrl,
                                                    alt: data["alt-text-banner"]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "virtual-designer-details__contact-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-12 col-md-6 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "profile-description",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.biography)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-12 col-md-6 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "contact-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "specialities",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "speciality-title",
                                                    children: specialtiesTxt
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "partner-address",
                                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.specialties)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "contacts",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "contact-title",
                                                    children: contactTxt
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "contact-details",
                                                    ref: contactRef,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-address",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.contactInfo)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "social-medias",
                                                    children: socialMediaList.map((s, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: data[s.redirectionLink],
                                                            className: "social-icon",
                                                            target: "".concat(data[s.newTab] ? "_blank" : ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: data[s.icon],
                                                                alt: data[s.alt]
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VirtualDesignerDetails_view = (VirtualDesignerDetailsView);

;// CONCATENATED MODULE: ./components/VirtualDesignerDetails/v1/VirtualDesignerDetails.jsx








const VirtualDesignerDetails = (props)=>{
    const { data: authorData  } = props;
    const staticTexts = i18n_useVirtuali18n({
        authorData
    });
    const [virtualData, setVirtualData] = (0,react.useState)({});
    const virtualDesignerDataUrl = get_default()(authorData, "designerFragLink", "");
    const virtualSanitizeURL = (0,helper/* removeAndCleanLink */.xEh)(virtualDesignerDataUrl);
    (0,react.useEffect)(()=>{
        (0,constants_api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: "".concat(virtualSanitizeURL, "/jcr:content/data/master.json")
            }
        }).then((response)=>{
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                setVirtualData(response === null || response === void 0 ? void 0 : response.data);
            }
        }).catch((err)=>{
            console.log("Failed to get compare attributes JSON file", err);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualDesignerDetails_view, {
        staticTexts: staticTexts,
        data: virtualData
    });
};
/* harmony default export */ var v1_VirtualDesignerDetails = (VirtualDesignerDetails);

;// CONCATENATED MODULE: ./i18n/useFindAProByZipi18n.js

const useFindAProByZipi18n = (componentProp)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        useMyLocation: t("kf.findpro.label.useMyLocation"),
        zipcodeDesc: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeDesc) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeDesc : t("kf.findpro.label.zipcodeDesc"),
        zipcodeInfo: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeInfo) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeInfo : t("kf.findpro.label.zipcodeInfo"),
        zipcodeLabel: t("kf.findpro.label.zipcodeLabel"),
        submitCTA: t("kf.findpro.label.submitCTA"),
        validZipcode: t("kf.findStoreUtilNav.validZipcode"),
        ariaLabel: {
            zipcodeLabel: t("kf.findpro.aria.label.zipcodeLabel")
        },
        continue: t("kf.checkout.label.continue")
    };
    return i18n;
};
/* harmony default export */ var i18n_useFindAProByZipi18n = (useFindAProByZipi18n);

// EXTERNAL MODULE: ./components/FindAProByZip/v1/index.module.scss
var FindAProByZip_v1_index_module = __webpack_require__(62271);
var FindAProByZip_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(FindAProByZip_v1_index_module);
;// CONCATENATED MODULE: ./components/FindAProByZip/v1/analytics.js
const addUseMyLocationAnalytics = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", zipcode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const eventInfo = {
        eventAction: "find a pro:see local professionals:use my location",
        eventName: "find a pro:see local professionals:use my location",
        eventType: "navigation",
        eventMsg: zipcode || message || "n/a",
        eventStatus: status,
        internalLinkName: "use my location",
        internalLinkPosition: "find a pro",
        internalLinkType: "find a pro:".concat(zipcode || "use my location"),
        internalLinkZoneName: "find a pro:see local professionals",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: page,
        eventInfo: eventInfo
    });
};
const getSubmitBtnAnalyticsData = function() {
    let zipcode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const url = pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.replace(".html", "");
    return JSON.stringify({
        eventAction: "find a pro:see local professionals:submit",
        eventName: "find a pro:see local professionals:submit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "submit",
        internalLinkPosition: "find a pro",
        internalLinkType: "find my pro:".concat(zipcode),
        internalLinkZoneName: "find a pro:see local professionals",
        internalLinkURL: "".concat(url, "?q=").concat(zipcode),
        clickInternalLinks: "true"
    });
};

;// CONCATENATED MODULE: ./components/FindAProByZip/v1/FindAProByZip.jsx










const FindAProByZip = (props)=>{
    var ref;
    const { data: componentProp = {}  } = props;
    const [zipcode, setZipcode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)("");
    const [infoModalError, setInfoModalError] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)(false);
    const [info, setInfo] = (0,react.useState)({});
    const [disableButton, setDisableButton] = (0,react.useState)(true);
    const staticTexts = i18n_useFindAProByZipi18n(JSON.parse((0,helper/* jsonStringEscape */.ASm)(JSON.stringify(componentProp))));
    const { validZipcode ="" , zipcodeInfo ="" , zipcodeDesc ="" , zipcodeLabel ="" , submitCTA ="" , useMyLocation =""  } = staticTexts;
    const handleChange = (e)=>{
        const { target: { value =""  } = {}  } = e !== null && e !== void 0 ? e : {};
        const inputValue = value === null || value === void 0 ? void 0 : value.trim();
        (0,helper/* validateField */.OP$)("zipCodeNumeric", inputValue).then((isValid)=>{
            if (isValid || inputValue === "") {
                setZipcode(inputValue);
            }
        });
    };
    const zipCodeCheck = function() {
        let zipVal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const zipcodeValue = zipVal || zipcode;
        (0,helper/* validateField */.OP$)("zipCodeNumeric", zipcodeValue).then((isValid)=>{
            if (((zipVal === null || zipVal === void 0 ? void 0 : zipVal.length) || (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length)) && !isValid) {
                setZipCodeError(validZipcode);
            } else {
                setZipCodeError("");
            }
        });
    };
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            const { zipcode =""  } = getLocation !== null && getLocation !== void 0 ? getLocation : {};
            setZipcode(zipcode);
            zipCodeCheck(zipcode);
            if (zipcode) {
                addUseMyLocationAnalytics("success", "", zipcode);
            } else {
                addUseMyLocationAnalytics("failure", "failed to load zipcode");
            }
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalError(cause);
            setInfoModal(true);
            var ref;
            addUseMyLocationAnalytics("failure", (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "");
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const findAProPageUrl = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.findProPagePath", ""));
            const info = {
                locale,
                currencySign,
                currencyCode,
                findAProPageUrl
            };
            setInfo(info);
        });
    }, []);
    (0,react.useEffect)(()=>{
        (0,helper/* validateField */.OP$)("zipCodeNumeric", zipcode).then((isValid)=>setDisableButton(!isValid));
    }, [
        zipcode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((FindAProByZip_v1_index_module_default()) === null || (FindAProByZip_v1_index_module_default()) === void 0 ? void 0 : (FindAProByZip_v1_index_module_default()).findAProByZipWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "zipcode-page",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                    handleModalClose: ()=>{
                        setInfoModal(false);
                    },
                    show: infoModal,
                    data: infoModalError,
                    pro: true,
                    labelledBy: "Geo-Location-pro-error-message",
                    className: "message-modal",
                    staticTexts: staticTexts,
                    dataLayerPosition: "find a pro"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "zipcode-page__main-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "zipcode-page__inner-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "zipcode-page__zipcode-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "zipcode-info",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(zipcodeInfo)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "zipcode-page__zipcode-right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "zipcode-description",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(zipcodeDesc)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "zipcode-text-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                className: "zipcodeInput",
                                                "aria-label": (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.zipcodeLabel,
                                                value: zipcode,
                                                onKeyUp: ()=>zipCodeCheck(),
                                                onFocus: ()=>zipCodeCheck(),
                                                placeholder: zipcodeLabel,
                                                onChange: (e)=>handleChange(e)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                label: submitCTA,
                                                className: "gbh-data-layer",
                                                "data-gbh-data-layer": getSubmitBtnAnalyticsData(zipcode, info === null || info === void 0 ? void 0 : info.findAProPageUrl),
                                                tag: "anchor",
                                                type: "primary",
                                                customClass: "submitCTA",
                                                to: "".concat(info === null || info === void 0 ? void 0 : info.findAProPageUrl, "?q=").concat(zipcode),
                                                disabled: disableButton,
                                                useDefaultClass: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "location-link-container",
                                        children: [
                                            zipCodeError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "findstore-util-nav__zipcode-error",
                                                children: zipCodeError
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "location-link",
                                                tabIndex: "0",
                                                role: "link",
                                                onClick: ()=>getGeoLocation(),
                                                children: useMyLocation
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_FindAProByZip = (FindAProByZip);

;// CONCATENATED MODULE: ./i18n/useStoreAppointmenti18n.js

const useStoreAppointmenti18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        requestAnAppointment: t("kf.reqAppointment.label.requestAnAppointment"),
        reqAppointmentDesc: t("kf.reqAppointment.label.reqAppointmentDesc"),
        location: t("kf.reqAppointment.label.location"),
        stepOne: t("kf.reqAppointment.label.stepOne"),
        selectData: t("kf.reqAppointment.label.selectData"),
        availableTimes: t("kf.reqAppointment.label.availableTimes"),
        stepTwo: t("kf.reqAppointment.label.stepTwo"),
        fillYourContact: t("kf.reqAppointment.label.fillYourContact"),
        requiredFields: t("kf.reqAppointment.label.requiredFields"),
        firstName: t("kf.reqAppointment.label.firstName"),
        lastName: t("kf.reqAppointment.label.lastName"),
        email: t("kf.reqAppointment.label.email"),
        phone: t("kf.reqAppointment.label.phone"),
        fnameError: t("kf.reqAppointment.label.fnameError"),
        lnameError: t("kf.reqAppointment.label.lnameError"),
        validFirstName: t("kf.reqAppointment.label.validFirstName"),
        validLastName: t("kf.reqAppointment.label.validLastName"),
        noEmailError: t("kf.reqAppointment.label.noEmailError"),
        validEmail: t("kf.reqAppointment.label.validEmail"),
        validPhone: t("kf.reqAppointment.label.validPhone"),
        dateError: t("kf.reqAppointment.label.dateError"),
        timeError: t("kf.reqAppointment.label.timeError"),
        submit: t("kf.reqAppointment.label.submit"),
        privacyPolicy: t("kf.reqAppointment.label.privacyPolicy"),
        subjectAccess: t("kf.reqAppointment.label.subjectAccess"),
        termsOfService: t("kf.reqAppointment.label.termsOfService"),
        leftArrowAlt: t("kf.reqAppointment.label.leftArrowAlt"),
        rightArrowAlt: t("kf.reqAppointment.label.rightArrowAlt"),
        thankYouMsg: t("kf.reqAppointment.label.thankYouMsg"),
        thankYouDesc: t("kf.reqAppointment.label.thankYouDesc"),
        dateAndTime: t("kf.reqAppointment.label.dateAndTime"),
        viewStore: t("kf.reqAppointment.label.viewStore"),
        contactInfo: t("kf.reqAppointment.label.contactInfo"),
        done: t("kf.reqAppointment.label.done"),
        noImage: t("kf.reqAppointment.label.noImage"),
        date: t("kf.reqAppointment.label.date"),
        datePlaceholder: t("kf.reqAppointment.label.datePlaceholder"),
        at: t("kf.reqAppointment.label.at"),
        sunday: t("kf.reqAppointment.label.sunday"),
        monday: t("kf.reqAppointment.label.monday"),
        tuesday: t("kf.reqAppointment.label.tuesday"),
        wednesday: t("kf.reqAppointment.label.wednesday"),
        thursday: t("kf.reqAppointment.label.thursday"),
        friday: t("kf.reqAppointment.label.friday"),
        saturday: t("kf.reqAppointment.label.saturday"),
        january: t("kf.reqAppointment.label.january"),
        february: t("kf.reqAppointment.label.february"),
        march: t("kf.reqAppointment.label.march"),
        april: t("kf.reqAppointment.label.april"),
        may: t("kf.reqAppointment.label.may"),
        june: t("kf.reqAppointment.label.june"),
        july: t("kf.reqAppointment.label.july"),
        august: t("kf.reqAppointment.label.august"),
        september: t("kf.reqAppointment.label.september"),
        october: t("kf.reqAppointment.label.october"),
        november: t("kf.reqAppointment.label.november"),
        december: t("kf.reqAppointment.label.december"),
        weekDays: t("kf.reqAppointment.label.weekDays"),
        weekEnds: t("kf.reqAppointment.label.weekEnds"),
        wholeWeek: t("kf.reqAppointment.label.wholeWeek"),
        sat: t("kf.reqAppointment.label.sat"),
        sun: t("kf.reqAppointment.label.sun"),
        ariaLabel: {
            prevMonth: t("kf.reqAppointment.aria.label.prevMonth"),
            nextMonth: t("kf.reqAppointment.aria.label.nextMonth"),
            changeYear: t("kf.reqAppointment.aria.label.changeYear"),
            selectYear: t("kf.reqAppointment.aria.label.selectYear"),
            prevSlots: t("kf.reqAppointment.aria.label.prevSlots"),
            nextSlots: t("kf.reqAppointment.aria.label.nextSlots"),
            sunday: t("kf.reqAppointment.aria.label.sunday"),
            monday: t("kf.reqAppointment.aria.label.monday"),
            tuesday: t("kf.reqAppointment.aria.label.tuesday"),
            wednesday: t("kf.reqAppointment.aria.label.wednesday"),
            thursday: t("kf.reqAppointment.aria.label.thursday"),
            friday: t("kf.reqAppointment.aria.label.friday"),
            saturday: t("kf.reqAppointment.aria.label.saturday"),
            days: t("kf.reqAppointment.label.days"),
            selected: t("kf.reqAppointment.label.selected"),
            notSelected: t("kf.reqAppointment.label.notSelected")
        },
        genError: t("kf.error.message.genericError"),
        validUSPhone: t("kf.checkout.error.validUSPhone")
    };
    return i18n;
};
/* harmony default export */ var i18n_useStoreAppointmenti18n = (useStoreAppointmenti18n);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Calendar/Calendar.mjs + 16 modules
var Calendar = __webpack_require__(55268);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DatesProvider/use-dates-context.mjs + 1 modules
var use_dates_context = __webpack_require__(69573);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Day/Day.utils.mjs + 1 modules
var Day_utils = __webpack_require__(35867);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DatePicker/DatePicker.module.css.mjs
var DatePicker_module_css_classes = {
    "overlay": "Rg7rY",
    "datePicker": "JGrZb"
};


// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DateInput.utils.mjs
var DateInput_utils = __webpack_require__(85904);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DatePicker/DatePicker.utils.mjs



function isInRange(date, range) {
    const _range = [
        ...range
    ].sort((a, b)=>a.getTime() - b.getTime());
    return dayjs_min_default()(_range[0]).startOf("day").subtract(1, "ms").isBefore(date) && dayjs_min_default()(_range[1]).endOf("day").add(1, "ms").isAfter(date);
}
function useDatesState(param) {
    let { type , level , value , defaultValue , onChange , allowSingleDateInRange , allowDeselect , onMouseLeave , applyTimezone =true  } = param;
    const [_value, setValue] = (0,DateInput_utils/* useUncontrolledDates */.lV)({
        type,
        value,
        defaultValue,
        onChange,
        applyTimezone
    });
    const [pickedDate, setPickedDate] = (0,react.useState)(type === "range" ? _value[0] && !_value[1] ? _value[0] : null : null);
    const [hoveredDate, setHoveredDate] = (0,react.useState)(null);
    const onDateChange = (date)=>{
        if (type === "range") {
            if (pickedDate instanceof Date && !_value[1]) {
                if (dayjs_min_default()(date).isSame(pickedDate, level) && !allowSingleDateInRange) {
                    setPickedDate(null);
                    setHoveredDate(null);
                    setValue([
                        null,
                        null
                    ]);
                    return;
                }
                const result = [
                    date,
                    pickedDate
                ];
                result.sort((a, b)=>a.getTime() - b.getTime());
                setValue(result);
                setHoveredDate(null);
                setPickedDate(null);
                return;
            }
            if (_value[0] && !_value[1] && dayjs_min_default()(date).isSame(_value[0], level) && !allowSingleDateInRange) {
                setPickedDate(null);
                setHoveredDate(null);
                setValue([
                    null,
                    null
                ]);
                return;
            }
            setValue([
                date,
                null
            ]);
            setHoveredDate(null);
            setPickedDate(date);
            return;
        }
        if (type === "multiple") {
            if (_value.some((selected)=>dayjs_min_default()(selected).isSame(date, level))) {
                setValue(_value.filter((selected)=>!dayjs_min_default()(selected).isSame(date, level)));
            } else {
                setValue([
                    ..._value,
                    date
                ]);
            }
            return;
        }
        if (_value && allowDeselect && dayjs_min_default()(date).isSame(_value, level)) {
            setValue(null);
        } else {
            setValue(date);
        }
    };
    const isDateInRange = (date)=>{
        if (pickedDate instanceof Date && hoveredDate instanceof Date) {
            return isInRange(date, [
                hoveredDate,
                pickedDate
            ]);
        }
        if (_value[0] instanceof Date && _value[1] instanceof Date) {
            return isInRange(date, _value);
        }
        return false;
    };
    const onRootMouseLeave = type === "range" ? (event)=>{
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event);
        setHoveredDate(null);
    } : onMouseLeave;
    const isFirstInRange = (date)=>{
        if (!(_value[0] instanceof Date)) {
            return false;
        }
        if (dayjs_min_default()(date).isSame(_value[0], level)) {
            return !(hoveredDate && dayjs_min_default()(hoveredDate).isBefore(_value[0]));
        }
        return false;
    };
    const isLastInRange = (date)=>{
        if (_value[1] instanceof Date) {
            return dayjs_min_default()(date).isSame(_value[1], level);
        }
        if (!(_value[0] instanceof Date) || !hoveredDate) {
            return false;
        }
        return dayjs_min_default()(hoveredDate).isBefore(_value[0]) && dayjs_min_default()(date).isSame(_value[0], level);
    };
    const getControlProps = (date)=>{
        if (type === "range") {
            return {
                selected: _value.some((selection)=>selection && dayjs_min_default()(selection).isSame(date, level)),
                inRange: isDateInRange(date),
                firstInRange: isFirstInRange(date),
                lastInRange: isLastInRange(date),
                "data-autofocus": !!_value[0] && dayjs_min_default()(_value[0]).isSame(date, level) || void 0
            };
        }
        if (type === "multiple") {
            return {
                selected: _value.some((selection)=>selection && dayjs_min_default()(selection).isSame(date, level)),
                "data-autofocus": !!_value[0] && dayjs_min_default()(_value[0]).isSame(date, level) || void 0
            };
        }
        const selected = dayjs_min_default()(_value).isSame(date, level);
        return {
            selected,
            "data-autofocus": selected || void 0
        };
    };
    const onHoveredDateChange = type === "range" && pickedDate ? setHoveredDate : ()=>{};
    return {
        onDateChange,
        onRootMouseLeave,
        onHoveredDateChange,
        getControlProps,
        _value,
        setValue
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DatePicker/DatePicker.mjs









const DatePicker = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { type ="default" , variant ="default" , defaultValue ="month" , value , onChange , getDayProps , allowSingleDateInRange , allowDeselect , onMouseLeave , numberOfColumns =1 , hideOutsideDates , className , __onDayMouseEnter , __onDayClick , __timezoneApplied , ...rest } = props;
    const { onDateChange , onRootMouseLeave , onHoveredDateChange , getControlProps  } = useDatesState({
        type,
        level: "day",
        allowDeselect,
        allowSingleDateInRange,
        value,
        defaultValue,
        onChange,
        onMouseLeave,
        applyTimezone: !__timezoneApplied
    });
    const ctx = (0,use_dates_context/* useDatesContext */.e)();
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Calendar/* Calendar */.f, {
        ref,
        minLevel: "month",
        className: (0,clsx/* default */.Z)(variant === "overlay" && DatePicker_module_css_classes.overlay, DatePicker_module_css_classes.datePicker, className, "kohler-date-picker-root"),
        onMouseLeave: onRootMouseLeave,
        numberOfColumns,
        hideOutsideDates: hideOutsideDates !== null && hideOutsideDates !== void 0 ? hideOutsideDates : numberOfColumns !== 1,
        __onDayMouseEnter: (_event, date)=>{
            onHoveredDateChange(date);
            __onDayMouseEnter === null || __onDayMouseEnter === void 0 ? void 0 : __onDayMouseEnter(_event, date);
        },
        __onDayClick: (_event, date)=>{
            onDateChange(date);
            __onDayClick === null || __onDayClick === void 0 ? void 0 : __onDayClick(_event, date);
        },
        getDayProps: (date)=>{
            return {
                ...getControlProps(date),
                ...getDayProps === null || getDayProps === void 0 ? void 0 : getDayProps(date)
            };
        },
        ...rest,
        date: (0,Day_utils/* shiftTimezone */.w)("add", rest.date, ctx.getTimezone(), __timezoneApplied),
        __timezoneApplied: true
    });
});


;// CONCATENATED MODULE: ./components/StoreAppointment/v1/analytics.js

const getLegalPageAnalytics = function(storeData, title, link) {
    let needJSON = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    const internalLinkType = "find a store:".concat((0,helper/* getInternalLinkTypeForFindStore */.dhb)(storeData.BillingStreet, storeData.BillingCity, storeData.BillingState, storeData.AEM_Microsite_Name__c));
    const eventAction = "find a store:store detail page:store experience:modal:book an appointment:".concat(title);
    const internalLinkZoneName = "find a store:store detail page:store experience:modal:book an appointment";
    let internalLinkName;
    switch(title){
        case "thankyou:done":
            internalLinkName = "done";
            break;
        case "thankyou:view store details":
            internalLinkName = "view store details";
            break;
        case "thankyou:close":
            internalLinkName = "close";
            break;
        default:
            internalLinkName = title;
    }
    let modifiedInternalLinkZoneName = internalLinkZoneName;
    if (title === "thankyou:done" || title === "thankyou:view store details" || title === "thankyou:close") {
        modifiedInternalLinkZoneName += ":thankyou";
    }
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "store appointment",
        internalLinkType,
        internalLinkZoneName: modifiedInternalLinkZoneName,
        internalLinkURL: link ? link.indexOf("http") === -1 ? window.location.origin + link : link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addBookAppointmentAnalytics = (params)=>{
    const { storeData , status , action , errorMessage , appointmentDate , appointmentTime  } = params;
    let eventMsg = "n/a";
    if (status && status !== "success" && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.length)) {
        eventMsg = errorMessage.join("|").toLowerCase();
    }
    // adding analytics
    const eventInfo = getLegalPageAnalytics(storeData, "submit", null, true);
    eventInfo.eventStatus = status;
    eventInfo.eventMsg = eventMsg;
    eventInfo.appointmentDate = appointmentDate || "n/a";
    eventInfo.appointmentTime = appointmentTime || "n/a";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo
    });
    delete window.pageObj;
};
const handleExternalLinkAnalytics = (storeData, title, link)=>{
    // Construct analytics data
    const internalLinkType = "find a store:".concat((0,helper/* getInternalLinkTypeForFindStore */.dhb)(storeData.BillingStreet, storeData.BillingCity, storeData.BillingState, storeData.AEM_Microsite_Name__c));
    const eventAction = "find a store:store detail page:store experience:modal:book an appointment::".concat(title);
    const internalLinkZoneName = "find a store:store detail page:store experience:modal:book an appointment";
    let internalLinkName;
    switch(title){
        case "thankyou:done":
            internalLinkName = "done";
            break;
        case "thankyou:view store details":
            internalLinkName = "view store details";
            break;
        case "thankyou:close":
            internalLinkName = "close";
            break;
        default:
            internalLinkName = title;
    }
    let modifiedInternalLinkZoneName = internalLinkZoneName;
    if (title === "thankyou:done" || title === "thankyou:view store details" || title === "thankyou:close") {
        modifiedInternalLinkZoneName += ":thankyou";
    }
    const internalLink = link ? link.indexOf("http") === -1 ? window.location.origin + link : link : "n/a";
    const analyticsData = {
        event: "cmp:click",
        eventInfo: {
            clickInternalLinks: "true",
            eventAction,
            eventName: eventAction,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "store appointment",
            internalLinkType,
            internalLinkZoneName: modifiedInternalLinkZoneName,
            internalLinkURL: internalLink
        }
    };
    // Push analytics data
    if (window.adobeDataLayer) {
        window.adobeDataLayer.push(analyticsData);
    } else {
        window.adobeDataLayer = [
            analyticsData
        ];
    }
    window.open(internalLink);
};
const getRecaptchaBookAppointmentAnalytics = (internalLinkType)=>{
    return {
        pageTitle: "find a store:landing:modal:book appointment",
        componentName: "book an appointment",
        parentComponent1: "find a store",
        parentComponent2: "store detail page",
        internalLinkPosition: "find a store",
        internalLinkType: "".concat(internalLinkType.indexOf("find a store") === -1 ? "find a store:" : "").concat(internalLinkType, ":google")
    };
};

// EXTERNAL MODULE: ./public/icons/left-arrow.svg
var left_arrow = __webpack_require__(23896);
;// CONCATENATED MODULE: ./public/icons/left-arrow-disabled.svg
/* harmony default export */ var left_arrow_disabled = ({"src":"/_next/static/media/left-arrow-disabled.31a0710c.svg","height":17,"width":10});
;// CONCATENATED MODULE: ./public/icons/right-arrow-disabled.svg
/* harmony default export */ var right_arrow_disabled = ({"src":"/_next/static/media/right-arrow-disabled.7d4bd102.svg","height":17,"width":10});
// EXTERNAL MODULE: ./public/icons/email.svg
var email = __webpack_require__(39306);
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
// EXTERNAL MODULE: ./public/icons/right-arrow.svg
var right_arrow = __webpack_require__(14074);
// EXTERNAL MODULE: ./components/StoreAppointment/v1/index.module.scss
var StoreAppointment_v1_index_module = __webpack_require__(72681);
var StoreAppointment_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(StoreAppointment_v1_index_module);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/fr-ca.js
var fr_ca = __webpack_require__(77989);
;// CONCATENATED MODULE: ./components/StoreAppointment/v1/StoreAppointmentView.jsx























const StoreAppointmentView = (props)=>{
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { internationalization: { locale =""  } = {}  } = globalConfig;
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const [dateValue, setDateValue] = (0,react.useState)(tomorrow);
    const newLocale = (locale === null || locale === void 0 ? void 0 : locale.includes("fr-CA")) ? "fr-ca" : (locale === null || locale === void 0 ? void 0 : locale.includes("en-CA")) ? "en-ca" : "en";
    const datePickerProps = {
        variant: "default",
        firstDayOfWeek: 0,
        defaultValue: tomorrow,
        onChange: setDateValue,
        minDate: tomorrow,
        value: dateValue,
        locale: newLocale
    };
    const { bpNumber ="" , getAppointmentDate =()=>{} , getUrlData ={} , i18n ={} , isSuccess =false , legalPathLinks ={} , monthsData =[] , onModalClose =()=>{} , requestAppointment =()=>{} , successData ={} , getStoreData ={} , loading =false , internalLinkType =""  } = props;
    const { isShowAppointmentModal  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [activeId, setActiveId] = (0,react.useState)(null);
    const [selectedTime, setSelectedTime] = (0,react.useState)("");
    const [currentSlotPage, setCurrentSlotPage] = (0,react.useState)(1);
    const [availableTimeData, setAvailableTimeData] = (0,react.useState)([]);
    const tomorrowFullDate = new Date(+new Date() + 86400000);
    const nextDay = tomorrowFullDate.getFullYear() + "/" + (tomorrowFullDate.getMonth() + 1) + "/" + tomorrowFullDate.getDate();
    const [dateInputVal, setDateInputVal] = (0,react.useState)(nextDay);
    const [dayVal, setDayVal] = (0,react.useState)(tomorrowFullDate.getDay());
    const [data, setData] = (0,react.useState)({
        date: {
            value: "",
            error: false,
            message: ""
        },
        firstName: {
            value: "",
            error: false,
            message: ""
        },
        lastName: {
            value: "",
            error: false,
            message: ""
        },
        email: {
            value: "",
            error: false,
            message: ""
        },
        phone: {
            value: "",
            error: false,
            message: ""
        },
        time: {
            value: selectedTime,
            error: false,
            timeError: ""
        }
    });
    const isSelectFromPicker = false;
    const [isNextDay, setisNextDay] = (0,react.useState)(nextDay === dateInputVal);
    const [storeDetailUrl, setStoreDetailUrl] = (0,react.useState)("");
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        setisNextDay(dateInputVal === nextDay);
    }, []);
    (0,react.useEffect)(()=>{
        getAvailableTimes();
    }, [
        getStoreData
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(getStoreData)) {
            getAvailableTimes();
            getAvailableTimeData();
        }
    }, [
        dayVal,
        isNextDay
    ]);
    (0,react.useEffect)(()=>{
        if (successData) {
            (0,helper/* getShortenedUrl */.Ppy)(successData.storeDetailUrl).then((res)=>{
                setStoreDetailUrl(res);
            });
        }
    }, [
        successData
    ]);
    (0,react.useEffect)(()=>{
        setDayVal(dateValue.getDay());
        setDateInputVal("".concat(dateValue.getFullYear(), "/").concat(dateValue.getMonth() + 1, "/").concat(dateValue.getDate()));
    }, [
        dateValue
    ]);
    const clearErrors = ()=>{
        const curData = data;
        if (curData) {
            for(const item in curData){
                if (Object.prototype.hasOwnProperty.call(curData, item)) {
                    curData[item].error = false;
                    curData[item].message = "";
                }
            }
            setData(curData);
        }
    };
    const getAvailableTimes = ()=>{
        const { getStoreData: { Appointment_Hours_Sunday__c: appointmentHoursSunday , Appointment_Hours_Saturday__c: appointmentHoursSat , Appointment_Hours_M_F__c: appointmentHoursMF  }  } = props;
        if (!isEmpty_default()(getStoreData)) {
            const checkDisabledTime = [];
            let splitAppointmentHoursInArr = [];
            if (dayVal === 0) {
                splitAppointmentHoursInArr = appointmentHoursSunday !== "Closed" ? appointmentHoursSunday === null || appointmentHoursSunday === void 0 ? void 0 : appointmentHoursSunday.split(";") : [];
            } else if (dayVal === 6) {
                splitAppointmentHoursInArr = appointmentHoursSat !== "Closed" ? appointmentHoursSat === null || appointmentHoursSat === void 0 ? void 0 : appointmentHoursSat.split(";") : [];
            } else {
                splitAppointmentHoursInArr = appointmentHoursMF === null || appointmentHoursMF === void 0 ? void 0 : appointmentHoursMF.split(";");
            }
            if ((splitAppointmentHoursInArr === null || splitAppointmentHoursInArr === void 0 ? void 0 : splitAppointmentHoursInArr.length) === 0 && !isSelectFromPicker) {
                setDateValue(new Date(dateValue.setDate(dateValue.getDate() + 1)));
                return;
            }
            splitAppointmentHoursInArr === null || splitAppointmentHoursInArr === void 0 ? void 0 : splitAppointmentHoursInArr.forEach((item)=>checkDisabledTime.push({
                    time: item
                }));
            setAvailableTimeData(checkDisabledTime);
        }
    };
    const getTime = (id, time)=>{
        setActiveId(id);
        setData({
            ...data,
            time: {
                error: false,
                value: time,
                message: ""
            }
        });
        setSelectedTime(time);
    };
    const handleSubmit = ()=>{
        clearErrors();
        setTimeout(async ()=>{
            const obj = {};
            let valid = true;
            const errorMessage = [];
            if (!data.firstName.value) {
                obj.firstName = {
                    ...data.firstName,
                    error: true,
                    message: i18n.fnameError
                };
                valid = false;
                errorMessage.push(i18n.fnameError);
            } else if (!await (0,helper/* validateName */.Olw)(data.firstName.value)) {
                obj.firstName = {
                    ...data.firstName,
                    error: true,
                    message: i18n.validFirstName
                };
                valid = false;
                errorMessage.push(i18n.validFirstName);
            }
            if (!data.lastName.value) {
                obj.lastName = {
                    ...data.lastName,
                    error: true,
                    message: i18n.lnameError
                };
                valid = false;
                errorMessage.push(i18n.lnameError);
            } else if (!await (0,helper/* validateName */.Olw)(data.lastName.value)) {
                obj.lastName = {
                    ...data.lastName,
                    error: true,
                    message: i18n.validLastName
                };
                valid = false;
                errorMessage.push(i18n.validLastName);
            }
            if (!data.email.value) {
                obj.email = {
                    ...data.email,
                    error: true,
                    message: i18n.noEmailError
                };
                valid = false;
                errorMessage.push(i18n.noEmailError);
            } else if (!await (0,helper/* validateField */.OP$)("email", data.email.value)) {
                obj.email = {
                    ...data.email,
                    error: true,
                    message: i18n.validEmail
                };
                valid = false;
                errorMessage.push(i18n.validEmail);
            }
            if (!(0,helperV2/* validateUSPhone */.ix)(data.phone.value)) {
                obj.phone = {
                    ...data.phone,
                    error: true,
                    message: i18n.validUSPhone
                };
                valid = false;
                errorMessage.push(i18n.validUSPhone);
            }
            if (isEmpty_default()(dateInputVal)) {
                obj.date = {
                    ...data.date,
                    error: true,
                    message: i18n.dateError
                };
                valid = false;
                errorMessage.push(i18n.dateError);
            }
            if (isEmpty_default()(selectedTime)) {
                obj.time = {
                    ...data.time,
                    error: true,
                    timeError: i18n.timeError
                };
                valid = false;
                errorMessage.push(i18n.timeError);
            }
            const newData = {
                ...data,
                ...obj
            };
            setData(newData);
            if (valid) {
                const appointmentDate = monthsData[new Date(dateInputVal).getMonth()] + " " + new Date(dateInputVal).getDate() + ", " + new Date(dateInputVal).getFullYear() + " " + i18n.at + " " + selectedTime;
                const body = {
                    Interaction_Type__c: "Appointment",
                    Preferred_Email__c: get_default()(data, "email.value", ""),
                    PreferredPhone: get_default()(data, "phone.value", ""),
                    BP_Number__c: bpNumber,
                    LastName__c: get_default()(data, "lastName.value", ""),
                    FirstName__c: get_default()(data, "firstName.value", ""),
                    Appointment_Date_Time__c: dateInputVal.replaceAll("/", "-") + " " + selectedTime
                };
                (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
                    if (res.success) {
                        getAppointmentDate(appointmentDate);
                        requestAppointment(body, appointmentDate);
                    } else {
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.genError,
                            isVisible: true
                        }));
                    }
                });
            } else {
                const appointmentDate1 = monthsData[new Date(dateInputVal).getMonth()] + " " + new Date(dateInputVal).getDate() + ", " + new Date(dateInputVal).getFullYear();
                addBookAppointmentAnalytics({
                    storeData: getStoreData,
                    action: "cmp:click",
                    status: "failure",
                    errorMessage: errorMessage,
                    appointmentDate: appointmentDate1,
                    appointmentTime: selectedTime
                });
            }
        }, 100);
    };
    const handleExternalLinkClick = (e, storeData, title, link)=>{
        e.preventDefault();
        handleExternalLinkAnalytics(storeData, title, link);
    };
    const onBlurInput = async (name, value)=>{
        switch(name){
            case "fname":
                if (!value) {
                    setData({
                        ...data,
                        firstName: {
                            error: true,
                            value: value,
                            message: i18n.fnameError
                        }
                    });
                } else if (!await (0,helper/* validateName */.Olw)(value)) {
                    setData({
                        ...data,
                        firstName: {
                            error: true,
                            value: value,
                            message: i18n.validFirstName
                        }
                    });
                } else {
                    setData({
                        ...data,
                        firstName: {
                            error: false,
                            value: value,
                            message: ""
                        }
                    });
                }
                break;
            case "lname":
                if (!value) {
                    setData({
                        ...data,
                        lastName: {
                            error: true,
                            value: value,
                            message: i18n.lnameError
                        }
                    });
                } else if (!await (0,helper/* validateName */.Olw)(value)) {
                    setData({
                        ...data,
                        lastName: {
                            error: true,
                            value: value,
                            message: i18n.validLastName
                        }
                    });
                } else {
                    setData({
                        ...data,
                        lastName: {
                            error: false,
                            value: value,
                            message: ""
                        }
                    });
                }
                break;
            case "email":
                if (!value) return setData({
                    ...data,
                    email: {
                        error: true,
                        value: value,
                        message: i18n.noEmailError
                    }
                });
                if (!await (0,helper/* validateField */.OP$)("email", value)) setData({
                    ...data,
                    email: {
                        error: true,
                        value: value,
                        message: i18n.validEmail
                    }
                });
                else setData({
                    ...data,
                    email: {
                        error: false,
                        value: value,
                        message: ""
                    }
                });
                break;
            case "phone":
                if (!(0,helperV2/* validateUSPhone */.ix)(value)) {
                    setData({
                        ...data,
                        phone: {
                            error: true,
                            value: value,
                            message: i18n.validUSPhone
                        }
                    });
                } else setData({
                    ...data,
                    phone: {
                        error: false,
                        value: value,
                        message: ""
                    }
                });
                break;
            default:
                return;
        }
    };
    const checkDisabled = (data)=>{
        if (data.firstName.value && data.lastName.value && data.email.value && data.phone.value) return false;
        return true;
    };
    const showPrevious = ()=>{
        if (currentSlotPage !== 1) {
            setCurrentSlotPage((currentSlotPage)=>currentSlotPage - 1);
        }
    };
    const showNext = ()=>{
        if (currentSlotPage < Math.ceil(availableTimeData.length / 12)) {
            setCurrentSlotPage((currentSlotPage)=>currentSlotPage + 1);
        }
    };
    const getAvailableTimeData = ()=>{
        let getavailableTimes = [];
        const startIndex = currentSlotPage * 12 - 12;
        const endIndex = startIndex + 12;
        if (!isEmpty_default()(getStoreData)) {
            availableTimeData.sort(function(a, b) {
                return new Date(nextDay + " " + a.time) - new Date(nextDay + " " + b.time);
            });
            getavailableTimes = availableTimeData.slice(startIndex, endIndex);
        }
        return getavailableTimes;
    };
    const modalClose = ()=>{
        onModalClose();
        setActiveId(null);
        setDateInputVal(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate());
        setData({
            date: {
                value: "",
                error: false,
                message: ""
            },
            firstName: {
                value: "",
                error: false,
                message: ""
            },
            lastName: {
                value: "",
                error: false,
                message: ""
            },
            email: {
                value: "",
                error: false,
                message: ""
            },
            phone: {
                value: "",
                error: false,
                message: ""
            },
            time: {
                value: "",
                error: false,
                timeError: ""
            }
        });
        setSelectedTime("");
        setDayVal(tomorrowFullDate.getDay());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        mod: "white",
        className: (StoreAppointment_v1_index_module_default()).storeAppointMentWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "store-appointment",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal["default"], {
                onModalClose: modalClose,
                modalTitle: getUrlData.title,
                showModal: isShowAppointmentModal,
                closeButtonAnalytics: getLegalPageAnalytics(getStoreData, isSuccess ? "thankyou:close" : "close"),
                children: !isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row ml-0 mr-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 store-appointment__header",
                                children: [
                                    !isEmpty_default()(getUrlData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "store-appointment__heading",
                                                children: getUrlData.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "store-appointment__desc",
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(getUrlData.description)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "store-appointment__location",
                                        children: i18n.location
                                    }),
                                    !isEmpty_default()(getStoreData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "store-appointment__store",
                                                children: getStoreData.AEM_Microsite_Name__c
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "store-appointment__address",
                                                children: getStoreData.BillingStreet + ", " + getStoreData.BillingCity + ", " + getStoreData.BillingState + " " + getStoreData.BillingPostalCode
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ml-0 mr-0",
                            role: "group",
                            "aria-label": i18n.stepOne + ": " + i18n.selectData,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 store-appointment__select-date",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "store-appointment__step",
                                        children: i18n.stepOne + ": " + i18n.selectData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 store-appointment__select-date-time",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12 col-md-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker, {
                                                    ...datePickerProps
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-12 col-md-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__available-time",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__available-txt",
                                                                children: i18n.availableTimes
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "store-appointment__available-arrow",
                                                                children: [
                                                                    currentSlotPage === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        "aria-disabled": "true",
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.prevSlots,
                                                                        src: left_arrow_disabled === null || left_arrow_disabled === void 0 ? void 0 : left_arrow_disabled.src,
                                                                        alt: i18n.leftArrowAlt,
                                                                        className: "store-appointment__left-arrow-disable"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.prevSlots,
                                                                        src: left_arrow/* default */.Z === null || left_arrow/* default */.Z === void 0 ? void 0 : left_arrow/* default.src */.Z.src,
                                                                        alt: i18n.leftArrowAlt,
                                                                        onClick: showPrevious,
                                                                        className: "store-appointment__arrow"
                                                                    }),
                                                                    currentSlotPage === Math.ceil(availableTimeData.length / 12) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        "aria-disabled": "true",
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.nextSlots,
                                                                        src: right_arrow_disabled === null || right_arrow_disabled === void 0 ? void 0 : right_arrow_disabled.src,
                                                                        alt: i18n.rightArrowAlt,
                                                                        className: "store-appointment__right-arrow-disable"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.nextSlots,
                                                                        src: right_arrow/* default */.Z === null || right_arrow/* default */.Z === void 0 ? void 0 : right_arrow/* default.src */.Z.src,
                                                                        alt: i18n.rightArrowAlt,
                                                                        className: "store-appointment__arrow",
                                                                        onClick: showNext
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "store-appointment__available-container",
                                                        role: "listbox",
                                                        children: getAvailableTimeData().map((item, i)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                tabIndex: "0",
                                                                role: "option",
                                                                "aria-selected": i === activeId,
                                                                className: "store-appointment__available-time-card ".concat(i === activeId ? "--active" : ""),
                                                                onClick: ()=>getTime(i, item.time),
                                                                children: item.time
                                                            }, i);
                                                        })
                                                    }),
                                                    data.time.error && isEmpty_default()(selectedTime) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "input-field__error-message",
                                                        role: "alert",
                                                        children: i18n.timeError
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ml-0 mr-0",
                            role: "group",
                            "aria-label": i18n.stepTwo + ": " + i18n.fillYourContact,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 store-appointment__contact-heading",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "store-appointment__step",
                                            children: i18n.stepTwo + ": " + i18n.fillYourContact
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "store-appointment__required",
                                            children: i18n.requiredFields
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 store-appointment__contact-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        id: "firstname",
                                                        type: "text",
                                                        value: data.firstName.value,
                                                        maxLength: 40,
                                                        placeholder: "".concat(i18n.firstName, "*"),
                                                        label: "".concat(i18n.firstName, "*"),
                                                        onChange: (e)=>setData({
                                                                ...data,
                                                                firstName: {
                                                                    value: e.target.value,
                                                                    error: false,
                                                                    message: ""
                                                                }
                                                            }),
                                                        showError: data.firstName.error,
                                                        errorMessage: data.firstName.message,
                                                        onBlur: ()=>onBlurInput("fname", data.firstName.value)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        id: "lastname",
                                                        type: "text",
                                                        value: data.lastName.value,
                                                        maxLength: 40,
                                                        placeholder: "".concat(i18n.lastName, "*"),
                                                        label: "".concat(i18n.lastName, "*"),
                                                        onChange: (e)=>setData({
                                                                ...data,
                                                                lastName: {
                                                                    value: e.target.value,
                                                                    error: false,
                                                                    message: ""
                                                                }
                                                            }),
                                                        showError: data.lastName.error,
                                                        errorMessage: data.lastName.message,
                                                        onBlur: ()=>onBlurInput("lname", data.lastName.value)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    id: "email",
                                                    type: "text",
                                                    value: data.email.value,
                                                    maxLength: 60,
                                                    placeholder: "".concat(i18n.email, "*"),
                                                    label: "".concat(i18n.email, "*"),
                                                    onChange: (e)=>setData({
                                                            ...data,
                                                            email: {
                                                                value: e.target.value,
                                                                error: false,
                                                                message: ""
                                                            }
                                                        }),
                                                    showError: data.email.error,
                                                    errorMessage: data.email.message,
                                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                                        alt: i18n.email
                                                    }),
                                                    onBlur: ()=>onBlurInput("email", data.email.value)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    id: "phone",
                                                    type: "text",
                                                    value: data.phone.value,
                                                    maxLength: 14,
                                                    placeholder: "".concat(i18n.phone, "*"),
                                                    label: "".concat(i18n.phone, "*"),
                                                    onChange: (e)=>setData({
                                                            ...data,
                                                            phone: {
                                                                value: (0,helperV2/* convertToUSPhoneNumber */.o8)(e.target.value),
                                                                error: false,
                                                                message: ""
                                                            }
                                                        }),
                                                    showError: data.phone.error,
                                                    errorMessage: data.phone.message,
                                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: phone_icon/* default */.Z === null || phone_icon/* default */.Z === void 0 ? void 0 : phone_icon/* default.src */.Z.src,
                                                        alt: i18n.phone
                                                    }),
                                                    onBlur: ()=>onBlurInput("phone", data.phone.value)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                            label: i18n.submit,
                                                            size: "medium",
                                                            type: "primary flexible",
                                                            onClick: handleSubmit,
                                                            disabled: checkDisabled(data),
                                                            loading: loading,
                                                            role: "button"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                                            getAnalyticsData: getRecaptchaBookAppointmentAnalytics(internalLinkType)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "col-12 store-appointment__privacy-policy",
                                                    children: !isEmpty_default()(legalPathLinks) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: legalPathLinks === null || legalPathLinks === void 0 ? void 0 : legalPathLinks.privacyPolicy,
                                                                    className: "gbh-data-layer",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: (e)=>{
                                                                        var ref;
                                                                        return handleExternalLinkClick(e, getStoreData, (ref = i18n.privacyPolicy) === null || ref === void 0 ? void 0 : ref.toLowerCase(), legalPathLinks.privacyPolicy);
                                                                    },
                                                                    children: i18n.privacyPolicy
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: legalPathLinks === null || legalPathLinks === void 0 ? void 0 : legalPathLinks.subjectAccessRequest,
                                                                    className: "gbh-data-layer",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: (e)=>{
                                                                        var ref;
                                                                        return handleExternalLinkClick(e, getStoreData, (ref = i18n.subjectAccess) === null || ref === void 0 ? void 0 : ref.toLowerCase(), legalPathLinks.subjectAccessRequest);
                                                                    },
                                                                    children: i18n.subjectAccess
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: legalPathLinks === null || legalPathLinks === void 0 ? void 0 : legalPathLinks.termsOfService,
                                                                    className: "gbh-data-layer",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: (e)=>{
                                                                        var ref;
                                                                        return handleExternalLinkClick(e, getStoreData, (ref = i18n.termsOfService) === null || ref === void 0 ? void 0 : ref.toLowerCase(), legalPathLinks.termsOfService);
                                                                    },
                                                                    children: i18n.termsOfService
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "store-appointment__confirmation",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "store-appointment__thank-you-container",
                                    role: "alert",
                                    children: !isEmpty_default()(getUrlData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "store-appointment__thank-you",
                                                children: getUrlData.confirmationTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "store-appointment__thank-you-desc",
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(getUrlData.confirmationDescription)
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: successData && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "store-appointment__details-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "store-appointment__details-left",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-title",
                                                                children: i18n.dateAndTime
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.selectedDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-title",
                                                                children: i18n.location
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "store-appointment__details-content-main",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "store-appointment__details-content",
                                                                        children: successData.storeName
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "store-appointment__details-content",
                                                                        children: successData.address
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "store-appointment__details-content-main",
                                                                children: successData.sameHours ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "store-appointment__details-time",
                                                                        children: i18n.wholeWeek + " " + successData.openingHours
                                                                    })
                                                                }) : isEmpty_default()(successData.saturday) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.weekDays + " " + successData.openingHours
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.weekEnds + " " + successData.weekendHours
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.weekDays + " " + successData.openingHours
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.sat + " " + successData.saturday
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.sun + " " + successData.sunday
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: storeDetailUrl,
                                                                className: "store-appointment__details-content store-appointment__details-store-link gbh-data-layer",
                                                                "data-gbh-data-layer": getLegalPageAnalytics(getStoreData, "thankyou:view store details", storeDetailUrl),
                                                                children: i18n.viewStore
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-title",
                                                                children: i18n.contactInfo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.contactName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.contactEmail
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.contactPhone
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "store-appointment__details-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            media: "(min-width: 481px) and (max-width:990px) and (orientation: landscape)",
                                                            srcSet: !isEmpty_default()(successData.storeImgMobileLandscape) ? successData.storeImgMobileLandscape : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            media: "(max-width:480px)",
                                                            srcSet: !isEmpty_default()(successData.storeImgMobilePortrait) ? successData.storeImgMobilePortrait : image_missing/* default */.Z
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: !isEmpty_default()(successData.storeImgDesktop) ? successData.storeImgDesktop : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                            alt: i18n.noImage
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row ml-0 mr-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 store-appointment__close-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        label: i18n.done,
                                        size: "medium",
                                        type: "primary flexible",
                                        onClick: modalClose,
                                        customClass: "store-appointment__close-btn",
                                        className: "gbh-data-layer",
                                        "data-gbh-data-layer": getLegalPageAnalytics(getStoreData, "thankyou:done"),
                                        useDefaultClass: true,
                                        role: "button"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v1_StoreAppointmentView = (StoreAppointmentView);

;// CONCATENATED MODULE: ./components/StoreAppointment/v1/StoreAppointment.jsx














const StoreAppointment = (props)=>{
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data: authorData = {}  } = props;
    const staticTexts = i18n_useStoreAppointmenti18n();
    const [storeDetails, setStoreDetails] = (0,react.useState)({});
    const [bpNumberState, setBpNumberState] = (0,react.useState)("");
    const [storeData, setStoreData] = (0,react.useState)({});
    const [info, setInfo] = (0,react.useState)({});
    const [appointmentDate, setAppointmentDate] = (0,react.useState)("");
    const [successData, setSuccessData] = (0,react.useState)({});
    const [isSuccess, setIsSuccess] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [getUrlData, setGetUrlData] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            document.addEventListener("click", getNodeList);
        }
        return ()=>{
            document.removeEventListener("click", getNodeList);
        };
    }, [
        isSsr,
        pageIsInteractive
    ]);
    const getNodeList = (event)=>{
        const anchor = event.target.closest("a");
        if (!anchor) return;
        const anchorValue = anchor.getAttribute("href");
        if (anchorValue === constants.STORE_APPOINTMENT_ANCHOR_VALUE) {
            event.preventDefault();
            dispatch((0,genericSlice/* showAppointmentModal */.kY)(null));
        }
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const getStoreURL = get_default()(config, "apiEndpoints.storeBpNumber", "");
            const getStoreAppointmentUrl = get_default()(config, "apiEndpoints.storeAppointment", "");
            const findStoreDetailsUrl = get_default()(config, "general.storeDetailsServletPath", "");
            const shortendPagePath = get_default()(config, "general.shortendPagePath", "");
            const legalPathLinks = get_default()(config, "legalPageData.map", {});
            const general = {
                getStoreURL: getStoreURL,
                getStoreAppointmentUrl: getStoreAppointmentUrl,
                legalPathLinks: legalPathLinks
            };
            setInfo(general);
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: findStoreDetailsUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    setStoreDetails(response.data);
                    const storeDetailsValue = response.data;
                    const shortendPageUrl = shortendPagePath + window.location.pathname + ".html";
                    let bpNumberValue = null;
                    Object.keys(storeDetailsValue).forEach((store)=>{
                        if (storeDetailsValue[store] === window.location.pathname || storeDetailsValue[store] === shortendPageUrl) {
                            bpNumberValue = store;
                        }
                    });
                    if (!bpNumberValue) {
                        setGetUrlData(authorData !== null && authorData !== void 0 ? authorData : {});
                        console.error("Store detail not configured: BP number not found");
                    } else {
                        setGetUrlData(authorData !== null && authorData !== void 0 ? authorData : {});
                        setBpNumberState(bpNumberValue);
                        if (getStoreURL) {
                            getStoreFromBP(bpNumberValue, getStoreURL);
                        }
                    }
                }
            }).catch((err)=>{
                console.log("Failed to get compare attributes JSON file", err);
            });
        });
    }, []);
    const getStoreFromBP = (bpNumberValue, getStoreURL)=>{
        if (!isEmpty_default()(getStoreURL)) {
            constants_api/* apim.get */.TH.get("".concat(getStoreURL, "/").concat(bpNumberValue), {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Access-Control-Allow-Headers": "X-Requested-With",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _data;
                    setStoreData((_data = response.data) !== null && _data !== void 0 ? _data : {});
                } else {
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                        isVisible: true
                    }));
                }
            }).catch((err)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                    isVisible: true
                }));
            });
        } else {
            console.warn("Store Data: Get URL Property not found");
        }
    };
    const getRequestAppointment = (val, selectedDateSucess)=>{
        // const genericError = authorData.genericError
        setLoading(true);
        getAppointmentData(val, selectedDateSucess);
        constants_api/* apim.post */.TH.post(info.getStoreAppointmentUrl, val, {
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Headers": "X-Requested-With",
                "X-Requested-With": "XMLHttpRequest"
            }
        }).then((response)=>{
            if (response && response.data) {
                var ref, ref1, ref2, ref3;
                const message = get_default()(response.data, "success", false);
                if (message === true) {
                    setIsSuccess(true);
                }
                const spliteDate = (selectedDateSucess === null || selectedDateSucess === void 0 ? void 0 : selectedDateSucess.split("at")) || (appointmentDate === null || appointmentDate === void 0 ? void 0 : appointmentDate.split("at"));
                const dateSplit = (ref = spliteDate[0]) === null || ref === void 0 ? void 0 : ref.split(",");
                const monthSplit = (ref1 = dateSplit[0]) === null || ref1 === void 0 ? void 0 : ref1.split(" ");
                const getFormatDate = "".concat(monthSplit[1], "-").concat(monthSplit[0], "-").concat((ref2 = dateSplit[1]) === null || ref2 === void 0 ? void 0 : ref2.trim());
                const getFormatTime = (ref3 = spliteDate[1]) === null || ref3 === void 0 ? void 0 : ref3.trim();
                addBookAppointmentAnalytics({
                    storeData: storeData,
                    action: "cmp:click",
                    status: "success",
                    errorMessage: [],
                    appointmentDate: getFormatDate,
                    appointmentTime: getFormatTime
                });
            } else {
                setLoading(false);
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                    isVisible: true
                }));
                console.log("Fetching data failed");
                addBookAppointmentAnalytics({
                    storeData: storeData,
                    action: "cmp:click",
                    status: "failure",
                    errorMessage: [
                        staticTexts.genError
                    ],
                    appointmentDate: null,
                    appointmentTime: null
                });
            }
        }).catch((err)=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                isVisible: true
            }));
            setLoading(false);
            console.log(err);
        });
    };
    const getAppointmentDate = (val)=>{
        setAppointmentDate(val);
    };
    const getAppointmentData = (val, selectedDateSucess)=>{
        const appointmentData = {};
        let checkWeekdayTime;
        let isAllDay;
        let isWeekend;
        let checkWeekEndTime;
        let saturdayTime;
        let sundayTime;
        const mondayStoreTime = get_default()(storeData, "Monday_Store_Hours__c", "");
        const saturdayStoreTime = get_default()(storeData, "Open_Hours_Saturday__c", "");
        const sundayStoreTime = get_default()(storeData, "Open_Hours_Sunday__c", "");
        const mondayTime = mondayStoreTime === null || mondayStoreTime === void 0 ? void 0 : mondayStoreTime.split(";");
        if (mondayStoreTime === saturdayStoreTime && mondayStoreTime === sundayStoreTime) {
            isAllDay = true;
            checkWeekdayTime = "".concat(mondayTime[0], "-").concat(mondayTime[1]);
        } else {
            isAllDay = false;
            checkWeekdayTime = "".concat(mondayTime[0], "-").concat(mondayTime[1]);
        }
        if (saturdayStoreTime === sundayStoreTime) {
            isWeekend = true;
            const weekEndTime = saturdayStoreTime !== "Closed" ? saturdayStoreTime === null || saturdayStoreTime === void 0 ? void 0 : saturdayStoreTime.split(";") : [];
            checkWeekEndTime = weekEndTime.length > 0 ? "".concat(saturdayStoreTime[0], "-").concat(saturdayStoreTime[1]) : "Closed";
        } else {
            isWeekend = false;
            saturdayTime = saturdayStoreTime === null || saturdayStoreTime === void 0 ? void 0 : saturdayStoreTime.split(";");
            sundayTime = sundayStoreTime === null || sundayStoreTime === void 0 ? void 0 : sundayStoreTime.split(";");
        }
        appointmentData.selectedDate = selectedDateSucess;
        appointmentData.storeName = get_default()(storeData, "AEM_Microsite_Name__c", "");
        var ref;
        appointmentData.address = (ref = "".concat(storeData.BillingStreet, ", ").concat(storeData.BillingCity, ", ").concat(storeData.BillingState, " ").concat(storeData.BillingPostalCode)) !== null && ref !== void 0 ? ref : "";
        var ref1;
        appointmentData.contactName = (ref1 = "".concat(val === null || val === void 0 ? void 0 : val.FirstName__c, " ").concat(val === null || val === void 0 ? void 0 : val.LastName__c)) !== null && ref1 !== void 0 ? ref1 : "";
        appointmentData.contactEmail = get_default()(val, "Preferred_Email__c", "");
        appointmentData.contactPhone = get_default()(val, "PreferredPhone", "");
        appointmentData.storeImgDesktop = get_default()(getUrlData, "imageDesktop", "");
        appointmentData.storeImgMobilePortrait = get_default()(getUrlData, "imageMobilePortrait", "");
        appointmentData.storeImgMobileLandscape = get_default()(getUrlData, "imageMobileLandscape", "");
        appointmentData.sameHours = isAllDay;
        appointmentData.openingHours = checkWeekdayTime;
        appointmentData.saturday = !isWeekend ? "".concat(saturdayTime[0]).concat(saturdayTime[1] ? "-".concat(saturdayTime[1]) : "") : "";
        appointmentData.sunday = !isWeekend ? "".concat(sundayTime[0]).concat(sundayTime[1] ? "-".concat(sundayTime[1]) : "") : "";
        appointmentData.weekendHours = isWeekend ? checkWeekEndTime : "";
        var _bpNumberState;
        appointmentData.storeDetailUrl = (_bpNumberState = storeDetails[bpNumberState]) !== null && _bpNumberState !== void 0 ? _bpNumberState : "/";
        setSuccessData(appointmentData);
    };
    const modalClose = ()=>{
        setIsSuccess(false);
        setLoading(false);
        dispatch((0,genericSlice/* hideAppointmentModal */.AN)());
    };
    const { ariaLabel ={
        sunday: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: ""
    } , january ="" , february ="" , march ="" , april ="" , may ="" , june ="" , july ="" , august ="" , september ="" , october ="" , november ="" , december =""  } = staticTexts;
    const daysData = [
        ariaLabel.sunday,
        ariaLabel.monday,
        ariaLabel.tuesday,
        ariaLabel.wednesday,
        ariaLabel.thursday,
        ariaLabel.friday,
        ariaLabel.saturday
    ];
    const monthsData = [
        january,
        february,
        march,
        april,
        may,
        june,
        july,
        august,
        september,
        october,
        november,
        december
    ];
    let internalLinkType = "find a store:".concat((0,helper/* getInternalLinkTypeForFindStore */.dhb)(storeData.BillingStreet, storeData.BillingCity, storeData.BillingState));
    if (window.storeLinkType) {
        try {
            internalLinkType = (0,helper/* sanitizeTextForAnalytics */.T68)(window.storeLinkType);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_StoreAppointmentView, {
        i18n: staticTexts,
        daysData: daysData,
        monthsData: monthsData,
        isSuccess: isSuccess,
        successData: successData,
        getStoreData: storeData,
        requestAppointment: (val, selectedDateSucess)=>getRequestAppointment(val, selectedDateSucess),
        hideInput: true,
        getAppointmentDate: (val)=>getAppointmentDate(val),
        hidePast: true,
        bpNumber: bpNumberState,
        onModalClose: ()=>modalClose(),
        legalPathLinks: info.legalPathLinks,
        getUrlData: getUrlData,
        loading: loading,
        internalLinkType: internalLinkType
    });
};
/* harmony default export */ var v1_StoreAppointment = (StoreAppointment);

;// CONCATENATED MODULE: ./components/productCard/Hotspot/utils.js


const getProductInfo = function() {
    let productinfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { productData , sku , needsJSON , cart , config , description , persona  } = productinfo;
    const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: cart,
        sku: sku
    });
    const colorDetails = get_default()(productData, "Color.SKU.Details_ss", []);
    var ref1;
    const colorDetail = (ref1 = colorDetails.find((colorDetail)=>colorDetail.includes(sku))) !== null && ref1 !== void 0 ? ref1 : "|";
    const color = colorDetail.split("|")[0];
    const productInfo = {
        productInfo: {
            productBrand: (ref = get_default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: ((0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a").toLowerCase(),
            globalPromotionPrice: Number(get_default()(productData, "priceList.".concat(persona, ".discountedPrice_d"), 0)).toFixed(2),
            productBasePrice: Number(get_default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toFixed(2),
            productCategory: ((0,helper/* sanitizeTextForAnalytics */.T68)(productData["Product_Category"]) || "n/a").toLowerCase(),
            productColor: ((0,helper/* sanitizeTextForAnalytics */.T68)(color) || "n/a").toLowerCase(),
            productName: ((0,helper/* sanitizeTextForAnalytics */.T68)(get_default()(productData, "productName_s", "")) || "n/a").toLowerCase(),
            productFindingMethod: "n/a",
            productCouponCode: productCouponCode.join("|") || "n/a",
            productCoupondiscount: productCoupondiscount,
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    };
    if (needsJSON) {
        return productInfo.productInfo;
    }
    return productInfo;
};
const getDescriptionWithElipsis = (isMobile, description)=>{
    const length = isMobile ? 41 : 45;
    if (description.length >= length) {
        if (description.charAt(length) === " ") {
            description = description.slice(0, length) + "...";
        } else {
            description = description.slice(0, length).split(" ");
            description.pop();
            description = description.join(" ") + "...";
        }
    }
    return description;
};
const flags = (persona)=>{
    return [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "Color.TPR.Details_ss",
        "RegionBrandName_s",
        "metaTitle_s",
        "ctId_s",
        "CustomerFacingBrand_s"
    ];
};

// EXTERNAL MODULE: ./components/ShopTheRoomCard/analytics.js
var ShopTheRoomCard_analytics = __webpack_require__(59362);
// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
// EXTERNAL MODULE: ./components/productCard/Hotspot/index.module.scss
var Hotspot_index_module = __webpack_require__(5417);
var Hotspot_index_module_default = /*#__PURE__*/__webpack_require__.n(Hotspot_index_module);
;// CONCATENATED MODULE: ./components/productCard/Hotspot/index.jsx























const Hotspot_ProductCard = (props)=>{
    const { authorData: { skewId ="" , presetConfigs ="{}"  } , isDefaultProductCard =true , isFavoriteIcon =true , selectedProduct ="" , hotspotClicked =false  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const presetConfig = JSON.parse(presetConfigs);
    const myRef = (0,react.useRef)(null);
    const [productData, setProductData] = (0,react.useState)({
        image: "",
        isFavorite: false
    });
    const [config, setConfig] = (0,react.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [badgesProps, setBadgesProps] = (0,react.useState)({});
    const { general ={}  } = config;
    const { newBadgeName ="" , saleBadgeName ="" , exclusiveBadgeName ="" , discontinuedBadgeName =""  } = general;
    const badgeTextObj = {
        new: newBadgeName,
        onSale: saleBadgeName,
        exclusive: exclusiveBadgeName,
        discontinued: discontinuedBadgeName
    };
    const staticTexts = (0,usePdpi18n/* default */.Z)("", badgeTextObj, "");
    (0,react.useEffect)(()=>{
        var ref;
        if (selectedProduct === skewId) myRef === null || myRef === void 0 ? void 0 : (ref = myRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    }, [
        selectedProduct,
        skewId,
        myRef,
        hotspotClicked
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            setConfig(config);
            var ref1;
            setSwatchUrl((ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.swatchUrl) !== null && ref1 !== void 0 ? ref1 : "");
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (skewId && !isEmpty_default()(config)) {
            const persona = (0,helper/* getUserPersona */.shu)();
            const { siteName: brandName = ""  } = {
                ...config === null || config === void 0 ? void 0 : config.general
            };
            const fl = flags(persona);
            setProductData({
                ...productData
            });
            try {
                var ref;
                var ref1;
                const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
                constants_api/* apim.get */.TH.get("/search/plp", {
                    params: {
                        fl: fl.join(","),
                        q: "*:*",
                        fq: [
                            'sku_s:("'.concat(skewId, '")'),
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: brandName.toLowerCase(),
                        profilename: "profile_".concat(brandName.toLowerCase(), "_General")
                    },
                    paramsSerializer: (params)=>{
                        return lib_default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    if (res && res.data) {
                        var ref, ref1, ref2;
                        var ref3;
                        const productData = (ref3 = (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs[0]) !== null && ref3 !== void 0 ? ref3 : {};
                        const { ctId_s: productId = "" , RegionReleaseforShipment_dt: releaseforShipmentDate = "" , ProductIsExclusive_s: productExclusive = ""  } = productData;
                        let imageId = "";
                        if (skewId.includes("-")) {
                            const skewIdPart = skewId.split("-");
                            const selectedVariant = skewIdPart.at(-1);
                            const imageData = productData["Color.TPR.Details_ss"].find((str)=>str.includes("-".concat(selectedVariant))).split("/");
                            imageId = imageData[imageData.length - 1];
                        }
                        const favoriteItem = favorites === null || favorites === void 0 ? void 0 : (ref2 = favorites.lineItems) === null || ref2 === void 0 ? void 0 : ref2.find((favorite)=>favorite.productId === productId);
                        const isFavorite = favoriteItem ? true : false;
                        const { currencySign =""  } = {
                            ...config === null || config === void 0 ? void 0 : config.internationalization
                        };
                        var ref4;
                        const badgesProps = {
                            isNewProduct: (0,helper/* showNewBadge */.ZTk)(releaseforShipmentDate),
                            badgeVal: (ref4 = productData["priceList.".concat(persona, ".saleOffer_s")]) !== null && ref4 !== void 0 ? ref4 : "",
                            exclusiveBadge: productExclusive
                        };
                        setBadgesProps(badgesProps);
                        setProductData({
                            ...productData,
                            imageId,
                            currencySign,
                            isFavorite
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.error("Error occured while fetching product data");
                    }
                });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Error occured while fetching product data", err);
            }
        }
    }, [
        config,
        favorites,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        setToasterMessage();
    }, [
        toaster
    ]);
    const setToasterMessage = async ()=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,helper/* getShortenedUrl */.Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,helper/* getShortenedUrl */.Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        const { ctId_s: productId = "" , isFavorite =false  } = productData;
        window.preActiveElement = e.target;
        e.stopPropagation();
        e.preventDefault();
        if (isFavorite) {
            var ref;
            const favProduct = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((fav)=>fav.productId === productId);
            if (favProduct) {
                if (!isAuth) {
                    handleLogin(e);
                } else {
                    dispatch((0,favoritesSlice/* removeItems */.Er)([
                        productId
                    ])).unwrap().then(()=>{
                        const productInfo = getProductInfo({
                            productData,
                            skewId,
                            needsJSON: false,
                            cart,
                            config,
                            description,
                            persona
                        });
                        (0,ShopTheRoomCard_analytics/* addAnalyticsEventForFavouriteAddRemove */.Xc)(false, productInfo);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: toasterContent.unfavoriteSuccessMessage || t("kf.favorites.removeItem"),
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: t("kf.favorites.removeItemError"),
                            isVisible: true
                        }));
                    });
                }
            }
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,favoritesSlice/* addProduct */.gK)(skewId)).unwrap().then(()=>{
                    const productInfo = getProductInfo({
                        productData,
                        skewId,
                        needsJSON: false,
                        cart,
                        config,
                        description,
                        persona
                    });
                    (0,ShopTheRoomCard_analytics/* addAnalyticsEventForFavouriteAddRemove */.Xc)(true, productInfo);
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: toasterContent.successMessage || t("kf.favorites.success"),
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: t("kf.favorites.error"),
                        isVisible: true
                    }));
                });
            }
        }
    };
    const { slug_s: slug = "" , currencySign ="" , imageId ="" , Product_Category: productCategory = "" , productName_s: productName = "" , isFavorite =false  } = productData;
    let { ProductDescriptionProductShort_s: description = ""  } = productData;
    const name = productName ? productName.split(" ").slice(" ")[0] : "";
    const persona = (0,helper/* getUserPersona */.shu)();
    var ref;
    const price = Number((ref = productData["priceList.".concat(persona, ".price_d")]) !== null && ref !== void 0 ? ref : 0).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const isMobile =  true ? window.matchMedia("(max-width: 1038px)").matches : 0;
    description = getDescriptionWithElipsis(isMobile, description);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(productData) && slug) {
            (0,helper/* getPDPUrl */.ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
        }
    }, [
        productData,
        slug
    ]);
    const getBadgeText = ()=>{
        const { isNewProduct ="" , exclusiveBadge ="" , badgeVal =""  } = badgesProps;
        const { new: newItem = "" , newExclusive ="" , exclusive ="" , sale =""  } = staticTexts;
        const badgeTxt = isNewProduct ? exclusiveBadge ? newExclusive : newItem : exclusiveBadge ? exclusive : badgeVal ? sale : "";
        return badgeTxt === null || badgeTxt === void 0 ? void 0 : badgeTxt.toUpperCase();
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: myRef,
        className: (Hotspot_index_module_default()).hotspotProductCardWraper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "hotspotProductCard",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: ()=>(0,ShopTheRoomCard_analytics/* shopRoomhandleProductClick */.dv)({
                        productData,
                        sku: skewId,
                        url: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : "", "}"),
                        cart,
                        config,
                        description,
                        persona
                    }),
                href: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hotspotProductContainer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "imageContainer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "imageCard",
                                    alt: "",
                                    src: (ref1 = (0,utils/* getPresetUrl */.v$)(width, 0, swatchUrl, imageId, presetConfig)) !== null && ref1 !== void 0 ? ref1 : image_missing/* default */.Z,
                                    onError: (e)=>e.target.src = image_missing/* default */.Z
                                }),
                                isFavoriteIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-tile__share",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        id: "kf-add-to-fav-".concat(skewId),
                                        className: "product-tile__share-icon",
                                        tabIndex: "0",
                                        onClick: handleFavorite,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "presentation",
                                            src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                                            alt: ""
                                        })
                                    })
                                }) : null
                            ]
                        }),
                        isDefaultProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "detailsContainer",
                            children: [
                                getBadgeText() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "badgeTextContaoner",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "textStyle",
                                        children: getBadgeText()
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "titleContainer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "name",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "price",
                                            children: "".concat(currencySign).concat(price)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "descriptionContainer",
                                    children: description
                                })
                            ]
                        }) : null
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Hotspot = (Hotspot_ProductCard);

;// CONCATENATED MODULE: ./public/icons/plus-button-shop.svg
/* harmony default export */ var plus_button_shop = ({"src":"/_next/static/media/plus-button-shop.96993e9b.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./public/icons/hotspot-button-small.svg
/* harmony default export */ var hotspot_button_small = ({"src":"/_next/static/media/hotspot-button-small.9baab6bb.svg","height":30,"width":30});
// EXTERNAL MODULE: ./components/ShopTheRoomDetail/v1/index.module.scss
var ShopTheRoomDetail_v1_index_module = __webpack_require__(95179);
var ShopTheRoomDetail_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(ShopTheRoomDetail_v1_index_module);
// EXTERNAL MODULE: ./components/ShopTheRoomCard/v1/ShopTheRoomCardModalView.jsx
var ShopTheRoomCardModalView = __webpack_require__(90746);
// EXTERNAL MODULE: ./components/ShopTheRoomDetail/v1/modal.module.scss
var modal_module = __webpack_require__(98609);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/ShopTheRoomDetail/v1/ShopTheRoomToaster.jsx







const ShopTheRoomToaster = (param)=>{
    let { isOpen , onClose , skuIds , presetConfigs , modalTitle , modalDesc , modalCtaTitle , setIsModalOpen , modalCtaLink , linkNewTabToaster , enableFavorite  } = param;
    const modalElement = (0,react.useRef)();
    (0,react.useEffect)((e)=>{
        const clickHandler = (e)=>{
            if (!modalElement.current) {
                return;
            }
            if (!modalElement.current.contains(e.target)) {
                setIsModalOpen(false);
            }
        };
        document.addEventListener("click", clickHandler, true);
        return ()=>document.removeEventListener("click", clickHandler);
    }, []);
    return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: modalElement,
            className: (modal_module_default()).modalWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "close-button",
                    alt: "close",
                    src: icons_close/* default */.Z,
                    onClick: ()=>onClose("modal")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content-div",
                        style: {
                            overflow: "auto"
                        },
                        children: [
                            modalTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-title",
                                children: (0,html_react_parser/* default */.ZP)(modalTitle)
                            }) : null,
                            modalCtaTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cta-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noreferrer",
                                    target: linkNewTabToaster ? "_blank" : "_self",
                                    href: modalCtaLink,
                                    className: "modal-cta",
                                    children: modalCtaTitle
                                })
                            }) : null,
                            modalDesc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-description",
                                children: (0,html_react_parser/* default */.ZP)(modalDesc)
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-products",
                                children: skuIds === null || skuIds === void 0 ? void 0 : skuIds.map((sku, id)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                                        isFavoriteIcon: enableFavorite,
                                        isDefaultProductCard: false,
                                        toasterVar: true,
                                        authorData: {
                                            skewId: sku,
                                            presetConfigs: presetConfigs
                                        }
                                    }, sku);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var v1_ShopTheRoomToaster = (ShopTheRoomToaster);

// EXTERNAL MODULE: ./components/ShopTheRoomDetail/v1/overlay.module.scss
var overlay_module = __webpack_require__(31201);
var overlay_module_default = /*#__PURE__*/__webpack_require__.n(overlay_module);
;// CONCATENATED MODULE: ./components/ShopTheRoomDetail/v1/Overlay.jsx



const Overlay = (param)=>{
    let { isOpen  } = param;
    (0,react.useEffect)(()=>{
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [
        isOpen
    ]);
    return isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (overlay_module_default()).overlayWrapper,
        children: "Overlay"
    });
};
/* harmony default export */ var v1_Overlay = (Overlay);

;// CONCATENATED MODULE: ./components/ShopTheRoomDetail/v1/ShopTheRoomDetail.jsx















const ShopTheRoomDetail = (param)=>{
    let { data: authorData  } = param;
    const { cardTitle ="" , cardDescription ="" , actions =[] , productsLabel ="" , hideProductsLabel ="" , cardFirstImage ="" , cardSecondImage ="" , productsView ="" , skuIds =[] , presetConfigs , modalTitle ="" , modalDesc ="" , modalCTATitle ="" , modalCTALink ="" , linkNewTabToaster ="" , enableFavorite =false  } = authorData;
    const popCardDefaultValues = {
        visible: false,
        top: 0,
        left: 0,
        skuId: "",
        index: -1
    };
    const firstImageHotspots = cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.hotspots;
    const secondImageHotspots = cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.hotspots;
    const [viewMoreToggle, setViewMoreToggle] = (0,react.useState)(false);
    const [showHotspots, setShowHotSpots] = (0,react.useState)(false);
    const [invokedFrom, setInvokedFrom] = (0,react.useState)("button");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const imageContainer = (0,react.useRef)(null);
    const [i, setI] = (0,react.useState)(0);
    const [x0, setX0] = (0,react.useState)(null);
    const [locked, setLocked] = (0,react.useState)(false);
    const [tx, setTx] = (0,react.useState)("");
    const [N, setN] = (0,react.useState)(1);
    const [toggle, setToggle] = (0,react.useState)(false);
    const [selectedProduct, setSelectedProduct] = (0,react.useState)("");
    const [hotspotClicked, setHotspotClicked] = (0,react.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [firstImageActive, setFirstImageActive] = (0,react.useState)(null);
    const firstImageContainerRef = (0,react.useRef)(null);
    const secondImageContainerRef = (0,react.useRef)(null);
    const [firstImagePopup, setFirstImagePopup] = (0,react.useState)({
        ...popCardDefaultValues
    });
    const [secondImagePopup, setSecondImagePopup] = (0,react.useState)({
        ...popCardDefaultValues
    });
    const [dataValShop, setDataValShop] = (0,react.useState)("");
    let isMobile;
    if (true) {
        isMobile = window.innerWidth <= 1037;
    }
    const removeHtmlExtension = async ()=>{
        const newDataShop = await (0,helper/* getShortenedUrl */.Ppy)(cardDescription);
        setDataValShop(newDataShop);
    };
    (0,react.useEffect)(()=>{
        if (cardDescription) {
            removeHtmlExtension();
        }
    }, [
        cardDescription
    ]);
    (0,react.useEffect)(()=>{
        if (isMobile) {
            const imageParent = imageContainer.current;
            const actualN = imageParent.children.length;
            setN(actualN);
        }
    }, [
        isMobile
    ]);
    const unify = (e)=>{
        return e.changedTouches ? e.changedTouches[0] : e;
    };
    const hotspotClass = "hotspotsmallimg ".concat(showHotspots ? "" : "hidden");
    (0,react.useEffect)(()=>{
        if (!viewMoreToggle) {
            setSelectedProduct("");
        }
    }, [
        viewMoreToggle
    ]);
    const handleModalToggle = (from)=>{
        if (from === "ViewMore") {
            setIsModalOpen(true);
        } else {
            setIsModalOpen(false);
        }
    };
    const handleMove = (e)=>{
        if (locked) {
            const dx = unify(e).clientX - x0;
            const s = Math.sign(dx);
            let tempI = i;
            if ((tempI > 0 || s < 0) && (tempI < N - 1 || s > 0)) tempI -= s;
            setI(tempI);
            setTx("0px");
            setLocked(false);
            setToggle(true);
            setX0(null);
        }
    };
    const hanldeDrag = (e)=>{
        e.preventDefault();
        if (locked) setTx("".concat(Math.round(unify(e).clientX - x0), "px"));
    };
    const hanldeLock = (e)=>{
        setX0(unify(e).clientX);
        setLocked(true);
        setToggle(false);
    };
    const handleViewMore = ()=>{
        setShowHotSpots(!showHotspots);
        if (productsView !== "cardView") {
            setViewMoreToggle(!viewMoreToggle);
        }
        handleModalToggle("ViewMore");
    };
    const handleHotspotClick = (skuId)=>{
        setHotspotClicked(!hotspotClicked);
        setSelectedProduct(skuId);
    };
    const handleImageIconClick = (e, skuId, index, imageType)=>{
        var ref;
        if (imageType === "first" && (firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.index) === index) {
            setFirstImagePopup({
                ...firstImagePopup,
                visible: false,
                index: -1
            });
            return;
        }
        if (imageType === "second" && (secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.index) === index) {
            setSecondImagePopup({
                ...firstImagePopup,
                visible: false,
                index: -1
            });
            return;
        }
        let parentRect;
        if (imageType === "first") {
            var ref1;
            parentRect = (ref1 = firstImageContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
        }
        if (imageType === "second") {
            var ref2;
            parentRect = (ref2 = secondImageContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.getBoundingClientRect();
        }
        const icon = (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        const parentHeight = parentRect.height;
        const parentWidth = parentRect.width;
        const popupWidth = 250;
        const popupHeight = 384;
        const margin = 1;
        const positions = [
            {
                top: icon.top - parentRect.top - popupHeight - margin,
                left: icon.left - parentRect.left
            },
            {
                top: icon.top - parentRect.top,
                left: icon.right - parentRect.left + margin
            },
            {
                top: icon.bottom - parentRect.top + margin,
                left: icon.left - parentRect.left
            },
            {
                top: icon.top - parentRect.top,
                left: icon.left - parentRect.left - popupWidth - margin
            }
        ];
        let finalPosition = positions.find((pos)=>{
            if (pos.top >= 0 && pos.top + popupHeight <= parentHeight && pos.left >= 0 && pos.left + popupWidth <= parentWidth) {
                return true;
            } else {
                return false;
            }
        });
        if (!finalPosition) {
            finalPosition = positions.reduce((bestPos, pos)=>{
                const overflowX = Math.max(0, pos.left + popupWidth - parentWidth) + Math.max(0, -pos.left);
                const overflowY = Math.max(0, pos.top + popupHeight - parentHeight) + Math.max(0, -pos.top);
                const overflow = overflowX + overflowY;
                return overflow < bestPos.overflow ? {
                    ...pos,
                    overflow
                } : bestPos;
            }, {
                overflow: Infinity
            });
        }
        if (Math.sign(finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.top) === -1) {
            finalPosition.top = 1;
        }
        if (finalPosition.left + 250 > parentWidth) {
            const gap = finalPosition.left + 250 - parentWidth;
            finalPosition.left = finalPosition.left - gap;
        }
        if (Math.sign(finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.left) === -1) {
            finalPosition.left = 1;
        }
        if (finalPosition.top + 352 > parentHeight) {
            const gap1 = finalPosition.top + 352 - parentHeight;
            finalPosition.top = finalPosition.top - gap1;
        }
        if (imageType === "first") {
            setFirstImagePopup({
                visible: true,
                top: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.top,
                left: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.left,
                skuId,
                index
            });
        }
        if (imageType === "second") {
            setSecondImagePopup({
                visible: true,
                top: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.top,
                left: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.left,
                skuId,
                index
            });
        }
    };
    const hadleHotspotImgeOutSideClick = function() {
        let imageTyep = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const popObj = {
            visible: false,
            top: 0,
            left: 0,
            skuId: "",
            index: -1
        };
        if (imageTyep === "first") {
            setFirstImagePopup({
                ...popObj
            });
        }
        if (imageTyep === "second") {
            setSecondImagePopup({
                ...popObj
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ShopTheRoomDetail_v1_index_module_default()).shopTheRoomDetailWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "shop-the-room-detail-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-images-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-the-room-detail-text-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "shop-the-room-detail-textbox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-title",
                                        children: cardTitle ? (0,html_react_parser/* default */.ZP)(cardTitle) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-description",
                                        children: cardDescription ? (0,html_react_parser/* default */.ZP)(dataValShop) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ctas-box",
                                        children: actions === null || actions === void 0 ? void 0 : actions.map((item, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                rel: "noreferrer",
                                                target: (item === null || item === void 0 ? void 0 : item.newTab) === "true" ? "_blank" : "_self",
                                                href: item === null || item === void 0 ? void 0 : item.url,
                                                children: item === null || item === void 0 ? void 0 : item.title
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "shop-the-room-detail-icon-label-container",
                                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "view-more-products-button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "view-more-button-text",
                                                role: "button",
                                                onClick: ()=>setViewMoreToggle(!viewMoreToggle),
                                                children: viewMoreToggle ? (0,html_react_parser/* default */.ZP)(hideProductsLabel) : (0,html_react_parser/* default */.ZP)(productsLabel)
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "view-more-products-button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    onClick: handleViewMore,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: plus_button_shop,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "view-more-button-text",
                                                    children: viewMoreToggle ? (0,html_react_parser/* default */.ZP)(hideProductsLabel) : (0,html_react_parser/* default */.ZP)(productsLabel)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-the-room-detail-image-container",
                            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "swipe-image ".concat(toggle ? "smooth" : ""),
                                style: {
                                    "--n": N,
                                    "--i": i,
                                    "--tx": tx
                                },
                                ref: imageContainer,
                                onTouchStart: hanldeLock,
                                onMouseMove: hanldeDrag,
                                onTouchMove: hanldeDrag,
                                onTouchEnd: handleMove,
                                children: [
                                    cardFirstImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                        url: cardFirstImage.imageLink,
                                        altText: "",
                                        smartCrop: smartCrop
                                    }),
                                    cardSecondImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                        url: cardSecondImage.imageLink,
                                        altText: "",
                                        smartCrop: smartCrop
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    cardFirstImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "first-image-container",
                                        style: {
                                            position: "relative"
                                        },
                                        ref: firstImageContainerRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                url: cardFirstImage.imageLink,
                                                altText: cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.altText,
                                                smartCrop: smartCrop,
                                                handleImgeClick: ()=>{
                                                    hadleHotspotImgeOutSideClick("first");
                                                }
                                            }),
                                            productsView !== "toasterView" && (firstImageHotspots === null || firstImageHotspots === void 0 ? void 0 : firstImageHotspots.map((hotspot, index)=>{
                                                const xCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[0]);
                                                const width = JSON.parse(cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.width);
                                                const xCoordinate = xCord / width * 100;
                                                const yCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[1]);
                                                const height = JSON.parse(cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.height);
                                                const yCoordinate = yCord / height * 100;
                                                const skuId = hotspot === null || hotspot === void 0 ? void 0 : hotspot.skuId;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        position: "absolute",
                                                        left: "calc(".concat(xCoordinate, "% - 20px)"),
                                                        top: "calc(".concat(yCoordinate, "%  - 20px)")
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: hotspot_button_small,
                                                        alt: "",
                                                        className: hotspotClass,
                                                        onClick: (e)=>{
                                                            if (productsView === "cardView") {
                                                                handleImageIconClick(e, skuId, index, "first");
                                                            } else {
                                                                handleHotspotClick(skuId);
                                                            }
                                                            setInvokedFrom("");
                                                            setFirstImageActive(firstImageActive === index ? null : index);
                                                        }
                                                    })
                                                }, "".concat(skuId));
                                            })),
                                            (firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.visible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-popup",
                                                style: {
                                                    left: "".concat(firstImagePopup.left, "px"),
                                                    top: "".concat(firstImagePopup.top, "px")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotspot, {
                                                    authorData: {
                                                        skewId: firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.skuId,
                                                        presetConfigs: presetConfigs
                                                    },
                                                    selectedProduct: selectedProduct,
                                                    hotspotClicked: hotspotClicked
                                                }, firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.skuId)
                                            }) : ""
                                        ]
                                    }),
                                    cardSecondImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "second-image-container",
                                        style: {
                                            position: "relative"
                                        },
                                        ref: secondImageContainerRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                url: cardSecondImage.imageLink,
                                                altText: cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.altText,
                                                smartCrop: smartCrop,
                                                handleImgeClick: ()=>{
                                                    hadleHotspotImgeOutSideClick("second");
                                                }
                                            }),
                                            productsView !== "toasterView" ? secondImageHotspots === null || secondImageHotspots === void 0 ? void 0 : secondImageHotspots.map((hotspot, index)=>{
                                                const xCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[0]);
                                                const width = JSON.parse(cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.width);
                                                const xCoordinate = xCord / width * 100;
                                                const yCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[1]);
                                                const height = JSON.parse(cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.height);
                                                const yCoordinate = yCord / height * 100;
                                                const skuId = hotspot === null || hotspot === void 0 ? void 0 : hotspot.skuId;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        position: "absolute",
                                                        left: "calc(".concat(xCoordinate, "% - 20px)"),
                                                        top: "calc(".concat(yCoordinate, "%  - 20px)")
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: hotspot_button_small,
                                                        alt: "",
                                                        className: hotspotClass,
                                                        onClick: (e)=>{
                                                            if (productsView === "cardView") {
                                                                handleImageIconClick(e, skuId, index, "second");
                                                            } else {
                                                                handleHotspotClick(skuId);
                                                            }
                                                            setInvokedFrom("");
                                                        }
                                                    })
                                                }, "".concat(skuId));
                                            }) : null,
                                            (secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.visible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-popup",
                                                style: {
                                                    left: "".concat(secondImagePopup.left, "px"),
                                                    top: "".concat(secondImagePopup.top, "px")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotspot, {
                                                    authorData: {
                                                        skewId: secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.skuId,
                                                        presetConfigs: presetConfigs
                                                    },
                                                    selectedProduct: selectedProduct,
                                                    hotspotClicked: hotspotClicked
                                                }, secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.skuId)
                                            }) : ""
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                viewMoreToggle && productsView === "stackView" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "view-more-products-container",
                    children: skuIds.map((sku, id)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                            isFavoriteIcon: enableFavorite,
                            authorData: {
                                skewId: sku,
                                presetConfigs: presetConfigs
                            },
                            selectedProduct: selectedProduct,
                            hotspotClicked: hotspotClicked
                        }, sku);
                    })
                }),
                viewMoreToggle && productsView === "carouselView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopTheRoomCardModalView["default"], {
                    skuIds: skuIds,
                    presetConfigs: presetConfigs,
                    isModal: false,
                    selectedProduct: selectedProduct,
                    hotspotClicked: hotspotClicked,
                    setHotspotClicked: setHotspotClicked,
                    invokedFrom: invokedFrom,
                    setInvokedFrom: setInvokedFrom
                }),
                !isMobile && isModalOpen && productsView === "toasterView" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShopTheRoomToaster, {
                    enableFavorite: enableFavorite,
                    modalTitle: modalTitle,
                    modalDesc: modalDesc,
                    modalCtaLink: modalCTALink,
                    modalCtaTitle: modalCTATitle,
                    setIsModalOpen: setIsModalOpen,
                    isOpen: isModalOpen,
                    onClose: handleModalToggle,
                    cardTitle: cardTitle,
                    skuIds: skuIds,
                    presetConfigs: presetConfigs,
                    linkNewTabToaster: linkNewTabToaster
                }) : null,
                !isMobile && productsView === "toasterView" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Overlay, {
                    isOpen: isModalOpen,
                    viewMore: viewMoreToggle
                }) : null
            ]
        })
    });
};
/* harmony default export */ var v1_ShopTheRoomDetail = (ShopTheRoomDetail);

// EXTERNAL MODULE: ./components/RoomDetailPage/v1/index.module.scss
var RoomDetailPage_v1_index_module = __webpack_require__(81881);
var RoomDetailPage_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(RoomDetailPage_v1_index_module);
;// CONCATENATED MODULE: ./components/RoomDetailPage/v1/RoomDetailPage.jsx







const RoomDetailPage = (param)=>{
    let { data: authorData  } = param;
    const { skuIds =[] , imageRight ="false" , landingImageLink ="" , presetConfigs ="{}" , title ="" , description ="" , enableFavorite =false , imageAltText =""  } = authorData;
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const noOfProducts = skuIds.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RoomDetailPage_v1_index_module_default()).roomDetailWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "room-detail-parent-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "room-detail-product-detail".concat(imageRight === "true" ? "__align-right" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-image-container\n             ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "room-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "product-count",
                                        children: [
                                            noOfProducts,
                                            " Products"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        class: "product-info",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "title",
                                                children: title ? (0,html_react_parser/* default */.ZP)(title) : null
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "description",
                                                children: description ? (0,html_react_parser/* default */.ZP)(description) : null
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                    url: landingImageLink,
                                    altText: imageAltText,
                                    smartCrop: smartCrop
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products-container",
                        children: skuIds.length > 0 ? skuIds.map((skuId, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                                isFavoriteIcon: enableFavorite,
                                authorData: {
                                    skewId: skuId,
                                    presetConfigs
                                },
                                isDefaultProductCard: false
                            }, "product-tile-".concat(skuId, "-").concat(index))) : null
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_RoomDetailPage = (RoomDetailPage);

// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx + 3 modules
var ProductCardForUpsell = __webpack_require__(54075);
// EXTERNAL MODULE: ./utils/ComponentImport.js
var ComponentImport = __webpack_require__(75227);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/FindAProResults/v1/analytics/constanst.js
const FIND_A_PRO_RESULTS = "find a pro results";
const FIND_A_PRO_STICKY_NAV = "sticky nav links";

;// CONCATENATED MODULE: ./components/FindAProResults/v1/analytics/index.js

const getProResultListEventInfo = (data)=>{
    const { phone ="" , url ="" , partnerName ="" , isEmail =false , needLocationFinderType =false , isForServiceProvider =false , staticTexts ={} , selectedMenu ="" , serviceProviderType =""  } = data;
    const sleectedMenuName = selectedMenu ? selectedMenu : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers;
    const internalLinkName = isEmail ? "services@kohler.com" : phone || partnerName;
    const type = phone ? "contact " + (isEmail ? "email" : "number") : isForServiceProvider ? "results" : partnerName;
    let internalLinkType = "find a pro results:navigation";
    if (phone) internalLinkType = "find a pro results:contact:".concat(partnerName, ":").concat(sleectedMenuName === null || sleectedMenuName === void 0 ? void 0 : sleectedMenuName.toLowerCase());
    if (needLocationFinderType) internalLinkType = "find a pro results:".concat(sleectedMenuName === null || sleectedMenuName === void 0 ? void 0 : sleectedMenuName.toLowerCase());
    const serviceProviderName = (serviceProviderType === null || serviceProviderType === void 0 ? void 0 : serviceProviderType.toLowerCase()) || "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(FIND_A_PRO_RESULTS, ":").concat(FIND_A_PRO_STICKY_NAV, ":").concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.toLowerCase(), ":").concat(phone || type),
        eventName: "".concat(FIND_A_PRO_RESULTS, ":").concat(FIND_A_PRO_STICKY_NAV, ":").concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.toLowerCase(), ":").concat(phone || type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: FIND_A_PRO_RESULTS,
        internalLinkType,
        internalLinkURL: window.eventPageType === "find a pro results" ? "tel:" + phone : url || "n/a",
        internalLinkZoneName: "".concat(FIND_A_PRO_RESULTS, ":").concat(serviceProviderName)
    };
    const page = window.pageObj || {};
    const datalayerObj = {
        event: "cmp:click",
        eventInfo,
        page
    };
    window.adobeDataLayer.push(datalayerObj);
};


;// CONCATENATED MODULE: ./components/FindAProResults/v1/ProfessionalsList/index.jsx




const ProfessionalsList = (props)=>{
    var ref;
    const { data ={} , staticTexts ="" , swatchUrl ="" , selectedMenu ="" , serviceProviderType =""  } = props;
    const { Phone: phone = "" , LocationName: locationName = "" , AddressLine: addressLine , AddressLine2: addressLine2 = "" , Locality: locality = "" , AdminDistrict: adminDistrict = "" , PostalCode: postalCode = "" , __Distance: distance = "" , LogoIMG: logoIMG = "" , SpecGeneral: specGeneral = "" , SpecIntelligentToilets: specIntelligentToilets = "" , SpecDigitalShowering: specDigitalShowering = "" , SpecLighting: specLighting , SpecKohlerConnected: specKohlerConnected = "" , SpecShowerDoors: specShowerDoors = "" , Email: email = ""  } = data;
    const handleConatctDetalisClick = (isEmail, url)=>getProResultListEventInfo({
            phone: phone,
            url: "mailto:".concat(url),
            partnerName: locationName.toLowerCase(),
            isEmail: isEmail,
            needLocationFinderType: false,
            staticTexts: staticTexts,
            selectedMenu: selectedMenu,
            serviceProviderType: serviceProviderType
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "find-pro-results__content-section",
        role: "listitem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "find-pro-results__content-section__space",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-sm-6 col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-name",
                                        role: "heading",
                                        level: "3",
                                        children: locationName.toLowerCase()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-rating"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "profile-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "partner-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "partner-address",
                                                children: [
                                                    addressLine.toLowerCase(),
                                                    addressLine2 ? ", " + addressLine2.toLowerCase() : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "partner-address",
                                                children: [
                                                    locality ? locality.toLowerCase() + ", " : "",
                                                    adminDistrict,
                                                    " ",
                                                    postalCode
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "miles-away",
                                                children: "(".concat(distance.toFixed(1), " mi away)")
                                            })
                                        ]
                                    }),
                                    logoIMG ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "partner-photography",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat(swatchUrl, "/").concat(logoIMG),
                                            alt: "logo"
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-sm-6 col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                specGeneral || specIntelligentToilets || specDigitalShowering || specLighting || specKohlerConnected || specShowerDoors ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-sm-12 col-md-12 col-lg-6 speciality",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "speciality-title",
                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.specialtiesTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "speciality-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    specGeneral ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecGeneral
                                                    }) : "",
                                                    specIntelligentToilets ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecIntelligentToilets
                                                    }) : "",
                                                    specDigitalShowering ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecDigitalShowering
                                                    }) : "",
                                                    specLighting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecLighting
                                                    }) : "",
                                                    specKohlerConnected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecKohlerConnected
                                                    }) : "",
                                                    specShowerDoors ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecShowerDoors
                                                    }) : ""
                                                ]
                                            })
                                        })
                                    ]
                                }) : null,
                                email || phone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-sm-12 col-md-12 col-lg-6 contact",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "contact-title",
                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.contactTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "contact-details",
                                            children: [
                                                email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "email",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "mailto:".concat(email),
                                                        onClick: ()=>handleConatctDetalisClick(true, email),
                                                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ariaLabel.email(locationName, email),
                                                        children: email
                                                    })
                                                }) : null,
                                                phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "phone",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(phone),
                                                        onClick: ()=>handleConatctDetalisClick(false, phone),
                                                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.phone(locationName, phone),
                                                        children: phone
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_ProfessionalsList = (ProfessionalsList);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/DesignerList/index.jsx





const DesignerList = (props)=>{
    const contactRef = (0,react.useRef)(null);
    const { data ={} , staticTexts ="" , selectedMenu ="" , serviceProviderType =""  } = props;
    const { proName ="" , address ="" , jobTitle ="" , available ="" , duration ="" , image ="" , specialties ="" , contactInfo =""  } = data;
    (0,react.useEffect)(()=>{
        if (contactInfo) {
            if (contactRef.current) {
                const links = contactRef.current.querySelectorAll("a");
                links.forEach((link)=>{
                    link.classList.add("gbh-data-layer");
                    const phone = link.textContent;
                    const url = link.getAttribute("href");
                    const isEmail = url.includes("mailto");
                    link.setAttribute("data-gbh-data-layer", getProResultListEventInfo({
                        phone: phone,
                        url: url,
                        partnerName: proName,
                        isEmail: isEmail,
                        staticTexts: staticTexts,
                        selectedMenu: selectedMenu,
                        serviceProviderType: serviceProviderType
                    }));
                });
            }
        }
    }, [
        data
    ]);
    const clickHandler = ()=>{
        var ref;
        getProResultListEventInfo({
            phone: null,
            url: (ref = data["detail-page-link"]) !== null && ref !== void 0 ? ref : "/",
            partnerName: proName,
            isEmail: false,
            needLocationFinderType: true,
            isForServiceProvider: true,
            staticTexts: staticTexts,
            selectedMenu: selectedMenu,
            serviceProviderType: serviceProviderType
        });
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "find-pro-results__content-section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: clickHandler,
            href: (ref = data["detail-page-link"]) !== null && ref !== void 0 ? ref : "/",
            className: "gbh-data-layer find-pro-results__designer-link ".concat(data["detail-page-link"] ? "link-added" : "link-removed"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__content-section__space",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-6 col-md-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 col-sm-12 col-md-12 px-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-name",
                                                role: "heading",
                                                level: "3",
                                                children: proName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-rating"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "profile-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "partner-details",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-address",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(address)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-designation",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(jobTitle)
                                                    }),
                                                    available === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "available-btn",
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": staticTexts.availableCTA,
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.availableCTA)
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "available-duration",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(duration)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "partner-photography",
                                                children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: image,
                                                    alt: staticTexts.userAlt
                                                }) : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-6 col-md-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row mx-0",
                                children: [
                                    (specialties === null || specialties === void 0 ? void 0 : specialties.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 col-sm-12 col-md-12 col-lg-6 speciality",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "speciality-title",
                                                children: staticTexts.specialtiesTxt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "speciality-details",
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(specialties)
                                            })
                                        ]
                                    }) : null,
                                    (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 col-sm-12 col-md-12 col-lg-6 contact",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "contact-title",
                                                children: staticTexts.contactTxt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "contact-details",
                                                ref: contactRef,
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(contactInfo)
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_DesignerList = (DesignerList);

// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var react_sticky_el_lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
;// CONCATENATED MODULE: ./components/FindAProResults/v1/analytics/helper.js
const getStickNavEventInfo = (linkName)=>{
    const menuName = linkName === null || linkName === void 0 ? void 0 : linkName.toLowerCase();
    return {
        eventAction: "find a pro results:sticky nav links:".concat(menuName),
        eventName: "find a pro results:sticky nav links:".concat(menuName),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: menuName,
        internalLinkPosition: "find a pro results",
        internalLinkType: "find a pro results:navigation",
        internalLinkZoneName: "find a pro results:sticky nav links",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
};
const addAnalyticsData = (count, zipcodeVal)=>{
    const eventInfo = {
        searchCount: sessionStorage.getItem("proSearches") ? Number(sessionStorage.getItem("proSearches")) + 1 : 1,
        searchResult: count,
        searchTerm: zipcodeVal
    };
    sessionStorage.setItem("proSearches", eventInfo.searchCount);
    const showEvent = window.adobeDataLayer.find((item)=>item.event === "cmp:show");
    showEvent.eventInfo = eventInfo;
};
const addDataLayerOnMenuItemClick = (linkName)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = getStickNavEventInfo(linkName);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getEventInfoForFindAproResultsView = (linkUrl, isForBathroom)=>{
    const type = isForBathroom ? "main content area:bathroom design services" : "hero:change location";
    const internalLinkName = isForBathroom ? "bathroom design services" : "change location";
    const zoneName = isForBathroom ? "main content area​" : "hero";
    const internalLinkType = "find a pro results:navigation";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "find a pro results:".concat(type),
        eventName: "find a pro results:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "find a pro results",
        internalLinkType,
        internalLinkURL: linkUrl,
        internalLinkZoneName: "find a pro results:".concat(zoneName)
    });
};

;// CONCATENATED MODULE: ./components/FindAProResults/v1/NoResults/index.jsx



const NoResults = (props)=>{
    const { professionalcount , brandName , findAProbyZipPagePath , zipcodeVal , staticTexts , subMenusRef , dataList , visibleSection , designersRef , handleMenuClick , handleKeyPress , bathroomDesignServiceLinkRef  } = props;
    const bathroomDesignConsultText = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.bathroomDesignConsultText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__local-professional-details",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "local-professional-count",
                        children: [
                            "Showing ".concat(professionalcount, " professionals near "),
                            brandName === "sterling" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                tabIndex: "0",
                                className: "local-professional-count",
                                href: findAProbyZipPagePath,
                                children: zipcodeVal
                            }) : zipcodeVal,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                id: "request-change-location",
                                tabIndex: "0",
                                className: "change-location",
                                href: findAProbyZipPagePath,
                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.changeLocationText
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__sub-navigation",
                ref: subMenusRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "menubar",
                        children: [
                            dataList.map((smenu, index)=>{
                                var ref;
                                return ((ref = smenu.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && smenu.section !== "Designers" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "header_link ".concat(visibleSection === smenu.menuName ? "selected" : ""),
                                    onClick: ()=>handleMenuClick(smenu.ref.current, smenu.menuName),
                                    onKeyDown: (e)=>handleKeyPress(e, smenu.section),
                                    role: "menuitem",
                                    tabIndex: visibleSection === smenu.menuName ? 0 : -1,
                                    id: "section-".concat(smenu.section.toLowerCase()),
                                    children: smenu.menuName
                                }, index) : null;
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "header_link ".concat(visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? "selected" : ""),
                                onClick: ()=>{
                                    return handleMenuClick(designersRef.current, staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers);
                                },
                                onKeyDown: (e)=>handleKeyPress(e, "Designers"),
                                role: "menuitem",
                                tabIndex: visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? 0 : -1,
                                id: "section-designers",
                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__designer-section",
                id: "Designers",
                ref: designersRef,
                tabIndex: "-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "find-pro-results__container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-inline-block service-info",
                            ref: bathroomDesignServiceLinkRef,
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(bathroomDesignConsultText)
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_NoResults = (NoResults);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/FindAProResults.view.jsx











const FindAProResultsLanding = (props)=>{
    var ref, ref1;
    const { data ={} , zipcodeVal ="" , staticTexts ="" , designersData =[] , loading =false , findAProbyZipPagePath =""  } = props;
    const [visibleSection, setVisibleSection] = (0,react.useState)();
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const subMenusRef = (0,react.useRef)(null);
    const remodelersRef = (0,react.useRef)(null);
    const plumbersRef = (0,react.useRef)(null);
    const buildersRef = (0,react.useRef)(null);
    const architectRef = (0,react.useRef)(null);
    const designersRef = (0,react.useRef)(null);
    const bathroomDesignServiceLinkRef = (0,react.useRef)(null);
    const CONFIG = (0,constants_config/* getConfig */.i)();
    var ref2;
    const brandName = (ref2 = (ref = CONFIG.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref2 !== void 0 ? ref2 : "";
    const swatchUrl = CONFIG === null || CONFIG === void 0 ? void 0 : (ref1 = CONFIG.general) === null || ref1 === void 0 ? void 0 : ref1.swatchUrl;
    const bathroomDesServTimeout = 2000;
    const remodelersData = (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationRemodeler) !== "" && data && data.filter((item)=>item.LocationRemodeler === true);
    const plumbersinstallersData = ((staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationPlumber) !== "" || (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationInstaller) !== "") && data && data.filter((item)=>item.LocationPlumber === true);
    const buildersData = (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationBuilder) !== "" && data && data.filter((item)=>item.LocationBuilder === true);
    const architectData = data && data.filter((item)=>item.LocationArchitect === true);
    const designerData = data && data.filter((item)=>item.LocationDesigner === true);
    const dataList = [
        {
            section: "Remodelers",
            ref: remodelersRef,
            data: remodelersData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelers,
            sectionTitle: brandName === "sterling" ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelersSterlingTitleText : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelersTitleText
        },
        {
            section: "Installers & Plumbers",
            ref: plumbersRef,
            data: plumbersinstallersData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.plumbersInstallers,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.plumbersInstallersTitleText
        },
        {
            section: "Builders",
            ref: buildersRef,
            data: buildersData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.builders,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.buildersTitleText
        },
        {
            section: "Architect",
            ref: architectRef,
            data: architectData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.architect,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.architectTitleText
        },
        {
            section: "Designers",
            ref: designersRef,
            data: designerData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designersTitleText
        }
    ];
    (0,react.useEffect)(()=>{
        if (data && (data === null || data === void 0 ? void 0 : data.length) < 1) return;
        const handleScroll = ()=>{
            const { height: headerHeight  } = getDimensions(subMenusRef.current);
            const scrollPosition = window.scrollY + headerHeight;
            const selected = dataList.find((param)=>{
                let { ref  } = param;
                const ele = ref.current;
                if (ele) {
                    const { offsetBottom , offsetTop  } = getDimensions(ele);
                    return scrollPosition > offsetTop && scrollPosition < offsetBottom;
                }
            });
            if (!selected) {
                setVisibleSection(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelers);
            } else if (selected && selected.menuName !== visibleSection) {
                setVisibleSection(selected.menuName);
            }
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        staticTexts
    ]);
    const bathroomDesignText = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.bathroomDesignConsultText;
    const professionalcount = dataList.reduce((sum, curr)=>{
        return sum + curr.data.length;
    }, 0) + (designersData === null || designersData === void 0 ? void 0 : designersData.length);
    (0,react.useEffect)(()=>{
        if (loading === false) {
            addAnalyticsData(professionalcount, zipcodeVal);
        } else if (loading === null) {
            addAnalyticsData(0, zipcodeVal);
        }
    }, [
        loading
    ]);
    (0,react.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            var ref;
            const link = (ref = bathroomDesignServiceLinkRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("p > a");
            if (link) {
                link.classList.add("gbh-data-layer");
                link.setAttribute("data-gbh-data-layer", getEventInfoForFindAproResultsView(link.getAttribute("href"), true));
            }
        }, bathroomDesServTimeout);
        return ()=>clearTimeout(timeoutId);
    }, []);
    const scrollTo = (ele)=>{
        ele.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    const handleKeyPress = (e, section)=>{
        const menus = dataList.filter((item)=>{
            var ref;
            if (item.section === "Designers") {
                return item;
            } else if (((ref = item.data) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                return item;
            }
        });
        const curMenu = menus.findIndex((item)=>item.section === section);
        if (e.keyCode === 37 || e.keyCode === 39) {
            let tab;
            if (e.keyCode === 37) {
                tab = curMenu - 1;
            } else if (e.keyCode === 39) {
                tab = curMenu + 1;
            }
            if (tab < 0) tab = (menus === null || menus === void 0 ? void 0 : menus.length) - 1;
            if (tab >= (menus === null || menus === void 0 ? void 0 : menus.length)) tab = 0;
            document.getElementById("section-".concat(menus[tab].section.toLowerCase())).focus();
        } else if (e.keyCode === 9 && e.shiftKey && document.activeElement === document.getElementById("section-".concat(menus[0].section.toLowerCase()))) {
            e.preventDefault();
            document.getElementById("request-change-location").focus();
            return;
        }
    };
    const handleMenuClick = (menu, linkName)=>{
        scrollTo(menu);
        addDataLayerOnMenuItemClick(linkName);
    };
    if (loading) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "find-pro-results",
        children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-pro-results__local-professional-details",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "local-professional-count",
                            children: [
                                "Showing ".concat(professionalcount, " professionals near "),
                                brandName === "sterling" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    tabIndex: "0",
                                    className: "local-professional-count",
                                    href: findAProbyZipPagePath,
                                    children: zipcodeVal
                                }) : zipcodeVal,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "data-gbh-data-layer": getEventInfoForFindAproResultsView(findAProbyZipPagePath),
                                    id: "request-change-location",
                                    tabIndex: "0",
                                    className: "change-location",
                                    href: findAProbyZipPagePath,
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.changeLocationText
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_sticky_el_lib_default()), {
                    onFixedToggle: ()=>setNavSticky(!navSticky),
                    className: "product-list__sticky-nav-wrap",
                    stickyStyle: {
                        zIndex: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "find-pro-results__sub-navigation",
                        ref: subMenusRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "container kf-react-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                role: "menubar",
                                children: [
                                    dataList.map((smenu, index)=>{
                                        var ref;
                                        return ((ref = smenu.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && smenu.section !== "Designers" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header_link ".concat(visibleSection === smenu.menuName ? "selected" : ""),
                                            onClick: ()=>handleMenuClick(smenu.ref.current, smenu.menuName),
                                            onKeyDown: (e)=>handleKeyPress(e, smenu.section),
                                            role: "menuitem",
                                            tabIndex: visibleSection === smenu.menuName ? 0 : -1,
                                            id: "section-".concat(smenu.section.toLowerCase()),
                                            children: smenu === null || smenu === void 0 ? void 0 : smenu.menuName
                                        }, index) : null;
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header_link ".concat(visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? "selected" : ""),
                                        onClick: ()=>{
                                            return handleMenuClick(designersRef.current, staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers);
                                        },
                                        onKeyDown: (e)=>handleKeyPress(e, "Designers"),
                                        role: "menuitem",
                                        tabIndex: visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? 0 : -1,
                                        id: "section-designers",
                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: dataList.map((list, index)=>{
                        var ref;
                        return ((ref = list.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && list.data !== designerData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "find-pro-results__remodelers-section",
                            id: list.section,
                            ref: list.ref,
                            tabIndex: "-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container kf-react-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "find-pro-results__container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "find-pro-results__section-title",
                                            role: "heading",
                                            level: "2",
                                            children: list.sectionTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            role: "list",
                                            "aria-label": list.sectionTitle,
                                            children: list.data && list.data.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProfessionalsList, {
                                                    staticTexts: staticTexts,
                                                    data: item,
                                                    swatchUrl: swatchUrl,
                                                    selectedMenu: visibleSection,
                                                    serviceProviderType: list.sectionTitle
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        }, index) : null;
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-pro-results__designer-section",
                    id: "Designers",
                    ref: designersRef,
                    tabIndex: "-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "find-pro-results__container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    role: "list",
                                    "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sectionTitle,
                                    children: designersData.map((item, index)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(v1_DesignerList, {
                                            staticTexts: staticTexts,
                                            data: item,
                                            selectedMenu: visibleSection,
                                            serviceProviderType: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designersTitleText
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-inline-block service-info",
                                    ref: bathroomDesignServiceLinkRef,
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(bathroomDesignText)
                                })
                            ]
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_NoResults, {
            professionalcount: professionalcount,
            brandName: brandName,
            findAProbyZipPagePath: findAProbyZipPagePath,
            zipcodeVal: zipcodeVal,
            staticTexts: staticTexts,
            subMenusRef: subMenusRef,
            dataList: dataList,
            visibleSection: visibleSection,
            designersRef: designersRef,
            handleMenuClick: handleMenuClick,
            handleKeyPress: handleKeyPress,
            designersData: designersData,
            bathroomDesignServiceLinkRef: bathroomDesignServiceLinkRef
        })
    });
};
/* harmony default export */ var FindAProResults_view = ((0,lib/* withOrientationChange */.Qe)(FindAProResultsLanding));

;// CONCATENATED MODULE: ./i18n/useFindAProResultsi18n.js


const useFindAProResultsi18n = function() {
    let componentProp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        remodelersTitleText: t("kf.findpro.label.remodelersTitleText"),
        plumbersInstallersTitleText: t("kf.findpro.label.plumbersInstallersTitleBaseText") + t("kf.findpro.label.installers") + " & " + t("kf.findpro.label.plumbers"),
        buildersTitleText: t("kf.findpro.label.buildersTitleText"),
        architectTitleText: t("kf.findpro.label.architectTitleText"),
        designersTitleText: t("kf.findpro.label.designersTitleText"),
        remodelers: t("kf.findpro.label.remodelers"),
        plumbersInstallers: t("kf.findpro.label.plumbers") + " & " + t("kf.findpro.label.installers"),
        builders: t("kf.findpro.label.builders"),
        bathroomDesignConsultText: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.bathroomDesignConsultCopy) ? (0,helper/* getShortenedUrlPath */.mXk)(componentProp === null || componentProp === void 0 ? void 0 : componentProp.bathroomDesignConsultCopy) : t("kf.findpro.label.serviceInfoText"),
        changeLocationText: t("kf.findpro.label.changeLocationText")
    };
    return i18n;
};
/* harmony default export */ var i18n_useFindAProResultsi18n = (useFindAProResultsi18n);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/index.jsx











const FindAProResults = (authorData)=>{
    const [data, setData] = (0,react.useState)([]);
    const [designersData, setDesignersData] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(true);
    const { globalConfig: { general: { findAProbyZipPagePath ="" , bathroomDesignServicesPagePath ="" , siteName ="" , findProResults =""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const urlParams =  true ? new URLSearchParams(window.location.search) : 0;
    const zipcodeVal = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("q");
    (0,react.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!isEmpty_default()(findProResults)) {
                const response = await axios_default().get(findProResults);
                if (response && response.data) {
                    var _items;
                    setDesignersData((_items = response.data.items) !== null && _items !== void 0 ? _items : []);
                }
            }
        };
        const fetchPros = async ()=>{
            if (!isEmpty_default()(zipcodeVal)) {
                try {
                    const response = await constants_api/* apim.get */.TH.get("/maps/pro", {
                        params: {
                            spatialFilter: "nearby('".concat(zipcodeVal, "',", 40, ")"),
                            $format: "json",
                            brand: siteName.toLowerCase(),
                            $select: "EntityID,LocationName,AddressLine,AddressLine2,Locality,AdminDistrict,PostalCode,LogoIMG,LocationRemodeler,LocationInstaller,LocationPlumber,LocationBuilder,LocationDesigner,LocationArchitect,Email,Phone,__Distance,SpecGeneral,SpecIntelligentToilets,SpecDigitalShowering,SpecLighting,SpecKohlerConnected,SpecShowerDoors"
                        }
                    });
                    if (response && response.data) {
                        setData(response.data.d.results);
                    }
                    setLoading(false);
                } catch (error) {
                    setLoading(null);
                }
            }
        };
        fetchData();
        fetchPros();
    }, [
        zipcodeVal,
        findProResults
    ]);
    const staticTexts = i18n_useFindAProResultsi18n(authorData === null || authorData === void 0 ? void 0 : authorData.data);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "find-a-pro-resuls-test",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAProResults_view, {
                loading: loading,
                data: data,
                zipcodeVal: zipcodeVal,
                staticTexts: staticTexts,
                designersData: designersData,
                findAProbyZipPagePath: (0,helper/* getShortenedUrlPath */.mXk)(findAProbyZipPagePath),
                bathroomDesignServicesPagePath: (0,helper/* getShortenedUrlPath */.mXk)(bathroomDesignServicesPagePath)
            })
        })
    });
};
/* harmony default export */ var FindAProResults_v1 = ((0,dist_es/* withTranslation */.Zh)()(FindAProResults));

// EXTERNAL MODULE: ./components/ChangePassword/index.jsx + 3 modules
var ChangePassword = __webpack_require__(42536);
;// CONCATENATED MODULE: ./components/SiteMap/v1/index.jsx



const SiteMap = (param)=>{
    let { data ={}  } = param;
    const [isHeaderActive, setIsHeaderActive] = (0,react.useState)(true);
    const { siteMapHeading ="" , options =[] , appliedCssClassNames =""  } = data;
    const isMobile =  true && window.innerWidth < 1025;
    (0,react.useEffect)(()=>{
        if (isMobile) {
            setIsHeaderActive(false);
        }
    }, [
        isMobile
    ]);
    const handleHeaderClick = ()=>{
        setIsHeaderActive(isMobile ? !isHeaderActive : true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "list ".concat((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.trim()) === "sitemap-first-list" ? "sitemap-first-list" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "list-inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "cmp-list__heading ".concat(isHeaderActive ? "active" : ""),
                    onClick: handleHeaderClick,
                    children: siteMapHeading
                }),
                options === null || options === void 0 ? void 0 : options.map((item, i)=>{
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("ul", {
                        className: "cmp-list ".concat(isHeaderActive ? "show" : "hide"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "cmp-list__subhead",
                                children: item === null || item === void 0 ? void 0 : item.subHeader
                            }),
                            item === null || item === void 0 ? void 0 : (ref = item.subHeaderItem) === null || ref === void 0 ? void 0 : ref.map((subItem, j)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
                                    className: "cmp-page-name",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "".concat((subItem === null || subItem === void 0 ? void 0 : subItem.isNewTab) ? "_blank" : "_self"),
                                            href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(subItem === null || subItem === void 0 ? void 0 : subItem.subPageLink),
                                            children: subItem === null || subItem === void 0 ? void 0 : subItem.subDisplayName
                                        })
                                    })
                                }, "".concat(subItem === null || subItem === void 0 ? void 0 : subItem.subDisplayName, "-").concat(j));
                            })
                        ]
                    }, "".concat(item === null || item === void 0 ? void 0 : item.subHeader, "-").concat(i));
                })
            ]
        })
    });
};
/* harmony default export */ var SiteMap_v1 = (SiteMap);

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/VisualFilter/subcomponents/VisualFilterCard/VisualFilterCard.mjs



const VisualFilterCard = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , className , image , title , isActive , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        component,
        className: (0,clsx/* default */.Z)("kohler-visual-filter-card-root", className),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio: "1:1"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ...(0,helpers/* omitText */.rW)(title),
        component: title.component || "h6",
        size: "label-medium-m",
        padding: "10px 15px",
        cursor: "pointer",
        textAlign: "start",
        backgroundColor: isActive ? colors/* DsmColor.SurfaceActionSecondary */.k.SurfaceActionSecondary : void 0,
        textColor: isActive ? colors/* DsmColor.ContentOnSurfaceActionSecondary */.k.ContentOnSurfaceActionSecondary : colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        style: {
            overflowWrap: "anywhere"
        }
    }, title.text));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/VisualFilter/VisualFilter.module.css.mjs
var VisualFilter_module_css_classes = {
    "visualFilter": "wweAR",
    "visualFilterContent": "Lduv7"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/VisualFilter/VisualFilter.mjs
"use client";





const VisualFilter = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , mod ="white" , className , cards , customCarouselProps , ...rest } = props;
    var ref1;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        component,
        mod,
        paddingBlock: 20,
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary,
        maxWidth: "100%",
        style: {
            overflow: "hidden"
        },
        className: (0,clsx/* default */.Z)("kohler-visual-filter-root", className),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        rowGap: 30
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: VisualFilter_module_css_classes.visualFilterContent
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel/* Carousel */.l, {
        ...customCarouselProps,
        includeGapInSize: false,
        slideGap: "20px",
        slideSize: 0,
        align: "start",
        loop: false,
        containScroll: "trimSnaps",
        carouselControlProps: {
            ...(ref1 = customCarouselProps === null || customCarouselProps === void 0 ? void 0 : customCarouselProps.carouselControlProps) !== null && ref1 !== void 0 ? ref1 : {},
            variant: "slider",
            isOnPhoto: true
        },
        className: VisualFilter_module_css_classes.visualFilter
    }, cards.map((card, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide/* CarouselSlide */.q, {
            className: VisualFilter_module_css_classes.productCardCarouselCard,
            key: index
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(VisualFilterCard, {
            ...card
        })))))));
});


;// CONCATENATED MODULE: ./components/Shared/VisualNav/analytics/constant.js
const constant_IMAGE_SILDER = "carousel image slider";
const IMAGE_CLICK = "carousel image click";
const LEFT_ARROW = "/icons/visual-nav-left-arrow.svg";
const RIGHT_ARROW = "/icons/visual-nav-right.svg";
const constant_PLP = "plp";

;// CONCATENATED MODULE: ./components/Shared/VisualNav/analytics/index.js




const dataLayerForForArrows = function() {
    let arrow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(PLP, ":").concat(IMAGE_SILDER, ":").concat(arrow),
        eventMsg: "n/a",
        eventName: "".concat(PLP, ":").concat(IMAGE_SILDER, ":").concat(arrow),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(arrow, " arrow"),
        internalLinkPosition: PLP,
        internalLinkType: "".concat(PLP, ":").concat(IMAGE_SILDER),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PLP, ":").concat(IMAGE_SILDER)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const dataLayerForImageClick = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isSlected ="false" , index =-1 , productLength =0 , title ="" , imageUrl ="" , link =""  } = data;
    const selected = !isSlected ? "select" : "remove";
    const IndexReady = index + 1;
    const datalayerRedayLink = link ? (0,HeaderNavTabs_utils/* modifyHref */.L9)(link) : "";
    const linkWithStart = datalayerRedayLink ? (datalayerRedayLink.indexOf("http") === -1 ? window.location.origin : "") + datalayerRedayLink : "n/a";
    const getImageID = (imageUrl)=>{
        if (!imageUrl) return null;
        if (imageUrl.startsWith("/content/dam")) {
            var ref;
            const imageID = ((ref = imageUrl.match(regex/* VISUAL_NAV_IMAGEID_FOR_DATALAYER */.ny)) === null || ref === void 0 ? void 0 : ref[1]) || null;
            return imageID ? imageID.split("_")[0] : null;
        }
        const scene7Match = imageUrl.match(regex/* VISUAL_NAV_SCENE7_REGEX */.LM);
        if (scene7Match) {
            const alpha = scene7Match[1];
            const numeric = scene7Match[2];
            return "".concat(alpha).concat(numeric);
        }
        const pawebMatch = imageUrl.match(regex/* IMAGEID_DATALAYER_REGEX */.L3);
        if (pawebMatch) {
            return pawebMatch[1];
        }
        return null;
    };
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_PLP, ":").concat(IMAGE_CLICK, ":").concat(selected),
        eventMsg: "n/a",
        eventName: "".concat(constant_PLP, ":").concat(IMAGE_CLICK, ":").concat(selected),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: title.toLowerCase(),
        internalLinkPosition: constant_PLP,
        internalLinkType: "".concat(constant_PLP, ":").concat(constant_IMAGE_SILDER),
        internalLinkURL: linkWithStart,
        internalLinkZoneName: "".concat(constant_PLP, ":").concat(constant_IMAGE_SILDER),
        imageId: getImageID(imageUrl),
        imageName: title.toLowerCase(),
        imageSequence: "".concat(IndexReady, "_").concat(productLength)
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Shared/VisualNav/index.jsx










const VisualNavigation = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const dispatch = (0,es/* useDispatch */.I0)();
    const productlistState = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
    const { facet_labels: facetLabels = {} , currentAppliedfiltersVisualNav =[] , isServerData =false  } = productlistState;
    const myAuthoredData = data === null || data === void 0 ? void 0 : data.data[":items"];
    const productArray = Object.values(myAuthoredData);
    const [activeCard, setActiveCard] = (0,react.useState)();
    const suppressSelectionCheck = (0,react.useRef)(false);
    // Accessibility workaround
    const wrapperRef = (0,react.useRef)(null);
    var ref;
    const formatVisualNavFilterName = (query)=>{
        var ref1;
        return (ref = (ref1 = facetLabels[query]) === null || ref1 === void 0 ? void 0 : ref1.replace(" ", "_")) !== null && ref !== void 0 ? ref : query;
    };
    const removeVisualNavFilter = (filterName, filterValue)=>{
        const updatedFilters = currentAppliedfiltersVisualNav.filter((filterStr)=>{
            const [facet, value] = filterStr.split(" - ");
            return !(facet === filterName && value === filterValue);
        });
        const updatedQuery = updatedFilters.length ? updatedFilters.map((f)=>{
            var ref;
            const [facet, value] = f.split(" - ");
            return "".concat(formatVisualNavFilterName(facet), ":").concat((ref = value.replace(regex/* DOUBLE_QUOTE_REGEX */.dq, '\\"')) === null || ref === void 0 ? void 0 : ref.replace(regex/* BACKSLASH_REGEX */.H, ""));
        }).join(",") : "NONE";
        dispatch((0,productListSlice/* setFilterQueryState */.nS)(updatedQuery));
        dispatch((0,productListSlice/* setIsFromVisualNav */.zm)(true));
        dispatch((0,productListSlice/* setServerData */.NY)(false));
    };
    const handleNavSelection = (filterName, filterValue, linkHref, visualNavType, newTab, index, title, imgeUrl)=>{
        if (visualNavType === "plpFilterNav") {
            var ref;
            suppressSelectionCheck.current = true;
            const filteredValue = (ref = filterValue === null || filterValue === void 0 ? void 0 : filterValue.replace(regex/* DOUBLE_QUOTE_REGEX */.dq, '\\"')) === null || ref === void 0 ? void 0 : ref.replace(regex/* BACKSLASH_REGEX */.H, "");
            const cardKey = "".concat(filterName, "-").concat(filterValue);
            const cartlength = (productArray === null || productArray === void 0 ? void 0 : productArray.length) || 0;
            if (activeCard === cardKey) {
                dataLayerForImageClick({
                    isSlected: true,
                    index: index,
                    productLength: cartlength,
                    title: title,
                    imageUrl: imgeUrl
                });
                removeVisualNavFilter(filterName, filterValue);
                dispatch((0,productListSlice/* setFilterQueryState */.nS)(""));
                setActiveCard(undefined);
            } else {
                dataLayerForImageClick({
                    isSlected: false,
                    index: index,
                    productLength: cartlength,
                    title: title,
                    imageUrl: imgeUrl
                });
                dispatch((0,productListSlice/* setFilterQueryState */.nS)("".concat(formatVisualNavFilterName(filterName), ":").concat(filteredValue)));
                dispatch((0,productListSlice/* setIsFromVisualNav */.zm)(true));
                dispatch((0,productListSlice/* setServerData */.NY)(false));
                setActiveCard(cardKey);
            }
        } else {
            // Navigate to link
            if (linkHref) {
                newTab ? window.open(linkHref, "_blank") : window.location.href = linkHref;
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (suppressSelectionCheck.current) {
            suppressSelectionCheck.current = false;
            return;
        }
        const matchedIndex = productArray.findIndex((param)=>{
            let { filterName , filterValue  } = param;
            return currentAppliedfiltersVisualNav.some((filterStr)=>{
                const [facet, value] = filterStr.split(" - ");
                return facet === filterName && value === filterValue;
            });
        });
        if (matchedIndex !== -1) {
            const matchedItem = productArray[matchedIndex];
            const cardKey = "".concat(matchedItem.filterName, "-").concat(matchedItem.filterValue);
            setActiveCard(cardKey);
            dispatch((0,productListSlice/* setFilterQueryState */.nS)("".concat(formatVisualNavFilterName(matchedItem.filterName), ":").concat(matchedItem.filterValue)));
        } else {
            setActiveCard(undefined);
        }
    }, [
        currentAppliedfiltersVisualNav,
        isServerData
    ]);
    // ✅ Build cards array
    const cardsArray = Object.values(myAuthoredData).map((item)=>{
        const card = {
            image: {
                src: item.imageUrl || "",
                alt: item.imageAltText || ""
            },
            title: {
                text: (0,html_react_parser/* default */.ZP)(item.title) || ""
            },
            visualNavType: item.visualNavType || "",
            newTab: item.newTab || false,
            "aria-label": item.imageAltText
        };
        if (item.visualNavType === "plpFilterNav") {
            card.filtername = item.filterName || "";
            card.filtervalue = item.filterValue || "";
        } else {
            card.href = (0,HeaderNavTabs_utils/* modifyHref */.L9)(item.link);
        }
        return card;
    });
    const handleLeftrightclick = (event)=>{
        const target = event.target.closest('[data-datalayer-id="kds-element-visual-nav"]');
        if (target) {
            var ref, ref1;
            const rawEventInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}");
            const commonEventInfo = {
                eventMsg: rawEventInfo.eventMsg || "n/a",
                eventStatus: rawEventInfo.eventStatus || "n/a",
                eventType: rawEventInfo.eventType || "navigation",
                internalLinkPosition: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkPosition) || "plp",
                internalLinkZoneName: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkZoneName) || "plp:carousel image slider",
                internalLinkType: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkType) || "plp:carousel image slider",
                internalLinkURL: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkURL) || "n/a"
            };
            let eventInfo = {};
            eventInfo = {
                ...rawEventInfo,
                ...commonEventInfo
            };
            (0,helper/* pushAnalyticsObjToDataLayer */.zYT)({
                ...eventInfo
            });
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handleLeftrightclick);
        return ()=>document.removeEventListener("click", handleLeftrightclick);
    }, []);
    const props = {
        mod: "white",
        cards: cardsArray,
        customCarouselProps: {
            "aria-roledescription": "carousel",
            "aria-label": "Shop by Type",
            "aria-live": "polite",
            role: "region",
            leftCarouselControlProps: {
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-visual-nav",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "plp:carousel image slider:left",
                        eventName: "plp:carousel image slider:left",
                        internalLinkName: "left arrow"
                    })
                }
            },
            rightCarouselControlProps: {
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-visual-nav",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "plp:carousel image slider:right",
                        eventName: "plp:carousel image slider:right",
                        internalLinkName: "right arrow"
                    })
                }
            }
        }
    };
    const { cards , ...rest } = props;
    const modifiedCards = cards.map((card, index)=>{
        const cardKey = "".concat(card.filtername, "-").concat(card.filtervalue);
        return {
            ...card,
            onClick: ()=>handleNavSelection(card.filtername, card.filtervalue, card.href, card.visualNavType, card.newTab, index, card.title.text, card.image.src),
            isActive: card.visualNavType === "plpFilterNav" && activeCard === cardKey
        };
    });
    (0,react.useEffect)(()=>{
        if (!wrapperRef.current) return;
        const container = wrapperRef.current.querySelector(".kohler-carousel-container");
        if (!container) return;
        container.setAttribute("aria-live", "polite");
        Array.from(container.children).forEach((slide, index)=>{
            var ref, ref1;
            slide.setAttribute("role", "group");
            slide.setAttribute("aria-roledescription", "slide");
            slide.setAttribute("aria-label", "".concat(((ref = modifiedCards[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.text) || "", " - Slide ").concat(index + 1, " of ").concat(modifiedCards.length));
        });
    }, [
        modifiedCards
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "visualNavWrapper",
        ref: wrapperRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualFilter, {
            ...rest,
            cards: modifiedCards
        })
    });
};
/* harmony default export */ var VisualNav = (VisualNavigation);

// EXTERNAL MODULE: ./components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(15540);
;// CONCATENATED MODULE: ./components/ProductCarousel/SliderProductCard.jsx







const SliderProductCard = (param)=>{
    let { i18n , product , currencySign , presetConfigs , swatchUrl , parent , title , brandName , skuId =""  } = param;
    const [productCardWidth, setProductCardWidth] = (0,react.useState)(0);
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react.useState)("");
    const productCardRef = (0,react.useRef)();
    const presetConfigObject = presetConfigs;
    const newTab = false;
    (0,react.useEffect)(()=>{
        setProductCardWidth(productCardRef.current.clientWidth);
    });
    (0,react.useEffect)(()=>{
        if (product) {
            (0,helper/* getPDPUrl */.ir5)(product === null || product === void 0 ? void 0 : product.productCategory, product === null || product === void 0 ? void 0 : product.slug).then((ret)=>setPdpNavigationURL(ret));
        }
    }, [
        product
    ]);
    const formatUrl = (uUrl, iWidth)=>{
        const sUrlPath = uUrl.split("/");
        const sUrlId = sUrlPath[sUrlPath.length - 1];
        let sPreset = "";
        if (iWidth <= 167) {
            var ref;
            sPreset = (ref = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobileLandscape) !== null && ref !== void 0 ? ref : "";
        } else if (iWidth <= 458) {
            var ref1;
            sPreset = (ref1 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.Desktop) !== null && ref1 !== void 0 ? ref1 : "";
        } else {
            var ref2;
            sPreset = (ref2 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobilePortrait) !== null && ref2 !== void 0 ? ref2 : "";
        }
        return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?$product_src=is{PAWEB/").concat(sUrlId, "}&?").concat(sPreset);
    };
    const getProductName = ()=>{
        if (!parent && title) {
            return title;
        }
        return product.name || brandName ? product.name || brandName : product.name ? product.name : product.description;
    };
    var _price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: productCardRef,
        className: "product-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            prefetch: false,
            href: product ? pdpNavigationURL + (skuId ? "?skuId=".concat(skuId) : "") : "",
            target: newTab ? "_blank" : "_self",
            className: "product-card__link",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-card__img-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: product ? presetConfigObject ? formatUrl(product.images, productCardWidth) : product.images : image_missing/* default.src */.Z.src,
                        className: "product-card__img",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "product-card__name".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                    text: product ? getProductName() : "..."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                className: "product-card__price".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: product ? product.discountedPrice > 0 ? product.discountedPrice : product.price : "0",
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-card-desc",
                                children: product ? product.name || title || brandName ? product.description : "" : ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__right",
                            children: product ? product.discountedPrice !== product.price && product.discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-card__discount-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__color-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: product ? product.colors.length > 1 ? "".concat(product.colors.length, " ").concat(i18n.recentlyViewedColors) : "1 ".concat(i18n.recentlyViewedColor) : "1 Color"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductCarousel_SliderProductCard = (SliderProductCard);

;// CONCATENATED MODULE: ./components/ProductCarousel/ProductCarouselLoader.jsx



const ProductCarouselLoader = (props)=>{
    var _productSkus;
    const products = (_productSkus = props.productSkus) !== null && _productSkus !== void 0 ? _productSkus : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-carousel-wrapper",
        id: "product-carousel-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-carousel",
            children: products === null || products === void 0 ? void 0 : products.map((product)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-carousel__card",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_SliderProductCard, {})
                    })
                }, product.productSkuId);
            })
        })
    });
};
/* harmony default export */ var ProductCarousel_ProductCarouselLoader = (ProductCarouselLoader);

;// CONCATENATED MODULE: ./components/ProductCarousel/ProductCarousel.jsx












const ProductCarousel = (props)=>{
    const [products, setProducts] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(true);
    const [info, setInfo] = (0,react.useState)({});
    const persona = (0,helper/* getUserPersona */.shu)();
    const staticTexts = i18n_useProductCardi18n({});
    const presetConfigs = {
        Desktop: "$PDPMoreCollectionDesktop$&fmt=webp",
        MobilePortrait: "$PDPMoreCollectionDesktop$&fmt=webp",
        MobileLandscape: "$PDPMoreCollectionDesktop$",
        PotraitCategory: "GBH_DataDrivenVerticalTemplate"
    };
    const swatchUrlKohler = "https://kohler.scene7.com/is/image/PAWEB/";
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const language = get_default()(config, "internationalization.language", "en");
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            setInfo({
                locale,
                language,
                currencySign,
                currencyCode,
                brandName,
                lwAppName
            });
        });
    }, []);
    const fetchProducts = async (info)=>{
        try {
            const fl = [
                "id",
                "slug_s",
                "productName_s",
                "masterSKU_s",
                "Product_Category",
                "ProductBrandName_s",
                "productImages.url_ss",
                "productImageVariantImages.url_ss",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "priceStartingAt.".concat(persona, "_d"),
                "discountedPriceStartingAt.".concat(persona, "_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "Color.SKU.Details_ss",
                "ProductWebFeatures_ss",
                "ProductWebFeatures_s",
                "ProductExclusive_s",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "title_s",
                "ProductNarrativeDescription_s",
                "priceList.".concat(persona, ".finalPrice_d"),
                "CustomerFacingBrand_s",
                "RegionBrandName_s",
                "productImages.labelWithUrl_ss"
            ];
            const productSkus = props.data.productSku.map((product)=>'"'.concat(product.productSkuId, '"'));
            const res = await constants_api/* apim.get */.TH.get("/search/plp", {
                params: {
                    fl: fl.join(","),
                    q: "*:*",
                    fq: [
                        "variantList.sku_ss:(".concat(productSkus.join(","), ")"),
                        'language_s:("en")'
                    ],
                    collections: info.lwAppName.toLowerCase(),
                    profilename: "profile_".concat(info.lwAppName.toLowerCase(), "_General")
                },
                paramsSerializer: (params)=>lib_default().stringify(params, {
                        arrayFormat: "repeat",
                        encode: false
                    })
            });
            setProducts(res.data.response.docs);
        } catch (err) {
            console.error("Failed to fetch products:", err);
        } finally{
            setLoading(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(info)) {
            fetchProducts(info);
        }
    }, [
        info
    ]);
    if (loading) {
        var ref;
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_ProductCarouselLoader, {
                productSkus: (ref1 = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.productSku) !== null && ref1 !== void 0 ? ref1 : []
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-carousel-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-carousel",
            children: products.map((product)=>{
                const productCardProps = {};
                productCardProps.presetConfigs = presetConfigs;
                productCardProps.swatchUrl = swatchUrlKohler;
                if (product) {
                    var ref;
                    // get product images
                    if (product["modifiedproductImageVariantImages.url_ss"]) {
                        var ref1;
                        const imageStrig = (ref1 = product["modifiedproductImageVariantImages.url_ss"]) === null || ref1 === void 0 ? void 0 : ref1.split("|");
                        productCardProps.images = imageStrig.length ? imageStrig[imageStrig.length - 1] : "";
                    } else if (product["productImages.url_ss"]) {
                        var ref2;
                        productCardProps.images = (ref2 = product["productImages.url_ss"][0]) !== null && ref2 !== void 0 ? ref2 : "";
                    } else {
                        productCardProps.images = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                    }
                    // get product colors
                    if (product["Color.SKU.Details_ss"]) {
                        var ref3;
                        const colors = (ref3 = product["Color.SKU.Details_ss"]) !== null && ref3 !== void 0 ? ref3 : [];
                        productCardProps.colors = colors.filter((item)=>{
                            const color = item.split("|");
                            return color[4] === "false" || Date.parse(color[4]) > Date.now();
                        });
                    }
                    // get product web features
                    if (product["ProductWebFeatures_s"]) {
                        var ref4;
                        productCardProps.productFeatures = (ref4 = [
                            product["ProductWebFeatures_s"]
                        ]) !== null && ref4 !== void 0 ? ref4 : [];
                    } else {
                        var ref5;
                        productCardProps.productFeatures = (ref5 = product["ProductWebFeatures_ss"]) !== null && ref5 !== void 0 ? ref5 : [];
                    }
                    productCardProps.currencySign = info.currencySign;
                    productCardProps.productCategory = get_default()(product, "Product_Category", "");
                    productCardProps.name = get_default()(product, "productName_s", "");
                    productCardProps.brandName = get_default()(product, "RegionBrandName_s", "");
                    productCardProps.description = get_default()(product, "title_s", "");
                    productCardProps.narrativeDescription = get_default()(product, "ProductNarrativeDescription_s", "");
                    productCardProps.price = get_default()(product, "priceStartingAt.".concat(persona, "_d"), 0);
                    productCardProps.discountedPrice = get_default()(product, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
                    productCardProps.discountPercent = parseInt(get_default()(product, "priceList.".concat(persona, ".saleOffer_s"), 0));
                    productCardProps.slug = get_default()(product, "slug_s", "");
                    productCardProps.customerBrand = get_default()(product, "CustomerFacingBrand_s", "");
                    let tempColorDetails = get_default()(product, "Color.SKU.Details_ss", null);
                    if (tempColorDetails) {
                        if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                            tempColorDetails = tempColorDetails[0];
                        }
                        productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
                    }
                    productCardProps.badgeVal = get_default()(product, "priceList.".concat(persona, ".saleOffer_s"), "");
                    productCardProps.globalDiscount = productCardProps.price - get_default()(product, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
                    const productCategory = productCardProps === null || productCardProps === void 0 ? void 0 : (ref = productCardProps.productCategory) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                    productCardProps.priceType = "";
                    if (productCategory === "field tiles" || productCategory === "slabs" || productCategory === "mosaics") {
                        productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sfLabel);
                    }
                    if (productCategory === "trims & moldings") {
                        productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lfLabel);
                    }
                    if (productCategory === "grout") {
                        productCardProps.priceType = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.boxLabel;
                    }
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-carousel__card",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_SliderProductCard, {
                        i18n: staticTexts,
                        product: productCardProps,
                        currencySign: info.currencySign,
                        presetConfigs: presetConfigs,
                        swatchUrl: swatchUrlKohler,
                        title: product.productName_s,
                        brandName: product.ProductBrandName_s
                    })
                }, product.masterSKU_s);
            })
        })
    });
};
/* harmony default export */ var ProductCarousel_ProductCarousel = (ProductCarousel);

;// CONCATENATED MODULE: ./components/AemGrid.jsx


















































const AemGrid = (props)=>{
    const { data ={} , itemKey ="" , count =0 , eventHandler ={} , fullData ={} , containerId ="" , bodytitle ="" , ...extraProps } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const componentContexts = (0,react.useContext)(ComponentImport/* default */.ZP);
    (0,react.useEffect)(()=>{
        if ((0,utils/* isAuthModal */.S)(data)) {
            dispatch((0,authSlice/* setAuthModalStaticText */.vu)(data));
        }
        if ((0,utils/* isCompareProducts */.Be)(data)) {
            dispatch((0,genericSlice/* setCompareproductsStaticText */.rA)(data));
        }
        if ((0,utils/* isNewsLetter */.C_)(data)) {
            dispatch((0,genericSlice/* setSubscribeModalContent */.ml)(data));
        }
        if ((0,utils/* isSiteWideWarning */.yd)(data)) {
            dispatch((0,genericSlice/* setSitewideWarningContent */.FV)(data));
        }
        if ((0,utils/* isNewsLetterSignUp */.f5)(data)) {
            dispatch((0,genericSlice/* setSitewideNewsLetterContent */._r)(data));
        }
        if ((0,utils/* isToaster */.bu)(data)) {
            dispatch((0,genericSlice/* setToastContent */.Ji)(data));
        }
        if ((0,utils/* isStoreFilter */.Ov)(data)) {
            dispatch((0,locationSlice/* setStoreFilter */.Ey)(data));
        }
        if ((0,utils/* isGatedContent */.Er)(data)) {
            dispatch((0,genericSlice/* setGatedContentData */.wA)(data));
        }
    }, [
        data
    ]);
    const { title ="" , urlNames ="" , knowledgeArticle =()=>{} , technicalSpecifications =()=>{} , myFavorites =()=>{} , myProducts =()=>{} , myGenericFiller =()=>{} , myServices =()=>{} , accountSettings =()=>{} , contactUs =()=>{} , contactUsFiller =()=>{} , pressReleaseLanding =()=>{} , findStore =()=>{} , keySpecifier =()=>{} , associateMembership =()=>{} , friendsAndFamily =()=>{} , installDesignServices =()=>{} , isScrollMarginRequired =false  } = extraProps;
    const itemsOrderValue = data[":itemsOrder"] || [];
    const isWrapperRequired = constants.groupedComponents === null || constants.groupedComponents === void 0 ? void 0 : constants.groupedComponents.every((value)=>{
        return itemsOrderValue === null || itemsOrderValue === void 0 ? void 0 : itemsOrderValue.some((val)=>{
            return val === null || val === void 0 ? void 0 : val.includes(value);
        });
    });
    if ((0,utils/* isContainer */.Nm)(data)) {
        const dsComponent = getDSComponentForContainer(data);
        if (dsComponent) {
            return dsComponent;
        }
    }
    if ((0,utils/* isInspireVideo */._)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Video, {
            data: data
        });
    }
    if ((0,utils/* isVideo */.Wv)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Video, {
            data: data
        });
    }
    if ((0,utils/* isShareList */.pO)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ShareList, {
            data: data
        });
    }
    if ((0,utils/* isSpacer */.MW)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Spacer, {
            data: data
        });
    }
    if ((0,utils/* isImageCluster */.Tk)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ImageCluster, {
            data: data
        }) : null;
    }
    if ((0,utils/* isImage */.Or)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
            data: data
        }) : null;
    }
    if ((0,utils/* isImageV3 */.EE)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Image, {
            data: data
        });
    }
    if ((0,utils/* isAemForm */.np)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_AemForm, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isProductCardV4 */.LV)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell/* default */.Z, {
            authData: data
        }) : null;
    }
    if ((0,utils/* isProductcardV3 */.DN)(data)) {
        const { skewId ="" , presetConfigs =""  } = data;
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "productcard-v3 productcard",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                authorData: {
                    skewId,
                    presetConfigs
                },
                fullData: fullData
            })
        }) : null;
    }
    if ((0,utils/* isProductcard */.po)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isCarousel */.C2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Carousel, {
            data: data,
            fullData: fullData,
            containerId: containerId
        });
    }
    if ((0,utils/* isPromoBanner */.e7)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PromoBanner, {
            data: data
        });
    }
    if ((0,utils/* isSlick */.bd)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselSlick, {
            fullData: fullData,
            data: data
        });
    }
    if ((0,utils/* isTeaser */.j$)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
            data: data,
            fullData: fullData,
            containerId: containerId,
            bodytitle: bodytitle
        });
    }
    if ((0,utils/* isText */.Gs)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
            data: data
        });
    }
    if ((0,utils/* isInPageSearch */.L8)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InPageSearch/* default */.Z, {
            data: data
        }) : null;
    }
    if ((0,utils/* isTab */.wR)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Tab, {
            data: data,
            itemKey: itemKey,
            ...extraProps
        });
    }
    if ((0,utils/* isBrandHeader */.cD)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeader, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isHeaderNav */.ZS)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNav, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isHeaderNavV3 */.A9)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNav, {
            data: data,
            eventHandler: eventHandler,
            v3: true
        });
    }
    if ((0,utils/* isVisualNav */.RU)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualNav, {
            data: data
        });
    }
    if ((0,utils/* isEmbed */.P2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Embed, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isFooter */.cl)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Footer, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isShopTheRoomDetail */.ph)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShopTheRoomDetail, {
            data: data
        });
    }
    if ((0,utils/* isRoomDetail */.X7)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_RoomDetailPage, {
            data: data
        });
    }
    if ((0,utils/* isShopTheRoomCard */.ck)(data)) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopTheRoomCard["default"], {
            cardTitle: data === null || data === void 0 ? void 0 : data.cardTitle,
            cardHoverTitle: data === null || data === void 0 ? void 0 : data.cardHoverTitle,
            ctalink: data === null || data === void 0 ? void 0 : data.ctalink,
            landingImageLink: data === null || data === void 0 ? void 0 : data.landingImageLink,
            modelImageLink: data === null || data === void 0 ? void 0 : data.modelImageLink,
            skuIds: data === null || data === void 0 ? void 0 : data.skuIds,
            presetConfigs: (ref = data === null || data === void 0 ? void 0 : data.presetConfigs) !== null && ref !== void 0 ? ref : "{}",
            altModel: data === null || data === void 0 ? void 0 : data.altModel,
            altLanding: data === null || data === void 0 ? void 0 : data.altLanding,
            linkNewTab: data === null || data === void 0 ? void 0 : data.linkNewTab
        });
    }
    if ((0,utils/* isGlobalToaster */.gC)(data)) {
        return extraProps && extraProps.globalToaster && extraProps.globalToaster(data);
    }
    if ((0,utils/* isCartLanding */.l1)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.landing && extraProps.landing(data);
        } else {
            return extraProps && extraProps.landingFiller && extraProps.landingFiller(data);
        }
    }
    if ((0,utils/* isUpSellContainer */._4)(data)) {
        return extraProps && extraProps.upSellContainer && extraProps.upSellContainer(data);
    }
    if ((0,utils/* isCheckoutLanding */.Ar)(data) && !isSsr) {
        return extraProps && extraProps.checkoutView && extraProps.checkoutView(data);
    }
    if ((0,utils/* isOrderConfirmation */.Uq)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderConfirmation && extraProps.orderConfirmation(data);
        } else {
            return extraProps && extraProps.orderConfirmationTagFiller && extraProps.orderConfirmationTagFiller();
        }
    }
    if ((0,utils/* isOrderStatus */.K0)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderStatus && extraProps.orderStatus(data);
        } else {
            return extraProps && extraProps.orderStatusFiller && extraProps.orderStatusFiller();
        }
    }
    if ((0,utils/* isOrderHistory */._$)(data) && !isSsr) {
        return extraProps && extraProps.orderHistory && extraProps.orderHistory(data);
    }
    if ((0,utils/* isOrderDetails */.pv)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderDetails && extraProps.orderDetails(data);
        } else {
            return extraProps && extraProps.orderDetailsFiller && extraProps.orderDetailsFiller(data);
        }
    }
    if ((0,utils/* isReturnSlips */.uJ)(data)) {
        if (!isSsr) {
            var ref1;
            return extraProps === null || extraProps === void 0 ? void 0 : (ref1 = extraProps.returnSlips) === null || ref1 === void 0 ? void 0 : ref1.call(extraProps, data);
        } else {
            var ref2;
            return extraProps === null || extraProps === void 0 ? void 0 : (ref2 = extraProps.returnSlipsFiller) === null || ref2 === void 0 ? void 0 : ref2.call(extraProps, data);
        }
    }
    if ((0,utils/* isPairsWellWth */.oC)(data) && !isSsr) {
        return extraProps && extraProps.pairsWellWith && extraProps.pairsWellWith(data);
    }
    if ((0,utils/* isSharedCart */.sL)(data) && !isSsr) {
        return extraProps && extraProps.sharedCart && extraProps.sharedCart(data);
    }
    if ((0,utils/* isShopTheRoomLandingPage */.mI)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: componentContexts.map((param, index)=>/*#__PURE__*/ {
                let { Component , componentProps  } = param;
                return (0,jsx_runtime.jsx)(Component, {
                    data: data,
                    ...componentProps.isFullData ? {
                        ...componentProps,
                        fullData: fullData
                    } : componentProps
                }, "".concat(Component.name, "-").concat(index));
            })
        });
    }
    if ((0,utils/* isBreadcrumb */.Z3)(data)) {
        return extraProps && extraProps.breadCrumb && extraProps.breadCrumb(data, fullData);
    }
    if ((0,utils/* isProductList */.Hx)(data)) {
        return extraProps && extraProps.productList && extraProps.productList(data, eventHandler);
    }
    if ((0,utils/* isSearch */.N)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.searchComponent && extraProps.searchComponent(data, eventHandler);
        } else {
            return extraProps && extraProps.searchFiller && extraProps.searchFiller(data);
        }
    }
    if ((0,utils/* isHelpSupport */.zK)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_HelpSupport, {
            data: data
        });
    }
    if ((0,utils/* isAccountSettings */.mg)(data)) {
        if (!isSsr) {
            return accountSettings(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isMyservice */.U4)(data)) {
        if (!isSsr) {
            return myServices(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isMyFavorites */.we)(data)) {
        if (!isSsr) {
            return myFavorites(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isChangePassword */.Si)(data)) {
        if (!isSsr) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePassword/* default */.Z, {
                data: data
            });
        } else {
            return "Loading...";
        }
    }
    if ((0,utils/* isMyproducts */.Dx)(data)) {
        if (!isSsr) {
            return myProducts(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isLiterature */.ek)(data) && !isSsr) {
        return extraProps && extraProps.literature && extraProps.literature(data);
    }
    if ((0,utils/* isTechnicalSpec */.HR)(data)) {
        return technicalSpecifications && technicalSpecifications(data);
    }
    if ((0,utils/* isProductDetails */.jS)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productDetail && extraProps.productDetail(data, extraProps === null || extraProps === void 0 ? void 0 : extraProps.slug, extraProps === null || extraProps === void 0 ? void 0 : extraProps.skuId);
        } else {
            return extraProps && extraProps.productDetailFiller && extraProps.productDetailFiller(data);
        }
    }
    if ((0,utils/* isProductAccordion */.eq)(data) && !isSsr) {
        if (extraProps && extraProps.productAccordion) {
            return extraProps.productAccordion(data);
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                data: data
            });
        }
    }
    if ((0,utils/* isProductExfPdp */.V6)(data) && !isSsr) {
        return extraProps && extraProps.productExf && extraProps.productExf(data);
    }
    if ((0,utils/* isProductReview */.s3)(data) && !isSsr) {
        return extraProps && extraProps.review && extraProps.review(data);
    }
    if ((0,utils/* isRegisterOffline */.hn)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProducts(data);
        } else {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isRegisterOnline */.L)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.onlineProducts && extraProps.onlineProducts(data);
        } else {
            return extraProps && extraProps.onlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isKnowledgeArticle */.Mc)(data)) {
        return extraProps && knowledgeArticle(data, urlNames);
    }
    if ((0,utils/* isBrowseAllStores */.MN)(data) && !isSsr) {
        return extraProps && extraProps.browseAllStores && extraProps.browseAllStores(data);
    }
    if ((0,utils/* isContactUs */.OL)(data)) {
        if (!isSsr) {
            return contactUs(data);
        } else {
            return contactUsFiller();
        }
    }
    if ((0,utils/* isFindingModelNumber */.iL)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindingModelNumber, {
            data: data
        });
    }
    if ((0,utils/* isPressLanding */.GX)(data) && !isSsr) {
        return pressReleaseLanding(data);
    }
    if ((0,utils/* isFindStore */._H)(data) && !isSsr) {
        return findStore(data);
    }
    if ((0,utils/* isTitle */.Wt)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_Title, {
            data: data
        });
    }
    if ((0,utils/* isKeySpecifier */.z9)(data)) {
        return keySpecifier(data);
    }
    if ((0,utils/* isDynamicSearch */.Lg)(data) && !isSsr) {
        const { presetConfigs: presetConfigs1 = {} , disableParts =false , enablePotraitTile =false  } = data;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DynamicSearch, {
            presetConfigs: presetConfigs1,
            disableParts: disableParts,
            enablePotraitTile: enablePotraitTile
        });
    }
    if ((0,utils/* isAssociateMembership */.F0)(data)) {
        return associateMembership(data);
    }
    if ((0,utils/* isInstallDesignServices */.kp)(data) && !isSsr) {
        return installDesignServices(data);
    }
    if ((0,utils/* isProfessionalDetail */.Y5)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_VirtualDesignerDetails, {
            data: data
        });
    }
    if ((0,utils/* isFriendsAndFamily */.jM)(data)) {
        return friendsAndFamily(data);
    }
    if ((0,utils/* isFindAProByZip */.gd)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindAProByZip, {
            data: data
        }) : null;
    }
    if ((0,utils/* isFindAProResults */.U2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAProResults_v1, {
            data: data
        });
    }
    if ((0,utils/* isStoreAppointment */.xA)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_StoreAppointment, {
            data: data
        });
    }
    if ((0,utils/* isList */.nq)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteMap_v1, {
            data: data
        });
    }
    if ((0,utils/* isPDPCuratedProducts */.VV)(data)) {
        return extraProps && extraProps.pdpCuratedProduct && extraProps.pdpCuratedProduct(data);
    }
    if ((0,utils/* isProductSlider */._h)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_ProductCarousel, {
            data: data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: (0,utils/* isContainer */.Nm)(data) && itemKey === constants.COMPONENT_TYPES.ROOT_CONTAINER || isWrapperRequired,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames, " ").concat(isScrollMarginRequired ? "unsetPageScrollMargin" : ""),
                    role: "main",
                    id: "main-content",
                    tabIndex: -1,
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGridColumn, {
                data: data,
                itemKey: itemKey,
                count: count,
                eventHandler: eventHandler,
                containerId: containerId,
                ...extraProps
            })
        })
    });
};
/* harmony default export */ var components_AemGrid = (AemGrid);


/***/ }),

/***/ 42536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ChangePassword; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./services/auth.service.js + 170 modules
var auth_service = __webpack_require__(25696);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/ChangePassword/analytics/index.js
const addAnalyticsShowAuthModal = ()=>{
    const eventInfo = {
        eventAction: "my account:password reset:sign in",
        eventName: "my account:password reset:sign in",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "sign in",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:password reset:success",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsShowRequirements = ()=>{
    const eventInfo = {
        eventAction: "my account:password reset:password requirements",
        eventName: "my account:password reset:password requirements",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "password requirements",
        internalLinkPosition: "my account",
        internalLinkType: "my account:informative",
        internalLinkZoneName: "my account:password reset:create new password form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsResetPassword = ()=>{
    const eventInfo = {
        eventAction: "my account:password reset:reset password button",
        eventName: "my account:password reset:reset password button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "reset password",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:password reset:create new password form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};

// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
;// CONCATENATED MODULE: ./components/ChangePassword/localization.js

const getTranslations = (t)=>{
    const { auth: { authModal: { staticText ={}  } = {}  } = {}  } = store/* store.getState */.h.getState();
    const { passwordlabel =t("kf.changePassword.label.password") , resetpasswordlabel =t("kf.changePassword.label.resetPassword") , passwordrequirementstext =t("kf.changePassword.label.passwordRequirements") , reEnterPassword =t("kf.changePassword.label.reEnterPassword") , createnewpassword =t("kf.changePassword.label.createNewPassword") , resetPassword =t("kf.changePassword.label.resetPassword") , newpassworddescription =t("kf.changePassword.label.createPasswordDesc") , passwordlabelerrormessage =t("kf.changePassword.label.passwordError") , reenterpasswordlabelerrormessage =t("kf.auth.label.provide.reEnterPwdError") , successMessage =t("kf.changePassword.label.successMessage")  } = staticText;
    return {
        passwordSuccessText: t("kf.changePassword.label.success"),
        recentPasswordText: t("kf.account.error.recentPassword"),
        characterCountText: t("kf.changePassword.label.characterCount"),
        pwMustIncludeText: t("kf.changePassword.label.pwMustInclude"),
        signinText: t("kf.changePassword.label.signin"),
        passwordMatchErrorText: t("kf.changePassword.label.passwordMatchError"),
        passwordAuthErrorText: t("kf.auth.error.passwordError"),
        pwdErrorText: t("kf.auth.label.provide.pwdError"),
        passwordUpdatedText: t("kf.changePassword.label.passwordRequirements"),
        passwordLabelText: passwordlabel,
        successMessageText: successMessage,
        reenterPasswordLabelErrorMessage: reenterpasswordlabelerrormessage,
        passwordLabelErrorMessage: passwordlabelerrormessage,
        newPasswordDescriptionText: newpassworddescription,
        reEnterPasswordText: reEnterPassword,
        createNewPasswordText: createnewpassword,
        resetPasswordText: resetPassword,
        resetPasswordLabelText: resetpasswordlabel,
        passwordRequirementsText: passwordrequirementstext,
        uppercaseLetterText: t("kf.changePassword.label.uppercaseLetter"),
        lowercaseLetterText: t("kf.changePassword.label.lowercaseLetter"),
        symbolValidationText: t("kf.changePassword.label.symbolValidation"),
        numberValidationText: t("kf.changePassword.label.numberValidation")
    };
};

// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
;// CONCATENATED MODULE: ./components/ChangePassword/PasswordRequirements/index.js



const PasswordRequirements = (props)=>{
    const { passwordRegExp: { passwordMessage =[]  } = {}  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { passwordRequirementsText ="" , pwMustIncludeText ="" , characterCountText ="" , uppercaseLetterText ="" , lowercaseLetterText ="" , symbolValidationText ="" , numberValidationText =""  } = staticText;
    const i18n = {
        showDialog: true
    };
    if (passwordRequirementsText === pwMustIncludeText) {
        i18n.characterCount = characterCountText;
        i18n.uppercaseLetter = uppercaseLetterText;
        i18n.lowercaseLetter = lowercaseLetterText;
        i18n.symbolValidation = symbolValidationText;
        i18n.numberValidation = numberValidationText;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "password-tooltip",
        children: i18n.showDialog ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: pwMustIncludeText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: passwordMessage.length ? passwordMessage.map((message, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: message
                        }, i)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.characterCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.uppercaseLetter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.lowercaseLetter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.symbolValidation
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.numberValidation
                            })
                        ]
                    })
                })
            ]
        }) : passwordRequirementsText
    });
};
/* harmony default export */ var ChangePassword_PasswordRequirements = (PasswordRequirements);

// EXTERNAL MODULE: ./components/ChangePassword/index.module.scss
var index_module = __webpack_require__(92186);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/ChangePassword/index.jsx

















const ChangePassword = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { passwordLabelText ="" , resetPasswordLabelText ="" , passwordRequirementsText ="" , reEnterPasswordText ="" , resetPasswordText ="" , newPasswordDescriptionText ="" , reenterPasswordLabelErrorMessage ="" , successMessageText ="" , passwordSuccessText ="" , signinText ="" , pwdErrorText ="" , passwordAuthErrorText ="" , passwordMatchErrorText ="" , recentPasswordText =""  } = staticText;
    const [showRequirements, setShowRequirements] = (0,react.useState)(false);
    const [showSuccess, setShowSuccess] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [password, setPassword] = (0,react.useState)({
        value: "",
        error: false,
        errorMssg: ""
    });
    const [rePassword, setRePassword] = (0,react.useState)({
        value: "",
        error: false,
        errorMssg: ""
    });
    const [passwordRegExp, setPasswordRegExp] = (0,react.useState)({
        regex: "",
        passwordMessage: []
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,helper/* getPasswordRegExp */.VzW)().then((getPasswordRegEx)=>{
            var _regex, _passwordMessage;
            setPasswordRegExp({
                regex: (_regex = getPasswordRegEx.regex) !== null && _regex !== void 0 ? _regex : "",
                passwordMessage: (_passwordMessage = getPasswordRegEx.passwordMessage) !== null && _passwordMessage !== void 0 ? _passwordMessage : []
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [
        showSuccess
    ]);
    const clearError = ()=>{
        setPassword({
            ...password,
            error: false,
            errorMssg: ""
        });
        setRePassword({
            ...rePassword,
            error: false,
            errorMssg: ""
        });
    };
    const onBlurInput = (name, value)=>{
        switch(name){
            case "pwd":
                {
                    if (!value) return setPassword({
                        ...password,
                        error: true,
                        errorMssg: pwdErrorText
                    });
                    if (!localStorage.getItem("passwordChangeRequired")) {
                        var ref;
                        const email = (ref = new URLSearchParams(window.location.search).get("email")) !== null && ref !== void 0 ? ref : "";
                        const emailVal = email ? email.split(/[@.]/) : [];
                        const passwordData = emailVal === null || emailVal === void 0 ? void 0 : emailVal.filter((el)=>el.length > 1);
                        (0,helper/* validatePassword */.uo4)(value, [
                            ...passwordData
                        ]).then((res)=>{
                            if (!res) setPassword({
                                ...password,
                                error: true,
                                errorMssg: passwordAuthErrorText
                            });
                            else setPassword({
                                ...password,
                                error: false,
                                errorMssg: ""
                            });
                        });
                    }
                    break;
                }
            case "re-pwd":
                if (!value) return setRePassword({
                    ...rePassword,
                    error: true,
                    errorMssg: reenterPasswordLabelErrorMessage
                });
                if (password.value !== rePassword.value) setRePassword({
                    ...rePassword,
                    error: true,
                    errorMssg: passwordMatchErrorText
                });
                else setRePassword({
                    ...rePassword,
                    error: false,
                    errorMssg: ""
                });
                break;
            default:
                return;
        }
    };
    const successCb = ()=>{
        setShowSuccess(true);
        setLoading(false);
        localStorage.removeItem("passwordChangeRequired");
        sessionStorage.removeItem("OTPPassword");
        sessionStorage.removeItem("userIdForOTP");
    };
    const errorCB = (err)=>{
        setLoading(false);
        if ((err === null || err === void 0 ? void 0 : err.errorCode) && (err === null || err === void 0 ? void 0 : err.errorCode) === "E0000014") {
            setPassword({
                ...password,
                error: true,
                errorMssg: recentPasswordText
            });
        } else if (err) setPassword({
            ...password,
            error: true,
            errorMssg: err
        });
    };
    const handleResetPassword = async ()=>{
        clearError();
        let valid = true;
        if (!localStorage.getItem("passwordChangeRequired")) {
            const email = new URLSearchParams(window.location.search).get("email");
            const emailVal = email ? email.split(/[@.]/) : [];
            const passwordData = emailVal === null || emailVal === void 0 ? void 0 : emailVal.filter((el)=>el.length > 1);
            const isValidPassword = await (0,helper/* validatePassword */.uo4)(password.value, [
                ...passwordData
            ]);
            if (!isValidPassword) {
                setPassword({
                    ...password,
                    error: true,
                    errorMssg: passwordAuthErrorText
                });
                valid = false;
            } else {
                setPassword({
                    ...password,
                    error: false,
                    errorMssg: ""
                });
            }
        }
        if (password.value !== rePassword.value) {
            setRePassword({
                ...rePassword,
                error: true,
                errorMssg: passwordMatchErrorText
            });
            valid = false;
        }
        if (valid) {
            setLoading(true);
            const { recoveryToken  } = lib_default().parse(window.location.search, {
                ignoreQueryPrefix: true
            });
            if (localStorage.getItem("passwordChangeRequired")) {
                changePassword(password.value);
                return;
            }
            (0,auth_service/* resetPassword */.c0)(recoveryToken, password.value, successCb, errorCB);
        }
        addAnalyticsResetPassword();
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    const changePassword = async (newPassword)=>{
        await (0,api/* getAnonymousToken */.ab)(true, "change_password");
        const res = await (0,ct_service/* requestForChangePassword */.HB)({
            oldPassword: sessionStorage.getItem("OTPPassword"),
            newPassword,
            id: sessionStorage.getItem("userIdForOTP")
        });
        if (res && res.status === 200) {
            successCb();
        } else {
            errorCB(res.data);
        }
    };
    const handleShowAuthModal = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        addAnalyticsShowAuthModal();
    };
    const handleShowRequirements = ()=>{
        setShowRequirements(!showRequirements);
        addAnalyticsShowRequirements();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).ChangePassword,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "wrapper",
            children: !showSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: resetPasswordText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: newPasswordDescriptionText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "kf-change-password",
                        type: "password",
                        value: password.value,
                        maxLength: 40,
                        placeholder: "".concat(passwordLabelText),
                        label: "".concat(passwordLabelText),
                        onChange: (e)=>setPassword({
                                ...password,
                                value: e.target.value
                            }),
                        showError: password.error,
                        errorMessage: password.errorMssg,
                        onBlur: (e)=>onBlurInput("pwd", e.target.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "password-requirements",
                        onClick: handleShowRequirements,
                        children: passwordRequirementsText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "password-requirements__tooltip".concat(showRequirements ? "--show" : "--hide"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "password-requirements__tooltip-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                message: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePassword_PasswordRequirements, {
                                    passwordRegExp: passwordRegExp
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "kf-change-re-password",
                        type: "password",
                        value: rePassword.value,
                        maxLength: 40,
                        placeholder: "".concat(reEnterPasswordText),
                        label: "".concat(reEnterPasswordText),
                        onChange: (e)=>setRePassword({
                                ...rePassword,
                                value: e.target.value
                            }),
                        showError: rePassword.error,
                        errorMessage: rePassword.errorMssg,
                        onBlur: (e)=>onBlurInput("re-pwd", e.target.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        flexible: true,
                        label: resetPasswordLabelText,
                        onClick: handleResetPassword,
                        customClass: "reset-button",
                        loading: loading,
                        role: "button"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "".concat(passwordSuccessText, "!")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: successMessageText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        flexible: true,
                        label: signinText,
                        onClick: handleShowAuthModal
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_ChangePassword = (ChangePassword);


/***/ }),

/***/ 42426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cu": function() { return /* binding */ doubleFeatureContentCardSettings; },
  "UD": function() { return /* binding */ isProductFeatureLandscapeCarouselUpdatePage; },
  "NW": function() { return /* binding */ singleSliderSettings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/Arrow.jsx

const Arrow = (props)=>{
    const { className ="" , style ="" , onClick =()=>{} , label ="" , topPosition =0 , addAnalyticsForArrows =()=>{}  } = props;
    const clickHandler = (e, label)=>{
        onClick && onClick(e);
        addAnalyticsForArrows(label);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: className,
        type: "button",
        "aria-label": label,
        style: {
            ...style,
            top: topPosition ? topPosition : ""
        },
        onClick: (e)=>clickHandler(e, label)
    });
};
/* harmony default export */ var v1_Arrow = (Arrow);

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/SlickSettings.js


const doubleFeatureContentCardSettings = {
    dots: false,
    infinite: true,
    fade: true,
    autoplay: false,
    cssEase: "ease-in-out",
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
};
const singleSliderSettings = function(cb, topPosition, autoplay, autoplaySpeed, addAnalyticsForArrows) {
    let afterChangeCb = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{};
    return {
        autoplay,
        autoplaySpeed,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false,
        beforeChange: (_, current)=>cb ? cb(current + 1, current) : undefined,
        afterChange: (a, b)=>afterChangeCb ? afterChangeCb(a, b) : undefined,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Next",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Previous",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        })
    };
};
const PRODUCT_FEATURE_LANDSCAPE_CAROUSEL_UPDATED = "product feature landscape carousel updated";
const isProductFeatureLandscapeCarouselUpdatePage = (pageName)=>{
    return pageName && (pageName === null || pageName === void 0 ? void 0 : pageName.trim().toLowerCase()) === PRODUCT_FEATURE_LANDSCAPE_CAROUSEL_UPDATED;
};


/***/ }),

/***/ 73846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        searchBrand: t("kf.search.label.searchBrand"),
        popularSearchText: t("kf.search.label.popularSearch"),
        topProductResults: (category)=>category !== "products" ? t("kf.search.label.topResults") : t("kf.search.label.topProductResults"),
        recentSearches: t("kf.search.label.recentSearch"),
        clearAll: t("kf.search.label.clearAll"),
        see: t("kf.search.label.see"),
        all: t("kf.search.label.all"),
        resultText: t("kf.search.label.resultsCaps"),
        searchCTA: t("kf.search.label.searchCTA"),
        top: t("kf.search.label.top"),
        product: t("kf.search.label.products"),
        topResult: t("kf.search.label.topResults"),
        saleText: t("kf.search.label.topResults"),
        colors: t("kf.search.label.colors"),
        color: t("kf.search.label.color"),
        brand: t("kf.search.label.brand"),
        new: t("kf.search.label.new"),
        sale: t("kf.search.label.sale"),
        topSuggestions: t("kf.search.label.topSuggestions"),
        yourSearch: t("kf.search.label.yourSearch"),
        seeAll: t("kf.search.label.seeAll"),
        results: t("kf.search.label.resultsCaps"),
        searchHeader: t("kf.search.label.searchHeader"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        favRemoveSuccessMsg: t("kf.favorites.removeItem"),
        favRemoveErrorMsg: t("kf.favorites.removeItemError"),
        modelNumber: t("kf.registerOfflineProduct.label.modelNumber"),
        etc: t("kf.plp.label.etc"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        addToCompare: t("kf.plp.label.addToCompare"),
        onSale: t("kf.plp.label.onSale"),
        ariaLabel: {
            close: t("kf.search.aria.label.close"),
            delete: (keyword)=>t("kf.search.aria.label.delete", {
                    keyword
                }),
            continue: t("kf.global.aria.label.continue"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                })
        },
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        globalHome: t("kf.global.label.home"),
        featured: t("kf.plp.label.featured"),
        searchCategoryTitle: t("kf.visualsearch.page.searchImage"),
        searchByImage: t("kf.Globalvisualsearch.searchCategoryTitle.text"),
        searchInputHint: t("kf.search.aria.label.suggestionsHint")
    };
};


/***/ }),

/***/ 33507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ addSearchAnalytics; },
/* harmony export */   "e": function() { return /* binding */ handleSearchAnalyticsEvent; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const handleSearchAnalyticsEvent = (status, message, internalLinkURL, eventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName)=>{
    if (!internalLinkURL) internalLinkURL = redirectUrl;
    const eventInfo = getEventInfoObj(status, message, internalLinkURL, eventType, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
    sessionStorage.setItem("searches", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getEventInfoObj = (status, message, internalLinkURL, eventType, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName)=>{
    const currDate = new Date();
    const contentType = window.adobeDataLayer && window.adobeDataLayer.getState ? window.adobeDataLayer.getState("page.pageInfo.contentType") || window.adobeDataLayer.getState("page.category.primaryCategory") : "";
    const pageName = contentType ? contentType.split("-")[0] : "";
    const autoSearch = !internalLinkURL ? true : false;
    const searchSuggestedTerm = [];
    if (!analyticsEventData.searchString) {
        analyticsEventData.searchString = searchString;
    }
    if (!analyticsEventData.searchTotal) {
        analyticsEventData.searchTotal = searchTotal;
    }
    if (!analyticsEventData.topSuggestedData) {
        analyticsEventData.topSuggestedData = topSuggestedData;
    }
    const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
    if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
        searchSuggestions.slice(0, 5).map((item)=>{
            searchSuggestedTerm.push((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(item.productName_s || item.keyWord));
        });
    }
    const eventInfo = {
        eventName: "internal ".concat(autoSearch ? "automatic " : "", "search"),
        eventAction: "internal ".concat(autoSearch ? "automatic " : "", "search"),
        internalLinkName: "internal search icon",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
        internalLinkPosition: "global header",
        eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
        eventStatus: status || "n/a",
        searchTerm: analyticsEventData.searchString,
        searchContentType: pageName ? pageName + " page" : "n/a",
        searchSuggestedTerm: searchSuggestedTerm.join("|") || "n/a",
        searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
        searchResult: analyticsEventData.searchTotal,
        internalZoneName: "search:search box",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
        contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
    };
    if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
        eventType.term = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(eventType.term);
        eventType.type = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(eventType.type);
        eventInfo.eventName = "search:" + eventType.type + ":search term";
        eventInfo.eventAction = "search:" + eventType.type + ":search term";
        eventInfo.internalLinkZoneName = "search:" + eventType.type;
        if (eventType.type === "our top suggestions") {
            var ref;
            eventInfo.searchTerm = (ref = analyticsEventData.searchString) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            eventInfo.searchSuggestedTerm = eventType.term;
        } else {
            eventInfo.searchTerm = eventType.term;
        }
        eventInfo.internalLinkName = eventType.term;
        eventInfo.internalZoneName = "search:" + eventType.type;
    }
    analyticsEventData = {};
    return eventInfo;
};
const addSearchAnalytics = (params, general, searchKeyword)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { total , errorMessage , status , autoSearch , keyword ="" , tabCountObj ={} , isSterlingTemp , searchCountIncreased =true , urlFlag =false , clear , tagger  } = params;
    const action = autoSearch ? "cmp:click" : params === null || params === void 0 ? void 0 : params.action;
    const { productTabCount , helpTabCount , resourceTabCount , technicalTabCount , inspireTabCount , partTabCount  } = tabCountObj;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window === null || window === void 0 ? void 0 : window.pageObj : getState && getState("page") || {};
    const contentType = window.eventPageType || "";
    const pageName = contentType ? contentType.split("-")[0] : "";
    const previousPageNameForSearch = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("previousPageNameForSearch");
    const previousUrlNew = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("previousUrl");
    sessionStorage.removeItem("previousUrl");
    const currDate = new Date();
    const eventInfo = {
        searchCount: (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("searches")) ? Number(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("searches")) + (searchCountIncreased ? 1 : 0) : 1,
        searchResult: isSterlingTemp ? "".concat(productTabCount) : total,
        searchResultCategory: isSterlingTemp ? "products>".concat(productTabCount) : "products>".concat(productTabCount, "|parts>").concat(partTabCount, "|inspiration>").concat(inspireTabCount, "|technical>").concat(technicalTabCount, "|resources>").concat(resourceTabCount, "|help>").concat(helpTabCount),
        internalLinkName: "search",
        internalLinkPosition: "search results:search",
        internalLinkType: autoSearch ? "search:automatic search" : "search results:search:navigation",
        searchContentType: pageName ? pageName + " page" : "n/a",
        searchTerm: tagger === "FROM TYPEAHEAD SUGGESTION" ? clear : keyword.length ? keyword : searchKeyword,
        searchSuggestedTerm: tagger === "FROM TYPEAHEAD SUGGESTION" ? keyword.length ? keyword.toLowerCase() : searchKeyword.toLowerCase() : "n/a",
        eventAction: "search:search box:".concat(autoSearch ? "automatic " : "", "search"),
        eventName: "search:search box:".concat(autoSearch ? "automatic " : "", "search"),
        eventType: "navigation",
        clickInternalLinks: "true",
        internalLinkURL: action === "cmp:show" ? "n/a" : window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href,
        internalZoneName: "search:search box",
        eventMsg: errorMessage || "n/a",
        eventStatus: status === "success" ? "success" : "failure",
        pageName: "search result",
        pageURL: urlFlag ? previousUrlNew : window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href,
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "n/a",
        previousPage: previousPageNameForSearch || (document === null || document === void 0 ? void 0 : document.referrer) || "n/a",
        timeStamp: ((ref2 = currDate === null || currDate === void 0 ? void 0 : currDate.toISOString()) === null || ref2 === void 0 ? void 0 : ref2.split("T")[0]) + " " + ((ref3 = currDate === null || currDate === void 0 ? void 0 : currDate.toTimeString()) === null || ref3 === void 0 ? void 0 : ref3.split(" ")[0]),
        mktgCampaign: "n/a",
        contentType: general === null || general === void 0 ? void 0 : (ref4 = general.brandName) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
        internalLinkZoneName: "search:search box"
    };
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("searches", eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.searchCount);
    let { pageInfo: { pageUrl: tempUrl  }  } = page;
    tempUrl = window === null || window === void 0 ? void 0 : (ref5 = window.location) === null || ref5 === void 0 ? void 0 : ref5.href;
    page.pageInfo.pageUrl = urlFlag ? previousUrlNew : tempUrl;
    page.pageInfo.previousPage = previousPageNameForSearch;
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, action, page);
};



/***/ }),

/***/ 30167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ getStoreEventInfo; },
/* harmony export */   "CS": function() { return /* binding */ zipCodeInfoModalContinueAnalytics; },
/* harmony export */   "DO": function() { return /* binding */ addFindAStoreAnalytics; },
/* harmony export */   "HS": function() { return /* binding */ locationMessageNavigationAnalytics; },
/* harmony export */   "LX": function() { return /* binding */ setStoreAnalytics; },
/* harmony export */   "OQ": function() { return /* binding */ addAnalyticsData; },
/* harmony export */   "Qq": function() { return /* binding */ pushAnalyticsToDataLayer; },
/* harmony export */   "Us": function() { return /* binding */ getFilterEventInfo; },
/* harmony export */   "X1": function() { return /* binding */ addAnalyticsEvent; },
/* harmony export */   "dm": function() { return /* binding */ getEventClearFilterInfo; },
/* harmony export */   "hE": function() { return /* binding */ getEventStoreFilterInfo; },
/* harmony export */   "pm": function() { return /* binding */ findAStoreLoadMoreAnalytics; },
/* harmony export */   "rt": function() { return /* binding */ getEventStorePhoneInfo; },
/* harmony export */   "wo": function() { return /* binding */ addFilterExpandCollapseAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const pageType = "find a store";
const addFindAStoreAnalytics = (params)=>{
    const { total , errorMessage , status , action , authorData , staticTexts , searchTerm , geolocationEvent  } = params;
    const errMsg = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oOy)(authorData.locationErrormessage ? authorData.locationErrormessage : staticTexts.locationErrormessage).trim().toLowerCase();
    let eventAction = "find a store:landing:location info:store search";
    let eventName = "find a store:landing:location info:store search";
    const eventStatus = status === "success" && total ? "success" : "failure";
    let internalLinkName = "store search";
    let internalLinkZoneName = "find a store:landing:location info:filters";
    if (geolocationEvent) {
        eventAction = "find a store:utility nav​:view store details:use my location";
        eventName = "find a store:utility nav​:view store details:use my location";
        internalLinkName = "use my location";
        internalLinkZoneName = "find a store:utility nav";
    }
    const currDate = new Date();
    const eventInfo = {
        searchCount: sessionStorage.getItem("findStores") ? Number(sessionStorage.getItem("findStores")) + 1 : 1,
        searchResult: total,
        internalLinkName,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        searchType: isNaN(searchTerm) || geolocationEvent ? "location" : "zipcode",
        searchTerm: searchTerm,
        eventAction,
        eventName,
        eventType: "navigation",
        clickInternalLinks: "true",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName,
        eventMsg: status === "success" && total ? "n/a" : errorMessage || errMsg || "n/a",
        eventStatus,
        pageName: "find a store result",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0]
    };
    if (action === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() || action !== "cmp:show") {
        sessionStorage.setItem("findStores", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const event = !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() ? "cmp:show" : action;
        const page = event === "cmp:show" ? window.pageObj : getState && getState("page") || {};
        if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .navigationType */ .UsO)() !== 1 && event === "cmp:show" || event === "cmp:click") {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, event, page);
        }
        delete window.pageObj;
    }
};
const findAStoreLoadMoreAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:load more results",
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:load more results",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "load more results",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:load more results",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getFilterEventInfo = (showFilter)=>{
    const type = showFilter ? "show filter" : "hide filter";
    const internalLinkType = "find a store:".concat(showFilter ? "show" : "hide");
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type, "s"),
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:filters"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getStoreEventInfo = (type, internalLinkName, link)=>{
    return JSON.stringify({
        eventAction: "find a store:landing:location info:" + type,
        eventName: "find a store:landing:location info:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName ? internalLinkName.toLowerCase() : type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:landing:location info",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStoreFilterInfo = (data, type, link)=>{
    let internalLinkName;
    let internalLinkType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(data.LocationName);
    const internalLinkTypeForFindStore = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getInternalLinkTypeForFindStore */ .dhb)(data.LocationName, data.Locality, data.StateLong);
    if (type === "store name") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(data.LocationName);
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    } else if (type === "store contact number") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .formatPhoneNumber */ .unW)(data.Phone);
        internalLinkType = "find a store:navigation";
    } else if (type === "set as preferred store" || type === "unset as preferred store") {
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    }
    const eventInfo = {
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: link ? (type !== "store contact number" && link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getEventStorePhoneInfo = (PhoneNumber, tabTitle, link)=>{
    const internalLinkPhoneType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .formatPhoneNumber */ .unW)(PhoneNumber);
    const eventInfo = {
        eventAction: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventName: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkPhoneType,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(tabTitle === null || tabTitle === void 0 ? void 0 : tabTitle.toLowerCase()),
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: internalLinkPhoneType === null ? link || "n/a" : "tel:".concat(PhoneNumber),
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo
    });
};
const addAnalyticsData = (curFilters, isChecked, obj, isFilterCancel)=>{
    const { facet , value: label  } = obj;
    const filterLabel = label || obj.display;
    const appliedOrRemoved = isFilterCancel ? "cancel" : isChecked ? "applied" : "removed";
    const eventInfo = {
        eventAction: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventName: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase(), ":").concat(appliedOrRemoved),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(facet === null || facet === void 0 ? void 0 : facet.toLowerCase()),
        filterArray: "".concat((facet === null || facet === void 0 ? void 0 : facet.toLowerCase()) + ":" + (filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase())),
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    let filterArray = "";
    if (curFilters.length > 0) {
        curFilters.forEach((facetObj)=>{
            facetObj.value.forEach((facetValue)=>{
                filterArray += facetObj.facet.toLowerCase() + ":" + facetValue.toLowerCase() + "|";
            });
        });
    }
    eventInfo.filterArray = filterArray === null || filterArray === void 0 ? void 0 : filterArray.slice(0, -1);
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const addFilterExpandCollapseAnalytics = (facet, formatFacetName, collapse)=>{
    const collapseOrExpand = collapse[facet] ? "expand" : "collapse";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:filters:".concat(collapseOrExpand),
        eventName: "find a store:landing:filters:".concat(collapseOrExpand),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(collapseOrExpand),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(formatFacetName === null || formatFacetName === void 0 ? void 0 : formatFacetName.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "find a store:landing:filters​"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getEventClearFilterInfo = ()=>{
    return JSON.stringify({
        eventAction: "find a store:landing:filters:clear all",
        eventName: "find a store:landing:filters:clear all",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:filters",
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const addAnalyticsEvent = function(action) {
    let isForLocateMe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const type = isForLocateMe ? "" : "zoom ";
    const linkType = isForLocateMe ? "navigation" : "zoom";
    const eventInfo = {
        eventAction: "find a store:landing:map:".concat(type).concat(action),
        eventName: "find a store:landing:map:".concat(type).concat(action),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type).concat(action),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(linkType),
        internalLinkZoneName: "find a store:landing:map",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const setStoreAnalytics = (checked, locationName)=>{
    const type = checked ? "set as preferred store" : "unset as preferred store";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:".concat(type),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(locationName === null || locationName === void 0 ? void 0 : locationName.toLowerCase()),
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const zipCodeInfoModalContinueAnalytics = (ctaLabel, dataLayerPosition)=>{
    const label = ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.toLowerCase();
    let eventName = "find a store:utility nav:view store details:".concat(label);
    let internalLinkPosition = "find a store";
    let internalLinkType = "find a store:navigation";
    let internalLinkZoneName = "find a store:modal:cant access your location";
    if (dataLayerPosition === "global header") {
        eventName = "find a store:utility nav:use my location:".concat(label);
        internalLinkPosition = "global header:find a store";
    }
    if (dataLayerPosition === "find a pro") {
        eventName = "find a pro:see local professionals:use my location:".concat(label);
        internalLinkPosition = "find a pro";
        internalLinkType = "find a pro:use my location";
        internalLinkZoneName = "find a pro:see local professionals";
    }
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: eventName,
        eventMsg: "n/a",
        eventName,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(label),
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const locationMessageNavigationAnalytics = (param)=>{
    let { link ="" , label ="" , zone =""  } = param;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: label,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getAnalyticsUrl */ .Uho)(link),
        internalLinkZoneName: "".concat(pageType, ":").concat(zone)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const pushAnalyticsToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


/***/ }),

/***/ 2182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getFindAStoresResult; },
/* harmony export */   "T": function() { return /* binding */ getAutoSuggestionsInputBased; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);

const getFindAStoresResult = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", disMiles = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100, maxStorePerPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 10, locationType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", page = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, sku = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    const params = {
        address,
        brand: brand.toLowerCase(),
        disMiles,
        maxItemPerPage: maxStorePerPage,
        locationType: locationType.toLowerCase(),
        page
    };
    if (sku) params["sku"] = sku;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params
    });
};
const getAutoSuggestionsInputBased = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", input = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params: {
            $format: "json",
            brand: brand.toLowerCase(),
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(input, "') eq true")
        }
    });
};


/***/ }),

/***/ 90062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pj": function() { return /* binding */ headerFindStoreUseLocationAnalytics; },
/* harmony export */   "Zj": function() { return /* binding */ headerViewAllStoreAnalytics; },
/* harmony export */   "cY": function() { return /* binding */ addFindStoreAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const addFindStoreAnalytics = (zipCodeValue, zipCodeError)=>{
    const { show , message  } = zipCodeError;
    const eventMsg = show ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a";
    const eventStatus = show ? "failure" : "success";
    const eventInfo = {
        eventAction: "find a store:utility nav:submit",
        eventName: "find a store:utility nav:submit",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "submit",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const headerFindStoreUseLocationAnalytics = (param)=>{
    let { errorMessage ="" , staticTexts ={} , eventStatus =""  } = param;
    const eventMsg = errorMessage ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(errorMessage ? errorMessage : staticTexts.locationErrormessage) : "n/a";
    const eventInfo = {
        eventAction: "find a store:utility nav:use my location",
        eventName: "find a store:utility nav:use my location",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "use my location",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const headerViewAllStoreAnalytics = (browseAllStoreUrl)=>{
    const eventInfo = {
        eventAction: "find a store:utility nav:view all stores",
        eventName: "find a store:utility nav:view all stores",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view all stores",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "".concat(window.location.origin).concat(browseAllStoreUrl),
        clickInternalLinks: "true"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};



/***/ }),

/***/ 26977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        useLocation: t("kf.findStoreUtilNav.label.useLocation"),
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        submit: t("kf.global.label.submit"),
        findStore: t("kf.findStoreUtilNav.label.findStore"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        kohlerText: t("kf.findStoreUtilNav.label.kohler"),
        signStore: t("kf.findStoreUtilNav.label.signStore"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        myStoreText: t("kf.findStoreUtilNav.label.myStoreText"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        closeAlt: t("kf.findStoreUtilNav.label.closeAlt"),
        menu: t("kf.findStoreUtilNav.label.menu"),
        leftArrow: t("kf.findStoreUtilNav.label.leftArrow"),
        enterZipCode: t("kf.findStoreUtilNav.label.enterZipCode"),
        zipcode: t("kf.findStoreUtilNav.zipcode"),
        validZipcode: t("kf.findStoreUtilNav.validZipcode"),
        MessageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        zipcodeEmptyError: t("kf.findStoreUtilNav.zipcodeEmptyError"),
        continue: t("kf.checkout.label.continue"),
        ariaLabel: {
            enterZipCode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            submit: t("kf.findStoreUtilNav.aria.label.submit")
        },
        enterCityStateZip: t("kf.findStoreUtilNav.label.countryPlaceholder"),
        skipToMainContent: t("kf.main.content.ariaLabel")
    };
};


/***/ }),

/***/ 87066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var _components_GlobalVisualSearch_localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83942);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);
/* harmony import */ var _kohler_dsm_library_kohler_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3171);
/* harmony import */ var _components_GlobalVisualSearch_ErrorFallBack_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(204);
/* harmony import */ var _components_GlobalVisualSearch_ErrorFallBack_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_GlobalVisualSearch_ErrorFallBack_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);








const ErrorFallBack = (props)=>{
    const { errorPage  } = props || {};
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { errorText , contactUs , errorSubText  } = (0,_components_GlobalVisualSearch_localization__WEBPACK_IMPORTED_MODULE_5__/* .getTranslations */ .F)(t);
    const viewGuide = (url)=>{
        window.open(url, "_blank");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_components_GlobalVisualSearch_ErrorFallBack_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ErrorContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "error-section ".concat(errorPage ? "error-page" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "sorry-section",
                        children: errorText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "try-section",
                        children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeInnerHtml */ .KD0)(errorSubText)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_kohler_dsm_library_kohler_core__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                component: "button",
                className: "contact-us-button",
                size: "medium",
                onClick: ()=>viewGuide(_constants_index__WEBPACK_IMPORTED_MODULE_3__.CONTACT_US_PAGE_URL_US),
                children: contactUs
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorFallBack);


/***/ }),

/***/ 31980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlobalVisualSearch_GlobalVSContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/GlobalVSContent/index.module.scss
var index_module = __webpack_require__(13803);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/close-icon-black.svg
/* harmony default export */ var close_icon_black = ({"src":"/_next/static/media/close-icon-black.87a5a011.svg","height":10,"width":10});
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs + 2 modules
var Tooltip = __webpack_require__(23293);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/analytics/index.js + 1 modules
var analytics = __webpack_require__(77612);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/localization.js
var localization = __webpack_require__(83942);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/GlobalVSContent/icons.js

const GlobalVisualSearchIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: "global-visual-search-icon",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 17C1.5 17.8284 2.17157 18.5 3 18.5H8V19.5H3C1.61929 19.5 0.5 18.3807 0.5 17V12H1.5V17Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 17C19.5 18.3807 18.3807 19.5 17 19.5H12V18.5H17C17.8284 18.5 18.5 17.8284 18.5 17V12H19.5V17Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 5.5C12.4853 5.5 14.5 7.51472 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10C5.5 7.51472 7.51472 5.5 10 5.5ZM10 6.5C8.067 6.5 6.5 8.067 6.5 10C6.5 11.933 8.067 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.067 11.933 6.5 10 6.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V8H0.5V3C0.5 1.61929 1.61929 0.5 3 0.5H8V1.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 0.5C18.3807 0.5 19.5 1.61929 19.5 3V8H18.5V3C18.5 2.17157 17.8284 1.5 17 1.5H12V0.5H17Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 3.5C16.0523 3.5 16.5 3.94772 16.5 4.5C16.5 5.05228 16.0523 5.5 15.5 5.5C14.9477 5.5 14.5 5.05228 14.5 4.5C14.5 3.94772 14.9477 3.5 15.5 3.5Z",
                fill: "currentColor"
            })
        ]
    });

// EXTERNAL MODULE: ./components/GlobalVisualSearch/GlobalVisualSearch.js + 23 modules
var GlobalVisualSearch = __webpack_require__(59522);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/GlobalVSContent/index.jsx










const GlobalVSContent = (props)=>{
    const { openVisualSearch , setOpenVisualSearch =()=>{} , className ="" , isFirstTime , setShowSearchBar =()=>{} , setIsFirstTime =()=>{} , onClickHandler =()=>{}  } = props || {};
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { newSearchTitle ="" , photoSelectLibrary ="" , gotIt ="" , searchImageText =""  } = staticText;
    (0,react.useEffect)(()=>{
        if (true) {
            const storedValue = localStorage.getItem("usingVSforFirstTime");
            if (storedValue === null) {
                localStorage.setItem("usingVSforFirstTime", "true");
                setIsFirstTime(true);
            } else {
                setIsFirstTime(storedValue === "true");
            }
        }
    }, []);
    (0,react.useEffect)(()=>{
        const handleGlobalClick = ()=>{
            const hasSeenTooltip = localStorage.getItem("usingVSforFirstTime");
            if (hasSeenTooltip === "true") {
                localStorage.setItem("usingVSforFirstTime", "false");
                setIsFirstTime(false);
            }
        };
        document.body.addEventListener("click", handleGlobalClick);
        return ()=>{
            document.body.removeEventListener("click", handleGlobalClick);
        };
    }, [
        isFirstTime
    ]);
    const handleGotItClick = ()=>{
        (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
            event: "got-it"
        });
        localStorage.setItem("usingVSforFirstTime", "false");
        setIsFirstTime(false);
    };
    (0,react.useEffect)(()=>{
        if (isFirstTime) {
            (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
                event: "new-search"
            });
        }
    }, []);
    const handleIconClick = ()=>{
        if (!isFirstTime) {
            setOpenVisualSearch(true);
            onClickHandler && onClickHandler();
            (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
                event: "search_icon_click"
            });
        }
    };
    const renderVSIcon = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: handleIconClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearchIcon, {})
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((index_module_default()).GlobalVisualSearchContainer, " ").concat(className, " ").concat(isFirstTime && "firstTime_shadow"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                children: isFirstTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        className: "".concat((index_module_default()).firstTimeVSContainer, " ").concat(isFirstTime && "firstTimeIcon_shadow"),
                        children: [
                            renderVSIcon(),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                align: "start",
                                justify: "space-between",
                                direction: "column",
                                gap: "15px",
                                className: (index_module_default()).tooltipBoxNew,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).tooltipBoxCont,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).tooltipBoxContHead,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        size: "label-medium-l",
                                                        children: newSearchTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        size: "paragraph-l",
                                                        children: photoSelectLibrary
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).tooltipBoxCloseIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onClick: handleGotItClick,
                                                    src: close_icon_black.src,
                                                    alt: "close",
                                                    "aria-hidden": true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pr-5 pb-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            size: "small",
                                            fullWidth: true,
                                            variant: "secondary",
                                            onClick: handleGotItClick,
                                            children: gotIt
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        size: "paragraph-l",
                        children: searchImageText
                    }),
                    offset: 20,
                    position: "bottom",
                    className: "visualSearchTooltip",
                    mod: "white",
                    children: renderVSIcon()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch/* default */.Z, {
                openVisualSearch: openVisualSearch,
                setOpenVisualSearch: setOpenVisualSearch,
                setShowSearchBar: setShowSearchBar
            })
        ]
    });
};
/* harmony default export */ var GlobalVisualSearch_GlobalVSContent = (GlobalVSContent);


/***/ }),

/***/ 59522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlobalVisualSearch_GlobalVisualSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Modal/Modal.mjs + 2 modules
var Modal = __webpack_require__(80891);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
// EXTERNAL MODULE: ./components/VisualSearch/v1/CameraView/index.jsx + 5 modules
var CameraView = __webpack_require__(4680);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(12002);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./components/VisualSearch/v1/UploadImage/constant.js + 30 modules
var constant = __webpack_require__(68637);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/analytics/index.js + 1 modules
var analytics = __webpack_require__(77612);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/localization.js
var localization = __webpack_require__(83942);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/FileUpload/index.module.scss
var index_module = __webpack_require__(5835);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/FileUpload/index.jsx










const MAX_FILE_SIZE_MB = 20;
const FileUpload = (props)=>{
    const { setImage , category ="faucets"  } = props || {};
    const [error, setError] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { isMediumScreen  } = (0,useViewport/* default */.Z)();
    let heic2any = null;
    (0,react.useEffect)(()=>{
        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23)).then((module)=>{
            heic2any = module.default;
        });
    }, []);
    const { dragAndDrop ="" , dropFilesHere ="" , orText ="" , uploadAFileButton ="" , imageUploadFileExtError ="" , imageUploadFileSizeError =""  } = staticText;
    const onDrop = (0,react.useCallback)((acceptedFiles, fileRejections)=>{
        const eventTye = (event === null || event === void 0 ? void 0 : event.type) ? "upload a file" : "drag an image here";
        let imageUploaderrorMessage = "";
        setError("");
        if (fileRejections.length > 0) {
            const rejection = fileRejections[0];
            const { errors  } = rejection;
            errors.forEach((err)=>{
                if (err.code === "file-too-large") {
                    setError(imageUploadFileSizeError(MAX_FILE_SIZE_MB));
                    imageUploaderrorMessage = imageUploadFileSizeError(MAX_FILE_SIZE_MB);
                } else if (err.code === "file-invalid-type") {
                    setError(imageUploadFileExtError);
                    imageUploaderrorMessage = imageUploadFileExtError;
                }
                (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
                    event: "image_upload",
                    browse: eventTye,
                    category: category,
                    errrorMessage: imageUploaderrorMessage
                });
            });
            return;
        }
        let file = acceptedFiles[0];
        const heicType = [
            "image/heif",
            "image/heic"
        ];
        const isHeicimg = heicType.includes(file === null || file === void 0 ? void 0 : file.type);
        if (isHeicimg) {
            heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.9
            }).then((res)=>{
                file = new File([
                    res
                ], file.name, {
                    type: res.type,
                    lastModified: new Date().getTime()
                });
                if (file) {
                    reader.readAsDataURL(file);
                }
            });
        }
        const reader = new FileReader();
        reader.onload = (event1)=>{
            const dataURL = event1.target.result;
            const img = new Image();
            img.onload = ()=>{
                const fileData = {
                    file,
                    width: img.width,
                    height: img.height,
                    dataURL
                };
                setImage([
                    fileData
                ]);
            };
            img.src = dataURL;
        };
        if (!isHeicimg && file) {
            reader.readAsDataURL(file);
        }
    }, [
        setImage
    ]);
    const { getRootProps , getInputProps , open , isDragActive  } = (0,es/* useDropzone */.uI)({
        onDrop,
        maxSize: MAX_FILE_SIZE_MB * 1024 * 1024,
        accept: constant/* ACCEPTED_FORMATS */.K8,
        noKeyboard: true
    });
    const handleDragAndDrop = (event1)=>{
        event1.preventDefault();
        (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
            event: "image_upload",
            browse: "drag an image here",
            category: category
        });
    };
    const uploadImageOperation = ()=>{
        (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
            event: "image_upload",
            browse: "upload a file",
            category: category
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        direction: "column",
        justify: "center",
        align: "center",
        gap: "25px",
        className: "".concat((index_module_default()).FileUploadContainer, " ").concat(error && "pb-27"),
        onClick: open,
        ...getRootProps(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            direction: "column",
            justify: "center",
            align: "center",
            gap: "25px",
            onDrop: handleDragAndDrop,
            className: (index_module_default()).DropzoneArea,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    accept: constant/* IMAGE_FILE_TYPE */.bG,
                    "aria-label": "Input Images",
                    ...getInputProps()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    justify: "center",
                    align: "center",
                    gap: "15px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            component: "h5",
                            size: "heading-h5",
                            children: isDragActive ? dropFilesHere : dragAndDrop
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            size: "label-regular-m",
                            children: orText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    justify: "center",
                    align: "center",
                    gap: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "small",
                            fullWidth: isMediumScreen,
                            variant: "secondary",
                            onClick: uploadImageOperation,
                            children: uploadAFileButton
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            size: "label-regular-xs",
                            className: (index_module_default()).ImageUploadError,
                            children: error
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_FileUpload = (FileUpload);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/vsresultSlice.js
var vsresultSlice = __webpack_require__(16407);
;// CONCATENATED MODULE: ./public/icons/left-back-icon.svg
/* harmony default export */ var left_back_icon = ({"src":"/_next/static/media/left-back-icon.527982cd.svg","height":18,"width":26});
;// CONCATENATED MODULE: ./public/icons/back-arraow-white-icon.svg
/* harmony default export */ var back_arraow_white_icon = ({"src":"/_next/static/media/back-arraow-white-icon.be51ffb9.svg","height":30,"width":26});
// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/ErrorFallBack/index.js
var ErrorFallBack = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 1 modules
var styleProps = __webpack_require__(79111);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/CustomGrid/CustomGrid.module.css.mjs
var classes = {
    "root": "-qJsY"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/CustomGrid/CustomGrid.utils.mjs
const GRID_STYLE_PROPS_DATA = {
    gap: {
        type: "spacing",
        property: "gap"
    },
    rowGap: {
        type: "spacing",
        property: "rowGap"
    },
    columnGap: {
        type: "spacing",
        property: "columnGap"
    },
    columns: {
        type: "identity",
        property: "gridTemplateColumns"
    },
    autoRows: {
        type: "identity",
        property: "gridAutoRows"
    },
    autoFlow: {
        type: "identity",
        property: "gridAutoFlow"
    },
    templateRows: {
        type: "identity",
        property: "gridTemplateRows"
    },
    templateAreas: {
        type: "identity",
        property: "gridTemplateAreas"
    },
    templateColumns: {
        type: "identity",
        property: "gridTemplateColumns"
    },
    justifyItems: {
        type: "identity",
        property: "justifyItems"
    },
    alignItems: {
        type: "identity",
        property: "alignItems"
    },
    justifyContent: {
        type: "identity",
        property: "justifyContent"
    },
    alignContent: {
        type: "identity",
        property: "alignContent"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/CustomGrid/CustomGrid.mjs










const CustomGrid = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , gap , rowGap , columnGap , columns , autoRows , autoFlow , templateRows , templateAreas , templateColumns , justifyItems , alignItems , justifyContent , alignContent , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: (0,helpers/* removeEmptyProps */.t_)({
            gap,
            rowGap,
            columnGap,
            columns,
            autoRows,
            autoFlow,
            templateRows,
            templateAreas,
            templateColumns,
            justifyItems,
            alignItems,
            justifyContent,
            alignContent
        }),
        data: GRID_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(classes.root, className, "kohler-grid-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
        ...style,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        style: parsedStyles,
        component,
        ...rest
    }));
});


// EXTERNAL MODULE: ./components/GlobalVisualSearch/globalvisualsearch.module.scss
var globalvisualsearch_module = __webpack_require__(2160);
var globalvisualsearch_module_default = /*#__PURE__*/__webpack_require__.n(globalvisualsearch_module);
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/faucets/faucets_category.png
/* harmony default export */ var faucets_category = ({"src":"/_next/static/media/faucets_category.d88f22d2.png","height":130,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEXT1Nng4OPNt4/e0LnRxbDn5ubU09TX19vp6+/Jw7vg1cvW0s7cxqvMqnDNuJ/TzcnCsa3Mt5TNuZbWvI2wrafIxsbHo4jEt6m1m4+pGjwxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImR3GSRLAIAgEwEERRHHL/v+XJpU+Naodp3FxdDbm6B0A1qjrgqqEKrf9GTofQCS0QhO0tT2mnFGiJ/ryAlYfAkNTp7rrAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/toilets/toilets_category.png
/* harmony default export */ var toilets_category = ({"src":"/_next/static/media/toilets_category.d9c7e049.png","height":130,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEVpWU93aF6DXUWNf3htRCzk4+SfdVmPYER0YVaAbWOai4Kng2d/c2xiTkHFwL+Va1La2Ni8urp0UTp1WkhlPyuhlo9SRDxHNizXzspHKRa9rqWghHF3VgDUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBBwLAIAgEsFNBwD26///QJsgVrpgKMkqbIUVEBB7mO7wFZlsCcmmcuiNIXUt1exwKntf9QqQ/3yL6AUzrAnao3mcpAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/showers/showers_category.png
/* harmony default export */ var showers_category = ({"src":"/_next/static/media/showers_category.f51f0432.png","height":131,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEVraWxgX2BPTElVU1N9cmI8PD9DQT9zZEljV0JYWFt7bFCOgGlxZ1WVektwbWvNr3jT/64MAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImSXGxxHAMAwDMIrqbtl/21xivAAVHJMONDCGSUAA1jP9i64J3qz+wzQldFtkliO2eZH+AimdATI0mXCiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/valves/valves_category.png
/* harmony default export */ var valves_category = ({"src":"/_next/static/media/valves_category.df1dfc4e.png","height":131,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEX5+fr49/b9/v/z8vCeiWvDspzo4NPl28zGroq5pYiqi1+jmo6LaTzs597YaUu2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVQImR2LSQ4AIAwCoYvVqv//rsGEA4EZEIQCEqPsN6vp0HEz0rWsjuniRp+QQF+xBcs18AEXSwCy929MqwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/service-parts/service_parts_category.png
/* harmony default export */ var service_parts_category = ({"src":"/_next/static/media/service_parts_category.62d9554f.png","height":130,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEVmY2lfXWNaWF18fIFta3F4dnmHiIxWR0Kff2mRgnqWkpOXbkttV1CiaEF7Y1249R7iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImR3Gxw3AMBAEsdm9JMmh/3INmC9CVvTpAKjuP7MiohD3s6MSoVmViaS5NmBL705jW17HHyUJAQhqsbxoAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/baths/bath_category.png
/* harmony default export */ var bath_category = ({"src":"/_next/static/media/bath_category.f263672c.png","height":130,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEUTDw49Ly0iHh1QJhUhGhgJBQRmY2ItJiUnEgoXFhg0FQtRTk59e3tqaGjt6+qjoaP///8MzOIVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImQXBgQHAIAgEsROBB7W1+0/bhM5n634vrcyd59DhFoHT0QI3GiQwABsEVFVJYzDnWl7lPzuxAWoYOuJEAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/shower-doors/shower_doors_category.png
/* harmony default export */ var shower_doors_category = ({"src":"/_next/static/media/shower_doors_category.88fc9d34.png","height":130,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEWglo+IgXu0rqc7NC2/uLEmIRw0LiawqKKqoZp+d3ChnJiRh350b2lsZV0aFgyysa9UUFFlX1qNQAtVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVQImR3JQRKAMAgDwNAGAlit/v+zjl53Eac17AlMazLLMQ+MgXJEYQjrF+mrQCpVFzxJsgJu6tzrfgEzfQGP3Jx3vQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/sinks/sinks_category.png
/* harmony default export */ var sinks_category = ({"src":"/_next/static/media/sinks_category.97687c13.png","height":130,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEXo5+errLDJpoWMgHikoZ94YE+npaVgXVeWl5y2s6+rqqSNjYyDg4OmpZ9ybGMpJB4zLijc2trIx8iytLi3ooyIdWl/c2nDrZa4usCWk43W1dNPSkWem5za2NkYChZQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARElEQVQImR3GRxaAIAwFwA+EkNAU7O3+1/TprAZ2nozI4mG33Yg4D19zTsmtGMYQKpX4J5SouLg/DeeBjk9TqBLxzfQCYXACqazi0CQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/faucet-parts/faucet-parts-subcategory.png
/* harmony default export */ var faucet_parts_subcategory = ({"src":"/_next/static/media/faucet-parts-subcategory.e0effe1c.png","height":175,"width":175,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEX5+fn+/v/09PPq6urZ2djJycju59h+fHpkZGaUko61QZVOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImS3IyQ0AMAwCQXw7/TccybAfRgCAOy7rNmoe4Tt6qrjIFCKE6wMM6wBOlur6nwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/toilet-parts/toilet-parts-subcategory.png
/* harmony default export */ var toilet_parts_subcategory = ({"src":"/_next/static/media/toilet-parts-subcategory.8f8dfd67.png","height":175,"width":175,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEX5+fn+///49/bb2dm8vb/y8vHt6+quqqq4e3iFgYJaWlqXl5dycXFBQEGcmJnAs1NqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVQImS3Jxw0AMAwCQNzT9x83Smw+oAMANyHGS9dfsDFL9qoRkhcdT/FQ++KmQrgWWgCi1xhbGwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/GlobalVisualSearch/category/other-parts/other-parts-subcategory.png
/* harmony default export */ var other_parts_subcategory = ({"src":"/_next/static/media/other-parts-subcategory.0d05abe9.png","height":175,"width":175,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEX6+vr4+Pj9/f3y8vLa2tuMi47f3uDDw8a6ubylpKhd6eksAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVQImT2LSQoAIAwDs7S2/v/DUlCTw0CYgDd4mEo0YCuqi3CsndnEbLE8MiD9F3kAErEAiuDooqYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/constant.js











const productCategories = [
    {
        name: "faucets",
        value: "faucets",
        image: faucets_category,
        isComingSoon: false
    },
    {
        name: "toilet",
        value: "toilet",
        image: toilets_category,
        isComingSoon: false
    },
    {
        name: "shower",
        value: "shower",
        image: showers_category,
        isComingSoon: false
    },
    {
        name: "valve",
        value: "valve",
        image: valves_category,
        isComingSoon: false
    },
    {
        name: "serviceParts",
        value: "serviceParts",
        image: service_parts_category,
        isComingSoon: true
    },
    {
        name: "baths",
        value: "bath",
        image: bath_category,
        isComingSoon: true
    },
    {
        name: "showerDoors",
        value: "shower door",
        image: shower_doors_category,
        isComingSoon: true
    },
    {
        name: "sinks",
        value: "sink",
        image: sinks_category,
        isComingSoon: true
    }
];
const productSubCategories = [
    {
        name: "faucetParts",
        value: "servicepart-faucet",
        image: faucet_parts_subcategory,
        isComingSoon: false
    },
    {
        name: "toiletParts",
        value: "servicepart-toilet",
        image: toilet_parts_subcategory,
        isComingSoon: false
    },
    {
        name: "otherParts",
        value: "servicepart-shower",
        image: other_parts_subcategory,
        isComingSoon: false
    }
];

;// CONCATENATED MODULE: ./components/GlobalVisualSearch/CategorySection/index.jsx









const CategorySection = (props)=>{
    const { setOpenCam , setSection , setCategory , setIShowQr  } = props || {};
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { isSmallScreen  } = (0,useViewport/* default */.Z)();
    const { textCommingSoon =""  } = staticText;
    const getCategoryTranslations = (textKey)=>{
        const translatedText = staticText[textKey];
        return translatedText;
    };
    const handleCategorySelection = (e, item)=>{
        if (item.isComingSoon) return;
        if (item.value === "serviceParts") {
            setSection("subCategory");
            return;
        }
        setCategory(item.value);
        if (isSmallScreen) {
            setOpenCam(true);
            setSection("camera");
        } else {
            setSection("upload");
        }
        (0,analytics/* addAdobeDataLayerGlobalVisualSearch */.A)({
            event: "category_selection",
            category: item.value
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGrid, {
        className: (globalvisualsearch_module_default()).ProductGrid,
        children: productCategories.filter((item)=>!item.isComingSoon).map((item, index)=>{
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                justify: "center",
                align: "start",
                className: (globalvisualsearch_module_default()).ProductItem,
                onClick: (e)=>handleCategorySelection(e, item),
                children: [
                    !item.isComingSoon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (ref = item.image) === null || ref === void 0 ? void 0 : ref.src,
                        alt: item.name
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        justify: "center",
                        align: "center",
                        className: (globalvisualsearch_module_default()).comingSoonCard,
                        onClick: ()=>{
                            setCategory(item.value);
                            setSection("comingSoon");
                            setIShowQr(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            size: "tag-s",
                            children: textCommingSoon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        size: "label-regular-m",
                        children: getCategoryTranslations(item.name)
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_CategorySection = (CategorySection);

// EXTERNAL MODULE: ./components/VisualSearch/v1/ComingSoon/utils.js
var utils = __webpack_require__(68552);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/ComingSoon/comingSoon.module.scss
var comingSoon_module = __webpack_require__(56541);
var comingSoon_module_default = /*#__PURE__*/__webpack_require__.n(comingSoon_module);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/ComingSoon/index.jsx







const ComingSoon = (props)=>{
    const { category  } = props;
    const categorySelected = category === null || category === void 0 ? void 0 : category.toLowerCase();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { recognitionCategory =()=>{} , recognitionCategorySubText =()=>{} , viewGuidtext , commingSoon  } = (0,localization/* getTranslations */.F)(t);
    const viewGuide = ()=>{
        const supportUrl = (0,utils/* getCategoryURL */.$)(category);
        window.open(supportUrl, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (comingSoon_module_default()).ComingSoonContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "para-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "working-para",
                    children: commingSoon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "button-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "para-two-section",
                        children: [
                            recognitionCategory(categorySelected),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "secong-line",
                                children: recognitionCategorySubText(categorySelected)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "small",
                    className: "view-button",
                    variant: "secondary",
                    onClick: viewGuide,
                    children: viewGuidtext
                })
            ]
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_ComingSoon = (ComingSoon);

// EXTERNAL MODULE: ./components/GlobalVisualSearch/LoadingSpinner/index.module.scss
var LoadingSpinner_index_module = __webpack_require__(24773);
var LoadingSpinner_index_module_default = /*#__PURE__*/__webpack_require__.n(LoadingSpinner_index_module);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/UIAnimations/Spinner/Spinner.mjs + 1 modules
var Spinner = __webpack_require__(3726);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/LoadingSpinner/index.jsx




const LoadingSpinner = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LoadingSpinner_index_module_default()).LoadingSpinnerContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "loading-spinner-section",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_LoadingSpinner = (LoadingSpinner);

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/SubcategorySection/index.jsx








const SubcategorySection = (props)=>{
    const { setOpenCam , setSection , setCategory , setIShowQr  } = props || {};
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { isSmallScreen  } = (0,useViewport/* default */.Z)();
    const { textCommingSoon =""  } = staticText;
    const getCategoryTranslations = (textKey)=>{
        const translatedText = staticText[textKey];
        return translatedText;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomGrid, {
        className: (globalvisualsearch_module_default()).SubProductGrid,
        children: productSubCategories.map((item, index)=>{
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                justify: "center",
                align: "start",
                className: (globalvisualsearch_module_default()).ProductItem,
                onClick: ()=>{
                    if (item.isComingSoon) return;
                    setCategory(item.value);
                    if (isSmallScreen) {
                        setOpenCam(true);
                        setSection("camera");
                    } else {
                        setSection("upload");
                    }
                },
                children: [
                    !item.isComingSoon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (ref = item.image) === null || ref === void 0 ? void 0 : ref.src,
                        alt: item.name
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        justify: "center",
                        align: "center",
                        className: (globalvisualsearch_module_default()).comingSoonCard,
                        onClick: ()=>{
                            setCategory(item.value);
                            setSection("comingSoon");
                            setIShowQr(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            size: "tag-s",
                            children: textCommingSoon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        size: "label-regular-m",
                        children: getCategoryTranslations(item.name)
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_SubcategorySection = (SubcategorySection);

;// CONCATENATED MODULE: ./public/images/qrcode.svg
/* harmony default export */ var qrcode = ({"src":"/_next/static/media/qrcode.fc2570fe.svg","height":1000,"width":1000});
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/GlobalVisualSearch.js























const GlobalVisualSearch = (props)=>{
    const { openVisualSearch , setOpenVisualSearch , setShowSearchBar =()=>{}  } = props || {};
    const containerRef = (0,react.useRef)(null);
    const [openCam, setOpenCam] = (0,react.useState)(false);
    const [eventType, setEventType] = (0,react.useState)(null);
    const [image, setImage] = (0,react.useState)(null);
    const [category, setCategory] = (0,react.useState)("");
    const [section, setSection] = (0,react.useState)("category");
    const [output, setOutput] = (0,react.useState)(null);
    const { isSmallScreen , isExtraSmallScreen , isSmallTabView  } = (0,useViewport/* default */.Z)();
    const [isShowQr, setIShowQr] = (0,react.useState)(true);
    const router = (0,next_router.useRouter)();
    const dispatch = (0,react_redux_es/* useDispatch */.I0)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { searchCategoryTitle ="" , findCategory =()=>{} , selectProductTitle ="" , selectTypeTitle ="" , photoUploadTitle ="" , dontSeeProduct ="" , getHelp ="" , haveTrouble ="" , QRCodeText =""  } = staticText;
    const isAtCategorySection = section === "category";
    const isAtSubCategorySection = section === "subCategory";
    const isAtUploadSection = section === "upload";
    const isAtCameraSection = section === "camera";
    const isAtResultSection = section === "result";
    const isAtErrorSection = section === "error";
    const isAtLoadingSection = section === "loading";
    const showCustomCloseBackIcon = isAtResultSection || isAtLoadingSection || isAtErrorSection;
    const getCategoryTranslations = (textKey)=>{
        const translatedText = staticText[textKey];
        return translatedText;
    };
    const slectedCategoty = (0,react.useMemo)(()=>{
        var ref;
        const combinedCategories = [
            ...productCategories.filter((item)=>!item.isComingSoon) || [],
            ...productSubCategories || []
        ];
        return ((ref = combinedCategories.find((d)=>d.value === category)) === null || ref === void 0 ? void 0 : ref.name) || "";
    }, [
        category
    ]);
    const isPreviosAtSubcategory = productSubCategories === null || productSubCategories === void 0 ? void 0 : productSubCategories.map((d)=>{
        return d === null || d === void 0 ? void 0 : d.name;
    }).includes(slectedCategoty);
    const clearSelection = ()=>{
        setCategory("");
        if (!isPreviosAtSubcategory) {
            setSection("category");
        } else {
            setSection("subCategory");
        }
        setIShowQr(true);
    };
    (0,react.useEffect)(()=>{
        const inpageSearch = isExtraSmallScreen ? document.querySelector(".kf-react-button") : document.querySelector(".inpage-search__header-section");
        if (openCam && isSmallScreen) {
            document.body.style.overflow = "hidden";
            inpageSearch === null || inpageSearch === void 0 ? void 0 : inpageSearch.scrollIntoView({
                behavior: "smooth"
            });
        } else {
            document.body.style.overflow = "";
        }
        return ()=>{
            document.body.style.overflow = "";
        };
    }, [
        openCam
    ]);
    (0,react.useEffect)(()=>{
        if (image) {
            const imageState = {};
            imageState.image = (image === null || image === void 0 ? void 0 : image[0]) || image;
            const dataResult = {
                ...imageState,
                category
            };
            dispatch((0,vsresultSlice/* updateVSResultData */.yC)(dataResult));
            const url = new URL(window.location.href);
            const urlpathName = url === null || url === void 0 ? void 0 : url.pathname.includes("/result");
            if (!urlpathName) {
                setSection("loading-modal");
            } else {
                setSection("category");
                setOpenVisualSearch(false);
            }
            setOpenCam(false);
            router.push("/en/result");
        }
    }, [
        image
    ]);
    (0,react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpenVisualSearch(false);
                openSearchBar();
                setSection("category");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const navBar = document.querySelector(".kohler-main-navigation-bar-root");
        if (!navBar) return;
        const updateOverlayHeight = ()=>{
            document.documentElement.style.setProperty("--nav-bar-height", "".concat(navBar.offsetHeight, "px"));
        };
        const observer = new ResizeObserver(updateOverlayHeight);
        observer.observe(navBar);
        return ()=>observer.disconnect();
    }, [
        openVisualSearch
    ]);
    const renderSection = ()=>{
        switch(section){
            case "category":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_CategorySection, {
                    setOpenCam: setOpenCam,
                    setSection: setSection,
                    setCategory: setCategory,
                    eventType: eventType,
                    category: category,
                    output: output,
                    setIShowQr: setIShowQr
                });
            case "subCategory":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_SubcategorySection, {
                    setOpenCam: setOpenCam,
                    setSection: setSection,
                    setCategory: setCategory,
                    eventType: eventType,
                    category: category,
                    output: output,
                    setIShowQr: setIShowQr
                });
            case "upload":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_FileUpload, {
                    setImage: setImage,
                    category: category
                });
            case "camera":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraView/* default */.Z, {
                        setImage: setImage,
                        setEventType: setEventType,
                        back: clearSelection,
                        category: category,
                        setOpenCam: setOpenCam,
                        setSection: setSection,
                        setOutput: setOutput,
                        hideCloseIcon: true,
                        isUsingGlobalVS: true
                    })
                });
            case "comingSoon":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_ComingSoon, {
                    setSection: setSection,
                    category: category
                });
            case "loading-modal":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_LoadingSpinner, {});
            case "error":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack/* default */.Z, {
                    category: category
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_CategorySection, {
                    setOpenCam: setOpenCam,
                    setSection: setSection,
                    setCategory: setCategory
                });
        }
    };
    const openSearchBar = ()=>{
        if (isSmallTabView) {
            setShowSearchBar(true);
        }
    };
    const handleBackClick = ()=>{
        if (isAtCategorySection) {
            setOpenVisualSearch(false);
            openSearchBar();
        } else {
            setSection(isPreviosAtSubcategory ? "subCategory" : "category");
            setCategory("");
            setIShowQr(true);
        }
    };
    const renderBackIcon = ()=>{
        const showBackIcon = !showCustomCloseBackIcon && !(!isSmallTabView && isAtCategorySection);
        if (!showBackIcon) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: handleBackClick,
            className: (globalvisualsearch_module_default()).BackIconInMobileScreen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isAtCameraSection ? back_arraow_white_icon.src : left_back_icon === null || left_back_icon === void 0 ? void 0 : left_back_icon.src,
                alt: "back-arrow-icon"
            })
        });
    };
    const renderCloseIcon = ()=>{
        if (isSmallScreen && !showCustomCloseBackIcon && isAtCameraSection) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>{
                    clearSelection();
                    setOpenCam(false);
                },
                className: (globalvisualsearch_module_default()).CloseIconInMobileScreen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: close_white/* default.src */.Z.src,
                    alt: "close-icon-white"
                })
            });
        }
        return null;
    };
    const renderResultPageNavigation = ()=>{
        if (isSmallScreen && showCustomCloseBackIcon) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (globalvisualsearch_module_default()).ResultPageNavigation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    align: "center",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>setSection("camera"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: back_arraow_white_icon.src,
                                alt: "back-arrow-icon-white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: clearSelection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: close_white/* default.src */.Z.src,
                                alt: "close-white-icon"
                            })
                        })
                    ]
                })
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (globalvisualsearch_module_default()).GlobalVisualSearchContainer,
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            opened: openVisualSearch,
            onClose: ()=>{
                setOpenVisualSearch(false);
                openSearchBar();
                setSection("category");
            },
            "data-testid": "global-visualsearch-modal",
            className: "global-visualsearch",
            modalContentProps: {
                classname: "gvs-modal-content"
            },
            closeButtonProps: {
                className: isAtCameraSection || showCustomCloseBackIcon ? "hide-close-btn" : ""
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((globalvisualsearch_module_default()).ModalContent, " ").concat(showCustomCloseBackIcon && "p-0", " "),
                role: "dialog",
                tabIndex: "-1",
                children: [
                    renderBackIcon(),
                    renderCloseIcon(),
                    renderResultPageNavigation(),
                    (isAtCategorySection || isAtSubCategorySection || isAtUploadSection) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                size: "h5",
                                className: "".concat((globalvisualsearch_module_default()).Title, " search-text template"),
                                children: !isAtUploadSection ? searchCategoryTitle : findCategory(getCategoryTranslations(slectedCategoty))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                size: "label-medium-l",
                                className: "".concat((globalvisualsearch_module_default()).SubTitle, " search-text"),
                                children: !isAtUploadSection ? isAtCategorySection ? selectProductTitle : selectTypeTitle : photoUploadTitle
                            })
                        ]
                    }),
                    renderSection(),
                    isShowQr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (globalvisualsearch_module_default()).HelpSection,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        size: "label-regular-s",
                                        children: !isAtUploadSection ? dontSeeProduct : haveTrouble
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        size: "label-regular-s",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: constants.CONTACT_US_PAGE_URL_US,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: getHelp
                                        })
                                    })
                                ]
                            }),
                            !isSmallTabView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (globalvisualsearch_module_default()).QRSection,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        size: "title-s",
                                        children: QRCodeText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: qrcode === null || qrcode === void 0 ? void 0 : qrcode.src,
                                        alt: QRCodeText
                                    })
                                ]
                            }) : null
                        ]
                    }) : null
                ]
            })
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_GlobalVisualSearch = (GlobalVisualSearch);


/***/ }),

/***/ 77612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ addAdobeDataLayerGlobalVisualSearch; }
});

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/analytics/constants.js
const VISUAL_SEARCH = "visual search";
const VISUAL_SEARCH_RESULT = "visual search results";
const NAVIGATION = "navigation";
const GLOBAL_HEADER = "global header";
const GLOBAL_NAV = "global navigation";
const FAILURE = "failure";
const SUCCESS = "success";
const INCORRECT_EVENT_MESSAGE = "Sorry, we weren’t able to identify your Kohler product";
const SEARCH_RESULT = "search results displayed";
const VSEARCH_RESULT = "visual search results displayed";
const SUCCESS_MESASGE = "Image uploaded and successfully fetched results";
const FAILURE_MESSAGE = "Error in fetching results";

;// CONCATENATED MODULE: ./components/GlobalVisualSearch/analytics/index.js


const addAdobeDataLayerGlobalVisualSearch = (analytics)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page");
    const { event , category , eventStatus , linkUrl , eventMsg , product , productCount , visualSearch , browse , errrorMessage , eventShow  } = analytics;
    var ref1;
    const productName_ = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.title) === null || ref === void 0 ? void 0 : ref.text) !== null && ref1 !== void 0 ? ref1 : product === null || product === void 0 ? void 0 : product.name;
    const pdpUrl = product === null || product === void 0 ? void 0 : product.pdpUrl;
    const links = linkUrl !== null && linkUrl !== void 0 ? linkUrl : window.location.href;
    const imageeventAction = browse;
    let eventInfo = {};
    switch(event){
        case "search_icon_click":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":search using an image"),
                eventMsg: "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":search using an image"),
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: "search using an image",
                internalLinkPosition: "".concat(GLOBAL_HEADER, ":").concat(VISUAL_SEARCH),
                internalLinkType: "".concat(GLOBAL_NAV, ":").concat(NAVIGATION),
                internalLinkURL: "n/a",
                internalLinkZoneName: VISUAL_SEARCH
            };
            break;
        case "category_selection":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":select your product:").concat(category),
                eventMsg: eventMsg ? (0,helper/* sanitizeTextForAnalytics */.T68)(eventMsg) : "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":select your product:").concat(category),
                eventStatus: eventStatus !== null && eventStatus !== void 0 ? eventStatus : "n/a",
                eventType: NAVIGATION,
                internalLinkName: category,
                internalLinkPosition: "".concat(GLOBAL_HEADER, ":").concat(VISUAL_SEARCH),
                internalLinkType: "".concat(GLOBAL_NAV, ":").concat(NAVIGATION),
                internalLinkURL: "n/a",
                internalLinkZoneName: "".concat(VISUAL_SEARCH, ":select your product")
            };
            break;
        case "result_page_error":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT),
                eventMsg: FAILURE_MESSAGE,
                eventName: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT),
                eventStatus: FAILURE,
                eventType: NAVIGATION,
                internalLinkName: VSEARCH_RESULT,
                internalLinkPosition: "".concat(VISUAL_SEARCH_RESULT, ":").concat(category),
                internalLinkType: VISUAL_SEARCH_RESULT,
                internalLinkURL: links,
                internalLinkZoneName: VISUAL_SEARCH_RESULT,
                searchContentType: VISUAL_SEARCH_RESULT,
                searchResult: productCount,
                searchResultCategory: "products>0"
            };
            break;
        case "result_page_success":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT),
                eventMsg: SUCCESS_MESASGE,
                eventName: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT),
                eventStatus: SUCCESS,
                eventType: NAVIGATION,
                internalLinkName: VSEARCH_RESULT,
                internalLinkPosition: "".concat(VISUAL_SEARCH_RESULT, ":").concat(category),
                internalLinkType: VISUAL_SEARCH_RESULT,
                internalLinkURL: links,
                internalLinkZoneName: VISUAL_SEARCH_RESULT,
                searchContentType: VISUAL_SEARCH,
                searchResult: productCount,
                searchResultCategory: "products>".concat(productCount)
            };
            break;
        case "resultpdp_page":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":product navigation"),
                eventMsg: "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":product navigation"),
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: productName_,
                internalLinkPosition: "".concat(VISUAL_SEARCH_RESULT, ":").concat(category),
                internalLinkType: "".concat(VISUAL_SEARCH_RESULT, ":product tiles"),
                internalLinkURL: pdpUrl,
                internalLinkZoneName: "".concat(VISUAL_SEARCH_RESULT, ":products:main content area")
            };
            break;
        case "service_parts":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":service parts"),
                eventMsg: "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":service parts"),
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: "service parts",
                internalLinkPosition: "".concat(VISUAL_SEARCH_RESULT, ":").concat(category),
                internalLinkType: "".concat(VISUAL_SEARCH_RESULT, ":product tiles"),
                internalLinkURL: "n/a",
                internalLinkZoneName: "".concat(VISUAL_SEARCH_RESULT, ":products:main content area")
            };
            break;
        case "image_upload":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(category, ":").concat(imageeventAction),
                eventMsg: errrorMessage ? errrorMessage : "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":").concat(category, ":").concat(imageeventAction),
                eventStatus: errrorMessage ? FAILURE : SUCCESS,
                eventType: NAVIGATION,
                internalLinkName: imageeventAction,
                internalLinkPosition: "".concat(GLOBAL_HEADER, ":").concat(VISUAL_SEARCH),
                internalLinkType: "".concat(GLOBAL_NAV, ":navigation"),
                internalLinkURL: "n/a",
                internalLinkZoneName: "".concat(VISUAL_SEARCH, ":").concat(category)
            };
            break;
        case "incorrect_match":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":incorrect match"),
                eventMsg: INCORRECT_EVENT_MESSAGE,
                eventName: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":incorrect match"),
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: "incorrect match",
                internalLinkPosition: "".concat(VISUAL_SEARCH_RESULT, ":").concat(category),
                internalLinkType: "".concat(VISUAL_SEARCH_RESULT, ":search:navigation"),
                internalLinkURL: "n/a",
                internalLinkZoneName: VISUAL_SEARCH_RESULT,
                searchContentType: VISUAL_SEARCH,
                searchResult: productCount,
                searchResultCategory: category
            };
            break;
        case "product-color":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":color selection"),
                eventMsg: "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":").concat(SEARCH_RESULT, ":color selection"),
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: "color selection",
                internalLinkPosition: "".concat(VISUAL_SEARCH_RESULT, ":").concat(category),
                internalLinkType: "".concat(VISUAL_SEARCH_RESULT, ":color selection"),
                internalLinkURL: "n/a",
                internalLinkZoneName: "".concat(VISUAL_SEARCH_RESULT, ":product details")
            };
            break;
        case "new-search":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: VISUAL_SEARCH,
                eventMsg: "n/a",
                eventName: VISUAL_SEARCH,
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: "visual search notification displayed",
                internalLinkPosition: GLOBAL_HEADER,
                internalLinkType: GLOBAL_NAV,
                internalLinkURL: "n/a",
                internalLinkZoneName: GLOBAL_HEADER
            };
            break;
        case "got-it":
            eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(VISUAL_SEARCH, ":got it"),
                eventMsg: "n/a",
                eventName: "".concat(VISUAL_SEARCH, ":got it"),
                eventStatus: "n/a",
                eventType: NAVIGATION,
                internalLinkName: "got it",
                internalLinkPosition: "".concat(GLOBAL_HEADER, ":").concat(VISUAL_SEARCH),
                internalLinkType: "".concat(GLOBAL_NAV, ":visual search notification"),
                internalLinkURL: "n/a",
                internalLinkZoneName: VISUAL_SEARCH
            };
            break;
    }
    const productInfo = product ? getAnalyticProductInfo(product, category) : null;
    if (visualSearch) productInfo.visualSearch = true;
    if (eventShow) {
        const cmpShowEvent = window.adobeDataLayer.find((e)=>{
            return (e === null || e === void 0 ? void 0 : e.event) === "cmp:show";
        });
        if (cmpShowEvent) {
            cmpShowEvent.eventInfo = eventInfo;
            cmpShowEvent.page.pageInfo["pageName"] = "kohler:".concat(VISUAL_SEARCH);
            cmpShowEvent.page.pageInfo["title"] = "Visual Search | KOHLER";
        }
    } else {
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            ...productInfo != null && {
                productInfo
            }
        });
    }
};
const priceNumber = (priceString)=>{
    return parseFloat(priceString === null || priceString === void 0 ? void 0 : priceString.replace(/[^\d.-]/g, ""));
};
const getAnalyticProductInfo = (products, category)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8;
    const productSKU = (ref8 = products === null || products === void 0 ? void 0 : (ref = products.productDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.SKU) === null || ref1 === void 0 ? void 0 : ref1.text) !== null && ref8 !== void 0 ? ref8 : products === null || products === void 0 ? void 0 : products.sku;
    const productPrice = priceNumber((products === null || products === void 0 ? void 0 : (ref2 = products.price) === null || ref2 === void 0 ? void 0 : ref2.text) || (products === null || products === void 0 ? void 0 : products.priceing));
    var ref9, ref10, ref11, ref12, ref13;
    const productInfo = {
        category: category,
        defaultImageName: (ref9 = products === null || products === void 0 ? void 0 : (ref3 = products.image) === null || ref3 === void 0 ? void 0 : ref3.src) !== null && ref9 !== void 0 ? ref9 : products === null || products === void 0 ? void 0 : products.isoImageURL,
        description: (0,helper/* sanitizeTextForAnalytics */.T68)((ref10 = products === null || products === void 0 ? void 0 : (ref4 = products.description) === null || ref4 === void 0 ? void 0 : ref4.text) !== null && ref10 !== void 0 ? ref10 : products === null || products === void 0 ? void 0 : products.longDescription),
        frequency: "n/a",
        globalDiscount: "n/a",
        globalOffer: "n/a",
        globalPromotionPrice: "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: (0,helper/* sanitizeTextForAnalytics */.T68)(category),
        numberOfReviews: "n/a",
        pdpType: "regular finished goods",
        priceState: "regular price",
        productBasePrice: productPrice,
        productBrand: "kohler",
        productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category),
        productCollectionsName: (ref11 = products === null || products === void 0 ? void 0 : (ref5 = products.title) === null || ref5 === void 0 ? void 0 : ref5.text) !== null && ref11 !== void 0 ? ref11 : products === null || products === void 0 ? void 0 : products.name,
        productColor: (ref12 = products === null || products === void 0 ? void 0 : products.productColor) !== null && ref12 !== void 0 ? ref12 : "n/a",
        productCouponCode: "n/a",
        productCoupondiscount: "n/a",
        productFindingMethod: "n/a",
        productID: "K-".concat(productSKU),
        productName: (0,helper/* sanitizeTextForAnalytics */.T68)((ref13 = products === null || products === void 0 ? void 0 : (ref6 = products.title) === null || ref6 === void 0 ? void 0 : ref6.text) !== null && ref13 !== void 0 ? ref13 : products === null || products === void 0 ? void 0 : products.name),
        productPartnerBuyNow: "n/a",
        productRoom: "n/a",
        productSalePrice: productPrice,
        productSaleable: "n/a",
        productStatus: "n/a",
        productSuperSku: "n/a",
        productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(products === null || products === void 0 ? void 0 : (ref7 = products.description) === null || ref7 === void 0 ? void 0 : ref7.text),
        quantity: "n/a",
        ratings: "n/a",
        visualSearch: true
    };
    return productInfo;
};


/***/ }),

/***/ 83942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        searchCategoryTitle: t("kf.visualsearch.page.searchImage"),
        searchByImageTitle: t("kf.Globalvisualsearch.searchByImageTitle.text"),
        selectProductTitle: t("kf.Globalvisualsearch.selectProductTitle.text"),
        selectTypeTitle: t("kf.Globalvisualsearch.selectTypeTitle.text"),
        photoUploadTitle: t("kf.Globalvisualsearch.photoUploadTitle.text"),
        dragAndDrop: t("kf.visualsearch.ImageUpload.text"),
        dropFilesHere: t("kf.Globalvisualsearch.dropFilesHere.text"),
        orText: t("kf.contactus.label.orText"),
        uploadAFileButton: t("kf.contactus.label.uploadAFileButton"),
        QRCodeText: t("kf.visualsearch.QRCode.text"),
        uploadFileTypes: t("kf.Globalvisualsearch.label.uploadFileTypes"),
        uploadFileExtn: t("kf.Globalvisualsearch.label.uploadFileExtn"),
        uploadSizeLimit: t("kf.Globalvisualsearch.label.uploadSizeLimit"),
        uploadMBLimit: t("kf.Globalvisualsearch.label.uploadMBLimit"),
        dontSeeProduct: t("kf.Globalvisualsearch.dontSeeProduct.text"),
        getHelp: t("kf.Globalvisualsearch.getHelp.link"),
        imageUploadFileExtError: t("kf.Globalvisualsearch.ImageUploadFileExtError.text"),
        imageUploadFileSizeError: (size)=>t("kf.Globalvisualsearch.ImageUploadFileSizeError.text", {
                size
            }),
        findCategory: (category)=>t("kf.visualsearch.ImageUpload.title.findCategory", {
                category
            }),
        faucets: t("kf.product.category.faucets"),
        toilet: t("kf.product.category.toilets"),
        haveTrouble: t("kf.global.haveTrouble.text"),
        shower: t("kf.product.category.showers"),
        valve: t("kf.product.category.valves"),
        serviceParts: t("kf.product.category.serviceParts"),
        faucetParts: t("kf.product.subCategory.faucetParts"),
        toiletParts: t("kf.product.subCategory.toiletParts"),
        otherParts: t("kf.product.subCategory.otherParts"),
        newSearchTitle: t("kf.visualsearch.cameraGuide.newSearch"),
        photoSelectLibrary: t("kf.visualsearch.cameraGuide.photoSelectLibrary"),
        gotIt: t("kf.visualsearch.cameraGuide.gotIt"),
        baths: t("kf.product.category.baths"),
        showerDoors: t("kf.product.category.showerDoors"),
        sinks: t("kf.product.category.sinks"),
        textCommingSoon: t("kf.visualsearch.label.textCommingSoon"),
        searchImageText: t("kf.visualsearch.page.searchImage"),
        results: t("kf.plp.label.results"),
        home: t("kf.global.label.home"),
        searchResults: t("kf.technical.label.searchResults"),
        colorFinish: t("kf.pdp.label.colorOrFinish"),
        tooltip: t("kf.visualsearch.ImageCropper.toolTip"),
        toolTipCrop: t("kf.visualsearch.ImageCropper.toolTipCrop"),
        incorrectMatch: t("kf.visualsearch.label.textIncorrectMatch"),
        newSearch: t("kf.visualsearch.label.textNewSearch"),
        helpText: t("kf.visualsearch.label.textHelp"),
        feedbackText: t("kf.visualsearch.label.feedbackText"),
        closestMatch: t("kf.visualsearch.label.textClosestMatch"),
        partDiagramtext: t("kf.pdp.label.partsDiagram"),
        friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
        associatePrice: t("kf.pdp.label.associatePrice"),
        listPriceInfo: t("kf.pdp.label.listPriceInfo"),
        searchText: t("kf.visualsearch.page.search"),
        viewProduct: t("kf.visualsearch.page.viewProduct"),
        incorrectMatchText: t("kf.visualsearch.page.incorrectMatch"),
        errorText: t("kf.visualsearch.ErrorPage.errorText"),
        errorSubText: t("kf.visualsearch.ErrorPage.errorSubText"),
        tryAgainBtn: t("kf.visualsearch.ErrorPage.button.tryAgainBtn"),
        recognitionCategory: (category)=>t("kf.visualsearch.label.recognitionCategory", {
                category
            }),
        recognitionCategorySubText: (category)=>t("kf.visualsearch.label.recognitionCategorySubText", {
                category
            }),
        commingSoon: t("kf.visualsearch.label.commingSoon"),
        viewGuidtext: t("kf.visualsearch.button.viewGuid"),
        contactUs: t("kf.contactus.label.contactUsDisplayName"),
        incorrectMatchTxt: t("kf.globalvisualsearch.label.incorrectMatch"),
        incorrectMatchTryTxt: t("kf.globalvisualsearch.label.incorrectMatchTry"),
        incorrectTitle: t("kf.globalvisualsearch.label.incorrectTitle"),
        listPrice: t("kf.list.table.listPrice"),
        pageExpire: t("kf.globalvisualsearch.label.pageExpire"),
        txtSearch: t("kf.visualsearch.result.search")
    };
};


/***/ }),

/***/ 67848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_InPageSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/InPageSearch/v1/analytics.js
const getEventInfo = function() {
    let linkUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", searchString = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const title = page.category.subCategoryID.replaceAll(" ", "-");
    const findAServicePart = title === "find-a-service-part";
    const eventAction = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "main content area:search";
    const internalLinkPosition = findAServicePart ? "".concat(page.category.pageType, ":").concat(title) : "support".concat(type);
    const internalLinkType = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "".concat(searchString);
    const internalLinkZoneName = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "main content area";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction,
        eventName: eventAction,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "search",
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: linkUrl || "n/a",
        internalLinkZoneName,
        searchTerm: searchString
    });
};

// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(17169);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartsViewer.jsx + 182 modules
var v2_PartsViewer = __webpack_require__(70159);
// EXTERNAL MODULE: ./components/InPageSearch/v1/index.module.scss
var index_module = __webpack_require__(2145);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/overlayscrollbars-react/dist/overlayscrollbars-react.esm.js
var overlayscrollbars_react_esm = __webpack_require__(1861);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/VisualSearch/localization.js
var localization = __webpack_require__(89166);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/faucets.png
/* harmony default export */ var faucets = ({"src":"/_next/static/media/faucets.ad3d08d9.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAD1BMVEX6+vrn6OnU1NXw8PDg4OLBIzzxAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAChJREFUCJk1ysENADAMwkAD2X/mllT9+CQEIEGrAZy4zMPpOPv4KLcHBmsAODJs0ncAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/toilet.png
/* harmony default export */ var toilet = ({"src":"/_next/static/media/toilet.ef95f71a.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEX39/fV1dbr6+vl5eXxU0fQAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB9JREFUCJljYIACJgjFDKUgNBMjI1ickRHMhVJMQEkAAq0AGyEyJQ0AAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/valve.png
/* harmony default export */ var valve = ({"src":"/_next/static/media/valve.81b08023.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAJFBMVEX4+Pi9q5TQxLKukWf5+Pj6+vv+///r5dzX0MaTeVOzm3nl2caQbtQCAAAABHRSTlP8/v7+EEOCdwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC5JREFUCJkdikkOADEMwtwpJF3+/9+KQbLsA6AMlIDqWwK+08Y99yrw+JVXsKUHFTUAxASKNxQAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/shower.png
/* harmony default export */ var shower = ({"src":"/_next/static/media/shower.c88ccfe8.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAHlBMVEX5+fn8/Pzp6evx8fJcWl98en/S0dRva2+gn6OioKS29MYpAAAABXRSTlP//v7+/gHW7VsAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAqSURBVAiZVYk3AgAgEINI4ln+/2HLJgMMwId7EAQ7oF5VRrON9W50o+MNB9wAVHjx1IgAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/bath.png
/* harmony default export */ var bath = ({"src":"/_next/static/media/bath.96b055e3.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAD1BMVEX29vb6+vrT09Ts7Ozd3N7vGlqrAAAAAXRSTlP9g+pWxwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACZJREFUCJkdirENAAAIgyj1/5uNssAA5AAuYCyhoxZ8peoNtPkvWQdUAEWoLD50AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/sink.png
/* harmony default export */ var sink = ({"src":"/_next/static/media/sink.8226f798.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEX5+fnv7u/a2dvl5eZ3e/xoAAAAAnRSTlP//r+y71EAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAiSURBVAiZY2BAB4wgzMjMzMzIwMjExMTEyMDAyMQMEkUGAANEAB+nJ8u/AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/toilet_seat.png
/* harmony default export */ var toilet_seat = ({"src":"/_next/static/media/toilet_seat.83d28ff4.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEX5+fny8/Pq6uvb3N53l0vqAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5JREFUCJljYEADjEyMIIqJGUQxMjMzQUgmhBQYAAADVwAjo2/QnwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/shower_door.png
/* harmony default export */ var shower_door = ({"src":"/_next/static/media/shower_door.cc5a0390.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEXs7Ov19PPc3t3k5uWZJUTxAAAAAnRSTlP+/qap3hAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAkSURBVAiZNcfBDQAACMLASvff2RDjfQpMyQgIgTSazvpnxHAWB9gARmKApS8AAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/constant.js








const imageInformation = [
    {
        imageUrl: faucets,
        imageName: "Faucet"
    },
    {
        imageUrl: toilet,
        imageName: "Toilet"
    },
    {
        imageUrl: valve,
        imageName: "Valve"
    },
    {
        imageUrl: shower,
        imageName: "Shower"
    },
    {
        imageUrl: toilet_seat,
        imageName: "Toilet Seat",
        comingSoon: true
    },
    {
        imageUrl: shower_door,
        imageName: "Shower Door",
        comingSoon: true
    },
    {
        imageUrl: sink,
        imageName: "Sink",
        comingSoon: true
    },
    {
        imageUrl: bath,
        imageName: "Bath",
        comingSoon: true
    }
];
const scrollOptions = {
    className: "os-theme-dark cmp-carousel__whole",
    style: "height:auto",
    scrollbars: {
        visibility: "auto",
        autoHide: "never"
    }
};

// EXTERNAL MODULE: ./components/VisualSearch/analytics/index.js
var analytics = __webpack_require__(94529);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/SelectProductCategory.view.jsx








const SelectProductCategoryView = (props)=>{
    const { updateCategoryItems , setOpenCam  } = props;
    const scrollerRef = (0,react.useRef)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { textCommingSoon  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        let timeId;
        if (scrollerRef.current) {
            timeId = setTimeout(()=>{
                document.querySelectorAll(".carousel-bottom-scroll").forEach((scrollDiv)=>{
                    let heightToSet = 0;
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".cmp-carousel__content").forEach((scrollDivContent)=>{
                        if (scrollDivContent && heightToSet < (scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight)) {
                            heightToSet = scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight;
                        }
                    });
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".os-content-glue").forEach((scrollDivglu)=>{
                        if (scrollDivglu && heightToSet > 0) {
                            scrollDivglu.style.height = heightToSet + "px";
                        }
                    });
                });
            }, 2000);
        }
        return ()=>clearTimeout(timeId);
    }, [
        scrollerRef.current
    ]);
    const handleCategorySelection = (e, category, item)=>{
        const categorySelected = category.toLowerCase();
        setOpenCam(true);
        const input = [
            {
                category: categorySelected,
                comingSoon: item === null || item === void 0 ? void 0 : item.comingSoon
            }
        ];
        (0,analytics/* addDataLayerVisualSearch */.K)({
            eventKey: "select you product",
            category: categorySelected,
            internalLinkZoneName: true
        });
        updateCategoryItems(input);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "carousel carousel-btm-scroll-title-small product-category",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-carousel slide-scrollbar",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-carousel-text",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cmp-carousel__pretitle",
                        role: "heading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Select Your Product"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: true,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(overlayscrollbars_react_esm/* OverlayScrollbarsComponent */.E, {
                            options: scrollOptions,
                            ref: scrollerRef,
                            defer: true,
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cmp-carousel__content",
                        children: [
                            imageInformation ? imageInformation.map((item, i)=>{
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item cmp-carousel__item--active",
                                    role: "tabpanel",
                                    "aria-label": "Slide ".concat(i + 1, " of ").concat(imageInformation === null || imageInformation === void 0 ? void 0 : imageInformation.length),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-list d-flex flex-column h-100",
                                        onClick: (e)=>{
                                            handleCategorySelection(e, item === null || item === void 0 ? void 0 : item.imageName, item);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-with-text position-relative d-inline-block",
                                            children: (item === null || item === void 0 ? void 0 : item.imageUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "image-part",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "pia-img",
                                                            src: item === null || item === void 0 ? void 0 : (ref = item.imageUrl) === null || ref === void 0 ? void 0 : ref.src,
                                                            alt: item === null || item === void 0 ? void 0 : item.imageName,
                                                            title: item === null || item === void 0 ? void 0 : item.imageName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-label",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                fontSize: 26,
                                                                className: "image-text",
                                                                children: item === null || item === void 0 ? void 0 : item.imageName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "comingSoon",
                                                                children: (item === null || item === void 0 ? void 0 : item.comingSoon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    fontSize: 16,
                                                                    className: "coming-soon section-Line",
                                                                    children: (item === null || item === void 0 ? void 0 : item.comingSoon) ? textCommingSoon === null || textCommingSoon === void 0 ? void 0 : textCommingSoon.toUpperCase() : null
                                                                }) : null
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        })
                                    }, i)
                                }, "carousel-".concat(i));
                            }) : null,
                            Array.from({
                                length: 2
                            }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item"
                                }, val))
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SelectProductCategory_view = (SelectProductCategoryView);

// EXTERNAL MODULE: ./components/VisualSearch/v1/QRCode/index.jsx
var QRCode = __webpack_require__(47796);
// EXTERNAL MODULE: ./components/VisualSearch/v1/SelectProductCategory/index.module.scss
var SelectProductCategory_index_module = __webpack_require__(71964);
var SelectProductCategory_index_module_default = /*#__PURE__*/__webpack_require__.n(SelectProductCategory_index_module);
// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/index.jsx





const SelectProductCategory = (props)=>{
    const { updateCategoryItems , setOpenCam  } = props;
    const device = (0,useViewport/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((SelectProductCategory_index_module_default()).SelectProductCategoryWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inpage-search_category inpage-list-category",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProductCategory_view, {
                    updateCategoryItems: updateCategoryItems,
                    setOpenCam: setOpenCam
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-100 ",
                    children: !(device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode/* default */.Z, {}) : null
                })
            ]
        })
    });
};
/* harmony default export */ var v1_SelectProductCategory = (SelectProductCategory);

// EXTERNAL MODULE: ./components/VisualSearch/v1/UploadImage/index.jsx + 4 modules
var UploadImage = __webpack_require__(26355);
// EXTERNAL MODULE: ./components/VisualSearch/v1/LoadingData/loadingdata.module.scss
var loadingdata_module = __webpack_require__(3856);
var loadingdata_module_default = /*#__PURE__*/__webpack_require__.n(loadingdata_module);
// EXTERNAL MODULE: ./components/core/Heading/Heading.jsx
var Heading = __webpack_require__(22231);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
// EXTERNAL MODULE: ./public/images/animated/uploadImage.svg
var uploadImage = __webpack_require__(9358);
;// CONCATENATED MODULE: ./public/images/animated/successImage.svg
/* harmony default export */ var successImage = ({"src":"/_next/static/media/successImage.c2b072b2.svg","height":630,"width":630});
;// CONCATENATED MODULE: ./public/images/animated/cricleImage.svg
/* harmony default export */ var cricleImage = ({"src":"/_next/static/media/cricleImage.3320c023.svg","height":1000,"width":1000});
// EXTERNAL MODULE: ./public/images/animated/downloadData.svg
var downloadData = __webpack_require__(91);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/LoadingData/constant.js




const data = [
    {
        text: "Uploading image...",
        imageUrl: uploadImage/* default.src */.Z.src,
        status: true
    },
    {
        text: "Matching products...",
        imageUrl: cricleImage.src,
        status: true
    },
    {
        text: "Match found.",
        imageUrl: successImage.src,
        status: true
    },
    {
        text: "Retrieving details...",
        imageUrl: downloadData/* default.src */.Z.src,
        status: true
    }
];
const APP_URL = "https://www.kohler.com";

// EXTERNAL MODULE: ./components/VisualSearch/v1/utils.js
var v1_utils = __webpack_require__(10068);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/LoadingData/index.jsx










const LoadingData = (props)=>{
    const { image =[] , category ="" , setSection , setOpenCam , setProductResult , setLoading , eventType  } = props;
    const [progress, setProgress] = (0,react.useState)(data[0]);
    const [productData, setProductData] = (0,react.useState)(null);
    const device = (0,useViewport/* default */.Z)();
    (0,react.useEffect)(()=>{
        let timeId1;
        let timeId2;
        let timeId3;
        if (image && category) {
            timeId1 = setTimeout(()=>setProgress(data[1]), 1000);
            timeId2 = setTimeout(()=>setProgress(data[2]), 2500);
            timeId3 = setTimeout(()=>setProgress(data[3]), 4000);
            setOpenCam(false);
            const categoryVal = (0,v1_utils/* getValidCategory */.cR)(category);
            getSkuNumberByImage(image, categoryVal);
        }
        return ()=>{
            clearTimeout(timeId1);
            clearTimeout(timeId2);
            clearTimeout(timeId3);
        };
    }, [
        image,
        category
    ]);
    (0,react.useEffect)(()=>{
        document.body.classList.remove("overflow-hidden");
    }, [
        productData
    ]);
    const getSkuNumberByImage = async function(image) {
        let category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "faucets";
        const { file  } = image;
        try {
            setLoading(false);
            if (file && category) {
                var ref;
                const formdata = new FormData();
                formdata.append("category", category);
                formdata.append("file", file);
                const response = await (0,ct_service/* getProductByImage */.He)(formdata);
                if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.result) {
                    var ref1, ref2, ref3, ref4, ref5, ref6;
                    setProductData(response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.result);
                    (0,analytics/* addDataLayerVisualSearch */.K)({
                        eventKey: eventType,
                        eventStatus: "success",
                        product: response.data.result,
                        category: category,
                        linkUrl: response.data.result.pdpUrl
                    });
                    const slug = response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.result) === null || ref3 === void 0 ? void 0 : ref3.slug;
                    const skuId = response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.result) === null || ref5 === void 0 ? void 0 : ref5.sku;
                    const resp = await (0,v1_utils/* getDetailSku */.i2)(slug, skuId);
                    setSection("result");
                    const mergedResponse = {
                        ...response === null || response === void 0 ? void 0 : (ref6 = response.data) === null || ref6 === void 0 ? void 0 : ref6.result,
                        allswatch: [
                            resp
                        ]
                    };
                    setLoading(true);
                    setProductResult(mergedResponse);
                    document.body.classList.remove("overflow-hidden");
                } else {
                    setProductData(null);
                    (0,analytics/* addDataLayerVisualSearch */.K)({
                        eventKey: eventType,
                        eventStatus: "failure",
                        category: category,
                        eventMsg: "sorry something went wrong"
                    });
                    setSection("error");
                    setLoading(false);
                }
            }
        } catch (err) {
            console.error("Error in getSkuNumberByImage", err);
            setSection("error");
        }
    };
    if (!category) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (loadingdata_module_default()).LoadingImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-loading-container visualContentwarpper d-flex justify-content-center align-items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "upload-image d-flex justify-content-center align-items-center flex-column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "icon-upload",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: progress === null || progress === void 0 ? void 0 : progress.imageUrl,
                                alt: progress === null || progress === void 0 ? void 0 : progress.text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            fontSize: 34,
                            level: 4,
                            className: "loading-text",
                            children: progress === null || progress === void 0 ? void 0 : progress.text
                        })
                    ]
                })
            }),
            !(device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode/* default */.Z, {}) : null
        ]
    });
};
/* harmony default export */ var v1_LoadingData = (LoadingData);

// EXTERNAL MODULE: ./components/VisualSearch/v1/CameraView/index.jsx + 5 modules
var CameraView = __webpack_require__(4680);
// EXTERNAL MODULE: ./components/VisualSearch/v1/ComingSoon/comingSoon.module.scss
var comingSoon_module = __webpack_require__(53163);
var comingSoon_module_default = /*#__PURE__*/__webpack_require__.n(comingSoon_module);
// EXTERNAL MODULE: ./components/VisualSearch/v1/ComingSoon/utils.js
var ComingSoon_utils = __webpack_require__(68552);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ComingSoon/index.jsx






const ComingSoon = (props)=>{
    const { setSection , category  } = props;
    const categorySelected = category === null || category === void 0 ? void 0 : category.toLowerCase();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { recognitionCategory =()=>{} , recognitionCategorySubText =()=>{} , viewGuidtext , backOnCategory , commingSoon  } = (0,localization/* getTranslations */.F)(t);
    const viewGuide = ()=>{
        const supportUrl = (0,ComingSoon_utils/* getCategoryURL */.$)(category);
        window.open(supportUrl, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (comingSoon_module_default()).ComingSoonContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "para-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "working-para",
                    children: commingSoon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "button-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "para-two-section",
                            children: [
                                recognitionCategory(categorySelected),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "secong-line",
                                    children: recognitionCategorySubText(categorySelected)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "view-button",
                            onClick: viewGuide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "button-label",
                                children: viewGuidtext
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "back-button",
                    onClick: ()=>setSection("category"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: backOnCategory
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ComingSoon = (ComingSoon);

// EXTERNAL MODULE: ./components/VisualSearch/v1/ErrorFallBack/index.module.scss
var ErrorFallBack_index_module = __webpack_require__(16899);
var ErrorFallBack_index_module_default = /*#__PURE__*/__webpack_require__.n(ErrorFallBack_index_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ErrorFallBack/index.js







const ErrorFallBack = (props)=>{
    const { setSection , setOpenCam , category  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { errorText , tryAgainBtn , errorSubText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        setOpenCam(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ErrorFallBack_index_module_default()).ErrorContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "error-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "sorry-section",
                    children: errorText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "try-section",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(errorSubText)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "back-button",
                    onClick: ()=>{
                        setSection("category");
                        (0,analytics/* addDataLayerVisualSearch */.K)({
                            eventKey: "try again",
                            category
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: tryAgainBtn
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ErrorFallBack = (ErrorFallBack);

// EXTERNAL MODULE: ./components/VisualSearch/v1/visualsearch.module.scss
var visualsearch_module = __webpack_require__(26657);
var visualsearch_module_default = /*#__PURE__*/__webpack_require__.n(visualsearch_module);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/VisualSearch/v1/ResultPage/ImageCropper/index.module.scss
var ImageCropper_index_module = __webpack_require__(20927);
var ImageCropper_index_module_default = /*#__PURE__*/__webpack_require__.n(ImageCropper_index_module);
// EXTERNAL MODULE: ./public/images/tooltip_questionmark.svg
var tooltip_questionmark = __webpack_require__(88871);
;// CONCATENATED MODULE: ./public/images/visual_search_small.svg
/* harmony default export */ var visual_search_small = ({"src":"/_next/static/media/visual_search_small.97683ec1.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.min.js
var ReactCrop_min = __webpack_require__(96120);
var ReactCrop_min_default = /*#__PURE__*/__webpack_require__.n(ReactCrop_min);
// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.css
var ReactCrop = __webpack_require__(96167);
// EXTERNAL MODULE: ./public/images/drag_indicator.svg
var drag_indicator = __webpack_require__(56575);
// EXTERNAL MODULE: ./public/images/tickButton.svg
var tickButton = __webpack_require__(87942);
// EXTERNAL MODULE: ./public/images/crossButton.svg
var crossButton = __webpack_require__(51334);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ImageCropPicker/index.jsx










const ImageCropPicker = (props)=>{
    const { loading , imageData  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { tooltip , toolTipCrop  } = (0,localization/* getTranslations */.F)(t);
    const { imageUrl , product , setOutput , output  } = props;
    const { model1 , model2  } = product || {};
    const { xmin , ymin , xmax , ymax  } = model1 || {};
    const initalCrop = {
        unit: "%",
        x: 25,
        y: 25,
        width: 40,
        height: 40
    };
    const initalPredictionDataSet = {
        unit: "%",
        x: xmin / imageData.width * 100,
        y: ymin / imageData.height * 100,
        width: (xmax - xmin) / imageData.width * 100,
        height: (ymax - ymin) / imageData.height * 100
    };
    const initalSet = model2 === null ? initalPredictionDataSet : initalCrop;
    const cropInitalSet = (output === null || output === void 0 ? void 0 : output.cropData) !== undefined ? output === null || output === void 0 ? void 0 : output.cropData : initalSet;
    const imgRef = (0,react.useRef)(null);
    const [crop, setCrop] = (0,react.useState)(cropInitalSet);
    const [completedCrop, setCompletedCrop] = (0,react.useState)(null);
    const [showTooltip, setShowTooltip] = (0,react.useState)(model2 === null ? "firstText" : "secondText");
    const [showButton, setShowButton] = (0,react.useState)(true);
    const [outputFlag, setOutputFlag] = (0,react.useState)(false);
    const [windowWidth, setWindowWidth] = (0,react.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const onLoad = (0,react.useCallback)((img)=>{
        imgRef.current = img;
    }, []);
    (0,react.useEffect)(()=>{
        var ref;
        if ((crop === null || crop === void 0 ? void 0 : crop.x) !== (props === null || props === void 0 ? void 0 : (ref = props.output) === null || ref === void 0 ? void 0 : ref.cropData)) {
            setCrop(cropInitalSet);
        }
    }, [
        output === null || output === void 0 ? void 0 : output.cropData,
        outputFlag
    ]);
    const handleWindowResize = ()=>{
        if ((window === null || window === void 0 ? void 0 : window.innerWidth) !== (windowWidth === null || windowWidth === void 0 ? void 0 : windowWidth.width)) {
            setCrop(cropInitalSet);
            setWindowWidth({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
    };
    (0,react.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    const createOutputBlob = (canvas)=>{
        canvas.toBlob((blob)=>{}, "image/png", 1);
    };
    const createOutputCanvas = ()=>{
        const image = imgRef.current;
        const canvas = document.createElement("canvas");
        const crop = completedCrop;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext("2d");
        const pixelRatio = window.devicePixelRatio;
        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width * scaleX, crop.height * scaleY);
        return canvas;
    };
    (0,react.useEffect)(()=>{
        if (!completedCrop || !imgRef.current) {
            return;
        }
        const canvas = createOutputCanvas();
        createOutputBlob(canvas);
    }, [
        completedCrop
    ]);
    const handleOnDragStart = ()=>{
        setShowTooltip(null);
        setShowButton(true);
    };
    const handleDragEnd = ()=>{
        if (showTooltip === null) {
            setShowButton(false);
        }
    };
    const handleBoundingBox = (flags)=>{
        const { width , height  } = imageData;
        setOutputFlag(!outputFlag);
        if (!flags) {
            setCompletedCrop(cropInitalSet);
            setShowButton(true);
            return;
        }
        const calcData = {};
        const calcImageWidthHeight = document.getElementsByClassName("ReactCrop__image")[0];
        calcData.xmax = (completedCrop.x + completedCrop.width) / calcImageWidthHeight.clientWidth;
        calcData.ymax = (completedCrop.y + completedCrop.height) / calcImageWidthHeight.clientHeight;
        calcData.xmin = completedCrop.x / calcImageWidthHeight.clientWidth;
        calcData.ymin = completedCrop.y / calcImageWidthHeight.clientHeight;
        const predictionDataPx = {};
        predictionDataPx.xmax = (calcData.xmax * width).toFixed(4);
        predictionDataPx.ymax = (calcData.ymax * height).toFixed(4);
        predictionDataPx.xmin = (calcData.xmin * width).toFixed(4);
        predictionDataPx.ymin = (calcData.ymin * height).toFixed(4);
        setOutput({
            predictionData: predictionDataPx,
            cropData: completedCrop,
            flag: flags
        });
        setShowButton(true);
    };
    const onCropComplete = (crop)=>{
        if (isNaN(crop.x)) {
            crop.x = 0;
        }
        if (isNaN(crop.y)) {
            crop.y = 0;
        }
        setCrop(crop);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cropper-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ReactCrop_min_default()), {
                    aspects: 1,
                    crop: crop,
                    keepSelection: true,
                    src: imageUrl,
                    onChange: (c)=>onCropComplete(c),
                    minHeight: 55,
                    minWidth: 55,
                    onImageLoaded: onLoad,
                    disabled: !loading,
                    locked: !loading,
                    onDragStart: handleOnDragStart,
                    onDragEnd: handleDragEnd,
                    onComplete: (c)=>setCompletedCrop(c),
                    alt: "crop",
                    "data-testid": "image-react-crop-picker",
                    renderSelectionAddon: ()=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: drag_indicator/* default */.Z === null || drag_indicator/* default */.Z === void 0 ? void 0 : drag_indicator/* default.src */.Z.src,
                                alt: "drag_indicator"
                            })
                        });
                    }
                })
            }),
            showTooltip !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showTooltip === "firstText" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "coachBox position-absolute text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: tooltip
                        })
                    }) : null,
                    showTooltip === "secondText" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "coachBox secondText position-absolute text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: toolTipCrop
                        })
                    }) : null
                ]
            }) : null,
            !showButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "verify-image position-absolute",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: tickButton/* default */.Z === null || tickButton/* default */.Z === void 0 ? void 0 : tickButton/* default.src */.Z.src,
                            alt: "correct",
                            onClick: ()=>handleBoundingBox(true)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icon mx-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: crossButton/* default */.Z === null || crossButton/* default */.Z === void 0 ? void 0 : crossButton/* default.src */.Z.src,
                            alt: "cross",
                            onClick: ()=>handleBoundingBox(false)
                        })
                    })
                ]
            })
        ]
    });
};
ImageCropPicker.propTypes = {
    loading: (prop_types_default()).bool.isRequired,
    imageData: prop_types_default().shape({
        width: (prop_types_default()).number.isRequired,
        height: (prop_types_default()).number.isRequired
    }).isRequired,
    imageUrl: (prop_types_default()).string.isRequired,
    product: prop_types_default().shape({
        model1: prop_types_default().shape({
            xmin: (prop_types_default()).number,
            ymin: (prop_types_default()).number,
            xmax: (prop_types_default()).number,
            ymax: (prop_types_default()).number
        }),
        model2: (prop_types_default()).any
    }),
    setOutput: (prop_types_default()).func.isRequired,
    output: prop_types_default().shape({
        cropData: (prop_types_default()).object
    })
};
/* harmony default export */ var ResultPage_ImageCropPicker = (ImageCropPicker);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ImageCropper/index.js









const ImageCropper = (props)=>{
    const { image , setSection , product , setOutput , output , loading  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { incorrectMatch , newSearch  } = (0,localization/* getTranslations */.F)(t);
    const [imagePreview, setImagePreview] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (image) {
            const imageUrl = URL.createObjectURL(image === null || image === void 0 ? void 0 : image.file);
            setImagePreview(imageUrl);
        }
    }, [
        image
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ImageCropper_index_module_default()).ImageCropperWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "image-cropper mb-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "outer-image-section position-relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ImageCropPicker, {
                        loadedState: true,
                        imageUrl: imagePreview,
                        imageData: image,
                        product: product,
                        setOutput: setOutput,
                        output: output,
                        loading: loading
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "incorrect-search",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "incorrect-match",
                                    src: tooltip_questionmark/* default */.Z === null || tooltip_questionmark/* default */.Z === void 0 ? void 0 : tooltip_questionmark/* default.src */.Z.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: ()=>setSection("categotory"),
                                    children: incorrectMatch
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "new-search",
                                    src: visual_search_small === null || visual_search_small === void 0 ? void 0 : visual_search_small.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: ()=>setSection("upload"),
                                    children: newSearch
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
ImageCropper.propTypes = {
    image: (prop_types_default()).object.isRequired,
    setSection: (prop_types_default()).func.isRequired,
    product: (prop_types_default()).object,
    setOutput: (prop_types_default()).func.isRequired,
    output: (prop_types_default()).object,
    loading: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var ResultPage_ImageCropper = (ImageCropper);

// EXTERNAL MODULE: ./components/VisualSearch/v1/ResultPage/ProductDetail/index.module.scss
var ProductDetail_index_module = __webpack_require__(42964);
var ProductDetail_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetail_index_module);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ImageSection/index.jsx




const ImageSection = (props)=>{
    const { product , varentList  } = props;
    const imageInfo = varentList.length !== 0 ? varentList : product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-split-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "standard-image-container",
            className: "standard-image-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                item: imageInfo
            })
        })
    });
};
ImageSection.propTypes = {
    product: (prop_types_default()).object.isRequired,
    varentList: (prop_types_default()).array.isRequired
};
/* harmony default export */ var ResultPage_ImageSection = (/*#__PURE__*/react.memo(ImageSection));
const ProductImage = (param)=>{
    let { item  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (item === null || item === void 0 ? void 0 : item.imageUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "standard-product-image position-relative image_".concat(item === null || item === void 0 ? void 0 : item.sku),
            id: item === null || item === void 0 ? void 0 : item.sku,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: item === null || item === void 0 ? void 0 : item.imageUrl,
                alt: "Standard Product",
                onError: (e)=>{
                    e.target.src = image_missing/* default.src */.Z.src;
                    e.target.parentNode.classList.add("missing");
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "standard-product-image missing",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: image_missing/* default.src */.Z.src,
                alt: "Standard Product"
            })
        })
    });
};
ProductImage.propTypes = {
    item: prop_types_default().shape({
        imageUrl: (prop_types_default()).string
    }).isRequired
};

// EXTERNAL MODULE: ./components/PartsViewer/v2/SwatchItems/index.js
var SwatchItems = __webpack_require__(73433);
// EXTERNAL MODULE: ./components/VisualSearch/v1/ResultPage/ProductDtls/index.module.scss
var ProductDtls_index_module = __webpack_require__(90996);
var ProductDtls_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductDtls_index_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ProductDtls/index.jsx











const ProductDtls = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    const { product , setVarentList , varentList , setShow  } = props;
    const { allswatch  } = product || {};
    const [varent, setVarent] = (0,react.useState)(product.sku);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { colorFinish , closestMatch , friendsFamilyPrice , associatePrice , listPriceInfo  } = (0,localization/* getTranslations */.F)(t);
    const persona = (0,helper/* getUserPersona */.shu)();
    (0,react.useEffect)(()=>{
        setVarent(product.sku);
    }, [
        product.sku
    ]);
    (0,react.useEffect)(()=>{
        allswatch[0].filter((item)=>{
            if ((item === null || item === void 0 ? void 0 : item.id) === varent) {
                setVarentList(item);
            }
        });
    }, [
        varent
    ]);
    const handleSwatchClick = (selectedVarent)=>{
        const viewport = window.innerWidth;
        if (viewport < 812) {
            (0,v1_utils/* getScrollTo */.rr)("image_".concat(selectedVarent));
        }
    };
    const priceCTR = varentList === null || varentList === void 0 ? void 0 : (ref = varentList.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[persona]) === null || ref2 === void 0 ? void 0 : ref2.centAmount;
    const discountPrice = varentList === null || varentList === void 0 ? void 0 : (ref3 = varentList.prices) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.discountPrices) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[persona]) === null || ref5 === void 0 ? void 0 : ref5.centAmount;
    const pricing = (0,v1_utils/* getPrice */.aS)(priceCTR, discountPrice);
    const personaPrice = varentList === null || varentList === void 0 ? void 0 : (ref6 = varentList.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.prices) === null || ref7 === void 0 ? void 0 : ref7[persona];
    var ref11, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductDtls_index_module_default()).DetailsProduct),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "details-text",
            id: "details-text",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "closest-match",
                    children: closestMatch
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    level: 2,
                    className: "label-desc mt-1 text-capitalize",
                    children: product === null || product === void 0 ? void 0 : product.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    level: 3,
                    className: "label-sku",
                    children: product === null || product === void 0 ? void 0 : product.shortDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    level: 3,
                    className: "label-sku-number",
                    children: (ref11 = varentList === null || varentList === void 0 ? void 0 : varentList.sku) !== null && ref11 !== void 0 ? ref11 : product === null || product === void 0 ? void 0 : product.sku
                }),
                personaPrice !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                            level: 3,
                            className: "label-price",
                            children: [
                                pricing === null || pricing === void 0 ? void 0 : pricing.actualPrice,
                                persona === "KEMP" || persona === "FF" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "productdtlpage__customer-group",
                                    children: [
                                        persona === "FF" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: friendsFamilyPrice
                                        }) : null,
                                        persona === "KEMP" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: associatePrice
                                        }) : null
                                    ]
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            level: 3,
                            className: "label-price-strike",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strike", {
                                children: pricing === null || pricing === void 0 ? void 0 : pricing.strikePrice
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "pricelist-text",
                            children: [
                                (0,v1_utils/* formatPrice */.T4)(varentList === null || varentList === void 0 ? void 0 : (ref8 = varentList.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.prices) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["ANY"]) === null || ref10 === void 0 ? void 0 : ref10.centAmount),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "list-text ml-5 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "List Price"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "list-description",
                                            children: listPriceInfo
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: " text-color ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "color-finish",
                            children: [
                                colorFinish,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "finish",
                            children: (ref12 = varentList === null || varentList === void 0 ? void 0 : varentList.label) !== null && ref12 !== void 0 ? ref12 : product === null || product === void 0 ? void 0 : product.label
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwatchItems/* default */.Z, {
                    variantList: allswatch[0],
                    setVariant: setVarent,
                    variant: varent,
                    clickSwatch: ()=>{
                        return handleSwatchClick(varentList === null || varentList === void 0 ? void 0 : varentList.sku);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "view-button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "view-product-button",
                            type: "black",
                            label: "View Product",
                            size: "large",
                            flexible: true,
                            role: "button",
                            onClick: ()=>{
                                return (0,v1_utils/* viewPdp */.MG)(product === null || product === void 0 ? void 0 : product.pdpUrl);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "service-button",
                            type: "ghost",
                            label: "Service Parts",
                            size: "large",
                            flexible: true,
                            role: "button",
                            onClick: ()=>{
                                setShow(true);
                            }
                        })
                    ]
                })
            ]
        })
    });
};
ProductDtls.propTypes = {
    product: prop_types_default().shape({
        sku: (prop_types_default()).string,
        productNo: (prop_types_default()).string,
        name: (prop_types_default()).string,
        shortDescription: (prop_types_default()).string,
        label: (prop_types_default()).string,
        pdpUrl: (prop_types_default()).string,
        allswatch: prop_types_default().arrayOf((prop_types_default()).array)
    }),
    setVarentList: (prop_types_default()).func.isRequired,
    varentList: prop_types_default().shape({
        sku: (prop_types_default()).string,
        label: (prop_types_default()).string,
        prices: prop_types_default().shape({
            prices: prop_types_default().objectOf(prop_types_default().shape({
                centAmount: (prop_types_default()).number
            })),
            discountPrices: prop_types_default().objectOf(prop_types_default().shape({
                centAmount: (prop_types_default()).number
            }))
        })
    }),
    setShow: (prop_types_default()).func.isRequired
};
/* harmony default export */ var ResultPage_ProductDtls = (ProductDtls);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ProductDetail/index.jsx






const ProductDetail = (props)=>{
    const { product , loading , show , setShow , productInfo , productIds , setProductId , setPartsFlag , partsFlag  } = props;
    const [varentList, setVarentList] = (0,react.useState)([]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductDetail_index_module_default()).ProductDetail),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-details-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ImageSection, {
                    product: product,
                    varentList: varentList,
                    loading: loading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "prod-details w-100",
                    id: "prod-details",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ProductDtls, {
                        product: product,
                        varentList: varentList,
                        setVarentList: setVarentList,
                        loading: loading,
                        show: show,
                        setShow: setShow,
                        productInfo: productInfo,
                        productIds: productIds,
                        setProductId: setProductId,
                        setPartsFlag: setPartsFlag,
                        partsFlag: partsFlag
                    })
                })
            ]
        })
    });
};
ProductDetail.propTypes = {
    product: (prop_types_default()).object.isRequired,
    loading: (prop_types_default()).bool.isRequired,
    show: (prop_types_default()).bool.isRequired,
    setShow: (prop_types_default()).func.isRequired,
    productInfo: (prop_types_default()).object,
    productIds: (prop_types_default()).array,
    setProductId: (prop_types_default()).func,
    setPartsFlag: (prop_types_default()).func,
    partsFlag: (prop_types_default()).bool
};
/* harmony default export */ var ResultPage_ProductDetail = (ProductDetail);

// EXTERNAL MODULE: ./components/VisualSearch/v1/ResultPage/index.module.scss
var ResultPage_index_module = __webpack_require__(53896);
var ResultPage_index_module_default = /*#__PURE__*/__webpack_require__.n(ResultPage_index_module);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/LoadingPage/index.jsx



const ResultLoading = (props)=>{
    const { skuLists  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container match-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "d-flex flex-wrap result-items1 justify-content-start other-match first-match result-container loading-section card-gap ",
            children: skuLists.map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "kohler-product-card-root other-match-container d-flex justify-content-center align-items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "kohler-product-card-root d-flex load-widgets flex-column justify-content-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "shimmer-loading__image shimmer thumb-size image-part"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex flex-column justify-content-start mt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "width-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para shimmer loading-part"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para shimmer loading-part"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para shimmer loading-part"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, index))
        })
    });
};
ResultLoading.propTypes = {
    skuLists: (prop_types_default()).array.isRequired
};
/* harmony default export */ var LoadingPage = (ResultLoading);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ProductDtls/LoadingPage/index.jsx


const ListLoading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " match-container result-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "loading-w-100 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "standard-image-container",
                    className: "standard-image-container w-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "loading-imag-part shimmer-loading__para shimmer"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "details-text",
                        id: "details-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex flex-column",
                                children: Array.from({
                                    length: 3
                                }, (_, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "loading-part shimmer-loading__para shimmer"
                                    }, val))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex flex-column",
                                children: Array.from({
                                    length: 2
                                }, (_, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "loading-large-part shimmer-loading__para shimmer"
                                    }, val))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex",
                                children: Array.from({
                                    length: 5
                                }, (_, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "loading-small-part shimmer-loading__para shimmer"
                                    }, val))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex",
                                children: Array.from({
                                    length: 2
                                }, (_, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "loading-button-part shimmer-loading__para shimmer"
                                    }, val))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductDtls_LoadingPage = (ListLoading);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/ProductCard.mjs + 18 modules
var ProductCard = __webpack_require__(3345);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/ProductCards/index.jsx






const ProductCards = (props)=>{
    const { skuLists , setProductId , setShow , prodResult  } = props;
    const [productImages, setProductImages] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        if (prodResult) {
            const fetchImages = async ()=>{
                const images = {};
                let imageData;
                for (const productDetails of prodResult){
                    if ((productDetails === null || productDetails === void 0 ? void 0 : productDetails.isoImageURL) && productDetails.isoImageURL !== "") {
                        imageData = await (0,v1_utils/* isImageUrl */.hU)(productDetails === null || productDetails === void 0 ? void 0 : productDetails.isoImageURL) ? productDetails.isoImageURL : image_missing/* default.src */.Z.src;
                    }
                    images[productDetails.sku] = {
                        src: imageData,
                        alt: "Product Image"
                    };
                }
                setProductImages(images);
            };
            fetchImages();
        }
    }, [
        prodResult
    ]);
    const productProps = {
        type: "Product Card",
        maxWidth: "460px"
    };
    const getProductDetails = (skuVal)=>{
        const productDetails = prodResult === null || prodResult === void 0 ? void 0 : prodResult.find((item)=>item.sku === skuVal);
        if (productDetails) {
            const prices = (0,v1_utils/* getPersonaPriceListDetail */.lw)(productDetails);
            const imageData = productImages[skuVal] || {
                src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                alt: "Image Not Available"
            };
            return {
                ...productProps,
                productNumber: productDetails === null || productDetails === void 0 ? void 0 : productDetails.productNo,
                pdpUrl: productDetails === null || productDetails === void 0 ? void 0 : productDetails.pdpUrl,
                image: imageData,
                title: {
                    text: productDetails === null || productDetails === void 0 ? void 0 : productDetails.name
                },
                description: {
                    text: (productDetails === null || productDetails === void 0 ? void 0 : productDetails.longDescription) || (productDetails === null || productDetails === void 0 ? void 0 : productDetails.shortDescription) || ""
                },
                price: {
                    text: (0,v1_utils/* formatPrice */.T4)(prices)
                },
                productDetails: {
                    ...productProps.productDetails,
                    SKU: {
                        text: productDetails === null || productDetails === void 0 ? void 0 : productDetails.sku
                    }
                }
            };
        }
        return productProps;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "result-container flex-wrap card-gap result-items1",
        children: skuLists.map((val, index)=>{
            const getProductDetailsObj = getProductDetails(val);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "other-match-container fixed-card-height d-flex flex-column align-items-stretch w-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-column h-100 justify-content-between align-items-center w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* ProductCard */.I, {
                                ...getProductDetailsObj,
                                onClick: ()=>{
                                    (0,v1_utils/* viewPdp */.MG)(getProductDetailsObj === null || getProductDetailsObj === void 0 ? void 0 : getProductDetailsObj.pdpUrl);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "service-part-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "service-part-text",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setShow(true);
                                        setProductId(getProductDetailsObj === null || getProductDetailsObj === void 0 ? void 0 : getProductDetailsObj.productNumber);
                                    },
                                    children: "Service Parts"
                                })
                            })
                        ]
                    })
                })
            }, index);
        })
    });
};
ProductCards.propTypes = {
    skuLists: (prop_types_default()).array.isRequired,
    setProductDtlId: (prop_types_default()).func.isRequired,
    setProductId: (prop_types_default()).func.isRequired,
    setShow: (prop_types_default()).func.isRequired,
    prodResult: (prop_types_default()).array.isRequired,
    setPartsFlag: (prop_types_default()).func.isRequired
};
/* harmony default export */ var ResultPage_ProductCards = (ProductCards);

// EXTERNAL MODULE: ./services/medallia.js
var medallia = __webpack_require__(8229);
// EXTERNAL MODULE: ./components/InPageSearch/v1/utils.js
var InPageSearch_v1_utils = __webpack_require__(32223);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ResultPage/index.jsx



















const ResultPage = (props)=>{
    var ref, ref1, ref2, ref3;
    const { image , productResult , setSection , setOutput , output , setProductResult , category , loading , setLoading  } = props;
    const categoryVal = (0,v1_utils/* getValidCategory */.cR)(category);
    const toiletGroup = categoryVal === "toilet_group" ? true : false;
    const [groupFlagValue, setGroupFlagValue] = (0,react.useState)(toiletGroup);
    const [partsFlag, setPartsFlag] = (0,react.useState)(true);
    const [partsLoading, setPartsLoading] = (0,react.useState)(false);
    const topFiveResults = (productResult === null || productResult === void 0 ? void 0 : productResult.topResults) || [];
    const groupList = (productResult === null || productResult === void 0 ? void 0 : productResult.listResults) || [];
    let prodResult = toiletGroup ? groupList : topFiveResults;
    if (Array.isArray(prodResult) && prodResult.length > 8) {
        prodResult = prodResult.slice(0, 8);
    }
    const skuResultList = toiletGroup ? groupList : topFiveResults.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.sku) !== (productResult === null || productResult === void 0 ? void 0 : productResult.sku);
    });
    const skuLists = skuResultList === null || skuResultList === void 0 ? void 0 : skuResultList.map((item)=>item.sku);
    const productLists = prodResult === null || prodResult === void 0 ? void 0 : prodResult.map((item)=>item.productNo);
    const [productId, setProductId] = (0,react.useState)(null);
    const productDtlId = groupFlagValue ? null : productResult === null || productResult === void 0 ? void 0 : productResult.productNo;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { helpText , feedbackText  } = (0,localization/* getTranslations */.F)(t);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [show, setShow] = (0,react.useState)(false);
    const [productInfo, setProductInfo] = (0,react.useState)({});
    const getSkufromApi = async ()=>{
        const { file  } = image;
        setLoading(false);
        try {
            if (output === null || output === void 0 ? void 0 : output.predictionData) {
                var ref;
                const coordinates = output === null || output === void 0 ? void 0 : output.predictionData;
                const formdata = new FormData();
                formdata.append("category", categoryVal);
                formdata.append("file", file);
                if (coordinates) {
                    formdata.append("coordinates", JSON.stringify(coordinates));
                }
                const response = await (0,ct_service/* getProductByImage */.He)(formdata);
                if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.result) {
                    var ref1, ref2, ref3, ref4, ref5;
                    const slug = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.result) === null || ref2 === void 0 ? void 0 : ref2.slug;
                    const skuId = response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.result) === null || ref4 === void 0 ? void 0 : ref4.sku;
                    const resp = await (0,v1_utils/* getDetailSku */.i2)(slug, skuId);
                    const mergedResponse = {
                        ...response === null || response === void 0 ? void 0 : (ref5 = response.data) === null || ref5 === void 0 ? void 0 : ref5.result,
                        allswatch: [
                            resp
                        ]
                    };
                    setLoading(true);
                    setProductResult(mergedResponse);
                } else {
                    console.log("Error in fetching SKU API");
                    setSection("error");
                }
            }
        } catch (err) {
            console.log(err, "Error in fetching SKU API");
        }
    };
    const [productInfoMap, setProductInfoMap] = (0,react.useState)({});
    const fetchAllProductInfo = async ()=>{
        const newProductInfoMap = {};
        for (const id of productLists){
            const productInfo = await getProductInfo(id);
            newProductInfoMap[id] = {
                ...productInfo
            };
        }
        setProductInfoMap(newProductInfoMap);
    };
    (0,react.useEffect)(()=>{
        setProductInfo({});
        setPartsLoading(false);
        fetchAllProductInfo();
        setPartsLoading(true);
    }, [
        productResult
    ]);
    (0,react.useEffect)(()=>{
        try {
            setProductInfo({});
            if (output === null || output === void 0 ? void 0 : output.predictionData) {
                setPartsLoading(false);
                if (toiletGroup) {
                    setGroupFlagValue(true);
                }
                getSkufromApi();
                setPartsLoading(true);
            }
        } catch (err) {
            console.log(err, "Error in fetching predictionData SKU API");
        }
    }, [
        output === null || output === void 0 ? void 0 : output.predictionData
    ]);
    (0,react.useEffect)(()=>{
        if (show) {
            if (productInfoMap[productDtlId]) setProductInfo({
                ...productInfoMap[productInfoMap[productDtlId]]
            });
            else if (productInfoMap[productId]) {
                setProductInfo({
                    ...productInfoMap[productId]
                });
            }
        } else if (show === false) {
            setProductId(null);
            (0,v1_utils/* getScrollTo */.rr)("Collapsible");
        } else {
            setProductId(null);
        }
    }, [
        show
    ]);
    const getProductInfo = async (productId)=>{
        try {
            const partList = await dispatch((0,pdpSlice/* getPartList */.gt)({
                productId
            })).unwrap();
            const parts = (0,v1_utils/* getServiceParts */.SY)(partList);
            return parts;
        } catch (e) {
            console.log(e, "Error in Rendering Parts nad Diagram");
        }
    };
    (0,react.useEffect)(()=>{
        (0,v1_utils/* getScrollTo */.rr)("Collapsible");
    }, []);
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ResultPage_index_module_default()).ResultWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-result-layout w-100 h-100 top-0 container p-0 d-flex flex-column justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container-wrapper w-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-0 px-container flex-column",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "products-splits-containers w-100 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ImageCropper, {
                                        image: image,
                                        product: productResult,
                                        setSection: setSection,
                                        setOutput: setOutput,
                                        output: output,
                                        loading: loading,
                                        groupFlagValue: groupFlagValue
                                    }),
                                    (!loading || !partsLoading) && (groupFlagValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage, {
                                        skuLists: skuLists
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex justify-content-between align-items-center flex-column w-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDtls_LoadingPage, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage, {
                                                skuLists: skuLists
                                            })
                                        ]
                                    })),
                                    loading && partsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: groupFlagValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container result-items match-container ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ProductCards, {
                                                skuLists: skuLists,
                                                prodResult: prodResult,
                                                setProductId: setProductId,
                                                setPartsFlag: setPartsFlag,
                                                setShow: setShow,
                                                groupFlagValue: groupFlagValue
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container match-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ProductDetail, {
                                                    product: productResult,
                                                    loading: loading,
                                                    show: show,
                                                    setShow: setShow,
                                                    setProductInfo: setProductInfo,
                                                    productInfo: productInfo,
                                                    productIds: productDtlId,
                                                    setPartsFlag: setPartsFlag,
                                                    partsFlag: partsFlag
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " result-items ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPage_ProductCards, {
                                                        skuLists: skuLists,
                                                        prodResult: prodResult,
                                                        setPartsFlag: setPartsFlag,
                                                        setShow: setShow,
                                                        setProductId: setProductId
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsViewer/* default */.Z, {
                            onClose: ()=>setShow(false),
                            productId: productId !== null && productId !== void 0 ? productId : productDtlId,
                            partId: (ref4 = productInfoMap === null || productInfoMap === void 0 ? void 0 : (ref = productInfoMap[productId]) === null || ref === void 0 ? void 0 : ref.partId) !== null && ref4 !== void 0 ? ref4 : productInfoMap === null || productInfoMap === void 0 ? void 0 : (ref1 = productInfoMap[productDtlId]) === null || ref1 === void 0 ? void 0 : ref1.partId,
                            showModal: show,
                            page: "visual search",
                            fileMap: (ref5 = productInfoMap === null || productInfoMap === void 0 ? void 0 : (ref2 = productInfoMap[productId]) === null || ref2 === void 0 ? void 0 : ref2.fileMap) !== null && ref5 !== void 0 ? ref5 : productInfoMap === null || productInfoMap === void 0 ? void 0 : (ref3 = productInfoMap[productDtlId]) === null || ref3 === void 0 ? void 0 : ref3.fileMap
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feedback-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " provide-feedback visualContentwarppers",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "feedback",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: helpText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "provide-feedback-button",
                                type: "ghost",
                                label: feedbackText,
                                size: "large",
                                flexible: true,
                                role: "button",
                                onClick: ()=>(0,medallia/* showMedalliaFeedbackModal */.y0)(InPageSearch_v1_utils/* MEDALLIA_FORM_ID */.K)
                            })
                        ]
                    })
                })
            })
        ]
    });
};
ResultPage.propTypes = {
    image: (prop_types_default()).object.isRequired,
    productResult: (prop_types_default()).object,
    setSection: (prop_types_default()).func.isRequired,
    setOutput: (prop_types_default()).func.isRequired,
    output: (prop_types_default()).object,
    setProductResult: (prop_types_default()).func.isRequired,
    category: (prop_types_default()).string,
    loading: (prop_types_default()).bool.isRequired,
    setLoading: (prop_types_default()).func.isRequired
};
/* harmony default export */ var v1_ResultPage = (ResultPage);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/index.jsx













const VisualSearch = (props)=>{
    const { showVisualSearch =false  } = props;
    const [category, setCategory] = (0,react.useState)(null);
    const [section, setSection] = (0,react.useState)("category");
    const [image, setImage] = (0,react.useState)(null);
    const [openCam, setOpenCam] = (0,react.useState)(false);
    const [eventType, setEventType] = (0,react.useState)(null);
    const device = (0,useViewport/* default */.Z)();
    const [output, setOutput] = (0,react.useState)(null);
    const [productResult, setProductResult] = (0,react.useState)(null);
    const [loading, setLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (image != null) setSection("loading");
    }, [
        image
    ]);
    (0,react.useEffect)(()=>{
        const inpageSearch = (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? document.querySelector(".kf-react-button") : document.querySelector(".inpage-search__header-section");
        if (openCam && (device === null || device === void 0 ? void 0 : device.isSmallScreen)) {
            document.body.style.overflow = "hidden";
            inpageSearch.scrollIntoView({
                behavior: "smooth"
            });
        } else {
            document.body.style.overflow = "";
        }
        return ()=>{
            document.body.style.overflow = "";
        };
    }, [
        openCam
    ]);
    const updateCategoryItems = (input)=>{
        var ref, ref1;
        setCategory((ref = input[0]) === null || ref === void 0 ? void 0 : ref.category);
        if ((input === null || input === void 0 ? void 0 : (ref1 = input[0]) === null || ref1 === void 0 ? void 0 : ref1.comingSoon) === true) {
            setSection("comingSoon");
            setOpenCam(false);
        } else {
            setSection("upload");
        }
    };
    const selectSection = ()=>{
        switch(section){
            case "category":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SelectProductCategory, {
                    updateCategoryItems: updateCategoryItems,
                    setOpenCam: setOpenCam
                });
            case "comingSoon":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ComingSoon, {
                    category: category,
                    setSection: setSection
                });
            case "error":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ErrorFallBack, {
                    setSection: setSection,
                    category: category,
                    setOpenCam: setOpenCam
                });
            case "result":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ResultPage, {
                    image: image,
                    productResult: productResult,
                    setProductResult: setProductResult,
                    category: category,
                    setSection: setSection,
                    setOutput: setOutput,
                    output: output,
                    setLoading: setLoading,
                    loading: loading
                });
            case "upload":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_lib/* BrowserView */.I3, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                                setEventType: setEventType,
                                setImage: setImage,
                                category: category,
                                setSection: setSection,
                                output: output,
                                setOutput: setOutput
                            })
                        }),
                        (device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraView/* default */.Z, {
                                setImage: setImage,
                                setEventType: setEventType,
                                back: ()=>setSection("category"),
                                category: category,
                                setOpenCam: setOpenCam,
                                setSection: setSection,
                                setOutput: setOutput
                            })
                        }) : null
                    ]
                });
            case "loading":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_LoadingData, {
                    setSection: setSection,
                    image: image,
                    category: category,
                    setOpenCam: setOpenCam,
                    eventType: eventType,
                    setProductResult: setProductResult,
                    output: output,
                    setLoading: setLoading
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SelectProductCategory, {
                    updateCategoryItems: updateCategoryItems,
                    setOpenCam: setOpenCam
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (visualsearch_module_default()).VisualSearchContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
            open: showVisualSearch,
            children: selectSection()
        })
    });
};
/* harmony default export */ var v1 = (VisualSearch);

;// CONCATENATED MODULE: ./components/InPageSearch/v1/icons.js

const VisualSearchIconDesktop = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsxs("g", {
            id: "center_focus_weak",
            children: [
                /*#__PURE__*/ _jsx("mask", {
                    id: "mask0_381_122521",
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "60",
                    height: "60",
                    children: /*#__PURE__*/ _jsx("rect", {
                        id: "Bounding box",
                        width: "60",
                        height: "60",
                        fill: "#D9D9D9"
                    })
                }),
                /*#__PURE__*/ _jsx("g", {
                    mask: "url(#mask0_381_122521)",
                    children: /*#__PURE__*/ _jsx("path", {
                        id: "center_focus_weak_2",
                        d: "M10 50V37.7113H11.9231V48.0769H22.2888V50H10ZM37.7113 50V48.0769H48.0769V37.7113H50V50H37.7113ZM10 22.2888V10H22.2888V11.9231H11.9231V22.2888H10ZM48.0769 22.2888V11.9231H37.7113V10H50V22.2888H48.0769ZM30 37.0144C27.9983 37.0144 26.329 36.3456 24.9919 35.0081C23.6544 33.671 22.9856 32.0017 22.9856 30C22.9856 27.9983 23.6544 26.329 24.9919 24.9919C26.329 23.6544 27.9983 22.9856 30 22.9856C32.0017 22.9856 33.671 23.6544 35.0081 24.9919C36.3456 26.329 37.0144 27.9983 37.0144 30C37.0144 32.0017 36.3456 33.671 35.0081 35.0081C33.671 36.3456 32.0017 37.0144 30 37.0144ZM29.9937 35.0912C31.4242 35.0912 32.6315 34.6013 33.6156 33.6213C34.5994 32.6413 35.0913 31.4363 35.0913 30.0063C35.0913 28.5758 34.6013 27.3685 33.6213 26.3844C32.6413 25.4006 31.4363 24.9087 30.0063 24.9087C28.5758 24.9087 27.3685 25.3987 26.3844 26.3787C25.4006 27.3587 24.9088 28.5637 24.9088 29.9937C24.9088 31.4242 25.3987 32.6315 26.3787 33.6156C27.3587 34.5994 28.5637 35.0912 29.9937 35.0912Z",
                        fill: "#757575"
                    })
                })
            ]
        })
    });
const VisualSearchIconMobile = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "35",
        height: "36",
        viewBox: "0 0 35 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_242_37200",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "35",
                height: "36",
                children: /*#__PURE__*/ _jsx("rect", {
                    y: "0.5",
                    width: "35",
                    height: "35",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                mask: "url(#mask0_242_37200)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M5.83337 29.6654V22.4969H6.9552V28.5435H13.0018V29.6654H5.83337ZM21.9983 29.6654V28.5435H28.0449V22.4969H29.1667V29.6654H21.9983ZM5.83337 13.5005V6.33203H13.0018V7.45385H6.9552V13.5005H5.83337ZM28.0449 13.5005V7.45385H21.9983V6.33203H29.1667V13.5005H28.0449ZM17.5 22.0904C16.3324 22.0904 15.3586 21.7003 14.5786 20.9201C13.7984 20.1401 13.4083 19.1663 13.4083 17.9987C13.4083 16.8311 13.7984 15.8573 14.5786 15.0773C15.3586 14.2971 16.3324 13.907 17.5 13.907C18.6677 13.907 19.6415 14.2971 20.4214 15.0773C21.2017 15.8573 21.5918 16.8311 21.5918 17.9987C21.5918 19.1663 21.2017 20.1401 20.4214 20.9201C19.6415 21.7003 18.6677 22.0904 17.5 22.0904ZM17.4964 20.9686C18.3308 20.9686 19.0351 20.6828 19.6092 20.1111C20.183 19.5394 20.4699 18.8365 20.4699 18.0023C20.4699 17.1679 20.1841 16.4637 19.6124 15.8896C19.0408 15.3157 18.3379 15.0288 17.5037 15.0288C16.6693 15.0288 15.965 15.3146 15.3909 15.8863C14.8171 16.458 14.5301 17.1609 14.5301 17.9951C14.5301 18.8295 14.816 19.5337 15.3876 20.1078C15.9593 20.6817 16.6622 20.9686 17.4964 20.9686Z",
                    fill: "#757575"
                })
            })
        ]
    });
const VisualSearchIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("g", {
            id: "Visual Search Icon",
            children: /*#__PURE__*/ _jsxs("g", {
                id: "center_focus_weak",
                children: [
                    /*#__PURE__*/ _jsx("mask", {
                        id: "mask0_355_64216",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "60",
                        height: "60",
                        children: /*#__PURE__*/ _jsx("rect", {
                            id: "Bounding box",
                            width: "60",
                            height: "60",
                            fill: "#D9D9D9"
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        mask: "url(#mask0_355_64216)",
                        children: /*#__PURE__*/ _jsx("path", {
                            id: "center_focus_weak_2",
                            d: "M10 50V37.7113H11.9231V48.0769H22.2888V50H10ZM37.7113 50V48.0769H48.0769V37.7113H50V50H37.7113ZM10 22.2888V10H22.2888V11.9231H11.9231V22.2888H10ZM48.0769 22.2888V11.9231H37.7113V10H50V22.2888H48.0769ZM30 37.0144C27.9983 37.0144 26.329 36.3456 24.9919 35.0081C23.6544 33.671 22.9856 32.0017 22.9856 30C22.9856 27.9983 23.6544 26.329 24.9919 24.9919C26.329 23.6544 27.9983 22.9856 30 22.9856C32.0017 22.9856 33.671 23.6544 35.0081 24.9919C36.3456 26.329 37.0144 27.9983 37.0144 30C37.0144 32.0017 36.3456 33.671 35.0081 35.0081C33.671 36.3456 32.0017 37.0144 30 37.0144ZM29.9937 35.0912C31.4242 35.0912 32.6315 34.6013 33.6156 33.6213C34.5994 32.6413 35.0913 31.4363 35.0913 30.0063C35.0913 28.5758 34.6013 27.3685 33.6213 26.3844C32.6413 25.4006 31.4363 24.9087 30.0063 24.9087C28.5758 24.9087 27.3685 25.3987 26.3844 26.3787C25.4006 27.3587 24.9088 28.5637 24.9088 29.9937C24.9088 31.4242 25.3987 32.6315 26.3787 33.6156C27.3587 34.5994 28.5637 35.0912 29.9937 35.0912Z",
                            fill: "#212121"
                        })
                    })
                ]
            })
        })
    });
const VisualSearchIconGreyMobile = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "35",
        height: "36",
        viewBox: "0 0 35 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_218_34843",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "35",
                height: "36",
                children: /*#__PURE__*/ _jsx("rect", {
                    y: "0.5",
                    width: "35",
                    height: "35",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                mask: "url(#mask0_218_34843)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M5.83325 29.6654V22.4969H6.95508V28.5435H13.0017V29.6654H5.83325ZM21.9981 29.6654V28.5435H28.0448V22.4969H29.1666V29.6654H21.9981ZM5.83325 13.5005V6.33203H13.0017V7.45385H6.95508V13.5005H5.83325ZM28.0448 13.5005V7.45385H21.9981V6.33203H29.1666V13.5005H28.0448ZM17.4999 22.0904C16.3323 22.0904 15.3585 21.7003 14.5785 20.9201C13.7983 20.1401 13.4082 19.1663 13.4082 17.9987C13.4082 16.8311 13.7983 15.8573 14.5785 15.0773C15.3585 14.2971 16.3323 13.907 17.4999 13.907C18.6676 13.907 19.6414 14.2971 20.4213 15.0773C21.2015 15.8573 21.5916 16.8311 21.5916 17.9987C21.5916 19.1663 21.2015 20.1401 20.4213 20.9201C19.6414 21.7003 18.6676 22.0904 17.4999 22.0904ZM17.4963 20.9686C18.3307 20.9686 19.0349 20.6828 19.609 20.1111C20.1829 19.5394 20.4698 18.8365 20.4698 18.0023C20.4698 17.1679 20.184 16.4637 19.6123 15.8896C19.0406 15.3157 18.3377 15.0288 17.5036 15.0288C16.6692 15.0288 15.9649 15.3146 15.3908 15.8863C14.8169 16.458 14.53 17.1609 14.53 17.9951C14.53 18.8295 14.8159 19.5337 15.3875 20.1078C15.9592 20.6817 16.6621 20.9686 17.4963 20.9686Z",
                    fill: "#212121"
                })
            })
        ]
    });
const VisualSearchIconNewMobile = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "35",
        height: "36",
        viewBox: "0 0 35 36",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5458_69523",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "35",
                height: "36",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    y: "0.5",
                    width: "35",
                    height: "35",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_5458_69523)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.82812 22.1436V26.6875C6.82812 27.7921 7.72356 28.6875 8.82812 28.6875H13.3721V29.6875H8.82812C7.17127 29.6875 5.82812 28.3444 5.82812 26.6875V22.1436H6.82812ZM29.1328 26.6875C29.1328 28.3444 27.7897 29.6875 26.1328 29.6875H21.5889V28.6875H26.1328C27.2374 28.6875 28.1328 27.7921 28.1328 26.6875V22.1436H29.1328V26.6875ZM17.4805 13.3359C20.0735 13.3362 22.1756 15.4382 22.1758 18.0312L22.1699 18.2734C22.0482 20.6744 20.1227 22.6 17.7217 22.7217L17.4805 22.7275C14.9682 22.7275 12.9159 20.7545 12.79 18.2734L12.7842 18.0312C12.7844 15.5191 14.7574 13.4676 17.2383 13.3418L17.4805 13.3359ZM17.4805 14.3359C15.4395 14.3359 13.7844 15.9903 13.7842 18.0312C13.7842 20.0723 15.4394 21.7275 17.4805 21.7275C19.5214 21.7273 21.1758 20.0722 21.1758 18.0312C21.1756 15.9905 19.5212 14.3362 17.4805 14.3359ZM13.3721 7.38281H8.82812C7.72356 7.38281 6.82812 8.27824 6.82812 9.38281V13.9268H5.82812V9.38281C5.82812 7.72596 7.17127 6.38281 8.82812 6.38281H13.3721V7.38281ZM26.1328 6.38281C27.7897 6.38281 29.1328 7.72596 29.1328 9.38281V13.9268H28.1328V9.38281C28.1328 8.27824 27.2374 7.38281 26.1328 7.38281H21.5889V6.38281H26.1328ZM23.6416 10.4062C24.452 10.4062 25.1094 11.0636 25.1094 11.874C25.1092 12.6843 24.4519 13.3408 23.6416 13.3408C22.8315 13.3406 22.175 12.6842 22.1748 11.874C22.1748 11.0637 22.8313 10.4064 23.6416 10.4062Z",
                    fill: "#757575"
                })
            })
        ]
    });
const VisualSearchIconNew = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5458_105466",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "60",
                height: "60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "60",
                    height: "60",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_5458_105466)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.5 37.0918V46.75C11.5 47.7165 12.2835 48.5 13.25 48.5H22.9082V50H13.25C11.4551 50 10 48.5449 10 46.75V37.0918H11.5ZM50 46.75C50 48.5449 48.5449 50 46.75 50H37.0918V48.5H46.75C47.7165 48.5 48.5 47.7165 48.5 46.75V37.0918H50V46.75ZM30 21.8984C34.4764 21.8984 38.1055 25.5275 38.1055 30.0039L38.0947 30.4209C37.8846 34.5654 34.5615 37.8887 30.417 38.0986L30 38.1094C25.6636 38.1093 22.1224 34.7034 21.9053 30.4209L21.8945 30.0039C21.8945 25.6674 25.3005 22.1263 29.583 21.9092L30 21.8984ZM30 23.3984C26.3521 23.3985 23.3945 26.356 23.3945 30.0039C23.3946 33.6517 26.3522 36.6093 30 36.6094C33.6479 36.6094 36.6054 33.6518 36.6055 30.0039C36.6055 26.3559 33.648 23.3984 30 23.3984ZM22.9082 11.5H13.25C12.2835 11.5 11.5 12.2835 11.5 13.25V22.9082H10V13.25C10 11.4551 11.4551 10 13.25 10H22.9082V11.5ZM46.75 10C48.5449 10 50 11.4551 50 13.25V22.9082H48.5V13.25C48.5 12.2835 47.7165 11.5 46.75 11.5H37.0918V10H46.75ZM40.6348 16.8281C42.0336 16.8281 43.168 17.9624 43.168 19.3613C43.1678 20.7601 42.0335 21.8936 40.6348 21.8936C39.2361 21.8934 38.1027 20.76 38.1025 19.3613C38.1025 17.9626 39.236 16.8283 40.6348 16.8281Z",
                    fill: "#757575"
                })
            })
        ]
    });
const CrossIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.704279 0L9.8599 9.28571L9.15562 10L0 0.714286L0.704279 0Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.29572 8.58307e-06L0.1401 9.28572L0.844378 10L10 0.714294L9.29572 8.58307e-06Z",
                fill: "#212121"
            })
        ]
    });

// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/InPageSearch/v1/InPageSearch.view.jsx

























const InPageSearchView = (props)=>{
    const { bgColor ="" , loading =false , partId ="" , isSkuSearch =false , productId ="" , searchString ="" , pdfPartsDiagram ="" , ctaLink ="" , ctaLabel ="" , type ="" , onChange =()=>{} , title ="" , lwAppName ="" , language ="en" , svgFileMap =[] , searchType ="" , placeholder ="" , showVisualSearchicon =true  } = props;
    const device = (0,useViewport/* default */.Z)();
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2: isPartsViewerV2Enabled = false , MYSQLCONNSTR_ENABLE_VISUAL_SEARCH_V1: isVisualSearchEnabled = false  } = featureFlags;
    const [width] = (0,useWindowResize/* default */.Z)();
    const isDarkBg = bgColor === "bgDark";
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [shortenedUrl, setShortenedUrl] = (0,react.useState)(ctaLink);
    const [showVisualSearch, setShowVisualSearch] = (0,react.useState)(false);
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { searchText , searchImageText  } = (0,localization/* getTranslations */.F)(t);
    const { globalConfig: { internationalization: { locale =constants.LOCALE_CANADA_FR  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isServicePage = constants.VISUAL_SEARCH_ALLOWED_URLS.includes(window.location.pathname);
    const VSGreyIcon = device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualSearchIconNewMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualSearchIconNew, {});
    const visualSearchIcon = VSGreyIcon;
    (0,react.useEffect)(()=>{
        if (ctaLink) {
            (0,helper/* getShortenedUrl */.Ppy)(ctaLink).then((url)=>setShortenedUrl(url));
        }
    }, [
        ctaLink
    ]);
    (0,react.useEffect)(()=>{
        (0,medallia/* initMedallia */.Ip)(InPageSearch_v1_utils/* MEDALLIA_FORM_ID */.K);
    }, [
        showVisualSearch
    ]);
    const handleKeyPress = (event)=>{
        const { keyCode ="" , key =""  } = event;
        if (keyCode === constants["default"].KEYCODE.ENTER && key === constants["default"].KEY.ENTER) {
            if (searchString !== "" && searchString.length <= 3) {
                var ref;
                location.href = "".concat(locale === constants.LOCALE_CANADA_FR ? (ref = shortenedUrl.replace) === null || ref === void 0 ? void 0 : ref.call(shortenedUrl, "/en/", "") : shortenedUrl, "?keyword=").concat(searchString).concat(searchType === "parts" ? "&service=true" : "");
            } else {
                const fl = "id,sku_s,slug_s,ProductResource.InteractiveSVG.resourceName_ss,ProductProductNo_s,ProductResource.InteractiveSVG.resourceTitle_ss,ProductResource.PartsPDFFileName.resourceFullWebURL_ss";
                api/* apim.get */.TH.get(constants.inPageSearchEndPoint, {
                    params: {
                        q: searchString,
                        fl,
                        fq: [
                            'Products:("ct")',
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: lwAppName.toLowerCase(),
                        profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search")
                    },
                    paramsSerializer: (params)=>{
                        return lib_default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    const { data: { response: { numFound ="" , docs =[]  } = {} , fusion: { exactMatch =""  } = {}  } = {}  } = res;
                    if (numFound === 1 && exactMatch) {
                        const mResources = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceName_ss", "");
                        const partId = Array.isArray(mResources) ? mResources[0] : mResources;
                        const productId = get_default()(docs[0], "ProductProductNo_s", "");
                        setIsShowModal(Boolean(partId) && Boolean(productId));
                    } else {
                        var ref;
                        location.href = "".concat(locale === constants.LOCALE_CANADA_FR ? (ref = shortenedUrl.replace) === null || ref === void 0 ? void 0 : ref.call(shortenedUrl, "/en/", "") : shortenedUrl, "?keyword=").concat(searchString).concat(searchType === "parts" ? "&service=true" : "");
                    }
                }).catch((err)=>console.log("error occured in fetch search term", err));
            }
        }
    };
    const handleOnClick = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (Boolean(partId) && Boolean(productId)) {
            setIsShowModal(true);
        }
        if (pdfPartsDiagram && pdfPartsDiagram[0]) {
            handlePDFDownload(event, pdfPartsDiagram ? pdfPartsDiagram[0] : "");
        }
    };
    const handlePDFDownload = (e, link)=>{
        e.stopPropagation();
        try {
            window.open(link.trim(), "_blank");
        } catch (err) {
            console.log(err);
        }
    };
    const onCloseModal = ()=>{
        setIsShowModal(false);
    };
    const getButton = ()=>{
        if (isSkuSearch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).inPageSearchWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "kf-react-button button gbh-data-layer large ".concat(isDarkBg ? "secondary" : "ghost", " ").concat(loading ? "disabled" : " ", " ").concat(searchString && searchString !== null && searchString.length > 0 ? "--active" : "--inactive"),
                    "data-gbh-data-layer": getEventInfo("".concat(ctaLink, "?keyword=").concat(searchString), "success"),
                    onClick: handleOnClick,
                    children: ctaLabel
                })
            });
        } else {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                label: ctaLabel,
                type: isDarkBg ? "secondary" : "ghost",
                to: "".concat(locale === constants.LOCALE_CANADA_FR ? (ref = shortenedUrl.replace) === null || ref === void 0 ? void 0 : ref.call(shortenedUrl, "/en/", "") : shortenedUrl, "?keyword=").concat(searchString).concat(searchType === "parts" ? "&service=true" : ""),
                className: "gbh-data-layer ".concat(loading ? "disabled" : " ", " ").concat(searchString && searchString !== null && searchString.length > 0 ? "--active" : "--inactive"),
                "data-gbh-data-layer": getEventInfo("".concat(ctaLink, "?keyword=").concat(searchString), "error", type, searchString)
            });
        }
    };
    (0,react.useEffect)(()=>{
        const getSearchKey = window.localStorage.getItem("getSearchKey");
        setShowTooltip(Boolean(!getSearchKey));
    }, []);
    const showVSDiv = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        (0,analytics/* addDataLayerVisualSearch */.K)({
            eventKey: "search using an image"
        });
        setShowVisualSearch((i)=>!i);
    };
    const hideTooltip = (e)=>{
        var ref;
        e.preventDefault();
        e.stopPropagation();
        setShowTooltip(false);
        window.localStorage.setItem("getSearchKey", true);
        (ref = document.querySelector(".tool-tip-clickable")) === null || ref === void 0 ? void 0 : ref.classList.add("tool-tip-clickable-hide");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "in-page-search ".concat(showVisualSearch ? "show-visualsearch-wrapper" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("inpage-search kf-react-container", isDarkBg && "inpage-search--dark"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row inpage-search-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("col-12 inpage-search__title", isDarkBg && "inpage-search__title--dark"),
                                children: (0,helper/* sanitizeText */.oOy)(title)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 inpage-search__header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("inpage-search__header-section", !isDarkBg && "inpage-search__header-section--light"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "inpage-search__search-filed ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "inpage-search__label",
                                                    htmlFor: "inpage-search__search-control",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            autoComplete: "off",
                                                            type: "text",
                                                            className: classnames_default()("inpage-search__search-control", isDarkBg && "inpage-search__search-control--dark"),
                                                            id: "inpage-search__search-control",
                                                            placeholder: placeholder,
                                                            "aria-labelledby": "searchBox",
                                                            onChange: (e)=>onChange(e.target.value),
                                                            onKeyUp: (e)=>handleKeyPress(e)
                                                        }),
                                                        isVisualSearchEnabled && showVisualSearchicon && isServicePage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "inpage-search__search-visual-icon ".concat(showVisualSearch ? "inpage-search__search-visual_show" : "inpage-search__search-visual"),
                                                            onClick: (e)=>showVSDiv(e),
                                                            children: [
                                                                visualSearchIcon,
                                                                showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "tool-tip-clickable",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-search",
                                                                            children: searchText
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "cross-icon-wrapper mb-3",
                                                                            onClick: (e)=>hideTooltip(e),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon, {})
                                                                        })
                                                                    ]
                                                                }),
                                                                (device === null || device === void 0 ? void 0 : device.isLargeTabView) && !showVisualSearch && !showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tool-tip-custom",
                                                                    children: searchImageText
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            }),
                                            width > 480 && searchString && searchString !== null && searchString.length > 0 && getButton(),
                                            isPartsViewerV2Enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsViewer/* default */.Z, {
                                                page: "search",
                                                onClose: onCloseModal,
                                                showModal: isShowModal,
                                                productId: productId,
                                                partId: partId,
                                                fileMap: svgFileMap.map((val)=>{
                                                    return {
                                                        id: val.url,
                                                        ...val
                                                    };
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                                                productId: productId,
                                                partId: partId,
                                                showModal: isShowModal,
                                                page: "search",
                                                onClose: onCloseModal
                                            })
                                        ]
                                    }),
                                    width <= 480 && getButton()
                                ]
                            })
                        ]
                    })
                })
            }),
            showVisualSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1, {
                showVisualSearch: showVisualSearch
            }) : null
        ]
    });
};
/* harmony default export */ var InPageSearch_view = ((0,dist_lib/* withOrientationChange */.Qe)(InPageSearchView));

;// CONCATENATED MODULE: ./components/InPageSearch/v1/InPageSearch.jsx









const InPageSearch = (props)=>{
    const { data: searchProps = {} , showVisualSearchicon =true  } = props;
    const [lwAppName, setLwAppName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [searchString, setSearchString] = (0,react.useState)("");
    const [{ loading , partId , productId  }, setState] = (0,react.useState)({
        loading: false,
        partId: "",
        productId: ""
    });
    const [isSkuSearch, setIsSkuSearch] = (0,react.useState)(false);
    const [pdfPartsDiagram, setPdfPartsDiagram] = (0,react.useState)("");
    const [svgFileMap, setSvgFileMap] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const { general: { lwAppName =""  } = {} , internationalization: { language ="en"  } = {}  } = config !== null && config !== void 0 ? config : {};
            setLwAppName(lwAppName);
            setLanguage(language);
        });
    }, []);
    const handleChange = (0,helper/* debounce */.DsO)((searchTerm)=>{
        setSearchString(searchTerm.trim());
    });
    (0,react.useEffect)(()=>{
        if (lwAppName && searchString) {
            getData(searchString);
        }
    }, [
        searchString,
        lwAppName
    ]);
    const getData = (searchString)=>{
        if (searchString.length >= 3) {
            setState((prevState)=>({
                    ...prevState,
                    loading: true
                }));
            const fl = "id,sku_s,slug_s,ProductResource.InteractiveSVG.resourceName_ss,ProductProductNo_s,ProductResource.InteractiveSVG.resourceTitle_ss,ProductResource.PartsPDFFileName.resourceFullWebURL_ss";
            api/* apim.get */.TH.get(constants.inPageSearchEndPoint, {
                params: {
                    q: searchString,
                    fl,
                    fq: [
                        'Products:("ct")',
                        'language_s:("'.concat(language, '")')
                    ],
                    collections: lwAppName.toLowerCase(),
                    profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search")
                },
                paramsSerializer: (params)=>{
                    return lib_default().stringify(params, {
                        arrayFormat: "repeat",
                        encode: false
                    });
                }
            }).then((res)=>{
                const { data: { response: { numFound ="" , docs =[]  } = {} , fusion: { exactMatch =""  } = {}  } = {}  } = res;
                if (numFound === 1 && exactMatch) {
                    const mResources = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceName_ss", "");
                    const mResourceTitles = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceTitle_ss", "");
                    const partLinks = (0,helper/* organizeData */.U2t)(mResources, mResourceTitles, "Service Parts Diagram", "part");
                    setSvgFileMap(partLinks);
                    const pdfPartsDiagram = get_default()(docs[0], "ProductResource.PartsPDFFileName.resourceFullWebURL_ss", "");
                    const partId = Array.isArray(mResources) ? mResources[0] : mResources;
                    const productId = get_default()(docs[0], "ProductProductNo_s", "");
                    setState((prevState)=>({
                            ...prevState,
                            partId: partId !== null && partId !== void 0 ? partId : "",
                            productId,
                            loading: false
                        }));
                    setPdfPartsDiagram(pdfPartsDiagram);
                    const isSkuSearch = Boolean(partId) && Boolean(productId) || Boolean(pdfPartsDiagram) && Boolean(pdfPartsDiagram[0]);
                    setIsSkuSearch(isSkuSearch);
                } else {
                    setIsSkuSearch(false);
                    setState((prevState)=>({
                            ...prevState,
                            loading: false
                        }));
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InPageSearch_view, {
        loading: loading,
        partId: partId,
        isSkuSearch: isSkuSearch,
        productId: productId,
        searchString: searchString,
        pdfPartsDiagram: pdfPartsDiagram,
        onChange: handleChange,
        lwAppName: lwAppName,
        language: language,
        svgFileMap: svgFileMap,
        showVisualSearchicon: showVisualSearchicon,
        ...searchProps
    });
};
/* harmony default export */ var v1_InPageSearch = (InPageSearch);


/***/ }),

/***/ 32223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ MEDALLIA_FORM_ID; }
/* harmony export */ });
const MEDALLIA_FORM_ID = "39220";


/***/ }),

/***/ 63652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ListConfirmationModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
;// CONCATENATED MODULE: ./components/ListConfirmationModal/localization.js
const getTranslations = (t)=>{
    return {
        listActionSuccess: t("kf.saveToList.action.success.title"),
        listActionDeleteMsg: t("Kf.myList.page.delete.confirm.msg"),
        listActionDeleteSuccessBtn: t("kf.account.label.myLists"),
        noListTitle: t("Kf.myList.page.nolist"),
        noListMsg: t("Kf.myList.page.nolist.msg"),
        bestSellersBtn: t("Kf.myList.page.shop.bestsellers"),
        deleteListTitle: t("kf.myList.page.deletList"),
        deleteDec: t("Kf.myList.page.delete.dec"),
        deleteListBtn: t("kf.myList.page.deletList"),
        deleteFromList: t("kf.myList.page.deletFromList"),
        deleteFromListDec: t("kf.myList.page.deletFromList.msg"),
        deleteFromListConfirmMsg: t("kf.myList.page.deletFromList.confirm.msg"),
        deleteProductFromList: t("kf.button.action.delete"),
        closeBtnTextForList: t("kf.checkout.label.close"),
        deleteProductFormListCloseMsg: t("kf.myList.page.deleteProduct.dec"),
        multiDeleteHeader: t("kf.delete.items.from.list.header"),
        multiDeleteFromListDec: t("kf.delete.items.from.list.dec"),
        multiDeleteBtnTex: t("kf.delete.items.from.list.btn"),
        multiDeleteSuccessDec: t("kf.delete.items.from.list.success.dec"),
        multiDeleteSuccessBtnTex: t("kf.myList.page.delete.success.btn")
    };
};

// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/ListConfirmationModal/index.module.scss
var index_module = __webpack_require__(47486);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
;// CONCATENATED MODULE: ./components/ListConfirmationModal/index.jsx












const ListConfirmationModal = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { list ={} , openConforMationModal =false , noLineItems =false , deleteList =false , deletefromListDetails =false , deleteFromList =false , closeConformationModal =()=>{} , deleteConfirmationModal =()=>{} , setSelectedList =()=>{} , handleSuccessCallBack =()=>{} , closeModalWithOutDelete =()=>{} , selectedItems =[] , multiDeleteFromList =false , deleteFromPLP =false , deleteFromPLPDataLayer =()=>{}  } = props || {};
    const { globalConfig: { internationalization: { locale: newLocale = "en-US" , language ="en"  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [headerTxt, setHeaderTxt] = (0,react.useState)("");
    const [decTxt, setDecTxt] = (0,react.useState)("");
    const [btnTxt, setBtnTxt] = (0,react.useState)("");
    const [deleteSuccess, setDeleteSuccess] = (0,react.useState)(false);
    const [deleteSuccessResponse, setDeleteSuccessResponse] = (0,react.useState)({});
    const [actionBtnDisabled, setActionBtnDisabled] = (0,react.useState)(false);
    const handleClose = ()=>{
        if (deleteSuccess) {
            if (multiDeleteFromList) {
                handleSuccessCallBack(deleteSuccessResponse);
            } else {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
                handleSuccessCallBack();
            }
        }
        if (btnTxt !== "My Lists" && deletefromListDetails) {
            closeModalWithOutDelete();
        } else if (multiDeleteFromList && !deleteSuccess) {
            closeModalWithOutDelete();
        } else {
            closeConformationModal();
        }
        deleteConfirmationModal();
    };
    const handleActionbtn = ()=>{
        if (btnTxt === "My Lists") {
            if (deleteList) {
                router.push("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
            } else if (deleteFromList) {
                setSelectedList(deleteSuccessResponse === null || deleteSuccessResponse === void 0 ? void 0 : deleteSuccessResponse.id);
                deleteConfirmationModal();
                router.push("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN, "?listId=").concat(deleteSuccessResponse === null || deleteSuccessResponse === void 0 ? void 0 : deleteSuccessResponse.id));
            }
        } else if (btnTxt === "Close" && deleteFromList) {
            deleteConfirmationModal();
            closeConformationModal();
        }
        if (multiDeleteFromList && deleteSuccess) {
            handleSuccessCallBack(deleteSuccessResponse);
        } else if (deleteSuccess) {
            if (!deletefromListDetails) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
            }
            handleSuccessCallBack();
            closeConformationModal();
        } else if (noLineItems) {
            router.push("/".concat(language).concat(routes/* PRODUCT_BEST_SELLERS */.RG));
        } else if (deleteList || deletefromListDetails) {
            setActionBtnDisabled(true);
            dispatch((0,favoritesSlice/* deleteUserList */.iF)(list)).unwrap().then((resonse)=>{
                setDeleteSuccess(true);
                setActionBtnDisabled(false);
                setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionSuccess);
                setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionDeleteMsg);
                setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionDeleteSuccessBtn);
            }).catch((error)=>{
                console.log(error);
            });
        } else if (deleteFromList) {
            setActionBtnDisabled(true);
            if (deleteFromPLP) {
                deleteFromPLPDataLayer();
            }
            dispatch((0,favoritesSlice/* deleteProductFromList */.D3)(list)).unwrap().then((resonse)=>{
                setDeleteSuccessResponse(resonse === null || resonse === void 0 ? void 0 : resonse.data);
                setDeleteSuccess(true);
                setActionBtnDisabled(false);
                setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionSuccess);
                setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteFromListConfirmMsg);
                setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.closeBtnTextForList);
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
            }).catch((error)=>{
                console.log(error);
            });
        } else if (multiDeleteFromList) {
            setActionBtnDisabled(true);
            dispatch((0,favoritesSlice/* deleteMultiProductFromList */.Lu)({
                list,
                selectedItems
            })).unwrap().then((resonse)=>{
                setDeleteSuccessResponse(resonse === null || resonse === void 0 ? void 0 : resonse.data);
                setDeleteSuccess(true);
                setActionBtnDisabled(false);
                setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionSuccess);
                setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteSuccessDec);
                setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.closeBtnTextForList);
            }).catch((error)=>{
                console.log(error);
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (noLineItems) {
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.noListTitle);
            setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.noListMsg);
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.bestSellersBtn);
        } else if (deleteList || deletefromListDetails) {
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteListTitle);
            setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteDec);
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteListBtn);
        } else if (deleteFromList) {
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            const ListName = list === null || list === void 0 ? void 0 : list.listName[locale];
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteFromList);
            setDecTxt("".concat(staticText === null || staticText === void 0 ? void 0 : staticText.deleteProductFormListCloseMsg, " '").concat(ListName, "'."));
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteProductFromList);
        } else if (multiDeleteFromList) {
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteHeader);
            setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteFromListDec);
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteBtnTex);
        }
    }, [
        noLineItems,
        deleteList,
        deleteFromList,
        deletefromListDetails,
        multiDeleteFromList
    ]);
    (0,react.useEffect)(()=>{
        document.body.style.overflow = openConforMationModal ? "hidden" : "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        openConforMationModal
    ]);
    return openConforMationModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).ListConfirmationModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "list-confirmation-modal ".concat(deleteFromList ? "deleteFromList" : "", " "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                        role: "presentation",
                        alt: "close",
                        width: "17",
                        height: "30"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "list-ocnfirmation-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header",
                            children: headerTxt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "discription",
                            children: decTxt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "cta-button",
                            onClick: handleActionbtn,
                            disabled: actionBtnDisabled,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cta-btn-txt",
                                children: btnTxt
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var components_ListConfirmationModal = (ListConfirmationModal);


/***/ }),

/***/ 65277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_PartsViewer_v2_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _components_Loader_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25443);
/* harmony import */ var _components_Loader_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_Loader_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Loader = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Loader_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().LoaderComponent),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "loader-image",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PartsViewer_v2_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .LoaderSpinner */ .cK, {})
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 72927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const ColorSwatchSelected = (props)=>{
    const { colors =[] , general ={} , cx ="" , mobile =false , customText =""  } = props || {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "color-swatch display-none".concat(mobile ? "__desktop" : ""),
        children: colors === null || colors === void 0 ? void 0 : colors.map((color, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: "".concat(color.name, "-id"),
                role: "radio",
                tabIndex: "0",
                "aria-label": "".concat(color.name, " color"),
                "aria-checked": true,
                rel: "noreferrer",
                title: color.name,
                className: cx({
                    "selected-swatch": true
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "radio",
                        id: "".concat(color.name, "-id"),
                        "aria-label": "".concat(color.name)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "swatch-outline",
                        role: "presentation",
                        src: "".concat(general.swatchUrl).concat(color.swatch).concat(window.innerWidth <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$"),
                        width: "20px",
                        alt: color.name
                    }),
                    customText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "color-text",
                        children: "".concat(customText, " ").concat(color.name)
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "color-text",
                        children: color.name
                    })
                ]
            }, "color-".concat(color.sku, "-").concat(color.customerFacingSKU, "-").concat(i)))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorSwatchSelected);


/***/ }),

/***/ 85619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Shared_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70914);
/* harmony import */ var _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55619);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_MyFavorites_v1_MyList_ListInventoryCheckModal_index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70033);
/* harmony import */ var _components_MyFavorites_v1_MyList_ListInventoryCheckModal_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_components_MyFavorites_v1_MyList_ListInventoryCheckModal_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36513);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20558);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11859);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55760);
/* harmony import */ var _components_MyFavorites_v1_MyList_ColorSwatchSelected_v1_index_jsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72927);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_MyFavorites_v1_MyList_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61171);













const ListInventoryCheckModal = (props)=>{
    const { closeInventoryCheckModal =()=>{} , general , presetConfigs , productData =[] , siteName , productQtyObj , staticText , flewItemsLessStock , allItemsOutOfStock , handleAvailableItemsToCart =()=>{}  } = props;
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .removeMavenoidChat */ .N9B)();
        return ()=>{
            const moreOptions = document.querySelector(".more-options");
            if (moreOptions && window.getComputedStyle(moreOptions).display === "none") {
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .addMavenoidChat */ .dVG)();
            }
        };
    }, []);
    const getOutOffStockText = (product)=>{
        if ((product === null || product === void 0 ? void 0 : product.stockStatus) === "Less Stock") {
            return "".concat(product === null || product === void 0 ? void 0 : product.inventory, " ").concat(staticText === null || staticText === void 0 ? void 0 : staticText.lessStock);
        } else if ((product === null || product === void 0 ? void 0 : product.stockStatus) === "Out of Stock") {
            return staticText === null || staticText === void 0 ? void 0 : staticText.outOfStock;
        }
        return "";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_MyFavorites_v1_MyList_ListInventoryCheckModal_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ListInventoryCheckModalWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "modal-container",
            "data-testid": "modal-container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "modal-body-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "close-modal-btn",
                        onClick: closeInventoryCheckModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                            role: "presentation",
                            alt: "close",
                            width: "16",
                            height: "16"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "header-container-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "title",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.quantityModelHeader
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "description",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.quantityModelSubHeader
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "items-header",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.item
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.quantity
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "product-container-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mobile-divider"
                            }),
                            productData.map((product, index)=>{
                                var ref;
                                var ref1;
                                const imageUrl = (ref1 = product === null || product === void 0 ? void 0 : product["productImages.url_ss"]) !== null && ref1 !== void 0 ? ref1 : [];
                                var ref2;
                                const sku = (ref2 = product === null || product === void 0 ? void 0 : product["masterSKU_s"]) !== null && ref2 !== void 0 ? ref2 : "";
                                const images = (0,_components_MyFavorites_v1_MyList_helper__WEBPACK_IMPORTED_MODULE_11__/* .getLineItemsProductImage */ .Db)(product, sku);
                                const colors = (0,_components_MyFavorites_v1_MyList_helper__WEBPACK_IMPORTED_MODULE_11__/* .getColors */ .EC)(product);
                                var ref3, _sku;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "product-container",
                                    "data-testid": "inventory-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "image-container",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                role: "button",
                                                onClick: (e)=>{},
                                                "data-testid": "view-product",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "list-image-tile",
                                                    children: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl[0]) && (images === null || images === void 0 ? void 0 : images.length) > 0 ? images === null || images === void 0 ? void 0 : images.map((id, i)=>{
                                                        const imgUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_6__/* .getPresetUrl */ .v$)(width, 0, general.swatchUrl, id, JSON.parse(presetConfigs));
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            className: "list-image",
                                                            id: id + "_IMG_" + i,
                                                            role: "presentation",
                                                            src: imgUrl,
                                                            imgsrc: imgUrl
                                                        }, id + "_IMG_" + i);
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        className: "list-image",
                                                        src: _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                                                        alt: "missing-image"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "details-container",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "brand",
                                                    "data-testid": "brand",
                                                    children: siteName === null || siteName === void 0 ? void 0 : siteName.toUpperCase()
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "name",
                                                    "data-testid": "name",
                                                    children: (ref3 = product === null || product === void 0 ? void 0 : product["Tile_Title"]) !== null && ref3 !== void 0 ? ref3 : ""
                                                }),
                                                colors && ((ref = colors[0]) === null || ref === void 0 ? void 0 : ref.name) === "Not Applicable" ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "color-text-main",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MyFavorites_v1_MyList_ColorSwatchSelected_v1_index_jsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        colors: colors,
                                                        cx: (classnames__WEBPACK_IMPORTED_MODULE_10___default()),
                                                        general: general,
                                                        mobile: false,
                                                        customText: staticText === null || staticText === void 0 ? void 0 : staticText.colorAndFinish
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "sku-text",
                                                    "data-testid": "sku",
                                                    children: "SKU: ".concat(sku)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "status",
                                                    "data-testid": "status",
                                                    children: getOutOffStockText(product)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "quantity-container",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "quantity-text",
                                                "data-testid": "quantity",
                                                children: (_sku = productQtyObj[sku]) !== null && _sku !== void 0 ? _sku : 1
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "button-container",
                        children: [
                            flewItemsLessStock ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                role: "button",
                                size: "small",
                                flexible: true,
                                type: "ghost",
                                className: "add-cart",
                                onClick: ()=>{
                                    return handleAvailableItemsToCart(staticText === null || staticText === void 0 ? void 0 : staticText.addAvailableItemsToCart);
                                },
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.addAvailableItemsToCart,
                                "data-testid": "add-to-cart"
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                role: "button",
                                size: "small",
                                flexible: true,
                                type: "ghost",
                                className: allItemsOutOfStock ? "close-black" : "close-empty",
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.close,
                                onClick: closeInventoryCheckModal,
                                "data-testid": "close-modal"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ListInventoryCheckModal);


/***/ }),

/***/ 33413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MyList_ListRequiredItemModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
// EXTERNAL MODULE: ./components/core/ColorSwatch/ColorSwatch.jsx
var ColorSwatch = __webpack_require__(32982);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/ListRequiredItemModal/ListRequiredItem/index.jsx
/* provided dependency */ var process = __webpack_require__(34155);











const ListRequiredItem = (props)=>{
    var ref;
    const { item ={} , addItemsData =[] , staticTexts ={} , colorId ="" , cart ={} , locale ="" , currencyCode ="" , backorder ="" , currencySign ="" , updateItems =()=>{} , isKohlerCanada =false  } = props;
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [selectedSkuItem, setSelectedSkuItem] = (0,react.useState)(item === null || item === void 0 ? void 0 : (ref = item.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
    const persona = (0,helper/* getUserPersona */.shu)();
    const isMobile = window.innerWidth <= 480;
    const requiredProductsData = [];
    let colorsDataMaster = [];
    const colorsDataVariants = [];
    let imagesDataMaster = [];
    const imagesDataVariants = [];
    let priceOfMaster = [];
    const priceOfVariants = [];
    let category = "";
    let slug = "";
    let customerFacingSKUMaster = [];
    const customerFacingSKUVariant = [];
    if (item) {
        var ref1;
        const product = {};
        const masterVariant = get_default()(item, "masterVariant", []);
        const variants = get_default()(item, "variants", []);
        const masterVariantSku = get_default()(masterVariant, "sku", "");
        slug = get_default()(item, 'slug["en-US"]', "");
        product.skuid = selectedSkuItem;
        product.masterVariantSku = masterVariantSku;
        const masterAttributes = get_default()(masterVariant, "attributes", []);
        customerFacingSKUMaster = [
            {
                id: masterVariantSku,
                CustomerFacingSKU: get_default()(masterAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "")
            }
        ];
        const masterColorName = get_default()(masterAttributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), "");
        const masterColorFiles = get_default()(masterAttributes.find((attr)=>attr.name === "SKUColorSwatchFilename"), "value", "");
        product.brandName = get_default()(masterVariant.attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
        product.productName = get_default()(masterVariant.attributes.find((attr)=>attr.name === "RegionBrandName"), "value", "");
        product.productDescription = get_default()(masterVariant.attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), "");
        imagesDataMaster = [
            {
                id: masterVariantSku,
                image: masterVariant.images.length > 0 ? get_default()(masterVariant, "images[0].url", "") : image_missing/* default */.Z
            }
        ];
        category = (0,helper/* getAttributeValue */.kDl)(masterAttributes, "ProductLocalCategory");
        priceOfMaster = [
            {
                id: masterVariantSku,
                price: (Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "value.centAmount", 0)) / 100).toFixed(2),
                discountedPrice: (Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "discounted.value.centAmount", 0)) / 100).toFixed(2),
                discountPercent: Number(get_default()(masterVariant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.permyriad", 0)) / 100,
                discountType: get_default()(masterVariant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.type", "")
            }
        ];
        if (!masterVariant.prices.find((item)=>{
            var ref, ref1, ref2;
            return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
        })) {
            priceOfMaster[0].price = (Number(get_default()(masterVariant.prices.find((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
            }), "value.centAmount", 0)) / 100).toFixed(2);
        }
        var ref2;
        const cartMasterVar = (ref2 = cart === null || cart === void 0 ? void 0 : (ref1 = cart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.variant.sku) === masterVariantSku;
        })) !== null && ref2 !== void 0 ? ref2 : {};
        if (cartMasterVar === null || cartMasterVar === void 0 ? void 0 : cartMasterVar.discountedPrice) {
            priceOfMaster[0].discountedPrice = (Number(get_default()(cartMasterVar.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
            priceOfMaster[0].discountType = get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
            priceOfMaster[0].discountPercent = priceOfMaster[0].discountType === "absolute" ? Number(get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(cartMasterVar.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
        }
        let OutOfStockMaster;
        const channels = Object.values(get_default()(masterVariant.availability, "channels", {}));
        if (channels.length > 0) {
            var ref3, ref4, ref5;
            const availableQtyMaster = ((ref5 = masterVariant === null || masterVariant === void 0 ? void 0 : (ref3 = masterVariant.availability) === null || ref3 === void 0 ? void 0 : ref3.channels[process === null || process === void 0 ? void 0 : (ref4 = process.env) === null || ref4 === void 0 ? void 0 : "eb939fc2-53eb-49d4-ac24-ba60d0345a93"]) === null || ref5 === void 0 ? void 0 : ref5.availableQuantity) || 0;
            OutOfStockMaster = availableQtyMaster > 0 ? false : true;
        }
        const getDiscontinuedValue = get_default()(masterAttributes.find((attr)=>attr.name === "RegionDiscontinuedDate"), "value", "");
        const discontinuedMasterVariant = Date.parse(getDiscontinuedValue) < Date.now();
        colorsDataMaster = [
            {
                id: masterVariantSku,
                name: "product-color-".concat(colorId),
                value: masterVariantSku,
                label: masterColorName,
                colorUrl: constants["default"].COLOR_FILE_URL + masterColorFiles,
                checked: masterVariantSku === selectedSkuItem ? true : false,
                isOutOfStock: OutOfStockMaster,
                isDiscontinued: discontinuedMasterVariant,
                notApplicable: masterColorFiles.toLowerCase() === constants.SWATCH_NA.toLowerCase()
            }
        ];
        variants.forEach((variant, i)=>{
            var ref;
            const variantAttributes = get_default()(variant, "attributes", []);
            const colorName = get_default()(variantAttributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), "");
            const colorFiles = get_default()(variantAttributes.find((attr)=>attr.name === "SKUColorSwatchFilename"), "value", "");
            const getDiscontinuedValue = get_default()(variantAttributes.find((attr)=>attr.name === "RegionDiscontinuedDate"), "value", "");
            const isDiscontinuedVariant = Date.parse(getDiscontinuedValue) < Date.now();
            let OutOfStockVariant;
            const channels = Object.values(get_default()(variant, "availability.channels", {}));
            if (channels.length > 0) {
                const availableQtyvariants = get_default()(channels[0], "availableQuantity", 0);
                OutOfStockVariant = availableQtyvariants > 0 ? false : true;
            }
            const variantSku = get_default()(variant, "sku", "");
            const isImgVariant = variantSku.startsWith("IMGV");
            customerFacingSKUVariant[i] = {
                id: variantSku,
                CustomerFacingSKU: get_default()(variantAttributes.find((attr)=>attr.name === "CustomerFacingSKU"), "value", "")
            };
            colorsDataVariants[i] = {
                id: variantSku,
                name: "product-color-".concat(colorId),
                value: variantSku,
                label: colorName,
                colorUrl: constants["default"].COLOR_FILE_URL + colorFiles,
                checked: variantSku === selectedSkuItem,
                isOutOfStock: OutOfStockVariant,
                isDiscontinued: isDiscontinuedVariant || isImgVariant,
                notApplicable: colorFiles.toLowerCase() === constants.SWATCH_NA.toLowerCase()
            };
            imagesDataVariants[i] = {
                id: variantSku,
                image: variant.images.length > 0 ? get_default()(variant, "images[0].url", "") : image_missing/* default */.Z
            };
            priceOfVariants[i] = {
                id: variantSku,
                price: (Number(get_default()(variant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "value.centAmount", 0)) / 100).toFixed(2),
                discountedPrice: (Number(get_default()(variant.prices.find((item)=>{
                    var ref, ref1, ref2;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                }), "discounted.value?.centAmount", 0)) / 100).toFixed(2),
                discountPercent: Number(get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.permyriad", 0)) / 100,
                discountType: get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "discounted.discount.obj.value.type", "")
            };
            if (!variant.prices.find((item)=>{
                var ref, ref1, ref2;
                return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && (item === null || item === void 0 ? void 0 : (ref1 = item.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
            })) {
                priceOfVariants[i].price = (Number(get_default()(variant.prices.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
                }), "value.centAmount", 0)) / 100).toFixed(2);
            }
            var ref1;
            const cartItem = (ref1 = cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === variantSku;
            })) !== null && ref1 !== void 0 ? ref1 : {};
            if (cartItem === null || cartItem === void 0 ? void 0 : cartItem.discountedPrice) {
                priceOfVariants[i].discountedPrice = (Number(get_default()(cartItem.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                priceOfVariants[i].discountType = get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                priceOfVariants[i].discountPercent = priceOfVariants[i].discountType === "absolute" ? Number(get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(cartItem.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
        });
        product.customerFacingSKU = [
            ...customerFacingSKUMaster,
            ...customerFacingSKUVariant
        ];
        product.priceData = [
            ...priceOfMaster,
            ...priceOfVariants
        ];
        product.imagesData = [
            ...imagesDataMaster,
            ...imagesDataVariants
        ];
        product.colorsData = [
            ...colorsDataMaster,
            ...colorsDataVariants
        ];
        product.backorder = backorder;
        requiredProductsData.push(product);
    }
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const selectedVariant = addItemsData && addItemsData.filter((list)=>{
            var ref;
            return (list === null || list === void 0 ? void 0 : list.masterVariantSku) === (item === null || item === void 0 ? void 0 : (ref = item.masterVariant) === null || ref === void 0 ? void 0 : ref.sku);
        });
        var ref2;
        const selectedSku = (ref2 = selectedVariant && ((ref = selectedVariant[0]) === null || ref === void 0 ? void 0 : ref.skuid)) !== null && ref2 !== void 0 ? ref2 : item === null || item === void 0 ? void 0 : (ref1 = item.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.sku;
        setSelectedSkuItem(selectedSku);
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>{
            return (list === null || list === void 0 ? void 0 : list.skuid) === selectedSku;
        })));
    }, []);
    (0,react.useEffect)(()=>{
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>list.skuid === selectedSkuItem)));
    }, [
        addItemsData
    ]);
    (0,react.useEffect)(()=>{
        if (category && slug) {
            (0,helper/* getPDPUrl */.ir5)(category, slug).then((url)=>{
                setPdpUrl(url);
            });
        }
    }, [
        category,
        slug
    ]);
    const handleNotifyme = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        location.href = decodeURIComponent("".concat(pdpUrl, "?skuId=").concat(selectedSkuItem));
    };
    const getSelectedSku = (sku)=>{
        setSelectedSkuItem(sku);
        setIsChecked(Boolean(addItemsData && addItemsData.find((list)=>list.skuid === sku)));
    };
    const getPrice = (sku, type)=>{
        return get_default()(requiredProductsData[0].priceData.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.id) === sku;
        }), type, 0);
    };
    const isItemOutOfStock = backorder ? false : get_default()(requiredProductsData[0].colorsData.find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
    }), "isOutOfStock", "");
    const colorswatchClickHandler = (id)=>{
        getSelectedSku(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "line-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-tile__image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: "",
                            src: get_default()(requiredProductsData[0].imagesData.find((item)=>{
                                return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                            }), "image", ""),
                            width: 120,
                            height: 120
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "line-item__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-and-description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "brand-name",
                                children: requiredProductsData[0].productName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item-description",
                                children: requiredProductsData[0].productDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "line-item__sku",
                        children: [
                            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sku-id",
                                children: get_default()(requiredProductsData[0].customerFacingSKU.find((item)=>{
                                    return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                                }), "CustomerFacingSKU", "")
                            }) : "",
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line-item__include--mobile",
                                children: !isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    className: "include-text",
                                    value: "",
                                    checked: isChecked,
                                    onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                                })
                            }) : ""
                        ]
                    }),
                    !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "line-item__price--desktop",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "list-item__price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    }),
                                    getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "list-item__discounted",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "list-item__percent-off",
                                                children: getPrice(selectedSkuItem, "discountType") === "absolute" ? "".concat(currencySign, "  ").concat(getPrice(selectedSkuItem, "discountPercent")) : "".concat(getPrice(selectedSkuItem, "discountPercent"), "% ").concat(staticTexts.percentOff)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: getPrice(selectedSkuItem, "price"),
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                checked: isChecked,
                                onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                            })
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "line-item__info",
                children: [
                    isMobile && !lib/* isTablet */.Em ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sku-id",
                        children: get_default()(requiredProductsData[0].customerFacingSKU.find((item)=>{
                            return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                        }), "CustomerFacingSKU", "")
                    }) : "",
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-item__price--mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "price_item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true
                                    })
                                }),
                                getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "discount-price",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: getPrice(selectedSkuItem, "price"),
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "discount-percent-off",
                                            children: [
                                                getPrice(selectedSkuItem, "discountType") === "absolute" ? currencySign + getPrice(selectedSkuItem, "discountPercent") : getPrice(selectedSkuItem, "discountPercent") + "%",
                                                " ",
                                                staticTexts.percentOff
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item-color",
                        children: [
                            requiredProductsData[0].colorsData && requiredProductsData[0].colorsData.filter((col)=>!col.notApplicable && !col.isDiscontinued).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "color-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "color-finish",
                                        children: staticTexts.colorOrFinish
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "color-value",
                                        children: get_default()(requiredProductsData[0].colorsData.find((item)=>{
                                            return (item === null || item === void 0 ? void 0 : item.id) === selectedSkuItem;
                                        }), "label", "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item-color-swatches",
                                children: requiredProductsData[0].colorsData && requiredProductsData[0].colorsData.filter((col)=>!col.notApplicable && !col.isDiscontinued).map((color, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch/* default */.Z, {
                                        type: "selector",
                                        id: color.id,
                                        name: color.name,
                                        value: color.value,
                                        label: color.label,
                                        colorUrl: color.colorUrl,
                                        checked: color.checked ? true : false,
                                        onClick: (id)=>colorswatchClickHandler(id)
                                    }, i))
                            }),
                            isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "out-of-stock-section --desktop",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "out-of-stock-msg",
                                        children: staticTexts.outOfStockErr
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "back-in-stock",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "gbh-data-layer",
                                            onClick: (e)=>{
                                                handleNotifyme(e);
                                            },
                                            href: "".concat(pdpUrl, "?skuId=").concat(selectedSkuItem),
                                            children: staticTexts.backInStock
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__include--mobile",
                children: !isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    className: "include-text",
                    value: staticTexts.includeTextCTA,
                    checked: isChecked,
                    onChange: (e)=>updateItems(e.target.checked, requiredProductsData[0])
                })
            }) : "",
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "line-item__price--mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "price",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "price_item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                value: getPrice(selectedSkuItem, "discountedPrice") > 0 ? getPrice(selectedSkuItem, "discountedPrice") : getPrice(selectedSkuItem, "price"),
                                displayType: "text",
                                thousandSeparator: true,
                                prefix: currencySign,
                                decimalScale: 2,
                                fixedDecimalScale: true
                            })
                        }),
                        getPrice(selectedSkuItem, "discountedPrice") > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "discount-price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: getPrice(selectedSkuItem, "price"),
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "discount-percent-off",
                                    children: [
                                        getPrice(selectedSkuItem, "discountType") === "absolute" ? currencySign + getPrice(selectedSkuItem, "discountPercent") : getPrice(selectedSkuItem, "discountPercent") + "%",
                                        " ",
                                        staticTexts.percentOff
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : "",
            isItemOutOfStock && !isKohlerCanada && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "out-of-stock-section --mobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "out-of-stock-msg",
                        children: staticTexts.outOfStockErr
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "back-in-stock",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gbh-data-layer",
                            onClick: (e)=>{
                                handleNotifyme(e);
                            },
                            href: "".concat(pdpUrl, "?skuId=").concat(selectedSkuItem),
                            children: staticTexts.backInStock
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ListRequiredItemModal_ListRequiredItem = (ListRequiredItem);

// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/localization.js
var localization = __webpack_require__(57493);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/ListRequiredItemModal/index.module.scss
var index_module = __webpack_require__(73188);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/ProductDetail/v3/productDetailsHelper.js
var productDetailsHelper = __webpack_require__(14887);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/utils.js
var ProductDetailView_utils = __webpack_require__(21328);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/ListRequiredItemModal/index.jsx
/* eslint-disable new-cap */ 






















const ListRequiredItemModal = (props)=>{
    var ref;
    const { installReq , discountPercent , isType , onModalClose , showModal , listItemsPrice , productRequiredAccessories , productDetailData , handleAddToCartWithInstallItems , isSkuDiscontinued , productBackOrdered  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticTexts = (0,localization/* getTranslations */.F)(t);
    const { masterSKU_s: sku = "" , ProductDescriptionProductShort_s: desc = "" , productName_s: name = ""  } = productDetailData;
    var _sku;
    const price = (_sku = listItemsPrice[sku]) !== null && _sku !== void 0 ? _sku : 0;
    var ref1;
    const discountedPrice = (ref1 = listItemsPrice["".concat(sku, "-discount")]) !== null && ref1 !== void 0 ? ref1 : 0;
    var ref2;
    const customerFacingSKU = (ref2 = listItemsPrice["".concat(sku, "-customerFacingSKU")]) !== null && ref2 !== void 0 ? ref2 : "";
    const dispatch = (0,es/* useDispatch */.I0)();
    const { authorData ={} , globalConfig: config = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [addItems, setAddItems] = (0,react.useState)([]);
    const [enableInclude, setEnableInclude] = (0,react.useState)(false);
    const [mainProductOutOfStock, setMainProductOutOfStock] = (0,react.useState)(false);
    const [imageUrl, setImageUrl] = (0,react.useState)("");
    const [colorsData, setColorsData] = (0,react.useState)([]);
    const [installRequiredItemsData, setInstallRequiredItemsData] = (0,react.useState)([]);
    const [reqItemLwData, setReqItemLwData] = (0,react.useState)([]);
    const modalWindow = (0,react.useRef)(null);
    const itemScroll = (0,react.useRef)(null);
    const [width] = (0,useWindowResize/* default */.Z)();
    const isKohlerCanada = (0,helper/* isCanadaSite */.guj)(config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName);
    const currencySign = isKohlerCanada ? "CAD $" : "$";
    const { general ={} , internationalization: { currencyCode ="" , locale =""  } = {}  } = config || {};
    const { siteName: brandName = "" , lwAppName =""  } = general;
    window.addEventListener("click", function(e) {
        var ref;
        if (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.contains(modalWindow === null || modalWindow === void 0 ? void 0 : modalWindow.current)) {
            onModalClose();
        }
    });
    (0,react.useEffect)(()=>{
        (0,cart/* getStock */.K5)(productDetailData["masterSKU_s"], true).then((param)=>{
            let { stock =0  } = param;
            setMainProductOutOfStock(stock <= 0);
        }).catch(()=>{});
    }, [
        productDetailData["masterSKU_s"]
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            var ref, ref1;
            const { general: { swatchUrl =""  } = {}  } = config;
            let variants = [];
            let colors = [];
            const availableColors = [];
            const disContinuedColors = [];
            if (productDetailData["variantList.sku_s"]) {
                variants = [
                    productDetailData["variantList.sku_s"]
                ];
            } else if (productDetailData["variantList.sku_ss"]) {
                variants = productDetailData["variantList.sku_ss"];
            }
            var ref2;
            // get list of variant colors
            const colorDetailsResponseOne = (ref2 = productDetailData["Color.SKU.Details_ss"]) !== null && ref2 !== void 0 ? ref2 : [];
            var ref3;
            const colorDetailsResponseTwo = (ref3 = productDetailData["Color.SKU.Details_s"]) !== null && ref3 !== void 0 ? ref3 : [];
            if (colorDetailsResponseOne) {
                colors = colorDetailsResponseOne.map((color)=>{
                    return (0,productDetailsHelper/* getColorDataObject */.WI)(color);
                });
            } else if (colorDetailsResponseTwo) {
                colors = [
                    (0,productDetailsHelper/* getColorDataObject */.WI)(colorDetailsResponseTwo)
                ];
            } else if (productDetailData["SKU.Details_ss"]) {
                colors = productDetailData["SKU.Details_ss"].map((color)=>{
                    const d = color.split("|");
                    return {
                        name: staticTexts.notApplicable,
                        swatch: constants.SWATCH_NA,
                        sku: d[0],
                        isStock: d[1],
                        discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now()),
                        customerSku: d[3]
                    };
                });
            }
            colors.forEach((color)=>{
                const colorObj = {
                    id: color.sku,
                    name: "product-color",
                    value: color.sku,
                    label: color.name,
                    notApplicable: color.swatch.toLowerCase() === constants.SWATCH_NA.toLowerCase(),
                    colorUrl: constants["default"].COLOR_FILE_URL + color.swatch,
                    checked: color.sku === productDetailData["masterSKU_s"],
                    discontinuedColor: color.discontinued,
                    slug: color.slug
                };
                color.discontinued ? disContinuedColors.push(colorObj) : availableColors.push(colorObj);
            });
            const isDisContinuedColor = (ref = colors.find((color)=>color.sku === productDetailData["masterSKU_s"])) === null || ref === void 0 ? void 0 : ref.discontinued;
            const colorsData = isDisContinuedColor ? disContinuedColors : availableColors;
            setColorsData(colorsData);
            const variantImages = productDetailData["productImages.labelWithUrl_s"] ? [
                productDetailData["productImages.labelWithUrl_s"]
            ] : productDetailData["productImages.labelWithUrl_ss"];
            let variantImageLabels = [];
            let variantImageURLs = [];
            if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
                const selVarImageUrls = [];
                const selVarImageLabels = [];
                variantImages.map((img)=>{
                    const imgDetail = img.split("|");
                    if (productDetailData["masterSKU_s"] === imgDetail[0]) {
                        var ref;
                        selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                        selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    } else if (!variants.find((v)=>v === imgDetail[0])) {
                        var ref1;
                        variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                        variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    }
                });
                variantImageLabels = [
                    ...selVarImageLabels,
                    ...variantImageLabels
                ];
                variantImageURLs = [
                    ...selVarImageUrls,
                    ...variantImageURLs
                ];
                if (variantImageURLs.length < 1) {
                    variantImageLabels.push(productDetailData["masterSKU_s"]);
                    variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                }
            } else {
                variantImageLabels.push(productDetailData["masterSKU_s"]);
                variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
            }
            const imagesData = (0,ProductDetailView_utils/* getFormatedImages */.$)({
                variantImageLabels,
                variantImageURLs,
                authorData
            });
            const imageUrl = swatchUrl + ((ref1 = imagesData[0]) === null || ref1 === void 0 ? void 0 : ref1.assetId);
            setImageUrl(imageUrl);
            getRequiredProductsData();
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (addItems.length !== 0) {
            setEnableInclude(true);
        } else {
            setEnableInclude(false);
        }
    }, [
        addItems
    ]);
    const getRequiredProductsData = ()=>{
        if (productRequiredAccessories.length) {
            let query = "";
            let lwQuery = "";
            productRequiredAccessories.forEach((item, i)=>{
                query = query + '"'.concat(item === null || item === void 0 ? void 0 : item.id, '"').concat(i !== productRequiredAccessories.length - 1 ? "," : "");
                lwQuery += '"'.concat(item === null || item === void 0 ? void 0 : item.id, '" ');
            });
            dispatch((0,pdpSlice/* fetchPdpRequiredItems */.Zp)(query)).unwrap().then((response)=>{
                setInstallRequiredItemsData(response);
                dispatch((0,pdpSlice/* getReqItemLwData */.gP)({
                    lwQuery,
                    brandName,
                    lwAppName
                })).unwrap().then((lwData)=>{
                    setReqItemLwData(lwData !== null && lwData !== void 0 ? lwData : []);
                });
            }).catch((err)=>{
                console.error("Fetching data failed", err);
            });
        }
    };
    const updateItems = (checked, item)=>{
        let installRequireItems = addItems;
        if (checked) {
            installRequireItems = installRequireItems.filter((requiredProduct)=>requiredProduct.masterVariantSku !== item.masterVariantSku);
            installRequireItems.push(item);
        } else {
            installRequireItems = installRequireItems.filter((requiredProduct)=>requiredProduct.skuid !== item.skuid);
        }
        setAddItems([
            ...installRequireItems
        ]);
    };
    const includeOnClick = ()=>{
        handleAddToCartWithInstallItems(addItems);
    };
    const addToCartButtonStatus = (enableInclude)=>{
        const mainCheck = isSkuDiscontinued || !enableInclude;
        const backOrderCheck = mainProductOutOfStock && !productBackOrdered;
        return !!(mainCheck || backOrderCheck);
    };
    (0,react.useEffect)(()=>{
        if (width > 991 && showModal && itemScroll.current && (installRequiredItemsData === null || installRequiredItemsData === void 0 ? void 0 : installRequiredItemsData.length) > 0) {
            if (window.OverlayScrollbars) {
                window.OverlayScrollbars(itemScroll === null || itemScroll === void 0 ? void 0 : itemScroll.current, {
                    className: "os-theme-dark",
                    resize: "none",
                    sizeAutoCapable: true,
                    clipAlways: true,
                    normalizeRTL: true,
                    paddingAbsolute: false,
                    autoUpdate: null,
                    autoUpdateInterval: 33,
                    nativeScrollbarsOverlaid: {
                        showNativeScrollbars: false,
                        initialize: true
                    },
                    overflow: {
                        x: "hidden"
                    },
                    scrollbars: {
                        visibility: "auto",
                        autoHide: "never",
                        autoHideDelay: 800,
                        dragScrolling: true,
                        clickScrolling: true,
                        touchSupport: true,
                        snapHandle: true
                    }
                });
            }
        }
    }, [
        showModal,
        itemScroll === null || itemScroll === void 0 ? void 0 : itemScroll.current,
        installRequiredItemsData,
        width
    ]);
    const handleAddToCart = (event)=>{
        includeOnClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).listRequiredItemModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-detail-page__install-items-modal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                showModal: showModal,
                onModalClose: onModalClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "required-item",
                    ref: modalWindow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "required-item__container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "required-item__left-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-title",
                                        children: staticTexts.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "item-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-details__image",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-image",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "product-image-container",
                                                        src: imageUrl,
                                                        alt: name,
                                                        onError: (e)=>(0,utils/* onImageError */.Ac)(e, imageUrl)
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item-details__info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-family-name",
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-description",
                                                        children: desc
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "sku-id",
                                                        children: customerFacingSKU || sku
                                                    }),
                                                    colorsData.filter((c)=>!c.notApplicable).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "color-finish",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Color/Finish"
                                                            }),
                                                            " :",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: get_default()(colorsData.find((item)=>item.id === sku), "label", "")
                                                            })
                                                        ]
                                                    }),
                                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "price",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "price-amount",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                value: discountedPrice > 0 ? discountedPrice : price,
                                                                displayType: "text",
                                                                thousandSeparator: true,
                                                                prefix: currencySign,
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true
                                                            })
                                                        })
                                                    }),
                                                    discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "required-item__display-discount --mobile",
                                                        children: [
                                                            discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "required-item__percent-off",
                                                                children: [
                                                                    isType === "absolute" ? currencySign + discountPercent : discountPercent + "%",
                                                                    " ",
                                                                    staticTexts.percentOff
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "required-item__discount-price --mobile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: price,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "required-item__right-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "required-product-title",
                                        children: isKohlerCanada ? staticTexts.cadRequiredProductTitle : staticTexts.requiredProductTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "required-product-description",
                                        children: isKohlerCanada ? staticTexts.cadRequiredProductDescription : staticTexts.requiredProductDescription
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "required-product-header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: staticTexts.productText
                                            }),
                                            isKohlerCanada ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: staticTexts.includeTextCTA
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: itemScroll,
                                        className: "product-line-items",
                                        children: installRequiredItemsData.length > 0 && installRequiredItemsData.map((product, i)=>{
                                            var ref;
                                            const lwProdData = (ref = reqItemLwData === null || reqItemLwData === void 0 ? void 0 : reqItemLwData.find((i)=>product.id === i.ctId_s)) !== null && ref !== void 0 ? ref : {};
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRequiredItemModal_ListRequiredItem, {
                                                staticTexts: staticTexts,
                                                addItemsData: addItems,
                                                item: product,
                                                updateItems: (checked, item)=>updateItems(checked, item),
                                                currencyCode: currencyCode,
                                                currencySign: currencySign,
                                                locale: locale,
                                                colorId: i,
                                                backorder: lwProdData["RegionOnBackOrder_s"] === "Yes",
                                                productInfo: productDetailData,
                                                isKohlerCanada: isKohlerCanada,
                                                ...props
                                            }, i);
                                        })
                                    }),
                                    isKohlerCanada ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "include-button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            useDefaultClass: true,
                                            role: "button",
                                            label: (installReq === null || installReq === void 0 ? void 0 : installReq.length) ? staticTexts.updateText : staticTexts.includeTextCTA,
                                            size: "medium",
                                            type: "primary",
                                            onClick: handleAddToCart,
                                            disabled: addToCartButtonStatus(enableInclude)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
ListRequiredItemModal.propTypes = {
    installReq: (prop_types_default()).array,
    discountPercent: (prop_types_default()).number,
    isType: (prop_types_default()).string,
    onModalClose: (prop_types_default()).func,
    showModal: (prop_types_default()).bool,
    listItemsPrice: (prop_types_default()).object,
    productRequiredAccessories: (prop_types_default()).array,
    productDetailData: (prop_types_default()).object,
    handleAddToCartWithInstallItems: (prop_types_default()).func,
    isSkuDiscontinued: (prop_types_default()).bool,
    productBackOrdered: (prop_types_default()).bool
};
/* harmony default export */ var MyList_ListRequiredItemModal = (ListRequiredItemModal);


/***/ }),

/***/ 68152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ dataLayerShareListPageEvents; },
/* harmony export */   "$s": function() { return /* binding */ dataLayerListDetailPageShareListEvents; },
/* harmony export */   "HF": function() { return /* binding */ dataLayerCreateNewMyListButton; },
/* harmony export */   "YU": function() { return /* binding */ dataLayerListDetailPageEvents; },
/* harmony export */   "cp": function() { return /* binding */ dataLayerListDetailAddToCartPageEvents; },
/* harmony export */   "cq": function() { return /* binding */ dataLayerOldestToNewest; },
/* harmony export */   "gn": function() { return /* binding */ dataLayerListCheckboxEvent; },
/* harmony export */   "hC": function() { return /* binding */ dataLayerNewestToOldest; },
/* harmony export */   "ro": function() { return /* binding */ dataLayerDeleteListButton; },
/* harmony export */   "t0": function() { return /* binding */ dataLayerViewShareListButton; },
/* harmony export */   "t6": function() { return /* binding */ dataLayerEventDetailsPageShow; },
/* harmony export */   "uP": function() { return /* binding */ dataLayerShopBestSellerButton; },
/* harmony export */   "v4": function() { return /* binding */ dataLayerViewListButton; },
/* harmony export */   "yJ": function() { return /* binding */ dataLayerlistTab; }
/* harmony export */ });
/* unused harmony export dataLayerMediaTab */
/* harmony import */ var _components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8541);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64757);


const sanitizeForDataLayer = (obj)=>{
    if (Array.isArray(obj)) {
        return obj.map(sanitizeForDataLayer);
    } else if (obj && typeof obj === "object") {
        const sanitized = {};
        for(const key in obj){
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const val = obj[key];
                if (val === undefined || val === null || typeof val === "string" && val.trim() === "") {
                    sanitized[key] = "n/a";
                } else if (typeof val === "object") {
                    sanitized[key] = sanitizeForDataLayer(val);
                } else {
                    sanitized[key] = val;
                }
            }
        }
        return sanitized;
    }
    return obj === undefined || obj === null || obj === "" ? "n/a" : obj;
};
const pushToAdobeDataLayer = (eventInfo, listInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const pageState = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const page = pageState;
    if (!page.category) page.category = {};
    page.category.pageType = "my list";
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...listInfo ? {
            listInfo
        } : {},
        page
    });
};
const pushToAdobeDataLayerDetails = function(eventInfo, listInfo) {
    let listName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const pageState = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const page = pageState;
    if (!page.category) page.category = {};
    page.category.pageType = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":detail");
    page.pageInfo.pageName = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":detail:").concat(listName);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...listInfo ? {
            listInfo
        } : {},
        page
    });
};
const dataLayerListCheckboxEvent = (param)=>{
    let { isSelectAll , isChecked , listName , checkedItems , productData , productInfo , quantityObject ={} , listItemsPrice ={} , persona  } = param;
    // Helper to map product to analytics attributes (same as add to cart)
    const mapProductToAnalytics = (product, persona)=>{
        if (!product) return {};
        let color = "";
        let image = "";
        if (product === null || product === void 0 ? void 0 : product["Color.".concat(persona, ".Details_ss")]) {
            var ref;
            const productInfoRec = product === null || product === void 0 ? void 0 : (ref = product["Color.".concat(persona, ".Details_ss")]) === null || ref === void 0 ? void 0 : ref.filter((rec)=>{
                return product["masterSKU_s"] === rec.split("|")[0];
            });
            if (productInfoRec.length) {
                const values = productInfoRec[0].split("|");
                color = values[1];
                image = values[5];
            }
        }
        var ref1, ref2, ref3, ref4;
        return {
            category: ((ref1 = product["Product_Category"]) !== null && ref1 !== void 0 ? ref1 : "").toLowerCase(),
            description: ((ref2 = product["ProductDescriptionProductShort_s"]) !== null && ref2 !== void 0 ? ref2 : "").toLowerCase(),
            productID: ((ref3 = product["ctId_s"]) !== null && ref3 !== void 0 ? ref3 : "").toLowerCase(),
            productName: ((ref4 = product["productName_s"]) !== null && ref4 !== void 0 ? ref4 : "").toLowerCase(),
            quantity: (quantityObject && product["masterSKU_s"] && typeof quantityObject[product["masterSKU_s"]] !== "undefined" ? quantityObject[product["masterSKU_s"]] : product.quantity || "1").toString(),
            productSalePrice: "".concat((listItemsPrice === null || listItemsPrice === void 0 ? void 0 : listItemsPrice["".concat(product["masterSKU_s"], "-discount")]) || listItemsPrice[product["masterSKU_s"]] || product["priceList.".concat(persona, ".finalPrice_d")] || ""),
            productSku: product["masterSKU_s"] ? "k-".concat(product["masterSKU_s"]).toLowerCase() : "n/a",
            defaultImageName: (image !== null && image !== void 0 ? image : "").toLowerCase(),
            productColor: color && color.trim() !== "" && color !== "null" ? "".concat(color).toLowerCase() : "n/a"
        };
    };
    let finalProductInfo;
    if (isSelectAll) {
        // If unchecking select all (isChecked === false), send all products' info
        if (isChecked) {
            var ref;
            finalProductInfo = checkedItems && productData ? (ref = checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.map((sku)=>productData.find((p)=>p.masterSKU_s === sku))) === null || ref === void 0 ? void 0 : ref.filter(Boolean).map((product)=>mapProductToAnalytics(product, persona)) : [];
        } else {
            // Unchecking select all: send all products
            finalProductInfo = productData ? productData.map((product)=>mapProductToAnalytics(product, persona)) : [];
        }
    } else {
        // productInfo is always [product] or []
        finalProductInfo = Array.isArray(productInfo) ? productInfo.map((product)=>mapProductToAnalytics(product, persona)) : productInfo ? [
            mapProductToAnalytics(productInfo, persona)
        ] : [];
        // If only one, flatten to object (like add to cart)
        if (finalProductInfo.length === 1) finalProductInfo = finalProductInfo[0];
    }
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventObj = {
        event: "cmp:click",
        eventInfo: {
            clickInternalLinks: "true",
            eventAction: "my account:my lists:".concat(isSelectAll ? "select all" : "single"),
            eventMsg: isSelectAll ? "Bulk add to cart initiated" : "n/a",
            eventName: "my account:my lists:".concat(isSelectAll ? "select all" : "single"),
            eventStatus: "n/a",
            eventType: "interaction",
            internalLinkName: "".concat(isSelectAll ? "select all items" : "single item", " ").concat(isChecked ? "checked" : "unchecked", " from my list"),
            internalLinkPosition: "my account:my lists",
            internalLinkType: "my account:my lists:".concat(listName),
            internalLinkURL: "n/a",
            internalLinkZoneName: "my account:my lists"
        },
        page,
        productInfo: finalProductInfo
    };
    window.adobeDataLayer.push(sanitizeForDataLayer(eventObj));
};
const dataLayerViewShareListButton = (listName, listInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const pageState = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const page = pageState;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .CLICK */ .ot),
        internalLinkName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(listName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(listName)
    };
    const category = {
        pageType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4),
        primaryCategory: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX),
        subCategory1: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4),
        subCategory2: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4),
        subCategoryID: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4),
        subCategoryID2: "n/a",
        subCategoryName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4)
    };
    if (!page.category) page.category = {};
    page.category = {
        ...page.category,
        ...category
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...listInfo ? {
            listInfo
        } : {},
        page
    });
};
const dataLayerViewListButton = (myListTitle, viewListCTATitle, listName, listInfo, idView)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const viewListCTAHeading = viewListCTATitle === null || viewListCTATitle === void 0 ? void 0 : viewListCTATitle.toLowerCase();
    const url = _constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .MY_LISTS_PAGE_PATH */ .PN;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(viewListCTAHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(viewListCTAHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(viewListCTAHeading),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(listName),
        internalLinkURL: "".concat(window.location.origin).concat(url).concat(idView),
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading)
    };
    pushToAdobeDataLayerDetails(eventInfo, listInfo, listName);
};
const dataLayerShopBestSellerButton = (myListTitle, shopBestSellerCTATitle, listName, listInfo)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const shopBestSellerCTAHeading = shopBestSellerCTATitle === null || shopBestSellerCTATitle === void 0 ? void 0 : shopBestSellerCTATitle.toLowerCase();
    const urlP = _constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_BEST_SELLERS */ .RG;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(shopBestSellerCTAHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(shopBestSellerCTAHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(shopBestSellerCTAHeading),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(listName),
        internalLinkURL: "".concat(window.location.origin).concat(urlP),
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo, listInfo);
};
const dataLayerDeleteListButton = (myListTitle, deleteListTitle, listName, listInfo)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const deleteListHeading = deleteListTitle === null || deleteListTitle === void 0 ? void 0 : deleteListTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(deleteListHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(deleteListHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(deleteListHeading),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(listName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo, listInfo);
};
const dataLayerCreateNewMyListButton = (myListTitle, createNewListTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const createNewListHeading = createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(createNewListHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(createNewListHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(createNewListHeading),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerlistTab = (myListTitle, tabListTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const listTabHeading = tabListTitle === null || tabListTitle === void 0 ? void 0 : tabListTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(listTabHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(listTabHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(listTabHeading),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(listTabHeading),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerMediaTab = (myListTitle, mediaTabTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const mediaTabHeading = mediaTabTitle === null || mediaTabTitle === void 0 ? void 0 : mediaTabTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(MY_ACCOUNT, ":").concat(myListHeading, ":").concat(mediaTabHeading),
        eventMsg: "n/a",
        eventName: "".concat(MY_ACCOUNT, ":").concat(myListHeading, ":").concat(mediaTabHeading),
        eventStatus: "n/a",
        eventType: "".concat(NAVIGATION),
        internalLinkName: "".concat(mediaTabHeading),
        internalLinkPosition: "".concat(MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(MY_ACCOUNT, ":").concat(myListHeading).concat(mediaTabHeading),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerNewestToOldest = (myListTitle, sortByTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const sortByHeading = sortByTitle === null || sortByTitle === void 0 ? void 0 : sortByTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY, ":").concat(sortByHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY, ":").concat(sortByHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NEWEST_TO_OLDEST */ .N$),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NEWEST_TO_OLDEST */ .N$),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerOldestToNewest = (myListTitle, sortByTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const sortByHeading = sortByTitle === null || sortByTitle === void 0 ? void 0 : sortByTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY, ":").concat(sortByHeading),
        eventMsg: "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY, ":").concat(sortByHeading),
        eventStatus: "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .OLDEST_TO_NEWEST */ .SE),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .OLDEST_TO_NEWEST */ .SE),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(myListHeading, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY)
    };
    pushToAdobeDataLayer(eventInfo);
};
const pushListDetailsAdobeDataLayer = (data)=>{
    const { name ="" , eventInfo ={} , productsCount =0 , productInfo =[] , shareListPage =false , listDetailsShareList =false  } = data;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    page.category.pageType = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name, ":").concat(productsCount);
    if (shareListPage) {
        page.category.pageType = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA);
        page.category.subCategory1 = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4);
        page.category.subCategory2 = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4);
        page.pageInfo.pageName = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(name);
        page.pageInfo.title = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, "|").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG);
    } else if (listDetailsShareList) {
        page.category.pageType = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAIL */ .Wo);
        page.pageInfo.pageName = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAIL */ .Wo, ":").concat(name);
    } else {
        var ref;
        page.category.pageType = (ref = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAIL */ .Wo, ":").concat(productsCount)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo: productInfo,
        page
    });
};
const dataLayerShareListPageEvents = (data)=>{
    const { name ="" , actionType ="" , productsCount =0 , records =[] , quantityObject ={} , eventStatus ="" , eventMsg ="" , eventType ="" , listTotalPrice ="" , listItemsPrice ={} , persona  } = data;
    let calActionType = actionType;
    if (records.length > 1 && actionType === _components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .ADD_T0_CART */ .dZ) {
        calActionType = _components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .ADD_ALL_T0_CART */ .Q0;
    }
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(calActionType),
        eventMsg: eventMsg || "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(calActionType),
        eventStatus: eventStatus || "n/a",
        eventType: eventType !== null && eventType !== void 0 ? eventType : "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(calActionType),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LISTS */ .sY),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(name),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SHARE_LIST */ .GA, ":").concat(name, ":").concat(listTotalPrice)
    };
    const productInfo = dataLayerEventDetailsPageProductInfo(records, quantityObject, listItemsPrice, persona);
    pushListDetailsAdobeDataLayer({
        eventInfo,
        productsCount,
        productInfo,
        name,
        shareListPage: true
    });
};
const dataLayerListDetailAddToCartPageEvents = (data)=>{
    const { name ="" , actionType ="" , productsCount =0 , eventStatus ="" , eventMsg ="" , eventType ="" , items =[] , records =[] , quantityObject ={} , handleSingleProduct =false , ctaLabel ="" , productInfo =[] , listItemsPrice , persona  } = data;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(actionType),
        eventMsg: eventMsg || "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(actionType),
        eventStatus: "".concat(eventStatus || "n/a").toLowerCase(),
        eventType: eventType,
        internalLinkName: "".concat(ctaLabel || actionType).toLowerCase(),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4)
    };
    let productInfoNew = productInfo;
    if (Array.isArray(productInfo) && productInfo.length === 1) {
        // Only one product: pass as object, not array with proper mapping
        const item = productInfo[0];
        // Find the matching record for this SKU
        const record = records.find((rec)=>rec["masterSKU_s"] === (item.productSku || item.productID || item.sku || item.masterSKU_s)) || {};
        // Compute color and image
        let color = "";
        let image = "";
        if (record === null || record === void 0 ? void 0 : record["Color.".concat(persona, ".Details_ss")]) {
            var ref;
            const productInfoRec = (ref = record["Color.".concat(persona, ".Details_ss")]) === null || ref === void 0 ? void 0 : ref.filter((recStr)=>{
                return record["masterSKU_s"] === recStr.split("|")[0];
            });
            if (productInfoRec.length) {
                const values = productInfoRec[0].split("|");
                color = values[1];
                image = values[5];
            }
        }
        var ref1, ref2, ref3, ref4, ref5;
        productInfoNew = {
            category: "".concat((ref1 = record["Product_Category"]) !== null && ref1 !== void 0 ? ref1 : "").toLowerCase(),
            description: "".concat((ref2 = record["ProductDescriptionProductShort_s"]) !== null && ref2 !== void 0 ? ref2 : "").toLowerCase(),
            productID: "".concat((ref3 = record["ctId_s"]) !== null && ref3 !== void 0 ? ref3 : "").toLowerCase(),
            productName: "".concat((ref4 = record["productName_s"]) !== null && ref4 !== void 0 ? ref4 : "").toLowerCase(),
            quantity: "".concat((ref5 = quantityObject[record["masterSKU_s"]]) !== null && ref5 !== void 0 ? ref5 : "").toLowerCase(),
            productSalePrice: "".concat((listItemsPrice === null || listItemsPrice === void 0 ? void 0 : listItemsPrice["".concat(record["masterSKU_s"], "-discount")]) || listItemsPrice[record["masterSKU_s"]] || ""),
            productSku: record["masterSKU_s"] ? "k-".concat(record["masterSKU_s"]).toLowerCase() : "n/a",
            defaultImageName: "".concat(image).toLowerCase(),
            productColor: color && color.trim() !== "" && color !== "null" ? "".concat(color).toLowerCase() : "n/a"
        };
    } else if (Array.isArray(productInfo) && productInfo.length > 1) {
        // Multiple products: pass productInfo array as is
        productInfoNew = productInfo.map((item)=>{
            // Find the matching record for this SKU
            const record = records.find((rec)=>rec["masterSKU_s"] === (item.productSku || item.productID || item.sku || item.masterSKU_s)) || {};
            // Compute color and image
            let color = "";
            let image = "";
            if (record["Color.".concat(persona, ".Details_ss")]) {
                var ref;
                const productInfoRec = record === null || record === void 0 ? void 0 : (ref = record["Color.".concat(persona, ".Details_ss")]) === null || ref === void 0 ? void 0 : ref.filter((recStr)=>{
                    return record["masterSKU_s"] === recStr.split("|")[0];
                });
                if (productInfoRec.length) {
                    const values = productInfoRec[0].split("|");
                    color = values[1];
                    image = values[5];
                }
            }
            var ref1, ref2, ref3, ref4, ref5;
            return {
                category: "".concat((ref1 = record["Product_Category"]) !== null && ref1 !== void 0 ? ref1 : "").toLowerCase(),
                description: "".concat((ref2 = record["ProductDescriptionProductShort_s"]) !== null && ref2 !== void 0 ? ref2 : "").toLowerCase(),
                productID: "".concat((ref3 = record["ctId_s"]) !== null && ref3 !== void 0 ? ref3 : "").toLowerCase(),
                productName: "".concat((ref4 = record["productName_s"]) !== null && ref4 !== void 0 ? ref4 : "").toLowerCase(),
                quantity: "".concat((ref5 = quantityObject[record["masterSKU_s"]]) !== null && ref5 !== void 0 ? ref5 : "").toLowerCase(),
                productSalePrice: "".concat((listItemsPrice === null || listItemsPrice === void 0 ? void 0 : listItemsPrice["".concat(record["masterSKU_s"], "-discount")]) || listItemsPrice[record["masterSKU_s"]] || ""),
                productSku: record["masterSKU_s"] ? "k-".concat(record["masterSKU_s"]).toLowerCase() : "n/a",
                defaultImageName: "".concat(image).toLowerCase(),
                productColor: color && color.trim() !== "" && color !== "null" ? "".concat(color).toLowerCase() : "n/a"
            };
        });
    }
    if (handleSingleProduct) {
        const colorAndImage = {
            color: "",
            image: ""
        };
        let itemsRecord = {};
        const record1 = records === null || records === void 0 ? void 0 : records.filter((rec)=>rec["masterSKU_s"] === items[0].productID.substring(2));
        if (record1.length) {
            var ref6, ref7;
            const productInfoRec1 = record1 === null || record1 === void 0 ? void 0 : (ref6 = record1[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["Color.".concat(persona, ".Details_ss")]) === null || ref7 === void 0 ? void 0 : ref7.filter((rec)=>{
                return items[0].productID.substring(2) === rec.split("|")[0];
            });
            if (productInfoRec1.length) {
                const values1 = productInfoRec1[0].split("|");
                colorAndImage.color = values1[1];
                colorAndImage.image = values1[5];
            }
            itemsRecord = record1[0];
        }
        var ref8, ref9, ref10, ref11, ref12;
        productInfoNew = {
            category: "".concat((ref8 = itemsRecord["Product_Category"]) !== null && ref8 !== void 0 ? ref8 : "").toLowerCase(),
            description: "".concat((ref9 = itemsRecord["ProductDescriptionProductShort_s"]) !== null && ref9 !== void 0 ? ref9 : "").toLowerCase(),
            productID: "".concat((ref10 = itemsRecord["ctId_s"]) !== null && ref10 !== void 0 ? ref10 : "").toLowerCase(),
            productName: "".concat((ref11 = itemsRecord["productName_s"]) !== null && ref11 !== void 0 ? ref11 : "").toLowerCase(),
            quantity: "".concat((ref12 = quantityObject[itemsRecord["masterSKU_s"]]) !== null && ref12 !== void 0 ? ref12 : "").toLowerCase(),
            productSalePrice: "".concat((listItemsPrice === null || listItemsPrice === void 0 ? void 0 : listItemsPrice["".concat(itemsRecord === null || itemsRecord === void 0 ? void 0 : itemsRecord["masterSKU_s"], "-discount")]) || listItemsPrice[itemsRecord["masterSKU_s"]]),
            productSku: itemsRecord["masterSKU_s"] ? "k-".concat(itemsRecord["masterSKU_s"]).toLowerCase() : "n/a",
            defaultImageName: "".concat(colorAndImage === null || colorAndImage === void 0 ? void 0 : colorAndImage.image).toLowerCase(),
            productColor: (colorAndImage === null || colorAndImage === void 0 ? void 0 : colorAndImage.color) && colorAndImage.color.trim() !== "" && colorAndImage.color !== "null" ? "".concat(colorAndImage.color).toLowerCase() : "n/a"
        };
    }
    pushListDetailsAddToCartAdobeDataLayer(sanitizeForDataLayer({
        eventInfo,
        productsCount,
        name,
        items,
        productInfo: productInfoNew
    }));
};
const pushListDetailsAddToCartAdobeDataLayer = (data)=>{
    var ref;
    const { name ="" , eventInfo ={} , productsCount =0 , items =[] , productInfo =false  } = data;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    page.category.pageType = (ref = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAIL */ .Wo, ":").concat(productsCount)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    page.item = items;
    window.adobeDataLayer.push(sanitizeForDataLayer({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    }));
};
const dataLayerEventDetailsPageProductInfo = function(records, quantityObject) {
    let listItemsPrice = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, persona = arguments.length > 3 ? arguments[3] : void 0;
    return records.map((product)=>{
        const colorAndImage = {
            color: "",
            image: ""
        };
        if (product["Color.".concat(persona, ".Details_ss")]) {
            var ref;
            const productInfoRec = product === null || product === void 0 ? void 0 : (ref = product["Color.".concat(persona, ".Details_ss")]) === null || ref === void 0 ? void 0 : ref.filter((rec)=>{
                return product["masterSKU_s"] === rec.split("|")[0];
            });
            if (productInfoRec.length) {
                const values = productInfoRec[0].split("|");
                colorAndImage.color = values[1];
                colorAndImage.image = values[5];
            }
        }
        var ref1, ref2, ref3, ref4, ref5;
        return {
            category: (ref1 = product["Product_Category"]) !== null && ref1 !== void 0 ? ref1 : "",
            description: (ref2 = product["ProductDescriptionProductShort_s"]) !== null && ref2 !== void 0 ? ref2 : "",
            productID: (ref3 = product["ctId_s"]) !== null && ref3 !== void 0 ? ref3 : "",
            productName: (ref4 = product["productName_s"]) !== null && ref4 !== void 0 ? ref4 : "",
            quantity: (ref5 = quantityObject[product["masterSKU_s"]]) !== null && ref5 !== void 0 ? ref5 : "",
            productSalePrice: "".concat((listItemsPrice === null || listItemsPrice === void 0 ? void 0 : listItemsPrice["".concat(product["masterSKU_s"], "-discount")]) || listItemsPrice[product["masterSKU_s"]] || product["priceList.".concat(persona, ".finalPrice_d")] || ""),
            productSku: product["masterSKU_s"] ? product["masterSKU_s"] : "n/a",
            defaultImageName: colorAndImage === null || colorAndImage === void 0 ? void 0 : colorAndImage.image,
            productColor: colorAndImage === null || colorAndImage === void 0 ? void 0 : colorAndImage.color
        };
    });
};
const dataLayerListDetailPageShareListEvents = (data)=>{
    const { name ="" , actionType ="" , productsCount =0 , records =[] , quantityObject ={} , eventStatus ="" , eventMsg ="" , listItemsPrice ={} , persona , listTotalPrice =""  } = data;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAILS */ .wU, ":").concat(actionType),
        eventMsg: eventMsg || "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAILS */ .wU, ":").concat(actionType),
        eventStatus: eventStatus || "n/a",
        eventType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .CLICK */ .ot),
        internalLinkName: "".concat(actionType),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAILS */ .wU),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAILS */ .wU, ":").concat(actionType, ":").concat(name),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .SELECTED_LISTS */ .LU, ":").concat(name, ":").concat(listTotalPrice)
    };
    const productInfo = dataLayerEventDetailsPageProductInfo(records, quantityObject, listItemsPrice, persona);
    pushListDetailsAdobeDataLayer({
        eventInfo,
        productsCount,
        productInfo,
        name,
        listDetailsShareList: true
    });
};
const dataLayerListDetailPageEvents = (data)=>{
    const { name ="" , actionType ="" , productsCount =0 , records =[] , quantityObject ={} , productName ="" , eventStatus ="" , eventMsg ="" , eventType ="" , listItemsPrice ={} , persona  } = data;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(actionType),
        eventMsg: eventMsg || "n/a",
        eventName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(actionType),
        eventStatus: eventStatus || "n/a",
        eventType: eventType !== null && eventType !== void 0 ? eventType : "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .NAVIGATION */ .k2),
        internalLinkName: actionType === "product navigation" ? "".concat(productName) : "".concat(actionType),
        internalLinkPosition: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4),
        internalLinkType: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4)
    };
    const productInfo = dataLayerEventDetailsPageProductInfo(records, quantityObject, listItemsPrice, persona);
    pushListDetailsAdobeDataLayer({
        eventInfo,
        productsCount,
        productInfo,
        name
    });
};
const dataLayerEventDetailsPageShow = (data)=>{
    var ref, ref1, ref2, ref3, ref4;
    const { name ="" , listInfo ={} , quantityObject ={} , records =[] , listItemsPrice ={} , persona  } = data;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const productInfo = dataLayerEventDetailsPageProductInfo(records, quantityObject, listItemsPrice, persona);
    page.category["pageType"] = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":detail");
    page.category["primaryCategory"] = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX);
    page.category["subCategory1"] = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4);
    page.category["subCategory2"] = (ref = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    page.category["subCategoryID"] = (ref1 = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    page.category["subCategoryName"] = (ref2 = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(name)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase();
    page.pageInfo["pageName"] = (ref3 = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_LISTS */ .E4, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .LIST_DETAIL */ .Wo, ":").concat(name)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase();
    page.pageInfo["previousPage"] = "".concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .KOHLER */ .fG, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT */ .RX, ":").concat(_components_MyFavorites_v1_MyList_constant__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_SETTINGS */ .QL);
    page.pageInfo["title"] = (ref4 = "My Lists | ".concat(name, " | KOHLER")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase();
    page.listInfo = {
        ...listInfo
    };
    if (page.pageName && page.pageUrl) {
        delete page.pageName;
        delete page.pageUrl;
    }
    setTimeout(()=>{
        window.adobeDataLayer.splice(1, 1);
        window.adobeDataLayer.push({
            event: "cmp:show",
            productInfo: productInfo,
            page
        });
    }, 2500);
};


/***/ }),

/***/ 8541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ MY_LISTS; },
/* harmony export */   "GA": function() { return /* binding */ SHARE_LIST; },
/* harmony export */   "LU": function() { return /* binding */ SELECTED_LISTS; },
/* harmony export */   "N$": function() { return /* binding */ NEWEST_TO_OLDEST; },
/* harmony export */   "O1": function() { return /* binding */ WISHLIST_SAVE; },
/* harmony export */   "Q0": function() { return /* binding */ ADD_ALL_T0_CART; },
/* harmony export */   "QL": function() { return /* binding */ ACCOUNT_SETTINGS; },
/* harmony export */   "RX": function() { return /* binding */ MY_ACCOUNT; },
/* harmony export */   "SE": function() { return /* binding */ OLDEST_TO_NEWEST; },
/* harmony export */   "Wo": function() { return /* binding */ LIST_DETAIL; },
/* harmony export */   "dZ": function() { return /* binding */ ADD_T0_CART; },
/* harmony export */   "fG": function() { return /* binding */ KOHLER; },
/* harmony export */   "k2": function() { return /* binding */ NAVIGATION; },
/* harmony export */   "ot": function() { return /* binding */ CLICK; },
/* harmony export */   "sY": function() { return /* binding */ LISTS; },
/* harmony export */   "wU": function() { return /* binding */ LIST_DETAILS; }
/* harmony export */ });
const MY_ACCOUNT = "my account";
const NAVIGATION = "navigation";
const WISHLIST_SAVE = "wishlist save";
const NEWEST_TO_OLDEST = "newest to oldest";
const OLDEST_TO_NEWEST = "oldest to newest";
const LISTS = "lists";
const MY_LISTS = "my lists";
const KOHLER = "kohler";
const ACCOUNT_SETTINGS = "account settings";
const SHARE_LIST = "share list";
const ADD_T0_CART = "add to cart";
const ADD_ALL_T0_CART = "add all to cart";
const LIST_DETAIL = "detail";
const CLICK = "click";
const LIST_DETAILS = "lists details";
const SELECTED_LISTS = "selected lists";


/***/ }),

/***/ 61171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ listItemQuantityChangeTypeAndValueCal; },
/* harmony export */   "Db": function() { return /* binding */ getLineItemsProductImage; },
/* harmony export */   "EC": function() { return /* binding */ getColors; },
/* harmony export */   "N6": function() { return /* binding */ createSharedListUrl; },
/* harmony export */   "eb": function() { return /* binding */ getListTotalPrice; },
/* harmony export */   "ef": function() { return /* binding */ checkDiscontinuedStatus; },
/* harmony export */   "mt": function() { return /* binding */ getProductPrice; }
/* harmony export */ });
/* unused harmony export getFormattedDate */
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const getProductPrice = (product, productQtyObj, listItemsPrice)=>{
    const quantity = productQtyObj[product["masterSKU_s"]] || 1;
    const price = listItemsPrice[product["masterSKU_s"]] || 0;
    return price * quantity;
};
const getListTotalPrice = (productData, productQtyObj, listItemsPrice)=>{
    let totalPrice = 0;
    productData === null || productData === void 0 ? void 0 : productData.map((product)=>{
        var ref;
        const price = (ref = listItemsPrice[product["masterSKU_s"]]) !== null && ref !== void 0 ? ref : 0;
        const quantity = productQtyObj[product["masterSKU_s"]] || 1;
        totalPrice += price * quantity;
    });
    return totalPrice;
};
const getColors = function(product) {
    let allVariantColors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    const colors = product === null || product === void 0 ? void 0 : (ref = product["Color.SKU.Details_ss"]) === null || ref === void 0 ? void 0 : ref.map((item)=>{
        const [name, swatch, sku, isStock, isDiscontinued, customerFacingSKU] = item.split("|");
        return {
            name,
            swatch,
            sku,
            isStock,
            isDiscontinued,
            customerFacingSKU
        };
    });
    return allVariantColors ? colors : colors === null || colors === void 0 ? void 0 : colors.filter((color)=>product["masterSKU_s"] === color.sku);
};
const getFormattedDate = (currentList)=>{
    const dateObj = new Date(currentList === null || currentList === void 0 ? void 0 : currentList.createdAt);
    const month = dateObj === null || dateObj === void 0 ? void 0 : dateObj.toLocaleString("default", {
        month: "long"
    });
    const day = dateObj.getDate();
    const year = dateObj === null || dateObj === void 0 ? void 0 : dateObj.getFullYear();
    // Format the date as "Month Day, Year"
    const formattedDate = "".concat(month, " ").concat(day, ", ").concat(year);
    return formattedDate !== null && formattedDate !== void 0 ? formattedDate : "";
};
const getLineItemsProductImage = (data, sku)=>{
    let imagestmp = [];
    const productVariantImages = (data === null || data === void 0 ? void 0 : data["productImages.labelWithUrl_ss"]) ? data === null || data === void 0 ? void 0 : data["productImages.labelWithUrl_ss"] : [];
    let setDefaultProductImage = "";
    if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
        productVariantImages.find((img)=>{
            const imgDetails = img.split("|");
            if (sku === imgDetails[0]) {
                return setDefaultProductImage = imgDetails[1];
            }
        });
        setDefaultProductImage ? imagestmp.push(setDefaultProductImage) : imagestmp.push("MissingImage");
    } else {
        imagestmp = [
            "MissingImage"
        ];
    }
    return imagestmp;
};
const listItemQuantityChangeTypeAndValueCal = (qty, product, productQtyObj)=>{
    const currentQuantity = productQtyObj[product["masterSKU_s"]];
    if (currentQuantity > qty) {
        return {
            updatedQuantity: currentQuantity - qty,
            actionType: "subtract"
        };
    } else if (currentQuantity < qty) {
        return {
            updatedQuantity: qty - currentQuantity,
            actionType: "add"
        };
    } else {
        return {
            updatedQuantity: "",
            actionType: ""
        };
    }
};
const checkDiscontinuedStatus = (product)=>{
    const availableSkus = [];
    const discontinuedSkus = [];
    const colorDetails = getColors(product, true);
    colorDetails === null || colorDetails === void 0 ? void 0 : colorDetails.forEach((color)=>{
        if (color.isDiscontinued === "false") {
            availableSkus.push(color.sku);
        } else {
            discontinuedSkus.push(color.sku);
        }
    });
    return {
        availableSkus,
        discontinuedSkus
    };
};
const createSharedListUrl = (list, language, listName)=>{
    let skus = "";
    if (typeof list === "string") {
        skus = list;
    } else {
        var ref;
        skus = list === null || list === void 0 ? void 0 : (ref = list.lineItems) === null || ref === void 0 ? void 0 : ref.map((item)=>{
            var ref;
            return item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku;
        }).join(",");
    }
    const baseUrl =  true ? window.location.origin : 0;
    const toBase64 = (str)=>{
        if (!str) return "";
        if (true) {
            try {
                // handle unicode safely
                return btoa(unescape(encodeURIComponent(str)));
            } catch (e) {
                return btoa(str);
            }
        }
        if (typeof Buffer !== "undefined") {
            return Buffer.from(str, "utf-8").toString("base64");
        }
        return "";
    };
    const encodedSkus = toBase64(skus);
    const encodedListName = toBase64(listName);
    const url = "".concat(baseUrl, "/").concat(language, "/share-list?products=").concat(encodeURIComponent(encodedSkus), "&ListName=").concat(encodeURIComponent(encodedListName));
    return url;
};


/***/ }),

/***/ 57493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        addToCart: t("kf.myList.details.page.addToCart"),
        addItemsToCart: t("kf.myList.details.page.addItemsToCart"),
        moreOptions: t("kf.myList.details.page.moreOptions"),
        close: t("kf.myList.details.page.close"),
        myListPageTitle: t("kf.mylist.page.title"),
        createdDate: t("kf.myList.page.created"),
        createList: t("kf.saveToList.create.header"),
        tablTitle: t("kf.account.label.lists"),
        tablTitleMedia: t("kf.account.label.media"),
        listPageEmptyText: t("kf.myList.page.emptyTxt"),
        bestSellers: t("kf.myList.page.bestSellers"),
        sortBy: t("kf.favorite.label.sort"),
        edit: t("kf.account.label.edit"),
        deleteList: t("kf.myList.page.deletList"),
        moveItems: t("kf.myList.page.details.moveItems"),
        deleteItems: t("kf.myList.page.details.deleteItems"),
        itemPrice: t("kf.list.table.itemPrice"),
        quantity: t("kf.list.table.cartQuantity"),
        total: t("kf.list.table.total"),
        item: t("kf.list.table.item"),
        items: t("kf.list.table.items"),
        featured: t("kf.plp.label.featured"),
        listTotal: t("kf.myList.page.details.listTotal"),
        browseMoreProducts: t("kf.myList.page.details.browseMoreProducts"),
        selectAll: t("kf.list.button.selectAll"),
        created: t("kf.myList.page.details.create.label"),
        backToTop: t("kf.plp.label.backToTop"),
        editList: t("kf.myList.page.details.editList"),
        viewList: t("kf.findstore.label.viewList"),
        shoupOurBestSeller: t("kf.myList.page.ourBestSellers"),
        shoupOurBestSellerListBtn: t("kf.myList.page.ourBestSellers.listPage"),
        lessStock: t("kf.list.details.lessStock"),
        outOfStock: t("kf.list.details.outOfStock"),
        quantityModelHeader: t("kf.list.details.quantity.header"),
        quantityModelSubHeader: t("kf.list.details.quantity.subHeader"),
        addAvailableItemsToCart: t("kf.list.details.quantity.addAllToCart"),
        loadMore: t("kf.myList.page.details.loadMore"),
        availColorCTA: t("kf.myList.details.page.availColorCTA"),
        discontinued: t("kf.myList.details.page.discontinued"),
        colorAndFinish: t("kf.myList.details.page.colorAndFinish"),
        title: t("kf.pdp.label.title"),
        percentOff: t("kf.cart.label.off"),
        cadRequiredProductTitle: t("kf.pdp.label.cadRequiredProductTitle"),
        requiredProductTitle: t("kf.pdp.label.requiredProductTitle"),
        cadRequiredProductDescription: t("kf.pdp.label.cadRequiredProductDescription"),
        requiredProductDescription: t("kf.pdp.label.requiredProductDescription"),
        productText: t("kf.pdp.label.productText"),
        includeTextCTA: t("kf.myList.details.page.addToCart"),
        colorOrFinish: t("kf.cart.label.colorFinish"),
        outOfStockErr: t("kf.pdp.label.reqItem.err.outOfStockErrMsg"),
        backInStock: t("kf.pdp.label.notifyMailCTA"),
        requiredItemsToInstall: t("kf.list.details.items.requiredToInstall"),
        requiredItemsToInstallToolTip: t("kf.list.details.requiredItemsToInstall"),
        shareList: t("kf.myList.details.page.shareList"),
        share: t("kf.myList.details.page.share"),
        Remove: t("kf.myList.details.page.Remove")
    };
};


/***/ }),

/***/ 17169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _i18n_usePdpi18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58886);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78145);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13678);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55760);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20558);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88751);













const PartsViewer = (param)=>{
    let { page ="" , i18n ={} , productId ="" , partId ="" , analyticsCustomData =null , onClose , showModal =false  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [svgViewerPath, setSvgViewerPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [currencySign, setCurrencySign] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [salesChannelConfig, setSalesChannelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_9__/* .getConfig */ .i)().then(async (config)=>{
            var ref;
            const svgViewerPath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "general.svgViewerPath", ""));
            var ref1;
            setSalesChannelConfig((ref1 = config === null || config === void 0 ? void 0 : (ref = config.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {});
            const currencySign = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "internationalization.currencySign", "");
            setCurrencySign(currencySign);
            setSvgViewerPath(svgViewerPath);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showModal) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .preventBodyScroll */ .MVu)(true);
        }
    }, [
        showModal
    ]);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getUserPersona */ .shu)();
    const [showShare, setShowShare] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getPDPUrlForViewer = (category, slug)=>{
        const pdpdUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getPDPUrlWithConfig */ .Upy)(category, slug, plpServletPath, general);
        return pdpdUrl;
    };
    const addToCartTrigger = async (data)=>{
        const actions = [];
        data.forEach((product)=>{
            var ref;
            const fields = {
                salesChannel: (ref = salesChannelConfig[product === null || product === void 0 ? void 0 : product.brand]) !== null && ref !== void 0 ? ref : "KOUS"
            };
            actions.push({
                action: product.isBundle ? "addbundle" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: {
                    type: {
                        key: "lineItemShipping"
                    },
                    fields: fields
                }
            });
        });
        const reqData = {};
        reqData["actions"] = actions;
        const cartObj = dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .searchPlp */ .tK)(reqData)).unwrap().then((res)=>{
            const respVal = {};
            respVal.status = 200;
            return respVal;
        }).catch((err)=>{
            const respVal = {};
            respVal.status = 500;
            return respVal;
        }) || {};
        return cartObj;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (currencySign !== "" && persona && plpServletPath && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(general)) {
            var ref;
            window.partViewer = {
                atc: addToCartTrigger,
                getPDPUrl: getPDPUrlForViewer,
                persona,
                currencySign,
                setShowShare
            };
            (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            return ()=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .preventBodyScroll */ .MVu)(false);
        }
    }, [
        currencySign,
        persona,
        general
    ]);
    const filename = (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getExtention */ .fN)(partId) ? partId : partId + ".svg";
    const closeModal = ()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .preventBodyScroll */ .MVu)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    const i18nTexts = (0,_i18n_usePdpi18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, {}, "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_7__["default"], {
        showModal: showModal,
        onModalClose: closeModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        className: "part-diagram-custom",
        modalTitle: i18nTexts === null || i18nTexts === void 0 ? void 0 : i18nTexts.serviceParts,
        children: [
            svgViewerPath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                id: "svg-viewer-iframe",
                ref: iframeRef,
                allowFullScreen: true,
                scrolling: "auto",
                src: "".concat(svgViewerPath, "?productId=").concat(productId, "&filename=").concat(filename, "&diagram=0&origin=").concat(window.location.href)
            }),
            showShare && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartSocialShare, {
                showShare: showShare,
                setShowShare: setShowShare,
                iframeId: "svg-viewer-iframe",
                i18n: i18n,
                iframeRef: iframeRef.current
            })
        ]
    });
};
const PartSocialShare = (param)=>{
    let { showShare , setShowShare , iframeId , i18n , iframeRef  } = param;
    return /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        showModal: showShare,
        id: "social-share-iframe",
        onClose: ()=>setShowShare(false),
        iframeId: iframeId,
        iframeRef: iframeRef,
        disableInstagram: true,
        mailSubject: i18n.mailSubject,
        mailBody: i18n.mailBody
    }), iframeRef.contentDocument.getElementById("social-share-gbh"));
};
/* harmony default export */ __webpack_exports__["Z"] = (PartsViewer);


/***/ }),

/***/ 70159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_PartsViewer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addEventListener.js
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ var esm_addEventListener = (addEventListener);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeEventListener.js
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ var esm_removeEventListener = (removeEventListener);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js


/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */
function useCallbackRef() {
  return (0,react.useState)(null);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js


/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef_useCommittedRef(value) {
  const ref = (0,react.useRef)(value);
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
/* harmony default export */ var esm_useCommittedRef = (useCommittedRef_useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js


function useEventCallback_useEventCallback(fn) {
  const ref = esm_useCommittedRef(fn);
  return (0,react.useCallback)(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js

const toFnRef = ref => !ref || typeof ref === 'function' ? ref : value => {
  ref.current = value;
};
function mergeRefs(refA, refB) {
  const a = toFnRef(refA);
  const b = toFnRef(refB);
  return value => {
    if (a) a(value);
    if (b) b(value);
  };
}

/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */
function useMergedRefs(refA, refB) {
  return (0,react.useMemo)(() => mergeRefs(refA, refB), [refA, refB]);
}
/* harmony default export */ var esm_useMergedRefs = (useMergedRefs);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useUpdatedRef.js


/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */
function useUpdatedRef(value) {
  const valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js



/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */
function useWillUnmount(fn) {
  const onUnmount = useUpdatedRef(fn);
  (0,react.useEffect)(() => () => onUnmount.current(), []);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerWindow.js

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/getComputedStyle.js

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenate.js
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenateStyle.js
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isTransform.js
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/css.js




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ var css = (style);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/listen.js



function listen(node, eventName, handler, options) {
  esm_addEventListener(node, eventName, handler, options);
  return function () {
    esm_removeEventListener(node, eventName, handler, options);
  };
}

/* harmony default export */ var esm_listen = (listen);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/triggerEvent.js
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js




function parseDuration(node) {
  var str = css(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = esm_listen(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = esm_listen(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/activeElement.js

/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */

function activeElement(doc) {
  if (doc === void 0) {
    doc = ownerDocument();
  }

  // Support: IE 9 only
  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
  try {
    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>

    if (!active || !active.nodeName) return null;
    return active;
  } catch (e) {
    /* ie throws if no active element */
    return doc.body;
  }
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/contains.js
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMounted.js


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted() {
  const mounted = (0,react.useRef)(true);
  const isMounted = (0,react.useRef)(() => mounted.current);
  (0,react.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useUpdatedRef.js


/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */
function useUpdatedRef_useUpdatedRef(value) {
  const valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useWillUnmount.js



/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @deprecated Use `useMounted` and normal effects, this is not StrictMode safe
 * @category effects
 */
function useWillUnmount_useWillUnmount(fn) {
  const onUnmount = useUpdatedRef_useUpdatedRef(fn);
  (0,react.useEffect)(() => () => onUnmount.current(), []);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/usePrevious.js


/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */
function usePrevious(value) {
  const ref = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useCommittedRef.js


/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function esm_useCommittedRef_useCommittedRef(value) {
  const ref = (0,react.useRef)(value);
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
/* harmony default export */ var hooks_esm_useCommittedRef = (esm_useCommittedRef_useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useEventCallback.js


function esm_useEventCallback_useEventCallback(fn) {
  const ref = hooks_esm_useCommittedRef(fn);
  return (0,react.useCallback)(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/DataKey.js
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
  return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
  return `${PROPERTY_PREFIX}${property}`;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/getScrollbarWidth.js
/**
 * Get the width of the vertical window scrollbar if it's visible
 */
function getBodyScrollbarWidth(ownerDocument = document) {
  const window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/ModalManager.js



const OPEN_DATA_ATTRIBUTE = dataAttr('modal-open');

/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */
class ModalManager {
  constructor({
    ownerDocument,
    handleContainerOverflow = true,
    isRTL = false
  } = {}) {
    this.handleContainerOverflow = handleContainerOverflow;
    this.isRTL = isRTL;
    this.modals = [];
    this.ownerDocument = ownerDocument;
  }
  getScrollbarWidth() {
    return getBodyScrollbarWidth(this.ownerDocument);
  }
  getElement() {
    return (this.ownerDocument || document).body;
  }
  setModalAttributes(_modal) {
    // For overriding
  }
  removeModalAttributes(_modal) {
    // For overriding
  }
  setContainerStyle(containerState) {
    const style = {
      overflow: 'hidden'
    };

    // we are only interested in the actual `style` here
    // because we will override it
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const container = this.getElement();
    containerState.style = {
      overflow: container.style.overflow,
      [paddingProp]: container.style[paddingProp]
    };
    if (containerState.scrollBarWidth) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style[paddingProp] = `${parseInt(css(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
    }
    container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
    css(container, style);
  }
  reset() {
    [...this.modals].forEach(m => this.remove(m));
  }
  removeContainerStyle(containerState) {
    const container = this.getElement();
    container.removeAttribute(OPEN_DATA_ATTRIBUTE);
    Object.assign(container.style, containerState.style);
  }
  add(modal) {
    let modalIdx = this.modals.indexOf(modal);
    if (modalIdx !== -1) {
      return modalIdx;
    }
    modalIdx = this.modals.length;
    this.modals.push(modal);
    this.setModalAttributes(modal);
    if (modalIdx !== 0) {
      return modalIdx;
    }
    this.state = {
      scrollBarWidth: this.getScrollbarWidth(),
      style: {}
    };
    if (this.handleContainerOverflow) {
      this.setContainerStyle(this.state);
    }
    return modalIdx;
  }
  remove(modal) {
    const modalIdx = this.modals.indexOf(modal);
    if (modalIdx === -1) {
      return;
    }
    this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (!this.modals.length && this.handleContainerOverflow) {
      this.removeContainerStyle(this.state);
    }
    this.removeModalAttributes(modal);
  }
  isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  }
}
/* harmony default export */ var esm_ModalManager = (ModalManager);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useWindow.js


const Context = /*#__PURE__*/(0,react.createContext)(canUseDOM ? window : undefined);
const WindowProvider = Context.Provider;

/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */
function useWindow() {
  return (0,react.useContext)(Context);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useWaitForDOMRef.js




const resolveContainerRef = (ref, document) => {
  if (!canUseDOM) return null;
  if (ref == null) return (document || ownerDocument()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  const window = useWindow();
  const [resolvedRef, setRef] = (0,react.useState)(() => resolveContainerRef(ref, window == null ? void 0 : window.document));
  if (!resolvedRef) {
    const earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }
  (0,react.useEffect)(() => {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  (0,react.useEffect)(() => {
    const nextRef = resolveContainerRef(ref);
    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMergedRefs.js

const useMergedRefs_toFnRef = ref => !ref || typeof ref === 'function' ? ref : value => {
  ref.current = value;
};
function useMergedRefs_mergeRefs(refA, refB) {
  const a = useMergedRefs_toFnRef(refA);
  const b = useMergedRefs_toFnRef(refB);
  return value => {
    if (a) a(value);
    if (b) b(value);
  };
}

/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */
function useMergedRefs_useMergedRefs(refA, refB) {
  return (0,react.useMemo)(() => useMergedRefs_mergeRefs(refA, refB), [refA, refB]);
}
/* harmony default export */ var hooks_esm_useMergedRefs = (useMergedRefs_useMergedRefs);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useIsomorphicEffect.js

const isReactNative = typeof __webpack_require__.g !== 'undefined' &&
// @ts-ignore
__webpack_require__.g.navigator &&
// @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
/* harmony default export */ var useIsomorphicEffect = (isDOM || isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/utils.js

function isEscKey(e) {
  return e.code === 'Escape' || e.keyCode === 27;
}
function getReactVersion() {
  const parts = react.version.split('.');
  return {
    major: +parts[0],
    minor: +parts[1],
    patch: +parts[2]
  };
}
function getChildRef(element) {
  if (!element || typeof element === 'function') {
    return null;
  }
  const {
    major
  } = getReactVersion();
  const childRef = major >= 19 ? element.props.ref : element.ref;
  return childRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/NoopTransition.js




function NoopTransition({
  children,
  in: inProp,
  onExited,
  mountOnEnter,
  unmountOnExit
}) {
  const ref = (0,react.useRef)(null);
  const hasEnteredRef = (0,react.useRef)(inProp);
  const handleExited = esm_useEventCallback_useEventCallback(onExited);
  (0,react.useEffect)(() => {
    if (inProp) hasEnteredRef.current = true;else {
      handleExited(ref.current);
    }
  }, [inProp, handleExited]);
  const combinedRef = hooks_esm_useMergedRefs(ref, getChildRef(children));
  const child = /*#__PURE__*/(0,react.cloneElement)(children, {
    ref: combinedRef
  });
  if (inProp) return child;
  if (unmountOnExit) {
    return null;
  }
  if (!hasEnteredRef.current && mountOnEnter) {
    return null;
  }
  return child;
}
/* harmony default export */ var esm_NoopTransition = (NoopTransition);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useRTGTransitionProps.js
const _excluded = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "addEndListener", "children"];
function useRTGTransitionProps_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }



/**
 * Normalizes RTG transition callbacks with nodeRef to better support
 * strict mode.
 *
 * @param props Transition props.
 * @returns Normalized transition props.
 */
function useRTGTransitionProps(_ref) {
  let {
      onEnter,
      onEntering,
      onEntered,
      onExit,
      onExiting,
      onExited,
      addEndListener,
      children
    } = _ref,
    props = useRTGTransitionProps_objectWithoutPropertiesLoose(_ref, _excluded);
  const nodeRef = (0,react.useRef)(null);
  const mergedRef = hooks_esm_useMergedRefs(nodeRef, getChildRef(children));
  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const handleEnter = (0,react.useCallback)(normalize(onEnter), [onEnter]);
  const handleEntering = (0,react.useCallback)(normalize(onEntering), [onEntering]);
  const handleEntered = (0,react.useCallback)(normalize(onEntered), [onEntered]);
  const handleExit = (0,react.useCallback)(normalize(onExit), [onExit]);
  const handleExiting = (0,react.useCallback)(normalize(onExiting), [onExiting]);
  const handleExited = (0,react.useCallback)(normalize(onExited), [onExited]);
  const handleAddEndListener = (0,react.useCallback)(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return Object.assign({}, props, {
    nodeRef
  }, onEnter && {
    onEnter: handleEnter
  }, onEntering && {
    onEntering: handleEntering
  }, onEntered && {
    onEntered: handleEntered
  }, onExit && {
    onExit: handleExit
  }, onExiting && {
    onExiting: handleExiting
  }, onExited && {
    onExited: handleExited
  }, addEndListener && {
    addEndListener: handleAddEndListener
  }, {
    children: typeof children === 'function' ? (status, innerProps) =>
    // TODO: Types for RTG missing innerProps, so need to cast.
    children(status, Object.assign({}, innerProps, {
      ref: mergedRef
    })) : /*#__PURE__*/(0,react.cloneElement)(children, {
      ref: mergedRef
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/RTGTransition.js
const RTGTransition_excluded = ["component"];
function RTGTransition_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }



// Normalizes Transition callbacks when nodeRef is used.
const RTGTransition = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      component: Component
    } = _ref,
    props = RTGTransition_objectWithoutPropertiesLoose(_ref, RTGTransition_excluded);
  const transitionProps = useRTGTransitionProps(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({
    ref: ref
  }, transitionProps));
});
/* harmony default export */ var esm_RTGTransition = (RTGTransition);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/ImperativeTransition.js








function useTransition({
  in: inProp,
  onTransition
}) {
  const ref = (0,react.useRef)(null);
  const isInitialRef = (0,react.useRef)(true);
  const handleTransition = esm_useEventCallback_useEventCallback(onTransition);
  useIsomorphicEffect(() => {
    if (!ref.current) {
      return undefined;
    }
    let stale = false;
    handleTransition({
      in: inProp,
      element: ref.current,
      initial: isInitialRef.current,
      isStale: () => stale
    });
    return () => {
      stale = true;
    };
  }, [inProp, handleTransition]);
  useIsomorphicEffect(() => {
    isInitialRef.current = false;
    // this is for strict mode
    return () => {
      isInitialRef.current = true;
    };
  }, []);
  return ref;
}
/**
 * Adapts an imperative transition function to a subset of the RTG `<Transition>` component API.
 *
 * ImperativeTransition does not support mounting options or `appear` at the moment, meaning
 * that it always acts like: `mountOnEnter={true} unmountOnExit={true} appear={true}`
 */
function ImperativeTransition({
  children,
  in: inProp,
  onExited,
  onEntered,
  transition
}) {
  const [exited, setExited] = (0,react.useState)(!inProp);

  // TODO: I think this needs to be in an effect
  if (inProp && exited) {
    setExited(false);
  }
  const ref = useTransition({
    in: !!inProp,
    onTransition: options => {
      const onFinish = () => {
        if (options.isStale()) return;
        if (options.in) {
          onEntered == null ? void 0 : onEntered(options.element, options.initial);
        } else {
          setExited(true);
          onExited == null ? void 0 : onExited(options.element);
        }
      };
      Promise.resolve(transition(options)).then(onFinish, error => {
        if (!options.in) setExited(true);
        throw error;
      });
    }
  });
  const combinedRef = hooks_esm_useMergedRefs(ref, getChildRef(children));
  return exited && !inProp ? null : /*#__PURE__*/(0,react.cloneElement)(children, {
    ref: combinedRef
  });
}
function renderTransition(component, runTransition, props) {
  if (component) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_RTGTransition, Object.assign({}, props, {
      component: component
    }));
  }
  if (runTransition) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ImperativeTransition, Object.assign({}, props, {
      transition: runTransition
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_NoopTransition, Object.assign({}, props));
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Modal.js
const Modal_excluded = ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "runTransition", "backdropTransition", "runBackdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"];
function Modal_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */


















let manager;

/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/

function getManager(window) {
  if (!manager) manager = new esm_ModalManager({
    ownerDocument: window == null ? void 0 : window.document
  });
  return manager;
}
function useModalManager(provided) {
  const window = useWindow();
  const modalManager = provided || getManager(window);
  const modal = (0,react.useRef)({
    dialog: null,
    backdrop: null
  });
  return Object.assign(modal.current, {
    add: () => modalManager.add(modal.current),
    remove: () => modalManager.remove(modal.current),
    isTopModal: () => modalManager.isTopModal(modal.current),
    setDialogRef: (0,react.useCallback)(ref => {
      modal.current.dialog = ref;
    }, []),
    setBackdropRef: (0,react.useCallback)(ref => {
      modal.current.backdrop = ref;
    }, [])
  });
}
const Modal = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
      show = false,
      role = 'dialog',
      className,
      style,
      children,
      backdrop = true,
      keyboard = true,
      onBackdropClick,
      onEscapeKeyDown,
      transition,
      runTransition,
      backdropTransition,
      runBackdropTransition,
      autoFocus = true,
      enforceFocus = true,
      restoreFocus = true,
      restoreFocusOptions,
      renderDialog,
      renderBackdrop = props => /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, props)),
      manager: providedManager,
      container: containerRef,
      onShow,
      onHide = () => {},
      onExit,
      onExited,
      onExiting,
      onEnter,
      onEntering,
      onEntered
    } = _ref,
    rest = Modal_objectWithoutPropertiesLoose(_ref, Modal_excluded);
  const ownerWindow = useWindow();
  const container = useWaitForDOMRef(containerRef);
  const modal = useModalManager(providedManager);
  const isMounted = useMounted();
  const prevShow = usePrevious(show);
  const [exited, setExited] = (0,react.useState)(!show);
  const lastFocusRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, () => modal, [modal]);
  if (canUseDOM && !prevShow && show) {
    lastFocusRef.current = activeElement(ownerWindow == null ? void 0 : ownerWindow.document);
  }

  // TODO: I think this needs to be in an effect
  if (show && exited) {
    setExited(false);
  }
  const handleShow = esm_useEventCallback_useEventCallback(() => {
    modal.add();
    removeKeydownListenerRef.current = esm_listen(document, 'keydown', handleDocumentKeyDown);
    removeFocusListenerRef.current = esm_listen(document, 'focus',
    // the timeout is necessary b/c this will run before the new modal is mounted
    // and so steals focus from it
    () => setTimeout(handleEnforceFocus), true);
    if (onShow) {
      onShow();
    }

    // autofocus after onShow to not trigger a focus event for previous
    // modals before this one is shown.
    if (autoFocus) {
      var _modal$dialog$ownerDo, _modal$dialog;
      const currentActiveElement = activeElement((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
      if (modal.dialog && currentActiveElement && !contains(modal.dialog, currentActiveElement)) {
        lastFocusRef.current = currentActiveElement;
        modal.dialog.focus();
      }
    }
  });
  const handleHide = esm_useEventCallback_useEventCallback(() => {
    modal.remove();
    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();
    if (restoreFocus) {
      var _lastFocusRef$current;
      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
      lastFocusRef.current = null;
    }
  });

  // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120

  // Show logic when:
  //  - show is `true` _and_ `container` has resolved
  (0,react.useEffect)(() => {
    if (!show || !container) return;
    handleShow();
  }, [show, container, /* should never change: */handleShow]);

  // Hide cleanup logic when:
  //  - `exited` switches to true
  //  - component unmounts;
  (0,react.useEffect)(() => {
    if (!exited) return;
    handleHide();
  }, [exited, handleHide]);
  useWillUnmount_useWillUnmount(() => {
    handleHide();
  });

  // --------------------------------

  const handleEnforceFocus = esm_useEventCallback_useEventCallback(() => {
    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
      return;
    }
    const currentActiveElement = activeElement(ownerWindow == null ? void 0 : ownerWindow.document);
    if (modal.dialog && currentActiveElement && !contains(modal.dialog, currentActiveElement)) {
      modal.dialog.focus();
    }
  });
  const handleBackdropClick = esm_useEventCallback_useEventCallback(e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    onBackdropClick == null ? void 0 : onBackdropClick(e);
    if (backdrop === true) {
      onHide();
    }
  });
  const handleDocumentKeyDown = esm_useEventCallback_useEventCallback(e => {
    if (keyboard && isEscKey(e) && modal.isTopModal()) {
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);
      if (!e.defaultPrevented) {
        onHide();
      }
    }
  });
  const removeFocusListenerRef = (0,react.useRef)();
  const removeKeydownListenerRef = (0,react.useRef)();
  const handleHidden = (...args) => {
    setExited(true);
    onExited == null ? void 0 : onExited(...args);
  };
  if (!container) {
    return null;
  }
  const dialogProps = Object.assign({
    role,
    ref: modal.setDialogRef,
    // apparently only works on the dialog role element
    'aria-modal': role === 'dialog' ? true : undefined
  }, rest, {
    style,
    className,
    tabIndex: -1
  });
  let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, dialogProps, {
    children: /*#__PURE__*/react.cloneElement(children, {
      role: 'document'
    })
  }));
  dialog = renderTransition(transition, runTransition, {
    unmountOnExit: true,
    mountOnEnter: true,
    appear: true,
    in: !!show,
    onExit,
    onExiting,
    onExited: handleHidden,
    onEnter,
    onEntering,
    onEntered,
    children: dialog
  });
  let backdropElement = null;
  if (backdrop) {
    backdropElement = renderBackdrop({
      ref: modal.setBackdropRef,
      onClick: handleBackdropClick
    });
    backdropElement = renderTransition(backdropTransition, runBackdropTransition, {
      in: !!show,
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      children: backdropElement
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [backdropElement, dialog]
    }), container)
  });
});
Modal.displayName = 'Modal';
/* harmony default export */ var esm_Modal = (Object.assign(Modal, {
  Manager: esm_ModalManager
}));
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/querySelectorAll.js
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BootstrapModalManager.js





const Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends esm_ModalManager {
  adjustAndStore(prop, element, adjust) {
    const actual = element.style[prop];
    // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
    element.dataset[prop] = actual;
    css(element, {
      [prop]: `${parseFloat(css(element, prop)) + adjust}px`
    });
  }
  restore(prop, element) {
    const value = element.dataset[prop];
    if (value !== undefined) {
      delete element.dataset[prop];
      css(element, {
        [prop]: value
      });
    }
  }
  setContainerStyle(containerState) {
    super.setContainerStyle(containerState);
    const container = this.getElement();
    addClass(container, 'modal-open');
    if (!containerState.scrollBarWidth) return;
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    qsa(container, Selector.FIXED_CONTENT).forEach(el => this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
    qsa(container, Selector.STICKY_CONTENT).forEach(el => this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
    qsa(container, Selector.NAVBAR_TOGGLER).forEach(el => this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
  }
  removeContainerStyle(containerState) {
    super.removeContainerStyle(containerState);
    const container = this.getElement();
    removeClass(container, 'modal-open');
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    qsa(container, Selector.FIXED_CONTENT).forEach(el => this.restore(paddingProp, el));
    qsa(container, Selector.STICKY_CONTENT).forEach(el => this.restore(marginProp, el));
    qsa(container, Selector.NAVBAR_TOGGLER).forEach(el => this.restore(marginProp, el));
  }
}
let sharedManager;
function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}
/* harmony default export */ var esm_BootstrapModalManager = ((/* unused pure expression or super */ null && (BootstrapModalManager)));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function inheritsLoose_inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,setPrototypeOf/* default */.Z)(t, o);
}

;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  inheritsLoose_inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js


function transitionEndListener_parseDuration(node, property) {
  const str = css(node, property) || '';
  const mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
  const duration = transitionEndListener_parseDuration(element, 'transitionDuration');
  const delay = transitionEndListener_parseDuration(element, 'transitionDelay');
  const remove = transitionEnd(element, e => {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/safeFindDOMNode.js

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return react_dom.findDOMNode(componentOrElement);
  }
  return componentOrElement != null ? componentOrElement : null;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
"use client";






// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  addEndListener,
  children,
  childRef,
  ...props
}, ref) => {
  const nodeRef = (0,react.useRef)(null);
  const mergedRef = esm_useMergedRefs(nodeRef, childRef);
  const attachRef = r => {
    mergedRef(safeFindDOMNode(r));
  };
  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };
  const handleEnter = (0,react.useCallback)(normalize(onEnter), [onEnter]);
  const handleEntering = (0,react.useCallback)(normalize(onEntering), [onEntering]);
  const handleEntered = (0,react.useCallback)(normalize(onEntered), [onEntered]);
  const handleExit = (0,react.useCallback)(normalize(onExit), [onExit]);
  const handleExiting = (0,react.useCallback)(normalize(onExiting), [onExiting]);
  const handleExited = (0,react.useCallback)(normalize(onExited), [onExited]);
  const handleAddEndListener = (0,react.useCallback)(normalize(addEndListener), [addEndListener]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Transition, {
    ref: ref,
    ...props,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    children: typeof children === 'function' ? (status, innerProps) =>
    // TODO: Types for RTG missing innerProps, so need to cast.
    children(status, {
      ...innerProps,
      ref: attachRef
    }) : /*#__PURE__*/react.cloneElement(children, {
      ref: attachRef
    })
  });
});
TransitionWrapper.displayName = 'TransitionWrapper';
/* harmony default export */ var esm_TransitionWrapper = (TransitionWrapper);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Fade.js









const fadeStyles = {
  [ENTERING]: 'show',
  [ENTERED]: 'show'
};
const Fade = /*#__PURE__*/react.forwardRef(({
  className,
  children,
  transitionClasses = {},
  onEnter,
  ...rest
}, ref) => {
  const props = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    ...rest
  };
  const handleEnter = (0,react.useCallback)((node, isAppearing) => {
    triggerBrowserReflow(node);
    onEnter == null || onEnter(node, isAppearing);
  }, [onEnter]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TransitionWrapper, {
    ref: ref,
    addEndListener: transitionEndListener,
    ...props,
    onEnter: handleEnter,
    childRef: getChildRef(children),
    children: (status, innerProps) => /*#__PURE__*/react.cloneElement(children, {
      ...innerProps,
      className: classnames_default()('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
    })
  });
});
Fade.displayName = 'Fade';
/* harmony default export */ var esm_Fade = (Fade);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
"use client";




const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/react.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const {
  Consumer,
  Provider
} = ThemeContext;
function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  minBreakpoint = DEFAULT_MIN_BREAKPOINT,
  dir,
  children
}) {
  const contextValue = useMemo(() => ({
    prefixes: {
      ...prefixes
    },
    breakpoints,
    minBreakpoint,
    dir
  }), [prefixes, breakpoints, minBreakpoint, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = (0,react.useContext)(ThemeContext);
  return breakpoints;
}
function useBootstrapMinBreakpoint() {
  const {
    minBreakpoint
  } = (0,react.useContext)(ThemeContext);
  return minBreakpoint;
}
function useIsRTL() {
  const {
    dir
  } = (0,react.useContext)(ThemeContext);
  return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent;
  // If it's a functional component make sure we don't break it with a ref
  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/React.forwardRef(({
    ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, {
      ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}

/* harmony default export */ var esm_ThemeProvider = ((/* unused pure expression or super */ null && (ThemeProvider)));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalBody.js
"use client";





const ModalBody = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-body');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
ModalBody.displayName = 'ModalBody';
/* harmony default export */ var esm_ModalBody = (ModalBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalContext.js
"use client";


const ModalContext = /*#__PURE__*/react.createContext({
  onHide() {}
});
/* harmony default export */ var esm_ModalContext = (ModalContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalDialog.js
"use client";





const ModalDialog = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  contentClassName,
  centered,
  size,
  fullscreen,
  children,
  scrollable,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const dialogClass = `${bsPrefix}-dialog`;
  const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ...props,
    ref: ref,
    className: classnames_default()(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(`${bsPrefix}-content`, contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ var esm_ModalDialog = (ModalDialog);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalFooter.js
"use client";





const ModalFooter = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-footer');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
ModalFooter.displayName = 'ModalFooter';
/* harmony default export */ var esm_ModalFooter = (ModalFooter);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js




const propTypes = {
  /** An accessible label indicating the relevant information about the Close Button. */
  'aria-label': (prop_types_default()).string,
  /** A callback fired after the Close Button is clicked. */
  onClick: (prop_types_default()).func,
  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: prop_types_default().oneOf(['white'])
};
const CloseButton = /*#__PURE__*/react.forwardRef(({
  className,
  variant,
  'aria-label': ariaLabel = 'Close',
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
  ref: ref,
  type: "button",
  className: classnames_default()('btn-close', variant && `btn-close-${variant}`, className),
  "aria-label": ariaLabel,
  ...props
}));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
/* harmony default export */ var esm_CloseButton = (CloseButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AbstractModalHeader.js
"use client";








const AbstractModalHeader = /*#__PURE__*/react.forwardRef(({
  closeLabel = 'Close',
  closeVariant,
  closeButton = false,
  onHide,
  children,
  ...props
}, ref) => {
  const context = (0,react.useContext)(esm_ModalContext);
  const handleClick = useEventCallback_useEventCallback(() => {
    context == null || context.onHide();
    onHide == null || onHide();
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    ...props,
    children: [children, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  });
});
AbstractModalHeader.displayName = 'AbstractModalHeader';
/* harmony default export */ var esm_AbstractModalHeader = (AbstractModalHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalHeader.js
"use client";






const ModalHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  closeLabel = 'Close',
  closeButton = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AbstractModalHeader, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    closeLabel: closeLabel,
    closeButton: closeButton
  });
});
ModalHeader.displayName = 'ModalHeader';
/* harmony default export */ var esm_ModalHeader = (ModalHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js



/* harmony default export */ var divWithClassName = (className =>
/*#__PURE__*/
// eslint-disable-next-line react/display-name
react.forwardRef((p, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
  ...p,
  ref: ref,
  className: classnames_default()(p.className, className)
})));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalTitle.js
"use client";






const DivStyledAsH4 = divWithClassName('h4');
const ModalTitle = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH4,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-title');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
ModalTitle.displayName = 'ModalTitle';
/* harmony default export */ var esm_ModalTitle = (ModalTitle);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Modal.js
"use client";

























function DialogTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Fade, {
    ...props,
    timeout: null
  });
}
function BackdropTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Fade, {
    ...props,
    timeout: null
  });
}
const Modal_Modal = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  style,
  dialogClassName,
  contentClassName,
  children,
  dialogAs: Dialog = esm_ModalDialog,
  'data-bs-theme': dataBsTheme,
  'aria-labelledby': ariaLabelledby,
  'aria-describedby': ariaDescribedby,
  'aria-label': ariaLabel,
  /* BaseModal props */

  show = false,
  animation = true,
  backdrop = true,
  keyboard = true,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus = true,
  enforceFocus = true,
  restoreFocus = true,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const [modalStyle, setStyle] = (0,react.useState)({});
  const [animateStaticModal, setAnimateStaticModal] = (0,react.useState)(false);
  const waitingForMouseUpRef = (0,react.useRef)(false);
  const ignoreBackdropClickRef = (0,react.useRef)(false);
  const removeStaticModalAnimationRef = (0,react.useRef)(null);
  const [modal, setModalRef] = useCallbackRef();
  const mergedRef = esm_useMergedRefs(ref, setModalRef);
  const handleHide = useEventCallback_useEventCallback(onHide);
  const isRTL = useIsRTL();
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const modalContext = (0,react.useMemo)(() => ({
    onHide: handleHide
  }), [handleHide]);
  function getModalManager() {
    if (propsManager) return propsManager;
    return getSharedManager({
      isRTL
    });
  }
  function updateDialogStyle(node) {
    if (!canUseDOM) return;
    const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
    const modalIsOverflowing = node.scrollHeight > ownerDocument(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }
  const handleWindowResize = useEventCallback_useEventCallback(() => {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  useWillUnmount(() => {
    esm_removeEventListener(window, 'resize', handleWindowResize);
    removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
  });

  // We prevent the modal from closing during a drag by detecting where the
  // click originates from. If it starts in the modal and then ends outside
  // don't close.
  const handleDialogMouseDown = () => {
    waitingForMouseUpRef.current = true;
  };
  const handleMouseUp = e => {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }
    waitingForMouseUpRef.current = false;
  };
  const handleStaticModalAnimation = () => {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = transitionEnd(modal.dialog, () => {
      setAnimateStaticModal(false);
    });
  };
  const handleStaticBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    handleStaticModalAnimation();
  };
  const handleClick = e => {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }
    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }
    onHide == null || onHide();
  };
  const handleEscapeKeyDown = e => {
    if (keyboard) {
      onEscapeKeyDown == null || onEscapeKeyDown(e);
    } else {
      // Call preventDefault to stop modal from closing in @restart/ui.
      e.preventDefault();
      if (backdrop === 'static') {
        // Play static modal animation.
        handleStaticModalAnimation();
      }
    }
  };
  const handleEnter = (node, isAppearing) => {
    if (node) {
      updateDialogStyle(node);
    }
    onEnter == null || onEnter(node, isAppearing);
  };
  const handleExit = node => {
    removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    onExit == null || onExit(node);
  };
  const handleEntering = (node, isAppearing) => {
    onEntering == null || onEntering(node, isAppearing);

    // FIXME: This should work even when animation is disabled.
    esm_addEventListener(window, 'resize', handleWindowResize);
  };
  const handleExited = node => {
    if (node) node.style.display = ''; // RHL removes it sometimes
    onExited == null || onExited(node);

    // FIXME: This should work even when animation is disabled.
    esm_removeEventListener(window, 'resize', handleWindowResize);
  };
  const renderBackdrop = (0,react.useCallback)(backdropProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ...backdropProps,
    className: classnames_default()(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
  }), [animation, backdropClassName, bsPrefix]);
  const baseModalStyle = {
    ...style,
    ...modalStyle
  };

  // If `display` is not set to block, autoFocus inside the modal fails
  // https://github.com/react-bootstrap/react-bootstrap/issues/5102
  baseModalStyle.display = 'block';
  const renderDialog = dialogProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "dialog",
    ...dialogProps,
    style: baseModalStyle,
    className: classnames_default()(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
    onClick: backdrop ? handleClick : undefined,
    onMouseUp: handleMouseUp,
    "data-bs-theme": dataBsTheme,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog, {
      ...props,
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName,
      children: children
    })
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ModalContext.Provider, {
    value: modalContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Modal, {
      show: show,
      ref: mergedRef,
      backdrop: backdrop,
      container: container,
      keyboard: true // Always set true - see handleEscapeKeyDown
      ,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: handleEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: onEntered,
      onExit: handleExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: animation ? DialogTransition : undefined,
      backdropTransition: animation ? BackdropTransition : undefined,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Modal_Modal.displayName = 'Modal';
/* harmony default export */ var react_bootstrap_esm_Modal = (Object.assign(Modal_Modal, {
  Body: esm_ModalBody,
  Header: esm_ModalHeader,
  Title: esm_ModalTitle,
  Footer: esm_ModalFooter,
  Dialog: esm_ModalDialog,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
}));
;// CONCATENATED MODULE: ./hooks/useTrigger.js

const useTrigger = function() {
    let cap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
    const [value, setValue] = (0,react.useState)(0);
    const triggerAction = ()=>setValue((item)=>{
            return (item + 1) % cap + 1;
        });
    return [
        value,
        triggerAction
    ];
};
/* harmony default export */ var hooks_useTrigger = (useTrigger);

// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./utils/ProjectionPartlist.js


const getProjectionPartListData = async (partList)=>{
    try {
        var ref, ref1;
        const response = await (0,constants_config/* getConfig */.i)();
        const currencyCode = response === null || response === void 0 ? void 0 : (ref = response.internationalization) === null || ref === void 0 ? void 0 : ref.currencyCode;
        const currencySign = response === null || response === void 0 ? void 0 : (ref1 = response.internationalization) === null || ref1 === void 0 ? void 0 : ref1.currencySign;
        const itemsCount = 20;
        let startFrom = 0;
        let endTo = itemsCount;
        const initialList = [];
        const groupArrayCount = Math.ceil(partList.length / itemsCount);
        const skus = partList.map((val)=>val.skuId);
        if ((partList === null || partList === void 0 ? void 0 : partList.length) <= itemsCount) {
            const resp = await (0,ct_service/* getProjectionData */.vP)({
                skus
            });
            const { repParts , replacementPartlist  } = await getReplacementItem(resp);
            const prices = getPartsPricebySku(replacementPartlist, currencyCode, currencySign);
            const { replacementPartsInfo , replacementParts  } = replacementProductInfo(replacementPartlist, prices, repParts);
            return {
                replacementParts,
                replacementPartsInfo,
                pricing: getPartsPricebySku([
                    ...resp,
                    ...replacementPartlist
                ], currencyCode, currencySign)
            };
        } else {
            const list = [];
            Array.from({
                length: groupArrayCount
            }, ()=>{
                list.push([
                    partList.slice(startFrom, endTo)
                ]);
                startFrom = endTo;
                endTo = endTo + itemsCount;
                return null;
            });
            list.forEach((val)=>{
                const skus = val[0].map((v)=>v.skuId);
                const resp = (0,ct_service/* getProjectionData */.vP)({
                    skus
                });
                initialList.push(resp);
            });
            const res = await Promise.allSettled(initialList);
            const combineItem = res.flatMap((x)=>x.value);
            const { repParts: repParts1 , replacementPartlist: replacementPartlist1  } = await getReplacementItem(combineItem);
            const prices1 = getPartsPricebySku(replacementPartlist1, currencyCode, currencySign);
            const { replacementPartsInfo: replacementPartsInfo1 , replacementParts: replacementParts1  } = replacementProductInfo(replacementPartlist1, prices1, repParts1);
            return {
                replacementParts: replacementParts1,
                replacementPartsInfo: replacementPartsInfo1,
                pricing: getPartsPricebySku([
                    ...combineItem,
                    ...replacementPartlist1
                ], currencyCode, currencySign)
            };
        }
    } catch (err) {
        return err;
    }
};
const getPartsPricebySku = function(list) {
    let currencyCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD", currencySign = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$";
    const sortItems = (i)=>{
        return {
            sku: i === null || i === void 0 ? void 0 : i.sku,
            currencySign,
            discountPrices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref, ref1;
                return (i === null || i === void 0 ? void 0 : (ref = i.discounted) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.currencyCode) === currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1, ref2;
                var ref3;
                return {
                    ...a,
                    [(ref3 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref3 !== void 0 ? ref3 : "ANY"]: i === null || i === void 0 ? void 0 : (ref2 = i.discounted) === null || ref2 === void 0 ? void 0 : ref2.value
                };
            }, {}),
            prices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref;
                return (i === null || i === void 0 ? void 0 : (ref = i.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1;
                var ref2;
                return {
                    ...a,
                    [(ref2 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref2 !== void 0 ? ref2 : "ANY"]: i === null || i === void 0 ? void 0 : i.value
                };
            }, {})
        };
    };
    return list.reduce((acc, sku)=>{
        var ref;
        return {
            ...acc,
            [sku === null || sku === void 0 ? void 0 : (ref = sku.masterVariant) === null || ref === void 0 ? void 0 : ref.sku]: [
                ...sku.variants.map(sortItems),
                ...[
                    sku.masterVariant
                ].map(sortItems)
            ]
        };
    }, {});
};
const getReplacementItem = async (projection)=>{
    const rootSku = [];
    const repParts = projection.map((i)=>{
        var ref, ref1, ref2, ref3;
        const values = i.variants.reduce((acc, j)=>{
            var ref, ref1, ref2;
            const x = j.attributes.filter((i)=>i.name === "SKUSupersededBy");
            if ((x === null || x === void 0 ? void 0 : (ref = x[0]) === null || ref === void 0 ? void 0 : ref.value) !== undefined && (x === null || x === void 0 ? void 0 : (ref1 = x[0]) === null || ref1 === void 0 ? void 0 : ref1.value) !== "DISC.") return {
                ...acc,
                [j === null || j === void 0 ? void 0 : j.sku]: x === null || x === void 0 ? void 0 : (ref2 = x[0]) === null || ref2 === void 0 ? void 0 : ref2.value
            };
            return acc;
        }, {});
        const masterValue = (ref = i.masterVariant.attributes.filter((i)=>i.name === "SKUSupersededBy")) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value;
        const ProductProductNo = (ref2 = i.masterVariant.attributes.filter((i)=>i.name === "ProductProductNo")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.value;
        if (masterValue !== undefined && masterValue !== "DISC.") values[i.masterVariant.sku] = masterValue;
        return {
            value: values,
            key: {
                ProductProductNo,
                sku: i.masterVariant.sku
            }
        };
    }).filter((i)=>{
        var ref, ref1;
        const value = Object.values(i === null || i === void 0 ? void 0 : i.value);
        const key = Object.keys(i.value)[0];
        const val = value.includes(i === null || i === void 0 ? void 0 : (ref = i.key) === null || ref === void 0 ? void 0 : ref.sku) || value.includes(key);
        const key1 = key === null || key === void 0 ? void 0 : key.split("-")[0];
        const val1 = (ref1 = value[0]) === null || ref1 === void 0 ? void 0 : ref1.split("-")[0];
        if (value.length !== 0 && !val && key1 !== val1) {
            return true;
        }
    }).reduce((res, item)=>{
        var ref, ref1;
        rootSku.push(Object.values(item.value));
        item.value.ProductProductNo = item === null || item === void 0 ? void 0 : (ref = item.key) === null || ref === void 0 ? void 0 : ref.ProductProductNo;
        return {
            ...res,
            [item === null || item === void 0 ? void 0 : (ref1 = item.key) === null || ref1 === void 0 ? void 0 : ref1.ProductProductNo]: item.value
        };
    }, {});
    const convertArrayItem = rootSku.flat();
    const resp = rootSku.length !== 0 ? await (0,ct_service/* getProjectionData */.vP)({
        skus: convertArrayItem
    }) : [];
    return {
        repParts,
        replacementPartlist: resp
    };
};
const priceUpdate = (currentPrice, type)=>{
    var ref, ref1;
    var ref2;
    return (ref2 = (ref1 = ((ref = currentPrice === null || currentPrice === void 0 ? void 0 : currentPrice.prices[type]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100) === null || ref1 === void 0 ? void 0 : ref1.toFixed(2)) !== null && ref2 !== void 0 ? ref2 : null;
};
const replacementProductInfo = (partsItems, priceList, replacementProducts)=>{
    const updatePartList = partsItems.map((values)=>{
        var ref, ref1;
        const { masterVariant , slug , name  } = values;
        const skuNo = masterVariant["sku"];
        const ProductNo = (ref = masterVariant === null || masterVariant === void 0 ? void 0 : masterVariant.attributes.filter((v)=>{
            return (v === null || v === void 0 ? void 0 : v.name) === "ProductProductNo";
        })[0]) === null || ref === void 0 ? void 0 : ref.value;
        const currentPrice = (ref1 = priceList[skuNo]) === null || ref1 === void 0 ? void 0 : ref1.filter((v)=>{
            return (v === null || v === void 0 ? void 0 : v.sku) === skuNo;
        })[0];
        return {
            Cod: ProductNo,
            Name: name["en-US"],
            ctrPrice: priceUpdate(currentPrice, "CTR"),
            ffPrice: priceUpdate(currentPrice, "FF"),
            guestPrice: priceUpdate(currentPrice, "GST"),
            kemprPrice: priceUpdate(currentPrice, "KEMP"),
            productId: ProductNo,
            skuId: skuNo,
            slug: slug["en-US"],
            stockStatus: true,
            tprPrice: priceUpdate(currentPrice, "TPR"),
            tvsPrice: priceUpdate(currentPrice, "TVS"),
            productDetails: values
        };
    });
    const replaceValue = Object.values(replacementProducts);
    const replacementParts = replaceValue.reduce((res, item)=>{
        const ProductProductNo = item.ProductProductNo;
        delete item.ProductProductNo;
        const currentVal = updatePartList.filter((v)=>{
            var ref, ref1;
            return (v === null || v === void 0 ? void 0 : (ref = v.Cod) === null || ref === void 0 ? void 0 : ref.split("-")[0]) === ((ref1 = Object.values(item)[0]) === null || ref1 === void 0 ? void 0 : ref1.split("-")[0]);
        });
        if (currentVal.length !== 0) {
            var ref;
            item.ReplaceProductProductNo = (ref = currentVal[0]) === null || ref === void 0 ? void 0 : ref.Cod;
        }
        return {
            ...res,
            [ProductProductNo]: item
        };
    }, {});
    return {
        replacementPartsInfo: updatePartList,
        replacementParts
    };
};

// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

;// CONCATENATED MODULE: ./components/PartsViewer/v2/ErrorBoundary/index.js



/**
 * This will catch errors and show alternate view
 */ class ErrorBoundary extends react.Component {
    /**
   * Rejection.
   * @param {Error} error
   * @return {Object}
   */ static getDerivedStateFromError(error) {
        return {
            error: true,
            errorMessage: error.toString()
        };
    }
    /**
   * Adding listner function on mount to the event.
   */ componentDidMount() {
        window.addEventListener("unhandledrejection", this.promiseRejectionHandler);
    }
    /**
   * Remove listner function on unmount.
   */ componentWillUnmount() {
        window.removeEventListener("unhandledrejection", this.promiseRejectionHandler);
    }
    /**
   * @return {React.JSX} Return appropriate component
   */ render() {
        const { error , errorMessage  } = this.state;
        const { FallBackComponent , children , params  } = this.props;
        return error === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FallBackComponent, {
            error,
            errorMessage,
            params
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                " ",
                children
            ]
        });
    }
    constructor(...args){
        super(...args);
        _defineProperty(this, "state", {
            error: false,
            errorMessage: ""
        });
        /**
   * This function handles rejection.
   * @param {Event} event
   */ _defineProperty(this, "promiseRejectionHandler", (event)=>{
            this.setState({
                error: event.reason
            }) // eslint-disable-line no-invalid-this
            ;
        });
    }
}
/* harmony default export */ var v2_ErrorBoundary = (ErrorBoundary);

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/PartsViewer/v2/localization.js
var localization = __webpack_require__(89676);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ErrorFallBack/index.js






const ErrorFallbackUI = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { errorSorryText , errorTextTwo , errorContactText  } = (0,localization/* getTranslations */.F)(t);
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { internationalization: { language ="en"  } = {}  } = globalConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fallback-wrapper d-flex flex-column w-100 h-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "error-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-first",
                        children: errorSorryText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "questions",
                        children: [
                            errorTextTwo,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/".concat(language).concat(constants.CONTACT_US_PAGE_URL),
                                target: "_blank",
                                rel: "noreferrer",
                                children: errorContactText
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ErrorFallBack = (ErrorFallbackUI);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/core/Coach/Coach.js




const Coach = (props)=>{
    const { text , hide =false , showHeaderCoach =false , panelState , isOverlapping , displayKey ="" , siteName =null  } = props || {};
    const [isShown, setIsShown] = (0,react.useState)(false);
    const [isSeen, setIsSeen] = (0,react.useState)(false);
    const device = (0,useViewport/* default */.Z)();
    const [coachMarkPosition, setCoachMarkPosition] = (0,react.useState)({
        top: 0,
        left: 0,
        zIndex: 1
    });
    const kohlerCanadaFlag = (0,helper/* isCanadaSite */.guj)(siteName);
    const exitClass = kohlerCanadaFlag ? "exit-coach-mark-canada" : null;
    (0,react.useEffect)(()=>{
        updateCoachMarkPosition();
        window.addEventListener("resize", updateCoachMarkPosition);
        return ()=>{
            window.removeEventListener("resize", updateCoachMarkPosition);
        };
    }, [
        device
    ]);
    const updateCoachMarkPosition = ()=>{
        let top;
        let left;
        if (showHeaderCoach) {
            var ref, ref1, ref2;
            const addCoachFirstChild = (ref2 = (ref = document === null || document === void 0 ? void 0 : document.querySelector(".add-coach")) === null || ref === void 0 ? void 0 : (ref1 = ref.firstElementChild) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.right;
            const contentChange = addCoachFirstChild - 85;
            if (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) {
                top = "110px";
                left = "65px";
            } else if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
                top = "115px";
                left = "85px";
            } else if (device === null || device === void 0 ? void 0 : device.isMediumScreen) {
                top = "110px";
                left = "".concat(contentChange, "px");
            } else {
                top = isOverlapping ? "115px" : "75px";
                left = "".concat(contentChange, "px");
            }
            setCoachMarkPosition({
                top: top,
                left: left
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (!hide) setIsShown(true);
        else setIsShown(false);
    }, []);
    const conditionalCss = showHeaderCoach ? {
        top: coachMarkPosition.top,
        left: coachMarkPosition.left,
        zIndex: panelState ? 1 : 2
    } : null;
    (0,react.useEffect)(()=>{
        const getCoachKey = window.localStorage.getItem("getCoachKey");
        if (getCoachKey && Object.prototype.hasOwnProperty.call(JSON.parse(getCoachKey), displayKey)) {
            setIsSeen(true);
        }
    }, []);
    const handlerModel = ()=>{
        const getCoachKeyVal = window.localStorage.getItem("getCoachKey");
        let keyVal = {};
        if (getCoachKeyVal) keyVal = JSON.parse(getCoachKeyVal);
        keyVal[displayKey] = "y";
        window.localStorage.setItem("getCoachKey", JSON.stringify(keyVal));
        setIsShown(false);
        setIsSeen(true);
    };
    return !isSeen && isShown && !hide ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "coach-mark ".concat(exitClass, " "),
        "data-testid": "header-back-button",
        style: conditionalCss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "coach-text",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "close-button-coach",
                onClick: handlerModel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10.7043 10L19.8599 19.2857L19.1556 20L10 10.7143L10.7043 10Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M19.2957 10L10.1401 19.2857L10.8444 20L20 10.7143L19.2957 10Z",
                            fill: "white"
                        })
                    ]
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var Coach_Coach = (Coach);

;// CONCATENATED MODULE: ./public/icons/cart-icon-dark-empty.svg
/* harmony default export */ var cart_icon_dark_empty = ({"src":"/_next/static/media/cart-icon-dark-empty.2d6bad3c.svg","height":23,"width":26});
;// CONCATENATED MODULE: ./public/icons/cart-icon-dark-nonempty.svg
/* harmony default export */ var cart_icon_dark_nonempty = ({"src":"/_next/static/media/cart-icon-dark-nonempty.63d9248c.svg","height":22,"width":25});
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Shared/MiniCart/v2/MiniCart.jsx






const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  }  } , color ="dark"  } = param;
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator v2 ".concat(cartCount > 0 && "cart-indicator__with-count", " ").concat(color === "dark" ? "dark" : "light"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"homepage:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 10 ? "count-single" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: cart_icon_dark_nonempty === null || cart_icon_dark_nonempty === void 0 ? void 0 : cart_icon_dark_nonempty.src,
                        alt: "Cart"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: cart_icon_dark_empty === null || cart_icon_dark_empty === void 0 ? void 0 : cart_icon_dark_empty.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v2_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./public/scout_icon/icons/printIcon.svg
/* harmony default export */ var printIcon = ({"src":"/_next/static/media/printIcon.99057120.svg","height":30,"width":30});
;// CONCATENATED MODULE: ./public/scout_icon/icons/shareIcon.svg
/* harmony default export */ var shareIcon = ({"src":"/_next/static/media/shareIcon.773c9ce7.svg","height":30,"width":30});
// EXTERNAL MODULE: ./components/PartsViewer/v2/PrintShareWindow/index.module.scss
var index_module = __webpack_require__(32353);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PrintShareWindow/index.js




const PrintAndShare = (props)=>{
    const { showPopup , setShowPopup , contents  } = props;
    if (!showPopup) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).PrintShareWindow,
        children: [
            showPopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "bg-overlay-print",
                onClick: ()=>setShowPopup(false)
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "print-modal",
                children: contents
            })
        ]
    });
};
PrintAndShare.propTypes = {
    showPopup: (prop_types_default()).bool.isRequired,
    setShowPopup: (prop_types_default()).func.isRequired,
    contents: (prop_types_default()).any.isRequired
};
/* harmony default export */ var PrintShareWindow = (PrintAndShare);

// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 3 modules
var SocialShare = __webpack_require__(49019);
// EXTERNAL MODULE: ./components/PartsViewer/v2/SelectedFileView/PrintShare/index.module.scss
var PrintShare_index_module = __webpack_require__(83000);
var PrintShare_index_module_default = /*#__PURE__*/__webpack_require__.n(PrintShare_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/PrintShare/index.js









const PrintShare = (props)=>{
    const { showShareModal =false , setShare , shareBtn , productId  } = props;
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { internationalization: { language ="en"  } = {}  } = globalConfig;
    const link = "".concat(window.location.origin, "/").concat(language, "/parts?number=").concat(productId);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { mailBody , description , mailSubjectTextOne , mailSubjectTextTwo  } = (0,localization/* getTranslations */.F)(t);
    const emailSubjecttext = "".concat(mailSubjectTextOne, "-").concat(mailSubjectTextTwo, "-").concat(productId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PrintShare_index_module_default()).PrintShare,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "share-widgets",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                asset: {
                    url: link,
                    description
                },
                id: "kf-my-product-tile-".concat(productId),
                showModal: showShareModal,
                onClose: setShare,
                shareBtn: shareBtn,
                mailSubject: emailSubjecttext,
                mailBody: mailBody,
                url: link
            })
        })
    });
};
PrintShare.propTypes = {
    showShareModal: (prop_types_default()).bool.isRequired,
    setShare: (prop_types_default()).func.isRequired,
    shareBtn: (prop_types_default()).string.isRequired,
    productId: (prop_types_default()).string.isRequired
};
/* harmony default export */ var SelectedFileView_PrintShare = (PrintShare);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/utils.js
const sortOptions = [
    {
        label: "A-Z",
        key: "asc"
    },
    {
        label: "Z-A",
        key: "desc"
    }
];
const LOCAL_PREFIX = "";
const MEDALLIA_FORM_ID = "40769";
const printElement = async function(elementId, uniqueIframeId) {
    const content = document.getElementById(elementId);
    let contentWindow;
    if (document.getElementById(uniqueIframeId)) {
        contentWindow = document.getElementById(uniqueIframeId).contentWindow;
    } else {
        const iframe = document.createElement("iframe");
        iframe.setAttribute("title", uniqueIframeId);
        iframe.setAttribute("id", uniqueIframeId);
        iframe.setAttribute("style", "height: 0px; width: 0px; position: absolute;");
        document.body.appendChild(iframe);
        contentWindow = iframe.contentWindow;
    }
    contentWindow.document.open();
    contentWindow.document.write(content.innerHTML);
    const style = contentWindow.document.createElement("style");
    style.textContent = "body { overflow: visible!important; }.main { display: none; visibility: hidden; }#parent-print { display: block; visibility: visible; height: 100%; min-height: 100%; }html, body, #wrap {height: 100%; margin: 0; padding: 0;}body #parent-print #wrap {min-height: 100%; max-height: 100%; overflow: visible!important; }#main {height: 74.2%; width: 100%; text-align: center;}#main img {height: 97%; width: 100%; margin: 1% auto}#header {height: 20%; border-bottom:solid 1px #ccc; text-align:left;}#header.topPrint svg{height:95%; width:100%;}#footer { bottom: 0;  font-size: 8px; left: 0; padding:3px 0 0 0; width: 100%; height: 5%; position: absolute; border-top: solid 1px #ccc;}#footer .cod-prod{float:left; padding:0 0 0 10px;}#footer #inf-print{float:right; text-align:right; padding:0 10px 0 0; }#footer .date-print{ font-style: italic; color: #333; }#footer #pagination{position:absolute; z-index:1; left:50%; margin:0 0 0 -50px; width:100px; text-align:center; color: #8399B6;}#wrap {page-break-after: always; position: relative;}body.mozilla #main svg { height: 95%; width: 100%; max-height: 95%; }body.safari { height:9in; width: 8.5in; }body.safari #main img {max-height: 99%; max-width: 100%; margin: 5px auto}body.safari #parent-print #wrap #footer { font-size: 8px; left: 0; padding:3px 0 0 0; width: 100%; height: 2%; position: absolute; border-top: solid 1px #ccc;}body.safari #parent-print #wrap #main svg {height: 99%; width: 99%; margin: 5px auto; }";
    contentWindow.document.head.appendChild(style);
    contentWindow.document.close();
    await new Promise((r)=>setTimeout(r, 500));
    contentWindow.focus();
    contentWindow.print();
};
const getUpdatedReplaceFile = (currentFile)=>{
    if (!(currentFile === null || currentFile === void 0 ? void 0 : currentFile.replacementParts) && !(currentFile === null || currentFile === void 0 ? void 0 : currentFile.replacementPartsInfo)) {
        return currentFile;
    }
    const parts = [];
    currentFile === null || currentFile === void 0 ? void 0 : currentFile.Parts.forEach((value)=>{
        const rootSku = value === null || value === void 0 ? void 0 : value.Cod;
        const currentVal = currentFile === null || currentFile === void 0 ? void 0 : currentFile.replacementParts[rootSku];
        const Key = currentVal ? currentVal === null || currentVal === void 0 ? void 0 : currentVal.ReplaceProductProductNo : null;
        const replaceVal = currentFile === null || currentFile === void 0 ? void 0 : currentFile.replacementPartsInfo.filter((v)=>v.Cod === Key)[0];
        const partid = parts === null || parts === void 0 ? void 0 : parts.filter((v)=>v.Cod === rootSku)[0];
        if (!partid) {
            if (replaceVal) {
                const findVal = parts === null || parts === void 0 ? void 0 : parts.filter((v)=>{
                    return v.Cod === (replaceVal === null || replaceVal === void 0 ? void 0 : replaceVal.Cod);
                })[0];
                if (!findVal) {
                    replaceVal.replaceRootSku = rootSku;
                    parts.push(replaceVal);
                } else {
                    findVal.replaceRootSku = rootSku;
                }
            } else {
                parts.push(value);
            }
        }
    });
    return parts;
};

// EXTERNAL MODULE: ./components/PartsViewer/v2/icon.js
var icon = __webpack_require__(7667);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PrintPage/index.js




const PrintPage = (props)=>{
    const { item , metadata , index , printItems  } = props;
    const getFormatedDate = ()=>{
        const today = new Date();
        return today.toLocaleString("en", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour12: true,
            hour: "2-digit",
            minute: "2-digit"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        rel: index,
        id: "wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "header",
                className: "topPrint",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* PrintHeader */.Gr, {
                    data: metadata === null || metadata === void 0 ? void 0 : metadata.Info
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                rel: "printDiv",
                className: "container",
                id: "main",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: item === null || item === void 0 ? void 0 : item.URL,
                    alt: "",
                    srcSet: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "pagination",
                        children: [
                            "Page ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "actual",
                                children: index + 1
                            }),
                            " - ",
                            "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "total",
                                children: printItems === null || printItems === void 0 ? void 0 : printItems.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "inf-print",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "date-print",
                            children: [
                                "printed on ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "date-print",
                                    children: getFormatedDate()
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
PrintPage.propTypes = {
    item: (prop_types_default()).object.isRequired,
    metadata: (prop_types_default()).object.isRequired,
    index: (prop_types_default()).string.isRequired,
    printItems: (prop_types_default()).array.isRequired
};
/* harmony default export */ var v2_PrintPage = (PrintPage);

// EXTERNAL MODULE: ./components/PartsViewer/v2/PrintWindow/index.module.scss
var PrintWindow_index_module = __webpack_require__(36697);
var PrintWindow_index_module_default = /*#__PURE__*/__webpack_require__.n(PrintWindow_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PrintWindow/index.js










const PrintWindow = (props)=>{
    var ref;
    const { files , productId  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [metadata, setMetadata] = (0,react.useState)(null);
    const [metadataPromise, setMetadataPromise] = (0,react.useState)(null);
    const [printItems, setPrintItems] = (0,react.useState)([]);
    const [selected, setSelected] = (0,react.useState)({});
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { printDiagrams , printAllText , printSelectedText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        if (files) {
            setMetadataPromise(getPartInfo(files));
        }
    }, [
        files
    ]);
    const getPartInfo = async (arg)=>{
        var ref;
        const resp = await dispatch((0,pdpSlice/* getPartList */.gt)({
            productId
        })).unwrap();
        const blobFileResp = await fetch(resp === null || resp === void 0 ? void 0 : (ref = resp.Info) === null || ref === void 0 ? void 0 : ref.Thumbnail);
        const data = await (blobFileResp === null || blobFileResp === void 0 ? void 0 : blobFileResp.blob());
        const imgFile = new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onload = function(e) {
                resolve(e.target.result);
            };
            return reader.readAsDataURL(data);
        });
        await new Promise((r)=>setTimeout(r, 500));
        resp.Info.uri = await imgFile;
        resp.SVGFiles = arg;
        setMetadata(resp);
        setPrintItems(arg);
    };
    const printHandler = async ()=>{
        setPrintItems(metadata === null || metadata === void 0 ? void 0 : metadata.SVGFiles);
        await metadataPromise;
        printElement("parts-print-content");
    };
    const handleChange = (event)=>{
        const { value , checked  } = event.target;
        setSelected((prevState)=>{
            const key = [
                "key_" + value
            ];
            const data = {
                ...prevState,
                [key]: value
            };
            if (data[key] && !checked) {
                delete data[key];
            }
            return data;
        });
    };
    const selectedPrinthandler = async (activeItem, list)=>{
        const item = Object === null || Object === void 0 ? void 0 : Object.values(activeItem);
        if ((item === null || item === void 0 ? void 0 : item.length) !== 0) {
            const value = list === null || list === void 0 ? void 0 : list.filter((v)=>{
                return item === null || item === void 0 ? void 0 : item.includes(v.FileName);
            });
            setPrintItems(value);
            await metadataPromise;
            printElement("parts-print-content");
        }
    };
    const activeButton = (ref = Object === null || Object === void 0 ? void 0 : Object.values(selected)) === null || ref === void 0 ? void 0 : ref.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PrintWindow_index_module_default()).PrintModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-15 print-heading",
                children: printDiagrams
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "print-lists",
                children: files === null || files === void 0 ? void 0 : files.map((val)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("label", {
                        className: "print-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    " ",
                                    val === null || val === void 0 ? void 0 : val.title
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                value: val === null || val === void 0 ? void 0 : val.id,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "checkmark"
                            })
                        ]
                    }, val === null || val === void 0 ? void 0 : val.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "print-action-buttons mt-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "print-button fs-18 fw-400 w-100",
                        onClick: ()=>printHandler(),
                        children: printAllText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "print-button fs-18 fw-400 w-100 ".concat(activeButton === 0 ? "disabled" : ""),
                        onClick: ()=>{
                            return selectedPrinthandler(selected, metadata === null || metadata === void 0 ? void 0 : metadata.SVGFiles);
                        },
                        children: printSelectedText
                    })
                ]
            }),
            printItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden-print-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "parts-print-content",
                    children: printItems === null || printItems === void 0 ? void 0 : printItems.map((item, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PrintPage, {
                            item: item,
                            metadata: metadata,
                            index: index,
                            printItems: printItems
                        }, item === null || item === void 0 ? void 0 : item.id);
                    })
                })
            }) : null
        ]
    });
};
PrintWindow.propTypes = {
    files: (prop_types_default()).array.isRequired
};
/* harmony default export */ var v2_PrintWindow = (PrintWindow);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/FileSelection/index.js




















const FileSelection = (props)=>{
    var ref;
    const { files , isActive , setSelected , setPopupModal , title , sku , skuImage , getFileTitle , setParts , panelState , initialIndex , setPartsHeight , productId , setShowPrint , siteName  } = props || {};
    const [visibleCoach, setVisibleCoach] = (0,react.useState)(false);
    const device = (0,useViewport/* default */.Z)();
    const divRef = (0,react.useRef)(null);
    const tabRefs = (0,react.useRef)([]);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { coachMarkText  } = (0,localization/* getTranslations */.F)(t);
    const cartCount = (0,cart/* getCartCount */.c0)();
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [isOverlapping, setIsOverlapping] = (0,react.useState)(false);
    const [showPopup, setShowPopup] = (0,react.useState)(false);
    const [share, setShare] = (0,react.useState)(false);
    const [showPrintWindow, setShowPrintWindow] = (0,react.useState)(false);
    const kohlerCanadaFlag = (0,helper/* isCanadaSite */.guj)(siteName);
    const shareBtn = (0,react.useRef)();
    const marginTab = kohlerCanadaFlag ? "mr-110" : "mr-150";
    const featuresDtl = {
        displayClass: "d-inline",
        floating: (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "" : "float-right",
        heightof: "h-80",
        skuDisplayClass: (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "" : "d-inline"
    };
    const [features, setFeatures] = (0,react.useState)(featuresDtl);
    const router = (0,next_router.useRouter)();
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            cartCount,
            ariaLabel,
            cartUrl
        },
        callbacks: {
            onClick: ()=>{
                redirect();
            }
        }
    };
    const scrollVisible = (index)=>{
        var ref, ref1, ref2;
        const addCoachContainer = document.querySelector(".add-coach");
        const offSetValue = ((ref1 = (ref = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.left) - ((ref2 = addCoachContainer === null || addCoachContainer === void 0 ? void 0 : addCoachContainer.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.left);
        if (tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) {
            var ref3;
            (ref3 = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) === null || ref3 === void 0 ? void 0 : ref3.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
            if (!(device === null || device === void 0 ? void 0 : device.isSmallScreen)) {
                const timer = setTimeout(()=>addCoachContainer.scrollLeft += offSetValue, 100);
                return ()=>clearTimeout(timer);
            }
        }
    };
    const adjustSrcollForView = ()=>{
        const addCoachContainer = document.querySelector(".add-coach");
        const activeTabContent = document.querySelector(".activeTab");
        const addCoachContainerRect = addCoachContainer === null || addCoachContainer === void 0 ? void 0 : addCoachContainer.getBoundingClientRect();
        const activeTabContentRect = activeTabContent === null || activeTabContent === void 0 ? void 0 : activeTabContent.getBoundingClientRect();
        const offset = (activeTabContentRect === null || activeTabContentRect === void 0 ? void 0 : activeTabContentRect.left) - (addCoachContainerRect === null || addCoachContainerRect === void 0 ? void 0 : addCoachContainerRect.left);
        addCoachContainer.scrollLeft += offset;
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", adjustSrcollForView);
        return ()=>{
            window.removeEventListener("resize", adjustSrcollForView);
        };
    }, []);
    (0,react.useEffect)(()=>{
        scrollVisible(initialIndex);
    }, [
        files,
        initialIndex
    ]);
    (0,react.useEffect)(()=>{
        setPartsHeight(features === null || features === void 0 ? void 0 : features.heightof);
        const timer = setTimeout(()=>setVisibleCoach(true), 3000);
        return ()=>clearTimeout(timer);
    }, []);
    const screenWidth = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    const handlerFileSelection = async (e, item, index)=>{
        var ref;
        if (!(item === null || item === void 0 ? void 0 : item.prices) && (item === null || item === void 0 ? void 0 : (ref = item.Parts) === null || ref === void 0 ? void 0 : ref.length) !== 0) {
            const listData = await getProjectionPartListData(item === null || item === void 0 ? void 0 : item.Parts);
            const prices = listData.pricing;
            setParts((prevState)=>{
                const { partsInfo: { SVGFiles  }  } = prevState;
                const updatePrice = SVGFiles === null || SVGFiles === void 0 ? void 0 : SVGFiles.filter((val)=>val.FileName === item.FileName)[0];
                updatePrice.replacementPartsInfo = listData.replacementPartsInfo;
                updatePrice.defaultPartsList = updatePrice.Parts;
                updatePrice.replacementParts = listData.replacementParts;
                updatePrice.Parts = getUpdatedReplaceFile(updatePrice);
                updatePrice.prices = prices;
                return {
                    ...prevState
                };
            });
        }
        setSelected(item);
        scrollVisible(index);
        setPopupModal(false);
    };
    (0,react.useEffect)(()=>{
        const checkOverlap = ()=>{
            if (device === null || device === void 0 ? void 0 : device.isLargeTabView) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                let addCoachSpan = 0;
                const childDiv = Array.from((ref = document === null || document === void 0 ? void 0 : document.querySelector(".add-coach")) === null || ref === void 0 ? void 0 : ref.children);
                childDiv.forEach((child)=>{
                    var ref;
                    return addCoachSpan += (ref = child === null || child === void 0 ? void 0 : child.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.width;
                });
                if (((ref2 = (ref1 = document === null || document === void 0 ? void 0 : document.querySelector(".sku-title")) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.width) + ((ref4 = (ref3 = document === null || document === void 0 ? void 0 : document.querySelector(".sku")) === null || ref3 === void 0 ? void 0 : ref3.getBoundingClientRect()) === null || ref4 === void 0 ? void 0 : ref4.width) + addCoachSpan + 200 > ((ref6 = (ref5 = document.querySelector(".section-title-file")) === null || ref5 === void 0 ? void 0 : ref5.getBoundingClientRect()) === null || ref6 === void 0 ? void 0 : ref6.width)) {
                    setIsOverlapping(true);
                } else {
                    setIsOverlapping(false);
                }
            }
        };
        checkOverlap();
        window.addEventListener("resize", checkOverlap);
        return ()=>window.removeEventListener("resize", checkOverlap);
    }, []);
    (0,react.useEffect)(()=>{
        if (isOverlapping) {
            setPartsHeight("h-115");
            setFeatures((prevfeatures)=>({
                    ...prevfeatures,
                    displayClass: "d-inline",
                    floating: "",
                    heightof: "h-115",
                    marginTb: "my-3",
                    skuDisplayClass: ""
                }));
        } else {
            setFeatures(featuresDtl);
            setPartsHeight("h-80");
        }
    }, [
        isOverlapping
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "check-modal d-flex flex-grow-1 ".concat(features.heightof, " ").concat(showPopup ? "show-print-window" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-container modal_panel selection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "only-image image-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "image-part",
                            src: skuImage,
                            alt: "skuimage"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section-title-file ".concat(features.displayClass, " w-100"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal_header flex-item ".concat(features.displayClass),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sku-part ".concat(features.skuDisplayClass),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sku-title",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sku",
                                            children: sku
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-container header-content ".concat(features.floating),
                                children: [
                                    files.length !== 1 && visibleCoach ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach_Coach, {
                                        text: coachMarkText,
                                        show: true,
                                        showHeaderCoach: true,
                                        panelState: panelState,
                                        isOverlapping: isOverlapping,
                                        displayKey: "top"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: divRef,
                                        className: "add-coach",
                                        children: (ref = files === null || files === void 0 ? void 0 : files.filter((files)=>"FileName" in files)) === null || ref === void 0 ? void 0 : ref.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ref: (el)=>tabRefs.current[index] = el,
                                                className: "file-tab user-select-none  header-icons header-name" + (isActive(item) ? " activeTab" : ""),
                                                onClick: (e)=>{
                                                    handlerFileSelection(e, item, index);
                                                },
                                                onKeyDown: (val)=>val,
                                                children: getFileTitle(item === null || item === void 0 ? void 0 : item.FileName)
                                            }, "".concat(index + (item === null || item === void 0 ? void 0 : item.FileName)));
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(!(device.isMediumScreen || device.isSmallScreen) ? "".concat(marginTab, " print-action") : "mobile-print-section"),
                children: screenWidth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "print-share-div d-flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-img d-flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn-share-print",
                                onClick: ()=>{
                                    setShowPopup(true);
                                    setShare(false);
                                    setShowPrintWindow(true);
                                    setShowPrint(true);
                                },
                                "aria-label": "Click here to print",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: printIcon === null || printIcon === void 0 ? void 0 : printIcon.src,
                                    alt: "print"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Click here to share",
                                className: "share-button",
                                onClick: ()=>{
                                    setShowPopup(true);
                                    setShare(true);
                                    setShowPrintWindow(false);
                                    setShowPrint(true);
                                },
                                ref: shareBtn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: shareIcon === null || shareIcon === void 0 ? void 0 : shareIcon.src,
                                    alt: "share"
                                })
                            }),
                            share ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintShareWindow, {
                                showPopup: showPopup,
                                setShowPopup: setShowPopup,
                                contents: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_PrintShare, {
                                    showShareModal: share,
                                    setShare: setShare,
                                    shareBtn: shareBtn,
                                    productId: productId
                                })
                            }) : null,
                            showPrintWindow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintShareWindow, {
                                showPopup: showPopup,
                                setShowPopup: setShowPopup,
                                contents: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PrintWindow, {
                                    files: files,
                                    productId: productId
                                })
                            }) : null
                        ]
                    })
                }) : ""
            }),
            !kohlerCanadaFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "parts-cart-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_MiniCart, {
                    eventHandler: eventHandler,
                    source: "from desk"
                })
            })
        ]
    });
};
FileSelection.propTypes = {
    files: (prop_types_default()).array
};
/* harmony default export */ var SelectedFileView_FileSelection = (FileSelection);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/partReducer.js



const partsReducer = (state, action)=>{
    try {
        switch(action.type){
            case "initPartsList":
                {
                    var ref;
                    const pricesReMapped = Object.values(action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.prices).reduce((a, i)=>{
                        const mappedList = {};
                        i.map((item)=>mappedList[item.sku] = i);
                        return {
                            ...a,
                            ...mappedList
                        };
                    }, {});
                    const newParts = action.payload.Parts.map((item)=>{
                        var ref, ref1;
                        const part = {
                            key: item === null || item === void 0 ? void 0 : item.Cod,
                            partApi: item,
                            ctApiPromise: null,
                            prices: (pricesReMapped === null || pricesReMapped === void 0 ? void 0 : pricesReMapped[item === null || item === void 0 ? void 0 : item.skuId]) ? pricesReMapped === null || pricesReMapped === void 0 ? void 0 : pricesReMapped[item === null || item === void 0 ? void 0 : item.skuId] : ""
                        };
                        const superseded = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.replacementParts) === null || ref1 === void 0 ? void 0 : ref1[item === null || item === void 0 ? void 0 : item.skuId];
                        if (superseded !== undefined) {
                            part["replacement"] = superseded;
                        }
                        return part;
                    });
                    state.parts = newParts;
                    const sortAsc = sortByName(state, "asc");
                    return {
                        parts: sortAsc
                    };
                }
            case "fetchCT":
                {
                    const { payload  } = action;
                    const newParts1 = state.parts.map((item)=>{
                        if (payload.includes(item.key) && item.ctApiPromise === null) return {
                            ...item,
                            ctApiPromise: fetchCTRequest(item.partApi, item === null || item === void 0 ? void 0 : item.prices)
                        };
                        return item;
                    });
                    return {
                        parts: newParts1
                    };
                }
            case "fetchCTAny":
                {
                    const { payload: payload1  } = action;
                    const newParts2 = [];
                    let count = 0;
                    for (const item of state.parts){
                        if (item.ctApiPromise === null && count < payload1) {
                            newParts2.push({
                                ...item,
                                ctApiPromise: fetchCTRequest(item.partApi, item === null || item === void 0 ? void 0 : item.prices)
                            });
                            count++;
                        } else newParts2.push(item);
                    }
                    return {
                        parts: newParts2
                    };
                }
            case "filterProduct":
                {
                    const { payload: payload2  } = action;
                    const persona = (0,helper/* getUserPersona */.shu)();
                    let sortedData;
                    switch(payload2){
                        case "asc":
                            sortedData = sortByName(state, "asc");
                            break;
                        case "desc":
                            sortedData = sortByName(state, "desc");
                            break;
                        case "descPrice":
                            sortedData = sortByPriceDesc(state, persona);
                            break;
                        case "ascPrice":
                            sortedData = sortByPrice(state, persona, "asc");
                            break;
                    }
                    return {
                        parts: sortedData
                    };
                }
            case "fetchForCpiPromise":
                {
                    const { payload: payload3  } = action;
                    const newParts3 = [];
                    let arraylength = 0;
                    for (const item1 of state.parts){
                        arraylength = newParts3 === null || newParts3 === void 0 ? void 0 : newParts3.length;
                        if (item1.ctApiPromise === null && arraylength < payload3) {
                            newParts3.push({
                                ...item1,
                                ctApiPromise: fetchCTRequest(item1.partApi, item1 === null || item1 === void 0 ? void 0 : item1.prices)
                            });
                        } else newParts3.push(item1);
                    }
                    return {
                        parts: newParts3
                    };
                }
            default:
                throw new Error("default");
        }
    } catch (e) {
        return e;
    }
};
/* harmony default export */ var partReducer = (partsReducer);
const sortByName = (state, order)=>{
    switch(order){
        case "desc":
            return state.parts.sort((a, b)=>{
                var ref, ref1, ref2, ref3;
                if ((a === null || a === void 0 ? void 0 : (ref = a.partApi) === null || ref === void 0 ? void 0 : ref.Name) < (b === null || b === void 0 ? void 0 : (ref1 = b.partApi) === null || ref1 === void 0 ? void 0 : ref1.Name)) return 1;
                if ((a === null || a === void 0 ? void 0 : (ref2 = a.partApi) === null || ref2 === void 0 ? void 0 : ref2.Name) > (b === null || b === void 0 ? void 0 : (ref3 = b.partApi) === null || ref3 === void 0 ? void 0 : ref3.Name)) return -1;
                return 0;
            });
        case "asc":
            return state.parts.sort((a, b)=>{
                var ref, ref1, ref2, ref3;
                if (((ref = a.partApi) === null || ref === void 0 ? void 0 : ref.Name) > ((ref1 = b.partApi) === null || ref1 === void 0 ? void 0 : ref1.Name)) return 1;
                if (((ref2 = a.partApi) === null || ref2 === void 0 ? void 0 : ref2.Name) < ((ref3 = b.partApi) === null || ref3 === void 0 ? void 0 : ref3.Name)) return -1;
                return 0;
            });
    }
};
const sortByPrice = function(state, persona) {
    let order = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "asc";
    state.parts.map((part)=>{
        return {
            ...part,
            prices: part.prices.sort((a, b)=>{
                var ref, ref1;
                return ((ref = a === null || a === void 0 ? void 0 : a.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) - ((ref1 = b === null || b === void 0 ? void 0 : b.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount);
            })
        };
    });
    const sortingPrice = personaPriceSort(persona);
    return state.parts.sort((a, b)=>a.partApi[sortingPrice] - b.partApi[sortingPrice]);
};
const sortByPriceDesc = (state, persona)=>{
    state.parts.map((part)=>{
        return {
            ...part,
            prices: part.prices.sort((a, b)=>{
                var ref, ref1;
                return ((ref = b === null || b === void 0 ? void 0 : b.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) - ((ref1 = a === null || a === void 0 ? void 0 : a.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount);
            })
        };
    });
    const sortingPrice = personaPriceSort(persona);
    return state.parts.sort((a, b)=>b.partApi[sortingPrice] - a.partApi[sortingPrice]);
};
const getActions = (state, dispatch)=>{
    return {
        initPartsList: (payload)=>dispatch({
                type: "initPartsList",
                payload
            }),
        fetchCT: (payload)=>dispatch({
                type: "fetchCT",
                payload
            }),
        fetchCTAny: (payload)=>dispatch({
                type: "fetchCTAny",
                payload
            }),
        filterProduct: (payload)=>dispatch({
                type: "filterProduct",
                payload
            }),
        fetchForCpiPromise: (payload)=>dispatch({
                type: "fetchForCpiPromise",
                payload
            }),
        get: {
            readyEntries: ()=>{
                var ref;
                return state === null || state === void 0 ? void 0 : (ref = state.parts) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.ctApiPromise) !== null;
                });
            },
            firstEntries: (key)=>{
                var ref;
                var ref1;
                return (ref = ((ref1 = state === null || state === void 0 ? void 0 : state.parts) !== null && ref1 !== void 0 ? ref1 : []).filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.ctApiPromise) !== null;
                })) === null || ref === void 0 ? void 0 : ref.splice(0, key);
            },
            entryByKey: (key, replaceState)=>{
                var ref, ref1;
                let data = (ref1 = state === null || state === void 0 ? void 0 : (ref = state.parts) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.key) === key;
                })) === null || ref1 === void 0 ? void 0 : ref1[0];
                if (!data) {
                    var ref2, ref3;
                    data = (ref3 = replaceState === null || replaceState === void 0 ? void 0 : (ref2 = replaceState.defaultPartsList) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>{
                        return (item === null || item === void 0 ? void 0 : item.Cod) === key;
                    })) === null || ref3 === void 0 ? void 0 : ref3[0];
                    return {
                        ...data,
                        ctApiPromise: fetchCTRequest(data, replaceState === null || replaceState === void 0 ? void 0 : replaceState.prices[data === null || data === void 0 ? void 0 : data.Cod])
                    };
                }
                if ((data === null || data === void 0 ? void 0 : data.ctApiPromise) === null) {
                    return {
                        ...data,
                        ctApiPromise: fetchCTRequest(data === null || data === void 0 ? void 0 : data.partApi, data === null || data === void 0 ? void 0 : data.prices)
                    };
                }
                return data;
            }
        }
    };
};
const fetchCTRequest = async (args, prices)=>{
    try {
        const docs = await getSearchDetails(args, prices);
        if (docs.length !== 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            const data = {
                ...args,
                productDiscontinue: Date.parse((ref = docs[0]) === null || ref === void 0 ? void 0 : ref.productDiscontinuedDate_dt) < Date.now(),
                productIdKey: (docs === null || docs === void 0 ? void 0 : (ref1 = docs[0]) === null || ref1 === void 0 ? void 0 : ref1["ProductNoSpecialKeyword"]) ? docs === null || docs === void 0 ? void 0 : (ref2 = docs[0]) === null || ref2 === void 0 ? void 0 : ref2["ProductNoSpecialKeyword"] : docs === null || docs === void 0 ? void 0 : (ref3 = docs[0]) === null || ref3 === void 0 ? void 0 : ref3["CustomerFacingSKU_s"],
                imageUrl: ((ref7 = docs === null || docs === void 0 ? void 0 : (ref4 = docs[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["Color.KEMP.Details_ss"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.split("||")) === null || ref7 === void 0 ? void 0 : ref7[1]) ? (ref8 = docs[0]["Color.KEMP.Details_ss"][0]) === null || ref8 === void 0 ? void 0 : ref8.split("||")[1] : null,
                activeItem: (ref12 = docs === null || docs === void 0 ? void 0 : (ref9 = docs[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["Color.KEMP.Details_ss"]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.split("||")[0]) === null || ref12 === void 0 ? void 0 : ref12.split("|")[0],
                data: docs[0]
            };
            return data;
        } else return null;
    } catch (err) {
        return err;
    }
};
const getSearchDetails = async (args, prices)=>{
    const { slug  } = args;
    const resp = await (0,ct_service/* getSearchPDP */.Do)(slug);
    const persona = (0,helper/* getUserPersona */.shu)();
    const { data: { response: { docs  }  }  } = resp;
    if (docs.length !== 0) {
        docs[0].prices = prices;
        if (docs[0]["Color.SKU.Details_ss"]) {
            var ref;
            const varientDetails = getVarientDetails(docs[0]);
            const fieldType = (ref = varientDetails[0]) === null || ref === void 0 ? void 0 : ref.fieldType;
            const swatches = getSwatches(docs[0][fieldType], persona, docs);
            docs[0].colorData = swatches;
            docs[0].varientDetails = varientDetails;
        } else {
            var ref1, ref2, ref3, ref4;
            const data = [
                "Not Applicable|swatch_NA|".concat((ref1 = docs[0]) === null || ref1 === void 0 ? void 0 : ref1.masterSKU_s, "|").concat((ref2 = docs[0]) === null || ref2 === void 0 ? void 0 : ref2.productInStock_b, "|").concat((ref3 = docs[0]) === null || ref3 === void 0 ? void 0 : ref3.productDiscontinued_b, "|").concat((ref4 = docs[0]) === null || ref4 === void 0 ? void 0 : ref4.CustomerFacingSKU_s)
            ];
            docs[0].colorData = getSwatches(data, persona, docs);
            docs[0].varientDetails = [];
        }
        return docs;
    } else return docs;
};
const getSwatches = (args, persona, docs)=>{
    return args === null || args === void 0 ? void 0 : args.map((val, i)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        let price = 0;
        let pricelist = 0;
        const [label, swatch, id, , , value] = val.split("|");
        const sortPrice = (ref = docs[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
            return (val === null || val === void 0 ? void 0 : val.sku) === id;
        })[0];
        const currencyCode = ((ref2 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices[persona]) === null || ref2 === void 0 ? void 0 : ref2.currencyCode) || "USD";
        const currencySign = (sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.currencySign) || "$";
        const centPrice = (ref3 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices[persona]) === null || ref3 === void 0 ? void 0 : ref3.centAmount;
        const discountedPrice = (sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.discountPrices) && Object.values(sortPrice.discountPrices).length ? Number(((ref4 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.discountPrices[persona]) === null || ref4 === void 0 ? void 0 : ref4.centAmount) / 100).toFixed(2) : null;
        pricelist = Number(((ref5 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices["ANY"]) === null || ref5 === void 0 ? void 0 : ref5.centAmount) / 100).toFixed(2);
        price = Number(centPrice / 100).toFixed(2);
        const colorBaseUrl = constants["default"].COLOR_FILE_URL;
        const colorUrl = colorBaseUrl + swatch;
        const imgUrl = docs[0]["productImages.url_ss"] ? docs[0]["productImages.url_ss"][0] : null;
        return {
            checked: false,
            colorUrl,
            discontinuedColor: false,
            id,
            label,
            name: "product-color",
            notApplicable: false,
            value,
            price,
            pricelist,
            currencyCode,
            currencySign,
            imgUrl,
            centPrice,
            discountedPrice
        };
    });
};
const getVarientDetails = (data)=>{
    if (data["Color.SKU.Details_ss"]) {
        return data["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                customerSku: d[5],
                fieldType: "Color.SKU.Details_ss"
            };
        });
    } else return null;
};
const personaPriceSort = (persona)=>{
    switch(persona){
        case "GST":
            return "guestPrice";
        case "CTR":
            return "ctrPrice";
        case "FF":
            return "ffPrice";
        case "KEMP":
            return "kemprPrice";
        case "TPR":
            return "tprPrice";
        case "TVR":
            return "tvrPrice";
        default:
            return "guestPrice";
    }
};

;// CONCATENATED MODULE: ./node_modules/react-zoom-pan-pinch/dist/index.esm.js


/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */
var roundNumber = function (num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */
var checkIsNumber = function (num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};

var handleCallback = function (context, event, callback) {
    if (callback && typeof callback === "function") {
        callback(context, event);
    }
};

/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */
var easeOut = function (t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var linear = function (t) {
    return t;
};
// accelerating from zero velocity
var easeInQuad = function (t) {
    return t * t;
};
// decelerating to zero velocity
var easeOutQuad = function (t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var easeInOutQuad = function (t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var easeInCubic = function (t) {
    return t * t * t;
};
// decelerating to zero velocity
var easeOutCubic = function (t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var easeInOutCubic = function (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var easeInQuart = function (t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuart = function (t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuart = function (t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var easeInQuint = function (t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuint = function (t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuint = function (t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var animations = {
    easeOut: easeOut,
    linear: linear,
    easeInQuad: easeInQuad,
    easeOutQuad: easeOutQuad,
    easeInOutQuad: easeInOutQuad,
    easeInCubic: easeInCubic,
    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
};

/* eslint-disable no-param-reassign */
var handleCancelAnimationFrame = function (animation) {
    if (typeof animation === "number") {
        cancelAnimationFrame(animation);
    }
};
var handleCancelAnimation = function (contextInstance) {
    if (!contextInstance.mounted)
        return;
    handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted)
        return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function () {
        if (!contextInstance.mounted) {
            return handleCancelAnimationFrame(contextInstance.animation);
        }
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        }
        else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) ||
        Number.isNaN(positionX) ||
        Number.isNaN(positionY)) {
        return false;
    }
    return true;
}
function animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid)
        return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) {
        setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    }
    else {
        // animation start timestamp
        handleSetupAnimation(contextInstance, animationName, animationTime, function (step) {
            var newScale = scale + scaleDiff * step;
            var newPositionX = positionX + positionXDiff * step;
            var newPositionY = positionY + positionYDiff * step;
            setTransformState(newScale, newPositionX, newPositionY);
        });
    }
}

/* eslint-disable no-param-reassign */
function getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight,
    };
}
var getBounds = function (wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth
        ? diffWidth * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight
        ? diffHeight * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return { minPositionX: minPositionX, maxPositionX: maxPositionX, minPositionY: minPositionY, maxPositionY: maxPositionY };
};
var calculateBounds = function (contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) {
        throw new Error("Components are not mounted");
    }
    var _a = getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */
var boundLimiter = function (value, minBound, maxBound, isActive) {
    if (!isActive)
        return roundNumber(value, 2);
    if (value < minBound)
        return roundNumber(minBound, 2);
    if (value > maxBound)
        return roundNumber(maxBound, 2);
    return roundNumber(value, 2);
};
var handleCalculateBounds = function (contextInstance, newScale) {
    var bounds = calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return { x: x, y: y };
}

function handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return { x: positionX, y: positionY };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale)
        return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding)
        return minScaleWithPadding;
    return zoom;
}

var isPanningStartAllowed = function (contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom
        ? event.composedPath().some(function (el) {
            if (!(el instanceof Element)) {
                return false;
            }
            return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
        })
        : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPanningAllowed = function (contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed)
        return false;
    return true;
};
var handlePanningSetup = function (contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = { x: x - positionX, y: y - positionY };
};
var handleTouchPanningSetup = function (contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = { x: x - positionX, y: y - positionY };
    }
};
function handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds)
        return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX
        ? wrapperComponent.offsetWidth
        : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY
        ? wrapperComponent.offsetHeight
        : contextInstance.setup.minPositionY || 0;
    var _d = handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY,
    };
}
function handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null ||
        bounds === null ||
        (newPositionX === positionX && newPositionY === positionY)) {
        return;
    }
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var getPanningClientPosition = function (contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) {
        return { x: positionX, y: positionY };
    }
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return { x: newPositionX, y: newPositionY };
};
var getPaddingValue = function (contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) {
        return size;
    }
    return 0;
};

var isVelocityCalculationAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    return true;
};
var isVelocityAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    if (!velocity || !bounds)
        return false;
    return true;
};
function getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) {
        return animationTime * velocity * sensitivity;
    }
    return animationTime;
}
function getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget)
                return maxTarget;
            if (calculatedPosition < maxPosition)
                return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget)
                return minTarget;
            if (calculatedPosition > minPosition)
                return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked)
        return startPosition;
    return boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}

function getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) {
        return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    }
    return defaultMultiplier;
}
function handleCalculateVelocity(contextInstance, position) {
    var isAllowed = isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) {
        return;
    }
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = { velocityX: velocityX, velocityY: velocityY, total: velocity };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) {
        return;
    }
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    var paddingX = (paddingValueX * wrapperComponent.offsetWidth) / 100;
    var paddingY = (paddingValueY * wrapperComponent.offsetHeight) / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function (step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) {
            contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
        }
    });
}

function handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    handleCancelAnimation(contextInstance);
    handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) {
        handleTouchPanningSetup(contextInstance, event);
    }
    else {
        handlePanningSetup(contextInstance, event);
    }
}
function handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || (!sizeX && !sizeY);
    if (isDisabled)
        return;
    var targetState = handlePanToBounds(contextInstance);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}
function handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords)
        return;
    var _b = getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    handleCalculateVelocity(contextInstance, { x: x, y: y });
    handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) {
            handleVelocityPanning(contextInstance);
        }
        else {
            handleAlignToBounds(contextInstance);
        }
    }
}

function handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = checkZoomBounds(roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var _b = handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return { scale: newScale, positionX: x, positionY: y };
}
function handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) {
        // fire fit to bounds animation
        handleAlignToBounds(contextInstance);
    }
    if (isDisabled || !wrapperComponent || !contextInstance.mounted)
        return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0,
};
var initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: [],
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: [],
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: [],
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: [],
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut",
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut",
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true,
    },
};
var baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component",
};

var createState = function (props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : initialState.positionY,
    };
};
var createSetup = function (props) {
    var newSetup = __assign({}, initialSetup);
    Object.keys(props).forEach(function (key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call(initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) {
                newSetup[key] = __assign(__assign({}, initialSetup[key]), props[key]);
            }
            else if (isArray) {
                newSetup[key] = __spreadArray(__spreadArray([], initialSetup[key], true), props[key], true);
            }
            else {
                newSetup[key] = props[key];
            }
        }
    });
    return newSetup;
};

var handleCalculateButtonZoom = function (contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = smooth
        ? scale * Math.exp(delta * step)
        : scale + delta * step;
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    animate(contextInstance, targetState, animationTime, animationType);
}
function resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return;
    var newBounds = calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y,
    };
    if (scale === initialTransformation.scale &&
        positionX === initialTransformation.positionX &&
        positionY === initialTransformation.positionY) {
        return;
    }
    onResetTransformation === null || onResetTransformation === void 0 ? void 0 : onResetTransformation();
    animate(contextInstance, newState, animationTime, animationType);
}
function getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale,
    };
}
function calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent)
        return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = calculateBounds(contextInstance, newScale);
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return { positionX: x, positionY: y, scale: newScale };
}

var zoomIn = function (contextInstance) {
    return function (step, animationTime, animationType) {
        if (step === void 0) { step = 0.5; }
        if (animationTime === void 0) { animationTime = 300; }
        if (animationType === void 0) { animationType = "easeOut"; }
        handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var zoomOut = function (contextInstance) {
    return function (step, animationTime, animationType) {
        if (step === void 0) { step = 0.5; }
        if (animationTime === void 0) { animationTime = 300; }
        if (animationType === void 0) { animationType = "easeOut"; }
        handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var setTransform = function (contextInstance) {
    return function (newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 300; }
        if (animationType === void 0) { animationType = "easeOut"; }
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent)
            return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale,
        };
        animate(contextInstance, targetState, animationTime, animationType);
    };
};
var resetTransform = function (contextInstance) {
    return function (animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 200; }
        if (animationType === void 0) { animationType = "easeOut"; }
        resetTransformations(contextInstance, animationTime, animationType);
    };
};
var centerView = function (contextInstance) {
    return function (scale, animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 200; }
        if (animationType === void 0) { animationType = "easeOut"; }
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = getCenterPosition(scale || transformState.scale, wrapperComponent, contentComponent);
            animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var zoomToElement = function (contextInstance) {
    return function (node, scale, animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 600; }
        if (animationType === void 0) { animationType = "easeOut"; }
        handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = calculateZoomToNode(contextInstance, target, scale);
            animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};

var getControls = function (contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: zoomIn(contextInstance),
        zoomOut: zoomOut(contextInstance),
        setTransform: setTransform(contextInstance),
        resetTransform: resetTransform(contextInstance),
        centerView: centerView(contextInstance),
        zoomToElement: zoomToElement(contextInstance),
    };
};
var getState = function (contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState,
    };
};
var getContext = function (contextInstance) {
    var ref = {};
    Object.assign(ref, getState(contextInstance));
    Object.assign(ref, getControls(contextInstance));
    return ref;
};

// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var passiveSupported = false;
function makePassiveEventOption() {
    try {
        var options = {
            get passive() {
                // This function will be called when the browser
                //   attempts to access the passive property.
                passiveSupported = true;
                return false;
            },
        };
        return options;
    }
    catch (err) {
        passiveSupported = false;
        return passiveSupported;
    }
}

var matchPrefix = ".".concat(baseClasses.wrapperClass);
var isExcludedNode = function (node, excluded) {
    return excluded.some(function (exclude) {
        return node.matches("".concat(matchPrefix, " ").concat(exclude, ", ").concat(matchPrefix, " .").concat(exclude, ", ").concat(matchPrefix, " ").concat(exclude, " *, ").concat(matchPrefix, " .").concat(exclude, " *"));
    });
};
var cancelTimeout = function (timeout) {
    if (timeout) {
        clearTimeout(timeout);
    }
};

var getTransformStyles = function (x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var getMatrixTransformStyles = function (x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var getCenterPosition = function (scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY,
    };
};

function index_esm_mergeRefs(refs) {
    return function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === "function") {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    };
}

var isWheelAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed)
        return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey)
        return false;
    if (touchPadDisabled && event.ctrlKey)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var getDeltaY = function (event) {
    if (event) {
        return event.deltaY < 0 ? 1 : -1;
    }
    return 0;
};
function getDelta(event, customDelta) {
    var deltaY = getDeltaY(event);
    var delta = checkIsNumber(customDelta, deltaY);
    return delta;
}
function getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    }
    else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY))
        console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY,
    };
}
var handleCalculateWheelZoom = function (contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = scale + delta * step;
    if (getTarget)
        return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var handleWheelZoomStop = function (contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent)
        return false;
    if (scale < maxScale || scale > minScale)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY)
        return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    return false;
};

var isPinchStartAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPinchAllowed = function (contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed)
        return false;
    return true;
};
var calculateTouchMidPoint = function (event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale,
    };
};
var getTouchDistance = function (event) {
    return Math.sqrt(Math.pow((event.touches[0].pageX - event.touches[1].pageX), 2) +
        Math.pow((event.touches[0].pageY - event.touches[1].pageY), 2));
};
var calculatePinchZoom = function (contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) {
        throw new Error("Pinch touches distance was not provided");
    }
    if (currentDistance < 0) {
        return contextInstance.transformState.scale;
    }
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return checkZoomBounds(roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};

var wheelStopEventTime = 160;
var wheelAnimationTime = 100;
var handleWheelStart = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        handleCancelAnimation(contextInstance);
        handleCallback(getContext(contextInstance), event, onWheelStart);
        handleCallback(getContext(contextInstance), event, onZoomStart);
    }
};
var handleWheelZoom = function (contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) {
        throw new Error("Component not mounted");
    }
    event.preventDefault();
    event.stopPropagation();
    var delta = getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale)
        return;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    handleCallback(getContext(contextInstance), event, onWheel);
    handleCallback(getContext(contextInstance), event, onZoom);
};
var handleWheelStop = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function () {
        if (!contextInstance.mounted)
            return;
        handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function () {
            if (!contextInstance.mounted)
                return;
            contextInstance.wheelStopEventTimer = null;
            handleCallback(getContext(contextInstance), event, onWheelStop);
            handleCallback(getContext(contextInstance), event, onZoomStop);
        }, wheelStopEventTime);
    }
};

var getTouchCenter = function (event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for (var i = 0; i < 2; i += 1) {
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return { x: x, y: y };
};
var handlePinchStart = function (contextInstance, event) {
    var distance = getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    handleCancelAnimation(contextInstance);
};
var handlePinchZoom = function (contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent)
        return;
    var midPoint = calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y))
        return;
    var currentDistance = getTouchDistance(event);
    var newScale = calculatePinchZoom(contextInstance, currentDistance);
    var center = getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0)
        return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var handlePinchStop = function (contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};

var handleDoubleClickStop = function (contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function () {
        contextInstance.doubleClickStopEventTimer = null;
        handleCallback(getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var handleDoubleClickResetMode = function (contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    handleCallback(getContext(contextInstance), event, onZoomStart);
    resetTransformations(contextInstance, animationTime, animationType, function () {
        return handleCallback(getContext(contextInstance), event, onZoom);
    });
    handleDoubleClickStop(contextInstance, event);
};
function getDoubleClickScale(mode, scale) {
    if (mode === "toggle") {
        return scale === 1 ? 1 : -1;
    }
    return mode === "zoomOut" ? -1 : 1;
}
function handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled)
        return;
    if (doubleClickStopEventTimer)
        return;
    if (mode === "reset") {
        return handleDoubleClickResetMode(contextInstance, event);
    }
    if (!contentComponent)
        return console.error("No ContentComponent found");
    var delta = getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale)
        return;
    handleCallback(getContext(contextInstance), event, onZoomStart);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var targetState = handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    handleCallback(getContext(contextInstance), event, onZoom);
    animate(contextInstance, targetState, animationTime, animationType);
    handleDoubleClickStop(contextInstance, event);
}
var isDoubleClickAllowed = function (contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};

var ZoomPanPinch = /** @class */ (function () {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function () {
            _this.initializeWindowEvents();
        };
        this.unmount = function () {
            _this.cleanupWindowEvents();
        };
        this.update = function (newProps) {
            _this.props = newProps;
            handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = createSetup(newProps);
        };
        this.initializeWindowEvents = function () {
            var _a, _b;
            var passive = makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 ? void 0 : _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function () {
            var _a, _b;
            var passive = makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 ? void 0 : _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function (wrapper) {
            // Zooming events on wrapper
            var passive = makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function (contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function (callback) { return callback(getContext(_this)); });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function () {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function (callback) {
                            return callback(getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function () {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isWheelAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed)
                return;
            handleWheelStart(_this, event);
            handleWheelZoom(_this, event);
            handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function (event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent ||
                !_this.contentComponent ||
                disabled ||
                !wheel.wheelDisabled ||
                panning.disabled ||
                !panning.wheelPanning ||
                event.ctrlKey) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = getPaddingValue(_this, sizeX);
            var paddingValueY = getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY)
                return;
            handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan)
                return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan)
                return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan)
                return;
            event.preventDefault();
            event.stopPropagation();
            handleCancelAnimation(_this);
            handlePanningStart(_this, event);
            handleCallback(getContext(_this), event, onPanningStart);
        };
        this.onPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled)
                return;
            var isAllowed = isPanningAllowed(_this);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePanning(_this, event.clientX, event.clientY);
            handleCallback(getContext(_this), event, onPanning);
        };
        this.onPanningStop = function (event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                handlePanningEnd(_this);
                handleCallback(getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled)
                return;
            var isAllowed = isPinchStartAllowed(_this, event);
            if (!isAllowed)
                return;
            handlePinchStart(_this, event);
            handleCancelAnimation(_this);
            handleCallback(getContext(_this), event, onPinchingStart);
            handleCallback(getContext(_this), event, onZoomStart);
        };
        this.onPinch = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled)
                return;
            var isAllowed = isPinchAllowed(_this);
            if (!isAllowed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePinchZoom(_this, event);
            handleCallback(getContext(_this), event, onPinching);
            handleCallback(getContext(_this), event, onZoom);
        };
        this.onPinchStop = function (event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                handlePinchStop(_this);
                handleCallback(getContext(_this), event, onPinchingStop);
                handleCallback(getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) {
                _this.onDoubleClick(event);
            }
            else {
                _this.lastTouch = +new Date();
                handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    handleCancelAnimation(_this);
                    handlePanningStart(_this, event);
                    handleCallback(getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) {
                    _this.onPinchStart(event);
                }
            }
        };
        this.onTouchPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled)
                    return;
                var isAllowed = isPanningAllowed(_this);
                if (!isAllowed)
                    return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                handlePanning(_this, touch.clientX, touch.clientY);
                handleCallback(getContext(_this), event, onPanning);
            }
            else if (event.touches.length > 1) {
                _this.onPinch(event);
            }
        };
        this.onTouchPanningStop = function (event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isDoubleClickAllowed(_this, event);
            if (!isAllowed)
                return;
            handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function (event) {
            if (_this.isPanning) {
                _this.onPanningStop(event);
            }
        };
        this.setKeyPressed = function (e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function (e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function (keys) {
            if (!keys.length) {
                return true;
            }
            return Boolean(keys.find(function (key) { return _this.pressedKeys[key]; }));
        };
        this.setTransformState = function (scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) &&
                !Number.isNaN(positionX) &&
                !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = getContext(_this);
                _this.onChangeCallbacks.forEach(function (callback) { return callback(ctx_1); });
                handleCallback(ctx_1, { scale: scale, positionX: positionX, positionY: positionY }, onTransformed);
            }
            else {
                console.error("Detected NaN set state values");
            }
        };
        this.setCenter = function () {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = getCenterPosition(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function (x, y, scale) {
            if (_this.props.customTransform) {
                return _this.props.customTransform(x, y, scale);
            }
            return getTransformStyles(x, y, scale);
        };
        this.applyTransformation = function () {
            if (!_this.mounted || !_this.contentComponent)
                return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function () {
            return getContext(_this);
        };
        /**
         * Hooks
         */
        this.onChange = function (callback) {
            if (!_this.onChangeCallbacks.has(callback)) {
                _this.onChangeCallbacks.add(callback);
            }
            return function () {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function (callback) {
            if (!_this.onInitCallbacks.has(callback)) {
                _this.onInitCallbacks.add(callback);
            }
            return function () {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */
        this.init = function (wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = getContext(_this);
            handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = createSetup(this.props);
        this.transformState = createState(this.props);
    }
    return ZoomPanPinch;
}());

var index_esm_Context = react.createContext(null);
var getContent = function (children, ctx) {
    if (typeof children === "function") {
        return children(ctx);
    }
    return children;
};
var TransformWrapper = react.forwardRef(function (props, ref) {
    var instance = (0,react.useRef)(new ZoomPanPinch(props)).current;
    var content = getContent(props.children, getControls(instance));
    (0,react.useImperativeHandle)(ref, function () { return getControls(instance); }, [instance]);
    (0,react.useEffect)(function () {
        instance.update(props);
    }, [instance, props]);
    return react.createElement(index_esm_Context.Provider, { value: instance }, content);
});

var KeepScale = react.forwardRef(function (props, ref) {
    var localRef = (0,react.useRef)(null);
    var instance = (0,react.useContext)(index_esm_Context);
    (0,react.useEffect)(function () {
        return instance.onChange(function (ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [instance]);
    return react.createElement("div", __assign({}, props, { ref: index_esm_mergeRefs([localRef, ref]) }));
});

var initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
};
var useResize = function (ref, onResize, dependencies) {
    var resizeObserverRef = useRef();
    var rectRef = useRef(initialElementRect);
    var didUnmount = useRef(false);
    useLayoutEffect(function () {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) {
            return;
        }
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function (entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) ||
                    !entries.length ||
                    didUnmount.current ||
                    (newSize.width === rectRef.current.width &&
                        newSize.height === rectRef.current.height))
                    return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.observe(ref);
        }
        return function () {
            var _a;
            didUnmount.current = true;
            if (ref) {
                (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.unobserve(ref);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArray([onResize, ref], dependencies, true));
};

var previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px",
};
var MiniMap = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = __rest(_a, ["width", "height", "borderColor", "children"]);
    var _e = useState(false), initialized = _e[0], setInitialized = _e[1];
    var instance = useTransformContext();
    var miniMapInstance = useRef(null);
    var mainRef = useRef(null);
    var wrapperRef = useRef(null);
    var previewRef = useRef(null);
    var getViewportSize = useCallback(function () {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [instance.wrapperComponent]);
    var getContentSize = useCallback(function () {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale,
            };
        }
        return {
            width: 0,
            height: 0,
        };
    }, [instance.contentComponent, instance.transformState.scale]);
    var computeMiniMapScale = useCallback(function () {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [getContentSize, height, width]);
    var computeMiniMapSize = function () {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) {
            return { width: width, height: contentSize.height * scaleX };
        }
        return { width: contentSize.width * scaleY, height: height };
    };
    var computeMiniMapStyle = function () {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden",
        };
        Object.keys(style).forEach(function (key) {
            if (wrapperRef.current) {
                wrapperRef.current.style[key] = style[key];
            }
        });
    };
    var transformMiniMap = function () {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function () {
        transformMiniMap();
    };
    useTransformEffect(function () {
        transformMiniMap();
    });
    useTransformInit(function () {
        initialize();
        setInitialized(true);
    });
    useResize(instance.contentComponent, initialize, [initialized]);
    useEffect(function () {
        return instance.onChange(function (zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale =
                    zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX =
                    zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY =
                    zpp.instance.transformState.positionY * scale;
            }
        });
    }, [computeMiniMapScale, instance, miniMapInstance]);
    var wrapperStyle = useMemo(function () {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden",
        };
    }, []);
    return (React.createElement("div", __assign({}, rest, { ref: mainRef, style: wrapperStyle, className: "rzpp-mini-map ".concat(rest.className || "") }),
        React.createElement("div", __assign({}, rest, { ref: wrapperRef, className: "rzpp-wrapper" }), children),
        React.createElement("div", { className: "rzpp-preview", ref: previewRef, style: __assign(__assign({}, previewStyles), { borderColor: borderColor }) })));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var styles = {"wrapper":"transform-component-module_wrapper__SPB86","content":"transform-component-module_content__FBWxo"};
styleInject(css_248z);

var TransformComponent = function (_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0,react.useContext)(index_esm_Context), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) {
            init === null || init === void 0 ? void 0 : init(wrapper, content);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function () {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 ? void 0 : cleanupWindowEvents();
        };
    }, []);
    return (react.createElement("div", __assign({}, wrapperProps, { ref: wrapperRef, className: "".concat(baseClasses.wrapperClass, " ").concat(styles.wrapper, " ").concat(wrapperClass), style: wrapperStyle }),
        react.createElement("div", __assign({}, contentProps, { ref: contentRef, className: "".concat(baseClasses.contentClass, " ").concat(styles.content, " ").concat(contentClass), style: contentStyle }), children)));
};

var useTransformContext = function () {
    var libraryContext = useContext(index_esm_Context);
    if (!libraryContext) {
        throw new Error("Transform context must be placed inside TransformWrapper");
    }
    return libraryContext;
};

var useControls = function () {
    var libraryContext = useTransformContext();
    return getControls(libraryContext);
};

var useTransformInit = function (callback) {
    var libraryContext = useTransformContext();
    useEffect(function () {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) {
            unmountCallback = callback(getState(libraryContext));
        }
        else {
            unmount = libraryContext.onInit(function (ref) {
                unmountCallback = callback(getState(ref.instance));
            });
        }
        return function () {
            unmount === null || unmount === void 0 ? void 0 : unmount();
            unmountCallback === null || unmountCallback === void 0 ? void 0 : unmountCallback();
        };
    }, []);
};

var useTransformEffect = function (callback) {
    var libraryContext = useTransformContext();
    useEffect(function () {
        var unmountCallback;
        var unmount = libraryContext.onChange(function (ref) {
            unmountCallback = callback(getState(ref.instance));
        });
        return function () {
            unmount();
            unmountCallback === null || unmountCallback === void 0 ? void 0 : unmountCallback();
        };
    }, [callback, libraryContext]);
};

function useTransformComponent(callback) {
    var libraryContext = useTransformContext();
    var _a = useState(callback(getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    useEffect(function () {
        var mounted = true;
        var unmount = libraryContext.onChange(function (ref) {
            if (mounted) {
                setTransformRender(callback(getState(ref.instance)));
            }
        });
        return function () {
            unmount();
            mounted = false;
        };
    }, [callback, libraryContext]);
    return transformRender;
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./components/core/Conditional/Conditional.js
const Conditional = (props)=>{
    const { show , children  } = props;
    return show ? children : null;
};
/* harmony default export */ var Conditional_Conditional = (Conditional);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/PopModal/index.js




const PopModal = (props)=>{
    var ref, ref1;
    const { position , setMessage , scale  } = props;
    const { isMobile  } = (0,useViewport/* default */.Z)();
    const { left , top , textWidth , textBounds , textHeight  } = position;
    const normalizeDynamic = isMobile ? 3 : 6;
    const normalizeStatic = isMobile ? 4 : 7;
    const normalizedfactor = normalizeStatic + normalizeDynamic / scale;
    const popUpHeight = 114;
    const popUpWidth = 237;
    const wrapperTop = ((ref1 = (ref = document === null || document === void 0 ? void 0 : document.querySelector(".react-transform-wrapper")) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top) || 0;
    const textTop = textBounds === null || textBounds === void 0 ? void 0 : textBounds.top;
    const gap = textTop - wrapperTop;
    const leftStyle = left - popUpWidth / 2 + textWidth / 2;
    const nTop = top - textHeight / 2 + normalizeStatic / 2;
    const topStyle = gap > popUpHeight ? "".concat(nTop - (popUpHeight + normalizedfactor), "px") : "".concat(nTop + normalizedfactor, "px");
    const scaleTransform = "scale(".concat(1 / scale, ")");
    const scaleOrigin = gap > popUpHeight ? "bottom" : "top";
    const stylePosition = {
        left: "".concat(leftStyle, "px"),
        height: "".concat(popUpHeight, "px"),
        top: topStyle,
        transform: scaleTransform,
        transformOrigin: scaleOrigin
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-window",
            style: stylePosition,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-popups",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-notfound",
                            children: "PART NOT FOUND"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button-close",
                            "data-testid": "part-not-found-close",
                            onClick: ()=>setMessage(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "content-popups",
                    children: "Please contact our customer service team"
                })
            ]
        })
    });
};
/* harmony default export */ var PartsDiagramViewer_PopModal = (PopModal);

;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMounted.js


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted_useMounted() {
  const mounted = (0,react.useRef)(true);
  const isMounted = (0,react.useRef)(() => mounted.current);
  (0,react.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js




/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */
const MAX_DELAY_MS = 2 ** 31 - 1;
function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  const delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(() => setChainedTimeout(handleRef, fn, timeoutAtMs), MAX_DELAY_MS);
}

/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */
function useTimeout() {
  const isMounted = useMounted_useMounted();

  // types are confused between node and web here IDK
  const handleRef = (0,react.useRef)();
  useWillUnmount(() => clearTimeout(handleRef.current));
  return (0,react.useMemo)(() => {
    const clear = () => clearTimeout(handleRef.current);
    function set(fn, delayMs = 0) {
      if (!isMounted()) return;
      clear();
      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }
    return {
      set,
      clear,
      handleRef
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(41143);
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/utils.js


var utils_noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = utils_noop;

    if (false) { var handler; }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/hook.js



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = (0,react.useRef)(propValue !== undefined);

  var _useState = (0,react.useState)(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, (0,react.useCallback)(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return (0,esm_extends/* default */.Z)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function react_lifecycles_compat_es_polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/uncontrollable.js



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = Utils.canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? 0 : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: _extends(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[Utils.defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: _extends(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
          nextState.values[key] = props[Utils.defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutPropertiesLoose(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return React.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(React.Component);

  polyfill(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (React.forwardRef) {
    WrappedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useCallbackRef.js


/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */
function useCallbackRef_useCallbackRef() {
  return (0,react.useState)(null);
}
;// CONCATENATED MODULE: ./node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useSafeState.js



/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */

function useSafeState(state) {
  const isMounted = useMounted();
  return [state[0], (0,react.useCallback)(nextState => {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}
/* harmony default export */ var esm_useSafeState = (useSafeState);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js
var arrow = __webpack_require__(66896);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var computeStyles = __webpack_require__(36531);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var eventListeners = __webpack_require__(82372);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js + 3 modules
var flip = __webpack_require__(68855);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js
var hide = __webpack_require__(19892);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js
var offset = __webpack_require__(82122);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
var popperOffsets = __webpack_require__(77421);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js + 1 modules
var preventOverflow = __webpack_require__(394);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/createPopper.js + 6 modules
var createPopper = __webpack_require__(45704);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/popper.js











// For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment
const popper_createPopper = (0,createPopper/* popperGenerator */.kZ)({
  defaultModifiers: [hide/* default */.Z, popperOffsets/* default */.Z, computeStyles/* default */.Z, eventListeners/* default */.Z, offset/* default */.Z, flip/* default */.Z, preventOverflow/* default */.Z, arrow/* default */.Z]
});

;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/usePopper.js
const usePopper_excluded = ["enabled", "placement", "strategy", "modifiers"];
function usePopper_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }




const disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false,
  phase: 'afterWrite',
  fn: () => undefined
};

// until docjs supports type exports...

const ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: ({
    state
  }) => () => {
    const {
      reference,
      popper
    } = state.elements;
    if ('removeAttribute' in reference) {
      const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(id => id.trim() !== popper.id);
      if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
    }
  },
  fn: ({
    state
  }) => {
    var _popper$getAttribute;
    const {
      popper,
      reference
    } = state.elements;
    const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      const ids = reference.getAttribute('aria-describedby');
      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }
      reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
    }
  }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */
function usePopper(referenceElement, popperElement, _ref = {}) {
  let {
      enabled = true,
      placement = 'bottom',
      strategy = 'absolute',
      modifiers = EMPTY_MODIFIERS
    } = _ref,
    config = usePopper_objectWithoutPropertiesLoose(_ref, usePopper_excluded);
  const prevModifiers = (0,react.useRef)(modifiers);
  const popperInstanceRef = (0,react.useRef)();
  const update = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu;
    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  const forceUpdate = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu2;
    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);
  const [popperState, setState] = esm_useSafeState((0,react.useState)({
    placement,
    update,
    forceUpdate,
    attributes: {},
    styles: {
      popper: {},
      arrow: {}
    }
  }));
  const updateModifier = (0,react.useMemo)(() => ({
    name: 'updateStateModifier',
    enabled: true,
    phase: 'write',
    requires: ['computeStyles'],
    fn: ({
      state
    }) => {
      const styles = {};
      const attributes = {};
      Object.keys(state.elements).forEach(element => {
        styles[element] = state.styles[element];
        attributes[element] = state.attributes[element];
      });
      setState({
        state,
        styles,
        attributes,
        update,
        forceUpdate,
        placement: state.placement
      });
    }
  }), [update, forceUpdate, setState]);
  const nextModifiers = (0,react.useMemo)(() => {
    if (!dequal(prevModifiers.current, modifiers)) {
      prevModifiers.current = modifiers;
    }
    return prevModifiers.current;
  }, [modifiers]);
  (0,react.useEffect)(() => {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement,
      strategy,
      modifiers: [...nextModifiers, updateModifier, disabledApplyStylesModifier]
    });
  }, [strategy, placement, updateModifier, enabled, nextModifiers]);
  (0,react.useEffect)(() => {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }
    popperInstanceRef.current = popper_createPopper(referenceElement, popperElement, Object.assign({}, config, {
      placement,
      strategy,
      modifiers: [...nextModifiers, ariaDescribedByModifier, updateModifier]
    }));
    return () => {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(s => Object.assign({}, s, {
          attributes: {},
          styles: {
            popper: {}
          }
        }));
      }
    };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}
/* harmony default export */ var esm_usePopper = (usePopper);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useClickOutside.js






const useClickOutside_noop = () => {};
function isLeftClickEvent(event) {
  return event.button === 0;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = ref => ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
  click: 'mousedown',
  mouseup: 'mousedown',
  pointerup: 'pointerdown'
};

/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useClickOutside(ref, onClickOutside = useClickOutside_noop, {
  disabled,
  clickTrigger = 'click'
} = {}) {
  const preventMouseClickOutsideRef = (0,react.useRef)(false);
  const waitingForTrigger = (0,react.useRef)(false);
  const handleMouseCapture = (0,react.useCallback)(e => {
    const currentTarget = getRefTarget(ref);
    warning_default()(!!currentTarget, 'ClickOutside captured a close event but does not have a ref to compare it to. ' + 'useClickOutside(), should be passed a ref that resolves to a DOM node');
    preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains(currentTarget, e.target) || waitingForTrigger.current;
    waitingForTrigger.current = false;
  }, [ref]);
  const handleInitialMouse = esm_useEventCallback_useEventCallback(e => {
    const currentTarget = getRefTarget(ref);
    if (currentTarget && contains(currentTarget, e.target)) {
      waitingForTrigger.current = true;
    } else {
      // When clicking on scrollbars within current target, click events are not triggered, so this ref
      // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
      // to close the overlay.
      waitingForTrigger.current = false;
    }
  });
  const handleMouse = esm_useEventCallback_useEventCallback(e => {
    if (!preventMouseClickOutsideRef.current) {
      onClickOutside(e);
    }
  });
  (0,react.useEffect)(() => {
    var _ownerWindow$event, _ownerWindow$parent;
    if (disabled || ref == null) return undefined;
    const doc = ownerDocument(getRefTarget(ref));
    const ownerWindow = doc.defaultView || window;

    // Store the current event to avoid triggering handlers immediately
    // For things rendered in an iframe, the event might originate on the parent window
    // so we should fall back to that global event if the local one doesn't exist
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
    let removeInitialTriggerListener = null;
    if (InitialTriggerEvents[clickTrigger]) {
      removeInitialTriggerListener = esm_listen(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
    }

    // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.
    const removeMouseCaptureListener = esm_listen(doc, clickTrigger, handleMouseCapture, true);
    const removeMouseListener = esm_listen(doc, clickTrigger, e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleMouse(e);
    });
    let mobileSafariHackListeners = [];
    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(el => esm_listen(el, 'mousemove', useClickOutside_noop));
    }
    return () => {
      removeInitialTriggerListener == null ? void 0 : removeInitialTriggerListener();
      removeMouseCaptureListener();
      removeMouseListener();
      mobileSafariHackListeners.forEach(remove => remove());
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleInitialMouse, handleMouse]);
}
/* harmony default export */ var esm_useClickOutside = (useClickOutside);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useRootClose.js






const useRootClose_noop = () => {};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, {
  disabled,
  clickTrigger
} = {}) {
  const onClose = onRootClose || useRootClose_noop;
  esm_useClickOutside(ref, onClose, {
    disabled,
    clickTrigger
  });
  const handleKeyUp = esm_useEventCallback_useEventCallback(e => {
    if (isEscKey(e)) {
      onClose(e);
    }
  });
  (0,react.useEffect)(() => {
    if (disabled || ref == null) return undefined;
    const doc = ownerDocument(getRefTarget(ref));

    // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (doc.defaultView || window).event;
    const removeKeyupListener = esm_listen(doc, 'keyup', e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleKeyUp(e);
    });
    return () => {
      removeKeyupListener();
    };
  }, [ref, disabled, handleKeyUp]);
}
/* harmony default export */ var esm_useRootClose = (useRootClose);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/mergeOptionsWithPopperConfig.js
function toModifierMap(modifiers) {
  const result = {};
  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  }

  // eslint-disable-next-line no-unused-expressions
  modifiers == null ? void 0 : modifiers.forEach(m => {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map = {}) {
  if (Array.isArray(map)) return map;
  return Object.keys(map).map(k => {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig({
  enabled,
  enableEvents,
  placement,
  flip,
  offset,
  fixed,
  containerPadding,
  arrowElement,
  popperConfig = {}
}) {
  var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
  const modifiers = toModifierMap(popperConfig.modifiers);
  return Object.assign({}, popperConfig, {
    placement,
    enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(Object.assign({}, modifiers, {
      eventListeners: {
        enabled: enableEvents,
        options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
      },
      preventOverflow: Object.assign({}, modifiers.preventOverflow, {
        options: containerPadding ? Object.assign({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: Object.assign({
          offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: Object.assign({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: Object.assign({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Overlay.js










/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
const Overlay = /*#__PURE__*/react.forwardRef((props, outerRef) => {
  const {
    flip,
    offset,
    placement,
    containerPadding,
    popperConfig = {},
    transition: Transition,
    runTransition
  } = props;
  const [rootElement, attachRef] = useCallbackRef_useCallbackRef();
  const [arrowElement, attachArrowRef] = useCallbackRef_useCallbackRef();
  const mergedRef = hooks_esm_useMergedRefs(attachRef, outerRef);
  const container = useWaitForDOMRef(props.container);
  const target = useWaitForDOMRef(props.target);
  const [exited, setExited] = (0,react.useState)(!props.show);
  const popper = esm_usePopper(target, rootElement, mergeOptionsWithPopperConfig({
    placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip,
    offset,
    arrowElement,
    popperConfig
  }));

  // TODO: I think this needs to be in an effect
  if (props.show && exited) {
    setExited(false);
  }
  const handleHidden = (...args) => {
    setExited(true);
    if (props.onExited) {
      props.onExited(...args);
    }
  };

  // Don't un-render the overlay while it's transitioning out.
  const mountOverlay = props.show || !exited;
  esm_useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });
  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }
  const {
    onExit,
    onExiting,
    onEnter,
    onEntering,
    onEntered
  } = props;
  let child = props.children(Object.assign({}, popper.attributes.popper, {
    style: popper.styles.popper,
    ref: mergedRef
  }), {
    popper,
    placement,
    show: !!props.show,
    arrowProps: Object.assign({}, popper.attributes.arrow, {
      style: popper.styles.arrow,
      ref: attachArrowRef
    })
  });
  child = renderTransition(Transition, runTransition, {
    in: !!props.show,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    children: child,
    onExit,
    onExiting,
    onExited: handleHidden,
    onEnter,
    onEntering,
    onEntered
  });
  return container ? /*#__PURE__*/react_dom.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
/* harmony default export */ var esm_Overlay = (Overlay);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useIsomorphicEffect.js

const useIsomorphicEffect_isReactNative = typeof __webpack_require__.g !== 'undefined' &&
// @ts-ignore
__webpack_require__.g.navigator &&
// @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
const useIsomorphicEffect_isDOM = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
/* harmony default export */ var esm_useIsomorphicEffect = (useIsomorphicEffect_isDOM || useIsomorphicEffect_isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PopoverHeader.js
"use client";





const PopoverHeader = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
PopoverHeader.displayName = 'PopoverHeader';
/* harmony default export */ var esm_PopoverHeader = (PopoverHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PopoverBody.js
"use client";





const PopoverBody = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-body');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
PopoverBody.displayName = 'PopoverBody';
/* harmony default export */ var esm_PopoverBody = (PopoverBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/helpers.js

class BsPrefixComponent extends react.Component {}

// Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;
  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }
  return bsDirection;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/getInitialPopperStyles.js
function getInitialPopperStyles(position = 'absolute') {
  return {
    position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Popover.js
"use client";










const Popover = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement = 'right',
  className,
  style,
  children,
  body,
  arrowProps,
  hasDoneInitialMeasure,
  popper,
  show,
  ...props
}, ref) => {
  const decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'popover');
  const isRTL = useIsRTL();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  let computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = {
      ...style,
      ...getInitialPopperStyles(popper == null ? void 0 : popper.strategy)
    };
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    role: "tooltip",
    style: computedStyle,
    "x-placement": primaryPlacement,
    className: classnames_default()(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "popover-arrow",
      ...arrowProps
    }), body ? /*#__PURE__*/(0,jsx_runtime.jsx)(esm_PopoverBody, {
      children: children
    }) : children]
  });
});
Popover.displayName = 'Popover';
/* harmony default export */ var esm_Popover = (Object.assign(Popover, {
  Header: esm_PopoverHeader,
  Body: esm_PopoverBody,
  // Default popover offset.
  // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
  POPPER_OFFSET: [0, 8]
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
"use client";








const Tooltip = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement = 'right',
  className,
  style,
  children,
  arrowProps,
  hasDoneInitialMeasure,
  popper,
  show,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tooltip');
  const isRTL = useIsRTL();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  let computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = {
      ...style,
      ...getInitialPopperStyles(popper == null ? void 0 : popper.strategy)
    };
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    style: computedStyle,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames_default()(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.displayName = 'Tooltip';
/* harmony default export */ var esm_Tooltip = (Object.assign(Tooltip, {
  // Default tooltip offset.
  // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
  TOOLTIP_OFFSET: [0, 6]
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/useOverlayOffset.js
"use client";







// This is meant for internal use.
// This applies a custom offset to the overlay if it's a popover or tooltip.
function useOverlayOffset(customOffset) {
  const overlayRef = (0,react.useRef)(null);
  const popoverClass = useBootstrapPrefix(undefined, 'popover');
  const tooltipClass = useBootstrapPrefix(undefined, 'tooltip');
  const offset = (0,react.useMemo)(() => ({
    name: 'offset',
    options: {
      offset: () => {
        if (customOffset) {
          return customOffset;
        }
        if (overlayRef.current) {
          if (hasClass(overlayRef.current, popoverClass)) {
            return esm_Popover.POPPER_OFFSET;
          }
          if (hasClass(overlayRef.current, tooltipClass)) {
            return esm_Tooltip.TOOLTIP_OFFSET;
          }
        }
        return [0, 0];
      }
    }
  }), [customOffset, popoverClass, tooltipClass]);
  return [overlayRef, [offset]];
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Overlay.js
"use client";












function wrapRefs(props, arrowProps) {
  const {
    ref
  } = props;
  const {
    ref: aRef
  } = arrowProps;
  props.ref = ref.__wrapped || (ref.__wrapped = r => ref(safeFindDOMNode(r)));
  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = r => aRef(safeFindDOMNode(r)));
}
const Overlay_Overlay = /*#__PURE__*/react.forwardRef(({
  children: overlay,
  transition = esm_Fade,
  popperConfig = {},
  rootClose = false,
  placement = 'top',
  show: outerShow = false,
  ...outerProps
}, outerRef) => {
  const popperRef = (0,react.useRef)({});
  const [firstRenderedState, setFirstRenderedState] = (0,react.useState)(null);
  const [ref, modifiers] = useOverlayOffset(outerProps.offset);
  const mergedRef = esm_useMergedRefs(outerRef, ref);
  const actualTransition = transition === true ? esm_Fade : transition || undefined;
  const handleFirstUpdate = useEventCallback_useEventCallback(state => {
    setFirstRenderedState(state);
    popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
  });
  esm_useIsomorphicEffect(() => {
    if (firstRenderedState && outerProps.target) {
      // Must wait for target element to resolve before updating popper.
      popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }
  }, [firstRenderedState, outerProps.target]);
  (0,react.useEffect)(() => {
    if (!outerShow) {
      setFirstRenderedState(null);
    }
  }, [outerShow]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Overlay, {
    ...outerProps,
    ref: mergedRef,
    popperConfig: {
      ...popperConfig,
      modifiers: modifiers.concat(popperConfig.modifiers || []),
      onFirstUpdate: handleFirstUpdate
    },
    transition: actualTransition,
    rootClose: rootClose,
    placement: placement,
    show: outerShow,
    children: (overlayProps, {
      arrowProps,
      popper: popperObj,
      show
    }) => {
      var _popperObj$state;
      wrapRefs(overlayProps, arrowProps);
      // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
      const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
      const popper = Object.assign(popperRef.current, {
        state: popperObj == null ? void 0 : popperObj.state,
        scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
        placement: updatedPlacement,
        outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
        strategy: popperConfig.strategy
      });
      const hasDoneInitialMeasure = !!firstRenderedState;
      if (typeof overlay === 'function') return overlay({
        ...overlayProps,
        placement: updatedPlacement,
        show,
        ...(!transition && show && {
          className: 'show'
        }),
        popper,
        arrowProps,
        hasDoneInitialMeasure
      });
      return /*#__PURE__*/react.cloneElement(overlay, {
        ...overlayProps,
        placement: updatedPlacement,
        arrowProps,
        popper,
        hasDoneInitialMeasure,
        className: classnames_default()(overlay.props.className, !transition && show && 'show'),
        style: {
          ...overlay.props.style,
          ...overlayProps.style
        }
      });
    }
  });
});
Overlay_Overlay.displayName = 'Overlay';
/* harmony default export */ var react_bootstrap_esm_Overlay = (Overlay_Overlay);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js
"use client";















function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
}

// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function handleMouseOverOut(handler, args, relatedNative) {
  const [e] = args;
  const target = e.currentTarget;
  const related = e.relatedTarget || e.nativeEvent[relatedNative];
  if ((!related || related !== target) && !contains(target, related)) {
    handler(...args);
  }
}
const triggerType = prop_types_default().oneOf(['click', 'hover', 'focus']);
const OverlayTrigger = ({
  trigger = ['hover', 'focus'],
  overlay,
  children,
  popperConfig = {},
  show: propsShow,
  defaultShow = false,
  onToggle,
  delay: propsDelay,
  placement,
  flip = placement && placement.indexOf('auto') !== -1,
  ...props
}) => {
  const triggerNodeRef = (0,react.useRef)(null);
  const mergedRef = esm_useMergedRefs(triggerNodeRef, getChildRef(children));
  const timeout = useTimeout();
  const hoverStateRef = (0,react.useRef)('');
  const [show, setShow] = useUncontrolledProp(propsShow, defaultShow, onToggle);
  const delay = normalizeDelay(propsDelay);
  const {
    onFocus,
    onBlur,
    onClick
  } = typeof children !== 'function' ? react.Children.only(children).props : {};
  const attachRef = r => {
    mergedRef(safeFindDOMNode(r));
  };
  const handleShow = (0,react.useCallback)(() => {
    timeout.clear();
    hoverStateRef.current = 'show';
    if (!delay.show) {
      setShow(true);
      return;
    }
    timeout.set(() => {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  const handleHide = (0,react.useCallback)(() => {
    timeout.clear();
    hoverStateRef.current = 'hide';
    if (!delay.hide) {
      setShow(false);
      return;
    }
    timeout.set(() => {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  const handleFocus = (0,react.useCallback)((...args) => {
    handleShow();
    onFocus == null || onFocus(...args);
  }, [handleShow, onFocus]);
  const handleBlur = (0,react.useCallback)((...args) => {
    handleHide();
    onBlur == null || onBlur(...args);
  }, [handleHide, onBlur]);
  const handleClick = (0,react.useCallback)((...args) => {
    setShow(!show);
    onClick == null || onClick(...args);
  }, [onClick, setShow, show]);
  const handleMouseOver = (0,react.useCallback)((...args) => {
    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  const handleMouseOut = (0,react.useCallback)((...args) => {
    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  const triggers = trigger == null ? [] : [].concat(trigger);
  const triggerProps = {
    ref: attachRef
  };
  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }
  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }
  if (triggers.indexOf('hover') !== -1) {
     false ? 0 : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/(0,react.cloneElement)(children, triggerProps), /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Overlay, {
      ...props,
      show: show,
      onHide: handleHide,
      flip: flip,
      placement: placement,
      popperConfig: popperConfig,
      target: triggerNodeRef.current,
      children: overlay
    })]
  });
};
/* harmony default export */ var esm_OverlayTrigger = (OverlayTrigger);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ToolTip/index.js



const ToolTip = (props)=>{
    const { children , text ="No text" , placement ="left" , show =true  } = props;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_OverlayTrigger, {
        placement: placement,
        overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tooltip, {
            className: "bg-color",
            children: text
        }),
        delay: {
            show: 0,
            hide: 0
        },
        children: children
    }, placement) : children;
};
/* harmony default export */ var v2_ToolTip = (ToolTip);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/PartsControls/index.js








const PartsControls = (props)=>{
    const { zoomIn , zoomOut , expandHandler , fullscreen , scale , initScale , centerView , setMessage , siteName  } = props || {};
    const device = (0,useViewport/* default */.Z)();
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    const inMargin = (value, expected, margin)=>expected - margin < value && value < expected + margin;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { exitFullScreenText , fullScreenText  } = (0,localization/* getTranslations */.F)(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "viewer-controls ".concat(isDesktop ? "position-absolute" : "position-fixed mobile-controls"),
        children: [
            fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach_Coach, {
                text: exitFullScreenText,
                displayKey: "bottom",
                hide: false,
                siteName: siteName
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: ()=>{
                    expandHandler();
                    setMessage(false);
                },
                className: "btn-expand",
                "data-testid": "parts-fullscreen",
                children: [
                    fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconCollapse */.bt, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconExpand */.qp, {}),
                    isDesktop && !fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tool-tip-custom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                !fullscreen ? fullScreenText : ""
                            ]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ToolTip, {
                text: "Reset",
                show: isDesktop ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "".concat(inMargin(scale, initScale, 0.05) ? "" : "acitve"),
                    onClick: ()=>{
                        centerView(initScale);
                    },
                    "data-testid": "parts-center",
                    children: inMargin(scale, initScale, 0.05) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconReset */.uN, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ResetActive */.iK, {})
                })
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ToolTip, {
                text: "Zoom",
                show: isDesktop ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "groups-buttons",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                zoomIn();
                            },
                            "data-testid": "parts-zoomin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconZoomIn */.WM, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                zoomOut();
                            },
                            "data-testid": "parts-zoomout",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconZoomOut */.DS, {})
                        })
                    ]
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var PartsDiagramViewer_PartsControls = (PartsControls);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/interactiveSvg.js
const createInteractiveSVGElement = (svgText, actions)=>{
    var ref, ref1, ref2;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = svgText;
    const svg = (ref = wrapper.getElementsByTagName("svg")) === null || ref === void 0 ? void 0 : ref[0];
    const groupNodeList = svg.querySelectorAll("g");
    const groupList = (ref1 = [
        ...groupNodeList
    ]) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>item.getAttribute("itedo:apstype") === "Part");
    groupList.forEach((item)=>{
        mutateGroupText(item);
    });
    const textNodeList = svg.querySelectorAll("text");
    const itemList = (ref2 = [
        ...textNodeList
    ]) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.getAttribute("itedo:apstype") === "Part");
    itemList.forEach((item)=>bindEvents(item, actions, svg));
    return svg;
};
/* harmony default export */ var interactiveSvg = (createInteractiveSVGElement);
const bindEvents = function(item, actions) {
    let context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    item.addEventListener("mouseover", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        addActionMultiple(relations, mouseOver);
    }, false);
    item.addEventListener("mouseout", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        addActionMultiple(relations, mouseOut);
    }, false);
    item.addEventListener("click", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        actions.click(e, relations);
    }, false);
};
const mutateGroupText = (groupNode)=>{
    const textList = [
        ...groupNode.querySelectorAll("text")
    ];
    const hotspotList = groupNode.getAttribute("kohler_illustration:hotspot_list");
    const groupNodeClassList = Array.from(groupNode.classList);
    textList === null || textList === void 0 ? void 0 : textList.forEach((item)=>{
        item.classList.add(...groupNodeClassList);
        item.setAttribute("kohler_illustration:hotspot_list", hotspotList === null || hotspotList === void 0 ? void 0 : hotspotList.trim());
        item.setAttribute("itedo:apstype", "Part");
    });
};
const addActionMultiple = (list, action)=>list.forEach((node)=>action(node));
const getNodes = (list, context)=>list.map((id)=>context.getElementById(id));
const getObjectRelations = (node)=>{
    const listString = node.getAttribute("kohler_illustration:hotspot_list");
    let list = [];
    if (typeof listString === "string") list = listString.split(",");
    return list;
};
const mouseOver = (node)=>node.classList.add("active");
const mouseOut = (node)=>node.classList.remove("active");

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/index.js









const PartsDiagramViewer = (props)=>{
    const { selectedFile , fullscreen , expandHandler , showPopup , title , sku , siteName  } = props || {};
    const transformComponentRef = (0,react.useRef)(null);
    const wrapper = (0,react.useRef)(null);
    const container = (0,react.useRef)(null);
    const [svgData, setSvgData] = (0,react.useState)();
    const [status, setStatus] = (0,react.useState)("loading");
    const [scale, setScale] = (0,react.useState)(1);
    const [initScale, setInitScale] = (0,react.useState)(1);
    const [message, setMessage] = (0,react.useState)(false);
    const [position, setPosition] = (0,react.useState)({
        left: 0,
        top: 0,
        textWidth: 0,
        textHeight: 0,
        showTop: 0,
        textBounds: {}
    });
    (0,react.useEffect)(()=>{
        const aspect = container.current.offsetHeight / container.current.offsetWidth * 0.85;
        setInitScale(aspect > 0.9 ? aspect : 0.9);
        return ()=>{
            container.current = false;
        };
    }, []);
    (0,react.useEffect)(()=>{
        setMessage(false);
        setStatus("loading");
        const abortController = new AbortController();
        getSelectedFile(abortController);
        return ()=>{
            abortController.abort();
            setMessage(false);
            setStatus("loading");
            setSvgData("");
        };
    }, [
        selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.URL
    ]);
    (0,react.useEffect)(()=>{
        if (wrapper === null || wrapper === void 0 ? void 0 : wrapper.current) wrapper.current.appendChild(svgData);
    }, [
        svgData,
        position
    ]);
    const getSelectedFile = async (abortController)=>{
        try {
            const response = await fetch(LOCAL_PREFIX + (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.URL), {
                signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal
            });
            const svgText = await response.text();
            const svgElement = interactiveSvg(svgText, {
                click: clickAction
            });
            setStatus("loaded");
            setSvgData(svgElement);
        } catch (error) {
            setStatus("error");
        }
    };
    const clickAction = async (e, relations)=>{
        var ref, ref1;
        setMessage(false);
        let text = e.currentTarget.getAttribute("class");
        text = text.replaceAll("active", "").replaceAll(" ", "");
        const replacePartNo = (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.replacementParts[text]) && ((ref = selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.replacementParts[text]) === null || ref === void 0 ? void 0 : ref.ReplaceProductProductNo);
        const getPartInfo = selectedFile === null || selectedFile === void 0 ? void 0 : (ref1 = selectedFile.replacementPartsInfo) === null || ref1 === void 0 ? void 0 : ref1.filter((v)=>{
            return (v === null || v === void 0 ? void 0 : v.Cod) === replacePartNo;
        });
        if (replacePartNo && getPartInfo.length !== 0) {
            getPartInfo[0].replaceRootSku = text;
            showPopup(replacePartNo);
        } else if (selectedFile.Parts.filter((item)=>item.Cod === text).length === 0) {
            partNotFoundMessage(e.currentTarget);
            setMessage(true);
            showPopup(text);
        } else {
            showPopup(text);
        }
    };
    const partNotFoundMessage = (textNode)=>{
        const svgElement = wrapper.current.children[0];
        const viewBox = svgElement.getAttribute("viewBox").split(" ");
        const boxWidth = viewBox === null || viewBox === void 0 ? void 0 : viewBox[2];
        const boxHeight = viewBox === null || viewBox === void 0 ? void 0 : viewBox[3];
        const boxAspect = boxWidth / boxHeight;
        const { top  } = textNode.getBoundingClientRect();
        const svgWidth = svgElement.width.baseVal.value;
        const svgHeight = svgElement.height.baseVal.value;
        const wrapperWidth = wrapper.current.offsetWidth;
        const wrapperHeight = wrapper.current.offsetHeight;
        const wrapperAspect = wrapperWidth / wrapperHeight;
        let leftOffset = 0;
        let topOffset = 0;
        let leftValue = 0;
        let topValue = 0;
        let actualSVGWidth = 0;
        let actualSVGHeight = 0;
        let svgScaleVertical = 1;
        let svgScaleHorizontal = 1;
        if (wrapperAspect > boxAspect) {
            actualSVGWidth = svgHeight * boxAspect;
            actualSVGHeight = svgHeight;
            leftOffset = (svgWidth - actualSVGWidth) / 2;
            topOffset = 0;
        } else {
            actualSVGWidth = svgWidth;
            actualSVGHeight = svgWidth / boxAspect;
            leftOffset = 0;
            topOffset = (svgHeight - actualSVGHeight) / 2;
        }
        svgScaleHorizontal = actualSVGWidth / boxWidth;
        svgScaleVertical = actualSVGHeight / boxHeight;
        leftValue = textNode.getAttribute("x") / boxWidth * actualSVGWidth;
        topValue = textNode.getAttribute("y") / boxHeight * actualSVGHeight;
        setPosition({
            left: leftValue + leftOffset,
            top: topValue + topOffset,
            textWidth: textNode.getComputedTextLength() * svgScaleHorizontal,
            textHeight: textNode.getBBox().height * svgScaleVertical / scale,
            showTop: top,
            textBounds: textNode.getBoundingClientRect()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Conditional_Conditional, {
                show: status === "loading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex w-100 h-100 justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        ref: container
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: status === "loaded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransformWrapper, {
                    initialScale: initScale,
                    velocityAnimation: {
                        disabled: true
                    },
                    ref: transformComponentRef,
                    zoomAnimation: {
                        disabled: true
                    },
                    centerOnInit: true,
                    minScale: 0.5,
                    onTransformed: (e)=>{
                        var ref;
                        return setScale(e === null || e === void 0 ? void 0 : (ref = e.state) === null || ref === void 0 ? void 0 : ref.scale);
                    },
                    onInit: ()=>{},
                    pinch: {
                        step: 2
                    },
                    wheel: {
                        step: 0.1
                    },
                    children: (utils)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransformComponent, {
                                    children: [
                                        message ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsDiagramViewer_PopModal, {
                                            position: position,
                                            setMessage: setMessage,
                                            scale: scale
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-wrapper",
                                            ref: wrapper
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsDiagramViewer_PartsControls, {
                                    ...utils,
                                    expandHandler: expandHandler,
                                    fullscreen: fullscreen,
                                    scale: scale,
                                    initScale: initScale,
                                    setMessage: setMessage,
                                    title: title,
                                    sku: sku,
                                    siteName: siteName
                                })
                            ]
                        })
                })
            })
        ]
    });
};
/* harmony default export */ var v2_PartsDiagramViewer = (PartsDiagramViewer);

;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Container.js
"use client";





const Container = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ var esm_Container = (Container);
// EXTERNAL MODULE: ./components/core/Heading/Heading.jsx
var Heading = __webpack_require__(22231);
// EXTERNAL MODULE: ./components/PartsViewer/v2/SwatchItems/index.js
var SwatchItems = __webpack_require__(73433);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Row.js
"use client";





const Row = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'row');
  const breakpoints = useBootstrapBreakpoints();
  const minBreakpoint = useBootstrapMinBreakpoint();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ var esm_Row = (Row);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Col.js
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'col');
  const breakpoints = useBootstrapBreakpoints();
  const minBreakpoint = useBootstrapMinBreakpoint();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames_default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames_default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ var esm_Col = (Col);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/utils.js
var utils = __webpack_require__(29885);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/PartsViewer/v2/NotifyMe/notify.module.scss
var notify_module = __webpack_require__(35423);
var notify_module_default = /*#__PURE__*/__webpack_require__.n(notify_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/NotifyMe/index.js










const NotifyItems = (props)=>{
    const { item , fromCart , isListExtend , gridViewNotify , showStockMessage =true , itemStock =false  } = props;
    const [email, setEmail] = (0,react.useState)("");
    const [emailError, setEmailError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [showWelcome, setShowWelcome] = (0,react.useState)(false);
    const [enableNotify, setEnableNotify] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { notifyText , notifySuccessText , notifyEmailText , successText , notifyOutofStockText , notifyButtonText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        setShowWelcome(false);
        setEmailError({
            show: false,
            message: ""
        });
        setEmail("");
    }, [
        item
    ]);
    const handleEmailChange = async (val)=>{
        const inputValue = val.trim();
        setEmailError({
            show: false,
            message: ""
        });
        setEmail(inputValue);
        if (!await (0,helper/* validateField */.OP$)("email", inputValue)) {
            setEnableNotify(false);
        } else {
            setEnableNotify(true);
        }
    };
    const callBackNotify = (isSuccess)=>{
        if (isSuccess) {
            setShowWelcome(true);
            setEmail("");
            setEnableNotify(false);
        } else {
            setEmailError({
                show: true,
                message: notifyText
            });
        }
    };
    const handleNotification = ()=>{
        var ref;
        const sku = item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.id;
        if (sku) (0,utils/* callNotification */.jL)({
            email,
            sku,
            callBackNotify
        });
    };
    const handlerSubmit = (event)=>{
        if (event.key === "Enter" && enableNotify) {
            handleNotification();
        }
    };
    const handlerNotify = ()=>{
        if (enableNotify) {
            handleNotification();
        }
    };
    const outofStockVal = !itemStock ? notifyOutofStockText : null;
    const notifytextVal = !itemStock ? notifyEmailText : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (notify_module_default()) === null || (notify_module_default()) === void 0 ? void 0 : (notify_module_default()).NotifyContianer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row, {
            className: gridViewNotify ? "girdViewNotify" : "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col, {
                className: "notify-contianer",
                children: [
                    showStockMessage || itemStock ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "notify-message notify-button-margin ".concat(isListExtend ? "notify-button-margin" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-16 fw-500 notify-heading ",
                                children: showWelcome ? successText : outofStockVal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-14 fw-400 notify-details ",
                                children: showWelcome ? notifySuccessText : notifytextVal
                            })
                        ]
                    }) : null,
                    !showWelcome ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(fromCart ? "input-button" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "email-inputbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "email-notify",
                                    onChange: (e)=>handleEmailChange(e.target.value),
                                    onKeyDown: handlerSubmit,
                                    type: "email",
                                    label: "Email Address",
                                    ariaRequried: true,
                                    maxLength: 60,
                                    value: email,
                                    showError: emailError.show,
                                    errorMessage: emailError.message
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "notify-button-div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "notify-button ".concat(!isListExtend ? "notify-button-margin" : "notify-button-width", " ").concat(enableNotify ? "" : "disabled-btn"),
                                    onClick: handlerNotify,
                                    disabled: !enableNotify,
                                    children: notifyButtonText
                                })
                            })
                        ]
                    }) : ""
                ]
            })
        })
    });
};
NotifyItems.propTypes = {
    item: (prop_types_default()).object.isRequired,
    fromCart: (prop_types_default()).string.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    gridViewNotify: (prop_types_default()).object.isRequired,
    showStockMessage: (prop_types_default()).string.isRequired,
    itemStock: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var NotifyMe = (NotifyItems);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/Loading/index.js





const LoadingPopupection = (props)=>{
    const { setModal , device , popupWidth , fullscreen  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "popup-default loading-popup",
        style: popupWidth && !device.isSmallScreen ? {
            width: (popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.sidebarWidth) + "px",
            top: !fullscreen ? popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.headHeight : 0 + "px"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Container, {
            fluid: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn closebtns",
                            onClick: ()=>setModal(false),
                            children: (device === null || device === void 0 ? void 0 : device.isLargeScreen) || device.isExtraLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DownIcon */.KL, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex  flex-column align-items-center mt-4 mb-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-thumb mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex  flex-column justify-content-start mb-30",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading mb-4",
                                    children: "new"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation mt-4 mb-4 h-16",
                                    children: "Widespread bathroom sink faucet"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading",
                                    children: "K-5709-7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex  flex-column justify-content-start mb-30",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading",
                                    children: "$800.44"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation mt-3 mb-2 h-16 loading-heading",
                                    children: "$1000.44 List Price"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex  flex-column justify-content-start mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "loading-animation loading-heading h-16",
                                children: "color/Finish white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-30 w-100",
                            children: Array.from({
                                length: 9
                            }, (v, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-buttons mb-2",
                                    children: "color Finish"
                                }, val))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-100 d-flex flex-rows justify-content-between align-content-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation counter-details",
                                    children: "counter"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation addtocart-details",
                                    children: "Add to cart"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
LoadingPopupection.propTypes = {
    fullscreen: (prop_types_default()).bool.isRequired,
    setModal: (prop_types_default()).func.isRequired,
    popupWidth: prop_types_default().shape({
        headHeight: (prop_types_default()).number
    }),
    device: (prop_types_default()).object.isRequired
};
/* harmony default export */ var Loading = (LoadingPopupection);

// EXTERNAL MODULE: ./components/PartsViewer/v2/ReplacementParts/index.module.scss
var ReplacementParts_index_module = __webpack_require__(9143);
var ReplacementParts_index_module_default = /*#__PURE__*/__webpack_require__.n(ReplacementParts_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ReplacementParts/index.js






const ReplacementParts = (props)=>{
    const { productNumber , setProductNumber , partController , selectedFile , productId  } = props;
    const [item, setItem] = (0,react.useState)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { viewreplacement , replacing , partname , partnumber , replacedby  } = (0,localization/* getTranslations */.F)(t);
    const replacePartId = productNumber === null || productNumber === void 0 ? void 0 : productNumber.replaceId;
    (0,react.useEffect)(()=>{
        if (replacePartId) {
            getFileNameUpdate(replacePartId);
        }
    }, [
        replacePartId
    ]);
    const getFileNameUpdate = async (id)=>{
        const entry = partController.actions.get.entryByKey(id, selectedFile);
        const data = await entry.ctApiPromise;
        setItem(data);
    };
    const replaceHandler = (arg)=>{
        setProductNumber((prevState)=>{
            return {
                productId: replacePartId,
                replaceId: productNumber === null || productNumber === void 0 ? void 0 : productNumber.productId
            };
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ReplacementParts_index_module_default()).ReplacementSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "replacement-container",
            children: [
                replacePartId === productId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "view-replacement",
                    onClick: ()=>replaceHandler(productNumber),
                    children: viewreplacement
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "repl-heading",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            " ",
                            replacePartId === productId ? replacedby : replacing,
                            " "
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "replacement-list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "repl-head item-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "repl-text",
                                    children: partnumber
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "repl-text",
                                    children: partname
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "repl-content item-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: " repl-text link-button",
                                onClick: ()=>replaceHandler(productNumber),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: " repl-text",
                                        children: item === null || item === void 0 ? void 0 : item.Cod
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: " repl-text replace-title",
                                        children: item === null || item === void 0 ? void 0 : item.Name
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
ReplacementParts.propTypes = {
    productId: (prop_types_default()).string.isRequired,
    productNumber: (prop_types_default()).object.isRequired,
    setProductNumber: (prop_types_default()).func.isRequired,
    partController: (prop_types_default()).object.isRequired,
    selectedFile: (prop_types_default()).object.isRequired
};
/* harmony default export */ var v2_ReplacementParts = (ReplacementParts);

// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./services/productServices.js
var productServices = __webpack_require__(35285);
;// CONCATENATED MODULE: ./services/ImageUrlValid.js
const isImgUrlValid = (url)=>{
    try {
        const img = new Image();
        img.src = url;
        return new Promise((resolve)=>{
            img.onerror = ()=>resolve(false);
            img.onload = ()=>resolve(true);
        });
    } catch (err) {
        throw new Error("Invalid Image");
    }
};

;// CONCATENATED MODULE: ./public/scout_icon/coming-soon.jpg
/* harmony default export */ var coming_soon = ({"src":"/_next/static/media/coming-soon.c51c0af8.jpg","height":375,"width":337,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQIRMSEkkf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCwNXZckLVzjgAA/9k=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/analytics.js

const partsAddToCartEvent = (analytics, productInfo)=>{
    const { page ="n/a"  } = analytics;
    const linkUrl = window.location.href;
    const event = "cmp:click";
    const newPage = page === "search results" ? "search results:modal" : page;
    const eventInfo = {
        eventAction: page + ":modal:interactive parts diagram:add to cart",
        eventName: page + ":modal:interactive parts diagram:add to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add to cart",
        internalLinkPosition: newPage,
        internalLinkType: page + ":add to cart",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: linkUrl,
        clickInternalLinks: "true"
    };
    const { productInfo: product , page: pageState  } = getAnalyticProductInfo(productInfo);
    if (pageState && pageState.pageInfo) {
        pageState.pageInfo["contentType"] = page;
        if (typeof pageState.pageInfo.pageName === "string" && pageState.pageInfo.pageName.match("::")) {
            const pageName = pageState.pageInfo.pageName.replaceAll("::", ":".concat(page, ":"));
            pageState.pageName = pageName;
            pageState.pageInfo.pageName = pageName;
        }
    }
    const modifiedPageObj = pageState || {
        page
    };
    // pass page as modifiedPageObj (3rd arg) and product as 5th arg
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, event, modifiedPageObj, {}, product);
};
const getAnalyticProductInfo = (pdpInfo)=>{
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState("page");
    if (page) {
        const { user ={
            encodedEmailId: null,
            profileType: null
        } , category ={
            productLocalCategory: null
        } , pageInfo ={
            thumbnailImageUrl: null
        }  } = page;
        delete category["productLocalCategory"];
        delete user["encodedEmailId"];
        delete user["profileType"];
        delete pageInfo["thumbnailImageUrl"];
    }
    const { Name ="" , quantity =0 , fileTitle ="" , currentVarent: { imgUrl , label , centPrice , value  } , data: { ProductDescriptionProduct_s: productDescription , ProductCategory_s: productCategory  } , pdpDetails: { pdp  }  } = pdpInfo;
    const serviceVs = JSON.parse(localStorage.getItem("serviceVS"));
    const productInfo = {
        category: (pdp === null || pdp === void 0 ? void 0 : (ref = pdp.data) === null || ref === void 0 ? void 0 : ref.category1_s) || "n/a",
        defaultImageName: imgUrl,
        description: (0,helper/* sanitizeTextForAnalytics */.T68)(productDescription || Name),
        frequency: "n/a",
        globalDiscount: 0,
        globalOffer: "n/a",
        globalPromotionPrice: centPrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        priceState: "regular price",
        productBasePrice: centPrice,
        productBrand: "kohler",
        productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        productCollectionsName: (pdp === null || pdp === void 0 ? void 0 : pdp.productBrand) || "n/a",
        productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(label),
        productCouponCode: "n/a",
        productCoupondiscount: 0,
        productFindingMethod: "pdp:".concat(fileTitle),
        productID: value,
        productName: (0,helper/* sanitizeTextForAnalytics */.T68)(Name),
        productPartnerBuyNow: false,
        productRoom: page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.room,
        productSalePrice: centPrice,
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: true,
        productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(Name),
        quantity,
        ratings: "n/a",
        waterSenseProduct: false,
        visualsearch: serviceVs !== null && serviceVs !== void 0 ? serviceVs : false
    };
    return {
        productInfo,
        page
    };
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/index.js




















const DetailPopUp = (props)=>{
    var ref, ref1;
    const { productId , setModal , partController , analytics , title , fullscreen , setWidthSize , selectedFile , siteName  } = props || {};
    const replaceId = (ref1 = selectedFile === null || selectedFile === void 0 ? void 0 : (ref = selectedFile.Parts) === null || ref === void 0 ? void 0 : ref.filter((v)=>{
        return (v === null || v === void 0 ? void 0 : v.Cod) === productId;
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.replaceRootSku;
    const [loading, setLoading] = (0,react.useState)("loading");
    const [item, setItem] = (0,react.useState)({});
    const [variant, setVariant] = (0,react.useState)(null);
    const [variantList, setVariantList] = (0,react.useState)([]);
    const [counter, setCounter] = (0,react.useState)(1);
    const [loaded, setLoaded] = (0,react.useState)(false);
    const [inventory, setInventory] = (0,react.useState)("");
    const [inventoryWarn, setInventoryWarn] = (0,react.useState)(false);
    const [cartToast, setCartToast] = (0,react.useState)(false);
    const [popupWidth, setPopupWidth] = (0,react.useState)(null);
    const [isValidImg, setIsValidImg] = (0,react.useState)(false);
    const [productNumber, setProductNumber] = (0,react.useState)({
        productId: null,
        replaceId: null
    });
    const [showProduct, setShowProduct] = (0,react.useState)(true);
    const showStockDiscontinue = null;
    const device = (0,useViewport/* default */.Z)();
    const resizeWidth = (0,useViewport/* useViewportWidth */.j)();
    const pdpDetails = (0,es/* useSelector */.v9)((state)=>state.pdp);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { addToCart , listPriceDescText , listPriceText , colorFinish , discontinuedText , outOfStockText , inventoryTextVal , replacesText  } = (0,localization/* getTranslations */.F)(t);
    const kohlerCanadaFlag = (0,helper/* isCanadaSite */.guj)(siteName);
    (0,react.useEffect)(()=>{
        const element = document.getElementsByClassName("product-list-viewer")[0];
        const headElement = document.querySelectorAll(".modal-fullscreen.modal-container")[0];
        if (element) {
            const { width  } = element.getBoundingClientRect();
            const { height  } = headElement.getBoundingClientRect();
            setWidthSize(width);
            setPopupWidth({
                sidebarWidth: width,
                headHeight: height
            });
        }
    }, [
        resizeWidth
    ]);
    (0,react.useEffect)(()=>{
        getItemDetails(productNumber === null || productNumber === void 0 ? void 0 : productNumber.productId);
    }, [
        productNumber
    ]);
    (0,react.useEffect)(()=>{
        setProductNumber({
            productId,
            replaceId
        });
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        let timeId;
        if (inventory && counter > inventory) {
            timeId = setTimeout(()=>{
                setCounter(inventory);
            }, 1000);
            setInventoryWarn(true);
        }
        return ()=>clearTimeout(timeId);
    }, [
        counter
    ]);
    (0,react.useEffect)(()=>{
        if (variant) {
            getVarientInfo();
        }
    }, [
        variant
    ]);
    const getVarientInfo = async ()=>{
        const currentVarent = variantList === null || variantList === void 0 ? void 0 : variantList.filter((val)=>val.id === variant)[0];
        if (currentVarent) {
            var ref;
            const isImgValid = await isImgUrlValid(item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.imgUrl);
            setIsValidImg(isImgValid);
            setLoaded(true);
            const productQuantity = await getInventoryBySku(currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
            setLoaded(false);
            setItem((prevState)=>{
                var ref, ref1;
                const details = prevState === null || prevState === void 0 ? void 0 : (ref = prevState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.varientDetails) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === (currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
                })[0];
                return {
                    ...prevState,
                    currentVarent: {
                        ...currentVarent,
                        details
                    }
                };
            });
            setInventory(productQuantity);
            setInventoryWarn(false);
            if (productQuantity && counter > productQuantity) {
                setCounter(productQuantity);
                setInventoryWarn(true);
            }
        }
    };
    const getItemDetails = async (id)=>{
        const entry = partController.actions.get.entryByKey(id, selectedFile);
        setShowProduct(true);
        setLoading("loading");
        if (entry === null || entry === void 0 ? void 0 : entry.ctApiPromise) {
            const ctResponse = await entry.ctApiPromise;
            if (ctResponse === null || ctResponse === void 0 ? void 0 : ctResponse.data) {
                var ref, ref1, ref2, ref3, ref4;
                setLoaded(true);
                const allSwatch = ctResponse === null || ctResponse === void 0 ? void 0 : (ref = ctResponse.data) === null || ref === void 0 ? void 0 : ref.colorData;
                const isImgValid = await isImgUrlValid(allSwatch === null || allSwatch === void 0 ? void 0 : (ref1 = allSwatch[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl);
                setIsValidImg(isImgValid);
                const currentSwatch = allSwatch === null || allSwatch === void 0 ? void 0 : (ref2 = allSwatch[0]) === null || ref2 === void 0 ? void 0 : ref2.id;
                const productQuantity = await getInventoryBySku(currentSwatch);
                const details = ctResponse === null || ctResponse === void 0 ? void 0 : (ref3 = ctResponse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === currentSwatch;
                })[0];
                setLoaded(false);
                setInventory(productQuantity);
                setVariantList(allSwatch);
                setVariant(currentSwatch);
                setItem({
                    ...ctResponse,
                    currentVarent: {
                        ...allSwatch[0],
                        details
                    }
                });
                setLoading("success");
            } else {
                setLoading("success");
                setShowProduct(false);
            }
        }
    };
    const incrementCounter = ()=>{
        setCounter(counter + 1);
    };
    const decrementCounter = ()=>{
        if (counter > 1) setCounter(counter - 1);
    };
    const handlerCounter = (val)=>{
        const count = Number(val);
        if (count && count >= 1) {
            setCounter(count);
        }
    };
    const handlerCart = (productInfo)=>{
        var ref;
        setLoaded(true);
        const data = [
            {
                sku: productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.currentVarent) === null || ref === void 0 ? void 0 : ref.id,
                quantity: counter,
                isBundleProduct: false,
                isBundle: false,
                brand: "kohler"
            }
        ];
        (0,shareCartHelper/* shareaddToCart */.J9)(data, "", (isFailed, res)=>{
            if (!isFailed && res) {
                setCartToast(true);
                setLoaded(false);
                const serviceVS = JSON.parse(localStorage.getItem("serviceVS"));
                if (serviceVS) {
                    const datavs = JSON.parse(localStorage.getItem("servicePartsVs")) || [];
                    datavs.push(productInfo === null || productInfo === void 0 ? void 0 : productInfo.productId);
                    sessionStorage.setItem("servicePartsVs", JSON.stringify(datavs));
                }
                partsAddToCartEvent(analytics, productInfo);
                setTimeout(()=>{
                    setCartToast(false);
                }, 3000);
            }
        });
    };
    const getInventoryBySku = async (sku)=>{
        if (!kohlerCanadaFlag) {
            var ref;
            const { inventories =[]  } = await (0,productServices/* getProductInventory */.o)(sku);
            return inventories.length ? (ref = inventories[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
        }
    };
    if (popupWidth) {
        var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
        if (showProduct && loading === "loading") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                setModal: setModal,
                device: device,
                popupWidth: popupWidth,
                fullscreen: fullscreen
            });
        }
        var ref28;
        const skuValreplace = (ref28 = item === null || item === void 0 ? void 0 : item.replaceRootSku) !== null && ref28 !== void 0 ? ref28 : item === null || item === void 0 ? void 0 : item.Cod;
        const replacePartItems = selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.replacementParts[skuValreplace];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-default",
            style: popupWidth && !device.isSmallScreen ? {
                width: (popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.sidebarWidth) + "px",
                top: !fullscreen ? popupWidth.headHeight : 0 + "px"
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Container, {
                        fluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-column content-dialogs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header-fixed",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn closebtns",
                                            onClick: ()=>{
                                                setModal(false);
                                            },
                                            "data-testid": "parts-modal-close",
                                            children: (device === null || device === void 0 ? void 0 : device.isLargeScreen) || device.isExtraLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DownIcon */.KL, {})
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "main-image mt-0",
                                    children: loading === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: isValidImg ? item === null || item === void 0 ? void 0 : (ref2 = item.currentVarent) === null || ref2 === void 0 ? void 0 : ref2.imgUrl : coming_soon === null || coming_soon === void 0 ? void 0 : coming_soon.src,
                                        alt: "comming soon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flag-container",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref3 = item.currentVarent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.details) === null || ref4 === void 0 ? void 0 : ref4.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-13 fw-600 tag-discontinue discontinued",
                                                    children: discontinuedText
                                                }) : null,
                                                !kohlerCanadaFlag && ((item === null || item === void 0 ? void 0 : (ref5 = item.currentVarent) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : ref6.isStock) === "false" || inventory === 0) && (item === null || item === void 0 ? void 0 : (ref7 = item.currentVarent) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : ref8.discontinued) === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-13 fw-600 tag-discontinue outof-stoke",
                                                    children: outOfStockText
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            level: 2,
                                            className: "label-name fs-28 fw-325 text-capitalize",
                                            children: (item === null || item === void 0 ? void 0 : (ref9 = item.data) === null || ref9 === void 0 ? void 0 : ref9.productName_s) || (item === null || item === void 0 ? void 0 : (ref10 = item.Name) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase()) || "N/A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "varient-text fs-14 fw-500",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref11 = item.currentVarent) === null || ref11 === void 0 ? void 0 : ref11.value) || "N/A",
                                                (item === null || item === void 0 ? void 0 : item.replaceRootSku) ? " (".concat(replacesText, " ").concat(item === null || item === void 0 ? void 0 : item.replaceRootSku, ")") : null
                                            ]
                                        }),
                                        (item === null || item === void 0 ? void 0 : (ref12 = item.currentVarent) === null || ref12 === void 0 ? void 0 : ref12.price) !== "NaN" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref13 = item.currentVarent) === null || ref13 === void 0 ? void 0 : ref13.discountedPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                                    level: 2,
                                                    className: "price-text fs-28 fw-325 text-capitalize ",
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref14 = item.currentVarent) === null || ref14 === void 0 ? void 0 : ref14.currencySign,
                                                        item === null || item === void 0 ? void 0 : (ref15 = item.currentVarent) === null || ref15 === void 0 ? void 0 : ref15.discountedPrice
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "price-text fs-16 fw-400 text-capitalize ".concat((item === null || item === void 0 ? void 0 : (ref16 = item.currentVarent) === null || ref16 === void 0 ? void 0 : ref16.discountedPrice) ? "discount-price" : ""),
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref17 = item.currentVarent) === null || ref17 === void 0 ? void 0 : ref17.currencySign,
                                                        item === null || item === void 0 ? void 0 : (ref18 = item.currentVarent) === null || ref18 === void 0 ? void 0 : ref18.price
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "pricelist-text fs-16 fw-400 product-description mb-2",
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref19 = item.currentVarent) === null || ref19 === void 0 ? void 0 : ref19.currencySign,
                                                        item === null || item === void 0 ? void 0 : (ref20 = item.currentVarent) === null || ref20 === void 0 ? void 0 : ref20.pricelist,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "list-text",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        listPriceText
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "list-description",
                                                                    children: listPriceDescText
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "fs-16 fw-300 text-color",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "fw-400",
                                                    children: [
                                                        colorFinish,
                                                        ": "
                                                    ]
                                                }),
                                                (item === null || item === void 0 ? void 0 : (ref21 = item.currentVarent) === null || ref21 === void 0 ? void 0 : ref21.label) || "N/A"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SwatchItems/* default */.Z, {
                                            variantList: variantList,
                                            setVariant: setVariant,
                                            variant: variant
                                        }),
                                        !kohlerCanadaFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex align-items-center justify-content-center detailpop-up",
                                                children: showStockDiscontinue != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "fw-400 stock-button mt-5",
                                                    disabled: true,
                                                    children: showStockDiscontinue
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "button-carts d-flex flex-row justify-content-center align-items-end mt-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex flex-column processing-div ".concat(loaded ? "processing" : ""),
                                                        children: [
                                                            inventoryWarn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inventory-warning",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* WarnIcon */.e6, {}),
                                                                    " ",
                                                                    inventoryTextVal(inventory)
                                                                ]
                                                            }) : "",
                                                            !(item === null || item === void 0 ? void 0 : (ref22 = item.currentVarent) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.details) === null || ref23 === void 0 ? void 0 : ref23.discontinued) && loading === "success" && inventory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "addtocart-widgets d-flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "counter-widgets d-flex",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                className: "decrement-widgets",
                                                                                onClick: decrementCounter,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DecIcon */.Nh, {})
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "number",
                                                                                onChange: (e)=>{
                                                                                    var ref;
                                                                                    return handlerCounter(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                                                },
                                                                                value: counter
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                className: "increment-widgets",
                                                                                onClick: incrementCounter,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IncIcon */.M9, {})
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "button-carts",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            onClick: ()=>!loaded ? handlerCart({
                                                                                    ...item,
                                                                                    fileTitle: title,
                                                                                    quantity: counter,
                                                                                    pdpDetails
                                                                                }) : null,
                                                                            disabled: loaded,
                                                                            type: "button",
                                                                            className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(loaded ? "disabled" : "", "\n                        "),
                                                                            children: loaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoadingIcon */.Ho, {}) : addToCart
                                                                        })
                                                                    })
                                                                ]
                                                            }) : "",
                                                            ((item === null || item === void 0 ? void 0 : (ref24 = item.currentVarent) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.details) === null || ref25 === void 0 ? void 0 : ref25.isStock) === "false" || inventory === 0) && !(item === null || item === void 0 ? void 0 : (ref26 = item.currentVarent) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.details) === null || ref27 === void 0 ? void 0 : ref27.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                                                item: item
                                                            }) : ""
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        replaceId && replacePartItems && replaceId !== productId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ReplacementParts, {
                                            productNumber: productNumber,
                                            setProductNumber: setProductNumber,
                                            variant: variant,
                                            productId: productId,
                                            partController: partController,
                                            replaceRootSku: item,
                                            selectedFile: selectedFile
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                }),
                cartToast ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cart-toast-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "( ",
                                counter,
                                " ) ",
                                counter > 1 ? "Items" : "Item",
                                " has been added to your cart."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>setCartToast(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CartCloseIcon */.xD, {})
                        })
                    ]
                }) : ""
            ]
        });
    }
};
DetailPopUp.propTypes = {
    productId: (prop_types_default()).string.isRequired,
    setModal: (prop_types_default()).func.isRequired,
    analytics: (prop_types_default()).object.isRequired,
    title: (prop_types_default()).string.isRequired,
    fullscreen: (prop_types_default()).bool.isRequired,
    setWidthSize: (prop_types_default()).func.isRequired,
    partController: prop_types_default().shape({
        actions: prop_types_default().shape({
            get: prop_types_default().shape({
                entryByKey: (prop_types_default()).func.isRequired
            })
        })
    })
};
/* harmony default export */ var v2_DetailPopUp = (DetailPopUp);

// EXTERNAL MODULE: ./components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(65131);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ToggleView/index.js





const ToggleView = (props)=>{
    const { listView , setlistView , device  } = props || {};
    const isDesktop = device.isExtraLargeScreen || device.isLargeScreen;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { gridViewText , listViewText  } = (0,localization/* getTranslations */.F)(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "btn-group btn-group-toggle",
            "data-toggle": "buttons",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-expand grid-btn border-0 ".concat(isDesktop || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "pr-15" : "pr-15 pl-20", " ").concat(listView ? "" : "active"),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        setlistView(false);
                    },
                    "data-testid": "select-grid-view",
                    children: [
                        !listView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ImageGridViewMobile */.Wz, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* GridViewUnSelected */.PL, {}),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tool-tip-custom bottom grid-list-view",
                            children: gridViewText
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-expand list-btn border-0 ".concat(listView ? "active" : ""),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        setlistView(true);
                    },
                    children: [
                        listView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ListViewSelected */.pS, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ImageListViewMobile */.Eh, {}),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tool-tip-custom bottom grid-list-view",
                            children: listViewText
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GridAndListPanel_ToggleView = (ToggleView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/SortDropdown/index.js









const SortDropdown = (props)=>{
    const { partController , visibleData , title , sku , setlistView , listView , isListExtend  } = props || {};
    const [sort, setSort] = (0,react.useState)("asc");
    const [sortDesc, setSortDesc] = (0,react.useState)("A-Z");
    const device = (0,useViewport/* default */.Z)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { sortByText , sortText  } = (0,localization/* getTranslations */.F)(t);
    const toogleDropDown = ()=>{
        setIsOpen((prevOpen)=>!prevOpen);
    };
    const sortBy = (e, order)=>{
        setIsOpen(false);
        partController.actions.filterProduct(order.key);
        partController.actions.fetchForCpiPromise(visibleData);
        setSortDesc(order.label);
        setSort(order.key);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "drop-down",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    id: "dropdown-basic",
                    "aria-expanded": "false",
                    "data-testid": "sort-dropdown",
                    className: "sorting-btn btn btn-expand border-0 ".concat(isListExtend ? "full-screen-view" : "small-screen-view"),
                    onClick: toogleDropDown,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: isDesktop ? "".concat(sortByText, ": ").concat(sortDesc) : sortBy
                        }),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* SortByDropDownIcon */.tR, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* SortByIcon */.rc, {}),
                        device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ToggleView, {
                            listView,
                            setlistView,
                            device,
                            title,
                            sku
                        }) : null
                    ]
                }),
                isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "drop-down-menu border-0 ".concat(device.isSmallScreen ? "mobile-dropdown" : ""),
                    children: [
                        device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sort-div d-flex justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sort-by-title",
                                        children: [
                                            sortText,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "close-icon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: toogleDropDown,
                                            className: "close-menu",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconClose */.bM, {})
                                        })
                                    })
                                ]
                            })
                        }) : null,
                        sortOptions.map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "data-testid": "sort-".concat(val.key),
                                className: "dropdown-item drop-link ".concat(sort === val.key ? "sort-by" : ""),
                                onClick: (event)=>sortBy(event, val),
                                children: device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sort__radio-group",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                        id: val.key,
                                        name: val.key,
                                        value: val.label,
                                        checked: sort === val.key
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: val.label
                                })
                            }, val.key))
                    ]
                }) : null,
                device.isSmallScreen && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-overlay"
                }) : null
            ]
        })
    });
};
/* harmony default export */ var GridAndListPanel_SortDropdown = (SortDropdown);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/helper.js

const isObjectEmpty = (objectName)=>{
    return Object.keys(objectName).length === 0;
};
const getPersonaPriceDetails = (priceDtl)=>{
    const persona = (0,helper/* getUserPersona */.shu)();
    const result = [];
    if (priceDtl === null || priceDtl === void 0 ? void 0 : priceDtl.prices) {
        var ref;
        const filerPrice = (priceDtl === null || priceDtl === void 0 ? void 0 : (ref = priceDtl.prices) === null || ref === void 0 ? void 0 : ref.filter((elemet)=>{
            return !isObjectEmpty(elemet === null || elemet === void 0 ? void 0 : elemet.prices);
        })) || [];
        filerPrice === null || filerPrice === void 0 ? void 0 : filerPrice.map((price)=>{
            if (Object.keys(price === null || price === void 0 ? void 0 : price.prices) !== 0) {
                var ref, ref1, ref2;
                result.push({
                    currencySign: (price === null || price === void 0 ? void 0 : price.currencySign) ? price === null || price === void 0 ? void 0 : price.currencySign : $,
                    sku: price === null || price === void 0 ? void 0 : price.sku,
                    discountedPrice: Object.values(price === null || price === void 0 ? void 0 : price.discountPrices).length ? (((ref = price === null || price === void 0 ? void 0 : price.discountPrices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100).toFixed(2) : null,
                    price: (price === null || price === void 0 ? void 0 : price.prices[persona]) ? (((ref1 = price === null || price === void 0 ? void 0 : price.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount) / 100).toFixed(2) : null,
                    pricelist: (price === null || price === void 0 ? void 0 : price.prices["ANY"]) ? (((ref2 = price === null || price === void 0 ? void 0 : price.prices["ANY"]) === null || ref2 === void 0 ? void 0 : ref2.centAmount) / 100).toFixed(2) : null
                });
            }
        });
    }
    return result;
};
const getProductCartQuantity = (listColor, cart, productId)=>{
    var ref;
    let mapColor;
    if (listColor) {
        const list = listColor.map((color)=>{
            const d = color.split("|");
            return {
                sku: d[2].split("-")[0]
            };
        });
        mapColor = [
            ...new Set(list.map((item)=>item.sku))
        ];
    }
    const isAdded = cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
        var ref;
        const itemID = (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku.split("-")[0];
        return (mapColor === null || mapColor === void 0 ? void 0 : mapColor.includes(itemID)) || productId === itemID;
    });
    const totalQunatity = isAdded === null || isAdded === void 0 ? void 0 : isAdded.reduce((sum, item)=>sum + item.quantity, 0);
    const isAddedFlag = (isAdded === null || isAdded === void 0 ? void 0 : isAdded[0]) ? true : false;
    return {
        isAddedFlag,
        totalQunatity
    };
};
const getStockItems = (args)=>{
    var ref;
    let stock = false;
    let discontuned = false;
    let outofStock = false;
    args === null || args === void 0 ? void 0 : args.forEach((val)=>{
        const isDiscontinudItems = val === null || val === void 0 ? void 0 : val.discontinued;
        const isStock = (val === null || val === void 0 ? void 0 : val.isStock) === "true" || (val === null || val === void 0 ? void 0 : val.isStock) === undefined;
        if (isDiscontinudItems) {
            discontuned = true;
        } else if (isStock) {
            stock = true;
        } else {
            outofStock = true;
        }
    });
    return {
        stock,
        discontuned,
        outofStock,
        sku: (ref = args[0]) === null || ref === void 0 ? void 0 : ref.sku
    };
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/GridView/LoadingGrid/index.js


const GridCardLoading = (param)=>{
    let { isListExtend  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card d-flex load-widgets flex-column justify-content-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                class: "shimmer-loading__image shimmer ".concat(isListExtend ? "grid-fullwidth" : "thumb-size", " ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex flex-column justify-content-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "width-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                Array.from({
                                    length: 5
                                }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "shimmer-loading__para shimmer width-20"
                                    }, val)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: " width-16 loading-part mx-1 shimmer-loading__para shimmer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            class: "shimmer-loading__para shimmer width-191 loading-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            class: "shimmer-loading__para shimmer width-102 loading-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-15 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-15 mx-3 loading-part"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var LoadingGrid = (GridCardLoading);

// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ButtonLable/Index.js






const ButtonLabel = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { addedText  } = (0,localization/* getTranslations */.F)(t);
    const { cartQuantity , list =false  } = props;
    if (list) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddedIcon */.tW, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "add-label",
                    children: [
                        "(",
                        cartQuantity,
                        ")"
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddedIcon */.tW, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "added-label",
                children: [
                    addedText,
                    " (",
                    cartQuantity,
                    ")"
                ]
            })
        ]
    });
};
ButtonLabel.propTypes = {
    cartQuantity: (prop_types_default()).string.isRequired,
    list: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var Index = (ButtonLabel);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/CartButton/Index.js





const CartButton = (props)=>{
    const { isAddedFlag , cartQuantity , handlerButton , swatches , list =false  } = props;
    const [item, setItem] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swatches) {
            getSwatchesDetails(swatches);
        }
    }, [
        swatches
    ]);
    const getSwatchesDetails = async (arg)=>{
        const filterItems = arg.filter((v)=>{
            return (v === null || v === void 0 ? void 0 : v.swatch) !== "swatch_NA";
        });
        const updatedList = filterItems.length === 0 ? arg : filterItems;
        const resp = await getStockItems(updatedList);
        if (resp) {
            setItem(resp);
        }
    };
    const buttonClass = isAddedFlag ? "cart-added" : "active-btn";
    const isDisabled = (item === null || item === void 0 ? void 0 : item.discontuned) && !(item === null || item === void 0 ? void 0 : item.outofStock);
    const listViewClass = list ? "grid-button list-button" : "grid-button ";
    const listViewtext = list ? "Notify" : "Notify Me";
    const stockText = (item === null || item === void 0 ? void 0 : item.outofStock) && !(item === null || item === void 0 ? void 0 : item.stock) ? listViewtext : "Add";
    const disabledVal = isDisabled && !(item === null || item === void 0 ? void 0 : item.stock);
    const buttontext = disabledVal ? "Discontinued" : stockText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "button-groups-".concat(list ? "list-btns" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: listViewClass + " button-add-carts ".concat(disabledVal ? "disabled-btn" : buttonClass),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(list ? "list right-screen" : ""),
                onClick: ()=>handlerButton(!disabledVal),
                children: isAddedFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Index, {
                    cartQuantity: cartQuantity,
                    list: list
                }) : buttontext
            })
        })
    });
};
CartButton.propTypes = {
    isAddedFlag: (prop_types_default()).string.isRequired,
    cartQuantity: (prop_types_default()).string.isRequired,
    handlerButton: (prop_types_default()).func.isRequired,
    swatches: (prop_types_default()).object.isRequired,
    list: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var CartButton_Index = (CartButton);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/utils.js
const sortedVal = (items)=>{
    const stock = [];
    const outOfStock = [];
    const discontinued = [];
    items.forEach((v)=>{
        if ((v === null || v === void 0 ? void 0 : v.discontinued) === true) {
            discontinued.push(v);
        } else if ((v === null || v === void 0 ? void 0 : v.isStock) === "true") {
            stock.push(v);
        } else {
            outOfStock.push(v);
        }
    });
    const data = [
        ...stock,
        ...outOfStock,
        ...discontinued
    ];
    return data.length === items.length ? data : items;
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/GridView/index.js

















const GridView = (props)=>{
    var ref, ref1, ref2, ref3;
    const { dataPromise , showPopup , isListExtend , dataInput , showCart , setShowCart , showCartPopUp , siteName  } = props || {};
    const [validUrl, setValidUrl] = (0,react.useState)({
        status: "loading"
    });
    const [loading, setLoading] = (0,react.useState)("notStarted");
    const [productSwatche, setProductSwatche] = (0,react.useState)({});
    const [colour, setColour] = (0,react.useState)();
    const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
    const [colorItem, setColorItem] = (0,react.useState)(null);
    const [swatches, setSwatches] = (0,react.useState)(null);
    const [showProduct, setShowProduct] = (0,react.useState)(true);
    const device = (0,useViewport/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { Name: name , productName , productId , imageUrl: image , priceInfo , productInventoryInfo , isAddedFlag , cartQuantity  } = productSwatche;
    const personaPriceList = getPersonaPriceDetails(dataInput);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { outOfStockText , discontinuedText , replacesText  } = (0,localization/* getTranslations */.F)(t);
    const kohlerCanadaFlag = (0,helper/* isCanadaSite */.guj)(siteName);
    (0,react.useEffect)(()=>{
        getGridItems();
        return ()=>{
            setProductSwatche({});
            setLoading("loading");
        };
    }, [
        cart
    ]);
    (0,react.useEffect)(()=>{
        updateImageUrl();
        return ()=>{
            setValidUrl({});
        };
    }, [
        productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl
    ]);
    const updateImageUrl = async ()=>{
        if (productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl) {
            const res = await isImgUrlValid(productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl);
            if (res) {
                setValidUrl({
                    status: "success"
                });
            } else {
                setValidUrl({
                    status: "failed"
                });
            }
        } else {
            setValidUrl({
                status: "failed"
            });
        }
    };
    const getGridItems = async ()=>{
        setLoading("loading");
        const res = await dataPromise;
        if (res === null || res === void 0 ? void 0 : res.data) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { Name , productId , skuId , data , productIdKey , data: list , activeItem  } = res;
            const imageUrl = data === null || data === void 0 ? void 0 : (ref = data.colorData) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl;
            const productName = (data === null || data === void 0 ? void 0 : data.productName_s) || Name;
            const priceInfo = (ref3 = list === null || list === void 0 ? void 0 : (ref2 = list.colorData) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.id === activeItem)) === null || ref3 === void 0 ? void 0 : ref3[0];
            const productInventoryInfo = (ref5 = list === null || list === void 0 ? void 0 : (ref4 = list.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((item)=>item.sku === activeItem)) === null || ref5 === void 0 ? void 0 : ref5[0];
            const isAddedOne = getProductCartQuantity(list["Color.SKU.Details_ss"], cart, productId, skuId, activeItem);
            const cartQuantity = isAddedOne ? isAddedOne.totalQunatity : "";
            const isAddedFlag = isAddedOne === null || isAddedOne === void 0 ? void 0 : isAddedOne.isAddedFlag;
            setProductSwatche({
                Name,
                productName,
                productId,
                skuId,
                imageUrl,
                productIdKey,
                priceInfo,
                productInventoryInfo,
                isAddedFlag,
                cartQuantity
            });
            if (list) {
                const getSwatches = list["varientDetails"];
                const filterSwatch = getSwatches === null || getSwatches === void 0 ? void 0 : getSwatches.filter((val)=>val["swatch"] !== "swatch_NA");
                const colorArray = personaPriceList.map((item)=>{
                    const matchItem = Object.values(filterSwatch).find((element)=>item.sku === element.sku);
                    if (matchItem) return {
                        ...item,
                        ...matchItem
                    };
                    else return item;
                });
                const sortArrayVal = sortedVal(colorArray);
                setColour(sortArrayVal);
                const activeItems = sortArrayVal === null || sortArrayVal === void 0 ? void 0 : sortArrayVal.filter((v)=>{
                    return (v === null || v === void 0 ? void 0 : v.swatch) ? (v === null || v === void 0 ? void 0 : v.swatch) !== "swatch_NA" : v[0];
                });
                const firstItems = activeItems[0];
                setColorItem(firstItems);
                setSelectedVariant(firstItems);
                setSwatches(getSwatches);
            }
            setLoading("loaded");
        } else {
            setLoading("loaded");
            setShowProduct(false);
        }
    };
    if (showProduct && loading !== "loaded") return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingGrid, {
        isListExtend: isListExtend
    });
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const colorCount = isListExtend && ((device === null || device === void 0 ? void 0 : device.isLargeScreen) || (device === null || device === void 0 ? void 0 : device.isExtraLargeScreen)) ? 7 : 5;
    let extraColor;
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > colorCount) {
        extraColor = (colour === null || colour === void 0 ? void 0 : colour.length) - colorCount;
    }
    let marginStyle = "";
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > 0) {
        marginStyle = "mb-8";
    }
    const varientPrices = selectedVariant ? selectedVariant : priceInfo;
    const chkDiscontinue = selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued : productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued;
    const outOfStock = selectedVariant ? !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isStock) === "false" : (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false;
    const handlerButton = (arg)=>{
        if (arg) {
            setShowCart(!showCart);
            showCartPopUp(productId);
        }
    };
    const replaceSku = dataInput === null || dataInput === void 0 ? void 0 : (ref = dataInput.partApi) === null || ref === void 0 ? void 0 : ref.replaceRootSku;
    if (!showProduct) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>{
                    showPopup(productId);
                },
                "data-testid": "grid-card",
                onKeyDown: ()=>{
                    showPopup(productId);
                },
                className: "thumb-size ".concat(isListExtend ? "grid-fullwidth" : ""),
                children: (validUrl === null || validUrl === void 0 ? void 0 : validUrl.status) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading-spinner border-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "shimmer-loading__image shimmer"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "card-img-top",
                    src: validUrl.status === "success" ? image : coming_soon.src,
                    alt: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-bodys grid ".concat((colour === null || colour === void 0 ? void 0 : colour.length) <= 0 ? "mt-3" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-information",
                        onClick: ()=>{
                            showPopup(productId);
                        },
                        onKeyDown: ()=>{
                            showPopup(productId);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "color-variants ".concat(marginStyle),
                                children: [
                                    (ref1 = colour === null || colour === void 0 ? void 0 : colour.slice(0, colorCount)) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>item["swatch"] !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "other_color",
                                            onMouseEnter: ()=>setSelectedVariant(item),
                                            onMouseLeave: ()=>setSelectedVariant(colorItem),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                width: "20px",
                                                height: "20px",
                                                className: "img_variant_color",
                                                src: constants["default"].COLOR_FILE_URL + item["swatch"],
                                                alt: item["name"],
                                                onError: (e)=>colorSwatchDefaultImg(e),
                                                title: selectedVariant ? selectedVariant[0] : item["name"]
                                            })
                                        }, item["swatch"]) : null),
                                    extraColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "extra-color",
                                        children: [
                                            "+",
                                            extraColor
                                        ]
                                    }) : null
                                ]
                            }),
                            chkDiscontinue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued",
                                children: discontinuedText
                            }) : null,
                            outOfStock && !kohlerCanadaFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-13 fw-600 tag-discontinue mb-5 outof-stoke label-discontinued ",
                                children: outOfStockText
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card-model",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-text fw-400 model-number card-product-title text-capitalize mb-5",
                                        children: productName !== null && productName !== void 0 ? productName : name === null || name === void 0 ? void 0 : name.toLowerCase()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "card-text fw-400 text-capitalize sku_product-description mb-5 ".concat(device.isSmallScreen ? "my-1" : ""),
                                        children: [
                                            varientPrices ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.customerSku) || (dataInput === null || dataInput === void 0 ? void 0 : (ref2 = dataInput.partApi) === null || ref2 === void 0 ? void 0 : ref2.skuId) : (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.value) || (dataInput === null || dataInput === void 0 ? void 0 : (ref3 = dataInput.partApi) === null || ref3 === void 0 ? void 0 : ref3.skuId),
                                            replaceSku ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "replaceVal",
                                                children: [
                                                    "(",
                                                    replacesText,
                                                    " ",
                                                    replaceSku,
                                                    ")"
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "card-text fw-400 text-capitalize sku-price",
                                        children: [
                                            (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sku-price ".concat((varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? "mx-1 discount-price" : ""),
                                                children: (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.price) || null
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !kohlerCanadaFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_Index, {
                        isAddedFlag: isAddedFlag,
                        cartQuantity: cartQuantity,
                        handlerButton: handlerButton,
                        swatches: swatches
                    }) : null
                ]
            })
        ]
    });
};
GridView.propTypes = {
    showPopup: (prop_types_default()).bool.isRequired,
    dataPromise: (prop_types_default()).func.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    dataInput: (prop_types_default()).object.isRequired,
    showCart: (prop_types_default()).bool.isRequired,
    setShowCart: (prop_types_default()).func.isRequired,
    showCartPopUp: (prop_types_default()).func.isRequired,
    siteName: (prop_types_default()).string.isRequired
};
/* harmony default export */ var GridAndListPanel_GridView = (GridView);

;// CONCATENATED MODULE: ./public/scout_icon/dummy_image.jpg
/* harmony default export */ var dummy_image = ({"src":"/_next/static/media/dummy_image.09e12036.jpg","height":800,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAEAAgMAAAAAAAAAAAAAAAAAERIiQYH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8Ared9VjoAP//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ListView/LoadingCard/index.js



const ListCardLoading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card d-flex load-widgets border-active flex-row justify-content-between mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex flex-row justify-content-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "thumb-list loading-animation shimmer ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: dummy_image === null || dummy_image === void 0 ? void 0 : dummy_image.src,
                        alt: "loading"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "width-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                Array.from({
                                    length: 5
                                }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "shimmer-loading__para shimmer width-20"
                                    }, val)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: " width-16 loading-part mx-1 shimmer-loading__para shimmer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column justify-content-start pt-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-191 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-102 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            class: "shimmer-loading__para shimmer width-15 loading-part"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            class: "shimmer-loading__para shimmer width-15 mx-3 loading-part"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var LoadingCard = (ListCardLoading);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ListView/index.js

















const ListView = (props)=>{
    var ref, ref1, ref2, ref3;
    const { dataPromise , showPopup , isListExtend , dataInput , showCart , setShowCart , showCartPopUp , siteName  } = props;
    const [validUrl, setValidUrl] = (0,react.useState)({
        status: "loading"
    });
    const [loading, setLoading] = (0,react.useState)("notStarted");
    const [productSwatche, setProductSwatche] = (0,react.useState)({});
    const device = (0,useViewport/* default */.Z)();
    const [colour, setColour] = (0,react.useState)();
    const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
    const [colorItem, setColorItem] = (0,react.useState)(null);
    const [swatches, setSwatches] = (0,react.useState)(null);
    const [showProduct, setShowProduct] = (0,react.useState)(true);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { outOfStockText , discontinuedText , replacesText  } = (0,localization/* getTranslations */.F)(t);
    const { Name: name , productName , productId , imageUrl: image , priceInfo , productInventoryInfo , isAddedFlag , cartQuantity  } = productSwatche;
    const personaPriceList = getPersonaPriceDetails(dataInput);
    const kohlerCanadaFlag = (0,helper/* isCanadaSite */.guj)(siteName);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    (0,react.useEffect)(()=>{
        getListData();
    }, [
        cart
    ]);
    (0,react.useEffect)(()=>{
        updateImgUrl();
    }, [
        productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl
    ]);
    const updateImgUrl = async ()=>{
        if (productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl) {
            const res = await isImgUrlValid(productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl);
            if (res) {
                setValidUrl({
                    status: "success"
                });
            } else {
                setValidUrl({
                    status: "failed"
                });
            }
        } else {
            setValidUrl({
                status: "failed"
            });
        }
    };
    const getListData = async ()=>{
        setLoading("loading");
        const res = await dataPromise;
        if (res === null || res === void 0 ? void 0 : res.data) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { Name , productId , productIdKey , data: list , activeItem  } = res;
            const productName = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.productName_s) || Name;
            const imageUrl = (ref1 = list === null || list === void 0 ? void 0 : list.colorData[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl;
            const priceInfo = (ref3 = list === null || list === void 0 ? void 0 : (ref2 = list.colorData) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.id === activeItem)) === null || ref3 === void 0 ? void 0 : ref3[0];
            const productInventoryInfo = (ref5 = list === null || list === void 0 ? void 0 : (ref4 = list.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((item)=>item.sku === activeItem)) === null || ref5 === void 0 ? void 0 : ref5[0];
            const isAddedOne = getProductCartQuantity(list["Color.SKU.Details_ss"], cart, productId, activeItem);
            const cartQuantity = isAddedOne ? isAddedOne.totalQunatity : "";
            const isAddedFlag = isAddedOne === null || isAddedOne === void 0 ? void 0 : isAddedOne.isAddedFlag;
            setProductSwatche({
                Name,
                productName,
                productId,
                imageUrl,
                productIdKey,
                priceInfo,
                productInventoryInfo,
                isAddedFlag,
                cartQuantity
            });
            if (res === null || res === void 0 ? void 0 : res.data) {
                const getSwatches = list === null || list === void 0 ? void 0 : list.varientDetails;
                const filterSwatch = getSwatches.filter((val)=>val["swatch"] !== "swatch_NA");
                const colorArray = personaPriceList.map((item)=>{
                    const matchItem = Object.values(filterSwatch).find((element)=>item.sku === element.sku);
                    if (matchItem) return {
                        ...item,
                        ...matchItem
                    };
                    else return item;
                });
                const sortArrayVal = sortedVal(colorArray);
                setColour(sortArrayVal);
                const activeItems = sortArrayVal === null || sortArrayVal === void 0 ? void 0 : sortArrayVal.filter((v)=>{
                    return (v === null || v === void 0 ? void 0 : v.swatch) ? (v === null || v === void 0 ? void 0 : v.swatch) !== "swatch_NA" : v[0];
                });
                const firstItems = activeItems[0];
                setColorItem(firstItems);
                setSelectedVariant(firstItems);
                setSwatches(getSwatches);
            }
            setLoading("loaded");
        } else {
            setLoading("loaded");
            setShowProduct(false);
        }
    };
    if (showProduct && loading !== "loaded") return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingCard, {});
    const colorCount = 5;
    let extraColor;
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > colorCount) {
        extraColor = (colour === null || colour === void 0 ? void 0 : colour.length) - colorCount;
    }
    let marginStyle;
    let flexDirection;
    const forMediumScreen = (device === null || device === void 0 ? void 0 : device.isMediumScreen) && !isListExtend;
    if (forMediumScreen) {
        marginStyle = "mx-0 marginStyle";
        flexDirection = "flex-column";
    } else if ((colour === null || colour === void 0 ? void 0 : colour.length) > 1) {
        if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
            marginStyle = "marginStyle";
        } else {
            marginStyle = "ml-10 tag-discontinue-position";
        }
    }
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const forAllSmallScreen = device.isMediumScreen || (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen);
    const listviewCls = !isListExtend && device.isMediumScreen ? "mx-0 p-0 mt-5" : "sku-cart-margin";
    const skuPriceClass = isListExtend && !device.isMediumScreen ? "justify-content-end" : listviewCls;
    let cadPriceWidth = "";
    if (isListExtend) {
        cadPriceWidth = kohlerCanadaFlag ? "width-50" : "w-25";
    }
    let titleAlignCenter = "";
    if (isListExtend && (device.isExtraLargeScreen || device.isLargeScreen)) {
        if (!(productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) && !((productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false)) {
            titleAlignCenter = true;
        }
    }
    const varientPrices = selectedVariant ? selectedVariant : priceInfo;
    let showAddTocart = false;
    if (!isListExtend && device.isExtraLargeScreen || (device === null || device === void 0 ? void 0 : device.isLargeTabView) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) && isListExtend) {
        showAddTocart = true;
    }
    const chkDiscontinue = selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued : productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued;
    const outOfStock = selectedVariant ? !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isStock) === "false" : (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false;
    const handlerButton = (arg)=>{
        if (arg) {
            setShowCart(!showCart);
            showCartPopUp(productId);
        }
    };
    const replaceSku = dataInput === null || dataInput === void 0 ? void 0 : (ref = dataInput.partApi) === null || ref === void 0 ? void 0 : ref.replaceRootSku;
    if (!showProduct) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card border-active list-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-bodys d-flex justify-content-between",
                onClick: ()=>{
                    showPopup(productId);
                },
                "data-testid": "list-card",
                onKeyDown: ()=>{
                    showPopup(productId);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex w-100 flex-grow-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "thumb-list",
                            children: (validUrl === null || validUrl === void 0 ? void 0 : validUrl.status) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-spinner",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "shimmer-loading__image shimmer"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: "60px",
                                height: "60px",
                                className: "card-img",
                                src: validUrl.status === "success" ? image : coming_soon === null || coming_soon === void 0 ? void 0 : coming_soon.src,
                                alt: name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex w-100 flex-grow-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex justify-content-between w-100 flex-grow-1 \n                ".concat(forAllSmallScreen ? "flex-column" : "", "\n                ").concat(isListExtend && !(device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "flex-row ms-4" : "flex-column", " pt-2 pb-2"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "color-variants list-color ".concat(forMediumScreen ? "d-block" : "color-parts"),
                                                children: [
                                                    (colour === null || colour === void 0 ? void 0 : colour.length) > 1 ? (ref1 = colour === null || colour === void 0 ? void 0 : colour.slice(0, colorCount)) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>{
                                                        return (item === null || item === void 0 ? void 0 : item.swatch) !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "other_color",
                                                            onMouseEnter: ()=>setSelectedVariant(item),
                                                            onMouseLeave: ()=>setSelectedVariant(colorItem),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                width: "20px",
                                                                height: "20px",
                                                                className: "img_variant_color",
                                                                src: constants["default"].COLOR_FILE_URL + item["swatch"],
                                                                alt: item["name"],
                                                                onError: (e)=>colorSwatchDefaultImg(e),
                                                                title: selectedVariant ? selectedVariant[0] : item["name"]
                                                            })
                                                        }, item["swatch"]) : "";
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: titleAlignCenter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title-center-align"
                                                        }) : ""
                                                    }),
                                                    extraColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "extra-color",
                                                        children: [
                                                            "+",
                                                            extraColor
                                                        ]
                                                    }) : "",
                                                    chkDiscontinue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "fs-13 fw-600 tag-discontinue discontinued label-discontinued ".concat(marginStyle),
                                                        children: discontinuedText
                                                    }) : "",
                                                    outOfStock && !kohlerCanadaFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "fs-13 fw-600 tag-discontinue outof-stoke label-discontinued ".concat(marginStyle, " "),
                                                        children: outOfStockText
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex align-items-center justify-content-between mb-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    fontSize: 18,
                                                    className: "card-text fw-400 tablet-view-padding ".concat(isListExtend ? "model-name-list " : "model-name list-items", " text-capitalize"),
                                                    children: productName !== null && productName !== void 0 ? productName : name === null || name === void 0 ? void 0 : name.toLowerCase()
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex card-text fw-400 align-items-center list-details list-fullwidth-tab position-relative ".concat(isListExtend ? "list-fullwidth" : "", " ").concat(!showAddTocart ? "justify-content-between" : "", " "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "model-name d-flex ".concat(flexDirection, " ").concat(isListExtend && !device.isMediumScreen ? "justify-content-end w-75" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    fontSize: 14,
                                                    className: "sku-name",
                                                    children: [
                                                        varientPrices ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.customerSku) || (dataInput === null || dataInput === void 0 ? void 0 : (ref2 = dataInput.partApi) === null || ref2 === void 0 ? void 0 : ref2.skuId) : (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.value) || (dataInput === null || dataInput === void 0 ? void 0 : (ref3 = dataInput.partApi) === null || ref3 === void 0 ? void 0 : ref3.skuId),
                                                        replaceSku ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "replaceVal",
                                                            children: [
                                                                "(",
                                                                replacesText,
                                                                " ",
                                                                replaceSku,
                                                                ")"
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    fontSize: 14,
                                                    className: "model-prices d-flex  \n                      ".concat(skuPriceClass, " ").concat(cadPriceWidth),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sku_product ".concat((varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? "mx-1 discount-price" : ""),
                                                            children: (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.price) || null
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "model-name-price px-1",
                                                            children: (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) : null
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            !kohlerCanadaFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_Index, {
                isAddedFlag: isAddedFlag,
                cartQuantity: cartQuantity,
                handlerButton: handlerButton,
                swatches: swatches,
                list: true
            }) : null
        ]
    });
};
ListView.propTypes = {
    showPopup: (prop_types_default()).bool.isRequired,
    dataPromise: (prop_types_default()).func.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    dataInput: (prop_types_default()).object.isRequired,
    showCart: (prop_types_default()).bool.isRequired,
    setShowCart: (prop_types_default()).func.isRequired,
    showCartPopUp: (prop_types_default()).func.isRequired,
    siteName: (prop_types_default()).string.isRequired
};
/* harmony default export */ var GridAndListPanel_ListView = (ListView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ViewController/index.js





const ViewController = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { partController , isListView , isListExtend , showPopup , visibleData , title , sku , showCart , setShowCart , showCartPopUp , selectedFile , siteName  } = props || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: isListView,
                children: (ref2 = partController === null || partController === void 0 ? void 0 : (ref = partController.actions) === null || ref === void 0 ? void 0 : (ref1 = ref.get) === null || ref1 === void 0 ? void 0 : ref1.firstEntries(visibleData)) === null || ref2 === void 0 ? void 0 : ref2.map((input)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ListView, {
                        dataInput: input,
                        dataPromise: input.ctApiPromise,
                        showPopup: showPopup,
                        isListExtend: isListExtend,
                        title: title,
                        sku: sku,
                        showCart: showCart,
                        setShowCart: setShowCart,
                        showCartPopUp: showCartPopUp,
                        selectedFile: selectedFile,
                        siteName: siteName
                    }, input.key))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: !isListView,
                children: (ref5 = partController === null || partController === void 0 ? void 0 : (ref3 = partController.actions) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.get) === null || ref4 === void 0 ? void 0 : ref4.firstEntries(visibleData)) === null || ref5 === void 0 ? void 0 : ref5.map((input)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_GridView, {
                        dataInput: input,
                        dataPromise: input.ctApiPromise,
                        showPopup: showPopup,
                        isListExtend: isListExtend,
                        title: title,
                        sku: sku,
                        showCart: showCart,
                        setShowCart: setShowCart,
                        showCartPopUp: showCartPopUp,
                        selectedFile: selectedFile,
                        siteName: siteName
                    }, input.key))
            })
        ]
    });
};
/* harmony default export */ var GridAndListPanel_ViewController = (ViewController);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/AddCart/PriceLabel/index.js






const PriceLabel = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { discontinuedText ="" , outOfStockText  } = (0,localization/* getTranslations */.F)(t);
    const { priceInfo , itemStock  } = props;
    const { currentVarent: { currencySign =null , details =null , discountedPrice =null , value =null , price ="NaN"  } , Name: name , replaceRootSku  } = priceInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inner-contents",
        children: [
            itemStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "fs-13 fw-600 tag-discontinue mb-5 outof-stoke",
                children: outOfStockText
            }) : null,
            (details === null || details === void 0 ? void 0 : details.discontinued) === false ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued",
                children: discontinuedText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                level: 2,
                className: "label-name fs-28 fw-325 text-capitalize",
                children: (name === null || name === void 0 ? void 0 : name.toLowerCase()) || "N/A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-with-price",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "varient-text fs-14 fw-500",
                        children: [
                            value || "N/A",
                            replaceRootSku ? " (replaces ".concat(replaceRootSku, ")") : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "price-part d-flex",
                        children: price !== "NaN" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                discountedPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                    level: 2,
                                    className: "price-text fs-28 fw-325 text-capitalize ",
                                    children: [
                                        currencySign,
                                        discountedPrice
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "price-text fs-16 fw-400 text-capitalize ml-5 ".concat(discountedPrice ? "discount-price" : ""),
                                    children: [
                                        currencySign,
                                        price
                                    ]
                                })
                            ]
                        }) : null
                    })
                ]
            })
        ]
    });
};
PriceLabel.propTypes = {
    priceInfo: prop_types_default().shape({
        currentVarent: prop_types_default().shape({
            currencySign: (prop_types_default()).string.isRequired,
            details: (prop_types_default()).string.isRequired,
            discountedPrice: (prop_types_default()).number.isRequired,
            value: (prop_types_default()).string.isRequired,
            price: (prop_types_default()).number.isRequired
        }),
        Name: (prop_types_default()).string.isRequired
    }),
    itemStock: (prop_types_default()).string.isRequired
};
/* harmony default export */ var AddCart_PriceLabel = (PriceLabel);

// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/PartsViewer/v2/AddCart/index.module.scss
var AddCart_index_module = __webpack_require__(16214);
var AddCart_index_module_default = /*#__PURE__*/__webpack_require__.n(AddCart_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/AddCart/index.js

















const AddCart = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const { productId , setShowCart , showCart , partController , analytics , title , isListExtend , setCartToast , selectedFile  } = props;
    const [loading, setLoading] = (0,react.useState)("loading");
    const [item, setItem] = (0,react.useState)({});
    const [variant, setVariant] = (0,react.useState)(null);
    const [variantList, setVariantList] = (0,react.useState)([]);
    const [counter, setCounter] = (0,react.useState)(1);
    const [loaded, setLoaded] = (0,react.useState)(false);
    const [inventory, setInventory] = (0,react.useState)("");
    const [inventoryWarn, setInventoryWarn] = (0,react.useState)(false);
    const [isAdding, setIsAdding] = (0,react.useState)("");
    const device = (0,useViewport/* default */.Z)();
    const { isDesktop , isSmallScreen  } = (0,useViewport/* default */.Z)();
    const pdpDetails = (0,es/* useSelector */.v9)((state)=>state.pdp);
    const cartRef = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const cartFlagFullWidth = isListExtend && device.isLargeTabView;
    const { addingCartText , addedCartText , addToCart , colorFinish , inventoryTextVal  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        getItemDetails(productId);
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        let timeId;
        if (inventory && counter > inventory) {
            setInventoryWarn(true);
            timeId = setTimeout(()=>{
                setCounter(inventory);
            }, 300);
        }
        return ()=>clearTimeout(timeId);
    }, [
        counter
    ]);
    (0,react.useEffect)(()=>{
        if (variant) {
            setCounter(1);
            setIsAdding("");
            getVarientInfo();
        }
    }, [
        variant
    ]);
    const getVarientInfo = async ()=>{
        const currentVarent = variantList === null || variantList === void 0 ? void 0 : variantList.filter((val)=>val.id === variant)[0];
        if (currentVarent) {
            setLoaded(true);
            const productQuantity = await getInventoryBySku(currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
            setLoaded(false);
            setItem((prevState)=>{
                var ref, ref1;
                const details = prevState === null || prevState === void 0 ? void 0 : (ref = prevState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.varientDetails) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === (currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
                })[0];
                return {
                    ...prevState,
                    currentVarent: {
                        ...currentVarent,
                        details
                    }
                };
            });
            setInventory(productQuantity);
            setInventoryWarn(false);
            if (productQuantity && counter > productQuantity) {
                setCounter(productQuantity);
                setInventoryWarn(true);
            }
        }
    };
    const getItemDetails = async (id)=>{
        const entry = partController.actions.get.entryByKey(id, selectedFile);
        setIsAdding("");
        setLoading("loading");
        if (entry === null || entry === void 0 ? void 0 : entry.ctApiPromise) {
            const ctResponse = await entry.ctApiPromise;
            if (ctResponse) {
                var ref, ref1, ref2, ref3;
                setLoaded(true);
                const allSwatch = ctResponse === null || ctResponse === void 0 ? void 0 : (ref = ctResponse.data) === null || ref === void 0 ? void 0 : ref.colorData;
                const currentSwatch = allSwatch === null || allSwatch === void 0 ? void 0 : (ref1 = allSwatch[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
                const productQuantity = await getInventoryBySku(currentSwatch);
                const details = ctResponse === null || ctResponse === void 0 ? void 0 : (ref2 = ctResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.varientDetails) === null || ref3 === void 0 ? void 0 : ref3.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === currentSwatch;
                })[0];
                setLoaded(false);
                setInventory(productQuantity);
                setVariantList(allSwatch);
                setVariant(currentSwatch);
                setItem({
                    ...ctResponse,
                    currentVarent: {
                        ...allSwatch[0],
                        details
                    }
                });
                setLoading("success");
            }
        }
    };
    const incrementCounter = ()=>{
        setCounter(counter + 1);
    };
    const decrementCounter = ()=>{
        if (counter > 1) setCounter(counter - 1);
    };
    const handlerCounter = (val)=>{
        const count = Number(val);
        if (count && count >= 1) {
            setCounter(count);
        }
    };
    const handlerCart = (productInfo)=>{
        var ref;
        setLoaded(true);
        setIsAdding("adding");
        const data = [
            {
                sku: productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.currentVarent) === null || ref === void 0 ? void 0 : ref.id,
                quantity: counter,
                isBundleProduct: false,
                isBundle: false,
                brand: "kohler"
            }
        ];
        (0,shareCartHelper/* shareaddToCart */.J9)(data, "", (isFailed, res)=>{
            if (!isFailed && res) {
                updateCartFlag(counter);
                setLoaded(false);
                setIsAdding("done");
                setShowCart(false);
                const serviceVS = JSON.parse(localStorage.getItem("serviceVS"));
                if (serviceVS) {
                    const datavs = JSON.parse(localStorage.getItem("servicePartsVs")) || [];
                    datavs.push(productInfo === null || productInfo === void 0 ? void 0 : productInfo.productId);
                    sessionStorage.setItem("servicePartsVs", JSON.stringify(datavs));
                }
                partsAddToCartEvent(analytics, productInfo);
            }
        });
    };
    const getInventoryBySku = async (sku)=>{
        var ref;
        const { inventories =[]  } = await (0,productServices/* getProductInventory */.o)(sku);
        return inventories.length ? (ref = inventories[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
    };
    (0,react.useEffect)(()=>{
        const closeAddCart = (event)=>{
            if (cartRef.current && !cartRef.current.contains(event.target)) setShowCart(false);
        };
        document.addEventListener("mousedown", closeAddCart);
        return ()=>document.removeEventListener("mousedown", closeAddCart);
    }, [
        setShowCart
    ]);
    const checkNoswatchfullWidth = cartFlagFullWidth && variantList.length < 1;
    const checWithswatchfullWidth = cartFlagFullWidth && variantList.length > 1;
    const itemStock = (item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : (ref1 = ref.details) === null || ref1 === void 0 ? void 0 : ref1.discontinued) === false && ((item === null || item === void 0 ? void 0 : (ref2 = item.currentVarent) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : ref3.isStock) === "false" || inventory === 0);
    const itemDiscontinue = item === null || item === void 0 ? void 0 : (ref4 = item.currentVarent) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.details) === null || ref5 === void 0 ? void 0 : ref5.discontinued;
    const showStockMessage = itemStock && variantList.length <= 1;
    const swatchClass = "align-items-center w-100";
    const swatchesCls = checWithswatchfullWidth && !itemStock ? "w-50 align-items-start" : swatchClass;
    const fullscreenClass = checkNoswatchfullWidth || itemDiscontinue ? "w-100 align-items-start" : swatchesCls;
    const getButtonLabel = (isLoad)=>{
        if (isLoad && isAdding === "") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoadingIcon */.Ho, {});
        }
        if (isLoad && isAdding === "adding") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoadingIcon */.Ho, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "adding-label",
                        children: addingCartText
                    })
                ]
            });
        }
        if (!isLoad && isAdding === "done") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddedIcon */.tW, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "adding-label",
                        children: addedCartText
                    })
                ]
            });
        } else {
            return addToCart;
        }
    };
    const updateCartFlag = (quantity)=>{
        const message = {
            quantity,
            status: true
        };
        setCartToast(message);
    };
    let overlaySection;
    if (!isSmallScreen) {
        overlaySection = isListExtend ? "position-overlay-fixed" : "position-overlay-absolute";
    }
    const buttonHandler = ()=>{
        if (!loaded) {
            handlerCart({
                ...item,
                fileTitle: title,
                quantity: counter,
                pdpDetails
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "add-cart-modal ".concat((AddCart_index_module_default()).CartModalViewer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "soverlay ".concat(overlaySection)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: cartRef,
                className: "popup-cart-section ".concat(overlaySection, "  ").concat(!isDesktop && showCart ? "mobile-snack-overlay" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-wrappers mobile-dropdown ".concat(loading === "loading" ? "loading-part" : "h-100"),
                    children: loading === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddToCartLoadingIcon */.Qb, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Container, {
                        fluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-column cart-content-dialogs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(isListExtend ? "main-content" : ""),
                                    children: showStockMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "button-carts notify-it",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                            item: item,
                                            fromCart: true,
                                            isListExtend: isListExtend,
                                            showStockMessage: showStockMessage
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCart_PriceLabel, {
                                                priceInfo: item,
                                                itemStock: itemStock
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "color-content",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "color-content-inner ".concat(checWithswatchfullWidth && !itemDiscontinue ? "d-flex" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "color-content-text  ".concat(fullscreenClass, "  "),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "fs-16 fw-300 text-color",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "fw-400 mr-5",
                                                                            children: colorFinish
                                                                        }),
                                                                        (item === null || item === void 0 ? void 0 : (ref6 = item.currentVarent) === null || ref6 === void 0 ? void 0 : ref6.label) || "N/A"
                                                                    ]
                                                                }),
                                                                variantList.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwatchItems/* default */.Z, {
                                                                    variantList: variantList,
                                                                    setVariant: setVariant,
                                                                    variant: variant,
                                                                    isListExtend: cartFlagFullWidth
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "d-flex justify-content-center flex-column ".concat(fullscreenClass, " ").concat(checWithswatchfullWidth ? "carts-fullwidth" : ""),
                                                            children: [
                                                                inventoryWarn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "inventory-warning-section",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* WarnIcon */.e6, {}),
                                                                        " ",
                                                                        inventoryTextVal(inventory)
                                                                    ]
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "button-carts d-flex flex-row justify-content-center align-items-end mt-3",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "d-flex flex-column processing-div ".concat(loaded ? "processing" : ""),
                                                                        children: [
                                                                            !(item === null || item === void 0 ? void 0 : (ref7 = item.currentVarent) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : ref8.discontinued) && loading === "success" && inventory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "addtocart-widgets d-flex",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "counter-widgets d-flex",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                className: "decrement-widgets",
                                                                                                onClick: decrementCounter,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DecIcon */.Nh, {})
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                type: "number",
                                                                                                onChange: (e)=>{
                                                                                                    var ref;
                                                                                                    return handlerCounter(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                                                                },
                                                                                                value: counter
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                className: "increment-widgets",
                                                                                                onClick: incrementCounter,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IncIcon */.M9, {})
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                        label: getButtonLabel(loaded),
                                                                                        onClick: buttonHandler,
                                                                                        disabled: loaded,
                                                                                        tag: "button",
                                                                                        className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(isAdding !== "" ? "disabled" : ""),
                                                                                        parentClass: "button-carts"
                                                                                    })
                                                                                ]
                                                                            }) : null,
                                                                            itemStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                                                                showStockMessage: showStockMessage,
                                                                                item: item,
                                                                                fromCart: true,
                                                                                isListExtend: isListExtend,
                                                                                itemStock: itemStock
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
AddCart.propTypes = {
    productId: (prop_types_default()).string.isRequired,
    setShowCart: (prop_types_default()).func.isRequired,
    showCart: (prop_types_default()).bool.isRequired,
    setCartToast: (prop_types_default()).func.isRequired,
    analytics: (prop_types_default()).object.isRequired,
    title: (prop_types_default()).string.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    partController: prop_types_default().shape({
        actions: prop_types_default().shape({
            get: prop_types_default().shape({
                entryByKey: (prop_types_default()).func.isRequired
            })
        })
    })
};
/* harmony default export */ var v2_AddCart = (AddCart);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/index.js













const GridAndListPanel = (props)=>{
    var ref, ref1;
    const { partsList , setIsListExtend , isListExtend , title , limit =6 , showPopup , partController , sku , showCart , setShowCart , showCartPopUp , productId , setCartToast , analytics , selectedFile , siteName  } = props || {};
    const [listView, setlistView] = (0,react.useState)(false);
    const [trigger, callTrigger] = hooks_useTrigger();
    const device = (0,useViewport/* default */.Z)();
    const loadCount = (partsList === null || partsList === void 0 ? void 0 : partsList.length) < limit ? partsList === null || partsList === void 0 ? void 0 : partsList.length : limit;
    const visibleCount = (ref = partController.actions.get.firstEntries()) === null || ref === void 0 ? void 0 : ref.length;
    const totalCount = partsList === null || partsList === void 0 ? void 0 : partsList.length;
    const [visibleData, setVisibleData] = (0,react.useState)(loadCount);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { loadMore , backToTop , totalCountText , expandText , exitExpandText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>callTrigger(), [
        title
    ]);
    (0,react.useEffect)(()=>{
        if (visibleCount < limit) partController.actions.fetchCTAny(loadCount);
    }, [
        trigger
    ]);
    const scrollToTop = ()=>{
        const ele = document.querySelector(".right-panel");
        if (ele) {
            ele.scrollIntoView({
                behaviour: "smooth"
            });
        }
    };
    const loadMoreitems = (e)=>{
        setVisibleData(visibleData + loadCount);
        partController.actions.fetchCTAny(visibleData);
    };
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-list-viewer h-100",
        "data-testid": "right-panel-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Container, {
                fluid: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row, {
                        className: "right-panel",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col, {
                            className: "d-flex justify-content-between align-items-center",
                            children: [
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ToggleView, {
                                    listView,
                                    setlistView,
                                    device,
                                    title,
                                    sku
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex align-items-center justify-content-center",
                                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: ()=>{
                                            setIsListExtend((state)=>!state);
                                        },
                                        "data-testid": "expand-button",
                                        className: "expand-button btn-expand border-0 d-flex align-items-center justify-content-center list-view-icons",
                                        children: [
                                            isListExtend ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconCollapse */.bt, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconExpandGrid */.wO, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tool-tip-custom bottom",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: !isListExtend ? expandText : exitExpandText
                                                })
                                            })
                                        ]
                                    }) : null
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row, {
                        className: "flex-column gird-content",
                        children: [
                            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col, {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    level: 3,
                                    fontSize: 26,
                                    className: "heading-grid",
                                    fontWeight: 300,
                                    children: title
                                })
                            }) : "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex flex-row align-items-center justify-content-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "total_item",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "total-count fw-400 ".concat(isListExtend ? "full-screen-view" : "small-screen-view"),
                                                children: [
                                                    (partsList === null || partsList === void 0 ? void 0 : partsList.length) || 0,
                                                    " ",
                                                    totalCountText
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_SortDropdown, {
                                            partController,
                                            visibleData,
                                            title,
                                            sku,
                                            setlistView,
                                            listView,
                                            isListExtend
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col, {
                                className: "d-flex align-items-center flex-column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "list-items ".concat(listView ? "d-flex justify-content-between flex-column" : "thumbnail-items ".concat(device.isDesktop ? "full-screens" : "")),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ViewController, {
                                                partController,
                                                isListView: listView,
                                                isListExtend,
                                                showPopup,
                                                visibleData,
                                                title,
                                                sku,
                                                showCart,
                                                setShowCart,
                                                showCartPopUp,
                                                selectedFile,
                                                siteName
                                            }),
                                            (ref1 = Array.from({
                                                length: 6
                                            }, (val, index)=>index + 1)) === null || ref1 === void 0 ? void 0 : ref1.map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "card empty-card"
                                                }, val))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "load-more d-flex align-items-center flex-column w-100",
                                        children: visibleData < totalCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: loadMoreitems,
                                            className: "load-more-button fs-18 fw-400 w-100",
                                            children: loadMore
                                        }) : null
                                    }),
                                    totalCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "back-to-top",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: ()=>scrollToTop(),
                                                className: "mx-2",
                                                children: backToTop
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* BackToTop */.zu, {})
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }),
            showCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_AddCart, {
                productId: productId,
                showCart: showCart,
                setShowCart: setShowCart,
                partController: partController,
                analytics: analytics,
                isListExtend: isListExtend,
                setCartToast: setCartToast,
                selectedFile: selectedFile
            }) : null
        ]
    });
};
/* harmony default export */ var v2_GridAndListPanel = (GridAndListPanel);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/DesktopView/index.js








const DesktopView = (props)=>{
    const { selectedFile , fullscreen , expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , partController , sku , loading , analytics , setWidthSize , widthSize , showCart , setShowCart , showCartPopUp , setCartToast , siteName  } = props || {};
    if (loading.error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    right: popupModal && fullscreen ? widthSize : 0 + "px",
                    width: popupModal && fullscreen ? "auto" : ""
                },
                className: "".concat(isListExtend ? "" : "fullscreen-extend", " left"),
                children: !(loading === null || loading === void 0 ? void 0 : loading.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsDiagramViewer, {
                    expandHandler: expandHandler,
                    fullscreen: fullscreen,
                    showPopup: showPopup,
                    selectedFile: selectedFile,
                    partController: partController,
                    sku: sku,
                    title: title,
                    siteName: siteName
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
            }),
            !(loading === null || loading === void 0 ? void 0 : loading.error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(isListExtend ? "fullscreen-extend" : "", " fullscreen-right h-100"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_GridAndListPanel, {
                    partsList: partsList,
                    setIsListExtend: setIsListExtend,
                    isListExtend: isListExtend,
                    title: title,
                    showPopup: showPopup,
                    partController: partController,
                    sku: sku,
                    showCart: showCart,
                    setShowCart: setShowCart,
                    showCartPopUp: showCartPopUp,
                    productId: productId,
                    analytics: analytics,
                    fullscreen: fullscreen,
                    setWidthSize: setWidthSize,
                    setCartToast: setCartToast,
                    selectedFile: selectedFile,
                    siteName: siteName
                })
            }) : "",
            popupModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_DetailPopUp, {
                productId: productId,
                setModal: setModal,
                partController: partController,
                sku: sku,
                title: title,
                analytics: analytics,
                fullscreen: fullscreen,
                setWidthSize: setWidthSize,
                selectedFile: selectedFile,
                siteName: siteName
            }) : ""
        ]
    });
};
DesktopView.propTypes = {
    widthSize: (prop_types_default()).number.isRequired,
    setWidthSize: (prop_types_default()).func.isRequired
};
/* harmony default export */ var SelectedFileView_DesktopView = (DesktopView);

;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/uncontrollable/lib/esm/index.js
function esm_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function esm_toPropertyKey(arg) { var key = esm_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function esm_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function esm_defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function esm_useUncontrolledProp(propValue, defaultValue, handler) {
  const wasPropRef = (0,react.useRef)(propValue !== undefined);
  const [stateValue, setState] = (0,react.useState)(defaultValue);
  const isProp = propValue !== undefined;
  const wasProp = wasPropRef.current;
  wasPropRef.current = isProp;

  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */
  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }
  return [isProp ? propValue : stateValue, (0,react.useCallback)((...args) => {
    const [value, ...rest] = args;
    let returnValue = handler == null ? void 0 : handler(value, ...rest);
    setState(value);
    return returnValue;
  }, [handler])];
}

function esm_useUncontrolled(props, config) {
  return Object.keys(config).reduce((result, fieldName) => {
    const _ref = result,
      _defaultKey = esm_defaultKey(fieldName),
      {
        [_defaultKey]: defaultValue,
        [fieldName]: propsValue
      } = _ref,
      rest = esm_objectWithoutPropertiesLoose(_ref, [_defaultKey, fieldName].map(esm_toPropertyKey));
    const handlerName = config[fieldName];
    const [value, handler] = esm_useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
    return Object.assign({}, rest, {
      [fieldName]: value,
      [handlerName]: handler
    });
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/react-aria/dist/private/ssr/SSRProvider.mjs


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $c7eafbbe1ea5834e$var$SSRContext = /*#__PURE__*/ (0, react).createContext($c7eafbbe1ea5834e$var$defaultContext);
const $c7eafbbe1ea5834e$var$IsSSRContext = /*#__PURE__*/ (0, react).createContext(false);
// This is only used in React < 18.
function $c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $bl59K$useContext)($c7eafbbe1ea5834e$var$SSRContext);
    let counter = $c7eafbbe1ea5834e$var$useCounter(cur === $c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $bl59K$useState)(true);
    let value = (0, $bl59K$useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bl59K$useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return /*#__PURE__*/ (0, $bl59K$react).createElement($c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, $bl59K$react).createElement($c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $c7eafbbe1ea5834e$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, $bl59K$react)['useId'] === 'function') {
        if (false) {}
        return /*#__PURE__*/ (0, $bl59K$react).createElement((0, $bl59K$react).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, $bl59K$react).createElement($c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, react.useContext)($c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (0, react).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) // On the first render, and first call to useId, store the id and state in our weak map.
            $c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, react.useContext)($c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $c7eafbbe1ea5834e$var$defaultContext && !$c7eafbbe1ea5834e$var$canUseDOM && "production" !== 'production') {}
    let counter = $c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = ctx === $c7eafbbe1ea5834e$var$defaultContext && "production" === 'test' ? 0 : `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, react).useId();
    let [didSSR] = (0, react.useState)($c7eafbbe1ea5834e$export$535bd6ca7f90a273());
    let prefix = didSSR || "production" === 'test' ? 'react-aria' : `react-aria${$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $c7eafbbe1ea5834e$export$619500959fc48b26 = typeof (0, react)['useId'] === 'function' ? $c7eafbbe1ea5834e$var$useModernSSRSafeId : $c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $c7eafbbe1ea5834e$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, react)['useSyncExternalStore'] === 'function') return (0, react)['useSyncExternalStore']($c7eafbbe1ea5834e$var$subscribe, $c7eafbbe1ea5834e$var$getSnapshot, $c7eafbbe1ea5834e$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, react.useContext)($c7eafbbe1ea5834e$var$IsSSRContext);
}



//# sourceMappingURL=SSRProvider.mjs.map

;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/TabContext.js

const TabContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var esm_TabContext = (TabContext);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/SelectableContext.js

const SelectableContext = /*#__PURE__*/react.createContext(null);
const makeEventKey = (eventKey, href = null) => {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ var esm_SelectableContext = (SelectableContext);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/TabPanel.js
const TabPanel_excluded = ["active", "eventKey", "mountOnEnter", "transition", "unmountOnExit", "role", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"],
  _excluded2 = ["activeKey", "getControlledId", "getControllerId"],
  _excluded3 = ["as"];
function TabPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }






function useTabPanel(_ref) {
  let {
      active,
      eventKey,
      mountOnEnter,
      transition,
      unmountOnExit,
      role = 'tabpanel',
      onEnter,
      onEntering,
      onEntered,
      onExit,
      onExiting,
      onExited
    } = _ref,
    props = TabPanel_objectWithoutPropertiesLoose(_ref, TabPanel_excluded);
  const context = (0,react.useContext)(esm_TabContext);
  if (!context) return [Object.assign({}, props, {
    role
  }), {
    eventKey,
    isActive: active,
    mountOnEnter,
    transition,
    unmountOnExit,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited
  }];
  const {
      activeKey,
      getControlledId,
      getControllerId
    } = context,
    rest = TabPanel_objectWithoutPropertiesLoose(context, _excluded2);
  const key = makeEventKey(eventKey);
  return [Object.assign({}, props, {
    role,
    id: getControlledId(eventKey),
    'aria-labelledby': getControllerId(eventKey)
  }), {
    eventKey,
    isActive: active == null && key != null ? makeEventKey(activeKey) === key : active,
    transition: transition || rest.transition,
    mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
    unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited
  }];
}
const TabPanel = /*#__PURE__*/react.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref) => {
  let {
      as: Component = 'div'
    } = _ref2,
    props = TabPanel_objectWithoutPropertiesLoose(_ref2, _excluded3);
  const [tabPanelProps, {
    isActive,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    mountOnEnter,
    unmountOnExit,
    transition: Transition = esm_NoopTransition
  }] = useTabPanel(props);
  // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
  // conflict with the top level one.
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContext.Provider, {
    value: null,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
      value: null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
        in: isActive,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, tabPanelProps, {
          ref: ref,
          hidden: !isActive,
          "aria-hidden": !isActive
        }))
      })
    })
  });
});
TabPanel.displayName = 'TabPanel';
/* harmony default export */ var esm_TabPanel = (TabPanel);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Tabs.js








const Tabs = props => {
  const {
    id: userId,
    generateChildId: generateCustomChildId,
    onSelect: propsOnSelect,
    activeKey: propsActiveKey,
    defaultActiveKey,
    transition,
    mountOnEnter,
    unmountOnExit,
    children
  } = props;
  const [activeKey, onSelect] = esm_useUncontrolledProp(propsActiveKey, defaultActiveKey, propsOnSelect);
  const id = $c7eafbbe1ea5834e$export$619500959fc48b26(userId);
  const generateChildId = (0,react.useMemo)(() => generateCustomChildId || ((key, type) => id ? `${id}-${type}-${key}` : null), [id, generateCustomChildId]);
  const tabContext = (0,react.useMemo)(() => ({
    onSelect,
    activeKey,
    transition,
    mountOnEnter: mountOnEnter || false,
    unmountOnExit: unmountOnExit || false,
    getControlledId: key => generateChildId(key, 'tabpane'),
    getControllerId: key => generateChildId(key, 'tab')
  }), [onSelect, activeKey, transition, mountOnEnter, unmountOnExit, generateChildId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContext.Provider, {
    value: tabContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
      value: onSelect || null,
      children: children
    })
  });
};
Tabs.Panel = esm_TabPanel;
/* harmony default export */ var esm_Tabs = (Tabs);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/getTabTransitionComponent.js


function getTabTransitionComponent(transition) {
  if (typeof transition === 'boolean') {
    return transition ? esm_Fade : esm_NoopTransition;
  }
  return transition;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContainer.js



const TabContainer = ({
  transition,
  ...props
}) => /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Tabs, {
  ...props,
  transition: getTabTransitionComponent(transition)
});
TabContainer.displayName = 'TabContainer';
/* harmony default export */ var esm_TabContainer = (TabContainer);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContent.js
"use client";





const TabContent = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tab-content');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
TabContent.displayName = 'TabContent';
/* harmony default export */ var esm_TabContent = (TabContent);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabPane.js
"use client";










const TabPane = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  transition,
  ...props
}, ref) => {
  const [{
    className,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    ...rest
  }, {
    isActive,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    mountOnEnter,
    unmountOnExit,
    transition: Transition = esm_Fade
  }] = useTabPanel({
    ...props,
    transition: getTabTransitionComponent(transition)
  });
  const prefix = useBootstrapPrefix(bsPrefix, 'tab-pane');

  // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
  // conflict with the top level one.
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContext.Provider, {
    value: null,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
      value: null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
        in: isActive,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
          ...rest,
          ref: ref,
          className: classnames_default()(className, prefix, isActive && 'active')
        })
      })
    })
  });
});
TabPane.displayName = 'TabPane';
/* harmony default export */ var esm_TabPane = (TabPane);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tab.js




const Tab_propTypes = {
  eventKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  /**
   * Content for the tab title.
   */
  title: (prop_types_default()).node.isRequired,
  /**
   * The disabled state of the tab.
   */
  disabled: (prop_types_default()).bool,
  /**
   * Class to pass to the underlying nav link.
   */
  tabClassName: (prop_types_default()).string,
  /**
   * Object containing attributes to pass to underlying nav link.
   */
  tabAttrs: (prop_types_default()).object
};
const Tab = () => {
  throw new Error('ReactBootstrap: The `Tab` component is not meant to be rendered! ' + "It's an abstract component that is only valid as a direct Child of the `Tabs` Component. " + 'For custom tabs components use TabPane and TabsContainer directly');
};
Tab.propTypes = Tab_propTypes;
/* harmony default export */ var esm_Tab = (Object.assign(Tab, {
  Container: esm_TabContainer,
  Content: esm_TabContent,
  Pane: esm_TabPane
}));
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useForceUpdate.js


/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */
function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are strictly equal to the last state value
  const [, dispatch] = (0,react.useReducer)(revision => revision + 1, 0);
  return dispatch;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/NavContext.js

const NavContext = /*#__PURE__*/react.createContext(null);
NavContext.displayName = 'NavContext';
/* harmony default export */ var esm_NavContext = (NavContext);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Button.js
const Button_excluded = ["as", "disabled"];
function Button_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }


function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }
  const meta = {
    tagName
  };
  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }
  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');
    if (disabled) {
      href = undefined;
    }
  }
  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button_Button = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      as: asProp,
      disabled
    } = _ref,
    props = Button_objectWithoutPropertiesLoose(_ref, Button_excluded);
  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button_Button.displayName = 'Button';
/* harmony default export */ var esm_Button = (Button_Button);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/NavItem.js
const NavItem_excluded = ["as", "active", "eventKey"];
function NavItem_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }









function useNavItem({
  key,
  onClick,
  active,
  id,
  role,
  disabled
}) {
  const parentOnSelect = (0,react.useContext)(esm_SelectableContext);
  const navContext = (0,react.useContext)(esm_NavContext);
  const tabContext = (0,react.useContext)(esm_TabContext);
  let isActive = active;
  const props = {
    role
  };
  if (navContext) {
    if (!role && navContext.role === 'tablist') props.role = 'tab';
    const contextControllerId = navContext.getControllerId(key != null ? key : null);
    const contextControlledId = navContext.getControlledId(key != null ? key : null);

    // @ts-ignore
    props[dataAttr('event-key')] = key;
    props.id = contextControllerId || id;
    isActive = active == null && key != null ? navContext.activeKey === key : active;

    /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */
    if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
  }
  if (props.role === 'tab') {
    props['aria-selected'] = isActive;
    if (!isActive) {
      props.tabIndex = -1;
    }
    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }
  }
  props.onClick = esm_useEventCallback_useEventCallback(e => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(e);
    if (key == null) {
      return;
    }
    if (parentOnSelect && !e.isPropagationStopped()) {
      parentOnSelect(key, e);
    }
  });
  return [props, {
    isActive
  }];
}
const NavItem = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      as: Component = esm_Button,
      active,
      eventKey
    } = _ref,
    options = NavItem_objectWithoutPropertiesLoose(_ref, NavItem_excluded);
  const [props, meta] = useNavItem(Object.assign({
    key: makeEventKey(eventKey, options.href),
    active
  }, options));

  // @ts-ignore
  props[dataAttr('active')] = meta.isActive;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, options, props, {
    ref: ref
  }));
});
NavItem.displayName = 'NavItem';
/* harmony default export */ var esm_NavItem = (NavItem);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Nav.js
const Nav_excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];
function Nav_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }











// eslint-disable-next-line @typescript-eslint/no-empty-function
const Nav_noop = () => {};
const EVENT_KEY_ATTR = dataAttr('event-key');
const Nav = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
      as: Component = 'div',
      onSelect,
      activeKey,
      role,
      onKeyDown
    } = _ref,
    props = Nav_objectWithoutPropertiesLoose(_ref, Nav_excluded);
  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  const forceUpdate = useForceUpdate();
  const needsRefocusRef = (0,react.useRef)(false);
  const parentOnSelect = (0,react.useContext)(esm_SelectableContext);
  const tabContext = (0,react.useContext)(esm_TabContext);
  let getControlledId, getControllerId;
  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey;
    // TODO: do we need to duplicate these?
    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }
  const listNode = (0,react.useRef)(null);
  const getNextActiveTab = offset => {
    const currentListNode = listNode.current;
    if (!currentListNode) return null;
    const items = qsa(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
    const activeChild = currentListNode.querySelector('[aria-selected=true]');
    if (!activeChild || activeChild !== document.activeElement) return null;
    const index = items.indexOf(activeChild);
    if (index === -1) return null;
    let nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };
  const handleSelect = (key, event) => {
    if (key == null) return;
    onSelect == null ? void 0 : onSelect(key, event);
    parentOnSelect == null ? void 0 : parentOnSelect(key, event);
  };
  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    if (!tabContext) {
      return;
    }
    let nextActiveChild;
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveTab(-1);
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveTab(1);
        break;
      default:
        return;
    }
    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset[dataProp('EventKey')] || null, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };
  (0,react.useEffect)(() => {
    if (listNode.current && needsRefocusRef.current) {
      const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
      activeChild == null ? void 0 : activeChild.focus();
    }
    needsRefocusRef.current = false;
  });
  const mergedRef = hooks_esm_useMergedRefs(ref, listNode);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_NavContext.Provider, {
      value: {
        role,
        // used by NavLink to determine it's role
        activeKey: makeEventKey(activeKey),
        getControlledId: getControlledId || Nav_noop,
        getControllerId: getControllerId || Nav_noop
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
      }))
    })
  });
});
Nav.displayName = 'Nav';
/* harmony default export */ var esm_Nav = (Object.assign(Nav, {
  Item: esm_NavItem
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavbarContext.js
"use client";



// TODO: check

const context = /*#__PURE__*/react.createContext(null);
context.displayName = 'NavbarContext';
/* harmony default export */ var NavbarContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
"use client";


const CardHeaderContext_context = /*#__PURE__*/react.createContext(null);
CardHeaderContext_context.displayName = 'CardHeaderContext';
/* harmony default export */ var CardHeaderContext = (CardHeaderContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavItem.js
"use client";





const NavItem_NavItem = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
NavItem_NavItem.displayName = 'NavItem';
/* harmony default export */ var react_bootstrap_esm_NavItem = (NavItem_NavItem);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useEventListener.js


/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener_useEventListener(eventTarget, event, listener, capture = false) {
  const handler = useEventCallback(listener);
  useEffect(() => {
    const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return () => target.removeEventListener(event, handler, capture);
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useGlobalListener.js


/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture = false) {
  const documentTarget = useCallback(() => document, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useInterval.js



/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

/**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */

/**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */

function useInterval(fn, ms, paused = false, runImmediately = false) {
  let handle;
  const fnRef = useCommittedRef(fn);
  // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
  const pausedRef = useCommittedRef(paused);
  const tick = () => {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  const schedule = () => {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };
  useEffect(() => {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }
    return () => clearTimeout(handle);
  }, [paused, runImmediately]);
}
/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useRafInterval.js


function useRafInterval(fn, ms, paused = false) {
  let handle;
  let start = new Date().getTime();
  const fnRef = useCommittedRef(fn);
  // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
  const pausedRef = useCommittedRef(paused);
  function loop() {
    const current = new Date().getTime();
    const delta = current - start;
    if (pausedRef.current) return;
    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }
    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }
  useEffect(() => {
    handle = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(handle);
  }, []);
}
/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMergeState.js


/**
 * Updates state, partial updates are merged into existing state values
 */

/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  const [state, setState] = useState(initialState);
  const updater = useCallback(update => {
    if (update === null) return;
    if (typeof update === 'function') {
      setState(state => {
        const nextState = update(state);
        return nextState == null ? state : Object.assign({}, state, nextState);
      });
    } else {
      setState(state => Object.assign({}, state, update));
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  const [state, setState] = useMergeState(initialState);
  const nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useImage.js

/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  const [state, setState] = useState({
    image: null,
    error: null
  });
  useEffect(() => {
    if (!imageOrUrl) return undefined;
    let image;
    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;
      if (image.complete && image.naturalHeight > 0) {
        setState({
          image,
          error: null
        });
        return;
      }
    }
    function onLoad() {
      setState({
        image,
        error: null
      });
    }
    function onError(error) {
      setState({
        image,
        error
      });
    }
    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useResizeObserver.js


const targetMap = new WeakMap();
let resizeObserver;
function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(entries => {
    entries.forEach(entry => {
      const handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}

/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */
function useResizeObserver(element) {
  const [rect, setRect] = useState(null);
  useEffect(() => {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, rect => {
      setRect(rect);
    });
    return () => {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/index.js














;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Anchor.js
const Anchor_excluded = ["onKeyDown"];
function Anchor_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */





function Anchor_isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      onKeyDown
    } = _ref,
    props = Anchor_objectWithoutPropertiesLoose(_ref, Anchor_excluded);
  const [buttonProps] = useButtonProps(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = esm_useEventCallback_useEventCallback(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });
  if (Anchor_isTrivialHref(props.href) || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavLink.js
"use client";








const NavLink = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  as: Component = esm_Anchor,
  active,
  eventKey,
  disabled = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-link');
  const [navItemProps, meta] = useNavItem({
    key: makeEventKey(eventKey, props.href),
    active,
    disabled,
    ...props
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ...props,
    ...navItemProps,
    ref: ref,
    disabled: disabled,
    className: classnames_default()(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
  });
});
NavLink.displayName = 'NavLink';
/* harmony default export */ var esm_NavLink = (NavLink);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Nav.js
"use client";












const Nav_Nav = /*#__PURE__*/react.forwardRef((uncontrolledProps, ref) => {
  const {
    as = 'div',
    bsPrefix: initialBsPrefix,
    variant,
    fill = false,
    justify = false,
    navbar,
    navbarScroll,
    className,
    activeKey,
    ...props
  } = useUncontrolled(uncontrolledProps, {
    activeKey: 'onSelect'
  });
  const bsPrefix = useBootstrapPrefix(initialBsPrefix, 'nav');
  let navbarBsPrefix;
  let cardHeaderBsPrefix;
  let isNavbar = false;
  const navbarContext = (0,react.useContext)(NavbarContext);
  const cardHeaderContext = (0,react.useContext)(CardHeaderContext);
  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    ({
      cardHeaderBsPrefix
    } = cardHeaderContext);
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Nav, {
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classnames_default()(className, {
      [bsPrefix]: !isNavbar,
      [`${navbarBsPrefix}-nav`]: isNavbar,
      [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
      [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
      [`${bsPrefix}-${variant}`]: !!variant,
      [`${bsPrefix}-fill`]: fill,
      [`${bsPrefix}-justified`]: justify
    }),
    ...props
  });
});
Nav_Nav.displayName = 'Nav';
/* harmony default export */ var react_bootstrap_esm_Nav = (Object.assign(Nav_Nav, {
  Item: react_bootstrap_esm_NavItem,
  Link: esm_NavLink
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ElementChildren.js


/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */
function map(children, func) {
  let index = 0;
  return react.Children.map(children, child => /*#__PURE__*/react.isValidElement(child) ? func(child, index++) : child);
}

/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */
function forEach(children, func) {
  let index = 0;
  react.Children.forEach(children, child => {
    if ( /*#__PURE__*/react.isValidElement(child)) func(child, index++);
  });
}

/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */
function hasChildOfType(children, type) {
  return React.Children.toArray(children).some(child => /*#__PURE__*/React.isValidElement(child) && child.type === type);
}

;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tabs.js












function getDefaultActiveKey(children) {
  let defaultActiveKey;
  forEach(children, child => {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}
function renderTab(child) {
  const {
    title,
    eventKey,
    disabled,
    tabClassName,
    tabAttrs,
    id
  } = child.props;
  if (title == null) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_NavItem, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_NavLink, {
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName,
      ...tabAttrs,
      children: title
    })
  });
}
const Tabs_Tabs = props => {
  const {
    id,
    onSelect,
    transition,
    mountOnEnter = false,
    unmountOnExit = false,
    variant = 'tabs',
    children,
    activeKey = getDefaultActiveKey(children),
    ...controlledProps
  } = useUncontrolled(props, {
    activeKey: 'onSelect'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(esm_Tabs, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: getTabTransitionComponent(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Nav, {
      id: id,
      ...controlledProps,
      role: "tablist",
      as: "ul",
      variant: variant,
      children: map(children, renderTab)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContent, {
      children: map(children, child => {
        const childProps = {
          ...child.props
        };
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabPane, {
          ...childProps
        });
      })
    })]
  });
};
Tabs_Tabs.displayName = 'Tabs';
/* harmony default export */ var react_bootstrap_esm_Tabs = (Tabs_Tabs);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/MobileView/index.js













const MobileView = (props)=>{
    const { expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , selected , tabsActive , panelState , onClose , partController , sku , prefeedbackController , loading , analytics , setWidthSize , showCart , setShowCart , showCartPopUp , setCartToast , selectedFile , siteName  } = props || {};
    const { isDesktop  } = (0,useViewport/* default */.Z)();
    (0,react.useEffect)(()=>prefeedbackController(false), []);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { parts , diagramText  } = (0,localization/* getTranslations */.F)(t);
    const selectionChange = (selection)=>{
        onClose(false);
        prefeedbackController(selection === "parts");
    };
    if (loading.error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-tabs d-flex flex-column w-100 ".concat(tabsActive === "parts" ? "parts-section" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_bootstrap_esm_Tabs, {
                    defaultActiveKey: "diagram",
                    className: "mobile-view",
                    onSelect: (selection)=>selectionChange(selection),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tab, {
                            eventKey: "diagram",
                            title: diagramText,
                            className: "tab-diagram",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isListExtend ? "" : "fullscreen-extend", " left"),
                                children: !(loading === null || loading === void 0 ? void 0 : loading.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsDiagramViewer, {
                                    expandHandler: expandHandler,
                                    fullscreen: panelState,
                                    selectedFile: selected,
                                    showPopup: showPopup,
                                    partController: partController,
                                    sku: sku,
                                    title: title,
                                    siteName: siteName
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tab, {
                            eventKey: "parts",
                            title: parts,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isListExtend ? "fullscreen-extend" : "", " fullscreen-right h-100"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_GridAndListPanel, {
                                    partsList: partsList,
                                    setIsListExtend: setIsListExtend,
                                    isListExtend: isListExtend,
                                    title: title,
                                    showPopup: showPopup,
                                    partController: partController,
                                    sku: sku,
                                    showCart: showCart,
                                    setShowCart: setShowCart,
                                    showCartPopUp: showCartPopUp,
                                    productId: productId,
                                    analytics: analytics,
                                    setCartToast: setCartToast,
                                    siteName: siteName
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-popup ".concat(!isDesktop && popupModal ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_DetailPopUp, {
                    productId: productId,
                    setModal: setModal,
                    partController: partController,
                    sku: sku,
                    title: title,
                    analytics: analytics,
                    setWidthSize: setWidthSize,
                    selectedFile: selectedFile,
                    siteName: siteName
                })
            })
        ]
    });
};
MobileView.propTypes = {
    setWidthSize: (prop_types_default()).func.isRequired
};
/* harmony default export */ var SelectedFileView_MobileView = (MobileView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/index.js







const SelectedFileView = (props)=>{
    const { selectedFile , expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , selected , tabsActive , panelState , onClose , sku , prefeedbackController , loading , analytics , showCart , setShowCart , showCartPopUp , siteName  } = props || {};
    const [partsState, dispatch] = (0,react.useReducer)(partReducer, {
        parts: []
    });
    const [widthSize, setWidthSize] = (0,react.useState)(0);
    const [cartToast, setCartToast] = (0,react.useState)(null);
    const partsActions = getActions(partsState, dispatch);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { cartNotificationText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>partController.actions.initPartsList(selected), [
        selected
    ]);
    let isDesktop;
    const screenWidth = window.innerWidth;
    if (screenWidth > 812) {
        isDesktop = true;
    }
    const partController = {
        state: partsState,
        actions: partsActions
    };
    (0,react.useEffect)(()=>{
        let timeOut;
        if (cartToast === null || cartToast === void 0 ? void 0 : cartToast.status) {
            timeOut = setTimeout(()=>{
                setCartToast(null);
            }, 2000);
        }
        return ()=>{
            clearTimeout(timeOut);
        };
    });
    const value = (cartToast === null || cartToast === void 0 ? void 0 : cartToast.quantity) > 1 ? "Items" : "Item";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_MobileView, {
                expandHandler: expandHandler,
                panelState: panelState,
                showPopup: showPopup,
                selectedFile: selectedFile,
                partsList: partsList,
                setIsListExtend: setIsListExtend,
                isListExtend: isListExtend,
                title: title,
                productId: productId,
                tabsActive: tabsActive,
                setModal: setModal,
                popupModal: popupModal,
                selected: selected,
                onClose: onClose,
                sku: sku,
                partController: partController,
                prefeedbackController: prefeedbackController,
                loading: loading,
                analytics: analytics,
                setWidthSize: setWidthSize,
                showCart: showCart,
                setShowCart: setShowCart,
                showCartPopUp: showCartPopUp,
                setCartToast: setCartToast,
                siteName: siteName
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_DesktopView, {
                    expandHandler: expandHandler,
                    fullscreen: panelState,
                    showPopup: showPopup,
                    selectedFile: selectedFile,
                    partsList: partsList,
                    setIsListExtend: setIsListExtend,
                    isListExtend: isListExtend,
                    title: title,
                    productId: productId,
                    setModal: setModal,
                    popupModal: popupModal,
                    selected: selected,
                    partController: partController,
                    sku: sku,
                    loading: loading,
                    analytics: analytics,
                    setWidthSize: setWidthSize,
                    widthSize: widthSize,
                    showCart: showCart,
                    setShowCart: setShowCart,
                    showCartPopUp: showCartPopUp,
                    setCartToast: setCartToast,
                    siteName: siteName
                })
            }),
            (cartToast === null || cartToast === void 0 ? void 0 : cartToast.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-toast-message cart-toast-text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: cartNotificationText(cartToast === null || cartToast === void 0 ? void 0 : cartToast.quantity, value)
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var v2_SelectedFileView = (SelectedFileView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartViewerModal/index.js







const PartsViewerModal = (props)=>{
    const { files , fileMap , title , sku , skuImage , prefeedbackController , setParts , selectedFile , loading , analytics ={
        page: "na"
    } , setPartsHeight , productId , setShowPrint , siteName  } = props || {};
    const [selected, setSelected] = (0,react.useState)(selectedFile);
    const [selectedPart, setSelectedPart] = (0,react.useState)("");
    const [isListExtend, setIsListExtend] = (0,react.useState)(false);
    const [panelState, setPanelState] = (0,react.useState)(false);
    const device = (0,useViewport/* default */.Z)();
    const [popupModal, setPopupModal] = (0,react.useState)(false);
    const [tabsActive, setTabsActive] = (0,react.useState)("");
    const [showCart, setShowCart] = (0,react.useState)(false);
    let initialIndex;
    const isActive = (item)=>{
        return (item === null || item === void 0 ? void 0 : item.FileName) === (selected === null || selected === void 0 ? void 0 : selected.FileName);
    };
    for(let i = 0; i <= (files === null || files === void 0 ? void 0 : files.length) - 1; i++){
        var ref;
        if (((ref = files[i]) === null || ref === void 0 ? void 0 : ref.FileName) === (selected === null || selected === void 0 ? void 0 : selected.FileName)) {
            initialIndex = i;
        }
    }
    const getFileTitle = (name)=>{
        return (fileMap === null || fileMap === void 0 ? void 0 : fileMap[name]) === undefined ? name === null || name === void 0 ? void 0 : name.replace(/.svg/i, "") : fileMap === null || fileMap === void 0 ? void 0 : fileMap[name];
    };
    const showPopup = function(selectedItem) {
        let popupFlag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const getSelectedItems = selected === null || selected === void 0 ? void 0 : selected.Parts.filter((val)=>{
            return (val === null || val === void 0 ? void 0 : val.Cod) === selectedItem;
        });
        if (getSelectedItems.length !== 0) {
            setPopupModal(popupFlag);
            setSelectedPart(selectedItem);
        } else {
            setPopupModal(false);
        }
    };
    const showCartPopUp = (selectedItem)=>{
        setSelectedPart(selectedItem);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !(loading === null || loading === void 0 ? void 0 : loading.error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-fullscreen modal-container ".concat(device.isSmallScreen ? "mobile-viewer" : "", "  ").concat(panelState ? "fullscreen-viewer" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_FileSelection, {
                    files: files,
                    getFileTitle: getFileTitle,
                    isActive: isActive,
                    setSelected: setSelected,
                    setPopupModal: setPopupModal,
                    title: title,
                    sku: sku,
                    skuImage: skuImage,
                    setParts: setParts,
                    panelState: panelState,
                    initialIndex: initialIndex,
                    setPartsHeight: setPartsHeight,
                    productId: productId,
                    setShowPrint: setShowPrint,
                    siteName: siteName
                })
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "parts-modal-wrapper modal_content ".concat(device.isSmallScreen ? "align-items-start" : "", "  ").concat(panelState ? "fullscreen-viewer" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ErrorBoundary, {
                    FallBackComponent: ErrorFallBack,
                    params: {
                        title: getFileTitle(selected === null || selected === void 0 ? void 0 : selected.FileName)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SelectedFileView, {
                        expandHandler: ()=>setPanelState((state)=>!state),
                        panelState: panelState,
                        showPopup: showPopup,
                        selectedFile: selected,
                        partsList: selected === null || selected === void 0 ? void 0 : selected.Parts,
                        setIsListExtend: setIsListExtend,
                        isListExtend: isListExtend,
                        title: getFileTitle(selected === null || selected === void 0 ? void 0 : selected.FileName),
                        productId: selectedPart,
                        tabsActive: tabsActive,
                        setModal: setPopupModal,
                        popupModal: popupModal,
                        selected: selected,
                        onClose: setTabsActive,
                        sku: sku,
                        prefeedbackController: prefeedbackController,
                        loading: loading,
                        analytics: analytics,
                        showCart: showCart,
                        setShowCart: setShowCart,
                        showCartPopUp: showCartPopUp,
                        siteName: siteName
                    })
                }, selected === null || selected === void 0 ? void 0 : selected.FileName)
            })
        ]
    });
};
/* harmony default export */ var PartViewerModal = (PartsViewerModal);

// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(20558);
// EXTERNAL MODULE: ./components/PartsViewer/v2/partviewer.module.scss
var partviewer_module = __webpack_require__(22222);
var partviewer_module_default = /*#__PURE__*/__webpack_require__.n(partviewer_module);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Buttons_Button_Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartViewerFeedback/feedback.module.scss
var feedback_module = __webpack_require__(3766);
var feedback_module_default = /*#__PURE__*/__webpack_require__.n(feedback_module);
// EXTERNAL MODULE: ./services/medallia.js
var medallia = __webpack_require__(8229);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartViewerFeedback/index.jsx








const PartViewerFeedback = (props)=>{
    const { loading =true  } = props || {};
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { feedbackText  } = (0,localization/* getTranslations */.F)(t);
    const [formLoaded, setFormLoaded] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (window === null || window === void 0 ? void 0 : window.KAMPYLE_ONSITE_SDK) {
            var ref;
            const formLoadedT = window === null || window === void 0 ? void 0 : (ref = window.KAMPYLE_ONSITE_SDK) === null || ref === void 0 ? void 0 : ref.loadForm(MEDALLIA_FORM_ID);
            setFormLoaded(formLoadedT);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (feedback_module_default()).PartViewerFeedbackContainer,
        children: loading && formLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_Button_Button/* Button */.z, {
            className: "provide-feedback-button",
            "aria-label": feedbackText,
            label: feedbackText,
            size: "small",
            variant: "active",
            flexible: true,
            type: "button",
            onClick: ()=>(0,medallia/* showMedalliaFeedbackModal */.y0)(MEDALLIA_FORM_ID),
            children: feedbackText
        }) : null
    });
};
/* harmony default export */ var v2_PartViewerFeedback = (PartViewerFeedback);

;// CONCATENATED MODULE: ./i18n/usePartsDiagrami18n.js

const usePartsDiagram = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        printDiagrams: t("kf.myList.parts.partviewer.printDiagrams"),
        printAllText: t("kf.myList.parts.partviewer.printAllText"),
        printSelectedText: t("kf.myList.parts.partviewer.printSelectedText"),
        errorSorryText: t("kf.error.parts.partviewer.sorryErrorText"),
        errorTextTwo: t("kf.error.parts.partviewer.anyText"),
        errorContactText: t("kf.error.parts.partviewer.contact"),
        totalCountText: t("kf.plp.label.results"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        expandText: t("kf.myList.parts.partviewer.expand"),
        exitExpandText: t("kf.myList.parts.partviewer.exitExpand"),
        listPriceText: t("kf.list.table.listPrice"),
        gridViewText: t("kf.plp.label.gridView"),
        listViewText: t("kf.myList.parts.partviewer.listViewText"),
        sortByText: t("kf.plp.label.sort"),
        sortText: t("kf.plp.label.img.altSort"),
        exitFullScreenText: t("kf.myList.partViewer.exitFullScreenText"),
        fullScreenText: t("kf.myList.partViewer.fullScreenText"),
        coachMarkText: t("kf.myList.partViewer.coachMark"),
        listPriceDescText: t("kf.pdp.label.listPriceInfo"),
        colorFinish: t("kf.pdp.label.colorOrFinish"),
        parts: t("kf.search.label.parts"),
        diagramText: t("kf.myList.partViewer.diagramText")
    };
    return i18n;
};
/* harmony default export */ var usePartsDiagrami18n = (usePartsDiagram);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsViewer.jsx

















const PartsViewer = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { page ="" , analyticsCustomData =null , onClose =()=>{} , showModal =false , productId ="" , fileMap =[] , partId ="" , disableCloseBtn =false  } = props;
    const [parts, setParts] = (0,react.useState)("");
    const [partsheight, setPartsHeight] = (0,react.useState)("");
    const [trigger, triggerAction] = hooks_useTrigger();
    const [loading, setLoading] = (0,react.useState)({
        status: true,
        error: false
    });
    const [showPrint, setShowPrint] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [siteName, setSiteName] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const metaVal = "width=device-width, initial-scale=1.0";
        if (showModal) {
            var ref, ref1;
            (0,utils_0/* updateMetaContent */.uW)("viewport", "".concat(metaVal, ", maximum-scale=1.0, user-scalable=false"));
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("mavenoid-remove");
            document.addEventListener("touchmove", handlerViewport, false);
        }
        return ()=>{
            var ref, ref1;
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("mavenoid-remove");
            document.removeEventListener("touchmove", handlerViewport);
            (0,utils_0/* updateMetaContent */.uW)("viewport", metaVal);
        };
    }, [
        showModal
    ]);
    (0,react.useEffect)(()=>{
        if (productId && fileMap) {
            const obj = {};
            fileMap.forEach((item)=>{
                obj[item.id] = item.title;
            });
            productInfo(obj);
        }
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        (0,medallia/* initMedallia */.Ip)(MEDALLIA_FORM_ID);
    }, []);
    const handlerViewport = (event)=>{
        if ((event === null || event === void 0 ? void 0 : event.scale) !== 1) {
            event.preventDefault();
        }
    };
    const productInfo = async (obj)=>{
        const resp = await dispatch((0,pdpSlice/* getPartList */.gt)({
            productId
        })).unwrap();
        if (resp === null || resp === void 0 ? void 0 : resp.SVGFiles) {
            const { Info , SVGFiles  } = resp;
            const diagramFiles = fileMap.map((val)=>{
                const getfile = SVGFiles === null || SVGFiles === void 0 ? void 0 : SVGFiles.filter((v)=>{
                    return (v === null || v === void 0 ? void 0 : v.FileName) === (val === null || val === void 0 ? void 0 : val.id);
                });
                return {
                    ...getfile === null || getfile === void 0 ? void 0 : getfile[0],
                    ...val
                };
            });
            const activePart = diagramFiles === null || diagramFiles === void 0 ? void 0 : diagramFiles.filter((val)=>val.FileName === partId);
            const selectedFile = activePart.length !== 0 ? activePart[0] : diagramFiles[0];
            const listData = await getProjectionPartListData(selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.Parts);
            const priceList = listData.pricing;
            selectedFile.prices = priceList;
            selectedFile.replacementPartsInfo = listData.replacementPartsInfo;
            selectedFile.defaultPartsList = selectedFile.Parts;
            selectedFile.replacementParts = listData.replacementParts;
            selectedFile.Parts = getUpdatedReplaceFile(selectedFile);
            setParts({
                fileMap: obj,
                partsInfo: {
                    Info,
                    SVGFiles: diagramFiles
                },
                selectedFile
            });
            setLoading({
                status: false,
                error: false
            });
        } else setLoading({
            status: false,
            error: true
        });
    };
    const closeModal = ()=>{
        localStorage.removeItem("serviceVS");
        setParts("");
        setLoading({
            status: true,
            error: false
        });
        (0,helper/* preventBodyScroll */.MVu)(false);
        onClose();
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            const siteName = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName;
            setSiteName(siteName);
        }, []);
    });
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    let text1;
    let text2;
    let title;
    if ((parts === null || parts === void 0 ? void 0 : (ref = parts.partsInfo) === null || ref === void 0 ? void 0 : ref.Info) !== undefined) {
        var ref6, ref7, ref8, ref9;
        text1 = parts === null || parts === void 0 ? void 0 : (ref6 = parts.partsInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Info) === null || ref7 === void 0 ? void 0 : ref7["Product Name"];
        text2 = parts === null || parts === void 0 ? void 0 : (ref8 = parts.partsInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Info) === null || ref9 === void 0 ? void 0 : ref9["Short Description"];
        title = text1.replace(new RegExp(text2, "g"), "");
    }
    const prefeedbackController = ()=>{};
    const i18nTexts = usePartsDiagrami18n({}, {}, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_bootstrap_esm_Modal, {
        show: showModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        className: "partviwer-modal ".concat((partviewer_module_default()).PartDiagramViewer, " "),
        fullscreen: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartViewerFeedback, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "partviewer-modal-container part-".concat(partsheight, " ").concat(!parts ? "loading-text" : "", " ").concat(showPrint ? "print-widgets" : "", " ").concat(disableCloseBtn ? "standalone-parts" : ""),
                children: [
                    !disableCloseBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "close-btns",
                        onClick: closeModal,
                        "aria-label": i18nTexts === null || i18nTexts === void 0 ? void 0 : i18nTexts.servicePartsLabel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {})
                    }) : null,
                    !loading.status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PartViewerModal, {
                        trigger: trigger,
                        triggerAction: triggerAction,
                        files: parts === null || parts === void 0 ? void 0 : (ref1 = parts.partsInfo) === null || ref1 === void 0 ? void 0 : ref1.SVGFiles,
                        fileMap: parts === null || parts === void 0 ? void 0 : parts.fileMap,
                        prefeedbackController: prefeedbackController,
                        skuImage: parts === null || parts === void 0 ? void 0 : (ref2 = parts.partsInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Info) === null || ref3 === void 0 ? void 0 : ref3.Thumbnail,
                        title: title,
                        sku: parts === null || parts === void 0 ? void 0 : (ref4 = parts.partsInfo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Info) === null || ref5 === void 0 ? void 0 : ref5.Cod,
                        setParts: setParts,
                        selectedFile: parts === null || parts === void 0 ? void 0 : parts.selectedFile,
                        loading: loading,
                        analytics: {
                            page: page
                        },
                        setPartsHeight: setPartsHeight,
                        productId: productId,
                        setShowPrint: setShowPrint,
                        siteName: siteName
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var v2_PartsViewer = (PartsViewer);


/***/ }),

/***/ 73433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_core_ColorSwatch_ColorSwatch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32982);




const SwatchItems = (props)=>{
    const { variantList , setVariant , variant , clickSwatch =()=>{}  } = props || {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "swatch-list d-flex",
        children: variantList === null || variantList === void 0 ? void 0 : variantList.map((val, i)=>{
            var ref;
            const validSwatch = val === null || val === void 0 ? void 0 : (ref = val.colorUrl) === null || ref === void 0 ? void 0 : ref.split("/");
            if (validSwatch[(validSwatch === null || validSwatch === void 0 ? void 0 : validSwatch.length) - 1] === "swatch_NA") {
                return null;
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "radio",
                "aria-label": val.label,
                "aria-checked": val.id === variant ? true : false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ColorSwatch_ColorSwatch__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    type: "selector",
                    id: val.id,
                    name: val.name,
                    value: val.value,
                    label: val.label,
                    colorUrl: val.colorUrl,
                    checked: (val === null || val === void 0 ? void 0 : val.id) === variant,
                    onClick: ()=>{
                        setVariant(val === null || val === void 0 ? void 0 : val.id);
                        clickSwatch(val === null || val === void 0 ? void 0 : val.id);
                    }
                }, i)
            }, "".concat(val === null || val === void 0 ? void 0 : val.id, "-").concat(i));
        })
    });
};
SwatchItems.propTypes = {
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    setVariant: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
    variantList: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().array.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (SwatchItems);


/***/ }),

/***/ 7667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": function() { return /* binding */ IconZoomOut; },
/* harmony export */   "Eh": function() { return /* binding */ ImageListViewMobile; },
/* harmony export */   "Gr": function() { return /* binding */ PrintHeader; },
/* harmony export */   "Ho": function() { return /* binding */ LoadingIcon; },
/* harmony export */   "KL": function() { return /* binding */ DownIcon; },
/* harmony export */   "M9": function() { return /* binding */ IncIcon; },
/* harmony export */   "Nh": function() { return /* binding */ DecIcon; },
/* harmony export */   "PL": function() { return /* binding */ GridViewUnSelected; },
/* harmony export */   "Qb": function() { return /* binding */ AddToCartLoadingIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "WM": function() { return /* binding */ IconZoomIn; },
/* harmony export */   "Wz": function() { return /* binding */ ImageGridViewMobile; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "bt": function() { return /* binding */ IconCollapse; },
/* harmony export */   "cK": function() { return /* binding */ LoaderSpinner; },
/* harmony export */   "e6": function() { return /* binding */ WarnIcon; },
/* harmony export */   "iK": function() { return /* binding */ ResetActive; },
/* harmony export */   "pS": function() { return /* binding */ ListViewSelected; },
/* harmony export */   "qp": function() { return /* binding */ IconExpand; },
/* harmony export */   "rc": function() { return /* binding */ SortByIcon; },
/* harmony export */   "tR": function() { return /* binding */ SortByDropDownIcon; },
/* harmony export */   "tW": function() { return /* binding */ AddedIcon; },
/* harmony export */   "uN": function() { return /* binding */ IconReset; },
/* harmony export */   "wO": function() { return /* binding */ IconExpandGrid; },
/* harmony export */   "xD": function() { return /* binding */ CartCloseIcon; },
/* harmony export */   "zu": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* unused harmony exports LoadingImage, PlusIcon, MinusIcon, SortIcon, ImageThumbIcon, ImageListIcon, CrossButton, ModalCloseIcon, ExitFullScreenIcon, IconApiError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_images_spinner_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59001);



const IconReset = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.5625 26.25V24.625C11.9583 24.3958 9.83333 23.4583 8.1875 21.8125C6.54167 20.1667 5.60417 18.0417 5.375 15.4375H3.75V14.5625H5.375C5.60417 11.9583 6.54167 9.83333 8.1875 8.1875C9.83333 6.54167 11.9583 5.60417 14.5625 5.375V3.75H15.4375V5.375C18.0417 5.60417 20.1667 6.54167 21.8125 8.1875C23.4583 9.83333 24.3958 11.9583 24.625 14.5625H26.25V15.4375H24.625C24.3958 18.0417 23.4583 20.1667 21.8125 21.8125C20.1667 23.4583 18.0417 24.3958 15.4375 24.625V26.25H14.5625ZM15 23.75C17.4167 23.75 19.4792 22.8958 21.1875 21.1875C22.8958 19.4792 23.75 17.4167 23.75 15C23.75 12.5833 22.8958 10.5208 21.1875 8.8125C19.4792 7.10417 17.4167 6.25 15 6.25C12.5833 6.25 10.5208 7.10417 8.8125 8.8125C7.10417 10.5208 6.25 12.5833 6.25 15C6.25 17.4167 7.10417 19.4792 8.8125 21.1875C10.5208 22.8958 12.5833 23.75 15 23.75ZM15 18.375C14.0719 18.375 13.2773 18.0445 12.6164 17.3836C11.9555 16.7227 11.625 15.9281 11.625 15C11.625 14.0719 11.9555 13.2773 12.6164 12.6164C13.2773 11.9555 14.0719 11.625 15 11.625C15.9281 11.625 16.7227 11.9555 17.3836 12.6164C18.0445 13.2773 18.375 14.0719 18.375 15C18.375 15.9281 18.0445 16.7227 17.3836 17.3836C16.7227 18.0445 15.9281 18.375 15 18.375Z",
            fill: "#ffffff"
        })
    });
const IconZoomIn = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.5 15.5V25H15.5V15.5H25V14.5H15.5V5H14.5V14.5H5V15.5H14.5Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.5 15.5V25H15.5V15.5H25V14.5H15.5V5H14.5V14.5H5V15.5H14.5Z",
                fill: "#ffffff"
            })
        ]
    });
const IconZoomOut = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 14.5H25V15.5H5V14.5Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 14.5H25V15.5H5V14.5Z",
                fill: "#ffffff"
            })
        ]
    });
const IconExpand = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.6985 16.2919L13.4056 16.999L8.46951 21.9341L12.7302 21.9341V22.9341H6.7793L6.7793 16.9832H7.7793L7.77937 21.2101L12.6985 16.2919ZM22.3215 6.76526V12.7162H21.3215L21.3203 8.48826L16.1524 13.6575L15.4453 12.9504L20.6303 7.76426L16.3706 7.76526V6.76526H22.3215Z",
            fill: "#ffffff"
        })
    });
const IconExpandGrid = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M5.91917 10.2918L6.62628 10.9989L1.69021 15.934L5.95093 15.934V16.934H0L0 10.9831H1L1.00007 15.2099L5.91917 10.2918ZM15.5422 0.765137V6.71606H14.5422L14.541 2.48814L9.37307 7.65737L8.66596 6.95027L13.851 1.76414L9.59131 1.76514V0.765137H15.5422Z",
            fill: "#212121"
        })
    });
const IconCollapse = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.35338 17.4951L0.586914 16.7291L6.23617 11.0833H2.49991V10H8.0866V15.5833H7.00263V11.8493L1.35338 17.4951Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.0879 7.99515V2.41183H11.1719V6.14583L16.8211 0.5L17.5876 1.266L11.9383 6.91183H15.6746V7.99515H10.0879Z",
                fill: "#ffffff"
            })
        ]
    });
const ResetActive = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.5625 26.25V24.625C11.9583 24.3958 9.83333 23.4583 8.1875 21.8125C6.54167 20.1667 5.60417 18.0417 5.375 15.4375H3.75V14.5625H5.375C5.60417 11.9583 6.54167 9.83333 8.1875 8.1875C9.83333 6.54167 11.9583 5.60417 14.5625 5.375V3.75H15.4375V5.375C18.0417 5.60417 20.1667 6.54167 21.8125 8.1875C23.4583 9.83333 24.3958 11.9583 24.625 14.5625H26.25V15.4375H24.625C24.3958 18.0417 23.4583 20.1667 21.8125 21.8125C20.1667 23.4583 18.0417 24.3958 15.4375 24.625V26.25H14.5625ZM15 23.75C17.4167 23.75 19.4792 22.8958 21.1875 21.1875C22.8958 19.4792 23.75 17.4167 23.75 15C23.75 12.5833 22.8958 10.5208 21.1875 8.8125C19.4792 7.10417 17.4167 6.25 15 6.25C12.5833 6.25 10.5208 7.10417 8.8125 8.8125C7.10417 10.5208 6.25 12.5833 6.25 15C6.25 17.4167 7.10417 19.4792 8.8125 21.1875C10.5208 22.8958 12.5833 23.75 15 23.75ZM15 18.375C14.0719 18.375 13.2773 18.0445 12.6164 17.3836C11.9555 16.7227 11.625 15.9281 11.625 15C11.625 14.0719 11.9555 13.2773 12.6164 12.6164C13.2773 11.9555 14.0719 11.625 15 11.625C15.9281 11.625 16.7227 11.9555 17.3836 12.6164C18.0445 13.2773 18.375 14.0719 18.375 15C18.375 15.9281 18.0445 16.7227 17.3836 17.3836C16.7227 18.0445 15.9281 18.375 15 18.375ZM15 17.5C15.6875 17.5 16.276 17.2552 16.7656 16.7656C17.2552 16.276 17.5 15.6875 17.5 15C17.5 14.3125 17.2552 13.724 16.7656 13.2344C16.276 12.7448 15.6875 12.5 15 12.5C14.3125 12.5 13.724 12.7448 13.2344 13.2344C12.7448 13.724 12.5 14.3125 12.5 15C12.5 15.6875 12.7448 16.276 13.2344 16.7656C13.724 17.2552 14.3125 17.5 15 17.5Z",
            fill: "#00BCE5"
        })
    });
const LoadingImage = ()=>/*#__PURE__*/ _jsx("div", {
        className: "loading-spinner",
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "56",
            height: "56",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("circle", {
                    cx: "30",
                    cy: "30",
                    r: "28",
                    stroke: "url(#paint0_linear_952_180)",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ _jsx("defs", {
                    children: /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_952_180",
                        x1: "54.1411",
                        y1: "49.3794",
                        x2: "9.49243",
                        y2: "8.51453",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#1AAA89"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.237209",
                                stopColor: "#08A1A9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.508047",
                                stopColor: "#1E80B7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.784094",
                                stopColor: "#693A92"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#D81081"
                            })
                        ]
                    })
                })
            ]
        })
    });
const CloseIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.79376 15.4999L0.369141 22.9245L1.07625 23.6316L8.50087 16.207L15.9255 23.6316L16.6326 22.9245L9.20798 15.4999L16.6326 8.07527L15.9255 7.36816L8.50087 14.7928L1.07625 7.36816L0.369141 8.07527L7.79376 15.4999Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.79376 15.4999L0.369141 22.9245L1.07625 23.6316L8.50087 16.207L15.9255 23.6316L16.6326 22.9245L9.20798 15.4999L16.6326 8.07527L15.9255 7.36816L8.50087 14.7928L1.07625 7.36816L0.369141 8.07527L7.79376 15.4999Z",
                fill: "#494949"
            })
        ]
    });
};
const DownIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.1504 0L15.8799 0.683941L8.01516 9.07303L0.150391 0.683941L0.879928 0L8.01516 7.61097L15.1504 0Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.1504 0L15.8799 0.683941L8.01516 9.07303L0.150391 0.683941L0.879928 0L8.01516 7.61097L15.1504 0Z",
                fill: "#212121"
            })
        ]
    });
};
const PlusIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.25 13.75V7.74995H0.25V6.25H6.25V0.25H7.74995V6.25H13.75V7.74995H7.74995V13.75H6.25Z",
            fill: "#757575"
        })
    });
const MinusIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "2",
        viewBox: "0 0 14 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.25 1.74995V0.25H13.75V1.74995H0.25Z",
            fill: "#CCCCCC"
        })
    });
const SortIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "18",
        height: "13",
        viewBox: "0 0 18 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.23755 12.703V11.203H10.7375V12.703H7.23755ZM3.23755 7.51064V6.01068H14.7375V7.51064H3.23755ZM0.237549 2.31833V0.818359H17.7375V2.31833H0.237549Z",
            fill: "#1C1B1F"
        })
    });
const SortByIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "21",
        height: "30",
        viewBox: "0 0 21 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.5 12.5025C14.2917 12.5309 13.2375 11.6876 13 10.5025H0V9.50251H13C13.2366 8.33734 14.2611 7.5 15.45 7.5C16.6389 7.5 17.6634 8.33734 17.9 9.50251H21V10.5025H17.95C17.7159 11.6688 16.6896 12.5067 15.5 12.5025ZM15.5 8.50293C14.6716 8.50293 14 9.1745 14 10.0029C14 10.8314 14.6716 11.5029 15.5 11.5029C16.3284 11.5029 17 10.8314 17 10.0029C17 9.1745 16.3284 8.50293 15.5 8.50293Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 19.5278C3.2264 18.3507 4.25636 17.5 5.455 17.5C6.65364 17.5 7.6836 18.3507 7.91 19.5278H21V20.5278H7.95C7.75555 21.7579 6.68544 22.6572 5.44026 22.6371C4.19509 22.617 3.15459 21.6835 3 20.4478H0V19.4478L3 19.5278ZM5.45996 21.5273C6.28839 21.5273 6.95996 20.8558 6.95996 20.0273C6.95996 19.1989 6.28839 18.5273 5.45996 18.5273C4.63153 18.5273 3.95996 19.1989 3.95996 20.0273C3.96517 20.4287 4.13103 20.8113 4.42045 21.0894C4.70987 21.3675 5.0987 21.5181 5.49996 21.5073L5.45996 21.5273Z",
                fill: "#494949"
            })
        ]
    });
const ImageThumbIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M-0.000244141 6.20115V0.201172H5.99974V6.20115H-0.000244141ZM-0.000244141 13.8011V7.80115H5.99974V13.8011H-0.000244141ZM7.59974 6.20115V0.201172H13.5997V6.20115H7.59974ZM7.59974 13.8011V7.80115H13.5997V13.8011H7.59974Z",
            fill: "#757575"
        })
    });
const ImageListIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.000244141 11.4015V10.2016H14.0002V11.4015H0.000244141ZM0.000244141 8.20152V7.00156H14.0002V8.20152H0.000244141ZM0.000244141 5.00152V3.80156H14.0002V5.00152H0.000244141ZM0.000244141 1.80152V0.601562H14.0002V1.80152H0.000244141Z",
            fill: "#757575"
        })
    });
const CrossButton = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 1.5L14.5 14.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 1.5L1.5 14.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
const ModalCloseIcon = ()=>{
    return /*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.40002 13.6553L0.346191 12.6015L5.94619 7.00148L0.346191 1.40148L1.40002 0.347656L7.00002 5.94766L12.6 0.347656L13.6538 1.40148L8.05384 7.00148L13.6538 12.6015L12.6 13.6553L7.00002 8.05531L1.40002 13.6553Z",
            fill: "#757575"
        })
    });
};
const ExitFullScreenIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M40 25C48.2843 25 55 31.7157 55 40C55 48.2843 48.2843 55 40 55C31.7157 55 25 48.2843 25 40C25 31.7157 31.7157 25 40 25Z",
            stroke: "#3FC28F",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
const IconApiError = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        className: "icon-api-error",
        viewBox: "0 0 168 169",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.999695 75.6734C0.999695 116.914 34.4321 150.347 75.6731 150.347C116.914 150.347 150.347 116.914 150.347 75.6734C150.347 34.4324 116.914 1 75.6731 1C34.4321 1 0.999695 34.4324 0.999695 75.6734ZM-0.000305176 75.6734C-0.000305176 117.467 33.8798 151.347 75.6731 151.347C96.8809 151.347 116.051 142.623 129.791 128.567L166.603 168.287L167.337 167.607L130.486 127.847C143.412 114.271 151.347 95.8987 151.347 75.6734C151.347 33.8801 117.466 0 75.6731 0C33.8798 0 -0.000305176 33.8801 -0.000305176 75.6734ZM61.0059 59.2387C61.2988 58.9458 61.7737 58.9458 62.0666 59.2387L77.8234 74.9955L93.5802 59.2387C93.8731 58.9458 94.3479 58.9458 94.6408 59.2387C94.9337 59.5316 94.9337 60.0065 94.6408 60.2994L78.884 76.0562L94.6407 91.8129C94.9336 92.1058 94.9336 92.5806 94.6407 92.8735C94.3478 93.1664 93.873 93.1664 93.5801 92.8735L77.8234 77.1168L62.0667 92.8735C61.7738 93.1664 61.2989 93.1664 61.006 92.8735C60.7131 92.5806 60.7131 92.1058 61.006 91.8129L76.7627 76.0562L61.0059 60.2994C60.713 60.0065 60.713 59.5316 61.0059 59.2387Z",
                fill: "url(#paint0_linear_2074_15327)"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_2074_15327",
                    x1: "0.223115",
                    y1: "0",
                    x2: "167.337",
                    y2: "0",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#1AAA89"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.237209",
                            stopColor: "#08A1A9"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.508047",
                            stopColor: "#1E80B7"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.784094",
                            stopColor: "#693A92"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#D81081"
                        })
                    ]
                })
            })
        ]
    });
};
const ImageGridViewMobile = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "grid icons/grid filled",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7 6H0V13H7V6Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17 6H10V13H17V6Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 16H7V23H0V16Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17 16H10V23H17V16Z",
                        fill: "#212121"
                    })
                ]
            })
        })
    });
const ImageListViewMobile = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "grid icons/vertical empty",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M-1.74846e-07 10L17 10L17 6L0 6L-1.74846e-07 10ZM16 7L16 9L1 9L1 7L16 7Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M-7.43094e-07 23L17 23L17 19L-5.68248e-07 19L-7.43094e-07 23ZM16 20L16 22L0.999999 22L0.999999 20L16 20Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17 16.5L-4.5897e-07 16.5L-2.84124e-07 12.5L8.5 12.5L17 12.5L17 16.5ZM16 15.5L16 13.5L1 13.5L1 15.5L16 15.5Z",
                        fill: "#212121"
                    })
                ]
            })
        })
    });
const SortByDropDownIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "13",
        height: "30",
        viewBox: "0 0 13 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12.1814 11L13 11.6448L6.5 18.8179L0 11.6448L0.782276 11L6.5 17.2061L12.1814 11Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12.1814 11L13 11.6448L6.5 18.8179L0 11.6448L0.782276 11L6.5 17.2061L12.1814 11Z",
                fill: "#494949"
            })
        ]
    });
const IconClose = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                fill: "#757575"
            })
        ]
    });
const IncIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "30",
        viewBox: "0 0 14 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.5 15.4995V21.9995H7.5V15.4995H14V14.4995H7.5V7.99951H6.5V14.4995H0V15.4995H6.5Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.5 15.4995V21.9995H7.5V15.4995H14V14.4995H7.5V7.99951H6.5V14.4995H0V15.4995H6.5Z",
                fill: "#212121"
            })
        ]
    });
const DecIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "30",
        viewBox: "0 0 14 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 14.4995H14V15.4995H0V14.4995Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 14.4995H14V15.4995H0V14.4995Z",
                fill: "#212121"
            })
        ]
    });
const LoadingIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "spinner-border loadingIcon"
    });
};
const WarnIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "B4-Cart",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "D_Kohler_UI_Batch-4,-Cart-Landing-Out-of-Stock-Promo-Error-ZipCode-1.2",
                transform: "translate(-806.000000, -1190.000000)",
                fill: "#D10000",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Cart-Products",
                    transform: "translate(70.000000, 395.000000)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "Product-Robern",
                        transform: "translate(0.000000, 644.000000)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            id: "03-Buttons/AlertMsg",
                            transform: "translate(731.000000, 146.000000)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M15.8865,19.128 L15.8865,21 L14.3565,21 L14.3565,19.128 L15.8865,19.128 Z M15.8865,8.148 L15.8865,17.454 L14.3565,17.454 L14.3565,8.148 L15.8865,8.148 Z",
                                    id: "Tool-Tip-Icon"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M15,5 C20.5228475,5 25,9.4771525 25,15 C25,20.5228475 20.5228475,25 15,25 C9.4771525,25 5,20.5228475 5,15 C5,9.4771525 9.4771525,5 15,5 Z M15,5.66666667 C9.84534234,5.66666667 5.66666667,9.84534234 5.66666667,15 C5.66666667,20.1546577 9.84534234,24.3333333 15,24.3333333 C20.1546577,24.3333333 24.3333333,20.1546577 24.3333333,15 C24.3333333,9.84534234 20.1546577,5.66666667 15,5.66666667 Z",
                                    id: "Oval",
                                    "fill-rule": "nonzero"
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
const BackToTop = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "10",
        height: "30",
        viewBox: "0 0 10 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.95028 9.99955L5.00053 5.0498L0.0507812 9.99955L0.757888 10.7067L4.50053 6.96402V23.9996H5.50053V6.96402L9.24317 10.7067L9.95028 9.99955Z",
            fill: "#212121"
        })
    });
const LoaderSpinner = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "spinner-img d-flex justify-content-center align-items-center h-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: _public_images_spinner_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
            alt: "loading"
        })
    });
};
const ListViewSelected = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17 10L-1.74846e-07 10L0 6L17 6L17 10Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17 23L-7.43094e-07 23L-5.68248e-07 19L17 19L17 23Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M-4.5897e-07 16.5L17 16.5L17 12.5L-2.84124e-07 12.5L-4.5897e-07 16.5Z",
                fill: "#212121"
            })
        ]
    });
const GridViewUnSelected = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7 6V13H0V6H7ZM6 7H1V12H6V7Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17 6V13H10V6H17ZM16 7H11V12H16V7Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7 23V16H0V23H7ZM1 17H6V22H1V17Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17 16V23H10V16H17ZM16 17H11V22H16V17Z",
                fill: "#212121"
            })
        ]
    });
const CartCloseIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4989L7 22.9235L7.73913 23.6306L15.5 16.206L23.2609 23.6306L24 22.9235L16.2391 15.4989L24 8.07429L23.2609 7.36719L15.5 14.7918L7.73913 7.36719L7 8.07429L14.7609 15.4989Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4989L7 22.9235L7.73913 23.6306L15.5 16.206L23.2609 23.6306L24 22.9235L16.2391 15.4989L24 8.07429L23.2609 7.36719L15.5 14.7918L7.73913 7.36719L7 8.07429L14.7609 15.4989Z",
                fill: "white"
            })
        ]
    });
const PrintHeader = (param)=>{
    let { data  } = param;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: "100%",
        height: "100%",
        version: "1.0",
        "shape-rendering": "geometricPrecision",
        "text-rendering": "geometricPrecision",
        "image-rendering": "optimizeQuality",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        viewBox: "0 0 12774 3080",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("font", {
                        id: "FontID0",
                        "horiz-adv-x": "722",
                        "font-variant": "normal",
                        "fill-rule": "nonzero",
                        "font-style": "normal",
                        "font-weight": "700",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("font-face", {
                                "font-family": "Arial"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("missing-glyph", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M0 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xff",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M6.00675 519.01l145.984 0 124.499 -368.166 121.507 368.166 142.002 0 -182.992 -499.505 -33.0034 -90.1687c-12.171,-30.1687 -23.667,-53.1609 -34.6682,-69.1789 -10.8436,-15.8155 -23.5096,-28.8189 -37.6603,-38.6502 -14.1732,-10.0112 -31.676,-17.6828 -52.5084,-23.1721 -20.6749,-5.51181 -44.162,-8.34646 -70.3262,-8.34646 -26.3442,0 -52.351,2.83465 -77.8403,8.34646l-11.991 106.997c21.4848,-4.16198 40.9899,-6.32171 58.3127,-6.32171 32.0135,0 55.6805,9.31384 71.0011,28.1665 15.3431,18.8301 27.1766,42.8121 35.3431,71.8335l-197.66 520zm115.501 66.9966l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.484 0l0 117.998 118.02 0 0 -117.998 -118.02 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xee",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm-91.0011 586.007l102.52 144.004 126.322 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdd",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M260.99 0l0 301.327 -262.497 414.668 169.516 0 169.314 -283.487 164.837 283.487 166.344 0 -262.497 -415.658 0 -300.337 -145.017 0zm-1.97975 780.99l67.9865 146.007 153.003 0 -135.006 -146.007 -85.9843 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcc",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm171.991 780.99l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbb",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.992 33.9933l127.019 220.832 -127.019 225.174 107.019 0 154.983 -225.174 -154.983 -220.832 -107.019 0zm-191.991 0l126.997 220.832 -126.997 225.174 106.997 0 155.006 -225.174 -155.006 -220.832 -106.997 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xaa",
                                "horiz-adv-x": "370",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.004 611.001l-92.0135 19.0101c7.51406,32.4859 22.5197,57.1654 45.1744,73.8133 22.4972,16.8504 56.8279,25.1744 102.677,25.1744 47.829,0 83.8245,-6.32171 108.166,-18.9876 15.9955,-8.18898 27.829,-22.6772 35.658,-43.5096 4.8369,-13.0034 7.33408,-37.9978 7.33408,-75.0056l0 -116.49c0,-33.8358 1.16985,-56.5129 3.32958,-68.1665 2.15973,-11.4961 6.00675,-22.8346 11.676,-33.8358l-93.4983 0c-4.18448,8.50394 -8.009,20 -11.1811,34.6682 -28.6614,-29.1789 -63.667,-43.667 -105.332,-43.667 -36.9854,0 -65.9843,9.83127 -86.8391,29.4938 -20.8324,19.6625 -31.1586,44.9944 -31.1586,75.838 0,22.1597 5.17435,40.8324 15.3431,56.153 10.3262,15.3431 25.3318,27.3341 45.1519,36.1755 14.5107,6.16423 45.1744,13.8358 91.5186,22.8346 25.6468,5.33183 45.9843,10.6637 60.9899,16.1755 0,4.49944 -0.15748,7.82902 -0.494938,9.98875 -0.337458,15.5006 -3.1721,25.6693 -8.68391,30.3262 -7.82902,6.68166 -21.3273,10.0112 -40.4949,10.0112 -16.8279,0 -29.4938,-2.83465 -37.8178,-8.32396 -6.18673,-4.18448 -12.6659,-14.8481 -19.5051,-31.676zm106.997 -75.1631c-7.1766,-4.34196 -17.1654,-7.67154 -30.1687,-10.3487 -35.0056,-7.49156 -55.838,-13.1609 -62.3397,-17.1654 -13.0034,-8.16648 -19.4826,-18.6502 -19.4826,-31.6535 0,-10.1687 4.31946,-19.3476 13.1609,-27.5141 8.66142,-8.16648 20.1575,-12.1485 33.9933,-12.1485 18.8301,0 34.3307,6.81665 46.5017,20.315 12.171,13.5208 18.3352,33.1834 18.3352,58.8526l0 19.6625z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x99",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x88",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "w",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M168.009 0l-164.004 519.01 133.318 0 97.1879 -340.18 89.4938 340.18 132.328 0 86.1642 -340.18 99.1676 340.18 135.343 0 -166.682 -519.01 -131.654 0 -89.1789 333.836 -87.9865 -333.836 -133.498 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "f",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M11.991 519.01l76.018 0 0 39.1676c0,43.6445 4.65692,76.333 13.9933,97.8178 9.33633,21.6648 26.5017,39.1676 51.4961,52.6659 25.1744,13.4983 56.8279,20.3375 95.1631,20.3375 39.1676,0 77.6828,-5.82677 115.343,-17.5028l-17.5028 -95.3206c-22.3397,5.15186 -43.8245,7.82902 -64.4994,7.82902 -20.3375,0 -34.8256,-4.67942 -43.667,-13.9933 -8.84139,-9.33633 -13.3408,-27.3341 -13.3408,-54.0157l0 -36.9854 103.015 0 0 -108.009 -103.015 0 0 -411.001 -136.985 0 0 411.001 -76.018 0 0 108.009z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "U",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "D",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l263.667 0c59.5051,0 104.837,-4.49944 135.996,-13.6558 41.8448,-12.3285 77.8403,-34.3307 107.672,-66.0067 29.9888,-31.4961 52.6659,-70.1687 68.324,-115.996 15.5006,-45.6693 23.3296,-102.16 23.3296,-169.179 0,-58.9876 -7.33408,-109.651 -21.9798,-152.328 -17.8403,-52.171 -43.3521,-94.3307 -76.5129,-126.502 -24.9944,-24.4994 -58.8301,-43.4871 -101.327,-57.1654 -31.8335,-10.1687 -74.3307,-15.1631 -127.672,-15.1631l-271.496 0 0 715.996zm144.994 -120.99l0 -474.016 107.492 0c40.18,0 69.1789,2.33971 87.0191,6.83915 23.4871,5.82677 42.8346,15.838 58.1552,29.8313 15.5006,14.0157 28.009,37.0079 37.6603,68.9989 9.85377,32.0135 14.6682,75.838 14.6682,131.181 0,55.3206 -4.8144,97.6603 -14.6682,127.334 -9.65129,29.6513 -23.3296,52.6659 -40.8324,69.3363 -17.4803,16.4904 -39.6625,27.829 -66.6592,33.6558 -20,4.49944 -59.5051,6.83915 -118.155,6.83915l-64.6794 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "3",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M37.9978 189.831l133.003 16.1755c4.16198,-34.0157 15.5006,-60 33.9933,-77.9978 18.5152,-17.9978 40.8324,-27.0191 66.9966,-27.0191 28.1665,0 51.8335,10.8436 71.1811,32.351 19.1676,21.4848 28.8189,50.4837 28.8189,87.1541 0,34.5107 -9.15636,62.0022 -27.649,82.1822 -18.5152,20.1575 -41.0124,30.3262 -67.6715,30.3262 -17.5028,0 -38.3352,-3.50956 -62.6772,-10.3262l15.1631 111.316c37.0079,-0.989876 65.1744,7.1766 84.6794,24.342 19.5051,17.0079 29.1564,39.8425 29.1564,68.324 0,24.1845 -7.15411,43.3521 -21.4848,57.8403 -14.3307,14.3307 -33.3408,21.5073 -57.1654,21.5073 -23.5096,0 -43.5096,-8.16648 -60,-24.4994 -16.6704,-16.333 -26.6817,-40.18 -30.3487,-71.4961l-125.984 21.4848c8.8189,43.667 22.0022,78.5152 39.82,104.679 17.6603,25.9843 42.4972,46.5017 74.1732,61.4848 31.6535,14.8481 67.3341,22.3397 106.659,22.3397 67.3341,0 121.35,-21.5073 162.002,-64.6569 33.4983,-35.3431 50.3262,-75.3431 50.3262,-119.843 0,-62.9921 -34.3307,-113.498 -103.15,-151.001 40.9899,-8.84139 73.6558,-28.5039 98.3352,-59.1676 24.4994,-30.6637 36.8279,-67.6715 36.8279,-111.001 0,-62.8346 -22.9921,-116.49 -68.8414,-160.832 -45.8268,-44.342 -102.835,-66.5017 -171.159,-66.5017 -64.6794,0 -118.335,18.6727 -160.832,56.1755 -42.6772,37.3228 -67.3341,86.1642 -74.1732,146.659z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: '"',
                                "horiz-adv-x": "474",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M80.8324 462.002l-25.8268 133.161 0 120.832 148.999 0 0 -120.832 -22.3397 -133.161 -100.832 0zm220.99 0l-25.8268 133.161 0 120.832 148.999 0 0 -120.832 -22.3172 -133.161 -100.855 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfc",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-267.514 586.007l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xeb",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-266.997 283.015l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xda",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm202.992 64.9944l68.009 146.007 153.003 0 -135.006 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc9",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm197.008 780.99l67.9865 146.007 153.003 0 -135.006 -146.007 -85.9843 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb8",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M18.4927 -197.008l0 57.3453c33.6783,-3.50956 64.4994,-5.33183 92.6659,-5.33183 28.9989,0 50.6637,5.15186 64.6794,15.658 10.8211,7.82902 16.153,17.8403 16.153,30.3262 0,11.0011 -4.99438,20.6749 -15.1631,28.8414 -10.1687,8.16648 -25.8268,12.171 -46.9966,12.171 -20.9899,0 -42.3397,-3.32958 -64.342,-9.83127l12.8459 48.5039c25.3318,8.99888 52.6659,13.3183 82.0022,13.3183 40.8324,0 71.6535,-8.99888 92.8234,-26.8166 21.1699,-18.0202 31.8335,-39.8425 31.8335,-65.5118 0,-28.8414 -11.6535,-51.991 -35.1631,-69.9888 -31.6535,-24.4994 -77.0079,-36.6704 -135.996,-36.6704 -42.0022,0 -73.8358,2.65467 -95.3431,7.9865z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa7",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M480.99 564.004l-133.993 -13.9933c-1.32733,23.982 -8.32396,42.3172 -20.9899,54.9831 -12.6659,12.6659 -30.3487,19.0101 -52.8459,19.0101 -20.8324,0 -36.8279,-4.67942 -47.829,-13.8358 -10.8211,-9.17885 -16.333,-19.5051 -16.333,-31.1586 0,-16.018 7.49156,-31.1811 22.3397,-45.8493 9.98875,-9.83127 43.1721,-33.0034 99.5051,-69.4938 56.153,-36.4904 93.4983,-62.4972 111.496,-78.1777 28.1665,-23.667 48.324,-47.3116 60.4949,-70.4837 12.171,-23.3296 18.1552,-49.1789 18.1552,-77.5028 0,-30.3262 -7.33408,-58.1777 -22.1597,-83.847 -14.8256,-25.4893 -37.0079,-48.6614 -66.6592,-69.4938 19.82,-18.3352 34.4882,-37.8178 44.162,-58.4927 9.83127,-20.6749 14.6682,-42.4972 14.6682,-65.6693 0,-48.1665 -17.9978,-88.5039 -54.1732,-121.17 -35.9955,-32.4859 -87.829,-48.8414 -155.501,-48.8414 -64.9944,0 -116.985,16.1755 -155.996,48.3465 -39.1676,32.171 -62.1597,75.0056 -69.3363,128.661l134.016 15.9955c5.82677,-29.1564 16.8279,-51.1586 33.1609,-65.8268 16.333,-14.8256 36.9854,-22.1597 62.0022,-22.1597 21.3273,0 38.3352,5.66929 50.8211,16.8279 12.6659,11.3386 19.0101,24.8369 19.0101,40.8324 0,15.3431 -6.00675,28.9989 -17.9978,40.9899 -12.351,12.171 -55.5006,41.8448 -129.674,89.1789 -74.1732,47.4916 -122.34,86.8391 -144.837,117.998 -22.3397,31.3386 -33.4983,66.3442 -33.4983,104.994 0,32.0135 7.33408,61.6648 22.1597,88.9989 14.8481,27.3341 37.6828,49.8313 68.9989,67.5141 -16.333,17.5028 -28.4814,35.3206 -36.8279,53.6558 -8.16648,18.1777 -12.3285,36.8279 -12.3285,55.6805 0,43.982 17.1654,81.1474 51.3386,111.654 34.1507,30.5062 82.3172,45.6693 144.162,45.6693 63.5096,0 113.498,-15.3431 149.989,-45.8268 36.5129,-30.5062 58.0202,-70.1687 64.4994,-119.168zm-122.317 -420.337c14.3307,13.1609 24.9944,25.4893 31.8335,37.5028 6.99663,11.8335 10.4837,23.3296 10.4837,34.3307 0,10.8436 -3.66704,21.8223 -11.1586,33.3408 -7.49156,11.3161 -27.829,29.1564 -61.3273,53.6558l-132.666 96.6704c-11.0011,-6.50169 -20.6749,-15.658 -29.1789,-27.829 -8.48144,-12.0135 -12.6659,-24.8369 -12.6659,-38.5152 0,-32.9809 21.8448,-64.162 65.6693,-93.8133l139.01 -95.3431z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x96",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x85",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "t",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M308.999 519.01l0 -108.999 -93.9933 0 0 -210.169c0,-42.6772 0.832396,-67.5141 2.65467,-74.5107 1.84477,-6.99663 5.84927,-12.8234 12.351,-17.5028 6.32171,-4.49944 13.9933,-6.83915 23.1496,-6.83915 12.8459,0 31.1811,4.34196 55.3431,13.1834l11.4961 -106.682c-31.8335,-13.6558 -67.829,-20.4949 -108.166,-20.4949 -24.6569,0 -46.8391,4.16198 -66.6592,12.5084 -19.8425,8.32396 -34.3307,19.1676 -43.5096,32.3285 -9.33633,13.3408 -15.658,31.1586 -19.3251,53.8358 -2.83465,15.9955 -4.34196,48.324 -4.34196,97.1654l0 227.177 -62.9921 0 0 108.999 62.9921 0 0 102.992 137.008 80.9899 0 -183.982 93.9933 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "c",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M524.004 364.994l-135.006 -24.0045c-4.49944,26.8391 -14.8256,47.0191 -31.0011,60.6749 -16.1755,13.4983 -37.0079,20.3375 -62.6547,20.3375 -34.1732,0 -61.5073,-11.8335 -81.8448,-35.5006 -20.3375,-23.667 -30.5062,-63.1721 -30.5062,-118.673 0,-61.6648 10.3487,-105.152 31.0011,-130.664 20.6749,-25.4893 48.3465,-38.1552 83.0146,-38.1552 25.9843,0 47.3341,7.49156 63.8245,22.3172 16.6704,14.8481 28.324,40.3375 35.1631,76.6704l135.006 -22.9921c-13.9933,-62.0022 -40.8324,-108.841 -80.4949,-140.495 -39.6625,-31.676 -92.8459,-47.5141 -159.663,-47.5141 -75.6805,0 -136.175,24.0045 -181.17,71.8335 -45.1744,48.009 -67.6715,114.331 -67.6715,199.168 0,85.8268 22.6547,152.508 67.829,200.337 45.1744,47.829 106.344,71.676 183.51,71.676 62.9921,0 113.161,-13.6783 150.484,-40.8549 37.1654,-27.1541 63.847,-68.4814 80.18,-124.162z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "R",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 304.499 0c76.4904,0 132.171,-6.50169 166.839,-19.3251 34.8256,-12.8459 62.4972,-35.6805 83.3296,-68.5039 20.8324,-33.0034 31.3386,-70.5062 31.3386,-112.823 0,-53.8358 -15.6805,-98.1777 -47.1766,-133.183 -31.4961,-34.9831 -78.4927,-56.9854 -141.17,-66.1642 31.1586,-18.1552 56.8279,-38.1552 77.0079,-60 20.3375,-21.8223 47.6715,-60.6524 82.0022,-116.333l87.3341 -139.663 -172.846 0 -103.667 156.333c-37.1654,55.5006 -62.6547,90.5062 -76.4904,104.994 -13.6783,14.3307 -28.1665,24.342 -43.5096,29.6738 -15.5006,5.33183 -39.82,8.009 -73.1609,8.009l-29.3363 0 0 -299.01 -144.994 0zm144.994 413.003l106.997 0c69.3363,0 112.508,2.99213 129.831,8.8189 17.1654,5.84927 30.8436,16.018 40.5174,30.3487 9.83127,14.3307 14.6682,32.3285 14.6682,53.8358 0,24.162 -6.50169,43.4871 -19.3476,58.4927 -12.8234,14.8256 -31.0011,24.162 -54.3307,28.009 -11.8335,1.66479 -46.9966,2.49719 -105.489,2.49719l-112.846 0 0 -182.002z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "A",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "0",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M274.511 720c69.3138,0 123.487,-24.8369 162.655,-74.5107 46.5017,-58.6502 69.8313,-156.153 69.8313,-292.148 0,-135.838 -23.4871,-233.498 -70.3262,-292.846 -38.8301,-48.9989 -92.8459,-73.4983 -162.16,-73.4983 -69.6738,0 -125.849,26.8391 -168.504,80.4949 -42.6772,53.6783 -64.0045,149.516 -64.0045,287.177 0,135.163 23.4871,232.508 70.3262,291.834 38.8301,48.9989 92.8459,73.4983 162.182,73.4983zm0 -113.993c-16.333,0 -31.0011,-5.33183 -43.667,-15.9955 -12.8459,-10.5062 -22.8346,-29.5163 -29.8538,-57.0079 -9.31384,-35.5006 -13.9933,-95.5006 -13.9933,-179.663 0,-84.342 4.16198,-142.182 12.5084,-173.678 8.32396,-31.4961 18.8301,-52.4859 31.4961,-62.9921 12.6659,-10.5062 27.1766,-15.6805 43.5096,-15.6805 16.333,0 30.9786,5.35433 43.8245,16.018 12.6659,10.4837 22.6547,29.4938 29.6738,56.9854 9.31384,35.1631 13.9933,95.0056 13.9933,179.348 0,84.162 -4.16198,142.002 -12.5084,173.498 -8.32396,31.4961 -18.8301,52.6659 -31.4961,63.1721 -12.6659,10.6637 -27.1541,15.9955 -43.4871,15.9955z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf9",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-21.0124 586.007l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe8",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-19.0101 283.015l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd7",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M54.5107 204.994l147.829 148.166 -149.336 149.336 91.4961 90.6637 148.661 -148.819 149.336 149.651 87.5141 -89.4938 -148.346 -148.661 149.831 -149.831 -91.0011 -91.0011 -149.651 149.651 -148.346 -148.661 -87.9865 88.9989z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc6",
                                "horiz-adv-x": "1000",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-42.0022 0l333.993 715.996 646.007 0 0 -120.99 -353.003 0 0 -159.01 326.007 0 0 -120.99 -326.007 0 0 -194.016 366.997 0 0 -120.99 -511.991 0 0.337458 168.999 -248.166 0 -74.3307 -168.999 -159.843 0zm286.839 293.993l195.658 0 0.494938 314.016 -55.9955 0 -140.157 -314.016z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb5",
                                "horiz-adv-x": "576",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M53.9933 519.01l137.008 0 0 -235.186c0,-67.829 6.83915,-113.993 20.4949,-138.335 17.1654,-31.6535 42.4972,-47.4916 76.333,-47.4916 18.1777,0 35.3431,5.82677 51.4961,17.6603 16.1755,11.676 28.1665,28.009 36.018,48.8414 7.82902,20.8324 11.6535,60.1575 11.6535,117.84l0 236.67 139.01 0 0 -519.01 -128.999 0 0 62.3397c-9.67379,-18.1777 -18.8301,-32.0135 -27.6715,-41.0124 -8.66142,-9.15636 -20.3375,-17.1654 -35.1631,-24.0045 -14.6682,-6.81665 -28.1665,-10.3262 -40.3375,-10.3262 -22.9921,0 -43.3296,6.34421 -61.1699,19.1676 -12.5084,9.33633 -26.5017,28.1665 -41.6648,56.1755l0 -261.35 -137.008 0 0 718.02z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa4",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M86.0067 460l-64.0045 62.9921 80.9899 88.009 66.0067 -66.9966c17.3453,9.49381 34.8256,16.4904 52.6659,21.1699 17.8403,4.49944 35.838,6.81665 54.1732,6.81665 18.4927,0 36.8279,-2.31721 54.8256,-6.81665 17.8403,-4.67942 35.3431,-11.676 52.3285,-21.1699l66.0067 66.0067 81.0124 -83.0146 -64.0045 -64.9944c8.99888,-16.6704 15.8155,-33.8358 20.3375,-51.4961 4.49944,-17.8403 6.65917,-36.1755 6.65917,-55.0056 0,-18.4927 -2.15973,-36.6704 -6.65917,-54.5107 -4.52193,-17.6603 -11.3386,-34.9831 -20.3375,-51.991l64.9944 -64.9944 -80.9899 -84.0045 -67.0191 66.9966c-16.333,-9.15636 -33.3183,-16.153 -51.0011,-20.8324 -17.8178,-4.8369 -36.333,-7.15411 -55.5006,-7.15411 -18.1552,0 -36.153,2.31721 -53.6558,6.81665 -17.6603,4.49944 -34.8256,11.1811 -51.8335,20.18l-62.9921 -64.0045 -84.0045 82.0022 64.0045 64.9944c-9.17885,17.0079 -16.1755,34.3307 -20.8324,52.171 -4.8369,17.8403 -7.1766,35.9955 -7.1766,54.4882 0,18.6727 2.15973,36.6704 6.50169,54.1732 4.34196,17.5028 10.8211,34.1732 19.5051,50.1687zm91.991 -104.499c0,-27.3341 9.67379,-50.5062 28.9989,-69.6738 19.3476,-19.1676 42.4972,-28.8189 69.4938,-28.8189 27.3341,0 50.5062,9.65129 69.6738,28.8189 19.1676,19.1676 28.8414,42.3397 28.8414,69.6738 0,27.3341 -9.67379,50.5062 -28.8414,69.6738 -19.1676,19.1676 -42.3397,28.8189 -69.6738,28.8189 -27.3341,0 -50.4837,-9.65129 -69.6513,-28.8189 -19.1676,-19.1676 -28.8414,-42.3397 -28.8414,-69.6738z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x93",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x82",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "q",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M411.001 -197.008l0 259.168c-17.9978,-22.9921 -40.3375,-41.3273 -66.9966,-54.8256 -26.8391,-13.4983 -55.6805,-20.3375 -86.6817,-20.3375 -58.9876,0 -107.649,22.1597 -145.827,66.5017 -44.9944,51.8335 -67.4916,122.16 -67.4916,210.844 0,83.4871 21.1699,148.661 63.3296,195.501 42.3397,46.8166 94.8256,70.1687 157.503,70.1687 34.6682,0 64.4994,-7.1766 89.8313,-21.6873 25.3318,-14.3307 47.829,-36.333 67.3341,-65.9843l0 76.6704 126.007 0 0 -716.018 -137.008 0zm4.0045 461.845c0,53.3408 -10.8436,93.1609 -32.3285,119.168 -21.6873,26.0067 -48.6839,38.9876 -81.1699,38.9876 -33.1834,0 -60.8324,-13.3183 -83.1721,-39.82 -22.1597,-26.5017 -33.3408,-68.5039 -33.3408,-126.164 0,-57.1654 10.6637,-98.5152 32.171,-124.004 21.5073,-25.3318 48.009,-37.9978 79.5051,-37.9978 31.4961,0 58.9876,14.1507 82.8346,42.6547 23.667,28.5039 35.5006,71.0011 35.5006,127.177z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "`",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.002 582.002l-86.0067 0 -135.006 146.007 153.003 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "O",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ">",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M46.0067 80.9899l0 138.02 342.497 135.163 -342.497 133.836 0 136.985 491.001 -212.666 0 -117.323 -491.001 -214.016z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "-",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M55.9955 191.001l0 137.008 270.011 0 0 -137.008 -270.011 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf6",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm-34.4882 327.514l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe5",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm13.9933 432.981c0,-26.1642 -9.31384,-48.4814 -27.829,-67.1541 -18.6727,-18.4927 -40.9899,-27.829 -67.1541,-27.829 -26.1642,0 -48.5039,9.33633 -67.1766,27.829 -18.4927,18.6727 -27.829,40.9899 -27.829,67.1541 0,26.1867 9.33633,48.5039 27.829,67.1766 18.6727,18.4927 41.0124,27.829 67.1766,27.829 26.1642,0 48.4814,-9.15636 67.1541,-27.6715 18.5152,-18.3127 27.829,-40.8324 27.829,-67.3341zm-51.991 0c0,12.0135 -4.16198,22.0022 -12.5084,30.5062 -8.48144,8.34646 -18.4927,12.5084 -30.4837,12.5084 -11.8335,0 -22.0022,-4.16198 -30.5062,-12.5084 -8.32396,-8.50394 -12.5084,-18.4927 -12.5084,-30.5062 0,-11.8335 4.18448,-21.9798 12.5084,-30.4837 8.50394,-8.34646 18.6727,-12.5084 30.5062,-12.5084 11.991,0 22.0022,4.16198 30.4837,12.5084 8.34646,8.50394 12.5084,18.6502 12.5084,30.4837z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd4",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm35.0056 422.497l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc3",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-197.008 495.996l-62.9921 0c-0.337458,7.49156 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.4904,18.4927 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.649,-9.49381 53.4983,-21.0124 25.9843,-11.4961 46.1642,-17.3228 60.9899,-17.3228 10.3487,0 19.0101,3.32958 26.0067,9.83127 7.15411,6.65917 11.4961,17.6603 13.4983,33.1609l62.9921 0c-0.314961,-44.4994 -8.50394,-76.153 -24.4994,-95.3206 -16.153,-19.1676 -36.8279,-28.6839 -62.1597,-28.6839 -11.1586,0 -22.0022,1.16985 -32.6659,3.50956 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -30.0112,11.8335 -51.676,17.6603 -65.3318,17.6603 -10.5062,0 -18.5152,-3.14961 -24.342,-9.65129 -6.00675,-6.34421 -8.99888,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb2",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M308.999 433.003l0 -77.9978 -297.008 0c3.66704,27.6715 12.5084,52.4859 26.6817,74.3307 14.1507,21.8223 45.8268,51.991 95.1631,90.8211 37.1654,28.9989 59.5051,48.1665 66.9966,57.6828 10.1687,12.3285 15.1631,24.8369 15.1631,37.6603 0,11.991 -4.16198,21.6648 -12.3285,28.8414 -8.16648,7.15411 -20.4949,10.6637 -37.1654,10.6637 -16.6704,0 -29.1789,-4.0045 -37.3453,-12.0135 -8.16648,-7.82902 -13.1609,-22.4972 -15.1631,-43.982l-91.991 7.82902c4.8369,37.9978 17.1654,65.8268 36.6704,83.4871 25.9843,23.1721 62.8346,34.6682 110.484,34.6682 45.3543,0 80,-10.3262 103.847,-31.1586 24.0045,-20.8324 35.9955,-45.3318 35.9955,-73.6783 0,-17.4803 -3.82452,-34.1507 -11.3386,-49.9888 -7.49156,-15.658 -19.3251,-31.991 -35.658,-48.9989 -8.50394,-8.34646 -30.5062,-26.5017 -66.0067,-54.5107 -18.9876,-14.6682 -32.4859,-25.8268 -40.6524,-33.6558l153.656 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa1",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M237.323 519.01l0 -137.008 -136.985 0 0 137.008 136.985 0zm-29.6513 -187.019l35.658 -362.655 0 -168.346 -147.987 0 0 168.346 35.5006 362.655 76.8279 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x90",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x7f",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "n",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M544.004 0l-137.008 0 0 264.499c0,55.9955 -2.99213,92.171 -8.8189,108.504 -6.00675,16.4904 -15.5006,29.1564 -28.8414,38.3352 -13.3408,9.15636 -29.3363,13.6558 -48.009,13.6558 -24.0045,0 -45.4893,-6.50169 -64.4994,-19.5051 -19.1676,-12.9809 -32.171,-30.3262 -39.1676,-51.6535 -7.15411,-21.5073 -10.6637,-61.1699 -10.6637,-119.168l0 -234.668 -136.985 0 0 519.01 126.997 0 0 -76.1755c45.4893,58.1552 102.655,87.1766 171.834,87.1766 30.3262,0 58.1552,-5.51181 83.3296,-16.3555 25.3318,-10.9786 44.3195,-24.8144 57.1654,-41.6648 13.0034,-16.9854 22.0022,-36.153 26.9966,-57.6603 5.17435,-21.5073 7.67154,-52.171 7.67154,-92.171l0 -322.16z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "]",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M260.99 715.996l0 -917.998 -242.992 0 0 108.009 113.003 0 0 702.992 -113.003 0 0 106.997 242.992 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "L",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M77.0079 0l0 710.011 144.994 0 0 -589.021 358.988 0 0 -120.99 -503.982 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ";",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M93.9933 382.002l0 137.008 137.008 0 0 -137.008 -137.008 0zm0 -244.994l137.008 0 0 -98.1777c0,-39.6625 -3.32958,-71.1586 -10.1687,-93.9933 -6.83915,-23.0146 -19.8425,-43.667 -38.8301,-61.8448 -19.0101,-18.3352 -43.1721,-32.4859 -72.3285,-42.9921l-26.6817 57.0079c27.5141,9.15636 47.0191,21.8223 58.6727,37.9978 11.4961,16.333 17.6603,37.9978 18.3352,64.9944l-66.0067 0 0 137.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "*",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M119.505 386.007l-73.4983 57.5028c23.4871,26.5017 47.829,51.6535 73.1609,75.8155 10.1687,9.83127 16.4904,16.018 19.0101,18.6727 -8.009,1.32733 -31.3386,6.65917 -69.6738,15.9955 -27.5141,6.83915 -45.6693,11.8335 -54.5107,15.0056l29.5163 86.0067c42.1597,-17.1654 80,-36.1755 113.161,-57.0079 -7.82902,53.1609 -11.676,96.5129 -11.676,130.011l86.0067 0c0,-23.847 -4.34196,-67.6715 -13.1609,-131.181 6.50169,2.49719 20.4949,8.84139 41.8223,19.0101 29.3363,13.3183 56.1755,24.6569 80.8324,34.1732l25.5118 -88.009c-35.9955,-8.16648 -77.5028,-16.1755 -124.837,-24.0045l58.1552 -66.5017c11.676,-13.4983 20.8324,-24.4994 27.6715,-33.0034l-74.4882 -49.4938 -65.0169 109.831c-19.6625,-35.3206 -42.3172,-73.0034 -67.9865,-112.823z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf3",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm64.0045 327.514l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe2",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-235.006 337.998l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd1",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 140.337 0 294.668 -479.82 0 479.82 133.993 0 0 -715.996 -144.837 0 -290.169 470.664 0 -470.664 -133.993 0zm160.652 780l-62.9921 0c-0.337458,7.49156 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.5129,18.4927 37.8403,27.6715 64.0045,27.6715 11.3386,0 22.0022,-1.16985 31.8335,-3.66704 9.67379,-2.49719 27.6715,-9.49381 53.4983,-21.0124 26.0067,-11.4961 46.1642,-17.3228 60.8324,-17.3228 10.5062,0 19.1676,3.32958 26.1642,9.83127 6.99663,6.65917 11.4961,17.6603 13.4983,33.1609l63.0146 0c-0.337458,-44.4994 -8.50394,-76.153 -24.6794,-95.3206 -15.9955,-19.1676 -36.6704,-28.6839 -62.0022,-28.6839 -11.1586,0 -22.0022,1.16985 -32.6659,3.50956 -7.49156,2.00225 -26.1642,8.99888 -56.153,20.8324 -29.8313,11.8335 -51.676,17.6603 -65.1744,17.6603 -10.5062,0 -18.6727,-3.14961 -24.4994,-9.65129 -5.82677,-6.34421 -8.84139,-17.5028 -9.17885,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc0",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-22.0022 496.985l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xaf",
                                "horiz-adv-x": "552",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-8.99888 757.998l0 88.9989 569.989 0 0 -88.9989 -569.989 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9e",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8d",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "|",
                                "horiz-adv-x": "279",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M86.9966 -210.011l0 938.02 108.009 0 0 -938.02 -108.009 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "k",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M66.9966 0l0 715.996 137.008 0 0 -379.82 160.495 182.835 168.999 0 -177.008 -189.674 190.011 -329.336 -148.009 0 -131.001 234.173 -63.4871 -68.009 0 -166.164 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "Z",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M10.0112 0l0 130.011 377.323 464.994 -334.331 0 0 120.99 524.004 0 0 -111.991 -392.013 -483.015 406.997 0 0 -120.99 -581.98 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "I",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "8",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M160.337 387.177c-35.3431,14.9831 -61.1699,35.5006 -77.1654,61.8223 -16.1755,26.1642 -24.162,55.0056 -24.162,86.1642 0,53.4983 18.6502,97.6603 55.8155,132.508 37.1654,34.8256 90.1687,52.3285 158.673,52.3285 68.009,0 120.675,-17.5028 158.178,-52.3285 37.4803,-34.8481 56.333,-79.0101 56.333,-132.508 0,-33.1609 -8.68391,-62.6547 -26.0067,-88.6614 -17.1654,-25.8268 -41.5073,-45.6693 -72.8459,-59.3251 39.8425,-16.018 70.0112,-39.3476 90.8436,-70.0112 20.6749,-30.8211 31.0011,-66.1642 31.0011,-106.322 0,-66.3442 -20.9899,-120.18 -63.1721,-161.687 -42.0022,-41.4848 -97.9978,-62.1597 -167.987,-62.1597 -65.0169,0 -119.01,17.1654 -162.34,51.4961 -51.0011,40.3375 -76.5129,96.018 -76.5129,166.502 0,38.8301 9.67379,74.5107 28.8414,106.997 19.1676,32.5084 49.3363,57.5028 90.5062,75.1856zm28.6614 137.998c0,-27.3341 7.67154,-48.8414 22.9921,-64.1845 15.5006,-15.3206 36.018,-22.9921 61.5073,-22.9921 26.0067,0 46.6592,7.82902 62.1597,23.3296 15.5006,15.5006 23.3521,37.0079 23.3521,64.342 0,25.8268 -7.67154,46.5017 -23.0146,62.0022 -15.5006,15.5006 -35.838,23.3296 -60.9899,23.3296 -26.3442,0 -47.1766,-7.82902 -62.6772,-23.5096 -15.5006,-15.658 -23.3296,-36.4904 -23.3296,-62.3172zm-13.0034 -306.997c0,-38.1777 9.67379,-67.8515 28.9989,-89.1789 19.3476,-21.3273 43.3296,-31.991 72.171,-31.991 28.324,0 51.676,10.3262 70.1687,30.8211 18.4927,20.4949 27.6715,50.1687 27.6715,88.8414 0,33.8358 -9.33633,60.9899 -28.1665,81.5073 -18.8301,20.4949 -42.6772,30.8211 -71.4961,30.8211 -33.5208,0 -58.3352,-11.676 -74.8481,-35.0056 -16.333,-23.3296 -24.4994,-48.5039 -24.4994,-75.8155z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "'",
                                "horiz-adv-x": "237",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M70.8436 462.002l-25.8493 133.161 0 120.832 148.999 0 0 -120.832 -22.3172 -133.161 -100.832 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf0",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M162.497 715.996l142.992 0c18.5152,-14.3307 36.333,-28.8189 53.1834,-43.4871l88.324 43.4871 21.8448 -47.1541 -70.3487 -32.8459c62.4972,-62.9921 107.334,-126.164 134.668,-189.651 27.1766,-63.5096 40.8324,-123.352 40.8324,-179.843 0,-84.162 -24.9944,-151.834 -75.1631,-202.835 -50.1687,-51.1586 -114.826,-76.6704 -194.331,-76.6704 -76.333,0 -139.505,25.3318 -188.999,76.1755 -49.6738,50.6637 -74.5107,116.333 -74.5107,196.985 0,79.1676 26.3442,144.342 79.0101,195.186 43.8245,42.4972 93.3408,63.667 148.324,63.667 17.5028,0 35.3431,-2.67717 53.1834,-7.85152 13.0034,-3.82452 31.4961,-12.4859 55.1631,-25.8268 -12.6659,22.8346 -23.1721,40.4949 -31.676,53.3408 -8.50394,12.8234 -21.6648,30.4837 -39.6625,53.0034l-122.002 -58.1777 -20.8324 46.5017 106.502 50.1687c-32.6659,29.9888 -68.009,58.4927 -106.502,85.8268zm21.5073 -457.323c0,-51.8335 11.8335,-91.4961 35.3206,-118.83 23.5096,-27.1766 52.351,-40.8324 86.5017,-40.8324 34.6682,0 64.342,13.6558 88.6839,41.1474 24.3195,27.3341 36.4904,65.3318 36.4904,113.678 0,48.6614 -12.5084,86.9966 -37.5028,115.006 -24.9944,28.1665 -54.4882,42.1597 -88.6614,42.1597 -33.4983,0 -62.0022,-13.3408 -85.5118,-40 -23.4871,-26.5017 -35.3206,-64.0045 -35.3206,-112.328z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdf",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 465.489c0,65.1744 5.82677,114.668 17.3228,148.684 11.4961,33.8358 33.9933,61.4848 67.1766,82.8346 33.1609,21.3273 76.333,31.991 129.314,31.991 66.3442,0 116.018,-14.1732 148.841,-42.6547 32.8459,-28.3465 49.3363,-63.667 49.3363,-105.669 0,-28.5039 -8.84139,-59.0101 -26.6592,-91.3386 -17.6828,-32.5084 -27.8515,-52.3285 -30.5062,-59.5051 -2.49719,-7.33408 -3.82452,-13.4983 -3.82452,-18.6727 0,-10.8211 3.982,-22.0022 12.1485,-33.8358 5.33183,-7.49156 24.8369,-28.324 58.6727,-62.6547 33.9933,-34.3307 56.8279,-63.3296 68.5039,-87.1766 11.8335,-23.8245 17.6603,-48.4814 17.6603,-73.9933 0,-47.3341 -16.333,-86.8391 -49.1564,-118.673 -32.6659,-31.8335 -74.1732,-47.829 -124.342,-47.829 -34.6682,0 -66.1642,8.84139 -94.4882,26.5017 -28.3465,17.6603 -49.6738,39.5051 -64.0045,65.5118l95.9955 55.9955c6.83915,-12.5084 14.5107,-22.0022 22.9921,-28.3465 8.50394,-6.50169 17.8403,-9.65129 28.009,-9.65129 13.3408,0 24.6569,4.8144 33.9933,14.4882 9.33633,9.67379 14.0157,21.6648 14.0157,35.9955 0,13.4983 -4.8369,27.0191 -14.6682,40.8324 -5.51181,8.16648 -28.1665,30.8436 -67.5141,68.1665 -55.1631,53.0034 -82.8346,94.6682 -82.8346,125.017 0,19.3251 10.5062,51.1586 31.4961,95.3206 16.5129,34.0157 26.1867,55.5006 29.1789,64.6794 2.83465,9.15636 4.34196,18.6502 4.34196,28.5039 0,14.3307 -5.35433,26.6592 -16.018,36.8279 -10.8211,10.1687 -25.1519,15.1631 -42.9921,15.1631 -16.1755,0 -30.3262,-4.16198 -42.1597,-12.6659 -11.8335,-8.50394 -19.8425,-19.5051 -24.0045,-32.8459 -5.82677,-17.9978 -8.84139,-54.8256 -8.84139,-110.664l0 -465.827 -136.985 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xce",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm-83.0146 780.99l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbd",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.992 355.006l-92.9809 0 0 251.001c-30.6862,-21.1699 -65.6693,-37.1654 -105.017,-48.009l0 75.9955c31.0011,8.84139 59.1676,22.8346 84.342,42.3397 17.6603,13.6783 30.5062,29.8313 38.3352,48.6614l75.3206 0 0 -369.989zm1.50731 -381.012l-77.6603 0 424.162 751.001 77.6603 0 -424.162 -751.001zm564.499 83.0146l0 -77.9978 -295.996 0c3.48706,27.649 12.4859,52.4859 26.8391,74.3307 14.1507,21.8223 45.6468,51.991 94.3307,90.8211 36.9854,28.9989 59.3251,48.1665 66.6592,57.6603 10.1687,12.351 15.1631,24.8369 15.1631,37.6828 0,11.991 -4.0045,21.6648 -11.991,28.8189 -8.16648,7.1766 -20.3375,10.6862 -36.8279,10.6862 -16.018,0 -28.1665,-4.0045 -36.5129,-12.0135 -8.16648,-7.82902 -13.0034,-22.4972 -14.6682,-44.0045l-93.0034 7.85152c4.8369,37.6603 17.1654,65.4893 37.0079,83.4871 25.6693,23.1721 62.1597,34.6682 109.674,34.6682 45.1519,0 79.6625,-10.3262 103.487,-31.1586 23.847,-20.6749 35.838,-45.1744 35.838,-73.4983 0,-17.5028 -3.66704,-34.1732 -11.0011,-49.8313 -7.33408,-15.838 -19.1676,-32.0135 -35.838,-49.0214 -8.50394,-8.32396 -30.3262,-26.4792 -65.8268,-54.4882 -18.4927,-14.5107 -31.8335,-25.8268 -40,-33.9933l152.666 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xac",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.996 182.992l0 215.006 -375.006 0 0 126.007 501.012 0 0 -341.012 -126.007 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9b",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8a",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "y",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M6.00675 519.01l145.984 0 124.499 -368.166 121.507 368.166 142.002 0 -182.992 -499.505 -33.0034 -90.1687c-12.171,-30.1687 -23.667,-53.1609 -34.6682,-69.1789 -10.8436,-15.8155 -23.5096,-28.8189 -37.6603,-38.6502 -14.1732,-10.0112 -31.676,-17.6828 -52.5084,-23.1721 -20.6749,-5.51181 -44.162,-8.34646 -70.3262,-8.34646 -26.3442,0 -52.351,2.83465 -77.8403,8.34646l-11.991 106.997c21.4848,-4.16198 40.9899,-6.32171 58.3127,-6.32171 32.0135,0 55.6805,9.31384 71.0011,28.1665 15.3431,18.8301 27.1766,42.8121 35.3431,71.8335l-197.66 520z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "h",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M206.997 715.996l0 -265.332c44.4994,52.8459 97.8403,79.3476 159.663,79.3476 31.8335,0 60.5174,-5.84927 86.0067,-17.5028 25.5118,-11.8335 44.6569,-26.6817 57.6603,-45.0169 13.0034,-18.1552 21.8448,-38.3352 26.5017,-60.4949 4.8369,-22.1597 7.1766,-56.4904 7.1766,-102.992l0 -304.004 -137.008 0 0 273.656c0,54.3532 -2.65467,88.8414 -7.82902,103.51 -5.33183,14.6682 -14.6682,26.3442 -28.009,34.8256 -13.3183,8.68391 -29.9888,13.0034 -50.1687,13.0034 -22.9921,0 -43.4871,-5.48931 -61.6648,-16.6704 -18.1552,-11.0011 -31.3161,-27.649 -39.6625,-49.9888 -8.50394,-22.1597 -12.6659,-55.1631 -12.6659,-98.6727l0 -259.663 -136.985 0 0 715.996 136.985 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "W",
                                "horiz-adv-x": "943",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M171.339 0l-168.346 715.996 148.999 0 106.502 -491.834 130.664 491.834 172.351 0 124.994 -500.157 108.999 500.157 145.489 0 -172.486 -715.996 -154.848 0 -141.147 535.343 -142.182 -535.343 -158.988 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "F",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 491.991 0 0 -120.99 -346.997 0 0 -170.011 300 0 0 -120.99 -300 0 0 -304.004 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "5",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M44.0045 183.825l136.985 14.1732c4.0045,-31.0011 15.5006,-55.658 34.6682,-73.8358 19.3476,-18.1552 41.5073,-27.1541 66.6817,-27.1541 28.6614,0 53.0034,11.6535 72.8234,35.1631 19.8425,23.4871 29.8313,58.8301 29.8313,106.007 0,44.3195 -9.83127,77.4803 -29.6513,99.6625 -19.685,22.1597 -45.3318,33.1609 -77.0079,33.1609 -39.5051,0 -75.0056,-17.3453 -106.344,-51.991l-111.001 15.9955 70.0112 371.991 362.992 0 0 -127.987 -258.83 0 -21.6648 -121.845c30.5062,15.1631 61.8448,22.8346 93.8358,22.8346 60.9899,0 112.666,-22.1597 155.006,-66.6592 42.4972,-44.342 63.667,-102.002 63.667,-173.003 0,-59.1676 -17.1654,-111.834 -51.3386,-158.335 -46.6592,-63.3296 -111.339,-95.0056 -193.993,-95.0056 -66.1642,0 -120.18,17.8403 -161.845,53.3408 -41.8223,35.658 -66.6592,83.3296 -74.8256,143.487z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "$",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M237.998 106.997l0 204.162c-63.4871,18.1777 -109.989,45.6693 -139.505,82.4972 -29.6513,37.0079 -44.4994,81.6873 -44.4994,134.353 0,53.3183 16.8504,98.1552 50.3487,134.331 33.4983,36.333 77.9978,57.1654 133.656,62.6547l0 48.009 71.0011 0 0 -48.009c51.991,-6.16423 93.3408,-23.8245 124.162,-53.0034 30.6637,-29.1564 50.3487,-68.1665 58.8301,-116.985l-123.982 -15.9955c-7.67154,38.3127 -27.3341,64.3195 -59.0101,77.9978l0 -190.506c78.4927,-21.0124 131.991,-48.5039 160.337,-82.0022 28.5039,-33.6558 42.6547,-76.8279 42.6547,-129.494 0,-58.8301 -17.8178,-108.346 -53.6558,-148.661 -35.838,-40.3375 -85.5118,-65.3543 -149.336,-75.3431l0 -91.0011 -71.0011 0 0 89.9888c-55.9955,6.83915 -101.507,27.5141 -136.67,62.3397 -35.1631,34.8481 -57.5028,84.162 -67.3341,147.672l126.997 15.0056c5.17435,-26.0067 15.0056,-48.3465 29.3363,-67.1766 14.3307,-18.8301 30.1687,-32.3285 47.6715,-40.8324zm0 512.013c-19.1676,-6.83915 -34.1732,-18.0202 -45.3318,-33.6783 -11.1586,-15.658 -16.6704,-32.8234 -16.6704,-51.676 0,-17.1654 4.99438,-33.1609 15.1631,-47.9865 10.1687,-14.6682 25.8493,-26.6592 46.8391,-35.658l0 168.999zm71.0011 -520c24.4994,5.33183 44.4994,16.9854 59.8425,34.9831 15.5006,17.9978 23.1496,39.1676 23.1496,63.667 0,21.6648 -6.50169,40.5174 -19.4826,56.1755 -12.8459,15.838 -34.0157,27.829 -63.5096,36.333l0 -191.159z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfe",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 715.996l136.985 0 0 -258.335c26.9966,26.9966 51.8335,45.8493 74.5107,56.5129 22.6547,10.4837 48.6614,15.838 77.9978,15.838 60.3375,0 111.496,-23.667 153.498,-71.0011 42.0022,-47.1766 62.9921,-113.183 62.9921,-197.503 0,-86.8391 -21.1699,-154.173 -63.4871,-202.34 -42.3397,-48.1665 -93.6783,-72.171 -154.016,-72.171 -28.6614,0 -54.6682,5.66929 -77.9978,17.1654 -23.1496,11.3386 -47.829,30.8436 -73.4983,58.5152l0 -259.685 -136.985 0 0 913.003zm134.983 -446.502c0,-53.8358 8.50394,-93.8358 25.5118,-119.483 23.8245,-36.6704 55.3206,-55.0056 94.8256,-55.0056 30.3262,0 56.1755,13.0034 77.6603,38.9876 21.3498,26.0067 32.0135,66.9966 32.0135,122.835 0,59.5051 -10.8436,102.34 -32.3285,128.661 -21.5073,26.3442 -48.9989,39.5051 -82.6772,39.5051 -33.0034,0 -60.3375,-12.8234 -82.1597,-38.4927 -21.8448,-25.6693 -32.8459,-64.6794 -32.8459,-117.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xed",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm-22.9921 586.007l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdc",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm126.502 64.9944l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcb",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm115.501 780.99l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xba",
                                "horiz-adv-x": "365",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M13.0034 545.332c0,57.8403 15.3206,102.992 46.0067,135.343 30.6637,32.1485 71.6535,48.324 122.992,48.324 51.0011,0 91.8335,-16.1755 122.655,-48.6614 30.8436,-32.3285 46.3442,-77.3453 46.3442,-135.006 0,-57.6603 -15.3431,-102.655 -46.0067,-135.006 -30.6637,-32.1485 -71.6535,-48.324 -122.992,-48.324 -51.3386,0 -92.3285,15.9955 -122.992,48.1665 -30.6862,31.991 -46.0067,77.1654 -46.0067,135.163zm102.992 -0.832396c0,-35.9955 6.00675,-61.5073 17.9978,-76.6704 12.0135,-15.1631 27.6715,-22.8346 46.8391,-22.8346 19.0101,0 34.6682,7.67154 46.8391,22.8346 12.171,15.1631 18.3352,40.6749 18.3352,76.6704 0,35.9955 -6.16423,61.5073 -18.3352,76.6704 -12.171,15.1631 -27.829,22.8346 -46.8391,22.8346 -19.1676,0 -34.8256,-7.51406 -46.8391,-22.4972 -11.991,-15.0056 -17.9978,-40.6749 -17.9978,-77.0079z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa9",
                                "horiz-adv-x": "736",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M370.011 730.011c64.162,0 125.647,-16.1755 184.499,-48.3465 58.9876,-32.171 105.332,-78.1552 138.988,-137.998 33.6783,-59.6625 50.5062,-122.16 50.5062,-187.672 0,-65.1519 -16.5129,-127.154 -49.4938,-186.322 -33.1834,-59.0101 -79.1676,-105.017 -138.178,-138.178 -59.1676,-33.0034 -121.17,-49.4938 -186.322,-49.4938 -65.1744,0 -127.177,16.4904 -186.344,49.4938 -59.0101,33.1609 -104.994,79.1676 -138.178,138.178 -32.9809,59.1676 -49.4938,121.17 -49.4938,186.322 0,65.5118 16.8279,128.009 50.5062,187.672 33.6558,59.8425 80,105.827 138.988,137.998 58.8526,32.171 120.337,48.3465 184.522,48.3465zm0 -74.0157c-51.3386,0 -100.675,-12.8234 -148.009,-38.4927 -47.3341,-25.6693 -84.4994,-62.4972 -111.496,-110.506 -26.9966,-47.9865 -40.4949,-98.3352 -40.4949,-151.001 0,-51.991 13.3183,-101.822 39.82,-149.336 26.5017,-47.3341 63.5096,-84.3195 110.844,-110.821 47.4916,-26.5017 97.3228,-39.8425 149.336,-39.8425 51.991,0 101.822,13.3408 149.314,39.8425 47.3341,26.5017 84.342,63.4871 110.844,110.821 26.5017,47.5141 39.8425,97.3453 39.8425,149.336 0,52.3285 -13.5208,102.677 -40.5174,150.664 -26.9966,48.1665 -64.162,85.1744 -111.496,110.844 -47.3341,25.6693 -96.6704,38.4927 -147.987,38.4927zm89.9888 -355.996l79.0101 -26.0067c-12.351,-41.3273 -32.8459,-73.0034 -61.3498,-94.9831 -28.5039,-22.0022 -62.6547,-33.0034 -102.16,-33.0034 -55.658,0 -100.832,18.3352 -135.996,54.8256 -35.0056,36.4904 -52.5084,86.9966 -52.5084,151.159 0,42.1822 7.82902,79.685 23.3296,112.666 15.6805,33.0034 38.1777,57.5028 67.5141,73.8358 29.3363,16.333 62.1597,24.4994 98.4927,24.4994 40,0 73.3408,-9.49381 100.157,-28.6614 26.6817,-18.9876 47.5141,-49.1564 62.5197,-90.3262l-79.0101 -19.0101c-8.99888,23.847 -20.8324,41.1699 -35.1631,51.8335 -14.5107,10.8436 -31.4961,16.1755 -51.3386,16.1755 -29.4938,0 -53.4983,-11.1811 -72.3285,-33.4983 -18.8301,-22.3397 -28.1665,-57.1654 -28.1665,-104.679 0,-47.649 9.15636,-82.6547 27.6715,-105.152 18.3352,-22.4972 40.4949,-33.6783 66.3217,-33.6783 21.6648,0 40.3375,6.50169 56.1755,19.3476 15.838,12.9809 28.1665,34.4882 36.8279,64.6569z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x98",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x87",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "v",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M214.668 0l-209.179 519.01 144.004 0 97.6828 -264.837 28.324 -88.5039c7.49156,22.4972 12.3285,37.3228 14.1732,44.4994 4.65692,14.6682 9.49381,29.3363 14.8256,44.0045l99.0101 264.837 140.99 0 -206.164 -519.01 -123.667 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "e",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "T",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M233.993 0l0 595.006 -211.991 0 0 120.99 568.009 0 0 -120.99 -211.001 0 0 -595.006 -145.017 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "C",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M531.001 264.004l140 -43.0146c-21.5073,-78.8301 -57.3453,-137.323 -107.334,-175.658 -50.0112,-38.1552 -113.341,-57.3228 -190.169,-57.3228 -95.1631,0 -173.341,32.4859 -234.668,97.4803 -61.1699,65.0169 -91.8335,153.836 -91.8335,266.682 0,119.168 30.8436,211.834 92.3285,277.84 61.5073,65.9843 142.497,98.9876 242.835,98.9876 87.6715,0 158.83,-26.0067 213.498,-77.8403 32.6659,-30.6637 57.0079,-74.6682 73.3408,-132.148l-142.992 -34.0157c-8.50394,37.0079 -26.1642,66.3442 -53.0034,87.829 -26.9966,21.5073 -59.6625,32.171 -97.9978,32.171 -53.1834,0 -96.333,-18.9876 -129.336,-57.1654 -33.1609,-37.9978 -49.6738,-99.6625 -49.6738,-184.994 0,-90.3262 16.333,-154.826 48.8414,-193.161 32.6659,-38.5152 75.0056,-57.6828 127.154,-57.6828 38.5152,0 71.676,12.171 99.3476,36.6704 27.6715,24.4994 47.6715,62.8346 59.6625,115.343z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "2",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M506.007 126.997l0 -126.997 -481.012 0c5.17435,48.324 20.8324,93.9933 46.8391,137.165 26.0067,43.1721 77.5028,100.495 154.173,171.991 61.8223,57.6828 99.6625,96.8504 113.656,117.345 18.8301,28.324 28.3465,56.333 28.3465,84.162 0,30.6637 -8.16648,54.1732 -24.6794,70.6637 -16.333,16.5129 -38.9876,24.6794 -67.829,24.6794 -28.6614,0 -51.3386,-8.68391 -68.324,-26.0067 -16.8504,-17.1654 -26.5017,-45.8268 -29.1789,-86.0067l-137.008 13.6783c8.16648,75.658 33.6783,129.989 76.6704,162.992 43.0146,32.8459 96.6704,49.3363 161.17,49.3363 70.6637,0 126.164,-19.1676 166.659,-57.3228 40.3375,-38.1777 60.5174,-85.6693 60.5174,-142.52 0,-32.3285 -5.84927,-62.9921 -17.3453,-92.3285 -11.4961,-29.1564 -29.8313,-59.6625 -55.0056,-91.6535 -16.4904,-21.3498 -46.6592,-51.8335 -89.9888,-91.676 -43.5096,-39.8425 -71.0011,-66.1642 -82.4972,-79.3251 -11.676,-13.0034 -21.0124,-25.8493 -28.1665,-38.1777l273.003 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "!",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 184.004l-35.5006 363.825 0 168.166 148.009 0 0 -168.166 -35.0056 -363.825 -77.5028 0zm-29.4938 -184.004l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfb",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-268.009 586.007l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xea",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-273.003 283.015l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd9",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm369.989 64.9944l-85.9843 0 -135.006 146.007 153.003 0 67.9865 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc8",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm346.997 780.99l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb7",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M97.9978 280l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa6",
                                "horiz-adv-x": "279",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M86.9966 342.992l0 385.017 108.009 0 0 -385.017 -108.009 0zm0 -553.003l0 386.007 108.009 0 0 -386.007 -108.009 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x95",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x84",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "s",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M22.9921 146.007l137.998 20.9899c5.84927,-26.5017 17.6828,-46.6592 35.6805,-60.3375 17.8403,-13.8358 42.9921,-20.6524 75.1631,-20.6524 35.5006,0 62.1597,6.50169 80.1575,19.4826 12.0135,9.17885 18.0202,21.5073 18.0202,36.8504 0,10.3262 -3.35208,18.9876 -9.85377,25.8268 -6.81665,6.50169 -22.1597,12.6659 -45.8268,18.1777 -110.821,24.4994 -180.99,46.8166 -210.664,66.9966 -41.1699,28.1665 -61.6648,67.1541 -61.6648,116.985 0,45.1744 17.8403,83.0146 53.3408,113.678 35.5006,30.6637 90.4837,46.0067 164.994,46.0067 71.0011,0 123.825,-11.676 158.335,-34.8481 34.4882,-23.3296 58.3352,-57.6603 71.3386,-103.172l-129.021 -23.982c-5.48931,20.315 -16.153,35.9955 -31.6535,46.8166 -15.5006,10.8436 -37.6603,16.1755 -66.5017,16.1755 -36.333,0 -62.3397,-4.99438 -78.1777,-15.1631 -10.4837,-7.1766 -15.658,-16.5129 -15.658,-27.829 0,-9.83127 4.49944,-18.1777 13.6783,-25.0169 12.4859,-9.15636 55.3206,-22.0022 128.661,-38.6502 73.3183,-16.6704 124.499,-37.0079 153.498,-61.1699 28.8189,-24.342 43.1721,-58.5152 43.1721,-102.182 0,-47.4916 -19.8425,-88.4814 -59.685,-122.655 -39.6625,-34.1732 -98.4927,-51.3386 -176.49,-51.3386 -70.6637,0 -126.659,14.3307 -168.009,42.8346 -41.1474,28.5039 -68.1665,67.1766 -80.8324,116.175z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "b",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M66.0067 0l0 715.996 136.985 0 0 -258.335c42.3397,48.1665 92.351,72.351 150.349,72.351 63.1496,0 115.321,-22.8346 156.67,-68.6839 41.3273,-45.8268 61.9798,-111.654 61.9798,-197.503 0,-88.6614 -20.9899,-156.985 -63.1496,-204.994 -42.1822,-47.829 -93.4983,-71.8335 -153.678,-71.8335 -29.6738,0 -58.8301,7.67154 -87.6715,22.8346 -28.8189,15.3431 -53.6558,37.3453 -74.4882,66.3442l0 -76.1755 -126.997 0zm134.983 269.494c0,-53.8358 8.50394,-93.8358 25.5118,-119.483 23.8245,-36.6704 55.3206,-55.0056 94.8256,-55.0056 30.3487,0 56.1755,13.0034 77.6828,38.9876 21.3273,26.0067 31.991,66.9966 31.991,122.835 0,59.5051 -10.8436,102.34 -32.3285,128.661 -21.5073,26.3442 -48.9989,39.5051 -82.6772,39.5051 -33.0034,0 -60.3375,-12.8234 -82.1597,-38.4927 -21.8448,-25.6693 -32.8459,-64.6794 -32.8459,-117.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "Q",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M648.504 90.6637c35.3206,-25.4893 73.8358,-45.6693 115.501,-60.6524l-53.1609 -103.015c-21.6873,6.50169 -43.0146,15.5006 -63.847,26.9966 -4.49944,2.33971 -36.4904,23.5096 -95.9955,63.847 -46.8391,-20.5174 -98.8301,-30.8436 -155.838,-30.8436 -109.989,0 -196.333,32.5084 -258.673,97.3453 -62.3172,64.9944 -93.4983,156.153 -93.4983,273.656 0,117.165 31.3386,208.346 93.8358,273.341 62.4972,65.1519 147.334,97.6603 254.331,97.6603 106.164,0 190.349,-32.5084 252.508,-97.6603 62.1597,-64.9944 93.3408,-155.996 93.3408,-273.161 0,-61.8448 -8.68391,-116.355 -26.0067,-163.352 -13.0034,-35.8155 -33.8358,-70.6637 -62.4972,-104.162zm-115.996 81.3273c18.4927,22.0022 32.3285,48.3465 41.6648,79.3476 9.15636,31.0011 13.8358,66.5017 13.8358,106.659 0,82.8346 -18.1777,144.679 -54.6682,185.669 -36.5129,40.8324 -84.1845,61.3273 -143.015,61.3273 -58.9876,0 -106.817,-20.4949 -143.33,-61.6648 -36.6704,-41.1699 -55.0056,-102.992 -55.0056,-185.669 0,-83.8245 18.3352,-146.659 55.0056,-188.166 36.6704,-41.6648 83.0146,-62.4972 139.01,-62.4972 20.9899,0 40.6524,3.50956 59.1676,10.3262 -29.1789,19.1676 -59.0101,34.0157 -89.1789,44.6794l40.4949 84.0045c47.3341,-16.5129 92.6659,-41.0124 136.018,-74.0157z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "@",
                                "horiz-adv-x": "975",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M867.829 8.99888l104.162 0c-32.4859,-66.5017 -82.4972,-118.493 -149.989,-156.175 -77.0079,-43.1496 -171.159,-64.8144 -282.16,-64.8144 -107.514,0 -200.18,18.1552 -278.335,54.4882 -78.1777,36.5129 -136.333,90.1687 -174.331,161.012 -38.1777,71.0011 -57.1654,148.166 -57.1654,231.834 0,91.6535 21.6648,176.985 64.9944,256.153 43.1721,79.0101 102.497,138.335 177.66,177.998 75.1631,39.6625 161.17,59.5051 257.84,59.5051 82.0022,0 154.983,-15.9955 218.65,-47.829 63.847,-32.0135 112.666,-77.3453 146.344,-136.175 33.6558,-58.8301 50.5062,-122.992 50.5062,-192.666 0,-83.1721 -25.5118,-158.155 -76.6704,-225.332 -64.0045,-84.6569 -146.164,-126.997 -246.344,-126.997 -26.9966,0 -47.3341,4.65692 -60.9899,13.9933 -13.6783,9.51631 -22.6772,23.1721 -27.3341,41.3498 -38.3352,-36.8504 -82.6772,-55.3431 -132.666,-55.3431 -53.9933,0 -98.8301,18.6727 -134.511,55.838 -35.658,37.3228 -53.4983,86.8391 -53.4983,148.661 0,76.4904 21.5073,146.164 64.342,209.336 52.171,76.8279 118.83,115.163 200.157,115.163 57.8403,0 100.675,-22.1597 128.166,-66.5017l12.171 54.5107 128.841 0 -73.8358 -349.674c-4.49944,-22.1597 -6.83915,-36.4904 -6.83915,-42.9921 0,-8.009 1.84477,-14.1732 5.66929,-18.1777 3.66704,-4.16198 8.16648,-6.16423 13.3408,-6.16423 15.658,0 35.8155,9.49381 60.6524,28.324 33.1834,24.6794 60,58.0202 80.5174,99.5051 20.4949,41.6648 30.8211,84.8369 30.8211,129.494 0,80 -28.9989,147.019 -86.8391,200.855 -57.9978,53.8133 -138.83,80.8324 -242.655,80.8324 -88.1665,0 -163.015,-18.0202 -224.342,-54.0157 -61.3273,-36.153 -107.492,-86.8166 -138.493,-152.328 -31.1586,-65.3318 -46.6592,-133.498 -46.6592,-204.342 0,-68.8189 17.3228,-131.316 51.991,-187.829 34.6682,-56.4904 83.3296,-97.6603 146.007,-123.667 62.4972,-25.8268 134.151,-38.8301 214.983,-38.8301 77.6828,0 144.679,11.0011 200.517,32.8459 55.9955,21.8223 101.147,54.4882 135.321,98.1552zm-526.839 200.675c0,-41.3498 8.34646,-71.8335 25.0169,-91.3386 16.8279,-19.5051 37.5028,-29.3363 62.1597,-29.3363 18.4927,0 35.838,4.49944 51.991,13.6783 12.351,6.47919 24.4994,16.8279 36.5129,30.8211 17.3228,19.8425 32.171,48.6614 44.6569,86.8391 12.5084,37.9978 18.6727,73.4983 18.6727,106.502 0,36.6704 -8.50394,64.9944 -25.4893,84.6569 -17.1879,19.6625 -38.6727,29.4938 -64.4994,29.4938 -28.009,0 -53.8358,-10.8211 -77.5028,-32.4859 -23.667,-21.6648 -41.5073,-52.5084 -53.4983,-92.5084 -12.0135,-40 -18.0202,-75.5006 -18.0202,-106.322z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "/",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-2.00225 -11.991l177.998 740 103.015 0 -179.01 -740 -102.002 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf8",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M462.34 487.492l51.1586 59.0101 53.9933 -44.9944 -52.4859 -60.8324c19.5051,-23.1721 34.8256,-50.6637 46.1642,-82.4972 11.1586,-31.8335 16.8279,-65.1744 16.8279,-100 0,-77.6828 -25.4893,-142.34 -76.6704,-193.836 -51.1586,-51.5186 -115.163,-77.3453 -192.328,-77.3453 -55.9955,0 -106.007,13.9933 -149.989,42.0022l-56.5129 -65.4893 -53.9933 45.9843 57.3228 66.3442c-20.1575,23.667 -35.8155,51.991 -46.9966,84.9944 -11.1586,32.8234 -16.8279,66.5017 -16.8279,100.99 0,78.1777 24.9944,142.34 75.1631,192.688 50.0112,50.3262 114.173,75.5006 192.508,75.5006 57.9978,0 108.999,-14.1732 152.666,-42.5197zm-77.1654 -89.1564c-21.8448,17.8403 -46.6817,26.6592 -74.5107,26.6592 -37.0079,0 -68.5039,-14.1507 -94.1732,-42.6547 -25.6468,-28.5039 -38.4927,-68.3465 -38.4927,-119.843 0,-32.3285 4.67942,-61.5073 13.9933,-87.3341l193.183 223.172zm41.8223 -59.3251l-192.171 -222.34c21.6648,-15.838 46.3442,-23.667 74.1732,-23.667 37.6603,0 69.1789,14.1732 94.6682,42.4972 25.4893,28.324 38.3352,68.009 38.3352,119.01 0,30.8211 -4.99438,58.8301 -15.0056,84.4994z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe7",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M524.004 364.994l-135.006 -24.0045c-4.49944,26.8391 -14.8256,47.0191 -31.0011,60.6749 -16.1755,13.4983 -37.0079,20.3375 -62.6547,20.3375 -34.1732,0 -61.5073,-11.8335 -81.8448,-35.5006 -20.3375,-23.667 -30.5062,-63.1721 -30.5062,-118.673 0,-61.6648 10.3487,-105.152 31.0011,-130.664 20.6749,-25.4893 48.3465,-38.1552 83.0146,-38.1552 25.9843,0 47.3341,7.49156 63.8245,22.3172 16.6704,14.8481 28.324,40.3375 35.1631,76.6704l135.006 -22.9921c-13.9933,-62.0022 -40.8324,-108.841 -80.4949,-140.495 -39.6625,-31.676 -92.8459,-47.5141 -159.663,-47.5141 -75.6805,0 -136.175,24.0045 -181.17,71.8335 -45.1744,48.009 -67.6715,114.331 -67.6715,199.168 0,85.8268 22.6547,152.508 67.829,200.337 45.1744,47.829 106.344,71.676 183.51,71.676 62.9921,0 113.161,-13.6783 150.484,-40.8549 37.1654,-27.1541 63.847,-68.4814 80.18,-124.162zm-381.507 -555.996l0 57.3453c33.6783,-3.50956 64.4994,-5.35433 92.6659,-5.35433 28.9989,0 50.6637,5.17435 64.6794,15.6805 10.8211,7.82902 16.153,17.8403 16.153,30.3262 0,11.0011 -4.99438,20.6749 -15.1631,28.8414 -10.1687,8.16648 -25.8268,12.171 -46.9966,12.171 -21.0124,0 -42.3397,-3.35208 -64.342,-9.83127l12.8459 48.4814c25.3318,8.99888 52.6659,13.3408 82.0022,13.3408 40.8324,0 71.6535,-8.99888 92.8234,-26.8391 21.1699,-17.9978 31.8335,-39.82 31.8335,-65.4893 0,-28.8414 -11.676,-52.0135 -35.1631,-70.0112 -31.676,-24.4994 -77.0079,-36.6704 -135.996,-36.6704 -42.0022,0 -73.8358,2.67717 -95.3431,8.009z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd6",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm31.0011 422.497l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc5",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-4.0045 475.006c0,-26.1867 -9.33633,-48.5039 -27.829,-67.1766 -18.6727,-18.4927 -41.0124,-27.829 -67.1766,-27.829 -26.1642,0 -48.5039,9.33633 -67.1541,27.829 -18.5152,18.6727 -27.829,40.9899 -27.829,67.1766 0,26.1642 9.31384,48.4814 27.829,67.1541 18.6502,18.4927 40.9899,27.829 67.1541,27.829 26.1642,0 48.5039,-9.15636 67.1766,-27.649 18.4927,-18.3352 27.829,-40.8549 27.829,-67.3341zm-51.991 0c0,11.991 -4.18448,21.9798 -12.5084,30.4837 -8.50394,8.34646 -18.4927,12.5084 -30.5062,12.5084 -11.8335,0 -22.0022,-4.16198 -30.4837,-12.5084 -8.34646,-8.50394 -12.5084,-18.4927 -12.5084,-30.4837 0,-11.8335 4.16198,-22.0022 12.5084,-30.5062 8.48144,-8.34646 18.6502,-12.5084 30.4837,-12.5084 12.0135,0 22.0022,4.16198 30.5062,12.5084 8.32396,8.50394 12.5084,18.6727 12.5084,30.5062z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb4",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M91.0011 582.002l68.009 146.007 152.981 0 -134.983 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa3",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M488.009 139.01l51.991 -116.018c-18.4927,-9.98875 -40,-18.1552 -64.162,-24.4994 -24.342,-6.32171 -47.829,-9.49381 -70.6637,-9.49381 -29.1789,0 -68.3465,6.99663 -117.165,21.0124 -48.8414,13.9933 -85.0169,20.9899 -108.346,20.9899 -39.82,0 -80.3375,-14.3307 -121.665,-42.9921l-51.991 118.335c36.9854,26.4792 63.4871,54.6457 79.6625,84.4994 16.153,29.8313 24.342,58.1552 24.342,85.3318 0,8.8189 -0.674916,17.9978 -2.00225,27.829l-102.002 0 0 107.987 76.9854 0c-13.3183,38.5152 -20,77.3453 -20,116.67 0,35.5006 9.67379,69.5163 28.9989,101.665 19.5051,32.171 46.8391,56.6704 82.3397,73.4983 35.6805,16.8504 74.3307,25.1744 116.333,25.1744 64.162,0 115.343,-16.1755 153.498,-48.6614 37.9978,-32.5084 61.3273,-79.0101 69.8313,-139.843l-131.991 -19.5051c-6.16423,35.1856 -17.3453,60.5174 -33.6783,75.838 -16.153,15.5006 -36.4904,23.1721 -60.8324,23.1721 -25.8268,0 -47.4916,-8.66142 -64.6569,-26.1642 -17.1654,-17.5028 -25.8268,-39.3251 -25.8268,-65.8268 0,-13.6783 2.31721,-31.8335 6.99663,-54.3532 4.65692,-22.4972 10.5062,-42.9921 17.3228,-61.6648l151.676 0 0 -107.987 -129.494 0c0.989876,-7.1766 1.48481,-14.3307 1.48481,-21.5073 0,-25.6693 -4.8369,-49.4938 -14.6682,-71.1586 -9.65129,-21.8448 -29.8313,-50.5062 -60,-86.0067 17.8403,9.17885 40.3375,13.6783 67.3341,13.6783 11.3386,0 21.6648,-0.674916 30.6637,-2.00225 4.67942,-0.674916 17.8403,-3.84702 40,-9.51631 39.3476,-10.3262 66.0067,-15.5006 80.3375,-15.5006 25.3318,0 58.5152,8.99888 99.3476,27.0191z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x92",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x81",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "p",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 519.01l127.987 0 0 -76.1755c16.6704,26.0067 39.0101,46.9966 67.3341,63.1721 28.3465,15.9955 59.8425,24.0045 94.3307,24.0045 60.18,0 111.339,-23.667 153.341,-71.0011 42.0022,-47.1766 62.9921,-113.183 62.9921,-197.503 0,-86.8391 -21.1699,-154.173 -63.4871,-202.34 -42.3397,-48.1665 -93.6783,-72.171 -154.016,-72.171 -28.6614,0 -54.6682,5.66929 -77.9978,17.1654 -23.1496,11.3386 -47.829,30.8436 -73.4983,58.5152l0 -259.685 -136.985 0 0 716.018zm134.983 -251.519c0,-58.4927 11.5186,-101.665 34.6682,-129.651 23.0146,-27.829 51.1811,-41.8448 84.162,-41.8448 31.8335,0 58.3352,12.8459 79.5051,38.5152 21.1699,25.6468 31.676,67.649 31.676,126.164 0,54.6682 -10.8436,95.1631 -32.6659,121.665 -21.6648,26.5017 -48.6614,39.6625 -80.8324,39.6625 -33.4983,0 -61.3273,-13.0034 -83.3296,-39.0101 -22.1822,-25.9843 -33.1834,-64.4994 -33.1834,-115.501z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "_",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-8.99888 -197.998l0 88.9989 569.989 0 0 -88.9989 -569.989 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "N",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 140.337 0 294.668 -479.82 0 479.82 133.993 0 0 -715.996 -144.837 0 -290.169 470.664 0 -470.664 -133.993 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "=",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40.9899 397.008l0 126.997 501.012 0 0 -126.997 -501.012 0zm0 -217.008l0 126.997 501.012 0 0 -126.997 -501.012 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ",",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 137.008l136.985 0 0 -98.1777c0,-39.6625 -3.32958,-71.1586 -10.1687,-93.9933 -6.81665,-23.0146 -19.82,-43.667 -38.8301,-61.8448 -18.9876,-18.3352 -43.1721,-32.4859 -72.3285,-42.9921l-26.6592 57.0079c27.4916,9.15636 46.9966,21.6648 58.6502,37.6603 11.5186,15.838 17.6828,37.6603 18.3352,65.3318l-65.9843 0 0 137.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf5",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm33.0034 326.502l-62.9921 0c-0.337458,7.51406 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.4904,18.5152 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.6715,-9.49381 53.4983,-20.9899 26.0067,-11.5186 46.1642,-17.3453 60.9899,-17.3453 10.3487,0 19.0101,3.32958 26.0067,9.83127 7.1766,6.68166 11.4961,17.6828 13.4983,33.1834l62.9921 0c-0.314961,-44.5219 -8.48144,-76.1755 -24.4994,-95.3431 -16.153,-19.1676 -36.8279,-28.6614 -62.1597,-28.6614 -11.1586,0 -22.0022,1.16985 -32.6659,3.48706 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -30.0112,11.8335 -51.676,17.6828 -65.3318,17.6828 -10.5062,0 -18.5152,-3.1721 -24.342,-9.67379 -6.00675,-6.34421 -8.99888,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe4",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-243.487 337.998l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.484 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd3",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm112.013 422.497l67.9865 146.007 153.003 0 -134.983 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc2",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-257.008 496.985l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb1",
                                "horiz-adv-x": "548",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M211.991 173.003l0 186.007 -187.987 0 0 127.987 187.987 0 0 186.007 125.017 0 0 -186.007 187.987 0 0 -127.987 -187.987 0 0 -186.007 -125.017 0zm-187.987 -173.003l0 128.009 500.99 0 0 -128.009 -500.99 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8f",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "~",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M31.991 253.003l0 126.997c41.3498,44.0045 89.6738,66.0067 144.679,66.0067 20.4949,0 39.3251,-2.00225 56.6704,-6.00675 17.3228,-4.0045 48.324,-14.8256 93.1609,-32.5084 44.6569,-17.6603 75.1631,-26.5017 91.0011,-26.5017 18.3352,0 39.5051,5.51181 63.3296,16.5129 24.0045,11.0011 47.3341,28.5039 70.1687,52.5084l0 -132.013c-15.0056,-15.5006 -35.9955,-29.9888 -62.8346,-43.667 -26.8391,-13.4983 -54.6682,-20.3375 -83.3296,-20.3375 -16.1755,0 -32.171,1.84477 -47.6715,5.66929 -15.3431,3.84702 -40,13.0034 -73.4983,27.3341 -50.1687,21.3273 -89.4938,32.0135 -118.178,32.0135 -45.6468,0 -90.1462,-22.0022 -133.498,-66.0067z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "m",
                                "horiz-adv-x": "889",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M62.0022 519.01l126.007 0 0 -70.8436c45.1519,54.5107 98.9876,81.8448 161.485,81.8448 33.1834,0 62.0022,-6.83915 86.3442,-20.5174 24.4994,-13.6558 44.4994,-34.3307 60,-62.0022 22.8346,27.6715 47.4916,48.3465 73.8358,62.0022 26.3217,13.6783 54.4882,20.5174 84.4994,20.5174 37.9978,0 70.1687,-7.67154 96.6704,-23.1721 26.3217,-15.5006 45.9843,-38.1777 58.9876,-68.1665 9.49381,-22.0022 14.1732,-57.8403 14.1732,-107.334l0 -331.339 -137.008 0 0 296.175c0,51.4961 -4.65692,84.6569 -14.1732,99.4826 -12.6659,19.5051 -32.3285,29.3363 -58.6502,29.3363 -19.1676,0 -37.3453,-5.82677 -54.3307,-17.5028 -16.8504,-11.8335 -29.1789,-28.9989 -36.6704,-51.4961 -7.51406,-22.6547 -11.1811,-58.3352 -11.1811,-107.154l0 -248.841 -136.985 0 0 284.004c0,50.3262 -2.49719,82.9921 -7.33408,97.5028 -4.8369,14.6682 -12.3285,25.6693 -22.6772,32.8234 -10.1687,7.1766 -24.162,10.6637 -41.6648,10.6637 -21.1699,0 -40.1575,-5.66929 -56.9854,-16.9854 -17.0079,-11.5186 -29.0214,-27.8515 -36.333,-49.3363 -7.33408,-21.5073 -11.0011,-57.1654 -11.0011,-106.839l0 -251.834 -137.008 0 0 519.01z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\\",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-2.00225 728.009l102.002 0 179.01 -740 -103.015 0 -177.998 740z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "K",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M75.0056 0l0 715.996 144.994 0 0 -317.165 292.171 317.165 194.331 0 -270.169 -278.83 284.162 -437.165 -186.997 0 -197.008 336.175 -116.49 -119.685 0 -216.49 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ":",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M97.9978 382.002l0 137.008 137.008 0 0 -137.008 -137.008 0zm0 -382.002l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ")",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M33.0034 -210.011c27.1541,58.0202 46.1642,102.34 57.3228,133.183 11.0011,31.0011 21.3498,66.6592 30.8436,106.997 9.33633,40.3375 16.333,78.6727 20.9899,114.826 4.49944,36.333 6.83915,73.4983 6.83915,111.496 0,77.5028 -8.32396,150.844 -24.9944,220 -16.6704,68.9989 -47.3341,153.003 -92.0135,251.519l93.0034 0c49.3363,-70.0112 87.6715,-144.184 115.006,-222.52 27.3341,-78.4927 40.9899,-157.998 40.9899,-238.65 0,-68.009 -10.8211,-140.832 -32.3285,-218.673 -24.3195,-87.1766 -64.6569,-173.161 -120.652,-258.178l-95.0056 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf2",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm217.008 327.514l-86.0067 0 -134.983 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe1",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-168.999 337.998l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd0",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l263.667 0c60.4949,0 106.322,-4.65692 137.66,-14.1732 42.3397,-12.6659 78.3352,-35.1631 108.346,-67.1541 29.9888,-31.991 52.4859,-70.8436 67.649,-116.49 15.1631,-45.5118 22.6772,-101.845 22.6772,-169.021 0,-58.8301 -8.34646,-111.991 -25.1744,-159.325 -16.6704,-47.4916 -41.3273,-86.9966 -73.9933,-118.493 -24.9944,-23.847 -58.6727,-42.4972 -101.012,-56.1755 -31.8335,-10.1687 -74.6457,-15.1631 -128.324,-15.1631l-271.496 0 0 313.003 -73.9933 0 0 91.0011 73.9933 0 0 311.991zm144.994 -120.99l0 -191.001 153.003 0 0 -91.0011 -153.003 0 0 -192.013 108.166 0c47.829,0 82.1597,3.84702 103.33,11.676 27.829,9.83127 49.1789,27.6715 63.847,53.6783 20.4949,36.8279 30.6637,92.9809 30.6637,168.481 0,53.6783 -4.34196,95.1856 -12.8459,124.184 -8.66142,29.1564 -21.3273,52.6659 -38.1552,70.6637 -16.6704,17.8178 -38.4927,30.3262 -65.5118,37.5028 -20.6524,5.15186 -62.1597,7.82902 -124.162,7.82902l-65.3318 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbf",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 519.01l0 -137.008 -123.982 0 0 137.008 123.982 0zm-123.982 -184.004l123.982 0c0.674916,-21.5073 1.01237,-34.0157 1.01237,-37.1654 0,-37.1654 -7.1766,-69.3363 -21.1699,-96.1755 -14.1732,-26.9966 -41.8223,-57.1654 -82.8346,-90.8211 -41.1699,-33.6783 -65.6693,-57.1879 -73.8358,-70.5062 -8.16648,-13.3408 -12.171,-28.5039 -12.171,-45.5118 0,-25.1519 10.6637,-47.1541 32.171,-66.1642 21.5073,-19.1676 50.1687,-28.6614 86.3442,-28.6614 34.8256,0 63.667,9.67379 86.8166,29.1564 23.0146,19.3476 39.1676,50.0112 48.6839,91.8335l125.984 -15.9955c-5.48931,-40.8324 -16.9854,-74.6682 -34.6682,-101.822 -23.982,-36.8279 -55.3206,-64.162 -93.9933,-81.6648 -38.4927,-17.6828 -80.9899,-26.5017 -127.672,-26.5017 -78.3352,0 -140.99,20.6524 -187.649,61.8223 -46.6817,41.1699 -70.0112,88.8414 -70.0112,142.835 0,20.8324 4.16198,41.1699 12.5084,61.0124 8.16648,19.6625 21.1699,39.4826 38.9876,59.4826 17.6828,19.8425 45.8493,45.8493 84.4994,77.8403 28.3465,22.8346 46.0067,41.8448 53.0034,57.0079 6.99663,15.1631 10.3262,41.8223 10.0112,80z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xae",
                                "horiz-adv-x": "736",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M370.011 730.011c64.162,0 125.647,-16.018 184.499,-48.189 58.9876,-31.991 105.332,-77.9978 138.988,-137.818 33.6783,-59.8425 50.5062,-122.497 50.5062,-188.009 0,-65.1519 -16.5129,-127.154 -49.4938,-186.322 -33.1834,-59.0101 -79.1676,-105.017 -138.178,-138.178 -59.1676,-33.0034 -121.17,-49.4938 -186.322,-49.4938 -65.1744,0 -127.177,16.4904 -186.344,49.4938 -59.0101,33.1609 -104.994,79.1676 -138.178,138.178 -32.9809,59.1676 -49.4938,121.17 -49.4938,186.322 0,65.5118 16.8279,128.166 50.5062,188.009 33.6558,59.82 80,105.827 138.988,137.818 58.8526,32.171 120.337,48.189 184.522,48.189zm0.314961 -74.0157c-51.4961,0 -100.832,-12.8234 -147.987,-38.4927 -47.1766,-25.6693 -84.342,-62.4972 -111.496,-110.664 -27.1766,-48.009 -40.8324,-98.5152 -40.8324,-151.001 0,-52.3285 13.3183,-102.34 39.82,-149.674 26.5017,-47.4916 63.5096,-84.4994 111.001,-111.159 47.4916,-26.6817 97.3453,-40 149.494,-40 52.351,0 102.182,13.3183 149.516,40 47.4916,26.6592 84.4994,63.667 111.159,111.159 26.6592,47.3341 40,97.3453 40,149.674 0,52.4859 -13.6783,102.992 -40.8324,151.001 -27.1766,48.1665 -64.342,84.9944 -111.676,110.664 -47.4916,25.6693 -96.8279,38.4927 -148.166,38.4927zm-169.336 -500l0 395.996 80.3375 0c75.3431,0 117.683,-0.314961 126.682,-0.989876 26.6592,-2.15973 47.3341,-7.49156 62.1597,-15.838 14.6682,-8.16648 26.9966,-20.8324 37.0079,-37.9978 9.83127,-17.0079 14.8256,-35.9955 14.8256,-56.6704 0,-28.6614 -9.33633,-53.0034 -28.009,-73.3183 -18.6502,-20.3375 -44.8369,-32.8459 -78.4927,-37.8403 11.991,-4.49944 21.3273,-9.49381 27.829,-14.8256 6.50169,-5.35433 15.5006,-15.5006 26.8391,-30.3487 2.99213,-4.0045 12.6659,-20 29.3363,-48.324l46.5017 -79.8425 -100 0 -32.8459 64.4994c-22.1597,43.1721 -40.4949,70.5062 -54.9831,81.6648 -14.6682,11.1811 -33.0034,16.8504 -55.3431,16.8504l-20.8324 0 0 -163.015 -81.0124 0zm81.0124 226.007l32.5084 0c46.3217,0 75.1631,1.82227 86.3217,5.33183 11.1586,3.50956 20,9.67379 26.5017,18.4927 6.50169,8.84139 9.67379,18.8301 9.67379,30.1687 0,10.8436 -3.1721,20.6749 -9.51631,29.1789 -6.32171,8.48144 -15.3206,14.6682 -26.9966,18.3352 -11.6535,3.66704 -40.3375,5.48931 -85.9843,5.48931l-32.5084 0 0 -106.997z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9d",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8c",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "{",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M28.9989 200.99l0 117.008c23.8245,1.32733 41.6648,4.8369 53.8358,10.8436 11.991,5.82677 22.3397,15.658 31.1586,29.4938 8.84139,13.8358 14.8481,31.1586 18.1777,51.991 2.49719,15.6805 3.82452,42.8346 3.82452,81.6648 0,63.1721 3.01462,107.177 8.84139,132.171 5.82677,24.9944 16.333,44.9944 31.6535,60.18 15.3431,15.1631 37.6828,26.9966 66.8391,35.8155 19.8425,5.84927 51.1811,8.84139 93.8358,8.84139l25.8268 0 0 -117.008c-36.333,0 -59.4826,-1.97975 -69.8313,-6.16423 -10.3262,-4.0045 -17.8178,-10.1687 -22.8346,-18.4927 -4.8369,-8.32396 -7.33408,-22.4972 -7.33408,-42.6772 0,-20.4949 -1.32733,-59.4826 -3.982,-116.648 -1.68729,-32.351 -5.84927,-58.3352 -12.6659,-78.5152 -6.83915,-20 -15.5006,-36.4904 -26.1867,-49.4938 -10.4837,-13.0034 -26.6592,-26.5017 -48.4814,-40.4949 19.3251,-11.0011 34.9831,-24.0045 47.3341,-38.8301 12.3285,-14.8481 21.6648,-32.8459 28.1665,-54.0157 6.65917,-21.1699 10.8211,-49.6513 12.8234,-85.1519 2.00225,-54.0157 2.99213,-88.6839 2.99213,-103.667 0,-21.5073 2.67717,-36.5129 7.85152,-45.0169 5.15186,-8.32396 12.9809,-14.8256 23.667,-19.1676 10.4837,-4.49944 33.3183,-6.65917 68.4814,-6.65917l0 -117.008 -25.8268 0c-44.0045,0 -77.6603,3.50956 -101.17,10.5062 -23.3296,6.99663 -43.1721,18.6727 -59.1676,35.0056 -16.153,16.1755 -26.9966,36.333 -32.4859,60.3375 -5.51181,23.8245 -8.34646,61.6648 -8.34646,113.161 0,59.8425 -2.65467,98.8301 -7.82902,116.67 -7.1766,26.1642 -17.9978,44.8369 -32.5084,55.9955 -14.4882,11.3386 -36.6479,17.6603 -66.6592,19.3251z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "j",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.9989 588.999l0 126.997 137.008 0 0 -126.997 -137.008 0zm137.008 -69.9888l0 -502.52c0,-65.9843 -4.34196,-112.666 -13.0034,-139.82 -8.50394,-27.1766 -25.1744,-48.5039 -49.8313,-63.667 -24.4994,-15.3431 -55.838,-23.0146 -94.0157,-23.0146 -13.6558,0 -28.324,1.16985 -44.162,3.66704 -15.838,2.33971 -32.8234,6.00675 -51.0011,11.0011l23.5096 116.67c6.50169,-1.16985 12.6659,-2.31721 18.4927,-3.14961 5.66929,-0.854893 11.0011,-1.16985 15.9955,-1.16985 14.0157,0 25.6693,2.99213 34.6682,8.99888 8.99888,5.98425 15.0056,13.3183 17.8403,21.8223 2.99213,8.50394 4.49944,33.8358 4.49944,76.1755l0 495.006 137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "Y",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M260.99 0l0 301.327 -262.497 414.668 169.516 0 169.314 -283.487 164.837 283.487 166.344 0 -262.497 -415.658 0 -300.337 -145.017 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "H",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 144.994 0 0 -282.002 282.002 0 0 282.002 144.994 0 0 -715.996 -144.994 0 0 313.003 -282.002 0 0 -313.003 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "7",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.0022 580l0 126.997 469.989 0 0 -100c-38.8301,-38.1552 -78.1552,-92.8234 -118.335,-164.162 -40,-71.3386 -70.6637,-147.177 -91.6535,-227.492 -21.0124,-80.3375 -31.3386,-152.171 -31.0011,-215.343l-131.991 0c2.31721,99.1676 22.6547,200.337 61.1474,303.51 38.6727,102.992 90.0112,195.321 154.511,276.49l-312.666 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "&",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M706.007 86.8391l-83.1721 -105.849c-40.6749,19.8425 -79.8425,47.1766 -117.345,82.0022 -28.8189,-25.9843 -59.6625,-45.1519 -92.1485,-57.5028 -32.5084,-12.3285 -71.1811,-18.4927 -116.175,-18.4927 -88.9989,0 -155.996,25.1744 -200.99,75.3431 -34.8481,38.6502 -52.171,83.3296 -52.171,133.836 0,45.9843 13.6558,87.3341 41.1699,123.982 27.3341,36.6704 68.324,68.5039 122.835,95.5006 -24.4994,28.9989 -43.0146,56.6704 -55.3431,83.0146 -12.5084,26.3217 -18.6727,51.1586 -18.6727,74.6682 0,43.3296 17.3453,80.1575 52.0135,110.326 34.4882,30.1687 84.0045,45.3318 147.987,45.3318 61.6648,0 110.011,-15.838 144.837,-47.3341 34.8256,-31.6535 52.171,-70.1687 52.171,-115.838 0,-28.9989 -8.50394,-56.4904 -25.6693,-82.4972 -17.1654,-26.0067 -51.676,-55.5006 -103.667,-88.324l98.4927 -132.508c11.676,20.6749 21.6648,47.829 30.1687,81.1699l124.342 -27.829c-12.3285,-44.0045 -23.1721,-76.333 -32.3285,-96.6704 -8.99888,-20.3375 -18.8301,-37.5028 -29.3363,-51.1586 15.3206,-14.3532 35.1631,-30.0112 59.5051,-47.1766 24.3195,-17.1654 42.1597,-28.5039 53.4983,-33.9933zm-373.498 389.989l36.8279 28.5039c27.1541,21.1699 40.6749,42.1597 40.6749,62.9921 0,17.6828 -6.50169,32.6659 -19.685,45.0169 -13.0034,12.4859 -30.6637,18.6502 -53.0034,18.6502 -21.6648,0 -38.6502,-5.48931 -50.9786,-16.333 -12.171,-11.0011 -18.3352,-23.667 -18.3352,-37.9978 0,-16.9854 10.3262,-37.5028 31.0011,-61.6648l33.4983 -39.1676zm-53.6783 -149.336c-31.3386,-15.9955 -54.8256,-35.3206 -70.5062,-57.8178 -15.5006,-22.4972 -23.3296,-45.5118 -23.3296,-68.8414 0,-29.6738 9.67379,-53.9933 28.9989,-72.6659 19.1676,-18.8301 45.0169,-28.1665 77.5028,-28.1665 21.3273,0 42.0022,4.16198 61.6648,12.6659 19.8425,8.50394 41.3498,22.4972 64.6794,42.1597l-139.01 172.666z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xef",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm-88.4814 586.007l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.484 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xde",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 144.994 0 0 -135.006 87.1766 0c87.829,0 145.152,-3.48706 172.148,-10.6637 40.8549,-11.1586 75.0056,-34.6682 102.52,-70.4837 27.4916,-36.018 41.1474,-82.5197 41.1474,-139.348 0,-43.667 -7.9865,-80.3375 -23.8245,-110.326 -15.9955,-30.0112 -36.1755,-53.4983 -60.6749,-70.8436 -24.4994,-17.1654 -49.4938,-28.324 -74.8256,-33.6558 -34.4882,-7.1766 -84.342,-10.6637 -149.674,-10.6637l-93.9933 0 0 -135.006 -144.994 0zm144.994 460l0 -204.004 78.8301 0c53.8358,0 88.009,1.84477 102.677,5.33183 20.1575,5.01687 37.1654,15.6805 51.3386,32.3285 14.1507,16.6704 21.1474,38.6727 21.1474,66.0067 0,22.1597 -5.64679,41.5073 -16.8279,57.9978 -11.1586,16.5129 -24.8369,27.6715 -40.8324,33.4983 -15.9955,5.84927 -58.3352,8.84139 -126.839,8.84139l-69.4938 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcd",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm-23.0146 780.99l68.009 146.007 153.003 0 -135.006 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbc",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.992 355.006l-92.9809 0 0 251.001c-30.6862,-21.1699 -65.6693,-37.1654 -105.017,-48.009l0 75.9955c31.0011,8.84139 59.1676,22.8346 84.342,42.3397 17.6603,13.6783 30.5062,29.8313 38.3352,48.6614l75.3206 0 0 -369.989zm1.50731 -381.012l-77.6603 0 422.497 751.001 77.5028 0 -422.34 -751.001zm439.505 5.01687l0 71.991 -175.996 0 0 68.9989 186.817 228.999 76.1755 0 0 -226.997 51.991 0 0 -71.0011 -51.991 0 0 -71.991 -86.9966 0zm0 142.992l0 108.166 -88.1665 -108.166 88.1665 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xab",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M308.999 480l-126.997 -220.337 126.997 -225.669 -106.997 0 -155.006 225.669 155.006 220.337 106.997 0zm191.001 0l-126.007 -220.337 126.007 -225.669 -106.997 0 -155.006 225.669 155.006 220.337 106.997 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9a",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x89",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "x",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M5.48931 0l187.019 267.334 -179.01 251.676 167.334 0 91.676 -142.677 97.3228 142.677 160.675 0 -175.838 -245.849 191.834 -273.161 -167.177 0 -106.817 160.832 -106.344 -160.832 -160.675 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "g",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M59.0101 -33.0034l156.985 -18.9876c2.67717,-18.5152 8.66142,-31.1811 17.9978,-38.1777 13.1834,-9.83127 33.6783,-14.8256 61.6648,-14.8256 35.838,0 62.6772,5.33183 80.6749,16.153 11.991,7.1766 21.1699,18.6727 27.3341,34.6682 4.16198,11.3386 6.34421,32.5084 6.34421,63.0146l0.652418 75.8155c-41.3273,-56.4904 -93.3408,-84.6569 -155.996,-84.6569 -69.6738,0 -124.994,29.4938 -165.669,88.324 -31.991,46.5017 -48.009,104.499 -48.009,173.678 0,86.9966 21.0124,153.341 62.8346,199.168 41.8448,45.8268 94.0157,68.8414 156.333,68.8414 64.1845,0 117.165,-28.189 158.853,-84.5219l0 73.5208 127.987 0 0 -465.354c0,-61.1474 -4.99438,-106.997 -15.1631,-137.165 -10.0112,-30.3262 -24.162,-53.9933 -42.4972,-71.3161 -18.1777,-17.1654 -42.4972,-30.8436 -73.0034,-40.5174 -30.5062,-9.83127 -68.9989,-14.6682 -115.501,-14.6682 -88.009,0 -150.326,15.1856 -187.177,45.3543 -36.8279,30.3262 -55.1631,68.4814 -55.1631,114.983 0,4.49944 0.179978,10.1687 0.517435,16.6704zm122.992 303.015c0,-55.0056 10.6637,-95.1856 31.8335,-120.675 21.3273,-25.5118 47.6715,-38.3352 78.8301,-38.3352 33.3408,0 61.6648,13.1609 84.6569,39.3251 23.1721,26.1642 34.6682,64.8369 34.6682,116.175 0,53.6558 -11.0011,93.4983 -33.1609,119.505 -22.0022,25.9843 -49.9888,38.9876 -83.8245,38.9876 -32.8459,0 -59.8425,-12.8234 -81.1699,-38.3352 -21.1699,-25.4893 -31.8335,-64.3195 -31.8335,-116.648z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "V",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M256.175 0l-256.175 715.996 156.67 0 181.822 -529.989 174.511 529.989 153.993 0 -254.668 -715.996 -156.153 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "E",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "4",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M311.001 0l0 144.004 -291.991 0 0 119.505 309.651 455.501 115.343 0 0 -455.006 88.9989 0 0 -120 -88.9989 0 0 -144.004 -133.003 0zm0 264.004l0 244.499 -163.667 -244.499 163.667 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "#",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M75.838 177.998l-66.8391 0 0 108.009 88.8414 0 29.3363 144.004 -118.178 0 0 107.987 140.157 0 38.8526 190.011 110.169 0 -38.6727 -190.011 104.994 0 37.5028 190.011 114.173 0 -38.6727 -190.011 66.5017 0 0 -107.987 -88.3465 0 -29.1564 -144.004 117.503 0 0 -108.009 -139.505 0 -38.4927 -189.989 -110.011 0 37.5028 189.989 -107.492 0 -38.8301 -189.989 -110.169 0 38.8301 189.989zm161.485 252.013l-29.3138 -144.004 106.817 0 28.3465 144.004 -105.849 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfd",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M6.00675 519.01l145.984 0 124.499 -368.166 121.507 368.166 142.002 0 -182.992 -499.505 -33.0034 -90.1687c-12.171,-30.1687 -23.667,-53.1609 -34.6682,-69.1789 -10.8436,-15.8155 -23.5096,-28.8189 -37.6603,-38.6502 -14.1732,-10.0112 -31.676,-17.6828 -52.5084,-23.1721 -20.6749,-5.51181 -44.162,-8.34646 -70.3262,-8.34646 -26.3442,0 -52.351,2.83465 -77.8403,8.34646l-11.991 106.997c21.4848,-4.16198 40.9899,-6.32171 58.3127,-6.32171 32.0135,0 55.6805,9.31384 71.0011,28.1665 15.3431,18.8301 27.1766,42.8121 35.3431,71.8335l-197.66 520zm202.002 66.9966l67.9865 145.984 153.003 0 -135.006 -145.984 -85.9843 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xec",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm164.004 586.007l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdb",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm124.994 64.9944l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xca",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm109.989 780.99l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb9",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.002 355.006l-93.0034 0 0 251.001c-30.6637,-21.1699 -65.6693,-37.1654 -104.994,-48.009l0 75.9955c31.0011,8.84139 59.1676,22.8346 84.3195,42.3397 17.6828,13.6783 30.5062,29.8313 38.3352,48.6614l75.3431 0 0 -369.989z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa8",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M2.49719 610.011l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x97",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x86",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "u",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "d",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M548.009 0l-127.019 0 0 76.1755c-21.1474,-29.6738 -46.3217,-51.8335 -75.1631,-66.8391 -28.8189,-14.8256 -57.9978,-22.3397 -87.3341,-22.3397 -59.82,0 -111.001,24.0045 -153.656,72.171 -42.4972,48.1665 -63.847,115.163 -63.847,201.327 0,88.009 20.6749,155.006 62.1822,200.832 41.4848,45.8493 93.8358,68.6839 157.165,68.6839 57.9978,0 108.324,-24.1845 150.664,-72.351l0 258.335 137.008 0 0 -715.996zm-366.007 269.494c0,-55.5006 7.67154,-95.658 22.8346,-120.495 22.1597,-35.9955 53.0034,-53.9933 92.6659,-53.9933 31.4961,0 58.3352,13.4983 80.3375,40.4949 22.1597,26.9966 33.1609,67.1766 33.1609,120.832 0,59.8425 -10.6637,102.835 -32.171,129.156 -21.5073,26.3442 -48.8189,39.5051 -82.3397,39.5051 -32.4859,0 -59.6625,-13.0034 -81.6648,-38.9876 -21.8223,-26.0067 -32.8234,-64.8369 -32.8234,-116.513z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "S",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M35.0056 231.991l140.99 14.0157c8.50394,-47.1766 25.5118,-81.6648 51.3386,-103.847 25.8268,-22.1597 60.6749,-33.1609 104.499,-33.1609 46.3442,0 81.3273,9.83127 104.837,29.4938 23.4871,19.685 35.3206,42.6772 35.3206,68.9989 0,17.0079 -4.99438,31.3386 -14.8256,43.3521 -9.83127,11.8335 -27.1541,22.1597 -51.8335,30.8211 -16.8279,6.00675 -55.1631,16.333 -115.163,31.3386 -77.1654,19.3251 -131.339,42.9921 -162.497,71.1586 -43.847,39.5051 -65.6693,87.6715 -65.6693,144.499 0,36.5129 10.3262,70.8436 30.8211,102.677 20.6749,31.8335 50.3487,55.9955 89.1789,72.6659 38.8301,16.6704 85.4893,24.9944 140.495,24.9944 89.4938,0 157.008,-19.8425 202.16,-59.6625 45.3543,-39.8425 68.9989,-92.8459 71.3386,-159.325l-144.994 -5.01687c-6.16423,37.0079 -19.3251,63.5096 -39.5051,79.6625 -20.1575,16.1755 -50.5062,24.342 -90.8211,24.342 -41.6648,0 -74.3307,-8.66142 -97.8403,-26.0067 -15.1631,-11.1586 -22.8346,-25.9843 -22.8346,-44.6569 0,-17.0079 7.1766,-31.4961 21.5073,-43.5096 18.1552,-15.5006 62.3172,-31.4961 132.486,-48.1665 70.1687,-16.4904 122.002,-33.8358 155.501,-51.4961 33.6783,-17.8403 60,-42.0022 79.0101,-72.8234 18.9876,-30.8436 28.5039,-68.8414 28.5039,-114.016 0,-40.9899 -11.3386,-79.4826 -34.1732,-115.321 -22.8346,-35.838 -55.0056,-62.4972 -96.6704,-79.8425 -41.6648,-17.5028 -93.6558,-26.1642 -155.838,-26.1642 -90.4837,0 -160,20.8324 -208.504,62.6772 -48.4814,41.6648 -77.3228,102.497 -86.8166,182.317z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "B",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l286.322 0c56.8504,0 99.0101,-2.33971 126.839,-6.99663 28.009,-4.8369 52.8459,-14.6682 74.8256,-29.4938 22.0022,-15.0056 40.3375,-34.8481 55.0056,-59.6625 14.6682,-24.8369 22.0022,-52.8459 22.0022,-83.667 0,-33.3408 -8.99888,-64.1845 -26.9966,-92.0135 -17.9978,-27.9865 -42.4972,-48.8189 -73.3408,-62.8346 43.5096,-12.8234 76.8504,-34.4882 100.337,-65.1519 23.3296,-30.6862 35.0056,-66.6817 35.0056,-108.166 0,-32.6659 -7.51406,-64.342 -22.6772,-95.1856 -15.1631,-30.8211 -35.8155,-55.5006 -62.1597,-73.9933 -26.1642,-18.3352 -58.4927,-29.6738 -97.0079,-33.9933 -23.982,-2.49719 -82.1597,-4.16198 -174.331,-4.8369l-243.825 0 0 715.996zm144.994 -118.988l0 -165.017 94.6682 0c56.1755,0 91.1586,0.832396 104.837,2.51969 24.6569,2.81215 44.162,11.3161 58.3352,25.4893 14.1732,14.1732 21.1699,32.6659 21.1699,55.658 0,22.1822 -6.16423,40 -18.3352,53.8358 -12.171,13.8358 -30.3487,22.1822 -54.3307,25.0169 -14.3307,1.66479 -55.5006,2.49719 -123.352,2.49719l-82.9921 0zm0 -284.004l0 -192.013 133.993 0c52.0135,0 85.1744,1.50731 99.1676,4.34196 21.5073,4.0045 39.0101,13.4983 52.5084,28.6614 13.4983,15.3431 20.3375,35.5006 20.3375,61.0124 0,21.6648 -5.17435,39.82 -15.6805,54.8256 -10.3262,15.0056 -25.4893,26.0067 -45.1519,32.8459 -19.6625,6.81665 -62.4972,10.3262 -128.346,10.3262l-116.828 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "1",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M393.003 0l-137.008 0 0 518.335c-49.9888,-46.9966 -108.999,-81.8448 -176.985,-104.342l0 125.017c35.8155,11.6535 74.6457,33.8133 116.49,66.6592 42.0022,32.6659 70.6637,70.8211 86.3217,114.331l111.181 0 0 -720z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: " ",
                                "horiz-adv-x": "277"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfa",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-181.012 586.007l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe9",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-177.008 283.015l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd8",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M604.837 663.667l77.6603 86.8391 68.009 -60 -82.0022 -91.8335c21.6648,-29.3363 38.4927,-65.5118 50.5062,-108.346 11.991,-42.8346 17.9978,-88.324 17.9978,-136.67 0,-113.656 -31.5186,-203.33 -94.3307,-268.661 -63.0146,-65.3318 -146.007,-97.9978 -249.336,-97.9978 -89.6738,0 -161.35,20.8324 -215.163,62.6772l-79.685 -89.1789 -68.9989 61.0124 83.847 93.6558c-47.5141,63.5096 -71.3386,146.164 -71.3386,248.009 0,113.003 31.4961,202.16 94.3307,267.672 62.9921,65.4893 146.839,98.1552 251.834,98.1552 86.9966,0 159.325,-21.8223 216.67,-65.3318zm-90.1687 -100.495c-32.8459,27.829 -74.6682,41.8223 -125.174,41.8223 -59.3251,0 -107.154,-20.4949 -143.667,-61.3273 -36.4904,-40.8324 -54.8256,-102.497 -54.8256,-184.837 0,-51.6535 7.1766,-95.9955 21.6648,-132.823l302.002 337.165zm53.4983 -76.8279l-301.507 -337.683c33.6783,-29.8313 74.1732,-44.6569 121.665,-44.6569 58.1777,0 106.007,20.9899 143.51,63.1721 37.5028,42.1597 56.1755,104.994 56.1755,188.481 0,52.8459 -6.68166,96.333 -19.8425,130.686z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc7",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M531.001 264.004l140 -43.0146c-21.5073,-78.8301 -57.3453,-137.323 -107.334,-175.658 -50.0112,-38.1552 -113.341,-57.3228 -190.169,-57.3228 -95.1631,0 -173.341,32.4859 -234.668,97.4803 -61.1699,65.0169 -91.8335,153.836 -91.8335,266.682 0,119.168 30.8436,211.834 92.3285,277.84 61.5073,65.9843 142.497,98.9876 242.835,98.9876 87.6715,0 158.83,-26.0067 213.498,-77.8403 32.6659,-30.6637 57.0079,-74.6682 73.3408,-132.148l-142.992 -34.0157c-8.50394,37.0079 -26.1642,66.3442 -53.0034,87.829 -26.9966,21.5073 -59.6625,32.171 -97.9978,32.171 -53.1834,0 -96.333,-18.9876 -129.336,-57.1654 -33.1609,-37.9978 -49.6738,-99.6625 -49.6738,-184.994 0,-90.3262 16.333,-154.826 48.8414,-193.161 32.6659,-38.5152 75.0056,-57.6828 127.154,-57.6828 38.5152,0 71.676,12.171 99.3476,36.6704 27.6715,24.4994 47.6715,62.8346 59.6625,115.343zm-314.511 -455.006l0 57.3453c33.6783,-3.50956 64.4994,-5.35433 92.6659,-5.35433 29.0214,0 50.6862,5.17435 64.6794,15.6805 10.8211,7.82902 16.1755,17.8403 16.1755,30.3262 0,11.0011 -5.01687,20.6749 -15.1856,28.8414 -10.1687,8.16648 -25.8268,12.171 -46.9966,12.171 -20.9899,0 -42.3397,-3.35208 -64.3195,-9.83127l12.8234 48.4814c25.3318,8.99888 52.6659,13.3408 82.0022,13.3408 40.8324,0 71.676,-8.99888 92.8234,-26.8391 21.1699,-17.9978 31.8335,-39.82 31.8335,-65.4893 0,-28.8414 -11.6535,-52.0135 -35.1631,-70.0112 -31.6535,-24.4994 -76.9854,-36.6704 -135.996,-36.6704 -42.0022,0 -73.8358,2.67717 -95.3431,8.009z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb6",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M311.001 -195.996l-119.01 0 0 511.001c-61.6648,4.49944 -109.156,24.3195 -142.317,59.5051 -33.1834,35.1631 -49.6738,81.6648 -49.6738,139.483 0,34.1732 6.65917,65.5118 20,94.0157 13.3408,28.324 31.3386,51.0011 53.9933,67.4916 22.4972,16.6704 49.1789,28.1665 79.6625,34.6682 18.3352,3.82452 54.0157,5.82677 107.019,5.82677l291.316 0 0 -126.997 -54.9831 0 0 -784.994 -116.018 0 0 784.994 -69.9888 0 0 -784.994z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa5",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M206.007 135.006l-182.002 0 0 106.997 182.002 0 0 58.9876 -182.002 0 0 107.019 128.819 0 -152.823 307.987 150.011 0 94.4882 -209.989c11.8335,-26.1642 22.0022,-48.5039 30.3262,-66.9966 9.17885,20.1575 19.3476,42.4972 30.5062,66.9966l95.658 209.989 150.011 0 -154.331 -307.987 130.326 0 0 -107.019 -184.004 0 0 -58.9876 184.004 0 0 -106.997 -184.004 0 0 -135.006 -136.985 0 0 135.006z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x94",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x83",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "r",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M202.992 0l-136.985 0 0 519.01 126.997 0 0 -73.6783c21.8223,34.8256 41.5073,57.6603 58.9876,68.5039 17.5028,10.8211 37.3453,16.1755 59.5051,16.1755 31.3386,0 61.5073,-8.68391 90.5062,-25.8493l-42.4972 -119.663c-23.1721,15.0056 -44.6794,22.4972 -64.4994,22.4972 -19.3476,0 -35.6805,-5.33183 -48.9989,-15.838 -13.3408,-10.6637 -23.847,-29.6513 -31.4961,-57.3228 -7.67154,-27.6715 -11.5186,-85.6693 -11.5186,-173.836l0 -160z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "a",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "P",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 231.834 0c87.829,0 144.994,-3.48706 171.654,-10.6637 41.0124,-10.8211 75.3431,-34.1732 103.015,-70.1687 27.6715,-35.9955 41.4848,-82.4972 41.4848,-139.505 0,-43.982 -7.9865,-80.8324 -23.8245,-110.821 -15.9955,-30.0112 -36.1755,-53.4983 -60.6749,-70.6637 -24.4994,-17.0079 -49.4938,-28.3465 -74.8256,-33.8358 -34.4882,-6.83915 -84.342,-10.3262 -149.674,-10.3262l-93.9933 0 0 -270.011 -144.994 0zm144.994 595.006l0 -204.004 78.8301 0c56.8279,0 94.6682,3.82452 113.836,11.3386 19.1676,7.49156 34.1732,19.1676 44.9944,35.3206 10.8436,15.9955 16.333,34.5107 16.333,55.838 0,26.1642 -7.64904,47.6715 -22.8346,64.6794 -15.3206,16.9854 -34.4882,27.649 -57.9978,31.991 -17.1654,3.1721 -51.6535,4.8369 -103.667,4.8369l-69.4938 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "?",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M366.997 184.004l-124.994 0c-0.337458,17.9978 -0.494938,28.8189 -0.494938,32.8234 0,40.3375 6.65917,73.4983 20.1575,99.6625 13.3408,26.0067 40,55.3431 80.1575,88.009 40.18,32.5084 64.1845,53.8358 72.0135,64.0045 12.171,15.9955 18.1552,33.6558 18.1552,52.8234 0,26.5017 -10.6637,49.3363 -32.1485,68.1665 -21.3498,19.0101 -50.1687,28.5039 -86.5017,28.5039 -35.0056,0 -64.1845,-9.98875 -87.8515,-29.8313 -23.4871,-20 -39.6625,-50.3262 -48.4814,-91.1586l-126.007 15.9955c3.66704,58.4927 28.5039,107.987 74.6682,148.819 46.1642,40.8549 106.839,61.1699 181.822,61.1699 79.0101,0 141.845,-20.6524 188.504,-61.8223 46.6817,-41.1699 70.0112,-88.9989 70.0112,-143.847 0,-30.1462 -8.50394,-58.9876 -25.6693,-85.9843 -17.1654,-26.9966 -53.6783,-63.847 -109.831,-110.506 -28.9989,-24.0045 -46.9966,-43.5096 -54.0157,-58.1552 -6.99663,-14.6682 -10.1462,-40.8549 -9.49381,-78.6727zm-124.994 -184.004l0 137.008 124.994 0 0 -137.008 -124.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ".",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.0011 0l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf7",
                                "horiz-adv-x": "548",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M206.007 479.01l0 136.985 136.985 0 0 -136.985 -136.985 0zm-182.002 -190.011l0 128.009 500.99 0 0 -128.009 -500.99 0zm182.002 -198.988l0 136.985 136.985 0 0 -136.985 -136.985 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe6",
                                "horiz-adv-x": "889",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M700.99 164.004l134.016 -24.0045c-18.5152,-51.0011 -46.6817,-89.1564 -84.4994,-114.668 -37.6828,-25.4893 -85.8493,-38.3352 -144.342,-38.3352 -36.4904,0 -70.1687,6.00675 -100.99,17.8403 -31.0011,11.991 -59.0101,29.9888 -84.0045,53.8358 -23.1721,-20 -53.0034,-36.8504 -89.4938,-50.8436 -36.6704,-13.8358 -74.3532,-20.8324 -113.003,-20.8324 -55.3431,0 -98.3352,14.5107 -129.336,43.3296 -30.8436,28.8414 -46.3442,65.1744 -46.3442,109.179 0,26.3217 5.51181,49.8313 16.333,70.3262 11.0011,20.6749 24.1845,36.6704 39.685,48.1665 15.5006,11.676 37.1654,21.6648 64.8144,30.1687 13.0034,4.16198 51.8335,13.0034 116.513,26.3442 32.3285,6.81665 59.82,13.9933 82.6547,21.4848l0 13.8358c0,25.1744 -6.81665,44.0045 -20.6524,56.5129 -13.6783,12.4859 -35.3431,18.6502 -65.1744,18.6502 -26.1642,0 -46.9966,-5.33183 -62.3397,-16.153 -15.3206,-10.6637 -26.3217,-27.3341 -32.8234,-49.8313l-124.004 23.982c16.333,50.5062 41.8448,87.6715 76.8279,111.339 34.8481,23.847 88.1665,35.6805 159.685,35.6805 33.8133,0 63.982,-4.0045 90.4837,-12.0135 26.5017,-7.9865 49.1789,-19.82 68.009,-35.838 19.82,16.018 41.5073,27.8515 64.9944,35.838 23.667,8.009 48.8414,12.0135 75.838,12.0135 51.991,0 95.9955,-11.0011 131.834,-33.0034 35.9955,-22.0022 64.162,-54.5107 84.8369,-97.3453 20.6524,-42.8346 30.8211,-103.487 30.4837,-181.665l-343.982 0c5.48931,-44.342 17.8178,-76.333 37.1654,-96.1755 19.1676,-19.82 42.6547,-29.8313 70.6637,-29.8313 23.1721,0 42.8346,5.84927 58.9876,17.6828 16.333,11.6535 28.6839,29.8313 37.1654,54.3307zm5.01687 140c-2.00225,28.6614 -5.84927,49.4938 -11.676,62.1597 -8.16648,18.3352 -20.3375,32.6659 -36.8279,43.1721 -16.333,10.5062 -35.6805,15.658 -57.6603,15.658 -19.1676,0 -36.018,-4.49944 -50.5062,-13.4983 -14.5107,-8.99888 -25.8268,-22.4972 -34.3307,-40.3375 -11.3386,-23.8245 -16.5129,-46.3217 -15.5006,-67.1541l206.502 0zm-345.017 -57.0079c-75.1631,-19.82 -115.996,-30.8211 -122.497,-33.1609 -21.6648,-7.1766 -36.9854,-15.838 -45.4893,-25.8268 -8.66142,-10.1687 -13.0034,-22.0022 -13.0034,-35.6805 0,-18.8301 6.99663,-35.0056 21.1699,-48.324 14.1732,-13.3408 32.6659,-20 55.5006,-20 24.0045,0 46.6592,7.67154 67.6715,22.9921 15.658,11.3386 25.6693,25.5118 29.9888,42.6772 4.49944,16.9854 6.65917,49.4938 6.65917,97.3228z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd5",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm105.017 421.507l-63.0146 0c-0.337458,7.49156 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.5129,18.4927 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.6715,-9.49381 53.4983,-21.0124 26.0067,-11.4961 46.1642,-17.3228 61.0124,-17.3228 10.3262,0 18.9876,3.32958 25.9843,9.83127 7.1766,6.65917 11.5186,17.6603 13.4983,33.1609l63.0146 0c-0.337458,-44.4994 -8.50394,-76.153 -24.4994,-95.3206 -16.1755,-19.1676 -36.8279,-28.6839 -62.1822,-28.6839 -11.1586,0 -21.9798,1.16985 -32.6659,3.50956 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -29.9888,11.8335 -51.6535,17.6603 -65.3318,17.6603 -10.5062,0 -18.4927,-3.14961 -24.3195,-9.65129 -6.00675,-6.34421 -9.02137,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc4",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-257.503 496.985l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb3",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M20 463.172l90.0112 9.83127c2.49719,-17.9978 8.48144,-31.3386 17.8178,-40 9.33633,-8.66142 21.5073,-13.0034 36.6704,-13.0034 15.658,0 28.324,4.8369 37.9978,14.6682 9.67379,9.67379 14.5107,22.4972 14.5107,37.9978 0,13.9933 -4.67942,25.5118 -13.8358,34.6682 -9.17885,9.15636 -21.1699,13.6558 -35.9955,13.6558 -9.85377,0 -24.4994,-2.49719 -44.1845,-7.33408l11.0011 71.8335c16.8504,-0.314961 30.0112,1.34983 39.5051,5.01687 9.67379,3.66704 16.333,8.32396 20.4949,13.9933 4.0045,5.51181 6.00675,11.8335 6.00675,18.8301 0,9.33633 -3.32958,16.8279 -10.1687,22.8346 -6.83915,5.82677 -16.6704,8.84139 -29.9888,8.84139 -13.1834,0 -23.847,-3.66704 -31.8335,-11.0011 -8.16648,-7.33408 -13.3408,-19.6625 -16.018,-37.0079l-86.9966 12.6659c8.16648,33.6783 20.18,57.6603 35.9955,72.0135 24.6794,22.1597 58.3352,33.3183 101.17,33.3183 40.18,0 72.0135,-9.98875 95.5006,-30.1687 23.5096,-20 35.3431,-42.9921 35.3431,-68.9989 0,-12.171 -3.32958,-23.4871 -10.1687,-33.9933 -9.17885,-14.5107 -21.5073,-26.5017 -37.0079,-35.838 22.0022,-7.82902 38.6727,-19.3251 50.1687,-34.4882 11.3386,-15.1631 17.0079,-32.8459 17.0079,-53.1834 0,-31.0011 -13.6783,-58.3127 -41.0124,-82.3172 -27.3341,-24.0045 -63.1496,-35.9955 -107.649,-35.9955 -41.6648,0 -75.0056,10.3262 -100,30.8211 -25.0169,20.6749 -39.8425,48.009 -44.342,82.3397z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa2",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M362.835 396.175l-88.6614 -295.186c7.15411,-1.32733 14.4882,-1.97975 22.0022,-1.97975 25.6468,0 46.8166,7.49156 63.4871,22.3172 16.8279,14.8481 28.5039,40.3375 35.3431,76.6704l135.006 -22.9921c-14.0157,-62.0022 -40.8549,-108.841 -80.5174,-140.495 -39.6625,-31.676 -92.6659,-47.5141 -159.168,-47.5141 -16.153,0 -32.6659,1.16985 -49.3363,3.50956l-56.8279 -187.334 -59.1676 17.8178 56.333 186.839c-45.1519,18.6727 -79.6625,50.3487 -104.004,94.8481 -24.162,44.4994 -36.333,97.1654 -36.333,157.818 0,84.4994 22.6772,150.506 67.8515,197.998 45.1519,47.6715 106.164,71.5186 182.992,71.5186 14.6682,0 29.9888,-1.01237 45.8268,-3.01462l55.3431 184.004 59.1676 -17.8403 -54.3307 -180.337c61.8223,-23.8245 103.487,-72.9809 125.152,-147.829l-134.983 -24.0045c-3.84702,23.0146 -12.351,41.3498 -25.1744,55.1856zm-56.8279 25.1519c-4.18448,0.337458 -8.16648,0.674916 -11.676,0.674916 -34.3307,0 -61.6648,-11.8335 -82.0022,-35.658 -20.1575,-23.847 -30.3262,-63.5096 -30.3262,-119.01 -0.337458,-63.3296 11.8335,-108.661 36.4904,-135.838l87.5141 289.831z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x91",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x80",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "o",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "^",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M55.9955 337.998l183.172 390.011 108.504 0 178.335 -390.011 -139.01 0 -95.658 238.673 -95.3431 -238.673 -140 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "M",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.0011 0l0 715.996 217.165 0 128.324 -488.324 126.839 488.324 217.66 0 0 -715.996 -133.993 0 -0.494938 563.667 -141.17 -563.667 -139.325 0 -140.517 563.667 -0.494938 -563.667 -133.993 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "<",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M537.008 82.0022l-491.001 213.341 0 118.155 491.001 212.508 0 -139.01 -342.497 -131.001 342.497 -135.996 0 -137.998z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "+",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M228.999 102.992l0 186.007 -188.009 0 0 128.009 188.009 0 0 185.984 124.994 0 0 -185.984 188.009 0 0 -128.009 -188.009 0 0 -186.007 -124.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf4",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm-36.9854 327.514l102.497 144.004 126.322 0 101.17 -144.004 -109.989 0 -56.5129 73.0034 -52.4859 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe3",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-178.988 336.985l-63.0146 0c-0.337458,7.51406 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.5129,18.5152 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.6715,-9.49381 53.4983,-20.9899 26.0067,-11.5186 46.1642,-17.3453 61.0124,-17.3453 10.3262,0 18.9876,3.32958 25.9843,9.83127 7.1766,6.68166 11.4961,17.6828 13.4983,33.1834l63.0146 0c-0.337458,-44.5219 -8.50394,-76.1755 -24.4994,-95.3431 -16.1755,-19.1676 -36.8504,-28.6614 -62.1822,-28.6614 -11.1586,0 -22.0022,1.16985 -32.6659,3.48706 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -29.9888,11.8335 -51.6535,17.6828 -65.3318,17.6828 -10.5062,0 -18.4927,-3.1721 -24.342,-9.67379 -5.98425,-6.34421 -8.99888,-17.5028 -9.31384,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd2",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm288.009 422.497l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc1",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-151.001 496.985l68.009 146.007 152.981 0 -134.983 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb0",
                                "horiz-adv-x": "399",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.0022 573.498c0,43.1721 15.1631,80 45.4893,110.169 30.5062,30.1687 67.1766,45.3318 110.011,45.3318 42.8346,0 79.5051,-15.1631 109.989,-45.4893 30.3487,-30.5062 45.5118,-67.1766 45.5118,-110.011 0,-42.8346 -15.1631,-79.5051 -45.5118,-109.989 -30.4837,-30.3487 -67.1541,-45.5118 -109.989,-45.5118 -42.8346,0 -79.5051,15.1631 -110.011,45.5118 -30.3262,30.4837 -45.4893,67.1541 -45.4893,109.989zm80.9899 0c0,-20.4949 7.33408,-37.9978 21.8448,-52.6659 14.6682,-14.4882 32.171,-21.8223 52.6659,-21.8223 20.4949,0 37.9978,7.33408 52.6659,21.8223 14.4882,14.6682 21.8223,32.171 21.8223,52.6659 0,20.4949 -7.33408,37.9978 -21.8223,52.6659 -14.6682,14.5107 -32.171,21.8448 -52.6659,21.8448 -20.4949,0 -37.9978,-7.33408 -52.6659,-21.8448 -14.5107,-14.6682 -21.8448,-32.171 -21.8448,-52.6659z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9f",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8e",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "}",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M355.996 200.99c-23.8245,-1.32733 -41.6648,-4.8144 -53.6558,-10.6637 -12.171,-5.98425 -22.4972,-15.8155 -31.1811,-29.6513 -8.48144,-13.8358 -14.6682,-31.1811 -18.3352,-52.0135 -2.49719,-15.658 -3.82452,-42.6547 -3.82452,-81.1699 0,-63.1496 -2.83465,-107.334 -8.50394,-132.486 -5.66929,-25.0169 -16.153,-45.1744 -31.4961,-60.3375 -15.3431,-15.1631 -37.8403,-26.9966 -67.3341,-35.838 -19.8425,-5.82677 -51.1586,-8.84139 -93.8358,-8.84139l-25.8268 0 0 117.008c35.0056,0 57.8403,2.15973 68.6614,6.65917 10.6637,4.34196 18.6727,10.6862 23.667,19.0101 5.17435,8.32396 7.67154,22.3397 7.82902,42.3397 0.179978,19.82 1.50731,57.8178 3.84702,113.836 1.66479,33.9933 5.98425,60.9899 13.1609,81.4848 7.1766,20.3375 16.6704,37.6828 28.5039,51.8335 11.991,14.1732 27.1541,26.5017 45.6693,37.3453 -24.0045,15.658 -41.6648,31.0011 -52.6659,45.8268 -15.3431,21.5073 -25.8493,48.8414 -31.3386,82.1597 -3.50956,22.6772 -6.00675,72.8459 -7.33408,150.349 -0.337458,24.3195 -2.49719,40.6524 -6.65917,48.8189 -4.0045,8.009 -11.3386,14.3307 -22.0022,18.6727 -10.6637,4.49944 -34.3307,6.65917 -71.3386,6.65917l0 117.008 25.8268 0c44.0045,0 77.6603,-3.50956 101.17,-10.3262 23.3296,-6.83915 42.9921,-18.5152 59.0101,-34.8481 15.9955,-16.4904 26.8166,-36.6479 32.4859,-60.6524 5.66929,-23.847 8.50394,-61.6648 8.50394,-113.161 0,-59.5051 2.49719,-98.5152 7.33408,-116.67 7.1766,-26.1642 17.9978,-44.8369 32.6659,-56.018 14.6682,-11.3161 37.0079,-17.6603 66.9966,-19.3251l0 -117.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "l",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 715.996 137.008 0 0 -715.996 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "[",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 -202.002l0 917.998 243.015 0 0 -107.987 -113.003 0 0 -702.002 113.003 0 0 -108.009 -243.015 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "J",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M330.011 715.996l144.994 0 0 -453.656c0,-59.3476 -5.17435,-105.017 -15.6805,-137.008 -13.9933,-41.6648 -39.3251,-75.1631 -76.153,-100.495 -36.6704,-25.1744 -85.1744,-37.8403 -145.512,-37.8403 -70.6637,0 -124.994,19.6625 -162.992,59.1676 -38.1777,39.5051 -57.3453,97.5028 -57.6603,173.836l136.985 15.9955c1.66479,-40.8324 7.51406,-69.6513 17.8403,-86.5017 15.5006,-25.6693 39.0101,-38.4927 70.6637,-38.4927 31.8335,0 54.5107,9.15636 67.6715,27.6715 13.1609,18.3352 19.8425,56.4904 19.8425,114.488l0 462.835z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "9",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M46.9966 166.344l133.003 14.6457c3.1721,-27.1541 11.676,-47.3341 25.1744,-60.315 13.4983,-13.1834 31.4961,-19.685 53.6558,-19.685 28.1665,0 52.0135,13.1834 71.676,39.3476 19.6625,26.1642 32.171,80.4949 37.6603,162.655 -34.5107,-40 -77.5028,-60 -129.336,-60 -56.153,0 -104.837,21.6648 -145.669,65.1744 -40.8324,43.5096 -61.1699,100 -61.1699,169.674 0,72.6659 21.5073,131.159 64.6794,175.501 43.1721,44.4994 98.1552,66.6592 164.837,66.6592 72.4859,0 132.148,-28.1665 178.65,-84.342 46.5017,-56.333 69.8538,-148.819 69.8538,-277.818 0,-131.001 -24.1845,-225.669 -72.5084,-283.667 -48.3465,-58.1777 -111.339,-87.1766 -188.999,-87.1766 -55.838,0 -100.832,15.0056 -135.343,44.9944 -34.3307,29.8313 -56.4904,74.6682 -66.1642,134.353zm308.999 300.315c0,44.1845 -10.1687,78.5152 -30.5062,102.835 -20.1575,24.342 -43.667,36.5129 -70.3262,36.5129 -25.3318,0 -46.3217,-10.0112 -62.9921,-30.0112 -16.8279,-20 -25.1744,-52.6659 -25.1744,-97.9978 0,-46.1642 9.17885,-80 27.3341,-101.665 18.1777,-21.5073 40.8324,-32.3285 68.1665,-32.3285 26.3442,0 48.5039,10.3262 66.5017,31.1586 17.9978,20.8324 26.9966,51.3386 26.9966,91.4961z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "(",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M300 -210.011l-93.9933 0c-50.1687,75.1856 -88.3465,153.183 -114.668,234.353 -26.1642,80.9899 -39.3476,159.325 -39.3476,235.163 0,93.9933 16.1755,182.992 48.3465,266.997 28.1665,72.8234 63.667,140 106.659,201.507l93.9933 0c-44.8144,-98.5152 -75.8155,-182.52 -92.6659,-251.519 -16.8279,-69.1564 -25.3318,-142.497 -25.3318,-220 0,-53.3183 5.01687,-107.987 15.0056,-163.982 10.1687,-55.838 23.8245,-108.999 41.3273,-159.505 11.5186,-33.1609 31.676,-80.8324 60.6749,-143.015z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf1",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M544.004 0l-137.008 0 0 264.499c0,55.9955 -2.99213,92.171 -8.8189,108.504 -6.00675,16.4904 -15.5006,29.1564 -28.8414,38.3352 -13.3408,9.15636 -29.3363,13.6558 -48.009,13.6558 -24.0045,0 -45.4893,-6.50169 -64.4994,-19.5051 -19.1676,-12.9809 -32.171,-30.3262 -39.1676,-51.6535 -7.15411,-21.5073 -10.6637,-61.1699 -10.6637,-119.168l0 -234.668 -136.985 0 0 519.01 126.997 0 0 -76.1755c45.4893,58.1552 102.655,87.1766 171.834,87.1766 30.3262,0 58.1552,-5.51181 83.3296,-16.3555 25.3318,-10.9786 44.3195,-24.8144 57.1654,-41.6648 13.0034,-16.9854 22.0022,-36.153 26.9966,-57.6603 5.17435,-21.5073 7.67154,-52.171 7.67154,-92.171l0 -322.16zm-328.009 584.994l-62.9921 0c-0.337458,7.51406 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.4904,18.5152 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.649,-9.49381 53.4983,-20.9899 25.9843,-11.5186 46.1642,-17.3453 60.9899,-17.3453 10.3487,0 19.0101,3.32958 26.0067,9.83127 7.15411,6.68166 11.4961,17.6828 13.4983,33.1834l62.9921 0c-0.314961,-44.5219 -8.50394,-76.1755 -24.4994,-95.3431 -16.153,-19.1676 -36.8279,-28.6614 -62.1597,-28.6614 -11.1586,0 -22.0022,1.16985 -32.6659,3.48706 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -30.0112,11.8335 -51.676,17.6828 -65.3318,17.6828 -10.5062,0 -18.5152,-3.1721 -24.342,-9.67379 -6.00675,-6.34421 -8.99888,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe0",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm2.99213 337.998l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcf",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm-80.5174 780.99l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbe",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M20 463.172l90.0112 9.83127c2.49719,-17.9978 8.48144,-31.3386 17.8178,-40 9.33633,-8.66142 21.5073,-13.0034 36.6704,-13.0034 15.658,0 28.324,4.8369 37.9978,14.6682 9.67379,9.67379 14.5107,22.4972 14.5107,37.9978 0,13.9933 -4.67942,25.5118 -13.8358,34.6682 -9.17885,9.15636 -21.1699,13.6558 -35.9955,13.6558 -9.85377,0 -24.4994,-2.49719 -44.1845,-7.33408l11.0011 71.8335c16.8504,-0.314961 30.0112,1.34983 39.5051,5.01687 9.67379,3.66704 16.333,8.32396 20.4949,13.9933 4.0045,5.51181 6.00675,11.8335 6.00675,18.8301 0,9.33633 -3.32958,16.8279 -10.1687,22.8346 -6.83915,5.82677 -16.6704,8.84139 -29.9888,8.84139 -13.1834,0 -23.847,-3.66704 -31.8335,-11.0011 -8.16648,-7.33408 -13.3408,-19.6625 -16.018,-37.0079l-86.9966 12.6659c8.16648,33.6783 20.18,57.6603 35.9955,72.0135 24.6794,22.1597 58.3352,33.3183 101.17,33.3183 40.18,0 72.0135,-9.98875 95.5006,-30.1687 23.5096,-20 35.3431,-42.9921 35.3431,-68.9989 0,-12.171 -3.32958,-23.4871 -10.1687,-33.9933 -9.17885,-14.5107 -21.5073,-26.5017 -37.0079,-35.838 22.0022,-7.82902 38.6727,-19.3251 50.1687,-34.4882 11.3386,-15.1631 17.0079,-32.8459 17.0079,-53.1834 0,-31.0011 -13.6783,-58.3127 -41.0124,-82.3172 -27.3341,-24.0045 -63.1496,-35.9955 -107.649,-35.9955 -41.6648,0 -75.0056,10.3262 -100,30.8211 -25.0169,20.6749 -39.8425,48.009 -44.342,82.3397zm234.668 -489.179l-77.6603 0 424.499 751.001 77.6603 0 -424.499 -751.001zm430.326 5.01687l0 71.991 -175.996 0 0 68.9989 186.839 228.999 76.153 0 0 -226.997 52.0135 0 0 -71.0011 -52.0135 0 0 -71.991 -86.9966 0zm0 142.992l0 108.166 -88.1665 -108.166 88.1665 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xad",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M55.9955 191.001l0 137.008 270.011 0 0 -137.008 -270.011 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9c",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8b",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "z",
                                "horiz-adv-x": "500",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M15.9955 0l0 108.009 194.173 222.497c31.991,36.4904 55.5006,62.1597 70.8211,77.5028 -15.9955,-1.01237 -36.9854,-1.66479 -62.9921,-2.00225l-182.992 -1.01237 0 114.016 428.999 0 0 -97.0079 -198.178 -228.346 -69.8313 -75.658c37.9978,2.00225 61.6648,2.99213 70.8436,2.99213l212.171 0 0 -120.99 -463.015 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "i",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 588.999l0 126.997 137.008 0 0 -126.997 -137.008 0zm0 -588.999l0 519.01 137.008 0 0 -519.01 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "X",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M0.494938 0l247.177 373.341 -224.162 342.655 168.819 0 141.012 -213.161 140.99 213.161 169.179 0 -224.679 -342.835 246.659 -373.161 -173.656 0 -158.673 242.497 -158.83 -242.497 -173.836 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "G",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M406.007 262.992l0 121.012 311.001 0 0 -285.669c-30.1687,-29.4938 -74.0157,-55.3431 -131.519,-77.8403 -57.3228,-22.3172 -115.478,-33.4983 -174.488,-33.4983 -74.8256,0 -140,15.6805 -195.658,47.1766 -55.5006,31.4961 -97.3453,76.6704 -125.332,135.163 -28.009,58.4927 -42.0022,122.34 -42.0022,191.159 0,74.6682 15.658,141.012 46.8166,199.168 31.3386,57.9978 77.0079,102.677 137.165,133.678 46.0067,23.8245 103.015,35.658 171.339,35.658 88.8414,0 158.335,-18.6727 208.346,-55.9955 49.8313,-37.5028 81.9798,-88.9989 96.333,-155.006l-144.004 -26.9966c-10.0112,35.1631 -28.9989,62.9921 -56.8279,83.5096 -27.6715,20.315 -62.3397,30.4837 -104.004,30.4837 -63.0146,0 -113.161,-20 -150.349,-60.1575 -37.1654,-40.18 -55.8155,-99.6625 -55.8155,-178.493 0,-85.1744 18.8301,-149.021 56.4904,-191.519 37.8403,-42.4972 87.1766,-63.8245 148.324,-63.8245 30.1687,0 60.5174,6.00675 90.8436,17.8403 30.5062,11.8335 56.4904,26.3217 78.3352,43.3296l0 90.8211 -164.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "6",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M506.997 540.675l-133.003 -14.6682c-3.14961,27.3341 -11.6535,47.4916 -25.3318,60.4949 -13.6558,13.0034 -31.3386,19.5051 -53.1609,19.5051 -28.9989,0 -53.4983,-13.0034 -73.4983,-39.0101 -20,-26.0067 -32.5084,-80.1575 -37.6603,-162.497 34.1507,40.3375 76.4904,60.4949 127.334,60.4949 57.1654,0 106.322,-21.8223 147.154,-65.4893 40.8324,-43.847 61.1699,-100.18 61.1699,-169.336 0,-73.3408 -21.5073,-132.328 -64.4994,-176.67 -42.9921,-44.342 -98.1777,-66.5017 -165.489,-66.5017 -72.171,0 -131.676,28.1665 -178.178,84.4994 -46.5017,56.333 -69.8313,148.504 -69.8313,276.828 0,131.519 24.342,226.344 72.8234,284.499 48.5039,58.1777 111.519,87.1766 188.999,87.1766 54.3532,0 99.3476,-15.3431 135.006,-46.0067 35.6805,-30.4837 58.3352,-74.9831 68.1665,-133.318zm-311.001 -299.685c0,-44.6569 10.3487,-79.1676 30.8436,-103.487 20.4949,-24.342 43.8245,-36.5129 70.3262,-36.5129 25.3318,0 46.5017,10.0112 63.5096,29.8538 16.8279,20 25.3318,52.6659 25.3318,97.9978 0,46.6592 -9.17885,80.8324 -27.3341,102.655 -18.3352,21.6648 -41.0124,32.5084 -68.3465,32.5084 -26.5017,0 -48.6614,-10.3487 -66.9966,-31.1811 -18.1552,-20.6524 -27.3341,-51.3161 -27.3341,-91.8335z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "%",
                                "horiz-adv-x": "889",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 540.495c0,64.0045 14.1732,111.339 42.3397,142.182 28.1665,30.8211 66.3442,46.3217 114.511,46.3217 49.8313,0 88.8189,-15.3431 116.985,-46.0067 28.1665,-30.6637 42.1822,-78.1552 42.1822,-142.497 0,-64.0045 -14.0157,-111.339 -42.1822,-142.16 -28.1665,-30.8436 -66.5017,-46.3442 -114.668,-46.3442 -49.8313,0 -88.6614,15.3431 -116.828,46.0067 -28.1665,30.6637 -42.3397,78.1777 -42.3397,142.497zm107.019 0c0,-46.1642 5.33183,-77.1654 16.153,-93.0034 8.16648,-11.6535 19.5051,-17.4803 33.8358,-17.4803 14.6682,0 26.1642,5.82677 34.3307,17.4803 10.5062,15.838 15.6805,46.8391 15.6805,93.0034 0,46.1642 -5.17435,77.0079 -15.6805,92.5084 -8.16648,11.991 -19.6625,17.9978 -34.3307,17.9978 -14.3307,0 -25.6693,-5.82677 -33.8358,-17.5028 -10.8211,-15.838 -16.153,-46.8391 -16.153,-93.0034zm154.488 -568.504l-101.507 0 381.17 757.008 99.3476 0 -379.01 -757.008zm221.507 188.841c0,64.162 14.1507,111.676 42.3172,142.677 28.1665,31.0011 66.6817,46.5017 115.501,46.5017 49.1789,0 87.8515,-15.5006 116.018,-46.5017 28.1665,-31.0011 42.1597,-78.5152 42.1597,-142.677 0,-64.6569 -13.9933,-112.328 -42.1597,-143.33 -28.1665,-31.0011 -66.5017,-46.5017 -114.668,-46.5017 -49.8313,0 -88.6839,15.5006 -116.85,46.5017 -28.1665,31.0011 -42.3172,78.6727 -42.3172,143.33zm106.997 -0.337458c0,-46.6592 5.33183,-77.8178 16.153,-93.3183 8.16648,-12.171 19.5051,-18.1777 33.8358,-18.1777 14.6682,0 26.0067,5.82677 33.8358,17.6603 10.8436,15.838 16.1755,47.1766 16.1755,93.8358 0,46.6817 -5.17435,77.9978 -15.6805,93.8358 -8.16648,11.8335 -19.6625,17.6603 -34.3307,17.6603 -14.6682,0 -25.9843,-5.82677 -33.8358,-17.6603 -10.8211,-15.838 -16.153,-47.1541 -16.153,-93.8358z"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "id0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "3601",
                            y: "1252",
                            width: "2439",
                            height: "1828"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Camada_x0020_1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("metadata", {
                        id: "CorelCorpID_0Corel-Layer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "#FEFEFE",
                        x: "6166",
                        y: "1256",
                        width: "5151",
                        height: "1370"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "#FEFEFE",
                        width: "3599",
                        height: "991"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "#221F1F",
                        x: "3600",
                        y: "812",
                        width: "200%",
                        height: "100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        transform: "matrix(1 0 0 1 -4226.83 -10394.7)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                            x: "7800",
                            y: "11000",
                            fill: "#221F1F",
                            "font-weight": "bold",
                            "font-size": "500",
                            "font-family": "Arial",
                            id: "prodName",
                            children: data === null || data === void 0 ? void 0 : data["Product Name"]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "_717381648",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "1947,608 1947,106 2085,106 2085,480 2239,480 2239,608 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "1500,608 1500,106 1637,106 1637,282 1776,282 1776,106 1913,106 1913,608 1776,608 1776,421 1637,421 1637,608 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "1033,106 835,345 1062,609 880,609 726,429 725,429 725,608 588,608 588,106 725,106 725,256 724,257 855,106 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "black",
                                d: "M959 353c0,-145 116,-262 259,-262 143,0 259,117 259,262 0,145 -116,262 -259,262 -143,0 -259,-117 -259,-262zm259 129c64,0 117,-58 117,-129 0,-71 -52,-129 -117,-129 -64,0 -117,58 -117,129 0,71 52,129 117,129z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "2405,106 2546,106 2546,222 2408,222 2408,301 2535,301 2535,414 2408,414 2408,491 2547,491 2547,608 2406,608 2267,608 2267,106 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "black",
                                d: "M2832 408l143 201 -150 0 -112 -154 0 154 -135 0 0 -502 172 0c151,0 248,190 81,302zm-81 -88c27,0 48,-22 48,-48 0,-27 -22,-48 -48,-48l-39 0 0 97 39 0z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "black",
                                d: "M2992 590c0,-17 14,-31 31,-31 17,0 31,14 31,31 0,17 -14,31 -31,31 -17,0 -31,-14 -31,-31zm57 0c0,-14 -12,-26 -26,-26 -14,0 -26,11 -26,26 0,14 12,26 26,26 14,0 26,-12 26,-26zm-12 17l-6 0 -10 -15 -6 0 0 15 -5 0 0 -34 15 0c6,0 12,2 12,9 0,7 -5,9 -11,9l10 15zm-16 -20c4,0 11,1 11,-5 0,-3 -5,-4 -8,-4l-9 0 0 9 6 0 0 0z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                "enable-background": "new ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M759 880c-17,23 -44,32 -70,32 -65,0 -103,-53 -103,-110 0,-63 35,-118 103,-118 47,0 86,21 93,72l-29 0c-6,-33 -32,-48 -65,-48 -53,0 -75,46 -75,92 0,45 26,87 75,87 45,0 71,-31 70,-71l-69 0 0 -24 95 0 0 114 -18 0 -8 -27z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "827,690 977,690 977,714 856,714 856,783 969,783 969,808 856,808 856,883 978,883 978,907 827,907 827,690 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1013,690 1044,690 1158,866 1159,866 1159,690 1186,690 1186,907 1155,907 1041,733 1040,733 1040,907 1013,907 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M1407 829c0,55 -31,84 -86,84 -56,0 -89,-26 -89,-84l0 -139 29 0 0 139c0,39 22,59 60,59 37,0 57,-21 57,-59l0 -139 29 0 0 139 0 0z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1454,690 1483,690 1483,907 1454,907 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1532,690 1562,690 1677,866 1677,866 1677,690 1705,690 1705,907 1673,907 1560,733 1559,733 1559,907 1532,907 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1752,690 1902,690 1902,714 1781,714 1781,783 1894,783 1894,808 1781,808 1781,883 1903,883 1903,907 1752,907 1752,690 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2022 690l95 0c44,0 67,24 67,64 0,41 -23,65 -67,64l-66 0 0 89 -29 0 0 -217 0 0zm29 104l57 0c33,0 48,-14 48,-40 0,-26 -15,-40 -48,-40l-57 0 0 80z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2279 690l32 0 85 217 -32 0 -24 -65 -92 0 -24 65 -30 0 85 -217zm-22 128l74 0 -36 -101 -1 0 -37 101z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2417 690l102 0c41,0 66,22 66,57 0,27 -11,48 -38,55l0 1c25,5 30,24 33,45 2,21 1,45 13,60l-32 0c-8,-9 -4,-32 -8,-54 -3,-21 -8,-39 -36,-39l-71 0 0 93 -29 0 0 -217 0 0zm89 100c27,0 50,-7 50,-39 0,-22 -12,-37 -39,-37l-72 0 0 76 60 0 0 0z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "2675,714 2603,714 2603,690 2776,690 2776,714 2704,714 2704,907 2675,907 2675,714 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2926 753c-3,-31 -24,-44 -54,-44 -25,0 -49,9 -49,37 0,54 139,16 139,101 0,46 -45,65 -85,65 -49,0 -90,-24 -90,-77l27 0c0,37 30,52 63,52 26,0 55,-8 55,-40 0,-60 -139,-20 -139,-100 0,-44 39,-64 79,-64 44,0 79,21 80,69l-27 0 0 0z"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        "clip-path": "url(#id0)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
                            id: "prodImg",
                            transform: "matrix(0.825998 0 0 0.825998 -3159.78 -6012.29)",
                            x: "7800",
                            y: "8795",
                            width: "2953",
                            height: "2213",
                            xlinkHref: data === null || data === void 0 ? void 0 : data.uri
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                        x: "6416",
                        y: "1883",
                        fill: "#606062",
                        "font-weight": "bold",
                        "font-size": "220.234",
                        "font-family": "Arial",
                        id: "prodCod",
                        children: data === null || data === void 0 ? void 0 : data.Cod
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                        x: "6407",
                        y: "1607",
                        fill: "#607CA1",
                        "font-weight": "bold",
                        "font-size": "200",
                        "font-family": "Arial",
                        id: "prodDesc",
                        children: data === null || data === void 0 ? void 0 : data["Short Description"]
                    })
                ]
            })
        ]
    });
};
const AddToCartLoadingIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "spinner-border text-secondary"
    });
const AddedIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "19",
        height: "30",
        viewBox: "0 0 19 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.7853 9L16.5 9.65557L8.09735 20L2.5 15.2495L3.07941 14.4766L7.96677 18.6253L15.7853 9Z",
                fill: "white"
            })
        })
    });


/***/ }),

/***/ 89676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        printDiagrams: t("kf.myList.parts.partviewer.printDiagrams"),
        printAllText: t("kf.myList.parts.partviewer.printAllText"),
        printSelectedText: t("kf.myList.parts.partviewer.printSelectedText"),
        mailBody: t("kf.partViewer.emailBody"),
        description: t("kf.orderDetails.label.viewPartsDiagram"),
        mailSubjectTextOne: t("kf.partViewer.emailSubject"),
        mailSubjectTextTwo: t("kf.orderDetails.label.viewPartsDiagram"),
        discontinuedText: t("kf.partViewer.gridView.discontinuedText"),
        addingCartText: t("kf.partViewer.gridView.cart.addingCartText"),
        addedCartText: t("kf.partViewer.gridView.cart.addedCartText"),
        outOfStockText: t("kf.compare.label.outOfStock"),
        addToCart: t("kf.cart.label.addToCart"),
        colorFinish: t("kf.pdp.label.colorOrFinish"),
        addedText: t("kf.partViewer.gridView.cart.addedText"),
        notifyText: t("kf.partViewer.NotifyMe.cart.notifyText"),
        notifySuccessText: t("kf.partViewer.NotifyMe.cart.notifySuccessText"),
        notifyEmailText: t("kf.partViewer.NotifyMe.cart.notifyEmailText"),
        successText: t("kf.partViewer.NotifyMe.cart.successText"),
        notifyOutofStockText: t("kf.partViewer.NotifyMe.cart.notifyOutofStockText"),
        notifyButtonText: t("kf.partViewer.NotifyMe.cart.notifyButtonText"),
        inventoryTextVal: (inventory)=>t("kf.partViewer.addtocart.cart.inventoryText", {
                inventory
            }),
        cartNotificationText: (number, category)=>t("kf.partViewer.gridView.cart.Notification", {
                number,
                category
            }),
        errorText: t("kf.partViewer.pageError.errorText"),
        queryText: t("kf.partViewer.pageError.queryText"),
        contactUsButton: t("kf.partViewer.pageError.contactUsButton"),
        viewreplacement: t("kf.partViewer.replacementPart.viewreplacement"),
        replacing: t("kf.partViewer.replacementPart.replacing"),
        replacedby: t("kf.partViewer.replacementPart.replacedby"),
        partname: t("kf.partViewer.replacementPart.partname"),
        partnumber: t("kf.partViewer.replacementPart.partnumber"),
        errorSorryText: t("kf.error.parts.partviewer.sorryErrorText"),
        errorTextTwo: t("kf.error.parts.partviewer.anyText"),
        errorContactText: t("kf.error.parts.partviewer.contact"),
        totalCountText: t("kf.plp.label.results"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        expandText: t("kf.myList.parts.partviewer.expand"),
        exitExpandText: t("kf.myList.parts.partviewer.exitExpand"),
        gridViewText: t("kf.myList.parts.partviewer.gridViewText"),
        listViewText: t("kf.myList.parts.partviewer.listViewText"),
        listPriceText: t("kf.list.table.listPrice"),
        sortByText: t("kf.plp.label.sort"),
        sortText: t("kf.plp.label.img.altSort"),
        exitFullScreenText: t("kf.myList.partViewer.exitFullScreenText"),
        fullScreenText: t("kf.myList.partViewer.fullScreenText"),
        coachMarkText: t("kf.myList.partViewer.coachMark"),
        listPriceDescText: t("kf.pdp.label.listPriceInfo"),
        parts: t("kf.search.label.parts"),
        diagramText: t("kf.myList.partViewer.diagramText"),
        replacesText: t("kf.myList.partViewer.replacesText"),
        feedbackText: t("kf.visualsearch.label.feedback")
    };
};


/***/ }),

/***/ 30525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ getAnalyticsData; },
/* harmony export */   "I1": function() { return /* binding */ productSuggestionLinkAnalytics; },
/* harmony export */   "ME": function() { return /* binding */ replaceAddToCartDatalayerPush; },
/* harmony export */   "Pt": function() { return /* binding */ getProductInfoAnalytics; },
/* harmony export */   "Qq": function() { return /* binding */ pushAnalyticsToDataLayer; },
/* harmony export */   "fl": function() { return /* binding */ addDataLayerFavGuestUser; },
/* harmony export */   "mw": function() { return /* binding */ addToCompareAnalytics; },
/* harmony export */   "t8": function() { return /* binding */ addDatalayerLocalStoreHrefClick; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49139);


const getAnalyticsData = function(type, url) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isBundleProduct = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const title = type.toLowerCase().trim();
    let eventAction;
    let internalLinkZoneName;
    let internalLinkType;
    let internalLinkPosition;
    let internalLinkURL;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    var ref6;
    const pageType = (ref6 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType) !== null && ref6 !== void 0 ? ref6 : "pdp";
    if (title === "notify me") {
        var ref7;
        internalLinkZoneName = "".concat(page === null || page === void 0 ? void 0 : (ref7 = page.category) === null || ref7 === void 0 ? void 0 : ref7.pageType, ":modal:availability notification");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
    } else if (title === "local store or showroom") {
        var ref8;
        var ref9;
        eventAction = "".concat((ref9 = page === null || page === void 0 ? void 0 : (ref8 = page.category) === null || ref8 === void 0 ? void 0 : ref8.pageType) !== null && ref9 !== void 0 ? ref9 : "pdp", ":").concat(title);
        internalLinkPosition = pageType;
        internalLinkType = "".concat(pageType, ":").concat(title);
        internalLinkZoneName = "".concat(pageType, ":product details");
        internalLinkURL = "n/a";
    } else if (title === "where to buy") {
        internalLinkURL = "".concat(window.location.origin + url);
    }
    const eventInfo = {
        eventAction: eventAction || "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType, ":product details:").concat(title),
        eventName: eventAction || "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType, ":product details:").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(title),
        internalLinkPosition: internalLinkPosition || "".concat(page === null || page === void 0 ? void 0 : (ref3 = page.category) === null || ref3 === void 0 ? void 0 : ref3.pageType).concat(isBundleProduct ? ":bundle" : ""),
        internalLinkType: internalLinkType || "".concat(page === null || page === void 0 ? void 0 : (ref4 = page.category) === null || ref4 === void 0 ? void 0 : ref4.pageType, ":").concat(title),
        internalLinkZoneName: internalLinkZoneName || "".concat(page === null || page === void 0 ? void 0 : (ref5 = page.category) === null || ref5 === void 0 ? void 0 : ref5.pageType, ":product details"),
        internalLinkURL: internalLinkURL || "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const replaceAddToCartDatalayerPush = (replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData)=>{
    const eventInfo = getAnalyticsData(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, true);
    const page = window.adobeDataLayer.getState("page");
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addToCompareAnalytics = (isChecked, analyticData)=>{
    const compareText = "".concat(isChecked ? "remove" : "add to", " compare");
    const eventInfo = {
        eventAction: "pdp:product details:".concat(compareText),
        eventName: "pdp:product details:".concat(compareText),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isChecked ? "remove compare" : "compare add"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(compareText),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const page = window.pageObj || {};
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const addDatalayerLocalStoreHrefClick = (type, link, productInfo)=>{
    // Check if the string contains a colon
    let linkName;
    if (type.includes(":")) {
        linkName = type.split(":")[1].trim() // Split and get the phone number
        ;
    }
    const eventInfo = {
        eventAction: "pdp:" + type,
        eventName: "pdp:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkName || type,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(linkName !== undefined ? linkName : type),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: link || "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};
const addDataLayerFavGuestUser = ()=>{
    var ref, ref1, ref2, ref3;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_DETAILS, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_GUEST_FAVORITE),
        eventMsg: "n/a",
        eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_DETAILS, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_GUEST_FAVORITE),
        eventStatus: "n/a",
        eventType: _constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FAVORITE,
        internalLinkName: _constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FAVORITE,
        internalLinkPosition: page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : (ref1 = ref.pageType) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
        internalLinkType: "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageType) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FAVORITE),
        internalLinkURL: window.location.href,
        internalLinkZoneName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_DETAILS)
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const productSuggestionLinkAnalytics = (eventName, url, analyticData)=>{
    const pageType = window.eventPageType;
    const eventInfo = {
        eventAction: "".concat(pageType, ":product details:").concat(eventName),
        eventName: "".concat(pageType, ":product details:").concat(eventName),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(eventName),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":product details:").concat(eventName),
        internalLinkURL: "".concat(url),
        clickInternalLinks: "true"
    };
    const page = window.adobeDataLayer.getState("page");
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const sanitizeTextForAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const testData = text !== null && text !== void 0 ? text : "";
    return String(testData).replace(_constants_regex__WEBPACK_IMPORTED_MODULE_1__/* .SANITIZE_TEXT_REGEX */ .If, "").toLowerCase().trim();
};
const getProductInfoAnalytics = (data)=>{
    var ref, ref1;
    const { getState =()=>{}  } = window.adobeDataLayer;
    const page = getState().page;
    const customerFacingSKUId = data.customerFacingSKU || data.sku;
    var ref2;
    return {
        productBrand: page === null || page === void 0 ? void 0 : (ref = page.site) === null || ref === void 0 ? void 0 : ref.siteName,
        description: sanitizeTextForAnalytics(data.desc) || "n/a",
        frequency: "n/a",
        globalPromotionPrice: Number(data.discountPrice) ? Number(data.discountPrice) : Number(data.unitPrice),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: data.discountPercent > 0 || data.discountAmount > 0 ? "percentOff|" + data.discountPercent : "regular price",
        productBasePrice: Number(data.unitPrice) || "n/a",
        productCategory: sanitizeTextForAnalytics(data.category) || "n/a",
        productColor: sanitizeTextForAnalytics(data.color) || "n/a",
        productCoupondiscount: "n/a",
        productID: customerFacingSKUId || "n/a",
        productName: sanitizeTextForAnalytics(data.name) || "n/a",
        productPartnerBuyNow: false,
        productRoom: sanitizeTextForAnalytics(data.category) || "n/a",
        productSalePrice: Number(data.discountPrice) ? Number(data.discountPrice) : Number(data.unitPrice),
        productSaleable: (page === null || page === void 0 ? void 0 : (ref1 = page.productInfo) === null || ref1 === void 0 ? void 0 : ref1.pdpType) === "bundle" || (data === null || data === void 0 ? void 0 : data.isBundleParent) ? "true" : (ref2 = Number(data.productSaleable)) !== null && ref2 !== void 0 ? ref2 : "true",
        productStatus: data.availableQty >= 0 ? "in stock" : "out of stock",
        productSuperSku: data.superSku ? true : false,
        productTileName: sanitizeTextForAnalytics(data.name) || "n/a",
        quantity: data.quantity,
        initialQuantity: data.quantity,
        defaultImageName: data.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: data.pdpType,
        productFindingMethod: "n/a",
        productCollectionsName: sanitizeTextForAnalytics(data.productCollectionsName || data.category) || "n/a"
    };
};
const pushAnalyticsToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 29885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SH": function() { return /* binding */ callFavorite; },
/* harmony export */   "YS": function() { return /* binding */ handleProductSuggestion; },
/* harmony export */   "jL": function() { return /* binding */ callNotification; }
/* harmony export */ });
/* unused harmony exports addDatalayerForLocalStoreOrShowroom, isAnchor, isMatchingAnchorText, getAnchorUrl */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88751);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7737);
/* harmony import */ var _components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30525);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73350);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64757);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);







const callFavorite = function(e, data) {
    let addFavoriteCallBack = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{}, logger = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    const { isFavorite , favItem =[] , staticTexts: { removeItem ="" , removeItemError ="" , favSuccessMsg ="" , favErrorMsg =""  } = {} , ctProductId ="" , isAuth , toasterContent , sku ="" , ctData  } = data;
    e.preventDefault();
    if (isFavorite) {
        favItem === null || favItem === void 0 ? void 0 : favItem.map((fav)=>{
            var ref, ref1, ref2;
            if (fav.productId === ctProductId && ((ctData === null || ctData === void 0 ? void 0 : (ref = ctData.variants) === null || ref === void 0 ? void 0 : ref.find((vt)=>{
                return vt.sku === sku && (vt === null || vt === void 0 ? void 0 : vt.id) === (fav === null || fav === void 0 ? void 0 : fav.variantId);
            })) || (ctData === null || ctData === void 0 ? void 0 : (ref1 = ctData.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.id) === (fav === null || fav === void 0 ? void 0 : fav.variantId) && (ctData === null || ctData === void 0 ? void 0 : (ref2 = ctData.masterVariant) === null || ref2 === void 0 ? void 0 : ref2.sku) === sku) && isAuth) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__/* .removeItems */ .Er)([
                    fav.id
                ])).unwrap().then((res)=>{
                    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                        message: toasterContent.unfavoriteSuccessMessage || removeItem,
                        isVisible: true
                    }));
                    addFavoriteCallBack(res === null || res === void 0 ? void 0 : res.lineItems);
                }).catch((error)=>{
                    logger.error("Error removing favorite item", {
                        error,
                        favId: fav.id,
                        sku
                    });
                    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                        message: removeItemError,
                        isVisible: true
                    }));
                });
            }
        });
    } else {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__/* .addProduct */ .gK)(sku)).unwrap().then((res)=>{
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                message: toasterContent.successMessage || favSuccessMsg,
                isVisible: true
            }));
            addFavoriteCallBack(res === null || res === void 0 ? void 0 : res.lineItems);
        }).catch((error)=>{
            logger.error("Error adding favorite item", {
                error,
                sku
            });
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                message: favErrorMsg,
                isVisible: true
            }));
        });
    }
    window.keyFocusCallBack = e.target.id;
};
const addDatalayerForLocalStoreOrShowroom = (data)=>{
    const { localStoreOrShowroomRef , productAnalyticsData  } = data;
    if (localStoreOrShowroomRef.current) {
        const localStoreOrShowroomAnchorLink = localStoreOrShowroomRef.current.querySelector("a");
        if (localStoreOrShowroomAnchorLink) {
            localStoreOrShowroomAnchorLink.classList.add("gbh-data-layer");
            localStoreOrShowroomAnchorLink.setAttribute("data-gbh-data-layer", getAnalyticsData("local store or showroom", localStoreOrShowroomAnchorLink.getAttribute("href")));
            localStoreOrShowroomAnchorLink.setAttribute("data-gbh-data-layer-custom", productAnalyticsData.stringProductInfo);
        }
    }
};
const callNotification = (data)=>{
    const { email ="" , sku ="" , callBackNotify  } = data;
    if (email) {
        const body = {
            customer: {
                id: "",
                firstName: "",
                lastName: "",
                email: email
            },
            sku,
            pdpURL: window.location.href
        };
        _constants_api__WEBPACK_IMPORTED_MODULE_4__/* .apim.post */ .TH.post(_constants_routes__WEBPACK_IMPORTED_MODULE_5__/* .CATALOG_NOTIFY_ENDPOINT */ .lY, body).then((res)=>{
            if (res) {
                callBackNotify(true);
            }
        }).catch(()=>{
            callBackNotify(false);
        });
    }
};
const isAnchor = (element)=>{
    return element === null || element === void 0 ? void 0 : element.closest("a");
};
const isMatchingAnchorText = (anchor, text)=>{
    var ref;
    return (anchor === null || anchor === void 0 ? void 0 : (ref = anchor.textContent) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (text === null || text === void 0 ? void 0 : text.toLowerCase());
};
const getAnchorUrl = (anchor)=>{
    return anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute("href");
};
const handleProductSuggestion = (e, productInfo)=>{
    const anchor = isAnchor(e.target);
    if (!anchor) return;
    if (!isMatchingAnchorText(anchor, _constants_index__WEBPACK_IMPORTED_MODULE_6__.SHOP_TOILET_SEATS)) return;
    const anchorUrl = getAnchorUrl(anchor);
    (0,_components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .productSuggestionLinkAnalytics */ .I1)(_constants_index__WEBPACK_IMPORTED_MODULE_6__.SHOP_TOILET_SEATS, anchorUrl, productInfo);
};


/***/ }),

/***/ 30534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/ProductAccordion.view.js









const Accordion = (props)=>{
    const { isOpen =false , contentOverflow =false , trigger =false , handleOpen , handleClose , containerElementProps , isArrow =false , items , itemsOrder , id , titleKey , componentPosition , componentLinkType , accordionProperties: { expandedItems =[]  } = {}  } = props;
    const [isExpanded, setisExpanded] = (0,react.useState)(true);
    const [general, setGeneral] = (0,react.useState)(null);
    const accordiumObject = (0,react.useRef)(null);
    const pageType = window.eventPageType;
    const handleAccordion = ()=>{
        setisExpanded(true);
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(function() {
            let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const CollapsibleHeader = (param)=>{
        let { title , open =false  } = param;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("h2", {
            className: "cmp-accordion__header ".concat(open ? "cmp-accordion__header_accordion_open" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "cmp-accordion__button ".concat(open ? "cmp-accordion__button--expanded" : ""),
                onClick: handleAccordion,
                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(componentPosition ? componentPosition : "accordion", '",\n        "internalLinkZoneName":"n/a","internalLinkURL":"n/a","internalLinkName":"').concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentLinkType ? componentLinkType : "navigation", '",\n        "eventType":"accordion",\n        "eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '"}'),
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "heading",
                        "aria-level": "5",
                        className: "cmp-accordion__title",
                        children: title
                    }),
                    !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-2"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "down-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default.src */.Z.src,
                                    alt: "Arrow Down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "up-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: "Arrow Up"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    const CollapsibleInnerText = (param)=>{
        let { gridColumnClassName , faqText , title  } = param;
        const finalText = (0,helper/* sanitizeInnerHtml */.KD0)((0,helper/* getShortenedUrlwithGeneral */.vu1)(faqText, general));
        const addFaqSeoScript = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: itemsOrder.map((item, i)=>({
                    "@type": "Question",
                    name: items[item]["cq:panelTitle"],
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: items[item]["text"]
                    }
                }))
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "faq-script",
                    type: "application/ld+json",
                    children: JSON.stringify(addFaqSeoScript)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-accordian-title": title,
                    className: "cmp-accordion__panel".concat(isExpanded ? " cmp-accordion__panel--expanded" : " cmp-accordion__panel--hidden"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text ".concat(gridColumnClassName),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-text",
                            children: finalText
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: accordiumObject,
        className: "cmp-accordion",
        "data-placeholder-text": "false",
        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((item, i)=>{
            const title = items[item][titleKey];
            let gridColumnClassName = items[item]["appliedCssClassNames"];
            let faqText = items[item]["text"];
            if (!faqText) {
                faqText = "";
                const itemsOrderArr = items[item][":itemsOrder"];
                if (itemsOrderArr) {
                    itemsOrderArr.forEach((itemTx)=>{
                        faqText = "".concat(faqText).concat(items[item][":items"][itemTx]["text"]);
                        gridColumnClassName = "".concat(items[item][":items"][itemTx]["appliedCssClassNames"]);
                    });
                }
            }
            var ref;
            const isItemExpanded = (ref = expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems.includes(item)) !== null && ref !== void 0 ? ref : isOpen;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cmp-hook-accordion": "item",
                    className: "cmp-accordion__item",
                    id: "accordion-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()),
                    "data-cmp-data-layer": '{"accordion-'.concat(i, "-").concat((0,helper/* getRandom */.sZz)(), '":{"@type":"kohler-us/components/accordion/item","dc:title":"').concat(title, '"}}'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        open: isItemExpanded,
                        onTriggerOpening: handleOpen,
                        onTriggerClosing: handleClose,
                        containerElementProps: containerElementProps,
                        overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                        openedClassName: "collapsible--open",
                        tabIndex: "0",
                        triggerOpenedClassName: "collapsible__trigger--open",
                        trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title
                        }),
                        triggerWhenOpen: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title,
                            open: true
                        }),
                        transitionTime: 400,
                        easing: "ease-in-out",
                        triggerElementProps: {
                            id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                        },
                        contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleInnerText, {
                            gridColumnClassName: gridColumnClassName,
                            faqText: faqText,
                            title: title
                        })
                    })
                })
            }, "accordion-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
        })
    });
};
/* harmony default export */ var ProductAccordion_view = (Accordion);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx


const ProductAccordion = (props)=>{
    const { data: { accordionProperties ={} , componentLinkType =""  }  } = props;
    const { [":itemsOrder"]: itemsOrder , [":items"]: items , id  } = accordionProperties;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "accordion  ".concat(accordionProperties === null || accordionProperties === void 0 ? void 0 : accordionProperties.appliedCssClassNames, " productAccordionView"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion_view, {
            accordionProperties: accordionProperties,
            componentLinkType: componentLinkType,
            items: items,
            itemsOrder: itemsOrder,
            id: id,
            textKey: "text",
            titleKey: "cq:panelTitle"
        })
    });
};
/* harmony default export */ var v3_ProductAccordion = (ProductAccordion);


/***/ }),

/***/ 21328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getFormatedImages; },
/* harmony export */   "FP": function() { return /* binding */ getDefaultStateData; },
/* harmony export */   "VQ": function() { return /* binding */ getSelectedColor; },
/* harmony export */   "gI": function() { return /* binding */ showToaster; },
/* harmony export */   "ku": function() { return /* binding */ getFirstSkuColor; },
/* harmony export */   "xU": function() { return /* binding */ getPdpProps; }
/* harmony export */ });
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88751);



const getDefaultStateData = (pdpData)=>{
    return {
        isProductVariantClicked: false,
        clickedProductVariant: false,
        selectedSku: "",
        customerFacingSKU: "",
        productDetailData: pdpData ? pdpData : {},
        docId: "",
        fusionQueryId: "",
        masterSku: "",
        options: {},
        facetLabels: [],
        currOptions: {},
        selectMoreTooltipData: {},
        reqCartData: [],
        ctData: {},
        persona: "",
        toaster: {
            show: false,
            message: "",
            mobileOnly: false
        },
        reverseGeo: "",
        jsonFileUrl: "",
        zipCodeData: [],
        installationData: [],
        designServiceData: [],
        servicesData: {},
        installationDataFromProp: [],
        designServiceDataFromProp: [],
        availableStock: 0,
        promoTitle: null,
        promoDescription: false,
        enablePromo: false,
        viewLoader: pdpData ? true : false,
        findInstallerPath: "",
        loadShowEvent: false,
        installerArea: "",
        statesData: [],
        mboxes: [],
        imageClickCounter: 1,
        variantData: []
    };
};
const getFormatedImages = (data)=>{
    const { variantImageLabels , variantImageURLs , authorData  } = data;
    const images = [];
    if (authorData) {
        for(let i = 0; i < variantImageURLs.length; i++){
            var ref;
            const urlPaths = (ref = variantImageURLs[i].split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
            const assetId = urlPaths[urlPaths.length - 1];
            var _i, _i1;
            images.push({
                label: (_i = variantImageLabels[i]) !== null && _i !== void 0 ? _i : "",
                assetId,
                url: (_i1 = variantImageURLs[i]) !== null && _i1 !== void 0 ? _i1 : ""
            });
        }
    }
    return images;
};
const getPdpProps = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { state: { productDetailData ={} , selectedSku ="" , availableStock =0 , masterSku ="" , variantData =[] , ctData ={} , loadShowEvent , clickedProductVariant  } , customerSkus , selectedColor , isParts , currencySign , requiredItemstoInstall , colorsData , comparedProducts , favorites , superSku , cartLoaded , cart , pricesData , // locale,
    discountedPrices  } = data;
    const { title_s: title = "" , productName_s: productNames = "" , features_s: features , RegionBrandName_s: regionBrandNames = "" , ProductBrandName_s: productBrandNames = [] , ProductDescriptionProductShort_s: desc , ProductNarrativeDescription_s: narrativeDescription = "" , CustomerFacingBrand_s: customerBrandName = "" , productRegionAllVariantDiscontinued_b: discontinuedProduct = false , ProductProductRecommendedAccessories_ss: ProductRequiredAccessoriesGroupsList = [] , RegionOnBackOrder_s: backOrder = "No" , ProductOverallLengthInches_s: productOverallLength = 0 , ProductOverallWidthInches_s: productOverallWidth = 0 , ProductOverallHeightInches_s: productOverallHeight = 0 , ProductWebFeatures_ss: productWebFeatures = [] , ProductPriceSpiderIncluded_s: productPriceSpiderIncluded , ProductFreightPolicyType_s: freightPolicyType = "" , category1_s: category1s , ProductBrandNameDisplay_t: productBrandNameDisplayt , ctProductType_s: ctProductTypes , primaryBundleSKU_s: primaryBundleSKUs = ""  } = productDetailData;
    var ref1;
    const { RegionSpecialOrder_s: specialOrder = "No"  } = (ref1 = variantData.find((item)=>item.sku_s === selectedSku)) !== null && ref1 !== void 0 ? ref1 : {};
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const productName = isBundleProduct || isParts ? productNames : regionBrandNames;
    const name = productName ? productName : productNames;
    const productDisc = isBundleProduct ? title : desc;
    var ref2, _selectedSku;
    return {
        features,
        sku: selectedSku,
        customerFacingSKU: customerSkus[selectedSku],
        name,
        desc: productDisc,
        narrativeDescription,
        customerBrandName,
        currencySign,
        discontinuedProduct: discontinuedProduct,
        ProductRequiredAccessoriesGroupsList,
        stickyHeaderProps: {
            selectedSku,
            title: isParts ? productNames : isBundleProduct ? productNames : productBrandNames,
            description: isBundleProduct ? title : desc,
            itemStatus: "available",
            color: {
                label: selectedColor,
                url: (ref = colorsData.find((item)=>item.id === selectedSku)) === null || ref === void 0 ? void 0 : ref.colorUrl
            }
        },
        requiredItems: requiredItemstoInstall !== null && requiredItemstoInstall !== void 0 ? requiredItemstoInstall : [],
        productOnStock: availableStock,
        colorsData: colorsData,
        addToCartProps: {
            compareChecked: Boolean(comparedProducts.find((prod)=>masterSku === prod["masterSKU_s"])),
            backOrder,
            specialOrder
        },
        detailsProps: {
            length: productOverallLength,
            width: productOverallWidth,
            height: productOverallHeight,
            dimensionUnit: "in",
            detailsData: productWebFeatures
        },
        ProductPriceSpiderIncluded_s: productPriceSpiderIncluded === "true" ? true : false,
        isProjectPack: productDetailData["SKUIsProjectPack_s"] === "Yes",
        freightPolicyType,
        isFavorite: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(favorites) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.find((vl)=>{
            var ref;
            return vl.productId === ctData.id && ((ref = vl.variant) === null || ref === void 0 ? void 0 : ref.sku) === selectedSku;
        })) ? true : false,
        favItem: (ref2 = favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) !== null && ref2 !== void 0 ? ref2 : [],
        ctProductId: ctData.id,
        superSku,
        loadShowEvent: cartLoaded || loadShowEvent,
        cart,
        clickedProductVariant,
        selectedColor: selectedColor,
        businessUnitName: category1s || category1s,
        globalDiscount: Number((pricesData[selectedSku] - ((_selectedSku = discountedPrices[selectedSku]) !== null && _selectedSku !== void 0 ? _selectedSku : 0)).toFixed(2)),
        productSaleable: true,
        productPartnerBuyNow: false,
        productCollectionsName: productBrandNameDisplayt,
        productType: ctProductTypes
    };
};
const showToaster = (mssg)=>{
    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)({
        message: mssg,
        isVisible: true
    }));
    setTimeout(()=>_store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)({
            message: mssg,
            isVisible: false
        })), 3000);
};
const getFirstSkuColor = (data)=>{
    const colorList = [];
    const newData = data.filter((e)=>{
        if (!colorList.includes(e.label)) {
            colorList.push(e.label);
            return e;
        }
    });
    return newData.map((e)=>{
        const newData = data.filter((el)=>el.label === e.label).map((a)=>a.value);
        return {
            ...e,
            skus: newData
        };
    });
};
const getSelectedColor = (colorsData, sku)=>{
    var ref;
    const { label =""  } = (ref = colorsData.find((item)=>{
        const { skus =[] , id =""  } = item;
        if (id === sku || (skus === null || skus === void 0 ? void 0 : skus.includes(sku))) {
            return item;
        }
    })) !== null && ref !== void 0 ? ref : {};
    return label;
};


/***/ }),

/***/ 3155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ addDataLayerSuperSkuOptionSelected; },
/* harmony export */   "Sg": function() { return /* binding */ getBreadcrumbEventInfo; },
/* harmony export */   "f8": function() { return /* binding */ addBuyBtnAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "zE": function() { return /* binding */ addShareBtnAnalytics; }
/* harmony export */ });
/* unused harmony exports dataLayerAddToCart, addDataLayerForConfigurationExapandState, getWidgetEventInfo */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);



const getEventInfo = function(type) {
    let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, toolTipText = arguments.length > 2 ? arguments[2] : void 0, accordianState = arguments.length > 3 ? arguments[3] : void 0;
    var ref, ref1, ref2;
    let eventAction;
    let eventName;
    let internalLinkType;
    let internalLinkName;
    if (type === "list info mouseover") {
        internalLinkType = "pdp:mouseover";
        internalLinkName = "list";
    } else if (type === "print") {
        internalLinkType = "pdp:print";
    } else if (type === "color selection") {
        internalLinkType = "pdp:color selection";
        internalLinkName = type;
    } else if (type === "select configurations") {
        internalLinkName = accordianState;
    } else if (type.includes("mouseover") && toolTipText) {
        internalLinkName = toolTipText === null || toolTipText === void 0 ? void 0 : toolTipText.toLowerCase();
        const title = type.replace("mouseover", "");
        internalLinkType = "pdp:mouseover:".concat(title);
    } else if (type === "remove") {
        internalLinkType = "pdp:".concat(type);
    } else if (type === "read more") {
        internalLinkType = "pdp:".concat(type);
    } else if (type === "tooltip") {
        internalLinkName = "info tooltip";
        internalLinkType = eventName = eventAction = "pdp:info tooltip";
    } else if (type === _constants__WEBPACK_IMPORTED_MODULE_2__.INSTALL_ITEMS || type === _constants__WEBPACK_IMPORTED_MODULE_2__.INSTALL_ITEMS_EDIT) {
        internalLinkType = eventName = eventAction = "pdp:".concat(type);
    }
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
    const { productInfo  } = page;
    let internalLinkPositionName = "pdp";
    if ((pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp" && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(productInfo)) {
        if (productInfo.pdpType === "bundle") {
            internalLinkPositionName = "pdp:bundle";
        }
    }
    const eventInfo = {
        eventAction: eventAction || "pdp:product details:" + type + (accordianState ? ":".concat(accordianState) : ""),
        eventName: eventName || "pdp:product details:" + type + (accordianState ? ":".concat(accordianState) : ""),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: internalLinkPositionName,
        internalLinkType: internalLinkType || "pdp:navigation",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const dataLayerAddToCart = (param, serviceName)=>{
    let { res , productInfo  } = param;
    var ref;
    const { status , message ="n/a"  } = res;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: "pdp:cross-sell:kohler professional services:add to cart",
        eventName: "pdp:cross-sell:kohler professional services:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(serviceName === null || serviceName === void 0 ? void 0 : serviceName.toLowerCase()),
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.id
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addDataLayerForConfigurationExapandState = (title, accordianState, productInfo)=>{
    const eventInfo = getEventInfo("select configurations", true, null, accordianState);
    eventInfo.internalLinkType = "pdp:".concat(title);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const getBreadcrumbEventInfo = function() {
    let internalLinkName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    return {
        eventAction: "pdp:breadcrumb",
        eventName: "pdp:breadcrumb",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(internalLinkName),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:breadcrumb",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: link ? (((ref = String(link)) === null || ref === void 0 ? void 0 : ref.indexOf("http")) === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
};
const getWidgetEventInfo = (retailer, retailBtnName)=>({
        clickInternalLinks: "false",
        eventAction: "pdp:product details:".concat(retailBtnName),
        eventMsg: "n/a",
        eventName: "pdp:product details:".concat(retailBtnName),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(retailer, "-").concat(retailBtnName),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(retailBtnName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:product details"
    });
const updatePrices = (obj, keys, price)=>{
    if (obj) {
        keys.forEach((key)=>{
            if (key in obj) {
                obj[key] = price;
            }
        });
    }
};
const addBuyBtnAnalytics = (e, retailer, productInfo, price)=>{
    var ref;
    e.preventDefault();
    e.stopPropagation();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const retailBtnName = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.innerText;
    const eventInfo = getWidgetEventInfo(retailer, retailBtnName.toLowerCase());
    const keys = [
        "productSalePrice",
        "productBasePrice",
        "globalPromotionPrice"
    ];
    updatePrices(page.productInfo, keys, price);
    updatePrices(productInfo, keys, price);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};
const addDataLayerSuperSkuOptionSelected = (action, field, productInfo)=>{
    const url = new URL(window.location.href);
    const formatString = (str)=>{
        str = str.toLowerCase();
        str = str.replace(/_/g, " ");
        return str;
    };
    const formatField = formatString(field);
    const formatAction = formatString(action);
    const eventInfo = {
        eventAction: "pdp:".concat(formatField, ":").concat(formatAction),
        eventName: "pdp:".concat(formatField, ":").concat(formatAction),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(formatAction, ":applied"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:product options:".concat(formatField),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "".concat(url),
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addShareBtnAnalytics = (stringProductInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:product details:share",
        eventMsg: "n/a",
        eventName: "pdp:product details:share",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "share",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:share",
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:product details"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo =""  } = JSON.parse(stringProductInfo);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 14887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": function() { return /* binding */ checkUserZipCode; },
/* harmony export */   "H3": function() { return /* binding */ getInitialSku; },
/* harmony export */   "Jo": function() { return /* binding */ getColorFinishData; },
/* harmony export */   "O1": function() { return /* binding */ getZipCodeJsonFile; },
/* harmony export */   "S8": function() { return /* binding */ getDataSheetUrl; },
/* harmony export */   "WI": function() { return /* binding */ getColorDataObject; },
/* harmony export */   "_V": function() { return /* binding */ findVariantOptionBySku; },
/* harmony export */   "i8": function() { return /* binding */ initPriceSpider; },
/* harmony export */   "lX": function() { return /* binding */ getTeaserFragments; },
/* harmony export */   "lk": function() { return /* binding */ getShippingLocations; },
/* harmony export */   "t0": function() { return /* binding */ resolveCollapsedPdpColorSelection; },
/* harmony export */   "tz": function() { return /* binding */ checkProductCategory; },
/* harmony export */   "yS": function() { return /* binding */ getRequireItems; }
/* harmony export */ });
/* unused harmony export getTeaserDetails */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20558);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88032);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44561);
/* harmony import */ var _components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3155);








const getInitialSku = (data)=>{
    var ref;
    const { productData , setSkuVariantCb , selectedColor  } = data;
    let colors = [];
    if (productData["Color.SKU.Details_ss"].length) {
        colors = productData["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                color: d.at(0),
                sku: d[2],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
            };
        });
    }
    const availableSkus = colors.filter((color)=>!color.discontinued);
    const discontinuedAvailableSkus = colors.filter((color)=>color.discontinued);
    let initSku = "";
    if ((ref = availableSkus[0]) === null || ref === void 0 ? void 0 : ref.sku) {
        var ref1;
        var ref2;
        const { sku: selectedColorSku = ""  } = (ref2 = availableSkus.find((el)=>el.color === selectedColor)) !== null && ref2 !== void 0 ? ref2 : {};
        var ref3;
        initSku = selectedColorSku ? selectedColorSku : (ref3 = (ref1 = availableSkus[0]) === null || ref1 === void 0 ? void 0 : ref1.sku) !== null && ref3 !== void 0 ? ref3 : productData["masterSKU_s"];
    } else {
        var ref4;
        var ref5;
        initSku = ((ref5 = (ref4 = discontinuedAvailableSkus[0]) === null || ref4 === void 0 ? void 0 : ref4.sku) !== null && ref5 !== void 0 ? ref5 : productData["variantList.sku_ss"]) ? productData["variantList.sku_ss"][0] : "";
    }
    setSkuVariantCb && setSkuVariantCb(initSku);
    return initSku;
};
const checkProductCategory = (productCategory, category)=>{
    if (productCategory === category || productCategory === "") {
        return true;
    }
    return false;
};
const getZipCodeJsonFile = function(jsonFileUrl, getZipCodeJsonFileCb) {
    let logger = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{};
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(jsonFileUrl)) {
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: jsonFileUrl
            }
        }).then((response)=>{
            if (response && response.data) {
                getZipCodeJsonFileCb && getZipCodeJsonFileCb(response.data);
            } else {
                logger.error("Failed to fetch zip code data from provided JSON file URL", {
                    url: jsonFileUrl
                });
            }
        }).catch((error)=>{
            logger.error("Error fetching zip code JSON file", {
                error,
                url: jsonFileUrl
            });
        });
    } else {
        logger.warn("Zip code JSON file URL is missing or not provided. Cannot fetch data.");
    }
};
const getShippingLocations = (statesData, states)=>{
    let resultTxt = "";
    if (statesData && (states === null || states === void 0 ? void 0 : states.length) > 0) {
        states.map((state, i)=>{
            const stateObj = statesData.find((st)=>{
                var ref;
                return state === ((ref = st.value) === null || ref === void 0 ? void 0 : ref.replace(/:US/g, ""));
            });
            if (stateObj === null || stateObj === void 0 ? void 0 : stateObj.text) {
                resultTxt = resultTxt + stateObj.text;
                if (i === states.length - 2) resultTxt += " and ";
                else if (i !== states.length - 1) resultTxt += ", ";
            }
        });
    }
    return resultTxt;
};
const getRequireItems = (items, discountedPrice, price, setInstallReqCb, setSubTotalCb, setPriceListCb, addItemsToCartCb)=>{
    setInstallReqCb(items);
    const cartItemProduct = [];
    const priceListItems = [];
    let requiredItemsPrice = 0;
    let priceLists = 0;
    let baseTotal = 0;
    let subTotalItem = 0;
    if (items.length > 0) {
        items && items.map((list)=>{
            const product = {};
            product.sku = list.skuid;
            product.brand = list.brandName;
            if (list.backorder) {
                product.quantity = 1;
                product.backorder = true;
                cartItemProduct.push(product);
            } else {
                var ref;
                const checkQuantity = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list === null || list === void 0 ? void 0 : (ref = list.colorsData) === null || ref === void 0 ? void 0 : ref.find((requiredItem)=>requiredItem.id === list.skuid), "isOutOfStock", false);
                product.quantity = !checkQuantity ? 1 : 0;
                if (!checkQuantity) {
                    cartItemProduct.push(product);
                }
            }
            if (list === null || list === void 0 ? void 0 : list.priceData) {
                var ref1, ref2, ref3;
                priceLists = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list === null || list === void 0 ? void 0 : (ref1 = list.priceData) === null || ref1 === void 0 ? void 0 : ref1.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) > 0 ? lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list === null || list === void 0 ? void 0 : (ref2 = list.priceData) === null || ref2 === void 0 ? void 0 : ref2.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) : lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list === null || list === void 0 ? void 0 : (ref3 = list.priceData) === null || ref3 === void 0 ? void 0 : ref3.find((requiredList)=>requiredList.id === list.skuid), "price", 0);
                priceListItems.push(priceLists);
                if (priceListItems.length >= 0) {
                    requiredItemsPrice = priceListItems.reduce((acc, item)=>{
                        return parseFloat(acc) + parseFloat(item);
                    }, 0);
                } else {
                    requiredItemsPrice = priceListItems[0];
                }
                baseTotal = discountedPrice > 0 ? discountedPrice : price;
                subTotalItem = baseTotal + requiredItemsPrice;
                setSubTotalCb(subTotalItem);
                setPriceListCb(requiredItemsPrice);
            }
        });
        addItemsToCartCb(cartItemProduct, false);
    } else {
        addItemsToCartCb([], false);
    }
};
const getTeaserFragments = (pageData, pdpData)=>{
    const { masterSKU_s: masterSku = "" , ProductLocalCategory_s: productLocalCategory = "" , BundleID_s: bundleSku = "" , BundleLocalCategory_s: bundleLocalCategory = ""  } = pdpData;
    const teaserFragmentOrder = getFragmentsOrder(pageData);
    const customerFacingSKU = masterSku || bundleSku;
    const category = productLocalCategory || bundleLocalCategory;
    const pdpXFPaths = getFragmentPaths(pageData);
    if (teaserFragmentOrder === null || teaserFragmentOrder === void 0 ? void 0 : teaserFragmentOrder.length) {
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsTeaserLoaded */ .ZR)(true));
        const params = {
            skuId: customerFacingSKU,
            category: category
        };
        if (pdpXFPaths) params.xfPaths = pdpXFPaths;
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.PDP_TEASER_DETAILS,
            params
        }).then((response)=>{
            const { data  } = response;
            if (data && teaserFragmentOrder.length) getTeaserDetails(data, teaserFragmentOrder);
            else console.error("PDP Teaser Fragments Order Not Found..!");
        }).catch((error)=>{
            console.error("PDP Teaser Fragments Fetching Error..!");
        });
    }
};
const getFragmentsOrder = (pageData)=>{
    const itemOrder = [];
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(teaserFragments[0], "configuredXfPathModels", "");
        list.map((item)=>{
            const itemArray = item && (item === null || item === void 0 ? void 0 : item.path) && item.path.split("/");
            itemOrder.push(itemArray[itemArray.length - 1]);
        });
        return itemOrder;
    }
};
const getFragmentPaths = (pageData)=>{
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const fragmentPaths = teaserFragments.reduce((paths, fragment)=>{
            const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(fragment, "configuredXfPathModels", "");
            list.forEach((item)=>{
                paths.push(item === null || item === void 0 ? void 0 : item.path);
            });
            return paths;
        }, []);
        return fragmentPaths.join(",");
    }
    return "";
};
const getTeaserDetails = (data, teaserFragmentOrder)=>{
    const teaserDataPromises = [];
    teaserFragmentOrder.forEach(async (item)=>{
        if (data[item]) {
            const teaserDeta = data[item].map(async (url)=>{
                const resData = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                    url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(url, ".model.json")
                    }
                });
                return resData.data;
            });
            teaserDataPromises.push(...teaserDeta);
        }
    });
    Promise.all(teaserDataPromises).then((response)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)(response));
    }).catch((error)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)([]));
        console.error("PDP Teaser Fragments Data Fetching Error..!");
    });
};
const initPriceSpider = (productInfo)=>{
    const waitTimeForPsWidgetElementsToLoad = 500;
    let psWidgetNode = document.getElementsByClassName("ps-widget")[0];
    // Here reason to use mutation observer instead of react ref is bcoz
    // this ps widget elements are getting fluctuated
    const psWidgetObserver = new MutationObserver(()=>{
        // fired when a mutation occurs
        psWidgetNode.querySelectorAll("div[data-retailer]").forEach((retailerDiv)=>{
            var ref, ref1;
            const btn = retailerDiv.querySelector(".ps-online-buy-button");
            const retailer = (ref = retailerDiv.getAttribute("data-retailer")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            const priceText = ((ref1 = retailerDiv.querySelector(".ps-price")) === null || ref1 === void 0 ? void 0 : ref1.textContent) || "n/a";
            const price = parseFloat((0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .getSanitizedFloatingNumber */ .zj)(priceText)) || "n/a";
            if (btn.getAttribute("attachedEvent") !== "true") {
                btn.addEventListener("click", (e)=>{
                    (0,_components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__/* .addBuyBtnAnalytics */ .f8)(e, retailer, productInfo, price);
                }, false);
                btn.setAttribute("attachedEvent", "true");
            }
        });
    });
    let psWidgetObserverTimeout;
    const addObserverIfDesiredNodeAvailable = ()=>{
        psWidgetNode = document.getElementsByClassName("ps-widget")[0];
        if (!psWidgetNode) {
            psWidgetObserverTimeout = setTimeout(addObserverIfDesiredNodeAvailable, waitTimeForPsWidgetElementsToLoad);
            return;
        }
        if (psWidgetObserverTimeout) {
            clearTimeout(psWidgetObserverTimeout);
            psWidgetObserverTimeout = undefined;
        }
        const config = {
            subtree: true,
            childList: true
        };
        psWidgetObserver.observe(psWidgetNode, config);
    };
    addObserverIfDesiredNodeAvailable();
};
const getDataSheetUrl = function() {
    let productServices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], currentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    const currentSkuMasterVariant = (ref = productServices.find((product)=>{
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku) === currentSku;
    })) !== null && ref !== void 0 ? ref : {};
    const { masterVariant: { attributes =[]  } = {}  } = currentSkuMasterVariant;
    var ref1;
    const { value: productResourceData = []  } = (ref1 = attributes.find((e)=>e.name === "ProductResource")) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    const dataSheet = (ref2 = productResourceData.find((e)=>{
        return e.find((el)=>el.value === "DataSheet");
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    const { value: resourceFullWebURL = ""  } = (ref3 = dataSheet.find((e)=>e.name === "ResourceFullWebURL")) !== null && ref3 !== void 0 ? ref3 : {};
    return resourceFullWebURL;
};
const getColorDataObject = function() {
    let color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const d = color.split("|");
    return {
        name: d.at(0),
        swatch: d.at(1),
        sku: d.at(2),
        isStock: d.at(3),
        discontinued: !(d.at(4) === "false" || Date.parse(d.at(4)) > Date.now()),
        customerSku: d.at(5),
        slug: d.at(6)
    };
};
const getVariantOptionValue = function() {
    let option = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, field = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const value = option === null || option === void 0 ? void 0 : option[field];
    if (Array.isArray(value)) {
        var ref;
        return (ref = value[0]) !== null && ref !== void 0 ? ref : "";
    }
    return value !== null && value !== void 0 ? value : "";
};
const findVariantOptionBySku = function() {
    let variantOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    return (ref = variantOptions.find((option)=>{
        const variantList = (option === null || option === void 0 ? void 0 : option["variantList.sku_ss"]) || [];
        return (option === null || option === void 0 ? void 0 : option.sku_s) === sku || variantList.includes(sku);
    })) !== null && ref !== void 0 ? ref : {};
};
const resolveCollapsedPdpColorSelection = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { variantData ={} , variantOptions =[] , currOptions ={} , options ={}  } = data;
    const { value: fallbackSku = "" , slug: fallbackSlug = "" , skus =[]  } = variantData;
    const candidateSkus = [
        ...new Set([
            fallbackSku,
            ...skus
        ].filter(Boolean))
    ];
    const selectedOptionFields = Object.keys(options).filter((field)=>{
        return getVariantOptionValue(currOptions, field) !== "";
    });
    const matchingSku = selectedOptionFields.length > 0 ? candidateSkus.find((candidateSku)=>{
        const option = findVariantOptionBySku(variantOptions, candidateSku);
        return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(option) && selectedOptionFields.every((field)=>{
            return getVariantOptionValue(option, field) === getVariantOptionValue(currOptions, field);
        });
    }) : "";
    const resolvedSku = matchingSku || candidateSkus[0] || fallbackSku;
    const resolvedOption = findVariantOptionBySku(variantOptions, resolvedSku);
    return {
        sku: resolvedSku,
        slug: (resolvedOption === null || resolvedOption === void 0 ? void 0 : resolvedOption.slug_s) || fallbackSlug,
        currOptions: resolvedOption
    };
};
const getColorFinishData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data["Color.SKU.Details_ss"] || [];
};
const checkUserZipCode = (data)=>{
    const { userZipCode , state , callBack , productServices  } = data;
    let availableSkuIdsForService = [];
    const { zipCodeData =[]  } = state;
    for (const zipKey of zipCodeData){
        const key = Object.keys(zipKey)[0];
        for (const zipInnerKey of zipKey[key]){
            const zipcode = Object.keys(zipInnerKey)[0];
            if (zipcode === userZipCode) {
                if (productServices.length > 0 && zipInnerKey[zipcode].includes(productServices[0])) {
                    availableSkuIdsForService = zipInnerKey[zipcode];
                }
                break;
            }
        }
        if (availableSkuIdsForService.length) break;
    }
    const isNearest = availableSkuIdsForService.length;
    callBack && callBack(isNearest);
};


/***/ }),

/***/ 65258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ closeSaveToListAnalytics; },
/* harmony export */   "NG": function() { return /* binding */ closeCreateNewListSuccessAnalytics; },
/* harmony export */   "OR": function() { return /* binding */ dataLayerSavetolistGuest; },
/* harmony export */   "Y$": function() { return /* binding */ dataLayerMyListSaveListButton; },
/* harmony export */   "Yt": function() { return /* binding */ dataLayerCreateNewSaveListButton; },
/* harmony export */   "iB": function() { return /* binding */ closeCreateNewListAnalytics; },
/* harmony export */   "jX": function() { return /* binding */ closeSelectMyListAnalytics; },
/* harmony export */   "p5": function() { return /* binding */ dataLayerCreateNewListButton; },
/* harmony export */   "y3": function() { return /* binding */ dataLayerHeartClickSaveListButton; }
/* harmony export */ });
/* harmony import */ var _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4943);

const pushToAdobeDataLayer = (eventInfo, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const pageType = getPageType();
    const updatedPageEvent = {
        ...page,
        pageInfo: {
            ...page.pageInfo || {},
            contentType: pageType
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...productInfo ? {
            productInfo
        } : {},
        page: updatedPageEvent
    });
};
const getPageType = ()=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    var ref1;
    const pageType = (ref1 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType) !== null && ref1 !== void 0 ? ref1 : "pdp";
    return pageType;
};
const dataLayerSavetolistGuest = (productInfo)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST.toLowerCase */ .V7.toLowerCase()),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST.toLowerCase */ .V7.toLowerCase()),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST.toLowerCase */ .IP.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST.toLowerCase */ .IP.toLowerCase())
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerHeartClickSaveListButton = (productInfo, headerTitle, eventType)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        eventStatus: "n/a",
        eventType: eventType,
        internalLinkName: "".concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase())
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerCreateNewListButton = (productInfo, createNewListTitle)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase()),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase()),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase()),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerMyListSaveListButton = function(productInfo) {
    let selectedData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", successDesc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", successTitle = arguments.length > 3 ? arguments[3] : void 0;
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SELECT_MY_LIST */ .oF, ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventMsg: "".concat(successDesc),
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SELECT_MY_LIST */ .oF, ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventStatus: "".concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(selectedData),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(selectedData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerCreateNewSaveListButton = function(productInfo) {
    let createListData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", successDesc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", createNewListTitle = arguments.length > 3 ? arguments[3] : void 0, successTitle = arguments.length > 4 ? arguments[4] : void 0;
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventMsg: "".concat(successDesc),
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventStatus: "".concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(createListData),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(createListData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeSaveToListAnalytics = (productInfo)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeCreateNewListAnalytics = (productInfo, createNewListTitle)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeCreateNewListSuccessAnalytics = function(productInfo) {
    let createListData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", createNewListTitle = arguments.length > 2 ? arguments[2] : void 0, successTitle = arguments.length > 3 ? arguments[3] : void 0;
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(createListData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeSelectMyListAnalytics = function(productInfo) {
    let selectedData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", successTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const pageType = getPageType();
    const eventPath = "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SELECT_MY_LIST */ .oF);
    const eventData = successTitle ? "".concat(eventPath, ":").concat(successTitle, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$) : "".concat(eventPath, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: eventData,
        eventMsg: "n/a",
        eventName: eventData,
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(selectedData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};


/***/ }),

/***/ 4943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F$": function() { return /* binding */ CLOSE; },
/* harmony export */   "IP": function() { return /* binding */ SAVE_TO_LIST; },
/* harmony export */   "Ik": function() { return /* binding */ WISHLIST_DELETE; },
/* harmony export */   "O1": function() { return /* binding */ WISHLIST_SAVE; },
/* harmony export */   "OH": function() { return /* binding */ PRODUCT_DETAILS; },
/* harmony export */   "V7": function() { return /* binding */ SAVE_TO_LIST_GUEST; },
/* harmony export */   "oF": function() { return /* binding */ SELECT_MY_LIST; }
/* harmony export */ });
const PRODUCT_DETAILS = "product details";
const WISHLIST_SAVE = "wishlist save";
const WISHLIST_DELETE = "wishlist delete";
const SELECT_MY_LIST = "select my list";
const CLOSE = "close";
const SAVE_TO_LIST = "save to list";
const SAVE_TO_LIST_GUEST = "save to list guest";


/***/ }),

/***/ 4165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_SaveToList_localization__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34428);
/* harmony import */ var _components_Shared_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70914);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49139);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7737);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55760);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64757);
/* harmony import */ var _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55619);
/* harmony import */ var _components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89986);
/* harmony import */ var _components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65258);
















const ListForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 3073).then(__webpack_require__.bind(__webpack_require__, 43073)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43073)
            ]
    }
});
const CreateForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 3042).then(__webpack_require__.bind(__webpack_require__, 43042)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43042)
            ]
    }
});
const SaveToList = (props)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const staticText = (0,_components_SaveToList_localization__WEBPACK_IMPORTED_MODULE_13__/* .getTranslations */ .F)(t);
    const { globalConfig: { internationalization: { locale: newLocale = "" , language =""  } = {}  } = {}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .selectGenericState */ .Px);
    const { productSku ="" , showListSaveAndCreate =false , createList =false , listSaveAndCreateClose =()=>{} , handleSuccessCallBack =()=>{} , listData ={} , editListText ="" , selectedListDetails ={} , getProductInfo ={} , moveToList =false , moveOrDeleteFromListName ="" , currentList ={} , productData =[] , selectedItems =[] , productQtyObj ={} , productInfoPdp ={} , plpAddToListAnalytics =()=>{} , fromPLP =false , fromShareListPage =false , handleShareListAddToListAnalytics =()=>{}  } = props || {};
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [saveBtnStatus, setSaveBtnStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [createNewList, setCreateNewList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(createList);
    const [headerText, setHeaderText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [decText, setDecText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [userLists, setUserLists] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [listNameValidationList, setListNameValidationList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [nameValidationErrorMsg, setNameValidationErrorMsg] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [showNameValidationError, setShowNameValidationError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [newListName, setNewListName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [projectName, setProjectName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [dec, setDec] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedList, setSelectedList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [createListData, setCreateListData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [selectedListData, setSelectedListData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [createListAddItemsSuccess, setCreateListAddItemsSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [count, setCount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [listNamesLoader, setListNamesLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const productInfoPlp = getProductInfo !== null && getProductInfo !== void 0 ? getProductInfo : "{}";
    const productInfo = Object.keys(productInfoPlp).length !== 0 ? productInfoPlp : productInfoPdp;
    const [moveToListResponse, setMoveToListResponse] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const getUserCreatedListData = ()=>{
        dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__/* .getMyAccountLists */ .jP)()).unwrap().then((response)=>{
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            const data = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getUserCreatedLists */ .$1Y)(response, locale, moveOrDeleteFromListName);
            setUserLists(data === null || data === void 0 ? void 0 : data.lists);
            moveOrDeleteFromListName ? setListNameValidationList([
                ...(data === null || data === void 0 ? void 0 : data.listNames) || [],
                moveOrDeleteFromListName
            ]) : setListNameValidationList(data === null || data === void 0 ? void 0 : data.listNames);
            setListNamesLoader(false);
        }).catch((error)=>{});
    };
    const listNameValidation = (e)=>{
        var ref;
        let value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        value = (value === null || value === void 0 ? void 0 : value.length) < 37 ? value : value.slice(0, 36);
        setNewListName(value);
        setNameValidationErrorMsg(staticText.createNameError);
        if ((value === null || value === void 0 ? void 0 : value.trim().length) < 3 || (value === null || value === void 0 ? void 0 : value.trim().length) > 36 || !_constants_regex__WEBPACK_IMPORTED_MODULE_7__/* .SAVE_TO_LIST_NAME_FIELD_REGEX.test */ .cH.test(value)) {
            setNameValidationErrorMsg(staticText.createNameError);
            setShowNameValidationError(true);
        } else if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getIsNameDuplicate */ .Cxt)(value.trim(), listNameValidationList)) {
            setNameValidationErrorMsg(staticText.createSameNameError);
            setShowNameValidationError(true);
        } else if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getIsSystemDefinedName */ .Qss)(value.trim())) {
            setNameValidationErrorMsg(staticText.createSystemNameError);
            setShowNameValidationError(true);
        } else {
            setShowNameValidationError(false);
        }
    };
    const projectNameValidation = (e)=>{
        var ref;
        const value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        (value === null || value === void 0 ? void 0 : value.length) < 37 ? setProjectName(value) : setProjectName(value.slice(0, 36));
    };
    const handleSelectedList = (list)=>{
        setSelectedList(list === null || list === void 0 ? void 0 : list.id);
        setSelectedListData(list);
    };
    const closeModalHandle = ()=>{
        if (saveBtnStatus && !createNewList) {
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeSaveToListAnalytics */ .$b)(productInfo);
        }
        if (!saveBtnStatus && !createNewList) {
            const selectedData = selectedListData === null || selectedListData === void 0 ? void 0 : selectedListData.name;
            const successTitle = createListAddItemsSuccess ? staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle : null;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeSelectMyListAnalytics */ .jX)(productInfo, selectedData, successTitle);
        }
        if (saveBtnStatus && createNewList) {
            const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeCreateNewListAnalytics */ .iB)(productInfo, createNewListTitle);
        }
        if (createListAddItemsSuccess && !saveBtnStatus && createNewList) {
            const createListData = newListName;
            const createNewListTitle1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
            const successTitle1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeCreateNewListSuccessAnalytics */ .NG)(productInfo, createListData, createNewListTitle1, successTitle1);
        }
        if (moveToList && createListAddItemsSuccess) handleSuccessCallBack(moveToListResponse);
        listSaveAndCreateClose();
    };
    const handleCreateNewList = ()=>{
        const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
        (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .dataLayerCreateNewListButton */ .p5)(productInfo, createNewListTitle);
        setSelectedList("");
        setCreateNewList(true);
        setSaveBtnStatus(true);
    };
    const handleDec = (e)=>{
        const { value  } = e.target;
        setCount(value === null || value === void 0 ? void 0 : value.length);
        setDec(value);
    };
    const handleMoveItemsFromList = async (list, listInfo)=>{
        dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__/* .moveItemsFromList */ .s$)({
            list: list,
            listData: listInfo,
            currentList,
            productData,
            selectedItems,
            productQtyObj
        })).unwrap().then((response)=>{
            var ref, ref1, ref2;
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            setCreateListData({
                name: response === null || response === void 0 ? void 0 : (ref = response.addResponse) === null || ref === void 0 ? void 0 : ref.name[locale],
                version: response === null || response === void 0 ? void 0 : (ref1 = response.addResponse) === null || ref1 === void 0 ? void 0 : ref1.version,
                id: response === null || response === void 0 ? void 0 : (ref2 = response.addResponse) === null || ref2 === void 0 ? void 0 : ref2.id
            });
            setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToListSuccessDec);
            setCreateListAddItemsSuccess(true);
            setSaveBtnStatus(false);
            setMoveToListResponse(response);
        }).catch((error)=>{});
    };
    const handleCreateListAndAddProductsToIt = async ()=>{
        if (createListAddItemsSuccess) {
            if (moveToList) handleSuccessCallBack(moveToListResponse);
            listSaveAndCreateClose();
            return;
        }
        setSaveBtnStatus(true);
        const listInfo = {};
        const list = {};
        if (createNewList && !editListText) {
            const createListData = newListName;
            const successDesc = staticText === null || staticText === void 0 ? void 0 : staticText.saveEventMsgCreateList;
            const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
            const successTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle;
            listInfo["name"] = newListName === null || newListName === void 0 ? void 0 : newListName.trim();
            listInfo["project"] = projectName;
            listInfo["description"] = dec;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .dataLayerCreateNewSaveListButton */ .Yt)(productInfo, createListData, successDesc, createNewListTitle, successTitle);
        } else {
            var ref, ref1;
            const selectedData = selectedListData.name;
            const successDesc1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveEventMsgMyList;
            const successTitle1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle;
            var ref2;
            list["id"] = (ref2 = selectedListData === null || selectedListData === void 0 ? void 0 : selectedListData.id) !== null && ref2 !== void 0 ? ref2 : (ref = selectedListDetails[0]) === null || ref === void 0 ? void 0 : ref.id;
            var ref3;
            list["version"] = (ref3 = selectedListData === null || selectedListData === void 0 ? void 0 : selectedListData.version) !== null && ref3 !== void 0 ? ref3 : (ref1 = selectedListDetails[0]) === null || ref1 === void 0 ? void 0 : ref1.version;
            listInfo["name"] = newListName === null || newListName === void 0 ? void 0 : newListName.trim();
            listInfo["project"] = projectName;
            listInfo["description"] = dec;
            if (fromShareListPage) {
                handleShareListAddToListAnalytics();
            } else if (!fromPLP) {
                (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .dataLayerMyListSaveListButton */ .Y$)(productInfo, selectedData, successDesc1, successTitle1);
            } else {
                plpAddToListAnalytics();
            }
        }
        if (moveToList) {
            handleMoveItemsFromList(list, listInfo);
            return;
        }
        editListText ? dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__/* .editList */ .Du)({
            list: list,
            listData: listInfo
        })).unwrap().then(async (response)=>{
            setSaveBtnStatus(false);
            handleSuccessCallBack(response);
        }).catch((errror)=>{}) : dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_8__/* .addProductToList */ .XV)({
            sku: productSku,
            list: list,
            listData: listInfo,
            createList
        })).unwrap().then(async (response)=>{
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            setCreateListData({
                name: response === null || response === void 0 ? void 0 : response.name[locale],
                version: response === null || response === void 0 ? void 0 : response.version,
                id: response === null || response === void 0 ? void 0 : response.id
            });
            setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionDec);
            setCreateListAddItemsSuccess(true);
            setSaveBtnStatus(false);
            handleSuccessCallBack();
            createList ? handleSuccessCallBack(response) : handleSuccessCallBack();
        }).catch((errror)=>{});
    };
    const handleListNameClick = ()=>{
        router.replace({
            pathname: "/".concat(language).concat(_constants_routes__WEBPACK_IMPORTED_MODULE_11__/* .MY_LISTS_PAGE_PATH */ .PN),
            query: {
                listId: createListData === null || createListData === void 0 ? void 0 : createListData.id
            }
        }).then(()=>{
            router.reload();
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getUserCreatedListData();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (moveToList) {
            setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToList);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToList);
        }
    }, [
        moveToList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (((ref = Object.keys(listData)) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            setProjectName(listData === null || listData === void 0 ? void 0 : listData.project);
            setNewListName(listData === null || listData === void 0 ? void 0 : listData.name);
            setDec(listData === null || listData === void 0 ? void 0 : listData.description);
            setHeaderText(editListText);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateDec);
            handleSelectedList(selectedList);
        }
    }, [
        listData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.body.style.overflow = showListSaveAndCreate ? "hidden" : "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        showListSaveAndCreate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (createNewList && !showNameValidationError || !createNewList && selectedList) {
            setSaveBtnStatus(false);
        } else {
            setSaveBtnStatus(true);
        }
    }, [
        newListName,
        selectedList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!editListText) {
            if (createNewList) {
                setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateHeader);
                setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateDec);
            } else if (moveToList) {
                setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToList);
                setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToListDec);
            } else {
                setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListSaveHeader);
                setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListSaveDec);
            }
        }
        setSaveBtnStatus(true);
    }, [
        createNewList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let timerConst;
        if (createListAddItemsSuccess) {
            timerConst = setTimeout(()=>{
                if (moveToList) handleSuccessCallBack(moveToListResponse);
                listSaveAndCreateClose();
                setCreateListAddItemsSuccess(false);
                setNameValidationErrorMsg("");
                setNewListName("");
                setProjectName("");
                setDec("");
                setMoveToListResponse({});
            }, 3000);
        }
        return ()=>{
            clearTimeout(timerConst);
        };
    }, [
        createListAddItemsSuccess
    ]);
    if (listNamesLoader && showListSaveAndCreate) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().SaveToListWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "save-to-list-modal",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "loading-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "loading-text",
                        children: staticText === null || staticText === void 0 ? void 0 : staticText.saveToListLoading
                    })
                })
            })
        });
    }
    return showListSaveAndCreate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().SaveToListWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "save-to-list-modal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "back-close-btn",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "close-btn",
                                onClick: closeModalHandle,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    src: _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z === null || _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"].src */ .Z.src,
                                    role: "presentation",
                                    alt: "close",
                                    width: "30",
                                    height: "30"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "modal-content",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "list-header",
                                    children: headerText
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "list-dec",
                                    children: decText
                                }),
                                !createNewList && !createListAddItemsSuccess ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "create-new-list",
                                    onClick: handleCreateNewList,
                                    children: staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn
                                }) : null,
                                createListAddItemsSuccess && !createList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "create-new-list",
                                    onClick: handleListNameClick,
                                    children: createListData === null || createListData === void 0 ? void 0 : createListData.name
                                }) : null,
                                !createListAddItemsSuccess && createNewList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CreateForm, {
                                    listNameValidation: listNameValidation,
                                    newListName: newListName,
                                    showNameValidationError: showNameValidationError,
                                    nameValidationErrorMsg: nameValidationErrorMsg,
                                    projectNameValidation: projectNameValidation,
                                    projectName: projectName,
                                    dec: dec,
                                    handleDec: handleDec,
                                    count: count
                                }) : null,
                                !createListAddItemsSuccess && !createNewList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListForm, {
                                    createNewList: createNewList,
                                    createListAddItemsSuccess: createListAddItemsSuccess,
                                    userLists: userLists,
                                    handleSelectedList: handleSelectedList,
                                    selectedList: selectedList
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "action-btn",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "action-btn-item",
                        disabled: saveBtnStatus,
                        onClick: handleCreateListAndAddProductsToIt,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "action-btn-item-txt",
                            children: createListAddItemsSuccess ? createList ? staticText === null || staticText === void 0 ? void 0 : staticText.saveToListNewActionSave : staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionSaved : staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionSave
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (SaveToList);


/***/ }),

/***/ 34428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        createNameError: t("kf.saveToList.create.name.error"),
        createSameNameError: t("kf.saveToList.create.same.name.error"),
        createSystemNameError: t("kf.saveToList.create.system.name.error"),
        saveToListActionTitle: t("kf.saveToList.action.success.title"),
        saveToListActionDec: t("kf.saveToList.action.success.dec"),
        saveToListCreateHeader: t("kf.saveToList.create.header"),
        saveToListCreateDec: t("kf.saveToList.create.dec"),
        saveToListSaveHeader: t("kf.saveToList.save.header"),
        saveToListSaveDec: t("kf.saveToList.save.dec"),
        saveToListLoading: t("kf.saveToList.loading"),
        saveToListCreateNewBtn: t("kf.saveToList.create.new.btn.txt"),
        saveToListActionSaved: t("kf.saveToList.action.saved"),
        saveToListActionSave: t("kf.saveToList.action.save"),
        saveToListNewActionSave: t("kf.saveToList.action.new.saved"),
        createLabel: t("kf.saveToList.create.name.label"),
        projectLabel: t("kf.saveToList.create.project.label"),
        dec: t("kf.saveToList.create.dec.label"),
        title: t("kf.saveToList.myList.titile"),
        saveEventMsgCreateList: t("kf.save.eventMsg.create.list"),
        saveEventMsgMyList: t("kf.save.eventMsg.myList"),
        moveToList: t("kf.moveToList.header"),
        moveToListDec: t("kf.moveToList.dec"),
        moveToListSuccessDec: t("kf.moveToList.success.dec")
    };
};


/***/ }),

/***/ 66016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ShareListModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/InternalLinkIcon.mjs
var InternalLinkIcon = __webpack_require__(33804);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/ShareListModal/index.module.scss
var index_module = __webpack_require__(84793);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/constant.js
var constant = __webpack_require__(8541);
;// CONCATENATED MODULE: ./components/ShareListModal/analytics.js

const shareListModalDataLayerEvents = (data)=>{
    const { name ="" , actionType ="" , pageType ="" , eventStatus ="" , eventType ="" , sharedURL =""  } = data;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const pageState = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const page = pageState;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant/* MY_ACCOUNT */.RX, ":").concat(constant/* MY_LISTS */.E4, ":").concat(pageType, ":").concat(actionType),
        eventMsg: "n/a",
        eventName: "".concat(constant/* MY_ACCOUNT */.RX, ":").concat(constant/* MY_LISTS */.E4, ":").concat(pageType, ":").concat(actionType),
        eventStatus: eventStatus || "n/a",
        eventType: "".concat(eventType),
        internalLinkName: "".concat(actionType),
        internalLinkPosition: "".concat(constant/* MY_ACCOUNT */.RX, ":").concat(constant/* MY_LISTS */.E4, ":").concat(pageType),
        internalLinkType: "".concat(constant/* MY_ACCOUNT */.RX, ":").concat(constant/* MY_LISTS */.E4, ":").concat(pageType, ":").concat(actionType, ":").concat(name),
        internalLinkURL: "".concat(sharedURL),
        internalLinkZoneName: "".concat(constant/* MY_ACCOUNT */.RX, ":").concat(constant/* MY_LISTS */.E4, ":").concat(pageType, ":").concat(name)
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./components/ShareListModal/index.jsx








const ShareListModal = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { listName ="" , showShareListModal =false , onClose =()=>{} , URLToShare ="" , fromPage =""  } = props || {};
    const [copied, setCopied] = react.useState(false);
    const handleCloseBtnClick = ()=>{
        onClose();
        shareListModalDataLayerEvents({
            name: listName,
            actionType: "modal close",
            pageType: fromPage,
            eventStatus: "success",
            eventType: "informative",
            sharedURL: URLToShare
        });
    };
    const handleCopyLink = async ()=>{
        try {
            var ref;
            if (!URLToShare) return;
            if (navigator === null || navigator === void 0 ? void 0 : (ref = navigator.clipboard) === null || ref === void 0 ? void 0 : ref.writeText) {
                var ref1;
                await (navigator === null || navigator === void 0 ? void 0 : (ref1 = navigator.clipboard) === null || ref1 === void 0 ? void 0 : ref1.writeText(URLToShare));
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = URLToShare;
                textarea.setAttribute("readonly", "");
                textarea.style.position = "absolute";
                textarea.style.left = "-9999px";
                document.body.appendChild(textarea);
                textarea.select();
                textarea.setSelectionRange(0, textarea.value.length);
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
            setCopied(true);
            setTimeout(()=>setCopied(false), 3000);
        } catch (err) {
            // fallback attempt if clipboard API failed
            try {
                var ref2, ref3;
                const textarea1 = document === null || document === void 0 ? void 0 : document.createElement("textarea");
                textarea1.value = URLToShare;
                textarea1.setAttribute("readonly", "");
                textarea1.style.position = "absolute";
                textarea1.style.left = "-9999px";
                document === null || document === void 0 ? void 0 : (ref2 = document.body) === null || ref2 === void 0 ? void 0 : ref2.appendChild(textarea1);
                textarea1.select();
                document === null || document === void 0 ? void 0 : document.execCommand("copy");
                document === null || document === void 0 ? void 0 : (ref3 = document.body) === null || ref3 === void 0 ? void 0 : ref3.removeChild(textarea1);
                setCopied(true);
                setTimeout(()=>setCopied(false), 3000);
            } catch (e) {
            // swallow errors silently
            }
        }
        shareListModalDataLayerEvents({
            name: listName,
            actionType: "copy link",
            pageType: fromPage,
            eventStatus: "success",
            eventType: "informative",
            sharedURL: URLToShare
        });
    };
    const handleContinueShopping = ()=>{
        onClose();
        shareListModalDataLayerEvents({
            name: listName,
            actionType: "continue shopping",
            pageType: fromPage,
            eventStatus: "success",
            eventType: "informative",
            sharedURL: URLToShare
        });
    };
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (typeof document === "undefined") return;
        if (!showShareListModal) return;
        const previousOverflow = document === null || document === void 0 ? void 0 : (ref = document.body) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : ref1.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = previousOverflow || "";
        };
    }, [
        showShareListModal
    ]);
    return showShareListModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).ShareListModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "Share-list-modal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "back-close-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "close-btn",
                                onClick: handleCloseBtnClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                                    role: "presentation",
                                    alt: "close",
                                    width: "16",
                                    height: "17"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "list-header",
                                    children: t("kf.share.list.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "list-dec",
                                    children: t("kf.share.list.title.dec")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cta-with-icon",
                                    onClick: ()=>{
                                        handleCopyLink();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLinkIcon/* InternalLinkIcon */.B, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "label-cls",
                                            children: copied ? t("kf.share.list.copied") : t("kf.share.list.copy'link")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "action-btn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "action-btn-item",
                        onClick: handleContinueShopping,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "action-btn-item-txt",
                            children: t("kf.share.list.continueShopping")
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var components_ShareListModal = (ShareListModal);


/***/ }),

/***/ 71025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98260);
/* harmony import */ var _components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);



const DisplayDiscountPrice = (param)=>{
    let { discountedPrice =0 , price =0 , currencySign ="$" , formListDetails =false , color =false  } = param;
    if (formListDetails) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().discountprice),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "price-width-disCount",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "price-discount",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                            value: price,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        })
                    }),
                    discountedPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "discount",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                            value: discountedPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        })
                    }) : null
                ]
            })
        });
    }
    if (discountedPrice && discountedPrice !== price) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_Shared_DisplayDiscountPrice_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().discountprice),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "price",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "price-discount".concat(color ? "-color" : ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                            value: discountedPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "discount".concat(color ? "-color" : "", " discount-padding"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
                                value: price,
                                displayType: "text",
                                thousandSeparator: true,
                                prefix: currencySign,
                                decimalScale: 2,
                                fixedDecimalScale: true
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "original-price".concat(color ? "-color" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* .NumericFormat */ .h3, {
            value: price,
            displayType: "text",
            thousandSeparator: true,
            prefix: currencySign,
            decimalScale: 2,
            fixedDecimalScale: true
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayDiscountPrice);


/***/ }),

/***/ 42346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7872);
/* harmony import */ var _components_core_Heading_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22231);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25935);
/* harmony import */ var _components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73712);
/* harmony import */ var _components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92058);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10884);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);












const ErrorPage = ()=>{
    const [header, setHeader] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const [footer, setFooter] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const [dataURL, setDataURL] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [pageData, setPageData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({});
    const axiosCall = async ()=>{
        var ref, ref1;
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.headerUrl, ".model.json")
            }
        }).then((res)=>{
            setHeader((0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .filterBackEndJson */ .LjD)(res.data));
        }).catch((err)=>{
            console.error("Failed to get compare attributes JSON file", err);
        });
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.footerUrl, ".model.json")
            }
        }).then((res)=>{
            setFooter((0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .filterBackEndJson */ .LjD)(res.data));
        }).catch((err)=>{
            console.error("Failed to get compare attributes JSON file", err);
        });
        const { data: configData = {}  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.CORE_GLOBAL_CONFIG_URL),
            method: "GET"
        });
        setDataURL(configData === null || configData === void 0 ? void 0 : (ref = configData.contentFragmentListConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.pageNotFoundError);
        if (dataURL) {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: dataURL
                }
            }).then((res)=>{
                var ref;
                setPageData((ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .filterBackEndJson */ .LjD)(res)) === null || ref === void 0 ? void 0 : ref.data);
            }).catch((err)=>{
                console.error("Failed to get compare attributes JSON file", err);
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        axiosCall();
    }, [
        dataURL
    ]);
    const { errorTitle ="" , supportNumberAndLabel ="" , previousPageLabel ="" , refreshLabel ="" , homepageLable ="" , homepageLink ="" , errorImage =""  } = pageData || {};
    const homeURL = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.authorBaseUrl).concat(homepageLink);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    const handlePrev = ()=>{
        document.referrer === "" ? router.push(homeURL) : history.back();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__["default"], {
                header: header
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().Container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "subContainer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mainSection",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "heading",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Heading_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        level: 1,
                                        className: "heading-grid",
                                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(errorTitle)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "buttonSection",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: "ghost",
                                            role: "button",
                                            size: "small",
                                            arrowImg: true,
                                            flexible: true,
                                            label: previousPageLabel,
                                            onClick: handlePrev
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: "ghost",
                                            role: "button",
                                            size: "small",
                                            flexible: true,
                                            label: refreshLabel,
                                            onClick: ()=>window.location.reload()
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: "ghost",
                                            role: "button",
                                            size: "small",
                                            flexible: true,
                                            label: homepageLable,
                                            onClick: ()=>window.location.href = homeURL
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "paraG",
                                            children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(supportNumberAndLabel)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "imageDiv",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.authorBaseUrl).concat(errorImage),
                                alt: "imag"
                            })
                        })
                    ]
                })
            }),
            footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__["default"], {
                footer: footer
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ }),

/***/ 10884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94020);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96301);








const GlobalPageFooter = (props)=>{
    const { footer , footerScripting  } = props;
    const [scripts, setScripts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectGenericState */ .Px);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getPageLevelScriptsAndStyles */ .ptY)(footerScripting);
        setScripts(pageLevelDetails["pageScripts"]);
    }, [
        footerScripting
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getScriptsAndStyles */ .csL)(footer);
    }, [
        footer
    ]);
    const eventHandler = {
        store: {},
        callbacks: {
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setGlobalStyles */ .cw)(item));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "footerscript-".concat(i)
                }, "footerscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    id: "footerscriptHtml-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "footerscriptHtml-".concat(i));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__["default"], {
                data: footer,
                count: 0,
                eventHandler: eventHandler,
                fragment: _constants__WEBPACK_IMPORTED_MODULE_7__.FRAGMENT_TYPES.FOOTER
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GlobalPageFooter);


/***/ }),

/***/ 92058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GlobalPage_GlobalPageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/utils.js
var utils = __webpack_require__(68446);
// EXTERNAL MODULE: ./utils/textUtils.js
var textUtils = __webpack_require__(89299);
;// CONCATENATED MODULE: ./components/DesignSystem/utils/navigationHelper.js
/**
 * Helper functions for navigation mapping
 */ /**
 * Recursively searches an object tree to find an item by name
 * @param {Object} obj - Object tree to search
 * @param {string} name - Name to search for
 * @return {Object|null} Found item or null
 */ 

const findItemByName = (obj, name)=>{
    // Check if obj is null/undefined first
    if (!obj) return {};
    // If we have :items, check them first
    if (obj[":items"]) {
        // Look through each key in :items
        for (const key of Object.keys(obj[":items"])){
            // If key contains our search name
            if (key.includes(name)) {
                return obj[":items"][key];
            }
            // If this item has nested :items, recurse into them
            const result = findItemByName(obj[":items"][key], name);
            if (result) return result;
        }
    }
    // Return empty object instead of null to allow safe property access
    return null;
};
const hasHeaderItems = (header)=>{
    if (header[":items"]) {
        for (const key of Object.keys(header[":items"])){
            if (header[":items"][key][":items"] && Object.keys(header[":items"][key][":items"]).length > 0) {
                return true;
            }
        }
    }
    return false;
};
/**
 * Extracts menu items from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array} Array of menu items
 */ function getMenuItems(obj) {
    const result = [];
    // Check if object has itemsOrder
    if (obj === null || !obj[":itemsOrder"]) return result;
    // Iterate through itemsOrder
    for (const itemKey of obj[":itemsOrder"]){
        const item = obj[":items"][itemKey];
        // For each item, check its :items
        if (item[":items"]) {
            // Look for keys containing globalnavigation_v3
            for (const key of Object.keys(item[":items"])){
                if (key.includes("globalnavigation_v3")) {
                    var _appliedCssClassNames;
                    result.push({
                        ...item[":items"][key],
                        appliedCssClassNames: (_appliedCssClassNames = item.appliedCssClassNames) !== null && _appliedCssClassNames !== void 0 ? _appliedCssClassNames : ""
                    });
                }
            }
        }
    }
    return result;
}
const checkForBusinessLevelOneArray = (obj)=>{
    if (!(obj === null || obj === void 0 ? void 0 : obj.levelOneNavMulti)) return false;
    return obj.levelOneNavMulti.some((levelOne)=>{
        if (!(levelOne === null || levelOne === void 0 ? void 0 : levelOne.levelTwoNavMulti)) return false;
        // Check if all levelTwo items have empty levelThreeNavMulti arrays
        return levelOne.levelTwoNavMulti.every((levelTwo)=>{
            var ref;
            return (levelTwo === null || levelTwo === void 0 ? void 0 : (ref = levelTwo.levelThreeNavMulti) === null || ref === void 0 ? void 0 : ref.length) === 0;
        });
    });
};
const transformArray = (obj, tabTitle)=>{
    var ref;
    const res = [];
    (ref = obj["levelOneNavMulti"]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        var ref;
        const levelTwoArray = [];
        item === null || item === void 0 ? void 0 : (ref = item.levelTwoNavMulti) === null || ref === void 0 ? void 0 : ref.forEach((levelTwo)=>{
            var ref, ref1, ref2, ref3;
            levelTwoArray.push({
                title: {
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: (0,utils/* modifyHref */.L9)(levelTwo.groupLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle)).toLowerCase(),
                            internalLinkURL: levelTwo.groupLink ? (ref = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelTwo.groupLink))) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a"
                        })
                    },
                    text: (0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle),
                    href: (0,utils/* modifyHref */.L9)(levelTwo.groupLink),
                    target: levelTwo.newTabGroup ? "_blank" : "_self"
                },
                isCTA: (ref1 = levelTwo.groupTitle) === null || ref1 === void 0 ? void 0 : ref1.includes("carrot-icon"),
                items: ((ref2 = levelTwo.levelThreeNavMulti) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? (ref3 = levelTwo.levelThreeNavMulti) === null || ref3 === void 0 ? void 0 : ref3.map((levelThree)=>{
                    var ref;
                    return {
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: (0,utils/* modifyHref */.L9)(levelThree.link) ? "true" : "false",
                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle), " > ").concat((0,textUtils/* sanitizeText */.o)(levelThree.label))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                internalLinkURL: levelThree.link ? "".concat(levelThree.link.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelThree.link)).toLowerCase() : "n/a"
                            })
                        },
                        text: (0,textUtils/* sanitizeText */.o)(levelThree.label),
                        href: (0,utils/* modifyHref */.L9)(levelThree.link),
                        target: levelThree.newTab ? "_blank" : "_self"
                    };
                }) : undefined
            });
        });
        res.push(levelTwoArray);
    });
    return res;
};
const transformBusinessArray = (obj, tabTitle)=>{
    var ref;
    const res = [];
    (ref = obj["levelOneNavMulti"]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        // Check if this levelOne item has all empty levelThreeNavMulti arrays
        if (checkForBusinessLevelOneArray({
            levelOneNavMulti: [
                item
            ]
        })) {
            var ref;
            // If true, create a simplified structure with just titles and links
            const simplifiedStructure = {
                items: ((ref = item.levelTwoNavMulti) === null || ref === void 0 ? void 0 : ref.map((levelTwo)=>{
                    var ref, ref1;
                    return {
                        title: {
                            text: (0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle),
                            href: (0,utils/* modifyHref */.L9)(levelTwo.groupLink),
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: (0,utils/* modifyHref */.L9)(levelTwo.groupLink) ? "true" : "false",
                                    internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                    internalLinkURL: levelTwo.groupLink ? (ref1 = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelTwo.groupLink))) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "n/a"
                                })
                            }
                        },
                        newTabGroup: levelTwo.newTabGroup
                    };
                })) || []
            };
            res.push(simplifiedStructure);
        } else {
            var ref1;
            // If false, keep the existing structure with tracking attributes
            const levelTwoArray = [];
            item === null || item === void 0 ? void 0 : (ref1 = item.levelTwoNavMulti) === null || ref1 === void 0 ? void 0 : ref1.forEach((levelTwo)=>{
                var ref, ref1, ref2, ref3;
                levelTwoArray.push({
                    title: {
                        text: (0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle),
                        href: (0,utils/* modifyHref */.L9)(levelTwo.groupLink),
                        target: levelTwo.newTabGroup ? "_blank" : "_self",
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: (0,utils/* modifyHref */.L9)(levelTwo.groupLink) ? "true" : "false",
                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                internalLinkURL: levelTwo.groupLink ? (ref1 = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelTwo.groupLink))) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "n/a"
                            })
                        }
                    },
                    items: ((ref2 = levelTwo.levelThreeNavMulti) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? (ref3 = levelTwo.levelThreeNavMulti) === null || ref3 === void 0 ? void 0 : ref3.map((levelThree)=>{
                        var ref;
                        return {
                            text: (0,textUtils/* sanitizeText */.o)(levelThree.label),
                            href: (0,utils/* modifyHref */.L9)(levelThree.link),
                            target: levelThree.newTab ? "_blank" : "_self",
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: (0,utils/* modifyHref */.L9)(levelThree.link) ? "true" : "false",
                                    internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(levelTwo.groupTitle), " > ").concat((0,textUtils/* sanitizeText */.o)(levelThree.label)).toLowerCase(),
                                    internalLinkURL: levelThree.link ? (ref = "".concat(levelThree.link.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelThree.link))) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a"
                                })
                            }
                        };
                    }) : undefined
                });
            });
            res.push(levelTwoArray);
        }
    });
    return res;
};
/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */ function getPanelTitles(obj) {
    // Check if object has required properties
    if (obj === null || !obj[":itemsOrder"] || !obj[":items"]) return [];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["cq:panelTitle"] || "";
    });
    return titles;
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/promoBannerhelper.js
/**
 * Recursively searches an object tree to find an item by containerId name
 * @param {Object} obj - Object tree to search
 * @param {string} name - Name to search for containerId
 * @return {Object|null} Found item or null
 */ function findItemByContainerId(obj, name) {
    // If we have :items, check them first
    if (obj[":items"]) {
        // Look through each key in :items
        for (const key of Object.keys(obj[":items"])){
            var ref;
            // If item containerId matches with name
            if (((ref = obj[":items"][key]) === null || ref === void 0 ? void 0 : ref.containerId) && obj[":items"][key].containerId === name) {
                return obj[":items"][key];
            }
            // If this item has nested :items, recurse into them
            const result = findItemByContainerId(obj[":items"][key], name);
            if (result) return result;
        }
    }
    return null;
}
/**
 * Extracts and formats promo banner content and CTAs from a container(navigation object).
 *
 * @param {Object} container - The container/navigation object containing promo data.
 * @param {string} name - The name or containerId to locate the promo details.
 * @param {Function} setPromoModal - Callback to trigger modal display for a promo.
 * @return {Array<Object>} - An array of formatted promo banner objects.
 */ function extractPromoBanners(container, name, setPromoModal) {
    var ref, ref1, ref2;
    // Find item by containerId
    const promoDetails = findItemByContainerId(container, name);
    if (!promoDetails) {
        return [];
    }
    // Extract promo banner items
    const promoBanners = promoDetails === null || promoDetails === void 0 ? void 0 : (ref = promoDetails[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["carousel_slick"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1["carouselComponentProperties"]) === null || ref2 === void 0 ? void 0 : ref2[":items"];
    if (!promoBanners) {
        return [];
    }
    // Format the response
    return Object.values(promoBanners).map((banner)=>{
        var ref;
        const content = ((ref = banner.description) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>/g, "").trim()) || "";
        const CTAs = (banner.actionItems || []).map((item)=>{
            var ref;
            let ctaObj = {
                text: item.text,
                href: item.ctaLink
            };
            if (item.enablePopup && banner.actionsEnabled) {
                // open popup
                ctaObj = {
                    text: item.text,
                    "aria-label": "".concat(item.text, " related to ").concat(content),
                    onClick: ()=>{
                        setPromoModal({
                            show: true,
                            modalContent: {
                                banner: banner,
                                item: item
                            }
                        });
                    }
                };
            } else if (item.isNewTab && !item.enablePopup) {
                // open in new tab
                ctaObj = {
                    text: item.text,
                    onClick: ()=>{
                        return window.open(item === null || item === void 0 ? void 0 : item.authoredLink, "_blank");
                    }
                };
            } else if (item.authoredLink && !item.enablePopup) {
                // open internal link
                ctaObj = {
                    text: item.text,
                    onClick: ()=>{
                        window.open(item === null || item === void 0 ? void 0 : item.authoredLink, "_self");
                    }
                };
            }
            ctaObj.trackingAttributes = {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: item.enablePopup ? "true" : "false",
                    eventAction: item.text,
                    eventName: item.text,
                    internalLinkName: item.text,
                    internalLinkPosition:  true ? "".concat(window.eventPageType, ":promo banner") : 0,
                    internalLinkType: "navigation",
                    internalLinkURL: item.enablePopup ? "n/a" : item.ctaLink && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref = item.ctaLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName:  true ? "".concat(window.eventPageType, ":promo details") : 0,
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "promo banner"
                })
            };
            return ctaObj;
        });
        return {
            content,
            CTAs
        };
    });
}

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/DesignSystem/utils/languageMenuHelper.js


const LANGUAGE_PROPERTY_MAPPINGS = [
    {
        nameKey: "languageOne",
        abbreviationKey: "languageOneAbbreviation",
        linkKey: "languageOneLink"
    },
    {
        nameKey: "languageTwo",
        abbreviationKey: "languageTwoAbbreviation",
        linkKey: "languageTwoLink"
    },
    {
        nameKey: "languageThree",
        abbreviationKey: "languageThreeAbbreviation",
        linkKey: "languageThreeLink"
    }
];
const createLanguageObject = (language, abbreviation, link, width)=>{
    if (!language) return null;
    const sanitizedLink = (0,helper/* removeAndCleanLink */.xEh)(link);
    return {
        text: width < 1024 ? language : abbreviation,
        href: sanitizedLink,
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "language selector",
                eventName: "language selector",
                eventType: "language selector",
                internalLinkName: "language select:".concat(abbreviation.toLowerCase()),
                internalLinkPosition: "languageselector",
                internalLinkType: "homepage:navigation",
                internalLinkURL: sanitizedLink,
                internalLinkZoneName: "home:global header"
            })
        }
    };
};
const mapRegion = function() {
    let regionName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], currentCountry = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return {
        name: regionName,
        countries: items.map((item)=>{
            if (!item.countryName && !item.country) return null;
            const country = {
                name: item.countryName || item.country
            };
            const languages = LANGUAGE_PROPERTY_MAPPINGS.map((param)=>{
                let { nameKey , abbreviationKey , linkKey  } = param;
                return createLanguageObject(item[nameKey], item[abbreviationKey], item[linkKey], width);
            }).filter(Boolean);
            if (item.countryLink) {
                country.href = (0,helper/* removeAndCleanLink */.xEh)(item.countryLink);
                country.trackingAttributes = {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "country selector",
                        eventName: "country selector",
                        eventType: "country selector",
                        internalLinkName: "country select:".concat(item.country.toLowerCase()),
                        internalLinkPosition: "global header",
                        internalLinkType: "homepage:navigation",
                        internalLinkURL: "n/a",
                        internalLinkZoneName: "home:global header"
                    })
                };
            }
            if (item.countryName === currentCountry) country.isCurrentCountry = true;
            if (languages.length) country.languages = languages;
            return country;
        }).filter(Boolean),
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "country select:".concat(regionName.toLowerCase()),
                eventName: "country select:".concat(regionName.toLowerCase()),
                eventType: "navigation",
                internalLinkName: regionName.toLowerCase(),
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkURL: "n/a",
                internalLinkZoneName: "global header"
            })
        }
    };
};
const getLanguageMenu = (container, width)=>{
    let secondLanguageCTA = {};
    const { country ="" , language ="" , enableLanguageSwitcher , languageLabel ="" , languageUrl =""  } = container || {};
    const currentCountry = "United States" || 0;
    const currentLanguage = language || "EN";
    const countrySelector = findItemByName(container, "countryselector");
    if (!countrySelector) {
        return {
            regions: [],
            languageMenuTitle: undefined,
            languageMenuDescription: undefined,
            currentCountry,
            currentLanguage,
            secondLanguageCTA
        };
    }
    const regionMappings = [
        {
            key: "americasItems",
            name: "Americas"
        },
        {
            key: "africaItems",
            name: "Africa"
        },
        {
            key: "asiaItems",
            name: "Asia"
        },
        {
            key: "oceaniaItems",
            name: "Australasia"
        },
        {
            key: "middleEastItems",
            name: "Middle East"
        },
        {
            key: "europeItems",
            name: "Europe"
        }
    ];
    const regions = regionMappings.filter((region)=>countrySelector[region.key]).map((region)=>mapRegion(region.name, countrySelector[region.key], currentCountry, width));
    if (enableLanguageSwitcher) {
        secondLanguageCTA = {
            text: languageLabel,
            href: (0,helper/* removeAndCleanLink */.xEh)(languageUrl)
        };
    }
    return {
        regions,
        languageMenuTitle: countrySelector.title,
        languageMenuDescription: countrySelector.description,
        currentCountry,
        currentLanguage,
        secondLanguageCTA
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/utils/brandSwitcherHelper.js
/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */ function getBrandTitles(obj) {
    if (!obj) return null;
    // Check if object has required properties
    if (!obj[":itemsOrder"] || !obj[":items"]) return obj["items"];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["brand_switcher"] || "";
    });
    return titles;
}
/**
 * Generates an array of brand objects from the given input object.
 *
 * @param {Object} obj - The input object containing brand information.
 * @param {Object} i18n - The internationalization object for localized strings.
 * @return {Array} An array of brand objects with text, href, target, and isActive properties.
 */ function getBrandsArray(obj, i18n) {
    const brandSwitcherArray = getBrandTitles(obj) || [];
    const brandArray = brandSwitcherArray.map((item)=>{
        var ref, ref1;
        if (!item) return {
            text: "",
            href: "",
            target: "_self",
            isActive: false
        };
        return {
            text: (item === null || item === void 0 ? void 0 : item.brandName) || "",
            href: (item === null || item === void 0 ? void 0 : item.link) || "",
            target: (item === null || item === void 0 ? void 0 : item.linkToNewTab) === "true" ? "_blank" : "_self",
            isActive: (item === null || item === void 0 ? void 0 : item.highlight) || false,
            "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandName, " ").concat((item === null || item === void 0 ? void 0 : item.linkToNewTab) === "true" ? i18n.opensInNewTab : i18n.opensInSameTab),
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks:  true && (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.includes(window.location.hostname.split(".").slice(1).join("."))),
                    eventAction: "brand sync",
                    eventName: "brand sync",
                    eventType: "click",
                    internalLinkName: "brand sync:".concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                    internalLinkPosition: "global header",
                    internalLinkType: "global header:navigation",
                    internalLinkURL: item === null || item === void 0 ? void 0 : item.link,
                    internalLinkZoneName:  true ? "".concat(window === null || window === void 0 ? void 0 : window.eventPageType, ":global header") : 0
                })
            }
        };
    }).filter((item)=>item.text || item.href) // Filter out empty items
    ;
    return brandArray;
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/utilityHeaderHelper.js

/**
 * Extracts links from an HTML string and modifies the href.
 *
 * @param {string} htmlString - The HTML string to extract links from.
 * @return {Array} An array of link objects with modified href and text.
 */ function extractLinks(htmlString) {
    const linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"(?:[^>]*)>(.*?)<\/a>/g;
    const links = [];
    let match;
    while((match = linkRegex.exec(htmlString)) !== null){
        var ref, ref1, ref2, ref3, ref4;
        links.push({
            component: "a",
            href: (0,utils/* modifyHref */.L9)(match[1].replace("/link", "/modified/link")),
            text: match[2] || "",
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "my account:".concat((ref = match[2]) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                    eventName: "my account:".concat((ref1 = match[2]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "global header",
                    internalLinkName: (ref2 = match[2]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
                    internalLinkPosition: "global header:".concat((ref3 = match[2]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                    internalLinkType: "global header:navigation",
                    internalLinkURL: match[1] && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref4 = match[1]) === null || ref4 === void 0 ? void 0 : ref4.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "global header"
                })
            }
        });
    }
    return links;
}
/**
 * Returns the cart badge CTA object if the cartLandingPagePath exists and canadaCheck is false, otherwise undefined.
 *
 * @param {string} cartLandingPagePath - The cart landing page URL.
 * @param {number} cartCount - The number of items in the cart.
 * @param {boolean} canadaCheck - If true, the cart icon should not be shown.
 * @return {CartBadgeCTA|undefined} The cart badge CTA object or undefined.
 */ function getCartBadgeCTA() {
    let cartLandingPagePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", cartCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, canadaCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (canadaCheck) return null;
    return {
        href: cartLandingPagePath,
        digit: cartCount > 0 && cartCount < 999 ? cartCount : null,
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "cart icon",
                eventMsg: "n/a",
                eventName: "cart icon",
                eventStatus: "n/a",
                eventType: "global header",
                internalLinkName: "cart icon",
                internalLinkPosition: "global header",
                internalLinkType: "global header:navigation",
                internalLinkURL: cartLandingPagePath,
                internalLinkZoneName: "global header"
            })
        }
    };
}

// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/constant.js
var constant = __webpack_require__(59187);
;// CONCATENATED MODULE: ./components/DesignSystem/mappers/navigationV2Mapper.js









const mapMainMenuProps = function() {
    let container = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i18n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lineItems = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, firstName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", isAuth = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, logIndata = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, logOutdata = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, onclicksignIN = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : ()=>{}, onClickCreateAccount = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : ()=>{}, onClickSignOut = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : ()=>{}, favClickHandler = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : ()=>{}, cartCount = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : 0, themeType = arguments.length > 12 && arguments[12] !== void 0 ? arguments[12] : "light", handleSearchClick = arguments.length > 13 && arguments[13] !== void 0 ? arguments[13] : ()=>{}, showBackground = arguments.length > 14 && arguments[14] !== void 0 ? arguments[14] : false, favoritesPage = arguments.length > 15 && arguments[15] !== void 0 ? arguments[15] : [], favoritesPagePath = arguments.length > 16 && arguments[16] !== void 0 ? arguments[16] : "", cartLandingPagePath = arguments.length > 17 && arguments[17] !== void 0 ? arguments[17] : "", path = arguments.length > 18 && arguments[18] !== void 0 ? arguments[18] : "", setPromoModal = arguments.length > 19 && arguments[19] !== void 0 ? arguments[19] : ()=>{}, canadaCheck = arguments.length > 20 && arguments[20] !== void 0 ? arguments[20] : false, transitionDelay = arguments.length > 21 && arguments[21] !== void 0 ? arguments[21] : "", searchHeader = arguments.length > 22 && arguments[22] !== void 0 ? arguments[22] : "Search", language = arguments.length > 23 && arguments[23] !== void 0 ? arguments[23] : "en", isSaveProductToList = arguments.length > 24 && arguments[24] !== void 0 ? arguments[24] : false, width = arguments.length > 25 && arguments[25] !== void 0 ? arguments[25] : 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    const titlesArray = getPanelTitles(findItemByName(container, "tabs"));
    const menuItemsArray = getMenuItems(findItemByName(container, "tabs"));
    const logoData = findItemByName(container, "image");
    const { languageMenuTitle ="" , languageMenuDescription ="" , regions =[] , currentCountry ="" , currentLanguage ="" , secondLanguageCTA ={}  } = getLanguageMenu(findItemByName(container, "utilitynavheader"), width) || {};
    const formattedResponse = extractPromoBanners(container, "promo-details", setPromoModal);
    const brandSwitcherArray = getBrandsArray(findItemByName(container, "brand_switcher"), i18n);
    const loggedInCtaArray = extractLinks(logIndata);
    const loggedOutCtaArray = extractLinks(logOutdata);
    const cartBadgeCTA = getCartBadgeCTA(cartLandingPagePath, cartCount, canadaCheck);
    const dataLayerTitle = "find a store";
    var ref28;
    const findStoreLabel = (ref28 = (ref = findItemByName(container, "store")) === null || ref === void 0 ? void 0 : ref.findStore) !== null && ref28 !== void 0 ? ref28 : "Find a Store";
    return {
        promoBanner: {
            mod: formattedResponse.length > 0 ? "slate" : "",
            type: formattedResponse.length > 0 ? "promo" : "",
            content: formattedResponse.length > 0 ? formattedResponse : undefined
        },
        mainNavigation: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
            mod: themeType === "light" ? "white" : "black",
            brandCTA: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
                brand: "Kohler Bold",
                href: "/",
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: (logoData === null || logoData === void 0 ? void 0 : logoData.link) ? "true" : "false",
                        eventAction: "header kohler logo",
                        eventName: "header kohler logo",
                        internalLinkName: "header kohler logo",
                        internalLinkPosition: "global header",
                        internalLinkType: "global header:navigation",
                        internalLinkURL: (logoData === null || logoData === void 0 ? void 0 : logoData.link) && "object" !== "undefined" ? "".concat(window.location.origin).concat(logoData === null || logoData === void 0 ? void 0 : (ref1 = logoData.link) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                        internalLinkZoneName: "global header"
                    })
                }
            } : {},
            showBackground: showBackground,
            menuItems: menuItemsArray.map((item, index)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
                const tabTitle = titlesArray[index];
                return {
                    text: tabTitle,
                    mod: themeType === "light" ? "white" : "black",
                    CTALists: (item === null || item === void 0 ? void 0 : item.navigationMenuType) !== "business" ? transformArray(item, titlesArray[index]) : transformBusinessArray(item, titlesArray[index]),
                    ...((ref = item.firstImagesblock) === null || ref === void 0 ? void 0 : ref.firstImageFileReference) && {
                        images: [
                            {
                                image: {
                                    src: item.firstImagesblock.firstImageFileReference || "",
                                    alt: item.firstImagesblock.altText || "",
                                    "data-mode": "smartcrop",
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref1 = item.firstImagesblock) === null || ref1 === void 0 ? void 0 : ref1.firstImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref2 = item.firstImagesblock) === null || ref2 === void 0 ? void 0 : ref2.ctaLabel).toLowerCase(),
                                            internalLinkURL: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    },
                                    reveal: "default",
                                    loading: "blank"
                                },
                                imageOrientation: ((ref3 = item.appliedCssClassNames) === null || ref3 === void 0 ? void 0 : ref3.includes("landscape")) ? "landscape" : "portrait",
                                caption: {
                                    text: item.firstImagesblock.firstImageTitle ? (0,textUtils/* sanitizeText */.o)(item.firstImagesblock.firstImageTitle) : ""
                                },
                                multiCTA: item.multiCTA.map((elem, index)=>{
                                    var ref;
                                    return {
                                        text: (0,textUtils/* sanitizeText */.o)(elem.ctaLabel),
                                        href: (0,utils/* modifyHref */.L9)(elem.ctaLink),
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(elem.ctaLabel))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(elem.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(elem.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(elem.ctaLink)) : "n/a"
                                            })
                                        }
                                    };
                                }),
                                CTA: item.firstImagesblock.ctaLabel ? {
                                    text: (0,textUtils/* sanitizeText */.o)(item.firstImagesblock.ctaLabel),
                                    href: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink),
                                    target: item.firstImagesblock.ctaNewTab ? "_blank" : "_self",
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref4 = item.firstImagesblock) === null || ref4 === void 0 ? void 0 : ref4.firstImageTitle), " > ").concat(item === null || item === void 0 ? void 0 : (ref5 = item.firstImagesblock) === null || ref5 === void 0 ? void 0 : ref5.ctaLabel).toLowerCase(),
                                            internalLinkURL: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    }
                                } : undefined,
                                imageCTA: item.firstImagesblock.ctaLabel ? {
                                    href: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink),
                                    target: item.firstImagesblock.ctaNewTab ? "_blank" : "_self",
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref6 = item.firstImagesblock) === null || ref6 === void 0 ? void 0 : ref6.firstImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref7 = item.firstImagesblock) === null || ref7 === void 0 ? void 0 : ref7.ctaLabel).toLowerCase(),
                                            internalLinkURL: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    }
                                } : undefined
                            },
                            ...((ref8 = item.secondImagesblock) === null || ref8 === void 0 ? void 0 : ref8.secondImageFileReference) ? [
                                {
                                    image: {
                                        src: item.secondImagesblock.secondImageFileReference || "",
                                        alt: item.secondImagesblock.altText || "",
                                        "data-mode": "smartcrop",
                                        reveal: "default",
                                        loading: "blank",
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref9 = item.secondImagesblock) === null || ref9 === void 0 ? void 0 : ref9.secondImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref10 = item.secondImagesblock) === null || ref10 === void 0 ? void 0 : ref10.ctaLabel).toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    },
                                    imageOrientation: ((ref11 = item.appliedCssClassNames) === null || ref11 === void 0 ? void 0 : ref11.includes("landscape")) ? "landscape" : "portrait",
                                    caption: {
                                        text: item.secondImagesblock.secondImageTitle ? (0,textUtils/* sanitizeText */.o)(item.secondImagesblock.secondImageTitle) : ""
                                    },
                                    CTA: item.secondImagesblock.ctaLabel ? {
                                        text: item.secondImagesblock.ctaLabel,
                                        href: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink),
                                        target: item.secondImagesblock.ctaNewTab ? "_blank" : "_self",
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref12 = item.secondImagesblock) === null || ref12 === void 0 ? void 0 : ref12.secondImageTitle), " > ").concat(item === null || item === void 0 ? void 0 : (ref13 = item.secondImagesblock) === null || ref13 === void 0 ? void 0 : ref13.ctaLabel).toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    } : undefined,
                                    imageCTA: item.secondImagesblock.ctaLabel ? {
                                        href: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink),
                                        target: item.secondImagesblock.ctaNewTab ? "_blank" : "_self",
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat((0,textUtils/* sanitizeText */.o)(item === null || item === void 0 ? void 0 : (ref14 = item.secondImagesblock) === null || ref14 === void 0 ? void 0 : ref14.secondImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref15 = item.secondImagesblock) === null || ref15 === void 0 ? void 0 : ref15.ctaLabel).toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    } : undefined
                                }
                            ] : []
                        ]
                    }
                };
            }),
            showMenuDelay: parseInt(transitionDelay) || 0,
            menuCTA: {
                onClick: ()=>(0,helper/* removeMavenoidChat */.N9B)()
            },
            closeCTA: {
                onClick: ()=>(0,helper/* addMavenoidChat */.dVG)()
            },
            variant: "v2.1",
            searchText: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? searchHeader : "",
            searchCTA: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
                onClick: ()=>{
                    handleSearchClick();
                },
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "internal search",
                        eventName: "internal search",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "internal search magnifying glass button",
                        internalLinkPosition: "global header",
                        internalLinkType: "global navigation",
                        internalLinkZoneName: "global header",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true"
                    })
                }
            } : {}
        } : undefined,
        utilityBar: {
            mod: "charcoal",
            ...path === "/checkout" ? {} : {
                languagePicker: {
                    languagePickerCTA: {
                        onClick: ()=>{},
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "country select",
                                eventName: "country select",
                                eventType: "click",
                                internalLinkName: "".concat(currentCountry.toLowerCase(), " - ").concat(currentLanguage.toLowerCase()),
                                internalLinkPosition: "global header",
                                internalLinkType: "global header : navigation",
                                internalLinkURL: "n/a",
                                internalLinkZoneName: "home:global header"
                            })
                        }
                    },
                    location: currentCountry,
                    currentLanguage: currentLanguage,
                    secondLanguageCTA: Object.keys(secondLanguageCTA).length === 0 ? undefined : secondLanguageCTA
                },
                isLoggedIn: isAuth,
                userName: "".concat(firstName),
                userCTA: {
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": !isAuth ? JSON.stringify({
                            clickInternalLinks: "true",
                            eventAction: "sign in start",
                            eventMsg: "n/a",
                            eventName: "sign in start",
                            eventStatus: "n/a",
                            eventType: "global header",
                            internalLinkName: "sign in start",
                            internalLinkPosition: "global header:sign in start",
                            internalLinkType: "global header:navigation",
                            internalLinkURL: "n/a",
                            internalLinkZoneName: "global header"
                        }) : JSON.stringify({
                            clickInternalLinks: "true",
                            eventAction: "global header:your kohler account",
                            eventMsg: "n/a",
                            eventName: "global header:your kohler account",
                            eventStatus: "n/a",
                            eventType: "navigation",
                            internalLinkName: "your kohler account",
                            internalLinkPosition: "global header:my account",
                            internalLinkType: "global header: welcome back to your kohler",
                            internalLinkURL: "n/a",
                            internalLinkZoneName: "global header"
                        })
                    }
                },
                userCTAMobile: {
                    signInCTA: {
                        text: i18n.signIn,
                        onClick: ()=>{
                            onclicksignIN();
                        },
                        component: "button"
                    },
                    signUpCTA: {
                        text: i18n.createAccount,
                        onClick: ()=>{
                            onClickCreateAccount();
                        },
                        component: "button"
                    },
                    accountCTA: {
                        text: "".concat(language === "fr" ? "Bonjour" : "Hi", ", ").concat(firstName),
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "global header:your kohler account",
                                eventMsg: "n/a",
                                eventName: "global header:your kohler account",
                                eventStatus: "n/a",
                                eventType: "navigation",
                                internalLinkName: "your kohler account",
                                internalLinkPosition: "global header:my account",
                                internalLinkType: "global header: welcome back to your kohler",
                                internalLinkURL: "n/a",
                                internalLinkZoneName: "global header"
                            })
                        }
                    }
                },
                ...isAuth ? {} : {
                    utilityLinksMobile: [
                        {
                            text: ((ref2 = loggedOutCtaArray[0]) === null || ref2 === void 0 ? void 0 : ref2.text) || "",
                            href: ((ref3 = loggedOutCtaArray[0]) === null || ref3 === void 0 ? void 0 : ref3.href) || "",
                            component: "a",
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: "true",
                                    eventAction: "my account:".concat((ref4 = loggedOutCtaArray[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.text) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                                    eventName: "my account:".concat((ref6 = loggedOutCtaArray[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.text) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()),
                                    eventMsg: "n/a",
                                    eventStatus: "n/a",
                                    eventType: "global header",
                                    internalLinkName: (ref8 = loggedOutCtaArray[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.text) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase(),
                                    internalLinkPosition: "global header:".concat((ref10 = loggedOutCtaArray[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.text) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()),
                                    internalLinkType: "global header:navigation",
                                    internalLinkURL: ((ref12 = loggedOutCtaArray[0]) === null || ref12 === void 0 ? void 0 : ref12.href) && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref13 = loggedOutCtaArray[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.href) === null || ref14 === void 0 ? void 0 : ref14.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                                    internalLinkZoneName: "global header"
                                })
                            }
                        }
                    ]
                },
                locationPickerCTA: {
                    text: findStoreLabel,
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            eventAction: dataLayerTitle,
                            eventMsg: "n/a",
                            eventName: dataLayerTitle,
                            eventStatus: "n/a",
                            eventType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A),
                            internalLinkName: dataLayerTitle,
                            internalLinkPosition: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":").concat(dataLayerTitle),
                            internalLinkType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":navigation"),
                            internalLinkZoneName: "".concat(constant/* GLOBAL_HEADER_TEXT */.A),
                            internalLinkURL: "n/a",
                            clickInternalLinks: "true"
                        })
                    }
                },
                favoritesCTA: {
                    text: language === "fr" ? isSaveProductToList ? "Mes Listes" : "Favoris" : isSaveProductToList ? "My List" : "Favorites",
                    onClick: (e)=>favClickHandler(e, favoritesPagePath),
                    isFilled: isAuth && (lineItems && lineItems.length > 0 || favoritesPage && favoritesPage.length > 0) ? true : false,
                    component: "a",
                    href: isAuth ? favoritesPagePath : ""
                }
            },
            cartBadgeCTA: cartBadgeCTA,
            brands: path === "/checkout" ? [
                {
                    text: "KOHLER",
                    href: "https://www.kohler.com",
                    target: "_blank",
                    isActive: "true"
                }
            ] : brandSwitcherArray
        },
        languageMenu: {
            mod: "charcoal",
            heading: {
                text: languageMenuTitle
            },
            copy: {
                text: (0,textUtils/* sanitizeText */.o)(languageMenuDescription)
            },
            currentCounty: currentCountry,
            regions: regions
        },
        ...path === "/checkout" ? {} : {
            loginMenu: {
                mod: "charcoal",
                headingSignIn: {
                    text: "".concat(i18n.welcome, " ").concat(firstName, "!")
                },
                headingSignOut: {
                    text: i18n.title
                },
                isLoggedIn: isAuth,
                userName: "".concat(firstName),
                loggedOutCTAs: [
                    {
                        text: i18n.signIn,
                        onClick: ()=>{
                            onclicksignIN();
                        },
                        component: "button"
                    },
                    {
                        text: i18n.createAccount,
                        onClick: ()=>{
                            onClickCreateAccount();
                        },
                        component: "button"
                    },
                    {
                        text: ((ref15 = loggedOutCtaArray[0]) === null || ref15 === void 0 ? void 0 : ref15.text) || "",
                        href: ((ref16 = loggedOutCtaArray[0]) === null || ref16 === void 0 ? void 0 : ref16.href) || "",
                        component: "a",
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "my account:".concat((ref17 = loggedOutCtaArray[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.text) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase()),
                                eventName: "my account:".concat((ref19 = loggedOutCtaArray[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.text) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase()),
                                eventMsg: "n/a",
                                eventStatus: "n/a",
                                eventType: "global header",
                                internalLinkName: (ref21 = loggedOutCtaArray[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.text) === null || ref22 === void 0 ? void 0 : ref22.toLowerCase(),
                                internalLinkPosition: "global header:".concat((ref23 = loggedOutCtaArray[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.text) === null || ref24 === void 0 ? void 0 : ref24.toLowerCase()),
                                internalLinkType: "global header:navigation",
                                internalLinkURL: ((ref25 = loggedOutCtaArray[0]) === null || ref25 === void 0 ? void 0 : ref25.href) && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref26 = loggedOutCtaArray[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.href) === null || ref27 === void 0 ? void 0 : ref27.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                                internalLinkZoneName: "global header"
                            })
                        }
                    }
                ],
                loggedInCTAs: loggedInCtaArray,
                signOutCTA: {
                    text: i18n.logout,
                    onClick: ()=>{
                        onClickSignOut();
                    },
                    component: "button"
                }
            }
        }
    };
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(68064);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/MainMenu.hook.mjs

const useStickyNavigation = function(mainMenuHeight) {
    let isAlwaysSticky = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [showStickyNav, setShowStickyNav] = (0,react.useState)(false);
    const [isSticky, setIsSticky] = (0,react.useState)(false);
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const [scrollDelta, setScrollDelta] = (0,react.useState)(0);
    const [hasHiddenOnce, setHasHiddenOnce] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollY = window.scrollY;
            const isScrollingUp = scrollY < lastScrollY;
            const hasScrolledPastThreshold = scrollY > window.innerHeight * 0.25;
            const hasScrolledPastMainMenu = scrollY > mainMenuHeight + (isAlwaysSticky ? 0 : 120);
            if (!isAlwaysSticky) {
                if (!isScrollingUp) {
                    setScrollDelta((prev)=>prev + (scrollY - lastScrollY));
                } else {
                    setScrollDelta(0);
                }
            }
            if (hasScrolledPastMainMenu) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
            if (isAlwaysSticky) {
                setShowStickyNav(true);
            }
            if (scrollDelta > 100 && !isAlwaysSticky) {
                setShowStickyNav(false);
                setHasHiddenOnce(true);
            }
            if (isScrollingUp && hasScrolledPastThreshold && hasHiddenOnce && !isAlwaysSticky) {
                setShowStickyNav(true);
            }
            setLastScrollY(scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, [
        lastScrollY,
        mainMenuHeight,
        scrollDelta,
        hasHiddenOnce
    ]);
    return {
        showStickyNav,
        isSticky
    };
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/MainMenu.module.css.mjs
var classes = {
    "mainMenu": "Ru7bK",
    "mainNavigationBarWrapper": "vuxGF",
    "showBackgroundRelative": "y2K8q",
    "fixedNav": "xizDn",
    "showSticky": "qoAOZ"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.module.css.mjs
var BrandLogo_module_css_classes = {
    "root": "iUo1k"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/AnnSacks.mjs

const AnnSacksLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "27",
    viewBox: "0 0 100 27",
    fill: "none",
    "aria-label": "Ann Sacks Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34446 26.0693V14.5146H3.44459V26.0693H1.23364V14.4812H0V12.227H1.23364V3.91159C1.23364 1.95797 2.86782 0.355 4.90254 0.355C6.93725 0.355 8.57143 1.94127 8.57143 3.91159V26.0693H6.34446ZM4.8865 2.60917C4.08543 2.60917 3.44457 3.24368 3.44457 4.01176V12.1769H6.34444V4.01176C6.34444 3.24368 5.68756 2.60917 4.8865 2.60917Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7344 25.9852H62.5827V16.2632H59.7638V25.9852H57.6121V16.2295H56.5112V14.1102H57.6121V8.2568C57.6121 6.42341 59.1967 4.92642 61.1649 4.92642C63.1332 4.92642 64.7178 6.42341 64.7178 8.2568L64.7344 25.9852ZM61.265 7.0794C60.481 7.0794 59.8638 7.66811 59.8638 8.39137V14.0934H62.6828V8.39137C62.6828 7.66811 62.0489 7.0794 61.265 7.0794Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M18.5474 5.01053V17.4238L15.2447 5.01053H13.1431V25.9684H15.3115V13.2692L18.6308 25.9684H20.7158V5.01053H18.5474Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M30.4237 5.01053V17.4238L27.1211 5.01053H25.0194V25.9684H27.1878V13.2692L30.4904 25.9684H32.5754V5.01053H30.4237Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M70.856 15.5063V22.6043C70.856 23.3276 71.4898 23.9163 72.2571 23.9163C73.0411 23.9163 73.6582 23.3276 73.6582 22.6043V18.8198H75.81V22.7389C75.81 24.5723 74.2087 26.0693 72.2571 26.0693C70.2889 26.0693 68.7043 24.5723 68.7043 22.7389V8.27362C68.7043 6.44023 70.2889 4.94325 72.2571 4.94325C74.2254 4.94325 75.81 6.44023 75.81 8.27362V12.2095H73.6749V8.40819C73.6749 7.68492 73.0411 7.09622 72.2738 7.09622C71.4898 7.09622 70.8727 7.68492 70.8727 8.40819L70.856 15.5063Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M89.5877 9.43421C89.5877 11.0321 90.2382 12.4114 91.5726 14.1775C93.9745 17.3397 94.5583 18.1638 94.5583 20.3505V22.6043C94.5583 23.3276 93.9245 23.9163 93.1572 23.9163C92.3733 23.9163 91.7561 23.3276 91.7561 22.6043V19.8122H89.6044V22.7221C89.6044 24.5555 91.2057 26.0525 93.1572 26.0525C95.1255 26.0525 96.7101 24.5555 96.7101 22.7221V20.3505C96.7101 18.147 96.4265 17.4238 95.2923 15.5735C94.8568 14.8546 94.3273 14.1822 93.8114 13.5271C92.7463 12.1746 91.7394 10.896 91.7394 9.43421V8.39136C91.7394 7.6681 92.3733 7.0794 93.1405 7.0794C93.9245 7.0794 94.5417 7.6681 94.5417 8.39136V9.97245H96.6934V8.2568C96.6934 6.42341 95.1088 4.92642 93.1405 4.92642C91.1723 4.92642 89.5877 6.42341 89.5877 8.2568V9.43421Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4112 25.9515V24.6227H98.9283C99.0784 24.6227 99.1952 24.6564 99.2619 24.7237C99.3286 24.7909 99.362 24.875 99.362 24.9928C99.362 25.0432 99.3453 25.1105 99.3286 25.1442C99.312 25.1946 99.2953 25.2283 99.2619 25.2619C99.2286 25.2955 99.1952 25.3124 99.1618 25.3292C99.1285 25.346 99.0784 25.3628 99.0284 25.3628L99.4287 25.9515H99.2286L98.8616 25.3628H98.578V25.9515H98.4112ZM98.9452 25.2283C98.9848 25.2283 99.0139 25.2177 99.0492 25.205C99.0584 25.2017 99.0682 25.1981 99.0786 25.1946C99.112 25.1778 99.1453 25.161 99.162 25.1274C99.1787 25.0937 99.1954 25.0433 99.1954 24.9928C99.1954 24.9592 99.1954 24.9087 99.162 24.8751C99.1504 24.8516 99.1306 24.8363 99.1141 24.8235C99.1069 24.818 99.1003 24.8129 99.0953 24.8078C99.0619 24.791 99.0286 24.7741 98.9952 24.7741C98.9785 24.7741 98.9577 24.7699 98.9369 24.7657C98.916 24.7615 98.8951 24.7573 98.8784 24.7573H98.5782V25.2283H98.9452Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.844 26.6407C99.4807 26.6407 100 26.1214 100 25.4847C100 24.8481 99.4807 24.3288 98.844 24.3288C98.2073 24.3288 97.6879 24.8481 97.6879 25.4847C97.6879 26.1214 98.2073 26.6407 98.844 26.6407ZM97.8052 25.4512C97.822 24.8816 98.2744 24.446 98.8441 24.4628C99.3802 24.4795 99.8159 24.9151 99.8326 25.4512C99.8494 26.0041 99.4137 26.4732 98.8441 26.4899H98.7938C98.2241 26.4732 97.7885 26.0208 97.8052 25.4512Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M49.3148 2.63343C48.3095 2.63343 47.4885 3.38732 47.4885 4.3255L47.455 5.79978C47.455 7.60959 48.6695 9.19028 49.9535 10.8616C50.5713 11.6656 51.2051 12.4906 51.7276 13.3722C53.0681 15.6506 53.4199 16.5386 53.4199 19.2526V22.4859C53.4199 24.5466 51.5601 26.2219 49.2813 26.2219C47.0026 26.2219 45.1427 24.5466 45.1427 22.4859V18.6159H47.455V22.2681C47.455 23.2063 48.276 23.9602 49.2813 23.9602C50.2867 23.9602 51.1077 23.2063 51.1077 22.2681V19.3196C51.1077 16.6391 50.4207 15.6339 47.522 11.7472C45.9135 9.58599 45.1427 7.84366 45.1427 5.88354V4.09096C45.1427 2.03032 47.0026 0.355 49.2981 0.355C51.5936 0.355 53.4534 2.03032 53.4534 4.09096V6.55367H51.1412V4.3255C51.1412 3.40408 50.3202 2.63343 49.3148 2.63343Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M86.3446 5.28043L84.8533 14.9973C85.7414 15.6004 86.3278 16.5721 86.3111 17.661V26.1549H84.1496V17.7783C84.1496 17.0579 83.5297 16.4715 82.7422 16.4715H81.6866V26.1549H79.5084V5.28043H81.6866V14.3439H82.0887C82.4908 14.3271 82.8092 14.0758 82.8594 13.7575L84.1161 5.28043H86.3446Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Kallista.mjs

const KallistaLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "20",
    viewBox: "0 0 120 20",
    fill: "none",
    "aria-label": "Kallista Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.0913V1.42895H1.56745V9.70491L9.47533 1.42895H11.5541L3.26383 9.87454L11.9481 19.0913H9.64267L1.56745 10.1274V19.0913H0Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7169 19.0913L20.0385 12.974H27.1958L29.4334 19.0913H31.1688L23.7966 0.389999L16.1038 19.0913H17.7169ZM23.6892 3.76242L26.6812 11.5762H20.577L23.6892 3.76242Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3636 19.6108V0.909476H37.9742V18.0219H44.1558V19.6108H36.3636Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3506 19.6108V0.909476H50.9615V18.0219H57.1428V19.6108H49.3506Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9352 19.0913H66.4936V1.42895H64.9352V19.0913Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2856 16.0683L75.6446 15.305C75.896 16.2068 76.3294 16.9053 76.9471 17.4018C77.5631 17.8982 78.3028 18.146 79.1678 18.146C80.2592 18.146 81.1113 17.8039 81.724 17.1202C82.3368 16.4362 82.6433 15.4904 82.6433 14.2805C82.6433 13.3971 82.438 12.6623 82.0256 12.0782C81.6134 11.4942 80.728 10.8187 79.3691 10.0515C77.6317 9.07567 76.4756 8.21654 75.9025 7.47374C75.3285 6.73159 75.0415 5.83906 75.0415 4.79548C75.0415 3.49464 75.4571 2.43462 76.289 1.61687C77.1208 0.799281 78.1993 0.389999 79.5251 0.389999C80.3926 0.389999 81.1476 0.583561 81.7903 0.970196C82.433 1.35634 82.9553 1.93523 83.3572 2.70802L82.1128 3.49758C81.8614 2.96349 81.5067 2.55519 81.0474 2.27527C80.5882 1.99503 80.044 1.85491 79.4167 1.85491C78.5687 1.85491 77.8936 2.12114 77.3907 2.65246C76.888 3.18491 76.6374 3.90262 76.6374 4.80689C76.6374 6.09632 77.6342 7.29729 79.6285 8.41141C79.9899 8.61263 80.264 8.76806 80.4531 8.87576C81.9277 9.73326 82.9132 10.5432 83.4096 11.3046C83.9068 12.0658 84.1558 13.0535 84.1558 14.2681C84.1558 15.9078 83.7015 17.2082 82.7961 18.17C81.889 19.1303 80.656 19.6108 79.0967 19.6108C77.9608 19.6108 76.9898 19.3149 76.1831 18.7222C75.3745 18.1302 74.7424 17.2458 74.2856 16.0683Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2426 19.0913V2.9296H89.3508V1.42895H100.779V2.9296H95.8441V19.0913H94.2426Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.432 19.0913L105.753 12.974H112.91L115.148 19.0913H116.883L109.511 0.389999L101.818 19.0913H103.432ZM109.404 3.76242L112.396 11.5762H106.292L109.404 3.76242Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.747 17.9782V17.6071H118.991C119.115 17.6071 119.249 17.6346 119.249 17.783C119.249 17.967 119.113 17.9782 118.961 17.9782H118.747ZM118.747 18.1322H118.953L119.265 18.6514H119.465L119.129 18.1239C119.302 18.102 119.436 18.0085 119.436 17.7941C119.436 17.5575 119.297 17.4533 119.018 17.4533H118.568V18.6514H118.747V18.1322ZM118.963 19.0913C119.522 19.0913 120 18.6514 120 18.0499C120 17.4533 119.522 17.0134 118.963 17.0134C118.399 17.0134 117.922 17.4533 117.922 18.0499C117.922 18.6514 118.399 19.0913 118.963 19.0913ZM118.129 18.0499C118.129 17.5575 118.494 17.1867 118.963 17.1867C119.427 17.1867 119.794 17.5575 119.794 18.0499C119.794 18.5499 119.427 18.9183 118.963 18.9183C118.494 18.9183 118.129 18.5499 118.129 18.0499Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Klafs.mjs

const KlafsLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "82",
    height: "24",
    viewBox: "0 0 82 24",
    fill: "none",
    "aria-label": "Klafs Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.76 1.51999H15.88L7.80004 10.56L16.36 21.12H11L4.20004 12.32V21.12H0.0400391V1.51999H4.20004V9.75999L10.76 1.51999ZM22.44 17.84H29.4V21.12H18.36V1.51999H22.44V17.84ZM59.8 4.79999V9.11999H66.84V12.48H59.8V21.12H55.72V1.51999H66.92V4.79999H59.8ZM79.32 5.83999C78.52 4.87999 77.56 4.23999 76.12 4.23999C74.76 4.23999 73.56 5.19999 73.56 6.47999C73.56 9.75999 81.96 8.39999 81.96 14.96C81.96 18.88 79.32 21.68 75 21.68C72.04 21.68 69.96 20.08 68.44 17.84L71.08 15.44C71.64 16.96 73.16 18.32 74.92 18.32C76.6 18.32 77.64 16.96 77.64 15.44C77.64 13.44 75.64 12.8 73.96 12.24C71.24 11.2 69.24 9.91999 69.24 6.87999C69.24 3.59999 71.88 0.959991 75.48 0.959991C77.4 0.959991 79.96 1.83999 81.24 3.11999L79.32 5.83999ZM54.36 21.12H49.32L42.44 8.95999L35.4 21.12H30.36L42.2 1.03999C42.2 1.03999 50.2 14.24 54.36 21.12Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M46.92 23.04H37.8L42.2 15.12L46.92 23.04Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KlafsSaunaAndSpa.mjs

const KlafsSaunaAndSpaLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "82",
    height: "32",
    viewBox: "0 0 82 32",
    fill: "none",
    "aria-label": "Klafs Sauna and Spa Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.76 0.839999H15.88L7.80004 9.88L16.36 20.44H11L4.20004 11.64V20.44H0.0400391V0.839999H4.20004V9.08L10.76 0.839999ZM22.44 17.16H29.4V20.44H18.36V0.839999H22.44V17.16ZM59.8 4.12V8.44H66.84V11.8H59.8V20.44H55.72V0.839999H66.92V4.12H59.8ZM79.32 5.16C78.52 4.2 77.56 3.56 76.12 3.56C74.76 3.56 73.56 4.52 73.56 5.8C73.56 9.08 81.96 7.72 81.96 14.28C81.96 18.2 79.32 21 75 21C72.04 21 69.96 19.4 68.44 17.16L71.08 14.76C71.64 16.28 73.16 17.64 74.92 17.64C76.6 17.64 77.64 16.28 77.64 14.76C77.64 12.76 75.64 12.12 73.96 11.56C71.24 10.52 69.24 9.24 69.24 6.2C69.24 2.92 71.88 0.279999 75.48 0.279999C77.4 0.279999 79.96 1.16 81.24 2.44L79.32 5.16ZM54.36 20.44H49.32L42.44 8.28L35.4 20.44H30.36L42.2 0.359999C42.2 0.359999 50.2 13.56 54.36 20.44Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M46.92 22.36H37.8L42.2 14.44L46.92 22.36Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M1.00004 26.84L2.60004 30.52L4.20004 26.84L5.08004 31.48H4.60004L4.04004 28.52L2.60004 31.64L1.24004 28.52L0.680039 31.48H0.120039L1.00004 26.84ZM6.92004 27.16H7.48004L8.60004 29.08L9.72004 27.16H10.28L8.84004 29.64V31.48H8.36004V29.64L6.92004 27.16ZM17.64 27.96C17.48 27.64 17.24 27.48 16.92 27.48C16.52 27.48 16.2 27.72 16.2 28.12C16.2 28.52 16.6 28.68 16.92 28.84L17.24 29C17.8 29.24 18.28 29.56 18.28 30.2C18.28 31 17.64 31.56 16.92 31.56C16.2 31.56 15.72 31.08 15.56 30.44L16.04 30.28C16.12 30.76 16.44 31.08 16.92 31.08C17.4 31.08 17.8 30.68 17.8 30.2C17.8 29.72 17.4 29.48 17 29.32L16.76 29.24C16.28 29 15.8 28.76 15.8 28.12C15.8 27.48 16.36 27 17 27C17.48 27 17.88 27.24 18.12 27.64L17.64 27.96ZM22.12 28.04L21.4 29.8H22.84L22.12 28.04ZM21.16 30.28L20.6 31.48H20.04L22.04 26.92L24.04 31.48H23.48L23 30.28H21.16ZM26.6 29.72C26.6 30.04 26.6 30.44 26.76 30.68C26.92 30.92 27.32 31.08 27.64 31.08C27.96 31.08 28.28 30.92 28.52 30.68C28.76 30.44 28.76 30.04 28.76 29.64V27.08H29.24V29.88C29.24 30.36 29.24 30.76 28.84 31.08C28.52 31.4 28.12 31.56 27.64 31.56C27.24 31.56 26.84 31.4 26.52 31.08C26.12 30.68 26.12 30.28 26.12 29.8V27.08H26.6V29.72ZM31.72 31.48H32.2V28.12L35.64 31.72V27.16H35.16V30.52L31.72 26.92V31.48ZM39.8 28.04L39.08 29.8H40.52L39.8 28.04ZM38.84 30.28L38.28 31.48H37.72L39.72 26.92L41.72 31.48H41.16L40.68 30.28H38.84ZM48.92 28.04L48.2 29.8H49.64L48.92 28.04ZM48.04 30.28L47.48 31.48H46.92L48.92 26.92L50.92 31.48H50.36L49.88 30.28H48.04ZM53.08 31.48H53.56V28.12L57 31.72V27.16H56.44V30.52L53.08 26.92V31.48ZM60.36 31.08C60.92 31.08 61.32 31 61.72 30.6C62.04 30.28 62.28 29.8 62.28 29.32C62.28 28.84 62.12 28.36 61.72 28.04C61.32 27.72 60.92 27.64 60.36 27.64H60.04V31.08H60.36ZM60.28 27.16C60.92 27.16 61.48 27.24 61.96 27.72C62.44 28.12 62.68 28.76 62.68 29.4C62.68 30.04 62.44 30.6 61.96 31C61.4 31.48 60.92 31.56 60.2 31.56H59.4V27.16H60.28ZM70.28 27.96C70.12 27.64 69.88 27.48 69.56 27.48C69.16 27.48 68.84 27.72 68.84 28.12C68.84 28.52 69.24 28.68 69.56 28.84L69.88 29C70.44 29.24 70.92 29.56 70.92 30.2C70.92 31 70.28 31.56 69.56 31.56C68.84 31.56 68.36 31.08 68.2 30.44L68.68 30.28C68.76 30.76 69.08 31.08 69.56 31.08C70.04 31.08 70.44 30.68 70.44 30.2C70.44 29.72 70.04 29.48 69.64 29.32L69.4 29.24C68.92 29 68.44 28.76 68.44 28.12C68.44 27.48 69 27 69.64 27C70.12 27 70.52 27.24 70.76 27.64L70.28 27.96ZM73.72 29.16H74.04C74.6 29.16 75 29 75 28.36C75 27.64 74.44 27.56 73.88 27.56H73.72V29.16ZM73.24 31.48V27.08H73.96C74.36 27.08 74.76 27.08 75.08 27.32C75.4 27.56 75.56 27.96 75.56 28.28C75.56 28.6 75.4 29 75.16 29.24C74.84 29.48 74.52 29.56 74.12 29.56H73.8V31.48H73.24ZM78.76 28.04L78.04 29.8H79.48L78.76 28.04ZM77.8 30.28L77.32 31.48H76.76L78.76 26.92L80.76 31.48H80.2L79.72 30.28H77.8Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Kohler.mjs

const KohlerLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "98",
    height: "22",
    viewBox: "0 0 98 22",
    fill: "none",
    "aria-label": "Kohler Brand Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4246 21.0039V0.938011H58.8226V15.8755L64.8821 15.8759V21.0039H53.4246Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8363 21.0039V0.938011H41.2343V7.97396H46.6772V0.938011H52.0751V21.0039H46.6772V13.5395H41.2343V21.0039H35.8363Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4953 0.940677L9.69605 10.4966L18.6075 21.0111L11.4631 21.0073L5.40994 13.8491H5.39757L5.39794 21.0039H0V0.938011H5.39757V6.94837L5.35558 6.95332L10.4967 0.940677H17.4953Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7559 15.9475C27.2873 15.9475 29.3401 13.6431 29.3401 10.8005C29.3401 7.95796 27.2873 5.65352 24.7559 5.65352C22.2241 5.65352 20.1714 7.95796 20.1714 10.8005C20.1714 13.6431 22.2241 15.9475 24.7559 15.9475ZM14.5714 10.8043C14.5714 5.03086 19.1312 0.35 24.7559 0.35C30.3803 0.35 34.9401 5.03086 34.9401 10.8043C34.9401 16.5778 30.3803 21.2587 24.7559 21.2587C19.1312 21.2587 14.5714 16.5778 14.5714 10.8043Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9492 0.938011V5.56098L71.5295 5.57317L71.51 8.7402H76.5169V13.2322H71.5175L71.5216 16.2945H76.996V21.0039H65.9913V0.938011H76.9492Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0033 9.45236C86.0537 9.45236 86.9054 8.5871 86.9054 7.51962C86.9054 6.45214 86.0537 5.58688 85.0033 5.58688H83.4739V9.44741L85.0033 9.45236ZM88.1716 12.9854L93.7885 21.0149L87.8946 21.0043L83.4923 14.8439V20.9925H78.2034V0.930394H84.9704C90.9242 0.930394 94.7028 8.51931 88.1716 12.9854Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4177 19.6858C96.6243 19.6858 96.7412 19.6401 96.7412 19.4025C96.7412 19.2105 96.5028 19.2105 96.3233 19.2105H95.9233V19.6858H96.4177ZM97.0741 20.7636H96.6243L96.2108 19.9688H95.9233V20.7636H95.5095V18.8819H96.4087C96.8357 18.8819 97.1277 18.9596 97.1277 19.4569C97.1277 19.8046 96.9527 19.9459 96.6243 19.9688L97.0741 20.7636ZM97.5775 19.8454C97.5775 19.0323 96.9841 18.4569 96.2198 18.4569C95.442 18.4569 94.8621 19.0323 94.8621 19.8454C94.8621 20.6493 95.442 21.2248 96.2198 21.2248C96.9841 21.2248 97.5775 20.6493 97.5775 19.8454ZM94.4396 19.8454C94.4396 18.8362 95.2261 18.0276 96.2198 18.0276C97.2091 18.0276 98 18.8362 98 19.8454C98 20.8458 97.2091 21.6543 96.2198 21.6543C95.2261 21.6543 94.4396 20.8458 94.4396 19.8454Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KohlerBold.mjs

const KohlerBoldLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "98",
    height: "30",
    viewBox: "0 0 98 30",
    fill: "none",
    "aria-label": "Kohler Bold Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9814 5.36964C41.9814 2.40469 39.5681 0 36.5922 0C33.6163 0 31.2029 2.40469 31.2029 5.36964C31.2029 8.33413 33.6163 10.7389 36.5922 10.7389C39.5681 10.7389 41.9814 8.33413 41.9814 5.36964ZM36.5922 0.64506C39.2104 0.64506 41.3338 2.76106 41.3338 5.36964C41.3338 7.97801 39.2104 10.0938 36.5922 10.0938C33.9738 10.0938 31.8504 7.97801 31.8504 5.36964C31.8504 2.76106 33.9738 0.64506 36.5922 0.64506Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.819 10.6262V0.11249H25.5315C25.612 0.111594 25.6926 0.110724 25.7733 0.109634C26.6821 0.0973585 27.6022 0.0849306 28.474 0.346039C30.3015 1.11194 30.5372 4.00614 28.8571 5.06623C29.6825 5.36063 30.5079 5.89079 30.8025 6.77423C31.4215 8.33499 30.331 10.1903 28.7098 10.5142C27.7738 10.663 26.8376 10.6475 25.9016 10.632C25.7782 10.6299 25.6548 10.6279 25.5315 10.6262H24.819ZM25.5315 0.758649V4.85992C25.7873 4.85164 26.048 4.86049 26.3094 4.86936C26.9499 4.8911 27.5941 4.91296 28.1792 4.68328C29.6825 4.09424 29.6529 1.61243 28.1792 0.994175C27.5252 0.768675 26.8367 0.767402 26.1533 0.766138C25.9452 0.765753 25.7375 0.765369 25.5315 0.758649ZM27.3984 10.0024C26.7655 10.0064 26.1125 10.0025 25.5315 9.97978C25.5315 9.57693 25.5289 9.1737 25.5263 8.7703C25.5193 7.68271 25.5123 6.59331 25.5559 5.50784C25.8781 5.5244 26.205 5.52474 26.5332 5.52509C27.376 5.52596 28.2278 5.52685 29.0339 5.80247C30.4194 6.30296 30.6552 8.39387 29.5647 9.30675C28.9729 9.88144 28.198 9.99711 27.3984 10.0024Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M6.21947 0.10524H0V0.766119H2.77086V10.6262H3.48331V0.766119H6.21947V0.10524Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9556 21.1252C46.9556 16.624 43.3237 12.9745 38.8454 12.9745C34.3669 12.9745 30.735 16.624 30.735 21.1252C30.735 25.6264 34.3669 29.2759 38.8454 29.2759C43.3237 29.2759 46.9556 25.6264 46.9556 21.1252ZM38.8454 17.1184C40.8502 17.1184 42.476 18.9124 42.476 21.1251C42.476 23.3379 40.8502 25.132 38.8454 25.132C36.8405 25.132 35.2146 23.3379 35.2146 21.1251C35.2146 18.9124 36.8405 17.1184 38.8454 17.1184Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M47.5744 13.4455H51.9074V18.908H56.1814V13.4455H60.5144V29.0985H56.1814V23.225H51.9074V29.0985H47.5744V13.4455Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M61.6346 13.4455H65.9676V25.0605H70.7427V29.0985H61.6346V13.4455Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M80.3813 13.4455H71.627V29.0985H80.3813V25.501H75.9599V23.0488H80.3813V19.4512H75.9599V17.043H80.3813V13.4455Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.687 13.4455H81.354V29.0985H85.687V24.485C85.8575 24.7193 86.0281 24.9543 86.1989 25.1895C87.1499 26.4993 88.1081 27.8191 89.1063 29.0985H93.7634L93.6069 28.8782L93.6063 28.8774C92.1856 26.8782 90.7648 24.8788 89.3125 22.9022C90.5211 22.0253 91.6118 20.8854 91.9064 19.3948C92.555 16.852 90.5505 14.1922 88.0745 13.666C87.285 13.52 86.4876 13.4633 85.687 13.4455ZM85.687 20.1183V17.0642C85.8082 17.0709 85.9311 17.0744 86.0544 17.0779C86.6788 17.0955 87.3125 17.1134 87.7799 17.5535C88.3989 18.0796 88.3989 19.1901 87.7503 19.6871C87.3303 20.1257 86.7275 20.12 86.1414 20.1146C85.9876 20.1131 85.8349 20.1117 85.687 20.1183Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M30.2204 16.8629C29.1033 18.2064 27.9856 19.5507 26.8823 20.9049L33.9566 29.0985H28.2381L23.4334 23.491V29.0985H19.1006V13.4455H23.4334V18.0659L27.5399 13.4519H33.0427C32.1089 14.5914 31.1669 15.7244 30.2249 16.8574L30.2216 16.8614L30.2204 16.8629Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M6.77438 10.6262V0.11249H7.48692V4.53234H13.8487V0.11249H14.5612V10.6262H13.8487V5.19322H7.48692V10.6262H6.77438Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M15.6813 0.11249V10.6262H20.7217V9.96546H16.3939V5.19322H20.7217V4.53234H16.3939V0.773369H20.7217V0.11249H15.6813Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M42.6813 0.11249V10.6262H47.6924V9.96546H43.3938V0.11249H42.6813Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3407 0.11249V10.6262H49.0534V10.6171C50.7516 10.6526 52.5691 10.6442 53.9119 9.48278C56.4467 7.47905 56.3878 3.14752 53.8234 1.2029C52.5017 0.11037 50.7635 0.113101 49.1192 0.115685L49.0534 0.115786V0.11249H48.3407ZM49.0534 9.98494V0.760846L49.1339 0.760809C50.6102 0.76002 52.2918 0.759122 53.4697 1.82159C55.5329 3.44215 55.6509 6.91924 53.735 8.71664C52.535 10.0039 50.6667 10.0421 49.0534 9.98494Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M60.0723 0.11249V10.6262H65.0833V9.96546H60.785V0.11249H60.0723Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M86.4469 10.6262V0.11249H87.1596V4.83971L91.9452 0.11249H92.9559L87.841 5.16619L93.2915 10.6262H92.284L87.1596 5.4907V10.6262H86.4469Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M11.7611 13.3868V23.9005H12.4736V18.4821H15.9034V17.8213H12.4736V14.0476H15.9761V13.3868H11.7611Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66602 13.2795C8.64188 13.2795 11.0553 15.6843 11.0553 18.649C11.0553 21.6136 8.64188 24.0184 5.66602 24.0184C2.69006 24.0184 0.276681 21.6136 0.276681 18.649C0.276681 15.6843 2.69006 13.2795 5.66602 13.2795ZM10.4077 18.649C10.4077 16.0404 8.28431 13.9246 5.66602 13.9246C3.04754 13.9246 0.92428 16.0404 0.92428 18.649C0.92428 21.2575 3.04754 23.3733 5.66602 23.3733C8.28431 23.3733 10.4077 21.2575 10.4077 18.649Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9126 0C71.8885 0 74.3021 2.40469 74.3021 5.36964C74.3021 8.33413 71.8885 10.7389 68.9126 10.7389C65.9367 10.7389 63.5234 8.33413 63.5234 5.36964C63.5234 2.40469 65.9367 0 68.9126 0ZM73.6544 5.36964C73.6544 2.76106 71.531 0.64506 68.9126 0.64506C66.2944 0.64506 64.171 2.76106 64.171 5.36964C64.171 7.97801 66.2944 10.0938 68.9126 10.0938C71.531 10.0938 73.6544 7.97801 73.6544 5.36964Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7566 5.36964C85.7566 2.40469 83.3433 0 80.3674 0C77.3915 0 74.9782 2.40469 74.9782 5.36964C74.9782 8.33413 77.3915 10.7389 80.3674 10.7389C83.3433 10.7389 85.7566 8.33413 85.7566 5.36964ZM80.3674 0.64506C82.9858 0.64506 85.1092 2.76106 85.1092 5.36964C85.1092 7.97801 82.9858 10.0938 80.3674 10.0938C77.749 10.0938 75.6256 7.97801 75.6256 5.36964C75.6256 2.76106 77.749 0.64506 80.3674 0.64506Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0743 29.2173H96.7662L96.515 28.5551H96.1053V29.2173H95.8138V27.6065H96.515C96.71 27.6065 96.8535 27.6503 96.945 27.7382C97.0368 27.8257 97.0824 27.9392 97.0824 28.0785C97.0824 28.2856 96.9854 28.4278 96.7909 28.5056L97.0743 29.2173ZM96.1053 28.3227H96.4678C96.5726 28.3227 96.6509 28.3009 96.7025 28.2566C96.7536 28.2127 96.7792 28.1519 96.7792 28.0749C96.7792 28.0041 96.7541 27.9469 96.7036 27.9033C96.6531 27.8595 96.5823 27.8377 96.4914 27.8377H96.1053V28.3227Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5332 27.2889C97.2447 27.0016 96.8463 26.8238 96.4061 26.8238C95.9659 26.8238 95.5672 27.0016 95.279 27.2889C94.9906 27.5762 94.812 27.9734 94.812 28.4118C94.812 28.8504 94.9906 29.2475 95.279 29.5348C95.5672 29.8221 95.9659 30 96.4061 30C96.8463 30 97.2447 29.8221 97.5332 29.5348C97.8216 29.2475 98 28.8504 98 28.4118C98 27.9734 97.8216 27.5762 97.5332 27.2889ZM96.4061 27.1351C96.7598 27.1351 97.0802 27.2781 97.3122 27.5092C97.544 27.7401 97.6875 28.0594 97.6875 28.4118C97.6875 28.7644 97.544 29.0836 97.3122 29.3146C97.0802 29.5456 96.7598 29.6885 96.4061 29.6885C96.0522 29.6885 95.7318 29.5456 95.5 29.3146C95.268 29.0836 95.1247 28.7644 95.1247 28.4118C95.1247 28.0594 95.268 27.7401 95.5 27.5092C95.7318 27.2781 96.0522 27.1351 96.4061 27.1351Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KohlerLuxStore.mjs

const KohlerLuxStoreLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    width: "304",
    height: "30",
    viewBox: "0 0 304 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Kohler Lux Store Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M75.9474 28.2555V0.774122H83.6053V21.211H92.2105V28.2555H75.9474Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M50.9211 28.2555V0.774122H58.5789V10.3732H66.3158V0.774122H73.9737V28.2555H66.3158V18.0371H58.5789V28.2555H50.9211Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M24.8684 0.774122L13.7368 13.8568L26.4474 28.3329L16.2632 28.2555L7.65789 18.5015V28.2555H0V0.774122H7.65789V8.97982H7.57895L14.9211 0.774122H24.8684Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M20.6842 14.3213C20.6842 6.42522 27.1579 0 35.1316 0C43.1053 0 49.5789 6.42522 49.5789 14.3213C49.5789 22.2173 43.1053 28.6425 35.1316 28.6425C27.1579 28.6425 20.6842 22.2173 20.6842 14.3213ZM35.1316 21.3658C38.7632 21.3658 41.6842 18.1919 41.6842 14.3213C41.6842 10.4507 38.7632 7.27675 35.1316 7.27675C31.5 7.27675 28.5789 10.4507 28.5789 14.3213C28.6579 18.1919 31.5789 21.3658 35.1316 21.3658Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M109.342 0.774122V7.12193H101.684L101.605 11.457H108.789V17.65H101.605L101.684 21.8303H109.421V28.2555H93.7895V0.774122H109.342Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M125.289 17.2629L133.263 28.2555H124.895L118.658 19.8175V28.2555H111.158V0.774122H120.789C129.237 0.774122 134.605 11.1474 125.289 17.2629ZM120.789 12.4634C122.289 12.4634 123.474 11.3022 123.474 9.83135C123.474 8.36052 122.289 7.19934 120.789 7.19934H118.579V12.4634H120.789Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M134.211 26.7072C134.211 25.3138 135.316 24.23 136.737 24.23C138.158 24.23 139.263 25.3138 139.263 26.7072C139.263 28.1006 138.158 29.1844 136.737 29.1844C135.395 29.1844 134.211 28.1006 134.211 26.7072ZM138.711 26.7072C138.711 25.6235 137.842 24.7719 136.816 24.7719C135.711 24.7719 134.921 25.546 134.921 26.7072C134.921 27.791 135.711 28.5651 136.816 28.5651C137.842 28.6425 138.711 27.791 138.711 26.7072ZM138 27.9458H137.368L136.816 26.862H136.421V27.9458H135.789V25.3912H137.053C137.684 25.3912 138.079 25.4686 138.079 26.1653C138.079 26.6298 137.842 26.862 137.368 26.862L138 27.9458ZM137.053 26.475C137.368 26.475 137.526 26.3976 137.526 26.0879C137.526 25.8557 137.211 25.8557 136.895 25.8557H136.342V26.475H137.053Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M298.784 27.5228C298.784 26.1294 299.889 25.0456 301.31 25.0456C302.732 25.0456 303.837 26.1294 303.837 27.5228C303.837 28.9162 302.732 30 301.31 30C299.968 30 298.784 28.9162 298.784 27.5228ZM303.284 27.5228C303.284 26.439 302.416 25.5875 301.389 25.5875C300.284 25.5875 299.495 26.3616 299.495 27.5228C299.495 28.6066 300.284 29.3807 301.389 29.3807C302.416 29.4581 303.284 28.6066 303.284 27.5228ZM302.574 28.7614H301.942L301.389 27.6776H300.995V28.7614H300.363V26.2068H301.626C302.258 26.2068 302.653 26.2842 302.653 26.9809C302.653 27.4454 302.416 27.6776 301.942 27.6776L302.574 28.7614ZM301.626 27.2906C301.942 27.2906 302.1 27.2132 302.1 26.9035C302.1 26.6713 301.784 26.6713 301.468 26.6713H300.916V27.2906H301.626Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M294.653 18.1145V19.1611H277.985C277.985 24.5954 280.818 27.695 285.375 27.695C289.193 27.695 291.245 25.5615 292.107 22.945L294.365 23.267C293.257 26.9302 290.137 29.7077 285.334 29.7077C279.176 29.7077 275.522 25.2395 275.522 18.7585C275.522 12.3178 279.135 7.97037 285.169 7.97037C291.04 7.97037 294.653 12.0361 294.653 18.1145ZM285.21 9.98308C281.105 9.98308 278.355 12.6801 278.026 17.3899H292.354C291.984 12.8009 289.48 9.98308 285.21 9.98308Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M266.815 7.93011C271.413 7.93011 274.122 10.6272 274.122 15.2161V29.2247H271.659V15.6589C271.659 12.0763 269.894 10.0636 266.322 10.0636C262.71 10.0636 259.466 12.1971 259.466 17.8327V29.2247H257.003V8.45342H259.302V12.4789C260.616 9.62079 263.243 7.93011 266.815 7.93011Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M245.712 29.748C239.759 29.748 235.777 25.4005 235.777 18.839C235.777 12.1568 239.841 7.93011 245.753 7.93011C251.582 7.93011 255.646 12.1166 255.646 18.7585C255.646 25.32 251.541 29.748 245.712 29.748ZM245.712 27.695C250.31 27.695 253.183 24.1526 253.183 18.7585C253.183 13.3242 250.31 9.98308 245.712 9.98308C241.114 9.98308 238.24 13.4047 238.24 18.839C238.24 24.2734 241.155 27.695 245.712 27.695Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M231.341 10.2649V24.4747C231.341 26.4069 232.08 27.1717 234.01 27.1717H236.637V29.2247H233.353C230.315 29.2247 228.878 27.8158 228.878 24.7564V10.2649L225.224 10.3454V8.45342L228.878 8.53393V2.2945H231.341V8.53393L236.678 8.45342V10.3454L231.341 10.2649Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M214.87 29.7882C207.809 29.7882 203.786 26.6886 203.211 20.3285H205.592C206.085 25.4408 209.369 27.7353 214.952 27.7353C220.576 27.7353 223.491 25.4408 223.491 21.6568C223.491 18.5975 221.603 16.8666 217.046 15.9407L212.119 14.9746C207.357 14.0085 204.237 11.9555 204.237 7.72884C204.237 3.09959 207.891 0 214.418 0C220.658 0 224.681 2.97882 225.051 8.2924H222.67C222.341 4.22671 219.263 2.01272 214.336 2.01272C209.451 2.01272 206.618 4.10595 206.618 7.56782C206.618 10.2649 208.425 11.875 212.448 12.7204L217.99 13.8072C223.163 14.8539 225.913 17.3094 225.913 21.5361C225.913 26.2458 222.465 29.7882 214.87 29.7882Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M203.874 29.2247H200.836L193.775 19.8857L186.673 29.2247H183.676L192.502 18.2352L184.661 8.45342H187.658L193.775 16.5445L199.851 8.45342H202.848L195.089 18.2352L203.874 29.2247Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M181.156 8.45342H183.62V29.2247H181.28V25.1992C179.966 28.0573 177.38 29.748 173.767 29.748C169.169 29.748 166.501 27.0509 166.501 22.4619V8.45342H168.964V22.0191C168.964 25.6018 170.729 27.6145 174.26 27.6145C177.913 27.6145 181.156 25.481 181.156 19.8454V8.45342Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M149.621 27.0912H165.96V29.2247H147.158V0.563562H149.621V27.0912Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KohlerWalkInBath.mjs

const KohlerWalkInBathLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    width: "338",
    height: "30",
    viewBox: "0 0 338 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Kohler Walk in Bath Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M75.9474 29.0451V0.795756H83.6053V21.8037H92.2105V29.0451H75.9474Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M50.9211 29.0451V0.795756H58.5789V10.6631H66.3158V0.795756H73.9737V29.0451H66.3158V18.5411H58.5789V29.0451H50.9211Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M24.8684 0.795756L13.7368 14.244L26.4474 29.1247L16.2632 29.0451L7.6579 19.0186V29.0451H0V0.795756H7.6579V9.23077H7.57895L14.9211 0.795756H24.8684Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M20.6842 14.7215C20.6842 6.60477 27.1579 0 35.1316 0C43.1053 0 49.579 6.60477 49.579 14.7215C49.579 22.8382 43.1053 29.443 35.1316 29.443C27.1579 29.443 20.6842 22.8382 20.6842 14.7215ZM35.1316 21.9629C38.7632 21.9629 41.6842 18.7003 41.6842 14.7215C41.6842 10.7427 38.7632 7.48011 35.1316 7.48011C31.5 7.48011 28.5789 10.7427 28.5789 14.7215C28.6579 18.7003 31.5789 21.9629 35.1316 21.9629Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M109.342 0.795756V7.32095H101.684L101.605 11.7772H108.789V18.1432H101.605L101.684 22.4403H109.421V29.0451H93.7895V0.795756H109.342Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M125.289 17.7454L133.263 29.0451H124.895L118.658 20.3714V29.0451H111.158V0.795756H120.789C129.237 0.795756 134.605 11.4589 125.289 17.7454ZM120.789 12.8117C122.289 12.8117 123.474 11.618 123.474 10.1061C123.474 8.59416 122.289 7.40053 120.789 7.40053H118.579V12.8117H120.789Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M134.211 27.4536C134.211 26.0212 135.316 24.9072 136.737 24.9072C138.158 24.9072 139.263 26.0212 139.263 27.4536C139.263 28.8859 138.158 30 136.737 30C135.395 30 134.211 28.8859 134.211 27.4536ZM138.711 27.4536C138.711 26.3395 137.842 25.4642 136.816 25.4642C135.711 25.4642 134.921 26.2599 134.921 27.4536C134.921 28.5676 135.711 29.3634 136.816 29.3634C137.842 29.443 138.711 28.5676 138.711 27.4536ZM138 28.7268H137.368L136.816 27.6127H136.421V28.7268H135.789V26.1008H137.053C137.684 26.1008 138.079 26.1804 138.079 26.8965C138.079 27.374 137.842 27.6127 137.368 27.6127L138 28.7268ZM137.053 27.2149C137.368 27.2149 137.526 27.1353 137.526 26.817C137.526 26.5782 137.211 26.5782 136.895 26.5782H136.342V27.2149H137.053Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M145.421 1.51194H147.158L154.342 27.5332H154.421L161.763 1.51194H163.895L171.316 27.5332H171.395L178.5 1.51194H180.316L172.421 29.3634H170.526L162.947 3.02387H162.868L155.368 29.3634H153.474L145.421 1.51194Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M193.263 25.3846C192.947 26.0212 192.632 26.5782 192.158 27.0557C191.684 27.6127 191.211 28.0902 190.579 28.4881C189.947 28.8859 189.237 29.2042 188.447 29.443C187.658 29.6817 186.789 29.7613 185.842 29.7613C183.711 29.7613 182.053 29.2838 180.947 28.4085C179.763 27.4536 179.211 26.1008 179.211 24.1114C179.211 22.9178 179.447 21.9629 179.921 21.2467C180.395 20.5305 180.947 19.8939 181.658 19.496C182.368 19.0981 183.158 18.7798 184.026 18.5411C184.895 18.382 185.684 18.2228 186.553 18.1432L188.684 18.0637C189.711 17.9841 190.579 17.8249 191.211 17.6658C191.842 17.5066 192.237 17.2679 192.553 16.9496C192.868 16.6313 193.026 16.2334 193.105 15.8355C193.184 15.3581 193.184 14.8011 193.184 14.0849C193.184 13.5279 193.105 13.0504 192.868 12.5729C192.632 12.0955 192.316 11.6976 191.921 11.2997C191.447 10.9019 190.895 10.6631 190.184 10.4244C189.474 10.1857 188.605 10.1061 187.658 10.1061C185.842 10.1061 184.421 10.5836 183.316 11.4589C182.211 12.3342 181.658 13.687 181.5 15.4377H180C180.079 13.2095 180.789 11.5385 182.132 10.504C183.395 9.38992 185.289 8.83289 187.658 8.83289C190.026 8.83289 191.763 9.31034 192.868 10.2653C193.974 11.2202 194.526 12.4934 194.526 14.0053V26.4987C194.526 26.817 194.605 27.0557 194.684 27.2944C194.763 27.5332 194.921 27.6923 195.079 27.8515C195.237 28.0106 195.553 28.0902 195.868 28.0902C196.105 28.0902 196.5 28.0902 196.974 28.0106V29.2042C196.579 29.2838 196.184 29.3634 195.789 29.3634C195.158 29.3634 194.763 29.2838 194.368 29.1247C194.053 28.9655 193.737 28.7268 193.579 28.4881C193.421 28.2493 193.263 27.931 193.184 27.5332C193.105 27.2149 193.105 26.817 193.105 26.4191V25.3846H193.263ZM193.263 17.9841C192.868 18.4615 192.316 18.7003 191.605 18.8594C190.895 19.0186 190.026 19.0981 189.158 19.1777L186.711 19.4164C186 19.496 185.289 19.5756 184.579 19.7347C183.868 19.8939 183.237 20.1326 182.605 20.4509C182.053 20.7692 181.579 21.2467 181.184 21.8037C180.789 22.3607 180.632 23.1565 180.632 24.1114C180.632 25.6233 181.105 26.6578 182.053 27.374C183 28.0902 184.263 28.4085 185.842 28.4085C187.5 28.4085 188.842 28.0902 189.789 27.4536C190.737 26.817 191.526 26.1804 192 25.3846C192.553 24.5889 192.868 23.7931 192.947 23.0769C193.105 22.3607 193.184 21.8037 193.184 21.565V17.9841H193.263Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M200.763 1.51194V29.3634H199.263V1.51194H200.763Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M204.868 1.51194H206.368V19.9735L218.605 9.31034H220.737L212.053 16.7904L221.368 29.3634H219.395L210.947 17.9841L206.447 21.8037V29.3634H204.947V1.51194H204.868Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M221.053 18.0638H229.342V19.5758H221.053V18.0638Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M233.211 1.51194H234.947V29.3634H233.211V1.51194Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M240.789 9.31034V13.6074H240.868C241.105 12.8912 241.5 12.1751 241.974 11.618C242.447 11.061 243 10.504 243.632 10.1061C244.263 9.70822 244.974 9.38992 245.684 9.15119C246.395 8.91247 247.184 8.83289 247.974 8.83289C249.158 8.83289 250.105 8.99204 250.895 9.23077C251.684 9.54907 252.395 9.86737 252.868 10.3448C253.421 10.8223 253.816 11.2997 254.053 11.9363C254.368 12.4934 254.526 13.13 254.684 13.687C254.842 14.3236 254.921 14.8806 254.921 15.4377V29.2838H253.421V16.6313C253.421 16.1538 253.421 15.5172 253.342 14.7215C253.263 14.0053 253.026 13.2095 252.632 12.5729C252.237 11.8568 251.684 11.2997 250.895 10.8223C250.105 10.3448 249.079 10.1061 247.737 10.1061C246.632 10.1061 245.605 10.3448 244.737 10.7427C243.868 11.1406 243.079 11.6976 242.526 12.4934C241.895 13.2095 241.421 14.0849 241.105 15.1194C240.789 16.1538 240.632 17.2679 240.632 18.4615V29.2838H239.132V9.31034H240.789Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M281.368 1.51194C283.026 1.51194 284.368 1.75066 285.474 2.14854C286.579 2.54642 287.447 3.10345 288.158 3.81963C288.789 4.45623 289.342 5.25199 289.579 6.12732C289.895 7.00265 290.053 7.87798 290.053 8.75331C290.053 9.46949 289.895 10.1857 289.658 10.9019C289.421 11.5385 289.026 12.1751 288.553 12.7321C288.079 13.2891 287.526 13.687 286.816 14.0053C286.184 14.3236 285.395 14.5623 284.605 14.7215L284.684 14.8011C284.842 14.8011 285.316 14.8806 285.947 15.0398C286.579 15.1989 287.289 15.5968 288.079 16.0743C288.789 16.5517 289.5 17.2679 290.053 18.1432C290.605 19.0186 290.921 20.2122 290.921 21.565C290.921 22.8382 290.684 23.9523 290.211 24.9072C289.737 25.8621 289.105 26.6578 288.237 27.374C287.368 28.0106 286.421 28.5676 285.237 28.8859C284.053 29.2042 282.711 29.3634 281.289 29.3634H270.237V1.51194H281.368ZM281.368 14.1645C283.737 14.1645 285.474 13.6074 286.658 12.5729C287.842 11.5385 288.395 10.1061 288.395 8.43501C288.395 7.40053 288.237 6.60477 287.842 5.88859C287.447 5.17241 286.974 4.61538 286.263 4.21751C285.632 3.81963 284.842 3.50133 284.053 3.2626C283.184 3.10345 282.316 3.02387 281.368 3.02387H271.974V14.1645H281.368ZM281.368 27.8515C283.816 27.8515 285.789 27.2944 287.211 26.2599C288.632 25.2255 289.342 23.6339 289.342 21.4854C289.342 20.2918 289.105 19.3369 288.632 18.5411C288.158 17.7454 287.526 17.1883 286.737 16.7109C285.947 16.2334 285.158 15.9947 284.211 15.756C283.263 15.5968 282.316 15.5172 281.447 15.5172H272.053V27.7719H281.368V27.8515Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M307.184 25.3846C306.868 26.0212 306.553 26.5782 306.079 27.0557C305.605 27.6127 305.132 28.0902 304.5 28.4881C303.868 28.8859 303.158 29.2042 302.368 29.443C301.579 29.6817 300.711 29.7613 299.763 29.7613C297.632 29.7613 295.974 29.2838 294.868 28.4085C293.684 27.4536 293.132 26.1008 293.132 24.1114C293.132 22.9178 293.368 21.9629 293.842 21.2467C294.316 20.5305 294.868 19.8939 295.579 19.496C296.289 19.0981 297.079 18.7798 297.947 18.5411C298.816 18.382 299.605 18.2228 300.474 18.1432L302.763 17.9841C303.789 17.9045 304.658 17.7454 305.289 17.5862C305.921 17.4271 306.316 17.1883 306.632 16.87C306.947 16.5517 307.105 16.1538 307.184 15.756C307.263 15.2785 307.263 14.7215 307.263 14.0053C307.263 13.4483 307.184 12.9708 306.947 12.4934C306.711 12.0159 306.395 11.618 306 11.2202C305.526 10.8223 304.974 10.5836 304.263 10.3448C303.553 10.1061 302.684 10.0265 301.737 10.0265C299.921 10.0265 298.5 10.504 297.395 11.3793C296.289 12.2546 295.737 13.6074 295.579 15.3581H294.079C294.158 13.13 294.868 11.4589 296.211 10.4244C297.474 9.31034 299.368 8.75331 301.737 8.75331C304.105 8.75331 305.842 9.23077 306.947 10.1857C308.053 11.1406 308.605 12.4138 308.605 13.9257V26.4191C308.605 26.7374 308.684 26.9761 308.763 27.2149C308.842 27.4536 309 27.6127 309.158 27.7719C309.316 27.931 309.632 28.0106 309.947 28.0106C310.184 28.0106 310.579 28.0106 311.053 27.931V29.2042C310.658 29.2838 310.263 29.3634 309.868 29.3634C309.237 29.3634 308.842 29.2838 308.447 29.1247C308.132 28.9655 307.816 28.7268 307.658 28.4881C307.5 28.2493 307.342 27.931 307.263 27.5332C307.184 27.2149 307.184 26.817 307.184 26.4191V25.3846ZM307.184 17.9841C306.789 18.4615 306.237 18.7003 305.526 18.8594C304.816 19.0186 303.947 19.0981 303.079 19.1777L300.632 19.4164C299.921 19.496 299.211 19.5756 298.5 19.7347C297.789 19.8939 297.158 20.1326 296.526 20.4509C295.974 20.7692 295.5 21.2467 295.105 21.8037C294.711 22.3607 294.553 23.1565 294.553 24.1114C294.553 25.6233 295.026 26.6578 295.974 27.374C296.921 28.0902 298.184 28.4085 299.763 28.4085C301.421 28.4085 302.763 28.0902 303.711 27.4536C304.658 26.817 305.447 26.1804 305.921 25.3846C306.474 24.5889 306.789 23.7931 306.868 23.0769C307.026 22.3607 307.105 21.8037 307.105 21.565V17.9841H307.184Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M315.395 10.5836V24.5889C315.395 25.3846 315.474 26.0212 315.632 26.4987C315.789 26.9761 316.105 27.2944 316.5 27.5332C316.895 27.7719 317.289 27.931 317.842 28.0106C318.395 28.0902 318.947 28.0902 319.658 28.0106V29.2838C318.947 29.3634 318.158 29.3634 317.447 29.2838C316.737 29.2042 316.105 29.0451 315.553 28.7268C315 28.4085 314.605 27.931 314.289 27.2944C313.974 26.6578 313.816 25.7825 313.895 24.5889V10.5836H310.263V9.31034H313.974V3.10345H315.474V9.31034H319.816V10.5836H315.395Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M323.368 13.6074H323.447C323.684 12.8912 324.079 12.1751 324.553 11.618C325.026 11.061 325.579 10.504 326.211 10.1061C326.842 9.70822 327.553 9.38992 328.263 9.15119C328.974 8.91247 329.763 8.83289 330.553 8.83289C331.737 8.83289 332.684 8.99204 333.474 9.23077C334.263 9.54907 334.974 9.86737 335.447 10.3448C336 10.8223 336.395 11.2997 336.632 11.9363C336.947 12.4934 337.105 13.13 337.263 13.687C337.421 14.3236 337.5 14.8806 337.5 15.4377V29.2838H336V16.6313C336 16.1538 336 15.5172 335.921 14.7215C335.842 14.0053 335.605 13.2095 335.211 12.5729C334.816 11.8568 334.263 11.2997 333.474 10.8223C332.684 10.3448 331.658 10.1061 330.316 10.1061C329.211 10.1061 328.184 10.3448 327.316 10.7427C326.447 11.1406 325.658 11.6976 325.105 12.4934C324.474 13.2095 324 14.0849 323.684 15.1194C323.368 16.1538 323.211 17.2679 323.211 18.4615V29.2838H321.711V1.43236H323.368V13.6074Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Mira.mjs

const MiraLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "51",
    viewBox: "0 0 80 51",
    fill: "none",
    "aria-label": "Mira Shower Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M44.1386 35.0481C44.1007 35.0665 44.0629 35.0849 44.0061 35.1032C42.3795 35.7644 38.0669 37.0499 34.057 37.0499C29.9335 37.0499 25.0535 35.2501 22.0082 33.9095C21.1192 33.5238 17.1471 31.8894 11.5862 31.8894C7.00878 31.8894 2.6962 33.836 0.426421 35.2501L0.142699 35.4338C-0.0653639 35.5807 -0.103193 35.9847 0.426421 35.7827C2.54488 35.0114 6.25218 34.0564 10.1297 34.0564C14.6504 34.0564 20.4572 36.3704 22.0082 37.0866C23.4268 37.7477 27.607 39.4557 32.6005 39.4557C36.9888 39.4557 42.0958 36.9764 44.0061 35.6174C44.1385 35.5256 44.252 35.4338 44.3466 35.3603C44.5358 35.2318 44.479 34.9379 44.1386 35.0481Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.1968 0.154999H42.3984C43.7225 0.154999 45.7274 0.816129 45.387 3.00153L45.2735 3.53411H38.2372C37.4806 3.53411 36.6672 2.68933 36.8375 2.00984C36.932 1.60581 37.1968 0.154999 37.1968 0.154999Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M75.5372 31.9996C75.4994 32.0179 75.4616 32.0363 75.4048 32.0547C73.7781 32.7158 69.4655 34.0013 65.4556 34.0013C61.3322 34.0013 56.4522 32.2016 53.4069 30.861C52.5179 30.4753 48.5458 28.8408 42.9848 28.8408C38.4074 28.8408 34.0948 30.7875 31.8251 32.2016L31.5413 32.3852C31.3333 32.5321 31.2955 32.9362 31.8251 32.7342C33.9435 31.9628 37.6508 31.0079 41.5284 31.0079C46.049 31.0079 51.8559 33.3218 53.4069 34.0381C54.8255 34.6992 59.0057 36.4071 63.9992 36.4071C68.3874 36.4071 73.4944 33.9279 75.4048 32.5689C75.5372 32.477 75.6507 32.3852 75.7453 32.3118C75.9344 32.2016 75.8777 31.8894 75.5372 31.9996Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M29.3285 5.16857H2.96124L2.60186 7.57436L2.58295 7.70291C2.58295 8.47423 3.9259 8.60279 3.60435 10.3842L3.52869 10.8066L1.46697 22.8171L1.35348 23.4966C1.24 24.1027 1.52372 24.5251 2.05334 24.5251C3.20714 24.5434 7.17925 24.5251 7.17925 24.5251C8.10608 24.5251 8.40871 23.8639 8.46546 23.515C8.48437 23.4415 8.54112 23.2028 8.59786 22.8171C9.10856 20.0257 10.8109 10.072 10.8109 10.072H13.232C14.0453 10.072 14.4425 10.2373 14.2156 11.4677L12.2106 22.7988L12.0782 23.4783C11.9647 24.0843 12.2484 24.5067 12.778 24.5067C13.9318 24.5251 18.0553 24.5067 18.0553 24.5067C18.9821 24.5067 19.2847 23.8456 19.3415 23.4783C19.3604 23.4048 19.3982 23.1661 19.455 22.7988C19.9657 19.9522 21.6869 10.0536 21.6869 10.0536H23.9945C24.8079 10.0536 25.3753 10.1087 25.2051 11.284L23.1434 22.7988L23.0299 23.4599C22.9164 24.0659 23.2001 24.4883 23.7297 24.4883C24.8835 24.5067 28.9313 24.4883 28.9313 24.4883C29.8581 24.4883 30.1607 23.8272 30.2175 23.4599C30.2364 23.3864 30.2742 23.1477 30.331 22.7804C30.8606 19.8053 32.9034 8.25386 32.9034 8.25386C33.1493 6.72958 32.7332 5.16857 29.3285 5.16857Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M40.715 5.16857H36.1754L35.7593 7.57436L35.7404 7.68455C35.7404 8.4375 36.7618 8.63952 36.5916 10.1271L36.4781 10.8066L34.3407 22.8171L34.2272 23.4966C34.1137 24.1027 34.3974 24.5251 34.9271 24.5251C36.0809 24.5434 40.28 24.5251 40.28 24.5251C41.2068 24.5251 41.5094 23.8639 41.5662 23.4966C41.5851 23.4232 41.6418 23.1661 41.6986 22.7988C42.2849 19.7869 44.2521 8.34568 44.2521 8.34568L44.271 8.29059C44.498 6.72958 44.1007 5.16857 40.715 5.16857Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M68.0657 44.9102C68.5764 44.9102 69.106 45.0571 69.5032 45.2591L69.8248 44.1389C69.2573 43.9185 68.6332 43.845 68.0279 43.845C66.7038 43.845 65.4555 44.4694 65.4555 45.8835C65.4555 47.6833 67.8198 47.4813 67.8198 48.7117C67.8198 49.4463 67.1578 49.7585 66.4958 49.7585C65.9094 49.7585 65.342 49.5381 64.7934 49.2994L64.4341 50.4564C65.0583 50.6767 65.7392 50.842 66.4012 50.842C67.9144 50.842 69.2384 50.236 69.2384 48.5831C69.2384 46.7099 66.8741 46.7834 66.8741 45.6999C66.9119 45.0938 67.5739 44.9102 68.0657 44.9102ZM58.2678 46.8385H57.7571L58.1354 45.0204H58.7029C59.2703 45.0204 59.8945 45.0204 59.8945 45.7182C59.9134 46.6181 59.0055 46.8385 58.2678 46.8385ZM58.6083 43.9552H56.9627L55.5063 50.6951H56.8871L57.4923 47.8853H58.0219C58.7785 47.8853 58.7407 48.3811 58.892 49.0974L59.2325 50.6767H60.6889L60.0269 47.9588C59.9323 47.5915 59.7054 47.3527 59.3271 47.3343V47.316C60.462 47.2976 61.351 46.6732 61.351 45.5162C61.351 43.9369 59.8756 43.9552 58.6083 43.9552ZM47.1081 50.6951H51.2315L51.4774 49.6299H48.7348L49.132 47.7384H51.5531L51.7801 46.6732H49.359L49.7183 45.002H52.4232L52.6312 43.9369H48.5645L47.1081 50.6951ZM40.7905 49.1341H40.7716L40.7338 43.9552H38.8612L36.5536 49.1341L36.3456 43.9552H34.9648L35.3998 50.6951H37.1211L39.5611 45.2959H39.58L39.6557 50.6951H41.3958L44.687 43.9552H43.2495L40.7905 49.1341ZM26.7747 49.7585C25.7722 49.7585 25.3182 48.9688 25.3182 48.1057C25.3182 46.7467 26.1505 44.9102 27.7582 44.9102C28.7607 44.9102 29.2336 45.6631 29.2336 46.563C29.2525 47.9036 28.3635 49.7585 26.7747 49.7585ZM27.815 43.845C26.6801 43.845 25.7154 44.2674 24.9778 45.0938C24.2779 45.9019 23.8807 46.9303 23.8807 48.0138C23.8807 49.6116 24.9021 50.8237 26.6044 50.8237C27.7582 50.8237 28.8175 50.4747 29.5362 49.685C30.2739 48.877 30.69 47.7935 30.69 46.6916C30.69 44.9102 29.6875 43.845 27.815 43.845ZM18.3954 46.6916H15.596L16.1824 43.9736H14.8016L13.3451 50.7135H14.7259L15.369 47.7567H18.1684L17.5253 50.7135H18.9061L20.3625 43.9736H18.9818L18.3954 46.6916ZM5.64682 45.8835C5.64682 47.6833 8.01117 47.4813 8.01117 48.7117C8.01117 49.4463 7.34915 49.7585 6.68713 49.7585C6.10077 49.7585 5.53333 49.5381 4.9848 49.2994L4.62542 50.4564C5.24961 50.6767 5.93054 50.842 6.59256 50.842C8.10575 50.842 9.42978 50.236 9.42978 48.5831C9.42978 46.7099 7.06543 46.7834 7.06543 45.6999C7.06543 45.1122 7.72745 44.9286 8.21924 44.9286C8.72994 44.9286 9.25955 45.0755 9.65676 45.2775L9.97831 44.1572C9.41087 43.9369 8.78668 43.8634 8.1814 43.8634C6.8952 43.845 5.64682 44.4694 5.64682 45.8835Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M70.9599 18.2994C70.9031 18.9054 70.6383 19.6951 69.2008 19.64H65.3043C64.699 19.64 64.1883 19.5666 64.3775 18.7402L64.491 17.7301C64.491 17.1791 64.7558 16.8302 65.4367 16.8302H71.1679L70.9599 18.2994ZM76.483 5.16857H59.7812C58.5706 5.16857 56.2819 5.22367 55.2984 7.51927C54.9579 5.68279 53.8798 5.24203 52.0261 5.16857H47.3541L46.9191 7.68455C46.9191 8.40077 48.054 8.47423 47.8081 10.0903L45.5951 22.8171L45.4816 23.4966C45.3681 24.1027 45.6518 24.5251 46.1814 24.5251C47.3352 24.5434 51.3073 24.5251 51.3073 24.5251C52.2342 24.5251 52.5368 23.8639 52.5936 23.4966C52.6125 23.4232 52.6692 23.1661 52.726 22.7988C52.8205 22.3029 54.0689 14.9754 54.0689 14.9754C54.2959 13.3042 55.7902 10.1271 60.2162 10.072H71.5462C72.473 10.072 72.3785 10.4209 72.265 11.082L71.9434 12.7532H61.6916C60.5945 12.7532 59.0435 12.8634 58.5328 15.4896L57.4925 21.2378C57.3223 22.2478 57.2844 24.5251 60.2919 24.5251H74.2321C75.3859 24.5251 77.1639 24.4149 77.6935 21.2929L79.9444 8.69461C80.1714 7.1336 79.8309 5.22367 76.483 5.16857Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/RevealByKohler.mjs

const RevealByKohlerLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    width: "98",
    height: "36",
    viewBox: "0 0 98 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Reveal by Kohler Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.6242 0C15.0384 0 17.7417 2.21552 17.7417 5.90806C17.7417 8.31054 16.5886 10.1521 14.5091 11.0776C16.4373 11.6946 17.0612 13.1996 17.1179 15.3497C17.184 17.8737 17.3069 19.9023 18.0158 21.5289H13.7529C13.1291 20.3604 13.0724 18.7338 13.0062 15.2843C12.9778 13.4053 12.1649 12.6388 10.3312 12.6388H4.14005V21.5289H0V0H10.6242ZM4.15896 3.22513V9.46972H10.3123C12.3634 9.46972 13.6678 8.36663 13.6678 6.32873C13.6678 4.29082 12.3634 3.22513 10.3123 3.22513H4.15896Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M20.2276 13.1903C20.2276 7.7777 23.5832 4.39365 28.4038 4.39365C32.9786 4.39365 36.4003 7.59073 36.4003 13.2557V13.5642H24.1503C24.2732 17.1633 25.8895 19.0984 28.4132 19.0984C30.4643 19.0984 31.9011 17.8083 32.4588 15.2843H36.2207C35.474 19.4629 32.61 21.9309 28.3849 21.9309C23.5359 21.9309 20.2371 18.6403 20.2371 13.1996L20.2276 13.1903ZM24.3015 11.2178H32.4209C31.8916 8.60034 30.4265 7.21681 28.3754 7.21681C26.3243 7.21681 24.8025 8.62838 24.3015 11.2178Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.2416 4.82367H41.4383L43.6785 11.2552L45.8903 17.6494L48.1304 11.2552L50.399 4.82367H54.4067L48.0643 21.5289H43.584L37.2416 4.82367Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M55.2385 13.1903C55.2385 7.7777 58.594 4.39365 63.4146 4.39365C67.9895 4.39365 71.4111 7.59073 71.4111 13.2557V13.5642H59.1611C59.284 17.1633 60.9003 19.0984 63.4241 19.0984C65.4752 19.0984 66.9119 17.8083 67.4696 15.2843H71.2316C70.4848 19.4629 67.6208 21.9309 63.3957 21.9309C58.5467 21.9309 55.2479 18.6403 55.2479 13.1996L55.2385 13.1903ZM59.3124 11.2178H67.4318C66.9025 8.60034 65.4374 7.21681 63.3862 7.21681C61.3351 7.21681 59.8133 8.62838 59.3124 11.2178Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M73.4812 17.2848C73.4812 13.9942 76.969 12.8818 80.5419 11.8068C83.1886 11.0028 84.4646 10.3952 84.4646 9.16123C84.4646 7.92727 83.406 7.22616 81.4777 7.22616C79.3037 7.22616 77.867 8.46012 77.4983 10.5167H73.8309C74.3319 6.91767 77.3188 4.45909 81.5722 4.45909C85.8257 4.45909 88.3872 6.4596 88.3872 10.1802V21.5289H84.4646V19.6499C83.1886 21.0334 81.2887 21.8 79.143 21.8C75.6552 21.8 73.4812 20.0145 73.4812 17.2755V17.2848ZM80.1733 19.1544C81.7896 19.1544 83.4721 18.5094 84.4646 17.397V12.779C83.7462 13.3586 82.6309 13.7325 81.3548 14.1625C79.0863 14.901 77.3755 15.4806 77.3755 17.1446C77.3755 18.4346 78.4625 19.1451 80.1733 19.1451V19.1544Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M91.8751 3.15141e-07H95.8545V21.5289H91.8751V3.15141e-07Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M98 33.0927C98 32.6066 97.6125 32.2233 97.1115 32.2233C96.6105 32.2233 96.223 32.6066 96.223 33.0927C96.223 33.5788 96.6105 33.9621 97.1115 33.9621C97.6125 33.9621 98 33.5788 98 33.0927ZM97.8677 33.0927C97.8677 33.504 97.5179 33.8312 97.1209 33.8312C96.724 33.8312 96.3742 33.504 96.3742 33.0927C96.3742 32.6814 96.724 32.3542 97.1209 32.3542C97.5179 32.3542 97.8677 32.6814 97.8677 33.0927ZM97.5463 32.859C97.5463 32.6533 97.3762 32.6066 97.206 32.6066H96.7901V33.5601H96.9225V33.1208H97.0831L97.3762 33.5601H97.5368L97.2438 33.1208C97.414 33.1208 97.5463 33.046 97.5463 32.859ZM97.414 32.859C97.414 33.0086 97.206 32.9899 97.0831 32.9899H96.9225V32.7468H97.1777C97.2816 32.7468 97.414 32.7655 97.414 32.859ZM95.93 33.5321L93.4251 30.0452C96.3364 28.1101 94.6539 24.8102 91.9979 24.8102H88.9826V33.5134H91.3362V30.8491L93.3023 33.5227H95.93V33.5321ZM92.858 27.6801C92.858 28.1475 92.4799 28.5214 92.0073 28.5214H91.3268V26.8481H92.0073C92.4799 26.8481 92.858 27.222 92.858 27.6895M88.4533 33.5321V31.4848H86.0146V30.1574H88.2454V28.213H86.0146V26.8388H88.4344V24.8289H83.5476V33.5321H88.4533ZM77.9425 33.5321H83.0467V31.3072H80.3433V24.8289H77.9425V33.5321ZM74.9273 33.5321H77.3376V24.8289H74.9273V27.8858H72.498V24.8289H70.0877V33.5321H72.498V30.2883H74.9273V33.5321ZM69.7002 29.101C69.7002 26.5957 67.668 24.5672 65.1632 24.5672C62.6583 24.5672 60.6261 26.5957 60.6261 29.101C60.6261 31.6063 62.6583 33.6349 65.1632 33.6349C67.668 33.6349 69.7002 31.6063 69.7002 29.101ZM67.2048 29.101C67.2048 30.335 66.288 31.3353 65.1632 31.3353C64.0384 31.3353 63.1215 30.335 63.1215 29.101C63.1215 27.8671 64.0384 26.8668 65.1632 26.8668C66.288 26.8668 67.2048 27.8671 67.2048 29.101ZM58.4521 28.9702L61.9305 24.8289H58.8113L56.5428 27.4184V27.4371H56.5239L56.5428 27.4184V24.8289H54.1325V33.5321H56.5428V30.4285L59.2461 33.5321H62.4315L58.4616 28.9702H58.4521Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M44.3306 30.4191C44.3306 32.429 43.2247 33.7284 41.4666 33.7284C40.5403 33.7284 39.8597 33.3358 39.4249 32.672V33.5788H37.922V24.8476H39.4816V28.0727C39.9164 27.4558 40.5686 27.1005 41.4666 27.1005C43.2247 27.1005 44.3306 28.3999 44.3306 30.4098V30.4191ZM42.7426 30.3724C42.7426 29.0356 42.1093 28.3906 41.0979 28.3906C40.0866 28.3906 39.4533 29.0917 39.4533 30.4285C39.4533 31.7653 40.0866 32.4664 41.0979 32.4664C42.1093 32.4664 42.7426 31.7185 42.7426 30.3817V30.3724Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M49.1701 27.2594H50.8053L48.3383 34.1023C47.8279 35.5139 47.1379 36 45.5877 36C45.2947 36 45.1057 35.9907 44.9072 35.9626V34.7473H45.5026C46.2683 34.7473 46.5518 34.2612 46.5518 33.7284C46.5518 33.3451 46.4006 32.8684 46.2588 32.457L44.3967 27.2594H46.0792L46.5991 28.8393C46.9488 29.9424 47.2891 31.1296 47.6199 32.3729C47.9508 31.1202 48.3005 29.9704 48.6502 28.858L49.1701 27.2688V27.2594Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/RevealByKohlerLarge.mjs

const RevealByKohlerLargeLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    width: "115",
    height: "42",
    viewBox: "0 0 115 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Reveal by Kohler Logo Large"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M12.4672 0C17.6471 0 20.8194 2.58478 20.8194 6.89274C20.8194 9.69564 19.4662 11.8442 17.026 12.9239C19.2887 13.6437 20.0208 15.3996 20.0873 17.908C20.1649 20.8527 20.3091 23.2194 21.141 25.117H16.1386C15.4066 23.7538 15.34 21.8561 15.2624 17.8317C15.2291 15.6395 14.2752 14.7452 12.1234 14.7452H4.85822V25.117H0V0H12.4672ZM4.88041 3.76265V11.048H12.1012C14.5081 11.048 16.0388 9.76107 16.0388 7.38351C16.0388 5.00596 14.5081 3.76265 12.1012 3.76265H4.88041Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M23.7365 15.3887C23.7365 9.07398 27.6741 5.12593 33.331 5.12593C38.6994 5.12593 42.7146 8.85586 42.7146 15.465V15.8249H28.3396C28.4838 20.0238 30.3805 22.2814 33.342 22.2814C35.749 22.2814 37.4349 20.7764 38.0894 17.8317H42.5039C41.6276 22.7068 38.2668 25.586 33.3088 25.586C27.6187 25.586 23.7476 21.747 23.7476 15.3996L23.7365 15.3887ZM28.5171 13.0875H38.045C37.4238 10.0337 35.7046 8.41961 33.2977 8.41961C30.8908 8.41961 29.105 10.0664 28.5171 13.0875Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M43.7018 5.62761H48.6266L51.2554 13.1311L53.8508 20.591L56.4796 13.1311L59.1416 5.62761H63.8446L56.402 25.117H51.1444L43.7018 5.62761Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M64.8207 15.3887C64.8207 9.07398 68.7583 5.12593 74.4151 5.12593C79.7835 5.12593 83.7988 8.85586 83.7988 15.465V15.8249H69.4238C69.568 20.0238 71.4647 22.2814 74.4262 22.2814C76.8331 22.2814 78.5191 20.7764 79.1735 17.8317H83.588C82.7118 22.7068 79.351 25.586 74.3929 25.586C68.7028 25.586 64.8318 21.747 64.8318 15.3996L64.8207 15.3887ZM69.6012 13.0875H79.1291C78.508 10.0337 76.7887 8.41961 74.3818 8.41961C71.9749 8.41961 70.1891 10.0664 69.6012 13.0875Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M86.2279 20.1656C86.2279 16.3266 90.3208 15.0288 94.5135 13.7746C97.6192 12.8366 99.1166 12.1277 99.1166 10.6881C99.1166 9.24848 97.8743 8.43051 95.6116 8.43051C93.0605 8.43051 91.3745 9.87014 90.9419 12.2695H86.6383C87.2262 8.07061 90.7312 5.20227 95.7225 5.20227C100.714 5.20227 103.72 7.5362 103.72 11.8769V25.117H99.1166V22.9249C97.6192 24.539 95.3898 25.4333 92.8719 25.4333C88.779 25.4333 86.2279 23.3502 86.2279 20.1547V20.1656ZM94.0809 22.3469C95.9776 22.3469 97.952 21.5943 99.1166 20.2965V14.9088C98.2736 15.585 96.9648 16.0212 95.4674 16.5229C92.8054 17.3845 90.7977 18.0607 90.7977 20.002C90.7977 21.5071 92.0733 22.336 94.0809 22.336V22.3469Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M107.813 3.67665e-07H112.482V25.117H107.813V3.67665e-07Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M115 38.6082C115 38.041 114.545 37.5939 113.957 37.5939C113.369 37.5939 112.915 38.041 112.915 38.6082C112.915 39.1753 113.369 39.6224 113.957 39.6224C114.545 39.6224 115 39.1753 115 38.6082ZM114.845 38.6082C114.845 39.088 114.434 39.4698 113.968 39.4698C113.503 39.4698 113.092 39.088 113.092 38.6082C113.092 38.1283 113.503 37.7466 113.968 37.7466C114.434 37.7466 114.845 38.1283 114.845 38.6082ZM114.468 38.3355C114.468 38.0956 114.268 38.041 114.068 38.041H113.58V39.1535H113.736V38.6409H113.924L114.268 39.1535H114.456L114.113 38.6409C114.312 38.6409 114.468 38.5536 114.468 38.3355ZM114.312 38.3355C114.312 38.51 114.068 38.4882 113.924 38.4882H113.736V38.2046H114.035C114.157 38.2046 114.312 38.2264 114.312 38.3355ZM112.571 39.1208L109.632 35.0527C113.048 32.7952 111.073 28.9452 107.957 28.9452H104.418V39.0989H107.18V35.9907L109.487 39.1099H112.571V39.1208ZM108.966 32.2935C108.966 32.8388 108.522 33.275 107.968 33.275H107.169V31.3228H107.968C108.522 31.3228 108.966 31.7591 108.966 32.3044M103.797 39.1208V36.7323H100.936V35.1836H103.553V32.9151H100.936V31.3119H103.775V28.9671H98.0406V39.1208H103.797ZM91.4631 39.1208H97.4527V36.5251H94.2805V28.9671H91.4631V39.1208ZM87.9248 39.1208H90.7532V28.9671H87.9248V32.5334H85.0742V28.9671H82.2458V39.1208H85.0742V35.3363H87.9248V39.1208ZM81.791 33.9512C81.791 31.0283 79.4063 28.6617 76.467 28.6617C73.5276 28.6617 71.1429 31.0283 71.1429 33.9512C71.1429 36.8741 73.5276 39.2407 76.467 39.2407C79.4063 39.2407 81.791 36.8741 81.791 33.9512ZM78.8628 33.9512C78.8628 35.3908 77.7869 36.5578 76.467 36.5578C75.147 36.5578 74.0711 35.3908 74.0711 33.9512C74.0711 32.5116 75.147 31.3446 76.467 31.3446C77.7869 31.3446 78.8628 32.5116 78.8628 33.9512ZM68.5918 33.7985L72.6736 28.9671H69.0133L66.3512 31.9881V32.0099H66.329L66.3512 31.9881V28.9671H63.5228V39.1208H66.3512V35.4999L69.5235 39.1208H73.2614L68.6029 33.7985H68.5918Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M52.0206 35.489C52.0206 37.8338 50.7228 39.3498 48.6598 39.3498C47.5728 39.3498 46.7741 38.8917 46.2639 38.1174V39.1753H44.5003V28.9889H46.3305V32.7515C46.8407 32.0317 47.606 31.6173 48.6598 31.6173C50.7228 31.6173 52.0206 33.1332 52.0206 35.4781V35.489ZM50.1571 35.4345C50.1571 33.8749 49.414 33.1223 48.2272 33.1223C47.0403 33.1223 46.2972 33.9403 46.2972 35.4999C46.2972 37.0595 47.0403 37.8774 48.2272 37.8774C49.414 37.8774 50.1571 37.005 50.1571 35.4454V35.4345Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M57.6996 31.8027H59.6185L56.7235 39.786C56.1245 41.4329 55.3148 42 53.4958 42C53.1519 42 52.9301 41.9891 52.6972 41.9564V40.5386H53.396C54.2944 40.5386 54.6272 39.9714 54.6272 39.3498C54.6272 38.9026 54.4497 38.3464 54.2833 37.8665L52.0982 31.8027H54.0726L54.6826 33.6458C55.093 34.9328 55.4923 36.3179 55.8805 37.7684C56.2687 36.3069 56.6791 34.9655 57.0895 33.6676L57.6996 31.8136V31.8027Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Robern.mjs

const RobernLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "27",
    viewBox: "0 0 100 27",
    fill: "none",
    "aria-label": "Robern Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6558 16.4847H30.455V0.0400009H34.1223V8.4595C35.8623 6.97832 38.1234 6.08395 40.5961 6.08395C46.0961 6.08395 50.5493 10.5089 50.5493 15.9741C50.5493 21.4392 46.0961 25.8642 40.5961 25.8642C35.2684 25.8642 30.923 21.7122 30.6558 16.4847ZM34.3484 15.9575C34.3484 19.3918 37.1566 22.1822 40.6128 22.1822C40.6627 22.1822 40.7291 22.1822 40.7624 22.1657C44.2186 22.1327 46.9935 19.3093 46.9437 15.875C46.9104 12.4407 44.069 9.68335 40.6128 9.73288C37.1566 9.73288 34.3484 12.5232 34.3484 15.9575Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M7.75129 7.21288C8.15136 7.21288 8.56809 7.24593 8.96816 7.29552V10.601C8.5756 10.601 7.99438 10.6244 7.80962 10.6318C7.7747 10.6332 7.75394 10.634 7.75129 10.634C5.38423 10.6836 3.6006 12.5843 3.6006 15.0799V26.2193H0V15.0799C0 10.4522 3.18386 7.21288 7.75129 7.21288Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M77.913 7.21288C78.3131 7.21288 78.7298 7.24593 79.1299 7.29552V10.601C78.7373 10.601 78.1561 10.6244 77.9713 10.6318C77.9364 10.6332 77.9157 10.634 77.913 10.634C75.546 10.6836 73.7623 12.5843 73.7623 15.0799V26.2193H70.1617V15.0799C70.1617 10.4522 73.3456 7.21288 77.913 7.21288Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M79.9966 15.0138C79.9966 10.3861 83.1804 7.14677 87.7478 7.14677C92.2986 7.14677 95.4825 10.3696 95.4991 14.9973V26.1698H91.8985V14.9973C91.8985 12.5182 90.0649 10.5679 87.7478 10.5679C85.4141 10.5679 83.5972 12.5182 83.5972 14.9973V26.1863H79.9966V15.0138Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8109 21.1785C65.9276 21.0793 66.0443 20.9802 66.1443 20.881C66.1443 20.881 66.1443 25.3434 66.1276 25.3269C65.7109 25.5252 65.2942 25.707 64.8774 25.8392C61.2768 27.0127 57.3262 26.0871 54.6591 23.4427C50.7584 19.5753 50.7584 13.3115 54.6591 9.44407C58.5597 5.57667 64.8774 5.57667 68.7781 9.44407C69.0448 9.70851 69.2948 9.98948 69.5282 10.2704L69.5449 10.287L66.1276 13.6751V13.6916L58.193 21.5586C58.3263 21.6578 58.4764 21.7404 58.6264 21.8231C58.6514 21.8396 58.6764 21.852 58.7014 21.8644C58.7264 21.8768 58.7514 21.8892 58.7764 21.9057C58.8186 21.9266 58.8598 21.9476 58.9004 21.9682C59.0202 22.0291 59.1353 22.0877 59.2598 22.1371C59.4098 22.2032 59.5599 22.2693 59.7266 22.3189C59.8433 22.3685 59.9599 22.4015 60.0766 22.4346C60.0933 22.4428 60.1141 22.447 60.135 22.4511C60.1558 22.4552 60.1766 22.4594 60.1933 22.4676C60.2767 22.4842 60.3559 22.5007 60.435 22.5172C60.5142 22.5337 60.5934 22.5503 60.6767 22.5668C60.6934 22.5668 60.7142 22.5709 60.7351 22.5751C60.7559 22.5792 60.7767 22.5833 60.7934 22.5833C60.8517 22.5916 60.9142 22.5999 60.9768 22.6081C61.0393 22.6164 61.1018 22.6246 61.1601 22.6329L61.3268 22.6494C61.5935 22.666 61.8769 22.666 62.1603 22.6494C62.227 22.6329 62.277 22.6329 62.327 22.6329C62.3405 22.6314 62.3542 22.6299 62.368 22.6284C62.5069 22.6133 62.6572 22.5969 62.7937 22.5668H62.8104C62.9176 22.5562 63.018 22.5319 63.1203 22.5071C63.177 22.4933 63.2344 22.4794 63.2938 22.4676L63.4438 22.4181C63.7772 22.3189 64.094 22.2032 64.4107 22.0545C64.5274 22.0049 64.6274 21.9553 64.7441 21.8892C64.7941 21.8561 64.8274 21.8396 64.8607 21.8231L64.8941 21.8065C64.9608 21.7652 65.0233 21.7239 65.0858 21.6826C65.1483 21.6413 65.2108 21.6 65.2775 21.5586L65.3775 21.4925C65.4942 21.4264 65.5942 21.3438 65.6942 21.2611L65.8109 21.1785ZM64.4941 10.8324C62.0771 9.67545 59.1933 10.1713 57.3096 12.0389C55.426 13.9065 54.9426 16.7657 56.1094 19.1456L64.4941 10.8324Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1497 25.2938H97.783V26.1863H97.4662V24.1038H98.2664C98.7498 24.1038 98.9998 24.2856 98.9998 24.6988C98.9998 25.079 98.7498 25.2442 98.4497 25.2773L99.0498 26.2028H98.6998L98.1497 25.2938ZM97.7831 24.3848V25.0459H98.1498C98.4332 25.0459 98.6665 25.0129 98.6665 24.6988C98.6665 24.4344 98.4332 24.3848 98.2165 24.3848H97.7831Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 25.1451C100 26.2028 99.1665 26.9631 98.1664 26.9631C97.1662 26.9631 96.3161 26.2028 96.3161 25.1451C96.3161 24.1038 97.1662 23.3436 98.1664 23.3436C99.1499 23.3436 100 24.1038 100 25.1451ZM98.1663 23.6411C97.3328 23.6411 96.6827 24.2856 96.6827 25.1451C96.6827 26.021 97.3328 26.6656 98.1663 26.6491C98.9831 26.6491 99.6332 26.021 99.6332 25.1451C99.6332 24.2856 98.9831 23.6411 98.1663 23.6411Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2472 15.9741C29.2472 10.5089 24.794 6.08396 19.2939 6.08396C13.7939 6.08396 9.34068 10.5089 9.34068 15.9741C9.34068 21.4392 13.7939 25.8642 19.2939 25.8642C24.794 25.8642 29.2472 21.4392 29.2472 15.9741ZM25.5749 15.9575C25.5749 19.3918 22.7668 22.1822 19.3105 22.1822C15.8543 22.1822 13.0628 19.3918 13.0461 15.9575C13.0461 12.5233 15.8543 9.73289 19.3105 9.73289C22.7668 9.73289 25.5749 12.5233 25.5749 15.9575Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Sprig.mjs

const SprigLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "51",
    viewBox: "0 0 90 51",
    fill: "none",
    "aria-label": "Sprig Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M24.4297 43.9801C24.8075 43.9801 25.5423 43.9801 26.0934 44.4062C26.492 44.7106 26.7265 45.2377 26.7265 45.8063C26.7265 46.6792 26.1442 47.0341 25.9605 47.1351C26.41 47.2064 26.6745 47.3993 26.849 47.5613C27.2568 47.9472 27.3389 48.4744 27.3389 48.8293C27.3389 49.2255 27.2268 49.7837 26.7566 50.1995C26.2459 50.6462 25.6232 50.7473 25.0316 50.7473H22.7452V43.9789H24.4297V43.9801ZM24.0727 46.7906H24.4505C24.655 46.7906 25.4811 46.7699 25.4811 45.9074C25.4811 45.2883 25.0016 45.0551 24.4609 45.0551H24.0727V46.7906ZM24.0727 49.6723H24.6446C24.8895 49.6723 25.2569 49.6619 25.5527 49.4897C25.8797 49.2967 25.9709 48.9717 25.9709 48.7087C25.9709 48.495 25.8993 48.1298 25.4707 47.938C25.1853 47.8059 24.8479 47.8059 24.5626 47.8059H24.0727V49.6734V49.6723Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M29.0846 47.6531L26.7473 43.9801H28.3197L29.7789 46.3346L31.2381 43.9801H32.8106L30.4121 47.6531V50.7485H29.0857V47.6531H29.0846Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.8556 17.304C6.13833 16.5551 5.24988 15.5019 5.03152 13.508C4.77619 11.1776 6.6178 8.54862 10.2225 8.5693C14.2569 8.59227 15.0622 11.1547 15.8582 14.1501H19.1117L19.077 13.9675C19.0597 13.8721 19.0389 13.7779 19.0135 13.6849C18.0869 10.1589 16.1656 7.09686 10.2721 7.04058C5.45437 6.99464 1.33558 9.73392 1.33558 13.6252C1.33558 17.2167 3.64742 19.7607 9.58241 20.6773C13.5556 21.2906 16.2037 22.2496 16.2071 24.9717C16.2106 27.5157 14.6867 29.7335 10.4859 29.6796C5.34461 29.6129 4.3152 26.335 3.5261 23.2282H0C0 23.2282 0.0196408 23.335 0.0820293 23.6015C1.1357 28.3404 4.51277 31.384 10.4362 31.384C15.8062 31.384 19.8026 28.5907 19.8026 24.5502C19.8026 20.8082 17.2781 18.3503 10.8556 17.3028V17.304Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M35.0635 7.09801C34.9456 7.09801 34.8289 7.10031 34.7146 7.1049C32.2456 7.17841 30.3636 8.03752 28.9783 9.42381C26.9807 11.2224 26.1847 13.4081 26.1847 13.4081V7.64816H22.7233V38.4682H26.1847V24.9602C26.1847 24.9602 27.0627 27.4801 29.4104 29.3637C30.761 30.5077 32.5009 31.2324 34.6152 31.3633C34.6626 31.3668 34.7099 31.3691 34.7573 31.3714C34.8174 31.3748 34.8775 31.3771 34.9375 31.3794C35.0623 31.384 35.1871 31.3863 35.3142 31.3863C41.0331 31.3863 44.4945 27.0976 44.4945 19.268C44.4945 11.4384 41.1833 7.09916 35.0635 7.09916V7.09801ZM33.8596 28.3427C29.1943 28.3427 26.1847 25.0015 26.1847 20.1639V18.4181C26.1847 13.3817 29.1943 10.2393 33.8596 10.2393C38.5249 10.2393 41.0331 13.1313 41.0331 19.2657C41.0331 25.4001 38.6751 28.3415 33.8596 28.3415V28.3427Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M50.8004 13.2496V7.64701H47.4395V30.8361H50.9009V18.9165C50.9009 13.3312 53.2081 11.1363 58.3748 11.1363H59.4782V7.39663H58.525C52.4791 7.39663 50.7992 13.2485 50.7992 13.2485L50.8004 13.2496Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M82.9767 27.2458C80.3679 27.2458 77.5593 27.2952 74.8997 27.2952C73.2441 27.2952 72.3418 26.8966 72.3418 25.8492C72.3418 25.2508 72.6421 24.8017 73.0939 24.1539L73.9465 22.9066C75.1007 23.2557 76.4051 23.4051 77.8597 23.4051C84.2811 23.4051 87.5923 20.8622 87.5923 16.3231C87.5923 11.7841 82.0489 10.1887 82.0489 10.1887C84.206 10.3886 85.2342 10.4874 86.4889 10.4874H89.3484V7.64472H78.2617C72.0414 7.64472 68.3789 10.438 68.3789 15.7236C68.3789 19.005 70.023 21.4927 73.1285 22.6436C73.2325 22.6826 69.4823 24.5949 69.4823 26.7944C69.4823 28.3415 70.4585 29.2282 71.8265 29.66C71.8265 29.66 66.9244 30.626 66.9244 34.1256C66.9244 37.2175 69.5331 39.1619 78.2617 39.1619C86.9903 39.1619 90 37.1175 90 32.6784C90 29.2374 87.5414 27.2423 82.9767 27.2423V27.2458ZM71.5896 15.6765C71.5896 12.5341 73.4959 10.5402 77.8597 10.5402C82.2234 10.5402 84.4821 12.4847 84.4821 15.6765C84.4821 18.8683 82.4753 20.7634 77.9105 20.7634C73.3457 20.7634 71.5896 18.9177 71.5896 15.6765ZM78.3622 36.4227C71.741 36.4227 69.8843 35.4751 69.8843 33.1815C69.8843 31.6849 71.2384 29.9403 74.4491 29.9403H83.0275C85.8373 29.9403 87.0412 31.1876 87.0412 32.7829C87.0412 35.1765 85.4364 36.4238 78.3622 36.4238V36.4227Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M65.2341 7.64701H61.8224V30.8361H65.2341V7.64701Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M65.2341 0H61.8224V3.82351H65.2341V0Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M53.5617 50.7772V43.9364H55.4414V49.0291H57.5534V50.7772H53.5617Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M47.4326 50.7772V43.9364H49.3135V46.3358H51.2105V43.9364H53.0914V50.7772H51.2105V48.2332H49.3135V50.7772H47.4326Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M41.0424 43.9376L38.325 47.1949L41.4294 50.7806L38.9408 50.7783L36.8312 48.3388H36.8277V50.7772H34.9468V43.9364H36.8277V45.9855L36.8127 45.9877L38.6035 43.9376H41.0424Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M40.0234 47.3005C40.0234 45.3319 41.612 43.7366 43.5714 43.7366C45.5309 43.7366 47.1195 45.3319 47.1195 47.3005C47.1195 49.2691 45.5309 50.8645 43.5714 50.8645C41.612 50.8645 40.0234 49.2691 40.0234 47.3005ZM43.5714 49.0544C44.4541 49.0544 45.1681 48.2688 45.1681 47.2994C45.1681 46.33 44.4529 45.5444 43.5714 45.5444C42.6899 45.5444 41.9736 46.33 41.9736 47.2994C41.9736 48.2688 42.6887 49.0544 43.5714 49.0544Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M61.7577 43.9364V45.5123L59.8698 45.5168L59.8629 46.5965H61.6075V48.1275H59.8652L59.8664 49.1715H61.7738V50.7772H57.9393V43.9364H61.7577Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M65.6685 48.0436L67.6256 50.7818L65.5714 50.7783L64.0372 48.6776V50.7737H62.1944V43.9342H64.5524C66.6263 43.9342 67.9434 46.5218 65.6673 48.0436H65.6685ZM64.564 46.8388C64.9302 46.8388 65.2272 46.5436 65.2272 46.1796C65.2272 45.8155 64.9302 45.5203 64.564 45.5203H64.0314V46.8365H64.564V46.8388Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M67.8521 50.3832C67.8521 50.0387 68.1259 49.763 68.4725 49.763C68.8191 49.763 69.0929 50.0387 69.0929 50.3832C69.0929 50.7278 68.8168 51 68.4725 51C68.1282 51 67.8521 50.7243 67.8521 50.3832ZM68.945 50.3832C68.945 50.1064 68.7382 49.91 68.4725 49.91C68.2068 49.91 68 50.1064 68 50.3832C68 50.66 68.2022 50.853 68.4725 50.853C68.7429 50.853 68.945 50.6566 68.945 50.3832ZM68.7694 50.6968H68.6123L68.4679 50.4257H68.3674V50.6968H68.223V50.0547H68.5361C68.6851 50.0547 68.7868 50.0812 68.7868 50.2511C68.7868 50.3694 68.7255 50.4177 68.6112 50.4257L68.7683 50.6968H68.7694ZM68.5407 50.3293C68.6123 50.3293 68.6539 50.3143 68.6539 50.2328C68.6539 50.1673 68.5707 50.1673 68.5083 50.1673H68.3685V50.3293H68.5407Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Sterling.mjs

const SterlingLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "15",
    viewBox: "0 0 120 15",
    fill: "none",
    "aria-label": "Sterling Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M11.5161 3.1635C10.4365 2.38491 8.74294 1.92197 7.19758 1.92197C5.63105 1.92197 3.64113 2.36387 3.64113 3.71062C3.64113 4.95613 5.66903 5.6167 7.84937 6.32692C10.3842 7.15261 13.125 8.04541 13.125 10.0025C13.125 12.1068 10.0343 14.0638 5.7369 14.0638C4.06452 14.0638 2.37097 13.8954 0.804435 13.4745L0 11.0125C1.63004 12.0226 3.87399 12.6328 6.03327 12.6328C7.5998 12.6328 9.97077 11.9595 9.97077 10.5917C9.97077 9.1723 7.94657 8.52545 5.7685 7.82942C3.23204 7.01886 0.486895 6.14162 0.486895 3.9C0.486895 1.41693 4.04335 0.470001 7.40927 0.470001C8.78528 0.470001 10.1825 0.617302 11.5161 0.911903V3.1635Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M74.4275 3.45729C74.4472 2.55076 74.4733 1.34737 73.125 1.00278V0.938751H78.75V1.00278C77.4098 1.35056 77.4323 2.59048 77.4486 3.48724C77.4503 3.58099 77.4519 3.67099 77.4519 3.75582V11.268C77.4519 11.3527 77.4503 11.4424 77.4486 11.5357C77.4323 12.4291 77.4101 13.652 78.75 13.9997V14.0638H73.125V13.9997C74.4651 13.6713 74.4427 12.4332 74.4264 11.5366C74.4247 11.4429 74.4231 11.3529 74.4231 11.268V3.75582C74.4231 3.66161 74.4253 3.56102 74.4275 3.45729Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M22.257 11.5366L22.257 2.50025H24.7536C25.6711 2.50025 26.7807 2.58465 27.1434 3.28099H27.2288L28.125 0.938751H28.0396C27.6769 1.06536 27.2288 1.08646 26.7594 1.08646H15.7062C15.6069 1.07418 15.5058 1.06548 15.4039 1.05671C15.1556 1.03533 14.9027 1.01356 14.6607 0.938751H14.5753L13.5938 3.28099H13.6791C14.554 2.71126 15.7916 2.50025 16.9865 2.50025H19.4191V11.2995C19.4191 11.3835 19.4206 11.4725 19.4222 11.565C19.4374 12.4483 19.4583 13.6566 18.2028 14.0004V14.0638H23.708V14.0004C22.2565 13.3972 22.2567 12.6298 22.257 11.5366Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M33.8732 12.4125L37.2192 12.6454C38.9632 12.7724 40.7883 12.349 42.1064 11.4811H42.1875L40.9911 14.0638H30V14.0002C31.2258 13.6706 31.2099 12.4176 31.1985 11.5261C31.1974 11.4445 31.1964 11.3651 31.1964 11.2906V3.83895C31.1964 3.7545 31.1978 3.6655 31.1993 3.5732C31.2135 2.6707 31.2326 1.45378 30 1.10811V1.0446H38.4359C38.5177 1.0446 38.5994 1.04602 38.6805 1.04743C39.0421 1.05372 39.3914 1.05979 39.6729 0.938751H39.7541V3.24621H39.6729C38.8618 2.52645 37.7667 2.46294 36.55 2.46294C35.6172 2.46294 34.7047 2.48411 33.853 2.61113V6.31577H36.9962C37.422 6.31577 37.8479 6.31577 38.152 6.18875H38.2332V8.28452H38.152C37.7407 7.73247 36.7052 7.73336 35.8858 7.73406L33.853 7.73411L33.8732 12.4125Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M54.9929 4.16131C54.9929 2.34729 52.9688 0.960093 49.2614 0.960093L42.6562 0.938751V1.00278C43.9177 1.34737 43.8933 2.55062 43.8749 3.45715C43.8728 3.5612 43.8707 3.66134 43.8707 3.75582V11.268C43.8707 11.3599 43.8728 11.4578 43.8749 11.56C43.8933 12.4546 43.9184 13.6741 42.6562 13.9997V14.0638H47.9403V13.9997C46.6453 13.6706 46.6654 12.4458 46.6802 11.5361C46.6818 11.4431 46.6832 11.3532 46.6832 11.268V2.32595C47.3011 2.26192 47.919 2.1979 48.5582 2.17656C50.4119 2.13387 52.1378 2.96619 52.1378 4.39607C52.1378 6.27412 49.5597 7.02107 47.3438 7.25582L49.9432 10.0302L53.2884 13.0607C54.1193 13.8077 55.0355 14.0638 56.5057 14.0638H59.0625C57.4858 13.3381 55.7386 12.3138 54.5668 11.268L50.5824 7.66131C52.8622 7.29851 54.9929 5.91131 54.9929 4.16131Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M66.9893 12.6339C68.7679 12.7192 70.3242 12.2497 71.6379 11.4174H71.7188L70.3444 14.0638H59.5312V13.9997C60.753 13.6674 60.7371 12.4042 60.7258 11.5054C60.7247 11.4229 60.7237 11.3434 60.7237 11.268V3.75582C60.7237 3.67064 60.7251 3.58086 60.7266 3.48776C60.7407 2.57792 60.7597 1.35126 59.5312 1.00278V0.938751H64.5639V1.00278C63.3666 1.34755 63.3905 2.56909 63.4079 3.46389C63.4099 3.56606 63.4118 3.66397 63.4118 3.75582V12.4418L66.9893 12.6339Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M84.8946 11.3964L84.8946 3.72073L94.0683 12.2774C95.2407 13.4155 96.084 14.0688 97.9763 14.5325V3.4889C97.9763 2.37189 97.9763 1.59209 99.375 1.00198V0.938751H94.6648V1.00198C96.0639 1.58375 96.0637 2.37036 96.0635 3.44259L96.0634 10.9497L86.2727 1.845L85.9025 1.44457C85.6968 1.29704 85.594 1.19166 85.4911 0.959827V0.938751H81.5831V1.00198C82.9817 1.59209 82.9817 2.39297 82.9817 3.4889V11.3501C82.9817 12.4671 82.9817 13.2469 81.5625 13.8581V13.9213H86.2933V13.8581C84.8941 13.2555 84.8943 12.4686 84.8946 11.3964Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M115.084 3.10445C113.991 2.1982 111.949 1.92422 110.299 1.92422C106.113 1.92422 102.917 3.9264 102.917 7.10881C102.917 10.2701 106.361 12.6728 110.588 12.6728C111.826 12.6728 113.104 12.5463 114.321 12.2934V9.4482C114.321 8.54195 114.3 7.57247 113.084 7.21419V7.15096H117.188V7.21419C117.043 7.44602 117.043 7.76215 117.043 8.05721V12.5885C117.043 12.6178 117.043 12.6474 117.043 12.6771C117.041 12.946 117.039 13.2269 117.188 13.4736L117.069 13.4899C114.965 13.7794 112.899 14.0638 110.774 14.0638C103.906 14.0638 99.8438 11.3028 99.8438 7.34064C99.8438 3.10445 104.422 0.470001 110.918 0.470001C112.341 0.470001 113.743 0.596455 115.125 0.807211L115.166 3.10445H115.084Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.723 13.1874H118.887V12.7798H119.011C119.135 12.7798 119.217 12.8206 119.238 12.9632C119.258 13.1059 119.3 13.1874 119.32 13.2282H119.506C119.485 13.1874 119.464 13.1263 119.444 12.9632C119.423 12.8002 119.361 12.7186 119.258 12.6983C119.361 12.6575 119.464 12.576 119.464 12.4333C119.464 12.3314 119.423 12.2499 119.361 12.2091C119.3 12.1684 119.196 12.1276 119.032 12.1276C118.887 12.1276 118.805 12.1276 118.723 12.148V13.1874ZM119.011 12.6167H118.887V12.2499H119.011C119.196 12.2499 119.258 12.3314 119.258 12.4333C119.258 12.576 119.155 12.6167 119.011 12.6167Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 12.6575C120 12.1276 119.588 11.72 119.073 11.72C118.537 11.72 118.125 12.1276 118.125 12.6575C118.125 13.1874 118.558 13.595 119.073 13.595C119.588 13.595 120 13.1874 120 12.6575ZM118.31 12.6575C118.31 12.2091 118.661 11.8627 119.073 11.8627C119.485 11.8627 119.835 12.2091 119.835 12.6575C119.835 13.1059 119.485 13.4523 119.073 13.4523C118.661 13.4523 118.31 13.1059 118.31 12.6575Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/StudioKohlerLarge.mjs

const StudioKohlerLargeLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "173",
    height: "22",
    viewBox: "0 0 173 22",
    fill: "none",
    "aria-label": "Studio Kohler Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.635 0.35C95.1038 0.35 90.6338 4.9736 90.6338 10.6586C90.6338 16.3557 95.1158 20.9671 100.642 20.9671C106.169 20.9671 110.643 16.3394 110.643 10.6504C110.639 4.95734 106.157 0.35 100.635 0.35ZM105.14 10.6463C105.14 13.4522 103.122 15.7254 100.638 15.7254C98.158 15.7294 96.1363 13.4603 96.1363 10.6504C96.1323 7.85264 98.154 5.57947 100.634 5.57947C103.126 5.5754 105.14 7.84857 105.14 10.6463Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M1.85996 14.2167C1.77623 18.2913 4.63528 19.5397 8.19613 19.5397C10.2338 19.5397 13.336 18.4011 13.336 15.518C13.336 13.2733 11.1589 12.3827 9.34055 11.9395L5.01808 10.8578C2.73323 10.2763 0.639782 9.19458 0.639782 6.08778C0.639782 4.14806 1.86395 0.512618 7.33084 0.512618C11.1908 0.512618 14.5084 2.59059 14.5084 6.66929H12.6582C12.5226 3.67228 10.1301 2.12295 7.35476 2.12295C4.82668 2.12295 2.486 3.12331 2.486 6.05931C2.486 7.9177 3.81783 8.72286 5.42082 9.08072L10.154 10.2722C12.9014 11.0204 15.1862 12.2688 15.1862 15.4854C15.1862 16.8436 14.6439 21.1419 7.76149 21.1419C3.16787 21.1419 -0.205571 19.0355 0.00975459 14.2086H1.85996V14.2167Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M20.4615 6.42532H23.3166V7.89332H20.4615V17.5431C20.4615 18.6817 20.625 19.3446 21.8492 19.43C22.3396 19.43 22.8301 19.4015 23.3166 19.3446V20.841C23.0574 20.841 22.8062 20.8553 22.555 20.8695C22.3038 20.8837 22.0525 20.898 21.7933 20.898C19.5085 20.898 18.719 20.1213 18.7469 17.6814V7.89332H16.2985V6.42532H18.7469V2.12703H20.4615V6.42532Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M34.9763 20.7353H36.5554V6.4253H34.8407V13.9361C34.8407 16.8477 33.5647 19.678 30.6259 19.678C27.9064 19.678 26.9534 18.3198 26.8737 15.7416V6.4253H25.159V15.7172C25.159 19.0762 26.5188 21.1541 30.0796 21.1541C32.1731 21.1541 34.0233 20.0724 34.9205 18.1571H34.9763V20.7353Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4147 20.7353H50.9938V0.935533H49.2791V9.14578H49.2233C48.5135 7.0922 46.4201 6.01051 44.3545 6.01051C40.0839 6.01051 38.0463 9.50363 38.0463 13.5823C38.0463 17.661 40.0839 21.1541 44.3545 21.1541C46.3962 21.1541 48.6252 19.9057 49.3589 18.0189H49.4147V20.7353ZM49.2788 13.5783C49.2788 16.5428 47.9749 19.678 44.3582 19.678C41.0964 19.678 39.7646 16.5428 39.7646 13.5783C39.7646 10.6138 41.0964 7.47857 44.3582 7.47857C47.9749 7.47857 49.2788 10.6138 49.2788 13.5783Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M53.6861 0.935533H55.4007V3.73735H53.6861V0.935533Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M53.6861 6.4253H55.4007V20.7353H53.6861V6.4253Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0174 21.1501C68.288 21.1501 70.6526 17.6813 70.6526 13.5783C70.6526 9.47517 68.288 6.00645 64.0174 6.00645C59.7468 6.00645 57.3822 9.4711 57.3822 13.5783C57.3822 17.6854 59.7468 21.1501 64.0174 21.1501ZM64.0177 19.6779C60.7559 19.6779 59.0971 16.5996 59.0971 13.5782C59.0971 10.5568 60.7559 7.47846 64.0177 7.47846C67.2795 7.47846 68.9383 10.5568 68.9383 13.5782C68.9383 16.5996 67.2795 19.6779 64.0177 19.6779Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M128.787 0.919272L128.795 20.6987L140.048 20.6946V15.6359H134.102L134.094 0.915205L128.787 0.919272Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M111.528 20.7069L111.512 0.927442L116.816 0.923376L116.82 7.86488L122.163 7.85674L122.159 0.923376L127.463 0.919309L127.471 20.6987H122.171V13.3424L116.82 13.3506L116.828 20.7028L111.528 20.7069Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M85.8488 10.3658L93.5008 0.939642H86.6303L81.622 6.82175V0.939642L76.3226 0.943708L76.3306 20.7231H81.626L81.622 13.6718H81.634L87.5873 20.7231H94.6054L85.8488 10.3658Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M151.89 0.903043L146.443 0.915243H141.128L141.14 20.6947L151.95 20.6865L151.942 16.0426L146.567 16.0467V13.0334L151.475 13.0212L151.471 8.60091H146.551L146.575 5.47785L151.89 5.46158V0.903043Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.442 20.6865L162.92 12.7731C169.331 8.36505 165.619 0.886771 159.769 0.894904L153.126 0.89897L153.138 20.6743L158.326 20.6703V14.6112L162.644 20.6865H168.442ZM161.676 7.38502C161.676 8.43825 160.834 9.29221 159.806 9.29221L158.302 9.28814V5.48597L159.798 5.48191C160.834 5.48191 161.676 6.3318 161.676 7.38502Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.621 20.7475H171.979L171.337 19.7512C171.712 19.739 172.011 19.5845 172.011 19.1534C172.011 18.6858 171.637 18.5801 171.258 18.5801H170.325L170.329 20.7475H170.624V19.7472H170.983L171.621 20.7475ZM171.078 19.4476C171.349 19.453 171.712 19.4603 171.712 19.1494C171.708 18.9258 171.421 18.8892 171.189 18.8892H170.623V19.4422C170.623 19.4463 170.982 19.4463 170.982 19.4463C171.012 19.4463 171.045 19.4469 171.078 19.4476Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.1 19.678C169.1 18.5719 169.962 17.6977 171.05 17.6977C172.139 17.6977 173 18.5719 173 19.674C173.004 20.776 172.143 21.6543 171.054 21.6543C169.962 21.6543 169.1 20.7841 169.1 19.678ZM172.701 19.674C172.701 18.7468 171.935 18.0026 171.054 18.0026C170.165 18.0026 169.407 18.7468 169.407 19.678C169.407 20.6093 170.165 21.3494 171.062 21.3494C171.943 21.3453 172.701 20.6052 172.701 19.674Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/StudioKohlerSmall.mjs

const StudioKohlerSmallLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "15",
    viewBox: "0 0 120 15",
    fill: "none",
    "aria-label": "Studio Kohler Logo"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8043 0.389999C65.968 0.389999 62.8674 3.4753 62.8674 7.26884C62.8674 11.0705 65.9763 14.1477 69.8098 14.1477C73.6434 14.1477 76.7467 11.0597 76.7467 7.26341C76.7439 3.46445 73.6351 0.389999 69.8043 0.389999ZM72.9296 7.26067C72.9296 9.13302 71.53 10.6499 69.8068 10.6499C68.0864 10.6526 66.6841 9.13844 66.6841 7.26338C66.6814 5.39647 68.0837 3.87959 69.8041 3.87959C71.5328 3.87688 72.9296 5.39375 72.9296 7.26067Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M1.29015 9.64316C1.23206 12.3621 3.21522 13.1952 5.68518 13.1952C7.09856 13.1952 9.25043 12.4354 9.25043 10.5115C9.25043 9.01362 7.74025 8.41935 6.47899 8.12357L3.48075 7.40177C1.89588 7.01374 0.44378 6.29193 0.44378 4.21878C0.44378 2.92442 1.29291 0.498513 5.08497 0.498513C7.76237 0.498513 10.0636 1.88513 10.0636 4.60682H8.78023C8.68619 2.60694 7.02664 1.57308 5.10157 1.57308C3.34798 1.57308 1.7244 2.24061 1.7244 4.19979C1.7244 5.43988 2.64821 5.97716 3.7601 6.21595L7.04324 7.01102C8.94895 7.51031 10.5338 8.34337 10.5338 10.4898C10.5338 11.3961 10.1576 14.2643 5.38369 14.2643C2.19737 14.2643 -0.142593 12.8587 0.00676619 9.63773H1.29015V9.64316Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M14.193 4.44402H16.1734V5.42361H14.193V11.8629C14.193 12.6226 14.3064 13.065 15.1555 13.1219C15.4957 13.1219 15.8359 13.1029 16.1734 13.065V14.0635C15.9936 14.0635 15.8193 14.073 15.6451 14.0825C15.4708 14.092 15.2966 14.1015 15.1168 14.1015C13.5319 14.1015 12.9843 13.5832 13.0036 11.9551V5.42361H11.3054V4.44402H13.0036V1.5758H14.193V4.44402Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M24.261 13.993H25.3563V4.44401H24.167V9.45593C24.167 11.3988 23.2819 13.2875 21.2434 13.2875C19.3571 13.2875 18.696 12.3811 18.6407 10.6607V4.44401H17.4514V10.6445C17.4514 12.8858 18.3945 14.2725 20.8645 14.2725C22.3166 14.2725 23.6 13.5507 24.2223 12.2726H24.261V13.993Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2761 13.993H35.3714V0.780721H34.1821V6.25937H34.1433C33.651 4.88903 32.1989 4.16723 30.7662 4.16723C27.8039 4.16723 26.3905 6.49816 26.3905 9.21985C26.3905 11.9415 27.8039 14.2725 30.7662 14.2725C32.1823 14.2725 33.7285 13.4394 34.2374 12.1803H34.2761V13.993ZM34.1818 9.21717C34.1818 11.1953 33.2774 13.2875 30.7687 13.2875C28.5062 13.2875 27.5824 11.1953 27.5824 9.21717C27.5824 7.239 28.5062 5.14685 30.7687 5.14685C33.2774 5.14685 34.1818 7.239 34.1818 9.21717Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.2389 0.780721H38.4283V2.65035H37.2389V0.780721Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.2389 4.44401H38.4283V13.993H37.2389V4.44401Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4051 14.2698C47.3674 14.2698 49.0076 11.9551 49.0076 9.21713C49.0076 6.47917 47.3674 4.16451 44.4051 4.16451C41.4428 4.16451 39.8027 6.47645 39.8027 9.21713C39.8027 11.9578 41.4428 14.2698 44.4051 14.2698ZM44.4053 13.2874C42.1428 13.2874 40.9922 11.2333 40.9922 9.2171C40.9922 7.20093 42.1428 5.14678 44.4053 5.14678C46.6678 5.14678 47.8185 7.20093 47.8185 9.2171C47.8185 11.2333 46.6678 13.2874 44.4053 13.2874Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M89.3319 0.769871L89.3374 13.9686L97.1428 13.9658V10.5902H93.0188L93.0133 0.767157L89.3319 0.769871Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M77.3607 13.974L77.3497 0.775323L81.0283 0.772609L81.0311 5.40463L84.7374 5.3992L84.7347 0.772609L88.4133 0.769896L88.4189 13.9686H84.743V9.05978L81.0311 9.0652L81.0366 13.9713L77.3607 13.974Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M59.5483 7.07346L64.8561 0.783463H60.0904L56.6164 4.70856V0.783463L52.9405 0.786177L52.9461 13.9849H56.6192L56.6164 9.27957H56.6247L60.7542 13.9849H65.6222L59.5483 7.07346Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M105.357 0.759042L101.579 0.767182H97.8921L97.9004 13.9659L105.399 13.9604L105.393 10.8616L101.665 10.8643V8.85355L105.07 8.84541L105.067 5.89578H101.654L101.67 3.81178L105.357 3.80093V0.759042Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.839 13.9604L113.008 8.67988C117.455 5.73839 114.88 0.748183 110.823 0.75361L106.215 0.756324L106.223 13.9523L109.821 13.9496V9.9064L112.817 13.9604H116.839ZM112.145 5.08443C112.145 5.78724 111.561 6.35708 110.848 6.35708L109.805 6.35437V3.8172L110.842 3.81449C111.561 3.81449 112.145 4.38162 112.145 5.08443Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.043 14.0011H119.292L118.847 13.3363C119.107 13.3282 119.314 13.2251 119.314 12.9374C119.314 12.6254 119.054 12.5548 118.791 12.5548H118.144L118.147 14.0011H118.352V13.3336H118.601L119.043 14.0011ZM118.667 13.1337C118.855 13.1373 119.106 13.1422 119.106 12.9347C119.104 12.7855 118.905 12.7611 118.744 12.7611H118.351V13.1301C118.351 13.1328 118.6 13.1328 118.6 13.1328C118.621 13.1328 118.644 13.1333 118.667 13.1337Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.295 13.2875C117.295 12.5494 117.892 11.966 118.647 11.966C119.403 11.966 120 12.5494 120 13.2848C120.003 14.0201 119.405 14.6063 118.65 14.6063C117.892 14.6063 117.295 14.0256 117.295 13.2875ZM119.793 13.2848C119.793 12.6661 119.261 12.1695 118.65 12.1695C118.033 12.1695 117.508 12.6661 117.508 13.2875C117.508 13.9089 118.033 14.4027 118.656 14.4027C119.267 14.4 119.793 13.9062 119.793 13.2848Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.utils.mjs
















const BrandLogoPath = {
    Kohler: KohlerLogo,
    "Kohler Bold": KohlerBoldLogo,
    "Studio Kohler Large": StudioKohlerLargeLogo,
    "Studio Kohler Small": StudioKohlerSmallLogo,
    "Ann Sacks": AnnSacksLogo,
    Sterling: SterlingLogo,
    Kallista: KallistaLogo,
    Robern: RobernLogo,
    Mira: MiraLogo,
    Sprig: SprigLogo,
    Klafs: KlafsLogo,
    "Klafs Sauna and Spa": KlafsSaunaAndSpaLogo,
    "Kohler Lux Store": KohlerLuxStoreLogo,
    "Kohler Walk in Bath": KohlerWalkInBathLogo,
    "Reveal by Kohler": RevealByKohlerLogo,
    "Reveal by Kohler Large": RevealByKohlerLargeLogo
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.mjs




const BrandLogo = (param)=>{
    let { brand , className , ...rest } = param;
    const classNames = (0,clsx/* default */.Z)(BrandLogo_module_css_classes.root, "kohler-brand-logo-root", className);
    const LogoSvg = BrandLogoPath[brand];
    if (!LogoSvg) {
        console.error("Brand logo not found for brand: ".concat(brand));
        return null;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(LogoSvg.type, {
        ...LogoSvg.props,
        className: classNames,
        ...rest
    });
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(3171);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/NotificationDot/NotificationDot.module.css.mjs
var NotificationDot_module_css_classes = {
    "notificationDotWrapper": "PqjqK",
    "notificationDot": "UC5Nw"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/resolvers.mjs
var resolvers = __webpack_require__(46548);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/NotificationDot/NotificationDot.utils.mjs


function getPositionVariables() {
    let _position = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "top-end", offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const variables = {
        "--indicator-top": void 0,
        "--indicator-bottom": void 0,
        "--indicator-left": void 0,
        "--indicator-right": void 0,
        "--indicator-translate-x": void 0,
        "--indicator-translate-y": void 0
    };
    const _offset = (0,resolvers/* spacingResolver */.k0)(offset);
    const [position, placement] = _position.split("-");
    if (position === "top") {
        variables["--indicator-top"] = _offset;
        variables["--indicator-translate-y"] = "-50%";
    }
    if (position === "middle") {
        variables["--indicator-top"] = "50%";
        variables["--indicator-translate-y"] = "-50%";
    }
    if (position === "bottom") {
        variables["--indicator-bottom"] = _offset;
        variables["--indicator-translate-y"] = "50%";
    }
    if (placement === "start") {
        variables["--indicator-left"] = _offset;
        variables["--indicator-translate-x"] = "-50%";
    }
    if (placement === "center") {
        variables["--indicator-left"] = "50%";
        variables["--indicator-translate-x"] = "-50%";
    }
    if (placement === "end") {
        variables["--indicator-right"] = _offset;
        variables["--indicator-translate-x"] = "50%";
    }
    return variables;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/NotificationDot/NotificationDot.mjs






const NotificationDot = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { children , disabled =false , position ="top-end" , inline =false , offset =0 , withBorder =true , className , wrapperStyles , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-notification-dot-root", NotificationDot_module_css_classes.notificationDot, className);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)("kohler-notification-dot-wrapper", NotificationDot_module_css_classes.notificationDotWrapper),
        style: {
            ...getPositionVariables(position, offset),
            ...wrapperStyles
        },
        "data-inline": inline ? "true" : void 0
    }, !disabled && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        "data-with-border": withBorder ? "true" : void 0,
        ...rest
    }), children);
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartEmptyIcon.mjs


const withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 14
};
const CartEmptyIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.22998 5.79001H6.77605L7.24498 7.78801L26.5559 7.67627L23.2376 20.57H9.22391L5.98398 6.79001H2.22998V5.79001ZM25.263 8.68301L7.47998 8.78501L10.015 19.569H22.462L25.263 8.68301Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.27 22.97C11.27 23.5831 10.773 24.08 10.16 24.08C9.54694 24.08 9.04998 23.5831 9.04998 22.97C9.04998 22.357 9.54694 21.86 10.16 21.86C10.773 21.86 11.27 22.357 11.27 22.97Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.68 24.08C23.293 24.08 23.79 23.5831 23.79 22.97C23.79 22.357 23.293 21.86 22.68 21.86C22.0669 21.86 21.57 22.357 21.57 22.97C21.57 23.5831 22.0669 24.08 22.68 24.08Z",
        fill: "currentColor"
    }));
};
CartEmptyIcon.iconName = "CartEmptyIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.module.css.mjs
var CartBadge_module_css_classes = {
    "cartBadgeRoot": "UEOHe"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartOneDigitIcon.mjs


const CartOneDigitIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 15
};
const CartOneDigitIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartOneDigitIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M2.34009 5.84998H6.88616L10.129 19.6299H22.5529L25.6398 7.73624H26.666L23.3477 20.63H9.33401L6.09409 6.84998H2.34009V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.3801 23.03C11.3801 23.643 10.8831 24.14 10.2701 24.14C9.65706 24.14 9.1601 23.643 9.1601 23.03C9.1601 22.4169 9.65706 21.92 10.2701 21.92C10.8831 21.92 11.3801 22.4169 11.3801 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.7901 24.14C23.4031 24.14 23.9001 23.643 23.9001 23.03C23.9001 22.4169 23.4031 21.92 22.7901 21.92C22.177 21.92 21.6801 22.4169 21.6801 23.03C21.6801 23.643 22.177 24.14 22.7901 24.14Z",
        fill: "currentColor"
    }));
};
CartOneDigitIcon.iconName = "CartOneDigitIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartTwoDigitIcon.mjs


const CartTwoDigitIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 17,
    xSmall: 14
};
const CartTwoDigitIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartTwoDigitIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
    }));
};
CartTwoDigitIcon.iconName = "CartTwoDigitIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartThreeDigitIcon.mjs


const CartThreeDigitIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 26,
    small: 17,
    xSmall: 14
};
const CartThreeDigitIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartThreeDigitIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
    }));
};
CartThreeDigitIcon.iconName = "CartThreeDigitIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartEmptyBoldIcon.mjs


const CartEmptyBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 14
};
const CartEmptyBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartEmptyBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.97466 5.54004H1.98047V7.04004H5.78643L9.02636 20.82H23.4319L26.8794 7.42443L7.44332 7.53689L6.97466 5.54004ZM10.2135 19.319L7.79563 9.03324L24.9405 8.9349L22.2687 19.319H10.2135Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M10.1605 21.61C9.40936 21.61 8.80047 22.2189 8.80047 22.97C8.80047 23.7212 9.40936 24.33 10.1605 24.33C10.9116 24.33 11.5205 23.7212 11.5205 22.97C11.5205 22.2189 10.9116 21.61 10.1605 21.61Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.6805 21.61C21.9294 21.61 21.3205 22.2189 21.3205 22.97C21.3205 23.7212 21.9294 24.33 22.6805 24.33C23.4316 24.33 24.0405 23.7212 24.0405 22.97C24.0405 22.2189 23.4316 21.61 22.6805 21.61Z",
        fill: "currentColor"
    }));
};
CartEmptyBoldIcon.iconName = "CartEmptyBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartOneDigitBoldIcon.mjs


const CartOneDigitBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 15
};
const CartOneDigitBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartOneDigitBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }));
};
CartOneDigitBoldIcon.iconName = "CartOneDigitBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartTwoDigitBoldIcon.mjs


const CartTwoDigitBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 23,
    small: 18,
    xSmall: 15
};
const CartTwoDigitBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartTwoDigitBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }));
};
CartTwoDigitBoldIcon.iconName = "CartTwoDigitBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartThreeDigitBoldIcon.mjs


const CartThreeDigitBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 23,
    small: 18,
    xSmall: 15
};
const CartThreeDigitBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartThreeDigitBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }));
};
CartThreeDigitBoldIcon.iconName = "CartThreeDigitBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.utils.mjs

const iconMap = {
    default: {
        0: CartEmptyIcon,
        1: CartOneDigitIcon,
        2: CartTwoDigitIcon,
        3: CartThreeDigitIcon
    },
    bold: {
        0: CartEmptyBoldIcon,
        1: CartOneDigitBoldIcon,
        2: CartTwoDigitBoldIcon,
        3: CartThreeDigitBoldIcon
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.mjs










const CartBadge = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , digit , thickness ="default" , withBoundingBox =true , textColor , ...rest } = props;
    const digitString = digit === null || digit === void 0 ? void 0 : digit.toString();
    const classNames = (0,clsx/* default */.Z)("kohler-cart-badge-root", className, CartBadge_module_css_classes.cartBadgeRoot);
    const Icon = digitString && digitString !== "0" ? iconMap[thickness][digitString.length || 0] : CartEmptyIcon;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "relative",
        className: classNames,
        component,
        ref,
        textColor: textColor !== null && textColor !== void 0 ? textColor : colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        withBoundingBox,
        style: {
            maxWidth: "100%",
            display: "block"
        }
    }), digitString && digitString !== "0" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center",
        position: "absolute",
        right: digitString.length > 2 ? 0 : 4,
        left: digitString.length > 2 ? 10 : 8,
        top: 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "tag-s",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        textColor: "inherit"
    }, digitString)));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Portal/Portal.mjs
var Portal = __webpack_require__(3713);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownIcon.mjs
var ArrowDownIcon = __webpack_require__(62281);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/SearchIcon.mjs
var SearchIcon = __webpack_require__(72457);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/VisualSearchIcon.mjs
var VisualSearchIcon = __webpack_require__(15051);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MenuIcon.mjs
var MenuIcon = __webpack_require__(24665);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/NavigationItem/NavigationItem.module.css.mjs
var NavigationItem_module_css_classes = {
    "navigationItem": "ryxOA",
    "navigationItemUnselected": "A1V04",
    "navigationItemKohler": "nVTYX",
    "navigationItemSelectedKohler": "JZ1wk",
    "navigationItemKlafs": "P-9Wr",
    "navigationItemSelectedKlafs": "neBFB",
    "navigationItemKhs": "j54en",
    "navigationItemSelectedKhs": "XpYGs"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/NavigationItem/NavigationItem.utility.mjs

const navigationItemVariantClasses = {
    kohler: NavigationItem_module_css_classes.navigationItemKohler,
    klafs: NavigationItem_module_css_classes.navigationItemKlafs,
    khs: NavigationItem_module_css_classes.navigationItemKhs
};
const navigationItemSelectedVariantClasses = {
    kohler: NavigationItem_module_css_classes.navigationItemSelectedKohler,
    klafs: NavigationItem_module_css_classes.navigationItemSelectedKlafs,
    khs: NavigationItem_module_css_classes.navigationItemSelectedKhs
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/NavigationItem/NavigationItem.mjs





const NavigationItem = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component , text , isSelected =false , brand ="kohler" , className , ...rest } = props;
    const isUniversal = brand === "klafs";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: rest.href ? "a" : component || "span",
        ref,
        size: isSelected ? "navigation-selected" : "navigation-unselected",
        className: (0,clsx/* default */.Z)("kohler-navigation-item-root", NavigationItem_module_css_classes.navigationItem, !isSelected && NavigationItem_module_css_classes.navigationItemUnselected, isUniversal && NavigationItem_module_css_classes.navigationItemKlafs, !isSelected && !isUniversal && navigationItemVariantClasses[brand], isSelected && navigationItemSelectedVariantClasses[brand], className),
        ...rest
    }, text);
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CloseIcon.mjs
var CloseIcon = __webpack_require__(61599);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowLeftIcon.mjs
var ArrowLeftIcon = __webpack_require__(90751);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ExternalLinkIcon.mjs
var ExternalLinkIcon = __webpack_require__(57537);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownBoldIcon.mjs
var ArrowDownBoldIcon = __webpack_require__(60068);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightBoldIcon.mjs
var ArrowRightBoldIcon = __webpack_require__(64260);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuCategory/OverlayMenuCategory.module.css.mjs
var OverlayMenuCategory_module_css_classes = {
    "overlayMenuCategory": "muZTc",
    "overlayMenuCategoryCTA": "BREK-",
    "overlayMenuCategoryTitle": "Y8ip4",
    "overlayMenuCategoryOpen": "WFLCP",
    "overlayMenuCategoryLinks": "cfjcS",
    "overlayMenuCategoryLinksLink": "EosB-",
    "iconTransitionArrowClosed": "VxcqM",
    "iconTransitionArrowOpen": "-ECJU",
    "overlayMenuCategoryTitleLink": "bGfiv",
    "arrowDownIcon": "GiCqj"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuCategory/OverlayMenuCategory.mjs





const OverlayMenuCategory = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , links , showArrow =true , isExternal , opened =false , onToggle , isCTA =false , ...rest } = props;
    const isOpen = opened;
    const hasNoLinks = !links || links.length === 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-category-root", OverlayMenuCategory_module_css_classes.overlayMenuCategory, isOpen && OverlayMenuCategory_module_css_classes.overlayMenuCategoryOpen, isCTA && OverlayMenuCategory_module_css_classes.overlayMenuCategoryCTA),
        component: "div",
        ...rest
    }, title && (!isCTA ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: hasNoLinks ? "a" : "button",
        target: hasNoLinks && isExternal ? "_blank" : void 0,
        ...(0,helpers/* omitText */.rW)(title),
        onClick: !links ? title.onClick : ()=>{
            if (onToggle) onToggle();
        },
        className: (0,clsx/* default */.Z)(OverlayMenuCategory_module_css_classes.overlayMenuCategoryTitle, hasNoLinks ? OverlayMenuCategory_module_css_classes.overlayMenuCategoryTitleLink : void 0, title.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "navigation-m",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, title.text, " ", !showArrow && hasNoLinks && isExternal && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, {
        size: "small",
        withBoundingBox: false
    })), showArrow && !hasNoLinks && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownBoldIcon/* ArrowDownBoldIcon */.T, {
        size: "xSmall",
        withBoundingBox: false,
        className: (0,clsx/* default */.Z)(OverlayMenuCategory_module_css_classes.iconTransitionArrowClosed, isOpen && OverlayMenuCategory_module_css_classes.iconTransitionArrowOpen, OverlayMenuCategory_module_css_classes.arrowDownIcon)
    })) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        size: "small",
        underline: false,
        rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
            size: "small",
            withBoundingBox: false
        }),
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text)), (isOpen || !title) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: 15,
        margin: 0,
        className: OverlayMenuCategory_module_css_classes.overlayMenuCategoryLinks
    }, !hasNoLinks && (links === null || links === void 0 ? void 0 : links.map((link)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: link.href,
            component: "li"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: "a",
            size: "navigation-s",
            textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault,
            ...(0,helpers/* omitText */.rW)(link),
            className: OverlayMenuCategory_module_css_classes.overlayMenuCategoryLinksLink
        }, link.text))))));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs
var use_window_size = __webpack_require__(17677);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs + 2 modules
var AspectRatioKeeper = __webpack_require__(66737);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 4 modules
var Image = __webpack_require__(26191);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuImage/OverlayMenuImage.module.css.mjs
var OverlayMenuImage_module_css_classes = {
    "overlayMenuImage": "oRy72",
    "overlayMenuImageCTA": "wCyIu",
    "overlayMenuImageWidth": "R1rEa"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuImage/OverlayMenuImage.utils.mjs
const kohlerUSSmartCropImageSize = {
    1: {
        portrait: {
            general: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        },
        landscape: {
            general: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        }
    },
    2: {
        portrait: {
            general: {
                1600: "340px",
                1440: "305px",
                1023: "250px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1600: "340px",
                1440: "280px",
                1023: "240px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        },
        landscape: {
            business: {
                1920: "440px",
                1600: "415px",
                1440: "335px",
                1023: "303px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        }
    }
};
function getSmartCropWidth(param) {
    let { screenWidth , imagesLength , isSmartCrop , imageOrientation , isBusinessTab  } = param;
    var ref, ref1;
    if (!isSmartCrop) return void 0;
    const layoutTier = imagesLength;
    const context = isBusinessTab ? "business" : "general";
    const orientation = imageOrientation === "portrait" ? "portrait" : "landscape";
    const breakpoints = (ref = kohlerUSSmartCropImageSize[layoutTier]) === null || ref === void 0 ? void 0 : (ref1 = ref[orientation]) === null || ref1 === void 0 ? void 0 : ref1[context];
    if (!breakpoints) return void 0;
    const sortedKeys = Object.keys(breakpoints).map(Number).sort((a, b)=>a - b);
    let selected;
    for (const bp of sortedKeys){
        if (screenWidth >= bp) {
            selected = breakpoints[bp];
        } else {
            break;
        }
    }
    return selected;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuImage/OverlayMenuImage.mjs
"use client";






const OverlayMenuImage = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , CTA , imagesLength =1 , caption , image , multiCTA , imageOrientation ="landscape" , href , imageCTA , isBusinessTab =true , ...rest } = props;
    const isSmartCrop = (image === null || image === void 0 ? void 0 : image["data-mode"]) === "smartcrop";
    const { width: screenWidth  } = (0,use_window_size/* useWindowSize */.i)();
    const resolvedWidth = getSmartCropWidth({
        screenWidth,
        imagesLength,
        isSmartCrop,
        imageOrientation,
        isBusinessTab
    });
    var ref1, ref2;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 40,
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-image-wrapper", OverlayMenuImage_module_css_classes.overlayMenuImageWrapper),
        width: resolvedWidth,
        ...rest
    }, multiCTA && multiCTA.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        margin: 0,
        gap: 20
    }, multiCTA === null || multiCTA === void 0 ? void 0 : multiCTA.map((item)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            key: item.text,
            component: "li",
            className: OverlayMenuImage_module_css_classes.overlayMenuCategoryLinksLink
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            ...(0,helpers/* omitText */.rW)(item),
            underline: false,
            rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                withBoundingBox: false,
                size: "xSmall"
            }),
            className: OverlayMenuImage_module_css_classes.overlayMenuCategoryLinksLink,
            size: "small",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
        }, item.text)))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)("kohler-overlay-menu-image", OverlayMenuImage_module_css_classes.overlayMenuImage, !isSmartCrop && OverlayMenuImage_module_css_classes.overlayMenuImageWidth)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        component: "a",
        href: (ref2 = (ref1 = CTA === null || CTA === void 0 ? void 0 : CTA.href) !== null && ref1 !== void 0 ? ref1 : href) !== null && ref2 !== void 0 ? ref2 : void 0,
        target: (CTA === null || CTA === void 0 ? void 0 : CTA.target) || "_self",
        ...imageCTA,
        aspectRatio: isSmartCrop ? "none" : imageOrientation === "landscape" ? "5:4" : "3:4"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), (caption || CTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, caption && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-s",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        component: /*#__PURE__*/ (0,react.isValidElement)(caption.text) ? "div" : caption.component || "p",
        ...(0,helpers/* omitText */.rW)(caption)
    }, caption.text), CTA && CTA.text && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        underline: false,
        rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
            withBoundingBox: false,
            size: "xSmall"
        }),
        className: OverlayMenuImage_module_css_classes.overlayMenuImageCTA,
        size: "small",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        ...(0,helpers/* omitText */.rW)(CTA)
    }, CTA.text))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuItem/OverlayMenuItem.module.css.mjs
var OverlayMenuItem_module_css_classes = {
    "overlayMenuItem": "PPy7I"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuItem/OverlayMenuItem.mjs





const OverlayMenuItem = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { className , title , showArrow =true , component ="button" , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-item", OverlayMenuItem_module_css_classes.overlayMenuItem),
        component,
        type: component === "button" ? "button" : void 0,
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "navigation-l",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, title), " ", showArrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
        size: "xSmall",
        withBoundingBox: false
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LanguageMenu/LanguageMenu.utils.mjs
function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str.replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
    return str;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.hooks.mjs


const useResponsiveNav = (menuItems)=>{
    const [visibleItems, setVisibleItems] = (0,react.useState)(menuItems);
    const [overflowItems, setOverflowItems] = (0,react.useState)([]);
    const [isMoreOpen, setIsMoreOpen] = (0,react.useState)(false);
    const [recalcKey, setRecalcKey] = (0,react.useState)(0);
    const navRef = (0,react.useRef)(null);
    const containerRef = (0,react.useRef)(null);
    const moreButtonRef = (0,react.useRef)(null);
    const resizeTimeoutRef = (0,react.useRef)(null);
    const itemWidthsRef = (0,react.useRef)({});
    const windowSize = (0,use_window_size/* useWindowSize */.i)();
    const measureItemWidths = (0,react.useCallback)(()=>{
        if (!navRef.current) return;
        const newWidths = {};
        navRef.current.childNodes.forEach((node)=>{
            const element = node;
            if (element.id) {
                newWidths[element.id] = element.offsetWidth;
            }
        });
        itemWidthsRef.current = newWidths;
    }, []);
    const calculateVisibility = (0,react.useCallback)(()=>{
        var ref, ref1;
        if (!navRef.current || !containerRef.current) return;
        const containerWidth = containerRef.current.clientWidth;
        const moreButtonWidth = ((ref = moreButtonRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) ? ((ref1 = moreButtonRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth) + 15 : 70;
        let totalWidth = 0;
        const newVisibleItems = [];
        const newOverflowItems = [];
        for (const item of menuItems){
            const itemWidth = itemWidthsRef.current[item.text] || 0;
            totalWidth += itemWidth;
            if (totalWidth < containerWidth - moreButtonWidth) {
                newVisibleItems.push(item);
            } else {
                newOverflowItems.push(item);
            }
        }
        setVisibleItems(newVisibleItems);
        setOverflowItems(newOverflowItems);
    }, [
        menuItems
    ]);
    (0,react.useEffect)(()=>{
        if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
        resizeTimeoutRef.current = setTimeout(()=>{
            var ref;
            measureItemWidths();
            calculateVisibility();
            const totalMeasuredWidth = Object.values(itemWidthsRef.current).reduce((sum, width)=>sum + width, 0);
            const containerWidth = ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) || 0;
            const isContainerWide = containerWidth > 100;
            if (totalMeasuredWidth === 0 && isContainerWide && navRef.current && menuItems.length > 0) {
                console.log("Initial measurement failed (widths were 0), forcing re-run.");
                setRecalcKey((prev)=>prev + 1);
            }
        }, 200);
        return ()=>{
            if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
        };
    }, [
        windowSize.width,
        recalcKey
    ]);
    return {
        visibleItems,
        overflowItems,
        isMoreOpen,
        setIsMoreOpen,
        navRef,
        containerRef,
        moreButtonRef
    };
};
function useMenuKeyboardNavigation(param) {
    let { listRef , itemSelector , orientation ="vertical" , currentIndexResolver ="activeElement" , onCustomKeyDown  } = param;
    const handleKeyDown = (0,react.useCallback)((e)=>{
        const list = listRef.current;
        if (!list) return;
        const items = Array.from(list.querySelectorAll(itemSelector));
        if (!items.length) return;
        const currentIndex = currentIndexResolver === "activeElement" ? items.indexOf(document.activeElement) : items.indexOf(e.currentTarget);
        if (onCustomKeyDown === null || onCustomKeyDown === void 0 ? void 0 : onCustomKeyDown(e, items, currentIndex)) return;
        const nextKey = orientation === "vertical" ? "ArrowDown" : "ArrowRight";
        const prevKey = orientation === "vertical" ? "ArrowUp" : "ArrowLeft";
        switch(e.key){
            case nextKey:
                var ref;
                e.preventDefault();
                (ref = items[(currentIndex + 1) % items.length]) === null || ref === void 0 ? void 0 : ref.focus();
                break;
            case prevKey:
                var ref1;
                e.preventDefault();
                (ref1 = items[(currentIndex - 1 + items.length) % items.length]) === null || ref1 === void 0 ? void 0 : ref1.focus();
                break;
            case "Home":
                var ref2;
                e.preventDefault();
                (ref2 = items[0]) === null || ref2 === void 0 ? void 0 : ref2.focus();
                break;
            case "End":
                var ref3;
                e.preventDefault();
                (ref3 = items[items.length - 1]) === null || ref3 === void 0 ? void 0 : ref3.focus();
                break;
        }
    }, [
        listRef,
        itemSelector,
        orientation,
        currentIndexResolver,
        onCustomKeyDown
    ]);
    return handleKeyDown;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuLinks/OverlayMenuLinks.module.css.mjs
var OverlayMenuLinks_module_css_classes = {
    "overlayMenuLinks": "_4jPFa",
    "overlayMenuCategoryLinksCTA": "hdex4",
    "overlayMenuLinksNoMargin": "_-6Bhq",
    "overlayMenuCategoryLinksLink": "O8QYI",
    "overlayMenuLinksList": "_0Y07-",
    "overlayMenuCategoryLinksTitleLink": "W9te5",
    "overlayMenuCategoryLinksTitleLinkCTA": "cG53K",
    "overlayMenuCategoryLinksLinkComponent": "K29q-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuLinks/OverlayMenuLinks.utils.mjs
function omitTextAndTabGroup(obj) {
    const { text: _ , newTabGroup: __ , ...rest } = obj;
    return rest;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuLinks/OverlayMenuLinks.mjs








const OverlayMenuLinks = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , items , CTAs , size ="small" , isCTA =false , newTabGroup =false , ...rest } = props;
    const isSmall = size === "small";
    const titleID = (0,react.useId)();
    const listRef = (0,react.useRef)(null);
    const handleMenuKeyDown = useMenuKeyboardNavigation({
        listRef,
        itemSelector: ":scope > li > [role='menuitem']",
        orientation: "vertical",
        currentIndexResolver: "activeElement"
    });
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        direction: "column",
        align: "flex-start",
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-links", OverlayMenuLinks_module_css_classes.overlayMenuLinks, isSmall && !(items === null || items === void 0 ? void 0 : items.length) && title.href && OverlayMenuLinks_module_css_classes.overlayMenuLinksNoMargin),
        ...rest
    }, title && (!isCTA ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.href ? "a" : "span",
        size: isSmall ? "label-medium-m" : "label-regular-s",
        textColor: isSmall ? "var(--content-primary)" : "var(--content-secondary)",
        className: (0,clsx/* default */.Z)(title.href && OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksTitleLink, newTabGroup && OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksTitleLinkCTA),
        id: "".concat(title.text ? slugify(title.text) : "", "-").concat(titleID),
        target: title.href ? newTabGroup ? "_blank" : void 0 : void 0,
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text, newTabGroup && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, {
        size: "small",
        withBoundingBox: false
    }))) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        size: "small",
        underline: false,
        rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
            size: "small",
            withBoundingBox: false
        }),
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text)), (items === null || items === void 0 ? void 0 : items.length) && (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        role: "menu",
        direction: "column",
        gap: 2,
        "aria-labelledby": title && "".concat(title.text ? slugify(title.text) : "", "-").concat(titleID),
        className: OverlayMenuLinks_module_css_classes.overlayMenuLinksList,
        ref: listRef,
        onKeyDown: handleMenuKeyDown
    }, items === null || items === void 0 ? void 0 : items.map((item)=>{
        if ("href" in item) {
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                key: item.text || item.href,
                component: "li",
                role: "none",
                className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksLink
            }, isSmall && item.target !== "_blank" && !item.newTabGroup && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
                component: "a",
                href: item.href,
                role: "menuitem",
                "aria-label": item.text,
                size: "navigation-overlay-item-s",
                textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault,
                ...omitTextAndTabGroup(item),
                className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksLink
            }, item.text), (!isSmall || item.target === "_blank" || item.newTabGroup) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
                size: "medium",
                rightIcon: item.target === "_blank" || item.newTabGroup ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, {
                    size: "small",
                    withBoundingBox: false
                }) : void 0,
                role: "menuitem",
                "aria-label": item.text,
                ...omitTextAndTabGroup(item),
                underline: false,
                className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksLinkComponent
            }, item.text));
        } else {
            var ref;
            var ref1;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuLinks, {
                component: "li",
                key: "group-".concat((ref1 = (ref = item.title) === null || ref === void 0 ? void 0 : ref.text) !== null && ref1 !== void 0 ? ref1 : Math.random()),
                ...item
            });
        }
    })), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: isSmall ? 10 : 2,
        marginTop: isSmall ? 10 : 2,
        className: OverlayMenuLinks_module_css_classes.overlayMenuLinksList
    }, CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((link)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: link.href,
            component: "li",
            className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksCTA
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            size: isSmall ? "small" : "medium",
            underline: false,
            rightIcon: isSmall ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                size: "small",
                withBoundingBox: false
            }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, {
                withBoundingBox: false
            }),
            ...(0,helpers/* omitText */.rW)(link)
        }, link.text)))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.module.css.mjs
var Tab_module_css_classes = {
    "tab": "YhILP",
    "tabHorizontal": "exTIC",
    "tabVertical": "_2ShWU"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.utils.mjs

const tabTypeClasses = {
    horizontal: Tab_module_css_classes.tabHorizontal,
    vertical: Tab_module_css_classes.tabVertical
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.mjs









const Tab = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { text , component ="button" , isSelected =false , variant ="horizontal" , icon , className , ...rest } = props;
    const isHorizontal = variant === "horizontal";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: isHorizontal ? "column" : "row",
        gap: isHorizontal ? 5 : void 0,
        align: "center",
        position: !isHorizontal ? "relative" : void 0
    }, !isHorizontal && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        backgroundColor: isSelected ? colors/* DsmColor.BorderPrimary */.k.BorderPrimary : colors/* DsmColor.BorderNeutralMediumContrast */.k.BorderNeutralMediumContrast,
        width: isSelected ? 3 : 1,
        style: {
            position: "absolute",
            height: "100%"
        }
    }), isHorizontal && icon ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, icon) : null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component,
        size: isHorizontal ? "label-medium-l" : "label-medium-m",
        type: component === "button" ? "button" : void 0,
        className: (0,clsx/* default */.Z)(Tab_module_css_classes.tab, className, tabTypeClasses[variant], "kohler-tab-root"),
        textColor: rest["aria-expanded"] || isSelected ? colors/* DsmColor.ContentPrimary */.k.ContentPrimary : colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        cursor: "pointer",
        ref,
        ...rest
    }, text), isSelected && isHorizontal && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        height: 4,
        backgroundColor: colors/* DsmColor.BorderPrimary */.k.BorderPrimary,
        className: Tab_module_css_classes.horizontalTabBar
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuTabs/OverlayMenuTabs.module.css.mjs
var OverlayMenuTabs_module_css_classes = {
    "overlayMenuTabs": "uD-Eu",
    "overlayMenuTabsKlafs": "EVNd8",
    "overlayMenuTabsList": "AkIVV",
    "overlayMenuTabsListKlafs": "-J8YL",
    "overlayMenuImageCTA": "oo9VZ",
    "overlayMenuImageCTAKlafs": "_2Cesn"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuTabs/OverlayMenuTabs.mjs





const OverlayMenuTabs = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , CTAs , brand ="kohler" , ...rest } = props;
    const isKlafs = brand === "klafs";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        direction: "column",
        gap: 10,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-tabs", OverlayMenuTabs_module_css_classes.overlayMenuTabs, isKlafs && OverlayMenuTabs_module_css_classes.overlayMenuTabsKlafs),
        ...rest
    }, title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "label-medium-m",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, title), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        margin: 0,
        className: (0,clsx/* default */.Z)(OverlayMenuTabs_module_css_classes.overlayMenuTabsList, isKlafs && OverlayMenuTabs_module_css_classes.overlayMenuTabsListKlafs)
    }, CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((link)=>{
        const { hasChildrenList , ...linkProps } = link;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: link.text
        }, hasChildrenList && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tab, {
            variant: "vertical",
            id: link.text,
            textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault,
            type: "button",
            ...linkProps
        }), !hasChildrenList && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            underline: false,
            rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                withBoundingBox: false,
                size: "xSmall"
            }),
            className: (0,clsx/* default */.Z)(OverlayMenuTabs_module_css_classes.overlayMenuImageCTA, isKlafs && OverlayMenuTabs_module_css_classes.overlayMenuImageCTAKlafs),
            size: "small",
            href: link.href
        }, link.text));
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/OverlayMenu.module.css.mjs
var OverlayMenu_module_css_classes = {
    "overlayMenu": "VnLVG",
    "overlayMenuLinkGridMainMobileWrapper": "VZHqR",
    "overlayMenuLinkGridWrapper": "_0joZn",
    "overlayMenuLinkGridWrapperKlafs": "_8gZ-l",
    "overlayMenuLinkGridWrapperKHS": "L94f3",
    "overlayMenuLinkGridMobileWrapper": "QzpWp",
    "overlayMenuLinkGridListsMobile": "s0UqJ",
    "overlayMenuLinkGridLists": "YT28-",
    "overlayMenuLinkGrid": "mQdab",
    "overlayMenuMobileImages": "p73rY",
    "overlayMenuLinkCloseButtonMobile": "ojZqn",
    "overlayMenuLinkLevelOneMobile": "nPytY",
    "arrowLeftIcon": "mjUag"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/OverlayMenu.utils.mjs
const isILink = (item)=>"href" in item;
function getSanitizedLanguagePickerCTA(config) {
    const { location , languagePickerCTA , currentLanguage , secondLanguageCTA , ...rest } = config;
    return {
        ...rest
    };
}
function countCTAListsWithItems(data) {
    return (data.CTALists || []).reduce((count, group)=>{
        const groups = Array.isArray(group) ? group : [
            group
        ];
        const hasItems = groups.some((g)=>Array.isArray(g.items) && g.items.length > 0);
        return hasItems ? count + 1 : count;
    }, 0);
}


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(18657);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.mjs + 2 modules
var Popover = __webpack_require__(86138);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Coachmark/Coachmark.module.css.mjs
var Coachmark_module_css_classes = {
    "dropdownWrapper": "C-xyM",
    "coachmarkDropdownTarget": "g4Dv4"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Coachmark/Coachmark.utils.mjs
"use client";


function useCoachmarkExternalTarget(param) {
    let { targetSelector , targetElementId , disabled =false , toggleOnExternalClick =true , onToggle , onExternalClick , wrapperClassName  } = param;
    const wrapperElRef = (0,react.useRef)(null);
    const createdWrapperRef = (0,react.useRef)(false);
    const originalParentRef = (0,react.useRef)(null);
    const originalNextSiblingRef = (0,react.useRef)(null);
    const movedElementRef = (0,react.useRef)(null);
    const anchorSpanRef = (0,react.useRef)(null);
    const resolveTarget = (0,react.useCallback)(()=>{
        if (typeof document === "undefined") return null;
        if (targetSelector) {
            try {
                const match = document.querySelector(targetSelector);
                return match || null;
            } catch (e) {
                return null;
            }
        }
        if (targetElementId) {
            return document.getElementById(targetElementId) || null;
        }
        return null;
    }, [
        targetSelector,
        targetElementId
    ]);
    (0,react.useEffect)(()=>{
        const el = resolveTarget();
        if (!el) return;
        if (el.parentElement && el.parentElement.classList.contains("kohler-coachmark-target")) {
            wrapperElRef.current = el.parentElement;
            createdWrapperRef.current = false;
        } else {
            var ref;
            movedElementRef.current = el;
            originalParentRef.current = el.parentNode;
            originalNextSiblingRef.current = el.nextSibling;
            const wrapper2 = document.createElement("button");
            wrapper2.type = "button";
            wrapper2.className = (0,clsx/* default */.Z)(wrapperClassName, "kohler-coachmark-target");
            wrapper2.setAttribute("aria-haspopup", "dialog");
            (ref = originalParentRef.current) === null || ref === void 0 ? void 0 : ref.insertBefore(wrapper2, el);
            wrapper2.appendChild(el);
            wrapperElRef.current = wrapper2;
            createdWrapperRef.current = true;
        }
        const wrapper = wrapperElRef.current;
        if (wrapper && toggleOnExternalClick) {
            const onClick = (e)=>{
                if (disabled) return;
                onToggle();
                onExternalClick === null || onExternalClick === void 0 ? void 0 : onExternalClick(e);
            };
            wrapper.addEventListener("click", onClick);
            return ()=>{
                wrapper.removeEventListener("click", onClick);
                if (createdWrapperRef.current) {
                    const moved = movedElementRef.current;
                    const parent = originalParentRef.current;
                    if (moved && parent) {
                        if (originalNextSiblingRef.current) {
                            parent.insertBefore(moved, originalNextSiblingRef.current);
                        } else {
                            parent.appendChild(moved);
                        }
                    }
                    if (wrapper.parentNode) wrapper.remove();
                }
                wrapperElRef.current = null;
                createdWrapperRef.current = false;
                movedElementRef.current = null;
                originalParentRef.current = null;
                originalNextSiblingRef.current = null;
            };
        }
        return ()=>{
            if (createdWrapperRef.current) {
                const wrapper2 = wrapperElRef.current;
                const moved = movedElementRef.current;
                const parent = originalParentRef.current;
                if (moved && parent) {
                    if (originalNextSiblingRef.current) {
                        parent.insertBefore(moved, originalNextSiblingRef.current);
                    } else {
                        parent.appendChild(moved);
                    }
                }
                if (wrapper2 && wrapper2.parentNode) wrapper2.remove();
            }
            wrapperElRef.current = null;
            createdWrapperRef.current = false;
            movedElementRef.current = null;
            originalParentRef.current = null;
            originalNextSiblingRef.current = null;
        };
    }, [
        resolveTarget,
        disabled,
        toggleOnExternalClick,
        onToggle,
        onExternalClick,
        wrapperClassName
    ]);
    (0,react.useEffect)(()=>{
        const wrapper = wrapperElRef.current;
        const span = anchorSpanRef.current;
        if (wrapper && span && span.parentElement !== wrapper) {
            wrapper.appendChild(span);
        }
    });
    return {
        isActive: !!wrapperElRef.current,
        anchorSpanRef
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Coachmark/Coachmark.mjs
"use client";





















const Coachmark = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { variant ="default" , target , dropdown , position , size ="big" , withArrow =true , className , targetCTA , closeCTA , opened , defaultOpened =false , heading , CTA , onChange , disabled , width , targetElementId , targetSelector , toggleOnExternalClick =true , ...rest } = props;
    const [dropdownOpened, setDropdownOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange
    });
    const id = (0,use_id/* useId */.M)();
    const isDefault = variant === "default";
    const isBig = size === "big";
    const contentColor = isDefault ? colors/* DsmColor.ContentSecondary */.k.ContentSecondary : colors/* DsmColor.ContentOnSurfaceInfo */.k.ContentOnSurfaceInfo;
    const externalOnClickRef = react.useRef();
    react.useEffect(()=>{
        const fn = targetCTA === null || targetCTA === void 0 ? void 0 : targetCTA.onClick;
        externalOnClickRef.current = fn;
    }, [
        targetCTA
    ]);
    const { isActive: isDynamicTarget , anchorSpanRef  } = useCoachmarkExternalTarget({
        targetSelector,
        targetElementId,
        disabled,
        toggleOnExternalClick,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onToggle: ()=>setDropdownOpened((o)=>!o),
        onExternalClick: (e)=>{
            var ref;
            return (ref = externalOnClickRef.current) === null || ref === void 0 ? void 0 : ref.call(externalOnClickRef, e);
        },
        wrapperClassName: (0,clsx/* default */.Z)(Coachmark_module_css_classes.coachmarkDropdownTarget)
    });
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ...rest,
        ref,
        className: (0,clsx/* default */.Z)("kohler-coachmark-root", className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover/* Popover */.J, {
        opened: dropdownOpened,
        trapFocus: false,
        position,
        withinPortal: false,
        withRoles: false,
        withArrow,
        id,
        closeOnClickOutside: toggleOnExternalClick,
        disabled,
        onChange: setDropdownOpened,
        width: isBig ? Number(width) || 180 : "max-content"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover/* Popover.Target */.J.Target, null, !disabled ? !isDynamicTarget ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        ...targetCTA,
        textColor: "inherit",
        className: (0,clsx/* default */.Z)("kohler-coachmark-target", targetCTA === null || targetCTA === void 0 ? void 0 : targetCTA.className),
        onClick: (e)=>{
            var ref;
            setDropdownOpened(!dropdownOpened);
            targetCTA === null || targetCTA === void 0 ? void 0 : (ref = targetCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(targetCTA, e);
        }
    }, target) : /* @__PURE__ */ /*#__PURE__*/ react.createElement("span", {
        ref: anchorSpanRef,
        className: "kohler-coachmark-portal-anchor",
        style: {
            display: "inline-block",
            inset: "0",
            lineHeight: 0,
            overflow: "hidden",
            visibility: "hidden",
            position: "absolute"
        },
        "aria-hidden": "true"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "div"
    }, target)), dropdown && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover/* Popover.Dropdown */.J.Dropdown, {
        onMouseDown: (event)=>event.preventDefault(),
        className: (0,clsx/* default */.Z)("kohler-coachmark-wrapper"),
        backgroundColor: isDefault ? colors/* DsmColor.SurfaceTransparent */.k.SurfaceTransparent : colors/* DsmColor.SurfaceInfo */.k.SurfaceInfo
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "div",
        className: Coachmark_module_css_classes.dropdownWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 10,
        paddingRight: 5
    }, heading && isBig && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ...(0,helpers/* omitText */.rW)(heading),
        size: "label-medium-m",
        textColor: contentColor
    }, heading.text), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "div",
        size: "paragraph-small",
        textColor: contentColor
    }, dropdown)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": "close popover",
        ...closeCTA,
        onClick: (e)=>{
            var ref;
            setDropdownOpened(false);
            closeCTA === null || closeCTA === void 0 ? void 0 : (ref = closeCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(closeCTA, e);
        },
        textColor: contentColor
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        size: "small",
        withBoundingBox: true
    })), CTA && isBig && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        style: {
            gridColumnStart: "span 2"
        },
        size: "small",
        fullWidth: true,
        variant: "secondary",
        component: CTA.href ? "a" : "button",
        ...(0,helpers/* omitText */.rW)(CTA)
    }, CTA.text)))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/UserIcon.mjs


const UserIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 18,
    small: 14,
    xSmall: 11
};
const UserIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : UserIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 5.5C12.2386 5.5 10 7.73858 10 10.5C10 13.2614 12.2386 15.5 15 15.5C17.7614 15.5 20 13.2614 20 10.5C20 7.73858 17.7614 5.5 15 5.5ZM15 6.5C17.2091 6.5 19 8.29086 19 10.5C19 12.7091 17.2091 14.5 15 14.5C12.7909 14.5 11 12.7091 11 10.5C11 8.29086 12.7909 6.5 15 6.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.9951 21.7882C23.8845 19.4012 21.9143 17.5 19.5 17.5H10.5L10.2882 17.5049C7.90124 17.6155 6 19.5857 6 22V25H7V22L7.00518 21.808C7.10487 19.9643 8.63144 18.5 10.5 18.5H19.5L19.692 18.5052C21.5357 18.6049 23 20.1314 23 22V25H24V22L23.9951 21.7882Z",
        fill: "currentColor"
    }));
};
UserIcon.iconName = "UserIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/LocationIcon.mjs


const LocationIcon_withoutBoundingBoxWidth = {
    large: 27,
    medium: 15,
    small: 10,
    xSmall: 8
};
const LocationIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : LocationIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.0007 10.834C17.6995 10.834 15.834 12.6995 15.834 15.0007C15.834 17.3018 17.6995 19.1673 20.0007 19.1673C22.3018 19.1673 24.1673 17.3018 24.1673 15.0007C24.1673 12.6995 22.3018 10.834 20.0007 10.834ZM16.834 15.0007C16.834 13.2517 18.2517 11.834 20.0007 11.834C21.7496 11.834 23.1673 13.2517 23.1673 15.0007C23.1673 16.7496 21.7496 18.1673 20.0007 18.1673C18.2517 18.1673 16.834 16.7496 16.834 15.0007Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20 2C12.8525 2 7 7.47319 7 14.2947C7 15.3127 7.23318 16.4956 7.67819 17.8359L7.68126 17.8448L7.94023 18.578L7.94327 18.5863C8.03879 18.8422 8.14149 19.1038 8.25133 19.3711L8.2542 19.378L8.59953 20.1842L8.60233 20.1906C8.97468 21.0275 9.41164 21.9177 9.91266 22.8614L9.91493 22.8656L10.433 23.8193L10.4374 23.8271L10.9987 24.8179L11.0007 24.8215C11.0986 24.9909 11.1982 25.1618 11.2996 25.3343L11.3015 25.3375L11.9277 26.3841L11.9313 26.3901L12.6007 27.4741L12.6024 27.4769C12.7182 27.6616 12.8357 27.8478 12.955 28.0356L12.9566 28.0381L13.6908 29.1783L13.6939 29.183L14.4714 30.3607L14.4743 30.3651L15.295 31.5805L15.2977 31.5845L16.1616 32.8376L16.1629 32.8395C16.3109 33.0521 16.4608 33.2663 16.6124 33.4821L16.6136 33.4838L17.5424 34.7937L17.5436 34.7954C17.7024 35.0174 17.863 35.241 18.0254 35.4662L18.0269 35.4684L20.1315 38.3543L22.2004 35.4581L22.2031 35.4544L23.134 34.1257L24.0248 32.8315L24.0273 32.8278L24.8735 31.5748L24.8762 31.5709L25.68 30.3557L25.6828 30.3513L26.4443 29.1738L26.4473 29.1691L27.1664 28.0291L27.1697 28.0239L27.8465 26.9214L27.8482 26.9186C27.958 26.7371 28.0661 26.557 28.1724 26.3785L28.1742 26.3754L28.7875 25.329L28.7913 25.3224L29.3623 24.3132L29.3664 24.3059L29.895 23.3338L29.8971 23.3299C29.9825 23.1696 30.066 23.0108 30.1478 22.8535L30.1501 22.8491L30.6152 21.9326L30.6176 21.9279C32.1792 18.7695 33 16.2187 33 14.2947C33 7.47319 27.1475 2 20 2ZM8 14.2947C8 8.07983 13.3488 3 20 3C26.6512 3 32 8.07983 32 14.2947C32 15.9782 31.268 18.3559 29.7223 21.4824L29.7212 21.4847L29.2606 22.3921L29.2595 22.3943C29.1799 22.5473 29.0986 22.7018 29.0155 22.8579L29.0144 22.86L28.4899 23.8244L27.9228 24.8267L27.3133 25.8667L27.3125 25.8682C27.2079 26.0438 27.1015 26.2209 26.9934 26.3996L26.9925 26.401L26.319 27.4982L25.6031 28.6331L24.8459 29.804L24.8431 29.8083L24.0448 31.0152L24.0421 31.0192L23.2011 32.2645L23.1986 32.2681L22.3149 33.5519L22.3126 33.5553L21.3867 34.8769L21.384 34.8806L20.1231 36.6457L18.8365 34.8813L18.8357 34.8802C18.6745 34.6567 18.5151 34.4348 18.3575 34.2144L17.4306 32.9071L17.4298 32.9061C17.2795 32.6921 17.1309 32.4797 16.9842 32.2689L16.1237 31.0209L16.121 31.0169L15.3059 29.8098L15.303 29.8055L14.5301 28.6345L13.799 27.4993L13.7982 27.498C13.6806 27.3129 13.5647 27.1293 13.4507 26.9473L13.4498 26.9459L12.784 25.8677L12.1616 24.8273L12.1607 24.8258C12.0612 24.6567 11.9636 24.4892 11.8678 24.3232L11.8667 24.3214L11.3096 23.3381L10.7959 22.3925L10.7948 22.3903C10.3039 21.4656 9.87828 20.5982 9.51737 19.7873L9.17491 18.9877C9.07006 18.7324 8.97231 18.4834 8.88164 18.2407L8.62576 17.5163C8.2014 16.2372 8 15.1676 8 14.2947Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "small":
            case "xSmall":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.9422 8.71053C13.5033 8.71053 12.3369 9.87694 12.3369 11.3158C12.3369 12.7546 13.5033 13.9211 14.9422 13.9211C16.381 13.9211 17.5474 12.7546 17.5474 11.3158C17.5474 9.87694 16.381 8.71053 14.9422 8.71053ZM14.9422 9.71053C15.8287 9.71053 16.5474 10.4292 16.5474 11.3158C16.5474 12.2024 15.8287 12.9211 14.9422 12.9211C14.0556 12.9211 13.3369 12.2024 13.3369 11.3158C13.3369 10.4292 14.0556 9.71053 14.9422 9.71053Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.9422 4.5C10.8897 4.5 7.6001 7.71675 7.6001 11.6905C7.6001 12.2672 7.72786 12.9542 7.98348 13.7532L8.13559 14.2002C8.19052 14.3529 8.24967 14.5093 8.31306 14.6694L8.51589 15.1609C8.73141 15.6637 8.98498 16.2 9.27661 16.7701L9.58094 17.3515L9.91064 17.9556C9.96771 18.0581 10.0258 18.1616 10.085 18.2661L10.4528 18.9041L10.846 19.565C10.9136 19.677 10.9823 19.79 11.0521 19.9039L11.4833 20.599L11.94 21.317L12.422 22.0579L12.9295 22.8219C13.0161 22.9511 13.1039 23.0814 13.1927 23.2125L13.7383 24.0111C13.8313 24.1462 13.9254 24.2822 14.0206 24.4191L15.017 25.8373L15.9957 24.4153L16.5425 23.6052L17.0643 22.8183L17.5614 22.0545L18.0335 21.3137L18.4808 20.5958L18.9032 19.9008L19.3007 19.2287C19.3649 19.1186 19.428 19.0094 19.4901 18.9012L19.8504 18.2633L20.1857 17.648L20.4962 17.0554C20.5459 16.9585 20.5945 16.8626 20.6422 16.7676L20.9154 16.2089C21.8282 14.2928 22.2843 12.7903 22.2843 11.6905C22.2843 7.71675 18.9947 4.5 14.9422 4.5ZM14.9422 5.5C18.4473 5.5 21.2843 8.27411 21.2843 11.6905L21.2811 11.8356C21.2559 12.4286 21.0789 13.1706 20.7502 14.0595L20.5733 14.5161C20.5417 14.5943 20.509 14.6734 20.4753 14.7536L20.2605 15.2469C20.1847 15.4154 20.1046 15.5879 20.0204 15.7645L19.755 16.3064L19.4644 16.8724L19.1485 17.4627C19.0938 17.563 19.038 17.6644 18.9811 17.7668L18.6274 18.3931L18.2484 19.0435L17.8441 19.7177L17.4146 20.4159L16.9599 21.1379C16.882 21.2602 16.8031 21.3835 16.7231 21.5077L16.2305 22.2653L15.7127 23.0466C15.6243 23.1787 15.5349 23.3119 15.4444 23.4461L15.0081 24.086L14.3101 23.0766L13.7915 22.3109L13.2975 21.5679L12.8283 20.8475L12.3837 20.1499L11.9638 19.4752C11.8958 19.3647 11.8289 19.2551 11.7631 19.1464L11.3802 18.506C11.3184 18.4012 11.2577 18.2974 11.198 18.1945L10.8521 17.5886L10.5309 17.0058C10.4279 16.8154 10.3291 16.6288 10.2344 16.4461L9.96258 15.9096C9.87609 15.7346 9.79372 15.5635 9.71546 15.3963L9.49304 14.9064C9.45803 14.8266 9.42405 14.7479 9.3911 14.6701L9.20573 14.2152L9.04507 13.7837C8.74846 12.9443 8.6001 12.2458 8.6001 11.6905C8.6001 8.27411 11.4371 5.5 14.9422 5.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
LocationIcon.iconName = "LocationIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteNavFilledIcon.mjs


const FavoriteNavFilledIcon_withoutBoundingBoxWidth = {
    large: 32,
    medium: 24,
    small: 18,
    xSmall: 14
};
const FavoriteNavFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : FavoriteNavFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.6951 7.09156C3.49859 9.29305 3.43021 12.8518 5.53178 15.106L5.68872 15.2692L15.0022 24.6039L24.2843 15.3011L24.4416 15.1385C26.57 12.8563 26.51 9.29736 24.3092 7.09156L24.1233 6.91321C21.8569 4.83246 18.3351 4.89191 16.1404 7.09156L15.0015 8.232L13.8639 7.09156C11.6693 4.89191 8.14741 4.83246 5.88101 6.91321L5.6951 7.09156Z",
        fill: "currentColor"
    }));
};
FavoriteNavFilledIcon.iconName = "FavoriteNavFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteNavIcon.mjs


const FavoriteNavIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 23,
    small: 18,
    xSmall: 12
};
const FavoriteNavIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : FavoriteNavIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.69461 7.09555C3.4981 9.29704 3.42972 12.8558 5.53129 15.11L5.68823 15.2732L15.0017 24.6079L24.2838 15.3051L24.4412 15.1425C26.5695 12.8603 26.5096 9.30135 24.3087 7.09555L24.1228 6.9172C21.8564 4.83646 18.3346 4.89591 16.1399 7.09555L15.001 8.23599L13.8634 7.09555C11.6688 4.89591 8.14693 4.83646 5.88052 6.9172L5.69461 7.09555ZM13.1555 7.80186L15.0017 9.65218L16.8478 7.80186C18.7127 5.93271 21.7359 5.93271 23.6008 7.80186C25.4215 9.62661 25.4711 12.5719 23.7161 14.4539L23.5705 14.6044L15.001 23.191L6.40252 14.5734L6.25733 14.4224C4.52885 12.5683 4.58545 9.62305 6.40252 7.80186C8.26744 5.93271 11.2906 5.93271 13.1555 7.80186Z",
        fill: "currentColor"
    }));
};
FavoriteNavIcon.iconName = "FavoriteNavIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/spacings.mjs
const DsmSpacing = {
    Fixed0: "var(--spacing-fixed-0)",
    Fixed0_25: "var(--spacing-fixed-0-25)",
    Fixed0_5: "var(--spacing-fixed-0-5)",
    Fixed1: "var(--spacing-fixed-1)",
    Fixed1_5: "var(--spacing-fixed-1-5)",
    Fixed2: "var(--spacing-fixed-2)",
    Fixed2_5: "var(--spacing-fixed-2-5)",
    Fixed3: "var(--spacing-fixed-3)",
    Fixed4: "var(--spacing-fixed-4)",
    Fixed5: "var(--spacing-fixed-5)",
    Fixed6: "var(--spacing-fixed-6)",
    Fixed7: "var(--spacing-fixed-7)",
    Fixed8: "var(--spacing-fixed-8)",
    Fixed9: "var(--spacing-fixed-9)",
    Fixed10: "var(--spacing-fixed-10)",
    Fixed13: "var(--spacing-fixed-13)",
    Fixed15: "var(--spacing-fixed-15)",
    Fixed30: "var(--spacing-fixed-30)",
    Fluid4xs: "var(--spacing-fluid-4xs)",
    Fluid3xs: "var(--spacing-fluid-3xs)",
    Fluid2xs: "var(--spacing-fluid-2xs)",
    FluidXs: "var(--spacing-fluid-xs)",
    FluidS: "var(--spacing-fluid-s)",
    FluidM: "var(--spacing-fluid-m)",
    FluidL: "var(--spacing-fluid-l)",
    FluidXl: "var(--spacing-fluid-xl)",
    Fluid2xl: "var(--spacing-fluid-2xl)",
    Fluid3xl: "var(--spacing-fluid-3xl)",
    Fluid4xl: "var(--spacing-fluid-4xl)"
};
const DsmGridSpacing = {
    DefaultGutterWidth: "var(--grid-default-gutter-width)",
    DefaultMargin: "var(--grid-default-margin)",
    DefaultColumnWidth: "var(--grid-default-column-width)"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/TabbedNavigationHorizontal/TabbedNavigationHorizontal.module.css.mjs
var TabbedNavigationHorizontal_module_css_classes = {
    "tabNavigationHorizontal": "VcjZ0",
    "tabNavigationHorizontalCenter": "uBoKP",
    "underline": "yyQEp",
    "underlineNoTransition": "Xh280"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/TabbedNavigationHorizontal/TabbedNavigationHorizontal.mjs
"use client";




const TabbedNavigationHorizontal = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    var ref1, ref2;
    const { mod , tabs , align , component ="div" , value , initialSelectedTab , onTabClick , className , ...rest } = props;
    var ref3;
    const firstTabId = (ref3 = (ref1 = tabs[0]) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : (ref2 = tabs[0]) === null || ref2 === void 0 ? void 0 : ref2.text;
    const resolvedDefault = initialSelectedTab !== null && initialSelectedTab !== void 0 ? initialSelectedTab : firstTabId;
    const handleChange = (val)=>{
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(val);
    };
    const [selectedTab, setSelectedTab] = (0,use_uncontrolled/* useUncontrolled */.C)({
        value,
        defaultValue: resolvedDefault,
        finalValue: firstTabId,
        onChange: handleChange
    });
    const [underlineStyle, setUnderlineStyle] = (0,react.useState)({});
    const tabRefs = (0,react.useRef)([]);
    const [isInitialRender, setIsInitialRender] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        const selectedTabElement = tabRefs.current.find((tab)=>tab.id === selectedTab);
        if (selectedTabElement) {
            setUnderlineStyle({
                width: "".concat(selectedTabElement.offsetWidth, "px"),
                transform: "translateX(".concat(selectedTabElement.offsetLeft, "px)")
            });
        }
    }, [
        selectedTab,
        align,
        tabs
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        role: "tablist",
        mod,
        component,
        className: (0,clsx/* default */.Z)("kohler-tabbed-navigation-horizontal-root", className, TabbedNavigationHorizontal_module_css_classes.tabNavigationHorizontal),
        align: "flex-start",
        margin: 0,
        borderBottom: "1px solid var(--border-neutral-medium-contrast)",
        position: "relative",
        backgroundColor: colors/* DsmColor.SurfaceTransparent */.k.SurfaceTransparent,
        width: "100vw",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        style: {
            listStyle: "none"
        },
        paddingTop: 18,
        paddingInline: DsmGridSpacing.DefaultMargin,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: align === "center" && TabbedNavigationHorizontal_module_css_classes.tabNavigationHorizontalCenter
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        backgroundColor: colors/* DsmColor.BorderPrimary */.k.BorderPrimary,
        height: 4,
        position: "absolute",
        style: underlineStyle,
        className: (0,clsx/* default */.Z)(TabbedNavigationHorizontal_module_css_classes.underline, isInitialRender && TabbedNavigationHorizontal_module_css_classes.underlineNoTransition)
    }), tabs.map((param, index)=>{
        let { id , text , ...restTabProps } = param;
        const tabId = id || text;
        const isSelected = selectedTab === tabId;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tab, {
            role: "tab",
            type: "button",
            id: tabId,
            key: tabId,
            text,
            "aria-selected": isSelected,
            "aria-controls": "region-panel-".concat(tabId),
            ref: (el)=>tabRefs.current[index] = el,
            onClick: ()=>{
                if (isInitialRender) {
                    setIsInitialRender(false);
                }
                setSelectedTab(tabId);
                onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(tabId);
            },
            ...restTabProps
        });
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowUpIcon.mjs


const ArrowUpIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 22,
    small: 16,
    xSmall: 10
};
const ArrowUpIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : ArrowUpIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M34.2662 29L35 28.3455L20 11L5 28.3643L5.76447 28.9812L20 12.5537L34.2662 29Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.2474 22L26 21.3415L15 9L4 21.3604L4.78404 21.9811L15 10.4528L25.2474 22Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 14.533L17.8645 13.849L9.99978 5.45996L2.13501 13.849L2.86455 14.533L9.99978 6.92202L17.135 14.533Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 14.533L17.8645 13.849L9.99978 5.45996L2.13501 13.849L2.86455 14.533L9.99978 6.92202L17.135 14.533Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
ArrowUpIcon.iconName = "ArrowUpIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/RegionItem/RegionItem.module.css.mjs
var RegionItem_module_css_classes = {
    "regionItem": "_0VTmW",
    "regionItemCountry": "kMwFV",
    "languageMenuContentListLanguageItemLink": "_49wes",
    "regionItemLanguage": "q1jj3",
    "regionItemLanguageDivider": "nY6c7",
    "languageMenuContentListLanguageItemLinkInactive": "aPTcL",
    "regionItemLanguageDividerInactive": "pPWSG",
    "languageMenuContentLanguageList": "BXqRI"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/RegionItem/RegionItem.mjs
"use client";





const RegionItem = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { name , languages , isCurrentCountry , setSelectedCountry , href , className , mod , ...rest } = props;
    const [selectedRegionName, setSelectedRegionName] = (0,react.useState)(false);
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const isSmallSize = width < 1024;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(RegionItem_module_css_classes.regionItem, className),
        mod
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ref,
        component: languages ? isSmallSize ? "button" : "div" : "a",
        size: isSmallSize ? "navigation-overlay-title" : "navigation-overlay-item-m-regular",
        className: RegionItem_module_css_classes.regionItemCountry,
        textColor: isCurrentCountry && !isSmallSize ? "var(--content-action-inactive)" : "var(--content-action-default)",
        href,
        ...languages ? {
            onClick: ()=>{
                setSelectedCountry === null || setSelectedCountry === void 0 ? void 0 : setSelectedCountry(name);
                setSelectedRegionName(!selectedRegionName);
            }
        } : {
            href
        },
        ...rest
    }, name, " ", languages && isSmallSize ? selectedRegionName ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowUpIcon, {
        size: "small"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownIcon/* ArrowDownIcon */.v, {
        size: "small"
    }) : void 0), (selectedRegionName || !isSmallSize) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: RegionItem_module_css_classes.languageMenuContentLanguageList
    }, languages === null || languages === void 0 ? void 0 : languages.map((language, index)=>{
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement("li", {
            key: language.text,
            className: (0,clsx/* default */.Z)(RegionItem_module_css_classes.regionItemLanguage, !isSmallSize && index !== (languages === null || languages === void 0 ? void 0 : languages.length) - 1 && RegionItem_module_css_classes.regionItemLanguageDivider, isCurrentCountry && RegionItem_module_css_classes.regionItemLanguageDividerInactive)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            className: (0,clsx/* default */.Z)(RegionItem_module_css_classes.languageMenuContentListLanguageItemLink, isCurrentCountry && RegionItem_module_css_classes.languageMenuContentListLanguageItemLinkInactive),
            component: language.href ? "a" : "span",
            size: isSmallSize ? "navigation-overlay-title" : "navigation-overlay-item-m-bold",
            ...language
        }, language.text));
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LanguageMenu/LanguageMenu.module.css.mjs
var LanguageMenu_module_css_classes = {
    "languageMenu": "G0NH7",
    "languageMenuTab": "qKQ8r",
    "languageMenuContentWrapper": "qP9Qm",
    "languageMenuContent": "_-0Fq-",
    "languageMenuContentList": "abjm6",
    "languageMenuContentListItem": "aR--I",
    "languageMenuContentListCurrentItem": "_60Rcx",
    "languageMenuContentWrapperMobile": "-ZPAr",
    "languageMenuContentWrapperMobileLevelOne": "_1vOYm",
    "languageMenuMobileClose": "sTS1m",
    "languageMenuMobileBackText": "cWa86",
    "languageMenuMobileCloseIcon": "_16azj"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LanguageMenu/LanguageMenu.mjs
"use client";







const LanguageMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { regions , heading , copy , currentCounty , className , setIsOpenMobileMenu , setMenuType , id ="language-menu" , ...rest } = props;
    const [selectedRegionName, setSelectedRegionName] = (0,react.useState)();
    const classNames = (0,clsx/* default */.Z)(className, "kohler-language-menu-root", LanguageMenu_module_css_classes.languageMenu);
    const tabs = regions.map((param)=>{
        let { countries , name , ...rest2 } = param;
        return {
            id: name,
            text: name,
            ...rest2
        };
    });
    const selectedRegion = regions.find((region)=>region.name === selectedRegionName);
    const selectedRegionTabs = selectedRegion || regions[0];
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        id,
        component: "div",
        ref,
        className: classNames,
        ...rest
    }, tabs.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(TabbedNavigationHorizontal, {
        align: "center",
        initialSelectedTab: (ref1 = tabs[0]) === null || ref1 === void 0 ? void 0 : ref1.id,
        tabs,
        onTabClick: setSelectedRegionName,
        className: LanguageMenu_module_css_classes.languageMenuTab
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)("center-grid", LanguageMenu_module_css_classes.languageMenuContentWrapper)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LanguageMenu_module_css_classes.languageMenuContent
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        className: LanguageMenu_module_css_classes.languageMenuTitle,
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text), copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: LanguageMenu_module_css_classes.languageMenuCopy,
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        size: "paragraph-medium",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        ...(0,helpers/* omitText */.rW)(copy)
    }, copy.text)), selectedRegionTabs && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: LanguageMenu_module_css_classes.languageMenuContentList,
        role: "tabpanel",
        tabIndex: -1,
        id: "region-panel-".concat(selectedRegionTabs.name),
        "aria-labelledby": selectedRegionTabs.name,
        ref: (el)=>{
            if (el && selectedRegionName) {
                el.focus();
            }
        }
    }, selectedRegionTabs.countries.map((country)=>{
        const { name , languages , ...rest2 } = country;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: country.name,
            className: (0,clsx/* default */.Z)(LanguageMenu_module_css_classes.languageMenuContentListItem, currentCounty === name && LanguageMenu_module_css_classes.languageMenuContentListCurrentItem)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RegionItem, {
            name,
            languages,
            ...rest2
        }));
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)(LanguageMenu_module_css_classes.languageMenuContentWrapperMobile),
        rowGap: 30
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LanguageMenu_module_css_classes.languageMenuMobileClose
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
        },
        className: LanguageMenu_module_css_classes.languageMenuMobileCloseIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false,
        size: "medium"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        component: "button",
        type: "button",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        className: LanguageMenu_module_css_classes.languageMenuMobileBackText,
        onClick: ()=>{
            return selectedRegionName ? setSelectedRegionName(void 0) : setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        withBoundingBox: false,
        size: "small"
    }), " ", selectedRegionName ? "Region" : "Menu")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        className: (0,clsx/* default */.Z)(LanguageMenu_module_css_classes.languageMenuContentWrapperMobileLevelOne)
    }, !selectedRegionName ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, tabs.map((tab)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: tab.id
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-overlay-item-l",
            textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault,
            component: "button",
            type: "button",
            ...(0,helpers/* omitText */.rW)(tab),
            onClick: ()=>setSelectedRegionName(tab.id)
        }, tab.text)))) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, selectedRegionTabs.countries.map((region)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: region.name
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RegionItem, {
            ...region
        })))))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LoginMenu/LoginMenu.module.css.mjs
var LoginMenu_module_css_classes = {
    "loginMenu": "pSbfH",
    "loginMenuContent": "-f9Ib",
    "loginMenuContentList": "g0mn1",
    "loginMenuContentListLastItem": "MJn-B",
    "loginMenuMobileClose": "Ya58B",
    "loginMenuMobileBackText": "Wzpj3",
    "loginMenuMobileCloseIcon": "lOY-R",
    "loginMenuGridGap": "TGjAi"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LoginMenu/LoginMenu.mjs
"use client";





const LoginMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , headingSignIn , headingSignOut , loggedInCTAs , loggedOutCTAs , signOutCTA , isLoggedIn , setIsOpenMobileMenu , setMenuType , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    userName , id ="login-menu" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, "kohler-login-menu-root", LoginMenu_module_css_classes.loginMenu);
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const isSmallerScreen = width < 1024;
    const didMountRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
        setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
    }, [
        isLoggedIn,
        setMenuType,
        setIsOpenMobileMenu
    ]);
    var _component, _component1;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        id,
        component: "div",
        ref,
        className: classNames,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)("center-grid", LoginMenu_module_css_classes.loginMenuGridGap)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: LoginMenu_module_css_classes.loginMenuMobileClose
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": "close user menu",
        onClick: ()=>{
            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
        },
        className: LoginMenu_module_css_classes.loginMenuMobileCloseIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false,
        size: "medium"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        component: "button",
        type: "button",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        className: LoginMenu_module_css_classes.loginMenuMobileBackText,
        onClick: ()=>{
            return setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        withBoundingBox: false,
        size: "small"
    }), " Menu")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LoginMenu_module_css_classes.loginMenuContent
    }, isLoggedIn && headingSignIn && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, headingSignIn.text), !isLoggedIn && headingSignOut && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, headingSignOut.text)), (loggedInCTAs || loggedOutCTAs) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: LoginMenu_module_css_classes.loginMenuContentList
    }, isLoggedIn && loggedInCTAs && loggedInCTAs.map((CTA)=>{
        var _component, _component1;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            component: "li",
            key: CTA.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: "href" in CTA && (CTA === null || CTA === void 0 ? void 0 : CTA.href) ? (_component = CTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = CTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
            ...(0,helpers/* omitText */.rW)(CTA),
            size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
            textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault
        }, CTA.text));
    }), !isLoggedIn && loggedOutCTAs && loggedOutCTAs.map((CTA)=>{
        var _component, _component1;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            component: "li",
            key: CTA.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: "href" in CTA && (CTA === null || CTA === void 0 ? void 0 : CTA.href) ? (_component = CTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = CTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
            ...(0,helpers/* omitText */.rW)(CTA),
            size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
            textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault
        }, CTA.text));
    }), isLoggedIn && signOutCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "li",
        className: LoginMenu_module_css_classes.loginMenuContentListLastItem
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "href" in signOutCTA && (signOutCTA === null || signOutCTA === void 0 ? void 0 : signOutCTA.href) ? (_component = signOutCTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = signOutCTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
        ...(0,helpers/* omitText */.rW)(signOutCTA),
        size: isSmallerScreen ? "label-regular-l" : "label-regular-m",
        textColor: colors/* DsmColor.ContentActionDefault */.k.ContentActionDefault
    }, signOutCTA.text || "Sign Out")))));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.mjs + 1 modules
var Checkbox = __webpack_require__(39091);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/StoreMenu.module.css.mjs
var StoreMenu_module_css_classes = {
    "storeMenu": "ZR55Z",
    "storeMenuMainGrid": "w4Fxm",
    "storeMenuMainContent": "gjKP9",
    "storeMenuMainFullContent": "h43x8",
    "storeMenuContentHeading": "lcpCD",
    "storeMenuContentInfoContainer": "uK28n",
    "storeMenuContentInfo": "TjwfC",
    "storeMenuZipContainer": "Z5Gs6",
    "storeMenuContentZipContainerEyebrow": "Yl0kK",
    "storeMenuContentList": "KUq53",
    "storeMenuContentListItemLink": "kQv73",
    "storeMenuMobileClose": "AFsOW",
    "storeMenuMobileBackText": "s3mxI",
    "storeMenuMobileCloseIcon": "_7Rh7F"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/ZipCodeInputField/ZipCodeInputField.module.css.mjs
var ZipCodeInputField_module_css_classes = {
    "inputContainer": "Gg-OE",
    "inputFieldButton": "sRmnm",
    "input": "wjs4T"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/ZipCodeInputField/ZipCodeInputField.mjs
"use client";




const ZipCodeInputField = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { handleSubmit , onSubmit , id ="zipcode-input" , label ="Zip Code" , placeholder , CTA , className , inputValue , onInputChange , ...rest } = props;
    const [value, setValue] = (0,react.useState)(null);
    var ref1;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("form", {
        className: "waitlist-form",
        onSubmit: (event)=>{
            event.preventDefault();
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
            const target = event.target;
            handleSubmit(target.elements[0].value || "");
        },
        onInvalid: (e)=>{
            e.preventDefault();
        },
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        ref,
        className: (0,clsx/* default */.Z)(ZipCodeInputField_module_css_classes.inputContainer, "kohler-input-field-wrapper", className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "h4",
        component: "input",
        id,
        type: "text",
        className: (0,clsx/* default */.Z)(ZipCodeInputField_module_css_classes.input),
        placeholder: placeholder || label,
        ref,
        "aria-label": rest["aria-label"],
        autoCapitalize: "off",
        autoCorrect: "off",
        maxLength: 75,
        min: 0,
        value: (ref1 = inputValue !== null && inputValue !== void 0 ? inputValue : value) !== null && ref1 !== void 0 ? ref1 : "",
        onChange: (e)=>{
            if (typeof onInputChange === "function") {
                onInputChange(e);
            } else {
                const newValue = e.target.value;
                setValue(newValue.length === 0 ? null : newValue);
            }
        }
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "primary",
        size: "small",
        type: "submit",
        disabled: !inputValue && !value,
        className: ZipCodeInputField_module_css_classes.inputFieldButton,
        ...(0,helpers/* omitText */.rW)(CTA || {})
    }, (CTA === null || CTA === void 0 ? void 0 : CTA.text) || "Submit")));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/StoreMenu.mjs
"use client";






const StoreMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , heading , CTAs , eyebrow , subheading , storeInfo , zipCodeInput , setStoreCTA , setMenuType , setIsOpenMobileMenu , id ="store-menu" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, "kohler-store-menu-root", StoreMenu_module_css_classes.storeMenu);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        id,
        component: "div",
        ref,
        className: classNames,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)("center-grid", StoreMenu_module_css_classes.storeMenuMainGrid)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuMobileClose
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": "close store menu",
        onClick: ()=>{
            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
        },
        className: StoreMenu_module_css_classes.storeMenuMobileCloseIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false,
        size: "medium"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        component: "button",
        type: "button",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        className: StoreMenu_module_css_classes.storeMenuMobileBackText,
        onClick: ()=>{
            return setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        withBoundingBox: false,
        size: "small"
    }), " Menu")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(StoreMenu_module_css_classes.storeMenuMainContent, !storeInfo && StoreMenu_module_css_classes.storeMenuMainFullContent)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuContentHeading
    }, eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(eyebrow.text) ? "div" : eyebrow.component || "p",
        ...(0,helpers/* omitText */.rW)(eyebrow),
        size: "label-medium-m",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, eyebrow.text), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ...(0,helpers/* omitText */.rW)(heading),
        size: "navigation-overlay-title",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, heading.text), subheading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(subheading.text) ? "div" : subheading.component || "p",
        ...(0,helpers/* omitText */.rW)(subheading),
        size: "label-regular-m",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, subheading.text)), storeInfo && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuContentInfoContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: StoreMenu_module_css_classes.storeMenuContentInfo,
        size: "label-regular-m",
        component: "div"
    }, storeInfo), setStoreCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Checkbox/* Checkbox */.X, {
        ...setStoreCTA
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuZipContainer
    }, zipCodeInput.eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-medium-m",
        className: StoreMenu_module_css_classes.storeMenuContentZipContainerEyebrow,
        component: /*#__PURE__*/ (0,react.isValidElement)(zipCodeInput.eyebrow.text) ? "div" : zipCodeInput.eyebrow.component || "p"
    }, zipCodeInput.eyebrow.text), /* @__PURE__ */ /*#__PURE__*/ react.createElement(ZipCodeInputField, {
        ...zipCodeInput,
        handleSubmit: (value)=>{
            var ref;
            (ref = zipCodeInput.handleSubmit) === null || ref === void 0 ? void 0 : ref.call(zipCodeInput, value);
            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
        }
    }), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: StoreMenu_module_css_classes.storeMenuContentList
    }, CTAs.map((CTA)=>{
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: CTA.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: CTA.component || "a",
            ...(0,helpers/* omitText */.rW)(CTA),
            className: (0,clsx/* default */.Z)(StoreMenu_module_css_classes.storeMenuContentListItemLink),
            size: "label-regular-m",
            style: {
                textDecoration: "underline"
            }
        }, CTA.text));
    })))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LanguagePicker/LanguagePicker.module.css.mjs
var LanguagePicker_module_css_classes = {
    "divider": "Ojclf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LanguagePicker/LanguagePicker.mjs



const LanguagePicker = (param)=>{
    let { location , languagePickerCTA , currentLanguage , secondLanguageCTA , textColor  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 4,
        justify: "center",
        align: "center"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "overline",
        component: "button",
        type: "button",
        textColor: textColor || "var(--content-perma-white)",
        "aria-label": "pick language",
        ...languagePickerCTA
    }, location, " - ", currentLanguage), secondLanguageCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: LanguagePicker_module_css_classes.divider,
        backgroundColor: textColor
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "overline",
        component: "a",
        ...(0,helpers/* omitText */.rW)(secondLanguageCTA),
        textColor: textColor || "var(--content-perma-white)"
    }, secondLanguageCTA.text)));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/subcomponent/UtilityBarMobile/UtilityBarMobile.module.css.mjs
var UtilityBarMobile_module_css_classes = {
    "utilityBarOverlayMobile": "UM-Eb",
    "menuPositionWrapper": "CnfKM",
    "userCTAMobileWrapper": "uDuou"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/subcomponent/UtilityBarMobile/UtilityBarMobile.mjs










const omitFavoritesCTA = (favoritesCTA)=>{
    const { isFilled =false , notificationDot , ...omitFavoritesCTA2 } = favoritesCTA;
    return {
        isFilled,
        notificationDot,
        omitFavoritesCTA: omitFavoritesCTA2
    };
};
const UtilityBarMobile = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { utilityLinks , className , ...rest } = props;
    const { userCTA , locationPickerCTA , favoritesCTA , languagePicker , userName , isLoggedIn , utilityLinksMobile , menuType , storeMenu , loginMenu , languageMenu , setIsOpenMobileMenu , setMenuType , userCTAMobile  } = utilityLinks || {};
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* clsx */.W)(UtilityBarMobile_module_css_classes.utilityBarOverlayMobile, className),
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 15,
        paddingTop: 20,
        paddingBottom: 30
    }, userCTA && !userCTAMobile && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        "aria-label": isLoggedIn ? "user sign in" : "profile",
        ...userCTA,
        onClick: (e)=>{
            var ref;
            userCTA === null || userCTA === void 0 ? void 0 : (ref = userCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(userCTA, e);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "span"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, userCTA.text ? userCTA.text : isLoggedIn && userName ? "Hi, ".concat(userName) : "Sign in / Create Account"))), userCTAMobile && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, !isLoggedIn && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        className: UtilityBarMobile_module_css_classes.userCTAMobileWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "button",
        type: "button",
        onClick: (e)=>{
            var ref;
            const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.signInCTA) === null || ref === void 0 ? void 0 : ref.onClick;
            if (!userCTAOnClick) {
                var ref1;
                userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
            } else {
                userCTAOnClick(e);
            }
        },
        ...(0,helpers/* omitText */.rW)(userCTAMobile.signInCTA)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "div",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, userCTAMobile.signInCTA.text ? userCTAMobile.signInCTA.text : "Sign in ")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, "/"), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "button",
        type: "button",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        onClick: (e)=>{
            var ref;
            const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.signUpCTA) === null || ref === void 0 ? void 0 : ref.onClick;
            if (!userCTAOnClick) {
                var ref1;
                userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
            } else {
                userCTAOnClick(e);
            }
        },
        ...(0,helpers/* omitText */.rW)(userCTAMobile.signUpCTA)
    }, userCTAMobile.signUpCTA.text ? userCTAMobile.signUpCTA.text : "Create Account")), isLoggedIn && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        ...userCTAMobile.accountCTA,
        onClick: (e)=>{
            var ref;
            const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.accountCTA) === null || ref === void 0 ? void 0 : ref.onClick;
            if (!userCTAOnClick) {
                var ref1;
                userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
            } else {
                userCTAOnClick(e);
            }
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "span"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, userCTAMobile.accountCTA.text ? userCTAMobile.accountCTA.text : "Hi, ".concat(userName)))), menuType && loginMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        display: menuType !== "user" ? "none" : void 0,
        className: UtilityBarMobile_module_css_classes.menuPositionWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LoginMenu, {
        ...loginMenu,
        setMenuType,
        setIsOpenMobileMenu
    }))), utilityLinksMobile && utilityLinksMobile.length > 0 && utilityLinksMobile.map((utilityLink)=>{
        const { icon , ...linkProps } = utilityLink;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: utilityLink.text,
            component: "a",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            ...(0,helpers/* omitText */.rW)(linkProps),
            className: UtilityBarMobile_module_css_classes.utilityLink
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            gap: 5,
            align: "center",
            component: "span"
        }, icon, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-s",
            component: "span",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
        }, utilityLink.text)));
    }), locationPickerCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "button",
        ...locationPickerCTA,
        onClick: (e)=>{
            var ref;
            locationPickerCTA === null || locationPickerCTA === void 0 ? void 0 : (ref = locationPickerCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(locationPickerCTA, e);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LocationIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, locationPickerCTA.text || "Find a Store")), menuType && storeMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        display: menuType !== "store" ? "none" : void 0,
        className: UtilityBarMobile_module_css_classes.menuPositionWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(StoreMenu, {
        ...storeMenu,
        setMenuType,
        setIsOpenMobileMenu
    }))), favoritesCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Coachmark, {
        target: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            component: "a",
            align: "center",
            gap: 5,
            "aria-label": "see favorites",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            ...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NotificationDot, {
            disabled: true,
            position: "top-end",
            borderColor: "var(--surface-neutral-medium-contrast)",
            withBorder: true,
            top: 7,
            right: 6,
            ...favoritesCTA.notificationDot
        }, omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavFilledIcon, {
            withBoundingBox: true
        }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavIcon, {
            withBoundingBox: true
        })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-s",
            component: "span",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
        }, favoritesCTA.text || "Favorites")),
        disabled: !((ref1 = favoritesCTA.coachmark) === null || ref1 === void 0 ? void 0 : ref1.dropdown),
        variant: "highlight",
        size: "small",
        position: "right",
        withArrow: true,
        ...favoritesCTA.coachmark
    })), languagePicker && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        paddingBlock: 20,
        borderTop: "1px solid var(--border-tertiary)"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguagePicker, {
        ...languagePicker,
        languagePickerCTA: {
            ...getSanitizedLanguagePickerCTA(languagePicker),
            className: languagePicker.languagePickerCTA.className,
            onClick: (e)=>{
                var ref;
                if ((languagePicker === null || languagePicker === void 0 ? void 0 : languagePicker.languagePickerCTA) && (languagePicker === null || languagePicker === void 0 ? void 0 : (ref = languagePicker.languagePickerCTA) === null || ref === void 0 ? void 0 : ref.onClick)) {
                    var ref1;
                    languagePicker === null || languagePicker === void 0 ? void 0 : (ref1 = languagePicker.languagePickerCTA) === null || ref1 === void 0 ? void 0 : ref1.onClick(e);
                }
            }
        },
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    })), menuType && languageMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        display: menuType !== "language" ? "none" : void 0,
        className: UtilityBarMobile_module_css_classes.menuPositionWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguageMenu, {
        ...languageMenu,
        setMenuType,
        setIsOpenMobileMenu
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/OverlayMenu.mjs












const OverlayMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1, ref2, ref3;
    const { className , CTALists , images , mainMenuItems , setIsOpenMobileMenu , isMoreOverlay , utilityLinks , buttonCTA , closeCTA , mod , brand ="kohler" , ...rest } = props;
    const [selectedMobileMenuItem, setSelectedMobileMenuItem] = (0,react.useState)(null);
    const [selectedMoreTab, setSelectedMoreTab] = (0,react.useState)(isMoreOverlay && mainMenuItems ? mainMenuItems[0] : null);
    const CTAListsMobile = mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.find((val)=>val.text === selectedMobileMenuItem);
    const [openCategoryIndex, setOpenCategoryIndex] = (0,react.useState)(null);
    const isKlafs = brand === "klafs";
    const isKHS = brand === "khs";
    const hasUtilities = utilityLinks && (utilityLinks.menuType || utilityLinks.storeMenu || utilityLinks.languageMenu || utilityLinks.loginMenu);
    (0,react.useEffect)(()=>{
        if (isMoreOverlay) {
            setSelectedMoreTab(mainMenuItems ? mainMenuItems[0] : null);
        }
    }, [
        mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.length
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-root", OverlayMenu_module_css_classes.overlayMenu),
        ...rest,
        mod
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridMainMobileWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(OverlayMenu_module_css_classes.overlayMenuLinkGridWrapper, {
            [OverlayMenu_module_css_classes.overlayMenuLinkGridWrapperKlafs]: isKlafs && isMoreOverlay,
            [OverlayMenu_module_css_classes.overlayMenuLinkGridWrapperKHS]: isKHS
        })
    }, (CTALists || isMoreOverlay && mainMenuItems) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridLists
    }, isMoreOverlay && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuTabs, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGrid,
        brand,
        CTAs: mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.map((mainMenuItem)=>{
            return {
                text: mainMenuItem.text,
                href: mainMenuItem.href,
                onClick: ()=>setSelectedMoreTab(mainMenuItem),
                isSelected: (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.text) === mainMenuItem.text,
                hasChildrenList: !!mainMenuItem.CTALists
            };
        })
    }), (ref1 = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.CTALists) || CTALists) === null || ref1 === void 0 ? void 0 : ref1.map((CTAList, index)=>{
        if (Array.isArray(CTAList)) {
            const overlayMenuLinkGroups = CTAList;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
                direction: "column",
                gap: "40px",
                key: "select-more-tab-cta-index-".concat(index)
            }, overlayMenuLinkGroups.map((overlayMenuLinkGroup, index2)=>{
                var ref;
                /* @__PURE__ */ /*#__PURE__*/ return react.createElement(OverlayMenuLinks, {
                    key: (overlayMenuLinkGroup === null || overlayMenuLinkGroup === void 0 ? void 0 : (ref = overlayMenuLinkGroup.title) === null || ref === void 0 ? void 0 : ref.text) + "overlay-menu-".concat(index2),
                    className: OverlayMenu_module_css_classes.overlayMenuLinkGrid,
                    ...overlayMenuLinkGroup
                });
            }));
        } else {
            var ref;
            const overlayMenuLinkGroup = CTAList;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
                key: (overlayMenuLinkGroup === null || overlayMenuLinkGroup === void 0 ? void 0 : (ref = overlayMenuLinkGroup.title) === null || ref === void 0 ? void 0 : ref.text) + "overlay-menu-".concat(index)
            }, isMoreOverlay && index % 3 === 0 && index !== 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                className: OverlayMenu_module_css_classes.overlayMenuLinkGrid
            }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuLinks, {
                className: OverlayMenu_module_css_classes.overlayMenuLinkGrid,
                ...overlayMenuLinkGroup
            }));
        }
    })), ((selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.images) || images) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 30
    }, (ref2 = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.images) || images) === null || ref2 === void 0 ? void 0 : ref2.map((image)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(OverlayMenuImage, {
            key: image.image.src,
            imagesLength: (ref = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.images) || images) === null || ref === void 0 ? void 0 : ref.length,
            isBusinessTab: ![
                "Bathroom",
                "Collection",
                "Kitchen",
                "Lighting",
                "Wellness"
            ].includes((rest === null || rest === void 0 ? void 0 : rest.text) || ""),
            ...image
        });
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridMobileWrapper
    }, mainMenuItems && !selectedMobileMenuItem && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        ...closeCTA,
        onClick: (e)=>{
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
            if (closeCTA && closeCTA.onClick) {
                closeCTA.onClick(e);
            }
        },
        className: (0,clsx/* default */.Z)(OverlayMenu_module_css_classes.overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        size: "medium",
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridListsMobile
    }, mainMenuItems.map((mainMenuItem, index)=>{
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(react.Fragment, {
            key: "".concat(mainMenuItem.text, "-mobile-").concat(index)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuItem, {
            title: mainMenuItem.text,
            component: mainMenuItem.CTALists ? "button" : "a",
            href: mainMenuItem.CTALists ? void 0 : mainMenuItem.href,
            onClick: mainMenuItem.CTALists ? (e)=>{
                var ref;
                setSelectedMobileMenuItem(mainMenuItem.text);
                const CTAListsMobileMap = mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.find((val)=>val.text === mainMenuItem.text);
                setOpenCategoryIndex(CTAListsMobileMap && countCTAListsWithItems(CTAListsMobileMap) === 1 ? 0 : null);
                (ref = mainMenuItem.onClick) === null || ref === void 0 ? void 0 : ref.call(mainMenuItem, e);
            } : void 0,
            className: mainMenuItem.className
        }));
    }), buttonCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        type: buttonCTA.onClick ? "button" : void 0,
        component: "href" in buttonCTA && buttonCTA.href ? "a" : "button",
        size: "navigation-l",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        ...(0,helpers/* omitText */.rW)(buttonCTA)
    }, buttonCTA.text)))), CTAListsMobile && selectedMobileMenuItem && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 30
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkLevelOneMobile
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            if (selectedMobileMenuItem) {
                setSelectedMobileMenuItem(null);
            }
        },
        className: closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        size: "small",
        withBoundingBox: true,
        className: OverlayMenu_module_css_classes.arrowLeftIcon
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-item-s",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        width: "100%"
    }, selectedMobileMenuItem), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        ...closeCTA,
        onClick: ()=>{
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
        },
        className: (0,clsx/* default */.Z)(OverlayMenu_module_css_classes.overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        size: "medium",
        withBoundingBox: false
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column"
    }, (ref3 = CTAListsMobile.CTALists) === null || ref3 === void 0 ? void 0 : ref3.map((CTAList, index)=>{
        var ref, ref1, ref2, ref3;
        if (Array.isArray(CTAList)) {
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
                direction: "column",
                key: "cta-list-array-".concat(index)
            }, CTAList.map((CTAs, subIndex)=>{
                var ref, ref1;
                const flatIndex = index * 100 + subIndex;
                const hasItems = (ref = CTAs.items) === null || ref === void 0 ? void 0 : ref.filter(isILink);
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
                    key: (CTAs === null || CTAs === void 0 ? void 0 : (ref1 = CTAs.title) === null || ref1 === void 0 ? void 0 : ref1.text) + "overlay-category-".concat(CTAs.title, "-").concat(subIndex)
                }, CTAs.title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuCategory, {
                    title: CTAs.title,
                    isCTA: CTAs.isCTA,
                    links: hasItems || [],
                    opened: hasItems ? openCategoryIndex === flatIndex : void 0,
                    onToggle: hasItems ? ()=>setOpenCategoryIndex(openCategoryIndex === flatIndex ? null : flatIndex) : void 0,
                    className: CTAs.className
                }));
            }));
        }
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
            key: (CTAList === null || CTAList === void 0 ? void 0 : (ref = CTAList.title) === null || ref === void 0 ? void 0 : ref.text) || "overlay-category-".concat(CTAList.title)
        }, CTAList.title ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuCategory, {
            title: CTAList.title,
            isCTA: CTAList.isCTA,
            links: ((ref1 = CTAList.items) === null || ref1 === void 0 ? void 0 : ref1.filter(isILink)) || [],
            opened: ((ref2 = CTAList.items) === null || ref2 === void 0 ? void 0 : ref2.filter(isILink)) && openCategoryIndex === index,
            onToggle: ((ref3 = CTAList.items) === null || ref3 === void 0 ? void 0 : ref3.filter(isILink)) ? ()=>setOpenCategoryIndex(openCategoryIndex === index ? null : index) : void 0
        }) : CTAList.items && CTAList.items.length && CTAList.items.length > 0 && CTAList.items.map((CTAs, index2)=>{
            var ref, ref1;
            /* @__PURE__ */ /*#__PURE__*/ return react.createElement(react.Fragment, {
                key: "".concat((CTAs === null || CTAs === void 0 ? void 0 : (ref = CTAs.title) === null || ref === void 0 ? void 0 : ref.text) || "no-title", "-overlay-category-").concat(index2)
            }, CTAs.title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuCategory, {
                title: CTAs.title,
                links: (ref1 = CTAs.items) === null || ref1 === void 0 ? void 0 : ref1.filter(isILink),
                showArrow: false,
                isExternal: CTAs.newTabGroup || CTAs.title.target === "_blank"
            }));
        }));
    })), CTAListsMobile.images && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuMobileImages
    }, CTAListsMobile.images.map((image)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(OverlayMenuImage, {
            key: image.image.src,
            imagesLength: CTAListsMobile === null || CTAListsMobile === void 0 ? void 0 : (ref = CTAListsMobile.images) === null || ref === void 0 ? void 0 : ref.length,
            isBusinessTab: ![
                "Bathroom",
                "Collection",
                "Kitchen",
                "Lighting",
                "Wellness"
            ].includes((rest === null || rest === void 0 ? void 0 : rest.text) || ""),
            ...image
        });
    }))))), mainMenuItems && !selectedMobileMenuItem && hasUtilities && /* @__PURE__ */ /*#__PURE__*/ react.createElement(UtilityBarMobile, {
        utilityLinks
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.module.css.mjs
var MainNavigationBar_module_css_classes = {
    "mainNavKohler": "Tr-vJ",
    "mainNavKlafs": "psbZ2",
    "mainNavKhs": "o82Nc",
    "navItemKlafs": "_5NdkN",
    "navItemKohler": "_1oZbm",
    "navItemKhs": "ry3AM",
    "mainNav": "tnml-",
    "utilities": "Kfs6C",
    "brandLogo": "_62R2z",
    "navItem": "fiq1p",
    "mainNavBackground": "ne4QY",
    "mainNavRelative": "_1TdFf",
    "mainNavShadow": "j6WZ0",
    "mainNavWrapperKohler": "Cspcz",
    "mainNavWrapperKlafs": "Kdt8S",
    "mainNavWrapperKhs": "zt3ag",
    "menuItems": "i59c6",
    "menuItemsKohler": "KRE3o",
    "menuItemsKlafs": "yMw4o",
    "menuItemsKhs": "tf3v-",
    "menuIconKlafs": "C1bA7",
    "menuIconKohler": "FIkYu",
    "menuLinksKohler": "E57FR",
    "menuLinks": "_5tXq-",
    "menuLinksWrapper": "e1Vtw",
    "menuLinksWrapperKhs": "_-2WEJ",
    "menuLinksKlafs": "pdRTw",
    "menuLinksKhs": "cjDXa",
    "utilitiesKohlerGap": "MW-vw",
    "utilitiesKlafsGap": "qk7NK",
    "utilitiesKhsGap": "fZD7C",
    "buttonCTA": "RpRJd",
    "utilitiesMobile": "kEUDE",
    "utilitiesDivider": "-qc6O",
    "utilitiesSearch": "PCr8F",
    "utilitiesSearchMobile": "z8Qye",
    "utilitiesSearchIcon": "dZIrv",
    "navigationOverlayMenuWrapper": "uD7ZK",
    "navigationItemWrapper": "_7DmRe",
    "navigationOverlayMenuVisible": "moPVk",
    "mobileOverlayMenu": "KTfSF",
    "navItemUnderlineKlafs": "zzqMu",
    "navItemUnderlineKohler": "_2E42k",
    "navItemUnderlineKhs": "j8mz5",
    "leftSectionButtonCta": "OtSp-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.utils.mjs

const normalizeMainNavVariant = (variant, brand)=>{
    if (brand) return brand;
    switch(variant){
        case "universal":
            return "klafs";
        case "v2.1":
        default:
            return "kohler";
    }
};
const mainNavigationBarVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.mainNavKohler,
    klafs: MainNavigationBar_module_css_classes.mainNavKlafs,
    khs: MainNavigationBar_module_css_classes.mainNavKhs
};
const mainNavWrapperVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.mainNavWrapperKohler,
    klafs: MainNavigationBar_module_css_classes.mainNavWrapperKlafs,
    khs: MainNavigationBar_module_css_classes.mainNavWrapperKhs
};
const menuItemsVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.menuItemsKohler,
    klafs: MainNavigationBar_module_css_classes.menuItemsKlafs,
    khs: MainNavigationBar_module_css_classes.menuItemsKhs
};
const menuLinksVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.menuLinksKohler,
    klafs: MainNavigationBar_module_css_classes.menuLinksKlafs,
    khs: MainNavigationBar_module_css_classes.menuLinksKhs
};
const navItemVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.navItemKohler,
    klafs: MainNavigationBar_module_css_classes.navItemKlafs,
    khs: MainNavigationBar_module_css_classes.navItemKhs
};
const utilitiesGapVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.utilitiesKohlerGap,
    klafs: MainNavigationBar_module_css_classes.utilitiesKlafsGap,
    khs: MainNavigationBar_module_css_classes.utilitiesKhsGap
};
const menuIconVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.menuIconKohler,
    klafs: MainNavigationBar_module_css_classes.menuIconKlafs,
    khs: MainNavigationBar_module_css_classes.menuIconKohler
};
const navItemUnderlineVariantClasses = {
    kohler: MainNavigationBar_module_css_classes.navItemUnderlineKohler,
    klafs: MainNavigationBar_module_css_classes.navItemUnderlineKlafs,
    khs: MainNavigationBar_module_css_classes.navItemUnderlineKhs
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.mjs
"use client";









const MainNavigationBar = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { brandCTA , menuItems , showShadow , showDesktopActions =true , searchCTA , visualSearchCTA , menuCTA , searchText ="Search" , buttonCTA , variant , brand , utilityLinks , showBackground =false , mod , overlayMod: _overlayMod , openMobileMenu , closeCTA , setIsOpenMobileMenu , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isStatic , style , showMenuDelay , hideMenuDelay , transitionDuration , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isAlwaysSticky , menuOpenType ="hover" , beRelative =false , ...rest } = props;
    const normalizedMainNavVariant = normalizeMainNavVariant(variant, brand);
    const isKlafs = normalizedMainNavVariant === "klafs";
    const isKhs = normalizedMainNavVariant === "khs";
    const overlayMod = _overlayMod || mod;
    const { brand: brandType , ...brandCTAProps } = brandCTA;
    const [activeMenu, setActiveMenu] = (0,react.useState)(null);
    const hoverTimeoutRef = (0,react.useRef)(null);
    const isKeyboardOpen = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        if (!activeMenu || !isKeyboardOpen.current) return;
        isKeyboardOpen.current = false;
        const trigger = document.getElementById(activeMenu);
        const timer = setTimeout(()=>{
            var ref;
            (ref = trigger === null || trigger === void 0 ? void 0 : trigger.querySelector('[role="menuitem"]')) === null || ref === void 0 ? void 0 : ref.focus();
        }, 50);
        return ()=>clearTimeout(timer);
    }, [
        activeMenu
    ]);
    const { visibleItems , overflowItems , isMoreOpen , setIsMoreOpen , navRef , containerRef , moreButtonRef  } = useResponsiveNav(menuItems);
    const handleNavKeyDown = useMenuKeyboardNavigation({
        listRef: navRef,
        itemSelector: ":scope > li",
        orientation: "horizontal",
        currentIndexResolver: "currentTarget"
    });
    const getMenuItemTogglerEventProps = (navItem)=>{
        const togglers = {
            onKeyDown: (e)=>{
                if (e.currentTarget !== e.target) return;
                if (e.key === "ArrowDown" && navItem.CTALists) {
                    e.preventDefault();
                    const navText = navItem.text;
                    if (activeMenu !== navText) {
                        isKeyboardOpen.current = true;
                        setActiveMenu(navText);
                    } else {
                        var ref;
                        const trigger = document.getElementById(navText);
                        (ref = trigger === null || trigger === void 0 ? void 0 : trigger.querySelector('[role="menuitem"]')) === null || ref === void 0 ? void 0 : ref.focus();
                    }
                    return;
                }
                if ((e.key === "Enter" || e.key === " ") && navItem.CTALists) {
                    e.preventDefault();
                    const navText1 = navItem.text;
                    setActiveMenu((prev)=>prev === navText1 ? null : navText1);
                    return;
                }
                handleNavKeyDown(e);
            }
        };
        if (navItem.CTALists) {
            togglers.onClick = (e)=>{
                const target = e.target;
                if (target.closest('[role="menu"]') || target.closest("a[href]")) return;
                e.preventDefault();
                const navText = navItem.text;
                setActiveMenu((prev)=>prev === navText ? null : navText);
            };
        }
        switch(menuOpenType){
            case "hover":
                togglers.onMouseEnter = ()=>{
                    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
                    hoverTimeoutRef.current = setTimeout(()=>{
                        setActiveMenu(navItem.text);
                    }, typeof showMenuDelay === "number" ? showMenuDelay : 0);
                };
                togglers.onMouseLeave = ()=>{
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                        hoverTimeoutRef.current = null;
                    }
                    hoverTimeoutRef.current = setTimeout(()=>{
                        setActiveMenu(null);
                    }, typeof hideMenuDelay === "number" ? hideMenuDelay : 0);
                };
                break;
        }
        return togglers;
    };
    const getMenuListTogglerEventProps = ()=>{
        if (menuOpenType === "click") {
            return {
                onMouseLeave: ()=>{
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                        hoverTimeoutRef.current = null;
                    }
                    hoverTimeoutRef.current = setTimeout(()=>{
                        setActiveMenu(null);
                    }, typeof hideMenuDelay === "number" ? hideMenuDelay : 0);
                }
            };
        }
        return {};
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.mainNav, showShadow && MainNavigationBar_module_css_classes.mainNavShadow, mainNavigationBarVariantClasses[normalizedMainNavVariant], showBackground && MainNavigationBar_module_css_classes.mainNavBackground, beRelative && MainNavigationBar_module_css_classes.mainNavRelative, "kohler-main-navigation-bar-root"),
        ref,
        style: {
            "--transition-overlay-duration": typeof transitionDuration === "number" ? "".concat(transitionDuration, "ms") : void 0,
            ...style
        },
        mod,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: mainNavWrapperVariantClasses[normalizedMainNavVariant]
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(menuItemsVariantClasses[normalizedMainNavVariant], MainNavigationBar_module_css_classes.menuItems)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "a",
        className: MainNavigationBar_module_css_classes.brandLogo,
        "aria-label": "".concat(brandType, " logo"),
        ...brandCTAProps
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(BrandLogo, {
        brand: brandType
    })), menuItems && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref: containerRef,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.menuLinksWrapper, isKhs && MainNavigationBar_module_css_classes.menuLinksWrapperKhs),
        component: "nav",
        "aria-label": "Main Navigation"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(menuLinksVariantClasses[normalizedMainNavVariant], MainNavigationBar_module_css_classes.menuLinks),
        component: "ul",
        ref: navRef,
        ...getMenuListTogglerEventProps()
    }, visibleItems.map((navItem)=>{
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(Box/* Box */.x, {
            component: "li",
            key: navItem.text,
            id: navItem.text || "nav-item-".concat(navItem.text),
            className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationItemWrapper),
            tabIndex: 0,
            "aria-haspopup": !!navItem.CTALists,
            "aria-expanded": activeMenu === navItem.text,
            ...getMenuItemTogglerEventProps(navItem)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NavigationItem, {
            text: navItem.text,
            isSelected: navItem.isSelected,
            href: navItem.href,
            onClick: navItem.onClick,
            brand: normalizedMainNavVariant,
            tabIndex: -1,
            className: (0,clsx/* default */.Z)(navItemVariantClasses[normalizedMainNavVariant], MainNavigationBar_module_css_classes.navItem, activeMenu === navItem.text && navItemUnderlineVariantClasses[normalizedMainNavVariant])
        }), navItem.CTALists && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationOverlayMenuWrapper, activeMenu === navItem.text ? MainNavigationBar_module_css_classes.navigationOverlayMenuVisible : MainNavigationBar_module_css_classes.navigationOverlayMenuHidden),
            ...activeMenu !== navItem.text && {
                inert: "true",
                tabIndex: -1
            },
            "aria-hidden": activeMenu !== navItem.text || void 0,
            onKeyDown: (e)=>{
                if (e.key === "Escape") {
                    var ref;
                    e.stopPropagation();
                    setActiveMenu(null);
                    (ref = e.currentTarget.parentElement) === null || ref === void 0 ? void 0 : ref.focus();
                }
            }
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenu, {
            mod: overlayMod,
            brand: normalizedMainNavVariant,
            ...navItem
        }))));
    }), overflowItems.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "li",
        ref: moreButtonRef,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationItemWrapper, MainNavigationBar_module_css_classes.moreButton),
        onMouseEnter: ()=>{
            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = setTimeout(()=>{
                setIsMoreOpen(true);
            }, typeof showMenuDelay === "number" ? showMenuDelay : 0);
        },
        onMouseLeave: ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            hoverTimeoutRef.current = setTimeout(()=>{
                setIsMoreOpen(false);
            }, typeof hideMenuDelay === "number" ? hideMenuDelay : 0);
        },
        "aria-haspopup": true,
        tabIndex: 0,
        "aria-expanded": isMoreOpen,
        onKeyDown: (e)=>{
            if (e.currentTarget !== e.target) return;
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setIsMoreOpen((prev)=>!prev);
            }
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NavigationItem, {
        className: (0,clsx/* default */.Z)(navItemVariantClasses[normalizedMainNavVariant], MainNavigationBar_module_css_classes.navItem),
        text: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            gap: 5,
            align: "center"
        }, "More ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownIcon/* ArrowDownIcon */.v, {
            size: "xSmall",
            withBoundingBox: false,
            style: {
                flexShrink: 0
            }
        })),
        brand: normalizedMainNavVariant
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationOverlayMenuWrapper, isMoreOpen ? MainNavigationBar_module_css_classes.navigationOverlayMenuVisible : MainNavigationBar_module_css_classes.navigationOverlayMenuHidden)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenu, {
        mod: overlayMod,
        isMoreOverlay: true,
        mainMenuItems: overflowItems,
        brand: normalizedMainNavVariant
    }))), overflowItems.map((navItem)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: navItem.text,
            id: navItem.text || "nav-item-".concat(navItem.text),
            className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationItemWrapper),
            style: {
                visibility: "hidden",
                opacity: 0,
                display: "none"
            }
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NavigationItem, {
            text: navItem.text,
            isSelected: navItem.isSelected,
            href: navItem.href,
            brand: normalizedMainNavVariant,
            className: (0,clsx/* default */.Z)(navItemVariantClasses[normalizedMainNavVariant], MainNavigationBar_module_css_classes.navItem, activeMenu === navItem.text && navItemUnderlineVariantClasses[normalizedMainNavVariant])
        })))))), (showDesktopActions || buttonCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilities, utilitiesGapVariantClasses[normalizedMainNavVariant])
    }, buttonCTA && isKlafs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        type: buttonCTA.onClick ? "button" : void 0,
        component: "href" in buttonCTA && buttonCTA.href ? "a" : "button",
        ...(0,helpers/* omitText */.rW)(buttonCTA),
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.buttonCTA, buttonCTA.className),
        size: "small"
    }, buttonCTA.text)), buttonCTA && isKhs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        type: buttonCTA.onClick ? "button" : void 0,
        component: "href" in buttonCTA && buttonCTA.href ? "a" : "button",
        ...(0,helpers/* omitText */.rW)(buttonCTA),
        className: (0,clsx/* default */.Z)("kohler-main-navigation-bar-button-cta", buttonCTA.className),
        size: "h6",
        ..."href" in buttonCTA && buttonCTA.href ? {
            href: "tel:".concat(buttonCTA.href)
        } : {}
    }, (buttonCTA === null || buttonCTA === void 0 ? void 0 : buttonCTA.leftSection) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("span", {
        className: MainNavigationBar_module_css_classes.leftSectionButtonCta
    }, buttonCTA === null || buttonCTA === void 0 ? void 0 : buttonCTA.leftSection), buttonCTA.text), searchCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: MainNavigationBar_module_css_classes.utilitiesDivider,
        width: 1,
        height: 25,
        backgroundColor: colors/* DsmColor.BorderNeutralHighContrast */.k.BorderNeutralHighContrast
    })), searchCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": searchText,
        ...searchCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilitiesSearch, searchCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "paragraph-small",
        component: "span"
    }, searchText), /* @__PURE__ */ /*#__PURE__*/ react.createElement(SearchIcon/* SearchIcon */.W, {
        className: MainNavigationBar_module_css_classes.utilitiesSearchIcon,
        withBoundingBox: false
    })), visualSearchCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        justify: "center",
        align: "center",
        component: "button",
        type: "button",
        "aria-label": "visual search",
        ...visualSearchCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilitiesSearch, visualSearchCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(VisualSearchIcon/* VisualSearchIcon */.Z, {
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: MainNavigationBar_module_css_classes.utilitiesMobile,
        gap: 15
    }, searchCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(NotificationDot, {
        disabled: true,
        position: "top-end",
        withBorder: true,
        top: 9,
        right: 4,
        wrapperStyles: {
            display: "flex"
        },
        ...searchCTA === null || searchCTA === void 0 ? void 0 : searchCTA.notificationDot
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": searchText,
        ...searchCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilitiesSearchMobile, searchCTA === null || searchCTA === void 0 ? void 0 : searchCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(SearchIcon/* SearchIcon */.W, {
        className: MainNavigationBar_module_css_classes.utilitiesSearchIcon,
        withBoundingBox: false
    }))), (utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.cartBadgeCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(CartBadge, {
        component: "a",
        "aria-label": "see shopping cart",
        textColor: "",
        ...utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.cartBadgeCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilityLink, utilityLinks.className)
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": "open menu",
        ...menuCTA,
        className: (0,clsx/* default */.Z)(menuIconVariantClasses[normalizedMainNavVariant], menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.className),
        onClick: (e)=>{
            setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(true);
            if (menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.onClick) {
                menuCTA.onClick(e);
            }
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NotificationDot, {
        disabled: true,
        position: "top-end",
        withBorder: true,
        top: 8,
        right: 2,
        ...utilityLinks === null || utilityLinks === void 0 ? void 0 : (ref1 = utilityLinks.favoritesCTA) === null || ref1 === void 0 ? void 0 : ref1.notificationDot
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(MenuIcon/* MenuIcon */.O, {
        size: "medium",
        withBoundingBox: false
    }))))), openMobileMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Portal/* Portal */.h, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenu, {
        mod: overlayMod,
        mainMenuItems: menuItems,
        className: MainNavigationBar_module_css_classes.mobileOverlayMenu,
        setIsOpenMobileMenu,
        utilityLinks,
        buttonCTA: isKhs ? {
            ...buttonCTA,
            ...buttonCTA && "href" in buttonCTA && buttonCTA.href ? {
                href: "tel:".concat(buttonCTA.href)
            } : {}
        } : buttonCTA,
        closeCTA,
        brand: normalizedMainNavVariant
    }))))));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.mjs + 6 modules
var Carousel = __webpack_require__(83022);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/CarouselSlide/CarouselSlide.mjs
var CarouselSlide = __webpack_require__(7749);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightIcon.mjs
var ArrowRightIcon = __webpack_require__(51782);
;// CONCATENATED MODULE: ./node_modules/embla-carousel-autoplay/esm/embla-carousel-autoplay.esm.js
const defaultOptions = {
  active: true,
  breakpoints: {},
  delay: 4000,
  jump: false,
  playOnInit: true,
  stopOnFocusIn: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  stopOnLastSnap: false,
  rootNode: null
};

function normalizeDelay(emblaApi, delay) {
  const scrollSnaps = emblaApi.scrollSnapList();
  if (typeof delay === 'number') {
    return scrollSnaps.map(() => delay);
  }
  return delay(scrollSnaps, emblaApi);
}
function getAutoplayRootNode(emblaApi, rootNode) {
  const emblaRootNode = emblaApi.rootNode();
  return rootNode && rootNode(emblaRootNode) || emblaRootNode;
}

function Autoplay(userOptions = {}) {
  let options;
  let emblaApi;
  let destroyed;
  let delay;
  let timerStartTime = null;
  let timerId = 0;
  let autoplayActive = false;
  let mouseIsOver = false;
  let playOnDocumentVisible = false;
  let jump = false;
  function init(emblaApiInstance, optionsHandler) {
    emblaApi = emblaApiInstance;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, Autoplay.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    if (emblaApi.scrollSnapList().length <= 1) return;
    jump = options.jump;
    destroyed = false;
    delay = normalizeDelay(emblaApi, options.delay);
    const {
      eventStore,
      ownerDocument
    } = emblaApi.internalEngine();
    const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
    const root = getAutoplayRootNode(emblaApi, options.rootNode);
    eventStore.add(ownerDocument, 'visibilitychange', visibilityChange);
    if (isDraggable) {
      emblaApi.on('pointerDown', pointerDown);
    }
    if (isDraggable && !options.stopOnInteraction) {
      emblaApi.on('pointerUp', pointerUp);
    }
    if (options.stopOnMouseEnter) {
      eventStore.add(root, 'mouseenter', mouseEnter);
    }
    if (options.stopOnMouseEnter && !options.stopOnInteraction) {
      eventStore.add(root, 'mouseleave', mouseLeave);
    }
    if (options.stopOnFocusIn) {
      emblaApi.on('slideFocusStart', stopAutoplay);
    }
    if (options.stopOnFocusIn && !options.stopOnInteraction) {
      eventStore.add(emblaApi.containerNode(), 'focusout', startAutoplay);
    }
    if (options.playOnInit) startAutoplay();
  }
  function destroy() {
    emblaApi.off('pointerDown', pointerDown).off('pointerUp', pointerUp).off('slideFocusStart', stopAutoplay);
    stopAutoplay();
    destroyed = true;
    autoplayActive = false;
  }
  function setTimer() {
    const {
      ownerWindow
    } = emblaApi.internalEngine();
    ownerWindow.clearTimeout(timerId);
    timerId = ownerWindow.setTimeout(next, delay[emblaApi.selectedScrollSnap()]);
    timerStartTime = new Date().getTime();
    emblaApi.emit('autoplay:timerset');
  }
  function clearTimer() {
    const {
      ownerWindow
    } = emblaApi.internalEngine();
    ownerWindow.clearTimeout(timerId);
    timerId = 0;
    timerStartTime = null;
    emblaApi.emit('autoplay:timerstopped');
  }
  function startAutoplay() {
    if (destroyed) return;
    if (documentIsHidden()) {
      playOnDocumentVisible = true;
      return;
    }
    if (!autoplayActive) emblaApi.emit('autoplay:play');
    setTimer();
    autoplayActive = true;
  }
  function stopAutoplay() {
    if (destroyed) return;
    if (autoplayActive) emblaApi.emit('autoplay:stop');
    clearTimer();
    autoplayActive = false;
  }
  function visibilityChange() {
    if (documentIsHidden()) {
      playOnDocumentVisible = autoplayActive;
      return stopAutoplay();
    }
    if (playOnDocumentVisible) startAutoplay();
  }
  function documentIsHidden() {
    const {
      ownerDocument
    } = emblaApi.internalEngine();
    return ownerDocument.visibilityState === 'hidden';
  }
  function pointerDown() {
    if (!mouseIsOver) stopAutoplay();
  }
  function pointerUp() {
    if (!mouseIsOver) startAutoplay();
  }
  function mouseEnter() {
    mouseIsOver = true;
    stopAutoplay();
  }
  function mouseLeave() {
    mouseIsOver = false;
    startAutoplay();
  }
  function play(jumpOverride) {
    if (typeof jumpOverride !== 'undefined') jump = jumpOverride;
    startAutoplay();
  }
  function stop() {
    if (autoplayActive) stopAutoplay();
  }
  function reset() {
    if (autoplayActive) startAutoplay();
  }
  function isPlaying() {
    return autoplayActive;
  }
  function next() {
    const {
      index
    } = emblaApi.internalEngine();
    const nextIndex = index.clone().add(1).get();
    const lastIndex = emblaApi.scrollSnapList().length - 1;
    const kill = options.stopOnLastSnap && nextIndex === lastIndex;
    if (emblaApi.canScrollNext()) {
      emblaApi.scrollNext(jump);
    } else {
      emblaApi.scrollTo(0, jump);
    }
    emblaApi.emit('autoplay:select');
    if (kill) return stopAutoplay();
    startAutoplay();
  }
  function timeUntilNext() {
    if (!timerStartTime) return null;
    const currentDelay = delay[emblaApi.selectedScrollSnap()];
    const timePastSinceStart = new Date().getTime() - timerStartTime;
    return currentDelay - timePastSinceStart;
  }
  const self = {
    name: 'autoplay',
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset,
    isPlaying,
    timeUntilNext
  };
  return self;
}
Autoplay.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-autoplay.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/PromoBanner/PromoBanner.module.css.mjs
var PromoBanner_module_css_classes = {
    "promoBanner": "zHJqC",
    "promoBannerSlide": "_2gfyC",
    "inlineLink": "_7C-k2"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/PromoBanner/PromoBanner.mjs
"use client";






const PromoBanner = (param)=>{
    let { content , carouselControlProps , autoplay =true , autoplayDelay =5e3  } = param;
    const autoplayPluginRef = (0,react.useRef)(autoplay ? Autoplay({
        delay: autoplayDelay
    }) : null);
    const plugins = (0,react.useMemo)(()=>autoplayPluginRef.current ? [
            autoplayPluginRef.current
        ] : void 0, [
        autoplayPluginRef.current
    ]);
    const handleMouseEnter = ()=>{
        var ref;
        (ref = autoplayPluginRef.current) === null || ref === void 0 ? void 0 : ref.stop();
    };
    const handleMouseLeave = ()=>{
        var ref;
        (ref = autoplayPluginRef.current) === null || ref === void 0 ? void 0 : ref.play();
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(PromoBanner_module_css_classes.promoBanner, "kohler-promo-banner-root"),
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel/* Carousel */.l, {
        maxWidth: "min(760px, calc(100% - 2 * 30px))",
        withControls: content.length > 1,
        draggable: content.length > 1,
        includeGapInSize: false,
        style: {
            justifySelf: "center",
            marginInline: "auto"
        },
        loop: true,
        plugins,
        onMouseEnter: autoplay ? handleMouseEnter : void 0,
        onMouseLeave: autoplay ? handleMouseLeave : void 0,
        carouselControlProps: {
            ...carouselControlProps
        },
        customLeftControl: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "button",
            type: "button",
            display: "flex",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            "aria-label": "go to previous slide"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
            withBoundingBox: true,
            size: "small"
        })),
        customRightControl: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "button",
            type: "button",
            display: "flex",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            "aria-label": "go to next slide"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
            withBoundingBox: true,
            size: "small"
        }))
    }, content.map((message, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide/* CarouselSlide */.q, {
            key: "promo-banner-".concat(index),
            className: PromoBanner_module_css_classes.promoBannerSlide
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "div",
            textAlign: "center",
            maxWidth: 700,
            style: {
                justifySelf: "center"
            },
            marginInline: 30
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "label-medium-xs",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            component: "span"
        }, message.content), message.CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, message.CTAs.map((link)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
                component: "href" in link && link.href ? "a" : "button",
                size: "label-medium-xs",
                textDecoration: "underline",
                textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
                whiteSpace: "nowrap",
                key: link.text,
                className: PromoBanner_module_css_classes.inlineLink,
                ...(0,helpers/* omitText */.rW)(link)
            }, link.text))))))))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/InfoBanner/InfoBanner.module.css.mjs
var InfoBanner_module_css_classes = {
    "infoBanner": "oWmAV",
    "infoBannerContent": "chMq3"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/InfoBanner/InfoBanner.mjs




const InfoBanner = (param)=>{
    let { content  } = param;
    const { message  } = content;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(InfoBanner_module_css_classes.infoBanner, "kohler-info-banner-root")
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: InfoBanner_module_css_classes.infoBannerContent
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textTransform: "uppercase",
        size: "caption-s",
        component: "div"
    }, message))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/GlobalBanner/GlobalBanner.module.css.mjs
var GlobalBanner_module_css_classes = {
    "globalBanner": "ZYZKS",
    "inlineLink": "upHNF"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/GlobalBanner/GlobalBanner.mjs
"use client";





const GlobalBanner = (param)=>{
    let { content , carouselControlProps  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(GlobalBanner_module_css_classes.globalBanner, "kohler-global-banner-root"),
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel/* Carousel */.l, {
        maxWidth: "min(calc(700px + 2 * 30px), 100%)",
        withControls: content.length > 1,
        includeGapInSize: false,
        loop: true,
        draggable: content.length > 1,
        style: {
            justifySelf: "center"
        },
        carouselControlProps: {
            ...carouselControlProps
        },
        customLeftControl: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "button",
            type: "button",
            display: "flex",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            "aria-label": "go to previous slide"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
            withBoundingBox: true,
            size: "small"
        })),
        customRightControl: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "button",
            type: "button",
            display: "flex",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            "aria-label": "go to next slide"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
            withBoundingBox: true,
            size: "small"
        }))
    }, content.map((item, index)=>{
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide/* CarouselSlide */.q, {
            key: "global-banner-".concat(index),
            className: GlobalBanner_module_css_classes.globalBannerSlide
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "div",
            textAlign: "center",
            maxWidth: 700,
            paddingInline: 30,
            marginTop: -1
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "paragraph-small",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            component: "span"
        }, item.message), item.CTA && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "label-medium-xs",
            whiteSpace: "nowrap",
            textDecoration: "underline",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            component: "href" in item.CTA && item.CTA.href ? "a" : "button",
            ...(0,helpers/* omitText */.rW)(item.CTA),
            className: GlobalBanner_module_css_classes.inlineLink
        }, item.CTA.text)));
    })))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/MessageBanner.mjs






const MessageBanner = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , type , mod ="white" , ...rest } = props;
    switch(type){
        case "promo":
            {
                const { content , carouselControlProps , autoplay , autoplayDelay , ...boxProps } = rest;
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                    ...boxProps,
                    mod,
                    ref,
                    className: (0,clsx/* default */.Z)(className, "kohler-message-banner-root")
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PromoBanner, {
                    content,
                    carouselControlProps,
                    autoplay,
                    autoplayDelay
                }));
            }
        case "global":
            {
                const { content: content1 , carouselControlProps: carouselControlProps1 , ...boxProps1 } = rest;
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                    ...boxProps1,
                    mod,
                    ref,
                    className: (0,clsx/* default */.Z)(className, "kohler-message-banner-root")
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GlobalBanner, {
                    content: content1,
                    carouselControlProps: carouselControlProps1
                }));
            }
        case "info":
            {
                const { content: content2 , ...boxProps2 } = rest;
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                    ...boxProps2,
                    mod,
                    ref,
                    className: (0,clsx/* default */.Z)(className, "kohler-message-banner-root")
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(InfoBanner, {
                    content: content2
                }));
            }
        default:
            {
                return null;
            }
    }
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MenuWrapper/MenuWrapper.module.css.mjs
var MenuWrapper_module_css_classes = {
    "menuPositionWrapper": "QcCOv",
    "menuPositionWrapperBody": "QPb4m"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MenuWrapper/MenuWrapper.mjs




const MenuWrapper = (props)=>{
    const { children , currentType , menuType , setMenuType , isOpen: isOpenProp  } = props;
    const menuContentRef = (0,react.useRef)(null);
    const isOpen = isOpenProp !== null && isOpenProp !== void 0 ? isOpenProp : menuType === currentType;
    const handleOverlayClickCapture = (e)=>{
        if (!isOpen) return;
        if (e.target === e.currentTarget) {
            setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(MenuWrapper_module_css_classes.menuPositionWrapper, isOpen && MenuWrapper_module_css_classes.menuPositionWrapperBody),
        "data-open": isOpen ? "true" : "false",
        hidden: !isOpen,
        "aria-hidden": !isOpen ? true : void 0,
        ...{
            inert: !isOpen ? "" : void 0
        },
        onClickCapture: handleOverlayClickCapture
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        ref: menuContentRef
    }, children));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LocationPickButton/LocationPickButton.module.css.mjs
var LocationPickButton_module_css_classes = {
    "locationPickButtonContainer": "D2D4P"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LocationPickButton/LocationPickButton.mjs





const LocationPickButton = (props)=>{
    const { text , className , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "button",
        type: "button",
        size: "overline",
        className: (0,clsx/* default */.Z)(LocationPickButton_module_css_classes.locationPickButtonContainer, className),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LocationIcon, {
        withBoundingBox: false
    }), " ", text);
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/UtilityLinks.module.css.mjs
var UtilityLinks_module_css_classes = {
    "utilityLinks": "JYuAi",
    "divider": "gk5hS"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/UtilityLinks.mjs
"use client";











const UtilityLinks_omitFavoritesCTA = (favoritesCTA)=>{
    const { isFilled =false , notificationDot , ...omitFavoritesCTA2 } = favoritesCTA;
    return {
        isFilled,
        notificationDot,
        omitFavoritesCTA: omitFavoritesCTA2
    };
};
const UtilityLinks = (param)=>{
    let { isLoggedIn =false , locationPickerCTA , languagePicker , favoritesCTA , cartBadgeCTA , userName , userCTA , utilityLinksDesktop , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    utilityLinksMobile , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    userCTAMobile , menuType , storeMenu , loginMenu , languageMenu , setMenuType , setIsOpenMobileMenu , currentlyUsedBrand ="kohler" , className , ...rest } = param;
    var ref, ref1, ref2;
    (0,react.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Escape") {
                setMenuType === null || setMenuType === void 0 ? void 0 : setMenuType(null);
                setIsOpenMobileMenu === null || setIsOpenMobileMenu === void 0 ? void 0 : setIsOpenMobileMenu(false);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        setMenuType,
        setIsOpenMobileMenu
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(UtilityLinks_module_css_classes.utilityLinks, className),
        gap: 20,
        ...rest
    }, (locationPickerCTA || languagePicker || utilityLinksDesktop) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center",
        gap: 25,
        paddingLeft: 25
    }, (utilityLinksDesktop === null || utilityLinksDesktop === void 0 ? void 0 : utilityLinksDesktop.length) && utilityLinksDesktop.map((utilityLink)=>{
        const { icon , ...linkProps } = utilityLink;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            key: utilityLink.text,
            component: "a",
            align: "center",
            gap: 10,
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            ...(0,helpers/* omitText */.rW)(linkProps)
        }, icon, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: currentlyUsedBrand === "klafs" ? "label-medium-s" : "overline",
            component: "span",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
        }, utilityLink.text));
    }), locationPickerCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(LocationPickButton, {
        "aria-expanded": menuType === "store",
        "aria-controls": "store-menu",
        ...locationPickerCTA
    }), storeMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MenuWrapper, {
        menuType,
        currentType: "store",
        setMenuType,
        isOpen: menuType === "store"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(StoreMenu, {
        ...storeMenu,
        setMenuType,
        setIsOpenMobileMenu
    })), languagePicker && /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguagePicker, {
        ...languagePicker,
        languagePickerCTA: {
            "aria-controls": "language-menu",
            "aria-expanded": menuType === "language",
            ...languagePicker.languagePickerCTA
        }
    }), languageMenu && languageMenu.regions && languageMenu.regions.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MenuWrapper, {
        menuType,
        currentType: "language",
        setMenuType,
        isOpen: menuType === "language"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguageMenu, {
        ...languageMenu,
        setMenuType,
        setIsOpenMobileMenu
    }))), (locationPickerCTA || languagePicker) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: UtilityLinks_module_css_classes.divider
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: UtilityLinks_module_css_classes.utilityLink,
        gap: 15,
        align: "center"
    }, userCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        display: "flex",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        "aria-label": isLoggedIn ? "user sign in" : "profile",
        "aria-expanded": menuType === "user",
        "aria-controls": "login-menu",
        ...(0,helpers/* omitText */.rW)(userCTA)
    }, isLoggedIn && userName ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-medium-xs",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary
    }, "Hi, ", userName) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: false
    })), loginMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MenuWrapper, {
        menuType,
        currentType: "user",
        setMenuType,
        isOpen: menuType === "user"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LoginMenu, {
        ...loginMenu,
        setMenuType,
        setIsOpenMobileMenu
    })), favoritesCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Coachmark, {
        target: /* @__PURE__ */ /*#__PURE__*/ react.createElement(NotificationDot, {
            disabled: true,
            position: "top-end",
            top: 7,
            right: 3,
            withBorder: true,
            ...favoritesCTA.notificationDot
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: (favoritesCTA === null || favoritesCTA === void 0 ? void 0 : (ref = favoritesCTA.coachmark) === null || ref === void 0 ? void 0 : ref.dropdown) && ((ref1 = favoritesCTA.notificationDot) === null || ref1 === void 0 ? void 0 : ref1.disabled) === false ? "span" : "a",
            display: "flex",
            "aria-label": "see favorites",
            textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
            ...UtilityLinks_omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
        }, UtilityLinks_omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavFilledIcon, {
            withBoundingBox: false
        }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavIcon, {
            withBoundingBox: false
        }))),
        disabled: !((ref2 = favoritesCTA.coachmark) === null || ref2 === void 0 ? void 0 : ref2.dropdown),
        variant: "highlight",
        size: "small",
        position: "bottom",
        withArrow: true,
        ...favoritesCTA.coachmark
    }), cartBadgeCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(CartBadge, {
        display: "flex",
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        component: cartBadgeCTA.href ? "a" : "button",
        "aria-label": "see cart",
        withBoundingBox: false,
        ...cartBadgeCTA
    })));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityBar/UtilityBar.module.css.mjs
var UtilityBar_module_css_classes = {
    "utilityBar": "PL9MW",
    "utilityBarContent": "_9Smdc",
    "utilityBrands": "xuHNv",
    "utilityBrand": "_02ugQ",
    "utilityBrandActive": "umtRO",
    "utilityLinksWrapper": "F3cqT"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityBar/UtilityBar.mjs





const UtilityBar = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { brands , mod , loginMenu , storeMenu , languageMenu , menuType , setMenuType , favoritesCTA , cartBadgeCTA , userCTA , isLoggedIn , languagePicker , locationPickerCTA , userName , utilityLinksMobile , utilityLinksDesktop , userCTAMobile , setIsOpenMobileMenu , currentlyUsedBrand , ...rest } = props;
    const utilityLinks = {
        favoritesCTA,
        cartBadgeCTA,
        userCTA,
        isLoggedIn,
        languagePicker,
        locationPickerCTA,
        userName,
        utilityLinksMobile,
        utilityLinksDesktop,
        userCTAMobile
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: UtilityBar_module_css_classes.utilityBar,
        mod,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: UtilityBar_module_css_classes.utilityBarContent
    }, brands && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        className: UtilityBar_module_css_classes.utilityBrands
    }, brands.map((brand)=>{
        const { isActive , ...brandProps } = brand;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: brand.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-brand-switcher",
            component: "a",
            target: "_blank",
            ...(0,helpers/* omitText */.rW)(brandProps),
            className: (0,clsx/* default */.Z)(UtilityBar_module_css_classes.utilityBrand, isActive && UtilityBar_module_css_classes.utilityBrandActive)
        }, brand.text));
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(UtilityLinks, {
        ...utilityLinks,
        menuType,
        className: UtilityBar_module_css_classes.utilityLinksWrapper,
        loginMenu,
        storeMenu,
        languageMenu,
        setIsOpenMobileMenu,
        setMenuType,
        currentlyUsedBrand
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/MainMenu.mjs
"use client";













const MainMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { className , infoBanner , globalBanner , mainNavigation , utilityBar , promoBanner , storeMenu , loginMenu , languageMenu , mod , style , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.mainMenu, className, "kohler-main-menu-root");
    const [menuType, setMenuType] = (0,react.useState)(null);
    const [mainMenuHeight, setMainMenuHeight] = (0,react.useState)(0);
    const [openMobileMenu, setOpenMobileMenu] = (0,react.useState)(false);
    const mainMenuWrapperRef = (0,react.useRef)(null);
    const mainNavigationRef = (0,react.useRef)(null);
    const composeMainMenuWrapperRef = (0,use_merged_ref/* useMergedRef */.Yx)(mainMenuWrapperRef, ref);
    const { showStickyNav , isSticky  } = useStickyNavigation(mainMenuHeight, mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.isAlwaysSticky);
    const [firstStickyApplied, setFirstStickyApplied] = (0,react.useState)(false);
    (0,react.useImperativeHandle)(ref, ()=>{
        const domNode = mainMenuWrapperRef.current;
        if (!domNode) return null;
        return Object.assign(domNode, {
            setMenuType
        });
    });
    (0,react.useEffect)(()=>{
        if (isSticky && !firstStickyApplied) {
            setFirstStickyApplied(true);
        } else if (!isSticky && firstStickyApplied) {
            setFirstStickyApplied(false);
        }
    }, [
        isSticky,
        firstStickyApplied
    ]);
    const disableTransition = isSticky && !firstStickyApplied;
    const typedUtilityBar = {
        ...utilityBar,
        storeMenu,
        loginMenu,
        languageMenu,
        menuType,
        setMenuType,
        setIsOpenMobileMenu: setOpenMobileMenu
    };
    if (typedUtilityBar) {
        if (typedUtilityBar.languagePicker && languageMenu) {
            var ref2, ref3;
            const originalOnClick = utilityBar === null || utilityBar === void 0 ? void 0 : (ref2 = utilityBar.languagePicker) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.languagePickerCTA) === null || ref3 === void 0 ? void 0 : ref3.onClick;
            typedUtilityBar.languagePicker.languagePickerCTA.onClick = (e)=>{
                if (originalOnClick) {
                    originalOnClick(e);
                }
                if (menuType === "language") {
                    setMenuType(null);
                } else {
                    setMenuType("language");
                }
            };
        }
        if (typedUtilityBar.locationPickerCTA && storeMenu) {
            var ref4;
            const originalOnClick1 = utilityBar === null || utilityBar === void 0 ? void 0 : (ref4 = utilityBar.locationPickerCTA) === null || ref4 === void 0 ? void 0 : ref4.onClick;
            typedUtilityBar.locationPickerCTA.onClick = (e)=>{
                if (originalOnClick1) {
                    originalOnClick1(e);
                }
                if (menuType === "store") {
                    setMenuType(null);
                } else {
                    setMenuType("store");
                }
            };
        }
        if (typedUtilityBar && loginMenu) {
            var ref5;
            const originalOnClick2 = utilityBar === null || utilityBar === void 0 ? void 0 : (ref5 = utilityBar.userCTA) === null || ref5 === void 0 ? void 0 : ref5.onClick;
            typedUtilityBar.userCTA = (utilityBar === null || utilityBar === void 0 ? void 0 : utilityBar.userCTA) || {};
            typedUtilityBar.userCTA.onClick = (e)=>{
                if (originalOnClick2) {
                    originalOnClick2(e);
                }
                setMenuType(menuType === "user" ? null : "user");
            };
        }
    }
    (0,react.useEffect)(()=>{
        if (mainMenuWrapperRef.current) {
            var ref;
            const mainMenuWrapperHeight = mainMenuWrapperRef.current.clientHeight;
            const mainNavigationHeight = (ref = mainNavigationRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
            const menuHeight = (mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.showBackground) && mainNavigation.isStatic ? mainMenuWrapperHeight - (mainNavigationHeight || 0) : mainMenuWrapperHeight;
            setMainMenuHeight(menuHeight);
        }
    }, [
        setMainMenuHeight
    ]);
    (0,react.useEffect)(()=>{
        if (mainNavigationRef.current) {
            const height = mainNavigationRef.current.clientHeight;
            document.body.style.setProperty("--main-menu-height", "".concat(showStickyNav ? height : 0, "px"));
        }
    }, [
        showStickyNav
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "header",
        ref: composeMainMenuWrapperRef,
        ...rest,
        className: classNames,
        mod,
        style: {
            "--main-menu-height": "".concat(mainMenuHeight, "px"),
            ...style
        }
    }, infoBanner && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MessageBanner, {
        type: "info",
        ...infoBanner
    }), globalBanner && globalBanner.content && globalBanner.content.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MessageBanner, {
        type: "global",
        ...globalBanner
    }), typedUtilityBar && utilityBar && /* @__PURE__ */ /*#__PURE__*/ react.createElement(UtilityBar, {
        ...typedUtilityBar,
        menuType,
        setMenuType,
        storeMenu,
        languageMenu,
        loginMenu,
        setIsOpenMobileMenu: setOpenMobileMenu,
        currentlyUsedBrand: mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.brand
    }), promoBanner && promoBanner.content && promoBanner.content.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MessageBanner, {
        type: "promo",
        ...promoBanner
    }), mainNavigation && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, showStickyNav && isSticky && mainNavigation.showBackground && mainNavigation.isStatic && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        style: {
            height: isSticky ? "".concat((ref1 = mainNavigationRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight, "px") : "auto",
            backgroundColor: "transparent",
            transition: "none"
        }
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(classes.mainNavigationBarWrapper, {
            [classes.fixedNav]: isSticky && showStickyNav,
            [classes.showSticky]: showStickyNav,
            [classes.showBackgroundRelative]: (mainNavigation.showBackground || mainNavigation.isStatic) && !isSticky
        }),
        style: disableTransition ? {
            transitionDuration: "0s"
        } : void 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(MainNavigationBar, {
        ...mainNavigation,
        mod: mainNavigation.mod || mod || "white",
        utilityLinks: typedUtilityBar,
        setIsOpenMobileMenu: setOpenMobileMenu,
        openMobileMenu,
        ref: mainNavigationRef,
        showBackground: mainNavigation.showBackground || showStickyNav && isSticky,
        beRelative: mainNavigation.isStatic && mainNavigation.showBackground
    }))));
});


// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx
var UtilityWidgets = __webpack_require__(55938);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./i18n/useAuthUtilityNavi18n.js
var useAuthUtilityNavi18n = __webpack_require__(46967);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./constants/index.js
var constants_0 = __webpack_require__(96301);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/FindStoreUtilNav/analytics.js
var analytics = __webpack_require__(90062);
// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/localization.js
var localization = __webpack_require__(26977);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./components/FindStore/v1/api.js
var v1_api = __webpack_require__(2182);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(96352);
// EXTERNAL MODULE: ./i18n/useFindStorei18n.js
var useFindStorei18n = __webpack_require__(83511);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var HeaderNavTabs_analytics = __webpack_require__(24897);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/GlobalVisualSearch.js + 23 modules
var GlobalVisualSearch = __webpack_require__(59522);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./store/features/searchSlice.js
var searchSlice = __webpack_require__(57879);
// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
;// CONCATENATED MODULE: ./hooks/useIsVSFeatFirstTime.js

/**
 *Custom hook to manage the first-time user experience for Visual Search feature.
 * It checks localStorage to determine if the user is using the feature for the first time
 * and provides a state variable and setter function to manage this state.
 * @return {[boolean, React.Dispatch<React.SetStateAction<boolean>>]}
 */ function useIsVSFeatFirstTime() {
    const [isFirstTime, setIsFirstTime] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (true) {
            let isFirstTimeValue = localStorage.getItem("usingVSforFirstTime");
            if (isFirstTimeValue === null) {
                localStorage.setItem("usingVSforFirstTime", "true");
                isFirstTimeValue = "true";
            }
            setIsFirstTime(isFirstTimeValue === "true");
        }
    }, []);
    (0,react.useEffect)(()=>{
        const handleStorageChange = (event)=>{
            if (event.key === "usingVSforFirstTime") {
                setIsFirstTime(event.newValue === "true");
            }
        };
        window.addEventListener("storage", handleStorageChange);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);
    return [
        isFirstTime,
        setIsFirstTime
    ];
}

// EXTERNAL MODULE: ./components/GlobalVisualSearch/GlobalVSContent/index.jsx + 2 modules
var GlobalVSContent = __webpack_require__(31980);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/SearchNotification/index.module.scss
var index_module = __webpack_require__(33369);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/GlobalVisualSearch/SearchNotification/icons.js

const icons_SearchIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        className: "nav-search-icon",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.54785 0.0185242C3.38846 0.0185242 0.0166016 3.39038 0.0166016 7.54977C0.0166016 11.7092 3.38846 15.081 7.54785 15.081C9.44761 15.081 11.1831 14.3776 12.508 13.2171L17.2724 17.9815L17.9795 17.2744L13.2151 12.5099C14.3757 11.185 15.0791 9.44953 15.0791 7.54977C15.0791 3.39038 11.7072 0.0185242 7.54785 0.0185242ZM7.54785 1.01852C11.155 1.01852 14.0791 3.94266 14.0791 7.54977C14.0791 11.1569 11.155 14.081 7.54785 14.081C3.94074 14.081 1.0166 11.1569 1.0166 7.54977C1.0166 3.94266 3.94074 1.01852 7.54785 1.01852Z",
            fill: "currentColor"
        })
    });
const SearchNotificationIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "31",
        viewBox: "0 0 18 31",
        fill: "none",
        className: "nav-search-icon",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12.4971",
                cy: "9",
                r: "2.5",
                fill: "#00BCE5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_7310_23014",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "-1",
                y: "0",
                width: "19",
                height: "31",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M17.9971 30.5H-0.00292969V0.5H17.9971V30.5ZM12.4971 5.5C10.5641 5.5 8.99707 7.067 8.99707 9C8.99707 10.933 10.5641 12.5 12.4971 12.5C14.4301 12.5 15.9971 10.933 15.9971 9C15.9971 7.067 14.4301 5.5 12.4971 5.5Z",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_7310_23014)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.54834 6.51855C3.38895 6.51855 0.0170898 9.89041 0.0170898 14.0498C0.0170898 18.2092 3.38895 21.5811 7.54834 21.5811C9.44809 21.5811 11.1836 20.8777 12.5085 19.7171L17.2729 24.4815L17.98 23.7744L13.2156 19.01C14.3762 17.685 15.0796 15.9496 15.0796 14.0498C15.0796 9.89041 11.7077 6.51855 7.54834 6.51855ZM7.54834 7.51855C11.1554 7.51855 14.0796 10.4427 14.0796 14.0498C14.0796 17.6569 11.1554 20.5811 7.54834 20.5811C3.94123 20.5811 1.01709 17.6569 1.01709 14.0498C1.01709 10.4427 3.94123 7.51855 7.54834 7.51855Z",
                    fill: "currentColor"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ./components/GlobalVisualSearch/SearchNotification/index.jsx






const SearchNotification = (props)=>{
    const { isFirstTime , onClickHandler  } = props;
    const { featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_GLOBAL_VISUAL_SEARCH_V1: isGlobalVisualSearchEnabled = false  } = featureFlags;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).SearchNotificationContainer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: ()=>{
                onClickHandler && onClickHandler();
            },
            children: isFirstTime && isGlobalVisualSearchEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchNotificationIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_SearchIcon, {})
        })
    });
};
/* harmony default export */ var GlobalVisualSearch_SearchNotification = (SearchNotification);

;// CONCATENATED MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx











































const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const GlobalPageHeader = (props)=>{
    var ref;
    const { themeType ="" , header ={} , title ="" , description ="" , globalScripting ="" , isPdp =false , imageUrl ="" , email ="" , phone ="" , fullUrl ="" , siteName =""  } = props;
    const { pageIsInteractive , featureFlags ={} , globalConfig: { internationalization: { language ="en"  } = {} , general: { cartLandingPagePath ="" , signInFragment ="" , signUpFragment ="" , navigationHoverTiming ="" , siteName: BrandName = ""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { utilityStoreDetails , utilityData , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { data: authorData = {}  } = props;
    const staticTexts = (0,useFindStorei18n/* default */.Z)({
        authorData
    });
    const bodyRef = (0,react.useRef)(null);
    const htmlRef = (0,react.useRef)(null);
    const [metas, setMetas] = (0,react.useState)([]);
    const [styles, setStyles] = (0,react.useState)([]);
    const [scripts, setScripts] = (0,react.useState)([]);
    const [links, setLinks] = (0,react.useState)([]);
    const [logIndata, setLogIndata] = (0,react.useState)([]);
    const [logOutdata, setLogOutdata] = (0,react.useState)([]);
    const [favoritesPagePath, setFavoritesPagePath] = (0,react.useState)("/");
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false , MYSQLCONNSTR_ENABLE_GLOBAL_VISUAL_SEARCH_V1: isGlobalVisualSearchEnabled = false  } = featureFlags;
    const { favorites ={} , saveToListLineItems ={}  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { lineItems =[]  } = favorites || {};
    const { isLargeScreen , isExtraLargeScreen  } = (0,useViewport/* default */.Z)();
    const i18n = (0,useAuthUtilityNavi18n/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const { user: { firstName =null  } = {} , isAuth =false  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const onclicksignIN = function() {
        let datalayershow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        if (datalayershow) {
            (0,HeaderNavTabs_analytics/* newdatalayerforSignIn */.UY)();
        }
    };
    const onClickCreateAccount = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
        (0,HeaderNavTabs_analytics/* newdataLayerForCreateAccount */.Lz)();
    };
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [myListsPagePath, setMyListsPagePath] = (0,react.useState)("/");
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    const [target, setTarget] = (0,react.useState)(null);
    // for search panel
    const [showSearchBar, setShowSearchBar] = (0,react.useState)(false);
    const [openVisualSearch, setOpenVisualSearch] = (0,react.useState)(false);
    const { t  } = (0,dist_es/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const [state, setState] = (0,react.useState)(initialState);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const [canadaCheck, setCanadaCheck] = (0,react.useState)(false);
    const [isFirstTime, setIsFirstTime] = useIsVSFeatFirstTime();
    const [searchIconContainer, setSearchIconContainer] = (0,react.useState)(null);
    const setExperianceFragmentValue = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        const fragmentPath = (ref6 = header === null || header === void 0 ? void 0 : (ref = header[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["root"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[":items"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["container_copy"]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[":items"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["dynamicsearch"]) === null || ref5 === void 0 ? void 0 : ref5["fragmentPath"]) !== null && ref6 !== void 0 ? ref6 : null;
        if (fragmentPath) {
            dispatch((0,searchSlice/* setDynamicSearchFragment */.Z7)({
                found: true,
                fragmentPath: fragmentPath
            }));
        }
    };
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    (0,react.useEffect)(()=>{
        setInitalState();
        setExperianceFragmentValue();
    }, []);
    (0,react.useEffect)(()=>{
        const iscanadaCheck = (0,helper/* isCanadaSite */.guj)(BrandName);
        setCanadaCheck(iscanadaCheck);
    }, [
        BrandName
    ]);
    const handleGlobalClick = (e)=>{
        const target = e.target.closest('[data-datalayer-id="kds-element-navigation"]');
        if (target) {
            var ref, ref1;
            const rawEventInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}");
            const page = window.pageObj || {};
            // Common attributes to add to all events
            const commonEventInfo = {
                eventAction: rawEventInfo.eventAction || "main dropdown menu",
                eventType: rawEventInfo.eventType || "global header",
                eventName: rawEventInfo.eventName || "main dropdown menu",
                internalLinkPosition: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkPosition) || "global header",
                internalLinkZoneName: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkZoneName) || "global header",
                internalLinkType: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkType) || "global header:navigation"
            };
            const getProductInfo = ()=>{
                if ((rawEventInfo.internalLinkPosition || "").includes("teaser")) {
                    const productInfo = {
                        productCategory: "n/a",
                        productCollectionsName: "n/a",
                        productRoom: "n/a"
                    };
                    return productInfo;
                }
            };
            const isproductInfo = getProductInfo();
            // Merge common attributes with specific event info
            let eventInfo = {};
            eventInfo = {
                ...rawEventInfo,
                ...commonEventInfo
            };
            if (isproductInfo) {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    page,
                    eventInfo,
                    productInfo: isproductInfo
                });
            } else {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    page,
                    eventInfo
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handleGlobalClick);
        return ()=>document.removeEventListener("click", handleGlobalClick);
    }, []);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndpoints.findStores", ""),
                reverseGeo: get_default()(config, "apiEndpoints.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice/* setUtilityStoreDetails */.Hm)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const redirect = (zipCodeValue)=>{
        const path = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue, "&queryAspath=").concat(state.findStoreUrl);
        const asPath = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue);
        router.push(path, asPath);
    };
    const handleZipCodeUpdate = (value)=>{
        setZipcodeValue(value);
    };
    const headerItemsPresent = hasHeaderItems(header);
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            setZipcodeValue(getLocation.zipcode ? Number(getLocation.zipcode) : undefined);
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            var ref;
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { apiEndpoints: { findStores =""  } = {} , general: { allStoresPagePath ="/" , siteName =""  } = {}  } = config || {};
            const url = await (0,utils_location/* getShortenedUrl */.Pp)(allStoresPagePath !== null && allStoresPagePath !== void 0 ? allStoresPagePath : "/");
            setConfigState({
                browseAllStoreUrl: url,
                findStores,
                brand: siteName
            });
            localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
            setbrowseAllStoreUrl(url);
        }).catch((err)=>console.log(err));
    }, []);
    (0,react.useEffect)(()=>{
        if (myStoreId === 0) {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper/* getCityList */.vzx)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    const nearestStoreAddress = async ()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const findStores = get_default()(config, "apiEndpoints.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            if (!findStores || (zipCodeValue === null || zipCodeValue === void 0 ? void 0 : zipCodeValue.length) < 3) return;
            const nearestStore = await (0,v1_api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
            if (nearestStore !== undefined) {
                var ref;
                var ref1;
                const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
                var ref2;
                const utilityData = {
                    ...nearestStoreData,
                    EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
                };
                dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
            } else {
                const utilityData1 = {};
                dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData1));
            }
        }).catch((err)=>console.log(err));
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
    };
    const pageUrl = fullUrl || ( true ? window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href : 0);
    (0,react.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,helper/* getPageLevelScriptsAndStyles */.ptY)(globalScripting);
        setMetas(pageLevelDetails["metaList"]);
        setStyles(pageLevelDetails["stylesList"]);
        setScripts(pageLevelDetails["pageScripts"]);
        setLinks(pageLevelDetails["linkList"]);
    }, [
        globalScripting
    ]);
    // for search panel
    (0,react.useEffect)(()=>{
        if (true) {
            bodyRef.current = document.body;
            htmlRef.current = document.getElementsByTagName("html")[0];
        }
    }, []);
    const handleSearchClick = ()=>{
        var ref;
        if (showSearchBar) {
            (0,helper/* addMavenoidChat */.dVG)();
        } else {
            if (lib/* isMobile */.tq) {
                (0,helper/* removeMavenoidChat */.N9B)();
            } else {
                (0,helper/* addMavenoidChat */.dVG)();
            }
        }
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        if (showSearchBar) {
            classNames.forEach((className)=>{
                var ref, ref1, ref2, ref3;
                bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove(className);
                htmlRef === null || htmlRef === void 0 ? void 0 : (ref2 = htmlRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.remove(className);
            });
        } else {
            classNames.forEach((className)=>{
                var ref, ref1, ref2, ref3;
                bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add(className);
                htmlRef === null || htmlRef === void 0 ? void 0 : (ref2 = htmlRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.add(className);
            });
        }
        setShowSearchBar(!showSearchBar);
        const page = window.pageObj || {};
        const previousPageNameForSearch = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
        sessionStorage.setItem("previousPageNameForSearch", previousPageNameForSearch);
    };
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            setFavoritesPagePath("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
        } else {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const myFavPath = get_default()(config, "general.myFavoritesPagePath", "");
                setFavoritesPagePath(await (0,utils_location/* getShortenedUrl */.Pp)(myFavPath !== null && myFavPath !== void 0 ? myFavPath : "/"));
            });
        }
    }, [
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
            if (isSaveProductToList) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                    if (Object.keys(res[1]).length) {
                        setFavoritesPage(Object.keys(res[1]));
                    } else {
                        setFavoritesPage([]);
                    }
                });
            }
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (Object.keys(saveToListLineItems).length && isAuth) {
            setFavoritesPage(Object.keys(saveToListLineItems));
        } else {
            setFavoritesPage([]);
        }
    }, [
        Object.keys(saveToListLineItems).length
    ]);
    const onClickSignOut = ()=>{
        dispatch((0,authSlice/* logout */.kS)());
        (0,HeaderNavTabs_analytics/* dataLayerForSignOut */.Sv)();
    };
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            window.location.href = myListsPagePath;
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const getNavMobileData = async ()=>{
        try {
            const fetchGlobalConfig = async ()=>{
                try {
                    const res = await (0,api/* aemAxiosInstance */.Gb)({
                        url: constants_0.GLOBAL_CONFIGURATION_ENDPOINT,
                        method: "GET"
                    });
                    var ref;
                    return (ref = res === null || res === void 0 ? void 0 : res.data) !== null && ref !== void 0 ? ref : null;
                } catch (e) {
                    console.warn("fetchGlobalConfig failed (aemAxiosInstance)", e);
                    return null;
                }
            };
            // Resolve fragment paths from local props / globalConfig map / proxy
            let signInPath = signInFragment;
            let signUpPath = signUpFragment;
            if (!signInPath || !signUpPath) {
                var ref;
                const curMap = globalConfig === null || globalConfig === void 0 ? void 0 : (ref = globalConfig.contentFragmentListConfig) === null || ref === void 0 ? void 0 : ref.map;
                if (curMap === null || curMap === void 0 ? void 0 : curMap.mobileNavigation) {
                    signInPath = signInPath || curMap.mobileNavigation.signInFragment;
                    signUpPath = signUpPath || curMap.mobileNavigation.signUpFragment;
                }
            }
            if (!signInPath || !signUpPath) {
                const fetched = await fetchGlobalConfig();
                if (fetched) {
                    var ref1, ref2, ref3;
                    signInPath = signInPath || (fetched === null || fetched === void 0 ? void 0 : (ref1 = fetched.general) === null || ref1 === void 0 ? void 0 : ref1.signInFragment);
                    signUpPath = signUpPath || (fetched === null || fetched === void 0 ? void 0 : (ref2 = fetched.general) === null || ref2 === void 0 ? void 0 : ref2.signUpFragment);
                    const fetchedMap = fetched === null || fetched === void 0 ? void 0 : (ref3 = fetched.contentFragmentListConfig) === null || ref3 === void 0 ? void 0 : ref3.map;
                    if (fetchedMap === null || fetchedMap === void 0 ? void 0 : fetchedMap.mobileNavigation) {
                        signInPath = signInPath || fetchedMap.mobileNavigation.signInFragment;
                        signUpPath = signUpPath || fetchedMap.mobileNavigation.signUpFragment;
                    }
                }
            }
            if (!signInPath && !signUpPath) {
                console.warn("getNavMobileData: no signIn/signUp fragment values available after fallback attempts");
                return;
            }
            const fetchFragment = async (path)=>{
                if (!path) return null;
                try {
                    const res = await (0,api/* aemAxiosInstance */.Gb)({
                        url: "".concat(constants_0.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(encodeURIComponent(path)),
                        method: "GET"
                    });
                    var ref;
                    return (ref = res === null || res === void 0 ? void 0 : res.data) !== null && ref !== void 0 ? ref : null;
                } catch (e) {
                    console.warn("fetchFragment failed (aemAxiosInstance)", path, e);
                    return null;
                }
            };
            const [signInRes, signUpRes] = await Promise.all([
                fetchFragment(signInPath),
                fetchFragment(signUpPath)
            ]);
            const logIndataResp = (signInRes === null || signInRes === void 0 ? void 0 : signInRes.commonTopics) || [];
            const loggedOutDataResp = (signUpRes === null || signUpRes === void 0 ? void 0 : signUpRes.commonTopics) || [];
            setLogIndata(logIndataResp);
            setLogOutdata(loggedOutDataResp);
        } catch (err) {
            console.error("getNavMobileData: error fetching fragments", err);
        }
    };
    const favClickHandler = function(e) {
        let path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)("favorites", false, favoritesPagePath);
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            if (path) setMyListsPagePath(path);
            onclicksignIN(false);
            e.stopPropagation();
            e.preventDefault();
        } else if (path && isAuth) {
            router.push(path);
        }
    };
    const { contentFragmentListConfig: { map: fragmentList = {}  } = {}  } = globalConfig;
    (0,react.useEffect)(()=>{
        if (Object.keys(fragmentList).length) getNavMobileData();
    }, [
        fragmentList
    ]);
    const [width] = (0,useWindowResize/* default */.Z)();
    const navigationProps = mapMainMenuProps(header, i18n, lineItems, firstName, isAuth, logIndata, logOutdata, onclicksignIN, onClickCreateAccount, onClickSignOut, favClickHandler, cartCount, (themeType === null || themeType === void 0 ? void 0 : themeType.includes("light")) ? "light" : "dark", handleSearchClick, !(themeType === null || themeType === void 0 ? void 0 : themeType.includes("transparent")), favoritesPage, favoritesPagePath, cartLandingPagePath, router.asPath, setPromoModal, canadaCheck, navigationHoverTiming, staticTexts.searchHeader, language, isSaveProductToList, width);
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : action === "set as my store" ? "set as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav:" + action,
            eventName: "find a store:utility nav:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL:  true ? action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a" : 0,
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics(myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID) ? "set as my store" : "unset as my store");
    const storeMenu = {
        mod: "charcoal",
        eyebrow: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? myStoreId !== 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myStore : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.closestStore : "",
                    " "
                ]
            })
        },
        heading: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.locationDescription,
                    " "
                ]
            })
        },
        subheading: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? "" : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.zipCodeContent,
                    " "
                ]
            })
        },
        storeInfo: !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.OpenUntil
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine
                        }),
                        !isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (utilityData === null || utilityData === void 0 ? void 0 : utilityData.Locality) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AdminDistrict) + " " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.PostalCode)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)
                }),
                myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "store-a",
                    href: myStoreUrl,
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": viewStoreAnalytics,
                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.storeDetail
                })
            ]
        }) : undefined,
        setStoreCTA: {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID) ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myStore : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.setAsMyStore : "",
                    " "
                ]
            }),
            onChange: (e)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        " ",
                        !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? handleUtilityStoreCheck(e.target.checked ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID : 0) : "",
                        " "
                    ]
                });
            },
            checked: myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID),
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": unsetMyStoreAnalytics
        },
        zipCodeInput: {
            eyebrow: {
                text: (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.NotYourStore) + "?"
            },
            optionList: optionList,
            label: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.enterCityStateZip,
            inputValue: zipCodeValue,
            onInputChange: (e)=>{
                handleZipCodeUpdate(e.target.value);
            },
            handleSubmit: (zipCode)=>{
                redirect(zipCode);
            },
            CTA: {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.submit,
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "find a store:utility nav:submit",
                        eventName: "find a store:utility nav:submit",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "success",
                        internalLinkName: "submit",
                        internalLinkPosition: "find a store",
                        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
                        internalLinkZoneName: "find a store:utility nav",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true"
                    })
                }
            }
        },
        CTAs: [
            {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.userMyLocation,
                onClick: ()=>{
                    getGeoLocation();
                },
                component: "button"
            },
            {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.viewAllStore,
                href: browseAllStoreUrl,
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "find a store:utility nav:view all stores",
                        eventName: "find a store:utility nav:view all stores",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "view all stores",
                        internalLinkPosition: "global header:find a store",
                        internalLinkType: "find a store:navigation",
                        internalLinkZoneName: "find a store:utility nav",
                        internalLinkURL:  true ? "".concat(window.location.origin).concat(browseAllStoreUrl) : 0,
                        clickInternalLinks: "true"
                    })
                },
                component: "a"
            }
        ]
    };
    (0,react.useEffect)(()=>{
        if (true) {
            const isFirstTimeValue = localStorage.getItem("usingVSforFirstTime") === "true";
            setIsFirstTime(isFirstTimeValue);
        }
    }, []);
    (0,react.useEffect)(()=>{
        const handleStorageChange = (event)=>{
            if (event.key === "usingVSforFirstTime") {
                setIsFirstTime(event.newValue === "true");
            }
        };
        window.addEventListener("storage", handleStorageChange);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const updateSearchIcon = ()=>{
            var ref;
            const searchButtons = Array.from(document.querySelectorAll('.kohler-main-navigation-bar-root button[aria-label="Search"]'));
            document.querySelectorAll(".kohler-main-menu-root, .kohler-date-picker-root, .kohler-main-navigation-bar-root").forEach((root)=>{
                root.querySelectorAll("button").forEach((btn)=>{
                    btn.classList.add("af-icon-button");
                });
            });
            if (searchButtons.length === 0) return;
            const targetButton = searchButtons[searchButtons.length - 1];
            targetButton.style.marginRight = "0px";
            targetButton.classList.add("globalvs-feat-toggle");
            const computedStyle = window.getComputedStyle(targetButton);
            const isHidden = computedStyle.display === "none";
            if (isHidden) {
                targetButton.classList.remove("globalvs-feat-toggle");
                setSearchIconContainer(null);
                return;
            }
            const svg = targetButton.querySelector("svg");
            const hasSiblingSpan = svg === null || svg === void 0 ? void 0 : (ref = svg.parentElement) === null || ref === void 0 ? void 0 : ref.querySelector("span");
            if (svg && !hasSiblingSpan && !svg.classList.contains("nav-search-icon")) {
                svg.remove();
            }
            setSearchIconContainer(targetButton);
        };
        updateSearchIcon();
        const observer = new MutationObserver(()=>updateSearchIcon());
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        window.addEventListener("scroll", updateSearchIcon);
        window.addEventListener("resize", updateSearchIcon);
        return ()=>{
            observer.disconnect();
            window.removeEventListener("scroll", updateSearchIcon);
            window.removeEventListener("resize", updateSearchIcon);
        };
    }, [
        isFirstTime,
        isLargeScreen,
        isExtraLargeScreen
    ]);
    (0,react.useEffect)(()=>{
        const mainMenu = document === null || document === void 0 ? void 0 : document.querySelector(".kohler-main-navigation-bar-root");
        if (!mainMenu) return;
        const mainNavContainer = mainMenu === null || mainMenu === void 0 ? void 0 : mainMenu.querySelector(".kohler-grid-root > div > .kohler-flex-root");
        if (!mainNavContainer) return;
        const vsSearchPlaceholder = document.createElement("div");
        const navContainers = mainNavContainer.querySelectorAll(":scope > .kohler-flex-root");
        if ((navContainers === null || navContainers === void 0 ? void 0 : navContainers.length) > 0) {
            const addVsSearchAtLast = navContainers[(navContainers === null || navContainers === void 0 ? void 0 : navContainers.length) - 1];
            addVsSearchAtLast.insertAdjacentElement("afterend", vsSearchPlaceholder);
        } else {
            mainNavContainer.appendChild(vsSearchPlaceholder);
        }
        Array.from(mainNavContainer.children).forEach((child, index)=>{
            child.style.order = "".concat(index + 1);
        });
        setTarget(vsSearchPlaceholder);
    }, []);
    (0,react.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            document.querySelectorAll(".kohler-overlay-menu-root").forEach((root)=>{
                root.querySelectorAll("button").forEach((btn)=>{
                    btn.classList.add("af-icon-button");
                });
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: title
                            })
                        ]
                    }) : null,
                    description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: description
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: isPdp ? "product" : "website"
                    }),
                    siteName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: siteName
                    }) : null,
                    pageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }) : null,
                    imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: imageUrl
                    }) : null,
                    email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:email",
                        content: email
                    }) : null,
                    phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:phone_number",
                        content: phone
                    }) : null,
                    metas.map((meta, i)=>{
                        if (meta.name && meta.content) return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: meta.name,
                            content: meta.content
                        }, "meta-".concat(i));
                    }),
                    styles.map((style, i)=>{
                        if (typeof style === "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (0,jsx_runtime.jsx)((style_default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "pagestyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
                    }),
                    links.map((link, i)=>{
                        if (typeof link !== "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: link.rel,
                            href: link.href
                        }, "pageLinks-".concat(i));
                    })
                ]
            }),
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "headscript-".concat(i)
                }, "headscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "headscriptHtml-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "headscriptHtml-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "skip-to-main",
                onClick: helper/* handleSkipToMain */.bOu,
                "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.skipToMainContent,
                role: "link",
                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.skipToMainContent
            }),
            headerItemsPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu, {
                ...navigationProps,
                storeMenu: storeMenu
            }) : null,
            infoModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                handleModalClose: ()=>setInfoModal(false),
                show: infoModal,
                data: infoModalErrror,
                labelledBy: "Geo-Location-error-message",
                className: "message-modal",
                staticTexts: staticTexts,
                dataLayerPosition: "global header",
                label: staticText.continue
            }),
            showSearchBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                showSearchBar: showSearchBar,
                handleSearchClick: handleSearchClick,
                setOpenVisualSearch: setOpenVisualSearch,
                data: findItemByName(header, "utilitywidgets"),
                isFirstTime: isFirstTime,
                setIsFirstTime: setIsFirstTime,
                setShowSearchBar: setShowSearchBar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    target && isGlobalVisualSearchEnabled && (isLargeScreen || isExtraLargeScreen) && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVSContent/* default */.Z, {
                        className: "ml-15 pb-2 globalvs-feat-toggle",
                        openVisualSearch: openVisualSearch,
                        setOpenVisualSearch: setOpenVisualSearch,
                        setShowSearchBar: setShowSearchBar,
                        isFirstTime: isFirstTime,
                        setIsFirstTime: setIsFirstTime
                    }), target),
                    searchIconContainer && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch_SearchNotification, {
                        isFirstTime: isFirstTime,
                        onClickHandler: ()=>setShowSearchBar(true)
                    }), searchIconContainer),
                    !(isLargeScreen || isExtraLargeScreen) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalVisualSearch/* default */.Z, {
                        openVisualSearch: openVisualSearch,
                        setOpenVisualSearch: setOpenVisualSearch,
                        setShowSearchBar: setShowSearchBar
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GlobalPage_GlobalPageHeader = (GlobalPageHeader);


/***/ }),

/***/ 59187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GLOBAL_HEADER_TEXT; },
/* harmony export */   "Pv": function() { return /* binding */ GLOBAL_NAVIGATION; },
/* harmony export */   "WC": function() { return /* binding */ MEGA_MENU; },
/* harmony export */   "zl": function() { return /* binding */ MAIN_MENU; }
/* harmony export */ });
const GLOBAL_HEADER_TEXT = "global header";
const MAIN_MENU = "main dropdown menu";
const MEGA_MENU = "mega menu navigation";
const GLOBAL_NAVIGATION = "global navigation";


/***/ }),

/***/ 24897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jm": function() { return /* binding */ onclickForSignedFun; },
/* harmony export */   "Lz": function() { return /* binding */ newdataLayerForCreateAccount; },
/* harmony export */   "Ps": function() { return /* binding */ backClickForMobile; },
/* harmony export */   "Sv": function() { return /* binding */ dataLayerForSignOut; },
/* harmony export */   "UY": function() { return /* binding */ newdatalayerforSignIn; },
/* harmony export */   "bL": function() { return /* binding */ l1DatalayerclickMobile; },
/* harmony export */   "hJ": function() { return /* binding */ addAnalyticsOnClose; },
/* harmony export */   "ue": function() { return /* binding */ dataLayerForUtilityClicks; },
/* harmony export */   "w_": function() { return /* binding */ hamburgerMenuDatalayer; },
/* harmony export */   "yp": function() { return /* binding */ servicesAnalyticsClick; },
/* harmony export */   "zw": function() { return /* binding */ closeButtonDatalayer; }
/* harmony export */ });
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59187);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);




const addAnalyticsOnClose = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "main dropdown menu:products:close",
        eventMsg: "n/a",
        eventName: "main dropdown menu:products:close",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "products > close",
        internalLinkPosition: "global header:products",
        internalLinkType: "global header:navigation",
        internalLinkURL: "".concat(window.origin).concat(location.pathname),
        internalLinkZoneName: "main dropdown menu:products"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const servicesAnalyticsClick = (data)=>{
    var ref;
    const { text ="" , link ="" , Leveltwo ="" , L1 ="" , imgcheck =""  } = data;
    const textcont = text ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .makingTextDatalayerReady */ .S$e)(text) : "";
    const l2DatalayerReady = Leveltwo ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .makingTextDatalayerReady */ .S$e)(Leveltwo) : "";
    const l1DatalayerReady = L1 ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .makingTextDatalayerReady */ .S$e)(L1) : "";
    const url = link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .removeAndCleanLink */ .xEh)(link)) : "n/a";
    let internallink;
    if (L1) {
        internallink = "".concat(l1DatalayerReady, " > ").concat(l2DatalayerReady, " > ").concat(imgcheck ? "img_".concat(textcont) : textcont);
    } else if (imgcheck) {
        internallink = "".concat(l2DatalayerReady, " > img_").concat(textcont);
    } else {
        internallink = "".concat(l2DatalayerReady, " > ").concat(textcont);
    }
    const eventInfo = {
        clickInternalLinks: (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null ? "true" : "false",
        eventAction: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl,
        eventName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl,
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkName: (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPureText */ .OM7)(internallink)) === null || ref === void 0 ? void 0 : ref.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_0__/* .PURE_DATA_FOR_STRING_REGEX */ .YN, ""),
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
        internalLinkURL: url,
        internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const l1DatalayerclickMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl,
        eventName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl,
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_NAVIGATION */ .Pv,
        internalLinkName: L1Name === null || L1Name === void 0 ? void 0 : L1Name.toLowerCase(),
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageNameDatalayer, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const backClickForMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":back"),
        eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":back"),
        eventType: "navigation",
        internalLinkName: "".concat(L1Name.toLowerCase(), " > back"),
        internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(L1Name.toLowerCase()),
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl, ":").concat(L1Name.toLowerCase())
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const closeButtonDatalayer = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "products";
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .addMavenoidChat */ .dVG)();
    data = data ? data : "products";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl, ":").concat(data.toLowerCase(), ":close"),
        eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl, ":").concat(data.toLowerCase(), ":close"),
        eventType: "navigation",
        internalLinkName: "".concat(data.toLowerCase(), " > close"),
        internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":products"),
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MAIN_MENU */ .zl, ":products")
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const hamburgerMenuDatalayer = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "hamburger menu open",
        eventName: "hamburger menu open",
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_NAVIGATION */ .Pv,
        internalLinkName: "hamburger menu open",
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":open"),
        internalLinkURL: "n/a",
        internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const newdatalayerforSignIn = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventType: "navigation",
            internalLinkName: "sign in start",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "my account:sign in",
            eventAction: "my account:sign in",
            internalLinkName: "sign in interaction",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    }
};
const newdataLayerForCreateAccount = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventType: "navigation",
            internalLinkName: "create account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CREATE_ACCOUNT),
            eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CREATE_ACCOUNT),
            internalLinkName: _constants_index__WEBPACK_IMPORTED_MODULE_2__.CREATE_ACCOUNT,
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.CREATE_ACCOUNT),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    }
};
const onclickForSignedFun = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":your kohler account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":your kohler account"),
            eventType: "navigation",
            internalLinkName: "your kohler account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":my account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    }
};
const dataLayerForUtilityClicks = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", themeChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    const dataLayerTitle = title === null || title === void 0 ? void 0 : title.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventType: "navigation",
            internalLinkName: "".concat(dataLayerTitle),
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .MEGA_MENU */ .WC),
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .removeAndCleanLink */ .xEh)(url)) : "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else if (dataLayerTitle === "find a store") {
        const eventInfo1 = {
            eventAction: dataLayerTitle,
            eventName: dataLayerTitle,
            eventType: dataLayerTitle,
            internalLinkName: dataLayerTitle,
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: "".concat(pageNameDatalayer).concat(pageNameDatalayer ? ":" : "").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    } else {
        const eventInfo2 = {
            eventName: "wishlist icon",
            eventAction: "wishlist icon",
            internalLinkName: "wishlist",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .removeAndCleanLink */ .xEh)(url)) : "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_HEADER_TEXT */ .A, " wishlist"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo2, "cmp:click");
    }
};
const dataLayerForSignOut = ()=>{
    const eventInfo = {
        eventName: "my account:sign out",
        eventAction: "my account:sign out",
        internalLinkName: "sign out",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: window.location.origin + "/en",
        internalLinkPosition: "global header sign out",
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};


/***/ }),

/***/ 68446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ pureText; },
/* harmony export */   "JI": function() { return /* binding */ checkSingleNonEmptyLevelThreeNavMulti; },
/* harmony export */   "L9": function() { return /* binding */ modifyHref; },
/* harmony export */   "TX": function() { return /* binding */ pureTextWithoutSpace; },
/* harmony export */   "dV": function() { return /* binding */ closestAnchorHref; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);


const checkSingleNonEmptyLevelThreeNavMulti = (data)=>{
    let nonEmptyLevelThreeNavMultiIndex = -1;
    let nonEmptyLevelThreeNavMultiCount = 0;
    for(let i = 0; i < data.length; i++){
        for (const levelTwoNavMulti of data[i].levelTwoNavMulti){
            if (levelTwoNavMulti.levelThreeNavMulti.length >= 1) {
                nonEmptyLevelThreeNavMultiCount++;
                if (nonEmptyLevelThreeNavMultiCount > 1) {
                    return -1 // More than one non-empty levelThreeNavMulti found
                    ;
                } else {
                    nonEmptyLevelThreeNavMultiIndex = i;
                }
            }
        }
    }
    return nonEmptyLevelThreeNavMultiIndex;
};
const modifyHref = (link)=>{
    return link === null || link === void 0 ? void 0 : link.split(_constants_index__WEBPACK_IMPORTED_MODULE_0__.internalLinkPath).join("").replace(".html", "");
};
const closestAnchorHref = (e)=>{
    return !e.target.closest("a").getAttribute("href");
};
const pureText = (text)=>{
    var ref;
    return (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPureText */ .OM7)(text)) === null || ref === void 0 ? void 0 : ref.trim();
};
const pureTextWithoutSpace = (text)=>{
    const pureTextTitle = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPureText */ .OM7)(text).trim().toLowerCase();
    return pureTextTitle.split(" ").join("-").replace("&amp;-", "").replace("&-", "");
};


/***/ }),

/***/ 70914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36513);




const ImageWrapper = (props)=>{
    const { src =_public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , alt ="" , ...restProps } = props || {};
    const [isError, setIsError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isError) setIsError(false);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...restProps,
        blurDataURL: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc1IiBoZWlnaHQ9IjIyOSIgdmlld0JveD0iMCAwIDE3NSAyMjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNzUiIGhlaWdodD0iMjI5IiByeD0iMTYiIGZpbGw9IiM4MDgwODAiIGZpbGwtb3BhY2l0eT0iMC41NSIvPgo8L3N2Zz4K",
        src: isError || !src ? _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : src,
        onError: ()=>setIsError(true),
        alt: alt
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWrapper);


/***/ }),

/***/ 13678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76118);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7__);








const ProductSocialShare = (props)=>{
    const { id ="" , url ="" , componentProp: { assetUrl ="" , url: compUrl = "" , showModal: componentPropShowModal = false  } = {} , disableInstagram =false , showModal =false , onClose =()=>{} , mailBody ="" , mailSubject ="" , isBundleProduct ="" , productInfoParam ={}  } = props;
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const origin = window.location.origin;
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const { general ={} , socialMediaConfig: socialMediaConfigs = {}  } = config;
    const { hostUrl =""  } = general;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)().then(async (configData)=>{
            setConfig(configData);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.siteName", "");
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.socialShareEmailIconPath", "");
        });
    }, []);
    // get component social share link url
    /**
   *
   * @return  {string} the the url
   */ const getLink = ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getShortenedUrlwithGeneral */ .vu1)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeUrl */ .Nmg)(window.location.href);
        }
    };
    const link = getLink();
    const brandNameCurrent = brandName.current;
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: props.sharedCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandNameCurrent,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText")
    };
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (socialMediaConfigs.myArrayList) {
            let siteList = [];
            socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.forEach((socialMediaConfig)=>{
                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(socialMediaConfig.map) && socialMediaConfig.map.name) {
                    var _name, _iconPath;
                    const site = {
                        key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                        icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                    };
                    var _redirectUrl;
                    const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                    if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                        siteList.push({
                            ...site,
                            url: encodeURI(url + link + "&text=".concat(document.title))
                        });
                    } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                        if (props.asset) siteList.push({
                            ...site,
                            url: url + "".concat(origin, "&media=").concat(props.asset.url, "&is_video=").concat(props.asset.isVideo, "$description=").concat(props.asset.description)
                        });
                    } else {
                        siteList.push({
                            ...site,
                            url: url + link
                        });
                    }
                }
            });
            if (disableInstagram && siteList.length) {
                siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
            }
            setSites(siteList);
        }
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    /**
   *
   * @param {string} e
   */ function socialLinks(e) {
        if (e.target && e.target.hostname && e.target.href) {
            const target = e.target;
            const nodeUrl = target.hostname.replace(/(^www\.)/, "");
            if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
                e.stopPropagation();
                e.preventDefault();
                if (window.handleShowModal) window.handleShowModal(target.href, target);
            } else if (target.href) {
                window.open(target.href);
            }
            const key = target.siteKey || nodeUrl || target.hostname;
            try {
                addDataLayer(key.split(".com")[0], target.href);
            // eslint-disable-next-line no-empty
            } catch (ee) {}
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        props.showModal
    ]);
    const { internallinkposition , internallinktype , internallinkzonename  } = props.componentProp || {};
    const analyticData = props.analyticData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a"
    };
    const shareRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleClick = (e)=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument.getElementById(props.id) : document.getElementById(props.id);
        if (props.showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target))) props.onClose();
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            props.onClose();
            props.shareBtn.current.focus();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument : document;
        if (props.showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && props.showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        props.showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", link !== null && link !== void 0 ? link : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        let eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" ? "true" : "false"
        };
        const page = window.pageObj || {};
        const { pageInfo: { contentType  } , productInfo  } = page;
        const isPdp = contentType === "pdp";
        if (isPdp) {
            eventInfo = {
                eventAction: "pdp:product details:share",
                eventName: "pdp:product details:share",
                eventType: "informative",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: siteKey,
                internalLinkPosition: "pdp".concat(isBundleProduct ? ":bundle" : ""),
                internalLinkType: "pdp:".concat(internalLinkType.split(":")[1] || ""),
                internalLinkZoneName: "pdp:".concat(internalLinkZoneName.split(":")[1] || ""),
                internalLinkURL: link || internalLinkURL || "n/a",
                clickInternalLinks: "true"
            };
        }
        if (window.dataLayerEventType && !isPdp) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName && !isPdp) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const dataLayerObj = {
            event: "cmp:click",
            eventInfo,
            page
        };
        if (isPdp) {
            dataLayerObj["productInfo"] = productInfo;
        }
        let customProductInfo;
        if (custom) {
            try {
                customProductInfo = JSON.parse(custom).productInfo;
                dataLayerObj["productInfo"] = customProductInfo;
            } catch (e) {
                console.error(e);
            }
        }
        if (dataLayerObj["productInfo"] === undefined) {
            dataLayerObj["productInfo"] = productInfoParam;
        }
        window.adobeDataLayer.push(dataLayerObj);
    };
    const { linksCTA =()=>{} , openNewTabText ="" , copyLinkIndication ="" , copyLink: staticTextcopyLink = "" , email =""  } = i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7___default().socialShareWrapper),
        children: (showModal !== null && showModal !== void 0 ? showModal : componentPropShowModal) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "social-share",
            id: id,
            ref: shareRef,
            "data-testid": id,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "social-share__box",
                ref: shareBoxRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "social-share__sites",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            role: "list",
                            children: sites.map((param, i)=>{
                                let { url ="" , key ="" , icon =""  } = param;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    role: "listitem",
                                    className: "social-share-list",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        id: "kf-social-links-".concat(i),
                                        rel: "noreferrer",
                                        href: url,
                                        className: "kf-social-links social-share-link",
                                        "aria-label": "".concat(linksCTA(key), " ").concat(openNewTabText),
                                        target: "_blank",
                                        "data-link-type": "social media",
                                        role: "link",
                                        tabIndex: "0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "aria-hidden": "true",
                                            src: "".concat(hostUrl).concat(icon),
                                            alt: key,
                                            className: "social-share__".concat(key),
                                            role: "presentation"
                                        })
                                    })
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "social-share__actions",
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    tabIndex: "0",
                                    role: "button",
                                    ref: copyBtnRef,
                                    className: "social-share__cta",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "social-share__copy-link-icon",
                                            "aria-hidden": true,
                                            src: "".concat(hostUrl).concat(socialShareCopyIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        copyIcon ? copyLinkIndication : staticTextcopyLink
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "social-share__cta social-share__email",
                                    "aria-label": "".concat(email, " ").concat(openNewTabText),
                                    onKeyDown: ()=>onClose(),
                                    ref: emailBtnRef,
                                    href: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeUrl */ .Nmg)("mailto:?body=".concat(mailBody + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    role: "link",
                                    tabIndex: "0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "".concat(hostUrl).concat(socialShareEmailIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        email
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductSocialShare);


/***/ }),

/***/ 78592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ quickViewCarouselImageClickAnalytics; },
/* harmony export */   "Av": function() { return /* binding */ quickViewDimensionsAnalytics; },
/* harmony export */   "E$": function() { return /* binding */ quickViewOpenAnalytics; },
/* harmony export */   "I4": function() { return /* binding */ quickViewCloseAnalytics; },
/* harmony export */   "Qe": function() { return /* binding */ quickViewPrevNextCarouselButtonClickAnalytics; },
/* harmony export */   "Ry": function() { return /* binding */ quickViewAddToCartAnalytics; },
/* harmony export */   "SD": function() { return /* binding */ quickViewReviewClickAnalytics; },
/* harmony export */   "_H": function() { return /* binding */ quickViewNotifyMeClickAnalytics; },
/* harmony export */   "cP": function() { return /* binding */ quickViewVaraintClickAnalytics; },
/* harmony export */   "jr": function() { return /* binding */ viewFullDetailsAnalytics; },
/* harmony export */   "qq": function() { return /* binding */ quickViewListPriceAnalytics; },
/* harmony export */   "um": function() { return /* binding */ quickViewDownloadClickAnalytics; }
/* harmony export */ });
/* unused harmony export createQuickViewEventInfo */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20443);


const getProductInfo = (data)=>{
    const { brandName , productName , productDesc , skuID , category , pdpType , productPrice , discountedPrice , productImageUrl  } = data;
    const productInfo = {
        category: category,
        description: productDesc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: "default",
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: productName || productDesc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "product",
        productSalePrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: productName,
        quantity: 1,
        defaultImageName: productImageUrl || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: pdpType || "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: productName,
        productBrand: brandName,
        itemType: "product",
        waterSenseProduct: false
    };
    return productInfo;
};
const getEventInfo = function() {
    let upshellmodal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageTypeObj = page.category;
    let pageTypeText = "";
    let pageName = "";
    let recommTitle = "";
    let upshellTitle = "";
    if ((pageTypeObj === null || pageTypeObj === void 0 ? void 0 : pageTypeObj.subCategoryID) === "cart") {
        pageName = "cart";
        pageTypeText = upshellmodal ? "cart preview" : pageName;
        recommTitle = upshellmodal !== true ? ":recommended additions" : "";
        upshellTitle = upshellmodal ? ":our best sellers" : ":recommended additions";
    }
    if ((pageTypeObj === null || pageTypeObj === void 0 ? void 0 : pageTypeObj.pageType) === "pdp") {
        pageName = "pdp";
        pageTypeText = "pdp";
        recommTitle = ":we recommend";
        upshellTitle = ":we recommend";
    }
    return {
        pageTypeText,
        pageName,
        recommTitle,
        upshellTitle
    };
};
const quickViewOpenAnalytics = (data)=>{
    const { productData , productUrl ="" , productImageUrl ="" , upshellmodal =false , recommendationSource ="n/a" , isMultifinishBundle =false , optionCategory ="" , commonProductInfo ={}  } = data;
    let eventInfo = {};
    let productInfo = {};
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getUserPersona */ .shu)();
    if (isMultifinishBundle) {
        eventInfo = {
            eventAction: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(optionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            eventMsg: "n/a",
            eventName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(optionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR,
            internalLinkPosition: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7),
            internalLinkType: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            clickInternalLinks: "true",
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            modalName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR)
        };
        productInfo = [
            {
                ...productData,
                ...commonProductInfo
            }
        ];
    } else {
        const { CustomerFacingBrand_s: brandName = "" , sku_s: skuID = "" , ProductBrandName_s: productName = "" , ProductDescriptionProductShort_s: productDesc = "" , Product_Category: category = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0  } = productData;
        productInfo = getProductInfo({
            brandName,
            productName,
            productDesc,
            skuID,
            category,
            productPrice,
            discountedPrice,
            productImageUrl,
            productUrl
        });
        const { pageTypeText , pageName , recommTitle , upshellTitle  } = getEventInfo(upshellmodal);
        eventInfo = {
            clickInternalLinks: "true",
            curatedRecommendation: recommendationSource,
            eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey).concat(recommTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            eventMsg: "n/a",
            eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey).concat(recommTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR,
            internalLinkPosition: "".concat(pageTypeText, ":upsell"),
            internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            internalLinkURL: productUrl || "n/a",
            internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
            modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewCloseAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , productUrl ="" , isMultifinishBundle =false , optionCategory =""  } = data;
    let eventInfo = {};
    if (isMultifinishBundle) {
        eventInfo = {
            eventAction: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(optionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
            eventMsg: "n/a",
            eventName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(optionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$,
            internalLinkPosition: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7),
            internalLinkType: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            clickInternalLinks: "true",
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
            modalName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR)
        };
    } else {
        const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
        eventInfo = {
            clickInternalLinks: "true",
            curatedRecommendation: recommendationSource,
            eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
            eventMsg: "n/a",
            eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$,
            internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            internalLinkURL: productUrl || "n/a",
            internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewAddToCartAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , plp =false , search =false  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventNameAndAction = plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2) : "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: eventNameAndAction,
        eventMsg: "n/a",
        eventName: eventNameAndAction,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2,
        internalLinkPosition: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":promo tile:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0) : "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0) : "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2) : "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const viewFullDetailsAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , isMultifinishBundle =false , productOptionCategory ="" , productUrl ="" , plp =false , search =false  } = data;
    const eventInfo = createQuickViewEventInfo({
        isMultifinishBundle,
        actionType: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .VIEW_FULL_DETAILS */ .YM,
        productOptionCategory,
        upshellmodal,
        recommendationSource,
        productUrl,
        plp,
        search
    });
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewDimensionsAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , dimensionsValue ={} , isMultifinishBundle =false , productOptionCategory =""  } = data;
    let eventInfo = {};
    const { tooltip ="" , label ="" , value =""  } = dimensionsValue;
    if (isMultifinishBundle) {
        eventInfo = {
            eventAction: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
            eventMsg: "n/a",
            eventName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: tooltip,
            internalLinkPosition: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7),
            internalLinkType: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            clickInternalLinks: "true",
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
            modalName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR)
        };
    } else {
        const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
        eventInfo = {
            clickInternalLinks: "true",
            curatedRecommendation: recommendationSource,
            eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
            eventMsg: "n/a",
            eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: tooltip,
            internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, ":").concat(label.toLowerCase(), " ").concat(value.toLowerCase()),
            internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$),
            modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewVaraintClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , assetId , label , isMultifinishBundle =false , productOptionCategory =""  } = data;
    const eventInfo = createQuickViewEventInfo({
        isMultifinishBundle,
        actionType: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_SELECTION */ ._I,
        productOptionCategory,
        upshellmodal,
        recommendationSource,
        assetData: {
            assetId,
            label
        }
    });
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewListPriceAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , listPriceInfo , isMultifinishBundle =false , productOptionCategory =""  } = data;
    let eventInfo = {};
    if (isMultifinishBundle) {
        eventInfo = {
            eventAction: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " mouseover"),
            eventMsg: "n/a",
            eventName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " mouseover"),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: listPriceInfo,
            internalLinkPosition: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7),
            internalLinkType: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            clickInternalLinks: "true",
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " mouseover"),
            modalName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR)
        };
    } else {
        const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
        eventInfo = {
            clickInternalLinks: "true",
            curatedRecommendation: recommendationSource,
            eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " mouseover"),
            eventMsg: "n/a",
            eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, "  mouseover"),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: listPriceInfo,
            internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " hover"),
            internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG),
            modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewPrevNextCarouselButtonClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , btnType ="" , isMultifinishBundle =false , productOptionCategory ="" , plp =false , search =false  } = data;
    const eventInfo = createQuickViewEventInfo({
        isMultifinishBundle,
        actionType: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA, ":").concat(btnType),
        productOptionCategory,
        upshellmodal,
        recommendationSource,
        additionalFields: {
            internalLinkName: "".concat(btnType, " arrow")
        },
        plp,
        search
    });
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewCarouselImageClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , assetId , imageSequence , resourceType , imageName , isMultifinishBundle =false , productOptionCategory ="" , plp =false , search =false  } = data;
    const eventInfo = createQuickViewEventInfo({
        isMultifinishBundle,
        actionType: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA,
        productOptionCategory,
        upshellmodal,
        recommendationSource,
        additionalFields: {
            internalLinkName: assetId,
            imageId: assetId,
            imageName: imageName,
            resourceType: resourceType,
            imageSequence: imageSequence
        },
        plp,
        search
    });
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewReviewClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , redirectUrl  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: window.location.origin + redirectUrl,
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewDownloadClickAnalytics = (data)=>{
    var ref;
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , title ="" , url ="" , isMultifinishBundle =false , productOptionCategory =""  } = data;
    let eventInfo = {};
    const downloadTitle = ((ref = title.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("specifications")) ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SPEC_SHEET */ .s4 : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .GUIDE */ .cd;
    if (isMultifinishBundle) {
        eventInfo = {
            eventAction: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DOWNLOADS */ .jF, ":").concat(downloadTitle),
            eventMsg: "n/a",
            eventName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DOWNLOADS */ .jF, ":").concat(downloadTitle),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(downloadTitle, " | ").concat(url),
            internalLinkPosition: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7),
            internalLinkType: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            clickInternalLinks: "true",
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DOWNLOADS */ .jF),
            modalName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR)
        };
    } else {
        const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
        eventInfo = {
            clickInternalLinks: "true",
            curatedRecommendation: recommendationSource,
            eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .Download */ .UW, ":").concat(downloadTitle),
            eventMsg: "n/a",
            eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .Download */ .UW, ":").concat(downloadTitle),
            eventStatus: "success",
            eventType: "navigation",
            internalLinkName: "".concat(downloadTitle, " | ").concat(url),
            internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .Download */ .UW, "s"),
            modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewNotifyMeClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , isSuccess , errorMsgQV , isMultifinishBundle =false , productOptionCategory ="" , plp =false , search =false  } = data;
    const eventInfo = createQuickViewEventInfo({
        isMultifinishBundle,
        actionType: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr,
        productOptionCategory,
        upshellmodal,
        recommendationSource,
        additionalFields: {
            internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr,
            formName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr
        },
        eventStatus: isSuccess ? "success" : "failure",
        eventMsg: !isSuccess ? errorMsgQV : "n/a",
        plp,
        search
    });
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const createQuickViewEventInfo = (param)=>{
    let { isMultifinishBundle =false , actionType , productOptionCategory ="" , upshellmodal =false , recommendationSource ="n/a" , additionalFields ={} , productUrl ="" , eventStatus ="n/a" , eventMsg ="n/a" , plp =false , search =false  } = param;
    if (isMultifinishBundle) {
        return createBundleEventInfo({
            actionType,
            productOptionCategory,
            productUrl,
            additionalFields,
            eventStatus,
            eventMsg,
            plp,
            search
        });
    }
    return createStandardEventInfo({
        actionType,
        upshellmodal,
        recommendationSource,
        additionalFields,
        productUrl,
        eventStatus,
        eventMsg,
        plp,
        search
    });
};
// Helper function for bundle product event info
const createBundleEventInfo = (param)=>{
    let { actionType , productOptionCategory ="" , productUrl ="" , additionalFields ={} , eventStatus ="n/a" , eventMsg ="n/a" , plp =false , search =false  } = param;
    let actionPattern = plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType) : "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType);
    const specialActions = {
        [_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA]: (action)=>"".concat(action, " click"),
        [_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$]: (action)=>"".concat(action, " mouseover"),
        [_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG]: (action)=>"".concat(action, " mouseover")
    };
    if (specialActions[actionType]) {
        actionPattern = plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(specialActions[actionType](actionType)) : "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(productOptionCategory, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(specialActions[actionType](actionType));
    }
    return {
        clickInternalLinks: "true",
        eventAction: actionPattern,
        eventMsg: eventMsg,
        eventName: actionPattern,
        eventStatus: eventStatus,
        eventType: "navigation",
        internalLinkName: actionType,
        internalLinkPosition: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":promo tile:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0) : "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7),
        internalLinkType: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0) : "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: productUrl || "n/a",
        internalLinkZoneName: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType) : "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PDP */ .Hs, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType),
        modalName: "".concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .BUNDLE */ .c7, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
        ...additionalFields
    };
};
// Helper function for standard product event info
const createStandardEventInfo = (param)=>{
    let { actionType , upshellmodal , recommendationSource , additionalFields ={} , productUrl ="" , eventStatus ="n/a" , eventMsg ="n/a" , plp =false , search =false  } = param;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const specialActions = {
        [_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA]: (action)=>"".concat(action, " click"),
        [_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$]: (action)=>"".concat(action, " mouseover"),
        [_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG]: (action)=>"".concat(action, " mouseover")
    };
    let baseAction = plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType) : "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType);
    if (specialActions[actionType]) {
        baseAction = plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(specialActions[actionType](actionType)) : "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(specialActions[actionType](actionType));
    }
    return {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: baseAction,
        eventMsg: eventMsg,
        eventName: baseAction,
        eventStatus: eventStatus,
        eventType: "navigation",
        internalLinkName: actionType,
        internalLinkPosition: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":promo tile:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0) : "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: plp ? "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0) : "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: productUrl || "n/a",
        internalLinkZoneName: plp ? (()=>{
            if (actionType.includes(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA)) {
                return "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType.split(":")[0]);
            }
            return "".concat(search ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULTS */ .fP : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .PLP */ .g5, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType);
        })() : "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(actionType),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0,
        ...additionalFields
    };
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 20443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ UPSELL_PRODUCT; },
/* harmony export */   "F$": function() { return /* binding */ CLOSE; },
/* harmony export */   "G2": function() { return /* binding */ ADD_TO_CART; },
/* harmony export */   "GG": function() { return /* binding */ LIST_PRICE; },
/* harmony export */   "Hs": function() { return /* binding */ PDP; },
/* harmony export */   "Jd": function() { return /* binding */ REVIEW; },
/* harmony export */   "K0": function() { return /* binding */ QUICK_VIEW_MODAL; },
/* harmony export */   "OH": function() { return /* binding */ PRODUCT_DETAILS; },
/* harmony export */   "UW": function() { return /* binding */ Download; },
/* harmony export */   "YM": function() { return /* binding */ VIEW_FULL_DETAILS; },
/* harmony export */   "_I": function() { return /* binding */ COLOR_SELECTION; },
/* harmony export */   "c7": function() { return /* binding */ BUNDLE; },
/* harmony export */   "cA": function() { return /* binding */ CAROUSEL_IMAGE; },
/* harmony export */   "cd": function() { return /* binding */ GUIDE; },
/* harmony export */   "fP": function() { return /* binding */ SEARCH_RESULTS; },
/* harmony export */   "g5": function() { return /* binding */ PLP; },
/* harmony export */   "iR": function() { return /* binding */ QUICK_VIEW; },
/* harmony export */   "jF": function() { return /* binding */ DOWNLOADS; },
/* harmony export */   "lq": function() { return /* binding */ REVIEW_CONTAINER_ID; },
/* harmony export */   "m$": function() { return /* binding */ DIMENSIONS; },
/* harmony export */   "mr": function() { return /* binding */ NOTIFY; },
/* harmony export */   "s4": function() { return /* binding */ SPEC_SHEET; }
/* harmony export */ });
const UPSELL_PRODUCT = "upsell product";
const QUICK_VIEW = "quick view";
const CLOSE = "close";
const QUICK_VIEW_MODAL = "quick view modal";
const ADD_TO_CART = "add to cart";
const VIEW_FULL_DETAILS = "view full details";
const DIMENSIONS = "dimensions";
const COLOR_SELECTION = "color selection";
const LIST_PRICE = "list price";
const CAROUSEL_IMAGE = "carousel image";
const REVIEW = "write a review";
const Download = "download";
const NOTIFY = "notify me";
const SPEC_SHEET = "specification sheet";
const GUIDE = "installation guide";
const REVIEW_CONTAINER_ID = "#product-review";
const DOWNLOADS = "downloads";
const BUNDLE = "bundle";
const PDP = "pdp";
const PRODUCT_DETAILS = "product details";
const SEARCH_RESULTS = "search results";
const PLP = "plp";


/***/ }),

/***/ 55888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ getInitialImageData; },
/* harmony export */   "Ne": function() { return /* binding */ getProductInfoQuickView; },
/* harmony export */   "Pq": function() { return /* binding */ handleAddToCart; },
/* harmony export */   "U2": function() { return /* binding */ organizeData; },
/* harmony export */   "ky": function() { return /* binding */ formatProductInfoForAnalytics; },
/* harmony export */   "lR": function() { return /* binding */ getListValue; },
/* harmony export */   "qt": function() { return /* binding */ preventPopupScroll; },
/* harmony export */   "uS": function() { return /* binding */ handleSpecsDownload; }
/* harmony export */ });
/* unused harmony exports getSlickSettings, getSlickQuickViewPdpThumbnail, addToCartHandler */
/* harmony import */ var _utils_addTocart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27522);
/* harmony import */ var _components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4364);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20558);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88751);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46201);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36513);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11763);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const getSlickSettings = ()=>{
    return {
        dots: false,
        draggable: true,
        touchMove: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: false,
        centerMode: false,
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    dotsClass: "slider-dots",
                    dots: true
                }
            }
        ]
    };
};
const getProductInfoQuickView = (data)=>{
    const { brandName ="" , productName ="" , productDesc ="" , skuID ="" , category , pdpType , productPrice =0 , discountedPrice =0 , productImageUrl , productOnStock , selectedColor , categoryType , waterSenseProduct  } = data;
    const waterSense = (waterSenseProduct === null || waterSenseProduct === void 0 ? void 0 : waterSenseProduct.length) > 0 ? true : false;
    const productInfo = {
        category: categoryType,
        description: productDesc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: selectedColor,
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: productName || productDesc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "product",
        productSalePrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        productSaleable: true,
        productStatus: productOnStock > 0 ? "in stock" : "out of stock",
        productSuperSku: false,
        productTileName: productName,
        quantity: 1,
        defaultImageName: productImageUrl || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: pdpType || "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: productName,
        productBrand: brandName,
        itemType: "product",
        waterSenseProduct: waterSense
    };
    return productInfo;
};
const formatProductInfoForAnalytics = function(productInfoData) {
    let isMultifinishBundle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, bundleInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!isMultifinishBundle) {
        return productInfoData;
    }
    const { bundleIds ="" , bundleProductColors ="" , pdpType: bundlePdpType = "" , bundlePrice =0  } = bundleInfo;
    return [
        {
            ...productInfoData,
            bundleIds,
            bundleProductColors,
            pdpType: bundlePdpType,
            bundlePrice
        }
    ];
};
const getSlickQuickViewPdpThumbnail = ()=>{
    return {
        dots: false,
        draggable: true,
        touchMove: true,
        slidesToScroll: 1,
        slidesToShow: 8.8,
        centerPadding: "10px",
        swipeToSlide: true,
        vertical: false,
        swipe: true,
        arrows: false,
        infinite: false,
        centerMode: false,
        focusOnSelect: false,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    draggable: true,
                    touchMove: true,
                    slidesToScroll: 1,
                    slidesToShow: 4.8,
                    centerPadding: "10px",
                    vertical: false,
                    swipe: true,
                    centerMode: false,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 8,
                    centerPadding: "10px",
                    vertical: false,
                    swipe: true,
                    centerMode: false,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 4.8,
                    centerPadding: "10px",
                    vertical: false,
                    swipe: true,
                    centerMode: false,
                    swipeToSlide: true
                }
            }
        ]
    };
};
const getListValue = function(arrayVal, stringVal) {
    let productData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (productData[arrayVal]) {
        return productData[arrayVal];
    } else if (productData[stringVal]) {
        return [
            productData[stringVal]
        ];
    } else {
        return [];
    }
};
const handleSpecsDownload = function(e, title, link) {
    let productInfo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    e.stopPropagation();
    let errMsg;
    const url = link.trim();
    try {
        window.open(url, "_blank");
    } catch (err) {
        errMsg = err.message;
        console.log(errMsg);
    }
};
const organizeData = (data, name, placeHolder, type)=>data.map((item, i)=>{
        let obj = {
            title: name ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
        };
        if (type === "part") {
            obj = {
                ...obj,
                id: item
            };
        } else {
            obj = {
                ...obj,
                type,
                url: item
            };
        }
        return obj;
    });
const getInitialImageData = function() {
    let labledImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], productSkuInit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const initialImagesData = [];
    if (labledImages.length) {
        var ref, ref1, ref2;
        const index = labledImages.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(productSkuInit);
        const assetId = ((ref1 = (ref = labledImages[index]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.length) ? labledImages[index].split("|")[1] : "";
        const imageParams = labledImages === null || labledImages === void 0 ? void 0 : (ref2 = labledImages[index]) === null || ref2 === void 0 ? void 0 : ref2.split("|");
        const primaryImage = imageParams === null || imageParams === void 0 ? void 0 : imageParams[imageParams.length - 1];
        initialImagesData.push({
            label: "",
            assetId,
            url: primaryImage !== null && primaryImage !== void 0 ? primaryImage : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"].src */ .Z.src
        });
    } else {
        initialImagesData.push({
            label: "",
            assetId: "",
            url: _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"].src */ .Z.src
        });
    }
    return initialImagesData;
};
// called when user click on Add To Cart button
const handleAddToCart = async function(e) {
    let selectedSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brandName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", cb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    var ref, ref1;
    e.preventDefault();
    e.stopPropagation();
    const { stock =0 , isError =false  } = await (0,_utils_cart__WEBPACK_IMPORTED_MODULE_7__/* .getStock */ .K5)(selectedSku);
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
    const { apiEndpoints: { stockFailureErrorMsg =""  } = {}  } = config || {};
    if (isError) {
        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__/* .showToast */ .CF)({
            isVisible: true,
            message: stockFailureErrorMsg
        }));
        cb();
        return;
    }
    const itemsProjectionApiResponse = await (0,_components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_1__/* .getProductsBySku */ .uX)([
        selectedSku
    ]);
    var ref2;
    const variants = (ref2 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref = itemsProjectionApiResponse[0]) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    variants.push((ref3 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref1 = itemsProjectionApiResponse[0]) === null || ref1 === void 0 ? void 0 : ref1.masterVariant) !== null && ref3 !== void 0 ? ref3 : {});
    let isComboSku = false;
    let isBackOrderable = false;
    for (const variant of variants){
        if (selectedSku === variant.sku) {
            var ref4;
            isComboSku = variant === null || variant === void 0 ? void 0 : variant.attributes.some((attr)=>attr.name === "ComboSKU");
            var ref5;
            isBackOrderable = (ref5 = (ref4 = variant === null || variant === void 0 ? void 0 : variant.attributes.find((attr)=>attr.name === "RegionIsBackorderable")) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref5 !== void 0 ? ref5 : false;
        }
    }
    if (stock > 0 || isBackOrderable) {
        const payload = [
            {
                sku: selectedSku,
                quantity: 1,
                brand: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
                isBundle: isComboSku,
                backorder: isBackOrderable
            }
        ];
        addToCartHandler(payload, cb);
    }
};
// Api call to dispatch the item to the cart
const addToCartHandler = async function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    const payload = await (0,_utils_addTocart__WEBPACK_IMPORTED_MODULE_0__/* .addToCartItem */ .q)([
        ...items
    ]);
    const body = {
        actions: payload
    };
    _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        const { payload ={}  } = res;
        if (!(0,_utils___WEBPACK_IMPORTED_MODULE_2__/* .isObjectEmpty */ .nK)(payload)) {
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .setCart */ .RV)(payload));
        }
        cb();
        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__/* .showPreviewCart */ .z0)());
    }).catch((err)=>{
        cb();
    });
};
// if quickview modal open prevent scrollbar body top
const preventPopupScroll = function() {
    let isPopupClose = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const bodyElement = document.body;
    if (isPopupClose) {
        bodyElement.classList.remove("quickview-image-scroll");
    } else {
        bodyElement.classList.remove("modal-open", "scroll-lock");
        document.getElementsByTagName("html")[0].classList.remove("modal-open", "scroll-lock");
        bodyElement.classList.add("quickview-image-scroll");
    }
};


/***/ }),

/***/ 54075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UpsellInstallServices_ProductCardForUpsell; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.module.scss
var index_module = __webpack_require__(20079);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/analytics/constant.js
const UPSELL = "upsell product";
const ADD_TO_CART = "add to cart";
const PREVIEW = "preview";

;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/analytics/index.js

const addAnalyticsForAddToCart = function(item, productPrice, discountedPrice, productImageUrl) {
    let recommendationSource = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "n/a";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageload, " ").concat(PREVIEW, ":").concat(UPSELL, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "".concat(pageload, " ").concat(PREVIEW, ":").concat(UPSELL, ":").concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: ADD_TO_CART,
        internalLinkPosition: "".concat(pageload, " ").concat(PREVIEW, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(ADD_TO_CART),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, " ").concat(PREVIEW, ":our best sellers")
    };
    pushAnalyticsObjToDataLayer(eventInfo, item, productPrice, discountedPrice, productImageUrl);
};
const addClickAnalytics = (data)=>{
    const { item , productPrice , discountedPrice , productImageUrl , productUrl  } = data;
    const { ProductBrandName_s: name = "" , ProductDescriptionProductShort_s: desc = "" , Product_Category: category = ""  } = item;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart preview:upsell product navigation",
        eventMsg: "n/a",
        eventName: "cart preview:upsell product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: name || desc || category || "n/a",
        internalLinkPosition: "cart preview:upsell",
        internalLinkType: "cart:upsell navigation",
        internalLinkURL: productUrl || "n/a",
        internalLinkZoneName: "cart preview:our best sellers"
    };
    pushAnalyticsObjToDataLayer(eventInfo, item, productPrice, discountedPrice, productImageUrl);
};
const getproductInfo = (item, productPrice, discountedPrice, productImageUrl)=>{
    const { CustomerFacingBrand_s: brandName = "" , sku_s: skuID = "" , ProductBrandName_s: name = "" , ProductDescriptionProductShort_s: desc = "" , Product_Category: category = ""  } = item;
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((productPrice - 0).toFixed(2)) : 0,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: "default",
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name,
        quantity: 1,
        defaultImageName: productImageUrl,
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category,
        productBrand: brandName,
        itemType: "service" || 0
    };
    return productInfo;
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, item = arguments.length > 1 ? arguments[1] : void 0, productPrice = arguments.length > 2 ? arguments[2] : void 0, discountedPrice = arguments.length > 3 ? arguments[3] : void 0, productImageUrl = arguments.length > 4 ? arguments[4] : void 0;
    const page = window.pageObj || {};
    const productInfo = getproductInfo(item, productPrice, discountedPrice, productImageUrl);
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

// EXTERNAL MODULE: ./components/Shared/QuickView/analytics.js
var analytics = __webpack_require__(78592);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/Shared/QuickView/utlis.js
var utlis = __webpack_require__(55888);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/ProductCard.jsx

















const QuickView = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2374), __webpack_require__.e(5490)]).then(__webpack_require__.bind(__webpack_require__, 10322)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10322)
            ]
    }
});
const ProductCard = (param)=>{
    let { persona ="GST" , currencySign ="$" , brand ="kohler" , presetConfigs ="" , rowCols =0 , swatchUrl: baseUrl = "" , outOfStockTitle ="" , addToCart =()=>{} , staticText ={} , productData ={} , quickViewAuthData ={} , quickViewButtonLabel ="" , ...item } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const [showQuickViewModal, setShowQuickViewModal] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { apiEndpoints: { stockFailureErrorMsg =""  } = {}  } = globalConfig;
    const { sku_s: skuId = "" , quantity: productQuantity = 0 , ProductBrandName_s: name = "" , productName_s: productName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["productImages.labelWithUrl_ss"]: labledImages = [] , Product_Category: productCategory = "" , slug_s: slug = "" , ctProductType_s: productType = ""  } = item;
    (0,react.useEffect)(()=>{
        (0,helper/* getPDPUrl */.ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
    }, []);
    const price = Number(productPrice).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const productPresetConfigs = presetConfigs ? JSON.parse(presetConfigs) : {};
    let imgId = "";
    if (labledImages.length) {
        var ref, ref1;
        const index = labledImages.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(skuId);
        const assetId = ((ref1 = (ref = labledImages[index]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.length) ? labledImages[index].split("|")[1] : "";
        imgId = assetId;
    }
    const handleAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleAddToCart = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);
        const { isError  } = await (0,cart/* getStock */.K5)(skuId);
        if (isError) {
            dispatch((0,genericSlice/* showToast */.CF)({
                isVisible: true,
                message: stockFailureErrorMsg
            }));
            setLoading(false);
            return;
        }
        const payload = [
            {
                sku: skuId,
                quantity: 1,
                brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                isBundle: productType === "engineer-bundle"
            }
        ];
        addToCart(payload, handleAddToCartCb);
        addAnalyticsForAddToCart(item, productPrice, discountedPrice, productImageUrl);
    };
    const productImageUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, baseUrl, imgId, productPresetConfigs);
    const productUrl = "".concat(constants.DOMAIN).concat(pdpUrl).concat(skuId ? "?skuId=" + skuId : "") || "";
    const linkClicked = ()=>{
        addClickAnalytics({
            item,
            productPrice,
            discountedPrice,
            productImageUrl,
            productUrl
        });
    };
    const openQuickViewModal = ()=>{
        (0,analytics/* quickViewOpenAnalytics */.E$)({
            productData,
            productUrl,
            productImageUrl,
            upshellmodal: true
        });
        setShowQuickViewModal(true);
    };
    const closeQuickViewModal = ()=>{
        setShowQuickViewModal(false);
        (0,utlis/* preventPopupScroll */.qt)(true);
    };
    (0,react.useEffect)(()=>{
        if (showQuickViewModal) {
            (0,utlis/* preventPopupScroll */.qt)();
        }
    }, [
        showQuickViewModal
    ]);
    const [productInfo, setProductInfo] = (0,react.useState)({});
    const handleProductInfo = (data)=>{
        setProductInfo(data);
    };
    const handleButtonClosed = ()=>{
        (0,analytics/* quickViewCloseAnalytics */.I4)({
            productInfo,
            upshellmodal: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).curatedProduct,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "curated-product-recommendation__card-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(pdpUrl).concat(skuId ? "?skuId=" + skuId : ""),
                    onClick: linkClicked,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "curated-product-recommendation__product-card",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: productImageUrl,
                                    alt: name,
                                    width: 280,
                                    height: 280
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__product-name",
                                children: name || productName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__product-sku",
                                children: skuId
                            }),
                            discountedPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "curated-product-recommendation__discounted-price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "price-with-discount",
                                        children: "".concat(currencySign).concat(discountedPrice)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "original-price",
                                        children: "".concat(currencySign).concat(price)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__product-price",
                                children: "".concat(currencySign).concat(price)
                            }),
                            !productQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__out-of-stock",
                                children: outOfStockTitle
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cart-quickview-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "curated-product-recommendation__add-to-cart".concat(!quickViewButtonLabel ? " upshell-button" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            label: "Add To Cart",
                                            size: "small",
                                            type: "primary",
                                            flexible: true,
                                            onClick: handleAddToCart,
                                            loading: loading
                                        })
                                    }),
                                    quickViewButtonLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "quick-view-title",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            label: quickViewButtonLabel,
                                            size: "small",
                                            type: "ghost",
                                            ariaLabel: quickViewButtonLabel,
                                            flexible: true,
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                openQuickViewModal();
                                            }
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                showModal: showQuickViewModal,
                onModalClose: closeQuickViewModal,
                className: "quickview-modal",
                isCloseButtonClicked: handleButtonClosed,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickView, {
                    productData: productData,
                    authorData: quickViewAuthData,
                    closeModal: closeQuickViewModal,
                    upshellmodal: true,
                    handleProductInfo: handleProductInfo
                })
            })
        ]
    });
};
/* harmony default export */ var ProductCardForUpsell_ProductCard = (/*#__PURE__*/(0,react.memo)(ProductCard));

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(9670);
// EXTERNAL MODULE: ./services/productServices.js
var productServices = __webpack_require__(35285);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx
















const ProductCardForUpsell = (param)=>{
    let { authData ={} , staticText ={} , quickViewAuthData ={}  } = param;
    const { skuIds =[] , presetConfigs ="" , swatchUrl ="" , outOfStockTitle ="" , quickViewButtonLabel =""  } = authData;
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const rowCols = (0,utils/* getRowCols */.n)(width, lib/* isMobile */.tq, lib/* isTablet */.Em);
    const persona = (0,helper/* getUserPersona */.shu)();
    const [recommendedProductData, setRecommendedProductData] = (0,react.useState)([]);
    const [currency, setCurrencySign] = (0,react.useState)("$");
    const [brand, setBrand] = (0,react.useState)("kohler");
    const callToFetchRecommendedProductData = ()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            if (!isEmpty_default()(config)) {
                const { general: { lwAppName ="" , siteName ="kohler"  } = {} , internationalization: { currencySign ="$"  } = {}  } = config;
                if (skuIds.length) getRecommendedProductData({
                    lwAppName,
                    currencySign,
                    siteName
                });
            }
        });
    };
    (0,react.useEffect)(()=>{
        if (persona) callToFetchRecommendedProductData();
    }, [
        persona
    ]);
    const getRecommendedProductData = (param)=>{
        let { lwAppName ="" , currencySign ="$" , siteName ="kohler"  } = param;
        (0,api/* getProductDataFromSkuIds */.fh)(persona, skuIds, lwAppName).then(async (res)=>{
            const skuidString = skuIds.join(",");
            if (!isEmpty_default()(res) && skuidString) {
                const { data: { response: { docs =[]  } = {}  } = {}  } = res;
                const { inventories =[]  } = await (0,productServices/* getProductInventory */.o)(skuidString);
                const updatedDocs = [];
                skuIds.forEach((sku)=>{
                    docs.forEach((item)=>{
                        if (sku === item.sku_s) {
                            const matchItem = inventories.find((product)=>product.sku === item.sku_s);
                            if (matchItem) {
                                updatedDocs.push({
                                    ...item,
                                    quantity: matchItem === null || matchItem === void 0 ? void 0 : matchItem.availableQuantity
                                });
                            }
                        }
                    });
                });
                setCurrencySign(currencySign);
                setBrand(siteName);
                setRecommendedProductData(updatedDocs);
            }
        });
    };
    const handleAddToCart = async function() {
        let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
        const payload = await (0,addTocart/* addToCartItem */.q)([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
            dispatch((0,genericSlice/* showPreviewCart */.z0)());
            const { payload ={}  } = res;
            if (!isEmpty_default()(payload)) {
                dispatch((0,cartSlice/* setCart */.RV)(payload));
            }
            cb();
        }).catch((err)=>{
            cb();
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).curatedProduct,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "curated-product-recommendation",
            children: recommendedProductData.map((item)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell_ProductCard, {
                        addToCart: handleAddToCart,
                        ...item,
                        persona: persona,
                        currencySign: currency,
                        brand: brand,
                        presetConfigs: presetConfigs,
                        rowCols: rowCols,
                        swatchUrl: swatchUrl,
                        outOfStockTitle: outOfStockTitle,
                        staticText: staticText,
                        productData: item,
                        quickViewAuthData: quickViewAuthData,
                        quickViewButtonLabel: quickViewButtonLabel
                    })
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var UpsellInstallServices_ProductCardForUpsell = (ProductCardForUpsell);


/***/ }),

/***/ 9670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ getListOfRequiredSkus; },
/* harmony export */   "U1": function() { return /* binding */ getListOfRequiredAdobeTargetSkus; },
/* harmony export */   "X_": function() { return /* binding */ getZipCodes; },
/* harmony export */   "fh": function() { return /* binding */ getProductDataFromSkuIds; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19514);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51666);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64757);






const getListOfParamsToFetch = (persona)=>{
    const fl = [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "sku_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "title_s",
        "ProductNarrativeDescription_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "RegionBrandName_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "CrossSellRecommendationSKUList_ss",
        "productImages.labelWithUrl_ss",
        "ItemResource.IMGSpinSet.resourceFullWebURL_ss",
        "ItemResource.IMGSpinSet.resourceName_ss",
        "ItemResource.IMGSpinSet.resourceAltText_ss",
        "ItemResource.IMGSpinSet.resourceType_ss",
        "ctProductType_s",
        "RegionIsBackorderable_b",
        "RegionLeadTime_i"
    ];
    return fl.join(",");
};
const getProductDataFromSkuIds = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", skus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lwAppName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    if (!skus.length) return;
    const fl = getListOfParamsToFetch(persona);
    const fq = "sku_s:(".concat(skus.map((ele)=>'"'.concat(ele, '"')).join(" "), ")");
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const brand = lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase();
    var ref2;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("/search/plp", {
        params: {
            fl,
            q: "*:*",
            fq: [
                fq,
                'language_s:("'.concat(language, '")')
            ],
            collections: brand,
            profilename: "profile_".concat(brand, "_Full_Catalog"),
            rows: (ref2 = skus === null || skus === void 0 ? void 0 : skus.length) !== null && ref2 !== void 0 ? ref2 : 10
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_4___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};
const getZipCodes = async (jsonFileUrl)=>await (0,_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance */ .Gb)({
        url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: jsonFileUrl
        }
    });
const getListOfRequiredSkus = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", sku = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lwAppName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    try {
        var ref;
        const fl = getListOfParamsToFetch(persona);
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const fq = 'sku_s:("'.concat(sku, '")');
        return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("search/pdp/".concat(slug), {
            fl,
            q: "*:*",
            fq: "".concat(fq, ' AND language_s:("').concat(language, '")'),
            collections: lwAppName,
            profilename: "profile_".concat(lwAppName, "_General")
        });
    } catch (err) {
        return {};
    }
};
const getListOfRequiredAdobeTargetSkus = async function(payload) {
    let logger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    try {
        var ref, ref1, ref2;
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT */ .TE, "?sessionId=").concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_5__/* .getSessionId */ .MQ)()), payload);
        var ref3;
        return (ref3 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.execute) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.mboxes) === null || ref2 === void 0 ? void 0 : ref2[0]) !== null && ref3 !== void 0 ? ref3 : [];
    } catch (error) {
        logger.error("Error fetching Adobe Target recommended SKUs", {
            error,
            payload
        });
        return [];
    }
};



/***/ }),

/***/ 55938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7737);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84181);
/* harmony import */ var _components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55760);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49682);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24899);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29843);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20558);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2595);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85518);


















const SearchPanel = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2857), __webpack_require__.e(2247), __webpack_require__.e(1976), __webpack_require__.e(9562), __webpack_require__.e(448), __webpack_require__.e(7845)]).then(__webpack_require__.bind(__webpack_require__, 47845)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47845)
            ]
    }
});
const UtilityWidgets = (props)=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
    let analyticsEventData = {};
    const { columnClassNames , data , showSearchBar , handleSearchClick , setOpenVisualSearch =()=>{} , isFirstTime =false , setIsFirstTime =()=>{} , setShowSearchBar =()=>{}  } = props || {};
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_11__/* .selectAuthState */ ._9);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getUserPersona */ .shu)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
    const currencySign = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const currencyCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const searchPagePath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const knowledgeArticleUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    // const [showSearchBar, setShowSearchBar] = useState(false)
    const [selectedData, setSelectedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [searchString, setSearchString] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [searchStringValue, setSearchStringValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    var ref1;
    const [searchHistory, setSearchHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref1 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref1 !== void 0 ? ref1 : []);
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [prevSearch, setPrevSearch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [searchTotal, setSearchTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [searchProfileTotal, setSearchProfileTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [category, setCategory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [tilesData, setTilesData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [xfLink, setXfLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [promoLayout, setPromoLayout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isSterling, setIsSterling] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const selectedFavoritesState = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectFavoritesState */ .Qx);
    const { favorites  } = selectedFavoritesState || {};
    const { lineItems =[]  } = favorites || {};
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showSearchBar) {
            var ref;
            setSearchHistory((ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        showSearchBar
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = await lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "internationalization.currencySign", "");
                    currencyCode.current = await lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.searchPagePath", ""));
                    setRedirectTileToKohelerPLP(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.searchPagePath", "")));
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isSsr,
        isGlobalConfigBlank
    ]);
    const getEventInfoObj = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        var ref;
        const currDate = new Date();
        const contentType = window.eventPageType || "";
        const pageName = contentType === "homepage" ? "home" : contentType && contentType.split("-")[0] || "";
        const searchSuggestedTerm = [];
        if (!analyticsEventData.searchString) {
            analyticsEventData.searchString = (eventType === null || eventType === void 0 ? void 0 : eventType.searchTerm) || searchString;
        }
        if (!analyticsEventData.searchTotal) {
            analyticsEventData.searchTotal = searchTotal;
        }
        if (!analyticsEventData.topSuggestedData) {
            analyticsEventData.topSuggestedData = topSuggestedData;
        }
        const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
        if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
            searchSuggestions.slice(0, 5).map((item)=>{
                searchSuggestedTerm.push((0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(item.productName_s || item.keyWord));
            });
        }
        const eventseachName = isserachButton ? "internal search" : "internal automatic search";
        const names = topSuggestedData ? topSuggestedData === null || topSuggestedData === void 0 ? void 0 : topSuggestedData.filter((obj)=>"productName_s" in obj).map(function(obj) {
            return obj["productName_s"];
        }) : null;
        const topsuggestions = names ? (ref = names === null || names === void 0 ? void 0 : names.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : null;
        const eventInfo = {
            eventName: eventseachName,
            eventAction: eventseachName,
            internalLinkName: "internal search icon",
            internalLinkType: "global header:navigation",
            internalLinkZoneName: "global header",
            clickInternalLinks: "true",
            eventType: "global header",
            internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
            internalLinkPosition: "global header",
            eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
            eventStatus: status || "n/a",
            searchTerm: analyticsEventData.searchString,
            searchContentType: pageName ? pageName + " page" : "n/a",
            searchSuggestedTerm: topsuggestions ? topsuggestions : "n/a",
            searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
            searchResult: analyticsEventData.searchTotal,
            internalZoneName: "search:search box",
            pageURL: window.location.href,
            referrer: document.referrer || "n/a",
            previousPage: document.referrer || "n/a",
            timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
            contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        };
        if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
            eventType.term = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(eventType.term);
            eventType.type = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(eventType.type);
            eventInfo.eventName = "search:" + eventType.type + ":search term";
            eventInfo.eventAction = "search:" + eventType.type + ":search term";
            eventInfo.internalLinkZoneName = "search:" + eventType.type;
            if (eventType.type === "top suggestions") {
                var ref1;
                eventInfo.searchTerm = (ref1 = analyticsEventData.searchString) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                eventInfo.searchSuggestedTerm = eventType.term;
            } else {
                eventInfo.searchTerm = eventType.term;
            }
            eventInfo.internalLinkName = eventType.term;
            eventInfo.internalZoneName = "search:" + eventType.type;
        }
        analyticsEventData = {};
        return eventInfo;
    };
    const handleSearchAnalyticsEvent = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        if (!internalLinkURL) internalLinkURL = redirectUrl;
        const eventInfo = getEventInfoObj(searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData);
        sessionStorage.setItem("searches", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType, isserachButton, topSuggestedData)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "success", null, null, analyticsEventType);
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandSearch */ .R$)([
                searchTerm.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                if (res.payload) {
                    let redirectLink = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (res.payload.fusion && res.payload.fusion.redirect && res.payload.fusion.redirect[0]) {
                        redirectLink = res.payload.fusion.redirect[0];
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectLink;
                    } else if (res.payload.response.numFound === 1 && res.payload.fusion.exactMatch) {
                        const d = res.payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(d.Product_Category, d.slug_s);
                            redirectLink = (0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectLink = d.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType);
                        window.location.href = redirectLink;
                    } else if (res.payload.fusion.partsCount === 1 && res.payload.fusion.partsExactMatch) {
                        const d1 = res.payload.fusion.partsDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "skuId=".concat(d1.sku_s) : "";
                            const pdpUrl1 = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(null, d1.slug_s);
                            redirectLink = (0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl1, param1);
                        } else if (d1.url_s) {
                            redirectLink = d1.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType);
                        window.location.href = redirectLink;
                    } else {
                        redirectLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeUrl */ .Nmg)(window.location.origin + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .removeAndCleanLink */ .xEh)(searchPagePath.current) + "?keyword=".concat(encodeURIComponent(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim())));
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectLink;
                    }
                }
            // setProductsLoaded(true)
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "failure", "error occured while fetching search data", null, analyticsEventType);
                setProductsLoaded(true);
            });
        }
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchStringValue(searchTerm);
        setSearchString(searchTerm.trim());
    };
    const searchingDebounced = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default()(function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return getData(searchStr);
    }, 300), [
        prevSearch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (brandName) {
            if (searchString.length >= 3) {
                setPrevSearch(searchString);
                searchingDebounced(searchString);
            } else {
                setSearchTotal(0);
            }
            setProductsLoaded(false);
        }
        return ()=>{
            searchingDebounced.cancel();
        };
    }, [
        searchString,
        brandName,
        searchingDebounced
    ]);
    const executeTypeaheadApi = function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandTypeahead */ .zw)([
            searchStr.trim(),
            brand.toLowerCase()
        ])).unwrap().then((res)=>{
            const { response: { docs =[]  } = {}  } = res;
            docs.length && setTopSuggestedData(docs);
        });
    };
    const getData = function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const { disableParts  } = data;
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            executeTypeaheadApi(searchStr, brandName);
            dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandSearch */ .R$)([
                searchStr.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                if (res.payload) {
                    // get PDP / article URL if only 1 result
                    if (res.payload.response.numFound === 1 && res.payload.fusion.exactMatch) {
                        const d = res.payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(d.Product_Category, d.slug_s);
                            setRedirectUrl((0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl, param));
                        } else if (d.url_s) {
                            setRedirectUrl(d.url_s);
                        }
                    } else if (res.payload.fusion.partsCount === 1 && res.payload.fusion.partsExactMatch) {
                        const d1 = res.payload.fusion.partsDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "skuId=".concat(d1.sku_s) : "";
                            const pdpUrl1 = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(null, d1.slug_s);
                            setRedirectUrl((0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl1, param1));
                        }
                    }
                    setSearchProfileTotal(res.payload.response.numFound);
                    let groups = [
                        {
                            key: "products",
                            fq: 'Products:("'.concat(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Products[0]", "ct"), '")'),
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Products[1]", 0)
                        },
                        {
                            key: "parts",
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload.fusion.partsCount, "res.payload.fusion.partsCount", 0)
                        },
                        {
                            key: "technical",
                            fq: 'Technical:("'.concat(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Technical[0]", "No"), '")'),
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Technical[1]", 0)
                        },
                        {
                            key: "inspiration",
                            fq: 'Inspiration:("'.concat(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Inspiration[0]", "Inspiration"), '")'),
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                        },
                        {
                            key: "resource",
                            fq: 'Resource:("'.concat(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Resource[0]", "Resource"), '")'),
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Resource[1]", 0)
                        },
                        {
                            key: "help",
                            fq: 'Help:("'.concat(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Help[0]", "sf"), '")'),
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Help[1]", 0)
                        }
                    ];
                    if (disableParts) {
                        groups = groups.filter((arr)=>{
                            return arr.key !== "parts";
                        });
                    }
                    // Calculating the total results
                    let total = 0;
                    const selected = groups.find((group)=>group.count > 0);
                    if (res.payload.fusion.exactMatch || res.payload.fusion.partsExactMatch) {
                        total = selected.key === "parts" ? res.payload.fusion.partsCount : res.payload.response.numFound;
                    } else {
                        groups.forEach((group)=>total += group.count);
                    }
                    analyticsEventData.searchTotal = total;
                    analyticsEventData.redirectUrl = redirectUrl;
                    analyticsEventData.topSuggestedData = {
                        ...topSuggestedData
                    };
                    analyticsEventData.selectedData = selected;
                    analyticsEventData.searchString = searchStr.trim();
                    setSearchTotal(total);
                    setRedirectUrl(redirectUrl);
                    const fullCatalogResponse = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "fusion.full_catalog_Response", []);
                    if (fullCatalogResponse.length > 0) {
                        setIsSterling(true);
                        setSearchTotal(1);
                        setTopSuggestedData(fullCatalogResponse);
                    }
                    setFusioFullCatalognResponse(fullCatalogResponse);
                    handleSearchAnalyticsEvent(searchStr, "success");
                    setSelectedData(selected);
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
            setSearchProfileTotal(0);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (searchTotal > 0 && (selectedData === null || selectedData === void 0 ? void 0 : selectedData.key)) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "masterCustomerFacingSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "urlName_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "layoutItems.Article_Type__c.value_s",
            "layoutItems.KM_Article_Content__c.value_s",
            "layoutItems.KBNA_3C_Image_Video__c.label_s",
            "layoutItems.KBNA_3C_Image_Video__c.value_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "primaryBundleSKU_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch(selected.key === "parts" ? (0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileServicePartsSearch */ .n7)([
            searchString.trim(),
            fl.join(","),
            8
        ]) : (0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandSearch */ .R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            8,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if ((fusionFullCatalogResponse === null || fusionFullCatalogResponse === void 0 ? void 0 : fusionFullCatalogResponse.length) > 0) {
                    setTilesData(fusionFullCatalogResponse);
                }
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        });
    };
    const bodyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(document.body);
    const htmlRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(document.getElementsByTagName("html")[0]);
    const handleToggle = ()=>{
        var ref;
        showSearchBar ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .addMavenoidChat */ .dVG)() : react_device_detect__WEBPACK_IMPORTED_MODULE_16__/* .isMobile */ .tq ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .removeMavenoidChat */ .N9B)() : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .addMavenoidChat */ .dVG)();
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.map((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.map((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        handleSearchClick(!showSearchBar);
        const page = window.pageObj || {};
        const previousPageNameForSearch = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
        sessionStorage.setItem("previousPageNameForSearch", previousPageNameForSearch);
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        isAuth ? router.push("/en/my-account/my-favorites") : dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_11__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    const handleClearInput = ()=>{
        setSearchString("");
        setSearchStringValue("");
        setTopSuggestedData([]);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17___default().utilityWidgetsWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "utilitywidgets ".concat(columnClassNames ? columnClassNames : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: "list",
                className: "utility-widgets",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "search-widget",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: showSearchBar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchPanel, {
                                showSearchBar: showSearchBar,
                                setShowSearchBar: setShowSearchBar,
                                onToggle: handleToggle,
                                onRedirect: handleRedirect,
                                onChange: handleChange,
                                searchString: searchString,
                                brand: brandName,
                                searchTotal: searchTotal,
                                topSuggestedData: topSuggestedData,
                                searchHistory: searchHistory,
                                xfLink: xfLink,
                                category: category,
                                removeFromCompare: _utils_product__WEBPACK_IMPORTED_MODULE_12__/* .removeFromCompareProduct */ .Zj,
                                addToCompare: _utils_product__WEBPACK_IMPORTED_MODULE_12__/* .addToCompareProduct */ .dX,
                                tilesData: tilesData,
                                productsLoaded: productsLoaded,
                                promoLayout: promoLayout,
                                favorites: (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getFavouraties */ .MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                                comparedProducts: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getCompareData */ .p2C)(),
                                currencySign: currencySign.current,
                                knowledgeArticleUrl: knowledgeArticleUrl.current,
                                presetConfigs: data.presetConfigs,
                                onDelete: handleDelete,
                                onClearAll: handleClearAll,
                                isSterling: isSterling,
                                sterlingData: fusionFullCatalogResponse,
                                parent: "Utility Widgets",
                                searchPagePath: redirectTileToKohelerPLP,
                                searchProfileTotal: searchProfileTotal,
                                handleClearInput: handleClearInput,
                                searchStringValue: searchStringValue,
                                setOpenVisualSearch: setOpenVisualSearch,
                                isFirstTime: isFirstTime,
                                setIsFirstTime: setIsFirstTime
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "wishlist-widget d-lg-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "aria-label": "View your wishlist",
                            className: "gbh-data-layer",
                            onClick: handleLogin,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                "aria-hidden": "true",
                                alt: "Wishlist",
                                src: lineItems && lineItems.length > 0 ? _constants__WEBPACK_IMPORTED_MODULE_4__.FULL_FAVORITE_BASE64 : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_FAVORITE_BASE64
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UtilityWidgets);


/***/ }),

/***/ 59362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ addAnalyticsEventForImageTitle; },
/* harmony export */   "I8": function() { return /* binding */ dataLayershopTheRoomPlusButton; },
/* harmony export */   "Xc": function() { return /* binding */ addAnalyticsEventForFavouriteAddRemove; },
/* harmony export */   "dv": function() { return /* binding */ shopRoomhandleProductClick; },
/* harmony export */   "i2": function() { return /* binding */ addAnalyticsEventForPrevNext; },
/* harmony export */   "vf": function() { return /* binding */ closeButtonAnalytics; }
/* harmony export */ });
/* unused harmony export addAnalyticsEventForProductInfo */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38560);


const pushToAdobeDataLayer = (eventInfo, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...productInfo ? {
            productInfo
        } : {},
        page
    });
};
const dataLayershopTheRoomPlusButton = (cardTitle, url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        eventName: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "room detail card modal open",
        internalLinkPosition: "shop the room",
        internalLinkType: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        internalLinkZoneName: "shop the room:all rooms",
        internalLinkURL: url
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForPrevNext = (navigationType)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:".concat(navigationType.toLowerCase(), " arrow"),
        eventName: "shop the room: room detail card modal:".concat(navigationType.toLowerCase(), " arrow"),
        eventType: "carousel",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(navigationType.toLowerCase(), " arrow"),
        internalLinkPosition: "shop the room: room detail card modal:carousel",
        internalLinkType: "shop the room: room detail card modal:classic glam room details",
        internalLinkZoneName: "shop the room: room detail card modal: shop products in this room",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForImageTitle = (cardTitle, url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        eventName: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(cardTitle.toLowerCase()),
        internalLinkPosition: "room detail card modal",
        internalLinkType: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        internalLinkZoneName: "shop the room: room detail card modal",
        internalLinkURL: url
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForFavouriteAddRemove = (favouriteType, productInfo)=>{
    const favoriteText = favouriteType ? "add" : "remove";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal: favorite ".concat(favoriteText.toLowerCase()),
        eventMsg: "your item has been ".concat(favoriteText.toLowerCase(), " to your Favorites"),
        eventName: "shop the room: room detail card modal: favorite ".concat(favoriteText.toLowerCase()),
        eventType: "wishlist save",
        eventStatus: "sucess",
        internalLinkName: "favorite ".concat(favoriteText.toLowerCase()),
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal: favorite",
        internalLinkZoneName: "shop the room: room detail card modal",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeButtonAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:close button",
        eventName: "shop the room: room detail card modal:close button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal :close",
        internalLinkZoneName: "shop the room: room detail card modal:navigation",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForProductInfo = (eventInfo, productInfo)=>{
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const shopRoomhandleProductClick = (productInfoParams)=>{
    const { productData , sku , url , cart , config , description , persona  } = productInfoParams;
    const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_1__/* .getProductInfo */ .C)(productData, sku, false, cart, config, description, persona);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal: product navigation",
        eventMsg: "n/a",
        eventName: "shop the room: room detail card modal: product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "RegionBrandName_s", ""),
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal: navigation",
        internalLinkURL: url,
        internalLinkZoneName: "shop the room: room detail card modal"
    };
    addAnalyticsEventForProductInfo(eventInfo, productInfo);
};



/***/ }),

/***/ 75781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59362);





const DynamicImage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18377)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18377)
            ]
    }
});
const Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78145)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(78145)
            ]
    }
});
const ShopTheRoomCardModalView = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90746)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90746)
            ]
    }
});
const ShopTheRoomCard = (props)=>{
    const { cardTitle ="" , cardHoverTitle ="" , ctalink ="" , landingImageLink ="" , modelImageLink ="" , skuIds =[] , presetConfigs ="{}" , altLanding ="" , altModel ="" , linkNewTab =false  } = props;
    const [showModal, setShowModalState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isHover, setIsHover] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [link, setLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isImageLoaded, setImageLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setImageLoaded(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicImage, {
            imgUrl: landingImageLink,
            alt: altLanding,
            width: "100%",
            style: {
                aspectRatio: "1.333/1"
            }
        }));
    }, [
        landingImageLink
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ctalink) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrl */ .Ppy)(ctalink).then((link)=>setLink(link));
        }
    }, [
        ctalink
    ]);
    const handleModal = (e)=>{
        e.stopPropagation();
        setShowModalState(!showModal);
        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_4__/* .dataLayershopTheRoomPlusButton */ .I8)(cardTitle);
    };
    const handleCloseModal = (e)=>{
        e.stopPropagation();
        setShowModalState(!showModal);
        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_4__/* .closeButtonAnalytics */ .vf)();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "shoptheroomcard",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "shop-the-room-card-container",
            style: isImageLoaded ? {} : {
                height: "66%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "shop-the-room-card",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: link,
                            onMouseEnter: ()=>setIsHover(true),
                            onMouseLeave: ()=>setIsHover(false),
                            target: linkNewTab ? "_blank" : "",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "shop-the-room-card-clip",
                                children: [
                                    isImageLoaded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: isImageLoaded
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-tile",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "product-list-tile__image wow",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "shimmer-loading__image shimmer"
                                            })
                                        })
                                    }),
                                    isHover ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "shop-the-room-card-hover-text",
                                        children: cardHoverTitle
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "plus",
                            onClick: handleModal,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "line line-1"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "line line-2"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "shop-the-room-card-modal",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
                        showModal: showModal,
                        onModalClose: handleCloseModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopTheRoomCardModalView, {
                            skuIds: skuIds,
                            presetConfigs: presetConfigs,
                            imageLink: modelImageLink,
                            cardTitle: cardTitle,
                            ctalink: ctalink,
                            altModel: altModel
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "shop-card-title",
                    children: cardTitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShopTheRoomCard);


/***/ }),

/***/ 90746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59362);
/* harmony import */ var _components_core_Image_DynamicImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18377);
/* harmony import */ var _components_productCard_v3_ProductCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44685);









const ShopTheRoomCardModalView = (param)=>{
    let { skuIds =[] , presetConfigs ="{}" , imageLink ="" , cardTitle ="" , ctalink ="" , isModal =true , altModel ="" , selectedProduct ="" , hotspotClicked =false , setHotspotClicked =()=>{} , invokedFrom ="button" , setInvokedFrom =()=>{} , enableFavorite =false  } = param;
    var ref;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const selectedIndex = skuIds.indexOf(selectedProduct);
    const [visibleSkuIdsObj, setVisibleSKuIds] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        currentPageSkus: [
            skuIds[0]
        ],
        visibleQuantity: 1,
        firstIndex: 0,
        isLeftDisabled: true,
        isRightDisabled: false
    });
    const [shopTheRoomLink, setShopTheRoomLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const productCardContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const productCardRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    let localVisibleQuantity = visibleSkuIdsObj.visibleQuantity;
    let localInnerWidth = window.innerWidth;
    const staticTexts = {
        title: t("kf.shoptheroom.modal.text")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        updateVisibleSkuIdsObject(true);
        window.addEventListener("resize", handleOnResize);
        return ()=>{
            window.removeEventListener("resize", handleOnResize);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ctalink) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(ctalink).then((link)=>setShopTheRoomLink(link));
        }
    }, [
        ctalink
    ]);
    const handleOnResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(()=>{
        var ref;
        if (((ref = productCardContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) > productCardRef.current.clientWidth * (localVisibleQuantity + 1)) {
            updateVisibleSkuIdsObject(true);
        } else if (localInnerWidth > window.innerWidth) {
            const difference = localInnerWidth - window.innerWidth;
            difference >= productCardRef.current.clientWidth && updateVisibleSkuIdsObject(false, difference);
        }
        localInnerWidth = window.innerWidth;
    }, _constants__WEBPACK_IMPORTED_MODULE_4__.MIN_DELAY);
    const updateVisibleSkuIdsObject = function(isAddItem) {
        let difference = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (skuIds.length >= visibleSkuIdsObj.currentPageSkus.length) {
            const visibleSkuIdsTemp = [
                ...visibleSkuIdsObj.currentPageSkus
            ];
            let visibleQuantity1 = visibleSkuIdsTemp.length;
            const { isLeftDisabled , isRightDisabled , firstIndex  } = visibleSkuIdsObj;
            const nextSkuIds = skuIds.slice(firstIndex + 1);
            nextSkuIds.forEach((skuId, index)=>{
                var ref, ref1;
                if (((ref = productCardContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) > ((ref1 = productCardRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) * (index + 2)) {
                    visibleQuantity1++;
                }
                if (visibleSkuIdsTemp.findIndex((tempSkuId)=>tempSkuId === skuId) !== index) {
                    visibleSkuIdsTemp.push(skuId);
                }
            });
            if (!isAddItem) {
                var ref;
                let index = 1;
                do {
                    visibleQuantity1 = localVisibleQuantity - index;
                }while (difference > ((ref = productCardRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) * index++);
            }
            localVisibleQuantity = visibleQuantity1 <= 0 ? 1 : visibleQuantity1;
            setVisibleSKuIds({
                currentPageSkus: visibleSkuIdsTemp,
                firstIndex,
                visibleQuantity: localVisibleQuantity,
                isLeftDisabled,
                isRightDisabled
            });
        }
    };
    const handleNextPrev = (param, navigationType)=>{
        let { target: { className =""  } = {}  } = param;
        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_6__/* .addAnalyticsEventForPrevNext */ .i2)(navigationType);
        let firstIndex = visibleSkuIdsObj.firstIndex;
        const visibleQuantity = visibleSkuIdsObj.visibleQuantity;
        if (className === "product-card-scroll" && !visibleSkuIdsObj.isLeftDisabled) {
            firstIndex = firstIndex - visibleQuantity;
            firstIndex = firstIndex < 0 ? 0 : firstIndex;
            setVisibleSKuIds((prevObje)=>({
                    firstIndex,
                    currentPageSkus: prevObje.currentPageSkus,
                    visibleQuantity,
                    isLeftDisabled: firstIndex === 0,
                    isRightDisabled: false
                }));
        } else if (className === "product-card-scroll__right" && !visibleSkuIdsObj.isRightDisabled) {
            firstIndex = firstIndex + visibleQuantity;
            let lastIndex = firstIndex + visibleQuantity;
            lastIndex = lastIndex > skuIds.length ? skuIds.length : lastIndex;
            setVisibleSKuIds((prevObje)=>({
                    firstIndex,
                    currentPageSkus: prevObje.currentPageSkus,
                    visibleQuantity,
                    isLeftDisabled: false,
                    isRightDisabled: lastIndex === skuIds.length
                }));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const noOfLoops = Math.abs(selectedIndex - visibleSkuIdsObj.firstIndex + visibleSkuIdsObj.visibleQuantity - 1) + 1;
        const val = selectedIndex - visibleSkuIdsObj.firstIndex;
        if (val < 0 || val > 3 && invokedFrom !== "button") {
            setInvokedFrom("");
        }
        if (selectedIndex > 0 && invokedFrom !== "button") {
            if (val > 3) {
                for(let i = 0; i < noOfLoops; i++){
                    handleNextPrev({
                        target: {
                            className: "product-card-scroll__right"
                        }
                    }, "right");
                }
                setHotspotClicked(!hotspotClicked);
            } else if (val < 0) {
                for(let i1 = 0; i1 < noOfLoops; i1++){
                    handleNextPrev({
                        target: {
                            className: "product-card-scroll"
                        }
                    }, "left");
                }
                setHotspotClicked(true);
            } else {
                setHotspotClicked(true);
            }
        }
    }, [
        selectedIndex,
        visibleSkuIdsObj.firstIndex,
        visibleSkuIdsObj.visibleQuantity,
        invokedFrom
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-modal-image-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Image_DynamicImage__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        width: "100%",
                        style: {
                            aspectRatio: "1.333/1"
                        },
                        imgUrl: imageLink,
                        alt: altModel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "image-title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: shopTheRoomLink,
                            role: "link",
                            onClick: ()=>(0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_6__/* .addAnalyticsEventForImageTitle */ .C2)(cardTitle),
                            children: cardTitle
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-modal-product-card-container",
                ref: productCardContainerRef,
                children: [
                    isModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "product-cards-title",
                        children: staticTexts.title
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-cards-container",
                        children: (visibleSkuIdsObj === null || visibleSkuIdsObj === void 0 ? void 0 : (ref = visibleSkuIdsObj.currentPageSkus) === null || ref === void 0 ? void 0 : ref.length) > 0 ? visibleSkuIdsObj.currentPageSkus.map((skuId, index)=>{
                            const isVisible = visibleSkuIdsObj.firstIndex <= index && index < visibleSkuIdsObj.firstIndex + visibleSkuIdsObj.visibleQuantity;
                            const extraProp = isVisible && visibleSkuIdsObj.firstIndex === index ? {
                                ref: productCardRef
                            } : {};
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-card".concat(isVisible ? "" : "__not-display"),
                                ...extraProp,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_productCard_v3_ProductCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    isFavoriteIcon: enableFavorite,
                                    selectedProduct: selectedProduct,
                                    authorData: {
                                        skewId: skuId,
                                        presetConfigs
                                    },
                                    isDefaultProductCard: false,
                                    hotspotClicked: hotspotClicked
                                })
                            }, "".concat(skuId, "-").concat(index));
                        }) : null
                    }),
                    skuIds.length > (visibleSkuIdsObj === null || visibleSkuIdsObj === void 0 ? void 0 : visibleSkuIdsObj.visibleQuantity) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "button-container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "scroll-wrapper",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "product-card-scroll".concat(visibleSkuIdsObj.isLeftDisabled ? "__button-disable" : ""),
                                    onClick: (e)=>{
                                        setInvokedFrom("button");
                                        handleNextPrev(e, "left");
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "product-card-scroll__right".concat(visibleSkuIdsObj.isRightDisabled ? "__button-disable" : ""),
                                    onClick: (e)=>{
                                        setInvokedFrom("button");
                                        handleNextPrev(e, "right");
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShopTheRoomCardModalView);


/***/ }),

/***/ 49019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./i18n/useSocialSharei18n.js

const useSocialSharei18n = (shareCartNum, brandName)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName: brandName,
                siteKey: siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    return i18n;
};
/* harmony default export */ var i18n_useSocialSharei18n = (useSocialSharei18n);

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/SocialShare/utils.js

// get component social share link url
const getLink = (data)=>{
    const { href , url ="" , assetUrl ="" , compUrl ="" , general  } = data;
    const isFullUrl = /^https?:\/\//i;
    if (url && isFullUrl.test(url)) {
        return url;
    }
    if (url) {
        return "".concat(origin).concat(url);
    } else if (assetUrl && compUrl) {
        // teaser video component link all cases
        if (!isFullUrl.test(compUrl)) {
            const newcompUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(compUrl, general);
            return "".concat(origin).concat(newcompUrl);
        } else {
            return compUrl;
        }
    } else if (assetUrl) {
        return assetUrl;
    } else {
        return (0,helper/* sanitizeUrl */.Nmg)(href !== null && href !== void 0 ? href : window.location.href);
    }
};

;// CONCATENATED MODULE: ./components/SocialShare/analytics/index.js
const addDataLayer = (data)=>{
    const { analyticData , siteKey , link  } = data;
    const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
    const eventInfo = {
        eventAction,
        eventName,
        eventType,
        eventMsg,
        eventStatus,
        internalLinkName: siteKey,
        internalLinkPosition,
        internalLinkType,
        internalLinkZoneName,
        internalLinkURL: link || internalLinkURL || "n/a",
        clickInternalLinks: siteKey === "copy link" || siteKey === "email" ? "true" : "false"
    };
    if (window.dataLayerEventType) {
        eventInfo.internalLinkType = window.dataLayerEventType;
    }
    if (window.dataLayerEventZoneName) {
        eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
        if (eventAction === "n/a") {
            eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
            eventInfo.eventName = window.dataLayerEventZoneName + ":share";
        }
    }
    const page = window.pageObj || {};
    let productInfo;
    if (custom) {
        try {
            productInfo = JSON.parse(custom).productInfo;
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/SocialShare/v1/SocialShare.jsx










const SocialShare = (props)=>{
    const { url ="" , showModal , componentProp: { assetUrl ="" , url: compUrl = "" , internallinkposition , internallinktype , internallinkzonename , eventaction , eventname , eventType  } = {} , componentProp , id , sharedCartNum , onClose , mailBody , mailSubject , asset , analyticData: analyticPropData , iframeId , shareBtn , shareRef  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [sites, setSites] = (0,react.useState)([]);
    const [origin, setOrigin] = (0,react.useState)(null);
    const [href, setHref] = (0,react.useState)(null);
    const emailBtnRef = (0,react.useRef)(null);
    const copyBtnRef = (0,react.useRef)(null);
    const shareBoxRef = (0,react.useRef)(null);
    const { globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general ={} , socialMediaConfig ={}  } = globalConfig;
    const { socialShareEmailIconPath ="" , socialShareCopyIconPath ="" , hostUrl ="" , siteName =""  } = general;
    (0,react.useEffect)(()=>{
        if (!isSsr) {
            setOrigin(window.location.origin);
            setHref(window.location.href);
        }
    }, [
        isSsr
    ]);
    const link = getLink({
        href,
        url,
        assetUrl,
        compUrl,
        general
    });
    const staticText = i18n_useSocialSharei18n(sharedCartNum, siteName);
    const [copyIcon, setCopyIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        let siteList = [];
        socialMediaConfig === null || socialMediaConfig === void 0 ? void 0 : (ref = socialMediaConfig.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((mediaConfig)=>{
            if (!isEmpty_default()(mediaConfig.map) && mediaConfig.map.name) {
                var _name, _iconPath;
                const site = {
                    key: (_name = mediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = mediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = mediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (mediaConfig.map.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (mediaConfig.map.name.toLowerCase().includes("pinterest")) {
                    if (asset) siteList.push({
                        ...site,
                        url: url + "".concat(origin, "&media=").concat(asset.url, "&description=").concat(asset.description)
                    });
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        });
        if (siteList.length) {
            siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
        }
        setSites(siteList);
    }, [
        socialMediaConfig
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer({
            analyticData,
            siteKey: "email",
            link: "n/a"
        });
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href, target);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer({
                analyticData,
                siteKey: key.split(".com")[0],
                link: target.href
            });
        } catch (err) {
            console.log(err);
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        showModal
    ]);
    const analyticData = analyticPropData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a",
        eventAction: eventaction || "n/a",
        eventName: eventname || "n/a",
        eventType: eventType || "n/a"
    };
    const handleClick = (e)=>{
        var ref;
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument.getElementById(id) : document.getElementById(id);
        if (showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target)) && !(shareBtn === null || shareBtn === void 0 ? void 0 : (ref = shareBtn.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            onClose();
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            onClose();
            shareBtn.current.focus();
        }
    };
    (0,react.useEffect)(()=>{
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument : document;
        if (showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer({
            analyticData,
            siteKey: "copy link",
            link: link !== null && link !== void 0 ? link : "n/a"
        });
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    return (showModal !== null && showModal !== void 0 ? showModal : componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "social-share",
        id: id,
        ref: shareRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "social-share__box",
            ref: shareBoxRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-share__sites",
                    children: sharedCartNum && sharedCartNum ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "social-share__shared-cart-number",
                        children: staticText.yourSharedCartNumber
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        children: sites.map((site, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    id: "kf-social-links-".concat(i),
                                    rel: "noreferrer",
                                    href: site.url,
                                    className: "kf-social-links",
                                    "aria-label": "".concat(staticText.linksCTA(site.key), " ").concat(staticText.openNewTabText),
                                    target: "_blank",
                                    "data-link-type": "social media",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        "aria-hidden": "true",
                                        src: "".concat(hostUrl).concat(site === null || site === void 0 ? void 0 : site.icon),
                                        alt: site.key,
                                        className: "social-share__".concat(site.key)
                                    })
                                })
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "social-share__actions",
                    role: "list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                tabIndex: "0",
                                role: "button",
                                ref: copyBtnRef,
                                className: "social-share__cta",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "social-share__copy-link-icon",
                                        "aria-hidden": true,
                                        src: "".concat(hostUrl).concat(socialShareCopyIconPath),
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    copyIcon ? staticText.copyLinkIndication : staticText.copyLink
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "social-share__cta social-share__email",
                                "aria-label": "".concat(staticText.email, " ").concat(staticText.openNewTabText),
                                onKeyDown: ()=>onClose(),
                                ref: emailBtnRef,
                                href: (0,helper/* sanitizeUrl */.Nmg)("mailto:?body=".concat((mailBody ? mailBody : "") + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(hostUrl).concat(socialShareEmailIconPath),
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    staticText.email
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var v1_SocialShare = (SocialShare);


/***/ }),

/***/ 94529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ addDataLayerVisualSearch; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const addDataLayerVisualSearch = (analytics)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page");
    if (page) {
        const { user , category , pageInfo  } = page;
        delete user["encodedEmailId"];
        delete user["profileType"];
        delete page["pageName"];
        delete page["pageUrl"];
        delete pageInfo["thumbnailImageUrl"];
        pageInfo["defaultImage"] = "n/a";
        pageInfo["imageId"] = "n/a";
        pageInfo["resourceType"] = "n/a";
        pageInfo["referrer"] = document.referrer;
        category["subCategory1"] = "".concat(category["pageType"], ":").concat(category["productLocalCategory"]);
    }
    const { eventKey , category: category1 , internalLinkZoneName =false , eventStatus , linkUrl , eventMsg , product  } = analytics;
    const links = linkUrl !== null && linkUrl !== void 0 ? linkUrl : window.location.href;
    const productRoom = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.room;
    const evtAction = internalLinkZoneName ? "".concat(eventKey, ":").concat(category1) : eventKey;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:find a service part:kohler genuine service parts:".concat(evtAction),
        eventMsg: eventMsg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(eventMsg) : "n/a",
        eventName: "support:find a service part:kohler genuine service parts:".concat(evtAction),
        eventStatus: eventStatus !== null && eventStatus !== void 0 ? eventStatus : "n/a",
        eventType: "navigation",
        internalLinkName: internalLinkZoneName ? category1 : eventKey,
        internalLinkPosition: "support:find a service part".concat(category1 ? ":".concat(category1) : ""),
        internalLinkType: "support:find a service part:kohler genuine service parts",
        internalLinkURL: links,
        internalLinkZoneName: "support:find a service part:kohler genuine service parts".concat(internalLinkZoneName || eventStatus ? ":".concat(eventKey) : "")
    };
    const productInfo = product ? getAnalyticProductInfo(product, category1, productRoom) : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        ...productInfo != null && {
            productInfo
        }
    });
};
const getAnalyticProductInfo = (products, category, productRoom)=>{
    const productInfo = {
        category: category,
        defaultImageName: products === null || products === void 0 ? void 0 : products.isoImageURL,
        description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(products === null || products === void 0 ? void 0 : products.shortDescription),
        frequency: "n/a",
        globalDiscount: "n/a",
        globalOffer: "n/a",
        globalPromotionPrice: "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category),
        numberOfReviews: "n/a",
        pdpType: "regular finished goods",
        priceState: "regular price",
        productBasePrice: "n/a",
        productBrand: "kohler",
        productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category),
        productCollectionsName: products === null || products === void 0 ? void 0 : products.name,
        productColor: "n/a",
        productCouponCode: "n/a",
        productCoupondiscount: "n/a",
        productFindingMethod: "n/a",
        productID: products === null || products === void 0 ? void 0 : products.sku,
        productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(products === null || products === void 0 ? void 0 : products.name),
        productPartnerBuyNow: "n/a",
        productRoom: productRoom,
        productSalePrice: "n/a",
        productSaleable: "n/a",
        productStatus: "n/a",
        productSuperSku: "n/a",
        productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(products === null || products === void 0 ? void 0 : products.shortDescription),
        quantity: "n/a",
        ratings: "n/a",
        waterSenseProduct: false
    };
    return productInfo;
};


/***/ }),

/***/ 89166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        recognitionCategory: (category)=>t("kf.visualsearch.label.recognitionCategory", {
                category
            }),
        recognitionCategorySubText: (category)=>t("kf.visualsearch.label.recognitionCategorySubText", {
                category
            }),
        faucetGuide: t("kf.visualsearch.label.faucetGuide"),
        toiletGuide: t("kf.visualsearch.label.toiletGuide"),
        volveGuide: t("kf.visualsearch.label.volveGuide"),
        sinkGuide: t("kf.visualsearch.label.sinkGuide"),
        defaultGuide: t("kf.visualsearch.label.defaultGuide"),
        commingSoon: t("kf.visualsearch.label.commingSoon"),
        viewGuidtext: t("kf.visualsearch.button.viewGuid"),
        backOnCategory: t("kf.visualsearch.button.backOnCategory"),
        errorText: t("kf.visualsearch.ErrorPage.errorText"),
        errorSubText: t("kf.visualsearch.ErrorPage.errorSubText"),
        tryAgainBtn: t("kf.visualsearch.ErrorPage.button.tryAgainBtn"),
        QRCodeText: t("kf.visualsearch.QRCode.text"),
        textCommingSoon: t("kf.visualsearch.label.textCommingSoon"),
        imageUploadtext: t("kf.visualsearch.ImageUpload.text"),
        borwseBtn: t("kf.visualsearch.ImageUpload.button.borwse"),
        changeProduct: t("kf.visualsearch.ImageUpload.text.changeProduct"),
        imageUploadSubText: t("kf.visualsearch.ImageUpload.subText"),
        photoGuidelineText: t("kf.visualsearch.ImageUpload.photoGuidelineText"),
        photoText: t("kf.visualsearch.ImageUpload.photoText"),
        wrongAngle: t("kf.visualsearch.ImageUpload.wrongAngle"),
        toClose: t("kf.visualsearch.ImageUpload.toClose"),
        toFar: t("kf.visualsearch.ImageUpload.toFar"),
        colorFinish: t("kf.pdp.label.colorOrFinish"),
        tooltip: t("kf.visualsearch.ImageCropper.toolTip"),
        toolTipCrop: t("kf.visualsearch.ImageCropper.toolTipCrop"),
        incorrectMatch: t("kf.visualsearch.label.textIncorrectMatch"),
        newSearch: t("kf.visualsearch.label.textNewSearch"),
        helpText: t("kf.visualsearch.label.textHelp"),
        feedbackText: t("kf.visualsearch.label.feedbackText"),
        closestMatch: t("kf.visualsearch.label.textClosestMatch"),
        partDiagramtext: t("kf.pdp.label.partsDiagram"),
        friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
        associatePrice: t("kf.pdp.label.associatePrice"),
        listPriceInfo: t("kf.pdp.label.listPriceInfo"),
        searchText: t("kf.visualsearch.page.search"),
        searchImageText: t("kf.visualsearch.page.searchImage"),
        serviewDetails: t("kf.technical.label.serviceParts"),
        toiletPhotoText: t("kf.visualsearch.ImageUpload.toilet.photoText"),
        sinkPhotoText: t("kf.visualsearch.ImageUpload.sink.photoText"),
        imageShould: t("kf.visualsearch.cameraGuide.imageShould"),
        servicePartInsrtuction1: t("kf.visualsearch.cameraGuide.servicePartInsrtuction1"),
        servicePartInsrtuction2: t("kf.visualsearch.cameraGuide.servicePartInsrtuction2"),
        servicePartInsrtuction3: t("kf.visualsearch.cameraGuide.servicePartInsrtuction3"),
        forFurtherHelp: t("kf.visualsearch.cameraGuide.forFurtherHelp"),
        contactSupport: t("kf.visualsearch.cameraGuide.contactSupportText")
    };
};


/***/ }),

/***/ 4680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_CameraView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/VisualSearch/v1/utils.js
var utils = __webpack_require__(10068);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/WebCam.js

/**
 * Webcam component
 */ class WebCam {
    /**
   * Initialization
   */ async setupCamera() {
        if (navigator.mediaDevices.getUserMedia !== undefined) {
            let width = window.innerWidth;
            width = width - width % 4;
            let height = window.innerHeight;
            height = height - height % 4;
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: {
                    facingMode: "environment",
                    aspectRatio: window.matchMedia("(orientation: landscape)").matches ? width / height : height / width
                }
            });
            if ("srcObject" in this.webcamElement) {
                this.webcamElement.srcObject = mediaStream;
                this.mediaStream = mediaStream;
            } else {
                this.webcamElement.src = window.URL.createObjectURL(mediaStream);
            }
            this.webcamElement.onloadedmetadata = (e)=>{
                this.webcamElement.play();
            };
            this.webcamElement.style.setProperty("width", "auto", "important");
            this.webcamElement.style.setProperty("height", "100%", "important");
            this.webcamElement.style.setProperty("max-width", "none", "important");
        }
    }
    /**
   * Stops Media stream
   */ stopMediaStream() {
        if (this.mediaStream) {
            if (this.mediaStream.getVideoTracks && this.mediaStream.getAudioTracks) {
                this.mediaStream.getVideoTracks().forEach((track)=>{
                    this.mediaStream.removeTrack(track);
                    track.stop();
                });
                this.mediaStream.getAudioTracks().forEach((track)=>{
                    this.mediaStream.removeTrack(track);
                    track.stop();
                });
            } else {
                this.mediaStream.stop();
            }
        }
    }
    /**
   * Renders Captured Image
   * @return {Object} Object with width and height of captured Image
   */ _drawImage() {
        const videoWidth = this.webcamElement.videoWidth;
        const videoHeight = this.webcamElement.videoHeight;
        let imageWidth = this.webcamElement.videoWidth;
        let imageHeight = this.webcamElement.videoHeight;
        const imageAspectRatio = imageWidth / imageHeight;
        let top = 0;
        let left = 0;
        if (this.portAspectRatio < imageAspectRatio) {
            left = imageWidth * (1 - this.portAspectRatio / imageAspectRatio) / 2;
            imageWidth = imageWidth * (this.portAspectRatio / imageAspectRatio);
        } else {
            top = imageHeight * (1 - imageAspectRatio / this.portAspectRatio) / 2;
            imageHeight = imageHeight * imageAspectRatio / this.portAspectRatio;
        }
        const context = this.canvasElement.getContext("2d");
        this.canvasElement.width = videoWidth;
        this.canvasElement.height = videoHeight;
        context.drawImage(this.webcamElement, 0, 0, videoWidth, videoHeight);
        const result = (0,utils/* cropCanvas */.fg)(this.canvasElement, left, top, imageWidth, imageHeight);
        this.canvasElement = result;
        return {
            imageHeight,
            imageWidth
        };
    }
    /**
   * Captures image from canvas
   * @param {Object} param0
   * @return {Object} Object with base64 value
   */ takeBase64Photo() {
        let { type , quality  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            type: "png",
            quality: 1
        };
        const { imageHeight , imageWidth  } = this._drawImage();
        const base64 = this.canvasElement.toDataURL("image/" + type, quality);
        return {
            base64,
            imageHeight,
            imageWidth
        };
    }
    /**
   * Constructor
   * @param {WebCam} webcamElement
   */ constructor(webcamElement){
        this.canvasElement = document.createElement("canvas");
        this.webcamElement = webcamElement;
        this.mediaStream = null;
        this.facingMode = [
            "environment",
            "user"
        ];
        this.flashLight = null;
        this.autoFocus = null;
        this.portWidth = window.innerWidth;
        this.portHeight = window.innerHeight;
        this.portAspectRatio = this.portWidth / this.portHeight;
    }
}

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/Camera.js




const Camera = (props)=>{
    const { captureTrigger =false , setCaptureTrigger , handlerResult  } = props;
    let wcstream = null;
    const [webcamStream, setWebcamStream] = (0,react.useState)({});
    const loadWebcam = async ()=>{
        if (wcstream != null) wcstream.stopMediaStream();
        const webCamElement = document.getElementById("webcam");
        if (null == webCamElement) return;
        const webCam = new WebCam(webCamElement);
        webCam.setupCamera().catch(()=>{});
        setWebcamStream(webCam);
        wcstream = webCam;
    };
    (0,react.useEffect)(()=>{
        loadWebcam();
        const debouncedWebcamEvent = (0,utils/* debounce */.Ds)(loadWebcam, 200);
        window.addEventListener("resize", debouncedWebcamEvent);
        window.addEventListener("orientationchange", debouncedWebcamEvent);
        const timer = setTimeout(()=>{
            const elements = document.getElementsByTagName("mavenoid-assistant");
            if (elements.length > 0) {
                document.querySelector("mavenoid-assistant").style.display = "none";
            }
        }, 100);
        return ()=>{
            wcstream.stopMediaStream();
            window.removeEventListener("resize", debouncedWebcamEvent);
            window.removeEventListener("orientationchange", debouncedWebcamEvent);
            document.querySelector("mavenoid-assistant").style.display = "block";
            clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (captureTrigger) {
            takePhoto();
            setCaptureTrigger(false);
        }
    }, [
        captureTrigger
    ]);
    const takePhoto = async ()=>{
        const capturedData = webcamStream.takeBase64Photo({
            type: "jpeg",
            quality: 1
        });
        webcamStream.stopMediaStream();
        const imageFile = await (0,utils/* dataUrlToFile */.Bo)(capturedData.base64, "input.jpg");
        handlerResult({
            width: capturedData.imageWidth,
            height: capturedData.imageHeight,
            file: imageFile,
            dataURL: capturedData.base64
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        id: "webcam",
        className: "video-container",
        autoPlay: true,
        playsInline: true,
        muted: true
    });
};
/* harmony default export */ var CameraView_Camera = (Camera);

// EXTERNAL MODULE: ./components/VisualSearch/v1/UploadImage/index.jsx + 4 modules
var UploadImage = __webpack_require__(26355);
// EXTERNAL MODULE: ./components/VisualSearch/v1/CameraView/cameraview.module.scss
var cameraview_module = __webpack_require__(18682);
var cameraview_module_default = /*#__PURE__*/__webpack_require__.n(cameraview_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/GuildePageMobile.jsx




const GuildePageMobile = (props)=>{
    const { setShowInfo , category ="" , setSection =()=>{} , setOutput =()=>{} , isUsingGlobalVS =false  } = props || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((cameraview_module_default()).CameraView, " ").concat(isUsingGlobalVS && (cameraview_module_default()).CameraViewModalGVS),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cameraview-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                setShowInfo: setShowInfo,
                category: category,
                setSection: setSection,
                setOutput: setOutput,
                isUsingGlobalVS: isUsingGlobalVS
            })
        })
    });
};
/* harmony default export */ var CameraView_GuildePageMobile = (GuildePageMobile);

// EXTERNAL MODULE: ./components/VisualSearch/localization.js
var localization = __webpack_require__(89166);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/icons.js

const Close = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79181 8.49989L0.367188 15.9245L1.07429 16.6316L8.49892 9.207L15.9235 16.6316L16.6306 15.9245L9.20602 8.49989L16.6306 1.07527L15.9235 0.368164L8.49892 7.79278L1.07429 0.368164L0.367188 1.07527L7.79181 8.49989Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79181 8.49989L0.367188 15.9245L1.07429 16.6316L8.49892 9.207L15.9235 16.6316L16.6306 15.9245L9.20602 8.49989L16.6306 1.07527L15.9235 0.368164L8.49892 7.79278L1.07429 0.368164L0.367188 1.07527L7.79181 8.49989Z",
                fill: "white"
            })
        ]
    });
const GuideValveImage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "322",
        height: "322",
        viewBox: "0 0 322 322",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.2",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M161 320.296C249.447 320.296 321.148 248.596 321.148 160.148C321.148 71.7008 249.447 0 161 0C72.5523 0 0.851562 71.7008 0.851562 160.148C0.851562 248.596 72.5523 320.296 161 320.296ZM161.424 189.962C165.423 189.962 168.665 186.72 168.665 182.721C168.665 178.722 165.423 175.48 161.424 175.48C157.425 175.48 154.184 178.722 154.184 182.721C154.184 186.72 157.425 189.962 161.424 189.962Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.421",
                cy: "182.721",
                r: "7.34259",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.423",
                cy: "182.728",
                r: "14.1574",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.429",
                cy: "178.464",
                r: "31.1944",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.429",
                cy: "171.648",
                r: "54.1944",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161",
                cy: "161",
                r: "90.3981",
                stroke: "white",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161",
                cy: "161",
                r: "160.25",
                stroke: "white",
                strokeWidth: "1.5"
            })
        ]
    });
const GuideSinkImage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "547",
        height: "189",
        viewBox: "0 0 547 189",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.2",
                d: "M475.994 1.12402C476.207 1.12778 476.519 1.13546 476.917 1.15039C477.712 1.1803 478.853 1.24002 480.233 1.35938C482.991 1.59802 486.717 2.07564 490.574 3.03223C494.428 3.98807 498.437 5.42733 501.748 7.60156C505.062 9.77834 507.701 12.7086 508.755 16.6426C510.792 24.2445 518.433 55.9615 526.298 88.5176C534.166 121.083 542.261 154.492 545.209 165.497C546.714 171.111 545.83 175.382 543.6 178.604C541.384 181.805 537.877 183.913 534.238 185.306C530.594 186.7 526.773 187.395 523.871 187.741C522.418 187.915 521.191 188.001 520.327 188.045C519.895 188.067 519.552 188.078 519.318 188.083C519.201 188.086 519.11 188.087 519.048 188.088C519.018 188.088 518.994 188.089 518.978 188.089H30.5864C30.5693 188.089 30.5439 188.088 30.5112 188.088C30.4451 188.087 30.3472 188.086 30.2212 188.083C29.9687 188.077 29.5998 188.066 29.1343 188.044C28.2029 187.999 26.8798 187.909 25.313 187.729C22.1825 187.371 18.0591 186.653 14.1196 185.213C10.1859 183.774 6.38801 181.598 3.96533 178.293C1.52663 174.966 0.521788 170.549 2.07861 164.738C5.12891 153.354 12.9825 120.516 20.6099 88.5195C28.2348 56.5334 35.6341 25.3847 37.7729 17.4023C38.8779 13.2789 41.6366 10.2066 45.103 7.92285C48.5657 5.64167 52.7584 4.13031 56.7896 3.12695C60.8241 2.12281 64.7209 1.6216 67.606 1.37109C69.049 1.24581 70.2415 1.18275 71.0737 1.15137C71.4897 1.13568 71.8168 1.12797 72.0396 1.12402C72.1506 1.12206 72.2365 1.12061 72.2944 1.12012H475.75C475.805 1.1206 475.887 1.12215 475.994 1.12402Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M273.625 1.12012H274.375V0.370117H273.625V1.12012ZM273.625 2.02051V2.77051H274.375V2.02051H273.625ZM71.584 2.02051V1.2705L71.5808 1.27051L71.584 2.02051ZM71.5244 2.02148L71.5308 2.77146L71.531 2.77146L71.5244 2.02148ZM71.2891 2.02441L71.2759 1.27453L71.2758 1.27453L71.2891 2.02441ZM70.3838 2.0498L70.3556 1.30033L70.3556 1.30033L70.3838 2.0498ZM67.1113 2.25586L67.0467 1.50865L67.0467 1.50865L67.1113 2.25586ZM56.9092 3.90625L56.7286 3.1783L56.7286 3.1783L56.9092 3.90625ZM46.0127 8.35449L45.601 7.72759L45.601 7.7276L46.0127 8.35449ZM39.3809 16.876L38.6564 16.6819L38.6564 16.6819L39.3809 16.876ZM21.8438 88.7295L22.5728 88.9056L21.8438 88.7295ZM2.92676 165.73L3.6512 165.925L2.92676 165.73ZM4.40723 178.091L3.79058 178.518L3.7906 178.518L4.40723 178.091ZM13.3506 184.465L13.0825 185.165H13.0825L13.3506 184.465ZM23.502 186.847L23.413 187.591H23.413L23.502 186.847ZM26.9844 187.146L26.9467 187.895H26.9467L26.9844 187.146ZM27.9688 187.183L27.9513 187.932H27.9513L27.9688 187.183ZM28.2275 187.188L28.2191 187.937H28.2193L28.2275 187.188ZM28.293 187.188L28.3017 186.438L28.2971 186.438L28.293 187.188ZM28.3086 187.188L28.3065 187.938H28.3086V187.188ZM273.625 187.188H274.375V186.438H273.625V187.188ZM273.625 188.089V188.839H274.375V188.089H273.625ZM28.3135 188.089H27.5635V188.839H28.3135V188.089ZM28.3125 188.089V188.839H28.8998L29.0406 188.269L28.3125 188.089ZM28.2881 188.089L28.2839 188.839H28.2881V188.089ZM28.2178 188.088L28.2263 187.338H28.2262L28.2178 188.088ZM27.9482 188.083L27.9308 188.833H27.9308L27.9482 188.083ZM26.9395 188.045L26.9018 188.794H26.9018L26.9395 188.045ZM23.3955 187.741L23.3066 188.486H23.3066L23.3955 187.741ZM13.0283 185.306L12.7602 186.006L12.7602 186.006L13.0283 185.306ZM3.66699 178.604L3.05034 179.03L3.05037 179.03L3.66699 178.604ZM2.05664 165.497L2.78109 165.691H2.78109L2.05664 165.497ZM20.9678 88.5176L21.6968 88.6937L20.9678 88.5176ZM38.5107 16.6426L37.7863 16.4484L37.7863 16.4485L38.5107 16.6426ZM45.5186 7.60156L45.1069 6.97466L45.1068 6.97467L45.5186 7.60156ZM56.6924 3.03223L56.5118 2.30428L56.5118 2.30428L56.6924 3.03223ZM67.0342 1.35938L66.9696 0.612165L66.9695 0.612165L67.0342 1.35938ZM70.3496 1.15039L70.3215 0.400919L70.3214 0.400919L70.3496 1.15039ZM71.2725 1.12402L71.2592 0.37414L71.2592 0.37414L71.2725 1.12402ZM71.5166 1.12012V0.37009L71.5102 0.370145L71.5166 1.12012ZM475.997 1.12402L476.01 0.37414V0.37414L475.997 1.12402ZM476.92 1.15039L476.948 0.400919V0.400919L476.92 1.15039ZM480.235 1.35938L480.3 0.612165V0.612165L480.235 1.35938ZM490.577 3.03223L490.758 2.30428V2.30428L490.577 3.03223ZM501.751 7.60156L502.163 6.97467V6.97467L501.751 7.60156ZM508.759 16.6426L509.483 16.4485L509.483 16.4484L508.759 16.6426ZM526.302 88.5176L525.573 88.6937L526.302 88.5176ZM545.213 165.497L544.488 165.691L545.213 165.497ZM543.603 178.604L544.219 179.03V179.03L543.603 178.604ZM534.241 185.306L534.509 186.006V186.006L534.241 185.306ZM523.874 187.741L523.963 188.486L523.874 187.741ZM520.33 188.045L520.368 188.794L520.33 188.045ZM519.321 188.083L519.339 188.833L519.321 188.083ZM519.052 188.088L519.06 188.838L519.052 188.088ZM518.981 188.089V188.839L518.986 188.839L518.981 188.089ZM518.957 188.089V187.339H518.957L518.957 188.089ZM518.956 188.089V188.839H519.706V188.089H518.956ZM273.645 188.089H272.895V188.839H273.645V188.089ZM273.645 187.188V186.438H272.895V187.188H273.645ZM518.961 187.188V187.938H518.963L518.961 187.188ZM518.977 187.188L518.981 187.937L518.977 187.188ZM519.042 187.188L519.05 187.937L519.042 187.188ZM519.301 187.183L519.318 187.932L519.301 187.183ZM520.285 187.146L520.323 187.895L520.285 187.146ZM523.768 186.847L523.857 187.591L523.768 186.847ZM533.919 184.465L534.187 185.165L533.919 184.465ZM542.862 178.091L543.479 178.518V178.518L542.862 178.091ZM544.343 165.73L545.067 165.536L544.343 165.73ZM525.426 88.7295L524.697 88.9056L525.426 88.7295ZM507.889 16.876L508.613 16.6819V16.6819L507.889 16.876ZM501.257 8.35449L501.669 7.7276V7.7276L501.257 8.35449ZM490.36 3.90625L490.541 3.1783V3.1783L490.36 3.90625ZM480.158 2.25586L480.223 1.50865L480.158 2.25586ZM476.886 2.0498L476.914 1.30033V1.30033L476.886 2.0498ZM475.98 2.02441L475.994 1.27453V1.27453L475.98 2.02441ZM475.745 2.02148L475.752 1.27151V1.27151L475.745 2.02148ZM475.686 2.02051L475.689 1.27051H475.686V2.02051ZM273.645 2.02051H272.895V2.77051H273.645V2.02051ZM273.645 1.12012V0.370117H272.895V1.12012H273.645ZM475.753 1.12012L475.759 0.370117H475.753V1.12012ZM273.625 1.12012H272.875V2.02051H273.625H274.375V1.12012H273.625ZM273.625 2.02051V1.27051H71.584V2.02051V2.77051H273.625V2.02051ZM71.584 2.02051L71.5808 1.27051C71.5723 1.27055 71.5645 1.27068 71.5591 1.27078C71.5537 1.27088 71.5477 1.27101 71.5435 1.27109C71.5341 1.27129 71.5262 1.27144 71.5178 1.27151L71.5244 2.02148L71.531 2.77146C71.5489 2.7713 71.5642 2.77099 71.5748 2.77077C71.5806 2.77065 71.5837 2.77058 71.5866 2.77052C71.5895 2.77047 71.5891 2.77049 71.5871 2.7705L71.584 2.02051ZM71.5244 2.02148L71.518 1.27151C71.465 1.27197 71.3828 1.27265 71.2759 1.27453L71.2891 2.02441L71.3023 2.7743C71.4019 2.77254 71.4784 2.77191 71.5308 2.77146L71.5244 2.02148ZM71.2891 2.02441L71.2758 1.27453C71.0643 1.27826 70.7526 1.28542 70.3556 1.30033L70.3838 2.0498L70.4119 2.79928C70.7974 2.7848 71.099 2.77788 71.3023 2.7743L71.2891 2.02441ZM70.3838 2.0498L70.3556 1.30033C69.5621 1.33015 68.4239 1.38953 67.0467 1.50865L67.1113 2.25586L67.176 3.00307C68.5254 2.88635 69.639 2.82832 70.4119 2.79928L70.3838 2.0498ZM67.1113 2.25586L67.0467 1.50865C64.2931 1.74684 60.576 2.22416 56.7286 3.1783L56.9092 3.90625L57.0897 4.6342C60.8378 3.70466 64.4726 3.23692 67.176 3.00307L67.1113 2.25586ZM56.9092 3.90625L56.7286 3.1783C52.8835 4.13194 48.8923 5.56611 45.601 7.72759L46.0127 8.35449L46.4244 8.98139C49.5205 6.94809 53.3324 5.56605 57.0897 4.6342L56.9092 3.90625ZM46.0127 8.35449L45.601 7.7276C42.3072 9.89081 39.6984 12.7935 38.6564 16.6819L39.3809 16.876L40.1053 17.0701C41.025 13.638 43.3381 11.0083 46.4244 8.98138L46.0127 8.35449ZM39.3809 16.876L38.6564 16.6819C36.6202 24.2812 28.9809 55.9953 21.1147 88.5534L21.8438 88.7295L22.5728 88.9056C30.4435 56.3288 38.0754 24.6457 40.1053 17.0701L39.3809 16.876ZM21.8438 88.7295L21.1147 88.5534C13.247 121.118 5.1518 154.529 2.20231 165.536L2.92676 165.73L3.6512 165.925C6.60692 154.894 14.7083 121.457 22.5728 88.9056L21.8438 88.7295ZM2.92676 165.73L2.20231 165.536C0.707589 171.115 1.58925 175.338 3.79058 178.518L4.40723 178.091L5.02387 177.664C3.10878 174.898 2.25335 171.141 3.6512 165.925L2.92676 165.73ZM4.40723 178.091L3.7906 178.518C5.98298 181.684 9.45779 183.778 13.0825 185.165L13.3506 184.465L13.6187 183.764C10.1359 182.431 6.97503 180.482 5.02385 177.664L4.40723 178.091ZM13.3506 184.465L13.0825 185.165C16.7103 186.554 20.518 187.246 23.413 187.591L23.502 186.847L23.5909 186.102C20.7631 185.764 17.0886 185.092 13.6187 183.764L13.3506 184.465ZM23.502 186.847L23.413 187.591C24.8614 187.764 26.0851 187.851 26.9467 187.895L26.9844 187.146L27.022 186.396C26.189 186.355 25 186.27 23.5909 186.102L23.502 186.847ZM26.9844 187.146L26.9467 187.895C27.3772 187.916 27.7181 187.927 27.9513 187.932L27.9688 187.183L27.9862 186.433C27.7652 186.428 27.4378 186.417 27.022 186.396L26.9844 187.146ZM27.9688 187.183L27.9513 187.932C28.0659 187.935 28.1568 187.937 28.2191 187.937L28.2275 187.188L28.236 186.438C28.1822 186.437 28.098 186.435 27.9862 186.433L27.9688 187.183ZM28.2275 187.188L28.2193 187.937C28.2392 187.938 28.2563 187.938 28.269 187.938C28.2722 187.938 28.2751 187.938 28.2776 187.938C28.2803 187.938 28.2823 187.938 28.2842 187.938C28.2883 187.937 28.2892 187.937 28.2888 187.937L28.293 187.188L28.2971 186.438C28.2896 186.437 28.2823 186.438 28.2773 186.438C28.2746 186.438 28.2719 186.438 28.2695 186.438C28.267 186.438 28.2646 186.438 28.2623 186.438C28.2531 186.438 28.2446 186.438 28.2358 186.438L28.2275 187.188ZM28.293 187.188L28.2843 187.937C28.2706 187.937 28.2592 187.937 28.2511 187.936C28.2432 187.936 28.2373 187.935 28.2363 187.935C28.2361 187.935 28.2359 187.935 28.2362 187.935C28.2363 187.935 28.237 187.935 28.2378 187.935C28.2391 187.935 28.2428 187.936 28.2473 187.936C28.2518 187.936 28.2592 187.937 28.2682 187.937C28.2771 187.938 28.2904 187.938 28.3065 187.938L28.3086 187.188L28.3107 186.438C28.326 186.439 28.3384 186.439 28.3463 186.439C28.3543 186.44 28.3607 186.44 28.3641 186.441C28.3674 186.441 28.3699 186.441 28.3701 186.441C28.3702 186.441 28.3703 186.441 28.3698 186.441C28.3694 186.441 28.3686 186.441 28.3677 186.441C28.3641 186.441 28.3553 186.44 28.3444 186.439C28.3333 186.438 28.3187 186.438 28.3017 186.438L28.293 187.188ZM28.3086 187.188V187.938H273.625V187.188V186.438H28.3086V187.188ZM273.625 187.188H272.875V188.089H273.625H274.375V187.188H273.625ZM273.625 188.089V187.339H28.3135V188.089V188.839H273.625V188.089ZM28.3135 188.089H29.0635V187.639H28.3135H27.5635V188.089H28.3135ZM28.3135 187.639H27.5635C27.5635 187.85 27.5633 187.961 27.5631 188.019C27.563 188.049 27.5629 188.063 27.5629 188.068C27.5628 188.072 27.5628 188.069 27.563 188.063C27.5631 188.06 27.5634 188.05 27.5643 188.038C27.5647 188.031 27.5657 188.018 27.5675 188.002C27.5689 187.991 27.5732 187.954 27.5844 187.909L28.3125 188.089L29.0406 188.269C29.0518 188.223 29.0562 188.187 29.0576 188.175C29.0594 188.159 29.0604 188.146 29.0609 188.139C29.0618 188.125 29.0622 188.114 29.0623 188.11C29.0626 188.101 29.0627 188.092 29.0628 188.086C29.0629 188.073 29.063 188.054 29.0631 188.024C29.0633 187.963 29.0635 187.85 29.0635 187.639H28.3135ZM28.3125 188.089V187.339H28.2881V188.089V188.839H28.3125V188.089ZM28.2881 188.089L28.2922 187.339C28.2752 187.339 28.2733 187.338 28.2263 187.338L28.2178 188.088L28.2093 188.838C28.2225 188.838 28.2343 188.838 28.2463 188.838C28.2568 188.839 28.2711 188.839 28.2839 188.839L28.2881 188.089ZM28.2178 188.088L28.2262 187.338C28.1681 187.337 28.0801 187.336 27.9657 187.333L27.9482 188.083L27.9308 188.833C28.0505 188.836 28.1445 188.837 28.2094 188.838L28.2178 188.088ZM27.9482 188.083L27.9657 187.333C27.7374 187.328 27.4019 187.317 26.9771 187.296L26.9395 188.045L26.9018 188.794C27.341 188.816 27.69 188.827 27.9308 188.833L27.9482 188.083ZM26.9395 188.045L26.9771 187.296C26.1269 187.253 24.9172 187.168 23.4844 186.997L23.3955 187.741L23.3066 188.486C24.7789 188.662 26.0233 188.75 26.9018 188.794L26.9395 188.045ZM23.3955 187.741L23.4844 186.997C20.6162 186.654 16.8613 185.97 13.2964 184.605L13.0283 185.306L12.7602 186.006C16.4828 187.431 20.3709 188.135 23.3066 188.486L23.3955 187.741ZM13.0283 185.306L13.2964 184.605C9.72861 183.24 6.37954 181.204 4.28361 178.177L3.66699 178.604L3.05037 179.03C5.38752 182.406 9.0506 184.586 12.7602 186.006L13.0283 185.306ZM3.66699 178.604L4.28364 178.177C2.1967 175.162 1.32508 171.125 2.78109 165.691L2.05664 165.497L1.3322 165.303C-0.220628 171.098 0.677068 175.602 3.05034 179.03L3.66699 178.604ZM2.05664 165.497L2.78109 165.691C5.73311 154.674 13.8304 121.253 21.6968 88.6937L20.9678 88.5176L20.2387 88.3414C12.3691 120.914 4.278 154.309 1.3322 165.303L2.05664 165.497ZM20.9678 88.5176L21.6968 88.6937C29.5648 56.1282 37.2015 24.4265 39.2352 16.8367L38.5107 16.6426L37.7863 16.4485C35.7462 24.062 28.1022 55.7946 20.2387 88.3414L20.9678 88.5176ZM38.5107 16.6426L39.2352 16.8367C40.2283 13.1309 42.7194 10.3372 45.9303 8.22845L45.5186 7.60156L45.1068 6.97467C41.6888 9.21949 38.9017 12.2861 37.7863 16.4484L38.5107 16.6426ZM45.5186 7.60156L45.9302 8.22847C49.1435 6.11831 53.0629 4.7051 56.8729 3.76017L56.6924 3.03223L56.5118 2.30428C52.614 3.27099 48.5153 4.73632 45.1069 6.97466L45.5186 7.60156ZM56.6924 3.03223L56.8729 3.76017C60.6806 2.81586 64.3653 2.34304 67.0988 2.10658L67.0342 1.35938L66.9695 0.612165C64.186 0.852949 60.4189 1.33532 56.5118 2.30428L56.6924 3.03223ZM67.0342 1.35938L67.0988 2.10659C68.4647 1.98845 69.5925 1.92937 70.3778 1.89986L70.3496 1.15039L70.3214 0.400919C69.5153 0.431208 68.3629 0.49165 66.9696 0.612165L67.0342 1.35938ZM70.3496 1.15039L70.3778 1.89986C70.7703 1.88512 71.0776 1.87758 71.2857 1.87391L71.2725 1.12402L71.2592 0.37414C71.0412 0.377986 70.724 0.3858 70.3215 0.400919L70.3496 1.15039ZM71.2725 1.12402L71.2857 1.87391C71.3947 1.87198 71.472 1.87053 71.523 1.87009L71.5166 1.12012L71.5102 0.370145C71.4503 0.370658 71.3626 0.372318 71.2592 0.37414L71.2725 1.12402ZM71.5166 1.12012V1.87012H273.625V1.12012V0.370117H71.5166V1.12012ZM475.997 1.12402L475.984 1.87391C476.192 1.87758 476.499 1.88511 476.892 1.89986L476.92 1.15039L476.948 0.400919C476.545 0.385788 476.228 0.377987 476.01 0.37414L475.997 1.12402ZM476.92 1.15039L476.892 1.89986C477.677 1.92937 478.805 1.98842 480.171 2.10658L480.235 1.35938L480.3 0.612165C478.906 0.491622 477.754 0.431211 476.948 0.400919L476.92 1.15039ZM480.235 1.35938L480.171 2.10658C482.904 2.34305 486.589 2.81578 490.397 3.76017L490.577 3.03223L490.758 2.30428C486.85 1.33524 483.084 0.852958 480.3 0.612165L480.235 1.35938ZM490.577 3.03223L490.397 3.76017C494.207 4.70514 498.126 6.11819 501.339 8.22846L501.751 7.60156L502.163 6.97467C498.754 4.73619 494.656 3.27102 490.758 2.30428L490.577 3.03223ZM501.751 7.60156L501.339 8.22845C504.55 10.3372 507.041 13.1308 508.034 16.8367L508.759 16.6426L509.483 16.4484C508.368 12.286 505.581 9.21951 502.163 6.97467L501.751 7.60156ZM508.759 16.6426L508.034 16.8367C510.068 24.4265 517.705 56.1281 525.573 88.6937L526.302 88.5176L527.031 88.3414C519.167 55.7946 511.523 24.0621 509.483 16.4485L508.759 16.6426ZM526.302 88.5176L525.573 88.6937C533.439 121.253 541.536 154.674 544.488 165.691L545.213 165.497L545.937 165.303C542.992 154.309 534.901 120.914 527.031 88.3414L526.302 88.5176ZM545.213 165.497L544.488 165.691C545.944 171.125 545.073 175.162 542.986 178.177L543.603 178.604L544.219 179.03C546.592 175.602 547.49 171.098 545.937 165.303L545.213 165.497ZM543.603 178.604L542.986 178.177C540.89 181.204 537.541 183.24 533.973 184.605L534.241 185.306L534.509 186.006C538.219 184.586 541.882 182.406 544.219 179.03L543.603 178.604ZM534.241 185.306L533.973 184.605C530.408 185.97 526.653 186.654 523.785 186.997L523.874 187.741L523.963 188.486C526.899 188.135 530.787 187.431 534.509 186.006L534.241 185.306ZM523.874 187.741L523.785 186.997C522.352 187.168 521.143 187.253 520.292 187.296L520.33 188.045L520.368 188.794C521.246 188.75 522.49 188.662 523.963 188.486L523.874 187.741ZM520.33 188.045L520.292 187.296C519.867 187.317 519.532 187.328 519.304 187.333L519.321 188.083L519.339 188.833C519.58 188.827 519.928 188.816 520.368 188.794L520.33 188.045ZM519.321 188.083L519.304 187.333C519.189 187.336 519.102 187.337 519.043 187.338L519.052 188.088L519.06 188.838C519.125 188.837 519.219 188.836 519.339 188.833L519.321 188.083ZM519.052 188.088L519.043 187.338C518.995 187.338 518.995 187.339 518.977 187.339L518.981 188.089L518.986 188.839C518.998 188.839 519.013 188.839 519.023 188.838C519.035 188.838 519.047 188.838 519.06 188.838L519.052 188.088ZM518.981 188.089V187.339H518.957V188.089V188.839H518.981V188.089ZM518.957 188.089L518.957 187.339C518.957 187.339 518.965 187.339 518.974 187.339C518.984 187.339 519 187.34 519.018 187.341C519.055 187.344 519.109 187.352 519.172 187.37C519.314 187.413 519.432 187.493 519.519 187.592C519.595 187.679 519.634 187.763 519.653 187.808C519.672 187.857 519.682 187.897 519.688 187.92C519.698 187.964 519.702 187.999 519.703 188.01C519.704 188.025 519.705 188.037 519.706 188.043C519.706 188.055 519.706 188.063 519.706 188.065C519.707 188.067 519.707 188.068 519.707 188.069C519.707 188.07 519.707 188.07 519.707 188.07C519.707 188.07 519.707 188.069 519.707 188.068C519.707 188.066 519.707 188.063 519.707 188.06C519.706 188.053 519.706 188.044 519.706 188.03C519.706 187.975 519.706 187.864 519.706 187.639H518.956H518.206C518.206 187.864 518.206 187.977 518.206 188.035C518.206 188.063 518.207 188.081 518.207 188.093C518.207 188.095 518.207 188.113 518.208 188.133C518.209 188.14 518.209 188.152 518.211 188.167C518.212 188.178 518.216 188.213 518.226 188.258C518.229 188.27 518.261 188.434 518.395 188.585C518.482 188.684 518.6 188.765 518.742 188.807C518.805 188.826 518.859 188.833 518.896 188.836C518.915 188.838 518.93 188.838 518.94 188.839C518.949 188.839 518.957 188.839 518.958 188.839L518.957 188.089ZM518.956 187.639H518.206V188.089H518.956H519.706V187.639H518.956ZM518.956 188.089V187.339H273.645V188.089V188.839H518.956V188.089ZM273.645 188.089H274.395V187.188H273.645H272.895V188.089H273.645ZM273.645 187.188V187.938H518.961V187.188V186.438H273.645V187.188ZM518.961 187.188L518.963 187.938C518.98 187.938 518.993 187.938 519.003 187.937C519.013 187.937 519.02 187.936 519.025 187.936C519.03 187.935 519.034 187.935 519.035 187.935C519.035 187.935 519.036 187.935 519.036 187.935C519.036 187.935 519.036 187.935 519.036 187.935C519.036 187.935 519.036 187.935 519.036 187.935C519.031 187.935 519.009 187.937 518.981 187.937L518.977 187.188L518.972 186.438C518.937 186.438 518.909 186.44 518.899 186.441C518.898 186.441 518.897 186.441 518.897 186.441C518.897 186.441 518.896 186.441 518.896 186.441C518.896 186.441 518.896 186.441 518.896 186.441C518.896 186.441 518.899 186.441 518.903 186.441C518.906 186.441 518.913 186.44 518.922 186.44C518.93 186.439 518.943 186.439 518.959 186.438L518.961 187.188ZM518.977 187.188L518.981 187.937C518.98 187.937 518.981 187.937 518.985 187.938C518.987 187.938 518.989 187.938 518.992 187.938C518.994 187.938 518.997 187.938 519 187.938C519.013 187.938 519.03 187.938 519.05 187.937L519.042 187.188L519.034 186.438C519.025 186.438 519.016 186.438 519.007 186.438C519.005 186.438 519.003 186.438 519 186.438C518.998 186.438 518.995 186.438 518.992 186.438C518.987 186.438 518.98 186.437 518.972 186.438L518.977 187.188ZM519.042 187.188L519.05 187.937C519.113 187.937 519.203 187.935 519.318 187.932L519.301 187.183L519.283 186.433C519.171 186.435 519.087 186.437 519.034 186.438L519.042 187.188ZM519.301 187.183L519.318 187.932C519.552 187.927 519.892 187.916 520.323 187.895L520.285 187.146L520.247 186.396C519.831 186.417 519.504 186.428 519.283 186.433L519.301 187.183ZM520.285 187.146L520.323 187.895C521.185 187.851 522.408 187.764 523.857 187.591L523.768 186.847L523.679 186.102C522.269 186.27 521.081 186.355 520.247 186.396L520.285 187.146ZM523.768 186.847L523.857 187.591C526.752 187.246 530.559 186.554 534.187 185.165L533.919 184.465L533.651 183.764C530.181 185.092 526.507 185.764 523.679 186.102L523.768 186.847ZM533.919 184.465L534.187 185.165C537.812 183.778 541.287 181.684 543.479 178.518L542.862 178.091L542.246 177.664C540.294 180.482 537.134 182.431 533.651 183.764L533.919 184.465ZM542.862 178.091L543.479 178.518C545.68 175.338 546.562 171.115 545.067 165.536L544.343 165.73L543.618 165.925C545.016 171.141 544.161 174.898 542.246 177.664L542.862 178.091ZM544.343 165.73L545.067 165.536C542.118 154.529 534.023 121.118 526.155 88.5534L525.426 88.7295L524.697 88.9056C532.561 121.457 540.663 154.894 543.618 165.925L544.343 165.73ZM525.426 88.7295L526.155 88.5534C518.289 55.9952 510.649 24.2812 508.613 16.6819L507.889 16.876L507.164 17.0701C509.194 24.6457 516.826 56.3287 524.697 88.9056L525.426 88.7295ZM507.889 16.876L508.613 16.6819C507.571 12.7935 504.962 9.89083 501.669 7.7276L501.257 8.35449L500.845 8.98138C503.931 11.0083 506.245 13.638 507.164 17.0701L507.889 16.876ZM501.257 8.35449L501.669 7.7276C498.377 5.56598 494.386 4.13197 490.541 3.1783L490.36 3.90625L490.18 4.6342C493.937 5.56609 497.749 6.94797 500.845 8.98138L501.257 8.35449ZM490.36 3.90625L490.541 3.1783C486.693 2.22408 482.977 1.74685 480.223 1.50865L480.158 2.25586L480.094 3.00307C482.797 3.23693 486.432 3.70458 490.18 4.6342L490.36 3.90625ZM480.158 2.25586L480.223 1.50865C478.845 1.3895 477.708 1.33015 476.914 1.30033L476.886 2.0498L476.858 2.79928C477.631 2.82832 478.744 2.88632 480.094 3.00307L480.158 2.25586ZM476.886 2.0498L476.914 1.30033C476.517 1.28541 476.205 1.27826 475.994 1.27453L475.98 2.02441L475.967 2.7743C476.171 2.77788 476.472 2.78479 476.858 2.79928L476.886 2.0498ZM475.98 2.02441L475.994 1.27453C475.887 1.27264 475.805 1.27197 475.752 1.27151L475.745 2.02148L475.739 2.77146C475.791 2.77191 475.867 2.77254 475.967 2.7743L475.98 2.02441ZM475.745 2.02148L475.752 1.27151C475.743 1.27144 475.735 1.27129 475.726 1.2711C475.722 1.27101 475.716 1.27088 475.711 1.27078C475.705 1.27068 475.697 1.27055 475.689 1.27051L475.686 2.02051L475.682 2.7705C475.68 2.77049 475.68 2.77047 475.683 2.77052C475.686 2.77058 475.689 2.77064 475.695 2.77077C475.705 2.77099 475.721 2.7713 475.739 2.77146L475.745 2.02148ZM475.686 2.02051V1.27051H273.645V2.02051V2.77051H475.686V2.02051ZM273.645 2.02051H274.395V1.12012H273.645H272.895V2.02051H273.645ZM273.645 1.12012V1.87012H475.753V1.12012V0.370117H273.645V1.12012ZM475.753 1.12012L475.747 1.87009C475.798 1.87053 475.875 1.87198 475.984 1.87391L475.997 1.12402L476.01 0.37414C475.907 0.372314 475.819 0.370658 475.759 0.370145L475.753 1.12012Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M273.616 23.9053L274.299 23.5952L274.099 23.1553H273.616V23.9053ZM273.616 24.8057V25.5557H274.099L274.299 25.1158L273.616 24.8057ZM76.918 24.8057V25.5557V24.8057ZM58.2031 28.0146L57.9818 27.2981L57.9818 27.2981L58.2031 28.0146ZM47.2139 33.0566L46.7857 32.4409L46.7857 32.4409L47.2139 33.0566ZM40.8984 41.1797L40.174 40.9855L40.174 40.9855L40.8984 41.1797ZM22.0596 116.168L21.3318 115.987L22.0596 116.168ZM10.9092 161.001L10.1813 160.82L10.9092 161.001ZM7.31641 175.469L6.58849 175.288L7.31641 175.469ZM6.31738 179.494L5.58946 179.314L6.31738 179.494ZM6.05566 180.551L6.7836 180.731L6.05566 180.551ZM5.98828 180.821L5.26035 180.641L5.26034 180.641L5.98828 180.821ZM5.9707 180.89L5.2428 180.709L5.24276 180.709L5.9707 180.89ZM5.9668 180.907L6.69474 181.088L6.69512 181.086L5.9668 180.907ZM5.96582 180.911L5.23799 180.73L5.23788 180.731L5.96582 180.911ZM5.52832 180.805L5.34776 181.533H5.34776L5.52832 180.805ZM5.09082 180.694L4.36288 180.514L4.35047 180.564L4.34502 180.615L5.09082 180.694ZM5.09277 180.69L5.82071 180.871L5.8211 180.869L5.09277 180.69ZM5.09668 180.673L4.36878 180.492L4.36874 180.492L5.09668 180.673ZM5.11426 180.604L4.38632 180.424L4.38632 180.424L5.11426 180.604ZM5.18164 180.334L5.90957 180.515H5.90957L5.18164 180.334ZM5.44336 179.276L4.71543 179.096L5.44336 179.276ZM6.44238 175.252L5.71447 175.071L6.44238 175.252ZM10.0352 160.783L9.30728 160.602L10.0352 160.783ZM21.1855 115.951L20.4578 115.77L21.1855 115.951ZM40.0283 40.9473L39.3039 40.7531L39.3039 40.7531L40.0283 40.9473ZM46.7002 32.3174L46.272 31.7016L46.272 31.7016L46.7002 32.3174ZM57.9375 27.1543L57.7161 26.4377L57.7161 26.4377L57.9375 27.1543ZM76.918 23.9053V24.6553V23.9053ZM471.082 23.9053V24.6553V23.9053ZM490.062 27.1543L490.284 26.4377V26.4377L490.062 27.1543ZM501.3 32.3174L501.728 31.7016V31.7016L501.3 32.3174ZM507.972 40.9473L508.696 40.7531V40.7531L507.972 40.9473ZM526.814 115.951L527.542 115.77L526.814 115.951ZM537.965 160.783L538.693 160.602L537.965 160.783ZM541.558 175.252L542.286 175.071L541.558 175.252ZM542.557 179.276L543.285 179.096L542.557 179.276ZM542.818 180.334L543.546 180.153L542.818 180.334ZM542.886 180.604L543.614 180.424L542.886 180.604ZM542.903 180.673L543.631 180.492L542.903 180.673ZM542.907 180.69L543.635 180.51L542.907 180.69ZM542.908 180.694L543.636 180.514L542.908 180.694ZM542.472 180.805L542.652 181.533L542.472 180.805ZM542.034 180.911L542.762 180.731L542.034 180.911ZM542.033 180.907L542.761 180.727L542.033 180.907ZM542.029 180.89L542.757 180.709L542.029 180.89ZM542.012 180.821L542.74 180.641L542.012 180.821ZM541.944 180.551L542.672 180.37L541.944 180.551ZM541.683 179.494L542.411 179.314L541.683 179.494ZM540.684 175.469L541.411 175.288L540.684 175.469ZM537.091 161.001L537.819 160.82L537.091 161.001ZM525.94 116.168L526.668 115.987L525.94 116.168ZM507.102 41.1797L507.826 40.9855V40.9855L507.102 41.1797ZM500.786 33.0566L501.214 32.4409V32.4409L500.786 33.0566ZM489.797 28.0146L490.018 27.2981V27.2981L489.797 28.0146ZM471.082 24.8057V25.5557V24.8057ZM274.384 24.8057L273.874 25.3559L274.09 25.5557H274.384V24.8057ZM274.384 23.9053V23.1553H274.09L273.874 23.3551L274.384 23.9053ZM273.616 23.9053L272.933 24.2154C272.907 24.1566 272.893 24.1069 272.887 24.081C272.88 24.0524 272.876 24.0291 272.874 24.0152C272.87 23.9882 272.869 23.9672 272.868 23.9602C272.868 23.951 272.868 23.9441 272.867 23.9415C272.867 23.9398 272.867 23.9386 272.867 23.9379C272.867 23.9371 272.867 23.9367 272.867 23.9366C272.867 23.9366 272.867 23.9374 272.867 23.9395C272.867 23.9415 272.867 23.9442 272.867 23.948C272.867 23.9556 272.868 23.966 272.868 23.9804C272.868 24.0384 272.868 24.1483 272.868 24.3555H273.618H274.368C274.368 24.1489 274.368 24.0349 274.368 23.9721C274.367 23.9419 274.367 23.9182 274.367 23.9005C274.367 23.8934 274.366 23.8763 274.365 23.8567C274.364 23.8477 274.363 23.8253 274.358 23.7973C274.357 23.7862 274.345 23.6972 274.299 23.5952L273.616 23.9053ZM273.618 24.3555H272.868C272.868 24.5627 272.868 24.6725 272.868 24.7306C272.868 24.7449 272.867 24.7554 272.867 24.763C272.867 24.7667 272.867 24.7695 272.867 24.7715C272.867 24.7735 272.867 24.7744 272.867 24.7743C272.867 24.7743 272.867 24.7738 272.867 24.7731C272.867 24.7724 272.867 24.7711 272.867 24.7695C272.868 24.7668 272.868 24.76 272.868 24.7508C272.869 24.7437 272.87 24.7228 272.874 24.6958C272.876 24.6818 272.88 24.6585 272.887 24.63C272.893 24.604 272.907 24.5544 272.933 24.4956L273.616 24.8057L274.299 25.1158C274.345 25.0138 274.357 24.9248 274.358 24.9137C274.363 24.8857 274.364 24.8633 274.365 24.8543C274.366 24.8347 274.367 24.8176 274.367 24.8104C274.367 24.7927 274.367 24.7691 274.368 24.7389C274.368 24.676 274.368 24.5621 274.368 24.3555H273.618ZM273.616 24.8057V24.0557H76.918V24.8057V25.5557H273.616V24.8057ZM76.918 24.8057V24.0557C74.2313 24.0557 66.0027 24.8204 57.9818 27.2981L58.2031 28.0146L58.4245 28.7312C66.2956 26.2999 74.3745 25.5557 76.918 25.5557V24.8057ZM58.2031 28.0146L57.9818 27.2981C53.9704 28.5372 49.9941 30.2099 46.7857 32.4409L47.2139 33.0566L47.642 33.6724C50.6769 31.5621 54.4937 29.9455 58.4245 28.7312L58.2031 28.0146ZM47.2139 33.0566L46.7857 32.4409C43.5774 34.672 41.1144 37.4773 40.174 40.9855L40.8984 41.1797L41.6229 41.3739C42.4403 38.3242 44.6074 35.7827 47.6421 33.6724L47.2139 33.0566ZM40.8984 41.1797L40.174 40.9855C38.3416 47.8229 29.6071 82.7624 21.3318 115.987L22.0596 116.168L22.7873 116.349C31.0654 83.1138 39.795 48.1943 41.6229 41.3738L40.8984 41.1797ZM22.0596 116.168L21.3318 115.987C17.1938 132.6 13.1703 148.787 10.1813 160.82L10.9092 161.001L11.6371 161.182C14.626 149.149 18.6495 132.962 22.7873 116.349L22.0596 116.168ZM10.9092 161.001L10.1813 160.82C8.68689 166.836 7.45074 171.814 6.58849 175.288L7.31641 175.469L8.04432 175.649C8.90653 172.176 10.1427 167.198 11.6371 161.182L10.9092 161.001ZM7.31641 175.469L6.58849 175.288C6.15739 177.025 5.8194 178.387 5.58946 179.314L6.31738 179.494L7.04531 179.675C7.27524 178.748 7.61321 177.386 8.04432 175.649L7.31641 175.469ZM6.31738 179.494L5.58946 179.314C5.47677 179.768 5.38452 180.141 5.32773 180.37L6.05566 180.551L6.7836 180.731C6.84533 180.483 6.92824 180.147 7.04531 179.675L6.31738 179.494ZM6.05566 180.551L5.32773 180.37C5.31306 180.429 5.30008 180.481 5.28884 180.526C5.27768 180.571 5.26804 180.61 5.26035 180.641L5.98828 180.821L6.71622 181.002C6.72357 180.972 6.73282 180.935 6.74419 180.89C6.75549 180.844 6.76867 180.792 6.7836 180.731L6.05566 180.551ZM5.98828 180.821L5.26034 180.641C5.25775 180.651 5.25524 180.661 5.25253 180.671C5.25136 180.676 5.24956 180.683 5.24818 180.688C5.24672 180.693 5.24477 180.701 5.2428 180.709L5.9707 180.89L6.69861 181.07C6.69853 181.071 6.6988 181.07 6.69981 181.066C6.70091 181.061 6.70187 181.058 6.70369 181.051C6.70694 181.038 6.71133 181.022 6.71622 181.002L5.98828 180.821ZM5.9707 180.89L5.24276 180.709C5.23857 180.726 5.23566 180.74 5.23444 180.746C5.23418 180.747 5.23386 180.748 5.23384 180.748C5.23373 180.749 5.23385 180.748 5.23404 180.747C5.23424 180.747 5.23471 180.744 5.23536 180.741C5.23601 180.739 5.23706 180.734 5.23847 180.728L5.9668 180.907L6.69512 181.086C6.69677 181.08 6.69806 181.074 6.69895 181.07C6.69985 181.066 6.70058 181.063 6.70104 181.06C6.7015 181.058 6.70189 181.056 6.70206 181.056C6.70233 181.054 6.70231 181.054 6.70236 181.054C6.70239 181.054 6.70096 181.061 6.69864 181.07L5.9707 180.89ZM5.9668 180.907L5.23886 180.727C5.2389 180.727 5.2389 180.727 5.23878 180.727C5.23877 180.727 5.2386 180.728 5.23852 180.728C5.23841 180.728 5.23821 180.729 5.23799 180.73L5.96582 180.911L6.69365 181.092C6.69353 181.093 6.69337 181.093 6.69371 181.092C6.69392 181.091 6.6943 181.09 6.69474 181.088L5.9668 180.907ZM5.96582 180.911L5.23788 180.731C5.23804 180.73 5.24079 180.719 5.24478 180.705C5.24902 180.69 5.25596 180.667 5.26636 180.64C5.28806 180.584 5.32436 180.511 5.38566 180.436C5.51652 180.276 5.67687 180.212 5.77616 180.186C5.86617 180.162 5.93951 180.161 5.96815 180.161C6.00306 180.161 6.0306 180.164 6.04462 180.166C6.07252 180.169 6.09378 180.172 6.09908 180.173C6.10728 180.175 6.11321 180.176 6.11503 180.177C6.11929 180.178 6.11491 180.177 6.08633 180.17C6.03438 180.157 5.92744 180.131 5.70888 180.077L5.52832 180.805L5.34776 181.533C5.56572 181.587 5.67742 181.614 5.73503 181.628C5.76123 181.634 5.78436 181.64 5.80247 181.644C5.80775 181.645 5.81628 181.647 5.82645 181.648C5.83372 181.65 5.8563 181.654 5.8851 181.657C5.89956 181.659 5.92744 181.661 5.96261 181.661C5.99152 181.661 6.06503 181.66 6.15517 181.637C6.25458 181.611 6.415 181.546 6.5459 181.387C6.60723 181.312 6.64355 181.238 6.66526 181.182C6.67566 181.155 6.68261 181.132 6.68684 181.118C6.69084 181.104 6.6936 181.092 6.69376 181.092L5.96582 180.911ZM5.52832 180.805L5.70889 180.077C5.4939 180.023 5.38651 179.997 5.33315 179.983C5.30448 179.976 5.29764 179.974 5.29918 179.974C5.30019 179.975 5.30424 179.976 5.31 179.977C5.31413 179.979 5.32824 179.983 5.34641 179.989C5.34933 179.991 5.41682 180.013 5.49164 180.061C5.52877 180.084 5.62619 180.149 5.70935 180.27C5.75527 180.337 5.79609 180.42 5.81976 180.518C5.84349 180.616 5.84401 180.704 5.83662 180.774L5.09082 180.694L4.34502 180.615C4.32728 180.782 4.36528 180.963 4.47234 181.119C4.55556 181.24 4.65307 181.305 4.69036 181.329C4.7655 181.376 4.83357 181.399 4.83754 181.401C4.86862 181.412 4.89603 181.419 4.89832 181.42C4.91479 181.424 4.93682 181.43 4.96386 181.437C5.02194 181.452 5.13335 181.479 5.34776 181.533L5.52832 180.805ZM5.09082 180.694L5.81876 180.875C5.81131 180.905 5.80289 180.931 5.79506 180.952C5.78721 180.974 5.77937 180.992 5.77255 181.007C5.76572 181.022 5.7593 181.034 5.75398 181.045C5.74865 181.055 5.74386 181.063 5.74012 181.07C5.73637 181.076 5.73316 181.081 5.73091 181.085C5.72867 181.089 5.72688 181.092 5.726 181.093C5.72529 181.094 5.72447 181.095 5.72498 181.095C5.72515 181.094 5.72617 181.093 5.72743 181.091C5.72995 181.087 5.73508 181.078 5.74122 181.068C5.74744 181.057 5.75554 181.042 5.76429 181.025C5.77306 181.007 5.783 180.985 5.79275 180.96C5.80252 180.934 5.81236 180.905 5.82071 180.871L5.09277 180.69L4.36483 180.51C4.37308 180.477 4.38279 180.447 4.39241 180.422C4.40201 180.397 4.41177 180.376 4.42036 180.359C4.42893 180.341 4.43682 180.327 4.44284 180.317C4.44878 180.306 4.4537 180.298 4.45602 180.295C4.45718 180.293 4.4581 180.291 4.45817 180.291C4.45858 180.291 4.45766 180.292 4.45685 180.293C4.45589 180.295 4.454 180.298 4.45167 180.302C4.44934 180.306 4.44604 180.311 4.44221 180.318C4.43839 180.324 4.43353 180.333 4.42812 180.343C4.42273 180.353 4.41625 180.366 4.40935 180.381C4.40248 180.396 4.39458 180.415 4.3867 180.436C4.37882 180.458 4.37036 180.484 4.36288 180.514L5.09082 180.694ZM5.09277 180.69L5.8211 180.869C5.82274 180.863 5.82404 180.857 5.82493 180.853C5.82583 180.849 5.82655 180.846 5.82702 180.844C5.82748 180.841 5.82787 180.84 5.82804 180.839C5.8283 180.837 5.82828 180.838 5.82834 180.837C5.82837 180.837 5.82694 180.844 5.82462 180.853L5.09668 180.673L4.36874 180.492C4.36455 180.509 4.36163 180.523 4.36041 180.529C4.36016 180.53 4.35984 180.532 4.35982 180.532C4.35971 180.532 4.35982 180.532 4.36002 180.531C4.36022 180.53 4.36069 180.528 4.36134 180.525C4.36198 180.522 4.36304 180.517 4.36445 180.511L5.09277 180.69ZM5.09668 180.673L5.82458 180.854C5.82451 180.854 5.82477 180.853 5.82579 180.849C5.82689 180.845 5.82785 180.841 5.82966 180.834C5.83292 180.822 5.8373 180.805 5.84219 180.785L5.11426 180.604L4.38632 180.424C4.38372 180.434 4.38122 180.444 4.37851 180.454C4.37733 180.459 4.37554 180.466 4.37416 180.471C4.37269 180.477 4.37075 180.484 4.36878 180.492L5.09668 180.673ZM5.11426 180.604L5.84219 180.785C5.84955 180.755 5.8588 180.718 5.87017 180.673C5.88146 180.628 5.89465 180.575 5.90957 180.515L5.18164 180.334L4.45371 180.153C4.43904 180.213 4.42605 180.265 4.41482 180.31C4.40366 180.354 4.39401 180.393 4.38632 180.424L5.11426 180.604ZM5.18164 180.334L5.90957 180.515C5.97463 180.252 6.05101 179.942 6.17129 179.457L5.44336 179.276L4.71543 179.096C4.60583 179.537 4.50722 179.938 4.45371 180.153L5.18164 180.334ZM5.44336 179.276L6.17129 179.457C6.40123 178.53 6.73919 177.17 7.1703 175.433L6.44238 175.252L5.71447 175.071C5.28347 176.808 4.94537 178.169 4.71543 179.096L5.44336 179.276ZM6.44238 175.252L7.1703 175.433C8.03254 171.959 9.26857 166.98 10.763 160.964L10.0352 160.783L9.30728 160.602C7.81279 166.619 6.57674 171.597 5.71447 175.071L6.44238 175.252ZM10.0352 160.783L10.763 160.964C13.752 148.931 17.7754 132.745 21.9133 116.132L21.1855 115.951L20.4578 115.77C16.3198 132.383 12.2963 148.57 9.30728 160.602L10.0352 160.783ZM21.1855 115.951L21.9133 116.132C30.1897 82.9041 38.922 47.9728 40.7528 41.1414L40.0283 40.9473L39.3039 40.7531C37.4686 47.6014 28.7314 82.5526 20.4578 115.77L21.1855 115.951ZM40.0283 40.9473L40.7528 41.1414C41.6439 37.8163 43.9891 35.1161 47.1284 32.9331L46.7002 32.3174L46.272 31.7016C42.9594 34.0052 40.318 36.9691 39.3039 40.7531L40.0283 40.9473ZM46.7002 32.3174L47.1284 32.9331C50.2675 30.7504 54.1797 29.1001 58.1589 27.8709L57.9375 27.1543L57.7161 26.4377C53.6564 27.6918 49.5847 29.3982 46.272 31.7016L46.7002 32.3174ZM57.9375 27.1543L58.1589 27.8709C66.1199 25.4117 74.2885 24.6553 76.918 24.6553V23.9053V23.1553C74.1453 23.1553 65.827 23.9323 57.7161 26.4377L57.9375 27.1543ZM76.918 23.9053V24.6553H273.616V23.9053V23.1553H76.918V23.9053ZM471.082 23.9053V24.6553C473.712 24.6553 481.88 25.4116 489.841 27.8709L490.062 27.1543L490.284 26.4377C482.173 23.9322 473.855 23.1553 471.082 23.1553V23.9053ZM490.062 27.1543L489.841 27.8709C493.82 29.1002 497.732 30.7503 500.872 32.9331L501.3 32.3174L501.728 31.7016C498.415 29.398 494.344 27.6919 490.284 26.4377L490.062 27.1543ZM501.3 32.3174L500.872 32.9331C504.011 35.1162 506.356 37.8162 507.247 41.1414L507.972 40.9473L508.696 40.7531C507.682 36.969 505.041 34.0052 501.728 31.7016L501.3 32.3174ZM507.972 40.9473L507.247 41.1414C509.078 47.9728 517.81 82.904 526.087 116.132L526.814 115.951L527.542 115.77C519.269 82.5526 510.531 47.6014 508.696 40.7531L507.972 40.9473ZM526.814 115.951L526.087 116.132C530.225 132.745 534.248 148.931 537.237 160.964L537.965 160.783L538.693 160.602C535.704 148.569 531.68 132.383 527.542 115.77L526.814 115.951ZM537.965 160.783L537.237 160.964C538.731 166.98 539.967 171.959 540.83 175.433L541.558 175.252L542.286 175.071C541.423 171.597 540.187 166.619 538.693 160.602L537.965 160.783ZM541.558 175.252L540.83 175.433C541.261 177.17 541.599 178.53 541.829 179.457L542.557 179.276L543.285 179.096C543.055 178.169 542.717 176.808 542.286 175.071L541.558 175.252ZM542.557 179.276L541.829 179.457C541.949 179.942 542.025 180.252 542.09 180.515L542.818 180.334L543.546 180.153C543.493 179.938 543.394 179.537 543.285 179.096L542.557 179.276ZM542.818 180.334L542.09 180.515C542.105 180.575 542.119 180.628 542.13 180.673C542.141 180.718 542.15 180.755 542.158 180.785L542.886 180.604L543.614 180.424C543.606 180.393 543.596 180.354 543.585 180.31C543.574 180.265 543.561 180.213 543.546 180.153L542.818 180.334ZM542.886 180.604L542.158 180.785C542.163 180.805 542.167 180.822 542.17 180.834C542.172 180.841 542.173 180.845 542.174 180.849C542.175 180.853 542.175 180.854 542.175 180.853L542.903 180.673L543.631 180.492C543.629 180.484 543.627 180.477 543.626 180.471C543.624 180.466 543.623 180.459 543.622 180.454C543.619 180.444 543.616 180.434 543.614 180.424L542.886 180.604ZM542.903 180.673L542.175 180.853C542.173 180.844 542.172 180.837 542.172 180.837C542.172 180.837 542.172 180.837 542.172 180.839C542.172 180.839 542.173 180.841 542.173 180.844C542.174 180.846 542.174 180.85 542.175 180.854C542.176 180.858 542.178 180.864 542.179 180.871L542.907 180.69L543.635 180.51C543.637 180.516 543.638 180.521 543.638 180.524C543.639 180.527 543.64 180.529 543.64 180.531C543.64 180.532 543.64 180.532 543.64 180.532C543.64 180.532 543.64 180.532 543.64 180.531C543.64 180.53 543.64 180.53 543.64 180.529C543.638 180.523 543.635 180.509 543.631 180.492L542.903 180.673ZM542.907 180.69L542.179 180.871C542.18 180.873 542.18 180.874 542.18 180.875C542.181 180.877 542.18 180.876 542.18 180.875L542.908 180.694L543.636 180.514C543.636 180.513 543.636 180.512 543.635 180.511C543.635 180.511 543.635 180.51 543.635 180.51C543.635 180.51 543.635 180.51 543.635 180.51L542.907 180.69ZM542.908 180.694L542.18 180.875C542.185 180.893 542.138 180.743 542.17 180.564C542.206 180.36 542.315 180.223 542.394 180.149C542.464 180.083 542.531 180.046 542.557 180.032C542.588 180.015 542.615 180.004 542.628 179.999C542.655 179.988 542.676 179.982 542.681 179.98C542.689 179.977 542.695 179.976 542.697 179.975C542.701 179.974 542.697 179.975 542.668 179.983C542.617 179.996 542.51 180.022 542.291 180.077L542.472 180.805L542.652 181.533C542.87 181.479 542.982 181.451 543.039 181.436C543.065 181.429 543.088 181.423 543.106 181.418C543.112 181.417 543.12 181.414 543.13 181.411C543.137 181.409 543.159 181.402 543.187 181.391C543.201 181.385 543.227 181.374 543.259 181.357C543.285 181.343 543.352 181.307 543.422 181.24C543.502 181.166 543.611 181.029 543.647 180.825C543.678 180.645 543.632 180.495 543.636 180.514L542.908 180.694ZM542.472 180.805L542.291 180.077C542.072 180.131 541.965 180.157 541.914 180.17C541.885 180.177 541.881 180.178 541.885 180.177C541.887 180.176 541.893 180.175 541.901 180.173C541.907 180.172 541.928 180.168 541.957 180.165C541.971 180.164 541.999 180.161 542.035 180.161C542.065 180.161 542.14 180.163 542.233 180.188C542.337 180.217 542.498 180.286 542.625 180.45C542.684 180.525 542.718 180.598 542.737 180.651C542.747 180.676 542.753 180.697 542.757 180.71C542.759 180.717 542.76 180.722 542.761 180.725C542.761 180.727 542.762 180.729 542.762 180.729C542.762 180.73 542.762 180.731 542.762 180.731L542.034 180.911L541.306 181.092C541.306 181.092 541.306 181.092 541.307 181.093C541.307 181.094 541.307 181.096 541.308 181.097C541.308 181.1 541.31 181.106 541.312 181.112C541.315 181.125 541.321 181.146 541.331 181.172C541.35 181.225 541.384 181.297 541.443 181.373C541.571 181.536 541.731 181.606 541.836 181.634C541.928 181.66 542.004 181.661 542.034 181.661C542.07 181.661 542.099 181.659 542.113 181.657C542.143 181.654 542.166 181.65 542.173 181.649C542.183 181.647 542.192 181.645 542.197 181.644C542.216 181.64 542.239 181.634 542.265 181.628C542.322 181.614 542.434 181.587 542.652 181.533L542.472 180.805ZM542.034 180.911L542.762 180.731C542.762 180.729 542.762 180.729 542.761 180.728C542.761 180.728 542.761 180.727 542.761 180.727C542.761 180.726 542.761 180.726 542.761 180.727L542.033 180.907L541.305 181.088C541.306 181.09 541.306 181.091 541.306 181.092C541.307 181.093 541.306 181.093 541.306 181.092L542.034 180.911ZM542.033 180.907L542.761 180.727C542.763 180.733 542.764 180.738 542.764 180.741C542.765 180.744 542.766 180.746 542.766 180.747C542.766 180.748 542.766 180.749 542.766 180.749C542.766 180.748 542.766 180.748 542.766 180.748C542.766 180.747 542.766 180.747 542.766 180.746C542.764 180.74 542.761 180.726 542.757 180.709L542.029 180.89L541.301 181.07C541.299 181.061 541.298 181.054 541.298 181.054C541.298 181.054 541.298 181.054 541.298 181.055C541.298 181.056 541.299 181.058 541.299 181.061C541.299 181.063 541.3 181.066 541.301 181.071C541.302 181.075 541.304 181.081 541.305 181.088L542.033 180.907ZM542.029 180.89L542.757 180.709C542.755 180.701 542.753 180.694 542.752 180.688C542.75 180.683 542.749 180.676 542.747 180.671C542.745 180.661 542.742 180.651 542.74 180.641L542.012 180.821L541.284 181.002C541.289 181.022 541.293 181.039 541.296 181.051C541.298 181.058 541.299 181.062 541.3 181.066C541.301 181.07 541.301 181.071 541.301 181.07L542.029 180.89ZM542.012 180.821L542.74 180.641C542.732 180.61 542.722 180.571 542.711 180.526C542.7 180.481 542.687 180.429 542.672 180.37L541.944 180.551L541.216 180.731C541.231 180.792 541.245 180.844 541.256 180.89C541.267 180.935 541.276 180.972 541.284 181.002L542.012 180.821ZM541.944 180.551L542.672 180.37C542.616 180.141 542.523 179.768 542.411 179.314L541.683 179.494L540.955 179.675C541.072 180.147 541.155 180.482 541.216 180.731L541.944 180.551ZM541.683 179.494L542.411 179.314C542.181 178.387 541.843 177.025 541.411 175.288L540.684 175.469L539.956 175.649C540.387 177.386 540.725 178.748 540.955 179.675L541.683 179.494ZM540.684 175.469L541.411 175.288C540.549 171.814 539.313 166.836 537.819 160.82L537.091 161.001L536.363 161.182C537.857 167.198 539.093 172.176 539.956 175.649L540.684 175.469ZM537.091 161.001L537.819 160.82C534.83 148.787 530.806 132.6 526.668 115.987L525.94 116.168L525.213 116.349C529.351 132.962 533.374 149.149 536.363 161.182L537.091 161.001ZM525.94 116.168L526.668 115.987C518.393 82.7623 509.658 47.8229 507.826 40.9855L507.102 41.1797L506.377 41.3738C508.205 48.1944 516.935 83.1138 525.213 116.349L525.94 116.168ZM507.102 41.1797L507.826 40.9855C506.886 37.4772 504.423 34.672 501.214 32.4409L500.786 33.0566L500.358 33.6724C503.393 35.7827 505.56 38.3242 506.377 41.3739L507.102 41.1797ZM500.786 33.0566L501.214 32.4409C498.006 30.2098 494.03 28.5373 490.018 27.2981L489.797 28.0146L489.576 28.7312C493.506 29.9456 497.323 31.562 500.358 33.6724L500.786 33.0566ZM489.797 28.0146L490.018 27.2981C481.997 24.8203 473.769 24.0557 471.082 24.0557V24.8057V25.5557C473.626 25.5557 481.704 26.2997 489.576 28.7312L489.797 28.0146ZM471.082 24.8057V24.0557H274.384V24.8057V25.5557H471.082V24.8057ZM274.384 24.8057L274.893 24.2554C274.996 24.3508 275.048 24.4521 275.072 24.508C275.097 24.5657 275.109 24.6142 275.115 24.639C275.126 24.6878 275.129 24.7267 275.13 24.7355C275.132 24.7501 275.132 24.7612 275.132 24.7652C275.133 24.7702 275.133 24.7736 275.133 24.7743C275.133 24.7746 275.132 24.766 275.132 24.7358C275.132 24.6792 275.132 24.569 275.132 24.3555H274.382H273.632C273.632 24.5682 273.632 24.6825 273.632 24.7441C273.633 24.773 273.633 24.797 273.633 24.8152C273.633 24.8208 273.634 24.8441 273.636 24.8714C273.637 24.8818 273.641 24.9217 273.652 24.9711C273.654 24.9793 273.691 25.1863 273.874 25.3559L274.384 24.8057ZM274.382 24.3555H275.132C275.132 24.1419 275.132 24.0318 275.132 23.9751C275.132 23.9449 275.133 23.9363 275.133 23.9366C275.133 23.9374 275.133 23.9407 275.132 23.9457C275.132 23.9498 275.132 23.9608 275.13 23.9754C275.129 23.9843 275.126 24.0231 275.115 24.0719C275.109 24.0968 275.097 24.1453 275.072 24.203C275.048 24.2589 274.996 24.3602 274.893 24.4555L274.384 23.9053L273.874 23.3551C273.691 23.5246 273.654 23.7316 273.652 23.7398C273.641 23.7893 273.637 23.8291 273.636 23.8396C273.634 23.8668 273.633 23.8902 273.633 23.8957C273.633 23.914 273.633 23.9379 273.632 23.9669C273.632 24.0284 273.632 24.1428 273.632 24.3555H274.382ZM274.384 23.9053V24.6553H471.082V23.9053V23.1553H274.384V23.9053Z",
                fill: "white"
            })
        ]
    });
const GuideFaucetsOverlay = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "375",
        height: "418",
        viewBox: "0 0 375 418",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_d_378_73463)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M211.882 99.6139C212.471 93.0166 215.768 82.1988 225.342 81.6669C231.028 81.351 240.479 99.1304 251.422 119.719C251.701 120.244 251.981 120.771 252.262 121.3C254.816 126.102 257.476 131.015 260.124 135.906C267.397 149.336 274.576 162.594 279.183 172.898C280.429 174.144 285.016 175.739 293.391 172.15C301.766 168.561 304.857 163.177 305.356 160.933C305.356 160.933 260.488 75.6846 256.001 70.4501C255.784 70.1962 255.557 69.9282 255.321 69.6482C250.68 64.1555 242.128 54.0348 219.36 54.7466C187.249 60.7205 183.476 99.5067 183.466 99.6139M211.882 99.6139V300.535C231.272 302.107 232.82 306.752 232.82 306.752V313.483C232.82 313.483 226.09 322.456 197.674 322.456C169.257 322.456 162.527 312.735 162.527 312.735V307.5C162.527 307.5 164.076 302.339 183.466 300.592V99.6139",
                    fill: "white",
                    fillOpacity: "0.25",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M235.152 57.1885C226.429 54.5817 215.818 54.3737 205.667 61.0248C185.257 74.3964 183.628 98.8997 184.074 110.048L183.34 110.078H184.074V306.107H182.578V282.6C182.389 282.656 182.189 282.686 181.981 282.686C180.827 282.686 179.891 281.751 179.891 280.596V262.694C179.891 261.539 180.827 260.603 181.981 260.603C182.189 260.603 182.389 260.634 182.578 260.69V251.274C182.389 251.33 182.189 251.36 181.981 251.36C180.827 251.36 179.891 250.424 179.891 249.27V246.584C179.891 245.43 180.827 244.494 181.981 244.494C182.189 244.494 182.389 244.524 182.578 244.58V110.078C182.133 98.8342 183.742 73.6014 204.847 59.7738C215.462 52.8192 226.557 53.0589 235.58 55.7556C244.571 58.4427 251.595 63.5943 254.164 66.6296C256.646 69.5627 258.519 72.1587 259.774 74.024C260.402 74.9569 260.875 75.7074 261.192 76.2265C261.293 76.3918 261.378 76.5336 261.447 76.6504L261.492 76.6267L305.574 160.538C305.681 160.691 305.773 160.855 305.849 161.032C306.252 161.97 306.084 163.001 305.619 163.973C305.153 164.948 304.353 165.952 303.322 166.933C301.255 168.899 298.142 170.886 294.476 172.46C290.81 174.034 287.225 174.923 284.376 175.068C282.955 175.14 281.675 175.029 280.648 174.696C279.709 174.391 278.906 173.872 278.468 173.066L278.439 173.081L235.067 90.5089L235.071 90.507C234.973 90.3457 234.863 90.1639 234.744 89.9687C234.307 89.2542 233.755 88.371 233.281 87.6732L233.229 87.596C232.699 86.812 231.347 84.8105 229.191 83.5617C228.089 82.9234 226.787 82.4891 225.28 82.514C223.773 82.5388 222.007 83.0235 219.977 84.3054C216.004 86.8147 214.095 91.6696 213.247 96.8154C212.403 101.933 212.639 107.14 212.788 110.124L212.717 110.128V298.995C218.779 299.688 223.972 300.802 227.708 302.207C229.641 302.934 231.227 303.755 232.342 304.666C233.45 305.57 234.197 306.652 234.198 307.898V307.899V312.821V313.031L234.089 313.21L233.45 312.821C234.089 313.21 234.088 313.211 234.088 313.211L234.087 313.213L234.084 313.217L234.078 313.228L234.07 313.24L234.057 313.26C234.04 313.286 234.016 313.322 233.984 313.367C233.922 313.456 233.83 313.58 233.705 313.734C233.455 314.043 233.072 314.471 232.525 314.978C231.429 315.993 229.677 317.32 227.012 318.638C221.684 321.274 212.725 323.863 198.093 323.863C183.461 323.863 174.502 321.274 169.174 318.638C166.509 317.32 164.757 315.993 163.662 314.978C163.114 314.471 162.731 314.043 162.481 313.734C162.356 313.58 162.264 313.456 162.202 313.367C162.17 313.322 162.146 313.286 162.129 313.26C162.121 313.247 162.114 313.236 162.108 313.228L162.102 313.217L162.099 313.213L162.098 313.211C162.098 313.211 162.097 313.21 162.736 312.821L162.097 313.21L161.988 313.031V312.821V307.899V307.898H161.988C161.989 306.712 162.667 305.674 163.685 304.799C164.707 303.92 166.159 303.127 167.929 302.42C171.476 301.003 176.469 299.866 182.336 299.13L182.522 300.614C176.719 301.341 171.866 302.458 168.484 303.809C166.79 304.486 165.506 305.205 164.66 305.933C163.809 306.664 163.484 307.326 163.484 307.899C163.484 308.733 164.177 309.799 165.93 310.972C167.635 312.112 170.148 313.218 173.31 314.185C179.627 316.115 188.391 317.445 198.093 317.445C207.795 317.445 216.559 316.115 222.876 314.185C226.038 313.218 228.551 312.112 230.256 310.972C232.009 309.799 232.702 308.733 232.702 307.899C232.702 307.297 232.343 306.597 231.397 305.824C230.458 305.058 229.041 304.306 227.182 303.607C223.636 302.274 218.637 301.187 212.717 300.5V306.107H211.222V110.078H211.289C211.139 107.073 210.91 101.793 211.771 96.572C212.639 91.3082 214.648 85.9026 219.179 83.0409C221.401 81.6374 223.431 81.0487 225.255 81.0186C227.08 80.9885 228.646 81.5177 229.941 82.2676C232.401 83.693 233.918 85.9422 234.457 86.7422L234.519 86.8339C235.013 87.5615 235.579 88.4688 236.019 89.1883C236.24 89.5493 236.431 89.8654 236.566 90.0913L236.661 90.2506L236.724 90.3572L236.767 90.429L236.778 90.4478L236.781 90.4527L236.782 90.454L236.782 90.4543L236.782 90.4544C236.782 90.4544 236.782 90.4545 236.74 90.4789L271.871 157.36C273.927 155.062 278.722 150.274 282.755 147.922C285.029 146.595 287.83 145.944 290.406 145.6C292.414 145.332 294.338 145.244 295.819 145.184L260.397 77.7569L260.37 77.7721L260.37 77.7719L260.369 77.7701L260.364 77.7618L260.344 77.7261C260.325 77.6939 260.297 77.645 260.259 77.5802C260.183 77.4505 260.069 77.2571 259.915 77.0062C259.609 76.5043 259.148 75.7722 258.533 74.8588C257.304 73.0316 255.463 70.4806 253.022 67.5957C250.667 64.813 243.907 59.805 235.152 57.1885ZM296.588 146.649C296.433 146.656 296.271 146.663 296.105 146.669C294.594 146.73 292.65 146.809 290.605 147.082C288.102 147.417 285.531 148.034 283.509 149.214C279.406 151.607 274.344 156.767 272.616 158.778L278.525 170.029L278.547 169.982C278.56 169.953 278.573 169.924 278.587 169.895C279.053 168.921 279.853 167.917 280.885 166.936C282.951 164.97 286.064 162.982 289.73 161.408C293.396 159.834 296.981 158.946 299.83 158.801C301.047 158.739 302.16 158.811 303.099 159.043L296.588 146.649ZM304.305 161.337L304.367 161.457L304.383 161.449C304.419 161.506 304.45 161.564 304.475 161.622C304.645 162.02 304.629 162.576 304.27 163.329C303.911 164.08 303.247 164.939 302.291 165.849C300.383 167.664 297.432 169.563 293.886 171.086C290.339 172.609 286.93 173.44 284.3 173.574C282.982 173.641 281.902 173.53 281.11 173.273C280.316 173.015 279.902 172.644 279.731 172.246C279.561 171.849 279.577 171.293 279.936 170.54C280.295 169.789 280.959 168.929 281.915 168.019C283.823 166.205 286.774 164.305 290.32 162.783C293.867 161.26 297.276 160.428 299.906 160.295C301.224 160.228 302.304 160.338 303.096 160.595C303.696 160.79 304.08 161.05 304.305 161.337ZM231.087 312.215C231.694 311.809 232.242 311.376 232.702 310.92V312.588C232.661 312.643 232.609 312.712 232.543 312.793C232.337 313.047 232.003 313.423 231.508 313.881C230.52 314.796 228.888 316.042 226.349 317.298C221.272 319.809 212.552 322.367 198.093 322.367C183.634 322.367 174.914 319.809 169.837 317.298C167.298 316.042 165.666 314.796 164.678 313.881C164.183 313.423 163.849 313.047 163.643 312.793C163.577 312.712 163.525 312.643 163.484 312.588V310.92C163.944 311.376 164.492 311.809 165.099 312.215C166.972 313.468 169.638 314.626 172.873 315.615C179.354 317.596 188.268 318.941 198.093 318.941C207.918 318.941 216.832 317.596 223.313 315.615C226.548 314.626 229.214 313.468 231.087 312.215ZM197.648 308.942C193.736 308.942 190.219 308.544 187.702 307.915C186.438 307.599 185.468 307.235 184.832 306.859C184.146 306.453 184.074 306.176 184.074 306.109H182.578C182.578 307.031 183.307 307.695 184.071 308.146C184.884 308.627 186.012 309.034 187.339 309.366C190.006 310.033 193.65 310.437 197.648 310.437C201.645 310.437 205.29 310.033 207.956 309.366C209.284 309.034 210.411 308.627 211.225 308.146C211.988 307.695 212.717 307.031 212.717 306.109H211.222C211.222 306.176 211.15 306.453 210.464 306.859C209.828 307.235 208.858 307.599 207.593 307.915C205.077 308.544 201.56 308.942 197.648 308.942ZM282.855 170.198C282.517 170.693 282.577 170.883 282.582 170.893C282.586 170.904 282.682 171.078 283.274 171.175C283.824 171.264 284.612 171.25 285.605 171.107C287.58 170.824 290.194 170.061 292.964 168.871C295.734 167.682 298.088 166.312 299.653 165.075C300.44 164.453 300.993 163.892 301.307 163.431C301.645 162.936 301.585 162.747 301.58 162.736C301.575 162.725 301.479 162.551 300.888 162.455C300.338 162.365 299.55 162.38 298.557 162.522C296.582 162.805 293.968 163.569 291.198 164.758C288.427 165.948 286.074 167.317 284.509 168.554C283.722 169.176 283.168 169.737 282.855 170.198ZM283.581 167.381C285.276 166.041 287.752 164.61 290.608 163.384C293.463 162.158 296.206 161.348 298.344 161.042C299.408 160.889 300.365 160.854 301.128 160.979C301.849 161.096 302.633 161.399 302.954 162.146C303.275 162.893 302.954 163.67 302.543 164.274C302.108 164.912 301.423 165.583 300.58 166.249C298.885 167.588 296.409 169.02 293.554 170.246C290.699 171.472 287.956 172.281 285.817 172.588C284.754 172.74 283.796 172.775 283.033 172.651C282.312 172.533 281.528 172.23 281.208 171.484C280.887 170.737 281.207 169.959 281.619 169.356C282.054 168.717 282.738 168.047 283.581 167.381ZM181.386 262.694C181.386 262.365 181.653 262.099 181.981 262.099C182.31 262.099 182.576 262.365 182.576 262.694V280.596C182.576 280.925 182.31 281.191 181.981 281.191C181.653 281.191 181.386 280.925 181.386 280.596V262.694ZM181.981 245.99C181.653 245.99 181.386 246.256 181.386 246.584V249.27C181.386 249.598 181.653 249.865 181.981 249.865C182.31 249.865 182.576 249.598 182.576 249.27V246.584C182.576 246.256 182.31 245.99 181.981 245.99Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter1_d_378_73463)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M73.0586 252.779C73.0586 252.779 78.2931 246.797 93.9968 246.797C109.7 246.797 114.935 252.779 114.935 252.779V323.026C127.298 326.096 131.385 331.297 131.385 331.297V338.775C131.385 338.775 123.16 351.488 94.7434 351.488C66.3273 351.488 58.1016 338.775 58.1016 338.775V331.297C58.1016 331.297 61.857 326.518 73.0586 323.417V271.429L26.6953 282.688V267.733L73.0586 257.798V252.779Z",
                    fill: "white",
                    fillOpacity: "0.25",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M73.4681 256.397V253.913C74.1289 254.451 75.0586 255.095 76.32 255.745L73.4681 256.397ZM71.9725 256.739V252.185V251.891L72.1723 251.676L72.6886 252.155C72.1724 251.676 72.1727 251.675 72.1731 251.675L72.174 251.674L72.1762 251.671L72.1823 251.665L72.201 251.646C72.2165 251.63 72.2378 251.608 72.2651 251.581C72.3198 251.527 72.3986 251.452 72.5025 251.36C72.7103 251.174 73.0185 250.916 73.435 250.614C74.2682 250.01 75.5337 249.226 77.2943 248.476C80.8189 246.973 86.3052 245.614 94.2457 246.067C102.144 246.519 107.586 247.874 111.072 249.131C112.815 249.76 114.067 250.363 114.892 250.816C115.304 251.042 115.609 251.23 115.815 251.365C115.917 251.432 115.996 251.486 116.05 251.524C116.077 251.544 116.098 251.559 116.113 251.57L116.132 251.584L116.138 251.589L116.14 251.591L116.141 251.591C116.141 251.592 116.142 251.592 115.686 252.185L116.142 251.592L116.434 251.816V252.185V259.343H116.434V265.609V265.803L116.434 265.805V322.529C120.813 323.494 124.485 324.75 127.112 326.226C129.802 327.737 131.648 329.626 131.648 331.866C131.648 332.161 131.615 332.453 131.552 332.742H131.648V338.823V339.002L131.568 339.161L130.9 338.823C131.568 339.161 131.567 339.161 131.567 339.162L131.566 339.164L131.564 339.168L131.558 339.18L131.547 339.2L131.538 339.217C131.529 339.234 131.517 339.255 131.503 339.28C131.492 339.299 131.48 339.32 131.467 339.343C131.405 339.45 131.313 339.6 131.186 339.787C130.934 340.162 130.546 340.686 129.987 341.309C128.87 342.556 127.077 344.194 124.342 345.824C118.871 349.084 109.67 352.287 94.6482 352.287C79.6267 352.287 70.4256 349.084 64.954 345.824C62.2197 344.194 60.4263 342.556 59.3091 341.309C58.7508 340.686 58.3623 340.162 58.11 339.787C57.9838 339.6 57.8918 339.45 57.8296 339.343C57.7986 339.29 57.775 339.247 57.7583 339.217L57.7475 339.197L57.7385 339.18L57.7323 339.168L57.7302 339.164L57.7293 339.162C57.729 339.161 57.7287 339.161 58.3961 338.823L57.7287 339.161L57.6483 339.002V338.823V332.742H57.7406C57.6798 332.453 57.6483 332.161 57.6483 331.866C57.6483 329.697 59.3794 327.859 61.9164 326.379C64.3867 324.938 67.8412 323.7 71.9725 322.732V272.014L26.9342 283.606L26 283.847L26 282.882L26 267.847L26 267.251L26.5811 267.118L71.9725 256.739ZM73.4681 271.629V322.704C73.4964 322.753 73.5325 322.812 73.5769 322.882C73.7178 323.103 73.9419 323.429 74.2646 323.824C74.9097 324.614 75.9496 325.683 77.5085 326.758C80.6185 328.903 85.8386 331.102 94.203 331.102C102.584 331.102 107.814 329.119 110.928 327.186C112.487 326.218 113.525 325.257 114.167 324.55C114.488 324.196 114.71 323.905 114.849 323.708C114.884 323.659 114.913 323.616 114.938 323.579V267.729C114.209 268.474 113.162 269.376 111.717 270.273C108.341 272.368 102.831 274.413 94.2038 274.413C86.4528 274.413 81.2112 272.582 77.7729 270.521L77.6998 270.54L73.4681 271.629ZM78.2682 269.071C81.4425 271.044 86.483 272.918 94.2038 272.918C102.584 272.918 107.815 270.934 110.929 269.002C112.488 268.034 113.526 267.073 114.168 266.366C114.489 266.012 114.711 265.721 114.85 265.524C114.884 265.476 114.914 265.433 114.938 265.396V254.426C114.202 254.969 113.126 255.634 111.622 256.293C108.266 257.763 102.79 259.199 94.203 259.199C86.8728 259.199 81.8042 258.037 78.3848 256.68L78.2682 269.071ZM74.1744 252.554C74.0312 252.43 73.9081 252.317 73.8037 252.216C73.9445 252.101 74.114 251.969 74.3134 251.825C75.0606 251.282 76.2287 250.556 77.8807 249.851C81.1813 248.445 86.4363 247.119 94.1604 247.56C101.926 248.004 107.225 249.334 110.565 250.538C112.235 251.141 113.416 251.712 114.172 252.127C114.471 252.291 114.703 252.43 114.873 252.537C114.737 252.669 114.537 252.849 114.262 253.063C113.626 253.557 112.589 254.236 111.022 254.923C107.889 256.295 102.624 257.703 94.203 257.703C85.7928 257.703 80.5375 256.141 77.4113 254.619C75.8474 253.858 74.8108 253.104 74.1744 252.554ZM116.434 330.059V324.062C120.59 324.998 123.991 326.188 126.38 327.53C128.996 328.999 130.152 330.505 130.152 331.866C130.152 332.991 129.345 334.32 127.524 335.728C125.732 337.113 123.101 338.46 119.807 339.639C113.225 341.994 104.137 343.631 94.2006 343.631C84.2644 343.631 75.4031 341.995 69.05 339.642C65.87 338.464 63.3527 337.12 61.6455 335.738C59.9158 334.339 59.1439 333.008 59.1439 331.866C59.1439 330.551 60.222 329.099 62.6701 327.671C64.8989 326.37 68.0748 325.206 71.9725 324.269V329.164V329.341L72.0515 329.499L72.7203 329.164C72.0515 329.499 72.0517 329.499 72.052 329.5L72.0527 329.501L72.0543 329.504L72.0588 329.513L72.0731 329.54C72.085 329.563 72.1016 329.593 72.1232 329.632C72.1664 329.708 72.2296 329.816 72.3148 329.95C72.4851 330.218 72.7436 330.592 73.1062 331.036C73.8317 331.924 74.9736 333.093 76.6595 334.255C80.039 336.586 85.5604 338.863 94.203 338.863C102.83 338.863 108.34 336.818 111.716 334.723C113.402 333.676 114.546 332.624 115.274 331.82C115.639 331.419 115.899 331.08 116.071 330.837C116.157 330.715 116.221 330.617 116.265 330.546C116.287 330.511 116.304 330.483 116.317 330.462L116.331 330.436L116.336 330.428L116.338 330.425L116.339 330.423C116.339 330.423 116.339 330.422 115.686 330.059L116.339 330.422L116.434 330.253V330.059ZM73.4681 328.97V325.196C74.1931 326.015 75.231 327.004 76.6595 327.99C80.039 330.32 85.5604 332.597 94.203 332.597C102.83 332.597 108.34 330.553 111.716 328.457C113.162 327.56 114.209 326.657 114.938 325.912V329.845L114.909 329.888L114.884 329.924C114.873 329.94 114.862 329.957 114.849 329.974C114.71 330.171 114.488 330.462 114.167 330.815C113.525 331.523 112.487 332.484 110.928 333.452C107.814 335.384 102.584 337.367 94.203 337.367C85.8386 337.367 80.6185 335.169 77.5085 333.024C75.9496 331.949 74.9097 330.88 74.2646 330.09C73.9419 329.695 73.7178 329.369 73.5769 329.148C73.5325 329.078 73.4964 329.018 73.4681 328.97ZM128.439 336.911C129.093 336.405 129.672 335.874 130.152 335.321V338.627C130.106 338.706 130.037 338.816 129.946 338.952C129.73 339.273 129.384 339.742 128.873 340.311C127.854 341.449 126.177 342.989 123.577 344.539C118.379 347.636 109.454 350.792 94.6482 350.792C79.842 350.792 70.9171 347.636 65.7196 344.539C63.1192 342.989 61.4423 341.449 60.4229 340.311C59.9128 339.742 59.5664 339.273 59.3509 338.952C59.259 338.816 59.1908 338.706 59.1439 338.627V335.399C59.5854 335.919 60.1116 336.421 60.7046 336.901C62.5824 338.421 65.2622 339.834 68.5306 341.044C75.0745 343.468 84.1153 345.127 94.2006 345.127C104.286 345.127 113.547 343.468 120.31 341.047C123.688 339.838 126.478 338.427 128.439 336.911ZM27.4956 281.917V268.443L76.8847 257.15L76.771 269.234L27.4956 281.917Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter2_d_378_73463)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M311.823 223.884V275.508C322.776 277.493 325.282 280.715 325.282 280.715L326.03 290.436C326.03 290.436 320.047 301.279 292.005 301.279C263.963 301.279 257.98 291.184 257.98 291.184V282.958C257.98 282.958 260.712 278.276 272.938 275.676V211.637C272.938 211.637 275.181 202.195 292.38 202.195C309.579 202.195 311.823 211.637 311.823 211.637V211.919L348.462 200.703V212.668L311.823 223.884Z",
                    fill: "white",
                    fillOpacity: "0.25",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M349.957 199.89V198.882L348.992 199.175L312.294 210.308L312.279 210.271C312.251 210.202 312.209 210.108 312.152 209.992C312.037 209.76 311.856 209.444 311.586 209.07C311.043 208.32 310.144 207.349 308.693 206.376C305.789 204.43 300.717 202.504 291.944 202.278C283.154 202.051 278.059 203.977 275.14 206.052C273.682 207.088 272.783 208.15 272.244 208.972C271.975 209.382 271.797 209.73 271.684 209.984C271.627 210.11 271.587 210.213 271.56 210.288C271.546 210.325 271.536 210.356 271.528 210.379L271.519 210.408L271.516 210.418L271.515 210.422L271.515 210.423C271.514 210.424 271.514 210.425 272.231 210.634L271.514 210.425L271.484 210.527V210.634V274.585C267.372 275.511 263.92 276.717 261.446 278.136C258.907 279.593 257.16 281.418 257.16 283.581C257.16 283.734 257.169 283.886 257.186 284.035H257.16V289.853C257.16 291.73 258.317 293.395 260.122 294.799C261.937 296.21 264.516 297.449 267.637 298.476C273.886 300.531 282.472 301.79 291.922 301.79C301.372 301.79 309.958 300.531 316.208 298.476C319.328 297.449 321.908 296.21 323.723 294.799C325.528 293.395 326.684 291.73 326.684 289.853V283.581V283.14H326.66C326.441 281.169 324.763 279.493 322.398 278.136C319.926 276.718 316.476 275.512 312.365 274.586V224.609L349.43 213.136L349.957 212.973V212.422V199.89ZM325.189 283.581C325.189 282.281 324.108 280.841 321.654 279.433C319.422 278.153 316.247 277.017 312.365 276.12V284.928V285.248L312.133 285.469L311.617 284.928C312.133 285.469 312.133 285.47 312.133 285.47L312.132 285.471L312.129 285.473L312.123 285.479L312.106 285.495L312.09 285.509L312.076 285.521L312.049 285.545C312.002 285.586 311.934 285.642 311.845 285.711C311.667 285.849 311.404 286.039 311.045 286.262C310.327 286.71 309.226 287.291 307.655 287.868C304.513 289.021 299.501 290.152 291.925 290.152C284.348 290.152 279.336 289.021 276.194 287.868C274.624 287.291 273.522 286.71 272.804 286.262C272.445 286.039 272.182 285.849 272.004 285.711C271.915 285.642 271.848 285.586 271.8 285.545C271.776 285.524 271.757 285.507 271.743 285.495L271.726 285.479L271.72 285.473L271.718 285.471L271.717 285.47C271.716 285.47 271.716 285.469 272.232 284.928L271.716 285.469L271.484 285.248V284.928V276.119C267.6 277.016 264.423 278.153 262.191 279.433C259.736 280.841 258.656 282.281 258.656 283.581C258.656 284.643 259.37 285.802 261.016 286.98C262.644 288.145 265.049 289.225 268.087 290.144C274.155 291.981 282.582 293.127 291.922 293.127C301.263 293.127 309.69 291.981 315.757 290.144C318.796 289.225 321.2 288.145 322.828 286.98C324.475 285.802 325.189 284.643 325.189 283.581ZM325.189 286.913C324.763 287.366 324.261 287.794 323.699 288.196C321.884 289.494 319.308 290.632 316.191 291.576C309.947 293.465 301.367 294.623 291.922 294.623C282.477 294.623 273.897 293.465 267.654 291.576C264.537 290.632 261.96 289.494 260.146 288.196C259.584 287.794 259.081 287.366 258.656 286.913V289.853C258.656 291.067 259.403 292.345 261.04 293.618C262.668 294.884 265.069 296.057 268.104 297.055C274.166 299.049 282.587 300.295 291.922 300.295C301.258 300.295 309.679 299.049 315.74 297.055C318.775 296.057 321.177 294.884 322.804 293.618C324.442 292.345 325.189 291.067 325.189 289.853V286.913ZM312.365 223.043L348.461 211.87V200.898L312.365 211.849V223.043ZM309.59 212.677L309.594 212.69L310.869 212.303V223.694C310.732 223.791 310.535 223.922 310.272 224.076C309.641 224.446 308.631 224.953 307.153 225.465C304.195 226.489 299.357 227.534 291.925 227.534C284.493 227.534 279.654 226.489 276.697 225.465C275.218 224.953 274.208 224.446 273.578 224.076C273.315 223.922 273.118 223.791 272.98 223.694V212.028C273.698 212.436 274.75 212.944 276.207 213.449C279.345 214.535 284.353 215.6 291.925 215.6C299.497 215.6 304.504 214.535 307.642 213.449C308.396 213.188 309.043 212.925 309.59 212.677ZM272.98 225.458V279.444C273.118 279.541 273.315 279.672 273.578 279.826C274.208 280.196 275.218 280.703 276.697 281.215C279.654 282.239 284.493 283.284 291.925 283.284C299.357 283.284 304.195 282.239 307.153 281.215C308.631 280.703 309.641 280.196 310.272 279.826C310.535 279.672 310.732 279.541 310.869 279.444V225.458C310.152 225.866 309.099 226.374 307.642 226.878C304.504 227.965 299.497 229.029 291.925 229.029C284.353 229.029 279.345 227.965 276.207 226.878C274.75 226.374 273.698 225.866 272.98 225.458ZM310.272 210.647C310.428 210.555 310.561 210.472 310.672 210.399C310.595 210.269 310.497 210.117 310.374 209.946C309.934 209.339 309.163 208.492 307.86 207.619C305.254 205.872 300.481 203.994 291.905 203.773C283.347 203.552 278.596 205.431 276.006 207.271C274.709 208.193 273.938 209.117 273.495 209.792C273.346 210.019 273.234 210.219 273.151 210.381C273.267 210.458 273.409 210.548 273.578 210.647C274.208 211.017 275.218 211.524 276.697 212.035C279.654 213.059 284.493 214.104 291.925 214.104C299.357 214.104 304.195 213.059 307.153 212.035C308.631 211.524 309.641 211.017 310.272 210.647ZM272.98 284.575V281.208C273.698 281.616 274.75 282.124 276.207 282.628C279.345 283.715 284.353 284.779 291.925 284.779C299.497 284.779 304.504 283.715 307.642 282.628C309.099 282.124 310.152 281.616 310.869 281.208V284.575C310.731 284.679 310.529 284.822 310.255 284.993C309.625 285.385 308.616 285.922 307.14 286.464C304.186 287.548 299.352 288.656 291.925 288.656C284.497 288.656 279.663 287.548 276.71 286.464C275.233 285.922 274.224 285.385 273.594 284.993C273.321 284.822 273.118 284.679 272.98 284.575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_378_73463",
                        x: "102.704",
                        y: "0.869857",
                        width: "262.475",
                        height: "387.392",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "5.98234"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "29.9117"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_378_73463"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_378_73463",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_d_378_73463",
                        x: "-33.1281",
                        y: "192.956",
                        width: "224.338",
                        height: "224.337",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "5.98234"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "29.9117"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_378_73463"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_378_73463",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter2_d_378_73463",
                        x: "198.157",
                        y: "146.862",
                        width: "210.127",
                        height: "220.223",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "5.98234"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "29.9117"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_378_73463"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_378_73463",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
const CaptureIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "84",
        height: "84",
        viewBox: "0 0 84 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "42",
                cy: "42",
                r: "35",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "42",
                cy: "42",
                r: "40.5",
                stroke: "white",
                strokeWidth: "3"
            })
        ]
    });
const InfoIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8865 20.02V18.148H24.3565V20.02H25.8865Z",
                fill: "#E6E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8865 31V21.694H24.3565V31H25.8865Z",
                fill: "#E6E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25 10C33.2843 10 40 16.7157 40 25C40 33.2843 33.2843 40 25 40C16.7157 40 10 33.2843 10 25C10 16.7157 16.7157 10 25 10ZM25 11C17.268 11 11 17.268 11 25C11 32.732 17.268 39 25 39C32.732 39 39 32.732 39 25C39 17.268 32.732 11 25 11Z",
                fill: "#E6E6E6"
            })
        ]
    });
const UploadIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_413_92298)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.3059 27.3381H32.08L28.7341 22.8622L25.5656 26.8447L23.5194 24.4231L21.3059 27.3381ZM17.7403 31.6347V13.75H35.625V31.6347H17.7403ZM18.7981 30.5769H34.5672V14.8078H18.7981V30.5769ZM14.375 35V17.8847H15.4328V33.9422H31.4903V35H14.375Z",
                    fill: "#E6E6E6"
                })
            })
        ]
    });
const GuideFaucet = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideFaucetsOverlay, {})
    });
const GuideValve = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideValveImage, {})
    });
const GuideSink = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideSinkImage, {})
    });
const GuideEmpty = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide"
    });

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/utils.js


const getGuide = (category, content)=>{
    const { faucetGuide , toiletGuide , volveGuide , sinkGuide , defaultGuide  } = content;
    switch(category === null || category === void 0 ? void 0 : category.toLowerCase()){
        case "faucets":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideFaucet, {}),
                text: faucetGuide
            };
        case "toilet":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideEmpty, {}),
                text: toiletGuide
            };
        case "valve":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideValve, {}),
                text: volveGuide
            };
        case "sinks":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideSink, {}),
                text: sinkGuide
            };
        case "shower":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideEmpty, {}),
                text: defaultGuide
            };
        default:
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideEmpty, {}),
                text: defaultGuide
            };
    }
};

// EXTERNAL MODULE: ./components/VisualSearch/analytics/index.js
var analytics = __webpack_require__(94529);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/index.jsx











const CameraView = (props)=>{
    const { setImage =()=>{} , back =()=>{} , category ="" , className ="" , setOpenCam =()=>{} , setSection =()=>{} , setOutput =()=>{} , setEventType =()=>{} , isUsingGlobalVS =false , hideCloseIcon =false  } = props;
    const [captureTrigger, setCaptureTrigger] = (0,react.useState)(false);
    const [showInfo, setShowInfo] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const data = (0,localization/* getTranslations */.F)(t);
    const { image , text  } = getGuide(category, data);
    let heic2any = null;
    (0,react.useEffect)(()=>{
        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23)).then((module)=>{
            heic2any = module.default;
        });
    }, []);
    const processImage = (input)=>{
        setImage(input);
        setOpenCam(false);
    };
    const handlesetResult = async (event)=>{
        if (event === null || event === void 0 ? void 0 : event.target) {
            var ref;
            const file = event.target.files[0];
            let convertFile = null;
            const heicType = [
                "image/heif",
                "image/heic",
                "heic",
                "heif"
            ];
            const fileType = (file === null || file === void 0 ? void 0 : file.type) ? file === null || file === void 0 ? void 0 : file.type : file === null || file === void 0 ? void 0 : (ref = file.name) === null || ref === void 0 ? void 0 : ref.split(".").at(-1);
            const isHeicimg = heicType.includes(fileType);
            if (isHeicimg) {
                var ref1;
                const res = await heic2any({
                    blob: file,
                    toType: "image/jpeg",
                    quality: 0.9
                });
                convertFile = new File([
                    res
                ], "".concat(file === null || file === void 0 ? void 0 : (ref1 = file.name) === null || ref1 === void 0 ? void 0 : ref1.split(".")[0], ".jpg"), {
                    type: res.type,
                    lastModified: new Date().getTime()
                });
            } else {
                convertFile = file;
            }
            if (convertFile) {
                const resp = await (0,utils/* validateImageFileAsync */.gW)(convertFile, heic2any);
                setEventType("browse");
                (0,analytics/* addDataLayerVisualSearch */.K)({
                    eventKey: "browse",
                    category: category,
                    eventStatus: "interaction"
                });
                if (resp) {
                    setImage(resp);
                } else {
                    setSection("error");
                }
            }
        }
    };
    return showInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraView_GuildePageMobile, {
        category: category,
        setShowInfo: setShowInfo,
        setSection: setSection,
        setOutput: setOutput,
        isUsingGlobalVS: isUsingGlobalVS
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((cameraview_module_default()).CameraView, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "back-button ".concat(hideCloseIcon && "hide-close-btn"),
                onClick: ()=>{
                    back();
                    setOpenCam(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraView_Camera, {
                handlerResult: processImage,
                captureTrigger: captureTrigger,
                setCaptureTrigger: setCaptureTrigger
            }),
            image,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "guide-text-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "".concat(isUsingGlobalVS && "globalvs-camera-text", " guide-text"),
                    children: text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(isUsingGlobalVS && "globalvs-camera-view-btns", " button-group"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: ()=>{
                            document.querySelector("#upload-input").click();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "upload-input",
                                className: "upload-input",
                                type: "file",
                                onChange: handlesetResult,
                                hidden: "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>{
                            setCaptureTrigger(true);
                            setEventType("capture");
                            (0,analytics/* addDataLayerVisualSearch */.K)({
                                eventKey: "capture",
                                category: category,
                                eventStatus: "interaction"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptureIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>setShowInfo(true),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_CameraView = (CameraView);


/***/ }),

/***/ 68552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getCategoryURL; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);

const getCategoryURL = (category)=>{
    var ref;
    const PRODUCT_FAQ_URL = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin) + _constants_index__WEBPACK_IMPORTED_MODULE_0__.HELP_AND_FAQ_SUPPORT;
    switch(category === null || category === void 0 ? void 0 : category.toLowerCase()){
        case "sink":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-sink-model");
        case "bath":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-bath-or-whirlpool-model");
        case "shower door":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-shower-door-model");
        case "toilet seat":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-toilet-seat-model");
        case "faucets":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-faucet-model");
        case "toilet":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-toilet-model");
        case "valve":
            return "".concat(PRODUCT_FAQ_URL, "/identify-a-single-control-bath-shower-valve");
        case "shower":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-shower-door-model");
        case "serviceParts":
            var ref1;
            return "".concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.origin, "/en/support/find-a-service-part");
    }
};


/***/ }),

/***/ 47796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var react_qr_code__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1653);
/* harmony import */ var _components_VisualSearch_v1_QRCode_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9527);
/* harmony import */ var _components_VisualSearch_v1_QRCode_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_VisualSearch_v1_QRCode_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_VisualSearch_localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89166);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _services_medallia__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8229);
/* harmony import */ var _components_InPageSearch_v1_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32223);









const QRCode = ()=>{
    const baseUrl = window.location.href;
    const currentUrl = "".concat(baseUrl, "#search");
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { QRCodeText , helpText , feedbackText  } = (0,_components_VisualSearch_localization__WEBPACK_IMPORTED_MODULE_5__/* .getTranslations */ .F)(t);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_VisualSearch_v1_QRCode_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().QRCodeWrapper)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "qr-feedback visualContentwarpper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "qr-section",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "qr-part",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_qr_code__WEBPACK_IMPORTED_MODULE_3__/* .QRCode */ .s_, {
                                size: 82.93,
                                value: currentUrl
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "photo_label",
                            children: QRCodeText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "provide-feedback",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "feedback",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: helpText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: "provide-feedback-button",
                                type: "ghost",
                                label: feedbackText,
                                size: "large",
                                flexible: true,
                                onClick: ()=>(0,_services_medallia__WEBPACK_IMPORTED_MODULE_7__/* .showMedalliaFeedbackModal */ .y0)(_components_InPageSearch_v1_utils__WEBPACK_IMPORTED_MODULE_8__/* .MEDALLIA_FORM_ID */ .K),
                                role: "button"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QRCode);


/***/ }),

/***/ 68637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K8": function() { return /* binding */ ACCEPTED_FORMATS; },
  "bG": function() { return /* binding */ IMAGE_FILE_TYPE; },
  "ZS": function() { return /* binding */ SERVICE_PARTS_SUB_CATEGORY_LIST; },
  "rK": function() { return /* binding */ imageList; }
});

;// CONCATENATED MODULE: ./public/images/parts/faucets/faucets_main.png
/* harmony default export */ var faucets_main = ({"src":"/_next/static/media/faucets_main.a2906f5f.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEWDgHt4dnG+u72moZ2cloyjnpbS0dealpOSj4nLytJ1eWOvpZuagWfEwsiaj4VQUyxqamq7sq5ZWDNYYkBGdm5iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImR3FURKAIAhAwYeCIJpa3f+uzbQ/izsghzRDBNKqhw5erWpu7PDQOXlW+D0Ke5Wr90b+tQ8srgGfZZbsTwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong1.png
/* harmony default export */ var wrong1 = ({"src":"/_next/static/media/wrong1.3a6dc656.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEWLdmK3qJ/88+5nTTeTfWrj2NDOwLb16+XRxb3BsqaomIprUTvt4djbz8S0ppe5q6CekoWGblvq2tDFubGiinVZPyptVT25oQAFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImSXBxwHAMAgEsLMBA+4t2X/UPCIBv4VS6C1ED+7NzLwYO/sJOTmijTlDqmjd+/BgOBJNdCeYRFWt7QNK2AIuzqUpAgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong2.png
/* harmony default export */ var wrong2 = ({"src":"/_next/static/media/wrong2.21d3c32c.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEWzqKK3r6vRycWak5A+PT2nm5W/ta/Kw78oKCiNhYLWzso0MzJHRkXGvrp1cG3l3NlCQUBkXVqBeXWix00nAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVQImR3GRxKAMAwAsY3jmgb8/7MM6CR8jFYF2F63XNLoMbNbhxLNsyZUaIa4/2nD4XzZGA+aBPYCOtYBj4Ed3WYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong3.png
/* harmony default export */ var wrong3 = ({"src":"/_next/static/media/wrong3.1ad2290c.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEUaGhoqKSsMDAzQy80iISEUFBTZxbrFrKC6ope0nJHOtam7ur2IdnOenJ40NDbPt62MjpGhjISen6Our7J4gm31AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImR3GSRLAIAwDMANZHPa2//9rB3QS4iCJoF8g/enVK8wsui1iv19rpQzkrIo0Ew5VkRtA5AdJMAGqrUbp6QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong1_mob.png
/* harmony default export */ var wrong1_mob = ({"src":"/_next/static/media/wrong1_mob.707bfc9a.png","height":189,"width":189,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEWrm42kk4SGbVeGe3CxoZXczsWMdF++r6JvVkDPwrrx5t7n29LHvbf37edyW0RlTTd7Y03UzMeTeGKRiYDVyb/Iu63+9/PszyTFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVQImQXBBwLAIAgAsXMg4Lbr/09tgpnNuWxRrhJ3jBuC56QlIKk7/RaGa0iqD0qGTOZttXttgozvnFHbD0g2AhpZpp/zAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong2_mob.png
/* harmony default export */ var wrong2_mob = ({"src":"/_next/static/media/wrong2_mob.3729874a.png","height":189,"width":189,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEWwpaFaUk6/tbCilI6ZjIU9PDzNxMCpmpS3r6zIv7y2q6apn5uPhYHo4t9tZmJ6dnPBuLR4cG3d1M/YzMZ+e3pLQj6EGsjDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImRXLRxLAMAgEsAWDAVec8v+vZqK7kJFRHQVdqne4QSh1RzMcYqU1gEGuz8UGeaGnmqAs0X03huHfc35HPQH7oVVplAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong3_mob.png
/* harmony default export */ var wrong3_mob = ({"src":"/_next/static/media/wrong3_mob.c61165b4.png","height":189,"width":189,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEUZGBg0NjirlIvGtbHKsaayl4wjJCS8o5iafnAREBB8b2vXx8K1qKaLfHp+cW1ERkhXVllWWFqihnmHPXtoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImTXGWw6AMAzEQCdsGlIehftfFrUSI38Y35ckIicRKQ9J+HacM5rZeB+7oKqK6iyN+5/+AThJAWjM6CPhAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/faucets_image_tab.png
/* harmony default export */ var faucets_image_tab = ({"src":"/_next/static/media/faucets_image_tab.e964b3f3.png","height":377,"width":446,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAQlBMVEWemZSHg36jn51oZUc9RydwbmuSjobPztXHxcminJibhW6zq6WZlY95emt+gmuqpaBsbFGlkX6pmYq5uLxeZUS5s7XvyHQUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImQXBBwLAIAgAsRMRwd31/682YVmkWUrhrB2WDPLcMKSjrzCi3WgmcbWO5pDHvaLnc/dafzVCAbopn1HkAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/images/parts/faucets/faucet_mask_group.png
/* harmony default export */ var faucet_mask_group = ({"src":"/_next/static/media/faucet_mask_group.f66d782b.png","height":612,"width":612,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEWmoZ3PztXBvsK3s7KinZmppaJCTCibmJOIhX7Ix86FhHBpbFO1p5ymmo94dXBramiPfWKlkXqSjINvdlmAdltJUS+FgXfQ/Ty1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVQImRXFxxHAIBAAsQUukQxO/bfqsT6iucRxrEUP8IiL3hTBlfcGRybWxX2eG9saWsbAnlJyrQlr+T99SoEB7zr7SgQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_main1.png
/* harmony default export */ var toilet_main1 = ({"src":"/_next/static/media/toilet_main1.ef8a6960.png","height":612,"width":612,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVSRDSMfm9LPi0uIhbPzMobDgaCfXhkV0pZSzxIOCiAd2yyr66Vjoe5t7N5c22mop9yXky/tqzLvrGhh2yOiIKqpJs/LSGjmIvV1NOCaU6hmpSwlXq+o4fd463YAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImQXBBwKAIAwEsAMKbdnDrf9/pwneSXOPIvjWQylAsO58lQAg9kiULTAMh7RZi3EyV1YHA61NnEfXoxX2/gdolAKiIAY8lgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_wrong1.png
/* harmony default export */ var toilet_wrong1 = ({"src":"/_next/static/media/toilet_wrong1.2b736f62.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEWMhny9s6JVUEuipKZ+d2lMRjxvaWLi18FjYFvNw7I/OjPRyr/Vz8e5s6q1r6eEfnSwqp+Yk4ugmo98b1utpJSXl5jq3spbWFK0sbCjnpE1MSw1p8+DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBhwGAMAwDMHcm6d4F/j8UCeZJKcYBbJScSwU299Y6V5jr18vawugr4p0FwjhHBQv9KSJxEz4sIuXmD2cLArILr5VoAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_wrong2.png
/* harmony default export */ var toilet_wrong2 = ({"src":"/_next/static/media/toilet_wrong2.5f82926c.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEU2KBuxoYuaindIOSy2p5CtnIddTTq9rpVyYkylk3zDtqBVRjWPf2yIeGb56tqBcl4iFw3t3s7bzb1rWEFBUgGeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVQImR3GRw7AIAwEwMW420DK//8aKXMauL9apYrmoBA78F4hbI55OoaZA2sE/5kkmWMCUOJkAXDVc+/9AUTPAdc7dNsnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_wrong3.png
/* harmony default export */ var toilet_wrong3 = ({"src":"/_next/static/media/toilet_wrong3.d1010512.png","height":189,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEVTRDNpYVeQgXGroJZkV0VKOiteUUFuYE9YSzqCcGLV0s05KBsjFgqFfnagkYG/t6qGeGS2s63Jwbk1KRt0XUt+aFaTjomalI2TkHezmoCBaE5lTDSwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImR3GSRLAIAgEwEFFwF2z5/8PTVX61JCAOO6VIEGj639Acz4eUdnS9TYocFYZHroVIrgOLtlXSEPm3dlh9gFWQAJhdzKsAgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet-wrong-mob1.png
/* harmony default export */ var toilet_wrong_mob1 = ({"src":"/_next/static/media/toilet-wrong-mob1.6de26823.png","height":189,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEWvqZ/l2820raOjnpOwsLOppJtVUk7Ewb7Dv7bAvLNJRkF6eHOPioLg18heW1WMiH9mY1zAuKplZWKWkIUbwLE+AAAACnRSTlP+////8///8/Pzq9eSRAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD5JREFUCJkVxlkSgCAMBcEJ8YVdQO9/V8v+aq6cS60FkpnZnInuksTiGQLUiS4S4ybu5f7uINo+x9sfbNpoHzntAcm4/zXjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet-wrong-mob2.png
/* harmony default export */ var toilet_wrong_mob2 = ({"src":"/_next/static/media/toilet-wrong-mob2.be9d09ef.png","height":189,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEWkk3ypmISZiXJKOy2fj3uSgmxvYVGunYpBMCK3ppN+bVlZSjyEdGPbzLfIuqMn4HcRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImSXGtwHAMAwEseMzKXr/cVUYFaiVkgTr3m8asNukVOD7VGWA7ypPDB9nxp81m2jG8DCzfjAAAUmmuQWJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_Ideal_Tab1.png
/* harmony default export */ var toilet_Ideal_Tab1 = ({"src":"/_next/static/media/toilet_Ideal_Tab1.47f8ffdd.png","height":463,"width":463,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEVOPy/Fu7ByXUlURTdDNCTQzswmGQ6oo59YSTl5cWmJgXmysKxhVER7d3O2tLFiWlCEcF6Mfm+Ti4EWCgMUCQTEw8K3m3/Dp4qeg2i5sKWLbxGrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImQXBBwLAIAgEsBNBwK3d//9oE9xBgroZnqlSHIaXVLojYlG+JAMIazR1Br5dR6ucMJm3Ih0gxF4snT9QrwJDLT3TmwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/sink/sink_mask_group.png
/* harmony default export */ var sink_mask_group = ({"src":"/_next/static/media/sink_mask_group.aaa19bf1.png","height":2448,"width":2448,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEXMysfCv7ybl5LU0tDc2tmzr6uDfXO9u7e4trJ5ZFSTj4ioo52RemmFcGDk4uBbRjh158PGAAAACXBIWXMAACxLAAAsSwGlPZapAAAAOUlEQVQImSXIyRHAMAgAscWAAZ/9d5tJoqcIQYTojPYanRbpKbNjZqqKc8QlMuDon0w+zq3ae616ACcMAUAfKbmmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/sink/sink_main.png
/* harmony default export */ var sink_main = ({"src":"/_next/static/media/sink_main.e1078ed3.png","height":612,"width":612,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEXQzs2Eem63tbGPfnHLycbGxMHY19XAvbqxrqqcmJKhnZeopaF+alqVkYvi4d5aRjh0YVOpNvQeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVQImR3BARLAIAgDsKpAC6jb/1+7uyUgzWlcOJmZdQZyTok9EDB3n8JVSd3ENUYAgcJPeN69x1r7AzuEAZ3HwRE7AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/sink/sink_wrong1.png
/* harmony default export */ var sink_wrong1 = ({"src":"/_next/static/media/sink_wrong1.4700df9a.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEXY1dDBvrjq5d/28/Ghn5y5t7Gwrabe2tbi3try7ehSUUnNzMdoaV/JxLp0c2/VzsOOkYA5QyOTlYCfoos8Riebl45cMtRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVQImQXBhQHAIBAAsQNesfr+qzbBjkLLrHjUZN0Pkb6+/l6Ymsw9T0SsiCh4ZGvhgQ4PwOl9q5bBD0hjAd3YkMoEAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/sink/sink_wrong2.png
/* harmony default export */ var sink_wrong2 = ({"src":"/_next/static/media/sink_wrong2.d0f37c4d.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEWEhH6bm5N+fniNjIV4eHBsa2Ogn5livudpAAAAAnRSTlP9/o2EjdMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAwSURBVAiZLcq5DYAAEMRA73f9l4xAOJrAkCR3x9Y1Du1LB50khW8JHditXYANG/89HU0AtvsEltcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/sink/sink_wrong3.png
/* harmony default export */ var sink_wrong3 = ({"src":"/_next/static/media/sink_wrong3.12452805.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEWXmJOkpaTe3N64t7aHhodubGt3d3VMUErLzdOjop6am5bHxcN3g4FxcXBlZWJcYF6Fjo+anp+roJ/OzdKOlpZqdnW9vsJrYlteUU1MW1itr7DaHwajAAAACnRSTlP1////9f//9fr6Kf318QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAENJREFUCJkFwQcCwCAIBLBDCyo4q3b9/6FNgKSkZB7Jj96KM4BWzjtXhHeLrvsBvmjOnQlxzsvT6DiEmVkKQqssIvwDXPQCjlZCHIAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_main.png
/* harmony default export */ var valve_main = ({"src":"/_next/static/media/valve_main.bd08bb89.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAASFBMVEXRxsDX1NSCgH5waWGroJaPhXvEubHUy8fHvbh5c2xMR0K8sKiJiYiBeHDOwbRlX1uCcGBkY19DOC/b085VVVOYkYgeGha0qqGj6ewyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImQXBhwGAIBAAsQO+Uuy6/6gmlHKDQwnNOhxfddY0JOfTTkWO/bt6w1R7W4KPt6ds4GGB/TN3AbZR7sv+AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_wrong1.png
/* harmony default export */ var valve_wrong1 = ({"src":"/_next/static/media/valve_wrong1.d97d1d32.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVxaWG/sqtHRUB/eXSdk4rEvbleVkzn1s3h0ciHgn25sq15c2xnYltSSUCVh3rZyb+/rp7VwraMeWuEc2etpJ2rpJ43MClBFg7KuKuMak5iRTiljnRiLiNwruYiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBBwLAIAgEsBNRwG33+v87m0B6sswqEBe4YFNo2LmtFqDWkBckXKBYAI/xnBRj9Xjvj45qijFnd07lB1OVAoL4dkTNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_wrong2.png
/* harmony default export */ var valve_wrong2 = ({"src":"/_next/static/media/valve_wrong2.81ba2886.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEUcGxYCAgFqY10MCwgUDwspIhtgJydzamNaUUpjWlJ+cmtlST1SRTsxLCh+ZFpsVUlCPTaSZl+Ti4VtXlA9MSQ941H4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVQImQXBCQLAIAgDsKJAwdtt/3/rEtgphZyGEwIFDRR1FxSE7nu9JtLeb7sEOJJLZwBPWz1bhSH7CMUPQHAB5pnYWR0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_wrong3.png
/* harmony default export */ var valve_wrong3 = ({"src":"/_next/static/media/valve_wrong3.0794860c.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEXKspKzmnzErY2VfV+6ooO/poesk3Y9MB1WRTFlVT+kimxxYEUqIhWKb1B4YEWv/QdPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImR3GSRLAMAgDQYEkwM7y/+emnMv0AAAy/9ryOZvDTKTYfYWhPX2vEPi8a1gCuSsiEnUI4QMgeQECwR5YvQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_Ideal_Tab.png
/* harmony default export */ var valve_Ideal_Tab = ({"src":"/_next/static/media/valve_Ideal_Tab.d590f763.png","height":1224,"width":1227,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEXDuK6flY2Tj4uEfniupJylnJKioZ3OxL9mZGHVzMiPhX7Z1dbKv7e4sKiqrK52dHOai35cVU43uUesAAAACXBIWXMAABJ0AAASdAHeZh94AAAAO0lEQVQImQXBiQGAIAwAsaP0B0T3X9aEtRhyKlh6RaYVu5/HvEHbb3Ya+o78Zg7CjkwXqK0znU1UQAQ/QQ0BrldtlY4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_main.png
/* harmony default export */ var shower_main = ({"src":"/_next/static/media/shower_main.1c97b122.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEW8s6WNhXiSj4hXWFdDREHCu7Ock4StqKG+uK51b2lsaGGXjoK4sqqnn5GBhIU8MzB/e3VVTEY6NzReX1pFq58XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVQImRXFRxLAIAwEsHUBF0xL/v/XTHQRAHf3BoBzVQNYVNgx8z0rDF1U9T/3s0+hU9ywwqBB0+wDMBYBsMRuKecAAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_wrong1.png
/* harmony default export */ var shower_wrong1 = ({"src":"/_next/static/media/shower_wrong1.d03d8144.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEV3alxuYlZ6eHFWRTRlY2F/a1pqW0yJdWNaUkhzYVCGhYGRgHBaXV02IxGPoKp/i5BraGVweHw7LBuWFvRyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVQImRXGRxLAIAwAsTXuQOr/H5uJTqLJ9FxJh4uNdLq69jAIDeZpSnqJXXUAYnv8kbifWS/QuWbpBzebAaBNdsc1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_wrong2.png
/* harmony default export */ var shower_wrong2 = ({"src":"/_next/static/media/shower_wrong2.06c698b7.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVzYk9yZlkODQw3LiWdiXRRRjpkUT5EOTCDeW12bF+MdmIiIB5HaHCQiYCJgHK9qpVcZ2K2m4RbeYGBj4/Bs6SckIKghWVaUUl9a1dAanhui5JeW04tGxlFSEtCWmWDhH2mn5RWmrBnZlyuskwNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImQXBhQHAMAwDMBdT5jH//+QkRHPdvfUXiU5b2/dg4bAljQgvVraHOuBJq/mQGYprVVie4ATpDdJAOlCANT+J+QMyp4Tq+AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_wrong3.png
/* harmony default export */ var shower_wrong3 = ({"src":"/_next/static/media/shower_wrong3.230c11a7.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEWqqa6enJqHiIuHgX+9vsZlW1S3uMGRj45sVUCDe3GfoKR/cmSZl5KtsbV6d3JBSFJaTUNTSkRHPjZvamXGxs1RU1omKjCLl5p5aFg8Ya15AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImRXJSQ7AIAwEsAECWUige/v/l1bcLBkjW4S74mRYDu6ojDnf8eFg3I+qYGe04kVW0ZW6oGZQW9iKUUsqP1eQAi5KsaiKAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/constant.js






























const imageList = {
    faucetmainImage: faucets_main,
    faucetWrong1: wrong1,
    faucetWrong2: wrong2,
    faucetWrong3: wrong3,
    faucetWrong1Mob: wrong1_mob,
    faucetWrong2Mob: wrong2_mob,
    faucetWrong3Mob: wrong3_mob,
    faucetmainImageTab: faucets_image_tab,
    faucetmainImageMobile: faucet_mask_group,
    toiletmainImage: toilet_main1,
    toiletWrong1: toilet_wrong1,
    toiletWrong2: toilet_wrong2,
    toiletWrong3: toilet_wrong3,
    toiletWrongMob1: toilet_wrong_mob1,
    toiletWrongMob2: toilet_wrong_mob2,
    toiletmainImageTab: toilet_Ideal_Tab1,
    valvemainImage: valve_main,
    valveWrong1: valve_wrong1,
    valveWrong2: valve_wrong2,
    valveWrong3: valve_wrong3,
    valvemainImageTab: valve_Ideal_Tab,
    showermainImage: shower_main,
    showerWrong1: shower_wrong1,
    showerWrong2: shower_wrong2,
    showerWrong3: shower_wrong3,
    sinkmainImageTab: sink_mask_group,
    sinkmainImage: sink_main,
    sinkWrong1: sink_wrong1,
    sinkWrong2: sink_wrong2,
    sinkWrong3: sink_wrong3
};
const IMAGE_FILE_TYPE = "image/jpeg, image/png, image/heic, image/heif,  image/bmp";
const ACCEPTED_FORMATS = {
    "image/png": [
        ".png"
    ],
    "image/jpeg": [
        ".jpeg",
        ".jpg"
    ],
    "image/bmp": [
        ".bmp"
    ],
    "image/heic": [
        ".heic"
    ],
    "image/heif": [
        ".heif"
    ]
};
const SERVICE_PARTS_SUB_CATEGORY_LIST = [
    "servicepart-faucet",
    "servicepart-toilet",
    "servicepart-shower"
];


/***/ }),

/***/ 26355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_UploadImage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/VisualSearch/v1/UploadImage/uploadImage.module.scss
var uploadImage_module = __webpack_require__(948);
var uploadImage_module_default = /*#__PURE__*/__webpack_require__.n(uploadImage_module);
// EXTERNAL MODULE: ./components/GlobalVisualSearch/UploadImageForGlobalVS/index.module.scss
var index_module = __webpack_require__(2843);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
// EXTERNAL MODULE: ./components/VisualSearch/v1/QRCode/index.jsx
var QRCode = __webpack_require__(47796);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(12002);
// EXTERNAL MODULE: ./components/VisualSearch/localization.js
var localization = __webpack_require__(89166);
// EXTERNAL MODULE: ./components/VisualSearch/v1/UploadImage/constant.js + 30 modules
var constant = __webpack_require__(68637);
// EXTERNAL MODULE: ./components/VisualSearch/analytics/index.js
var analytics = __webpack_require__(94529);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/FileUpload.view.jsx








const FileUpload = (props)=>{
    const { setImage =()=>{} , setSection , setEventType =()=>{} , category  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const device = (0,useViewport/* default */.Z)();
    const { borwseBtn , imageUploadtext , changeProduct , imageUploadSubText  } = (0,localization/* getTranslations */.F)(t);
    let heic2any = null;
    (0,react.useEffect)(()=>{
        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23)).then((module)=>{
            heic2any = module.default;
        });
    }, []);
    const onDrop = (0,react.useCallback)((acceptedFiles)=>{
        let file = acceptedFiles[0];
        const heicType = [
            "image/heif",
            "image/heic"
        ];
        const isHeicimg = heicType.includes(file === null || file === void 0 ? void 0 : file.type);
        if (isHeicimg) {
            heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.9
            }).then((res)=>{
                file = new File([
                    res
                ], file.name, {
                    type: res.type,
                    lastModified: new Date().getTime()
                });
                if (file) {
                    reader.readAsDataURL(file);
                }
            });
        }
        const reader = new FileReader();
        reader.onload = (event)=>{
            const img = new Image();
            img.onload = ()=>{
                setImage({
                    file,
                    width: img.width,
                    height: img.height
                });
            };
            img.src = event.target.result;
        };
        if (!isHeicimg && file) {
            reader.readAsDataURL(file);
        }
    }, []);
    const { getRootProps , getInputProps , isDragActive  } = (0,es/* useDropzone */.uI)({
        onDrop
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !(device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "file-upload ".concat(isDragActive ? "drag-container" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "drag-wrapper",
                onDrop: ()=>{
                    setEventType("drag an image here");
                    (0,analytics/* addDataLayerVisualSearch */.K)({
                        eventKey: "drag an image here",
                        category: category,
                        eventStatus: "interaction"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ...getRootProps(),
                        className: "file-upload-dropzone" + (isDragActive ? " drag" : ""),
                        children: isDragActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "title-hover",
                            children: imageUploadtext
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "title",
                                    children: imageUploadtext
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "seperator",
                                    children: imageUploadSubText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "browse",
                                    onClick: ()=>{
                                        setEventType("browse");
                                        (0,analytics/* addDataLayerVisualSearch */.K)({
                                            eventKey: "browse",
                                            category: category,
                                            eventStatus: "interaction"
                                        });
                                    },
                                    children: borwseBtn
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ...getInputProps(),
                                    accept: constant/* IMAGE_FILE_TYPE */.bG,
                                    "aria-label": "Input Images"
                                })
                            ]
                        })
                    }),
                    !isDragActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product_change",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "change-button",
                            onClick: ()=>{
                                setSection("category");
                                (0,analytics/* addDataLayerVisualSearch */.K)({
                                    eventKey: "change product",
                                    category: category
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: changeProduct
                            })
                        })
                    }) : null
                ]
            })
        }) : null
    });
};
/* harmony default export */ var FileUpload_view = (FileUpload);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/icons.js

const CorrectIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "20",
                transform: "matrix(1 0 0 -1 0 40)",
                fill: "#4A9232"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.3778 12L29.3307 12.8741L18.1272 26.6667L10.6641 20.3326L11.4366 19.3022L17.9531 24.8337L28.3778 12Z",
                fill: "white"
            })
        ]
    });
};
const IncorrectIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                transform: "matrix(1 0 0 -1 0 30)",
                fill: "#D10000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.7043 10L19.8599 19.2857L19.1556 20L10 10.7143L10.7043 10Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2957 10L10.1401 19.2857L10.8444 20L20 10.7143L19.2957 10Z",
                fill: "white"
            })
        ]
    });
};
const CloseIconGuide = ()=>/*#__PURE__*/ _jsx("svg", {
        className: "close-big",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.5015 15.4996L28.9365 2.06453L28.2294 1.35742L14.7944 14.7924L2.06648 2.06453L1.35938 2.77164L14.0873 15.4996L1.35938 28.2275L2.06648 28.9346L14.7944 16.2067L28.2294 29.6417L28.9365 28.9346L15.5015 15.4996Z",
            fill: "white"
        })
    });
const CloseIconGuideNew = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "close-big",
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79083 15.0009L0.366211 22.4255L1.07332 23.1326L8.49794 15.708L15.9226 23.1326L16.6297 22.4255L9.20505 15.0009L16.6297 7.57625L15.9226 6.86914L8.49794 14.2938L1.07332 6.86914L0.366211 7.57625L7.79083 15.0009Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79083 15.0009L0.366211 22.4255L1.07332 23.1326L8.49794 15.708L15.9226 23.1326L16.6297 22.4255L9.20505 15.0009L16.6297 7.57625L15.9226 6.86914L8.49794 14.2938L1.07332 6.86914L0.366211 7.57625L7.79083 15.0009Z",
                fill: "#212121"
            })
        ]
    });
const CloseIconVSGuideNew = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "close-vs-big",
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79083 15.0009L0.366211 22.4255L1.07332 23.1326L8.49794 15.708L15.9226 23.1326L16.6297 22.4255L9.20505 15.0009L16.6297 7.57625L15.9226 6.86914L8.49794 14.2938L1.07332 6.86914L0.366211 7.57625L7.79083 15.0009Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79083 15.0009L0.366211 22.4255L1.07332 23.1326L8.49794 15.708L15.9226 23.1326L16.6297 22.4255L9.20505 15.0009L16.6297 7.57625L15.9226 6.86914L8.49794 14.2938L1.07332 6.86914L0.366211 7.57625L7.79083 15.0009Z",
                fill: "white"
            })
        ]
    });
const BackIconGVSGuide = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "back_icon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "30",
        viewBox: "0 0 25 30",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.911 14.5L9.5 6.95L8.7963 6.25L0 15L8.7963 23.75L9.5 23.05L1.91099 15.5H25V14.5H1.911Z",
            fill: "#212121"
        })
    });
const BackIconGuide = ()=>/*#__PURE__*/ _jsx("svg", {
        className: "back_icon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "30",
        viewBox: "0 0 25 30",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.911 14.5L9.5 6.95L8.7963 6.25L0 15L8.7963 23.75L9.5 23.05L1.91099 15.5H25V14.5H1.911Z",
            fill: "white"
        })
    });
const BackIconMobGuide = ()=>/*#__PURE__*/ _jsx("svg", {
        className: "back_icon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "30",
        viewBox: "0 0 25 30",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.911 14.5L9.5 6.95L8.7963 6.25L0 15L8.7963 23.75L9.5 23.05L1.91099 15.5H25V14.5H1.911Z",
            fill: "#212121"
        })
    });
const CloseIconGuideMob = ()=>/*#__PURE__*/ _jsx("svg", {
        className: "close_small",
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("g", {
            id: "close/medium",
            children: /*#__PURE__*/ _jsxs("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        stroke: "white",
                        strokeWidth: "0.5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        stroke: "white",
                        strokeWidth: "0.5"
                    })
                ]
            })
        })
    });
const CloseIconGuideMobNew = ()=>/*#__PURE__*/ _jsxs("svg", {
        className: "close_small",
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.79083 15.0009L0.366211 22.4255L1.07332 23.1326L8.49794 15.708L15.9226 23.1326L16.6297 22.4255L9.20505 15.0009L16.6297 7.57625L15.9226 6.86914L8.49794 14.2938L1.07332 6.86914L0.366211 7.57625L7.79083 15.0009Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.79083 15.0009L0.366211 22.4255L1.07332 23.1326L8.49794 15.708L15.9226 23.1326L16.6297 22.4255L9.20505 15.0009L16.6297 7.57625L15.9226 6.86914L8.49794 14.2938L1.07332 6.86914L0.366211 7.57625L7.79083 15.0009Z",
                fill: "#212121"
            })
        ]
    });
const CorrectIconMob = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                transform: "matrix(1 0 0 -1 0 30)",
                fill: "#4A9232"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.2853 9L22 9.65557L13.5973 20L8 15.2495L8.57941 14.4766L13.4668 18.6253L21.2853 9Z",
                fill: "white"
            })
        ]
    });

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/utils.js

const { faucetmainImage , faucetWrong1 , faucetWrong2 , faucetWrong3 , faucetWrong1Mob , faucetWrong2Mob , faucetWrong3Mob , faucetmainImageTab , faucetmainImageMobile , toiletmainImage , toiletWrong1 , toiletWrong2 , toiletWrong3 , toiletWrongMob1 , toiletWrongMob2 , toiletmainImageTab , valvemainImage , valveWrong1 , valveWrong2 , valveWrong3 , valvemainImageTab , showermainImage , showerWrong1 , showerWrong2 , showerWrong3 , sinkmainImageTab , sinkmainImage , sinkWrong1 , sinkWrong2 , sinkWrong3  } = constant/* imageList */.rK;
const getImageCategory = (value, text, device)=>{
    const imageForFaucet = (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetmainImageMobile : faucetmainImageTab;
    const defaultItems = {
        idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? faucetmainImage : imageForFaucet,
        badAngle: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetWrong1Mob : faucetWrong1,
        tooClose: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetWrong2Mob : faucetWrong2,
        tooFar: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetWrong3Mob : faucetWrong3
    };
    const { toiletPhotoText , sinkPhotoText  } = text;
    switch(value){
        case "faucets":
            return defaultItems;
        case "toilet":
            return {
                idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? toiletmainImage : toiletmainImageTab,
                badAngle: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? toiletWrongMob1 : toiletWrong1,
                tooClose: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? toiletWrongMob2 : toiletWrong2,
                tooFar: toiletWrong3,
                text: toiletPhotoText
            };
        case "sinks":
            return {
                idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? sinkmainImage : sinkmainImageTab,
                badAngle: sinkWrong1,
                tooClose: sinkWrong2,
                tooFar: sinkWrong3,
                text: sinkPhotoText
            };
        case "valve":
            return {
                idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? valvemainImage : valvemainImageTab,
                badAngle: valveWrong1,
                tooClose: valveWrong2,
                tooFar: valveWrong3
            };
        case "shower":
            return {
                idealImage: showermainImage,
                badAngle: showerWrong1,
                tooClose: showerWrong2,
                tooFar: showerWrong3
            };
        default:
            return defaultItems;
    }
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/UploadImageSection.view.jsx









const UploadImageSection = (props)=>{
    const { category , setOutput  } = props;
    const device = (0,useViewport/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { photoText , toFar , toClose , wrongAngle , imageShould , servicePartInsrtuction1 , servicePartInsrtuction2 , servicePartInsrtuction3 , forFurtherHelp , contactSupport  } = (0,localization/* getTranslations */.F)(t);
    const translationText = (0,localization/* getTranslations */.F)(t);
    const [idealImg, setIdeal] = (0,react.useState)({
        idealImage: null,
        badAngle: null,
        tooClose: null,
        tooFar: null,
        text: photoText
    });
    const { idealImage , badAngle , tooClose , tooFar , text  } = idealImg;
    (0,react.useEffect)(()=>{
        setOutput(null);
        if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
            const timer = setTimeout(()=>{
                const elements = document.getElementsByTagName("mavenoid-assistant");
                if (elements.length > 0) {
                    document.querySelector("mavenoid-assistant").style.display = "none";
                }
            }, 100);
            return ()=>{
                document.querySelector("mavenoid-assistant").style.display = "block";
                clearTimeout(timer);
            };
        }
    }, []);
    (0,react.useEffect)(()=>{
        const selectedCategory = category === null || category === void 0 ? void 0 : category.toLowerCase();
        if (selectedCategory) {
            const selectedCategoryImg = getImageCategory(selectedCategory, translationText, device);
            setIdeal((prevstate)=>{
                return {
                    ...prevstate,
                    ...selectedCategoryImg
                };
            });
        }
    }, [
        category,
        device
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !constant/* SERVICE_PARTS_SUB_CATEGORY_LIST.includes */.ZS.includes(category) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "main-image-container position-relative ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "corret-image-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "correct-image",
                                src: idealImage === null || idealImage === void 0 ? void 0 : idealImage.src,
                                alt: "Ideal Angle"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "indicator-icon",
                            children: (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIconMob, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "image-caption",
                            children: text
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "outer-wrapper-wrongImage",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrong-image-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "Bad Angle",
                                    className: "incorrect-image",
                                    src: badAngle === null || badAngle === void 0 ? void 0 : badAngle.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "indicator-wrong-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "image-caption",
                                    children: wrongAngle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrong-image-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "Too Close",
                                    className: "incorrect-image",
                                    src: tooClose === null || tooClose === void 0 ? void 0 : tooClose.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "indicator-wrong-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "image-caption",
                                    children: toClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrong-image-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "Too Far",
                                    className: "incorrect-image",
                                    src: tooFar === null || tooFar === void 0 ? void 0 : tooFar.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "indicator-wrong-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "image-caption",
                                    children: toFar
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "main-image-container position-relative ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-instructions-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-title",
                        children: [
                            imageShould,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex image-instructions-points",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex image-instructions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIconMob, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIcon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-caption mt-0",
                                        children: servicePartInsrtuction1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex image-instructions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIconMob, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIcon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-caption mt-0",
                                        children: servicePartInsrtuction2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex image-instructions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIconMob, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIcon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-caption mt-0",
                                        children: servicePartInsrtuction3
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-instruction-support",
                        children: [
                            forFurtherHelp,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "#",
                                children: contactSupport
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var UploadImageSection_view = (UploadImageSection);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/index.jsx











const UploadImage = (props)=>{
    const { setImage =()=>{} , category , setShowInfo , setSection , setEventType =()=>{} , setOutput , isUsingGlobalVS =false  } = props;
    const device = (0,useViewport/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { photoGuidelineText  } = (0,localization/* getTranslations */.F)(t);
    const Style = isUsingGlobalVS ? (index_module_default()) : (uploadImage_module_default());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: Style.UploadImageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "outer-wrapper position-relative visualContentwarpper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUpload_view, {
                            setImage: setImage,
                            setSection: setSection,
                            setEventType: setEventType,
                            category: category
                        }),
                        (device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-wrapper ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "close-container d-flex align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "close-Icon",
                                        onClick: ()=>setShowInfo(false),
                                        tabIndex: "0",
                                        role: "button",
                                        children: isUsingGlobalVS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIconGVSGuide, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconVSGuideNew, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "guide-photo d-flex align-items-center justify-content-center flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: photoGuidelineText
                                        })
                                    }),
                                    !isUsingGlobalVS ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "close-Icon",
                                        onClick: ()=>setShowInfo ? setShowInfo(false) : setSection("category"),
                                        tabIndex: "0",
                                        role: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGuideNew, {})
                                    }) : null
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "how-it-works ".concat(category === "serviceParts" && "justify-content-start align-items-start pt-50 m-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImageSection_view, {
                                category: category,
                                setOutput: setOutput
                            })
                        })
                    ]
                })
            }),
            !(device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode/* default */.Z, {}) : null
        ]
    });
};
/* harmony default export */ var v1_UploadImage = (UploadImage);


/***/ }),

/***/ 10068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bo": function() { return /* binding */ dataUrlToFile; },
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "J7": function() { return /* binding */ getPartsPricebySku; },
/* harmony export */   "MG": function() { return /* binding */ viewPdp; },
/* harmony export */   "SY": function() { return /* binding */ getServiceParts; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "aS": function() { return /* binding */ getPrice; },
/* harmony export */   "cR": function() { return /* binding */ getValidCategory; },
/* harmony export */   "fg": function() { return /* binding */ cropCanvas; },
/* harmony export */   "gW": function() { return /* binding */ validateImageFileAsync; },
/* harmony export */   "hU": function() { return /* binding */ isImageUrl; },
/* harmony export */   "i2": function() { return /* binding */ getDetailSku; },
/* harmony export */   "lw": function() { return /* binding */ getPersonaPriceListDetail; },
/* harmony export */   "rr": function() { return /* binding */ getScrollTo; }
/* harmony export */ });
/* unused harmony exports getCroppedImg, getPartsFileMap, checkImageUrl */
/* harmony import */ var _services_ct_service_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13875);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/**
 * Converts data url to file object
 * @param {String} dataUrl Dataurl text
 * @param {String} fileName FileName
 * @return {File|null} File Object
 */ 


/**
 *
 * @param {*} dataUrl
 * @param {*} fileName
 * @return {File}
 */ async function dataUrlToFile(dataUrl, fileName) {
    if (dataUrl) {
        const res = await fetch(dataUrl);
        const blob = await res.blob();
        return new File([
            blob
        ], fileName, {
            type: "image/png"
        });
    }
    return null;
}
/**
 * Crops canvas and return new canvas
 * @param {Canvas} sourceCanvas Canvas to be cropped
 * @param {Number} left left coordinate
 * @param {Number} top top coordinate
 * @param {Number} width Width of crop
 * @param {Number} height Height of the crop
 * @return {Canvas} Canvas
 */ const cropCanvas = (sourceCanvas, left, top, width, height)=>{
    const destCanvas = document.createElement("canvas");
    destCanvas.width = width;
    destCanvas.height = height;
    destCanvas.getContext("2d").drawImage(sourceCanvas, left, top, width, height, 0, 0, width, height);
    return destCanvas;
};
/**
 * Converts to cropped image
 * @param {Image} image
 * @param {Object} crop
 * @param {String} fileName
 * @param {String} type
 * @return {File}
 */ function getCroppedImg(image, crop, fileName, type) {
    const canvas = document.createElement("canvas");
    const scaleX = (image === null || image === void 0 ? void 0 : image.naturalWidth) ? image.naturalWidth / image.width : 1;
    const scaleY = (image === null || image === void 0 ? void 0 : image.naturalHeight) ? image.naturalHeight / image.height : 1;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    const base64Image = canvas.toDataURL(type);
    return dataUrlToFile(base64Image, fileName);
}
const debounce = (func, debounceTime)=>{
    let debounce = true;
    return ()=>{
        if (debounce) {
            debounce = false;
            setTimeout(()=>{
                func();
                debounce = true;
            }, debounceTime);
        }
    };
};
const promiseImageFileReader = (imageFile)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = (e)=>{
            resolve({
                result: e.target.result,
                readerResult: reader.result
            });
        };
        reader.onerror = (e)=>{
            reject(e);
        };
        reader.readAsDataURL(imageFile);
    });
};
const promiseImageReader = (source)=>{
    return new Promise((resolve, reject)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(image);
        };
        image.onerror = (e)=>{
            reject(e);
        };
        image.src = source;
    });
};
const imageExtentionCheck = (imageFile)=>{
    var ref, ref1;
    if (imageFile && ((ref1 = (ref = imageFile.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.match(/\.(jpg|jpeg|heic|heif|png|bmp|jfif)$/))) return true;
    return false;
};
const validateImageFileAsync = async (imageFile)=>{
    try {
        if (imageExtentionCheck(imageFile)) {
            const { result , readerResult  } = await promiseImageFileReader(imageFile);
            const image = await promiseImageReader(result);
            return {
                width: image.width,
                height: image.height,
                image: image,
                file: imageFile,
                dataURL: readerResult
            };
        }
    } catch (e) {
        return false;
    }
    return false;
};
/**
 *
 * @param {*} value
 * @returns
 */ const getValidCategory = (value)=>{
    try {
        let categoryList = [
            "faucets",
            "toilet",
            "valve",
            "shower",
            "servicepart-faucet",
            "servicepart-toilet",
            "servicepart-shower"
        ];
        if (value && value.toLowerCase() === "toilet") {
            value = "toilet_group";
            categoryList = [
                "faucets",
                "toilet_group",
                "valve",
                "shower",
                "servicepart-faucet",
                "servicepart-toilet",
                "servicepart-shower"
            ];
        }
        if (categoryList.includes(value.toLowerCase())) {
            return value.toLowerCase();
        } else {
            return categoryList[0];
        }
    } catch (e) {
        console.log(e, "error in getValidCategory");
    }
};
/**
 * Retrieves detailed SKU information for a product.
 * @param {String} slug - The product slug.
 * @param {String} skuId - The SKU ID to retrieve details for.
 * @return {Promise<Object>} A promise that resolves to an object containing SKU details.
 */ const getDetailSku = async (slug, skuId)=>{
    try {
        var ref, ref1, ref2, ref3, ref4, ref5;
        const resp = await (0,_services_ct_service_js__WEBPACK_IMPORTED_MODULE_0__/* .getSearchPDP */ .Do)(slug, false);
        const productImages = resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.docs) === null || ref2 === void 0 ? void 0 : ref2[0]["productImages.labelWithUrl_ss"];
        const colorDetails = resp === null || resp === void 0 ? void 0 : (ref3 = resp.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.docs) === null || ref5 === void 0 ? void 0 : ref5[0]["Color.SKU.Details_ss"];
        const skus = colorDetails.map((item)=>item.split("|")[2]);
        const response = await (0,_services_ct_service_js__WEBPACK_IMPORTED_MODULE_0__/* .getProjectionData */ .vP)({
            slug,
            skus
        });
        const princeInfo = getPartsPricebySku(response);
        const priceArray = princeInfo[skuId];
        const productArray = productImages.filter((image)=>{
            const [, , type] = image.split("|");
            return type === "IMGITEMISO";
        }).map((image)=>{
            const [sku, , , , , imageUrl] = image.split("|");
            const colorDetail = colorDetails.find((detail)=>detail.includes(sku));
            if (colorDetail) {
                const [label, colorUrl, id, , , value] = colorDetail.split("|");
                return {
                    sku,
                    id,
                    imageUrl,
                    label,
                    colorUrl: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__["default"].COLOR_FILE_URL).concat(colorUrl),
                    value
                };
            }
            return null;
        }).filter((item)=>item !== null);
        const mapArrayWithPrices = (productArray, priceArray)=>{
            return productArray.map((product)=>{
                const priceInfo = priceArray.find((price)=>price.sku === product.sku) || {};
                return {
                    ...product,
                    prices: priceInfo
                };
            });
        };
        const mappedArray = mapArrayWithPrices(productArray, priceArray);
        return mappedArray;
    } catch (err) {
        console.error("Error in getDetailSku", err);
    }
};
/**
 * Maps a list of products to their prices by SKU.
 * @param {Array} list - The list of products.
 * @param {String} [currencyCode="USD"] - The currency code to use.
 * @param {String} [currencySign="$"] - The currency sign to use.
 * @return {Object} An object mapping SKUs to their price details.
 */ const getPartsPricebySku = function(list) {
    let currencyCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD", currencySign = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$";
    const sortItems = (i)=>{
        return {
            sku: i === null || i === void 0 ? void 0 : i.sku,
            currencySign,
            discountPrices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref, ref1;
                return (i === null || i === void 0 ? void 0 : (ref = i.discounted) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.currencyCode) === currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1, ref2;
                var ref3;
                return {
                    ...a,
                    [(ref3 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref3 !== void 0 ? ref3 : "ANY"]: i === null || i === void 0 ? void 0 : (ref2 = i.discounted) === null || ref2 === void 0 ? void 0 : ref2.value
                };
            }, {}),
            prices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref;
                return (i === null || i === void 0 ? void 0 : (ref = i.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1;
                var ref2;
                return {
                    ...a,
                    [(ref2 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref2 !== void 0 ? ref2 : "ANY"]: i === null || i === void 0 ? void 0 : i.value
                };
            }, {})
        };
    };
    return list.reduce((acc, sku)=>{
        var ref;
        return {
            ...acc,
            [sku === null || sku === void 0 ? void 0 : (ref = sku.masterVariant) === null || ref === void 0 ? void 0 : ref.sku]: [
                ...sku.variants.map(sortItems),
                ...[
                    sku.masterVariant
                ].map(sortItems)
            ]
        };
    }, {});
};
/**
 * Formats a price value into a string.
 * @param {Number} price - The price value to format.
 * @return {String|null} The formatted price string or null if the price is invalid.
 */ const formatPrice = (price)=>{
    return price ? "$".concat(Number((price !== null && price !== void 0 ? price : 0) / 100).toFixed(2)) : null;
};
/**
 * Retrieves the actual and strike-through prices for a product.
 * @param {Number} priceCTR - The original price.
 * @param {Number} discountPrice - The discounted price.
 * @return {Object} An object containing the actual price and strike-through price.
 */ const getPrice = (priceCTR, discountPrice)=>{
    const price = {};
    if (discountPrice) {
        price.actualPrice = formatPrice(discountPrice);
        price.strikePrice = formatPrice(priceCTR);
    } else {
        price.actualPrice = formatPrice(priceCTR);
        price.strikePrice = null;
    }
    return price;
};
/**
 * Extracts and maps parts file information from product data.
 * @param {Array} data - The product data containing parts information.
 * @return {Array|null} An array of objects containing part IDs and titles, or null if an error occurs.
 */ const getPartsFileMap = (data)=>{
    try {
        var ref, ref1, ref2, ref3, ref4;
        const extract1 = (ref3 = data === null || data === void 0 ? void 0 : (ref = data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.masterVariant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.name === "ProductResource")) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.value;
        const extract2 = extract1.filter((item)=>item.filter((i)=>i.name === "ResourceType" && i.value === "InteractiveSVG").length > 0);
        const extract3 = extract2.map((item)=>{
            const obj = {};
            item.forEach((item)=>{
                obj[item.name] = item.value;
            });
            return obj;
        });
        const extract4 = extract3.reduce((acc, item)=>{
            acc.push({
                id: item === null || item === void 0 ? void 0 : item.ResourceName,
                title: item.ResourceTitle
            });
            return acc;
        }, []);
        return extract4;
    } catch (e) {
        console.error("Error in getPartsFileMap:", e);
        return null;
    }
};
/**
 * Opens a product detail page (PDP) in a new browser tab.
 * @param {String} url - The URL to open.
 */ const viewPdp = (url)=>{
    const urlObj = new URL(url);
    const path = urlObj.pathname + urlObj.search;
    const fullUrl = "".concat(window.origin).concat(path);
    window.open(fullUrl, "_blank");
};
/**
 * Checks if an image URL is valid and accessible.
 * @param {String} url - The image URL to check.
 * @return {Promise<Boolean>} A promise that resolves to true if the image exists, otherwise false.
 */ const checkImageUrl = async (url)=>{
    try {
        const response = await fetch(url);
        if (response.ok) return response.ok;
    } catch (e) {
        return false;
    }
};
/**
 * Retrieves service parts information for a product.
 * @param {Object} partList - The part list object.
 * @param {String} productId - The product ID.
 * @returns {Promise<Object>} A promise that resolves to the service parts information.
 */ const getServiceParts = async (partList, productId)=>{
    const partDiagramtext = "text for parts";
    try {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        const projectionData = await (0,_services_ct_service_js__WEBPACK_IMPORTED_MODULE_0__/* .getProjectionData */ .vP)({
            slug: partList === null || partList === void 0 ? void 0 : (ref = partList.Info) === null || ref === void 0 ? void 0 : ref.slug,
            skus: [
                productId
            ]
        });
        const fileMapItems = getPartsFileMap(projectionData);
        const partNames = await (0,_services_ct_service_js__WEBPACK_IMPORTED_MODULE_0__/* .getSearchPDP */ .Do)(partList === null || partList === void 0 ? void 0 : (ref1 = partList.Info) === null || ref1 === void 0 ? void 0 : ref1.slug);
        let fileMap = fileMapItems;
        if (!fileMapItems) {
            var ref7;
            fileMap = partList === null || partList === void 0 ? void 0 : (ref7 = partList.SVGFiles) === null || ref7 === void 0 ? void 0 : ref7.map((file, index)=>{
                return {
                    title: "".concat(partDiagramtext, " ").concat(index + 1),
                    id: file.FileName
                };
            });
        }
        const product = {
            productId: partList === null || partList === void 0 ? void 0 : (ref2 = partList.Info) === null || ref2 === void 0 ? void 0 : ref2.prodId,
            partId: partList === null || partList === void 0 ? void 0 : (ref3 = partList.SVGFiles) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.FileName,
            analyticsCustomData: "",
            num: partNames === null || partNames === void 0 ? void 0 : (ref5 = partNames.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.response) === null || ref6 === void 0 ? void 0 : ref6.numFound,
            fileMap
        };
        return product;
    } catch (e) {
        console.error("Error in getServiceParts:", e);
    }
};
/**
 * Scrolls smoothly to a specified section in the document.
 * @param {String} divSection - The class name of the section to scroll to.
 */ const getScrollTo = (divSection)=>{
    const detailsText = document.querySelector(".".concat(divSection));
    if (detailsText) {
        detailsText.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
        });
    }
};
/**
 * Retrieves the persona-specific price detail from a price list.
 * @param {Object} priceDtl - The price detail object.
 * @param {String} [currencyCode="USD"] - The currency code to use.
 * @returns {Number|undefined} The persona-specific price or undefined if not found.
 */ const getPersonaPriceListDetail = function(priceDtl) {
    let currencyCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD";
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getUserPersona */ .shu)();
    let filerPrice;
    if (priceDtl === null || priceDtl === void 0 ? void 0 : priceDtl.prices) {
        filerPrice = ((priceDtl === null || priceDtl === void 0 ? void 0 : priceDtl.prices) || []).filter((price)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            const priceDiscounted = price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.value;
            const personaPriceDetails = ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
            const priceUSD = (price === null || price === void 0 ? void 0 : (ref3 = price.value) === null || ref3 === void 0 ? void 0 : ref3.currencyCode) === currencyCode;
            if (priceDiscounted && price.discounted.value.currencyCode === currencyCode) {
                var ref7, ref8;
                return ((ref7 = price.customerGroup) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.obj) === null || ref8 === void 0 ? void 0 : ref8.key) === persona;
            } else if (personaPriceDetails && priceUSD && !priceDiscounted) {
                return true;
            } else if ((!((ref4 = price.customerGroup) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.obj) === null || ref5 === void 0 ? void 0 : ref5.key) || !personaPriceDetails) && (price === null || price === void 0 ? void 0 : (ref6 = price.key) === null || ref6 === void 0 ? void 0 : ref6.includes("ANY")) && priceUSD) {
                return true;
            }
            return false;
        });
    }
    var ref7;
    const dicountedPerson = (ref7 = filerPrice === null || filerPrice === void 0 ? void 0 : (ref = filerPrice[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.discounted) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref7 !== void 0 ? ref7 : filerPrice === null || filerPrice === void 0 ? void 0 : (ref3 = filerPrice[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.centAmount;
    filerPrice = dicountedPerson !== null && dicountedPerson !== void 0 ? dicountedPerson : filerPrice === null || filerPrice === void 0 ? void 0 : (ref5 = filerPrice[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.value) === null || ref6 === void 0 ? void 0 : ref6.centAmount;
    return filerPrice;
};
/**
 * Checks whether a given URL points to a valid, loadable image. *
 * @param {string} url - The URL to test.
 * @returns {Promise<boolean>} Resolves to true if the URL loads as an image,otherwise false.
 */ const isImageUrl = (url)=>{
    return new Promise((resolve)=>{
        if (!url) return resolve(false);
        const img = new Image();
        img.onload = ()=>resolve(true);
        img.onerror = ()=>resolve(false);
        img.src = url;
    });
};


/***/ }),

/***/ 22006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66773);
/* harmony import */ var _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91883);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24400);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97433);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20558);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9473);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46201);














const SocialShare = (param)=>{
    let { cartId , analyticEventData , specFiles , mobileView =false , componentProp: { assetUrl ="" , url: compUrl = ""  } = {} , enableDownload =true , videoComp =false  } = param;
    // *****
    const [shareCart, setShareCart] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        show: false,
        id: "",
        url: ""
    });
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [link, setLink] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [downloading, setDownloading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const url = shareCart.url || "";
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)();
    const origin = window.location.origin;
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({});
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const shareCartUrl = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const hostUrlPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then(async (config)=>{
            const socialMediaConfigs = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "socialMediaConfig", {});
            setSocialMediaConfigs(socialMediaConfigs);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general?.siteName", "");
            const { general: { hostUrl =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            hostUrlPath.current = hostUrl;
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.socialShareEmailIconPath", "");
            shareCartUrl.current = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.shareCartPagePath", ""));
        });
        getLink().then((urlLink)=>{
            setLink(urlLink);
        });
    }, []);
    const handleShareCart = ()=>{
        setShareCart({
            ...shareCart,
            show: !shareCart.show
        });
        addDataLayer("share cart", link);
    };
    const handleShareCartCopyLink = (data)=>{
        const { isCopyLink =false , ismail =false  } = data;
        const payload = {
            cartId: cartId
        };
        return dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_12__/* .shareCart */ .Vp)(payload)).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.sharedCartId) {
                const shareUrl = window.location.origin + shareCartUrl.current + "?share-id=".concat(res.sharedCartId);
                if (isCopyLink) {
                    setShareCart({
                        ...shareCart,
                        id: res.sharedCartId,
                        url: shareUrl
                    });
                    navigator.clipboard.writeText(shareUrl);
                    addDataLayer("copy link", shareUrl !== null && shareUrl !== void 0 ? shareUrl : "n/a");
                } else if (ismail) {
                    return "share-id=".concat(res.sharedCartId);
                }
                return shareUrl;
            }
        });
    };
    // get component social share link url
    const getLink = async ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Pp)(compUrl);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeUrl */ .Nmg)(window.location.href);
        }
    };
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCart.id
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref;
        const siteList = [];
        socialMediaConfigs && (socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : (ref = socialMediaConfigs.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((socialMediaConfig)=>{
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default()(socialMediaConfig.map && socialMediaConfig.map.name)) {
                var _name, _iconPath;
                const site = {
                    key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                // if (props.asset)
                //   siteList.push({
                //     ...site,
                //     url:
                //       url +
                //       `${origin}&media=${props.asset.url}&is_video=${props.asset.isVideo}$description=${props.asset.description}`,
                //   })
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        }));
        setSites(siteList);
    }, [
        socialMediaConfigs
    ]);
    const emailLink = async (e)=>{
        const firstLink = window.location.origin + shareCartUrl.current;
        const lastLink = await handleShareCartCopyLink({
            ismail: true
        });
        const cartLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeUrl */ .Nmg)("mailto:?body=".concat(firstLink + "%3F" + lastLink).concat(i18n.mailSubject && "&subject=" + i18n.mailSubject));
        window.open(cartLink, "_blank");
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    const handleEmailActionKeydown = async (e)=>{
        if (e.keyCode === 13) {
            emailLink(e);
        }
        handleShareCart();
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href, target);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer(key.split(".com")[0], target.href);
        // eslint-disable-next-line no-empty
        } catch (ee) {}
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref3 = emailBtnRef.current) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("keydown", handleEmailActionKeydown, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref4;
            (ref4 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref4 === void 0 ? void 0 : ref4.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2, ref3;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref3 = emailBtnRef.current) === null || ref3 === void 0 ? void 0 : ref3.removeEventListener("keydown", handleEmailActionKeydown, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref4;
                (ref4 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref4 === void 0 ? void 0 : ref4.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        shareCart.show
    ]);
    const analyticData = analyticEventData || {
        internalLinkPosition: "n/a",
        internalLinkType: "n/a",
        internalLinkZoneName: "n/a"
    };
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        handleShareCartCopyLink({
            isCopyLink: true
        });
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const handleDownload = async ()=>{
        setDownloading(true);
        await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .handleZipDownload */ .G12)(specFiles);
        setDownloading(false);
    };
    const addDataLayer = (siteKey, link)=>{
        var ref;
        const { eventAction ="n/a" , eventName ="n/a" , eventType =siteKey === "share cart" ? "navigation" : "informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , videoId ="" , videoName =""  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" || siteKey === "share cart" ? "true" : "false"
        };
        if (videoId) eventInfo.videoId = videoId;
        if (videoName) eventInfo.videoName = videoName;
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const page = window.pageObj || {};
        if ((ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.length) {
            const { page: { cart ={}  } = {}  } = window.adobeDataLayer[0];
            page.cart = cart;
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_index__WEBPACK_IMPORTED_MODULE_10__/* .ConditionalWrapper */ .M2, {
            condition: enableDownload,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "download-specs".concat(mobileView ? "--mobile" : " d-none d-lg-block"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeInnerHtml */ .KD0)(i18n.shareCartDesc)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "download-specs".concat(mobileView ? "--mobile" : "", "__cta"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    onClick: ()=>handleShareCart(),
                                    name: "socialShareModelClose",
                                    "aria-expanded": shareCart.show,
                                    "aria-controls": "kf-order-summary",
                                    children: [
                                        i18n.shareCart,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === null || _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                            role: "presentation",
                                            alt: ""
                                        })
                                    ]
                                }),
                                (specFiles === null || specFiles === void 0 ? void 0 : specFiles.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": '{"eventAction":"cart:landing page:download specs","eventName":"cart:landing page:download specs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"download specs","internalLinkPosition":"cart","internalLinkType":"cart:download","internalLinkZoneName":"cart:landing page:order summary","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    onClick: handleDownload,
                                    children: [
                                        i18n.downloadSpecs,
                                        downloading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "loading-spinner"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        children
                    ]
                });
            },
            children: shareCart.show || !enableDownload ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "social-share",
                id: "kf-order-summary",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "social-share__box",
                    ref: shareBoxRef,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "social-share__sites",
                            children: shareCart.id && !videoComp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "social-share__shared-cart-number",
                                children: i18n.yourSharedCartNumber
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                role: "list",
                                children: sites.map((site, i)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            id: "kf-social-links-".concat(i),
                                            rel: "noreferrer",
                                            href: site.url,
                                            className: "kf-social-links",
                                            "aria-label": "".concat(i18n.linksCTA(site.key), " ").concat(i18n.openNewTabText),
                                            target: "_blank",
                                            "data-link-type": "social media",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                "aria-hidden": "true",
                                                src: "".concat("https://web-api.kohler.com/aem/resource?subscription-key=3da4541f545f4dc7841b6ba0606f96fc&resourcepath=").concat(site.icon),
                                                alt: site.key,
                                                className: "social-share__".concat(site.key)
                                            })
                                        })
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "social-share__actions",
                            role: "list",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        tabIndex: "0",
                                        role: "button",
                                        ref: copyBtnRef,
                                        className: "social-share__cta",
                                        "aria-live": "polite",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "social-share__copy-link-icon",
                                                "aria-hidden": true,
                                                src: "".concat(hostUrlPath.current).concat(socialShareCopyIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            copyIcon ? i18n.copyLinkIndication : i18n.copyLink
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        tabIndex: "0",
                                        className: "social-share__cta social-share__email",
                                        "aria-label": "".concat(i18n.email, " ").concat(i18n.openNewTabText),
                                        role: "link",
                                        ref: emailBtnRef,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "".concat(hostUrlPath.current).concat(socialShareEmailIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            i18n.email
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialShare);


/***/ }),

/***/ 75653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_cart_localization__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96286);
/**
 * It is Quantity Selector
 *  @returns {number} the QuantitySelector
 */ 







/**
 * It returns updated Value
 * @param {props} props is the only param.
 * @return {number} the updated Value in the cart
 */ function QuantitySelector(props) {
    const { isPDPQuantitySelector , source , doNotRequiredAnalyticsData , productData , productInfoData , onLoading =()=>{}  } = props || {};
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.value);
    const [focusControl, setFocusControl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [siteName, setSiteName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const product = productData && (productData.name || productData.desc) ? productData : {};
    const minusButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const addButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const qtyInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const staticTexts = (0,_components_cart_localization__WEBPACK_IMPORTED_MODULE_7__/* .getTranslations */ .F)(t);
    const { increaseQuantity , decreaseQuantity , minimumReached , qty  } = staticTexts;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!props.loading && value !== props.value) {
            setValue(props.value);
        } else if (!props.loading && value === props.value && value !== 1 && focusControl) {
            focusControl.current.focus({
                preventScroll: true
            });
        }
    }, [
        props.value,
        props.loading
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then((config)=>{
            setSiteName(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "general.siteName", ""));
        });
    }, []);
    /**
   * @param {val} val The first number.
   * @param {action} action The second number.
   */ const handleChange = (val, action)=>{
        if (val === "" || parseInt(val) < 1000) {
            if (props.isAddToCart) {
                onLoading();
            }
            if (!action) {
                setFocusControl(qtyInput);
            } else {
                setFocusControl(action === "add" ? addButton : minusButton);
            }
            let fieldValue = val.toString().replace(/\D/, "");
            if (fieldValue.charAt(0) === "0") {
                fieldValue = fieldValue.length === 1 ? 0 : fieldValue.substring(1);
            }
            fieldValue = fieldValue === "" ? value : Number(fieldValue);
            // if (!window.oldValue && window.oldValue !== 0) {
            window.oldValue = Number(props.value);
            // }
            setValue(fieldValue);
            delayedChange(fieldValue, action);
        }
    };
    const handleAddAnalytics = (action, val)=>{
        var ref, ref1, ref2, ref3, ref4;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        if (source !== "cart-preview" && (page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            // this is flow of cart page only
            let updatedSku;
            let pdpTypeBundle;
            page.cart.item.forEach((prod)=>{
                var ref, ref1, ref2, ref3, ref4, ref5;
                const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || ((ref4 = props.productData) === null || ref4 === void 0 ? void 0 : ref4.isBundleParent) && ((ref5 = props.productData) === null || ref5 === void 0 ? void 0 : ref5.sku)) {
                    var ref6, ref7;
                    if (((ref6 = props.productData) === null || ref6 === void 0 ? void 0 : ref6.isBundleParent) && ((ref7 = props.productData) === null || ref7 === void 0 ? void 0 : ref7.sku)) {
                        var ref8;
                        updatedSku = (ref8 = props.productData) === null || ref8 === void 0 ? void 0 : ref8.sku;
                        pdpTypeBundle = "bundle";
                    } else {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        updatedSku = productId;
                        pdpTypeBundle = prod.productInfo.pdpType;
                    }
                }
            });
            if (pdpTypeBundle === "bundle") {
                var ref5;
                var ref6;
                productInfoData.productInfo = {
                    ...productInfoData.productInfo,
                    quantity: val,
                    initialQuantity: (ref6 = Number((ref5 = productInfoData.productInfo) === null || ref5 === void 0 ? void 0 : ref5.quantity)) !== null && ref6 !== void 0 ? ref6 : Number(value)
                };
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    ...productInfoData,
                    page
                });
            } else {
                page.eventInfo = eventInfo(action);
                page.updatedSku = updatedSku;
                window.pageObj = page;
            }
        // wait till api is updating cart details
        } else if (source === "cart-preview" && (page === null || page === void 0 ? void 0 : (ref2 = page.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.length)) {
            var ref7, ref8;
            // This is flow of cart preview updates
            let customPI;
            if (page === null || page === void 0 ? void 0 : (ref7 = page.cart) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.item) === null || ref8 === void 0 ? void 0 : ref8.length) {
                // update this one too to get updated page state in analytics
                page.cart.item.forEach((prod)=>{
                    var ref, ref1, ref2, ref3;
                    const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                    if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase())) {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        customPI = prod.productInfo;
                    }
                });
            }
            if (!doNotRequiredAnalyticsData) {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    productInfo: customPI !== null && customPI !== void 0 ? customPI : productInfo(val),
                    page
                });
            }
        }
        if (source !== "cart-preview" && page && !(window === null || window === void 0 ? void 0 : (ref4 = window.pageObj) === null || ref4 === void 0 ? void 0 : ref4.updatedSku)) {
            page.updatedSku = (productData === null || productData === void 0 ? void 0 : productData.customerFacingSKU) || "true";
            window.pageObj = page;
        }
    };
    const productInfo = (val)=>{
        const customerFacingSKUId = product.customerFacingSKU || product.sku;
        const itemType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getCartItemType */ .Nth)(product.category, product.businessUnitName);
        const discountPriceProduct = Number(product.discountPrice);
        var _productSaleable, _oldValue;
        return {
            productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
            description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.desc) || "n/a",
            frequency: "n/a",
            globalPromotionPrice: discountPriceProduct ? discountPriceProduct : Number(product.unitPrice),
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: product.discountPercent > 0 || product.discountAmount > 0 ? "percentOff|" + product.discountPercent : "regular price",
            productBasePrice: Number(product.unitPrice) || "n/a",
            productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.category) || "n/a",
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.color) || "n/a",
            productCoupondiscount: "n/a",
            productID: customerFacingSKUId || "n/a",
            productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.name) || "n/a",
            productPartnerBuyNow: false,
            productRoom: (props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(productData.category) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.productRoom || (itemType === "service" ? itemType : "non-catalog")) || "n/a",
            productSalePrice: Number(product.discountPrice) ? Number(product.discountPrice) : Number(product.unitPrice),
            productSaleable: (_productSaleable = product.productSaleable) !== null && _productSaleable !== void 0 ? _productSaleable : "true",
            productStatus: product.availableQty >= val || product.stock >= val ? "in stock" : "out of stock",
            productSuperSku: product.superSku ? true : false,
            productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.name) || "n/a",
            quantity: val,
            initialQuantity: (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : Number(value),
            defaultImageName: product.image || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? "bundle" : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .pdpTypeFormat */ .V4r)({
                businessUnitName: props.businessUnitName,
                ProductIsRetail: props.ProductIsRetail,
                discontinuedProductb: props.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: props.ProductRequiredAccessoriesGroupsList,
                superSku: props.superSku
            }),
            productFindingMethod: "n/a",
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .sanitizeTextForAnalytics */ .T68)(product.productCollectionsName || product.category) || "n/a",
            itemType
        };
    };
    const eventInfo = (action)=>{
        return {
            eventAction: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventName: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "cart update",
            internalLinkPosition: "cart".concat((props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? ":bundle" : ""),
            internalLinkType: "cart:".concat(action === "add" ? "addition" : action === "subtract" ? "removal" : "update"),
            internalLinkZoneName: "cart:preview",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    };
    const delayedChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default()((val, action)=>{
        if (val) {
            if (!action) {
                var _oldValue;
                const oldVal = (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : value;
                if (val > oldVal) {
                    action = "add";
                } else if (val < oldVal) {
                    action = "subtract";
                }
            }
            handleAddAnalytics(action, val);
            props.onChange(parseInt(val), action);
        }
    }, 300), [
        props.onChange
    ]);
    /**
   * input value updates her
   */ const handleBlur = ()=>{
        if (!value || parseInt(value) === 0) setValue(props.value);
    };
    const isMinDisabled = props.loading || !value || value === 1;
    const isMaxDisabled = props.loading;
    const productName = product.name || product.desc || "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "quantity-selector no-print ".concat(props.size === "small" ? "small" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: minusButton,
                onClick: ()=>handleChange(parseInt(value) - 1, "subtract"),
                "aria-label": "".concat(productName, " ").concat(decreaseQuantity).concat(isMinDisabled ? " (".concat(minimumReached, ")") : ""),
                "aria-disabled": isMinDisabled,
                disabled: isMinDisabled,
                "data-testid": "decrement-button",
                type: "button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "plus",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "line-1 line"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: qtyInput,
                type: "text",
                inputMode: "numeric",
                pattern: "[0-9]*",
                className: "quantity-selector__count",
                value: parseInt(value),
                onBlur: ()=>handleBlur(),
                onChange: (e)=>handleChange(e.target.value),
                disabled: props.loading,
                "data-testid": "quantity-input",
                "aria-label": "".concat(productName, " ").concat(qty)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: addButton,
                onClick: ()=>handleChange(parseInt(value) + 1, "add"),
                "aria-label": "".concat(productName, " ").concat(increaseQuantity),
                "aria-disabled": isMaxDisabled,
                disabled: isMaxDisabled,
                "data-testid": "increment-button",
                type: "button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "plus",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line-1 line"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (QuantitySelector);


/***/ }),

/***/ 93284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ getMessageStatus; },
  "OA": function() { return /* binding */ getProductsById; },
  "$y": function() { return /* binding */ getProfileData; },
  "Qi": function() { return /* binding */ getShippingDetails; },
  "qy": function() { return /* binding */ getShippingMethods; },
  "bQ": function() { return /* binding */ handleQuantityChange; },
  "B8": function() { return /* binding */ removeCartItem; },
  "nc": function() { return /* binding */ setShippingAddress; },
  "FX": function() { return /* binding */ updateProductDetailToStore; }
});

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./utils/removeCart.js
// import { analyticsCB } from "@/components/cart/cartAnalytics"
const removeFromCart = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    /**
   * It removeFrom cart for pay load
   */ const { lineItemId ="" , quantity =0 , isBundle =false , isBundleParent =false , sku =""  } = data;
    const bundlePayload = {
        action: "removeBundleItem",
        customLineItemId: lineItemId,
        sku
    };
    const actions = [
        isBundleParent ? bundlePayload : {
            action: isBundle ? "removebundle" : "removeLineItem",
            lineItemId,
            quantity
        }
    ];
    return actions;
};
const setRemoveCartPayload = function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    /**
   * It removeFrom cart for payload removeBundleItem
   */ const actions = [];
    const allIds = items.filter((item)=>item.id).map((item)=>item.id);
    items.forEach((item)=>{
        const { id ="" , sku ="" , quantity =0 , isComboSku =false , bundleParentId ="" , parentBundleSku ="" , parentBundleId ="" , isBundleParent =false , isBundleChildItem =false  } = item;
        const filteredIds = allIds.filter((i)=>i !== id);
        const isChildItem = parentBundleSku && isBundleChildItem;
        // filtering out the combo sku items, to select only parent item if available
        if (!filteredIds.includes(bundleParentId) && !parentBundleSku && !isBundleParent) {
            actions.push({
                action: isComboSku || bundleParentId ? "removebundle" : "removeLineItem",
                lineItemId: bundleParentId || id,
                quantity
            });
        } else if (!parentBundleSku && isBundleParent || isChildItem) {
            // Handle static bundles and bundle child items
            actions.push({
                action: "removeBundleItem",
                customLineItemId: isChildItem ? parentBundleId : id,
                sku: isChildItem ? parentBundleSku : sku
            });
        }
    });
    return actions;
};

// EXTERNAL MODULE: ./js/helperV2.js
var helperV2 = __webpack_require__(30696);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
;// CONCATENATED MODULE: ./components/cart/cartHelper.js












const setShippingAddress = async (data, cb, needAnalytics, errorCb, expPayPalCallBackErrorMsg)=>{
    var ref;
    var ref1;
    const { user ={}  } = (ref1 = (ref = store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : ref.auth) !== null && ref1 !== void 0 ? ref1 : {};
    if (data.postalCode && data.postalCode.trim() !== "") {
        var ref2, ref3, ref4;
        const address = {
            postalCode: (ref2 = data.postalCode) === null || ref2 === void 0 ? void 0 : ref2.trim(),
            state: (ref3 = data.state) === null || ref3 === void 0 ? void 0 : ref3.trim(),
            country: (ref4 = data.country) === null || ref4 === void 0 ? void 0 : ref4.trim()
        };
        if (!(data === null || data === void 0 ? void 0 : data.email)) {
            data.email = user === null || user === void 0 ? void 0 : user.sub;
        }
        const { firstName , lastName , streetName , streetNumber , city , email , phone  } = data;
        if (firstName) address.firstName = firstName.trim();
        if (lastName) address.lastName = lastName.trim();
        if (streetName) address.streetName = streetName.trim();
        if (streetNumber) address.streetNumber = streetNumber.trim();
        if (city) address.city = city.trim();
        if (email) address.email = email.trim().toLowerCase();
        if (phone) address.phone = phone.trim();
        const actions = [
            {
                action: "setShippingAddress",
                address: address
            },
            {
                action: "recalculate",
                updateProductData: true
            }
        ];
        if (email) actions.push({
            action: "setCustomerEmail",
            email: email.trim().toLowerCase()
        });
        if (user === null || user === void 0 ? void 0 : user.koc) {
            actions.push({
                action: "setCustomType",
                type: {
                    key: "order",
                    typeId: "type"
                },
                fields: {
                    CSRAssociateId: user === null || user === void 0 ? void 0 : user.koc,
                    orderType: "ISC",
                    ...(user === null || user === void 0 ? void 0 : user.sub) && {
                        CSREmailId: user === null || user === void 0 ? void 0 : user.sub
                    }
                }
            });
        }
        const payload = {
            actions: actions
        };
        await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentUpdate */.NM)(payload)).unwrap().then((res)=>{
            if ((res === null || res === void 0 ? void 0 : res.type) === "Cart" && res.lineItems.length > 0) {
                store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(res));
                const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
                const payload = (0,helperV2/* getQuantityCount */.PW)(quantityLineItems);
                store/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)(payload));
                getShippingMethods(expPayPalCallBackErrorMsg, errorCb);
                cb && cb(address.postalCode, "success");
                needAnalytics && needAnalytics("success");
            } else {
                if (!phone) {
                    cb && cb(address.postalCode, "failure", "no items to ship in cart");
                }
            }
        }).catch((error)=>{
            console.error("Failed to set shipping address:", error);
            error.type = "setShippingAddressError";
            errorCb && errorCb(error);
            if (!phone) {
                cb && cb(address.postalCode, "failure", "failed to set shipping address.");
            }
        });
    }
};
const getShippingMethods = async function(expPayPalCallBackErrorMsg) {
    let errorCb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref, ref1, ref2, ref3;
    var ref4;
    const cart = (ref4 = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart) !== null && ref4 !== void 0 ? ref4 : {};
    const lineItemsLength = (cart === null || cart === void 0 ? void 0 : cart.lineItems) ? cart.lineItems.length : 0;
    // const taxedPrice = getState().cart?.cart?.data?.taxedPrice;
    const shippingZip = localStorage.getItem("shippingZip");
    const { taxedPrice ="" , shippingAddress: { postalCode: shippingAddressPostCode = ""  } = {}  } = cart;
    let shippingCost = 0;
    var ref5;
    shippingCost = Number(((ref5 = cart === null || cart === void 0 ? void 0 : (ref2 = cart.shippingTotal) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref5 !== void 0 ? ref5 : 0) / 100).toFixed(2);
    let promoCodes = [];
    if ((cart === null || cart === void 0 ? void 0 : (ref3 = cart.customLineItems) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
        promoCodes = promoCodes.concat(await (0,helper/* getShippingDiscountPromoCodes */.oH8)(cart));
        promoCodes.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.type) === "shipping";
        }).forEach((item)=>{
            shippingCost = Number(shippingCost) + Number(item.discount);
        });
    }
    if (lineItemsLength > 0 && shippingZip && shippingZip.trim() !== "" && shippingAddressPostCode && (!taxedPrice || !shippingCost || shippingCost && shippingCost * 1 === 0)) {
        await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentCart */.pw)(expPayPalCallBackErrorMsg)).unwrap().then((response)=>{
            if (response && response["shipping-details"]) {
                updateProductDetailToStore(response);
            } else {
                getShippingDetails().then((response)=>{
                    updateProductDetailToStore(response);
                }).catch((error)=>{
                    console.error("Unable to calculate tax:", error);
                    error.type = "setCalculateTaxError";
                    errorCb && errorCb(error);
                });
            }
        }).catch((error)=>{
            console.error("Failed to fetch shipping methods:", error);
            error.type = "setShippingMethodError";
            errorCb && errorCb(error);
        });
    }
};
const getProfileData = async function() {
    let errorMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let profile = {};
    try {
        const res = await store/* store.dispatch */.h.dispatch((0,checkoutSlice/* getProfile */.Ai)());
        if (res && res.data) {
            var ref, ref1, ref2, ref3;
            localStorage.setItem("profile-version", (ref = res.data) === null || ref === void 0 ? void 0 : ref.version);
            profile = res.data;
            profile.postalCode = (ref1 = profile === null || profile === void 0 ? void 0 : profile.addresses[0]) === null || ref1 === void 0 ? void 0 : ref1.postalCode;
            const profileAddr = profile === null || profile === void 0 ? void 0 : (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            });
            profile.profileAddrId = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
            profile.addresses = profile === null || profile === void 0 ? void 0 : (ref3 = profile.addresses) === null || ref3 === void 0 ? void 0 : ref3.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
            if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,helper/* arrayMove */.RpN)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        errorMsg && store/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
            message: errorMsg,
            isVisible: true
        }));
    }
    return profile;
};
const removeCartItem = async function(data) {
    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref, ref1;
    const { id ="" , quantity =0 , isComboSku =false , isBundleParent =false , sku  } = data;
    let payload;
    var ref2;
    const { shippingAddress: { postalCode =""  } = {}  } = (ref2 = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart) !== null && ref2 !== void 0 ? ref2 : {};
    if (!Array.isArray(data)) {
        const payloadData = {
            lineItemId: id,
            quantity,
            isBundle: isComboSku,
            isBundleParent,
            sku
        };
        payload = removeFromCart(payloadData);
    } else {
        payload = setRemoveCartPayload(data);
    }
    payload = payload.reduce((acc, ini)=>{
        if (!acc.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.lineItemId) === (ini === null || ini === void 0 ? void 0 : ini.lineItemId);
        }).length) {
            acc.push(ini);
        }
        return acc;
    }, []);
    const body = {
        actions: payload
    };
    await store/* store.dispatch */.h.dispatch((0,cartSlice/* removeFromCartLineItem */.Z5)(body)).unwrap().then((res)=>{
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(res));
        const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
        const payload = (0,helperV2/* getQuantityCount */.PW)(quantityLineItems);
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)(payload));
        if (res.lineItems.length > 0) {
            if (postalCode) {
                getShippingMethods();
            }
        } else {
            (0,cart/* deleteFromCart */.EI)(cb);
        }
    });
};
const getProductsById = async (ids)=>{
    let query = "";
    ids.forEach((id, i)=>{
        query += '"'.concat(id, '"');
        if (i + 1 !== ids.length) query += ", ";
    });
    try {
        const response = await store/* store.dispatch */.h.dispatch((0,cartSlice/* recentlyViewed */.er)(query)).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.results) {
                return res.results;
            }
        });
        if (response) return response;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
};
const getShippingDetails = async ()=>{
    try {
        var ref, ref1, ref2;
        const cart = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
        if (!(cart === null || cart === void 0 ? void 0 : cart.id)) {
            console.error("Cart ID is missing");
        }
        const response = await api/* apim.get */.TH.get("".concat(constants.shippingCostEndPoint, "?cartId=").concat(cart.id));
        if (!(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.results)) {
            console.error("Invalid response from shipping API");
        }
        return {
            "shipping-details": {
                results: response.data.results
            },
            shippingCost: true
        };
    } catch (error) {
        console.error(error.message || "Cannot ship to your location");
        const { response: { data: { error: errorData = {}  } = {}  } = {}  } = error;
        if (errorData === null || errorData === void 0 ? void 0 : errorData.sku) {
            return errorData;
        }
        return null;
    }
};
const updateProductDetailToStore = (response)=>{
    var ref, ref1;
    if ((response === null || response === void 0 ? void 0 : (ref = response.sku) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        const invalidProducts = response.sku.map((item)=>({
                sku: item
            }));
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setNoshipping */.qT)(invalidProducts));
        return;
    }
    const shippingDetails = response && ((ref1 = response["shipping-details"]) === null || ref1 === void 0 ? void 0 : ref1.results) || [];
    var ref2;
    const validProducts = (ref2 = shippingDetails.filter((item)=>!item.warningMessage)) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    const inValidProducts = (ref3 = shippingDetails.filter((item)=>item.warningMessage)) !== null && ref3 !== void 0 ? ref3 : [];
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setShipping */.YO)(validProducts));
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setNoshipping */.qT)(inValidProducts));
};
const getMessageStatus = (info)=>{
    const { data , email , hideAlerts , i18n , checkoutMode , isMobile , alert ={}  } = info;
    if (data.cancelled || email || !hideAlerts) {
        if (isMobile) {
            if (alert.show) {
                return true;
            } else if (!alert.show && data.outOfStock) {
                return true;
            } else if (!alert.show && !data.outOfStock && data.noShipping) {
                return true;
            } else if (data.category !== "Install Services" && data.category !== "Design Services") {
                if (data.backOrder && data.leadTime && data.quantity > data.availableQty) {
                    return true;
                } else if (!alert.show) {
                    if (data.outOfStock || data.noShipping) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else return false;
        } else {
            return true;
        }
    } else if (!data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg) {
        return true;
    } else if (!checkoutMode && !isMobile) {
        return true;
    } else {
        return false;
    }
};
const handleAddtoCartResponse = (param)=>{
    let { payload  } = param;
    if (payload) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(payload));
    }
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
};
const handleQuantityChange = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { id ="" , sku ="" , quantity =0 , isComboSku =false , isBundleParent =false , stockCheck , cb , zipCode =""  } = data || {};
    let additionalInfo = {};
    var ref;
    const { cart: { qtyLoading =false , cart: { lineItems =[]  } = {}  } = {}  } = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const cartItem = (ref1 = lineItems.find((item)=>{
        const { custom: { fields: { isBundleChildItem =false , zipCode: itemZipCode  } = {}  } = {} , variant: { sku: variantSku = ""  } = {}  } = item;
        if (isComboSku) {
            if (!isBundleChildItem && variantSku === sku) return item;
        } else if (!isBundleChildItem) {
            if (zipCode && itemZipCode) {
                if (itemZipCode === zipCode && variantSku === sku) {
                    return item;
                }
            } else if (variantSku === sku) {
                return item;
            }
        }
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { custom: { variant: { attributes =[]  } = {} , fields: { roomInfo ="" , isBackOrderable: backorder = false  } = {}  } = {} , quantity: cartQuantity = 0 , id: lineItemId = ""  } = cartItem;
    const brand = get_default()(attributes === null || attributes === void 0 ? void 0 : attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
    if (roomInfo) {
        var ref2, ref3;
        const roomInfoObj = JSON.parse(roomInfo["0"]);
        const { productType ="" , soldByBox , soldByUom  } = roomInfoObj;
        const isTrim = productType === "trim";
        const totalPiecesNo = isTrim ? quantity : soldByBox * quantity;
        const totalOverage = soldByUom > 0 && totalPiecesNo > 0 ? totalPiecesNo / soldByUom : 0;
        const overageVal = Number(cartItem === null || cartItem === void 0 ? void 0 : (ref2 = cartItem.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.overage);
        const overagePercent = overageVal > 0 ? overageVal / 100 : 0;
        const totalNeeded = Math.floor(totalOverage) / (1 + overagePercent);
        additionalInfo = {
            ...roomInfoObj,
            productType: productType,
            totalNeeded: totalNeeded.toFixed(2),
            totalArea: totalOverage.toFixed(2),
            soldByBox: Number(soldByBox),
            soldByUom: Number(soldByUom),
            customQuantity: quantity,
            overage: overageVal.toString(),
            roomInfo: true
        };
    }
    if (quantity > cartQuantity && !stockCheck) {
        var ref4, ref5;
        if (Object.keys(additionalInfo).length > 0) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo);
            return;
        } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref4 = cartItem.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.customQuantity) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                quantity
            });
            return;
        } else {
            const payload = await (0,addTocart/* addToCartItem */.q)([
                {
                    lineItemId: lineItemId,
                    sku,
                    quantity: quantity - cartQuantity,
                    isBundle: isComboSku,
                    backorder,
                    brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                    zipCode
                }
            ]);
            const body = {
                actions: payload
            };
            store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                handleAddtoCartResponse(res);
                getShippingMethods();
            });
            return;
        }
    }
    // change quantity for bundle
    if (isBundleParent) {
        (0,cart/* getStock */.K5)(sku).then(async (param)=>{
            let { stock =0  } = param;
            const isAvailableQty = quantity <= stock;
            const payload = await (0,addTocart/* addToCartItem */.q)([
                {
                    lineItemId: id,
                    isBundleParent,
                    sku,
                    quantity: isAvailableQty ? quantity : stock
                }
            ]);
            const body = {
                actions: payload
            };
            store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                handleAddtoCartResponse(res);
                getShippingMethods();
            });
            if (!isAvailableQty) {
                cb(stock);
            }
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        }).catch(()=>{
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        });
    } else if (quantity > cartQuantity) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(!qtyLoading));
        // Checking stock
        (0,cart/* getStock */.K5)(sku).then(async (param)=>{
            let { stock =0  } = param;
            var ref, ref1;
            // At first time whenever changes made with input feild
            if (Object.keys(additionalInfo).length > 0) {
                if (quantity <= stock) {
                    (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo, cartSlice/* setQtyLoading */.LR);
                    return;
                } else if (quantity > stock) {
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
                    cb(stock);
                    return;
                }
            } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.customQuantity) {
                (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                    quantity
                }, cartSlice/* setQtyLoading */.LR);
                return;
            }
            if (quantity > stock) {
                if (stock > cartQuantity) {
                    const payload = await (0,addTocart/* addToCartItem */.q)([
                        {
                            lineItemId: lineItemId,
                            sku,
                            quantity: stock - cartQuantity,
                            isBundle: isComboSku,
                            backorder,
                            brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                            zipCode
                        }
                    ]);
                    const body = {
                        actions: payload
                    };
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                        cb(stock);
                        handleAddtoCartResponse(res);
                        getShippingMethods();
                    });
                    cb(stock);
                } else if (stock === cartQuantity) {
                    cb(stock);
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* getCart */.dv)());
                } else if (stock > 0) {
                    const payloadData = {
                        lineItemId: lineItemId,
                        quantity: cartQuantity - stock,
                        isBundle: isComboSku,
                        sku
                    };
                    const payload1 = removeFromCart(payloadData);
                    const body1 = {
                        actions: payload1
                    };
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body1)).unwrap().then((res)=>{
                        handleAddtoCartResponse(res);
                        getShippingMethods();
                    });
                } else {
                    cb();
                }
            } else if (cartQuantity !== stock) {
                const payload2 = await (0,addTocart/* addToCartItem */.q)([
                    {
                        lineItemId: lineItemId,
                        sku,
                        quantity: quantity - cartQuantity,
                        isBundle: isComboSku,
                        backorder,
                        brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                        zipCode
                    }
                ]);
                const body2 = {
                    actions: payload2
                };
                store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body2)).unwrap().then((res)=>{
                    handleAddtoCartResponse(res);
                    getShippingMethods();
                });
            }
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        }).catch(()=>{
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        });
    } else if (cartQuantity > quantity) {
        var ref6, ref7;
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(!qtyLoading));
        if (Object.keys(additionalInfo).length > 0) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo, cartSlice/* setQtyLoading */.LR);
            return;
        } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref6 = cartItem.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.customQuantity) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                quantity
            }, cartSlice/* setQtyLoading */.LR);
            return;
        }
        const payloadData = {
            lineItemId: lineItemId,
            quantity: cartQuantity - quantity,
            isBundle: isComboSku,
            sku
        };
        const payload1 = removeFromCart(payloadData, true);
        const body1 = {
            actions: payload1
        };
        store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body1)).unwrap().then((res)=>{
            handleAddtoCartResponse(res);
            getShippingMethods();
        });
    }
};


/***/ }),

/***/ 96286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        yourCart: t("kf.cart.label.yourCart"),
        emptyCart: t("kf.cart.label.emptyCart"),
        sharCartLink: t("kf.cart.label.sharCartLink"),
        sharCartLinkCopied: t("kf.cart.label.sharCartLinkCopied"),
        qty: t("kf.cart.label.quantity"),
        unitPrice: t("kf.cart.label.unitPrice"),
        total: t("kf.cart.label.total"),
        colorFinish: t("kf.cart.label.colorFinish"),
        shape: t("kf.cart.label.shape"),
        coverage: t("kf.cart.label.coverage"),
        sku: t("kf.cart.label.sku"),
        inStockMsg: t("kf.cart.label.inStockMsg"),
        saveLater: t("kf.cart.label.saveLater"),
        remove: t("kf.cart.label.remove"),
        continueCheckout: t("kf.cart.label.continueCheckout"),
        orderSummary: t("kf.cart.label.orderSummary"),
        LoadCart: t("Kf.button.action.loadcart"),
        collabrativeCartDecs: t("kf.cart.label.collbcartdecs"),
        createcart: t("kf.cart.lable.createcart"),
        customersCartID: t("kf.cart.lable.customercartid"),
        subTotal: t("kf.cart.label.subTotal"),
        totalPromotions: t("kf.cart.label.totalPromotions"),
        estimatedShipping: t("kf.cart.label.estimatedShipping"),
        estimatedTax: t("kf.cart.label.estimatedTax"),
        estimatedTotal: t("kf.cart.label.estimatedTotal"),
        enterPromo: t("kf.cart.label.enterPromo"),
        coupon: t("kf.cart.label.coupon"),
        apply: t("kf.global.label.apply"),
        free: t("kf.cart.label.free"),
        freeShipping: t("kf.label.freeShipping"),
        previousDiscountErr: t("kf.cart.error.previousDiscountErr"),
        combinePromoErr: t("kf.cart.error.combinePromoErr"),
        maxAppReachedErr: t("kf.cart.error.maxAppReachedErr"),
        promoNotApplicable: t("kf.cart.error.promoNotApplicable"),
        invalidPromoErr: t("kf.cart.error.invalidPromoErr"),
        noPromoErr: t("kf.cart.error.noPromoErr"),
        alreadyAppliedErr: t("kf.cart.error.alreadyAppliedErr"),
        update: t("kf.global.label.update"),
        zipCode: t("kf.cart.label.zipCode"),
        edit: t("kf.cart.label.edit"),
        cart: t("kf.cart.label.cart"),
        shareCart: t("kf.cart.label.shareCart"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        downloadSpecs: t("kf.cart.label.downloadSpecs"),
        noItemsInCart: t("kf.cart.label.noItemsInCart"),
        addA: t("kf.cart.label.addA"),
        or: t("kf.global.label.or"),
        recentlyViewedItem: t("kf.cart.label.recentlyViewedItem"),
        recentlyViewedTitle: t("kf.cart.label.recentlyViewedTitle"),
        recentlyViewedColor: t("kf.pairsWellWith.label.color"),
        recentlyViewedColors: t("kf.pairsWellWith.label.colors"),
        ariaLabelColor: t("kf.pairsWellWith.aria.colors"),
        ariaLabelTooltip: t("kf.pairsWellWith.aria.tooltip"),
        continueShopping: t("kf.cart.label.continueShopping"),
        alert: t("kf.global.label.alert"),
        outOfStock: t("kf.cart.label.outOfStock"),
        outOfStockAlert: t("kf.cart.label.outOfStockAlert"),
        cannotShip: t("kf.cart.label.cannotShip"),
        callSupport: t("kf.cart.label.callSupport"),
        needMoreTime: t("kf.cart.label.needMoreTime"),
        saveCartMssg: t("kf.cart.label.saveCartMssg"),
        createAccount: t("kf.cart.label.createAnAccount"),
        createProfessionalAccount: t("kf.cart.label.createProfessionalAccount"),
        createCartAccount: t("kf.cart.label.createCartAccount"),
        saveYourCart: t("kf.cart.label.saveYourCart"),
        taxTooltip: t("kf.cart.label.taxTooltip"),
        shippingTooltip: t("kf.cart.label.shippingTooltip"),
        oversizedDelivery: t("kf.cart.label.oversizedDelivery"),
        oversizedFragileDelivery: t("kf.cart.label.oversizedFragileDelivery"),
        freightShipping: t("kf.orderDetails.label.freightShipping"),
        freightLabel: t("kf.orderSUmmary.label.freightLabel"),
        validZipcode: t("kf.checkout.error.validZipcode"),
        zipCodeError: t("kf.checkout.error.zipcodeError"),
        note: t("kf.cart.label.note"),
        comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
        outOfStockToolTip: t("kf.cart.label.outOfStockToolTip"),
        qtyMoreThanToolTip: t("kf.cart.label.qtyMoreThanToolTip"),
        noShippingTooltip: t("kf.cart.label.noShippingTooltip"),
        emptyCartAria: t("kf.cart.label.emptyCartAria"),
        continueCheckoutAria: (count, total)=>t("kf.cart.label.continueCheckoutAria", {
                count: count,
                total: total
            }),
        removePromoAria: t("kf.cart.label.removePromoAria"),
        shippingInfoAria: t("kf.cart.label.shippingInfoAria"),
        strikedPrice: t("kf.cart.label.strikedPrice"),
        taxInfoAria: t("kf.cart.label.taxInfoAria"),
        discountPercentage: t("kf.checkout.label.discountPercentage"),
        productDiscounts: t("kf.cart.label.productDiscounts"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        off: t("kf.cart.label.off"),
        linearFtNeeded: t("annsacks.pdpTrimCalculator.label.linearFtNeeded"),
        squareFtNeeded: t("annsacks.pdpTrimCalculator.label.squareFtNeeded"),
        overage: t("annsacks.pdpTrimCalculator.label.overage"),
        lf: t("annsacks.pdpTrimCalculator.label.LF"),
        sf: t("annsacks.pdpTrimCalculator.label.SF"),
        totalLF: t("annsacks.pdpTrimCalculator.label.totalLF"),
        totalSF: t("annsacks.pdpTrimCalculator.label.totalSF"),
        pieces: t("annsacks.pdpTrimCalculator.label.pieces"),
        boxes: t("annsacks.pdpTrimCalculator.label.boxes"),
        totalPieces: t("annsacks.pdpTrimCalculator.label.totalPieces"),
        totalBoxes: t("annsacks.pdpTrimCalculator.label.totalBoxes"),
        whatYouWillReceive: t("annsacks.pdpTrimCalculator.label.whatYouWillReceive"),
        totalCoverage: t("annsacks.pdpTrimCalculator.label.totalCoverage"),
        cartLandingCalculatorTitle: t("annsacks.pdpTrimCalculator.label.cartLandingCalculatorTitle"),
        cartLandingCalculatorDescription: t("annsacks.pdpTrimCalculator.label.cartLandingCalculatorDescription"),
        cartLandingCalculatorArea: t("annsacks.pdpTrimCalculator.label.area"),
        cartLandingCalculatorRecalculate: t("annsacks.pdpTrimCalculator.label.recalculate"),
        qtyMoreThanStock: (stock, qty)=>t("kf.cart.label.qtyMoreThanStock", {
                qty,
                stock
            }),
        yourSharedCartID: (cartNumber)=>t("kf.share.label.yourSharedCartID", "Cart ID:", {
                cartNumber
            }),
        recalculateUpdateCart: t("annsacks.recalculate.label.updateCart"),
        recalculateLinearFt: t("annsacks.recalculate.label.linearFt"),
        recalculateSqureFt: t("annsacks.recalculate.label.squreFt"),
        mailSubject: t("kf.share.label.emailSubject"),
        noItemsToShip: t("kf.cart.label.noItemsToShip"),
        availableToShip: (qty)=>t("kf.cart.label.availableToShip", {
                qty
            }),
        removeDiscountErrorMsg: t("kf.cart.label.removeDiscountErrorMsg"),
        qtyMinus: "Quantity minus",
        qtyPlus: "Quantity plus",
        profileFailure: t("kf.account.label.profileFailure"),
        signIn: t("kf.loggedin.button.signIn"),
        needHelpOrder: t("kf.cart.label.needHelpOrder"),
        kohlerOrders: t("kf.cart.label.kohlerOrders"),
        promocode: t("kf.cart.label.promocode"),
        signInItemsPreviously: t("kf.cart.label.signInItemsPreviously"),
        proceedToCheckout: t("kf.cart.label.proceedToCheckout"),
        item: t("kf.list.table.item"),
        itemPrice: t("kf.list.table.itemPrice"),
        itemDiscount: t("kf.cart.label.itemdiscount"),
        calculatedInCheckout: t("kf.cart.label.calculatedInCheckout"),
        tax: t("kf.ordersummary.label.tax"),
        shipping: t("kf.list.table.shipping"),
        saveAddressMyAccount: t("kf.checkout.label.saveAddressMyAccount"),
        inStock: t("kf.cart.label.inStock"),
        checkout: t("kf.cart.label.checkout"),
        totalPrice: t("annsacks.pdpTrimCalculator.label.totalPrice"),
        bucket: t("annsacks.annsacksPdp.label.bucket"),
        perBox: t("annsacks.pdpProductSummary.label.perBox"),
        perEach: t("annsacks.pdpProductSummary.label.perEach"),
        saveOnBundle: (number)=>t("kf.pdp.bundles.saveOnBundle", {
                number
            }),
        availableToShipMsg: (qty)=>t("kf.cart.label.availableToShipMsg", {
                qty
            }),
        increaseQuantity: t("kf.pdp.label.increaseQuantity"),
        decreaseQuantity: t("kf.pdp.label.decreaseQuantity"),
        minimumReached: t("kf.pdp.label.minimumReached")
    };
};


/***/ }),

/***/ 82883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nx": function() { return /* binding */ addShippingAnalytics; },
/* harmony export */   "O": function() { return /* binding */ addAnalyticsVerifyAddress; },
/* harmony export */   "Ye": function() { return /* binding */ addPlaceOrderDataLayer; },
/* harmony export */   "gV": function() { return /* binding */ getAddPromoEventInfo; },
/* harmony export */   "nU": function() { return /* binding */ updatePromoAnalytics; },
/* harmony export */   "o2": function() { return /* binding */ addAnalyticsAddressEdit; },
/* harmony export */   "oM": function() { return /* binding */ addAnalyticsRemoveItems; },
/* harmony export */   "uU": function() { return /* binding */ calculateCartAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; }
/* harmony export */ });
/* unused harmony exports getCheckoutReviewEventInfo, getCheckoutSignEventInfo, addCheckoutSignDataLayer */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);


const addShippingAnalytics = (status, message, i18n)=>{
    if (window.adobeDataLayer) {
        const eventInfo = getShippingEventInfo("next", true);
        if (status) {
            eventInfo.eventStatus = status;
        }
        if (message) {
            if (message === "failed to set shipping address." || message === "failed to get shipping options.") {
                var ref;
                message = (ref = i18n.shippingProcessError) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            }
            eventInfo.eventMsg = message;
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const getShippingEventInfo = function(type) {
    let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const eventInfo = {
        eventAction: "checkout:shipping:" + type,
        eventName: "checkout:shipping:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "continue to delivery",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const calculateCartAnalytics = (param)=>{
    let { cart  } = param;
    const page = window.pageObj || {};
    page.cart = cart;
    page.user = getUserAnalyticsObject();
    // push this data to data layer in show event
    if (page.user && (!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
        window.pageObj = page;
        window.isShowAnalyticsEvent = true;
    } else if (!(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)()) {
        window.adobeDataLayer.push({
            event: "cmp:show",
            page
        });
        delete window.pageObj;
    }
};
const getUserAnalyticsObject = function() {
    let isFromRegisterUser = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const hashedEmail = localStorage.getItem("hashedEmail");
    const customerProspect = localStorage.getItem("customerProspect");
    let isCustomerOrProspect = "n/a";
    if (hashedEmail && customerProspect) {
        try {
            const decryptedJSON = JSON.parse((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .caesarDecrypt */ .s80)(hashedEmail, customerProspect));
            if (decryptedJSON.pastOrders.length) {
                isCustomerOrProspect = "customer";
            } else {
                isCustomerOrProspect = "prospect";
            }
        } catch (es) {
            // eslint-disable-next-line no-console
            console.log("decrypt error: ", es);
        }
    }
    // this user object should be updated when user log in or out.
    const user = {
        gId: "n/a",
        abTestName: "n/a",
        adBlocker: false,
        authStatus: "anonymous",
        commerceToolsID: "n/a",
        customerProspect: isCustomerOrProspect,
        envName: "development",
        knownStatus: "unknown",
        profileRole: "guest",
        returningStatus: "new visitor",
        emailId: hashedEmail || "n/a"
    };
    // fetch okta tokens for both logged in and anonymous users
    const oktaToken = localStorage.getItem("okta-token-storage");
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token");
    if (oktaToken && oktaToken !== "{}") {
        var ref;
        // user is logged in
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref = oktaObject.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {};
        // user.uId = claim.uid || "n/a";
        if (claim.businessType === "Consumer") {
            user.profileRole = "consumer";
        } else {
            user.profileRole = "professional";
        }
        user.commerceToolsID = claim.commercetoolsID || "n/a";
        if (!isFromRegisterUser) {
            user.returningStatus = "returning customer";
        }
        user.authStatus = "logged in";
        user.knownStatus = "known";
    } else if (anonymousOktaToken) {
        // anonymous user
        let oktaObject1;
        try {
            oktaObject1 = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Anonymous Okta Token can not be decoded......");
        }
        if (oktaObject1) {
            user.gId = oktaObject1.gId || "n/a";
        }
    }
    return user;
};
const getEventInfo = (step)=>{
    return JSON.stringify({
        eventAction: "checkout:" + step + ":edit",
        eventName: "checkout:" + step + ":edit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:" + step,
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getAddPromoEventInfo = async function() {
    let promoCodeLable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "expand";
    if (window.adobeDataLayer) {
        const eventInfo = {
            eventName: "checkout:payment & billing:promo code:expand",
            eventAction: "checkout:payment & billing:promo code:expand",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: promoCodeLable,
            internalLinkPosition: "checkout",
            internalLinkZoneName: "checkout:payment and billing",
            internalLinkType: "checkout:promo code",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    }
};
const updatePromoAnalytics = async (status, cartObj, promo, action, productDiscounts)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        eventAction: "checkout:payment & billing:promo code:" + action,
        eventName: "checkout:payment & billing:promo code:" + action,
        eventType: "navigation",
        eventMsg: status === "success" ? action === "remove" ? "promocode removed successfully" : "promocode applied successfully" : status === null || status === void 0 ? void 0 : status.toLowerCase(),
        eventStatus: status === "success" ? "success" : "failure",
        internalLinkName: action,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:promo code",
        internalLinkZoneName: "checkout:payment & billing",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        promoCode: promo
    };
    if (cartObj) {
        const { cart  } = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .calculateCartData */ .DpP)({
            cart: cartObj,
            i18n: {
                productDiscounts: productDiscounts || "Product Discounts"
            }
        }, true);
        page.cart = cart;
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getCheckoutReviewEventInfo = function(type, link, needJson) {
    let isModalOpen = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, status = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "n/a";
    const extraText = isModalOpen ? "something went wrong:" : "";
    const extraText2 = isModalOpen ? ":modal:something went wrong" : "";
    const eventInfo = {
        eventAction: "checkout:review:".concat(extraText).concat(type),
        eventName: "checkout:review:".concat(extraText).concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: status || "n/a",
        internalLinkName: type,
        internalLinkPosition: "checkout".concat(extraText2),
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:review".concat(extraText2),
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addPlaceOrderDataLayer = async function(link) {
    let isModalOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, paymentMethod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "n/a", status = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "n/a";
    var ref, ref1;
    const eventInfo = getCheckoutReviewEventInfo("place order", link, true, isModalOpen, status);
    const { adobeDataLayer: { getState  } = {}  } = window;
    let pageData = getState && getState("page") || {};
    const cartObj = (ref = _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    if (cartObj) {
        try {
            const { cart  } = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .calculateCartData */ .DpP)({
                cart: cartObj
            }, true);
            pageData = {
                ...pageData,
                cart
            };
        } catch (error) {
            console.error("Error calculating cart data:", error);
        }
    }
    const page = {
        ...pageData,
        cart: {
            ...pageData.cart,
            payment: {
                paymentMethod: paymentMethod.toLowerCase()
            }
        }
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getCheckoutSignEventInfo = (type)=>{
    const eventInfo = {
        eventAction: "checkout:shipping:sign in",
        eventName: "checkout:shipping:sign in",
        eventType: "navigation",
        eventMsg: type === "success" ? "n/a" : "please enter a valid password",
        eventStatus: type === "success" ? "success" : "failure",
        internalLinkName: "sign in",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    return eventInfo;
};
const addCheckoutSignDataLayer = (type)=>{
    const eventInfo = getCheckoutSignEventInfo(type);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const addAnalyticsAddressEdit = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "checkout:shipping:edit",
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "checkout:shipping:edit",
        eventType: "navigation",
        internalLinkName: "edit",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "checkout:shipping"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const addAnalyticsVerifyAddress = function() {
    let action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        eventAction: "checkout:shipping verify address:".concat(action),
        eventName: "checkout:shipping verify address:".concat(action),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: action === "use original" ? "success" : "n/a",
        internalLinkName: action,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping verify address",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsRemoveItems = function() {
    let product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const productArrayLists = product ? product.length > 1 : false;
    const prodcutLists = [];
    if (product === null || product === void 0 ? void 0 : product.length) {
        product.forEach((prod)=>{
            const productInformation = JSON.parse(prod === null || prod === void 0 ? void 0 : prod.customProductInfo);
            prodcutLists.push(productInformation === null || productInformation === void 0 ? void 0 : productInformation.productInfo);
        });
    }
    const removeText = productArrayLists ? "remove items" : "remove item";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "checkout:continue to delivery:we are sorry we cannot ship to your location:".concat(removeText),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "checkout:continue to delivery:we are sorry we cannot ship to your location:".concat(removeText),
        eventType: "navigation",
        internalLinkName: removeText,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "checkout:we are sorry we cannot ship to your location"
    };
    const productInfoJSON = (prodcutLists === null || prodcutLists === void 0 ? void 0 : prodcutLists.length) > 0 ? {
        productInfo: prodcutLists
    } : null;
    pushAnalyticsObjToDataLayer(eventInfo, productInfoJSON);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfoJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    let DLObj = {
        event,
        eventInfo,
        page
    };
    if (productInfoJSON === null || productInfoJSON === void 0 ? void 0 : productInfoJSON.productInfo) {
        DLObj = {
            ...DLObj,
            productInfo: productInfoJSON.productInfo
        };
    }
    window.adobeDataLayer.push(DLObj);
};



/***/ }),

/***/ 90625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$7": function() { return /* binding */ getPromoTotalAmount; },
/* harmony export */   "Eg": function() { return /* binding */ preventBodyScrollPayError; },
/* harmony export */   "Jk": function() { return /* binding */ getShippingQuantity; },
/* harmony export */   "N8": function() { return /* binding */ shippingMethodData; },
/* harmony export */   "T9": function() { return /* binding */ findSelectParcelType; },
/* harmony export */   "XL": function() { return /* binding */ assignShipping; },
/* harmony export */   "YG": function() { return /* binding */ optionAmount; },
/* harmony export */   "go": function() { return /* binding */ discountMethod; }
/* harmony export */ });
/* unused harmony exports serviceAmount, getFreightsAmount, getParcelsAmount, getDeliveryOption */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46201);
/* harmony import */ var _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63519);




const assignShipping = (body, cb)=>{
    _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .shipmentCart */ .pw)(body)).unwrap().then(()=>{
        _store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_2__/* .setIsPayPalCallback */ .eM)(true));
        if (cb) {
            cb();
        }
    });
};
const findSelectParcelType = function() {
    let selected = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parcels = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    let parcelTypeName = _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_3__/* .STANDARD */ .b2;
    const { parcel =0  } = selected;
    if (parcels[parcel]) {
        parcelTypeName = parcels[parcel].name;
    }
    return parcelTypeName === null || parcelTypeName === void 0 ? void 0 : parcelTypeName.toLocaleLowerCase();
};
const getShippingQuantity = (parcelItems)=>{
    let shippingQty = 0;
    parcelItems === null || parcelItems === void 0 ? void 0 : parcelItems.map((item)=>{
        if ((item === null || item === void 0 ? void 0 : item.isComboSku) === false) {
            shippingQty = shippingQty + (item === null || item === void 0 ? void 0 : item.quantity);
        }
        if ((item === null || item === void 0 ? void 0 : item.isComboSku) === true) {
            shippingQty = shippingQty + (item === null || item === void 0 ? void 0 : item.childItems.reduce((total, childObj)=>{
                return total + (childObj === null || childObj === void 0 ? void 0 : childObj.quantity);
            }, 0));
        }
    });
    return shippingQty;
};
const preventBodyScrollPayError = (status)=>{
    if (status) {
        document.body.classList.add("scroll-lock-payError", "modal-open");
        document.getElementsByTagName("html")[0].classList.add("scroll-lock-payError", "modal-open");
    } else {
        document.body.classList.remove("scroll-lock-payError", "modal-open");
        document.getElementsByTagName("html")[0].classList.remove("scroll-lock-payError", "modal-open");
    }
};
const shippingMethodData = (lineItems, cartItems)=>{
    const parcelMethods = lineItems.filter((lineItem)=>lineItem.type === "Parcel").reduce((acc, param)=>{
        let { tiers  } = param;
        if (acc.length === 0) {
            acc = tiers;
        } else {
            if (acc.length < tiers.length) {
                tiers = tiers.filter((tier)=>acc.find((t)=>t.name === tier.name));
            } else if (acc.length > tiers.length) {
                acc = acc.filter((tier)=>tiers.find((t)=>t.name === tier.name));
            }
            tiers.forEach((tier)=>{
                if (acc.find((t)=>t.name === tier.name)) acc.find((t)=>t.name === tier.name).centAmount += tier === null || tier === void 0 ? void 0 : tier.centAmount;
            });
        }
        return acc;
    }, []);
    const freightMethods = lineItems.filter((lineItem)=>lineItem.type === "LTL").reduce((acc, param)=>{
        let { tiers  } = param;
        acc.length === 0 ? acc = tiers : tiers.forEach((tier)=>{
            acc.find((t)=>t.name === tier.name).centAmount += tier === null || tier === void 0 ? void 0 : tier.centAmount;
        });
        return acc;
    }, []);
    const servicetMethods = lineItems.filter((lineItem)=>lineItem.type === "Design Services").reduce((acc, param)=>{
        let { tiers  } = param;
        acc.length === 0 ? acc = tiers : tiers.forEach((tier)=>{
            acc.find((t)=>t.name === tier.name).centAmount + (tier === null || tier === void 0 ? void 0 : tier.centAmount);
        });
        return acc;
    }, []);
    const parcelItems = [];
    const freightItems = [];
    const eDeliveryItems = [];
    lineItems.filter((lineItem)=>lineItem.type === "Parcel").map((item)=>{
        if (item.parentLineItemId) {
            const comboChild = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.lineItemId);
            if (parcelItems.find((prod)=>prod.id === item.parentLineItemId)) {
                var ref;
                const comboParent = parcelItems.find((prod)=>prod.id === item.parentLineItemId) || {};
                (ref = comboParent.childItems) === null || ref === void 0 ? void 0 : ref.push(comboChild);
            } else {
                const comboParent1 = {
                    ...(cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.parentLineItemId)) || {}
                };
                comboParent1.childItems = [
                    comboChild
                ];
                parcelItems.push(comboParent1);
            }
        } else {
            const cartItem = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.lineItemId);
            parcelItems.push(cartItem);
        }
    });
    lineItems.filter((lineItem)=>lineItem.type === "LTL").map((item)=>{
        if (item.parentLineItemId) {
            const comboChild = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.lineItemId);
            if (freightItems.find((prod)=>prod.id === item.parentLineItemId)) {
                var ref;
                const comboParent = freightItems.find((prod)=>prod.id === item.parentLineItemId) || {};
                (ref = comboParent.childItems) === null || ref === void 0 ? void 0 : ref.push(comboChild);
            } else {
                const comboParent1 = {
                    ...(cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.parentLineItemId)) || {}
                };
                comboParent1.childItems = [
                    comboChild
                ];
                freightItems.push(comboParent1);
            }
        } else {
            const cartItem = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.lineItemId);
            freightItems.push(cartItem);
        }
    });
    lineItems.filter((lineItem)=>lineItem.type === "Design Services").map((item)=>{
        if (item) {
            const cartItem = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find((prod)=>prod.id === item.lineItemId);
            eDeliveryItems.push(cartItem);
        }
    });
    return {
        freightMethods,
        parcelMethods,
        servicetMethods,
        parcelItems,
        freightItems,
        eDeliveryItems
    };
};
const getPromoTotalAmount = (codes, name)=>{
    let total = 0;
    codes.forEach((e)=>{
        if (e.name === name) {
            total += Number(e.discount);
        }
    });
    return total;
};
const serviceAmount = (services, selected)=>{
    var ref;
    const serviceAmount = Number(((ref = services[selected === null || selected === void 0 ? void 0 : selected.service]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100);
    return serviceAmount;
};
const getFreightsAmount = (data)=>{
    var ref;
    const { freights , selected , currencySign , promoCodes , freightName , freeShipping  } = data;
    const totalPromo = getPromoTotalAmount(promoCodes, freightName);
    const freightAmount = Number(((ref = freights[selected === null || selected === void 0 ? void 0 : selected.freight]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100) - totalPromo;
    const shippingCost = freightAmount ? "".concat(currencySign).concat(freightAmount.toFixed(2)) : freeShipping;
    return shippingCost;
};
const getParcelsAmount = (data)=>{
    var ref;
    const { currencySign , parcels , selected , promoCodes , parcelName , freeShipping  } = data;
    const totalPromo = getPromoTotalAmount(promoCodes, parcelName);
    const parcelsAmount = Number(((ref = parcels[selected === null || selected === void 0 ? void 0 : selected.parcel]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100) - totalPromo;
    const shippingCost = parcelsAmount ? "".concat(currencySign).concat(parcelsAmount.toFixed(2)) : freeShipping;
    return shippingCost;
};
const optionAmount = (option)=>{
    const optionAmount = Number(option.centAmount / 100);
    return optionAmount;
};
const discountMethod = (cart)=>{
    var ref;
    cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).forEach((item)=>{
        var ref;
        let discountPercentage = 0;
        if ((ref = item.price) === null || ref === void 0 ? void 0 : ref.discounted) discountPercentage = Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(item.price.discounted, "discount.obj.value.permyriad", 0)) / 100;
        if (item.discountedPrice) discountPercentage = Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(item.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
        return discountPercentage;
    });
};
const getDeliveryOption = (selected)=>{
    let deliveryOption;
    if (selected && selected.parcel === 1) {
        deliveryOption = "express";
    } else if (selected && selected.parcel === 2) {
        deliveryOption = "premium";
    } else {
        deliveryOption = "standard";
    }
    return deliveryOption;
};


/***/ }),

/***/ 63519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ PAYMENTS; },
/* harmony export */   "BV": function() { return /* binding */ CHECKOUT_WITH; },
/* harmony export */   "Bg": function() { return /* binding */ CHECKBOX; },
/* harmony export */   "Bu": function() { return /* binding */ PASSWORD_RESET; },
/* harmony export */   "Bz": function() { return /* binding */ PRIVACY_POLICY; },
/* harmony export */   "C8": function() { return /* binding */ EXPAND; },
/* harmony export */   "Dp": function() { return /* binding */ SHIPPING_RESTRICTIONS; },
/* harmony export */   "GK": function() { return /* binding */ PRODUCT_NAVIGATION; },
/* harmony export */   "H0": function() { return /* binding */ CALL_SUPPORT_PHONE_NUMBER; },
/* harmony export */   "H4": function() { return /* binding */ SIGN_IN; },
/* harmony export */   "HA": function() { return /* binding */ ORDER_SUMMARY; },
/* harmony export */   "IA": function() { return /* binding */ MORE_DETAILS; },
/* harmony export */   "Jd": function() { return /* binding */ REVIEW; },
/* harmony export */   "LE": function() { return /* binding */ NOT_APPLICABLE; },
/* harmony export */   "LJ": function() { return /* binding */ TERMS_OF_USE; },
/* harmony export */   "M2": function() { return /* binding */ CREDIT_CARD; },
/* harmony export */   "Mq": function() { return /* binding */ PROFESSIONAL_ACCOUNT; },
/* harmony export */   "Mu": function() { return /* binding */ SHOW_PASSWORD; },
/* harmony export */   "N5": function() { return /* binding */ HIDE_PASSWORD; },
/* harmony export */   "Ok": function() { return /* binding */ ENTER_ADDRESS_MANUALLY; },
/* harmony export */   "P6": function() { return /* binding */ LOAD_MORE; },
/* harmony export */   "Pr": function() { return /* binding */ SAVE_ADDRESS_TO_MY_ACCOUNT; },
/* harmony export */   "Qf": function() { return /* binding */ SHIPPING_VERIFY_ADDRESS; },
/* harmony export */   "VP": function() { return /* binding */ EDIT_CART; },
/* harmony export */   "X0": function() { return /* binding */ LANDING; },
/* harmony export */   "YR": function() { return /* binding */ PAYPAL; },
/* harmony export */   "ZF": function() { return /* binding */ CREATE_A_QUICK_ACCOUNT; },
/* harmony export */   "_K": function() { return /* binding */ SELECT_BUSINESS_TYPE; },
/* harmony export */   "_i": function() { return /* binding */ SIGN_ME_UP_FOR_THE_E_NEWSLETTER; },
/* harmony export */   "b2": function() { return /* binding */ STANDARD; },
/* harmony export */   "cD": function() { return /* binding */ CHECKOUT_PROCESS_BUTTON; },
/* harmony export */   "cL": function() { return /* binding */ HOMEOWNER_ACCOUNT; },
/* harmony export */   "dM": function() { return /* binding */ CHECKOUT_WITH_PAYPAL; },
/* harmony export */   "dR": function() { return /* binding */ CONTINUE; },
/* harmony export */   "do": function() { return /* binding */ PAYPAL_ERROR; },
/* harmony export */   "fC": function() { return /* binding */ PROFESSIONAL; },
/* harmony export */   "hB": function() { return /* binding */ BILLING_INFORMATION; },
/* harmony export */   "hE": function() { return /* binding */ DELIVERY_OPTIONS; },
/* harmony export */   "hL": function() { return /* binding */ PAYMENT_METHOD; },
/* harmony export */   "iK": function() { return /* binding */ CHECKOUT; },
/* harmony export */   "iq": function() { return /* binding */ PLACE_ORDER; },
/* harmony export */   "jU": function() { return /* binding */ CUSTOMER_SUPPORT; },
/* harmony export */   "k": function() { return /* binding */ HELP_SUPPORT; },
/* harmony export */   "k2": function() { return /* binding */ NAVIGATION; },
/* harmony export */   "kj": function() { return /* binding */ PAYMENT_BILLING; },
/* harmony export */   "lP": function() { return /* binding */ FORGOT_PASSWORD; },
/* harmony export */   "nm": function() { return /* binding */ PROMO; },
/* harmony export */   "o0": function() { return /* binding */ SHIPPING; },
/* harmony export */   "pG": function() { return /* binding */ CHECKOUT_PCIPAL; },
/* harmony export */   "qG": function() { return /* binding */ SAVE_AND_CONTINUE; },
/* harmony export */   "sc": function() { return /* binding */ COLLAPSE; },
/* harmony export */   "wQ": function() { return /* binding */ MOUSE_OVER; },
/* harmony export */   "z8": function() { return /* binding */ CITY_DROPDOWN; },
/* harmony export */   "zD": function() { return /* binding */ SUBMIT; },
/* harmony export */   "zh": function() { return /* binding */ SAVE_CHANGES; },
/* harmony export */   "zy": function() { return /* binding */ RESEND_EMAIL; }
/* harmony export */ });
/* unused harmony exports NEXT, CART_LABEL */
const CHECKOUT = "checkout";
const SHIPPING = "shipping";
const STANDARD = "standard";
const NAVIGATION = "navigation";
const ENTER_ADDRESS_MANUALLY = "enter address manually";
const SAVE_AND_CONTINUE = "save & continue";
const CONTINUE = "continue";
const DELIVERY_OPTIONS = "delivery options";
const MORE_DETAILS = "more details";
const LANDING = "landing page";
const CALL_SUPPORT_PHONE_NUMBER = "call support number";
const HELP_SUPPORT = "help support";
const CUSTOMER_SUPPORT = "customer support";
const ORDER_SUMMARY = "order summary";
const EDIT_CART = "edit cart";
const LOAD_MORE = "load more";
const PRODUCT_NAVIGATION = "product navigation";
const PROMO = "promo";
const PAYMENT_BILLING = "payment & billing";
const CREDIT_CARD = "credit card";
const REVIEW = "review";
const CHECKOUT_WITH = "checkout with";
const CHECKOUT_PROCESS_BUTTON = "process";
const CHECKOUT_PCIPAL = "pci pal";
const TERMS_OF_USE = "terms of use";
const PRIVACY_POLICY = "privacy policy";
const CHECKOUT_WITH_PAYPAL = "checkout with paypal";
const PAYPAL = "paypal";
const PAYMENTS = "payments";
const CREATE_A_QUICK_ACCOUNT = "create a quick account";
const FORGOT_PASSWORD = "forgot password";
const PASSWORD_RESET = "password reset";
const NEXT = "next";
const HOMEOWNER_ACCOUNT = "homeowner account";
const PROFESSIONAL_ACCOUNT = "professional account";
const SAVE_CHANGES = "save changes";
const SHIPPING_VERIFY_ADDRESS = "shipping verify address";
const BILLING_INFORMATION = "billing information";
const PLACE_ORDER = "place order";
const PAYMENT_METHOD = "payment method";
const EXPAND = "expand";
const COLLAPSE = "collapse";
const SIGN_IN = "sign in";
const MOUSE_OVER = "mouseover";
const SHOW_PASSWORD = "show password";
const HIDE_PASSWORD = "hide password";
const CITY_DROPDOWN = "city dropdown selection";
const PROFESSIONAL = "professional";
const SELECT_BUSINESS_TYPE = "select business type";
const SAVE_ADDRESS_TO_MY_ACCOUNT = "save address to my account";
const CHECKBOX = "checkbox";
const SIGN_ME_UP_FOR_THE_E_NEWSLETTER = "sign me up for the e-newsletter";
const SHIPPING_RESTRICTIONS = "shipping restrictions";
const SUBMIT = "submit";
const RESEND_EMAIL = "resend email";
const PAYPAL_ERROR = "paypal error";
const CART_LABEL = "cart";
const NOT_APPLICABLE = "not applicable";


/***/ }),

/***/ 37490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ addCheckoutSignInAnalyticsData; },
/* harmony export */   "Bw": function() { return /* binding */ addPlaceOrderCCAnalytics; },
/* harmony export */   "Ht": function() { return /* binding */ addAnalyticsBackOrderTooltip; },
/* harmony export */   "IN": function() { return /* binding */ addAnalyticsForPciProcessBtnClick; },
/* harmony export */   "JS": function() { return /* binding */ mouseOverTooltipAnalytics; },
/* harmony export */   "L8": function() { return /* binding */ addLoginAnalytics; },
/* harmony export */   "Mb": function() { return /* binding */ placeOrderClickFailed; },
/* harmony export */   "N2": function() { return /* binding */ createQuickAccountAnalytics; },
/* harmony export */   "NV": function() { return /* binding */ addContinueToPaymentAnalytics; },
/* harmony export */   "Nx": function() { return /* binding */ addShippingAnalytics; },
/* harmony export */   "O": function() { return /* binding */ addAnalyticsVerifyAddress; },
/* harmony export */   "PI": function() { return /* binding */ addAnalyticsForPaypalButton; },
/* harmony export */   "Q6": function() { return /* binding */ addAnalyticsNewsletterSignupClick; },
/* harmony export */   "Ve": function() { return /* binding */ addAnalyticsForErrorCheckout; },
/* harmony export */   "XA": function() { return /* binding */ addAnalyticsShowHidePasswordClick; },
/* harmony export */   "ab": function() { return /* binding */ addAnalyticsCallSupportNumber; },
/* harmony export */   "ak": function() { return /* binding */ editCartAnalytics; },
/* harmony export */   "b3": function() { return /* binding */ addAnalyticsObjForMoreDetails; },
/* harmony export */   "c7": function() { return /* binding */ productClickAnalytics; },
/* harmony export */   "d$": function() { return /* binding */ loadMoreAnalytics; },
/* harmony export */   "fd": function() { return /* binding */ addAnalyticsForErrorMessages; },
/* harmony export */   "gM": function() { return /* binding */ addEmailAnalytics; },
/* harmony export */   "hE": function() { return /* binding */ enterAddressManuallyAnalytics; },
/* harmony export */   "hn": function() { return /* binding */ addAnalyticsSaveAddressClick; },
/* harmony export */   "hv": function() { return /* binding */ forgotPasswordAnalytics; },
/* harmony export */   "iD": function() { return /* binding */ forgotPasswordModalAnalytics; },
/* harmony export */   "jN": function() { return /* binding */ addAnalyticsOrderSummaryDropDown; },
/* harmony export */   "k0": function() { return /* binding */ addAnalyticsForPciPal; },
/* harmony export */   "kz": function() { return /* binding */ shippingErrorTaxCalculate; },
/* harmony export */   "mQ": function() { return /* binding */ addAnalyticsBusinessTypeDropDownClick; },
/* harmony export */   "nF": function() { return /* binding */ paypalXPPErrorOnLanding; },
/* harmony export */   "nU": function() { return /* binding */ updatePromoAnalytics; },
/* harmony export */   "oM": function() { return /* binding */ addAnalyticsRemoveItems; },
/* harmony export */   "rA": function() { return /* binding */ addAnalyticsDeliveryComboSku; },
/* harmony export */   "xh": function() { return /* binding */ addAnalyticsCityClick; },
/* harmony export */   "yd": function() { return /* binding */ addAnalyticsForCardPayment; },
/* harmony export */   "yo": function() { return /* binding */ addAnalyticsForPaypal; },
/* harmony export */   "zl": function() { return /* binding */ addAnalyticsBillingInformationBtnClick; }
/* harmony export */ });
/* unused harmony export passwordResetCloseAnalytics */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63519);
/* harmony import */ var _DeliveryOptions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90625);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);





const getAnalyticsCartData = async (cartObj)=>{
    if (!cartObj || typeof cartObj !== "object" || Object.keys(cartObj).length === 0) {
        return null;
    }
    try {
        return await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .calculateCartData */ .DpP)({
            cart: cartObj
        }, true);
    } catch (error) {
        console.warn("Cart calculation failed:", error);
        return null;
    }
};
const enterAddressManuallyAnalytics = ()=>{
    const eventInfo = getEventInfo(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENTER_ADDRESS_MANUALLY */ .Ok);
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addEmailAnalytics = async (data)=>{
    var ref, ref1, ref2;
    const { isAuth , email , errors , type , saveChanges , isCreateAccount =false , isVerifyAddress =false , selectedAccount , newsletterSignup =false  } = data;
    const internalLinkName = type === "edit" ? saveChanges.toLowerCase() : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG;
    let eventAction;
    let internalLinkType;
    let internalLinkZoneName;
    if (isCreateAccount) {
        eventAction = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(selectedAccount === "homeowner" ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEOWNER_ACCOUNT */ .cL : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROFESSIONAL_ACCOUNT */ .Mq, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG);
        internalLinkType = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(selectedAccount === "homeowner" ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .HOMEOWNER_ACCOUNT */ .cL : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROFESSIONAL_ACCOUNT */ .Mq);
        internalLinkZoneName = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_A_QUICK_ACCOUNT */ .ZF);
    } else if (isVerifyAddress) {
        eventAction = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_CHANGES */ .zh);
        internalLinkType = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2);
        internalLinkZoneName = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0);
    } else {
        eventAction = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(type === "edit" ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_CHANGES */ .zh : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG);
        internalLinkType = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2);
        internalLinkZoneName = "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0);
    }
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: !errors.length ? "n/a" : (ref = errors.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
        eventStatus: !errors.length ? "success" : "failure",
        internalLinkName,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType,
        internalLinkZoneName,
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        ...isCreateAccount && !errors.length && {
            newsletterSignUp: newsletterSignup
        }
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    var ref3;
    const cartObj = (ref3 = (ref1 = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cart) === null || ref2 === void 0 ? void 0 : ref2.cart) !== null && ref3 !== void 0 ? ref3 : {};
    const cartData = await getAnalyticsCartData(cartObj);
    page.cart = (cartData === null || cartData === void 0 ? void 0 : cartData.cart) || {};
    delete page.pageName;
    delete page.pageUrl;
    delete page.productInfo;
    if (!isAuth && email) {
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .shaEncrypt */ .aLl)(email).then((encryptedEmail)=>{
            localStorage.setItem("hashedEmail", encryptedEmail);
            page.user = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getUserAnalyticsObject */ .L7i)({
                encryptedEmail
            });
            window.adobeDataLayer.push({
                event: "cmp:click",
                page: page,
                eventInfo
            });
        }).catch((er)=>{
            window.adobeDataLayer.push({
                event: "cmp:click",
                page: page,
                eventInfo
            });
        });
    } else {
        window.adobeDataLayer.push({
            event: "cmp:click",
            page: page,
            eventInfo
        });
    }
};
const createQuickAccountAnalytics = ()=>{
    const eventInfo = getEventInfo(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_A_QUICK_ACCOUNT */ .ZF);
    pushAnalyticsObjToDataLayer(eventInfo);
};
const forgotPasswordAnalytics = ()=>{
    const eventInfo = getEventInfo(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .FORGOT_PASSWORD */ .lP);
    pushAnalyticsObjToDataLayer(eventInfo);
};
const forgotPasswordModalAnalytics = (param)=>{
    let { status , isMailSent , message , i18n  } = param;
    var ref, ref1, ref2;
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PASSWORD_RESET */ .Bu, ":").concat(!isMailSent ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SUBMIT */ .zD : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .RESEND_EMAIL */ .zy),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PASSWORD_RESET */ .Bu, ":").concat(!isMailSent ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SUBMIT */ .zD : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .RESEND_EMAIL */ .zy),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: message || (status === "failure" ? (ref = i18n.generalAuthenticationError) === null || ref === void 0 ? void 0 : ref.toLowerCase() : (ref1 = i18n.mailSent) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
        eventStatus: status,
        internalLinkName: !isMailSent ? (ref2 = i18n.submit) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase() : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .RESEND_EMAIL */ .zy,
        internalLinkPosition: "auth modal",
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PASSWORD_RESET */ .Bu, ":form"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const passwordResetCloseAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(CHECKOUT, ":").concat(PASSWORD_RESET, ":close"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "".concat(CHECKOUT, ":").concat(PASSWORD_RESET, ":close"),
        eventType: NAVIGATION,
        internalLinkName: "close",
        internalLinkPosition: "auth modal",
        internalLinkType: "".concat(CHECKOUT, ":").concat(NAVIGATION),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(CHECKOUT, ":").concat(PASSWORD_RESET, ":form")
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addLoginAnalytics = (status, errorsList)=>{
    if (!window.adobeDataLayer) return;
    let formattedErrorsList = errorsList;
    if (status === "failure") {
        var ref;
        formattedErrorsList = ((ref = errorsList.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "n/a";
    }
    const eventInfo = {
        eventAction: "checkout:shipping:sign in",
        eventName: "checkout:shipping:sign in",
        eventType: "sign in",
        eventMsg: status === "failure" ? formattedErrorsList : "n/a",
        eventStatus: status,
        internalLinkName: "sign in",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const userObj = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getUserAnalyticsObject */ .L7i)();
    pushAnalyticsObjToDataLayer(eventInfo, null, null, null, userObj);
};
const getEventInfo = (action)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(action),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(action),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: action,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0)
    };
    return eventInfo;
};
const addContinueToPaymentAnalytics = async (param)=>{
    let { selected ={} , parcels =[] , isXpp =false  } = param;
    const parcelTypeName = (0,_DeliveryOptions_utils__WEBPACK_IMPORTED_MODULE_1__/* .findSelectParcelType */ .T9)(selected, parcels);
    var ref;
    const { cart: { cart: cartObj = {}  } = {}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) !== null && ref !== void 0 ? ref : {};
    const cartData = await getAnalyticsCartData(cartObj);
    const buttonType = isXpp ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CONTINUE */ .dR : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ":").concat(buttonType),
        eventMsg: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ":").concat(buttonType),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: buttonType,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ":").concat(parcelTypeName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE)
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, cartData);
};
const editCartAnalytics = (cartPage)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .EDIT_CART */ .VP),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .EDIT_CART */ .VP),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .EDIT_CART */ .VP,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: cartPage,
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const loadMoreAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOAD_MORE */ .P6),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOAD_MORE */ .P6),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOAD_MORE */ .P6,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const productClickAnalytics = (pdpUrl, productName, productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_NAVIGATION */ .GK),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_NAVIGATION */ .GK),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(productName) || "n/a",
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PRODUCT_NAVIGATION */ .GK),
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getAnalyticsUrl */ .Uho)(pdpUrl),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA)
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const updatePromoAnalytics = async (status, cart, promo, action)=>{
    const cartData = await getAnalyticsCartData(cart);
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(action, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROMO */ .nm),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(action, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROMO */ .nm),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: status === "success" ? action === "apply" ? "promocode applied successfully" : "promocode removed successfully" : status === null || status === void 0 ? void 0 : status.toLowerCase(),
        eventStatus: status === "success" ? "success" : "failure",
        internalLinkName: action,
        internalLinkPosition: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK),
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROMO */ .nm),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        promoCode: promo
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, cartData);
};
const addAnalyticsForCardPayment = ()=>{
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":checkout with card"),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":checkout with card"),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREDIT_CARD */ .M2,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsForErrorMessages = function() {
    let eventMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "n/a", eventStatus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a", isModalOpen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, eventText = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "place order", modalCloseText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const extraText = isModalOpen ? ":modal:something went wrong" : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd).concat(extraText).concat(modalCloseText, ":").concat(eventText),
        eventMsg,
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd).concat(extraText).concat(modalCloseText, ":").concat(eventText),
        eventStatus,
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: "".concat(eventText),
        internalLinkPosition: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK).concat(extraText),
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd).concat(extraText)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsObjForMoreDetails = async ()=>{
    var ref;
    const { cart: { cart: cartObj = {}  } = {}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) !== null && ref !== void 0 ? ref : {};
    const cartData = await getAnalyticsCartData(cartObj);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .MORE_DETAILS */ .IA),
        eventMsg: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .MORE_DETAILS */ .IA),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .MORE_DETAILS */ .IA,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE)
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, cartData);
};
const addAnalyticsForErrorCheckout = function(event) {
    let customerCareNum = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a";
    event.preventDefault();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd, ":").concat(customerCareNum),
        eventMsg: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd, ":").concat(customerCareNum),
        eventStatus: "n/a",
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: customerCareNum,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: window.location.href = event.target.href,
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, cartObj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, paymentMethodName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", userObj = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const page = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.cloneDeep)(window.pageObj || {});
    delete page.pageName;
    delete page.pageUrl;
    delete page.productInfo;
    if (page === null || page === void 0 ? void 0 : page.pageInfo) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : delete ref.contentIdentificationCategory;
        page === null || page === void 0 ? void 0 : (ref1 = page.pageInfo) === null || ref1 === void 0 ? void 0 : delete ref1.contentIdentificationRoom;
        page === null || page === void 0 ? void 0 : (ref2 = page.pageInfo) === null || ref2 === void 0 ? void 0 : delete ref2.contentIdentificationPurpose;
        page === null || page === void 0 ? void 0 : (ref3 = page.pageInfo) === null || ref3 === void 0 ? void 0 : delete ref3.contentIdentificationCollection;
        page === null || page === void 0 ? void 0 : (ref4 = page.pageInfo) === null || ref4 === void 0 ? void 0 : delete ref4.contentIdentificationDesignStyle;
        page === null || page === void 0 ? void 0 : (ref5 = page.pageInfo) === null || ref5 === void 0 ? void 0 : delete ref5.contentIdentificationContentType;
        page.category.room = _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NOT_APPLICABLE */ .LE;
        page.category.subCategoryName = _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK;
        if (!(page === null || page === void 0 ? void 0 : (ref6 = page.pageInfo) === null || ref6 === void 0 ? void 0 : ref6.referrer)) {
            page.pageInfo.referrer = document.referrer || sessionStorage.getItem("previousPageUrl") || "n/a";
            sessionStorage.removeItem("previousPageUrl");
        }
    }
    if (cartObj === null || cartObj === void 0 ? void 0 : cartObj.cart) {
        var ref7;
        page.cart = cartObj.cart;
        var ref8;
        const cartItems = (ref8 = page === null || page === void 0 ? void 0 : (ref7 = page.cart) === null || ref7 === void 0 ? void 0 : ref7.item) !== null && ref8 !== void 0 ? ref8 : [];
        var ref9;
        const cartItemStr = cartItems.map((item)=>{
            var ref;
            return (ref9 = (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== null && ref9 !== void 0 ? ref9 : "";
        }).filter(Boolean).join(",");
        page.cartInfo = {
            cartItems: cartItemStr
        };
        window.pageObj.cart = cartObj.cart;
        window.pageObj.cartInfo = {
            cartItems: cartItemStr
        };
    }
    if (paymentMethodName) {
        page.cart = {
            ...page.cart,
            payment: {
                paymentMethod: paymentMethodName
            }
        };
    }
    if (userObj && typeof userObj === "object" && Object.keys(userObj).length > 0) {
        page.user = userObj;
    }
    const eventData = {
        event: "cmp:click",
        eventInfo,
        page
    };
    if (productInfo && typeof productInfo === "object" && Object.keys(productInfo).length > 0) {
        eventData.productInfo = productInfo;
    }
    window.adobeDataLayer.push(eventData);
};
const addAnalyticsCallSupportNumber = (e)=>{
    var ref, ref1;
    if (!(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.innerText)) return;
    const innerText = e.target.innerText;
    let eventInfo = {};
    const isEmail = innerText.toLowerCase().includes("email");
    const actionValue = isEmail ? innerText.toLowerCase() : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CALL_SUPPORT_PHONE_NUMBER */ .H0;
    eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(actionValue),
        eventMsg: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(actionValue),
        eventStatus: "n/a",
        eventType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .HELP_SUPPORT */ .k),
        internalLinkName: isEmail ? innerText.toLowerCase() : innerText,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":navigation"),
        internalLinkURL: isEmail ? e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.href : "tel:".concat(innerText),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CUSTOMER_SUPPORT */ .jU)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const mouseOverTooltipAnalytics = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    const { type , i18n  } = data;
    const eventText = "cart:landing page:".concat(type === (i18n === null || i18n === void 0 ? void 0 : i18n.oversizedFragileDelivery) ? type.toLowerCase().replace("/", " ") : "estimated ".concat(type), " mouseover");
    const eventLinkName = type === (i18n === null || i18n === void 0 ? void 0 : i18n.oversizedFragileDelivery) ? (ref1 = (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(i18n === null || i18n === void 0 ? void 0 : i18n.oversizedDelivery)) === null || ref === void 0 ? void 0 : ref.split("  ")) === null || ref1 === void 0 ? void 0 : ref1.join(" ") : i18n === null || i18n === void 0 ? void 0 : i18n.shippingTooltip.toLowerCase();
    const eventInfo = {
        eventAction: eventText,
        eventName: eventText,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type === "tax" ? i18n === null || i18n === void 0 ? void 0 : i18n.taxTooltip.toLowerCase() : eventLinkName,
        internalLinkPosition: "cart",
        internalLinkType: "cart:mouseover",
        internalLinkZoneName: "cart:landing page:order summary",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsForPaypal = ()=>{
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_WITH_PAYPAL */ .dM),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_WITH_PAYPAL */ .dM),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL */ .YR,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsForPaypalButton = ()=>{
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL */ .YR, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENTS */ .Ar),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL */ .YR, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENTS */ .Ar),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL */ .YR,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj),
        internalLinkURL: "n/a",
        clickInternalLinks: "false"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsForPciPal = function() {
    let pciPalTxt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_WITH */ .BV, " ").concat(pciPalTxt),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_WITH */ .BV, " ").concat(pciPalTxt),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_PCIPAL */ .pG,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsForPciProcessBtnClick = ()=>{
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_WITH */ .BV, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_PCIPAL */ .pG, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_PROCESS_BUTTON */ .cD),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_WITH */ .BV, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_PCIPAL */ .pG, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_PROCESS_BUTTON */ .cD),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT_PCIPAL */ .pG,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsVerifyAddress = function() {
    let action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING_VERIFY_ADDRESS */ .Qf, ":").concat(action),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING_VERIFY_ADDRESS */ .Qf, ":").concat(action),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: action,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING_VERIFY_ADDRESS */ .Qf),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsBillingInformationBtnClick = function() {
    let btnTxt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .BILLING_INFORMATION */ .hB, ":").concat(btnTxt),
        eventMsg: "n/a",
        eventStatus: "success",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .BILLING_INFORMATION */ .hB, ":").concat(btnTxt),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: btnTxt,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .BILLING_INFORMATION */ .hB)
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addPlaceOrderCCAnalytics = function() {
    let paymentMethod = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "n/a", status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a", link = arguments.length > 2 ? arguments[2] : void 0, errorMsg = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_ORDER */ .iq),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_ORDER */ .iq),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: errorMsg || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_ORDER */ .iq,
        internalLinkPosition: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK),
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_METHOD */ .hL, ":").concat(paymentMethod),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_BILLING */ .kj),
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, null, "Credit Card");
};
const placeOrderClickFailed = (errorMsg)=>{
    var ref;
    const { checkout: { paymentMethodName =""  } = {}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) !== null && ref !== void 0 ? ref : {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_ORDER */ .iq),
        eventMsg: errorMsg || "placeorder failed",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_ORDER */ .iq),
        eventStatus: "failure",
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PLACE_ORDER */ .iq,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .REVIEW */ .Jd)
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, null, paymentMethodName);
};
const addAnalyticsOrderSummaryDropDown = function() {
    let actionType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, " ").concat(actionType),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .LANDING */ .X0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA, " ").concat(actionType),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: actionType,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_SUMMARY */ .HA),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addCheckoutSignInAnalyticsData = ()=>{
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_IN */ .H4),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_IN */ .H4),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_IN */ .H4,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const paypalXPPErrorOnLanding = async (data)=>{
    const { customErrorMsg  } = data;
    var ref;
    const { cart: { cart: cartObj = {}  } = {}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) !== null && ref !== void 0 ? ref : {};
    const cartData = await getAnalyticsCartData(cartObj);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":landing page:").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL_ERROR */ ["do"]),
        eventMsg: customErrorMsg,
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":landing page:").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL_ERROR */ ["do"]),
        eventStatus: "failure",
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYPAL_ERROR */ ["do"],
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":landing page")
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, cartData);
};
const shippingErrorTaxCalculate = async (data)=>{
    const { customErrorMsg  } = data;
    var ref;
    const { cart: { cart: cartObj = {}  } = {}  } = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) !== null && ref !== void 0 ? ref : {};
    const cartData = await getAnalyticsCartData(cartObj);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG),
        eventMsg: customErrorMsg,
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG),
        eventStatus: "failure",
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0)
    };
    pushAnalyticsObjToDataLayer(eventInfo, null, cartData);
};
const addShippingAnalytics = (status, message, i18n)=>{
    if (window.adobeDataLayer) {
        const eventInfo = getShippingEventInfo(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG, true);
        if (status) {
            eventInfo.eventStatus = status;
        }
        if (message) {
            if (message === "failed to set shipping address." || message === "failed to get shipping options.") {
                var ref;
                message = (ref = i18n.shippingProcessError) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            }
            eventInfo.eventMsg = message;
        }
        pushAnalyticsObjToDataLayer(eventInfo);
    }
};
const getShippingEventInfo = function(type) {
    let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(type),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(type),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addAnalyticsDeliveryComboSku = (param)=>{
    let { title ="" , actionTitle ="" , parcels =[] , selected ={}  } = param;
    const parcelTypeName = (0,_DeliveryOptions_utils__WEBPACK_IMPORTED_MODULE_1__/* .findSelectParcelType */ .T9)(selected, parcels);
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ": ").concat(title).concat(actionTitle),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ": ").concat(title).concat(actionTitle),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: actionTitle,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(parcelTypeName, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ": ").concat(title),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsBackOrderTooltip = (param)=>{
    let { title ="" , parcels =[] , selected ={} , tooltipMsg =""  } = param;
    const parcelTypeName = (0,_DeliveryOptions_utils__WEBPACK_IMPORTED_MODULE_1__/* .findSelectParcelType */ .T9)(selected, parcels);
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ": ").concat(title, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .MOUSE_OVER */ .wQ),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ": ").concat(title, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .MOUSE_OVER */ .wQ),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: tooltipMsg,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(parcelTypeName, " ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_OPTIONS */ .hE, ": ").concat(title),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsShowHidePasswordClick = (param)=>{
    let { btnClickAction =""  } = param;
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_IN */ .H4, ":").concat(btnClickAction),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_IN */ .H4, ":").concat(btnClickAction),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: btnClickAction,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ": ").concat(btnClickAction),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_IN */ .H4),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsCityClick = function() {
    let cityName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedAccount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const selectedAccountType = selectedAccount ? ":".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_A_QUICK_ACCOUNT */ .ZF, ":").concat(selectedAccount, " account") : ":".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0);
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CITY_DROPDOWN */ .z8, ":").concat(cityName),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CITY_DROPDOWN */ .z8, ":").concat(cityName),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: cityName,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK).concat(selectedAccountType),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CITY_DROPDOWN */ .z8),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsBusinessTypeDropDownClick = function() {
    let businessType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_A_QUICK_ACCOUNT */ .ZF, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROFESSIONAL */ .fC, ":").concat(businessType),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_A_QUICK_ACCOUNT */ .ZF, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROFESSIONAL */ .fC, ":").concat(businessType),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: businessType,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SELECT_BUSINESS_TYPE */ ._K, ":").concat(businessType),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_A_QUICK_ACCOUNT */ .ZF, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .PROFESSIONAL */ .fC),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsSaveAddressClick = function() {
    let checkboxAction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const selectedText = checkboxAction ? "selection" : "unselection";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_ADDRESS_TO_MY_ACCOUNT */ .Pr, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_ADDRESS_TO_MY_ACCOUNT */ .Pr, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_ADDRESS_TO_MY_ACCOUNT */ .Pr, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_ADDRESS_TO_MY_ACCOUNT */ .Pr),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsNewsletterSignupClick = function() {
    let checkboxAction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const selectedText = checkboxAction ? "selection" : "unselection";
    const eventInfo = {
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_ME_UP_FOR_THE_E_NEWSLETTER */ ._i, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_ME_UP_FOR_THE_E_NEWSLETTER */ ._i, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_ME_UP_FOR_THE_E_NEWSLETTER */ ._i, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKBOX */ .Bg, " ").concat(selectedText),
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ": ").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIGN_ME_UP_FOR_THE_E_NEWSLETTER */ ._i),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsRemoveItems = async function() {
    let product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref, ref1;
    const cartObj = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const cartData = await getAnalyticsCartData(cartObj);
    const productArrayLists = product ? product.length > 1 : false;
    const prodcutLists = [];
    if (product === null || product === void 0 ? void 0 : product.length) {
        product === null || product === void 0 ? void 0 : product.forEach((prod)=>{
            const { customProductInfo ="{}"  } = prod;
            const productInformation = JSON.parse(customProductInfo);
            prodcutLists.push(productInformation === null || productInformation === void 0 ? void 0 : productInformation.productInfo);
        });
    }
    const removeText = productArrayLists ? "remove items" : "remove item";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING_RESTRICTIONS */ .Dp, ":").concat(removeText),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING */ .o0, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SAVE_AND_CONTINUE */ .qG, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING_RESTRICTIONS */ .Dp, ":").concat(removeText),
        eventType: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2,
        internalLinkName: removeText,
        internalLinkPosition: _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK,
        internalLinkType: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .NAVIGATION */ .k2),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHECKOUT */ .iK, ":").concat(_components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHIPPING_RESTRICTIONS */ .Dp)
    };
    const productInfoJSON = (prodcutLists === null || prodcutLists === void 0 ? void 0 : prodcutLists.length) > 0 ? {
        productInfo: prodcutLists
    } : null;
    pushAnalyticsObjToDataLayer(eventInfo, productInfoJSON, cartData);
};


/***/ }),

/***/ 82321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ loggerCallBack; }
/* harmony export */ });
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);

const redactedEmail = (email)=>{
    if (!email) return "";
    const [localPart, domain] = email.split("@");
    const redactedLocalPart = localPart.charAt(0) + "***" + localPart.charAt(localPart.length - 1);
    return "".concat(redactedLocalPart, "@").concat(domain);
};
const loggerCallBack = (param)=>{
    let { logger =()=>{} , message ="" , action ="" , data ={}  } = param;
    const { auth: { user: { lowercaseEmail =""  } = {} , isAuth =false  } = {}  } = _store_index__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token");
    let oktaObject = {};
    try {
        oktaObject = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
    } catch (e) {
        console.warn("Anonymous Okta Token can not be decoded......", e.message);
        oktaObject = {};
    }
    const objectId = (oktaObject === null || oktaObject === void 0 ? void 0 : oktaObject.gId) || "";
    const email = redactedEmail(lowercaseEmail);
    const logDetails = isAuth ? {
        ...data,
        user: email
    } : {
        ...data,
        guestID: objectId
    } || {};
    switch(action.toLocaleLowerCase()){
        case "error":
            logger === null || logger === void 0 ? void 0 : logger.error(message, logDetails);
            break;
        case "info":
            logger === null || logger === void 0 ? void 0 : logger.info(message, logDetails);
            break;
        case "warn":
            logger === null || logger === void 0 ? void 0 : logger.warn(message, logDetails);
            break;
        default:
            logger === null || logger === void 0 ? void 0 : logger.log(message, logDetails);
            break;
    }
};


/***/ }),

/***/ 12378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bf": function() { return /* binding */ getShippingApiError; },
/* harmony export */   "Bu": function() { return /* binding */ isValidInputData; },
/* harmony export */   "W2": function() { return /* binding */ getUpdatedCart; },
/* harmony export */   "We": function() { return /* binding */ getAddressSuggestions; },
/* harmony export */   "b0": function() { return /* binding */ validateInput; },
/* harmony export */   "e$": function() { return /* binding */ getErrorMessage; },
/* harmony export */   "eG": function() { return /* binding */ checkIsShippingRestricted; },
/* harmony export */   "nc": function() { return /* binding */ setShippingAddress; },
/* harmony export */   "tz": function() { return /* binding */ getShippingAddressFormated; },
/* harmony export */   "wr": function() { return /* binding */ validateAllFields; },
/* harmony export */   "xj": function() { return /* binding */ checkInactivePromos; }
/* harmony export */ });
/* unused harmony exports refreshCart, createOrder, getEventInfo */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _components_checkout_v2_utils_payment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13593);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64757);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97433);
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30696);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60475);
/* harmony import */ var _services_checkoutService__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21315);
/* harmony import */ var _components_checkout_v2_utils_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56980);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93284);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20558);
/* harmony import */ var _components_checkout_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82883);
/* harmony import */ var _components_checkout_v2_analytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37490);
/* harmony import */ var _components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(82321);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

















const getGeoLocationDataFromCookie = ()=>{
    var ref;
    const userLocation = ((ref = document.cookie.match("(^|;)\\s*userLocation\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    let geoLocationData = {};
    if (userLocation !== "") {
        const splitLocation = userLocation.split("+");
        if (splitLocation[4] && splitLocation[5]) {
            geoLocationData = {
                lat: splitLocation[4],
                lng: splitLocation[5]
            };
        }
    }
    return geoLocationData;
};
const getAddressSuggestions = async function(addr) {
    let useGeoLocation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, logger = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{};
    if (!addr || addr.trim() === "") return [];
    try {
        let geoLocationData = {};
        // If useGeoLocation is true, get the geo location data from cookie
        if (useGeoLocation) {
            geoLocationData = getGeoLocationDataFromCookie();
        }
        const res = await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addresssSuggest */ .th)({
            addr,
            geoLocationData
        }));
        if (res && res.payload && res.payload.results) {
            var _suggestion;
            return res.payload.results.map((item)=>(_suggestion = item.suggestion) !== null && _suggestion !== void 0 ? _suggestion : "");
        } else if (res === null || res === void 0 ? void 0 : res.error) {
            throw res.error;
        }
        return [];
    } catch (err) {
        (0,_components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_16__/* .loggerCallBack */ .u)({
            logger,
            action: "warn",
            message: "Failed to get suggestions from Experian",
            data: {
                error: err
            }
        });
        throw err;
    }
};
const refreshCart = async ()=>{
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { lineItems =[] , taxedPrice ={}  } = cart;
    if ((lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) === 0) return;
    const shippingZip = localStorage.getItem("shippingZip");
    let payload = {};
    if (shippingZip && shippingZip.trim() !== "" && !taxedPrice) {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                },
                {
                    action: "calculateTax"
                }
            ]
        };
    } else {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                }
            ]
        };
    }
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(payload)).unwrap().then((res)=>{
        if (res) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
        }
    });
};
const checkInactivePromos = async (data)=>{
    const actions = [];
    let actionData;
    const { cart: { cart: { discountCodes =[]  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const deviceId = (0,_utils_index__WEBPACK_IMPORTED_MODULE_13__/* .getDeviceId */ .Zw)();
    discountCodes.filter((item)=>item.state !== "MatchesCart").map((item)=>{
        var ref;
        actions.push({
            action: "removeDiscountCode",
            discountCode: {
                typeId: "discount-code",
                id: (ref = item.discountCode) === null || ref === void 0 ? void 0 : ref.id
            }
        });
        actionData = [
            ...actions
        ];
    });
    if ((actionData === null || actionData === void 0 ? void 0 : actionData.length) > 0) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .discount */ .Al)({
            actions: actionData
        })).unwrap().then((res)=>{
            if (res && res.type === "Cart") {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)({
                    actions: [
                        {
                            action: "calculateTax"
                        }
                    ]
                })).unwrap().then((resp)=>{
                    if (resp && resp.type === "Cart") {
                        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
                        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(res.lineItems));
                        createOrder({
                            ...data,
                            deviceId
                        });
                    }
                });
            }
        });
    } else {
        createOrder({
            ...data,
            deviceId
        });
    }
};
const createOrder = async (data)=>{
    const { isModalOpen =false , isAciCreditCardV2 , checkoutId , deviceId , logger =()=>{}  } = data || {};
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(""));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(false));
    const { generic: { globalConfig: { general: { siteName ="" , orderConfirmPath ="/" , homepageUrl ="/"  } = {}  } = {}  } = {} , checkout: { paymentOptionName =""  } = {} , generic: { globalConfig ={}  } = {} , cart: { paymentId =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const { apiEndpoints: { orderSubmitAPITimeout =""  } = {}  } = globalConfig;
    const orderConfirmUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrlPath */ .mXk)(orderConfirmPath);
    const homePagePath = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrlPath */ .mXk)(homepageUrl);
    const payload = {
        ...!isAciCreditCardV2 && {
            deviceId,
            paymentId
        },
        ...checkoutId && {
            sessionId: checkoutId
        },
        isAciCreditCardV2,
        orderSource: siteName,
        timeout: orderSubmitAPITimeout
    };
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .orderSubmit */ .aN)(payload)).unwrap().then(async (res)=>{
        const { parentOrder: { orderNumber ="" , customerEmail =""  }  } = res;
        if (res) {
            const base64Str = Buffer.from(customerEmail).toString("base64");
            const url = "".concat(orderConfirmUrl, "?orderNumber=").concat(orderNumber, "&q=").concat(base64Str);
            if (paymentOptionName === "card") {
                (0,_components_checkout_v2_analytics__WEBPACK_IMPORTED_MODULE_15__/* .addPlaceOrderCCAnalytics */ .Bw)(paymentOptionName, "success", url);
            } else {
                await (0,_components_checkout_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_14__/* .addPlaceOrderDataLayer */ .Ye)(url, isModalOpen, paymentOptionName, "success");
            }
            const isXpp = (0,_components_checkout_v2_utils_payment__WEBPACK_IMPORTED_MODULE_4__/* .checkExpPayPal */ .DV)();
            if (paymentOptionName.toLowerCase() === "paypal" && isXpp) {
                localStorage.setItem("paymentMethodXPP", "paypalExpress");
            }
            window.history.replaceState(null, null, homePagePath);
            window.location.href = url;
        }
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(false));
    }).catch(async (error)=>{
        const { error: errorMsg , paymentCompleted =false , errorCode =null  } = error;
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(true));
        isAciCreditCardV2 && _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentMethodNameAction */ .I2)("card"));
        if (paymentCompleted) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentTechnicalFailedAction */ .t5)(true));
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsPaymentInfoAction */ .hK)(true));
        // popup condition
        } else if (errorMsg === "Declined") {
            (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .deleteFromCart */ .EI)();
            window.location.href = _constants_routes__WEBPACK_IMPORTED_MODULE_5__/* .FRAUD_DECLINED_MESSAGE_ENDPOINT */ .Ht;
        } else {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .getCart */ .dv)()).unwrap().then(async ()=>{
                await refreshCart();
                callErrorMessge(error);
            });
        }
        const authorErrorMsg = await (0,_services_checkoutService__WEBPACK_IMPORTED_MODULE_10__/* .getAciPaymentErrorMessage */ .B)(errorCode);
        const errmsg = authorErrorMsg || errorMsg;
        (0,_components_checkout_v2_analytics__WEBPACK_IMPORTED_MODULE_15__/* .placeOrderClickFailed */ .Mb)(errmsg);
        (0,_components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_16__/* .loggerCallBack */ .u)({
            logger,
            action: "error",
            message: "Order submission failed",
            data: {
                error,
                paymentCompleted
            }
        });
    });
};
const callErrorMessge = async (error)=>{
    const { generic: { globalConfig: { general: { checkoutPagePath ="/"  } = {}  } = {}  } = {} , checkout: { cardLastDigit =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const isXpp = (0,_components_checkout_v2_utils_payment__WEBPACK_IMPORTED_MODULE_4__/* .checkExpPayPal */ .DV)();
    const checkoutUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrlPath */ .mXk)(checkoutPagePath);
    if (isXpp) {
        window.history.replaceState(null, null, checkoutUrl);
    }
    const { error: errorMsg = "" , errorCode  } = error;
    try {
        const authorErrorMsg = await (0,_services_checkoutService__WEBPACK_IMPORTED_MODULE_10__/* .getAciPaymentErrorMessage */ .B)(errorCode);
        const errorMessage = authorErrorMsg.replace("card-last-4-digits", cardLastDigit);
        // payment  section open error condition
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(errorMessage || _constants___WEBPACK_IMPORTED_MODULE_6__.GENERIC_ERROR_MESSAGE));
    } catch (error1) {
        // payment  section open error condition
        const errorMsgNew = errorMsg.replace("card-last-4-digits", cardLastDigit);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(errorMsgNew || _constants___WEBPACK_IMPORTED_MODULE_6__.GENERIC_ERROR_MESSAGE));
    }
};
const getEventInfo = function(type, link) {
    let needJson = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const eventInfo = {
        eventAction: "checkout:review:" + type,
        eventName: "checkout:review:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:review",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getShippingAddressFormated = (data)=>{
    const { city ="" , country ="" , email ="" , firstName ="" , lastName ="" , phone ="" , postalCode ="" , state ="" , streetName ="" , streetNumber ="" , id =""  } = data;
    return {
        fname: {
            value: firstName,
            error: false,
            message: ""
        },
        lname: {
            value: lastName,
            error: false,
            message: ""
        },
        email: {
            value: email,
            error: false,
            message: ""
        },
        phone: {
            value: phone,
            error: false,
            message: ""
        },
        address1: {
            value: streetName,
            error: false,
            message: ""
        },
        address2: streetNumber,
        city: {
            value: city,
            error: false,
            message: ""
        },
        state: {
            value: state,
            error: false,
            message: ""
        },
        zipcode: {
            value: postalCode,
            error: false,
            message: ""
        },
        country: {
            value: country,
            error: false,
            message: ""
        },
        notes: "",
        label: {
            show: true,
            value: ""
        },
        id: id
    };
};
const getErrorMessage = function() {
    let genericMessages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], errorKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (errorKey && genericMessages.length) {
        var ref;
        var ref1;
        return (ref1 = (ref = genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.find((msg)=>msg.text === errorKey)) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : "";
    }
    return "";
};
const ERROR_TYPE_MAP = {
    setShippingAddressError: {
        key: "CHECKOUT_SHIPPING_ADDRESS_ERROR",
        i18n: "checkoutShippingAddressError"
    },
    setShippingMethodError: {
        key: "CHECKOUT_SHIPPING_METHOD_ERROR",
        i18n: "checkoutShippingMethodError"
    },
    setCalculateTaxError: {
        key: "CHECKOUT_CALCULATE_TAX_ERROR",
        i18n: "checkoutCalculateTaxError"
    }
};
const getShippingApiError = function() {
    let genericMessages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], errorType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i18n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const config = ERROR_TYPE_MAP[errorType];
    if (config) {
        return getErrorMessage(genericMessages, config.key) || i18n[config.i18n];
    }
    return getErrorMessage(genericMessages, errorType || "INVALID_DELIVERY_ADDRESS");
};
const setShippingAddress = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cb = arguments.length > 1 ? arguments[1] : void 0, needAnalytics = arguments.length > 2 ? arguments[2] : void 0, errorCb = arguments.length > 3 ? arguments[3] : void 0, expPayPalCallBackErrorMsg = arguments.length > 4 ? arguments[4] : void 0, logger = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{};
    var ref;
    var ref1;
    const { user ={}  } = (ref1 = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.auth) !== null && ref1 !== void 0 ? ref1 : {};
    const { sub: emailFromUser = ""  } = user;
    const { firstName ="" , lastName ="" , streetName ="" , streetNumber ="" , city ="" , email ="" , phone ="" , postalCode ="" , state ="" , country =""  } = data;
    const streetValue = typeof streetNumber === "string" ? streetNumber : streetNumber === null || streetNumber === void 0 ? void 0 : streetNumber.value;
    const shippingEmail = email || emailFromUser;
    const address = {
        postalCode: postalCode === null || postalCode === void 0 ? void 0 : postalCode.trim(),
        state: state === null || state === void 0 ? void 0 : state.trim(),
        country: country === null || country === void 0 ? void 0 : country.trim(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        streetName: streetName.trim(),
        city: city.trim(),
        email: shippingEmail.trim().toLowerCase(),
        phone: phone.trim(),
        streetNumber: streetValue === null || streetValue === void 0 ? void 0 : streetValue.trim()
    };
    const validationData = validateAllFields(address);
    const { isValid =true  } = validationData || {};
    if (!isValid) {
        return errorCb(validationData);
    }
    const actions = [
        {
            action: "setShippingAddress",
            address: address
        },
        {
            action: "recalculate",
            updateProductData: true
        }
    ];
    if (email) actions.push({
        action: "setCustomerEmail",
        email: email.trim().toLowerCase()
    });
    if (user === null || user === void 0 ? void 0 : user.koc) {
        actions.push({
            action: "setCustomType",
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: user === null || user === void 0 ? void 0 : user.koc,
                orderType: "ISC",
                ...(user === null || user === void 0 ? void 0 : user.sub) && {
                    CSREmailId: user === null || user === void 0 ? void 0 : user.sub
                }
            }
        });
    }
    const payload = {
        actions: actions
    };
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .shipmentUpdate */ .NM)(payload)).unwrap().then((res)=>{
        if ((res === null || res === void 0 ? void 0 : res.type) === "Cart" && res.lineItems.length > 0) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
            (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__/* .getShippingMethods */ .qy)(expPayPalCallBackErrorMsg, errorCb);
            cb && cb(address.postalCode, "success");
            needAnalytics && needAnalytics("success");
        } else {
            if (!phone) {
                cb && cb(address.postalCode, "failure", "failed to set shipping address.");
            }
            (0,_components_checkout_v2_utils_index__WEBPACK_IMPORTED_MODULE_11__/* .redirectToCartPage */ .DZ)();
        }
    }).catch((error)=>{
        (0,_components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_16__/* .loggerCallBack */ .u)({
            logger,
            action: "error",
            message: "Failed to set shipping address",
            data: {
                error
            }
        });
        error.type = "setShippingAddressError";
        errorCb && errorCb(error);
        if (!phone) {
            cb && cb(address.postalCode, "failure", "failed to set shipping address.");
        }
    });
};
const validateInput = async function(field) {
    let val = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", data = arguments.length > 2 ? arguments[2] : void 0, i18n = arguments.length > 3 ? arguments[3] : void 0, genericMessages = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
    var ref;
    const value = val === null || val === void 0 ? void 0 : val.trim();
    const validUSPhone = ((ref = genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.find((msg)=>msg.text === "VALID_US_PHONE")) === null || ref === void 0 ? void 0 : ref.value) || (i18n === null || i18n === void 0 ? void 0 : i18n.validUSPhone);
    switch(field){
        case "fname":
        case "lname":
            if (!value) {
                return field === "fname" ? i18n.fnameError : i18n.lnameError;
            } else if (!await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("name", value)) {
                return i18n.nameValidation;
            }
            break;
        case "email":
            if (!data.email.value) return i18n.noEmailError;
            else if (!await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("email", value)) return i18n.validEmail;
            break;
        case "phone":
            if (!value) return i18n.emptyPhoneError;
            if (!(0,_js_helperV2__WEBPACK_IMPORTED_MODULE_8__/* .validateUSPhone */ .ix)(value)) return validUSPhone;
            break;
        case "address1":
            if (!value) return i18n.addressError;
            else if (!await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("address", value)) return i18n.nameValidation;
            break;
        case "city":
            if (!value) return i18n.cityError;
            else if (!await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("city", value)) return i18n.cityValidation;
            break;
        case "state":
            if (!value) return i18n.stateError;
            break;
        case "zipcode":
            if (!value) return i18n.emptyZipcodeError;
            else if (value.length < 5 || !await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("zipCodeNumeric", value)) return i18n.invalidZipcodeError;
            break;
        case "password":
            if (!value) return i18n.pwdErrorText;
            break;
        case "companyName":
            if (!value) return i18n.companyNameError;
            else if (!await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("businessName", value)) return i18n.nameValidation;
            break;
        case "businessType":
            if (!value) return i18n.businessTypeError;
            break;
        case "subType":
            if (!value) return i18n.subTypeError;
            break;
        case "label":
            if (value.length > 0 && !await (0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateField */ .OP)("saveAddressLabel", value)) {
                return i18n.nameValidation;
            }
            break;
        default:
            return;
    }
};
const isValidInputData = function(field) {
    let val = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const value = val === null || val === void 0 ? void 0 : val.trim();
    switch(field){
        case "firstName":
        case "lastName":
        case "fname":
        case "lname":
            if (!value || !(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("name", value)) {
                return false;
            }
            break;
        case "email":
            if (!value) return false;
            else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("email", value)) return false;
            break;
        case "phone":
            if (!value) return false;
            if (!(0,_js_helperV2__WEBPACK_IMPORTED_MODULE_8__/* .validatePhone */ .a$)(value)) return false;
            else if ((0,_js_helperV2__WEBPACK_IMPORTED_MODULE_8__/* .validateCountryCode */ .Y4)(value)) return false;
            break;
        case "streetName":
        case "address1":
            if (!value) return false;
            else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("address", value)) return false;
            break;
        case "city":
            if (!value) return false;
            else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("city", value)) return false;
            break;
        case "state":
            if (!value) return false;
            break;
        case "postalCode":
        case "zipcode":
            if (!value) return false;
            else if (value.length < 5 || !(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("zipCodeNumeric", value)) return false;
            break;
        case "password":
            if (!value) return false;
            break;
        case "companyName":
            if (!value) return false;
            else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("businessName", value)) return false;
            break;
        case "businessType":
            if (!value) return false;
            break;
        case "subType":
            if (!value) return false;
            break;
        case "label":
            if (value.length > 0 && !(0,_utils_location__WEBPACK_IMPORTED_MODULE_7__/* .validateInputField */ .nY)("saveAddressLabel", value)) {
                return false;
            }
            break;
        default:
            return true;
    }
    return true;
};
const getUpdatedCart = async (logger)=>{
    const payload = {
        actions: [
            {
                action: "recalculate",
                updateProductData: true
            }
        ]
    };
    try {
        const response = await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(payload)).unwrap();
        const { error: errorMessage = ""  } = response;
        if (errorMessage === _constants___WEBPACK_IMPORTED_MODULE_6__.NO_ACTIVE_CART_EXISTS) {
            (0,_components_checkout_v2_utils_index__WEBPACK_IMPORTED_MODULE_11__/* .redirectToCartPage */ .DZ)();
        }
        return response;
    } catch (error) {
        const { response: { data: { error: errorMessage1 = ""  }  } = {}  } = error;
        if (errorMessage1 === _constants___WEBPACK_IMPORTED_MODULE_6__.NO_ACTIVE_CART_EXISTS) {
            (0,_components_checkout_v2_utils_index__WEBPACK_IMPORTED_MODULE_11__/* .redirectToCartPage */ .DZ)();
        }
        (0,_components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_16__/* .loggerCallBack */ .u)({
            logger,
            action: "error",
            message: "Failed to fetch updated cart",
            data: {
                error
            }
        });
        const { cart: { cart ={}  } = {}  } = (_store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) || {};
        return cart;
    }
};
const validateAllFields = (address)=>{
    for (const [field, value] of Object.entries(address)){
        if (!isValidInputData(field, value)) {
            return {
                isValid: false,
                invalidField: field
            };
        }
    }
    return {
        isValid: true
    };
};
const checkIsShippingRestricted = async ()=>{
    var ref;
    const shippingResponse = await (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__/* .getShippingDetails */ .Qi)();
    (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_12__/* .updateProductDetailToStore */ .FX)(shippingResponse);
    return (shippingResponse === null || shippingResponse === void 0 ? void 0 : (ref = shippingResponse.sku) === null || ref === void 0 ? void 0 : ref.length) > 0 || false;
};


/***/ }),

/***/ 56980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ redirectToCartPage; },
/* harmony export */   "HS": function() { return /* binding */ initialCartLoad; },
/* harmony export */   "R9": function() { return /* binding */ checkDisabled; },
/* harmony export */   "YV": function() { return /* binding */ recalculateCart; },
/* harmony export */   "bA": function() { return /* binding */ getValidationData; },
/* harmony export */   "bn": function() { return /* binding */ getDefaultFormData; },
/* harmony export */   "gv": function() { return /* binding */ dispatchCallbackHandler; },
/* harmony export */   "lK": function() { return /* binding */ getAddressString; },
/* harmony export */   "mf": function() { return /* binding */ filterComboChildForAnalytics; },
/* harmony export */   "pZ": function() { return /* binding */ getFilteredAddress; },
/* harmony export */   "ud": function() { return /* binding */ getAddressData; }
/* harmony export */ });
/* unused harmony export getFilteredData */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88032);
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30696);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97433);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20558);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _components_checkout_v2_utils_checkout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12378);












const dispatchCallbackHandler = function(type) {
    let payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    switch(type){
        case "set-auth-modal":
            {
                return _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAuthModalVisibility */ .LY)(payload));
            }
        case "discount":
            {
                return _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .discount */ .Al)(payload));
            }
        case "taxCalculation":
            {
                return _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .taxCalculation */ .QL)());
            }
    }
};
const redirectToCartPage = ()=>{
    (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then((config)=>{
        const { general: { cartLandingPagePath ="en/cart"  } = {}  } = config || {};
        const cartLandingPageUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrlPath */ .mXk)(cartLandingPagePath);
        window.location.href = cartLandingPageUrl;
    });
};
const initialCartLoad = (data)=>{
    const { getZipCode , onError  } = data;
    const { cart: { isCartLoading  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState();
    if (!isCartLoading) {
        _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCardStatus */ .YZ)(true));
        const payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                }
            ]
        };
        _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .addToCart */ .Xq)(payload)).unwrap().then((rsp)=>{
            if ((rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) && (rsp === null || rsp === void 0 ? void 0 : rsp.cartExists) === "false" && (rsp === null || rsp === void 0 ? void 0 : rsp.error) === "No active cart exists.") {
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getCurrency */ .zC$)().then((currency)=>{
                    const cartPayload = {
                        currency: currency,
                        taxMode: "ExternalAmount"
                    };
                    _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .createCart */ .Bk)(cartPayload)).unwrap().then((rsp)=>{
                        getZipCode(rsp);
                        _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCardStatus */ .YZ)(false));
                        redirectToCartPage();
                    }).catch((error)=>{
                        console.error("Error creating cart:", error);
                        if (onError) {
                            onError();
                        }
                    });
                });
            } else if (!(rsp === null || rsp === void 0 ? void 0 : rsp.lineItems.length)) {
                // Handle the case where the no line item in cart
                redirectToCartPage();
            }
        }).catch((error)=>{
            console.error("Error adding to cart:", error);
            if (onError) {
                onError();
            }
        });
    }
};
const recalculateCart = ()=>{
    _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCardStatus */ .YZ)(false));
    const payload = {
        actions: [
            {
                action: "recalculate",
                updateProductData: true
            }
        ]
    };
    _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .addToCart */ .Xq)(payload));
};
const getAddressData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isLabel1 = arguments.length > 1 ? arguments[1] : void 0;
    const { item ={} , i18n ={} , defaultId , tileIndex  } = data;
    var ref;
    const label1 = {
        value: (ref = item === null || item === void 0 ? void 0 : item.label) !== null && ref !== void 0 ? ref : ""
    };
    const label2 = {
        show: item.id === defaultId,
        value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(item, "custom.fields.label", "".concat(i18n.address, " #").concat(tileIndex))
    };
    const label = isLabel1 ? label1 : label2;
    var _firstName, _lastName, _email, _phone, _streetName, _streetNumber, _city, _state, _postalCode, _country, ref1;
    return {
        label,
        fname: {
            value: (_firstName = item.firstName) !== null && _firstName !== void 0 ? _firstName : ""
        },
        lname: {
            value: (_lastName = item.lastName) !== null && _lastName !== void 0 ? _lastName : ""
        },
        email: {
            value: (_email = item.email) !== null && _email !== void 0 ? _email : ""
        },
        phone: {
            value: (_phone = item.phone) !== null && _phone !== void 0 ? _phone : ""
        },
        address1: {
            value: (_streetName = item.streetName) !== null && _streetName !== void 0 ? _streetName : ""
        },
        address2: (_streetNumber = item.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : "",
        city: {
            value: (_city = item.city) !== null && _city !== void 0 ? _city : ""
        },
        state: {
            value: (_state = item.state) !== null && _state !== void 0 ? _state : ""
        },
        zipcode: {
            value: (_postalCode = item.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ""
        },
        country: {
            value: (_country = item.country) !== null && _country !== void 0 ? _country : ""
        },
        id: (ref1 = item === null || item === void 0 ? void 0 : item.id) !== null && ref1 !== void 0 ? ref1 : ""
    };
};
const getFilteredData = function() {
    let suggData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], excludedAddresses = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return suggData.filter((item)=>!excludedAddresses.some((address)=>item.startsWith(address)));
};
const getFilteredAddress = function() {
    let suggData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    const { generic: { globalConfig: { regexPattern: { map: { excludePOBoxAddress =""  } = {}  } = {}  } = {}  }  } = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState();
    if (excludePOBoxAddress) {
        const poBoxRegex = new RegExp(excludePOBoxAddress, "i");
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_1__.isArray)(suggData)) {
            return suggData.filter((item)=>!poBoxRegex.test(item));
        } else if (typeof suggData === "string") {
            return !poBoxRegex.test(suggData);
        }
    }
    return suggData;
};
const getDefaultFormData = (data)=>{
    const { props , isAuth , user  } = data;
    var _country, _country1;
    return {
        fname: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "fname.value", ""),
            error: false,
            message: ""
        },
        lname: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "lname.value", ""),
            error: false,
            message: ""
        },
        email: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "email.value", "") || (isAuth && !(user === null || user === void 0 ? void 0 : user.koc) ? user === null || user === void 0 ? void 0 : user.sub : ""),
            error: false,
            message: ""
        },
        phone: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "phone.value", ""),
            error: false,
            message: ""
        },
        address1: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "address1.value", ""),
            error: false,
            message: ""
        },
        address2: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "address2", ""),
        city: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "city.value", ""),
            error: false,
            message: ""
        },
        state: {
            value: (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_3__/* .getStateName */ .qs)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "state.value", ""), lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "country.value", (_country = props.country) !== null && _country !== void 0 ? _country : ""), props.countries),
            error: false,
            message: ""
        },
        zipcode: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "zipcode.value", ""),
            error: false,
            message: ""
        },
        country: {
            value: (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_3__/* .getCountryName */ .pD)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "country.value", (_country1 = props.country) !== null && _country1 !== void 0 ? _country1 : ""), props.countries),
            error: false,
            message: ""
        },
        notes: "",
        label: {
            show: props.checkToggle ? true : lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "label.show", true),
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "label.value", "")
        },
        id: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "id", ""),
        password: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "password.value", ""),
            error: false,
            message: ""
        },
        companyName: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "companyName.value", ""),
            error: false,
            message: ""
        },
        accountType: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "accountType.value", ""),
            error: false,
            message: ""
        },
        businessType: {
            value: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(props.data, "businessType.value", ""),
            error: false,
            message: ""
        }
    };
};
// Validates all required fields in address using isValidInputData from checkout.js
const validateAllAddressFields = (addr, requiredFields)=>{
    for (const field of requiredFields){
        var ref;
        const value = (ref = addr[field]) === null || ref === void 0 ? void 0 : ref.value;
        if (!(0,_components_checkout_v2_utils_checkout__WEBPACK_IMPORTED_MODULE_10__/* .isValidInputData */ .Bu)(field, value)) {
            return {
                isValid: false,
                invalidField: field
            };
        }
    }
    return {
        isValid: true
    };
};
const checkDisabled = (data)=>{
    var ref, ref1;
    const { addr , type , isSignUp =false , isPasswordValid ={} , createAccountType =""  } = data;
    // Check if any field has error flag set
    const hasFormAnyError = Object.values(addr).some((item)=>{
        return (item === null || item === void 0 ? void 0 : item.error) === true;
    });
    if (hasFormAnyError) return true;
    const accountType = createAccountType.toLowerCase();
    const isProfessional = accountType.includes("professional");
    const isHomeowner = accountType.includes("homeowner");
    // Define required fields based on context
    const baseFields = [
        "phone",
        "address1",
        "city",
        "state",
        "zipcode"
    ];
    const commonFields = [
        "fname",
        "lname",
        "email",
        ...baseFields
    ];
    // Edit/Add mode - only need base address fields
    if ((type === "edit" || type === "add") && !isSignUp) {
        var ref2, ref3;
        const password = (ref2 = addr.password) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.value) === null || ref3 === void 0 ? void 0 : ref3.trim();
        if (password) return true // shouldn't have password in edit/add mode
        ;
        return !validateAllAddressFields(addr, baseFields).isValid;
    }
    // Guest checkout - no signup
    if (!isSignUp) {
        return !validateAllAddressFields(addr, commonFields).isValid;
    }
    // Signup flow
    const password1 = (ref = addr.password) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.trim();
    const isPasswordOk = password1 && (isPasswordValid === null || isPasswordValid === void 0 ? void 0 : isPasswordValid.valid) !== false;
    if (!isPasswordOk) return true;
    if (isProfessional && !isHomeowner) {
        // Professional account needs companyName and businessType
        const proFields = [
            ...commonFields,
            "password",
            "companyName",
            "businessType"
        ];
        return !validateAllAddressFields(addr, proFields).isValid;
    }
    if (isHomeowner && !isProfessional) {
        // Homeowner account
        const homeFields = [
            ...commonFields,
            "password"
        ];
        return !validateAllAddressFields(addr, homeFields).isValid;
    }
    return true;
};
const getValidationData = (data)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { i18n , formData , type , setCtaLoad , isSignUpForm =false  } = data;
    const obj = {};
    let valid = true;
    const errorMessage = [];
    const isBingActive = "disabled" === "enabled";
    setCtaLoad && setCtaLoad(true);
    if (type !== "add" && type !== "edit") {
        if (!formData.email.value) {
            obj.email = {
                ...formData.email,
                error: true,
                message: i18n.noEmailError
            };
            valid = false;
            errorMessage.push(i18n.noEmailError);
        } else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_4__/* .validateInputField */ .nY)("email", formData.email.value)) {
            obj.email = {
                ...formData.email,
                error: true,
                message: i18n.validEmail
            };
            valid = false;
            errorMessage.push(i18n.validEmail);
        }
    }
    if (!(0,_js_helperV2__WEBPACK_IMPORTED_MODULE_3__/* .validateUSPhone */ .ix)(formData.phone.value)) {
        obj.phone = {
            ...formData.phone,
            error: true,
            message: i18n.validPhone
        };
        valid = false;
        errorMessage.push(i18n.validPhone);
    }
    if (!((ref = formData.fname.value) === null || ref === void 0 ? void 0 : ref.trim())) {
        obj.fname = {
            ...formData.fname,
            error: true,
            message: i18n.fnameError
        };
        valid = false;
        errorMessage.push(i18n.fnameError);
    } else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_4__/* .validateInputField */ .nY)("name", formData.fname.value)) {
        obj.fname = {
            ...formData.fname,
            error: true,
            message: i18n.nameValidation
        };
        valid = false;
        errorMessage.push(i18n.nameValidation);
    }
    if (!((ref1 = formData.lname.value) === null || ref1 === void 0 ? void 0 : ref1.trim())) {
        obj.lname = {
            ...formData.lname,
            error: true,
            message: i18n.lnameError
        };
        valid = false;
        errorMessage.push(i18n.lnameError);
    } else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_4__/* .validateInputField */ .nY)("name", formData.lname.value)) {
        obj.lname = {
            ...formData.lname,
            error: true,
            message: i18n.nameValidation
        };
        valid = false;
        errorMessage.push(i18n.nameValidation);
    }
    if (!((ref2 = formData.address1.value) === null || ref2 === void 0 ? void 0 : ref2.trim())) {
        obj.address1 = {
            ...formData.address1,
            error: true,
            message: i18n.addressError
        };
        valid = false;
        errorMessage.push(i18n.addressError);
    }
    if (!((ref3 = formData.password.value) === null || ref3 === void 0 ? void 0 : ref3.trim()) && isSignUpForm) {
        obj.password = {
            ...formData.password,
            error: true,
            message: i18n.pwdErrorText
        };
        valid = false;
        errorMessage.push(i18n.pwdErrorText);
    }
    if (!((ref4 = formData.city.value) === null || ref4 === void 0 ? void 0 : ref4.trim())) {
        obj.city = {
            ...formData.city,
            error: true,
            message: i18n.cityError
        };
        valid = false;
        errorMessage.push(i18n.cityError);
    } else if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_4__/* .validateInputField */ .nY)("city", formData.city.value)) {
        obj.city = {
            ...formData.city,
            error: true,
            message: i18n.cityValidation
        };
        valid = false;
        errorMessage.push(i18n.cityValidation);
    }
    if (!formData.state.value) {
        obj.state = {
            ...formData.state,
            error: true,
            message: i18n.stateError
        };
        valid = false;
        errorMessage.push(i18n.stateError);
    }
    if (!((ref5 = formData.zipcode.value) === null || ref5 === void 0 ? void 0 : ref5.trim())) {
        obj.zipcode = {
            ...formData.zipcode,
            error: true,
            message: i18n.zipcodeError
        };
        valid = false;
        errorMessage.push(i18n.zipcodeError);
    } else if (formData.zipcode.value.trim().length < 5) {
        obj.zipcode = {
            ...formData.zipcode,
            error: true,
            message: i18n.validZipcode
        };
        valid = false;
        errorMessage.push(i18n.validZipcode);
    } else if (isBingActive) {
        if (!(0,_utils_location__WEBPACK_IMPORTED_MODULE_4__/* .validateZip */ .$8)(formData.zipcode.value)) {
            obj.zipcode = {
                ...formData.zipcode,
                error: true,
                message: i18n.validZipcode
            };
            valid = false;
            errorMessage.push(i18n.validZipcode);
        }
    }
    if (formData === null || formData === void 0 ? void 0 : (ref6 = formData.label) === null || ref6 === void 0 ? void 0 : ref6.error) {
        valid = false;
        errorMessage.push(i18n.nameValidation);
    }
    return {
        valid,
        validationData: obj,
        errorMessage
    };
};
const getAddressString = (addressData)=>{
    const { streetName ="" , city ="" , state ="" , postalCode =""  } = addressData;
    return "".concat((0,_utils___WEBPACK_IMPORTED_MODULE_5__/* .removeExtraSpaces */ .zm)(streetName), ", ").concat((0,_utils___WEBPACK_IMPORTED_MODULE_5__/* .removeExtraSpaces */ .zm)(city), " ").concat((0,_utils___WEBPACK_IMPORTED_MODULE_5__/* .removeExtraSpaces */ .zm)(state), " ").concat((0,_utils___WEBPACK_IMPORTED_MODULE_5__/* .removeExtraSpaces */ .zm)(postalCode));
};
const filterComboChildForAnalytics = (cartData)=>{
    var ref;
    if (!(cartData === null || cartData === void 0 ? void 0 : cartData.cartItems) || !(cartData === null || cartData === void 0 ? void 0 : (ref = cartData.cart) === null || ref === void 0 ? void 0 : ref.item)) {
        return {
            filteredCartItems: [],
            filteredCart: []
        };
    }
    // Filter out combo child skus
    const filteredCartItems = cartData.cartItems.filter((item)=>!item.bundleParentId).map((item)=>{
        return item === null || item === void 0 ? void 0 : item.customerFacingSKU;
    }).filter(Boolean);
    const filteredCart = cartData.cart.item.filter((item)=>{
        var ref;
        return filteredCartItems.includes(item === null || item === void 0 ? void 0 : (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID);
    });
    return {
        filteredCartItems,
        filteredCart
    };
};


/***/ }),

/***/ 13593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ checkExpPayPal; },
/* harmony export */   "Xx": function() { return /* binding */ getAciPayPalPaymentStatus; },
/* harmony export */   "mR": function() { return /* binding */ aciPaymentWidgetsInit; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20558);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64757);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73350);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46201);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60475);
/* harmony import */ var _services_checkoutService__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21315);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93284);
/* harmony import */ var _components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82321);
/* harmony import */ var _utils_logger_client__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61372);













const getAciPayPalPaymentStatus = async (data)=>{
    const { genericError ="" , unverifiedAddressMsg ="" , outOfCountryAddressMsg ="" , expPayPalCallBackErrorMsg: expPayPalAuthorErrorMsg = "" , onNext =()=>{}  } = data || {};
    const loggerPayment = (0,_utils_logger_client__WEBPACK_IMPORTED_MODULE_12__/* .createContextLogger */ .lK)("checkout:payment");
    const isXpp = checkExpPayPal();
    const id = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getPayPalPaymentIdFromParams */ .qV)();
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentFailedAction */ .RM)(false));
    const { generic: { globalConfig: { general: { checkoutPagePath ="/"  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState() || {};
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setLoading */ .K4)(true));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentErrorMessageAction */ .Fc)(""));
    const checkoutUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getShortenedUrlPath */ .mXk)(checkoutPagePath);
    const { activeCartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getCartIdParams */ .Uo)();
    if (!id) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setLoading */ .K4)(false));
        if (isXpp) {
            return false;
        } else {
            window.history.replaceState(null, null, checkoutUrl);
            return false;
        }
    }
    // for non-xpp paypal flow calling shipping details to update the store
    if (!isXpp) {
        (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_10__/* .getShippingDetails */ .Qi)().then((response)=>{
            (0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_10__/* .updateProductDetailToStore */ .FX)(response);
        });
    }
    const apiUrl = "".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_4__/* .ACI_PAYMENT_CALLBACK_ENDPOINT */ .zG, "?cartId=").concat(activeCartId, "&sessionId=").concat(id, "&pm=").concat(isXpp ? "xpp" : "pp");
    try {
        const { data: data1 = {}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_5__/* .apim.get */ .TH.get(apiUrl);
        const { paymentInfo: { payments =[]  } = {} , isVerifiedAddress =false  } = data1;
        var ref;
        const { id: payPalpaymentId = "" , obj: { paymentMethodInfo: { method =""  } = {}  } = {}  } = (ref = payments[0]) !== null && ref !== void 0 ? ref : {};
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .setPaymetId */ .BR)(payPalpaymentId));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setIsPaymentInfoAction */ .hK)(true));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentMethodNameAction */ .I2)(method));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setLoading */ .K4)(false));
        onNext();
        if (isXpp) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setIsVerifiedAddress */ .Bp)(isVerifiedAddress));
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setCheckoutAction */ .BZ)(!isVerifiedAddress ? 0 : 3));
            if (!isVerifiedAddress) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPayPalCallBackErrorMsg */ .SB)(unverifiedAddressMsg));
            }
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .getCart */ .dv)());
        }
        window.history.replaceState(null, null, "".concat(checkoutUrl).concat(isXpp ? "?pm=xpp" : ""));
        sessionStorage.removeItem("payId");
    } catch (error) {
        const { response: { data: { errorCode , errorDesc ="" , isShipmentFromCart =true  } = {}  } = {}  } = error !== null && error !== void 0 ? error : {};
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentFailedAction */ .RM)(true));
        (0,_components_checkout_v2_logger__WEBPACK_IMPORTED_MODULE_11__/* .loggerCallBack */ .u)({
            logger: loggerPayment,
            action: "error",
            message: "Aci Payment failed:PayPal",
            data: {
                error,
                activeCartId,
                paypalID: id
            }
        });
        try {
            const authorErrorMsg = await (0,_services_checkoutService__WEBPACK_IMPORTED_MODULE_9__/* .getAciPaymentErrorMessage */ .B)(errorCode);
            onPayPalCallBackErorr({
                isXpp,
                genericError,
                errorMsg: authorErrorMsg,
                errorDesc,
                expPayPalAuthorErrorMsg,
                outOfCountryAddressMsg,
                unverifiedAddressMsg,
                isShipmentFromCart
            });
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setLoading */ .K4)(false));
        } catch (e) {
            onPayPalCallBackErorr({
                isXpp,
                genericError,
                errorDesc,
                expPayPalAuthorErrorMsg,
                outOfCountryAddressMsg,
                unverifiedAddressMsg,
                isShipmentFromCart
            });
        }
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setLoading */ .K4)(false));
        window.history.replaceState(null, null, checkoutUrl);
    }
};
const onPayPalCallBackErorr = (data)=>{
    const { isXpp , genericError , errorMsg , errorDesc , expPayPalAuthorErrorMsg , outOfCountryAddressMsg , unverifiedAddressMsg , isShipmentFromCart  } = data;
    const isInvalidCountry = errorDesc === "invalid country";
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setIsInvalidCountryAction */ .Ds)(isInvalidCountry));
    const getErrorMessage = ()=>{
        if (isInvalidCountry) {
            return outOfCountryAddressMsg;
        }
        if (!isShipmentFromCart) {
            return unverifiedAddressMsg;
        }
        return errorMsg || expPayPalAuthorErrorMsg;
    };
    if (isXpp) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setCheckoutAction */ .BZ)(0));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setExpPayPalCheckout */ .gp)(false));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPayPalCallBackErrorMsg */ .SB)(getErrorMessage()));
    } else {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setCheckoutAction */ .BZ)(2));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentMethodNameAction */ .I2)("paypal"));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentErrorMessageAction */ .Fc)(errorMsg || errorDesc || genericError));
    }
};
const checkExpPayPal = ()=>{
    if (false) {}
    const urlParams = new URLSearchParams(window.location.search);
    const paymentType = urlParams.get("pm");
    return paymentType === "xpp";
};
const aciPaymentWidgetsInit = function() {
    let isInit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, checkoutId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const scriptElem = document.getElementById("aciPaymentWidget");
    if (isInit) {
        const script = document.createElement("script");
        script.src = "".concat("https://eu-prod.oppwa.com/v1/paymentWidgets.js", "?").concat(checkoutId ? "checkoutId=".concat(checkoutId) : "");
        script.id = "aciPaymentWidget";
        document.body.append(script);
    } else {
        scriptElem === null || scriptElem === void 0 ? void 0 : scriptElem.remove();
    }
};


/***/ }),

/***/ 36130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56387);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49139);




const AutoSuggestion = (param)=>{
    let { id , borderValue , placeholderLabel , prefix , suffix , optionList , ariaLabel , selectedValue , iconAnalyticsdata , handleSelect , handleChange , title =""  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getInputVal = (item)=>{
        const value = item.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .ZIP_CODE_MATCH_WHITESPACE_REGEX */ .bY, "").match(_constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .ZIP_CODE_DIGIT_REGEX */ .lY);
        const inputVal = value != null ? value[0] : item;
        handleChange(inputVal);
        setIsOpen(true);
    };
    const getSuggestionVal = (item)=>{
        handleSelect(item);
        setIsOpen(false);
    };
    document.addEventListener("click", function(e) {
        var ref;
        if (setIsOpen && !((ref = document.getElementById("".concat(id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setIsOpen(false);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().autoSuggetionWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "auto-suggestion",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "auto-suggestion__input-container ".concat(borderValue === "bottom" ? "auto-suggestion__border-bottom" : "auto-suggestion__border-all"),
                        children: [
                            prefix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-prefix",
                                children: prefix
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                className: "auto-suggestion__input",
                                placeholder: placeholderLabel,
                                value: selectedValue,
                                onChange: (e)=>getInputVal(e.target.value),
                                "aria-label": ariaLabel,
                                onBlur: ()=>setIsOpen(false),
                                title: title
                            }),
                            suffix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-suffix " + (iconAnalyticsdata ? "gbh-data-layer" : ""),
                                "data-gbh-data-layer": iconAnalyticsdata || null,
                                children: suffix
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "auto-suggestion__dropdown ".concat(isOpen ? " active" : ""),
                        children: (optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "auto-suggestion__dropdown-items",
                            children: optionList.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onMouseDown: ()=>getSuggestionVal(item),
                                    className: "auto-suggestion__dropdown-item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "auto-suggestion__dropdown-item-value",
                                        children: item
                                    })
                                }, i))
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoSuggestion);


/***/ }),

/***/ 7872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/core/Button/Button.module.scss
var Button_module = __webpack_require__(77529);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./public/images/backArrow.png
/* harmony default export */ var backArrow = ({"src":"/_next/static/media/backArrow.efb2b3dc.png","height":18,"width":18,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXFISEhISEhISEhISEhHR0d9PL0uAAAABnRSTlMAQVETiRCREjDgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVQImWNgYGBiZgADRiYIzQylGViYGMEAwYBLwRUzMDCxgigAB6cANS8/ZOEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
;// CONCATENATED MODULE: ./components/core/Button/Button.jsx








const Button = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { label , size , arrowImg , image ="" , type , flexible , disabled , onClick , customClass , to , target , className , loading , role , tag , tabIndex =0 , ariaLabel , parentClass , useDefaultClass , testid ="" , icon , iconAlt ="" , iconClass ="" , iconProps ={} , ...remainingProps } = props;
    const buttonClass = classnames_default()("kf-react-button", "button", className ? className : null, size ? size : "large", type ? type : "primary", flexible ? "flexible" : null, disabled ? "disabled" : null, customClass ? customClass : null, loading ? "loading" : null);
    const ButtonTag = tag === "button" || role === "button" ? "button" : tag === "anchor" ? "a" : (link_default());
    const buttonFullClass = useDefaultClass ? (Button_module_default()).buttonWrapper : (Button_module_default()).buttonWrapper + " " + buttonClass + " " + (parentClass || "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: buttonFullClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTag, {
            ...remainingProps,
            className: buttonClass,
            onClick: onClick,
            href: to !== null && to !== void 0 ? to : "",
            target: target,
            role: role !== null && role !== void 0 ? role : "",
            tabIndex: tabIndex,
            "aria-label": ariaLabel,
            "aria-disabled": disabled,
            "data-testid": "button".concat(testid ? "-".concat(testid) : ""),
            disabled: disabled,
            ref: ref,
            children: [
                icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: iconClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon,
                        alt: iconAlt,
                        width: iconProps === null || iconProps === void 0 ? void 0 : iconProps.width,
                        height: iconProps === null || iconProps === void 0 ? void 0 : iconProps.height
                    })
                }) : null,
                arrowImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "arrowImage",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: backArrow,
                        alt: "backArrow "
                    })
                }),
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loader"
                }),
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image,
                    alt: label
                }),
                " ",
                label
            ]
        })
    });
});
Button.displayName = "Button";
Button.propTypes = {
    label: (prop_types_default()).string,
    size: (prop_types_default()).string,
    type: (prop_types_default()).string,
    flexible: (prop_types_default()).bool,
    customClass: (prop_types_default()).string,
    onClick: (prop_types_default()).func,
    disabled: (prop_types_default()).bool,
    parentClass: (prop_types_default()).string
};
/* harmony default export */ var Button_Button = (Button);


/***/ }),

/***/ 65764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/Checkbox/index.module.scss
var index_module = __webpack_require__(43090);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/checkbox-tick.svg
/* harmony default export */ var checkbox_tick = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/core/Checkbox/Checkbox.jsx







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false , inputRef =null  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        if (e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            e.target.click();
        }
    };
    var _checkBoxAria, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).checkboxWrapper).concat(inline ? " ".concat((index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            htmlFor: props.id,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    ref: inputRef,
                    onChange: (e)=>props.onChange(e),
                    onKeyDown: handleCheck,
                    checked: props.checked,
                    disabled: props.disabled,
                    "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
                    "data-testid": (ref = props === null || props === void 0 ? void 0 : props.dataTestId) !== null && ref !== void 0 ? ref : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: (checkbox_tick === null || checkbox_tick === void 0 ? void 0 : checkbox_tick.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick.src,
                            alt: "checkbox-icon",
                            "aria-hidden": true
                        }) : null
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
Checkbox.propTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    inline: (prop_types_default()).bool,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func,
    inputRef: prop_types_default().oneOfType([
        (prop_types_default()).func,
        prop_types_default().shape({
            current: (prop_types_default()).any
        })
    ])
};


/***/ }),

/***/ 32982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _public_images_swatch_missing_jpeg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36562);







const ColorSwatch = (props)=>{
    const { type ="" , id ="" , label ="" , name ="" , value ="" , checked =false , color ="" , colorUrl ="" , initConfig  } = props || {};
    const { globalConfig  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectGenericState */ .Px);
    const { general: { scene7AccountName ="PAWEB"  } = {}  } = initConfig || globalConfig;
    const swatchUrlName = colorUrl ? colorUrl + "?$PDPSwatch_Desk$" : _public_images_swatch_missing_jpeg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
    const swatchUrl = swatchUrlName.replace("PAWEB", scene7AccountName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "color-swatch",
        title: label,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                "aria-label": label,
                type: type === "selector" ? "radio" : "checkbox",
                id: id,
                name: name,
                value: value,
                checked: checked,
                style: {
                    backgroundColor: color
                },
                onClick: (e)=>!checked && props.onClick(e.target.value),
                onChange: (e)=>props.onChange(e),
                "data-testid": "color-swatch-".concat(id !== null && id !== void 0 ? id : "0")
            }),
            type !== "selector" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            type === "selector" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "".concat(!colorUrl || colorUrl.includes(_constants_index__WEBPACK_IMPORTED_MODULE_4__.SWATCH_NA) ? "--no-swatch" : ""),
                htmlFor: id,
                children: swatchUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    role: "presentation",
                    src: swatchUrl,
                    alt: "NA"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    role: "presentation",
                    src: _constants_index__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL,
                    alt: "EMPTY_PIXEL"
                })
            })
        ]
    });
};
ColorSwatch.defaultProps = {
    type: "",
    label: "",
    id: "",
    name: "",
    value: undefined,
    color: "",
    colorUrl: "",
    checked: undefined,
    defaultChecked: false,
    onClick: ()=>{},
    onChange: ()=>{}
};
ColorSwatch.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    colorUrl: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    defaultChecked: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onMouseEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorSwatch);


/***/ }),

/***/ 22231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49139);



const Heading = (props)=>{
    const { level =6 , fontSize , fontWeight , className ="" , children  } = props;
    const Tag = _constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .NUMBER_HEADING_REGEX.test */ .uZ.test("".concat(level)) ? "h" + level : "h6";
    let classes = "";
    classes = (fontSize ? "fs-".concat(fontSize) : "") + " ";
    classes += fontWeight ? "fw-".concat(fontWeight) : "";
    if (!classes) classes = "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: "".concat(classes, " ").concat(className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 15540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3522);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__);



const Highlight = (param)=>{
    let { text ="" , highlight =""  } = param;
    if (!highlight.trim()) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: text
    });
    const regex = new RegExp("(".concat(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default()(highlight), ")"), "gi");
    const parts = text.split(regex);
    return parts.filter((part)=>part).map((part, i)=>regex.test(part) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "highlight-text",
            children: part
        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: part
        }, i));
};
/* harmony default export */ __webpack_exports__["Z"] = (Highlight);


/***/ }),

/***/ 18377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83886);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2595);




const DynamicImage = (param)=>{
    let { imgUrl ="" , alt ="" , className ="" , uniqueId ="" , urlModifiers ="" , pageType ="" , ...restProps } = param;
    const smartCrop = (0,_hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const cropedImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const isScene7Img = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("scene7");
    const [bgColorImage, setBgColorImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && smartCrop.scriptStatus && isScene7Img && "object" !== "undefined" && window.s7responsiveImage) {
            smartCrop.applySmartCrop(cropedImage.current);
        }
    }, [
        smartCrop.scriptStatus,
        imgUrl,
        uniqueId,
        isSsr
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (urlModifiers && imgUrl) {
            setBgColorImage((imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("?")) ? "".concat(imgUrl, "&").concat(urlModifiers) : "".concat(imgUrl, "?").concat(urlModifiers));
        }
    }, [
        imgUrl,
        urlModifiers
    ]);
    const isPLP = pageType === "plp";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: cropedImage,
        "data-src": urlModifiers ? bgColorImage : imgUrl,
        "data-mode": "smartcrop",
        className: className,
        alt: alt,
        ...!isPLP && {
            src: imgUrl || imgPlaceholder
        },
        ...restProps
    }, uniqueId);
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicImage);


/***/ }),

/***/ 61319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const ImagePlaceHolder = (param)=>{
    let { assetID =""  } = param;
    if (!assetID) return null;
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: imgPlaceholder,
        "data-src": imgPlaceholder,
        "data-mode": "smartcrop",
        alt: "Image Placeholder",
        className: "fluidimage cmp-image__image image-placeholder"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImagePlaceHolder);


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96301);
/* harmony import */ var _components_checkout_v2_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37490);
/* harmony import */ var _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63519);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21531);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_8__);









const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    var ref1;
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const errorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    var _type;
    const [type, setType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_type = props.type) !== null && _type !== void 0 ? _type : "text");
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [matchedItem, setMatchedItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedListItem, setListItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { showError , errorMessage , id , className ="" , placeholder ="" , autoComplete ="off" , isCheckoutPage =false  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (toggle) setType("text");
        else setType("password");
    }, [
        toggle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            var ref;
            inputRef === null || inputRef === void 0 ? void 0 : (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showError && errorMessage) {
            errorRef.current.focus();
        }
    }, [
        showError,
        errorMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const keyPressEvent = (e)=>{
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            if (e.keyCode === KEYCODE.TAB && showList) {
                setShowList(false);
            }
        };
        const containerTarget = (e)=>{
            var ref;
            if (showList && !((ref = document.getElementById("".concat(props.id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setShowList(false);
        };
        window.addEventListener("click", containerTarget);
        document.addEventListener("keydown", keyPressEvent);
        return ()=>{
            document.removeEventListener("keydown", keyPressEvent);
            window.removeEventListener("click", containerTarget);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        if (((ref = props.value) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = props.suggestions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            setShowList(true);
            selectListItem();
            setActivedescendant();
        } else setShowList(false);
    }, [
        props.value,
        props.suggestions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) setActivedescendant();
    }, [
        showList
    ]);
    const selectListItem = ()=>{
        const listItems = [
            ...props.suggestions
        ];
        const firstMatchedItem = listItems.find((item)=>{
            if (item === null || item === void 0 ? void 0 : item.includes(props.value)) return item;
        });
        setMatchedItem(firstMatchedItem);
    };
    var _id;
    const setActivedescendant = ()=>{
        var ref;
        return setListItem((_id = (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].id) !== null && _id !== void 0 ? _id : "");
    };
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("input-field__border", props.disabled ? "--disabled" : null, props.showError ? "--with-error" : null, focus ? "--focused" : null);
    const i18n = {
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        resultsText: t("kf.input.aria.resultsText")
    };
    const handleClick = ()=>{
        var ref;
        return (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleKeyDown = (e)=>{
        if (showList) {
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            const ele = [
                ...document.getElementById("".concat(props.id, "-list")).childNodes
            ];
            let index = 0;
            const selectedItem = ele.find((item, i)=>{
                if (item.id === selectedListItem) {
                    index = i;
                    return item;
                }
            });
            switch(e.keyCode){
                case KEYCODE.ESC:
                    setShowList(false);
                    break;
                case KEYCODE.UP:
                    e.preventDefault();
                    if (index > 0) ele.forEach((item, i)=>{
                        if (i === index - 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .smoothScroll */ .ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.DOWN:
                    e.preventDefault();
                    if (index < ele.length - 1) ele.forEach((item, i)=>{
                        if (i === index + 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .smoothScroll */ .ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.SPACE:
                    break;
                case KEYCODE.ENTER:
                    selectedItem.click();
                    break;
                default:
                    break;
            }
        }
    };
    const autoCompleteValue = autoComplete === "true" || autoComplete === true ? "on" : autoComplete === "false" || autoComplete === false ? "off" : autoComplete;
    const handleClickHideShowPassword = ()=>{
        if (isCheckoutPage) {
            const btnClickAction = !toggle ? _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .SHOW_PASSWORD */ .Mu : _components_checkout_v2_analytics_constants__WEBPACK_IMPORTED_MODULE_7__/* .HIDE_PASSWORD */ .N5;
            (0,_components_checkout_v2_analytics__WEBPACK_IMPORTED_MODULE_6__/* .addAnalyticsShowHidePasswordClick */ .XA)({
                btnClickAction
            });
        }
    };
    var _ariaRequried;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputFieldWrapper), " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " input-field ".concat(props.customClass ? props.customClass : ""),
            id: "".concat(props.id, "-wrapper"),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: inputClasses,
                    children: [
                        props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__prefix",
                            children: props.prefix
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "input-field__value",
                            onKeyDown: (e)=>handleKeyDown(e),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    ref: ref !== null && ref !== void 0 ? ref : inputRef,
                                    id: props.id,
                                    type: props.type === "password" ? type : props.type,
                                    value: props.value,
                                    name: props.name,
                                    autoComplete: (props === null || props === void 0 ? void 0 : props.autoCompleteTextVal) ? props === null || props === void 0 ? void 0 : props.autoCompleteTextVal : autoCompleteValue,
                                    maxLength: props.maxLength,
                                    disabled: props.disabled,
                                    placeholder: placeholder ? placeholder : props.label.replace(/\*/g, ""),
                                    onChange: props.onChange,
                                    onKeyUp: props.onKeyUp,
                                    onKeyDown: props.onKeyDown,
                                    onKeyPress: handleKeyDown,
                                    onFocus: (e)=>{
                                        setFocus(true);
                                        props.onFocus && props.onFocus(e);
                                    },
                                    onBlur: (e)=>{
                                        setFocus(false);
                                        props.onBlur && props.onBlur(e);
                                    },
                                    max: props.max,
                                    min: props.min,
                                    autoFocus: props.autoFocus,
                                    "aria-required": ((_ariaRequried = props.ariaRequried) !== null && _ariaRequried !== void 0 ? _ariaRequried : props.label.indexOf("*") > 0) ? true : false,
                                    ...(props === null || props === void 0 ? void 0 : props.showAriaOwnsriaActivedescendant) === false ? {} : {
                                        "aria-activedescendant": props.autoComplete ? selectedListItem : "undefined"
                                    },
                                    "aria-readonly": props.readOnly ? "true" : "false",
                                    ...(props === null || props === void 0 ? void 0 : props.showAriaOwns) === false ? {} : {
                                        "aria-owns": "".concat(props.id, "-list")
                                    },
                                    // aria-expanded={props.autoComplete ? showList : "undefined"}
                                    "aria-haspopup": props.autoComplete ? "listbox" : "false",
                                    "data-testid": "input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: props.id,
                                    children: props.label
                                })
                            ]
                        }),
                        props.type === "password" && ((ref1 = props.value) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                tabIndex: "0",
                                "aria-label": toggle ? "".concat(i18n.hide, " ").concat(props.label) : "".concat(i18n.show, " ").concat(props.label),
                                role: "button",
                                onClick: ()=>{
                                    setToggle(!toggle);
                                    handleClickHideShowPassword();
                                },
                                className: "input-field__toggle",
                                children: toggle ? i18n.hide : i18n.show
                            })
                        }),
                        props.suffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: props.suffix
                        })
                    ]
                }),
                showList && props.suggestions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    id: "".concat(props.id, "-list"),
                    className: "input-field__suggestions",
                    role: "listbox",
                    "aria-label": i18n.resultsText,
                    children: props.suggestions.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            id: "suggestion-list-item-".concat(i),
                            className: "input-field__list-item ".concat(matchedItem === item ? "--hover" : ""),
                            "aria-selected": selectedListItem === item ? "true" : "false",
                            role: "option",
                            onClick: ()=>props.onSelect(item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "input-field__list-value",
                                children: item
                            })
                        }, i))
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ref: errorRef,
                    "aria-live": "polite",
                    role: "alert",
                    id: "".concat(id, "-error"),
                    className: "input-field__error-message",
                    children: errorMessage
                })
            ]
        })
    });
});
Input.displayName = "Input";
Input.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 78145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(43106);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false , isCloseButtonClicked =()=>{} , fromPLP =false  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper/* preventBodyScroll */.MVu)(false);
        isCloseButtonClicked();
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (width < 577 || lib/* isIOS */.gn && width < 992) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            (0,helper/* removeMavenoidChat */.N9B)();
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            (0,helper/* addMavenoidChat */.dVG)();
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper/* setFocus */.kWv)(window.keyFocusCallBack);
            }
        }
        if (!fromPLP) {
            (0,helper/* preventBodyScroll */.MVu)(showModal);
        }
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper/* preventBodyScroll */.MVu)(false);
        };
    }, [
        showModal
    ]);
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    const handleModelContentOutSideClick = (e)=>{
        if (e.target === e.currentTarget) {
            triggerModalClose();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : ""),
            onClick: (e)=>{
                handleModelContentOutSideClick(e);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body",
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 96352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78145);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30167);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);








const ZipCodeInfoModal = (props)=>{
    const { staticTexts: { infoModalTitle ="" , messageZipcode ="" , continue: continueCtaLabel = ""  } = {} , data: { ctaLabel ="" , title ="" , message =""  } = {} , dataLayerPosition =""  } = props;
    const handleModalClose = (e)=>{
        if (props.data.ctaLink) {
            window.open(props.data.ctaLink);
        } else {
            var ref;
            props.handleModalClose();
            let label = ctaLabel ? ctaLabel : continueCtaLabel;
            if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.nodeName) === _constants__WEBPACK_IMPORTED_MODULE_6__.NODE_NAMES.IMG) {
                label = "close";
            }
            (0,_components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__/* .zipCodeInfoModalContinueAnalytics */ .CS)(label, dataLayerPosition);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"], {
        showModal: props.show,
        className: props.className,
        onModalClose: handleModalClose,
        labelledBy: props.labelledBy,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "taxware-down-title",
                className: "taxware-down__title",
                children: title ? title : infoModalTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "taxware-down__desc",
                children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeInnerHtml */ .KD0)(message ? message : messageZipcode)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                tag: "button",
                customClass: "taxware-down__cta",
                role: "button",
                onClick: handleModalClose,
                flexible: true,
                label: ctaLabel ? ctaLabel : continueCtaLabel,
                useDefaultClass: true
            })
        ]
    });
};
_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"].propTypes = {
    labelledBy: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    data: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (ZipCodeInfoModal);


/***/ }),

/***/ 41600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageLoader_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./public/icons/page-loader.svg
/* harmony default export */ var page_loader = ({"src":"/_next/static/media/page-loader.46514bdc.svg","height":40,"width":40});
// EXTERNAL MODULE: ./components/core/PageLoader/index.module.scss
var index_module = __webpack_require__(20889);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/PageLoader/PageLoader.jsx






const PageLoader = (param)=>{
    let { loading =false , initialLoader =false  } = param;
    (0,react.useEffect)(()=>{
        const htmlElem = document.getElementsByTagName("html")[0];
        if (loading) {
            document.body.style["touch-action"] = "none";
            htmlElem.style["touch-action"] = "none";
        } else {
            document.body.style.removeProperty("touch-action");
            htmlElem.style.removeProperty("touch-action");
        }
        return ()=>{
            document.body.style.removeProperty("touch-action");
            htmlElem.style.removeProperty("touch-action");
        };
    }, [
        loading
    ]);
    const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const [src, setSrc] = (0,react.useState)(EMPTY_PIXEL);
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq) {
            setSrc(EMPTY_PIXEL);
        } else {
            setSrc(page_loader.src);
        }
    }, [
        lib/* isMobile */.tq
    ]);
    return loading || initialLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).pageLoaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "page-loader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "page-loader__spinner",
                src: src,
                alt: "",
                "aria-hidden": "true"
            })
        })
    }) : null;
};
PageLoader.propTypes = {
    loading: (prop_types_default()).bool
};
/* harmony default export */ var PageLoader_PageLoader = (PageLoader);


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const RadioButton = (param)=>{
    let { onKeydown , analyticsData , id ="" , name ="" , value =undefined , checked =undefined , onClick =()=>{}  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        role: "radio",
        onKeyDown: onKeydown,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            radio: true
        }),
        htmlFor: id,
        "aria-checked": checked,
        tabIndex: checked ? 0 : -1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "radio",
                className: "radio__input " + (analyticsData ? "gbh-data-layer" : ""),
                "data-gbh-data-layer": analyticsData,
                name: name,
                id: id,
                checked: checked,
                onClick: onClick,
                onChange: onClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "radio__custom"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: value
            })
        ]
    });
};
RadioButton.propTypes = {
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 46394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReCaptcha_ReCaptcha; },
  "L": function() { return /* binding */ validateRecaptcha; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/analytics.js


const getInternalLinkURLS = (url)=>{
    return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) ? "true" : "false";
};
const setLinkAnalytics = function(linkUrl, type, getAnalyticsData) {
    let eventType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "navigation";
    if (!getAnalyticsData) return null;
    const { pageTitle ="n/a" , internalLinkPosition ="n/a" , addNoFooterInAttr =false  } = getAnalyticsData;
    if (typeof type !== "string") {
        var ref;
        // this is html content
        const div = document.createElement("div");
        div.innerHTML = type;
        // This contains HTML code so remove some bugs here.
        type = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
        type = type.replaceAll("\n", "");
    } else {
        type = type.toLowerCase();
    }
    const isOrderStatusPage = pageTitle === null || pageTitle === void 0 ? void 0 : pageTitle.includes(constants.ORDER_STATUS_PAGE);
    const form = !addNoFooterInAttr ? ":form" : "";
    const formFooter = !addNoFooterInAttr ? ":form:".concat(constants.FRAGMENT_TYPES.FOOTER) : "";
    const eventDetail = isOrderStatusPage ? "".concat(pageTitle, ":").concat(type) : "".concat(pageTitle).concat(formFooter, ":").concat(type);
    const eventLinkType = isOrderStatusPage ? "my account:".concat(type) : "".concat(pageTitle).concat(form, ":").concat(type);
    const prefix = linkUrl && linkUrl.indexOf("http") === -1 ? window.location.origin : "";
    const eventInfo = {
        clickInternalLinks: getInternalLinkURLS(linkUrl),
        eventAction: eventDetail || "n/a",
        eventName: eventDetail || "n/a",
        eventType,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type || "n/a",
        internalLinkPosition: internalLinkPosition || "n/a",
        internalLinkType: eventLinkType,
        internalLinkURL: linkUrl ? prefix + linkUrl : "n/a",
        internalLinkZoneName: "".concat(pageTitle).concat(formFooter)
    };
    addAnalyticsForRecaptchLinks(eventInfo, "cmp:click");
};
const addAnalyticsForRecaptchLinks = function(eventInfo) {
    let event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click";
    const page = (0,helper/* getPageInfo */.UMn)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./components/core/ReCaptcha/Recaptcha.module.scss
var Recaptcha_module = __webpack_require__(81918);
var Recaptcha_module_default = /*#__PURE__*/__webpack_require__.n(Recaptcha_module);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx
/* eslint-disable no-undef */ 









let promiseResolve;
let promiseReject;
const validateRecaptcha = ()=>{
    return new Promise((resolve, reject)=>{
        (0,config/* getConfig */.i)().then((CONFIG)=>{
            try {
                const { isDisableRecaptcha  } = CONFIG.general;
                if (isDisableRecaptcha) {
                    return resolve({
                        success: isDisableRecaptcha
                    });
                }
                const { captcha: { captchaSiteKeyV3 , captchaThreshold  } , general: { siteName  }  } = CONFIG;
                promiseResolve = resolve;
                promiseReject = reject;
                grecaptcha.ready(()=>{
                    grecaptcha.reset();
                    grecaptcha.execute(captchaSiteKeyV3).then(async (token)=>{
                        try {
                            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                                url: "/bin/kohler/google/captchaAuth?type=V3&access_token=".concat(token, "&brandName=").concat(siteName.toLowerCase()),
                                method: "GET"
                            });
                            if (data.score < captchaThreshold) {
                                grecaptcha.reset();
                                grecaptcha.execute();
                            } else {
                                return resolve(data);
                            }
                        } catch (error) {
                            reject(error);
                        }
                    }).catch((err1)=>reject(err1));
                });
            } catch (error) {
                reject(error);
            }
        });
    });
};
const ReCaptcha = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [links, setLinks] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)({});
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { legalPageLinks  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const getTranslations = (t)=>{
        return {
            protectedByGoogle: t("kf.associatemembership.label.protectedByGoogle"),
            privacyPolicyGoogle: t("kf.associatemembership.label.privacyPolicyGoogle"),
            privacyPolicy: t("kf.contactus.label.privacyPolicy"),
            termsOfService: t("kf.contactus.label.termsOfService"),
            and: t("kf.contactus.message.and"),
            apply: t("kf.contactus.message.apply")
        };
    };
    (0,react.useEffect)(()=>{
        seti18n(getTranslations(t));
        (0,config/* getConfig */.i)().then((config)=>{
            const { captcha: { captchaSiteKeyV2 , captchaSiteKeyV3  } , general: { siteName  }  } = config;
            setState({
                captchaSiteKeyV2,
                captchaSiteKeyV3,
                siteName
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3 , siteName  } = state;
        if (captchaSiteKeyV2 && captchaSiteKeyV3 && siteName) {
            loadRecaptcha();
            getLegalPages();
        }
    }, [
        state.captchaSiteKeyV2,
        state.captchaSiteKeyV3,
        state.siteName
    ]);
    (0,react.useEffect)(()=>{
        if (legalPageLinks) {
            const { googlePrivacyPolicy , googleTermsOfService  } = legalPageLinks;
            setLinks({
                googlePrivacyPolicy,
                googleTermsOfService
            });
        }
    }, [
        legalPageLinks
    ]);
    const getLegalPages = async ()=>{
        dispatch((0,genericSlice/* getLegalPageLinks */.go)());
    };
    const loadRecaptcha = ()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3  } = state;
        const scriptExist = document.getElementById("recaptcha-key");
        if (!scriptExist) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=".concat(captchaSiteKeyV3);
            script.id = "recaptcha-key";
            script.onload = function onload() {
                grecaptcha.ready(()=>{
                    grecaptcha.render("recaptcha-container", {
                        sitekey: captchaSiteKeyV2,
                        callback: (t)=>verifyToken(t)
                    });
                });
            };
            document.body.appendChild(script);
        } else {
            grecaptcha.ready(()=>{
                grecaptcha.render("recaptcha-container", {
                    sitekey: captchaSiteKeyV2,
                    callback: (t)=>verifyToken(t)
                });
            });
        }
    };
    const verifyToken = async (token)=>{
        const CONFIG = await (0,config/* getConfig */.i)();
        const { isDisableRecaptcha  } = CONFIG.general;
        if (isDisableRecaptcha) {
            promiseResolve({
                success: isDisableRecaptcha
            });
        }
        try {
            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                url: "/bin/kohler/google/captchaAuth?type=V2&access_token=".concat(token, "&brandName=").concat(state.siteName.toLowerCase()),
                method: "GET"
            });
            promiseResolve(data);
        } catch (error) {
            promiseReject(err);
        }
    };
    const { getAnalyticsData ={} , isPopupNeededBeforeRedirection =true  } = props;
    const { googlePrivacyPolicy ="n/a" , googleTermsOfService ="n/a"  } = links;
    const { privacyPolicyGoogle ="" , termsOfService =""  } = i18n;
    const handleClickOfLinks = (e, text, url)=>{
        const eventType = isPopupNeededBeforeRedirection ? "navigation" : "informative";
        if (props.addReviewRegistrationEventInfo) {
            const eventReviewInfo = props.addReviewRegistrationEventInfo(text, url, "false");
            addAnalyticsForRecaptchLinks(eventReviewInfo);
        } else {
            setLinkAnalytics(url, text, getAnalyticsData, eventType);
        }
        if (isPopupNeededBeforeRedirection) (0,helper/* getSiteWideModal */.Ure)(e, url);
        else window.open(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Recaptcha_module_default()).reCatichWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "recaptcha-container",
                    className: "g-recaptcha",
                    "data-size": "invisible"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-20 mb-20 recaptcha-links",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(i18n.protectedByGoogle, " ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, privacyPolicyGoogle, googlePrivacyPolicy),
                            children: privacyPolicyGoogle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.and,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, termsOfService, googleTermsOfService),
                            children: termsOfService
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.apply
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReCaptcha_ReCaptcha = (ReCaptcha);


/***/ }),

/***/ 1906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36513);




const SmartCropImage = (param)=>{
    let { url , altText , smartCrop ={} , handleImgeClick =()=>{}  } = param;
    let s7Image;
    if (true) {
        s7Image = window.s7responsiveImage;
    }
    const pressImg = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = url !== null && url !== void 0 ? url : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (smartCrop.scriptStatus) {
            smartCrop.applySmartCrop(pressImg.current);
        }
    }, [
        smartCrop.scriptStatus,
        url,
        s7Image
    ]);
    const checkImg = (e)=>{
        e.persist();
        const ele = e.target;
        if (ele.src !== _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src && ele.src === imgPlaceholder) {
            axios__WEBPACK_IMPORTED_MODULE_2___default().head(ele.dataset.src).then((res)=>{
                if (!res) handleImgErr(e);
            }).catch(()=>handleImgErr(e));
        }
    };
    const handleImgErr = (e)=>e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: pressImg,
        src: url ? imgPlaceholder : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
        "data-src": url,
        "data-mode": "smartcrop",
        onLoad: checkImg,
        onError: handleImgErr,
        alt: altText,
        onClick: handleImgeClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SmartCropImage);


/***/ }),

/***/ 53683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26075);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ToolTip = (props)=>{
    const [{ children =null , ...attr }, setAttribute] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        id: props.id,
        role: "tooltip",
        tabIndex: props.setFocus ? 0 : -1,
        "aria-label": props.ariaLabel,
        children: props.message
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAttribute({
            ...attr,
            children: props.message
        });
    }, [
        props.message
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (props.setFocus) (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        props.setFocus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltipWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tooltip__container",
            role: "alert",
            "aria-live": "polite",
            children: [
                props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "--label",
                            children: "".concat(props.label, ":")
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ...attr,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToolTip);


/***/ }),

/***/ 27221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15540);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57333);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76735);









const ProductCardView = (param)=>{
    let { i18n , product , currencySign , presetConfigs , swatchUrl , parent , title , brandName , skuId =""  } = param;
    var ref, ref1, ref2;
    const { COMPONENT  } = _constants_index__WEBPACK_IMPORTED_MODULE_6__["default"];
    const [productCardWidth, setProductCardWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const productCardRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const presetConfigObject = presetConfigs ? JSON.parse(presetConfigs) : {};
    const newTab = false;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setProductCardWidth(productCardRef.current.clientWidth);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getPDPUrl */ .ir5)(product === null || product === void 0 ? void 0 : product.productCategory, product === null || product === void 0 ? void 0 : product.slug).then((ret)=>setPdpNavigationURL(ret));
    }, [
        product
    ]);
    const formatUrl = (uUrl, iWidth)=>{
        if (!uUrl.includes("data:image")) {
            var ref;
            const sUrlPath = (ref = uUrl.split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
            const sUrlId = sUrlPath[sUrlPath.length - 1];
            let sPreset = "";
            if (iWidth <= 167) {
                var ref1;
                sPreset = (ref1 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobileLandscape) !== null && ref1 !== void 0 ? ref1 : "";
            } else if (iWidth <= 458) {
                var ref2;
                sPreset = (ref2 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.Desktop) !== null && ref2 !== void 0 ? ref2 : "";
            } else {
                var ref3;
                sPreset = (ref3 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobilePortrait) !== null && ref3 !== void 0 ? ref3 : "";
            }
            if (parent === COMPONENT.PAIRS_WELL_WITH) {
                return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?&product_src=is{PAWEB/").concat(sUrlId, "}&").concat(sPreset);
            }
            return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?$product_src=is{PAWEB/").concat(sUrlId, "}&?").concat(sPreset);
        }
        return uUrl;
    };
    const getProductName = ()=>{
        if (!parent && title) {
            return title;
        }
        return product.name || brandName ? product.name || brandName : product.name ? product.name : product.description;
    };
    var _price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: productCardRef,
        className: "product-card",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            prefetch: false,
            href: pdpNavigationURL + (skuId ? "?skuId=".concat(skuId) : ""),
            target: newTab ? "_blank" : "_self",
            "aria-label": "".concat(product.name, " ").concat(currencySign + product.price, " ").concat(product === null || product === void 0 ? void 0 : (ref = product.colors) === null || ref === void 0 ? void 0 : ref.length, " ").concat(i18n.ariaLabelColor),
            className: "product-card__link gbh-data-layer",
            "data-gbh-data-layer": (0,_components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_7__/* .getMoreInCollectionsInfo */ .VA)(title !== null && title !== void 0 ? title : "", false, pdpNavigationURL, product),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__img-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(presetConfigs) ? formatUrl(product.images, productCardWidth) : product.images,
                        className: "product-card__img",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "product-card__name".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    text: getProductName()
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__right",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                className: "product-card__price".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_8__/* .NumericFormat */ .h3, {
                                    value: product.discountedPrice > 0 ? product.discountedPrice : product.price,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "product-card-desc",
                                children: product.name || title || brandName ? product.description : ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__right",
                            children: product.discountedPrice !== product.price && product.discountedPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "product-card__discount-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_8__/* .NumericFormat */ .h3, {
                                    value: (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__color-text",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: (product === null || product === void 0 ? void 0 : (ref1 = product.colors) === null || ref1 === void 0 ? void 0 : ref1.length) > 1 ? "".concat(product === null || product === void 0 ? void 0 : (ref2 = product.colors) === null || ref2 === void 0 ? void 0 : ref2.length, " ").concat(i18n.recentlyViewedColors) : "1 ".concat(i18n.recentlyViewedColor)
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardView);


/***/ }),

/***/ 76735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ getMoreInCollectionSlider; },
/* harmony export */   "VA": function() { return /* binding */ getMoreInCollectionsInfo; },
/* harmony export */   "__": function() { return /* binding */ callDesignServicesAddToCartAnalytics; },
/* harmony export */   "gA": function() { return /* binding */ callInstallServiceAddToCartAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/**
 *
 * @param {Object} resInfo
 * @param {Object} productInfo
 * Kohler Data Layer Tech Spec 2021 - Batch 5 - Installation Services v1
 * Requirement#12 Add to Cart button
 */ 
const callInstallServiceAddToCartAnalytics = (param)=>{
    let { resInfo , productInfo , cartID , eventInfoObj  } = param;
    var ref;
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = eventInfoObj !== null && eventInfoObj !== void 0 ? eventInfoObj : {
        eventAction: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventName: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "installer services",
        internalLinkType: "installer services:in-person",
        internalLinkZoneName: "installer services:already have a product purchase a kohler installation service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const callDesignServicesAddToCartAnalytics = async (resInfo, productInfo, serviceName)=>{
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: serviceName + ":virtual bathroom design service:add to cart",
        eventName: serviceName + ":virtual bathroom design service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: serviceName,
        internalLinkType: serviceName + ":add to cart",
        internalLinkZoneName: serviceName + ":virtual bathroom design service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click", null, null, productInfo);
};
const getMoreInCollectionsInfo = function(title, needsJSON) {
    let pdpNavigationURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", product = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const type = (title === null || title === void 0 ? void 0 : title.toLowerCase()) === "recently viewed";
    const eventAction = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":product navigation");
    const internalLinkURL = ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL;
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(product === null || product === void 0 ? void 0 : product.name), " "),
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL,
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    if (type) {
        eventInfo.eventAction = "pdp:recently viewed:product navigation";
        eventInfo.eventName = "pdp:recently viewed:product navigation";
        eventInfo.internalLinkPosition = "pdp";
        eventInfo.internalLinkType = "pdp:navigation";
        eventInfo.internalLinkZoneName = "pdp:recently:viewed:preview";
    }
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getMoreInCollectionSlider = (title)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const eventAction = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":product slider");
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "slider",
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL: "n/a",
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};


/***/ }),

/***/ 69442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ findZipCodeMatch; },
/* harmony export */   "x": function() { return /* binding */ productCardAddToCart; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88751);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11763);





const productCardAddToCart = async (items, showPreview, message, cb)=>{
    var ref;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref1;
    const salesChannels = (ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {};
    const actions = [];
    let userZipCode;
    items.forEach((product)=>{
        var _brand;
        const fields = {
            ...(product === null || product === void 0 ? void 0 : product.userZipCode) ? {
                zipCode: product === null || product === void 0 ? void 0 : product.userZipCode
            } : {},
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        actions.push({
            action: product.isBundle ? "addbundle" : "addLineItem",
            sku: product.sku,
            quantity: product.quantity,
            custom: product.additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[product.brand],
                    roomInfo: product.additionalInfo.roomInfo,
                    customQuantity: product.additionalInfo.customQuantity,
                    overage: product.additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    });
    const body = {
        actions: actions
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        if (res) {
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
            cb && cb({
                status: 200,
                message: "success"
            });
            if (message) {
                _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)(message));
            }
            if (showPreview) _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showPreviewCart */ .z0)());
        }
    });
};
const findZipCodeMatch = (userZipCodeVal, zipCodeData)=>{
    for (const codes of zipCodeData){
        for (const key of Object.keys(codes)){
            for (const val of Object.values(codes[key])){
                var ref;
                // If val is an object with a single key, check that key
                if (((ref = Object.keys(val)) === null || ref === void 0 ? void 0 : ref[0]) === userZipCodeVal) {
                    return true;
                }
            }
        }
    }
    return false;
};


/***/ }),

/***/ 44685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24400);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11859);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38560);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20558);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59362);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7737);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46201);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24899);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88751);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36513);
/* harmony import */ var _public_icons_wish_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29875);
/* harmony import */ var _public_icons_wishlist_gray_filled_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(62084);
/* harmony import */ var _components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(80597);
/* harmony import */ var _components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21__);






















const ProductCard = (props)=>{
    const { authorData: { skewId ="" , presetConfigs ="{}"  } , isDefaultProductCard =true , isFavoriteIcon =false , selectedProduct ="" , hotspotClicked =false , toasterVar =false  } = props;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { toaster  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .selectGenericState */ .Px);
    const { cart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectCartState */ .xw);
    const { favorites  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectFavoritesState */ .Qx);
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .selectAuthState */ ._9);
    const [presetConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(JSON.parse(presetConfigs));
    const myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [favFilled, setFavFilled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [productData, setState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        isLoading: false,
        image: "",
        isFavorite: false
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (selectedProduct === skewId) myRef === null || myRef === void 0 ? void 0 : (ref = myRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    }, [
        selectedProduct,
        skewId,
        myRef,
        hotspotClicked
    ]);
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [toasterContent, setToasterContent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [pdpUrl, setPdpUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const staticTexts = {
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then((config)=>{
            setConfig(config);
            const swatchUrl = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.swatchUrl", "");
            setSwatchUrl(swatchUrl);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (skewId && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(config)) {
            const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
            const brandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.siteName", "");
            const fl = [
                "id",
                "slug_s",
                "productName_s",
                "masterSKU_s",
                "Product_Category",
                "ProductBrandName_s",
                "productImages.url_ss",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "priceList.".concat(persona, ".price_d"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "Color.SKU.Details_ss",
                "ProductWebFeatures_ss",
                "ProductWebFeatures_s",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.TPR.Details_ss",
                "RegionBrandName_s",
                "metaTitle_s",
                "ctId_s",
                "CustomerFacingBrand_s",
                "BundlePLPImageURL_s",
                "Bundle_s",
                "displayPriceStartingAt_s"
            ];
            setState({
                ...productData,
                isLoading: true
            });
            try {
                var ref;
                var ref1;
                const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
                _constants_api__WEBPACK_IMPORTED_MODULE_7__/* .apim.get */ .TH.get("/search/plp", {
                    params: {
                        fl: fl.join(","),
                        q: "*:*",
                        fq: [
                            'sku_s:("'.concat(skewId, '")'),
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: brandName.toLowerCase(),
                        profilename: "profile_".concat(brandName.toLowerCase(), "_General")
                    },
                    paramsSerializer: (params)=>{
                        return qs__WEBPACK_IMPORTED_MODULE_20___default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    if (res && res.data) {
                        var ref;
                        const productData = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(res.data, "response.docs[0]", {});
                        let imageId = "";
                        if (skewId.includes("-")) {
                            const skewIdPart = skewId.split("-");
                            const selectedVariant = skewIdPart.at(-1);
                            const imageData = productData["Color.TPR.Details_ss"].find((str)=>str.includes("-".concat(selectedVariant))).split("/");
                            imageId = imageData[imageData.length - 1];
                        }
                        const favoriteItem = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((favorite)=>favorite.variant.sku === skewId);
                        const isFavorite = favoriteItem ? true : false;
                        setFavFilled(isFavorite);
                        setState({
                            ...productData,
                            isLoading: false,
                            imageId,
                            currencySign: lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.currencySign", ""),
                            isFavorite
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.error("Error occured while fetching product data");
                    }
                });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Error occured while fetching product data", err);
            }
        }
    }, [
        config,
        favorites,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setToasterMessage();
    }, [
        toaster
    ]);
    const setToasterMessage = async ()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        window.preActiveElement = e.target;
        e.stopPropagation();
        e.preventDefault();
        if (productData.isFavorite) {
            var ref;
            const favProduct = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((fav)=>fav.variant.sku === skewId);
            if (favProduct) {
                if (!isAuth) {
                    handleLogin(e);
                } else {
                    dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .removeItems */ .Er)({
                        ids: [
                            favProduct.id
                        ]
                    })).unwrap().then(()=>{
                        const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__/* .getProductInfo */ .C)(productData, skewId, false, cart, config, description, persona);
                        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsEventForFavouriteAddRemove */ .Xc)(false, productInfo);
                        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                            message: toasterContent.unfavoriteSuccessMessage || staticTexts.removeItem,
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                            message: staticTexts.removeItemError,
                            isVisible: true
                        }));
                    });
                }
            }
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .addProduct */ .gK)(skewId)).unwrap().then(()=>{
                    const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__/* .getProductInfo */ .C)(productData, skewId, false, cart, config, description, persona);
                    (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsEventForFavouriteAddRemove */ .Xc)(true, productInfo);
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                        message: toasterContent.successMessage || staticTexts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                        message: staticTexts.favErrorMsg,
                        isVisible: true
                    }));
                });
            }
        }
    };
    const getDescriptionWithElipsis = (isMobile, description)=>{
        const length = isMobile ? 41 : 45;
        if (description.length >= length) {
            if (description.charAt(length) === " ") {
                description = description.slice(0, length) + "...";
            } else {
                description = description.slice(0, length).split(" ");
                description.pop();
                description = description.join(" ") + "...";
            }
        }
        return description;
    };
    const productCategory = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "Product_Category", "");
    const slug = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "slug_s", "");
    const name = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "productName_s", "").split(" ").slice(" ")[0];
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
    var _currencySign;
    const currencySign = (_currencySign = productData.currencySign) !== null && _currencySign !== void 0 ? _currencySign : "";
    const price = Number(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    let description = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "ProductDescriptionProductShort_s", "");
    const isMobile =  true ? window.matchMedia("(max-width: 1038px)").matches : 0;
    description = getDescriptionWithElipsis(isMobile, description);
    const reginalBrandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "RegionBrandName_s", "");
    const productBrand = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "CustomerFacingBrand_s", "");
    const { imageId =""  } = productData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(productData) && slug) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getPDPUrl */ .ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
        }
    }, [
        productData,
        slug
    ]);
    if (productData.isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "product-card-loader__container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "filter__inner-container shimmer height-300"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "filter__footer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "products-per-page width-240 mt60 mb20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "shimmer-loading__headpara shimmer"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "products-per-page width-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "shimmer-loading__para shimmer"
                            })
                        })
                    ]
                })
            ]
        });
    }
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: myRef,
        className: (_components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().productCardWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inspired-selling-module__card-container",
            style: {
                border: skewId === selectedProduct ? "3px solid var(--Gray-Gray300, #CDCDCD)" : "",
                boxShadow: skewId === selectedProduct ? "0px 0px 20px 0px rgba(0, 0, 0, 0.40)" : "",
                width: toasterVar ? "165px" : "100%"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                onClick: ()=>(0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .shopRoomhandleProductClick */ .dv)({
                        productData: productData,
                        sku: skewId,
                        url: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : "", "}"),
                        cart: cart,
                        config: config,
                        description: description,
                        persona: persona
                    }),
                href: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "inspired-selling-module__card",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image__container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "product-card__image",
                                    alt: "",
                                    src: (ref = (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getPresetUrl */ .v$)(width, 0, swatchUrl, imageId, presetConfig)) !== null && ref !== void 0 ? ref : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
                                    onError: (e)=>e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z
                                })
                            }),
                            isFavoriteIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-tile__share",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    id: "kf-add-to-fav-".concat(skewId),
                                    className: "product-tile__share-icon",
                                    tabIndex: "0",
                                    onClick: handleFavorite,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        role: "presentation",
                                        src: favFilled ? _public_icons_wishlist_gray_filled_svg__WEBPACK_IMPORTED_MODULE_19__/* ["default"].src */ .Z.src : _public_icons_wish_svg__WEBPACK_IMPORTED_MODULE_18__/* ["default"].src */ .Z.src,
                                        alt: ""
                                    })
                                })
                            }) : null
                        ]
                    }),
                    isDefaultProductCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-text__container",
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-details__container",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-details__card-title-container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            style: {
                                                color: toaster ? "#494949" : ""
                                            },
                                            children: name
                                        })
                                    }),
                                    !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-details__card-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "".concat(currencySign).concat(price)
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-details-descriprion__container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: description
                                })
                            }),
                            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-details__card-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "".concat(currencySign).concat(price)
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "shop-the-room-card-details",
                        style: {
                            color: toasterVar ? "#494949" : ""
                        },
                        children: [
                            !toasterVar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "brand-name",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: productBrand
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "regional-brand-name",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: reginalBrandName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "short-description",
                                style: {
                                    color: toasterVar ? "#494949" : "",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    webkitLineClamp: "2",
                                    webkitBoxOrient: "vertical"
                                },
                                children: description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "price",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: "".concat(currencySign).concat(price)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 38560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getProductInfo; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);


const getProductInfo = function(productData, sku) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cart = arguments.length > 3 ? arguments[3] : void 0, config = arguments.length > 4 ? arguments[4] : void 0, description = arguments.length > 5 ? arguments[5] : void 0, persona = arguments.length > 6 ? arguments[6] : void 0;
    var ref;
    const { productCouponCode , productCoupondiscount  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentSkuCouponDiscounts */ .mPk)({
        cart: cart,
        sku: sku
    });
    const colorDetails = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "Color.SKU.Details_ss", []);
    var ref1;
    const colorDetail = (ref1 = colorDetails.find((colorDetail)=>colorDetail.includes(sku))) !== null && ref1 !== void 0 ? ref1 : "|";
    const color = colorDetail.split("|")[0];
    const productInfo = {
        productInfo: {
            productBrand: (ref = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(description) || "n/a").toLowerCase(),
            globalPromotionPrice: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "priceList.".concat(persona, ".discountedPrice_d"), 0)).toFixed(2),
            productBasePrice: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toFixed(2),
            productCategory: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(productData["Product_Category"]) || "n/a").toLowerCase(),
            productColor: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(color) || "n/a").toLowerCase(),
            productName: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "productName_s", "")) || "n/a").toLowerCase(),
            productFindingMethod: "n/a",
            productCouponCode: productCouponCode.join("|") || "n/a",
            productCoupondiscount: productCoupondiscount,
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    };
    if (needsJSON) {
        return productInfo.productInfo;
    }
    return productInfo;
};


/***/ }),

/***/ 29982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fw": function() { return /* binding */ handleEmptyCartCallback; },
/* harmony export */   "G": function() { return /* binding */ addAllToCartEventInfo; },
/* harmony export */   "HP": function() { return /* binding */ multiFinishAddToCartBundleAnalytics; },
/* harmony export */   "Mw": function() { return /* binding */ continueShopGetEventInfo; },
/* harmony export */   "p1": function() { return /* binding */ getCartItemProductInfo; },
/* harmony export */   "t9": function() { return /* binding */ addMergeEventInfo; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const emptyCartEventInfo = (status, message)=>({
        eventAction: "cart:landing page:empty cart",
        eventName: "cart:landing page:empty cart",
        eventType: "navigation",
        eventMsg: status === "success" ? "n/a" : message,
        eventStatus: status,
        internalLinkName: "empty cart",
        internalLinkPosition: "cart",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:landing page:cart items",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const continueShopGetEventInfo = (continueShopUrl)=>{
    return JSON.stringify({
        eventAction: "cart preview:continue shopping",
        eventName: "cart preview:continue shopping",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "continue shopping",
        internalLinkPosition: "cart",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: (continueShopUrl.indexOf("http") === -1 ? window.location.origin : "") + continueShopUrl,
        clickInternalLinks: "true"
    });
};
const addAllToCartEventInfo = (link)=>{
    const eventInfo = {
        eventAction: "cart:share cart landing page:add all to cart",
        eventName: "cart:share cart landing page:add all to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add all to cart",
        internalLinkPosition: "share cart",
        internalLinkType: "share cart:navigation",
        internalLinkZoneName: "cart:share cart landing page:order summary",
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addMergeEventInfo = (type, link)=>{
    const eventInfo = {
        eventAction: "cart:share cart landing page:add all to cart:".concat(type),
        eventName: "cart:share cart landing page:add all to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "share cart",
        internalLinkType: "share cart:navigation",
        internalLinkZoneName: "cart:share cart landing page:order summary",
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};
const handleEmptyCartCallback = (status, message, res)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState ? getState("page") : {};
    if (status === "success" && res) {
        var ref;
        page.cart = {
            cartID: res.id || ((ref = page.cart) === null || ref === void 0 ? void 0 : ref.cartID) || null,
            item: null,
            price: null
        };
    }
    const eventInfo = emptyCartEventInfo(status, message);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getCartItemProductInfo = function() {
    let siteName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { sku ="" , desc ="" , name ="" , color ="" , image ="" , quantity =0 , category ="" , unitPrice =0 , totalPrice =0 , availableQty =0 , superSku =false , outOfStock =false , discountPercent =0 , ProductIsRetail ="" , businessUnitName ="" , customerFacingSKU ="" , discontinuedProductb ="" , productCollectionsName ="" , ProductRequiredAccessoriesGroupsList =""  } = data;
    return JSON.stringify({
        productInfo: {
            productBrand: siteName.toLowerCase(),
            description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(desc),
            globalPromotionPrice: totalPrice,
            priceState: "".concat(discountPercent > 0 ? "percentOff|".concat(discountPercent) : "regular price"),
            productBasePrice: unitPrice,
            productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category),
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(color),
            productID: customerFacingSKU || sku,
            productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(name),
            productRoom: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category),
            productSalePrice: totalPrice,
            productStatus: outOfStock && availableQty < 1 ? "out of stock" : "in stock",
            productSuperSku: superSku ? true : false,
            productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(name),
            quantity: quantity,
            defaultImageName: image,
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(productCollectionsName || category),
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "true",
            productSaleable: "true",
            isRecommended: "true",
            isSendNow: "true",
            isSubscription: "true",
            frequency: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pdpTypeFormat */ .V4r)({
                businessUnitName: businessUnitName,
                ProductIsRetail: ProductIsRetail,
                discontinuedProductb: discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
                superSku: superSku
            }),
            productFindingMethod: "n/a"
        }
    });
};
const multiFinishAddToCartBundleAnalytics = function() {
    let previousBundleItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], selectedBundlesProdctList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (Object.keys(previousBundleItems).length === 0) {
        const bundlesLists = JSON.stringify(selectedBundlesProdctList);
        localStorage.setItem("bundleItems", bundlesLists);
    } else {
        const isExitingBundleItems = previousBundleItems.find((item)=>{
            return item.bundleId === selectedBundlesProdctList[0].bundleId;
        });
        if (isExitingBundleItems) {
            const newBundleItems = previousBundleItems.map((item)=>{
                var ref;
                if ((item === null || item === void 0 ? void 0 : item.bundleId) === ((ref = selectedBundlesProdctList[0]) === null || ref === void 0 ? void 0 : ref.bundleId)) {
                    const data = {
                        ...item,
                        selectedSkus: [
                            ...item.selectedSkus,
                            ...selectedBundlesProdctList[0].selectedSkus
                        ]
                    };
                    data.selectedSkus = data.selectedSkus.filter((value, index, array)=>array.indexOf(value) === index);
                    return data;
                }
                return item;
            });
            localStorage.setItem("bundleItems", JSON.stringify(newBundleItems));
        } else {
            const newBundleItems1 = [
                ...previousBundleItems,
                ...selectedBundlesProdctList
            ];
            localStorage.setItem("bundleItems", JSON.stringify(newBundleItems1));
        }
    }
};


/***/ }),

/***/ 4364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J9": function() { return /* binding */ shareaddToCart; },
/* harmony export */   "Ot": function() { return /* binding */ generateCartData; },
/* harmony export */   "al": function() { return /* binding */ deleteCart; },
/* harmony export */   "gO": function() { return /* binding */ getSharedCart; },
/* harmony export */   "kx": function() { return /* binding */ getShareCartaddToCart; },
/* harmony export */   "tH": function() { return /* binding */ handleSharedCartItems; },
/* harmony export */   "uX": function() { return /* binding */ getProductsBySku; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11763);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55760);
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30696);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93284);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64757);
/* harmony import */ var _components_sharedCart_analytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29982);
/* harmony import */ var _services_productServices__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35285);










const { shareCartEndPoint  } = __webpack_require__(96301);



const getProductsBySku = async (skus)=>{
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_10__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=masterVariant(sku in (").concat(query, ")) or variants(sku in (").concat(query, "))"));
    if (res && res.data && res.data.results) return res.data.results;
    return [];
};
const getSharedCart = async (id)=>{
    const { data =false  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(shareCartEndPoint, "/").concat(id));
    if (data) {
        const lineitems = data === null || data === void 0 ? void 0 : data.lineitems.map((item)=>{
            return {
                ...item,
                roomInfo: (item === null || item === void 0 ? void 0 : item.roomInfo) ? JSON.stringify(item.roomInfo) : ""
            };
        });
        const sharedCart = {
            ...data,
            lineitems
        };
        return sharedCart;
    }
};
const showToastHandler = (msg)=>_store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .showToast */ .CF)({
        message: msg,
        isVisible: true
    }));
const shareaddToCart = async (items, message, callback, clockID)=>{
    var ref, ref1;
    const payload = [];
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { apiEndpoints: { stockFailureErrorMsg =""  } = {}  } = config || {};
    var ref2;
    const salesChannels = (ref2 = config === null || config === void 0 ? void 0 : (ref = config.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref2 !== void 0 ? ref2 : {};
    const selectedBundlesProdctList = items === null || items === void 0 ? void 0 : (ref1 = items[0]) === null || ref1 === void 0 ? void 0 : ref1.selectedBundlesProduct;
    items.forEach(function() {
        let product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { isBundleProduct =false , isBundle =false , sku ="" , quantity =0 , brand =""  } = product;
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        payload.push({
            action: isBundleProduct ? "addBundleItem" : isBundle ? "addbundle" : "addLineItem",
            sku,
            quantity,
            custom: product.additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[product.brand],
                    roomInfo: product.additionalInfo.roomInfo,
                    customQuantity: product.additionalInfo.customQuantity,
                    overage: product.additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    ...fields
                }
            }
        });
    });
    if (clockID) {
        payload.push({
            action: "setCustomType",
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: clockID,
                orderType: "ISC"
            }
        });
    }
    const bundleLocalStorage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("bundleItems");
    const previousBundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : [];
    const skus = payload.map((item)=>item.sku).join(",");
    const { inventories , isError =false  } = await (0,_services_productServices__WEBPACK_IMPORTED_MODULE_12__/* .getProductInventory */ .o)(skus);
    const inventoriesMap = inventories.map((item)=>{
        const isBackOrder = payload.find((el)=>el.custom.fields.isBackOrderable);
        if (isBackOrder) {
            return {
                ...item,
                availableQuantity: 1
            };
        } else return item;
    });
    const isAllAvailable = inventoriesMap.every((el)=>el.availableQuantity > 0);
    const body = {
        actions: payload
    };
    if (isError) {
        _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .showToast */ .CF)({
            isVisible: true,
            message: stockFailureErrorMsg
        }));
        callback(true);
        return;
    }
    if (isAllAvailable) {
        await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
            if (res) {
                if ((selectedBundlesProdctList === null || selectedBundlesProdctList === void 0 ? void 0 : selectedBundlesProdctList.length) > 0) {
                    (0,_components_sharedCart_analytics__WEBPACK_IMPORTED_MODULE_11__/* .multiFinishAddToCartBundleAnalytics */ .HP)(previousBundleItems, selectedBundlesProdctList);
                }
                _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCart */ .RV)(res));
                const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
                const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_5__/* .getQuantityCount */ .PW)(quantityLineItems);
                _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCartCount */ .oJ)(payload));
                if (message) {
                    showToastHandler(message);
                }
                if (callback) {
                    callback(false, {
                        res
                    });
                }
            }
        }).catch((err)=>{
            callback(err);
        });
    } else {
        callback(false);
    }
};
const handleSharedCartItems = function() {
    let cartItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], products = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], info = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const { currencyCode ="" , locale ="" , comboSkus: comboSkusArg = [] , productBrands: productBrandsArg = []  } = info;
    let subtotal = 0;
    const specFiles = [];
    const cartData = [];
    const comboSkus = [
        ...comboSkusArg
    ];
    const productBrands = [
        ...productBrandsArg
    ];
    if (products.length > 0) {
        cartItems.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        }).forEach((item, i)=>{
            var ref;
            let product = {};
            let productVariant = {};
            // Check if product is master variant
            if (products.find((product)=>product.masterVariant.sku === item.sku)) {
                product = products.find((product)=>product.masterVariant.sku === item.sku);
                productVariant = product.masterVariant;
            } else {
                var ref1;
                var ref2;
                product = (ref2 = products.find((product)=>product.variants.find((variant)=>variant.sku === item.sku))) !== null && ref2 !== void 0 ? ref2 : {};
                var ref3;
                productVariant = (ref3 = (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.find((variant)=>variant.sku === item.sku)) !== null && ref3 !== void 0 ? ref3 : {};
            }
            var _attributes;
            // Get product details
            const attributes = (_attributes = productVariant.attributes) !== null && _attributes !== void 0 ? _attributes : [];
            let priceObj = (ref = productVariant.prices) === null || ref === void 0 ? void 0 : ref.find((price)=>{
                var ref, ref1;
                return price.value.currencyCode === currencyCode && ((ref = price.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) === (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getUserPersona */ .shu)();
            });
            if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) {
                var ref4;
                priceObj = (ref4 = productVariant.prices) === null || ref4 === void 0 ? void 0 : ref4.find((price)=>price.value.currencyCode === currencyCode && !price.customerGroup);
            }
            const unitPrice = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(priceObj, "value.centAmount", 0);
            var ref5, _thumbnailImage;
            cartData[i] = {
                id: (ref5 = product === null || product === void 0 ? void 0 : product.id) !== null && ref5 !== void 0 ? ref5 : "",
                sku: item.sku,
                slug: (product === null || product === void 0 ? void 0 : product.slug) ? product.slug[locale] : "",
                quantity: item.qty,
                image: (_thumbnailImage = item.thumbnailImage) !== null && _thumbnailImage !== void 0 ? _thumbnailImage : "",
                category: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", ""),
                brand: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", ""),
                name: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(item, "skuName", "")),
                desc: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
                color: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), ""),
                unitPrice: Number((unitPrice / 100).toFixed(2)),
                totalPrice: Number((unitPrice * item.qty / 100).toFixed(2)),
                customerFacingSKU: (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_8__/* .getAttributeValue */ .kD)(attributes, "CustomerFacingSKU")
            };
            // Check if product is a combo sku
            comboSkus[item.sku] = attributes.findIndex((attr)=>attr.name === "ComboSKU") !== -1;
            productBrands[item.sku] = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
            // Calculate cart subtotal
            subtotal = subtotal + Number((unitPrice * item.qty / 100).toFixed(2));
            // Get spec files for all line items
            const productResources = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductResource"), "value", []);
            if (productResources.length > 0) {
                var ref6;
                const resource = (ref6 = productResources.find((arr)=>arr[1].value === "SpecPDFFileName")) !== null && ref6 !== void 0 ? ref6 : [];
                var ref7;
                const resourceUrl = (ref7 = resource.find((obj)=>obj.name === "ResourceFullWebURL")) !== null && ref7 !== void 0 ? ref7 : {};
                var _value;
                const specFileUrl = (_value = resourceUrl.value) !== null && _value !== void 0 ? _value : "";
                if (specFileUrl) specFiles.push(specFileUrl);
            }
        });
        return {
            cartData,
            specFiles,
            subtotal,
            comboSkus,
            productBrands
        };
    }
};
const getShareCartaddToCart = async function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], showPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, message = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{}, taxCalculate = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, clockID = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", isSharedCart = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, replaceCart = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var ref, ref1;
    const { itemAddedToCart ="" , addToCartErrorMsg =""  } = message;
    const payload = [];
    let userZipCode;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const isAuthenticated = (ref = _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.auth.isAuth;
    var ref2;
    const salesChannels = (ref2 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref1 = CONFIG.salesChannelConfig) === null || ref1 === void 0 ? void 0 : ref1.map) !== null && ref2 !== void 0 ? ref2 : {};
    items.forEach((product)=>{
        const { brand ="" , backorder =false , isBundle ="" , sku ="" , quantity ="" , additionalInfo =""  } = product;
        var ref;
        const fields = {
            salesChannel: (ref = salesChannels[brand.toLowerCase()]) !== null && ref !== void 0 ? ref : "KOUS"
        };
        if (backorder) fields.isBackOrderable = true;
        payload.push({
            action: isBundle ? "addbundle" : "addLineItem",
            sku: sku,
            quantity: quantity,
            custom: additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[brand],
                    roomInfo: additionalInfo.roomInfo,
                    customQuantity: additionalInfo.customQuantity,
                    overage: additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    });
    const { id ="" , version =0 , customerGroup ="" , shippingAddress: { postalCode =""  } = {}  } = await generateCartData({
        replaceCart
    });
    if (taxCalculate && postalCode) payload.push({
        action: "calculateTax"
    });
    if (!isAuthenticated && !customerGroup) {
        payload.push({
            action: "setCustomerGroup",
            customerGroup: {
                key: "GST"
            }
        });
    }
    if (clockID) {
        payload.push({
            action: "setCustomType",
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: clockID,
                orderType: "ISC"
            }
        });
    }
    const body = {
        version: version,
        actions: payload,
        cartId: id,
        isSharedCart
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    let atcStatus;
    await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .shareCartaddToCart */ ._P)(body)).unwrap().then((res)=>{
        if (res) {
            atcStatus = {
                res
            };
            if (itemAddedToCart) {
                showToastHandler(itemAddedToCart);
            }
            if (showPreview) _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .showPreviewCart */ .z0)());
            if (callback) {
                callback({
                    message: "success",
                    res
                });
            }
            if (taxCalculate && postalCode) {
                _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_9__/* .getShippingMethods */ .qy)());
            }
            if (!isAuthenticated && res.anonymousId) localStorage.setItem("anonymousId", res.anonymousId);
        }
    }).catch(()=>{
        _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(showToastHandler(addToCartErrorMsg));
    });
    return atcStatus;
};
const deleteCart = async (errMsg)=>{
    const errorMsg = "Failed to delete cart";
    try {
        const { id ="" , version =0  } = await generateCartData({
            isNotFromCart: true
        });
        return _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .shareCartDelete */ .ap)({
            id,
            version
        }));
    } catch (err) {
        console.log(errorMsg, err);
        _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(showToastHandler(errMsg));
    }
};
const generateCartData = async (arg)=>{
    const { replaceCart =false , isNotFromCart =false  } = arg || {};
    const currency = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getCurrency */ .zC$)();
    const body = {
        currency: currency,
        taxMode: "ExternalAmount"
    };
    let cartData = {};
    if (replaceCart) {
        const { payload  } = await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(body));
        cartData = payload;
    } else {
        var ref, ref1;
        const { payload: rsp  } = await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)(arg));
        cartData = isNotFromCart ? rsp === null || rsp === void 0 ? void 0 : (ref = rsp.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.activeCart : rsp;
    }
    return cartData;
};


/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gb": function() { return /* binding */ aemAxiosInstance; },
/* harmony export */   "TH": function() { return /* binding */ apim; },
/* harmony export */   "ab": function() { return /* binding */ getAnonymousToken; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65885);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88032);
/* harmony import */ var _utils_dateHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64443);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46201);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55760);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* harmony import */ var _utils_httpTimeout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51380);
/* provided dependency */ var process = __webpack_require__(34155);










const httpTimeoutMs = (0,_utils_httpTimeout__WEBPACK_IMPORTED_MODULE_8__/* .resolveHttpTimeoutMs */ .F)(process.env.NEXT_PUBLIC_HTTP_TIMEOUT_MS, process.env.HTTP_TIMEOUT_MS);
const aemAxiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: ___WEBPACK_IMPORTED_MODULE_1__.authorBaseUrl,
    timeout: httpTimeoutMs,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp"
    }
});
const apim = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    timeout: 25000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp"
    }
});
let validateTokenRequest;
let getAnonymousTokenRequest;
let isRefreshingToken = false;
let failedRequestsQueue = [];
const validateToken = (accessToken, apimHost)=>{
    if (!validateTokenRequest) {
        validateTokenRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(apimHost).concat(___WEBPACK_IMPORTED_MODULE_1__.validateTokenEndPoint), {}, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken)
            }
        });
        validateTokenRequest.then(resetValidateTokenRequest, resetValidateTokenRequest);
    }
    return validateTokenRequest;
};
const getAnonymousToken = async (apimHost)=>{
    let gId;
    const token = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getAccessToken */ .hPi)();
    gId = token.gId;
    const cookie = new universal_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z();
    cookie.get("commerce_gid") && (gId = cookie.get("commerce_gid"));
    if (!getAnonymousTokenRequest) {
        const { apiEndPointData: { map: { channel  }  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        getAnonymousTokenRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(apimHost).concat(___WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest").concat(channel ? "&channel=".concat(channel) : ""), null, {
            params: {
                gId: gId
            }
        });
        getAnonymousTokenRequest.then(resetGetAnonymousTokenRequest, resetGetAnonymousTokenRequest);
    }
    return getAnonymousTokenRequest;
};
const processQueue = function(error) {
    let token = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const queue = [
        ...failedRequestsQueue
    ];
    failedRequestsQueue = [];
    queue.forEach((promise)=>{
        if (error) {
            promise.reject(error);
        } else {
            promise.resolve(token);
        }
    });
};
const addRequestToQueue = (originalRequest)=>{
    return new Promise((resolve, reject)=>{
        failedRequestsQueue.push({
            resolve: (token)=>{
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = "Bearer ".concat(token);
                originalRequest._retry = true;
                resolve(apim(originalRequest));
            },
            reject: (err)=>{
                reject(err);
            }
        });
    });
};
const resetValidateTokenRequest = ()=>{
    validateTokenRequest = null;
    getAnonymousTokenRequest = null;
};
const resetGetAnonymousTokenRequest = ()=>{
    getAnonymousTokenRequest = null;
    validateTokenRequest = null;
};
apim.interceptors.request.use(async (config)=>{
    config.baseURL = ___WEBPACK_IMPORTED_MODULE_1__.publicApiBaseUrl;
    config.headers = config.headers || {};
    const { token: accessToken = ""  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getAccessToken */ .hPi)();
    const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getAnonymousId */ .yQL)();
    if (accessToken) {
        config.headers.Authorization = "Bearer ".concat(accessToken);
    } else if (window && window.authAccessToken) {
        config.headers.Authorization = "Bearer ".concat(window.authAccessToken);
        window.authAccessToken = "";
    }
    if (!config.headers["X-Source-Origin"]) {
        config.headers["X-Source-Origin"] = ___WEBPACK_IMPORTED_MODULE_1__.SOURCE_ORIGIN !== null && ___WEBPACK_IMPORTED_MODULE_1__.SOURCE_ORIGIN !== void 0 ? ___WEBPACK_IMPORTED_MODULE_1__.SOURCE_ORIGIN :  true ? window.location.origin : 0;
    }
    const getNewToken = async ()=>{
        try {
            const res = await getAnonymousToken(___WEBPACK_IMPORTED_MODULE_1__.publicApiBaseUrl);
            const { data: { access_token: accessToken = ""  } = {}  } = res;
            const payload = {
                accessToken
            };
            _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
            config.headers.Authorization = "Bearer ".concat(accessToken);
            return config;
        } catch (_error) {
            return Promise.reject(_error);
        }
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .addPageLoadAnalyticsEvent */ .igK)();
    const { auth: { revalidate_in: revalidateIn , isAuth =false  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState() || {};
    const isAfter = (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_3__/* .isAfterDate */ .fT)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentDate */ .Ux)(), revalidateIn);
    if (!accessToken) {
        return await getNewToken();
    } else if (anonymousId && isAfter && !isAuth) {
        try {
            var ref;
            const res = await validateToken(accessToken, ___WEBPACK_IMPORTED_MODULE_1__.publicApiBaseUrl);
            if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.valid) {
                _store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setRevalidateTime */ .iU)());
                return config;
            } else {
                return await getNewToken();
            }
        } catch (e) {
            try {
                const res1 = await getAnonymousToken(___WEBPACK_IMPORTED_MODULE_1__.publicApiBaseUrl);
                const { data: { access_token: accessToken1 = ""  } = {}  } = res1;
                const payload = {
                    accessToken: accessToken1
                };
                _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
                config.headers.Authorization = "Bearer ".concat(accessToken1);
                return config;
            } catch (_error) {
                return Promise.reject(_error);
            }
        }
    } else {
        return config;
    }
}, (error)=>{
    return Promise.reject(error);
});
apim.interceptors.response.use(async (res)=>{
    return res;
}, async (error)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    const originalConfig = (error === null || error === void 0 ? void 0 : error.config) || {};
    const isTokenEndpoint = originalConfig === null || originalConfig === void 0 ? void 0 : (ref = originalConfig.url) === null || ref === void 0 ? void 0 : ref.includes(___WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint);
    if (!((ref1 = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState()) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.auth) === null || ref2 === void 0 ? void 0 : ref2.isAuth) && (error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 401 && !originalConfig._retry && !isTokenEndpoint) {
        originalConfig.headers = originalConfig.headers || {};
        // If token refresh is already in progress, queue this request
        if (isRefreshingToken) {
            return addRequestToQueue(originalConfig);
        }
        originalConfig._retry = true;
        isRefreshingToken = true;
        return getAnonymousToken(___WEBPACK_IMPORTED_MODULE_1__.publicApiBaseUrl).then((res)=>{
            const { data: { access_token: accessToken = ""  } = {}  } = res;
            const payload = {
                accessToken
            };
            _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
            // Process all queued requests with new token
            processQueue(null, accessToken);
            originalConfig.headers.Authorization = "Bearer ".concat(accessToken);
            return apim(originalConfig);
        }).catch((_error)=>{
            processQueue(_error, null);
            return Promise.reject(_error);
        }).finally(()=>{
            isRefreshingToken = false;
        });
    } else if (((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.config) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.url) === null || ref6 === void 0 ? void 0 : ref6.includes(___WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint)) || (error === null || error === void 0 ? void 0 : (ref7 = error.response) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.config) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.url) === null || ref9 === void 0 ? void 0 : ref9.includes(___WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint))) && (error === null || error === void 0 ? void 0 : (ref10 = error.response) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.error) === null || ref12 === void 0 ? void 0 : ref12.message) && (error === null || error === void 0 ? void 0 : (ref13 = error.response) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.error) === null || ref15 === void 0 ? void 0 : ref15.sku)) {
        var ref16, ref17, ref18, ref19;
        const productsArray = [];
        error === null || error === void 0 ? void 0 : (ref16 = error.response) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.error) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.sku) === null || ref19 === void 0 ? void 0 : ref19.forEach((data)=>{
            productsArray.push({
                sku: data
            });
        });
        await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .setNoshipping */ .qT)(productsArray));
    }
    return Promise.reject(error);
});
aemAxiosInstance.interceptors.request.use(async (config)=>{
    const origin = ___WEBPACK_IMPORTED_MODULE_1__.SOURCE_ORIGIN !== null && ___WEBPACK_IMPORTED_MODULE_1__.SOURCE_ORIGIN !== void 0 ? ___WEBPACK_IMPORTED_MODULE_1__.SOURCE_ORIGIN : ___WEBPACK_IMPORTED_MODULE_1__.authorBaseUrl;
    if (!config.headers["X-Source-Origin"]) {
        var ref;
        if ((ref = config.headers) === null || ref === void 0 ? void 0 : ref.common["Ocp-Apim-Subscription-Key"]) {
            config.headers["X-Source-Origin"] = origin;
        }
    }
    return config;
});



/***/ }),

/***/ 19514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getConfig; },
/* harmony export */   "p": function() { return /* binding */ initConfig; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);


/**
 *
 * @return {{initConfig, getConfig}}
 */ function configuration() {
    let _configurationObj = {};
    const initConfig = async ()=>{
        const urlPath = window.location.pathname;
        const path = "".concat(___WEBPACK_IMPORTED_MODULE_0__.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(urlPath, "&caConfig=true");
        var ref;
        _configurationObj = (ref = JSON.parse(localStorage && localStorage.getItem("caConfig-".concat(document.documentElement.lang)))) !== null && ref !== void 0 ? ref : {
            expireTime: 0
        };
        const currentTime = new Date().getTime();
        if (path && currentTime > _configurationObj.expireTime) {
            var ref1;
            await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.get */ .Gb.get(path).then((response)=>{
                if (response && response.data) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                    const _backendConfig = response.data;
                    if (_backendConfig === null || _backendConfig === void 0 ? void 0 : (ref = _backendConfig.general) === null || ref === void 0 ? void 0 : ref.isPublish) {
                        const getShortenedUrl = (uUrl)=>{
                            var ref;
                            var ref1;
                            const shortUrl = (ref1 = _backendConfig === null || _backendConfig === void 0 ? void 0 : (ref = _backendConfig.general) === null || ref === void 0 ? void 0 : ref.shortendPagePath) !== null && ref1 !== void 0 ? ref1 : "";
                            const shortUrlRegEx = new RegExp(shortUrl, "g");
                            const htmlRegExp = new RegExp(".html", "g");
                            return uUrl.replace(shortUrlRegEx, "").replace(htmlRegExp, "");
                        };
                        const pattern = "^(?!.*json)".concat(_backendConfig.general.shortendPagePath, ".*");
                        for(const link in _backendConfig.general){
                            if (({}).hasOwnProperty.call(_backendConfig.general, link)) {
                                const url = "".concat(_backendConfig.general[link]);
                                if (url.match(pattern)) {
                                    if (link !== "shortendPagePath") _backendConfig.general[link] = getShortenedUrl(_backendConfig.general[link]);
                                }
                            }
                        }
                    }
                    _configurationObj = Object.assign(_configurationObj, _backendConfig);
                    _configurationObj.annsacksPDPConfig = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.annsacksPDPConfig) === null || ref2 === void 0 ? void 0 : ref2.map;
                    var ref7;
                    _configurationObj.apiEndpoints = (ref7 = (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.apiEndPointData) === null || ref4 === void 0 ? void 0 : ref4.map) !== null && ref7 !== void 0 ? ref7 : {};
                    var ref8;
                    const assetAccountName = (ref8 = response === null || response === void 0 ? void 0 : (ref5 = response.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.general) === null || ref6 === void 0 ? void 0 : ref6.scene7AccountName) !== null && ref8 !== void 0 ? ref8 : null;
                    if (assetAccountName) {
                        _configurationObj.general.swatchUrl = _configurationObj.general.swatchUrl.replace("PAWEB", assetAccountName);
                    }
                } else {
                    console.error("Error occurred while fetching Backend Configuration");
                }
            });
            await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.get */ .Gb.get(___WEBPACK_IMPORTED_MODULE_0__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + ((ref1 = _configurationObj.general) === null || ref1 === void 0 ? void 0 : ref1.plpServletPath)).then((res)=>{
                var ref;
                _configurationObj.plpServletPath = (ref = res.data) === null || ref === void 0 ? void 0 : ref.pdpURLMapping;
                _configurationObj.expireTime = new Date().getTime() + ___WEBPACK_IMPORTED_MODULE_0__.ADD_10_MINUTES;
                if (localStorage) localStorage.setItem("caConfig-".concat(document.documentElement.lang), JSON.stringify(_configurationObj));
            }).catch((err)=>console.error("Error occurred while fetching PLP Servlet path", err));
        } else {
            console.log("Configuration URL for found");
        }
    };
    const getConfig = async ()=>{
        let configTimer;
        const config = new Promise((resolve)=>{
            if ((_configurationObj === null || _configurationObj === void 0 ? void 0 : _configurationObj.expireTime) === 0) {
                configTimer = setTimeout(()=>resolve(getConfig()), 500);
            } else {
                configTimer && clearTimeout(configTimer);
                resolve(_configurationObj);
            }
        });
        return config;
    };
    return {
        initConfig,
        getConfig
    };
}
const { initConfig , getConfig  } = configuration();


/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADDRESS_SUGGESTION_DEFAULT_COUNTRY": function() { return /* binding */ ADDRESS_SUGGESTION_DEFAULT_COUNTRY; },
/* harmony export */   "ADD_10_MINUTES": function() { return /* binding */ ADD_10_MINUTES; },
/* harmony export */   "ADD_TO_CART": function() { return /* binding */ ADD_TO_CART; },
/* harmony export */   "AFFIRM_SHOP_URL": function() { return /* binding */ AFFIRM_SHOP_URL; },
/* harmony export */   "API_FAILURE_STATUS": function() { return /* binding */ API_FAILURE_STATUS; },
/* harmony export */   "API_SUCCESS_STATUS": function() { return /* binding */ API_SUCCESS_STATUS; },
/* harmony export */   "ARTICLE_CONTENT_END_POINT": function() { return /* binding */ ARTICLE_CONTENT_END_POINT; },
/* harmony export */   "ARTICLE_IMG_END_POINT": function() { return /* binding */ ARTICLE_IMG_END_POINT; },
/* harmony export */   "BAZAAR_VOICE": function() { return /* binding */ BAZAAR_VOICE; },
/* harmony export */   "BRAND_NAME": function() { return /* binding */ BRAND_NAME; },
/* harmony export */   "BREAD_CRUMB_APP_LD_JSON": function() { return /* binding */ BREAD_CRUMB_APP_LD_JSON; },
/* harmony export */   "BROWSE_ALL_KOHLER_STORES": function() { return /* binding */ BROWSE_ALL_KOHLER_STORES; },
/* harmony export */   "BROWSE_ALL_STORES": function() { return /* binding */ BROWSE_ALL_STORES; },
/* harmony export */   "BROWSE_ALL_STORES_URL": function() { return /* binding */ BROWSE_ALL_STORES_URL; },
/* harmony export */   "BUNDLE_LABEL": function() { return /* binding */ BUNDLE_LABEL; },
/* harmony export */   "BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY; },
/* harmony export */   "BUYING_GUIDE": function() { return /* binding */ BUYING_GUIDE; },
/* harmony export */   "BUYING_GUIDE_ASPATH": function() { return /* binding */ BUYING_GUIDE_ASPATH; },
/* harmony export */   "BV_SCRIPT_URL": function() { return /* binding */ BV_SCRIPT_URL; },
/* harmony export */   "CALL_OUR_TEAM": function() { return /* binding */ CALL_OUR_TEAM; },
/* harmony export */   "CARD_TYPES": function() { return /* binding */ CARD_TYPES; },
/* harmony export */   "CAROUSEL_IMAGE": function() { return /* binding */ CAROUSEL_IMAGE; },
/* harmony export */   "CART_URL": function() { return /* binding */ CART_URL; },
/* harmony export */   "CATEGORY_LANDING_PAGES": function() { return /* binding */ CATEGORY_LANDING_PAGES; },
/* harmony export */   "CHANGE_ACCOUNT_PASSWORD_ENDPOINT": function() { return /* binding */ CHANGE_ACCOUNT_PASSWORD_ENDPOINT; },
/* harmony export */   "CHECKOUT_PAYMENT": function() { return /* binding */ CHECKOUT_PAYMENT; },
/* harmony export */   "CHECKOUT_URL": function() { return /* binding */ CHECKOUT_URL; },
/* harmony export */   "CLOSE": function() { return /* binding */ CLOSE; },
/* harmony export */   "COLOR": function() { return /* binding */ COLOR; },
/* harmony export */   "COMPONENT_TYPES": function() { return /* binding */ COMPONENT_TYPES; },
/* harmony export */   "CONTACT_US_FORM": function() { return /* binding */ CONTACT_US_FORM; },
/* harmony export */   "CONTACT_US_PAGE_URL": function() { return /* binding */ CONTACT_US_PAGE_URL; },
/* harmony export */   "CONTACT_US_PAGE_URL_US": function() { return /* binding */ CONTACT_US_PAGE_URL_US; },
/* harmony export */   "CONTACT_US_SUPPORT": function() { return /* binding */ CONTACT_US_SUPPORT; },
/* harmony export */   "CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT": function() { return /* binding */ CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT; },
/* harmony export */   "CORE_GLOBAL_CONFIG_URL": function() { return /* binding */ CORE_GLOBAL_CONFIG_URL; },
/* harmony export */   "COUNTRY": function() { return /* binding */ COUNTRY; },
/* harmony export */   "CREATE_ACCOUNT": function() { return /* binding */ CREATE_ACCOUNT; },
/* harmony export */   "DB_NAME": function() { return /* binding */ DB_NAME; },
/* harmony export */   "DB_VERSION": function() { return /* binding */ DB_VERSION; },
/* harmony export */   "DECLINED_PAGE_URL": function() { return /* binding */ DECLINED_PAGE_URL; },
/* harmony export */   "DEFAULT_CARD_DETAILS_API_PATH": function() { return /* binding */ DEFAULT_CARD_DETAILS_API_PATH; },
/* harmony export */   "DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME": function() { return /* binding */ DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME; },
/* harmony export */   "DEFAULT_PRODUCT_COUNT_PLP": function() { return /* binding */ DEFAULT_PRODUCT_COUNT_PLP; },
/* harmony export */   "DEFAULT_SCROLL": function() { return /* binding */ DEFAULT_SCROLL; },
/* harmony export */   "DEFAULT_STORE_DETAILS_API_PATH": function() { return /* binding */ DEFAULT_STORE_DETAILS_API_PATH; },
/* harmony export */   "DEFAULT_TECHNICAL_SPECT_COUNT": function() { return /* binding */ DEFAULT_TECHNICAL_SPECT_COUNT; },
/* harmony export */   "DELETE_ACCOUNT_ENDPOINT": function() { return /* binding */ DELETE_ACCOUNT_ENDPOINT; },
/* harmony export */   "DESKTOP_WIDTH": function() { return /* binding */ DESKTOP_WIDTH; },
/* harmony export */   "DEVICE_TYPE_DESKTOP": function() { return /* binding */ DEVICE_TYPE_DESKTOP; },
/* harmony export */   "DISABLE_SROLL_PATH": function() { return /* binding */ DISABLE_SROLL_PATH; },
/* harmony export */   "DISCOUNTED_PRICE_FACET_LABEL": function() { return /* binding */ DISCOUNTED_PRICE_FACET_LABEL; },
/* harmony export */   "DOMAIN": function() { return /* binding */ DOMAIN; },
/* harmony export */   "DOWNLOAD_SPINNER": function() { return /* binding */ DOWNLOAD_SPINNER; },
/* harmony export */   "EDIT_PROFILE_ENDPOINT": function() { return /* binding */ EDIT_PROFILE_ENDPOINT; },
/* harmony export */   "EMBED_TYPE_HTML": function() { return /* binding */ EMBED_TYPE_HTML; },
/* harmony export */   "EMBED_TYPE_SCRIPT": function() { return /* binding */ EMBED_TYPE_SCRIPT; },
/* harmony export */   "EMPTY_FAVORITE_BASE64": function() { return /* binding */ EMPTY_FAVORITE_BASE64; },
/* harmony export */   "EMPTY_PIXEL": function() { return /* binding */ EMPTY_PIXEL; },
/* harmony export */   "EXCEPTIONAL_SITENAME": function() { return /* binding */ EXCEPTIONAL_SITENAME; },
/* harmony export */   "EXCLUDE_PAGES": function() { return /* binding */ EXCLUDE_PAGES; },
/* harmony export */   "FAQ_PAGE_DATA_URL": function() { return /* binding */ FAQ_PAGE_DATA_URL; },
/* harmony export */   "FAVORITES_LIST_END_POINT": function() { return /* binding */ FAVORITES_LIST_END_POINT; },
/* harmony export */   "FAVORITES_LIST_LIMIT": function() { return /* binding */ FAVORITES_LIST_LIMIT; },
/* harmony export */   "FEATURE_FLAGS_CHECKOUT_PAYLOAD": function() { return /* binding */ FEATURE_FLAGS_CHECKOUT_PAYLOAD; },
/* harmony export */   "FETCH_PRODUCT_REG_ENDPOINT": function() { return /* binding */ FETCH_PRODUCT_REG_ENDPOINT; },
/* harmony export */   "FINDLOCATIONKEYCODE": function() { return /* binding */ FINDLOCATIONKEYCODE; },
/* harmony export */   "FIND_A_PRO_HASH": function() { return /* binding */ FIND_A_PRO_HASH; },
/* harmony export */   "FIND_A_PRO_PATH": function() { return /* binding */ FIND_A_PRO_PATH; },
/* harmony export */   "FIND_A_STORE": function() { return /* binding */ FIND_A_STORE; },
/* harmony export */   "FIND_MY_ORDERS_ENDPOINT": function() { return /* binding */ FIND_MY_ORDERS_ENDPOINT; },
/* harmony export */   "FIND_MY_ORDERS_V1_ENDPOINT": function() { return /* binding */ FIND_MY_ORDERS_V1_ENDPOINT; },
/* harmony export */   "FIND_STORE_URL": function() { return /* binding */ FIND_STORE_URL; },
/* harmony export */   "FRAGMENT_TYPES": function() { return /* binding */ FRAGMENT_TYPES; },
/* harmony export */   "FRAUD_CHLLENGE_STATUS": function() { return /* binding */ FRAUD_CHLLENGE_STATUS; },
/* harmony export */   "FREIGHT_SHIPPING_TYPES": function() { return /* binding */ FREIGHT_SHIPPING_TYPES; },
/* harmony export */   "FRIENDS_AND_FAMILY_API_URL_ENDPOINT": function() { return /* binding */ FRIENDS_AND_FAMILY_API_URL_ENDPOINT; },
/* harmony export */   "FRIENDS_AND_FAMILY_PROGRAM": function() { return /* binding */ FRIENDS_AND_FAMILY_PROGRAM; },
/* harmony export */   "FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL": function() { return /* binding */ FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL; },
/* harmony export */   "FULL_FAVORITE_BASE64": function() { return /* binding */ FULL_FAVORITE_BASE64; },
/* harmony export */   "GATED_HASHES": function() { return /* binding */ GATED_HASHES; },
/* harmony export */   "GENERIC_ERROR_MESSAGE": function() { return /* binding */ GENERIC_ERROR_MESSAGE; },
/* harmony export */   "GET_CITY_AND_STATE_BY_ZIPCODE": function() { return /* binding */ GET_CITY_AND_STATE_BY_ZIPCODE; },
/* harmony export */   "GET_GUEST_TOKEN_ENDPOINT": function() { return /* binding */ GET_GUEST_TOKEN_ENDPOINT; },
/* harmony export */   "GET_ORDER_DETAILS_ENDPOINT": function() { return /* binding */ GET_ORDER_DETAILS_ENDPOINT; },
/* harmony export */   "GET_PROFILE_ENDPOINT": function() { return /* binding */ GET_PROFILE_ENDPOINT; },
/* harmony export */   "GIFT_DESIGN": function() { return /* binding */ GIFT_DESIGN; },
/* harmony export */   "GLOBAL_CONFIGURATION_ENDPOINT": function() { return /* binding */ GLOBAL_CONFIGURATION_ENDPOINT; },
/* harmony export */   "GLOBAL_CONFIGURATION_PATH": function() { return /* binding */ GLOBAL_CONFIGURATION_PATH; },
/* harmony export */   "GRADIENT_DICTIONARY": function() { return /* binding */ GRADIENT_DICTIONARY; },
/* harmony export */   "HEADER_NAV_TABS_WRAPPER_ID": function() { return /* binding */ HEADER_NAV_TABS_WRAPPER_ID; },
/* harmony export */   "HELP_AND_FAQ": function() { return /* binding */ HELP_AND_FAQ; },
/* harmony export */   "HELP_AND_FAQ_SUPPORT": function() { return /* binding */ HELP_AND_FAQ_SUPPORT; },
/* harmony export */   "HELP_AND_SUPPORT": function() { return /* binding */ HELP_AND_SUPPORT; },
/* harmony export */   "HELP_FAQ_END_POINT": function() { return /* binding */ HELP_FAQ_END_POINT; },
/* harmony export */   "HELP_SUPPORT": function() { return /* binding */ HELP_SUPPORT; },
/* harmony export */   "HERO_BANNER": function() { return /* binding */ HERO_BANNER; },
/* harmony export */   "HOW_TO_BECOME_A_KPN": function() { return /* binding */ HOW_TO_BECOME_A_KPN; },
/* harmony export */   "IMG_ITEM_ISO": function() { return /* binding */ IMG_ITEM_ISO; },
/* harmony export */   "INDEXEDDB_NOT_SUPPORTED_ERROR": function() { return /* binding */ INDEXEDDB_NOT_SUPPORTED_ERROR; },
/* harmony export */   "INITIAL_SEARCH_TABS_COUNT": function() { return /* binding */ INITIAL_SEARCH_TABS_COUNT; },
/* harmony export */   "INSPIRATION_PAGE_NAME": function() { return /* binding */ INSPIRATION_PAGE_NAME; },
/* harmony export */   "INSTALLATION_SERVICES_ASPATH": function() { return /* binding */ INSTALLATION_SERVICES_ASPATH; },
/* harmony export */   "INSTALLATION_SERVICES_HASH": function() { return /* binding */ INSTALLATION_SERVICES_HASH; },
/* harmony export */   "INSTALLATION_SERVICES_PATH": function() { return /* binding */ INSTALLATION_SERVICES_PATH; },
/* harmony export */   "INSTALL_ITEMS": function() { return /* binding */ INSTALL_ITEMS; },
/* harmony export */   "INSTALL_ITEMS_EDIT": function() { return /* binding */ INSTALL_ITEMS_EDIT; },
/* harmony export */   "INTERACTIVE_TAGS": function() { return /* binding */ INTERACTIVE_TAGS; },
/* harmony export */   "INVENTORY_CHANNEL_ID": function() { return /* binding */ INVENTORY_CHANNEL_ID; },
/* harmony export */   "IN_REVIEW_ORDER_STATUS": function() { return /* binding */ IN_REVIEW_ORDER_STATUS; },
/* harmony export */   "IS": function() { return /* binding */ IS; },
/* harmony export */   "JOIN_NOW": function() { return /* binding */ JOIN_NOW; },
/* harmony export */   "KEYCODE": function() { return /* binding */ KEYCODE; },
/* harmony export */   "KEY_SPECIFIER_API_URL_ENDPOINT": function() { return /* binding */ KEY_SPECIFIER_API_URL_ENDPOINT; },
/* harmony export */   "KEY_SPECIFIER_QUERRY_SELECTOR_URL": function() { return /* binding */ KEY_SPECIFIER_QUERRY_SELECTOR_URL; },
/* harmony export */   "KOHLER_BATHROOM_DESIGN": function() { return /* binding */ KOHLER_BATHROOM_DESIGN; },
/* harmony export */   "KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP": function() { return /* binding */ KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP; },
/* harmony export */   "LITERATURE": function() { return /* binding */ LITERATURE; },
/* harmony export */   "LITERATURE_DATA_URL": function() { return /* binding */ LITERATURE_DATA_URL; },
/* harmony export */   "LOCALE_CANADA_FR": function() { return /* binding */ LOCALE_CANADA_FR; },
/* harmony export */   "LOCALE_ENGLISH": function() { return /* binding */ LOCALE_ENGLISH; },
/* harmony export */   "LOCATIONSCONST": function() { return /* binding */ LOCATIONSCONST; },
/* harmony export */   "LOCATIONS_ASPATH": function() { return /* binding */ LOCATIONS_ASPATH; },
/* harmony export */   "LOCATIONS_PATH": function() { return /* binding */ LOCATIONS_PATH; },
/* harmony export */   "LOCATION_API_TRIGGER_INTERVAL": function() { return /* binding */ LOCATION_API_TRIGGER_INTERVAL; },
/* harmony export */   "LW_APP_NAME": function() { return /* binding */ LW_APP_NAME; },
/* harmony export */   "MATTERPORT_ARIA_LABEL": function() { return /* binding */ MATTERPORT_ARIA_LABEL; },
/* harmony export */   "MAX_MID_WIDTH": function() { return /* binding */ MAX_MID_WIDTH; },
/* harmony export */   "MAX_WIDTH_MOBILE": function() { return /* binding */ MAX_WIDTH_MOBILE; },
/* harmony export */   "MEMBERSHIP_API_URL_ENDPOINT": function() { return /* binding */ MEMBERSHIP_API_URL_ENDPOINT; },
/* harmony export */   "MEMBERSHIP_QUERRY_SELECTOR_URL": function() { return /* binding */ MEMBERSHIP_QUERRY_SELECTOR_URL; },
/* harmony export */   "METRIC_THRESHOLDS": function() { return /* binding */ METRIC_THRESHOLDS; },
/* harmony export */   "MILLISECONDSADAY": function() { return /* binding */ MILLISECONDSADAY; },
/* harmony export */   "MINUTE_MILLISECONDS": function() { return /* binding */ MINUTE_MILLISECONDS; },
/* harmony export */   "MIN_DELAY": function() { return /* binding */ MIN_DELAY; },
/* harmony export */   "MIN_VIDEO_DURATION": function() { return /* binding */ MIN_VIDEO_DURATION; },
/* harmony export */   "MIN_WIDTH_CLOSEICON": function() { return /* binding */ MIN_WIDTH_CLOSEICON; },
/* harmony export */   "ML_API_MODEL_1": function() { return /* binding */ ML_API_MODEL_1; },
/* harmony export */   "ML_API_MODEL_2": function() { return /* binding */ ML_API_MODEL_2; },
/* harmony export */   "MODEL_JSON_EXTENSION": function() { return /* binding */ MODEL_JSON_EXTENSION; },
/* harmony export */   "MONTH_NAMES_EN": function() { return /* binding */ MONTH_NAMES_EN; },
/* harmony export */   "MONTH_NAMES_FR": function() { return /* binding */ MONTH_NAMES_FR; },
/* harmony export */   "MORE_OPTIONS": function() { return /* binding */ MORE_OPTIONS; },
/* harmony export */   "MY_ACCOUNT_MODAL": function() { return /* binding */ MY_ACCOUNT_MODAL; },
/* harmony export */   "MY_ACCOUNT_PATH": function() { return /* binding */ MY_ACCOUNT_PATH; },
/* harmony export */   "MY_FAVORITES_ENDPOINT": function() { return /* binding */ MY_FAVORITES_ENDPOINT; },
/* harmony export */   "MY_LISTS_PATH": function() { return /* binding */ MY_LISTS_PATH; },
/* harmony export */   "MY_LISTS_PATH_FR": function() { return /* binding */ MY_LISTS_PATH_FR; },
/* harmony export */   "MY_PRODUCTS_ENDPOINT": function() { return /* binding */ MY_PRODUCTS_ENDPOINT; },
/* harmony export */   "MY_PRODUCT_PRODUCT_REGISTRATION": function() { return /* binding */ MY_PRODUCT_PRODUCT_REGISTRATION; },
/* harmony export */   "MY_PRODUCT_SEARCH_CATALOG": function() { return /* binding */ MY_PRODUCT_SEARCH_CATALOG; },
/* harmony export */   "MY_SERVICES_ENDPOINT": function() { return /* binding */ MY_SERVICES_ENDPOINT; },
/* harmony export */   "MyFavoritesPageDataUrl": function() { return /* binding */ MyFavoritesPageDataUrl; },
/* harmony export */   "MyListsPageDataUrl": function() { return /* binding */ MyListsPageDataUrl; },
/* harmony export */   "MyProductsPageDataUrl": function() { return /* binding */ MyProductsPageDataUrl; },
/* harmony export */   "MyServicePageDataUrl": function() { return /* binding */ MyServicePageDataUrl; },
/* harmony export */   "NAVIGATION_TYPE": function() { return /* binding */ NAVIGATION_TYPE; },
/* harmony export */   "NODE_NAMES": function() { return /* binding */ NODE_NAMES; },
/* harmony export */   "NOTIFY": function() { return /* binding */ NOTIFY; },
/* harmony export */   "NO_ACTIVE_CART_EXISTS": function() { return /* binding */ NO_ACTIVE_CART_EXISTS; },
/* harmony export */   "NS": function() { return /* binding */ NS; },
/* harmony export */   "NUMERIC_REGX": function() { return /* binding */ NUMERIC_REGX; },
/* harmony export */   "ONETRUST_IDENTIFIER": function() { return /* binding */ ONETRUST_IDENTIFIER; },
/* harmony export */   "ORDER_CONFIRMATION": function() { return /* binding */ ORDER_CONFIRMATION; },
/* harmony export */   "ORDER_IN_RECEIVED_STATUS": function() { return /* binding */ ORDER_IN_RECEIVED_STATUS; },
/* harmony export */   "ORDER_STATUS_PAGE": function() { return /* binding */ ORDER_STATUS_PAGE; },
/* harmony export */   "ORDER_THANKYOU": function() { return /* binding */ ORDER_THANKYOU; },
/* harmony export */   "PAGE_TYPES": function() { return /* binding */ PAGE_TYPES; },
/* harmony export */   "PARTS": function() { return /* binding */ PARTS; },
/* harmony export */   "PAYPAL_TYPES": function() { return /* binding */ PAYPAL_TYPES; },
/* harmony export */   "PCIPAL_TYPES": function() { return /* binding */ PCIPAL_TYPES; },
/* harmony export */   "PDP_DEFAULT_IMAGE": function() { return /* binding */ PDP_DEFAULT_IMAGE; },
/* harmony export */   "PDP_DETAILS": function() { return /* binding */ PDP_DETAILS; },
/* harmony export */   "PDP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ PDP_END_POINT_SUBSCRIPTION_KEY; },
/* harmony export */   "PDP_FAVORITE": function() { return /* binding */ PDP_FAVORITE; },
/* harmony export */   "PDP_FEEDBACK": function() { return /* binding */ PDP_FEEDBACK; },
/* harmony export */   "PDP_FIND_ON_DISPLAY": function() { return /* binding */ PDP_FIND_ON_DISPLAY; },
/* harmony export */   "PDP_GUEST_FAVORITE": function() { return /* binding */ PDP_GUEST_FAVORITE; },
/* harmony export */   "PDP_SLIDER_SIZES": function() { return /* binding */ PDP_SLIDER_SIZES; },
/* harmony export */   "PDP_TEASER_DETAILS": function() { return /* binding */ PDP_TEASER_DETAILS; },
/* harmony export */   "PDP_TYPE": function() { return /* binding */ PDP_TYPE; },
/* harmony export */   "PDP_TYPES": function() { return /* binding */ PDP_TYPES; },
/* harmony export */   "PERCENT_OFF": function() { return /* binding */ PERCENT_OFF; },
/* harmony export */   "PLP_END_POINT": function() { return /* binding */ PLP_END_POINT; },
/* harmony export */   "PLP_END_POINT_CLIENT": function() { return /* binding */ PLP_END_POINT_CLIENT; },
/* harmony export */   "PLP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ PLP_END_POINT_SUBSCRIPTION_KEY; },
/* harmony export */   "PLUMBING_SERVICE_PARTS": function() { return /* binding */ PLUMBING_SERVICE_PARTS; },
/* harmony export */   "PRESS_KIT_PAGE_TYPE": function() { return /* binding */ PRESS_KIT_PAGE_TYPE; },
/* harmony export */   "PRESS_LANDING_URL": function() { return /* binding */ PRESS_LANDING_URL; },
/* harmony export */   "PRESS_ROOM_PATH": function() { return /* binding */ PRESS_ROOM_PATH; },
/* harmony export */   "PRICE_RANGE": function() { return /* binding */ PRICE_RANGE; },
/* harmony export */   "PRICE_RANGE_FRENCH_LOCALE": function() { return /* binding */ PRICE_RANGE_FRENCH_LOCALE; },
/* harmony export */   "PRIVACY_ASPATH": function() { return /* binding */ PRIVACY_ASPATH; },
/* harmony export */   "PRIVACY_COOKIE_CLICKED": function() { return /* binding */ PRIVACY_COOKIE_CLICKED; },
/* harmony export */   "PRODUCT": function() { return /* binding */ PRODUCT; },
/* harmony export */   "PRODUCTS_PER_PAGE": function() { return /* binding */ PRODUCTS_PER_PAGE; },
/* harmony export */   "PRODUCT_DATA_URL": function() { return /* binding */ PRODUCT_DATA_URL; },
/* harmony export */   "PRODUCT_EXCLUDE_FROM_PAID_ADVERTISING": function() { return /* binding */ PRODUCT_EXCLUDE_FROM_PAID_ADVERTISING; },
/* harmony export */   "PRODUCT_GLOBALCONFIG_DATA_URL": function() { return /* binding */ PRODUCT_GLOBALCONFIG_DATA_URL; },
/* harmony export */   "PROFILE_END_POINT_CLIENT": function() { return /* binding */ PROFILE_END_POINT_CLIENT; },
/* harmony export */   "PROMO_COLUMNS": function() { return /* binding */ PROMO_COLUMNS; },
/* harmony export */   "PROMO_TILES": function() { return /* binding */ PROMO_TILES; },
/* harmony export */   "PriceRangeFrench": function() { return /* binding */ PriceRangeFrench; },
/* harmony export */   "QUICK_VIEW": function() { return /* binding */ QUICK_VIEW; },
/* harmony export */   "QUICK_VIEW_MODAL": function() { return /* binding */ QUICK_VIEW_MODAL; },
/* harmony export */   "READ_ONLY": function() { return /* binding */ READ_ONLY; },
/* harmony export */   "READ_WRITE": function() { return /* binding */ READ_WRITE; },
/* harmony export */   "REGISTER_OFFLINE_PRODUCTS_DATA_URL": function() { return /* binding */ REGISTER_OFFLINE_PRODUCTS_DATA_URL; },
/* harmony export */   "REGISTER_ONLINE_PRODUCTS_DATA_URL": function() { return /* binding */ REGISTER_ONLINE_PRODUCTS_DATA_URL; },
/* harmony export */   "REGULAR_PRICE": function() { return /* binding */ REGULAR_PRICE; },
/* harmony export */   "REMEDY_MODEL_JSON": function() { return /* binding */ REMEDY_MODEL_JSON; },
/* harmony export */   "RETURN_SLIPS_API_ENDPOINT": function() { return /* binding */ RETURN_SLIPS_API_ENDPOINT; },
/* harmony export */   "RETURN_SLIPS_PAGE_URL": function() { return /* binding */ RETURN_SLIPS_PAGE_URL; },
/* harmony export */   "ROW_COLUMN_MIN_WIDTH": function() { return /* binding */ ROW_COLUMN_MIN_WIDTH; },
/* harmony export */   "ROW_COLUMN_WIDTH": function() { return /* binding */ ROW_COLUMN_WIDTH; },
/* harmony export */   "SEARCH_INTERNAL_TYPE": function() { return /* binding */ SEARCH_INTERNAL_TYPE; },
/* harmony export */   "SEARCH_PDP_FL": function() { return /* binding */ SEARCH_PDP_FL; },
/* harmony export */   "SEARCH_PLP_ENDPOINT": function() { return /* binding */ SEARCH_PLP_ENDPOINT; },
/* harmony export */   "SEARCH_TABS": function() { return /* binding */ SEARCH_TABS; },
/* harmony export */   "SEAT_TYPES": function() { return /* binding */ SEAT_TYPES; },
/* harmony export */   "SERVICES": function() { return /* binding */ SERVICES; },
/* harmony export */   "SHARE_LIST_PATH": function() { return /* binding */ SHARE_LIST_PATH; },
/* harmony export */   "SHARE_LIST_PATH_FR": function() { return /* binding */ SHARE_LIST_PATH_FR; },
/* harmony export */   "SHOP_THE_LOOK": function() { return /* binding */ SHOP_THE_LOOK; },
/* harmony export */   "SHOP_THE_ROOM": function() { return /* binding */ SHOP_THE_ROOM; },
/* harmony export */   "SHOP_THE_ROOM_CLASSES": function() { return /* binding */ SHOP_THE_ROOM_CLASSES; },
/* harmony export */   "SHOP_TOILET_SEATS": function() { return /* binding */ SHOP_TOILET_SEATS; },
/* harmony export */   "SIGNUP_HASH": function() { return /* binding */ SIGNUP_HASH; },
/* harmony export */   "SMART_TOILETS_MODEL_JSON": function() { return /* binding */ SMART_TOILETS_MODEL_JSON; },
/* harmony export */   "SOURCE_ORIGIN": function() { return /* binding */ SOURCE_ORIGIN; },
/* harmony export */   "SPACER_ALIAS": function() { return /* binding */ SPACER_ALIAS; },
/* harmony export */   "SPLIT_ORDER": function() { return /* binding */ SPLIT_ORDER; },
/* harmony export */   "SSR_PLP_FL": function() { return /* binding */ SSR_PLP_FL; },
/* harmony export */   "STERLING_LINK": function() { return /* binding */ STERLING_LINK; },
/* harmony export */   "STOCKS": function() { return /* binding */ STOCKS; },
/* harmony export */   "STORE_APPOINTMENT_ANCHOR_VALUE": function() { return /* binding */ STORE_APPOINTMENT_ANCHOR_VALUE; },
/* harmony export */   "STORE_APP_LD_JSON": function() { return /* binding */ STORE_APP_LD_JSON; },
/* harmony export */   "STORE_DETAILS_API_ENDPOINT": function() { return /* binding */ STORE_DETAILS_API_ENDPOINT; },
/* harmony export */   "STORE_MAX_DISTANCE": function() { return /* binding */ STORE_MAX_DISTANCE; },
/* harmony export */   "STORE_MIN_DISTANCE": function() { return /* binding */ STORE_MIN_DISTANCE; },
/* harmony export */   "STORE_NAME": function() { return /* binding */ STORE_NAME; },
/* harmony export */   "SUCCESS": function() { return /* binding */ SUCCESS; },
/* harmony export */   "SUPPORT_CENTER_PATH": function() { return /* binding */ SUPPORT_CENTER_PATH; },
/* harmony export */   "SWATCH_NA": function() { return /* binding */ SWATCH_NA; },
/* harmony export */   "TABS_NOT_REQUIRED_GRIDICON": function() { return /* binding */ TABS_NOT_REQUIRED_GRIDICON; },
/* harmony export */   "TAB_WIDTH": function() { return /* binding */ TAB_WIDTH; },
/* harmony export */   "TARGETED_DOMAIN_TO_MONITOR": function() { return /* binding */ TARGETED_DOMAIN_TO_MONITOR; },
/* harmony export */   "TEASER_CAPTION_CLASSES": function() { return /* binding */ TEASER_CAPTION_CLASSES; },
/* harmony export */   "TEASER_CAPTION_CLASSES_LIST": function() { return /* binding */ TEASER_CAPTION_CLASSES_LIST; },
/* harmony export */   "TEASER_CLASSES": function() { return /* binding */ TEASER_CLASSES; },
/* harmony export */   "TECHNICAL_SPECIFICATIONS": function() { return /* binding */ TECHNICAL_SPECIFICATIONS; },
/* harmony export */   "TECHNICAL_SPECIFICATION_DATA_URL": function() { return /* binding */ TECHNICAL_SPECIFICATION_DATA_URL; },
/* harmony export */   "TECHNICAL_SPECIFICATION_PATH": function() { return /* binding */ TECHNICAL_SPECIFICATION_PATH; },
/* harmony export */   "TECHNICAL_SPECT_SEARCH_COUNT": function() { return /* binding */ TECHNICAL_SPECT_SEARCH_COUNT; },
/* harmony export */   "TIMEOUT_1500": function() { return /* binding */ TIMEOUT_1500; },
/* harmony export */   "TOAST_MESSAGE_DEFAULT_DURATION": function() { return /* binding */ TOAST_MESSAGE_DEFAULT_DURATION; },
/* harmony export */   "TWO_WAYS_TO_BE_A_KPN": function() { return /* binding */ TWO_WAYS_TO_BE_A_KPN; },
/* harmony export */   "TotalSecsForaDay": function() { return /* binding */ TotalSecsForaDay; },
/* harmony export */   "USER_LIST_DELETE_END_POINT": function() { return /* binding */ USER_LIST_DELETE_END_POINT; },
/* harmony export */   "USER_LIST_PRODUCT_DELETE_POINT": function() { return /* binding */ USER_LIST_PRODUCT_DELETE_POINT; },
/* harmony export */   "UTILITY_CONSTANTS": function() { return /* binding */ UTILITY_CONSTANTS; },
/* harmony export */   "VALID_GLOBA_CONFIG_PATHS": function() { return /* binding */ VALID_GLOBA_CONFIG_PATHS; },
/* harmony export */   "VALID_SPACER_SIZES": function() { return /* binding */ VALID_SPACER_SIZES; },
/* harmony export */   "VANITY_REDIRECT_TYPE": function() { return /* binding */ VANITY_REDIRECT_TYPE; },
/* harmony export */   "VIDEO_EVENTS": function() { return /* binding */ VIDEO_EVENTS; },
/* harmony export */   "VIEW_FULL_DETAILS": function() { return /* binding */ VIEW_FULL_DETAILS; },
/* harmony export */   "VISUALICON_ARIA_LABEL": function() { return /* binding */ VISUALICON_ARIA_LABEL; },
/* harmony export */   "VISUAL_SEARCH_ALLOWED_URLS": function() { return /* binding */ VISUAL_SEARCH_ALLOWED_URLS; },
/* harmony export */   "ZIP_FILE_DOWNLOAD_ENDPOINT": function() { return /* binding */ ZIP_FILE_DOWNLOAD_ENDPOINT; },
/* harmony export */   "accountSettingsPageDataUrl": function() { return /* binding */ accountSettingsPageDataUrl; },
/* harmony export */   "addAddressEndPoint": function() { return /* binding */ addAddressEndPoint; },
/* harmony export */   "addFavoritesEndPoint": function() { return /* binding */ addFavoritesEndPoint; },
/* harmony export */   "addressSuggestionEndPoint": function() { return /* binding */ addressSuggestionEndPoint; },
/* harmony export */   "annSacksConstants": function() { return /* binding */ annSacksConstants; },
/* harmony export */   "apiBVApiKey": function() { return /* binding */ apiBVApiKey; },
/* harmony export */   "apiBVBaseUrl": function() { return /* binding */ apiBVBaseUrl; },
/* harmony export */   "apiBaseUrl": function() { return /* binding */ apiBaseUrl; },
/* harmony export */   "apiVersionBV": function() { return /* binding */ apiVersionBV; },
/* harmony export */   "apimSubscriptionKey": function() { return /* binding */ apimSubscriptionKey; },
/* harmony export */   "authorBaseUrl": function() { return /* binding */ authorBaseUrl; },
/* harmony export */   "baseUrl": function() { return /* binding */ baseUrl; },
/* harmony export */   "browseAllStoresURL": function() { return /* binding */ browseAllStoresURL; },
/* harmony export */   "cartDataUrl": function() { return /* binding */ cartDataUrl; },
/* harmony export */   "cartItemsEndPoint": function() { return /* binding */ cartItemsEndPoint; },
/* harmony export */   "cartPage": function() { return /* binding */ cartPage; },
/* harmony export */   "checkoutDataUrl": function() { return /* binding */ checkoutDataUrl; },
/* harmony export */   "createCartEndPoint": function() { return /* binding */ createCartEndPoint; },
/* harmony export */   "createFavoritesEndPoint": function() { return /* binding */ createFavoritesEndPoint; },
/* harmony export */   "customActivityEvents": function() { return /* binding */ customActivityEvents; },
/* harmony export */   "dataUrl": function() { return /* binding */ dataUrl; },
/* harmony export */   "debounceThresholdCheckUserExists": function() { return /* binding */ debounceThresholdCheckUserExists; },
/* harmony export */   "deleteCartEndPoint": function() { return /* binding */ deleteCartEndPoint; },
/* harmony export */   "dimensionsDataEndPoint": function() { return /* binding */ dimensionsDataEndPoint; },
/* harmony export */   "discountEndPoint": function() { return /* binding */ discountEndPoint; },
/* harmony export */   "discountMatchesCart": function() { return /* binding */ discountMatchesCart; },
/* harmony export */   "dynamicSearch": function() { return /* binding */ dynamicSearch; },
/* harmony export */   "editAddressEndPoint": function() { return /* binding */ editAddressEndPoint; },
/* harmony export */   "emailSubscribeEndPoint": function() { return /* binding */ emailSubscribeEndPoint; },
/* harmony export */   "favoritesEndPoint": function() { return /* binding */ favoritesEndPoint; },
/* harmony export */   "findAllStores": function() { return /* binding */ findAllStores; },
/* harmony export */   "footerUrl": function() { return /* binding */ footerUrl; },
/* harmony export */   "getCartEndPoint": function() { return /* binding */ getCartEndPoint; },
/* harmony export */   "getPdpTooltipEndPoint": function() { return /* binding */ getPdpTooltipEndPoint; },
/* harmony export */   "getStockEndPoint": function() { return /* binding */ getStockEndPoint; },
/* harmony export */   "groupedComponents": function() { return /* binding */ groupedComponents; },
/* harmony export */   "headerUrl": function() { return /* binding */ headerUrl; },
/* harmony export */   "imgPlaceholderData": function() { return /* binding */ imgPlaceholderData; },
/* harmony export */   "inPageSearchEndPoint": function() { return /* binding */ inPageSearchEndPoint; },
/* harmony export */   "internalLinkPath": function() { return /* binding */ internalLinkPath; },
/* harmony export */   "isANYPersona": function() { return /* binding */ isANYPersona; },
/* harmony export */   "keyCodes": function() { return /* binding */ keyCodes; },
/* harmony export */   "locationIpEndPoint": function() { return /* binding */ locationIpEndPoint; },
/* harmony export */   "locationZipEndPoint": function() { return /* binding */ locationZipEndPoint; },
/* harmony export */   "loveYourLookDataUrl": function() { return /* binding */ loveYourLookDataUrl; },
/* harmony export */   "maxAppReached": function() { return /* binding */ maxAppReached; },
/* harmony export */   "mergeCartEndPoint": function() { return /* binding */ mergeCartEndPoint; },
/* harmony export */   "missingImage": function() { return /* binding */ missingImage; },
/* harmony export */   "myListContainerBreakPoints": function() { return /* binding */ myListContainerBreakPoints; },
/* harmony export */   "oktaTokenEndpoint": function() { return /* binding */ oktaTokenEndpoint; },
/* harmony export */   "orderConfirmationDataUrl": function() { return /* binding */ orderConfirmationDataUrl; },
/* harmony export */   "orderConstants": function() { return /* binding */ orderConstants; },
/* harmony export */   "orderDetailsPageDataUrl": function() { return /* binding */ orderDetailsPageDataUrl; },
/* harmony export */   "orderHistoryPageDataUrl": function() { return /* binding */ orderHistoryPageDataUrl; },
/* harmony export */   "orderStatusPageDataUrl": function() { return /* binding */ orderStatusPageDataUrl; },
/* harmony export */   "orderSubmitEndPoint": function() { return /* binding */ orderSubmitEndPoint; },
/* harmony export */   "pageNotFoundDataUrl": function() { return /* binding */ pageNotFoundDataUrl; },
/* harmony export */   "pageUrl": function() { return /* binding */ pageUrl; },
/* harmony export */   "payPalPaymentEndPoint": function() { return /* binding */ payPalPaymentEndPoint; },
/* harmony export */   "paymentEndPoint": function() { return /* binding */ paymentEndPoint; },
/* harmony export */   "postOrderNoOfDays": function() { return /* binding */ postOrderNoOfDays; },
/* harmony export */   "publicApiBaseUrl": function() { return /* binding */ publicApiBaseUrl; },
/* harmony export */   "publicWebsiteUrl": function() { return /* binding */ publicWebsiteUrl; },
/* harmony export */   "publisherBaseUrl": function() { return /* binding */ publisherBaseUrl; },
/* harmony export */   "queryParamsToPersist": function() { return /* binding */ queryParamsToPersist; },
/* harmony export */   "removeFavoritesEndPoint": function() { return /* binding */ removeFavoritesEndPoint; },
/* harmony export */   "resourceFacetLabels": function() { return /* binding */ resourceFacetLabels; },
/* harmony export */   "returnSlipPageDataUrl": function() { return /* binding */ returnSlipPageDataUrl; },
/* harmony export */   "reviewDataEndPoint": function() { return /* binding */ reviewDataEndPoint; },
/* harmony export */   "reviewStatsEndPoint": function() { return /* binding */ reviewStatsEndPoint; },
/* harmony export */   "reviews": function() { return /* binding */ reviews; },
/* harmony export */   "searchDataUrl": function() { return /* binding */ searchDataUrl; },
/* harmony export */   "searchFeatureResults": function() { return /* binding */ searchFeatureResults; },
/* harmony export */   "searchPdpEndPoint": function() { return /* binding */ searchPdpEndPoint; },
/* harmony export */   "searchPlpEndPoint": function() { return /* binding */ searchPlpEndPoint; },
/* harmony export */   "searchProfilePlpEndPoint": function() { return /* binding */ searchProfilePlpEndPoint; },
/* harmony export */   "searchUrl": function() { return /* binding */ searchUrl; },
/* harmony export */   "selectors": function() { return /* binding */ selectors; },
/* harmony export */   "shareCartEndPoint": function() { return /* binding */ shareCartEndPoint; },
/* harmony export */   "sharedCartItemsEndPoint": function() { return /* binding */ sharedCartItemsEndPoint; },
/* harmony export */   "sharedCartUrl": function() { return /* binding */ sharedCartUrl; },
/* harmony export */   "shipmentFromCartEndPoint": function() { return /* binding */ shipmentFromCartEndPoint; },
/* harmony export */   "shippingCostEndPoint": function() { return /* binding */ shippingCostEndPoint; },
/* harmony export */   "signupEndPoint": function() { return /* binding */ signupEndPoint; },
/* harmony export */   "skuBypimLookup": function() { return /* binding */ skuBypimLookup; },
/* harmony export */   "staticClasses": function() { return /* binding */ staticClasses; },
/* harmony export */   "stopedByPreviousDiscount": function() { return /* binding */ stopedByPreviousDiscount; },
/* harmony export */   "taxEndPoint": function() { return /* binding */ taxEndPoint; },
/* harmony export */   "tooltip": function() { return /* binding */ tooltip; },
/* harmony export */   "validateTokenEndPoint": function() { return /* binding */ validateTokenEndPoint; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(34155);
const authorBaseUrl = "https://web-api.kohler.com/aem/resource?subscription-key=3da4541f545f4dc7841b6ba0606f96fc&resourcepath=";
const internalLinkPath = "/content/kohler/us";
const publisherBaseUrl = "http://localhost:4503";
const baseUrl = "/en";
const publicWebsiteUrl = "https://www.kohler.com/en";
const publicApiBaseUrl = "https://www.kohler.com/apirequest";
const DOMAIN = "https://www.kohler.com";
const BV_SCRIPT_URL = "https://apps.bazaarvoice.com/deployments/kohler/2021redesign/production/en_US/bv.js";
const LW_APP_NAME = process.env.NEXT_PUBLIC_LW_APP_NAME;
const SOURCE_ORIGIN = "https://www.kohler.com";
const isANYPersona = process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true";
const INVENTORY_CHANNEL_ID = "eb939fc2-53eb-49d4-ac24-ba60d0345a93";
// server side variable
const apiBVBaseUrl = process.env.BAZAARVOICE_APIURL;
const apiBVApiKey = process.env.BAZAARVOICE_APIKEY;
const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY;
const PDP_DEFAULT_IMAGE = process.env.PDP_DEFAULT_IMAGE;
const apiBaseUrl = process.env.SERVER_APIBASEURL;
const dataUrl = "/en.model.json";
const searchDataUrl = "/search.model.json";
const cartDataUrl = "/en/cart.model.json";
const headerUrl = "/content/experience-fragments/kohler/us/en/navigation/header/global-header-experience-fragment/master";
const footerUrl = "/content/experience-fragments/kohler/us/en/navigation/footer/Global-footer-experience-fragment/master";
const pageUrl = "/en/";
const cartPage = pageUrl + "cart";
const checkoutDataUrl = "/en/checkout.model.json";
const sharedCartUrl = "/en/cart/shared-cart.model.json";
const orderConfirmationDataUrl = "/en/orders/order-confirmation.model.json";
const orderDetailsPageDataUrl = "/en/orders/order-details.model.json";
const orderHistoryPageDataUrl = "/en/orders/order-history.model.json";
const orderStatusPageDataUrl = "/en/orders/order-status.model.json";
const returnSlipPageDataUrl = "/en/returns/return-slips.model.json";
const PRODUCT_DATA_URL = "/products/product-details.model.json";
const PRODUCT_GLOBALCONFIG_DATA_URL = ".globalconfig.json";
const MyProductsPageDataUrl = "/my-account/my-products.model.json";
const loveYourLookDataUrl = "/en/love-your-look.model.json";
const pageNotFoundDataUrl = "/error-handler-pages/404.model.json";
const oktaTokenEndpoint = "/oauth/token";
const getCartEndPoint = "/cart/active?expand=calculation";
const createCartEndPoint = "/cart/create";
const getStockEndPoint = "/catalog/inventory";
const cartItemsEndPoint = "/cart/v2/items";
const sharedCartItemsEndPoint = "/cart/items";
const reviewStatsEndPoint = "/data/statistics.json";
const reviewDataEndPoint = "/data/reviews.json";
const apiVersionBV = "5.4";
const reviews = "Reviews";
const shippingCostEndPoint = "/checkout/shipping-cost";
const discountEndPoint = "cart/v2/discount?expand=calculation";
const taxEndPoint = "/cart/v2/items?expand=calculation";
const shareCartEndPoint = "/cart/sharedcart";
const mergeCartEndPoint = "/cart/merge?expand=calculation";
const signupEndPoint = "/customer/signup";
const deleteCartEndPoint = "/cart/v2/deleteActiveCart";
const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart";
const addAddressEndPoint = "/customer/address";
const addressSuggestionEndPoint = "/maps/address/validate";
const validateTokenEndPoint = "/oauth/token/validate";
const orderSubmitEndPoint = "/checkout/v2/order/submit";
const paymentEndPoint = "/checkout/payment";
const payPalPaymentEndPoint = "/payment/paypal/getToken";
const searchPlpEndPoint = "/search/plp";
const inPageSearchEndPoint = "/search/plp";
const searchProfilePlpEndPoint = "/search/profile";
const searchPdpEndPoint = "/search/pdp";
const getPdpTooltipEndPoint = "/search/tooltip";
const accountSettingsPageDataUrl = "/my-account/account-settings.model.json";
const MY_PRODUCTS_ENDPOINT = "/shopping-list/MyProducts";
const FETCH_PRODUCT_REG_ENDPOINT = "/crm/fetchproductregistration";
const staticClasses = {
    CONTAINER: "container responsivegrid"
};
const MyServicePageDataUrl = "/my-account/my-services.model.json";
const MyFavoritesPageDataUrl = "/my-account/my-favorites.model.json";
const MyListsPageDataUrl = "/my-account/my-lists.model.json";
const REGISTER_OFFLINE_PRODUCTS_DATA_URL = "/my-account/product-registration/register-offline-product.model.json";
const REGISTER_ONLINE_PRODUCTS_DATA_URL = "/en/my-account/product-registration/register-online-product.model.json";
const FAQ_PAGE_DATA_URL = "/support/help-and-faq";
const browseAllStoresURL = "/en/locations/browse-all-stores.model.json";
const LITERATURE_DATA_URL = "/en/for-professionals/literature.model.json";
const TECHNICAL_SPECIFICATION_DATA_URL = "/en/for-professionals/technical-specifications.model.json";
const PRESS_LANDING_URL = "/en/press-room.model.json";
const FIND_STORE_URL = "en/locations.model.json";
const ARTICLE_CONTENT_END_POINT = "/jcr:content.json";
const ARTICLE_IMG_END_POINT = "/jcr:content/image.json";
const FAVORITES_LIST_END_POINT = "/shopping-list/FavoriteLists";
const USER_LIST_DELETE_END_POINT = "/shopping-list";
const USER_LIST_PRODUCT_DELETE_POINT = "/shopping-list/remove/items";
const FAVORITES_LIST_LIMIT = 499;
const MODEL_JSON_EXTENSION = ".model.json";
const dynamicSearch = "dynamic search";
const dimensionsDataEndPoint = "/search/plp";
const findAllStores = "/maps/store";
const HELP_AND_FAQ_SUPPORT = "/en/support/help-and-faq";
const VISUAL_SEARCH_ALLOWED_URLS = [
    "/en/support/find-a-service-part"
];
const missingImage = "MissingImage";
const skuBypimLookup = "/scout/service/api/customer/mavenoid";
const FRIENDS_AND_FAMILY_PROGRAM = "friends and family program";
const KOHLER_FRIENDS_AND_FAMILY_MEMBERSHIP = "kohler friends and family membership";
const CONSTANTS = {
    DEFAULT_IDLE_TIMEOUT: 172800,
    DEFAULT_VERSION: "v1",
    ERROR_CODES: {
        BAD_REQUEST_ERROR: 400,
        INTERNAL_SERVER_ERROR: 500,
        AUTHENTICATION_ERROR: [
            401,
            403
        ]
    },
    USER_STATE: {
        LOGGED_USER: "logged",
        ANONYMOUS_USER: "anonymous"
    },
    PARENT_COMPONENTS_LIST: {
        ORDER_DETAILS: "OrderDetails"
    },
    PAYMENT: {
        SUCCESS_CODE: "870",
        NUM_YEARS: 16
    },
    ORDER_STATUS_SHIPPED: "Shipped",
    DELETE_INACTIVE_MYFOLDER_AFTER: 30,
    ERROR_MESSAGE: {
        GENERAL: "Something went wrong. Please try again...",
        SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
        SESSION_TIMEOUT_SECURE_PAGE_MSG: "Redirecting to Home Page due to inactivity"
    },
    COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/",
    CT_API_URL: "https://api.us-central1.gcp.commercetools.com",
    CT_PROJECT_KEY: "kohler-na-qa-1",
    CT_SALES_CHANNEL: "KOUS",
    REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
    REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
    REGEX_PASSWORD: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"),
    REGEX_EMAIL: /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
    KEYCODE: {
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        UP: 38,
        DOWN: 40,
        TAB: 9
    },
    KEY: {
        ENTER: "Enter",
        ESC: "Escape"
    },
    FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
    KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
    KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
    KF_UPDATE_MEMBERSHIP: "kf-update-membership",
    CREATE_ACCOUNT_TYPE: {
        HOME_OWNER: "homeowner",
        PROFESSIONAL: "professional"
    },
    UNDEFINED: "undefined",
    COMPONENT: {
        PAIRS_WELL_WITH: "pairsWellWith"
    },
    SLICK: {
        DEFAULT_DELAY: 5000,
        COUNT_OFFSET: 20,
        ARROW_OFFSET: 42
    },
    CURRENCY_SIGN: "$",
    STATUS: {
        OK: 200,
        PAGE_NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500
    },
    REGEX_CONTAINS_LETTER: /[a-z]/i,
    BROWSER_NO_AUTOFILL: "no-autofill"
};
const annSacksConstants = {
    asBrandName: "annsacks",
    asBrandNameWithCase: "AnnSacks",
    asSourceChannel: "asus"
};
const favoritesEndPoint = "/shopping-list/Favorites";
const createFavoritesEndPoint = "/shopping-list/create";
const addFavoritesEndPoint = (id, type)=>{
    return "/shopping-list/add/".concat(id, "?type=").concat(type);
};
const removeFavoritesEndPoint = (id)=>{
    return "/shopping-list/remove/items/".concat(id);
};
const SWATCH_NA = "swatch_NA";
const ADD_10_MINUTES = 600000;
const MINUTE_MILLISECONDS = 60000;
const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked";
const GLOBAL_CONFIGURATION_PATH = "/bin/kohler/services/globalconfig.kohler.json";
const GLOBAL_CONFIGURATION_ENDPOINT = DOMAIN + "/api/globalconfig";
const locationIpEndPoint = "/maps/location/ip/";
const locationZipEndPoint = "/maps/location/zipcode/";
const STORE_MIN_DISTANCE = 64;
const STORE_MAX_DISTANCE = 1000;
const TIMEOUT_1500 = 1500;
const LOCATION_API_TRIGGER_INTERVAL = 1800000 // 30mins
;
const STORE_DETAILS_API_ENDPOINT = DOMAIN + "/api/storedetails";
const DEFAULT_STORE_DETAILS_API_PATH = "/bin/kohler/services/storedetails?path=";
const GET_PROFILE_ENDPOINT = "/customer/me";
const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download";
const SEARCH_PLP_ENDPOINT = "search/plp";
const MY_ACCOUNT_PATH = "/my-account";
// cart Dicount
const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount";
const maxAppReached = "MaxApplicationReached";
const discountMatchesCart = "MatchesCart";
const emailSubscribeEndPoint = "/crm/newsletter/subscription";
const TOAST_MESSAGE_DEFAULT_DURATION = 5000 // 5seconds
;
const editAddressEndPoint = "customer/address";
const FIND_MY_ORDERS_V1_ENDPOINT = "/checkout/orders/v1/query";
const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query";
const SPLIT_ORDER = "checkout/ordersplit";
const GET_GUEST_TOKEN_ENDPOINT = DOMAIN + "/api/token";
// Membership
const KEY_SPECIFIER_QUERRY_SELECTOR_URL = 'a[href="#KeySpecifier"]';
const KEY_SPECIFIER_API_URL_ENDPOINT = "/membership/assign/persona";
const MEMBERSHIP_API_URL_ENDPOINT = "/membership/kohler-associate/entry";
const MEMBERSHIP_QUERRY_SELECTOR_URL = 'a[href="#AssociateMembership"]';
const FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL = 'a[href="#FriendsAndFamily"]';
const FRIENDS_AND_FAMILY_API_URL_ENDPOINT = "/membership/assign/persona";
// Store Appointment
const STORE_APPOINTMENT_ANCHOR_VALUE = "#StoreAppointment";
// Return Slips
const RETURN_SLIPS_API_ENDPOINT = "/return/slip";
const RETURN_SLIPS_PAGE_URL = "returns/return-slips";
const DECLINED_PAGE_URL = "/declined";
const MORE_OPTIONS = {
    LEARN_MORE: "Learn More",
    EXPLORE_MORE: "Explore More",
    FREE_QUOTE: "Get a FREE Quote",
    FIND_PRO: "Find a Pro",
    INSTALLATION_SERVICES: "Buy Now",
    WATCH_VIDEO: "Watch Video"
};
const DISABLE_SROLL_PATH = [
    "home-energy/home-generators",
    "buying-guides/bath-tub-buying-guide",
    "services/installation-services"
];
const DEFAULT_SCROLL = {
    scroll: 60,
    backToTop: 20,
    freeQuote: 120,
    findAPro: 120,
    installationServices: 120
};
// order confirmation
const orderConstants = {
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
    CREDIT_CARD: "CREDIT_CARD",
    PAYPAL: "PP",
    ACI_PAYPAL: "Paypal",
    SHIPPED: "Shipped"
};
const PAYPAL_TYPES = [
    "PP",
    "Paypal",
    "PAYPAL",
    "PayPal",
    "paypal"
];
const CARD_TYPES = [
    "CREDIT_CARD",
    "credit_card",
    "CARD",
    "card"
];
const PCIPAL_TYPES = [
    "PCIPAL",
    "PciPal",
    "pcipal",
    "PCIPal",
    "PCI_Pal"
];
const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders";
const DEFAULT_CARD_DETAILS_API_PATH = "/bin/kohler/services/list?path=/content/kohler";
const MY_SERVICES_ENDPOINT = "/shopping-list/MyServices?lang=" + "en-US";
const MY_FAVORITES_ENDPOINT = "/shopping-list/Favorites";
const COMPONENT_TYPES = {
    AEMFORM: "aemform",
    PRODUCTCARD: "productcard",
    ROOT_CONTAINER: "root",
    CONTAINER: "container",
    VIDEO: "video",
    AUTH_MODAL: "authmodal",
    NEWSLETTER: "newsletter",
    TEASER: "teaser",
    CAROUSEL: "carousel",
    SLICK: "carousel-slick",
    SPACER: "spacer",
    TEXT: "text",
    TAB: "tab",
    GLOBAL_TOASTER: "globalToaster",
    BREADCRUMB: "breadcrumb",
    PRODUCTLIST: "productlist",
    SEARCH: "search/v1/search",
    EMBED: "embed",
    BRAND_SWITCHER: "brand-switcher",
    UTILITY_NAV_HEADER: "utilitynavheader",
    UTILITY_WIDGET: "utilitywidget",
    TABS: "tabs",
    IMAGE: "image",
    SITEWIDE_WARNING: "sitewide-warning",
    IMAGEV3: "image/v3/image",
    CAROUSELSLICK: "carousel-slick",
    TOASTER: "toaster/v1/toaster",
    COMPARE_PRODUCTS: "compareproducts",
    MAIN_FOOTER: "mainfooter",
    ADDITIONAL_FOOTER: "additionalfooter",
    NEWSLETTER_SIGNIN: "newslettersignin",
    NEWSLETTER_SIGNUP: "newslettersignup",
    CART_LANDING: "cart-landing",
    CHECKOUT: "checkout",
    ORDER_CONFIRMATION: "orderconfirmation",
    ORDER_STATUS: "orderstatus",
    ORDER_HISTORY: "orderhistory",
    ORDER_DETAILS: "orderdetails",
    SHARED_CART: "sharedcart",
    PAIRS_WELL_WITH: "pairs-well-with",
    HELPSUPPORT: "help-support",
    GLOBAL_NAVIGATION: "globalnavigation",
    PROMOBANNER: "plp-promo-banner",
    ACCOUNT_SETTINGS: "accountsettings",
    MY_SERVICES: "myservices",
    MY_FAVORITES: "myfavorites",
    CHANGE_PASSWORD: "changepassword",
    MY_PRODUCTS: "myproducts",
    PRODUCT_DETAILS: "pdp/v1/pdp",
    PRODUCT_DETAILS_ACCORDION: "accordion",
    PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
    PRODUCT_DETAILS_REVIEW: "components/review",
    REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
    REGISTER_ONLINE_PRODUCTS: "register-online-products",
    KNOWLEDGE_ARTICLE: "knowledge-article/v1/knowledge-article",
    BROWSE_ALL_STORES: "browseallstores",
    STORE_FILTER: "storefilter",
    LITERATURE: "literature",
    CONTACT_US: "contactus",
    FINDING_MODEL_NUMBER: "finding-model-number",
    TECHNICAL_SPECIFICATION: "technicalspecs",
    PRESS_LANDING: "press-release-landing",
    UPSELL_CONTAINER: "container-up-sell",
    FIND_STORE: "findstore",
    INPAGE_SEARCH: "in-page-search",
    TITLE: "title",
    KEY_SPECIFIER: "key-specifier",
    DYNAMIC_SEARCH: "dynamicsearch",
    ASSOCIATE_MEMBERSHIP: "associate-membership",
    INSPIRE_VIDEO: "inspire-video",
    IMAGE_CLUSTER: "imagecluster",
    SHOP_THE_ROOM_CARD: "shoptheroomcard",
    INSTALL_DESIGN_SERVICES: "v1/installdesignservices",
    PROFESSIONAL_DETAILS: "professional-detail",
    FRIENDS_AND_FAMILY: "friends-family",
    FIND_A_PRO_BY_ZIP: "find-pro-by-zip",
    FIND_A_PRO_RESULTS: "find-a-pro-results",
    LIST: "list",
    STORE_APPOINTMENT: "store-appointment",
    PRODUCTCARD_V3: "productcard-v3",
    SHOP_THE_ROOM_DETAIL: "shoptheroomdetail",
    ROOM_DETAIL: "roomdetail",
    GATED_CONTENT: "gated-content-paths",
    PRODUCT_CARD_V4: "productcard-v4",
    PDP_CURATED_PRODUCTS: "pdp-curated-product",
    PDP_CURATED_RECOMMENDATION: "target-recommendations",
    SHOP_THE_ROOM_PAGE: "shoptheroomlist",
    NAVIGATION_V3: "v3/globalnavigation",
    Lead_Generation: "leadgenform",
    VISUAL_NAV_FILTER: "visual_nav_filter",
    VISUAL_NAV_APPLIEDCLASS: "visual-nav",
    PRODUCT_SLIDER: "productslider",
    RETURN_SLIP: "returnslip"
};
const FRAGMENT_TYPES = {
    HEADER: "header",
    MAIN: "main",
    FOOTER: "footer"
};
const VIDEO_EVENTS = {
    PLAY: "play",
    PAUSE: "pause",
    ENDED: "ended",
    VIDEO_PLAY: "video play",
    VIDEO_PAUSE: "video pause",
    VIDEO_VIEWED: "video viewed",
    VIDEO_COMPLETE: "video complete",
    VIDEO_CLICK: "videoClick",
    PLAY_VIDEO: "videoPlay",
    PAUSE_VIDEO: "videoPause",
    CLOSE_VIDEO: "videoClose",
    CLOSE: "close"
};
const HERO_BANNER = "hero banner";
const TAB_WIDTH = 768;
const DESKTOP_WIDTH = 1280;
const ROW_COLUMN_MIN_WIDTH = 1025;
const ROW_COLUMN_WIDTH = 1024;
const MIN_WIDTH_CLOSEICON = 639;
const MAX_WIDTH_MOBILE = 374;
const MAX_MID_WIDTH = 1600;
// PLP
// sort constants
const KEYCODE = {
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    UP: 38,
    DOWN: 40,
    TAB: 9
};
// Find a store
const FINDLOCATIONKEYCODE = {
    LEFTARROW: 37,
    RIGHTARROW: 39
};
const LOCATIONSCONST = {
    LocationType: "KOHLER Store",
    paramSpatialFilter: 161,
    status: 200
};
const MILLISECONDSADAY = 86400000;
// press room
const PRESS_ROOM_PATH = "/en/press-room";
// Filter
const queryParamsToPersist = [
    "sort",
    "keyword",
    "tab"
];
const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME = 9;
const PLP_END_POINT = "/apirequest/search/v1/plp";
const PLP_END_POINT_CLIENT = "/search/v1/plp";
const PLP_END_POINT_SUBSCRIPTION_KEY = "/lw/plp";
const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/v1/pdp/product";
const BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/";
const HELP_FAQ_END_POINT = "/search/plp";
const DEFAULT_PRODUCT_COUNT_PLP = 30;
const DEFAULT_TECHNICAL_SPECT_COUNT = 30;
const TECHNICAL_SPECT_SEARCH_COUNT = 5;
const PROFILE_END_POINT_CLIENT = "/search/v1/profile";
const debounceThresholdCheckUserExists = 500;
const customActivityEvents = [
    "click",
    "keydown"
];
const PAGE_TYPES = {
    CATEGORY_LANDING_PAGE: "category landing page",
    SHARE_CART_LANDING_PAGE: "share cart landing page",
    LOCATION_LANDING_PAGE: "landing:location info"
};
const PRODUCTS_PER_PAGE = [
    30,
    60,
    90
];
const imgPlaceholderData = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
// Account Settings constants
const EDIT_PROFILE_ENDPOINT = "/customer/profile";
const DELETE_ACCOUNT_ENDPOINT = "/customer/account";
const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password";
const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const FULL_FAVORITE_BASE64 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEJsYWNrIGZpbGxlZCBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGYXZvcml0ZXMtQmxhY2stZmlsbGVkLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk5OTcyLCAwLjUwMDAwMCkiIGZpbGw9IiM0OTQ5NDkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjY5NDYxMTg5LDEuNjk1NTU5NDQgQy0wLjUwMTg5NzgzLDMuODk3MDQ5NDMgLTAuNTcwMjc5NjkxLDcuNDU1ODUwMTEgMS41MzEyODgxMyw5LjcwOTk2MzkgTDEuNjg4MjMwMDEsOS44NzMxOTUyIEwxMS4wMDE3MDE4LDE5LjIwNzkwMTYgTDIwLjI4Mzc4NTQsOS45MDUxNTEyIEwyMC40NDExNTc3LDkuNzQyNTQ2OCBDMjIuNTY5NTIwNiw3LjQ2MDMwODEzIDIyLjUwOTU1NjcsMy45MDEzNjA3OSAyMC4zMDg3NDU0LDEuNjk1NTU5NDQgTDIwLjEyMjgzOTUsMS41MTcyMDk4NyBDMTcuODU2NDMxMywtMC41NjM1MzUwOTUgMTQuMzM0NTc5MiwtMC41MDQwODUyMzkgMTIuMTM5OTEwNiwxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjMsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyMzkgNC4xNDY5MjYwMiwtMC41NjM1MzUwOTUgMS44ODA1MTc3NywxLjUxNzIwOTg3IEwxLjY5NDYxMTg5LDEuNjk1NTU5NDQgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
const EMPTY_FAVORITE_BASE64 = "data:image/svg+xml;base64,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";
const TABS_NOT_REQUIRED_GRIDICON = [
    "inspiration",
    "technical",
    "resources",
    "help"
];
// myProducts endPoints
const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog";
const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration";
const PDP_TEASER_DETAILS = DOMAIN + "/api/pdpTeaserDetails";
const PLUMBING_SERVICE_PARTS = "PlumbingServiceParts";
const PARTS = "parts";
// contact us endpoints
const CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT = "/crm/webtocase";
const API_SUCCESS_STATUS = "succeeded";
const API_FAILURE_STATUS = "failed";
const EMBED_TYPE_SCRIPT = "SCRIPT";
const EMBED_TYPE_HTML = "HTML";
const VISUALICON_ARIA_LABEL = "View at 360 degree mode";
const MATTERPORT_ARIA_LABEL = "virtual tour popup";
// tab component constants
const NS = "cmp";
const IS = "tabs";
const keyCodes = {
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
};
const selectors = {
    self: "[data-" + NS + '-is="' + IS + '"]',
    active: {
        tab: "cmp-tabs__tab--active",
        tabpanel: "cmp-tabs__tabpanel--active"
    }
};
const MIN_VIDEO_DURATION = 5;
// privacy-policy constants
const PRIVACY_ASPATH = "privacy-policy";
// press room constants
const DOWNLOAD_SPINNER = "download-spinner";
const postOrderNoOfDays = 45;
const TotalSecsForaDay = 86400000;
// teasercaption-repositioning constants
const TEASER_CAPTION_CLASSES = ".teaser.img-right-caption-left, .history-module-vertical-image.image-right, .history-module-with-SQR-img.image-left, .img-caption-style-left.img-right-with-number__intend, .img-caption-style-left.img-right-with-number";
// Add conditional wrapper in AEMGRID component for the provided grouped elements.
const groupedComponents = [
    COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.BREADCRUMB,
    COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.CAROUSEL
];
const SUCCESS = "success";
// Product support center constants
const SUPPORT_CENTER_PATH = "/en/support/product-support-center";
// my lists constant
const MY_LISTS_PATH = "/en/my-account/my-lists";
// share list path
const SHARE_LIST_PATH = "/en/share-list";
// share list path fr
const SHARE_LIST_PATH_FR = "/fr/share-list";
// help-and-faq constants
const HELP_AND_FAQ = "help-and-faq";
const resourceFacetLabels = [
    "ResourceVntanaProductId_s",
    "ResourceVntanaProductIdList_ss",
    "ResourceNvznIdList_ss",
    "ProductIsExclusive_s",
    "RegionSoldOnline_s",
    "CustomerFacingBrand_s",
    "ProductBusinessUnit_ss",
    "BundlePLPImageURL_s",
    "ctProductType_s",
    "colorSkuSlugListDetails_ss"
];
const DEVICE_TYPE_DESKTOP = "desktop";
// find a pro constants
const FIND_A_PRO_PATH = "/en/services/find-a-pro";
const FIND_A_PRO_HASH = "#findapro";
// shop the room details page
const SHOP_THE_ROOM = "shop-the-room";
// Installation services constants
const INSTALLATION_SERVICES_HASH = "#InstallService";
const INSTALLATION_SERVICES_PATH = "/en/services/installation-services";
const INSTALLATION_SERVICES_ASPATH = "installation-services";
const BUYING_GUIDE_ASPATH = "buying-guides";
const SIGNUP_HASH = "#signup";
// cart and checkout constants
const CART_URL = "/en/cart";
const CHECKOUT_URL = "/en/checkout";
const COUNTRY = {
    US: "US"
};
// Technical Specifications constants
const TECHNICAL_SPECIFICATION_PATH = "/en/for-professionals/technical-specifications";
// Browse all stores constants
const BROWSE_ALL_STORES = "browse-all-stores";
const BROWSE_ALL_STORES_URL = "/locations/browse-all-stores";
const MY_LISTS_PATH_FR = "/fr/my-account/my-lists";
// Locations constants
const LOCATIONS_PATH = "/en/locations";
const LOCATIONS_ASPATH = "/locations";
// bazaar voice constants
const BAZAAR_VOICE = "bazaarvoice";
// Redirect constants
const VANITY_REDIRECT_TYPE = "Vanity";
// teasercaption-repositioning constants
const TEASER_CAPTION_CLASSES_LIST = [
    "img-right-caption-left",
    "img-right-caption-left mobile-cta-double",
    "mobile-cta-double img-right-caption-left",
    "img-right-caption-left mobile-cta-single",
    "history-module-vertical-image image-right",
    "history-module-with-SQR-img image-left",
    "img-caption-style-left img-right-with-number__intend",
    "img-caption-style-left img-right-with-number"
];
const GATED_HASHES = [
    "#login",
    "#signup",
    "#createaccount",
    "#signin"
];
const FRAUD_CHLLENGE_STATUS = [
    "CHALLENGE",
    "ERROR",
    "DENY"
];
const IN_REVIEW_ORDER_STATUS = [
    "PA_PENDING",
    "ERROR_STATE",
    "FRAUD_HOLD",
    "FRAUD_CANCELLED"
];
const ORDER_IN_RECEIVED_STATUS = [
    "RECEIVED",
    "CREATED"
];
const myListContainerBreakPoints = {
    default: 3,
    1920: 3,
    1599: 2,
    639: 1
};
const MONTH_NAMES_EN = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const MONTH_NAMES_FR = [
    "Janvier",
    "F\xe9vrier",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Ao\xfbt",
    "Septembre",
    "Octobre",
    "Novembre",
    "D\xe9cembre"
];
const NODE_NAMES = {
    BUTTON: "BUTTON",
    IMG: "IMG"
};
const ONETRUST_IDENTIFIER = "cookielaw";
const SEARCH_TABS = {
    PRODUCTS: "Products",
    PARTS: "Parts",
    INSPIRATION: "Inspiration",
    TECHNICAL: "Technical",
    RESOURCES: "Resources",
    HELP: "Help"
};
const INITIAL_SEARCH_TABS_COUNT = {
    [SEARCH_TABS.PRODUCTS]: 0,
    [SEARCH_TABS.PARTS]: 0,
    [SEARCH_TABS.INSPIRATION]: 0,
    [SEARCH_TABS.TECHNICAL]: 0,
    [SEARCH_TABS.RESOURCES]: 0,
    [SEARCH_TABS.HELP]: 0
};
const searchFeatureResults = "/bin/kohler/searchpanelfragment";
const GET_CITY_AND_STATE_BY_ZIPCODE = "/maps/v2/location/zipcode";

const SEAT_TYPES = [
    "Toilet Seats",
    "Bidet Seats"
];
const EXCLUDE_PAGES = [
    "/checkout"
];
const UTILITY_CONSTANTS = {
    FAVOURITES: "favourite",
    SHARE: "share",
    PRINT: "print",
    DOWNLOAD: "download"
};
const TEASER_CLASSES = [
    "hero-banner-full-bleed-image",
    "hero-video-3-4"
];
const SHOP_THE_ROOM_CLASSES = [
    "shop-the-room"
];
const MIN_DELAY = 100;
/* harmony default export */ __webpack_exports__["default"] = (CONSTANTS);
const ADDRESS_SUGGESTION_DEFAULT_COUNTRY = "USA";
const AFFIRM_SHOP_URL = "https://www.affirm.com/shop/kohler-web";
const FREIGHT_SHIPPING_TYPES = [
    "Freight",
    "Freight Shipping"
];
const SEARCH_PDP_FL = [
    "id",
    "sku_s",
    "ctId_s",
    "ProductWaterSense_ss",
    "masterSKU_s",
    "CustomerFacingSKU_s",
    "ProductProductRecommendedAccessories_ss",
    "Product_Category",
    "ProductLocalCategory_s",
    "ProductServices_ss",
    "ProductPriceSpiderIncluded_s",
    "SKUIsProjectPack_s",
    "ProductBrandNameDisplay_s",
    "Collapse_Field_s",
    "Color.SKU.Details_ss",
    "productName_s",
    "RegionBrandName_s",
    "variantList.sku_ss",
    "ProductRequiredAccessoryGroup_ss",
    "ProductYoutubeID_s",
    "productImages.labelWithUrl_ss",
    "ProductDescriptionProductShort_s",
    "productRegionAllVariantDiscontinued_b",
    "ProductBrandName_s",
    "RegionOnBackOrder_s",
    "ProductOverallLengthInches_s",
    "ProductOverallWidthInches_s",
    "ProductOverallHeightInches_s",
    "ProductWebFeatures_ss",
    "ProductFreightPolicyType_s",
    "category1_s",
    "RegionReleaseforShipment_dt",
    "priceList.*.finalPrice_d",
    "priceList.*.saleOffer_s",
    "priceStartingAt.*_d",
    "priceList.*.discountedPrice_d",
    "priceList.*.price_d",
    "ProductBadgeInfo_ss",
    "ProductWebTechnology_ss",
    "ProductNarrativeDescription_s",
    "ProductWebMaterial_ss",
    "ProductWebInstallation_ss",
    "ProductCaliforniaProp65WarningDisclaimer_s",
    "ProductWebHydrotherapy_ss",
    "ProductWebRebates_ss",
    "ProductResource.DXFPlanView.resourceFullWebURL_ss",
    "ProductResource.DWGPlanView.resourceFullWebURL_ss",
    "ProductResource.DXFFrontView.resourceFullWebURL_ss",
    "ProductResource.DWGFrontView.resourceFullWebURL_ss",
    "ProductResource.DXFSideView.resourceFullWebURL_ss",
    "ProductResource.DWGSideView.resourceFullWebURL_ss",
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
    "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
    "ProductResource.3DRevit.resourceFullWebURL_ss",
    "ProductResource.3D3DS.resourceFullWebURL_ss",
    "ProductResource.3DSketchup.resourceFullWebURL_ss",
    "ProductResource.3DOBJ.resourceFullWebURL_ss",
    "ProductResource.CutOutDXF.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceTitle_ss",
    "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
    "ProductResource.EnvironProdDecl.resourceTitle_ss",
    "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
    "ProductResource.HomeownersGuide.resourceTitle_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
    "SKUDiscontinuedDate_dt",
    "ProductResource.YouTubeInstallVideo.resourceName_ss",
    "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
    "ProductResource.InteractiveSVG.resourceName_ss",
    "ProductResource.InteractiveSVG.resourceTitle_ss",
    "ProductProductNo_s",
    "ctProductType_s",
    "CustomerFacingBrand_s",
    "isCollapsedPDP_b",
    resourceFacetLabels.join(","),
    "CrossSellRecommendationSKUList_ss",
    "primaryBundleSKU_s",
    "bundleSKUList_ss",
    "title_s",
    "features_s",
    "ItemResource.IMGSpinSet.resourceFullWebURL_ss",
    "ItemResource.IMGSpinSet.resourceName_ss",
    "ItemResource.IMGSpinSet.resourceAltText_ss",
    "ItemResource.IMGSpinSet.resourceType_ss",
    "productLocalCategoryBreadCrumb_s",
    "productImages.url_ss"
];
const FEATURE_FLAGS_CHECKOUT_PAYLOAD = [
    "MYSQLCONNSTR_ACI_PAYMENT_FLAG",
    "MYSQLCONNSTR_ACI_GLOBAL_PAYMENT_FLAG",
    "MYSQLCONNSTR_DISABLE_ADD_CART",
    "MYSQLCONNSTR_EXCLUDE_PO_BOX_ADDRESSES",
    "MYSQLCONNSTR_DISABLE_BILLING_CUSTOM_DROPDOWN",
    "MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2",
    "MYSQLCONNSTR_ENABLE_ORDER_DETAILS_TABS",
    "MYSQLCONNSTR_ENABLE_NARVAR_RETURN",
    "MYSQLCONNSTR_ENABLE_PAYPAL_EXPRESS_CHECKOUT",
    "MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2",
    "MYSQLCONNSTR_ENABLE_SAVE_TO_LIST_FOR_QUICK_VIEW",
    "MYSQLCONNSTR_ENABLE_VISUAL_SEARCH_V1",
    "MYSQLCONNSTR_ENABLE_CONFIGURATOR",
    "MYSQLCONNSTR_ENABLE_CHECKOUT_V2",
    "MYSQLCONNSTR_ENABLE_ALBY_FOR_PERSONAS",
    "MYSQLCONNSTR_ENABLE_ACI_CREDIT_CARD_V2",
    "MYSQLCONNSTR_ENABLE_GLOBAL_VISUAL_SEARCH_V1",
    "MYSQLCONNSTR_ENABLE_EXECUTING_ORDER_LOGGING_API",
    "MYSQLCONNSTR_ENABLE_PDP_AFFIRM"
];
const CONTACT_US_PAGE_URL_US = "/en/support/contact";
const CONTACT_US_PAGE_URL = "/support/contact";
const CORE_GLOBAL_CONFIG_URL = "/api/globalconfig";
const NUMERIC_REGX = /^[0-9]+$/;
const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again...";
const EXCEPTIONAL_SITENAME = "kohler";
const STORE_APP_LD_JSON = {
    context: "https://schema.org",
    type: "Store",
    addressType: "PostalAddress",
    geoType: "GeoCoordinates",
    openingHourType: "OpeningHoursSpecification",
    openingDays: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
    }
};
const BREAD_CRUMB_APP_LD_JSON = {
    context: "https://schema.org",
    breadcrumbList: "breadcrumbList",
    listItemType: "ListItem"
};
const PDP_SLIDER_SIZES = {
    largeIpadSize: 1024,
    mobileSize: 767,
    desktopSliderImages: 15,
    smallesIpadSliderImages: 12,
    imageReelTitle: "image reel",
    portateDevice: 812,
    visualNavPlp: 1023
};
const ORDER_THANKYOU = "order:thank you";
const ORDER_CONFIRMATION = "order confirmation";
const VALID_GLOBA_CONFIG_PATHS = /^(?!.*[\{\}#%])(?!(.*https?:\/\/|.*www\.|.*\.com))[a-zA-Z0-9\/:._=?-]+$/;
const PriceRangeFrench = "Fourchette de prix";
const ML_API_MODEL_1 = "/pia-qa/model1";
const ML_API_MODEL_2 = "/pia-qa/model2";
const LOCALE_ENGLISH = "en-US";
const LOCALE_CANADA_FR = "fr-CA";
const PRICE_RANGE = "Price_Range";
const PDP_FIND_ON_DISPLAY = "pdp:find on display";
const PRICE_RANGE_FRENCH_LOCALE = "priceList.ANY.finalPrice_d";
const DISCOUNTED_PRICE_FACET_LABEL = "discountedPriceStartingAt";
const PDP_TYPE = "regular w/ required items";
const PDP_FEEDBACK = "pdp:provide feedback";
const SHOP_TOILET_SEATS = "shop toilet seats";
const ORDER_STATUS_PAGE = "order status";
const LITERATURE = "literature";
const TECHNICAL_SPECIFICATIONS = "technical specs";
const HOW_TO_BECOME_A_KPN = "how to become a kohler partner";
const TWO_WAYS_TO_BE_A_KPN = "two ways to be a kohler partner";
const JOIN_NOW = "Join Now";
const SEARCH_INTERNAL_TYPE = {
    sterlingResults: "view sterling results",
    compare: "compare",
    partsDiagram: "parts diagram",
    serviceParts: "service parts"
};
const INSTALL_ITEMS = "items required for install test";
const INSTALL_ITEMS_EDIT = "edit items required for install";
const MY_ACCOUNT_MODAL = "my account modal section";
const CREATE_ACCOUNT = "create account";
const BRAND_NAME = {
    annSacks: "Ann Sacks",
    sterling: "STERLING",
    homeEnergy: "Home Energy"
};
const BROWSE_ALL_KOHLER_STORES = "browse all kohler stores";
const FIND_A_STORE = "find a store";
const PDP_DETAILS = "pdp:product details";
const PDP_FAVORITE = "favorites";
const PDP_GUEST_FAVORITE = "guest favorites";
const NAVIGATION_TYPE = {
    PRODUCT: "product navigation",
    MEGA_MENU: "mega menu navigation",
    GLOBAL: "global navigation"
};
const CHECKOUT_PAYMENT = "payment & billing";
const HEADER_NAV_TABS_WRAPPER_ID = "header-nav-tabs-wrapper";
const PDP_TYPES = "regular finished goods";
const STOCKS = {
    OUT_OF_STOCK: "out of stock",
    IN_STOCK: "in stock"
};
const PERCENT_OFF = "percentOff|";
const REGULAR_PRICE = "regular price";
const TARGETED_DOMAIN_TO_MONITOR = "kohlermetrics";
const tooltip = "/icons/tooltip-red.svg";
const INSPIRATION_PAGE_NAME = {
    KIPS_BAY_DECORATOR: "kips bay decorator showhouse gallery dallas",
    PROJECT_GALLERY: "project gallery",
    ABOUT_US_OUR_IMPACT: "about us:our impact"
};
const CONTACT_US_SUPPORT = "support:contact:form";
const CONTACT_US_FORM = "support:contact";
const HELP_AND_SUPPORT = "help and support";
const HELP_SUPPORT = "help support";
const CALL_OUR_TEAM = "call our team";
const SSR_PLP_FL = [
    "id",
    "masterSKU_s",
    "sku_s",
    "RegionSoldOnline_s",
    "ctProductType_s",
    "productRegionAllVariantDiscontinued_b",
    "CustomerFacingBrand_s",
    "ProductBusinessUnit_ss",
    "masterCustomerFacingSKU_s",
    "SKUColorSwatchFilename_ss",
    "SKUColorSwatchFilename_s",
    "ProductDescriptionProductShort_s",
    "ProductBrandName_s",
    "metaTitle_s",
    "productName_s",
    "RegionBrandName_s",
    "productImages.url_s",
    "productImages.url_ss",
    "slug_s",
    "Product_Category",
    "displayPriceStartingAt_s",
    "Tile_Title",
    "Collapse_Title_s",
    "Collapse_Description_s",
    "price*",
    "discountedPrice*",
    "variantList.sku_ss",
    "variantList.sku_s",
    "SKUColorFinishName_s",
    "SKUColorFinishName_ss",
    "SKU.Details_ss",
    "Color.SKU.Details_ss",
    "ProductExclusive_s",
    "RegionReleaseforShipment_dt",
    "productImages.labelWithUrl_ss",
    "productImages.labelWithUrl_s",
    "productImageVariantImages.labelWithUrl_ss",
    "RegionOnBackOrder_s",
    "ProductIsRetail",
    "comboSKUAvailable_b",
    "category1_s",
    "ProductBrandNameDisplay_s",
    "ctId_s",
    "ProductResource.InteractiveSVG.resourceName_ss",
    "ProductProductNo_s",
    "ProductResource.InteractiveSVG.resourceTitle_ss",
    "ResourceNvznId_s",
    "ResourceVntanaProductId_s",
    "ResourceVntanaProductIdList_ss",
    "ResourceNvznIdList_ss",
    "ProductIsExclusive_s",
    "Collapse_Field_s",
    "primaryBundleSKU_s",
    "disc_max_price",
    "max_price",
    "RegionIsBackOrderable_b",
    "ProductIsRetail_s",
    "ProductWebFeatures_ss",
    "RegionSoldOnline_s",
    "ProductBusinessUnit_ss",
    "CustomerFacingBrand_s",
    "*.Details_ss",
    "disc_min_price",
    "BundlePLPImageURL_s",
    "Bundle_s",
    "displayPriceStartingAt_s",
    "*.minPrice_d",
    "*.maxPrice_d",
    "*.discMaxPrice_d",
    "*.discMinPrice_d",
    "colorSkuSlugListDetails_ss"
];
const REMEDY_MODEL_JSON = "/remedy.model.json";
const SMART_TOILETS_MODEL_JSON = "/smart-toilets.model.json";
const PRESS_KIT_PAGE_TYPE = "press-kit";
const BUYING_GUIDE = "Buying Guide";
const SHOP_THE_LOOK = "shop the look";
const INTERACTIVE_TAGS = [
    "A",
    "BUTTON",
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const SERVICES = [
    "Install Services",
    "Design Services"
];
const PRODUCT_EXCLUDE_FROM_PAID_ADVERTISING = "ProductExcludeFromPaidAdvertising";
const VALID_SPACER_SIZES = new Set([
    "none",
    "xs",
    "s",
    "m",
    "l",
    "xl"
]);
const SPACER_ALIAS = {
    "top size": "none",
    "bottom size": "none",
    small: "s",
    medium: "m",
    large: "l"
};
const BUNDLE_LABEL = "BUNDLE";
const GIFT_DESIGN = "give the gift of design";
const KOHLER_BATHROOM_DESIGN = "kohler bathroom design";
const QUICK_VIEW = "quick view";
const CLOSE = "close";
const QUICK_VIEW_MODAL = "quick view modal";
const PRODUCT = "product";
const COLOR = "color";
const IMG_ITEM_ISO = "imgitemiso";
const ADD_TO_CART = "add to cart";
const VIEW_FULL_DETAILS = "view full details";
const CAROUSEL_IMAGE = "carousel image";
const NOTIFY = "notify me";
const PROMO_TILES = "promo tiles";
const NO_ACTIVE_CART_EXISTS = "No active cart exists.";
const searchUrl = "/content/kohler/us/en/search.html";
const STERLING_LINK = [
    {
        brandName: "STERLING",
        link: "https://sterling.kohler.com",
        linkRef: true
    }
];
const GRADIENT_DICTIONARY = {
    topToBottom: "top-bottom",
    bottomToTop: "bottom-top",
    leftToRight: "left-right",
    rightToLeft: "right-left",
    radialCenterOut: "tint"
};
const PROMO_COLUMNS = {
    "one-column": "1-column",
    "two-column": "2-column",
    "three-column": "3-column"
};
const DB_NAME = "ProductListDB";
const DB_VERSION = 1;
const STORE_NAME = "plpCardsData";
const READ_WRITE = "readwrite";
const READ_ONLY = "readonly";
const INDEXEDDB_NOT_SUPPORTED_ERROR = "IndexedDB is not supported in this browser";
const METRIC_THRESHOLDS = {
    LCP: [
        2500,
        4000
    ],
    FID: [
        100,
        300
    ],
    CLS: [
        0.1,
        0.25
    ],
    FCP: [
        1800,
        3000
    ],
    TTFB: [
        800,
        1800
    ]
};
const CATEGORY_LANDING_PAGES = [
    "bathroom-faucets",
    "toilet-seats-bidet-seats",
    "toilets",
    "showers",
    "bathtubs"
];


/***/ }),

/***/ 49139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ PURE_TEXT_REGEX; },
/* harmony export */   "FU": function() { return /* binding */ SPECIAL_CHAR_REGEX; },
/* harmony export */   "GK": function() { return /* binding */ FILTER_PARAM_REGEX; },
/* harmony export */   "H": function() { return /* binding */ BACKSLASH_REGEX; },
/* harmony export */   "HS": function() { return /* binding */ FACET_FORMAT_REGEX; },
/* harmony export */   "I1": function() { return /* binding */ SANITIZE_TAG_OR_UNDEFINED_REGEX; },
/* harmony export */   "If": function() { return /* binding */ SANITIZE_TEXT_REGEX; },
/* harmony export */   "JR": function() { return /* binding */ THREEKIT_SWATCH_PREFIX_REGEX; },
/* harmony export */   "JY": function() { return /* binding */ VIDEO_ID_REGEX; },
/* harmony export */   "KC": function() { return /* binding */ UNDERSCORE_REPLACE_REGEX; },
/* harmony export */   "L3": function() { return /* binding */ IMAGEID_DATALAYER_REGEX; },
/* harmony export */   "LM": function() { return /* binding */ VISUAL_NAV_SCENE7_REGEX; },
/* harmony export */   "LN": function() { return /* binding */ CAMEL_CASE_REGEX; },
/* harmony export */   "Nw": function() { return /* binding */ PHONE_DISPLAY_REGEX; },
/* harmony export */   "RR": function() { return /* binding */ QUOT_REGEX; },
/* harmony export */   "SA": function() { return /* binding */ SANITIZE_FLOAT_NUMBER_REGEX; },
/* harmony export */   "TT": function() { return /* binding */ TEXT_AREA_LABEL_REGEX; },
/* harmony export */   "Tc": function() { return /* binding */ SANITIZE_NUMBER_REGEX; },
/* harmony export */   "VB": function() { return /* binding */ POSTAL_CODE_US_REGEX; },
/* harmony export */   "VL": function() { return /* binding */ HTML_STRING_REGEX_OPT1; },
/* harmony export */   "Vb": function() { return /* binding */ MEMBERSHIP_CODE_ERROR_REGEX; },
/* harmony export */   "X_": function() { return /* binding */ HTML_STRING_REGEX_OPT2; },
/* harmony export */   "YN": function() { return /* binding */ PURE_DATA_FOR_STRING_REGEX; },
/* harmony export */   "ab": function() { return /* binding */ UPPERCASE_REGEX; },
/* harmony export */   "bY": function() { return /* binding */ ZIP_CODE_MATCH_WHITESPACE_REGEX; },
/* harmony export */   "cH": function() { return /* binding */ SAVE_TO_LIST_NAME_FIELD_REGEX; },
/* harmony export */   "dd": function() { return /* binding */ MEMBERSHIP_VALID_MAIL_ERROR_REGEX; },
/* harmony export */   "dq": function() { return /* binding */ DOUBLE_QUOTE_REGEX; },
/* harmony export */   "ef": function() { return /* binding */ URL_REPLACE_REGEX; },
/* harmony export */   "gP": function() { return /* binding */ NON_DIGIT_REGEX; },
/* harmony export */   "iD": function() { return /* binding */ PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX; },
/* harmony export */   "kh": function() { return /* binding */ FIRST_LETTER_REGEX; },
/* harmony export */   "lY": function() { return /* binding */ ZIP_CODE_DIGIT_REGEX; },
/* harmony export */   "lh": function() { return /* binding */ CAMEL_CASE_REPLACE_PATTERN; },
/* harmony export */   "lj": function() { return /* binding */ NAME_REGEX; },
/* harmony export */   "my": function() { return /* binding */ SPACE_REGEX; },
/* harmony export */   "ny": function() { return /* binding */ VISUAL_NAV_IMAGEID_FOR_DATALAYER; },
/* harmony export */   "ok": function() { return /* binding */ DATA_LAYER_REGEX; },
/* harmony export */   "si": function() { return /* binding */ ALPHABET_WITH_SPACE_REGEX; },
/* harmony export */   "uZ": function() { return /* binding */ NUMBER_HEADING_REGEX; },
/* harmony export */   "ub": function() { return /* binding */ PDP_REGEX; },
/* harmony export */   "wM": function() { return /* binding */ POSTAL_CODE_REGEX; },
/* harmony export */   "wc": function() { return /* binding */ POSTAL_CODE_CA_REGEX; }
/* harmony export */ });
/* unused harmony exports FULL_NAME_REGEX, INCH_SYMBOL_REGEX, SELECT_AFTER_LAST_SLASH_REGEX, MATCH_DIGIT_FOLLOWED_BY_INCH_SYMBOL_REGEX */
const SANITIZE_TEXT_REGEX = /[^a-zA-Z<>&@.-\d\s:]/g;
const SANITIZE_NUMBER_REGEX = /[^0-9]/g;
const PDP_REGEX = /^([\/]).*.([\-]).([0-9]{2,}).*$/gm;
const URL_REPLACE_REGEX = /\s&\s|\s/g;
const MEMBERSHIP_VALID_MAIL_ERROR_REGEX = /\S+@\S+\.\S+/;
const MEMBERSHIP_CODE_ERROR_REGEX = /@kohler.com\s*$/;
const FULL_NAME_REGEX = /^[a-zA-Z]+ [a-zA-Z]+$/;
const PURE_TEXT_REGEX = /<[^>]*>/g;
const SPECIAL_CHAR_REGEX = /[^a-zA-Zd0-9 ]/g;
const NUMBER_HEADING_REGEX = /^[1-6]$/;
const ALPHABET_WITH_SPACE_REGEX = /^[a-zA-Z ]*$/;
const POSTAL_CODE_US_REGEX = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
const POSTAL_CODE_CA_REGEX = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
const POSTAL_CODE_REGEX = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
const INCH_SYMBOL_REGEX = /\d$/;
const DATA_LAYER_REGEX = /&amp;/g;
const PURE_DATA_FOR_STRING_REGEX = /(\r\n|\n|\r)/gm;
const SPACE_REGEX = /\s+/g;
const FILTER_PARAM_REGEX = /[\/\\]/g;
const TEXT_AREA_LABEL_REGEX = /\*/g;
const SAVE_TO_LIST_NAME_FIELD_REGEX = /^[a-zA-Z0-9 ]*$/;
const VISUAL_NAV_IMAGEID_FOR_DATALAYER = /\/([^\/]+)\.(jpg|jpeg|png)$/i;
const UPPERCASE_REGEX = /(?=.*[A-Z])/;
const ZIP_CODE_MATCH_WHITESPACE_REGEX = /\s/g;
const ZIP_CODE_DIGIT_REGEX = /^\d+$/;
const VIDEO_ID_REGEX = /PAWEB\/|Kohler\//;
const SANITIZE_FLOAT_NUMBER_REGEX = /[^0-9.]/g;
const NAME_REGEX = /^[a-zA-Z-'.]+$/;
const IMAGEID_DATALAYER_REGEX = /PAWEB\/(\w+)_/;
const SELECT_AFTER_LAST_SLASH_REGEX = /\/[^\/]*$/;
const QUOT_REGEX = /&quot;/g;
const DOUBLE_QUOTE_REGEX = /"/g;
const UNDERSCORE_REPLACE_REGEX = /_/g;
const CAMEL_CASE_REGEX = /([a-z])([A-Z])/g;
const CAMEL_CASE_REPLACE_PATTERN = "$1 $2";
const FACET_FORMAT_REGEX = /(^facet:')|('\s*$)/g;
const THREEKIT_SWATCH_PREFIX_REGEX = /^swatch_/;
const SANITIZE_TAG_OR_UNDEFINED_REGEX = /^[a-z][a-z0-9:-]*$/i;
const HTML_STRING_REGEX_OPT1 = /<([a-z][\w:-]*)(\s[^>]*)?>[\s\S]*<\/\1>/i;
const HTML_STRING_REGEX_OPT2 = /<([a-z][\w:-]*)(\s[^>]*)?\/>/i;
const VISUAL_NAV_SCENE7_REGEX = /Visual-Nav-Filter-([a-z]{3})(\d+)_rgb/i;
const FIRST_LETTER_REGEX = /\b\w/g;
const PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX = RegExp("(?<!\\\\)\\|");
const BACKSLASH_REGEX = /\\/g;
const MATCH_DIGIT_FOLLOWED_BY_INCH_SYMBOL_REGEX = /(\d+)"/g;
const NON_DIGIT_REGEX = /\D/g;
const PHONE_DISPLAY_REGEX = /(\d{0,3})(\d{0,3})(\d{0,4})/;


/***/ }),

/***/ 64757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ CATALOG_PROJECTION_ENDPOINT; },
/* harmony export */   "FF": function() { return /* binding */ ORDER_SUBMIT_V2_ENDPOINT; },
/* harmony export */   "Ht": function() { return /* binding */ FRAUD_DECLINED_MESSAGE_ENDPOINT; },
/* harmony export */   "PN": function() { return /* binding */ MY_LISTS_PAGE_PATH; },
/* harmony export */   "RG": function() { return /* binding */ PRODUCT_BEST_SELLERS; },
/* harmony export */   "Rv": function() { return /* binding */ ACI_PAYMENT_CHECKOUT_ENDPOINT; },
/* harmony export */   "TE": function() { return /* binding */ ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT; },
/* harmony export */   "VA": function() { return /* binding */ CART_OFFER_ENDPOINT; },
/* harmony export */   "VU": function() { return /* binding */ FEATURE_FLAGS_API_ENDPOINT; },
/* harmony export */   "X0": function() { return /* binding */ SWATCH_ORDER_CATALOG; },
/* harmony export */   "YZ": function() { return /* binding */ SVG_METADATA_ENDPOINT; },
/* harmony export */   "_2": function() { return /* binding */ ORDER_SUBMIT_V3_ENDPOINT; },
/* harmony export */   "bQ": function() { return /* binding */ ORDER_LOGGING_ENDPOINT; },
/* harmony export */   "hW": function() { return /* binding */ THREEKIT_DATATABLE_END_POINT; },
/* harmony export */   "j0": function() { return /* binding */ CHANGE_PASSWORD_ENDPOINT; },
/* harmony export */   "lY": function() { return /* binding */ CATALOG_NOTIFY_ENDPOINT; },
/* harmony export */   "r5": function() { return /* binding */ SEARCH_FULL_CATALOG; },
/* harmony export */   "sW": function() { return /* binding */ ACI_PAYMENT_CHECKOUT_V1_ENDPOINT; },
/* harmony export */   "zG": function() { return /* binding */ ACI_PAYMENT_CALLBACK_ENDPOINT; }
/* harmony export */ });
/* unused harmony exports CHANGE_PASSWORD_MODEL_DATA_URL, ML_END_POINT, USER_LIST_DELETE_END_POINT, FAVORITES_PAGE_PATH */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);

const ACI_PAYMENT_CHECKOUT_ENDPOINT = "/payment/checkout";
const ACI_PAYMENT_CHECKOUT_V1_ENDPOINT = "/payment/v1/checkout";
const ORDER_SUBMIT_V3_ENDPOINT = "/checkout/v3/order/submit";
const ORDER_SUBMIT_V2_ENDPOINT = "/checkout/v2/order/submit";
const ACI_PAYMENT_CALLBACK_ENDPOINT = "/payment/checkout/callback";
const FRAUD_DECLINED_MESSAGE_ENDPOINT = "/en/declined";
const CHANGE_PASSWORD_MODEL_DATA_URL = "/en/my-account/change-password.model.json";
const CHANGE_PASSWORD_ENDPOINT = "/customer/change_password";
const CATALOG_NOTIFY_ENDPOINT = "catalog/product/oos/notify";
const CATALOG_PROJECTION_ENDPOINT = "/catalog/product/projection";
const FEATURE_FLAGS_API_ENDPOINT = _constants__WEBPACK_IMPORTED_MODULE_0__.DOMAIN + "/api/featureflags";
const SVG_METADATA_ENDPOINT = "/catalog/svg/metadata";
const ML_END_POINT = "https://api-kohler-int-test.azure-api.net";
const ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT = "/catalog/product/recommendation";
const PRODUCT_BEST_SELLERS = "/products/best-sellers";
const USER_LIST_DELETE_END_POINT = "/shopping-list";
const MY_LISTS_PAGE_PATH = "/my-account/my-lists";
const FAVORITES_PAGE_PATH = "/my-account/my-favorites";
const SEARCH_FULL_CATALOG = "/search/full-catalog";
const CART_OFFER_ENDPOINT = "/cart/offer?discountCodeList=true";
const SWATCH_ORDER_CATALOG = "/search/swatch";
const THREEKIT_DATATABLE_END_POINT = "/catalog/product/configurator";
const ORDER_LOGGING_ENDPOINT = _constants__WEBPACK_IMPORTED_MODULE_0__.DOMAIN + "/api/order-logging";


/***/ }),

/***/ 31895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ConfigContext; },
/* harmony export */   "i": function() { return /* binding */ ConfigProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const ConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
const ConfigProvider = (param)=>{
    let { configData , children  } = param;
    const memoizedConfig = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>configData !== null && configData !== void 0 ? configData : {}, [
        configData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfigContext.Provider, {
        value: memoizedConfig,
        children: children
    });
};
ConfigProvider.propTypes = {
    configData: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().any.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired)
};


/***/ }),

/***/ 2595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useIsSsr = ()=>{
    // we always start off in "SSR mode", to ensure our initial browser render
    // matches the SSR render
    const [isSsr, setIsSsr] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // `useEffect` never runs on the server, so we must be on the client if
        // we hit this block
        setIsSsr(false);
    }, []);
    return isSsr;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSsr);


/***/ }),

/***/ 83886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2595);


const useSmartCrop = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [scriptStatus, setScriptStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!isSsr && window.s7responsiveImage ? true : false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!isSsr) {
            loadSmartcrop();
        }
    }, [
        isSsr
    ]);
    const loadSmartcrop = ()=>{
        const scriptExist = document.querySelectorAll("script#smartcrop-react");
        if (scriptExist.length === 0 && !window.s7responsiveImage) {
            const script = document.createElement("script");
            script.src = "/js/responsive-images.js";
            script.id = "smartcrop-react";
            script.onload = function onload() {
                setScriptStatus(true);
            };
            document.body.appendChild(script);
        } else {
            setScriptStatus(true);
        }
    };
    const applySmartCrop = (ele)=>{
        window.s7responsiveImage && window.s7responsiveImage(ele);
    };
    return {
        scriptStatus,
        applySmartCrop
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSmartCrop);


/***/ }),

/***/ 78770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useViewportWidth; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useViewport = ()=>{
    const [device, setDevice] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({});
    /**
   * This function does the comparisons for different viewports
   * @return {Object} Object of all the viewport flags
   */ const getValues = ()=>{
        const resolution = window.innerWidth;
        const isExtraSmallScreen = resolution <= 375;
        const isSmallScreen = resolution <= 812;
        const isMediumScreen = resolution > 812 && resolution <= 1024;
        const isSmallTabView = resolution < 1024;
        const isLargeTabView = resolution > 1024;
        const isLargeScreen = resolution >= 1024 && resolution < 1920;
        const isExtraLargeScreen = resolution >= 1920;
        return {
            isExtraSmallScreen,
            isSmallScreen,
            isMediumScreen,
            isLargeScreen,
            isExtraLargeScreen,
            isLargeTabView,
            isSmallTabView
        };
    };
    /**
   * Sets updated viewport flag values
   */ const handleWindowResize = ()=>{
        setDevice(getValues());
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return device;
};
/* harmony default export */ __webpack_exports__["Z"] = (useViewport);
const useViewportWidth = ()=>{
    const [width, setWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const handleWindowResize = ()=>setWidth(window.innerWidth);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return width;
};


/***/ }),

/***/ 30394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2595);



/**
 *
 * @return {{width, height}}
 */ const useWindowDimensions = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [windowDimensions, setWindowDimensions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        winWidth: 0,
        winHeight: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) {
            return;
        }
        const { innerWidth: width , innerHeight: height  } = window;
        /**
     * Set window dimensions on resize
     */ const handleResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(()=>{
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
        }, 300);
        if (!isSsr) {
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
            window.addEventListener("resize", handleResize);
        }
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        isSsr
    ]);
    return windowDimensions;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowDimensions);


/***/ }),

/***/ 11859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2595);
/* eslint-disable require-jsdoc */ 

const useWindowResize = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    // [1366, 443] [768, 1024] [449, 972]
    // const [size, setSize] = useState([1366, 443])
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
         true ? window.innerWidth : 0,
         true ? window.innerHeight : 0
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (isSsr) {
            return;
        }
        setSize([
            window.innerWidth,
            window.innerHeight
        ]);
        function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        }
        if (!isSsr) {
            window.addEventListener("resize", updateSize);
            updateSize();
        }
        return ()=>window.removeEventListener("resize", updateSize);
    }, [
        isSsr
    ]);
    return size;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowResize);


/***/ }),

/***/ 46967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const useAuthUtilityNavi18n = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        favorites: t("Favorites"),
        signIn: t("Sign In"),
        createAccount: t("Create Account"),
        hi: t("kf.auth.label.hi"),
        title: t("kf.auth.label.bannerMssg"),
        welcome: t("kf.auth.label.welcome"),
        logout: t("kf.auth.label.logout"),
        rightArrowAlt: t("kf.auth.label.rightArrowAlt"),
        leftArrowAlt: t("kf.auth.label.rightArrowAlt"),
        menu: t("kf.auth.label.menu"),
        expanded: t("kf.auth.label.expanded"),
        collapsed: t("kf.auth.label.collapsed"),
        user: t("kf.auth.label.user"),
        storeOperations: t("kf.account.label.storeOperations"),
        opensInNewTab: t("kf.navigation.opensInNewTab"),
        opensInSameTab: t("kf.navigation.opensInSameTab")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthUtilityNavi18n);


/***/ }),

/***/ 83511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const useFindStorei18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        userMyLocation: authorData.userMyLocation ? authorData.userMyLocation : t("kf.findstore.label.userMyLocation"),
        kohlerStores: authorData.kohlerStores ? authorData.kohlerStores : t("kf.findstore.label.kohlerStores"),
        showrooms: authorData.showrooms ? authorData.showrooms : t("kf.findstore.label.showrooms"),
        showroom: authorData.showroom ? authorData.showroom : t("kf.findstore.label.showrooms"),
        kohlerStore: authorData.kohlerStore ? authorData.kohlerStore : t("kf.findstore.label.kohlerStore"),
        annsacksShowroom: authorData.annsacksShowroom ? authorData.annsacksShowroom : t("kf.findstore.label.annsacksShowroom"),
        partsDealer: authorData.partsDealer ? authorData.partsDealer : t("kf.findstore.label.partsDealer"),
        homeCenter: authorData.homeCenter ? authorData.homeCenter : t("kf.findStore.label.homeCenter"),
        genuinePartsDealers: authorData.genuinePartsDealers ? authorData.genuinePartsDealers : t("kf.findstore.label.genuinePartsDealers"),
        kohler: t("kf.findStoreUtilNav.label.kohler"),
        annSacks: authorData.annSacks ? authorData.annSacks : t("kf.findstore.label.annSacks"),
        annSacksText: authorData.annSacksText ? authorData.annSacksText : t("kf.findstore.label.annSacksText"),
        countryPlaceholder: authorData.countryPlaceholder ? authorData.countryPlaceholder : t("kf.findstore.label.countryPlaceholder"),
        locationErrormessage: authorData.locationErrormessage ? authorData.locationErrormessage : t("kf.findstore.label.locationErrormessage"),
        clearAll: t("kf.plp.label.clearAll"),
        viewList: authorData.viewList ? authorData.viewList : t("kf.findstore.label.viewList"),
        viewMap: authorData.viewMap ? authorData.viewMap : t("kf.findstore.label.viewMap"),
        applyFilters: authorData.applyFilters ? authorData.applyFilters : t("kf.findstore.label.applyFilters"),
        filters: t("kf.plp.label.filters"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        miles: authorData.miles ? authorData.miles : t("kf.findstore.label.miles"),
        away: authorData.away ? authorData.away : t("kf.findstore.label.away"),
        browseAllStore: authorData.browseAllStore ? authorData.browseAllStore : t("kf.findstore.label.browseAllStore"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        home: authorData.home ? authorData.home : t("kf.findstore.label.home"),
        findStore: authorData.findstore ? authorData.findstore : t("kf.findstore.label.findstore"),
        kohlerStoreImgAlt: t("kf.findstore.label.kohlerStoreImgAlt"),
        viewResults: t("kf.plp.label.viewResults"),
        view: t("kf.plp.label.view"),
        results: t("kf.plp.label.results"),
        filterImgAlt: t("kf.findstore.label.filterImgAlt"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        retailStore: authorData.retailStore ? authorData.retailStore : t("kf.findstore.label.retailStore"),
        retailMobileText: t("kf.findstore.label.retailMobileText"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        ariaLabel: {
            enterZipcode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            showFilter: t("kf.findstore.aria.label.showFilter"),
            hideFilter: t("kf.findstore.aria.label.hideFilter"),
            browseAll: t("kf.findstore.aria.label.browseAll"),
            contact: (phone)=>t("kf.findStore.aria.label.contact", {
                    phone
                }),
            mapMarker: t("kf.findstore.aria.label.mapMarker"),
            mapGuidelines: t("kf.findstore.aria.label.mapGuidelines"),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        messageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        continue: t("kf.checkout.label.continue"),
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        submit: t("kf.global.label.submit"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        useLocation: t("kf.findStoreUtilNav.label.useLocation"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        enterCityStateZip: t("kf.findStoreUtilNav.label.countryPlaceholder"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        KohlerSignatureStore: t("kf.findStoreUtilNav.label.KohlerSignatureStore"),
        BySupplyNew: t("kf.findStoreUtilNav.label.BySupplyNewEnglad"),
        searchHeader: t("kf.search.label.searchHeader"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        skipToMainContent: t("kf.main.content.ariaLabel")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindStorei18n);


/***/ }),

/***/ 58886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const usePdpi18n = (authorData, badgeText, name)=>{
    const { configuratorTitle ="" , configuratorDesc ="" , configuratorButtonLabel ="" , configuratorErrorTitle ="" , configuratorErrorDesc ="" , configuratorErrorButtonLabel =""  } = authorData;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    var _listpricelabel, _colorlabel, ref, _professionalService, _installationHelp, _installerArea, _maxProducts, ref1, _superskulabel, _priceFootnoteTitle, _priceFootnote, _colorFootnoteTitle, _colorFootnote, _discontinueProductMsg, _discontinueColorMsg, _onPdpCtaLabel, _colorOrFinish, _outofStockTitle, _welcomeMsg, _notifyEmailTxt, _findLocalStore, _backOrder, _specialOrder, _discontinueColorLabel, _discontinueColorFinishLabel, _modalRightSectionTitle, _modalRightSectionTitle1, _modalRightSectionDesc, _modalRightSectionDesc1, _modalRighttSectionCtaLabel, _modalLeftSectionTitle, _onPdpTooltip, _priceSpiderTitle, _oversizeMsgTitle, _oversizeMsgDesc, _noPriceMsg, _listpricetooltip, _subCopy, _subCopy1, _serviceavailable, _errorMessage, _zipcodevalidationmessage, _zipcodevalidationmessage1, _new, _onSale, _shippingTitle, _shippingDescription, _modalRightSectionNoStockMsg;
    const i18n = {
        home: t("kf.global.label.home"),
        viewLink: t("kf.pdp.label.viewGallery"),
        linkMore: t("kf.pdp.label.morePhotos"),
        moreCollection: t("kf.pdp.label.moreFromCollection"),
        moreCollectionDiscontinued: t("kf.pdp.label.moreFromCollectionDiscontinued"),
        shopText: t("kf.pdp.label.shopAll"),
        listPrice: t("kf.pdp.label.listPrice"),
        refPrice: (_listpricelabel = authorData.listpricelabel) !== null && _listpricelabel !== void 0 ? _listpricelabel : t("kf.pdp.label.refPrice"),
        startingAt: t("kf.pdp.label.startingAt"),
        finish: (_colorlabel = authorData.colorlabel) !== null && _colorlabel !== void 0 ? _colorlabel : t("kf.pdp.label.finish"),
        orderSample: t("kf.pdp.label.orderSample"),
        dimensions: t("kf.pdp.label.dimensions"),
        details: t("kf.pdp.label.details"),
        viewAllSpecs: t("kf.pdp.label.viewAllSpecs"),
        viewMore: t("kf.pdp.label.viewMore"),
        viewGallery: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.viewgalleryctalabel) !== null && ref !== void 0 ? ref : t("kf.pdp.label.viewGallery"),
        length: t("kf.pdp.label.length"),
        width: t("kf.pdp.label.width"),
        height: t("kf.pdp.label.height"),
        smLength: t("kf.pdp.label.smLength"),
        smWidth: t("kf.pdp.label.smWidth"),
        smHeight: t("kf.pdp.label.smHeight"),
        learnMore: t("kf.pdp.label.learnMore"),
        addToCart: t("kf.cart.label.addToCart"),
        addService: t("kf.cart.label.addService"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        print: t("kf.plp.label.print"),
        wishlist: t("kf.pdp.label.wishlist"),
        share: t("kf.plp.label.share"),
        addToCompare: t("kf.compare.label.addToCompare"),
        nearByStoreLink: t("kf.pdp.label.nearByStoreLink"),
        professionalService: (_professionalService = authorData.professionalService) !== null && _professionalService !== void 0 ? _professionalService : t("kf.pdp.label.professionalService"),
        installationHelp: (_installationHelp = authorData.installationHelp) !== null && _installationHelp !== void 0 ? _installationHelp : t("kf.pdp.label.installationHelp"),
        installerArea: (_installerArea = authorData.installerArea) !== null && _installerArea !== void 0 ? _installerArea : t("kf.pdp.label.installerArea"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: (_maxProducts = authorData.maxProducts) !== null && _maxProducts !== void 0 ? _maxProducts : t("kf.compare.validation.maxProducts"),
        sameVariants: (ref1 = authorData === null || authorData === void 0 ? void 0 : authorData.sameVariants) !== null && ref1 !== void 0 ? ref1 : t("kf.compare.validation.sameVariants"),
        itemAdded: t("kf.pdp.label.itemAdded"),
        itemsAdded: t("kf.pdp.label.itemsAdded"),
        yourCart: t("kf.pdp.label.yourCart"),
        selectMoreOptions: t("kf.pdp.label.selectMoreOptions"),
        productOptions: (_superskulabel = authorData.superskulabel) !== null && _superskulabel !== void 0 ? _superskulabel : t("kf.pdp.label.productOptions"),
        priceFootnoteTitle: (_priceFootnoteTitle = authorData.priceFootnoteTitle) !== null && _priceFootnoteTitle !== void 0 ? _priceFootnoteTitle : t("kf.pdp.label.priceFootnoteTitle"),
        priceFootnote: (_priceFootnote = authorData.priceFootnote) !== null && _priceFootnote !== void 0 ? _priceFootnote : t("kf.pdp.label.priceFootnote"),
        colorFootnoteTitle: (_colorFootnoteTitle = authorData.colorFootnoteTitle) !== null && _colorFootnoteTitle !== void 0 ? _colorFootnoteTitle : t("kf.pdp.label.colorFootnoteTitle"),
        colorFootnote: (_colorFootnote = authorData.colorFootnote) !== null && _colorFootnote !== void 0 ? _colorFootnote : t("kf.pdp.label.colorFootnote"),
        discontinueProductMsg: (_discontinueProductMsg = authorData.discontinueProductMsg) !== null && _discontinueProductMsg !== void 0 ? _discontinueProductMsg : t("kf.pdp.label.discontinueProductMsg"),
        discontinueColorMsg: (_discontinueColorMsg = authorData.discontinueColorMsg) !== null && _discontinueColorMsg !== void 0 ? _discontinueColorMsg : t("kf.pdp.label.discontinueColorMsg"),
        itemReqCTA: (_onPdpCtaLabel = authorData.onPdpCtaLabel) !== null && _onPdpCtaLabel !== void 0 ? _onPdpCtaLabel : t("kf.pdp.label.itemReqCTA"),
        editItemReqCTA: authorData.onPdpCtaLabel ? "".concat(t("kf.pdp.label.edit"), " ").concat(authorData.onPdpCtaLabel) : t("kf.pdp.label.editItemReqCTA"),
        colorOrFinish: (_colorOrFinish = authorData.colorOrFinish) !== null && _colorOrFinish !== void 0 ? _colorOrFinish : t("kf.pdp.label.colorOrFinish"),
        outOfStockMsg: authorData.outofStockDesc,
        outOfStock: (_outofStockTitle = authorData.outofStockTitle) !== null && _outofStockTitle !== void 0 ? _outofStockTitle : t("kf.pdp.label.outOfStockMsg"),
        notifyMailCTA: t("kf.pdp.label.notifyMailCTA"),
        emailAddress: t("kf.pdp.label.emailAddress"),
        validEmail: t("kf.pdp.label.validEmail"),
        welcomeMsg: (_welcomeMsg = authorData.welcomeMsg) !== null && _welcomeMsg !== void 0 ? _welcomeMsg : t("kf.pdp.label.welcomeMsg"),
        discontinuedTxt: t("kf.pdp.label.discontinuedTxt"),
        compareTxt: t("kf.pdp.label.compareTxt"),
        favTxt: t("kf.pdp.label.favTxt"),
        projectTxt: t("kf.pdp.label.projectTxt"),
        findItemCTA: t("kf.pdp.label.findItemCTA"),
        availColorCTA: authorData.discontinuePartialCtaLabel ? authorData.discontinuePartialCtaLabel : t("kf.pdp.label.availColorCTA"),
        notifyEmailTxt: (_notifyEmailTxt = authorData.notifyEmailTxt) !== null && _notifyEmailTxt !== void 0 ? _notifyEmailTxt : t("kf.pdp.label.notifyEmailTxt"),
        findLocalStore: (_findLocalStore = authorData.findLocalStore) !== null && _findLocalStore !== void 0 ? _findLocalStore : t("kf.pdp.label.findLocalStore"),
        toCheckAvailability: t("kf.pdp.label.toCheckAvailability"),
        backOrder: (_backOrder = authorData.backOrder) !== null && _backOrder !== void 0 ? _backOrder : t("kf.pdp.label.backOrder"),
        specialOrder: (_specialOrder = authorData.specialOrder) !== null && _specialOrder !== void 0 ? _specialOrder : t("kf.pdp.label.specialOrder"),
        discontinuedColor: (_discontinueColorLabel = authorData.discontinueColorLabel) !== null && _discontinueColorLabel !== void 0 ? _discontinueColorLabel : t("kf.pdp.label.discontinuedColor"),
        discontinuedColorFinish: (_discontinueColorFinishLabel = authorData.discontinueColorFinishLabel) !== null && _discontinueColorFinishLabel !== void 0 ? _discontinueColorFinishLabel : t("kf.pdp.label.discontinuedColorFinish"),
        toolTip: t("kf.pdp.label.toolTip"),
        requiredProductTitle: (_modalRightSectionTitle = authorData.modalRightSectionTitle) !== null && _modalRightSectionTitle !== void 0 ? _modalRightSectionTitle : t("kf.pdp.label.requiredProductTitle"),
        cadRequiredProductTitle: (_modalRightSectionTitle1 = authorData.modalRightSectionTitle) !== null && _modalRightSectionTitle1 !== void 0 ? _modalRightSectionTitle1 : t("kf.pdp.label.cadRequiredProductTitle"),
        requiredProductDescription: (_modalRightSectionDesc = authorData.modalRightSectionDesc) !== null && _modalRightSectionDesc !== void 0 ? _modalRightSectionDesc : t("kf.pdp.label.requiredProductDescription"),
        cadRequiredProductDescription: (_modalRightSectionDesc1 = authorData.modalRightSectionDesc) !== null && _modalRightSectionDesc1 !== void 0 ? _modalRightSectionDesc1 : t("kf.pdp.label.cadRequiredProductDescription"),
        productText: t("kf.pdp.label.productText"),
        includesText: t("kf.pdp.label.includesText"),
        updateText: t("kf.pdp.label.updateText"),
        includeTextCTA: (_modalRighttSectionCtaLabel = authorData.modalRighttSectionCtaLabel) !== null && _modalRighttSectionCtaLabel !== void 0 ? _modalRighttSectionCtaLabel : t("kf.pdp.label.includeTextCTA"),
        title: (_modalLeftSectionTitle = authorData.modalLeftSectionTitle) !== null && _modalLeftSectionTitle !== void 0 ? _modalLeftSectionTitle : t("kf.pdp.label.title"),
        remove: t("kf.pdp.label.remove"),
        tooltipMsg: (_onPdpTooltip = authorData.onPdpTooltip) !== null && _onPdpTooltip !== void 0 ? _onPdpTooltip : t("kf.pdp.label.tooltipMsg"),
        priceSpiderTitle: (_priceSpiderTitle = authorData.priceSpiderTitle) !== null && _priceSpiderTitle !== void 0 ? _priceSpiderTitle : t("kf.pdp.label.priceSpiderTitle"),
        primaryTxt: (_oversizeMsgTitle = authorData.oversizeMsgTitle) !== null && _oversizeMsgTitle !== void 0 ? _oversizeMsgTitle : t("kf.pdp.label.alert.primaryMsg"),
        secondaryTxt: (_oversizeMsgDesc = authorData.oversizeMsgDesc) !== null && _oversizeMsgDesc !== void 0 ? _oversizeMsgDesc : t("kf.pdp.label.alert.secondaryMsg"),
        withoutPriceTxt: (_noPriceMsg = authorData.noPriceMsg) !== null && _noPriceMsg !== void 0 ? _noPriceMsg : t("kf.pdp.label.withoutPriceTxt"),
        projectPackMssg: authorData.projectPackMssg ? authorData.projectPackMssg : t("kf.pdp.label.projectPackMssg"),
        qtyMoreThanStock: t("kf.pdp.label.qtyMoreThanStock"),
        associatePrice: t("kf.pdp.label.associatePrice"),
        friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
        listPriceInfo: (_listpricetooltip = authorData.listpricetooltip) !== null && _listpricetooltip !== void 0 ? _listpricetooltip : t("kf.pdp.label.listPriceInfo"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        installationTitle: t("kf.pdp.label.installationTitle"),
        nearestService: (_subCopy = authorData.subCopy) !== null && _subCopy !== void 0 ? _subCopy : t("kf.pdp.label.nearestService"),
        nearestInPerson: (_subCopy1 = authorData.subCopy) !== null && _subCopy1 !== void 0 ? _subCopy1 : t("kf.pdp.label.nearestInPerson"),
        edit: t("kf.pdp.label.edit"),
        change: t("kf.pdp.label.change"),
        eligibleZipCodeSuccess: (_serviceavailable = authorData.serviceavailable) !== null && _serviceavailable !== void 0 ? _serviceavailable : t("kf.pdp.label.eligibleZipCodeSuccess"),
        eligibleZipCodeError: (_errorMessage = authorData.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : t("kf.pdp.label.eligibleZipCodeError"),
        findaPro: t("kf.pdp.label.findaPro"),
        zipcode: t("kf.pdp.label.zipcode"),
        checkAvailability: t("kf.pdp.label.checkAvailability"),
        zipCodeGuidText: t("kf.pdp.label.zipCodeGuidText"),
        update: t("kf.pdp.label.updateBtn"),
        search: t("kf.pdp.label.searchBtn"),
        forText: t("kf.pdp.label.forText"),
        memberShipPrice: t("kf.pdp.label.memberShipPrice"),
        bathroomDesignService: t("kf.pdp.label.bathroomDesignService"),
        maxInventory: t("kf.pdp.label.maxInventory"),
        zipcodeEmptyError: (_zipcodevalidationmessage = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage !== void 0 ? _zipcodevalidationmessage : t("kf.pdp.label.zipcodeEmptyError"),
        validZipcode: (_zipcodevalidationmessage1 = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage1 !== void 0 ? _zipcodevalidationmessage1 : t("kf.pdp.label.validZipcode"),
        percentOff: t("kf.pdp.label.percentOff"),
        serviceItemAdded: t("kf.pdp.label.serviceItemAdded"),
        serviceItemsAdded: t("kf.pdp.label.serviceItemsAdded"),
        serviceParts: t("kf.technical.label.serviceParts"),
        servicePartsLabel: t("kf.pdp.label.aria.serviceParts"),
        outOfStockError: authorData.invalidEmailMessage ? authorData.invalidEmailMessage : t("kf.pdp.error.outOfStock"),
        successTxt: t("kf.pdp.outOfStock.successTxt"),
        successMsg: authorData.outofStockConfirmMsg ? authorData.outofStockConfirmMsg : t("kf.pdp.outOfStock.thankMsg"),
        doneCTA: t("kf.pdp.outOfStock.doneCTA"),
        new: (_new = badgeText.new) !== null && _new !== void 0 ? _new : t("kf.plp.label.new"),
        sale: (_onSale = badgeText.onSale) !== null && _onSale !== void 0 ? _onSale : t("kf.plp.label.onSale"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        discontinued: badgeText.discontinued ? badgeText.discontinued : t("kf.plp.label.discontinued"),
        shippingTitle: (_shippingTitle = authorData.shippingTitle) !== null && _shippingTitle !== void 0 ? _shippingTitle : t("kf.pdp.label.alert.shippingRestrictions"),
        shippingDescription: (_shippingDescription = authorData.shippingDescription) !== null && _shippingDescription !== void 0 ? _shippingDescription : t("kf.pdp.label.alert.shippingRestrictionsDesc"),
        ariaLabel: {
            serviceAddToCart: t("kf.pdp.aria.label.addServiceToCart"),
            serviceLearnMore: t("kf.pdp.aria.label.serviceLearnMore"),
            designServiceAddToCart: t("kf.pdp.aria.label.addDesignServiceToCart"),
            designServiceLearnMore: t("kf.pdp.aria.label.designServiceLearnMore"),
            closeZoomImageModel: t("kf.pdp.aria.label.closeZoomImageModel"),
            addProductToCart: (productName)=>t("kf.pdp.aria.label.addProductToCart", {
                    productName
                }),
            addProductService: t("kf.pdp.aria.label.addProductService", {
                name
            }),
            print: t("kf.pdp.label.aria.print", {
                productName: name
            }),
            share: t("kf.pdp.label.aria.share", {
                productName: name
            }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        outOfStockErr: (_modalRightSectionNoStockMsg = authorData.modalRightSectionNoStockMsg) !== null && _modalRightSectionNoStockMsg !== void 0 ? _modalRightSectionNoStockMsg : t("kf.pdp.label.reqItem.err.outOfStockErrMsg"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        backInStock: t("kf.pdp.label.backInStock"),
        notApplicable: t("kf.pdp.label.notApplicable"),
        partNumber: t("kf.pdp.label.partNumber"),
        partName: t("kf.pdp.label.partName"),
        descReadMore: t("kf.pdp.label.descReadMore"),
        productAccordionText: {
            features: t("kf.pdp.label.features"),
            dimensions: t("kf.pdp.label.dimensions"),
            specs: t("kf.pdp.label.specs"),
            addOnServices: t("kf.pdp.label.addOnServices"),
            technologies: t("kf.pdp.label.technology"),
            productDetails: t("kf.pdp.label.productDetails"),
            material: t("kf.pdp.label.material"),
            installation: t("kf.pdp.label.installation"),
            hydrotherapy: t("kf.pdp.label.hydrotherapy"),
            rebates: t("kf.pdp.label.rebates"),
            props65Warning: t("kf.pdp.label.props65Warning"),
            selectAll: t("kf.technical.label.selectAll"),
            download: t("kf.technical.label.download"),
            installationSupport: t("kf.pdp.label.installationSupport"),
            designFiles: t("kf.technical.label.designFiles"),
            technicalInfo: t("kf.technical.label.technicalInfo"),
            file: t("kf.technical.label.file"),
            files: t("kf.technical.label.files"),
            specsSheet: t("kf.technical.label.specsSheet"),
            guides: t("kf.technical.label.guides"),
            installVideo: t("kf.technical.label.installVideo"),
            helpfulLinks: authorData.sectionHeading ? authorData.sectionHeading : t("kf.technical.label.helpfulLinks"),
            envDeclaration: t("kf.technical.label.envDeclaration"),
            installationGuide: t("kf.technical.label.installationGuide"),
            installationVideo: t("kf.technical.label.installationVideo"),
            userGuide: t("kf.technical.label.userGuide"),
            homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
            homeOwnerGuideWithoutSPPDF: t("kf.technical.label.homeOwnerGuideWithoutSPPDF"),
            declareLabel: t("kf.technical.label.declareLabel"),
            tearSheet: t("kf.technical.label.tearSheet"),
            quickReference: t("kf.technical.label.quickReference"),
            warranty: t("kf.technical.label.warranty"),
            serviceParts: t("kf.technical.label.serviceParts"),
            twoDplan: t("kf.technical.label.twoDplan"),
            twoDside: t("kf.technical.label.twoDside"),
            twoDfront: t("kf.technical.label.twoDfront"),
            threeDfile: t("kf.technical.label.threeDfile"),
            bimFile: t("kf.technical.label.bimFile"),
            cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
            partsDiagram: t("kf.pdp.label.partsDiagram"),
            installationGuidesSubTitle: t("kf.technical.label.installationGuidesSubTitle"),
            supportSubTitle: t("kf.technical.label.supportSubTitle"),
            icon: t("kf.technical.label.icon"),
            pdf: t("kf.literature.aria.label.pdf"),
            video: t("kf.technical.label.video"),
            viewMore: t("kf.pdp.label.viewMore")
        },
        baseProduct: t("kf.pdp.label.baseProduct"),
        subTotal: t("kf.pdp.label.subTotal"),
        requiredItems: t("kf.pdp.label.requiredItems"),
        requiredItemsProduct: t("kf.pdp.label.productRequiredItem"),
        requiredItemsPrice: t("kf.pdp.label.priceRequiredItem"),
        zipCodes: t("kf.pdp.lable.zipcode"),
        ingredientsLabel: authorData.ingredientsLabel,
        saveToListText: t("kf.saveToList.save.header"),
        savedToListText: t("kf.saveToList.action.saved"),
        currentPriceAriaLabel: t("kf.pdp.label.currentPrice"),
        deleteFromListText: t("kf.myList.page.pdp.deletefromList"),
        configuratorTitle: configuratorTitle,
        configuratorDesc: configuratorDesc,
        configuratorButtonLabel: configuratorButtonLabel,
        configuratorErrorTitle: configuratorErrorTitle,
        configuratorErrorDesc: configuratorErrorDesc,
        configuratorErrorButtonLabel: configuratorErrorButtonLabel
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePdpi18n);


/***/ }),

/***/ 81294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const useSearchi18n = (param)=>{
    let { componentProp  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        searchPlaceHolder: t("kf.technical.label.searchPlaceHolder"),
        for: t("kf.search.label.for"),
        searchInstead: t("kf.search.label.searchInstead"),
        showing: t("kf.search.label.showing"),
        results: t("kf.search.label.results"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        addToCart: t("kf.compare.label.addToCart"),
        products: t("kf.search.label.products"),
        parts: t("kf.search.label.parts"),
        technical: t("kf.search.label.technical"),
        inspiration: t("kf.search.label.inspiration"),
        resource: t("kf.search.label.resource"),
        help: t("kf.search.label.help"),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        applyFilters: "Apply Filters",
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        bestSellers: t("kf.plp.label.bestSellers"),
        featured: t("kf.plp.label.featured"),
        onSale: t("kf.plp.label.onSale"),
        relevancy: t("kf.plp.label.relevancy"),
        date: t("kf.plp.label.date"),
        priceDesc: t("kf.plp.label.priceDesc"),
        priceAsc: t("kf.plp.label.priceAsc"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        new: t("kf.plp.label.new"),
        sale: t("kf.plp.label.sale"),
        category: t("kf.technical.label.category"),
        collection: t("kf.technical.label.collection"),
        certifications: t("kf.technical.label.certifications"),
        designFiles: t("kf.technical.label.designFiles"),
        technicalInfo: t("kf.pdp.label.specs"),
        installationSupport: t("kf.pdp.label.installationSupport"),
        addToFolder: t("kf.technical.label.addToFolder"),
        selectAll: t("kf.technical.label.selectAll"),
        download: t("kf.technical.label.download"),
        hideDiscontinued: t("kf.plp.label.hideDiscontinued"),
        file: t("kf.technical.label.file"),
        files: t("kf.technical.label.files"),
        specsSheet: t("kf.technical.label.specsSheet"),
        envDeclaration: t("kf.technical.label.envDeclaration"),
        installationGuide: t("kf.technical.label.installationGuide"),
        userGuide: t("kf.technical.label.userGuide"),
        homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
        declareLabel: t("kf.technical.label.declareLabel"),
        tearSheet: t("kf.technical.label.tearSheet"),
        quickReference: t("kf.technical.label.quickReference"),
        warranty: t("kf.technical.label.warranty"),
        serviceParts: t("kf.technical.label.serviceParts"),
        suggestions: t("kf.search.label.suggestions"),
        checkSpelling: t("kf.search.label.checkSpelling"),
        simplerWord: t("kf.search.label.simplerWord"),
        searchSimilar: t("kf.search.label.searchSimilar"),
        popularSearch: t("kf.search.label.trendingSearch"),
        commonTopics: t("kf.search.label.commonTopics"),
        noResults: t("kf.search.label.noResults"),
        noResultsSuggest: t("kf.search.label.noResultsSuggest"),
        loading: t("kf.search.label.loading"),
        twoDplan: t("kf.technical.label.twoDplan"),
        twoDside: t("kf.technical.label.twoDside"),
        twoDfront: t("kf.technical.label.twoDfront"),
        threeDfile: t("kf.technical.label.threeDfile"),
        bimFile: t("kf.technical.label.bimFile"),
        cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
        viewResults: t("kf.plp.label.viewResults"),
        popularSearchText: t("kf.search.label.trendingSearch"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        searchBrand: t("kf.search.label.searchBrand"),
        brand: t("kf.search.label.brand"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        discontinuedText: t("kf.pdp.label.discontinuedTxt"),
        partsDiagram: t("kf.pdp.label.partsDiagram"),
        guides: t("kf.technical.label.guides"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            tabs: (count, tabName)=>t("kf.search.aria.label.tabs", {
                    count,
                    tabName
                }),
            loadMore: t("kf.search.aria.label.loadMore"),
            loadMoreArticles: t("kf.search.aria.label.loadMoreArticles"),
            close: t("kf.search.aria.label.clear"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        home: t("kf.technical.label.home"),
        searchResults: t("kf.technical.label.searchResults"),
        searchText: t("kf.search.label.searchText"),
        searchNoResultErrorMessage: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg : t("kf.search.label.noResultsMssg"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: t("kf.plp.label.aria.print"),
        ariaLabelShare: t("kf.plp.label.aria.share"),
        favorites: t("kf.account.label.favorites"),
        removeItem: t("kf.favorites.removeItem"),
        downloadSuccess: t("kf.PressRoom.label.downloadSuccess"),
        downloadFailure: t("kf.PressRoom.label.downloadFailure")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchi18n);


/***/ }),

/***/ 30696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PW": function() { return /* binding */ getQuantityCount; },
/* harmony export */   "Y4": function() { return /* binding */ validateCountryCode; },
/* harmony export */   "a$": function() { return /* binding */ validatePhone; },
/* harmony export */   "in": function() { return /* binding */ convertToPhoneNumber; },
/* harmony export */   "ix": function() { return /* binding */ validateUSPhone; },
/* harmony export */   "kD": function() { return /* binding */ getAttributeValue; },
/* harmony export */   "o8": function() { return /* binding */ convertToUSPhoneNumber; },
/* harmony export */   "oO": function() { return /* binding */ sanitizeText; },
/* harmony export */   "pD": function() { return /* binding */ getCountryName; },
/* harmony export */   "qs": function() { return /* binding */ getStateName; }
/* harmony export */ });
/* unused harmony exports sanitizeDOMString, normalizeUSPhoneNumber, checkStock, getStateCode, getCountryCode, validateEmail */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27856);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49139);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88032);





const sanitizeText = (text)=>text.replace(/<\/?[^>]+(>|$)/g, "");
const checkStock = (backOrder, category)=>{
    if (!category) return false;
    if (backOrder === true || backOrder === "Yes") return false;
    if (category === "Install Services") return false;
    if (category === "Design Services") return false;
    return true;
};
const getQuantityCount = (data)=>{
    var ref;
    const totalCount = (ref = data === null || data === void 0 ? void 0 : data.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    })) === null || ref === void 0 ? void 0 : ref.reduce(function(accumulator, item) {
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const sanitizeDOMString = (property)=>typeof property === "string" ? DOMPurify.sanitize(property) : property;
const getStateCode = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.code === countryVal)) {
        country = data.find((obj)=>obj.code === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.name === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.code === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.name === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _code;
    return (_code = state.code) !== null && _code !== void 0 ? _code : "";
};
const getCountryCode = (countryVal, data)=>{
    if (data.find((obj)=>obj.code === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.name === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _code;
    return (_code = country.code) !== null && _code !== void 0 ? _code : "";
};
const getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};
const getCountryName = (countryVal, data)=>{
    if (data.find((obj)=>obj.name === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.code === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _name;
    return (_name = country.name) !== null && _name !== void 0 ? _name : "";
};
const convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            return !x[2] ? "(" + x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const validateEmail = (email)=>{
    if (CONSTANTS.REGEX_EMAIL.test(email)) return true;
    return false;
};
const validatePhone = (phone)=>{
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    if (/^\d+$/.test(phone) && phone.length > 9) return true;
    return false;
};
const validateCountryCode = (phone)=>{
    phone = phone.replace(/[()\s-]/g, "");
    if (phone.startsWith("1")) return true;
    return false;
};
/**
 * Normalizes a US phone number by:
 * 1. Removing all non-numeric characters
 * 2. Stripping leading "1" if present (country code)
 * 3. Returning 10-digit number or original if invalid
 *
 * @param {string} phone - Raw phone input
 * @return {string} - Normalized 10-digit number (or original if can't normalize)
 */ const normalizeUSPhoneNumber = function() {
    let phone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!phone) return "";
    const digitsOnly = phone.replaceAll(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .NON_DIGIT_REGEX */ .gP, "");
    if (digitsOnly.length >= 10 && digitsOnly.startsWith("1")) {
        return digitsOnly.substring(1);
    }
    return digitsOnly;
};
/**
 * Validates US phone number against NANP rules:
 * - Must be exactly 10 digits
 * - Area code (NPA) first digit must be 2-9
 * - Exchange (NXX) first digit must be 2-9
 *
 * @param {string} phone - Phone number to validate
 * @return {boolean} - True if valid US/NANP number
 */ const validateUSPhone = function() {
    let phone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const { generic: { globalConfig: { regexPattern: { map: { phoneNANP =""  } = {}  } = {}  } = {}  } = {}  } = (_store_index__WEBPACK_IMPORTED_MODULE_4__/* .store */ .h === null || _store_index__WEBPACK_IMPORTED_MODULE_4__/* .store */ .h === void 0 ? void 0 : _store_index__WEBPACK_IMPORTED_MODULE_4__/* .store.getState */ .h.getState()) || {};
    const normalized = normalizeUSPhoneNumber(phone);
    const phoneNANPRegex = new RegExp(phoneNANP);
    return phoneNANPRegex.test(normalized);
};
const convertToUSPhoneNumber = (text)=>{
    try {
        if (!text) return "";
        const normalized = normalizeUSPhoneNumber(text);
        if (normalized.length > 10) {
            return normalized;
        }
        const match = normalized.match(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .PHONE_DISPLAY_REGEX */ .Nw);
        if (!match) return "";
        const [, area, exchange, subscriber] = match;
        if (!area) return "";
        if (!exchange) return "(".concat(area);
        if (!subscriber) return "(".concat(area, ") ").concat(exchange);
        return "(".concat(area, ") ").concat(exchange, "-").concat(subscriber);
    } catch (error) {
        console.error("convertToUSPhoneNumber error:", error);
        return text;
    }
};
const getAttributeValue = (attributes, name)=>lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === name), "value", "");



/***/ }),

/***/ 91463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

const HttpBackend = __webpack_require__(78122);
const ChainedBackend = (__webpack_require__(81580)/* ["default"] */ .Z);
const LocalStorageBackend = (__webpack_require__(70660)/* ["default"] */ .Z);
module.exports = {
    backend: {
        backendOptions: [
            {
                expirationTime: 60 * 60 * 1000
            },
            {
                // need to revisit this block to load dictionaryPath from global config -  currently not possible due to incompatability with cjs modules. need to redefine imports and exports in future
                loadPath: async function(lng, ns) {
                    const dictionaryPath = "/content/kohler.i18nDictionary.json";
                    return "/api/locales/".concat(lng, "/").concat(ns, ".json?path=").concat(dictionaryPath);
                }
            }
        ],
        backends:  true ? [
            LocalStorageBackend,
            HttpBackend
        ] : 0
    },
    i18n: {
        locales: [
            "default",
            "en",
            "fr"
        ],
        defaultLocale: "default"
    },
    ns: [
        "common"
    ],
    serializeConfig: false,
    use:  true ? [
        ChainedBackend
    ] : 0
};


/***/ }),

/***/ 10227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        const normalizeLocalePath = (__webpack_require__(72554).normalizeLocalePath);
        const detectDomainLocale = (__webpack_require__(84643).detectDomainLocale);
        const target = locale || normalizeLocalePath(path, locales).detectedLocale;
        const domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            const proto = "http".concat(domain.http ? "" : "s", "://");
            const finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 19749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ImageLoaderProps", ({
    enumerable: true,
    get: function() {
        return _imageConfig.ImageLoaderProps;
    }
}));
exports["default"] = Image;
var _extends = (__webpack_require__(31032)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(99402)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(38774)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(83121));
var _imageBlurSvg = __webpack_require__(2675);
var _imageConfig = __webpack_require__(10139);
var _imageConfigContext = __webpack_require__(28730);
var _warnOnce = __webpack_require__(57238);
var _imageLoader = _interop_require_default(__webpack_require__(89824));
function Image(_param) {
    var { src , sizes , unoptimized =false , priority =false , loading , className , quality , width , height , fill , style , onLoad , onLoadingComplete , placeholder ="empty" , blurDataURL , layout , objectFit , objectPosition , lazyBoundary , lazyRoot  } = _param, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoad",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL",
        "layout",
        "objectFit",
        "objectPosition",
        "lazyBoundary",
        "lazyRoot"
    ]);
    const configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    const config = (0, _react).useMemo(()=>{
        const c = configEnv || configContext || _imageConfig.imageConfigDefault;
        const allSizes = [
            ...c.deviceSizes,
            ...c.imageSizes
        ].sort((a, b)=>a - b);
        const deviceSizes = c.deviceSizes.sort((a, b)=>a - b);
        return _extends({}, c, {
            allSizes,
            deviceSizes
        });
    }, [
        configContext
    ]);
    let rest = all;
    let loader = rest.loader || _imageLoader.default;
    // Remove property so it's not spread on <img> element
    delete rest.loader;
    if ("__next_img_default" in loader) {
        // This special value indicates that the user
        // didn't define a "loader" prop or config.
        if (config.loader === "custom") {
            throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
        }
    } else {
        // The user defined a "loader" prop or config.
        // Since the config object is internal only, we
        // must not pass it to the user-defined "loader".
        const customImageLoader = loader;
        var _tmp;
        _tmp = (obj)=>{
            const { config: _  } = obj, opts = _object_without_properties_loose(obj, [
                "config"
            ]);
            return customImageLoader(opts);
        }, loader = _tmp, _tmp;
    }
    if (layout) {
        if (layout === "fill") {
            fill = true;
        }
        const layoutToStyle = {
            intrinsic: {
                maxWidth: "100%",
                height: "auto"
            },
            responsive: {
                width: "100%",
                height: "auto"
            }
        };
        const layoutToSizes = {
            responsive: "100vw",
            fill: "100vw"
        };
        const layoutStyle = layoutToStyle[layout];
        if (layoutStyle) {
            style = _extends({}, style, layoutStyle);
        }
        const layoutSizes = layoutToSizes[layout];
        if (layoutSizes && !sizes) {
            sizes = layoutSizes;
        }
    }
    let staticSrc = "";
    let widthInt = getInt(width);
    let heightInt = getInt(height);
    let blurWidth;
    let blurHeight;
    if (isStaticImport(src)) {
        const staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                const ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                const ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    let isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    const [blurComplete, setBlurComplete] = (0, _react).useState(false);
    const [showAltText, setShowAltText] = (0, _react).useState(false);
    const qualityInt = getInt(quality);
    if (false) {}
    const imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        objectFit,
        objectPosition
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    const blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt,
            heightInt,
            blurWidth,
            blurHeight,
            blurDataURL
        }), '")')
    } : {};
    if (false) {}
    const imgAttributes = generateImgAttrs({
        config,
        src,
        unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes,
        loader
    });
    let srcString = src;
    if (false) {}
    const linkProps = {
        // @ts-expect-error upgrade react types to react 18
        imageSrcSet: imgAttributes.srcSet,
        imageSizes: imgAttributes.sizes,
        crossOrigin: rest.crossOrigin
    };
    const onLoadRef = (0, _react).useRef(onLoad);
    (0, _react).useEffect(()=>{
        onLoadRef.current = onLoad;
    }, [
        onLoad
    ]);
    const onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(()=>{
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    const imgElementArgs = _extends({
        isLazy,
        imgAttributes,
        heightInt,
        widthInt,
        qualityInt,
        className,
        imgStyle,
        blurStyle,
        loading,
        config,
        fill,
        unoptimized,
        placeholder,
        loader,
        srcString,
        onLoadRef,
        onLoadingCompleteRef,
        setBlurComplete,
        setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"use client";
const configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
const allImgs = new Map();
let perfObserver;
if (false) {}
const VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    let { deviceSizes , allSizes  } = param;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        const viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        const percentSizes = [];
        for(let match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            const smallestRatio = Math.min(...percentSizes) * 0.01;
            return {
                widths: allSizes.filter((s)=>s >= deviceSizes[0] * smallestRatio),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2 /*, width * 3*/ 
        ].map((w)=>allSizes.find((p)=>p >= w) || allSizes[allSizes.length - 1]))
    ];
    return {
        widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    let { config , src , unoptimized , width , quality , sizes , loader  } = param;
    if (unoptimized) {
        return {
            src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    const { widths , kind  } = getWidths(config, width, sizes);
    const last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map((w, i)=>"".concat(loader({
                config,
                src,
                quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind)).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config,
            src,
            quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(()=>{}).then(()=>{
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadRef == null ? void 0 : onLoadRef.current) {
            // Since we don't have the SyntheticEvent here,
            // we must create one with the same shape.
            // See https://reactjs.org/docs/events.html
            const event = new Event("load");
            Object.defineProperty(event, "target", {
                writable: false,
                value: img
            });
            let prevented = false;
            let stopped = false;
            onLoadRef.current(_extends({}, event, {
                nativeEvent: event,
                currentTarget: img,
                target: img,
                isDefaultPrevented: ()=>prevented,
                isPropagationStopped: ()=>stopped,
                persist: ()=>{},
                preventDefault: ()=>{
                    prevented = true;
                    event.preventDefault();
                },
                stopPropagation: ()=>{
                    stopped = true;
                    event.stopPropagation();
                }
            }));
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) {}
    });
}
const ImageElement = (_param)=>{
    var { imgAttributes , heightInt , widthInt , qualityInt , className , imgStyle , blurStyle , isLazy , fill , placeholder , loading , srcString , config , unoptimized , loader , onLoadRef , onLoadingCompleteRef , setBlurComplete , setShowAltText , onLoad , onError  } = _param, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadRef",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": fill ? "fill" : "1",
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback((img)=>{
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
            }
        }, [
            srcString,
            placeholder,
            onLoadRef,
            onLoadingCompleteRef,
            setBlurComplete,
            onError,
            unoptimized
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
        },
        onError: (event)=>{
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 31551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(38774)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(41003);
var _addLocale = __webpack_require__(54465);
var _routerContext = __webpack_require__(72692);
var _appRouterContext = __webpack_require__(48245);
var _useIntersection = __webpack_require__(69246);
var _getDomainLocale = __webpack_require__(10227);
var _addBasePath = __webpack_require__(33468);
"use client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            // Apply `as` if it's provided.
            router[method](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 72554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
const normalizeLocalePath = (pathname, locales)=>{
    if (true) {
        return (__webpack_require__(24769).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 69246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(44686);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 48245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
"use client";
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(31032)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 2675:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    let { widthInt , heightInt , blurWidth , blurHeight , blurDataURL  } = param;
    const std = blurWidth && blurHeight ? "1" : "20";
    const svgWidth = blurWidth || widthInt;
    const svgHeight = blurHeight || heightInt;
    const feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    if (svgWidth && svgHeight) {
        return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage preserveAspectRatio='none' filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
    }
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg'%3E%3Cimage style='filter:blur(20px)' x='0' y='0' height='100%25' width='100%25' href='".concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 89824:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
function defaultLoader(param) {
    let { config , src , width , quality  } = param;
    if (false) {}
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
// We use this to determine if the import is the default loader
// or a custom loader defined by the user in next.config.js
defaultLoader.__next_img_default = true;
var _default = defaultLoader;
exports["default"] = _default; //# sourceMappingURL=image-loader.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(31032)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(99402)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 82470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(34155);
__webpack_require__(2350);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 51857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(82470).style;


/***/ }),

/***/ 12806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/integration/react.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // eslint-disable-line import/no-unresolved

var PersistGate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      bootstrapped: false
    });

    _defineProperty(_assertThisInitialized(_this), "_unsubscribe", void 0);

    _defineProperty(_assertThisInitialized(_this), "handlePersistorState", function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).finally(function () {
            return _this.setState({
              bootstrapped: true
            });
          });
        } else {
          _this.setState({
            bootstrapped: true
          });
        }

        _this._unsubscribe && _this._unsubscribe();
      }
    });

    return _this;
  }

  _createClass(PersistGate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      if (false) {}

      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(react.PureComponent);

_defineProperty(PersistGate, "defaultProps", {
  children: null,
  loading: null
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./utils/appInsights.js + 120 modules
var appInsights = __webpack_require__(55954);
// EXTERNAL MODULE: ./utils/logger/client.js
var client = __webpack_require__(61372);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./services/auth.service.js + 170 modules
var auth_service = __webpack_require__(25696);
// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./next-i18next.config.js
var next_i18next_config = __webpack_require__(91463);
var next_i18next_config_default = /*#__PURE__*/__webpack_require__.n(next_i18next_config);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./components/Shared/ErrorBoundary/ErrorPage.jsx
var ErrorPage = __webpack_require__(42346);
;// CONCATENATED MODULE: ./components/Shared/ErrorBoundary/index.jsx




/**
 * Class declaration for handling frontend errors
 */ class ErrorBoundary extends react.Component {
    /**
   *
   * @param {*} error
   * @return {boolean}
   */ static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    /**
   *
   * @param {*} error
   * @param {*} errorInfo
   */ componentDidCatch(error, errorInfo) {
        // You can use your own error logging service here
        const logger = (0,client/* createContextLogger */.lK)("ErrorBoundary");
        logger.error("Uncaught error:", {
            error,
            errorInfo
        });
    }
    /**
   *
   * @return {JSX.Element}
   */ render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage["default"], {});
        }
        return this.props.children;
    }
    /**
   *
   * @param {*} props
   */ constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
/* harmony default export */ var Shared_ErrorBoundary = (ErrorBoundary);

;// CONCATENATED MODULE: ./components/Shared/Layout.jsx

const Layout = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                props.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-backdrop fade show"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var Shared_Layout = (Layout);

;// CONCATENATED MODULE: ./utils/web-vitals-helper.js


const getUserAgentDeviceType = ()=>{
    const uad = navigator.userAgentData;
    if (!uad) return null // fall back below if null
    ;
    // uad.mobile -> true on phones (Chromium); platform -> "Android", "Windows", "Chrome OS", etc.
    const isMobile = !!uad.mobile;
    const platform = uad.platform || "unknown";
    return {
        isMobile,
        platform
    };
};
const getWebVitalRating = function() {
    let metric = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { name ="" , value =0  } = metric;
    const limits = constants.METRIC_THRESHOLDS[name];
    if (!limits) return "unknown";
    const [goodLimit, needsImprovementLimit] = limits;
    if (value <= goodLimit) return "good";
    if (value <= needsImprovementLimit) return "needs-improvement";
    return "poor";
};
const trackWebVital = function() {
    let metric = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { location: { href: url = "" , pathname =""  } = {}  } = window;
    const rating = getWebVitalRating(metric);
    const appInsightsInst = (0,appInsights.getAppInsights)();
    if (!appInsightsInst) return;
    const deviceType = getUserAgentDeviceType();
    const webVitalsInfo = {
        ...metric,
        rating,
        url,
        path: pathname,
        navigationType: ((ref = performance.getEntriesByType("navigation")[0]) === null || ref === void 0 ? void 0 : ref.type) || "navigate",
        deviceType
    };
    appInsightsInst.trackMetric({
        name: "Web Vitals - ".concat(metric.name),
        average: metric.value,
        properties: {
            ...webVitalsInfo
        }
    });
};


// EXTERNAL MODULE: ./styles/index.scss
var styles = __webpack_require__(63911);
// EXTERNAL MODULE: ./styles/index_main.scss
var index_main = __webpack_require__(93054);
// EXTERNAL MODULE: ./styles/clientlib-site.min.css
var clientlib_site_min = __webpack_require__(34571);
// EXTERNAL MODULE: ./styles/clientlib-base.min.css
var clientlib_base_min = __webpack_require__(28380);
// EXTERNAL MODULE: ./styles/overrides.scss
var overrides = __webpack_require__(81076);
// EXTERNAL MODULE: ./styles/aci-payment-logos.min.css
var aci_payment_logos_min = __webpack_require__(77954);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
;// CONCATENATED MODULE: ./pages/_app.jsx
/* eslint-disable new-cap */ 


































const AuthModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(361), __webpack_require__.e(234), __webpack_require__.e(1447)]).then(__webpack_require__.bind(__webpack_require__, 31447)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31447)
            ]
    },
    ssr: false
});
const CartActionModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7409).then(__webpack_require__.bind(__webpack_require__, 27409)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27409)
            ]
    },
    ssr: false
});
const NewsLetterSignUpOverlay = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9730).then(__webpack_require__.bind(__webpack_require__, 69730)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69730)
            ]
    },
    ssr: false
});
const CompareProducts = dynamic_default()(()=> true ? __webpack_require__.e(/* import() */ 4310).then(__webpack_require__.bind(__webpack_require__, 75405)) : 0, {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(null /* weak dependency, without id */)
            ]
    },
    ssr: false
});
const PromoModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1636).then(__webpack_require__.bind(__webpack_require__, 41636)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(41636)
            ]
    },
    ssr: false
});
const Toaster = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2182).then(__webpack_require__.bind(__webpack_require__, 2025)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2025)
            ]
    },
    ssr: false
});
const PreviewCart = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3369).then(__webpack_require__.bind(__webpack_require__, 73369)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73369)
            ]
    },
    ssr: false
});







if (false) {}
const MyApp = store/* wrapper.withRedux */.YS.withRedux((param)=>{
    let { Component , pageProps , featureFlags  } = param;
    var ref, ref1, ref2, ref3;
    const store = (0,es/* useStore */.oR)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { isLoading =false , globalScripts , globalStyles , dataLayerObj , pageIsInteractive , toaster: { isVisible  } , menu: { isOpen  } , previewCart: { showPreview  } , newslettersignup , eventPageType , compareproducts , promoBannerModal , isProductInfo , isPreviewCartInit =false , gatedContentData  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const language = (0,esm/* useTranslation */.$G)();
    const { compare  } = router.query;
    const { comparedProducts  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const [showCompare, setShowCompare] = (0,react.useState)(false);
    const siteName = react.useRef("");
    const { authModal: { show  } = {} , showCartAction =false , isAuth =false , user ={}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { cart: cartObj  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [scriptsLoaded, setScriptsLoaded] = (0,react.useState)(0);
    const [showCampaign, setShowCampaign] = (0,react.useState)(false);
    const isRestricted = constants.EXCLUDE_PAGES.indexOf(router.pathname) >= 0;
    const [pageAlternateLinks] = (0,react.useState)( true ? "en-US:www.kohler.com/en,en-CA:www.kohler.ca/en,fr-CA:www.kohler.ca/fr,x-default:www.kohler.com".split(",").map((item)=>{
        var ref;
        const [lang = "", baseUrl = ""] = (ref = item === null || item === void 0 ? void 0 : item.split(":")) !== null && ref !== void 0 ? ref : [];
        return {
            lang,
            baseUrl
        };
    }) : 0);
    const userInteractionEvents = [
        "mouseover",
        "keydown",
        "touchmove",
        "touchstart",
        "scroll",
        "click"
    ];
    const loadScripts = ()=>{
        dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        (0,constants_config/* initConfig */.p)().then(async ()=>{
            var ref;
            const config = await (0,constants_config/* getConfig */.i)();
            var ref1;
            siteName.current = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            dispatch((0,genericSlice/* setGlobalConfig */.Qb)(config));
            await (0,auth_service/* initAuth */.Z5)(config);
        });
        getFeatureFlags();
        const loadScriptsTimer = setTimeout(loadScripts, 5000);
        const triggerScriptLoader = ()=>{
            loadScripts();
            clearTimeout(loadScriptsTimer);
            userInteractionEvents.forEach(function(event) {
                window.removeEventListener(event, triggerScriptLoader, {
                    passive: true
                });
            });
        };
        userInteractionEvents.forEach(function(event) {
            window.addEventListener(event, triggerScriptLoader, {
                passive: true
            });
        });
        concernBanner("add");
        // setTimeout(ontrustCookie(), 1000)
        if ( true && window.history && !window.__safeReplaceStateInstalled) {
            try {
                const originalReplaceState = window.history.replaceState.bind(window.history);
                let lastCallTs = 0;
                let lastUrl = "";
                let callCount = 0;
                let windowStartTs = Date.now();
                const WINDOW_MS = 10000 // 10 seconds
                ;
                const MAX_CALLS = 60 // Conservative limit for mobile Safari
                ;
                const THROTTLE_MS = 100 // Increased throttle for mobile
                ;
                let isMobileSafari = false;
                // Detect mobile Safari more reliably
                const userAgent = window.navigator.userAgent;
                isMobileSafari = /iPhone|iPad|iPod/.test(userAgent) && /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS/.test(userAgent);
                window.history.replaceState = function safeReplaceState(state, title, url) {
                    try {
                        const now = Date.now();
                        // reset count window
                        if (now - windowStartTs > WINDOW_MS) {
                            windowStartTs = now;
                            callCount = 0;
                        }
                        // Skip no-op updates (same URL string)
                        const nextUrl = typeof url === "string" ? url : "";
                        if (nextUrl && nextUrl === lastUrl) return;
                        // More aggressive throttling for mobile Safari
                        const throttleTime = isMobileSafari ? THROTTLE_MS * 2 : THROTTLE_MS;
                        if (now - lastCallTs < throttleTime) return;
                        // More conservative call limit for mobile Safari
                        const maxCalls = isMobileSafari ? MAX_CALLS / 2 : MAX_CALLS;
                        if (callCount >= maxCalls) {
                            // eslint-disable-next-line no-console
                            console.warn("Blocked history.replaceState: exceeded ".concat(maxCalls, " calls in ").concat(WINDOW_MS, "ms"));
                            return;
                        }
                        originalReplaceState(state, title, url);
                        lastCallTs = now;
                        lastUrl = nextUrl;
                        callCount += 1;
                    } catch (err) {
                        var ref;
                        // Swallow only SecurityError caused by WebKit rate limiting
                        if (err.name === "SecurityError" || ((ref = err.message) === null || ref === void 0 ? void 0 : ref.includes("replaceState"))) {
                            // eslint-disable-next-line no-console
                            console.warn("Blocked history.replaceState call due to rate limiting:", err.message);
                        } else {
                            // Re-throw non-rate-limiting errors
                            throw err;
                        }
                    }
                };
                // Also wrap pushState for consistency
                const originalPushState = window.history.pushState.bind(window.history);
                window.history.pushState = function safePushState(state, title, url) {
                    try {
                        const now = Date.now();
                        if (now - lastCallTs < THROTTLE_MS) return;
                        originalPushState(state, title, url);
                        lastCallTs = now;
                    } catch (err) {
                        var ref;
                        if (err.name === "SecurityError" || ((ref = err.message) === null || ref === void 0 ? void 0 : ref.includes("pushState"))) {
                            // eslint-disable-next-line no-console
                            console.warn("Blocked history.pushState call due to rate limiting:", err.message);
                        } else {
                            throw err;
                        }
                    }
                };
                Object.defineProperty(window, "__safeReplaceStateInstalled", {
                    value: true,
                    configurable: false
                });
                // Log installation for debugging
                // eslint-disable-next-line no-console
                console.log("Safe history wrapper installed (mobile Safari: ".concat(isMobileSafari, ")"));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Unable to install safe replaceState wrapper", e);
            }
        }
        // Initialize Application Insights with connection string
        if (true) {
            var ref4, ref5;
            const connectionString = "InstrumentationKey=fc0f8954-09c4-46f9-a834-f9981be012f3;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=95e45e7f-b1db-426a-b7af-23e661fc2e28";
            if (connectionString) {
                (0,appInsights.initAppInsights)(connectionString);
            } else {
                console.warn("Application Insights: Connection string not found in environment variables");
            }
            (ref4 = window.kohler) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.logger) === null || ref5 === void 0 ? void 0 : ref5.info("[KohlerLogger] Application Insights initialized");
        }
        var ref6;
        const authModalData = (ref6 = pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.footertmp) === null || ref === void 0 ? void 0 : (ref1 = ref[":items"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.root) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[":items"]) === null || ref3 === void 0 ? void 0 : ref3.authmodal) !== null && ref6 !== void 0 ? ref6 : {};
        dispatch((0,authSlice/* setAuthModalFormData */.id)(authModalData));
        window.adobeDataLayer = window.adobeDataLayer || [];
        document.body.addEventListener("keypress", helper/* handleEnter */.Bmk);
        (0,helper/* createPersonaCookie */.g45)();
        if (!utilityLocation) checkForLocation();
        // handle sign-in/sign-up using the hashed parameter
        const hashUrl = window.location.hash;
        if (constants.GATED_HASHES.includes(hashUrl.toLowerCase())) {
            let active = 0;
            if (hashUrl.includes("#signup") || hashUrl.includes("#createaccount")) active = 1;
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true,
                active
            }));
        }
        return ()=>{
            document.body.removeEventListener("keypress", helper/* handleEnter */.Bmk);
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(false));
            concernBanner("remove");
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(gatedContentData)) checkForGatedContentPaths();
    }, [
        gatedContentData
    ]);
    const checkForGatedContentPaths = ()=>{
        if (window) {
            var ref;
            const path = (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname;
            const { gatedContentPathsParameters =[]  } = gatedContentData;
            if (gatedContentPathsParameters.length) {
                var ref1;
                const matchedGatedContent = (ref1 = gatedContentPathsParameters.find((item)=>{
                    const { gatedURL =""  } = item;
                    const securedPath = gatedURL.substring(gatedURL.indexOf(constants.pageUrl), gatedURL.length);
                    return securedPath === path;
                })) !== null && ref1 !== void 0 ? ref1 : {};
                const { gatedURL ="" , landingPageURL =""  } = matchedGatedContent;
                const oktaTokenBrowStorage = localStorage.getItem("okta-token-storage");
                const oktaTokenStorage = oktaTokenBrowStorage ? JSON.parse(oktaTokenBrowStorage) : {};
                const isAnonymous = isEmpty_default()(oktaTokenStorage);
                if (gatedURL && landingPageURL && isAnonymous) {
                    var ref2;
                    const redirectBackUrl = (ref2 = landingPageURL.substring(landingPageURL.indexOf("/en"), landingPageURL.length)) !== null && ref2 !== void 0 ? ref2 : "/en";
                    dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                        show: true,
                        onCloseHandlation: ()=>handleCloseOfModal(redirectBackUrl)
                    }));
                }
            }
        }
    };
    const handleCloseOfModal = function() {
        let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        window.location.replace(url);
    };
    const checkForLocation = ()=>{
        const currentZipCode = localStorage.getItem("currentZipCode");
        if (currentZipCode) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: currentZipCode
            }));
            return;
        }
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode, _city;
            const details = {
                utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
            };
            dispatch((0,locationSlice/* setCityLocation */.OX)(details));
        }).catch((err)=>{
            (0,helper/* getMyLocationByUserIP */.SAL)().then((getLocation)=>{
                var _zipcode, _city;
                const details = {
                    utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                    userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
                };
                dispatch((0,locationSlice/* setCityLocation */.OX)(details));
            }).catch((error)=>{
                // eslint-disable-next-line no-console
                console.log(error);
            });
        });
    };
    (0,react.useEffect)(()=>{
        let queueDelay;
        if (cartObj === null || cartObj === void 0 ? void 0 : cartObj.id) {
            (0,helper/* calculateCartData */.DpP)({
                cart: cartObj
            }, true).then(async (res)=>{
                // added timeout for queueing to the callback stack
                // fix for cart not updating to dataLayer sometimes
                const { cart: { itemSkus , ...cartData } = {}  } = res;
                res.cart = await (0,utils/* mapCollapsedSku */.eo)({
                    itemSkus,
                    cart: cartData
                });
                queueDelay = setInterval(()=>{
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    var ref6;
                    const datalayerLength = (ref6 = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.length) !== null && ref6 !== void 0 ? ref6 : 0;
                    if (datalayerLength > 0 && !((ref1 = window.adobeDataLayer[datalayerLength - 1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.page) === null || ref2 === void 0 ? void 0 : ref2.cartInfo)) {
                        window.adobeDataLayer.forEach(function(part, index, dataLayer) {
                            if (dataLayer[index].event) {
                                var ref;
                                var ref1;
                                const cartItems = (ref1 = res === null || res === void 0 ? void 0 : (ref = res.cart) === null || ref === void 0 ? void 0 : ref.item) !== null && ref1 !== void 0 ? ref1 : [];
                                var ref2;
                                const cartItemStr = cartItems.map((item)=>{
                                    var ref;
                                    return (ref2 = (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== null && ref2 !== void 0 ? ref2 : "";
                                }).join();
                                dataLayer[index].page.cartInfo = {
                                    cartItems: cartItemStr
                                };
                                dataLayer[index].page.cart = res === null || res === void 0 ? void 0 : res.cart;
                                const pageObj = dataLayer[index].page || window.pageObj;
                                const { category: { pageType =""  } = {}  } = pageObj;
                                const pageObjEvent = window.adobeDataLayer.filter((data)=>{
                                    return data.event === "cmp:show";
                                });
                                if (pageObjEvent && pageObjEvent.length > 0) {
                                    const pageObjEventTmp = {
                                        ...pageObjEvent
                                    };
                                    pageObjEventTmp.page = pageObj;
                                    pageObjEventTmp.event = "cmp:tmpShow";
                                    if ((window === null || window === void 0 ? void 0 : window.productInfo) && pageType === "pdp") {
                                        pageObjEventTmp.productInfo = JSON.parse(window === null || window === void 0 ? void 0 : window.productInfo);
                                        pageObjEventTmp.pageInfo = pageObj.pageInfo;
                                    }
                                    window.adobeDataLayer.push(pageObjEventTmp);
                                    window.adobeDataLayer.pop();
                                }
                            }
                        });
                    }
                    // clear the interval if the cart is added up to cmp:show
                    if ((ref3 = window.adobeDataLayer) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.page) === null || ref5 === void 0 ? void 0 : ref5.cartInfo) {
                        clearInterval(queueDelay);
                    }
                }, 100);
            });
        }
        return ()=>clearInterval(queueDelay);
    }, [
        cartObj,
        router
    ]);
    (0,react.useEffect)(()=>{
        const onRouterChangeStart = (url)=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(false));
            window.referrer = window.location.href;
            concernBanner("remove");
            clearAdobeTargetVideoTimeout();
        };
        const onRouterChangeComplete = (_, urlProp)=>{
            if (window && window.adobeDataLayer) {
                // prevent the dalatalayer events in case of shallow routing from PDP page
                if (!(urlProp === null || urlProp === void 0 ? void 0 : urlProp.shallow)) {
                    window.adobeDataLayer.length = 0;
                    window.datalayerTopLoaded = false;
                    dispatch((0,genericSlice/* setPageObject */.FE)(false));
                }
            }
            alterBodyClass();
            const isPdp = (window === null || window === void 0 ? void 0 : window.eventPageType) === "pdp";
            if (!isPdp) {
                window.datalayerTopLoaded = false;
                window.initDataLayerTop();
            }
            window.isShowAnalyticsEvent = true;
            (0,helper/* addPageLoadAnalyticsEvent */.igK)();
            delete window.referrer;
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
            concernBanner("add");
            if (pageIsInteractive) appendAdobeTargetVideoScript();
        };
        const popStateListener = (e)=>{
            const queryString = window.location.search;
            const path = window.location.pathname;
            const urlParams = new URLSearchParams(queryString);
            const hashedUrl = window.location.hash;
            const eventState = e === null || e === void 0 ? void 0 : e.state;
            if (hashedUrl) {
                var ref;
                const hashUrl = (ref = hashedUrl.split("::")[0]) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const redirectionPath = (ref1 = hashedUrl.split("::")[1]) !== null && ref1 !== void 0 ? ref1 : "";
                if (constants.GATED_HASHES.includes(hashUrl.toLowerCase())) {
                    if ((0,helper/* getAnonymousId */.yQL)() || (0,helper/* isCanadaSite */.guj)(siteName.current)) {
                        let active = 0;
                        if (hashUrl.includes("#signup")) active = 1;
                        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                            show: true,
                            active
                        }));
                        window.gatedPathRedirection = redirectionPath;
                    } else {
                        window.location.href = redirectionPath;
                    }
                }
                if (hashedUrl === "#newsletter") {
                    setShowCampaign(true);
                }
            }
            if (urlParams.has("back") || urlParams.has("keyword") || path === "/en/support/help-and-faq" || path === constants.MY_LISTS_PATH || path === constants.MY_LISTS_PATH_FR || path === constants.SHARE_LIST_PATH || path === constants.SHARE_LIST_PATH_FR || path === constants.SUPPORT_CENTER_PATH || path === constants.FIND_A_PRO_PATH || path.includes(constants.SHOP_THE_ROOM) || path === constants.INSTALLATION_SERVICES_PATH && (eventState !== null && isEmpty_default()(eventState) || (eventState === null || eventState === void 0 ? void 0 : eventState.previousUrl) === constants.CART_URL || (eventState === null || eventState === void 0 ? void 0 : eventState.previousUrl) === constants.CHECKOUT_URL) || path.includes(constants.TECHNICAL_SPECIFICATION_PATH) || path.includes(constants.LOCATIONS_PATH) || urlParams.has("compare") || regex/* PDP_REGEX.test */.ub.test(path)) {
                router.reload();
            }
        };
        window.addEventListener("popstate", popStateListener);
        router.events.on("routeChangeStart", onRouterChangeStart);
        router.events.on("routeChangeComplete", onRouterChangeComplete);
        return ()=>{
            // concernBanner("remove")
            router.events.off("routeChangeStart", onRouterChangeStart);
            router.events.off("routeChangeComplete", onRouterChangeComplete);
            window.removeEventListener("popstate", popStateListener);
        };
    }, [
        router
    ]);
    const alterBodyClass = ()=>{
        var ref;
        if (pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.tmpData) === null || ref === void 0 ? void 0 : ref.cssClassNames) {
            var ref1;
            document.body.className = pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.tmpData) === null || ref1 === void 0 ? void 0 : ref1.cssClassNames;
        }
    };
    (0,react.useEffect)(()=>{
        if (dataLayerObj) {
            const pageObj = JSON.parse(dataLayerObj);
            const { pageInfo: { pageUrl =""  } = {}  } = pageObj;
            if (pageUrl.includes(".json")) {
                pageObj.pageInfo.pageUrl = window.location.href;
            }
            window.pageObj = pageObj;
            window.eventPageType = eventPageType;
            window.isShowAnalyticsEvent = true;
            const isPdpLoaded = (window === null || window === void 0 ? void 0 : window.eventPageType) === "pdp" && isProductInfo || (window === null || window === void 0 ? void 0 : window.eventPageType) !== "pdp";
            if (window.pageObj && !window.datalayerTopLoaded && isPdpLoaded) {
                const dataLayerEvent = new Event("datalayerTopFired");
                window.dispatchEvent(dataLayerEvent);
            }
        }
    }, [
        dataLayerObj,
        isProductInfo
    ]);
    const concernBanner = (action)=>{
        const oneTrustVal = window.OneTrust || window.OneTrustStub;
        if (oneTrustVal && oneTrustVal.ToggleInfoDisplay) {
            var ref;
            if (action === "add") {
                oneTrustVal.initializeCookiePolicyHtml();
                oneTrustVal.LoadBanner();
            }
            (ref = document.querySelectorAll("#ot-sdk-link")[0]) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", function() {
                oneTrustVal.ToggleInfoDisplay();
            });
            if (action === "add") {
                var ref1;
                (ref1 = document.querySelectorAll("#ot-sdk-link")[0]) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", function() {
                    oneTrustVal.ToggleInfoDisplay();
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        // To remove hide the chat window on openinig menu
        if (lib/* isMobile */.tq) {
            const chatElement = document.getElementsByClassName("embeddedServiceHelpButton");
            if (isOpen && chatElement.length) {
                chatElement.item(0).style.display = "none";
            } else if (chatElement.length) {
                chatElement.item(0).style.display = "block";
            }
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        if (compare) {
            setShowCompare(true);
        } else if (comparedProducts && comparedProducts.length > 0) {
            setShowCompare(true);
        } else {
            document.body.classList.remove("compare-open", "scroll-lock", "modal-open");
            setShowCompare(false);
        }
    }, [
        comparedProducts
    ]);
    let adobeTargetVideoTimer;
    let adobeTargetElValidateCount = 0;
    const appendAdobeTargetVideoScript = ()=>{
        adobeTargetElValidateCount += 1;
        const adobeTargetVideoContainer = document.getElementsByClassName("at-element-marker");
        const videoEl = document.getElementsByTagName("video");
        if (adobeTargetVideoTimer) {
            clearTimeout(adobeTargetVideoTimer);
            adobeTargetVideoTimer = undefined;
        }
        if (adobeTargetVideoContainer.length > 0 && videoEl.length > 0) {
            const scriptPath = "/js/video.js";
            let script = document.querySelector('script[src="'.concat(scriptPath, '"]'));
            if (!script) {
                script = document.createElement("script");
                script.src = scriptPath;
                script.defer = true;
                document.body.appendChild(script);
            }
        } else if (adobeTargetElValidateCount <= 10) {
            adobeTargetVideoTimer = setTimeout(()=>{
                appendAdobeTargetVideoScript();
            }, 1000);
        }
    };
    const clearAdobeTargetVideoTimeout = ()=>{
        if (adobeTargetVideoTimer) {
            clearTimeout(adobeTargetVideoTimer);
            adobeTargetVideoTimer = undefined;
            adobeTargetElValidateCount = 0;
        }
    };
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) appendAdobeTargetVideoScript();
        return ()=>{
            clearAdobeTargetVideoTimeout();
        };
    }, [
        pageIsInteractive
    ]);
    const handleModalClose = ()=>{
        if (showCampaign) setShowCampaign(false);
    };
    const getFeatureFlags = async ()=>{
        try {
            const { data: featureFlags = {}  } = await axios_default().get(routes/* FEATURE_FLAGS_API_ENDPOINT */.VU);
            dispatch((0,genericSlice/* setFeatureFlagsFeature */.F$)(featureFlags));
        } catch (error) {
            console.error("Error fetching feature flags:", error);
        }
    };
    (0,react.useEffect)(()=>{
        let timeOut = null;
        if (isLoading) {
            timeOut = setTimeout(()=>{
                dispatch((0,genericSlice/* setLoading */.K4)(false));
            }, 30000);
        }
        return ()=>clearTimeout(timeOut);
    }, [
        isLoading
    ]);
    // Monitor auth state and manage blueCore user_email
    // Temporarily disable Bluecore on mobile Safari to prevent crashes
    (0,react.useEffect)(()=>{
        if (true) {
            var ref;
            // Detect mobile Safari
            const userAgent = window.navigator.userAgent;
            const isMobileSafari = /iPhone|iPad|iPod/.test(userAgent) && /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS/.test(userAgent);
            if (!(window === null || window === void 0 ? void 0 : (ref = window.kohler) === null || ref === void 0 ? void 0 : ref.bluecore)) {
                Object.assign(window.kohler, {
                    bluecore: {
                        user_email: ""
                    }
                });
            }
            // Disable Bluecore on mobile Safari as hotfix for crashes
            if (isMobileSafari) {
                // eslint-disable-next-line no-console
                console.log("Bluecore disabled on mobile Safari to prevent crashes");
                window.kohler.bluecore.user_email = "";
                // Prevent Bluecore scripts from loading
                window.kohler.bluecore.disabled = true;
            } else {
                window.kohler.bluecore.user_email = isAuth ? user === null || user === void 0 ? void 0 : user.sub : "";
                window.kohler.bluecore.disabled = false;
            }
        }
    }, [
        isAuth,
        user === null || user === void 0 ? void 0 : user.sub
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    pageAlternateLinks.length ? pageAlternateLinks.map((param, index)=>/*#__PURE__*/ {
                        let { lang ="" , baseUrl =""  } = param;
                        return (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            hrefLang: lang,
                            href: "https://".concat(baseUrl).concat(lang === "x-default" ? "/en" : "").concat(pageProps.urlPath === "/" ? "" : pageProps.urlPath)
                        }, "page-alterante-link-8csi3-3232k-sae".concat(index, "12"));
                    }) : null,
                    globalStyles.map((style, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (0,jsx_runtime.jsx)((style_default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "style-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
                    }),
                    ((ref = pageProps.metaContent) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: pageProps === null || pageProps === void 0 ? void 0 : pageProps.metaContent
                    }) : null,
                    (pageProps === null || pageProps === void 0 ? void 0 : pageProps.canonicalUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: (language === null || language === void 0 ? void 0 : (ref1 = language.i18n) === null || ref1 === void 0 ? void 0 : ref1.language) === "fr" ? pageProps === null || pageProps === void 0 ? void 0 : (ref2 = pageProps.canonicalUrl) === null || ref2 === void 0 ? void 0 : ref2.replace("/en/", "/fr/") : pageProps === null || pageProps === void 0 ? void 0 : pageProps.canonicalUrl
                    }) : null,
                    (pageProps === null || pageProps === void 0 ? void 0 : (ref3 = pageProps.tmpData) === null || ref3 === void 0 ? void 0 : ref3.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: pageProps.tmpData.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Provider */.zt, {
                store: store,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
                    condition: !isSsr,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PersistGate, {
                            persistor: store.__persistor,
                            loading: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                                initialLoader: true
                            }),
                            children: children
                        }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                            loading: isLoading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Layout, {
                            show: promoBannerModal === null || promoBannerModal === void 0 ? void 0 : promoBannerModal.show,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shared_ErrorBoundary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "root",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                            ...pageProps,
                                            featureFlags: featureFlags
                                        })
                                    }),
                                    show && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {}),
                                    showCartAction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartActionModal, {}) : null,
                                    isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster, {
                                        message: ""
                                    }),
                                    newslettersignup && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetterSignUpOverlay, {
                                        data: newslettersignup,
                                        showCampaign: showCampaign,
                                        handleModalClose: handleModalClose
                                    }),
                                    (promoBannerModal === null || promoBannerModal === void 0 ? void 0 : promoBannerModal.show) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModal, {
                                        ...promoBannerModal.modalContent
                                    }),
                                    !isRestricted && showCompare && (compareproducts === null || compareproducts === void 0 ? void 0 : compareproducts.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareProducts, {
                                        compareproducts: compareproducts === null || compareproducts === void 0 ? void 0 : compareproducts.content
                                    }),
                                    showPreview || isPreviewCartInit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCart, {}) : null
                                ]
                            })
                        })
                    ]
                })
            }),
            pageIsInteractive && globalScripts.map((script, i)=>{
                if (!script.innerHTML && scriptsLoaded === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    onReady: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    onError: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    src: script.src,
                    id: "script-".concat(i)
                }, "script-".concat(i));
                if (script.innerHTML && scriptsLoaded === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    onReady: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    onError: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    id: "innerscript-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "module",
                src: "/js/datalayer.js",
                onReady: ()=>{
                    const dataLayerEvent = new Event("datalayerFired");
                    window.dispatchEvent(dataLayerEvent);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "module",
                src: "/js/basic-text-module.js"
            })
        ]
    });
});
/**
 * function to log webvitals
 * @param {*} metric
 */ function reportWebVitals(metric) {
    // Ignore hidden tabs
    if (document.visibilityState !== "visible") return;
    const { name =""  } = metric;
    if (name !== "Next.js-hydration") {
        if (true) trackWebVital(metric);
    }
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp, (next_i18next_config_default())));


/***/ }),

/***/ 25696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U_": function() { return /* binding */ authClient; },
  "Z5": function() { return /* binding */ initAuth; },
  "c0": function() { return /* binding */ resetPassword; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/index.js
var crypto_namespaceObject = {};
__webpack_require__.r(crypto_namespaceObject);
__webpack_require__.d(crypto_namespaceObject, {
  "atob": function() { return a; },
  "base64ToBase64Url": function() { return base64ToBase64Url; },
  "base64UrlDecode": function() { return base64UrlDecode; },
  "base64UrlToBase64": function() { return base64UrlToBase64; },
  "base64UrlToBuffer": function() { return base64UrlToBuffer; },
  "base64UrlToString": function() { return base64UrlToString; },
  "btoa": function() { return b; },
  "bufferToBase64Url": function() { return bufferToBase64Url; },
  "getOidcHash": function() { return getOidcHash; },
  "stringToBase64Url": function() { return stringToBase64Url; },
  "stringToBuffer": function() { return stringToBuffer; },
  "verifyToken": function() { return verifyToken; },
  "webcrypto": function() { return c; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/constants.js
var constants_namespaceObject = {};
__webpack_require__.r(constants_namespaceObject);
__webpack_require__.d(constants_namespaceObject, {
  "ACCESS_TOKEN_STORAGE_KEY": function() { return ACCESS_TOKEN_STORAGE_KEY; },
  "CACHE_STORAGE_NAME": function() { return CACHE_STORAGE_NAME; },
  "DEFAULT_CACHE_DURATION": function() { return DEFAULT_CACHE_DURATION; },
  "DEFAULT_CODE_CHALLENGE_METHOD": function() { return DEFAULT_CODE_CHALLENGE_METHOD; },
  "DEFAULT_MAX_CLOCK_SKEW": function() { return DEFAULT_MAX_CLOCK_SKEW; },
  "DEFAULT_POLLING_DELAY": function() { return DEFAULT_POLLING_DELAY; },
  "IDX_API_VERSION": function() { return IDX_API_VERSION; },
  "IDX_RESPONSE_STORAGE_NAME": function() { return IDX_RESPONSE_STORAGE_NAME; },
  "ID_TOKEN_STORAGE_KEY": function() { return ID_TOKEN_STORAGE_KEY; },
  "MAX_VERIFIER_LENGTH": function() { return MAX_VERIFIER_LENGTH; },
  "MIN_VERIFIER_LENGTH": function() { return MIN_VERIFIER_LENGTH; },
  "ORIGINAL_URI_STORAGE_NAME": function() { return ORIGINAL_URI_STORAGE_NAME; },
  "PKCE_STORAGE_NAME": function() { return PKCE_STORAGE_NAME; },
  "REDIRECT_NONCE_COOKIE_NAME": function() { return REDIRECT_NONCE_COOKIE_NAME; },
  "REDIRECT_OAUTH_PARAMS_NAME": function() { return REDIRECT_OAUTH_PARAMS_NAME; },
  "REDIRECT_STATE_COOKIE_NAME": function() { return REDIRECT_STATE_COOKIE_NAME; },
  "REFERRER_PATH_STORAGE_KEY": function() { return REFERRER_PATH_STORAGE_KEY; },
  "REFRESH_TOKEN_STORAGE_KEY": function() { return REFRESH_TOKEN_STORAGE_KEY; },
  "SHARED_TRANSACTION_STORAGE_NAME": function() { return SHARED_TRANSACTION_STORAGE_NAME; },
  "STATE_TOKEN_KEY_NAME": function() { return STATE_TOKEN_KEY_NAME; },
  "TOKEN_STORAGE_NAME": function() { return TOKEN_STORAGE_NAME; },
  "TRANSACTION_STORAGE_NAME": function() { return TRANSACTION_STORAGE_NAME; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/features.js
var features_namespaceObject = {};
__webpack_require__.r(features_namespaceObject);
__webpack_require__.d(features_namespaceObject, {
  "getUserAgent": function() { return getUserAgent; },
  "hasTextEncoder": function() { return hasTextEncoder; },
  "isBrowser": function() { return isBrowser; },
  "isFingerprintSupported": function() { return isFingerprintSupported; },
  "isHTTPS": function() { return isHTTPS; },
  "isIE11OrLess": function() { return isIE11OrLess; },
  "isLocalhost": function() { return isLocalhost; },
  "isPKCESupported": function() { return isPKCESupported; },
  "isPopupPostMessageSupported": function() { return isPopupPostMessageSupported; },
  "isTokenVerifySupported": function() { return isTokenVerifySupported; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/webauthn.js
var webauthn_namespaceObject = {};
__webpack_require__.r(webauthn_namespaceObject);
__webpack_require__.d(webauthn_namespaceObject, {
  "buildCredentialCreationOptions": function() { return buildCredentialCreationOptions; },
  "buildCredentialRequestOptions": function() { return buildCredentialRequestOptions; },
  "getAssertion": function() { return getAssertion; },
  "getAttestation": function() { return getAttestation; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/index.js
var remediators_namespaceObject = {};
__webpack_require__.r(remediators_namespaceObject);
__webpack_require__.d(remediators_namespaceObject, {
  "AuthenticatorEnrollmentData": function() { return AuthenticatorEnrollmentData; },
  "AuthenticatorVerificationData": function() { return AuthenticatorVerificationData; },
  "ChallengeAuthenticator": function() { return ChallengeAuthenticator; },
  "ChallengePoll": function() { return ChallengePoll; },
  "EnrollAuthenticator": function() { return EnrollAuthenticator; },
  "EnrollPoll": function() { return EnrollPoll; },
  "EnrollProfile": function() { return EnrollProfile; },
  "EnrollmentChannelData": function() { return EnrollmentChannelData; },
  "GenericRemediator": function() { return GenericRemediator; },
  "Identify": function() { return Identify; },
  "ReEnrollAuthenticator": function() { return ReEnrollAuthenticator; },
  "RedirectIdp": function() { return RedirectIdp; },
  "Remediator": function() { return Remediator; },
  "ResetAuthenticator": function() { return ResetAuthenticator; },
  "SelectAuthenticatorAuthenticate": function() { return SelectAuthenticatorAuthenticate; },
  "SelectAuthenticatorEnroll": function() { return SelectAuthenticatorEnroll; },
  "SelectAuthenticatorUnlockAccount": function() { return SelectAuthenticatorUnlockAccount; },
  "SelectEnrollProfile": function() { return SelectEnrollProfile; },
  "SelectEnrollmentChannel": function() { return SelectEnrollmentChannel; },
  "Skip": function() { return Skip; }
});

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/CustomError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class CustomError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}


//# sourceMappingURL=CustomError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthSdkError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthSdkError_AuthSdkError extends CustomError {
    constructor(msg, xhr) {
        super(msg);
        this.name = 'AuthSdkError';
        this.errorCode = 'INTERNAL';
        this.errorSummary = msg;
        this.errorLink = 'INTERNAL';
        this.errorId = 'INTERNAL';
        this.errorCauses = [];
        if (xhr) {
            this.xhr = xhr;
        }
    }
}


//# sourceMappingURL=AuthSdkError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const a = function (str) { return atob(str); };
const b = function (str) { return btoa(str); };
const c = typeof crypto === 'undefined' ? null : crypto;


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/base64.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function stringToBase64Url(str) {
    var b64 = b(str);
    return base64ToBase64Url(b64);
}
function base64ToBase64Url(b64) {
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function base64UrlToBase64(b64u) {
    return b64u.replace(/-/g, '+').replace(/_/g, '/');
}
function base64UrlToString(b64u) {
    var b64 = base64UrlToBase64(b64u);
    switch (b64.length % 4) {
        case 0:
            break;
        case 2:
            b64 += '==';
            break;
        case 3:
            b64 += '=';
            break;
        default:
            throw new AuthSdkError_AuthSdkError('Not a valid Base64Url');
    }
    var utf8 = a(b64);
    try {
        return decodeURIComponent(escape(utf8));
    }
    catch (e) {
        return utf8;
    }
}
function stringToBuffer(str) {
    var buffer = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
        buffer[i] = str.charCodeAt(i);
    }
    return buffer;
}
function base64UrlDecode(str) {
    return a(base64UrlToBase64(str));
}
function base64UrlToBuffer(b64u) {
    return Uint8Array.from(base64UrlDecode(b64u), (c) => c.charCodeAt(0));
}
function bufferToBase64Url(bin) {
    return b(new Uint8Array(bin).reduce((s, byte) => s + String.fromCharCode(byte), ''));
}


//# sourceMappingURL=base64.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/oidcHash.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getOidcHash(str) {
    var buffer = new TextEncoder().encode(str);
    return c.subtle.digest('SHA-256', buffer).then(function (arrayBuffer) {
        var intBuffer = new Uint8Array(arrayBuffer);
        var firstHalf = intBuffer.slice(0, 16);
        var hash = String.fromCharCode.apply(null, firstHalf);
        var b64u = stringToBase64Url(hash);
        return b64u;
    });
}


//# sourceMappingURL=oidcHash.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/object.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function bind(fn, ctx) {
    var additionalArgs = Array.prototype.slice.call(arguments, 2);
    return function () {
        var args = Array.prototype.slice.call(arguments);
        args = additionalArgs.concat(args);
        return fn.apply(ctx, args);
    };
}
function extend() {
    var obj1 = arguments[0];
    var objArray = [].slice.call(arguments, 1);
    objArray.forEach(function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] !== undefined) {
                obj1[prop] = obj[prop];
            }
        }
    });
    return obj1;
}
function removeNils(obj) {
    var cleaned = {};
    for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            var value = obj[prop];
            if (value !== null && value !== undefined) {
                cleaned[prop] = value;
            }
        }
    }
    return cleaned;
}
function clone(obj) {
    if (obj) {
        var str = JSON.stringify(obj);
        if (str) {
            return JSON.parse(str);
        }
    }
    return obj;
}
function omit(obj, ...props) {
    var newobj = {};
    for (var p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p) && props.indexOf(p) == -1) {
            newobj[p] = obj[p];
        }
    }
    return clone(newobj);
}
function find(collection, searchParams) {
    var c = collection.length;
    while (c--) {
        var item = collection[c];
        var found = true;
        for (var prop in searchParams) {
            if (!Object.prototype.hasOwnProperty.call(searchParams, prop)) {
                continue;
            }
            if (item[prop] !== searchParams[prop]) {
                found = false;
                break;
            }
        }
        if (found) {
            return item;
        }
    }
}
function getLink(obj, linkName, altName) {
    if (!obj || !obj._links) {
        return;
    }
    var link = clone(obj._links[linkName]);
    if (link && link.name && altName) {
        if (link.name === altName) {
            return link;
        }
    }
    else {
        return link;
    }
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/verifyToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function verifyToken(idToken, key) {
    key = clone(key);
    var format = 'jwk';
    var algo = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: { name: 'SHA-256' }
    };
    var extractable = true;
    var usages = ['verify'];
    delete key.use;
    return c.subtle.importKey(format, key, algo, extractable, usages)
        .then(function (cryptoKey) {
        var jwt = idToken.split('.');
        var payload = stringToBuffer(jwt[0] + '.' + jwt[1]);
        var b64Signature = base64UrlDecode(jwt[2]);
        var signature = stringToBuffer(b64Signature);
        return c.subtle.verify(algo, cryptoKey, signature, payload);
    });
}


//# sourceMappingURL=verifyToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/_virtual/_tslib.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}


//# sourceMappingURL=_tslib.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/constants.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const STATE_TOKEN_KEY_NAME = 'oktaStateToken';
const DEFAULT_POLLING_DELAY = 500;
const DEFAULT_MAX_CLOCK_SKEW = 300;
const DEFAULT_CACHE_DURATION = 86400;
const REDIRECT_OAUTH_PARAMS_NAME = 'okta-oauth-redirect-params';
const REDIRECT_STATE_COOKIE_NAME = 'okta-oauth-state';
const REDIRECT_NONCE_COOKIE_NAME = 'okta-oauth-nonce';
const TOKEN_STORAGE_NAME = 'okta-token-storage';
const CACHE_STORAGE_NAME = 'okta-cache-storage';
const PKCE_STORAGE_NAME = 'okta-pkce-storage';
const TRANSACTION_STORAGE_NAME = 'okta-transaction-storage';
const SHARED_TRANSACTION_STORAGE_NAME = 'okta-shared-transaction-storage';
const ORIGINAL_URI_STORAGE_NAME = 'okta-original-uri-storage';
const IDX_RESPONSE_STORAGE_NAME = 'okta-idx-response-storage';
const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
const ID_TOKEN_STORAGE_KEY = 'idToken';
const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
const REFERRER_PATH_STORAGE_KEY = 'referrerPath';
const MIN_VERIFIER_LENGTH = 43;
const MAX_VERIFIER_LENGTH = 128;
const DEFAULT_CODE_CHALLENGE_METHOD = 'S256';
const IDX_API_VERSION = '1.0.0';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/types.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
function isNumber(obj) {
    return Object.prototype.toString.call(obj) === '[object Number]';
}
function isFunction(fn) {
    return !!fn && {}.toString.call(fn) === '[object Function]';
}
function isPromise(obj) {
    return obj && obj.finally && (typeof obj.finally === 'function');
}


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/url.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isAbsoluteUrl(url) {
    return /^[a-z][a-z0-9+.-]*:/i.test(url);
}
function toAbsoluteUrl(url = '', baseUrl) {
    if (isAbsoluteUrl(url)) {
        return url;
    }
    baseUrl = removeTrailingSlash(baseUrl);
    return url[0] === '/' ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
}
function toRelativeUrl(url = '', baseUrl) {
    if (isAbsoluteUrl(url)) {
        url = url.substring(baseUrl.length);
    }
    return url[0] === '/' ? url : `/${url}`;
}
function toQueryString(obj) {
    var str = [];
    if (obj !== null) {
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) &&
                obj[key] !== undefined &&
                obj[key] !== null) {
                str.push(key + '=' + encodeURIComponent(obj[key]));
            }
        }
    }
    if (str.length) {
        return '?' + str.join('&');
    }
    else {
        return '';
    }
}
function removeTrailingSlash(path) {
    if (!path) {
        return;
    }
    var trimmed = path.replace(/^\s+|\s+$/gm, '');
    trimmed = trimmed.replace(/\/+$/, '');
    return trimmed;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthApiError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthApiError_AuthApiError extends CustomError {
    constructor(err, xhr, meta) {
        const message = err.errorSummary;
        super(message);
        this.name = 'AuthApiError';
        this.errorSummary = err.errorSummary;
        this.errorCode = err.errorCode;
        this.errorLink = err.errorLink;
        this.errorId = err.errorId;
        this.errorCauses = err.errorCauses;
        if (xhr) {
            this.xhr = xhr;
        }
        if (meta) {
            this.meta = meta;
        }
    }
}


//# sourceMappingURL=AuthApiError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/OAuthError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OAuthError extends CustomError {
    constructor(errorCode, summary) {
        super(summary);
        this.name = 'OAuthError';
        this.errorCode = errorCode;
        this.errorSummary = summary;
        this.error = errorCode;
        this.error_description = summary;
    }
}


//# sourceMappingURL=OAuthError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/request.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function request_httpRequest(sdk, options) {
    options = options || {};
    if (sdk.options.httpRequestInterceptors) {
        for (const interceptor of sdk.options.httpRequestInterceptors) {
            interceptor(options);
        }
    }
    var url = options.url, method = options.method, args = options.args, saveAuthnState = options.saveAuthnState, accessToken = options.accessToken, withCredentials = options.withCredentials === true,
    storageUtil = sdk.options.storageUtil, storage = storageUtil.storage, httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    if (options.cacheResponse) {
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[url];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            return Promise.resolve(cachedResponse.response);
        }
    }
    var oktaUserAgentHeader = sdk._oktaUserAgent.getHttpHeader();
    var headers = Object.assign({ 'Accept': 'application/json', 'Content-Type': 'application/json' }, oktaUserAgentHeader);
    Object.assign(headers, sdk.options.headers, options.headers);
    headers = removeNils(headers);
    if (accessToken && isString(accessToken)) {
        headers['Authorization'] = 'Bearer ' + accessToken;
    }
    var ajaxOptions = {
        headers,
        data: args || undefined,
        withCredentials
    };
    var err, res;
    return sdk.options.httpRequestClient(method, url, ajaxOptions)
        .then(function (resp) {
        res = resp.responseText;
        if (res && isString(res)) {
            res = JSON.parse(res);
            if (res && typeof res === 'object' && !res.headers) {
                if (Array.isArray(res)) {
                    res.forEach(item => {
                        item.headers = resp.headers;
                    });
                }
                else {
                    res.headers = resp.headers;
                }
            }
        }
        if (saveAuthnState) {
            if (!res.stateToken) {
                storage.delete(STATE_TOKEN_KEY_NAME);
            }
        }
        if (res && res.stateToken && res.expiresAt) {
            storage.set(STATE_TOKEN_KEY_NAME, res.stateToken, res.expiresAt, sdk.options.cookies);
        }
        if (res && options.cacheResponse) {
            httpCache.updateStorage(url, {
                expiresAt: Math.floor(Date.now() / 1000) + DEFAULT_CACHE_DURATION,
                response: res
            });
        }
        return res;
    })
        .catch(function (resp) {
        var serverErr = resp.responseText || {};
        if (isString(serverErr)) {
            try {
                serverErr = JSON.parse(serverErr);
            }
            catch (e) {
                serverErr = {
                    errorSummary: 'Unknown error'
                };
            }
        }
        if (resp.status >= 500) {
            serverErr.errorSummary = 'Unknown error';
        }
        if (sdk.options.transformErrorXHR) {
            resp = sdk.options.transformErrorXHR(clone(resp));
        }
        if (serverErr.error && serverErr.error_description) {
            err = new OAuthError(serverErr.error, serverErr.error_description);
        }
        else {
            err = new AuthApiError_AuthApiError(serverErr, resp);
        }
        if (err.errorCode === 'E0000011') {
            storage.delete(STATE_TOKEN_KEY_NAME);
        }
        throw err;
    });
}
function get(sdk, url, options) {
    url = isAbsoluteUrl(url) ? url : sdk.getIssuerOrigin() + url;
    var getOptions = {
        url: url,
        method: 'GET'
    };
    Object.assign(getOptions, options);
    return request_httpRequest(sdk, getOptions);
}
function post(sdk, url, args, options) {
    url = isAbsoluteUrl(url) ? url : sdk.getIssuerOrigin() + url;
    var postOptions = {
        url: url,
        method: 'POST',
        args: args,
        saveAuthnState: true
    };
    Object.assign(postOptions, options);
    return request_httpRequest(sdk, postOptions);
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function addStateToken(res, options) {
    var builtArgs = {};
    Object.assign(builtArgs, options);
    if (!builtArgs.stateToken && res.stateToken) {
        builtArgs.stateToken = res.stateToken;
    }
    return builtArgs;
}
function getStateToken(res) {
    return addStateToken(res);
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function transactionStatus(sdk, args) {
    args = addStateToken(sdk, args);
    return post(sdk, sdk.getIssuerOrigin() + '/api/v1/authn', args, { withCredentials: true });
}
function resumeTransaction(sdk, args) {
    if (!args || !args.stateToken) {
        var stateToken = sdk.tx.exists._get(STATE_TOKEN_KEY_NAME);
        if (stateToken) {
            args = {
                stateToken: stateToken
            };
        }
        else {
            return Promise.reject(new AuthSdkError_AuthSdkError('No transaction to resume'));
        }
    }
    return sdk.tx.status(args)
        .then(function (res) {
        return sdk.tx.createTransaction(res);
    });
}
function introspectAuthn(sdk, args) {
    if (!args || !args.stateToken) {
        var stateToken = sdk.tx.exists._get(STATE_TOKEN_KEY_NAME);
        if (stateToken) {
            args = {
                stateToken: stateToken
            };
        }
        else {
            return Promise.reject(new AuthSdkError_AuthSdkError('No transaction to evaluate'));
        }
    }
    return transactionStep(sdk, args)
        .then(function (res) {
        return sdk.tx.createTransaction(res);
    });
}
function transactionStep(sdk, args) {
    args = addStateToken(sdk, args);
    return post(sdk, sdk.getIssuerOrigin() + '/api/v1/authn/introspect', args, { withCredentials: true });
}
function transactionExists(sdk) {
    return !!sdk.tx.exists._get(STATE_TOKEN_KEY_NAME);
}
function postToTransaction(sdk, url, args, options) {
    options = Object.assign({ withCredentials: true }, options);
    return post(sdk, url, args, options)
        .then(function (res) {
        return sdk.tx.createTransaction(res);
    });
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/misc.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isoToUTCString(str) {
    var parts = str.match(/\d+/g), isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]), isoDate = new Date(isoTime);
    return isoDate.toUTCString();
}
function genRandomString(length) {
    var randomCharset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var random = '';
    for (var c = 0, cl = randomCharset.length; c < length; ++c) {
        random += randomCharset[Math.floor(Math.random() * cl)];
    }
    return random;
}
function delay(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}
function split2(str, delim) {
    const parts = str.split(delim);
    return [
        parts[0],
        parts.splice(1, parts.length).join(delim),
    ];
}


//# sourceMappingURL=misc.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthPollStopError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthPollStopError extends CustomError {
    constructor() {
        const message = 'The poll was stopped by the sdk';
        super(message);
    }
}


//# sourceMappingURL=AuthPollStopError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/poll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */











function getPollFn(sdk, res, ref) {
    return function (options) {
        var delay$1;
        var rememberDevice;
        var autoPush;
        var transactionCallBack;
        if (isNumber(options)) {
            delay$1 = options;
        }
        else if (isObject(options)) {
            options = options;
            delay$1 = options.delay;
            rememberDevice = options.rememberDevice;
            autoPush = options.autoPush;
            transactionCallBack = options.transactionCallBack;
        }
        if (!delay$1 && delay$1 !== 0) {
            delay$1 = DEFAULT_POLLING_DELAY;
        }
        var pollLink = getLink(res, 'next', 'poll');
        function pollFn() {
            var opts = {};
            if (typeof autoPush === 'function') {
                try {
                    opts.autoPush = !!autoPush();
                }
                catch (e) {
                    return Promise.reject(new AuthSdkError_AuthSdkError('AutoPush resulted in an error.'));
                }
            }
            else if (autoPush !== undefined && autoPush !== null) {
                opts.autoPush = !!autoPush;
            }
            if (typeof rememberDevice === 'function') {
                try {
                    opts.rememberDevice = !!rememberDevice();
                }
                catch (e) {
                    return Promise.reject(new AuthSdkError_AuthSdkError('RememberDevice resulted in an error.'));
                }
            }
            else if (rememberDevice !== undefined && rememberDevice !== null) {
                opts.rememberDevice = !!rememberDevice;
            }
            var href = pollLink.href + toQueryString(opts);
            return post(sdk, href, getStateToken(res), {
                saveAuthnState: false,
                withCredentials: true
            });
        }
        ref.isPolling = true;
        var retryCount = 0;
        var recursivePoll = function () {
            if (!ref.isPolling) {
                return Promise.reject(new AuthPollStopError());
            }
            return pollFn()
                .then(function (pollRes) {
                retryCount = 0;
                if (pollRes.factorResult && pollRes.factorResult === 'WAITING') {
                    if (!ref.isPolling) {
                        throw new AuthPollStopError();
                    }
                    if (typeof transactionCallBack === 'function') {
                        transactionCallBack(pollRes);
                    }
                    return delay(delay$1).then(recursivePoll);
                }
                else {
                    ref.isPolling = false;
                    return sdk.tx.createTransaction(pollRes);
                }
            })
                .catch(function (err) {
                if (err.xhr &&
                    (err.xhr.status === 0 || err.xhr.status === 429) &&
                    retryCount <= 4) {
                    var delayLength = Math.pow(2, retryCount) * 1000;
                    retryCount++;
                    return delay(delayLength)
                        .then(recursivePoll);
                }
                throw err;
            });
        };
        return recursivePoll()
            .catch(function (err) {
            ref.isPolling = false;
            throw err;
        });
    };
}


//# sourceMappingURL=poll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/AuthTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










class AuthTransaction {
    constructor(sdk, res = null) {
        this.data = undefined;
        this.status = undefined;
        if (res) {
            this.data = res;
            if (this.data.interactionHandle) {
                this.status = res.status;
                return;
            }
            Object.assign(this, flattenEmbedded(sdk, res, res, {}));
            delete this.stateToken;
            if (res.status === 'RECOVERY_CHALLENGE' && !res._links) {
                this.cancel = function () {
                    return Promise.resolve(sdk.tx.createTransaction());
                };
            }
        }
    }
}
function link2fn(sdk, res, obj, link, ref) {
    if (Array.isArray(link)) {
        return function (name, opts) {
            if (!name) {
                throw new AuthSdkError_AuthSdkError('Must provide a link name');
            }
            var lk = find(link, { name: name });
            if (!lk) {
                throw new AuthSdkError_AuthSdkError('No link found for that name');
            }
            return link2fn(sdk, res, obj, lk, ref)(opts);
        };
    }
    else if (link.hints &&
        link.hints.allow &&
        link.hints.allow.length === 1) {
        var method = link.hints.allow[0];
        switch (method) {
            case 'GET':
                return function () {
                    return get(sdk, link.href, { withCredentials: true });
                };
            case 'POST':
                return function (opts) {
                    if (ref && ref.isPolling) {
                        ref.isPolling = false;
                    }
                    var data = addStateToken(res, opts);
                    if (res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL') {
                        Object.assign(data, {
                            factorType: obj.factorType,
                            provider: obj.provider
                        });
                    }
                    var params = {};
                    var autoPush = data.autoPush;
                    if (autoPush !== undefined) {
                        if (typeof autoPush === 'function') {
                            try {
                                params.autoPush = !!autoPush();
                            }
                            catch (e) {
                                return Promise.reject(new AuthSdkError_AuthSdkError('AutoPush resulted in an error.'));
                            }
                        }
                        else if (autoPush !== null) {
                            params.autoPush = !!autoPush;
                        }
                        data = omit(data, 'autoPush');
                    }
                    var rememberDevice = data.rememberDevice;
                    if (rememberDevice !== undefined) {
                        if (typeof rememberDevice === 'function') {
                            try {
                                params.rememberDevice = !!rememberDevice();
                            }
                            catch (e) {
                                return Promise.reject(new AuthSdkError_AuthSdkError('RememberDevice resulted in an error.'));
                            }
                        }
                        else if (rememberDevice !== null) {
                            params.rememberDevice = !!rememberDevice;
                        }
                        data = omit(data, 'rememberDevice');
                    }
                    else if (data.profile &&
                        data.profile.updatePhone !== undefined) {
                        if (data.profile.updatePhone) {
                            params.updatePhone = true;
                        }
                        data.profile = omit(data.profile, 'updatePhone');
                    }
                    var href = link.href + toQueryString(params);
                    return postToTransaction(sdk, href, data);
                };
        }
    }
}
function links2fns(sdk, res, obj, ref) {
    var fns = {};
    for (var linkName in obj._links) {
        if (!Object.prototype.hasOwnProperty.call(obj._links, linkName)) {
            continue;
        }
        var link = obj._links[linkName];
        if (linkName === 'next') {
            linkName = link.name;
        }
        if (link.type) {
            fns[linkName] = link;
            continue;
        }
        switch (linkName) {
            case 'poll':
                fns.poll = getPollFn(sdk, res, ref);
                break;
            default:
                var fn = link2fn(sdk, res, obj, link, ref);
                if (fn) {
                    fns[linkName] = fn;
                }
        }
    }
    return fns;
}
function flattenEmbedded(sdk, res, obj, ref) {
    obj = obj || res;
    obj = clone(obj);
    if (Array.isArray(obj)) {
        var objArr = [];
        for (var o = 0, ol = obj.length; o < ol; o++) {
            objArr.push(flattenEmbedded(sdk, res, obj[o], ref));
        }
        return objArr;
    }
    var embedded = obj._embedded || {};
    for (var key in embedded) {
        if (!Object.prototype.hasOwnProperty.call(embedded, key)) {
            continue;
        }
        if (isObject(embedded[key]) || Array.isArray(embedded[key])) {
            embedded[key] = flattenEmbedded(sdk, res, embedded[key], ref);
        }
    }
    var fns = links2fns(sdk, res, obj, ref);
    Object.assign(embedded, fns);
    obj = omit(obj, '_embedded', '_links');
    Object.assign(obj, embedded);
    return obj;
}


//# sourceMappingURL=AuthTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/headers.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function setRequestHeader(authClient, headerName, headerValue) {
    authClient.options.headers = authClient.options.headers || {};
    authClient.options.headers[headerName] = headerValue;
}


//# sourceMappingURL=headers.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/pkce.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function getRandomString(length) {
    var a = new Uint8Array(Math.ceil(length / 2));
    c.getRandomValues(a);
    var str = Array.from(a, dec2hex).join('');
    return str.slice(0, length);
}
function generateVerifier(prefix) {
    var verifier = prefix || '';
    if (verifier.length < MIN_VERIFIER_LENGTH) {
        verifier = verifier + getRandomString(MIN_VERIFIER_LENGTH - verifier.length);
    }
    return encodeURIComponent(verifier).slice(0, MAX_VERIFIER_LENGTH);
}
function computeChallenge(str) {
    var buffer = new TextEncoder().encode(str);
    return c.subtle.digest('SHA-256', buffer).then(function (arrayBuffer) {
        var hash = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
        var b64u = stringToBase64Url(hash);
        return b64u;
    });
}
var PKCE = {
    DEFAULT_CODE_CHALLENGE_METHOD: DEFAULT_CODE_CHALLENGE_METHOD,
    generateVerifier,
    computeChallenge
};


//# sourceMappingURL=pkce.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/session.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function sessionExists(sdk) {
    return sdk.session.get()
        .then(function (res) {
        if (res.status === 'ACTIVE') {
            return true;
        }
        return false;
    })
        .catch(function () {
        return false;
    });
}
function getSession(sdk) {
    return get(sdk, '/api/v1/sessions/me', { withCredentials: true })
        .then(function (session) {
        var res = omit(session, '_links');
        res.refresh = function () {
            return post(sdk, getLink(session, 'refresh').href, {}, { withCredentials: true });
        };
        res.user = function () {
            return get(sdk, getLink(session, 'user').href, { withCredentials: true });
        };
        return res;
    })
        .catch(function () {
        return { status: 'INACTIVE' };
    });
}
function closeSession(sdk) {
    return request_httpRequest(sdk, {
        url: sdk.getIssuerOrigin() + '/api/v1/sessions/me',
        method: 'DELETE',
        withCredentials: true
    });
}
function refreshSession(sdk) {
    return post(sdk, '/api/v1/sessions/me/lifecycle/refresh', {}, { withCredentials: true });
}
function setCookieAndRedirect(sdk, sessionToken, redirectUrl) {
    redirectUrl = redirectUrl || window.location.href;
    window.location.assign(sdk.getIssuerOrigin() + '/login/sessionCookieRedirect' +
        toQueryString({
            checkAccountSetupComplete: true,
            token: sessionToken,
            redirectUrl: redirectUrl
        }));
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/oauth.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function generateState() {
    return genRandomString(64);
}
function generateNonce() {
    return genRandomString(64);
}
function getIssuer(sdk, options = {}) {
    const issuer = removeTrailingSlash(options.issuer) || sdk.options.issuer;
    return issuer;
}
function getOAuthBaseUrl(sdk, options = {}) {
    const issuer = getIssuer(sdk, options);
    const baseUrl = issuer.indexOf('/oauth2') > 0 ? issuer : issuer + '/oauth2';
    return baseUrl;
}
function getOAuthDomain(sdk, options = {}) {
    const issuer = getIssuer(sdk, options);
    const domain = issuer.split('/oauth2')[0];
    return domain;
}
function getOAuthUrls(sdk, options) {
    if (arguments.length > 2) {
        throw new AuthSdkError_AuthSdkError('As of version 3.0, "getOAuthUrls" takes only a single set of options');
    }
    options = options || {};
    var authorizeUrl = removeTrailingSlash(options.authorizeUrl) || sdk.options.authorizeUrl;
    var issuer = getIssuer(sdk, options);
    var userinfoUrl = removeTrailingSlash(options.userinfoUrl) || sdk.options.userinfoUrl;
    var tokenUrl = removeTrailingSlash(options.tokenUrl) || sdk.options.tokenUrl;
    var logoutUrl = removeTrailingSlash(options.logoutUrl) || sdk.options.logoutUrl;
    var revokeUrl = removeTrailingSlash(options.revokeUrl) || sdk.options.revokeUrl;
    var baseUrl = getOAuthBaseUrl(sdk, options);
    authorizeUrl = authorizeUrl || baseUrl + '/v1/authorize';
    userinfoUrl = userinfoUrl || baseUrl + '/v1/userinfo';
    tokenUrl = tokenUrl || baseUrl + '/v1/token';
    revokeUrl = revokeUrl || baseUrl + '/v1/revoke';
    logoutUrl = logoutUrl || baseUrl + '/v1/logout';
    return {
        issuer: issuer,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        tokenUrl: tokenUrl,
        revokeUrl: revokeUrl,
        logoutUrl: logoutUrl
    };
}


//# sourceMappingURL=oauth.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/features.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const isWindowsPhone = /windows phone|iemobile|wpdesktop/i;
function isBrowser() {
    return typeof document !== 'undefined' && typeof window !== 'undefined';
}
function isIE11OrLess() {
    if (!isBrowser()) {
        return false;
    }
    const documentMode = document.documentMode;
    return !!documentMode && documentMode <= 11;
}
function getUserAgent() {
    return navigator.userAgent;
}
function isFingerprintSupported() {
    const agent = getUserAgent();
    return agent && !isWindowsPhone.test(agent);
}
function isPopupPostMessageSupported() {
    if (!isBrowser()) {
        return false;
    }
    const documentMode = document.documentMode;
    var isIE8or9 = documentMode && documentMode < 10;
    if (typeof window.postMessage !== 'undefined' && !isIE8or9) {
        return true;
    }
    return false;
}
function isTokenVerifySupported() {
    return typeof c !== 'undefined'
        && c !== null
        && typeof c.subtle !== 'undefined'
        && typeof Uint8Array !== 'undefined';
}
function hasTextEncoder() {
    return typeof TextEncoder !== 'undefined';
}
function isPKCESupported() {
    return isTokenVerifySupported() && hasTextEncoder();
}
function isHTTPS() {
    if (!isBrowser()) {
        return false;
    }
    return window.location.protocol === 'https:';
}
function isLocalhost() {
    return isBrowser() && window.location.hostname === 'localhost';
}


//# sourceMappingURL=features.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function errors_isAuthApiError(obj) {
    return (obj instanceof AuthApiError_AuthApiError);
}
function isOAuthError(obj) {
    return (obj instanceof OAuthError);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/errors.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function isInteractionRequiredError(error) {
    if (error.name !== 'OAuthError') {
        return false;
    }
    const oauthError = error;
    return (oauthError.errorCode === 'interaction_required');
}
function isAuthorizationCodeError(sdk, error) {
    if (error.name !== 'AuthApiError') {
        return false;
    }
    const authApiError = error;
    const errorResponse = authApiError.xhr;
    const responseJSON = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.responseJSON;
    return sdk.options.pkce && ((responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.error) === 'invalid_grant');
}
function isRefreshTokenInvalidError(error) {
    return isOAuthError(error) &&
        error.errorCode === 'invalid_grant' &&
        error.errorSummary === 'The refresh token is invalid or expired.';
}


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/loginRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function hasTokensInHash(hash) {
    return /((id|access)_token=)/i.test(hash);
}
function hasAuthorizationCode(hashOrSearch) {
    return /(code=)/i.test(hashOrSearch);
}
function hasInteractionCode(hashOrSearch) {
    return /(interaction_code=)/i.test(hashOrSearch);
}
function hasErrorInUrl(hashOrSearch) {
    return /(error=)/i.test(hashOrSearch) || /(error_description)/i.test(hashOrSearch);
}
function isRedirectUri(uri, sdk) {
    var authParams = sdk.options;
    if (!uri || !authParams.redirectUri) {
        return false;
    }
    return uri.indexOf(authParams.redirectUri) === 0;
}
function isCodeFlow(options) {
    return options.pkce || options.responseType === 'code' || options.responseMode === 'query';
}
function getHashOrSearch(options) {
    var codeFlow = isCodeFlow(options);
    var useQuery = codeFlow && options.responseMode !== 'fragment';
    return useQuery ? window.location.search : window.location.hash;
}
function isLoginRedirect(sdk) {
    if (!isRedirectUri(window.location.href, sdk)) {
        return false;
    }
    var codeFlow = isCodeFlow(sdk.options);
    var hashOrSearch = getHashOrSearch(sdk.options);
    if (hasErrorInUrl(hashOrSearch)) {
        return true;
    }
    if (codeFlow) {
        var hasCode = hasAuthorizationCode(hashOrSearch) || hasInteractionCode(hashOrSearch);
        return hasCode;
    }
    return hasTokensInHash(window.location.hash);
}
function isInteractionRequired(sdk, hashOrSearch) {
    if (!hashOrSearch) {
        if (!isLoginRedirect(sdk)) {
            return false;
        }
        hashOrSearch = getHashOrSearch(sdk.options);
    }
    return /(error=interaction_required)/i.test(hashOrSearch);
}


//# sourceMappingURL=loginRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/well-known.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getWellKnown(sdk, issuer) {
    var authServerUri = (issuer || sdk.options.issuer);
    return get(sdk, authServerUri + '/.well-known/openid-configuration', {
        cacheResponse: true
    });
}
function getKey(sdk, issuer, kid) {
    var httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    return getWellKnown(sdk, issuer)
        .then(function (wellKnown) {
        var jwksUri = wellKnown['jwks_uri'];
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[jwksUri];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            var cachedKey = find(cachedResponse.response.keys, {
                kid: kid
            });
            if (cachedKey) {
                return cachedKey;
            }
        }
        httpCache.clearStorage(jwksUri);
        return get(sdk, jwksUri, {
            cacheResponse: true
        })
            .then(function (res) {
            var key = find(res.keys, {
                kid: kid
            });
            if (key) {
                return key;
            }
            throw new AuthSdkError_AuthSdkError('The key id, ' + kid + ', was not found in the server\'s keys');
        });
    });
}


//# sourceMappingURL=well-known.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/defaultTokenParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getDefaultTokenParams(sdk) {
    const { pkce, clientId, redirectUri, responseType, responseMode, scopes, state, ignoreSignature } = sdk.options;
    const defaultRedirectUri = isBrowser() ? window.location.href : undefined;
    return removeNils({
        pkce,
        clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseType: responseType || ['token', 'id_token'],
        responseMode,
        state: state || generateState(),
        nonce: generateNonce(),
        scopes: scopes || ['openid', 'email'],
        ignoreSignature
    });
}


//# sourceMappingURL=defaultTokenParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/prepareTokenParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function assertPKCESupport(sdk) {
    if (!sdk.features.isPKCESupported()) {
        var errorMessage = 'PKCE requires a modern browser with encryption support running in a secure context.';
        if (!sdk.features.isHTTPS()) {
            errorMessage += '\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol.';
        }
        if (!sdk.features.hasTextEncoder()) {
            errorMessage += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.';
        }
        throw new AuthSdkError_AuthSdkError(errorMessage);
    }
}
async function validateCodeChallengeMethod(sdk, codeChallengeMethod) {
    codeChallengeMethod = codeChallengeMethod || sdk.options.codeChallengeMethod || DEFAULT_CODE_CHALLENGE_METHOD;
    const wellKnownResponse = await getWellKnown(sdk);
    var methods = wellKnownResponse['code_challenge_methods_supported'] || [];
    if (methods.indexOf(codeChallengeMethod) === -1) {
        throw new AuthSdkError_AuthSdkError('Invalid code_challenge_method');
    }
    return codeChallengeMethod;
}
async function preparePKCE(sdk, tokenParams) {
    let { codeVerifier, codeChallenge, codeChallengeMethod } = tokenParams;
    codeChallenge = codeChallenge || sdk.options.codeChallenge;
    if (!codeChallenge) {
        assertPKCESupport(sdk);
        codeVerifier = codeVerifier || PKCE.generateVerifier();
        codeChallenge = await PKCE.computeChallenge(codeVerifier);
    }
    codeChallengeMethod = await validateCodeChallengeMethod(sdk, codeChallengeMethod);
    tokenParams = Object.assign(Object.assign({}, tokenParams), { responseType: 'code',
        codeVerifier,
        codeChallenge,
        codeChallengeMethod });
    return tokenParams;
}
async function prepareTokenParams(sdk, tokenParams = {}) {
    const defaults = getDefaultTokenParams(sdk);
    tokenParams = Object.assign(Object.assign({}, defaults), tokenParams);
    if (tokenParams.pkce === false) {
        return tokenParams;
    }
    return preparePKCE(sdk, tokenParams);
}


//# sourceMappingURL=prepareTokenParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/types/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var IdxStatus;
(function (IdxStatus) {
    IdxStatus["SUCCESS"] = "SUCCESS";
    IdxStatus["PENDING"] = "PENDING";
    IdxStatus["FAILURE"] = "FAILURE";
    IdxStatus["TERMINAL"] = "TERMINAL";
    IdxStatus["CANCELED"] = "CANCELED";
})(IdxStatus || (IdxStatus = {}));
var AuthenticatorKey;
(function (AuthenticatorKey) {
    AuthenticatorKey["OKTA_PASSWORD"] = "okta_password";
    AuthenticatorKey["OKTA_EMAIL"] = "okta_email";
    AuthenticatorKey["PHONE_NUMBER"] = "phone_number";
    AuthenticatorKey["GOOGLE_AUTHENTICATOR"] = "google_otp";
    AuthenticatorKey["SECURITY_QUESTION"] = "security_question";
    AuthenticatorKey["OKTA_VERIFY"] = "okta_verify";
    AuthenticatorKey["WEBAUTHN"] = "webauthn";
})(AuthenticatorKey || (AuthenticatorKey = {}));
var IdxFeature;
(function (IdxFeature) {
    IdxFeature["PASSWORD_RECOVERY"] = "recover-password";
    IdxFeature["REGISTRATION"] = "enroll-profile";
    IdxFeature["SOCIAL_IDP"] = "redirect-idp";
    IdxFeature["ACCOUNT_UNLOCK"] = "unlock-account";
})(IdxFeature || (IdxFeature = {}));
function isAuthenticator(obj) {
    return obj && (obj.key || obj.id);
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/types.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var EmailRole;
(function (EmailRole) {
    EmailRole["PRIMARY"] = "PRIMARY";
    EmailRole["SECONDARY"] = "SECONDARY";
})(EmailRole || (EmailRole = {}));
var Status;
(function (Status) {
    Status["VERIFIED"] = "VERIFIED";
    Status["UNVERIFIED"] = "UNVERIFIED";
})(Status || (Status = {}));


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/decodeToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function decodeToken(token) {
    var jwt = token.split('.');
    var decodedToken;
    try {
        decodedToken = {
            header: JSON.parse(base64UrlToString(jwt[0])),
            payload: JSON.parse(base64UrlToString(jwt[1])),
            signature: jwt[2]
        };
    }
    catch (e) {
        throw new AuthSdkError_AuthSdkError('Malformed token');
    }
    return decodedToken;
}


//# sourceMappingURL=decodeToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/revokeToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







async function revokeToken(sdk, token) {
    let accessToken = '';
    let refreshToken = '';
    if (token) {
        accessToken = token.accessToken;
        refreshToken = token.refreshToken;
    }
    if (!accessToken && !refreshToken) {
        throw new AuthSdkError_AuthSdkError('A valid access or refresh token object is required');
    }
    var clientId = sdk.options.clientId;
    var clientSecret = sdk.options.clientSecret;
    if (!clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to revoke a token');
    }
    var revokeUrl = getOAuthUrls(sdk).revokeUrl;
    var args = toQueryString({
        token_type_hint: refreshToken ? 'refresh_token' : 'access_token',
        token: refreshToken || accessToken,
    }).slice(1);
    var creds = clientSecret ? b(`${clientId}:${clientSecret}`) : b(clientId);
    return post(sdk, revokeUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + creds
        }
    });
}


//# sourceMappingURL=revokeToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/types/Token.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isToken(obj) {
    if (obj &&
        (obj.accessToken || obj.idToken || obj.refreshToken) &&
        Array.isArray(obj.scopes)) {
        return true;
    }
    return false;
}
function isAccessToken(obj) {
    return obj && obj.accessToken;
}
function isIDToken(obj) {
    return obj && obj.idToken;
}
function isRefreshToken(obj) {
    return obj && obj.refreshToken;
}


//# sourceMappingURL=Token.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function addListener(eventTarget, name, fn) {
    if (eventTarget.addEventListener) {
        eventTarget.addEventListener(name, fn);
    }
    else {
        eventTarget.attachEvent('on' + name, fn);
    }
}
function removeListener(eventTarget, name, fn) {
    if (eventTarget.removeEventListener) {
        eventTarget.removeEventListener(name, fn);
    }
    else {
        eventTarget.detachEvent('on' + name, fn);
    }
}
function loadFrame(src) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = src;
    return document.body.appendChild(iframe);
}
function loadPopup(src, options) {
    var title = options.popupTitle || 'External Identity Provider User Authentication';
    var appearance = 'toolbar=no, scrollbars=yes, resizable=yes, ' +
        'top=100, left=500, width=600, height=600';
    return window.open(src, title, appearance);
}
function addPostMessageListener(sdk, timeout, state) {
    var responseHandler;
    var timeoutId;
    var msgReceivedOrTimeout = new Promise(function (resolve, reject) {
        responseHandler = function responseHandler(e) {
            if (!e.data || e.data.state !== state) {
                return;
            }
            if (e.origin !== sdk.getIssuerOrigin()) {
                return reject(new AuthSdkError_AuthSdkError('The request does not match client configuration'));
            }
            resolve(e.data);
        };
        addListener(window, 'message', responseHandler);
        timeoutId = setTimeout(function () {
            reject(new AuthSdkError_AuthSdkError('OAuth flow timed out'));
        }, timeout || 120000);
    });
    return msgReceivedOrTimeout
        .finally(function () {
        clearTimeout(timeoutId);
        removeListener(window, 'message', responseHandler);
    });
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/authorize.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function convertTokenParamsToOAuthParams(tokenParams) {
    if (!tokenParams.clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to get a token');
    }
    if (isString(tokenParams.responseType) && tokenParams.responseType.indexOf(' ') !== -1) {
        throw new AuthSdkError_AuthSdkError('Multiple OAuth responseTypes must be defined as an array');
    }
    var oauthParams = {
        'client_id': tokenParams.clientId,
        'code_challenge': tokenParams.codeChallenge,
        'code_challenge_method': tokenParams.codeChallengeMethod,
        'display': tokenParams.display,
        'idp': tokenParams.idp,
        'idp_scope': tokenParams.idpScope,
        'login_hint': tokenParams.loginHint,
        'max_age': tokenParams.maxAge,
        'nonce': tokenParams.nonce,
        'prompt': tokenParams.prompt,
        'redirect_uri': tokenParams.redirectUri,
        'response_mode': tokenParams.responseMode,
        'response_type': tokenParams.responseType,
        'sessionToken': tokenParams.sessionToken,
        'state': tokenParams.state,
    };
    oauthParams = removeNils(oauthParams);
    ['idp_scope', 'response_type'].forEach(function (mayBeArray) {
        if (Array.isArray(oauthParams[mayBeArray])) {
            oauthParams[mayBeArray] = oauthParams[mayBeArray].join(' ');
        }
    });
    if (tokenParams.responseType.indexOf('id_token') !== -1 &&
        tokenParams.scopes.indexOf('openid') === -1) {
        throw new AuthSdkError_AuthSdkError('openid scope must be specified in the scopes argument when requesting an id_token');
    }
    else {
        oauthParams.scope = tokenParams.scopes.join(' ');
    }
    return oauthParams;
}
function buildAuthorizeParams(tokenParams) {
    var oauthQueryParams = convertTokenParamsToOAuthParams(tokenParams);
    return toQueryString(Object.assign(Object.assign({}, oauthQueryParams), (tokenParams.extraParams && Object.assign({}, tokenParams.extraParams))));
}


//# sourceMappingURL=authorize.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/validateClaims.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function validateClaims(sdk, claims, validationParams) {
    var aud = validationParams.clientId;
    var iss = validationParams.issuer;
    var nonce = validationParams.nonce;
    if (!claims || !iss || !aud) {
        throw new AuthSdkError_AuthSdkError('The jwt, iss, and aud arguments are all required');
    }
    if (nonce && claims.nonce !== nonce) {
        throw new AuthSdkError_AuthSdkError('OAuth flow response nonce doesn\'t match request nonce');
    }
    var now = Math.floor(Date.now() / 1000);
    if (claims.iss !== iss) {
        throw new AuthSdkError_AuthSdkError('The issuer [' + claims.iss + '] ' +
            'does not match [' + iss + ']');
    }
    if (claims.aud !== aud) {
        throw new AuthSdkError_AuthSdkError('The audience [' + claims.aud + '] ' +
            'does not match [' + aud + ']');
    }
    if (claims.iat > claims.exp) {
        throw new AuthSdkError_AuthSdkError('The JWT expired before it was issued');
    }
    if (!sdk.options.ignoreLifetime) {
        if ((now - sdk.options.maxClockSkew) > claims.exp) {
            throw new AuthSdkError_AuthSdkError('The JWT expired and is no longer valid');
        }
        if (claims.iat > (now + sdk.options.maxClockSkew)) {
            throw new AuthSdkError_AuthSdkError('The JWT was issued in the future');
        }
    }
}


//# sourceMappingURL=validateClaims.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/verifyToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










async function verifyToken_verifyToken(sdk, token, validationParams) {
    if (!token || !token.idToken) {
        throw new AuthSdkError_AuthSdkError('Only idTokens may be verified');
    }
    var jwt = decodeToken(token.idToken);
    const configuredIssuer = (validationParams === null || validationParams === void 0 ? void 0 : validationParams.issuer) || sdk.options.issuer;
    const { issuer } = await getWellKnown(sdk, configuredIssuer);
    var validationOptions = Object.assign({
        clientId: sdk.options.clientId,
        ignoreSignature: sdk.options.ignoreSignature
    }, validationParams, {
        issuer
    });
    validateClaims(sdk, jwt.payload, validationOptions);
    if (validationOptions.ignoreSignature == true || !sdk.features.isTokenVerifySupported()) {
        return token;
    }
    const key = await getKey(sdk, token.issuer, jwt.header.kid);
    const valid = await verifyToken(token.idToken, key);
    if (!valid) {
        throw new AuthSdkError_AuthSdkError('The token signature is not valid');
    }
    if (validationParams && validationParams.accessToken && token.claims.at_hash) {
        const hash = await getOidcHash(validationParams.accessToken);
        if (hash !== token.claims.at_hash) {
            throw new AuthSdkError_AuthSdkError('Token hash verification failed');
        }
    }
    return token;
}


//# sourceMappingURL=verifyToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/handleOAuthResponse.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function validateResponse(res, oauthParams) {
    if (res['error'] && res['error_description']) {
        throw new OAuthError(res['error'], res['error_description']);
    }
    if (res.state !== oauthParams.state) {
        throw new AuthSdkError_AuthSdkError('OAuth flow response state doesn\'t match request state');
    }
}
async function handleOAuthResponse(sdk, tokenParams, res, urls) {
    var pkce = sdk.options.pkce !== false;
    if (pkce && (res.code || res.interaction_code)) {
        return sdk.token.exchangeCodeForTokens(Object.assign({}, tokenParams, {
            authorizationCode: res.code,
            interactionCode: res.interaction_code
        }), urls);
    }
    tokenParams = tokenParams || getDefaultTokenParams(sdk);
    urls = urls || getOAuthUrls(sdk, tokenParams);
    var responseType = tokenParams.responseType || [];
    if (!Array.isArray(responseType)) {
        responseType = [responseType];
    }
    var scopes;
    if (res.scope) {
        scopes = res.scope.split(' ');
    }
    else {
        scopes = clone(tokenParams.scopes);
    }
    var clientId = tokenParams.clientId || sdk.options.clientId;
    validateResponse(res, tokenParams);
    var tokenDict = {};
    var expiresIn = res.expires_in;
    var tokenType = res.token_type;
    var accessToken = res.access_token;
    var idToken = res.id_token;
    var refreshToken = res.refresh_token;
    var now = Math.floor(Date.now() / 1000);
    if (accessToken) {
        var accessJwt = sdk.token.decode(accessToken);
        tokenDict.accessToken = {
            accessToken: accessToken,
            claims: accessJwt.payload,
            expiresAt: Number(expiresIn) + now,
            tokenType: tokenType,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            userinfoUrl: urls.userinfoUrl
        };
    }
    if (refreshToken) {
        tokenDict.refreshToken = {
            refreshToken: refreshToken,
            expiresAt: Number(expiresIn) + now,
            scopes: scopes,
            tokenUrl: urls.tokenUrl,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
        };
    }
    if (idToken) {
        var idJwt = sdk.token.decode(idToken);
        var idTokenObj = {
            idToken: idToken,
            claims: idJwt.payload,
            expiresAt: idJwt.payload.exp - idJwt.payload.iat + now,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
            clientId: clientId
        };
        var validationParams = {
            clientId: clientId,
            issuer: urls.issuer,
            nonce: tokenParams.nonce,
            accessToken: accessToken
        };
        if (tokenParams.ignoreSignature !== undefined) {
            validationParams.ignoreSignature = tokenParams.ignoreSignature;
        }
        await verifyToken_verifyToken(sdk, idTokenObj, validationParams);
        tokenDict.idToken = idTokenObj;
    }
    if (responseType.indexOf('token') !== -1 && !tokenDict.accessToken) {
        throw new AuthSdkError_AuthSdkError('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
    }
    if (responseType.indexOf('id_token') !== -1 && !tokenDict.idToken) {
        throw new AuthSdkError_AuthSdkError('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
    }
    return {
        tokens: tokenDict,
        state: res.state,
        code: res.code
    };
}


//# sourceMappingURL=handleOAuthResponse.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function getToken(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getToken" takes only a single set of options'));
    }
    options = options || {};
    const popupWindow = options.popupWindow;
    options.popupWindow = undefined;
    return prepareTokenParams(sdk, options)
        .then(function (tokenParams) {
        var sessionTokenOverrides = {
            prompt: 'none',
            responseMode: 'okta_post_message',
            display: null
        };
        var idpOverrides = {
            display: 'popup'
        };
        if (options.sessionToken) {
            Object.assign(tokenParams, sessionTokenOverrides);
        }
        else if (options.idp) {
            Object.assign(tokenParams, idpOverrides);
        }
        var requestUrl, endpoint, urls;
        urls = getOAuthUrls(sdk, tokenParams);
        endpoint = options.codeVerifier ? urls.tokenUrl : urls.authorizeUrl;
        requestUrl = endpoint + buildAuthorizeParams(tokenParams);
        var flowType;
        if (tokenParams.sessionToken || tokenParams.display === null) {
            flowType = 'IFRAME';
        }
        else if (tokenParams.display === 'popup') {
            flowType = 'POPUP';
        }
        else {
            flowType = 'IMPLICIT';
        }
        switch (flowType) {
            case 'IFRAME':
                var iframePromise = addPostMessageListener(sdk, options.timeout, tokenParams.state);
                var iframeEl = loadFrame(requestUrl);
                return iframePromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                })
                    .finally(function () {
                    var _a;
                    if (document.body.contains(iframeEl)) {
                        (_a = iframeEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(iframeEl);
                    }
                });
            case 'POPUP':
                var oauthPromise;
                if (tokenParams.responseMode === 'okta_post_message') {
                    if (!sdk.features.isPopupPostMessageSupported()) {
                        throw new AuthSdkError_AuthSdkError('This browser doesn\'t have full postMessage support');
                    }
                    oauthPromise = addPostMessageListener(sdk, options.timeout, tokenParams.state);
                }
                if (popupWindow) {
                    popupWindow.location.assign(requestUrl);
                }
                var popupPromise = new Promise(function (resolve, reject) {
                    var closePoller = setInterval(function () {
                        if (!popupWindow || popupWindow.closed) {
                            clearInterval(closePoller);
                            reject(new AuthSdkError_AuthSdkError('Unable to parse OAuth flow response'));
                        }
                    }, 100);
                    oauthPromise
                        .then(function (res) {
                        clearInterval(closePoller);
                        resolve(res);
                    })
                        .catch(function (err) {
                        clearInterval(closePoller);
                        reject(err);
                    });
                });
                return popupPromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                })
                    .finally(function () {
                    if (popupWindow && !popupWindow.closed) {
                        popupWindow.close();
                    }
                });
            default:
                throw new AuthSdkError_AuthSdkError('The full page redirect flow is not supported');
        }
    });
}


//# sourceMappingURL=getToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithoutPrompt.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getWithoutPrompt(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getWithoutPrompt" takes only a single set of options'));
    }
    options = clone(options) || {};
    Object.assign(options, {
        prompt: 'none',
        responseMode: 'okta_post_message',
        display: null
    });
    return getToken(sdk, options);
}


//# sourceMappingURL=getWithoutPrompt.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/refreshToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function isSameRefreshToken(a, b) {
    return (a.refreshToken === b.refreshToken);
}
function isRefreshTokenError(err) {
    if (!isAuthApiError(err)) {
        return false;
    }
    if (!err.xhr || !err.xhr.responseJSON) {
        return false;
    }
    const { responseJSON } = err.xhr;
    if (responseJSON.error === 'invalid_grant') {
        return true;
    }
    return false;
}


//# sourceMappingURL=refreshToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/token.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function validateOptions(options) {
    if (!options.clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to get a token');
    }
    if (!options.redirectUri) {
        throw new AuthSdkError_AuthSdkError('The redirectUri passed to /authorize must also be passed to /token');
    }
    if (!options.authorizationCode && !options.interactionCode) {
        throw new AuthSdkError_AuthSdkError('An authorization code (returned from /authorize) must be passed to /token');
    }
    if (!options.codeVerifier) {
        throw new AuthSdkError_AuthSdkError('The "codeVerifier" (generated and saved by your app) must be passed to /token');
    }
}
function getPostData(sdk, options) {
    var params = removeNils({
        'client_id': options.clientId,
        'redirect_uri': options.redirectUri,
        'grant_type': options.interactionCode ? 'interaction_code' : 'authorization_code',
        'code_verifier': options.codeVerifier
    });
    if (options.interactionCode) {
        params['interaction_code'] = options.interactionCode;
    }
    else if (options.authorizationCode) {
        params.code = options.authorizationCode;
    }
    const { clientSecret } = sdk.options;
    if (clientSecret) {
        params['client_secret'] = clientSecret;
    }
    return toQueryString(params).slice(1);
}
function postToTokenEndpoint(sdk, options, urls) {
    validateOptions(options);
    var data = getPostData(sdk, options);
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    return request_httpRequest(sdk, {
        url: urls.tokenUrl,
        method: 'POST',
        args: data,
        headers
    });
}
function postRefreshToken(sdk, options, refreshToken) {
    return request_httpRequest(sdk, {
        url: refreshToken.tokenUrl,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        args: Object.entries({
            client_id: options.clientId,
            grant_type: 'refresh_token',
            scope: refreshToken.scopes.join(' '),
            refresh_token: refreshToken.refreshToken,
        }).map(function ([name, value]) {
            return name + '=' + encodeURIComponent(value);
        }).join('&'),
    });
}


//# sourceMappingURL=token.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewTokensWithRefresh.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function renewTokensWithRefresh(sdk, tokenParams, refreshTokenObject) {
    const { clientId } = sdk.options;
    if (!clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to renew tokens');
    }
    try {
        const renewTokenParams = Object.assign({}, tokenParams, {
            clientId,
        });
        const tokenResponse = await postRefreshToken(sdk, renewTokenParams, refreshTokenObject);
        const urls = getOAuthUrls(sdk, tokenParams);
        const { tokens } = await handleOAuthResponse(sdk, renewTokenParams, tokenResponse, urls);
        const { refreshToken } = tokens;
        if (refreshToken && !isSameRefreshToken(refreshToken, refreshTokenObject)) {
            sdk.tokenManager.updateRefreshToken(refreshToken);
        }
        return tokens;
    }
    catch (err) {
        if (isRefreshTokenInvalidError(err)) {
            sdk.tokenManager.removeRefreshToken();
        }
        throw err;
    }
}


//# sourceMappingURL=renewTokensWithRefresh.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function throwInvalidTokenError() {
    throw new AuthSdkError_AuthSdkError('Renew must be passed a token with an array of scopes and an accessToken or idToken');
}
function getSingleToken(originalToken, tokens) {
    if (isIDToken(originalToken)) {
        return tokens.idToken;
    }
    if (isAccessToken(originalToken)) {
        return tokens.accessToken;
    }
    throwInvalidTokenError();
}
async function renewToken(sdk, token) {
    if (!isIDToken(token) && !isAccessToken(token)) {
        throwInvalidTokenError();
    }
    let tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        tokens = await renewTokensWithRefresh(sdk, {
            scopes: token.scopes,
        }, tokens.refreshToken);
        return getSingleToken(token, tokens);
    }
    var responseType;
    if (sdk.options.pkce) {
        responseType = 'code';
    }
    else if (isAccessToken(token)) {
        responseType = 'token';
    }
    else {
        responseType = 'id_token';
    }
    const { scopes, authorizeUrl, userinfoUrl, issuer } = token;
    return getWithoutPrompt(sdk, {
        responseType,
        scopes,
        authorizeUrl,
        userinfoUrl,
        issuer
    })
        .then(function (res) {
        return getSingleToken(token, res.tokens);
    });
}


//# sourceMappingURL=renewToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewTokens.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function renewTokens(sdk, options) {
    const tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        return renewTokensWithRefresh(sdk, options || {}, tokens.refreshToken);
    }
    if (!tokens.accessToken && !tokens.idToken) {
        throw new AuthSdkError_AuthSdkError('renewTokens() was called but there is no existing token');
    }
    const accessToken = tokens.accessToken || {};
    const idToken = tokens.idToken || {};
    const scopes = accessToken.scopes || idToken.scopes;
    if (!scopes) {
        throw new AuthSdkError_AuthSdkError('renewTokens: invalid tokens: could not read scopes');
    }
    const authorizeUrl = accessToken.authorizeUrl || idToken.authorizeUrl;
    if (!authorizeUrl) {
        throw new AuthSdkError_AuthSdkError('renewTokens: invalid tokens: could not read authorizeUrl');
    }
    const userinfoUrl = accessToken.userinfoUrl || sdk.options.userinfoUrl;
    const issuer = idToken.issuer || sdk.options.issuer;
    options = Object.assign({
        scopes,
        authorizeUrl,
        userinfoUrl,
        issuer
    }, options);
    if (sdk.options.pkce) {
        options.responseType = 'code';
    }
    else {
        const { responseType } = getDefaultTokenParams(sdk);
        options.responseType = responseType;
    }
    return getWithoutPrompt(sdk, options)
        .then(res => res.tokens);
}


//# sourceMappingURL=renewTokens.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getUserInfo.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









async function getUserInfo(sdk, accessTokenObject, idTokenObject) {
    if (!accessTokenObject) {
        accessTokenObject = (await sdk.tokenManager.getTokens()).accessToken;
    }
    if (!idTokenObject) {
        idTokenObject = (await sdk.tokenManager.getTokens()).idToken;
    }
    if (!accessTokenObject || !isAccessToken(accessTokenObject)) {
        return Promise.reject(new AuthSdkError_AuthSdkError('getUserInfo requires an access token object'));
    }
    if (!idTokenObject || !isIDToken(idTokenObject)) {
        return Promise.reject(new AuthSdkError_AuthSdkError('getUserInfo requires an ID token object'));
    }
    return request_httpRequest(sdk, {
        url: accessTokenObject.userinfoUrl,
        method: 'GET',
        accessToken: accessTokenObject.accessToken
    })
        .then(userInfo => {
        if (userInfo.sub === idTokenObject.claims.sub) {
            return userInfo;
        }
        return Promise.reject(new AuthSdkError_AuthSdkError('getUserInfo request was rejected due to token mismatch'));
    })
        .catch(function (err) {
        if (err.xhr && (err.xhr.status === 401 || err.xhr.status === 403)) {
            var authenticateHeader;
            if (err.xhr.headers && isFunction(err.xhr.headers.get) && err.xhr.headers.get('WWW-Authenticate')) {
                authenticateHeader = err.xhr.headers.get('WWW-Authenticate');
            }
            else if (isFunction(err.xhr.getResponseHeader)) {
                authenticateHeader = err.xhr.getResponseHeader('WWW-Authenticate');
            }
            if (authenticateHeader) {
                var errorMatches = authenticateHeader.match(/error="(.*?)"/) || [];
                var errorDescriptionMatches = authenticateHeader.match(/error_description="(.*?)"/) || [];
                var error = errorMatches[1];
                var errorDescription = errorDescriptionMatches[1];
                if (error && errorDescription) {
                    err = new OAuthError(error, errorDescription);
                }
            }
        }
        throw err;
    });
}


//# sourceMappingURL=getUserInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/exchangeCodeForTokens.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function exchangeCodeForTokens(sdk, tokenParams, urls) {
    urls = urls || getOAuthUrls(sdk, tokenParams);
    tokenParams = Object.assign({}, getDefaultTokenParams(sdk), clone(tokenParams));
    const { authorizationCode, interactionCode, codeVerifier, clientId, redirectUri, scopes, ignoreSignature, state } = tokenParams;
    var getTokenOptions = {
        clientId,
        redirectUri,
        authorizationCode,
        interactionCode,
        codeVerifier,
    };
    return postToTokenEndpoint(sdk, getTokenOptions, urls)
        .then((response) => {
        const responseType = ['token'];
        if (scopes.indexOf('openid') !== -1) {
            responseType.push('id_token');
        }
        const handleResponseOptions = {
            clientId,
            redirectUri,
            scopes,
            responseType,
            ignoreSignature,
        };
        return handleOAuthResponse(sdk, handleResponseOptions, response, urls)
            .then((response) => {
            response.code = authorizationCode;
            response.state = state;
            return response;
        });
    })
        .finally(() => {
        sdk.transactionManager.clear();
    });
}


//# sourceMappingURL=exchangeCodeForTokens.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithPopup.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function getWithPopup(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getWithPopup" takes only a single set of options'));
    }
    const popupWindow = loadPopup('/', options);
    options = clone(options) || {};
    Object.assign(options, {
        display: 'popup',
        responseMode: 'okta_post_message',
        popupWindow
    });
    return getToken(sdk, options);
}


//# sourceMappingURL=getWithPopup.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/oauthMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createOAuthMeta(sdk, tokenParams) {
    const issuer = sdk.options.issuer;
    const urls = getOAuthUrls(sdk, tokenParams);
    const oauthMeta = {
        issuer,
        urls,
        clientId: tokenParams.clientId,
        redirectUri: tokenParams.redirectUri,
        responseType: tokenParams.responseType,
        responseMode: tokenParams.responseMode,
        scopes: tokenParams.scopes,
        state: tokenParams.state,
        nonce: tokenParams.nonce,
        ignoreSignature: tokenParams.ignoreSignature,
    };
    if (tokenParams.pkce === false) {
        return oauthMeta;
    }
    const pkceMeta = Object.assign(Object.assign({}, oauthMeta), { codeVerifier: tokenParams.codeVerifier, codeChallengeMethod: tokenParams.codeChallengeMethod, codeChallenge: tokenParams.codeChallenge });
    return pkceMeta;
}


//# sourceMappingURL=oauthMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









async function getWithRedirect(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getWithRedirect" takes only a single set of options'));
    }
    options = clone(options) || {};
    const tokenParams = await prepareTokenParams(sdk, options);
    const meta = createOAuthMeta(sdk, tokenParams);
    const requestUrl = meta.urls.authorizeUrl + buildAuthorizeParams(tokenParams);
    sdk.transactionManager.save(meta, { oauth: true });
    sdk.token.getWithRedirect._setLocation(requestUrl);
}


//# sourceMappingURL=getWithRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/urlParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function urlParamsToObject(hashOrSearch) {
    var plus2space = /\+/g;
    var paramSplit = /([^&=]+)=?([^&]*)/g;
    var fragment = hashOrSearch || '';
    if (fragment.charAt(0) === '#' && fragment.charAt(1) === '/') {
        fragment = fragment.substring(2);
    }
    if (fragment.charAt(0) === '#' || fragment.charAt(0) === '?') {
        fragment = fragment.substring(1);
    }
    var obj = {};
    var param;
    while (true) {
        param = paramSplit.exec(fragment);
        if (!param) {
            break;
        }
        var key = param[1];
        var value = param[2];
        if (key === 'id_token' || key === 'access_token' || key === 'code') {
            obj[key] = value;
        }
        else {
            obj[key] = decodeURIComponent(value.replace(plus2space, ' '));
        }
    }
    return obj;
}


//# sourceMappingURL=urlParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/parseFromUrl.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function removeHash(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) {
        nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.search);
    }
    else {
        nativeLoc.hash = '';
    }
}
function removeSearch(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) {
        nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.hash);
    }
    else {
        nativeLoc.search = '';
    }
}
function getResponseMode(sdk) {
    var defaultResponseMode = sdk.options.pkce ? 'query' : 'fragment';
    var responseMode = sdk.options.responseMode || defaultResponseMode;
    return responseMode;
}
function parseOAuthResponseFromUrl(sdk, options) {
    options = options || {};
    if (isString(options)) {
        options = { url: options };
    }
    else {
        options = options;
    }
    var url = options.url;
    var responseMode = options.responseMode || getResponseMode(sdk);
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    var paramStr;
    if (responseMode === 'query') {
        paramStr = url ? url.substring(url.indexOf('?')) : nativeLoc.search;
    }
    else {
        paramStr = url ? url.substring(url.indexOf('#')) : nativeLoc.hash;
    }
    if (!paramStr) {
        throw new AuthSdkError_AuthSdkError('Unable to parse a token from the url');
    }
    return urlParamsToObject(paramStr);
}
function cleanOAuthResponseFromUrl(sdk, options) {
    const responseMode = options.responseMode || getResponseMode(sdk);
    responseMode === 'query' ? removeSearch(sdk) : removeHash(sdk);
}
async function parseFromUrl(sdk, options) {
    options = options || {};
    if (isString(options)) {
        options = { url: options };
    }
    else {
        options = options;
    }
    const res = parseOAuthResponseFromUrl(sdk, options);
    const state = res.state;
    const oauthParams = sdk.transactionManager.load({
        oauth: true,
        pkce: sdk.options.pkce,
        state
    });
    if (!oauthParams) {
        return Promise.reject(new AuthSdkError_AuthSdkError('Unable to retrieve OAuth redirect params from storage'));
    }
    const urls = oauthParams.urls;
    delete oauthParams.urls;
    if (!options.url) {
        cleanOAuthResponseFromUrl(sdk, options);
    }
    return handleOAuthResponse(sdk, oauthParams, res, urls)
        .catch(err => {
        if (!isInteractionRequiredError(err)) {
            sdk.transactionManager.clear({
                state
            });
        }
        throw err;
    })
        .then(res => {
        sdk.transactionManager.clear({
            state
        });
        return res;
    });
}


//# sourceMappingURL=parseFromUrl.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/webauthn.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getEnrolledCredentials = (authenticatorEnrollments = []) => {
    const credentials = [];
    authenticatorEnrollments.forEach((enrollement) => {
        if (enrollement.key === 'webauthn') {
            credentials.push({
                type: 'public-key',
                id: base64UrlToBuffer(enrollement.credentialId),
            });
        }
    });
    return credentials;
};
const buildCredentialCreationOptions = (activationData, authenticatorEnrollments) => {
    return {
        publicKey: {
            rp: activationData.rp,
            user: {
                id: base64UrlToBuffer(activationData.user.id),
                name: activationData.user.name,
                displayName: activationData.user.displayName
            },
            challenge: base64UrlToBuffer(activationData.challenge),
            pubKeyCredParams: activationData.pubKeyCredParams,
            attestation: activationData.attestation,
            authenticatorSelection: activationData.authenticatorSelection,
            excludeCredentials: getEnrolledCredentials(authenticatorEnrollments),
        }
    };
};
const buildCredentialRequestOptions = (challengeData, authenticatorEnrollments) => {
    return {
        publicKey: {
            challenge: base64UrlToBuffer(challengeData.challenge),
            userVerification: challengeData.userVerification,
            allowCredentials: getEnrolledCredentials(authenticatorEnrollments),
        }
    };
};
const getAttestation = (credential) => {
    const response = credential.response;
    const id = credential.id;
    const clientData = bufferToBase64Url(response.clientDataJSON);
    const attestation = bufferToBase64Url(response.attestationObject);
    return {
        id,
        clientData,
        attestation
    };
};
const getAssertion = (credential) => {
    const response = credential.response;
    const id = credential.id;
    const clientData = bufferToBase64Url(response.clientDataJSON);
    const authenticatorData = bufferToBase64Url(response.authenticatorData);
    const signatureData = bufferToBase64Url(response.signature);
    return {
        id,
        clientData,
        authenticatorData,
        signatureData
    };
};


//# sourceMappingURL=webauthn.js.map

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/console.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getNativeConsole() {
    if (typeof window !== 'undefined') {
        return window.console;
    }
    else if (typeof console !== 'undefined') {
        return console;
    }
    else {
        return undefined;
    }
}
function getConsole() {
    var nativeConsole = getNativeConsole();
    if (nativeConsole && nativeConsole.log) {
        return nativeConsole;
    }
    return {
        log: function () { },
        warn: function () { },
        group: function () { },
        groupEnd: function () { }
    };
}
function warn(text) {
    getConsole().warn('[okta-auth-sdk] WARN: ' + text);
}
function deprecate(text) {
    getConsole().warn('[okta-auth-sdk] DEPRECATION: ' + text);
}
function deprecateWrap(text, fn) {
    return function () {
        deprecate(text);
        return fn.apply(null, arguments);
    };
}


//# sourceMappingURL=console.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/browser/browserStorage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






var storageUtil = {
    getHttpCache() {
        return null;
    },
    getPKCEStorage() {
        return null;
    },
    browserHasLocalStorage: function () {
        try {
            var storage = this.getLocalStorage();
            return this.testStorage(storage);
        }
        catch (e) {
            return false;
        }
    },
    browserHasSessionStorage: function () {
        try {
            var storage = this.getSessionStorage();
            return this.testStorage(storage);
        }
        catch (e) {
            return false;
        }
    },
    testStorageType: function (storageType) {
        var supported = false;
        switch (storageType) {
            case 'sessionStorage':
                supported = this.browserHasSessionStorage();
                break;
            case 'localStorage':
                supported = this.browserHasLocalStorage();
                break;
            case 'cookie':
            case 'memory':
                supported = true;
                break;
            default:
                supported = false;
                break;
        }
        return supported;
    },
    getStorageByType: function (storageType, options) {
        let storageProvider;
        switch (storageType) {
            case 'sessionStorage':
                storageProvider = this.getSessionStorage();
                break;
            case 'localStorage':
                storageProvider = this.getLocalStorage();
                break;
            case 'cookie':
                storageProvider = this.getCookieStorage(options);
                break;
            case 'memory':
                storageProvider = this.getInMemoryStorage();
                break;
            default:
                throw new AuthSdkError_AuthSdkError(`Unrecognized storage option: ${storageType}`);
        }
        return storageProvider;
    },
    findStorageType: function (types) {
        let curType;
        let nextType;
        types = types.slice();
        curType = types.shift();
        nextType = types.length ? types[0] : null;
        if (!nextType) {
            return curType;
        }
        if (this.testStorageType(curType)) {
            return curType;
        }
        warn(`This browser doesn't support ${curType}. Switching to ${nextType}.`);
        return this.findStorageType(types);
    },
    getLocalStorage: function () {
        if (isIE11OrLess() && !window.onstorage) {
            window.onstorage = function () { };
        }
        return localStorage;
    },
    getSessionStorage: function () {
        return sessionStorage;
    },
    getCookieStorage: function (options) {
        const secure = options.secure;
        const sameSite = options.sameSite;
        const sessionCookie = options.sessionCookie;
        if (typeof secure === 'undefined' || typeof sameSite === 'undefined') {
            throw new AuthSdkError_AuthSdkError('getCookieStorage: "secure" and "sameSite" options must be provided');
        }
        const storage = {
            getItem: this.storage.get,
            setItem: (key, value, expiresAt = '2200-01-01T00:00:00.000Z') => {
                expiresAt = (sessionCookie ? null : expiresAt);
                this.storage.set(key, value, expiresAt, {
                    secure: secure,
                    sameSite: sameSite,
                });
            },
            removeItem: (key) => {
                this.storage.delete(key);
            },
            isSharedStorage: () => true
        };
        if (!options.useSeparateCookies) {
            return storage;
        }
        return {
            getItem: function (key) {
                var data = storage.getItem();
                var value = {};
                Object.keys(data).forEach(k => {
                    if (k.indexOf(key) === 0) {
                        value[k.replace(`${key}_`, '')] = JSON.parse(data[k]);
                    }
                });
                return JSON.stringify(value);
            },
            setItem: function (key, value) {
                var existingValues = JSON.parse(this.getItem(key));
                value = JSON.parse(value);
                Object.keys(value).forEach(k => {
                    var storageKey = key + '_' + k;
                    var valueToStore = JSON.stringify(value[k]);
                    storage.setItem(storageKey, valueToStore);
                    delete existingValues[k];
                });
                Object.keys(existingValues).forEach(k => {
                    storage.removeItem(key + '_' + k);
                });
            },
            removeItem: function (key) {
                var existingValues = JSON.parse(this.getItem(key));
                Object.keys(existingValues).forEach(k => {
                    storage.removeItem(key + '_' + k);
                });
            },
            isSharedStorage: () => true
        };
    },
    inMemoryStore: {},
    getInMemoryStorage: function () {
        return {
            getItem: (key) => {
                return this.inMemoryStore[key];
            },
            setItem: (key, value) => {
                this.inMemoryStore[key] = value;
            },
            isSharedStorage: () => false
        };
    },
    testStorage: function (storage) {
        var key = 'okta-test-storage';
        try {
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        }
        catch (e) {
            return false;
        }
    },
    storage: {
        set: function (name, value, expiresAt, options) {
            const { sameSite, secure } = options;
            if (typeof secure === 'undefined' || typeof sameSite === 'undefined') {
                throw new AuthSdkError_AuthSdkError('storage.set: "secure" and "sameSite" options must be provided');
            }
            var cookieOptions = {
                path: options.path || '/',
                secure,
                sameSite
            };
            if (!!(Date.parse(expiresAt))) {
                cookieOptions.expires = new Date(expiresAt);
            }
            api.set(name, value, cookieOptions);
            return this.get(name);
        },
        get: function (name) {
            if (!arguments.length) {
                return api.get();
            }
            return api.get(name);
        },
        delete: function (name) {
            return api.remove(name, { path: '/' });
        }
    }
};


//# sourceMappingURL=browserStorage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/validateToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function validateToken(token, type) {
    if (!isIDToken(token) && !isAccessToken(token) && !isRefreshToken(token)) {
        throw new AuthSdkError_AuthSdkError('Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property');
    }
    if (type === 'accessToken' && !isAccessToken(token)) {
        throw new AuthSdkError_AuthSdkError('invalid accessToken');
    }
    if (type === 'idToken' && !isIDToken(token)) {
        throw new AuthSdkError_AuthSdkError('invalid idToken');
    }
    if (type === 'refreshToken' && !isRefreshToken(token)) {
        throw new AuthSdkError_AuthSdkError('invalid refreshToken');
    }
}


//# sourceMappingURL=validateToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/clock.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class SdkClock {
    constructor(localOffset) {
        this.localOffset = parseInt(localOffset || 0);
    }
    static create( ) {
        var localOffset = 0;
        return new SdkClock(localOffset);
    }
    now() {
        var now = (Date.now() + this.localOffset) / 1000;
        return now;
    }
}


//# sourceMappingURL=clock.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/types/TokenManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const EVENT_EXPIRED = 'expired';
const EVENT_RENEWED = 'renewed';
const EVENT_ADDED = 'added';
const EVENT_REMOVED = 'removed';
const EVENT_ERROR = 'error';
const EVENT_SET_STORAGE = 'set_storage';


//# sourceMappingURL=TokenManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/TokenManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












const DEFAULT_OPTIONS = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    clearPendingRemoveTokens: true,
    storage: undefined,
    expireEarlySeconds: 30,
    storageKey: TOKEN_STORAGE_NAME
};
function defaultState() {
    return {
        expireTimeouts: {},
        renewPromise: null
    };
}
class TokenManager {
    constructor(sdk, options = {}) {
        this.sdk = sdk;
        this.emitter = sdk.emitter;
        if (!this.emitter) {
            throw new AuthSdkError_AuthSdkError('Emitter should be initialized before TokenManager');
        }
        options = Object.assign({}, DEFAULT_OPTIONS, removeNils(options));
        if (!isLocalhost()) {
            options.expireEarlySeconds = DEFAULT_OPTIONS.expireEarlySeconds;
        }
        this.options = options;
        const storageOptions = removeNils({
            storageKey: options.storageKey,
            secure: options.secure,
        });
        if (typeof options.storage === 'object') {
            storageOptions.storageProvider = options.storage;
        }
        else if (options.storage) {
            storageOptions.storageType = options.storage;
        }
        this.storage = sdk.storageManager.getTokenStorage(Object.assign(Object.assign({}, storageOptions), { useSeparateCookies: true }));
        this.clock = SdkClock.create( );
        this.state = defaultState();
    }
    on(event, handler, context) {
        if (context) {
            this.emitter.on(event, handler, context);
        }
        else {
            this.emitter.on(event, handler);
        }
    }
    off(event, handler) {
        if (handler) {
            this.emitter.off(event, handler);
        }
        else {
            this.emitter.off(event);
        }
    }
    hasSharedStorage() {
        return this.storage.isSharedStorage();
    }
    start() {
        if (this.options.clearPendingRemoveTokens) {
            this.clearPendingRemoveTokens();
        }
        this.setExpireEventTimeoutAll();
    }
    stop() {
        this.clearExpireEventTimeoutAll();
    }
    getOptions() {
        return clone(this.options);
    }
    getExpireTime(token) {
        const expireEarlySeconds = this.options.expireEarlySeconds || 0;
        var expireTime = token.expiresAt - expireEarlySeconds;
        return expireTime;
    }
    hasExpired(token) {
        var expireTime = this.getExpireTime(token);
        return expireTime <= this.clock.now();
    }
    emitExpired(key, token) {
        this.emitter.emit(EVENT_EXPIRED, key, token);
    }
    emitRenewed(key, freshToken, oldToken) {
        this.emitter.emit(EVENT_RENEWED, key, freshToken, oldToken);
    }
    emitAdded(key, token) {
        this.emitter.emit(EVENT_ADDED, key, token);
    }
    emitRemoved(key, token) {
        this.emitter.emit(EVENT_REMOVED, key, token);
    }
    emitError(error) {
        this.emitter.emit(EVENT_ERROR, error);
    }
    clearExpireEventTimeout(key) {
        clearTimeout(this.state.expireTimeouts[key]);
        delete this.state.expireTimeouts[key];
        this.state.renewPromise = null;
    }
    clearExpireEventTimeoutAll() {
        var expireTimeouts = this.state.expireTimeouts;
        for (var key in expireTimeouts) {
            if (!Object.prototype.hasOwnProperty.call(expireTimeouts, key)) {
                continue;
            }
            this.clearExpireEventTimeout(key);
        }
    }
    setExpireEventTimeout(key, token) {
        if (isRefreshToken(token)) {
            return;
        }
        var expireTime = this.getExpireTime(token);
        var expireEventWait = Math.max(expireTime - this.clock.now(), 0) * 1000;
        this.clearExpireEventTimeout(key);
        var expireEventTimeout = setTimeout(() => {
            this.emitExpired(key, token);
        }, expireEventWait);
        this.state.expireTimeouts[key] = expireEventTimeout;
    }
    setExpireEventTimeoutAll() {
        var tokenStorage = this.storage.getStorage();
        for (var key in tokenStorage) {
            if (!Object.prototype.hasOwnProperty.call(tokenStorage, key)) {
                continue;
            }
            var token = tokenStorage[key];
            this.setExpireEventTimeout(key, token);
        }
    }
    resetExpireEventTimeoutAll() {
        this.clearExpireEventTimeoutAll();
        this.setExpireEventTimeoutAll();
    }
    add(key, token) {
        var tokenStorage = this.storage.getStorage();
        validateToken(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitAdded(key, token);
        this.setExpireEventTimeout(key, token);
    }
    getSync(key) {
        var tokenStorage = this.storage.getStorage();
        return tokenStorage[key];
    }
    async get(key) {
        return this.getSync(key);
    }
    getTokensSync() {
        const tokens = {};
        const tokenStorage = this.storage.getStorage();
        Object.keys(tokenStorage).forEach(key => {
            const token = tokenStorage[key];
            if (isAccessToken(token)) {
                tokens.accessToken = token;
            }
            else if (isIDToken(token)) {
                tokens.idToken = token;
            }
            else if (isRefreshToken(token)) {
                tokens.refreshToken = token;
            }
        });
        return tokens;
    }
    async getTokens() {
        return this.getTokensSync();
    }
    getStorageKeyByType(type) {
        const tokenStorage = this.storage.getStorage();
        const key = Object.keys(tokenStorage).filter(key => {
            const token = tokenStorage[key];
            return (isAccessToken(token) && type === 'accessToken')
                || (isIDToken(token) && type === 'idToken')
                || (isRefreshToken(token) && type === 'refreshToken');
        })[0];
        return key;
    }
    getTokenType(token) {
        if (isAccessToken(token)) {
            return 'accessToken';
        }
        if (isIDToken(token)) {
            return 'idToken';
        }
        if (isRefreshToken(token)) {
            return 'refreshToken';
        }
        throw new AuthSdkError_AuthSdkError('Unknown token type');
    }
    emitSetStorageEvent() {
        if (isIE11OrLess()) {
            const storage = this.storage.getStorage();
            this.emitter.emit(EVENT_SET_STORAGE, storage);
        }
    }
    getStorage() {
        return this.storage;
    }
    setTokens(tokens,
    accessTokenCb, idTokenCb, refreshTokenCb) {
        const handleTokenCallback = (key, token) => {
            const type = this.getTokenType(token);
            if (type === 'accessToken') {
                accessTokenCb && accessTokenCb(key, token);
            }
            else if (type === 'idToken') {
                idTokenCb && idTokenCb(key, token);
            }
            else if (type === 'refreshToken') {
                refreshTokenCb && refreshTokenCb(key, token);
            }
        };
        const handleAdded = (key, token) => {
            this.emitAdded(key, token);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRenewed = (key, token, oldToken) => {
            this.emitRenewed(key, token, oldToken);
            this.clearExpireEventTimeout(key);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRemoved = (key, token) => {
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, token);
            handleTokenCallback(key, token);
        };
        const types = ['idToken', 'accessToken', 'refreshToken'];
        const existingTokens = this.getTokensSync();
        types.forEach((type) => {
            const token = tokens[type];
            if (token) {
                validateToken(token, type);
            }
        });
        const storage = types.reduce((storage, type) => {
            const token = tokens[type];
            if (token) {
                const storageKey = this.getStorageKeyByType(type) || type;
                storage[storageKey] = token;
            }
            return storage;
        }, {});
        this.storage.setStorage(storage);
        this.emitSetStorageEvent();
        types.forEach(type => {
            const newToken = tokens[type];
            const existingToken = existingTokens[type];
            const storageKey = this.getStorageKeyByType(type) || type;
            if (newToken && existingToken) {
                handleRemoved(storageKey, existingToken);
                handleAdded(storageKey, newToken);
                handleRenewed(storageKey, newToken, existingToken);
            }
            else if (newToken) {
                handleAdded(storageKey, newToken);
            }
            else if (existingToken) {
                handleRemoved(storageKey, existingToken);
            }
        });
    }
    remove(key) {
        this.clearExpireEventTimeout(key);
        var tokenStorage = this.storage.getStorage();
        var removedToken = tokenStorage[key];
        delete tokenStorage[key];
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitRemoved(key, removedToken);
    }
    async renewToken(token) {
        var _a;
        return (_a = this.sdk.token) === null || _a === void 0 ? void 0 : _a.renew(token);
    }
    validateToken(token) {
        return validateToken(token);
    }
    renew(key) {
        if (this.state.renewPromise) {
            return this.state.renewPromise;
        }
        try {
            var token = this.getSync(key);
            if (!token) {
                throw new AuthSdkError_AuthSdkError('The tokenManager has no token for the key: ' + key);
            }
        }
        catch (e) {
            return Promise.reject(e);
        }
        this.clearExpireEventTimeout(key);
        this.state.renewPromise = this.sdk.token.renewTokens()
            .then(tokens => {
            this.setTokens(tokens);
            const tokenType = this.getTokenType(token);
            return tokens[tokenType];
        })
            .catch(err => {
            this.remove(key);
            err.tokenKey = key;
            this.emitError(err);
            throw err;
        })
            .finally(() => {
            this.state.renewPromise = null;
        });
        return this.state.renewPromise;
    }
    clear() {
        const tokens = this.getTokensSync();
        this.clearExpireEventTimeoutAll();
        this.storage.clearStorage();
        this.emitSetStorageEvent();
        Object.keys(tokens).forEach(key => {
            this.emitRemoved(key, tokens[key]);
        });
    }
    clearPendingRemoveTokens() {
        const tokenStorage = this.storage.getStorage();
        const removedTokens = {};
        Object.keys(tokenStorage).forEach(key => {
            if (tokenStorage[key].pendingRemove) {
                removedTokens[key] = tokenStorage[key];
                delete tokenStorage[key];
            }
        });
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        Object.keys(removedTokens).forEach(key => {
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, removedTokens[key]);
        });
    }
    updateRefreshToken(token) {
        const key = this.getStorageKeyByType('refreshToken') || REFRESH_TOKEN_STORAGE_KEY;
        var tokenStorage = this.storage.getStorage();
        validateToken(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
    }
    removeRefreshToken() {
        const key = this.getStorageKeyByType('refreshToken') || REFRESH_TOKEN_STORAGE_KEY;
        this.remove(key);
    }
    addPendingRemoveFlags() {
        const tokens = this.getTokensSync();
        Object.keys(tokens).forEach(key => {
            tokens[key].pendingRemove = true;
        });
        this.setTokens(tokens);
    }
}


//# sourceMappingURL=TokenManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/AutoRenewService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







class AutoRenewService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.tokenManager = tokenManager;
        this.options = options;
        this.renewTimeQueue = [];
        this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
    }
    shouldThrottleRenew() {
        let res = false;
        this.renewTimeQueue.push(Date.now());
        if (this.renewTimeQueue.length >= 10) {
            const firstTime = this.renewTimeQueue.shift();
            const lastTime = this.renewTimeQueue[this.renewTimeQueue.length - 1];
            res = (lastTime - firstTime) < 30 * 1000;
        }
        return res;
    }
    requiresLeadership() {
        return !!this.options.syncStorage && isBrowser();
    }
    onTokenExpiredHandler(key) {
        if (this.options.autoRenew) {
            if (this.shouldThrottleRenew()) {
                const error = new AuthSdkError_AuthSdkError('Too many token renew requests');
                this.tokenManager.emitError(error);
            }
            else {
                this.tokenManager.renew(key).catch(() => { });
            }
        }
        else if (this.options.autoRemove) {
            this.tokenManager.remove(key);
        }
    }
    canStart() {
        return (!!this.options.autoRenew || !!this.options.autoRemove);
    }
    async start() {
        if (this.canStart()) {
            await this.stop();
            this.tokenManager.on(EVENT_EXPIRED, this.onTokenExpiredHandler);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            this.tokenManager.off(EVENT_EXPIRED, this.onTokenExpiredHandler);
            this.renewTimeQueue = [];
            this.started = false;
        }
    }
    isStarted() {
        return this.started;
    }
}


//# sourceMappingURL=AutoRenewService.js.map

;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/util.js
/**
 * returns true if the given object is a promise
 */
function util_isPromise(obj) {
  if (obj && typeof obj.then === 'function') {
    return true;
  } else {
    return false;
  }
}
var util_PROMISE_RESOLVED_FALSE = Promise.resolve(false);
var PROMISE_RESOLVED_TRUE = Promise.resolve(true);
var PROMISE_RESOLVED_VOID = Promise.resolve();
function sleep(time, resolveWith) {
  if (!time) time = 0;
  return new Promise(function (res) {
    return setTimeout(function () {
      return res(resolveWith);
    }, time);
  });
}
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * https://stackoverflow.com/a/8084248
 */

function randomToken() {
  return Math.random().toString(36).substring(2);
}
var lastMs = 0;
var additional = 0;
/**
 * returns the current time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */

function microSeconds() {
  var ms = new Date().getTime();

  if (ms === lastMs) {
    additional++;
    return ms * 1000 + additional;
  } else {
    lastMs = ms;
    additional = 0;
    return ms * 1000;
  }
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/native.js

var native_microSeconds = microSeconds;
var type = 'native';
function create(channelName) {
  var state = {
    messagesCallback: null,
    bc: new BroadcastChannel(channelName),
    subFns: [] // subscriberFunctions

  };

  state.bc.onmessage = function (msg) {
    if (state.messagesCallback) {
      state.messagesCallback(msg.data);
    }
  };

  return state;
}
function native_close(channelState) {
  channelState.bc.close();
  channelState.subFns = [];
}
function postMessage(channelState, messageJson) {
  try {
    channelState.bc.postMessage(messageJson, false);
    return PROMISE_RESOLVED_VOID;
  } catch (err) {
    return Promise.reject(err);
  }
}
function onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function canBeUsed() {
  if (typeof window === 'undefined') {
    return false;
  }

  if (typeof BroadcastChannel === 'function') {
    if (BroadcastChannel._pubkey) {
      throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
    }

    return true;
  } else {
    return false;
  }
}
function averageResponseTime() {
  return 150;
}
/* harmony default export */ var methods_native = ({
  create: create,
  close: native_close,
  onMessage: onMessage,
  postMessage: postMessage,
  canBeUsed: canBeUsed,
  type: type,
  averageResponseTime: averageResponseTime,
  microSeconds: native_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/oblivious-set/dist/es/index.js
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */
var ObliviousSet = /** @class */ (function () {
    function ObliviousSet(ttl) {
        this.ttl = ttl;
        this.map = new Map();
        /**
         * Creating calls to setTimeout() is expensive,
         * so we only do that if there is not timeout already open.
         */
        this._to = false;
    }
    ObliviousSet.prototype.has = function (value) {
        return this.map.has(value);
    };
    ObliviousSet.prototype.add = function (value) {
        var _this = this;
        this.map.set(value, now());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */
        if (!this._to) {
            this._to = true;
            setTimeout(function () {
                _this._to = false;
                removeTooOldValues(_this);
            }, 0);
        }
    };
    ObliviousSet.prototype.clear = function () {
        this.map.clear();
    };
    return ObliviousSet;
}());

/**
 * Removes all entries from the set
 * where the TTL has expired
 */
function removeTooOldValues(obliviousSet) {
    var olderThen = now() - obliviousSet.ttl;
    var iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */
    while (true) {
        var next = iterator.next().value;
        if (!next) {
            return; // no more elements
        }
        var value = next[0];
        var time = next[1];
        if (time < olderThen) {
            obliviousSet.map.delete(value);
        }
        else {
            // We reached a value that is not old enough
            return;
        }
    }
}
function now() {
    return new Date().getTime();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/options.js
function options_fillOptionsWithDefaults() {
  var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = JSON.parse(JSON.stringify(originalOptions)); // main

  if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true; // indexed-db

  if (!options.idb) options.idb = {}; //  after this time the messages get deleted

  if (!options.idb.ttl) options.idb.ttl = 1000 * 45;
  if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150; //  handles abrupt db onclose events.

  if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose; // localstorage

  if (!options.localstorage) options.localstorage = {};
  if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 1000 * 60; // custom methods

  if (originalOptions.methods) options.methods = originalOptions.methods; // node

  if (!options.node) options.node = {};
  if (!options.node.ttl) options.node.ttl = 1000 * 60 * 2; // 2 minutes;

  /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */

  if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
  if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
  return options;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/indexed-db.js
/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */

var indexed_db_microSeconds = microSeconds;


var DB_PREFIX = 'pubkey.broadcast-channel-0-';
var OBJECT_STORE_ID = 'messages';
/**
 * Use relaxed durability for faster performance on all transactions.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */

var TRANSACTION_SETTINGS = {
  durability: 'relaxed'
};
var indexed_db_type = 'idb';
function getIdb() {
  if (typeof indexedDB !== 'undefined') return indexedDB;

  if (typeof window !== 'undefined') {
    if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
    if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
  }

  return false;
}
/**
 * If possible, we should explicitly commit IndexedDB transactions
 * for better performance.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */

function commitIndexedDBTransaction(tx) {
  if (tx.commit) {
    tx.commit();
  }
}
function createDatabase(channelName) {
  var IndexedDB = getIdb(); // create table

  var dbName = DB_PREFIX + channelName;
  /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */

  var openRequest = IndexedDB.open(dbName);

  openRequest.onupgradeneeded = function (ev) {
    var db = ev.target.result;
    db.createObjectStore(OBJECT_STORE_ID, {
      keyPath: 'id',
      autoIncrement: true
    });
  };

  var dbPromise = new Promise(function (res, rej) {
    openRequest.onerror = function (ev) {
      return rej(ev);
    };

    openRequest.onsuccess = function () {
      res(openRequest.result);
    };
  });
  return dbPromise;
}
/**
 * writes the new message to the database
 * so other readers can find it
 */

function writeMessage(db, readerUuid, messageJson) {
  var time = new Date().getTime();
  var writeObject = {
    uuid: readerUuid,
    time: time,
    data: messageJson
  };
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  return new Promise(function (res, rej) {
    tx.oncomplete = function () {
      return res();
    };

    tx.onerror = function (ev) {
      return rej(ev);
    };

    var objectStore = tx.objectStore(OBJECT_STORE_ID);
    objectStore.add(writeObject);
    commitIndexedDBTransaction(tx);
  });
}
function getAllMessages(db) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;

      if (cursor) {
        ret.push(cursor.value); //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);

        cursor["continue"]();
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function getMessagesHigherThan(db, lastCursorId) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
  /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */

  if (objectStore.getAll) {
    var getAllRequest = objectStore.getAll(keyRangeValue);
    return new Promise(function (res, rej) {
      getAllRequest.onerror = function (err) {
        return rej(err);
      };

      getAllRequest.onsuccess = function (e) {
        res(e.target.result);
      };
    });
  }

  function openCursor() {
    // Occasionally Safari will fail on IDBKeyRange.bound, this
    // catches that error, having it open the cursor to the first
    // item. When it gets data it will advance to the desired key.
    try {
      keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
      return objectStore.openCursor(keyRangeValue);
    } catch (e) {
      return objectStore.openCursor();
    }
  }

  return new Promise(function (res, rej) {
    var openCursorRequest = openCursor();

    openCursorRequest.onerror = function (err) {
      return rej(err);
    };

    openCursorRequest.onsuccess = function (ev) {
      var cursor = ev.target.result;

      if (cursor) {
        if (cursor.value.id < lastCursorId + 1) {
          cursor["continue"](lastCursorId + 1);
        } else {
          ret.push(cursor.value);
          cursor["continue"]();
        }
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function removeMessagesById(db, ids) {
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  return Promise.all(ids.map(function (id) {
    var deleteRequest = objectStore["delete"](id);
    return new Promise(function (res) {
      deleteRequest.onsuccess = function () {
        return res();
      };
    });
  }));
}
function getOldMessages(db, ttl) {
  var olderThen = new Date().getTime() - ttl;
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;

      if (cursor) {
        var msgObk = cursor.value;

        if (msgObk.time < olderThen) {
          ret.push(msgObk); //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);

          cursor["continue"]();
        } else {
          // no more old messages,
          commitIndexedDBTransaction(tx);
          res(ret);
          return;
        }
      } else {
        res(ret);
      }
    };
  });
}
function cleanOldMessages(db, ttl) {
  return getOldMessages(db, ttl).then(function (tooOld) {
    return removeMessagesById(db, tooOld.map(function (msg) {
      return msg.id;
    }));
  });
}
function indexed_db_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);
  return createDatabase(channelName).then(function (db) {
    var state = {
      closed: false,
      lastCursorId: 0,
      channelName: channelName,
      options: options,
      uuid: randomToken(),

      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new ObliviousSet(options.idb.ttl * 2),
      // ensures we do not read messages in parrallel
      writeBlockPromise: PROMISE_RESOLVED_VOID,
      messagesCallback: null,
      readQueuePromises: [],
      db: db
    };
    /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */

    db.onclose = function () {
      state.closed = true;
      if (options.idb.onclose) options.idb.onclose();
    };
    /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */


    _readLoop(state);

    return state;
  });
}

function _readLoop(state) {
  if (state.closed) return;
  readNewMessages(state).then(function () {
    return sleep(state.options.idb.fallbackInterval);
  }).then(function () {
    return _readLoop(state);
  });
}

function _filterMessage(msgObj, state) {
  if (msgObj.uuid === state.uuid) return false; // send by own

  if (state.eMIs.has(msgObj.id)) return false; // already emitted

  if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback

  return true;
}
/**
 * reads all new messages from the database and emits them
 */


function readNewMessages(state) {
  // channel already closed
  if (state.closed) return PROMISE_RESOLVED_VOID; // if no one is listening, we do not need to scan for new messages

  if (!state.messagesCallback) return PROMISE_RESOLVED_VOID;
  return getMessagesHigherThan(state.db, state.lastCursorId).then(function (newerMessages) {
    var useMessages = newerMessages
    /**
     * there is a bug in iOS where the msgObj can be undefined some times
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */
    .filter(function (msgObj) {
      return !!msgObj;
    }).map(function (msgObj) {
      if (msgObj.id > state.lastCursorId) {
        state.lastCursorId = msgObj.id;
      }

      return msgObj;
    }).filter(function (msgObj) {
      return _filterMessage(msgObj, state);
    }).sort(function (msgObjA, msgObjB) {
      return msgObjA.time - msgObjB.time;
    }); // sort by time

    useMessages.forEach(function (msgObj) {
      if (state.messagesCallback) {
        state.eMIs.add(msgObj.id);
        state.messagesCallback(msgObj.data);
      }
    });
    return PROMISE_RESOLVED_VOID;
  });
}

function indexed_db_close(channelState) {
  channelState.closed = true;
  channelState.db.close();
}
function indexed_db_postMessage(channelState, messageJson) {
  channelState.writeBlockPromise = channelState.writeBlockPromise.then(function () {
    return writeMessage(channelState.db, channelState.uuid, messageJson);
  }).then(function () {
    if (randomInt(0, 10) === 0) {
      /* await (do not await) */
      cleanOldMessages(channelState.db, channelState.options.idb.ttl);
    }
  });
  return channelState.writeBlockPromise;
}
function indexed_db_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
  readNewMessages(channelState);
}
function indexed_db_canBeUsed() {
  var idb = getIdb();

  if (!idb) {
    return false;
  }

  return true;
}
function indexed_db_averageResponseTime(options) {
  return options.idb.fallbackInterval * 2;
}
/* harmony default export */ var indexed_db = ({
  create: indexed_db_create,
  close: indexed_db_close,
  onMessage: indexed_db_onMessage,
  postMessage: indexed_db_postMessage,
  canBeUsed: indexed_db_canBeUsed,
  type: indexed_db_type,
  averageResponseTime: indexed_db_averageResponseTime,
  microSeconds: indexed_db_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/localstorage.js
/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside of webworkers because they have no access to locastorage
 * This is basically implemented to support IE9 or your grandmothers toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */



var localstorage_microSeconds = microSeconds;
var KEY_PREFIX = 'pubkey.broadcastChannel-';
var localstorage_type = 'localstorage';
/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */

function getLocalStorage() {
  var localStorage;
  if (typeof window === 'undefined') return null;

  try {
    localStorage = window.localStorage;
    localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
  } catch (e) {// New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
  }

  return localStorage;
}
function storageKey(channelName) {
  return KEY_PREFIX + channelName;
}
/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/

function localstorage_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    sleep().then(function () {
      var key = storageKey(channelState.channelName);
      var writeObj = {
        token: randomToken(),
        time: new Date().getTime(),
        data: messageJson,
        uuid: channelState.uuid
      };
      var value = JSON.stringify(writeObj);
      getLocalStorage().setItem(key, value);
      /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */

      var ev = document.createEvent('Event');
      ev.initEvent('storage', true, true);
      ev.key = key;
      ev.newValue = value;
      window.dispatchEvent(ev);
      res();
    });
  });
}
function addStorageEventListener(channelName, fn) {
  var key = storageKey(channelName);

  var listener = function listener(ev) {
    if (ev.key === key) {
      fn(JSON.parse(ev.newValue));
    }
  };

  window.addEventListener('storage', listener);
  return listener;
}
function removeStorageEventListener(listener) {
  window.removeEventListener('storage', listener);
}
function localstorage_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);

  if (!localstorage_canBeUsed()) {
    throw new Error('BroadcastChannel: localstorage cannot be used');
  }

  var uuid = randomToken();
  /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */

  var eMIs = new ObliviousSet(options.localstorage.removeTimeout);
  var state = {
    channelName: channelName,
    uuid: uuid,
    eMIs: eMIs // emittedMessagesIds

  };
  state.listener = addStorageEventListener(channelName, function (msgObj) {
    if (!state.messagesCallback) return; // no listener

    if (msgObj.uuid === uuid) return; // own message

    if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted

    if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old

    eMIs.add(msgObj.token);
    state.messagesCallback(msgObj.data);
  });
  return state;
}
function localstorage_close(channelState) {
  removeStorageEventListener(channelState.listener);
}
function localstorage_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
}
function localstorage_canBeUsed() {
  var ls = getLocalStorage();
  if (!ls) return false;

  try {
    var key = '__broadcastchannel_check';
    ls.setItem(key, 'works');
    ls.removeItem(key);
  } catch (e) {
    // Safari 10 in private mode will not allow write access to local
    // storage and fail with a QuotaExceededError. See
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
    return false;
  }

  return true;
}
function localstorage_averageResponseTime() {
  var defaultTime = 120;
  var userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    // safari is much slower so this time is higher
    return defaultTime * 2;
  }

  return defaultTime;
}
/* harmony default export */ var localstorage = ({
  create: localstorage_create,
  close: localstorage_close,
  onMessage: localstorage_onMessage,
  postMessage: localstorage_postMessage,
  canBeUsed: localstorage_canBeUsed,
  type: localstorage_type,
  averageResponseTime: localstorage_averageResponseTime,
  microSeconds: localstorage_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/simulate.js

var simulate_microSeconds = microSeconds;
var simulate_type = 'simulate';
var SIMULATE_CHANNELS = new Set();
function simulate_create(channelName) {
  var state = {
    name: channelName,
    messagesCallback: null
  };
  SIMULATE_CHANNELS.add(state);
  return state;
}
function simulate_close(channelState) {
  SIMULATE_CHANNELS["delete"](channelState);
}
function simulate_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    return setTimeout(function () {
      var channelArray = Array.from(SIMULATE_CHANNELS);
      channelArray.filter(function (channel) {
        return channel.name === channelState.name;
      }).filter(function (channel) {
        return channel !== channelState;
      }).filter(function (channel) {
        return !!channel.messagesCallback;
      }).forEach(function (channel) {
        return channel.messagesCallback(messageJson);
      });
      res();
    }, 5);
  });
}
function simulate_onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function simulate_canBeUsed() {
  return true;
}
function simulate_averageResponseTime() {
  return 5;
}
/* harmony default export */ var simulate = ({
  create: simulate_create,
  close: simulate_close,
  onMessage: simulate_onMessage,
  postMessage: simulate_postMessage,
  canBeUsed: simulate_canBeUsed,
  type: simulate_type,
  averageResponseTime: simulate_averageResponseTime,
  microSeconds: simulate_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/method-chooser.js



 // the line below will be removed from es5/browser builds


var METHODS = [methods_native, // fastest
indexed_db, localstorage];
function method_chooser_chooseMethod(options) {
  var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean); // the line below will be removed from es5/browser builds


  if (options.type) {
    if (options.type === 'simulate') {
      // only use simulate-method if directly chosen
      return simulate;
    }

    var ret = chooseMethods.find(function (m) {
      return m.type === options.type;
    });
    if (!ret) throw new Error('method-type ' + options.type + ' not found');else return ret;
  }
  /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage is been chosen
   */


  if (!options.webWorkerSupport) {
    chooseMethods = chooseMethods.filter(function (m) {
      return m.type !== 'idb';
    });
  }

  var useMethod = chooseMethods.find(function (method) {
    return method.canBeUsed();
  });
  if (!useMethod) throw new Error("No useable method found in " + JSON.stringify(METHODS.map(function (m) {
    return m.type;
  })));else return useMethod;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/broadcast-channel.js



/**
 * Contains all open channels,
 * used in tests to ensure everything is closed.
 */

var OPEN_BROADCAST_CHANNELS = new Set();
var lastId = 0;
var broadcast_channel_BroadcastChannel = function BroadcastChannel(name, options) {
  // identifier of the channel to debug stuff
  this.id = lastId++;
  OPEN_BROADCAST_CHANNELS.add(this);
  this.name = name;

  if (ENFORCED_OPTIONS) {
    options = ENFORCED_OPTIONS;
  }

  this.options = options_fillOptionsWithDefaults(options);
  this.method = method_chooser_chooseMethod(this.options); // isListening

  this._iL = false;
  /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */

  this._onML = null;
  /**
   * _addEventListeners
   */

  this._addEL = {
    message: [],
    internal: []
  };
  /**
   * Unsend message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */

  this._uMP = new Set();
  /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */

  this._befC = [];
  /**
   * _preparePromise
   */

  this._prepP = null;

  _prepareChannel(this);
}; // STATICS

/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */

broadcast_channel_BroadcastChannel._pubkey = true;
/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */

function clearNodeFolder(options) {
  options = fillOptionsWithDefaults(options);
  var method = chooseMethod(options);

  if (method.type === 'node') {
    return method.clearNodeFolder().then(function () {
      return true;
    });
  } else {
    return PROMISE_RESOLVED_FALSE;
  }
}
/**
 * if set, this method is enforced,
 * no mather what the options are
 */

var ENFORCED_OPTIONS;
function enforceOptions(options) {
  ENFORCED_OPTIONS = options;
} // PROTOTYPE

broadcast_channel_BroadcastChannel.prototype = {
  postMessage: function postMessage(msg) {
    if (this.closed) {
      throw new Error('BroadcastChannel.postMessage(): ' + 'Cannot post message after channel has closed ' +
      /**
       * In the past when this error appeared, it was realy hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(msg));
    }

    return _post(this, 'message', msg);
  },
  postInternal: function postInternal(msg) {
    return _post(this, 'internal', msg);
  },

  set onmessage(fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };

    _removeListenerObject(this, 'message', this._onML);

    if (fn && typeof fn === 'function') {
      this._onML = listenObj;

      _addListenerObject(this, 'message', listenObj);
    } else {
      this._onML = null;
    }
  },

  addEventListener: function addEventListener(type, fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };

    _addListenerObject(this, type, listenObj);
  },
  removeEventListener: function removeEventListener(type, fn) {
    var obj = this._addEL[type].find(function (obj) {
      return obj.fn === fn;
    });

    _removeListenerObject(this, type, obj);
  },
  close: function close() {
    var _this = this;

    if (this.closed) {
      return;
    }

    OPEN_BROADCAST_CHANNELS["delete"](this);
    this.closed = true;
    var awaitPrepare = this._prepP ? this._prepP : PROMISE_RESOLVED_VOID;
    this._onML = null;
    this._addEL.message = [];
    return awaitPrepare // wait until all current sending are processed
    .then(function () {
      return Promise.all(Array.from(_this._uMP));
    }) // run before-close hooks
    .then(function () {
      return Promise.all(_this._befC.map(function (fn) {
        return fn();
      }));
    }) // close the channel
    .then(function () {
      return _this.method.close(_this._state);
    });
  },

  get type() {
    return this.method.type;
  },

  get isClosed() {
    return this.closed;
  }

};
/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */

function _post(broadcastChannel, type, msg) {
  var time = broadcastChannel.method.microSeconds();
  var msgObj = {
    time: time,
    type: type,
    data: msg
  };
  var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : PROMISE_RESOLVED_VOID;
  return awaitPrepare.then(function () {
    var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj); // add/remove to unsend messages list

    broadcastChannel._uMP.add(sendPromise);

    sendPromise["catch"]().then(function () {
      return broadcastChannel._uMP["delete"](sendPromise);
    });
    return sendPromise;
  });
}

function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);

  if (util_isPromise(maybePromise)) {
    channel._prepP = maybePromise;
    maybePromise.then(function (s) {
      // used in tests to simulate slow runtime

      /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/
      channel._state = s;
    });
  } else {
    channel._state = maybePromise;
  }
}

function _hasMessageListeners(channel) {
  if (channel._addEL.message.length > 0) return true;
  if (channel._addEL.internal.length > 0) return true;
  return false;
}

function _addListenerObject(channel, type, obj) {
  channel._addEL[type].push(obj);

  _startListening(channel);
}

function _removeListenerObject(channel, type, obj) {
  channel._addEL[type] = channel._addEL[type].filter(function (o) {
    return o !== obj;
  });

  _stopListening(channel);
}

function _startListening(channel) {
  if (!channel._iL && _hasMessageListeners(channel)) {
    // someone is listening, start subscribing
    var listenerFn = function listenerFn(msgObj) {
      channel._addEL[msgObj.type].forEach(function (listenerObject) {
        /**
         * Getting the current time in JavaScript has no good precision.
         * So instead of only listening to events that happend 'after' the listener
         * was added, we also listen to events that happended 100ms before it.
         * This ensures that when another process, like a WebWorker, sends events
         * we do not miss them out because their timestamp is a bit off compared to the main process.
         * Not doing this would make messages missing when we send data directly after subscribing and awaiting a response.
         * @link https://johnresig.com/blog/accuracy-of-javascript-time/
         */
        var hundredMsInMicro = 100 * 1000;
        var minMessageTime = listenerObject.time - hundredMsInMicro;

        if (msgObj.time >= minMessageTime) {
          listenerObject.fn(msgObj.data);
        }
      });
    };

    var time = channel.method.microSeconds();

    if (channel._prepP) {
      channel._prepP.then(function () {
        channel._iL = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._iL = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}

function _stopListening(channel) {
  if (channel._iL && !_hasMessageListeners(channel)) {
    // noone is listening, stop subscribing
    channel._iL = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}
// EXTERNAL MODULE: ./node_modules/detect-node/browser.js
var browser = __webpack_require__(25643);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./node_modules/unload/dist/es/browser.js
/* global WorkerGlobalScope */
function add(fn) {
  if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {// this is run inside of a webworker
  } else {
    /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */
    if (typeof window.addEventListener !== 'function') return;
    /**
     * for normal browser-windows, we use the beforeunload-event
     */

    window.addEventListener('beforeunload', function () {
      fn();
    }, true);
    /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */

    window.addEventListener('unload', function () {
      fn();
    }, true);
  }
  /**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */

}

/* harmony default export */ var es_browser = ({
  add: add
});
// EXTERNAL MODULE: ./node.js (ignored)
var node_ignored_ = __webpack_require__(199);
var node_ignored_default = /*#__PURE__*/__webpack_require__.n(node_ignored_);
;// CONCATENATED MODULE: ./node_modules/unload/dist/es/index.js



var USE_METHOD = (browser_default()) ? (node_ignored_default()) : es_browser;
var LISTENERS = new Set();
var startedListening = false;

function startListening() {
  if (startedListening) return;
  startedListening = true;
  USE_METHOD.add(runAll);
}

function es_add(fn) {
  startListening();
  if (typeof fn !== 'function') throw new Error('Listener is no function');
  LISTENERS.add(fn);
  var addReturn = {
    remove: function remove() {
      return LISTENERS["delete"](fn);
    },
    run: function run() {
      LISTENERS["delete"](fn);
      return fn();
    }
  };
  return addReturn;
}
function runAll() {
  var promises = [];
  LISTENERS.forEach(function (fn) {
    promises.push(fn());
    LISTENERS["delete"](fn);
  });
  return Promise.all(promises);
}
function removeAll() {
  LISTENERS.clear();
}
function getSize() {
  return LISTENERS.size;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/leader-election.js



var LeaderElection = function LeaderElection(broadcastChannel, options) {
  var _this = this;

  this.broadcastChannel = broadcastChannel;
  this._options = options;
  this.isLeader = false;
  this.hasLeader = false;
  this.isDead = false;
  this.token = randomToken();
  /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */

  this._aplQ = PROMISE_RESOLVED_VOID; // amount of unfinished applyOnce() calls

  this._aplQC = 0; // things to clean up

  this._unl = []; // _unloads

  this._lstns = []; // _listeners

  this._dpL = function () {}; // onduplicate listener


  this._dpLC = false; // true when onduplicate called

  /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */

  var hasLeaderListener = function hasLeaderListener(msg) {
    if (msg.context === 'leader') {
      if (msg.action === 'death') {
        _this.hasLeader = false;
      }

      if (msg.action === 'tell') {
        _this.hasLeader = true;
      }
    }
  };

  this.broadcastChannel.addEventListener('internal', hasLeaderListener);

  this._lstns.push(hasLeaderListener);
};

LeaderElection.prototype = {
  /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */
  applyOnce: function applyOnce( // true if the applyOnce() call came from the fallbackInterval cycle
  isFromFallbackInterval) {
    var _this2 = this;

    if (this.isLeader) {
      return sleep(0, true);
    }

    if (this.isDead) {
      return sleep(0, false);
    }
    /**
     * Already applying more then once,
     * -> wait for the apply queue to be finished.
     */


    if (this._aplQC > 1) {
      return this._aplQ;
    }
    /**
     * Add a new apply-run
     */


    var applyRun = function applyRun() {
      /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */
      if (_this2.isLeader) {
        return PROMISE_RESOLVED_TRUE;
      }

      var stopCriteria = false;
      var stopCriteriaPromiseResolve;
      /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */

      var stopCriteriaPromise = new Promise(function (res) {
        stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
          stopCriteria = true;
          res();
        };
      });
      var recieved = [];

      var handleMessage = function handleMessage(msg) {
        if (msg.context === 'leader' && msg.token != _this2.token) {
          recieved.push(msg);

          if (msg.action === 'apply') {
            // other is applying
            if (msg.token > _this2.token) {
              /**
               * other has higher token
               * -> stop applying and let other become leader.
               */
              stopCriteriaPromiseResolve();
            }
          }

          if (msg.action === 'tell') {
            // other is already leader
            stopCriteriaPromiseResolve();
            _this2.hasLeader = true;
          }
        }
      };

      _this2.broadcastChannel.addEventListener('internal', handleMessage);
      /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other intances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */


      var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;

      var applyPromise = _sendMessage(_this2, 'apply') // send out that this one is applying
      .then(function () {
        return Promise.race([sleep(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      }) // send again in case another instance was just created
      .then(function () {
        return _sendMessage(_this2, 'apply');
      }) // let others time to respond
      .then(function () {
        return Promise.race([sleep(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      })["catch"](function () {}).then(function () {
        _this2.broadcastChannel.removeEventListener('internal', handleMessage);

        if (!stopCriteria) {
          // no stop criteria -> own is leader
          return beLeader(_this2).then(function () {
            return true;
          });
        } else {
          // other is leader
          return false;
        }
      });

      return applyPromise;
    };

    this._aplQC = this._aplQC + 1;
    this._aplQ = this._aplQ.then(function () {
      return applyRun();
    }).then(function () {
      _this2._aplQC = _this2._aplQC - 1;
    });
    return this._aplQ.then(function () {
      return _this2.isLeader;
    });
  },
  awaitLeadership: function awaitLeadership() {
    if (
    /* _awaitLeadershipPromise */
    !this._aLP) {
      this._aLP = _awaitLeadershipOnce(this);
    }

    return this._aLP;
  },

  set onduplicate(fn) {
    this._dpL = fn;
  },

  die: function die() {
    var _this3 = this;

    this._lstns.forEach(function (listener) {
      return _this3.broadcastChannel.removeEventListener('internal', listener);
    });

    this._lstns = [];

    this._unl.forEach(function (uFn) {
      return uFn.remove();
    });

    this._unl = [];

    if (this.isLeader) {
      this.hasLeader = false;
      this.isLeader = false;
    }

    this.isDead = true;
    return _sendMessage(this, 'death');
  }
};
/**
 * @param leaderElector {LeaderElector}
 */

function _awaitLeadershipOnce(leaderElector) {
  if (leaderElector.isLeader) {
    return PROMISE_RESOLVED_VOID;
  }

  return new Promise(function (res) {
    var resolved = false;

    function finish() {
      if (resolved) {
        return;
      }

      resolved = true;
      leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
      res(true);
    } // try once now


    leaderElector.applyOnce().then(function () {
      if (leaderElector.isLeader) {
        finish();
      }
    });
    /**
     * Try on fallbackInterval
     * @recursive
     */

    var tryOnFallBack = function tryOnFallBack() {
      return sleep(leaderElector._options.fallbackInterval).then(function () {
        if (leaderElector.isDead || resolved) {
          return;
        }

        if (leaderElector.isLeader) {
          finish();
        } else {
          return leaderElector.applyOnce(true).then(function () {
            if (leaderElector.isLeader) {
              finish();
            } else {
              tryOnFallBack();
            }
          });
        }
      });
    };

    tryOnFallBack(); // try when other leader dies

    var whenDeathListener = function whenDeathListener(msg) {
      if (msg.context === 'leader' && msg.action === 'death') {
        leaderElector.hasLeader = false;
        leaderElector.applyOnce().then(function () {
          if (leaderElector.isLeader) {
            finish();
          }
        });
      }
    };

    leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);

    leaderElector._lstns.push(whenDeathListener);
  });
}
/**
 * sends and internal message over the broadcast-channel
 */


function _sendMessage(leaderElector, action) {
  var msgJson = {
    context: 'leader',
    action: action,
    token: leaderElector.token
  };
  return leaderElector.broadcastChannel.postInternal(msgJson);
}

function beLeader(leaderElector) {
  leaderElector.isLeader = true;
  leaderElector.hasLeader = true;
  var unloadFn = es_add(function () {
    return leaderElector.die();
  });

  leaderElector._unl.push(unloadFn);

  var isLeaderListener = function isLeaderListener(msg) {
    if (msg.context === 'leader' && msg.action === 'apply') {
      _sendMessage(leaderElector, 'tell');
    }

    if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
      /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */
      leaderElector._dpLC = true;

      leaderElector._dpL(); // message the lib user so the app can handle the problem


      _sendMessage(leaderElector, 'tell'); // ensure other leader also knows the problem

    }
  };

  leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);

  leaderElector._lstns.push(isLeaderListener);

  return _sendMessage(leaderElector, 'tell');
}

function leader_election_fillOptionsWithDefaults(options, channel) {
  if (!options) options = {};
  options = JSON.parse(JSON.stringify(options));

  if (!options.fallbackInterval) {
    options.fallbackInterval = 3000;
  }

  if (!options.responseTime) {
    options.responseTime = channel.method.averageResponseTime(channel.options);
  }

  return options;
}

function createLeaderElection(channel, options) {
  if (channel._leaderElector) {
    throw new Error('BroadcastChannel already has a leader-elector');
  }

  options = leader_election_fillOptionsWithDefaults(options, channel);
  var elector = new LeaderElection(channel, options);

  channel._befC.push(function () {
    return elector.die();
  });

  channel._leaderElector = elector;
  return elector;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/index.js


;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/SyncStorageService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







class SyncStorageService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.enablePostMessage = true;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this);
        this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this);
        this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this);
        this.onSetStorageHandler = this.onSetStorageHandler.bind(this);
        this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return !!this.options.syncStorage && isBrowser() && this.tokenManager.hasSharedStorage();
    }
    async start() {
        if (this.canStart()) {
            await this.stop();
            const { syncChannelName } = this.options;
            this.channel = new broadcast_channel_BroadcastChannel(syncChannelName);
            this.tokenManager.on(EVENT_ADDED, this.onTokenAddedHandler);
            this.tokenManager.on(EVENT_REMOVED, this.onTokenRemovedHandler);
            this.tokenManager.on(EVENT_RENEWED, this.onTokenRenewedHandler);
            this.tokenManager.on(EVENT_SET_STORAGE, this.onSetStorageHandler);
            this.channel.addEventListener('message', this.onSyncMessageHandler);
            this.started = true;
        }
    }
    async stop() {
        var _a, _b;
        if (this.started) {
            this.tokenManager.off(EVENT_ADDED, this.onTokenAddedHandler);
            this.tokenManager.off(EVENT_REMOVED, this.onTokenRemovedHandler);
            this.tokenManager.off(EVENT_RENEWED, this.onTokenRenewedHandler);
            this.tokenManager.off(EVENT_SET_STORAGE, this.onSetStorageHandler);
            (_a = this.channel) === null || _a === void 0 ? void 0 : _a.removeEventListener('message', this.onSyncMessageHandler);
            await ((_b = this.channel) === null || _b === void 0 ? void 0 : _b.close());
            this.channel = undefined;
            this.started = false;
        }
    }
    onTokenAddedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_ADDED,
            key,
            token
        });
    }
    onTokenRemovedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_REMOVED,
            key,
            token
        });
    }
    onTokenRenewedHandler(key, token, oldToken) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_RENEWED,
            key,
            token,
            oldToken
        });
    }
    onSetStorageHandler(storage) {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_SET_STORAGE,
            storage
        });
    }
    onSyncMessageHandler(msg) {
        this.enablePostMessage = false;
        switch (msg.type) {
            case EVENT_SET_STORAGE:
                this.tokenManager.getStorage().setStorage(msg.storage);
                break;
            case EVENT_ADDED:
                this.tokenManager.emitAdded(msg.key, msg.token);
                this.tokenManager.setExpireEventTimeout(msg.key, msg.token);
                break;
            case EVENT_REMOVED:
                this.tokenManager.clearExpireEventTimeout(msg.key);
                this.tokenManager.emitRemoved(msg.key, msg.token);
                break;
            case EVENT_RENEWED:
                this.tokenManager.emitRenewed(msg.key, msg.token, msg.oldToken);
                break;
        }
        this.enablePostMessage = true;
    }
}


//# sourceMappingURL=SyncStorageService.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/LeaderElectionService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class LeaderElectionService {
    constructor(options = {}) {
        this.started = false;
        this.options = options;
        this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this);
        this.onLeader = this.onLeader.bind(this);
    }
    onLeaderDuplicate() {
    }
    async onLeader() {
        var _a, _b;
        await ((_b = (_a = this.options).onLeader) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    isLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.isLeader);
    }
    hasLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.hasLeader);
    }
    async start() {
        await this.stop();
        if (this.canStart()) {
            const { electionChannelName } = this.options;
            this.channel = new broadcast_channel_BroadcastChannel(electionChannelName);
            this.elector = createLeaderElection(this.channel);
            this.elector.onduplicate = this.onLeaderDuplicate;
            this.elector.awaitLeadership().then(this.onLeader);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            if (this.elector) {
                await this.elector.die();
                this.elector = undefined;
            }
            if (this.channel) {
                this.channel.postInternal = () => Promise.resolve();
                await this.channel.close();
                this.channel = undefined;
            }
            this.started = false;
        }
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return isBrowser();
    }
}


//# sourceMappingURL=LeaderElectionService.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/ServiceManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






const AUTO_RENEW = 'autoRenew';
const SYNC_STORAGE = 'syncStorage';
const LEADER_ELECTION = 'leaderElection';
class ServiceManager {
    constructor(sdk, options = {}) {
        this.sdk = sdk;
        this.onLeader = this.onLeader.bind(this);
        const { autoRenew, autoRemove, syncStorage } = sdk.tokenManager.getOptions();
        options.electionChannelName = options.electionChannelName || options.broadcastChannelName;
        this.options = Object.assign({}, ServiceManager.defaultOptions, { autoRenew, autoRemove, syncStorage }, {
            electionChannelName: `${sdk.options.clientId}-election`,
            syncChannelName: `${sdk.options.clientId}-sync`,
        }, removeNils(options));
        this.started = false;
        this.services = new Map();
        ServiceManager.knownServices.forEach(name => {
            const svc = this.createService(name);
            if (svc) {
                this.services.set(name, svc);
            }
        });
    }
    async onLeader() {
        if (this.started) {
            await this.startServices();
        }
    }
    isLeader() {
        var _a;
        return (_a = this.getService(LEADER_ELECTION)) === null || _a === void 0 ? void 0 : _a.isLeader();
    }
    isLeaderRequired() {
        return [...this.services.values()].some(srv => srv.canStart() && srv.requiresLeadership());
    }
    async start() {
        if (this.started) {
            return;
        }
        await this.startServices();
        this.started = true;
    }
    async stop() {
        await this.stopServices();
        this.started = false;
    }
    getService(name) {
        return this.services.get(name);
    }
    async startServices() {
        for (const [name, srv] of this.services.entries()) {
            if (this.canStartService(name, srv)) {
                await srv.start();
            }
        }
    }
    async stopServices() {
        for (const srv of this.services.values()) {
            await srv.stop();
        }
    }
    canStartService(name, srv) {
        let canStart = srv.canStart() && !srv.isStarted();
        if (name === LEADER_ELECTION) {
            canStart && (canStart = this.isLeaderRequired());
        }
        else if (srv.requiresLeadership()) {
            canStart && (canStart = this.isLeader());
        }
        return canStart;
    }
    createService(name) {
        const tokenManager = this.sdk.tokenManager;
        let service;
        switch (name) {
            case LEADER_ELECTION:
                service = new LeaderElectionService(Object.assign(Object.assign({}, this.options), { onLeader: this.onLeader }));
                break;
            case AUTO_RENEW:
                service = new AutoRenewService(tokenManager, Object.assign({}, this.options));
                break;
            case SYNC_STORAGE:
                service = new SyncStorageService(tokenManager, Object.assign({}, this.options));
                break;
            default:
                throw new Error(`Unknown service ${name}`);
        }
        return service;
    }
}
ServiceManager.knownServices = [AUTO_RENEW, SYNC_STORAGE, LEADER_ELECTION];
ServiceManager.defaultOptions = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true
};


//# sourceMappingURL=ServiceManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/PromiseQueue.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class PromiseQueue {
    constructor(options = { quiet: false }) {
        this.queue = [];
        this.running = false;
        this.options = options;
    }
    push(method, thisObject, ...args) {
        return new Promise((resolve, reject) => {
            if (this.queue.length > 0) {
                if (this.options.quiet !== false) {
                    warn('Async method is being called but another async method is already running. ' +
                        'The new method will be delayed until the previous method completes.');
                }
            }
            this.queue.push({
                method,
                thisObject,
                args,
                resolve,
                reject
            });
            this.run();
        });
    }
    run() {
        if (this.running) {
            return;
        }
        if (this.queue.length === 0) {
            return;
        }
        this.running = true;
        var queueItem = this.queue.shift();
        var res = queueItem.method.apply(queueItem.thisObject, queueItem.args);
        if (isPromise(res)) {
            res.then(queueItem.resolve, queueItem.reject).finally(() => {
                this.running = false;
                this.run();
            });
        }
        else {
            queueItem.resolve(res);
            this.running = false;
            this.run();
        }
    }
}


//# sourceMappingURL=PromiseQueue.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/browser/fingerprint.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function fingerprint(sdk, options) {
    options = options || {};
    if (!isFingerprintSupported()) {
        return Promise.reject(new AuthSdkError_AuthSdkError('Fingerprinting is not supported on this device'));
    }
    var timeout;
    var iframe;
    var listener;
    var promise = new Promise(function (resolve, reject) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        listener = function listener(e) {
            if (!e || !e.data || e.origin !== sdk.getIssuerOrigin()) {
                return;
            }
            try {
                var msg = JSON.parse(e.data);
            }
            catch (err) {
                return;
            }
            if (!msg) {
                return;
            }
            if (msg.type === 'FingerprintAvailable') {
                return resolve(msg.fingerprint);
            }
            if (msg.type === 'FingerprintServiceReady') {
                e.source.postMessage(JSON.stringify({
                    type: 'GetFingerprint'
                }), e.origin);
            }
        };
        addListener(window, 'message', listener);
        iframe.src = sdk.getIssuerOrigin() + '/auth/services/devicefingerprint';
        document.body.appendChild(iframe);
        timeout = setTimeout(function () {
            reject(new AuthSdkError_AuthSdkError('Fingerprinting timed out'));
        }, (options === null || options === void 0 ? void 0 : options.timeout) || 15000);
    });
    return promise.finally(function () {
        clearTimeout(timeout);
        removeListener(window, 'message', listener);
        if (document.body.contains(iframe)) {
            iframe.parentElement.removeChild(iframe);
        }
    });
}


//# sourceMappingURL=fingerprint.js.map

// EXTERNAL MODULE: ./node_modules/p-cancelable/index.js
var p_cancelable = __webpack_require__(80341);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/AuthStateManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









const INITIAL_AUTH_STATE = null;
const DEFAULT_PENDING = {
    updateAuthStatePromise: null,
    canceledTimes: 0
};
const EVENT_AUTH_STATE_CHANGE = 'authStateChange';
const MAX_PROMISE_CANCEL_TIMES = 10;
const isSameAuthState = (prevState, state) => {
    if (!prevState) {
        return false;
    }
    return prevState.isAuthenticated === state.isAuthenticated
        && JSON.stringify(prevState.idToken) === JSON.stringify(state.idToken)
        && JSON.stringify(prevState.accessToken) === JSON.stringify(state.accessToken)
        && prevState.error === state.error;
};
class AuthStateManager {
    constructor(sdk) {
        if (!sdk.emitter) {
            throw new AuthSdkError_AuthSdkError('Emitter should be initialized before AuthStateManager');
        }
        this._sdk = sdk;
        this._pending = Object.assign({}, DEFAULT_PENDING);
        this._authState = INITIAL_AUTH_STATE;
        this._logOptions = {};
        this._prevAuthState = null;
        this._transformQueue = new PromiseQueue({
            quiet: true
        });
        sdk.tokenManager.on(EVENT_ADDED, (key, token) => {
            this._setLogOptions({ event: EVENT_ADDED, key, token });
            this.updateAuthState();
        });
        sdk.tokenManager.on(EVENT_REMOVED, (key, token) => {
            this._setLogOptions({ event: EVENT_REMOVED, key, token });
            this.updateAuthState();
        });
    }
    _setLogOptions(options) {
        this._logOptions = options;
    }
    getAuthState() {
        return this._authState;
    }
    getPreviousAuthState() {
        return this._prevAuthState;
    }
    async updateAuthState() {
        const { transformAuthState, devMode } = this._sdk.options;
        const log = (status) => {
            const { event, key, token } = this._logOptions;
            getConsole().group(`OKTA-AUTH-JS:updateAuthState: Event:${event} Status:${status}`);
            getConsole().log(key, token);
            getConsole().log('Current authState', this._authState);
            getConsole().groupEnd();
            this._logOptions = {};
        };
        const emitAuthStateChange = (authState) => {
            if (isSameAuthState(this._authState, authState)) {
                devMode && log('unchanged');
                return;
            }
            this._prevAuthState = this._authState;
            this._authState = authState;
            this._sdk.emitter.emit(EVENT_AUTH_STATE_CHANGE, Object.assign({}, authState));
            devMode && log('emitted');
        };
        const finalPromise = (origPromise) => {
            return this._pending.updateAuthStatePromise.then(() => {
                const curPromise = this._pending.updateAuthStatePromise;
                if (curPromise && curPromise !== origPromise) {
                    return finalPromise(curPromise);
                }
                return this.getAuthState();
            });
        };
        if (this._pending.updateAuthStatePromise) {
            if (this._pending.canceledTimes >= MAX_PROMISE_CANCEL_TIMES) {
                devMode && log('terminated');
                return finalPromise(this._pending.updateAuthStatePromise);
            }
            else {
                this._pending.updateAuthStatePromise.cancel();
            }
        }
        const cancelablePromise = new p_cancelable((resolve, _, onCancel) => {
            onCancel.shouldReject = false;
            onCancel(() => {
                this._pending.updateAuthStatePromise = null;
                this._pending.canceledTimes = this._pending.canceledTimes + 1;
                devMode && log('canceled');
            });
            const emitAndResolve = (authState) => {
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                emitAuthStateChange(authState);
                resolve();
                this._pending = Object.assign({}, DEFAULT_PENDING);
            };
            this._sdk.isAuthenticated()
                .then(() => {
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                const { accessToken, idToken, refreshToken } = this._sdk.tokenManager.getTokensSync();
                const authState = {
                    accessToken,
                    idToken,
                    refreshToken,
                    isAuthenticated: !!(accessToken && idToken)
                };
                const promise = transformAuthState
                    ? this._transformQueue.push(transformAuthState, null, this._sdk, authState)
                    : Promise.resolve(authState);
                promise
                    .then(authState => emitAndResolve(authState))
                    .catch(error => emitAndResolve({
                    accessToken,
                    idToken,
                    refreshToken,
                    isAuthenticated: false,
                    error
                }));
            });
        });
        this._pending.updateAuthStatePromise = cancelablePromise;
        return finalPromise(cancelablePromise);
    }
    subscribe(handler) {
        this._sdk.emitter.on(EVENT_AUTH_STATE_CHANGE, handler);
    }
    unsubscribe(handler) {
        this._sdk.emitter.off(EVENT_AUTH_STATE_CHANGE, handler);
    }
}


//# sourceMappingURL=AuthStateManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/storage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isLocalStorageAvailable() {
    const test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    }
    catch (_a) {
        return false;
    }
}


//# sourceMappingURL=storage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/SavedObject.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class SavedObject {
    constructor(storage, storageName) {
        if (!storage) {
            throw new AuthSdkError_AuthSdkError('"storage" is required');
        }
        if (typeof storageName !== 'string' || !storageName.length) {
            throw new AuthSdkError_AuthSdkError('"storageName" is required');
        }
        this.storageName = storageName;
        this.storageProvider = storage;
    }
    getItem(key) {
        return this.getStorage()[key];
    }
    setItem(key, value) {
        return this.updateStorage(key, value);
    }
    removeItem(key) {
        return this.clearStorage(key);
    }
    isSharedStorage() {
        var _a, _b;
        return isLocalStorageAvailable() && this.storageProvider === localStorage
            || !!((_b = (_a = this.storageProvider).isSharedStorage) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    getStorage() {
        var storageString = this.storageProvider.getItem(this.storageName);
        storageString = storageString || '{}';
        try {
            return JSON.parse(storageString);
        }
        catch (e) {
            throw new AuthSdkError_AuthSdkError('Unable to parse storage string: ' + this.storageName);
        }
    }
    setStorage(obj) {
        try {
            var storageString = obj ? JSON.stringify(obj) : '{}';
            this.storageProvider.setItem(this.storageName, storageString);
        }
        catch (e) {
            throw new AuthSdkError_AuthSdkError('Unable to set storage: ' + this.storageName);
        }
    }
    clearStorage(key) {
        if (!key) {
            if (this.storageProvider.removeItem) {
                this.storageProvider.removeItem(this.storageName);
            }
            else {
                this.setStorage();
            }
            return;
        }
        var obj = this.getStorage();
        delete obj[key];
        this.setStorage(obj);
    }
    updateStorage(key, value) {
        var obj = this.getStorage();
        obj[key] = value;
        this.setStorage(obj);
    }
}


//# sourceMappingURL=SavedObject.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/StorageManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function logServerSideMemoryStorageWarning(options) {
    if (!isBrowser() && !options.storageProvider && !options.storageProvider) {
        warn('Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.');
    }
}
class StorageManager {
    constructor(storageManagerOptions, cookieOptions, storageUtil) {
        this.storageManagerOptions = storageManagerOptions;
        this.cookieOptions = cookieOptions;
        this.storageUtil = storageUtil;
    }
    getOptionsForSection(sectionName, overrideOptions) {
        return Object.assign({}, this.storageManagerOptions[sectionName], overrideOptions);
    }
    getStorage(options) {
        options = Object.assign({}, this.cookieOptions, options);
        if (options.storageProvider) {
            return options.storageProvider;
        }
        let { storageType, storageTypes } = options;
        if (storageType === 'sessionStorage') {
            options.sessionCookie = true;
        }
        if (storageType && storageTypes) {
            const idx = storageTypes.indexOf(storageType);
            if (idx >= 0) {
                storageTypes = storageTypes.slice(idx);
                storageType = undefined;
            }
        }
        if (!storageType) {
            storageType = this.storageUtil.findStorageType(storageTypes);
        }
        return this.storageUtil.getStorageByType(storageType, options);
    }
    getTransactionStorage(options) {
        options = this.getOptionsForSection('transaction', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || TRANSACTION_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getSharedTansactionStorage(options) {
        options = this.getOptionsForSection('shared-transaction', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || SHARED_TRANSACTION_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getOriginalUriStorage(options) {
        options = this.getOptionsForSection('original-uri', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || ORIGINAL_URI_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getIdxResponseStorage(options) {
        let storage;
        if (isBrowser()) {
            try {
                storage = this.storageUtil.getStorageByType('memory', options);
            }
            catch (e) {
                warn('No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic');
            }
        }
        else {
            const transactionStorage = this.getTransactionStorage(options);
            if (transactionStorage) {
                storage = {
                    getItem: (key) => {
                        const transaction = transactionStorage.getStorage();
                        if (transaction && transaction[key]) {
                            return transaction[key];
                        }
                        return null;
                    },
                    setItem: (key, val) => {
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) {
                            throw new AuthSdkError_AuthSdkError('Transaction has been cleared, failed to save idxState');
                        }
                        transaction[key] = val;
                        transactionStorage.setStorage(transaction);
                    },
                    removeItem: (key) => {
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) {
                            return;
                        }
                        delete transaction[key];
                        transactionStorage.setStorage(transaction);
                    }
                };
            }
        }
        if (!storage) {
            return null;
        }
        return new SavedObject(storage, IDX_RESPONSE_STORAGE_NAME);
    }
    getTokenStorage(options) {
        options = this.getOptionsForSection('token', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || TOKEN_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getHttpCache(options) {
        options = this.getOptionsForSection('cache', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || CACHE_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getLegacyPKCEStorage(options) {
        options = this.getOptionsForSection('legacy-pkce', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || PKCE_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getLegacyOAuthParamsStorage(options) {
        options = this.getOptionsForSection('legacy-oauth-params', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || REDIRECT_OAUTH_PARAMS_NAME;
        return new SavedObject(storage, storageKey);
    }
}


//# sourceMappingURL=StorageManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/types/Transaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isObjectWithProperties(obj) {
    if (!obj || typeof obj !== 'object' || Object.values(obj).length === 0) {
        return false;
    }
    return true;
}
function isOAuthTransactionMeta(obj) {
    if (!isObjectWithProperties(obj)) {
        return false;
    }
    return !!obj.redirectUri || !!obj.responseType;
}
function isPKCETransactionMeta(obj) {
    if (!isOAuthTransactionMeta(obj)) {
        return false;
    }
    return !!obj.codeVerifier;
}
function isIdxTransactionMeta(obj) {
    if (!isPKCETransactionMeta(obj)) {
        return false;
    }
    return !!obj.interactionHandle;
}
function isCustomAuthTransactionMeta(obj) {
    if (!isObjectWithProperties(obj)) {
        return false;
    }
    const isAllStringValues = Object.values(obj).find((value) => (typeof value !== 'string')) === undefined;
    return isAllStringValues;
}
function isTransactionMeta(obj) {
    if (isOAuthTransactionMeta(obj) || isCustomAuthTransactionMeta(obj)) {
        return true;
    }
    return false;
}


//# sourceMappingURL=Transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/types/idx-js.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isRawIdxResponse(obj) {
    return obj && obj.version;
}
function isIdxResponse(obj) {
    return obj && isRawIdxResponse(obj.rawIdxState);
}


//# sourceMappingURL=idx-js.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/sharedStorage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





const MAX_ENTRY_LIFETIME = 30 * 60 * 1000;
function pruneSharedStorage(storageManager) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    Object.keys(entries).forEach(state => {
        const entry = entries[state];
        const age = Date.now() - entry.dateCreated;
        if (age > MAX_ENTRY_LIFETIME) {
            delete entries[state];
        }
    });
    sharedStorage.setStorage(entries);
}
function saveTransactionToSharedStorage(storageManager, state, meta) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    entries[state] = {
        dateCreated: Date.now(),
        transaction: meta
    };
    sharedStorage.setStorage(entries);
}
function loadTransactionFromSharedStorage(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    const entry = entries[state];
    if (entry && entry.transaction && isTransactionMeta(entry.transaction)) {
        return entry.transaction;
    }
    return null;
}
function clearTransactionFromSharedStorage(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    delete entries[state];
    sharedStorage.setStorage(entries);
}


//# sourceMappingURL=sharedStorage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/TransactionManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










class TransactionManager {
    constructor(options) {
        this.storageManager = options.storageManager;
        this.legacyWidgetSupport = options.legacyWidgetSupport === false ? false : true;
        this.saveNonceCookie = options.saveNonceCookie === false ? false : true;
        this.saveStateCookie = options.saveStateCookie === false ? false : true;
        this.saveParamsCookie = options.saveParamsCookie === false ? false : true;
        this.enableSharedStorage = options.enableSharedStorage === false ? false : true;
        this.saveLastResponse = options.saveLastResponse === false ? false : true;
        this.options = options;
    }
    clear(options = {}) {
        const transactionStorage = this.storageManager.getTransactionStorage();
        const meta = transactionStorage.getStorage();
        transactionStorage.clearStorage();
        if (this.enableSharedStorage && options.clearSharedStorage !== false) {
            const state = options.state || (meta === null || meta === void 0 ? void 0 : meta.state);
            if (state) {
                clearTransactionFromSharedStorage(this.storageManager, state);
            }
        }
        if (options.clearIdxResponse !== false) {
            this.clearIdxResponse();
        }
        if (!this.legacyWidgetSupport) {
            return;
        }
        if (options.oauth) {
            this.clearLegacyOAuthParams();
        }
        if (options.pkce) {
            this.clearLegacyPKCE();
        }
    }
    save(meta, options = {}) {
        let storage = this.storageManager.getTransactionStorage();
        const obj = storage.getStorage();
        if (isTransactionMeta(obj) && !options.muteWarning) {
            warn('a saved auth transaction exists in storage. This may indicate another auth flow is already in progress.');
        }
        storage.setStorage(meta);
        if (this.enableSharedStorage && meta.state) {
            saveTransactionToSharedStorage(this.storageManager, meta.state, meta);
        }
        if (!options.oauth) {
            return;
        }
        if (this.saveNonceCookie || this.saveStateCookie || this.saveParamsCookie) {
            const cookieStorage = this.storageManager.getStorage({ storageType: 'cookie' });
            if (this.saveParamsCookie) {
                const { responseType, state, nonce, scopes, clientId, urls, ignoreSignature } = meta;
                const oauthParams = {
                    responseType,
                    state,
                    nonce,
                    scopes,
                    clientId,
                    urls,
                    ignoreSignature
                };
                cookieStorage.setItem(REDIRECT_OAUTH_PARAMS_NAME, JSON.stringify(oauthParams), null);
            }
            if (this.saveNonceCookie && meta.nonce) {
                cookieStorage.setItem(REDIRECT_NONCE_COOKIE_NAME, meta.nonce, null);
            }
            if (this.saveStateCookie && meta.state) {
                cookieStorage.setItem(REDIRECT_STATE_COOKIE_NAME, meta.state, null);
            }
        }
    }
    exists(options = {}) {
        try {
            const meta = this.load(options);
            return !!meta;
        }
        catch (_a) {
            return false;
        }
    }
    load(options = {}) {
        let meta;
        if (this.enableSharedStorage && options.state) {
            pruneSharedStorage(this.storageManager);
            meta = loadTransactionFromSharedStorage(this.storageManager, options.state);
            if (isTransactionMeta(meta)) {
                return meta;
            }
        }
        let storage = this.storageManager.getTransactionStorage();
        meta = storage.getStorage();
        if (isTransactionMeta(meta)) {
            return meta;
        }
        if (!this.legacyWidgetSupport) {
            return null;
        }
        if (options.oauth) {
            try {
                const oauthParams = this.loadLegacyOAuthParams();
                Object.assign(meta, oauthParams);
            }
            finally {
                this.clearLegacyOAuthParams();
            }
        }
        if (options.pkce) {
            try {
                const pkceMeta = this.loadLegacyPKCE();
                Object.assign(meta, pkceMeta);
            }
            finally {
                this.clearLegacyPKCE();
            }
        }
        if (isTransactionMeta(meta)) {
            return meta;
        }
        return null;
    }
    clearLegacyPKCE() {
        let storage;
        if (this.storageManager.storageUtil.testStorageType('localStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'localStorage' });
            storage.clearStorage();
        }
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'sessionStorage' });
            storage.clearStorage();
        }
    }
    loadLegacyPKCE() {
        let storage;
        let obj;
        if (this.storageManager.storageUtil.testStorageType('localStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'localStorage' });
            obj = storage.getStorage();
            if (obj && obj.codeVerifier) {
                return obj;
            }
        }
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'sessionStorage' });
            obj = storage.getStorage();
            if (obj && obj.codeVerifier) {
                return obj;
            }
        }
        throw new AuthSdkError_AuthSdkError('Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.', undefined);
    }
    clearLegacyOAuthParams() {
        let storage;
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'sessionStorage' });
            storage.clearStorage();
        }
        if (this.storageManager.storageUtil.testStorageType('cookie')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'cookie' });
            storage.clearStorage();
        }
    }
    loadLegacyOAuthParams() {
        let storage;
        let oauthParams;
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'sessionStorage' });
            oauthParams = storage.getStorage();
        }
        if (isOAuthTransactionMeta(oauthParams)) {
            return oauthParams;
        }
        if (this.storageManager.storageUtil.testStorageType('cookie')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'cookie' });
            oauthParams = storage.getStorage();
        }
        if (isOAuthTransactionMeta(oauthParams)) {
            return oauthParams;
        }
        throw new AuthSdkError_AuthSdkError('Unable to retrieve OAuth redirect params from storage');
    }
    saveIdxResponse(data) {
        if (!this.saveLastResponse) {
            return;
        }
        const storage = this.storageManager.getIdxResponseStorage();
        if (!storage) {
            return;
        }
        storage.setStorage(data);
    }
    loadIdxResponse(options) {
        if (!this.saveLastResponse) {
            return null;
        }
        const storage = this.storageManager.getIdxResponseStorage();
        if (!storage) {
            return null;
        }
        const storedValue = storage.getStorage();
        if (!storedValue || !isRawIdxResponse(storedValue.rawIdxResponse)) {
            return null;
        }
        if (options) {
            const { stateHandle, interactionHandle } = options;
            if (stateHandle && storedValue.stateHandle !== stateHandle) {
                return null;
            }
            if (interactionHandle && storedValue.interactionHandle !== interactionHandle) {
                return null;
            }
        }
        return storedValue;
    }
    clearIdxResponse() {
        if (!this.saveLastResponse) {
            return;
        }
        const storage = this.storageManager.getIdxResponseStorage();
        storage === null || storage === void 0 ? void 0 : storage.clearStorage();
    }
}


//# sourceMappingURL=TransactionManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/builderUtil.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function assertValidConfig(args) {
    args = args || {};
    var scopes = args.scopes;
    if (scopes && !Array.isArray(scopes)) {
        throw new AuthSdkError_AuthSdkError('scopes must be a array of strings. ' +
            'Required usage: new OktaAuth({scopes: ["openid", "email"]})');
    }
    var issuer = args.issuer;
    if (!issuer) {
        throw new AuthSdkError_AuthSdkError('No issuer passed to constructor. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    }
    var isUrlRegex = new RegExp('^http?s?://.+');
    if (!isUrlRegex.test(issuer)) {
        throw new AuthSdkError_AuthSdkError('Issuer must be a valid URL. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    }
    if (issuer.indexOf('-admin.') !== -1) {
        throw new AuthSdkError_AuthSdkError('Issuer URL passed to constructor contains "-admin" in subdomain. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
    }
}


//# sourceMappingURL=builderUtil.js.map

// EXTERNAL MODULE: ./node_modules/@okta/okta-auth-js/node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(44642);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/fetch/fetchRequest.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const appJsonContentTypeRegex = /application\/\w*\+?json/;
function readData(response) {
    if (response.headers.get('Content-Type') &&
        response.headers.get('Content-Type').toLowerCase().indexOf('application/json') >= 0) {
        return response.json()
            .catch(e => {
            return {
                error: e,
                errorSummary: 'Could not parse server response'
            };
        });
    }
    else {
        return response.text();
    }
}
function formatResult(status, data, response) {
    const isObject = typeof data === 'object';
    const headers = {};
    for (const pair of response.headers.entries()) {
        headers[pair[0]] = pair[1];
    }
    const result = {
        responseText: isObject ? JSON.stringify(data) : data,
        status: status,
        headers
    };
    if (isObject) {
        result.responseType = 'json';
        result.responseJSON = data;
    }
    return result;
}
function fetchRequest(method, url, args) {
    var body = args.data;
    var headers = args.headers || {};
    var contentType = (headers['Content-Type'] || headers['content-type'] || '');
    if (body && typeof body !== 'string') {
        if (appJsonContentTypeRegex.test(contentType)) {
            body = JSON.stringify(body);
        }
        else if (contentType === 'application/x-www-form-urlencoded') {
            body = Object.entries(body)
                .map(([param, value]) => `${param}=${encodeURIComponent(value)}`)
                .join('&');
        }
    }
    var fetch = window.fetch || browser_ponyfill;
    var fetchPromise = fetch(url, {
        method: method,
        headers: args.headers,
        body: body,
        credentials: args.withCredentials ? 'include' : 'omit'
    });
    if (!fetchPromise.finally) {
        fetchPromise = Promise.resolve(fetchPromise);
    }
    return fetchPromise.then(function (response) {
        var error = !response.ok;
        var status = response.status;
        return readData(response)
            .then(data => {
            return formatResult(status, data, response);
        })
            .then(result => {
            var _a;
            if (error || ((_a = result.responseJSON) === null || _a === void 0 ? void 0 : _a.error)) {
                throw result;
            }
            return result;
        });
    });
}


//# sourceMappingURL=fetchRequest.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/options/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getStorage() {
    const storageUtil$1 = Object.assign({}, storageUtil, {
        inMemoryStore: {}
    });
    return storageUtil$1;
}
const STORAGE_MANAGER_OPTIONS = {
    token: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    cache: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    transaction: {
        storageTypes: [
            'sessionStorage',
            'localStorage',
            'cookie'
        ]
    },
    'shared-transaction': {
        storageTypes: [
            'localStorage'
        ]
    },
    'original-uri': {
        storageTypes: [
            'localStorage'
        ]
    }
};
const enableSharedStorage = true;
function getCookieSettings(args = {}, isHTTPS) {
    var cookieSettings = args.cookies || {};
    if (typeof cookieSettings.secure === 'undefined') {
        cookieSettings.secure = isHTTPS;
    }
    if (typeof cookieSettings.sameSite === 'undefined') {
        cookieSettings.sameSite = cookieSettings.secure ? 'none' : 'lax';
    }
    if (cookieSettings.secure && !isHTTPS) {
        warn('The current page is not being served with the HTTPS protocol.\n' +
            'For security reasons, we strongly recommend using HTTPS.\n' +
            'If you cannot use HTTPS, set "cookies.secure" option to false.');
        cookieSettings.secure = false;
    }
    if (cookieSettings.sameSite === 'none' && !cookieSettings.secure) {
        cookieSettings.sameSite = 'lax';
    }
    return cookieSettings;
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/options/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function getDefaultOptions() {
    const options = {
        devMode: false,
        httpRequestClient: fetchRequest,
        storageUtil: getStorage(),
        storageManager: STORAGE_MANAGER_OPTIONS,
        transactionManager: {
            enableSharedStorage: enableSharedStorage
        }
    };
    return options;
}
function mergeOptions(options, args) {
    return Object.assign({}, options, removeNils(args), {
        storageManager: Object.assign({}, options.storageManager, args.storageManager),
        transactionManager: Object.assign({}, options.transactionManager, args.transactionManager),
    });
}
function buildOptions(args = {}) {
    var _a, _b;
    assertValidConfig(args);
    args = mergeOptions(getDefaultOptions(), args);
    return removeNils({
        issuer: removeTrailingSlash(args.issuer),
        tokenUrl: removeTrailingSlash(args.tokenUrl),
        authorizeUrl: removeTrailingSlash(args.authorizeUrl),
        userinfoUrl: removeTrailingSlash(args.userinfoUrl),
        revokeUrl: removeTrailingSlash(args.revokeUrl),
        logoutUrl: removeTrailingSlash(args.logoutUrl),
        clientId: args.clientId,
        redirectUri: args.redirectUri,
        state: args.state,
        scopes: args.scopes,
        postLogoutRedirectUri: args.postLogoutRedirectUri,
        responseMode: args.responseMode,
        responseType: args.responseType,
        pkce: args.pkce === false ? false : true,
        useInteractionCodeFlow: args.useInteractionCodeFlow,
        httpRequestClient: args.httpRequestClient,
        httpRequestInterceptors: args.httpRequestInterceptors,
        transformErrorXHR: args.transformErrorXHR,
        transformAuthState: args.transformAuthState,
        restoreOriginalUri: args.restoreOriginalUri,
        storageUtil: args.storageUtil,
        headers: args.headers,
        devMode: !!args.devMode,
        storageManager: args.storageManager,
        transactionManager: args.transactionManager,
        cookies: getCookieSettings(args, isHTTPS()),
        flow: args.flow,
        codeChallenge: args.codeChallenge,
        codeChallengeMethod: args.codeChallengeMethod,
        recoveryToken: args.recoveryToken,
        activationToken: args.activationToken,
        idx: {
            useGenericRemediator: !!((_a = args.idx) === null || _a === void 0 ? void 0 : _a.useGenericRemediator),
            exchangeCodeForTokens: ((_b = args.idx) === null || _b === void 0 ? void 0 : _b.exchangeCodeForTokens) !== false
        },
        ignoreSignature: !!args.ignoreSignature,
        clientSecret: args.clientSecret,
        setLocation: args.setLocation
    });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/transactionMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







async function createTransactionMeta(authClient, options = {}) {
    const tokenParams = await authClient.token.prepareTokenParams(options);
    const pkceMeta = createOAuthMeta(authClient, tokenParams);
    let { flow = 'default', withCredentials = true, activationToken = undefined, recoveryToken = undefined, maxAge = undefined, } = Object.assign(Object.assign({}, authClient.options), options);
    const meta = Object.assign(Object.assign({}, pkceMeta), { flow,
        withCredentials,
        activationToken,
        recoveryToken,
        maxAge });
    return meta;
}
function hasSavedInteractionHandle(authClient, options) {
    const savedMeta = getSavedTransactionMeta(authClient, options);
    if (savedMeta === null || savedMeta === void 0 ? void 0 : savedMeta.interactionHandle) {
        return true;
    }
    return false;
}
function getSavedTransactionMeta(authClient, options) {
    options = removeNils(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    let savedMeta;
    try {
        savedMeta = authClient.transactionManager.load(options);
    }
    catch (e) {
    }
    if (!savedMeta) {
        return;
    }
    if (isTransactionMetaValid(savedMeta, options)) {
        return savedMeta;
    }
    warn('Saved transaction meta does not match the current configuration. ' +
        'This may indicate that two apps are sharing a storage key.');
}
async function getTransactionMeta(authClient, options) {
    options = removeNils(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    const validExistingMeta = getSavedTransactionMeta(authClient, options);
    if (validExistingMeta) {
        return validExistingMeta;
    }
    return createTransactionMeta(authClient, options);
}
function saveTransactionMeta(authClient, meta) {
    authClient.transactionManager.save(meta, { muteWarning: true });
}
function clearTransactionMeta(authClient) {
    authClient.transactionManager.clear();
}
function isTransactionMetaValid(meta, options = {}) {
    const keys = [
        'issuer',
        'clientId',
        'redirectUri',
        'state',
        'codeChallenge',
        'codeChallengeMethod',
        'activationToken',
        'recoveryToken'
    ];
    if (isTransactionMetaValidForOptions(meta, options, keys) === false) {
        return false;
    }
    const { flow } = options;
    if (isTransactionMetaValidForFlow(meta, flow) === false) {
        return false;
    }
    return true;
}
function isTransactionMetaValidForFlow(meta, flow) {
    const shouldValidateFlow = flow && flow !== 'default' && flow !== 'proceed';
    if (shouldValidateFlow) {
        if (flow !== meta.flow) {
            return false;
        }
    }
    return true;
}
function isTransactionMetaValidForOptions(meta, options, keys) {
    const mismatch = keys.some(key => {
        const value = options[key];
        if (value && value !== meta[key]) {
            return true;
        }
    });
    return !mismatch;
}


//# sourceMappingURL=transactionMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/interact.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function getResponse(meta) {
    return {
        meta,
        interactionHandle: meta.interactionHandle,
        state: meta.state
    };
}
async function interact(authClient, options = {}) {
    options = removeNils(options);
    let meta = getSavedTransactionMeta(authClient, options);
    if (meta === null || meta === void 0 ? void 0 : meta.interactionHandle) {
        return getResponse(meta);
    }
    meta = await createTransactionMeta(authClient, Object.assign(Object.assign({}, meta), options));
    const baseUrl = getOAuthBaseUrl(authClient);
    let { clientId, redirectUri, state, scopes, withCredentials, codeChallenge, codeChallengeMethod, activationToken, recoveryToken, maxAge, nonce } = meta;
    const clientSecret = options.clientSecret || authClient.options.clientSecret;
    withCredentials = withCredentials !== null && withCredentials !== void 0 ? withCredentials : true;
    const url = `${baseUrl}/v1/interact`;
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ client_id: clientId, scope: scopes.join(' '), redirect_uri: redirectUri, code_challenge: codeChallenge, code_challenge_method: codeChallengeMethod, state }, (activationToken && { activation_token: activationToken })), (recoveryToken && { recovery_token: recoveryToken })), (clientSecret && { client_secret: clientSecret })), (maxAge && { max_age: maxAge })), (nonce && { nonce }));
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    };
    const resp = await request_httpRequest(authClient, {
        method: 'POST',
        url,
        headers,
        withCredentials,
        args: params
    });
    const interactionHandle = resp.interaction_handle;
    const newMeta = Object.assign(Object.assign({}, meta), { interactionHandle,
        withCredentials,
        state,
        scopes,
        recoveryToken,
        activationToken });
    saveTransactionMeta(authClient, newMeta);
    return getResponse(newMeta);
}


//# sourceMappingURL=interact.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/actionParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const isFieldMutable = function isFieldMutable(field) {
    return (field.mutable !== false);
};
const divideSingleActionParamsByMutability = function divideSingleActionParamsByMutability(action) {
    var _a, _b;
    const defaultParamsForAction = {};
    const neededParamsForAction = [];
    const immutableParamsForAction = {};
    if (!action.value) {
        neededParamsForAction.push(action);
        return { defaultParamsForAction, neededParamsForAction, immutableParamsForAction };
    }
    for (let field of action.value) {
        if (isFieldMutable(field)) {
            neededParamsForAction.push(field);
            if ((_a = field.value) !== null && _a !== void 0 ? _a : false) {
                defaultParamsForAction[field.name] = field.value;
            }
        }
        else {
            immutableParamsForAction[field.name] = (_b = field.value) !== null && _b !== void 0 ? _b : '';
        }
    }
    return { defaultParamsForAction, neededParamsForAction, immutableParamsForAction };
};
const divideActionParamsByMutability = function divideActionParamsByMutability(actionList) {
    actionList = Array.isArray(actionList) ? actionList : [actionList];
    const neededParams = [];
    const defaultParams = {};
    const immutableParams = {};
    for (let action of actionList) {
        const { defaultParamsForAction, neededParamsForAction, immutableParamsForAction } = divideSingleActionParamsByMutability(action);
        neededParams.push(neededParamsForAction);
        defaultParams[action.name] = defaultParamsForAction;
        immutableParams[action.name] = immutableParamsForAction;
    }
    return { defaultParams, neededParams, immutableParams };
};


//# sourceMappingURL=actionParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/generateIdxAction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





const generateDirectFetch = function generateDirectFetch(authClient, { actionDefinition, defaultParamsForAction = {}, immutableParamsForAction = {}, toPersist = {} }) {
    const target = actionDefinition.href;
    return async function (params = {}) {
        var _a;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': actionDefinition.accepts || 'application/ion+json',
        };
        const body = JSON.stringify(Object.assign(Object.assign(Object.assign({}, defaultParamsForAction), params), immutableParamsForAction));
        try {
            const response = await request_httpRequest(authClient, {
                url: target,
                method: actionDefinition.method,
                headers,
                args: body,
                withCredentials: (_a = toPersist === null || toPersist === void 0 ? void 0 : toPersist.withCredentials) !== null && _a !== void 0 ? _a : true
            });
            return authClient.idx.makeIdxResponse(Object.assign({}, response), toPersist, true);
        }
        catch (err) {
            if (!(err instanceof AuthApiError_AuthApiError) || !(err === null || err === void 0 ? void 0 : err.xhr)) {
                throw err;
            }
            const response = err.xhr;
            const payload = response.responseJSON || JSON.parse(response.responseText);
            const wwwAuthHeader = response.headers['WWW-Authenticate'] || response.headers['www-authenticate'];
            const idxResponse = authClient.idx.makeIdxResponse(Object.assign({}, payload), toPersist, false);
            if (response.status === 401 && wwwAuthHeader === 'Oktadevicejwt realm="Okta Device"') {
                idxResponse.stepUp = true;
            }
            throw idxResponse;
        }
    };
};
const generateIdxAction = function generateIdxAction(authClient, actionDefinition, toPersist) {
    const generator = generateDirectFetch;
    const { defaultParams, neededParams, immutableParams } = divideActionParamsByMutability(actionDefinition);
    const action = generator(authClient, {
        actionDefinition,
        defaultParamsForAction: defaultParams[actionDefinition.name],
        immutableParamsForAction: immutableParams[actionDefinition.name],
        toPersist
    });
    action.neededParams = neededParams;
    return action;
};


//# sourceMappingURL=generateIdxAction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/remediationParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const generateRemediationFunctions = function generateRemediationFunctions(authClient, remediationValue, toPersist = {}) {
    return Object.fromEntries(remediationValue.map(remediation => {
        return [
            remediation.name,
            generateIdxAction(authClient, remediation, toPersist),
        ];
    }));
};


//# sourceMappingURL=remediationParser.js.map

;// CONCATENATED MODULE: ./node_modules/jsonpath-plus/dist/index-browser-esm.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var hasOwnProp = Object.prototype.hasOwnProperty;
/**
* @typedef {null|boolean|number|string|PlainObject|GenericArray} JSONObject
*/

/**
 * Copies array and then pushes item into it.
 * @param {GenericArray} arr Array to copy and into which to push
 * @param {any} item Array item to add (to end)
 * @returns {GenericArray} Copy of the original array
 */

function push(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
/**
 * Copies array and then unshifts item into it.
 * @param {any} item Array item to add (to beginning)
 * @param {GenericArray} arr Array to copy and into which to unshift
 * @returns {GenericArray} Copy of the original array
 */


function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
/**
 * Caught when JSONPath is used without `new` but rethrown if with `new`
 * @extends Error
 */


var NewError = /*#__PURE__*/function (_Error) {
  _inherits(NewError, _Error);

  var _super = _createSuper(NewError);

  /**
   * @param {any} value The evaluated scalar value
   */
  function NewError(value) {
    var _this;

    _classCallCheck(this, NewError);

    _this = _super.call(this, 'JSONPath should not be called with "new" (it prevents return ' + 'of (unwrapped) scalar values)');
    _this.avoidNew = true;
    _this.value = value;
    _this.name = 'NewError';
    return _this;
  }

  return NewError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
* @typedef {PlainObject} ReturnObject
* @property {string} path
* @property {JSONObject} value
* @property {PlainObject|GenericArray} parent
* @property {string} parentProperty
*/

/**
* @callback JSONPathCallback
* @param {string|PlainObject} preferredOutput
* @param {"value"|"property"} type
* @param {ReturnObject} fullRetObj
* @returns {void}
*/

/**
* @callback OtherTypeCallback
* @param {JSONObject} val
* @param {string} path
* @param {PlainObject|GenericArray} parent
* @param {string} parentPropName
* @returns {boolean}
*/

/* eslint-disable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @typedef {PlainObject} JSONPathOptions
 * @property {JSON} json
 * @property {string|string[]} path
 * @property {"value"|"path"|"pointer"|"parent"|"parentProperty"|"all"} [resultType="value"]
 * @property {boolean} [flatten=false]
 * @property {boolean} [wrap=true]
 * @property {PlainObject} [sandbox={}]
 * @property {boolean} [preventEval=false]
 * @property {PlainObject|GenericArray|null} [parent=null]
 * @property {string|null} [parentProperty=null]
 * @property {JSONPathCallback} [callback]
 * @property {OtherTypeCallback} [otherTypeCallback] Defaults to
 *   function which throws on encountering `@other`
 * @property {boolean} [autostart=true]
 */

/* eslint-enable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @param {string|JSONPathOptions} opts If a string, will be treated as `expr`
 * @param {string} [expr] JSON path to evaluate
 * @param {JSON} [obj] JSON object to evaluate against
 * @param {JSONPathCallback} [callback] Passed 3 arguments: 1) desired payload
 *     per `resultType`, 2) `"value"|"property"`, 3) Full returned object with
 *     all payloads
 * @param {OtherTypeCallback} [otherTypeCallback] If `@other()` is at the end
 *   of one's query, this will be invoked with the value of the item, its
 *   path, its parent, and its parent's property name, and it should return
 *   a boolean indicating whether the supplied value belongs to the "other"
 *   type or not (or it may handle transformations and return `false`).
 * @returns {JSONPath}
 * @class
 */


function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  // eslint-disable-next-line no-restricted-syntax
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e) {
      if (!e.avoidNew) {
        throw e;
      }

      return e.value;
    }
  }

  if (typeof opts === 'string') {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }

  var optObj = opts && _typeof(opts) === 'object';
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || 'value';
  this.flatten = opts.flatten || false;
  this.wrap = hasOwnProp.call(opts, 'wrap') ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.preventEval = opts.preventEval || false;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;

  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function () {
    throw new TypeError('You must supply an otherTypeCallback callback option ' + 'with the @other() operator.');
  };

  if (opts.autostart !== false) {
    var args = {
      path: optObj ? opts.path : expr
    };

    if (!optObj) {
      args.json = obj;
    } else if ('json' in opts) {
      args.json = opts.json;
    }

    var ret = this.evaluate(args);

    if (!ret || _typeof(ret) !== 'object') {
      throw new NewError(ret);
    }

    return ret;
  }
} // PUBLIC METHODS


JSONPath.prototype.evaluate = function (expr, json, callback, otherTypeCallback) {
  var _this2 = this;

  var currParent = this.parent,
      currParentProperty = this.parentProperty;
  var flatten = this.flatten,
      wrap = this.wrap;
  this.currResultType = this.resultType;
  this.currPreventEval = this.preventEval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;

  if (expr && _typeof(expr) === 'object' && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== '') {
      throw new TypeError('You must supply a "path" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    if (!hasOwnProp.call(expr, 'json')) {
      throw new TypeError('You must supply a "json" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    var _expr = expr;
    json = _expr.json;
    flatten = hasOwnProp.call(expr, 'flatten') ? expr.flatten : flatten;
    this.currResultType = hasOwnProp.call(expr, 'resultType') ? expr.resultType : this.currResultType;
    this.currSandbox = hasOwnProp.call(expr, 'sandbox') ? expr.sandbox : this.currSandbox;
    wrap = hasOwnProp.call(expr, 'wrap') ? expr.wrap : wrap;
    this.currPreventEval = hasOwnProp.call(expr, 'preventEval') ? expr.preventEval : this.currPreventEval;
    callback = hasOwnProp.call(expr, 'callback') ? expr.callback : callback;
    this.currOtherTypeCallback = hasOwnProp.call(expr, 'otherTypeCallback') ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = hasOwnProp.call(expr, 'parent') ? expr.parent : currParent;
    currParentProperty = hasOwnProp.call(expr, 'parentProperty') ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }

  currParent = currParent || null;
  currParentProperty = currParentProperty || null;

  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }

  if (!expr && expr !== '' || !json) {
    return undefined;
  }

  var exprList = JSONPath.toPathArray(expr);

  if (exprList[0] === '$' && exprList.length > 1) {
    exprList.shift();
  }

  this._hasParentSelector = null;

  var result = this._trace(exprList, json, ['$'], currParent, currParentProperty, callback).filter(function (ea) {
    return ea && !ea.isParentSelector;
  });

  if (!result.length) {
    return wrap ? [] : undefined;
  }

  if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }

  return result.reduce(function (rslt, ea) {
    var valOrPath = _this2._getPreferredOutput(ea);

    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }

    return rslt;
  }, []);
}; // PRIVATE METHODS


JSONPath.prototype._getPreferredOutput = function (ea) {
  var resultType = this.currResultType;

  switch (resultType) {
    case 'all':
      {
        var path = Array.isArray(ea.path) ? ea.path : JSONPath.toPathArray(ea.path);
        ea.pointer = JSONPath.toPointer(path);
        ea.path = typeof ea.path === 'string' ? ea.path : JSONPath.toPathString(ea.path);
        return ea;
      }

    case 'value':
    case 'parent':
    case 'parentProperty':
      return ea[resultType];

    case 'path':
      return JSONPath.toPathString(ea[resultType]);

    case 'pointer':
      return JSONPath.toPointer(ea.path);

    default:
      throw new TypeError('Unknown result type');
  }
};

JSONPath.prototype._handleCallback = function (fullRetObj, callback, type) {
  if (callback) {
    var preferredOutput = this._getPreferredOutput(fullRetObj);

    fullRetObj.path = typeof fullRetObj.path === 'string' ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path); // eslint-disable-next-line node/callback-return

    callback(preferredOutput, type, fullRetObj);
  }
};
/**
 *
 * @param {string} expr
 * @param {JSONObject} val
 * @param {string} path
 * @param {PlainObject|GenericArray} parent
 * @param {string} parentPropName
 * @param {JSONPathCallback} callback
 * @param {boolean} hasArrExpr
 * @param {boolean} literalPriority
 * @returns {ReturnObject|ReturnObject[]}
 */


JSONPath.prototype._trace = function (expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
  var _this3 = this;

  // No expr to follow? return path and value as the result of
  //  this trace branch
  var retObj;

  if (!expr.length) {
    retObj = {
      path: path,
      value: val,
      parent: parent,
      parentProperty: parentPropName,
      hasArrExpr: hasArrExpr
    };

    this._handleCallback(retObj, callback, 'value');

    return retObj;
  }

  var loc = expr[0],
      x = expr.slice(1); // We need to gather the return value of recursive trace calls in order to
  // do the parent sel computation.

  var ret = [];
  /**
   *
   * @param {ReturnObject|ReturnObject[]} elems
   * @returns {void}
   */

  function addRet(elems) {
    if (Array.isArray(elems)) {
      // This was causing excessive stack size in Node (with or
      //  without Babel) against our performance test:
      //  `ret.push(...elems);`
      elems.forEach(function (t) {
        ret.push(t);
      });
    } else {
      ret.push(elems);
    }
  }

  if ((typeof loc !== 'string' || literalPriority) && val && hasOwnProp.call(val, loc)) {
    // simple case--directly follow property
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr)); // eslint-disable-next-line unicorn/prefer-switch -- Part of larger `if`
  } else if (loc === '*') {
    // all child properties
    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      addRet(_this3._trace(unshift(m, _x), v, p, par, pr, cb, true, true));
    });
  } else if (loc === '..') {
    // all descendent parent properties
    // Check remaining expression with val's immediate children
    addRet(this._trace(x, val, path, parent, parentPropName, callback, hasArrExpr));

    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      // We don't join m and x here because we only want parents,
      //   not scalar values
      if (_typeof(v[m]) === 'object') {
        // Keep going with recursive descent on val's
        //   object children
        addRet(_this3._trace(unshift(l, _x), v[m], push(p, m), v, m, cb, true));
      }
    }); // The parent sel computation is handled in the frame above using the
    // ancestor object of val

  } else if (loc === '^') {
    // This is not a final endpoint, so we do not invoke the callback here
    this._hasParentSelector = true;
    return {
      path: path.slice(0, -1),
      expr: x,
      isParentSelector: true
    };
  } else if (loc === '~') {
    // property name
    retObj = {
      path: push(path, loc),
      value: parentPropName,
      parent: parent,
      parentProperty: null
    };

    this._handleCallback(retObj, callback, 'property');

    return retObj;
  } else if (loc === '$') {
    // root only
    addRet(this._trace(x, val, path, null, null, callback, hasArrExpr));
  } else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(loc)) {
    // [start:end:step]  Python slice syntax
    addRet(this._slice(loc, x, val, path, parent, parentPropName, callback));
  } else if (loc.indexOf('?(') === 0) {
    // [?(expr)] (filtering)
    if (this.currPreventEval) {
      throw new Error('Eval [?(expr)] prevented in JSONPath expression.');
    }

    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      if (_this3._eval(l.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, '$1'), v[m], m, p, par, pr)) {
        addRet(_this3._trace(unshift(m, _x), v, p, par, pr, cb, true));
      }
    });
  } else if (loc[0] === '(') {
    // [(expr)] (dynamic property/index)
    if (this.currPreventEval) {
      throw new Error('Eval [(expr)] prevented in JSONPath expression.');
    } // As this will resolve to a property name (but we don't know it
    //  yet), property and parent information is relative to the
    //  parent of the property to which this expression will resolve


    addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x), val, path, parent, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === '@') {
    // value type: @boolean(), etc.
    var addType = false;
    var valueType = loc.slice(1, -2);

    switch (valueType) {
      case 'scalar':
        if (!val || !['object', 'function'].includes(_typeof(val))) {
          addType = true;
        }

        break;

      case 'boolean':
      case 'string':
      case 'undefined':
      case 'function':
        // eslint-disable-next-line valid-typeof
        if (_typeof(val) === valueType) {
          addType = true;
        }

        break;

      case 'integer':
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }

        break;

      case 'number':
        if (Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'nonFinite':
        if (typeof val === 'number' && !Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'object':
        // eslint-disable-next-line valid-typeof
        if (val && _typeof(val) === valueType) {
          addType = true;
        }

        break;

      case 'array':
        if (Array.isArray(val)) {
          addType = true;
        }

        break;

      case 'other':
        addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
        break;

      case 'null':
        if (val === null) {
          addType = true;
        }

        break;

      /* c8 ignore next 2 */

      default:
        throw new TypeError('Unknown value type ' + valueType);
    }

    if (addType) {
      retObj = {
        path: path,
        value: val,
        parent: parent,
        parentProperty: parentPropName
      };

      this._handleCallback(retObj, callback, 'value');

      return retObj;
    } // `-escaped property

  } else if (loc[0] === '`' && val && hasOwnProp.call(val, loc.slice(1))) {
    var locProp = loc.slice(1);
    addRet(this._trace(x, val[locProp], push(path, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(',')) {
    // [name1,name2,...]
    var parts = loc.split(',');

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;
        addRet(this._trace(unshift(part, x), val, path, parent, parentPropName, callback, true));
      } // simple case--directly follow property

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr, true));
  } // We check the resulting values for parent selections. For parent
  // selections we discard the value object and continue the trace with the
  // current val object


  if (this._hasParentSelector) {
    for (var t = 0; t < ret.length; t++) {
      var rett = ret[t];

      if (rett && rett.isParentSelector) {
        var tmp = this._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);

        if (Array.isArray(tmp)) {
          ret[t] = tmp[0];
          var tl = tmp.length;

          for (var tt = 1; tt < tl; tt++) {
            t++;
            ret.splice(t, 0, tmp[tt]);
          }
        } else {
          ret[t] = tmp;
        }
      }
    }
  }

  return ret;
};

JSONPath.prototype._walk = function (loc, expr, val, path, parent, parentPropName, callback, f) {
  if (Array.isArray(val)) {
    var n = val.length;

    for (var i = 0; i < n; i++) {
      f(i, loc, expr, val, path, parent, parentPropName, callback);
    }
  } else if (val && _typeof(val) === 'object') {
    Object.keys(val).forEach(function (m) {
      f(m, loc, expr, val, path, parent, parentPropName, callback);
    });
  }
};

JSONPath.prototype._slice = function (loc, expr, val, path, parent, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return undefined;
  }

  var len = val.length,
      parts = loc.split(':'),
      step = parts[2] && Number.parseInt(parts[2]) || 1;
  var start = parts[0] && Number.parseInt(parts[0]) || 0,
      end = parts[1] && Number.parseInt(parts[1]) || len;
  start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
  end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
  var ret = [];

  for (var i = start; i < end; i += step) {
    var tmp = this._trace(unshift(i, expr), val, path, parent, parentPropName, callback, true); // Should only be possible to be an array here since first part of
    //   ``unshift(i, expr)` passed in above would not be empty, nor `~`,
    //     nor begin with `@` (as could return objects)
    // This was causing excessive stack size in Node (with or
    //  without Babel) against our performance test: `ret.push(...tmp);`


    tmp.forEach(function (t) {
      ret.push(t);
    });
  }

  return ret;
};

JSONPath.prototype._eval = function (code, _v, _vname, path, parent, parentPropName) {
  if (code.includes('@parentProperty')) {
    this.currSandbox._$_parentProperty = parentPropName;
    code = code.replace(/@parentProperty/g, '_$_parentProperty');
  }

  if (code.includes('@parent')) {
    this.currSandbox._$_parent = parent;
    code = code.replace(/@parent/g, '_$_parent');
  }

  if (code.includes('@property')) {
    this.currSandbox._$_property = _vname;
    code = code.replace(/@property/g, '_$_property');
  }

  if (code.includes('@path')) {
    this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
    code = code.replace(/@path/g, '_$_path');
  }

  if (code.includes('@root')) {
    this.currSandbox._$_root = this.json;
    code = code.replace(/@root/g, '_$_root');
  }

  if (/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(code)) {
    this.currSandbox._$_v = _v;
    code = code.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, '_$_v$1');
  }

  try {
    return this.vm.runInNewContext(code, this.currSandbox);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    throw new Error('jsonPath: ' + e.message + ': ' + code);
  }
}; // PUBLIC CLASS PROPERTIES AND METHODS
// Could store the cache object itself


JSONPath.cache = {};
/**
 * @param {string[]} pathArr Array to convert
 * @returns {string} The path string
 */

JSONPath.toPathString = function (pathArr) {
  var x = pathArr,
      n = x.length;
  var p = '$';

  for (var i = 1; i < n; i++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
      p += /^[\*0-9]+$/.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
    }
  }

  return p;
};
/**
 * @param {string} pointer JSON Path
 * @returns {string} JSON Pointer
 */


JSONPath.toPointer = function (pointer) {
  var x = pointer,
      n = x.length;
  var p = '';

  for (var i = 1; i < n; i++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
      p += '/' + x[i].toString().replace(/~/g, '~0').replace(/\//g, '~1');
    }
  }

  return p;
};
/**
 * @param {string} expr Expression to convert
 * @returns {string[]}
 */


JSONPath.toPathArray = function (expr) {
  var cache = JSONPath.cache;

  if (cache[expr]) {
    return cache[expr].concat();
  }

  var subx = [];
  var normalized = expr // Properties
  .replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ';$&;') // Parenthetical evaluations (filtering and otherwise), directly
  //   within brackets or single quotes
  .replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function ($0, $1) {
    return '[#' + (subx.push($1) - 1) + ']';
  }) // Escape periods and tildes within properties
  .replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function ($0, prop) {
    return "['" + prop.replace(/\./g, '%@%').replace(/~/g, '%%@@%%') + "']";
  }) // Properties operator
  .replace(/~/g, ';~;') // Split by property boundaries
  .replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ';') // Reinsert periods within properties
  .replace(/%@%/g, '.') // Reinsert tildes within properties
  .replace(/%%@@%%/g, '~') // Parent
  .replace(/(?:;)?(\^+)(?:;)?/g, function ($0, ups) {
    return ';' + ups.split('').join(';') + ';';
  }) // Descendents
  .replace(/;;;|;;/g, ';..;') // Remove trailing
  .replace(/;$|'?\]|'$/g, '');
  var exprList = normalized.split(';').map(function (exp) {
    var match = exp.match(/#([0-9]+)/);
    return !match || !match[1] ? exp : subx[match[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};

/**
* @callback ConditionCallback
* @param {any} item
* @returns {boolean}
*/

/**
 * Copy items out of one array into another.
 * @param {GenericArray} source Array with items to copy
 * @param {GenericArray} target Array to which to copy
 * @param {ConditionCallback} conditionCb Callback passed the current item;
 *     will move item if evaluates to `true`
 * @returns {void}
 */

var moveToAnotherArray = function moveToAnotherArray(source, target, conditionCb) {
  var il = source.length;

  for (var i = 0; i < il; i++) {
    var item = source[i];

    if (conditionCb(item)) {
      target.push(source.splice(i--, 1)[0]);
    }
  }
};

JSONPath.prototype.vm = {
  /**
   * @param {string} expr Expression to evaluate
   * @param {PlainObject} context Object whose items will be added
   *   to evaluation
   * @returns {any} Result of evaluated code
   */
  runInNewContext: function runInNewContext(expr, context) {
    var keys = Object.keys(context);
    var funcs = [];
    moveToAnotherArray(keys, funcs, function (key) {
      return typeof context[key] === 'function';
    });
    var values = keys.map(function (vr, i) {
      return context[vr];
    });
    var funcString = funcs.reduce(function (s, func) {
      var fString = context[func].toString();

      if (!/function/.test(fString)) {
        fString = 'function ' + fString;
      }

      return 'var ' + func + '=' + fString + ';' + s;
    }, '');
    expr = funcString + expr; // Mitigate http://perfectionkills.com/global-eval-what-are-the-options/#new_function

    if (!/(["'])use strict\1/.test(expr) && !keys.includes('arguments')) {
      expr = 'var arguments = undefined;' + expr;
    } // Remove last semi so `return` will be inserted before
    //  the previous one instead, allowing for the return
    //  of a bare ending expression


    expr = expr.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, ''); // Insert `return`

    var lastStatementEnd = expr.lastIndexOf(';');
    var code = lastStatementEnd > -1 ? expr.slice(0, lastStatementEnd + 1) + ' return ' + expr.slice(lastStatementEnd + 1) : ' return ' + expr; // eslint-disable-next-line no-new-func

    return _construct(Function, _toConsumableArray(keys).concat([code])).apply(void 0, _toConsumableArray(values));
  }
};



;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/idxResponseParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






const SKIP_FIELDS = Object.fromEntries([
    'remediation',
    'context',
].map((field) => [field, !!'skip this field']));
const parseNonRemediations = function parseNonRemediations(authClient, idxResponse, toPersist = {}) {
    const actions = {};
    const context = {};
    Object.keys(idxResponse)
        .filter(field => !SKIP_FIELDS[field])
        .forEach(field => {
        const fieldIsObject = typeof idxResponse[field] === 'object' && !!idxResponse[field];
        if (!fieldIsObject) {
            context[field] = idxResponse[field];
            return;
        }
        if (idxResponse[field].rel) {
            actions[idxResponse[field].name] = generateIdxAction(authClient, idxResponse[field], toPersist);
            return;
        }
        const _a = idxResponse[field], { value: fieldValue, type } = _a, info = __rest(_a, ["value", "type"]);
        context[field] = Object.assign({ type }, info);
        if (type !== 'object') {
            context[field].value = fieldValue;
            return;
        }
        context[field].value = {};
        Object.entries(fieldValue)
            .forEach(([subField, value]) => {
            if (value.rel) {
                actions[`${field}-${subField.name || subField}`] = generateIdxAction(authClient, value, toPersist);
            }
            else {
                context[field].value[subField] = value;
            }
        });
    });
    return { context, actions };
};
const expandRelatesTo = (idxResponse, value) => {
    Object.keys(value).forEach(k => {
        if (k === 'relatesTo') {
            const query = Array.isArray(value[k]) ? value[k][0] : value[k];
            if (typeof query === 'string') {
                const result = JSONPath({ path: query, json: idxResponse })[0];
                if (result) {
                    value[k] = result;
                    return;
                }
            }
        }
        if (Array.isArray(value[k])) {
            value[k].forEach(innerValue => expandRelatesTo(idxResponse, innerValue));
        }
    });
};
const convertRemediationAction = (authClient, remediation, toPersist) => {
    if (remediation.rel) {
        const remediationActions = generateRemediationFunctions(authClient, [remediation], toPersist);
        const actionFn = remediationActions[remediation.name];
        return Object.assign(Object.assign({}, remediation), { action: actionFn });
    }
    return remediation;
};
const parseIdxResponse = function parseIdxResponse(authClient, idxResponse, toPersist = {}) {
    var _a;
    const remediationData = ((_a = idxResponse.remediation) === null || _a === void 0 ? void 0 : _a.value) || [];
    remediationData.forEach(remediation => expandRelatesTo(idxResponse, remediation));
    const remediations = remediationData.map(remediation => convertRemediationAction(authClient, remediation, toPersist));
    const { context, actions } = parseNonRemediations(authClient, idxResponse, toPersist);
    return {
        remediations,
        context,
        actions,
    };
};


//# sourceMappingURL=idxResponseParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/makeIdxState.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function makeIdxState(authClient, idxResponse, toPersist, requestDidSucceed) {
    var _a, _b, _c;
    const rawIdxResponse = idxResponse;
    const { remediations, context, actions } = parseIdxResponse(authClient, idxResponse, toPersist);
    const neededToProceed = [...remediations];
    const proceed = async function (remediationChoice, paramsFromUser = {}) {
        const remediationChoiceObject = remediations.find((remediation) => remediation.name === remediationChoice);
        if (!remediationChoiceObject) {
            return Promise.reject(`Unknown remediation choice: [${remediationChoice}]`);
        }
        const actionFn = remediationChoiceObject.action;
        if (typeof actionFn !== 'function') {
            return Promise.reject(`Current remediation cannot make form submit action: [${remediationChoice}]`);
        }
        return remediationChoiceObject.action(paramsFromUser);
    };
    const findCode = item => item.name === 'interaction_code';
    const interactionCode = (_c = (_b = (_a = rawIdxResponse.successWithInteractionCode) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(findCode)) === null || _c === void 0 ? void 0 : _c.value;
    return {
        proceed,
        neededToProceed,
        actions,
        context,
        rawIdxState: rawIdxResponse,
        interactionCode,
        toPersist,
        requestDidSucceed,
    };
}


//# sourceMappingURL=makeIdxState.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/parsers.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



var v1 = {
    makeIdxState: makeIdxState,
};


//# sourceMappingURL=parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




const parsersForVersion = function parsersForVersion(version) {
    switch (version) {
        case '1.0.0':
            return v1;
        case undefined:
        case null:
            throw new Error('Api version is required');
        default:
            throw new Error(`Unknown api version: ${version}.  Use an exact semver version.`);
    }
};
function validateVersionConfig(version) {
    if (!version) {
        throw new Error('version is required');
    }
    const cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');
    if (cleanVersion !== version || !version) {
        throw new Error('invalid version supplied - version is required and uses semver syntax');
    }
    parsersForVersion(version);
}
function idxState_makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed) {
    var _a;
    const version = (_a = rawIdxResponse === null || rawIdxResponse === void 0 ? void 0 : rawIdxResponse.version) !== null && _a !== void 0 ? _a : IDX_API_VERSION;
    validateVersionConfig(version);
    const { makeIdxState } = parsersForVersion(version);
    return makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/introspect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










async function introspect(authClient, options = {}) {
    var _a;
    let rawIdxResponse;
    let requestDidSucceed;
    const savedIdxResponse = authClient.transactionManager.loadIdxResponse(options);
    if (savedIdxResponse) {
        rawIdxResponse = savedIdxResponse.rawIdxResponse;
        requestDidSucceed = savedIdxResponse.requestDidSucceed;
    }
    if (!rawIdxResponse) {
        const version = options.version || IDX_API_VERSION;
        const domain = getOAuthDomain(authClient);
        const { interactionHandle, stateHandle } = options;
        const withCredentials = (_a = options.withCredentials) !== null && _a !== void 0 ? _a : true;
        try {
            requestDidSucceed = true;
            validateVersionConfig(version);
            const url = `${domain}/idp/idx/introspect`;
            const body = stateHandle ? { stateToken: stateHandle } : { interactionHandle };
            const headers = {
                'Content-Type': `application/ion+json; okta-version=${version}`,
                Accept: `application/ion+json; okta-version=${version}`,
            };
            rawIdxResponse = await request_httpRequest(authClient, {
                method: 'POST',
                url,
                headers,
                withCredentials,
                args: body
            });
        }
        catch (err) {
            if (errors_isAuthApiError(err) && err.xhr && isRawIdxResponse(err.xhr.responseJSON)) {
                rawIdxResponse = err.xhr.responseJSON;
                requestDidSucceed = false;
            }
            else {
                throw err;
            }
        }
    }
    const { withCredentials } = options;
    return idxState_makeIdxState(authClient, rawIdxResponse, { withCredentials }, requestDidSucceed);
}


//# sourceMappingURL=introspect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getAllValues(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.map(r => r.name);
}
function getRequiredValues(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.reduce((required, cur) => {
        if (cur.required) {
            required.push(cur.name);
        }
        return required;
    }, []);
}
function titleCase(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
function getAuthenticatorFromRemediation(remediation) {
    return remediation.value.find(({ name }) => name === 'authenticator');
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function formatAuthenticator(incoming) {
    let authenticator;
    if (isAuthenticator(incoming)) {
        authenticator = incoming;
    }
    else if (typeof incoming === 'string') {
        authenticator = {
            key: incoming
        };
    }
    else {
        throw new Error('Invalid format for authenticator');
    }
    return authenticator;
}
function compareAuthenticators(auth1, auth2) {
    if (!auth1 || !auth2) {
        return false;
    }
    if (auth1.id && auth2.id) {
        return (auth1.id === auth2.id);
    }
    if (auth1.key && auth2.key) {
        return (auth1.key === auth2.key);
    }
    return false;
}
function findMatchedOption(authenticators, options) {
    let option;
    for (let authenticator of authenticators) {
        option = options
            .find(({ relatesTo }) => relatesTo.key === authenticator.key);
        if (option) {
            break;
        }
    }
    return option;
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/Remediator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class Remediator {
    constructor(remediation, values = {}, options = {}) {
        this.values = Object.assign({}, values);
        this.options = Object.assign({}, options);
        this.formatAuthenticators();
        this.remediation = remediation;
    }
    formatAuthenticators() {
        this.values.authenticators = (this.values.authenticators || []);
        this.values.authenticators = this.values.authenticators.map(authenticator => {
            return formatAuthenticator(authenticator);
        });
        if (this.values.authenticator) {
            const authenticator = formatAuthenticator(this.values.authenticator);
            const hasAuthenticatorInList = this.values.authenticators.some(existing => {
                return compareAuthenticators(authenticator, existing);
            });
            if (!hasAuthenticatorInList) {
                this.values.authenticators.push(authenticator);
            }
        }
        this.values.authenticatorsData = this.values.authenticators.reduce((acc, authenticator) => {
            if (typeof authenticator === 'object' && Object.keys(authenticator).length > 1) {
                acc.push(authenticator);
            }
            return acc;
        }, this.values.authenticatorsData || []);
    }
    getName() {
        return this.remediation.name;
    }
    canRemediate() {
        const required = getRequiredValues(this.remediation);
        const needed = required.find((key) => !this.hasData(key));
        if (needed) {
            return false;
        }
        return true;
    }
    getData(key) {
        if (!key) {
            let allValues = getAllValues(this.remediation);
            let res = allValues.reduce((data, key) => {
                data[key] = this.getData(key);
                return data;
            }, {});
            return res;
        }
        if (typeof this[`map${titleCase(key)}`] === 'function') {
            const val = this[`map${titleCase(key)}`](this.remediation.value.find(({ name }) => name === key));
            if (val) {
                return val;
            }
        }
        if (this.map && this.map[key]) {
            const entry = this.map[key];
            for (let i = 0; i < entry.length; i++) {
                let val = this.values[entry[i]];
                if (val) {
                    return val;
                }
            }
        }
        return this.values[key];
    }
    hasData(key
    ) {
        return !!this.getData(key);
    }
    getNextStep(_authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const authenticator = this.getAuthenticator();
        const type = authenticator === null || authenticator === void 0 ? void 0 : authenticator.type;
        return Object.assign(Object.assign({ name,
            inputs }, (type && { type })), (authenticator && { authenticator }));
    }
    getInputs() {
        const inputs = [];
        const inputsFromRemediation = this.remediation.value || [];
        inputsFromRemediation.forEach(inputFromRemediation => {
            let input;
            let { name, type, visible, messages } = inputFromRemediation;
            if (visible === false) {
                return;
            }
            if (typeof this[`getInput${titleCase(name)}`] === 'function') {
                input = this[`getInput${titleCase(name)}`](inputFromRemediation);
            }
            else if (type !== 'object') {
                let alias;
                const aliases = (this.map ? this.map[name] : null) || [];
                if (aliases.length === 1) {
                    alias = aliases[0];
                }
                else {
                    alias = aliases.find(name => Object.keys(this.values).includes(name));
                }
                if (alias) {
                    input = Object.assign(Object.assign({}, inputFromRemediation), { name: alias });
                }
            }
            if (!input) {
                input = inputFromRemediation;
            }
            if (Array.isArray(input)) {
                input.forEach(i => inputs.push(i));
            }
            else {
                if (messages) {
                    input.messages = messages;
                }
                inputs.push(input);
            }
        });
        return inputs;
    }
    static getMessages(remediation) {
        var _a, _b;
        if (!remediation.value) {
            return;
        }
        return (_b = (_a = remediation.value[0]) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.value.reduce((messages, field) => {
            if (field.messages) {
                messages = [...messages, ...field.messages.value];
            }
            return messages;
        }, []);
    }
    getValuesAfterProceed() {
        const inputsFromRemediation = this.remediation.value || [];
        const inputsFromRemediator = this.getInputs();
        const inputs = [
            ...inputsFromRemediation,
            ...inputsFromRemediator
        ];
        for (const input of inputs) {
            delete this.values[input.name];
        }
        return this.values;
    }
    getAuthenticator() {
        var _a, _b;
        const relatesTo = (_a = this.remediation.relatesTo) === null || _a === void 0 ? void 0 : _a.value;
        if (!relatesTo) {
            return;
        }
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        if (!authenticatorFromRemediation) {
            return relatesTo;
        }
        const id = authenticatorFromRemediation.form.value
            .find(({ name }) => name === 'id').value;
        const enrollmentId = (_b = authenticatorFromRemediation.form.value
            .find(({ name }) => name === 'enrollmentId')) === null || _b === void 0 ? void 0 : _b.value;
        return Object.assign(Object.assign({}, relatesTo), { id,
            enrollmentId });
    }
}


//# sourceMappingURL=Remediator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/Authenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class Authenticator {
    constructor(authenticator) {
        this.meta = authenticator;
    }
}


//# sourceMappingURL=Authenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/VerificationCodeAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class VerificationCodeAuthenticator extends Authenticator {
    canVerify(values) {
        return !!(values.credentials || values.verificationCode || values.otp);
    }
    mapCredentials(values) {
        const { credentials, verificationCode, otp } = values;
        if (!credentials && !verificationCode && !otp) {
            return;
        }
        return credentials || { passcode: verificationCode || otp };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), { name: 'verificationCode', type: 'string', required: idxRemediationValue.required });
    }
}


//# sourceMappingURL=VerificationCodeAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/OktaVerifyTotp.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaVerifyTotp extends VerificationCodeAuthenticator {
    mapCredentials(values) {
        const { verificationCode } = values;
        if (!verificationCode) {
            return;
        }
        return { totp: verificationCode };
    }
}


//# sourceMappingURL=OktaVerifyTotp.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/OktaPassword.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaPassword extends Authenticator {
    canVerify(values) {
        return !!(values.credentials || values.password || values.passcode);
    }
    mapCredentials(values) {
        const { credentials, password, passcode } = values;
        if (!credentials && !password && !passcode) {
            return;
        }
        return credentials || { passcode: passcode || password };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), { name: 'password', type: 'string', required: idxRemediationValue.required });
    }
}


//# sourceMappingURL=OktaPassword.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/SecurityQuestionEnrollment.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SecurityQuestionEnrollment extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        if (credentials && credentials.questionKey && credentials.answer) {
            return true;
        }
        const { questionKey, question, answer } = values;
        return !!(questionKey && answer) || !!(question && answer);
    }
    mapCredentials(values) {
        const { questionKey, question, answer } = values;
        if (!answer || (!questionKey && !question)) {
            return;
        }
        return {
            questionKey: question ? 'custom' : questionKey,
            question,
            answer
        };
    }
    getInputs() {
        return [
            { name: 'questionKey', type: 'string', required: true },
            { name: 'question', type: 'string', label: 'Create a security question' },
            { name: 'answer', type: 'string', label: 'Answer', required: true },
        ];
    }
}


//# sourceMappingURL=SecurityQuestionEnrollment.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/SecurityQuestionVerification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SecurityQuestionVerification extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        if (credentials && credentials.answer) {
            return true;
        }
        const { answer } = values;
        return !!answer;
    }
    mapCredentials(values) {
        const { answer } = values;
        if (!answer) {
            return;
        }
        return {
            questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
            answer
        };
    }
    getInputs() {
        return [
            { name: 'answer', type: 'string', label: 'Answer', required: true }
        ];
    }
}


//# sourceMappingURL=SecurityQuestionVerification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/WebauthnEnrollment.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class WebauthnEnrollment extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        const obj = credentials || values;
        const { clientData, attestation } = obj;
        return !!(clientData && attestation);
    }
    mapCredentials(values) {
        const { credentials, clientData, attestation } = values;
        if (!credentials && !clientData && !attestation) {
            return;
        }
        return credentials || ({
            clientData,
            attestation
        });
    }
    getInputs() {
        return [
            { name: 'clientData', type: 'string', required: true, visible: false, label: 'Client Data' },
            { name: 'attestation', type: 'string', required: true, visible: false, label: 'Attestation' },
        ];
    }
}


//# sourceMappingURL=WebauthnEnrollment.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/WebauthnVerification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class WebauthnVerification extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        const obj = credentials || values;
        const { clientData, authenticatorData, signatureData } = obj;
        return !!(clientData && authenticatorData && signatureData);
    }
    mapCredentials(values) {
        const { credentials, authenticatorData, clientData, signatureData } = values;
        if (!credentials && !authenticatorData && !clientData && !signatureData) {
            return;
        }
        return credentials || ({
            authenticatorData,
            clientData,
            signatureData
        });
    }
    getInputs() {
        return [
            { name: 'authenticatorData', type: 'string', label: 'Authenticator Data', required: true, visible: false },
            { name: 'clientData', type: 'string', label: 'Client Data', required: true, visible: false },
            { name: 'signatureData', type: 'string', label: 'Signature Data', required: true, visible: false },
        ];
    }
}


//# sourceMappingURL=WebauthnVerification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/getAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function getAuthenticator(remediation) {
    var _a, _b;
    const relatesTo = remediation.relatesTo;
    const value = (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.value) || {};
    switch (value.key) {
        case AuthenticatorKey.OKTA_PASSWORD:
            return new OktaPassword(value);
        case AuthenticatorKey.SECURITY_QUESTION:
            if ((_a = value.contextualData) === null || _a === void 0 ? void 0 : _a.enrolledQuestion) {
                return new SecurityQuestionVerification(value);
            }
            else {
                return new SecurityQuestionEnrollment(value);
            }
        case AuthenticatorKey.OKTA_VERIFY:
            return new OktaVerifyTotp(value);
        case AuthenticatorKey.WEBAUTHN:
            if ((_b = value.contextualData) === null || _b === void 0 ? void 0 : _b.challengeData) {
                return new WebauthnVerification(value);
            }
            else {
                return new WebauthnEnrollment(value);
            }
        default:
            return new VerificationCodeAuthenticator(value);
    }
}


//# sourceMappingURL=getAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/VerifyAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class VerifyAuthenticator extends Remediator {
    constructor(remediation, values = {}) {
        super(remediation, values);
        this.authenticator = getAuthenticator(remediation);
    }
    getNextStep(authClient, context) {
        var _a;
        const nextStep = super.getNextStep(authClient, context);
        const authenticatorEnrollments = (_a = context === null || context === void 0 ? void 0 : context.authenticatorEnrollments) === null || _a === void 0 ? void 0 : _a.value;
        return Object.assign(Object.assign({}, nextStep), { authenticatorEnrollments });
    }
    canRemediate() {
        return this.authenticator.canVerify(this.values);
    }
    mapCredentials() {
        return this.authenticator.mapCredentials(this.values);
    }
    getInputCredentials(input) {
        return this.authenticator.getInputs(input);
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'credentials');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}


//# sourceMappingURL=VerifyAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollAuthenticator extends VerifyAuthenticator {
}
EnrollAuthenticator.remediationName = 'enroll-authenticator';


//# sourceMappingURL=EnrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollPoll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollPoll extends Remediator {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'enroll-poll';
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        let authenticator = this.getAuthenticator();
        if (!authenticator && (context === null || context === void 0 ? void 0 : context.currentAuthenticator)) {
            authenticator = context.currentAuthenticator.value;
        }
        return Object.assign(Object.assign({}, common), { authenticator, poll: {
                required: true,
                refresh: this.remediation.refresh
            } });
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'startPolling');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollPoll.remediationName = 'enroll-poll';


//# sourceMappingURL=EnrollPoll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectEnrollmentChannel.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class SelectEnrollmentChannel extends Remediator {
    canRemediate() {
        if (this.values.channel) {
            return true;
        }
        if (this.values.authenticator) {
            const { id, channel } = this.values.authenticator;
            if (!!id && !!channel) {
                return true;
            }
        }
        return false;
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const options = this.getChannels();
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign(Object.assign({}, common), (options && { options })), { authenticator });
    }
    getChannels() {
        var _a;
        const authenticator = getAuthenticatorFromRemediation(this.remediation);
        const remediationValue = authenticator.value;
        return (_a = remediationValue.form.value.find(({ name }) => name === 'channel')) === null || _a === void 0 ? void 0 : _a.options;
    }
    getData() {
        var _a;
        const remediationValue = this.remediation.value[0].value;
        return {
            authenticator: {
                id: remediationValue.form.value[0].value,
                channel: ((_a = this.values.authenticator) === null || _a === void 0 ? void 0 : _a.channel) || this.values.channel,
            },
            stateHandle: this.values.stateHandle,
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        delete this.values.authenticators;
        const filterKey = this.values.channel ? 'channel' : 'authenticator';
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== filterKey);
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
SelectEnrollmentChannel.remediationName = 'select-enrollment-channel';


//# sourceMappingURL=SelectEnrollmentChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollmentChannelData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollmentChannelData extends Remediator {
    getInputEmail() {
        return [
            { name: 'email', type: 'string', required: true, label: 'Email' },
        ];
    }
    getInputPhoneNumber() {
        return [
            { name: 'phoneNumber', type: 'string', required: true, label: 'Phone Number' },
        ];
    }
    canRemediate() {
        return Boolean(this.values.email || this.values.phoneNumber);
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), { authenticator });
    }
    getData() {
        return {
            stateHandle: this.values.stateHandle,
            email: this.values.email,
            phoneNumber: this.values.phoneNumber
        };
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => !['email', 'phoneNumber'].includes(valueKey));
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollmentChannelData.remediationName = 'enrollment-channel-data';


//# sourceMappingURL=EnrollmentChannelData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ChallengeAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ChallengeAuthenticator extends VerifyAuthenticator {
}
ChallengeAuthenticator.remediationName = 'challenge-authenticator';


//# sourceMappingURL=ChallengeAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ChallengePoll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ChallengePoll extends EnrollPoll {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'challenge-poll';
    }
}
ChallengePoll.remediationName = 'challenge-poll';


//# sourceMappingURL=ChallengePoll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ResetAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ResetAuthenticator extends VerifyAuthenticator {
}
ResetAuthenticator.remediationName = 'reset-authenticator';


//# sourceMappingURL=ResetAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollProfile.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class EnrollProfile extends Remediator {
    constructor(remediation, values = {}, options = {}) {
        super(remediation, values, options);
        this.authenticator = null;
        const credentials = this.getCredentialsFromRemediation();
        if (credentials) {
            this.authenticator = this.authenticator = new OktaPassword({});
        }
    }
    canRemediate() {
        if (this.authenticator && !this.authenticator.canVerify(this.values)) {
            return false;
        }
        const userProfileFromValues = this.getData().userProfile;
        if (!userProfileFromValues) {
            return false;
        }
        const userProfileFromRemediation = this.remediation.value.find(({ name }) => name === 'userProfile');
        return userProfileFromRemediation.form.value.reduce((canRemediate, curr) => {
            if (curr.required) {
                canRemediate = canRemediate && !!userProfileFromValues[curr.name];
            }
            return canRemediate;
        }, true);
    }
    getCredentialsFromRemediation() {
        return this.remediation.value.find(({ name }) => name === 'credentials');
    }
    mapUserProfile({ form: { value: profileAttributes } }) {
        const attributeNames = profileAttributes.map(({ name }) => name);
        const data = attributeNames.reduce((attributeValues, attributeName) => (this.values[attributeName] ? Object.assign(Object.assign({}, attributeValues), { [attributeName]: this.values[attributeName] }) : attributeValues), {});
        if (Object.keys(data).length === 0) {
            return;
        }
        return data;
    }
    mapCredentials() {
        const val = this.authenticator && this.authenticator.mapCredentials(this.values);
        if (!val) {
            return;
        }
        return val;
    }
    getInputUserProfile(input) {
        return [...input.form.value];
    }
    getInputCredentials(input) {
        return [...input.form.value];
    }
    getErrorMessages(errorRemediation) {
        return errorRemediation.value[0].form.value.reduce((errors, field) => {
            if (field.messages) {
                errors.push(field.messages.value[0].message);
            }
            return errors;
        }, []);
    }
}
EnrollProfile.remediationName = 'enroll-profile';


//# sourceMappingURL=EnrollProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Identify.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class Identify extends Remediator {
    constructor() {
        super(...arguments);
        this.map = {
            'identifier': ['username']
        };
    }
    canRemediate() {
        const { identifier } = this.getData();
        return !!identifier;
    }
    mapCredentials() {
        const { credentials, password } = this.values;
        if (!credentials && !password) {
            return;
        }
        return credentials || { passcode: password };
    }
    getInputCredentials(input) {
        return Object.assign(Object.assign({}, input.form.value[0]), { name: 'password', required: input.required });
    }
}
Identify.remediationName = 'identify';


//# sourceMappingURL=Identify.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ReEnrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ReEnrollAuthenticator extends Remediator {
    mapCredentials() {
        const { newPassword } = this.values;
        if (!newPassword) {
            return;
        }
        return {
            passcode: newPassword,
        };
    }
    getInputCredentials(input) {
        const challengeType = this.getAuthenticator().type;
        const name = challengeType === 'password' ? 'newPassword' : 'verificationCode';
        return Object.assign(Object.assign({}, input.form.value[0]), { name });
    }
}
ReEnrollAuthenticator.remediationName = 'reenroll-authenticator';


//# sourceMappingURL=ReEnrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/RedirectIdp.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class RedirectIdp extends Remediator {
    canRemediate() {
        return false;
    }
    getNextStep() {
        const { name, type, idp, href } = this.remediation;
        return {
            name,
            type,
            idp,
            href
        };
    }
}
RedirectIdp.remediationName = 'redirect-idp';


//# sourceMappingURL=RedirectIdp.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/SelectAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






class SelectAuthenticator extends Remediator {
    findMatchedOption(authenticators, options) {
        let option;
        for (let authenticator of authenticators) {
            option = options
                .find(({ relatesTo }) => relatesTo.key === authenticator.key);
            if (option) {
                break;
            }
        }
        return option;
    }
    canRemediate() {
        const { authenticators, authenticator } = this.values;
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        const { options } = authenticatorFromRemediation;
        if (!authenticators || !authenticators.length) {
            return false;
        }
        if (isAuthenticator(authenticator) && authenticator.id) {
            return true;
        }
        const matchedOption = this.findMatchedOption(authenticators, options);
        if (matchedOption) {
            return true;
        }
        return false;
    }
    getNextStep(authClient) {
        const common = super.getNextStep(authClient);
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        const options = authenticatorFromRemediation.options.map(option => {
            const { label, relatesTo } = option;
            const key = relatesTo.key;
            return { label, value: key };
        });
        return Object.assign(Object.assign({}, common), { options });
    }
    mapAuthenticator(remediationValue) {
        const { authenticators, authenticator } = this.values;
        if (isAuthenticator(authenticator) && authenticator.id) {
            this.selectedAuthenticator = authenticator;
            return authenticator;
        }
        const { options } = remediationValue;
        const selectedOption = findMatchedOption(authenticators, options);
        this.selectedAuthenticator = selectedOption.relatesTo;
        this.selectedOption = selectedOption;
        return {
            id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value.form.value.find(({ name }) => name === 'id').value
        };
    }
    getInputAuthenticator(remediation) {
        const options = remediation.options.map(({ label, relatesTo }) => {
            return {
                label,
                value: relatesTo.key
            };
        });
        return { name: 'authenticator', type: 'string', options };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticators = this.values.authenticators
            .filter(authenticator => {
            return compareAuthenticators(authenticator, this.selectedAuthenticator) !== true;
        });
        return Object.assign(Object.assign({}, this.values), { authenticators });
    }
}


//# sourceMappingURL=SelectAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorAuthenticate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class SelectAuthenticatorAuthenticate extends SelectAuthenticator {
    constructor(remediation, values = {}, options = {}) {
        var _a;
        super(remediation, values, options);
        const isRecoveryFlow = this.options.flow === 'recoverPassword';
        const hasPasswordInOptions = (_a = getAuthenticatorFromRemediation(remediation)
            .options) === null || _a === void 0 ? void 0 : _a.some(({ relatesTo }) => (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.key) === AuthenticatorKey.OKTA_PASSWORD);
        if (hasPasswordInOptions && (isRecoveryFlow || this.values.password)) {
            this.values.authenticators = [
                ...this.values.authenticators || [],
                { key: AuthenticatorKey.OKTA_PASSWORD }
            ];
        }
    }
}
SelectAuthenticatorAuthenticate.remediationName = 'select-authenticator-authenticate';


//# sourceMappingURL=SelectAuthenticatorAuthenticate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorEnroll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectAuthenticatorEnroll extends SelectAuthenticator {
}
SelectAuthenticatorEnroll.remediationName = 'select-authenticator-enroll';


//# sourceMappingURL=SelectAuthenticatorEnroll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorUnlockAccount.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectAuthenticatorUnlockAccount extends SelectAuthenticator {
    constructor() {
        super(...arguments);
        this.map = {
            identifier: ['username']
        };
    }
    canRemediate() {
        const identifier = this.getData('identifier');
        return !!identifier && super.canRemediate();
    }
    mapAuthenticator(remediationValue) {
        var _a, _b, _c;
        const authenticatorMap = super.mapAuthenticator(remediationValue);
        const methodTypeOption = (_a = this.selectedOption) === null || _a === void 0 ? void 0 : _a.value.form.value.find(({ name }) => name === 'methodType');
        const methodTypeValue = this.values.methodType ||
            (methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.value) || ((_c = (_b = methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.options) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value);
        if (methodTypeValue) {
            return Object.assign(Object.assign({}, authenticatorMap), { methodType: methodTypeValue });
        }
        return authenticatorMap;
    }
    getInputUsername() {
        return { name: 'username', type: 'string' };
    }
}
SelectAuthenticatorUnlockAccount.remediationName = 'select-authenticator-unlock-account';


//# sourceMappingURL=SelectAuthenticatorUnlockAccount.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectEnrollProfile.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectEnrollProfile extends Remediator {
    canRemediate() {
        return true;
    }
}
SelectEnrollProfile.remediationName = 'select-enroll-profile';


//# sourceMappingURL=SelectEnrollProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/AuthenticatorData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class AuthenticatorData extends Remediator {
    constructor(remediation, values = {}) {
        super(remediation, values);
        this.authenticator = this.getAuthenticator();
        this.formatAuthenticatorData();
    }
    formatAuthenticatorData() {
        const authenticatorData = this.getAuthenticatorData();
        if (authenticatorData) {
            this.values.authenticatorsData = this.values.authenticatorsData.map(data => {
                if (compareAuthenticators(this.authenticator, data)) {
                    return this.mapAuthenticatorDataFromValues(data);
                }
                return data;
            });
        }
        else {
            const data = this.mapAuthenticatorDataFromValues();
            if (data) {
                this.values.authenticatorsData.push(data);
            }
        }
    }
    getAuthenticatorData() {
        return this.values.authenticatorsData
            .find((data) => compareAuthenticators(this.authenticator, data));
    }
    canRemediate() {
        return this.values.authenticatorsData
            .some(data => compareAuthenticators(this.authenticator, data));
    }
    getNextStep(authClient) {
        const common = super.getNextStep(authClient);
        const options = this.getMethodTypes();
        return Object.assign(Object.assign({}, common), (options && { options }));
    }
    mapAuthenticatorDataFromValues(authenticatorData) {
        let { methodType, authenticator } = this.values;
        if (!methodType && isAuthenticator(authenticator)) {
            methodType = authenticator === null || authenticator === void 0 ? void 0 : authenticator.methodType;
        }
        const { id, enrollmentId } = this.authenticator;
        const data = Object.assign(Object.assign({ id,
            enrollmentId }, (authenticatorData && authenticatorData)), (methodType && { methodType }));
        return data.methodType ? data : null;
    }
    getAuthenticatorFromRemediation() {
        const authenticator = this.remediation.value
            .find(({ name }) => name === 'authenticator');
        return authenticator;
    }
    getMethodTypes() {
        var _a;
        const authenticator = this.getAuthenticatorFromRemediation();
        return (_a = authenticator.form.value.find(({ name }) => name === 'methodType')) === null || _a === void 0 ? void 0 : _a.options;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticatorsData = this.values.authenticatorsData
            .filter(data => compareAuthenticators(this.authenticator, data) !== true);
        return Object.assign(Object.assign({}, this.values), { authenticatorsData });
    }
}


//# sourceMappingURL=AuthenticatorData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/AuthenticatorVerificationData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class AuthenticatorVerificationData extends AuthenticatorData {
    constructor(remediation, values = {}, options = {}) {
        super(remediation, values);
        this.shouldProceedWithEmailAuthenticator = options.shouldProceedWithEmailAuthenticator !== false
            && this.authenticator.methods.length === 1
            && this.authenticator.methods[0].type === 'email';
    }
    canRemediate() {
        if (this.shouldProceedWithEmailAuthenticator !== false) {
            return true;
        }
        return super.canRemediate();
    }
    mapAuthenticator() {
        var _a;
        if (this.shouldProceedWithEmailAuthenticator !== false) {
            const authenticatorFromRemediation = this.getAuthenticatorFromRemediation();
            return (_a = authenticatorFromRemediation.form) === null || _a === void 0 ? void 0 : _a.value.reduce((acc, curr) => {
                if (curr.value) {
                    acc[curr.name] = curr.value;
                }
                else if (curr.options) {
                    acc[curr.name] = curr.options[0].value;
                }
                else {
                    throw new AuthSdkError_AuthSdkError(`Unsupported authenticator data type: ${curr}`);
                }
                return acc;
            }, {});
        }
        return this.getAuthenticatorData();
    }
    getInputAuthenticator() {
        const authenticator = this.getAuthenticatorFromRemediation();
        const methodType = authenticator.form.value.find(({ name }) => name === 'methodType');
        if (methodType && methodType.options) {
            return {
                name: 'methodType',
                type: 'string',
                required: true,
                options: methodType.options
            };
        }
        const inputs = [...authenticator.form.value];
        return inputs;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'authenticator');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
AuthenticatorVerificationData.remediationName = 'authenticator-verification-data';


//# sourceMappingURL=AuthenticatorVerificationData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/AuthenticatorEnrollmentData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class AuthenticatorEnrollmentData extends AuthenticatorData {
    mapAuthenticator() {
        const authenticatorData = this.getAuthenticatorData();
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        return {
            id: authenticatorFromRemediation.form.value
                .find(({ name }) => name === 'id').value,
            methodType: authenticatorData.methodType,
            phoneNumber: authenticatorData.phoneNumber,
        };
    }
    getInputAuthenticator(remediation) {
        return [
            { name: 'methodType', type: 'string' },
            { name: 'phoneNumber', label: 'Phone Number', type: 'string' }
        ].map(item => {
            const value = remediation.form.value.find(val => val.name === item.name);
            return Object.assign(Object.assign({}, value), item);
        });
    }
    mapAuthenticatorDataFromValues(data) {
        data = super.mapAuthenticatorDataFromValues(data);
        const { phoneNumber } = this.values;
        if (!data && !phoneNumber) {
            return;
        }
        return Object.assign(Object.assign({}, (data && data)), (phoneNumber && { phoneNumber }));
    }
}
AuthenticatorEnrollmentData.remediationName = 'authenticator-enrollment-data';


//# sourceMappingURL=AuthenticatorEnrollmentData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Skip.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class Skip extends Remediator {
    canRemediate() {
        return !!this.values.skip || this.options.step === 'skip';
    }
}
Skip.remediationName = 'skip';


//# sourceMappingURL=Skip.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/GenericRemediator/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function unwrapFormValue(remediation) {
    if (Array.isArray(remediation)) {
        return remediation
            .map(item => {
            if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
                return item;
            }
            return unwrapFormValue(item);
        });
    }
    const res = {};
    for (const [key, value] of Object.entries(remediation)) {
        if (value === null || typeof value === 'undefined') {
            continue;
        }
        if (typeof value === 'object') {
            const formKeys = Object.keys(value);
            if (['value', 'form'].includes(key)
                && formKeys.length === 1
                && ['value', 'form'].includes(formKeys[0])) {
                const unwrappedForm = unwrapFormValue(value);
                Object.entries(unwrappedForm).forEach(([key, value]) => {
                    res[key] = value;
                });
            }
            else {
                res[key] = unwrapFormValue(value);
            }
        }
        else {
            res[key] = value;
        }
    }
    return res;
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/GenericRemediator/GenericRemediator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class GenericRemediator extends Remediator {
    canRemediate() {
        if (typeof this.remediation.action !== 'function') {
            return false;
        }
        if (this.remediation.name === 'poll' || this.remediation.name.endsWith('-poll')) {
            return true;
        }
        if (this.options.step) {
            return true;
        }
        return false;
    }
    getData() {
        const data = this.getInputs().reduce((acc, { name }) => {
            acc[name] = this.values[name];
            return acc;
        }, {});
        return data;
    }
    getNextStep(authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const _a = this.remediation, {
        href, method, rel, accepts, produces,
        value,
        action } = _a, rest = __rest(_a, ["href", "method", "rel", "accepts", "produces", "value", "action"]);
        if (action) {
            return Object.assign(Object.assign(Object.assign({}, rest), (!!inputs.length && { inputs })), { action: async (params) => {
                    return authClient.idx.proceed(Object.assign({ step: name }, params));
                } });
        }
        return Object.assign({}, this.remediation);
    }
    getInputs() {
        return (this.remediation.value || [])
            .filter(({ name }) => name !== 'stateHandle')
            .map(unwrapFormValue)
            .map(input => {
            input.type = input.type || 'string';
            return input;
        });
    }
}


//# sourceMappingURL=GenericRemediator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function isTerminalResponse(idxResponse) {
    const { neededToProceed, interactionCode } = idxResponse;
    return !neededToProceed.length && !interactionCode;
}
function canSkipFn(idxResponse) {
    return idxResponse.neededToProceed.some(({ name }) => name === 'skip');
}
function canResendFn(idxResponse) {
    return Object.keys(idxResponse.actions).some(actionName => actionName.includes('resend'));
}
function getMessagesFromIdxRemediationValue(value) {
    if (!value || !Array.isArray(value)) {
        return;
    }
    return value.reduce((messages, value) => {
        if (value.messages) {
            messages = [...messages, ...value.messages.value];
        }
        if (value.form) {
            const messagesFromForm = getMessagesFromIdxRemediationValue(value.form.value) || [];
            messages = [...messages, ...messagesFromForm];
        }
        if (value.options) {
            let optionValues = [];
            value.options.forEach(option => {
                if (!option.value || typeof option.value === 'string') {
                    return;
                }
                optionValues = [...optionValues, option.value];
            });
            const messagesFromOptions = getMessagesFromIdxRemediationValue(optionValues) || [];
            messages = [...messages, ...messagesFromOptions];
        }
        return messages;
    }, []);
}
function getMessagesFromResponse(idxResponse, options) {
    var _a;
    let messages = [];
    const { rawIdxState, neededToProceed } = idxResponse;
    const globalMessages = (_a = rawIdxState.messages) === null || _a === void 0 ? void 0 : _a.value.map(message => message);
    if (globalMessages) {
        messages = [...messages, ...globalMessages];
    }
    if (!options.useGenericRemediator) {
        for (let remediation of neededToProceed) {
            const fieldMessages = getMessagesFromIdxRemediationValue(remediation.value);
            if (fieldMessages) {
                messages = [...messages, ...fieldMessages];
            }
        }
    }
    const seen = {};
    messages = messages.reduce((filtered, message) => {
        var _a;
        const key = (_a = message.i18n) === null || _a === void 0 ? void 0 : _a.key;
        if (key && seen[key]) {
            return filtered;
        }
        seen[key] = message;
        filtered = [...filtered, message];
        return filtered;
    }, []);
    return messages;
}
function getEnabledFeatures(idxResponse) {
    const res = [];
    const { actions, neededToProceed } = idxResponse;
    if (actions['currentAuthenticator-recover']) {
        res.push(IdxFeature.PASSWORD_RECOVERY);
    }
    if (neededToProceed.some(({ name }) => name === 'select-enroll-profile')) {
        res.push(IdxFeature.REGISTRATION);
    }
    if (neededToProceed.some(({ name }) => name === 'redirect-idp')) {
        res.push(IdxFeature.SOCIAL_IDP);
    }
    if (neededToProceed.some(({ name }) => name === 'unlock-account')) {
        res.push(IdxFeature.ACCOUNT_UNLOCK);
    }
    return res;
}
function getAvailableSteps(authClient, idxResponse, useGenericRemediator) {
    var _a;
    const res = [];
    const remediatorMap = Object.values(remediators_namespaceObject)
        .reduce((map, remediatorClass) => {
        if (remediatorClass.remediationName) {
            map[remediatorClass.remediationName] = remediatorClass;
        }
        return map;
    }, {});
    for (let remediation of idxResponse.neededToProceed) {
        const T = getRemediatorClass(remediation, { useGenericRemediator, remediators: remediatorMap });
        if (T) {
            const remediator = new T(remediation);
            res.push(remediator.getNextStep(authClient, idxResponse.context));
        }
    }
    for (const [name] of Object.entries((idxResponse.actions || {}))) {
        let stepObj = {
            name,
            action: async (params) => {
                return authClient.idx.proceed({
                    actions: [{ name, params }]
                });
            }
        };
        if (name.startsWith('currentAuthenticator')) {
            const [part1, part2] = split2(name, '-');
            const actionObj = idxResponse.rawIdxState[part1].value[part2];
            const rest = __rest(actionObj, ["href", "method", "rel", "accepts", "produces"]);
            const value = (_a = actionObj.value) === null || _a === void 0 ? void 0 : _a.filter(item => item.name !== 'stateHandle');
            stepObj = Object.assign(Object.assign(Object.assign({}, rest), (value && { value })), stepObj);
        }
        res.push(stepObj);
    }
    return res;
}
function filterValuesForRemediation(idxResponse, remediationName, values) {
    const remediations = idxResponse.neededToProceed || [];
    const remediation = remediations.find(r => r.name === remediationName);
    if (!remediation) {
        warn(`filterValuesForRemediation: "${remediationName}" did not match any remediations`);
        return values;
    }
    const valuesForRemediation = remediation.value.reduce((res, entry) => {
        const { name, value } = entry;
        if (name === 'stateHandle') {
            res[name] = value;
        }
        else {
            res[name] = values[name];
        }
        return res;
    }, {});
    return valuesForRemediation;
}
function getRemediatorClass(remediation, options) {
    const { useGenericRemediator, remediators } = options;
    if (!remediation) {
        return undefined;
    }
    if (useGenericRemediator) {
        return GenericRemediator;
    }
    return remediators[remediation.name];
}
function getRemediator(idxRemediations, values, options) {
    const remediators = options.remediators;
    const useGenericRemediator = options.useGenericRemediator;
    let remediator;
    if (options.step) {
        const remediation = idxRemediations.find(({ name }) => name === options.step);
        if (remediation) {
            const T = getRemediatorClass(remediation, options);
            return T ? new T(remediation, values, options) : undefined;
        }
        else {
            warn(`step "${options.step}" did not match any remediations`);
            return;
        }
    }
    const remediatorCandidates = [];
    if (useGenericRemediator) {
        remediatorCandidates.push(new GenericRemediator(idxRemediations[0], values, options));
    }
    else {
        for (let remediation of idxRemediations) {
            const isRemeditionInFlow = Object.keys(remediators).includes(remediation.name);
            if (!isRemeditionInFlow) {
                continue;
            }
            const T = getRemediatorClass(remediation, options);
            remediator = new T(remediation, values, options);
            if (remediator.canRemediate()) {
                return remediator;
            }
            remediatorCandidates.push(remediator);
        }
    }
    return remediatorCandidates[0];
}
function getNextStep(authClient, remediator, idxResponse) {
    const nextStep = remediator.getNextStep(authClient, idxResponse.context);
    const canSkip = canSkipFn(idxResponse);
    const canResend = canResendFn(idxResponse);
    return Object.assign(Object.assign(Object.assign({}, nextStep), (canSkip && { canSkip })), (canResend && { canResend }));
}
function handleIdxError(authClient, e, options = {}) {
    let idxResponse = isIdxResponse(e) ? e : null;
    if (!idxResponse) {
        throw e;
    }
    idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: false });
    const terminal = isTerminalResponse(idxResponse);
    const messages = getMessagesFromResponse(idxResponse, options);
    if (terminal) {
        return { idxResponse, terminal, messages };
    }
    else {
        const remediator = getRemediator(idxResponse.neededToProceed, {}, options);
        const nextStep = remediator && getNextStep(authClient, remediator, idxResponse);
        return Object.assign({ idxResponse,
            messages }, (nextStep && { nextStep }));
    }
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getActionFromValues(values, idxResponse) {
    return Object.keys(idxResponse.actions).find(action => !!values.resend && action.includes('-resend'));
}
function removeActionFromValues(values) {
    return Object.assign(Object.assign({}, values), { resend: undefined });
}
function removeActionFromOptions(options, actionName) {
    let actions = options.actions || [];
    actions = actions.filter(entry => {
        if (typeof entry === 'string') {
            return entry !== actionName;
        }
        return entry.name !== actionName;
    });
    return Object.assign(Object.assign({}, options), { actions });
}
async function remediate(authClient, idxResponse, values, options) {
    let { neededToProceed, interactionCode } = idxResponse;
    const { flow } = options;
    if (interactionCode) {
        return { idxResponse };
    }
    const remediator = getRemediator(neededToProceed, values, options);
    const actionFromValues = getActionFromValues(values, idxResponse);
    const actionFromOptions = options.actions || [];
    const actions = [
        ...actionFromOptions,
        ...(actionFromValues && [actionFromValues] || []),
    ];
    if (actions) {
        for (let action of actions) {
            let params = {};
            if (typeof action !== 'string') {
                params = action.params || {};
                action = action.name;
            }
            let valuesWithoutExecutedAction = removeActionFromValues(values);
            let optionsWithoutExecutedAction = removeActionFromOptions(options, action);
            if (typeof idxResponse.actions[action] === 'function') {
                try {
                    idxResponse = await idxResponse.actions[action](params);
                    idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
                }
                catch (e) {
                    return handleIdxError(authClient, e, options);
                }
                if (action === 'cancel') {
                    return { idxResponse, canceled: true };
                }
                return remediate(authClient, idxResponse, valuesWithoutExecutedAction, optionsWithoutExecutedAction);
            }
            const remediationAction = neededToProceed.find(({ name }) => name === action);
            if (remediationAction) {
                try {
                    idxResponse = await idxResponse.proceed(action, params);
                    idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
                }
                catch (e) {
                    return handleIdxError(authClient, e, options);
                }
                return remediate(authClient, idxResponse, values, optionsWithoutExecutedAction);
            }
        }
    }
    const terminal = isTerminalResponse(idxResponse);
    if (terminal) {
        return { idxResponse, terminal };
    }
    if (!remediator) {
        if (options.step) {
            values = filterValuesForRemediation(idxResponse, options.step, values);
            try {
                idxResponse = await idxResponse.proceed(options.step, values);
                idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
                return { idxResponse };
            }
            catch (e) {
                return handleIdxError(authClient, e, options);
            }
        }
        if (flow === 'default') {
            return { idxResponse };
        }
        throw new AuthSdkError_AuthSdkError(`
      No remediation can match current flow, check policy settings in your org.
      Remediations: [${neededToProceed.reduce((acc, curr) => acc ? acc + ' ,' + curr.name : curr.name, '')}]
    `);
    }
    if (!remediator.canRemediate()) {
        const nextStep = getNextStep(authClient, remediator, idxResponse);
        return {
            idxResponse,
            nextStep,
        };
    }
    const name = remediator.getName();
    const data = remediator.getData();
    try {
        idxResponse = await idxResponse.proceed(name, data);
        idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
        values = remediator.getValuesAfterProceed();
        options = Object.assign(Object.assign({}, options), { step: undefined });
        if (options.useGenericRemediator && !idxResponse.interactionCode && !isTerminalResponse(idxResponse)) {
            const gr = getRemediator(idxResponse.neededToProceed, values, options);
            const nextStep = getNextStep(authClient, gr, idxResponse);
            return {
                idxResponse,
                nextStep,
            };
        }
        return remediate(authClient, idxResponse, values, options);
    }
    catch (e) {
        return handleIdxError(authClient, e, options);
    }
}


//# sourceMappingURL=remediate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/AuthenticationFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const AuthenticationFlow = {
    'identify': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'enroll-authenticator': EnrollAuthenticator,
    'challenge-authenticator': ChallengeAuthenticator,
    'challenge-poll': ChallengePoll,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'enroll-poll': EnrollPoll,
    'select-enrollment-channel': SelectEnrollmentChannel,
    'enrollment-channel-data': EnrollmentChannelData,
    'redirect-idp': RedirectIdp,
    'skip': Skip,
};


//# sourceMappingURL=AuthenticationFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/PasswordRecoveryFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const PasswordRecoveryFlow = {
    'identify': Identify,
    'identify-recovery': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'challenge-authenticator': ChallengeAuthenticator,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'reset-authenticator': ResetAuthenticator,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'enroll-poll': EnrollPoll,
};


//# sourceMappingURL=PasswordRecoveryFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/RegistrationFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const RegistrationFlow = {
    'select-enroll-profile': SelectEnrollProfile,
    'enroll-profile': EnrollProfile,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'enroll-poll': EnrollPoll,
    'select-enrollment-channel': SelectEnrollmentChannel,
    'enrollment-channel-data': EnrollmentChannelData,
    'enroll-authenticator': EnrollAuthenticator,
    'skip': Skip,
};


//# sourceMappingURL=RegistrationFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/AccountUnlockFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const AccountUnlockFlow = {
    'identify': Identify,
    'select-authenticator-unlock-account': SelectAuthenticatorUnlockAccount,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'challenge-authenticator': ChallengeAuthenticator,
    'challenge-poll': ChallengePoll,
    'authenticator-verification-data': AuthenticatorVerificationData,
};


//# sourceMappingURL=AccountUnlockFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/FlowSpecification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function getFlowSpecification(oktaAuth, flow = 'default') {
    let remediators, actions, withCredentials = true;
    switch (flow) {
        case 'register':
        case 'signup':
        case 'enrollProfile':
            remediators = RegistrationFlow;
            withCredentials = false;
            break;
        case 'recoverPassword':
        case 'resetPassword':
            remediators = PasswordRecoveryFlow;
            actions = [
                'currentAuthenticator-recover',
                'currentAuthenticatorEnrollment-recover'
            ];
            withCredentials = false;
            break;
        case 'unlockAccount':
            remediators = AccountUnlockFlow;
            withCredentials = false;
            actions = [
                'unlock-account'
            ];
            break;
        case 'authenticate':
        case 'login':
        case 'signin':
            remediators = AuthenticationFlow;
            break;
        default:
            remediators = AuthenticationFlow;
            break;
    }
    return { flow, remediators, actions, withCredentials };
}


//# sourceMappingURL=FlowSpecification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/run.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





























function initializeValues(options) {
    const knownOptions = [
        'flow',
        'remediators',
        'actions',
        'withCredentials',
        'step',
        'useGenericRemediator',
        'exchangeCodeForTokens',
        'shouldProceedWithEmailAuthenticator'
    ];
    const values = Object.assign({}, options);
    knownOptions.forEach(option => {
        delete values[option];
    });
    return values;
}
function initializeData(authClient, data) {
    let { options } = data;
    options = Object.assign(Object.assign({}, authClient.options.idx), options);
    let { flow, withCredentials, remediators, actions, } = options;
    const status = IdxStatus.PENDING;
    flow = flow || authClient.idx.getFlow() || 'default';
    if (flow) {
        authClient.idx.setFlow(flow);
        const flowSpec = getFlowSpecification(authClient, flow);
        withCredentials = (typeof withCredentials !== 'undefined') ? withCredentials : flowSpec.withCredentials;
        remediators = remediators || flowSpec.remediators;
        actions = actions || flowSpec.actions;
    }
    return Object.assign(Object.assign({}, data), { options: Object.assign(Object.assign({}, options), { flow,
            withCredentials,
            remediators,
            actions }), status });
}
async function getDataFromIntrospect(authClient, data) {
    const { options } = data;
    const { stateHandle, withCredentials, version, state, scopes, recoveryToken, activationToken, maxAge, nonce, } = options;
    let idxResponse;
    let meta = getSavedTransactionMeta(authClient, { state, recoveryToken, activationToken });
    if (stateHandle) {
        idxResponse = await introspect(authClient, { withCredentials, version, stateHandle });
    }
    else {
        let interactionHandle = meta === null || meta === void 0 ? void 0 : meta.interactionHandle;
        if (!interactionHandle) {
            authClient.transactionManager.clear();
            const interactResponse = await interact(authClient, {
                withCredentials,
                state,
                scopes,
                activationToken,
                recoveryToken,
                maxAge,
                nonce,
            });
            interactionHandle = interactResponse.interactionHandle;
            meta = interactResponse.meta;
        }
        idxResponse = await introspect(authClient, { withCredentials, version, interactionHandle });
    }
    return Object.assign(Object.assign({}, data), { idxResponse, meta });
}
async function getDataFromRemediate(authClient, data) {
    let { idxResponse, options, values } = data;
    const { autoRemediate, remediators, actions, flow, step, shouldProceedWithEmailAuthenticator,
    useGenericRemediator, } = options;
    const shouldRemediate = (autoRemediate !== false && (remediators || actions || step));
    if (!shouldRemediate) {
        return data;
    }
    values = Object.assign(Object.assign({}, values), { stateHandle: idxResponse.rawIdxState.stateHandle });
    const { idxResponse: idxResponseFromRemediation, nextStep, canceled, } = await remediate(authClient, idxResponse, values, {
        remediators,
        actions,
        flow,
        step,
        shouldProceedWithEmailAuthenticator,
        useGenericRemediator,
    });
    idxResponse = idxResponseFromRemediation;
    return Object.assign(Object.assign({}, data), { idxResponse, nextStep, canceled });
}
async function getTokens(authClient, data) {
    let { meta, idxResponse } = data;
    const { interactionCode } = idxResponse;
    const { clientId, codeVerifier, ignoreSignature, redirectUri, urls, scopes, } = meta;
    const tokenResponse = await authClient.token.exchangeCodeForTokens({
        interactionCode,
        clientId,
        codeVerifier,
        ignoreSignature,
        redirectUri,
        scopes
    }, urls);
    return tokenResponse.tokens;
}
async function finalizeData(authClient, data) {
    let { options, idxResponse, canceled, status, } = data;
    const { exchangeCodeForTokens } = options;
    let shouldSaveResponse = false;
    let shouldClearTransaction = false;
    let clearSharedStorage = true;
    let interactionCode;
    let tokens;
    let enabledFeatures;
    let availableSteps;
    let messages;
    let terminal;
    if (idxResponse) {
        shouldSaveResponse = !!(idxResponse.requestDidSucceed || idxResponse.stepUp);
        enabledFeatures = getEnabledFeatures(idxResponse);
        availableSteps = getAvailableSteps(authClient, idxResponse, options.useGenericRemediator);
        messages = getMessagesFromResponse(idxResponse, options);
        terminal = isTerminalResponse(idxResponse);
    }
    if (terminal) {
        status = IdxStatus.TERMINAL;
        const hasActions = Object.keys(idxResponse.actions).length > 0;
        const hasErrors = !!messages.find(msg => msg.class === 'ERROR');
        const isTerminalSuccess = !hasActions && !hasErrors && idxResponse.requestDidSucceed === true;
        if (isTerminalSuccess) {
            shouldClearTransaction = true;
        }
        else {
            shouldSaveResponse = shouldSaveResponse && hasActions;
        }
        clearSharedStorage = false;
    }
    else if (canceled) {
        status = IdxStatus.CANCELED;
        shouldClearTransaction = true;
    }
    else if (idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.interactionCode) {
        interactionCode = idxResponse.interactionCode;
        if (exchangeCodeForTokens === false) {
            status = IdxStatus.SUCCESS;
            shouldClearTransaction = false;
        }
        else {
            tokens = await getTokens(authClient, data);
            status = IdxStatus.SUCCESS;
            shouldClearTransaction = true;
        }
    }
    return Object.assign(Object.assign({}, data), { status,
        interactionCode,
        tokens,
        shouldSaveResponse,
        shouldClearTransaction,
        clearSharedStorage,
        enabledFeatures,
        availableSteps,
        messages,
        terminal });
}
function handleError(err, data) {
    let { error, status, shouldClearTransaction } = data;
    if (isIdxResponse(err)) {
        error = err;
        status = IdxStatus.FAILURE;
        shouldClearTransaction = true;
    }
    else {
        throw err;
    }
    return Object.assign(Object.assign({}, data), { error, status, shouldClearTransaction });
}
async function run(authClient, options = {}) {
    var _a;
    let data = {
        options,
        values: initializeValues(options)
    };
    data = initializeData(authClient, data);
    try {
        data = await getDataFromIntrospect(authClient, data);
        data = await getDataFromRemediate(authClient, data);
    }
    catch (err) {
        data = handleError(err, data);
    }
    data = await finalizeData(authClient, data);
    const { idxResponse, meta, shouldSaveResponse, shouldClearTransaction, clearSharedStorage, status, enabledFeatures, availableSteps, tokens, nextStep, messages, error, interactionCode } = data;
    if (shouldClearTransaction) {
        authClient.transactionManager.clear({ clearSharedStorage });
    }
    else {
        saveTransactionMeta(authClient, Object.assign({}, meta));
        if (shouldSaveResponse) {
            const { rawIdxState: rawIdxResponse, requestDidSucceed } = idxResponse;
            authClient.transactionManager.saveIdxResponse({
                rawIdxResponse,
                requestDidSucceed,
                stateHandle: (_a = idxResponse.context) === null || _a === void 0 ? void 0 : _a.stateHandle,
                interactionHandle: meta === null || meta === void 0 ? void 0 : meta.interactionHandle
            });
        }
    }
    const { actions, context, neededToProceed, proceed, rawIdxState, requestDidSucceed, stepUp } = idxResponse || {};
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ status: status }, (meta && { meta })), (enabledFeatures && { enabledFeatures })), (availableSteps && { availableSteps })), (tokens && { tokens })), (nextStep && { nextStep })), (messages && messages.length && { messages })), (error && { error })), (stepUp && { stepUp })), { interactionCode,
        actions: actions, context: context, neededToProceed: neededToProceed, proceed: proceed, rawIdxState: rawIdxState, requestDidSucceed });
}


//# sourceMappingURL=run.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





async function authenticate(authClient, options = {}) {
    if (options.password && !options.authenticator) {
        options.authenticator = AuthenticatorKey.OKTA_PASSWORD;
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow: 'authenticate' }));
}


//# sourceMappingURL=authenticate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/cancel.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */























async function cancel(authClient, options) {
    const meta = authClient.transactionManager.load();
    const flowSpec = getFlowSpecification(authClient, meta.flow);
    return run(authClient, Object.assign(Object.assign(Object.assign({}, options), flowSpec), { actions: ['cancel'] }));
}


//# sourceMappingURL=cancel.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/emailVerify.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailVerifyCallbackError extends CustomError {
    constructor(state, otp) {
        super(`Enter the OTP code in the originating client: ${otp}`);
        this.name = 'EmailVerifyCallbackError';
        this.state = state;
        this.otp = otp;
    }
}
function isEmailVerifyCallbackError(error) {
    return (error.name === 'EmailVerifyCallbackError');
}
function isEmailVerifyCallback(urlPath) {
    return /(otp=)/i.test(urlPath) && /(state=)/i.test(urlPath);
}
function parseEmailVerifyCallback(urlPath) {
    return urlParamsToObject(urlPath);
}
async function handleEmailVerifyCallback(authClient, search) {
    if (isEmailVerifyCallback(search)) {
        const { state, otp } = parseEmailVerifyCallback(search);
        if (authClient.idx.canProceed({ state })) {
            return await authClient.idx.proceed({ state, otp });
        }
        else {
            throw new EmailVerifyCallbackError(state, otp);
        }
    }
}


//# sourceMappingURL=emailVerify.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/proceed.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function canProceed(authClient, options = {}) {
    const meta = getSavedTransactionMeta(authClient, options);
    return !!(meta || options.stateHandle);
}
async function proceed(authClient, options = {}) {
    if (!canProceed(authClient, options)) {
        throw new AuthSdkError_AuthSdkError('Unable to proceed: saved transaction could not be loaded');
    }
    let { flow, state } = options;
    if (!flow) {
        const meta = getSavedTransactionMeta(authClient, { state });
        flow = meta === null || meta === void 0 ? void 0 : meta.flow;
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow }));
}


//# sourceMappingURL=proceed.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/poll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





async function poll(authClient, options = {}) {
    var _a;
    let transaction = await proceed(authClient, {
        startPolling: true
    });
    const meta = getSavedTransactionMeta(authClient);
    let availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find(remediation => remediation.includes('poll'));
    if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) {
        warn('No polling remediations available at the current IDX flow stage');
    }
    if (Number.isInteger(options.refresh)) {
        return new Promise(function (resolve, reject) {
            setTimeout(async function () {
                var _a, _b;
                try {
                    const refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                    if (refresh) {
                        resolve(poll(authClient, {
                            refresh
                        }));
                    }
                    else {
                        resolve(transaction);
                    }
                }
                catch (err) {
                    reject(err);
                }
            }, options.refresh);
        });
    }
    return transaction;
}


//# sourceMappingURL=poll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/startTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



async function startTransaction(authClient, options = {}) {
    authClient.transactionManager.clear();
    return run(authClient, Object.assign({ exchangeCodeForTokens: false }, options));
}


//# sourceMappingURL=startTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/register.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function register(authClient, options = {}) {
    if (!hasSavedInteractionHandle(authClient)) {
        const { enabledFeatures, availableSteps } = await startTransaction(authClient, Object.assign(Object.assign({}, options), { flow: 'register', autoRemediate: false }));
        if (!options.activationToken && enabledFeatures && !enabledFeatures.includes(IdxFeature.REGISTRATION)) {
            const error = new AuthSdkError_AuthSdkError('Registration is not supported based on your current org configuration.');
            throw error;
        }
        if (options.activationToken && (availableSteps === null || availableSteps === void 0 ? void 0 : availableSteps.some(({ name }) => name === 'identify'))) {
            const error = new AuthSdkError_AuthSdkError('activationToken is not supported based on your current org configuration.');
            throw error;
        }
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow: 'register' }));
}


//# sourceMappingURL=register.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/recoverPassword.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */























async function recoverPassword(authClient, options = {}) {
    const flowSpec = getFlowSpecification(authClient, 'recoverPassword');
    return run(authClient, Object.assign(Object.assign({}, options), flowSpec));
}


//# sourceMappingURL=recoverPassword.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/handleInteractionCodeRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




async function handleInteractionCodeRedirect(authClient, url) {
    const meta = authClient.transactionManager.load();
    if (!meta) {
        throw new AuthSdkError_AuthSdkError('No transaction data was found in storage');
    }
    const { codeVerifier, state: savedState } = meta;
    const { searchParams
     } = new URL(url);
    const state = searchParams.get('state');
    const interactionCode = searchParams.get('interaction_code');
    const error = searchParams.get('error');
    if (error) {
        throw new OAuthError(error, searchParams.get('error_description'));
    }
    if (state !== savedState) {
        throw new AuthSdkError_AuthSdkError('State in redirect uri does not match with transaction state');
    }
    if (!interactionCode) {
        throw new AuthSdkError_AuthSdkError('Unable to parse interaction_code from the url');
    }
    const { tokens } = await authClient.token.exchangeCodeForTokens({ interactionCode, codeVerifier });
    authClient.tokenManager.setTokens(tokens);
}


//# sourceMappingURL=handleInteractionCodeRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/unlockAccount.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function unlockAccount(authClient, options = {}) {
    options.flow = 'unlockAccount';
    if (!hasSavedInteractionHandle(authClient)) {
        const { enabledFeatures } = await startTransaction(authClient, Object.assign(Object.assign({}, options), { autoRemediate: false }));
        if (enabledFeatures && !enabledFeatures.includes(IdxFeature.ACCOUNT_UNLOCK)) {
            throw new AuthSdkError_AuthSdkError('Self Service Account Unlock is not supported based on your current org configuration.');
        }
    }
    return run(authClient, Object.assign({}, options));
}


//# sourceMappingURL=unlockAccount.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/OktaUserAgent.js
/* provided dependency */ var process = __webpack_require__(34155);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaUserAgent {
    constructor() {
        this.environments = [`okta-auth-js/${"6.9.0"}`];
    }
    addEnvironment(env) {
        this.environments.push(env);
    }
    getHttpHeader() {
        this.maybeAddNodeEnvironment();
        return { 'X-Okta-User-Agent-Extended': this.environments.join(' ') };
    }
    getVersion() {
        return "6.9.0";
    }
    maybeAddNodeEnvironment() {
        if (isBrowser() || !process || !process.versions) {
            return;
        }
        const { node: version } = process.versions;
        this.environments.push(`nodejs/${version}`);
    }
}


//# sourceMappingURL=OktaUserAgent.js.map

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(74279);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/OktaAuth.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




























































class OktaAuth {
    constructor(args) {
        this.features = features_namespaceObject;
        const options = this.options = buildOptions(args);
        this.storageManager = new StorageManager(options.storageManager, options.cookies, options.storageUtil);
        this.transactionManager = new TransactionManager(Object.assign({
            storageManager: this.storageManager,
        }, options.transactionManager));
        this._oktaUserAgent = new OktaUserAgent();
        this.tx = {
            status: transactionStatus.bind(null, this),
            resume: resumeTransaction.bind(null, this),
            exists: Object.assign(transactionExists.bind(null, this), {
                _get: (name) => {
                    const storage = options.storageUtil.storage;
                    return storage.get(name);
                }
            }),
            introspect: introspectAuthn.bind(null, this),
            createTransaction: (res) => {
                return new AuthTransaction(this, res);
            },
            postToTransaction: (url, args, options) => {
                return postToTransaction(this, url, args, options);
            }
        };
        this.pkce = {
            DEFAULT_CODE_CHALLENGE_METHOD: PKCE.DEFAULT_CODE_CHALLENGE_METHOD,
            generateVerifier: PKCE.generateVerifier,
            computeChallenge: PKCE.computeChallenge
        };
        Object.assign(this.options.storageUtil || {}, {
            getPKCEStorage: this.storageManager.getLegacyPKCEStorage.bind(this.storageManager),
            getHttpCache: this.storageManager.getHttpCache.bind(this.storageManager),
        });
        this._pending = { handleLogin: false };
        if (isBrowser()) {
            this.options = Object.assign(this.options, {
                redirectUri: toAbsoluteUrl(args.redirectUri, window.location.origin),
            });
        }
        if (!args.maxClockSkew && args.maxClockSkew !== 0) {
            this.options.maxClockSkew = DEFAULT_MAX_CLOCK_SKEW;
        }
        else {
            this.options.maxClockSkew = args.maxClockSkew;
        }
        this.options.ignoreLifetime = !!args.ignoreLifetime;
        this.session = {
            close: closeSession.bind(null, this),
            exists: sessionExists.bind(null, this),
            get: getSession.bind(null, this),
            refresh: refreshSession.bind(null, this),
            setCookieAndRedirect: setCookieAndRedirect.bind(null, this)
        };
        this._tokenQueue = new PromiseQueue();
        const useQueue = (method) => {
            return PromiseQueue.prototype.push.bind(this._tokenQueue, method, null);
        };
        const getWithRedirectFn = useQueue(getWithRedirect.bind(null, this));
        const getWithRedirectApi = Object.assign(getWithRedirectFn, {
            _setLocation: function (url) {
                if (options.setLocation) {
                    options.setLocation(url);
                }
                else {
                    window.location = url;
                }
            }
        });
        const parseFromUrlFn = useQueue(parseFromUrl.bind(null, this));
        const parseFromUrlApi = Object.assign(parseFromUrlFn, {
            _getHistory: function () {
                return window.history;
            },
            _getLocation: function () {
                return window.location;
            },
            _getDocument: function () {
                return window.document;
            }
        });
        this.token = {
            prepareTokenParams: prepareTokenParams.bind(null, this),
            exchangeCodeForTokens: exchangeCodeForTokens.bind(null, this),
            getWithoutPrompt: getWithoutPrompt.bind(null, this),
            getWithPopup: getWithPopup.bind(null, this),
            getWithRedirect: getWithRedirectApi,
            parseFromUrl: parseFromUrlApi,
            decode: decodeToken,
            revoke: revokeToken.bind(null, this),
            renew: renewToken.bind(null, this),
            renewTokensWithRefresh: renewTokensWithRefresh.bind(null, this),
            renewTokens: renewTokens.bind(null, this),
            getUserInfo: (accessTokenObject, idTokenObject) => {
                return getUserInfo(this, accessTokenObject, idTokenObject);
            },
            verify: verifyToken_verifyToken.bind(null, this),
            isLoginRedirect: isLoginRedirect.bind(null, this)
        };
        const toWrap = [
            'getWithoutPrompt',
            'getWithPopup',
            'revoke',
            'renew',
            'renewTokensWithRefresh',
            'renewTokens'
        ];
        toWrap.forEach(key => {
            this.token[key] = useQueue(this.token[key]);
        });
        const boundStartTransaction = startTransaction.bind(null, this);
        this.idx = {
            interact: interact.bind(null, this),
            introspect: introspect.bind(null, this),
            makeIdxResponse: idxState_makeIdxState.bind(null, this),
            authenticate: authenticate.bind(null, this),
            register: register.bind(null, this),
            start: boundStartTransaction,
            startTransaction: boundStartTransaction,
            poll: poll.bind(null, this),
            proceed: proceed.bind(null, this),
            cancel: cancel.bind(null, this),
            recoverPassword: recoverPassword.bind(null, this),
            handleInteractionCodeRedirect: handleInteractionCodeRedirect.bind(null, this),
            isInteractionRequired: isInteractionRequired.bind(null, this),
            isInteractionRequiredError: isInteractionRequiredError,
            handleEmailVerifyCallback: handleEmailVerifyCallback.bind(null, this),
            isEmailVerifyCallback: isEmailVerifyCallback,
            parseEmailVerifyCallback: parseEmailVerifyCallback,
            isEmailVerifyCallbackError: isEmailVerifyCallbackError,
            getSavedTransactionMeta: getSavedTransactionMeta.bind(null, this),
            createTransactionMeta: createTransactionMeta.bind(null, this),
            getTransactionMeta: getTransactionMeta.bind(null, this),
            saveTransactionMeta: saveTransactionMeta.bind(null, this),
            clearTransactionMeta: clearTransactionMeta.bind(null, this),
            isTransactionMetaValid: isTransactionMetaValid,
            setFlow: (flow) => {
                this.options.flow = flow;
            },
            getFlow: () => {
                return this.options.flow;
            },
            canProceed: canProceed.bind(null, this),
            unlockAccount: unlockAccount.bind(null, this),
        };
        this.http = {
            setRequestHeader: setRequestHeader.bind(null, this)
        };
        this.fingerprint = fingerprint.bind(null, this);
        this.emitter = new tiny_emitter();
        this.tokenManager = new TokenManager(this, args.tokenManager);
        this.authStateManager = new AuthStateManager(this);
        this.serviceManager = new ServiceManager(this, args.services);
    }
    async start() {
        await this.serviceManager.start();
        this.tokenManager.start();
        if (!this.token.isLoginRedirect()) {
            await this.authStateManager.updateAuthState();
        }
    }
    async stop() {
        this.tokenManager.stop();
        await this.serviceManager.stop();
    }
    setHeaders(headers) {
        this.options.headers = Object.assign({}, this.options.headers, headers);
    }
    async signIn(opts) {
        return this.signInWithCredentials(opts);
    }
    async signInWithCredentials(opts) {
        opts = clone(opts || {});
        const _postToTransaction = (options) => {
            delete opts.sendFingerprint;
            return postToTransaction(this, '/api/v1/authn', opts, options);
        };
        if (!opts.sendFingerprint) {
            return _postToTransaction();
        }
        return this.fingerprint()
            .then(function (fingerprint) {
            return _postToTransaction({
                headers: {
                    'X-Device-Fingerprint': fingerprint
                }
            });
        });
    }
    async signInWithRedirect(opts = {}) {
        const { originalUri } = opts, additionalParams = __rest(opts, ["originalUri"]);
        if (this._pending.handleLogin) {
            return;
        }
        this._pending.handleLogin = true;
        try {
            if (originalUri) {
                this.setOriginalUri(originalUri);
            }
            const params = Object.assign({
                scopes: this.options.scopes || ['openid', 'email', 'profile']
            }, additionalParams);
            await this.token.getWithRedirect(params);
        }
        finally {
            this._pending.handleLogin = false;
        }
    }
    closeSession() {
        return this.session.close()
            .then(async () => {
            this.tokenManager.clear();
        })
            .catch(function (e) {
            if (e.name === 'AuthApiError' && e.errorCode === 'E0000007') {
                return null;
            }
            throw e;
        });
    }
    async revokeAccessToken(accessToken) {
        if (!accessToken) {
            accessToken = (await this.tokenManager.getTokens()).accessToken;
            const accessTokenKey = this.tokenManager.getStorageKeyByType('accessToken');
            this.tokenManager.remove(accessTokenKey);
        }
        if (!accessToken) {
            return Promise.resolve(null);
        }
        return this.token.revoke(accessToken);
    }
    async revokeRefreshToken(refreshToken) {
        if (!refreshToken) {
            refreshToken = (await this.tokenManager.getTokens()).refreshToken;
            const refreshTokenKey = this.tokenManager.getStorageKeyByType('refreshToken');
            this.tokenManager.remove(refreshTokenKey);
        }
        if (!refreshToken) {
            return Promise.resolve(null);
        }
        return this.token.revoke(refreshToken);
    }
    getSignOutRedirectUrl(options = {}) {
        let { idToken, postLogoutRedirectUri, state, } = options;
        if (!idToken) {
            idToken = this.tokenManager.getTokensSync().idToken;
        }
        if (!idToken) {
            return '';
        }
        if (!postLogoutRedirectUri) {
            postLogoutRedirectUri = this.options.postLogoutRedirectUri;
        }
        const logoutUrl = getOAuthUrls(this).logoutUrl;
        const idTokenHint = idToken.idToken;
        let logoutUri = logoutUrl + '?id_token_hint=' + encodeURIComponent(idTokenHint);
        if (postLogoutRedirectUri) {
            logoutUri += '&post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri);
        }
        if (state) {
            logoutUri += '&state=' + encodeURIComponent(state);
        }
        return logoutUri;
    }
    async signOut(options) {
        options = Object.assign({}, options);
        var defaultUri = window.location.origin;
        var currentUri = window.location.href;
        var postLogoutRedirectUri = options.postLogoutRedirectUri
            || this.options.postLogoutRedirectUri
            || defaultUri;
        var accessToken = options.accessToken;
        var refreshToken = options.refreshToken;
        var revokeAccessToken = options.revokeAccessToken !== false;
        var revokeRefreshToken = options.revokeRefreshToken !== false;
        if (revokeRefreshToken && typeof refreshToken === 'undefined') {
            refreshToken = this.tokenManager.getTokensSync().refreshToken;
        }
        if (revokeAccessToken && typeof accessToken === 'undefined') {
            accessToken = this.tokenManager.getTokensSync().accessToken;
        }
        if (!options.idToken) {
            options.idToken = this.tokenManager.getTokensSync().idToken;
        }
        if (revokeRefreshToken && refreshToken) {
            await this.revokeRefreshToken(refreshToken);
        }
        if (revokeAccessToken && accessToken) {
            await this.revokeAccessToken(accessToken);
        }
        const logoutUri = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, options), { postLogoutRedirectUri }));
        if (!logoutUri) {
            return this.closeSession()
                .then(function () {
                if (postLogoutRedirectUri === currentUri) {
                    window.location.reload();
                }
                else {
                    window.location.assign(postLogoutRedirectUri);
                }
            });
        }
        else {
            if (options.clearTokensBeforeRedirect) {
                this.tokenManager.clear();
            }
            else {
                this.tokenManager.addPendingRemoveFlags();
            }
            window.location.assign(logoutUri);
        }
    }
    webfinger(opts) {
        var url = '/.well-known/webfinger' + toQueryString(opts);
        var options = {
            headers: {
                'Accept': 'application/jrd+json'
            }
        };
        return get(this, url, options);
    }
    async isAuthenticated(options = {}) {
        const { autoRenew, autoRemove } = this.tokenManager.getOptions();
        const shouldRenew = options.onExpiredToken ? options.onExpiredToken === 'renew' : autoRenew;
        const shouldRemove = options.onExpiredToken ? options.onExpiredToken === 'remove' : autoRemove;
        let { accessToken } = this.tokenManager.getTokensSync();
        if (accessToken && this.tokenManager.hasExpired(accessToken)) {
            accessToken = undefined;
            if (shouldRenew) {
                try {
                    accessToken = await this.tokenManager.renew('accessToken');
                }
                catch (_a) {
                }
            }
            else if (shouldRemove) {
                this.tokenManager.remove('accessToken');
            }
        }
        let { idToken } = this.tokenManager.getTokensSync();
        if (idToken && this.tokenManager.hasExpired(idToken)) {
            idToken = undefined;
            if (shouldRenew) {
                try {
                    idToken = await this.tokenManager.renew('idToken');
                }
                catch (_b) {
                }
            }
            else if (shouldRemove) {
                this.tokenManager.remove('idToken');
            }
        }
        return !!(accessToken && idToken);
    }
    async getUser() {
        const { idToken, accessToken } = this.tokenManager.getTokensSync();
        return this.token.getUserInfo(accessToken, idToken);
    }
    getIdToken() {
        const { idToken } = this.tokenManager.getTokensSync();
        return idToken ? idToken.idToken : undefined;
    }
    getAccessToken() {
        const { accessToken } = this.tokenManager.getTokensSync();
        return accessToken ? accessToken.accessToken : undefined;
    }
    getRefreshToken() {
        const { refreshToken } = this.tokenManager.getTokensSync();
        return refreshToken ? refreshToken.refreshToken : undefined;
    }
    async storeTokensFromRedirect() {
        const { tokens } = await this.token.parseFromUrl();
        this.tokenManager.setTokens(tokens);
    }
    setOriginalUri(originalUri, state) {
        const sessionStorage = storageUtil.getSessionStorage();
        sessionStorage.setItem(REFERRER_PATH_STORAGE_KEY, originalUri);
        state = state || this.options.state;
        if (state) {
            const sharedStorage = this.storageManager.getOriginalUriStorage();
            sharedStorage.setItem(state, originalUri);
        }
    }
    getOriginalUri(state) {
        state = state || this.options.state;
        if (state) {
            const sharedStorage = this.storageManager.getOriginalUriStorage();
            const originalUri = sharedStorage.getItem(state);
            if (originalUri) {
                return originalUri;
            }
        }
        const storage = storageUtil.getSessionStorage();
        return storage ? storage.getItem(REFERRER_PATH_STORAGE_KEY) || undefined : undefined;
    }
    removeOriginalUri(state) {
        const storage = storageUtil.getSessionStorage();
        storage.removeItem(REFERRER_PATH_STORAGE_KEY);
        state = state || this.options.state;
        if (state) {
            const sharedStorage = this.storageManager.getOriginalUriStorage();
            sharedStorage.removeItem && sharedStorage.removeItem(state);
        }
    }
    isLoginRedirect() {
        return isLoginRedirect(this);
    }
    async handleLoginRedirect(tokens, originalUri) {
        let state = this.options.state;
        if (tokens) {
            this.tokenManager.setTokens(tokens);
            originalUri = originalUri || this.getOriginalUri(this.options.state);
        }
        else if (this.isLoginRedirect()) {
            try {
                const oAuthResponse = await parseOAuthResponseFromUrl(this, {});
                state = oAuthResponse.state;
                originalUri = originalUri || this.getOriginalUri(state);
                await this.storeTokensFromRedirect();
            }
            catch (e) {
                await this.authStateManager.updateAuthState();
                throw e;
            }
        }
        else {
            return;
        }
        await this.authStateManager.updateAuthState();
        this.removeOriginalUri(state);
        const { restoreOriginalUri } = this.options;
        if (restoreOriginalUri) {
            await restoreOriginalUri(this, originalUri);
        }
        else if (originalUri) {
            window.location.replace(originalUri);
        }
    }
    isPKCE() {
        return !!this.options.pkce;
    }
    hasResponseType(responseType) {
        let hasResponseType = false;
        if (Array.isArray(this.options.responseType) && this.options.responseType.length) {
            hasResponseType = this.options.responseType.indexOf(responseType) >= 0;
        }
        else {
            hasResponseType = this.options.responseType === responseType;
        }
        return hasResponseType;
    }
    isAuthorizationCodeFlow() {
        return this.hasResponseType('code');
    }
    getIssuerOrigin() {
        return this.options.issuer.split('/oauth2/')[0];
    }
    forgotPassword(opts) {
        return postToTransaction(this, '/api/v1/authn/recovery/password', opts);
    }
    unlockAccount(opts) {
        return postToTransaction(this, '/api/v1/authn/recovery/unlock', opts);
    }
    verifyRecoveryToken(opts) {
        return postToTransaction(this, '/api/v1/authn/recovery/token', opts);
    }
    async invokeApiMethod(options) {
        if (!options.accessToken) {
            const accessToken = (await this.tokenManager.getTokens()).accessToken;
            options.accessToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken;
        }
        return request_httpRequest(this, options);
    }
}
OktaAuth.features = features_namespaceObject;
OktaAuth.crypto = crypto_namespaceObject;
OktaAuth.webauthn = webauthn_namespaceObject;
OktaAuth.features = OktaAuth.prototype.features = features_namespaceObject;
Object.assign(OktaAuth, {
    constants: constants_namespaceObject
});


//# sourceMappingURL=OktaAuth.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailTransaction_EmailTransaction extends (/* unused pure expression or super */ null && (BaseTransaction)) {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { accessToken, res } = options;
        const { id, profile, roles, status, _links } = res;
        this.id = id;
        this.profile = profile;
        this.roles = roles;
        this.status = status;
        this.get = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'get',
                links: _links,
                transactionClassName: 'EmailTransaction'
            });
            return await fn();
        };
        this.delete = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'challenge',
                links: _links,
                transactionClassName: 'EmailChallengeTransaction'
            });
            return await fn();
        };
        if (_links.poll) {
            this.poll = async () => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'poll',
                    links: _links,
                    transactionClassName: 'EmailStatusTransaction'
                });
                return await fn();
            };
        }
        if (_links.verify) {
            this.verify = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'verify',
                    links: _links,
                });
                return await fn(payload);
            };
        }
    }
}


//# sourceMappingURL=EmailTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailChallengeTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailChallengeTransaction_EmailChallengeTransaction extends (/* unused pure expression or super */ null && (BaseTransaction)) {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { accessToken, res } = options;
        const { id, expiresAt, profile, status, _links } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
        this.poll = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'poll',
                links: _links,
                transactionClassName: 'EmailStatusTransaction'
            });
            return await fn();
        };
        this.verify = async (payload) => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'verify',
                links: _links,
            });
            return await fn(payload);
        };
    }
}


//# sourceMappingURL=EmailChallengeTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/PhoneTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class PhoneTransaction_PhoneTransaction extends (/* unused pure expression or super */ null && (BaseTransaction)) {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { res, accessToken } = options;
        const { id, profile, status, _links } = res;
        this.id = id;
        this.profile = profile;
        this.status = status;
        this.get = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'get',
                links: _links,
                transactionClassName: 'PhoneTransaction'
            });
            return await fn();
        };
        this.delete = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async (payload) => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'challenge',
                links: _links
            });
            return await fn(payload);
        };
        if (_links.verify) {
            this.verify = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'verify',
                    links: _links
                });
                return await fn(payload);
            };
        }
    }
}


//# sourceMappingURL=PhoneTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/request.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












const parseInsufficientAuthenticationError = (header) => {
    if (!header) {
        throw new AuthSdkError('Missing header string');
    }
    return header
        .split(',')
        .map(part => part.trim())
        .map(part => part.split('='))
        .reduce((acc, curr) => {
        acc[curr[0]] = curr[1].replace(/^"(.*)"$/, '$1');
        return acc;
    }, {});
};
async function request_sendRequest(oktaAuth, options) {
    var _a, _b;
    const { accessToken: accessTokenObj, idToken: idTokenObj } = oktaAuth.tokenManager.getTokensSync();
    const idToken = idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.idToken;
    const accessToken = options.accessToken || (accessTokenObj === null || accessTokenObj === void 0 ? void 0 : accessTokenObj.accessToken);
    const { issuer } = oktaAuth.options;
    const { url, method, payload } = options;
    const requestUrl = url.startsWith(issuer) ? url : `${issuer}${url}`;
    if (!accessToken) {
        throw new AuthSdkError('AccessToken is required to request MyAccount API endpoints.');
    }
    let res;
    try {
        res = await httpRequest(oktaAuth, Object.assign({ headers: { 'Accept': '*/*;okta-version=1.0.0' }, accessToken, url: requestUrl, method }, (payload && { args: payload })));
    }
    catch (err) {
        const errorResp = err.xhr;
        if (idToken && (errorResp === null || errorResp === void 0 ? void 0 : errorResp.status) === 403 && !!((_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.headers) === null || _a === void 0 ? void 0 : _a['www-authenticate'])) {
            const { error,
            error_description,
            max_age } = parseInsufficientAuthenticationError((_b = errorResp === null || errorResp === void 0 ? void 0 : errorResp.headers) === null || _b === void 0 ? void 0 : _b['www-authenticate']);
            if (error === 'insufficient_authentication_context') {
                const insufficientAuthenticationError = new AuthApiError({
                    errorSummary: error,
                    errorCauses: [{ errorSummary: error_description }]
                }, errorResp,
                { max_age: +max_age });
                throw insufficientAuthenticationError;
            }
            else {
                throw err;
            }
        }
        else {
            throw err;
        }
    }
    const map = {
        EmailTransaction,
        EmailStatusTransaction,
        EmailChallengeTransaction,
        ProfileTransaction,
        ProfileSchemaTransaction,
        PhoneTransaction
    };
    const TransactionClass = map[options.transactionClassName] || BaseTransaction;
    if (Array.isArray(res)) {
        return res.map(item => new TransactionClass(oktaAuth, {
            res: item,
            accessToken
        }));
    }
    return new TransactionClass(oktaAuth, {
        res,
        accessToken
    });
}
function request_generateRequestFnFromLinks({ oktaAuth, accessToken, methodName, links, transactionClassName }) {
    for (const method of ['GET', 'POST', 'PUT', 'DELETE']) {
        if (method.toLowerCase() === methodName) {
            const link = links.self;
            return (async (payload) => request_sendRequest(oktaAuth, {
                accessToken,
                url: link.href,
                method,
                payload,
                transactionClassName
            }));
        }
    }
    const link = links[methodName];
    if (!link) {
        throw new AuthSdkError(`No link is found with methodName: ${methodName}`);
    }
    return (async (payload) => request_sendRequest(oktaAuth, {
        accessToken,
        url: link.href,
        method: link.hints.allow[0],
        payload,
        transactionClassName
    }));
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/profileApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getProfile = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'ProfileTransaction'
    });
    return transaction;
};
const updateProfile = async (oktaAuth, options) => {
    const { payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'PUT',
        payload,
        accessToken,
        transactionClassName: 'ProfileTransaction'
    });
    return transaction;
};
const getProfileSchema = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile/schema',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'ProfileSchemaTransaction'
    });
    return transaction;
};


//# sourceMappingURL=profileApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/emailApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getEmails = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'EmailTransaction'
    });
    return transaction;
};
const getEmail = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'GET',
        accessToken,
        transactionClassName: 'EmailTransaction'
    });
    return transaction;
};
const addEmail = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'POST',
        payload,
        accessToken,
        transactionClassName: 'EmailTransaction'
    });
    return transaction;
};
const deleteEmail = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'DELETE',
        accessToken
    });
    return transaction;
};
const sendEmailChallenge = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}/challenge`,
        method: 'POST',
        accessToken,
        transactionClassName: 'EmailChallengeTransaction'
    });
    return transaction;
};
const getEmailChallenge = async (oktaAuth, options) => {
    const { emailId, challengeId, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}`,
        method: 'POST',
        accessToken,
        transactionClassName: 'EmailChallengeTransaction'
    });
    return transaction;
};
const verifyEmailChallenge = async (oktaAuth, options) => {
    const { emailId, challengeId, payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}/verify`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};


//# sourceMappingURL=emailApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/phoneApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getPhones = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'PhoneTransaction'
    });
    return transaction;
};
const getPhone = async (oktaAuth, options) => {
    const { accessToken, id } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'GET',
        accessToken,
        transactionClassName: 'PhoneTransaction'
    });
    return transaction;
};
const addPhone = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'POST',
        payload,
        accessToken,
        transactionClassName: 'PhoneTransaction'
    });
    return transaction;
};
const deletePhone = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'DELETE',
        accessToken,
    });
    return transaction;
};
const sendPhoneChallenge = async (oktaAuth, options) => {
    const { accessToken, id, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/challenge`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};
const verifyPhoneChallenge = async (oktaAuth, options) => {
    const { id, payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/verify`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};


//# sourceMappingURL=phoneApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */
















































































//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./services/auth.service.js





let authClient;
const initAuth = async (config)=>{
    const { apiEndPointData: { map: { oktaScopes  }  } = {} , general: { homepageUrl ="" , registerNonKohlerProductPath ="" , isPublish  } = {} , commerce: { sessionAuth: { securePagePathList =[]  } = {}  } = {} , apiEndpoints: { oktaClientId ="" , oktaIssuerUrl ="" , oktaLogoutUri =""  } = {}  } = config || {};
    authClient = new OktaAuth({
        issuer: oktaIssuerUrl,
        clientId: oktaClientId,
        redirectUri: "https://www.kohler.com",
        postLogoutRedirectUri: oktaLogoutUri,
        scopes: oktaScopes ? oktaScopes.split(",") : [
            "kcom-session",
            "openid",
            "offline_access"
        ],
        tokenManager: {
            autoRenew: true,
            expireEarlySeconds: 120
        }
    });
    authClient.start();
    let prevAuthState = null;
    authClient.authStateManager.subscribe((authState)=>{
        if (authState.isAuthenticated) {
            const payload = {
                accessToken: authState.accessToken.accessToken,
                refreshToken: authState.refreshToken.refreshToken,
                user: authState.accessToken.claims || {},
                isAuth: authState.isAuthenticated
            };
            store/* store.dispatch */.h.dispatch((0,authSlice/* postLogin */.SV)(payload));
            store/* store.dispatch */.h.dispatch((0,authSlice/* setAnonymousId */.$t)(""));
        }
        if (prevAuthState && prevAuthState.isAuthenticated !== authState.isAuthenticated) {
            if (document.hidden) window.location.reload();
        }
        prevAuthState = authState;
        (0,helper/* addPageLoadAnalyticsEvent */.igK)();
    });
    authClient.tokenManager.on("error", async function(err) {
        console.error(err);
        await authClient.signOut({
            clearTokensBeforeRedirect: true
        });
        await authClient.session.close();
    });
    const isLoggedInRedirect = await authClient.isLoginRedirect();
    if (isLoggedInRedirect) {
        const { tokens  } = await authClient.token.parseFromUrl();
        authClient.tokenManager.setTokens(tokens);
        const { accessToken  } = tokens;
        store/* store.dispatch */.h.dispatch((0,authSlice/* postLogin */.SV)(accessToken.claims));
    } else {
        authClient.authStateManager.updateAuthState();
        try {
            const accessToken1 = await authClient.tokenManager.get("accessToken");
            const isSessionExists = await authClient.session.exists();
            if (accessToken1 && !authClient.tokenManager.hasExpired(accessToken1) && isSessionExists) {
                // check  if force renewal requested in previous session
                const userInfo = sessionStorage.getItem(constants["default"].KF_UPDATE_MEMBERSHIP);
                if (localStorage.getItem(constants["default"].KF_FORCE_RENEW_TOKEN)) {
                    if (userInfo) {
                        const user = JSON.parse(userInfo);
                        if (user.uid === accessToken1.claims.uid) {
                            const payload = {
                                user: accessToken1.claims
                            };
                            store/* store.dispatch */.h.dispatch((0,authSlice/* postLogin */.SV)(payload));
                            store/* store.dispatch */.h.dispatch((0,authSlice/* setPersona */.nf)(user.persona));
                        }
                    } else {
                        const renwedToken = await authClient.tokenManager.renew("accessToken");
                        const payload1 = {
                            user: renwedToken.claims
                        };
                        store/* store.dispatch */.h.dispatch((0,authSlice/* postLogin */.SV)(payload1));
                        localStorage.removeItem(constants["default"].KF_FORCE_RENEW_TOKEN);
                    }
                } else {
                    const payload2 = {
                        user: accessToken1.claims
                    };
                    store/* store.dispatch */.h.dispatch((0,authSlice/* postLogin */.SV)(payload2));
                }
            } else if (isSessionExists) {
                authClient.token.getWithRedirect({
                    responseType: [
                        "id_token",
                        "access_token",
                        "code"
                    ],
                    state: location.href
                }).catch((err)=>{
                    console.error("error in getting token", err);
                });
            } else if (!accessToken1) {
                const isProtected = await (0,helper/* isProtectedUrl */.GtH)();
                if (isProtected && isPublish) {
                    const redirectAction = {
                        isLoginAction: true,
                        loginCallbackURL: window.location.href
                    };
                    localStorage.setItem("SecurePageRedirect", JSON.stringify(redirectAction));
                    window.location.replace(await (0,helper/* getShortenedUrl */.Ppy)(homepageUrl));
                    if (window.location.pathname === homepageUrl) {
                        store/* store.dispatch */.h.dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                            show: true
                        }));
                    }
                } else if (localStorage.getItem("SecurePageRedirect")) {
                    const redirectAction1 = JSON.parse(localStorage.getItem("SecurePageRedirect"));
                    if (redirectAction1.isLoginAction) {
                        window.loginCallback = redirectAction1.loginCallbackURL;
                        localStorage.removeItem("SecurePageRedirect");
                        store/* store.dispatch */.h.dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                            show: true
                        }));
                    }
                }
            // store?.dispatch(getOktaToken("guest"))
            } else {
                store/* store.dispatch */.h.dispatch((0,authSlice/* logout */.kS)());
            }
        } catch (err) {
            console.error("Okta error while getting access token from token manager", err);
        }
    }
    securePagePathList.forEach((path)=>{
        document.querySelectorAll('a[href="'.concat(path, '"]')).forEach((tag)=>{
            tag.onclick = function(e) {
                e.preventDefault();
                if (registerNonKohlerProductPath === this.href) {
                    (0,helper/* setWindowProps */.F2_)("signUpConfirmationCTA", "Register Products");
                }
                (0,helper/* isAuthenticated */.$8e)(this.href);
            };
        });
    });
    document.querySelectorAll('a[href^="#isAuth"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const url = e.target.href.split("::")[1];
            (0,helper/* isAuthenticated */.$8e)(url);
        });
    });
    document.querySelectorAll('a[href*="#KPN"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const link = e.target.href.split("::");
            const id = link[0];
            const url = link[1];
            if (link) {
                store/* store.dispatch */.h.dispatch((0,authSlice/* setHideCustomerSignupCTA */.n$)(true));
                if (id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,helper/* isAuthenticated */.$8e)(url, 0, true);
                } else if (id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,helper/* isAuthenticated */.$8e)(url, 1, true);
                } else {
                    (0,helper/* isAuthenticated */.$8e)(url);
                }
            }
        });
    });
};
const resetPassword = function() {
    let recoveryToken = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", newPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", cb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{}, errCb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    authClient.verifyRecoveryToken({
        recoveryToken
    }).then(function(transaction) {
        if (transaction.status === "PASSWORD_RESET") {
            transaction.resetPassword({
                newPassword
            }).then(()=>{
                cb();
            }).catch((ex)=>errCb(ex.message));
        } else {
            errCb();
        }
    }).catch(function(ex) {
        errCb(ex.message);
    });
};



/***/ }),

/***/ 21315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getAciPaymentErrorMessage; },
/* harmony export */   "U": function() { return /* binding */ getCityAndStateByZipcode; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88032);



/**
 * Fetches the city and state details for the given zipcode.
 *
 * @param {string} zipcode - The zipcode to fetch address details for.
 * @return {Promise<Object>} A promise that resolves to an object containing city and state details.
 *                           Returns an empty object if an error occurs or no results are found.
 */ const getCityAndStateByZipcode = async function() {
    let zipcode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        var ref;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants___WEBPACK_IMPORTED_MODULE_1__.GET_CITY_AND_STATE_BY_ZIPCODE, "/").concat(zipcode));
        const results = (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.result) || {};
        return {
            city: (results === null || results === void 0 ? void 0 : results.city) || [],
            state: (results === null || results === void 0 ? void 0 : results.state) || ""
        };
    } catch (e) {
        var ref1, ref2, ref3;
        if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 400 && (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) === "No suggestions found, possibly invalid ZIP provided") {
            var ref4, ref5;
            return {
                city: [],
                state: "",
                error: ((ref4 = e.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "An error occurred while fetching data"
            };
        } else {
            var ref6, ref7;
            throw new Error((e === null || e === void 0 ? void 0 : (ref6 = e.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message) || "An error occurred while fetching data");
        }
    }
};
const getAciPaymentErrorMessage = async function(errorCode) {
    let errorKeyName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const { generic: { aciPaymentErrorMessagesPath =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState();
    try {
        const { data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance.get */ .Gb.get(_constants___WEBPACK_IMPORTED_MODULE_1__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath);
        const { value: authorErrorMsg = ""  } = data.find((e)=>e.text === errorCode) || {};
        let defaultErrorMessage = "";
        if (!authorErrorMsg) {
            const { value: configuredErrorMessage = ""  } = data.find((e)=>e.text === errorKeyName) || {};
            defaultErrorMessage = configuredErrorMessage;
            if (!configuredErrorMessage) {
                const { value: customMessage = ""  } = data.find((e)=>e.text === "customErrorMessage") || {};
                defaultErrorMessage = customMessage;
            }
        }
        return authorErrorMsg || defaultErrorMessage || _constants___WEBPACK_IMPORTED_MODULE_1__.GENERIC_ERROR_MESSAGE;
    } catch (e) {
        return _constants___WEBPACK_IMPORTED_MODULE_1__.GENERIC_ERROR_MESSAGE;
    }
};


/***/ }),

/***/ 13875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ getSearchPDP; },
/* harmony export */   "HB": function() { return /* binding */ requestForChangePassword; },
/* harmony export */   "He": function() { return /* binding */ getProductByImage; },
/* harmony export */   "vP": function() { return /* binding */ getProjectionData; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64757);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51666);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);





const API_TIMEOUT = 50000;
const requestForChangePassword = async (data)=>{
    try {
        return await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_PASSWORD_ENDPOINT */ .j0, data);
    } catch (err) {
        console.error("Failed to reset password", err);
        return err.response;
    }
};
const getProductByImage = async (input)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.skuBypimLookup), input, {
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_4__/* .getSessionIdObjWithEpoc */ .oq)(),
            timeout: API_TIMEOUT
        });
        return response;
    } catch (err) {
        return err;
    }
};
const getSearchPDP = async function(slug) {
    let isParts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    try {
        var ref, ref1, ref2;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
        var ref3;
        const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
        const data = {
            collections: isParts ? "service_parts" : "kohler",
            fl: _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_PDP_FL.toString(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_kohler_PDP",
            q: "*:*",
            search_type: "product_detail",
            fq: 'language_s:("'.concat(language, '")')
        };
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), data);
        if (!(response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs.length)) {
            data.collections = "kohler";
            data.profilename = "profile_kohler_General";
            return await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), data);
        }
        return response;
    } catch (err) {
        return err;
    }
};
const getProjectionData = async (payload)=>{
    const { slug , skus  } = payload;
    let query = "";
    let masterQuery = "";
    if (slug) masterQuery += 'slug(en-US%3D"'.concat(slug, '") or ');
    if (skus.length > 0) {
        skus.forEach((sku, i)=>{
            query += '"'.concat(sku, '"');
            if (i + 1 !== skus.length) query += ", ";
        });
        masterQuery += "masterVariant(sku in (".concat(query, ")) or variants(sku in (").concat(query, "))");
    }
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=").concat(masterQuery));
        if (res && res.data && res.data.results) return res.data.results;
    } catch (err) {
        return err;
    }
    return [];
};


/***/ }),

/***/ 8229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ip": function() { return /* binding */ initMedallia; },
/* harmony export */   "y0": function() { return /* binding */ showMedalliaFeedbackModal; }
/* harmony export */ });
/* unused harmony export loadMedalliaFeedbackModal */
const loadMedalliaFeedbackModal = (formID)=>{
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.KAMPYLE_ONSITE_SDK) === null || ref === void 0 ? void 0 : ref.loadForm(formID);
};
const showMedalliaFeedbackModal = (formID)=>{
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.KAMPYLE_ONSITE_SDK) === null || ref === void 0 ? void 0 : ref.showForm(formID);
};
const initMedallia = (formID)=>{
    if (window.KAMPYLE_ONSITE_SDK) {
        loadMedalliaFeedbackModal(formID);
    } else {
        window.addEventListener("neb_OnsiteLoaded", ()=>loadMedalliaFeedbackModal(formID));
    }
};


/***/ }),

/***/ 35285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getProductInventory; },
/* harmony export */   "uX": function() { return /* binding */ getProductsBySku; }
/* harmony export */ });
/* unused harmony exports getBundleProductDetailsFromServer, callGetConfigDataServerApi */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64757);




/**
 * Retrieves products by their SKUs from the catalog projection endpoint.
 *
 * @param {String} skus - An array of SKU strings to query for products.
 * @return {Array} A promise that resolves to an array of product objects.
 *                              Returns an empty array if an error occurs or no products are found.
 */ const getProductsBySku = async (skus)=>{
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ",";
    });
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=masterVariant(sku in (").concat(query, ")) or variants(sku in (").concat(query, "))"));
        const { data: { results =[]  } = {}  } = res || {};
        return results;
    } catch (error) {
        const { response  } = error || {};
        const { data: { error: errorMessaqge = ""  } = {}  } = response;
        console.error("Error fetching products by SKU:", errorMessaqge);
        return [];
    }
};
const getBundleProductDetailsFromServer = async (slug, lwAppName)=>{
    const payload = bundleRequestBuilder(lwAppName);
    aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
    const response = await aemAxiosInstance.post("".concat(apiBaseUrl).concat(BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY).concat(slug), payload);
    const { data: { response: { docs =[]  } = {}  } = {}  } = response;
    var ref;
    return (ref = docs[0]) !== null && ref !== void 0 ? ref : {};
};
const callGetConfigDataServerApi = async (locale, url)=>{
    try {
        const { data: configData = {}  } = await aemAxiosInstance({
            url: "".concat(CORE_GLOBAL_CONFIG_URL, "?caConfig=true&path=/").concat(locale).concat(url),
            method: "GET"
        });
        return {
            data: configData
        };
    } catch (error) {
        const { response: { config: { headers , url: url1 = ""  } = {} , status =500 , statusText =""  } = {}  } = error;
        return {
            error: {
                headers,
                statusText,
                status,
                url: url1
            }
        };
    }
};
const getProductInventory = async function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants___WEBPACK_IMPORTED_MODULE_1__.getStockEndPoint, "/?sku=").concat(skus));
        const { data: { results =[]  } = {}  } = response || {};
        return {
            inventories: results
        };
    } catch (e) {
        const skusArray = skus.split(",");
        const results1 = skusArray.map((sku)=>{
            return {
                availableQuantity: 1,
                key: "OMS-US",
                sku
            };
        });
        return {
            inventories: results1,
            isError: true
        };
    }
};


/***/ }),

/***/ 93014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h$": function() { return /* binding */ resetAccordion; },
/* harmony export */   "x4": function() { return /* binding */ setLastOpenAccordion; },
/* harmony export */   "xW": function() { return /* binding */ setOpenAccordion; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    openAccordion: null,
    lastOpenAccordion: null
};
const accordionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "accordion",
    initialState,
    reducers: {
        setOpenAccordion (state, action) {
            state.openAccordion = action.payload;
        },
        setLastOpenAccordion (state, action) {
            state.lastOpenAccordion = action.payload;
        },
        resetAccordion (state) {
            state.openAccordion = null;
            state.lastOpenAccordion = null;
        }
    }
});
const { setOpenAccordion , setLastOpenAccordion , resetAccordion  } = accordionSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (accordionSlice);


/***/ }),

/***/ 24899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ setAnonymousId; },
/* harmony export */   "A3": function() { return /* binding */ setAuthData; },
/* harmony export */   "Fc": function() { return /* binding */ setShowProSignup; },
/* harmony export */   "Gb": function() { return /* binding */ authSlice; },
/* harmony export */   "IR": function() { return /* binding */ setShowCartAction; },
/* harmony export */   "IU": function() { return /* binding */ signup; },
/* harmony export */   "LY": function() { return /* binding */ setAuthModalVisibility; },
/* harmony export */   "Mi": function() { return /* binding */ setShowCustomerSignup; },
/* harmony export */   "SV": function() { return /* binding */ postLogin; },
/* harmony export */   "_9": function() { return /* binding */ selectAuthState; },
/* harmony export */   "b4": function() { return /* binding */ setUserName; },
/* harmony export */   "cj": function() { return /* binding */ setShowForgotPassword; },
/* harmony export */   "cs": function() { return /* binding */ getOktaToken; },
/* harmony export */   "gF": function() { return /* binding */ forgotPassword; },
/* harmony export */   "hS": function() { return /* binding */ setAuthModalActiveTab; },
/* harmony export */   "iU": function() { return /* binding */ setRevalidateTime; },
/* harmony export */   "id": function() { return /* binding */ setAuthModalFormData; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "n$": function() { return /* binding */ setHideCustomerSignupCTA; },
/* harmony export */   "nf": function() { return /* binding */ setPersona; },
/* harmony export */   "vu": function() { return /* binding */ setAuthModalStaticText; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "xF": function() { return /* binding */ clearGuestState; }
/* harmony export */ });
/* unused harmony export clearAuthState */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28858);
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25696);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11763);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);












const initialState = {
    isAuth: false,
    anonymousId: "",
    access_token: "",
    refresh_token: "",
    expires_in: "",
    revalidate_in: "",
    scopes: [],
    token_type: "",
    status: "",
    error: "",
    authModal: {
        show: false,
        staticText: {},
        formData: {},
        active: 0
    },
    showCartAction: false,
    hashedEmail: "",
    customerProspect: "",
    showForgotPassword: false,
    showCustomerSignup: false,
    showProSignup: false,
    hideCustomerSignupCTA: false,
    user: {}
};
const getOktaToken = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/getOktaToken", async (type)=>{
    const { gId  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getAccessToken */ .hPi)();
    const { apiEndPointData: { map: { channel  }  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
    const path = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=").concat(type).concat(channel ? "&channel=".concat(channel) : "");
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(path, null, {
        params: {
            gId
        }
    });
    return response.data;
});
const login = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/login", async (payload, thunkAPI)=>{
    const { username , password , isFirstLogin  } = payload;
    const { cart: { cart: { lineItems =[]  }  }  } = thunkAPI.getState() || {};
    const isCartItems = lineItems.length > 0;
    try {
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        const { apiEndPointData: { map: { brandUsernameExtension  }  } = {}  } = config;
        const usernameWithExtension = brandUsernameExtension ? "".concat(username, ".").concat(brandUsernameExtension) : username;
        const res = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signInWithCredentials */ .U_.signInWithCredentials({
            username: usernameWithExtension,
            password
        });
        if (res.status === "SUCCESS") {
            return _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.token.getWithoutPrompt */ .U_.token.getWithoutPrompt({
                responseType: [
                    "id_token",
                    "access_token"
                ],
                sessionToken: res.sessionToken
            }).then(async function(param) {
                let { tokens  } = param;
                var ref;
                if (!isFirstLogin) {
                    thunkAPI.dispatch(setAuthModalVisibility({
                        show: false
                    }));
                }
                const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getAnonymousId */ .yQL)();
                localStorage.setItem("tempAnonymousId", anonymousId);
                thunkAPI.dispatch(setAnonymousId(""));
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .clearAnonymousToken */ .loo)();
                _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.setTokens */ .U_.tokenManager.setTokens(tokens);
                const payload = {
                    accessToken: tokens.accessToken.accessToken,
                    refreshToken: tokens.refreshToken.refreshToken,
                    user: ((ref = tokens.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {},
                    isAuth: true
                };
                window.kohler.datalayer.setItem("okta-token-storage", payload);
                await thunkAPI.dispatch(postLogin(payload));
                if (!isFirstLogin && isCartItems) {
                    thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .getCart */ .dv)()).unwrap().then(function() {
                        let res = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        const { lineItems =[]  } = res;
                        if (lineItems.length) {
                            thunkAPI.dispatch(setShowCartAction(true));
                        } else {
                            const mergeCartPayload = {
                                anonymousId
                            };
                            if (anonymousId) {
                                thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .mergeCart */ .Ii)(mergeCartPayload)).unwrap().then(()=>{
                                    var ref;
                                    thunkAPI.dispatch(setAnonymousId(""));
                                    localStorage.removeItem("tempAnonymousId");
                                    var ref1;
                                    const disableCommerce = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) !== null && ref1 !== void 0 ? ref1 : false;
                                    if (!disableCommerce) {
                                        thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .getCart */ .dv)());
                                    }
                                });
                            }
                        }
                    });
                }
                // ------------ functionality review start ----------------
                const state = thunkAPI.getState();
                const loginCallback = window.loginCallback;
                const { hideCustomerSignupCTA  } = state.auth;
                if (loginCallback) {
                    if (hideCustomerSignupCTA) {
                        const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getUserPersona */ .shu)();
                        const { general: { homepageUrl =""  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
                        if (persona !== "TVS") {
                            if (true) {
                                window.location.replace(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getShortenedUrl */ .Ppy)(homepageUrl !== null && homepageUrl !== void 0 ? homepageUrl : "/"));
                            }
                        } else if ( true && window.KPNSignIn) {
                            window.location.replace(loginCallback);
                        }
                    } else {
                        if (typeof loginCallback === "function") {
                            loginCallback();
                        } else {
                            window.location.replace(loginCallback);
                        // await authClient.session.setCookieAndRedirect(res.sessionToken)
                        }
                        window.loginCallback = null;
                    }
                }
                // ------------ functionality review end ----------------
                // await authClient.session.setCookieAndRedirect(res.sessionToken)
                return thunkAPI.fulfillWithValue("success");
            }).catch(function(err) {
                return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
            });
        } else if (res.status === "LOCKED_OUT") {
            return thunkAPI.fulfillWithValue({
                lockedOut: true
            });
        } else if (res.status === "PASSWORD_EXPIRED") {
            return thunkAPI.fulfillWithValue({
                passwordExpired: true,
                data: res.data
            });
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
    }
});
const signup = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/signup", async (payload, thunkAPI)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.signupEndPoint), payload);
        return response.data;
    } catch (err) {
        var ref;
        return thunkAPI.rejectWithValue(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data);
    }
});
const forgotPassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/forgotPassword", async (payload, thunkAPI)=>{
    const { username  } = payload;
    try {
        const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        const { apiEndpoints: { oktaChangePasswordUri =""  }  } = CONFIG;
        const { apiEndPointData: { map: { brandUsernameExtension  } = {}  }  } = CONFIG;
        const usernameWithExtension = brandUsernameExtension ? "".concat(username, ".").concat(brandUsernameExtension) : username;
        const response = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.forgotPassword */ .U_.forgotPassword({
            username: usernameWithExtension,
            factorType: "EMAIL",
            relayState: oktaChangePasswordUri
        });
        return response.data;
    } catch (err) {
        return thunkAPI.rejectWithValue(err);
    }
});
const logout = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/logout", async (payload, thunkAPI)=>{
    try {
        thunkAPI.dispatch(clearAuthState());
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .createPersonaCookie */ .g45)();
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_5__/* .removeCustomerCartId */ .w$)();
        await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signOut */ .U_.signOut({
            clearTokensBeforeRedirect: true
        });
        await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.session.close */ .U_.session.close();
        window.kohler.datalayer.setItem("okta-token-storage", "");
    } catch (err) {
        var ref;
        return thunkAPI.rejectWithValue(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data);
    }
});
const postLogin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/postLogin", async (payload)=>{
    const { user ={}  } = payload;
    if (user === null || user === void 0 ? void 0 : user.sub) {
        // this is email id hashing
        const res = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .shaEncrypt */ .aLl)(user === null || user === void 0 ? void 0 : user.sub);
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .createPersonaCookie */ .g45)();
        return {
            ...payload,
            encryptedEmail: res
        };
    }
});
const authSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSlice */ .oM)({
    name: "auth",
    initialState,
    reducers: {
        clearAuthState (state, action) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .clearAuthToken */ .RnQ)();
            if (window) {
                window.authAccessToken = "";
            }
            state.isAuth = false;
            state.anonymousId = "";
            state.access_token = "";
            state.refresh_token = "";
            state.revalidate_in = "";
            state.user = {};
            state.hashedEmail = "";
            state.customerProspect = "";
            state.auth = {};
            state.hideCustomerSignupCTA = false;
        },
        clearGuestState (state, action) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .clearAnonymousToken */ .loo)();
            state.anonymousId = "";
            state.access_token = "";
            state.refresh_token = "";
            state.revalidate_in = "";
        },
        setAnonymousId (state, action) {
            var ref;
            const { isAuth  } = state;
            const kohlerDatalayer = (ref = window.kohler) === null || ref === void 0 ? void 0 : ref.datalayer;
            const anonymousId = isAuth === false ? action.payload : "";
            state.anonymousId = anonymousId;
            if (typeof localStorage !== "undefined") {
                localStorage.setItem("anonymousId", anonymousId);
            }
            if (kohlerDatalayer && typeof kohlerDatalayer.setItem === "function") {
                kohlerDatalayer.setItem("anonymousId", anonymousId);
            }
        },
        setAuthData (state, action) {
            var ref;
            const kohlerDatalayer = (ref = window.kohler) === null || ref === void 0 ? void 0 : ref.datalayer;
            const { accessToken ="" , refreshToken ="" , isAuth =false , user ={}  } = action.payload;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
                if (!isAuth) {
                    if (typeof localStorage !== "undefined") {
                        localStorage.setItem("okta-anonymous-access-token", accessToken);
                    }
                    if (kohlerDatalayer && typeof kohlerDatalayer.setItem === "function") {
                        kohlerDatalayer.setItem("okta-anonymous-access-token", accessToken);
                    }
                }
            }
            if (refreshToken) {
                state.refresh_token = refreshToken;
                if (typeof localStorage !== "undefined") {
                    localStorage.setItem("okta-anonymous-refresh-token", refreshToken);
                }
                if (kohlerDatalayer && typeof kohlerDatalayer.setItem === "function") {
                    kohlerDatalayer.setItem("okta-anonymous-refresh-token", refreshToken);
                }
            }
            if (isAuth) state.isAuth = isAuth;
            if (user) state.user = user;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
        },
        setRevalidateTime (state, action) {
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
        },
        setAuthModalVisibility (state, action) {
            const { show , active =0 , onCloseHandlation =()=>{}  } = action.payload;
            state.authModal = {
                ...state.authModal,
                show: show,
                active: active,
                onCloseHandlation: onCloseHandlation
            };
            state.showCustomerSignup = false;
            state.showProSignup = false;
            state.showForgotPassword = false;
            state.hideCustomerSignupCTA = show ? state.hideCustomerSignupCTA : false;
        },
        setAuthModalActiveTab (state, action) {
            state.authModal = {
                ...state.authModal,
                active: action.payload
            };
        },
        setAuthModalStaticText (state, action) {
            state.authModal = {
                ...state.authModal,
                staticText: action.payload
            };
        },
        setShowCartAction (state, action) {
            state.showCartAction = action.payload;
        },
        setShowCustomerSignup (state, action) {
            state.showCustomerSignup = action.payload;
            state.showProSignup = false;
            state.showForgotPassword = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setShowProSignup (state, action) {
            state.showProSignup = action.payload;
            state.showCustomerSignup = false;
            state.showForgotPassword = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setShowForgotPassword (state, action) {
            state.showForgotPassword = action.payload;
            state.showCustomerSignup = false;
            state.showProSignup = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setHideCustomerSignupCTA (state, action) {
            state.hideCustomerSignupCTA = action.payload;
        },
        setPersona (state, action) {
            const { isAuth , user: { uid  }  } = state;
            const { user  } = state;
            if (isAuth) {
                sessionStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].KF_UPDATE_MEMBERSHIP, JSON.stringify({
                    uid
                }));
                localStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].KF_FORCE_RENEW_TOKEN, true);
                state.user = {
                    ...user,
                    persona: [
                        action.payload
                    ]
                };
            }
        },
        setUserName (state, action) {
            const { isAuth , user  } = state;
            var ref;
            const [firstName = "", lastName = ""] = (ref = action === null || action === void 0 ? void 0 : action.payload) !== null && ref !== void 0 ? ref : [];
            if (isAuth) {
                state.user = {
                    ...user,
                    firstName,
                    lastName
                };
            }
        },
        setAuthModalFormData (state, action) {
            state.authModal.formData = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.auth
            };
        }).addCase(getOktaToken.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getOktaToken.fulfilled, (state, action)=>{
            const kohlerDatalayer = window.kohler.datalayer;
            const { access_token: accessToken = "" , refresh_token: refreshToken = "" , expires_in: expiresIn = "" , scopes =[] , token_type: tokenType = ""  } = action.payload;
            if (state === null || state === void 0 ? void 0 : state.access_token) {
                if (window) {
                    window.authAccessToken = state === null || state === void 0 ? void 0 : state.access_token;
                }
                localStorage.setItem("okta-anonymous-access-token", state === null || state === void 0 ? void 0 : state.access_token);
                kohlerDatalayer.setItem("okta-anonymous-access-token", state === null || state === void 0 ? void 0 : state.access_token);
            } else if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
                localStorage.setItem("okta-anonymous-access-token", accessToken);
                kohlerDatalayer.setItem("okta-anonymous-access-token", accessToken);
            }
            if (state === null || state === void 0 ? void 0 : state.refresh_token) {
                localStorage.setItem("okta-anonymous-refresh-token", state === null || state === void 0 ? void 0 : state.refresh_token);
                kohlerDatalayer.setItem("okta-anonymous-refresh-token", state === null || state === void 0 ? void 0 : state.refresh_token);
            } else if (refreshToken) {
                state.refresh_token = refreshToken;
                localStorage.setItem("okta-anonymous-refresh-token", refreshToken);
                kohlerDatalayer.setItem("okta-anonymous-refresh-token", refreshToken);
            }
            if (expiresIn) state.expires_in = expiresIn;
            if (scopes) state.scopes = scopes;
            if (tokenType) state.token_type = tokenType;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
            state.status = "succeeded";
            state.error = "";
        }).addCase(getOktaToken.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(login.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(login.rejected, (state, action)=>{
            console.log("LOGIN", action.payload);
        }).addCase(login.fulfilled, (state, action)=>{
            console.log("LOGIN", action.payload);
        }).addCase(signup.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(signup.rejected, (state, action)=>{
            console.log("SIGNUP rejected", action.error);
        }).addCase(signup.fulfilled, (state, action)=>{
            console.log("SIGNUP fulfilled", action.payload);
        }).addCase(postLogin.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(postLogin.fulfilled, (state, action)=>{
            const { payload: { encryptedEmail ="" , accessToken ="" , refreshToken ="" , user ={} , isAuth =""  }  } = action;
            const oldHashedEmail = state.hashedEmail;
            const oldCustomerProspect = state.customerProspect;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
            }
            if (refreshToken) state.refresh_token = refreshToken;
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(user)) {
                state.user = user;
            }
            if (isAuth !== "") state.isAuth = isAuth;
            if (encryptedEmail) state.hashedEmail = encryptedEmail;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
            let needsUpdate = false;
            if (oldCustomerProspect && oldHashedEmail === encryptedEmail) {
                // here check if existing customerProspects are outdated
                try {
                    const decryptedCaesar = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .caesarDecrypt */ .s80)(encryptedEmail, oldCustomerProspect);
                    const decryptedJSON = JSON.parse(decryptedCaesar);
                    const currDate = new Date().toString();
                    if (decryptedJSON.updatedAt && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .hourDifference */ .oC7)(decryptedJSON.updatedAt, currDate) >= 1) {
                        needsUpdate = true;
                    }
                } catch (e) {
                    needsUpdate = true;
                }
            } else {
                needsUpdate = true;
            }
            if (needsUpdate) {
            /**
           * checking 3 conditions here
           *  1. if hashed emails are different
           *  2. if hashed emails are same then check if sync is done 1 hour ago or before that
           *  3. if old customer prospect object is missing from localstorage
           */ // await getPastOrders(true)
            }
        }).addCase(postLogin.rejected, (state, action)=>{
            console.log(action.error);
        }).addCase(logout.fulfilled, (state, action)=>{
            window.kohler.datalayer.setItem("okta-token-storage", "");
            state.cart = {};
        });
    }
});
const { clearAuthState , clearGuestState , setAuthData , setRevalidateTime , setAuthModalVisibility , setAuthModalActiveTab , setAuthModalStaticText , setAnonymousId , setShowCustomerSignup , setShowProSignup , setShowForgotPassword , setHideCustomerSignupCTA , setPersona , setUserName , setAuthModalFormData , setShowCartAction  } = authSlice.actions;
const selectAuthState = (state)=>state.auth;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (authSlice.reducer);


/***/ }),

/***/ 46201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ discount; },
/* harmony export */   "Ao": function() { return /* binding */ cartSlice; },
/* harmony export */   "BR": function() { return /* binding */ setPaymetId; },
/* harmony export */   "Bk": function() { return /* binding */ createCart; },
/* harmony export */   "Ii": function() { return /* binding */ mergeCart; },
/* harmony export */   "LR": function() { return /* binding */ setQtyLoading; },
/* harmony export */   "NM": function() { return /* binding */ shipmentUpdate; },
/* harmony export */   "QL": function() { return /* binding */ taxCalculation; },
/* harmony export */   "RV": function() { return /* binding */ setCart; },
/* harmony export */   "Vp": function() { return /* binding */ shareCart; },
/* harmony export */   "Vw": function() { return /* binding */ setNameOnCard; },
/* harmony export */   "Xq": function() { return /* binding */ addToCart; },
/* harmony export */   "YO": function() { return /* binding */ setShipping; },
/* harmony export */   "YZ": function() { return /* binding */ setCardStatus; },
/* harmony export */   "Z5": function() { return /* binding */ removeFromCartLineItem; },
/* harmony export */   "_P": function() { return /* binding */ shareCartaddToCart; },
/* harmony export */   "aN": function() { return /* binding */ orderSubmit; },
/* harmony export */   "al": function() { return /* binding */ deleteCart; },
/* harmony export */   "ap": function() { return /* binding */ shareCartDelete; },
/* harmony export */   "dv": function() { return /* binding */ getCart; },
/* harmony export */   "eM": function() { return /* binding */ setIsPayPalCallback; },
/* harmony export */   "er": function() { return /* binding */ recentlyViewed; },
/* harmony export */   "oJ": function() { return /* binding */ setCartCount; },
/* harmony export */   "pw": function() { return /* binding */ shipmentCart; },
/* harmony export */   "qT": function() { return /* binding */ setNoshipping; },
/* harmony export */   "th": function() { return /* binding */ addresssSuggest; },
/* harmony export */   "w9": function() { return /* binding */ setShowShippingDetails; },
/* harmony export */   "xA": function() { return /* binding */ setCartUrl; },
/* harmony export */   "xw": function() { return /* binding */ selectCartState; }
/* harmony export */ });
/* unused harmony exports shippingCost, addAddress, payment, payPalPayment, increment, decrement, setIsShipmentLoading */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64757);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28858);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11763);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88032);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24899);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60475);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _utils_payment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87864);
/* harmony import */ var _components_checkout_v2_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56980);













const initialState = {
    cart: {
        id: ""
    },
    quantity: 0,
    shipping: {},
    shipment: {},
    cartCount: 0,
    // shpping Items to checkout when product stock available
    shippingItemstoCheckout: [],
    // no items to ship from checkout when product is out of stock
    noShippingItemsInCheckout: [],
    cartUrl: "",
    showShippingDetailsForReview: {
        Parcel: false,
        LTL: false,
        Services: false
    },
    paymentId: "",
    nameOnCard: "",
    status: "",
    isCartLoading: false
};
const getCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("getCart", async function() {
    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isNotFromCart ="" , klId =""  } = payload;
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = klId ? "/cart/".concat(klId) // it's for loading customer cart data using KL id
     : "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.getCartEndPoint).concat(isNotFromCart ? "&gfqprofile=refershCartProfile" : "").concat(cartId);
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    const { anonymousId =""  } = data;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    return data;
});
const createCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("createCart", async (body, thunkAPI)=>{
    var ref;
    const state = thunkAPI.getState() || {};
    const { user  } = state.auth || {};
    var ref1;
    if (user) body.customerEmail = (ref1 = (ref = user.sub) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref1 !== void 0 ? ref1 : "";
    if (user.koc) {
        body.custom = {
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: user.koc,
                orderType: "ISC"
            }
        };
    }
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.createCartEndPoint), body);
    const { anonymousId =""  } = data;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    return data;
});
const shippingCost = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("shippingCost", async (id)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint, "?cartId=").concat(id));
    return response.data;
});
const discount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("discount", async (body)=>{
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.discountEndPoint).concat(cartId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    return response.data;
});
const taxCalculation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("tax", async ()=>{
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const body = {
        actions: [
            {
                action: "calculateTax"
            }
        ]
    };
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.taxEndPoint).concat(cartId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    return response.data;
});
const shipmentUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("shipmentUpdate", async (body, thunkAPI)=>{
    try {
        const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
        const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.taxEndPoint).concat(cartId);
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
        return response.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const shareCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("sharecart", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shareCartEndPoint), body);
    return response.data;
});
const mergeCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("cart/merge", async (payload)=>{
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_1__.mergeCartEndPoint, payload);
    if (data && data.type === "Cart") {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(""));
    }
    return data;
});
const addToCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("addToCart", async (body, thunkAPI)=>{
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
    const state = thunkAPI.getState() || {};
    const { cart: { customerGroup  }  } = state.cart;
    if (!customerGroup) {
        const customerGroupData = {};
        customerGroupData["action"] = "setCustomerGroup";
        customerGroupData["customerGroup"] = {
            key: persona
        };
        if (body.actions) {
            body.actions.push(customerGroupData);
        }
    }
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.cartItemsEndPoint, "?expand=calculation").concat(cartId);
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    const { anonymousId =""  } = data;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    const kohlerDatalayer = window.kohler.datalayer;
    if (typeof kohlerDatalayer !== "undefined" && typeof kohlerDatalayer.setItem === "function") {
        kohlerDatalayer.setItem("CART_DATA", data);
    }
    return data;
});
const shareCartaddToCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("shareCartaddToCart", async (body)=>{
    const { cartId ="" , isSharedCart =false , ...restBody } = body;
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.sharedCartItemsEndPoint, "?expand=calculation&cartId=").concat(cartId);
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, restBody);
    return {
        data,
        isSharedCart
    };
});
const removeFromCartLineItem = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("removeFromCartLineItem", async (body)=>{
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.cartItemsEndPoint, "?expand=calculation").concat(cartId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    const kohlerDatalayer = window.kohler.datalayer;
    if (typeof kohlerDatalayer !== "undefined" && typeof kohlerDatalayer.setItem === "function") {
        kohlerDatalayer.setItem("CART_DATA", response.data);
    }
    return response.data;
});
const deleteCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("deleteCart", async ()=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim["delete"] */ .TH["delete"]("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.deleteCartEndPoint));
    return response.data;
});
const shareCartDelete = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("shareCartDelete", async (body)=>{
    const { id , version  } = body;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim["delete"] */ .TH["delete"]("".concat("/cart/".concat(id, "?cart-versionId=").concat(version)));
    return response.data;
});
const shipmentCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("shipmentcart", async (body)=>{
    let response;
    const { cartId ="" , cartIdQuery =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const { cart: { cart ={}  } , checkout: { checkoutStep =0 , isFromPaymentInventoryCheck =false  }  } = _store__WEBPACK_IMPORTED_MODULE_5__/* .store.getState */ .h.getState() || {};
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(setIsShipmentLoading(true));
    const isXpp = (0,_utils_payment__WEBPACK_IMPORTED_MODULE_10__/* .checkExpPayPal */ .DV)();
    if (checkoutStep < 2 && isFromPaymentInventoryCheck) {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setFromPaymentInventoryCheck */ .Db)(false));
    }
    try {
        if (body && (body === null || body === void 0 ? void 0 : body.assign) && (body === null || body === void 0 ? void 0 : body.payload)) {
            const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint).concat(body.assign ? "?assignshipping=true" : "").concat(cartId);
            response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body.payload);
        } else {
            const url1 = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint).concat(cartIdQuery);
            response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url1);
        }
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(setIsShipmentLoading(false));
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setIsShipmentFromCart */ .ig)(true));
        if (isXpp) {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCheckoutAction */ .BZ)(3));
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setExpPayPalCheckout */ .gp)(true));
        } else if (!isXpp && checkoutStep >= 2 && isFromPaymentInventoryCheck) {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCheckoutAction */ .BZ)(2));
        } else {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCheckoutAction */ .BZ)(1));
        }
        return response.data;
    } catch (error) {
        var ref;
        const { response: { data: { error: errorMessage = ""  } , status  } = {}  } = error;
        if (errorMessage === _constants_index__WEBPACK_IMPORTED_MODULE_1__.NO_ACTIVE_CART_EXISTS) {
            (0,_components_checkout_v2_utils__WEBPACK_IMPORTED_MODULE_11__/* .redirectToCartPage */ .DZ)();
        }
        const shippingDetails = {
            "shipping-details": {
                results: []
            },
            shippingCost: true
        };
        response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint, "?cartId=").concat(cart === null || cart === void 0 ? void 0 : cart.id));
        shippingDetails["shipping-details"]["results"] = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.results;
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(setIsShipmentLoading(false));
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setIsShipmentFromCart */ .ig)(false));
        if (status === 401 || status === 403) {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setIsShipmentFromCart */ .ig)(true));
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setPayPalCallBackErrorMsg */ .SB)(body));
        }
        return shippingDetails;
    }
});
const addresssSuggest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("addresssSuggest", async (data)=>{
    var ref, ref1;
    const { addr ="" , geoLocationData ={}  } = data || {};
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
    const country = (config === null || config === void 0 ? void 0 : (ref = config.apiEndPointData) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.experianISOCode) || _constants_index__WEBPACK_IMPORTED_MODULE_1__.ADDRESS_SUGGESTION_DEFAULT_COUNTRY;
    let path = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.addressSuggestionEndPoint, "?query=").concat(addr, "&country=").concat(country);
    if ((geoLocationData === null || geoLocationData === void 0 ? void 0 : geoLocationData.lat) && (geoLocationData === null || geoLocationData === void 0 ? void 0 : geoLocationData.lng)) {
        path += "&location=".concat(geoLocationData.lat, ",").concat(geoLocationData.lng);
    }
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(path);
    return response.data;
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("addAddress", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.addAddressEndPoint), body);
    return response.data;
});
const payment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("payment", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.paymentEndPoint), body);
    return response.data;
});
const payPalPayment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("payPalPayment", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.payPalPaymentEndPoint), body);
    return response.data;
});
const orderSubmit = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("orderSubmit", async (body, thunkAPI)=>{
    const { cartIdQuery ="" , activeCartId  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)(true);
    const { timeout , isAciCreditCardV2 , ...restBody } = body || {};
    const url = isAciCreditCardV2 ? _constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_SUBMIT_V3_ENDPOINT */ ._2 : "".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_SUBMIT_V2_ENDPOINT */ .FF).concat(cartIdQuery);
    const payload = {
        ...restBody,
        ...isAciCreditCardV2 && {
            cartId: activeCartId
        }
    };
    const isOrderError = sessionStorage.getItem("isOrderError");
    const requestConfig = {
        ...timeout && {
            timeout: timeout
        },
        ...isAciCreditCardV2 && isOrderError === "true" && {
            headers: {
                "X-Iframe-Retry": "true"
            }
        }
    };
    if (activeCartId) {
        try {
            const { data , status  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, payload, requestConfig);
            const state = thunkAPI.getState();
            const { auth: { isAuth =false  } = {}  } = state;
            if (status === 201 || status === 200) {
                sessionStorage.removeItem("isOrderError");
                (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .removeCustomerCartId */ .w$)();
                if (!isAuth) {
                    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .clearGuestState */ .xF)());
                }
            }
            return data;
        } catch (error) {
            if (isAciCreditCardV2) {
                sessionStorage.setItem("isOrderError", "true");
            }
            const { response: { data: data1 = {}  } = {}  } = error;
            console.error(error);
            return thunkAPI.rejectWithValue(data1);
        }
    }
});
const recentlyViewed = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createAsyncThunk */ .hg)("recentlyViewed", async (query)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=id in (").concat(query, ")"));
    return response.data;
});
const cartSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_12__/* .createSlice */ .oM)({
    name: "cart",
    initialState,
    reducers: {
        setCart (state, action) {
            state.cart = action.payload;
        },
        setCartCount (state, action) {
            state.cartCount = action.payload;
        },
        setQtyLoading (state, action) {
            state.qtyLoading = action.payload;
        },
        setShipping (state, action) {
            state.shippingItemstoCheckout = action.payload;
        },
        setNoshipping (state, action) {
            var ref;
            const skuIds = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.map((item)=>item.sku);
            state.noShippingItemsInCheckout = skuIds || [];
        },
        setShowShippingDetails (state, action) {
            state.showShippingDetailsForReview = action.payload;
        },
        setCartUrl (state, action) {
            state.cartUrl = action.payload;
        },
        setPaymetId (state, action) {
            state.paymentId = action.payload;
        },
        increment (state, action) {
            state.quantity = state.quantity + 1;
        },
        decrement (state, action) {
            state.quantity = state.quantity - 1;
        },
        setNameOnCard (state, action) {
            state.nameOnCard = action.payload;
        },
        setCardStatus (state, action) {
            state.isCartLoading = action.payload;
        },
        setIsPayPalCallback (state, action) {
            state.isPayPalCallback = action.payload;
        },
        setIsShipmentLoading (state, action) {
            state.isShipmentLoading = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.cart
            };
        }).addCase(getCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(getCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(createCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shippingCost.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shippingCost.fulfilled, (state, action)=>{
            state.shipping = action.payload;
            state.status = "succeeded";
        }).addCase(shippingCost.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(discount.pending, (state)=>{
            state.status = "loading";
        }).addCase(discount.fulfilled, (state, action)=>{
            state.status = "succeeded";
            // after discount this will set cart with updated data
            state.cart = action.payload;
        }).addCase(discount.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(taxCalculation.pending, (state)=>{
            state.status = "loading";
        }).addCase(taxCalculation.fulfilled, (state, action)=>{
            state.status = "succeeded";
            // after tax this will set cart with updated data
            state.cart = action.payload;
        }).addCase(taxCalculation.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shipmentUpdate.pending, (state)=>{
            state.status = "loading";
        }).addCase(shipmentUpdate.fulfilled, (state, action)=>{
            var ref, ref1;
            state.status = "succeeded";
            // temp
            const activeCart = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.type) === "Cart" && ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.lineItems.length) > 0;
            state.cart = activeCart ? action.payload : state.cart;
        }).addCase(shipmentUpdate.rejected, (state, action)=>{
            var ref;
            state.status = "failed";
            state.error = action.error.message;
            state.isNonDeliverableAddress = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.isNonDeliverableAddress;
        }).addCase(shareCart.pending, (state)=>{
        // state.status = "loading"
        }).addCase(shareCart.fulfilled, (state, action)=>{
        // state.status = "succeeded"
        }).addCase(shareCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addToCart.pending, (state, action)=>{
            // state.status = "loading"
            state.status = "loading";
        }).addCase(addToCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(addToCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(deleteCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(deleteCart.fulfilled, (state, action)=>{
            // state.cart = { id: action.payload.id, lineItems: [] }
            state.cartCount = 0;
            state.status = "succeeded";
        }).addCase(deleteCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shipmentCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shipmentCart.fulfilled, (state, action)=>{
            var ref;
            if (!((ref = action.payload) === null || ref === void 0 ? void 0 : ref.shippingCost)) {
                state.cart = {
                    ...state.cart,
                    ...action.payload
                };
            }
            state.status = "succeeded";
        }).addCase(shipmentCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addresssSuggest.pending, (state, action)=>{
        // state.status = "loading"
        }).addCase(addresssSuggest.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(addresssSuggest.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addAddress.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addAddress.fulfilled, (state, action)=>{
            // state.cart = action.payload
            state.status = "succeeded";
        }).addCase(addAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(mergeCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(mergeCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(mergeCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(payment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(payment.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(payment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(payPalPayment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(payPalPayment.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(payPalPayment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(orderSubmit.pending, (state, action)=>{
            state.status = "loading" || 0;
        }).addCase(orderSubmit.fulfilled, (state, action)=>{
            // state.cart = action.payload
            state.status = "succeeded" || 0;
        }).addCase(orderSubmit.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message || "";
        }).addCase(removeFromCartLineItem.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(removeFromCartLineItem.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(removeFromCartLineItem.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(recentlyViewed.pending, (state)=>{
            state.status = "loading";
        }).addCase(recentlyViewed.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(recentlyViewed.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shareCartaddToCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shareCartaddToCart.fulfilled, (state, action)=>{
            const { data , isSharedCart  } = action.payload;
            if (!isSharedCart) state.cart = data;
            var ref;
            state.cartCount = (ref = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(data === null || data === void 0 ? void 0 : data.lineItems)) !== null && ref !== void 0 ? ref : 0;
            state.status = "succeeded";
        }).addCase(shareCartaddToCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shareCartDelete.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shareCartDelete.fulfilled, (state, action)=>{
            state.cart = {
                id: action.payload.id,
                lineItems: []
            };
            state.cartCount = 0;
            state.shippingItemstoCheckout = [];
            state.status = "succeeded";
        }).addCase(shareCartDelete.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setCart , increment , decrement , setCartCount , setQtyLoading , setCartUrl , setShipping , setNoshipping , setShowShippingDetails , setPaymetId , setNameOnCard , setCardStatus , setIsPayPalCallback , setIsShipmentLoading  } = cartSlice.actions;
const selectCartState = (state)=>state.cart;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (cartSlice.reducer);


/***/ }),

/***/ 60475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ getProfile; },
/* harmony export */   "BZ": function() { return /* binding */ setCheckoutAction; },
/* harmony export */   "Bp": function() { return /* binding */ setIsVerifiedAddress; },
/* harmony export */   "Db": function() { return /* binding */ setFromPaymentInventoryCheck; },
/* harmony export */   "Ds": function() { return /* binding */ setIsInvalidCountryAction; },
/* harmony export */   "Fc": function() { return /* binding */ setPaymentErrorMessageAction; },
/* harmony export */   "I2": function() { return /* binding */ setPaymentMethodNameAction; },
/* harmony export */   "JN": function() { return /* binding */ setCardLastDigit; },
/* harmony export */   "Pk": function() { return /* binding */ setPaymentDisableBtnAction; },
/* harmony export */   "RM": function() { return /* binding */ setPaymentFailedAction; },
/* harmony export */   "SB": function() { return /* binding */ setPayPalCallBackErrorMsg; },
/* harmony export */   "TG": function() { return /* binding */ checkoutState; },
/* harmony export */   "Yb": function() { return /* binding */ editAddress; },
/* harmony export */   "_K": function() { return /* binding */ setDefaultAddress; },
/* harmony export */   "cU": function() { return /* binding */ setPaymentOptionNameAction; },
/* harmony export */   "gp": function() { return /* binding */ setExpPayPalCheckout; },
/* harmony export */   "hK": function() { return /* binding */ setIsPaymentInfoAction; },
/* harmony export */   "ig": function() { return /* binding */ setIsShipmentFromCart; },
/* harmony export */   "jJ": function() { return /* binding */ setPlaceOrderCountsAction; },
/* harmony export */   "t5": function() { return /* binding */ setPaymentTechnicalFailedAction; },
/* harmony export */   "vu": function() { return /* binding */ checkoutSlice; },
/* harmony export */   "wC": function() { return /* binding */ setBillingAddress; },
/* harmony export */   "y$": function() { return /* binding */ addAddress; },
/* harmony export */   "zs": function() { return /* binding */ setIsLoginCheckoutForm; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77236);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);




const initialState = {
    status: "",
    error: "",
    addresses: [],
    isVerifiedAddress: false,
    profileInfo: null,
    profileVersion: null,
    nextDefaultAddressId: null,
    isExpPayPalCheckout: false,
    paymentMethod: "",
    payPalCallBackErrorMsg: "",
    cardLastDigit: "",
    paymentErrorMessage: "",
    paymentMethodName: "",
    placeOrderCounts: 1,
    isShipmentFromCart: null,
    isFromPaymentInventoryCheck: false
};
const editAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/address/edit", async (payload, thunkAPI)=>{
    let addresses = [];
    const body = {
        actions: [
            {
                action: "changeAddress",
                addressId: payload.id,
                address: payload.address
            }
        ],
        version: payload.version
    };
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
        if (res && res.data) {
            if (res.data.addresses.length > 0) {
                var ref;
                var ref1;
                addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                    var ref, ref1;
                    return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref1 !== void 0 ? ref1 : [];
                if (payload.address.setPrimary) {
                    res.data.setPrimary = true;
                    res.data.nextDefaultAddressId = payload.id;
                }
            }
        }
        res.data.addresses = addresses;
        return res.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/address/add", async (payload, thunkAPI)=>{
    let addresses = [];
    const body = Array.isArray(payload.address) ? {
        version: payload.version,
        actions: payload.data
    } : {
        version: payload.version,
        actions: [
            {
                action: "addAddress",
                address: payload.address
            }
        ]
    };
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
        if (res && res.data) {
            if (res.data.addresses.length > 0) {
                var ref;
                var ref1;
                addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                    var ref, ref1;
                    return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref1 !== void 0 ? ref1 : [];
                if (payload.address.setPrimary) {
                    var ref2;
                    const index = addresses.length - 1;
                    res.data.setPrimary = true;
                    res.data.nextDefaultAddressId = (ref2 = addresses[index]) === null || ref2 === void 0 ? void 0 : ref2.id;
                }
            }
        }
        res.data.addresses = addresses;
        return res.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const setDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/default/address", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    const body = {
        version: payload.profileVersion,
        actions: [
            {
                action: "setDefaultShippingAddress",
                addressId: payload.id
            }
        ]
    };
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
    if (res && res.data) {
        resPayload.version = res.data.version;
        if (res.data.addresses.length > 0) {
            var ref;
            var ref1;
            resPayload.addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            })) !== null && ref1 !== void 0 ? ref1 : [];
            resPayload.defaultShippingAddressId = res.data.defaultShippingAddressId;
        }
    }
    return resPayload;
});
const getProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/me", async ()=>{
    var ref, ref1;
    let profile = {};
    let index = 0;
    let addresses = {};
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_PROFILE_ENDPOINT));
    profile = response.data;
    const profileAddr = profile === null || profile === void 0 ? void 0 : (ref = profile.addresses) === null || ref === void 0 ? void 0 : ref.find((addr)=>{
        var ref, ref1;
        return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
    });
    profile["profileAddrId"] = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
    profile["addresses"] = profile === null || profile === void 0 ? void 0 : (ref1 = profile.addresses) === null || ref1 === void 0 ? void 0 : ref1.filter((addr)=>{
        var ref, ref1;
        return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
    });
    addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
    if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
        index = addresses.findIndex((item)=>{
            return item.id === (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId);
        });
    }
    if (index !== 0) {
        addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .arrayMove */ .RpN)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
    }
    profile["addresses"] = addresses;
    response["data"] = profile;
    return response.data;
});
const checkoutSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "checkout",
    initialState,
    reducers: {
        setIsPaymentInfoAction (state, action) {
            state.isPaymentInfo = action.payload;
        },
        setPaymentMethodNameAction (state, action) {
            state.paymentMethodName = action.payload;
        },
        setPaymentOptionNameAction (state, action) {
            state.paymentOptionName = action.payload;
        },
        setCheckoutAction (state, action) {
            state.checkoutStep = action.payload;
        },
        setPaymentFailedAction (state, action) {
            state.isPaymentFailed = action.payload;
        },
        setIsInvalidCountryAction (state, action) {
            state.isInvalidCountry = action.payload;
        },
        setPaymentTechnicalFailedAction (state, action) {
            state.isPaymentTechnicalErrorFailed = action.payload;
        },
        setPaymentErrorMessageAction (state, action) {
            state.paymentErrorMessage = action.payload;
        },
        setCardLastDigit (state, action) {
            state.cardLastDigit = action.payload;
        },
        setPaymentDisableBtnAction (state, action) {
            state.isPaymentDisableAction = action.payload;
        },
        setPlaceOrderCountsAction (state, action) {
            state.placeOrderCounts = action.payload;
        },
        setBillingAddress (state, action) {
            state.billingAddress = action.payload;
        },
        setExpPayPalCheckout (state, action) {
            state.isExpPayPalCheckout = action.payload;
        },
        setPayPalCallBackErrorMsg: (state, action)=>{
            state.payPalCallBackErrorMsg = action.payload;
        },
        setIsVerifiedAddress: (state, action)=>{
            state.isVerifiedAddress = action.payload;
        },
        setIsShipmentFromCart: (state, action)=>{
            state.isShipmentFromCart = action.payload;
        },
        setIsLoginCheckoutForm (state, action) {
            state.isLoginCheckoutForm = action.payload;
        },
        setFromPaymentInventoryCheck (state, action) {
            state.isFromPaymentInventoryCheck = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase(editAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(editAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version , nextDefaultAddressId , setPrimary  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
            if (setPrimary) {
                state.nextDefaultAddressId = nextDefaultAddressId;
            }
        }).addCase(editAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(setDefaultAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(setDefaultAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
        }).addCase(setDefaultAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProfile.pending, (state)=>{
            state.status = "loading";
        }).addCase(getProfile.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.profileInfo = action.payload;
            state.profileVersion = action.payload.version;
        }).addCase(getProfile.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(addAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version , nextDefaultAddressId , setPrimary , defaultShippingAddressId  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
            state.defaultAddressId = defaultShippingAddressId;
            if (setPrimary) {
                state.nextDefaultAddressId = nextDefaultAddressId;
            }
        }).addCase(addAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setIsPaymentInfoAction , setPaymentMethodNameAction , setPaymentOptionNameAction , setCheckoutAction , setPaymentFailedAction , setIsInvalidCountryAction , setBillingAddress , setPaymentErrorMessageAction , setPaymentTechnicalFailedAction , setPaymentDisableBtnAction , setPlaceOrderCountsAction , setCardLastDigit , setExpPayPalCheckout , setPayPalCallBackErrorMsg , setIsVerifiedAddress , setIsShipmentFromCart , setIsLoginCheckoutForm , setFromPaymentInventoryCheck  } = checkoutSlice.actions;
const checkoutState = (state)=>state.checkout;


/***/ }),

/***/ 39915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ updateCompareStatus; },
/* harmony export */   "JY": function() { return /* binding */ clearProduct; },
/* harmony export */   "NP": function() { return /* binding */ compareState; },
/* harmony export */   "Oe": function() { return /* binding */ clearAllCompareProducts; },
/* harmony export */   "Sw": function() { return /* binding */ setCompareExpiry; },
/* harmony export */   "qD": function() { return /* binding */ compareSlice; },
/* harmony export */   "rI": function() { return /* binding */ addCompareProducts; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    category: "",
    comparedProducts: [],
    expiresIn: 60,
    isEnable: false,
    compareSectionData: []
};
const compareSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "compare",
    initialState,
    reducers: {
        clearProduct (state, action) {
            state.comparedProducts.forEach((obj)=>{});
            const products = state.comparedProducts.filter((product)=>product.compareSku !== action.payload);
            const query = products.map((item)=>item.compareSku).join(",");
            const currentUrl = window.location.href;
            const urlObj = new URL(currentUrl);
            const isSearchPage = urlObj.pathname.includes("/search");
            if (isSearchPage) {
                // 🔹 We're on a search page — only touch the compare param
                if (!query) {
                    // Remove compare if empty
                    urlObj.searchParams.delete("compare");
                } else {
                    // Update compare param with remaining products
                    urlObj.searchParams.set("compare", query);
                }
                // Update URL but preserve keyword and any other params
                window.history.replaceState({}, document.title, urlObj.toString());
            } else {
                // 🔹 Not a search page — keep older logic
                const path = "".concat(products.length > 0 ? "?compare=" : "").concat(query.toString());
                if (!query) {
                    window.history.replaceState(null, "", window.location.pathname);
                } else {
                    window.history.replaceState(window.location.pathname, document.title, path);
                }
            }
            state.category = products.length === 0 ? "" : state.category;
            state.comparedProducts = products;
        },
        setCompareExpiry (state, action) {
            state.expiresIn = action.payload;
        },
        clearAllCompareProducts (state, action) {
            state.category = "";
            state.comparedProducts = [];
        },
        addCompareProducts (state, action) {
            try {
                const { expiresIn  } = state;
                const { productData ={} , backorder =false , compareSku ="" , slug =""  } = action.payload;
                const product = productData;
                if (product && Object.keys(product).length > 0) {
                    product.compareSku = compareSku || productData.sku_s || productData.sku;
                    product.expiry = Date.now() + expiresIn * 24 * 3600 * 1000;
                    product.backorder = backorder;
                    product.slug = slug;
                    const productsTemp = state.comparedProducts;
                    const alreadyExist = productsTemp.some((obj)=>{
                        return obj.compareSku === productData.sku_s || obj.compareSku === productData.sku;
                    });
                    if (!alreadyExist) {
                        const prodMain = productsTemp.filter((obj)=>{
                            return obj.compareSku !== productData.sku_s || obj.compareSku !== productData.sku;
                        });
                        prodMain.push(product);
                        state.comparedProducts = prodMain;
                        var _ProductLocalCategory_s, ref;
                        state.category = productData.Product_Category ? productData.Product_Category : (ref = (_ProductLocalCategory_s = productData.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : productData.category) !== null && ref !== void 0 ? ref : "";
                    }
                }
                state.isEnable = false;
            } catch (error) {
                state.isEnable = false;
            }
        },
        updateCompareStatus (state, action) {
            state.isEnable = action.payload;
        }
    }
});
const { setCompareExpiry , clearAllCompareProducts , addCompareProducts , clearProduct , updateCompareStatus  } = compareSlice.actions;
const compareState = (state)=>state.compare;


/***/ }),

/***/ 7737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kn": function() { return /* binding */ addListLineItemQuantity; },
  "rA": function() { return /* binding */ addMedia; },
  "gK": function() { return /* binding */ addProduct; },
  "XV": function() { return /* binding */ addProductToList; },
  "Lu": function() { return /* binding */ deleteMultiProductFromList; },
  "D3": function() { return /* binding */ deleteProductFromList; },
  "iF": function() { return /* binding */ deleteUserList; },
  "Du": function() { return /* binding */ editList; },
  "MY": function() { return /* binding */ favoritesSlice; },
  "_l": function() { return /* binding */ getFavorites; },
  "Vb": function() { return /* binding */ getListFirstLineItemsData; },
  "w": function() { return /* binding */ getMyAccountFavorites; },
  "jP": function() { return /* binding */ getMyAccountLists; },
  "WQ": function() { return /* binding */ getMyAccountListsWithLineItems; },
  "Co": function() { return /* binding */ getProductBySlug; },
  "RD": function() { return /* binding */ getSharedListProductData; },
  "s$": function() { return /* binding */ moveItemsFromList; },
  "tC": function() { return /* binding */ myAccountRemoveItems; },
  "Er": function() { return /* binding */ removeItems; },
  "Qx": function() { return /* binding */ selectFavoritesState; }
});

// UNUSED EXPORTS: createFavorite, default, setFavorites, setLoginFavouriteCallback

// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./utils/favouritesHelper.js


const addDataLayerFav = function() {
    let msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isSuccess = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", internalLinkType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", zone = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoName = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", videoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", imageName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    var ref;
    const sharedZoneName = (ref = zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ")) !== null && ref !== void 0 ? ref : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { pageInfo: { contentType  }  } = page;
    const sharedInternalLinkType = internalLinkType ? (0,helper/* sanitizeTextForAnalytics */.T68)(internalLinkType) : "teaser";
    const cleanSharedInternalLinkType = (0,helper/* cleanText */.FV)(sharedInternalLinkType);
    const sharedInternalLinkZoneName = sharedZoneName ? (0,helper/* sanitizeTextForAnalytics */.T68)(sharedZoneName) : "teaser";
    const eventPageType = contentType === "locations" ? "locations:kohler stores" : window.eventPageType;
    const isPdp = eventPageType === "pdp";
    const pageType = "".concat(eventPageType, ":").concat(sharedInternalLinkZoneName);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":favorite ").concat(type),
        eventName: "".concat(pageType, ":favorite ").concat(type),
        eventMsg: msg || "n/a",
        eventStatus: isSuccess ? "success" : "failure",
        eventType: "navigation",
        internalLinkName: "favorite ".concat(type),
        internalLinkPosition: eventPageType,
        internalLinkType: "".concat(eventPageType, ":").concat(cleanSharedInternalLinkType),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventPageType, ":").concat(sharedInternalLinkZoneName)
    };
    if (videoName) eventInfo.videoName = videoName;
    if (videoId) eventInfo.videoId = videoId;
    if (imageName) eventInfo.imageName = imageName;
    const dataLayerObj = {
        event: "cmp:click",
        eventInfo,
        page
    };
    if (isPdp) {
        const { pageInfo: { pageUrl  } , productInfo  } = page;
        const isAdd = type === "add" ? true : type === "remove" ? false : true;
        const eventInfoPdp = {
            clickInternalLinks: "true",
            eventAction: "pdp:product details:favorite ".concat(type),
            eventName: "pdp:product details:favorite ".concat(type),
            eventMsg: isAdd ? "your item has been saved to your favorites." : "item has been removed from your favorites.",
            eventStatus: "success",
            eventType: isAdd ? "wishlist save" : "navigation",
            internalLinkName: "favorite ".concat(type),
            internalLinkPosition: "pdp".concat((productInfo === null || productInfo === void 0 ? void 0 : productInfo.pdpType) === "bundle" ? ":bundle" : ""),
            internalLinkType: "pdp:favorites",
            internalLinkURL: pageUrl || "n/a",
            internalLinkZoneName: "pdp:product details"
        };
        dataLayerObj["productInfo"] = productInfo;
        dataLayerObj["eventInfo"] = eventInfoPdp;
    }
    window.adobeDataLayer.push(dataLayerObj);
    delete window.zoneName;
    delete window.internalLinkType;
};

// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/ApiUtil.js
var ApiUtil = __webpack_require__(51666);
;// CONCATENATED MODULE: ./store/features/favoritesSlice.js











const initialState = {
    favorites: {},
    status: "",
    fullFavoriteData: {},
    isLoginFavouriteCallback: {
        isCallBack: false,
        callBackAssetID: ""
    },
    saveToListLineItems: {},
    userListItemsSkus: {},
    userLists: []
};
const shoppingListName = "Favorites";
const getFavorites = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getFavorites", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.favoritesEndPoint, "?lang=").concat(locale));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    if (results.length > 0) {
        const getVersion = Math.max(...results.map((i)=>i.version));
        const favoritesData = results.filter((item)=>item.name[locale] === "Favorites" && item.version === getVersion);
        const { textLineItems =[]  } = favoritesData[0];
        if (textLineItems.length > 0) (0,helper/* checkIsFavorite */.GsT)(textLineItems);
        if (favoritesData.length) {
            return favoritesData[0];
        }
    }
    return {};
});
const deleteUserList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("deleteUserList", async (list)=>{
    const response = await api/* apim.delete */.TH["delete"]("".concat(constants.USER_LIST_DELETE_END_POINT, "/").concat(list === null || list === void 0 ? void 0 : list.id, "?version=").concat(list === null || list === void 0 ? void 0 : list.version));
    return response;
});
const deleteProductFromList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("deleteProductFromList", async (list)=>{
    const response = await api/* apim.post */.TH.post("".concat(constants.USER_LIST_PRODUCT_DELETE_POINT, "/").concat(list === null || list === void 0 ? void 0 : list.listId), {
        version: list.listVersion,
        actions: [
            {
                action: "removeLineItem",
                lineItemId: list.id
            }
        ]
    });
    return response;
});
const getMyAccountListsWithLineItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountListsWithLineItems", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.FAVORITES_LIST_END_POINT, "?lang=").concat(locale, "&limit=").concat(constants.FAVORITES_LIST_LIMIT));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    const maxVersionLists = (0,ApiUtil/* getMaxVersionLists */.Lp)(results, locale);
    const listItems = (0,ApiUtil/* getUserListLineItems */.ZV)(maxVersionLists);
    return [
        listItems,
        maxVersionLists
    ];
});
const getMyAccountLists = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountLists", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.FAVORITES_LIST_END_POINT, "?lang=").concat(locale, "&limit=").concat(constants.FAVORITES_LIST_LIMIT));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    return (0,ApiUtil/* getMaxVersionLists */.Lp)(results, locale);
});
const getListFirstLineItemsData = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getListFirstLineItemsData", async function(list) {
    let allItems = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { lineItems =[]  } = list;
    if (lineItems.length) {
        var ref, ref1, ref2, ref3;
        const config = await (0,constants_config/* getConfig */.i)();
        const productId = (ref = lineItems[0]) === null || ref === void 0 ? void 0 : ref.productId;
        const productIds = lineItems.map((item)=>item.productId);
        const persona = (0,helper/* getUserPersona */.shu)();
        const fl = (0,helper/* getProductFlgs */.Ezx)(persona);
        var ref4;
        const language = (ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.internationalization) === null || ref1 === void 0 ? void 0 : ref1.language) !== null && ref4 !== void 0 ? ref4 : "en";
        const res = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                q: "*:*",
                fq: 'ctId_s:("'.concat(allItems ? productIds.join('","') : productId, '") && language_s:("').concat(language, '")'),
                rows: allItems ? productIds === null || productIds === void 0 ? void 0 : productIds.length : constants.FAVORITES_LIST_LIMIT,
                fl: fl.join(","),
                collections: "kohler",
                profilename: "profile_kohler_Full_Catalog"
            }
        });
        var ref5;
        const productData = (ref5 = (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.docs) !== null && ref5 !== void 0 ? ref5 : [];
        return productData;
    }
});
const getSharedListProductData = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getSharedListProductData", async (skus)=>{
    var ref, ref1, ref2;
    const config = await (0,constants_config/* getConfig */.i)();
    const persona = (0,helper/* getUserPersona */.shu)();
    const fl = (0,helper/* getProductFlgs */.Ezx)(persona);
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    const res = await api/* apim.get */.TH.get("/search/plp", {
        params: {
            q: "*:*",
            fq: 'sku_s:("'.concat(skus.join('","'), '") && language_s:("').concat(language, '")'),
            rows: skus ? skus === null || skus === void 0 ? void 0 : skus.length : constants.FAVORITES_LIST_LIMIT,
            fl: fl.join(","),
            collections: "kohler",
            profilename: "profile_kohler_Full_Catalog"
        }
    });
    var ref4;
    const productData = (ref4 = (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs) !== null && ref4 !== void 0 ? ref4 : [];
    return productData;
});
const getMyAccountFavorites = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountFavorites", async (query)=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.favoritesEndPoint, "?lang=").concat(locale));
    const { results  } = response.data;
    if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
        const getVersion = Math.max(...results.map((i)=>i.version));
        const d = results.filter((i)=>i.name[locale] === "Favorites" && i.version === getVersion)[0];
        if (d) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { lineItems =[] , textLineItems =[]  } = d;
            const productIds = lineItems.map((item)=>item.productId);
            const persona = (0,helper/* getUserPersona */.shu)();
            const fl = [
                "masterSKU_s",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "ProductBrandName_s",
                "metaTitle_s",
                "productName_s",
                "id",
                "productImages.url_ss",
                "slug_s",
                "Product_Category",
                "displayPriceStartingAt_s",
                "Tile_Title",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.SKU.Details_ss",
                "productImages.labelWithUrl_ss",
                "variantList.sku_ss",
                "RegionBrandName_s",
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".price_d"),
                "Color.".concat(persona, ".Details_ss"),
                "ctId_s",
                "Brand_ss",
                "Country_ss"
            ];
            var ref6;
            const language = (ref6 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref6 !== void 0 ? ref6 : "en";
            var ref7;
            const canadianPrice = (ref7 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            const params = {
                q: "*:*",
                fq: 'ctId_s:("'.concat(productIds.join('","'), '") && language_s:("').concat(language, '")'),
                fl: fl.join(","),
                collections: (ref8 = config === null || config === void 0 ? void 0 : (ref3 = config.general) === null || ref3 === void 0 ? void 0 : ref3.siteName) !== null && ref8 !== void 0 ? ref8 : "Kohler",
                start: 0,
                rows: 50
            };
            // Conditionally add `canadianPrice` if it has a value
            if (canadianPrice) {
                params.CanadianPrice = canadianPrice;
            }
            const res = await api/* apim.get */.TH.get(routes/* SEARCH_FULL_CATALOG */.r5, {
                params
            });
            var ref9;
            const productData = (ref9 = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.docs) !== null && ref9 !== void 0 ? ref9 : [];
            if (productData.length > 0) {
                lineItems.forEach((item, index, items)=>{
                    const product = productData.find((product)=>{
                        return product["ctId_s"] === (item === null || item === void 0 ? void 0 : item.productId);
                    });
                    items[index].productData = product;
                });
            }
            let sortLineItems = [];
            if (lineItems.length > 0) {
                sortLineItems = lineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            let sortTextLineItems = [];
            if (textLineItems.length > 0) {
                sortTextLineItems = textLineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            return {
                sortProducts: sortLineItems !== null && sortLineItems !== void 0 ? sortLineItems : [],
                sortMedia: sortTextLineItems !== null && sortTextLineItems !== void 0 ? sortTextLineItems : [],
                d
            };
        } else {
            await store/* store.dispatch */.h.dispatch(createFavorite());
        }
    }
    return null;
});
const createFavorite = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("createFavorite", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
        name: {
            [locale]: shoppingListName
        }
    });
    var _data;
    return (_data = response.data) !== null && _data !== void 0 ? _data : {};
});
const getProductBySlug = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("list/getProductBySlug", async (payload)=>{
    const { listProductSkus , currencyCode , skuString , persona  } = payload;
    try {
        let responseVariants = [];
        const obj = {};
        const { data: { results =[]  } = {}  } = await api/* apim.get */.TH.get("".concat(routes/* CATALOG_PROJECTION_ENDPOINT */.E5, "?where=masterVariant(sku in ").concat(skuString, ") or variants(sku in ").concat(skuString, ")"));
        results.forEach((item)=>{
            responseVariants.push(item === null || item === void 0 ? void 0 : item.masterVariant);
            responseVariants = [
                ...responseVariants,
                ...Array.isArray(item === null || item === void 0 ? void 0 : item.variants) ? item.variants : []
            ];
        });
        listProductSkus.forEach((sku)=>{
            const product = responseVariants.find((variant)=>variant.sku === sku);
            if (product) {
                var ref, ref1, ref2;
                const fixedPromo = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find((price)=>{
                    var ref, ref1, ref2, ref3, ref4;
                    return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona && ((ref3 = price.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.fixedPrice);
                });
                const productPrice = product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1.find((price)=>{
                    var ref, ref1, ref2;
                    return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                });
                let priceObj = fixedPromo || productPrice;
                if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) {
                    var ref3;
                    priceObj = product === null || product === void 0 ? void 0 : (ref3 = product.prices) === null || ref3 === void 0 ? void 0 : ref3.find((price)=>{
                        var ref;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                    });
                }
                if ((priceObj === null || priceObj === void 0 ? void 0 : priceObj.discounted) && currencyCode !== "CAD") {
                    var ref4, ref5, ref6;
                    var ref7;
                    obj[sku] = Number((((ref7 = priceObj === null || priceObj === void 0 ? void 0 : (ref4 = priceObj.discounted) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.centAmount) !== null && ref7 !== void 0 ? ref7 : 0) / 100).toFixed(2));
                    var ref8;
                    obj["".concat(sku, "-discount")] = Number((((ref8 = priceObj === null || priceObj === void 0 ? void 0 : (ref6 = priceObj.value) === null || ref6 === void 0 ? void 0 : ref6.centAmount) !== null && ref8 !== void 0 ? ref8 : 0) / 100).toFixed(2));
                } else {
                    var ref9;
                    var ref10;
                    obj[sku] = Number((((ref10 = priceObj === null || priceObj === void 0 ? void 0 : (ref9 = priceObj.value) === null || ref9 === void 0 ? void 0 : ref9.centAmount) !== null && ref10 !== void 0 ? ref10 : 0) / 100).toFixed(2));
                }
                const listPrice = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : ref2.find((price)=>{
                    var ref;
                    return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                });
                if (listPrice) {
                    var ref11;
                    var ref12;
                    obj["".concat(sku, "-listPrice")] = Number((((ref12 = listPrice === null || listPrice === void 0 ? void 0 : (ref11 = listPrice.value) === null || ref11 === void 0 ? void 0 : ref11.centAmount) !== null && ref12 !== void 0 ? ref12 : 0) / 100).toFixed(2));
                }
                const regionIsBackorderable = "".concat(sku, "-RegionIsBackorderable");
                const comboSku = "".concat(sku, "-ComboSKU");
                const requiredAccessories = "".concat(sku, "-RequiredAccessories");
                const regionIsBackorderableRec = product === null || product === void 0 ? void 0 : product.attributes.find((rec)=>rec.name === "RegionIsBackorderable");
                const comboSkuRec = product === null || product === void 0 ? void 0 : product.attributes.find((rec)=>rec.name === "ComboSKU");
                const requiredAccessoriesRec = product === null || product === void 0 ? void 0 : product.attributes.find((rec)=>rec.name === "ProductRequiredAccessoryGroup");
                obj[regionIsBackorderable] = regionIsBackorderableRec && (regionIsBackorderableRec === null || regionIsBackorderableRec === void 0 ? void 0 : regionIsBackorderableRec.name) === "RegionIsBackorderable" ? regionIsBackorderableRec === null || regionIsBackorderableRec === void 0 ? void 0 : regionIsBackorderableRec.value : false;
                if (requiredAccessoriesRec && (requiredAccessoriesRec === null || requiredAccessoriesRec === void 0 ? void 0 : requiredAccessoriesRec.name) === "ProductRequiredAccessoryGroup") {
                    var ref13;
                    obj[requiredAccessories] = (ref13 = requiredAccessoriesRec === null || requiredAccessoriesRec === void 0 ? void 0 : requiredAccessoriesRec.value) !== null && ref13 !== void 0 ? ref13 : [];
                    const cstomerFacingSKURec = product === null || product === void 0 ? void 0 : product.attributes.find((rec)=>rec.name === "CustomerFacingSKU");
                    if (cstomerFacingSKURec && (cstomerFacingSKURec === null || cstomerFacingSKURec === void 0 ? void 0 : cstomerFacingSKURec.name) === "CustomerFacingSKU") {
                        var ref14;
                        obj["".concat(sku, "-customerFacingSKU")] = (ref14 = cstomerFacingSKURec === null || cstomerFacingSKURec === void 0 ? void 0 : cstomerFacingSKURec.value) !== null && ref14 !== void 0 ? ref14 : "";
                    }
                } else {
                    obj[requiredAccessories] = [];
                }
                obj[comboSku] = !!comboSkuRec;
            } else {
                obj[sku] = 0;
                obj["".concat(sku, "-RegionIsBackorderable")] = false;
                obj["".concat(sku, "-ComboSKU")] = false;
                obj["".concat(sku, "-RequiredAccessories")] = [];
            }
        });
        return obj;
    } catch (err) {
        return err;
    }
});
const addListLineItemQuantity = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addListLineItemQuantity", async (data)=>{
    const { listId , version , productId , lineItemId , quantity , variantId , action  } = data;
    const actionObject = {
        action: "addLineItem",
        productId: productId,
        variantId: variantId,
        quantity: quantity,
        custom: {
            type: {
                key: "lineItemShoppingList",
                typeId: "type"
            }
        }
    };
    if (action === "subtract") {
        actionObject.action = "removeLineItem";
        actionObject.lineItemId = lineItemId;
    }
    const body = {
        version,
        actions: [
            actionObject
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    return response === null || response === void 0 ? void 0 : response.data;
});
const moveItemsFromList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("moveItemsFromList", async (data)=>{
    const { list , listData , currentList , productData , selectedItems , productQtyObj  } = data;
    let listId;
    let version;
    if ((list === null || list === void 0 ? void 0 : list.id) && (list === null || list === void 0 ? void 0 : list.version)) {
        listId = list === null || list === void 0 ? void 0 : list.id;
        version = list === null || list === void 0 ? void 0 : list.version;
    } else {
        var ref, ref1;
        const config = await (0,constants_config/* getConfig */.i)();
        const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
        const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
        var ref2;
        const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
            name: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.name
            },
            project: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.project
            },
            description: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.description
            },
            custom: {
                type: {
                    key: "shoppingList"
                },
                fields: {
                    project: (ref2 = listData === null || listData === void 0 ? void 0 : listData.project) !== null && ref2 !== void 0 ? ref2 : ""
                }
            }
        });
        var ref3;
        listId = (ref3 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "";
        var ref4;
        version = (ref4 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.version) !== null && ref4 !== void 0 ? ref4 : "";
    }
    const formattedData = (0,ApiUtil/* getMovieToListAndDeleteFormListItems */.mK)(selectedItems, currentList, productData, productQtyObj);
    const deleteResponse = await api/* apim.post */.TH.post("".concat(constants.USER_LIST_PRODUCT_DELETE_POINT, "/").concat(currentList === null || currentList === void 0 ? void 0 : currentList.id), {
        version: currentList === null || currentList === void 0 ? void 0 : currentList.version,
        actions: formattedData[0]
    });
    const body = {
        version,
        actions: formattedData[1]
    };
    const addResponse = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    return {
        deleteResponse: deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.data,
        addResponse: addResponse === null || addResponse === void 0 ? void 0 : addResponse.data
    };
});
const deleteMultiProductFromList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("deleteMultiProductFromList", async (data)=>{
    const { list , selectedItems  } = data;
    const payload = (0,ApiUtil/* getMultiDeleteItemsPayLoad */._z)(list, selectedItems);
    const deleteResponse = await api/* apim.post */.TH.post("".concat(constants.USER_LIST_PRODUCT_DELETE_POINT, "/").concat(list === null || list === void 0 ? void 0 : list.id), {
        version: list === null || list === void 0 ? void 0 : list.version,
        actions: payload
    });
    return deleteResponse;
});
const addProductToList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addProductToList", async (data)=>{
    const { sku , list , listData , createList  } = data;
    let listId;
    let version;
    if ((list === null || list === void 0 ? void 0 : list.id) && (list === null || list === void 0 ? void 0 : list.version)) {
        listId = list === null || list === void 0 ? void 0 : list.id;
        version = list === null || list === void 0 ? void 0 : list.version;
    } else {
        var ref, ref1;
        const config = await (0,constants_config/* getConfig */.i)();
        const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
        const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
        var ref2;
        const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
            name: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.name
            },
            project: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.project
            },
            description: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.description
            },
            custom: {
                type: {
                    key: "shoppingList"
                },
                fields: {
                    project: (ref2 = listData === null || listData === void 0 ? void 0 : listData.project) !== null && ref2 !== void 0 ? ref2 : ""
                }
            }
        });
        var ref3;
        listId = (ref3 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "";
        var ref4;
        version = (ref4 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.version) !== null && ref4 !== void 0 ? ref4 : "";
        if (createList) {
            return response === null || response === void 0 ? void 0 : response.data;
        }
    }
    const actionsArray = [];
    let addingType = "product";
    if (Array.isArray(sku)) {
        addingType = "others";
        sku.forEach((item)=>{
            actionsArray.push({
                action: "addLineItem",
                sku: item,
                custom: {
                    type: {
                        key: "lineItemShoppingList",
                        typeId: "type"
                    }
                }
            });
        });
    } else {
        actionsArray.push({
            action: "addLineItem",
            sku,
            custom: {
                type: {
                    key: "lineItemShoppingList",
                    typeId: "type"
                }
            }
        });
    }
    const body = {
        version,
        actions: actionsArray
    };
    const response1 = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, addingType)), body);
    await store/* store.dispatch */.h.dispatch(getMyAccountListsWithLineItems());
    return response1 === null || response1 === void 0 ? void 0 : response1.data;
});
const editList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("editList", async (data)=>{
    const { list , listData ={}  } = data;
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    let listId;
    let version;
    if ((list === null || list === void 0 ? void 0 : list.id) && (list === null || list === void 0 ? void 0 : list.version)) {
        listId = list === null || list === void 0 ? void 0 : list.id;
        version = list === null || list === void 0 ? void 0 : list.version;
    }
    const body = {
        version,
        actions: [
            {
                action: "changeName",
                name: {
                    [locale]: listData === null || listData === void 0 ? void 0 : listData.name
                }
            },
            {
                action: "setDescription",
                description: {
                    [locale]: listData === null || listData === void 0 ? void 0 : listData.description
                }
            },
            {
                action: "setCustomType",
                type: {
                    key: "shoppingList"
                },
                fields: {
                    project: listData === null || listData === void 0 ? void 0 : listData.project
                }
            }
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    return response === null || response === void 0 ? void 0 : response.data;
});
const addProduct = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addProduct", async (sku, thunkAPI)=>{
    await store/* store.dispatch */.h.dispatch(getFavorites());
    const state = thunkAPI.getState();
    let id;
    let version;
    let favorites;
    const isPdp = window.eventPageType === "pdp";
    if ((state === null || state === void 0 ? void 0 : state.favorites.favorites) !== undefined && Object.keys(state === null || state === void 0 ? void 0 : state.favorites.favorites).length > 0) {
        var ref;
        favorites = state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites;
        id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
        version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
    } else {
        const favoritesMain = await store/* store.dispatch */.h.dispatch(createFavorite());
        favorites = favoritesMain === null || favoritesMain === void 0 ? void 0 : favoritesMain.payload;
        id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
        version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
    }
    const body = {
        version,
        actions: [
            {
                action: "addLineItem",
                sku,
                custom: {
                    type: {
                        key: "lineItemShoppingList",
                        typeId: "type"
                    }
                }
            }
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(id, "product")), body);
    if (isPdp && response.data) {
        var _internalLinkType, _zoneName;
        addDataLayerFav("", true, "add", (_internalLinkType = window.internalLinkType) !== null && _internalLinkType !== void 0 ? _internalLinkType : "", (_zoneName = window.zoneName) !== null && _zoneName !== void 0 ? _zoneName : "", "", "");
    }
    return response.data;
});
const removeItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("removeItems", async (ids, thunkAPI)=>{
    let isDataLayerNeeded = true;
    let imageName = "";
    let section = "";
    if (!Array.isArray(ids)) {
        isDataLayerNeeded = ids === null || ids === void 0 ? void 0 : ids.isDataLayerNeeded;
        imageName = ids === null || ids === void 0 ? void 0 : ids.imageName;
        section = ids === null || ids === void 0 ? void 0 : ids.section;
        ids = ids.ids;
    }
    try {
        const state = thunkAPI.getState();
        const { id , version , lineItems  } = (state === null || state === void 0 ? void 0 : state.favorites.favorites) || {};
        if (id) {
            const actions = ids.map((pid)=>{
                if (lineItems.find((el)=>el.id === pid)) {
                    return {
                        action: "removeLineItem",
                        lineItemId: pid
                    };
                } else {
                    return {
                        action: "removeTextLineItem",
                        textLineItemId: pid
                    };
                }
            });
            const response = await api/* apim.post */.TH.post("".concat((0,constants.removeFavoritesEndPoint)(id)), {
                version,
                actions
            });
            var _internalLinkType;
            isDataLayerNeeded && addDataLayerFav("", true, "remove", (_internalLinkType = window.internalLinkType) !== null && _internalLinkType !== void 0 ? _internalLinkType : "", section !== null && section !== void 0 ? section : "", "", "", imageName);
            return response.data;
        }
        return {};
    } catch (error) {
        var _internalLinkType1, _zoneName;
        isDataLayerNeeded && addDataLayerFav("", false, "remove", (_internalLinkType1 = window.internalLinkType) !== null && _internalLinkType1 !== void 0 ? _internalLinkType1 : "", (_zoneName = window.zoneName) !== null && _zoneName !== void 0 ? _zoneName : "", "", "");
    }
});
const myAccountRemoveItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("myAccountRemoveItems", async (ids, thunkAPI)=>{
    var ref, ref1;
    const state = thunkAPI.getState();
    const { id , version , lineItems  } = (state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : (ref1 = ref.fullFavoriteData) === null || ref1 === void 0 ? void 0 : ref1.d) || {};
    if (id) {
        const actions = ids.map((pid)=>{
            if (lineItems.find((el)=>el.id === pid)) {
                return {
                    action: "removeLineItem",
                    lineItemId: pid
                };
            } else {
                return {
                    action: "removeTextLineItem",
                    textLineItemId: pid
                };
            }
        });
        const response = await api/* apim.post */.TH.post("".concat((0,constants.removeFavoritesEndPoint)(id)), {
            version,
            actions
        });
        if (response === null || response === void 0 ? void 0 : response.data) {
            var ref2, ref3, ref4, ref5;
            const { lineItems: lineItems1 = [] , textLineItems =[]  } = (response === null || response === void 0 ? void 0 : response.data) || {};
            const productIds = lineItems1.map((item)=>item.productId);
            const persona = (0,helper/* getUserPersona */.shu)();
            const fl = [
                "masterSKU_s",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "ProductBrandName_s",
                "metaTitle_s",
                "productName_s",
                "id",
                "productImages.url_ss",
                "slug_s",
                "Product_Category",
                "displayPriceStartingAt_s",
                "Tile_Title",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.SKU.Details_ss",
                "productImages.labelWithUrl_ss",
                "variantList.sku_ss",
                "RegionBrandName_s",
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".price_d"),
                "Color.".concat(persona, ".Details_ss"),
                "ctId_s",
                "Brand_ss",
                "Country_ss"
            ];
            const config = await (0,constants_config/* getConfig */.i)();
            var ref6;
            const language = (ref6 = config === null || config === void 0 ? void 0 : (ref2 = config.internationalization) === null || ref2 === void 0 ? void 0 : ref2.language) !== null && ref6 !== void 0 ? ref6 : "en";
            var ref7;
            const res = await api/* apim.get */.TH.get("/search/full-catalog", {
                params: {
                    q: "*:*",
                    fq: 'ctId_s:("'.concat(productIds.join('","'), '") && language_s:("').concat(language, '")'),
                    fl: fl.join(","),
                    collections: (ref7 = config === null || config === void 0 ? void 0 : (ref3 = config.general) === null || ref3 === void 0 ? void 0 : ref3.siteName) !== null && ref7 !== void 0 ? ref7 : "Kohler",
                    start: 0,
                    rows: 50
                }
            });
            var ref8;
            const productData = (ref8 = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.docs) !== null && ref8 !== void 0 ? ref8 : [];
            if (productData.length > 0) {
                lineItems1.forEach((item, index, items)=>{
                    const product = productData.find((product)=>{
                        return product["ctId_s"] === (item === null || item === void 0 ? void 0 : item.productId);
                    });
                    items[index].productData = product;
                });
            }
            let sortLineItems = [];
            if (lineItems1.length > 0) {
                sortLineItems = lineItems1.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            let sortTextLineItems = [];
            if (textLineItems.length > 0) {
                sortTextLineItems = textLineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            var ref9;
            return {
                sortProducts: sortLineItems !== null && sortLineItems !== void 0 ? sortLineItems : [],
                sortMedia: sortTextLineItems !== null && sortTextLineItems !== void 0 ? sortTextLineItems : [],
                d: (ref9 = response === null || response === void 0 ? void 0 : response.data) !== null && ref9 !== void 0 ? ref9 : {}
            };
        }
    }
    return {};
});
const addMedia = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addMedia", async (params, thunkAPI)=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const { type ="" , name ="" , url ="" , description ="" , articleType ="" , thumbnail ="" , needDataLayerToAdd =true , caption ="" , section ="" , videoName ="" , videoId ="" , errorMessage ="" , successMsg ="" , successCallback =()=>{} , errorCallback =()=>{} , imageName =""  } = params;
    try {
        var ref, ref1, ref2;
        const state = thunkAPI.getState();
        let id;
        let version;
        const fav = await store/* store.dispatch */.h.dispatch(getFavorites());
        let favorites = ((ref1 = Object.keys(state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites)) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? state === null || state === void 0 ? void 0 : (ref2 = state.favorites) === null || ref2 === void 0 ? void 0 : ref2.favorites : fav === null || fav === void 0 ? void 0 : fav.payload;
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.id) && (favorites === null || favorites === void 0 ? void 0 : favorites.version)) {
            id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
            version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
        } else {
            const favoritesMain = await store/* store.dispatch */.h.dispatch(createFavorite());
            favorites = favoritesMain === null || favoritesMain === void 0 ? void 0 : favoritesMain.payload;
            id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
            version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
        }
        const body = {
            version: version,
            actions: [
                {
                    action: "addTextLineItem",
                    name: {
                        [locale]: name || videoName || ""
                    },
                    description: {
                        [locale]: description
                    },
                    custom: {
                        type: {
                            key: "textLineItemShoppingList",
                            typeId: "type"
                        },
                        fields: {
                            itemType: type,
                            link: url,
                            thumbnail,
                            articleType
                        }
                    }
                }
            ]
        };
        const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(id, type)), body);
        const { textLineItems =[]  } = response.data;
        if (textLineItems.length > 0) {
            (0,helper/* checkIsFavorite */.GsT)(textLineItems);
            successCallback();
        }
        var _internalLinkType;
        if (needDataLayerToAdd) addDataLayerFav(successMsg, true, "add", (_internalLinkType = window.internalLinkType) !== null && _internalLinkType !== void 0 ? _internalLinkType : caption, section, videoName, videoId, imageName);
        return response.data;
    } catch (error) {
        if (needDataLayerToAdd) addDataLayerFav(errorMessage, false, "add", caption, section, videoName, videoId);
        errorCallback();
    }
});
const favoritesSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "favorites",
    initialState,
    reducers: {
        setFavorites (state, action) {
            state.favorites = action.payload;
        },
        setLoginFavouriteCallback (state, action) {
            state.isLoginFavouriteCallback = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            es6/* HYDRATE */.ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.favorites
            };
        }).addCase(getFavorites.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getFavorites.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(getFavorites.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getMyAccountListsWithLineItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getMyAccountListsWithLineItems.fulfilled, (state, action)=>{
            state.saveToListLineItems = action.payload[0][0];
            state.userListItemsSkus = action.payload[0][1];
            state.userLists = action.payload[1];
            state.status = "succeeded";
        }).addCase(getMyAccountListsWithLineItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getMyAccountFavorites.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getMyAccountFavorites.fulfilled, (state, action)=>{
            state.fullFavoriteData = action.payload;
            state.status = "succeeded";
        }).addCase(getMyAccountFavorites.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(myAccountRemoveItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(myAccountRemoveItems.fulfilled, (state, action)=>{
            state.fullFavoriteData = action.payload;
            state.status = "succeeded";
        }).addCase(myAccountRemoveItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addProduct.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addProduct.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(addProduct.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createFavorite.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createFavorite.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(createFavorite.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addMedia.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addMedia.fulfilled, (state, action)=>{
            state.favorites = {
                ...state.favorites,
                ...action.payload
            };
            state.status = "succeeded";
        }).addCase(addMedia.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(removeItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(removeItems.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(removeItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setFavorites , setLoginFavouriteCallback  } = favoritesSlice.actions;
const selectFavoritesState = (state)=>state.favorites;
/* harmony default export */ var features_favoritesSlice = (favoritesSlice.reducer);


/***/ }),

/***/ 88751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ hideAppointmentModal; },
/* harmony export */   "AT": function() { return /* binding */ setAuthNav; },
/* harmony export */   "Ai": function() { return /* binding */ getProfile; },
/* harmony export */   "BL": function() { return /* binding */ setPlaceOrderLoading; },
/* harmony export */   "C1": function() { return /* binding */ getCardType; },
/* harmony export */   "CF": function() { return /* binding */ showToast; },
/* harmony export */   "DE": function() { return /* binding */ setAnalyticsScript; },
/* harmony export */   "Dz": function() { return /* binding */ getBusinessList; },
/* harmony export */   "F$": function() { return /* binding */ setFeatureFlagsFeature; },
/* harmony export */   "FE": function() { return /* binding */ setPageObject; },
/* harmony export */   "FV": function() { return /* binding */ setSitewideWarningContent; },
/* harmony export */   "Fu": function() { return /* binding */ getCheckoutErrorList; },
/* harmony export */   "GL": function() { return /* binding */ getplaceOfPurchaseList; },
/* harmony export */   "Ix": function() { return /* binding */ uploadImage; },
/* harmony export */   "JN": function() { return /* binding */ genericSlice; },
/* harmony export */   "J_": function() { return /* binding */ setConsolidatedZipCodes; },
/* harmony export */   "Ji": function() { return /* binding */ setToastContent; },
/* harmony export */   "Jp": function() { return /* binding */ getCountryList; },
/* harmony export */   "K4": function() { return /* binding */ setLoading; },
/* harmony export */   "Ln": function() { return /* binding */ getGenericListPath; },
/* harmony export */   "PE": function() { return /* binding */ hideToast; },
/* harmony export */   "Px": function() { return /* binding */ selectGenericState; },
/* harmony export */   "Qb": function() { return /* binding */ setGlobalConfig; },
/* harmony export */   "RS": function() { return /* binding */ showFindingModelPopup; },
/* harmony export */   "Ro": function() { return /* binding */ removeAddress; },
/* harmony export */   "SX": function() { return /* binding */ getOrderStatus; },
/* harmony export */   "T8": function() { return /* binding */ getAuthMenuFragment; },
/* harmony export */   "UD": function() { return /* binding */ mapStateToCountry; },
/* harmony export */   "Wj": function() { return /* binding */ closeMenu; },
/* harmony export */   "Wv": function() { return /* binding */ showPromoModal; },
/* harmony export */   "X7": function() { return /* binding */ setActiveMainCategory; },
/* harmony export */   "XY": function() { return /* binding */ setBrandLogoImg; },
/* harmony export */   "Yb": function() { return /* binding */ editAddress; },
/* harmony export */   "Ys": function() { return /* binding */ setPageIsIntercative; },
/* harmony export */   "_4": function() { return /* binding */ setShowHalfCompare; },
/* harmony export */   "_K": function() { return /* binding */ setDefaultAddress; },
/* harmony export */   "_W": function() { return /* binding */ hideFindingModelPopup; },
/* harmony export */   "_r": function() { return /* binding */ setSitewideNewsLetterContent; },
/* harmony export */   "a5": function() { return /* binding */ getStoreCountriesList; },
/* harmony export */   "bC": function() { return /* binding */ getAccountBusinessList; },
/* harmony export */   "c0": function() { return /* binding */ resetPassword; },
/* harmony export */   "cw": function() { return /* binding */ setGlobalStyles; },
/* harmony export */   "dN": function() { return /* binding */ setDatalayerPageName; },
/* harmony export */   "e6": function() { return /* binding */ setPreviewCartInit; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "go": function() { return /* binding */ getLegalPageLinks; },
/* harmony export */   "jy": function() { return /* binding */ toggleSiteWideWarning; },
/* harmony export */   "kY": function() { return /* binding */ showAppointmentModal; },
/* harmony export */   "ks": function() { return /* binding */ setGbhDataLayerCustom; },
/* harmony export */   "lK": function() { return /* binding */ getstateList; },
/* harmony export */   "m8": function() { return /* binding */ getCommonList; },
/* harmony export */   "ml": function() { return /* binding */ setSubscribeModalContent; },
/* harmony export */   "n8": function() { return /* binding */ setGlobalScripts; },
/* harmony export */   "p1": function() { return /* binding */ setShowFullCompare; },
/* harmony export */   "qX": function() { return /* binding */ setRegionNav; },
/* harmony export */   "qn": function() { return /* binding */ openMenu; },
/* harmony export */   "rA": function() { return /* binding */ setCompareproductsStaticText; },
/* harmony export */   "s2": function() { return /* binding */ editProfile; },
/* harmony export */   "sZ": function() { return /* binding */ setDataLayerObj; },
/* harmony export */   "su": function() { return /* binding */ setAuthorData; },
/* harmony export */   "t8": function() { return /* binding */ zipDownload; },
/* harmony export */   "tK": function() { return /* binding */ searchPlp; },
/* harmony export */   "tm": function() { return /* binding */ deleteAccount; },
/* harmony export */   "wA": function() { return /* binding */ setGatedContentData; },
/* harmony export */   "x": function() { return /* binding */ hidePreviewCart; },
/* harmony export */   "y$": function() { return /* binding */ addAddress; },
/* harmony export */   "z0": function() { return /* binding */ showPreviewCart; },
/* harmony export */   "zF": function() { return /* binding */ getTrackingList; }
/* harmony export */ });
/* unused harmony exports getOccupationList, setSitewideWarningRendered, setAnalyticsScripts, setCompareExpiry, clearAllCompareProducts, setUpsellInstallationServiceData */
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28858);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77236);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88032);










const initialState = {
    isLoading: false,
    datalayerPageName: "",
    eventPageType: "",
    accountTypeListPath: "",
    businessListPath: "",
    countryListPath: "",
    occupationListPath: "",
    commonListPath: "",
    trackingListPath: "",
    stateListPath: "",
    cardTypesPath: "",
    storeCountryListPath: "",
    placeOfPurchaseListPath: "",
    accountTypeList: [],
    businessList: [],
    checkoutErrorList: [],
    checkoutErrorsPath: "",
    legalPageLinks: {},
    countryList: [],
    stateList: [],
    stateToCountryList: [],
    placeOfPurchaseList: [],
    cardType: "",
    userMenuFragment: "",
    guestMenuFragment: "",
    status: "",
    error: "",
    subscribeModal: {
        show: false,
        modalContent: {},
        active: 0
    },
    siteWideWarning: {
        isRendered: false
    },
    newslettersignup: {},
    compareproducts: {},
    profile: "",
    brandLogoImg: "",
    globalScripts: [],
    dataLayerObj: "",
    analyticsScript: "",
    globalStyles: [],
    globalConfig: {},
    authorData: {},
    toaster: {
        message: "",
        isVisible: false,
        content: {}
    },
    menu: {
        isOpen: false,
        mainCategoryActive: "",
        isRegionOpen: false,
        isAuthNavOpen: false
    },
    pageIsInteractive: false,
    previewCart: {
        showPreview: false
    },
    promoBannerModal: {
        show: false,
        modalContent: {
            banner: {},
            item: {},
            count: 0
        }
    },
    enableSiteWideWarning: false,
    FindingModelModal: {
        show: false,
        modalContent: {}
    },
    associateMembershipModal: {
        show: false,
        isRetired: false,
        modalContent: {}
    },
    showHalfCompare: false,
    showFullCompare: false,
    isProductInfo: false,
    isPreviewCartInit: false,
    consolidatedZipCodes: [],
    upsellInstallationServiceAuthData: {},
    isShowAppointmentModal: false,
    bpNumber: null,
    gatedContentData: {},
    featureFlags: {},
    isPlaceOrderLoading: false
};
const getGenericListPath = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getGenericListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    const state = thunkAPI.getState();
    var ref11;
    const accountTypeListPath = (ref11 = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.accountTypeListPath) !== null && ref11 !== void 0 ? ref11 : "";
    var ref12;
    const businessListPath = (ref12 = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.businessListPath) !== null && ref12 !== void 0 ? ref12 : "";
    var ref13;
    const countryListPath = (ref13 = state === null || state === void 0 ? void 0 : (ref2 = state.generic) === null || ref2 === void 0 ? void 0 : ref2.countryListPath) !== null && ref13 !== void 0 ? ref13 : "";
    var ref14;
    const occupationListPath = (ref14 = state === null || state === void 0 ? void 0 : (ref3 = state.generic) === null || ref3 === void 0 ? void 0 : ref3.occupationListPath) !== null && ref14 !== void 0 ? ref14 : "";
    var ref15;
    const commonListPath = (ref15 = state === null || state === void 0 ? void 0 : (ref4 = state.generic) === null || ref4 === void 0 ? void 0 : ref4.commonListPath) !== null && ref15 !== void 0 ? ref15 : "";
    var ref16;
    const trackingListPath = (ref16 = state === null || state === void 0 ? void 0 : (ref5 = state.generic) === null || ref5 === void 0 ? void 0 : ref5.trackingListPath) !== null && ref16 !== void 0 ? ref16 : "";
    var ref17;
    const stateListPath = (ref17 = state === null || state === void 0 ? void 0 : (ref6 = state.generic) === null || ref6 === void 0 ? void 0 : ref6.stateListPath) !== null && ref17 !== void 0 ? ref17 : "";
    var ref18;
    const cardTypesPath = (ref18 = state === null || state === void 0 ? void 0 : (ref7 = state.generic) === null || ref7 === void 0 ? void 0 : ref7.cardTypesPath) !== null && ref18 !== void 0 ? ref18 : "";
    var ref19;
    const placeOfPurchaseListPath = (ref19 = state === null || state === void 0 ? void 0 : (ref8 = state.generic) === null || ref8 === void 0 ? void 0 : ref8.placeOfPurchaseListPath) !== null && ref19 !== void 0 ? ref19 : "";
    var ref20;
    const storeCountryListPath = (ref20 = state === null || state === void 0 ? void 0 : (ref9 = state.generic) === null || ref9 === void 0 ? void 0 : ref9.placeOfPurchaseListPath) !== null && ref20 !== void 0 ? ref20 : "";
    var ref21;
    const checkoutErrorsPath = (ref21 = state === null || state === void 0 ? void 0 : (ref10 = state.generic) === null || ref10 === void 0 ? void 0 : ref10.checkoutErrorsPath) !== null && ref21 !== void 0 ? ref21 : "";
    let data = {};
    if (accountTypeListPath || businessListPath || countryListPath || occupationListPath || commonListPath || trackingListPath || stateListPath || cardTypesPath || checkoutErrorsPath || placeOfPurchaseListPath || storeCountryListPath && !reload) {
        data = {
            accountTypeList: accountTypeListPath,
            businessList: businessListPath,
            countryList: countryListPath,
            occupationList: occupationListPath,
            commonList: commonListPath,
            trackingList: trackingListPath,
            stateList: stateListPath,
            cardTypes: cardTypesPath,
            placeOfPurchaseList: placeOfPurchaseListPath,
            storeCountryListPath: storeCountryListPath,
            checkoutErrorList: checkoutErrorsPath
        };
        return data;
    }
    const { general  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    if (general === null || general === void 0 ? void 0 : general.genericListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + (general === null || general === void 0 ? void 0 : general.genericListPath));
        return response.data;
    }
    return data;
});
const getCardType = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/cardTypesPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const cardTypesPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.cardTypesPath;
    if (cardTypesPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + cardTypesPath);
        return response.data;
    }
    return {};
});
const getOrderStatus = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/orderStatusesPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const orderStatusesPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.orderStatusesPath;
    if (orderStatusesPath) {
        const { data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + orderStatusesPath);
        return data;
    }
    return {};
});
const getTrackingList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/trackingListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const trackingListPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.trackingListPath;
    if (trackingListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + trackingListPath);
        return response.data;
    }
    return {};
});
const getBusinessList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getBusinessList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const businessList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.businessList;
    if ((businessList === null || businessList === void 0 ? void 0 : businessList.length) > 0 && !reload) return businessList;
    const businessListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.businessListPath;
    if (businessListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + businessListPath);
        return response.data;
    }
    return [];
});
const getCheckoutErrorList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getCheckoutErrorList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const checkoutErrorList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.checkoutErrorList;
    if ((checkoutErrorList === null || checkoutErrorList === void 0 ? void 0 : checkoutErrorList.length) > 0 && !reload) return checkoutErrorList;
    const checkoutErrorsPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.checkoutErrorsPath;
    if (checkoutErrorsPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + checkoutErrorsPath);
        return response.data;
    }
    return [];
});
const getAccountBusinessList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getAccountBusinessList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const accountTypeList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.accountTypeList;
    if ((accountTypeList === null || accountTypeList === void 0 ? void 0 : accountTypeList.length) > 0 && !reload) return accountTypeList;
    const accountTypeListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.accountTypeListPath;
    if (accountTypeListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + accountTypeListPath);
        return response.data;
    }
    return [];
});
const getLegalPageLinks = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getLegalPageLinks", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const legalPageLinks = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.legalPageLinks;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(legalPageLinks) > 0 && !reload) return legalPageLinks;
    const { general  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    if (general === null || general === void 0 ? void 0 : general.legalPageListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + (general === null || general === void 0 ? void 0 : general.legalPageListPath));
        return response.data;
    }
    return {};
});
const getAuthMenuFragment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getAuthMenuFragment", async function() {
    let { reload =false , path , fragmentName  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    const state = thunkAPI.getState();
    var _fragmentName;
    const fragment = (_fragmentName = state === null || state === void 0 ? void 0 : state.generic[fragmentName]) !== null && _fragmentName !== void 0 ? _fragmentName : "";
    const payload = {};
    if (fragment && !reload) {
        payload[fragmentName] = fragment;
        return payload;
    }
    if (path) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + path);
        var ref;
        payload[fragmentName] = (ref = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(response.data.commonTopics)) !== null && ref !== void 0 ? ref : "";
        return payload;
    }
    return {};
});
const getProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("getprofile", async ()=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GET_PROFILE_ENDPOINT));
    return response.data;
});
const getOccupationList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/occupationListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const occupationList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.occupationList;
    if ((occupationList === null || occupationList === void 0 ? void 0 : occupationList.length) > 0 && !reload) return occupationList;
    const occupationListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.occupationListPath;
    if (occupationListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + occupationListPath);
        return response.data;
    }
    return {};
});
const getCountryList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/countryListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const countryList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.countryList;
    if ((countryList === null || countryList === void 0 ? void 0 : countryList.length) > 0 && !reload) return countryList;
    const countryListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.countryListPath;
    if (countryListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + countryListPath);
        return response.data;
    }
    return {};
});
const getstateList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/stateListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const stateList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.stateList;
    if ((stateList === null || stateList === void 0 ? void 0 : stateList.length) > 0 && !reload) return stateList;
    const stateListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.stateListPath;
    if (stateListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + stateListPath);
        return response.data;
    }
    return {};
});
const getStoreCountriesList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/storeCountryListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const storeCountryList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.storeCountryList;
    if ((storeCountryList === null || storeCountryList === void 0 ? void 0 : storeCountryList.length) > 0 && !reload) return storeCountryList;
    const storeCountryListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.storeCountryListPath;
    if (storeCountryListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + storeCountryListPath);
        return response.data;
    }
    return {};
});
const getplaceOfPurchaseList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/placeOfPurchaseList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const placeOfPurchaseList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.placeOfPurchaseList;
    if ((placeOfPurchaseList === null || placeOfPurchaseList === void 0 ? void 0 : placeOfPurchaseList.length) > 0 && !reload) return placeOfPurchaseList;
    const placeOfPurchaseListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.placeOfPurchaseListPath;
    if (placeOfPurchaseListPath) {
        var ref2;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + placeOfPurchaseListPath);
        return (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.map((purchase)=>purchase.value);
    }
    return {};
});
const zipDownload = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("zipDownload", async (payload)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_4__.ZIP_FILE_DOWNLOAD_ENDPOINT, payload, {
        responseType: "blob"
    });
    return response;
});
const searchPlp = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("search-plp", async (data)=>{
    const { internationalization: { language ="en"  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    try {
        var ref, ref1, ref2;
        const actions = data.actions;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.SEARCH_PLP_ENDPOINT, {
            params: {
                q: "*:*",
                fl: "CustomerFacingBrand_s, RegionOnBackOrder_s",
                fq: [
                    "sku_s:(".concat((ref = actions[0]) === null || ref === void 0 ? void 0 : ref.sku, ")"),
                    'language_s:("'.concat(language, '")')
                ],
                collections: "service_parts",
                profilename: "profile_service_parts_Search"
            },
            paramsSerializer: (params)=>{
                return qs__WEBPACK_IMPORTED_MODULE_9___default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        if (response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs[0]) {
            const newActions = [];
            const newData = {};
            actions.forEach((action)=>{
                action["backorder"] = response.data.response.docs[0]["RegionOnBackOrder_s"] === "Yes";
                action["brand"] = response.data.response.docs[0]["CustomerFacingBrand_s"];
                newActions.push(action);
            });
            newData["actions"] = newActions;
            return _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .addToCart */ .Xq)(newData));
        }
    } catch (e) {
        return _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .addToCart */ .Xq)(data));
    }
});
const getUserProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("getuserprofile", async ()=>{
    let profile = {};
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GET_PROFILE_ENDPOINT));
        if (res && res.data) {
            var ref, ref1, ref2;
            localStorage.setItem("profile-version", res.data.version);
            profile = res.data;
            profile.postalCode = (ref = profile.addresses[0]) === null || ref === void 0 ? void 0 : ref.postalCode;
            const profileAddr = (ref1 = profile.addresses) === null || ref1 === void 0 ? void 0 : ref1.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            });
            profile.profileAddrId = profileAddr.id;
            profile.addresses = (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile.addresses;
            if (profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .arrayMove */ .RpN)(profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        console.log("Failed to get user profile", err);
    }
    return profile;
});
const editProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("editProfile", async (data, thunkAPI)=>{
    let profile = [];
    let actions = [];
    const oktaTokenStorage = JSON.parse(localStorage.getItem("okta-token-storage"));
    const userType = oktaTokenStorage.accessToken.claims.persona[0].split(":")[1];
    if (userType === "TVS") {
        actions = [
            {
                action: "setFirstName",
                firstName: data.firstName
            },
            {
                action: "setLastName",
                lastName: data.lastName
            },
            {
                action: "setCompanyName",
                companyName: data.businessName
            },
            {
                action: "setCustomField",
                name: "businessType",
                value: data.businessType
            },
            {
                action: "setCustomField",
                name: "businessSubType",
                value: data.businessSubType
            },
            {
                action: "changeAddress",
                addressId: data.addressId,
                address: {
                    postalCode: data.businessZipCode,
                    country: "US",
                    custom: {
                        type: {
                            key: "custom-address"
                        },
                        fields: {
                            label: "Profile"
                        }
                    }
                }
            }
        ];
    } else {
        actions = [
            {
                action: "setFirstName",
                firstName: data.firstName
            },
            {
                action: "setLastName",
                lastName: data.lastName
            }
        ];
    }
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.EDIT_PROFILE_ENDPOINT), {
            version: version,
            actions: actions
        });
        if (res) {
            profile = await thunkAPI.dispatch(getUserProfile());
            localStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_4__["default"] === null || _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"] === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN, true);
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("Failed to edit profile", err);
    }
    const { payload: response  } = profile;
    return response;
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("addAddress", async (data)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const payload = Array.isArray(data) ? {
            version: version,
            actions: data
        } : {
            version: version,
            actions: [
                {
                    action: "addAddress",
                    address: data
                }
            ]
        };
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), payload);
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3;
            localStorage.setItem("profile-version", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                var ref4, ref5, ref6;
                var ref7;
                resPayload.addresses = (ref7 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addresses) === null || ref5 === void 0 ? void 0 : ref5.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref7 !== void 0 ? ref7 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to add address", err);
        const { response: { data: { error =""  }  } = {}  } = err;
        return {
            error
        };
    }
    return resPayload;
});
const editAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("editAddress", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "changeAddress",
                    addressId: payload === null || payload === void 0 ? void 0 : payload.id,
                    address: payload === null || payload === void 0 ? void 0 : payload.addr
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2;
            localStorage.setItem("profile-version", res.data.version);
            if ((res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.addresses) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                var ref3, ref4, ref5;
                var ref6;
                resPayload.addresses = (ref6 = res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addresses) === null || ref4 === void 0 ? void 0 : ref4.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref6 !== void 0 ? ref6 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to edit address", err);
    }
    return resPayload;
});
const setDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("setDefaultAddress", async (addressId)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "setDefaultShippingAddress",
                    addressId: addressId
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3;
            localStorage.setItem("profile-version", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                var ref4, ref5, ref6;
                var ref7;
                resPayload.addresses = (ref7 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addresses) === null || ref5 === void 0 ? void 0 : ref5.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref7 !== void 0 ? ref7 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to set default", err);
    }
    return resPayload;
});
const removeAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("removeAddress", async (addressId)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "removeAddress",
                    addressId: addressId
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3, ref4;
            localStorage.setItem("profile-version", (ref1 = res === null || res === void 0 ? void 0 : res.data.profileDetail) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profileDetail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addresses) === null || ref4 === void 0 ? void 0 : ref4.length) > 0) {
                var ref5, ref6, ref7, ref8, ref9;
                var ref10;
                resPayload.addresses = (ref10 = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.profileDetail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.addresses) === null || ref7 === void 0 ? void 0 : ref7.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref10 !== void 0 ? ref10 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref8 = res.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.profileDetail) === null || ref9 === void 0 ? void 0 : ref9.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to remove address", err);
    }
    return resPayload;
});
const deleteAccount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("deleteAccount", async ()=>{
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim["delete"] */ .TH["delete"]("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.DELETE_ACCOUNT_ENDPOINT));
        if (res && res.data) return true;
    } catch (err) {
        console.log("Failed to delete account", err);
    }
});
const resetPassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("resetPassword", async (data)=>{
    try {
        return await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.CHANGE_ACCOUNT_PASSWORD_ENDPOINT), data);
    } catch (err) {
        console.log("Failed to reset password", err);
        return err.response;
    }
});
const uploadImage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("", async (file)=>{
    var ref, ref1;
    const fileName = (ref1 = file === null || file === void 0 ? void 0 : (ref = file.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.replace(/ /g, "-");
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.put */ .TH.put("/crm/asset/upload?fileName=".concat(fileName), file, {
        headers: {
            "Content-Type": file.type
        }
    });
    if (res && res.data) return res.data;
});
const getCommonList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getCommonList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const commonList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.commonList;
    if ((commonList === null || commonList === void 0 ? void 0 : commonList.length) > 0 && !reload) return commonList;
    const commonListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.commonListPath;
    if (commonListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + commonListPath);
        return response.data;
    }
    return [];
});
const genericSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
    name: "generic",
    initialState,
    reducers: {
        setSubscribeModalContent (state, action) {
            state.subscribeModal = {
                ...state.subscribeModal,
                modalContent: action.payload
            };
        },
        setCompareproductsStaticText (state, action) {
            state.compareproducts = {
                ...state.compareproducts,
                content: action.payload
            };
        },
        setSitewideWarningContent (state, action) {
            state.siteWideWarning = {
                ...state.subscribeModal,
                content: action.payload
            };
        },
        setSitewideNewsLetterContent (state, action) {
            state.newslettersignup = {
                ...state.newslettersignup,
                content: action.payload
            };
        },
        setSitewideWarningRendered (state, action) {
            state.siteWideWarning = {
                ...state.subscribeModal,
                isRendered: action.payload
            };
        },
        setBrandLogoImg (state, action) {
            state.brandLogoImg = action.payload;
        },
        setGlobalScripts (state, action) {
            state.globalScripts = state.globalScripts.concat(action.payload);
        },
        setDataLayerObj (state, action) {
            state.dataLayerObj = action.payload;
        },
        setGlobalStyles (state, action) {
            state.globalStyles = state.globalStyles.concat(action.payload);
        },
        setGlobalConfig (state, action) {
            state.globalConfig = action.payload;
        },
        setAuthorData (state, action) {
            state.authorData = action.payload;
        },
        setLoading (state, action) {
            state.isLoading = action.payload;
        },
        setAnalyticsScript (state, action) {
            state.analyticsScript = action.payload;
        },
        showToast (state, action) {
            state.toaster = {
                ...state.toaster,
                ...action.payload
            };
        },
        hideToast (state, action) {
            state.toaster = {
                ...state.toaster,
                message: "",
                isVisible: false
            };
        },
        setToastContent (state, action) {
            state.toaster = {
                ...state.toaster,
                content: action.payload
            };
        },
        openMenu (state, action) {
            state.menu = {
                ...state.menu,
                isOpen: true
            };
        },
        closeMenu (state, action) {
            state.menu = {
                ...state.menu,
                isOpen: false
            };
        },
        setActiveMainCategory (state, action) {
            state.menu = {
                ...state.menu,
                mainCategoryActive: action.payload.item
            };
        },
        setRegionNav (state, action) {
            state.menu = {
                ...state.menu,
                isRegionOpen: action.payload
            };
        },
        setAuthNav (state, action) {
            state.menu = {
                ...state.menu,
                isAuthNavOpen: action.payload
            };
        },
        setPageIsIntercative (state, action) {
            state.pageIsInteractive = action.payload;
        },
        showPreviewCart (state, action) {
            window.previewCartKeySource = false;
            state.previewCart = {
                ...state.previewCart,
                showPreview: true
            };
        },
        hidePreviewCart (state, action) {
            window.previewCartKeySource = true;
            state.previewCart = {
                ...state.previewCart,
                showPreview: false
            };
        },
        setDatalayerPageName (state, action) {
            let trimmed = action.payload;
            // will remove .model.json from the incoming string
            trimmed = trimmed ? trimmed.replace(".model.json", "") : trimmed;
            state.datalayerPageName = trimmed;
        },
        setGbhDataLayerCustom (state, action) {
            var ref;
            const { datalayerPageName , eventPageType , pageType  } = action.payload;
            if (datalayerPageName) {
                state.datalayerPageName = datalayerPageName;
            } else {
                state.datalayerPageName = "";
            }
            if (eventPageType) {
                state.eventPageType = window.eventPageType = eventPageType;
            } else {
                state.eventPageType = "";
            }
            if (pageType) {
                state.pageType = window.pageType = pageType;
            } else {
                state.pageType = "";
            }
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const content = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
            if (content === "locations") {
                state.eventPageType = "locations:kohler stores";
            }
        },
        showPromoModal (state, action) {
            state.promoBannerModal = {
                ...action.payload
            };
        },
        mapStateToCountry: (state, action)=>{
            const { countryList , stateList  } = action.payload;
            const stateToCountryList = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .mapStateToCountryHandler */ .oFy)(countryList, stateList);
            state.stateToCountryList = stateToCountryList;
        },
        toggleSiteWideWarning: (state, action)=>{
            state.enableSiteWideWarning = !state.enableSiteWideWarning;
        },
        showFindingModelPopup (state, action) {
            state.FindingModelModal = {
                show: true,
                modalContent: {}
            };
        },
        hideFindingModelPopup (state, action) {
            state.FindingModelModal = {
                show: false,
                modalContent: {}
            };
        },
        setShowHalfCompare (state, action) {
            state.showHalfCompare = action.payload;
        },
        setShowFullCompare (state, action) {
            state.showFullCompare = action.payload;
        },
        setPageObject (state, action) {
            state.isProductInfo = action.payload;
        },
        setPreviewCartInit (state, action) {
            state.isPreviewCartInit = action.payload;
        },
        setConsolidatedZipCodes (state, action) {
            state.consolidatedZipCodes = action.payload;
        },
        setUpsellInstallationServiceData (state, action) {
            state.upsellInstallationServiceAuthData = action.payload;
        },
        showAppointmentModal: (state, action)=>{
            state.isShowAppointmentModal = true;
            state.bpNumber = action.payload;
        },
        hideAppointmentModal: (state)=>{
            state.isShowAppointmentModal = false;
        },
        setGatedContentData: (state, action)=>{
            state.gatedContentData = action.payload;
        },
        setFeatureFlagsFeature: (state, action)=>{
            state.featureFlags = action.payload;
        },
        setPlaceOrderLoading (state, action) {
            state.isPlaceOrderLoading = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.generic
            };
        }).addCase(getGenericListPath.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getGenericListPath.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const data = action.payload;
            for (const key of Object.keys(data)){
                state[key + "Path"] = data[key];
            }
        }).addCase(getGenericListPath.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getBusinessList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getBusinessList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.businessList = action.payload;
        }).addCase(getBusinessList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCheckoutErrorList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCheckoutErrorList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.checkoutErrorList = action.payload;
        }).addCase(getCheckoutErrorList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAccountBusinessList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getAccountBusinessList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.accountTypeList = action.payload;
        }).addCase(getAccountBusinessList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getLegalPageLinks.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getLegalPageLinks.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.legalPageLinks = action.payload;
        }).addCase(getLegalPageLinks.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAuthMenuFragment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getAuthMenuFragment.fulfilled, (state, action)=>{
            state.status = "succeeded";
            for(const key in action.payload){
                if (({}).hasOwnProperty.call(action.payload, key)) {
                    state[key] = action.payload[key];
                }
            }
        }).addCase(getAuthMenuFragment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCountryList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCountryList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.countryList = action.payload;
        }).addCase(getCountryList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getOccupationList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getOccupationList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.countryList = action.payload;
        }).addCase(getOccupationList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getstateList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getstateList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.stateList = action.payload;
        }).addCase(getStoreCountriesList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getStoreCountriesList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getStoreCountriesList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.stateList = action.payload;
        }).addCase(getstateList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getplaceOfPurchaseList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getplaceOfPurchaseList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.placeOfPurchaseList = action.payload;
        }).addCase(getplaceOfPurchaseList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCardType.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCardType.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.cardType = action.payload;
        }).addCase(getCardType.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getOrderStatus.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getOrderStatus.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.orderStatus = action.payload;
        }).addCase(getOrderStatus.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setLoading , setCompareproductsStaticText , setSubscribeModalContent , setSitewideWarningContent , setSitewideWarningRendered , setBrandLogoImg , setGlobalScripts , setGlobalStyles , setGlobalConfig , setAuthorData , setDataLayerObj , setAnalyticsScripts , setCompareExpiry , showToast , clearAllCompareProducts , showPreviewCart , hidePreviewCart , hideToast , openMenu , closeMenu , setActiveMainCategory , setRegionNav , setAuthNav , setAnalyticsScript , setPageIsIntercative , setDatalayerPageName , setGbhDataLayerCustom , setSitewideNewsLetterContent , setToastContent , showPromoModal , mapStateToCountry , toggleSiteWideWarning , showFindingModelPopup , hideFindingModelPopup , setShowHalfCompare , setShowFullCompare , setPageObject , setPreviewCartInit , setConsolidatedZipCodes , setUpsellInstallationServiceData , showAppointmentModal , hideAppointmentModal , setGatedContentData , setFeatureFlagsFeature , setPlaceOrderLoading  } = genericSlice.actions;
const selectGenericState = (state)=>state.generic;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (genericSlice.reducer);


/***/ }),

/***/ 49265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ setLastChangedSelection; },
/* harmony export */   "M0": function() { return /* binding */ resetInvalidSelection; },
/* harmony export */   "VN": function() { return /* binding */ setModalOpen; },
/* harmony export */   "Zh": function() { return /* binding */ setInvalidSelection; },
/* harmony export */   "iP": function() { return /* binding */ setRemovedSelections; },
/* harmony export */   "oT": function() { return /* binding */ setPreviousConfig; },
/* harmony export */   "ot": function() { return /* binding */ setAddedSelections; },
/* harmony export */   "yz": function() { return /* binding */ setCurrentConfig; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    isModalOpen: false,
    attributes: [],
    lastChanged: {
        attribute: "",
        value: "",
        image: null
    },
    removedSelections: [],
    addedSelections: [],
    previousConfig: {},
    currenConfig: {}
};
const invalidSelectionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "invalidSelection",
    initialState,
    reducers: {
        setInvalidSelection (state, action) {
            state.attributes = action.payload.attributes;
        },
        setModalOpen (state, action) {
            state.isModalOpen = action.payload;
        },
        setCurrentConfig (state, action) {
            state.currenConfig = action.payload;
        },
        setPreviousConfig (state, action) {
            state.previousConfig = action.payload;
        },
        setLastChangedSelection (state, action) {
            var _image;
            state.lastChanged = {
                attribute: action.payload.attribute,
                value: action.payload.value,
                image: (_image = action.payload.image) !== null && _image !== void 0 ? _image : null
            };
        },
        setRemovedSelections (state, action) {
            state.removedSelections = action.payload;
        },
        setAddedSelections (state, action) {
            state.addedSelections = action.payload;
        },
        resetInvalidSelection (state) {
            state.isModalOpen = false;
            state.attributes = [];
            state.lastChanged = {
                attribute: "",
                value: "",
                image: null
            };
            state.removedSelections = [];
            state.addedSelections = [];
            state.previousConfig = {};
            state.currenConfig = {};
        }
    }
});
const { setInvalidSelection , setModalOpen , resetInvalidSelection , setLastChangedSelection , setRemovedSelections , setAddedSelections , setCurrentConfig , setPreviousConfig  } = invalidSelectionSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (invalidSelectionSlice);


/***/ }),

/***/ 56608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ setStoreFilter; },
/* harmony export */   "Hm": function() { return /* binding */ setUtilityStoreDetails; },
/* harmony export */   "I_": function() { return /* binding */ setFindAStoreActive; },
/* harmony export */   "NL": function() { return /* binding */ setUtilityLocation; },
/* harmony export */   "OX": function() { return /* binding */ setCityLocation; },
/* harmony export */   "T7": function() { return /* binding */ setFindAStoreShow; },
/* harmony export */   "_n": function() { return /* binding */ locationState; },
/* harmony export */   "h9": function() { return /* binding */ setMyStore; },
/* harmony export */   "tD": function() { return /* binding */ setFindAStoreSearchEvent; },
/* harmony export */   "vM": function() { return /* binding */ locationSlice; },
/* harmony export */   "wf": function() { return /* binding */ setStoreAddress; }
/* harmony export */ });
/* unused harmony export setAPIRecallTime */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77236);
/* harmony import */ var _utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64443);


const initialState = {
    userCity: "",
    utilityLocation: "",
    utilityData: {},
    utilityStoreDetails: {},
    myStoreId: 0,
    utilityStoreDetailsUrl: "",
    isLoading: false,
    reCallIn: "",
    browseLocationsStoreFilterData: [],
    findAStoreShow: false,
    findAStoreActive: false,
    findAStoreSearchEvent: false
};
const locationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "location",
    initialState,
    reducers: {
        setAPIRecallTime (state, action) {
            state.reCallIn = (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getUnixTimestamp */ .K9)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .addToDate */ .EE)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentDate */ .Ux)(), 1, "m"));
        },
        setStoreAddress: (state, action)=>{
            state.utilityData = action.payload;
            state.reCallIn = (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getUnixTimestamp */ .K9)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .addToDate */ .EE)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentDate */ .Ux)(), 1, "m"));
            state.isLoading = false;
        },
        setUtilityStoreDetails: (state, action)=>{
            state.utilityStoreDetails = action.payload;
            state.reCallIn = (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getUnixTimestamp */ .K9)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .addToDate */ .EE)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentDate */ .Ux)(), 1, "m"));
            state.isLoading = false;
        },
        setCityLocation: (state, action)=>{
            const { payload: { userCity ="" , utilityLocation =""  }  } = action;
            state.userCity = userCity;
            state.utilityLocation = utilityLocation;
            state.reCallIn = (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getUnixTimestamp */ .K9)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .addToDate */ .EE)((0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentDate */ .Ux)(), 1, "m"));
            state.isLoading = false;
            localStorage.setItem("currentZipCode", utilityLocation);
        },
        setUtilityLocation: (state, action)=>{
            const { payload: { utilityLocation =""  } = {}  } = action;
            state.utilityLocation = utilityLocation;
            localStorage.setItem("currentZipCode", utilityLocation);
        },
        setMyStore: (state, action)=>{
            state.myStoreId = action.payload;
        },
        setStoreFilter: (state, action)=>{
            state.browseLocationsStoreFilterData = action.payload;
        },
        setFindAStoreShow: (state, action)=>{
            state.findAStoreShow = action.payload;
        },
        setFindAStoreActive: (state, action)=>{
            state.findAStoreActive = action.payload;
        },
        setFindAStoreSearchEvent: (state, action)=>{
            state.findAStoreSearchEvent = action.payload;
        }
    }
});
const { setStoreAddress , setAPIRecallTime , setUtilityStoreDetails , setCityLocation , setMyStore , setUtilityLocation , setStoreFilter , setFindAStoreActive , setFindAStoreShow , setFindAStoreSearchEvent  } = locationSlice.actions;
const locationState = (state)=>state.location;


/***/ }),

/***/ 3507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": function() { return /* binding */ selectMyAccountState; },
/* harmony export */   "JC": function() { return /* binding */ setOnlineSubmitStatus; },
/* harmony export */   "Ku": function() { return /* binding */ clearSuccess; },
/* harmony export */   "M_": function() { return /* binding */ setInvalidModelNumber; },
/* harmony export */   "N0": function() { return /* binding */ onlineProductSubmitRegistration; },
/* harmony export */   "TN": function() { return /* binding */ setSubmitStatus; },
/* harmony export */   "Tp": function() { return /* binding */ offlineProductSubmitRegistration; },
/* harmony export */   "dM": function() { return /* binding */ clearSuggestion; },
/* harmony export */   "dj": function() { return /* binding */ myProductSlice; },
/* harmony export */   "q5": function() { return /* binding */ getProductsForRegistration; },
/* harmony export */   "u8": function() { return /* binding */ getModelNumberSuggest; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28858);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77236);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);








const initialState = {
    status: "",
    offlineRegistration: {
        suggestions: [],
        invalidModelNumber: false,
        submitError: false,
        isSuccess: false,
        isDisabled: false
    },
    onlineRegistration: {
        submitError: false,
        isSuccess: false,
        isDisabled: false
    }
};
const getModelNumberSuggest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/getSuggestion", async (payload)=>{
    const { q , rows , fq , fl , start , skuSearch  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_SEARCH_CATALOG, {
        params: {
            q,
            rows,
            fq,
            fl,
            start,
            skuSearch
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_7___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const skuData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .handleModelNumberSuggestion */ .Gzb)(response.data);
    return skuData;
});
const getProductsForRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/fetchProducts", async (body)=>{
    var ref;
    const productsData = [];
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    var ref1;
    const locale = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.locale) !== null && ref1 !== void 0 ? ref1 : "en-US";
    await Promise.all([
        _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCTS_ENDPOINT, "?lang=").concat(locale)),
        _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_3__.FETCH_PRODUCT_REG_ENDPOINT))
    ]).then(async (res)=>{
        var ref, ref1, ref2, ref3;
        if ((ref = res[0]) === null || ref === void 0 ? void 0 : ref.data) productsData[0] = (ref1 = res[0]) === null || ref1 === void 0 ? void 0 : ref1.data;
        if ((ref2 = res[1]) === null || ref2 === void 0 ? void 0 : ref2.data) productsData[1] = (ref3 = res[1]) === null || ref3 === void 0 ? void 0 : ref3.data;
    }).catch((err)=>{
        console.error("Error occured while fetching registered product data", err);
    });
    return productsData;
});
const offlineProductSubmitRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/offlineRegistration", async (body)=>{
    let message = false;
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_PRODUCT_REGISTRATION, body);
    if (data) {
        message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, "success", "") === "true" ? true : false;
    }
    return message;
});
const onlineProductSubmitRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/onlineRegistration", async (body)=>{
    let message = false;
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_PRODUCT_REGISTRATION, body);
    if (data) {
        message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, "success", "") === "true" ? true : false;
    }
    return message;
});
const myProductSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "myProduct",
    initialState,
    reducers: {
        clearSuggestion: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                suggestions: []
            };
        },
        setInvalidModelNumber: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                invalidModelNumber: action.payload
            };
        },
        setSubmitStatus: (state, action)=>{
            const { submitError ="" , isDisabled =false  } = action.payload;
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: submitError,
                isDisabled: isDisabled
            };
        },
        clearSuccess: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                isSuccess: false
            };
        },
        setOnlineSubmitStatus: (state, action)=>{
            const { submitError ="" , isDisabled =false  } = action.payload;
            state.onlineRegistration = {
                ...state.onlineRegistration,
                submitError: submitError,
                isDisabled: isDisabled
            };
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_1__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(getModelNumberSuggest.pending, (state, action)=>{
        // state.status = "loading"
        }).addCase(getModelNumberSuggest.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.offlineRegistration = {
                ...state.offlineRegistration,
                ...action.payload
            };
        }).addCase(getModelNumberSuggest.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(offlineProductSubmitRegistration.pending, (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: false,
                isDisabled: true
            };
            state.status = "loading";
        }).addCase(offlineProductSubmitRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const isSuccess = action.payload;
            if (isSuccess) {
                state.offlineRegistration = {
                    ...state.offlineRegistration,
                    isSuccess: true,
                    isDisabled: false
                };
            }
        }).addCase(offlineProductSubmitRegistration.rejected, (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: action.error.message,
                isDisabled: false
            };
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProductsForRegistration.pending, (state)=>{
            state.status = "loading";
        }).addCase(getProductsForRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getProductsForRegistration.rejected, (state, action)=>{
            state.status = "failed";
        }).addCase(onlineProductSubmitRegistration.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(onlineProductSubmitRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(onlineProductSubmitRegistration.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { clearSuggestion , setInvalidModelNumber , setSubmitStatus , clearSuccess , setOnlineSubmitStatus  } = myProductSlice.actions;
const selectMyAccountState = (state)=>state.myProduct;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (myProductSlice.reducer);


/***/ }),

/***/ 76977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ findOrderByEmail; },
/* harmony export */   "_w": function() { return /* binding */ ordersState; },
/* harmony export */   "co": function() { return /* binding */ getOrder; },
/* harmony export */   "gB": function() { return /* binding */ getSpecsSheetData; },
/* harmony export */   "rx": function() { return /* binding */ getPastOrders; },
/* harmony export */   "tI": function() { return /* binding */ getSplitOrder; },
/* harmony export */   "x0": function() { return /* binding */ getOpenOrders; },
/* harmony export */   "zM": function() { return /* binding */ orderSlice; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77236);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88032);




const initialState = {
    status: "",
    error: "",
    orders: []
};
const findOrderByEmail = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/email", async (payload, thunkAPI)=>{
    var ref, ref1;
    const body = {
        email: (ref = payload.email) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase(),
        orderId: (ref1 = payload.orderNo) === null || ref1 === void 0 ? void 0 : ref1.trim().toUpperCase()
    };
    try {
        const state = thunkAPI.getState();
        const { auth: { isAuth =false  } = {}  } = state;
        const isFluent = "enabled" === "enabled";
        const url = isFluent ? _constants__WEBPACK_IMPORTED_MODULE_1__.FIND_MY_ORDERS_V1_ENDPOINT : _constants__WEBPACK_IMPORTED_MODULE_1__.FIND_MY_ORDERS_ENDPOINT;
        if (!isFluent && isAuth) {
            const authData = await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(getOrder({
                orderNo: body.orderId
            })).unwrap();
            return {
                results: authData
            };
        } else {
            const { status , data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
            if (status === 200) return data;
        }
    } catch (err) {
        return {};
    }
});
const getOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/details", async (payload)=>{
    let data = [];
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, '?order-id="').concat(payload.orderNo, '"'));
        if (res && res.data && res.data.results) {
            data = res.data.results;
        }
    } catch (err) {
        // log.error("Failed to fetch order details", err)
        console.error("Failed to fetch order details", err);
    }
    return data;
});
const getOpenOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/list/open", async ()=>{
    let data = [];
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, "?state=open"));
        if (res && res.data && res.data.results) {
            data = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch open orders", err);
    }
    return data;
});
const getPastOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/list/past", async ()=>{
    let data = [];
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, "?state=past"));
        if (res && res.data && res.data.results) {
            data = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch past orders", err);
    }
    return data;
});
const getSplitOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orderSplit", async (payload)=>{
    const { email ="" , orderNo =""  } = payload;
    const emailId = email === null || email === void 0 ? void 0 : email.trim().toLowerCase();
    const encodeEmail = encodeURIComponent(emailId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.SPLIT_ORDER, "?parentOrderNumber=").concat(orderNo === null || orderNo === void 0 ? void 0 : orderNo.trim().toUpperCase(), "&email=").concat(encodeEmail));
    return response.data;
});
const getSpecsSheetData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/specs", async (productIds)=>{
    let data = [];
    try {
        const fl = [
            "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
            "ProductResource.SpecPDFFileName.resourceTitle_ss"
        ];
        const params = {
            q: "*:*",
            fq: 'ctId_s:("'.concat(productIds.join('","'), '")'),
            fl: fl.join(","),
            collections: "kohler",
            profilename: "profile_kohler_Search"
        };
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, {
            params
        });
        if (res && res.data && res.data.response) {
            data = res.data.response.docs;
        }
        return data;
    } catch (err) {
        console.error("Failed to fetch specs sheet data", err);
        return data;
    }
});
const orderSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "orders",
    initialState,
    reducers: {},
    extraReducers (builder) {
        builder.addCase(findOrderByEmail.pending, (state)=>{
            state.status = "loading";
        }).addCase(findOrderByEmail.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.orders = action.payload.addresses;
        }).addCase(findOrderByEmail.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getSplitOrder.pending, (state)=>{
            state.status = "loading";
        }).addCase(getSplitOrder.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getSplitOrder.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getOrder.pending, (state)=>{
            state.status = "loading";
        }).addCase(getOrder.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getOrder.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getSpecsSheetData.pending, (state)=>{
            state.status = "loading";
        }).addCase(getSpecsSheetData.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.specs = action.payload;
        }).addCase(getSpecsSheetData.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
// export const {} = orderSlice.actions
const ordersState = (state)=>state.orders;


/***/ }),

/***/ 44561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ getDiscontinuedProductValue; },
/* harmony export */   "BY": function() { return /* binding */ selectPdpState; },
/* harmony export */   "CC": function() { return /* binding */ setProductInfo; },
/* harmony export */   "Co": function() { return /* binding */ getProductBySlug; },
/* harmony export */   "OW": function() { return /* binding */ setIsProductExcludeFromPaidAdvertising; },
/* harmony export */   "ZR": function() { return /* binding */ setIsTeaserLoaded; },
/* harmony export */   "Zp": function() { return /* binding */ fetchPdpRequiredItems; },
/* harmony export */   "bF": function() { return /* binding */ getProductBySlugAndSku; },
/* harmony export */   "gP": function() { return /* binding */ getReqItemLwData; },
/* harmony export */   "gt": function() { return /* binding */ getPartList; },
/* harmony export */   "n_": function() { return /* binding */ getPdpTooltip; },
/* harmony export */   "ou": function() { return /* binding */ pdpSlice; },
/* harmony export */   "qK": function() { return /* binding */ setPDP; },
/* harmony export */   "ub": function() { return /* binding */ setTeaserContent; },
/* harmony export */   "vM": function() { return /* binding */ setRequiredItemsSkuData; },
/* harmony export */   "ww": function() { return /* binding */ getVariantFields; },
/* harmony export */   "zF": function() { return /* binding */ searchPdp; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64757);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28858);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14887);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);










const initialState = {
    pdp: {},
    isDiscontinued: false,
    productInfo: {},
    teaserContent: [],
    isTeaserLoaded: false,
    isProductExcludeFromPaidAdvertising: false,
    requiredItemsSkuData: []
};
const searchPdp = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/searchPdp", async (payload, thunkAPI)=>{
    try {
        var ref;
        const { slug , isParts , selectedSku , selectedColor , setSkuVariantCb , getVariantFieldsCb =()=>{} , lwAppName ="" , quickView =false , isConfigurator =false  } = payload;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            q: "*:*",
            fl: _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_PDP_FL.join(","),
            fq: "".concat(isConfigurator && selectedSku ? 'sku_s:("'.concat(selectedSku, '"),') : "", 'language_s:("').concat(language, '")'),
            collections: isParts ? "service_parts" : lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(), "_PDP"),
            search_type: "product_detail",
            skuId: selectedSku
        });
        const { data: { response: { docs =[]  } = {} , fusion ={}  } = {}  } = response;
        const { BundleSKUDetails: bundleIncludedItems = [] , ProductDimensionAttributes ={} , ProductDimensionAttributesValues ={} , configuratorEnabled =false , ProductSpecificationAttributesValues =[]  } = fusion;
        const dimensionData = Object.keys(ProductDimensionAttributes).length && Object.keys(ProductDimensionAttributesValues).length ? {
            ProductDimensionAttributes,
            ProductDimensionAttributesValues
        } : {};
        const specificationData = Object.keys(ProductSpecificationAttributesValues).length ? {
            ProductSpecificationAttributesValues
        } : {};
        const productData = docs.at(0);
        const threeSixtyResourceData = {};
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceFullWebURL_ss"]) {
            threeSixtyResourceData.resourceFullWebUrl = productData["ItemResource.IMGSpinSet.resourceFullWebURL_ss"];
        }
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceAltText_ss"]) {
            threeSixtyResourceData.resourceAltText = productData["ItemResource.IMGSpinSet.resourceAltText_ss"];
        }
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceName_ss"]) {
            threeSixtyResourceData.resourceName = productData["ItemResource.IMGSpinSet.resourceName_ss"];
        }
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceType_ss"]) {
            threeSixtyResourceData.resourceTypeImg = productData["ItemResource.IMGSpinSet.resourceType_ss"];
        }
        const sku = selectedSku === "" || !productData["variantList.sku_ss"].some((v)=>v === selectedSku) ? (0,_components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_6__/* .getInitialSku */ .H3)({
            productData,
            setSkuVariantCb,
            selectedColor
        }) : selectedSku;
        const customerFacingSKU = productData["CustomerFacingSKU_s"];
        const fusionQueryId = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(response.data, "fusion.fusionQueryId");
        if (productData === null || productData === void 0 ? void 0 : productData["variantList.sku_ss"]) {
            getVariantFieldsCb(productData["variantList.sku_ss"]);
        }
        let recommendedAccessories = [];
        if (productData === null || productData === void 0 ? void 0 : productData["ProductProductRecommendedAccessories_ss"]) {
            recommendedAccessories = productData["ProductProductRecommendedAccessories_ss"];
        } else if (productData === null || productData === void 0 ? void 0 : productData["ProductProductRecommendedAccessories_s"]) {
            recommendedAccessories.push(productData["ProductProductRecommendedAccessories_s"]);
        }
        let colors = [];
        if (productData === null || productData === void 0 ? void 0 : productData["Color.SKU.Details_ss"]) {
            colors = productData["Color.SKU.Details_ss"].map((color)=>{
                const d = color.split("|");
                return {
                    sku: d[2],
                    discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
                };
            });
        }
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .addToRecentlyViewed */ .gP3)(productData["ctId_s"]);
        return {
            bundleIncludedItems,
            productData,
            sku,
            recommendedAccessories,
            colors,
            fusionQueryId,
            customerFacingSKU,
            slug,
            dimensionData,
            specificationData,
            threeSixtyResourceData,
            quickView,
            configuratorEnabled,
            isConfigurator,
            fusion,
            docs
        };
    } catch (err) {
        return err;
    }
});
const getVariantFields = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getVariantFields", async (payload)=>{
    try {
        var ref;
        const { skuList =[] , slug , isParts , lwAppName =""  } = payload;
        let skus = "";
        skuList.forEach((s)=>skus += '"'.concat(s, '" '));
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            q: "*:*",
            fq: "sku_s:(".concat(skus.trim(), '),language_s:("').concat(language, '")'),
            fl: "sku_s,RegionStatesExcluded_ss,RegionSpecialOrder_s",
            collections: isParts ? "service_parts" : lwAppName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
            search_type: "product_detail"
        });
        return response.data;
    } catch (err) {
        return err;
    }
});
const getPartList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getPartList", async (payload)=>{
    let parts = {};
    try {
        const { productId  } = payload;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .SVG_METADATA_ENDPOINT */ .YZ, "/").concat(productId));
        if (response && response.data) {
            parts = response.data;
        }
    } catch (err) {
        return err;
    }
    return parts;
});
const getProductBySlug = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getProductBySlug", async (payload)=>{
    let product = {};
    try {
        const { slug  } = payload;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, '?where=slug(en-US%3D"').concat(slug, '")'));
        if (response && response.data && response.data.results) {
            var ref;
            product = (ref = response.data.results[0]) !== null && ref !== void 0 ? ref : {};
        }
    } catch (err) {
        return err;
    }
    return product;
});
const getProductBySlugAndSku = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getProductBySlugAndSku", async (payload)=>{
    const { slug , skus  } = payload;
    let query = "";
    let masterQuery = "";
    if (slug) masterQuery += 'slug(en-US%3D"'.concat(slug, '") or ');
    if (skus.length > 0) {
        skus.forEach((sku, i)=>{
            query += '"'.concat(sku, '"');
            if (i + 1 !== skus.length) query += ", ";
        });
        masterQuery += "masterVariant(sku in (".concat(query, ")) or variants(sku in (").concat(query, "))");
    }
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=").concat(masterQuery));
        if (res && res.data && res.data.results) return res.data.results;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
});
const getReqItemLwData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getReqItemLwData", async (payload)=>{
    var ref, ref1, ref2;
    const { query , lwAppName =""  } = payload;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, {
        params: {
            q: "*:*",
            fl: "ctId_s, RegionOnBackOrder_s",
            fq: [
                "ctId_s:(".concat(query.trim(), ")"),
                'masterVariant_b:("true")',
                'language_s:("'.concat(language, '")')
            ],
            collections: lwAppName.toLowerCase(),
            profilename: "profile_".concat(lwAppName.toLowerCase(), "_General")
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_9___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    var ref4;
    return (ref4 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs) !== null && ref4 !== void 0 ? ref4 : [];
});
const fetchPdpRequiredItems = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/fetchPdpRequiredItems", async (query)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=id in (").concat(query, ")"));
        var _results;
        return (_results = response.data.results) !== null && _results !== void 0 ? _results : [];
    } catch (err) {
        return err;
    }
});
const getPdpTooltip = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getPdpTooltip", async (payload)=>{
    const { brandName  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getPdpTooltipEndPoint, {
        params: {
            collection: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
});
const pdpSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
    name: "pdp",
    initialState,
    reducers: {
        setPDP (state, action) {
            state.pdp = {
                ...state.pdp,
                ...action.payload
            };
        },
        getDiscontinuedProductValue (state, action) {
            state.isDiscontinued = action.payload;
        },
        setProductInfo (state, action) {
            state.productInfo = action.payload;
        },
        setTeaserContent (state, action) {
            state.teaserContent = action.payload;
        },
        setIsTeaserLoaded (state, action) {
            state.isTeaserLoaded = action.payload;
        },
        setRequiredItemsSkuData (state, action) {
            state.requiredItemsSkuData = action.payload;
        },
        setIsProductExcludeFromPaidAdvertising (state, action) {
            state.isProductExcludeFromPaidAdvertising = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.pdp
            };
        }).addCase(searchPdp.pending, (state, action)=>{
            state.status = "pending";
        }).addCase(searchPdp.fulfilled, (state, action)=>{
            const { productData ={} , sku ="" , recommendedAccessories =[] , colors =[] , slug ="" , customerFacingSKU ="" , bundleIncludedItems =[] , quickView =false , configuratorEnabled =false , isConfigurator =false  } = action.payload;
            state.status = "succeeded";
            if (!quickView && !isConfigurator) {
                state.pdp = {
                    sku,
                    slug: slug,
                    recommendedAccessories,
                    productBrand: productData["ProductBrandNameDisplay_t"],
                    productNo: productData["ProductProductNo_s"],
                    data: productData,
                    variants: colors,
                    customerFacingSKU: customerFacingSKU ? customerFacingSKU.replace("K-", "") : "",
                    bundleIncludedItems,
                    configuratorEnabled
                };
            }
        }).addCase(searchPdp.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProductBySlugAndSku.pending, (state)=>{
            state.status = "pending";
        }).addCase(getProductBySlugAndSku.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.productServices = action.payload;
        }).addCase(getProductBySlugAndSku.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setPDP , getDiscontinuedProductValue , setProductInfo , setTeaserContent , setIsTeaserLoaded , setRequiredItemsSkuData , setIsProductExcludeFromPaidAdvertising  } = pdpSlice.actions;
const selectPdpState = (state)=>state.pdp;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (pdpSlice.reducer);


/***/ }),

/***/ 49682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ profileBrandTopSearches; },
/* harmony export */   "Li": function() { return /* binding */ setCurrentAppliedfilters; },
/* harmony export */   "NY": function() { return /* binding */ setServerData; },
/* harmony export */   "R$": function() { return /* binding */ profileBrandSearch; },
/* harmony export */   "Tx": function() { return /* binding */ productListSlice; },
/* harmony export */   "W1": function() { return /* binding */ setFacetLabels; },
/* harmony export */   "Xp": function() { return /* binding */ getProducts; },
/* harmony export */   "ZZ": function() { return /* binding */ setVisualNavAppliedFilters; },
/* harmony export */   "_8": function() { return /* binding */ setCurrentAppliedfiltersVisualNav; },
/* harmony export */   "dM": function() { return /* binding */ clearSuggestion; },
/* harmony export */   "gS": function() { return /* binding */ setPlpData; },
/* harmony export */   "n7": function() { return /* binding */ profileServicePartsSearch; },
/* harmony export */   "nS": function() { return /* binding */ setFilterQueryState; },
/* harmony export */   "pO": function() { return /* binding */ setIsViewDetailClicked; },
/* harmony export */   "rv": function() { return /* binding */ selectProductListState; },
/* harmony export */   "sR": function() { return /* binding */ clearProductData; },
/* harmony export */   "zm": function() { return /* binding */ setIsFromVisualNav; },
/* harmony export */   "zw": function() { return /* binding */ profileBrandTypeahead; }
/* harmony export */ });
/* unused harmony exports setProfileServicePartsSearch, setProfileBrandTypeahead, setProfileBrandSearch, setFilterData, updatePlpData, updatePlpDataStatus */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29843);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28858);








const initialState = {
    profile_service_parts_Search: {},
    profile_brand_Typeahead: {},
    profile_brand_Search: {},
    profile_brand_Top_Searches: {},
    visualNavAppliedFilters: [],
    visualNavFiltersInitialLoad: false,
    filterQueryState: "",
    isServerData: true,
    facet_labels: {},
    isFromVisualNav: false,
    currentAppliedfiltersVisualNav: [],
    isViewDetailClicked: "VIEW_DETAILS_NOT_CLICKED",
    plp: {
        status: "loading-yes",
        error: "",
        initialLoad: true,
        suggestions: [],
        suggestionExactMatch: false,
        currentAppliedfilters: []
    }
};
const profileBrandTypeahead = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileBrandTypeahead", async (query)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?rows=10&fl=sku_s,masterCustomerFacingSKU_s,productName_s&collections=").concat(query[1], "&profilename=profile_").concat(query[1], "_Typeahead&q=").concat(query[0], '&start=0&fq=language_s:("').concat(language, '")'));
    return response.data;
});
const profileServicePartsSearch = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileServicePartsSearch", async (query)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?rows=").concat(query[2], "&fl=").concat(query[1], "&collections=service_parts&profilename=profile_service_parts_Search&q=").concat(query[0], '&fq=language_s%3A("').concat(language, '")'));
    return response.data;
});
const profileBrandSearch = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileBrandSearch", async (query)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?rows=").concat(query[3], "&fl=").concat(query[2], "&lw.tagger.debug=true&collections=").concat(query[1], "&profilename=profile_").concat(query[1], "_Search&q=").concat(encodeURIComponent(query[0])).concat(query[4] ? "&fq=".concat(query[4]) : "", '&fq=language_s:("').concat(language, '")').concat(query[3] === 1 ? "&servicePartsSearch=true" : ""));
    return response.data;
});
const profileBrandTopSearches = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileBrandTopSearches", async (brand)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchProfilePlpEndPoint, "?q=*.*&profilename=profile_").concat(brand, "_Top_Searches&collections=").concat(brand, '&fq=language_s:("').concat(language, '")'));
    return response.data;
});
const getProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("plp/getProducts", async (payload)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getUserPersona */ .shu)();
    const { profileName: profilename , update , query , isFaq , isSuggestion , collections , ...params } = payload;
    const url = isFaq ? _constants_index__WEBPACK_IMPORTED_MODULE_1__.HELP_FAQ_END_POINT : _constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref6;
    const language = (ref6 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref6 !== void 0 ? ref6 : "en";
    var ref7;
    const canadianPrice = (ref7 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref7 !== void 0 ? ref7 : null;
    const customParams = {
        ...query,
        ...params,
        persona,
        profilename
    };
    if (customParams.q) customParams.q = customParams ? encodeURIComponent(customParams === null || customParams === void 0 ? void 0 : customParams.q) : customParams.q;
    if (collections) customParams.collections = collections;
    if (canadianPrice) customParams.CanadianPrice = canadianPrice;
    if (!isFaq) {
        if (!customParams.fq) {
            customParams.fq = 'language_s:("'.concat(language, '")');
        } else {
            if (typeof customParams.fq === "string" && customParams.fq.length > 0) {
                customParams.fq = [
                    customParams.fq,
                    'language_s:("'.concat(language, '")')
                ];
            } else if (Array.isArray(customParams.fq)) {
                customParams.fq = [
                    ...customParams.fq,
                    'language_s:("'.concat(language, '")')
                ];
            }
        }
    }
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params: customParams,
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_7___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const data = isSuggestion ? response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.response) === null || ref4 === void 0 ? void 0 : ref4.docs : await (0,_utils_product__WEBPACK_IMPORTED_MODULE_4__/* .formatListingData */ .nx)(response.data);
    return {
        data,
        update,
        isSuggestion,
        total: (ref5 = response.data) === null || ref5 === void 0 ? void 0 : ref5.response["numFound"]
    };
});
const productListSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "productList",
    initialState,
    reducers: {
        setIsViewDetailClicked (state, action) {
            state.isViewDetailClicked = action.payload;
        },
        setProfileServicePartsSearch (state, action) {
            state.profile_service_parts_Search = action.payload;
        },
        setVisualNavAppliedFilters (state, action) {
            state.visualNavAppliedFilters = action.payload;
            state.visualNavFiltersInitialLoad = true;
        },
        setFilterQueryState (state, action) {
            state.filterQueryState = action.payload;
        },
        setServerData (state, action) {
            state.isServerData = action.payload;
        },
        setFacetLabels (state, action) {
            state.facet_labels = action.payload;
        },
        setIsFromVisualNav (state, action) {
            state.isFromVisualNav = action.payload;
        },
        setCurrentAppliedfiltersVisualNav (state, action) {
            state.currentAppliedfiltersVisualNav = action.payload;
        },
        setCurrentAppliedfilters (state, action) {
            state.plp = {
                ...state.plp,
                currentAppliedfilters: action.payload
            };
        },
        setProfileBrandTypeahead (state, action) {
            state.profile_brand_Typeahead = action.payload;
        },
        setProfileBrandSearch (state, action) {
            state.profile_brand_Search = action.payload;
        },
        setPlpData (state, action) {
            state.plp = action === null || action === void 0 ? void 0 : action.payload;
            state.plp["status"] = "succeeded";
        },
        setFilterData (state, action) {
            state.filterData = action === null || action === void 0 ? void 0 : action.payload;
            state.plp["status"] = "succeeded";
        },
        updatePlpData (state, action) {
            state.plp = {
                ...state.plp,
                data: [
                    ...state.plp.data,
                    ...action.payload
                ]
            };
        },
        updatePlpDataStatus (state, action) {
            state.plp.status = action.payload;
        },
        clearSuggestion (state) {
            state.plp.suggestions = [];
        },
        clearProductData (state) {
            state.plp = {
                status: "idle",
                error: "",
                initialLoad: false,
                suggestions: [],
                suggestionExactMatch: false,
                currentAppliedfilters: [],
                data: [],
                total: 0
            };
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_5__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(profileBrandSearch.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(profileBrandSearch.fulfilled, (state, action)=>{
            state.profile_brand_Search = action.payload;
            state.profile_brand_Search.status = "succeeded";
        }).addCase(profileBrandSearch.rejected, (state, action)=>{
            state.profile_brand_Search.status = "failed";
            state.profile_brand_Search.error = action.error.message;
        }).addCase(profileServicePartsSearch.pending, (state, action)=>{
            state.profile_service_parts_Search.status = "loading";
        }).addCase(profileServicePartsSearch.fulfilled, (state, action)=>{
            if (action.payload && action.payload !== "") {
                state.profile_service_parts_Search = action.payload;
                state.profile_service_parts_Search.status = "succeeded";
            }
        }).addCase(profileServicePartsSearch.rejected, (state, action)=>{
            state.profile_service_parts_Search.status = "failed";
            state.profile_service_parts_Search.error = action.error.message;
        }).addCase(profileBrandTopSearches.pending, (state, action)=>{
            state.profile_brand_Top_Searches.status = "loading";
        }).addCase(profileBrandTopSearches.fulfilled, (state, action)=>{
            if (action.payload && action.payload !== "") {
                state.profile_brand_Top_Searches = action.payload;
                state.profile_brand_Top_Searches.status = "succeeded";
            }
        }).addCase(profileBrandTopSearches.rejected, (state, action)=>{
            state.profile_brand_Top_Searches.status = "failed";
            state.profile_brand_Top_Searches.error = action.error.message;
        }).addCase(profileBrandTypeahead.pending, (state, action)=>{
            state.profile_brand_Typeahead.status = "loading";
        }).addCase(profileBrandTypeahead.fulfilled, (state, action)=>{
            state.profile_brand_Typeahead = action.payload;
            state.profile_brand_Typeahead.status = "succeeded";
        }).addCase(profileBrandTypeahead.rejected, (state, action)=>{
            state.profile_brand_Typeahead.status = "failed";
            state.profile_brand_Top_Searches.error = action.error.message;
        }).addCase(getProducts.pending, (state, action)=>{
            if (!state.plp.initialLoad) {
                state.plp.status = "loading";
            }
        }).addCase(getProducts.fulfilled, (state, action)=>{
            const { data , update , isSuggestion ="" , total =0  } = (action === null || action === void 0 ? void 0 : action.payload) || {};
            if (isSuggestion) {
                state.plp = {
                    ...state.plp,
                    suggestions: data,
                    suggestionExactMatch: isSuggestion
                };
            } else if (update) {
                state.plp = {
                    ...state.plp,
                    data: state.plp.data.concat(data.data)
                };
            } else {
                state.plp = data;
            }
            state.plp.initialLoad = false;
            state.plp.status = "succeeded";
            state.plp.total = total;
        }).addCase(getProducts.rejected, (state, action)=>{
            state.plp.status = "failed";
            state.plp.error = action.error.message;
        });
    }
});
const { setProfileServicePartsSearch , setVisualNavAppliedFilters , setCurrentAppliedfilters , setProfileBrandTypeahead , setProfileBrandSearch , setPlpData , setFilterData , updatePlpData , updatePlpDataStatus , clearSuggestion , clearProductData , setFilterQueryState , setServerData , setFacetLabels , setIsFromVisualNav , setCurrentAppliedfiltersVisualNav , setIsViewDetailClicked  } = productListSlice.actions;
const selectProductListState = (state)=>state.productList;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (productListSlice.reducer);


/***/ }),

/***/ 57879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": function() { return /* binding */ setSearchKeyword; },
/* harmony export */   "Qf": function() { return /* binding */ setSearchFilter; },
/* harmony export */   "Ug": function() { return /* binding */ clearSearchResults; },
/* harmony export */   "Z7": function() { return /* binding */ setDynamicSearchFragment; },
/* harmony export */   "az": function() { return /* binding */ setActiveTabDispatch; },
/* harmony export */   "iv": function() { return /* binding */ searchSlice; },
/* harmony export */   "kj": function() { return /* binding */ setSearchCount; },
/* harmony export */   "mJ": function() { return /* binding */ fetchSearchServicePartsResults; },
/* harmony export */   "u1": function() { return /* binding */ setSearchTabCount; },
/* harmony export */   "uv": function() { return /* binding */ searchState; },
/* harmony export */   "w$": function() { return /* binding */ fetchSearchAllResults; }
/* harmony export */ });
/* unused harmony exports fetchSearchInspirationResults, getSearchProducts, getProducts */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29843);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28858);






const fetchSearchInspirationResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchResults", async (general)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, {
        params: {
            fl: "id",
            fq: [
                'language_s:("'.concat(language, '")')
            ],
            q: "*:*",
            rows: 5,
            profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search"),
            collections: lwAppName.toLowerCase()
        }
    });
    return response.data;
});
const getSearchProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/getProducts", async (payload)=>{
    var ref;
    const { profilename , collections , q , fq , rows , start , fl  } = payload;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?q=").concat(q, "&fl=").concat(fl).concat(fq ? "&fq=".concat(fq.join("&fq=")) : "").concat(rows ? "&rows=" : "").concat(rows ? rows : "").concat(start >= 0 ? "&start=" : "").concat(start >= 0 ? start : "", "&profilename=").concat(profilename, "&collections=").concat(collections, '&fq=language_s:("').concat(language, '")');
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return {
        response
    };
});
const initialState = {
    searchDetails: {},
    search: {
        status: "loading",
        error: ""
    },
    servicePartsSearch: {
        status: "loading",
        error: ""
    },
    searchResponse: {
        data: ""
    },
    servicePartsSearchResponse: {
        data: ""
    },
    dynamicSearchAemData: {
        found: false,
        fragmentPath: ""
    }
};
const fetchSearchAllResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchAllResults", async (params)=>{
    var ref, ref1, ref2;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    if (!params.fq) {
        params.fq = 'language_s:("'.concat(language, '")');
    } else {
        if (typeof params.fq === "string" && params.fq.length > 0) {
            params.fq = [
                params.fq,
                'language_s:("'.concat(language, '")')
            ];
        } else if (Array.isArray(params.fq)) {
            params.fq = [
                ...params.fq,
                'language_s:("'.concat(language, '")')
            ];
        }
    }
    var ref4;
    const canadaPrice = (ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref4 !== void 0 ? ref4 : null;
    if (canadaPrice) {
        params.CanadianPrice = canadaPrice;
    }
    const searchParams = new URLSearchParams(params);
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?").concat(searchParams.toString());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return response.data;
});
const fetchSearchServicePartsResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchServicePartsResults", async (params)=>{
    var ref, ref1, ref2;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    if (!params.fq) {
        params.fq = 'language_s:("'.concat(language, '")');
    } else {
        if (typeof params.fq === "string" && params.fq.length > 0) {
            params.fq = [
                params.fq,
                'language_s:("'.concat(language, '")')
            ];
        } else if (Array.isArray(params.fq)) {
            params.fq = [
                ...params.fq,
                'language_s:("'.concat(language, '")')
            ];
        }
    }
    var ref4;
    const canadaPrice = (ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref4 !== void 0 ? ref4 : null;
    if (canadaPrice) {
        params.CanadianPrice = canadaPrice;
    }
    const searchParams = new URLSearchParams({
        ...params
    });
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?").concat(searchParams.toString());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return response.data;
});
const getProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("plp/getProducts", async (payload)=>{
    const { q , profileName , update , query , collections , displaytype , type  } = payload;
    const { internationalization: { language ="en"  } = {} , apiEndPointData: { map: { canadianPrice =""  } = {}  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const { fq , rows , start , sort  } = query;
    const url = "".concat(type === "parts" ? _constants_index__WEBPACK_IMPORTED_MODULE_1__.PROFILE_END_POINT_CLIENT : _constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?profilename=").concat(profileName).concat(fq ? "&fq=".concat(fq.join("&fq=")) : "").concat(sort ? "&sort=".concat(sort) : "").concat(q ? "&q=".concat(q) : "").concat(collections ? "&collections=".concat(collections) : "").concat(displaytype ? "&displaytype=".concat(displaytype) : "").concat(rows ? "&rows=" : "").concat(rows ? rows : "").concat(start >= 0 ? "&start=" : "").concat(start >= 0 ? start : "").concat('&fq=language_s:("'.concat(language, '")')).concat(canadianPrice ? "&CanadianPrice=".concat(canadianPrice) : null);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    const data = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_3__/* .formatListingData */ .nx)(response.data);
    return {
        data,
        update
    };
});
const searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "search",
    initialState,
    reducers: {
        setSearchCount: (state, action)=>{
            state.searchDetails = {
                ...state.searchDetails,
                ...action.payload
            };
        },
        setDynamicSearchFragment: (state, action)=>{
            state.searchDetails = {
                ...state.searchDetails,
                dynamicSearchAemData: {
                    ...action.payload
                }
            };
        },
        setSearchTabCount: (state, action)=>{
            const { tabType , count  } = action.payload;
            if (!state.searchDetails[tabType]) {
                state.searchDetails[tabType] = {};
            }
            state.searchDetails = {
                ...state.searchDetails,
                [tabType]: {
                    ...state.searchDetails[tabType],
                    count: count
                }
            };
        },
        setSearchFilter: (state, param)=>{
            let { payload: { key ="" , queries =[]  }  } = param;
            const searchDetails = {
                ...state.searchDetails
            };
            if (key) searchDetails[key] = {
                ...searchDetails[key],
                filters: queries
            };
            state.searchDetails = {
                ...state.searchDetails
            };
            state.searchDetails = searchDetails;
        },
        setSearchKeyword: (state, action)=>{
            state.searchDetails = {
                ...state.searchDetails,
                keyword: action.payload
            };
        },
        setActiveTabDispatch: (state, action)=>{
            state.searchDetails = {
                ...state.searchDetails,
                activeTab: action.payload
            };
        },
        clearSearchResults: (state)=>{
            state.searchResponse.data = "";
            state.servicePartsSearchResponse.data = "";
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(fetchSearchAllResults.pending, (state, action)=>{
            state.search.status = "loading";
        }).addCase(fetchSearchAllResults.fulfilled, (state, action)=>{
            state.search.status = "succeeded";
            state.search.error = "";
            state.searchResponse.data = action.payload;
        }).addCase(fetchSearchAllResults.rejected, (state, action)=>{
            state.search.status = "failed";
            state.search.error = action.error.message;
        }).addCase(fetchSearchServicePartsResults.pending, (state, action)=>{
            state.servicePartsSearch.status = "loading";
        }).addCase(fetchSearchServicePartsResults.fulfilled, (state, action)=>{
            state.servicePartsSearch.status = "succeeded";
            state.servicePartsSearch.error = "";
            state.servicePartsSearchResponse.data = action.payload;
        }).addCase(fetchSearchServicePartsResults.rejected, (state, action)=>{
            state.servicePartsSearch.status = "failed";
            state.servicePartsSearch.error = action.error.message;
        }).addCase(getSearchProducts.pending, (state, action)=>{
            state.searchDetails.status = "loading";
        }).addCase(getSearchProducts.fulfilled, (state, action)=>{
            state.searchDetails = action.payload;
            state.searchDetails.status = "succeeded";
        }).addCase(getSearchProducts.rejected, (state, action)=>{
            state.searchDetails.status = "failed";
            state.searchDetails.error = action.error.message;
        });
    }
});
const { setSearchCount , setSearchTabCount , setSearchFilter , setSearchKeyword , setActiveTabDispatch , clearSearchResults , setDynamicSearchFragment  } = searchSlice.actions;
const searchState = (state)=>state.search;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (searchSlice.reducer);


/***/ }),

/***/ 53882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LG": function() { return /* binding */ shopTheRoomSlice; },
/* harmony export */   "Lg": function() { return /* binding */ shopTheRoomState; },
/* harmony export */   "MK": function() { return /* binding */ laodingStatus; },
/* harmony export */   "Ti": function() { return /* binding */ setRoomList; },
/* harmony export */   "f4": function() { return /* binding */ getFilterShopRoomList; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28858);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29843);






const laodingStatus = {
    loading: "loading",
    success: "success",
    rejected: "faiure"
};
const shopTheRoomInitialState = {
    roomList: undefined,
    filterList: undefined,
    facets: undefined,
    facetLabels: undefined,
    fusion: {},
    status: laodingStatus.loading
};
const shopTheRoomSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "shopTheRoomState",
    initialState: shopTheRoomInitialState,
    reducers: {
        setRoomList (state, param) {
            let { payload  } = param;
            var ref, ref1, ref2, ref3;
            var ref4;
            state.roomList = (ref4 = (ref = payload.shopTheRoomData) === null || ref === void 0 ? void 0 : ref.data) !== null && ref4 !== void 0 ? ref4 : [];
            var ref5;
            state.facets = (ref5 = (ref1 = payload.shopTheRoomData) === null || ref1 === void 0 ? void 0 : ref1.facets) !== null && ref5 !== void 0 ? ref5 : {};
            var ref6;
            state.facetLabels = (ref6 = (ref2 = payload.shopTheRoomData) === null || ref2 === void 0 ? void 0 : ref2.facetLabels) !== null && ref6 !== void 0 ? ref6 : {};
            var ref7;
            state.fusion = (ref7 = payload === null || payload === void 0 ? void 0 : (ref3 = payload.shopTheRoomData) === null || ref3 === void 0 ? void 0 : ref3.fusion) !== null && ref7 !== void 0 ? ref7 : {};
            state.status = laodingStatus.success;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(getFilterShopRoomList.fulfilled, (state, param)=>{
            let { payload  } = param;
            var _data;
            state.roomList = (_data = payload.data) !== null && _data !== void 0 ? _data : state.roomList;
            var ref;
            state.facets = (ref = payload === null || payload === void 0 ? void 0 : payload.facets) !== null && ref !== void 0 ? ref : state.facets;
            var ref1;
            state.facetLabels = (ref1 = payload === null || payload === void 0 ? void 0 : payload.facetLabels) !== null && ref1 !== void 0 ? ref1 : state.facets;
            var ref2;
            state.fusion = (ref2 = payload === null || payload === void 0 ? void 0 : payload.fusion) !== null && ref2 !== void 0 ? ref2 : state.fusion;
            state.status = laodingStatus.success;
        }).addCase(getFilterShopRoomList.pending, (state)=>{
            state.status = laodingStatus.loading;
        }).addCase(getFilterShopRoomList.rejected, (state)=>{
            state.status = laodingStatus.rejected;
        });
    }
});
const clientShopRoomListFl = [
    "templateName_s",
    "landingFileReference_s",
    "cq_shoptheroomtags_s",
    "productSkuIds_s",
    "modelFileReference_s",
    "cardHoverTitle_s",
    "title_s",
    "cardTitle_s",
    "url_s",
    "strTheme_ss",
    "strColor_ss",
    "strRoom_s",
    "strDesignStyle_s"
];
const getFilterShopRoomList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("shopTheRoomList/getfilterList", async (payLoad)=>{
    const { sort =null , fq =[] , profilename ="Shop_The_Room"  } = payLoad;
    const fl = [
        ...clientShopRoomListFl
    ];
    const params = {
        fl: fl.join(),
        collection: "kohler",
        profilename,
        rows: 30,
        ...fq.length ? {
            fq
        } : {},
        ...sort ? {
            sort
        } : {}
    };
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, {
        params,
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_5___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const data = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_3__/* .formatListingData */ .nx)(response.data);
    return data;
});
const { setRoomList  } = shopTheRoomSlice.actions;
const shopTheRoomState = (state)=>state.shopTheRoomState;
/* harmony default export */ __webpack_exports__["ZP"] = (shopTheRoomSlice.reducer);


/***/ }),

/***/ 16407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nu": function() { return /* binding */ selectvsresultState; },
/* harmony export */   "to": function() { return /* binding */ vsresultSlice; },
/* harmony export */   "yC": function() { return /* binding */ updateVSResultData; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28858);


const initialState = {
    loading: false,
    productsResult: {}
};
const vsresultSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "vsresult",
    initialState: initialState,
    reducers: {
        updateVSResultData (state, param) {
            let { payload  } = param;
            state.productsResult = payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        });
    }
});
const { updateVSResultData  } = vsresultSlice.actions;
const selectvsresultState = (state)=>state.vsresult;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (vsresultSlice.reducer);


/***/ }),

/***/ 88032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ store; },
  "YS": function() { return /* binding */ wrapper; }
});

// UNUSED EXPORTS: makeStore

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/redux-persist/lib/storage/createWebStorage.js
var createWebStorage = __webpack_require__(23488);
;// CONCATENATED MODULE: ./store/syncStorage.js

const createNoopStorage = ()=>{
    return {
        getItem (_key) {
            return Promise.resolve(null);
        },
        setItem (_key, value) {
            return Promise.resolve(value);
        },
        removeItem (_key) {
            return Promise.resolve();
        }
    };
};
const storage =  true ? (0,createWebStorage/* default */.Z)("local") : 0;
/* harmony default export */ var syncStorage = (storage);

// EXTERNAL MODULE: ./node_modules/redux-persist/es/index.js + 11 modules
var es = __webpack_require__(97568);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./store/features/orderSlice.js
var orderSlice = __webpack_require__(76977);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./node_modules/redux-persist-transform-filter/dist/index.js
var dist = __webpack_require__(38551);
// EXTERNAL MODULE: ./node_modules/redux-persist/lib/stateReconciler/autoMergeLevel2.js
var autoMergeLevel2 = __webpack_require__(1190);
// EXTERNAL MODULE: ./store/features/searchSlice.js
var searchSlice = __webpack_require__(57879);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./store/features/myProductSlice.js
var myProductSlice = __webpack_require__(3507);
;// CONCATENATED MODULE: ./store/features/inspirationSlice.js

const initialState = {
    inspirations: {
        selectedInspiration: {},
        loading: true,
        fq: [],
        data: [],
        total: 0,
        facets: [],
        start: 0,
        colors: {},
        grouped: false
    }
};
const getInspirationDetails = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("inspirations/getInspirationDetails", async ()=>{
// Placeholder Inspiration slice So That It Can Be Overridden For AnnSacks Inspiration Page.
});
const inspirationSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "inspirations",
    initialState,
    reducers: {},
    extraReducers: ()=>{
    // Placeholder Inspiration slice So That It Can Be Overridden For AnnSacks Inspiration Page.
    }
});
/* harmony default export */ var features_inspirationSlice = (inspirationSlice.reducer);

// EXTERNAL MODULE: ./store/features/shopTheRoomSlice.js
var shopTheRoomSlice = __webpack_require__(53882);
;// CONCATENATED MODULE: ./store/features/asPlpSlice.js

const asPlpSlice_initialState = {
    plp: {
        loaded: false,
        loading: true,
        fq: [],
        data: [],
        total: 0,
        facets: [],
        facetLabels: [],
        start: 0,
        colors: {},
        grouped: false
    }
};
const getProducts = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("asPlp/getProducts", async ()=>{
// Placeholder PLP slice so that it can be overridden for AnnSacks PLP Page.
});
const asPlpSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "asPlp",
    initialState: asPlpSlice_initialState,
    reducers: {},
    extraReducers: ()=>{
    // Placeholder PLP slice so that it can be overridden for AnnSacks PLP Page.
    }
});
const { startLoading , stopLoading  } = asPlpSlice.actions;
const selectPlpState = (state)=>state.asPlp;
/* harmony default export */ var features_asPlpSlice = (asPlpSlice.reducer);

;// CONCATENATED MODULE: ./store/features/asPdpSlice.js

const asPdpSlice_initialState = {
    asProductDetails: {
        sku: "",
        slug: "",
        variants: [],
        recommendedAccessories: [],
        productBrand: "",
        data: {}
    }
};
const asPdpSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "asPdp",
    initialState: asPdpSlice_initialState,
    reducers: {},
    extraReducers: ()=>{
    // Placeholder PLP slice so that it can be overridden for AnnSacks PLP Page.
    }
});
const { setAsProductDetails  } = asPdpSlice.actions;
const selectPdpState = (state)=>state.asPdp;
/* harmony default export */ var features_asPdpSlice = (asPdpSlice.reducer);

// EXTERNAL MODULE: ./store/features/accordionSlice.js
var accordionSlice = __webpack_require__(93014);
// EXTERNAL MODULE: ./store/features/invalidSelectionSlice.js
var invalidSelectionSlice = __webpack_require__(49265);
// EXTERNAL MODULE: ./store/features/vsresultSlice.js
var vsresultSlice = __webpack_require__(16407);
;// CONCATENATED MODULE: ./store/index.js

























const combinedReducer = (0,redux/* combineReducers */.UY)({
    [authSlice/* authSlice.name */.Gb.name]: authSlice/* authSlice.reducer */.Gb.reducer,
    [cartSlice/* cartSlice.name */.Ao.name]: cartSlice/* cartSlice.reducer */.Ao.reducer,
    [locationSlice/* locationSlice.name */.vM.name]: locationSlice/* locationSlice.reducer */.vM.reducer,
    [genericSlice/* genericSlice.name */.JN.name]: genericSlice/* genericSlice.reducer */.JN.reducer,
    [checkoutSlice/* checkoutSlice.name */.vu.name]: checkoutSlice/* checkoutSlice.reducer */.vu.reducer,
    [productListSlice/* productListSlice.name */.Tx.name]: productListSlice/* productListSlice.reducer */.Tx.reducer,
    [orderSlice/* orderSlice.name */.zM.name]: orderSlice/* orderSlice.reducer */.zM.reducer,
    [favoritesSlice/* favoritesSlice.name */.MY.name]: favoritesSlice/* favoritesSlice.reducer */.MY.reducer,
    [inspirationSlice.name]: inspirationSlice.reducer,
    [compareSlice/* compareSlice.name */.qD.name]: compareSlice/* compareSlice.reducer */.qD.reducer,
    [searchSlice/* searchSlice.name */.iv.name]: searchSlice/* searchSlice.reducer */.iv.reducer,
    [pdpSlice/* pdpSlice.name */.ou.name]: pdpSlice/* pdpSlice.reducer */.ou.reducer,
    [myProductSlice/* myProductSlice.name */.dj.name]: myProductSlice/* myProductSlice.reducer */.dj.reducer,
    [shopTheRoomSlice/* shopTheRoomSlice.name */.LG.name]: shopTheRoomSlice/* default */.ZP,
    [asPlpSlice.name]: asPlpSlice.reducer,
    [asPdpSlice.name]: asPdpSlice.reducer,
    [accordionSlice/* default.name */.ZP.name]: accordionSlice/* default.reducer */.ZP.reducer,
    [invalidSelectionSlice/* default.name */.ZP.name]: invalidSelectionSlice/* default.reducer */.ZP.reducer,
    [vsresultSlice/* vsresultSlice.name */.to.name]: vsresultSlice/* vsresultSlice.reducer */.to.reducer
});
let store;
const makeStore = ()=>{
    const isServer = "object" === "undefined";
    if (isServer) {
        // If it's on server side, create a store
        return (0,redux_toolkit_esm/* configureStore */.xC)({
            reducer: combinedReducer,
            middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                    serializableCheck: {
                        ignoredActions: [
                            es.FLUSH,
                            es.REHYDRATE,
                            es.PAUSE,
                            es.PERSIST,
                            es.PURGE,
                            es.REGISTER
                        ]
                    }
                })
        });
    } else {
        // If it's on client side, create a store which will persist
        const authSubsetFilter = (0,dist/* default */.ZP)("auth", [
            "anonymousId",
            "access_token",
            "refresh_token",
            "expires_in",
            "revalidate_in",
            "hashedEmail",
            "customerProspect"
        ]);
        const persistConfig = {
            key: "root",
            whitelist: [
                "auth",
                "location",
                "compare"
            ],
            transforms: [
                authSubsetFilter
            ],
            storage: syncStorage,
            stateReconciler: autoMergeLevel2/* default */.Z
        };
        const persistedReducer = (0,es.persistReducer)(persistConfig, combinedReducer);
        store = (0,redux_toolkit_esm/* configureStore */.xC)({
            reducer: persistedReducer,
            middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                    serializableCheck: {
                        ignoredActions: [
                            es.FLUSH,
                            es.REHYDRATE,
                            es.PAUSE,
                            es.PERSIST,
                            es.PURGE,
                            es.REGISTER
                        ]
                    }
                })
        });
        store.__persistor = (0,es.persistStore)(store);
        return store;
    }
};

const wrapper = (0,es6/* createWrapper */.KV)(makeStore);


/***/ }),

/***/ 51666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ getMaxVersionLists; },
/* harmony export */   "MQ": function() { return /* binding */ getSessionId; },
/* harmony export */   "ZV": function() { return /* binding */ getUserListLineItems; },
/* harmony export */   "_z": function() { return /* binding */ getMultiDeleteItemsPayLoad; },
/* harmony export */   "mK": function() { return /* binding */ getMovieToListAndDeleteFormListItems; },
/* harmony export */   "oq": function() { return /* binding */ getSessionIdObjWithEpoc; },
/* harmony export */   "xE": function() { return /* binding */ getTntId; }
/* harmony export */ });
const getSessionIdObjWithEpoc = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let sessionCookie = (ref1 = cookies.find((myCookie)=>myCookie.includes("session#"))) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    sessionCookie = (ref2 = sessionCookie.split("|").find((item)=>item.includes("session"))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const sessionCookies = (ref3 = sessionCookie.split("#")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    const sessionId = (ref4 = sessionCookies[1]) !== null && ref4 !== void 0 ? ref4 : "";
    return sessionId ? "".concat(sessionId, "-").concat(Date.now()) : "";
};
const getSessionId = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let sessionCookie = (ref1 = cookies.find((myCookie)=>myCookie.includes("session#"))) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    sessionCookie = (ref2 = sessionCookie.split("|").find((item)=>item.includes("session"))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const sessionCookies = (ref3 = sessionCookie.split("#")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    return (ref4 = sessionCookies[1]) !== null && ref4 !== void 0 ? ref4 : "";
};
const getTntId = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let tntCookie = decodeURIComponent((ref1 = cookies.find((myCookie)=>myCookie.includes("AMCV_"))) !== null && ref1 !== void 0 ? ref1 : "");
    var ref2;
    tntCookie = (ref2 = tntCookie.split("|")) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    return (ref3 = tntCookie[4]) !== null && ref3 !== void 0 ? ref3 : "";
};
const getUserListLineItems = (results)=>{
    const listItems = {};
    const listItemsSkus = {};
    results.forEach((list)=>{
        list === null || list === void 0 ? void 0 : list.lineItems.forEach((lineItem)=>{
            var ref;
            listItems[lineItem === null || lineItem === void 0 ? void 0 : lineItem.productId] = {
                ...lineItem,
                listName: list === null || list === void 0 ? void 0 : list.name,
                listId: list === null || list === void 0 ? void 0 : list.id,
                listVersion: list === null || list === void 0 ? void 0 : list.version
            };
            listItemsSkus[lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku] = {
                ...lineItem,
                listName: list === null || list === void 0 ? void 0 : list.name,
                listId: list === null || list === void 0 ? void 0 : list.id,
                listVersion: list === null || list === void 0 ? void 0 : list.version
            };
        });
    });
    return [
        listItems,
        listItemsSkus
    ];
};
const getMaxVersionOfList = (listName, lists, locale)=>{
    const versions = [];
    lists.forEach((list)=>{
        if ((list === null || list === void 0 ? void 0 : list.name[locale]) === listName) {
            versions.push(list === null || list === void 0 ? void 0 : list.version);
        }
    });
    return Math.max(...versions);
};
const removeSystemDefinedLists = (userList)=>{
    const systemDefinedListNames = [
        "MyProducts",
        "MyServices",
        "MesServices",
        "Mes produits"
    ];
    return userList.filter((list)=>!systemDefinedListNames.includes(list));
};
const getMaxVersionLists = (result, locale)=>{
    const listNames = [];
    const finalLists = [];
    result.forEach((list)=>{
        listNames.push(list === null || list === void 0 ? void 0 : list.name[locale]);
    });
    const uniqueListNames = removeSystemDefinedLists([
        ...new Set(listNames)
    ]);
    uniqueListNames.forEach((listName)=>{
        const maxVersion = getMaxVersionOfList(listName, result, locale);
        result.forEach((list)=>{
            if (listName && (list === null || list === void 0 ? void 0 : list.name[locale]) === listName && (list === null || list === void 0 ? void 0 : list.version) === maxVersion) {
                finalLists.push(list);
            }
        });
    });
    return finalLists;
};
const getMultiDeleteItemsPayLoad = (list, selectedItems)=>{
    const deletePayLoad = [];
    selectedItems.forEach((productSku)=>{
        list.lineItems.forEach((lineItem)=>{
            var ref;
            if ((lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku) === productSku) {
                deletePayLoad.push({
                    action: "removeLineItem",
                    lineItemId: lineItem.id
                });
            }
        });
    });
    return deletePayLoad;
};
const getMovieToListAndDeleteFormListItems = (selectedItems, currentList, productData, productQtyObj)=>{
    const deleteItemsList = [];
    const addItemsList = [];
    selectedItems.forEach((productSku)=>{
        currentList.lineItems.forEach((lineItem)=>{
            var ref;
            if ((lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku) === productSku) {
                deleteItemsList.push({
                    action: "removeLineItem",
                    lineItemId: lineItem.id
                });
                addItemsList.push({
                    action: "addLineItem",
                    sku: productSku,
                    quantity: productQtyObj[productSku],
                    custom: {
                        type: {
                            key: "lineItemShoppingList",
                            typeId: "type"
                        }
                    }
                });
            }
        });
    });
    return [
        deleteItemsList,
        addItemsList
    ];
};


/***/ }),

/***/ 75227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$u": function() { return /* binding */ DynamicShopTheRoomList; },
/* harmony export */   "bA": function() { return /* binding */ DynamicStickyNavHeader; },
/* harmony export */   "kO": function() { return /* binding */ DynamicShopTheRoomCard; },
/* harmony export */   "xE": function() { return /* binding */ DynamicFilter; }
/* harmony export */ });
/* unused harmony export DynamicBreadcrumb */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const DummyComponent = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
const ComponentContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)([
    {
        Component: DummyComponent,
        componentProps: {}
    }
]);
const DynamicShopTheRoomList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1976), __webpack_require__.e(7783), __webpack_require__.e(5979), __webpack_require__.e(6598)]).then(__webpack_require__.bind(__webpack_require__, 6598)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6598)
            ]
    }
});
const DynamicFilter = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(361), __webpack_require__.e(772)]).then(__webpack_require__.bind(__webpack_require__, 50772)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50772)
            ]
    }
});
const DynamicBreadcrumb = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 3282).then(__webpack_require__.bind(__webpack_require__, 3282)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3282)
            ]
    }
});
const DynamicShopTheRoomCard = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 75781)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75781)
            ]
    }
});
const DynamicStickyNavHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2857), __webpack_require__.e(2247), __webpack_require__.e(4751), __webpack_require__.e(1217)]).then(__webpack_require__.bind(__webpack_require__, 24751)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24751)
            ]
    }
});
/* harmony default export */ __webpack_exports__["ZP"] = (ComponentContext);


/***/ }),

/***/ 27522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ addToCartItem; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/**
 * It add to cart Utility for pay load
 * @returns the addToCartItem
 */ 
const addToCartItem = async (items)=>{
    var ref;
    let userZipCode;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref1;
    const salesChannels = (ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {};
    const actionPayload = actionProduct(items, salesChannels, userZipCode);
    return actionPayload;
};
/**
 *  payload to add to cart.
 * @param {items} items The first param.
 * @param {salesChannels} salesChannels The second param.
 * @param {userZipCode} userZipCode The third param.
 * @return {object} the pay load for add to cart
 */ const actionProduct = (items, salesChannels, userZipCode)=>{
    const actions = [];
    let actionData;
    items.forEach((product)=>{
        const { lineItemId , isBundle =false , isBundleProduct =false , isBundleParent =false , sku ="" , quantity =0 , additionalInfo , brand ="" , zipCode =""  } = product;
        const { roomInfo ="" , customQuantity =0 , overage =""  } = additionalInfo !== null && additionalInfo !== void 0 ? additionalInfo : {};
        var _brand;
        const fields = {
            ...zipCode ? {
                zipCode
            } : {},
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        const bundlePayload = {
            action: "changeBundleItemQuantity",
            customLineItemId: lineItemId,
            sku,
            quantity
        };
        const payload = {
            action: isBundleProduct ? "addBundleItem" : isBundle ? "addbundle" : "addLineItem",
            sku,
            quantity,
            custom: additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[brand],
                    roomInfo,
                    customQuantity,
                    overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        };
        actions.push(isBundleParent ? bundlePayload : payload);
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
        actionData = [
            ...actions
        ];
    });
    return actionData;
};


/***/ }),

/***/ 55954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "getAppInsights": function() { return /* binding */ getAppInsights; },
  "getCurrentPageViewId": function() { return /* binding */ getCurrentPageViewId; },
  "initAppInsights": function() { return /* binding */ initAppInsights; }
});

;// CONCATENATED MODULE: ./node_modules/@nevware21/ts-utils/dist/es5/mod/ts-utils.js
/* provided dependency */ var process = __webpack_require__(34155);
/*! https://github.com/nevware21/ts-utils v0.13.0 */
/*
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */
/*#__NO_SIDE_EFFECTS__*/
function _pureAssign(func1, func2) {
    return func1 || func2;
}
/*#__NO_SIDE_EFFECTS__*/
function _pureRef(value, name) {
    return value[name];
}

var UNDEF_VALUE = undefined;
var NULL_VALUE = null;
var EMPTY = "";
var FUNCTION = "function";
var OBJECT = "object";
var PROTOTYPE = "prototype";
var __PROTO__ = "__proto__";
var UNDEFINED = "undefined";
var CONSTRUCTOR = "constructor";
var SYMBOL = "Symbol";
var LENGTH = "length";
var NAME = "name";
var CALL = "call";
var TO_STRING = "toString";
var GET_OWN_PROPERTY_DESCRIPTOR = "getOwnPropertyDescriptor";
var GET_OWN_PROPERTY_NAMES = "getOwnPropertyNames";
var GET_OWN_PROPERTY_SYMBOLS = "getOwnPropertySymbols";
var ts_utils_ObjClass = ( /*#__PURE__*/_pureAssign(Object));
var ts_utils_ObjProto = ( /*#__PURE__*/_pureRef(ts_utils_ObjClass, PROTOTYPE));
var StrCls = ( /*#__PURE__*/_pureAssign(String));
var StrProto = ( /*#__PURE__*/_pureRef(StrCls, PROTOTYPE));
var MathCls = ( /*#__PURE__*/_pureAssign(Math));
var ArrCls = ( /*#__PURE__*/_pureAssign(Array));
var ArrProto = ( /*#__PURE__*/_pureRef(ArrCls, PROTOTYPE));
var ArrSlice = ( /*#__PURE__*/_pureRef(ArrProto, "slice"));
var NumberCls = ( /*#__PURE__*/_pureAssign(Number));

var POLYFILL_TAG = "_polyfill";
var POLYFILL_TYPE_NAME = "__nw21$polytype__";
function _isPolyfill(obj) {
    return !!(obj && obj[POLYFILL_TAG]);
}
function _isPolyfillType(obj, polyfillTypeName) {
    return !!(obj && obj[POLYFILL_TYPE_NAME] === polyfillTypeName);
}

function ts_utils_safe(func, argArray) {
    try {
        return {
            v: func.apply(this, argArray)
        };
    }
    catch (e) {
        return { e: e };
    }
}

/*#__NO_SIDE_EFFECTS__*/
function safeGet(cb, defValue, argArray) {
    var result = ts_utils_safe(cb, argArray);
    return result.e ? defValue : result.v;
}

var _primitiveTypes;
/*#__NO_SIDE_EFFECTS__*/
function _createIs(theType) {
    return function (value) {
        return typeof value === theType;
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _createIsWithPoly(theType) {
    return function (value) {
        return typeof value === theType || _isPolyfillType(value, theType);
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _createObjIs(theName) {
    var theType = "[object " + theName + "]";
    return function (value) {
        return !!(value && objToString(value) === theType);
    };
}
/*#__NO_SIDE_EFFECTS__*/
function objToString(value) {
    return ts_utils_ObjProto[TO_STRING].call(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isTypeof(value, theType) {
    return typeof value === theType;
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isUndefined(value) {
    return typeof value === UNDEFINED || value === UNDEFINED;
}
/*#__NO_SIDE_EFFECTS__*/
function isStrictUndefined(arg) {
    return arg === UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isNullOrUndefined(value) {
    return value === NULL_VALUE || ts_utils_isUndefined(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isStrictNullOrUndefined(value) {
    return value === NULL_VALUE || value === UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/
function isDefined(arg) {
    return !!arg || arg !== UNDEF_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isPrimitive(value) {
    return value === NULL_VALUE || isPrimitiveType(typeof value);
}
/*#__NO_SIDE_EFFECTS__*/
function isPrimitiveType(theType) {
    !_primitiveTypes && (_primitiveTypes = ["string", "number", "boolean", UNDEFINED, "symbol", "bigint"]);
    return !!(theType !== OBJECT && _primitiveTypes.indexOf(theType) !== -1);
}
var ts_utils_isString = ( /*#__PURE__*/_createIs("string"));
var ts_utils_isFunction = ( /*#__PURE__*/_createIs(FUNCTION));
var isAsyncFunction = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("AsyncFunction"))));
var isGenerator = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("GeneratorFunction"))));
var isAsyncGenerator = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("AsyncGeneratorFunction"))));
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isObject(value) {
    if (!value && ts_utils_isNullOrUndefined(value)) {
        return false;
    }
    return !!value && typeof value === OBJECT;
}
var ts_utils_isArray = ( /* #__PURE__*/_pureRef(ArrCls, "isArray"));
var ts_utils_isDate = ( /*#__PURE__*/_createObjIs("Date"));
var ts_utils_isNumber = ( /*#__PURE__*/_createIs("number"));
var isBoolean = ( /*#__PURE__*/_createIs("boolean"));
var isRegExp = ( /*#__PURE__*/_createObjIs("RegExp"));
var isFile = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("File"))));
var isFormData = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("FormData"))));
var isBlob = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("Blob"))));
var isArrayBuffer = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("ArrayBuffer"))));
var ts_utils_isError = ( /*#__PURE__*/_createObjIs("Error"));
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isPromiseLike(value) {
    return !!(value && value.then && ts_utils_isFunction(value.then));
}
var isThenable = (/* unused pure expression or super */ null && (ts_utils_isPromiseLike));
/*#__NO_SIDE_EFFECTS__*/
function isPromise(value) {
    return !!(value && value.then && value.catch && ts_utils_isFunction(value.then) && ts_utils_isFunction(value.catch));
}
var isMap = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("Map"))));
var isWeakMap = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("WeakMap"))));
var isSet = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("Set"))));
var isWeakSet = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createObjIs("WeakSet"))));
/*#__NO_SIDE_EFFECTS__*/
function isMapLike(value) {
    return !!(value &&
        ts_utils_isFunction(value.get) &&
        ts_utils_isFunction(value.set) &&
        ts_utils_isFunction(value.has) &&
        ts_utils_isFunction(value.delete) &&
        ts_utils_isNumber(value.size));
}
function isSetLike(value) {
    return !!(value &&
        ts_utils_isFunction(value.add) &&
        ts_utils_isFunction(value.has) &&
        ts_utils_isFunction(value.delete) &&
        ts_utils_isNumber(value.size));
}
/*#__NO_SIDE_EFFECTS__*/
function isNotTruthy(value) {
    return !value || !isTruthy(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isTruthy(value) {
    return !(!value || safeGet(function () { return !(value && (0 + value)); }, !value));
}
var isBigInt = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createIsWithPoly("bigint"))));

function _returnNothing() {
    return;
}
function _returnEmptyArray() {
    return [];
}
function _returnFalse() {
    return false;
}

var ts_utils_asString = ( /*#__PURE__*/_pureAssign(StrCls));

var ERROR_TYPE = "[object Error]";
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_dumpObj(object, format) {
    var propertyValueDump = EMPTY;
    var objType = ts_utils_ObjProto[TO_STRING][CALL](object);
    if (objType === ERROR_TYPE) {
        object = { stack: ts_utils_asString(object.stack), message: ts_utils_asString(object.message), name: ts_utils_asString(object.name) };
    }
    try {
        propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? ((typeof format === "number") ? format : 4) : UNDEF_VALUE);
        propertyValueDump = (propertyValueDump ? propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : NULL_VALUE) || ts_utils_asString(object);
    }
    catch (e) {
        propertyValueDump = " - " + ts_utils_dumpObj(e, format);
    }
    return objType + ": " + propertyValueDump;
}

function throwError(message) {
    throw new Error(message);
}
function ts_utils_throwTypeError(message) {
    throw new TypeError(message);
}
function throwRangeError(message) {
    throw new RangeError(message);
}

function _throwIfNullOrUndefined(obj) {
    if (isStrictNullOrUndefined(obj)) {
        ts_utils_throwTypeError("Cannot convert undefined or null to object");
    }
}
function _throwIfNotString(value) {
    if (!ts_utils_isString(value)) {
        ts_utils_throwTypeError("'" + ts_utils_dumpObj(value) + "' is not a string");
    }
}

/*#__NO_SIDE_EFFECTS__*/
function ts_utils_objHasOwnProperty(obj, prop) {
    return !!obj && ts_utils_ObjProto.hasOwnProperty[CALL](obj, prop);
}

var _objGetOwnPropertyDescriptor$2 = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_DESCRIPTOR)), _returnNothing));
var objHasOwn = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "hasOwn")), polyObjHasOwn));
/*#__NO_SIDE_EFFECTS__*/
function polyObjHasOwn(obj, prop) {
    _throwIfNullOrUndefined(obj);
    return ts_utils_objHasOwnProperty(obj, prop) || !!_objGetOwnPropertyDescriptor$2(obj, prop);
}

function ts_utils_objForEachKey(theObject, callbackfn, thisArg) {
    if (theObject && (ts_utils_isObject(theObject) || ts_utils_isFunction(theObject))) {
        for (var prop in theObject) {
            if (objHasOwn(theObject, prop)) {
                if (callbackfn[CALL](thisArg || theObject, prop, theObject[prop]) === -1) {
                    break;
                }
            }
        }
    }
}

function ts_utils_arrForEach(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[LENGTH] >>> 0;
        for (var idx = 0; idx < len; idx++) {
            if (idx in theArray) {
                if (callbackfn[CALL](thisArg || theArray, theArray[idx], idx, theArray) === -1) {
                    break;
                }
            }
        }
    }
}

var _unwrapFunction = ( _unwrapFunctionWithPoly);
/*#__NO_SIDE_EFFECTS__*/
function _unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
    var clsFn = clsProto ? clsProto[funcName] : NULL_VALUE;
    return function (thisArg) {
        var theFunc = (thisArg ? thisArg[funcName] : NULL_VALUE) || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL](theArgs, 1) : theArgs);
        }
        ts_utils_throwTypeError("\"" + ts_utils_asString(funcName) + "\" not defined for " + ts_utils_dumpObj(thisArg));
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _unwrapProp(propName) {
    return function (thisArg) {
        return thisArg[propName];
    };
}

function _objPropertyIsEnum(obj, propKey) {
    var desc;
    var fn = ts_utils_ObjClass.getOwnPropertyDescriptor;
    if (!isStrictNullOrUndefined(obj) && fn) {
        desc = ts_utils_safe(fn, [obj, propKey]).v || NULL_VALUE;
    }
    if (!desc) {
        desc = ts_utils_safe(function () {
            for (var key in obj) {
                if (key === propKey) {
                    return { enumerable: true };
                }
            }
        }).v;
    }
    return (desc && desc.enumerable) || false;
}
var objPropertyIsEnumerable = ( /*#__PURE__*/_unwrapFunctionWithPoly("propertyIsEnumerable", NULL_VALUE, _objPropertyIsEnum));

var _objGetOwnPropertyDescriptor$1 = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_DESCRIPTOR)), _returnNothing));
var _objGetOwnPropertySymbols = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_SYMBOLS)), _returnEmptyArray));
var propMap = {
    e: "enumerable",
    c: "configurable",
    v: "value",
    w: "writable",
    g: "get",
    s: "set"
};
/*#__NO_SIDE_EFFECTS__*/
function _createProp(value) {
    var prop = {};
    prop[propMap["c"]] = true;
    prop[propMap["e"]] = true;
    if (value.l) {
        prop.get = function () { return value.l.v; };
        var desc = _objGetOwnPropertyDescriptor$1(value.l, "v");
        if (desc && desc.set) {
            prop.set = function (newValue) {
                value.l.v = newValue;
            };
        }
    }
    ts_utils_objForEachKey(value, function (key, value) {
        prop[propMap[key]] = isStrictUndefined(value) ? prop[propMap[key]] : value;
    });
    return prop;
}
var ts_utils_objDefineProp = ( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "defineProperty"));
var objDefineProperties = ( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "defineProperties"));
function objDefineGet(target, key, value, configurable, enumerable) {
    var _a;
    return ts_utils_objDefineProp(target, key, _createProp((_a = {
            e: enumerable,
            c: configurable
        },
        _a[ts_utils_isFunction(value) ? "g" : "v"] = value,
        _a)));
}
function objDefineAccessors(target, prop, getProp, setProp, configurable, enumerable) {
    var desc = {
        e: enumerable,
        c: configurable
    };
    if (getProp) {
        desc.g = getProp;
    }
    if (setProp) {
        desc.s = setProp;
    }
    return ts_utils_objDefineProp(target, prop, _createProp(desc));
}
function ts_utils_objDefine(target, key, propDesc) {
    return ts_utils_objDefineProp(target, key, _createProp(propDesc));
}
function objDefineProps(target, propDescMap) {
    var props = {};
    ts_utils_objForEachKey(propDescMap, function (key, value) {
        props[key] = _createProp(value);
    });
    ts_utils_arrForEach(_objGetOwnPropertySymbols(propDescMap), function (sym) {
        if (objPropertyIsEnumerable(propDescMap, sym)) {
            props[sym] = _createProp(propDescMap[sym]);
        }
    });
    return objDefineProperties(target, props);
}

/*#__NO_SIDE_EFFECTS__*/
function _createKeyValueMap(values, keyType, valueType, completeFn, writable) {
    var theMap = {};
    ts_utils_objForEachKey(values, function (key, value) {
        _assignMapValue(theMap, key, keyType ? value : key);
        _assignMapValue(theMap, value, valueType ? value : key);
    });
    return completeFn ? completeFn(theMap) : theMap;
}
function _assignMapValue(theMap, key, value, writable) {
    ts_utils_objDefineProp(theMap, key, {
        value: value,
        enumerable: true,
        writable: false
    });
}

function _objIterateEntries(obj, mapper) {
    var result = [];
    ts_utils_objForEachKey(obj, function (key, val) {
        result.push(mapper(key, val));
    });
    return result;
}
/*#__NO_SIDE_EFFECTS__*/
function polyObjKeys(obj) {
    _throwIfNullOrUndefined(obj);
    if (!ts_utils_isObject(obj)) {
        ts_utils_throwTypeError("non-object " + ts_utils_dumpObj(obj));
    }
    return _objIterateEntries(obj, function (k, _) { return k; });
}
/*#__NO_SIDE_EFFECTS__*/
function polyObjEntries(value) {
    return _objIterateEntries(value, function (k, v) { return [k, v]; });
}
/*#__NO_SIDE_EFFECTS__*/
function polyObjValues(value) {
    return _objIterateEntries(value, function (_, v) { return v; });
}

function polyObjIs(value1, value2) {
    if (value1 !== value1) {
        return value2 !== value2;
    }
    if (value1 === 0 && value2 === 0) {
        return 1 / value1 === 1 / value2;
    }
    return value1 === value2;
}

var objIsFrozen = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "isFrozen")), _returnFalse));
var objIsSealed = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "isSealed")), _returnFalse))));

var _objFreeze = ( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "freeze"));
function _doNothing(value) {
    return value;
}
/*#__NO_SIDE_EFFECTS__*/
function _getProto(value) {
    _throwIfNullOrUndefined(value);
    return value[__PROTO__] || NULL_VALUE;
}
var objAssign = ( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "assign"));
var objKeys = ( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "keys"));
function _deepFreeze(val, visited) {
    if ((ts_utils_isArray(val) || ts_utils_isObject(val) || ts_utils_isFunction(val)) && !objIsFrozen(val)) {
        for (var lp = 0; lp < visited.length; lp++) {
            if (visited[lp] === val) {
                return val;
            }
        }
        visited.push(val);
        ts_utils_objForEachKey(val, function (_key, propValue) {
            _deepFreeze(propValue, visited);
        });
        objFreeze(val);
    }
    return val;
}
function ts_utils_objDeepFreeze(value) {
    return _objFreeze ? _deepFreeze(value, []) : value;
}
var objFreeze = ( /*#__PURE__*/_pureAssign(_objFreeze, _doNothing));
var objSeal = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "seal")), _doNothing))));
var objGetPrototypeOf = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "getPrototypeOf")), _getProto));
var objEntries = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "entries")), polyObjEntries))));
var objValues = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "values")), polyObjValues))));
var objIs = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "is")), polyObjIs));

/*#__NO_SIDE_EFFECTS__*/
function createEnum(values) {
    return _createKeyValueMap(values, 1 , 0 , objFreeze);
}
/*#__NO_SIDE_EFFECTS__*/
function createEnumKeyMap(values) {
    return _createKeyValueMap(values, 0 , 0 , objFreeze);
}
/*#__NO_SIDE_EFFECTS__*/
function createEnumValueMap(values) {
    return _createKeyValueMap(values, 1 , 1 , objFreeze);
}
/*#__NO_SIDE_EFFECTS__*/
function createSimpleMap(values) {
    var mapClass = {};
    ts_utils_objForEachKey(values, function (key, value) {
        _assignMapValue(mapClass, key, value[1]);
        _assignMapValue(mapClass, value[0], value[1]);
    });
    return objFreeze(mapClass);
}
/*#__NO_SIDE_EFFECTS__*/
function createTypeMap(values) {
    return createSimpleMap(values);
}

var _wellKnownSymbolMap = ( /*#__PURE__*/createEnumKeyMap({
    asyncIterator: 0 ,
    hasInstance: 1 ,
    isConcatSpreadable: 2 ,
    iterator: 3 ,
    match: 4 ,
    matchAll: 5 ,
    replace: 6 ,
    search: 7 ,
    species: 8 ,
    split: 9 ,
    toPrimitive: 10 ,
    toStringTag: 11 ,
    unscopables: 12
}));

var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var _globalCfg;
/*#__NO_SIDE_EFFECTS__*/
function _getGlobalValue() {
    var result;
    if (typeof globalThis !== UNDEFINED) {
        result = globalThis;
    }
    if (!result && typeof self !== UNDEFINED) {
        result = self;
    }
    if (!result && typeof window !== UNDEFINED) {
        result = window;
    }
    if (!result && typeof __webpack_require__.g !== UNDEFINED) {
        result = __webpack_require__.g;
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/
function _getGlobalConfig() {
    if (!_globalCfg) {
        var gbl = ts_utils_safe(_getGlobalValue).v || {};
        _globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
    }
    return _globalCfg;
}

var mathMin = ( /*#__PURE__*/_pureRef(MathCls, "min"));
var mathMax = ( /*#__PURE__*/_pureRef(MathCls, "max"));

var strSlice = ( /*#__PURE__*/_unwrapFunction("slice", StrProto));

var ts_utils_strSubstring = ( /*#__PURE__*/_unwrapFunction("substring", StrProto));
var strSubstr = ( /*#__PURE__*/_unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr));
/*#__NO_SIDE_EFFECTS__*/
function polyStrSubstr(value, start, length) {
    _throwIfNullOrUndefined(value);
    if (length < 0) {
        return EMPTY;
    }
    start = start || 0;
    if (start < 0) {
        start = mathMax(start + value[LENGTH], 0);
    }
    if (ts_utils_isUndefined(length)) {
        return strSlice(value, start);
    }
    return strSlice(value, start, start + length);
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_strLeft(value, count) {
    return ts_utils_strSubstring(value, 0, count);
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_strRight(value, count) {
    return count <= 0 ? EMPTY : (value[LENGTH] > count ? strSlice(value, -count) : value);
}

function _tagAsPolyfill(target, polyfillTypeName) {
    if (target) {
        ts_utils_safe(function () {
            target[POLYFILL_TAG] = true;
            target[POLYFILL_TYPE_NAME] = polyfillTypeName;
        });
        ts_utils_safe(ts_utils_objDefine, [target, POLYFILL_TAG, {
                v: true,
                w: false,
                e: false
            }]);
        ts_utils_safe(ts_utils_objDefine, [target, POLYFILL_TYPE_NAME, {
                v: polyfillTypeName,
                w: false,
                e: false
            }]);
    }
    return target;
}

var objCreate = ( /* #__PURE__*/_pureAssign(( /* #__PURE__*/_pureRef(ts_utils_ObjClass, "create")), polyObjCreate));
/*#__NO_SIDE_EFFECTS__*/
function polyObjCreate(obj, properties) {
    var newObj = null;
    function tempFunc() { }
    if (!isStrictNullOrUndefined(obj)) {
        var type = typeof obj;
        if (type !== OBJECT && type !== FUNCTION) {
            ts_utils_throwTypeError("Prototype must be an Object or function: " + ts_utils_dumpObj(obj));
        }
        tempFunc[PROTOTYPE] = obj;
        ts_utils_safe(function () {
            tempFunc[__PROTO__] = obj;
        });
        newObj = new tempFunc();
    }
    else {
        newObj = {};
    }
    if (properties) {
        ts_utils_safe(objDefineProperties, [newObj, properties]);
    }
    return newObj;
}

/*#__NO_SIDE_EFFECTS__*/
function ts_utils_utcNow() {
    return (Date.now || polyUtcNow)();
}
/*#__NO_SIDE_EFFECTS__*/
function polyUtcNow() {
    return new Date().getTime();
}

function ts_utils_fnApply(fn, thisArg, argArray) {
    return fn.apply(thisArg, argArray);
}
function ts_utils_fnCall(fn, thisArg) {
    return fn.apply(thisArg, ArrSlice[CALL](arguments, 2));
}
function fnBind(fn, thisArg) {
    return fn.bind.apply(fn, ArrSlice[CALL](arguments, 1));
}

var _globalLazyTestHooks;
function _initTestHooks() {
    _globalLazyTestHooks = _getGlobalConfig();
}
/*#__NO_SIDE_EFFECTS__*/
function getLazy(cb, argArray) {
    var lazyValue = {};
    !_globalLazyTestHooks && _initTestHooks();
    lazyValue.b = _globalLazyTestHooks.lzy;
    ts_utils_objDefineProp(lazyValue, "v", {
        configurable: true,
        get: function () {
            var result = ts_utils_fnApply(cb, null, argArray);
            if (!_globalLazyTestHooks.lzy) {
                ts_utils_objDefineProp(lazyValue, "v", {
                    value: result
                });
            }
            lazyValue.b = _globalLazyTestHooks.lzy;
            return result;
        }
    });
    return lazyValue;
}
function setBypassLazyCache(newValue) {
    !_globalLazyTestHooks && _initTestHooks();
    _globalLazyTestHooks.lzy = newValue;
}
function getWritableLazy(cb, argArray) {
    var lazyValue = {};
    !_globalLazyTestHooks && _initTestHooks();
    lazyValue.b = _globalLazyTestHooks.lzy;
    var _setValue = function (newValue) {
        ts_utils_objDefineProp(lazyValue, "v", {
            value: newValue,
            writable: true
        });
        if (lazyValue.b) {
            delete lazyValue.b;
        }
    };
    ts_utils_objDefineProp(lazyValue, "v", {
        configurable: true,
        get: function () {
            var result = ts_utils_fnApply(cb, null, argArray);
            if (!_globalLazyTestHooks.lzy) {
                _setValue(result);
            }
            if (_globalLazyTestHooks.lzy && lazyValue.b !== _globalLazyTestHooks.lzy) {
                lazyValue.b = _globalLazyTestHooks.lzy;
            }
            return result;
        },
        set: _setValue
    });
    return lazyValue;
}

var mathRandom = ( /*#__PURE__*/_pureRef(MathCls, "random"));

var _uniqueInstanceId = ( /*#__PURE__*/getLazy(function () {
    var value = (ts_utils_utcNow().toString(36).slice(2));
    while (value.length < 16) {
        value += mathRandom().toString(36).slice(2);
    }
    value = value.substring(0, 16);
    return value;
}));

var UNIQUE_REGISTRY_ID = "_urid";
var POLY_SYM = "$nw21sym";
var _polySymbols;
var _polyId = 0;
/*#__NO_SIDE_EFFECTS__*/
function _globalSymbolRegistry() {
    if (!_polySymbols) {
        var gblCfg = _getGlobalConfig();
        _polySymbols = gblCfg.gblSym = gblCfg.gblSym || { k: {}, s: {} };
    }
    return _polySymbols;
}
var _wellKnownSymbolCache;
/*#__NO_SIDE_EFFECTS__*/
function polyNewSymbol(description) {
    var uniqueId = "_" + _polyId++ + "_" + _uniqueInstanceId.v;
    var symString = SYMBOL + "(" + description + ")";
    function _setProp(name, value) {
        ts_utils_objDefine(theSymbol, name, {
            v: value,
            e: false,
            w: false
        });
    }
    var theSymbol = objCreate(null);
    _setProp("description", ts_utils_asString(description));
    _setProp(TO_STRING, function () { return symString + POLY_SYM + uniqueId; });
    _setProp("valueOf", function () { return theSymbol; });
    _setProp("v", symString);
    _setProp("_uid", uniqueId);
    return _tagAsPolyfill(theSymbol, "symbol");
}
/*#__NO_SIDE_EFFECTS__*/
function polySymbolFor(key) {
    var registry = _globalSymbolRegistry();
    if (!objHasOwn(registry.k, key)) {
        var newSymbol_1 = polyNewSymbol(key);
        var regId_1 = objKeys(registry.s).length;
        newSymbol_1[UNIQUE_REGISTRY_ID] = function () { return regId_1 + "_" + newSymbol_1[TO_STRING](); };
        registry.k[key] = newSymbol_1;
        registry.s[newSymbol_1[UNIQUE_REGISTRY_ID]()] = ts_utils_asString(key);
    }
    return registry.k[key];
}
/*#__NO_SIDE_EFFECTS__*/
function polySymbolKeyFor(sym) {
    if (!sym || !sym[TO_STRING] || ts_utils_strSubstring(sym[TO_STRING](), 0, 6) != SYMBOL) {
        ts_utils_throwTypeError(sym + " is not a symbol");
    }
    var regId = _isPolyfill(sym) && sym[UNIQUE_REGISTRY_ID] && sym[UNIQUE_REGISTRY_ID]();
    return regId ? _globalSymbolRegistry().s[regId] : undefined;
}
/*#__NO_SIDE_EFFECTS__*/
function polyGetKnownSymbol(name) {
    !_wellKnownSymbolCache && (_wellKnownSymbolCache = {});
    var result;
    var knownName = _wellKnownSymbolMap[name];
    if (knownName) {
        result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || polyNewSymbol(SYMBOL + "." + knownName);
    }
    return result;
}

/*#__NO_SIDE_EFFECTS__*/
function ts_utils_createCachedValue(value) {
    return ts_utils_objDefineProp({
        toJSON: function () { return value; }
    }, "v", { value: value });
}
var createDeferredCachedValue = getDeferred;
/*#__NO_SIDE_EFFECTS__*/
function getDeferred(cb, argArray) {
    var theValue = {
        toJSON: function () { return theValue.v; }
    };
    return ts_utils_objDefineProp(theValue, "v", {
        get: function () {
            var result = ts_utils_fnApply(cb, null, argArray);
            cb = NULL_VALUE;
            ts_utils_objDefineProp(theValue, "v", { value: result });
            return result;
        },
        configurable: true
    });
}
/*#__NO_SIDE_EFFECTS__*/
function getWritableDeferred(cb, argArray) {
    var theValue = {
        toJSON: function () { return theValue.v; }
    };
    var _setValue = function (newValue) {
        ts_utils_objDefineProp(theValue, "v", {
            value: newValue,
            writable: true
        });
    };
    return ts_utils_objDefineProp(theValue, "v", {
        get: function () {
            var result = ts_utils_fnApply(cb, null, argArray);
            _setValue(result);
            cb = NULL_VALUE;
            return result;
        },
        set: _setValue,
        configurable: true
    });
}

var WINDOW = "window";
var _cachedGlobal;
function _getGlobalInstFn(getFn, theArgs) {
    var cachedValue;
    return function () {
        !_globalLazyTestHooks && _initTestHooks();
        if (!cachedValue || _globalLazyTestHooks.lzy) {
            cachedValue = ts_utils_createCachedValue(ts_utils_safe(getFn, theArgs).v);
        }
        return cachedValue.v;
    };
}
/*#__NO_SIDE_EFFECTS__*/
function lazySafeGetInst(name) {
    return getLazy(function () { return ts_utils_safe((ts_utils_getInst), [name]).v || UNDEF_VALUE; });
}
function getGlobal(useCached) {
    !_globalLazyTestHooks && _initTestHooks();
    if (!_cachedGlobal || useCached === false || _globalLazyTestHooks.lzy) {
        _cachedGlobal = ts_utils_createCachedValue(ts_utils_safe(_getGlobalValue).v || NULL_VALUE);
    }
    return _cachedGlobal.v;
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_getInst(name, useCached) {
    var gbl;
    if (!_cachedGlobal || useCached === false) {
        gbl = getGlobal(useCached);
    }
    else {
        gbl = _cachedGlobal.v;
    }
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    if (name === WINDOW) {
        try {
            return window;
        }
        catch (e) {
        }
    }
    return NULL_VALUE;
}
/*#__NO_SIDE_EFFECTS__*/
function hasDocument() {
    return !!( /*#__PURE__*/ts_utils_getDocument());
}
var ts_utils_getDocument = ( /*#__PURE__*/_getGlobalInstFn(ts_utils_getInst, ["document"]));
/*#__NO_SIDE_EFFECTS__*/
function hasWindow() {
    return !!( /*#__PURE__*/getWindow());
}
var getWindow = ( /*#__PURE__*/_getGlobalInstFn(ts_utils_getInst, [WINDOW]));
/*#__NO_SIDE_EFFECTS__*/
function hasNavigator() {
    return !!( /*#__PURE__*/getNavigator());
}
var getNavigator = ( /*#__PURE__*/_getGlobalInstFn(ts_utils_getInst, ["navigator"]));
/*#__NO_SIDE_EFFECTS__*/
function hasHistory() {
    return !!( /*#__PURE__*/getHistory());
}
var getHistory = ( /*#__PURE__*/_getGlobalInstFn(ts_utils_getInst, ["history"]));
var isNode = ( /*#__PURE__*/_getGlobalInstFn(function () {
    return !!( /*#__PURE__*/ts_utils_safe(function () { return (process && (process.versions || {}).node); }).v);
}));
var isWebWorker = ( /*#__PURE__*/_getGlobalInstFn(function () {
    return !!( /*#__PURE__*/ts_utils_safe(function () { return self && self instanceof WorkerGlobalScope; }).v);
}));

var _symbol;
var _symbolFor;
var _symbolKeyFor;
/*#__NO_SIDE_EFFECTS__*/
function _initSymbol() {
    _symbol = ( /*#__PURE__*/ts_utils_createCachedValue(ts_utils_safe((ts_utils_getInst), [SYMBOL]).v));
    return _symbol;
}
function _getSymbolKey(key) {
    var gblSym = ((!_globalLazyTestHooks.lzy ? _symbol : 0) || _initSymbol());
    return (gblSym.v ? gblSym.v[key] : UNDEF_VALUE);
}
var isSymbol = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createIsWithPoly("symbol"))));
/*#__NO_SIDE_EFFECTS__*/
function hasSymbol() {
    return !!( /*#__PURE__*/getSymbol());
}
/*#__NO_SIDE_EFFECTS__*/
function getSymbol() {
    !_globalLazyTestHooks && _initTestHooks();
    return ((!_globalLazyTestHooks.lzy ? _symbol : 0) || _initSymbol()).v;
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_getKnownSymbol(name, noPoly) {
    var knownName = _wellKnownSymbolMap[name];
    !_globalLazyTestHooks && _initTestHooks();
    var sym = ((!_globalLazyTestHooks.lzy ? _symbol : 0) || _initSymbol());
    return sym.v ? sym.v[knownName || name] : (!noPoly ? polyGetKnownSymbol(name) : UNDEF_VALUE);
}
/*#__NO_SIDE_EFFECTS__*/
function newSymbol(description, noPoly) {
    !_globalLazyTestHooks && _initTestHooks();
    var sym = ((!_globalLazyTestHooks.lzy ? _symbol : 0) || _initSymbol());
    return sym.v ? sym.v(description) : (!noPoly ? polyNewSymbol(description) : NULL_VALUE);
}
/*#__NO_SIDE_EFFECTS__*/
function symbolFor(key) {
    !_globalLazyTestHooks && _initTestHooks();
    _symbolFor = ((!_globalLazyTestHooks.lzy ? _symbolFor : 0) || ( /*#__PURE__*/ts_utils_createCachedValue(ts_utils_safe((_getSymbolKey), ["for"]).v)));
    return (_symbolFor.v || polySymbolFor)(key);
}
/*#__NO_SIDE_EFFECTS__*/
function symbolKeyFor(sym) {
    !_globalLazyTestHooks && _initTestHooks();
    _symbolKeyFor = ((!_globalLazyTestHooks.lzy ? _symbolKeyFor : 0) || ( /*#__PURE__*/ts_utils_createCachedValue(ts_utils_safe((_getSymbolKey), ["keyFor"]).v)));
    return (_symbolKeyFor.v || polySymbolKeyFor)(sym);
}

/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isIterator(value) {
    return !!value && ts_utils_isFunction(value.next);
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_isIterable(value) {
    return !isStrictNullOrUndefined(value) && ts_utils_isFunction(value[ts_utils_getKnownSymbol(3 )]);
}

var _iterSymbol$1;
function ts_utils_iterForOf(iter, callbackfn, thisArg) {
    if (iter) {
        if (!ts_utils_isIterator(iter)) {
            !_iterSymbol$1 && (_iterSymbol$1 = ts_utils_createCachedValue(ts_utils_getKnownSymbol(3 )));
            iter = iter[_iterSymbol$1.v] ? iter[_iterSymbol$1.v]() : NULL_VALUE;
        }
        if (ts_utils_isIterator(iter)) {
            var err = UNDEF_VALUE;
            var iterResult = UNDEF_VALUE;
            try {
                var count = 0;
                while (!(iterResult = iter.next()).done) {
                    if (callbackfn[CALL](thisArg || iter, iterResult.value, count, iter) === -1) {
                        break;
                    }
                    count++;
                }
            }
            catch (failed) {
                err = { e: failed };
                if (iter.throw) {
                    iterResult = NULL_VALUE;
                    iter.throw(err);
                }
            }
            finally {
                try {
                    if (iterResult && !iterResult.done) {
                        iter.return && iter.return(iterResult);
                    }
                }
                finally {
                    if (err) {
                        // eslint-disable-next-line no-unsafe-finally
                        throw err.e;
                    }
                }
            }
        }
    }
}

function arrAppend(target, elms) {
    if (!ts_utils_isUndefined(elms) && target) {
        if (ts_utils_isArray(elms)) {
            ts_utils_fnApply(target.push, target, elms);
        }
        else if (ts_utils_isIterator(elms) || ts_utils_isIterable(elms)) {
            ts_utils_iterForOf(elms, function (elm) {
                target.push(elm);
            });
        }
        else {
            target.push(elms);
        }
    }
    return target;
}

var arrEvery = /*#__PURE__*/ (/* unused pure expression or super */ null && (_unwrapFunction("every", ArrProto)));
var arrFilter = /*#__PURE__*/ (/* unused pure expression or super */ null && (_unwrapFunction("filter", ArrProto)));

var ts_utils_arrIndexOf = ( /*#__PURE__*/_unwrapFunction("indexOf", ArrProto));
var arrLastIndexOf = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_unwrapFunction("lastIndexOf", ArrProto))));

var arrMap = ( /*#__PURE__*/_unwrapFunction("map", ArrProto));

function ts_utils_arrSlice(theArray, start, end) {
    return ((theArray ? theArray["slice"] : NULL_VALUE) || ArrSlice).apply(theArray, ArrSlice[CALL](arguments, 1));
}

/*#__NO_SIDE_EFFECTS__*/
function polyIsArray(value) {
    if (ts_utils_isNullOrUndefined(value)) {
        return false;
    }
    return objToString(value) === "[object Array]";
}
/*#__NO_SIDE_EFFECTS__*/
function polyArrIncludes(theArray, searchElement, fromIndex) {
    return ts_utils_arrIndexOf(theArray, searchElement, fromIndex) !== -1;
}
function polyArrFind(theArray, callbackFn, thisArg) {
    var result;
    var idx = polyArrFindIndex(theArray, callbackFn, thisArg);
    return idx !== -1 ? theArray[idx] : result;
}
function polyArrFindIndex(theArray, callbackFn, thisArg) {
    var result = -1;
    ts_utils_arrForEach(theArray, function (value, index) {
        if (callbackFn[CALL](thisArg | theArray, value, index, theArray)) {
            result = index;
            return -1;
        }
    });
    return result;
}
function polyArrFindLast(theArray, callbackFn, thisArg) {
    var result;
    var idx = polyArrFindLastIndex(theArray, callbackFn, thisArg);
    return idx !== -1 ? theArray[idx] : result;
}
function polyArrFindLastIndex(theArray, callbackFn, thisArg) {
    var result = -1;
    var len = theArray[LENGTH] >>> 0;
    for (var idx = len - 1; idx >= 0; idx--) {
        if (idx in theArray && callbackFn[CALL](thisArg | theArray, theArray[idx], idx, theArray)) {
            result = idx;
            break;
        }
    }
    return result;
}
function polyArrFrom(theValue, mapFn, thisArg) {
    if (ts_utils_isArray(theValue)) {
        var result_1 = ts_utils_arrSlice(theValue);
        return mapFn ? arrMap(result_1, mapFn, thisArg) : result_1;
    }
    var result = [];
    ts_utils_iterForOf(theValue, function (value, cnt) {
        return result.push(mapFn ? mapFn[CALL](thisArg, value, cnt) : value);
    });
    return result;
}

var arrFind = /*#__PURE__*/ (/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("find", ArrProto, polyArrFind)));
var arrFindIndex = /*#__PURE__*/ (/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("findIndex", ArrProto, polyArrFindIndex)));
var arrFindLast = /*#__PURE__*/ (/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("findLast", ArrProto, polyArrFindLast)));
var arrFindLastIndex = /*#__PURE__*/ (/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("findLastIndex", ArrProto, polyArrFindLastIndex)));

var arrFrom = ( /* #__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /* #__PURE__*/_pureRef(ArrCls, "from")), polyArrFrom))));

var arrIncludes = ( /*#__PURE__*/_unwrapFunctionWithPoly("includes", ArrProto, polyArrIncludes));
var arrContains = (/* unused pure expression or super */ null && (arrIncludes));

var arrReduce = ( /*#__PURE__*/_unwrapFunction("reduce", ArrProto));

var arrSome = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_unwrapFunction("some", ArrProto))));

/*#__NO_SIDE_EFFECTS__*/
function createFnDeferredProxy(hostFn, funcName) {
    return function () {
        var theArgs = ArrSlice[CALL](arguments);
        var theHost = hostFn();
        return ts_utils_fnApply(theHost[funcName], theHost, theArgs);
    };
}
function createProxyFuncs(target, host, funcDefs) {
    if (target && host && ts_utils_isArray(funcDefs)) {
        var isDeferred_1 = ts_utils_isFunction(host);
        ts_utils_arrForEach(funcDefs, function (funcDef) {
            var targetName = (funcDef.as || funcDef.n);
            if (funcDef.rp === false && target[targetName]) {
                return;
            }
            target[targetName] = isDeferred_1 ?
                createFnDeferredProxy(host, funcDef.n) :
                fnBind(host[funcDef.n], host);
        });
    }
    return target;
}

var _iterSymbol;
/*#__NO_SIDE_EFFECTS__*/
function readArgs(theArgs, start, end) {
    if (!objHasOwn(theArgs, LENGTH)) {
        !_iterSymbol && (_iterSymbol = ts_utils_createCachedValue(hasSymbol() && ts_utils_getKnownSymbol(3 )));
        var iterFn = void 0;
        if (_iterSymbol.v) {
            iterFn = theArgs[_iterSymbol.v];
        }
        if (iterFn) {
            var values_1 = [];
            var from_1 = (start === UNDEF_VALUE || start < 0) ? 0 : start;
            var to_1 = end < 0 || start < 0 ? UNDEF_VALUE : end;
            ts_utils_iterForOf(iterFn[CALL](theArgs), function (value, cnt) {
                if (to_1 !== UNDEF_VALUE && cnt >= to_1) {
                    return -1;
                }
                if (cnt >= from_1) {
                    values_1.push(value);
                }
            });
            if ((start === UNDEF_VALUE || start >= 0) && (end === UNDEF_VALUE || end >= 0)) {
                return values_1;
            }
            theArgs = values_1;
        }
    }
    return ts_utils_arrSlice(theArgs, start, end);
}

var _isProtoArray;
var objSetPrototypeOf = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "setPrototypeOf")), _polyObjSetPrototypeOf));
function _polyObjSetPrototypeOf(obj, proto) {
    var _a;
    !_isProtoArray && (_isProtoArray = ts_utils_createCachedValue((_a = {}, _a[__PROTO__] = [], _a) instanceof Array));
    _isProtoArray.v ? obj[__PROTO__] = proto : ts_utils_objForEachKey(proto, function (key, value) { return obj[key] = value; });
    return obj;
}

/*#__NO_SIDE_EFFECTS__*/
function _createCustomError(name, d, b) {
    ts_utils_safe(ts_utils_objDefine, [d, NAME, { v: name, c: true, e: false }]);
    d = objSetPrototypeOf(d, b);
    function __() {
        this[CONSTRUCTOR] = d;
        ts_utils_safe(ts_utils_objDefine, [this, NAME, { v: name, c: true, e: false }]);
    }
    d[PROTOTYPE] = b === NULL_VALUE ? objCreate(b) : (__[PROTOTYPE] = b[PROTOTYPE], new __());
    return d;
}
function _setName(baseClass, name) {
    name && (baseClass[NAME] = name);
}
/*#__NO_SIDE_EFFECTS__*/
function ts_utils_createCustomError(name, constructCb, errorBase, superArgsFn) {
    var theBaseClass = errorBase || Error;
    var orgName = theBaseClass[PROTOTYPE][NAME];
    var captureFn = Error.captureStackTrace;
    return _createCustomError(name, function () {
        var _this = this;
        var theArgs = arguments;
        try {
            ts_utils_safe(_setName, [theBaseClass, name]);
            var _self = ts_utils_fnApply(theBaseClass, _this, superArgsFn ? superArgsFn(theArgs) : ArrSlice[CALL](theArgs)) || _this;
            if (_self !== _this) {
                var orgProto = objGetPrototypeOf(_this);
                if (orgProto !== objGetPrototypeOf(_self)) {
                    objSetPrototypeOf(_self, orgProto);
                }
            }
            captureFn && captureFn(_self, _this[CONSTRUCTOR]);
            constructCb && constructCb(_self, theArgs);
            return _self;
        }
        finally {
            ts_utils_safe(_setName, [theBaseClass, orgName]);
        }
    }, theBaseClass);
}
var _unsupportedError;
function throwUnsupported(message) {
    if (!_unsupportedError) {
        _unsupportedError = ts_utils_createCustomError("UnsupportedError");
    }
    throw new _unsupportedError(message);
}

function isElement(value) {
    return !!value && value.nodeType === 1 &&
        !!value.nodeName &&
        !!(typeof Element !== "undefined" && value instanceof Element);
}
function isElementLike(value) {
    return !!value && value.nodeType === 1 && !!value.nodeName;
}

function isEmpty(value) {
    var result = isStrictNullOrUndefined(value);
    if (!result) {
        if (ts_utils_isString(value) || ts_utils_isArray(value)) {
            result = (value.length === 0);
        }
        else if (isMapLike(value) || isSetLike(value)) {
            result = (value.size === 0);
        }
        else if (ts_utils_isObject(value)) {
            result = objKeys(value).length === 0;
        }
    }
    return result;
}

/*#__NO_SIDE_EFFECTS__*/
function _createTrimFn(exp) {
    return function _doTrim(value) {
        _throwIfNullOrUndefined(value);
        if (value && value.replace) {
            value = value.replace(exp, EMPTY);
        }
        return value;
    };
}
var polyStrTrim = ( /*#__PURE__*/_createTrimFn(/^\s+|(?=\s)\s+$/g));
var polyStrTrimStart = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createTrimFn(/^\s+/g))));
var polyStrTrimEnd = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createTrimFn(/(?=\s)\s+$/g))));

var strTrim = ( /*#__PURE__*/_unwrapFunctionWithPoly("trim", StrProto, polyStrTrim));
var strTrimStart = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("trimStart", StrProto, polyStrTrimStart))));
var strTrimLeft = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(strTrimStart))));
var strTrimEnd = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("trimEnd", StrProto, polyStrTrimEnd))));
var strTrimRight = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(strTrimEnd))));

var strUpper = ( /*#__PURE__*/_unwrapFunction("toUpperCase", StrProto));
var strLower = ( /*#__PURE__*/_unwrapFunction("toLowerCase", StrProto));

/*#__NO_SIDE_EFFECTS__*/
function _convertCase(value, newPrefix, upperWord) {
    return strTrim(ts_utils_asString(value)).replace(/((_|\W)+(\w){0,1}|([a-z])([A-Z]))/g, function (_match, _g1, _g2, wordStart, upperPrefix, upperLetter) {
        var convertMatch = wordStart || upperLetter || EMPTY;
        if (upperWord) {
            convertMatch = strUpper(convertMatch);
        }
        return (upperPrefix || EMPTY) + newPrefix + convertMatch;
    });
}
/*#__NO_SIDE_EFFECTS__*/
function strLetterCase(value) {
    return ts_utils_asString(value).replace(/(_|\b)\w/g, strUpper);
}
/*#__NO_SIDE_EFFECTS__*/
function strCamelCase(value, upperFirst) {
    var result = _convertCase(value, "", true);
    return result.replace(/^\w/, upperFirst ? strUpper : strLower);
}
/*#__NO_SIDE_EFFECTS__*/
function strKebabCase(value, scream) {
    var result = _convertCase(value, "-");
    return (scream ? strUpper : strLower)(result);
}
/*#__NO_SIDE_EFFECTS__*/
function strSnakeCase(value, scream) {
    var result = _convertCase(value, "_");
    return (scream ? strUpper : strLower)(result);
}

var mathFloor = ( /*#__PURE__*/_pureRef(MathCls, "floor"));
var mathCeil = ( /*#__PURE__*/_pureRef(MathCls, "ceil"));

var mathTrunc = ( /* #__PURE__*/_pureAssign(( /* #__PURE__*/_pureRef(MathCls, "trunc")), polyMathTrunc));
/*#__NO_SIDE_EFFECTS__*/
function polyMathTrunc(value) {
    var theValue = +value;
    return (theValue > 0 ? mathFloor : mathCeil)(theValue);
}

/*#__NO_SIDE_EFFECTS__*/
function mathToInt(value, throwInfinity) {
    var result = +value;
    if (throwInfinity && (result === Infinity || result == Infinity)) {
        throwRangeError("invalid value [" + ts_utils_dumpObj(value) + "]");
    }
    return result !== result || result === 0 ? 0 : mathTrunc(result);
}

var strRepeat = ( /*#__PURE__*/_unwrapFunctionWithPoly("repeat", StrProto, polyStrRepeat));
/*#__NO_SIDE_EFFECTS__*/
function polyStrRepeat(value, count) {
    _throwIfNullOrUndefined(value);
    count = mathToInt(count, true);
    if (count < 0) {
        throwRangeError("invalid count must be >= 0 && < Infinity");
    }
    var pad = ts_utils_isString(value) ? value : ts_utils_asString(value);
    var result = EMPTY;
    for (; count > 0; (count >>>= 1) && (pad += pad)) {
        if (count & 1) {
            result += pad;
        }
    }
    return result;
}

/*#__NO_SIDE_EFFECTS__*/
function _padValue(value, targetLength, padString) {
    var result = EMPTY;
    targetLength = mathToInt(targetLength, true);
    targetLength >>= 0;
    var len = value[LENGTH];
    if (len < targetLength) {
        result = ts_utils_isNullOrUndefined(padString) ? " " : ts_utils_asString(padString);
        targetLength = targetLength - len;
        if (targetLength > result[LENGTH]) {
            result = strRepeat(result, mathCeil(targetLength / result[LENGTH]));
        }
        if (result[LENGTH] > targetLength) {
            result = ts_utils_strSubstring(result, 0, targetLength);
        }
    }
    return result;
}
var strPadStart = ( /*#__PURE__*/_unwrapFunctionWithPoly("padStart", StrProto, polyStrPadStart));
var strPadEnd = ( /*#__PURE__*/_unwrapFunctionWithPoly("padEnd", StrProto, polyStrPadEnd));
/*#__NO_SIDE_EFFECTS__*/
function polyStrPadStart(value, targetLength, padString) {
    return _padValue(value, targetLength, padString) + value;
}
/*#__NO_SIDE_EFFECTS__*/
function polyStrPadEnd(value, targetLength, padString) {
    return value + _padValue(value, targetLength, padString);
}

/*#__NO_SIDE_EFFECTS__*/
function ts_utils_safeGetLazy(cb, defValue, argArray) {
    return getLazy(function () {
        var result = ts_utils_safe(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/
function safeGetWritableLazy(cb, defValue, argArray) {
    return getWritableLazy(function () {
        var result = ts_utils_safe(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/
function safeGetDeferred(cb, defValue, argArray) {
    return getDeferred(function () {
        var result = ts_utils_safe(cb, argArray);
        return result.e ? defValue : result.v;
    });
}
/*#__NO_SIDE_EFFECTS__*/
function safeGetWritableDeferred(cb, defValue, argArray) {
    return getWritableDeferred(function () {
        var result = ts_utils_safe(cb, argArray);
        return result.e ? defValue : result.v;
    });
}

var DBL_QUOTE = "\"";
var INVALID_JS_NAME = /([^\w\d_$])/g;
var BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var HEX_CHARS = "0123456789abcdef";
var _btoa;
var _atob;
var _htmlEntityCache;
var _base64Cache;
/*#__NO_SIDE_EFFECTS__*/
function normalizeJsName(jsName, camelCase) {
    var result = ts_utils_asString(jsName).replace(INVALID_JS_NAME, "_");
    return !ts_utils_isUndefined(camelCase) ? strCamelCase(result, !camelCase) : result;
}
/*#__NO_SIDE_EFFECTS__*/
function encodeAsJson(value, format) {
    var result;
    if (ts_utils_isString(value)) {
        result = DBL_QUOTE + value.replace(/[^\w .,\-!@#$%\^&*\(\)_+={}\[\]:;|<>?]/g, function (match) {
            if (match === DBL_QUOTE || match === "\\") {
                return "\\" + match;
            }
            var hex = match.charCodeAt(0)[TO_STRING](16);
            return "\\u" + strPadStart(strUpper(hex), 4, "0");
        }) + DBL_QUOTE;
    }
    else {
        try {
            result = JSON.stringify(value, NULL_VALUE, format ? (ts_utils_isNumber(format) ? format : 4) : UNDEF_VALUE);
        }
        catch (e) {
            result = DBL_QUOTE + ts_utils_dumpObj(e) + DBL_QUOTE;
        }
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/
function encodeAsHtml(value) {
    !_htmlEntityCache && (_htmlEntityCache = {
        "&": "amp",
        "<": "lt",
        ">": "gt",
        "\"": "quot",
        "'": "#39"
    });
    return ts_utils_asString(value).replace(/[&<>"']/g, function (match) { return "&" + _htmlEntityCache[match] + ";"; });
}
/*#__NO_SIDE_EFFECTS__*/
function encodeAsBase64(value) {
    var result;
    if (value || !isStrictNullOrUndefined(value)) {
        result = ts_utils_asString(value);
        try {
            !_btoa && (_btoa = safeGetDeferred(function () { return !ts_utils_isUndefined(btoa) ? btoa : _encodeBase64Polyfill; }, _encodeBase64Polyfill));
            result = _btoa.v(result);
        }
        catch (e) {
            result = _encodeBase64Polyfill(result);
        }
    }
    return result || EMPTY;
}
/*#__NO_SIDE_EFFECTS__*/
function decodeBase64(value) {
    var result;
    if (value || !isStrictNullOrUndefined(value)) {
        result = ts_utils_asString(value);
        try {
            !_atob && (_atob = safeGetDeferred(function () { return !ts_utils_isUndefined(atob) ? atob : _decodeBase64Polyfill; }, _decodeBase64Polyfill));
            result = _atob.v(result);
        }
        catch (e) {
            result = _decodeBase64Polyfill(result);
        }
    }
    return result || value || EMPTY;
}
/*#__NO_SIDE_EFFECTS__*/
function encodeAsBase64Url(value) {
    var encoded = encodeAsBase64(value);
    if (encoded) {
        encoded = encoded.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    }
    return encoded || EMPTY;
}
/*#__NO_SIDE_EFFECTS__*/
function decodeBase64Url(value) {
    var result;
    if (value || !isStrictNullOrUndefined(value)) {
        result = ts_utils_asString(value);
        var pad = 4 - (result.length % 4);
        if (pad && pad !== 4) {
            result = result + strRepeat("=", pad);
        }
        result = decodeBase64(result.replace(/-/g, "+").replace(/_/g, "/")) || EMPTY;
    }
    return result || value || EMPTY;
}
/*#__NO_SIDE_EFFECTS__*/
function encodeAsHex(value) {
    var result;
    if (value || !isStrictNullOrUndefined(value)) {
        result = ts_utils_asString(value);
        var hex = [];
        for (var idx = 0; idx < result.length; idx++) {
            var code = result.charCodeAt(idx);
            hex.push(HEX_CHARS[(code >> 4) & 0xf]);
            hex.push(HEX_CHARS[code & 0xf]);
        }
        result = hex.join("");
    }
    return result || value || EMPTY;
}
/*#__NO_SIDE_EFFECTS__*/
function decodeHex(value) {
    var result = [];
    if (value || !isStrictNullOrUndefined(value)) {
        var theValue = ts_utils_asString(value);
        for (var idx = 0; idx < theValue.length; idx += 2) {
            result.push(String.fromCharCode(parseInt(strSubstr(theValue, idx, 2), 16)));
        }
    }
    return result.join("");
}
/*#__NO_SIDE_EFFECTS__*/
function encodeAsUri(value) {
    var result;
    if (value || !isStrictNullOrUndefined(value)) {
        try {
            result = encodeURIComponent(ts_utils_asString(value));
        }
        catch (e) {
        }
    }
    return result || value || EMPTY;
}
/*#__NO_SIDE_EFFECTS__*/
function decodeUri(value) {
    var result;
    if (value || !isStrictNullOrUndefined(value)) {
        try {
            result = decodeURIComponent(ts_utils_asString(value));
        }
        catch (e) {
        }
    }
    return result || value || EMPTY;
}
function _encodeBase64Polyfill(str) {
    var result = [];
    if (str || !isStrictNullOrUndefined(str)) {
        str = ts_utils_asString(str);
        var len = str.length;
        var lp = 0;
        while (lp < len) {
            var a = str.charCodeAt(lp++);
            var hasB = lp < len;
            var b = hasB ? str.charCodeAt(lp++) : 0;
            var hasC = lp < len;
            var c = hasC ? str.charCodeAt(lp++) : 0;
            var bitmap = (a << 16) | (b << 8) | c;
            result.push(BASE64_CHARS[(bitmap >> 18) & 63]);
            result.push(BASE64_CHARS[(bitmap >> 12) & 63]);
            if (hasB) {
                result.push(BASE64_CHARS[(bitmap >> 6) & 63]);
            }
            else {
                result.push("=");
            }
            if (hasC) {
                result.push(BASE64_CHARS[bitmap & 63]);
            }
            else {
                result.push("=");
            }
        }
    }
    return result.join("");
}
function _decodeBase64Polyfill(str) {
    var result = [];
    if (str || !isStrictNullOrUndefined(str)) {
        str = ts_utils_asString(str);
        var len = str.length;
        !_base64Cache && (_base64Cache = {});
        if (!_base64Cache["A"]) {
            for (var i = 0; i < BASE64_CHARS.length; i++) {
                _base64Cache[BASE64_CHARS[i]] = i;
            }
        }
        var idx = 0;
        while (idx < len) {
            var a = _base64Cache[str[idx++]] || 0;
            var b = _base64Cache[str[idx++]] || 0;
            var c = _base64Cache[str[idx++]] || 0;
            var d = _base64Cache[str[idx++]] || 0;
            var bitmap = (a << 18) | (b << 12) | (c << 6) | d;
            result.push(String.fromCharCode((bitmap >> 16) & 255));
            if (str[idx - 2] !== "=") {
                result.push(String.fromCharCode((bitmap >> 8) & 255));
            }
            if (str[idx - 1] !== "=") {
                result.push(String.fromCharCode(bitmap & 255));
            }
        }
    }
    return result.join("");
}

var _fnToString;
var _objCtrFnString;
var _gblWindow;
/*#__NO_SIDE_EFFECTS__*/
function isPlainObject(value) {
    if (!value || typeof value !== OBJECT) {
        return false;
    }
    if (!_gblWindow) {
        _gblWindow = hasWindow() ? getWindow() : true;
    }
    var result = false;
    if (value !== _gblWindow) {
        if (!_objCtrFnString) {
            _fnToString = Function[PROTOTYPE][TO_STRING];
            _objCtrFnString = _fnToString[CALL](ts_utils_ObjClass);
        }
        try {
            var proto = objGetPrototypeOf(value);
            result = !proto;
            if (!result) {
                if (ts_utils_objHasOwnProperty(proto, CONSTRUCTOR)) {
                    proto = proto[CONSTRUCTOR];
                }
                result = !!(proto && typeof proto === FUNCTION && _fnToString[CALL](proto) === _objCtrFnString);
            }
        }
        catch (ex) {
        }
    }
    return result;
}

/*#__NO_SIDE_EFFECTS__*/
function _defaultDeepCopyHandler(details) {
    details.value && plainObjDeepCopyHandler(details);
    return true;
}
var defaultDeepCopyHandlers = [
    arrayDeepCopyHandler,
    plainObjDeepCopyHandler,
    functionDeepCopyHandler,
    dateDeepCopyHandler
];
/*#__NO_SIDE_EFFECTS__*/
function _getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    ts_utils_arrForEach(visitMap, function (entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        theEntry = { k: source, v: source };
        visitMap.push(theEntry);
        cb(theEntry);
    }
    return theEntry.v;
}
function _deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? (key ? ctx.path.concat(key) : ctx.path) : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = value === NULL_VALUE;
    if (!isPrim) {
        if (value && theType === OBJECT) {
            isPlain = isPlainObject(value);
        }
        else {
            isPrim = isPrimitiveType(theType);
        }
    }
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function (source, newKey) {
            return _deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function (target, source) {
            return _copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) {
        return _getSetVisited(visitMap, value, newPath, function (newEntry) {
            ts_utils_objDefine(details, "result", {
                g: function () {
                    return newEntry.v;
                },
                s: function (newValue) {
                    newEntry.v = newValue;
                }
            });
            var idx = 0;
            var handler = userHandler;
            while (!(handler || (idx < defaultDeepCopyHandlers.length ? defaultDeepCopyHandlers[idx++] : _defaultDeepCopyHandler))[CALL](ctx, details)) {
                handler = NULL_VALUE;
            }
        });
    }
    if (userHandler && userHandler[CALL](ctx, details)) {
        return details.result;
    }
    return value;
}
function _copyProps(visitMap, target, source, ctx) {
    if (!ts_utils_isNullOrUndefined(source)) {
        for (var key in source) {
            target[key] = _deepCopy(visitMap, source[key], ctx, key);
        }
    }
    return target;
}
function objCopyProps(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return _copyProps([], target, source, ctx);
}
/*#__NO_SIDE_EFFECTS__*/
function objDeepCopy(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return _deepCopy([], source, ctx);
}
function arrayDeepCopyHandler(details) {
    var value = details.value;
    if (ts_utils_isArray(value)) {
        var target = details.result = [];
        target.length = value.length;
        details.copyTo(target, value);
        return true;
    }
    return false;
}
function dateDeepCopyHandler(details) {
    var value = details.value;
    if (ts_utils_isDate(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
function functionDeepCopyHandler(details) {
    if (details.type === FUNCTION) {
        return true;
    }
    return false;
}
function plainObjDeepCopyHandler(details) {
    var value = details.value;
    if (value && details.isPlain) {
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}

function _doExtend(target, theArgs) {
    ts_utils_arrForEach(theArgs, function (theArg) {
        objCopyProps(target, theArg);
    });
    return target;
}
function deepExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(objDeepCopy(target) || {}, ArrSlice[CALL](arguments));
}
function objExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(target || {}, ArrSlice[CALL](arguments));
}

/*#__NO_SIDE_EFFECTS__*/
function polyStrSymSplit(value, splitter, limit) {
    var splitFn = splitter ? splitter[ts_utils_getKnownSymbol(9 )] : UNDEF_VALUE;
    return splitFn ? splitFn(value, limit) : [value];
}

var strSplit = ( /*#__PURE__*/_unwrapFunction("split", StrProto));
var strSymSplit = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_unwrapFunctionWithPoly("split", StrProto, polyStrSymSplit))));

/*#__NO_SIDE_EFFECTS__*/
function getValueByKey(target, path, defValue) {
    if (!path || !target) {
        return defValue;
    }
    var parts = strSplit(path, ".");
    var cnt = parts.length;
    for (var lp = 0; lp < cnt && !ts_utils_isNullOrUndefined(target); lp++) {
        target = target[parts[lp]];
    }
    return (!ts_utils_isNullOrUndefined(target) ? target : defValue);
}
/*#__NO_SIDE_EFFECTS__*/
function getValueByIter(target, iter, defValue) {
    if (!iter || !target) {
        return defValue;
    }
    ts_utils_iterForOf(iter, function (value) {
        if (ts_utils_isNullOrUndefined(target)) {
            return -1;
        }
        target = target[value];
    });
    return (!ts_utils_isNullOrUndefined(target) ? target : defValue);
}
function setValueByKey(target, path, value) {
    if (target && path) {
        var parts = strSplit(path, ".");
        var lastKey = parts.pop();
        ts_utils_arrForEach(parts, function (key) {
            if (ts_utils_isNullOrUndefined(target[key])) {
                target[key] = {};
            }
            target = target[key];
        });
        target[lastKey] = value;
    }
}
function setValueByIter(target, iter, value) {
    if (target && iter) {
        var lastKey_1;
        ts_utils_iterForOf(iter, function (key) {
            if (lastKey_1) {
                if (ts_utils_isNullOrUndefined(target[lastKey_1])) {
                    target[lastKey_1] = {};
                }
                target = target[lastKey_1];
            }
            lastKey_1 = key;
        });
        target[lastKey_1] = value;
    }
}

var ts_utils_getLength = ( /*#__PURE__*/_unwrapProp(LENGTH));

/*#__NO_SIDE_EFFECTS__*/
function getIntValue(value, defValue) {
    try {
        var theValue = value;
        if (!ts_utils_isNumber(value)) {
            theValue = parseInt(ts_utils_asString(value), 10);
        }
        return (ts_utils_isNullOrUndefined(value) || isNaN(theValue)) ? defValue : theValue;
    }
    catch (e) {
    }
    return defValue;
}
var isInteger = ( /* #__PURE__*/_pureAssign(( /* #__PURE__*/_pureRef(NumberCls, "isInteger")), _polyNumberIsInteger));
function _polyNumberIsInteger(value) {
    return ts_utils_isNumber(value) && !isNaN(value) &&
        isFinite(value) &&
        mathFloor(value) === value;
}
function isFiniteNumber(value) {
    return ts_utils_isNumber(value) && !isNaN(value) && isFinite(value);
}

var _perf;
/*#__NO_SIDE_EFFECTS__*/
function hasPerformance() {
    return !!getPerformance();
}
/*#__NO_SIDE_EFFECTS__*/
function getPerformance() {
    !_globalLazyTestHooks && _initTestHooks();
    if (!_perf || _globalLazyTestHooks.lzy) {
        _perf = ts_utils_createCachedValue(ts_utils_safe((ts_utils_getInst), ["performance"]).v);
    }
    return _perf.v;
}
/*#__NO_SIDE_EFFECTS__*/
function perfNow() {
    var perf = getPerformance();
    if (perf && perf.now) {
        return perf.now();
    }
    return ts_utils_utcNow();
}
/*#__NO_SIDE_EFFECTS__*/
function elapsedTime(startTime) {
    return perfNow() - startTime;
}

var MATCH_ANY = "(.*)";
var MATCH_SINGLE = "(.)";
function _createRegExp(value, escapeRgx, replaceFn, ignoreCase, fullMatch) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    return new RegExp((fullMatch ? "^" : EMPTY) + replaceFn(value.replace(escapeRgx, "\\$1")) + (fullMatch ? "$" : EMPTY), ignoreCase ? "i" : "");
}
/*#__NO_SIDE_EFFECTS__*/
function createWildcardRegex(value, ignoreCase, fullMatch) {
    return _createRegExp(ts_utils_asString(value), /([-+|^$#\.\?{}()\[\]\\\/\"\'])/g, function (value) {
        return value.replace(/\*/g, MATCH_ANY);
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/
function createFilenameRegex(value, ignoreCase, fullMatch) {
    return _createRegExp(ts_utils_asString(value), /([-+|^$#\.{}()\\\/\[\]\"\'])/g, function (value) {
        return value.replace(/(\\\\|\\\/|\*|\?)/g, function (_all, g1) {
            if (g1 == "\\/" || g1 == "\\\\") {
                return "[\\\\\\/]{1}";
            }
            return g1 == "*" ? MATCH_ANY : MATCH_SINGLE;
        });
    }, !!ignoreCase, fullMatch);
}
/*#__NO_SIDE_EFFECTS__*/
function makeGlobRegex(value, ignoreCase, fullMatch) {
    return _createRegExp(ts_utils_asString(value), /([-+|^$#\.{}()\\\/\[\]\"\'])/g, function (value) {
        return value.replace(/(\*\*\\[\\\/]|\\\\|\\\/|\*\*|\*|\?)/g, function (_all, g1) {
            if (g1 == "**\\/" || g1 == "**\\\\") {
                return "(.*[\\\\\\/])*";
            }
            if (g1 === "\\/" || g1 == "\\\\") {
                return "[\\\\\\/]{1}";
            }
            if (g1 === "**") {
                return MATCH_ANY;
            }
            return g1 === "*" ? "([^\\\\\\/]*)" : "([^\\\\\\/]{1})";
        });
    }, !!ignoreCase, fullMatch);
}

/*#__NO_SIDE_EFFECTS__*/
function _checkLength(value, props) {
    var result;
    ts_utils_arrForEach(props, function (prop) {
        if (prop in value) {
            var propValue = value[prop];
            result = (ts_utils_isFunction(propValue) ? propValue() : propValue) > 0;
            return -1;
        }
    });
    return result;
}
/*#__NO_SIDE_EFFECTS__*/
function _hasValue(value, depth) {
    var result = value === false || value === 0;
    if (!result && !ts_utils_isNullOrUndefined(value)) {
        if (ts_utils_isArray(value)) {
            result = value[LENGTH] > 0;
        }
        else if (ts_utils_isDate(value)) {
            result = !isNaN(value.getTime());
        }
        else if (isBoolean(value)) {
            return true;
        }
        else if (ts_utils_isObject(value)) {
            try {
                var chkValue = _checkLength(value, [LENGTH, "byteLength", "size", "count"]);
                if (isBoolean(chkValue)) {
                    return chkValue;
                }
                if (ts_utils_isFunction(value.valueOf) && depth < 5) {
                    return _hasValue(value.valueOf(), ++depth);
                }
            }
            catch (e) {
            }
            return !!objKeys(value)[LENGTH];
        }
        else {
            result = isTruthy(value);
        }
    }
    return result;
}
/*#__NO_SIDE_EFFECTS__*/
function hasValue(value) {
    return _hasValue(value, 0);
}

/*#__NO_SIDE_EFFECTS__*/
function createIterable(ctx) {
    return makeIterable({}, ctx);
}
function makeIterable(target, ctx) {
    var itSymbol = ts_utils_getKnownSymbol(3 );
    function _createIterator() {
        return createIterator(ctx);
    }
    target[itSymbol] = _createIterator;
    return target;
}
/*#__NO_SIDE_EFFECTS__*/
function createIterator(ctx) {
    var isDone = false;
    function _value() {
        return ctx.v;
    }
    function _next() {
        if (!isDone) {
            isDone = (ctx.n ? ctx.n(arguments) : true);
        }
        var result = {
            done: isDone
        };
        if (!isDone) {
            ts_utils_objDefine(result, "value", { g: _value });
        }
        return result;
    }
    function _return(value) {
        isDone = true;
        return {
            done: true,
            value: ctx.r && ctx.r(value)
        };
    }
    function _throw(e) {
        isDone = true;
        return {
            done: true,
            value: ctx.t && ctx.t(e)
        };
    }
    var theIterator = {
        next: _next
    };
    if (ctx.r) {
        theIterator.return = _return;
    }
    if (ctx.t) {
        theIterator.throw = _throw;
    }
    return theIterator;
}

/*#__NO_SIDE_EFFECTS__*/
function createArrayIterator(values) {
    var idx = -1;
    var theValues = values ? values.slice() : [];
    var len = theValues[LENGTH];
    function _value() {
        if (idx >= 0 && idx < len) {
            return theValues[idx];
        }
    }
    function _getNext() {
        idx++;
        return idx >= len;
    }
    var ctx = {
        n: _getNext
    };
    ts_utils_objDefine(ctx, "v", { g: _value });
    return createIterator(ctx);
}

/*#__NO_SIDE_EFFECTS__*/
function createRangeIterator(start, end, step) {
    var nextValue = start;
    var theValue = UNDEF_VALUE;
    if (ts_utils_isNullOrUndefined(end)) {
        end = start;
    }
    var theStep = step;
    if (!theStep) {
        theStep = (start <= end) ? 1 : -1;
    }
    function _value() {
        return theValue;
    }
    function _getNext() {
        var isDone = (theStep > 0) ? (nextValue > end) : (nextValue < end);
        if (!isDone) {
            theValue = nextValue;
            nextValue += theStep;
        }
        return isDone;
    }
    return createIterator(ts_utils_objDefine({
        n: _getNext
    }, "v", { g: _value }));
}

var mathAbs = ( /*#__PURE__*/_pureRef(MathCls, "abs"));

var mathExp = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "exp"))));
var mathLog = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "log"))));

var mathAsin = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "asin"))));
var mathAcos = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "acos"))));
var mathAtan = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "atan"))));
var mathAtan2 = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "atan2"))));

var mathPow = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "pow"))));
var mathSqrt = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "sqrt"))));

var mathRound = ( /*#__PURE__*/_pureRef(MathCls, "round"));

var mathSin = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "sin"))));
var mathCos = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "cos"))));
var mathTan = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureRef(MathCls, "tan"))));

var _recursionCheckOwnDescriptors;
var _recursionCheckOwnSymbols;
var _objGetOwnPropertyNames = ( /* #__PURE__ */(/* unused pure expression or super */ null && (_pureAssign(( /* #__PURE__ */_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_NAMES)), _returnEmptyArray))));
var _objGetOwnPropertyDescriptor = ( /* #__PURE__ */(/* unused pure expression or super */ null && (_pureAssign(( /* #__PURE__ */_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_DESCRIPTOR)), _returnNothing))));
function polyObjGetOwnPropertyDescriptors(obj) {
    var result = {};
    _throwIfNullOrUndefined(obj);
    if (!_recursionCheckOwnDescriptors) {
        try {
            _recursionCheckOwnDescriptors = true;
            ts_utils_arrForEach(_objGetOwnPropertyNames(obj), function (propName) {
                var descriptor = _objGetOwnPropertyDescriptor(obj, propName);
                if (descriptor !== undefined) {
                    result[propName] = descriptor;
                }
            });
            ts_utils_arrForEach(_polyObjGetOwnPropertySymbols(obj), function (sym) {
                var descriptor = _objGetOwnPropertyDescriptor(obj, sym);
                if (descriptor !== undefined) {
                    result[sym] = descriptor;
                }
            });
        }
        finally {
            _recursionCheckOwnDescriptors = false;
        }
    }
    return result;
}
function _polyObjGetOwnPropertySymbols(obj) {
    var result = [];
    var objHasOwn = ts_utils_ObjClass.hasOwn || polyObjHasOwn;
    if (!_recursionCheckOwnSymbols) {
        try {
            _recursionCheckOwnSymbols = true;
            var symEnum = 0 ;
            while (symEnum <= 12 ) {
                var sym = ts_utils_getKnownSymbol(symEnum);
                if (sym && objHasOwn(obj, sym)) {
                    result.push(sym);
                }
                symEnum++;
            }
        }
        finally {
            _recursionCheckOwnSymbols = false;
        }
    }
    return result;
}

var objGetOwnPropertyDescriptor = ( /*#__PURE__*/_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_DESCRIPTOR)), _returnNothing));
var objGetOwnPropertyDescriptors = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "getOwnPropertyDescriptors")), polyObjGetOwnPropertyDescriptors))));
var objGetOwnPropertyNames = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_NAMES)), _returnEmptyArray))));
var objGetOwnPropertySymbols = ( /* #__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /* #__PURE__ */_pureRef(ts_utils_ObjClass, GET_OWN_PROPERTY_SYMBOLS)), _returnEmptyArray))));

function polyObjFromEntries(entries) {
    var result = {};
    function addEntry(entry) {
        if (ts_utils_isArray(entry) && entry.length >= 2) {
            result[entry[0]] = entry[1];
        }
    }
    if (ts_utils_isArray(entries)) {
        ts_utils_arrForEach(entries, addEntry);
    }
    else if (ts_utils_isIterable(entries)) {
        ts_utils_iterForOf(entries, addEntry);
    }
    return result;
}

var objFromEntries = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "fromEntries")), polyObjFromEntries))));

var objPreventExtensions = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "preventExtensions")), _doNothing))));
var objIsExtensible = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(( /*#__PURE__*/_pureRef(ts_utils_ObjClass, "isExtensible")), _returnFalse))));

var strEndsWith = ( /*#__PURE__*/_unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith));
/*#__NO_SIDE_EFFECTS__*/
function polyStrEndsWith(value, searchString, length) {
    _throwIfNotString(value);
    var searchValue = ts_utils_isString(searchString) ? searchString : ts_utils_asString(searchString);
    var end = (!ts_utils_isUndefined(length) && length < value[LENGTH]) ? length : value[LENGTH];
    return ts_utils_strSubstring(value, end - searchValue[LENGTH], end) === searchValue;
}

var ts_utils_strIndexOf = ( /*#__PURE__*/_unwrapFunction("indexOf", StrProto));
var strLastIndexOf = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_unwrapFunction("lastIndexOf", StrProto))));

var strIncludes = ( /*#__PURE__*/_unwrapFunctionWithPoly("includes", StrProto, polyStrIncludes));
var strContains = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_pureAssign(strIncludes))));
/*#__NO_SIDE_EFFECTS__*/
function polyStrIncludes(value, searchString, position) {
    if (isRegExp(searchString)) {
        ts_utils_throwTypeError("'searchString' must not be a regular expression" + ts_utils_dumpObj(searchString));
    }
    return ts_utils_strIndexOf(value, ts_utils_asString(searchString), position) !== -1;
}

/*#__NO_SIDE_EFFECTS__*/
function strIsNullOrWhiteSpace(value) {
    if (ts_utils_isString(value)) {
        return value.replace(/[\s\t\r\n\f]+/g, EMPTY) === EMPTY;
    }
    return ts_utils_isNullOrUndefined(value);
}
/*#__NO_SIDE_EFFECTS__*/
function strIsNullOrEmpty(value) {
    if (ts_utils_isString(value)) {
        return value === EMPTY;
    }
    return ts_utils_isNullOrUndefined(value);
}

var strStartsWith = ( /*#__PURE__*/_unwrapFunctionWithPoly("startsWith", StrProto, polyStrStartsWith));
/*#__NO_SIDE_EFFECTS__*/
function polyStrStartsWith(value, searchString, position) {
    _throwIfNotString(value);
    var searchValue = ts_utils_isString(searchString) ? searchString : ts_utils_asString(searchString);
    var pos = position > 0 ? position : 0;
    return ts_utils_strSubstring(value, pos, pos + searchValue[LENGTH]) === searchValue;
}

var REF = "ref";
var UNREF = "unref";
var HAS_REF = "hasRef";
var ENABLED = "enabled";
/*#__NO_SIDE_EFFECTS__*/
function _createTimerHandler(startTimer, refreshFn, cancelFn) {
    var ref = true;
    var timerId = startTimer ? refreshFn(NULL_VALUE) : NULL_VALUE;
    var theTimerHandler;
    function _unref() {
        ref = false;
        timerId && timerId[UNREF] && timerId[UNREF]();
        return theTimerHandler;
    }
    function _cancel() {
        timerId && cancelFn(timerId);
        timerId = NULL_VALUE;
    }
    function _refresh() {
        timerId = refreshFn(timerId);
        if (!ref) {
            _unref();
        }
        return theTimerHandler;
    }
    function _setEnabled(value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    }
    theTimerHandler = {
        cancel: _cancel,
        refresh: _refresh
    };
    theTimerHandler[HAS_REF] = function () {
        if (timerId && timerId[HAS_REF]) {
            return timerId[HAS_REF]();
        }
        return ref;
    };
    theTimerHandler[REF] = function () {
        ref = true;
        timerId && timerId[REF] && timerId[REF]();
        return theTimerHandler;
    };
    theTimerHandler[UNREF] = _unref;
    theTimerHandler = ts_utils_objDefineProp(theTimerHandler, ENABLED, {
        get: function () { return !!timerId; },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function () {
            timerId = NULL_VALUE;
        }
    };
}

var _setTimeoutFn;
var _clearTimeoutFn;
function _resolveTimeoutFn(timeoutFn) {
    var result = ts_utils_isFunction(timeoutFn) ? timeoutFn : _setTimeoutFn;
    if (!result) {
        var globalOverrides = _getGlobalConfig().tmOut || [];
        if (ts_utils_isArray(globalOverrides) && globalOverrides.length > 0 && ts_utils_isFunction(globalOverrides[0])) {
            result = globalOverrides[0];
        }
    }
    return result || setTimeout;
}
function _resolveClearTimeoutFn(timeoutFn) {
    var result = ts_utils_isFunction(timeoutFn) ? timeoutFn : _clearTimeoutFn;
    if (!result) {
        var globalOverrides = _getGlobalConfig().tmOut || [];
        if (ts_utils_isArray(globalOverrides) && globalOverrides.length > 1 && ts_utils_isFunction(globalOverrides[1])) {
            result = globalOverrides[1];
        }
    }
    return result || clearTimeout;
}
function _createTimeoutWith(startTimer, overrideFn, theArgs) {
    var isArr = ts_utils_isArray(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = _resolveTimeoutFn(len > 0 ? overrideFn[0] : (!isArr ? overrideFn : UNDEF_VALUE));
    var clearFn = _resolveClearTimeoutFn(len > 1 ? overrideFn[1] : UNDEF_VALUE);
    var timerFn = theArgs[0];
    theArgs[0] = function () {
        handler.dn();
        ts_utils_fnApply(timerFn, UNDEF_VALUE, ArrSlice[CALL](arguments));
    };
    var handler = _createTimerHandler(startTimer, function (timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            ts_utils_fnApply(clearFn, UNDEF_VALUE, [timerId]);
        }
        return ts_utils_fnApply(setFn, UNDEF_VALUE, theArgs);
    }, function (timerId) {
        ts_utils_fnApply(clearFn, UNDEF_VALUE, [timerId]);
    });
    return handler.h;
}
function setTimeoutOverrides(overrideFn) {
    var isArr = ts_utils_isArray(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    _setTimeoutFn = (len > 0 ? overrideFn[0] : (!isArr ? overrideFn : UNDEF_VALUE));
    _clearTimeoutFn = (len > 1 ? overrideFn[1] : UNDEF_VALUE);
}
function setGlobalTimeoutOverrides(overrideFn) {
    var isArr = ts_utils_isArray(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var globalCfg = _getGlobalConfig();
    if (!overrideFn) {
        globalCfg.tmOut = undefined;
    }
    else {
        globalCfg.tmOut = [
            (len > 0 ? overrideFn[0] : (!isArr ? overrideFn : null)),
            (len > 1 ? overrideFn[1] : null)
        ];
    }
}
function ts_utils_scheduleTimeout(callback, timeout) {
    return _createTimeoutWith(true, UNDEF_VALUE, ArrSlice[CALL](arguments));
}
function scheduleTimeoutWith(overrideFn, callback, timeout) {
    return _createTimeoutWith(true, overrideFn, ArrSlice[CALL](arguments, 1));
}
function createTimeout(callback, timeout) {
    return _createTimeoutWith(false, UNDEF_VALUE, ArrSlice[CALL](arguments));
}
function createTimeoutWith(overrideFn, callback, timeout) {
    return _createTimeoutWith(false, overrideFn, ArrSlice[CALL](arguments, 1));
}

var _defaultIdleTimeout = 100;
var _maxExecutionTime = 50;
/*#__NO_SIDE_EFFECTS__*/
function hasIdleCallback() {
    return !!( /*#__PURE__*/getIdleCallback());
}
var getIdleCallback = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_getGlobalInstFn(ts_utils_getInst, ["requestIdleCallback"]))));
var getCancelIdleCallback = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_getGlobalInstFn(ts_utils_getInst, ["cancelIdleCallback"]))));
function setDefaultIdleTimeout(timeout) {
    _defaultIdleTimeout = timeout;
}
function setDefaultMaxExecutionTime(maxTime) {
    _maxExecutionTime = maxTime;
}
function ts_utils_scheduleIdleCallback(callback, options) {
    function _createDeadline(timedOut) {
        var startTime = perfNow();
        return {
            didTimeout: timedOut,
            timeRemaining: function () {
                return _maxExecutionTime - elapsedTime(startTime);
            }
        };
    }
    if (hasIdleCallback()) {
        var handler_1 = _createTimerHandler(true, function (idleId) {
            idleId && getCancelIdleCallback()(idleId);
            return getIdleCallback()(function (deadline) {
                handler_1.dn();
                callback(deadline || _createDeadline(false));
            }, options);
        }, function (idleId) {
            getCancelIdleCallback()(idleId);
        });
        return handler_1.h;
    }
    var timeout = (options || {}).timeout;
    if (ts_utils_isUndefined(timeout)) {
        timeout = _defaultIdleTimeout;
    }
    return ts_utils_scheduleTimeout(function () {
        callback(_createDeadline(true));
    }, timeout);
}

function scheduleInterval(callback, timeout) {
    var theArguments = ArrSlice[CALL](arguments);
    var handler = _createTimerHandler(true, function (intervalId) {
        intervalId && clearInterval(intervalId);
        return ts_utils_fnApply(setInterval, UNDEF_VALUE, theArguments);
    }, function (intervalId) {
        ts_utils_fnApply(clearInterval, UNDEF_VALUE, [intervalId]);
    });
    return handler.h;
}


//# sourceMappingURL=ts-utils.js.map

;// CONCATENATED MODULE: ./node_modules/@microsoft/dynamicproto-js/dist-es5/DynamicProto.js
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var _a;

;
var DynamicProto_UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */
var DynProtoBaseProto = "_dyn" + str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */
var DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */
var DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */
var _objGetOwnProps = Obj["getOwnPropertyNames"];
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var _gbl = getGlobal();
var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
    o: (_a = {},
        _a[strSetInstFuncs] = true,
        _a[strUseBaseInst] = true,
        _a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[DynProtoBaseProto] || curProto;
        if (!ts_utils_objHasOwnProperty(target, DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
            target[DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    if (_objGetOwnProps) {
        props = _objGetOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && ts_utils_objHasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || ts_utils_objHasOwnProperty(target, funcName)) && funcName !== str__Proto && funcName !== Prototype);
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    ts_utils_throwTypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = objCreate(null);
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = objCreate(null);
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && ts_utils_objHasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || objCreate(null);
        instFunc = (instFuncTable[proto[DynClassName]] || objCreate(null))[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !ts_utils_objHasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || objCreate(null);
        if (!_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || objCreate(null)); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
            }
            if (!_isObjectOrArrayPrototype(instFuncs_1)) {
                _forEachProp(target, function (name) {
                    // Only add overridden functions
                    if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                        // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                        instFuncs_1[name] = target[name];
                        delete target[name];
                        // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                        if (!ts_utils_objHasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                            proto[name] = _createDynamicPrototype(proto, name);
                        }
                    }
                });
            }
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (ts_utils_objHasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!ts_utils_objHasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (ts_utils_objHasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
        _gblInst.n++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
dynamicProto[DynProtoDefaultOptions] = _gblInst.o;
//# sourceMappingURL=DynamicProto.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-shims/dist-es5/Constants.js
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Constants_strShimFunction = "function";
var strShimObject = "object";
var Constants_strShimUndefined = "undefined";
var Constants_strShimPrototype = "prototype";
var Constants_strDefault = "default";
var Constants_ObjClass = Object;
var Constants_ObjProto = Constants_ObjClass[Constants_strShimPrototype];
//# sourceMappingURL=Constants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-shims/dist-es5/TsLibShims.js
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES5 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (getGlobal() || {})["Symbol"];
var ReflectObj = (getGlobal() || {})["Reflect"];
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var strHasOwnProperty = "hasOwnProperty";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Constants_ObjProto[strHasOwnProperty].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = objAssign || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = Constants_ObjClass.setPrototypeOf ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[strHasOwnProperty](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== Constants_strShimFunction && b !== null) {
        ts_utils_throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[Constants_strShimPrototype] = b === null ? objCreate(b) : (__[Constants_strShimPrototype] = b[Constants_strShimPrototype], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (objHasOwnProperty(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof ObjClass[strGetOwnPropertySymbols] === strShimFunction) {
        for (var i = 0, p = ObjClass[strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && ObjProto["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = ObjClass["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === strShimFunction) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && objDefineProp(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === strShimFunction) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== strDefault && !objHasOwnProperty(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!objDefineProp) {
        objDefineProp(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === strShimFunction && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    throwTypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === strShimFunction && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (objDefineProp) {
        objDefineProp(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== strDefault && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!objDefineProp) {
        objDefineProp(result, strDefault, { enumerable: true, value: mod });
    }
    else {
        result[strDefault] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DynamicConstants_DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 17
var _DynamicConstants_DYN_LENGTH = "length"; // Count: 138
var _DYN_WARN_TO_CONSOLE = "warnToConsole"; // Count: 5
var _DYN_THROW_INTERNAL = "throwInternal"; // Count: 9
var _DYN_WATCH = "watch"; // Count: 7
var _DYN_APPLY = "apply"; // Count: 7
var _DynamicConstants_DYN_PUSH = "push"; // Count: 68
var _DYN_SPLICE = "splice"; // Count: 15
var _DYN_LOGGER = "logger"; // Count: 22
var _DYN_CANCEL = "cancel"; // Count: 9
var _DynamicConstants_DYN_INITIALIZE = "initialize"; // Count: 8
var _DynamicConstants_DYN_IDENTIFIER = "identifier"; // Count: 9
var _DYN_REMOVE_NOTIFICATION_0 = "removeNotificationListener"; // Count: 4
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 4
var _DynamicConstants_DYN_STRINGIFY = "stringify"; // Count: 10
var _DynamicConstants_DYN_TRACE_ID = "traceId"; // Count: 19
var _DynamicConstants_DYN_SPAN_ID = "spanId"; // Count: 22
var _DynamicConstants_DYN_TRACE_FLAGS = "traceFlags"; // Count: 19
var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 11
var _DYN_TRACE_HDR_MODE = "traceHdrMode"; // Count: 3
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 5
var _DYN_GET_PLUGIN = "getPlugin"; // Count: 5
var _DYN_TRACK = "track"; // Count: 6
var _DynamicConstants_DYN_NAME = "name"; // Count: 18
var _DYN_I_KEY = "iKey"; // Count: 8
var _DYN_TIME = "time"; // Count: 6
var _DYN_PROCESS_NEXT = "processNext"; // Count: 15
var _DYN_GET_PROCESS_TEL_CONT2 = "getProcessTelContext"; // Count: 2
var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs"; // Count: 4
var _DYN_VALUE = "value"; // Count: 32
var _DYN_ENABLED = "enabled"; // Count: 6
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
var _DYN_UNLOAD = "unload"; // Count: 7
var _DYN_ON_COMPLETE = "onComplete"; // Count: 4
var _DYN_REASON = "reason"; // Count: 5
var _DYN_FLUSH = "flush"; // Count: 5
var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 4
var _DYN_SET_TRACE_CTX = "setTraceCtx"; // Count: 3
var _DYN_GET_ACTIVE_SPAN = "getActiveSpan"; // Count: 3
var _DynamicConstants_DYN_SET_ACTIVE_SPAN = "setActiveSpan"; // Count: 5
var _DynamicConstants_DYN_SPAN_CONTEXT = "spanContext"; // Count: 6
var _DYN_PARENT_SPAN_CONTEXT = "parentSpanContext"; // Count: 4
var _DYN_PARENT_SPAN_ID = "parentSpanId"; // Count: 3
var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole"; // Count: 2
var _DYN_JOIN = "join"; // Count: 8
var _DYN_CREATE_NEW = "createNew"; // Count: 7
var _DYN_TEARDOWN = "teardown"; // Count: 9
var _DYN_MESSAGE_ID = "messageId"; // Count: 4
var _DYN_MESSAGE = "message"; // Count: 18
var _DYN_ATTRIBUTE_COUNT_LIMI5 = "attributeCountLimit"; // Count: 3
var _DynamicConstants_DYN_SUPPRESS_TRACING = "suppressTracing"; // Count: 5
var _DYN_NOT_IMPLEMENTED = "notImplemented"; // Count: 3
var _DYN_DIAG_LOG = "diagLog"; // Count: 9
var _DynamicConstants_DYN_DO_TEARDOWN = "_doTeardown"; // Count: 5
var _DYN_UPDATE = "update"; // Count: 5
var _DYN_GET_NEXT = "getNext"; // Count: 10
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
var _DYN_SPLIT = "split"; // Count: 16
var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
var _DYN_DATA = "data"; // Count: 17
var _DYN_GET_CTX = "getCtx"; // Count: 6
var _DYN_SET_CTX = "setCtx"; // Count: 10
var _DynamicConstants_DYN_CONFIG = "config"; // Count: 9
var _DynamicConstants_DYN_CALL = "call"; // Count: 6
var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 3
var _DYN_HEADERS = "headers"; // Count: 6
var _DYN_URL_STRING = "urlString"; // Count: 5
var _DYN_TIMEOUT = "timeout"; // Count: 6
var _DYN_STATUS = "status"; // Count: 10
var _DynamicConstants_DYN_REPLACE = "replace"; // Count: 12
var _DynamicConstants_DYN_HOST = "host"; // Count: 11
var _DYN_HAS_OWN_PROPERTY = "hasOwnProperty"; // Count: 3
var _DYN_TOTAL_REQUEST = "totalRequest"; // Count: 4
var _DYN_REQUEST_DURATION = "requestDuration"; // Count: 3
var _DYN_FAILURE = "failure"; // Count: 4
var _DYN_EXCEPTION = "exception"; // Count: 6
var _DYN_THROTTLE = "throttle"; // Count: 4
var _DYN_INDEX_OF = "indexOf"; // Count: 6
var _DynamicConstants_DYN_TYPE = "type"; // Count: 18
var _DYN_MATCH = "match"; // Count: 7
var _DYN_SET_TRACE_FLAGS = "setTraceFlags"; // Count: 3
var _DynamicConstants_DYN_PATHNAME = "pathname"; // Count: 6
var _DYN_TRACE_STATE = "traceState"; // Count: 7
var _DYN_COUNT = "count"; // Count: 6
var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
var _DYN_TIMINGS = "timings"; // Count: 4
var _DYN_BASE_DATA = "baseData"; // Count: 5
var _DYN_PROPERTIES = "properties"; // Count: 13
var _DYN_USER_AGENT = "userAgent"; // Count: 4
var _DynamicConstants_DYN_ATTRIBUTES = "attributes"; // Count: 6
var _DYN_KIND = "kind"; // Count: 6
var _DYN_START_TIME = "startTime"; // Count: 6
var _DYN_DURATION = "duration"; // Count: 5
var _DynamicConstants_DYN_TO_STRING = "toString"; // Count: 12
var _DYN_PROCESS_TELEMETRY_ST6 = "processTelemetryStart"; // Count: 3
var _DYN_HANDLE_FIELD = "handleField"; // Count: 3
var _DYN_RM_SANITIZER = "rmSanitizer"; // Count: 3
var _DYN_RM_FIELD_SANITIZER = "rmFieldSanitizer"; // Count: 3
var _DYN_CAN_HANDLE = "canHandle"; // Count: 4
var _DynamicConstants_DYN_HANDLER = "handler"; // Count: 5
var _DynamicConstants_DYN_ERROR_HANDLERS = "errorHandlers"; // Count: 4
var _DynamicConstants_DYN_EVT_NAME = "evtName"; // Count: 4
var _DYN_CONCAT = "concat"; // Count: 5
var _DynamicConstants_DYN_WARN = "warn"; // Count: 6
var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 6
var _DYN_CREATE_EVENT = "createEvent"; // Count: 4
var _DYN_SUBSTRING = "substring"; // Count: 4
var _DYN_GET_ALL_RESPONSE_HEA7 = "getAllResponseHeaders"; // Count: 2
var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
var _DYN_GET_ATTRIBUTE = "getAttribute"; // Count: 3
var _DYN_CORRELATION_HEADER_E8 = "correlationHeaderExcludePatterns"; // Count: 2
var _DYN_ENTRIES = "entries"; // Count: 5
var _DynamicConstants_DYN_TRACE_CFG = "traceCfg"; // Count: 6
var _DYN_MEASUREMENTS = "measurements"; // Count: 9
var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 4
var _DYN_TYPE_NAME = "typeName"; // Count: 5
var _DYN_EXCEPTIONS = "exceptions"; // Count: 5
var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
var _DYN_PARSED_STACK = "parsedStack"; // Count: 6
var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 5
var _DYN_ASSEMBLY = "assembly"; // Count: 4
var _DYN_FILE_NAME = "fileName"; // Count: 9
var _DYN_LINE = "line"; // Count: 6
var _DYN_AI_DATA_CONTRACT = "aiDataContract"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/constants/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var UNDEFINED_VALUE = undefined;
var InternalConstants_STR_EMPTY = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_OFFLINE_STORE = "offlineEventsStored";
var STR_OFFLINE_SENT = "offlineBatchSent";
var STR_OFFLINE_DROP = "offlineBatchDrop";
var STR_GET_PERF_MGR = "getPerfMgr";
var STR_DOMAIN = "domain";
var STR_PATH = "path";
var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";
var STR_REDACTED = "REDACTED";
var DEFAULT_SENSITIVE_PARAMS = ["sig", "Signature", "AWSAccessKeyId", "X-Goog-Signature"];
var STR_DEFAULT_ENDPOINT_URL = "https://browser.events.data.microsoft.com/OneCollector/1.0/";
var InternalConstants_STR_VERSION = "version";
var STR_NOT_SPECIFIED = "not_specified";
//# sourceMappingURL=InternalConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/config/ConfigDefaultHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */
function _stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && ts_utils_isNullOrUndefined(theValue)) {
        return defaultValue;
    }
    if (isBoolean(theValue)) {
        return theValue;
    }
    return ts_utils_asString(theValue)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the field defined as an object
 * that should be merged
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfMerge(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field set function
 * @param setter - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfSet(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field validator
 * @param validator - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfValidate(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate and convert the user
 * provided value to a boolean from a string or boolean value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfBoolean(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: _stringToBoolOrDefault,
        v: !!defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate that the user
 * provided value is a function.
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfFunc(defaultValue) {
    return {
        isVal: isFunction,
        v: defaultValue || null
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate that the user
 * provided value is a function.
 * @param defaultValue - The default string value to apply it not provided or it's not valid, defaults to an empty string
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfString(defaultValue) {
    return {
        isVal: ts_utils_isString,
        v: ts_utils_asString(defaultValue || InternalConstants_STR_EMPTY)
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance identifying that value associated with this property
 * should not have it's properties converted into a dynamic config properties.
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfBlockPropValue(defaultValue) {
    return {
        blkVal: true,
        v: defaultValue
    };
}
//# sourceMappingURL=ConfigDefaultHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/HelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var strGetPrototypeOf = "getPrototypeOf";
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
var _ProtoNameTag;
var HelperFuncs_getObjProto = Object[strGetPrototypeOf];
/*#__NO_SIDE_EFFECTS__*/
function isNotUndefined(value) {
    return !isUndefined(value);
}
/*#__NO_SIDE_EFFECTS__*/
function isNotNullOrUndefined(value) {
    return !ts_utils_isNullOrUndefined(value);
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name - The name to validate
 */
/*#__NO_SIDE_EFFECTS__*/
function HelperFuncs_normalizeJsName(name) {
    var value = name;
    if (value && ts_utils_isString(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](rCamelCase, function (_all, letter) {
            return letter.toUpperCase();
        });
        value = value[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](rNormalizeInvalid, "_");
        value = value[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](rLeadingNumeric, function (_all, match) {
            return "_" + match;
        });
    }
    return value;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
/*#__NO_SIDE_EFFECTS__*/
function HelperFuncs_strContains(value, search) {
    if (value && search) {
        return ts_utils_strIndexOf(value, search) !== -1;
    }
    return false;
}
/**
 * Convert a date to I.S.O. format in IE8
 */
/*#__NO_SIDE_EFFECTS__*/
function HelperFuncs_toISOString(date) {
    return date && date.toISOString() || InternalConstants_STR_EMPTY;
}
var deepFreeze = (/* unused pure expression or super */ null && (objDeepFreeze));
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
/*#__NO_SIDE_EFFECTS__*/
function getExceptionName(object) {
    if (ts_utils_isError(object)) {
        return object[_DynamicConstants_DYN_NAME /* @min:%2ename */];
    }
    return InternalConstants_STR_EMPTY;
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && ts_utils_isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !ts_utils_isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !ts_utils_isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function _createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if (ts_utils_isFunction(source)) {
        srcFunc = source;
    }
    else {
        src = source;
    }
    return function () {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) {
            src = srcFunc();
        }
        if (src) {
            return src[funcName][_DYN_APPLY /* @min:%2eapply */](src, originalArguments);
        }
    };
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 =\> will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -\> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && ts_utils_isObject(target) && ts_utils_isObject(source)) {
        var _loop_1 = function (field) {
            if (ts_utils_isString(field)) {
                var value = source[field];
                if (ts_utils_isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = _createProxyFunction(source, field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (objHasOwn(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    ts_utils_objDefine(target, field, {
                        g: function () {
                            return source[field];
                        },
                        s: function (theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Creates a proxy function on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param name - The function name that will be added on the target
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param theFunc - The function name on the source that will be proxied on the target
 * @param overwriteTarget - If `false` this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || ts_utils_isUndefined(target[name])) {
            target[name] = _createProxyFunction(source, theFunc);
        }
    }
}
/**
 * Creates proxy functions on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param functionsToProxy - An array of function names that will be proxied on the target
 * @param overwriteTarget - If false this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && ts_utils_isObject(target) && ts_utils_isArray(functionsToProxy)) {
        ts_utils_arrForEach(functionsToProxy, function (theFuncName) {
            if (ts_utils_isString(theFuncName)) {
                proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
            }
        });
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults - Simple helper
 */
/*#__NO_SIDE_EFFECTS__*/
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                ts_utils_objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * Set the type of the object by defining the toStringTag well known symbol, this will impact the
 * Object.prototype.toString.call() results for the object. And can be used to identify the type
 * in the debug output and also in the DevTools watchers window when inspecting the object etc.
 * @param target - The object to set the toStringTag symbol on
 * @param nameOrFunc - The name or function to use for the toStringTag
 * @returns The target object
 */
function setObjStringTag(target, nameOrFunc) {
    ts_utils_safe(ts_utils_objDefine, [target, ts_utils_getKnownSymbol(11 /* WellKnownSymbols.toStringTag */), ts_utils_isFunction(nameOrFunc) ? { g: nameOrFunc, e: false } : { v: nameOrFunc, w: false, e: false }]);
    return target;
}
/**
 * Introduce an intermediate prototype to the target object and that sets the toStringTag on that prototype,
 * this avoids directly modifying the target object and also allows multiple different "types" to be
 * applied to the same target object if required.
 * This is done as a best effort approach and may not always succeed due to security / object model restrictions
 * So if it fails then it will fallback to just defining the toStringTag on the target object, which also may fail
 * resulting in no change.
 * @param target - The object to set the toStringTag symbol on
 * @param name - The name or function to use for the toStringTag
 * @returns The target object
 */
function setProtoTypeName(target, name) {
    if (target) {
        var proto_1 = HelperFuncs_getObjProto(target);
        var done_1 = false;
        if (proto_1) {
            // Set the target's prototype to the new intermediate prototype
            ts_utils_safe(function () {
                // Create a new intermediate prototype that extends the current prototype
                var newProto = setObjStringTag(objCreate(proto_1), name);
                if (!_ProtoNameTag) {
                    // Note: Using a cached value instead of a lazy value as we want to ensure that the namespace is consistent
                    // across multiple calls as the `getLazy()` supports runtime invalidation via `setBypassLazyCache()` which would
                    // result in different namespaces being returned.
                    _ProtoNameTag = ts_utils_createCachedValue(newSymbol("ai$ProtoName"));
                }
                // Tag this new prototype
                ts_utils_objDefine(newProto, _ProtoNameTag.v, {
                    v: true,
                    w: false,
                    e: false
                });
                objSetPrototypeOf(target, newProto);
                done_1 = true;
            });
        }
        if (!done_1) {
            // Either no prototype or we failed to set it so just define the toStringTag on the target
            ts_utils_safe(setObjStringTag, [target, name]);
        }
    }
    return target;
}
/**
 * Update the introduced intermediate prototype name of the target object.
 * @param target - The object to look for the prototype name and update
 * @param name - The updated name to apply
 * @returns The target Object
 */
function updateProtoTypeName(target, name) {
    if (_ProtoNameTag) {
        // Find the Parent Proto
        while (target && target !== Constants_ObjProto && !target[_ProtoNameTag.v]) {
            var protoTarget = objGetPrototypeOf(target);
            if (target === protoTarget) {
                // Break out of any recursive case (happens on some runtimes) where the prototype of an
                // object is the same prototype
                break;
            }
            target = protoTarget;
        }
        if (target[_ProtoNameTag.v]) {
            // Found it so update
            ts_utils_safe(setObjStringTag, [target, name]);
        }
    }
    return target;
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
/*#__NO_SIDE_EFFECTS__*/
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && objAssign) {
        theObject = Constants_ObjClass(objAssign({}, theObject));
    }
    return theObject;
}
function HelperFuncs_objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && isBoolean(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!ts_utils_isObject(extended)) {
        extended = {};
    }
    // Loop through each remaining object and conduct a merge
    for (; idx < argLen; idx++) {
        var arg = theArgs[idx];
        var isArgArray = ts_utils_isArray(arg);
        var isArgObj = ts_utils_isObject(arg);
        for (var prop in arg) {
            var propOk = (isArgArray && (prop in arg)) || (isArgObj && objHasOwn(arg, prop));
            if (!propOk) {
                continue;
            }
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = ts_utils_isArray(newValue)) || isPlainObject(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!ts_utils_isArray(clone)) {
                        // We can't "merge" an array with a non-array so overwrite the original
                        clone = [];
                    }
                }
                else if (!isPlainObject(clone)) {
                    // We can't "merge" an object with a non-object
                    clone = {};
                }
                // Never move the original objects always clone them
                newValue = HelperFuncs_objExtend(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) {
                extended[prop] = newValue;
            }
        }
    }
    return extended;
}
var HelperFuncs_asString = (/* unused pure expression or super */ null && (asString21));
/**
 * Checks if the feature is enabled on not. If the feature is not defined, it will return the default state if provided or undefined.
 * If the feature is defined, it will check the mode and return true if the mode is enable or false if the mode is disable.
 * @param feature - The feature name to check
 * @param cfg - The configuration object to check the feature state against
 * @param sdkDefaultState - Optional default state to return if the feature is not defined
 * @returns True if the feature is enabled, false if the feature is disabled, or undefined if the feature is not defined and no default state is provided.
 */
/*#__NO_SIDE_EFFECTS__*/
function isFeatureEnabled(feature, cfg, sdkDefaultState) {
    var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
    if (feature && ft) {
        var mode = ft.mode;
        // NOTE: None will be considered as true
        if (mode === 3 /* FeatureOptInMode.enable */) {
            return true;
        }
        else if (mode === 2 /* FeatureOptInMode.disable */) {
            return false;
        }
    }
    // Return the default state if provided or undefined
    return sdkDefaultState;
}
/*#__NO_SIDE_EFFECTS__*/
function getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
/*#__NO_SIDE_EFFECTS__*/
function formatErrorMessageXdr(xdr, message) {
    if (xdr) {
        return "XDomainRequest,Response:" + getResponseText(xdr) || 0;
    }
    return message;
}
/*#__NO_SIDE_EFFECTS__*/
function formatErrorMessageXhr(xhr, message) {
    if (xhr) {
        return "XMLHttpRequest,Status:" + xhr[_DYN_STATUS /* @min:%2estatus */] + ",Response:" + getResponseText(xhr) || 0 || 0;
    }
    return message;
}
/*#__NO_SIDE_EFFECTS__*/
function prependTransports(theTransports, newTransports) {
    if (newTransports) {
        if (ts_utils_isNumber(newTransports)) {
            theTransports = [newTransports][_DYN_CONCAT /* @min:%2econcat */](theTransports);
        }
        else if (ts_utils_isArray(newTransports)) {
            theTransports = newTransports[_DYN_CONCAT /* @min:%2econcat */](theTransports);
        }
    }
    return theTransports;
}
var strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var strWithCredentials = "withCredentials";
var strTimeout = "timeout";
/**
 * Create and open an XMLHttpRequest object
 * @param method - The request method
 * @param urlString - The url
 * @param withCredentials - Option flag indicating that credentials should be sent
 * @param disabled - Optional flag indicating that the XHR object should be marked as disabled and not tracked (default is false)
 * @param isSync - Optional flag indicating if the instance should be a synchronous request (defaults to false)
 * @param timeout - Optional value identifying the timeout value that should be assigned to the XHR request
 * @returns A new opened XHR request
 */
function openXhr(method, urlString, withCredentials, disabled, isSync, timeout) {
    if (disabled === void 0) { disabled = false; }
    if (isSync === void 0) { isSync = false; }
    function _wrapSetXhrProp(xhr, prop, value) {
        try {
            xhr[prop] = value;
        }
        catch (e) {
            // - Wrapping as depending on the environment setting the property may fail (non-terminally)
        }
    }
    var xhr = new XMLHttpRequest();
    if (disabled) {
        // Tag the instance so it's not tracked (trackDependency)
        // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
        // cause the request to fail and we no telemetry would be sent
        _wrapSetXhrProp(xhr, strDisabledPropertyName, disabled);
    }
    if (withCredentials) {
        // Some libraries require that the withCredentials flag is set "before" open and
        // - Wrapping as IE 10 has started throwing when setting before open
        _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
    }
    xhr.open(method, urlString, !isSync);
    if (withCredentials) {
        // withCredentials should be set AFTER open (https://xhr.spec.whatwg.org/#the-withcredentials-attribute)
        // And older firefox instances from 11+ will throw for sync events (current versions don't) which happens during unload processing
        _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
    }
    // Only set the timeout for asynchronous requests as
    // "Timeout shouldn't be used for synchronous XMLHttpRequests requests used in a document environment or it will throw an InvalidAccessError exception.""
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (!isSync && timeout) {
        _wrapSetXhrProp(xhr, strTimeout, timeout);
    }
    return xhr;
}
/**
* Converts the XHR getAllResponseHeaders to a map containing the header key and value.
* @internal
*/
// tslint:disable-next-line: align
/*#__NO_SIDE_EFFECTS__*/
function convertAllHeadersToMap(headersString) {
    var headers = {};
    if (ts_utils_isString(headersString)) {
        var headersArray = strTrim(headersString)[_DYN_SPLIT /* @min:%2esplit */](/[\r\n]+/);
        ts_utils_arrForEach(headersArray, function (headerEntry) {
            if (headerEntry) {
                var idx = ts_utils_strIndexOf(headerEntry, ": ");
                if (idx !== -1) {
                    // The new spec has the headers returning all as lowercase -- but not all browsers do this yet
                    var header = strTrim(headerEntry.substring(0, idx))[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                    var value = strTrim(headerEntry[_DYN_SUBSTRING /* @min:%2esubstring */](idx + 1));
                    headers[header] = value;
                }
                else {
                    headers[strTrim(headerEntry)] = 1;
                }
            }
        });
    }
    return headers;
}
/**
* append the XHR headers.
* @internal
*/
function _appendHeader(theHeaders, xhr, name) {
    if (!theHeaders[name] && xhr && xhr.getResponseHeader) {
        var value = xhr.getResponseHeader(name);
        if (value) {
            theHeaders[name] = strTrim(value);
        }
    }
    return theHeaders;
}
var STR_KILL_DURATION_HEADER = "kill-duration";
var STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
var STR_TIME_DELTA_HEADER = "time-delta-millis";
/**
* get the XHR getAllResponseHeaders.
* @internal
*/
function _getAllResponseHeaders(xhr, isOneDs) {
    var theHeaders = {};
    if (!xhr[_DYN_GET_ALL_RESPONSE_HEA7 /* @min:%2egetAllResponseHeaders */]) {
        // Firefox 2-63 doesn't have getAllResponseHeaders function but it does have getResponseHeader
        // Only call these if getAllResponseHeaders doesn't exist, otherwise we can get invalid response errors
        // as collector is not currently returning the correct header to allow JS to access these headers
        if (!!isOneDs) {
            theHeaders = _appendHeader(theHeaders, xhr, STR_TIME_DELTA_HEADER);
            theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_HEADER);
            theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_SECONDS_HEADER);
        }
    }
    else {
        theHeaders = convertAllHeadersToMap(xhr[_DYN_GET_ALL_RESPONSE_HEA7 /* @min:%2egetAllResponseHeaders */]());
    }
    return theHeaders;
}
/*#__NO_SIDE_EFFECTS__*/
function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString()[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Convert ms to c# time span format
 */
/*#__NO_SIDE_EFFECTS__*/
function msToTimeSpan(totalms) {
    if (isTimeSpan(totalms)) {
        // Already in time span format
        return totalms;
    }
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = mathRound(totalms);
    var ms = InternalConstants_STR_EMPTY + totalms % 1000;
    var sec = InternalConstants_STR_EMPTY + mathFloor(totalms / 1000) % 60;
    var min = InternalConstants_STR_EMPTY + mathFloor(totalms / (1000 * 60)) % 60;
    var hour = InternalConstants_STR_EMPTY + mathFloor(totalms / (1000 * 60 * 60)) % 24;
    var days = mathFloor(totalms / (1000 * 60 * 60 * 24));
    ms = ms[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 1 ? "00" + ms : ms[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2 ? "0" + ms : ms;
    sec = sec[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2 ? "0" + sec : sec;
    min = min[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2 ? "0" + min : min;
    hour = hour[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : InternalConstants_STR_EMPTY) + hour + ":" + min + ":" + sec + "." + ms;
}
/*#__NO_SIDE_EFFECTS__*/
function getExtensionByName(extensions, identifier) {
    var extension = null;
    arrForEach(extensions, function (value) {
        if (value[_DYN_IDENTIFIER /* @min:%2eidentifier */] === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
/*#__NO_SIDE_EFFECTS__*/
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && ts_utils_isString(message) && (message === "Script error." || message === "Script error");
}
/**
 * A helper method to determine whether the provided value is in a ISO time span format (DD.HH:MM:SS.MMMMMM)
 * @param value - The value to check
 * @returns True if the value is in a time span format; false otherwise
 */
/*#__NO_SIDE_EFFECTS__*/
function isTimeSpan(value) {
    var result = false;
    if (ts_utils_isString(value)) {
        var parts = strSplit(value, ":");
        if (parts[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 3) {
            // Looks like a candidate, now validate each part
            var daysHours = strSplit(parts[0], ".");
            if (daysHours[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2) {
                result = !isNaN(parseInt(daysHours[0] || "0")) && !isNaN(parseInt(daysHours[1] || "0"));
            }
            else {
                result = !isNaN(parseInt(daysHours[0] || "0"));
            }
            result = result && !isNaN(parseInt(parts[1] || "0"));
            var secondsParts = strSplit(parts[2], ".");
            if (secondsParts[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2) {
                result = result && !isNaN(parseInt(secondsParts[0] || "0")) && !isNaN(parseInt(secondsParts[1] || "0"));
            }
            else {
                result = result && !isNaN(parseInt(secondsParts[0] || "0"));
            }
        }
    }
    return result;
}
//# sourceMappingURL=HelperFuncs.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/EnvUtils.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strDocumentMode = "documentMode";
var strLocation = "location";
var strConsole = "console";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
// Local cached properties which are used to avoid multiple checks within the module
var _isTrident;
var _navUserAgentCheck;
var _enableMocks = false;
var _useXDomainRequest;
var _beaconsSupported;
var _userAgent;
function _hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[Constants_strShimPrototype];
                if (proto) {
                    supported = property in proto;
                }
            }
        }
        catch (e) {
            // Do Nothing
        }
        if (!supported) {
            try {
                var tmp = new theClass();
                supported = !ts_utils_isUndefined(tmp[property]);
            }
            catch (e) {
                // Do Nothing
            }
        }
    }
    return supported;
}
/*#__NO_SIDE_EFFECTS__*/
function getUserAgentString() {
    if (!_userAgent) {
        // Use lazy to allow mocking
        _userAgent = getLazy(function () {
            var nav = getNavigator() || {};
            return nav[_DYN_USER_AGENT /* @min:%2euserAgent */] || InternalConstants_STR_EMPTY;
        });
    }
    return _userAgent.v;
}
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled - A flag to enable or disable the mock
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
/*#__NO_SIDE_EFFECTS__*/
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = ts_utils_getInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === strShimObject && location) {
        return location;
    }
    return ts_utils_getInst(strLocation);
}
/**
 * Returns the global console object
 */
/*#__NO_SIDE_EFFECTS__*/
function getConsole() {
    if (typeof console !== Constants_strShimUndefined) {
        return console;
    }
    return ts_utils_getInst(strConsole);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
/*#__NO_SIDE_EFFECTS__*/
function hasJSON() {
    return Boolean((typeof JSON === strShimObject && JSON) || ts_utils_getInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
/*#__NO_SIDE_EFFECTS__*/
function EnvUtils_getJSON() {
    if (hasJSON()) {
        return JSON || ts_utils_getInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
/*#__NO_SIDE_EFFECTS__*/
function getCrypto() {
    return ts_utils_getInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
/*#__NO_SIDE_EFFECTS__*/
function getMsCrypto() {
    return ts_utils_getInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
/*#__NO_SIDE_EFFECTS__*/
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
/*#__NO_SIDE_EFFECTS__*/
function isIE() {
    var userAgent = getUserAgentString();
    if (!_isTrident || userAgent !== _navUserAgentCheck) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = userAgent;
        var lwrUserAgent = _navUserAgentCheck[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
        _isTrident = ts_utils_createCachedValue(HelperFuncs_strContains(lwrUserAgent, strMsie) || HelperFuncs_strContains(lwrUserAgent, strTrident));
    }
    return _isTrident.v;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
/*#__NO_SIDE_EFFECTS__*/
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        userAgentStr = getUserAgentString();
    }
    var ua = (userAgentStr || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if (HelperFuncs_strContains(ua, strMsie)) {
        var doc = ts_utils_getDocument() || {};
        return mathMax(parseInt(ua[_DYN_SPLIT /* @min:%2esplit */](strMsie)[1]), (doc[strDocumentMode] || 0));
    }
    else if (HelperFuncs_strContains(ua, strTrident)) {
        var tridentVer = parseInt(ua[_DYN_SPLIT /* @min:%2esplit */](strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/*#__NO_SIDE_EFFECTS__*/
function isSafari(userAgentStr) {
    if (!userAgentStr || !isString(userAgentStr)) {
        userAgentStr = getUserAgentString()[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    }
    var ua = (userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    return (strIndexOf(ua, "safari") >= 0);
}
/**
 * Checks if HTML5 Beacons are supported in the current environment. There is a side effect (for testing)
 * when `useCached` is set to `false`, it will reset the cached value causing all future calls to
 * use the new re-evaluated value for all future calls.
 * @param useCached - [Optional] used for testing to bypass the cached lookup, when `true` this will
 * cause the cached global to be reset.
 * @returns True if supported, false otherwise.
 */
function isBeaconsSupported(useCached) {
    if (!_beaconsSupported || useCached === false) {
        _beaconsSupported = ts_utils_createCachedValue(hasNavigator() && !!(getNavigator().sendBeacon));
    }
    return _beaconsSupported.v;
}
/**
 * Checks if the Fetch API is supported in the current environment.
 * @param withKeepAlive - [Optional] If True, check if fetch is available and it supports the keepalive feature, otherwise only check if fetch is supported
 * @returns True if supported, otherwise false
 */
/*#__NO_SIDE_EFFECTS__*/
function isFetchSupported(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!ts_utils_getInst("fetch");
        var request = ts_utils_getInst("Request");
        if (isSupported && withKeepAlive && request) {
            isSupported = _hasProperty(request, "keepalive");
        }
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
/*#__NO_SIDE_EFFECTS__*/
function useXDomainRequest() {
    if (!_useXDomainRequest) {
        _useXDomainRequest = getDeferred(function () {
            var useXDomainRequest = (typeof XDomainRequest !== Constants_strShimUndefined);
            if (useXDomainRequest && isXhrSupported()) {
                useXDomainRequest = useXDomainRequest && !_hasProperty(ts_utils_getInst(strXMLHttpRequest), "withCredentials");
            }
            return !!useXDomainRequest;
        });
    }
    return _useXDomainRequest.v;
}
/**
 * Checks if XMLHttpRequest is supported
 * @returns True if supported, otherwise false
 */
/*#__NO_SIDE_EFFECTS__*/
function isXhrSupported() {
    var isSupported = false;
    try {
        var xmlHttpRequest = ts_utils_getInst(strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
/*#__NO_SIDE_EFFECTS__*/
function _getNamedValue(values, name) {
    var items = [];
    if (values) {
        ts_utils_arrForEach(values, function (value) {
            if (value[_DynamicConstants_DYN_NAME /* @min:%2ename */]) {
                if (value[_DynamicConstants_DYN_NAME /* @min:%2ename */] === name) {
                    items[_DynamicConstants_DYN_PUSH /* @min:%2epush */](value);
                }
            }
        });
    }
    return items;
}
/**
 * Helper function to fetch the named meta-tag from the page.
 * @param name - The name of the meta-tag to find.
 */
/*#__NO_SIDE_EFFECTS__*/
function findMetaTag(name) {
    var tags = findMetaTags(name);
    if (tags[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        return tags[0];
    }
    return null;
}
/**
 * Helper function to fetch all named meta-tag from the page.
 * @since 3.4.0
 * @param name - The name of the meta-tag to find.
 * @returns - An array of meta-tag values.
 */
/*#__NO_SIDE_EFFECTS__*/
function findMetaTags(name) {
    var tags = [];
    var doc = ts_utils_getDocument();
    if (doc && name) {
        // Look for a meta-tag
        ts_utils_arrForEach(_getNamedValue(doc.querySelectorAll("meta"), name), function (item) {
            tags[_DynamicConstants_DYN_PUSH /* @min:%2epush */](item.content);
        });
    }
    return tags;
}
/**
 * Helper function to fetch the named server timing value from the page response (first navigation event).
 * @param name - The name of the server timing value to find.
 */
/*#__NO_SIDE_EFFECTS__*/
function findNamedServerTiming(name) {
    var value;
    var serverTimings = findNamedServerTimings(name);
    if (serverTimings[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        value = serverTimings[0];
    }
    return value;
}
/**
 * Helper function to fetch the named server timing value from the page response (first navigation event).
 * @since 3.4.0
 * @param name - The name of the server timing value to find.
 * @returns - An array of server timing values.
 */
/*#__NO_SIDE_EFFECTS__*/
function findNamedServerTimings(name) {
    var values = [];
    var perf = getPerformance();
    if (perf && perf.getEntriesByType) {
        // Try looking for a server-timing header
        ts_utils_arrForEach(perf.getEntriesByType("navigation") || [], function (navPerf) {
            ts_utils_arrForEach(_getNamedValue(navPerf.serverTiming, name), function (value) {
                var desc = value.description;
                if (!ts_utils_isNullOrUndefined(desc)) {
                    values[_DynamicConstants_DYN_PUSH /* @min:%2epush */](desc);
                }
            });
        });
    }
    return values;
}
// TODO: should reuse this method for analytics plugin
function dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
/*#__NO_SIDE_EFFECTS__*/
function createCustomDomEvent(eventName, details) {
    var event = null;
    var detail = { detail: details || null };
    if (ts_utils_isFunction(CustomEvent)) { // Use CustomEvent constructor when available
        event = new CustomEvent(eventName, detail);
    }
    else { // CustomEvent has no constructor in IE
        var doc = ts_utils_getDocument();
        if (doc && doc[_DYN_CREATE_EVENT /* @min:%2ecreateEvent */]) {
            event = doc[_DYN_CREATE_EVENT /* @min:%2ecreateEvent */]("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function sendCustomEvent(evtName, cfg, customDetails) {
    var global = getGlobal();
    if (global && global.CustomEvent) {
        try {
            var details = { cfg: cfg || null, customDetails: customDetails || null };
            return dispatchEvent(global, createCustomDomEvent(evtName, details));
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
    return false;
}
/**
 * Redacts user information from a URL
 * @param url - The URL string to redact
 * @returns The URL with user information redacted
 */
/*#__NO_SIDE_EFFECTS__*/
function redactUserInfo(url) {
    return url.replace(/^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)([^:@]{1,200}):([^@]{1,200})@(.*)$/, "$1REDACTED:REDACTED@$4");
}
/**
 * Redacts sensitive query parameters from a URL
 * @param url - The URL string to redact
 * @returns The URL with sensitive query parameters redacted
 */
/*#__NO_SIDE_EFFECTS__*/
function redactQueryParameters(url, config) {
    var sensitiveParams;
    var questionMarkIndex = ts_utils_strIndexOf(url, "?");
    if (questionMarkIndex === -1) {
        return url;
    }
    var option = config ? config.redactUrls : undefined;
    if (option === 3 /* eUrlRedactionOptions.appendToDefault */) {
        sensitiveParams = DEFAULT_SENSITIVE_PARAMS[_DYN_CONCAT /* @min:%2econcat */](config.redactQueryParams);
    }
    else if (option === 4 /* eUrlRedactionOptions.replaceDefault */) {
        sensitiveParams = config.redactQueryParams;
    }
    else {
        sensitiveParams = DEFAULT_SENSITIVE_PARAMS;
    }
    var baseUrl = ts_utils_strSubstring(url, 0, questionMarkIndex + 1);
    var queryString = ts_utils_strSubstring(url, questionMarkIndex + 1);
    var fragment = InternalConstants_STR_EMPTY;
    var hashIndex = ts_utils_strIndexOf(queryString, "#");
    if (hashIndex !== -1) {
        fragment = ts_utils_strSubstring(queryString, hashIndex);
        queryString = ts_utils_strSubstring(queryString, 0, hashIndex);
    }
    var hasPotentialSensitiveParam = false;
    for (var i = 0; i < sensitiveParams[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
        var paramCheck = sensitiveParams[i] + "=";
        if (ts_utils_strIndexOf(queryString, paramCheck) !== -1) {
            hasPotentialSensitiveParam = true;
            break;
        }
    }
    if (!hasPotentialSensitiveParam) {
        return url;
    }
    var resultParts = [];
    var anyParamRedacted = false;
    if (queryString && queryString[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
        var pairs = queryString[_DYN_SPLIT /* @min:%2esplit */]("&");
        for (var i = 0; i < pairs[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
            var pair = pairs[i];
            if (!pair) {
                continue;
            }
            var equalsIndex = ts_utils_strIndexOf(pair, "=");
            if (equalsIndex === -1) {
                // Parameter without value
                resultParts[_DynamicConstants_DYN_PUSH /* @min:%2epush */](pair);
            }
            else {
                var paramName = pair[_DYN_SUBSTRING /* @min:%2esubstring */](0, equalsIndex);
                var paramValue = pair[_DYN_SUBSTRING /* @min:%2esubstring */](equalsIndex + 1);
                if (paramValue === InternalConstants_STR_EMPTY) {
                    resultParts[_DynamicConstants_DYN_PUSH /* @min:%2epush */](pair);
                }
                else {
                    var shouldRedact = false;
                    for (var j = 0; j < sensitiveParams[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; j++) {
                        if (paramName === sensitiveParams[j]) {
                            shouldRedact = true;
                            anyParamRedacted = true;
                            break;
                        }
                    }
                    if (shouldRedact) {
                        resultParts[_DynamicConstants_DYN_PUSH /* @min:%2epush */](paramName + "=" + STR_REDACTED);
                    }
                    else {
                        resultParts[_DynamicConstants_DYN_PUSH /* @min:%2epush */](pair);
                    }
                }
            }
        }
    }
    // If no parameters were redacted, return the original URL
    if (!anyParamRedacted) {
        return url;
    }
    return baseUrl + resultParts[_DYN_JOIN /* @min:%2ejoin */]("&") + fragment;
}
/**
 * Redacts sensitive information from a URL string, including credentials and specific query parameters.
 * @param input - The URL string to be redacted.
 * @param config - Configuration object that contain redactUrls setting.
 * @returns The redacted URL string or the original string if no redaction was needed or possible.
 */
/*#__NO_SIDE_EFFECTS__*/
function fieldRedaction(input, config) {
    if (!input || !ts_utils_isString(input) || ts_utils_strIndexOf(input, " ") !== -1) {
        return input;
    }
    var option = config ? config.redactUrls : undefined;
    var isRedactionDisabled = option === false || option === 2 /* eUrlRedactionOptions.false */;
    if (isRedactionDisabled) {
        return input;
    }
    var hasCredentials = ts_utils_strIndexOf(input, "@") !== -1;
    var hasQueryParams = ts_utils_strIndexOf(input, "?") !== -1;
    // If no credentials and no query params, return original
    if (!hasCredentials && !hasQueryParams) {
        return input;
    }
    if (option === 5 /* eUrlRedactionOptions.usernamePasswordOnly */) {
        hasQueryParams = false;
    }
    if (option === 6 /* eUrlRedactionOptions.queryParamsOnly */) {
        hasCredentials = false;
    }
    try {
        var result = input;
        if (hasCredentials) {
            result = redactUserInfo(input);
        }
        if (hasQueryParams) {
            result = redactQueryParameters(result, config);
        }
        return result;
    }
    catch (e) {
        return input;
    }
}
//# sourceMappingURL=EnvUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/RandomHelper.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
var SEED1 = 123456789;
var SEED2 = 987654321;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = SEED1;
var _mwcZ = SEED2;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (SEED1 + seedValue) & MaxUInt32;
    _mwcZ = (SEED2 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = ts_utils_utcNow() & 0x7fffffff;
        _mwcSeed(((mathRandom() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue - The max value for the range
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return mathFloor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value = 0;
    var c = getCrypto() || getMsCrypto();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    if (value === 0 && isIE()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    if (value === 0) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mathFloor((UInt32Mask * mathRandom()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = random32() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = InternalConstants_STR_EMPTY;
    while (result[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
//# sourceMappingURL=RandomHelper.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/DataCacheHelper.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var version = '3.4.1';
var instanceName = "." + newId(6);
var _dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function _canAcceptData(target) {
    return target.nodeType === 1 || target.nodeType === 9 || !(+target.nodeType);
}
function _getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if (_canAcceptData(target)) {
                ts_utils_objDefine(target, data.id, {
                    e: false,
                    v: theCache
                });
            }
        }
        catch (e) {
            // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function DataCacheHelper_createUniqueNamespace(name, includeVersion) {
    if (includeVersion === void 0) { includeVersion = false; }
    return HelperFuncs_normalizeJsName(name + (_dataUid++) + (includeVersion ? "." + version : InternalConstants_STR_EMPTY) + instanceName);
}
function createElmNodeData(name) {
    var data = {
        id: DataCacheHelper_createUniqueNamespace("_aiData-" + (name || InternalConstants_STR_EMPTY) + "." + version),
        accept: function (target) {
            return _canAcceptData(target);
        },
        get: function (target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = _getCache(data, target);
                    theCache[HelperFuncs_normalizeJsName(name)] = defValue;
                }
                return defValue;
            }
            return theCache[HelperFuncs_normalizeJsName(name)];
        },
        kill: function (target, name) {
            if (target && target[name]) {
                try {
                    delete target[name];
                }
                catch (e) {
                    // Just cleaning up, so if this fails -- ignore
                }
            }
        }
    };
    return data;
}
//# sourceMappingURL=DataCacheHelper.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/config/ConfigDefaults.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _isConfigDefaults(value) {
    return (value && ts_utils_isObject(value) && !ts_utils_isArray(value) && (value.isVal || value.fb || objHasOwn(value, "v") || objHasOwn(value, "mrg") || objHasOwn(value, "ref") || value.set));
}
function _getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || isDefined;
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!ts_utils_isArray(fallbacks)) {
            fallbacks = [fallbacks];
        }
        for (var lp = 0; lp < fallbacks[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) {
                defValue = fbValue;
            }
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) {
                    defValue = fbValue;
                }
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, ts_utils_asString(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) {
                // We have a valid default so break out of the look
                break;
            }
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) {
        defValue = cfgDefaults.v;
    }
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */
function _resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && _isConfigDefaults(cfgDefaults)) {
        theValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    if (theValue) {
        if (_isConfigDefaults(theValue)) {
            theValue = _resolveDefaultValue(dynamicHandler, theConfig, theValue);
        }
        var newValue_1;
        if (ts_utils_isArray(theValue)) {
            newValue_1 = [];
            newValue_1[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = theValue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        }
        else if (isPlainObject(theValue)) {
            newValue_1 = {};
        }
        if (newValue_1) {
            ts_utils_objForEachKey(theValue, function (key, value) {
                if (value && _isConfigDefaults(value)) {
                    value = _resolveDefaultValue(dynamicHandler, theConfig, value);
                }
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
/**
 * Applies the default value on the config property and makes sure that it's dynamic
 * @param theConfig
 * @param name
 * @param defaultValue
 */
function _applyDefaultValue(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if (_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults.rdOnly;
        blkDynamicValue = cfgDefaults.blkVal;
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && ts_utils_isUndefined(reference)) {
            reference = !!mergeDf;
        }
        defValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    else {
        defValue = defaultValue;
    }
    if (blkDynamicValue) {
        // Mark the property so that any value assigned will be blocked from conversion, we need to do this
        // before assigning or fetching the value to ensure it's not converted
        dynamicHandler.blkVal(theConfig, name);
    }
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !ts_utils_isNullOrUndefined(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if (isPlainObject(theValue) || ts_utils_isArray(defValue)) {
            // we are using the user supplied value and it's an object
            if (mergeDf && defValue && (isPlainObject(defValue) || ts_utils_isArray(defValue))) {
                // Resolve/apply the defaults
                ts_utils_objForEachKey(defValue, function (dfName, dfValue) {
                    // Sets the value and makes it dynamic (if it doesn't already exist)
                    _applyDefaultValue(dynamicHandler, theValue, dfName, dfValue);
                });
            }
        }
    }
    else if (defValue) {
        // Just resolve the default
        theValue = _resolveDefaultValue(dynamicHandler, theConfig, defValue);
    }
    else {
        theValue = defValue;
    }
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) {
        dynamicHandler.ref(theConfig, name);
    }
    if (readOnly) {
        dynamicHandler.rdOnly(theConfig, name);
    }
}
//# sourceMappingURL=ConfigDefaults.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/config/DynamicSupport.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




// Using Symbol.for so that if the same symbol was already created it would be returned
// To handle multiple instances using potentially different versions we are not using
// createUniqueNamespace()
var CFG_HANDLER_LINK = symbolFor("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */
var BLOCK_DYNAMIC = symbolFor("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */
var FORCE_DYNAMIC = symbolFor("[[ai_frcDynCfg_1]]");
function _cfgDeepCopy(source) {
    if (source) {
        var target_1;
        if (ts_utils_isArray(source)) {
            target_1 = [];
            target_1[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = source[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        }
        else if (isPlainObject(source)) {
            target_1 = {};
        }
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            ts_utils_objForEachKey(source, function (key, value) {
                // Perform a deep copy of the object
                target_1[key] = _cfgDeepCopy(value);
            });
            return target_1;
        }
    }
    return source;
}
/**
 * @internal
 * Get the dynamic config handler if the value is already dynamic
 * @param value - The value to check for dynamic config handler
 * @returns The dynamic config handler if present, null otherwise
 */
function getDynamicConfigHandler(value) {
    if (value) {
        var handler = value[CFG_HANDLER_LINK] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[CFG_HANDLER_LINK] === handler)) {
            return handler;
        }
    }
    return null;
}
/**
 * Mark the provided value so that if it's included into the configuration it will NOT have
 * its properties converted into a dynamic (reactive) object. If the object is not a plain object
 * or an array (ie. a class) this function has not affect as only Objects and Arrays are converted
 * into dynamic objects in the dynamic configuration.
 *
 * When you have tagged a value as both {@link forceDynamicConversion} and blocked force will take precedence.
 *
 * You should only need to use this function, if you are creating dynamic "classes" from objects
 * which confirm to the require interface. A common case for this is during unit testing where it's
 * easier to create mock extensions.
 *
 * If `value` is falsy (null / undefined / 0 / empty string etc) it will not be tagged and
 * if there is an exception adding the property to the value (because its frozen etc) the
 * exception will be swallowed
 *
 * @example
 * ```ts
 * // This is a valid "extension", but it is technically an object
 * // So when included in the config.extensions it WILL be cloned and then
 * // converted into a dynamic object, where all of its properties will become
 * // get/set object properties and will be tracked. While this WILL still
 * // function, when attempt to use a mocking framework on top of this the
 * // functions are now technically get accessors which return a function
 * // and this can cause some mocking frameworks to fail.
 * let mockChannel = {
 *      pause: () => { },
*      resume: () => { },
*      teardown: () => { },
*      flush: (async: any, callBack: any) => { },
*      processTelemetry: (env: any) => { },
*      setNextPlugin: (next: any) => { },
*      initialize: (config: any, core: any, extensions: any) => { },
*      identifier: "testChannel",
*      priority: 1003
* };
 * ```
 * @param value - The object that you want to block from being converted into a
 * trackable dynamic object
 * @returns The original value
 */
function blockDynamicConversion(value) {
    if (value && (isPlainObject(value) || ts_utils_isArray(value))) {
        try {
            value[BLOCK_DYNAMIC] = true;
        }
        catch (e) {
            // Don't throw for this case as it's an ask only
        }
    }
    return value;
}
/**
 * This is the reverse case of {@link blockDynamicConversion} in that this will tag an
 * object to indicate that it should always be converted into a dynamic trackable object
 * even when not an object or array. So all properties of this object will become
 * get / set accessor functions.
 *
 * When you have tagged a value as both {@link forceDynamicConversion} and blocked force will take precedence.
 *
 * If `value` is falsy (null / undefined / 0 / empty string etc) it will not be tagged and
 * if there is an exception adding the property to the value (because its frozen etc) the
 * exception will be swallowed.
 * @param value - The object that should be tagged and converted if included into a dynamic
 * configuration.
 * @returns The original value
 */
function forceDynamicConversion(value) {
    if (value) {
        try {
            value[FORCE_DYNAMIC] = true;
        }
        catch (e) {
            // Don't throw for this case as it's an ask only
        }
    }
    return value;
}
/**
 * @internal
 * @ignore
 * Helper function to check whether an object can or should be converted into a dynamic
 * object.
 * @param value - The object to check whether it should be converted
 * @returns `true` if the value should be converted otherwise `false`.
 */
function _canMakeDynamic(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[BLOCK_DYNAMIC]) {
            // Only convert plain objects or arrays by default
            result = isPlainObject(value) || ts_utils_isArray(value);
        }
    }
    return result;
}
/**
 * Throws an invalid access exception
 * @param message - The message to include in the exception
 */
function throwInvalidAccess(message) {
    ts_utils_throwTypeError("InvalidAccess:" + message);
}
//# sourceMappingURL=DynamicSupport.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/config/DynamicProperty.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var _throwDynamicError = function (logger, name, desc, e) {
    logger && logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](3 /* eLoggingSeverity.DEBUG */, 108 /* _eInternalMessageId.DynamicConfigException */, "".concat(desc, " [").concat(name, "] failed - ") + ts_utils_dumpObj(e));
};
function _patchArray(state, target, name) {
    if (ts_utils_isArray(target)) {
        // Monkey Patch the methods that might change the array
        ts_utils_arrForEach(arrayMethodsToPatch, function (method) {
            var orgMethod = target[method];
            target[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result = orgMethod[_DYN_APPLY /* @min:%2eapply */](this, args);
                // items may be added, removed or moved so need to make some new dynamic properties
                _makeDynamicObject(state, target, name, "Patching");
                return result;
            };
        });
    }
}
function _getOwnPropGetter(target, name) {
    var propDesc = objGetOwnPropertyDescriptor(target, name);
    return propDesc && propDesc.get;
}
function _createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function (handler) {
            if (handler && handler.fn) {
                if (ts_utils_arrIndexOf(detail.h, handler) === -1) {
                    // Add this handler to the collection that should be notified when the value changes
                    detail.h[_DynamicConstants_DYN_PUSH /* @min:%2epush */](handler);
                }
                state.trk(handler, detail);
            }
        },
        clr: function (handler) {
            var idx = ts_utils_arrIndexOf(detail.h, handler);
            if (idx !== -1) {
                detail.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
            }
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[CFG_HANDLER_LINK] && isObjectOrArray) {
                // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
                value = _makeDynamicObject(state, value, name, "Converting");
            }
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) {
            detail.trk(activeHandler);
        }
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function () {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) {
                // field is marked as readonly so return false
                throwInvalidAccess("[" + name + "] is read-only:" + ts_utils_dumpObj(theConfig));
            }
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    ts_utils_objForEachKey(value, function (key) {
                        value[key] = newValue ? newValue[key] : UNDEFINED_VALUE;
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        ts_utils_objForEachKey(newValue, function (key, theValue) {
                            _setDynamicProperty(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    }
                    catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                }
                else if (value && value[CFG_HANDLER_LINK]) {
                    // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                    // for every property it has already
                    ts_utils_objForEachKey(value, function (key) {
                        // Check if the value is dynamic
                        var getter = _getOwnPropGetter(value, key);
                        if (getter) {
                            // And if it is tell it's listeners that the value has changed
                            var valueState = getter[state.prop];
                            valueState && valueState.chng();
                        }
                    });
                }
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && _canMakeDynamic(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) {
                    // As the newValue is an object/array lets preemptively make it dynamic
                    newValue = _makeDynamicObject(state, newValue, name, "Converting");
                }
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    ts_utils_objDefine(theConfig, detail.n, { g: _getProperty, s: _setProperty });
}
function _setDynamicProperty(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) {
            _createDynamicProperty(state, target, name, value);
        }
        else {
            // Looks like it's already dynamic just assign the new value
            target[name] = value;
        }
    }
    return target;
}
function _setDynamicPropertyState(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */];
        if (!isDynamic) {
            if (blkProp) {
                try {
                    // Attempt to mark the target as blocked from conversion
                    blockDynamicConversion(target);
                }
                catch (e) {
                    _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Blocking", e);
                }
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                _setDynamicProperty(state, target, name, target[name]);
                getter = _getOwnPropGetter(target, name);
            }
            catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) {
            getter[state.rf] = inPlace;
        }
        if (rdOnly) {
            getter[state.ro] = rdOnly;
        }
        if (blkProp) {
            getter[state.blkVal] = true;
        }
    }
    return target;
}
function _makeDynamicObject(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        ts_utils_objForEachKey(target, function (key, value) {
            // Assign and/or make the property dynamic
            _setDynamicProperty(state, target, key, value);
        });
        if (!target[CFG_HANDLER_LINK]) {
            // Link the config back to the dynamic config details
            ts_utils_objDefineProp(target, CFG_HANDLER_LINK, {
                get: function () {
                    return state.hdlr;
                }
            });
            _patchArray(state, target, name);
        }
    }
    catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, desc, e);
    }
    return target;
}
//# sourceMappingURL=DynamicProperty.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/AggregationError.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var aggregationErrorType;
/**
 * Throws an Aggregation Error which includes all of the errors that led to this error occurring
 * @param message - The message describing the aggregation error (the sourceError details are added to this)
 * @param sourceErrors - An array of the errors that caused this situation
 */
function throwAggregationError(message, sourceErrors) {
    if (!aggregationErrorType) {
        aggregationErrorType = ts_utils_createCustomError("AggregationError", function (self, args) {
            if (args[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 1) {
                // Save the provided errors
                self.errors = args[1];
            }
        });
    }
    var theMessage = message || "One or more errors occurred.";
    ts_utils_arrForEach(sourceErrors, function (srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat(ts_utils_dumpObj(srcError));
    });
    throw new aggregationErrorType(theMessage, sourceErrors || []);
}
//# sourceMappingURL=AggregationError.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/config/DynamicState.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var symPrefix = "[[ai_";
var symPostfix = "]]";
function _createState(cfgHandler) {
    var dynamicPropertySymbol = newSymbol(symPrefix + "get" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReadOnly = newSymbol(symPrefix + "ro" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReferenced = newSymbol(symPrefix + "rf" + cfgHandler.uid + symPostfix);
    var dynamicPropertyBlockValue = newSymbol(symPrefix + "blkVal" + cfgHandler.uid + symPostfix);
    var dynamicPropertyDetail = newSymbol(symPrefix + "dtl" + cfgHandler.uid + symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                ts_utils_arrForEach(activeHandler[dynamicPropertyDetail], function (detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler.setDf.bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler.rdOnly.bind(cfgHandler)
            });
        }
        catch (e) {
            var logger = cfgHandler[_DYN_LOGGER /* @min:%2elogger */];
            if (logger) {
                // Don't let one individual failure break everyone
                logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](1 /* eLoggingSeverity.CRITICAL */, 107 /* _eInternalMessageId.ConfigWatcherException */, ts_utils_dumpObj(e));
            }
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        }
        finally {
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[_DYN_CANCEL /* @min:%2ecancel */]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            ts_utils_arrForEach(notifyHandlers, function (handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        ts_utils_arrForEach(handler[dynamicPropertyDetail], function (detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) {
                        try {
                            _useHandler(handler, handler.fn);
                        }
                        catch (e) {
                            // Don't let a single failing watcher cause other watches to fail
                            watcherFailures_1[_DynamicConstants_DYN_PUSH /* @min:%2epush */](e);
                        }
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) {
                try {
                    _notifyWatchers();
                }
                catch (e) {
                    watcherFailures_1[_DynamicConstants_DYN_PUSH /* @min:%2epush */](e);
                }
            }
            if (watcherFailures_1[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                throwAggregationError("Watcher error(s): ", watcherFailures_1);
            }
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            if (!_waitingHandlers) {
                _waitingHandlers = [];
            }
            if (!_watcherTimer) {
                _watcherTimer = ts_utils_scheduleTimeout(function () {
                    _watcherTimer = null;
                    _notifyWatchers();
                }, 0);
            }
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for (var idx = 0; idx < detail.h[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; idx++) {
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && ts_utils_arrIndexOf(_waitingHandlers, handler) === -1) {
                    _waitingHandlers[_DynamicConstants_DYN_PUSH /* @min:%2epush */](handler);
                }
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if (ts_utils_arrIndexOf(details, detail) === -1) {
                // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
                details[_DynamicConstants_DYN_PUSH /* @min:%2epush */](detail);
            }
        }
    }
    theState = {
        prop: dynamicPropertySymbol,
        ro: dynamicPropertyReadOnly,
        rf: dynamicPropertyReferenced,
        blkVal: dynamicPropertyBlockValue,
        hdlr: cfgHandler,
        add: _addWatcher,
        notify: _notifyWatchers,
        use: _useHandler,
        trk: _trackHandler
    };
    return theState;
}
//# sourceMappingURL=DynamicState.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/config/DynamicConfig.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */
function _createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function () {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    ts_utils_objDefine(handler, "toJSON", { v: function () { return "WatcherHandler" + (handler.fn ? InternalConstants_STR_EMPTY : "[X]"); } });
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */
function _createDynamicHandler(logger, target, inPlace) {
    var dynamicHandler = getDynamicConfigHandler(target);
    if (dynamicHandler) {
        // The passed config is already dynamic so return it's tracker
        return dynamicHandler;
    }
    var uid = DataCacheHelper_createUniqueNamespace("dyncfg", true);
    var newTarget = (target && inPlace !== false) ? target : _cfgDeepCopy(target);
    var theState;
    function _notifyWatchers() {
        theState.notify();
    }
    function _setValue(target, name, value) {
        try {
            target = _setDynamicProperty(theState, target, name, value);
        }
        catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            _throwDynamicError(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return _createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function (details) {
            var prevUpd = theState.upd;
            try {
                if (!ts_utils_isUndefined(allowUpdate)) {
                    theState.upd = allowUpdate;
                }
                configHandler(details);
            }
            finally {
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) {
            // Resolve/apply the defaults
            ts_utils_objForEachKey(defaultValues, function (name, value) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                _applyDefaultValue(cfgHandler, theConfig, name, value);
            });
        }
        return theConfig;
    }
    var cfgHandler = {
        uid: null,
        cfg: newTarget,
        logger: logger,
        notify: _notifyWatchers,
        set: _setValue,
        setDf: _applyDefaults,
        watch: _watch,
        ref: _ref,
        rdOnly: _rdOnly,
        blkVal: _blkPropValue,
        _block: _block
    };
    ts_utils_objDefine(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = _createState(cfgHandler);
    // Setup tracking for all defined default keys
    _makeDynamicObject(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 */
function _logInvalidAccess(logger, message) {
    if (logger) {
        logger[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
        logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](2 /* eLoggingSeverity.WARNING */, 108 /* _eInternalMessageId.DynamicConfigException */, message);
    }
    else {
        // We don't have a logger so just throw an exception
        throwInvalidAccess(message);
    }
}
/**
 * Create or return a dynamic version of the passed config, if it is not already dynamic
 * @param config - The config to be converted into a dynamic config
 * @param defaultConfig - The default values to apply on the config if the properties don't already exist
 * @param inPlace - Should the config be converted in-place into a dynamic config or a new instance returned, defaults to true
 * @returns The dynamic config handler for the config (whether new or existing)
 */
function createDynamicConfig(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = _createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) {
        dynamicHandler.setDf(dynamicHandler.cfg, defaultConfig);
    }
    return dynamicHandler;
}
/**
 * Watch and track changes for accesses to the current config, the provided config MUST already be
 * a dynamic config or a child accessed via the dynamic config
 * @param logger - The logger instance to use if there is no existing handler
 * @returns A watcher handler instance that can be used to remove itself when being unloaded
 * @throws TypeError if the provided config is not a dynamic config instance
 */
function onConfigChange(config, configHandler, logger) {
    var handler = config[CFG_HANDLER_LINK] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[CFG_HANDLER_LINK] === handler)) {
        return handler[_DYN_WATCH /* @min:%2ewatch */](configHandler);
    }
    _logInvalidAccess(logger, STR_NOT_DYNAMIC_ERROR + ts_utils_dumpObj(config));
    return createDynamicConfig(config, null, logger)[_DYN_WATCH /* @min:%2ewatch */](configHandler);
}
//# sourceMappingURL=DynamicConfig.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/DbgExtensionUtils.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var listenerFuncs = [STR_EVENTS_SENT, STR_EVENTS_DISCARDED, STR_EVENTS_SEND_REQUEST, STR_PERF_EVENT];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
    return function () {
        var args = arguments;
        var dbgExt = getDebugExt(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) {
                listener[name][_DYN_APPLY /* @min:%2eapply */](listener, args);
            }
        }
    };
}
function _getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = ts_utils_getInst("Microsoft");
    if (target) {
        _aiNamespace = target["ApplicationInsights"];
    }
    return _aiNamespace;
}
function getDebugExt(config) {
    var ns = _aiNamespace;
    if (!ns && config.disableDbgExt !== true) {
        ns = _aiNamespace || _getExtensionNamespace();
    }
    return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
    if (!_debugListener) {
        _debugListener = {};
        for (var lp = 0; lp < listenerFuncs[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
            _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
        }
    }
    return _debugListener;
}
//# sourceMappingURL=DbgExtensionUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/diagnostics/DiagnosticLogger.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var DiagnosticLogger_a;







var STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
var defaultValues = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var _logFuncs = (DiagnosticLogger_a = {},
    DiagnosticLogger_a[0 /* eLoggingSeverity.DISABLED */] = null,
    DiagnosticLogger_a[1 /* eLoggingSeverity.CRITICAL */] = "errorToConsole",
    DiagnosticLogger_a[2 /* eLoggingSeverity.WARNING */] = STR_WARN_TO_CONSOLE,
    DiagnosticLogger_a[3 /* eLoggingSeverity.DEBUG */] = "debugToConsole",
    DiagnosticLogger_a);
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](/\"/g, InternalConstants_STR_EMPTY) + "\"";
    }
    return InternalConstants_STR_EMPTY;
}
function _logToConsole(func, message) {
    var theConsole = getConsole();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) {
            logFunc = func;
        }
        if (ts_utils_isFunction(theConsole[logFunc])) {
            theConsole[logFunc](message);
        }
    }
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self[_DYN_MESSAGE_ID /* @min:%2emessageId */] = msgId;
        _self[_DYN_MESSAGE /* @min:%2emessage */] =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = InternalConstants_STR_EMPTY;
        if (hasJSON()) {
            strProps = EnvUtils_getJSON()[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : InternalConstants_STR_EMPTY) +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : InternalConstants_STR_EMPTY);
        _self[_DYN_MESSAGE /* @min:%2emessage */] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

/*#__NO_SIDE_EFFECTS__*/
function safeGetLogger(core, config) {
    return (core || {})[_DYN_LOGGER /* @min:%2elogger */] || new DiagnosticLogger(config || (core || {})[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        dynamicProto(DiagnosticLogger, this, function (_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function () { return _loggingLevelConsole; };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - The severity of the log message
             * @param message  - The log message.
             */
            _self[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */] = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_enableDebug) {
                    throw ts_utils_dumpObj(message);
                }
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = _logFuncs[severity] || STR_WARN_TO_CONSOLE;
                    if (!ts_utils_isUndefined(message[_DYN_MESSAGE /* @min:%2emessage */])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE /* @min:%2emessage */]);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // Only log traces if the console Logging Level is >= the throwInternal severity level
                            if (_loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE /* @min:%2emessage */]);
                            }
                        }
                        _logInternalMessage(severity, message);
                    }
                    else {
                        _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */ ? "Critical" : "Warning"), message);
                    }
                }
            };
            _self.debugToConsole = function (message) {
                _logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */] = function (message) {
                _logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function (message) {
                _logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self.logInternalMessage = _logInternalMessage;
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            ts_utils_objDefine(_self, "dbgMode", {
                g: function () { return _enableDebug; }
            });
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](message);
                        _messageCount++;
                        _debugExtMsg((severity === 1 /* eLoggingSeverity.CRITICAL */ ? "error" : "warn"), message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */, throttleLimitMessage, false);
                        _self.queue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */) {
                            _self.errorToConsole(throttleLimitMessage);
                        }
                        else {
                            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](throttleLimitMessage);
                        }
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return onConfigChange(createDynamicConfig(config, defaultValues, _self).cfg, function (details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = getDebugExt(config || {});
                if (dbgExt && dbgExt[_DYN_DIAG_LOG /* @min:%2ediagLog */]) {
                    dbgExt[_DYN_DIAG_LOG /* @min:%2ediagLog */](name, data);
                }
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.debugToConsole.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.errorToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
// Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn=1;

    return DiagnosticLogger;
}());

function _getLogger(logger) {
    return (logger || new DiagnosticLogger());
}
/**
 * This is a helper method which will call throwInternal on the passed logger, will throw exceptions in
 * debug mode or attempt to log the error as a console warning. This helper is provided mostly to better
 * support minification as logger.throwInternal() will not compress the publish "throwInternal" used throughout
 * the code.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - The severity of the log message
 * @param message  - The log message.
 */
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) { isUserAct = false; }
    _getLogger(logger)[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](severity, msgId, msg, properties, isUserAct);
}
/**
 * This is a helper method which will call warnToConsole on the passed logger with the provided message.
 * @param logger - The Diagnostic Logger instance to use.
 * @param message  - The log message.
 */
function _warnToConsole(logger, message) {
    _getLogger(logger)[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
}
/**
 * Logs a message to the internal queue.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity  - The severity of the log message
 * @param message - The message to log.
 */
function _logInternalMessage(logger, severity, message) {
    _getLogger(logger).logInternalMessage(severity, message);
}
//# sourceMappingURL=DiagnosticLogger.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/enums/EnumHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Create an enum style object which has both the key \=\> value and value \=\> key mappings
 * @param values - The values to populate on the new object
 * @returns
 */
var createEnumStyle = createEnum;
/**
 * Create a 2 index map that maps an enum's key and value to the defined map value, X["key"] \=\> mapValue and X[0] \=\> mapValue.
 * Generic values
 * - E = the const enum type (typeof eRequestHeaders);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @param values - The values to populate on the new object
 * @returns
 */
var createValueMap = createTypeMap;
//# sourceMappingURL=EnumHelperFuncs.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/enums/ai/Enums.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var StorageType = ( /* @__PURE__ */createEnumStyle({
    LocalStorage: 0 /* eStorageType.LocalStorage */,
    SessionStorage: 1 /* eStorageType.SessionStorage */
}));
var DistributedTracingModes = ( /* @__PURE__ */createEnumStyle({
    AI: 0 /* eDistributedTracingModes.AI */,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */,
    W3C: 2 /* eDistributedTracingModes.W3C */,
    AI_AND_W3C_TRACE: 17 /* eDistributedTracingModes.AI_AND_W3C_TRACE */,
    W3C_TRACE: 18 /* eDistributedTracingModes.W3C_TRACE */,
    // Internal mask values
    _BaseMask: 15 /* eDistributedTracingModes._BaseMask */,
    _W3CTraceState: 16 /* eDistributedTracingModes._W3CTraceState */
}));
/**
 * The EventPersistence contains a set of values that specify the event's persistence.
 */
var EventPersistence = ( /* @__PURE__ */createEnumStyle({
    /**
     * Normal persistence.
     */
    Normal: 1 /* EventPersistenceValue.Normal */,
    /**
     * Critical persistence.
     */
    Critical: 2 /* EventPersistenceValue.Critical */
}));
//# sourceMappingURL=Enums.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/StorageHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
var _storagePrefix = InternalConstants_STR_EMPTY;
/**
 * Gets the localStorage object if available
 * @returns {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(StorageType.LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType - Type of storage
 * @returns {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (ts_utils_isNullOrUndefined(getGlobal())) {
            return null;
        }
        var uid = (new Date)[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
        var storage = ts_utils_getInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = _storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name_1);
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @returns {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(StorageType.SessionStorage);
    }
    return null;
}
/**
 * Disables the global SDK usage of local or session storage if available
 */
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlSetStoragePrefix(storagePrefix) {
    _storagePrefix = storagePrefix || InternalConstants_STR_EMPTY;
}
/**
 * Re-enables the global SDK usage of local or session storage if available
 */
function utlEnableStorage() {
    _canUseLocalStorage = utlCanUseLocalStorage(true);
    _canUseSessionStorage = utlCanUseSessionStorage(true);
}
/**
 * Returns whether LocalStorage can be used, if the reset parameter is passed a true this will override
 * any previous disable calls.
 * @param reset - Should the usage be reset and determined only based on whether LocalStorage is available
 */
function utlCanUseLocalStorage(reset) {
    if (reset || _canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */, "Browser failed read of local storage. " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */, "Browser failed write to local storage. " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */, "Browser failed removal of local storage item. " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage(reset) {
    if (reset || _canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        objForEachKey(getGlobalInst("sessionStorage"), function (key) {
            keys[_DYN_PUSH /* @min:%2epush */](key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */, "Browser failed read of session storage. " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */, "Browser failed write to session storage. " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage[_DYN_REMOVE_ITEM /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */, "Browser failed removal of session storage item. " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/index.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
















//export { IStatsBeat, IStatsBeatConfig, IStatsBeatKeyMap as IStatsBeatEndpoints, IStatsBeatState} from "./interfaces/ai/IStatsBeat";
//export { IStatsEventData } from "./interfaces/ai/IStatsEventData";
//export { IStatsMgr, IStatsMgrConfig } from "./interfaces/ai/IStatsMgr";
//export { createStatsMgr } from "./core/StatsBeat";






























// OpenTelemetry Enums


// OpenTelemetry Helper Utilities



// OpenTelemetry Error Handlers

// OpenTelemetry Error Classes



// ========================================
// Application Insights Common Exports
// ========================================
// Utility functions





// Telemetry classes










// Severity level

// Configuration

// Context tags and keys


// Data types and envelope types


// Data sanitization

// Telemetry item creator

// Enums

// Helper functions


// Storage helpers

// URL helpers

// Offline support

// Plugin identifiers
var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
// ==========================================================================
// 1DS (OneCollector) exports - merged from @microsoft/1ds-core-js
// ==========================================================================
// 1DS Enums

// 1DS Classes


// 1DS Utils

// 1DS Span Utils

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/CookieMgr.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var CookieMgr_a, _b;








var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc;
var _cookieCache = {};
var _globalCookieConfig = {};
// // `isCookieUseDisabled` is deprecated, so explicitly casting as a key of IConfiguration to avoid typing error
// // when both isCookieUseDisabled and disableCookiesUsage are used disableCookiesUsage will take precedent, which is
// // why its listed first
/**
 * Set the supported dynamic config values as undefined (or an empty object) so that
 * any listeners will be informed of any changes.
 * Explicitly NOT including the deprecated `isCookieUseDisabled` as we don't want to support
 * the v1 deprecated field as dynamic for updates
 */
var rootDefaultConfig = (CookieMgr_a = {
        cookieCfg: cfgDfMerge((_b = {},
            _b[STR_DOMAIN] = { fb: "cookieDomain", dfVal: isNotNullOrUndefined },
            _b.path = { fb: "cookiePath", dfVal: isNotNullOrUndefined },
            _b.enabled = UNDEFINED_VALUE,
            _b.ignoreCookies = UNDEFINED_VALUE,
            _b.blockedCookies = UNDEFINED_VALUE,
            _b.disableCookieDefer = false,
            _b)),
        cookieDomain: UNDEFINED_VALUE,
        cookiePath: UNDEFINED_VALUE
    },
    CookieMgr_a[strDisableCookiesUsage] = UNDEFINED_VALUE,
    CookieMgr_a);
function _getDoc() {
    !_doc && (_doc = getLazy(function () { return ts_utils_getDocument(); }));
}
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && ts_utils_isArray(cookieMgrCfg.ignoreCookies)) {
        return ts_utils_arrIndexOf(cookieMgrCfg.ignoreCookies, name) !== -1;
    }
    return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && ts_utils_isArray(cookieMgrCfg.blockedCookies)) {
        if (ts_utils_arrIndexOf(cookieMgrCfg.blockedCookies, name) !== -1) {
            return true;
        }
    }
    return _isIgnoredCookie(cookieMgrCfg, name);
}
function _isCfgEnabled(rootConfig, cookieMgrConfig) {
    var isCfgEnabled = cookieMgrConfig[_DYN_ENABLED /* @min:%2eenabled */];
    if (ts_utils_isNullOrUndefined(isCfgEnabled)) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        // This field is deprecated and dynamic updates will not be fully supported
        if (!ts_utils_isUndefined(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        // If this value is defined it takes precedent over the above
        if (!ts_utils_isUndefined(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        // Not setting the cookieMgrConfig.enabled as that will update (set) the global dynamic config
        // So future "updates" then may not be as expected
        isCfgEnabled = cookieEnabled;
    }
    return isCfgEnabled;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core - The AppInsightsCore instance to get the cookie manager from
 * @param config - The config to use if the core is not available
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = config.cookieCfg;
        if (cookieCfg && cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER /* @min:%2elogger */]);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var cookieMgrConfig;
    var _path;
    var _domain;
    var unloadHandler;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled;
    var _getCookieFn;
    var _setCookieFn;
    var _delCookieFn;
    // Buffer for storing cookie operations when cookies are disabled
    // null = deferral disabled, array = deferral enabled with pending operations
    var _pendingCookies = [];
    // Helper function to format deletion cookie value
    function _formatDeletionValue(path) {
        var _a;
        var values = (_a = {},
            _a[STR_PATH] = path ? path : "/",
            _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
            _a);
        if (!isIE()) {
            // Set max age to expire now
            values["max-age"] = "0";
        }
        return _formatCookieValue(InternalConstants_STR_EMPTY, values);
    }
    // Helper function to format a cookie value with all attributes
    function _formatSetCookieValue(value, maxAgeSec, domain, path) {
        var values = {};
        var theValue = strTrim(value || InternalConstants_STR_EMPTY);
        var idx = ts_utils_strIndexOf(theValue, ";");
        if (idx !== -1) {
            theValue = strTrim(ts_utils_strLeft(value, idx));
            values = _extractParts(ts_utils_strSubstring(value, idx + 1));
        }
        // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
        setValue(values, STR_DOMAIN, domain || _domain, isTruthy, ts_utils_isUndefined);
        if (!ts_utils_isNullOrUndefined(maxAgeSec)) {
            var _isIE = isIE();
            if (ts_utils_isUndefined(values[strExpires])) {
                var nowMs = ts_utils_utcNow();
                // Only add expires if not already present
                var expireMs = nowMs + (maxAgeSec * 1000);
                // Sanity check, if zero or -ve then ignore
                if (expireMs > 0) {
                    var expiry = new Date();
                    expiry.setTime(expireMs);
                    setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || InternalConstants_STR_EMPTY, isTruthy);
                }
            }
            if (!_isIE) {
                // Only replace if not already present
                setValue(values, "max-age", InternalConstants_STR_EMPTY + maxAgeSec, null, ts_utils_isUndefined);
            }
        }
        var location = getLocation();
        if (location && location.protocol === "https:") {
            setValue(values, "secure", null, null, ts_utils_isUndefined);
            // Only set same site if not also secure
            if (_allowUaSameSite === null) {
                _allowUaSameSite = !uaDisallowsSameSiteNone(getUserAgentString());
            }
            if (_allowUaSameSite) {
                setValue(values, "SameSite", "None", null, ts_utils_isUndefined);
            }
        }
        setValue(values, STR_PATH, path || _path, null, ts_utils_isUndefined);
        return _formatCookieValue(theValue, values);
    }
    // Helper function to remove any existing pending operations for a cookie name
    function _removePendingCookie(name) {
        if (_pendingCookies) {
            // Remove all existing entries for this cookie name (iterate backwards to handle multiple entries safely)
            for (var i = _pendingCookies[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1; i >= 0; i--) {
                if (_pendingCookies[i].n === name) {
                    _pendingCookies[_DYN_SPLICE /* @min:%2esplice */](i, 1);
                }
            }
        }
    }
    // Helper function to flush pending cookies when cookies become enabled
    function _flushPendingCookies() {
        if (areCookiesSupported(logger) && _pendingCookies) {
            // Process all pending cookie operations in order
            ts_utils_arrForEach(_pendingCookies, function (pendingData) {
                if (!_isBlockedCookie(cookieMgrConfig, pendingData.n)) {
                    if (pendingData.o === 0 /* ePendingOp.Set */) {
                        // Apply the cached cookie value directly
                        _setCookieFn(pendingData.n, pendingData.v);
                    }
                    else if (pendingData.o === 1 /* ePendingOp.Purge */) {
                        // Apply the cached deletion
                        _delCookieFn(pendingData.n, pendingData.v);
                    }
                }
            });
            // Clear the cache after flushing
            _pendingCookies = [];
        }
    }
    // Make sure the root config is dynamic as it may be the global config
    rootConfig = createDynamicConfig(rootConfig || _globalCookieConfig, null, logger).cfg;
    // Will get recalled if the referenced configuration is changed
    unloadHandler = onConfigChange(rootConfig, function (details) {
        // Make sure the root config has all of the the defaults to the root config to ensure they are dynamic
        details.setDf(details.cfg, rootDefaultConfig);
        // Create and apply the defaults to the cookieCfg element
        cookieMgrConfig = details.ref(details.cfg, "cookieCfg"); // details.setDf(details.cfg.cookieCfg, defaultConfig);
        _path = cookieMgrConfig[STR_PATH /* @min:%2epath */] || "/";
        _domain = cookieMgrConfig[STR_DOMAIN /* @min:%2edomain */];
        // Handle deferral state changes based on disableCookieDefer setting
        if (cookieMgrConfig.disableCookieDefer) {
            // When deferral is disabled, set to null to disable any deferral behavior
            // All pending operations are dropped
            _pendingCookies = null;
        }
        else if (_pendingCookies === null) {
            // When deferral is enabled and was previously disabled, initialize empty buffer
            _pendingCookies = [];
        }
        // Check if enabled state is changing
        var wasEnabled = _enabled;
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
        _getCookieFn = cookieMgrConfig.getCookie || _getCookieValue;
        _setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
        _delCookieFn = cookieMgrConfig.delCookie || _setCookieValue;
        // If cookies were just enabled via config change and we have pending cookies, flush them
        if (!wasEnabled && _enabled && _pendingCookies) {
            _flushPendingCookies();
        }
    }, logger);
    var cookieMgr = {
        isEnabled: function () {
            var enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && areCookiesSupported(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = _globalCookieConfig[strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) {
                // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                // As the global (deprecated) functions may have been called (for backward compatibility)
                enabled = _isMgrEnabled(gblManager);
            }
            return enabled;
        },
        setEnabled: function (value) {
            // Change the default config and allow the asynchronous dynamic config logic
            // to process all of the changes at once (like handling change to the enabled and
            // disabling caching at the same time)
            cookieMgrConfig[_DYN_ENABLED /* @min:%2eenabled */] = value;
            // If this value is defined someone else might be listening to it so also update it,
            // this also handles the edge case if the default above is not dynamic
            if (!ts_utils_isUndefined(rootConfig[strDisableCookiesUsage])) {
                rootConfig[strDisableCookiesUsage] = !value;
            }
        },
        set: function (name, value, maxAgeSec, domain, path) {
            var result = false;
            var isBlocked = _isBlockedCookie(cookieMgrConfig, name);
            if (!isBlocked) {
                var cookieValue = _formatSetCookieValue(value, maxAgeSec, domain, path);
                if (_isMgrEnabled(cookieMgr)) {
                    _setCookieFn(name, cookieValue);
                    result = true;
                }
                else if (_pendingCookies) {
                    // Defer the fully formatted cookie value if cookies are disabled and deferral is enabled
                    // Remove any previous operation for this cookie name (latest operation wins)
                    _removePendingCookie(name);
                    // Append new operation to the array
                    _pendingCookies[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
                        n: name,
                        o: 0 /* ePendingOp.Set */,
                        v: cookieValue
                    });
                    result = true; // Return true to indicate the operation was "successful" (deferred)
                }
            }
            return result;
        },
        get: function (name) {
            var value = InternalConstants_STR_EMPTY;
            var isIgnored = _isIgnoredCookie(cookieMgrConfig, name);
            if (!isIgnored) {
                if (_isMgrEnabled(cookieMgr)) {
                    value = _getCookieFn(name);
                }
                else if (_pendingCookies) {
                    // Search for the most recent operation for this cookie (search backwards through array)
                    for (var i = _pendingCookies[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1; i >= 0; i--) {
                        var pendingData = _pendingCookies[i];
                        if (pendingData.n === name) {
                            // Found the most recent operation for this cookie name
                            if (pendingData.o === 0 /* ePendingOp.Set */) {
                                // Return deferred value if it was a set operation
                                // Extract the value part from the formatted cookie string (before first semicolon)
                                var cookieValue = pendingData.v;
                                var idx = ts_utils_strIndexOf(cookieValue, ";");
                                value = idx !== -1 ? strTrim(ts_utils_strLeft(cookieValue, idx)) : strTrim(cookieValue);
                            }
                            // If it was a Purge operation, value remains empty (STR_EMPTY)
                            break;
                        }
                    }
                }
            }
            return value;
        },
        del: function (name, path) {
            var result = false;
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                result = cookieMgr.purge(name, path);
            }
            else if (_pendingCookies) {
                // Defer the deletion operation when cookies are disabled and deferral is enabled
                // Remove any previous operation for this cookie name (latest operation wins)
                _removePendingCookie(name);
                // Append new deletion operation to the array
                _pendingCookies[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
                    n: name,
                    o: 1 /* ePendingOp.Purge */,
                    v: _formatDeletionValue(path)
                });
                result = true;
            }
            return result;
        },
        purge: function (name, path) {
            var result = false;
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                _delCookieFn(name, _formatDeletionValue(path));
                result = true;
            }
            return result;
        },
        unload: function (isAsync) {
            unloadHandler && unloadHandler.rm();
            unloadHandler = null;
            // Clear any pending cookies on unload
            _pendingCookies = null;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        !_doc && _getDoc();
        try {
            var doc = _doc.v || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 68 /* _eInternalMessageId.CannotAccessCookie */, "Cannot access document.cookie - " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
        var parts = strTrim(theValue)[_DYN_SPLIT /* @min:%2esplit */](";");
        ts_utils_arrForEach(parts, function (thePart) {
            thePart = strTrim(thePart || InternalConstants_STR_EMPTY);
            if (thePart) {
                var idx = ts_utils_strIndexOf(thePart, "=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[strTrim(ts_utils_strLeft(thePart, idx))] = strTrim(ts_utils_strSubstring(thePart, idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (ts_utils_isFunction(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || InternalConstants_STR_EMPTY;
    ts_utils_objForEachKey(values, function (name, theValue) {
        cookieValue += "; " + name + (!ts_utils_isNullOrUndefined(theValue) ? "=" + theValue : InternalConstants_STR_EMPTY);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = InternalConstants_STR_EMPTY;
    !_doc && _getDoc();
    if (_doc.v) {
        var theCookie = _doc.v[strCookie] || InternalConstants_STR_EMPTY;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = strTrim(_cookieCache[name] || InternalConstants_STR_EMPTY);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    !_doc && _getDoc();
    if (_doc.v) {
        _doc.v[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!ts_utils_isString(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (HelperFuncs_strContains(userAgent, "CPU iPhone OS 12") || HelperFuncs_strContains(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (HelperFuncs_strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && HelperFuncs_strContains(userAgent, "Version/") && HelperFuncs_strContains(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (HelperFuncs_strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (HelperFuncs_strContains(userAgent, "Chrome/5") || HelperFuncs_strContains(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (HelperFuncs_strContains(userAgent, "UnrealEngine") && !HelperFuncs_strContains(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (HelperFuncs_strContains(userAgent, "UCBrowser/12") || HelperFuncs_strContains(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/constants/Constants.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var ChannelControllerPriority = 500;
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";
//# sourceMappingURL=Constants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Common/DataSanitizer.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = ts_utils_strSubstring(field, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = strTrim(ts_utils_asString(name));
        // truncate the string to 150 chars
        if (name[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */) {
            nameTrunc = ts_utils_strSubstring(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 57 /* _eInternalMessageId.NameTooLong */, "name is too long.  It has been truncated to " + 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
/*#__NO_SIDE_EFFECTS__*/
function DataSanitizer_dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; // in case default parameters dont work
        value = strTrim(ts_utils_asString(value));
        if (value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > maxLength) {
            valueTrunc = ts_utils_strSubstring(value, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 61 /* _eInternalMessageId.StringValueTooLong */, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeUrl(logger, url, config) {
    if (ts_utils_isString(url)) {
        url = fieldRedaction(url, config);
    }
    return dataSanitizeInput(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */, 66 /* _eInternalMessageId.UrlTooLong */);
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */) {
            messageTrunc = ts_utils_strSubstring(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 56 /* _eInternalMessageId.MessageTruncated */, "message is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = ts_utils_strSubstring(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 52 /* _eInternalMessageId.ExceptionTruncated */, "exception is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        ts_utils_objForEachKey(properties, function (prop, value) {
            if (ts_utils_isObject(value) && hasJSON()) {
                // Stringify any part C properties
                try {
                    value = EnvUtils_getJSON()[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](value);
                }
                catch (e) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "custom property is not valid", { exception: e }, true);
                }
            }
            value = DataSanitizer_dataSanitizeString(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        ts_utils_objForEachKey(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */, 69 /* _eInternalMessageId.IdTooLong */)[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]() : id;
}
/*#__NO_SIDE_EFFECTS__*/
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = strTrim(ts_utils_asString(input));
        if (input[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > maxLength) {
            inputTrunc = ts_utils_strSubstring(input, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
/*#__NO_SIDE_EFFECTS__*/
function dsPadNumber(num) {
    var s = "00" + num;
    return strSubstr(s, s[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 3);
}
//# sourceMappingURL=DataSanitizer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/TelemetryItemCreator.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * Create a telemetry item that the 1DS channel understands
 * @param item - domain specific properties; part B
 * @param baseType - telemetry item type. ie PageViewData
 * @param envelopeName - Name of the envelope, e.g., `Microsoft.ApplicationInsights.\<instrumentation key\>.PageView`.
 * @param customProperties - user defined custom properties; part C
 * @param systemProperties - system properties that are added to the context; part A
 * @returns ITelemetryItem that is sent to channel
 */
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    envelopeName = DataSanitizer_dataSanitizeString(logger, envelopeName) || strNotSpecified;
    if (ts_utils_isNullOrUndefined(item) ||
        ts_utils_isNullOrUndefined(baseType) ||
        ts_utils_isNullOrUndefined(envelopeName)) {
        throwError("Input doesn't contain all required fields");
    }
    var iKey = "";
    if (item[strIkey]) {
        iKey = item[strIkey];
        delete item[strIkey];
    }
    var telemetryItem = {
        name: envelopeName,
        time: HelperFuncs_toISOString(new Date()),
        iKey: iKey,
        ext: systemProperties ? systemProperties : {},
        tags: [],
        data: {},
        baseType: baseType,
        baseData: item // Part B
    };
    // Part C
    if (!ts_utils_isNullOrUndefined(customProperties)) {
        ts_utils_objForEachKey(customProperties, function (prop, value) {
            telemetryItem[_DYN_DATA /* @min:%2edata */][prop] = value;
        });
    }
    return telemetryItem;
}
var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item - domain specific properties; part B
     * @param baseType - telemetry item type. ie PageViewData
     * @param envelopeName - Name of the envelope (e.g., Microsoft.ApplicationInsights.[instrumentationKey].PageView).
     * @param customProperties - user defined custom properties; part C
     * @param systemProperties - system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = createTelemetryItem;
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/DataTypes.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var EventDataType = "EventData";
var ExceptionDataType = "ExceptionData";
var MetricDataType = "MetricData";
var PageViewDataType = "PageviewData";
var PageViewPerformanceDataType = "PageviewPerformanceData";
var RemoteDependencyDataType = "RemoteDependencyData";
var RequestDataType = "RequestData";
var TraceDataType = "MessageData";
//# sourceMappingURL=DataTypes.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/EnvelopeTypes.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/* #__NO_SIDE_EFFECTS__# */
function _AddPrefix(name) {
    return "Microsoft.ApplicationInsights.{0}." + name;
}
var EventEnvelopeType = ( /*#__PURE__*/_AddPrefix("Event"));
var ExceptionEnvelopeType = ( /*#__PURE__*/_AddPrefix("Exception"));
var MetricEnvelopeType = ( /*#__PURE__*/_AddPrefix("Metric"));
var PageViewEnvelopeType = ( /*#__PURE__*/_AddPrefix("Pageview"));
var PageViewPerformanceEnvelopeType = ( /*#__PURE__*/_AddPrefix("PageviewPerformance"));
var RemoteDependencyEnvelopeType = ( /*#__PURE__*/_AddPrefix("RemoteDependency"));
var RequestEnvelopeType = ( /*#__PURE__*/_AddPrefix("Request"));
var TraceEnvelopeType = ( /*#__PURE__*/_AddPrefix("Message"));
//# sourceMappingURL=EnvelopeTypes.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Exception.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









// These Regex covers the following patterns
// 1. Chrome/Firefox/IE/Edge:
//    at functionName (filename:lineNumber:columnNumber)
//    at functionName (filename:lineNumber)
//    at filename:lineNumber:columnNumber
//    at filename:lineNumber
//    at functionName@filename:lineNumber:columnNumber
// 2. Safari / Opera:
//    functionName@filename:lineNumber:columnNumber
//    functionName@filename:lineNumber
//    filename:lineNumber:columnNumber
//    filename:lineNumber
//    Line ## of scriptname script filename:lineNumber:columnNumber
//    Line ## of scriptname script filename
// 3. IE/Edge (Additional formats)
//    at functionName@filename:lineNumber
var STACKFRAME_BASE_SIZE = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
/**
 * Check if the string conforms to what looks like a stack frame line and not just a general message
 * comment or other non-stack related info.
 *
 * This  should be used to filter out any leading "message" lines from a stack trace, before attempting to parse
 * the individual stack frames. Once you have estabilsted the start of the stack frames you can then use the
 * FULL_STACK_FRAME_1, FULL_STACK_FRAME_2, FULL_STACK_FRAME_3, and EXTRACT_FILENAME to parse the individual
 * stack frames to extract the method, filename, line number, and column number.
 * These may still provide invalid matches, so the sequence of execution is important to avoid providing
 * an invalid parsed stack.
 */
var IS_FRAME = /^\s{0,50}(from\s|at\s|Line\s{1,5}\d{1,10}\s{1,5}of|\w{1,50}@\w{1,80}|[^\(\s\n]+:[0-9\?]+(?::[0-9\?]+)?)/;
/**
 * Parse a well formed stack frame with both the line and column numbers
 * ----------------------------------
 * **Primary focus of the matching**
 * - at functionName (filename:lineNumber:columnNumber)
 * - at filename:lineNumber:columnNumber
 * - at functionName@filename:lineNumber:columnNumber
 * - functionName (filename:lineNumber:columnNumber)
 * - filename:lineNumber:columnNumber
 * - functionName@filename:lineNumber:columnNumber
 */
var FULL_STACK_FRAME_1 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+):([0-9\?]+)\)?$/;
/**
 * Parse a well formed stack frame with only a line number.
 * ----------------------------------
 * > Note: this WILL also match with line and column number, but the line number is included with the filename
 * > you should attempt to match with FULL_STACK_FRAME_1 first.
 *
 * **Primary focus of the matching (run FULL_STACK_FRAME_1 first)**
 * - at functionName (filename:lineNumber)
 * - at filename:lineNumber
 * - at functionName@filename:lineNumber
 * - functionName (filename:lineNumber)
 * - filename:lineNumber
 * - functionName@filename:lineNumber
 *
 * **Secondary matches**
 * - at functionName (filename:lineNumber:columnNumber)
 * - at filename:lineNumber:columnNumber
 * - at functionName@filename:lineNumber:columnNumber
 * - functionName (filename:lineNumber:columnNumber)
 * - filename:lineNumber:columnNumber
 * - functionName@filename:lineNumber:columnNumber
 */
var FULL_STACK_FRAME_2 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+)\)?$/;
/**
 * Attempt to Parse a frame that doesn't include a line or column number.
 * ----------------------------------
 * > Note: this WILL also match lines with a line or line and column number, you should attempt to match with
 * both FULL_STACK_FRAME_1 and FULL_STACK_FRAME_2 first to avoid false positives.
 *
 * **Unexpected Invalid Matches** (Matches that should be avoided -- by using the FULL_STACK_FRAME_1 and FULL_STACK_FRAME_2 first)
 * - at https://localhost:44365/static/node_bundles/@microsoft/blah/js/bundle.js:144112:27
 * - at https://localhost:44365/static/node_bundles/@microsoft/blah/js/bundle.js:144112:27
 *
 * **Primary focus of the matching (run FULL_STACK_FRAME_1 first)**
 * - at functionName@filename
 * - at functionName (filename)
 * - at functionName filename
 * - at filename  <- Will actuall match this as the "method" and not the filename (care should be taken to avoid this)
 * - functionName@filename
 * - functionName (filename)
 * - functionName filename
 * - functionName
 *
 * **Secondary matches** (The line and column numbers will be included with the matched filename)
 * - at functionName (filename:lineNumber:columnNumber)
 * - at functionName (filename:lineNumber)
 * - at filename:lineNumber:columnNumber
 * - at filename:lineNumber
 * - at functionName@filename:lineNumber:columnNumber
 * - at functionName@filename:lineNumber
 * - functionName (filename:lineNumber:columnNumber)
 * - functionName (filename:lineNumber)
 * - filename:lineNumber:columnNumber
 * - filename:lineNumber
 * - functionName@filename:lineNumber:columnNumber
 * - functionName@filename:lineNumber
  */
var FULL_STACK_FRAME_3 = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\)\]]+)\)?$/;
/**
 * Attempt to extract the filename (with or without line and column numbers) from a string.
 * ----------------------------------
 * > Note: this will only match the filename (with any line or column numbers) and will
 * > return what looks like the filename, however, it will also match random strings that
 * > look like a filename, so care should be taken to ensure that the filename is actually
 * > a filename before using it.
 * >
 * > It is recommended to use this in conjunction with the FULL_STACK_FRAME_1, FULL_STACK_FRAME_2, and FULL_STACK_FRAME_3
 * > to ensure first to reduce false matches, if all of these fail then you can use this to extract the filename from a random
 * > strings to identify any potential filename from a known stack frame line.
 *
 * **Known Invalid matching**
 *
 * This regex will basically match any "final" string of a line or one that is trailed by a comma, so this should not
 * be used as the "only" matching regex, but rather as a final fallback to extract the filename from a string.
 * If you are certain that the string line is a stack frame and not part of the exception message (lines before the stack)
 * or trailing comments, then you can use this to extract the filename and then further parse with PARSE_FILENAME_LINE_COL
 * and PARSE_FILENAME_LINE_ONLY to extract any potential the line and column numbers.
 *
 * **Primary focus of the matching**
 * - at (anonymous) @ VM60:1
 * - Line 21 of linked script file://localhost/C:/Temp/stacktrace.js
 * - Line 11 of inline#1 script in http://localhost:3000/static/js/main.206f4846.js:2:296748
 * - Line 68 of inline#2 script in file://localhost/teststack.html
 * - at Global code (http://example.com/stacktrace.js:11:1)
 */
var EXTRACT_FILENAME = /(?:^|\(|\s{0,10}[\w\)]+\@)?([^\(\n\s\]\)]+)(?:\:([0-9]+)(?:\:([0-9]+))?)?\)?(?:,|$)/;
/**
 * Attempt to extract the filename, line number, and column number from a string.
 */
var PARSE_FILENAME_LINE_COL = /([^\(\s\n]+):([0-9]+):([0-9]+)$/;
/**
 * Attempt to extract the filename and line number from a string.
 */
var PARSE_FILENAME_LINE_ONLY = /([^\(\s\n]+):([0-9]+)$/;
var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
var _parseSequence = [
    { re: FULL_STACK_FRAME_1, len: 5, m: 1, fn: 2, ln: 3, col: 4 },
    { chk: _ignoreNative, pre: _scrubAnonymous, re: FULL_STACK_FRAME_2, len: 4, m: 1, fn: 2, ln: 3 },
    { re: FULL_STACK_FRAME_3, len: 3, m: 1, fn: 2, hdl: _handleFilename },
    { re: EXTRACT_FILENAME, len: 2, fn: 1, hdl: _handleFilename }
];
function _scrubAnonymous(frame) {
    return frame[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](/(\(anonymous\))/, "<anonymous>");
}
function _ignoreNative(frame) {
    return ts_utils_strIndexOf(frame, "[native") < 0;
}
function _stringify(value, convertToString) {
    var result = value;
    if (result && !ts_utils_isString(result)) {
        if (JSON && JSON[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */]) {
            result = JSON[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](value);
            if (convertToString && (!result || result === "{}")) {
                if (ts_utils_isFunction(value[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */])) {
                    result = value[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !ts_utils_isString(evtMessage)) {
            evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
        }
        // Make sure the message is a string
        if (evtMessage && !ts_utils_isString(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && ts_utils_strIndexOf(evtMessage || "", errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    try {
        if (ts_utils_isObject(value)) {
            return "hasFullStack" in value && "typeName" in value;
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isExceptionInternal(value) {
    try {
        if (ts_utils_isObject(value)) {
            return ("ver" in value && "exceptions" in value && "properties" in value);
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && ts_utils_isString(details.src) && details.obj && ts_utils_isArray(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!ts_utils_isString(src)) {
        if (ts_utils_isString(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src[_DYN_SPLIT /* @min:%2esplit */]("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[_DYN_SPLIT /* @min:%2esplit */]("\n");
    for (var lp = 0; lp < lines[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack[_DynamicConstants_DYN_PUSH /* @min:%2epush */](entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj["exception"] && errorObj[_DYN_EXCEPTION /* @min:%2eexception */][strStack]) {
                details = _convertStackObj(errorObj[_DYN_EXCEPTION /* @min:%2eexception */][strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (getWindow() && getWindow()["opera"] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj[_DYN_MESSAGE /* @min:%2emessage */]);
            }
            else if (errorObj["reason"] && errorObj[_DYN_REASON /* @min:%2ereason */][strStack]) {
                // UnhandledPromiseRejection
                details = _convertStackObj(errorObj[_DYN_REASON /* @min:%2ereason */][strStack]);
            }
            else if (ts_utils_isString(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (ts_utils_isString(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            stack = stackDetails.obj[_DYN_JOIN /* @min:%2ejoin */]("\n");
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var foundStackStart_1 = false;
        var totalSizeInBytes_1 = 0;
        ts_utils_arrForEach(frames, function (frame) {
            if (foundStackStart_1 || _isStackFrame(frame)) {
                var theFrame = ts_utils_asString(frame);
                // Once we have found the first stack frame we treat the rest of the lines as part of the stack
                foundStackStart_1 = true;
                var parsedFrame = _extractStackFrame(theFrame, level_1);
                if (parsedFrame) {
                    totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                    parsedStack[_DynamicConstants_DYN_PUSH /* @min:%2epush */](parsedFrame);
                    level_1++;
                }
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack[_DYN_SPLICE /* @min:%2esplice */](acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[_DynamicConstants_DYN_NAME /* @min:%2ename */] || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,200})\(/;
                var results = (funcNameRegex).exec((errorType).constructor[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]());
                typeName = (results && results[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 1) ? results[1] : "";
            }
            catch (e) {
                // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj - The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!ts_utils_isString(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (ts_utils_strIndexOf(result, errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function () {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            exceptions: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            if (id) {
                properties.id = id;
            }
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = [_createExceptionDetails(logger, exception, properties)];
            _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
            if (severityLevel) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
            }
            if (id) {
                _self.id = id;
            }
        }
        else {
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */] || [];
            _self[_DYN_PROPERTIES /* @min:%2eproperties */] = exception[_DYN_PROPERTIES /* @min:%2eproperties */];
            _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = exception[_DYN_MEASUREMENTS /* @min:%2emeasurements */];
            if (exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */]) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */];
            }
            if (exception.id) {
                _self.id = exception.id;
                exception[_DYN_PROPERTIES /* @min:%2eproperties */].id = exception.id;
            }
            if (exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */]) {
                _self[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */] = exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */];
            }
            // bool/int types, use isNullOrUndefined
            if (!ts_utils_isNullOrUndefined(exception.isManual)) {
                _self.isManual = exception.isManual;
            }
        }
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = _getErrorType(error || evt || message);
        return {
            message: _formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: _formatErrorCode(error || evt || message),
            evt: _formatErrorCode(evt || message),
            typeName: errorType,
            stackDetails: _getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */]
            && arrMap(exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */], function (ex) { return _createExDetailsFromInterface(logger, ex); });
        var exceptionData = new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && arrMap(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {},
                    _a[_DYN_HAS_FULL_STACK /* @min:hasFullStack */] = true,
                    _a.message = message,
                    _a.stack = details,
                    _a.typeName = typeName,
                    _a)
            ]
        };
    };
    /**
     * @deprecated Use the constant ExceptionEnvelopeType instead.
     */
    Exception.envelopeType = ExceptionEnvelopeType;
    /**
     * @deprecated Use the constant ExceptionDataType instead.
     */
    Exception.dataType = ExceptionDataType;
    Exception.formatError = _formatErrorCode;
    return Exception;
}());

var exDetailsAiDataContract = ( /*#__PURE__*/objFreeze({
    id: 0 /* FieldType.Default */,
    outerId: 0 /* FieldType.Default */,
    typeName: 1 /* FieldType.Required */,
    message: 1 /* FieldType.Required */,
    hasFullStack: 0 /* FieldType.Default */,
    stack: 0 /* FieldType.Default */,
    parsedStack: 2 /* FieldType.Array */
}));
function _toInterface() {
    var _self = this;
    var parsedStack = ts_utils_isArray(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */])
        && arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return _parsedFrameToInterface(frame); });
    var exceptionDetailsInterface = {
        id: _self.id,
        outerId: _self.outerId,
        typeName: _self[_DYN_TYPE_NAME /* @min:%2etypeName */],
        message: _self[_DYN_MESSAGE /* @min:%2emessage */],
        hasFullStack: _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */],
        stack: _self[strStack],
        parsedStack: parsedStack || undefined
    };
    return exceptionDetailsInterface;
}
function _createExceptionDetails(logger, exception, properties) {
    var _a;
    var id;
    var outerId;
    var typeName;
    var message;
    var hasFullStack;
    var theStack;
    var parsedStack;
    if (!_isExceptionDetailsInternal(exception)) {
        var error = exception;
        var evt = error && error.evt;
        if (!ts_utils_isError(error)) {
            error = error[strError] || evt || error;
        }
        typeName = DataSanitizer_dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
        message = dataSanitizeMessage(logger, _formatMessage(exception || error, typeName)) || strNotSpecified;
        var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
        parsedStack = _parseStack(stack);
        // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
        if (ts_utils_isArray(parsedStack)) {
            arrMap(parsedStack, function (frame) {
                frame[_DYN_ASSEMBLY /* @min:%2eassembly */] = DataSanitizer_dataSanitizeString(logger, frame[_DYN_ASSEMBLY /* @min:%2eassembly */]);
                frame[_DYN_FILE_NAME /* @min:%2efileName */] = DataSanitizer_dataSanitizeString(logger, frame[_DYN_FILE_NAME /* @min:%2efileName */]);
            });
        }
        theStack = dataSanitizeException(logger, _formatStackTrace(stack));
        hasFullStack = ts_utils_isArray(parsedStack) && parsedStack[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0;
        if (properties) {
            properties[_DYN_TYPE_NAME /* @min:%2etypeName */] = properties[_DYN_TYPE_NAME /* @min:%2etypeName */] || typeName;
        }
    }
    else {
        typeName = exception[_DYN_TYPE_NAME /* @min:%2etypeName */];
        message = exception[_DYN_MESSAGE /* @min:%2emessage */];
        theStack = exception[strStack];
        parsedStack = exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] || [];
        hasFullStack = exception[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */];
    }
    return _a = {},
        _a[_DYN_AI_DATA_CONTRACT /* @min:aiDataContract */] = exDetailsAiDataContract,
        _a.id = id,
        _a.outerId = outerId,
        _a.typeName = typeName,
        _a.message = message,
        _a[_DYN_HAS_FULL_STACK /* @min:hasFullStack */] = hasFullStack,
        _a.stack = theStack,
        _a.parsedStack = parsedStack,
        _a.toInterface = _toInterface,
        _a;
}
function _createExDetailsFromInterface(logger, exception) {
    var parsedStack = (ts_utils_isArray(exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */])
        && arrMap(exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return _stackFrameFromInterface(frame); }))
        || exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */];
    var exceptionDetails = _createExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack: parsedStack }));
    return exceptionDetails;
}
function _parseFilename(theFrame, fileName) {
    var lineCol = fileName[_DYN_MATCH /* @min:%2ematch */](PARSE_FILENAME_LINE_COL);
    if (lineCol && lineCol[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= 4) {
        theFrame[_DYN_FILE_NAME /* @min:%2efileName */] = lineCol[1];
        theFrame[_DYN_LINE /* @min:%2eline */] = parseInt(lineCol[2]);
    }
    else {
        var lineNo = fileName[_DYN_MATCH /* @min:%2ematch */](PARSE_FILENAME_LINE_ONLY);
        if (lineNo && lineNo[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= 3) {
            theFrame[_DYN_FILE_NAME /* @min:%2efileName */] = lineNo[1];
            theFrame[_DYN_LINE /* @min:%2eline */] = parseInt(lineNo[2]);
        }
        else {
            theFrame[_DYN_FILE_NAME /* @min:%2efileName */] = fileName;
        }
    }
}
function _handleFilename(theFrame, sequence, matches) {
    var filename = theFrame[_DYN_FILE_NAME /* @min:%2efileName */];
    if (sequence.fn && matches && matches[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > sequence.fn) {
        if (sequence.ln && matches[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > sequence.ln) {
            filename = strTrim(matches[sequence.fn] || "");
            theFrame[_DYN_LINE /* @min:%2eline */] = parseInt(strTrim(matches[sequence.ln] || "")) || 0;
        }
        else {
            filename = strTrim(matches[sequence.fn] || "");
        }
    }
    if (filename) {
        _parseFilename(theFrame, filename);
    }
}
function _isStackFrame(frame) {
    var result = false;
    if (frame && ts_utils_isString(frame)) {
        var trimmedFrame = strTrim(frame);
        if (trimmedFrame) {
            result = IS_FRAME.test(trimmedFrame);
        }
    }
    return result;
}
var stackFrameAiDataContract = ( /*#__PURE__*/objFreeze({
    level: 1 /* FieldType.Required */,
    method: 1 /* FieldType.Required */,
    assembly: 0 /* FieldType.Default */,
    fileName: 0 /* FieldType.Default */,
    line: 0 /* FieldType.Default */
}));
function _extractStackFrame(frame, level) {
    var _a;
    var theFrame;
    if (frame && ts_utils_isString(frame) && strTrim(frame)) {
        theFrame = (_a = {},
            _a[_DYN_AI_DATA_CONTRACT /* @min:aiDataContract */] = stackFrameAiDataContract,
            _a.level = level,
            _a.assembly = strTrim(frame),
            _a.method = NoMethod,
            _a.fileName = "",
            _a.line = 0,
            _a.sizeInBytes = 0,
            _a);
        var idx = 0;
        while (idx < _parseSequence[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
            var sequence = _parseSequence[idx];
            if (sequence.chk && !sequence.chk(frame)) {
                break;
            }
            if (sequence.pre) {
                frame = sequence.pre(frame);
            }
            // Attempt to "parse" the stack frame
            var matches = frame[_DYN_MATCH /* @min:%2ematch */](sequence.re);
            if (matches && matches[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= sequence.len) {
                if (sequence.m) {
                    theFrame.method = strTrim(matches[sequence.m] || NoMethod);
                }
                if (sequence.hdl) {
                    // Run any custom handler
                    sequence.hdl(theFrame, sequence, matches);
                }
                else if (sequence.fn) {
                    if (sequence.ln) {
                        theFrame[_DYN_FILE_NAME /* @min:%2efileName */] = strTrim(matches[sequence.fn] || "");
                        theFrame[_DYN_LINE /* @min:%2eline */] = parseInt(strTrim(matches[sequence.ln] || "")) || 0;
                    }
                    else {
                        _parseFilename(theFrame, matches[sequence.fn] || "");
                    }
                }
                // We found a match so stop looking
                break;
            }
            idx++;
        }
    }
    return _populateFrameSizeInBytes(theFrame);
}
function _stackFrameFromInterface(frame) {
    var _a;
    var parsedFrame = (_a = {},
        _a[_DYN_AI_DATA_CONTRACT /* @min:aiDataContract */] = stackFrameAiDataContract,
        _a.level = frame.level,
        _a.method = frame.method,
        _a.assembly = frame[_DYN_ASSEMBLY /* @min:%2eassembly */],
        _a.fileName = frame[_DYN_FILE_NAME /* @min:%2efileName */],
        _a.line = frame[_DYN_LINE /* @min:%2eline */],
        _a.sizeInBytes = 0,
        _a);
    return _populateFrameSizeInBytes(parsedFrame);
}
function _populateFrameSizeInBytes(frame) {
    var sizeInBytes = STACKFRAME_BASE_SIZE;
    if (frame) {
        sizeInBytes += frame.method[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        sizeInBytes += frame.assembly[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        sizeInBytes += frame.fileName[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        sizeInBytes += frame.level.toString()[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        sizeInBytes += frame.line.toString()[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
        frame[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = sizeInBytes;
    }
    return frame;
}
function _parsedFrameToInterface(frame) {
    return {
        level: frame.level,
        method: frame.method,
        assembly: frame[_DYN_ASSEMBLY /* @min:%2eassembly */],
        fileName: frame[_DYN_FILE_NAME /* @min:%2efileName */],
        line: frame[_DYN_LINE /* @min:%2eline */]
    };
}
//# sourceMappingURL=Exception.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/CoreUtils.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








// Added to help with minfication
var Undefined = (/* unused pure expression or super */ null && (strShimUndefined));
function newGuid() {
    var uuid = generateW3CId();
    return strSubstring(uuid, 0, 8) + "-" + strSubstring(uuid, 8, 12) + "-" + strSubstring(uuid, 12, 16) + "-" + strSubstring(uuid, 16, 20) + "-" + strSubstring(uuid, 20);
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function CoreUtils_strEndsWith(value, search) {
    if (value && search) {
        var len = value[_DYN_LENGTH /* @min:%2elength */];
        var start = len - search[_DYN_LENGTH /* @min:%2elength */];
        return strSubstring(value, start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = InternalConstants_STR_EMPTY, tmp;
    for (var a = 0; a < 4; a++) {
        tmp = random32();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
    return strSubstr(oct, 0, 8) + strSubstr(oct, 9, 4) + "4" + strSubstr(oct, 13, 3) + clockSequenceHi + strSubstr(oct, 16, 3) + strSubstr(oct, 19, 12);
}
//# sourceMappingURL=CoreUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/TraceParent.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var TraceParent_INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
var SAMPLED_FLAG = 0x01;
function _isValid(value, len, invalidValue) {
    if (value && value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === len && value !== invalidValue) {
        return !!value.match(/^[\da-f]*$/i);
    }
    return false;
}
function _formatValue(value, len, defValue) {
    if (_isValid(value, len)) {
        return value;
    }
    return defValue;
}
function _formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) {
        value = 0x01;
    }
    var result = value[_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */](16);
    while (result[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < 2) {
        result = "0" + result;
    }
    return result;
}
/**
 * Create a new ITraceParent instance using the provided values.
 * @param traceId - The traceId to use, when invalid a new random W3C id will be generated.
 * @param spanId - The parent/span id to use, a new random value will be generated if it is invalid.
 * @param flags - The traceFlags to use, defaults to zero (0) if not supplied or invalid
 * @param version - The version to used, defaults to version "01" if not supplied or invalid.
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function createTraceParent(traceId, spanId, flags, version) {
    return {
        version: _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
        traceId: isValidTraceId(traceId) ? traceId : generateW3CId(),
        spanId: isValidSpanId(spanId) ? spanId : ts_utils_strLeft(generateW3CId(), 16),
        traceFlags: (!ts_utils_isNullOrUndefined(flags) && flags >= 0 && flags <= 0xFF ? flags : 1 /* eW3CTraceFlags.Sampled */)
    };
}
/**
 * Attempt to parse the provided string as a W3C TraceParent header value (https://www.w3.org/TR/trace-context/#traceparent-header)
 *
 * @param value - The value to be parsed
 * @param selectIdx - If the found value is comma separated which is the preferred entry to select, defaults to the first
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function parseTraceParent(value, selectIdx) {
    if (!value) {
        // Don't pass a null/undefined or empty string
        return null;
    }
    if (ts_utils_isArray(value)) {
        // The value may have been encoded on the page into an array so handle this automatically
        value = value[0] || InternalConstants_STR_EMPTY;
    }
    if (!value || !ts_utils_isString(value) || value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 8192) {
        // limit potential processing based on total length
        return null;
    }
    if (ts_utils_strIndexOf(value, ",") !== -1) {
        var values = value[_DYN_SPLIT /* @min:%2esplit */](",");
        value = values[selectIdx > 0 && values[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > selectIdx ? selectIdx : 0];
    }
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    TRACE_PARENT_REGEX.lastIndex = 0;
    var match = TRACE_PARENT_REGEX.exec(strTrim(value));
    if (!match || // No match
        match[1] === INVALID_VERSION || // version ff is forbidden
        match[2] === TraceParent_INVALID_TRACE_ID || // All zeros is considered to be invalid
        match[3] === INVALID_SPAN_ID) { // All zeros is considered to be invalid
        return null;
    }
    return {
        version: (match[1] || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](),
        traceId: (match[2] || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](),
        spanId: (match[3] || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](),
        traceFlags: parseInt(match[4], 16)
    };
}
/**
 * Is the provided W3c Trace Id a valid string representation, it must be a 32-character string
 * of lowercase hexadecimal characters for example, 4bf92f3577b34da6a3ce929d0e0e4736.
 * If all characters as zero (00000000000000000000000000000000) it will be considered an invalid value.
 * @param value - The W3c trace Id to be validated
 * @returns true if valid otherwise false
 */
/*#__NO_SIDE_EFFECTS__*/
function isValidTraceId(value) {
    return _isValid(value, 32, TraceParent_INVALID_TRACE_ID);
}
/**
 * Is the provided W3c span id (aka. parent id) a valid string representation, it must be a 16-character
 * string of lowercase hexadecimal characters, for example, 00f067aa0ba902b7.
 * If all characters are zero (0000000000000000) this is considered an invalid value.
 * @param value - The W3c span id to be validated
 * @returns true if valid otherwise false
 */
/*#__NO_SIDE_EFFECTS__*/
function isValidSpanId(value) {
    return _isValid(value, 16, INVALID_SPAN_ID);
}
/**
 * Validates that the provided ITraceParent instance conforms to the currently supported specifications
 * @param value - The parsed traceParent value
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function isValidTraceParent(value) {
    if (!value ||
        !_isValid(value[STR_VERSION /* @min:%2eversion */], 2, INVALID_VERSION) ||
        !_isValid(value[_DYN_TRACE_ID /* @min:%2etraceId */], 32, TraceParent_INVALID_TRACE_ID) ||
        !_isValid(value[_DYN_SPAN_ID /* @min:%2espanId */], 16, INVALID_SPAN_ID) ||
        !_isValid(_formatFlags(value[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]), 2)) {
        // Each known field must contain a valid value
        return false;
    }
    return true;
}
/**
 * Is the parsed traceParent indicating that the trace is currently sampled.
 * @param value - The parsed traceParent value
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function isSampledFlag(value) {
    if (isValidTraceParent(value)) {
        return (value[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] & SAMPLED_FLAG) === SAMPLED_FLAG;
    }
    return false;
}
/**
 * Format the ITraceParent value as a string using the supported and know version formats.
 * So even if the passed traceParent is a later version the string value returned from this
 * function will convert it to only the known version formats.
 * This currently only supports version "00" and invalid "ff"
 * @param value - The parsed traceParent value
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function formatTraceParent(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = _formatFlags(value[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]);
        if (!_isValid(flags, 2)) {
            flags = "01";
        }
        var version = value[InternalConstants_STR_VERSION /* @min:%2eversion */] || DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") {
            // Reduce version to "00"
            version = DEFAULT_VERSION;
        }
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, TraceParent_INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return InternalConstants_STR_EMPTY;
}
/**
 * Helper function to fetch the passed traceparent from the page, looking for it as a meta-tag or a Server-Timing header.
 * @param selectIdx - If the found value is comma separated which is the preferred entry to select, defaults to the first
 * @returns
 */
function findW3cTraceParent(selectIdx) {
    var name = "traceparent";
    var traceParent = parseTraceParent(findMetaTag(name), selectIdx);
    if (!traceParent) {
        traceParent = parseTraceParent(findNamedServerTiming(name), selectIdx);
    }
    return traceParent;
}
/**
 * Find all script tags in the provided document and return the information about them.
 * @param doc - The document to search for script tags
 * @returns
 */
function findAllScripts(doc) {
    var scripts = doc.getElementsByTagName("script");
    var result = [];
    ts_utils_arrForEach(scripts, function (script) {
        var src = script[_DYN_GET_ATTRIBUTE /* @min:%2egetAttribute */]("src");
        if (src) {
            var crossOrigin = script[_DYN_GET_ATTRIBUTE /* @min:%2egetAttribute */]("crossorigin");
            var async = script.hasAttribute("async") === true;
            var defer = script.hasAttribute("defer") === true;
            var referrerPolicy = script[_DYN_GET_ATTRIBUTE /* @min:%2egetAttribute */]("referrerpolicy");
            var info = { url: src };
            if (crossOrigin) {
                info.crossOrigin = crossOrigin;
            }
            if (async) {
                info.async = async;
            }
            if (defer) {
                info.defer = defer;
            }
            if (referrerPolicy) {
                info.referrerPolicy = referrerPolicy;
            }
            result[_DynamicConstants_DYN_PUSH /* @min:%2epush */](info);
        }
    });
    return result;
}
//# sourceMappingURL=TraceParent.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/internal/EventHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strPageShow = "pageshow";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var _strPageHideNamespace;
var _strPageShowNamespace;
/*#__NO_SIDE_EFFECTS__*/
function _getPageHideNamespace() {
    // Note: Using a cached value instead of a lazy value as we want to ensure that the namespace is consistent
    // across multiple calls as the `getLazy()` supports runtime invalidation via `setBypassLazyCache()` which would
    // result in different namespaces being returned.
    !_strPageHideNamespace && (_strPageHideNamespace = ts_utils_createCachedValue(DataCacheHelper_createUniqueNamespace("aiEvtPageHide")));
    return _strPageHideNamespace.v;
}
/*#__NO_SIDE_EFFECTS__*/
function _getPageShowNamespace() {
    // Note: Using a cached value instead of a lazy value as we want to ensure that the namespace is consistent
    // across multiple calls as the `getLazy()` supports runtime invalidation via `setBypassLazyCache()` which would
    // result in different namespaces being returned.
    !_strPageShowNamespace && (_strPageShowNamespace = createCachedValue(createUniqueNamespace("aiEvtPageShow")));
    return _strPageShowNamespace.v;
}
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var _elmNodeData;
/*#__NO_SIDE_EFFECTS__*/
function _getElmNodeData() {
    // Note: Using a cached value instead of a lazy value as we want to ensure that the namespace is consistent
    // across multiple calls as the `getLazy()` supports runtime invalidation via `setBypassLazyCache()` which would
    // result in different namespaces being returned.
    !_elmNodeData && (_elmNodeData = ts_utils_createCachedValue(createElmNodeData("events")));
    return _elmNodeData.v;
}
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
/*#__NO_SIDE_EFFECTS__*/
function _normalizeNamespace(name) {
    if (name && name[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */]) {
        return name[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, InternalConstants_STR_EMPTY);
    }
    return name;
}
/*#__NO_SIDE_EFFECTS__*/
function _getEvtNamespace(eventName, evtNamespace) {
    if (evtNamespace) {
        var theNamespace_1 = InternalConstants_STR_EMPTY;
        if (ts_utils_isArray(evtNamespace)) {
            theNamespace_1 = InternalConstants_STR_EMPTY;
            ts_utils_arrForEach(evtNamespace, function (name) {
                name = _normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") {
                        name = "." + name;
                    }
                    theNamespace_1 += name;
                }
            });
        }
        else {
            theNamespace_1 = _normalizeNamespace(evtNamespace);
        }
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") {
                theNamespace_1 = "." + theNamespace_1;
            }
            // We may only have the namespace and not an eventName
            eventName = (eventName || InternalConstants_STR_EMPTY) + theNamespace_1;
        }
    }
    var parsedEvent = (eventNamespace.exec(eventName || InternalConstants_STR_EMPTY) || []);
    return {
        type: parsedEvent[1],
        ns: ((parsedEvent[2] || InternalConstants_STR_EMPTY).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, InternalConstants_STR_EMPTY).split(".").sort())[_DYN_JOIN /* @min:%2ejoin */](".")
    };
}
/**
 * Get all of the registered events on the target object, this is primarily used for testing cleanup but may also be used by
 * applications to remove their own events
 * @param target - The EventTarget that has registered events
 * @param eventName - [Optional] The name of the event to return the registered handlers and full name (with namespaces)
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 */
/*#__NO_SIDE_EFFECTS__*/
function __getRegisteredEvents(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = _getElmNodeData().get(target, strEvents, {}, false);
    var evtName = _getEvtNamespace(eventName, evtNamespace);
    objForEachKey(eventCache, function (evtType, registeredEvents) {
        arrForEach(registeredEvents, function (value) {
            if (!evtName[_DYN_TYPE /* @min:%2etype */] || evtName[_DYN_TYPE /* @min:%2etype */] === value[_DYN_EVT_NAME /* @min:%2eevtName */][_DYN_TYPE /* @min:%2etype */]) {
                if (!evtName.ns || evtName.ns === evtName.ns) {
                    theEvents[_DYN_PUSH /* @min:%2epush */]({
                        name: value.evtName[_DYN_TYPE /* @min:%2etype */] + (value[_DYN_EVT_NAME /* @min:%2eevtName */].ns ? "." + value[_DYN_EVT_NAME /* @min:%2eevtName */].ns : STR_EMPTY),
                        handler: value[_DYN_HANDLER /* @min:%2ehandler */]
                    });
                }
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
/*#__NO_SIDE_EFFECTS__*/
function _getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) { addDefault = true; }
    var aiEvts = _getElmNodeData().get(target, strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) {
        registeredEvents = aiEvts[evtName] = [];
    }
    return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */]) {
        if (obj[strRemoveEventListener]) {
            obj[strRemoveEventListener](evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
        }
        else if (obj[strDetachEvent]) {
            obj[strDetachEvent](strOnPrefix + evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef);
        }
    }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */] && handlerRef) {
        if (obj[strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[strAddEventHelper](evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
            result = true;
        }
        else if (obj[strAttachEvent]) {
            // IE before version 9
            obj[strAttachEvent](strOnPrefix + evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */], handlerRef);
            result = true;
        }
    }
    return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
    var idx = events[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    while (idx--) {
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent[_DynamicConstants_DYN_EVT_NAME /* @min:%2eevtName */].ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    _doDetach(target, theEvent.evtName, theEvent[_DynamicConstants_DYN_HANDLER /* @min:%2ehandler */], theEvent.capture);
                    // Remove the registered event
                    events[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                }
            }
        }
    }
}
function _unregisterEvents(target, evtName, unRegFn) {
    if (evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */]) {
        _doUnregister(target, _getRegisteredEvents(target, evtName[_DynamicConstants_DYN_TYPE /* @min:%2etype */]), evtName, unRegFn);
    }
    else {
        var eventCache = _getElmNodeData().get(target, strEvents, {});
        ts_utils_objForEachKey(eventCache, function (evtType, events) {
            _doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if (objKeys(eventCache)[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
            _getElmNodeData().kill(target, strEvents);
        }
    }
}
/*#__NO_SIDE_EFFECTS__*/
function mergeEvtNamespace(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if (ts_utils_isArray(namespaces)) {
            newNamespaces = [theNamespace][_DYN_CONCAT /* @min:%2econcat */](namespaces);
        }
        else {
            newNamespaces = [theNamespace, namespaces];
        }
        // resort the namespaces so they are always in order
        newNamespaces = (_getEvtNamespace("xx", newNamespaces).ns)[_DYN_SPLIT /* @min:%2esplit */](".");
    }
    else {
        newNamespaces = theNamespace;
    }
    return newNamespaces;
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj - Object to add the event too.
 * @param eventName - String that specifies any of the standard DHTML Events without "on" prefix, if may also include an optional (dot "." prefixed)
 * namespaces "click" "click.mynamespace" in addition to specific namespaces.
 * @param handlerRef - Pointer that specifies the function to call when event fires
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (target) {
        try {
            var evtName = _getEvtNamespace(eventName, evtNamespace);
            result = _doAttach(target, evtName, handlerRef, useCapture);
            if (result && _getElmNodeData().accept(target)) {
                var registeredEvent = {
                    guid: _guid++,
                    evtName: evtName,
                    handler: handlerRef,
                    capture: useCapture
                };
                _getRegisteredEvents(target, evtName.type)[_DynamicConstants_DYN_PUSH /* @min:%2epush */](registeredEvent);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object - to remove the event from
 * @param eventName - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 */
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (target) {
        try {
            var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
            var found_1 = false;
            _unregisterEvents(target, evtName_1, function (regEvent) {
                if ((evtName_1.ns && !handlerRef) || regEvent[_DynamicConstants_DYN_HANDLER /* @min:%2ehandler */] === handlerRef) {
                    found_1 = true;
                    return true;
                }
                return false;
            });
            if (!found_1) {
                // fallback to try and remove as requested
                _doDetach(target, evtName_1, handlerRef, useCapture);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj - Object to add the event too.
 * @param eventNameWithoutOn - String that specifies any of the standard DHTML Events without "on" prefix and optional (dot "." prefixed) namespaces "click" "click.mynamespace".
 * @param handlerRef - Pointer that specifies the function to call when event fires
 * @param useCapture - [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    return eventOn(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
/**
 * Removes an event handler for the specified event
 * @param Object - to remove the event from
 * @param eventNameWithoutOn  - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param useCapture - [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    eventOff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName  - The name of the event
 * @param callback  - The callback function that needs to be executed for the given event
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns - true if the handler was successfully added
 */
function addEventHandler(eventName, callback, evtNamespace) {
    var result = false;
    var w = getWindow();
    if (w) {
        result = eventOn(w, eventName, callback, evtNamespace);
        result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = ts_utils_getDocument();
    if (doc) {
        result = eventOn(doc, eventName, callback, evtNamespace) || result;
    }
    return result;
}
/**
 * Trys to remove event handler(s) for the specified event/namespace to the window, body and document
 * @param eventName - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param callback - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventHandler(eventName, callback, evtNamespace) {
    var w = getWindow();
    if (w) {
        eventOff(w, eventName, callback, evtNamespace);
        eventOff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = ts_utils_getDocument();
    if (doc) {
        eventOff(doc, eventName, callback, evtNamespace);
    }
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        ts_utils_arrForEach(events, function (name) {
            if (name) {
                if (!excludeEvents || ts_utils_arrIndexOf(excludeEvents, name) === -1) {
                    added = addEventHandler(name, listener, evtNamespace) || added;
                }
            }
        });
    }
    return added;
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && ts_utils_isArray(events)) {
        added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
            added = _addEventListeners(events, listener, null, evtNamespace);
        }
    }
    return added;
}
/**
 * Remove the listener from the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventListeners(events, listener, evtNamespace) {
    if (events && ts_utils_isArray(events)) {
        ts_utils_arrForEach(events, function (name) {
            if (name) {
                removeEventHandler(name, listener, evtNamespace);
            }
        });
    }
}
/**
 * Listen to the 'beforeunload', 'unload' and 'pagehide' events which indicates a page unload is occurring,
 * this does NOT listen to the 'visibilitychange' event as while it does indicate that the page is being hidden
 * it does not *necessarily* mean that the page is being completely unloaded, it can mean that the user is
 * just navigating to a different Tab and may come back (without unloading the page). As such you may also
 * need to listen to the 'addPageHideEventListener' and 'addPageShowEventListener' events.
 * @param listener - The event callback to call when a page unload event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked, unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
/**
 * Remove any matching 'beforeunload', 'unload' and 'pagehide' events that may have been added via addEventListener,
 * addEventListeners, addPageUnloadEventListener or addPageHideEventListener.
 * @param listener - The specific event callback to to be removed
 * @param evtNamespace - [Optional] Namespace(s) uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function removePageUnloadEventListener(listener, evtNamespace) {
    removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
/**
 * Listen to the pagehide and visibility changing to 'hidden' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page hide event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] A Namespace to append to the event listeners so they can be uniquely identified and removed
 * based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageHideEventListener" can remove these events.
 * Suggestion: pass as true if you are also calling addPageUnloadEventListener as that also hooks pagehide
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = ts_utils_getDocument();
        if (listener && doc && doc.visibilityState === "hidden") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(_getPageHideNamespace(), evtNamespace);
    var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || ts_utils_arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
        pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    }
    if (!pageUnloadAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
    }
    return pageUnloadAdded;
}
/**
 * Removes the pageHide event listeners added by addPageHideEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageHideEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageHideEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(_getPageHideNamespace(), evtNamespace);
    removeEventListeners([strPageHide], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}
/**
 * Listen to the pageshow and visibility changing to 'visible' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page is show event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional/Recommended] A Namespace to append to the event listeners so they can be uniquely
 * identified and removed based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageShowEventListener" can remove these events.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageShowEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = getDocument();
        if (listener && doc && doc.visibilityState === "visible") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = mergeEvtNamespace(_getPageShowNamespace(), evtNamespace);
    var pageShowAdded = _addEventListeners([strPageShow], listener, excludeEvents, newNamespaces);
    pageShowAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageShowAdded = addPageShowEventListener(listener, null, evtNamespace);
    }
    return pageShowAdded;
}
/**
 * Removes the pageShow event listeners added by addPageShowEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageShowEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageShowEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = mergeEvtNamespace(_getPageShowNamespace(), evtNamespace);
    removeEventListeners([strPageShow], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}
//# sourceMappingURL=EventHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/internal/noopHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * A simple function that does nothing and returns the current this (if any).
 * @returns
 */
function _noopThis() {
    return this;
}
/**
 * A simple function that does nothing and returns undefined.
 */
function _noopVoid() {
}
//# sourceMappingURL=noopHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/PerfManager.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        _self.start = ts_utils_utcNow();
        _self[_DynamicConstants_DYN_NAME /* @min:%2ename */] = name;
        _self.isAsync = isAsync;
        _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () { return false; };
        if (ts_utils_isFunction(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            ts_utils_objDefine(_self, "payload", {
                g: function () {
                    // Delay the execution of the payloadDetails until needed
                    if (!theDetails_1 && ts_utils_isFunction(payloadDetails)) {
                        theDetails_1 = payloadDetails();
                        // clear it out now so the referenced objects can be garbage collected
                        payloadDetails = null;
                    }
                    return theDetails_1;
                }
            });
        }
        _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */] = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent[strChildrenContextKey]) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function () {
            var childTime = 0;
            var childEvts = _self[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
            if (ts_utils_isArray(childEvts)) {
                for (var lp = 0; lp < childEvts[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt[_DYN_TIME /* @min:%2etime */];
                    }
                }
            }
            _self[_DYN_TIME /* @min:%2etime */] = ts_utils_utcNow() - _self.start;
            _self.exTime = _self[_DYN_TIME /* @min:%2etime */] - childTime;
            _self.complete = _noopVoid;
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        dynamicProto(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager && ts_utils_isFunction(manager[STR_PERF_EVENT /* @min:%2eperfEvent */])) {
                        manager[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                    }
                }
            };
            _self[_DYN_SET_CTX /* @min:%2esetCtx */] = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[_DYN_GET_CTX /* @min:%2egetCtx */] = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfManager.__ieDyn=1;

    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[STR_GET_PERF_MGR]) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr[STR_GET_PERF_MGR]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[_DYN_GET_CTX /* @min:%2egetCtx */](doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                        perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strParentContextKey], currentActive);
                        if (currentActive[_DYN_GET_CTX /* @min:%2egetCtx */] && currentActive[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                            var children = currentActive[_DYN_GET_CTX /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[_DYN_SET_CTX /* @min:%2esetCtx */](PerfEvent[strChildrenContextKey], children);
                            }
                            children[_DynamicConstants_DYN_PUSH /* @min:%2epush */](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]) {
                    perfEvt[_DYN_SET_CTX /* @min:%2esetCtx */]("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr[_DYN_SET_CTX /* @min:%2esetCtx */](doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
/**
 * Set the global performance manager to use when there is no core instance or it has not been initialized yet.
 * @param perfManager - The IPerfManager instance to use when no performance manager is supplied.
 */
function setGblPerfMgr(perfManager) {
    _defaultPerfManager = perfManager;
}
/**
 * Get the current global performance manager that will be used with no performance manager is supplied.
 * @returns - The current default manager
 */
function getGblPerfMgr() {
    return _defaultPerfManager;
}
//# sourceMappingURL=PerfManager.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/W3cTraceState.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var MAX_TRACE_STATE_MEMBERS = 32;
var MAX_TRACE_STATE_LEN = 512;
// https://www.w3.org/TR/trace-context-1/#key
var LCALPHA = "[a-z]";
var LCALPHA_DIGIT = "[a-z\\d]";
var LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH = "[a-z\\d_\\-*\\/]";
var SIMPLE_KEY = "(" + LCALPHA + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,255})";
var TENANT_ID = "(" + LCALPHA_DIGIT + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,240})";
var SYSTEM_ID = "(" + LCALPHA + LCALPHA_DIGIT_UNDERSCORE_DASH_STAR_SLASH + "{0,13})";
var MULTI_TENANT_KEY = "(" + TENANT_ID + "@" + SYSTEM_ID + ")";
// https://www.w3.org/TR/trace-context-1/#value
var NBLK_CHAR = "\x21-\x2B\\--\x3C\x3E-\x7E";
var TRACESTATE_VALUE = "[\x20" + NBLK_CHAR + "]{0,255}[" + NBLK_CHAR + "]";
// https://www.w3.org/TR/trace-context-1/#tracestate-header
var TRACESTATE_KVP_REGEX = ( /*#__PURE__*/new RegExp("^\\s*((?:" + SIMPLE_KEY + "|" + MULTI_TENANT_KEY + ")=(" + TRACESTATE_VALUE + "))\\s*$"));
/**
 * @internal
 * Parse a trace state key/value pair
 * @param value - the key/value pair as a string
 * @returns The trace state member if valid, otherwise null
 */
function _parseListMember(value) {
    if (value) {
        TRACESTATE_KVP_REGEX.lastIndex = 0; // Reset the regex to ensure we start from the beginning
        var match = TRACESTATE_KVP_REGEX.exec(value);
        if (match && match[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= 7 && match[1] && match[6]) {
            var type = match[3] ? 1 /* eTraceStateKeyType.multiTenant */ : 0 /* eTraceStateKeyType.simple */;
            var multiTenant = null;
            if (type === 1 /* eTraceStateKeyType.multiTenant */) {
                multiTenant = {
                    tenantId: match[4],
                    systemId: match[5]
                };
            }
            var parts = {
                type: type,
                key: match[2],
                multiTenant: multiTenant,
                value: match[6]
            };
            return parts;
        }
    }
    return null;
}
/**
 * @internal
 * Parse the trace state list from a string
 * @param value - the list of trace states as a string
 * @returns An array of trace state members
 */
function _parseTraceStateList(value) {
    var items = [];
    if (value) {
        var addedKeys_1 = [];
        ts_utils_arrForEach(strSplit(value, ","), function (member) {
            var parts = _parseListMember(member);
            if (parts) {
                // As per the spec, the first occurrence of a key is the one that should be used
                // as all new entries are added to the front (left) of the list
                if (ts_utils_arrIndexOf(addedKeys_1, parts.key) === -1) {
                    items[_DynamicConstants_DYN_PUSH /* @min:%2epush */](parts);
                    addedKeys_1[_DynamicConstants_DYN_PUSH /* @min:%2epush */](parts.key);
                    if (items[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] >= MAX_TRACE_STATE_MEMBERS) {
                        // The trace state list should not exceed 32 members
                        return -1;
                    }
                }
            }
        });
    }
    return items;
}
function _indexOf(items, key) {
    for (var lp = 0; lp < items[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
        if (items[lp].key === key) {
            return lp;
        }
    }
    return -1;
}
function _keys(items, parent) {
    var keys = [];
    var delKeys = [];
    ts_utils_arrForEach(items, function (member) {
        if (member[_DYN_VALUE /* @min:%2evalue */] != null) {
            keys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](member.key);
        }
        else {
            delKeys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](member.key);
        }
    });
    if (parent) {
        // Get and add parent keys that are not in the current list or marked as deleted
        ts_utils_arrForEach(parent.keys, function (key) {
            if (ts_utils_arrIndexOf(keys, key) === -1 && ts_utils_arrIndexOf(delKeys, key) === -1) {
                keys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](key);
            }
        });
    }
    return keys;
}
/**
 * @internal
 * Identifies if the provided items are empty, meaning it has no keys or values.
 * @param items - The items to check
 * @param parent - The parent trace state to check for keys
 * @returns true if the items are empty, false otherwise
 */
/*#__NO_SIDE_EFFECTS__*/
function _isEmpty(items, parent) {
    var delKeys;
    var isEmpty = true;
    if (items && items[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        ts_utils_arrForEach(items, function (member) {
            if (member[_DYN_VALUE /* @min:%2evalue */] != null) {
                isEmpty = false;
            }
            else {
                if (!delKeys) {
                    delKeys = [];
                }
                // If the value is null then this is a deleted key, so we can ignore it
                delKeys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](member.key);
            }
        });
    }
    if (isEmpty && parent) {
        isEmpty = parent.isEmpty;
        if (!isEmpty && delKeys && delKeys[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            // If the parent is not empty then we need to check if any of the keys are in the deleted list
            isEmpty = true;
            ts_utils_arrForEach(parent.keys, function (key) {
                if (ts_utils_arrIndexOf(delKeys, key) === -1) {
                    isEmpty = false;
                    return -1; // Break out of the loop
                }
            });
        }
    }
    return isEmpty;
}
/**
 * Identifies if the provided value looks like a distributed trace state instance
 * @param value - The value to check
 * @returns - True if the value looks like a distributed trace state instance
 */
/*#__NO_SIDE_EFFECTS__*/
function isW3cTraceState(value) {
    return !!(value && ts_utils_isArray(value.keys) && ts_utils_isFunction(value.get) && ts_utils_isFunction(value.set) && ts_utils_isFunction(value.del) && ts_utils_isFunction(value.hdrs));
}
/**
 * Creates a new mutable {@link IW3cTraceState} instance, optionally inheriting from the parent trace state
 * and optionally using the provided encoded string value as the initial trace state.
 * Calls to {@link IW3cTraceState.set} and {@link IW3cTraceState.del} will modify the current instance
 * which means that any child instance that is using this instance as a parent will also be indirectly
 * modified unless the child instance has overridden the value associated with the modified key.
 * @since 3.4.0
 * @param value - The string value for the trace state
 * @param parent - The parent trace state to inherit any existing keys from.
 * @returns - A new distributed trace state instance
 */
/*#__NO_SIDE_EFFECTS__*/
function createW3cTraceState(value, parent) {
    var cachedItems = safeGetDeferred(_parseTraceStateList, [], [value || InternalConstants_STR_EMPTY]);
    function _get(key) {
        var value;
        var theItems = cachedItems.v;
        var idx = _indexOf(theItems, key);
        if (idx !== -1) {
            var itmValue = theItems[idx][_DYN_VALUE /* @min:%2evalue */];
            if (itmValue != null) {
                // Special case for the value being null, which means the key was deleted
                value = itmValue;
            }
        }
        else if (parent) {
            // Get the value from the parent if it exists
            value = parent.get(key);
        }
        return value;
    }
    function _setMember(member) {
        if (member) {
            var theItems = cachedItems.v;
            var idx = _indexOf(theItems, member.key);
            if (idx !== -1) {
                // Move the item to the front of the list, removing the previous instance
                theItems[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
            }
            theItems.unshift(member);
            // We need to re-create the cached value as during testing the cached lazy value
            // may get re-evaluated resetting the items to the original value
            cachedItems = ts_utils_createCachedValue(theItems);
            return 0;
        }
        return -1;
    }
    function _set(key, value) {
        var member;
        if (key && ts_utils_isString(key) && !ts_utils_isNullOrUndefined(value) && ts_utils_isString(value)) {
            member = _parseListMember(key + "=" + value); // Validate the key/value pair before adding it to the state
        }
        return _setMember(member);
    }
    function _del(key) {
        _setMember({
            type: 2 /* eTraceStateKeyType.deleted */,
            key: key
        });
    }
    function _headers(maxHeaders, maxKeys, maxLen) {
        var results = [];
        var result = InternalConstants_STR_EMPTY;
        var numKeys = 0;
        var len = 0;
        // Default to the max values if not provided
        maxKeys = maxKeys || MAX_TRACE_STATE_MEMBERS;
        // Default to the max length if not provided
        maxLen = maxLen || MAX_TRACE_STATE_LEN;
        var theItems = cachedItems.v;
        ts_utils_arrForEach(_keys(theItems, parent), function (key) {
            var value = _get(key);
            if (!ts_utils_isNullOrUndefined(value) && ts_utils_isString(value)) {
                numKeys++;
                var val = key + "=" + value;
                var valLen = val[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                if (len + 1 + valLen >= maxLen) {
                    // Don't exceed the max length for any single combined header value
                    results[_DynamicConstants_DYN_PUSH /* @min:%2epush */](result);
                    if (maxHeaders && results[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] <= maxHeaders) {
                        // Don't exceed the max number of entries
                        return -1;
                    }
                    result = InternalConstants_STR_EMPTY;
                    len = 0;
                }
                if (result[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    result += ",";
                    len++;
                }
                result += val;
                len += valLen;
                if (numKeys >= maxKeys) {
                    // Only allow the first maxKeys members
                    return -1;
                }
            }
        });
        if (result) {
            results[_DynamicConstants_DYN_PUSH /* @min:%2epush */](result);
        }
        return results;
    }
    var traceStateList = {
        keys: [],
        isEmpty: false,
        get: _get,
        set: _set,
        del: _del,
        hdrs: _headers,
        child: function () { return createW3cTraceState(null, traceStateList); }
    };
    function _toString() {
        var headers = traceStateList.hdrs(1);
        return headers[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0 ? headers[0] : InternalConstants_STR_EMPTY;
    }
    objDefineProps(traceStateList, {
        "keys": {
            g: function () { return _keys(cachedItems.v, parent); }
        },
        "isEmpty": {
            g: function () { return _isEmpty(cachedItems.v, parent); }
        },
        "toString": {
            v: _toString,
            e: false // Do not allow the toString to be enumerated
        },
        "_p": {
            v: parent,
            e: false // Do not allow the parent to be enumerated
        }
    });
    setObjStringTag(traceStateList, _toString);
    return traceStateList;
}
/**
 * Create a new independent instance of IW3cTraceState that contains a snapshot of all current key/value pairs
 * from the provided instance and any parent instances. The returned instance will have no parent and will be completely
 * independent from any future changes to the original instance or its parent chain.
 * This is useful when you need to capture the current state and ensure it remains unchanged regardless of
 * future modifications to the parent instances.
 * @since 3.4.0
 * @param traceState - The trace state instance to snapshot
 * @returns A new independent instance of IW3cTraceState with all current key/value pairs captured
 */
/*#__NO_SIDE_EFFECTS__*/
function snapshotW3cTraceState(traceState) {
    // Create a new independent instance with no parent
    // This ensures the returned instance is completely independent from future changes
    var snapshot = createW3cTraceState(null, null);
    if (traceState) {
        var theKeys = traceState.keys;
        // Iterate over the keys in reverse order to maintain correct precedence
        // Since set() adds items to the front, we need to add them in reverse order
        // to preserve the original key ordering where newer keys take precedence
        for (var i = theKeys[_DYN_LENGTH /* @min:%2elength */] - 1; i >= 0; i--) {
            var key = theKeys[i];
            var value = traceState.get(key);
            if (!isNullOrUndefined(value) && isString(value)) {
                // Use the set function to add the key/value pair to the snapshot
                // This leverages the existing validation and formatting logic
                snapshot.set(key, value);
            }
        }
    }
    return snapshot;
}
/**
 * Helper function to fetch the passed traceparent from the page, looking for it as a meta-tag or a Server-Timing header.
 * @since 3.4.0
 * @param selectIdx - If the found value is comma separated which is the preferred entry to select, defaults to the first
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function findW3cTraceState() {
    var name = "tracestate";
    var traceState = null;
    var metaTags = findMetaTags(name);
    if (metaTags[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        traceState = createW3cTraceState(metaTags[_DYN_JOIN /* @min:%2ejoin */](","));
    }
    if (!traceState) {
        var serverTimings = findNamedServerTimings(name);
        if (serverTimings[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            traceState = createW3cTraceState(serverTimings[_DYN_JOIN /* @min:%2ejoin */](","));
        }
    }
    return traceState;
}
//# sourceMappingURL=W3cTraceState.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/traceState.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var _otelTraceState;
function _initOTelTraceStateSymbol() {
    if (!_otelTraceState) {
        _otelTraceState = ts_utils_createCachedValue(symbolFor("otTraceState"));
    }
    return _otelTraceState;
}
/*#__NO_SIDE_EFFECTS__*/
function _createOTelTraceState(traceState) {
    if (!_otelTraceState) {
        _otelTraceState = _initOTelTraceStateSymbol();
    }
    var otTraceState = {
        set: function (key, value) {
            var newState = createW3cTraceState(InternalConstants_STR_EMPTY, traceState);
            newState.set(key, value);
            return _createOTelTraceState(newState);
        },
        unset: function (key) {
            var newState = createW3cTraceState(InternalConstants_STR_EMPTY, traceState);
            newState.del(key);
            return _createOTelTraceState(newState);
        },
        get: function (key) {
            return traceState.get(key);
        },
        serialize: function () {
            var headers = traceState.hdrs(1);
            if (headers[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                return headers[0];
            }
            return InternalConstants_STR_EMPTY;
        }
    };
    ts_utils_objDefine(otTraceState, _otelTraceState.v, { g: function () { return traceState; } });
    return otTraceState;
}
/**
 * Identifies if the provided value is an OpenTelemetry TraceState object
 * @param value - The value to check
 * @returns true if the value is an OpenTelemetry TraceState object otherwise false
 * @remarks The OpenTelemetry TraceState is an immutable object, meaning that any changes made to the trace state will
 * @since 3.4.0
 */
/*#__NO_SIDE_EFFECTS__*/
function isOTelTraceState(value) {
    if (!_otelTraceState) {
        _otelTraceState = _initOTelTraceStateSymbol();
    }
    if (value && value[_otelTraceState.v]) {
        return true;
    }
    return value && ts_utils_isFunction(value.serialize) && ts_utils_isFunction(value.unset) && ts_utils_isFunction(value.get) && ts_utils_isFunction(value.set);
}
/**
 * Returns an OpenTelemetry compatible instance of the trace state, an important distinction
 * between an {@link IW3cTraceState} and an {@link IOTelTraceState} is that the OpenTelemetry version
 * is immutable, meaning that any changes made to the trace state will create and return a new
 * instance for the {@link IOTelTraceState.set} and {@link IOTelTraceState.unset} methods.
 * @param value - The current trace state value
 * @returns An OpenTelemetry compatible instance of the trace state
 * @remarks The OpenTelemetry TraceState is an immutable object, meaning that any changes made to the trace state will
 * @since 3.4.0
 */
/*#__NO_SIDE_EFFECTS__*/
function createOTelTraceState(value) {
    var traceState = null;
    if (isOTelTraceState(value)) {
        var parentTraceState = void 0;
        if (_otelTraceState) {
            // Only attempt the lookup if the symbol has been created and therefore possibly
            // assigned to a parent trace state
            parentTraceState = value[_otelTraceState.v];
        }
        if (parentTraceState) {
            // Reuse the existing trace state as a parent to avoid copying objects
            traceState = createW3cTraceState(InternalConstants_STR_EMPTY, parentTraceState);
        }
        else {
            // fallback to creating a new trace state
            traceState = createW3cTraceState(value.serialize());
        }
    }
    else if (isW3cTraceState(value)) {
        traceState = value;
    }
    else {
        traceState = createW3cTraceState(ts_utils_isString(value) ? value : InternalConstants_STR_EMPTY);
    }
    return _createOTelTraceState(traceState);
}
//# sourceMappingURL=traceState.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/spanContext.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






function createOTelSpanContext(traceContext) {
    var traceId = isValidTraceId(traceContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */]) ? traceContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] : TraceParent_INVALID_TRACE_ID;
    var spanId = isValidSpanId(traceContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */]) ? traceContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] : INVALID_SPAN_ID;
    var isRemote = traceContext.isRemote;
    var traceFlags = (!ts_utils_isNullOrUndefined(traceContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]) ? traceContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] : 1 /* eW3CTraceFlags.Sampled */);
    var otTraceState = null;
    var traceContextObj = {
        traceId: traceId,
        spanId: spanId,
        traceFlags: traceFlags
    };
    return objDefineProps(traceContextObj, {
        traceId: {
            g: function () { return traceId; },
            s: function (value) { return traceId = isValidTraceId(value) ? value : TraceParent_INVALID_TRACE_ID; }
        },
        spanId: {
            g: function () { return spanId; },
            s: function (value) { return spanId = isValidSpanId(value) ? value : INVALID_SPAN_ID; }
        },
        isRemote: {
            g: function () { return isRemote; }
        },
        traceFlags: {
            g: function () { return traceFlags; },
            s: function (value) { return traceFlags = value; }
        },
        traceState: {
            g: function () {
                if (!otTraceState) {
                    // The Trace State has changed, update the local copy
                    otTraceState = createOTelTraceState(traceContext[_DYN_TRACE_STATE /* @min:%2etraceState */]);
                }
                return otTraceState;
            },
            s: function (value) {
                // The Trace State has changed, update the local copy
                otTraceState = value;
            }
        }
    });
}
function isSpanContext(spanContext) {
    return spanContext && isObject(spanContext) && isString(spanContext[_DYN_TRACE_ID /* @min:%2etraceId */]) && isString(spanContext[_DYN_SPAN_ID /* @min:%2espanId */]) && isNumber(spanContext[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]);
}
function wrapDistributedTrace(traceContext) {
    return createOTelSpanContext(traceContext);
}
//# sourceMappingURL=spanContext.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/TelemetryHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */













var pluginStateData = createElmNodeData("plugin");
function _getPluginState(plugin) {
    return pluginStateData.get(plugin, "state", {}, true);
}
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config - The current config for the instance
 * @param core - THe current core instance
 * @param extensions - The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[_DYN_GET_NEXT /* @min:%2egetNext */]();
    var pluginState;
    while (proxy) {
        var thePlugin = proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] && thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]) {
                // Set this plugin as the next for the previous one
                lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](thePlugin);
            }
            pluginState = _getPluginState(thePlugin);
            var isInitialized = !!pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */];
            if (thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]) {
                isInitialized = thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]();
            }
            if (!isInitialized) {
                initPlugins[_DynamicConstants_DYN_PUSH /* @min:%2epush */](thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
        }
    }
    // Now initialize the plugins
    ts_utils_arrForEach(initPlugins, function (thePlugin) {
        var core = processContext[STR_CORE /* @min:%2ecore */]();
        thePlugin[_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT /* @min:%2egetNext */]());
        pluginState = _getPluginState(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) {
            pluginState[STR_CORE] = core;
        }
        pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = true;
        delete pluginState[_DYN_TEARDOWN /* @min:%2eteardown */];
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[STR_PROCESS_TELEMETRY];
            if (extA[STR_PROCESS_TELEMETRY]) {
                result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
            }
            else if (bHasProcess) {
                result = -1;
            }
        }
        else {
            result = extA ? 1 : -1;
        }
        return result;
    });
    // sort complete
}
/**
 * Teardown / Unload helper to perform teardown/unloading operations for the provided components synchronously or asynchronously, this will call any
 * _doTeardown() or _doUnload() functions on the provided components to allow them to finish removal.
 * @param components - The components you want to unload
 * @param unloadCtx - This is the context that should be used during unloading.
 * @param unloadState - The details / state of the unload process, it holds details like whether it should be unloaded synchronously or asynchronously and the reason for the unload.
 * @param asyncCallback - An optional callback that the plugin must call if it returns true to inform the caller that it has completed any async unload/teardown operations.
 * @returns boolean - true if the plugin has or will call asyncCallback, this allows the plugin to perform any asynchronous operations.
 */
function unloadComponents(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while (idx < components[_DYN_LENGTH /* @min:%2elength */]) {
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */];
                if (isFunction(func)) {
                    if (func[_DYN_CALL /* @min:%2ecall */](component, unloadCtx, unloadState, _doUnload) === true) {
                        return true;
                    }
                }
            }
        }
    }
    return _doUnload();
}
/*#__NO_SIDE_EFFECTS__*/
function isDistributedTraceContext(obj) {
    return obj &&
        ts_utils_isFunction(obj.getName) &&
        ts_utils_isFunction(obj.getTraceId) &&
        ts_utils_isFunction(obj.getSpanId) &&
        ts_utils_isFunction(obj.getTraceFlags) &&
        ts_utils_isFunction(obj.setName) &&
        ts_utils_isFunction(obj.setTraceId) &&
        ts_utils_isFunction(obj.setSpanId) &&
        ts_utils_isFunction(obj[_DYN_SET_TRACE_FLAGS /* @min:%2esetTraceFlags */]);
}
/**
 * Creates an IDistributedTraceContext instance that ensures a valid traceId is always available.
 * The traceId will be inherited from the parent context if valid, otherwise a new random W3C trace ID is generated.
 *
 * @param parent - An optional parent {@link IDistributedTraceContext} or {@link IOTelSpanContext} to inherit
 * trace context values from. If provided, the traceId and spanId will be copied from the parent if they are valid.
 * When the parent is an {@link IDistributedTraceContext}, it will be set as the parentCtx property to maintain
 * hierarchical relationships and enable parent context updates.
 * When the parent is an {@link IOTelSpanContext}, the parentCtx will be null because OpenTelemetry span contexts
 * are read-only data sources that don't support the same hierarchical management methods as IDistributedTraceContext.
 * The core instance will create a wrapped IDistributedTraceContext instance from the IOTelSpanContext data
 * to enable Application Insights distributed tracing functionality while maintaining OpenTelemetry compatibility.
 *
 * @returns A new IDistributedTraceContext instance with the following behavior:
 * - **traceId**: Always present - either inherited from parent (if valid) or newly generated W3C trace ID
 * - **spanId**: Inherited from parent if valid, otherwise empty string
 * - **traceFlags**: Inherited from parent if available, otherwise undefined
 * - **pageName**: Inherited from parent context or derived from current location, defaults to "_unknown_"
 * - **traceState**: Lazily created W3C trace state, inheriting from parent if available
 *
 * @remarks
 * This function ensures consistent distributed tracing by guaranteeing that every context has a valid traceId,
 * which is essential for the refactored W3C trace state implementation. The spanId may be empty until a
 * specific span is created, which is normal behavior for trace contexts.
 *
 * The distinction between IDistributedTraceContext and IOTelSpanContext parents is important:
 * - IDistributedTraceContext parents enable bidirectional updates and hierarchical management
 * - IOTelSpanContext parents are used only for initial data extraction and OpenTelemetry compatibility
 */
/*#__NO_SIDE_EFFECTS__*/
function createDistributedTraceContext(parent) {
    var _a;
    var parentCtx = null;
    var initCtx = null;
    var traceId = (parent && isValidTraceId(parent[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */])) ? parent[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] : generateW3CId();
    var spanId = (parent && isValidSpanId(parent[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */])) ? parent[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] : InternalConstants_STR_EMPTY;
    var traceFlags = parent ? parent[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] : UNDEFINED_VALUE;
    var isRemote = parent ? parent.isRemote : false;
    var pageName = InternalConstants_STR_EMPTY;
    var traceState = null;
    if (parent) {
        if (isDistributedTraceContext(parent)) {
            parentCtx = parent;
            pageName = parentCtx.getName();
        }
        else {
            initCtx = parent;
        }
    }
    if (!pageName) {
        pageName = "_unknown_";
        // If we have a location, use that as the page name
        var location_1 = getLocation();
        if (location_1 && location_1[_DynamicConstants_DYN_PATHNAME /* @min:%2epathname */]) {
            pageName = location_1[_DynamicConstants_DYN_PATHNAME /* @min:%2epathname */] + (location_1.hash || "");
        }
    }
    function _getName() {
        return pageName;
    }
    function _setPageNameFn(updateParent) {
        return function (newValue) {
            if (updateParent) {
                parentCtx && parentCtx.setName(newValue);
            }
            pageName = newValue;
        };
    }
    function _getTraceId() {
        return traceId;
    }
    function _setTraceIdFn(updateParent) {
        return function (newValue) {
            if (updateParent) {
                parentCtx && parentCtx.setTraceId(newValue);
            }
            if (isValidTraceId(newValue)) {
                traceId = newValue;
            }
        };
    }
    function _getSpanId() {
        return spanId;
    }
    function _setSpanIdFn(updateParent) {
        return function (newValue) {
            if (updateParent) {
                parentCtx && parentCtx.setSpanId(newValue);
            }
            if (isValidSpanId(newValue)) {
                spanId = newValue;
            }
        };
    }
    function _getTraceFlags() {
        return traceFlags;
    }
    function _setTraceFlagsFn(updateParent) {
        return function (newTraceFlags) {
            if (updateParent) {
                parentCtx && parentCtx[_DYN_SET_TRACE_FLAGS /* @min:%2esetTraceFlags */](newTraceFlags);
            }
            traceFlags = newTraceFlags;
        };
    }
    function _getTraceState() {
        if (!traceState) {
            if (!parentCtx) {
                // The passed in parent was not an IDistributedTraceContext
                if (initCtx) {
                    if (isOTelTraceState(initCtx[_DYN_TRACE_STATE /* @min:%2etraceState */])) {
                        // This looks like an IOTelSpanContext, so we have to just use the passed traceState as-is as it doesn't support
                        // the W3cTraceState heirarchy methods
                        traceState = createW3cTraceState(initCtx[_DYN_TRACE_STATE /* @min:%2etraceState */].serialize() || InternalConstants_STR_EMPTY, parentCtx ? parentCtx[_DYN_TRACE_STATE /* @min:%2etraceState */] : undefined);
                    }
                    else {
                        // This looks like an IDistributedTraceInit, so we can create a new W3cTraceState
                        traceState = createW3cTraceState(InternalConstants_STR_EMPTY, initCtx[_DYN_TRACE_STATE /* @min:%2etraceState */] || (parentCtx ? parentCtx[_DYN_TRACE_STATE /* @min:%2etraceState */] : undefined));
                    }
                }
            }
            if (!traceState) {
                traceState = createW3cTraceState(InternalConstants_STR_EMPTY, parentCtx ? parentCtx[_DYN_TRACE_STATE /* @min:%2etraceState */] : undefined);
            }
        }
        return traceState;
    }
    var otelSpanCtx = null;
    var traceCtx = setProtoTypeName((_a = {
            getName: _getName,
            setName: _setPageNameFn(true),
            getTraceId: _getTraceId,
            setTraceId: _setTraceIdFn(true),
            getSpanId: _getSpanId,
            setSpanId: _setSpanIdFn(true),
            getTraceFlags: _getTraceFlags
        },
        _a[_DYN_SET_TRACE_FLAGS /* @min:setTraceFlags */] = _setTraceFlagsFn(true),
        _a.traceId = traceId,
        _a.spanId = spanId,
        _a.traceFlags = traceFlags,
        _a.traceState = traceState,
        _a.isRemote = isRemote,
        _a.pageName = pageName,
        _a.getOTelSpanContext = function () {
            if (!otelSpanCtx) {
                // Lazily create the OTel Span Context
                otelSpanCtx = createOTelSpanContext(traceCtx);
            }
            return otelSpanCtx;
        },
        _a), "DistributedTraceContext");
    return objDefineProps(traceCtx, {
        pageName: {
            g: _getName,
            s: _setPageNameFn(false)
        },
        traceId: {
            g: _getTraceId,
            s: _setTraceIdFn(false)
        },
        spanId: {
            g: _getSpanId,
            s: _setSpanIdFn(false)
        },
        traceFlags: {
            g: _getTraceFlags,
            s: _setTraceFlagsFn(false)
        },
        isRemote: {
            v: isRemote,
            w: false
        },
        traceState: {
            g: _getTraceState
        },
        parentCtx: {
            g: function () { return parentCtx; }
        },
        _parent: {
            g: function () {
                var result;
                if (parentCtx) {
                    result = {
                        t: "traceCtx",
                        v: parentCtx
                    };
                }
                else if (initCtx) {
                    result = {
                        t: "initCtx",
                        v: initCtx
                    };
                }
                return result;
            }
        }
    });
}
//# sourceMappingURL=TelemetryHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/ProcessTelemetryContext.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
    while (proxy) {
        if (proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]() === startAt) {
            return proxy;
        }
        proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return createTelemetryProxyChain([startAt], core[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */] || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */
function _createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) {
        dynamicHandler = createDynamicConfig({}, null, core[_DYN_LOGGER /* @min:%2elogger */]);
    }
    if (startAt !== null) {
        // There is no next element (null) vs not defined (undefined) so use the full chain
        _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    }
    var context = {
        _next: _moveNext,
        ctx: {
            core: function () {
                return core;
            },
            diagLog: function () {
                return safeGetLogger(core, dynamicHandler.cfg);
            },
            getCfg: function () {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function () {
                return !!_nextProxy;
            },
            getNext: function () {
                return _nextProxy;
            },
            setNext: function (nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (onComplete) {
            _onComplete[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
                func: onComplete,
                self: !ts_utils_isUndefined(that) ? that : context.ctx,
                args: args
            });
        }
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT /* @min:%2egetNext */]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                ts_utils_arrForEach(onComplete, function (completeDetails) {
                    try {
                        completeDetails.func[_DynamicConstants_DYN_CALL /* @min:%2ecall */](completeDetails.self, completeDetails.args);
                    }
                    catch (e) {
                        _throwInternal(core[_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected Exception during onComplete - " + ts_utils_dumpObj(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var extCfg = _getCfg(dynamicHandler.cfg, "extensionConfig", createIfMissing);
        if (extCfg) {
            idCfg = _getCfg(extCfg, identifier, createIfMissing);
        }
        return idCfg;
    }
    function _getCfg(cfg, identifier, createIfMissing) {
        var idCfg = null;
        if (cfg && identifier) {
            idCfg = cfg[identifier];
            if (!idCfg && createIfMissing) {
                idCfg = {};
            }
            // Always set the value so that the property always exists
            cfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            idCfg = dynamicHandler.ref(cfg, identifier);
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues, rootOnly) {
        var newConfig = rootOnly ? _getCfg(dynamicHandler.cfg, identifier, true) : _getExtCfg(identifier, true);
        if (defaultValues) {
            // Enumerate over the defaultValues and if not already populated attempt to
            // find a value from the root config or use the default value
            ts_utils_objForEachKey(defaultValues, function (field, defaultValue) {
                // for each unspecified field, set the default value
                if (ts_utils_isNullOrUndefined(newConfig[field])) {
                    var cfgValue = dynamicHandler.cfg[field];
                    if (cfgValue || !ts_utils_isNullOrUndefined(cfgValue)) {
                        newConfig[field] = cfgValue;
                    }
                }
                _applyDefaultValue(dynamicHandler, newConfig, field, defaultValue);
            });
        }
        return dynamicHandler.setDf(newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !ts_utils_isNullOrUndefined(extConfig[field]))) {
            theValue = extConfig[field];
        }
        else if (rootConfig[field] || !ts_utils_isNullOrUndefined(rootConfig[field])) {
            theValue = rootConfig[field];
        }
        return (theValue || !ts_utils_isNullOrUndefined(theValue)) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while (!!(nextPlugin = context._next())) {
            var plugin = nextPlugin[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
            if (plugin) {
                // callback with the current on
                cb(plugin);
            }
        }
    }
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryContext(telemetryChain, cfg, core, startAt) {
    var config = createDynamicConfig(cfg);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) {
            // Run the next plugin which will call "processNext()"
            nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, context);
        }
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (ts_utils_isArray(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), config.cfg, core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for handling the unloading of the chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[_DYN_UNLOAD /* @min:%2eunload */](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (ts_utils_isArray(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for updating the configuration
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function (plugin) {
            if (ts_utils_isFunction(plugin[_DYN_UPDATE /* @min:%2eupdate */])) {
                plugin[_DYN_UPDATE /* @min:%2eupdate */](context, updateState);
            }
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (ts_utils_isArray(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates an execution chain from the array of plugins
 * @param plugins - The array of plugins that will be executed in this order
 * @param defItemCtx - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 */
function createTelemetryProxyChain(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if (ts_utils_isArray(plugins) && plugins[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        ts_utils_arrForEach(plugins, function (thePlugin) {
            if (!add && startAt === thePlugin) {
                add = true;
            }
            if (add && thePlugin && ts_utils_isFunction(thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Only add plugins that are processors
                var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
                if (!firstProxy) {
                    firstProxy = newProxy;
                }
                if (lastProxy_1) {
                    // Set this new proxy as the next for the previous one
                    lastProxy_1._setNext(newProxy);
                }
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) {
        // Special case where the "startAt" was not in the original list of plugins
        return createTelemetryProxyChain([startAt], config, core);
    }
    return firstProxy;
}
/**
 * Create the processing telemetry proxy instance, the proxy is used to abstract the current plugin to allow monitoring and
 * execution plugins while passing around the dynamic execution state (IProcessTelemetryContext), the proxy instance no longer
 * contains any execution state and can be reused between requests (this was not the case for 2.7.2 and earlier with the
 * TelemetryPluginChain class).
 * @param plugin - The plugin instance to proxy
 * @param config - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 * @returns
 */
function createTelemetryPluginProxy(plugin, config, core) {
    var _a;
    var nextProxy = null;
    var hasProcessTelemetry = ts_utils_isFunction(plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]);
    var hasSetNext = ts_utils_isFunction(plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */]);
    var chainId;
    if (plugin) {
        chainId = plugin[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */] + "-" + plugin[STR_PRIORITY /* @min:%2epriority */] + "-" + _chainId++;
    }
    else {
        chainId = "Unknown-0-" + _chainId++;
    }
    var proxyChain = (_a = {
            getPlugin: function () {
                return plugin;
            },
            getNext: function () {
                return nextProxy;
            }
        },
        _a[STR_PROCESS_TELEMETRY /* @min:processTelemetry */] = _processTelemetry,
        _a.unload = _unloadPlugin,
        _a.update = _updatePlugin,
        _a._id = chainId,
        _a._setNext = function (nextPlugin) {
            nextProxy = nextPlugin;
        },
        _a);
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && ts_utils_isFunction(plugin[strGetTelCtx])) {
            // This plugin extends from the BaseTelemetryPlugin so lets use it
            itemCtx = plugin[strGetTelCtx]();
        }
        if (!itemCtx) {
            // Create a temporary one
            itemCtx = createProcessTelemetryContext(proxyChain, config, core);
        }
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */] : strTelemetryPluginChain;
        var hasRunContext = itemCtx[strHasRunFlags];
        if (!hasRunContext) {
            // Assign and populate
            hasRunContext = itemCtx[strHasRunFlags] = {};
        }
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) {
            doPerf(itemCtx[STR_CORE /* @min:%2ecore */](), function () { return identifier + ":" + name; }, function () {
                // Mark this component as having run
                hasRunContext[chainId] = true;
                try {
                    // Set a flag on the next plugin so we know if it was attempted to be executed
                    var nextId = nextProxy ? nextProxy._id : InternalConstants_STR_EMPTY;
                    if (nextId) {
                        hasRunContext[nextId] = false;
                    }
                    hasRun = processPluginFn(itemCtx);
                }
                catch (error) {
                    var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                    if (hasNextRun) {
                        // The next plugin after us has already run so set this one as complete
                        hasRun = true;
                    }
                    if (!nextProxy || !hasNextRun) {
                        // Either we have no next plugin or the current one did not attempt to call the next plugin
                        // Which means the current one is the root of the failure so log/report this failure
                        _throwInternal(itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 73 /* _eInternalMessageId.PluginException */, "Plugin [" + identifier + "] failed during " + name + " - " + ts_utils_dumpObj(error) + ", run flags: " + ts_utils_dumpObj(hasRunContext));
                    }
                }
            }, details, isAsync);
        }
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) {
                return false;
            }
            var pluginState = _getPluginState(plugin);
            if (pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] || pluginState[STR_DISABLED]) {
                return false;
            }
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) {
                // Backward compatibility setting the next plugin on the instance
                plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](nextProxy);
            }
            plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () { return ({ item: env }); }, !(env.sync))) {
            // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
            // so we still want the next plugin to be executed.
            itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
        }
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[STR_CORE /* @min:%2ecore */] = null;
                    pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] = true;
                    pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = false;
                    if (plugin[_DYN_TEARDOWN /* @min:%2eteardown */] && plugin[_DYN_TEARDOWN /* @min:%2eteardown */](unloadCtx, unloadState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", _noopVoid, unloadState.isAsync)) {
            // Only called if we hasRun was not true
            unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
        }
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    if (plugin[_DYN_UPDATE /* @min:%2eupdate */] && plugin[_DYN_UPDATE /* @min:%2eupdate */](updateCtx, updateState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", _noopVoid, false)) {
            // Only called if we hasRun was not true
            updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
        }
    }
    return objFreeze(proxyChain);
}
//# sourceMappingURL=ProcessTelemetryContext.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/InstrumentHooks.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var aiInstrumentHooks = "_aiHooks";
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */ && type <= 2 /* CallbackType.HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* CallbackType.HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        funcArgs.evt = ts_utils_getInst("event");
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target[_DynamicConstants_DYN_PUSH /* @min:%2epush */](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) {
            try {
                funcArgs.rslt = theFunc[_DYN_APPLY /* @min:%2eapply */](funcThis, orgArgs);
            }
            catch (err) {
                // Report the request callback
                funcArgs.err = err;
                _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */);
                // rethrow the original exception so anyone listening for it can catch the exception
                throw err;
            }
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */);
        return funcArgs.rslt;
    };
}
/** @ignore */
function _getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if (ts_utils_objHasOwnProperty(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(HelperFuncs_getObjProto(target), name, checkParentProto, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[Constants_strShimPrototype], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[strShimPrototype], funcNames, callbacks, false);
    }
    return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = _createFunctionHook(aiHook);
        newFunc[aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function () {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            _arrLoop(aiHook.h, function (hook, idx) {
                if (hook.id === id) {
                    aiHook.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return 1;
                }
            });
        }
        // tslint:enable:object-literal-shorthand
    };
    aiHook.i++;
    aiHook.h[_DynamicConstants_DYN_PUSH /* @min:%2epush */](theHook);
    return theHook;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === Constants_strShimFunction) {
                return _createInstrumentHook(owner, funcName, fn, callbacks);
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks[_DYN_PUSH /* @min:%2epush */](hook);
        }
    });
    return hooks;
}
/**
 * Add an instrumentation hook to the provided named "event" for the target class / object, this doesn't check whether the
 * named "event" is in fact a function and just assigns the instrumentation hook to the target[evtName]
 * @param target - The target object
 * @param evtName - The name of the event
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) {
            return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
        }
    }
    return null;
}
//# sourceMappingURL=InstrumentHooks.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/DomHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function createDomEvent(eventName) {
    var event = null;
    if (ts_utils_isFunction(Event)) { // Use Event constructor when available
        event = new Event(eventName);
    }
    else { // Event has no constructor in IE
        var doc = ts_utils_getDocument();
        if (doc && doc[_DYN_CREATE_EVENT /* @min:%2ecreateEvent */]) {
            event = doc[_DYN_CREATE_EVENT /* @min:%2ecreateEvent */]("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/UnloadHandlerContainer.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/*#__NO_SIDE_EFFECTS__*/
function createUnloadHandlerContainer() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) {
            handlers[_DynamicConstants_DYN_PUSH /* @min:%2epush */](handler);
        }
    }
    function _runHandlers(unloadCtx, unloadState) {
        ts_utils_arrForEach(handlers, function (handler) {
            try {
                handler(unloadCtx, unloadState);
            }
            catch (e) {
                _throwInternal(unloadCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected error calling unload handler - " + ts_utils_dumpObj(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}
//# sourceMappingURL=UnloadHandlerContainer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/UnloadHookContainer.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var _maxHooks;
var _hookAddMonitor;
/**
 * Test hook for setting the maximum number of unload hooks and calling a monitor function when the hooks are added or removed
 * This allows for automatic test failure when the maximum number of unload hooks is exceeded
 * @param maxHooks - The maximum number of unload hooks
 * @param addMonitor - The monitor function to call when hooks are added or removed
 */
function _testHookMaxUnloadHooksCb(maxHooks, addMonitor) {
    _maxHooks = maxHooks;
    _hookAddMonitor = addMonitor;
}
/**
 * Create a IUnloadHookContainer which can be used to remember unload hook functions to be executed during the component unloading
 * process.
 * @returns A new IUnloadHookContainer instance
 */
function createUnloadHookContainer() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        ts_utils_arrForEach(oldHooks, function (fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove)[_DynamicConstants_DYN_CALL /* @min:%2ecall */](fn);
            }
            catch (e) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unloading:" + ts_utils_dumpObj(e));
            }
        });
        if (_maxHooks && oldHooks[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > _maxHooks) {
            _hookAddMonitor ? _hookAddMonitor("doUnload", oldHooks) : _throwInternal(null, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.MaxUnloadHookExceeded */, "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
        }
    }
    function _addHook(hooks) {
        if (hooks) {
            arrAppend(_hooks, hooks);
            if (_maxHooks && _hooks[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > _maxHooks) {
                _hookAddMonitor ? _hookAddMonitor("Add", _hooks) : _throwInternal(null, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.MaxUnloadHookExceeded */, "Max unload hooks exceeded. An excessive number of unload hooks has been detected.");
            }
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}
//# sourceMappingURL=UnloadHookContainer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/BaseTelemetryPlugin.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var BaseTelemetryPlugin_a;










var strGetPlugin = "getPlugin";
var BaseTelemetryPlugin_defaultValues = (BaseTelemetryPlugin_a = {},
    BaseTelemetryPlugin_a[STR_EXTENSION_CONFIG] = { isVal: isNotNullOrUndefined, v: {} },
    BaseTelemetryPlugin_a);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        dynamicProto(BaseTelemetryPlugin, _self, function (_self) {
            _self[_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[_DYN_TEARDOWN /* @min:%2eteardown */] = function (unloadCtx, unloadState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (unloadCtx && core !== unloadCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                    return;
                }
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || {
                    reason: 0 /* TelemetryUnloadReason.ManualTeardown */,
                    isAsync: false
                };
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */]());
                        if (result === true) {
                            theUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
                        }
                        _initDefaults();
                    }
                }
                if (!_self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */] || _self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
                    _unloadCallback();
                }
                else {
                    // Tell the caller that we will be calling processNext()
                    result = true;
                }
                return result;
            };
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function (updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (updateCtx && core !== updateCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing
                    return;
                }
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT /* @min:%2egetNext */]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
                    _updateCallback();
                }
                else {
                    result = true;
                }
                return result;
            };
            proxyFunctionAs(_self, "_addUnloadCb", function () { return _unloadHandlerContainer; }, "add");
            proxyFunctionAs(_self, "_addHook", function () { return _hookContainer; }, "add");
            ts_utils_objDefine(_self, "_unloadHooks", { g: function () { return _hookContainer; } });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[_DYN_DIAG_LOG /* @min:%2ediagLog */] = function (itemCtx) {
            return _getTelCtx(itemCtx)[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
        };
        _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] = function (next) {
            _nextPlugin = next;
        };
        _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
            }
            else if (_nextPlugin && ts_utils_isFunction(_nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Looks like backward compatibility or out of band processing. And as it looks
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, null);
            }
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE /* @min:%2ecore */]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx[_DYN_CREATE_NEW /* @min:%2ecreateNew */](null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx[_DYN_CREATE_NEW /* @min:%2ecreateNew */](null, _nextPlugin);
                }
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            createDynamicConfig(config, BaseTelemetryPlugin_defaultValues, safeGetLogger(core));
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core[_DYN_GET_PROCESS_TEL_CONT2 /* @min:%2egetProcessTelContext */]()[_DYN_GET_NEXT /* @min:%2egetNext */]();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self[STR_CORE /* @min:%2ecore */] = core;
            _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[STR_CORE /* @min:%2ecore */] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = createUnloadHookContainer();
            _unloadHandlerContainer = createUnloadHandlerContainer();
        }
    }
// Removed Stub for BaseTelemetryPlugin.prototype.initialize.
// Removed Stub for BaseTelemetryPlugin.prototype.teardown.
// Removed Stub for BaseTelemetryPlugin.prototype.update.
// Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
// Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn=1;

    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var dist_es5_DynamicConstants_DYN_TO_STRING = "toString"; // Count: 4
var _DYN_IS_STORAGE_USE_DISAB0 = "isStorageUseDisabled"; // Count: 3
var _DYN__ADD_HOOK = "_addHook"; // Count: 6
var _DYN_CORE = "core"; // Count: 13
var _DynamicConstants_DYN_DIAG_LOG = "diagLog"; // Count: 13
var _DynamicConstants_DYN_TRACK = "track"; // Count: 7
var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
var dist_es5_DynamicConstants_DYN_CONFIG = "config"; // Count: 12
var _DYN_TRACK_PREVIOUS_PAGE_1 = "trackPreviousPageVisit"; // Count: 3
var _DYN_SEND_PAGE_VIEW_INTER2 = "sendPageViewInternal"; // Count: 7
var _DYN_REF_URI = "refUri"; // Count: 5
var _DynamicConstants_DYN_START_TIME = "startTime"; // Count: 6
var _DynamicConstants_DYN_PROPERTIES = "properties"; // Count: 5
var _DynamicConstants_DYN_DURATION = "duration"; // Count: 12
var _DYN_SEND_PAGE_VIEW_PERFO3 = "sendPageViewPerformanceInternal"; // Count: 3
var _DYN_POPULATE_PAGE_VIEW_P4 = "populatePageViewPerformanceEvent"; // Count: 2
var _DYN_HREF = "href"; // Count: 6
var _DYN_SEND_EXCEPTION_INTER5 = "sendExceptionInternal"; // Count: 2
var _DYN_ERROR = "error"; // Count: 5
var _DYN_LINE_NUMBER = "lineNumber"; // Count: 4
var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
var _DYN__CREATE_AUTO_EXCEPTI6 = "CreateAutoException"; // Count: 3
var _DYN_ADD_TELEMETRY_INITIA7 = "addTelemetryInitializer"; // Count: 4
var _DYN_OVERRIDE_PAGE_VIEW_D8 = "overridePageViewDuration"; // Count: 2
var _DYN_AUTO_EXCEPTION_INSTR9 = "autoExceptionInstrumented"; // Count: 3
var _DYN_AUTO_TRACK_PAGE_VISI10 = "autoTrackPageVisitTime"; // Count: 2
var _DYN_IS_BROWSER_LINK_TRAC11 = "isBrowserLinkTrackingEnabled"; // Count: 2
var dist_es5_DynamicConstants_DYN_LENGTH = "length"; // Count: 5
var _DYN_ENABLE_AUTO_ROUTE_TR12 = "enableAutoRouteTracking"; // Count: 2
var _DynamicConstants_DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
var _DYN_ENABLE_UNHANDLED_PRO13 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var _DYN_AUTO_UNHANDLED_PROMI14 = "autoUnhandledPromiseInstrumented"; // Count: 3
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 5
var _DYN_IS_PERFORMANCE_TIMIN15 = "isPerformanceTimingSupported"; // Count: 2
var _DYN_GET_PERFORMANCE_TIMI16 = "getPerformanceTiming"; // Count: 2
var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
var _DYN_SHOULD_COLLECT_DURAT17 = "shouldCollectDuration"; // Count: 2
var _DYN_IS_PERFORMANCE_TIMIN18 = "isPerformanceTimingDataReady"; // Count: 2
var _DYN_RESPONSE_START = "responseStart"; // Count: 5
var _DYN_REQUEST_START = "requestStart"; // Count: 3
var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
var _DYN_CONNECT_END = "connectEnd"; // Count: 4
var _DYN_PAGE_VISIT_TIME = "pageVisitTime"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/RequestResponseHeaders.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var RequestHeaders = ( /* @__PURE__ */createValueMap({
    requestContextHeader: [0 /* eRequestHeaders.requestContextHeader */, "Request-Context"],
    requestContextTargetKey: [1 /* eRequestHeaders.requestContextTargetKey */, "appId"],
    requestContextAppIdFormat: [2 /* eRequestHeaders.requestContextAppIdFormat */, "appId=cid-v1:"],
    requestIdHeader: [3 /* eRequestHeaders.requestIdHeader */, "Request-Id"],
    traceParentHeader: [4 /* eRequestHeaders.traceParentHeader */, "traceparent"],
    traceStateHeader: [5 /* eRequestHeaders.traceStateHeader */, "tracestate"],
    sdkContextHeader: [6 /* eRequestHeaders.sdkContextHeader */, "Sdk-Context"],
    sdkContextHeaderAppIdRequest: [7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */, "appId"],
    requestContextHeaderLowerCase: [8 /* eRequestHeaders.requestContextHeaderLowerCase */, "request-context"]
}));
//# sourceMappingURL=RequestResponseHeaders.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/UrlHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var _document = ts_utils_getDocument() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function UrlHelperFuncs_urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance
        tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = UrlHelperFuncs_urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = UrlHelperFuncs_urlParseUrl(url);
    if (a) {
        result = a[_DynamicConstants_DYN_PATHNAME /* @min:%2epathname */];
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort) || InternalConstants_STR_EMPTY;
    if (fullHost) {
        var match = fullHost[_DYN_MATCH /* @min:%2ematch */](/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 3 && ts_utils_isString(match[2]) && match[2][_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            return match[2] + (match[3] || InternalConstants_STR_EMPTY);
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url[_DYN_MATCH /* @min:%2ematch */](/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 2 && ts_utils_isString(match[2]) && match[2][_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
            result = match[2] || InternalConstants_STR_EMPTY;
            if (inclPort && match[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 2) {
                var protocol = (match[1] || InternalConstants_STR_EMPTY)[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                var port = match[3] || InternalConstants_STR_EMPTY;
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = InternalConstants_STR_EMPTY;
                }
                else if (protocol === "https" && port === ":443") {
                    port = InternalConstants_STR_EMPTY;
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/Util.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [
    DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
    "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
    "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
];
var _correlationIdPrefix = "cid-v1:";
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return ts_utils_arrIndexOf(_internalEndpoints, endpointUrl[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]()) !== -1;
}
function correlationIdSetPrefix(prefix) {
    _correlationIdPrefix = prefix;
}
function correlationIdGetPrefix() {
    return _correlationIdPrefix;
}
/**
 * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
 * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
 * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
 * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
 * manually supply domains to include correlation headers on. Else, no headers will be included at all.
 */
function correlationIdCanIncludeCorrelationHeader(config, requestUrl, currentHost) {
    if (!requestUrl || (config && config.disableCorrelationHeaders)) {
        return false;
    }
    if (config && config[_DYN_CORRELATION_HEADER_E8 /* @min:%2ecorrelationHeaderExcludePatterns */]) {
        for (var i = 0; i < config.correlationHeaderExcludePatterns[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
            if (config[_DYN_CORRELATION_HEADER_E8 /* @min:%2ecorrelationHeaderExcludePatterns */][i].test(requestUrl)) {
                return false;
            }
        }
    }
    var requestHost = UrlHelperFuncs_urlParseUrl(requestUrl).host[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    if (requestHost && (ts_utils_strIndexOf(requestHost, ":443") !== -1 || ts_utils_strIndexOf(requestHost, ":80") !== -1)) {
        // [Bug #1260] IE can include the port even for http and https URLs so if present
        // try and parse it to remove if it matches the default protocol port
        requestHost = (urlParseFullHost(requestUrl, true) || "")[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
    }
    if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
        return false;
    }
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        ts_utils_arrForEach(includedDomains, function (domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) {
            return false;
        }
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
        return true;
    }
    for (var i = 0; i < excludedDomains[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) {
            return false;
        }
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0;
}
/**
 * Combines target appId and target role name from response header.
 */
function correlationIdGetCorrelationContext(responseHeader) {
    if (responseHeader) {
        var correlationId = correlationIdGetCorrelationContextValue(responseHeader, RequestHeaders[1]);
        if (correlationId && correlationId !== _correlationIdPrefix) {
            return correlationId;
        }
    }
}
/**
 * Gets key from correlation response header
 */
function correlationIdGetCorrelationContextValue(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[_DYN_SPLIT /* @min:%2esplit */](",");
        for (var i = 0; i < keyValues[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; ++i) {
            var keyValue = keyValues[i][_DYN_SPLIT /* @min:%2esplit */]("=");
            if (keyValue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2 && keyValue[0] === key) {
                return keyValue[1];
            }
        }
    }
}
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[_DYN_LENGTH /* @min:%2elength */] > 0) {
        var parsedUrl = urlParseUrl(absoluteUrl);
        target = parsedUrl[_DYN_HOST /* @min:%2ehost */];
        if (!name) {
            if (parsedUrl[_DYN_PATHNAME /* @min:%2epathname */] != null) {
                var pathName = (parsedUrl.pathname[_DYN_LENGTH /* @min:%2elength */] === 0) ? "/" : parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = dataSanitizeString(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = getPerformance();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return ts_utils_utcNow();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !ts_utils_isNullOrUndefined(start) && !ts_utils_isNullOrUndefined(end)) {
        result = end - start;
    }
    return result;
}
/**
 * Creates a IDistributedTraceContext from an optional telemetryTrace
 * @param telemetryTrace - The telemetryTrace instance that is being wrapped
 * @param parentCtx - An optional parent distributed trace instance, almost always undefined as this scenario is only used in the case of multiple property handlers.
 * @returns A new IDistributedTraceContext instance that is backed by the telemetryTrace or temporary object
 * @deprecated This function is deprecated and will be removed in a future version. Use the createDistributedTraceContext function instead and set the necessary properties
 * on the context object directly.
 */
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
    var traceCtx = createDistributedTraceContext(parentCtx);
    if (telemetryTrace) {
        traceCtx.pageName = telemetryTrace[_DynamicConstants_DYN_NAME /* @min:%2ename */] || traceCtx.pageName || InternalConstants_STR_EMPTY; // The name of the page
        traceCtx[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] = telemetryTrace.traceID || traceCtx[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] || InternalConstants_STR_EMPTY; // 16 byte hex string
        traceCtx[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = telemetryTrace.parentID || traceCtx[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] || InternalConstants_STR_EMPTY; // 8 byte hex string
        traceCtx[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = (!ts_utils_isNullOrUndefined(telemetryTrace[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]) ? telemetryTrace[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] : traceCtx[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]) || 0; // 1 byte hex string
    }
    return traceCtx;
}
//# sourceMappingURL=Util.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-es5/JavaScriptSDK/Telemetry/PageViewManager.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * Factory function to create a PageViewManager instance.
 * @param appInsights - Internal interface to send telemetry
 * @param overridePageViewDuration - Whether to override page view duration
 * @param core - App Insights core instance
 * @param pageViewPerformanceManager - Page view performance manager instance
 * @returns A new IPageViewManager instance.
 * @internal
 */
function createPageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
    var _a;
    var queueTimer = null;
    var itemQueue = [];
    var pageViewPerformanceSent = false;
    var firstPageViewSent = false;
    var _logger;
    if (core) {
        _logger = core.logger;
    }
    function _flushChannels(isAsync) {
        if (core) {
            core.flush(isAsync, function () {
                // Event flushed, callback added to prevent promise creation
            });
        }
    }
    function _startTimer() {
        if (!queueTimer) {
            queueTimer = ts_utils_scheduleTimeout((function () {
                queueTimer = null;
                var allItems = itemQueue.slice(0);
                var doFlush = false;
                itemQueue = [];
                ts_utils_arrForEach(allItems, function (item) {
                    if (!item()) {
                        // Not processed so rescheduled
                        itemQueue.push(item);
                    }
                    else {
                        doFlush = true;
                    }
                });
                if (itemQueue[dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    _startTimer();
                }
                if (doFlush) {
                    // We process at least one item so flush the queue
                    _flushChannels(true);
                }
            }), 100);
        }
    }
    function _addQueue(cb) {
        itemQueue.push(cb);
        _startTimer();
    }
    return _a = {},
        _a[_DYN_TRACK_PAGE_VIEW /* @min:trackPageView */] = function (pageView, customProperties) {
            var name = pageView.name;
            if (ts_utils_isNullOrUndefined(name) || typeof name !== "string") {
                var doc = ts_utils_getDocument();
                name = pageView.name = doc && doc.title || "";
            }
            var uri = pageView.uri;
            if (ts_utils_isNullOrUndefined(uri) || typeof uri !== "string") {
                var location_1 = getLocation();
                uri = pageView.uri = location_1 && location_1[_DYN_HREF /* @min:%2ehref */] || "";
            }
            if (core && core[dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]) {
                uri = pageView.uri = fieldRedaction(pageView.uri, core[dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
            }
            if (!firstPageViewSent) {
                var perf = getPerformance();
                // Access the performance timing object
                var navigationEntries = (perf && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */] && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation"));
                // Edge Case the navigation Entries may return an empty array and the timeOrigin is not supported on IE
                if (navigationEntries && navigationEntries[0] && !ts_utils_isUndefined(perf.timeOrigin)) {
                    // Get the value of loadEventStart
                    var loadEventStart = navigationEntries[0].loadEventStart;
                    pageView[_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] = new Date(perf.timeOrigin + loadEventStart);
                }
                else {
                    // calculate the start time manually
                    var duration_1 = ((customProperties || pageView[_DynamicConstants_DYN_PROPERTIES /* @min:%2eproperties */] || {})[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] || 0);
                    pageView[_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] = new Date(new Date().getTime() - duration_1);
                }
                firstPageViewSent = true;
            }
            // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
            // do not provide the duration, set duration to undefined
            // Also this is case 4
            if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN15 /* @min:%2eisPerformanceTimingSupported */]()) {
                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                _flushChannels(true);
                if (!isWebWorker()) {
                    // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 25 /* _eInternalMessageId.NavigationTimingNotSupported */, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                }
                return;
            }
            var pageViewSent = false;
            var customDuration;
            // if the performance timing is supported by the browser, calculate the custom duration
            var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI16 /* @min:%2egetPerformanceTiming */]()[_DYN_NAVIGATION_START /* @min:%2enavigationStart */];
            if (start > 0) {
                customDuration = dateTimeUtilsDuration(start, +new Date);
                if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT17 /* @min:%2eshouldCollectDuration */](customDuration)) {
                    customDuration = undefined;
                }
            }
            // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
            // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
            var duration;
            if (!ts_utils_isNullOrUndefined(customProperties) &&
                !ts_utils_isNullOrUndefined(customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */])) {
                duration = customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */];
            }
            if (overridePageViewDuration || !isNaN(duration)) {
                if (isNaN(duration)) {
                    // case 3
                    if (!customProperties) {
                        customProperties = {};
                    }
                    customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = customDuration;
                }
                // case 2
                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                _flushChannels(true);
                pageViewSent = true;
            }
            // now try to send the page view performance telemetry
            var maxDurationLimit = 60000;
            if (!customProperties) {
                customProperties = {};
            }
            // Queue the event for processing
            _addQueue(function () {
                var processed = false;
                try {
                    if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN18 /* @min:%2eisPerformanceTimingDataReady */]()) {
                        processed = true;
                        var pageViewPerformance = {
                            name: name,
                            uri: uri
                        };
                        pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](pageViewPerformance);
                        if (!pageViewPerformance.isValid && !pageViewSent) {
                            // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                            // That's the best value we can get that makes sense.
                            customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = customDuration;
                            appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                        }
                        else {
                            if (!pageViewSent) {
                                customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = pageViewPerformance.durationMs;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                            if (!pageViewPerformanceSent) {
                                appInsights[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](pageViewPerformance, customProperties);
                                pageViewPerformanceSent = true;
                            }
                        }
                    }
                    else if (start > 0 && dateTimeUtilsDuration(start, +new Date) > maxDurationLimit) {
                        // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                        // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                        processed = true;
                        if (!pageViewSent) {
                            customProperties[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = maxDurationLimit;
                            appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                        }
                    }
                }
                catch (e) {
                    _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 38 /* _eInternalMessageId.TrackPVFailedCalc */, "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
                return processed;
            });
        },
        _a.teardown = function (unloadCtx, unloadState) {
            if (queueTimer) {
                queueTimer.cancel();
                queueTimer = null;
                var allItems = itemQueue.slice(0);
                itemQueue = [];
                ts_utils_arrForEach(allItems, function (item) {
                    if (item()) {
                        // Item processed successfully
                    }
                });
            }
        },
        _a;
}
//# sourceMappingURL=PageViewManager.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-es5/JavaScriptSDK/Telemetry/PageViewPerformanceManager.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var MAX_DURATION_ALLOWED = 3600000; // 1h
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
    var perf = getPerformance();
    return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
    var perf = getPerformance();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0;
}
function _isPerformanceTimingDataReady() {
    var perf = getPerformance();
    var timing = perf ? perf.timing : 0;
    return timing
        && timing.domainLookupStart > 0
        && timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */] > 0
        && timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */] > 0
        && timing[_DYN_REQUEST_START /* @min:%2erequestStart */] > 0
        && timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */] > 0
        && timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */] > 0
        && timing[_DYN_CONNECT_END /* @min:%2econnectEnd */] > 0
        && timing.domLoading > 0;
}
function _getPerformanceTiming() {
    if (_isPerformanceTimingSupported()) {
        return getPerformance().timing;
    }
    return null;
}
function _getPerformanceNavigationTiming() {
    if (_isPerformanceNavigationTimingSupported()) {
        return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation")[0];
    }
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/
function _shouldCollectDuration() {
    var durations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        durations[_i] = arguments[_i];
    }
    var _navigator = getNavigator() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) {
        for (var i = 0; i < botAgentNames[dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
            isGoogleBot = isGoogleBot || ts_utils_strIndexOf(userAgent.toLowerCase(), botAgentNames[i]) !== -1;
        }
    }
    if (isGoogleBot) {
        // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
        return false;
    }
    else {
        // for other page views, don't report if it's outside of a reasonable range
        for (var i = 0; i < durations[dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
            if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Factory function to create a PageViewPerformanceManager instance.
 * @param core - App Insights core instance
 * @returns A new IPageViewPerformanceManager instance.
 * @internal
 */
function createPageViewPerformanceManager(core) {
    var _a;
    var _logger = safeGetLogger(core);
    return _a = {},
        _a[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:populatePageViewPerformanceEvent */] = function (pageViewPerformance) {
            pageViewPerformance.isValid = false;
            /*
             * http://www.w3.org/TR/navigation-timing/#processing-model
             *  |-navigationStart
             *  |             |-connectEnd
             *  |             ||-requestStart
             *  |             ||             |-responseStart
             *  |             ||             |              |-responseEnd
             *  |             ||             |              |
             *  |             ||             |              |         |-loadEventEnd
             *  |---network---||---request---|---response---|---dom---|
             *  |--------------------------total----------------------|
             *
             *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
             *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
             *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
             *  response = Response time
             *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
             *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
             *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
             */
            var navigationTiming = _getPerformanceNavigationTiming();
            var timing = _getPerformanceTiming();
            var total = 0;
            var network = 0;
            var request = 0;
            var response = 0;
            var dom = 0;
            if (navigationTiming || timing) {
                if (navigationTiming) {
                    total = navigationTiming[_DynamicConstants_DYN_DURATION /* @min:%2eduration */];
                    /**
                     * support both cases:
                     * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                     * - for older browsers where the startTime is not zero
                     */
                    network = navigationTiming[_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] === 0 ? navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */] : dateTimeUtilsDuration(navigationTiming[_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */], navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                    request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                    response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */], navigationTiming[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                    dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                }
                else {
                    total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                    request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                    response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */], timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                    dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                }
                if (total === 0) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 10 /* _eInternalMessageId.ErrorPVCalc */, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
                }
                else if (!_shouldCollectDuration(total, network, request, response, dom)) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 45 /* _eInternalMessageId.InvalidDurationValue */, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
                }
                else if (total < mathFloor(network) + mathFloor(request) + mathFloor(response) + mathFloor(dom)) {
                    // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                    // in this case, don't report client performance from this page
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 8 /* _eInternalMessageId.ClientPerformanceMathError */, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
                }
                else {
                    pageViewPerformance.durationMs = total;
                    // // convert to timespans
                    pageViewPerformance.perfTotal = pageViewPerformance[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(total);
                    pageViewPerformance.networkConnect = msToTimeSpan(network);
                    pageViewPerformance.sentRequest = msToTimeSpan(request);
                    pageViewPerformance.receivedResponse = msToTimeSpan(response);
                    pageViewPerformance.domProcessing = msToTimeSpan(dom);
                    pageViewPerformance.isValid = true;
                }
            }
        },
        _a[_DYN_GET_PERFORMANCE_TIMI16 /* @min:getPerformanceTiming */] = _getPerformanceTiming,
        _a[_DYN_IS_PERFORMANCE_TIMIN15 /* @min:isPerformanceTimingSupported */] = _isPerformanceTimingSupported,
        _a[_DYN_IS_PERFORMANCE_TIMIN18 /* @min:isPerformanceTimingDataReady */] = _isPerformanceTimingDataReady,
        _a[_DYN_SHOULD_COLLECT_DURAT17 /* @min:shouldCollectDuration */] = _shouldCollectDuration,
        _a;
}
//# sourceMappingURL=PageViewPerformanceManager.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-es5/JavaScriptSDK/Telemetry/PageVisitTimeManager.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




/**
 * Factory function to create a page visit data object
 * @param pageName - Name of the page
 * @param pageUrl - URL of the page
 * @returns IPageVisitData instance
 */
function createPageVisitData(pageName, pageUrl) {
    var _a;
    return _a = {
            pageVisitStartTime: ts_utils_utcNow(),
            pageName: pageName,
            pageUrl: pageUrl
        },
        _a[_DYN_PAGE_VISIT_TIME /* @min:pageVisitTime */] = 0,
        _a;
}
/**
 * Factory function to create a PageVisitTimeManager instance.
 * @param logger - Diagnostic logger
 * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
 * @returns A new IPageVisitTimeManager instance.
 * @internal
 */
function createPageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
    var _a;
    var prevPageVisitDataKeyName = "prevPageVisitData";
    /**
     * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
     * @param pageName - Name of page to begin timing visit duration
     * @returns {IPageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
     */
    function restartPageVisitTimer(pageName, pageUrl) {
        var prevPageVisitData = null;
        try {
            prevPageVisitData = stopPageVisitTimer();
            if (utlCanUseSessionStorage()) {
                if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
                    throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                }
                var currPageVisitDataStr = EnvUtils_getJSON().stringify(createPageVisitData(pageName, pageUrl));
                utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
            }
        }
        catch (e) {
            _warnToConsole(logger, "Call to restart failed: " + ts_utils_dumpObj(e));
            prevPageVisitData = null;
        }
        return prevPageVisitData;
    }
    /**
     * Stops timing of current page, if exists.
     * @returns {IPageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
     */
    function stopPageVisitTimer() {
        var prevPageVisitData = null;
        try {
            if (utlCanUseSessionStorage()) {
                // Define end time of page's visit
                var pageVisitEndTime = ts_utils_utcNow();
                // Try to retrieve  page name and start time from session storage
                var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
                if (pageVisitDataJsonStr && hasJSON()) {
                    // if previous page data exists, set end time of visit
                    prevPageVisitData = EnvUtils_getJSON().parse(pageVisitDataJsonStr);
                    prevPageVisitData[_DYN_PAGE_VISIT_TIME /* @min:%2epageVisitTime */] = pageVisitEndTime - prevPageVisitData.pageVisitStartTime;
                    // Remove data from storage since we already used it
                    utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
                }
            }
        }
        catch (e) {
            _warnToConsole(logger, "Stop page visit timer failed: " + ts_utils_dumpObj(e));
            prevPageVisitData = null;
        }
        return prevPageVisitData;
    }
    return _a = {},
        _a[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:trackPreviousPageVisit */] = function (currentPageName, currentPageUrl) {
            try {
                // Restart timer for new page view
                var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                // If there was a page already being timed, track the visit time for it now.
                if (prevPageVisitTimeData) {
                    pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData[_DYN_PAGE_VISIT_TIME /* @min:%2epageVisitTime */]);
                }
            }
            catch (e) {
                _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + ts_utils_dumpObj(e));
            }
        },
        // Expose for backward compatibility with tests
        _a._logger = logger,
        _a.pageVisitTimeTrackingHandler = pageVisitTimeTrackingHandler,
        _a;
}
//# sourceMappingURL=PageVisitTimeManager.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-es5/JavaScriptSDK/Timing.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Factory function to create a Timing instance.
 * @param logger - Diagnostic logger
 * @param name - Name identifier for timing operations
 * @returns A new ITiming instance.
 * @internal
 */
function createTiming(logger, name) {
    var _events = {};
    var timing = {
        action: null,
        start: function (name) {
            if (typeof _events[name] !== "undefined") {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        },
        stop: function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = dateTimeUtilsDuration(start, end);
                timing.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        }
    };
    return timing;
}
//# sourceMappingURL=Timing.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-analytics-js/dist-es5/JavaScriptSDK/AnalyticsPlugin.js
/*
 * Application Insights JavaScript SDK - Web Analytics, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/
var AnalyticsPlugin_a;









var strEvent = "event";
function _dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
    }
}
function _getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!ts_utils_isString(reason) && ts_utils_isFunction(reason[dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */])) {
            return reason[dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
        }
        return ts_utils_dumpObj(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var MinMilliSeconds = 60000;
var AnalyticsPlugin_defaultValues = ts_utils_objDeepFreeze((AnalyticsPlugin_a = {
        sessionRenewalMs: cfgDfSet(_chkConfigMilliseconds, 30 * 60 * 1000),
        sessionExpirationMs: cfgDfSet(_chkConfigMilliseconds, 24 * 60 * 60 * 1000),
        disableExceptionTracking: cfgDfBoolean()
    },
    AnalyticsPlugin_a[_DYN_AUTO_TRACK_PAGE_VISI10 /* @min:autoTrackPageVisitTime */] = cfgDfBoolean(),
    AnalyticsPlugin_a[_DYN_OVERRIDE_PAGE_VIEW_D8 /* @min:overridePageViewDuration */] = cfgDfBoolean(),
    AnalyticsPlugin_a[_DYN_ENABLE_UNHANDLED_PRO13 /* @min:enableUnhandledPromiseRejectionTracking */] = cfgDfBoolean(),
    AnalyticsPlugin_a[_DYN_AUTO_UNHANDLED_PROMI14 /* @min:autoUnhandledPromiseInstrumented */] = false,
    AnalyticsPlugin_a.samplingPercentage = cfgDfValidate(_chkSampling, 100),
    AnalyticsPlugin_a[_DYN_IS_STORAGE_USE_DISAB0 /* @min:isStorageUseDisabled */] = cfgDfBoolean(),
    AnalyticsPlugin_a[_DYN_IS_BROWSER_LINK_TRAC11 /* @min:isBrowserLinkTrackingEnabled */] = cfgDfBoolean(),
    AnalyticsPlugin_a[_DYN_ENABLE_AUTO_ROUTE_TR12 /* @min:enableAutoRouteTracking */] = cfgDfBoolean(),
    AnalyticsPlugin_a.namePrefix = cfgDfString(),
    AnalyticsPlugin_a.enableDebug = cfgDfBoolean(),
    AnalyticsPlugin_a.disableFlushOnBeforeUnload = cfgDfBoolean(),
    AnalyticsPlugin_a.disableFlushOnUnload = cfgDfBoolean(false, "disableFlushOnBeforeUnload"),
    AnalyticsPlugin_a.expCfg = cfgDfMerge({ inclScripts: false, expLog: undefined, maxLogs: 50 }),
    AnalyticsPlugin_a.routeTraceStrategy = 0 /* eRouteTraceStrategy.Server */,
    AnalyticsPlugin_a));
function _chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < MinMilliSeconds) {
        value = MinMilliSeconds;
    }
    return +value;
}
function _chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function _updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!ts_utils_isUndefined(extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */])) {
        if (extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */]) {
            utlDisableStorage();
        }
        else {
            utlEnableStorage();
        }
    }
}
var AnalyticsPlugin = /** @class */ (function (_super) {
    __extendsFn(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = AnalyticsPluginIdentifier; // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        var _expCfg;
        // New configuration variables for trace context management
        var _routeTraceStrategy;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        // For testing error hooks only
        var _errorHookCnt;
        dynamicProto(AnalyticsPlugin, _this, function (_self, _base) {
            var _addHook = _base[_DYN__ADD_HOOK /* @min:%2e_addHook */];
            _initDefaults();
            _self.getCookieMgr = function () {
                return safeGetCookieMgr(_self[_DYN_CORE /* @min:%2ecore */]);
            };
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function (event, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(event, EventDataType, EventEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param name - A string that identifies this event uniquely within the document.
             */
            _self.startTrackEvent = function (name) {
                try {
                    _eventTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 29 /* _eInternalMessageId.StartTrackEventFailed */, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param name - The string you used to identify this event in `startTrackEvent`.
             * @param properties - map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param measurements - map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackEvent = function (name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 30 /* _eInternalMessageId.StopTrackEventFailed */, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace - the trace message
             * @param customProperties - Additional custom properties to include in the event
             */
            _self.trackTrace = function (trace, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(trace, TraceDataType, TraceEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             */
            _self.trackMetric = function (metric, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(metric, MetricDataType, MetricEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 36 /* _eInternalMessageId.TrackMetricFailed */, "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]) {
                        inPv.uri = fieldRedaction(inPv.uri, _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
                    }
                    _pageViewManager[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](inPv.name, inPv.uri);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */
            _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */] = function (pageView, properties, systemProperties) {
                var doc = ts_utils_getDocument();
                if (doc) {
                    pageView[_DYN_REF_URI /* @min:%2erefUri */] = pageView[_DYN_REF_URI /* @min:%2erefUri */] === undefined ? doc.referrer : pageView[_DYN_REF_URI /* @min:%2erefUri */];
                }
                if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]) {
                    pageView.refUri = fieldRedaction(pageView.refUri, _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
                }
                if (ts_utils_isNullOrUndefined(pageView[_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */])) {
                    // calculate the start time manually
                    var duration = ((properties || pageView[_DynamicConstants_DYN_PROPERTIES /* @min:%2eproperties */] || {})[_DynamicConstants_DYN_DURATION /* @min:%2eduration */] || 0);
                    pageView[_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] = new Date(new Date().getTime() - duration);
                }
                var telemetryItem = createTelemetryItem(pageView, PageViewDataType, PageViewEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                // reset ajaxes counter
                _resetAjaxAttempts();
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */
            _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */] = function (pageViewPerformance, properties, systemProperties) {
                var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformanceDataType, PageViewPerformanceEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */
            _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](inPvp);
                    _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](inPvp, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */
            _self.startTrackPage = function (name) {
                try {
                    if (typeof name !== "string") {
                        var doc = ts_utils_getDocument();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 31 /* _eInternalMessageId.StartTrackFailed */, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param name - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param url - String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param properties - map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param measurements - map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackPage = function (name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = ts_utils_getDocument();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = getLocation();
                        url = loc && loc[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]) {
                        url = fieldRedaction(url, _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](name, url);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 32 /* _eInternalMessageId.StopTrackFailed */, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */
            _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */] = function (exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = (exception && (exception.exception || exception[_DYN_ERROR /* @min:%2eerror */])) ||
                    // - Handle someone calling trackException based of v1 API where the exception was the Error
                    ts_utils_isError(exception) && exception ||
                    // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                    //   is preserved and does not list ApplicationInsights code as the source
                    { name: (exception && typeof exception), message: exception || strNotSpecified };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new Exception(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), theError, exception[_DynamicConstants_DYN_PROPERTIES /* @min:%2eproperties */] || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var doc = ts_utils_getDocument();
                if (doc && (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.inclScripts)) {
                    var scriptsInfo = findAllScripts(doc);
                    exceptionPartB[_DynamicConstants_DYN_PROPERTIES /* @min:%2eproperties */]["exceptionScripts"] = JSON.stringify(scriptsInfo);
                }
                if (_expCfg === null || _expCfg === void 0 ? void 0 : _expCfg.expLog) {
                    var logs = _expCfg.expLog();
                    if (logs && logs.logs && ts_utils_isArray(logs.logs)) {
                        exceptionPartB[_DynamicConstants_DYN_PROPERTIES /* @min:%2eproperties */]["exceptionLog"] = logs.logs.slice(0, _expCfg.maxLogs).join("\n");
                    }
                }
                var telemetryItem = createTelemetryItem(exceptionPartB, ExceptionDataType, ExceptionEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), customProperties, systemProperties);
                _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             */
            _self.trackException = function (exception, customProperties) {
                if (exception && !exception.exception && exception[_DYN_ERROR /* @min:%2eerror */]) {
                    exception.exception = exception[_DYN_ERROR /* @min:%2eerror */];
                }
                try {
                    _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */](exception, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 35 /* _eInternalMessageId.TrackExceptionFailed */, "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             */
            _self._onerror = function (exception) {
                var error = exception && exception[_DYN_ERROR /* @min:%2eerror */];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = getWindow();
                        if (_window) {
                            evt = _window[strEvent];
                        }
                    }
                    var url = (exception && exception.url) || (ts_utils_getDocument() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception.errorSrc || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0,
                        columnNumber: exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0,
                        message: exception.message
                    };
                    if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR /* @min:%2eerror */])) {
                        _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0, exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0, error, evt, null, errorSrc), properties);
                    }
                    else {
                        if (!exception.errorSrc) {
                            exception.errorSrc = errorSrc;
                        }
                        _self.trackException({ exception: exception, severityLevel: 3 /* eSeverityLevel.Error */ }, properties);
                    }
                }
                catch (e) {
                    var errorString = error ? (error.name + ", " + error.message) : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 11 /* _eInternalMessageId.ExceptionWhileLoggingError */, "_onError threw exception while logging error, error will not be collected: "
                        + getExceptionName(e), { exception: ts_utils_dumpObj(e), errorString: errorString });
                }
            };
            _self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */] = function (telemetryInitializer) {
                if (_self[_DYN_CORE /* @min:%2ecore */]) {
                    // Just add to the core
                    return _self[_DYN_CORE /* @min:%2ecore */][_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](telemetryInitializer);
                }
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) {
                    _preInitTelemetryInitializers = [];
                }
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    return;
                }
                if (ts_utils_isNullOrUndefined(core)) {
                    throwError("Error initializing");
                }
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = mergeEvtNamespace(DataCacheHelper_createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        ts_utils_arrForEach(_preInitTelemetryInitializers, function (initializer) {
                            core[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = createPageViewPerformanceManager(_self[_DYN_CORE /* @min:%2ecore */]);
                    _pageViewManager = createPageViewManager(_self, _extConfig.overridePageViewDuration, _self[_DYN_CORE /* @min:%2ecore */], _pageViewPerformanceManager);
                    _pageVisitTimeManager = createPageVisitTimeManager(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                    _eventTracking = createTiming(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), "trackEvent");
                    _eventTracking.action =
                        function (name, url, duration, properties, measurements) {
                            if (!properties) {
                                properties = {};
                            }
                            if (!measurements) {
                                measurements = {};
                            }
                            properties.duration = duration[dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
                            _self.trackEvent({ name: name, properties: properties, measurements: measurements });
                        };
                    // initialize page view timing
                    _pageTracking = createTiming(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), "trackPageView");
                    _pageTracking.action = function (name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if (ts_utils_isNullOrUndefined(properties)) {
                            properties = {};
                        }
                        properties.duration = duration[dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageViewItem, properties);
                    };
                    if (hasWindow()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                }
                catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                eventOff(window, null, null, _evtNamespace);
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_errorHookCnt, _autoExceptionInstrumented];
            };
            function _resetAjaxAttempts() {
                // Reset ajax attempts counter for the new page view
                if (_self[_DYN_CORE /* @min:%2ecore */]) {
                    var ajaxPlugin = _self[_DYN_CORE /* @min:%2ecore */].getPlugin("AjaxDependencyPlugin");
                    if (ajaxPlugin && ajaxPlugin.plugin && ajaxPlugin.plugin.resetAjaxAttempts) {
                        ajaxPlugin.plugin.resetAjaxAttempts();
                    }
                }
            }
            function _populateDefaults(config) {
                // it is used for 1DS as well, so config type should be IConfiguration only
                var identifier = _self.identifier;
                var core = _self[_DYN_CORE /* @min:%2ecore */];
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, AnalyticsPlugin_defaultValues);
                    // make sure auto exception is instrumented only once and it won't be overriden by the following config changes
                    _autoExceptionInstrumented = _autoExceptionInstrumented || config[_DYN_AUTO_EXCEPTION_INSTR9 /* @min:%2eautoExceptionInstrumented */] || _extConfig[_DYN_AUTO_EXCEPTION_INSTR9 /* @min:%2eautoExceptionInstrumented */];
                    _expCfg = _extConfig.expCfg;
                    _autoTrackPageVisitTime = _extConfig[_DYN_AUTO_TRACK_PAGE_VISI10 /* @min:%2eautoTrackPageVisitTime */];
                    // Initialize new trace context configuration options
                    _routeTraceStrategy = _extConfig.routeTraceStrategy || 0 /* eRouteTraceStrategy.Server */;
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[_DYN_IS_BROWSER_LINK_TRAC11 /* @min:%2eisBrowserLinkTrackingEnabled */];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param pageName - Name of page
             * @param pageVisitDuration - Duration of visit to the page in milliseconds
             */
            function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = { PageName: pageName, PageUrl: pageUrl };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
                    var dropBrowserLinkRequests = function (envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyDataType) {
                            var remoteData = envelope.baseData;
                            if (remoteData) {
                                for (var i = 0; i < browserLinkPaths_1[dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
                                    if (remoteData.target && ts_utils_strIndexOf(remoteData.target, browserLinkPaths_1[i]) >= 0) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    };
                    _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](_self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = createTelemetryItem(exception, ExceptionDataType, ExceptionEnvelopeType, _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), properties);
                _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = getWindow();
                var locn = getLocation(true);
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig[_DYN_AUTO_EXCEPTION_INSTR9 /* @min:%2eautoExceptionInstrumented */]) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) {
                                    _self._onerror(Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](message, url, lineNumber, columnNumber, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _errorHookCnt++;
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = getWindow();
                var locn = getLocation(true);
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableAutoRouteTracking = _extConfig[_DYN_ENABLE_AUTO_ROUTE_TR12 /* @min:%2eenableAutoRouteTracking */] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */
                    if (win && _enableAutoRouteTracking && !_historyListenerAdded && hasHistory()) {
                        var _history = getHistory();
                        if (ts_utils_isFunction(_history.pushState) && ts_utils_isFunction(_history.replaceState) && typeof Event !== Constants_strShimUndefined) {
                            _addHistoryListener(win, _history, locn);
                        }
                    }
                }));
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */
            function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) {
                    return;
                }
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) {
                        _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                    }
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    else {
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]) {
                        _currUri = fieldRedaction(_currUri, _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
                    }
                    if (_enableAutoRouteTracking) {
                        // TODO(OTelSpan) (create new "context") / spans for the new page view
                        // Should "end" any previous span (once we have a new one)
                        var newContext = void 0;
                        // Quick and dirty backward compatibility check -- should never be needed but here to avoid a JS exception
                        if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]) {
                            var currentContext = _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false); // Get current context without creating new
                            if (currentContext && _routeTraceStrategy === 1 /* eRouteTraceStrategy.Page */) {
                                // Create new context with the determined parent
                                newContext = createDistributedTraceContext(currentContext);
                            }
                            else {
                                // Fall back to original behavior - use server context as parent
                                newContext = _self[_DYN_CORE /* @min:%2ecore */][_DynamicConstants_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](true);
                            }
                            // Always generate new trace ID for route changes (this also generates new span ID)
                            newContext.traceId = generateW3CId();
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            newContext.pageName = DataSanitizer_dataSanitizeString(_self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), newContext.pageName || "_unknown_");
                            _self[_DYN_CORE /* @min:%2ecore */].setTraceCtx(newContext);
                        }
                        // Single page view tracking call for all scenarios
                        ts_utils_scheduleTimeout((function (uri) {
                            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */]({ refUri: uri, properties: { duration: 0 } });
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook(InstrumentEvent(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook(InstrumentEvent(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[_DYN__ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[_DYN_ENABLE_UNHANDLED_PRO13 /* @min:%2eenableUnhandledPromiseRejectionTracking */] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[_DYN_AUTO_UNHANDLED_PROMI14 /* @min:%2eautoUnhandledPromiseInstrumented */];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) { // handled could be typeof function
                                    _self._onerror(Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](_getReason(error), _location ? _location[_DYN_HREF /* @min:%2ehref */] : "", 0, 0, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _errorHookCnt++;
                        _extConfig[_DYN_AUTO_UNHANDLED_PROMI14 /* @min:%2eautoUnhandledPromiseInstrumented */] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - The severity of the log message
             * @param msgId - The log message.
             */
            function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // Reset ajax attempts counter
                _resetAjaxAttempts();
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = getLocation(true);
                _prevUri = location && location[_DYN_HREF /* @min:%2ehref */] || "";
                if (_self[_DYN_CORE /* @min:%2ecore */] && _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]) {
                    _prevUri = fieldRedaction(_prevUri, _self[_DYN_CORE /* @min:%2ecore */][dist_es5_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]);
                }
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                _errorHookCnt = 0;
                // Define _self.config
                ts_utils_objDefine(_self, "config", {
                    g: function () { return _extConfig; }
                });
            }
            // For backward compatibility
            ts_utils_objDefine(_self, "_pageViewManager", { g: function () { return _pageViewManager; } });
            ts_utils_objDefine(_self, "_pageViewPerformanceManager", { g: function () { return _pageViewPerformanceManager; } });
            ts_utils_objDefine(_self, "_pageVisitTimeManager", { g: function () { return _pageVisitTimeManager; } });
            ts_utils_objDefine(_self, "_evtNamespace", { g: function () { return "." + _evtNamespace; } });
        });
        return _this;
    }
// Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
// Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
// Removed Stub for AnalyticsPlugin.prototype.trackEvent.
// Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.trackTrace.
// Removed Stub for AnalyticsPlugin.prototype.trackMetric.
// Removed Stub for AnalyticsPlugin.prototype.trackPageView.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
// Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackException.
// Removed Stub for AnalyticsPlugin.prototype._onerror.
// Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
// Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = '3.4.1'; // Not currently used anywhere
    return AnalyticsPlugin;
}(BaseTelemetryPlugin));

//# sourceMappingURL=AnalyticsPlugin.js.map
;// CONCATENATED MODULE: ./node_modules/@nevware21/ts-async/dist/es5/mod/ts-async.js
/* provided dependency */ var ts_async_process = __webpack_require__(34155);
/*!
 * NevWare21 Solutions LLC - ts-async, 0.5.5
 * https://github.com/nevware21/ts-async
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */


var STR_PROMISE = "Promise";
var DONE = "done";
var VALUE = "value";
var RETURN = "return";
var REJECTED = "rejected";

function doAwaitResponse(value, cb) {
    return doAwait(value, function (value) {
        return cb ? cb({
            status: "fulfilled",
            rejected: false,
            value: value
        }) : value;
    }, function (reason) {
        return cb ? cb({
            status: REJECTED,
            rejected: true,
            reason: reason
        }) : reason;
    });
}
function doAwait(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    try {
        if (ts_utils_isPromiseLike(value)) {
            if (resolveFn || rejectFn) {
                result = value.then(resolveFn, rejectFn);
            }
        }
        else {
            try {
                if (resolveFn) {
                    result = resolveFn(value);
                }
            }
            catch (err) {
                if (rejectFn) {
                    result = rejectFn(err);
                }
                else {
                    throw err;
                }
            }
        }
    }
    finally {
        if (finallyFn) {
            doFinally(result, finallyFn);
        }
    }
    return result;
}
function doFinally(value, finallyFn) {
    var result = value;
    if (finallyFn) {
        if (ts_utils_isPromiseLike(value)) {
            if (value.finally) {
                result = value.finally(finallyFn);
            }
            else {
                result = value.then(function (value) {
                    finallyFn();
                    return value;
                }, function (reason) {
                    finallyFn();
                    throw reason;
                });
            }
        }
        else {
            finallyFn();
        }
    }
    return result;
}

/*#__NO_SIDE_EFFECTS__*/
function ts_async_pureAssign(func1, func2) {
    return func1 || func2;
}

var _debugState;
var _debugResult;
var _debugHandled;
var _promiseDebugEnabled = false;
function _addDebugState$1(thePromise, stateFn, resultFn, handledFn) {
    _debugState = _debugState || { toString: function () { return "[[PromiseState]]"; } };
    _debugResult = _debugResult || { toString: function () { return "[[PromiseResult]]"; } };
    _debugHandled = _debugHandled || { toString: function () { return "[[PromiseIsHandled]]"; } };
    var props = {};
    props[_debugState] = { get: stateFn };
    props[_debugResult] = { get: resultFn };
    props[_debugHandled] = { get: handledFn };
    objDefineProperties(thePromise, props);
}
function setPromiseDebugState(enabled, logger) {
    _promiseDebugEnabled = enabled;
}

var STRING_STATES = [
    "pending", "resolving", "resolved", REJECTED
];

var DISPATCH_EVENT = "dispatchEvent";
var _hasInitEvent;
function _hasInitEventFn(doc) {
    var evt;
    if (doc && doc.createEvent) {
        evt = doc.createEvent("Event");
    }
    return (!!evt && evt.initEvent);
}
function emitEvent(target, evtName, populateEvent, useNewEvent) {
    var doc = ts_utils_getDocument();
    !_hasInitEvent && (_hasInitEvent = ts_utils_createCachedValue(!!ts_utils_safe(_hasInitEventFn, [doc]).v));
    var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : (useNewEvent ? new Event(evtName) : {});
    populateEvent && populateEvent(theEvt);
    if (_hasInitEvent.v) {
        theEvt.initEvent(evtName, false, true);
    }
    if (theEvt && target[DISPATCH_EVENT]) {
        target[DISPATCH_EVENT](theEvt);
    }
    else {
        var handler = target["on" + evtName];
        if (handler) {
            handler(theEvt);
        }
        else {
            var theConsole = ts_utils_getInst("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, ts_utils_dumpObj(theEvt));
        }
    }
}

var NODE_UNHANDLED_REJECTION = "unhandledRejection";
var UNHANDLED_REJECTION = NODE_UNHANDLED_REJECTION.toLowerCase();
var _currentPromiseId = [];
var _uniquePromiseId = 0;
var _unhandledRejectionTimeout = 10;
var _aggregationError;
var _hasPromiseRejectionEvent;
function dumpFnObj(value) {
    if (ts_utils_isFunction(value)) {
        return value.toString();
    }
    return ts_utils_dumpObj(value);
}
/*#__NO_SIDE_EFFECTS__*/
function _createAggregationError(values) {
    !_aggregationError && (_aggregationError = createCachedValue(safe(getInst, ["AggregationError"]).v || createCustomError("AggregationError", function (self, args) {
        self.errors = args[0];
    })));
    return new _aggregationError.v(values);
}
function _createPromise(newPromise, processor, executor) {
    var additionalArgs = ts_utils_arrSlice(arguments, 3);
    var _state = 0 ;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _id = _uniquePromiseId++;
    var _parentId = _currentPromiseId.length > 0 ? _currentPromiseId[_currentPromiseId.length - 1] : undefined;
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    function _then(onResolved, onRejected) {
        try {
            _currentPromiseId.push(_id);
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            var thenPromise = newPromise(function (resolve, reject) {
                _queue.push(function () {
                    try {
                        var handler = _state === 2  ? onResolved : onRejected;
                        var value = ts_utils_isUndefined(handler) ? _settledValue : (ts_utils_isFunction(handler) ? handler(_settledValue) : handler);
                        if (ts_utils_isPromiseLike(value)) {
                            value.then(resolve, reject);
                        }
                        else if (handler) {
                            resolve(value);
                        }
                        else if (_state === 3 ) {
                            reject(value);
                        }
                        else {
                            resolve(value);
                        }
                    }
                    catch (e) {
                        reject(e);
                    }
                });
                if (_hasResolved) {
                    _processQueue();
                }
            }, additionalArgs);
            return thenPromise;
        }
        finally {
            _currentPromiseId.pop();
        }
    }
    function _catch(onRejected) {
        return _then(undefined, onRejected);
    }
    function _finally(onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if (ts_utils_isFunction(onFinally)) {
            thenFinally = function (value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function (reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    }
    function _strState() {
        return STRING_STATES[_state];
    }
    function _processQueue() {
        if (_queue.length > 0) {
            var pending = _queue.slice();
            _queue = [];
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            processor(pending);
        }
    }
    function _createSettleIfFn(newState, allowState) {
        return function (theValue) {
            if (_state === allowState) {
                if (newState === 2  && ts_utils_isPromiseLike(theValue)) {
                    _state = 1 ;
                    theValue.then(_createSettleIfFn(2 , 1 ), _createSettleIfFn(3 , 1 ));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                _processQueue();
                if (!_handled && newState === 3  && !_unHandledRejectionHandler) {
                    _unHandledRejectionHandler = ts_utils_scheduleTimeout(_notifyUnhandledRejection, _unhandledRejectionTimeout);
                }
            }
        };
    }
    function _notifyUnhandledRejection() {
        if (!_handled) {
            _handled = true;
            if (isNode()) {
                ts_async_process.emit(NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            }
            else {
                var gbl = getWindow() || getGlobal();
                !_hasPromiseRejectionEvent && (_hasPromiseRejectionEvent = ts_utils_createCachedValue(ts_utils_safe((ts_utils_getInst), [STR_PROMISE + "RejectionEvent"]).v));
                emitEvent(gbl, UNHANDLED_REJECTION, function (theEvt) {
                    ts_utils_objDefine(theEvt, "promise", { g: function () { return _thePromise; } });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!_hasPromiseRejectionEvent.v);
            }
        }
    }
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    ts_utils_objDefineProp(_thePromise, "state", {
        get: _strState
    });
    if (_promiseDebugEnabled) {
        _addDebugState$1(_thePromise, _strState, function () { return objToString(_settledValue); }, function () { return _handled; });
    }
    if (hasSymbol()) {
        _thePromise[ts_utils_getKnownSymbol(11 )] = "IPromise";
    }
    function _toString() {
        return "IPromise" + (_promiseDebugEnabled ? "[" + _id + (!ts_utils_isUndefined(_parentId) ? (":" + _parentId) : "") + "]" : "") + " " + _strState() + (_hasResolved ? (" - " + dumpFnObj(_settledValue)) : "") + ("");
    }
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!ts_utils_isFunction(executor)) {
            ts_utils_throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpFnObj(executor));
        }
        var _rejectFn = _createSettleIfFn(3 , 0 );
        try {
            executor.call(_thePromise, _createSettleIfFn(2 , 0 ), _rejectFn);
        }
        catch (e) {
            _rejectFn(e);
        }
    })();
    return _thePromise;
}
/*#__NO_SIDE_EFFECTS__*/
function _createAllPromise(newPromise) {
    return function (input) {
        var additionalArgs = ts_utils_arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1;
                ts_utils_iterForOf(input, function (item, idx) {
                    if (item) {
                        pending_1++;
                        doAwait(item, function (value) {
                            values_1[idx] = value;
                            if (--pending_1 === 0) {
                                resolve(values_1);
                            }
                        }, reject);
                    }
                });
                pending_1--;
                if (pending_1 === 0) {
                    resolve(values_1);
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _createResolvedPromise(newPromise) {
    return function (value) {
        var additionalArgs = arrSlice(arguments, 1);
        if (isPromiseLike(value)) {
            return value;
        }
        return newPromise(function (resolve) {
            resolve(value);
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _createRejectedPromise(newPromise) {
    return function (reason) {
        var additionalArgs = arrSlice(arguments, 1);
        return newPromise(function (_resolve, reject) {
            reject(reason);
        }, additionalArgs);
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _createAllSettledPromise(newPromise) {
    return ts_utils_createCachedValue(function (input) {
        var additionalArgs = ts_utils_arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            var values = [];
            var pending = 1;
            function processItem(item, idx) {
                pending++;
                doAwaitResponse(item, function (value) {
                    if (value.rejected) {
                        values[idx] = {
                            status: REJECTED,
                            reason: value.reason
                        };
                    }
                    else {
                        values[idx] = {
                            status: "fulfilled",
                            value: value.value
                        };
                    }
                    if (--pending === 0) {
                        resolve(values);
                    }
                });
            }
            try {
                if (ts_utils_isArray(input)) {
                    ts_utils_arrForEach(input, processItem);
                }
                else if (ts_utils_isIterable(input)) {
                    ts_utils_iterForOf(input, processItem);
                }
                else {
                    ts_utils_throwTypeError("Input is not an iterable");
                }
                pending--;
                if (pending === 0) {
                    resolve(values);
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
/*#__NO_SIDE_EFFECTS__*/
function _createRacePromise(newPromise) {
    return createCachedValue(function (input) {
        var additionalArgs = arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            var isDone = false;
            function processItem(item) {
                doAwaitResponse(item, function (value) {
                    if (!isDone) {
                        isDone = true;
                        if (value.rejected) {
                            reject(value.reason);
                        }
                        else {
                            resolve(value.value);
                        }
                    }
                });
            }
            try {
                if (isArray(input)) {
                    arrForEach(input, processItem);
                }
                else if (isIterable(input)) {
                    iterForOf(input, processItem);
                }
                else {
                    throwTypeError("Input is not an iterable");
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}
/*#__NO_SIDE_EFFECTS__*/
function _createAnyPromise(newPromise) {
    return createCachedValue(function (input) {
        var additionalArgs = arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            var theErros = [];
            var pending = 1;
            var isDone = false;
            function processItem(item, idx) {
                pending++;
                doAwaitResponse(item, function (value) {
                    if (!value.rejected) {
                        isDone = true;
                        resolve(value.value);
                        return;
                    }
                    else {
                        theErros[idx] = value.reason;
                    }
                    if (--pending === 0 && !isDone) {
                        reject(_createAggregationError(theErros));
                    }
                });
            }
            try {
                if (isArray(input)) {
                    arrForEach(input, processItem);
                }
                else if (isIterable(input)) {
                    iterForOf(input, processItem);
                }
                else {
                    throwTypeError("Input is not an iterable");
                }
                pending--;
                if (pending === 0 && !isDone) {
                    reject(_createAggregationError(theErros));
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    });
}

function syncItemProcessor(pending) {
    ts_utils_arrForEach(pending, function (fn) {
        try {
            fn();
        }
        catch (e) {
        }
    });
}
function timeoutItemProcessor(timeout) {
    var callbackTimeout = ts_utils_isNumber(timeout) ? timeout : 0;
    return function (pending) {
        ts_utils_scheduleTimeout(function () {
            syncItemProcessor(pending);
        }, callbackTimeout);
    };
}
function idleItemProcessor(timeout) {
    var options;
    if (timeout >= 0) {
        options = {
            timeout: +timeout
        };
    }
    return function (pending) {
        scheduleIdleCallback(function (deadline) {
            syncItemProcessor(pending);
        }, options);
    };
}

var _allAsyncSettledCreator;
var _raceAsyncCreator;
var _anyAsyncCreator;
function createAsyncPromise(executor, timeout) {
    return _createPromise(createAsyncPromise, timeoutItemProcessor(timeout), executor, timeout);
}
var createAsyncAllPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createAllPromise(createAsyncPromise))));
var createAsyncResolvedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createResolvedPromise(createAsyncPromise))));
var createAsyncRejectedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createRejectedPromise(createAsyncPromise))));
function createAsyncAllSettledPromise(input, timeout) {
    !_allAsyncSettledCreator && (_allAsyncSettledCreator = _createAllSettledPromise(createAsyncPromise));
    return _allAsyncSettledCreator.v(input, timeout);
}
function createAsyncRacePromise(values, timeout) {
    !_raceAsyncCreator && (_raceAsyncCreator = _createRacePromise(createAsyncPromise));
    return _raceAsyncCreator.v(values, timeout);
}
function createAsyncAnyPromise(values, timeout) {
    !_anyAsyncCreator && (_anyAsyncCreator = _createAnyPromise(createAsyncPromise));
    return _anyAsyncCreator.v(values, timeout);
}

var _promiseCls;
var _allCreator;
var _allNativeSettledCreator;
var _raceNativeCreator;
var _anyNativeCreator;
/*#__NO_SIDE_EFFECTS__*/
function _createNativePromiseHelper(name, func) {
    !_promiseCls && (_promiseCls = createCachedValue((safe(getInst, [STR_PROMISE]).v) || null));
    if (_promiseCls.v && _promiseCls.v[name]) {
        return createCachedValue(function (input, timeout) {
            return createNativePromise(function (resolve, reject) {
                _promiseCls.v[name](input).then(resolve, reject);
            });
        });
    }
    return func();
}
function createNativePromise(executor, timeout) {
    !_promiseCls && (_promiseCls = ts_utils_createCachedValue((ts_utils_safe(ts_utils_getInst, [STR_PROMISE]).v) || null));
    var PrmCls = _promiseCls.v;
    if (!PrmCls) {
        return createAsyncPromise(executor);
    }
    if (!ts_utils_isFunction(executor)) {
        ts_utils_throwTypeError(STR_PROMISE + ": executor is not a function - " + ts_utils_dumpObj(executor));
    }
    var _state = 0 ;
    function _strState() {
        return STRING_STATES[_state];
    }
    var thePromise = new PrmCls(function (resolve, reject) {
        function _resolve(value) {
            _state = 2 ;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3 ;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    ts_utils_objDefineProp(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}
function createNativeAllPromise(input, timeout) {
    !_allCreator && (_allCreator = _createNativePromiseHelper("all", function () { return createCachedValue(_createAllPromise(createNativePromise)); }));
    return _allCreator.v(input, timeout);
}
var createNativeResolvedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createResolvedPromise(createNativePromise))));
var createNativeRejectedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createRejectedPromise(createNativePromise))));
function createNativeAllSettledPromise(input, timeout) {
    !_allNativeSettledCreator && (_allNativeSettledCreator = _createNativePromiseHelper("allSettled", function () { return _createAllSettledPromise(createNativePromise); }));
    return _allNativeSettledCreator.v(input, timeout);
}
function createNativeRacePromise(values, timeout) {
    !_raceNativeCreator && (_raceNativeCreator = _createNativePromiseHelper("race", function () { return _createRacePromise(createNativePromise); }));
    return _raceNativeCreator.v(values, timeout);
}
function createNativeAnyPromise(values, timeout) {
    !_anyNativeCreator && (_anyNativeCreator = _createNativePromiseHelper("any", function () { return _createAnyPromise(createNativePromise); }));
    return _anyNativeCreator.v(values, timeout);
}

var _allSyncSettledCreator;
var _raceSyncCreator;
var _anySyncCreator;
function createSyncPromise(executor) {
    return _createPromise(createSyncPromise, syncItemProcessor, executor);
}
var createSyncAllPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createAllPromise(createSyncPromise))));
var createSyncResolvedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createResolvedPromise(createSyncPromise))));
var createSyncRejectedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createRejectedPromise(createSyncPromise))));
function createSyncAllSettledPromise(input, timeout) {
    !_allSyncSettledCreator && (_allSyncSettledCreator = _createAllSettledPromise(createSyncPromise));
    return _allSyncSettledCreator.v(input, timeout);
}
function createSyncRacePromise(values, timeout) {
    !_raceSyncCreator && (_raceSyncCreator = _createRacePromise(createSyncPromise));
    return _raceSyncCreator.v(values, timeout);
}
function createSyncAnyPromise(values, timeout) {
    !_anySyncCreator && (_anySyncCreator = _createAnyPromise(createSyncPromise));
    return _anySyncCreator.v(values, timeout);
}

var ts_async_defaultIdleTimeout;
var _allIdleSettledCreator;
var _raceIdleCreator;
var _anyIdleCreator;
function setDefaultIdlePromiseTimeout(idleDeadline) {
    ts_async_defaultIdleTimeout = idleDeadline;
}
var ts_async_setDefaultIdleTimeout = ( /*#__PURE__*/(/* unused pure expression or super */ null && (ts_async_pureAssign(setDefaultIdlePromiseTimeout))));
function createIdlePromise(executor, timeout) {
    var theTimeout = isUndefined(timeout) ? ts_async_defaultIdleTimeout : timeout;
    return _createPromise(createIdlePromise, idleItemProcessor(theTimeout), executor, theTimeout);
}
var createIdleAllPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createAllPromise(createIdlePromise))));
var createIdleResolvedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createResolvedPromise(createIdlePromise))));
var createIdleRejectedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createRejectedPromise(createIdlePromise))));
function createIdleAllSettledPromise(input, timeout) {
    !_allIdleSettledCreator && (_allIdleSettledCreator = _createAllSettledPromise(createIdlePromise));
    return _allIdleSettledCreator.v(input, timeout);
}
function createIdleRacePromise(values, timeout) {
    !_raceIdleCreator && (_raceIdleCreator = _createRacePromise(createIdlePromise));
    return _raceIdleCreator.v(values, timeout);
}
function createIdleAnyPromise(values, timeout) {
    !_anyIdleCreator && (_anyIdleCreator = _createAnyPromise(createIdlePromise));
    return _anyIdleCreator.v(values, timeout);
}

var _promiseCreator;
var _allSettledCreator;
var _raceCreator;
var _anyCreator;
function setCreatePromiseImpl(creator) {
    _promiseCreator = creator ? createCachedValue(creator) : null;
}
function createPromise(executor, timeout) {
    !_promiseCreator && (_promiseCreator = ts_utils_createCachedValue(createNativePromise));
    return _promiseCreator.v.call(this, executor, timeout);
}
var createAllPromise = ( /*#__PURE__*/_createAllPromise(createPromise));
var createResolvedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createResolvedPromise(createPromise))));
var createRejectedPromise = ( /*#__PURE__*/(/* unused pure expression or super */ null && (_createRejectedPromise(createPromise))));
function createAllSettledPromise(input, timeout) {
    !_allSettledCreator && (_allSettledCreator = _createAllSettledPromise(createPromise));
    return _allSettledCreator.v(input, timeout);
}
function ts_async_createRacePromise(values, timeout) {
    !_raceCreator && (_raceCreator = _createRacePromise(createPromise));
    return _raceCreator.v(values, timeout);
}
function createAnyPromise(values, timeout) {
    !_anyCreator && (_anyCreator = _createAnyPromise(createPromise));
    return _anyCreator.v(values, timeout);
}

function ts_async_createTimeoutPromise(timeout, resolveReject, message) {
    return createPromise(function (resolve, reject) {
        scheduleTimeout(function () {
            (resolveReject ? resolve : reject)(!isUndefined(message) ? message : "Timeout of " + timeout + "ms exceeded");
        }, timeout);
    });
}

function _doneChk(isDone, state, value, thisArg) {
    var result = isDone;
    state.res = value;
    if (!result) {
        if (state.isDone && isFunction(state.isDone)) {
            return doAwait(state.isDone.call(thisArg, state), function (done) {
                state.iter++;
                return !!done;
            });
        }
        else {
            result = !!state.isDone;
        }
    }
    state.iter++;
    return result;
}
function doWhileAsync(callbackFn, isDoneFn, thisArg) {
    var promise;
    var resolve;
    var reject = function (reason) {
        isDone = true;
        throw reason;
    };
    var isDone = false;
    var state = {
        st: utcNow(),
        iter: 0,
        isDone: isDoneFn || false
    };
    if (callbackFn) {
        var _createPromise_1 = function () {
            return createPromise(function (res, rej) {
                resolve = res;
                reject = rej;
            });
        };
        var _handleAsyncDone_1 = function (done) {
            isDone = !!done;
            if (!isDone) {
                _processNext_1();
            }
            else {
                resolve(state.res);
            }
        };
        var _processNext_1 = function () {
            while (!isDone) {
                try {
                    var cbResult = callbackFn.call(thisArg, state);
                    if (isPromiseLike(cbResult)) {
                        promise = promise || _createPromise_1();
                        doAwait(cbResult, function (res) {
                            try {
                                doAwait(_doneChk(isDone, state, res, thisArg), _handleAsyncDone_1, reject);
                            }
                            catch (e) {
                                reject(e);
                            }
                        }, reject);
                        return promise;
                    }
                    else {
                        var dnRes = _doneChk(isDone, state, cbResult, thisArg);
                        if (isPromiseLike(dnRes)) {
                            promise = promise || _createPromise_1();
                            doAwait(dnRes, _handleAsyncDone_1, reject);
                            return promise;
                        }
                        else {
                            isDone = !!dnRes;
                        }
                    }
                }
                catch (e) {
                    reject(e);
                    return promise;
                }
            }
            if (isDone && resolve) {
                resolve(state.res);
            }
            return promise || state.res;
        };
        return _processNext_1();
    }
}

function arrForEachAsync(theArray, callbackFn, thisArg) {
    if (theArray) {
        var len_1 = getLength(theArray);
        if (len_1) {
            var isDone = function (state) {
                if (state.iter >= len_1 || state.res === -1) {
                    return true;
                }
            };
            return doWhileAsync(function (state) {
                var idx = state.iter;
                if (idx in theArray) {
                    return callbackFn.call(thisArg || theArray, theArray[idx], idx, theArray);
                }
            }, isDone);
        }
    }
}

var ts_async_iterSymbol;
var _iterAsyncSymbol;
function iterForOfAsync(iter, callbackFn, thisArg) {
    var err;
    var iterResult;
    var theIter = iter;
    function onFailed(failed) {
        err = { e: failed };
        if (theIter.throw) {
            iterResult = null;
            theIter.throw(err);
        }
        throw failed;
    }
    function onFinally() {
        try {
            if (iterResult && !iterResult[DONE]) {
                theIter[RETURN] && theIter[RETURN](iterResult);
            }
        }
        finally {
            if (err) {
                throw err.e;
            }
        }
    }
    if (iter) {
        if (!isIterator(iter)) {
            !_iterAsyncSymbol && (_iterAsyncSymbol = createCachedValue(getKnownSymbol(0 )));
            theIter = iter[_iterAsyncSymbol.v] ? iter[_iterAsyncSymbol.v]() : null;
            if (!theIter) {
                !ts_async_iterSymbol && (ts_async_iterSymbol = createCachedValue(getKnownSymbol(3 )));
                theIter = iter[ts_async_iterSymbol.v] ? iter[ts_async_iterSymbol.v]() : null;
            }
        }
        if (theIter && isIterator(theIter)) {
            var result = void 0;
            try {
                result = doWhileAsync(function (state) {
                    return doAwait(theIter.next(), function (res) {
                        iterResult = res;
                        if (!res[DONE]) {
                            return fnCall(callbackFn, thisArg || theIter, iterResult[VALUE], state.iter, theIter);
                        }
                    }, function (reason) {
                        state.isDone = true;
                        onFailed(reason);
                    });
                }, function (state) {
                    if (!iterResult || iterResult[DONE] || state.res === -1) {
                        onFinally();
                        return true;
                    }
                }, thisArg || theIter);
                if (isPromiseLike(result)) {
                    result = doFinally(result.catch(onFailed), onFinally);
                }
                return result;
            }
            catch (failed) {
                onFailed(failed);
            }
            finally {
                if (result && !isPromiseLike(result)) {
                    onFinally();
                }
            }
        }
    }
}

var REJECT = "reject";
var REJECTED_ERROR = "Rejected";
var _schedulerId = 0;
var _debugName;
var _debugIntState;
var _customErrors = {};
function _rejectDone() {
}
function _createError(type, evt, message) {
    !_customErrors[type] && (_customErrors[type] = createCustomError(type));
    var now = utcNow();
    return new (_customErrors[type])("Task [".concat(evt.id, "] ").concat(message || "", "- ").concat((evt.st ? "Running" : "Waiting"), ": ").concat(_calcTime(now, evt.st || evt.cr)));
}
function _calcTime(now, start) {
    return ((now - start) || "0") + " ms";
}
function _abortStaleTasks(taskQueue, staleTimeoutPeriod) {
    var now = utcNow();
    var expired = now - staleTimeoutPeriod;
    arrForEach(taskQueue, function (evt) {
        if (evt && !evt.rj && (evt.st && evt.st < expired) || (!evt.st && evt.cr && evt.cr < expired)) {
            evt && evt[REJECT](evt.rj || _createError("Aborted", evt, "Stale "));
        }
    });
}
function _removeTask(queue, taskDetail) {
    var idx = arrIndexOf(queue, taskDetail);
    if (idx !== -1) {
        queue.splice(idx, 1);
    }
}
function _addDebugState(theScheduler, nameFn, stateFn) {
    _debugName = _debugName || { toString: function () { return "[[SchedulerName]]"; } };
    _debugIntState = _debugIntState || { toString: function () { return "[[SchedulerState]]"; } };
    objDefineProp(theScheduler, _debugName, { get: nameFn });
    objDefineProp(theScheduler, _debugIntState, { get: stateFn });
}
function createTaskScheduler(newPromise, name) {
    var _theTask;
    var _running = [];
    var _waiting = [];
    var _staleTimeoutPeriod = 600000;
    var _staleTimeoutCheckPeriod = _staleTimeoutPeriod / 10;
    var _taskCount = 0;
    var _schedulerName = (name ? (name + ".") : "") + _schedulerId++;
    var _blockedTimer;
    newPromise = newPromise || createPromise;
    var _startBlockedTimer = function () {
        var hasTasks = (getLength(_running) + getLength(_waiting)) > 0;
        if (_staleTimeoutPeriod > 0) {
            if (!_blockedTimer) {
                _blockedTimer = scheduleTimeout(function () {
                    _abortStaleTasks(_running, _staleTimeoutPeriod);
                    _abortStaleTasks(_waiting, _staleTimeoutPeriod);
                    _blockedTimer && (_blockedTimer.enabled = ((getLength(_running) + getLength(_waiting)) > 0));
                }, _staleTimeoutCheckPeriod);
                _blockedTimer.unref();
            }
            _blockedTimer && (_blockedTimer.enabled = hasTasks);
        }
    };
    var _queueTask = function (startAction, taskName, timeout) {
        var _a;
        var taskId = _schedulerName + "." + _taskCount++;
        if (taskName) {
            taskId += "-(" + taskName + ")";
        }
        var newTask = (_a = {
                id: taskId,
                cr: utcNow(),
                to: timeout
            },
            _a[REJECT] = function (reason) {
                newTask.rj = reason || _createError(REJECTED_ERROR, newTask);
                newTask[REJECT] = _rejectDone;
            },
            _a);
        if (!_theTask) {
            newTask.p = newPromise(_runTask(newTask, startAction));
        }
        else {
            newTask.p = _waitForPreviousTask(newTask, _theTask, startAction);
        }
        _theTask = newTask;
        return newTask.p;
    };
    var _runTask = function (taskDetail, startAction) {
        taskDetail.st = utcNow();
        _running.push(taskDetail);
        _startBlockedTimer();
        return function (onTaskResolve, onTaskReject) {
            var _promiseReject = function (reason) {
                taskDetail.rj = taskDetail.rj || reason || _createError(REJECTED_ERROR, taskDetail);
                taskDetail[REJECT] = _rejectDone;
                _doCleanup(taskDetail);
                onTaskResolve = null;
                onTaskReject && onTaskReject(reason);
                onTaskReject = null;
            };
            var taskId = taskDetail.id;
            if (taskDetail.rj) {
                _promiseReject(taskDetail.rj);
            }
            else {
                taskDetail[REJECT] = _promiseReject;
                try {
                    var startResult = startAction(taskId);
                    if (taskDetail.to && isPromiseLike(startResult)) {
                        taskDetail.t = scheduleTimeout(function () {
                            _promiseReject(_createError("Timeout", taskDetail));
                        }, taskDetail.to);
                    }
                    doAwait(startResult, function (theResult) {
                        _doCleanup(taskDetail);
                        try {
                            onTaskResolve && onTaskResolve(theResult);
                        }
                        catch (e) {
                            onTaskReject && onTaskReject(e);
                        }
                        onTaskReject = null;
                        onTaskResolve = null;
                    }, _promiseReject);
                }
                catch (e) {
                    _promiseReject(e);
                }
            }
        };
    };
    var _waitForPreviousTask = function (taskDetail, prevTask, startAction) {
        _waiting.push(taskDetail);
        _startBlockedTimer();
        return newPromise(function (onWaitResolve, onWaitReject) {
            doAwaitResponse(prevTask.p, function () {
                _removeTask(_waiting, taskDetail);
                _runTask(taskDetail, startAction)(onWaitResolve, onWaitReject);
            });
        });
    };
    var _doCleanup = function (taskDetail) {
        _removeTask(_running, taskDetail);
        taskDetail.t && taskDetail.t.cancel();
        taskDetail.t = null;
        if (_theTask && _theTask === taskDetail) {
            _theTask = null;
            if (getLength(_running) + getLength(_waiting) === 0) {
                _blockedTimer && _blockedTimer.cancel();
                _blockedTimer = null;
            }
        }
    };
    var theScheduler = {
        idle: true,
        queue: _queueTask,
        setStaleTimeout: function (staleTimeout, staleCheckPeriod) {
            _blockedTimer && _blockedTimer.cancel();
            _blockedTimer = null;
            _staleTimeoutPeriod = staleTimeout;
            _staleTimeoutCheckPeriod = staleCheckPeriod || staleTimeout / 10;
            _startBlockedTimer();
        }
    };
    objDefine(theScheduler, "idle", {
        g: function () {
            return getLength(_running) + getLength(_waiting) === 0;
        }
    });
    _addDebugState(theScheduler, function () { return _schedulerName; }, function () {
        return {
            l: _theTask,
            r: _running,
            w: _waiting
        };
    });
    return theScheduler;
}

var toStringTagSymbol = ts_utils_getKnownSymbol(11 );
var PolyPromise = ( /*#__PURE__*/((/* unused pure expression or super */ null && (function () {
    function PolyPromiseImpl(executor) {
        this._$ = createAsyncPromise(executor);
        if (toStringTagSymbol) {
            this[toStringTagSymbol] = "Promise";
        }
        objDefineProp(this, "state", {
            get: function () {
                return this._$.state;
            }
        });
    }
    PolyPromiseImpl.all = createAsyncAllPromise;
    PolyPromiseImpl.race = createAsyncRacePromise;
    PolyPromiseImpl.any = createAsyncAnyPromise;
    PolyPromiseImpl.reject = createAsyncRejectedPromise;
    PolyPromiseImpl.resolve = createAsyncResolvedPromise;
    PolyPromiseImpl.allSettled = createAsyncAllSettledPromise;
    var theProto = PolyPromiseImpl.prototype;
    theProto.then = function (onResolved, onRejected) {
        return this._$.then(onResolved, onRejected);
    };
    theProto.catch = function (onRejected) {
        return this._$.catch(onRejected);
    };
    theProto.finally = function (onfinally) {
        return this._$.finally(onfinally);
    };
    return PolyPromiseImpl;
}()))));


//# sourceMappingURL=ts-async.js.map

;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-cfgsync-js/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_FEATURE_OPT_IN = "featureOptIn"; // Count: 4
var _DYN_SCHEDULE_FETCH_TIMEO0 = "scheduleFetchTimeout"; // Count: 2
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-cfgsync-js/dist-es5/CfgSyncHelperFuncs.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Delete a config key in the given cfg, if the config key exists in nonOverrideConfigs and its value is set to true
 * @param cfg - cfg to modify
 * @param nonOverrideConfigs - nonOverrideConfigs
 * @param curLevel - cur config level, starting at 0
 * @param maxLevel - max config level
 * @returns new copy of modified configs
 */
function replaceByNonOverrideCfg(cfg, nonOverrideConfigs, curLevel, maxLevel) {
    try {
        var exceedMaxLevel = curLevel > maxLevel;
        if (exceedMaxLevel) {
            cfg = null;
        }
        var curCfg_1 = curLevel == 0 ? objExtend({}, cfg) : cfg; // only copy cfg at the begining level
        if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) {
            ts_utils_objForEachKey(curCfg_1, function (key) {
                var nonOverrideVal = nonOverrideConfigs[key];
                if (!!nonOverrideVal) {
                    if (ts_utils_isObject(curCfg_1[key]) && ts_utils_isObject(nonOverrideVal)) {
                        curCfg_1[key] = replaceByNonOverrideCfg(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
                    }
                    else {
                        delete curCfg_1[key];
                    }
                }
            });
        }
        return curCfg_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    // if errors happen, do nothing
    return cfg;
}
//                                                     CDN Mode, value = B (CDN value = B)
//                                |--------------------------------------------------------------------------|-----------|
//                                |                    | none        | disabled    | enabled     | forceOn   | forceOff  |
//                                | ------------------ | ----------- | ----------- | ----------- | --------- | --------- |
// | User Mode, value = A         | none               | none        | disabled    | enabled     | enabled   | disabled  |
// (user Value = A)               | disabled           | disabled    | disabled    | disabled    | enabled   | disabled  |
//                                | enabled            | enabled     | disabled    | enabled     | enabled   | disabled  |
//                                | none(blockCdn)     | none        | none        | none        | none      | none      |
//                                | disabled(blockCdn) | disabled    | disabled    | disabled    | disabled  | disabled  |
//                                | enabled(blockCdn)  | enabled     | enabled     | enabled     | enabled   | enabled   |
// This matrix identifies how feature based overrides are selected (if present)
//                                cdn Mode (cdn Value = B)
//                   |---------------------------------------------------------------------------|
//                   |                    | none     | disabled | enabled  | forceOn  | forceOff |
//                   | ------------------ | ---------| ---------| ---------| ---------|----------|
// | User Mode       | none               | A        | A        | A || B   | B || A   | B || A   |
// (user Value = A)  | disabled           | A        | A        | A        | B || A   | B || A   |
//                   | enabled            | A        | A        | A || B   | B || A   | B || A   |
//                   | none(blockCdn)     | A        | A        | A        | A        | A        |
//                   | disabled(blockCdn) | A        | A        | A        | A        | A        |
//                   | enabled(blockCdn)  | A        | A        | A        | A        | A        |
// Note:
// Where the "value" is an object (map) of encoded key/values which will be used to override the real configuration
// A = either the user supplied enable/disable value (via the `config.featureOptIn[name]`) or if not defined by the user the SDK defaults of the same.
// B = The enable/disable value obtained from the CDN for the named feature
// These are evaluated based on the above matrix to either
// - A (Always the user/sdk value)
// - B (Always the value from the CDN)
// - A || B (If A is null or undefined use the value from the CDN (B) otherwise A)
// - B || A (If B is null or undefined use the user/SDK value otherwise use the value from the CDN)
//
// The result of the value may also be null / undefined, which means there are no overrides to apply when the feature is enabled
var F = "featureOptIn.";
var M = ".mode";
var ON = ".onCfg";
var OFF = ".offCfg";
function resolveCdnFeatureCfg(field, cdnCfg, userOptInDetails) {
    var _a;
    // cdn conifg value
    if (!cdnCfg || !cdnCfg.enabled) {
        return null;
    }
    var cdnFt = (cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */] || {})[field] || { mode: 1 /* CdnFeatureMode.none */ };
    var cdnM = cdnFt.mode;
    var cdnOnV = cdnFt.onCfg;
    var cdnOffV = cdnFt.offCfg;
    var userFt = (userOptInDetails || {})[field] || { mode: 2 /* FeatureOptInMode.disable */ }; // default user mode is disable
    var userM = userFt.mode;
    var userOnV = userFt.onCfg;
    var userOffV = userFt.offCfg;
    var blockCdn = !!userFt.blockCdnCfg;
    var mFld = F + field + M;
    var onFld = F + field + ON;
    var offFld = F + field + OFF;
    var mode = userM;
    var onV = userOnV;
    var offV = userOffV;
    if (!blockCdn) {
        if (cdnM === 4 /* CdnFeatureMode.forceOn */ || cdnM === 5 /* CdnFeatureMode.forceOff */) {
            mode = (cdnM == 4 /* CdnFeatureMode.forceOn */ ? 3 /* FeatureOptInMode.enable */ : 2 /* FeatureOptInMode.disable */);
            onV = cdnOnV || userOnV;
            offV = cdnOffV || userOffV;
        }
        else if (cdnM === 2 /* CdnFeatureMode.disable */ || userM === 2 /* FeatureOptInMode.disable */) {
            mode = 2 /* FeatureOptInMode.disable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 3 /* CdnFeatureMode.enable */) {
            mode = 3 /* FeatureOptInMode.enable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 1 /* CdnFeatureMode.none */ && userM === 1 /* FeatureOptInMode.none */) {
            mode = 1 /* FeatureOptInMode.none */;
        }
    }
    return _a = {},
        _a[mFld] = mode,
        _a[onFld] = onV,
        _a[offFld] = offV,
        _a;
}
// helper function to get cdn config with opt-in features
function applyCdnfeatureCfg(cdnCfg, core) {
    try {
        if (!cdnCfg || !cdnCfg.enabled) {
            return null;
        }
        if (!cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]) {
            return cdnCfg.config;
        }
        var optInMap = cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */];
        var cdnConfig_1 = cdnCfg.config || {};
        ts_utils_objForEachKey(optInMap, function (key) {
            var featureVal = resolveCdnFeatureCfg(key, cdnCfg, core.config[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]);
            if (!ts_utils_isNullOrUndefined(featureVal)) {
                ts_utils_objForEachKey(featureVal, function (config, val) {
                    setValueByKey(cdnConfig_1, config, val);
                });
                _overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
            }
        });
        return cdnConfig_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
function _overrideCdnCfgByFeature(field, ftVal, config) {
    var mode = ftVal[F + field + M];
    var val = ftVal[F + field + ON];
    var dVal = ftVal[F + field + OFF];
    var target = null;
    if (mode === 3 /* FeatureOptInMode.enable */) {
        target = val;
    }
    if (mode === 2 /* FeatureOptInMode.disable */) {
        target = dVal;
    }
    if (target) {
        ts_utils_objForEachKey(target, function (key, cfg) {
            setValueByKey(config, key, cfg);
        });
    }
}
//# sourceMappingURL=CfgSyncHelperFuncs.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-cfgsync-js/dist-es5/CfgSyncPlugin.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* CfgSyncPlugin.ts
* @copyright Microsoft 2018
*/
var CfgSyncPlugin_a;







var EVENT_NAME = "ai_cfgsync";
var STR_GET_METHOD = "GET";
var FETCH_TIMEOUT = 1800000; // 30 minutes
var udfVal = undefined;
var defaultNonOverrideCfg = { instrumentationKey: true, connectionString: true, endpointUrl: true };
var _defaultConfig = ts_utils_objDeepFreeze((CfgSyncPlugin_a = {
        syncMode: 1 /* ICfgSyncMode.Broadcast */,
        blkCdnCfg: udfVal,
        customEvtName: udfVal,
        cfgUrl: udfVal,
        overrideSyncFn: udfVal,
        overrideFetchFn: udfVal,
        onCfgChangeReceive: udfVal
    },
    CfgSyncPlugin_a[_DYN_SCHEDULE_FETCH_TIMEO0 /* @min:scheduleFetchTimeout */] = FETCH_TIMEOUT,
    CfgSyncPlugin_a.nonOverrideConfigs = defaultNonOverrideCfg,
    CfgSyncPlugin_a.enableAjax = false,
    CfgSyncPlugin_a));
var CfgSyncPlugin = /** @class */ (function (_super) {
    __extendsFn(CfgSyncPlugin, _super);
    function CfgSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 198;
        _this.identifier = "AppInsightsCfgSyncPlugin";
        var _extensionConfig;
        var _mainConfig; // throttle config should be wrapped in IConfiguration
        var _evtName;
        var _evtNamespace;
        var _cfgUrl;
        var _timeoutHandle;
        var _receiveChanges;
        var _broadcastChanges;
        var _blkCdnCfg;
        var _fetchTimeout;
        var _retryCnt;
        var _onCfgChangeReceive;
        var _nonOverrideConfigs;
        var _fetchFn;
        var _overrideFetchFn;
        var _overrideSyncFn;
        var _paused = false;
        var _enableAjax;
        dynamicProto(CfgSyncPlugin, _this, function (_self, _base) {
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _evtNamespace = mergeEvtNamespace(DataCacheHelper_createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                _populateDefaults(config);
            };
            _self.getCfg = function () {
                return _mainConfig;
            };
            _self.pause = function () {
                _paused = true;
                _clearScheduledTimer();
            };
            _self.resume = function () {
                _paused = false;
                _setupTimer();
            };
            // used for V2 to manaully trigger config udpate
            _self.setCfg = function (config) {
                return _setCfg(config);
            };
            _self.sync = function (customDetails) {
                return _sendCfgsyncEvents(customDetails);
            };
            _self.updateEventListenerName = function (eventName) {
                return _updateEventListenerName(eventName);
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _eventOff();
                _clearScheduledTimer();
                _initDefaults();
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_broadcastChanges, _receiveChanges, _evtName, _blkCdnCfg, _nonOverrideConfigs];
            };
            function _initDefaults() {
                _mainConfig = null;
                _evtName = null;
                _evtNamespace = null;
                _cfgUrl = null;
                _receiveChanges = null;
                _broadcastChanges = null;
                _nonOverrideConfigs = null;
                _timeoutHandle = null;
                _fetchTimeout = null;
                _retryCnt = null;
                _blkCdnCfg = null;
                _enableAjax = false;
                _overrideFetchFn = null;
                _overrideSyncFn = null;
                _onCfgChangeReceive = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig);
                    var preBlkCdn = _blkCdnCfg;
                    _blkCdnCfg = !!_extensionConfig.blkCdnCfg;
                    _enableAjax = !!_extensionConfig.enableAjax;
                    // avoid initial call
                    if (!ts_utils_isNullOrUndefined(preBlkCdn) && preBlkCdn !== _blkCdnCfg) {
                        if (!_blkCdnCfg && _cfgUrl) {
                            _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                        }
                        else {
                            _clearScheduledTimer();
                        }
                    }
                    if (ts_utils_isNullOrUndefined(_receiveChanges)) {
                        _receiveChanges = _extensionConfig.syncMode === 2 /* ICfgSyncMode.Receive */;
                    }
                    if (ts_utils_isNullOrUndefined(_broadcastChanges)) {
                        _broadcastChanges = _extensionConfig.syncMode === 1 /* ICfgSyncMode.Broadcast */;
                    }
                    var newEvtName = _extensionConfig.customEvtName || EVENT_NAME;
                    if (_evtName !== newEvtName) {
                        if (_receiveChanges) {
                            _updateEventListenerName(newEvtName);
                        }
                        else {
                            _eventOff();
                            _evtName = newEvtName;
                        }
                    }
                    if (ts_utils_isNullOrUndefined(_cfgUrl)) {
                        _cfgUrl = _extensionConfig.cfgUrl;
                    }
                    // if cfgUrl is set, we will ignore core config change
                    if (!_cfgUrl) {
                        _mainConfig = config;
                        if (_broadcastChanges) {
                            _sendCfgsyncEvents();
                        }
                    }
                }));
                _overrideSyncFn = _extensionConfig.overrideSyncFn;
                _overrideFetchFn = _extensionConfig.overrideFetchFn;
                _onCfgChangeReceive = _extensionConfig.onCfgChangeReceive;
                _nonOverrideConfigs = _extensionConfig.nonOverrideConfigs; // override values should not be changed
                _fetchTimeout = _extensionConfig[_DYN_SCHEDULE_FETCH_TIMEO0 /* @min:%2escheduleFetchTimeout */];
                _fetchFn = _getFetchFnInterface();
                _retryCnt = 0;
                // NOT support cfgURL change to avoid mutiple fetch calls
                if (_cfgUrl && !_blkCdnCfg) {
                    _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                }
            }
            function _setCfg(config, isAutoSync) {
                if (config) {
                    _mainConfig = config;
                    if (!!isAutoSync && !_paused) {
                        return _sendCfgsyncEvents();
                    }
                    if (_receiveChanges && !_paused) {
                        _self.core.updateCfg(config);
                        return true;
                    }
                }
                return false;
            }
            function _eventOff() {
                try {
                    var global_1 = getGlobal();
                    if (global_1) {
                        eventOff(global_1, null, null, _evtNamespace);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _sendCfgsyncEvents(customDetails) {
                try {
                    if (!!_overrideSyncFn && ts_utils_isFunction(_overrideSyncFn)) {
                        return _overrideSyncFn(_mainConfig, customDetails);
                    }
                    return sendCustomEvent(_evtName, _mainConfig, customDetails);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _updateEventListenerName(name) {
                try {
                    _eventOff();
                    if (name) {
                        _evtName = name;
                        _addEventListener();
                    }
                    return true;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            }
            function _getFetchFnInterface() {
                var _fetchFn = _overrideFetchFn;
                if (ts_utils_isNullOrUndefined(_fetchFn)) {
                    if (isFetchSupported()) {
                        _fetchFn = _fetchSender;
                    }
                    else if (isXhrSupported()) {
                        _fetchFn = _xhrSender;
                    }
                }
                return _fetchFn;
            }
            function _fetchSender(url, oncomplete, isAutoSync) {
                var global = getGlobal();
                var fetchFn = (global && global.fetch) || null;
                if (url && fetchFn && ts_utils_isFunction(fetchFn)) {
                    try {
                        var init = {
                            method: STR_GET_METHOD
                        };
                        if (!_enableAjax) {
                            init[DisabledPropertyName] = true;
                        }
                        var request = new Request(url, init);
                        if (!_enableAjax) {
                            try {
                                // Also try and tag the request (just in case the value in init is not copied over)
                                request[DisabledPropertyName] = true;
                            }
                            catch (e) {
                                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                                // cause the request to fail and we no telemetry would be sent
                            }
                        }
                        doAwaitResponse(fetch(request), function (result) {
                            var response = result.value;
                            if (!result.rejected) {
                                if (response.ok) {
                                    doAwaitResponse(response.text(), function (res) {
                                        _doOnComplete(oncomplete, response.status, res.value, isAutoSync);
                                    });
                                }
                                else {
                                    _doOnComplete(oncomplete, response.status, null, isAutoSync);
                                }
                            }
                            else {
                                _doOnComplete(oncomplete, 400);
                            }
                        });
                    }
                    catch (e) {
                        // eslint-disable-next-line no-empty
                    }
                }
            }
            function _xhrSender(url, oncomplete, isAutoSync) {
                try {
                    var xhr_1 = new XMLHttpRequest();
                    if (!_enableAjax) {
                        xhr_1[DisabledPropertyName] = true;
                    }
                    xhr_1.open(STR_GET_METHOD, url);
                    xhr_1.onreadystatechange = function () {
                        if (xhr_1.readyState === XMLHttpRequest.DONE) {
                            _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
                        }
                    };
                    xhr_1.onerror = function () {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.ontimeout = function () {
                        _doOnComplete(oncomplete, 400);
                    };
                    xhr_1.send();
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _onFetchComplete(status, response, isAutoSync) {
                try {
                    if (status >= 200 && status < 400 && response) {
                        _retryCnt = 0; // any successful response will reset retry count to 0
                        var JSON_1 = EnvUtils_getJSON();
                        if (JSON_1) {
                            var cdnCfg = JSON_1.parse(response); //comments are not allowed
                            var cfg = applyCdnfeatureCfg(cdnCfg, _self.core);
                            var newCfg = cfg && isPlainObject(cfg) && _replaceTartgetByKeys(cfg);
                            newCfg && _setCfg(newCfg, isAutoSync);
                            //cfg && _setCfg(cfg, isAutoSync);
                        }
                    }
                    else {
                        _retryCnt++;
                    }
                    if (_retryCnt < 3) {
                        _setupTimer();
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _doOnComplete(oncomplete, status, response, isAutoSync) {
                try {
                    oncomplete(status, response, isAutoSync);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _addEventListener() {
                if (_receiveChanges) {
                    var global_2 = getGlobal();
                    if (global_2) {
                        try {
                            eventOn(global_2, _evtName, function (event) {
                                // TODO: add more validation here
                                // may include a "name" or some other features to check
                                var cfgEvent = event && event.detail;
                                if (_onCfgChangeReceive && cfgEvent) {
                                    _onCfgChangeReceive(cfgEvent);
                                }
                                else {
                                    var cfg = cfgEvent && cfgEvent.cfg;
                                    var newCfg = cfg && isPlainObject(cfg) && _replaceTartgetByKeys(cfg);
                                    newCfg && _setCfg(newCfg);
                                }
                            }, _evtNamespace, true);
                        }
                        catch (e) {
                            // eslint-disable-next-line no-empty
                        }
                    }
                }
            }
            // 4 levels
            function _replaceTartgetByKeys(cfg, level) {
                var _cfg = null;
                try {
                    if (cfg) {
                        _cfg = replaceByNonOverrideCfg(cfg, _nonOverrideConfigs, 0, 5);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return _cfg;
            }
            /**
             * Sets up the timer which triggers fetching cdn every 30mins after inital call
             */
            function _setupTimer() {
                if (!_timeoutHandle && _fetchTimeout) {
                    _timeoutHandle = ts_utils_scheduleTimeout(function () {
                        _timeoutHandle = null;
                        _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
                    }, _fetchTimeout);
                    _timeoutHandle.unref();
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryCnt = 0;
            }
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
        });
        return _this;
    }
// Removed Stub for CfgSyncPlugin.prototype.initialize.
// Removed Stub for CfgSyncPlugin.prototype.getCfg.
// Removed Stub for CfgSyncPlugin.prototype.setCfg.
// Removed Stub for CfgSyncPlugin.prototype.sync.
// Removed Stub for CfgSyncPlugin.prototype.updateEventListenerName.
// Removed Stub for CfgSyncPlugin.prototype.pause.
// Removed Stub for CfgSyncPlugin.prototype.resume.
    //// Removed Stub for CfgSyncPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    CfgSyncPlugin.__ieDyn=1;

    return CfgSyncPlugin;
}(BaseTelemetryPlugin));

//# sourceMappingURL=CfgSyncPlugin.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/utils/Offline.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






function _disableEvents(target, evtNamespace) {
    eventOff(target, null, null, evtNamespace);
}
/**
 * Create a new OfflineListener instance to monitor browser online / offline events
 * @param parentEvtNamespace - The parent event namespace to append to any specific events for this instance
 */
function createOfflineListener(parentEvtNamespace) {
    var _document = ts_utils_getDocument();
    var _navigator = getNavigator(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var listenerList = [];
    // Set the initial state
    // rState is changed by the browser, both via events and when we check the navigator.onLine property
    var rState = 1 /* eOfflineValue.Online */;
    if (_navigator && !ts_utils_isNullOrUndefined(_navigator.onLine) && !_navigator.onLine) { // navigator.onLine is undefined in react-native
        rState = 2 /* eOfflineValue.Offline */;
    }
    // ustate is changed by the user calling setOnlineState
    var uState = 0 /* eOfflineValue.Unknown */;
    // current state would be updated each time rState or uState is changed
    // it is a resolved value of rState and uState
    var _currentState = calCurrentState();
    var _evtNamespace = mergeEvtNamespace(DataCacheHelper_createUniqueNamespace("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents(getWindow())) {
            _isListening = true;
        }
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) {
                    _isListening = true;
                }
            }
        }
    }
    catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = eventOn(target, "online", _setOnline, _evtNamespace);
            if (enabled) {
                eventOn(target, "offline", _setOffline, _evtNamespace);
            }
        }
        return enabled;
    }
    function _isOnline() {
        return _currentState;
    }
    function calCurrentState() {
        if (uState === 2 /* eOfflineValue.Offline */ || rState === 2 /* eOfflineValue.Offline */) {
            return false;
        }
        return true; // if both unknown, then we assume the network is good
    }
    function listnerNoticeCheck() {
        // we were offline and are now online or we were online and now offline
        var newState = calCurrentState();
        if (_currentState !== newState) {
            _currentState = newState; // use the resolved state to update
            // send all the callbacks with the current state
            ts_utils_arrForEach(listenerList, function (callback) {
                var offlineState = {
                    isOnline: _currentState,
                    rState: rState,
                    uState: uState
                };
                try {
                    callback(offlineState);
                }
                catch (e) {
                    // Do nothing, just making sure we run all of the callbacks
                }
            });
        }
    }
    function setOnlineState(newState) {
        uState = newState;
        listnerNoticeCheck();
    }
    function _setOnline() {
        rState = 1 /* eOfflineValue.Online */;
        listnerNoticeCheck();
    }
    function _setOffline() {
        rState = 2 /* eOfflineValue.Offline */;
        listnerNoticeCheck();
    }
    function _unload() {
        var win = getWindow();
        if (win && _isListening) {
            _disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!ts_utils_isUndefined(target.ononline)) {
                    _disableEvents(target, _evtNamespace);
                }
            }
            _isListening = false;
        }
    }
    function addListener(callback) {
        listenerList[_DynamicConstants_DYN_PUSH /* @min:%2epush */](callback);
        // Define rm as an instance of IUnloadHook
        return {
            rm: function () {
                var index = ts_utils_arrIndexOf(listenerList, callback);
                if (index > -1) {
                    return listenerList[_DYN_SPLICE /* @min:%2esplice */](index, 1);
                }
                else {
                    return;
                }
            }
        };
    }
    return {
        isOnline: _isOnline,
        isListening: function () { return _isListening; },
        unload: _unload,
        addListener: addListener,
        setOnlineState: setOnlineState
    };
}
//# sourceMappingURL=Offline.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/enums/ai/InitActiveStatusEnum.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ActiveStatus = ( /* @__PURE__ */createEnumStyle({
    NONE: 0 /* eActiveStatus.NONE */,
    PENDING: 3 /* eActiveStatus.PENDING */,
    INACTIVE: 1 /* eActiveStatus.INACTIVE */,
    ACTIVE: 2 /* eActiveStatus.ACTIVE */
}));
//# sourceMappingURL=InitActiveStatusEnum.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/SenderPostManager.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var STR_NO_RESPONSE_BODY = "NoResponseBody";
var _noResponseQs = "&" + STR_NO_RESPONSE_BODY + "=true";
var STR_POST_METHOD = "POST";
/**
 * This Internal component
 * Manager SendPost functions
 * SendPostManger
 * @internal for internal use only
 * @since 3.0.0
 */
var SenderPostManager = /** @class */ (function () {
    function SenderPostManager() {
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _enableSendPromise;
        var _isInitialized;
        var _diagLog;
        var _isOneDs;
        var _onCompleteFuncs;
        var _disableCredentials;
        var _fetchCredentials;
        var _fallbackInst;
        var _disableXhr;
        var _disableBeacon;
        var _disableBeaconSync;
        var _disableFetchKeepAlive;
        var _addNoResponse;
        var _timeoutWrapper;
        dynamicProto(SenderPostManager, this, function (_self, _base) {
            var _sendCredentials = true; // for 1ds
            _initDefaults();
            _self[_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, diagLog) {
                _diagLog = diagLog;
                if (_isInitialized) {
                    _throwInternal(_diagLog, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _self.SetConfig(config);
                _isInitialized = true;
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_isInitialized, _isOneDs, _disableCredentials, _enableSendPromise];
            };
            // This componet might get its config from sender, offline sender, 1ds post
            // so set this function to mock dynamic changes
            _self.SetConfig = function (config) {
                try {
                    _onCompleteFuncs = config.senderOnCompleteCallBack || {};
                    _disableCredentials = !!config.disableCredentials;
                    _fetchCredentials = config.fetchCredentials;
                    _isOneDs = !!config.isOneDs;
                    _enableSendPromise = !!config.enableSendPromise;
                    _disableXhr = !!config.disableXhr;
                    _disableBeacon = !!config.disableBeacon;
                    _disableBeaconSync = !!config.disableBeaconSync;
                    _timeoutWrapper = config.timeWrapper;
                    _addNoResponse = !!config.addNoResponse;
                    _disableFetchKeepAlive = !!config.disableFetchKeepAlive;
                    _fallbackInst = { sendPOST: _xhrSender };
                    if (!_isOneDs) {
                        _sendCredentials = false; // for appInsights, set it to false always
                    }
                    if (_disableCredentials) {
                        var location_1 = getLocation();
                        if (location_1 && location_1.protocol && location_1.protocol[_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === "file:") {
                            // Special case where a local html file fails with a CORS error on Chromium browsers
                            _sendCredentials = false;
                        }
                    }
                    return true;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            };
            _self.getSyncFetchPayload = function () {
                return _syncFetchPayload;
            };
            _self.getSenderInst = function (transports, sync) {
                if (transports && transports[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                    return _getSenderInterface(transports, sync);
                }
                return null;
            };
            _self.getFallbackInst = function () {
                return _fallbackInst;
            };
            _self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */] = function (unloadCtx, unloadState) {
                _initDefaults();
            };
            _self.preparePayload = function (callback, zipPayload, payload, isSync) {
                if (!zipPayload || isSync || !payload[_DYN_DATA /* @min:%2edata */]) {
                    // If the request is synchronous, the body is null or undefined or Compression is not supported, we don't need to compress it
                    callback(payload);
                    return;
                }
                try {
                    var csStream = ts_utils_getInst("CompressionStream");
                    if (!ts_utils_isFunction(csStream)) {
                        callback(payload);
                        return;
                    }
                    // Create a readable stream from the uint8 data
                    var body = new ReadableStream({
                        start: function (controller) {
                            controller.enqueue(ts_utils_isString(payload[_DYN_DATA /* @min:%2edata */]) ? new TextEncoder().encode(payload[_DYN_DATA /* @min:%2edata */]) : payload[_DYN_DATA /* @min:%2edata */]);
                            controller.close();
                        }
                    });
                    var compressedStream = body.pipeThrough(new csStream("gzip"));
                    var reader_1 = compressedStream.getReader();
                    var chunks_1 = [];
                    var totalLength_1 = 0;
                    var callbackCalled_1 = false;
                    // Process each chunk from the compressed stream reader
                    doAwaitResponse(reader_1.read(), function processChunk(response) {
                        if (!callbackCalled_1 && !response.rejected) {
                            // Process the chunk and continue reading
                            var result = response[_DYN_VALUE /* @min:%2evalue */];
                            if (!result.done) {
                                // Add current chunk and continue reading
                                chunks_1[_DynamicConstants_DYN_PUSH /* @min:%2epush */](result[_DYN_VALUE /* @min:%2evalue */]);
                                totalLength_1 += result.value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                                return doAwaitResponse(reader_1.read(), processChunk);
                            }
                            // We are complete so combine all chunks
                            var combined = new Uint8Array(totalLength_1);
                            var offset = 0;
                            for (var _i = 0, chunks_2 = chunks_1; _i < chunks_2.length; _i++) {
                                var chunk = chunks_2[_i];
                                combined.set(chunk, offset);
                                offset += chunk[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                            }
                            // Update payload with compressed data
                            payload[_DYN_DATA /* @min:%2edata */] = combined;
                            payload[_DYN_HEADERS /* @min:%2eheaders */]["Content-Encoding"] = "gzip";
                            payload._chunkCount = chunks_1[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                        }
                        if (!callbackCalled_1) {
                            // Send the processed payload to the callback, if not already called
                            // If the response was rejected, we will call the callback with the original payload
                            // As it only gets "replaced" if the compression was successful
                            callbackCalled_1 = true;
                            callback(payload);
                        }
                        // We don't need to return anything as this will cause the calling chain to be resolved and closed
                    });
                    // returning the reader to allow the caller to cancel the stream if needed
                    // This is not a requirement but allows for better control over the stream, like if we detect that we are unloading
                    // we could use reader.cancel() to stop the stream and avoid sending the request, but this may still be an asynchronous operation
                    // and may not be possible to cancel the stream in time
                    return reader_1;
                }
                catch (error) {
                    // CompressionStream is not available at all
                    callback(payload);
                    return;
                }
            };
            /**
             * success handler
             */
            function _onSuccess(res, onComplete) {
                _doOnComplete(onComplete, 200, {}, res);
            }
            /**
             * error handler
             */
            function _onError(message, onComplete) {
                _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _doOnComplete(onComplete, 400, {});
            }
            function _onNoPayloadUrl(onComplete) {
                _onError("No endpoint url is provided for the batch", onComplete);
            }
            function _getSenderInterface(transports, syncSupport) {
                var transportType = 0 /* TransportType.NotSet */;
                var sendPostFunc = null;
                var lp = 0;
                while (sendPostFunc == null && lp < transports[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                    transportType = transports[lp];
                    if (!_disableXhr && transportType === 1 /* TransportType.Xhr */) {
                        if (useXDomainRequest()) {
                            // IE 8 and 9
                            sendPostFunc = _xdrSender;
                        }
                        else if (isXhrSupported()) {
                            sendPostFunc = _xhrSender;
                        }
                    }
                    else if (transportType === 2 /* TransportType.Fetch */ && isFetchSupported(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) {
                        sendPostFunc = _doFetchSender;
                    }
                    else if (transportType === 3 /* TransportType.Beacon */ && isBeaconsSupported() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) {
                        sendPostFunc = _beaconSender;
                    }
                    lp++;
                }
                if (sendPostFunc) {
                    return {
                        _transport: transportType,
                        _isSync: syncSupport,
                        sendPOST: sendPostFunc
                    };
                }
                return null;
            }
            function _doOnComplete(oncomplete, status, headers, response) {
                try {
                    oncomplete && oncomplete(status, headers, response);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _doBeaconSend(payload, oncomplete) {
                var nav = getNavigator();
                var url = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!url) {
                    _onNoPayloadUrl(oncomplete);
                    // return true here, because we don't want to retry it with fallback sender
                    return true;
                }
                url = payload[_DYN_URL_STRING /* @min:%2eurlString */] + (_addNoResponse ? _noResponseQs : InternalConstants_STR_EMPTY);
                var data = payload[_DYN_DATA /* @min:%2edata */];
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = _isOneDs ? data : new Blob([data], { type: "text/plain;charset=UTF-8" });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - The data payload to be sent.
             * @param sync - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _beaconSender(payload, oncomplete, sync) {
                var data = payload[_DYN_DATA /* @min:%2edata */];
                try {
                    if (data) {
                        // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                        if (!_doBeaconSend(payload, oncomplete)) {
                            var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
                            if (onRetry && ts_utils_isFunction(onRetry)) {
                                onRetry(payload, oncomplete, _doBeaconSend);
                            }
                            else {
                                _fallbackInst && _fallbackInst.sendPOST(payload, oncomplete, true);
                                _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                            }
                        }
                        else {
                            // if can send
                            _onSuccess(InternalConstants_STR_EMPTY, oncomplete); // if success, onComplete is called with status code 200
                        }
                    }
                }
                catch (e) {
                    _isOneDs && _warnToConsole(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + ts_utils_dumpObj(e));
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, InternalConstants_STR_EMPTY);
                }
                return;
            }
            /**
             * Send XMLHttpRequest
             * @param payload - The data payload to be sent.
             * @param sync - Indicates if the request should be sent synchronously
             */
            function _xhrSender(payload, oncomplete, sync) {
                //let  internalPayload = payload as IInternalPayloadData;
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var headers = payload[_DYN_HEADERS /* @min:%2eheaders */] || {};
                if (!sync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                if (_isOneDs && sync && payload.disableXhrSync) {
                    sync = false;
                }
                //const xhr = new XMLHttpRequest();
                var endPointUrl = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                var xhr = openXhr(STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[_DYN_TIMEOUT /* @min:%2etimeout */]);
                if (!_isOneDs) {
                    // application/json should NOT add to 1ds post by default
                    xhr.setRequestHeader("Content-type", "application/json");
                }
                ts_utils_arrForEach(objKeys(headers), function (headerName) {
                    xhr.setRequestHeader(headerName, headers[headerName]);
                });
                xhr.onreadystatechange = function () {
                    if (!_isOneDs) {
                        _doOnReadyFunc(xhr);
                        if (xhr.readyState === 4) {
                            resolveFunc && resolveFunc(true);
                        }
                    }
                };
                xhr.onload = function () {
                    if (_isOneDs) {
                        _doOnReadyFunc(xhr);
                    }
                };
                function _doOnReadyFunc(xhr) {
                    var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
                    var onReadyFuncExist = onReadyFunc && ts_utils_isFunction(onReadyFunc);
                    if (onReadyFuncExist) {
                        onReadyFunc(xhr, oncomplete, payload);
                    }
                    else {
                        var response = getResponseText(xhr);
                        _doOnComplete(oncomplete, xhr[_DYN_STATUS /* @min:%2estatus */], _getAllResponseHeaders(xhr, _isOneDs), response);
                    }
                }
                xhr.onerror = function (event) {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS /* @min:%2estatus */] : 400, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? InternalConstants_STR_EMPTY : formatErrorMessageXhr(xhr));
                    rejectFunc && rejectFunc(event);
                };
                xhr.ontimeout = function () {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS /* @min:%2estatus */] : 500, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? InternalConstants_STR_EMPTY : formatErrorMessageXhr(xhr));
                    resolveFunc && resolveFunc(false);
                };
                xhr.send(payload[_DYN_DATA /* @min:%2edata */]);
                return thePromise;
            }
            /**
             * Send fetch API request
             * @param payload - The data payload to be sent.
             * @param sync - For fetch this identifies whether we are "unloading" (false) or a normal request
             */
            function _doFetchSender(payload, oncomplete, sync) {
                var _a;
                var endPointUrl = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                var batch = payload[_DYN_DATA /* @min:%2edata */];
                var plainTextBatch = _isOneDs ? batch : new Blob([batch], { type: "application/json" });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                var ignoreResponse = false;
                var responseHandled = false;
                var headers = payload[_DYN_HEADERS /* @min:%2eheaders */] || {};
                //TODO: handle time out for 1ds
                var init = (_a = {
                        method: STR_POST_METHOD,
                        body: plainTextBatch
                    },
                    _a[DisabledPropertyName] = true // Mark so we don't attempt to track this request
                ,
                    _a);
                // Only add headers if there are headers to add, due to issue with some polyfills
                if (payload.headers && objKeys(payload.headers)[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    ts_utils_arrForEach(objKeys(headers), function (headerName) {
                        requestHeaders.append(headerName, headers[headerName]);
                    });
                    init[_DYN_HEADERS /* @min:%2eheaders */] = requestHeaders;
                }
                if (_fetchCredentials) { // if user passed in this value via post channel (1ds), then use it
                    init.credentials = _fetchCredentials;
                }
                else if (_sendCredentials && _isOneDs) {
                    // for 1ds, Don't send credentials when URL is file://
                    init.credentials = "include";
                }
                if (sync) {
                    init.keepalive = true;
                    _syncFetchPayload += batchLength;
                    if (_isOneDs) {
                        if (payload["_sendReason"] === 2 /* SendRequestReason.Unload */) {
                            // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                            // just like beacon send assume that the events have been accepted and processed
                            ignoreResponse = true;
                            if (_addNoResponse) {
                                endPointUrl += _noResponseQs;
                            }
                        }
                    }
                    else {
                        // for appinsights, set to true for all sync request
                        ignoreResponse = true;
                    }
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[DisabledPropertyName] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                if (!sync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                function _handleError(res, statusCode) {
                    // In case there is an error in the request. Set the status to 0 for 1ds and 400 for appInsights
                    // so that the events can be retried later.
                    if (statusCode) {
                        _doOnComplete(oncomplete, _isOneDs ? 0 : statusCode, {}, _isOneDs ? InternalConstants_STR_EMPTY : res);
                    }
                    else {
                        _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? InternalConstants_STR_EMPTY : res);
                    }
                }
                function _onFetchComplete(response, payload, value) {
                    var status = response[_DYN_STATUS /* @min:%2estatus */];
                    var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
                    if (onCompleteFunc && ts_utils_isFunction(onCompleteFunc)) {
                        onCompleteFunc(response, oncomplete, value || InternalConstants_STR_EMPTY, payload);
                    }
                    else {
                        _doOnComplete(oncomplete, status, {}, value || InternalConstants_STR_EMPTY);
                    }
                }
                try {
                    doAwaitResponse(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function (result) {
                        if (sync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result[_DYN_VALUE /* @min:%2evalue */];
                                try {
                                    /**
                                     * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                     * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                     * or if anything prevented the request from completing.
                                     */
                                    if (!_isOneDs && !response_1.ok) {
                                        // this is for appInsights only
                                        if (response_1[_DYN_STATUS /* @min:%2estatus */]) {
                                            _handleError(response_1.statusText, response_1[_DYN_STATUS /* @min:%2estatus */]);
                                        }
                                        else {
                                            _handleError(response_1.statusText, 499);
                                        }
                                        resolveFunc && resolveFunc(false);
                                    }
                                    else {
                                        if (_isOneDs && !response_1.body) {
                                            _onFetchComplete(response_1, null, InternalConstants_STR_EMPTY);
                                            resolveFunc && resolveFunc(true);
                                        }
                                        else {
                                            doAwaitResponse(response_1.text(), function (resp) {
                                                _onFetchComplete(response_1, payload, resp[_DYN_VALUE /* @min:%2evalue */]);
                                                resolveFunc && resolveFunc(true);
                                            });
                                        }
                                    }
                                }
                                catch (e) {
                                    if (response_1 && response_1[_DYN_STATUS /* @min:%2estatus */]) {
                                        _handleError(ts_utils_dumpObj(e), response_1[_DYN_STATUS /* @min:%2estatus */]);
                                    }
                                    else {
                                        _handleError(ts_utils_dumpObj(e), 499);
                                    }
                                    rejectFunc && rejectFunc(e);
                                }
                            }
                            else {
                                _handleError(result[_DYN_REASON /* @min:%2ereason */] && result[_DYN_REASON /* @min:%2ereason */][_DYN_MESSAGE /* @min:%2emessage */], 499);
                                rejectFunc && rejectFunc(result[_DYN_REASON /* @min:%2ereason */]);
                            }
                        }
                    });
                }
                catch (e) {
                    if (!responseHandled) {
                        _handleError(ts_utils_dumpObj(e), 499);
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _doOnComplete(oncomplete, 200, {});
                    resolveFunc && resolveFunc(true);
                }
                if (_isOneDs && !responseHandled && payload[_DYN_TIMEOUT /* @min:%2etimeout */] > 0) {
                    // Simulate timeout
                    _timeoutWrapper && _timeoutWrapper.set(function () {
                        if (!responseHandled) {
                            // Assume a 500 response (which will cause a retry)
                            responseHandled = true;
                            _doOnComplete(oncomplete, 500, {});
                            resolveFunc && resolveFunc(true);
                        }
                    }, payload[_DYN_TIMEOUT /* @min:%2etimeout */]);
                }
                return thePromise;
            }
            /**
             * Send XDomainRequest
             * @param payload - The data payload to be sent.
             * @param sync - Indicates if the request should be sent synchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _xdrSender(payload, oncomplete, sync) {
                // It doesn't support custom headers, so no action is taken with current requestHeaders
                var _window = getWindow();
                var xdr = new XDomainRequest();
                var data = payload[_DYN_DATA /* @min:%2edata */];
                xdr.onload = function () {
                    var response = getResponseText(xdr);
                    var onloadFunc = _onCompleteFuncs && _onCompleteFuncs.xdrOnComplete;
                    if (onloadFunc && ts_utils_isFunction(onloadFunc)) {
                        onloadFunc(xdr, oncomplete, payload);
                    }
                    else {
                        _doOnComplete(oncomplete, 200, {}, response);
                    }
                };
                xdr.onerror = function () {
                    _doOnComplete(oncomplete, 400, {}, _isOneDs ? InternalConstants_STR_EMPTY : formatErrorMessageXdr(xdr));
                };
                xdr.ontimeout = function () {
                    _doOnComplete(oncomplete, 500, {});
                };
                xdr.onprogress = _noopVoid;
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || InternalConstants_STR_EMPTY;
                var endpoint = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!endpoint) {
                    _onNoPayloadUrl(oncomplete);
                    return;
                }
                if (!_isOneDs && endpoint.lastIndexOf(hostingProtocol, 0) !== 0) {
                    var msg = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                    _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + msg);
                    _onError(msg, oncomplete);
                    return;
                }
                var endpointUrl = _isOneDs ? endpoint : endpoint[_DynamicConstants_DYN_REPLACE /* @min:%2ereplace */](/^(https?:)/, InternalConstants_STR_EMPTY);
                xdr.open(STR_POST_METHOD, endpointUrl);
                if (payload[_DYN_TIMEOUT /* @min:%2etimeout */]) {
                    xdr[_DYN_TIMEOUT /* @min:%2etimeout */] = payload[_DYN_TIMEOUT /* @min:%2etimeout */];
                }
                xdr.send(data);
                if (_isOneDs && sync) {
                    _timeoutWrapper && _timeoutWrapper.set(function () {
                        xdr.send(data);
                    }, 0);
                }
                else {
                    xdr.send(data);
                }
            }
            function _initDefaults() {
                _syncFetchPayload = 0;
                _isInitialized = false;
                _enableSendPromise = false;
                _diagLog = null;
                _isOneDs = null;
                _onCompleteFuncs = null;
                _disableCredentials = null;
                _fetchCredentials = null;
                _fallbackInst = null;
                _disableXhr = false;
                _disableBeacon = false;
                _disableBeaconSync = false;
                _disableFetchKeepAlive = false;
                _addNoResponse = false;
                _timeoutWrapper = null;
            }
        });
    }
// Removed Stub for SenderPostManager.prototype.initialize.
// Removed Stub for SenderPostManager.prototype.getSyncFetchPayload.
// Removed Stub for SenderPostManager.prototype.SetConfig.
// Removed Stub for SenderPostManager.prototype.getSenderInst.
// Removed Stub for SenderPostManager.prototype.getFallbackInst.
// Removed Stub for SenderPostManager.prototype._doTeardown.
// Removed Stub for SenderPostManager.prototype.preparePayload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    SenderPostManager.__ieDyn=1;

    return SenderPostManager;
}());

//# sourceMappingURL=SenderPostManager.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/AsyncUtils.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * Run the unload function of the target object if it exists
 * @param target - The target object that contains the unload function
 * @param isAsync - The caller identifies whether it is expecting the operation to complete synchronously or asynchronously. Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @returns The result of the target function
 */
function runTargetUnload(target, isAsync) {
    if (target && target[_DYN_UNLOAD /* @min:%2eunload */]) {
        return target[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
    }
}
/**
 * Call the unload function on all targets handling any returned [IPromise](https://nevware21.github.io/ts-async/typedoc/interfaces/IPromise.html)
 * / Promise before calling the next targets unload
 * @param targets - An array of the targets to unload
 * @param isAsync - The caller identifies whether it is expecting the operations to complete synchronously or asynchronously.  Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @param done - Optional callback function to call once all of the unload functions have been called.
 */
function doUnloadAll(targets, isAsync, done) {
    var result;
    if (!done) {
        result = createPromise(function (resolved) {
            done = resolved;
        });
    }
    if (targets && ts_utils_getLength(targets) > 0) {
        doAwaitResponse(runTargetUnload(targets[0], isAsync), function () {
            doUnloadAll(ts_utils_arrSlice(targets, 1), isAsync, done);
        });
    }
    else {
        done();
    }
    return result;
}
//# sourceMappingURL=AsyncUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/ResponseHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * Parses the response from the backend.
 * @param response - XMLHttpRequest or XDomainRequest response
 */
function parseResponse(response, diagLog) {
    try {
        if (response && response !== InternalConstants_STR_EMPTY) {
            var result = EnvUtils_getJSON().parse(response);
            if (result && result[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] && result[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] >= result.itemsAccepted &&
                result.itemsReceived - result.itemsAccepted === result.errors[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                return result;
            }
        }
    }
    catch (e) {
        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + (e[_DynamicConstants_DYN_NAME /* @min:%2ename */] || ts_utils_dumpObj(e)), {
            response: response
        });
    }
    return null;
}
//# sourceMappingURL=ResponseHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/interfaces/ai/contracts/ContextTagKeys.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    __extendsFn(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(createClassFromInterface({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/interfaces/ai/PartAExtensions.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = ( /* #__PURE__ */new ContextTagKeys());
//# sourceMappingURL=PartAExtensions.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Common/Envelope.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Envelope = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[_DynamicConstants_DYN_NAME /* @min:%2ename */] = DataSanitizer_dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_DATA /* @min:%2edata */] = data;
        _self[_DYN_TIME /* @min:%2etime */] = HelperFuncs_toISOString(new Date());
        _self[_DYN_AI_DATA_CONTRACT /* @min:%2eaiDataContract */] = {
            time: 1 /* FieldType.Required */,
            iKey: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* FieldType.Hidden */ : 1 /* FieldType.Required */;
            },
            tags: 1 /* FieldType.Required */,
            data: 1 /* FieldType.Required */
        };
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Event.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Event_Event = /** @class */ (function () {
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self[_DynamicConstants_DYN_NAME /* @min:%2ename */] = DataSanitizer_dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    /**
     * @deprecated Use the constant EventEnvelopeType instead.
     */
    Event.envelopeType = EventEnvelopeType;
    /**
     * @deprecated Use the constant EventDataType instead.
     */
    Event.dataType = EventDataType;
    return Event;
}());

//# sourceMappingURL=Event.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Common/DataPoint.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            name: 1 /* FieldType.Required */,
            kind: 0 /* FieldType.Default */,
            value: 1 /* FieldType.Required */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = 0 /* DataPointType.Measurement */;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Metric.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var Metric = /** @class */ (function () {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            metrics: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new DataPoint();
        dataPoint[_DYN_COUNT /* @min:%2ecount */] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[_DynamicConstants_DYN_NAME /* @min:%2ename */] = DataSanitizer_dataSanitizeString(logger, name) || strNotSpecified;
        dataPoint[_DYN_VALUE /* @min:%2evalue */] = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [dataPoint];
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    /**
     * @deprecated Use the constant MetricEnvelopeType instead.
     */
    Metric.envelopeType = MetricEnvelopeType;
    /**
     * @deprecated Use the constant MetricDataType instead.
     */
    Metric.dataType = MetricDataType;
    return Metric;
}());

//# sourceMappingURL=Metric.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/PageView.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var PageView = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            id: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = dataSanitizeId(logger, id);
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DynamicConstants_DYN_NAME /* @min:%2ename */] = DataSanitizer_dataSanitizeString(logger, name) || strNotSpecified;
        if (!isNaN(durationMs)) {
            _self[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(durationMs);
        }
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    /**
     * @deprecated Use the constant PageViewEnvelopeType instead.
     */
    PageView.envelopeType = PageViewEnvelopeType;
    /**
     * @deprecated Use the constant PageViewDataType instead.
     */
    PageView.dataType = PageViewDataType;
    return PageView;
}());

//# sourceMappingURL=PageView.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/PageViewPerformance.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var PageViewPerformance = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            perfTotal: 0 /* FieldType.Default */,
            networkConnect: 0 /* FieldType.Default */,
            sentRequest: 0 /* FieldType.Default */,
            receivedResponse: 0 /* FieldType.Default */,
            domProcessing: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DynamicConstants_DYN_NAME /* @min:%2ename */] = DataSanitizer_dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[_DYN_DURATION /* @min:%2eduration */] = cs4BaseData[_DYN_DURATION /* @min:%2eduration */];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self.receivedResponse = cs4BaseData.receivedResponse;
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    /**
     * @deprecated Use the constant PageViewPerformanceEnvelopeType instead.
     */
    PageViewPerformance.envelopeType = PageViewPerformanceEnvelopeType;
    /**
     * @deprecated Use the constant PageViewPerformanceDataType instead.
     */
    PageViewPerformance.dataType = PageViewPerformanceDataType;
    return PageViewPerformance;
}());

//# sourceMappingURL=PageViewPerformance.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ai/Trace.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Trace = /** @class */ (function () {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        message = message || strNotSpecified;
        _self[_DYN_MESSAGE /* @min:%2emessage */] = dataSanitizeMessage(logger, message);
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (severityLevel) {
            _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
        }
    }
    /**
     * @deprecated Use the constant TraceEnvelopeType instead.
     */
    Trace.envelopeType = TraceEnvelopeType;
    /**
     * @deprecated Use the constant TraceDataType instead.
     */
    Trace.dataType = TraceDataType;
    return Trace;
}());

//# sourceMappingURL=Trace.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
//# sourceMappingURL=InternalConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/Telemetry/Common/Data.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


function _createData(baseType, data) {
    return {
        baseType: baseType,
        baseData: data,
        aiDataContract: {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        }
    };
}
//# sourceMappingURL=Data.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TAGS = "tags"; // Count: 17
var _DYN_DEVICE_TYPE = "deviceType"; // Count: 3
var _DynamicConstants_DYN_DATA = "data"; // Count: 15
var dist_es5_DynamicConstants_DYN_NAME = "name"; // Count: 10
var dist_es5_DynamicConstants_DYN_TRACE_ID = "traceID"; // Count: 5
var applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH = "length"; // Count: 40
var dist_es5_DynamicConstants_DYN_STRINGIFY = "stringify"; // Count: 5
var _DynamicConstants_DYN_MEASUREMENTS = "measurements"; // Count: 8
var _DYN_RESPONSE_CODE = "responseCode"; // Count: 3
var applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING = "toString"; // Count: 7
var _DYN_ENQUEUE = "enqueue"; // Count: 7
var _DynamicConstants_DYN_COUNT = "count"; // Count: 7
var dist_es5_DynamicConstants_DYN_PUSH = "push"; // Count: 9
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson"; // Count: 3
var _DYN_CLEAR = "clear"; // Count: 6
var _DYN_MARK_AS_SENT = "markAsSent"; // Count: 4
var _DYN_CLEAR_SENT = "clearSent"; // Count: 5
var _DYN_BUFFER_OVERRIDE = "bufferOverride"; // Count: 3
var _DYN__BUFFER__KEY = "BUFFER_KEY"; // Count: 5
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY"; // Count: 8
var _DynamicConstants_DYN_CONCAT = "concat"; // Count: 6
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE"; // Count: 5
var _DYN_TRIGGER_SEND = "triggerSend"; // Count: 5
var dist_es5_DynamicConstants_DYN_DIAG_LOG = "diagLog"; // Count: 16
var dist_es5_DynamicConstants_DYN_INITIALIZE = "initialize"; // Count: 3
var _DYN__SENDER = "_sender"; // Count: 5
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 5
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 5
var _DYN_CUSTOM_HEADERS = "customHeaders"; // Count: 3
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 2
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon"; // Count: 3
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled"; // Count: 3
var _DYN_ALWAYS_USE_XHR_OVERR4 = "alwaysUseXhrOverride"; // Count: 2
var _DYN_ENABLE_SESSION_STORA5 = "enableSessionStorageBuffer"; // Count: 2
var _DYN__BUFFER = "_buffer"; // Count: 9
var _DYN_ONUNLOAD_DISABLE_FET6 = "onunloadDisableFetch"; // Count: 2
var _DYN_DISABLE_SEND_BEACON_7 = "disableSendBeaconSplit"; // Count: 2
var _DYN_GET_SENDER_INST = "getSenderInst"; // Count: 4
var _DYN__ON_ERROR = "_onError"; // Count: 7
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess"; // Count: 3
var _DYN__ON_SUCCESS = "_onSuccess"; // Count: 6
var _DynamicConstants_DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 3
var _DYN_ITEMS_ACCEPTED = "itemsAccepted"; // Count: 3
var _DYN_BASE_TYPE = "baseType"; // Count: 4
var _DYN_SAMPLE_RATE = "sampleRate"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/Telemetry/RemoteDependencyData.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var RemoteDependencyData_RemoteDependencyEnvelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
function RemoteDependencyData_AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        var parsedUrl = UrlHelperFuncs_urlParseUrl(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = DataSanitizer_dataSanitizeString(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = DataSanitizer_dataSanitizeString(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function createRemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
    if (requestAPI === void 0) { requestAPI = "Ajax"; }
    var dependencyFields = RemoteDependencyData_AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
    var data = {
        ver: 2,
        id: id,
        duration: msToTimeSpan(value),
        success: success,
        resultCode: "" + resultCode,
        type: DataSanitizer_dataSanitizeString(logger, requestAPI),
        data: dataSanitizeUrl(logger, commandName) || dependencyFields[_DynamicConstants_DYN_DATA /* @min:%2edata */],
        target: DataSanitizer_dataSanitizeString(logger, dependencyFields.target),
        name: DataSanitizer_dataSanitizeString(logger, dependencyFields[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */]),
        properties: dataSanitizeProperties(logger, properties),
        measurements: dataSanitizeMeasurements(logger, measurements),
        aiDataContract: {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            resultCode: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            success: 0 /* FieldType.Default */,
            data: 0 /* FieldType.Default */,
            target: 0 /* FieldType.Default */,
            type: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            kind: 0 /* FieldType.Default */,
            value: 0 /* FieldType.Default */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */,
            dependencyKind: 0 /* FieldType.Default */,
            dependencySource: 0 /* FieldType.Default */,
            commandName: 0 /* FieldType.Default */,
            dependencyTypeName: 0 /* FieldType.Default */
        }
    };
    if (correlationContext) {
        data.target = "" + data.target + " | " + correlationContext;
    }
    return data;
}
//# sourceMappingURL=RemoteDependencyData.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/Telemetry/RequestData.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var RequestData_RequestEnvelopeType = "Microsoft.ApplicationInsights.{0}.Request";
/**
 * Constructs a new instance of the RequestData object
 */
function createRequestData(logger, id, name, value, success, responseCode, source, url, properties, measurements) {
    var _a;
    return _a = {
            ver: 2,
            id: id,
            name: DataSanitizer_dataSanitizeString(logger, name),
            duration: msToTimeSpan(value),
            success: success
        },
        _a[_DYN_RESPONSE_CODE /* @min:responseCode */] = ts_utils_asString(responseCode || "0"),
        _a.source = DataSanitizer_dataSanitizeString(logger, source),
        _a.url = dataSanitizeUrl(logger, url),
        _a.properties = dataSanitizeProperties(logger, properties),
        _a.measurements = dataSanitizeMeasurements(logger, measurements),
        _a.aiDataContract = {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            responseCode: 1 /* FieldType.Required */,
            duration: 1 /* FieldType.Required */,
            success: 1 /* FieldType.Required */,
            source: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        },
        _a;
}
//# sourceMappingURL=RequestData.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/EnvelopeCreator.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
    return setValue(target, field, value, isTruthy);
}
/*
 * Maps Part A data from CS 4.0
 */
function _extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[_DYN_TAGS /* @min:%2etags */] = env[_DYN_TAGS /* @min:%2etags */] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[_DYN_TAGS /* @min:%2etags */] = item[_DYN_TAGS /* @min:%2etags */] || {};
    var extUser = itmExt.user;
    if (extUser) {
        _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
        _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) {
        _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
    }
    var extDevice = itmExt.device;
    if (extDevice) {
        _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice.deviceClass);
        _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
        _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice[_DYN_DEVICE_TYPE /* @min:%2edeviceType */]);
    }
    var web = item.ext.web;
    if (web) {
        _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
        _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
        _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
        var envData = env[_DynamicConstants_DYN_DATA /* @min:%2edata */] = env[_DynamicConstants_DYN_DATA /* @min:%2edata */] || {};
        var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
        var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
        _setValueIf(envProps, "domain", web.domain);
        _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
        _setValueIf(envProps, "screenRes", web.screenRes);
        _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */]);
        _setValueIf(envTags, CtxTagKeys.deviceOSVersion, extOs.osVer);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
        _setValueIf(envTags, CtxTagKeys.operationName, DataSanitizer_dataSanitizeString(logger, extTrace[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */]));
        _setValueIf(envTags, CtxTagKeys.operationId, extTrace[dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for (var i = itmTags[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1; i >= 0; i--) {
        var tg = itmTags[i];
        ts_utils_objForEachKey(tg, function (key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    ts_utils_objForEachKey(itmTags, function (tg, value) {
        tgs[tg] = value;
    });
    var theTags = __assignFn(__assignFn({}, envTags), tgs);
    if (!theTags[CtxTagKeys.internalSdkVersion]) {
        // Append a version in case it is not already set
        theTags[CtxTagKeys.internalSdkVersion] = DataSanitizer_dataSanitizeString(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
    }
    env[_DYN_TAGS /* @min:%2etags */] = optimizeObject(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
    if (!ts_utils_isNullOrUndefined(data)) {
        ts_utils_objForEachKey(data, function (key, value) {
            if (ts_utils_isNumber(value)) {
                measurements[key] = value;
            }
            else if (ts_utils_isString(value)) {
                properties[key] = value;
            }
            else if (hasJSON()) {
                properties[key] = EnvUtils_getJSON()[dist_es5_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](value);
            }
        });
    }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!ts_utils_isNullOrUndefined(properties)) {
        ts_utils_objForEachKey(properties, function (key, value) {
            properties[key] = value || customUndefinedValue;
        });
    }
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new Envelope(logger, data, envelopeType);
    _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
    var startTime = (telemetryItem[strBaseData] || {}).startTime;
    if (ts_utils_isDate(startTime)) {
        // Starting from Version 3.0.3, the time property will be assigned by the startTime value,
        // which records the loadEvent time for the pageView event.
        envelope.time = HelperFuncs_toISOString(startTime);
    }
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */] = envelope[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    _extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[_DYN_TAGS /* @min:%2etags */] = telemetryItem[_DYN_TAGS /* @min:%2etags */] || [];
    return optimizeObject(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
    if (ts_utils_isNullOrUndefined(telemetryItem[strBaseData])) {
        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */, "telemetryItem.baseData cannot be null.");
    }
}
var EnvelopeCreator = {
    Version: '3.4.1'
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    if (ts_utils_isNullOrUndefined(bd)) {
        _warnToConsole(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
    var remoteDepData = createRemoteDependencyData(logger, bd.id, bd.target, bd[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */], bd[STR_DURATION /* @min:%2eduration */], bd.success, bd[_DYN_RESPONSE_CODE /* @min:%2eresponseCode */], method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = _createData(RemoteDependencyDataType, remoteDepData);
    return _createEnvelope(logger, RemoteDependencyData_RemoteDependencyEnvelopeType, telemetryItem, data);
}
function RequestEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    var requestData = createRequestData(logger, bd.id, bd[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */], bd[STR_DURATION /* @min:%2eduration */], bd.success, bd[_DYN_RESPONSE_CODE /* @min:%2eresponseCode */], bd.source, bd.url, customProperties, customMeasurements);
    var data = _createData(RequestDataType, requestData);
    return _createEnvelope(logger, RequestDataType, telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[strBaseType] !== EventDataType) {
        customProperties["baseTypeSource"] = telemetryItem[strBaseType]; // save the passed in base type as a property
    }
    if (telemetryItem[strBaseType] === EventDataType) { // take collection
        customProperties = telemetryItem[strBaseData][strProperties] || {};
        customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    }
    else { // if its not a known type, convert to custom event
        if (telemetryItem[strBaseData]) {
            _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
        }
    }
    // Extract root level properties from part C telemetryItem.data
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var eventName = telemetryItem[strBaseData][dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */];
    var eventData = new Event_Event(logger, eventName, customProperties, customMeasurements);
    var data = _createData(EventDataType, eventData);
    return _createEnvelope(logger, EventEnvelopeType, telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = _createData(ExceptionDataType, exData);
    return _createEnvelope(logger, ExceptionEnvelopeType, telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[strBaseData];
    var props = baseData[strProperties] || {};
    var measurements = baseData[_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseMetricData = new Metric(logger, baseData[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = _createData(MetricDataType, baseMetricData);
    return _createEnvelope(logger, MetricEnvelopeType, telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[strBaseData];
    if (!ts_utils_isNullOrUndefined(baseData) &&
        !ts_utils_isNullOrUndefined(baseData[strProperties]) &&
        !ts_utils_isNullOrUndefined(baseData[strProperties][STR_DURATION])) { // from part B properties
        duration = baseData[strProperties][STR_DURATION];
        delete baseData[strProperties][STR_DURATION];
    }
    else if (!ts_utils_isNullOrUndefined(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */]) &&
        !ts_utils_isNullOrUndefined(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */][STR_DURATION])) { // from custom properties
        duration = telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */][STR_DURATION];
        delete telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */][STR_DURATION];
    }
    var bd = telemetryItem[strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]) {
        currentContextId = telemetryItem.ext.trace[dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */];
    }
    var id = bd.id || currentContextId;
    var name = bd[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */];
    var url = bd.uri;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!ts_utils_isNullOrUndefined(bd.refUri)) {
        properties["refUri"] = bd.refUri;
    }
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!ts_utils_isNullOrUndefined(bd.pageType)) {
        properties["pageType"] = bd.pageType;
    }
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!ts_utils_isNullOrUndefined(bd.isLoggedIn)) {
        properties["isLoggedIn"] = bd.isLoggedIn[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
    }
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!ts_utils_isNullOrUndefined(bd[strProperties])) {
        var pageTags = bd[strProperties];
        ts_utils_objForEachKey(pageTags, function (key, value) {
            properties[key] = value;
        });
    }
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
    var data = _createData(PageViewDataType, pageViewData);
    return _createEnvelope(logger, PageViewEnvelopeType, telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[strBaseData];
    var name = bd[dist_es5_DynamicConstants_DYN_NAME /* @min:%2ename */];
    var url = bd.uri || bd.url;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
    var data = _createData(PageViewPerformanceDataType, baseData);
    return _createEnvelope(logger, PageViewPerformanceEnvelopeType, telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[strBaseData].message;
    var severityLevel = telemetryItem[strBaseData].severityLevel;
    var props = telemetryItem[strBaseData][strProperties] || {};
    var measurements = telemetryItem[strBaseData][_DynamicConstants_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DynamicConstants_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!ts_utils_isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseData = new Trace(logger, message, severityLevel, props, measurements);
    var data = _createData(TraceDataType, baseData);
    return _createEnvelope(logger, TraceEnvelopeType, telemetryItem, data);
}
//# sourceMappingURL=EnvelopeCreator.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/SendBuffer.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var BaseSendBuffer = /** @class */ (function () {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        var _maxRetryCnt = config.maxRetryCnt;
        this._get = function () {
            return _buffer;
        };
        this._set = function (buffer) {
            _buffer = buffer;
            return _buffer;
        };
        dynamicProto(BaseSendBuffer, this, function (_self) {
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() >= config.eventsLimitInMem) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 105 /* _eInternalMessageId.InMemoryStorageBufferFull */, "Maximum in-memory buffer size reached: " + _self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                payload.cnt = payload.cnt || 0;
                // max retry is defined, and max retry is reached, do not add the payload to buffer
                if (!ts_utils_isNullOrUndefined(_maxRetryCnt)) {
                    if (payload.cnt > _maxRetryCnt) {
                        // TODO: add log here on dropping payloads
                        // will log statsbeat exception later here
                        return;
                    }
                }
                _buffer[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](payload);
                return;
            };
            _self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */] = function () {
                return _buffer[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
            };
            _self.size = function () {
                var size = _buffer[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                for (var lp = 0; lp < _buffer[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
                    size += (_buffer[lp].item)[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                }
                if (!config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */]) {
                    size += 2;
                }
                return size;
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function (payloads) {
                if (payloads && payloads[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    var payloadStr_1 = [];
                    ts_utils_arrForEach(payloads, function (payload) {
                        payloadStr_1[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](payload.item);
                    });
                    var batch = config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */] ?
                        payloadStr_1.join("\n") :
                        "[" + payloadStr_1.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self.createNew = function (newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                ts_utils_arrForEach(items, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                return newBuffer;
            };
        });
    }
// Removed Stub for BaseSendBuffer.prototype.enqueue.
// Removed Stub for BaseSendBuffer.prototype.count.
// Removed Stub for BaseSendBuffer.prototype.size.
// Removed Stub for BaseSendBuffer.prototype.clear.
// Removed Stub for BaseSendBuffer.prototype.getItems.
// Removed Stub for BaseSendBuffer.prototype.batchPayloads.
// Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn=1;

    return BaseSendBuffer;
}());
/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */ (function (_super) {
    __extendsFn(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        dynamicProto(ArraySendBuffer, _this, function (_self, _base) {
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                // not supported
            };
        });
        return _this;
    }
// Removed Stub for ArraySendBuffer.prototype.markAsSent.
// Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn=1;

    return ArraySendBuffer;
}(BaseSendBuffer));

var PREVIOUS_KEYS = ["AI_buffer", "AI_sentBuffer"];
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */ (function (_super) {
    __extendsFn(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === void 0 ? void 0 : config.namePrefix;
        // TODO: add remove buffer override as well
        var _b = config[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */] || { getItem: utlGetSessionStorage, setItem: utlSetSessionStorage }, getItem = _b.getItem, setItem = _b.setItem;
        var _maxRetryCnt = config.maxRetryCnt;
        dynamicProto(SessionStorageSendBuffer, _this, function (_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */]);
            var itemsInSentBuffer = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
            var previousItems = _getPreviousEvents();
            var notDeliveredItems = itemsInSentBuffer[_DynamicConstants_DYN_CONCAT /* @min:%2econcat */](previousItems);
            var buffer = _self._set(bufferItems[_DynamicConstants_DYN_CONCAT /* @min:%2econcat */](notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                buffer[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
            }
            _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
            _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], buffer);
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Maximum buffer size reached: " + _self[_DynamicConstants_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                payload.cnt = payload.cnt || 0;
                // max retry is defined, and max retry is reached, do not add the payload to buffer
                if (!ts_utils_isNullOrUndefined(_maxRetryCnt)) {
                    if (payload.cnt > _maxRetryCnt) {
                        // TODO: add log here on dropping payloads
                        return;
                    }
                }
                _base[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._get());
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._get());
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
                _bufferFullMessageSent = false;
            };
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements[_DynamicConstants_DYN_CONCAT /* @min:%2econcat */](payload);
                    if (sentElements[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Sent buffer reached its maximum size: " + sentElements[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */], true);
                        sentElements[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
                    }
                    _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
                }
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
            };
            _self.createNew = function (newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self._get().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[_DYN_CLEAR /* @min:%2eclear */]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                ts_utils_arrForEach(unsentItems, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                if (canUseSessionStorage) {
                    // arr buffer will clear all payloads if markAsSent() is called
                    newBuffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](sentItems);
                }
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                var payloadStr = [];
                ts_utils_arrForEach(payloads, function (payload) {
                    payloadStr[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](payload.item);
                });
                ts_utils_arrForEach(buffer, function (value) {
                    if (!ts_utils_isFunction(value) && ts_utils_arrIndexOf(payloadStr, value.item) === -1) {
                        remaining[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](value);
                    }
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                return _getBufferBase(prefixedKey);
            }
            function _getBufferBase(key) {
                try {
                    var bufferJson = getItem(logger, key);
                    if (bufferJson) {
                        var buffer_1 = EnvUtils_getJSON().parse(bufferJson);
                        if (ts_utils_isString(buffer_1)) {
                            // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                            buffer_1 = EnvUtils_getJSON().parse(buffer_1);
                        }
                        if (buffer_1 && ts_utils_isArray(buffer_1)) {
                            return buffer_1;
                        }
                    }
                }
                catch (e) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */, " storage key: " + key + ", " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[dist_es5_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                }
                catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[dist_es5_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */]([]));
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: ts_utils_dumpObj(e) });
                }
            }
            // this removes buffer with prefix+key
            function _getPreviousEvents() {
                var items = [];
                try {
                    ts_utils_arrForEach(PREVIOUS_KEYS, function (key) {
                        var events = _getItemsFromPreviousKey(key);
                        items = items[_DynamicConstants_DYN_CONCAT /* @min:%2econcat */](events);
                        // to make sure that we also transfer items from old prefixed + key buffer
                        if (_namePrefix) {
                            var prefixedKey = _namePrefix + "_" + key;
                            var prefixEvents = _getItemsFromPreviousKey(prefixedKey);
                            items = items[_DynamicConstants_DYN_CONCAT /* @min:%2econcat */](prefixEvents);
                        }
                    });
                    return items;
                }
                catch (e) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, "Transfer events from previous buffers: " + getExceptionName(e) + ". previous Buffer items can not be removed", { exception: ts_utils_dumpObj(e) });
                }
                return [];
            }
            // transform string[] to IInternalStorageItem[]
            function _getItemsFromPreviousKey(key) {
                try {
                    var items = _getBufferBase(key);
                    var transFormedItems_1 = [];
                    ts_utils_arrForEach(items, function (item) {
                        var internalItem = {
                            item: item,
                            cnt: 0 // previous events will be default to 0 count
                        };
                        transFormedItems_1[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](internalItem);
                    });
                    // remove the session storage if we can add events back
                    utlRemoveSessionStorage(logger, key);
                    return transFormedItems_1;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return [];
            }
        });
        return _this;
    }
// Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
// Removed Stub for SessionStorageSendBuffer.prototype.clear.
// Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
// Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
// Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    var _a;
    _a = SessionStorageSendBuffer;
    SessionStorageSendBuffer.VERSION = "_1";
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer" + _a.VERSION;
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer" + _a.VERSION;
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}(BaseSendBuffer));

//# sourceMappingURL=SendBuffer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/Serializer.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Used to "tag" objects that are currently being serialized to detect circular references
 */
var circularReferenceCheck = "__aiCircularRefCheck";
function _serializeObject(logger, source, name) {
    var output = {};
    if (!source) {
        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, "cannot serialize object because it is null or undefined", { name: name }, true);
        return output;
    }
    if (source[circularReferenceCheck]) {
        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 50 /* _eInternalMessageId.CircularReferenceDetected */, "Circular reference detected while serializing object", { name: name }, true);
        return output;
    }
    if (!source.aiDataContract) {
        // special case for measurements/properties/tags
        if (name === "measurements") {
            output = _serializeStringMap(logger, source, 2 /* eSerializeType.Number */, name);
        }
        else if (name === "properties") {
            output = _serializeStringMap(logger, source, 1 /* eSerializeType.String */, name);
        }
        else if (name === "tags") {
            output = _serializeStringMap(logger, source, 1 /* eSerializeType.String */, name);
        }
        else if (ts_utils_isArray(source)) {
            output = _serializeArray(logger, source, name);
        }
        else {
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
            try {
                // verify that the object can be stringified
                EnvUtils_getJSON()[dist_es5_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](source);
                output = source;
            }
            catch (e) {
                // if serialization fails return an empty string
                _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && ts_utils_isFunction(e[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */])) ? e[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
            }
        }
        return output;
    }
    source[circularReferenceCheck] = true;
    ts_utils_objForEachKey(source.aiDataContract, function (field, contract) {
        var fieldType = ts_utils_isFunction(contract) ? contract() : contract;
        var isRequired = fieldType & 1 /* FieldType.Required */;
        var isHidden = fieldType & 4 /* FieldType.Hidden */;
        var isArray = fieldType & 2 /* FieldType.Array */;
        var isPresent = source[field] !== undefined;
        var isObj = ts_utils_isObject(source[field]) && source[field] !== null;
        if (isRequired && !isPresent && !isArray) {
            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
            // If not in debug mode, continue and hope the error is permissible
        }
        else if (!isHidden) { // Don't serialize hidden fields
            var value = void 0;
            if (isObj) {
                if (isArray) {
                    // special case; recurse on each object in the source array
                    value = _serializeArray(logger, source[field], field);
                }
                else {
                    // recurse on the source object in this field
                    value = _serializeObject(logger, source[field], field);
                }
            }
            else {
                // assign the source field to the output even if undefined or required
                value = source[field];
            }
            // only emit this field if the value is defined
            if (value !== undefined) {
                output[field] = value;
            }
        }
    });
    delete source[circularReferenceCheck];
    return output;
}
function _serializeArray(logger, sources, name) {
    var output;
    if (!!sources) {
        if (!ts_utils_isArray(sources)) {
            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 54 /* _eInternalMessageId.ItemNotInArray */, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
        }
        else {
            output = [];
            for (var i = 0; i < sources[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; i++) {
                var source = sources[i];
                var item = _serializeObject(logger, source, name + "[" + i + "]");
                output[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](item);
            }
        }
    }
    return output;
}
function _serializeStringMap(logger, map, expectedType, name) {
    var output;
    if (map) {
        output = {};
        ts_utils_objForEachKey(map, function (field, value) {
            var serializedValue;
            if (value === undefined) {
                serializedValue = "undefined";
            }
            else if (value === null) {
                serializedValue = "null";
            }
            if (expectedType === 1 /* eSerializeType.String */ && !serializedValue) {
                if (!value[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]) {
                    serializedValue = "invalid field: toString() is not defined.";
                }
                else {
                    serializedValue = value[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]();
                }
            }
            else if (expectedType === 2 /* eSerializeType.Number */ && !serializedValue) {
                serializedValue = parseFloat(value);
            }
            if (serializedValue || !ts_utils_isNullOrUndefined(value)) {
                output[field] = serializedValue;
            }
        });
    }
    return output;
}
var Serializer = /** @class */ (function () {
    function Serializer(logger) {
        dynamicProto(Serializer, this, function (_self) {
            /**
             * Serializes the current object to a JSON string.
             */
            _self.serialize = function (input) {
                var output = _serializeObject(logger, input, "root");
                try {
                    return EnvUtils_getJSON()[dist_es5_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](output);
                }
                catch (e) {
                    // if serialization fails return an empty string
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && ts_utils_isFunction(e[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */])) ? e[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
            };
        });
    }
// Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn=1;

    return Serializer;
}());

//# sourceMappingURL=Serializer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/TelemetryProcessors/SamplingScoreGenerators/HashCodeScoreGenerator.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
// We're using 32 bit math, hence max value is (2^31 - 1)
var INT_MAX_VALUE = 2147483647;
function getHashCodeScore(key) {
    var score = 0;
    var input = key;
    if (input) {
        while (input[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] < MIN_INPUT_LENGTH) {
            input = input[_DynamicConstants_DYN_CONCAT /* @min:%2econcat */](input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        score = mathAbs(hash) / INT_MAX_VALUE;
    }
    return score * 100;
}
//# sourceMappingURL=HashCodeScoreGenerator.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/TelemetryProcessors/SamplingScoreGenerators/SamplingScoreGenerator.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





function createSamplingScoreGenerator() {
    var keys = new ContextTagKeys();
    return {
        getScore: function (item) {
            var score = 0;
            if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.userId]) { // search in tags first, then ext
                score = getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.userId]);
            }
            else if (item.ext && item.ext.user && item.ext.user.id) {
                score = getHashCodeScore(item.ext.user.id);
            }
            else if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.operationId]) { // search in tags first, then ext
                score = getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.operationId]);
            }
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]) {
                score = getHashCodeScore(item.ext.telemetryTrace[dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceID */]);
            }
            else {
                // tslint:disable-next-line:insecure-random
                score = (Math.random() * 100);
            }
            return score;
        }
    };
}
//# sourceMappingURL=SamplingScoreGenerator.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/TelemetryProcessors/Sample.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





function _isSampledIn(envelope, samplingPercentage, scoreGenerator) {
    var isSampledIn = false;
    if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
        isSampledIn = true;
    }
    else if (envelope[_DYN_BASE_TYPE /* @min:%2ebaseType */] === MetricDataType) {
        // exclude MetricData telemetry from sampling
        isSampledIn = true;
    }
    if (!isSampledIn) {
        isSampledIn = scoreGenerator.getScore(envelope) < samplingPercentage;
    }
    return isSampledIn;
}
function createSampler(sampleRate, logger) {
    var _samplingScoreGenerator = createSamplingScoreGenerator();
    if (sampleRate > 100 || sampleRate < 0) {
        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
        sampleRate = 100;
    }
    var sampler = {
        sampleRate: sampleRate,
        generator: _samplingScoreGenerator,
        isSampledIn: function (envelope) {
            return _isSampledIn(envelope, sampler[_DYN_SAMPLE_RATE /* @min:%2esampleRate */], sampler.generator);
        }
    };
    return sampler;
}
//# sourceMappingURL=Sample.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-channel-js/dist-es5/Sender.js
/*
 * Application Insights JavaScript SDK - Channel, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Sender_a, Sender_b;










var Sender_UNDEFINED_VALUE = undefined;
var EMPTY_STR = "";
var FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function _getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function isOverrideFn(httpXHROverride) {
    return httpXHROverride && httpXHROverride.sendPOST;
}
var defaultAppInsightsChannelConfig = ts_utils_objDeepFreeze((Sender_a = {
        // Use the default value (handles empty string in the configuration)
        endpointUrl: cfgDfValidate(isTruthy, DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH)
    },
    Sender_a[_DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */] = cfgDfBoolean(),
    Sender_a.maxBatchInterval = 15000,
    Sender_a[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */] = 102400,
    Sender_a.disableTelemetry = cfgDfBoolean(),
    Sender_a[_DYN_ENABLE_SESSION_STORA5 /* @min:enableSessionStorageBuffer */] = cfgDfBoolean(true),
    Sender_a.isRetryDisabled = cfgDfBoolean(),
    Sender_a[_DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */] = cfgDfBoolean(true),
    Sender_a[_DYN_DISABLE_SEND_BEACON_7 /* @min:disableSendBeaconSplit */] = cfgDfBoolean(true),
    Sender_a.disableXhr = cfgDfBoolean(),
    Sender_a[_DYN_ONUNLOAD_DISABLE_FET6 /* @min:onunloadDisableFetch */] = cfgDfBoolean(),
    Sender_a[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */] = cfgDfBoolean(),
    Sender_a[_DYN_INSTRUMENTATION_KEY /* @min:instrumentationKey */] = Sender_UNDEFINED_VALUE,
    Sender_a.namePrefix = Sender_UNDEFINED_VALUE,
    Sender_a.samplingPercentage = cfgDfValidate(Sender_chkSampling, 100),
    Sender_a[_DYN_CUSTOM_HEADERS /* @min:customHeaders */] = Sender_UNDEFINED_VALUE,
    Sender_a.convertUndefined = Sender_UNDEFINED_VALUE,
    Sender_a.eventsLimitInMem = 10000,
    Sender_a[_DYN_BUFFER_OVERRIDE /* @min:bufferOverride */] = false,
    Sender_a.httpXHROverride = { isVal: isOverrideFn, v: Sender_UNDEFINED_VALUE },
    Sender_a[_DYN_ALWAYS_USE_XHR_OVERR4 /* @min:alwaysUseXhrOverride */] = cfgDfBoolean(),
    Sender_a.transports = Sender_UNDEFINED_VALUE,
    Sender_a.retryCodes = Sender_UNDEFINED_VALUE,
    Sender_a.corsPolicy = Sender_UNDEFINED_VALUE,
    Sender_a.maxRetryCnt = { isVal: ts_utils_isNumber, v: 10 },
    Sender_a));
var CrossOriginResourcePolicyHeader = "X-Set-Cross-Origin-Resource-Policy";
function Sender_chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var EnvelopeTypeCreator = (Sender_b = {},
    Sender_b[EventDataType] = EventEnvelopeCreator,
    Sender_b[TraceDataType] = TraceEnvelopeCreator,
    Sender_b[PageViewDataType] = PageViewEnvelopeCreator,
    Sender_b[PageViewPerformanceDataType] = PageViewPerformanceEnvelopeCreator,
    Sender_b[ExceptionDataType] = ExceptionEnvelopeCreator,
    Sender_b[MetricDataType] = MetricEnvelopeCreator,
    Sender_b[RemoteDependencyDataType] = DependencyEnvelopeCreator,
    Sender_b[RequestDataType] = RequestEnvelopeCreator,
    Sender_b);
var Sender = /** @class */ (function (_super) {
    __extendsFn(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = BreezeChannelIdentifier;
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _beaconOnUnloadSupported;
        var _beaconNormalSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        var _alwaysUseCustomSend;
        var _disableXhr;
        var _fetchKeepAlive;
        var _xhrSend;
        var _fallbackSend;
        var _disableBeaconSplit;
        var _sendPostMgr;
        var _retryCodes;
        var _zipPayload;
        dynamicProto(Sender, _this, function (_self, _base) {
            _initDefaults();
            _self.pause = function () {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function () {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function (isAsync, callBack, sendReason) {
                if (isAsync === void 0) { isAsync = true; }
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        var result_1 = _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */);
                        // Handles non-promise and always called if the returned promise resolves or rejects
                        return doAwaitResponse(result_1, function (rsp) {
                            if (callBack) {
                                callBack(!rsp.rejected);
                                return true;
                            }
                            // When async=true and no callback, return a promise
                            if (isAsync) {
                                return createPromise(function (resolve) {
                                    resolve(!rsp.rejected);
                                });
                            }
                            return result_1;
                        });
                    }
                    catch (e) {
                        _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 22 /* _eInternalMessageId.FlushFailed */, "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                    }
                }
            };
            _self.onunloadFlush = function () {
                if (!_paused) {
                    if (_beaconSupported || _alwaysUseCustomSend) {
                        try {
                            return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, _doUnloadSend, 2 /* SendRequestReason.Unload */);
                        }
                        catch (e) {
                            _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                        }
                    }
                    else {
                        _self.flush(false);
                    }
                }
            };
            _self.addHeader = function (name, value) {
                _headers[name] = value;
            };
            _self[dist_es5_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _base[dist_es5_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */](config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new Serializer(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                _evtNamespace = mergeEvtNamespace(DataCacheHelper_createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = createOfflineListener(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function (details) {
                    var config = details.cfg;
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    var ctx = createProcessTelemetryContext(null, config, core);
                    // getExtCfg only finds undefined values from core
                    var senderConfig = ctx.getExtCfg(identifier, defaultAppInsightsChannelConfig);
                    var curExtUrl = senderConfig[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */];
                    // if it is not inital change (_endpointUrl has value)
                    // if current sender endpoint url is not changed directly
                    // means ExtCfg is not changed directly
                    // then we need to monitor endpoint url changes from core
                    if (_endpointUrl && curExtUrl === _endpointUrl) {
                        var coreUrl = config[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */];
                        // if core endpoint url is changed
                        if (coreUrl && coreUrl !== curExtUrl) {
                            // and endpoint promise changes is handled by this as well
                            senderConfig[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = coreUrl;
                        }
                    }
                    var csStream = ts_utils_getInst("CompressionStream");
                    // Determine whether to enable payload compression (zipping).
                    _zipPayload = isFeatureEnabled("zipPayload", config, false);
                    if (!ts_utils_isFunction(csStream)) {
                        _zipPayload = false;
                    }
                    var corsPolicy = senderConfig.corsPolicy;
                    if (corsPolicy) {
                        if (corsPolicy === "same-origin" || corsPolicy === "same-site" || corsPolicy === "cross-origin") {
                            _this.addHeader(CrossOriginResourcePolicyHeader, corsPolicy);
                        }
                    }
                    else {
                        delete _headers[CrossOriginResourcePolicyHeader];
                    }
                    if (ts_utils_isPromiseLike(senderConfig[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */])) {
                        // if it is promise, means the endpoint url is from core.endpointurl
                        senderConfig[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */] = config[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
                    }
                    ts_utils_objDefine(_self, "_senderConfig", {
                        g: function () {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */]) {
                        if (_orgEndpointUrl) {
                            // TODO: add doc to remind users to flush before changing endpoint, otherwise all unsent payload will be sent to new endpoint
                        }
                        _endpointUrl = _orgEndpointUrl = senderConfig[_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */];
                    }
                    // or is not string
                    if (core.activeStatus() === ActiveStatus.PENDING) {
                        // waiting for core promises to be resolved
                        // NOTE: if active status is set to pending, stop sending, clear timer here
                        _self.pause();
                    }
                    else if (core.activeStatus() === ActiveStatus.ACTIVE) {
                        // core status changed from pending to other status
                        _self.resume();
                    }
                    if (_customHeaders && _customHeaders !== senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */]) {
                        // Removing any previously defined custom headers as they have changed
                        ts_utils_arrForEach(_customHeaders, function (customHeader) {
                            delete _headers[customHeader.header];
                        });
                    }
                    _maxBatchSizeInBytes = senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */];
                    _beaconSupported = (senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false || senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false) && isBeaconsSupported();
                    _beaconOnUnloadSupported = senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false && isBeaconsSupported();
                    _beaconNormalSupported = senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false && isBeaconsSupported();
                    _alwaysUseCustomSend = senderConfig[_DYN_ALWAYS_USE_XHR_OVERR4 /* @min:%2ealwaysUseXhrOverride */];
                    _disableXhr = !!senderConfig.disableXhr;
                    _retryCodes = senderConfig.retryCodes;
                    var bufferOverride = senderConfig[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */];
                    var canUseSessionStorage = !!senderConfig[_DYN_ENABLE_SESSION_STORA5 /* @min:%2eenableSessionStorageBuffer */] &&
                        (!!bufferOverride || utlCanUseSessionStorage());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = (canUseSessionStorage !== _sessionStorageUsed)
                        || (canUseSessionStorage && (_namePrefix !== namePrefix)) // prefixName is only used in session storage
                        || (canUseSessionStorage && (_bufferOverrideUsed !== bufferOverride));
                    if (_self[_DYN__BUFFER /* @min:%2e_buffer */]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) {
                            try {
                                _self[_DYN__BUFFER /* @min:%2e_buffer */] = _self[_DYN__BUFFER /* @min:%2e_buffer */].createNew(diagLog, senderConfig, canUseSessionStorage);
                            }
                            catch (e) {
                                _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                            }
                        }
                        _checkMaxSize();
                    }
                    else {
                        _self[_DYN__BUFFER /* @min:%2e_buffer */] = canUseSessionStorage
                            ? new SessionStorageSendBuffer(diagLog, senderConfig) : new ArraySendBuffer(diagLog, senderConfig);
                    }
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _fetchKeepAlive = !senderConfig[_DYN_ONUNLOAD_DISABLE_FET6 /* @min:%2eonunloadDisableFetch */] && isFetchSupported(true);
                    _disableBeaconSplit = !!senderConfig[_DYN_DISABLE_SEND_BEACON_7 /* @min:%2edisableSendBeaconSplit */];
                    _self._sample = createSampler(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
                    if (!ts_utils_isPromiseLike(_instrumentationKey) && !_validateInstrumentationKey(_instrumentationKey, config)) {
                        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, "Invalid Instrumentation key " + _instrumentationKey);
                    }
                    _customHeaders = senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */];
                    if (ts_utils_isString(_endpointUrl) && !isInternalApplicationInsightsEndpoint(_endpointUrl) && _customHeaders && _customHeaders[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                        ts_utils_arrForEach(_customHeaders, function (customHeader) {
                            _this.addHeader(customHeader.header, customHeader.value);
                        });
                    }
                    else {
                        _customHeaders = null;
                    }
                    _enableSendPromise = senderConfig.enableSendPromise;
                    var sendPostConfig = _getSendPostMgrConfig();
                    // only init it once
                    if (!_sendPostMgr) {
                        _sendPostMgr = new SenderPostManager();
                        _sendPostMgr[dist_es5_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */](sendPostConfig, diagLog);
                    }
                    else {
                        _sendPostMgr.SetConfig(sendPostConfig);
                    }
                    var customInterface = senderConfig.httpXHROverride;
                    var httpInterface = null;
                    var syncInterface = null;
                    // User requested transport(s) values > Beacon > Fetch > XHR
                    // Beacon would be filtered out if user has set disableBeaconApi to true at _getSenderInterface
                    var theTransports = prependTransports([3 /* TransportType.Beacon */, 1 /* TransportType.Xhr */, 2 /* TransportType.Fetch */], senderConfig.transports);
                    httpInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */](theTransports, false);
                    var xhrInterface = _sendPostMgr && _sendPostMgr.getFallbackInst();
                    _xhrSend = function (payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync);
                    };
                    _fallbackSend = function (payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync, false);
                    };
                    httpInterface = _alwaysUseCustomSend ? customInterface : (httpInterface || customInterface || xhrInterface);
                    _self[_DYN__SENDER /* @min:%2e_sender */] = function (payload, isAsync) {
                        return _doSend(httpInterface, payload, isAsync);
                    };
                    if (_fetchKeepAlive) {
                        // Try and use the fetch with keepalive
                        _syncUnloadSender = _fetchKeepAliveSender;
                    }
                    var syncTransports = prependTransports([3 /* TransportType.Beacon */, 1 /* TransportType.Xhr */], senderConfig.unloadTransports);
                    if (!_fetchKeepAlive) {
                        // remove fetch from theTransports
                        syncTransports = syncTransports.filter(function (transport) { return transport !== 2 /* TransportType.Fetch */; });
                    }
                    syncInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */](syncTransports, true);
                    syncInterface = _alwaysUseCustomSend ? customInterface : (syncInterface || customInterface);
                    if ((_alwaysUseCustomSend || senderConfig.unloadTransports || !_syncUnloadSender) && syncInterface) {
                        _syncUnloadSender = function (payload, isAsync) {
                            return _doSend(syncInterface, payload, isAsync);
                        };
                    }
                    if (!_syncUnloadSender) {
                        _syncUnloadSender = _xhrSend;
                    }
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig.convertUndefined || Sender_UNDEFINED_VALUE;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig.maxBatchInterval;
                }));
            };
            _self.processTelemetry = function (telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    var isValidate = _validate(telemetryItem, diagLogger);
                    if (!isValidate) {
                        return;
                    }
                    var aiEnvelope = _getEnvelope(telemetryItem, diagLogger);
                    if (!aiEnvelope) {
                        return;
                    }
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                    _checkMaxSize(payload);
                    var payloadItem = {
                        item: payload,
                        cnt: 0 // inital cnt will always be 0
                    };
                    // enqueue the payload
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payloadItem);
                    // ensure an invocation timeout is set
                    _setupTimer();
                }
                catch (e) {
                    _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            _self.isCompletelyIdle = function () {
                return !_paused && _syncFetchPayload === 0 && _self._buffer[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() === 0;
            };
            _self.getOfflineListener = function () {
                return _offlineListener;
            };
            /**
             * xhr state changes
             */
            _self._xhrReadyStateChange = function (xhr, payload, countOfItemsInPayload) {
                // since version 3.2.0, this function is no-op
                if (_isStringArr(payload)) {
                    return;
                }
                return _xhrReadyStateChange(xhr, payload, countOfItemsInPayload);
            };
            /**
             * Immediately send buffered data
             * @param isAsync - Indicates if the events should be sent asynchronously
             * @param forcedSender - Indicates the forcedSender, undefined if not passed
             */
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */] = function (isAsync, forcedSender, sendReason) {
                if (isAsync === void 0) { isAsync = true; }
                var result;
                if (!_paused) {
                    try {
                        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                        // Send data only if disableTelemetry is false
                        if (!_disableTelemetry) {
                            if (buffer[_DynamicConstants_DYN_COUNT /* @min:%2ecount */]() > 0) {
                                var payload = buffer.getItems();
                                _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */, isAsync);
                                // invoke send
                                if (forcedSender) {
                                    result = forcedSender.call(_self, payload, isAsync);
                                }
                                else {
                                    result = _self[_DYN__SENDER /* @min:%2e_sender */](payload, isAsync);
                                }
                            }
                            // update lastSend time to enable throttling
                            _lastSend = +new Date;
                        }
                        else {
                            buffer[_DYN_CLEAR /* @min:%2eclear */]();
                        }
                        _clearScheduledTimer();
                    }
                    catch (e) {
                        /* Ignore this error for IE under v10 */
                        var ieVer = getIEVersion();
                        if (!ieVer || ieVer > 9) {
                            _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 40 /* _eInternalMessageId.TransmissionFailed */, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                        }
                        // potential place to call countException q3
                    }
                }
                return result;
            };
            _self.getOfflineSupport = function () {
                return {
                    getUrl: function () {
                        return _endpointUrl;
                    },
                    createPayload: _createPayload,
                    serialize: _serialize,
                    batch: _batch,
                    shouldProcess: function (evt) {
                        return !!_validate(evt);
                    }
                };
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _self.onunloadFlush();
                runTargetUnload(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */
            _self[_DYN__ON_ERROR /* @min:%2e_onError */] = function (payload, message, event) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) {
                    return;
                }
                return _onError(payload, message, event);
            };
            /**
             * partial success handler
             */
            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */] = function (payload, results) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) {
                    return;
                }
                return _onPartialSuccess(payload, results);
            };
            /**
             * success handler
             */
            _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */] = function (payload, countOfItemsInPayload) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) {
                    return;
                }
                return _onSuccess(payload, countOfItemsInPayload);
                //_self._buffer && _self._buffer.clearSent(payload);
            };
            /**
             * xdr state changes
             */
            _self._xdrOnLoad = function (xdr, payload) {
                // since version 3.1.3, string[] is no-op
                if (_isStringArr(payload)) {
                    return;
                }
                return _xdrOnLoad(xdr, payload);
            };
            // function _getStatsBeat() {
            //     let statsBeatConfig: IStatsBeatState = {
            //         cKey: _self._senderConfig.instrumentationKey,
            //         endpoint: _endpointUrl,
            //         sdkVer: EnvelopeCreator.Version,
            //         type: eStatsType.SDK
            //     };
            //     let core = _self.core;
            //     // During page unload the core may have been cleared and some async events may not have been sent yet
            //     // resulting in the core being null. In this case we don't want to create a statsbeat instance
            //     return core ? core.getStatsBeat(statsBeatConfig) : null;
            // }
            function _xdrOnLoad(xdr, payload) {
                var responseText = _getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, 0);
                }
                else {
                    var results = parseResponse(responseText);
                    if (results && results[_DynamicConstants_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] && results[_DynamicConstants_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] > results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]
                        && !_isRetryDisabled) {
                        _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, results);
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, formatErrorMessageXdr(xdr));
                    }
                }
            }
            function _getSendPostMgrConfig() {
                try {
                    var onCompleteFuncs = {
                        xdrOnComplete: function (xdr, oncomplete, payload) {
                            var payloadArr = _getPayloadArr(payload);
                            if (!payloadArr) {
                                return;
                            }
                            //const responseText = _getResponseText(xdr);
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat) {
                            //     if (xdr && (responseText + "" === "200" || responseText === "")) {
                            //         _consecutiveErrors = 0;
                            //         statsbeat.count(200, payload, _endpointUrl);
                            //     } else {
                            //         const results = parseResponse(responseText);
                            //         if (results && results.itemsReceived && results.itemsReceived > results.itemsAccepted
                            //             && !_isRetryDisabled) {
                            //             statsbeat.count(206, payload, _endpointUrl);
                            //         } else {
                            //             statsbeat.count(499, payload, _endpointUrl);
                            //         }
                            //     }
                            // }
                            return _xdrOnLoad(xdr, payloadArr);
                        },
                        fetchOnComplete: function (response, onComplete, resValue, payload) {
                            var payloadArr = _getPayloadArr(payload);
                            if (!payloadArr) {
                                return;
                            }
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat) {
                            //     statsbeat.count(response.status, payload, _endpointUrl);
                            // }
                            return _checkResponsStatus(response.status, payloadArr, response.url, payloadArr[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */], response.statusText, resValue || "");
                        },
                        xhrOnComplete: function (request, oncomplete, payload) {
                            var payloadArr = _getPayloadArr(payload);
                            if (!payloadArr) {
                                return;
                            }
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat && request.readyState === 4) {
                            //     statsbeat.count(request.status, payload, _endpointUrl);
                            // }
                            return _xhrReadyStateChange(request, payloadArr, payloadArr[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
                        },
                        beaconOnRetry: function (data, onComplete, canSend) {
                            // let statsbeat = _getStatsBeat();
                            // if (statsbeat) {
                            //     statsbeat.count(499, data, _endpointUrl);
                            // }
                            return _onBeaconRetry(data, onComplete, canSend);
                        }
                    };
                    var config = {
                        enableSendPromise: _enableSendPromise,
                        isOneDs: false,
                        disableCredentials: false,
                        disableXhr: _disableXhr,
                        disableBeacon: !_beaconNormalSupported,
                        disableBeaconSync: !_beaconOnUnloadSupported,
                        senderOnCompleteCallBack: onCompleteFuncs
                    };
                    return config;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            /**
             * xhr state changes
             */
            function _xhrReadyStateChange(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) {
                    _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                }
            }
            /**
             * error handler
             */
            function _onError(payload, message, event) {
                _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            }
            /**
             * partial success handler
             */
            function _onPartialSuccess(payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) {
                        retry[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                    else {
                        // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                        failed[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                }
                if (payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]);
                }
                if (failed[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_ERROR /* @min:%2e_onError */](failed, formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */], "of", results.itemsReceived].join(" ")));
                }
                if (retry[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    _resendPayload(retry);
                    _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, "Partial success. " +
                        "Delivered: " + payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + ", Failed: " + failed[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] +
                        ". Will retry to send " + retry[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + " our of " + results[_DynamicConstants_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] + " items");
                }
            }
            /**
             * success handler
             */
            function _onSuccess(payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            }
            function _getPayloadArr(payload) {
                try {
                    if (payload) {
                        var internalPayload = payload;
                        var arr = internalPayload.oriPayload;
                        if (arr && arr[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                            return arr;
                        }
                        return null;
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _validate(telemetryItem, diagLogger) {
                if (_disableTelemetry) {
                    // Do not send/save data
                    return false;
                }
                // validate input
                if (!telemetryItem) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */, "Cannot send empty telemetry");
                    return false;
                }
                // validate event
                if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 70 /* _eInternalMessageId.InvalidEvent */, "Cannot send telemetry without baseData and baseType");
                    return false;
                }
                if (!telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                    // Default
                    telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */] = "EventData";
                }
                // ensure a sender was constructed
                if (!_self[_DYN__SENDER /* @min:%2e_sender */]) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender was not initialized");
                    return false;
                }
                // check if this item should be sampled in, else add sampleRate tag
                var sampleRate = telemetryItem[_DYN_SAMPLE_RATE /* @min:%2esampleRate */];
                if (ts_utils_isNullOrUndefined(sampleRate) || !ts_utils_isNumber(sampleRate) || sampleRate < 0 || sampleRate > 100) {
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        diagLogger && _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] });
                        return false;
                    }
                    else {
                        telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */];
                    }
                }
                return true;
            }
            function _getEnvelope(telemetryItem, diagLogger) {
                // construct an envelope that Application Insights endpoint can understand
                // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                var aiEnvelope = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                if (!aiEnvelope) {
                    _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 47 /* _eInternalMessageId.CreateEnvelopeError */, "Unable to create an AppInsights envelope");
                    return;
                }
                var doNotSendItem = false;
                // this is for running in legacy mode, where customer may already have a custom initializer present
                if (telemetryItem[_DYN_TAGS /* @min:%2etags */] && telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy]) {
                    ts_utils_arrForEach(telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy], function (callBack) {
                        try {
                            if (callBack && callBack(aiEnvelope) === false) {
                                doNotSendItem = true;
                                _warnToConsole(diagLogger, "Telemetry processor check returns false");
                            }
                        }
                        catch (e) {
                            // log error but dont stop executing rest of the telemetry initializers
                            // doNotSendItem = true;
                            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) }, true);
                        }
                    });
                    delete telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy];
                }
                if (doNotSendItem) {
                    return; // do not send, no need to execute next plugin
                }
                return aiEnvelope;
            }
            function _serialize(item) {
                var rlt = EMPTY_STR;
                var diagLogger = _self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    var valid = _validate(item, diagLogger);
                    var envelope = null;
                    if (valid) {
                        envelope = _getEnvelope(item, diagLogger);
                    }
                    if (envelope) {
                        rlt = _serializer.serialize(envelope);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return rlt;
            }
            function _batch(arr) {
                var rlt = EMPTY_STR;
                if (arr && arr[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                    rlt = "[" + arr.join(",") + "]";
                }
                return rlt;
            }
            function _createPayload(data) {
                var headers = _getHeaders();
                return {
                    urlString: _endpointUrl,
                    data: data,
                    headers: headers
                };
            }
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _getOnComplete(payload, status, headers, response) {
                // ***********************************************************************************************
                //TODO: handle other status codes
                if (status === 200 && payload) {
                    _self._onSuccess(payload, payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
                }
                else {
                    response && _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, response);
                }
            }
            function _doSend(sendInterface, payload, isAsync, markAsSent) {
                if (markAsSent === void 0) { markAsSent = true; }
                var onComplete = function (status, headers, response) {
                    // let statsbeat = _getStatsBeat();
                    // if (statsbeat) {
                    //     statsbeat.count(status, payloadData, _endpointUrl);
                    // }
                    return _getOnComplete(payload, status, headers, response);
                };
                var payloadData = _getPayload(payload);
                // if (payloadData) {
                //     payloadData.statsBeatData = {startTime: dateNow()};
                // }
                var sendPostFunc = sendInterface && sendInterface.sendPOST;
                if (sendPostFunc && payloadData) {
                    // ***********************************************************************************************
                    // mark payload as sent at the beginning of calling each send function
                    if (markAsSent) {
                        _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
                    }
                    var result_2;
                    var callbackExecuted_1 = false;
                    var resolveFn_1;
                    var rejectFn_1;
                    _sendPostMgr.preparePayload(function (processedPayload) {
                        result_2 = sendPostFunc(processedPayload, onComplete, !isAsync);
                        callbackExecuted_1 = true;
                        if (resolveFn_1) {
                            doAwait(result_2, resolveFn_1, rejectFn_1);
                        }
                    }, _zipPayload, payloadData, !isAsync);
                    if (callbackExecuted_1) {
                        return result_2;
                    }
                    // Callback was not executed synchronously, so we need to return a promise
                    return createPromise(function (resolve, reject) {
                        resolveFn_1 = resolve;
                        rejectFn_1 = reject;
                    });
                }
                return null;
            }
            function _getPayload(payload) {
                if (ts_utils_isArray(payload) && payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    var batch = _self[_DYN__BUFFER /* @min:%2e_buffer */].batchPayloads(payload);
                    var headers = _getHeaders();
                    var payloadData = {
                        data: batch,
                        urlString: _endpointUrl,
                        headers: headers,
                        disableXhrSync: _disableXhr,
                        disableFetchKeepAlive: !_fetchKeepAlive,
                        oriPayload: payload
                    };
                    return payloadData;
                }
                return null;
            }
            function _getHeaders() {
                try {
                    var headers = _headers || {};
                    if (isInternalApplicationInsightsEndpoint(_endpointUrl)) {
                        headers[RequestHeaders[6]] = RequestHeaders[7];
                    }
                    return headers;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] : 0;
                if ((_self[_DYN__BUFFER /* @min:%2e_buffer */].size() + incomingSize) > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener.isOnline()) { // only trigger send when currently online
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
                    }
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = parseResponse(res);
                    if (response && response.appId) {
                        _self._appId = response.appId;
                    }
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                            return;
                        }
                    }
                    if (_offlineListener && !_offlineListener.isOnline()) { // offline
                        // Note: Don't check for status == 0, since adblock gives this code
                        if (!_isRetryDisabled) {
                            var offlineBackOffMultiplier = 10; // arbritrary number
                            _resendPayload(payload, offlineBackOffMultiplier);
                            _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                        }
                        return;
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                            "Response code " + status + ". Will retry to send " + payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] + " items.");
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                    }
                }
                else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) {
                            response = parseResponse(res);
                        }
                        if (response && !_isRetryDisabled) {
                            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, response);
                        }
                        else {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                        }
                    }
                    else {
                        _consecutiveErrors = 0;
                        _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) {
                    //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                    //  _stamp_specific_redirects = 0;
                    return false;
                }
                if (!ts_utils_isNullOrUndefined(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) {
                    // We are unloading so always call the sender with sync set to false
                    _syncUnloadSender(payload, false);
                }
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    var beaconInst = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */]([3 /* TransportType.Beacon */], true);
                    return _doSend(beaconInst, payload, isAsync);
                }
            }
            function _onBeaconRetry(payload, onComplete, canSend) {
                var internalPayload = payload;
                var data = internalPayload && internalPayload.oriPayload;
                if (!_disableBeaconSplit) {
                    // Failed to send entire payload so try and split data and try to send as much events as possible
                    var droppedPayload = [];
                    for (var lp = 0; lp < data[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
                        var thePayload = data[lp];
                        var arr = [thePayload];
                        var item = _getPayload(arr);
                        if (!canSend(item, onComplete)) {
                            // Can't send anymore, so split the batch and drop the rest
                            droppedPayload[dist_es5_DynamicConstants_DYN_PUSH /* @min:%2epush */](thePayload);
                        }
                        else {
                            _self._onSuccess(arr, arr[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
                        }
                    }
                    if (droppedPayload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                        _fallbackSend && _fallbackSend(droppedPayload, true);
                        _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                    }
                }
                else {
                    _fallbackSend && _fallbackSend(data, true);
                    _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                }
            }
            function _isStringArr(arr) {
                try {
                    if (arr && arr[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                        return (ts_utils_isString(arr[0]));
                    }
                }
                catch (e) {
                    //TODO: log, sender use IInternalStorageItem instead of string since 3.1.3
                }
                return null;
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                var transport = null;
                if (ts_utils_isArray(payload)) {
                    var payloadSize = payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                    for (var lp = 0; lp < payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */]; lp++) {
                        payloadSize += payload[lp].item[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                    }
                    var syncFetchPayload = _sendPostMgr.getSyncFetchPayload();
                    if ((syncFetchPayload + payloadSize) <= FetchSyncRequestSizeLimitBytes) {
                        transport = 2 /* TransportType.Fetch */;
                    }
                    else if (isBeaconsSupported()) {
                        // Fallback to beacon sender as we at least get told which events can't be scheduled
                        transport = 3 /* TransportType.Beacon */;
                    }
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        transport = 1 /* TransportType.Xhr */;
                        _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                    var inst = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */]([transport], true);
                    return _doSend(inst, payload, isAsync);
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */
            function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) { linearFactor = 1; }
                if (!payload || payload[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
                    return;
                }
                var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
                _consecutiveErrors++;
                for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                    var item = payload_1[_i];
                    item.cnt = item.cnt || 0; // to make sure we have cnt for each payload
                    item.cnt++; // when resend, increase cnt
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */
            function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) {
                    delayInSeconds = SlotDelayInSeconds;
                }
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = mathFloor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = mathMax(mathMin(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = ts_utils_utcNow() + (delayInSeconds * 1000);
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */
            function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? mathMax(0, _retryAt - ts_utils_utcNow()) : 0;
                    var timerValue = mathMax(_maxBatchInterval, retryInterval);
                    _timeoutHandle = ts_utils_scheduleTimeout(function () {
                        _timeoutHandle = null;
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 1 /* SendRequestReason.NormalSchedule */);
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */
            function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!ts_utils_isNullOrUndefined(_retryCodes)) {
                    return _retryCodes[applicationinsights_channel_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] && _retryCodes.indexOf(statusCode) > -1;
                }
                return statusCode === 401 // Unauthorized
                    // Removing as private links can return a 403 which causes excessive retries and session storage usage
                    // || statusCode === 403 // Forbidden
                    || statusCode === 408 // Timeout
                    || statusCode === 429 // Too many requests.
                    || statusCode === 500 // Internal server error.
                    || statusCode === 502 // Bad Gateway.
                    || statusCode === 503 // Service unavailable.
                    || statusCode === 504; // Gateway timeout.
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                var result;
                var core = _self.core;
                if (core) {
                    // During page unload the core may have been cleared and some async events may not have been sent yet
                    // resulting in the core being null. In this case we don't want to create a statsbeat instance
                    if (core[func]) {
                        result = core[func]();
                    }
                    else {
                        // using _self.core['_notificationManager'] for backward compatibility
                        result = core["_notificationManager"];
                    }
                }
                return result;
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager.eventsSendRequest) {
                    try {
                        manager.eventsSendRequest(sendRequest, isAsync);
                    }
                    catch (e) {
                        _throwInternal(_self[dist_es5_DynamicConstants_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 74 /* _eInternalMessageId.NotificationException */, "send request notification failed: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                    }
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */
            function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = ts_utils_isNullOrUndefined(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) {
                    return true;
                }
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _self[_DYN__BUFFER /* @min:%2e_buffer */] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = Sender_UNDEFINED_VALUE;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = Sender_UNDEFINED_VALUE;
                _disableXhr = false;
                _fetchKeepAlive = false;
                _disableBeaconSplit = false;
                _xhrSend = null;
                _fallbackSend = null;
                _sendPostMgr = null;
                ts_utils_objDefine(_self, "_senderConfig", {
                    g: function () {
                        return HelperFuncs_objExtend({}, defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !ts_utils_isNullOrUndefined(iKey)) {
            envelope = __assignFn(__assignFn({}, orig), { iKey: iKey });
        }
        else {
            envelope = orig;
        }
        var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
        return creator(logger, envelope, convertUndefined);
    };
// Removed Stub for Sender.prototype.pause.
// Removed Stub for Sender.prototype.resume.
// Removed Stub for Sender.prototype.flush.
// Removed Stub for Sender.prototype.onunloadFlush.
// Removed Stub for Sender.prototype.initialize.
// Removed Stub for Sender.prototype.processTelemetry.
// Removed Stub for Sender.prototype._xhrReadyStateChange.
// Removed Stub for Sender.prototype.triggerSend.
// Removed Stub for Sender.prototype._onError.
// Removed Stub for Sender.prototype._onPartialSuccess.
// Removed Stub for Sender.prototype._onSuccess.
// Removed Stub for Sender.prototype._xdrOnLoad.
// Removed Stub for Sender.prototype.addHeader.
// Removed Stub for Sender.prototype.isCompletelyIdle.
// Removed Stub for Sender.prototype.getOfflineSupport.
// Removed Stub for Sender.prototype.getOfflineListener.
    return Sender;
}(BaseTelemetryPlugin));

//# sourceMappingURL=Sender.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/telemetry/ConnectionStringParser.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString[_DYN_SPLIT /* @min:%2esplit */](_FIELDS_SEPARATOR);
    var result = arrReduce(kvPairs, function (fields, kv) {
        var kvParts = kv[_DYN_SPLIT /* @min:%2esplit */](_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2) { // only save fields with valid formats
            var key = kvParts[0][_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (objKeys(result)[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // apply the default endpoints
            var locationPrefix = result.location ? result.location + "." : "";
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply user override endpoint or the default endpoints
        result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || DEFAULT_BREEZE_ENDPOINT;
        if (strEndsWith(result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */], "/")) {
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */].slice(0, -1);
        }
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/errors/OTelError.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var otelErrorType;
/*#__NO_SIDE_EFFECTS__*/
function getOpenTelemetryError() {
    if (!otelErrorType) {
        otelErrorType = ts_utils_createCustomError("OpenTelemetryError", function (self, args) {
        });
    }
    return otelErrorType;
}
function throwOTelError(message) {
    throw new (getOpenTelemetryError())(message);
}
//# sourceMappingURL=OTelError.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/internal/attributeHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/*#__NO_SIDE_EFFECTS__*/
function _isSupportedType(theType) {
    return theType === "number" || theType === "boolean" || theType === "string";
}
/*#__NO_SIDE_EFFECTS__*/
function _isHomogeneousArray(arr) {
    var type;
    var result = true;
    ts_utils_arrForEach(arr, function (element) {
        // null/undefined elements are allowed
        if (element !== null) {
            var elType = typeof element;
            if (!type) {
                result = _isSupportedType(elType);
                type = elType;
            }
            else {
                result = (type === elType);
            }
        }
        if (!result) {
            return -1;
        }
    });
    return result;
}
/**
  * Helper to determine if the provided key is a valid attribute key
  * @param key - The key to check
  * @returns true if the key is a valid attribute key
  */
/*#__NO_SIDE_EFFECTS__*/
function isAttributeKey(key) {
    return isString(key) && !!key;
}
/**
 * Helper to determine if the provided value is a valid attribute value
 * @param val - The value to check
 * @returns true if the value is a valid attribute value
 */
/*#__NO_SIDE_EFFECTS__*/
function isAttributeValue(val) {
    var result = (val === null || _isSupportedType(typeof val));
    if (val && ts_utils_isArray(val)) {
        result = _isHomogeneousArray(val);
    }
    return result;
}
/**
 * Sanitize the provided attributes to ensure they conform to OTel attribute requirements
 * @param otelApi - The OpenTelemetry API instance
 * @param attributes - The attributes to sanitize
 * @returns The sanitized attributes
 */
/*#__NO_SIDE_EFFECTS__*/
function sanitizeAttributes(otelApi, attributes) {
    var container = createAttributeContainer(otelApi.cfg);
    if (!isObject(attributes) || attributes == null) {
        return {};
    }
    objForEachKey(attributes, function (key, val) {
        if (!isAttributeKey(key)) {
            handleWarn(otelApi.cfg[_DYN_ERROR_HANDLERS /* @min:%2eerrorHandlers */], "Invalid attribute key: " + key);
        }
        else if (!isAttributeValue(val)) {
            handleWarn(otelApi.cfg[_DYN_ERROR_HANDLERS /* @min:%2eerrorHandlers */], "Invalid attribute value set for : " + key);
        }
        else if (isArray(val)) {
            container.set(key, arrSlice(val));
        }
        else {
            container.set(key, val);
        }
    });
    return container[_DYN_ATTRIBUTES /* @min:%2eattributes */];
}
//# sourceMappingURL=attributeHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/internal/handleErrors.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




/**
 * Handle / report an error.
 * When not provided the default is to generally throw an {@link OTelInvalidAttributeError}
 * @param handlers - The error handlers configuration
 * @param message - The error message to report
 * @param key - The attribute key that caused the error
 * @param value - The attribute value that caused the error
 */
/*#__NO_SIDE_EFFECTS__*/
function handleAttribError(handlers, message, key, value) {
    if (handlers.attribError) {
        handlers.attribError(message, key, value);
    }
    else {
        handleErrors_handleWarn(handlers, message + " for [" + key + "]: " + ts_utils_dumpObj(value));
    }
}
/**
 * There was an error with the span.
 * @param handlers - The error handlers configuration
 * @param message - The message to report
 * @param spanName - The name of the span
 */
/*#__NO_SIDE_EFFECTS__*/
function handleSpanError(handlers, message, spanName) {
    if (handlers.spanError) {
        handlers.spanError(message, spanName);
    }
    else {
        handleErrors_handleWarn(handlers, "Span [" + spanName + "]: " + message);
    }
}
/**
 * Report a general debug message, should not be treated as fatal
 * @param handlers - The error handlers configuration
 * @param message - The debug message to report
 */
/*#__NO_SIDE_EFFECTS__*/
function handleDebug(handlers, message) {
    if (handlers.debug) {
        handlers.debug(message);
    }
    else {
        if (console) {
            var fn = console.log;
            fnApply(fn, console, [message]);
        }
    }
}
/**
 * Report a general warning, should not be treated as fatal
 * @param handlers - The error handlers configuration
 * @param message - The warning message to report
 */
/*#__NO_SIDE_EFFECTS__*/
function handleErrors_handleWarn(handlers, message) {
    if (handlers[_DynamicConstants_DYN_WARN /* @min:%2ewarn */]) {
        handlers[_DynamicConstants_DYN_WARN /* @min:%2ewarn */](message);
    }
    else {
        if (console) {
            var fn = console[_DynamicConstants_DYN_WARN /* @min:%2ewarn */] || console.log;
            ts_utils_fnApply(fn, console, [message]);
        }
    }
}
/**
 * Report a general error, should not be treated as fatal
 * @param handlers - The error handlers configuration
 * @param message - The error message to report
 */
/*#__NO_SIDE_EFFECTS__*/
function handleErrors_handleError(handlers, message) {
    if (handlers.error) {
        handlers.error(message);
    }
    else if (handlers[_DYN_WARN /* @min:%2ewarn */]) {
        handlers[_DYN_WARN /* @min:%2ewarn */](message);
    }
    else {
        if (console) {
            var fn = console.error || console[_DYN_WARN /* @min:%2ewarn */] || console.log;
            fnApply(fn, console, [message]);
        }
    }
}
/**
 * A general error handler for not implemented methods.
 * @param handlers - The error handlers configuration
 * @param message - The message to report
 */
/*#__NO_SIDE_EFFECTS__*/
function handleNotImplemented(handlers, message) {
    if (handlers[_DYN_NOT_IMPLEMENTED /* @min:%2enotImplemented */]) {
        handlers[_DYN_NOT_IMPLEMENTED /* @min:%2enotImplemented */](message);
    }
    else {
        if (console) {
            var fn = console.error || console.log;
            ts_utils_fnApply(fn, console, [message]);
        }
    }
}
//# sourceMappingURL=handleErrors.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/internal/timeHelpers.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var NANOSECOND_DIGITS = 9;
// Constants for time unit conversions and manipulation
var NANOS_IN_MILLIS = 1000000; // Number of nanoseconds in a millisecond
var NANOS_IN_SECOND = 1000000000; // Number of nanoseconds in a second
var MICROS_IN_SECOND = 1000000; // Number of microseconds in a second
var MICROS_IN_MILLIS = 1000; // Number of microseconds in a millisecond
var MILLIS_IN_SECOND = 1000; // Number of milliseconds in a second
var cSecondsToNanos;
var cTimeOrigin;
var cNanoPadding;
function _notMutable() {
    ts_utils_throwTypeError("HrTime is not mutable");
}
/**
 * Initialize the cached value for converting milliseconds to nanoseconds.
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function _initSecondsToNanos() {
    if (!cSecondsToNanos) {
        cSecondsToNanos = ts_utils_createCachedValue(NANOS_IN_SECOND);
    }
    return cSecondsToNanos;
}
/**
 * Initialize the time origin.
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function _initTimeOrigin() {
    if (!cTimeOrigin) {
        var timeOrigin = 0;
        var perf = getPerformance();
        if (perf) {
            timeOrigin = perf.timeOrigin;
            if (!ts_utils_isNumber(timeOrigin)) {
                timeOrigin = perf.timing && perf.timing.fetchStart;
            }
            if (!ts_utils_isNumber(timeOrigin) && perf.now) {
                timeOrigin = perf.now();
            }
        }
        cTimeOrigin = ts_utils_createCachedValue({
            to: timeOrigin,
            hr: millisToHrTime(timeOrigin)
        });
    }
    return cTimeOrigin;
}
/*#__NO_SIDE_EFFECTS__*/
function _finalizeHrTime(hrTime) {
    function _toString() {
        return "[" + hrTime[0] + ", " + hrTime[1] + "]";
    }
    setObjStringTag(hrTime, _toString);
    return objFreeze(hrTime);
}
/*#__NO_SIDE_EFFECTS__*/
function _createUnixNanoHrTime(unixNano) {
    // Create array with initial length of 2
    var hrTime = [0, 0];
    var immutable = { v: _notMutable, w: false, e: false };
    // Define the array elements and other properties (avoid redefining length)
    objDefineProps(hrTime, {
        0: {
            l: getDeferred(function () { return mathFloor(unixNano / NANOS_IN_SECOND); })
        },
        1: {
            l: getDeferred(function () { return unixNano % NANOS_IN_SECOND; })
        },
        // unixNano: {
        //     v: unixNano,
        //     e: false,
        //     w: false
        // },
        // Override array mutating methods with single _notMutable function
        push: immutable,
        pop: immutable,
        shift: immutable,
        unshift: immutable,
        splice: immutable,
        sort: immutable,
        reverse: immutable,
        fill: immutable,
        copyWithin: immutable
    });
    return _finalizeHrTime(hrTime);
}
/*#__NO_SIDE_EFFECTS__*/
function _createHrTime(seconds, nanoseconds) {
    var hrTime = [seconds, nanoseconds];
    // objDefine(hrTime, "unixNano", {
    //     v: (seconds * NANOS_IN_SECOND) + nanoseconds,
    //     w: false,
    //     e: false
    // });
    return _finalizeHrTime(hrTime);
}
/**
 * Returns a new HrTime object with zero values for seconds and nanoseconds.
 * @returns A HrTime object representing zero time.
 */
/*#__NO_SIDE_EFFECTS__*/
function zeroHrTime() {
    return _createUnixNanoHrTime(0);
}
/**
 * Converts a number of milliseconds from epoch to HrTime([seconds, remainder in nanoseconds]).
 * @param epochMillis - The number of milliseconds since the epoch (January 1, 1970).
 * @returns A HrTime object representing the converted time.
 */
/*#__NO_SIDE_EFFECTS__*/
function millisToHrTime(epochMillis) {
    var result;
    if (epochMillis > 0) {
        // Handle whole and fractional parts separately for maximum precision
        var wholeMillis = mathFloor(epochMillis);
        var fractionalMillis = epochMillis - wholeMillis;
        // Handle whole milliseconds using integer arithmetic
        var seconds = mathFloor(wholeMillis / MILLIS_IN_SECOND);
        var millisFromSeconds = wholeMillis % MILLIS_IN_SECOND;
        var nanosFromWholeMillis = millisFromSeconds * NANOS_IN_MILLIS;
        // Convert fractional milliseconds to nanoseconds with proper rounding
        // Use Math.round to properly handle cases where we need to round up
        var nanosFromFraction = mathRound(fractionalMillis * NANOS_IN_MILLIS);
        // Combine the nanoseconds parts and handle any potential overflow
        var totalNanos = nanosFromWholeMillis + nanosFromFraction;
        var adjustedSeconds = seconds;
        // Check if we need to increment the seconds
        if (totalNanos >= NANOS_IN_SECOND) {
            adjustedSeconds++;
            totalNanos -= NANOS_IN_SECOND;
        }
        result = _createHrTime(adjustedSeconds, totalNanos);
    }
    return result || zeroHrTime();
}
/**
 * Converts a number of nanoseconds to HrTime([seconds, remainder in nanoseconds]).
 * @param nanos - The number of nanoseconds since the epoch (January 1, 1970).
 * @returns A HrTime object representing the converted time.
 */
/*#__NO_SIDE_EFFECTS__*/
function nanosToHrTime(nanos) {
    var result;
    if (nanos > 0) {
        result = _createUnixNanoHrTime(nanos);
    }
    return result || zeroHrTime();
}
// /**
//  * Converts a HrTime object to a number representing nanoseconds since epoch.
//  * Note: Due to JavaScript number limitations, values greater than Number.MAX_SAFE_INTEGER
//  * may lose precision. For very large time values, consider using string representation
//  * or splitting into separate second/nanosecond components.
//  * @param hrTime - The HrTime object to convert.
//  * @returns The number of nanoseconds represented by the HrTime object.
//  */
// export function hrTimeToUnixNanos(hrTime: IOTelHrTime): number {
//     let value = hrTime.unixNano;
//     if (isNullOrUndefined(value)) {
//         // Handle legacy HRTime format using standard number operations
//         // First calculate seconds contribution to nanoseconds
//         const secondsInNanos = hrTime[0] * NANOS_IN_MILLIS;
//         // Add the additional nanoseconds
//         value = secondsInNanos + hrTime[1];
//
//         // // Add warning if we're approaching number precision limits
//         // if (Math.abs(value) > Number.MAX_SAFE_INTEGER) {
//         //     console.warn("Time value exceeds safe integer limits, precision may be lost");
//         // }
//     }
//
//     return value;
// }
/**
 * Returns an hrtime calculated via performance component.
 * @param performanceNow - The current time in milliseconds since the epoch.
 */
/*#__NO_SIDE_EFFECTS__*/
function hrTime(performanceNow) {
    var result = millisToHrTime(ts_utils_isNumber(performanceNow) ? performanceNow : perfNow());
    var perf = getPerformance();
    if (perf) {
        var timeOrigin = cTimeOrigin || _initTimeOrigin();
        result = addHrTimes(timeOrigin.v.hr, result);
    }
    return result;
}
/**
 * Converts a TimeInput to an HrTime, defaults to _hrtime().
 * @param time - The time input to convert.
 */
/*#__NO_SIDE_EFFECTS__*/
function timeInputToHrTime(time) {
    var result;
    if (!isTimeInputHrTime(time)) {
        if (ts_utils_isNumber(time)) {
            var timeOrigin = cTimeOrigin || _initTimeOrigin();
            // Must be a performance.now() if it's smaller than process start time
            result = (time < timeOrigin.v.to) ? hrTime(time) : millisToHrTime(time);
        }
        else if (ts_utils_isDate(time)) {
            result = millisToHrTime(time.getTime());
        }
        else {
            ts_utils_throwTypeError("Invalid input type");
        }
    }
    else {
        // Convert HrTime array to IOTelHrTime
        result = _createHrTime(time[0], time[1]);
    }
    return result;
}
/**
 * Returns a duration of two hrTime.
 * @param startTime - The start time of the duration
 * @param endTime - The end time of the duration
 * @returns The duration between startTime and endTime as an IOTelHrTime
 */
/*#__NO_SIDE_EFFECTS__*/
function hrTimeDuration(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        var adjustedSeconds = seconds - 1;
        // negate
        var nanoSeconds = cSecondsToNanos || _initSecondsToNanos();
        nanos += nanoSeconds.v;
        return _createHrTime(adjustedSeconds, nanos);
    }
    return _createHrTime(seconds, nanos);
}
/**
 * Convert hrTime to timestamp, for example "2019-05-14T17:00:00.000123456Z"
 * @param time - The hrTime to convert.
 */
/*#__NO_SIDE_EFFECTS__*/
function hrTimeToTimeStamp(time) {
    if (!cNanoPadding) {
        cNanoPadding = createCachedValue(strLeft(INVALID_TRACE_ID, NANOSECOND_DIGITS));
    }
    var date = toISOString(new Date(time[0] * 1000));
    return date[_DYN_REPLACE /* @min:%2ereplace */]("000Z", strRight(cNanoPadding.v + time[1] + "Z", NANOSECOND_DIGITS + 1));
}
/**
 * Convert hrTime to nanoseconds.
 * @param time - The hrTime to convert.
 */
/*#__NO_SIDE_EFFECTS__*/
function hrTimeToNanoseconds(time) {
    var nanoSeconds = cSecondsToNanos || _initSecondsToNanos();
    return time[0] * nanoSeconds.v + time[1];
}
/**
 * Convert hrTime to milliseconds.
 * @param time - The hrTime to convert.
 */
/*#__NO_SIDE_EFFECTS__*/
function hrTimeToMilliseconds(time) {
    // Use integer math for the seconds part to avoid floating point precision loss
    var millisFromSeconds = time[0] * MILLIS_IN_SECOND;
    // Convert nanoseconds to milliseconds with proper rounding
    var millisFromNanos = Math.round(time[1] / NANOS_IN_MILLIS);
    return millisFromSeconds + millisFromNanos;
}
/**
 * Convert hrTime to microseconds.
 * @param time - The hrTime to convert.
 */
/*#__NO_SIDE_EFFECTS__*/
function hrTimeToMicroseconds(time) {
    // Use integer math for the seconds part to avoid floating point precision loss
    var microsFromSeconds = time[0] * MICROS_IN_SECOND;
    // Convert nanoseconds to microseconds with proper rounding
    var microsFromNanos = Math.round(time[1] / MICROS_IN_MILLIS);
    return microsFromSeconds + microsFromNanos;
}
/**
 * check if time is HrTime
 * @param value - The value to check.
 */
/*#__NO_SIDE_EFFECTS__*/
function isTimeInputHrTime(value) {
    return ts_utils_isArray(value) && value[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 2 && ts_utils_isNumber(value[0]) && ts_utils_isNumber(value[1]);
}
/**
 * check if input value is a correct types.TimeInput
 * @param value - The value to check.
 */
/*#__NO_SIDE_EFFECTS__*/
function isTimeInput(value) {
    return !isNullOrUndefined(value) && (isTimeInputHrTime(value) || isNumber(value) || isDate(value));
}
/**
 * Given 2 HrTime formatted times, return their sum as an HrTime.
 * @param time1 - The first HrTime to add
 * @param time2 - The second HrTime to add
 * @returns The sum of the two HrTime values as an IOTelHrTime
 */
/*#__NO_SIDE_EFFECTS__*/
function addHrTimes(time1, time2) {
    var seconds = time1[0] + time2[0];
    var nanos = time1[1] + time2[1];
    var nanoSeconds = cSecondsToNanos || _initSecondsToNanos();
    // Nanoseconds overflow check
    if (nanos >= nanoSeconds.v) {
        nanos -= nanoSeconds.v;
        return _createHrTime(seconds + 1, nanos);
    }
    return _createHrTime(seconds, nanos);
}
//# sourceMappingURL=timeHelpers.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/attribute/attributeContainer.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var _inheritedKey = "~[[inherited]]";
var _deletedKey = "~[[deleted]]";
var _containerId = 0;
function _noOpFunc() {
    // No-op function
}
function _addValue(container, target, theKey, value, maxAttribs, cfg) {
    var errorHandlers = cfg[_DynamicConstants_DYN_ERROR_HANDLERS /* @min:%2eerrorHandlers */] || {};
    if (theKey && ts_utils_getLength(theKey) > 0) {
        var key = theKey[_DYN_SPLIT /* @min:%2esplit */](".");
        var parts = [];
        var keyIndex = 0;
        var keyLen = ts_utils_getLength(key);
        while (keyIndex < keyLen) {
            var part = key[keyIndex];
            parts[_DynamicConstants_DYN_PUSH /* @min:%2epush */](part);
            if (keyIndex === keyLen - 1) {
                // last part
                if (target[part] && target[part].n) {
                    // This node already exists as a branch node
                    handleAttribError(errorHandlers, "Attribute key [" + parts[_DYN_JOIN /* @min:%2ejoin */](".") + "] already exists as a branch node", theKey, value);
                    return { r: 2 /* AddAttributeResult.BranchNodeExists */ };
                }
                if (!target[part] || target[part].d) {
                    // Node doesn't exist or was deleted
                    if (container.size >= maxAttribs) {
                        // If the key is not already present, we have exceeded the limit
                        // But if it does exist in the hierarchy, we can replace it locally
                        if (!container.has(theKey)) {
                            handleAttribError(errorHandlers, "Maximum allowed attributes exceeded [" + maxAttribs + "]", theKey, value);
                            return { r: 1 /* AddAttributeResult.MaxAttribsExceeded */ };
                        }
                    }
                    // Add new leaf node or restore deleted node
                    target[part] = {
                        v: value
                    };
                    return { r: 0 /* AddAttributeResult.Success */, a: true };
                }
                else {
                    // replace the value - capture the previous value
                    var previousValue = target[part].v;
                    target[part].v = value;
                    target[part].d = false; // Clear any deleted flag when setting value
                    return { r: 0 /* AddAttributeResult.Success */, a: false, p: previousValue };
                }
            }
            if (!target[part]) {
                target[part] = {
                    n: {}
                };
            }
            if (!target[part].n) {
                handleAttribError(errorHandlers, "Attribute key [" + parts[_DYN_JOIN /* @min:%2ejoin */](".") + "] already exists as a leaf node", theKey, value);
                return { r: 3 /* AddAttributeResult.LeafNodeExists */ };
            }
            target = target[part].n;
            keyIndex++;
        }
    }
    handleAttribError(errorHandlers, "Attribute key is empty", theKey, value);
    return { r: 4 /* AddAttributeResult.EmptyKey */ };
}
/**
 * Delete a specific attribute from the tree
 * @param target - The target branch to delete from
 * @param key - The key parts to delete
 * @returns true if the attribute was deleted, false if it didn't exist
 */
function _deleteValue(target, key) {
    if (key && ts_utils_getLength(key) > 0) {
        var keyIndex = 0;
        var keyLen = ts_utils_getLength(key);
        // Navigate to the parent of the target node, creating path if needed
        while (keyIndex < keyLen - 1) {
            var part = key[keyIndex++];
            if (!target[part]) {
                target[part] = {
                    n: {}
                };
            }
            if (!target[part].n) {
                // Path is blocked by a leaf node, can't delete
                return { d: false };
            }
            target = target[part].n;
        }
        // Now we're at the parent of the target node
        var lastPart = key[keyLen - 1];
        if (target[lastPart] && !target[lastPart].d && !target[lastPart].n) {
            // Node exists, is not already deleted, and is a leaf - delete it
            var prev = target[lastPart].v;
            target[lastPart].d = true; // Mark as deleted
            target[lastPart].v = UNDEFINED_VALUE; // Clear the value
            return { d: true, p: prev };
        }
        else if (!target[lastPart] || !target[lastPart].d) {
            // Node doesn't exist or is not already deleted - create a deleted marker
            // This is important for tracking inherited keys that are locally deleted
            // and for the edge case where inherited keys might be added later
            target[lastPart] = {
                d: true // Mark as deleted without a value
            };
            return { d: true };
        }
    }
    return { d: false };
}
/**
 * Find a local specific node (including if it's been deleted) in the attribute tree, or if it exists in an inherited source
 * @param container - The target attribute container to search in
 * @param key - The key to search for
 * @param filter - The filter to apply
 * @param cb - The callback function to execute when the node is found
 * @param nodes - The attribute branches to search in
 * @param inheritContainer - The inherited attribute container
 * @param inheritAttribObj - The inherited attribute object
 * @param otelCfg - Optional OpenTelemetry configuration
 * @returns The result of the callback function
 */
function _findDetail(container, key, filter, cb, nodes, inheritContainer, inheritAttribObj, otelCfg) {
    var theDetail;
    // Find the local node
    if (key && ts_utils_getLength(key) > 0) {
        var theNode = void 0;
        var target = nodes;
        var keys = strSplit(key, ".");
        var keysLen = ts_utils_getLength(keys);
        var idx = 0;
        if (filter == 0 /* eAttributeFilter.Local */ || filter === 2 /* eAttributeFilter.LocalOrDeleted */ || ts_utils_isUndefined(filter)) {
            // Find any local node (if it exists)
            while (target && idx < keysLen) {
                var part = keys[idx++];
                var node = target[part];
                if (node && idx >= keysLen) {
                    // last part
                    theNode = node;
                    break;
                }
                if (!node || !node.n) {
                    // TODO - support wildcard(s) (when no node is found), likely need to refactor this to support multiple keys
                    break;
                }
                target = node.n;
            }
            // So if the caller didn't specify a filter then always return the found "value" (which will be undefined for a deleted key)
            // If they have specified a filter, then we need to respect that filter where Local and LocalOrDeleted are treated the same
            if (theNode) {
                theDetail = {
                    c: container,
                    k: key,
                    n: theNode,
                    v: theNode.d ? UNDEFINED_VALUE : theNode.v,
                    s: 0 /* eAttributeSource.Local */,
                    e: !theNode.d
                };
            }
        }
        // So we get here if
        // - We didn't find a node (no local overrides)
        // - The filter doesn't match (undefined, Local, LocalOrDeleted), so we didn't look for a node
        // So we just need to check if the filter is undefined or inherited and if so we are free
        // to look in the inherited sources
        if (!theDetail && (filter === 1 /* eAttributeFilter.Inherited */ || ts_utils_isUndefined(filter))) {
            var inheritedValue = _getInheritedValue(key, inheritContainer, inheritAttribObj);
            if (inheritedValue) {
                theDetail = {
                    c: container,
                    k: key,
                    n: null,
                    v: inheritedValue.v,
                    s: 1 /* eAttributeSource.Inherited */,
                    e: true
                };
            }
        }
    }
    return cb(theDetail);
}
function _size(target, inheritAttrib, inheritContainer) {
    var count = 0;
    var seenKeys = [];
    // Use the iterator to count all unique attributes including inheritance
    var iter = _iterator(target, function (prefix, key, _node) {
        return prefix + key;
    }, undefined, inheritContainer || inheritAttrib);
    ts_utils_iterForOf(iter, function (key) {
        if (ts_utils_arrIndexOf(seenKeys, key) === -1) {
            seenKeys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](key);
            count++;
        }
    });
    return count;
}
function _getStackEntry(theNode, prefix) {
    var entry;
    if (theNode) {
        var allKeys = objKeys(theNode);
        if (ts_utils_getLength(allKeys) > 0) {
            entry = {
                p: prefix,
                n: theNode,
                k: allKeys,
                i: -1
            };
        }
    }
    return entry;
}
function _iterator(target, cb, otelCfg, parentAttribs, inclDeleted) {
    var stack = [];
    var visitedKeys = parentAttribs ? [] : UNDEFINED_VALUE;
    var inheritState;
    var inheritContainerIter;
    var current = _getStackEntry(target, InternalConstants_STR_EMPTY); // Start with the root branch
    var inheritContainer;
    var inheritAttribs;
    // Used as the initializer for the iterator and the flag to indicate that the iterator is done
    var ctx = {
        v: undefined,
        n: _moveNext
    };
    if (parentAttribs) {
        if (isAttributeContainer(parentAttribs)) {
            inheritContainer = parentAttribs;
        }
        else if (ts_utils_isObject(parentAttribs)) {
            inheritAttribs = parentAttribs;
        }
    }
    function _moveNext() {
        var thePrefix = InternalConstants_STR_EMPTY;
        var theKey;
        var theNode;
        var theSource = 0 /* eAttributeFilter.Local */; // Default to local
        // Process entries from the current node
        while (current) {
            current.i++;
            if (current.i < ts_utils_getLength(current.k)) {
                // We have at least 1 key
                var key = current.k[current.i];
                // The key is "real" (we don't support null or undefined keys)
                var node = current.n[key];
                if (node) {
                    if (node.n) {
                        // We are at a branch node, so add the current node to the stack so we can continue traversing it later
                        stack[_DynamicConstants_DYN_PUSH /* @min:%2epush */](current);
                        current = _getStackEntry(node.n, current.p + key + ".");
                        // If the branch is empty, continue with the next item from stack
                        if (!current) {
                            current = stack.pop();
                        }
                    }
                    else {
                        // Leaf node
                        var fullKey = current.p + key;
                        if (visitedKeys && ts_utils_arrIndexOf(visitedKeys, fullKey) === -1) {
                            visitedKeys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](fullKey);
                        }
                        // If we are not deleted, then return this key
                        if (!node.d || inclDeleted) {
                            // Leaf node with value - not deleted
                            thePrefix = current.p;
                            theKey = key;
                            theNode = node;
                            theSource = node.d ? 2 /* eAttributeFilter.LocalOrDeleted */ : 0 /* eAttributeFilter.Local */;
                            break;
                        }
                    }
                }
            }
            else {
                // No more keys to process at this level
                current = stack.pop();
            }
        }
        // We get here only after we have processed all keys of the current instance
        // Switch to processing inherited attributes if we have them
        if (!theNode && inheritAttribs) {
            if (!inheritState) {
                // Lazy initialize the inherited state
                inheritState = {
                    p: InternalConstants_STR_EMPTY,
                    n: UNDEFINED_VALUE,
                    k: objKeys(inheritAttribs),
                    i: -1
                };
            }
            // Process inherited attributes that haven't been overridden or deleted
            while (inheritState.i < ts_utils_getLength(inheritState.k) - 1) {
                inheritState.i++;
                var key = inheritState.k[inheritState.i];
                if (ts_utils_arrIndexOf(visitedKeys, key) === -1) {
                    visitedKeys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](key);
                    theKey = key;
                    theNode = { v: inheritAttribs[key] };
                    theSource = 1 /* eAttributeFilter.Inherited */;
                    break;
                }
            }
        }
        // Process inherited container if we have one and no other node was found
        if (!theNode && inheritContainer) {
            if (!inheritContainerIter) {
                // Initialize the container's iterator only once - this will include the full inheritance chain
                inheritContainerIter = inheritContainer[_DYN_ENTRIES /* @min:%2eentries */]();
            }
            // Use the container's iterator to get next entry
            ts_utils_iterForOf(inheritContainerIter, function (entry) {
                var key = entry[0];
                if (ts_utils_arrIndexOf(visitedKeys, key) === -1) {
                    visitedKeys[_DynamicConstants_DYN_PUSH /* @min:%2epush */](key);
                    theKey = key;
                    theNode = { v: entry[1] };
                    theSource = 1 /* eAttributeFilter.Inherited */; // Always return Inherited for inherited container entries
                    return -1;
                }
            });
        }
        if (theNode) {
            ctx.v = cb(thePrefix, theKey, theNode, theSource);
        }
        return !theNode;
    }
    return createIterator(ctx);
}
function _generateAttributes(container, target, otelCfg, inheritAttrib, showTree) {
    // TODO: Look at making this return a proxy instead of a new object
    // This should be more effecient as it would make the property lookups lazy
    var attribs = objCreate(null);
    var deletedKeys;
    if (showTree) {
        // Add Node Id
        ts_utils_objDefine(attribs, "#id", {
            v: container.id,
            w: false
        });
    }
    // Use the iterator properly - collect the key-value pairs
    var iter = _iterator(target, function (prefix, key, node, source) {
        var name = prefix + key;
        return { n: name, v: node.v, d: node.d, s: source };
    }, otelCfg, showTree ? null : inheritAttrib, showTree ? 2 /* eAttributeFilter.LocalOrDeleted */ : UNDEFINED_VALUE);
    ts_utils_iterForOf(iter, function (entry) {
        var theNode = attribs;
        var theName = entry.n;
        if (entry.d) {
            if (!deletedKeys) {
                // Create separate objects for inherited and deleted attributes
                deletedKeys = objCreate(null);
                ts_utils_objDefine(attribs, _deletedKey, {
                    v: deletedKeys,
                    w: false
                });
            }
            theNode = deletedKeys;
        }
        if (theNode && !(theName in theNode)) {
            theNode[theName] = entry.v;
        }
    });
    if (inheritAttrib && showTree) {
        // Create separate objects for inherited and deleted attributes
        var inheritedKeys_1;
        // Add a tree showing the inherited attributes
        if (isAttributeContainer(inheritAttrib)) {
            inheritedKeys_1 = inheritAttrib._attributes;
        }
        else {
            // Create separate objects for inherited and deleted attributes
            inheritedKeys_1 = objCreate(null);
            ts_utils_objForEachKey(inheritAttrib, function (key, value) {
                inheritedKeys_1[key] = value;
            });
        }
        ts_utils_objDefine(attribs, _inheritedKey, {
            v: inheritedKeys_1,
            w: false
        });
    }
    return attribs;
}
function _notifyListeners(listeners, changeInfo) {
    // Notify all registered listeners of changes
    if (listeners) {
        ts_utils_arrForEach(listeners, function (listener) {
            ts_utils_safe(listener.cb, [changeInfo]);
        });
    }
}
function _getInheritedValue(key, inheritContainer, inheritAttribObj) {
    // Check inherited container first
    if (inheritContainer && inheritContainer.has(key)) {
        return { v: inheritContainer.get(key) };
    }
    // Then check inherited attributes object
    if (inheritAttribObj && key in inheritAttribObj) {
        return { v: inheritAttribObj[key] };
    }
}
function _createUnloadHook(listeners, callback) {
    var cbInst = {
        cb: callback
    };
    listeners[_DynamicConstants_DYN_PUSH /* @min:%2epush */](cbInst);
    var unloadHook = {
        rm: function () {
            if (listeners && cbInst) {
                var index = ts_utils_arrIndexOf(listeners, cbInst);
                if (index >= 0) {
                    // Remove the current listener
                    listeners[_DYN_SPLICE /* @min:%2esplice */](index, 1);
                }
                // Clear the cached values
                cbInst.cb = null;
                cbInst = null;
                // Optimization to drop all references and shortcut any future lookups
                unloadHook.rm = _noOpFunc;
            }
        }
    };
    return unloadHook;
}
/**
 * Creates a new attribute container that provides an efficient, observable key-value storage
 * for OpenTelemetry attributes with support for inheritance, limits, and change notifications.
 *
 * The container supports inherited attributes from parent containers or plain objects,
 * enforces attribute count and value size limits, and provides efficient iteration and access patterns.
 *
 * @param otelCfg - The OpenTelemetry configuration containing trace configuration and limits
 * @param name - Optional name for the container (used in the container ID)
 * @param inheritAttrib - Optional parent attributes or container to inherit from
 * @param attribLimits - Optional specific attribute limits to override configuration defaults
 * @returns A new IAttributeContainer instance with the specified configuration
 * @since 3.4.0
 * @example
 * ```typescript
 * const config = { traceCfg: { generalLimits: { attributeCountLimit: 64 } } };
 * const container = createAttributeContainer(config, "my-container");
 * container.set("service.name", "my-service");
 *
 * // With inheritance
 * const parent = { "environment": "production" };
 * const child = createAttributeContainer(config, "child-container", parent);
 * console.log(child.get("environment")); // "production"
 * ```
 */
function attributeContainer_createAttributeContainer(otelCfg, name, inheritAttrib, attribLimits) {
    var traceCfg = otelCfg[_DynamicConstants_DYN_TRACE_CFG /* @min:%2etraceCfg */] || {};
    var nodes = null;
    var theSize = null;
    var theDropped = null;
    var limits = traceCfg.generalLimits || {};
    var maxAttribs = limits[_DYN_ATTRIBUTE_COUNT_LIMI5 /* @min:%2eattributeCountLimit */] || 128;
    // let maxValueLen: number = limits.attributeValueLengthLimit;
    var theAttributes;
    var localAttributes;
    var droppedAttribs = 0;
    var inheritContainer = null;
    var inheritAttribObj = null;
    var listeners = null;
    var parentListenerHook = null;
    var containerName = name || InternalConstants_STR_EMPTY;
    if (attribLimits) {
        maxAttribs = attribLimits[_DYN_ATTRIBUTE_COUNT_LIMI5 /* @min:%2eattributeCountLimit */] || maxAttribs;
        // maxValueLen = attribLimits.attributeValueLengthLimit || maxValueLen;
    }
    // Determine if inheritAttrib is a container or plain attributes object
    if (isAttributeContainer(inheritAttrib)) {
        inheritContainer = inheritAttrib;
    }
    else if (ts_utils_isObject(inheritAttrib)) {
        inheritAttribObj = inheritAttrib;
    }
    inheritAttrib = null;
    var inheritSrc = inheritAttribObj || inheritContainer;
    var container = {
        id: (containerName || InternalConstants_STR_EMPTY) + "." + (_containerId++),
        size: 0,
        droppedAttributes: 0,
        attributes: UNDEFINED_VALUE,
        clear: function () {
            // Remove parent listener if exists
            if (parentListenerHook) {
                parentListenerHook.rm();
                parentListenerHook = null;
            }
            // Only inform children if we appear to have any keys or could possible inherit keys
            if (nodes || inheritContainer || inheritAttribObj) {
                // Inform any children (Synchronously) that we are about to clear all attributes
                // Called prior to clearing the nodes, so that children still have full access
                // to the current and inherited attributes
                _notifyListeners(listeners, { frm: container.id, op: 0 /* eAttributeChangeOp.Clear */ });
            }
            nodes = null;
            theSize = null;
            theDropped = null;
            theAttributes = null;
            localAttributes = null;
            droppedAttribs = 0;
            inheritSrc = null; // Clear the inherited attributes
            inheritContainer = null; // Clear inherited container as well
            inheritAttribObj = null; // Clear inherited attributes as well
        },
        get: function (key, source) {
            return _findDetail(container, key, source, function (detail) {
                // Just return the value (which will include deleted ones (as undefined)if the filter is set)
                return detail ? detail.v : UNDEFINED_VALUE;
            }, nodes, inheritContainer, inheritAttribObj, otelCfg);
        },
        has: function (key, source) {
            return _findDetail(container, key, source, function (detail) {
                // Note: We may still have a detail object if the key was deleted, so we need to
                // - Check if the detail is considered to "exist"
                // - If the source filter is LocalOrDeleted, then return that is "exists"
                return detail ? (detail.e || source === 2 /* eAttributeFilter.LocalOrDeleted */) : false;
            }, nodes, inheritContainer, inheritAttribObj, otelCfg);
        },
        set: function (key, value) {
            if (!nodes) {
                // Lazily create a container object
                nodes = objCreate(null);
            }
            var addResult = _addValue(container, nodes, key, value, maxAttribs, otelCfg);
            if (addResult.r === 0 /* AddAttributeResult.Success */) {
                theSize = null; // invalidate any previously cached size
                theAttributes = null; // invalidate any previously cached attributes
                localAttributes = null; // invalidate any previously cached local attributes
                // Determine operation type based on whether this was a new attribute or set
                var op = addResult.a ? 2 /* eAttributeChangeOp.Add */ : 1 /* eAttributeChangeOp.Set */;
                var prevValue = addResult.p;
                if (op === 2 /* eAttributeChangeOp.Add */) {
                    // Special case, if we just added/changed it locally we need to lookup our parents to see if we are replacing (hiding)
                    // a previously inherited value and if so we need to notify our children that this was a set not an add (if the value changed)
                    var inheritedValue = _getInheritedValue(key, inheritContainer, inheritAttribObj);
                    if (inheritedValue) {
                        op = 1 /* eAttributeChangeOp.Set */;
                        prevValue = inheritedValue.v;
                    }
                }
                // Only notify children if the value has changed
                if (!objIs(value, prevValue)) {
                    // Inform any children (Synchronously) that we have "changed" a value
                    // Unlike clear, this is called after the change is made, so children
                    // will need to "handle" the change accordingly
                    _notifyListeners(listeners, {
                        frm: container.id,
                        op: op,
                        k: key,
                        prev: prevValue,
                        val: value
                    });
                }
            }
            else if (addResult.r === 1 /* AddAttributeResult.MaxAttribsExceeded */) {
                theDropped = null;
                droppedAttribs++;
                _notifyListeners(listeners, {
                    frm: container.id,
                    op: 4 /* eAttributeChangeOp.DroppedAttributes */,
                    k: key,
                    val: value
                });
            }
            return addResult.r === 0 /* AddAttributeResult.Success */;
        },
        del: function (key) {
            // Find the node / value for this container
            return _findDetail(container, key, UNDEFINED_VALUE, function (detail) {
                // Check if the key exists locally (incl marked as deleted) or is inherited
                if (detail) {
                    // So the key exists either locally or in an inherited source
                    // - It may also exists but marked as deleted
                    if (!nodes) {
                        // Always create nodes structure if it doesn't exist since we need to track deleted keys
                        nodes = objCreate(null);
                    }
                    // Now lets mark this key as deleted locally
                    var deleteResult = _deleteValue(nodes, key[_DYN_SPLIT /* @min:%2esplit */]("."));
                    if (deleteResult.d) {
                        theSize = null; // invalidate any previously cached size
                        theAttributes = null; // invalidate any previously cached attributes
                        localAttributes = null; // invalidate any previously cached local attributes
                    }
                    // Inform any children (Synchronously) that we have deleted a value
                    // This is important even if the key didn't exist locally, as it existed in inheritance
                    // chain and we need children (like snapshot containers) to know about the deletion to
                    // ignore any future inherited values.
                    _notifyListeners(listeners, {
                        frm: container.id,
                        op: 3 /* eAttributeChangeOp.Delete */,
                        k: key,
                        prev: detail.v
                    });
                    // Return true if we successfully marked it as deleted
                    return deleteResult.d;
                }
                return false;
            }, nodes, inheritContainer, inheritAttribObj, otelCfg);
        },
        keys: function () {
            return _iterator(nodes, function (prefix, key, node, source) {
                return prefix + key;
            }, otelCfg, inheritSrc);
        },
        entries: function () {
            return _iterator(nodes, function (prefix, key, node, source) {
                return [prefix + key, node.v, source];
            }, otelCfg, inheritSrc);
        },
        values: function () {
            return _iterator(nodes, function (_prefix, _key, node, _source) {
                return node.v;
            }, otelCfg, inheritSrc);
        },
        forEach: function (cb) {
            var iter = _iterator(nodes, function (prefix, key, node, source) {
                cb(prefix + key, node.v, source);
                return true; // Return true to indicate the callback was executed
            }, otelCfg, inheritSrc);
            // Iterate over the entire container
            ts_utils_iterForOf(iter, _noOpFunc);
        },
        child: function (name, snapshot) {
            var childName = (name ? name : "child") + (snapshot ? "<-@[" : "<=[") + container.id + "]";
            return snapshot ? _createSnapshotContainer(otelCfg, childName, container, attribLimits) : attributeContainer_createAttributeContainer(otelCfg, childName, container, attribLimits);
        },
        listen: function (callback) {
            if (!listeners) {
                listeners = [];
            }
            return _createUnloadHook(listeners, callback);
        }
    };
    function _listener(changeInfo) {
        // Invalidate caches when parent changes
        var shouldNotify = true;
        // If a parent adds a new key, then if this instance has not replaced it
        // then we need to also inform our children
        if (changeInfo.op === 2 /* eAttributeChangeOp.Add */ || changeInfo.op === 1 /* eAttributeChangeOp.Set */ || changeInfo.op === 3 /* eAttributeChangeOp.Delete */) {
            theSize = null;
            theAttributes = null;
            localAttributes = null;
            // If we already have (or deleted) this key locally, then we don't need to notify children
            _findDetail(container, changeInfo.k, 2 /* eAttributeFilter.LocalOrDeleted */, function (detail) {
                // If we have a node (which also might be that it was deleted) then don't notify
                // If we didn't find a node then we still need to notify our children
                shouldNotify = !detail || !detail.n;
            }, nodes);
        }
        else if (changeInfo.op === 0 /* eAttributeChangeOp.Clear */) {
            theSize = null;
            theAttributes = null;
            localAttributes = null;
            // If the parent clears all of it's keys, we need to inform our children
            shouldNotify = true;
        }
        else if (changeInfo.op === 4 /* eAttributeChangeOp.DroppedAttributes */) {
            shouldNotify = true;
            theDropped = null;
        }
        if (shouldNotify) {
            _notifyListeners(listeners, changeInfo);
        }
    }
    // If we have a parent container, register a listener to stay connected to parent changes
    if (inheritContainer && ts_utils_isFunction(inheritContainer.listen)) {
        parentListenerHook = inheritContainer.listen(_listener);
    }
    return objDefineProps(container, {
        size: {
            g: function () {
                if (!theSize) {
                    theSize = ts_utils_createCachedValue(_size(nodes, inheritAttribObj, inheritContainer));
                }
                return theSize.v;
            }
        },
        droppedAttributes: {
            g: function () {
                if (!theDropped) {
                    theDropped = ts_utils_createCachedValue((inheritContainer ? inheritContainer.droppedAttributes : 0) + droppedAttribs);
                }
                return theDropped.v;
            }
        },
        attributes: {
            g: function () {
                if (!theAttributes) {
                    theAttributes = ts_utils_createCachedValue(_generateAttributes(container, nodes, otelCfg, inheritSrc));
                }
                return theAttributes.v;
            }
        },
        _attributes: {
            g: function () {
                if (!localAttributes) {
                    localAttributes = ts_utils_createCachedValue(_generateAttributes(container, nodes, otelCfg, inheritSrc, true));
                }
                return localAttributes.v;
            }
        }
    });
}
/**
 * Add all attributes from the source attributes or container to the target container.
 * This function has performance and memory implications as it immediately copies all key-value pairs
 * from the source to the target container, handling both plain attribute objects and other attribute
 * containers.
 *
 * @param container - The target container to add attributes to
 * @param attributes - The source attributes or container to copy from
 * @since 3.4.0
 * @example
 * ```typescript
 * const target = createAttributeContainer(config, "target");
 * const source = { key1: "value1", key2: "value2" };
 * addAttributes(target, source);
 *
 * // Or from another container
 * const sourceContainer = createAttributeContainer(config, "source");
 * sourceContainer.set("key3", "value3");
 * addAttributes(target, sourceContainer);
 * ```
 */
function addAttributes(container, attributes) {
    if (isAttributeContainer(attributes)) {
        // Use the container's forEach for direct processing - more efficient than entries() iterator
        attributes.forEach(function (key, value, source) {
            container.set(key, value);
        });
    }
    else if (attributes) {
        if (ts_utils_isFunction(attributes[_DYN_ENTRIES /* @min:%2eentries */])) {
            // Handle any type that has an entries function
            ts_utils_iterForOf(attributes[_DYN_ENTRIES /* @min:%2eentries */](), function (entry) {
                container.set(entry[0], entry[1]);
            });
        }
        else {
            // Handle as plain attributes object
            ts_utils_objForEachKey(attributes, function (key, value) {
                container.set(key, value);
            });
        }
    }
}
function _createSnapshotContainer(otelCfg, name, sourceContainer, attribLimits) {
    var newContainer = attributeContainer_createAttributeContainer(otelCfg, name, sourceContainer, attribLimits);
    sourceContainer.listen(function (changeInfo) {
        if (changeInfo.op === 0 /* eAttributeChangeOp.Clear */) {
            // Copy all parent keys to this container if not already present
            ts_utils_iterForOf(sourceContainer[_DYN_ENTRIES /* @min:%2eentries */](), function (entry) {
                var key = entry[0];
                // If the Key has not been set or explicitly deleted from the new Container, and the source Container
                // has the key (directly or inherited), then copy the value locally so we have a copy because our parent
                // some grand parent is clearing their collection of values. Note ideal as if it's a grand parent or higher
                // we end up duplicating the keys multiple times, but we only know about our direct ancestor
                // Note: Deleting locally hides any inherited value
                if (!newContainer.has(key, 2 /* eAttributeFilter.LocalOrDeleted */) && sourceContainer.has(key)) {
                    newContainer.set(key, entry[1]);
                }
            });
        }
        else if (changeInfo.op === 2 /* eAttributeChangeOp.Add */) {
            // For add operations add), we need to ensure that when the key is not already present on the current instance
            // that we hide the key so it's "not" inherited, by marking it as deleted.
            var key = changeInfo.k;
            if (!newContainer.has(key, 0 /* eAttributeFilter.Local */)) {
                newContainer.del(key);
            }
        }
        else if (changeInfo.op === 1 /* eAttributeChangeOp.Set */ || changeInfo.op === 3 /* eAttributeChangeOp.Delete */) {
            // For set operations (change), preserve the previous value if we don't have it locally
            // For delete operations, if we don't have the key locally, preserve it with the deleted value
            var key = changeInfo.k;
            if (!newContainer.has(key, 2 /* eAttributeFilter.LocalOrDeleted */)) {
                newContainer.set(key, changeInfo.prev);
            }
        }
    });
    return newContainer;
}
/**
 * Creates a snapshot container based on the passed IOTelAttributes or IAttributeContainer.
 * The returned container effectively treats the source attributes as immutable as at the time of creation, you
 * may still add / update existing attributes without affecting the original source. And changes to the source
 * attributes / container will not be reflected from the new snapshot container, only changes made to the returned
 * container itself.
 *
 * Note: It implements this in a lazy manner, so changes made to the original source after the snapshot is taken will
 * cause the changed attributes to be copied into this snapshot container with it's original value and cause a local
 * version of the changed key (if not already been present) to be added, so when using the {@link IAttributeContainer#has} or
 * {@link IAttributeContainer#get} methods, with the optional source filter as {@link eAttributeFilter.Inherited} it will
 * only return attributes that were present and unchanged at the time of the snapshot. This means for those attributes you must
 * use the {@link eAttributeFilter.Local} as source filter (or leave it undefined) to access the local version.
 *
 * It is recommended that you always use {@link IAttributeContainer} instances for better memory and performance overheads,
 * for this specific function when you pass a {@link IOTelAttributes} instance it will create a copy of all present attributes
 * at the point of creation (not lazily).
 *
 * @param otelCfg - The OpenTelemetry configuration to use for the snapshot container
 * @param source - The source attributes or container to create a snapshot view from
 * @param attribLimits - Optional attribute limits to apply to the snapshot container
 * @returns An IAttributeContainer instance that will preserves the attributes and values from the source attributes / container
 * at creation time. The snapshot container will be named "snapshot(xxxx)" where xxxx is the source container ID, or "snapshot(...)" for non-container sources.
 * @since 3.4.0
 * @example
 * ```typescript
 * // Immediate copy for plain attributes
 * const attrs = { key1: "value1", key2: "value2" };
 * const snapshot = createAttributeSnapshot(attrs);
 * // snapshot.id will be "snapshot(...).N"
 * attrs.key1 = "changed"; // snapshot.get("key1") is still "value1"
 *
 * // Lazy copy-on-change for containers
 * const container = createAttributeContainer(config, "my-container");
 * container.set("key1", "value1");
 * const snapshot2 = createAttributeSnapshot(container);
 * // snapshot2.id will be "snapshot(my-container.N).M"
 * container.set("key1", "changed"); // snapshot2.get("key1") remains "value1" (previous value copied)
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function createAttributeSnapshot(otelCfg, name, source, attribLimits) {
    var newContainer;
    if (isAttributeContainer(source)) {
        newContainer = _createSnapshotContainer(otelCfg, (name || "child") + "<-@[" + source.id + "]", source, attribLimits);
    }
    else {
        newContainer = attributeContainer_createAttributeContainer(otelCfg, (name || "child") + "<-@[(...)]", null, attribLimits);
        addAttributes(newContainer, source);
    }
    return newContainer;
}
/**
 * Helper function to identify if a passed argument is or implements the IAttributeContainer interface
 * @param value - The value to check
 * @returns true if the value implements IAttributeContainer interface, false otherwise
 * @since 3.4.0
 * @example
 * ```typescript
 * const container = createAttributeContainer(config, "test-container");
 * if (isAttributeContainer(container)) {
 *     // TypeScript now knows container is IAttributeContainer
 *     console.log(container.size);
 *     container.set("key", "value");
 * }
 *
 * // Check unknown object
 * function processContainer(obj: unknown) {
 *     if (isAttributeContainer(obj)) {
 *         obj.forEach((key, value) => console.log(key, value));
 *     }
 * }
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isAttributeContainer(value) {
    return value &&
        ts_utils_isFunction(value.clear) &&
        ts_utils_isFunction(value.get) &&
        ts_utils_isFunction(value.has) &&
        ts_utils_isFunction(value.set) &&
        ts_utils_isFunction(value.del) &&
        ts_utils_isFunction(value.keys) &&
        ts_utils_isFunction(value[_DYN_ENTRIES /* @min:%2eentries */]) &&
        ts_utils_isFunction(value.forEach) &&
        ts_utils_isFunction(value.values) &&
        ts_utils_isFunction(value.child) &&
        ts_utils_isFunction(value.listen) &&
        (ts_utils_isObject(value) || ts_utils_isFunction(value)) &&
        // Check for existence of the required properties, but don't cause them to be processed ("executed")
        ("id" in value) &&
        ("size" in value) &&
        ("droppedAttributes" in value) &&
        ("attributes" in value);
}
//# sourceMappingURL=attributeContainer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/span.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










function createSpan(spanCtx, orgName, kind) {
    var otelCfg = spanCtx.api.cfg;
    var perfStartTime = perfNow();
    var spanContext = spanCtx[_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */];
    var attributes;
    var isEnded = false;
    var errorHandlers = otelCfg[_DynamicConstants_DYN_ERROR_HANDLERS /* @min:%2eerrorHandlers */] || {};
    var spanStartTime = getDeferred(function () {
        if (ts_utils_isNullOrUndefined(spanCtx[_DYN_START_TIME /* @min:%2estartTime */])) {
            return hrTime(perfStartTime);
        }
        return timeInputToHrTime(spanCtx[_DYN_START_TIME /* @min:%2estartTime */]);
    });
    var spanEndTime;
    var spanDuration;
    var spanStatus;
    // let links: IOTelLink[] = [];
    // let events: IOTelTimedEvent[] = [];
    var localDroppedAttributes = 0;
    var localContainer = null;
    // let droppedEvents = 0;
    // let droppedLinks = 0;
    var isRecording = spanCtx.isRecording !== false;
    if (otelCfg.traceCfg && otelCfg.traceCfg[_DynamicConstants_DYN_SUPPRESS_TRACING /* @min:%2esuppressTracing */]) {
        // Automatically disable the span from recording
        isRecording = false;
    }
    var spanName = orgName || InternalConstants_STR_EMPTY;
    if (isRecording) {
        attributes = getDeferred(function () { return attributeContainer_createAttributeContainer(otelCfg, spanName, spanCtx[_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */]); });
    }
    function _handleIsEnded(operation, extraMsg) {
        if (isEnded) {
            handleSpanError(errorHandlers, "Span {traceID: " + spanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] + ", spanId: " + spanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] + "} has ended - operation [" + operation + "] unsuccessful" + (extraMsg ? (" - " + extraMsg) : InternalConstants_STR_EMPTY) + ".", spanName);
        }
        return isEnded;
    }
    function _toString() {
        return "ReadableSpan (\"" + spanName + "\")";
    }
    var theSpan = setProtoTypeName({
        spanContext: function () { return spanContext; },
        setAttribute: function (key, value) {
            var message;
            if (value !== null && !_handleIsEnded("setAttribute") && isRecording) {
                if (!key || key[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
                    message = "Invalid attribute key: " + ts_utils_dumpObj(key);
                }
                else if (!isAttributeValue(value)) {
                    message = "Invalid attribute value: " + ts_utils_dumpObj(value);
                }
                if (message) {
                    handleAttribError(errorHandlers, message, key, value);
                    localDroppedAttributes++;
                }
                else if (attributes) {
                    attributes.v.set(key, value);
                }
                else {
                    localDroppedAttributes++;
                }
            }
            else {
                localDroppedAttributes++;
            }
            return theSpan;
        },
        setAttributes: function (attrs) {
            if (!_handleIsEnded("setAttributes") && isRecording && attributes) {
                addAttributes(attributes.v, attrs);
            }
            else {
                localDroppedAttributes += (objKeys(attrs)[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] || 0);
            }
            return theSpan;
        },
        // addEvent: (name: string, attributesOrStartTime?: IOTelAttributes | OTelTimeInput, startTime?: OTelTimeInput) => {
        //     droppedEvents++;
        //     if(!_handleIsEnded("addEvent") && isRecording) {
        //         handleWarn(errorHandlers, "Span.addEvent: " + name + " not added - No events allowed");
        //     }
        //     return theSpan;
        // },
        // addLink: (link: any) => {
        //     droppedLinks++;
        //     if(!_handleIsEnded("addEvent") && isRecording) {
        //         handleWarn(errorHandlers, "Span.addLink: " + link + " not added - No links allowed");
        //     }
        //     return theSpan;
        // },
        // addLinks: (links: any[]) => {
        //     droppedLinks += links.length;
        //     if (!_handleIsEnded("addLinks") && isRecording) {
        //         handleWarn(errorHandlers, "Span.addLinks: " + links + " not added - No links allowed");
        //     }
        //     return theSpan;
        // },
        setStatus: function (newStatus) {
            if (!_handleIsEnded("setStatus")) {
                spanStatus = newStatus;
                if (!ts_utils_isNullOrUndefined(spanStatus) && !ts_utils_isNullOrUndefined(spanStatus[_DYN_MESSAGE /* @min:%2emessage */]) && !ts_utils_isString(spanStatus[_DYN_MESSAGE /* @min:%2emessage */])) {
                    spanStatus[_DYN_MESSAGE /* @min:%2emessage */] = ts_utils_dumpObj(spanStatus[_DYN_MESSAGE /* @min:%2emessage */]);
                }
            }
            return theSpan;
        },
        updateName: function (name) {
            if (!_handleIsEnded("updateName") && !objIs(spanName, name)) {
                spanName = name;
                updateProtoTypeName(theSpan, _toString());
            }
            return theSpan;
        },
        end: function (endTime) {
            var calcDuration;
            if (!_handleIsEnded("end", "You can only call end once")) {
                try {
                    if (!ts_utils_isNullOrUndefined(endTime)) {
                        // User provided an end time
                        spanEndTime = timeInputToHrTime(endTime);
                        spanDuration = hrTimeDuration(spanStartTime.v, spanEndTime);
                        calcDuration = hrTimeToMilliseconds(spanDuration);
                    }
                    else {
                        var perfEndTime = perfNow();
                        calcDuration = perfEndTime - perfStartTime;
                        spanDuration = millisToHrTime(calcDuration);
                        spanEndTime = hrTime(perfEndTime);
                    }
                    if (calcDuration < 0) {
                        handleErrors_handleWarn(errorHandlers, "Span.end: duration is negative - startTime > endTime. Setting duration to 0 ms");
                        spanDuration = zeroHrTime();
                        spanEndTime = spanStartTime.v;
                    }
                    // if (droppedEvents > 0) {
                    //     handleWarn(errorHandlers, "Droped " + droppedEvents + " events");
                    // }
                    // We don't mark as ended until after the onEnd callback to ensure that it can
                    // still read / change the span if required as well as ensuring that the returned
                    // value for isRecording is correct.
                    spanCtx.onEnd && spanCtx.onEnd(theSpan);
                }
                finally {
                    // Ensure we mark as ended even if the onEnd throws
                    isEnded = true;
                }
            }
        },
        isRecording: function () { return isRecording && !isEnded; },
        recordException: function (exception, time) {
            if (!_handleIsEnded("recordException")) {
                if (spanCtx.onException) {
                    spanCtx.onException(theSpan, exception, time);
                }
                else {
                    handleNotImplemented(errorHandlers, "Span.recordException: " + ts_utils_dumpObj(exception) + " not handled");
                }
            }
        }
    }, _toString());
    // Make the relevant properties dynamic (and read-only)
    objDefineProps(theSpan, {
        name: {
            g: function () { return spanName; }
        },
        kind: {
            v: kind || 0 /* eOTelSpanKind.INTERNAL */
        },
        startTime: {
            g: function () {
                return spanStartTime.v;
            }
        },
        endTime: {
            g: function () {
                return spanEndTime;
            }
        },
        status: {
            g: function () {
                return spanStatus || {
                    code: 0 /* eOTelSpanStatusCode.UNSET */
                };
            }
        },
        attributes: {
            g: function () {
                return attributes ? attributes.v[_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */] : objFreeze({});
            }
        },
        attribContainer: {
            g: function () {
                if (!attributes && !localContainer) {
                    // Create an empty container and cache it for future use (for performance only)
                    localContainer = attributeContainer_createAttributeContainer(otelCfg, spanName);
                }
                return attributes ? attributes.v : localContainer;
            }
        },
        links: {
            g: function () {
                return [];
            }
        },
        events: {
            g: function () {
                return [];
            }
        },
        duration: {
            g: function () {
                return spanDuration || zeroHrTime();
            }
        },
        ended: {
            g: function () {
                return isEnded;
            }
        },
        droppedAttributesCount: {
            g: function () {
                return attributes ? attributes.v.droppedAttributes : localDroppedAttributes;
            }
        },
        // droppedEventsCount: {
        //     g: () => {
        //         return droppedEvents;
        //     }
        // },
        // droppedLinksCount: {
        //     g: () => {
        //         return droppedLinks;
        //     }
        // },
        parentSpanContext: {
            l: getDeferred(function () {
                return spanCtx ? spanCtx[_DYN_PARENT_SPAN_CONTEXT /* @min:%2eparentSpanContext */] : UNDEFINED_VALUE;
            })
        },
        parentSpanId: {
            l: getDeferred(function () {
                var parentSpanId = UNDEFINED_VALUE;
                if (spanCtx) {
                    var parentSpanCtx = spanCtx[_DYN_PARENT_SPAN_CONTEXT /* @min:%2eparentSpanContext */];
                    parentSpanId = parentSpanCtx ? parentSpanCtx[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] : UNDEFINED_VALUE;
                }
                return parentSpanId;
            })
        }
    });
    return theSpan;
}
//# sourceMappingURL=span.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/utils.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








/**
 * Internal helper to execute a callback function with a span set as the active span.
 * Handles both synchronous and asynchronous (Promise-based) callbacks, ensuring
 * the previous active span is properly restored after execution.
 * @param scope - The span scope instance
 * @param fn - The callback function to execute
 * @param thisArg - The `this` context for the callback
 * @param args - Array of arguments to pass to the callback
 * @returns The result of the callback function
 */
function _executeWithActiveSpan(scope, fn, thisArg, args) {
    var isAsync = false;
    try {
        var result = ts_utils_fnApply(fn, thisArg || scope, args);
        if (ts_utils_isPromiseLike(result)) {
            isAsync = true;
            return doFinally(result, function () {
                // Restore previous active span after promise settles (resolves or rejects)
                if (scope) {
                    scope.restore();
                }
            });
        }
        return result;
    }
    finally {
        // Restore previous active span only if result is not a promise
        // (promises handle restoration in their callbacks)
        if (scope && !isAsync) {
            scope.restore();
        }
    }
}
/**
 * Execute the callback `fn` function with the passed span as the active span
 * Note: The callback will be executed even if the span is null.
 * @param traceHost - The current trace host instance (core or AISKU instance)
 * @param span - The span to set as the active span during the execution of the callback
 * @param fn - the callback function
 * @param thisArg - the `this` argument for the callback. If not provided, ISpanScope is used as `this`
 * @returns the result of the function
 */
function withSpan(traceHost, span, fn, thisArg) {
    var scope = traceHost[_DYN_SET_ACTIVE_SPAN /* @min:%2esetActiveSpan */](span);
    return _executeWithActiveSpan(scope, fn, thisArg, arrSlice(arguments, 4));
}
/**
 * Execute the callback `fn` function with the passed span as the active span. The callback receives
 * an ISpanScope object as its first parameter and the `this` context (when no thisArg is provided).
 * Note: The callback will be executed even if the span is null.
 * @param traceHost - The current trace host instance (core or AISKU instance)
 * @param span - The span to set as the active span during the execution of the callback
 * @param fn - the callback function that receives an ISpanScope and additional arguments
 * @param thisArg - the `this` argument for the callback. If not provided, ISpanScope is used as `this`
 * @param _args - Additional arguments to be passed to the function
 */
function useSpan(traceHost, span, fn, thisArg) {
    var scope = traceHost[_DynamicConstants_DYN_SET_ACTIVE_SPAN /* @min:%2esetActiveSpan */](span);
    return _executeWithActiveSpan(scope, fn, thisArg, [scope][_DYN_CONCAT /* @min:%2econcat */](ts_utils_arrSlice(arguments, 4)));
}
/**
 * Creates and starts a new span, sets it as the active span in the current context,
 * and executes a provided function within this context.
 *
 * This method creates a span, makes it active during the execution of the provided
 * function, and automatically ends the span when the function completes (or throws).
 * This provides automatic span lifecycle management and context propagation. If the function
 * is asynchronous the span will be ended when the returned Promise resolves or rejects.
 * Note: The callback will be executed even if the traceHost is unable to create a span (returns null).
 * @remarks
 * This overloaded version supports both optional span creation options and the `this` argument for the callback.
 * @param name - The name of the span, should be descriptive of the operation being traced
 * @param optionsOrFn - Optional configuration for span creation (parent context, attributes, etc.) or the function to execute within the span's active context
 * @param maybeFnOrThis - The function to execute within the span's active context or the `this` argument for the callback
 * @param thisArg - The `this` argument for the callback. If not provided, ISpanScope is used as `this`
 * @returns The result of executing the provided function
 * @remarks
 * - The span is automatically ended when the function completes or throws an exception
 * - The span becomes the active parent for any spans created within the function
 * - If the function throws an error, the span status is automatically set to ERROR
 * - This is the recommended method for most tracing scenarios due to automatic lifecycle management
 * - Multiple overloads available for different parameter combinations
 */
function startActiveSpan(traceHost, name, optionsOrFn, maybeFnOrThis, thisArg) {
    var options = null;
    var fn;
    var that = thisArg;
    if (ts_utils_isFunction(optionsOrFn)) {
        fn = optionsOrFn;
    }
    else {
        options = optionsOrFn;
        fn = maybeFnOrThis;
        that = thisArg || maybeFnOrThis;
    }
    var span = traceHost.startSpan(name, options);
    var useAsync = false;
    try {
        var result = useSpan(traceHost, span, function (scope) {
            return ts_utils_fnApply(fn, that, [scope]);
        });
        if (ts_utils_isPromiseLike(result)) {
            useAsync = true;
            return doAwait(result, function (value) { return value; }, function (reason) {
                if (span) {
                    span.setStatus({ code: reason ? 2 /* eOTelSpanStatusCode.ERROR */ : 1 /* eOTelSpanStatusCode.OK */, message: reason ? reason[_DYN_MESSAGE /* @min:%2emessage */] || reason : undefined });
                }
            }, function () {
                if (span) {
                    span.end();
                }
            });
        }
        return result;
    }
    catch (e) {
        if (span) {
            span.setStatus({ code: e ? 2 /* eOTelSpanStatusCode.ERROR */ : 1 /* eOTelSpanStatusCode.OK */, message: e ? e[_DYN_MESSAGE /* @min:%2emessage */] : undefined });
        }
        throw e;
    }
    finally {
        // If the function returned a promise, we need to end the span when the promise resolves/rejects
        if (!useAsync && span) {
            span.end();
        }
    }
}
/**
 * Returns true if the passed spanContext of type  {@link IDistributedTraceContext} or {@link IDistributedTraceInit} is valid.
 * @return true if this {@link IDistributedTraceContext} is valid.
 */
/*#__NO_SIDE_EFFECTS__*/
function isSpanContextValid(spanContext) {
    return spanContext ? (isValidTraceId(spanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */]) && isValidSpanId(spanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */])) : false;
}
/**
 * Wrap the given {@link IDistributedTraceContext} in a new non-recording {@link IReadableSpan}
 *
 * @param spanContext - span context to be wrapped
 * @returns a new non-recording {@link IReadableSpan} with the provided context
 */
function wrapSpanContext(otelApi, spanContext) {
    if (!isDistributedTraceContext(spanContext)) {
        spanContext = createDistributedTraceContext(spanContext);
    }
    // Return a non-recording span
    return createNonRecordingSpan(otelApi, "wrapped(\"" + spanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] + "\")", spanContext);
}
/**
 * Return a non-recording span based on the provided spanContext using the otelApi instance as the
 * owning instance.
 * @param otelApi - The otelApi to use for creating the non-Recording Span
 * @param spanName - The span name to associated with the span
 * @param spanContext - The Span context to use for the span
 * @returns A new span that is marked as a non-recording span
 */
function createNonRecordingSpan(otelApi, spanName, spanContext) {
    // Return a non-recording span
    var spanCtx = {
        api: otelApi,
        spanContext: isDistributedTraceContext(spanContext) ? spanContext : createDistributedTraceContext(spanContext),
        isRecording: false
    };
    return createSpan(spanCtx, spanName, 0 /* eOTelSpanKind.INTERNAL */);
}
/**
 * Identifies whether the span is an {@link IReadableSpan} or not
 * @param span - The span to check
 * @returns true if the span is an {@link IReadableSpan} otherwise false
 */
/*#__NO_SIDE_EFFECTS__*/
function isReadableSpan(span) {
    return !!span &&
        isObject(span) &&
        "name" in span &&
        "kind" in span &&
        isFunction(span[_DYN_SPAN_CONTEXT /* @min:%2espanContext */]) &&
        "duration" in span &&
        "ended" in span &&
        "startTime" in span &&
        "endTime" in span &&
        "attributes" in span &&
        "links" in span &&
        "events" in span &&
        "status" in span &&
        // "resource" in span &&
        // "instrumentationScope" in span &&
        "droppedAttributesCount" in span &&
        isFunction(span.isRecording) &&
        isFunction(span.setStatus) &&
        isFunction(span.updateName) &&
        isFunction(span.setAttribute) &&
        isFunction(span.setAttributes) &&
        isFunction(span.end) &&
        isFunction(span.recordException);
}
function _getTraceCfg(context) {
    var traceCfg = null;
    if (context) {
        if (context.cfg && context[_DYN_HOST /* @min:%2ehost */]) {
            traceCfg = context.cfg[_DYN_TRACE_CFG /* @min:%2etraceCfg */];
        }
        else if (isFunction(context[_DYN_INITIALIZE /* @min:%2einitialize */]) && context[_DYN_CONFIG /* @min:%2econfig */]) {
            traceCfg = context[_DYN_CONFIG /* @min:%2econfig */][_DYN_TRACE_CFG /* @min:%2etraceCfg */];
        }
        else if (context[_DYN_TRACE_CFG /* @min:%2etraceCfg */]) {
            traceCfg = context[_DYN_TRACE_CFG /* @min:%2etraceCfg */];
        }
    }
    return traceCfg;
}
/**
 * Set the suppress tracing flag on the context
 * @param context - The context to set the suppress tracing flag on
 * @returns The context with the suppress tracing flag set
 * @remarks This is used to suppress tracing for the current context and all child contexts
 */
/*#__NO_SIDE_EFFECTS__*/
function suppressTracing(context) {
    var traceCfg = _getTraceCfg(context);
    if (traceCfg) {
        traceCfg[_DYN_SUPPRESS_TRACING /* @min:%2esuppressTracing */] = true;
    }
    return context;
}
/**
 * Remove the suppress tracing flag from the context
 * @param context - The context to remove the suppress tracing flag from
 * @returns The context with the suppress tracing flag removed
 * @remarks This is used to remove the suppress tracing flag from the current context and all child
 * contexts. This is used to restore tracing after it has been suppressed
 */
/*#__NO_SIDE_EFFECTS__*/
function unsuppressTracing(context) {
    var traceCfg = _getTraceCfg(context);
    if (traceCfg) {
        traceCfg[_DYN_SUPPRESS_TRACING /* @min:%2esuppressTracing */] = false;
    }
    return context;
}
/**
 * Check if the tracing is suppressed for the current context
 * @param context - The context to check for the suppress tracing flag
 * @returns true if tracing is suppressed for the current context otherwise false
 * @remarks This is used to check if tracing is suppressed for the current context and all child
 */
/*#__NO_SIDE_EFFECTS__*/
function isTracingSuppressed(context) {
    var result = false;
    var traceCfg = _getTraceCfg(context);
    if (traceCfg) {
        result = !!traceCfg[_DYN_SUPPRESS_TRACING /* @min:%2esuppressTracing */];
    }
    return result;
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/traceApi.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








/**
 * @internal
 * Create a new instance of the OpenTelemetry Trace API, this is bound to the
 * provided instance of the traceProvider (the {@link IOTelApi} instance),
 * to "change" (setGlobalTraceProvider) you MUST create a new instance of this API.
 * @param otelApi - The IOTelApi instance associated with this instance
 * @returns A new instance of the ITraceApi for the provided ITelApi
 */
function _createTraceApi(otelApi) {
    var traceProvider = otelApi;
    if (!traceProvider) {
        throwOTelError("Must provide an otelApi instance");
    }
    return getDeferred(function () {
        return setProtoTypeName({
            getTracer: fnBind(traceProvider.getTracer, traceProvider),
            // We use fnBind to automatically inject the "otelApi" argument as the first argument to the wrapSpanContext function
            wrapSpanContext: fnBind(wrapSpanContext, UNDEFINED_VALUE, [otelApi]),
            isSpanContextValid: isSpanContextValid,
            getActiveSpan: function () {
                return otelApi.host ? otelApi.host[_DYN_GET_ACTIVE_SPAN /* @min:%2egetActiveSpan */]() : null;
            },
            setActiveSpan: function (span) {
                return otelApi.host ? otelApi.host[_DynamicConstants_DYN_SET_ACTIVE_SPAN /* @min:%2esetActiveSpan */](span) : null;
            }
        }, "TraceApi");
    });
}
//# sourceMappingURL=traceApi.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/tracer.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * @internal
 * Create a tracer implementation.
 * @param host - The ApplicationInsights core instance
 * @returns A tracer object
 */
function _createTracer(host, name) {
    var tracer = setProtoTypeName({
        startSpan: function (spanName, options) {
            // Note: context is not used / needed for Application Insights / 1DS
            if (host) {
                return host.startSpan(spanName, options);
            }
            return null;
        },
        startActiveSpan: function (name, fnOrOptions, fn) {
            // Figure out which parameter order was passed
            var theFn = null;
            var opts = null;
            if (ts_utils_isFunction(fnOrOptions)) {
                // startActiveSpan<F extends (span: IReadableSpan) => unknown>(name: string, fn: F): ReturnType<F>;
                theFn = fnOrOptions;
            }
            else {
                // startActiveSpan<F extends (span: IReadableSpan) => unknown>(name: string, options: IOTelSpanOptions, fn: F): ReturnType<F>; or
                opts = fnOrOptions;
                theFn = fn;
            }
            if (theFn) {
                return startActiveSpan(host, name, opts, function (spanScope) {
                    return ts_utils_fnApply(theFn, spanScope, [spanScope.span, spanScope]);
                });
            }
        }
    }, "OTelTracer" + (name ? (" (" + name + ")") : InternalConstants_STR_EMPTY));
    return tracer;
}
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/tracerProvider.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * @internal
 * Create a trace implementation with tracer caching.
 * @param core - The ApplicationInsights core instance
 * @returns A trace object
 */
function _createTracerProvider(host) {
    var tracers = {};
    return {
        getTracer: function (name, version) {
            var tracerKey = (name || "ai-web") + "@" + (version || "unknown");
            if (!tracers[tracerKey]) {
                tracers[tracerKey] = _createTracer(host);
            }
            return tracers[tracerKey];
        },
        forceFlush: function () {
            // Nothing to flush
            return;
        },
        shutdown: function () {
            // Just clear the locally cached IOTelTracer instances so they can be garbage collected
            tracers = {};
            host = null;
            return;
        }
    };
}
//# sourceMappingURL=tracerProvider.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/OTelApi.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/*#__NO_SIDE_EFFECTS__*/
function createOTelApi(otelApiCtx) {
    var _traceApi;
    var otelApi = setProtoTypeName(objDefineProps(_createTracerProvider(otelApiCtx[_DynamicConstants_DYN_HOST /* @min:%2ehost */]), {
        cfg: { g: function () { return otelApiCtx.host[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */]; } },
        trace: { g: function () { return _traceApi.v; } },
        host: { g: function () { return otelApiCtx[_DynamicConstants_DYN_HOST /* @min:%2ehost */]; } }
    }), "OTelApi");
    _traceApi = _createTraceApi(otelApi);
    return otelApi;
}
//# sourceMappingURL=OTelApi.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/api/trace/traceProvider.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * @internal
 * Creates a new trace provider adapter
 * @param host - The trace host instance (typically IAppInsightsCore).
 * @param traceName - The name of the trace provider.
 * @param api - The OpenTelemetry API instance (as a lazy value).
 * @param onEnd - Optional callback to be invoked when a span ends.
 * @param onException - Optional callback to be invoked when an exception is recorded on a span.
 * @returns The created trace provider.
 */
/*#__NO_SIDE_EFFECTS__*/
function createTraceProvider(host, traceName, api, onEnd, onException) {
    var provider = {
        api: null,
        createSpan: function (name, options, parent) {
            var newCtx;
            var parentCtx;
            if (options && options.root) {
                newCtx = createDistributedTraceContext();
            }
            else {
                newCtx = createDistributedTraceContext(parent || host[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]());
                if (newCtx.parentCtx) {
                    parentCtx = newCtx.parentCtx;
                }
            }
            // Always generate a new spanId
            newCtx[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = strSubstr(generateW3CId(), 0, 16);
            var spanCtx = {
                api: api,
                spanContext: newCtx,
                attributes: options ? options[_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */] : undefined,
                startTime: options ? options[_DYN_START_TIME /* @min:%2estartTime */] : undefined,
                isRecording: options ? options.recording !== false : true,
                onEnd: onEnd,
                onException: onException
            };
            if (parentCtx) {
                ts_utils_objDefine(spanCtx, "parentSpanContext", {
                    v: parentCtx,
                    w: false
                });
            }
            return createSpan(spanCtx, name, (options === null || options === void 0 ? void 0 : options.kind) || 0 /* eOTelSpanKind.INTERNAL */);
        },
        getProviderId: function () { return traceName; },
        isAvailable: function () { return !!onEnd; }
    };
    ts_utils_objDefine(provider, "api", {
        v: api,
        w: false
    });
    return provider;
}
//# sourceMappingURL=traceProvider.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/NotificationManager.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var NotificationManager_defaultValues = {
    perfEvtsSendAll: false
};
function _runScheduledListeners(asyncNotifications) {
    asyncNotifications.h = null;
    var callbacks = asyncNotifications.cb;
    asyncNotifications.cb = [];
    ts_utils_arrForEach(callbacks, function (cb) {
        // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
        ts_utils_safe(cb.fn, [cb.arg]);
    });
}
// This function is used to combine the logic of running the listeners and handling the async notifications so that they don't
// create multiple timers if there are multiple async listeners.
function _runListeners(listeners, name, asyncNotifications, callback) {
    ts_utils_arrForEach(listeners, function (listener) {
        if (listener && listener[name]) {
            if (asyncNotifications) {
                // Schedule the callback to be called after the current call stack has cleared.
                asyncNotifications.cb[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
                    fn: callback,
                    arg: listener
                });
                asyncNotifications.h = asyncNotifications.h || ts_utils_scheduleTimeout(_runScheduledListeners, 0, asyncNotifications);
            }
            else {
                // Run the listener in a try-catch to ensure that a single listener failing doesn't prevent the others from running
                ts_utils_safe(callback, [listener]);
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var _asyncNotifications = {
            h: null,
            cb: []
        };
        var cfgHandler = createDynamicConfig(config, NotificationManager_defaultValues);
        unloadHandler = cfgHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        dynamicProto(NotificationManager, this, function (_self) {
            ts_utils_objDefine(_self, "listeners", {
                g: function () { return _listeners; }
            });
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _listeners[_DynamicConstants_DYN_PUSH /* @min:%2epush */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */] = function (listener) {
                var index = ts_utils_arrIndexOf(_listeners, listener);
                while (index > -1) {
                    _listeners[_DYN_SPLICE /* @min:%2esplice */](index, 1);
                    index = ts_utils_arrIndexOf(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */
            _self[STR_EVENTS_SENT /* @min:%2eeventsSent */] = function (events) {
                _runListeners(_listeners, STR_EVENTS_SENT, _asyncNotifications, function (listener) {
                    listener[STR_EVENTS_SENT /* @min:%2eeventsSent */](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             * @param sendType - [Optional] The send type used when the events were discarded.
             */
            _self[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */] = function (events, reason, sendType) {
                _runListeners(_listeners, STR_EVENTS_DISCARDED, _asyncNotifications, function (listener) {
                    listener[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */](events, reason, sendType);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */] = function (sendReason, isAsync) {
                _runListeners(_listeners, STR_EVENTS_SEND_REQUEST, isAsync ? _asyncNotifications : null, function (listener) {
                    listener[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendReason, isAsync);
                });
            };
            _self[STR_PERF_EVENT /* @min:%2eperfEvent */] = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */]()) {
                        _runListeners(_listeners, STR_PERF_EVENT, null, function (listener) {
                            if (perfEvent.isAsync) {
                                ts_utils_scheduleTimeout(function () { return listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent); }, 0);
                            }
                            else {
                                listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                            }
                        });
                    }
                }
            };
            _self[STR_OFFLINE_STORE /* @min:%2eofflineEventsStored */] = function (events) {
                if (events && events[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                    _runListeners(_listeners, STR_OFFLINE_STORE, _asyncNotifications, function (listener) {
                        listener[STR_OFFLINE_STORE /* @min:%2eofflineEventsStored */](events);
                    });
                }
            };
            _self[STR_OFFLINE_SENT /* @min:%2eofflineBatchSent */] = function (batch) {
                if (batch && batch[_DYN_DATA /* @min:%2edata */]) {
                    _runListeners(_listeners, STR_OFFLINE_SENT, _asyncNotifications, function (listener) {
                        listener[STR_OFFLINE_SENT /* @min:%2eofflineBatchSent */](batch);
                    });
                }
            };
            _self[STR_OFFLINE_DROP /* @min:%2eofflineBatchDrop */] = function (cnt, reason) {
                if (cnt > 0) {
                    var rn_1 = reason || 0; // default is unknown
                    _runListeners(_listeners, STR_OFFLINE_DROP, _asyncNotifications, function (listener) {
                        listener[STR_OFFLINE_DROP /* @min:%2eofflineBatchDrop */](cnt, rn_1);
                    });
                }
            };
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                var _finishUnload = function () {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                    // Clear any async listener
                    _asyncNotifications.h && _asyncNotifications.h[_DYN_CANCEL /* @min:%2ecancel */]();
                    _asyncNotifications.h = null;
                    _asyncNotifications.cb = [];
                };
                var waiting;
                _runListeners(_listeners, "unload", null, function (listener) {
                    var asyncUnload = listener[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
                    if (asyncUnload) {
                        if (!waiting) {
                            waiting = [];
                        }
                        waiting[_DynamicConstants_DYN_PUSH /* @min:%2epush */](asyncUnload);
                    }
                });
                if (waiting) {
                    return createPromise(function (resolve) {
                        return doAwaitResponse(createAllPromise(waiting), function () {
                            _finishUnload();
                            resolve();
                        });
                    });
                }
                else {
                    _finishUnload();
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
// Removed Stub for NotificationManager.prototype.perfEvent.
// Removed Stub for NotificationManager.prototype.unload.
// Removed Stub for NotificationManager.prototype.offlineEventsStored.
// Removed Stub for NotificationManager.prototype.offlineBatchSent.
// Removed Stub for NotificationManager.prototype.offlineBatchDrop.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn=1;

    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/TelemetryInitializerPlugin.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










function _addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    arrAppend(_initializers, theInitializer);
    var handler = {
        remove: function () {
            ts_utils_arrForEach(_initializers, function (initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function _runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    for (var i = 0; i < telemetryInitializersCount; ++i) {
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) {
            try {
                if (telemetryInitializer.fn[_DYN_APPLY /* @min:%2eapply */](null, [item]) === false) {
                    doNotSendItem = true;
                    break;
                }
            }
            catch (e) {
                // log error but dont stop executing rest of the telemetry initializers
                // doNotSendItem = true;
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Telemetry initializer failed: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) }, true);
            }
        }
    }
    return !doNotSendItem;
}
var TelemetryInitializerPlugin = /** @class */ (function (_super) {
    __extendsFn(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        dynamicProto(TelemetryInitializerPlugin, _this, function (_self, _base) {
            _self.addTelemetryInitializer = function (telemetryInitializer) {
                return _addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */] = function (item, itemCtx) {
                if (_runInitializers(_initializers, item, itemCtx ? itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */]() : _self[_DYN_DIAG_LOG /* @min:%2ediagLog */]())) {
                    _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item, itemCtx);
                }
            };
            _self[_DynamicConstants_DYN_DO_TEARDOWN /* @min:%2e_doTeardown */] = function () {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
// Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
// Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn=1;

    return TelemetryInitializerPlugin;
}(BaseTelemetryPlugin));

//# sourceMappingURL=TelemetryInitializerPlugin.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/core/AppInsightsCore.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var AppInsightsCore_a, AppInsightsCore_b, _c;


























// import { IStatsBeat, IStatsBeatConfig, IStatsBeatState } from "../interfaces/ai/IStatsBeat";
// import { IStatsMgr } from "../interfaces/ai/IStatsMgr";
var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
var maxInitQueueSize = 100;
var maxInitTimeout = 50000;
var maxAttributeCount = 128;
// const strPluginUnloadFailed = "Failed to unload plugin";
// /**
//  * Default StatsBeatMgr configuration
//  * @internal
//  */
// const defaultStatsCfg: IConfigDefaults<IStatsBeatConfig> = objDeepFreeze({
//     shrtInt: UNDEFINED_VALUE,
//     endCfg: cfgDfMerge([])
// });
// /**
//  * Default SDK initialization configuration
//  * @internal
//  */
// const defaultSdkConfig: IConfigDefaults<IInternalSdkConfiguration> = objDeepFreeze({
//     stats: { rdOnly: true, mrg: true, v: defaultStatsCfg }
// });
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */
var defaultConfig = ts_utils_objDeepFreeze((AppInsightsCore_a = {
        cookieCfg: {}
    },
    AppInsightsCore_a[STR_EXTENSIONS] = { rdOnly: true, ref: true, v: [] },
    AppInsightsCore_a[STR_CHANNELS] = { rdOnly: true, ref: true, v: [] },
    AppInsightsCore_a[STR_EXTENSION_CONFIG] = { ref: true, v: {} },
    AppInsightsCore_a[STR_CREATE_PERF_MGR] = UNDEFINED_VALUE,
    AppInsightsCore_a.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */,
    AppInsightsCore_a.diagnosticLogInterval = UNDEFINED_VALUE,
    AppInsightsCore_a.traceHdrMode = 3 /* eTraceHeadersMode.All */,
    AppInsightsCore_a.traceCfg = cfgDfMerge((AppInsightsCore_b = {
            generalLimits: cfgDfMerge((_c = {
                    attributeValueLengthLimit: undefined
                },
                _c[_DYN_ATTRIBUTE_COUNT_LIMI5 /* @min:attributeCountLimit */] = maxAttributeCount,
                _c)),
            // spanLimits: cfgDfMerge({
            //     attributeValueLengthLimit: undefined,
            //     attributeCountLimit: maxAttributeCount,
            //     linkCountLimit: maxAttributeCount,
            //     eventCountLimit: maxAttributeCount,
            //     attributePerEventCountLimit: maxAttributeCount,
            //     attributePerLinkCountLimit: maxAttributeCount
            // }),
            // idGenerator: null,
            serviceName: null
        },
        AppInsightsCore_b[_DynamicConstants_DYN_SUPPRESS_TRACING /* @min:suppressTracing */] = false,
        AppInsightsCore_b)),
    AppInsightsCore_a));
function _getDefaultConfig(core) {
    var _a;
    var handlers = {
        // Dynamic Default Error Handlers
        errorHandlers: cfgDfMerge((_a = {
                attribError: function (message, key, value) {
                    core.logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](2 /* eLoggingSeverity.WARNING */, 115 /* _eInternalMessageId.AttributeError */, message, {
                        attribName: key,
                        value: value
                    });
                },
                spanError: function (message, spanName) {
                    core.logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](2 /* eLoggingSeverity.WARNING */, 116 /* _eInternalMessageId.SpanError */, message, {
                        spanName: spanName
                    });
                },
                debug: function (message) {
                    core[_DYN_LOGGER /* @min:%2elogger */].debugToConsole(message);
                },
                warn: function (message) {
                    core.logger[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
                },
                error: function (message) {
                    core.logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](1 /* eLoggingSeverity.CRITICAL */, 117 /* _eInternalMessageId.TraceError */, message);
                }
            },
            _a[_DYN_NOT_IMPLEMENTED /* @min:notImplemented */] = function (message) {
                core.logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](1 /* eLoggingSeverity.CRITICAL */, 118 /* _eInternalMessageId.NotImplementedError */, message);
            },
            _a))
    };
    return ts_utils_objDeepFreeze(objAssign({}, defaultConfig, handlers));
}
/**
 * Helper to create the default performance manager
 * @param core - The AppInsightsCore instance
 * @param notificationMgr - The notification manager
 */
/*#__NO_SIDE_EFFECTS__*/
function _createPerfManager(core, notificationMgr) {
    return new PerfManager(notificationMgr);
}
/*#__NO_SIDE_EFFECTS__*/
function _validateExtensions(logger, channelPriority, allExtensions) {
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    ts_utils_arrForEach(allExtensions, function (ext) {
        // Check for ext.initialize
        if (ts_utils_isNullOrUndefined(ext) || ts_utils_isNullOrUndefined(ext[_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */])) {
            throwError(strValidationError);
        }
        var extPriority = ext[STR_PRIORITY /* @min:%2epriority */];
        var identifier = ext[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */];
        if (ext && extPriority) {
            if (!ts_utils_isNullOrUndefined(extPriorities[extPriority])) {
                _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            }
            else {
                // set a value
                extPriorities[extPriority] = identifier;
            }
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) {
            // Add to core extension that will be managed by AppInsightsCore
            coreExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](ext);
        }
        else {
            channels[_DynamicConstants_DYN_PUSH /* @min:%2epush */](ext);
        }
    });
    return {
        core: coreExtensions,
        channels: channels
    };
}
/*#__NO_SIDE_EFFECTS__*/
function _isPluginPresent(thePlugin, plugins) {
    var exists = false;
    ts_utils_arrForEach(plugins, function (plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function _deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) {
        ts_utils_objForEachKey(newValues, function (key, value) {
            if (merge) {
                if (isPlainObject(value) && isPlainObject(target[key])) {
                    // The target is an object and it has a value
                    _deepMergeConfig(details, target[key], value, merge);
                }
            }
            if (merge && isPlainObject(value) && isPlainObject(target[key])) {
                // The target is an object and it has a value
                _deepMergeConfig(details, target[key], value, merge);
            }
            else {
                // Just Assign (replace) and/or make the property dynamic
                details.set(target, key, value);
            }
        });
    }
}
/*#__NO_SIDE_EFFECTS__*/
function _findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    ts_utils_arrForEach(listeners, function (listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return { i: idx, l: theListener };
}
function _addDelayedCfgListener(listeners, newWatcher) {
    var theListener = _findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function () {
                var fnd = _findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) {
                    listeners[_DYN_SPLICE /* @min:%2esplice */](fnd.i, 1);
                }
            }
        };
        listeners[_DynamicConstants_DYN_PUSH /* @min:%2epush */](theListener);
    }
    return theListener;
}
function _registerDelayedCfgListener(config, listeners, logger) {
    ts_utils_arrForEach(listeners, function (listener) {
        var unloadHdl = onConfigChange(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function () {
            unloadHdl.rm();
        };
    });
}
// Moved this outside of the closure to reduce the retained memory footprint
function _initDebugListener(configHandler, unloadContainer, notificationManager, debugListener) {
    // Will get recalled if any referenced config values are changed
    unloadContainer.add(configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
        var disableDbgExt = details.cfg.disableDbgExt;
        if (disableDbgExt === true && debugListener) {
            // Remove any previously loaded debug listener
            notificationManager[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */](debugListener);
            debugListener = null;
        }
        if (notificationManager && !debugListener && disableDbgExt !== true) {
            debugListener = getDebugListener(details.cfg);
            notificationManager[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](debugListener);
        }
    }));
    return debugListener;
}
// Moved this outside of the closure to reduce the retained memory footprint
/*#__NO_SIDE_EFFECTS__*/
function AppInsightsCore_createUnloadHook(unloadHook) {
    return ts_utils_objDefine({
        rm: function () {
            unloadHook.rm();
        }
    }, "toJSON", { v: function () { return "aicore::onCfgChange<" + JSON[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](unloadHook) + ">"; } });
}
/*#__NO_SIDE_EFFECTS__*/
function _getParentTraceCtx(mode) {
    var spanContext = null;
    var parentTrace = (mode & 1 /* eTraceHeadersMode.TraceParent */) ? findW3cTraceParent() : null;
    var parentTraceState = (mode & 2 /* eTraceHeadersMode.TraceState */) ? findW3cTraceState() : null;
    if (parentTrace || parentTraceState) {
        spanContext = createDistributedTraceContext({
            traceId: parentTrace ? parentTrace[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] : null,
            spanId: parentTrace ? parentTrace[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] : null,
            traceFlags: parentTrace ? parentTrace[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] : UNDEFINED_VALUE,
            isRemote: true,
            traceState: parentTraceState
        });
    }
    return spanContext;
}
/**
 * @group Classes
 * @group Entrypoint
 */
var AppInsightsCore = /** @class */ (function () {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        // let _statsBeat: IStatsBeat | null;
        // let _statsMgr: IStatsMgr | null;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _serverOTelCtx;
        var _serverTraceHdrMode;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _traceProvider;
        var _activeSpan;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        var _activeStatus; // to indicate if ikey or endpoint url promised is resolved or not
        var _endpoint;
        var _initInMemoMaxSize; // max event count limit during wait for init promises to be resolved
        var _isStatusSet; // track if active status is set in case of init timeout and init promises setting the status twice
        var _initTimer;
        /**
         * Internal log poller
         */
        var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        dynamicProto(AppInsightsCore, this, function (_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function () {
                return [_extensions, _eventQueue];
            };
            _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () { return _isInitialized; };
            // since version 3.3.0
            _self.activeStatus = function () { return _activeStatus; };
            // since version 3.3.0
            // internal
            _self._setPendingStatus = function () {
                _activeStatus = 3 /* eActiveStatus.PENDING */;
            };
            // Creating the self.initialize = ()
            _self[_DynamicConstants_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
                if (_isUnloading) {
                    throwError(strSdkUnloadingError);
                }
                // Make sure core is only initialized once
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    throwError("Core cannot be initialized more than once");
                }
                _configHandler = createDynamicConfig(config, _getDefaultConfig(_self), logger || _self[_DYN_LOGGER /* @min:%2elogger */], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var rootCfg = details.cfg;
                    _initInMemoMaxSize = rootCfg.initInMemoMaxSize || maxInitQueueSize;
                    _handleIKeyEndpointPromises(rootCfg);
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, STR_EXTENSION_CONFIG);
                    ts_utils_objForEachKey(extCfg, function (key) {
                        details.ref(extCfg, key);
                    });
                    if (rootCfg[_DYN_TRACE_HDR_MODE /* @min:%2etraceHdrMode */] !== _serverTraceHdrMode) {
                        // Create a new trace context if it doesn't exist and the mode is not None
                        _serverOTelCtx = _getParentTraceCtx(rootCfg[_DYN_TRACE_HDR_MODE /* @min:%2etraceHdrMode */]);
                        _serverTraceHdrMode = rootCfg[_DYN_TRACE_HDR_MODE /* @min:%2etraceHdrMode */];
                    }
                }));
                _notificationManager = notificationManager;
                // Initialize the debug listener outside of the closure to reduce the retained memory footprint
                _debugListener = _initDebugListener(_configHandler, _hookContainer, _notificationManager && _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */](), _debugListener);
                _initPerfManager();
                _self[_DYN_LOGGER /* @min:%2elogger */] = logger;
                var cfgExtensions = config[STR_EXTENSIONS /* @min:%2eextensions */];
                // Extension validation
                _configExtensions = [];
                _configExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions, false));
                _channelConfig = config[STR_CHANNELS /* @min:%2echannels */];
                _initPluginChain(null);
                if (!_channels || _channels[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 0) {
                    throwError("No " + STR_CHANNELS + " available");
                }
                if (_channelConfig && _channelConfig[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 1) {
                    var teeController = _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]("TeeChannelController");
                    if (!teeController || !teeController.plugin) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "TeeChannel required");
                    }
                }
                _registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                if (_activeStatus === ActiveStatus.ACTIVE) {
                    _releaseQueues();
                }
            };
            _self.getChannels = function () {
                var controls = [];
                if (_channels) {
                    ts_utils_arrForEach(_channels, function (channel) {
                        controls[_DynamicConstants_DYN_PUSH /* @min:%2epush */](channel);
                    });
                }
                return objFreeze(controls);
            };
            _self[_DYN_TRACK /* @min:%2etrack */] = function (telemetryItem) {
                doPerf(_self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */](), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        throwError("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[_DynamicConstants_DYN_NAME /* @min:%2ename */] && ts_utils_isNullOrUndefined(telemetryItem[_DynamicConstants_DYN_NAME /* @min:%2ename */])) {
                        _notifyInvalidEvent(telemetryItem);
                        throwError("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem[_DYN_I_KEY /* @min:%2eiKey */] = telemetryItem[_DYN_I_KEY /* @min:%2eiKey */] || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem[_DYN_TIME /* @min:%2etime */] = telemetryItem[_DYN_TIME /* @min:%2etime */] || HelperFuncs_toISOString(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]() && _activeStatus === ActiveStatus.ACTIVE) {
                        // Process the telemetry plugin chain
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](telemetryItem);
                    }
                    else if (_activeStatus !== ActiveStatus.INACTIVE) {
                        // Queue events until all extensions are initialized
                        if (_eventQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] <= _initInMemoMaxSize) {
                            // set limit, if full, stop adding new events
                            _eventQueue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](telemetryItem);
                        }
                    }
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            _self[_DYN_GET_PROCESS_TEL_CONT2 /* @min:%2egetProcessTelContext */] = _createTelCtx;
            _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */] = function () {
                if (!_notificationManager) {
                    _notificationManager = new NotificationManager(_configHandler.cfg);
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _self.getNotifyMgr()[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */] = function (listener) {
                if (_notificationManager) {
                    _notificationManager[_DYN_REMOVE_NOTIFICATION_0 /* @min:%2eremoveNotificationListener */](listener);
                }
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = createCookieMgr(_configHandler.cfg, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    runTargetUnload(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */] = function () {
                return _perfManager || _cfgPerfManager || getGblPerfMgr();
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            // _self.getStatsBeat = (statsBeatState: IStatsBeatState) => {
            //     // create a new statsbeat if not initialize yet or the endpoint is different
            //     // otherwise, return the existing one, or null
            //     if (statsBeatState) {
            //         if (_statsMgr && _statsMgr.enabled) {
            //             if (_statsBeat && _statsBeat.endpoint !== statsBeatState.endpoint) {
            //                 // Different endpoint, so unload the existing and create a new one
            //                 _statsBeat.enabled = false;
            //                 _statsBeat = null;
            //             }
            //             if (!_statsBeat) {
            //                 // Create a new statsbeat instance
            //                 _statsBeat = _statsMgr.newInst(statsBeatState);
            //             }
            //         } else if (_statsBeat) {
            //             // Disable and remove any previously created statsbeat instance
            //             _statsBeat.enabled = false;
            //             _statsBeat = null;
            //         }
            //         // Return the current statsbeat instance or null if not created
            //         return _statsBeat;
            //     }
            //     // Return null as no statsbeat state was provided
            //     return null;
            // };
            // _self.setStatsMgr = (statsMgr: IStatsMgr) => {
            //     if (_statsMgr && _statsMgr !== statsMgr) {
            //         // Disable any previously created statsbeat instance
            //         if (_statsBeat) {
            //             _statsBeat.enabled = false;
            //             _statsBeat = null;
            //         }
            //     }
            //     _statsMgr = statsMgr;
            // };
            _self.eventCnt = function () {
                return _eventQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
            };
            _self.releaseQueue = function () {
                if (_isInitialized && _eventQueue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    if (_activeStatus === 2 /* eActiveStatus.ACTIVE */) {
                        ts_utils_arrForEach(eventQueue, function (event) {
                            event[_DYN_I_KEY /* @min:%2eiKey */] = event[_DYN_I_KEY /* @min:%2eiKey */] || _instrumentationKey;
                            _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](event);
                        });
                    }
                    else {
                        // new one for msg ikey
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "core init status is not active");
                    }
                }
            };
            _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */] = function (eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                return _startLogPoller(true);
            };
            function _handleIKeyEndpointPromises(theConfig) {
                // app Insights core only handle ikey and endpointurl, aisku will handle cs
                // But we want to reference these config values so that if any future changes are made
                // this will trigger the re-run of the watch function
                // and the ikey and endpointUrl will be set to the new values
                var ikey = theConfig.instrumentationKey;
                var endpointUrl = theConfig.endpointUrl; // do not need to validate endpoint url, if it is null, default one will be set by sender
                // Check if we are waiting for previous promises to be resolved, won't apply new changes
                if (_activeStatus !== 3 /* eActiveStatus.PENDING */) {
                    if (ts_utils_isNullOrUndefined(ikey)) {
                        _instrumentationKey = null;
                        // if new ikey is null, set status to be inactive, all new events will be saved in memory or dropped
                        _activeStatus = ActiveStatus.INACTIVE;
                        var msg = "Please provide instrumentation key";
                        if (!_isInitialized) {
                            // only throw error during initialization
                            throwError(msg);
                        }
                        else {
                            _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, msg);
                            _releaseQueues();
                        }
                        return;
                    }
                    var promises = [];
                    if (ts_utils_isPromiseLike(ikey)) {
                        promises[_DynamicConstants_DYN_PUSH /* @min:%2epush */](ikey);
                        _instrumentationKey = null; // reset current local ikey variable (otherwise it will always be the previous ikeys if timeout is called before promise cb)
                    }
                    else {
                        // string
                        _instrumentationKey = ikey;
                    }
                    if (ts_utils_isPromiseLike(endpointUrl)) {
                        promises[_DynamicConstants_DYN_PUSH /* @min:%2epush */](endpointUrl);
                        _endpoint = null; // reset current local endpoint variable (otherwise it will always be the previous urls if timeout is called before promise cb)
                    }
                    else {
                        // string or null
                        _endpoint = endpointUrl;
                    }
                    // at least have one promise
                    if (promises[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                        _waitForInitPromises(theConfig, promises);
                    }
                    else {
                        // means no promises
                        _setStatus();
                    }
                }
            }
            function _waitForInitPromises(theConfig, promises) {
                // reset to false for new dynamic changes
                _isStatusSet = false;
                _activeStatus = 3 /* eActiveStatus.PENDING */;
                var initTimeout = isNotNullOrUndefined(theConfig.initTimeOut) ? theConfig.initTimeOut : maxInitTimeout; // theConfig.initTimeOut could be 0
                var allPromises = createSyncAllSettledPromise(promises);
                if (_initTimer) {
                    // Stop any previous timer
                    _initTimer[_DYN_CANCEL /* @min:%2ecancel */]();
                }
                _initTimer = ts_utils_scheduleTimeout(function () {
                    // set _isStatusSet to true
                    // set active status
                    // release queues
                    _initTimer = null;
                    if (!_isStatusSet) {
                        _setStatus();
                    }
                }, initTimeout);
                doAwaitResponse(allPromises, function (response) {
                    try {
                        if (_isStatusSet) {
                            // promises take too long to resolve, ignore them
                            // active status should be set by timeout already
                            return;
                        }
                        if (!response.rejected) {
                            var values = response[_DYN_VALUE /* @min:%2evalue */];
                            if (values && values[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) {
                                // ikey
                                var ikeyRes = values[0];
                                _instrumentationKey = ikeyRes && ikeyRes[_DYN_VALUE /* @min:%2evalue */];
                                // endpoint
                                if (values[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 1) {
                                    var endpointRes = values[1];
                                    _endpoint = endpointRes && endpointRes[_DYN_VALUE /* @min:%2evalue */];
                                }
                            }
                            if (_instrumentationKey) {
                                // if ikey is null, no need to trigger extra dynamic changes for extensions
                                theConfig.instrumentationKey = _instrumentationKey; // set config.instrumentationKey for extensions to consume
                                theConfig.endpointUrl = _endpoint; // set config.endpointUrl for extensions to consume
                            }
                        }
                        // set _isStatusSet to true
                        // set active status
                        // release queues
                        _setStatus();
                    }
                    catch (e) {
                        if (!_isStatusSet) {
                            _setStatus();
                        }
                    }
                });
            }
            function _setStatus() {
                _isStatusSet = true;
                if (ts_utils_isNullOrUndefined(_instrumentationKey)) {
                    _activeStatus = ActiveStatus.INACTIVE;
                    _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 112 /* _eInternalMessageId.InitPromiseException */, "ikey can't be resolved from promises");
                }
                else {
                    _activeStatus = ActiveStatus.ACTIVE;
                }
                _releaseQueues();
            }
            function _releaseQueues() {
                if (_isInitialized) {
                    _self.releaseQueue();
                    _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
                }
            }
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || (_logger && _logger.queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0);
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) {
                                    interval = 10000;
                                }
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */];
                                    _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = createTimeout(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = isRunning;
                            }));
                        }
                        _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */] = function () {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            proxyFunctions(_self, function () { return _telemetryInitializerPlugin; }, ["addTelemetryInitializer"]);
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync, unloadComplete, cbTimeout) {
                if (isAsync === void 0) { isAsync = true; }
                if (!_isInitialized) {
                    // The SDK is not initialized
                    throwError(strSdkNotInitialized);
                }
                // Check if the SDK still unloading so throw
                if (_isUnloading) {
                    // The SDK is already unloading
                    throwError(strSdkUnloadingError);
                }
                var unloadState = {
                    reason: 50 /* TelemetryUnloadReason.SdkUnload */,
                    isAsync: isAsync,
                    flushComplete: false
                };
                var result;
                if (isAsync && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
                processUnloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                    // if (_statsBeat) {
                    //     // Disable any statsbeat instance
                    //     _statsBeat.enabled = false;
                    //     _statsBeat = null;
                    // }
                    _hookContainer.run(_self[_DYN_LOGGER /* @min:%2elogger */]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    doUnloadAll([_cookieManager, _notificationManager, _logger], isAsync, function () {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */, cbTimeout)) {
                    _doUnload(false);
                }
                return result;
            };
            _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */] = _getPlugin;
            _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError(strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */
                };
                function _addPlugin(removed) {
                    _configExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](plugin);
                    updateState.added = [plugin];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [existingPlugin.plugin];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function (removed) {
                        if (!removed) {
                            // Previous plugin was successfully removed or was not installed
                            addCb && addCb(false);
                        }
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState[_DYN_REASON /* @min:%2ereason */] |= 32 /* TelemetryUpdateReason.PluginRemoved */;
                            _addPlugin(true);
                        }
                    });
                }
                else {
                    _addPlugin(false);
                }
            };
            _self.updateCfg = function (newConfig, mergeExisting) {
                if (mergeExisting === void 0) { mergeExisting = true; }
                var updateState;
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */,
                        cfg: _configHandler.cfg,
                        oldCfg: deepExtend({}, _configHandler.cfg),
                        newConfig: deepExtend({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[STR_EXTENSIONS /* @min:%2eextensions */] = cfg[STR_EXTENSIONS /* @min:%2eextensions */];
                    newConfig[STR_CHANNELS /* @min:%2echannels */] = cfg[STR_CHANNELS /* @min:%2echannels */];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function (details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    _deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) {
                        // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                        ts_utils_objForEachKey(theConfig, function (key) {
                            if (!objHasOwn(newConfig, key)) {
                                // Set the value to undefined
                                details.set(theConfig, key, UNDEFINED_VALUE);
                            }
                        });
                    }
                    // Apply defaults to the new config
                    details.setDf(theConfig, defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler.notify();
                if (updateState) {
                    _doUpdate(updateState);
                }
            };
            _self.evtNamespace = function () {
                return _evtNamespace;
            };
            _self[_DYN_FLUSH /* @min:%2eflush */] = _flushChannels;
            _self[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */] = function (createNew) {
                if ((!_traceCtx && createNew !== false) || createNew === true) {
                    _traceCtx = createDistributedTraceContext(_serverOTelCtx);
                }
                return _traceCtx;
            };
            _self[_DYN_SET_TRACE_CTX /* @min:%2esetTraceCtx */] = function (traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.startSpan = function (name, options, parent) {
                if (!_traceProvider || !_traceProvider.v || !_traceProvider.v.isAvailable()) {
                    // No trace provider available or provider is not ready
                    return null;
                }
                return _traceProvider.v.createSpan(name, options, parent || _self[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]());
            };
            /**
             * Return the current active span
             * @param createNew - Optional flag to create a non-recording span if no active span exists, defaults to true
             */
            _self[_DYN_GET_ACTIVE_SPAN /* @min:%2egetActiveSpan */] = function (createNew) {
                // Special case for when there is no active span but there is a trace provider
                if (createNew !== false && _traceProvider && !_activeSpan && _traceProvider.v) {
                    // Now that we have a trace provider, ensure that we return an active span (non-recording)
                    _activeSpan = _traceProvider.v.createSpan(_traceProvider.v.getProviderId(), {
                        recording: false,
                        root: true
                    });
                }
                return _activeSpan;
            };
            /**
             * Set the current Active Span
             * @param span - The span to set as the active span
             */
            _self[_DynamicConstants_DYN_SET_ACTIVE_SPAN /* @min:%2esetActiveSpan */] = function (span) {
                var theSpanContext = null;
                var currentCtx = _self[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]();
                var currentSpan = _activeSpan;
                var scope;
                if (span) {
                    var otelSpanContext = null;
                    if (span[_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]) {
                        // May be a valid IDistributedTraceContext or an OpenTelemetry SpanContext
                        otelSpanContext = span[_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]();
                    }
                    else if (span.context) {
                        // Legacy OpenTelemetry API support (Note: The returned context won't be a valid IDistributedTraceContext)
                        otelSpanContext = span.context();
                    }
                    if (otelSpanContext) {
                        if (isDistributedTraceContext(otelSpanContext)) {
                            theSpanContext = otelSpanContext;
                        }
                        else {
                            // Support Spans from other libraries that may not be using the IDistributedTraceContext
                            // If the spanContext is not a valid IDistributedTraceContext then we need to create a new one
                            // and optionally set the parentSpanContext if it exists
                            // Create a new context using the current trace context as the parent
                            theSpanContext = createDistributedTraceContext(currentCtx);
                            var parentContext = span[_DYN_PARENT_SPAN_CONTEXT /* @min:%2eparentSpanContext */];
                            if (!parentContext) {
                                if (span[_DYN_PARENT_SPAN_ID /* @min:%2eparentSpanId */]) {
                                    parentContext = {
                                        traceId: otelSpanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */],
                                        spanId: span[_DYN_PARENT_SPAN_ID /* @min:%2eparentSpanId */]
                                    };
                                }
                            }
                            // Was there a defined parent context and is it different from the current basic context
                            if (parentContext && parentContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] !== theSpanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] &&
                                parentContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] !== theSpanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] &&
                                parentContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] !== theSpanContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]) {
                                // Assign the parent details to this new context
                                theSpanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] = parentContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */];
                                theSpanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = parentContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
                                theSpanContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = parentContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                                // Now create a new "Child" context which is extending the parent context
                                theSpanContext = createDistributedTraceContext(theSpanContext);
                            }
                            theSpanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] = otelSpanContext[_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */];
                            theSpanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = otelSpanContext[_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
                            theSpanContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = otelSpanContext[_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                        }
                    }
                }
                scope = {
                    host: _self,
                    span: span,
                    prvSpan: currentSpan,
                    restore: function () {
                        // Restore the current span and trace context
                        if (currentSpan) {
                            _self[_DynamicConstants_DYN_SET_ACTIVE_SPAN /* @min:%2esetActiveSpan */](currentSpan);
                        }
                        else {
                            _activeSpan = null;
                            _self[_DYN_SET_TRACE_CTX /* @min:%2esetTraceCtx */](currentCtx);
                        }
                        // Clear the restore function, so that multiple calls to restore do not have any effect
                        scope.restore = _noopVoid;
                    }
                };
                // Change the active span to the new span
                _activeSpan = span;
                // Set the current trace context for the core SDK
                // This is REQUIRED for the SDK to correctly associate telemetry with the current span context
                if (theSpanContext) {
                    _self[_DYN_SET_TRACE_CTX /* @min:%2esetTraceCtx */](theSpanContext);
                }
                return scope;
            };
            _self.setTraceProvider = function (traceProvider) {
                _traceProvider = traceProvider;
            };
            _self.getTraceProvider = function () {
                return _traceProvider ? _traceProvider.v : null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            proxyFunctionAs(_self, "addUnloadCb", function () { return _unloadHandlers; }, "add");
            _self.onCfgChange = function (handler) {
                var unloadHook;
                if (!_isInitialized) {
                    unloadHook = _addDelayedCfgListener(_cfgListeners, handler);
                }
                else {
                    unloadHook = onConfigChange(_configHandler.cfg, handler, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return AppInsightsCore_createUnloadHook(unloadHook);
            };
            _self.getWParam = function () {
                return (hasDocument() || !!_configHandler.cfg.enableWParam) ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function (plugins) {
                    if (plugins) {
                        ts_utils_arrForEach(plugins, function (plugin) {
                            if (plugin[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */] && plugin[InternalConstants_STR_VERSION /* @min:%2eversion */] && !thePlugins[plugin.identifier]) {
                                var ver = plugin[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */] + "=" + plugin[InternalConstants_STR_VERSION /* @min:%2eversion */];
                                _pluginVersionStringArr[_DynamicConstants_DYN_PUSH /* @min:%2epush */](ver);
                                thePlugins[plugin.identifier] = plugin;
                            }
                        });
                    }
                };
                _addPluginVersions(_channels);
                if (_channelConfig) {
                    ts_utils_arrForEach(_channelConfig, function (channels) {
                        _addPluginVersions(channels);
                    });
                }
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = createDynamicConfig({}, defaultConfig, _self[_DYN_LOGGER /* @min:%2elogger */]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */] = 1 /* eLoggingSeverity.CRITICAL */;
                // Define _self.config
                ts_utils_objDefine(_self, "config", {
                    g: function () { return _configHandler.cfg; },
                    s: function (newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                ts_utils_objDefine(_self, "pluginVersionStringArr", {
                    g: function () {
                        if (!_pluginVersionStringArr) {
                            _setPluginVersions();
                        }
                        return _pluginVersionStringArr;
                    }
                });
                ts_utils_objDefine(_self, "pluginVersionString", {
                    g: function () {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) {
                                _setPluginVersions();
                            }
                            _pluginVersionString = _pluginVersionStringArr[_DYN_JOIN /* @min:%2ejoin */](";");
                        }
                        return _pluginVersionString || InternalConstants_STR_EMPTY;
                    }
                });
                ts_utils_objDefine(_self, "logger", {
                    g: function () {
                        if (!_logger) {
                            _logger = new DiagnosticLogger(_configHandler.cfg);
                            _configHandler[_DYN_LOGGER /* @min:%2elogger */] = _logger;
                        }
                        return _logger;
                    },
                    s: function (newLogger) {
                        _configHandler[_DYN_LOGGER /* @min:%2elogger */] = newLogger;
                        if (_logger !== newLogger) {
                            runTargetUnload(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[_DYN_LOGGER /* @min:%2elogger */] = new DiagnosticLogger(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
                _serverOTelCtx = null;
                _serverTraceHdrMode = 0 /* eTraceHeadersMode.None */;
                _eventQueue = [];
                runTargetUnload(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                // _statsBeat = null;
                _cfgPerfManager = null;
                runTargetUnload(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = DataCacheHelper_createUniqueNamespace("AIBaseCore", true);
                _unloadHandlers = createUnloadHandlerContainer();
                _traceCtx = null;
                _traceProvider = null;
                _instrumentationKey = null;
                _hookContainer = createUnloadHookContainer();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller = null;
                _internalLogPollerListening = false;
                _activeStatus = 0 /* eActiveStatus.NONE */; // default is None
                _endpoint = null;
                _initInMemoMaxSize = null;
                _isStatusSet = false;
                _initTimer = null;
                // if (_statsBeat) {
                //     // Unload and disable any statsbeat instance
                //     _statsBeat.enabled = false;
                // }
                // _statsBeat = null;
            }
            function _createTelCtx() {
                var theCtx = createProcessTelemetryContext(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = _validateExtensions(_self[_DYN_LOGGER /* @min:%2elogger */], ChannelControllerPriority, _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = sortPlugins(arrAppend(_channels, theExtensions[STR_CHANNELS /* @min:%2echannels */]));
                // Create an array of all extensions, including the _channels
                var allExtensions = arrAppend(sortPlugins(theExtensions[STR_CORE /* @min:%2ecore */]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = objFreeze(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */][STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    initializePlugins(rootCtx[_DYN_CREATE_NEW /* @min:%2ecreateNew */](_channels), allExtensions);
                }
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                initializePlugins(rootCtx, allExtensions);
                if (updateState) {
                    _doUpdate(updateState);
                }
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                ts_utils_arrForEach(_extensions, function (ext) {
                    if (ext[_DynamicConstants_DYN_IDENTIFIER /* @min:%2eidentifier */] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) {
                        channelHosts[_DynamicConstants_DYN_PUSH /* @min:%2epush */](ext);
                    }
                });
                if (!thePlugin && channelHosts[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    ts_utils_arrForEach(channelHosts, function (host) {
                        thePlugin = host.getChannel(pluginIdentifier);
                        if (!thePlugin) {
                            return -1;
                        }
                    });
                }
                if (thePlugin) {
                    theExt = {
                        plugin: thePlugin,
                        setEnabled: function (enabled) {
                            _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
                        },
                        isEnabled: function () {
                            var pluginState = _getPluginState(thePlugin);
                            return !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] && !pluginState[STR_DISABLED];
                        },
                        remove: function (isAsync, removeCb) {
                            if (isAsync === void 0) { isAsync = true; }
                            var pluginsToRemove = [thePlugin];
                            var unloadState = {
                                reason: 1 /* TelemetryUnloadReason.PluginUnload */,
                                isAsync: isAsync
                            };
                            _removePlugins(pluginsToRemove, unloadState, function (removed) {
                                if (removed) {
                                    // Re-Initialize the plugin chain
                                    _initPluginChain({
                                        reason: 32 /* TelemetryUpdateReason.PluginRemoved */,
                                        removed: pluginsToRemove
                                    });
                                }
                                removeCb && removeCb(removed);
                            });
                        }
                    };
                }
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if (ts_utils_arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
                        extensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](_telemetryInitializerPlugin);
                    }
                    _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    var unloadChain = createTelemetryProxyChain(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
                    unloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        ts_utils_arrForEach(_configExtensions, function (plugin, idx) {
                            if (!_isPluginPresent(plugin, thePlugins)) {
                                newConfigExtensions[_DynamicConstants_DYN_PUSH /* @min:%2epush */](plugin);
                            }
                            else {
                                removed = true;
                            }
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            ts_utils_arrForEach(_channelConfig, function (queue, idx) {
                                var newQueue = [];
                                ts_utils_arrForEach(queue, function (channel) {
                                    if (!_isPluginPresent(channel, thePlugins)) {
                                        newQueue[_DynamicConstants_DYN_PUSH /* @min:%2epush */](channel);
                                    }
                                    else {
                                        removed = true;
                                    }
                                });
                                newChannelConfig[_DynamicConstants_DYN_PUSH /* @min:%2epush */](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                else {
                    removeComplete(false);
                }
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] = 0;
                    ts_utils_arrForEach(queue, function (logMessage) {
                        var item = {
                            name: _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID /* @min:%2emessageId */],
                            iKey: _instrumentationKey,
                            time: HelperFuncs_toISOString(new Date()),
                            baseType: _InternalLogMessage.dataType,
                            baseData: { message: logMessage[_DYN_MESSAGE /* @min:%2emessage */] }
                        };
                        _self[_DYN_TRACK /* @min:%2etrack */](item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[_DYN_CANCEL /* @min:%2ecancel */]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    var flushCtx = _createTelCtx()[_DYN_CREATE_NEW /* @min:%2ecreateNew */](_channels);
                    flushCtx.iterate(function (plugin) {
                        if (plugin[_DYN_FLUSH /* @min:%2eflush */]) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin[_DYN_FLUSH /* @min:%2eflush */](isAsync, function () {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) {
                                        cbTimer = ts_utils_scheduleTimeout(function () {
                                            cbTimer = null;
                                            doCallback();
                                        }, cbTimeout);
                                    }
                                    else {
                                        doCallback();
                                    }
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initPerfManager() {
                // Save the previous config based performance manager creator to avoid creating new perf manager instances if unchanged
                var prevCfgPerfMgr;
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (enablePerfMgr) {
                        var createPerfMgr = details.cfg[STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */];
                        // for preCfgPerfMgr = createPerfMgr = null
                        // initial createPerfMgr function should be _createPerfManager
                        if ((prevCfgPerfMgr !== createPerfMgr) || !prevCfgPerfMgr) {
                            if (!createPerfMgr) {
                                createPerfMgr = _createPerfManager;
                            }
                            // Set the performance manager creation function if not defined
                            getSetValue(details.cfg, STR_CREATE_PERF_MGR, createPerfMgr);
                            prevCfgPerfMgr = createPerfMgr;
                            // Remove any existing config based performance manager
                            _cfgPerfManager = null;
                        }
                        // Only create the performance manager if it's not already created or manually set
                        if (!_perfManager && !_cfgPerfManager && ts_utils_isFunction(createPerfMgr)) {
                            // Create a new config based performance manager
                            _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]());
                        }
                    }
                    else {
                        // Remove any existing config based performance manager
                        _cfgPerfManager = null;
                        // Clear the previous cached value so it can be GC'd
                        prevCfgPerfMgr = null;
                    }
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
                updateCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
                    updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
                }
            }
            function _logOrThrowError(message) {
                var logger = _self[_DYN_LOGGER /* @min:%2elogger */];
                if (logger) {
                    // there should always be a logger
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, message);
                    _startLogPoller();
                }
                else {
                    throwError(message);
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
                if (manager) {
                    manager[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */]([telemetryItem], 2 /* eEventsDiscardedReason.InvalidEvent */);
                }
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.getChannels.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
// Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.getCookieMgr.
// Removed Stub for AppInsightsCore.prototype.setCookieMgr.
// Removed Stub for AppInsightsCore.prototype.getPerfMgr.
    // public getStatsBeat(statsBeatState: IStatsBeatState): IStatsBeat {
    //     // @ DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    //     return null;
    // }
    // public setStatsMgr(statsMgr?: IStatsMgr): void {
    //     // @ DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    // }
// Removed Stub for AppInsightsCore.prototype.setPerfMgr.
// Removed Stub for AppInsightsCore.prototype.eventCnt.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
// Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
// Removed Stub for AppInsightsCore.prototype.unload.
// Removed Stub for AppInsightsCore.prototype.getPlugin.
// Removed Stub for AppInsightsCore.prototype.addPlugin.
// Removed Stub for AppInsightsCore.prototype.updateCfg.
// Removed Stub for AppInsightsCore.prototype.evtNamespace.
// Removed Stub for AppInsightsCore.prototype.addUnloadCb.
// Removed Stub for AppInsightsCore.prototype.flush.
// Removed Stub for AppInsightsCore.prototype.getTraceCtx.
// Removed Stub for AppInsightsCore.prototype.setTraceCtx.
// Removed Stub for AppInsightsCore.prototype.startSpan.
// Removed Stub for AppInsightsCore.prototype.getActiveSpan.
// Removed Stub for AppInsightsCore.prototype.setActiveSpan.
// Removed Stub for AppInsightsCore.prototype.setTraceProvider.
// Removed Stub for AppInsightsCore.prototype.getTraceProvider.
// Removed Stub for AppInsightsCore.prototype.addUnloadHook.
// Removed Stub for AppInsightsCore.prototype.onCfgChange.
// Removed Stub for AppInsightsCore.prototype.activeStatus.
// Removed Stub for AppInsightsCore.prototype._setPendingStatus.
// Removed Stub for AppInsightsCore.prototype.releaseQueue.
// Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn=1;

    return AppInsightsCore;
}());

//# sourceMappingURL=AppInsightsCore.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/diagnostics/ThrottleMgr.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var ThrottleMgr = /** @class */ (function () {
    function ThrottleMgr(core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
        _self["_getDbgPlgTargets"] = function () {
            return [_queue];
        };
        _self.getConfig = function () {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */
        _self.canThrottle = function (msgId) {
            var localObj = _getLocalStorageObjByKey(msgId);
            var cfg = _getCfgByKey(msgId);
            return _canThrottle(cfg, _canUseLocalStorage, localObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */
        _self.isTriggered = function (msgId) {
            return _isTrigger(msgId);
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */
        _self.isReady = function () {
            return _isReady;
        };
        /**
         * Flush all message with given message key in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self[_DYN_FLUSH /* @min:%2eflush */] = function (msgId) {
            try {
                var queue = _getQueueByKey(msgId);
                if (queue && queue[_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    var items = queue.slice(0);
                    _queue[msgId] = [];
                    ts_utils_arrForEach(items, function (item) {
                        _flushMessage(item.msgID, item[_DYN_MESSAGE /* @min:%2emessage */], item.severity, false);
                    });
                    return true;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flushAll = function () {
            try {
                if (_queue) {
                    var result_1 = true;
                    ts_utils_objForEachKey(_queue, function (key) {
                        var isFlushed = _self[_DYN_FLUSH /* @min:%2eflush */](parseInt(key));
                        result_1 = result_1 && isFlushed;
                    });
                    return result_1;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady - isReady State
         * @pa
         * @returns if message queue is flushed
         */
        _self.onReadyState = function (isReady, flushAll) {
            if (flushAll === void 0) { flushAll = true; }
            _isReady = ts_utils_isNullOrUndefined(isReady) ? true : isReady;
            if (_isReady && flushAll) {
                return _self.flushAll();
            }
            return null;
        };
        _self.sendMessage = function (msgID, message, severity) {
            return _flushMessage(msgID, message, severity, true);
        };
        function _flushMessage(msgID, message, severity, saveUnsentMsg) {
            if (_isReady) {
                var isSampledIn = _canSampledIn(msgID);
                if (!isSampledIn) {
                    return;
                }
                var cfg = _getCfgByKey(msgID);
                var localStorageObj = _getLocalStorageObjByKey(msgID);
                var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
                var throttled = false;
                var number = 0;
                var isTriggered = _isTrigger(msgID);
                try {
                    if (canThrottle && !isTriggered) {
                        number = mathMin(cfg.limit.maxSendNumber, localStorageObj[_DYN_COUNT /* @min:%2ecount */] + 1);
                        localStorageObj[_DYN_COUNT /* @min:%2ecount */] = 0;
                        throttled = true;
                        _isTriggered[msgID] = true;
                        localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */] = new Date();
                    }
                    else {
                        _isTriggered[msgID] = canThrottle;
                        localStorageObj[_DYN_COUNT /* @min:%2ecount */] += 1;
                    }
                    var localStorageName = _getLocalStorageName(msgID);
                    _resetLocalStorage(_logger, localStorageName, localStorageObj);
                    for (var i = 0; i < number; i++) {
                        _sendMessage(msgID, _logger, message, severity);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            }
            else {
                if (!!saveUnsentMsg) {
                    var queue = _getQueueByKey(msgID);
                    queue[_DynamicConstants_DYN_PUSH /* @min:%2epush */]({
                        msgID: msgID,
                        message: message,
                        severity: severity
                    });
                }
            }
            return null;
        }
        function _initConfig() {
            _logger = safeGetLogger(core);
            _isTriggered = {};
            _localStorageObj = {};
            _queue = {};
            _config = {};
            _setCfgByKey(109 /* _eInternalMessageId.DefaultThrottleMsgKey */);
            _namePrefix = !ts_utils_isNullOrUndefined(namePrefix) ? namePrefix : "";
            core.addUnloadHook(onConfigChange(core[_DynamicConstants_DYN_CONFIG /* @min:%2econfig */], function (details) {
                var coreConfig = details.cfg;
                _canUseLocalStorage = utlCanUseLocalStorage();
                var configMgr = coreConfig.throttleMgrCfg || {};
                ts_utils_objForEachKey(configMgr, function (key, cfg) {
                    _setCfgByKey(parseInt(key), cfg);
                });
            }));
        }
        function _getCfgByKey(msgID) {
            return _config[msgID] || _config[109 /* _eInternalMessageId.DefaultThrottleMsgKey */];
        }
        function _setCfgByKey(msgID, config) {
            var _a, _b;
            try {
                var cfg = config || {};
                var curCfg = {};
                curCfg[STR_DISABLED /* @min:%2edisabled */] = !!cfg[STR_DISABLED /* @min:%2edisabled */];
                var configInterval = cfg.interval || {};
                _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[_DynamicConstants_DYN_LENGTH /* @min:%2elength */]) > 0;
                curCfg.interval = _getIntervalConfig(configInterval);
                var limit = {
                    samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                    // dafault: every time sent only 1 event
                    maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
                };
                curCfg.limit = limit;
                _config[msgID] = curCfg;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
            var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
            // default: send data every 3 month each year
            if (ts_utils_isNullOrUndefined(monthInterval) && ts_utils_isNullOrUndefined(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval.daysOfMonth = [28];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
                dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
                daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (config && !config[STR_DISABLED /* @min:%2edisabled */] && canUseLocalStorage && !ts_utils_isNullOrUndefined(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj.date;
                var interval = config.interval;
                var monthCheck = 1;
                if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) {
                    dayCheck = ts_utils_arrIndexOf(interval.daysOfMonth, curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]());
                }
                else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
                    var daySpan = mathFloor((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = !ts_utils_isNullOrUndefined(prefix) ? prefix : "";
            if (msgKey) {
                return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            }
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() &&
                        preTriggerDate.getUTCMonth() === curDate.getUTCMonth() &&
                        preTriggerDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]() === curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    var curObj = {
                        date: _getThrottleDate(obj.date) || storageObj.date,
                        count: obj[_DYN_COUNT /* @min:%2ecount */] || storageObj[_DYN_COUNT /* @min:%2ecount */],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]) : undefined
                    };
                    return curObj;
                }
                else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) {
                        return date;
                    }
                }
                else {
                    return new Date();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return utlSetLocalStorage(logger, storageName, strTrim(JSON[_DynamicConstants_DYN_STRINGIFY /* @min:%2estringify */](obj)));
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            if (interval <= 0) {
                return 1;
            }
            // count from start year
            return (current >= start) && (current - start) % interval == 0 ? mathFloor((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            _throwInternal(logger, severity || 1 /* eLoggingSeverity.CRITICAL */, msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn(msgID) {
            try {
                var cfg = _getCfgByKey(msgID);
                return randomValue(1000000) <= cfg.limit.samplingRate;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _getLocalStorageObjByKey(key) {
            try {
                var curObj = _localStorageObj[key];
                if (!curObj) {
                    var localStorageName = _getLocalStorageName(key, _namePrefix);
                    curObj = _getLocalStorageObj(utlGetLocalStorage(_logger, localStorageName), _logger, localStorageName);
                    _localStorageObj[key] = curObj;
                }
                return _localStorageObj[key];
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _isTrigger(key) {
            var isTrigger = _isTriggered[key];
            if (ts_utils_isNullOrUndefined(isTrigger)) {
                isTrigger = false;
                var localStorageObj = _getLocalStorageObjByKey(key);
                if (localStorageObj) {
                    isTrigger = _isTriggeredOnCurDate(localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]);
                }
                _isTriggered[key] = isTrigger;
            }
            return _isTriggered[key];
        }
        function _getQueueByKey(key) {
            _queue = _queue || {};
            if (ts_utils_isNullOrUndefined(_queue[key])) {
                _queue[key] = [];
            }
            return _queue[key];
        }
    }
    return ThrottleMgr;
}());

//# sourceMappingURL=ThrottleMgr.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-es5/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var InternalConstants_UNDEFINED_VALUE = (/* unused pure expression or super */ null && (undefined));
var InternalConstants_STR_DURATION = "duration";
var STR_PROPERTIES = "properties";
//# sourceMappingURL=InternalConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_REQUEST_URL = "requestUrl"; // Count: 10
var applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH = "length"; // Count: 9
var _DYN_ABORTED = "aborted"; // Count: 5
var applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID = "traceId"; // Count: 11
var dist_es5_DynamicConstants_DYN_SPAN_ID = "spanId"; // Count: 10
var dist_es5_DynamicConstants_DYN_TRACE_FLAGS = "traceFlags"; // Count: 7
var _DynamicConstants_DYN_TRACE_STATE = "traceState"; // Count: 3
var _DYN_CONTEXT = "context"; // Count: 4
var _DynamicConstants_DYN_ADD_HOOK = "_addHook"; // Count: 4
var _DynamicConstants_DYN_CORE = "core"; // Count: 7
var _DYN_INCLUDE_CORRELATION_0 = "includeCorrelationHeaders"; // Count: 4
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 4
var _DynamicConstants_DYN_HEADERS = "headers"; // Count: 7
var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 15
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 4
var _DYN_TRACK_DEPENDENCY_DAT1 = "trackDependencyDataInternal"; // Count: 2
var dist_es5_DynamicConstants_DYN_START_TIME = "startTime"; // Count: 5
var dist_es5_DynamicConstants_DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_ENABLE_REQUEST_HEADE2 = "enableRequestHeaderTracking"; // Count: 3
var _DYN_ENABLE_AJAX_ERROR_ST3 = "enableAjaxErrorStatusText"; // Count: 2
var _DYN_ENABLE_AJAX_PERF_TRA4 = "enableAjaxPerfTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V5 = "maxAjaxCallsPerView"; // Count: 2
var _DYN_EXCLUDE_REQUEST_FROM6 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var _DYN_DISABLE_AJAX_TRACKIN7 = "disableAjaxTracking"; // Count: 3
var _DYN_AJAX_PERF_LOOKUP_DEL8 = "ajaxPerfLookupDelay"; // Count: 2
var _DYN_DISABLE_FETCH_TRACKI9 = "disableFetchTracking"; // Count: 2
var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking"; // Count: 2
var _DynamicConstants_DYN_STATUS = "status"; // Count: 10
var _DYN_STATUS_TEXT = "statusText"; // Count: 7
var _DYN_HEADER_MAP = "headerMap"; // Count: 5
var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
var _DYN_METHOD = "method"; // Count: 7
var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
var _DYN_STATE_CHANGE_ATTACHE11 = "stateChangeAttached"; // Count: 2
var _DYN_RESPONSE_TEXT = "responseText"; // Count: 7
var _DYN_RESPONSE_FINISHED_TI12 = "responseFinishedTime"; // Count: 7
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
var _DYN_GET_ALL_RESPONSE_HEA13 = "getAllResponseHeaders"; // Count: 2
var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
var _DYN_AJAX_DIAGNOSTICS_MES14 = "ajaxDiagnosticsMessage"; // Count: 3
var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-es5/ajaxRecord.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) {
        result = dateTimeUtilsDuration(from, to);
    }
    return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = _calcPerfDuration(resourceEntry, start, end);
    if (value) {
        result = _setPerfValue(props, name, msToTimeSpan(value));
    }
    return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = (props[strPerf] || {});
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */
    var resourceEntry = ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */];
    var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[InternalConstants_STR_DURATION /* @min:%2eduration */];
        if (!duration) {
            duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        }
        propsSet |= _setPerfValue(props, InternalConstants_STR_DURATION, duration);
        propsSet |= _setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            ts_utils_arrForEach(serverTiming, function (value, idx) {
                var name = HelperFuncs_normalizeJsName(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                ts_utils_objForEachKey(value, function (key, val) {
                    if (key !== strName && ts_utils_isString(val) || ts_utils_isNumber(val)) {
                        if (newValue[key]) {
                            val = newValue[key] + ";" + val;
                        }
                        if (val || !ts_utils_isString(val)) {
                            // Only set the value if it has a value and it's not an empty string
                            newValue[key] = val;
                        }
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= _setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    }
    else {
        if (ajaxData.perfMark) {
            propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
        }
    }
    if (propsSet) {
        dependency[STR_PROPERTIES /* @min:%2eproperties */] = props;
    }
}
/**
 * Factory function to create an XHR monitoring state object
 * @returns An object implementing IXHRMonitoringState interface
 */
function createXHRMonitoringState() {
    var _a;
    return _a = {
            openDone: false,
            setRequestHeaderDone: false,
            sendDone: false,
            abortDone: false
        },
        _a[_DYN_STATE_CHANGE_ATTACHE11 /* @min:stateChangeAttached */] = false,
        _a;
}
/**
 * Factory function to create an ajax record that implements IAjaxRecordInternal
 * @param traceCtx - The distributed trace context for the ajax request
 * @param logger - The diagnostic logger instance
 * @returns An object implementing IAjaxRecordInternal interface
 */
function createAjaxRecord(traceCtx, logger) {
    var _a;
    var _logger = logger;
    // Create the ajax record object implementing IAjaxRecordInternal
    var ajaxRecord = (_a = {
            // Initialize all properties with default values
            perfMark: null,
            completed: false,
            requestHeadersSize: null
        },
        _a[_DYN_REQUEST_HEADERS /* @min:requestHeaders */] = null,
        _a.responseReceivingDuration = null,
        _a.callbackDuration = null,
        _a[_DYN_AJAX_TOTAL_DURATION /* @min:ajaxTotalDuration */] = null,
        _a.aborted = 0,
        _a.pageUrl = null,
        _a.requestUrl = null,
        _a.requestSize = 0,
        _a.method = null,
        _a.status = null,
        _a[_DYN_REQUEST_SENT_TIME /* @min:requestSentTime */] = null,
        _a.responseStartedTime = null,
        _a[_DYN_RESPONSE_FINISHED_TI12 /* @min:responseFinishedTime */] = null,
        _a.callbackFinishedTime = null,
        _a.endTime = null,
        _a.xhrMonitoringState = createXHRMonitoringState(),
        _a.clientFailure = 0,
        _a.traceCtx = traceCtx,
        _a.perfTiming = null,
        _a[_DYN_GET_ABSOLUTE_URL /* @min:getAbsoluteUrl */] = function () {
            return ajaxRecord[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? urlGetAbsoluteUrl(ajaxRecord[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) : null;
        },
        _a.getPathName = function () {
            return ajaxRecord[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(ajaxRecord[_DYN_METHOD /* @min:%2emethod */], ajaxRecord[_DYN_REQUEST_URL /* @min:%2erequestUrl */])) : null;
        },
        _a[_DYN__CREATE_TRACK_ITEM /* @min:CreateTrackItem */] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
            var _a;
            // round to 3 decimal points
            ajaxRecord.ajaxTotalDuration = mathRound(dateTimeUtilsDuration(ajaxRecord.requestSentTime, ajaxRecord.responseFinishedTime) * 1000) / 1000;
            if (ajaxRecord[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] < 0) {
                return null;
            }
            var dependency = (_a = {
                    // Always use the traceId and spanId from the traceCtx, this is the same as the
                    // traceId and spanId used to create the ajaxRecord, this is to ensure that
                    // the traceId and spanId are always the same for the ajaxRecord and the dependency
                    // This is important for the distributed tracing to work correctly
                    id: "|" + traceCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] + "." + traceCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */],
                    target: ajaxRecord[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](),
                    name: ajaxRecord.getPathName(),
                    type: ajaxType,
                    startTime: null,
                    duration: ajaxRecord[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */],
                    success: (+(ajaxRecord[_DynamicConstants_DYN_STATUS /* @min:%2estatus */])) >= 200 && (+(ajaxRecord[_DynamicConstants_DYN_STATUS /* @min:%2estatus */])) < 400,
                    responseCode: (+(ajaxRecord[_DynamicConstants_DYN_STATUS /* @min:%2estatus */]))
                },
                _a[STR_PROPERTIES] = { HttpMethod: ajaxRecord[_DYN_METHOD /* @min:%2emethod */] },
                _a);
            var props = dependency[STR_PROPERTIES];
            if (ajaxRecord[_DYN_ABORTED /* @min:%2eaborted */]) {
                props[_DYN_ABORTED /* @min:%2eaborted */] = true;
            }
            if (ajaxRecord[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]) {
                // Set the correct dependency start time
                dependency[dist_es5_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                dependency[dist_es5_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */].setTime(ajaxRecord[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]);
            }
            // Add Ajax perf details if available
            _populatePerfData(this, dependency);
            if (enableRequestHeaderTracking) {
                if (objKeys(ajaxRecord.requestHeaders)[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                    props[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = ajaxRecord[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */];
                }
            }
            if (getResponse) {
                var response = getResponse();
                if (response) {
                    // enrich dependency target with correlation context from the server
                    var correlationContext = response[_DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */];
                    if (correlationContext) {
                        dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                    }
                    if (response[_DYN_HEADER_MAP /* @min:%2eheaderMap */]) {
                        if (objKeys(response.headerMap)[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                            props.responseHeaders = response[_DYN_HEADER_MAP /* @min:%2eheaderMap */];
                        }
                    }
                    if (ajaxRecord[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */]) {
                        if ((+(ajaxRecord[_DynamicConstants_DYN_STATUS /* @min:%2estatus */])) >= 400) {
                            var responseType = response.type;
                            if (responseType === "" || responseType === "text") {
                                props.responseText = response.responseText ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + response[_DYN_RESPONSE_TEXT /* @min:%2eresponseText */] : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                            }
                            if (responseType === "json") {
                                props.responseText = response.response ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + JSON.stringify(response.response) : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                            }
                        }
                        else if (ajaxRecord[_DynamicConstants_DYN_STATUS /* @min:%2estatus */] === 0) {
                            props.responseText = response[_DYN_STATUS_TEXT /* @min:%2estatusText */] || "";
                        }
                    }
                }
            }
            return dependency;
        },
        _a.getPartAProps = function () {
            var partA = null;
            var parentCtx = ajaxRecord.traceCtx.parentCtx;
            if (parentCtx && (parentCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] || parentCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */])) {
                partA = {};
                var traceExt = partA[Extensions.TraceExt] = {
                    traceID: parentCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */],
                    parentID: parentCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */]
                };
                if (!ts_utils_isNullOrUndefined(parentCtx[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */])) {
                    traceExt[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = parentCtx[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                }
            }
            return partA;
        },
        _a);
    return ajaxRecord;
}
//# sourceMappingURL=ajaxRecord.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-dependencies-js/dist-es5/ajax.js
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var ajax_a;







// const AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var AJAX_DATA_CONTAINER = "_ajaxData";
var STR_FETCH = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var _markCount = 0;
/** @Ignore */
function _supportsFetch() {
    var _global = getGlobal();
    if (!_global ||
        ts_utils_isNullOrUndefined(_global.Request) ||
        ts_utils_isNullOrUndefined(_global.Request[Constants_strShimPrototype]) ||
        ts_utils_isNullOrUndefined(_global[STR_FETCH])) {
        return null;
    }
    return _global[STR_FETCH];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */
function _supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a;
    var result = false;
    if (isXhrSupported()) {
        var proto = XMLHttpRequest[Constants_strShimPrototype];
        result = !ts_utils_isNullOrUndefined(proto) &&
            !ts_utils_isNullOrUndefined(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
            !ts_utils_isNullOrUndefined(proto.send) &&
            !ts_utils_isNullOrUndefined(proto.abort);
    }
    var ieVer = getIEVersion();
    if (ieVer && ieVer < 9) {
        result = false;
    }
    if (result) {
        // Disable if the XmlHttpRequest can't be extended or hooked
        try {
            var xhr = new XMLHttpRequest();
            var xhrData = {
                xh: [],
                i: (_a = {},
                    _a[ajaxDataId] = {},
                    _a)
            };
            xhr[AJAX_DATA_CONTAINER] = xhrData;
            // Check that we can update the prototype
            var theOpen = XMLHttpRequest[Constants_strShimPrototype].open;
            XMLHttpRequest[Constants_strShimPrototype].open = theOpen;
        }
        catch (e) {
            // We can't decorate the xhr object so disable monitoring
            result = false;
            _throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
                exception: ts_utils_dumpObj(e)
            });
        }
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */
var _getAjaxData = function (xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[AJAX_DATA_CONTAINER]) {
        return (xhr[AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    }
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */
var _addSharedXhrHeaders = function (xhr, name, value) {
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            headers.push({
                n: name,
                v: value
            });
        }
    }
};
var _isHeaderSet = function (xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            ts_utils_arrForEach(headers, function (header) {
                if (header.n === name) {
                    isPresent = true;
                    return -1;
                }
            });
        }
    }
    return isPresent;
};
/** @Ignore */
function _getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = _getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) {
            result += "(url: '" + ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] + "')";
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    _throwInternal(ajaxMonitorInstance[strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */, msgId, message, properties, isUserAct);
}
/** @ignore */
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    _throwInternal(ajaxMonitorInstance[strDiagLog](), 2 /* eLoggingSeverity.WARNING */, msgId, message, properties, isUserAct);
}
/** @Ignore */
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function (callDetails) {
        var _a;
        _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a = {},
            _a[_DYN_AJAX_DIAGNOSTICS_MES14 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(callDetails.inst, ajaxMonitorInstance._ajaxDataId),
            _a.exception = ts_utils_dumpObj(callDetails.err),
            _a));
    };
}
function ajax_indexOf(value, match) {
    if (value && match) {
        return ts_utils_strIndexOf(value, match);
    }
    return -1;
}
function _addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function () {
            ts_utils_arrForEach(container, function (initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function _processDependencyContainer(core, container, details, message) {
    var result = true;
    ts_utils_arrForEach(container, function (theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) {
                result = false;
            }
        }
        catch (e) {
            _throwInternal(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), { exception: ts_utils_dumpObj(e) }, true);
        }
    });
    return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var initializersCount = listeners[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
    var result = true;
    if (initializersCount > 0) {
        var traceCtx_1 = ajaxData.traceCtx;
        var details = {
            core: core,
            xhr: xhr,
            input: input,
            init: init,
            aborted: !!ajaxData[_DYN_ABORTED /* @min:%2eaborted */]
        };
        objDefineProps(details, {
            "traceId": {
                g: function () { return traceCtx_1[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */]; },
                s: function (value) {
                    traceCtx_1[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] = value;
                }
            },
            "spanId": {
                g: function () { return traceCtx_1[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */]; },
                s: function (value) {
                    traceCtx_1[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = value;
                }
            },
            "traceFlags": {
                g: function () { return traceCtx_1[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]; },
                s: function (value) {
                    traceCtx_1[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = value;
                }
            },
            "traceState": {
                g: function () { return traceCtx_1[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */]; }
            },
            "context": {
                g: function () { return ajaxData[_DYN_CONTEXT /* @min:%2econtext */] || {}; },
                s: function (value) {
                    ajaxData[_DYN_CONTEXT /* @min:%2econtext */] = value;
                }
            }
        });
        result = _processDependencyContainer(core, listeners, details, "listener");
    }
    return result;
}
var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = objFreeze([
    BLOB_CORE + "windows.net",
    BLOB_CORE + "chinacloudapi.cn",
    BLOB_CORE + "cloudapi.de",
    BLOB_CORE + "usgovcloudapi.net"
]);
var _internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var ajax_defaultConfig = objFreeze((ajax_a = {},
    ajax_a[_DYN_MAX_AJAX_CALLS_PER_V5 /* @min:maxAjaxCallsPerView */] = 500,
    ajax_a[_DYN_DISABLE_AJAX_TRACKIN7 /* @min:disableAjaxTracking */] = false,
    ajax_a[_DYN_DISABLE_FETCH_TRACKI9 /* @min:disableFetchTracking */] = false,
    ajax_a[_DYN_EXCLUDE_REQUEST_FROM6 /* @min:excludeRequestFromAutoTrackingPatterns */] = undefined,
    ajax_a.disableCorrelationHeaders = false,
    ajax_a.distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */,
    ajax_a.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains,
    ajax_a.correlationHeaderDomains = undefined,
    ajax_a.correlationHeaderExcludePatterns = undefined,
    ajax_a.appId = undefined,
    ajax_a.enableCorsCorrelation = false,
    ajax_a[_DYN_ENABLE_REQUEST_HEADE2 /* @min:enableRequestHeaderTracking */] = false,
    ajax_a[_DYN_ENABLE_RESPONSE_HEAD10 /* @min:enableResponseHeaderTracking */] = false,
    ajax_a[_DYN_ENABLE_AJAX_ERROR_ST3 /* @min:enableAjaxErrorStatusText */] = false,
    ajax_a[_DYN_ENABLE_AJAX_PERF_TRA4 /* @min:enableAjaxPerfTracking */] = false,
    ajax_a.maxAjaxPerfLookupAttempts = 3,
    ajax_a[_DYN_AJAX_PERF_LOOKUP_DEL8 /* @min:ajaxPerfLookupDelay */] = 25,
    ajax_a.ignoreHeaders = [
        "Authorization",
        "X-API-Key",
        "WWW-Authenticate"
    ],
    ajax_a.addRequestContext = undefined,
    ajax_a.addIntEndpoints = true,
    ajax_a));
var AjaxMonitor = /** @class */ (function (_super) {
    __extendsFn(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _extensionConfig;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _isUsingW3CTraceState;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        var _ignoreHeaders;
        var _maxAjaxPerfLookupAttempts;
        var _ajaxPerfLookupDelay;
        var _distributedTracingMode;
        var _appId;
        var _polyfillInitialized;
        dynamicProto(AjaxMonitor, _this, function (_self, _base) {
            var _addHook = _base[_DynamicConstants_DYN_ADD_HOOK /* @min:%2e_addHook */];
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = mergeEvtNamespace(DataCacheHelper_createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function () {
                _initDefaults();
            };
            _self.trackDependencyData = function (dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], null, dependency, properties);
            };
            _self.resetAjaxAttempts = function () {
                _trackAjaxAttempts = 0;
            };
            _self[_DYN_INCLUDE_CORRELATION_0 /* @min:%2eincludeCorrelationHeaders */] = function (ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                if (_processDependencyListeners(_dependencyListeners, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], ajaxData, xhr, input, init)) {
                    if (input || input === "") { // Fetch
                        if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                            if (!init) {
                                init = {};
                            }
                            var traceCtx = ajaxData.traceCtx;
                            // init headers override original request headers
                            // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                            // not using original request headers will result in them being lost
                            var headers_1 = new Headers(init[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */] || (input instanceof Request ? (input[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */] || {}) : {}));
                            if (_isUsingAIHeaders) {
                                var id = "|" + traceCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] + "." + traceCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
                                headers_1.set(RequestHeaders[3], id);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3]] = id;
                                }
                            }
                            var appId = _appId || (_context && _context.appId());
                            if (appId) {
                                headers_1.set(RequestHeaders[0], RequestHeaders[2] + appId);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0]] = RequestHeaders[2] + appId;
                                }
                            }
                            if (_isUsingW3CHeaders) {
                                var traceFlags = traceCtx[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                                if (ts_utils_isNullOrUndefined(traceFlags)) {
                                    traceFlags = 1 /* eW3CTraceFlags.Sampled */; // Default to sampled
                                }
                                var traceParent = formatTraceParent(createTraceParent(traceCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */], traceCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */], traceFlags));
                                headers_1.set(RequestHeaders[4], traceParent);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4]] = traceParent;
                                }
                            }
                            if (_isUsingW3CTraceState) {
                                if (traceCtx[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */] && !traceCtx[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */].isEmpty) {
                                    var traceStateHeaders = traceCtx[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */].hdrs();
                                    if (traceStateHeaders && traceStateHeaders[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                                        var stateSet_1 = false;
                                        ts_utils_arrForEach(traceStateHeaders, function (stateValue) {
                                            if (stateValue) {
                                                if (!stateSet_1) {
                                                    stateSet_1 = true;
                                                    headers_1.set(RequestHeaders[5], stateValue);
                                                }
                                                else {
                                                    headers_1.append(RequestHeaders[5], stateValue);
                                                }
                                            }
                                        });
                                    }
                                    if (_enableRequestHeaderTracking) {
                                        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[5]] = traceStateHeaders.join(",");
                                    }
                                }
                            }
                            init[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */] = headers_1;
                        }
                    }
                    else if (xhr) { // XHR
                        if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                            var traceCtx = ajaxData.traceCtx;
                            if (_isUsingAIHeaders) {
                                if (!_isHeaderSet(xhr, RequestHeaders[3])) {
                                    var id = "|" + traceCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] + "." + traceCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
                                    xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[3], id);
                                    if (_enableRequestHeaderTracking) {
                                        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[3]] = id;
                                    }
                                }
                                else {
                                    _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[3] + "] as it has already been set by another instance");
                                }
                            }
                            var appId = _appId || (_context && _context.appId());
                            if (appId) {
                                if (!_isHeaderSet(xhr, RequestHeaders[0])) {
                                    xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[0], RequestHeaders[2] + appId);
                                    if (_enableRequestHeaderTracking) {
                                        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[0]] = RequestHeaders[2] + appId;
                                    }
                                }
                                else {
                                    _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[0] + "] as it has already been set by another instance");
                                }
                            }
                            if (_isUsingW3CHeaders) {
                                var traceFlags = traceCtx[dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                                if (ts_utils_isNullOrUndefined(traceFlags)) {
                                    traceFlags = 1 /* eW3CTraceFlags.Sampled */;
                                }
                                if (!_isHeaderSet(xhr, RequestHeaders[4])) {
                                    var traceParent = formatTraceParent(createTraceParent(traceCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */], traceCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */], traceFlags));
                                    xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[4], traceParent);
                                    if (_enableRequestHeaderTracking) {
                                        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[4]] = traceParent;
                                    }
                                }
                                else {
                                    _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + RequestHeaders[4] + "] as it has already been set by another instance");
                                }
                            }
                            if (_isUsingW3CTraceState) {
                                if (traceCtx[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */] && !traceCtx[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */].isEmpty) {
                                    var traceStateHeaders = traceCtx[_DynamicConstants_DYN_TRACE_STATE /* @min:%2etraceState */].hdrs();
                                    if (traceStateHeaders && traceStateHeaders[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] > 0) {
                                        ts_utils_arrForEach(traceStateHeaders, function (stateValue) {
                                            if (stateValue) {
                                                xhr[_DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */](RequestHeaders[5], stateValue);
                                            }
                                        });
                                    }
                                    if (_enableRequestHeaderTracking) {
                                        ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][RequestHeaders[5]] = traceStateHeaders.join(",");
                                    }
                                }
                            }
                        }
                    }
                }
                return xhr || init;
            };
            _self[_DYN_TRACK_DEPENDENCY_DAT1 /* @min:%2etrackDependencyDataInternal */] = function (dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_distributedTracingMode === 2 /* eDistributedTracingModes.W3C */
                        || _distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */)
                        && typeof dependency.id === "string" && dependency.id[dependency.id[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1] !== ".") {
                        dependency.id += ".";
                    }
                    if (ts_utils_isNullOrUndefined(dependency[dist_es5_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */])) {
                        dependency[dist_es5_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                    }
                    var item = createTelemetryItem(dependency, RemoteDependencyDataType, RemoteDependencyEnvelopeType, _self[strDiagLog](), properties, systemProperties);
                    _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].track(item);
                }
                else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
                    _throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                }
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function (dependencyListener) {
                return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function (dependencyInitializer) {
                return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = getLocation();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _polyfillInitialized = false; // polyfill monitoring initialized
                _currentWindowHost = location && location.host && location.host[dist_es5_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                _extensionConfig = null;
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingW3CTraceState = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = DataCacheHelper_createUniqueNamespace("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
                _ignoreHeaders = null;
                _maxAjaxPerfLookupAttempts = 1;
                _ajaxPerfLookupDelay = 1;
                _distributedTracingMode = 1 /* eDistributedTracingModes.AI_AND_W3C */;
                _appId = null;
            }
            function _populateDefaults(config) {
                _self[_DynamicConstants_DYN_ADD_HOOK /* @min:%2e_addHook */](onConfigChange(config, function (details) {
                    var config = details.cfg;
                    var ctx = createProcessTelemetryContext(null, config, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */]);
                    _extensionConfig = ctx.getExtCfg(AjaxMonitor.identifier, ajax_defaultConfig);
                    _distributedTracingMode = _extensionConfig.distributedTracingMode;
                    _enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE2 /* @min:%2eenableRequestHeaderTracking */];
                    _enableAjaxErrorStatusText = _extensionConfig[_DYN_ENABLE_AJAX_ERROR_ST3 /* @min:%2eenableAjaxErrorStatusText */];
                    _enableAjaxPerfTracking = _extensionConfig[_DYN_ENABLE_AJAX_PERF_TRA4 /* @min:%2eenableAjaxPerfTracking */];
                    _maxAjaxCallsPerView = _extensionConfig[_DYN_MAX_AJAX_CALLS_PER_V5 /* @min:%2emaxAjaxCallsPerView */];
                    _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[_DYN_EXCLUDE_REQUEST_FROM6 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */] || [], _extensionConfig.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
                    _addRequestContext = _extensionConfig.addRequestContext;
                    var baseDistributedTracingMode = _distributedTracingMode & 15 /* eDistributedTracingModes._BaseMask */;
                    _isUsingAIHeaders = baseDistributedTracingMode === 0 /* eDistributedTracingModes.AI */ || baseDistributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */;
                    _isUsingW3CHeaders = baseDistributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ || baseDistributedTracingMode === 2 /* eDistributedTracingModes.W3C */;
                    _isUsingW3CTraceState = !!(_distributedTracingMode & 16 /* eDistributedTracingModes._W3CTraceState */);
                    if (_enableAjaxPerfTracking) {
                        _markPrefix = _ajaxDataId;
                    }
                    _disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN7 /* @min:%2edisableAjaxTracking */];
                    _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
                    _ajaxPerfLookupDelay = _extensionConfig[_DYN_AJAX_PERF_LOOKUP_DEL8 /* @min:%2eajaxPerfLookupDelay */];
                    _ignoreHeaders = _extensionConfig.ignoreHeaders;
                    _appId = _extensionConfig.appId;
                }));
            }
            function _populateContext() {
                var propExt = _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
                if (propExt) {
                    _context = propExt.plugin[_DYN_CONTEXT /* @min:%2econtext */]; // we could move IPropertiesPlugin to common as well
                }
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _ignoreHeaders) {
                    ts_utils_arrForEach(_ignoreHeaders, (function (key) {
                        if (key[dist_es5_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]() === header[dist_es5_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]()) {
                            rlt = false;
                            return -1;
                        }
                    }));
                }
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = _supportsFetch();
                if (!fetch) {
                    return;
                }
                var global = getGlobal();
                var isPolyfill = fetch.polyfill;
                _self[_DynamicConstants_DYN_ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extensionConfig, function () {
                    _disableFetchTracking = !!_extensionConfig[_DYN_DISABLE_FETCH_TRACKI9 /* @min:%2edisableFetchTracking */];
                    _enableResponseHeaderTracking = _extensionConfig[_DYN_ENABLE_RESPONSE_HEAD10 /* @min:%2eenableResponseHeaderTracking */];
                    if (!_disableFetchTracking && !_fetchInitialized) {
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            // Add request hook
                            req: function (callDetails, input, init) {
                                var fetchData;
                                if (!_disableFetchTracking && _fetchInitialized &&
                                    !_isDisabledRequest(null, input, init) &&
                                    // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                    !(isPolyfill && _xhrInitialized)) {
                                    var ctx = callDetails.ctx();
                                    fetchData = _createFetchRecord(input, init);
                                    var newInit = _self[_DYN_INCLUDE_CORRELATION_0 /* @min:%2eincludeCorrelationHeaders */](fetchData, input, init);
                                    if (newInit !== init) {
                                        callDetails.set(1, newInit);
                                    }
                                    ctx.data = fetchData;
                                }
                            },
                            rsp: function (callDetails, input) {
                                if (!_disableFetchTracking) {
                                    var fetchData_1 = callDetails.ctx().data;
                                    if (fetchData_1) {
                                        // Replace the result with the new promise from this code
                                        callDetails.rslt = callDetails.rslt.then(function (response) {
                                            _reportFetchMetrics(callDetails, (response || {})[_DynamicConstants_DYN_STATUS /* @min:%2estatus */], input, response, fetchData_1, function () {
                                                var _a;
                                                var ajaxResponse = (_a = {
                                                        statusText: (response || {})[_DYN_STATUS_TEXT /* @min:%2estatusText */],
                                                        headerMap: null
                                                    },
                                                    _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getFetchCorrelationContext(response),
                                                    _a);
                                                if (_enableResponseHeaderTracking && response) {
                                                    var responseHeaderMap_1 = {};
                                                    response.headers.forEach(function (value, name) {
                                                        if (_canIncludeHeaders(name)) {
                                                            responseHeaderMap_1[name] = value;
                                                        }
                                                    });
                                                    ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_1;
                                                }
                                                return ajaxResponse;
                                            });
                                            return response;
                                        })
                                            .catch(function (reason) {
                                            _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message || ts_utils_dumpObj(reason) });
                                            throw reason;
                                        });
                                    }
                                }
                            },
                            // Create an error callback to report any hook errors
                            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
                        }, true, isWebWorker()));
                        _fetchInitialized = true;
                    }
                    else if (isPolyfill && !_polyfillInitialized) {
                        // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                        // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                        // of reporting ourselves, for example React Native uses a polyfill for fetch
                        // Note: Polyfill implementations that don't support the "polyfill" tag are not supported
                        // the workaround is to add a polyfill property to your fetch implementation before initializing
                        // App Insights
                        _addHook(InstrumentFunc(global, STR_FETCH, {
                            ns: _evtNamespace,
                            req: function (callDetails, input, init) {
                                // Just call so that we record any disabled URL
                                _isDisabledRequest(null, input, init);
                            }
                        }));
                        _polyfillInitialized = true;
                    }
                }));
                if (isPolyfill) {
                    // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                    // But also supports multiple App Insights usages
                    global[STR_FETCH].polyfill = isPolyfill;
                }
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook(InstrumentProto(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (!_supportsAjaxMonitoring(_self, _ajaxDataId)) {
                    return;
                }
                _self[_DynamicConstants_DYN_ADD_HOOK /* @min:%2e_addHook */](onConfigChange(_extensionConfig, function () {
                    _disableAjaxTracking = !!_extensionConfig[_DYN_DISABLE_AJAX_TRACKIN7 /* @min:%2edisableAjaxTracking */];
                    _enableRequestHeaderTracking = _extensionConfig[_DYN_ENABLE_REQUEST_HEADE2 /* @min:%2eenableRequestHeaderTracking */];
                    if (!_disableAjaxTracking && !_xhrInitialized) {
                        // Instrument open
                        _hookProto(XMLHttpRequest, "open", {
                            ns: _evtNamespace,
                            req: function (callDetails, method, url, async) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                        if (!ajaxData || !ajaxData.xhrMonitoringState.openDone) {
                                            // Only create a single ajaxData (even when multiple AI instances are running)
                                            ajaxData = _openHandler(xhr, method, url, async);
                                        }
                                        // always attach to the on ready state change (required for handling multiple instances)
                                        _attachToOnReadyStateChange(xhr, ajaxData);
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, ERROR_HEADER + ".open" + ERROR_POSTFIX)
                        });
                        // Instrument send
                        _hookProto(XMLHttpRequest, "send", {
                            ns: _evtNamespace,
                            req: function (callDetails, context) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState.sendDone) {
                                        _createMarkId("xhr", ajaxData);
                                        ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                                        _self[_DYN_INCLUDE_CORRELATION_0 /* @min:%2eincludeCorrelationHeaders */](ajaxData, undefined, undefined, xhr);
                                        ajaxData.xhrMonitoringState.sendDone = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */, ERROR_HEADER + ERROR_POSTFIX)
                        });
                        // Instrument abort
                        _hookProto(XMLHttpRequest, "abort", {
                            ns: _evtNamespace,
                            req: function (callDetails) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState.abortDone) {
                                        ajaxData[_DYN_ABORTED /* @min:%2eaborted */] = 1;
                                        ajaxData.xhrMonitoringState.abortDone = true;
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
                        });
                        // Instrument setRequestHeader
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            ns: _evtNamespace,
                            req: function (callDetails, header, value) {
                                if (!_disableAjaxTracking) {
                                    var xhr = callDetails.inst;
                                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                    if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                        _addSharedXhrHeaders(xhr, header, value);
                                        if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                            ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */][header] = value;
                                        }
                                    }
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
                        });
                        _xhrInitialized = true;
                    }
                }));
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!ts_utils_isString(request) ? (request || {}).url || "" : request) || "")[dist_es5_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                ts_utils_arrForEach(_excludeRequestFromAutoTrackingPatterns, function (regex) {
                    var theRegex = regex;
                    if (ts_utils_isString(regex)) {
                        theRegex = new RegExp(regex);
                    }
                    if (!isDisabled) {
                        isDisabled = theRegex.test(theUrl);
                    }
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) {
                    return isDisabled;
                }
                var idx = ajax_indexOf(theUrl, "?");
                var idx2 = ajax_indexOf(theUrl, "#");
                if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
                    idx = idx2;
                }
                if (idx !== -1) {
                    // Strip off any Query string
                    theUrl = theUrl.substring(0, idx);
                }
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!ts_utils_isNullOrUndefined(xhr)) {
                    // Look on the XMLHttpRequest of the URL string value
                    isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
                }
                else if (!ts_utils_isNullOrUndefined(request)) { // fetch
                    // Look for DisabledPropertyName in either Request or RequestInit
                    isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) ||
                        (init ? init[DisabledPropertyName] === true : false);
                }
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
                    isDisabled = true;
                }
                if (isDisabled) {
                    // Add the disabled url if not present
                    if (!_disabledUrls[theUrl]) {
                        _disabledUrls[theUrl] = 1;
                    }
                }
                else {
                    // Check to see if the url is listed as disabled
                    if (_disabledUrls[theUrl]) {
                        isDisabled = true;
                    }
                }
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!ts_utils_isNullOrUndefined(xhr)) {
                    ajaxValidation = excludeAjaxDataValidation === true || !ts_utils_isNullOrUndefined(ajaxData);
                }
                // checking to see that all interested functions on xhr were instrumented
                return initialized
                    // checking on ajaxData to see that it was not removed in user code
                    && ajaxValidation;
            }
            /**
             * Using the ajaxRecord (for now) to capture what will be the "span" state for the ajax request.
             * @returns
             */
            function _startSpan() {
                var distributedTraceCtx = null;
                if (_self[_DynamicConstants_DYN_CORE /* @min:%2ecore */] && _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].getTraceCtx) {
                    // Note creating a new distributed trace context
                    // This is to ensure that we have a original traceId and spanId for each request
                    distributedTraceCtx = createDistributedTraceContext(_self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].getTraceCtx());
                }
                // Fall back if running on an older version of the core
                if (!distributedTraceCtx && _context && _context.telemetryTrace) {
                    distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
                }
                // TODO(OTelSpan): change to call traceCtx.startSpan() when available rather than setting
                // a new spanId and traceId
                var newCtx = createDistributedTraceContext(distributedTraceCtx);
                // Always generate a new spanId for each dependency request to ensure proper span isolation
                newCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] = newCtx[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */] || generateW3CId();
                newCtx[dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] = strSubstr(generateW3CId(), 0, 16);
                return createAjaxRecord(newCtx, _self[strDiagLog]());
            }
            function _endSpan(ajaxData, dependency, properties) {
                // TODO(OTelSpan): change to call span.end() when available
                if (dependency) {
                    if (properties !== undefined) {
                        dependency[STR_PROPERTIES /* @min:%2eproperties */] = __assignFn(__assignFn({}, dependency.properties), properties);
                    }
                    var sysProperties = ajaxData.getPartAProps();
                    _reportDependencyInternal(_dependencyInitializers, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */], ajaxData, dependency, properties, sysProperties);
                }
            }
            function _openHandler(xhr, method, url, async) {
                var xhrRequestData = xhr[AJAX_DATA_CONTAINER] = (xhr[AJAX_DATA_CONTAINER] || { xh: [], i: {} });
                var ajaxDataCntr = xhrRequestData.i = (xhrRequestData.i || {});
                var ajaxData = ajaxDataCntr[_ajaxDataId] = (ajaxDataCntr[_ajaxDataId] || _startSpan());
                ajaxData[_DYN_METHOD /* @min:%2emethod */] = method;
                ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = url;
                ajaxData.xhrMonitoringState.openDone = true;
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = {};
                ajaxData.async = async;
                ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[_DYN_STATE_CHANGE_ATTACHE11 /* @min:%2estateChangeAttached */] = eventOn(xhr, "readystatechange", function () {
                    var _a;
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) {
                            _onAjaxComplete(xhr);
                        }
                    }
                    catch (e) {
                        var exceptionText = ts_utils_dumpObj(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || ajax_indexOf(exceptionText[dist_es5_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), "c00c023f") === -1) {
                            _throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a = {},
                                _a[_DYN_AJAX_DIAGNOSTICS_MES14 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                                _a.exception = exceptionText,
                                _a));
                        }
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") {
                        // As per the specification responseText is only valid if the type is an empty string or "text"
                        return xhr[_DYN_RESPONSE_TEXT /* @min:%2eresponseText */];
                    }
                }
                catch (e) {
                    // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                ajaxData[_DYN_RESPONSE_FINISHED_TI12 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
                ajaxData[_DynamicConstants_DYN_STATUS /* @min:%2estatus */] = xhr[_DynamicConstants_DYN_STATUS /* @min:%2estatus */];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) {
                        errorProps["exception"] = ts_utils_dumpObj(e);
                    }
                    _throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
                    try {
                        var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Ajax", _enableRequestHeaderTracking, function () {
                            var _a;
                            var ajaxResponse = (_a = {
                                    statusText: xhr[_DYN_STATUS_TEXT /* @min:%2estatusText */],
                                    headerMap: null
                                },
                                _a[_DYN_CORRELATION_CONTEXT /* @min:correlationContext */] = _getAjaxCorrelationContext(xhr),
                                _a.type = xhr.responseType,
                                _a[_DYN_RESPONSE_TEXT /* @min:responseText */] = _getResponseText(xhr),
                                _a.response = xhr.response,
                                _a);
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[_DYN_GET_ALL_RESPONSE_HEA13 /* @min:%2egetAllResponseHeaders */]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = strTrim(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    ts_utils_arrForEach(arr, function (line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) {
                                            responseHeaderMap_2[header] = value;
                                        }
                                    });
                                    ajaxResponse[_DYN_HEADER_MAP /* @min:%2eheaderMap */] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) {
                                properties = _addRequestContext({ status: xhr[_DynamicConstants_DYN_STATUS /* @min:%2estatus */], xhr: xhr });
                            }
                        }
                        catch (e) {
                            _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (!dependency) {
                            _reportXhrError(null, {
                                requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                                responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI12 /* @min:%2eresponseFinishedTime */]
                            });
                        }
                        _endSpan(ajaxData, dependency, properties);
                    }
                    finally {
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = (xhr[AJAX_DATA_CONTAINER] || { i: {} });
                            var ajaxDataCntr = (xhrRequestData.i || {});
                            if (ajaxDataCntr[_ajaxDataId]) {
                                ajaxDataCntr[_ajaxDataId] = null;
                            }
                        }
                        catch (e) {
                            // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function (e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                var _a;
                try {
                    var responseHeadersString = xhr[_DYN_GET_ALL_RESPONSE_HEA13 /* @min:%2egetAllResponseHeaders */]();
                    if (responseHeadersString !== null) {
                        var index = ajax_indexOf(responseHeadersString[dist_es5_DynamicConstants_DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */](), RequestHeaders[8]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader(RequestHeaders[0]);
                            return correlationIdGetCorrelationContext(responseHeader);
                        }
                    }
                }
                catch (e) {
                    _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, (_a = {},
                        _a[_DYN_AJAX_DIAGNOSTICS_MES14 /* @min:ajaxDiagnosticsMessage */] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                        _a.exception = ts_utils_dumpObj(e),
                        _a));
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = getPerformance();
                    if (performance_1 && ts_utils_isFunction(performance_1.mark)) {
                        _markCount++;
                        var markId = _markPrefix + type + "#" + _markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] === 1) {
                            ajaxData.perfMark = entries[0];
                        }
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData.perfMark;
                var performance = getPerformance();
                var maxAttempts = _maxAjaxPerfLookupAttempts;
                var retryDelay = _ajaxPerfLookupDelay;
                var requestUrl = ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for (var lp = entries[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */] - 1; lp >= 0; lp--) {
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType &&
                                            (ajax_indexOf(entry.name, requestUrl) !== -1 || ajax_indexOf(requestUrl, entry.name) !== -1)) {
                                            perfTiming = entry;
                                        }
                                    }
                                    else if (entry.entryType === "mark" && entry.name === perfMark.name) {
                                        // We hit the start event
                                        ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] = perfTiming;
                                        break;
                                    }
                                    if (entry[dist_es5_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] < perfMark[dist_es5_DynamicConstants_DYN_START_TIME /* @min:%2estartTime */] - 1000) {
                                        // Fallback to try and reduce the time spent looking for the perf entry
                                        break;
                                    }
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                            ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */] || // - we have not found the perf entry or
                            attempt >= maxAttempts || // - we have tried too many attempts or
                            ajaxData.async === false) { // - this is a sync request
                            if (perfMark && ts_utils_isFunction(performance.clearMarks)) {
                                // Remove the mark so we don't fill up the performance resources too much
                                performance.clearMarks(perfMark.name);
                            }
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        }
                        else {
                            // We need to wait for the browser to populate the window.performance entry
                            // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                            // this is a scheduling issue for the browser implementation
                            ts_utils_scheduleTimeout(locateResourceTiming, retryDelay);
                        }
                    }
                    catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var ajaxData = _startSpan();
                ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = dateTimeUtilsNow();
                ajaxData[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                var requestUrl;
                if (input instanceof Request) {
                    requestUrl = (input || {}).url || "";
                }
                else {
                    requestUrl = input;
                }
                if (requestUrl === "") {
                    var location_1 = getLocation();
                    if (location_1 && location_1.href) {
                        requestUrl = strSplit(location_1.href, "#")[0];
                    }
                }
                if (_self[_DynamicConstants_DYN_CORE /* @min:%2ecore */] && _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].config) {
                    requestUrl = fieldRedaction(requestUrl, _self[_DynamicConstants_DYN_CORE /* @min:%2ecore */].config);
                }
                ajaxData[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = requestUrl;
                var method = "GET";
                if (init && init[_DYN_METHOD /* @min:%2emethod */]) {
                    method = init[_DYN_METHOD /* @min:%2emethod */];
                }
                else if (input && input instanceof Request) {
                    method = input[_DYN_METHOD /* @min:%2emethod */];
                }
                ajaxData[_DYN_METHOD /* @min:%2emethod */] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */] : 0) || (input instanceof Request ? (input[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */] || {}) : {}));
                    headers.forEach(function (value, key) {
                        if (_canIncludeHeaders(key)) {
                            requestHeaders[key] = value;
                        }
                    });
                }
                ajaxData[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = requestHeaders;
                _createMarkId(STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!ts_utils_isNullOrUndefined(input)) {
                        if (typeof (input) === "string") {
                            result += "(url: '".concat(input, "')");
                        }
                        else {
                            result += "(url: '".concat(input.url, "')");
                        }
                    }
                }
                catch (e) {
                    _throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to grab failed fetch diagnostics message", { exception: ts_utils_dumpObj(e) });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) {
                    return;
                }
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) {
                        errorProps["exception"] = ts_utils_dumpObj(e);
                    }
                    _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
                }
                ajaxData[_DYN_RESPONSE_FINISHED_TI12 /* @min:%2eresponseFinishedTime */] = dateTimeUtilsNow();
                ajaxData[_DynamicConstants_DYN_STATUS /* @min:%2estatus */] = status;
                _findPerfResourceEntry(STR_FETCH, ajaxData, function () {
                    var dependency = ajaxData[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) {
                            properties = _addRequestContext({ status: status, request: input, response: response });
                        }
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (!dependency) {
                        _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */, null, {
                            requestSentTime: ajaxData[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */],
                            responseFinishedTime: ajaxData[_DYN_RESPONSE_FINISHED_TI12 /* @min:%2eresponseFinishedTime */]
                        });
                    }
                    _endSpan(ajaxData, dependency, properties);
                }, function (e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                if (response && response[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */]) {
                    try {
                        var responseHeader = response[_DynamicConstants_DYN_HEADERS /* @min:%2eheaders */].get(RequestHeaders[0]);
                        return correlationIdGetCorrelationContext(responseHeader);
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, {
                            fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                            exception: ts_utils_dumpObj(e)
                        });
                    }
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var result = true;
                var initializersCount = initializers[applicationinsights_dependencies_js_dist_es5_DynamicConstants_DYN_LENGTH /* @min:%2elength */];
                if (initializersCount > 0) {
                    var details = {
                        item: dependency,
                        properties: properties,
                        sysProperties: systemProperties,
                        context: ajaxData ? ajaxData[_DYN_CONTEXT /* @min:%2econtext */] : null,
                        aborted: ajaxData ? !!ajaxData[_DYN_ABORTED /* @min:%2eaborted */] : false
                    };
                    result = _processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) {
                    _self[_DYN_TRACK_DEPENDENCY_DAT1 /* @min:%2etrackDependencyDataInternal */](dependency, properties, systemProperties);
                }
            }
        });
        return _this;
    }
// Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
        this.processNext(item, itemCtx);
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyData.
// Removed Stub for AjaxMonitor.prototype.resetAjaxAttempts.
// Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
// Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AjaxMonitor.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}(BaseTelemetryPlugin));

//# sourceMappingURL=ajax.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/Context/Application.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());

//# sourceMappingURL=Application.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/Context/Device.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());

//# sourceMappingURL=Device.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/Context/Internal.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var Version = '3.4.1';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = onConfigChange((config), function () {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}());

//# sourceMappingURL=Internal.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/Context/Location.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());

//# sourceMappingURL=Location.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SESSION = "session"; // Count: 4
var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 2
var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 6
var _DYN_ACCOUNT_ID = "accountId"; // Count: 6
var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
var _DYN_AUTH_USER_COOKIE_NAM7 = "authUserCookieName"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/Context/Session.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var SESSION_COOKIE_NAME = "ai_session";
var ACQUISITION_SPAN = 86400000; // 24 hours in ms
var RENEWAL_SPAN = 1800000; // 30 minutes in ms
var COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());

var _SessionManager = /** @class */ (function () {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        dynamicProto(_SessionManager, self, function (_self) {
            if (!config) {
                config = {};
            }
            var unloadHook = onConfigChange(config, function (details) {
                _sessionExpirationMs = config.sessionExpirationMs || ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config[_DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */] || config.namePrefix || "";
                _storageNamePrefix = SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */] = new Session();
            _self.update = function () {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = ts_utils_utcNow();
                var isExpired = false;
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                if (!session.id) {
                    isExpired = !_initializeAutomaticSession(session, nowMs);
                }
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                    var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) {
                    // update automaticSession so session state has correct id
                    _renew(nowMs);
                }
                else {
                    // do not update the cookie more often than cookieUpdateInterval
                    if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > COOKIE_UPDATE_INTERVAL) {
                        _setCookie(session, nowMs);
                    }
                }
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */
            _self.backup = function () {
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                _setStorage(session.id, session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */], session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && ts_utils_isFunction(cookieValue.split)) {
                    isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                }
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix);
                    if (storageValue) {
                        isValid = _initializeAutomaticSessionWithData(session, storageValue);
                    }
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens.length >= 2) {
                    try {
                        var acqMs = +tokens[1] || 0;
                        var renewalMs = +tokens[2] || 0;
                        if (isNaN(acqMs) || acqMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session acquisition date is 0" + sessionReset);
                        }
                        else if (isNaN(renewalMs) || renewalMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session renewal date is 0" + sessionReset);
                        }
                        else if (tokens[0]) {
                            // Everything looks valid so set the values
                            session.id = tokens[0];
                            session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = acqMs;
                            session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = renewalMs;
                            isValid = true;
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: ts_utils_dumpObj(e) });
                    }
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config.getNewId || newId;
                _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */].id = getNewId(config.idLength || 22);
                _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */][_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = nowMs;
                _setCookie(_self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!utlCanUseLocalStorage()) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */, "Browser does not support local storage. Session durations will be inaccurate.");
                }
            }
            function _setCookie(session, nowMs) {
                var acq = session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = (acq + _sessionExpirationMs) - nowMs;
                var cookie = [session.id, acq, nowMs];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) {
                    maxAgeSec = acqTimeLeftMs / 1000;
                }
                else {
                    maxAgeSec = renewalPeriodMs / 1000;
                }
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie.join("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                utlSetLocalStorage(_logger, _storageNamePrefix, [guid, acq, renewal].join("|"));
            }
        });
    }
// Removed Stub for _SessionManager.prototype.update.
// Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn=1;

    return _SessionManager;
}());

//# sourceMappingURL=Session.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/Context/User.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






function _validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" ||
        !id ||
        id.match(/,|;|=| |\|/)) {
        return false;
    }
    return true;
}
var User = /** @class */ (function () {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */
        this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */
        this.isUserCookieSet = false;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _storageNamePrefix;
        dynamicProto(User, this, function (_self) {
            // Define _self.config
            ts_utils_objDefine(_self, "config", {
                g: function () { return config; }
            });
            var unloadHook = onConfigChange(config, function () {
                var userCookiePostfix = config.userCookiePostfix || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                    var params = cookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (params.length > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie.join(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config.namePrefix || "") + "ai_session";
                    utlRemoveStorage(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = config[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (authCookieString[0]) {
                        _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authCookieString[0];
                    }
                    if (authCookieString.length > 1 && authCookieString[1]) {
                        _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = authCookieString[1];
                    }
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = (config || {});
                var getNewId = theConfig.getNewId || newId;
                var id = getNewId(theConfig.idLength ? config.idLength : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = HelperFuncs_toISOString(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = true;
                var newCookie = [userId, acqStr];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) { storeInCookie = false; }
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                if (isInvalidInput) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */, "Setting auth user context failed. " +
                        "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authenticatedUserId;
                var authCookie = _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */];
                if (accountId) {
                    _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = accountId;
                    authCookie = [_self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], _self.accountId].join(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                }
                if (storeInCookie) {
                    // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                    // Encoding the cookie to handle unexpected unicode characters.
                    _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */], encodeURI(authCookie));
                }
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */
            _self.clearAuthenticatedUserContext = function () {
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = null;
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = null;
                _cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
            };
            _self.update = function (userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie.join(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                }
            };
        });
    }
// Removed Stub for User.prototype.setAuthenticatedUserContext.
// Removed Stub for User.prototype.clearAuthenticatedUserContext.
// Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}());

//# sourceMappingURL=User.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/TelemetryContext.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/










var strExt = "ext";
var strTags = "tags";
var TelemetryContext_UNDEF_VALUE;
function _removeEmpty(target, name) {
    if (target && target[name] && objKeys(target[name]).length === 0) {
        delete target[name];
    }
}
function _nullResult() {
    return null;
}
/**
 * Create a telemetryTrace object that will be used to manage the trace context for the current telemetry item.
 * This will create a proxy object that will read the values from the core.getTraceCtx() and provide a way to update the values
 * in the core.getTraceCtx() if they are valid.
 * @param core - The core instance that will be used to get the trace context
 * @returns A telemetryTrace object that will be used to manage the trace context for the current telemetry item.
 */
function _createTelemetryTrace(core) {
    var coreTraceCtx = core ? core.getTraceCtx() : null;
    var trace = {};
    function _getCtx() {
        var ctx = core ? core.getTraceCtx() : null;
        if (coreTraceCtx && ctx !== coreTraceCtx) {
            // It appears that the coreTraceCtx has been updated, so clear the local trace context
            trace = {};
        }
        return ctx;
    }
    function _getTraceCtx(name) {
        var value;
        var ctx = _getCtx();
        if (!ts_utils_isUndefined(trace[name])) {
            // has local value
            value = trace[name];
        }
        else if (ctx) {
            if (name in ctx) {
                // has property
                value = ctx[name];
            }
            else {
                var fnName = "get" + strLetterCase(name);
                if (ts_utils_isFunction(ctx[fnName])) {
                    value = ctx[fnName];
                }
            }
            if (ts_utils_isFunction(value)) {
                // The return values was a function, call it
                value = ts_utils_fnCall(value, ctx);
            }
        }
        return value;
    }
    function _setTraceCtx(name, value, checkFn) {
        var ctx = _getCtx();
        if (ctx) {
            if (name in ctx) {
                if (ts_utils_isFunction(ctx[name])) {
                    // The return values was a function, call it
                    ts_utils_fnCall(ctx[name], ctx, [value]);
                }
                else {
                    ctx[name] = value;
                }
            }
            else {
                var fnName = "set" + strLetterCase(name);
                if (ts_utils_isFunction(ctx[fnName])) {
                    ctx[fnName](value);
                }
            }
            // For backward compatability, we need to support invalid values for historic reasons,
            // moving forward we have marked the usage of the telemetryTrace as deprecated and will be removed in a future version.
            // We will only set the value in the local trace context if it is a valid trace ID or a string, otherwise we will remove it
            trace[name] = TelemetryContext_UNDEF_VALUE;
            if (value && ts_utils_isString(value)) {
                // If the value is null or undefined, remove it from the local trace context
                if (checkFn && checkFn() !== value) {
                    // If the values doesn't match (most likely because the value is invalid), set the value in the local trace context
                    coreTraceCtx = ctx;
                    trace[name] = value;
                }
            }
        }
    }
    function _getTraceId() {
        return _getTraceCtx("traceId");
    }
    function _getParentId() {
        var ctx = _getCtx();
        var spanId = trace["spanId"];
        if (ctx && ts_utils_isUndefined(spanId)) {
            var parentCtx = ctx.parentCtx;
            if (parentCtx) {
                spanId = parentCtx.spanId;
            }
        }
        return spanId || _getTraceCtx("spanId");
    }
    function _getTraceFlags() {
        return _getTraceCtx("traceFlags");
    }
    function _getName() {
        return DataSanitizer_dataSanitizeString(core ? core.logger : null, _getTraceCtx("getName") || _getTraceCtx("pageName"));
    }
    function _setValue(name, checkFn) {
        return function (value) {
            _setTraceCtx(name, value, checkFn);
        };
    }
    return objDefineProps({}, {
        traceID: {
            g: _getTraceId,
            s: _setValue("traceId", _getTraceId)
        },
        parentID: {
            g: _getParentId,
            s: _setValue("spanId", _getParentId)
        },
        traceFlags: {
            g: _getTraceFlags,
            s: _setValue("traceFlags", _getTraceFlags)
        },
        name: {
            g: _getName,
            s: _setValue("pageName", _getName)
        }
    });
}
var TelemetryContext = /** @class */ (function () {
    function TelemetryContext(core, defaultConfig, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        dynamicProto(TelemetryContext, this, function (_self) {
            _self.appId = _nullResult;
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = _nullResult;
            _self.application = new Application();
            _self.internal = new Internal(defaultConfig, unloadHookContainer);
            if (hasWindow()) {
                _self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] = new _SessionManager(defaultConfig, core, unloadHookContainer);
                _self.device = new Device();
                _self.location = new Location();
                _self.user = new User(defaultConfig, core, unloadHookContainer);
                _self[_DYN_SESSION /* @min:%2esession */] = new Session();
                ts_utils_objDefine(_self, "telemetryTrace", {
                    l: getDeferred(function () { return _createTelemetryTrace(core); })
                });
            }
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = function () {
                var session = _self[_DYN_SESSION /* @min:%2esession */];
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && ts_utils_isString(session.id)) {
                    sesId = session.id;
                }
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] || {})[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                    sesId = autoSession && ts_utils_isString(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */] = function (evt, itemCtx) {
                setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */](), ts_utils_isString);
            };
            _self[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */] = function (evt, itemCtx) {
                setValue(evt.ext, Extensions.OSExt, _self.os);
            };
            _self[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */] = function (evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.applicationVersion, application.ver, ts_utils_isString);
                    setValue(tags, CtxTagKeys.applicationBuild, application.build, ts_utils_isString);
                }
            };
            _self.applyDeviceContext = function (evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
                    setValue(extDevice, "localId", device.id, ts_utils_isString);
                    setValue(extDevice, "ip", device.ip, ts_utils_isString);
                    setValue(extDevice, "model", device.model, ts_utils_isString);
                    setValue(extDevice, "deviceClass", device.deviceClass, ts_utils_isString);
                }
            };
            _self[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */] = function (evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, ts_utils_isString); // not mapped in CS 4.0
                    setValue(tags, CtxTagKeys.internalSdkVersion, DataSanitizer_dataSanitizeString(logger, internal.sdkVersion, 64), ts_utils_isString);
                    if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageViewDataType) {
                        setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, ts_utils_isString);
                        setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, ts_utils_isString);
                    }
                }
            };
            _self[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */] = function (evt, itemCtx) {
                var location = _this.location;
                if (location) {
                    setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, ts_utils_isString);
                }
            };
            _self[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */] = function (evt, itemCtx) {
                var telemetryTrace = _self.telemetryTrace;
                if (telemetryTrace) {
                    var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: undefined, parentID: undefined });
                    setValue(extTrace, "traceID", telemetryTrace.traceID, ts_utils_isString, ts_utils_isNullOrUndefined);
                    setValue(extTrace, "name", telemetryTrace.name, ts_utils_isString, ts_utils_isNullOrUndefined);
                    setValue(extTrace, "parentID", telemetryTrace.parentID, ts_utils_isString, ts_utils_isNullOrUndefined);
                }
            };
            _self.applyWebContext = function (evt, itemCtx) {
                var web = _this.web;
                if (web) {
                    setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
                }
            };
            _self.applyUserContext = function (evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = getSetValue(evt, strTags, []);
                    // stays in tags
                    setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID /* @min:%2eaccountId */], ts_utils_isString);
                    // CS 4.0
                    var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
                    setValue(extUser, "id", user.id, ts_utils_isString);
                    setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], ts_utils_isString);
                }
            };
            _self.cleanUp = function (evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    _removeEmpty(ext, Extensions.DeviceExt);
                    _removeEmpty(ext, Extensions.UserExt);
                    _removeEmpty(ext, Extensions.WebExt);
                    _removeEmpty(ext, Extensions.OSExt);
                    _removeEmpty(ext, Extensions.AppExt);
                    _removeEmpty(ext, Extensions.TraceExt);
                }
            };
        });
    }
// Removed Stub for TelemetryContext.prototype.applySessionContext.
// Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
// Removed Stub for TelemetryContext.prototype.applyApplicationContext.
// Removed Stub for TelemetryContext.prototype.applyDeviceContext.
// Removed Stub for TelemetryContext.prototype.applyInternalContext.
// Removed Stub for TelemetryContext.prototype.applyLocationContext.
// Removed Stub for TelemetryContext.prototype.applyOperationContext.
// Removed Stub for TelemetryContext.prototype.applyWebContext.
// Removed Stub for TelemetryContext.prototype.applyUserContext.
// Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn=1;

    return TelemetryContext;
}());

//# sourceMappingURL=TelemetryContext.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-properties-js/dist-es5/PropertiesPlugin.js
/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/
var PropertiesPlugin_a;






var undefString;
var nullValue = null;
var PropertiesPlugin_defaultConfig = ts_utils_objDeepFreeze((PropertiesPlugin_a = {
        accountId: nullValue,
        sessionRenewalMs: 30 * 60 * 1000,
        samplingPercentage: 100,
        sessionExpirationMs: 24 * 60 * 60 * 1000,
        cookieDomain: nullValue,
        sdkExtension: nullValue,
        isBrowserLinkTrackingEnabled: false,
        appId: nullValue
    },
    PropertiesPlugin_a[_DYN_GET_SESSION_ID /* @min:getSessionId */] = nullValue,
    PropertiesPlugin_a.namePrefix = undefString,
    PropertiesPlugin_a[_DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */] = undefString,
    PropertiesPlugin_a.userCookiePostfix = undefString,
    PropertiesPlugin_a.idLength = 22,
    PropertiesPlugin_a.getNewId = nullValue,
    PropertiesPlugin_a));
var PropertiesPlugin = /** @class */ (function (_super) {
    __extendsFn(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = PropertiesPluginIdentifier;
        var _extensionConfig;
        var _context;
        var _disableUserInitMessage;
        dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
            _initDefaults();
            ts_utils_objDefine(_self, "context", {
                g: function () {
                    return _context;
                }
            });
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */
            _self.processTelemetry = function (event, itemCtx) {
                if (!ts_utils_isNullOrUndefined(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === PageViewEnvelopeType) {
                        itemCtx.diagLog().resetInternalMessageCount();
                    }
                    var theContext = (_context || {});
                    if (theContext[_DYN_SESSION /* @min:%2esession */]) {
                        // If customer did not provide custom session id update the session manager
                        if (!ts_utils_isString(_context[_DYN_SESSION /* @min:%2esession */].id) && theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */]) {
                            theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */].update();
                        }
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                        userCtx.update(theContext.user.id);
                    }
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */]) {
                        userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                        if (!_disableUserInitMessage) {
                            var message = new _InternalLogMessage(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */, ((getNavigator() || {}).userAgent || ""));
                            _logInternalMessage(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, message);
                        }
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _context = null;
                _disableUserInitMessage = true;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _disableUserInitMessage = config.disableUserInitMessage === false ? false : true;
                    _extensionConfig = ctx.getExtCfg(identifier, PropertiesPlugin_defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _context = new TelemetryContext(core, _extensionConfig, _self._unloadHooks);
                _self.context.appId = function () {
                    var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                getSetValue(evt, "tags", []);
                getSetValue(evt, "ext", {});
                var ctx = _self.context;
                ctx[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */](evt, itemCtx);
                ctx[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */](evt, itemCtx);
                ctx.applyDeviceContext(evt, itemCtx);
                ctx[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */](evt, itemCtx);
                ctx.applyUserContext(evt, itemCtx);
                ctx[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */](evt, itemCtx); // legacy tags
                ctx[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn=1;

    return PropertiesPlugin;
}(BaseTelemetryPlugin));
/* harmony default export */ var dist_es5_PropertiesPlugin = (PropertiesPlugin);
//# sourceMappingURL=PropertiesPlugin.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-es5/InternalConstants.js
/*
 * Application Insights JavaScript SDK - Web, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var dist_es5_InternalConstants_UNDEFINED_VALUE = undefined;
var dist_es5_InternalConstants_STR_EMPTY = "";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_ADD_TELEMETRY_INITIALIZERS = STR_ADD_TELEMETRY_INITIALIZER + "s";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;
var CONFIG_ENDPOINT_URL = "https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json";
//# sourceMappingURL=InternalConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-es5/__DynamicConstants.js
/*
 * Application Insights JavaScript SDK - Web, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_CONNECTION_STRING = "connectionString"; // Count: 3
var _DYN_VERSION = "version"; // Count: 6
var _DYN_QUEUE = "queue"; // Count: 6
var _DynamicConstants_DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 4
var _DYN_USER_OVERRIDE_ENDPOI0 = "userOverrideEndpointUrl"; // Count: 5
var _DynamicConstants_DYN_ENDPOINT_URL = "endpointUrl"; // Count: 5
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
var _DynamicConstants_DYN_CONTEXT = "context"; // Count: 5
var _DYN_ADD_HOUSEKEEPING_BEF1 = "addHousekeepingBeforeUnload"; // Count: 2
var _DYN_SEND_MESSAGE = "sendMessage"; // Count: 3
var _DYN_UPDATE_SNIPPET_DEFIN2 = "updateSnippetDefinitions"; // Count: 2
var _DynamicConstants_DYN_LOGGER = "logger"; // Count: 5
var _DYN_ATTRIB_CONTAINER = "attribContainer"; // Count: 5
var dist_es5_DynamicConstants_DYN_ATTRIBUTES = "attributes"; // Count: 5
var dist_es5_DynamicConstants_DYN_SPAN_CONTEXT = "spanContext"; // Count: 6
var applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_ID = "traceId"; // Count: 4
var applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID = "spanId"; // Count: 9
var _DynamicConstants_DYN_KIND = "kind"; // Count: 6
var _DynamicConstants_DYN_BASE_DATA = "baseData"; // Count: 6
var dist_es5_DynamicConstants_DYN_TYPE = "type"; // Count: 12
var _DynamicConstants_DYN_RESPONSE_CODE = "responseCode"; // Count: 4
var _DYN_TARGET = "target"; // Count: 7
var applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_FLAGS = "traceFlags"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/otel/attribute/SemanticConventions.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var MICROSOFT_APPLICATIONINSIGHTS_NAME = "Microsoft.ApplicationInsights.";
var MICROSOFT_DOT = "microsoft.";
var CLIENT_DOT = "client.";
var HTTP_DOT = "http.";
var NET_DOT = "net.";
var PEER_DOT = "peer.";
var EXCEPTION_DOT = "exception.";
var ENDUSER_DOT = "enduser.";
var URL_DOT = "url.";
var DB_DOT = "db.";
var NETWORK_DOT = "network.";
var AzureMonitorSampleRate = MICROSOFT_DOT + "sample_rate";
var ApplicationInsightsCustomEventName = MICROSOFT_DOT + "custom_event.name";
var MicrosoftClientIp = MICROSOFT_DOT + CLIENT_DOT + "ip";
var ApplicationInsightsMessageName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Message";
var ApplicationInsightsExceptionName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Exception";
var ApplicationInsightsPageViewName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "PageView";
var ApplicationInsightsAvailabilityName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Availability";
var ApplicationInsightsEventName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Event";
var ApplicationInsightsBaseType = "_MS.baseType";
var ApplicationInsightsMessageBaseType = "MessageData";
var ApplicationInsightsExceptionBaseType = "ExceptionData";
var ApplicationInsightsPageViewBaseType = "PageViewData";
var ApplicationInsightsAvailabilityBaseType = "AvailabilityData";
var ApplicationInsightsEventBaseType = "EventData";
var ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
var ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
var ATTR_HTTP_ROUTE = HTTP_DOT + "route";
var SEMATTRS_NET_PEER_IP = NET_DOT + PEER_DOT + "ip";
var SEMATTRS_NET_PEER_NAME = NET_DOT + PEER_DOT + "name";
var SEMATTRS_NET_HOST_IP = NET_DOT + "host.ip";
var SEMATTRS_PEER_SERVICE = PEER_DOT + "service";
var SEMATTRS_HTTP_USER_AGENT = HTTP_DOT + "user_agent";
var SEMATTRS_HTTP_METHOD = HTTP_DOT + "method";
var SEMATTRS_HTTP_URL = HTTP_DOT + "url";
var SEMATTRS_HTTP_STATUS_CODE = HTTP_DOT + "status_code";
var SEMATTRS_HTTP_ROUTE = HTTP_DOT + "route";
var SEMATTRS_HTTP_HOST = HTTP_DOT + "host";
var SEMATTRS_DB_SYSTEM = DB_DOT + "system";
var SEMATTRS_DB_STATEMENT = DB_DOT + "statement";
var SEMATTRS_DB_OPERATION = DB_DOT + "operation";
var SEMATTRS_DB_NAME = DB_DOT + "name";
var SEMATTRS_RPC_SYSTEM = "rpc.system";
var SEMATTRS_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
var SEMATTRS_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
var SEMATTRS_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
var SEMATTRS_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
var SEMATTRS_HTTP_SCHEME = HTTP_DOT + "scheme";
var SEMATTRS_HTTP_TARGET = HTTP_DOT + "target";
var SEMATTRS_HTTP_FLAVOR = HTTP_DOT + "flavor";
var SEMATTRS_NET_TRANSPORT = NET_DOT + "transport";
var SEMATTRS_NET_HOST_NAME = NET_DOT + "host.name";
var SEMATTRS_NET_HOST_PORT = NET_DOT + "host.port";
var SEMATTRS_NET_PEER_PORT = NET_DOT + PEER_DOT + "port";
var SEMATTRS_HTTP_CLIENT_IP = HTTP_DOT + "client_ip";
var SEMATTRS_ENDUSER_ID = ENDUSER_DOT + "id";
var ATTR_CLIENT_ADDRESS = CLIENT_DOT + "address";
var ATTR_CLIENT_PORT = CLIENT_DOT + "port";
var ATTR_SERVER_ADDRESS = "server.address";
var ATTR_SERVER_PORT = "server.port";
var ATTR_URL_FULL = URL_DOT + "full";
var ATTR_URL_PATH = URL_DOT + "path";
var ATTR_URL_QUERY = URL_DOT + "query";
var ATTR_URL_SCHEME = URL_DOT + "scheme";
var ATTR_ERROR_TYPE = "error.type";
var ATTR_NETWORK_LOCAL_ADDRESS = NETWORK_DOT + "local.address";
var ATTR_NETWORK_LOCAL_PORT = NETWORK_DOT + "local.port";
var ATTR_NETWORK_PROTOCOL_NAME = NETWORK_DOT + "protocol.name";
var ATTR_NETWORK_PEER_ADDRESS = NETWORK_DOT + PEER_DOT + "address";
var ATTR_NETWORK_PEER_PORT = NETWORK_DOT + PEER_DOT + "port";
var ATTR_NETWORK_PROTOCOL_VERSION = NETWORK_DOT + "protocol.version";
var ATTR_NETWORK_TRANSPORT = NETWORK_DOT + "transport";
var ATTR_USER_AGENT_ORIGINAL = "user_agent.original";
var ATTR_HTTP_REQUEST_METHOD = HTTP_DOT + "request.method";
var ATTR_HTTP_RESPONSE_STATUS_CODE = HTTP_DOT + "response.status_code";
var ATTR_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
var ATTR_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
var ATTR_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
var EXP_ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
var EXP_ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
var EXP_ATTR_SYNTHETIC_TYPE = "synthetic.type";
var DBSYSTEMVALUES_MONGODB = "mongodb";
var DBSYSTEMVALUES_COSMOSDB = "cosmosdb";
var DBSYSTEMVALUES_MYSQL = "mysql";
var DBSYSTEMVALUES_POSTGRESQL = "postgresql";
var DBSYSTEMVALUES_REDIS = "redis";
var DBSYSTEMVALUES_DB2 = "db2";
var DBSYSTEMVALUES_DERBY = "derby";
var DBSYSTEMVALUES_MARIADB = "mariadb";
var DBSYSTEMVALUES_MSSQL = "mssql";
var DBSYSTEMVALUES_ORACLE = "oracle";
var DBSYSTEMVALUES_SQLITE = "sqlite";
var DBSYSTEMVALUES_OTHER_SQL = "other_sql";
var DBSYSTEMVALUES_HSQLDB = "hsqldb";
var DBSYSTEMVALUES_H2 = "h2";
//# sourceMappingURL=SemanticConventions.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-core-js/dist-es5/internal/commonUtils.js
/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var _hasJsonStringify = ( /*#__PURE__*/(/* unused pure expression or super */ null && (safeGetLazy(function () { return !!getJSON()[_DYN_STRINGIFY /* @min:%2estringify */]; }, null))));
var SYNTHETIC_TYPE = "user_agent.synthetic.type";
var commonUtils_CLIENT_DOT = "client.";
var commonUtils_HTTP_DOT = "http.";
var commonUtils_NET_DOT = "net.";
var commonUtils_PEER_DOT = "peer.";
var commonUtils_ATTR_NETWORK_PEER_ADDRESS = "network.peer.address";
var commonUtils_SEMATTRS_NET_PEER_IP = commonUtils_NET_DOT + commonUtils_PEER_DOT + "ip";
var commonUtils_ATTR_CLIENT_ADDRESS = commonUtils_CLIENT_DOT + "address";
var commonUtils_SEMATTRS_HTTP_CLIENT_IP = commonUtils_HTTP_DOT + "client_ip";
var commonUtils_ATTR_USER_AGENT_ORIGINAL = "user_agent.original";
var commonUtils_SEMATTRS_HTTP_USER_AGENT = commonUtils_HTTP_DOT + "user_agent";
var commonUtils_ATTR_URL_FULL = "url.full";
var commonUtils_SEMATTRS_HTTP_URL = commonUtils_HTTP_DOT + "url";
var commonUtils_ATTR_HTTP_REQUEST_METHOD = commonUtils_HTTP_DOT + "request.method";
var commonUtils_SEMATTRS_HTTP_METHOD = commonUtils_HTTP_DOT + "method";
var commonUtils_ATTR_HTTP_RESPONSE_STATUS_CODE = commonUtils_HTTP_DOT + "response.status_code";
var commonUtils_SEMATTRS_HTTP_STATUS_CODE = commonUtils_HTTP_DOT + "status_code";
var commonUtils_ATTR_URL_SCHEME = "url.scheme";
var commonUtils_SEMATTRS_HTTP_SCHEME = commonUtils_HTTP_DOT + "scheme";
var commonUtils_ATTR_URL_PATH = "url.path";
var commonUtils_ATTR_URL_QUERY = "url.query";
var commonUtils_SEMATTRS_HTTP_TARGET = commonUtils_HTTP_DOT + "target";
var commonUtils_ATTR_SERVER_ADDRESS = "server.address";
var commonUtils_SEMATTRS_HTTP_HOST = commonUtils_HTTP_DOT + "host";
var commonUtils_SEMATTRS_NET_PEER_NAME = commonUtils_NET_DOT + commonUtils_PEER_DOT + "name";
var commonUtils_ATTR_CLIENT_PORT = commonUtils_CLIENT_DOT + "port";
var commonUtils_ATTR_SERVER_PORT = "server.port";
var commonUtils_SEMATTRS_NET_PEER_PORT = commonUtils_NET_DOT + commonUtils_PEER_DOT + "port";
var commonUtils_SEMATTRS_PEER_SERVICE = commonUtils_PEER_DOT + "service";
/**
 * Get the URL from the attribute container
 * @param container - The attribute container to extract the URL from
 * @returns The constructed URL string
 */
/* #__NO_SIDE_EFFECTS__ */
function getUrl(container) {
    var result = "";
    if (container) {
        var httpMethod = getHttpMethod(container);
        if (httpMethod) {
            var httpUrl = getHttpUrl(container);
            if (httpUrl) {
                result = ts_utils_asString(httpUrl);
            }
            else {
                var httpScheme = getHttpScheme(container);
                var httpTarget = getHttpTarget(container);
                if (httpScheme && httpTarget) {
                    var httpHost = getHttpHost(container);
                    if (httpHost) {
                        result = httpScheme + "://" + httpHost + httpTarget;
                    }
                    else {
                        var netPeerPort = getNetPeerPort(container);
                        if (netPeerPort) {
                            var netPeerName = getNetPeerName(container);
                            if (netPeerName) {
                                result = httpScheme + "://" + netPeerName + ":" + netPeerPort + httpTarget;
                            }
                            else {
                                var netPeerIp = getPeerIp(container);
                                if (netPeerIp) {
                                    result = httpScheme + "://" + netPeerIp + ":" + netPeerPort + httpTarget;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return result;
}
/**
 * Gets the synthetic type from the attribute container
 * @param container - The attribute container to extract the synthetic type from
 * @returns The synthetic type value
 */
/* #__NO_SIDE_EFFECTS__ */
function getSyntheticType(container) {
    return container.get(SYNTHETIC_TYPE);
}
/**
 * Determine if the attribute container represents a synthetic source
 * @param container - The attribute container to check
 * @returns True if the attribute container is from a synthetic source
 */
/* #__NO_SIDE_EFFECTS__ */
function isSyntheticSource(container) {
    return !!getSyntheticType(container);
}
/**
 * Serialize an attribute value to a string value
 * @param value - The attribute value to serialize
 * @returns The serialized string value
 */
/* #__NO_SIDE_EFFECTS__ */
function serializeAttribute(value) {
    var result;
    if (isError(value)) {
        result = dumpObj(value);
    }
    else if ((!value[_DYN_TO_STRING /* @min:%2etoString */] || isObject(value)) && _hasJsonStringify.v) {
        result = safe(getJSON()[_DYN_STRINGIFY /* @min:%2estringify */], [value]).v;
    }
    else if (isPrimitive(value)) {
        // We keep primitives as-is, so that the standard attribute types are preserved
        // These are converted as required in the sending channel(s)
        result = value;
    }
    else {
        result = asString(value);
    }
    // Return scalar and undefined values
    return result;
}
/**
 * Peer address of the network connection - IP address or Unix domain socket name.
 *
 * @example 10.1.2.80
 * @example /tmp/my.sock
 * @since 3.4.0
 */
/* #__NO_SIDE_EFFECTS__ */
function getPeerIp(container) {
    if (container) {
        return container.get(commonUtils_ATTR_NETWORK_PEER_ADDRESS) || container.get(commonUtils_SEMATTRS_NET_PEER_IP);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getLocationIp(container) {
    var result;
    if (container) {
        var httpClientIp = getHttpClientIp(container);
        if (httpClientIp) {
            result = ts_utils_asString(httpClientIp);
        }
        if (!result) {
            var netPeerIp = getPeerIp(container);
            if (netPeerIp) {
                result = ts_utils_asString(netPeerIp);
            }
        }
    }
    return result;
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpClientIp(container) {
    if (container) {
        return container.get(commonUtils_ATTR_CLIENT_ADDRESS) || container.get(commonUtils_SEMATTRS_HTTP_CLIENT_IP);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getUserAgent(container) {
    if (container) {
        return container.get(commonUtils_ATTR_USER_AGENT_ORIGINAL) || container.get(commonUtils_SEMATTRS_HTTP_USER_AGENT);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpUrl(container) {
    // Stable sem conv only supports populating url from `url.full`
    if (container) {
        return container.get(commonUtils_ATTR_URL_FULL) || container.get(commonUtils_SEMATTRS_HTTP_URL);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpMethod(container) {
    if (container) {
        return container.get(commonUtils_ATTR_HTTP_REQUEST_METHOD) || container.get(commonUtils_SEMATTRS_HTTP_METHOD);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpStatusCode(container) {
    if (container) {
        return container.get(commonUtils_ATTR_HTTP_RESPONSE_STATUS_CODE) || container.get(commonUtils_SEMATTRS_HTTP_STATUS_CODE);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpScheme(container) {
    if (container) {
        return container.get(commonUtils_ATTR_URL_SCHEME) || container.get(commonUtils_SEMATTRS_HTTP_SCHEME);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpTarget(container) {
    if (container) {
        return container.get(commonUtils_ATTR_URL_PATH) || container.get(commonUtils_ATTR_URL_QUERY) || container.get(commonUtils_SEMATTRS_HTTP_TARGET);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getHttpHost(container) {
    if (container) {
        return container.get(commonUtils_ATTR_SERVER_ADDRESS) || container.get(commonUtils_SEMATTRS_HTTP_HOST);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getNetPeerName(container) {
    if (container) {
        return container.get(commonUtils_ATTR_CLIENT_ADDRESS) || container.get(commonUtils_SEMATTRS_NET_PEER_NAME);
    }
}
/* #__NO_SIDE_EFFECTS__ */
function getNetPeerPort(container) {
    if (container) {
        return (container.get(commonUtils_ATTR_CLIENT_PORT) ||
            container.get(commonUtils_ATTR_SERVER_PORT) ||
            container.get(commonUtils_SEMATTRS_NET_PEER_PORT));
    }
}
function getDependencyTarget(container) {
    var result;
    if (container) {
        var peerService = container.get(commonUtils_SEMATTRS_PEER_SERVICE);
        if (peerService) {
            result = ts_utils_asString(peerService);
        }
        if (!result) {
            var httpHost = getHttpHost(container);
            if (httpHost) {
                result = ts_utils_asString(httpHost);
            }
        }
        if (!result) {
            var httpUrl = getHttpUrl(container);
            if (httpUrl) {
                result = ts_utils_asString(httpUrl);
            }
        }
        if (!result) {
            var netPeerName = getNetPeerName(container);
            if (netPeerName) {
                result = ts_utils_asString(netPeerName);
            }
        }
        if (!result) {
            var netPeerIp = getPeerIp(container);
            if (netPeerIp) {
                result = ts_utils_asString(netPeerIp);
            }
        }
    }
    return result || InternalConstants_STR_EMPTY;
}
/** #__NO_SIDE_EFFECTS__ */
function isSqlDB(dbSystem) {
    return (dbSystem === DBSYSTEMVALUES_DB2 ||
        dbSystem === DBSYSTEMVALUES_DERBY ||
        dbSystem === DBSYSTEMVALUES_MARIADB ||
        dbSystem === DBSYSTEMVALUES_MSSQL ||
        dbSystem === DBSYSTEMVALUES_ORACLE ||
        dbSystem === DBSYSTEMVALUES_SQLITE ||
        dbSystem === DBSYSTEMVALUES_OTHER_SQL ||
        dbSystem === DBSYSTEMVALUES_HSQLDB ||
        dbSystem === DBSYSTEMVALUES_H2);
}
/**
 * Adds a timeout to a promise and rejects if the specified timeout has elapsed.
 * Reports the timeout through the configured error handlers before rejecting.
 *
 * @param handlers - The configured error handlers to notify.
 * @param promise - The promise to guard with the timeout.
 * @param timeout - Timeout in milliseconds before the promise is rejected.
 */
function callWithTimeout(handlers, promise, timeout) {
    var timeoutMessage = "Operation timed out.";
    var timeoutError = new Error(timeoutMessage);
    timeoutError[_DYN_NAME /* @min:%2ename */] = "TimeoutError";
    timeoutError.__otelTimeout = true;
    var racedPromise = createRacePromise([
        promise,
        createTimeoutPromise(timeout, false, timeoutError)
    ]);
    return racedPromise.catch(function (error) {
        if (error && (error === timeoutError || error.__otelTimeout)) {
            handleError(handlers, timeoutMessage);
        }
        throw error;
    });
}
//# sourceMappingURL=commonUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-es5/internal/trace/spanUtils.js
/*
 * Application Insights JavaScript SDK - Web, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// Copyright (c) Microsoft Corporation.





/**
 * Azure SDK namespace.
 * @internal
 */
var AzNamespace = "az.namespace";
var AzResourceNamespace = "azure.resource_provider.namespace";
/**
 * Azure SDK Eventhub.
 * @internal
 */
var MicrosoftEventHub = "Microsoft.EventHub";
/**
 * Azure SDK message bus destination.
 * @internal
 */
var MessageBusDestination = "message_bus.destination";
/**
 * AI time since enqueued attribute.
 * @internal
 */
var TIME_SINCE_ENQUEUED = "timeSinceEnqueued";
var PORT_REGEX = ( /*#__PURE__*/getLazy(function () { return new RegExp(/(https?)(:\/\/.*)(:\d+)(\S*)/); }));
var spanUtils_HTTP_DOT = ( /*#__PURE__*/"http.");
var _MS_PROCESSED_BY_METRICS_EXTRACTORS = ( /* #__PURE__*/"_MS.ProcessedByMetricExtractors");
/**
 * Legacy HTTP semantic convention values
 * @internal
 */
var _ignoreSemanticValues = ( /* #__PURE__*/getLazy(_initIgnoreSemanticValues));
/* #__NO_SIDE_EFFECTS__ */
function _initIgnoreSemanticValues() {
    return [
        // Internal Microsoft attributes
        _MS_PROCESSED_BY_METRICS_EXTRACTORS,
        // Legacy HTTP semantic values
        SEMATTRS_NET_PEER_IP,
        SEMATTRS_NET_PEER_NAME,
        SEMATTRS_NET_HOST_IP,
        SEMATTRS_PEER_SERVICE,
        SEMATTRS_HTTP_USER_AGENT,
        SEMATTRS_HTTP_METHOD,
        SEMATTRS_HTTP_URL,
        SEMATTRS_HTTP_STATUS_CODE,
        SEMATTRS_HTTP_ROUTE,
        SEMATTRS_HTTP_HOST,
        SEMATTRS_DB_SYSTEM,
        SEMATTRS_DB_STATEMENT,
        SEMATTRS_DB_OPERATION,
        SEMATTRS_DB_NAME,
        SEMATTRS_RPC_SYSTEM,
        SEMATTRS_RPC_GRPC_STATUS_CODE,
        SEMATTRS_EXCEPTION_TYPE,
        SEMATTRS_EXCEPTION_MESSAGE,
        SEMATTRS_EXCEPTION_STACKTRACE,
        SEMATTRS_HTTP_SCHEME,
        SEMATTRS_HTTP_TARGET,
        SEMATTRS_HTTP_FLAVOR,
        SEMATTRS_NET_TRANSPORT,
        SEMATTRS_NET_HOST_NAME,
        SEMATTRS_NET_HOST_PORT,
        SEMATTRS_NET_PEER_PORT,
        SEMATTRS_HTTP_CLIENT_IP,
        SEMATTRS_ENDUSER_ID,
        spanUtils_HTTP_DOT + "status_text",
        // http Semabtic conventions
        ATTR_CLIENT_ADDRESS,
        ATTR_CLIENT_PORT,
        ATTR_SERVER_ADDRESS,
        ATTR_SERVER_PORT,
        ATTR_URL_FULL,
        ATTR_URL_PATH,
        ATTR_URL_QUERY,
        ATTR_URL_SCHEME,
        ATTR_ERROR_TYPE,
        ATTR_NETWORK_LOCAL_ADDRESS,
        ATTR_NETWORK_LOCAL_PORT,
        ATTR_NETWORK_PROTOCOL_NAME,
        ATTR_NETWORK_PEER_ADDRESS,
        ATTR_NETWORK_PEER_PORT,
        ATTR_NETWORK_PROTOCOL_VERSION,
        ATTR_NETWORK_TRANSPORT,
        ATTR_USER_AGENT_ORIGINAL,
        ATTR_HTTP_REQUEST_METHOD,
        ATTR_HTTP_RESPONSE_STATUS_CODE,
        ATTR_EXCEPTION_TYPE,
        ATTR_EXCEPTION_MESSAGE,
        ATTR_EXCEPTION_STACKTRACE,
        EXP_ATTR_ENDUSER_ID,
        EXP_ATTR_ENDUSER_PSEUDO_ID,
        EXP_ATTR_SYNTHETIC_TYPE
    ];
}
function _populateTagsFromSpan(telemetryItem, span, contextKeys, config) {
    var tags = telemetryItem.tags = (telemetryItem.tags || []);
    var container = span[_DYN_ATTRIB_CONTAINER /* @min:%2eattribContainer */] || attributeContainer_createAttributeContainer(span[dist_es5_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */]);
    tags[contextKeys.operationId] = span[dist_es5_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]()[applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */];
    if ((span.parentSpanContext || {})[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */]) {
        tags[contextKeys.operationParentId] = span.parentSpanContext[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
    }
    // Map OpenTelemetry enduser attributes to Application Insights user attributes
    var endUserId = container.get(ATTR_ENDUSER_ID);
    if (endUserId) {
        tags[contextKeys.userAuthUserId] = ts_utils_asString(endUserId);
    }
    var endUserPseudoId = container.get(ATTR_ENDUSER_PSEUDO_ID);
    if (endUserPseudoId) {
        tags[contextKeys.userId] = ts_utils_asString(endUserPseudoId);
    }
    var httpUserAgent = getUserAgent(container);
    if (httpUserAgent) {
        tags["ai.user.userAgent"] = String(httpUserAgent);
    }
    if (isSyntheticSource(container)) {
        tags[contextKeys.operationSyntheticSource] = "True";
    }
    // Check for microsoft.client.ip first - this takes precedence over all other IP logic
    var microsoftClientIp = container.get(MicrosoftClientIp);
    if (microsoftClientIp) {
        tags[contextKeys.locationIp] = ts_utils_asString(microsoftClientIp);
    }
    if (span[_DynamicConstants_DYN_KIND /* @min:%2ekind */] === 1 /* eOTelSpanKind.SERVER */) {
        var httpMethod = getHttpMethod(container);
        // Only use the fallback IP logic for server spans if microsoft.client.ip is not set
        if (!microsoftClientIp) {
            tags[contextKeys.locationIp] = getLocationIp(container);
        }
        if (httpMethod) {
            var httpRoute = container.get(ATTR_HTTP_ROUTE);
            var httpUrl = getHttpUrl(container);
            tags[contextKeys.operationName] = span.name; // Default
            if (httpRoute) {
                // AiOperationName max length is 1024
                // https://github.com/MohanGsk/ApplicationInsights-Home/blob/master/EndpointSpecs/Schemas/Bond/ContextTagKeys.bond
                tags[contextKeys.operationName] = httpMethod + " " + fieldRedaction(ts_utils_asString(httpRoute), config);
            }
            else if (httpUrl) {
                try {
                    var urlPathName = fieldRedaction(urlGetPathName(ts_utils_asString(httpUrl)), config);
                    tags[contextKeys.operationName] = httpMethod + " " + urlPathName;
                }
                catch (_a) {
                    /* no-op */
                }
            }
        }
        else {
            tags[contextKeys.operationName] = span.name;
        }
    }
    else {
        var opName = container.get(contextKeys.operationName);
        if (opName) {
            tags[contextKeys.operationName] = opName;
        }
    }
    // TODO: Location IP TBD for non server spans
}
/**
 * Check to see if the key is in the list of known properties to ignore (exclude)
 * from the properties collection
 * @param key - the property key to check
 * @param contextKeys - The current context keys
 * @returns true if the key should be ignored, false otherwise
 */
function _isIgnorePropertiesKey(key, contextKeys) {
    var result = false;
    if (arrIncludes(_ignoreSemanticValues.v, key)) {
        // The key is in set of known keys to ignore
        result = true;
    }
    else if (strStartsWith(key, "microsoft.")) {
        // Ignoring all ALL keys starting with "microsoft."
        result = true;
    }
    else if (key === contextKeys.operationName) {
        // Ignoring the key if it is the operation name context tag
        result = true;
    }
    return result;
}
function _populatePropertiesFromAttributes(item, contextKeys, container) {
    if (container) {
        var baseData = item[_DynamicConstants_DYN_BASE_DATA /* @min:%2ebaseData */] = (item[_DynamicConstants_DYN_BASE_DATA /* @min:%2ebaseData */] || {});
        var properties_1 = baseData.properties = (baseData.properties || {});
        container.forEach(function (key, value) {
            // Avoid duplication ignoring fields already mapped.
            if (!_isIgnorePropertiesKey(key, contextKeys)) {
                properties_1[key] = value;
            }
        });
    }
}
function _populateHttpDependencyProperties(dependencyTelemetry, container, httpMethod, config) {
    if (httpMethod) {
        // HTTP Dependency
        var httpUrl = getHttpUrl(container);
        if (httpUrl) {
            try {
                var pathName = urlGetPathName(ts_utils_asString(httpUrl));
                if (pathName) {
                    dependencyTelemetry.name = httpMethod + " " + fieldRedaction(pathName, config);
                }
            }
            catch (_a) {
                /* no-op */
            }
        }
        dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "Http" /* eDependencyTypes.Http */;
        dependencyTelemetry.data = fieldRedaction(getUrl(container), config);
        var httpStatusCode = getHttpStatusCode(container);
        if (httpStatusCode) {
            dependencyTelemetry[_DynamicConstants_DYN_RESPONSE_CODE /* @min:%2eresponseCode */] = +httpStatusCode;
        }
        var target = getDependencyTarget(container);
        if (target) {
            try {
                // Remove default port
                var res = PORT_REGEX.v.exec(target);
                if (res !== null) {
                    var protocol = res[1];
                    var port = res[3];
                    if ((protocol === "https" && port === ":443") ||
                        (protocol === "http" && port === ":80")) {
                        // Drop port
                        target = res[1] + res[2] + res[4];
                    }
                }
            }
            catch (_b) {
                /* no-op */
            }
            dependencyTelemetry[_DYN_TARGET /* @min:%2etarget */] = target;
        }
    }
    return !!httpMethod;
}
function _populateDbDependencyProperties(dependencyTelemetry, container, dbSystem) {
    if (dbSystem) {
        // TODO: Remove special logic when Azure UX supports OpenTelemetry dbSystem
        if (String(dbSystem) === DBSYSTEMVALUES_MYSQL) {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "mysql";
        }
        else if (String(dbSystem) === DBSYSTEMVALUES_POSTGRESQL) {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "postgresql";
        }
        else if (String(dbSystem) === DBSYSTEMVALUES_MONGODB) {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "mongodb";
        }
        else if (String(dbSystem) === DBSYSTEMVALUES_REDIS) {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "redis";
        }
        else if (isSqlDB(String(dbSystem))) {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "SQL";
        }
        else {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = String(dbSystem);
        }
        var dbStatement = container.get(SEMATTRS_DB_STATEMENT);
        var dbOperation = container.get(SEMATTRS_DB_OPERATION);
        if (dbStatement) {
            dependencyTelemetry.data = String(dbStatement);
        }
        else if (dbOperation) {
            dependencyTelemetry.data = String(dbOperation);
        }
        var target = getDependencyTarget(container);
        var dbName = container.get(SEMATTRS_DB_NAME);
        if (target) {
            dependencyTelemetry[_DYN_TARGET /* @min:%2etarget */] = dbName ? target + "|" + ts_utils_asString(dbName) : target;
        }
        else {
            dependencyTelemetry[_DYN_TARGET /* @min:%2etarget */] = dbName ? ts_utils_asString(dbName) : ts_utils_asString(dbSystem);
        }
    }
    return !!dbSystem;
}
function _populateRpcDependencyProperties(dependencyTelemetry, container, rpcSystem) {
    if (rpcSystem) {
        if (strLower(rpcSystem) === "wcf") {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "WCF Service" /* eDependencyTypes.Wcf */;
        }
        else {
            dependencyTelemetry[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "GRPC" /* eDependencyTypes.Grpc */;
        }
        var grpcStatusCode = container.get(SEMATTRS_RPC_GRPC_STATUS_CODE);
        if (!ts_utils_isNullOrUndefined(grpcStatusCode)) {
            dependencyTelemetry[_DynamicConstants_DYN_RESPONSE_CODE /* @min:%2eresponseCode */] = +grpcStatusCode;
        }
        var target = getDependencyTarget(container);
        if (target) {
            dependencyTelemetry[_DYN_TARGET /* @min:%2etarget */] = ts_utils_asString(target);
        }
        else {
            dependencyTelemetry[_DYN_TARGET /* @min:%2etarget */] = String(rpcSystem);
        }
    }
    return !!rpcSystem;
}
function createDependencyTelemetryItem(core, span, contextKeys) {
    var container = span[_DYN_ATTRIB_CONTAINER /* @min:%2eattribContainer */] || attributeContainer_createAttributeContainer(span[dist_es5_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */]);
    var dependencyType = "Dependency";
    if (span[_DynamicConstants_DYN_KIND /* @min:%2ekind */] === 3 /* eOTelSpanKind.PRODUCER */) {
        dependencyType = "Queue Message" /* eDependencyTypes.QueueMessage */;
    }
    else if (span[_DynamicConstants_DYN_KIND /* @min:%2ekind */] === 0 /* eOTelSpanKind.INTERNAL */ && span.parentSpanContext) {
        dependencyType = "InProc" /* eDependencyTypes.InProc */;
    }
    var spanCtx = span[dist_es5_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]();
    var dependencyTelemetry = {
        name: span.name,
        id: spanCtx[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] || core.getTraceCtx()[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */],
        success: (span.status || {}).code !== 2 /* eOTelSpanStatusCode.ERROR */,
        responseCode: 0,
        type: dependencyType,
        duration: hrTimeToMilliseconds(span.duration),
        data: dist_es5_InternalConstants_STR_EMPTY,
        target: dist_es5_InternalConstants_STR_EMPTY,
        properties: dist_es5_InternalConstants_UNDEFINED_VALUE,
        measurements: dist_es5_InternalConstants_UNDEFINED_VALUE
    };
    // Check for HTTP Dependency
    if (!_populateHttpDependencyProperties(dependencyTelemetry, container, getHttpMethod(container), core.config)) {
        // Check for DB Dependency
        if (!_populateDbDependencyProperties(dependencyTelemetry, container, container.get(SEMATTRS_DB_SYSTEM))) {
            // Check for Rpc Dependency
            _populateRpcDependencyProperties(dependencyTelemetry, container, container.get(SEMATTRS_RPC_SYSTEM));
        }
    }
    return createTelemetryItem(dependencyTelemetry, RemoteDependencyDataType, RemoteDependencyEnvelopeType.replace("{0}.", ""), core[_DynamicConstants_DYN_LOGGER /* @min:%2elogger */]);
}
function createRequestTelemetryItem(core, span, contextKeys) {
    var container = span[_DYN_ATTRIB_CONTAINER /* @min:%2eattribContainer */] || attributeContainer_createAttributeContainer(span[dist_es5_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */]);
    var spanCtx = span[dist_es5_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]();
    var requestData = {
        name: span.name,
        id: spanCtx[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */] || core.getTraceCtx()[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */],
        success: span.status.code !== 0 /* eOTelSpanStatusCode.UNSET */
            ? span.status.code === 1 /* eOTelSpanStatusCode.OK */
            : (Number(getHttpStatusCode(container)) || 0) < 400,
        responseCode: 0,
        duration: hrTimeToMilliseconds(span.duration),
        source: undefined
    };
    var httpMethod = getHttpMethod(container);
    var grpcStatusCode = container.get(SEMATTRS_RPC_GRPC_STATUS_CODE);
    if (httpMethod) {
        requestData.url = fieldRedaction(getUrl(container), core.config);
        var httpStatusCode = getHttpStatusCode(container);
        if (httpStatusCode) {
            requestData[_DynamicConstants_DYN_RESPONSE_CODE /* @min:%2eresponseCode */] = +httpStatusCode;
        }
    }
    else if (grpcStatusCode) {
        requestData[_DynamicConstants_DYN_RESPONSE_CODE /* @min:%2eresponseCode */] = +grpcStatusCode;
    }
    return createTelemetryItem(requestData, RequestDataType, RequestEnvelopeType.replace("{0}.", ""), core[_DynamicConstants_DYN_LOGGER /* @min:%2elogger */]);
}
function createTelemetryItemFromSpan(core, span) {
    var telemetryItem = null;
    var container = span[_DYN_ATTRIB_CONTAINER /* @min:%2eattribContainer */] || attributeContainer_createAttributeContainer(span[dist_es5_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */]);
    var contextKeys = CtxTagKeys;
    var kind = span[_DynamicConstants_DYN_KIND /* @min:%2ekind */];
    if (kind == 1 /* eOTelSpanKind.SERVER */ || kind == 4 /* eOTelSpanKind.CONSUMER */) {
        // Request
        telemetryItem = createRequestTelemetryItem(core, span, contextKeys);
    }
    else if (kind == 2 /* eOTelSpanKind.CLIENT */ || kind == 3 /* eOTelSpanKind.PRODUCER */ || kind == 0 /* eOTelSpanKind.INTERNAL */) {
        // RemoteDependency
        telemetryItem = createDependencyTelemetryItem(core, span, contextKeys);
    }
    else {
        //diag.error(`Unsupported span kind ${span.kind}`);
    }
    if (telemetryItem) {
        // Set start time for the telemetry item from the event, not the time it is being processed (the default)
        // The channel envelope creator uses this value when creating the envelope only when defined, otherwise it
        // uses the time when the item is being processed
        var baseData = telemetryItem[_DynamicConstants_DYN_BASE_DATA /* @min:%2ebaseData */] = telemetryItem[_DynamicConstants_DYN_BASE_DATA /* @min:%2ebaseData */] || {};
        baseData.startTime = new Date(hrTimeToMilliseconds(span.startTime));
        // Add dt extension to the telemetry item
        var ext = telemetryItem.ext = telemetryItem.ext || {};
        var dt = ext["dt"] = ext["dt"] || {};
        // Don't overwrite any existing values
        dt.spanId = dt.spanId || span[dist_es5_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]()[applicationinsights_web_dist_es5_DynamicConstants_DYN_SPAN_ID /* @min:%2espanId */];
        dt.traceId = dt.traceId || span[dist_es5_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]()[applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_ID /* @min:%2etraceId */];
        var traceFlags = span[dist_es5_DynamicConstants_DYN_SPAN_CONTEXT /* @min:%2espanContext */]()[applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
        if (!ts_utils_isNullOrUndefined(traceFlags)) {
            dt[applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = dt[applicationinsights_web_dist_es5_DynamicConstants_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] || traceFlags;
        }
        _populateTagsFromSpan(telemetryItem, span, contextKeys, core.config);
        _populatePropertiesFromAttributes(telemetryItem, contextKeys, container);
        var sampleRate = container.get("microsoft.sample_rate");
        if (!ts_utils_isNullOrUndefined(sampleRate)) {
            telemetryItem.sampleRate = Number(sampleRate);
        }
        // Azure SDK
        var azNamespace = container.get(AzResourceNamespace) || container.get(AzNamespace);
        if (azNamespace) {
            if (span[_DynamicConstants_DYN_KIND /* @min:%2ekind */] === 0 /* eOTelSpanKind.INTERNAL */) {
                baseData[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = "InProc" /* eDependencyTypes.InProc */ + " | " + azNamespace;
            }
            if (azNamespace === MicrosoftEventHub) {
                _parseEventHubSpan(telemetryItem, span);
            }
        }
    }
    return telemetryItem;
}
/**
 * Implementation of Mapping to Azure Monitor
 *
 * https://gist.github.com/lmolkova/e4215c0f44a49ef824983382762e6b92#mapping-to-azure-monitor-application-insights-telemetry
 * @internal
 */
function _parseEventHubSpan(telemetryItem, span) {
    var baseData = telemetryItem[_DynamicConstants_DYN_BASE_DATA /* @min:%2ebaseData */] = telemetryItem[_DynamicConstants_DYN_BASE_DATA /* @min:%2ebaseData */] || {};
    var container = span[_DYN_ATTRIB_CONTAINER /* @min:%2eattribContainer */] || attributeContainer_createAttributeContainer(span[dist_es5_DynamicConstants_DYN_ATTRIBUTES /* @min:%2eattributes */]);
    var namespace = container.get(AzResourceNamespace) || container.get(AzNamespace);
    var peerAddress = ts_utils_asString(container.get(SEMATTRS_NET_PEER_NAME) || container.get("peer.address") || "unknown").replace(/\/$/g, ""); // remove trailing "/"
    var messageBusDestination = (container.get(MessageBusDestination) || "unknown");
    var baseType = baseData[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] || "";
    var kind = span[_DynamicConstants_DYN_KIND /* @min:%2ekind */];
    if (kind === 2 /* eOTelSpanKind.CLIENT */) {
        baseType = namespace;
        baseData[_DYN_TARGET /* @min:%2etarget */] = peerAddress + "/" + messageBusDestination;
    }
    else if (kind === 3 /* eOTelSpanKind.PRODUCER */) {
        baseType = "Queue Message | " + namespace;
        baseData[_DYN_TARGET /* @min:%2etarget */] = peerAddress + "/" + messageBusDestination;
    }
    else if (kind === 4 /* eOTelSpanKind.CONSUMER */) {
        baseType = "Queue Message | " + namespace;
        baseData.source = peerAddress + "/" + messageBusDestination;
        var measurements = baseData.measurements = (baseData.measurements || {});
        var timeSinceEnqueued = container.get("timeSinceEnqueued");
        if (timeSinceEnqueued) {
            measurements[TIME_SINCE_ENQUEUED] = Number(timeSinceEnqueued);
        }
        else {
            var enqueuedTime = parseFloat(ts_utils_asString(container.get("enqueuedTime")));
            if (isNaN(enqueuedTime)) {
                enqueuedTime = 0;
            }
            measurements[TIME_SINCE_ENQUEUED] = hrTimeToMilliseconds(span.startTime) - enqueuedTime;
        }
    }
    baseData[dist_es5_DynamicConstants_DYN_TYPE /* @min:%2etype */] = baseType;
}
//# sourceMappingURL=spanUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@microsoft/applicationinsights-web/dist-es5/AISku.js
/*
 * Application Insights JavaScript SDK - Web, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var AISku_a, AISku_b, AISku_c;












var _internalSdkSrc;
var STR_DEPENDENCIES = "dependencies";
var AISku_STR_PROPERTIES = "properties";
var STR_SNIPPET_VERSION = "_snippetVersion";
var STR_APP_INSIGHTS_NEW = "appInsightsNew";
var STR_GET_SKU_DEFAULTS = "getSKUDefaults";
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    STR_SNIPPET, STR_DEPENDENCIES, AISku_STR_PROPERTIES, STR_SNIPPET_VERSION, STR_APP_INSIGHTS_NEW, STR_GET_SKU_DEFAULTS, "trace", "otelApi"
];
// This is an exclude list of properties that should not be proxied to the snippet
// They include a combination of private and internal property names
var _ignoreProxyAssignProperties = [
    STR_SNIPPET, STR_DEPENDENCIES, AISku_STR_PROPERTIES, STR_SNIPPET_VERSION, STR_APP_INSIGHTS_NEW, STR_GET_SKU_DEFAULTS
];
var IKEY_USAGE = "iKeyUsage";
var CDN_USAGE = "CdnUsage";
var SDK_LOADER_VER = "SdkLoaderVer";
var ZIP_PAYLOAD = "zipPayload";
var default_limit = {
    samplingRate: 100,
    maxSendNumber: 1
};
var default_interval = {
    monthInterval: 3,
    daysOfMonth: [28]
};
var default_throttle_config = {
    disabled: true,
    limit: cfgDfMerge(default_limit),
    interval: cfgDfMerge(default_interval)
};
// We need to include all properties that we only reference that we want to be dynamically updatable here
// So they are converted even when not specified in the passed configuration
var defaultConfigValues = {
    connectionString: dist_es5_InternalConstants_UNDEFINED_VALUE,
    endpointUrl: dist_es5_InternalConstants_UNDEFINED_VALUE,
    instrumentationKey: dist_es5_InternalConstants_UNDEFINED_VALUE,
    userOverrideEndpointUrl: dist_es5_InternalConstants_UNDEFINED_VALUE,
    diagnosticLogInterval: cfgDfValidate(_chkDiagLevel, 10000),
    featureOptIn: (AISku_a = {},
        AISku_a[IKEY_USAGE] = { mode: 3 /* FeatureOptInMode.enable */ },
        AISku_a[CDN_USAGE] = { mode: 2 /* FeatureOptInMode.disable */ },
        AISku_a[SDK_LOADER_VER] = { mode: 2 /* FeatureOptInMode.disable */ },
        AISku_a[ZIP_PAYLOAD] = { mode: 1 /* FeatureOptInMode.none */ },
        AISku_a),
    throttleMgrCfg: cfgDfMerge((AISku_b = {},
        AISku_b[109 /* _eInternalMessageId.DefaultThrottleMsgKey */] = cfgDfMerge(default_throttle_config),
        AISku_b[106 /* _eInternalMessageId.InstrumentationKeyDeprecation */] = cfgDfMerge(default_throttle_config),
        AISku_b[111 /* _eInternalMessageId.SdkLdrUpdate */] = cfgDfMerge(default_throttle_config),
        AISku_b[110 /* _eInternalMessageId.CdnDeprecation */] = cfgDfMerge(default_throttle_config),
        AISku_b)),
    extensionConfig: cfgDfMerge((AISku_c = {},
        AISku_c["AppInsightsCfgSyncPlugin"] = cfgDfMerge({
            cfgUrl: CONFIG_ENDPOINT_URL,
            syncMode: 2 /* ICfgSyncMode.Receive */
        }),
        AISku_c))
};
function _chkDiagLevel(value) {
    // Make sure we have a value > 0
    return value && value > 0;
}
function _parseCs(config, configCs) {
    return createSyncPromise(function (resolve, reject) {
        doAwaitResponse(configCs, function (res) {
            var curCs = res && res.value;
            var parsedCs = null;
            if (!res.rejected && curCs) {
                // replace cs with resolved values in case of circular promises
                config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */] = curCs;
                parsedCs = parseConnectionString(curCs);
            }
            // if can't resolve cs promise, null will be returned
            resolve(parsedCs);
        });
    });
}
function _initOTel(sku, traceName, onEnd, onException) {
    var otelApi = getDeferred(createOTelApi, [{
            host: sku
        }]);
    // Create the initial default traceProvider
    sku.core.setTraceProvider(getDeferred(function () {
        return createTraceProvider(sku, traceName, otelApi.v, onEnd, onException);
    }));
    return otelApi;
}
/**
 * Application Insights API
 * @group Entrypoint
 * @group Classes
 */
var AppInsightsSku = /** @class */ (function () {
    function AppInsightsSku(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        var _config;
        var _analyticsPlugin;
        var _cfgSyncPlugin;
        var _throttleMgr;
        var _iKeySentMessage;
        var _cdnSentMessage;
        var _sdkVerSentMessage;
        var _otelApi;
        dynamicProto(AppInsightsSku, this, function (_self) {
            _initDefaults();
            ts_utils_objDefine(_self, "config", {
                g: function () {
                    return _config;
                }
            });
            ts_utils_arrForEach(["pluginVersionStringArr", "pluginVersionString"], function (key) {
                ts_utils_objDefine(_self, key, {
                    g: function () {
                        if (_core) {
                            return _core[key];
                        }
                        return null;
                    }
                });
            });
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[_DYN_VERSION /* @min:%2eversion */] || "");
            snippet[_DYN_QUEUE /* @min:%2equeue */] = snippet[_DYN_QUEUE /* @min:%2equeue */] || [];
            snippet[_DYN_VERSION /* @min:%2eversion */] = snippet[_DYN_VERSION /* @min:%2eversion */] || 2.0; // Default to new version
            var cfgHandler = createDynamicConfig(snippet.config || {}, defaultConfigValues);
            _config = cfgHandler.cfg;
            _analyticsPlugin = new AnalyticsPlugin();
            ts_utils_objDefine(_self, "appInsights", {
                g: function () {
                    return _analyticsPlugin;
                }
            });
            properties = new dist_es5_PropertiesPlugin();
            dependencies = new AjaxMonitor();
            _sender = new Sender();
            _core = new AppInsightsCore();
            ts_utils_objDefine(_self, "core", {
                g: function () {
                    return _core;
                }
            });
            ts_utils_objDefine(_self, "otelApi", {
                g: function () {
                    return _otelApi ? _otelApi.v : null;
                }
            });
            ts_utils_objDefine(_self, "trace", {
                g: function () {
                    return _otelApi ? _otelApi.v.trace : null;
                }
            });
            // Will get recalled if any referenced values are changed
            _addUnloadHook(onConfigChange(cfgHandler, function () {
                var configCs = _config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */];
                if (ts_utils_isPromiseLike(configCs)) {
                    var ikeyPromise = createSyncPromise(function (resolve, reject) {
                        doAwaitResponse(_parseCs(_config, configCs), function (rsp) {
                            if (!rsp.rejected) {
                                var ikey = _config[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
                                var cs = rsp.value;
                                ikey = cs && cs.instrumentationkey || ikey;
                                resolve(ikey);
                            }
                            else {
                                // parseCs will always resolve(unless timeout)
                                // return null in case any error happens
                                resolve(null);
                            }
                        });
                    });
                    var url = _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */];
                    if (ts_utils_isNullOrUndefined(url)) {
                        url = createSyncPromise(function (resolve, reject) {
                            doAwaitResponse(_parseCs(_config, configCs), function (rsp) {
                                if (!rsp.rejected) {
                                    var url_1 = _config[_DynamicConstants_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */];
                                    var cs = rsp.value;
                                    var ingest = cs && cs.ingestionendpoint;
                                    url_1 = ingest ? ingest + DEFAULT_BREEZE_PATH : url_1;
                                    resolve(url_1);
                                }
                                else {
                                    // parseCs will always resolve(unless timeout)
                                    // return null in case any error happens
                                    resolve(null);
                                }
                            });
                        });
                    }
                    _config[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */] = ikeyPromise;
                    _config[_DynamicConstants_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */] = url;
                }
                if (ts_utils_isString(configCs) && configCs) {
                    // confirm if promiselike function present
                    // handle cs promise here
                    // add cases to oneNote
                    var cs = parseConnectionString(configCs);
                    var ingest = cs.ingestionendpoint;
                    _config.endpointUrl = _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] ? _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] : ingest + DEFAULT_BREEZE_PATH; // add /v2/track
                    _config[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */] = cs.instrumentationkey || _config[_DynamicConstants_DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */];
                }
                // userOverrideEndpointUrl have the highest priority
                _config.endpointUrl = _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] ? _config[_DYN_USER_OVERRIDE_ENDPOI0 /* @min:%2euserOverrideEndpointUrl */] : _config[_DynamicConstants_DYN_ENDPOINT_URL /* @min:%2eendpointUrl */];
            }));
            _self[STR_SNIPPET /* @min:%2esnippet */] = snippet;
            _self[STR_FLUSH /* @min:%2eflush */] = function (isAsync, callBack) {
                if (isAsync === void 0) { isAsync = true; }
                var result;
                doPerf(_core, function () { return "AISKU.flush"; }, function () {
                    if (isAsync && !callBack) {
                        result = createPromise(function (resolve) {
                            callBack = resolve;
                        });
                    }
                    var waiting = 1;
                    var flushDone = function () {
                        waiting--;
                        if (waiting === 0) {
                            callBack();
                        }
                    };
                    ts_utils_arrForEach(_core.getChannels(), function (channel) {
                        if (channel) {
                            waiting++;
                            channel[STR_FLUSH /* @min:%2eflush */](isAsync, flushDone);
                        }
                    });
                    // decrement the initial "waiting"
                    flushDone();
                }, null, isAsync);
                return result;
            };
            _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */] = function (isAsync) {
                if (isAsync === void 0) { isAsync = true; }
                ts_utils_arrForEach(_core.getChannels(), function (channel) {
                    if (channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]) {
                        channel[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */]();
                    }
                    else {
                        channel[STR_FLUSH /* @min:%2eflush */](isAsync);
                    }
                });
            };
            _self.loadAppInsights = function (legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) { legacyMode = false; }
                if (legacyMode) {
                    throwUnsupported("Legacy Mode is no longer supported");
                }
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!ts_utils_isNullOrUndefined(_snippetVersion)) {
                            snippetVer += _snippetVersion;
                        }
                        if (_self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */] && _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal) {
                            _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal.snippetVer = snippetVer || "-";
                        }
                        // apply updated properties to the global instance (snippet)
                        ts_utils_objForEachKey(_self, function (field, value) {
                            if (ts_utils_isString(field) &&
                                !ts_utils_isFunction(value) &&
                                field && field[0] !== "_" && // Don't copy "internal" values
                                ts_utils_arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
                                if (snippet[field] !== value) {
                                    snippet[field] = value;
                                }
                            }
                        });
                    }
                }
                doPerf(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
                    // initialize core
                    _core.initialize(_config, [_sender, properties, dependencies, _analyticsPlugin, _cfgSyncPlugin], logger, notificationManager);
                    // Initialize the initial OTel API
                    _otelApi = _initOTel(_self, "aisku", _onEnd, _onException);
                    ts_utils_objDefine(_self, "context", {
                        g: function () { return properties[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]; }
                    });
                    if (!_throttleMgr) {
                        _throttleMgr = new ThrottleMgr(_core);
                    }
                    var sdkSrc = _findSdkSourceFile();
                    if (sdkSrc && _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]) {
                        _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc = sdkSrc;
                    }
                    _updateSnippetProperties(_self[STR_SNIPPET /* @min:%2esnippet */]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[STR_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
                    _self[_DYN_ADD_HOUSEKEEPING_BEF1 /* @min:%2eaddHousekeepingBeforeUnload */](_self);
                    _addUnloadHook(onConfigChange(cfgHandler, function () {
                        var defaultEnable = false;
                        if (_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */]) {
                            defaultEnable = !_config.throttleMgrCfg[109 /* _eInternalMessageId.DefaultThrottleMsgKey */].disabled;
                        }
                        if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) {
                            // set ready state to true will automatically trigger flush()
                            _throttleMgr.onReadyState(true);
                        }
                        if (!_iKeySentMessage && !_config[_DYN_CONNECTION_STRING /* @min:%2econnectionString */] && isFeatureEnabled(IKEY_USAGE, _config, true)) {
                            _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](106 /* _eInternalMessageId.InstrumentationKeyDeprecation */, "See Instrumentation key support at aka.ms/IkeyMigrate");
                            _iKeySentMessage = true;
                        }
                        if (!_cdnSentMessage && _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc && _self[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */].internal.sdkSrc.indexOf("az416426") != -1 && isFeatureEnabled(CDN_USAGE, _config, true)) {
                            _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](110 /* _eInternalMessageId.CdnDeprecation */, "See Cdn support notice at aka.ms/JsActiveCdn");
                            _cdnSentMessage = true;
                        }
                        if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && isFeatureEnabled(SDK_LOADER_VER, _config, true)) {
                            _throttleMgr[_DYN_SEND_MESSAGE /* @min:%2esendMessage */](111 /* _eInternalMessageId.SdkLdrUpdate */, "An updated Sdk Loader is available, see aka.ms/SnippetVer");
                            _sdkVerSentMessage = true;
                        }
                    }));
                });
                return _self;
            };
            _self[_DYN_UPDATE_SNIPPET_DEFIN2 /* @min:%2eupdateSnippetDefinitions */] = function (snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                proxyAssign(snippet, _self, function (name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && ts_utils_arrIndexOf(_ignoreProxyAssignProperties, name) === -1;
                });
            };
            _self.emptyQueue = function () {
                // call functions that were queued before the main script was loaded
                try {
                    if (ts_utils_isArray(_self.snippet[_DYN_QUEUE /* @min:%2equeue */])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[_DYN_QUEUE /* @min:%2equeue */].length;
                        for (var i = 0; i < length_1; i++) {
                            var call = _self.snippet[_DYN_QUEUE /* @min:%2equeue */][i];
                            call();
                        }
                        _self.snippet[_DYN_QUEUE /* @min:%2equeue */] = undefined;
                        delete _self.snippet[_DYN_QUEUE /* @min:%2equeue */];
                    }
                }
                catch (exception) {
                    var properties_1 = {};
                    if (exception && ts_utils_isFunction(exception.toString)) {
                        properties_1.exception = exception.toString();
                    }
                    // need from core
                    // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                    //     eLoggingSeverity.WARNING,
                    //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                    //     "Failed to send queued telemetry",
                    //     properties);
                }
            };
            _self[_DYN_ADD_HOUSEKEEPING_BEF1 /* @min:%2eaddHousekeepingBeforeUnload */] = function (appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if (hasWindow() || hasDocument()) {
                    var performHousekeeping_1 = function () {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if (ts_utils_isFunction(_self.core[STR_GET_PLUGIN /* @min:%2egetPlugin */])) {
                            var loadedPlugin = _this.core[STR_GET_PLUGIN /* @min:%2egetPlugin */](PropertiesPluginIdentifier);
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */] && propertiesPlugin[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]._sessionManager) {
                                    propertiesPlugin[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */]._sessionManager.backup();
                                }
                            }
                        }
                    };
                    var added_1 = false;
                    if (!_houseKeepingNamespace) {
                        _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */] && _core[STR_EVT_NAMESPACE /* @min:%2eevtNamespace */]());
                    }
                    // Will be recalled if any referenced config properties change
                    _addUnloadHook(onConfigChange(_config, function (details) {
                        var coreConfig = details.cfg;
                        var analyticsPlugin = appInsightsInstance.appInsights;
                        var ctx = createProcessTelemetryContext(null, coreConfig, analyticsPlugin.core);
                        var extConfig = ctx.getExtCfg(analyticsPlugin.identifier || AnalyticsPluginIdentifier);
                        // As we could get recalled, remove any previously registered event handlers first
                        _removePageEventHandlers();
                        var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
                        if (!extConfig.disableFlushOnBeforeUnload) {
                            // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                            // As just hooking the window does not always fire (on chrome) for page navigation's.
                            if (addPageUnloadEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added_1 = true;
                            }
                            // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                            if (addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                                added_1 = true;
                            }
                            // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                            // log the failure in this case
                            if (!added_1 && !isReactNative()) {
                                _throwInternal(_core[_DynamicConstants_DYN_LOGGER /* @min:%2elogger */], 1 /* eLoggingSeverity.CRITICAL */, 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */, "Could not add handler for beforeunload and pagehide");
                            }
                        }
                        if (!added_1 && !extConfig.disableFlushOnUnload) {
                            // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                            addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
                        }
                    }));
                }
            };
            _self.getSender = function () {
                return _sender;
            };
            _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                var unloadDone = false;
                var result;
                if (isAsync !== false && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                function _unloadCallback(unloadState) {
                    if (!unloadDone) {
                        unloadDone = true;
                        // Reset OTel API to clean up all trace state before unloading core
                        if (_core) {
                            // Clear the trace provider to stop any active spans
                            _core.setTraceProvider(null);
                            // Reset the OTel API instances - this will be recreated on next init
                            if (_otelApi) {
                                _otelApi.v.shutdown();
                            }
                            _otelApi = null;
                        }
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    }
                }
                _self[_DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */](isAsync);
                _removePageEventHandlers();
                _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
                return result;
            };
            proxyFunctions(_self, _analyticsPlugin, [
                STR_GET_COOKIE_MGR,
                STR_TRACK_EVENT,
                STR_TRACK_PAGE_VIEW,
                "trackPageViewPerformance",
                STR_TRACK_EXCEPTION,
                "_onerror",
                STR_TRACK_TRACE,
                STR_TRACK_METRIC,
                STR_START_TRACK_PAGE,
                STR_STOP_TRACK_PAGE,
                STR_START_TRACK_EVENT,
                STR_STOP_TRACK_EVENT
            ]);
            proxyFunctions(_self, _getCurrentDependencies, [
                STR_TRACK_DEPENDENCY_DATA,
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            proxyFunctions(_self, _core, [
                STR_ADD_TELEMETRY_INITIALIZER,
                STR_POLL_INTERNAL_LOGS,
                "stopPollingInternalLogs",
                STR_GET_PLUGIN,
                "addPlugin",
                STR_EVT_NAMESPACE,
                "addUnloadCb",
                "updateCfg",
                "onCfgChange",
                // ITraceHost Proxy
                "getTraceCtx",
                "setTraceCtx",
                "startSpan",
                "getActiveSpan",
                "setActiveSpan",
                "setTraceProvider",
                "getTraceProvider"
            ]);
            proxyFunctions(_self, function () {
                var context = properties[_DynamicConstants_DYN_CONTEXT /* @min:%2econtext */];
                return context ? context.user : null;
            }, [
                STR_SET_AUTHENTICATED_USER_CONTEXT,
                STR_CLEAR_AUTHENTICATED_USER_CONTEXT
            ]);
            // Handle span end event - create telemetry from span data
            function _onEnd(span) {
                if (_otelApi && span && span.isRecording() && !_otelApi.v.cfg.traceCfg.suppressTracing) {
                    // Flip this span to be the "current" span during processing, so any telemetry created during the span processing
                    // is associated with this span
                    useSpan(_core, span, function () {
                        try {
                            // Create trace telemetry for the span
                            var telemetryItem = createTelemetryItemFromSpan(_core, span);
                            if (telemetryItem) {
                                _self.core.track(telemetryItem);
                            }
                        }
                        catch (error) {
                            // Log any errors during trace processing but don't let them break the span lifecycle
                            _throwInternal(_core[_DynamicConstants_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Error processing span - " + ts_utils_dumpObj(error));
                        }
                    });
                }
            }
            function _onException(span, exception, time) {
                if (_otelApi) {
                    // Flip this span to be the "current" span during processing, so any telemetry created during the span processing
                    useSpan(_core, span, function () {
                        try {
                            _self[STR_TRACK_EXCEPTION /* @min:%2etrackException */]({
                                exception: exception,
                                properties: {
                                    time: time
                                }
                            });
                        }
                        catch (error) {
                            // Log any errors during exception processing but don't let them break the span lifecycle
                            _throwInternal(_core[_DynamicConstants_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Error processing exception - " + ts_utils_dumpObj(error));
                        }
                    });
                }
            }
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = DataCacheHelper_createUniqueNamespace("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
                _throttleMgr = null;
                _iKeySentMessage = false;
                _cdnSentMessage = false;
                _sdkVerSentMessage = false;
                _cfgSyncPlugin = new CfgSyncPlugin();
            }
            function _removePageEventHandlers() {
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    removePageUnloadEventListener(null, _houseKeepingNamespace);
                    removePageHideEventListener(null, _houseKeepingNamespace);
                }
            }
            function _addUnloadHook(hooks) {
                _core.addUnloadHook(hooks);
            }
        });
    }
    // Analytics Plugin
// Removed Stub for AppInsightsSku.prototype.getCookieMgr.
// Removed Stub for AppInsightsSku.prototype.trackEvent.
// Removed Stub for AppInsightsSku.prototype.trackPageView.
// Removed Stub for AppInsightsSku.prototype.trackPageViewPerformance.
// Removed Stub for AppInsightsSku.prototype.trackException.
// Removed Stub for AppInsightsSku.prototype._onerror.
// Removed Stub for AppInsightsSku.prototype.trackTrace.
// Removed Stub for AppInsightsSku.prototype.trackMetric.
// Removed Stub for AppInsightsSku.prototype.startTrackPage.
// Removed Stub for AppInsightsSku.prototype.stopTrackPage.
// Removed Stub for AppInsightsSku.prototype.startTrackEvent.
// Removed Stub for AppInsightsSku.prototype.stopTrackEvent.
// Removed Stub for AppInsightsSku.prototype.addTelemetryInitializer.
    // Properties Plugin
// Removed Stub for AppInsightsSku.prototype.setAuthenticatedUserContext.
// Removed Stub for AppInsightsSku.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
// Removed Stub for AppInsightsSku.prototype.trackDependencyData.
    // Misc
// Removed Stub for AppInsightsSku.prototype.flush.
// Removed Stub for AppInsightsSku.prototype.onunloadFlush.
// Removed Stub for AppInsightsSku.prototype.loadAppInsights.
// Removed Stub for AppInsightsSku.prototype.updateSnippetDefinitions.
// Removed Stub for AppInsightsSku.prototype.emptyQueue.
// Removed Stub for AppInsightsSku.prototype.pollInternalLogs.
// Removed Stub for AppInsightsSku.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsSku.prototype.addHousekeepingBeforeUnload.
// Removed Stub for AppInsightsSku.prototype.getSender.
// Removed Stub for AppInsightsSku.prototype.unload.
// Removed Stub for AppInsightsSku.prototype.getPlugin.
// Removed Stub for AppInsightsSku.prototype.addPlugin.
// Removed Stub for AppInsightsSku.prototype.updateCfg.
// Removed Stub for AppInsightsSku.prototype.evtNamespace.
// Removed Stub for AppInsightsSku.prototype.addUnloadCb.
// Removed Stub for AppInsightsSku.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AppInsightsSku.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AppInsightsSku.prototype.getTraceCtx.
// Removed Stub for AppInsightsSku.prototype.setTraceCtx.
// Removed Stub for AppInsightsSku.prototype.onCfgChange.
// Removed Stub for AppInsightsSku.prototype.startSpan.
// Removed Stub for AppInsightsSku.prototype.getActiveSpan.
// Removed Stub for AppInsightsSku.prototype.setActiveSpan.
// Removed Stub for AppInsightsSku.prototype.setTraceProvider.
// Removed Stub for AppInsightsSku.prototype.getTraceProvider.
    return AppInsightsSku;
}());

// tslint:disable-next-line
function _findSdkSourceFile() {
    if (_internalSdkSrc) {
        // Use the cached value
        return _internalSdkSrc;
    }
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) {
            sdkSrc = scrpt.src;
            // } else {
            //     // We need to update to at least typescript 2.9 for this to work :-(
            //     // Leaving as a stub for now so after we upgrade this breadcrumb is available
            //     let meta = import.meta;
            //     sdkSrc = (meta || {}).url;
            //     isModule = true;
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url_2 = sdkSrc.toLowerCase();
            if (url_2) {
                var src_1 = "";
                ts_utils_arrForEach(cdns, function (value, idx) {
                    if (ts_utils_strIndexOf(url_2, value) !== -1) {
                        src_1 = "cdn" + (idx + 1);
                        if (ts_utils_strIndexOf(url_2, "/scripts/") === -1) {
                            if (ts_utils_strIndexOf(url_2, "/next/") !== -1) {
                                src_1 += "-next";
                            }
                            else if (ts_utils_strIndexOf(url_2, "/beta/") !== -1) {
                                src_1 += "-beta";
                            }
                        }
                        _internalSdkSrc = src_1 + (isModule ? ".mod" : "");
                        return -1;
                    }
                });
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
        // Cache the found value so we don't have to look it up again
        _internalSdkSrc = sdkSrc;
    }
    return _internalSdkSrc;
}
//# sourceMappingURL=AISku.js.map
;// CONCATENATED MODULE: ./utils/appInsights.js
/* provided dependency */ var appInsights_process = __webpack_require__(34155);
/**
 * Azure Application Insights Integration - Logging Only
 */ 
let appInsights = null;
const currentPageViewId = "";
const enableCorsCorrelation = appInsights_process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_ENABLE_CORS_CORRELATION === "true";
// Helper function to safely access window object
const appInsights_getWindow = ()=>{
    if (false) {}
    return window;
};
/**
 * Initialize Azure Application Insights
 * @param {string} connectionString - The Application Insights connection string
 * @return {ApplicationInsights} - The initialized AppInsights instance
 */ function initAppInsights(connectionString) {
    if (appInsights) {
        return appInsights;
    }
    if (!connectionString) {
        console.error("Application Insights: Connection string is required");
        return null;
    }
    try {
        appInsights = new AppInsightsSku({
            config: {
                connectionString: connectionString,
                enableAutoRouteTracking: false,
                enableCorsCorrelation,
                enableRequestHeaderTracking: false,
                enableResponseHeaderTracking: false,
                disableFetchTracking: false,
                enableAjaxPerfTracking: false,
                maxBatchInterval: 15000,
                disableFlushOnBeforeUnload: false,
                enableDebug: false,
                autoTrackPageVisitTime: false
            }
        });
        // Initialize the SDK
        appInsights.loadAppInsights();
        const window1 = appInsights_getWindow();
        if (window1) {
            window1.addEventListener("beforeunload", ()=>{
                appInsights.flush();
            });
        }
        return appInsights;
    } catch (error) {
        console.error("Application Insights: Initialization failed", error);
        return null;
    }
}
/**
 * Get the Application Insights instance
 * @return {ApplicationInsights|null}
 */ function getAppInsights() {
    return appInsights;
}
/**
 * Get current page view ID for correlation
 * @return {string}
 */ function getCurrentPageViewId() {
    return currentPageViewId;
}


/***/ }),

/***/ 11763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ deleteFromCart; },
/* harmony export */   "K5": function() { return /* binding */ getStock; },
/* harmony export */   "NS": function() { return /* binding */ setCartLandingPagePath; },
/* harmony export */   "PW": function() { return /* binding */ getQuantityCount; },
/* harmony export */   "Uo": function() { return /* binding */ getCartIdParams; },
/* harmony export */   "VN": function() { return /* binding */ setCustomerCartId; },
/* harmony export */   "Xw": function() { return /* binding */ getAriaLabel; },
/* harmony export */   "c0": function() { return /* binding */ getCartCount; },
/* harmony export */   "dZ": function() { return /* binding */ getCartLandingPagePath; },
/* harmony export */   "w$": function() { return /* binding */ removeCustomerCartId; }
/* harmony export */ });
/* unused harmony exports getCustomerCartId, getCartPagePath */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97433);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);







const getStock = async function(sku) {
    let returnObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    try {
        var ref;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getStockEndPoint, "/?sku=").concat(sku));
        const { data: { results =[]  } = {}  } = response || {};
        var ref1;
        const stock = (ref1 = (ref = results[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
        return {
            results,
            stock
        };
    } catch (e) {
        return {
            stock: 1,
            isError: true,
            results: [
                {
                    availableQuantity: 1,
                    key: "OMS-US",
                    sku
                }
            ]
        };
    }
};
const getQuantityCount = (data)=>{
    if (!(data && data.length)) return 0;
    const totalCount = data && data.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).reduce((accumulator, item)=>{
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const getCartCount = ()=>{
    var ref;
    var ref1;
    const { cartCount  } = (ref1 = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.cart) !== null && ref1 !== void 0 ? ref1 : 0;
    return cartCount;
};
const getAriaLabel = (t, cartCount)=>{
    const ariaLabel = cartCount > 1 ? t("kf.minicart.aria.label.cartItems", {
        count: cartCount
    }) : t("kf.minicart.aria.label.cartItem", {
        count: cartCount
    });
    return ariaLabel;
};
const setCartLandingPagePath = async ()=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const cartLandingUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.cartLandingPagePath", "/"));
    _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCartUrl */ .xA)(cartLandingUrl));
};
const getCartLandingPagePath = async ()=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const cartLandingUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.cartLandingPagePath", "/"));
    return cartLandingUrl;
};
const getCartPagePath = ()=>{
    let path = "/";
    path = getCartLandingPagePath().then((res)=>{
        return res;
    });
    return path;
};
const getCustomerCartId = ()=>{
    return localStorage.getItem("customerCartId");
};
const setCustomerCartId = (item)=>{
    localStorage.setItem("customerCartId", item);
};
const removeCustomerCartId = ()=>{
    localStorage.removeItem("customerCartId");
};
const getCartIdParams = (isSubmit)=>{
    const { auth: { user: { koc: isIscUser  } = {}  } = {} , cart: { cart: { id =""  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState();
    const customerCartId = getCustomerCartId();
    const cartId = isIscUser && customerCartId ? "&cartId=".concat(customerCartId) : "";
    const cartIdQuery = isIscUser && customerCartId ? "?cartId=".concat(customerCartId) : isSubmit ? "?cartId=".concat(id) : "";
    const activeCartId = isIscUser && customerCartId ? customerCartId : id;
    return {
        cartId,
        cartIdQuery,
        activeCartId
    };
};
const deleteFromCart = async (cb)=>{
    await _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .deleteCart */ .al)()).unwrap().then((res)=>{
        if (res) {
            cb && cb("success", null, res ? res : {});
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCart */ .RV)({
                lineItems: []
            }));
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setNoshipping */ .qT)([]));
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCartCount */ .oJ)(0));
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setShipping */ .YO)([]));
            const cartPayload = {
                currency: "USD",
                taxMode: "ExternalAmount"
            };
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .createCart */ .Bk)(cartPayload));
        }
    }).catch(()=>{
        cb && cb("failure", "failed to empty your cart.");
    });
};



/***/ }),

/***/ 64443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EE": function() { return /* binding */ addToDate; },
  "p6": function() { return /* binding */ formatDate; },
  "M": function() { return /* binding */ fromUnixTimestamp; },
  "Ux": function() { return /* binding */ getCurrentDate; },
  "K9": function() { return /* binding */ getUnixTimestamp; },
  "fT": function() { return /* binding */ isAfterDate; },
  "gO": function() { return /* binding */ isBeforeDate; },
  "AO": function() { return /* binding */ isValidDateValue; },
  "sG": function() { return /* binding */ dateHelper_parseDate; },
  "wD": function() { return /* binding */ subtractFromDate; },
  "Y6": function() { return /* binding */ toISOString; }
});

// UNUSED EXPORTS: DATE_FORMATS, momentCompatible

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

// EXTERNAL MODULE: ./node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(37238);
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

// EXTERNAL MODULE: ./node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(65580);
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/localize.mjs


const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = {
  ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

// EXTERNAL MODULE: ./node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(95021);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(6898);
;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ./node_modules/date-fns/locale/en-US.mjs






/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var en_US = ((/* unused pure expression or super */ null && (enUS)));

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/defaultOptions.mjs
let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/constants.mjs
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
const daysInWeek = 7;

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = 365.2425;

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "./constants/date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "./constants/date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
const minTime = -maxTime;

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = 3600000;

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = 1000;

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
const minutesInYear = 525600;

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
const minutesInMonth = 43200;

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
const minutesInDay = 1440;

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
const minutesInHour = 60;

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
const monthsInQuarter = 3;

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
const monthsInYear = 12;

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
const quartersInYear = 4;

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = 3600;

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
const secondsInMinute = 60;

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = secondsInHour * 24;

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
const secondsInWeek = secondsInDay * 7;

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = secondsInDay * daysInYear;

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = secondsInYear / 12;

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
const secondsInQuarter = secondsInMonth * 3;

// EXTERNAL MODULE: ./node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(45459);
// EXTERNAL MODULE: ./node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(32841);
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.mjs


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/differenceInCalendarDays.mjs




/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = (0,startOfDay/* startOfDay */.b)(dateLeft);
  const startOfDayRight = (0,startOfDay/* startOfDay */.b)(dateRight);

  const timestampLeft =
    +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight =
    +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_differenceInCalendarDays = ((/* unused pure expression or super */ null && (differenceInCalendarDays)));

;// CONCATENATED MODULE: ./node_modules/date-fns/constructFrom.mjs
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_constructFrom = ((/* unused pure expression or super */ null && (constructFrom)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfYear.mjs



/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = (0,toDate/* toDate */.Q)(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfYear = ((/* unused pure expression or super */ null && (startOfYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getDayOfYear.mjs




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getDayOfYear = ((/* unused pure expression or super */ null && (getDayOfYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfWeek.mjs



/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = getDefaultOptions();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0,toDate/* toDate */.Q)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeek = ((/* unused pure expression or super */ null && (startOfWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfISOWeek.mjs


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeek = ((/* unused pure expression or super */ null && (startOfISOWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getISOWeekYear.mjs




/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeekYear = ((/* unused pure expression or super */ null && (getISOWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfISOWeekYear.mjs




/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeekYear = ((/* unused pure expression or super */ null && (startOfISOWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getISOWeek.mjs





/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeek = ((/* unused pure expression or super */ null && (getISOWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getWeekYear.mjs





/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const year = _date.getFullYear();

  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeekYear = ((/* unused pure expression or super */ null && (getWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/startOfWeekYear.mjs





/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeekYear = ((/* unused pure expression or super */ null && (startOfWeekYear)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getWeek.mjs





/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeek = ((/* unused pure expression or super */ null && (getWeek)));

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/addLeadingZeros.mjs
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/lightFormatters.mjs


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/formatters.mjs








const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/format/longFormatters.mjs
const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/protectedTokens.mjs
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

;// CONCATENATED MODULE: ./node_modules/date-fns/isDate.mjs
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isDate = ((/* unused pure expression or super */ null && (isDate)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isValid.mjs



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0,toDate/* toDate */.Q)(date);
  return !isNaN(Number(_date));
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isValid = ((/* unused pure expression or super */ null && (isValid)));

;// CONCATENATED MODULE: ./node_modules/date-fns/format.mjs








// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874


// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;



/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = (0,toDate/* toDate */.Q)(date);

  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          isProtectedWeekYearToken(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_format = ((/* unused pure expression or super */ null && (format)));

;// CONCATENATED MODULE: ./node_modules/date-fns/fromUnixTime.mjs


/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */
function fromUnixTime(unixTime) {
  return (0,toDate/* toDate */.Q)(unixTime * 1000);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_fromUnixTime = ((/* unused pure expression or super */ null && (fromUnixTime)));

;// CONCATENATED MODULE: ./node_modules/date-fns/parseISO.mjs


/**
 * The {@link parseISO} function options.
 */

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);

  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const timestamp = date.getTime();
  let time = 0;
  let offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    // JS parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    const result = new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate(),
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}

const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};

const dateRegex =
  /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex =
  /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length,
      );
    }
  }

  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" +
      (4 + additionalDigits) +
      "})|(\\d{2}|[+-]\\d{" +
      (2 + additionalDigits) +
      "})$)",
  );

  const captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return { year: NaN, restDateString: "" };

  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);

  const captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);

  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (
      !validateDate(year, month, day) ||
      !validateDayOfYearDate(year, dayOfYear)
    ) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return (
    hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000
  );
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(",", "."))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;

  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;

  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return (
    month >= 0 &&
    month <= 11 &&
    date >= 1 &&
    date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28))
  );
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return (
    seconds >= 0 &&
    seconds < 60 &&
    minutes >= 0 &&
    minutes < 60 &&
    hours >= 0 &&
    hours < 25
  );
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_parseISO = ((/* unused pure expression or super */ null && (parseISO)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addMilliseconds.mjs



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(date, amount) {
  const timestamp = +(0,toDate/* toDate */.Q)(date);
  return constructFrom(date, timestamp + amount);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addMilliseconds = ((/* unused pure expression or super */ null && (addMilliseconds)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addMinutes.mjs



/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addMinutes = ((/* unused pure expression or super */ null && (addMinutes)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addMonths.mjs



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = (0,toDate/* toDate */.Q)(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addMonths = ((/* unused pure expression or super */ null && (addMonths)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addYears.mjs


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addYears = ((/* unused pure expression or super */ null && (addYears)));

;// CONCATENATED MODULE: ./node_modules/date-fns/addSeconds.mjs


/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds(date, amount) {
  return addMilliseconds(date, amount * 1000);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addSeconds = ((/* unused pure expression or super */ null && (addSeconds)));

;// CONCATENATED MODULE: ./node_modules/date-fns/subSeconds.mjs


/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds(date, amount) {
  return addSeconds(date, -amount);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_subSeconds = ((/* unused pure expression or super */ null && (subSeconds)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isBefore.mjs


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const _dateToCompare = (0,toDate/* toDate */.Q)(dateToCompare);
  return +_date < +_dateToCompare;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isBefore = ((/* unused pure expression or super */ null && (isBefore)));

;// CONCATENATED MODULE: ./node_modules/date-fns/isAfter.mjs


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const _dateToCompare = (0,toDate/* toDate */.Q)(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isAfter = ((/* unused pure expression or super */ null && (isAfter)));

;// CONCATENATED MODULE: ./node_modules/date-fns/getUnixTime.mjs


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(date) {
  return Math.trunc(+(0,toDate/* toDate */.Q)(date) / 1000);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getUnixTime = ((/* unused pure expression or super */ null && (getUnixTime)));

;// CONCATENATED MODULE: ./utils/dateHelper.js
/**
 * Date utility functions using date-fns as replacement for moment.js
 * This file provides a centralized way to handle date operations
 */ 
/**
 * Format date to string
 * @param {Date|string|number} date - Date to format
 * @param {string} formatString - Format pattern
 * @return {string} Formatted date string
 */ const formatDate = function(date) {
    let formatString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "MM/dd/yyyy";
    try {
        const dateObj = dateHelper_parseDate(date);
        if (!dateObj) return "";
        return format(dateObj, formatString);
    } catch (error) {
        console.warn("formatDate error:", error);
        return "";
    }
};
/**
 * Parse various date formats to Date object
 * @param {Date|string|number} date - Date to parse
 * @return {Date|null} Parsed date or null if invalid
 */ const dateHelper_parseDate = (date)=>{
    if (!date) return null;
    if (date instanceof Date) {
        return isValid(date) ? date : null;
    }
    if (typeof date === "number") {
        return fromUnixTime(date);
    }
    if (typeof date === "string") {
        // Try parsing ISO string first
        const isoDate = parseISO(date);
        if (isValid(isoDate)) return isoDate;
        // Try parsing as regular date string
        const parsedDate = new Date(date);
        if (isValid(parsedDate)) return parsedDate;
    }
    return null;
};
/**
 * Add time to date
 * @param {Date|string} date - Base date
 * @param {number} amount - Amount to add
 * @param {string} unit - Unit ('minutes', 'months', 'years', etc.)
 * @return {Date|null} New date with added time
 */ const addToDate = (date, amount, unit)=>{
    const dateObj = dateHelper_parseDate(date);
    if (!dateObj) return null;
    switch(unit){
        case "minutes":
        case "minute":
        case "m":
            return addMinutes(dateObj, amount);
        case "months":
        case "month":
        case "M":
            return addMonths(dateObj, amount);
        case "years":
        case "year":
        case "y":
            return addYears(dateObj, amount);
        case "seconds":
        case "second":
        case "s":
            return addSeconds(dateObj, amount);
        default:
            console.warn("Unsupported unit: ".concat(unit));
            return dateObj;
    }
};
/**
 * Subtract time from date
 * @param {Date|string} date - Base date
 * @param {number} amount - Amount to subtract
 * @param {string} unit - Unit ('seconds', etc.)
 * @return {Date|null} New date with subtracted time
 */ const subtractFromDate = (date, amount, unit)=>{
    const dateObj = dateHelper_parseDate(date);
    if (!dateObj) return null;
    switch(unit){
        case "seconds":
        case "second":
        case "s":
            return subSeconds(dateObj, amount);
        default:
            // For other units, use negative addition
            return addToDate(date, -amount, unit);
    }
};
/**
 * Check if date1 is before date2
 * @param {Date|string} date1 - First date
 * @param {Date|string} date2 - Second date
 * @return {boolean} True if date1 is before date2
 */ const isBeforeDate = (date1, date2)=>{
    const d1 = dateHelper_parseDate(date1);
    const d2 = dateHelper_parseDate(date2);
    if (!d1 || !d2) return false;
    return isBefore(d1, d2);
};
/**
 * Check if date1 is after date2
 * @param {Date|string} date1 - First date
 * @param {Date|string} date2 - Second date
 * @return {boolean} True if date1 is after date2
 */ const isAfterDate = (date1, date2)=>{
    const d1 = dateHelper_parseDate(date1);
    const d2 = dateHelper_parseDate(date2);
    if (!d1 || !d2) return false;
    return isAfter(d1, d2);
};
/**
 * Get Unix timestamp from date
 * @param {Date|string} date - Date to convert
 * @return {number} Unix timestamp
 */ const getUnixTimestamp = (date)=>{
    const dateObj = dateHelper_parseDate(date);
    if (!dateObj) return 0;
    return getUnixTime(dateObj);
};
/**
 * Create date from Unix timestamp
 * @param {number} timestamp - Unix timestamp
 * @return {Date} Date object
 */ const fromUnixTimestamp = (timestamp)=>{
    return fromUnixTime(timestamp);
};
/**
 * Check if date is valid
 * @param {any} date - Date to validate
 * @return {boolean} True if valid date
 */ const isValidDateValue = (date)=>{
    const dateObj = dateHelper_parseDate(date);
    return dateObj !== null && isValid(dateObj);
};
/**
 * Get current date
 * @return {Date} Current date
 */ const getCurrentDate = ()=>{
    return new Date();
};
/**
 * Convert date to ISO string with timezone
 * @param {Date|string} date - Date to convert
 * @param {boolean} keepOffset - Whether to keep timezone offset
 * @return {string} ISO string
 */ const toISOString = function(date) {
    let keepOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const dateObj = dateHelper_parseDate(date);
    if (!dateObj) return "";
    if (keepOffset) {
        return dateObj.toISOString();
    }
    return dateObj.toISOString();
};
// Common date format patterns used in the codebase
const DATE_FORMATS = {
    MM_DD_YYYY: "MM/dd/yyyy",
    YYYY_MM_DD: "yyyy-MM-dd",
    LL: "MMM d, yyyy",
    LONG_DATE: "MMMM d, yyyy"
};
// Migration helpers - these functions provide moment.js-like API
const momentCompatible = {
    /**
   * Moment-like constructor
   * @param {Date|string|number} date - Date to parse
   * @return {Object} Object with moment-like methods
   */ moment: (date)=>{
        const dateObj = dateHelper_parseDate(date) || getCurrentDate();
        return {
            format: (formatString)=>formatDate(dateObj, formatString),
            add: (amount, unit)=>momentCompatible.moment(addToDate(dateObj, amount, unit)),
            subtract: (amount, unit)=>momentCompatible.moment(subtractFromDate(dateObj, amount, unit)),
            isBefore: (otherDate)=>isBeforeDate(dateObj, otherDate),
            isAfter: (otherDate)=>isAfterDate(dateObj, otherDate),
            unix: ()=>getUnixTimestamp(dateObj),
            toISOString: (keepOffset)=>toISOString(dateObj, keepOffset),
            isValid: ()=>isValidDateValue(dateObj),
            toDate: ()=>dateObj
        };
    },
    /**
   * Create moment from unix timestamp
   * @param {number} timestamp - Unix timestamp
   * @return {Object} Moment-like object
   */ unix: (timestamp)=>{
        return momentCompatible.moment(fromUnixTimestamp(timestamp));
    }
};


/***/ }),

/***/ 55760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i6z": function() { return /* binding */ addADALink; },
  "dVG": function() { return /* binding */ addMavenoidChat; },
  "iZV": function() { return /* binding */ addMediaToFavorites; },
  "igK": function() { return /* binding */ addPageLoadAnalyticsEvent; },
  "R$3": function() { return /* binding */ addToRecentSearch; },
  "gP3": function() { return /* binding */ addToRecentlyViewed; },
  "QCk": function() { return /* binding */ appendPresetToUrl; },
  "RpN": function() { return /* binding */ arrayMove; },
  "s80": function() { return /* binding */ caesarDecrypt; },
  "DpP": function() { return /* binding */ calculateCartData; },
  "MyB": function() { return /* binding */ capitalizeFirstName; },
  "pJD": function() { return /* binding */ checkAlphabetOnly; },
  "ytv": function() { return /* binding */ checkAlphanumeric; },
  "KzD": function() { return /* binding */ checkCartStock; },
  "Oh7": function() { return /* binding */ checkIfImageExists; },
  "yNA": function() { return /* binding */ checkIfUserExists; },
  "GsT": function() { return /* binding */ checkIsFavorite; },
  "yyd": function() { return /* binding */ checkStock; },
  "FV": function() { return /* binding */ cleanText; },
  "loo": function() { return /* binding */ clearAnonymousToken; },
  "RnQ": function() { return /* binding */ clearAuthToken; },
  "TaE": function() { return /* binding */ closeCompareProductView; },
  "u8D": function() { return /* binding */ closeModalAnalytics; },
  "mUs": function() { return /* binding */ convertStringToBoolean; },
  "ZT_": function() { return /* binding */ createIdFromString; },
  "g45": function() { return /* binding */ createPersonaCookie; },
  "pMF": function() { return /* binding */ customSanitizeInnerHtml; },
  "DsO": function() { return /* binding */ debounce; },
  "qOB": function() { return /* binding */ decodeHtmlCharacters; },
  "LY3": function() { return /* binding */ destructureAddress; },
  "vIr": function() { return /* binding */ downloadArticle; },
  "Uni": function() { return /* binding */ extractPhoneNumber; },
  "CZn": function() { return /* binding */ extractScriptsFromDOM; },
  "LjD": function() { return /* binding */ filterBackEndJson; },
  "p6d": function() { return /* binding */ formatDate; },
  "n4H": function() { return /* binding */ formatFacetName; },
  "fSM": function() { return /* binding */ formatOfflineRegisterPropsData; },
  "Oyq": function() { return /* binding */ formatOnlineRegisterPropsData; },
  "unW": function() { return /* binding */ formatPhoneNumber; },
  "NO1": function() { return /* binding */ formatPriceRange; },
  "V08": function() { return /* binding */ formatRegistrationSuveryPropsData; },
  "NpZ": function() { return /* binding */ geMonthNameDayandYear; },
  "hPi": function() { return /* binding */ getAccessToken; },
  "ud4": function() { return /* binding */ getAllFilterQueries; },
  "Szq": function() { return /* binding */ getAnalyticsScript; },
  "Uho": function() { return /* binding */ getAnalyticsUrl; },
  "yQL": function() { return /* binding */ getAnonymousId; },
  "fnA": function() { return /* binding */ getAppliedSortPressKit; },
  "kDl": function() { return /* binding */ getAttributeValue; },
  "A_z": function() { return /* binding */ getAuthShortenedUrl; },
  "FcF": function() { return /* binding */ getBadgeValue; },
  "Nth": function() { return /* binding */ getCartItemType; },
  "Cx9": function() { return /* binding */ getCartItemsAnalyticsData; },
  "vzx": function() { return /* binding */ getCityList; },
  "p2C": function() { return /* binding */ getCompareData; },
  "ejW": function() { return /* binding */ getCookie; },
  "soW": function() { return /* binding */ getCountryCode; },
  "zC$": function() { return /* binding */ getCurrency; },
  "mPk": function() { return /* binding */ getCurrentSkuCouponDiscounts; },
  "C2G": function() { return /* binding */ getDataLayerObj; },
  "Dgj": function() { return /* binding */ getDefaultProfileAddress; },
  "dzO": function() { return /* binding */ getDeviceInfo; },
  "bZU": function() { return /* binding */ getFacetsFromUrl; },
  "MqV": function() { return /* binding */ getFavouraties; },
  "DOg": function() { return /* binding */ getGeoRegion; },
  "dhb": function() { return /* binding */ getInternalLinkTypeForFindStore; },
  "Cxt": function() { return /* binding */ getIsNameDuplicate; },
  "Qss": function() { return /* binding */ getIsSystemDefinedName; },
  "pDj": function() { return /* binding */ getLangCode; },
  "OWN": function() { return /* binding */ getLinkFromHref; },
  "ngN": function() { return /* binding */ getLocationByCookies; },
  "fPm": function() { return /* binding */ getMyLocation; },
  "SAL": function() { return /* binding */ getMyLocationByUserIP; },
  "oJS": function() { return /* binding */ getOffsetTop; },
  "ir5": function() { return /* binding */ getPDPUrl; },
  "Aut": function() { return /* binding */ getPDPUrlForProductTile; },
  "Upy": function() { return /* binding */ getPDPUrlWithConfig; },
  "UMn": function() { return /* binding */ getPageInfo; },
  "ptY": function() { return /* binding */ getPageLevelScriptsAndStyles; },
  "C2B": function() { return /* binding */ getPageType; },
  "LjC": function() { return /* binding */ getParamFromUrl; },
  "VzW": function() { return /* binding */ getPasswordRegExp; },
  "VvO": function() { return /* binding */ getPdpUrlPath; },
  "v$f": function() { return /* binding */ getPresetUrl; },
  "KF8": function() { return /* binding */ getPriceFieldFromFacet; },
  "YHw": function() { return /* binding */ getPriceSortQuery; },
  "N2S": function() { return /* binding */ getProcessedProductInfoBasedOnLineItems; },
  "Lkg": function() { return /* binding */ getProductDisplayName; },
  "fhj": function() { return /* binding */ getProductExcludeFromPaidAdvertising; },
  "Ezx": function() { return /* binding */ getProductFlgs; },
  "Gai": function() { return /* binding */ getProductImageUrl; },
  "AEk": function() { return /* binding */ getProductStatus; },
  "OM7": function() { return /* binding */ getPureText; },
  "sKe": function() { return /* binding */ getQuickViewAuth; },
  "sZz": function() { return /* binding */ getRandom; },
  "M0Q": function() { return /* binding */ getRowCols; },
  "csL": function() { return /* binding */ getScriptsAndStyles; },
  "g1g": function() { return /* binding */ getSearchDataLayerDetails; },
  "a4K": function() { return /* binding */ getSelectedSort; },
  "oH8": function() { return /* binding */ getShippingDiscountPromoCodes; },
  "Ppy": function() { return /* binding */ getShortenedUrl; },
  "mXk": function() { return /* binding */ getShortenedUrlPath; },
  "vu1": function() { return /* binding */ getShortenedUrlwithGeneral; },
  "Ure": function() { return /* binding */ getSiteWideModal; },
  "aN0": function() { return /* binding */ getSortFromUrl; },
  "KE": function() { return /* binding */ getSortItemBasedOnURL; },
  "jeb": function() { return /* binding */ getStateCode; },
  "m3S": function() { return /* binding */ getSwatchCount; },
  "iZU": function() { return /* binding */ getSwatchCountSearch; },
  "Z8v": function() { return /* binding */ getSwatchPreset; },
  "jGm": function() { return /* binding */ getUpSellAuthData; },
  "L7i": function() { return /* binding */ getUserAnalyticsObject; },
  "$1Y": function() { return /* binding */ getUserCreatedLists; },
  "shu": function() { return /* binding */ getUserPersona; },
  "Bmk": function() { return /* binding */ handleEnter; },
  "Gzb": function() { return /* binding */ handleModelNumberSuggestion; },
  "bOu": function() { return /* binding */ handleSkipToMain; },
  "G12": function() { return /* binding */ handleZipDownload; },
  "Yo6": function() { return /* binding */ hasNumber; },
  "oC7": function() { return /* binding */ hourDifference; },
  "$8e": function() { return /* binding */ isAuthenticated; },
  "guj": function() { return /* binding */ isCanadaSite; },
  "B3G": function() { return /* binding */ isColorFacet; },
  "G_Z": function() { return /* binding */ isElementExcluded; },
  "cLX": function() { return /* binding */ isEmbeddedElement; },
  "fM6": function() { return /* binding */ isEmbeddedStyles; },
  "DVc": function() { return /* binding */ isGuestTokenValid; },
  "YN4": function() { return /* binding */ isPriceZero; },
  "GtH": function() { return /* binding */ isProtectedUrl; },
  "xJ2": function() { return /* binding */ isShowAnalyticsEventLoaded; },
  "l4J": function() { return /* binding */ isUrlIncludeHttp; },
  "ASm": function() { return /* binding */ jsonStringEscape; },
  "S$e": function() { return /* binding */ makingTextDatalayerReady; },
  "oFy": function() { return /* binding */ mapStateToCountryHandler; },
  "UsO": function() { return /* binding */ navigationType; },
  "E9Q": function() { return /* binding */ nbspSanitizeInnerHtml; },
  "U2t": function() { return /* binding */ organizeData; },
  "V4r": function() { return /* binding */ pdpTypeFormat; },
  "MVu": function() { return /* binding */ preventBodyScroll; },
  "aCP": function() { return /* binding */ preventBodyScrollTab; },
  "pHj": function() { return /* binding */ processColorDetails; },
  "idg": function() { return /* binding */ processSwatchData; },
  "zYT": function() { return /* binding */ pushAnalyticsObjToDataLayer; },
  "NxS": function() { return /* binding */ recalculateCartRoomInfo; },
  "xEh": function() { return /* binding */ removeAndCleanLink; },
  "NgF": function() { return /* binding */ removeFavorites; },
  "Za4": function() { return /* binding */ removeHtmlSuffixFromAnchors; },
  "N9B": function() { return /* binding */ removeMavenoidChat; },
  "FvC": function() { return /* binding */ removeSearchQueryParams; },
  "CjH": function() { return /* binding */ replaceSearchUrl; },
  "pUm": function() { return /* binding */ resetFilterUrl; },
  "eRK": function() { return /* binding */ resetUrl; },
  "mSA": function() { return /* binding */ retainSearchQueryParams; },
  "uP2": function() { return /* binding */ revalidateTime; },
  "NXl": function() { return /* binding */ safeParseJSON; },
  "EzU": function() { return /* binding */ sanitizeAndDecodeHtml; },
  "TRt": function() { return /* binding */ sanitizeDOMString; },
  "KD0": function() { return /* binding */ sanitizeInnerHtml; },
  "O0b": function() { return /* binding */ sanitizeObject; },
  "ZUO": function() { return /* binding */ sanitizeProductName; },
  "oOy": function() { return /* binding */ sanitizeText; },
  "pkm": function() { return /* binding */ sanitizeTextArticle; },
  "T68": function() { return /* binding */ sanitizeTextForAnalytics; },
  "Nmg": function() { return /* binding */ sanitizeUrl; },
  "Sp5": function() { return /* binding */ scene7ImageUrl; },
  "sG9": function() { return /* binding */ scrollToActivePaymentTile; },
  "kIi": function() { return /* binding */ scrollToElement; },
  "kWv": function() { return /* binding */ setFocus; },
  "F2_": function() { return /* binding */ setWindowProps; },
  "aLl": function() { return /* binding */ shaEncrypt; },
  "_AA": function() { return /* binding */ shouldShowSortElement; },
  "ZTk": function() { return /* binding */ showNewBadge; },
  "ldy": function() { return /* binding */ smoothScroll; },
  "zIK": function() { return /* binding */ sortParameterURL; },
  "TeW": function() { return /* binding */ storeFilterData; },
  "wMR": function() { return /* binding */ toggeleBodyClass; },
  "lj5": function() { return /* binding */ toggeleBodyClassAfterLogin; },
  "wA4": function() { return /* binding */ toggeleBodyScroll; },
  "CQb": function() { return /* binding */ updateAnalyticPageUrl; },
  "OP$": function() { return /* binding */ validateField; },
  "Olw": function() { return /* binding */ validateName; },
  "uo4": function() { return /* binding */ validatePassword; }
});

// UNUSED EXPORTS: caesarEncrypt, extractStylesFromDOM, formatMultiSelectFacets, generateCanonicalUrl, getAnalyticsFileName, getClienIP, getExactUserPersona, getFormattedLogForAppInsights, getModelSuggestionSkuListFromData, getParamsFromUrl, getPathFromUrl, getPdpUrlParams, getPresetThumbnailUrl, getUser, getUserIP, handleZipcodeSet, hasComponentType, isAuth, isPartsPage, performRedirect, removePathandHtml, replaceAndFunction, updateHeader, validatePhone

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/js-file-download/file-download.js
var file_download = __webpack_require__(35823);
var file_download_default = /*#__PURE__*/__webpack_require__.n(file_download);
// EXTERNAL MODULE: ./node_modules/content-disposition/index.js
var content_disposition = __webpack_require__(67389);
var content_disposition_default = /*#__PURE__*/__webpack_require__.n(content_disposition);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store_0 = __webpack_require__(88032);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./utils/dateHelper.js + 40 modules
var dateHelper = __webpack_require__(64443);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./js/helperV2.js
var helperV2 = __webpack_require__(30696);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./constants/regex.js
var constants_regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./public/redirect/redirectmap.json
var redirectmap_namespaceObject = {};
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./utils/helper.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(34155);























const isServer = "object" === "undefined";
const getMyLocation = ()=>{
    return new Promise((resolve, reject)=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            navigator.geolocation.getCurrentPosition(async (position)=>{
                try {
                    const res = await getCurrentLocationLatLng(position);
                    var _city, _zipcode;
                    resolve({
                        city: (_city = res.city) !== null && _city !== void 0 ? _city : "",
                        zipcode: (_zipcode = res.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
                    });
                } catch (e) {
                    const errorCause = {
                        title: get_default()(CONFIG, "general.geoLocationErrorTitle", "").trim(),
                        message: get_default()(CONFIG, "general.geoLocationErrorMessage", "").trim(),
                        ctaLink: get_default()(CONFIG, "general.geoLocationErrorCtaLink", "").trim(),
                        ctaLabel: get_default()(CONFIG, "general.geoLocationErrorCtaLabel", "").trim()
                    };
                    reject(new Error("Location Error", {
                        cause: errorCause
                    }));
                }
            }, (e)=>{
                const errorCause = {
                    title: get_default()(CONFIG, "general.geoLocationErrorTitle", "").trim(),
                    message: get_default()(CONFIG, "general.geoLocationErrorMessage", "").trim(),
                    ctaLink: get_default()(CONFIG, "general.geoLocationErrorCtaLink", "").trim(),
                    ctaLabel: get_default()(CONFIG, "general.geoLocationErrorCtaLabel", "").trim()
                };
                reject(new Error("Location Error", {
                    cause: errorCause
                }));
            });
        });
    });
};
const getMyCity = async (reverseGeo, lat, long)=>{
    const { general  } = await (0,constants_config/* getConfig */.i)();
    var _siteName;
    const siteName = (_siteName = general.siteName) !== null && _siteName !== void 0 ? _siteName : "";
    try {
        const res = await api/* apim.get */.TH.get(reverseGeo, {
            params: {
                $format: "json",
                brand: siteName.toLowerCase(),
                lat: lat,
                long: long
            }
        });
        const response = res.data.resourceSets[0].resources[0].address;
        return {
            city: get_default()(response, "adminDistrict2", ""),
            zipcode: get_default()(response, "postalCode", "")
        };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Fetching City failed", err);
    }
};
const getApiServletPath = async ()=>{
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const res = CONFIG.apiEndpoints;
    return {
        findStores: get_default()(res, "findStores", ""),
        reverseGeo: get_default()(res, "reverseGeo", ""),
        findStoresBingKey: get_default()(res, "findStoresBingKey", "")
    };
};
const getCurrentLocationLatLng = async (position)=>{
    const getReverseGeo = await getApiServletPath();
    var _reverseGeo;
    const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
    let getCityData = {};
    try {
        const lat = localStorage.getItem("latitude");
        const lng = localStorage.getItem("longitude");
        const cityData = localStorage.getItem("cityData");
        const locationTimeout = localStorage.getItem("locationTimeout");
        if (parseFloat(lat) === position.coords.latitude && parseFloat(lng) === position.coords.longitude && cityData && locationTimeout && (0,dateHelper/* isBeforeDate */.gO)((0,dateHelper/* getCurrentDate */.Ux)(), locationTimeout)) {
            getCityData = JSON.parse(cityData);
        } else {
            getCityData = await getMyCity(reverseGeoLink, position.coords.latitude, position.coords.longitude);
            const localStorageData = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                cityData: JSON.stringify(getCityData),
                locationTimeout: (0,dateHelper/* toISOString */.Y6)((0,dateHelper/* addToDate */.EE)((0,dateHelper/* getCurrentDate */.Ux)(), 30, "minutes"), true)
            };
            setLocalStorageData(localStorageData);
        }
    } catch (err) {
        clearLocalStorageData("latitude", "longitude", "cityData", "locationTimeout");
    }
    return {
        city: get_default()(getCityData, "city", ""),
        zipcode: get_default()(getCityData, "zipcode", "")
    };
};
const clearLocalStorageData = function() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    keys.forEach((key)=>{
        localStorage.removeItem(key);
    });
};
const setLocalStorageData = (localStorageData)=>{
    for (const [key, value] of Object.entries(localStorageData)){
        localStorage.setItem(key, value);
    }
};
const getMyLocationByUserIP = async ()=>{
    const response = await getUserIP();
    var _city, _zipcode;
    return {
        city: (_city = response.city) !== null && _city !== void 0 ? _city : "",
        zipcode: (_zipcode = response.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
    };
};
const getUserIP = async ()=>{
    const res = await getLocationByCookies();
    var _city, _zipcode;
    return {
        city: (_city = res.city) !== null && _city !== void 0 ? _city : "",
        zipcode: (_zipcode = res.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
    };
};
const getLocationByCookies = async ()=>{
    var ref;
    const userLocation = ((ref = document.cookie.match("(^|;)\\s*userLocation\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    let getCityData = {};
    if (userLocation !== "") {
        try {
            const splitLocation = userLocation.split("+");
            const lat = localStorage.getItem("cookiesLatitude");
            const lng = localStorage.getItem("cookiesLongitude");
            const cityData = localStorage.getItem("cookiesCityData");
            const locationTimeout = localStorage.getItem("cookiesLocationTimeout");
            if (parseFloat(lat) === splitLocation[4] && parseFloat(lng) === splitLocation[5] && cityData && locationTimeout && (0,dateHelper/* isBeforeDate */.gO)((0,dateHelper/* getCurrentDate */.Ux)(), locationTimeout)) {
                getCityData = JSON.parse(cityData);
            } else {
                const getReverseGeo = await getApiServletPath();
                var _reverseGeo;
                const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
                getCityData = await getMyCity(reverseGeoLink, splitLocation[4], splitLocation[5]);
                const localStorageData = {
                    cookiesLatitude: splitLocation[4],
                    cookiesLongitude: splitLocation[5],
                    cookiesCityData: JSON.stringify(getCityData),
                    cookiesLocationTimeout: (0,dateHelper/* toISOString */.Y6)((0,dateHelper/* addToDate */.EE)((0,dateHelper/* getCurrentDate */.Ux)(), 30, "minutes"), true)
                };
                setLocalStorageData(localStorageData);
            }
        } catch (err) {
            clearLocalStorageData("cookiesLatitude", "cookiesLongitude", "cookiesCityData", "cookiesLocationTimeout");
        }
    }
    return {
        city: get_default()(getCityData, "city", ""),
        zipcode: get_default()(getCityData, "zipcode", "")
    };
};
const sanitizeInnerHtml = function(property) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,html_react_parser/* default */.ZP)("".concat(browser_default().sanitize(property, {
        ADD_ATTR: [
            "target"
        ]
    })), options);
};
const customSanitizeInnerHtml = (property)=>(0,html_react_parser/* default */.ZP)("".concat(browser_default().sanitize(property, {
        ADD_ATTR: [
            "target",
            "frameborder",
            "scrolling",
            "allowfullscreen",
            "height",
            "src",
            "width",
            "style",
            "alt",
            "lang",
            "title"
        ],
        ALLOWED_TAGS: [
            "iframe",
            "p",
            "img",
            "a",
            "br",
            "span",
            "ul",
            "ol",
            "li",
            "div",
            "b",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "strong",
            "button",
            "video",
            "svg",
            "hr"
        ]
    })));
/**
 * Remove trailing `.html` from anchor hrefs whose path starts with `/en` or `/content`.
 * Keeps other anchors unchanged.
 *
 * @param {string} html - HTML string to process
 * @return {string} Modified HTML string
 */ function removeHtmlSuffixFromAnchors() {
    let html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!html || typeof html !== "string") return html;
    // Match <a ... href="/en/... .html" or href='/content/....html'
    const regex = /(<a\b[^>]*\bhref=)(["'])(\/?(?:en|content)[^"']*?)\.html\2/gi;
    return html.replace(regex, (match, p1, quote, path)=>{
        return "".concat(p1).concat(quote).concat(path).concat(quote);
    });
}
const formatPhoneNumber = (phoneNumberString)=>{
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return null;
};
const validatePassword = async (password, userData)=>{
    const regexObj = await getPasswordRegExp();
    const regex = new RegExp(regexObj.regex);
    const data = userData.filter((el)=>el.length > 0);
    if (password.length < 10) return false;
    if (!regex.test(password)) return false;
    if (data.some((vl)=>password.toLowerCase().includes(vl.toLowerCase()))) {
        return false;
    }
    if (!constants_regex/* UPPERCASE_REGEX.test */.ab.test(password)) return false;
    return true;
};
const validateField = async (field, value)=>{
    const { regexPattern  } = await (0,constants_config/* getConfig */.i)();
    const pattern = get_default()(regexPattern, "map.".concat(field), "");
    const regex = new RegExp(pattern);
    return !!regex.test(value);
};
const validateName = async (value)=>{
    return constants_regex/* NAME_REGEX.test */.lj.test(value);
};
const addToRecentSearch = (keyword)=>{
    if (keyword && keyword.length > 2) {
        var ref;
        let history1 = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history1 = history1.filter((item)=>item.keyWord.toLowerCase() !== keyword.toLowerCase());
        history1.unshift({
            keyWord: keyword,
            id: Date.now()
        });
        window.localStorage.setItem("keyWordList", JSON.stringify(history1));
    }
};
const navigationType = ()=>{
    let result;
    let p;
    if (window.performance.getEntriesByType("navigation")) {
        p = window.performance.getEntriesByType("navigation")[0].type;
        if (p === "navigate") result = 0;
        if (p === "reload") result = 1;
        if (p === "back_forward") result = 2;
        if (p === "prerender") result = 3;
    }
    return result;
};
const getParamFromUrl = function(param) {
    let urlLocation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const url = new URL(urlLocation || location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get(param)) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const smoothScroll = (element)=>element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
    });
const getClienIP = (request)=>{
    let ip = "";
    if (!request) return ip;
    if (request.headers["IpAddress"]) {
        ip = request.headers["IpAddress"].split(",")[0];
    } else if (request.headers["true-ip"]) {
        ip = request.headers["true-ip"].split(",")[0];
    } else if (request.headers["x-forwarded-for"]) {
        ip = request.headers["x-forwarded-for"].split(",")[0];
    } else if (request.headers["x-real-ip"]) {
        ip = request.connection.remoteAddress;
    } else {
        ip = request.connection.remoteAddress || "";
    }
    return ip;
};
const isProtectedUrl = async (url)=>{
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const { commerce: { sessionAuth: { securePagePathList  }  }  } = CONFIG;
    const curUrl = url !== null && url !== void 0 ? url : window.location.pathname;
    return securePagePathList.includes(curUrl);
};
const updateHeader = function(token) {
    let isAuth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const authHeader = "Bearer ".concat(token);
    apim.defaults.headers.common["Authorization"] = authHeader;
// if (isAuth) {
//   clearTimeout(refreshTimer)
//   setTimeout(() => {
//     addPageLoadAnalyticsEvent()
//   }, 2000)
//   return
// }
// addPageLoadAnalyticsEvent()
// renewAnonymousTokenBeforeExpiry(token.access_token)
};
// eslint-disable-next-line require-jsdoc
function debounce(func) {
    let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _this = this;
    let timer;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timer);
        timer = setTimeout(()=>{
            // eslint-disable-next-line no-invalid-this
            func.apply(_this, args);
        }, timeout);
    };
}
const shaEncrypt = async (message)=>{
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);
    // hash the message
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    // convert bytes to hex string
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
    // return a promise
    return hashHex;
};
const caesarEncrypt = (salt, text)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const byteHex = (n)=>("0" + Number(n).toString(16)).slice(-2);
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};
const caesarDecrypt = (salt, encoded)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return encoded.match(/.{1,2}/g).map((hex)=>parseInt(hex, 16)).map(applySaltToChar).map((charCode)=>String.fromCharCode(charCode)).join("");
};
const getPasswordRegExp = async ()=>{
    const { regex  } = await (0,constants_config/* getConfig */.i)();
    var _regex, _conditionsList;
    return {
        regex: (_regex = regex.regex) !== null && _regex !== void 0 ? _regex : "",
        passwordMessage: (_conditionsList = regex.conditionsList) !== null && _conditionsList !== void 0 ? _conditionsList : []
    };
};
const getUserAnalyticsObject = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { isFromRegisterUser =false , encryptedEmail =""  } = data;
    const hashedEmail = localStorage.getItem("hashedEmail") || ((ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.hashedEmail) || encryptedEmail || "";
    const customerProspect = localStorage.getItem("customerProspect") || ((ref2 = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.auth) === null || ref3 === void 0 ? void 0 : ref3.customerProspect);
    let isCustomerOrProspect = "n/a";
    if (hashedEmail && customerProspect) {
        try {
            const decryptedJSON = JSON.parse(caesarDecrypt(hashedEmail, customerProspect));
            if (decryptedJSON.pastOrders.length) {
                isCustomerOrProspect = "customer";
            } else {
                isCustomerOrProspect = "prospect";
            }
        } catch (es) {
            // eslint-disable-next-line no-console
            console.log("decrypt error: ", es);
        }
    }
    const url = new URL(window.location.href);
    var ref7;
    const encodedEmailId = (ref7 = (ref4 = url.searchParams) === null || ref4 === void 0 ? void 0 : ref4.get("q")) !== null && ref7 !== void 0 ? ref7 : "";
    // this user object should be updated when user log in or out.
    const user = {
        gId: "n/a",
        abTestName: "n/a",
        adBlocker: false,
        authStatus: "anonymous",
        commerceToolsID: "n/a",
        customerProspect: isCustomerOrProspect,
        envName: "development",
        knownStatus: "unknown",
        profileRole: "guest",
        profileType: "n/a",
        returningStatus: "new visitor",
        emailId: hashedEmail || "n/a",
        encodedEmailId
    };
    const isOrderConfirmationPage = (window === null || window === void 0 ? void 0 : window.eventPageType) === "orders:order confirmation";
    if (isOrderConfirmationPage) {
        localStorage.removeItem("hashedEmail");
    }
    // fetch okta tokens for both logged in and anonymous users
    const oktaToken = localStorage.getItem("okta-token-storage");
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token") || ((ref5 = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.auth) === null || ref6 === void 0 ? void 0 : ref6.access_token);
    if (oktaToken && oktaToken !== "{}") {
        var ref8;
        // user is logged in
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref8 = oktaObject.accessToken) === null || ref8 === void 0 ? void 0 : ref8.claims) || {};
        // user.uId = claim.uid || "n/a";
        if (claim.businessType === "Consumer" || claim.businessType === "homeowner") {
            user.profileRole = "consumer";
            user.profileType = "consumer";
        } else {
            user.profileRole = "professional";
            const businessSubType = (claim === null || claim === void 0 ? void 0 : claim.businessSubType) !== undefined && (claim === null || claim === void 0 ? void 0 : claim.businessSubType) !== null ? "|".concat(claim.businessSubType) : "";
            user.profileType = "".concat(claim.businessType).concat(businessSubType);
        }
        user.commerceToolsID = claim.commercetoolsID || "n/a";
        if (!isFromRegisterUser) {
            user.returningStatus = "returning customer";
        }
        user.authStatus = "logged in";
        user.emailId = hashedEmail || "n/a";
        user.knownStatus = "known";
    } else if (anonymousOktaToken) {
        // anonymous user
        let oktaObject1;
        try {
            oktaObject1 = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Anonymous Okta Token can not be decoded......");
        }
        if (oktaObject1) {
            user.gId = oktaObject1.gId || "n/a";
        }
    }
    return user;
};
const isElementExcluded = (e, classNames)=>{
    const path = e.path || e.composedPath && e.composedPath();
    return path.some((element)=>{
        return classNames.some((className)=>{
            var ref;
            return element === null || element === void 0 ? void 0 : (ref = element.className) === null || ref === void 0 ? void 0 : ref.includes(className);
        });
    });
};
const getAnonymousId = ()=>{
    var ref, ref1;
    let anonymousId = "";
    if (true) {
        anonymousId = localStorage.getItem("anonymousId");
    }
    if (!anonymousId) anonymousId = (ref = store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.anonymousId;
    return anonymousId;
};
const clearAuthToken = ()=>{
    localStorage.removeItem("customerProspect");
    localStorage.removeItem("okta-cache-storage");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("anonymousId");
    const cookies = new es6/* default */.Z();
    cookies.remove("commerce_gid", {
        path: "/",
        domain: ".kohler.com"
    });
};
const clearAnonymousToken = ()=>{
    localStorage.removeItem("anonymousId");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("okta-anonymous-refresh-token");
    localStorage.removeItem("token-revalidate-expiry");
    const cookies = new es6/* default */.Z();
    cookies.remove("commerce_gid", {
        path: "/",
        domain: ".kohler.com"
    });
};
const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;
/** A pattern that matches safe data URLs. It only matches image, video, and audio types. */ const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
const _sanitizeUrl = (url)=>{
    url = String(url);
    if (url === "null" || url.length === 0 || url === "about:blank") return "about:blank";
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) return url;
    return "unsafe:".concat(url);
};
const sanitizeUrl = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "about:blank";
    return _sanitizeUrl(String(url).trim());
};
const revalidateTime = ()=>(0,dateHelper/* toISOString */.Y6)((0,dateHelper/* addToDate */.EE)((0,dateHelper/* getCurrentDate */.Ux)(), 30, "m"));
const getPDPUrl = async (category, slug)=>{
    const { plpServletPath , general  } = await (0,constants_config/* getConfig */.i)();
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getPdpUrlPath = (category, slug)=>{
    const { generic: { globalConfig: { plpServletPath , general ={}  } = {}  } = {}  } = (store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) || {};
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getPDPUrlForProductTile = async (data)=>{
    const { Product_Category: productCategory = "" , ProductLocalCategory_s: productLocalCategory = "" , slug_s: slug  } = data;
    const category = productCategory ? productCategory : productLocalCategory !== null && productLocalCategory !== void 0 ? productLocalCategory : "";
    const { plpServletPath , general  } = await (0,constants_config/* getConfig */.i)();
    return gePDPUrlPageDetails(plpServletPath, general, category, slug);
};
const getPDPUrlWithConfig = (category, slug, plpServletPath, general)=>{
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const gePDPUrlPageDetails = (plpServletPath, general, category, slug)=>{
    const path = plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.find((i)=>i.categories.includes(category));
    var ref;
    const shortUrl = (ref = general === null || general === void 0 ? void 0 : general.shortendPagePath) !== null && ref !== void 0 ? ref : "";
    if (category === "Design Services") {
        return getShortenedUrlwithGeneral(general.designServiceLandingPath, general);
    }
    if (category === "Install Services") {
        return getShortenedUrlwithGeneral(general.installServiceLandingPath, general);
    }
    if (!category || category === "Service Parts") {
        var ref1;
        return "".concat((ref1 = general.servicePartsLandingPath) === null || ref1 === void 0 ? void 0 : ref1.replace(shortUrl, ""), "/").concat(slug);
    }
    if (path) {
        var ref2;
        return "".concat((ref2 = path.url) === null || ref2 === void 0 ? void 0 : ref2.replace(shortUrl, ""), "/").concat(slug);
    }
    return "".concat(getShortenedUrlwithGeneral(general === null || general === void 0 ? void 0 : general.plpPagePath, general), "/").concat(category === null || category === void 0 ? void 0 : category.replace(constants_regex/* URL_REPLACE_REGEX */.ef, "-").toLowerCase(), "/").concat(slug, ".html");
};
const pdpTypeFormat = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { businessUnitName ="" , ProductIsRetail ="" , ProductRequiredAccessoriesGroupsList =[] , superSku =""  } = data;
    let pdpType = "";
    if (businessUnitName === "Service Parts") {
        pdpType = "regular part";
    } else if (ProductIsRetail) {
        pdpType = "retail exclusive";
    } else if (ProductRequiredAccessoriesGroupsList.length) {
        pdpType = constants.PDP_TYPE;
    } else if (superSku) {
        pdpType = "super sku";
    } else {
        pdpType = constants.PDP_TYPE;
    }
    return pdpType;
};
const sanitizeTextForAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const testData = text !== null && text !== void 0 ? text : "";
    return String(testData).replace(constants_regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().trim();
};
const makingTextDatalayerReady = (text)=>{
    var ref, ref1, ref2;
    return (ref2 = (ref1 = (ref = getPureText(text)) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.replace(constants_regex/* DATA_LAYER_REGEX */.ok, "&")) === null || ref2 === void 0 ? void 0 : ref2.trim();
};
const getSwatchCount = function() {
    let isPlp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // If we're in a server environment, return desktop values
    if (false) {}
    // Client-side logic
    const width = window.outerWidth;
    if (isPlp) {
        if (width >= 1024 && width < 1440) {
            return 3;
        }
        if (width >= 1440) {
            return 7;
        }
        if (width < 812) {
            return 5;
        }
        return 3;
    } else {
        if (width < 1330) {
            return 3;
        }
        return 5;
    }
};
const getSwatchCountSearch = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (width < 1024) {
        return 5;
    }
    if (width < 1440) {
        return 3;
    }
    return 7;
};
const isColorFacet = (f)=>{
    const facet = f.replace(/^\*{2}/, "");
    return !!(facet === "ColorFinish_s" || facet === "SKUColorFinishName_ss");
};
const getCurrentSkuCouponDiscounts = (param)=>{
    let { sku , cart , locale  } = param;
    var ref, ref1;
    // find if cart-discount is applied to this product
    const discountID = [];
    const discountedAmount = [];
    const productCouponCode = [];
    const comparedList = [];
    const codesList = [];
    const globalDiscountNames = [];
    let productCoupondiscount = 0;
    let globalDiscountValues = 0;
    cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.forEach((lineItem)=>{
        const discountSku = get_default()(lineItem, "variant.sku", null);
        // finding discount details in lineItems
        if (discountSku === sku) {
            get_default()(lineItem, "discountedPrice.includedDiscounts", []).forEach((includedDiscount)=>{
                var ref, ref1;
                if ((includedDiscount === null || includedDiscount === void 0 ? void 0 : (ref = includedDiscount.discount) === null || ref === void 0 ? void 0 : ref.typeId) === "cart-discount" && ((ref1 = includedDiscount.discount.obj) === null || ref1 === void 0 ? void 0 : ref1.id)) {
                    discountID.push(includedDiscount.discount.obj.id);
                    discountedAmount.push(Number((includedDiscount.discountedAmount.centAmount / 100).toFixed(2)));
                    codesList.push(includedDiscount.discount.obj.name[locale]);
                }
            });
        }
    });
    if (discountID.length && (cart === null || cart === void 0 ? void 0 : (ref1 = cart.discountCodes) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        // we got discount id from lineItems, now get discount code from discountCodes
        cart === null || cart === void 0 ? void 0 : cart.discountCodes.forEach((discountCode)=>{
            var ref, ref1;
            if (discountCode === null || discountCode === void 0 ? void 0 : (ref = discountCode.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) {
                var ref2;
                (ref2 = discountCode.discountCode.obj.cartDiscounts) === null || ref2 === void 0 ? void 0 : ref2.forEach((cartDiscount)=>{
                    const matchingIndex = discountID.indexOf(cartDiscount.id);
                    if (matchingIndex !== -1 && cartDiscount.typeId === "cart-discount") {
                        // copy discount code of this discountCode object
                        productCouponCode.push(discountCode.discountCode.obj.code);
                        productCoupondiscount += discountedAmount[matchingIndex];
                        comparedList.push(cartDiscount.id);
                    }
                });
            }
        });
    }
    discountID.filter((a)=>!comparedList.includes(a)).forEach((a)=>{
        const matchedIndex = discountID.indexOf(a);
        if (matchedIndex >= 0) {
            globalDiscountNames.push(codesList[matchedIndex]);
            globalDiscountValues += discountedAmount[matchedIndex];
        }
    });
    productCoupondiscount = Number(productCoupondiscount.toFixed(2));
    return {
        productCouponCode,
        productCoupondiscount,
        globalDiscountNames,
        globalDiscountValues
    };
};
const destructureAddress = (addr, siteName)=>{
    const data = {
        address: "",
        city: "",
        state: "",
        zipcode: ""
    };
    var ref;
    data.address = (ref = addr.split(",")[0]) !== null && ref !== void 0 ? ref : "";
    if (siteName === "kohler-canada") {
        var ref1, ref2, ref3;
        var ref4;
        const address = (ref4 = addr.split(",")) !== null && ref4 !== void 0 ? ref4 : "";
        var ref5;
        data.city = (ref5 = (ref1 = address[1]) === null || ref1 === void 0 ? void 0 : ref1.trim()) !== null && ref5 !== void 0 ? ref5 : "";
        var ref6;
        data.state = (ref6 = (ref2 = address[2]) === null || ref2 === void 0 ? void 0 : ref2.trim()) !== null && ref6 !== void 0 ? ref6 : "";
        var ref7;
        data.zipcode = (ref7 = (ref3 = address[3]) === null || ref3 === void 0 ? void 0 : ref3.trim()) !== null && ref7 !== void 0 ? ref7 : "";
    } else {
        var ref8;
        const addrLine2 = (ref8 = addr.split(",")[1]) !== null && ref8 !== void 0 ? ref8 : "";
        const splitAddress = addrLine2.split(" ");
        var ref9;
        const len = (ref9 = splitAddress === null || splitAddress === void 0 ? void 0 : splitAddress.length) !== null && ref9 !== void 0 ? ref9 : 0;
        let addrLine1 = "";
        splitAddress.forEach((item, i)=>{
            if (i < len - 2) addrLine1 = addrLine1 + item + " ";
        });
        if (addrLine2) {
            var ref10;
            data.city = (ref10 = addrLine1 === null || addrLine1 === void 0 ? void 0 : addrLine1.trim()) !== null && ref10 !== void 0 ? ref10 : "";
            var ref11;
            data.state = (ref11 = addrLine2.split(" ")[len - 2]) !== null && ref11 !== void 0 ? ref11 : "";
            var ref12;
            data.zipcode = (ref12 = addrLine2.split(" ")[len - 1]) !== null && ref12 !== void 0 ? ref12 : "";
        }
    }
    return data;
};
const getStateCode = function(stateVal, countryVal) {
    let data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    const country = data.find((obj)=>{
        return (obj === null || obj === void 0 ? void 0 : obj.code) === countryVal || (obj === null || obj === void 0 ? void 0 : obj.name) === countryVal;
    });
    if (!country || !country.states) return "";
    const state = country.states.find((obj)=>{
        return (obj === null || obj === void 0 ? void 0 : obj.code) === stateVal || (obj === null || obj === void 0 ? void 0 : obj.name) === stateVal;
    });
    var ref;
    return (ref = state === null || state === void 0 ? void 0 : state.code) !== null && ref !== void 0 ? ref : "";
};
const getCountryCode = function(countryVal) {
    let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const country = data.find((obj)=>{
        return (obj === null || obj === void 0 ? void 0 : obj.code) === countryVal || (obj === null || obj === void 0 ? void 0 : obj.name) === countryVal;
    });
    var ref;
    return (ref = country === null || country === void 0 ? void 0 : country.code) !== null && ref !== void 0 ? ref : "";
};
const extractScriptsFromDOM = (doc, cb)=>{
    const scripts = doc.getElementsByTagName("script");
    for (const script of scripts){
        const scriptItem = {};
        const src = script.getAttribute("src") || "";
        const type = script.getAttribute("type") || "";
        const integrity = script.getAttribute("integrity") || "";
        const charset = script.getAttribute("charset") || "";
        const dataDomainScript = script.getAttribute("data-domain-script") || "";
        if (src) scriptItem.src = src;
        if (charset) scriptItem.charset = charset;
        if (dataDomainScript) scriptItem.dataDomainScript = dataDomainScript;
        if (type) scriptItem.type = type;
        if (integrity) scriptItem.integrity = integrity;
        if (script.innerHTML) scriptItem.innerHTML = script.innerHTML;
        if ("https://www.kohler.com/corporate/include-consent-banner.js" !== src) {
            cb(scriptItem);
        }
    }
};
const extractStylesFromDOM = (doc, cb)=>{
    const styles = doc.getElementsByTagName("style");
    for (const style of styles){
        if (style.innerHTML) cb(style.innerHTML);
    }
};
const extractLinksFromDOM = (doc, cb)=>{
    const links = doc.getElementsByTagName("link");
    for (const link of links){
        cb(link);
    }
};
const extractMetasFromDOM = (doc, cb)=>{
    const metas = doc.getElementsByTagName("meta");
    for (const meta of metas){
        cb(meta);
    }
};
const showNewBadge = (shipmentDate)=>{
    if (shipmentDate) {
        const today = new Date();
        today.setMonth(today.getMonth() - 6);
        if (Date.parse(shipmentDate) > Date.parse(today)) {
            return true;
        }
    }
    return false;
};
const getCompareData = ()=>{
    const { compare  } = store_0/* store.getState */.h.getState();
    return compare;
};
const isAuth = ()=>{
    const { isAuth  } = store.getState();
    return isAuth;
};
const getUser = ()=>{
    const { user  } = store.getState();
    return user;
};
const getFavouraties = ()=>{
    if (!isServer) {
        const { favorites  } = store_0/* store.getState */.h.getState();
        return favorites === null || favorites === void 0 ? void 0 : favorites.favorites;
    }
    return [];
};
const getDataLayerObj = (datalayerObj)=>{
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setDataLayerObj */.sZ)(datalayerObj));
};
const getScriptsAndStyles = (jsonData)=>{
    const { generic: { globalScripts =[] , globalStyles =[]  } = {}  } = store_0/* store.getState */.h.getState();
    const scriptsList = [];
    const stylesList = [];
    const dataRecursion = (jsonData)=>{
        jsonData[":itemsOrder"] && jsonData[":itemsOrder"].map((key, index)=>{
            var ref;
            const jsonItem = jsonData[":items"][key];
            if ((ref = jsonItem[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.EMBED)) {
                const doc = new DOMParser().parseFromString(jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.script, "text/html");
                extractScriptsFromDOM(doc, (item)=>{
                    const isExit = globalScripts.some((el)=>JSON.stringify(el) === JSON.stringify(item));
                    !isExit && scriptsList.push(item);
                });
                extractStylesFromDOM(doc, (item)=>{
                    const isExit = globalStyles.some((el)=>el === item);
                    !isExit && stylesList.push(item);
                });
            } else {
                return dataRecursion(jsonItem);
            }
        });
    };
    dataRecursion(jsonData);
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setGlobalScripts */.n8)(scriptsList));
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setGlobalStyles */.cw)(stylesList));
    return scriptsList;
};
const hasComponentType = (data, type, cb)=>{
    data[":itemsOrder"] && data[":itemsOrder"].map((key)=>{
        const item = data[":items"][key];
        if (item[":type"].includes(type)) {
            cb && cb();
        } else {
            return hasComponentType(item, type, cb);
        }
    });
};
const isShowAnalyticsEventLoaded = ()=>{
    // this function is used to check if cmp:show event is already loaded or not to avoid duplicate show events
    if (window.adobeDataLayer) {
        let isLoaded = false;
        window.adobeDataLayer.forEach((event)=>{
            if ((event === null || event === void 0 ? void 0 : event.event) === "cmp:show") {
                isLoaded = true;
            }
        });
        return isLoaded;
    }
    return false;
};
const handleForOrderconfirmationCall = ()=>{
    var ref;
    if (document.isOrderConfirmation && !(window === null || window === void 0 ? void 0 : (ref = window.pageObj) === null || ref === void 0 ? void 0 : ref.transaction)) {
        return false;
    }
    return true;
};
let pageLoadAnalyticsTimer;
const addPageLoadAnalyticsEvent = ()=>{
    if (window.adobeDataLayer && window.isShowAnalyticsEvent === true && window.pageObj && !isShowAnalyticsEventLoaded() && window.datalayerTopLoaded && handleForOrderconfirmationCall()) {
        // we need to execute cmp:show event here as it is a first time page
        const page = window.pageObj;
        const { category: { pageType ="" , subCategoryID =""  } = {}  } = page;
        if (pageLoadAnalyticsTimer) {
            clearTimeout(pageLoadAnalyticsTimer);
            pageLoadAnalyticsTimer = undefined;
        }
        if (!pageType) {
            pageLoadAnalyticsTimer = setTimeout(()=>addPageLoadAnalyticsEvent(), 500);
            return;
        }
        if (pageType === "pdp" || pageType === "search-results" || pageType === "search" || pageType === "orders" && subCategoryID === "order details") {
            return;
        }
        page.user = localStorage ? getUserAnalyticsObject() : {};
        const otherItems = {};
        if (page.component) {
            otherItems.component = page.component;
        // delete page.component
        }
        if (page.eventInfo) {
            otherItems.eventInfo = page.eventInfo;
        // delete page.eventInfo
        }
        if (page.productInfo) {
            otherItems.productInfo = page.productInfo;
        // delete page.productInfo
        }
        window.adobeDataLayer.push({
            event: "cmp:show",
            page: page,
            ...otherItems
        });
        window.isShowAnalyticsEvent = false;
        delete window.isShowAnalyticsEvent;
    }
};
const handleZipcodeSet = (zipCode, status, message)=>{
    const eventInfo = {
        eventAction: "cart:landing page:order summary:update zip code",
        eventName: "cart:landing page:order summary:update zip code",
        eventMsg: message || "n/a",
        eventStatus: status,
        internalLinkName: "update",
        eventType: "navigation",
        internalLinkPosition: "cart",
        internalLinkType: "cart:" + zipCode,
        internalLinkZoneName: "cart:landing page:order summary",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const page = window.pageObj || {};
    if (page.cart) {
        page.cart.zipcode = zipCode;
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getAccessToken = ()=>{
    const { auth: { isAuth , access_token: accessToken = ""  } = {}  } = store_0/* store.getState */.h.getState();
    let token = "";
    if (!isAuth && "object" !== "undefined") {
        token = localStorage.getItem("okta-anonymous-access-token");
    }
    if (!token) token = accessToken;
    if (token) {
        const tokenSplit = token.split(".")[1] || null;
        if (tokenSplit) {
            const { gId , exp  } = JSON.parse(Buffer.from(tokenSplit, "base64"));
            return {
                token,
                gId,
                exp
            };
        } else {
            return {};
        }
    }
    return {
        token
    };
};
const isAuthenticated = async (ref, activeTab, isKPN)=>{
    const { auth: { isAuth  } = {}  } = store_0/* store.getState */.h.getState();
    const { general  } = await (0,constants_config/* getConfig */.i)();
    if (isAuth) {
        if (typeof ref === "function") {
            ref();
            return;
        }
        if (isKPN) {
            const persona = getExactUserPersona();
            var _homepageUrl;
            if (persona !== "TVS") return window.location.replace(getShortenedUrlwithGeneral((_homepageUrl = general.homepageUrl) !== null && _homepageUrl !== void 0 ? _homepageUrl : "/", general));
        }
        window.location.href = ref;
    } else {
        window.loginCallback = ref;
        store_0/* store.dispatch */.h.dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: !activeTab ? 0 : activeTab
        }));
    }
};
const isGuestTokenValid = ()=>{
    const { auth: { isAuth  } = {}  } = store_0/* store.getState */.h.getState();
    const { exp =""  } = getAccessToken();
    if (!exp) return false;
    if (!isAuth) return (0,dateHelper/* isBeforeDate */.gO)((0,dateHelper/* getCurrentDate */.Ux)(), (0,dateHelper/* subtractFromDate */.wD)((0,dateHelper/* fromUnixTimestamp */.M)(exp), 120, "s"));
    return true;
};
const hourDifference = (date1, date2)=>{
    let diff = (new Date(date2).getTime() - new Date(date1).getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
};
const getUserPersona = ()=>{
    if (!isServer) {
        if (process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true") return "ANY";
        if (store_0/* store */.h) {
            const { auth: { isAuth , user: { persona =[]  } = {}  } = {}  } = store_0/* store.getState */.h.getState();
            if (isAuth) {
                var ref;
                const personaName = (ref = persona === null || persona === void 0 ? void 0 : persona.find((e)=>{
                    return e === null || e === void 0 ? void 0 : e.includes(":");
                })) !== null && ref !== void 0 ? ref : "";
                var ref1;
                return (ref1 = personaName.split(":")[1]) !== null && ref1 !== void 0 ? ref1 : "GST";
            }
        }
    }
    if (process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true") return "ANY";
    return "GST";
};
const getExactUserPersona = ()=>{
    if (!isServer) {
        const { auth: { isAuth , user: { persona =[]  } = {}  } = {}  } = store_0/* store.getState */.h.getState() || {};
        if (isAuth) {
            var ref;
            const personaName = (ref = persona === null || persona === void 0 ? void 0 : persona.find((e)=>{
                return e === null || e === void 0 ? void 0 : e.includes(":");
            })) !== null && ref !== void 0 ? ref : "";
            var ref1;
            return (ref1 = personaName.split(":")[1]) !== null && ref1 !== void 0 ? ref1 : "GST";
        }
    }
    return "GST";
};
const createPersonaCookie = ()=>{
    const cookie = new es6/* default */.Z();
    cookie.set("userPersona", getUserPersona(), {
        path: "/"
    });
};
const handleEnter = (e)=>{
    if (e.keyCode === 13) {
        if (e.target.onclick && e.target.tagName !== "BUTTON") {
            e.stopPropagation();
            document.activeElement.click();
        }
    }
};
const setWindowProps = (obj, val)=>{
    if (val) window[obj] = val;
};
const arrayMove = (arr, fromIndex, toIndex)=>{
    const newArr = [
        ...arr
    ];
    const element = newArr.splice(fromIndex, 1)[0];
    newArr.splice(toIndex, 0, element);
    return newArr;
};
const getCurrency = async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { currencyCode ="USD"  } = {}  } = config || {};
    return currencyCode;
};
const getAnalyticsScript = (analyticsScript)=>{
    if (analyticsScript) {
        store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setAnalyticsScript */.DE)(analyticsScript));
    } else {
        store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setAnalyticsScript */.DE)(""));
    }
};
const getPageLevelScriptsAndStyles = (scriptsAndStyles)=>{
    const scriptsList = [];
    const stylesList = [];
    const metaList = [];
    const linkList = [];
    let bazaarVoice = null;
    const dataRecursion = (scriptsAndStyles)=>{
        const doc = new DOMParser().parseFromString(scriptsAndStyles, "text/html");
        extractScriptsFromDOM(doc, (item)=>{
            var ref;
            const isBv = item === null || item === void 0 ? void 0 : (ref = item.src) === null || ref === void 0 ? void 0 : ref.includes(constants.BAZAAR_VOICE);
            if (isBv) {
                bazaarVoice = item;
            } else {
                scriptsList.push(item);
            }
        });
        extractStylesFromDOM(doc, (item)=>stylesList.push(item));
        extractMetasFromDOM(doc, (item)=>metaList.push(item));
        extractLinksFromDOM(doc, (item)=>linkList.push(item));
    };
    dataRecursion(scriptsAndStyles);
    const pageLevelDetails = {};
    pageLevelDetails["pageScripts"] = scriptsList;
    pageLevelDetails["stylesList"] = stylesList;
    pageLevelDetails["metaList"] = metaList;
    pageLevelDetails["linkList"] = linkList;
    return {
        pageLevelDetails,
        bazaarVoice
    };
};
const checkStock = (backOrder, category)=>{
    return !(!category || backOrder === true || backOrder === "Yes" || category === "Install Services" || category === "Design Services");
};
const checkCartStock = function() {
    let cart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { lineItems =[]  } = cart;
    let valid = true;
    lineItems.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).map((item)=>{
        var ref;
        var ref1;
        const attributes = (ref1 = (ref = item.variant) === null || ref === void 0 ? void 0 : ref.attributes) !== null && ref1 !== void 0 ? ref1 : [];
        const cartItem = {
            quantity: get_default()(item, "quantity", 0),
            backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
            category: get_default()(attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", "")
        };
        if (valid && checkStock(cartItem.backOrder, cartItem.category)) {
            const channels = Object.values(get_default()(item, "variant.availability.channels", {}));
            if (channels.length > 0) {
                const availableQty = get_default()(channels[0], "availableQuantity", 0);
                if (availableQty < cartItem.quantity) {
                    valid = false;
                }
            }
        }
    });
    return valid;
};
const getCartItemsAnalyticsData = async (cartItems)=>{
    const bundleLocalStorage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("bundleItems");
    const bundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : [];
    // first parameter should be cartItems
    const { general  } = await (0,constants_config/* getConfig */.i)();
    const data = {
        item: [],
        itemSkus: []
    };
    cartItems.forEach((item)=>{
        var ref, ref1, ref2, ref3, ref4;
        const vsContent = JSON.parse(sessionStorage.getItem("GVS"));
        const { productNo =""  } = vsContent || {};
        item["vsContentflag"] = productNo !== "" && (item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.includes(productNo)) ? true : false;
        const skuIndex = item === null || item === void 0 ? void 0 : (ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.indexOf("-");
        const numberPart = skuIndex !== -1 ? item === null || item === void 0 ? void 0 : (ref2 = item.sku) === null || ref2 === void 0 ? void 0 : ref2.substring(0, skuIndex) : item === null || item === void 0 ? void 0 : item.sku;
        const serviceParts = JSON.parse(sessionStorage.getItem("servicePartsVs"));
        item["serviceVsContentFlag"] = serviceParts === null || serviceParts === void 0 ? void 0 : serviceParts.includes(numberPart);
        const siteWideCoupanCode = [];
        const productCouponCode = [];
        const discountPercents = [];
        let productCoupondiscount = 0;
        let siteWideDiscount = 0;
        let selectedBundles = [];
        if (bundleItems.length) {
            selectedBundles = bundleItems.find((bItem)=>{
                var ref;
                return Array.isArray(bItem === null || bItem === void 0 ? void 0 : bItem.selectedSkus) && (bItem === null || bItem === void 0 ? void 0 : (ref = bItem.selectedSkus) === null || ref === void 0 ? void 0 : ref.includes(item === null || item === void 0 ? void 0 : item.sku));
            });
        }
        const { bundleId =""  } = selectedBundles || {};
        if ((ref3 = item.discountsList) === null || ref3 === void 0 ? void 0 : ref3.length) {
            item.discountsList.forEach((discountItem)=>{
                if (discountItem.type === "sitewide") {
                    var ref;
                    // always apply sitewide discount first then remaining can be applied
                    siteWideDiscount += Number(item.unitPrice) * (discountItem.percent / 100);
                    siteWideCoupanCode.push((ref = discountItem.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                } else {
                    // there can be multiple product coupon codes
                    discountPercents.push(discountItem.percent);
                    productCouponCode.push(discountItem.code);
                }
            });
            if (discountPercents.length) {
                let priceAfterDiscount = Number(item.unitPrice) - siteWideDiscount;
                let temporaryCouponPrice;
                for (const disc of discountPercents){
                    temporaryCouponPrice = Number((priceAfterDiscount * (disc / 100)).toFixed(2));
                    priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice;
                    productCoupondiscount += temporaryCouponPrice;
                }
                productCoupondiscount = Number(productCoupondiscount.toFixed(2));
            }
        }
        const otherItem = {};
        if (item.productUpdated === true || item.productUpdated === false) {
            otherItem.productUpdated = item.productUpdated;
        }
        var ref5;
        const globalDiscount = siteWideDiscount ? siteWideDiscount : (ref5 = item === null || item === void 0 ? void 0 : item.discountAmount) !== null && ref5 !== void 0 ? ref5 : 0;
        const globalPromotionPrice = Number(item.unitPrice) - globalDiscount;
        const itemType = getCartItemType(item.category, item.businessUnitName);
        const discountedPrice = Number(item === null || item === void 0 ? void 0 : item.discountPrice) ? Number(item === null || item === void 0 ? void 0 : item.discountPrice) : Number(item === null || item === void 0 ? void 0 : item.discountUnitPrice);
        const customerFacingSKUId = item.customerFacingSKU || item.sku;
        data.itemSkus.push(item.sku);
        data.item.push({
            productInfo: {
                productBrand: general === null || general === void 0 ? void 0 : (ref4 = general.siteName) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
                productID: customerFacingSKUId,
                description: sanitizeTextForAnalytics(item.desc),
                productCategory: sanitizeTextForAnalytics(item.category),
                productName: sanitizeTextForAnalytics(item.name || item.desc || item.category),
                productColor: sanitizeTextForAnalytics(item.color) || "n/a",
                productRoom: (item === null || item === void 0 ? void 0 : item.isBundleParent) || (item === null || item === void 0 ? void 0 : item.isBundleChildItem) ? sanitizeTextForAnalytics(item.category) : sanitizeTextForAnalytics(item.productRoom || (itemType === "service" ? itemType : "non-catalog")),
                productSaleable: true,
                productStatus: !item.availableQty && item.backOrder ? "back order" : !checkStock(item.backOrder, item.category) || item.availableQty >= item.quantity || itemType === "service" ? "in stock" : "out of stock",
                productPartnerBuyNow: false,
                productBasePrice: Number(item.unitPrice),
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount || 0,
                productSuperSku: Boolean(item.superSku),
                productSalePrice: discountedPrice ? discountedPrice : Number(item.unitPrice),
                globalPromotionPrice: Number(globalPromotionPrice.toFixed(2)),
                defaultImageName: item.image,
                priceState: item.discountPercent > 0 ? "percentOff|" + item.discountPercent : item.discountAmount > 0 ? "priceOff|" + item.discountAmount : "regular price",
                productCollectionsName: sanitizeTextForAnalytics(item.productCollectionsName || item.category),
                productFindingMethod: "n/a",
                productTileName: sanitizeTextForAnalytics(item.name || item.desc),
                quantity: item.quantity,
                globalOffer: siteWideCoupanCode.join("|") || "n/a",
                globalDiscount: Number(globalDiscount.toFixed(2)),
                itemType,
                isSubscription: false,
                isRecommended: false,
                frequency: "n/a",
                isSendNow: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a",
                pdpType: bundleId || (item === null || item === void 0 ? void 0 : item.isBundleParent) || (item === null || item === void 0 ? void 0 : item.isBundleChildItem) ? "bundle" : "regular finished goods & service parts",
                bundleIds: bundleId ? "K-".concat(bundleId) : "n/a",
                visualSearch: (item === null || item === void 0 ? void 0 : item.vsContentflag) || (item === null || item === void 0 ? void 0 : item.serviceVsContentFlag) || false,
                bundleProductColors: bundleId ? sanitizeTextForAnalytics(item === null || item === void 0 ? void 0 : item.color) || "n/a" : "n/a",
                ...otherItem
            },
            quantity: item.quantity
        });
    });
    const isOrderConfirmationPage = (window === null || window === void 0 ? void 0 : window.eventPageType) === "orders:order confirmation";
    if (isOrderConfirmationPage) {
        localStorage.removeItem("bundleItems");
    }
    return data;
};
const getAssociatedServices = (attr)=>{
    var ref;
    const productServices = (ref = attr.find((item)=>item.name === "ProductServices")) !== null && ref !== void 0 ? ref : {};
    const { value =[]  } = productServices;
    return [
        ...value
    ];
};
const getFreightDiscountTotal = function() {
    let codes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    let total = 0;
    codes.forEach((e)=>{
        if (constants.FREIGHT_SHIPPING_TYPES.includes(e.name)) {
            total += Number(e.discount);
        }
    });
    return total;
};
const getCartItemData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    const { item ={} , CONFIG ={}  } = data;
    const { internationalization: { locale ="" , currencySign ="$"  } = {}  } = CONFIG;
    const { price: { discounted ={} , value: { centAmount: unitPrice = 0  } = {}  } = {} , discountedPrice ={} , variant: { attributes =[] , sku ="" , images: variantImages = []  } = {} , id ="" , totalPrice: { centAmount: totalPrice = 0  } = {} , productSlug ={} , quantity =0 , custom: { fields: { isBundleChildItem =false , isBundleParent =false , bundleSku ="" , parentBundleSku ="" , bundleParentId ="" , bundleParentProduct ={} , bundleItemPrice: { centAmount: bundleUnitPrice = ""  } = {} , bundleTotalPrice: { centAmount: bundleTotalPrice = ""  } = {} , zipCode =""  } = {}  } = {}  } = item;
    const { obj: { masterData: { current: { name: names = {} , description ={} , slug: bundleSlug = {} , masterVariant: { images =[] , attributes: bundleAttributes = []  } = {}  } = {}  } = {}  } = {}  } = bundleParentProduct;
    const { discount: { obj: { value: { money =[]  } = {}  } = {}  } = {}  } = discounted;
    var _locale;
    const bundleName = (_locale = names[locale]) !== null && _locale !== void 0 ? _locale : "";
    var _locale1;
    const bundleDesc = (_locale1 = description[locale]) !== null && _locale1 !== void 0 ? _locale1 : "";
    var ref14;
    const { value: regionBrandNameValue  } = (ref14 = attributes.find((attr)=>attr.name === "RegionBrandName")) !== null && ref14 !== void 0 ? ref14 : {};
    var ref15;
    const regionBrandName = (ref15 = regionBrandNameValue !== null && regionBrandNameValue !== void 0 ? regionBrandNameValue : item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref[locale]) !== null && ref15 !== void 0 ? ref15 : "";
    var ref16;
    const { value: productDescShortValue  } = (ref16 = attributes.find((attr)=>attr.name === "ProductDescriptionProductShort")) !== null && ref16 !== void 0 ? ref16 : {};
    var ref17;
    const { value: productDescValue  } = (ref17 = attributes.find((attr)=>attr.name === "ProductDescriptionProduct")) !== null && ref17 !== void 0 ? ref17 : {};
    var ref18, ref19;
    const productDesc = (ref19 = (ref18 = productDescShortValue === null || productDescShortValue === void 0 ? void 0 : productDescShortValue[locale]) !== null && ref18 !== void 0 ? ref18 : productDescValue) !== null && ref19 !== void 0 ? ref19 : "";
    var ref20;
    const { value: colorValue  } = (ref20 = attributes.find((attr)=>attr.name === "SKUColorFinishName")) !== null && ref20 !== void 0 ? ref20 : {};
    var ref21;
    const color = (ref21 = colorValue === null || colorValue === void 0 ? void 0 : colorValue[locale]) !== null && ref21 !== void 0 ? ref21 : "";
    var ref22;
    const { value: getShape = ""  } = (ref22 = attributes.find((attr)=>attr.name === "ProductShape")) !== null && ref22 !== void 0 ? ref22 : {};
    let shape;
    if (getShape && getShape[0] && getShape[0][locale]) {
        shape = getShape[0][locale];
    }
    var ref23;
    // Get line item details
    const { value: productSection = []  } = (ref23 = attributes.find((attr)=>attr.name === "ProductSection")) !== null && ref23 !== void 0 ? ref23 : {};
    let productRoom;
    if (productSection && productSection[0] && productSection[0][locale]) {
        productRoom = productSection[0][locale];
    }
    var ref24;
    const { value: getSize = ""  } = (ref24 = attributes.find((attr)=>attr.name === "ProductSize")) !== null && ref24 !== void 0 ? ref24 : {};
    let size;
    if (getSize && getSize[0] && getSize[0][locale]) {
        size = getSize[0][locale];
    }
    let discountedPriceProductLevel = 0;
    if (!isEmpty_default()(money)) {
        var ref25;
        var ref26;
        discountedPriceProductLevel = (Number((ref26 = (ref25 = money[0]) === null || ref25 === void 0 ? void 0 : ref25.centAmount) !== null && ref26 !== void 0 ? ref26 : 0) / 100).toFixed(2);
    }
    // Get line item price
    const { value: { centAmount: discountPriceValue = 0  } = {} , includedDiscounts =[]  } = discountedPrice;
    let discountPrice = 0;
    if (discounted) {
        const { value: { centAmount: dicCentAmount = 0  } = {}  } = discounted;
        discountPrice = (Number(dicCentAmount) / 100).toFixed(2);
    }
    if (discountedPrice) {
        discountPrice = (Number(discountPriceValue) / 100).toFixed(2);
    }
    const name = isBundleParent ? bundleName : regionBrandName;
    const desc = isBundleParent ? bundleDesc : productDesc;
    var ref27;
    const discountedPricePerQuantity = (Number((ref27 = (ref1 = includedDiscounts[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discountedAmount) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref27 !== void 0 ? ref27 : 0) / 100).toFixed(2);
    const productSku = isBundleParent ? bundleSku : sku;
    const image = isBundleParent ? (ref3 = images.at(0)) === null || ref3 === void 0 ? void 0 : ref3.url : (ref4 = variantImages.at(0)) === null || ref4 === void 0 ? void 0 : ref4.url;
    const productUnitPrice = (Number(isBundleParent ? bundleUnitPrice : unitPrice) / 100).toFixed(2);
    const productTotalPrice = (Number(isBundleParent ? bundleTotalPrice : totalPrice) / 100).toFixed(2);
    const slug = isBundleParent ? bundleSlug[locale] : productSlug[locale];
    const category = getAttributeValue(isBundleParent ? bundleAttributes : attributes, "ProductLocalCategory");
    var ref28, ref29, ref30, ref31, ref32;
    return {
        isBundleParent,
        isBundleChildItem,
        id,
        bundleParentId,
        parentBundleSku,
        sku: productSku,
        customerFacingSKU: getAttributeValue(attributes, "CustomerFacingSKU"),
        productRoom,
        slug,
        quantity,
        image,
        category,
        brand: getAttributeValue(attributes, "CustomerFacingBrand"),
        associatedServices: getAssociatedServices(attributes),
        currencySign,
        name,
        desc,
        color,
        size,
        shape,
        unitPrice: productUnitPrice,
        totalPrice: productTotalPrice,
        discountUnitPrice: (Number((ref28 = item === null || item === void 0 ? void 0 : (ref5 = item.price) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.discounted) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.centAmount) !== null && ref28 !== void 0 ? ref28 : 0) / 100).toFixed(2),
        discountPrice,
        discountedPricePerQuantity,
        discountedPriceProductLevel,
        isComboSku: attributes.some((attr)=>attr.name === "ComboSKU"),
        backOrder: (ref29 = item === null || item === void 0 ? void 0 : (ref8 = item.custom) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.isBackOrderable) !== null && ref29 !== void 0 ? ref29 : false,
        businessUnitName: (ref30 = (ref10 = attributes.find((attr)=>attr.name === "SPProductBusinessUnit")) === null || ref10 === void 0 ? void 0 : ref10.value) !== null && ref30 !== void 0 ? ref30 : "",
        additionalData: (item === null || item === void 0 ? void 0 : (ref11 = item.custom) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : ref12.roomInfo) ? (ref31 = item === null || item === void 0 ? void 0 : (ref13 = item.custom) === null || ref13 === void 0 ? void 0 : ref13.fields) !== null && ref31 !== void 0 ? ref31 : "" : "",
        discountsList: [],
        productCollectionsName: getAttributeValue(attributes, "ProductBrandNameDisplay") || getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
        addedAt: (ref32 = item === null || item === void 0 ? void 0 : item.addedAt) !== null && ref32 !== void 0 ? ref32 : "",
        zipCode
    };
};
const getBundleCombineData = (items)=>{
    const bundleChildItems = items.filter((e)=>e.isBundleChildItem);
    const cartItems = items.filter((e)=>!e.isBundleChildItem);
    const data = [];
    cartItems.forEach((e)=>{
        if (e.isBundleParent) {
            const childrens = bundleChildItems.filter((el)=>{
                return el.parentBundleSku === e.sku;
            });
            const isOutOfStock = childrens.some((e)=>e.outOfStock);
            data.push({
                ...e,
                bundleLineItems: childrens,
                bundleItemsCount: childrens.length,
                outOfStock: isOutOfStock
            });
        } else data.push(e);
    });
    return data;
};
const getChildBundleData = (items)=>{
    return items.filter((e)=>!e.isBundleParent);
};
const calculateCartData = async function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isCart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { cart: cartObject = {} , noShippingItems: noShippingItemsProps = [] , shippingItemstoCheckout =[] , quantityUpdatedFlag  } = params;
    const { shippingTotal: { centAmount: shippingTotal  } = {} , customerGroup: { id: custGroupId = ""  } = {} , customLineItems =[] , billingAddress ={} , promoCode ="" , discountCodes =[] , lineItems =[] , subtotalWithoutDiscount: { centAmount: subtotalWithoutDiscount = 0  } = {} , subtotalWithPromotion: { centAmount: subtotalWithPromotion = 0  } = {} , totalPromo: { centAmount: totalPromo = 0  } = {} , totalTax: { centAmount: totalTax = 0  } = {} , estimatedTotal: { centAmount: estimatedTotalAmount = 0  } = {}  } = cartObject;
    const shippingItemsProps = shippingItemstoCheckout;
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale ="" , currencyCode: currency = "usd"  } = {} , general: { siteName ="" , lwAppName =""  } = {}  } = CONFIG;
    const brandName = siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase();
    let voucherDiscount = 0;
    let subtotal = 0;
    let subtotalWithDiscount = 0;
    let totalPromotions = 0;
    let estimatedShipping = 0;
    let estimatedTax = 0;
    let estimatedTotal = 0;
    let promoCodes = [];
    let oldPromoCodes = [];
    let oldDiscountCodes = [];
    const cartItems = [];
    const specFiles = [];
    const outOfStockItems = [];
    const noShippingItems = [];
    let shippingDiscountsList = 0;
    const shippingDiscountsNameList = [];
    const voucherCode = [];
    oldPromoCodes = promoCode;
    oldDiscountCodes = discountCodes;
    if (lineItems.length) {
        // Get discount code details
        if (promoCode === null || promoCode === void 0 ? void 0 : promoCode.length) {
            promoCode.forEach(function() {
                let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                const { type ="" , discountedAmount: { centAmount =0  } = {} , name  } = item;
                let discountName;
                if (item.code) {
                    var ref, ref1, ref2;
                    if (discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.length) {
                        const matchedDiscountCode = discountCodes.find((dc)=>{
                            var ref, ref1;
                            return ((ref = dc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) === item.code;
                        });
                        const { discountCode: { obj: { name: disNames = {}  }  }  } = matchedDiscountCode;
                        const localeName = disNames[locale];
                        if (localeName) {
                            discountName = localeName;
                        }
                    }
                    var ref3, ref4;
                    promoCodes.push({
                        code: item.code,
                        discount: (Number((ref3 = (ref = item.discountedAmount) === null || ref === void 0 ? void 0 : ref.centAmount) !== null && ref3 !== void 0 ? ref3 : 0) / 100).toFixed(2),
                        id: (ref4 = (ref1 = discountCodes.find((code)=>code.discountCode.obj.code === item.code)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discountCode) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref4 !== void 0 ? ref4 : "",
                        type: item.type
                    });
                } else if (type === "product") {
                    const proCode = promoCodes.find((p)=>p.type === "product");
                    if (proCode) {
                        const code = proCode;
                        code.discount = (Number(code.discount) + Number(centAmount) / 100).toFixed(2);
                    } else {
                        promoCodes.unshift({
                            code: "Product Discounts",
                            discount: (Number(centAmount) / 100).toFixed(2),
                            id: "",
                            type: "product",
                            name: discountName
                        });
                    }
                } else {
                    if (promoCodes.find((p)=>p.code === (name || discountName))) {
                        const code1 = promoCodes.find((p)=>p.code === (name || discountName));
                        code1.discount = (Number(code1.discount) + Number(centAmount) / 100).toFixed(2);
                    } else {
                        centAmount && promoCodes.unshift({
                            code: item.name || discountName,
                            discount: (Number(centAmount) / 100).toFixed(2),
                            id: "",
                            type: "no-code"
                        });
                    }
                }
            });
        }
        // Get shipping promotions
        if (customLineItems.length) {
            promoCodes = promoCodes.concat(await getShippingDiscountPromoCodes(cartObject));
        }
        let lineItemsCopy = lineItems !== null && lineItems !== void 0 ? lineItems : [];
        if (isCart) {
            var ref;
            lineItemsCopy = (ref = lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter((item)=>{
                var ref, ref1;
                return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
            })) !== null && ref !== void 0 ? ref : [];
        }
        const parentBundleItems = customLineItems.filter((item)=>{
            var ref;
            return (ref = item.custom) === null || ref === void 0 ? void 0 : ref.fields.isBundleParent;
        });
        lineItemsCopy = [
            ...lineItemsCopy,
            ...parentBundleItems
        ];
        lineItemsCopy.forEach((item, i)=>{
            var ref;
            const { price: { discounted ={}  } = {} , discountedPrice ={} , variant: { availability: { channels =[]  } = {} , attributes =[]  } = {} , custom: { fields: { isBundleParent , bundleParentProduct: { obj: { masterData: { current: { masterVariant: { availability: { channels: bundleChannels = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = item;
            const { discount: { obj: { value: { permyriad , money =[] , type =""  } = {}  } = {}  } = {}  } = discounted;
            cartItems[i] = getCartItemData({
                item,
                CONFIG,
                custGroupId
            });
            if (quantityUpdatedFlag) {
                var ref1;
                if (quantityUpdatedFlag === ((ref1 = cartItems[i].customerFacingSKU) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase())) {
                    cartItems[i].productUpdated = true;
                } else {
                    cartItems[i].productUpdated = false;
                }
            }
            cartItems[i].superSku = cartItems[i].isComboSku;
            // Get line item discounts
            if (discounted) {
                const isAbs = type === "absolute";
                const isRel = !isAbs;
                if (isAbs) {
                    cartItems[i].discountAmount = Number(money[0].centAmount / 100);
                } else {
                    var ref2, ref3;
                    cartItems[i].discountPercent = Number(permyriad / 100);
                    if ((ref2 = discounted.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : ref3.name[locale]) {
                        var // sitewide discount
                        ref4;
                        (ref4 = cartItems[i].discountsList) === null || ref4 === void 0 ? void 0 : ref4.push({
                            type: "sitewide",
                            isAbs,
                            isRel,
                            percent: isRel ? cartItems[i].discountPercent : 0,
                            absolute: cartItems[i].discountAmount || 0,
                            code: discounted.discount.obj.name[locale]
                        });
                    }
                }
            }
            const { includedDiscounts =[]  } = discountedPrice;
            if (includedDiscounts === null || includedDiscounts === void 0 ? void 0 : includedDiscounts.length) {
                includedDiscounts.forEach(function() {
                    let includedDiscountItem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    const { discount: { obj: { name ={} , value: { permyriad =0 , type ="" , money =[]  }  } = {}  } = {}  } = includedDiscountItem;
                    const isAbs = type === "absolute";
                    const isRel = type === "relative";
                    if (isAbs) {
                        cartItems[i].discountAmount = Number(money[0].centAmount / 100);
                    } else if (isRel) {
                        cartItems[i].discountPercent = Number(permyriad / 100);
                    }
                    if (isAbs || isRel) {
                        const otherDiscount = name[locale];
                        const lineItemDiscountName = promoCode === null || promoCode === void 0 ? void 0 : promoCode.find((p)=>p.type === "order" && p.name === otherDiscount);
                        if (otherDiscount && lineItemDiscountName) {
                            // capture discounts like buy 1 get 1 free. could be like installation service free on design service
                            const matchedOrderDiscount = promoCodes.find((p)=>p.type === "no-code" && p.code === otherDiscount);
                            if (matchedOrderDiscount) {
                                var // sitewide discount
                                ref;
                                (ref = cartItems[i].discountsList) === null || ref === void 0 ? void 0 : ref.push({
                                    type: "sitewide",
                                    percent: isRel ? cartItems[i].discountPercent : 0,
                                    absolute: cartItems[i].discountAmount || 0,
                                    isAbs,
                                    isRel,
                                    code: matchedOrderDiscount.code
                                });
                            }
                        }
                        // find code from discountCode
                        if (discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.length) {
                            discountCodes.forEach(function() {
                                let disCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                const { discountCode: { obj: { cartDiscounts =[] , code =""  }  } = {}  } = disCode;
                                if (cartDiscounts === null || cartDiscounts === void 0 ? void 0 : cartDiscounts.length) {
                                    cartDiscounts.forEach((discountItem)=>{
                                        if (discountItem.id === includedDiscountItem.discount.obj.id) {
                                            var // All coupon discounts
                                            ref;
                                            (ref = cartItems[i].discountsList) === null || ref === void 0 ? void 0 : ref.push({
                                                type: "cart",
                                                isAbs,
                                                isRel,
                                                percent: cartItems[i].discountPercent || 0,
                                                absolute: cartItems[i].discountAmount || 0,
                                                code
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
            var ref5;
            const { availableQuantity =0  } = (ref5 = channels[Object.keys(channels).at(0)]) !== null && ref5 !== void 0 ? ref5 : {};
            var ref6;
            const { availableQuantity: availableQuantityBundle = 0  } = (ref6 = bundleChannels[Object.keys(bundleChannels).at(0)]) !== null && ref6 !== void 0 ? ref6 : {};
            cartItems[i].availableQty = isBundleParent ? availableQuantityBundle : availableQuantity;
            // Check if item is out of stock
            const isProduct = checkStock(cartItems[i].backOrder, cartItems[i].category);
            if (isProduct) {
                if (cartItems[i].availableQty < cartItems[i].quantity) {
                    cartItems[i].outOfStock = true;
                    outOfStockItems.push(cartItems[i]);
                }
            }
            // get lead time if item is back ordered
            if (cartItems[i].backOrder === true) {
                var ref7;
                const { value: leadTimeValue = 0  } = (ref7 = attributes.find((attr)=>attr.name === "RegionLeadTime")) !== null && ref7 !== void 0 ? ref7 : {};
                cartItems[i].leadTime = leadTimeValue;
            }
            var ref8;
            // Check if all items are avilable for shipping
            const { value: comboSku  } = (ref8 = attributes.find((attr)=>attr.name === "ComboSKU")) !== null && ref8 !== void 0 ? ref8 : {};
            const childSku = [];
            comboSku === null || comboSku === void 0 ? void 0 : comboSku.forEach((e)=>{
                const sku = e.find((attr)=>attr.name === "sku");
                childSku.push(sku.value);
            });
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.find((e)=>{
                return childSku === null || childSku === void 0 ? void 0 : childSku.includes(e);
            })) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            }
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.includes((ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku)) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            } else if (shippingItemsProps) {
                var ref9;
                const { warningMessage ="" , parentLineItemId =""  } = (ref9 = shippingItemsProps === null || shippingItemsProps === void 0 ? void 0 : shippingItemsProps.find((shippingItem)=>shippingItem.lineItemId === item.id)) !== null && ref9 !== void 0 ? ref9 : {};
                if (warningMessage) {
                    if (parentLineItemId) {
                        const parentIndex = cartItems.findIndex((c)=>c.id === parentLineItemId);
                        if (parentIndex >= 0 && !cartItems[parentIndex].noShipping) {
                            cartItems[parentIndex].noShipping = true;
                            noShippingItems.push(cartItems[parentIndex]);
                        }
                    } else {
                        cartItems[i].noShipping = true;
                        noShippingItems.push(cartItems[i]);
                    }
                }
            }
            var ref10;
            // Get spec files for all line items
            const { value: productResources = []  } = (ref10 = attributes.find((attr)=>attr.name === "ProductResource")) !== null && ref10 !== void 0 ? ref10 : {};
            if (productResources.length) {
                var ref11;
                const resource = (ref11 = productResources.find((arr)=>arr[1].value === "SpecPDFFileName")) !== null && ref11 !== void 0 ? ref11 : [];
                var ref12;
                const resourceUrl = (ref12 = resource.find((obj)=>obj.name === "ResourceFullWebURL")) !== null && ref12 !== void 0 ? ref12 : {};
                var _value;
                const specFileUrl = (_value = resourceUrl.value) !== null && _value !== void 0 ? _value : "";
                if (specFileUrl) specFiles.push(specFileUrl);
            }
        });
        // Get order summary price amounts
        subtotal = Number(subtotalWithoutDiscount / 100).toFixed(2);
        subtotalWithDiscount = Number(subtotalWithPromotion / 100).toFixed(2);
        totalPromotions = Number(totalPromo / 100).toFixed(2);
        estimatedTax = Number(totalTax / 100).toFixed(2);
        estimatedShipping = Number((shippingTotal !== null && shippingTotal !== void 0 ? shippingTotal : 0) / 100).toFixed(2);
        estimatedTotal = Number(estimatedTotalAmount / 100).toFixed(2);
        // checking shipping related discounts and adding it to price object
        promoCodes.forEach((promo)=>{
            if (promo.type === "shipping" || promo.type === "no-code") {
                shippingDiscountsList += Number(promo.discount);
                shippingDiscountsNameList.push(promo.code);
            }
        });
        // Add shipping promotions to total promotions
        promoCodes.filter((item)=>item.type === "shipping").forEach((item)=>{
            estimatedShipping = Number(estimatedShipping) + Number(item.discount);
        });
    }
    promoCodes.forEach((itm)=>{
        voucherCode.push(itm.code);
        voucherDiscount += Number(itm.discount);
    });
    var _pageObj;
    const page = (_pageObj = window.pageObj) !== null && _pageObj !== void 0 ? _pageObj : {};
    const { category: { subCategoryName =""  } = {}  } = page;
    const cartItemsData = getBundleCombineData(cartItems);
    let analyticsCartItems = [];
    if (subCategoryName === "pdp") {
        analyticsCartItems = await getCartItemsAnalyticsData(cartItemsData);
    } else {
        const cartItemsAllData = getChildBundleData(cartItems);
        analyticsCartItems = await getCartItemsAnalyticsData(cartItemsAllData);
    }
    if (analyticsCartItems === null || analyticsCartItems === void 0 ? void 0 : analyticsCartItems.itemSkus) {
        delete analyticsCartItems.itemSkus;
    }
    const cart = {
        cartID: cartObject === null || cartObject === void 0 ? void 0 : cartObject.id,
        cartNumber: cartObject === null || cartObject === void 0 ? void 0 : cartObject.key,
        price: {
            basePrice: subtotal || 0,
            voucherCode: voucherCode.length ? voucherCode.join("|") : "n/a",
            voucherDiscount: voucherDiscount ? Number(voucherDiscount.toFixed(2)) : 0,
            globalOffer: shippingDiscountsNameList ? shippingDiscountsNameList.join("|") || "n/a" : "n/a",
            globalDiscount: shippingDiscountsList ? Number(shippingDiscountsList.toFixed(2)) : 0,
            currency: currency.toLowerCase(),
            taxRate: estimatedTax || "n/a",
            shipping: estimatedShipping ? Number(estimatedShipping) : "n/a",
            priceWithTax: estimatedTotal || 0,
            cartTotal: subtotal || 0,
            couponCode: "n/a",
            couponDiscount: 0,
            orderCouponCode: "n/a",
            orderCouponDiscount: 0,
            shippingMethod: "ground"
        },
        ...analyticsCartItems
    };
    cartItemsData.forEach((e)=>{
        var ref;
        const matchedItem = analyticsCartItems === null || analyticsCartItems === void 0 ? void 0 : (ref = analyticsCartItems.item) === null || ref === void 0 ? void 0 : ref.find((i)=>i.productInfo.productID === e.customerFacingSKU);
        if (matchedItem) {
            e.customProductInfo = sanitizeDOMString(JSON.stringify(matchedItem));
        }
    });
    cartItemsData.sort((prev, curr)=>{
        return new Date(curr.addedAt) - new Date(prev.addedAt);
    });
    sanitizeObject(cartItemsData);
    sanitizeObject(cart);
    const freightDiscountTotal = getFreightDiscountTotal(promoCodes);
    const shippingAllTotal = (0,utils/* getShippingAllTotal */.hH)(customLineItems, locale);
    const shippingRestrictedItems = noShippingItems.map((item)=>{
        if (item.isBundleChildItem) {
            const parrentItem = cartItemsData.find((e)=>e.sku === item.parentBundleSku);
            return {
                ...item,
                parentBundleId: parrentItem.id
            };
        } else return item;
    });
    return {
        oldPromoCodes,
        oldDiscountCodes,
        cartItems: cartItemsData,
        outOfStockItems,
        noShippingItems: shippingRestrictedItems,
        subtotal,
        subtotalWithDiscount,
        totalPromotions,
        estimatedTax,
        estimatedShipping,
        estimatedTotal,
        shippingTotal: shippingTotal / 100,
        promoCodes,
        specFiles,
        shippingDiscountsNameList,
        shippingDiscountsList,
        cart,
        freightDiscountTotal,
        shippingAllTotal,
        brandName,
        billingAddress,
        lwAppName
    };
};
const getShippingDiscountPromoCodes = async (cartObject)=>{
    const locale = await (0,constants_config/* getConfig */.i)().then((config)=>get_default()(config, "internationalization.locale", ""));
    const { customLineItems =[] , discountCodes =[]  } = cartObject;
    const promoCodes = [];
    customLineItems.forEach(function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { discountedPrice: { includedDiscounts =[]  } = {}  } = item;
        includedDiscounts.forEach(function() {
            let disc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var ref;
            const { discountedAmount: { centAmount: discountedAmountCent = 0  } = {} , discount: { obj: { requiresDiscountCode , id ="" , name: objName = {}  } = {}  } = {}  } = disc;
            const discountedAmount = Number(discountedAmountCent) / 100;
            var _locale;
            const discountName = (_locale = objName[locale]) !== null && _locale !== void 0 ? _locale : "";
            var ref1;
            const name = (ref1 = item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref[locale]) !== null && ref1 !== void 0 ? ref1 : "";
            // get shipping promotions with codes
            if (requiresDiscountCode) {
                var ref2;
                var ref3;
                const dicountIdObj = (ref3 = discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.find((disc)=>{
                    var ref, ref1, ref2;
                    return ((ref2 = (ref = disc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.cartDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === id;
                })) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const discountId = (ref4 = (ref2 = dicountIdObj.discountCode) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref4 !== void 0 ? ref4 : "";
                if (!promoCodes.find((code)=>code.id === discountId)) {
                    promoCodes.push({
                        code: discountName,
                        discount: discountedAmount.toFixed(2),
                        id: discountId,
                        type: "shipping",
                        name
                    });
                } else {
                    const index = promoCodes.findIndex((code)=>code.id === discountId);
                    promoCodes[index].discount = (Number(promoCodes[index].discount) + discountedAmount).toFixed(2);
                }
            } else {
                if (!promoCodes.find((p)=>p.code === name)) {
                    promoCodes.push({
                        code: discountName,
                        discount: discountedAmount.toFixed(2),
                        id: "",
                        type: "shipping",
                        name
                    });
                } else {
                    const index1 = promoCodes.findIndex((p)=>p.code === name);
                    promoCodes[index1].discount = (Number(promoCodes[index1].discount) + discountedAmount).toFixed(2);
                }
            }
        });
    });
    return promoCodes;
};
const getCartItemType = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", businessUnitName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!category && !businessUnitName) {
        return "n/a";
    }
    category = category.toLowerCase();
    businessUnitName = businessUnitName.toLowerCase();
    if (category === "install services" || category === "design services" || category === "services") {
        return "service";
    }
    if (category === "samples") {
        return "sample";
    }
    if (category === "parts" || category === "service parts" || businessUnitName.indexOf("serviceparts") !== -1 || businessUnitName === "service parts") {
        return "part";
    }
    return "product";
};
const sanitizeDOMString = (property)=>typeof property === "string" ? browser_default().sanitize(property) : property;
const decodeHtmlCharacters = (str)=>{
    return str.replace(/&amp;/g, "&").replace(/&#8217;/g, "'").replace(/&nbsp;/g, " ");
};
const sanitizeAndDecodeHtml = (str)=>{
    const decodeVal = decodeHtmlCharacters(str);
    return sanitizeInnerHtml(decodeVal);
};
const updateObject = (objRef, objKey)=>{
    const copyObject = {
        ...objRef
    };
    copyObject[objKey] = sanitizeDOMString(copyObject[objKey]);
    return copyObject;
};
const sanitizeObject = (obj)=>{
    if (typeof obj === "object" && obj !== null) {
        Object.keys(obj).forEach((objKey)=>{
            if (typeof obj[objKey] === "string") {
                return updateObject(obj, objKey);
            }
            return sanitizeObject(obj[objKey]);
        });
    }
    return obj;
};
const handleZipDownload = async (files, filename, success, err)=>{
    for(let i = 0; i < files.length; i++){
        if (!files[i].includes("http")) {
            files.splice(i, i + 1);
            i--;
        }
    }
    try {
        const payload = {
            files: files
        };
        if (filename) {
            payload.downloadFileName = filename;
        } else {
            const crypto1 = window.crypto || window.msCrypto;
            const array = new Uint32Array(1);
            const rand = crypto1.getRandomValues(array)[0];
            const { general  } = await (0,constants_config/* getConfig */.i)();
            var ref;
            const brandName = (ref = general === null || general === void 0 ? void 0 : general.siteName) !== null && ref !== void 0 ? ref : "";
            const randomId = Math.floor(rand * 10000000).toString(16);
            payload.downloadFileName = "".concat(brandName, "-").concat(randomId);
        }
        const { payload: res  } = await store_0/* store.dispatch */.h.dispatch((0,genericSlice/* zipDownload */.t8)(payload)) || {};
        if (res) {
            let downloadFileName = filename + ".zip";
            if (!filename) {
                const disposition = content_disposition_default().parse(res.headers["content-disposition"]);
                downloadFileName = disposition.parameters.filename;
            }
            file_download_default()(res.data, downloadFileName);
            if (success) success();
        }
    } catch (ex) {
        // temp
        // log.error(ex)
        if (err) err();
    }
};
const isEmbeddedElement = (script)=>{
    if (script) {
        const doc = new DOMParser().parseFromString(script, "text/html");
        if (doc.body.innerHTML) {
            return true;
        }
    }
    return false;
};
const isEmbeddedStyles = (script)=>{
    const stylesList = [];
    if (script) {
        const doc = new DOMParser().parseFromString(script, "text/html");
        extractStylesFromDOM(doc, (item)=>stylesList.push(item));
    }
    const resultVal = {
        styles: stylesList
    };
    return resultVal;
};
const getSiteWideModal = (e, url)=>{
    if ((url === null || url === void 0 ? void 0 : url.indexOf("http")) === 0) {
        e.preventDefault();
        window.handleShowModal(url);
    }
};
const getAttributeValue = (attributes, name)=>{
    var ref;
    const { value =""  } = (ref = attributes.find((attr)=>attr.name === name)) !== null && ref !== void 0 ? ref : {};
    return value;
};
const createIdFromString = (text)=>{
    const testData = text !== null && text !== void 0 ? text : "";
    testData.replace(constants_regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().replace(/ /g, "-").trim();
    return testData;
};
const capitalizeFirstName = (firstname)=>{
    firstname = (firstname === null || firstname === void 0 ? void 0 : firstname.charAt(0).toUpperCase()) + (firstname === null || firstname === void 0 ? void 0 : firstname.slice(1));
    return firstname;
};
const setFocus = (id)=>{
    var ref;
    (ref = document.getElementById(id)) === null || ref === void 0 ? void 0 : ref.focus();
};
const preventBodyScroll = (status)=>{
    if (status) {
        document.body.classList.add("scroll-lock", "modal-open");
        document.getElementsByTagName("html")[0].classList.add("scroll-lock", "modal-open");
    } else {
        document.body.classList.remove("scroll-lock", "modal-open");
        document.getElementsByTagName("html")[0].classList.remove("scroll-lock", "modal-open");
    }
};
const preventBodyScrollTab = (status)=>{
    if (status) {
        document.body.classList.add("gbh-of-scroll");
    } else {
        document.body.classList.remove("gbh-of-scroll");
    }
};
const sanitizeText = (text)=>{
    return text === null || text === void 0 ? void 0 : text.replace(/<\/?[^>]+(>|$)/g, "");
};
/**
 * Safely parses a JSON string, returning null for invalid or undefined input.
 * @param {string} str
 * @return {any|null}
 */ const safeParseJSON = (str)=>{
    if (!str || str === "undefined") return null;
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
};
// Sort
const getSortFromUrl = ()=>{
    const url = new URL(location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const getSelectedSort = (text, query)=>{
    switch(query){
        case "bestSeller_l+asc":
            return {
                name: text.bestSellers,
                query: "bestSeller_l+asc"
            };
        case "price+desc":
            return {
                name: text.priceDesc,
                query: "price+desc"
            };
        case "price+asc":
            return {
                name: text.priceAsc,
                query: "price+asc"
            };
        case "CollapseSort_s+asc":
        case "NonCollapseSort_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "CollapseSort_s+desc":
        case "NonCollapseSort_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "productName_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "productName_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "title_s+asc":
        case "cardTitle_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "title_s+desc":
        case "cardTitle_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "new":
            return {
                name: text.newToOld,
                query
            };
        case "old":
            return {
                name: text.oldToNew,
                query
            };
        // Temp Fix AToZ & ZToA
        case "atoz":
            return {
                name: text.AToZ,
                query
            };
        case "ztoa":
            return {
                name: text.ZToA,
                query
            };
    }
    return {
        name: text.featured,
        query: ""
    };
};
const replaceSearchUrl = (searchTerm, param)=>{
    const url = new URL(window.location.href);
    let searchUrl = url.search;
    const searchArray = searchUrl.split("&");
    const index = searchUrl.split("&").findIndex((param)=>param.includes(searchTerm));
    if (param === "" || param === undefined) {
        searchArray.splice(index, 1);
        const urlIndex = searchArray.findIndex((searchParam)=>searchParam.includes("?"));
        searchUrl = searchArray.length !== 0 ? urlIndex === -1 ? "?".concat(searchArray.join("&")) : searchArray.join("&") : searchArray.join("&");
    } else if (index !== -1) {
        searchArray.splice(index, 1, "".concat(searchTerm, "=").concat(param));
        if (!index) {
            searchArray[index] = "?".concat(searchArray[index]);
        }
        searchUrl = searchArray.join("&");
    } else {
        searchUrl = searchUrl ? searchUrl + "&".concat(searchTerm, "=").concat(param) : "?".concat(searchTerm, "=").concat(param);
    }
    history.replaceState(window.location.pathname, document.title, url.pathname + searchUrl);
};
const getPriceSortQuery = ()=>{
    const persona = getUserPersona();
    return "priceList.".concat(persona, ".finalPrice_d");
};
const getSortItemBasedOnURL = (text, defaultItem)=>{
    const urlParams = window.location.search;
    let queryVal = "";
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
    }
    const query = getSortFromUrl();
    const selectedSortItem = query ? getSelectedSort(text, query) : defaultItem || null;
    return selectedSortItem;
};
// *****
const filterBackEndJson = (json)=>{
    const newJson = {};
    for(const k in json){
        if (k !== "allowedComponents") {
            if (typeof json[k] === "object" && !Array.isArray(json[k]) && json[k] !== null) {
                newJson[k] = filterBackEndJson(json[k]);
            } else {
                newJson[k] = json[k];
            }
        }
    }
    return newJson;
};
// Filter
const formatFacetName = (name, filter, facetLabels)=>{
    var ref, ref1;
    let val = facetLabels && facetLabels[name === null || name === void 0 ? void 0 : name.replace(/^\*{2}/, "")] ? facetLabels[name === null || name === void 0 ? void 0 : name.replace(/^\*{2}/, "")] : (ref1 = (ref = name === null || name === void 0 ? void 0 : name.replace(/\./g, "/")) === null || ref === void 0 ? void 0 : ref.replace(/_/g, " ")) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "");
    if (filter) val += " - ".concat(filter);
    return val;
};
const formatPriceRange = function(filter) {
    let isAnnsacksPlp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const values = filter.match(/\d+/g);
    if (Array.isArray(values)) {
        var ref, ref1;
        return isAnnsacksPlp ? "$".concat((ref = Number(values[0])) === null || ref === void 0 ? void 0 : ref.toLocaleString(), " - $").concat((ref1 = Number(values[1])) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) : "$".concat(values[0], " - $").concat(values[1]);
    } else {
        return null;
    }
};
const resetFilterUrl = ()=>{
    let searches = location.search.split("&");
    searches = searches.filter((item)=>constants.queryParamsToPersist.filter((param)=>item.includes(param)).length);
    const url = searches.join("&");
    window.history.replaceState({}, document.title, window.location.pathname + (url.includes("?") ? url : url && "?".concat(url)));
};
const getFacetsFromUrl = function() {
    let marketParamValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const currFilters = [];
    const url = new URL(window.location.href);
    const urlParams = url.searchParams.get("facets");
    const aMarkettingParameters = marketParamValues === null || marketParamValues === void 0 ? void 0 : marketParamValues.marketParamValues;
    if (urlParams) {
        urlParams.replace("?", "").split(",").forEach((filter)=>{
            if (filter.split(":")[0] !== "title" && filter.split(":")[0] !== "id" && filter.split(":")[0] !== "keyword" && filter.split(":")[0] !== "compare" && filter.split(":")[0] !== "back" && filter.split(":")[0] !== "sort" && filter.split(":")[0] !== "activeTab" && filter.split(":")[0] !== "tab" && filter.split(":")[0] !== "skuSearch" && filter.split(":")[0] !== "service" && !(aMarkettingParameters === null || aMarkettingParameters === void 0 ? void 0 : aMarkettingParameters.includes(filter.split(":")[0]))) {
                const facet = decodeURIComponent(filter.split(":")[0]);
                if (facet === "wcmmode") return;
                const decode = decodeURIComponent(filter);
                const values = decode && decode.split(":")[1].split("|");
                let display = decode && decode.split(":")[1].split("|");
                display = display.map((val)=>val.replace(constants_regex/* FILTER_PARAM_REGEX */.GK, " "));
                const filterName = decode.split(":")[0];
                display = display.map((d)=>d.replace(/\\/g, ""));
                // format price range filter
                if (filterName === "Price_Range") {
                    display = display.map((range)=>formatPriceRange(range));
                }
                // Check if the filter attribute already exists
                let checkFacet = false;
                currFilters.forEach((item)=>{
                    checkFacet = Object.values(item).includes(facet);
                });
                // Add a new filter or add values to existing filter
                if (!checkFacet) {
                    currFilters.push({
                        facet: facet,
                        value: values,
                        display: display
                    });
                } else {
                    currFilters.forEach((fc)=>{
                        if (facet === fc.facet) {
                            fc.value.push(values);
                            fc.display.push(display);
                        }
                    });
                }
            }
        });
    }
    return currFilters.filter((currFilter)=>currFilter.facet !== "sort");
};
const getParamsFromUrl = async ()=>{
    const urlParams = window.location.search;
    const decode = decodeURIComponent(urlParams);
    const value = decode && decode.split("=")[1].split(",");
    return value;
};
const retainSearchQueryParams = (type)=>{
    const currentSearch = window.location.search;
    // Strip tab parameter from URL before storing
    // The tab will be added dynamically when restoring based on which tab is active
    const urlParams = new URLSearchParams(currentSearch);
    urlParams.delete("tab");
    const searchWithoutTab = urlParams.toString() ? "?".concat(urlParams.toString()) : "";
    // Load existing tab details or create new object
    const existingData = sessionStorage.getItem("SRPTabDetails");
    const srpTabDetails = existingData ? JSON.parse(existingData) : {};
    // Store the URL without tab parameter
    srpTabDetails[type] = searchWithoutTab;
    // Save back to sessionStorage
    sessionStorage.setItem("SRPTabDetails", JSON.stringify(srpTabDetails));
};
const removeSearchQueryParams = ()=>{
    sessionStorage.removeItem("SRPTabDetails");
};
const checkIfUserExists = (email)=>api/* apim.post */.TH.post("/customer/lookup", {
        email
    });
const removeHtmlWithoutHttps = (str)=>{
    const htmlPositions = [];
    const htmlPattern = /.html/g;
    let match;
    let formattedString = str;
    while(match = htmlPattern.exec(str) !== null){
        htmlPositions.push(match.index);
    }
    if (htmlPositions.length) {
        for(let i = 0; i < htmlPositions.length; i++){
            const htmlPostion = formattedString.indexOf(".html");
            const herfStartingPosition = formattedString.lastIndexOf('"', htmlPostion);
            const subStr = formattedString.substring(herfStartingPosition + 1, herfStartingPosition + 6);
            if (!subStr.includes("http")) {
                formattedString = formattedString.slice(0, htmlPostion) + formattedString.slice(htmlPostion + 5);
            }
        }
    }
    return formattedString;
};
const getShortenedUrl = async function() {
    let uUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", generalConfigData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const general = generalConfigData !== null && generalConfigData !== void 0 ? generalConfigData : (await (0,constants_config/* getConfig */.i)()).general;
    if (!isEmpty_default()(general)) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRemovedUrl = removeHtmlWithoutHttps(uUrl);
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getShortenedUrlPath = (uUrl)=>{
    const { generic: { globalConfig: { general ={}  } = {}  } = {}  } = (store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) || {};
    const { shortendPagePath =""  } = general;
    if (shortendPagePath) {
        const htmlRemovedUrl = removeHtmlWithoutHttps(uUrl);
        const shortUrlRegEx = new RegExp(shortendPagePath, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getAuthShortenedUrl = async (name)=>{
    const { general ={}  } = await (0,constants_config/* getConfig */.i)();
    const url = general[name];
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRegExp = new RegExp(".html", "g");
        const htmlRemovedUrl = "".concat(url === null || url === void 0 ? void 0 : url.replace(htmlRegExp, ""));
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getShortenedUrlwithGeneral = (uUrl, general)=>{
    if (!isEmpty_default()(general)) {
        const { shortendPagePath =""  } = general;
        const htmlRemovedUrl = removeHtmlWithoutHttps(uUrl);
        const shortUrlRegEx = new RegExp(shortendPagePath, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getFacetField = (facetFields, facetQuery)=>{
    return Array.isArray(facetFields) ? facetFields.find((f)=>f === facetQuery) : facetFields === facetQuery;
};
const getAllFilterQueries = function(componentProps) {
    let fusion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, marketParamValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let currFilters = [];
    const urlFilters = getFacetsFromUrl(marketParamValues);
    var ref;
    const facetFields = (ref = fusion["facet.field"]) !== null && ref !== void 0 ? ref : [];
    var ref1;
    const facetLabels = (ref1 = fusion === null || fusion === void 0 ? void 0 : fusion.facet_labels) !== null && ref1 !== void 0 ? ref1 : {};
    if (urlFilters.length > 0) {
        urlFilters.forEach((f)=>{
            let facetQuery = f.facet === "Price_Range" ? "Price_Range" : Object.keys(facetLabels).find((key)=>facetLabels[key] === f.facet.replace(/_/g, " "));
            const isValidFacet = getFacetField(facetFields, facetQuery);
            if (isValidFacet) facetQuery = "**".concat(facetQuery);
            if (facetQuery) {
                f.facet = facetQuery;
            }
        });
    }
    // Set pre-selected filters
    if ((urlFilters === null || urlFilters === void 0 ? void 0 : urlFilters.length) === 0 && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName) && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue) && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName) !== "" && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue) !== "") {
        let facetQuery = componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName;
        const isValidFacet = getFacetField(facetFields, facetQuery);
        if (isValidFacet) {
            facetQuery = "**".concat(facetQuery);
        }
        currFilters.push({
            facet: facetQuery,
            value: [
                componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue.replace(/"/g, '\\"')
            ],
            display: [
                componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue
            ]
        });
    }
    currFilters = [
        ...currFilters,
        ...urlFilters
    ];
    return currFilters;
};
const convertStringToBoolean = (str)=>{
    if (typeof str === "string") {
        if (str.toLowerCase() === "true") {
            return true;
        } else if (str.toLowerCase() === "false") {
            return false;
        } else {
            return false;
        }
    } else if (typeof str === "boolean") {
        return str;
    } else {
        return false;
    }
};
const resetUrl = ()=>{
    const url = new URL(window.location.href);
    const searchUrl = url.search;
    const searchArray = searchUrl.split("&");
    const searchedUrl = searchArray.length ? searchArray[0] : "";
    history.replaceState(window.location.pathname, document.title, url.pathname + searchedUrl);
};
const formatMultiSelectFacets = (data)=>{
    var ref;
    var ref1;
    const facets = Object.entries((ref1 = (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) !== null && ref1 !== void 0 ? ref1 : {}).map((fields)=>({
            [fields[0]]: fields[1]
        }));
    let facetField = data === null || data === void 0 ? void 0 : data.fusion["facet.field"];
    if (facetField) {
        if (typeof facetField === "string") facetField = [
            facetField
        ];
        facetField.forEach((item)=>{
            facets.forEach((filter, index)=>{
                if (filter[item]) {
                    const obj = {
                        ["**".concat(item)]: filter[item]
                    };
                    facets.splice(index, 1, obj);
                }
            });
        });
    }
    const result = Object.assign({}, ...facets);
    return result;
};
const addADALink = (ele, params)=>{
    const a = ele === null || ele === void 0 ? void 0 : ele.getElementsByTagName("a");
    if (a && a.length) {
        for(let i = 0; i < a.length; i++){
            const anchor = a[i];
            if (!anchor.hasAttribute("aria-label")) {
                const innerHtml = anchor.innerHTML;
                anchor.setAttribute("aria-label", anchor.getAttribute("target") === "_blank" ? params.translate("kf.pdp.label.aria.dangerouslyLinkADABlankPage", {
                    innerHtml
                }) : params.translate("kf.pdp.label.aria.dangerouslyLinkADA", {
                    innerHtml
                }));
            }
        }
    }
};
const removeAndCleanLink = (link)=>{
    return link ? link === null || link === void 0 ? void 0 : link.split("/content/kohler/us").join("").replace(".html", "") : link;
};
const mapStateToCountryHandler = function() {
    let countryData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], stateData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const data = [];
    countryData.forEach((country)=>{
        data.push({
            code: country.value,
            name: country.text,
            states: []
        });
    });
    stateData.forEach((state)=>{
        var ref, ref1, ref2;
        const countryCode = (ref = state.value) === null || ref === void 0 ? void 0 : ref.split(":")[1];
        (ref1 = data.find((country)=>country.code === countryCode)) === null || ref1 === void 0 ? void 0 : ref1.states.push({
            code: (ref2 = state.value) === null || ref2 === void 0 ? void 0 : ref2.split(":")[0],
            name: state.text
        });
    });
    return data;
};
const addToRecentlyViewed = (id)=>{
    const { general  } = (0,constants_config/* getConfig */.i)();
    var ref;
    const max = (ref = general === null || general === void 0 ? void 0 : general.recentlyViewedMax) !== null && ref !== void 0 ? ref : 10;
    let items = localStorage.getItem("recently-viewed") ? JSON.parse(localStorage.getItem("recently-viewed")) : [];
    if (id) {
        items = items.filter((i)=>i !== id);
        items.unshift(id);
        const newItems = items.slice(0, max);
        localStorage.setItem("recently-viewed", JSON.stringify(newItems));
    }
};
const getModelSuggestionSkuListFromData = (data)=>{
    const skuList = [];
    data.map((variants)=>{
        var ref;
        const labelList = (ref = variants === null || variants === void 0 ? void 0 : variants.customerFacingSKUList_ss) !== null && ref !== void 0 ? ref : get_default()(variants, "variantList.sku_ss");
        if (Array.isArray(labelList)) {
            labelList.forEach((sku)=>skuList.push(sku));
        } else if (labelList) {
            skuList.push(labelList);
        }
    });
    return skuList;
};
const handleModelNumberSuggestion = (resp)=>{
    const { response: { numFound , docs  }  } = resp;
    if (numFound < 1) {
        return {
            suggestions: [],
            invalidModelNumber: numFound === 0 ? true : false
        };
    } else {
        var ref;
        const skuList = (ref = getModelSuggestionSkuListFromData(docs)) !== null && ref !== void 0 ? ref : [];
        return {
            suggestions: skuList
        };
    }
};
const closeModalAnalytics = (productInfo)=>{
    setTimeout(()=>{
        const modalCloseButtons = document.getElementsByClassName("bv-mbox-close");
        if (!window.modalCloseEventLoaded && (modalCloseButtons === null || modalCloseButtons === void 0 ? void 0 : modalCloseButtons.length)) {
            // this means review contents are loaded
            const modalCloseButton = modalCloseButtons[0];
            const clickEvent = function() {
                const page = window.pageObj || {};
                const eventInfo = {
                    eventAction: "pdp:modal:write a review:close",
                    eventName: "pdp:modal:write a review:close",
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "close",
                    internalLinkPosition: "pdp",
                    internalLinkType: "pdp:close",
                    internalLinkZoneName: "pdp:modal:write a review",
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                };
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productInfo: productInfo ? JSON.parse(productInfo).productInfo : null
                });
                modalCloseButton.removeEventListener("click", clickEvent);
                delete window.checker;
                delete window.modalCloseEventLoaded;
            };
            modalCloseButton.addEventListener("click", clickEvent);
            window.modalCloseEventLoaded = true;
        } else if (!window.modalCloseEventLoaded && (!window.checker || window.checker < 10)) {
            var _checker;
            window.checker = ((_checker = window.checker) !== null && _checker !== void 0 ? _checker : 0) + 1;
            closeModalAnalytics(productInfo);
        }
    }, 2000);
};
const sanitizeTextArticle = (text)=>{
    return text.replace(/<\/?[^>]+(>|$)/g, "").replace(/(\r\n|\n|\r)/gm, "");
};
const cleanText = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.replace(/<\/?[^>]+(>|$)/g, "");
};
const appendPresetToUrl = function(assetAccountName, swatchUrl, assetId, width) {
    let presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isReel = arguments.length > 5 ? arguments[5] : void 0;
    const { Desktop , MobileLandscape ="" , MobilePortrait ="" , LandscapeCategory  } = presetConfigs;
    let preset = "";
    if (width <= 768) {
        if (width <= 425) {
            if (MobilePortrait) {
                preset = MobilePortrait;
            }
        } else {
            if (MobileLandscape) {
                preset = MobileLandscape;
            }
        }
    } else {
        preset = isReel ? Desktop : MobileLandscape;
    }
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(preset);
};
const getPresetThumbnailUrl = (assetAccountName, swatchUrl, assetId, presetConfigs)=>{
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const checkIsFavorite = (items)=>{
    const page = window.location.origin + window.location.pathname;
    const checkLink = (item)=>{
        let link = {};
        try {
            var ref, ref1;
            link = new URL((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
        return link.origin + link.pathname === page ? true : false;
    };
    const isFavorite = (el)=>{
        var ref, ref1, ref2;
        // check if asset url is added to favorites
        if (((ref = el.dataset) === null || ref === void 0 ? void 0 : ref.asset) && items.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === el.dataset.url;
        })) {
            return items.find((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === el.dataset.url;
            }).id;
        }
        if (((ref1 = el.dataset) === null || ref1 === void 0 ? void 0 : ref1.asset) && items.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === window.location.origin + el.dataset.url;
        })) {
            return items.find((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === window.location.origin + el.dataset.url;
            }).id;
        }
        // check if current page url is added to favorites
        if (!((ref2 = el.dataset) === null || ref2 === void 0 ? void 0 : ref2.asset) && items.find((item)=>checkLink(item))) {
            return items.find((item)=>checkLink(item)).id;
        }
        return false;
    };
    const favElements = [
        ...document.getElementsByClassName("fav-trigger"),
        ...document.getElementsByClassName("fav-video-trigger")
    ];
    favElements.forEach((elem)=>{
        const id = isFavorite(elem);
        if (id) {
            elem.classList.add("favorite-filled");
            elem.dataset.id = id;
        }
    });
};
const sanitizeProductName = (name)=>name.replace(/®|™/g, "");
/**
 *
 * @param {Boolean} isEnable
 */ const toggeleBodyScroll = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("remove-scroll");
    } else {
        document.body.classList.remove("remove-scroll");
    }
};
const toggeleBodyClass = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("add-body-class");
    } else {
        document.body.classList.remove("add-body-class");
    }
};
const toggeleBodyClassAfterLogin = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("add-body-class-after-login");
    } else {
        document.body.classList.remove("add-body-class-after-login");
    }
};
const formatOfflineRegisterPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "register_offline_pro") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const formatRegistrationSuveryPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "medallia_survey_form") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const formatOnlineRegisterPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "register_online_prod") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const nbspSanitizeInnerHtml = (property)=>{
    const sanitizedHtml = browser_default().sanitize(property).replace(/&nbsp;/g, " ");
    const parsedHtml = (0,html_react_parser/* default */.ZP)(sanitizedHtml);
    return parsedHtml;
};
const getDefaultProfileAddress = (profile)=>{
    const { firstName ="" , lastName ="" , defaultShippingAddressId ="" , addresses =[]  } = profile;
    const prefilledCustomerDetails = {
        firstName: {
            value: firstName
        },
        lastName: {
            value: lastName
        }
    };
    if (addresses.length) {
        const defaultAddress = addresses.find((item)=>item.id === defaultShippingAddressId);
        if (!isEmpty_default()(defaultAddress)) {
            const { city , postalCode , state , streetName  } = defaultAddress;
            prefilledCustomerDetails["city"] = {
                value: city
            };
            prefilledCustomerDetails["address"] = {
                value: streetName
            };
            prefilledCustomerDetails["zipCode"] = {
                value: postalCode
            };
            prefilledCustomerDetails["state"] = {
                value: state
            };
        }
    }
    return prefilledCustomerDetails;
};
const getPathFromUrl = (url)=>{
    return url.split(/[?#]/)[0];
};
const validatePhone = function() {
    let phone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    if (/^\d+$/.test(phone) && phone.length > 9) return true;
    return false;
};
const getCityList = (url, brand, searchTerm)=>{
    return api/* apim.get */.TH.get(url, {
        params: {
            $format: "json",
            brand,
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(searchTerm, "') eq true")
        }
    });
};
const storeFilterData = (filterData)=>{
    const storeFinalData = {};
    delete filterData["jcr:primaryType"];
    const filterKeys = Object.keys(filterData);
    filterKeys.forEach((element)=>{
        delete filterData[element]["jcr:primaryType"];
        const categoryKeys = filterData[element]["categoryName"];
        const categoryList = filterData[element]["list"];
        delete categoryList["jcr:primaryType"];
        const categoryListValues = Object === null || Object === void 0 ? void 0 : Object.values(filterData[element]["list"]);
        const filteredCategoryValues = Object === null || Object === void 0 ? void 0 : Object.values(categoryListValues);
        const finalFacets = filteredCategoryValues.map((x)=>({
                label: x.displayName,
                query: x.bingName
            }));
        storeFinalData[categoryKeys] = finalFacets;
    });
    return storeFinalData;
};
const checkAlphanumeric = (value)=>{
    const pattern = /^[A-Za-z0-9 ]+$/;
    if (pattern.test(value)) {
        return true;
    }
    return false;
};
const checkAlphabetOnly = (value)=>{
    return constants_regex/* ALPHABET_WITH_SPACE_REGEX.test */.si.test(value);
};
const getRandom = ()=>{
    if (!isServer) {
        const crypto1 = window.crypto || window.msCrypto;
        const array = new Uint32Array(1);
        return crypto1.getRandomValues(array)[0];
    } else {
        return parseInt(new Date().getTime());
    }
};
const getAnalyticsUrl = (url)=>(url.indexOf("http") === -1 ? window.location.origin : "") + url;
const getPageInfo = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    return getState && getState("page") || {};
};
const formatDate = async (date)=>{
    const { internationalization: { locale: currentLocale  }  } = await (0,constants_config/* getConfig */.i)();
    const d = new Date(date);
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    return d.toLocaleDateString(currentLocale, options);
};
const downloadArticle = async function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, successCallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{}, downloadSuccess = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", downloadFailure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { target: { classList: targetClassList = {}  } = {}  } = e;
    try {
        targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.add(constants.DOWNLOAD_SPINNER);
        const { status , data , headers  } = await api/* apim.get */.TH.get("catalog/pdf-file-download?page=".concat(url), {
            responseType: "blob"
        });
        if (status === 200) {
            let filenameVal;
            if (headers["content-disposition"]) {
                const { parameters: { filename =""  } = {}  } = content_disposition_default().parse(headers["content-disposition"]);
                filenameVal = filename;
            } else {
                filenameVal = "zip";
            }
            file_download_default()(data, filenameVal);
            typeof successCallback === "function" && successCallback();
            store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
                message: downloadSuccess,
                isVisible: true
            }));
            targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        } else {
            store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
                message: downloadFailure,
                isVisible: true
            }));
            targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        }
    } catch (ex) {
        targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
            message: downloadFailure,
            isVisible: true
        }));
    }
};
const getAppliedSortPressKit = (i18n, query)=>{
    switch(query){
        case "navTitle_s+asc":
            return i18n.sortByAsc;
        case "navTitle_s+desc":
            return i18n.sortByDesc;
        case "pressReleaseDate_dt+desc":
            return i18n.sortByNewest;
        case "pressReleaseDate_dt+asc":
            return i18n.sortByOldest;
    }
    return null;
};
// Function will scroll to a particular element
const scrollToElement = (element)=>{
    element.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};
// function to get offsetTop
const getOffsetTop = (element)=>{
    let offsetTop = 0;
    while(element){
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
};
/**
 * Scrolls the window to the active payment tile, offset by 100 pixels from the top.
 * @param {string} selector - The CSS selector for the payment tile element.
 */ const scrollToActivePaymentTile = (selector)=>{
    const inpageSearch = document.querySelector(selector);
    const offsetTop = getOffsetTop(inpageSearch) - 100;
    window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
    });
};
// Function to check part page or not
const isPartsPage = (url)=>{
    const urls = url === null || url === void 0 ? void 0 : url.split("?");
    let isPart = false;
    if ((urls === null || urls === void 0 ? void 0 : urls.length) && urls[1]) {
        isPart = url === null || url === void 0 ? void 0 : url.includes("type=part");
    } else {
        isPart = url === null || url === void 0 ? void 0 : url.includes("/support/");
    }
    return isPart;
};
const getPdpUrlParams = ()=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const skuNumber = searchParams.get("skuNumber");
    const skuId = searchParams.get("skuId");
    const listId = searchParams.get("listId");
    const products = searchParams.get("products");
    const listName = searchParams.get("ListName");
    if (skuNumber || skuId) {
        skuNumber ? searchParams.set("skuNumber", skuNumber) : searchParams.set("skuId", skuId);
        const query = "?" + searchParams.toString();
        return query;
    } else if (listId) {
        searchParams.set("listId", listId);
        const query1 = "?" + searchParams.toString();
        return query1;
    } else if (products && listName) {
        searchParams.set("products", products);
        searchParams.set("ListName", listName);
        const query2 = "?" + searchParams.toString();
        return query2;
    }
    return null;
};
const getUpSellDataByRecursion = (data)=>{
    var ref;
    let upSellContainerData = {};
    if ((ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length) {
        let isContainerMatched = false;
        let item = {};
        for(let i = 0; i < data[":itemsOrder"].length; i++){
            var ref1;
            const key = data[":itemsOrder"][i];
            item = data[":items"][key];
            if ((0,utils/* isUpSellContainer */._4)(item)) {
                upSellContainerData = item;
                isContainerMatched = true;
                break;
            }
            if (Object.hasOwn(item, ":itemsOrder") && ((ref1 = item[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                for(let j = 0; j < item[":itemsOrder"].length; j++){
                    const innerKey = item[":itemsOrder"][j];
                    if (Object.hasOwn(item[":items"][innerKey], ":itemsOrder")) {
                        item = item[":items"][innerKey];
                        if ((0,utils/* isUpSellContainer */._4)(item)) {
                            upSellContainerData = item;
                            isContainerMatched = true;
                            break;
                        }
                    }
                }
                if (isContainerMatched) break;
            }
        }
        if (!isContainerMatched) return getUpSellDataByRecursion(item);
        return upSellContainerData;
    }
    return upSellContainerData;
};
const getUpSellAuthData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isRequireToLookupFullData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    let upSellAuthData = {};
    if (isEmpty_default()(data)) return {};
    let upSellContainerData = data;
    if (isRequireToLookupFullData) {
        upSellContainerData = getUpSellDataByRecursion(data);
    }
    const { searchLabelUpSell , zipUpdateLabelUpSell , zipChangeLabelUpSell , zipLabelUpSell , userTitleUpSell  } = upSellContainerData;
    const headerAuthData = {
        searchLabelUpSell,
        zipUpdateLabelUpSell,
        zipChangeLabelUpSell,
        zipLabelUpSell,
        userTitleUpSell
    };
    var ref6;
    const productCard = (ref6 = (ref = upSellContainerData[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["container"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[":items"]) === null || ref2 === void 0 ? void 0 : ref2["productcard_v4"]) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    const serviceData = (ref7 = (ref3 = upSellContainerData[":items"]) === null || ref3 === void 0 ? void 0 : ref3["up_sell_services"]) !== null && ref7 !== void 0 ? ref7 : {};
    const itemsTabs = (ref4 = upSellContainerData[":items"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["up_sell_tabs"]) === null || ref5 === void 0 ? void 0 : ref5[":items"];
    const tabs = [];
    const tabsData = {};
    if (!isEmpty_default()(itemsTabs)) {
        for(const tabKey in itemsTabs){
            if (Object.prototype.hasOwnProperty.call(itemsTabs, tabKey)) {
                const panelTitle = itemsTabs[tabKey]["cq:panelTitle"].toLowerCase();
                tabs.push(panelTitle);
                tabsData[panelTitle] = itemsTabs[tabKey][":items"]["up_sell_services"];
            }
        }
    }
    const upSellServiceData = tabsData.length ? tabsData["services"] : serviceData;
    upSellAuthData = {
        headerAuthData,
        tabs,
        tabsData,
        productCard,
        upSellServiceData
    };
    return upSellAuthData;
};
const isUrlIncludeHttp = (url)=>{
    if (url) {
        return url.indexOf("http") !== -1;
    } else {
        return false;
    }
};
const getInternalLinkTypeForFindStore = function(store, city, state, name) {
    let isLocationPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const storeName = sanitizeTextForAnalytics(store);
    const cityName = sanitizeTextForAnalytics(city);
    const stateName = sanitizeTextForAnalytics(state);
    const micrositeName = sanitizeTextForAnalytics(name);
    if (isLocationPage) return "".concat(storeName, ":").concat(cityName, ":").concat(stateName);
    return "".concat(micrositeName, ":").concat(cityName, ":").concat(stateName);
};
const getProcessedProductInfoBasedOnLineItems = async (lineItems)=>{
    var ref;
    const config = await (0,constants_config/* getConfig */.i)();
    const locale = get_default()(config, "internationalization.locale", "");
    const brandName = (ref = get_default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const currency = get_default()(config, "internationalization.currencyCode", "usd");
    const currencySign = get_default()(config, "internationalization.currencySign", "$");
    const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
    const productItems = lineItems.map((item)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        let discountPrice = (ref6 = item === null || item === void 0 ? void 0 : item.discountPrice) !== null && ref6 !== void 0 ? ref6 : 0;
        if ((ref = item.price) === null || ref === void 0 ? void 0 : ref.discounted) {
            discountPrice = (Number(get_default()(item.price.discounted, "value.centAmount", 0)) / 100).toFixed(2);
        }
        if (item.discountedPrice) {
            discountPrice = (Number(get_default()(item.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
        }
        const discountedPricePerQuantity = (Number(get_default()((ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.discountedPrice) === null || ref1 === void 0 ? void 0 : ref1.includedDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.discountedAmount, "centAmount", 0)) / 100).toFixed(2);
        var ref7;
        const attributes = (ref7 = (ref3 = item.variant) === null || ref3 === void 0 ? void 0 : ref3.attributes) !== null && ref7 !== void 0 ? ref7 : [];
        const productSection = get_default()(attributes.find((attr)=>attr.name === "ProductSection"), "value", null);
        let productRoom = "";
        if (productSection && productSection[0] && productSection[0][locale]) {
            productRoom = productSection[0][locale];
        }
        return {
            id: get_default()(item, "id", ""),
            sku: get_default()(item, "variant.sku", ""),
            customerFacingSKU: getAttributeValue(attributes, "CustomerFacingSKU"),
            productRoom: productRoom,
            slug: get_default()(item, "productSlug[".concat(locale, "]"), ""),
            quantity: get_default()(item, "quantity", 0),
            image: get_default()(item, "variant.images[0].url", ""),
            category: getAttributeValue(attributes, "ProductLocalCategory"),
            brand: getAttributeValue(attributes, "CustomerFacingBrand"),
            associatedServices: getAssociatedServices(attributes),
            currencySign,
            name: get_default()(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", get_default()(item, "name[".concat(locale, "]"), "")),
            desc: get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
            color: get_default()(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), ""),
            unitPrice: typeof item.unitPrice === "string" ? item.unitPrice : (Number(get_default()(item, "price.value.centAmount", 0)) / 100).toFixed(2),
            totalPrice: typeof item.totalPrice === "string" ? item.totalPrice : (Number(get_default()(item, "totalPrice.centAmount", 0)) / 100).toFixed(2),
            discountPrice: discountPrice,
            discountedPricePerQuantity: discountedPricePerQuantity,
            isComboSku: attributes.find((attr)=>attr.name === "ComboSKU") ? true : false,
            backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
            businessUnitName: get_default()(attributes.find((attr)=>attr.name === "SPProductBusinessUnit"), "value", ""),
            additionalData: brandName === "annsacks" && (item === null || item === void 0 ? void 0 : (ref4 = item.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.roomInfo) ? get_default()(item, "custom.fields", "") : "",
            discountsList: [],
            productCollectionsName: getAttributeValue(attributes, "ProductBrandNameDisplay") || getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
            addedAt: get_default()(item, "addedAt", "")
        };
    });
    return {
        productItems,
        brandName,
        currency,
        lwAppName
    };
};
const jsonStringEscape = (jsonString)=>{
    return jsonString.replace(/\n|\t|\r|\&|\'/g, (m)=>{
        switch(m){
            case "\n":
            case "\r":
            case "	":
            case "\b":
            case "\f":
                return "";
            case "&":
                return "&amp;";
            case "'":
                return "&#8217;";
            default:
                return;
        }
    });
};
const replaceAndFunction = (str)=>{
    return str === null || str === void 0 ? void 0 : str.replace("&", "%26");
};
const getBadgeValue = (key, arry)=>{
    const badgeInfo = arry.find((item)=>item.map.Key === key);
    const { map: { Key ="" , Values: { myArrayList: badgeValue = []  } = {}  } = {}  } = badgeInfo;
    var ref;
    return {
        key: Key,
        value: (ref = badgeValue[0]) !== null && ref !== void 0 ? ref : ""
    };
};
const pushAnalyticsObjToDataLayer = async function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click", modifiedPageObj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, customDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, productInfo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var ref, ref1;
    let page = window.pageObj || {};
    // if cartInfo is missing in page object then get it from adobe data layer
    const { adobeDataLayer: { getState  } = {}  } = window;
    const pageObj = getState && getState("page") || {};
    if (!page.cartInfo) {
        var ref2;
        page.cartInfo = (ref2 = pageObj === null || pageObj === void 0 ? void 0 : pageObj.cartInfo) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if (!isEmpty_default()(modifiedPageObj)) {
        page = modifiedPageObj;
    }
    const cartObj = (ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    if (cartObj) {
        var ref3;
        const { cart  } = await calculateCartData({
            cart: cartObj
        }, true);
        page.cart = cart;
        var ref4;
        const cartItems = (ref4 = page === null || page === void 0 ? void 0 : (ref3 = page.cart) === null || ref3 === void 0 ? void 0 : ref3.item) !== null && ref4 !== void 0 ? ref4 : [];
        var ref5;
        const cartItemStr = cartItems.map((item)=>{
            var ref;
            return (ref5 = (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== null && ref5 !== void 0 ? ref5 : "";
        }).filter(Boolean).join(",");
        page.cartInfo = {
            cartItems: cartItemStr
        };
    }
    const datalayerObj = !isEmpty_default()(eventInfo) ? {
        event,
        eventInfo,
        page
    } : {
        event,
        page
    };
    if (!isEmpty_default()(productInfo)) {
        datalayerObj.productInfo = productInfo;
    }
    if (!isEmpty_default()(customDataLayer)) {
        for(const key in customDataLayer){
            if (Object.hasOwn(customDataLayer, key)) {
                datalayerObj[key] = customDataLayer[key];
            }
        }
    }
    window.adobeDataLayer.push(datalayerObj);
};
const removeMavenoidChat = ()=>{
    var ref, ref1;
    return (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("mavenoid-remove");
};
const addMavenoidChat = ()=>{
    var ref, ref1;
    return (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("mavenoid-remove");
};
const hasNumber = (str)=>{
    return /\d/.test(str);
};
const generateCanonicalUrl = (url, locale, host)=>{
    if (url) {
        if ((url === null || url === void 0 ? void 0 : url.includes(".json")) && "object" !== "undefined") {
            return window.location.href;
        }
        var ref;
        const canonicalUrl = (ref = url.split("?")[0]) !== null && ref !== void 0 ? ref : url;
        if (locale === "fr") {
            return "".concat(host === null || host === void 0 ? void 0 : host.substring(0, host.length - 2)).concat(locale).concat(canonicalUrl);
        } else {
            return "".concat(host).concat(canonicalUrl);
        }
    }
    return "";
};
const updateAnalyticPageUrl = (data, url)=>{
    if (data) {
        const parsedData = JSON.parse(data);
        parsedData.pageInfo.pageUrl = url;
        const analyticsData = JSON.stringify(parsedData);
        return analyticsData;
    }
    return "";
};
const sortParameterURL = ()=>{
    const url = new URL(window.location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort === null || appliedSort === void 0 ? void 0 : appliedSort.split(" ").join("+");
};
// Below util helper (removePathandHtml) is created especially when shortened URL is needed from getserversideprops function.
const removePathandHtml = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (url) {
        const { shortendPagePath =""  } = redirectsData !== null && redirectsData !== void 0 ? redirectsData : {};
        const htmlRemovedUrl = url === null || url === void 0 ? void 0 : url.replace(".html", "");
        const pathRemovedUrl = htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortendPagePath, "");
        return pathRemovedUrl;
    }
    return null;
};
const performRedirect = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let redirectUrl;
    let redirectType;
    const urlWithLocale = "/".concat(locale).concat(url);
    Object.keys(redirectsData).forEach((key)=>{
        if (redirectsData[key][url]) {
            redirectUrl = redirectsData[key][url];
            redirectType = key;
        } else if (redirectsData[key][urlWithLocale]) {
            redirectUrl = redirectsData[key][urlWithLocale];
            redirectType = key;
        }
    });
    if (redirectUrl) {
        redirectUrl = removePathandHtml(redirectUrl);
        return {
            redirectUrl,
            url,
            redirectType
        };
    }
    return null;
};
const getPureText = (str)=>{
    return str.replace(constants_regex/* PURE_TEXT_REGEX */.AP, "");
};
const isPriceZero = (price)=>price === "0.00" || price === 0;
const toastMsg = (msg)=>store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
        message: msg,
        isVisible: true
    }));
const addMediaToFavorites = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", successMsg = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", errMsg = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", internalLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", sharedZoneName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", videoName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", videoId = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
    isAuthenticated(()=>store_0/* store.dispatch */.h.dispatch((0,favoritesSlice/* addMedia */.rA)({
            type,
            name,
            url,
            errMsg,
            internalLinkType,
            sharedZoneName,
            videoName,
            videoId,
            successCallback: ()=>toastMsg(successMsg)
        })));
};
const removeFavorites = (ids, favEle, removemsg)=>{
    isAuthenticated(()=>store_0/* store.dispatch */.h.dispatch((0,favoritesSlice/* removeItems */.Er)(ids)).unwrap().then(()=>{
            favEle.current.removeAttribute("data-id");
            favEle.current.classList.remove("favorite-filled");
            toastMsg(removemsg);
        }));
};
const organizeData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], placeHolder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", idVal = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    return data.map((item, i)=>{
        let obj = {
            title: name.length ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
        };
        if (idVal) {
            obj.id = idVal + "-" + i;
        }
        if (type === "PART") {
            obj = {
                ...obj,
                id: item
            };
        } else {
            obj = {
                ...obj,
                type,
                url: item
            };
        }
        return obj;
    });
};
const getAnalyticsFileName = (file)=>{
    const { actualName ="" , title ="" , type =""  } = file;
    const fileName = actualName || sanitizeTextForAnalytics("".concat(title === null || title === void 0 ? void 0 : title.trim(), ".").concat(type));
    return fileName;
};
const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, swatchUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", image = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", presetConfigs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, scene7AccountName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { Desktop ="" , MobileLandscape ="" , MobilePortrait ="" , PotraitCategory =""  } = presetConfigs;
    const assetId = image.split("/").pop();
    const scene7Url = swatchUrl === null || swatchUrl === void 0 ? void 0 : swatchUrl.replace("PAWEB/", "");
    let preset = Desktop;
    if (width >= 1024) {
        preset = Desktop;
    } else if (width < 1024 && width >= 768) {
        preset = MobileLandscape;
    } else if (width < 768) {
        preset = MobilePortrait;
    }
    return "".concat(scene7Url).concat(scene7AccountName, "/").concat(PotraitCategory, "?$product_src=is{").concat(scene7AccountName, "/").concat(assetId, "}&").concat(preset);
};
const recalculateCartRoomInfo = (lineItemId, product)=>{
    const actions = [];
    if (product === null || product === void 0 ? void 0 : product.roomInfo) {
        actions.push({
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "roomInfo",
            value: [
                '{"productType":"' + (product === null || product === void 0 ? void 0 : product.productType) + '","totalNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalNeeded) + '","totalUserNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalUserNeeded) + '","totalSFUserNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalSFUserNeeded) + '","totalArea":"' + (product === null || product === void 0 ? void 0 : product.totalArea) + '","soldByBox":"' + (product === null || product === void 0 ? void 0 : product.soldByBox) + '","soldByUom":"' + (product === null || product === void 0 ? void 0 : product.soldByUom) + '"}'
            ]
        }, {
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "customQuantity",
            value: (product === null || product === void 0 ? void 0 : product.soldByBox) ? Number((product === null || product === void 0 ? void 0 : product.customQuantity) * (product === null || product === void 0 ? void 0 : product.soldByBox)) : product === null || product === void 0 ? void 0 : product.customQuantity
        }, {
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "totalUOM",
            value: "".concat(product === null || product === void 0 ? void 0 : product.totalArea)
        }, {
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "overage",
            value: product === null || product === void 0 ? void 0 : product.overage
        }, {
            action: "changeLineItemQuantity",
            lineItemId: lineItemId,
            quantity: product === null || product === void 0 ? void 0 : product.customQuantity
        });
    } else {
        actions.push({
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "customQuantity",
            value: product === null || product === void 0 ? void 0 : product.quantity
        }, {
            action: "changeLineItemQuantity",
            lineItemId: lineItemId,
            quantity: product === null || product === void 0 ? void 0 : product.quantity
        });
    }
    try {
        api/* apim.post */.TH.post("/cart/v2/items?expand=calculation", {
            actions: actions
        }).then((response)=>{
            const kohlerDatalayer = window.kohler.datalayer;
            if (typeof kohlerDatalayer !== "undefined" && typeof kohlerDatalayer.setItem === "function") {
                kohlerDatalayer.setItem("CART_DATA", response.data);
            }
            store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(response.data));
            store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)((0,helperV2/* getQuantityCount */.PW)(response.data.lineItems)));
            store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.log(err);
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
    }
};
const checkIfImageExists = (url, callback)=>{
    const img = new Image();
    img.src = url;
    if (img.complete) {
        callback(true);
    } else {
        img.onload = ()=>{
            callback(true);
        };
        img.onerror = ()=>{
            callback(false);
        };
    }
};
const getLinkFromHref = (htmlString)=>{
    let link = htmlString.match(/href="([^"]*)"/);
    link = link ? link[1] : "";
    if ( true && link.indexOf("https") === -1) {
        link = window.location.href + link;
    }
    return link;
};
const isCanadaSite = (siteName)=>siteName && siteName.trim().toLocaleLowerCase() === "kohler-canada";
const getProductStatus = function() {
    let discontinued = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, backorder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", inStock = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    const productStatus = discontinued ? "discontinued" : backorder === "Yes" ? "backorder" : inStock ? "in stock" : "out of stock";
    return productStatus;
};
const getLangCode = (config)=>{
    var ref, ref1, ref2;
    const locale = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : (ref1 = ref.locale) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    const languageName = (ref2 = "EN") === null || ref2 === void 0 ? void 0 : ref2.toLowerCase();
    const result = (locale === null || locale === void 0 ? void 0 : locale.includes(languageName)) ? constants.LOCALE_ENGLISH.toLowerCase() : locale;
    return result;
};
const getIsNameDuplicate = (value, listNameValidationList)=>{
    return listNameValidationList.map((name)=>{
        return name === null || name === void 0 ? void 0 : name.toUpperCase();
    }).includes(value === null || value === void 0 ? void 0 : value.toUpperCase());
};
const getIsSystemDefinedName = (value)=>{
    return [
        "MYPRODUCTS",
        "MYSERVICES",
        "MESSERVICES"
    ].includes(value === null || value === void 0 ? void 0 : value.toUpperCase());
};
const geMonthNameDayandYear = function(dateStr) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    const date = new Date(dateStr);
    const month = locale === "en-US" || locale === "en-CA" ? constants.MONTH_NAMES_EN[date.getMonth()] : constants.MONTH_NAMES_FR[date.getMonth()];
    return "".concat(month, " ").concat(date.getDate(), ", ").concat(date.getFullYear());
};
const getUserCreatedLists = (response, locale, moveOrDeleteFromListName)=>{
    const lists = [];
    const listNames = [];
    response.sort((a, b)=>{
        return new Date(b === null || b === void 0 ? void 0 : b.lastModifiedAt) - new Date(a === null || a === void 0 ? void 0 : a.lastModifiedAt);
    }).forEach((list)=>{
        if ((list === null || list === void 0 ? void 0 : list.name[locale]) !== moveOrDeleteFromListName) {
            lists.push({
                name: list === null || list === void 0 ? void 0 : list.name[locale],
                id: list === null || list === void 0 ? void 0 : list.id,
                version: list === null || list === void 0 ? void 0 : list.version
            });
            listNames.push(list === null || list === void 0 ? void 0 : list.name[locale]);
        }
    });
    return {
        lists: lists,
        listNames: listNames
    };
};
const getProductFlgs = (persona)=>{
    return [
        "masterSKU_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "ProductBrandName_s",
        "metaTitle_s",
        "productName_s",
        "id",
        "productImages.url_ss",
        "slug_s",
        "Product_Category",
        "displayPriceStartingAt_s",
        "Tile_Title",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "Color.SKU.Details_ss",
        "productImages.labelWithUrl_ss",
        "productDiscontinued_b",
        "productDiscontinuedDate_dt",
        "productRegionAllVariantDiscontinued_b",
        "variantList.sku_ss",
        "RegionBrandName_s",
        "ProductIsRetail_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "Color.".concat(persona, ".Details_ss"),
        "ctId_s",
        "Brand_ss",
        "Country_ss",
        "ProductRequiredAccessoryGroup_s",
        "ProductRequiredAccessoryGroup_ss"
    ];
};
const extractPhoneNumber = (htmlString)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const anchor = doc.querySelector('a[href^="tel:"]');
    return anchor ? anchor.getAttribute("href").replace("tel:", "") : null;
};
const getQuickViewAuth = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2;
    if (isEmpty_default()(data)) return {};
    var ref3;
    const quickViewAuthData = (ref3 = (ref = data[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["root"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[":items"]) === null || ref2 === void 0 ? void 0 : ref2["pdp_quick_view"]) !== null && ref3 !== void 0 ? ref3 : {};
    return quickViewAuthData;
};
const processColorDetails = function() {
    let colorDetails = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return colorDetails.map((color)=>{
        const [name, swatch, sku, isStock, isDiscontinued, customerFacingSKU] = color.split("|");
        return {
            name,
            swatch,
            sku,
            isStock,
            isDiscontinued,
            customerFacingSKU
        };
    });
};
const processSwatchData = function() {
    let colorProducts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const swatchPairs = colorProducts.map((product)=>{
        const swatches = get_default()(product, "swatch", "");
        const swatchNames = get_default()(product, "name", "");
        return [
            swatches,
            swatchNames
        ];
    });
    return swatchPairs.filter((pair)=>pair.every(Boolean));
};
const getProductImageUrl = function() {
    let productVariantImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", fallbackImage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : image_missing/* default */.Z;
    const variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
    if (!variantImages.length) {
        return fallbackImage;
    }
    const img = variantImages[0].split("|");
    var ref;
    return (ref = img[img.length - 1]) !== null && ref !== void 0 ? ref : fallbackImage;
};
const getSearchDataLayerDetails = (searchResultDataLayerObj)=>{
    if (!searchResultDataLayerObj || typeof searchResultDataLayerObj !== "object" || Object.keys(searchResultDataLayerObj).length === 0) {
        return {};
    }
    const currDate = new Date();
    return {
        searchCount: Number(sessionStorage.getItem("searches")) || 1,
        searchResult: searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResult,
        searchTerm: searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchTerm,
        searchSuggestedTerm: "n/a",
        timeStamp: (currDate === null || currDate === void 0 ? void 0 : currDate.toISOString().split("T")[0]) + " " + (currDate === null || currDate === void 0 ? void 0 : currDate.toTimeString().split(" ")[0]),
        ...(searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResultCategoryType) ? {
            searchResultCategory: "".concat(searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResultCategoryType, ">").concat(searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResultCategoryTypeCount)
        } : {}
    };
};
const getRowCols = (width)=>{
    if (width < constants.ROW_COLUMN_WIDTH) return 2;
    if (width >= constants.ROW_COLUMN_WIDTH && width < constants.MAX_MID_WIDTH) return 3;
    if (width >= constants.MAX_MID_WIDTH) return 4;
};
const getSwatchPreset = (width)=>{
    // Server-side rendering (no window object)
    if (false) {}
    // Client-side rendering with width check
    return width <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$";
};
const shouldShowSortElement = (page)=>{
    // If page is search and width is up to 1023px
    if (page === "search" && window.innerWidth < 1024) {
        return true;
    }
    // If page is not search but width is up to 991px
    if (page !== "search" && window.innerWidth <= 991) {
        return true;
    }
    // All other cases return false
    return false;
};
const getPriceFieldFromFacet = (facetLabels, persona)=>{
    const dynamicPriceField = Object.keys(facetLabels).find((key)=>{
        const normalizedKey = key.toLowerCase();
        return normalizedKey.includes("price") && normalizedKey.includes(persona.toLowerCase());
    });
    return dynamicPriceField || "";
};
const getProductDisplayName = (data)=>{
    const { name ="" , desc =""  } = data;
    if (!name) return desc;
    if (name === desc) return name;
    return "".concat(name, " ").concat(desc);
};
const closeCompareProductView = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setShowHalfCompare */._4)(false));
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setShowFullCompare */.p1)(true));
    const query = getPdpUrlParams();
    var _state;
    const historyState = (_state = window.history.state) !== null && _state !== void 0 ? _state : {};
    if ((window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) === constants.INSTALLATION_SERVICES_PATH) {
        const newUrl = window.location.hash ? "".concat(window.location.pathname).concat(window.location.hash) : window.location.pathname;
        window.history.replaceState({
            ...historyState,
            previousUrl: url
        }, document.title, newUrl);
    } else if (query) {
        window.history.replaceState(historyState, document.title, query);
    } else {
        const currentUrl = "".concat(window.location.pathname).concat(window.location.search);
        window.history.replaceState(historyState, document.title, currentUrl);
    }
    document.body.classList.remove("compare-open", "scroll-lock", "modal-open");
};
const handleSkipToMain = (event)=>{
    event.preventDefault();
    const target = document.getElementById("main-content");
    if (!target) return;
    if (typeof target.focus === "function") {
        target.focus({
            preventScroll: true
        });
    }
    target.scrollIntoView({
        block: "start"
    });
    if (window.location.hash) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
};
const scene7ImageUrl = (image, scene7BaseUrl, dmScene7AccountName)=>"".concat(scene7BaseUrl).concat(dmScene7AccountName, "/").concat(image.substring(image.lastIndexOf("/") + 1, image.lastIndexOf(".")));
const getCookie = function() {
    let cName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded.split("; ");
    let res;
    cArr.forEach((val)=>{
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
};
const getDeviceInfo = ()=>{
    const width = screen.width;
    const isPortrait = window.innerHeight > window.innerWidth;
    if (width <= 700) {
        return {
            platform: "mobile",
            responsiveFormat: true
        };
    }
    if (width <= 1100) {
        return {
            platform: "tablet",
            responsiveFormat: true
        };
    }
    return {
        platform: "desktop",
        responsiveFormat: false,
        orientation: isPortrait ? "portrait" : "landscape"
    };
};
const getGeoRegion = (locale)=>{
    var ref;
    return locale.includes("-") ? (ref = locale.split("-")[1]) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "us";
};
const getProductExcludeFromPaidAdvertising = (ctProductData)=>{
    const { masterVariant: { attributes =[]  } = {}  } = ctProductData || {};
    if (!Array.isArray(attributes)) return false;
    const attr = attributes.find((a)=>{
        return (a === null || a === void 0 ? void 0 : a.name) === constants.PRODUCT_EXCLUDE_FROM_PAID_ADVERTISING;
    });
    var ref;
    return (ref = attr === null || attr === void 0 ? void 0 : attr.value) !== null && ref !== void 0 ? ref : false;
};
const getPageType = ()=>{
    var ref, ref1, ref2;
    const page = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.getState) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "page");
    var ref3;
    return (ref3 = page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType) !== null && ref3 !== void 0 ? ref3 : "pdp";
};
const getFormattedLogForAppInsights = (param)=>{
    let { eventType , pageUrl , locale , persona , apiurl , productCount , numberOfProducts , log  } = param;
    const properties = {
        eventType: eventType,
        log: log,
        pageUrl: pageUrl,
        locale: locale,
        persona: persona,
        apiurl: apiurl,
        productCount: productCount,
        numberOfProducts: numberOfProducts,
        timestamp: new Date().toISOString()
    };
    return JSON.stringify(properties);
};



/***/ }),

/***/ 51380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ resolveHttpTimeoutMs; }
/* harmony export */ });
/* unused harmony export DEFAULT_HTTP_TIMEOUT_MS */
const DEFAULT_HTTP_TIMEOUT_MS = 10000;
const parseTimeoutMs = (value)=>{
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
const resolveHttpTimeoutMs = function() {
    for(var _len = arguments.length, candidates = new Array(_len), _key = 0; _key < _len; _key++){
        candidates[_key] = arguments[_key];
    }
    for (const candidate of candidates){
        const parsed = parseTimeoutMs(candidate);
        if (parsed !== null) return parsed;
    }
    return DEFAULT_HTTP_TIMEOUT_MS;
};


/***/ }),

/***/ 20558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ findStoreUtilNavselectQuery; },
/* harmony export */   "A9": function() { return /* binding */ isHeaderNavV3; },
/* harmony export */   "Ac": function() { return /* binding */ onImageError; },
/* harmony export */   "Ar": function() { return /* binding */ isCheckoutLanding; },
/* harmony export */   "BB": function() { return /* binding */ getPresetThumbnailUrl; },
/* harmony export */   "Be": function() { return /* binding */ isCompareProducts; },
/* harmony export */   "C2": function() { return /* binding */ isCarousel; },
/* harmony export */   "C_": function() { return /* binding */ isNewsLetter; },
/* harmony export */   "DD": function() { return /* binding */ parseToBoolean; },
/* harmony export */   "DN": function() { return /* binding */ isProductcardV3; },
/* harmony export */   "Dx": function() { return /* binding */ isMyproducts; },
/* harmony export */   "EE": function() { return /* binding */ isImageV3; },
/* harmony export */   "Er": function() { return /* binding */ isGatedContent; },
/* harmony export */   "F0": function() { return /* binding */ isAssociateMembership; },
/* harmony export */   "GX": function() { return /* binding */ isPressLanding; },
/* harmony export */   "Gs": function() { return /* binding */ isText; },
/* harmony export */   "Gz": function() { return /* binding */ getShippingData; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "HR": function() { return /* binding */ isTechnicalSpec; },
/* harmony export */   "Hx": function() { return /* binding */ isProductList; },
/* harmony export */   "K0": function() { return /* binding */ isOrderStatus; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "L": function() { return /* binding */ isRegisterOnline; },
/* harmony export */   "L8": function() { return /* binding */ isInPageSearch; },
/* harmony export */   "LV": function() { return /* binding */ isProductCardV4; },
/* harmony export */   "Lg": function() { return /* binding */ isDynamicSearch; },
/* harmony export */   "M0": function() { return /* binding */ accordionUniqueId; },
/* harmony export */   "M2": function() { return /* binding */ ConditionalWrapper; },
/* harmony export */   "M6": function() { return /* binding */ getSanitizeNumber; },
/* harmony export */   "MN": function() { return /* binding */ isBrowseAllStores; },
/* harmony export */   "MW": function() { return /* binding */ isSpacer; },
/* harmony export */   "Mc": function() { return /* binding */ isKnowledgeArticle; },
/* harmony export */   "N": function() { return /* binding */ isSearch; },
/* harmony export */   "NF": function() { return /* binding */ getIsSameAddress; },
/* harmony export */   "Nm": function() { return /* binding */ isContainer; },
/* harmony export */   "OL": function() { return /* binding */ isContactUs; },
/* harmony export */   "Om": function() { return /* binding */ getPdpRedirectUrl; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "Ov": function() { return /* binding */ isStoreFilter; },
/* harmony export */   "P2": function() { return /* binding */ isEmbed; },
/* harmony export */   "Qe": function() { return /* binding */ recursiveDataFunction; },
/* harmony export */   "RU": function() { return /* binding */ isVisualNav; },
/* harmony export */   "S": function() { return /* binding */ isAuthModal; },
/* harmony export */   "Si": function() { return /* binding */ isChangePassword; },
/* harmony export */   "Tg": function() { return /* binding */ formatAddress; },
/* harmony export */   "Tk": function() { return /* binding */ isImageCluster; },
/* harmony export */   "U2": function() { return /* binding */ isFindAProResults; },
/* harmony export */   "U4": function() { return /* binding */ isMyservice; },
/* harmony export */   "Ui": function() { return /* binding */ getBillingAsShippingAddress; },
/* harmony export */   "Uq": function() { return /* binding */ isOrderConfirmation; },
/* harmony export */   "V6": function() { return /* binding */ isProductExfPdp; },
/* harmony export */   "VV": function() { return /* binding */ isPDPCuratedProducts; },
/* harmony export */   "Vw": function() { return /* binding */ handleViewSterlingResults; },
/* harmony export */   "Wt": function() { return /* binding */ isTitle; },
/* harmony export */   "Wv": function() { return /* binding */ isVideo; },
/* harmony export */   "X7": function() { return /* binding */ isRoomDetail; },
/* harmony export */   "Y5": function() { return /* binding */ isProfessionalDetail; },
/* harmony export */   "Z3": function() { return /* binding */ isBreadcrumb; },
/* harmony export */   "ZS": function() { return /* binding */ isHeaderNav; },
/* harmony export */   "Zw": function() { return /* binding */ getDeviceId; },
/* harmony export */   "_": function() { return /* binding */ isInspireVideo; },
/* harmony export */   "_$": function() { return /* binding */ isOrderHistory; },
/* harmony export */   "_4": function() { return /* binding */ isUpSellContainer; },
/* harmony export */   "_H": function() { return /* binding */ isFindStore; },
/* harmony export */   "_h": function() { return /* binding */ isProductSlider; },
/* harmony export */   "a4": function() { return /* binding */ isValidPostalCode; },
/* harmony export */   "bU": function() { return /* binding */ alterClass; },
/* harmony export */   "bd": function() { return /* binding */ isSlick; },
/* harmony export */   "bu": function() { return /* binding */ isToaster; },
/* harmony export */   "cD": function() { return /* binding */ isBrandHeader; },
/* harmony export */   "ck": function() { return /* binding */ isShopTheRoomCard; },
/* harmony export */   "cl": function() { return /* binding */ isFooter; },
/* harmony export */   "e1": function() { return /* binding */ getOrderDetailsUrl; },
/* harmony export */   "e7": function() { return /* binding */ isPromoBanner; },
/* harmony export */   "ek": function() { return /* binding */ isLiterature; },
/* harmony export */   "eo": function() { return /* binding */ mapCollapsedSku; },
/* harmony export */   "eq": function() { return /* binding */ isProductAccordion; },
/* harmony export */   "f5": function() { return /* binding */ isNewsLetterSignUp; },
/* harmony export */   "fN": function() { return /* binding */ getExtention; },
/* harmony export */   "gC": function() { return /* binding */ isGlobalToaster; },
/* harmony export */   "gd": function() { return /* binding */ isFindAProByZip; },
/* harmony export */   "hH": function() { return /* binding */ getShippingAllTotal; },
/* harmony export */   "hn": function() { return /* binding */ isRegisterOffline; },
/* harmony export */   "iL": function() { return /* binding */ isFindingModelNumber; },
/* harmony export */   "j$": function() { return /* binding */ isTeaser; },
/* harmony export */   "jM": function() { return /* binding */ isFriendsAndFamily; },
/* harmony export */   "jS": function() { return /* binding */ isProductDetails; },
/* harmony export */   "kp": function() { return /* binding */ isInstallDesignServices; },
/* harmony export */   "l1": function() { return /* binding */ isCartLanding; },
/* harmony export */   "mI": function() { return /* binding */ isShopTheRoomLandingPage; },
/* harmony export */   "mg": function() { return /* binding */ isAccountSettings; },
/* harmony export */   "n": function() { return /* binding */ getRowCols; },
/* harmony export */   "nK": function() { return /* binding */ isObjectEmpty; },
/* harmony export */   "np": function() { return /* binding */ isAemForm; },
/* harmony export */   "nq": function() { return /* binding */ isList; },
/* harmony export */   "o4": function() { return /* binding */ getBrandSwitcher; },
/* harmony export */   "oC": function() { return /* binding */ isPairsWellWth; },
/* harmony export */   "oq": function() { return /* binding */ closest; },
/* harmony export */   "pO": function() { return /* binding */ isShareList; },
/* harmony export */   "ph": function() { return /* binding */ isShopTheRoomDetail; },
/* harmony export */   "po": function() { return /* binding */ isProductcard; },
/* harmony export */   "pv": function() { return /* binding */ isOrderDetails; },
/* harmony export */   "qV": function() { return /* binding */ getPayPalPaymentIdFromParams; },
/* harmony export */   "rp": function() { return /* binding */ getCountryStatesList; },
/* harmony export */   "s3": function() { return /* binding */ isProductReview; },
/* harmony export */   "sL": function() { return /* binding */ isSharedCart; },
/* harmony export */   "uJ": function() { return /* binding */ isReturnSlips; },
/* harmony export */   "uW": function() { return /* binding */ updateMetaContent; },
/* harmony export */   "v$": function() { return /* binding */ getPresetUrl; },
/* harmony export */   "wR": function() { return /* binding */ isTab; },
/* harmony export */   "we": function() { return /* binding */ isMyFavorites; },
/* harmony export */   "wq": function() { return /* binding */ sanitizedTextAndEntities; },
/* harmony export */   "xA": function() { return /* binding */ isStoreAppointment; },
/* harmony export */   "yd": function() { return /* binding */ isSiteWideWarning; },
/* harmony export */   "z9": function() { return /* binding */ isKeySpecifier; },
/* harmony export */   "zK": function() { return /* binding */ isHelpSupport; },
/* harmony export */   "zj": function() { return /* binding */ getSanitizedFloatingNumber; },
/* harmony export */   "zm": function() { return /* binding */ removeExtraSpaces; }
/* harmony export */ });
/* unused harmony exports getUniqueObjectListBy, isLeadGeneration, getSkusQuery, isTeaserContainer, isglobalNavV3 */
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36513);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73350);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];








const isContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CONTAINER);
};
const isProductcard = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTCARD);
};
const isProductcardV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTCARD_V3);
};
const isAuthModal = (item)=>{
    var ref;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.AUTH_MODAL)) && (item === null || item === void 0 ? void 0 : item.hi);
};
const isSiteWideWarning = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SITEWIDE_WARNING);
};
const isNewsLetter = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER);
};
const isNewsLetterSignUp = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER_SIGNUP);
};
const isCompareProducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.COMPARE_PRODUCTS);
};
const isVideo = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VIDEO);
};
const isSpacer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SPACER);
};
const isImage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE);
};
const isImageV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGEV3);
};
const isUpSellContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UPSELL_CONTAINER);
};
const isGlobalToaster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.GLOBAL_TOASTER);
};
const isCartLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CART_LANDING);
};
const isCheckoutLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CHECKOUT);
};
const isSharedCart = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHARED_CART);
};
const isOrderConfirmation = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_CONFIRMATION);
};
const isOrderDetails = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_DETAILS);
};
const isOrderHistory = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_HISTORY);
};
const isOrderStatus = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_STATUS);
};
const isPairsWellWth = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PAIRS_WELL_WITH);
};
const isCarousel = (item)=>{
    var ref, ref1;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CAROUSEL)) && !((ref1 = item[":type"]) === null || ref1 === void 0 ? void 0 : ref1.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CAROUSELSLICK));
};
const isReturnSlips = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.RETURN_SLIP);
};
const isSlick = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SLICK)) && !(item === null || item === void 0 ? void 0 : (ref1 = item.carouselComponentProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appliedCssClassNames) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel-promo-banner"));
};
const isPromoBanner = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SLICK)) && (item === null || item === void 0 ? void 0 : (ref1 = item.carouselComponentProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appliedCssClassNames) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel-promo-banner"));
};
const isAemForm = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.AEMFORM);
};
const isTeaser = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEASER);
};
const isTeaserContainer = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.every((a)=>a.includes(COMPONENT_TYPES.TEASER));
};
const isText = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEXT);
};
const isTab = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TAB);
};
const isBrandHeader = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BRAND_SWITCHER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_NAV_HEADER));
};
const checkNavigationV3 = (obj)=>{
    // Check if the current object has the is_good property
    if (Object.keys(obj).some((key)=>key.includes("globalnavigation_v3"))) {
        return true;
    }
    // Traverse each property of the object
    for(const key in obj){
        if (Object.hasOwn(obj, key)) {
            // Check if the property is an object or an array
            if (typeof obj[key] === "object" && obj[key] !== null) {
                // Recursively check nested objects or arrays
                if (checkNavigationV3(obj[key])) {
                    return true;
                }
            }
        }
    }
    // Return false if no v3 property is found in the object or its nested objects
    return false;
};
const isHeaderNav = (data)=>{
    const types = [];
    const itemsOrders = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (data[":items"][key][":items"]) {
            itemsOrders.push(checkNavigationV3(data[":items"][key][":items"]));
        }
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_WIDGET)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TABS)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE)) && !itemsOrders.find((a)=>a === true);
};
const isHeaderNavV3 = (data)=>{
    const types = [];
    const itemsOrders = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (data[":items"][key][":items"]) {
            itemsOrders.push(checkNavigationV3(data[":items"][key][":items"]));
        }
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TABS)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_WIDGET)) && itemsOrders.find((a)=>a === true);
};
const isVisualNav = (data)=>{
    const perviousData = data[":itemsOrder"];
    const appliedclass = data["appliedCssClassNames"];
    return (perviousData === null || perviousData === void 0 ? void 0 : perviousData.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VISUAL_NAV_FILTER)) || (appliedclass === null || appliedclass === void 0 ? void 0 : appliedclass.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VISUAL_NAV_APPLIEDCLASS));
};
const isFooter = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MAIN_FOOTER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ADDITIONAL_FOOTER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER_SIGNIN));
};
const isEmbed = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.EMBED);
};
const isBreadcrumb = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BREADCRUMB);
};
const isProductList = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTLIST);
};
const isSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SEARCH);
};
const isToaster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TOASTER);
};
const isHelpSupport = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.HELPSUPPORT);
};
const isProductDetails = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS);
};
const isAccountSettings = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ACCOUNT_SETTINGS);
};
const isMyservice = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_SERVICES);
};
const isMyFavorites = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_FAVORITES);
};
const isChangePassword = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CHANGE_PASSWORD);
};
const isMyproducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_PRODUCTS);
};
const isProductAccordion = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_ACCORDION);
};
const isProductReview = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_REVIEW);
};
const isRegisterOffline = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.REGISTER_OFFLINE_PRODUCTS);
};
const isRegisterOnline = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.REGISTER_ONLINE_PRODUCTS);
};
const isBrowseAllStores = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BROWSE_ALL_STORES);
};
const isStoreFilter = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.STORE_FILTER);
};
const isProductExfPdp = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
};
const isKnowledgeArticle = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.KNOWLEDGE_ARTICLE);
};
const isLiterature = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.LITERATURE);
};
const isContactUs = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CONTACT_US);
};
const isFindingModelNumber = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FINDING_MODEL_NUMBER);
};
const isTechnicalSpec = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TECHNICAL_SPECIFICATION);
};
const isPressLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRESS_LANDING);
};
const isFindStore = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FIND_STORE);
};
const isInPageSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INPAGE_SEARCH);
};
const isTitle = function() {
    let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TITLE);
};
const isKeySpecifier = function() {
    let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.KEY_SPECIFIER);
};
const isDynamicSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.DYNAMIC_SEARCH);
};
const isAssociateMembership = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ASSOCIATE_MEMBERSHIP);
};
const isInspireVideo = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INSPIRE_VIDEO);
};
const isShareList = (item)=>{
    var ref;
    return (ref = item["title"]) === null || ref === void 0 ? void 0 : ref.includes("Share List");
};
const isImageCluster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE_CLUSTER);
};
const isProfessionalDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PROFESSIONAL_DETAILS);
};
const isRoomDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ROOM_DETAIL);
};
const isShopTheRoomDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_DETAIL);
};
const isglobalNavV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.NAVIGATION_V3);
};
const isShopTheRoomCard = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_CARD);
};
const isFindAProResults = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FIND_A_PRO_RESULTS);
};
const isFriendsAndFamily = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FRIENDS_AND_FAMILY);
};
const isList = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.LIST);
};
const isInstallDesignServices = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INSTALL_DESIGN_SERVICES);
};
const isFindAProByZip = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FIND_A_PRO_BY_ZIP);
};
const isStoreAppointment = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.STORE_APPOINTMENT);
};
const isGatedContent = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.GATED_CONTENT);
};
const isProductCardV4 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_CARD_V4);
};
const isPDPCuratedProducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PDP_CURATED_PRODUCTS);
};
const isShopTheRoomLandingPage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_PAGE);
};
const isProductSlider = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_SLIDER);
};
/**
 *
 * @param {Element} e
 * @param {String} url
 */ const onImageError = (e, url)=>{
    const imgsrc = e.target.src;
    if (imgsrc.includes("&fmt=webp")) {
        e.target.src = imgsrc.replace("&fmt=webp", "");
        return;
    }
    const attr = document.createAttribute("errorsrc");
    attr.value = url;
    e.target.setAttributeNode(attr);
    e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"].src */ .Z.src;
};
/**
 *
 * @param {Number} width
 * @param {Number} rowCols
 * @param {String} swatchUrl
 * @param {String} assetId
 * @param {Object} presetConfigs
 * @param {Boolean} isForInstallationService
 * @return {String} preset url
 */ const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, rowCols = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, swatchUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", assetId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isForInstallationService = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    const { Desktop , MobilePortrait , MobilePortrait1 , MobilePortrait2 , MobileLandscape , MobileLandscape1 , MobileLandscape2 , PotraitCategory  } = presetConfigs;
    let preset = "";
    const mobileBasedCheckPoint = isForInstallationService ? 1023 : 768;
    if (width <= mobileBasedCheckPoint) {
        if (width <= 425) {
            if (rowCols) {
                preset = MobilePortrait2 || MobilePortrait;
                if (rowCols === 1) preset = MobilePortrait1 || MobilePortrait;
            } else if (MobilePortrait) {
                preset = MobilePortrait;
            } else preset = MobilePortrait2;
        } else {
            if (rowCols) {
                if (rowCols === 1) preset = MobileLandscape1 || MobileLandscape;
                else preset = MobileLandscape2 || MobileLandscape;
            } else if (MobileLandscape) {
                preset = MobileLandscape;
            } else preset = MobileLandscape1;
        }
    } else preset = Desktop;
    if (isForInstallationService) {
        return "".concat(swatchUrl).concat(assetId, "?").concat(preset);
    }
    return "".concat(swatchUrl).concat(PotraitCategory, "?$product_src=is{PAWEB/").concat(assetId, "}&").concat(preset);
};
const alterClass = function() {
    let elementClass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", toAdd = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, toRemove = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const element = document.getElementsByClassName(elementClass).item(0);
    if (toAdd && element) {
        element.classList.add(toAdd);
    }
    if (toRemove && element) {
        element.classList.remove(toRemove);
    }
};
//  * @param {String} fileName imagename.jpg / imagename
//  * @returns .jpg,.svg / false
const getExtention = (fileName)=>{
    const i = fileName.lastIndexOf(".");
    if (i === -1) return false;
    return fileName.slice(i);
};
/**
 *
 * @param {String} str
 * @param {Number} max
 * @param {Number} min
 * @return {Number}
 */ const accordionUniqueId = (str, max, min)=>{
    if (false) {}
    const crypto = window.crypto || window.msCrypto;
    const array = new Uint32Array(1);
    const randVal = crypto.getRandomValues(array)[0];
    return "".concat(str, "-").concat(Math.floor(randVal * (max - min + 1)) + min);
};
const ConditionalWrapper = (param)=>{
    let { condition , wrapper , children  } = param;
    return condition ? wrapper(children) : children;
};
const closest = (el, fn)=>el && (fn(el) ? el : closest(el.parentNode, fn));
const removeExtraSpaces = function() {
    let string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return string.replace(/\s+/g, " ").trim();
};
/**
 *
 * @param {String} swatchUrl
 * @param {String} assetId
 * @param {Object} presetConfigs
 * @param {String} assetAccountName
 * @return {String}
 */ const getPresetThumbnailUrl = (swatchUrl, assetId, presetConfigs, assetAccountName)=>{
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const recursiveDataFunction = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const results = [];
    if (data && data[":itemsOrder"]) {
        data[":itemsOrder"].map((key)=>{
            var ref;
            const item = data[":items"][key];
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(type)) {
                results.push(item);
                return item;
            } else {
                const nestedResults = recursiveDataFunction(item, type);
                results.push(...nestedResults);
            }
        });
    }
    return results;
};
const getRowCols = (width, isMobile, isTablet)=>{
    let rowCols = width < 1024 ? 1 : 3;
    switch(true){
        case width > 1024:
            rowCols = 3;
            break;
        case width < 990 && (isMobile || isTablet) || width < 480:
            rowCols = 2;
            break;
        default:
            rowCols = 2;
    }
    return rowCols;
};
const getBillingAsShippingAddress = (shipping, billing)=>{
    const { billingStreetName ="" , billingAptNo ="" , billingCity ="" , billingStateCode ="" , billingZipcode =""  } = billing;
    const { shippingStreetName ="" , shippingAptNo ="" , shippingCity ="" , shippingStateCode ="" , shippingZipcode =""  } = shipping;
    return billingStreetName.toLowerCase() === shippingStreetName.toLowerCase() && billingAptNo.toLowerCase() === shippingAptNo.toLowerCase() && billingCity.toLowerCase() === shippingCity.toLowerCase() && billingStateCode.toLowerCase() === shippingStateCode.toLowerCase() && billingZipcode.toLowerCase() === shippingZipcode.toLowerCase();
};
const getIsSameAddress = (add1, add2)=>{
    const { streetName: streetName1 = "" , streetNumber: streetNumber1 = "" , city: city1 = "" , state: state1 = "" , postalCode: postalCode1 = ""  } = add1;
    const { streetName: streetName2 = "" , streetNumber: streetNumber2 = "" , city: city2 = "" , state: state2 = "" , postalCode: postalCode2 = ""  } = add2;
    return streetName1.toLowerCase() === streetName2.toLowerCase() && streetNumber1.toLowerCase() === streetNumber2.toLowerCase() && city1.toLowerCase() === city2.toLowerCase() && state1.toLowerCase() === state2.toLowerCase() && postalCode1.toLowerCase() === postalCode2.toLowerCase();
};
const getShippingAllTotal = (customLineItems, locale)=>{
    const shippings = [];
    customLineItems.forEach(function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { custom: { fields: { isBundleParent =false  } = {}  } = {} , name ={} , totalPrice: { centAmount: totalPrice = 0  } = {}  } = item;
        const itemName = name[locale];
        var ref;
        const amount = (ref = totalPrice / 100) !== null && ref !== void 0 ? ref : 0;
        if (isBundleParent) return false;
        if (!shippings.find((el)=>el.name === itemName)) {
            shippings.push({
                total: amount,
                name: itemName
            });
        } else {
            const index = shippings.findIndex((code)=>code.name === itemName);
            shippings[index].total += amount;
        }
    });
    return shippings.filter((e)=>e.name !== "Service");
};
const getShippingData = async (currencySign, freeShipping)=>{
    const { cart: { cart: { customLineItems  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState();
    const { internationalization: { locale  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const shippingAllTotal = getShippingAllTotal(customLineItems, locale);
    var ref;
    const freightShippingData = (ref = shippingAllTotal.find((el)=>{
        return _constants__WEBPACK_IMPORTED_MODULE_1__.FREIGHT_SHIPPING_TYPES.includes(el === null || el === void 0 ? void 0 : el.name);
    })) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const parcelShippingData = (ref1 = shippingAllTotal.find((el)=>{
        return !_constants__WEBPACK_IMPORTED_MODULE_1__.FREIGHT_SHIPPING_TYPES.includes(el === null || el === void 0 ? void 0 : el.name);
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { total: freightAmount = ""  } = freightShippingData;
    const { total: parcelAmount = ""  } = parcelShippingData;
    const freightShippingCost = freightAmount > 0 ? "".concat(currencySign).concat(Number(freightAmount).toFixed(2)) : freeShipping;
    const parcelShippingCost = parcelAmount > 0 ? "".concat(currencySign).concat(parcelAmount, ".00") : freeShipping;
    return {
        freightShippingCost,
        parcelShippingCost
    };
};
const getOrderDetailsUrl = async (email, orderNumber)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const { general: { orderDetailsPath =""  } = {}  } = config;
    return "".concat(orderDetailsPath, "?orderNumber=").concat(orderNumber, "&q=").concat(Buffer.from(email).toString("base64"));
};
const getPdpRedirectUrl = (pdpUrl, param)=>{
    const isHasQueryParams = pdpUrl.includes("?");
    return "".concat(pdpUrl).concat(isHasQueryParams ? "&" : "?").concat(param);
};
const isObjectEmpty = (object)=>{
    return Object.keys(object).length === 0;
};
/**
 *
 * @param {Array} data Array of Object
 * @param {String} key key name
 * @return {String} preset url
 */ const getUniqueObjectListBy = (data, key)=>{
    return [
        ...new Map(data.map((e)=>[
                e[key],
                e
            ])).values()
    ];
};
const getPayPalPaymentIdFromParams = ()=>{
    if (false) {}
    const urlParams = new URLSearchParams(window.location.search);
    const paymentType = urlParams.get("pm");
    const urlPayId = urlParams.get("payId");
    const isXpp = paymentType === "xpp";
    const payId = sessionStorage.getItem("payId");
    return isXpp ? payId : urlPayId;
};
const getBrandSwitcher = function() {
    let headerData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const headPropsItems = headerData[":items"];
    const headerPropsRoot = headPropsItems === null || headPropsItems === void 0 ? void 0 : headPropsItems.root;
    const headerRootItems = headerPropsRoot[":items"];
    const hedaerPropsContainer = headerRootItems === null || headerRootItems === void 0 ? void 0 : headerRootItems.container_copy_copy;
    const headerContainerItems = hedaerPropsContainer[":items"];
    const headerUtilityWidgets = headerContainerItems === null || headerContainerItems === void 0 ? void 0 : headerContainerItems.brand_switcher;
    var ref;
    return (ref = headerUtilityWidgets === null || headerUtilityWidgets === void 0 ? void 0 : headerUtilityWidgets.items) !== null && ref !== void 0 ? ref : "";
};
const handleViewSterlingResults = function() {
    let brandSwitcher = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], brandName = arguments.length > 1 ? arguments[1] : void 0, sku = arguments.length > 2 ? arguments[2] : void 0;
    const { link  } = brandSwitcher.find((item)=>item.brandName.toLowerCase().replaceAll(" ", "") === brandName.toLowerCase());
    window.open("".concat(link, "/en/search?keyword=").concat(sku), "_blank");
};
const findStoreUtilNavselectQuery = "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality";
const isString = (data)=>{
    return (data === null || data === void 0 ? void 0 : data.constructor.name) === "String";
};
const isObject = (data)=>{
    return (data === null || data === void 0 ? void 0 : data.constructor.name) === "Object";
};
const isValidPostalCode = (postalCode, countryCode)=>{
    let postalCodeRegex;
    switch(countryCode){
        case "US":
            postalCodeRegex = _constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .POSTAL_CODE_US_REGEX */ .VB;
            break;
        case "CA":
            postalCodeRegex = _constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .POSTAL_CODE_CA_REGEX */ .wc;
            break;
        default:
            postalCodeRegex = _constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .POSTAL_CODE_REGEX */ .wM;
    }
    return postalCodeRegex.test(postalCode);
};
const isLeadGeneration = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.Lead_Generation);
};
const getSanitizeNumber = (number)=>{
    return number.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .SANITIZE_NUMBER_REGEX */ .Tc, "");
};
const updateMetaContent = (metaName, value)=>{
    const metas = document.querySelectorAll("meta");
    const itemList = Array.from(metas).filter((val)=>{
        return (val === null || val === void 0 ? void 0 : val.name) === (metaName === null || metaName === void 0 ? void 0 : metaName.toLowerCase());
    });
    if (itemList && itemList.length !== 0) {
        const lastElement = itemList.at(-1);
        lastElement.setAttribute("content", value);
        return lastElement;
    }
    return false;
};
const parseToBoolean = (inputVal)=>{
    if (inputVal === null || inputVal === undefined) {
        return false;
    }
    if (typeof inputVal === "boolean") {
        return inputVal;
    }
    if (typeof inputVal === "string") {
        return /true/i.test(inputVal);
    }
    return inputVal;
};
/**
 *
 * @return {Object} {
 *  code: 'US',
 *  name: 'United States of America',
 *  states: [{code: 'AL', name: 'Alabama', countryCode: 'US'}]}
 */ const getCountryStatesList = ()=>{
    const { generic: { countryList =[] , stateList =[]  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState();
    const countriesListData = countryList.map((country)=>{
        return {
            code: country.value,
            name: country.text,
            states: []
        };
    });
    const countries = countriesListData.map((el)=>{
        const states = [];
        stateList.forEach((state)=>{
            const { value =""  } = state;
            const [code, countryCode] = value.split(":");
            if (countryCode === el.code) {
                states.push({
                    code,
                    name: state.text,
                    countryCode
                });
            }
        });
        return {
            ...el,
            states
        };
    });
    return {
        countries
    };
};
const formatAddress = (addr)=>{
    const { countries  } = getCountryStatesList();
    const { fname: { value: firstName = ""  } = {} , lname: { value: lastName = ""  } = {} , address1: { value: streetName = ""  } = {} , zipcode: { value: postalCode = ""  } = {} , city: { value: city = ""  } = {} , state: { value: state = ""  } = {} , country: { value: country = ""  } = {} , email: { value: email = ""  } = {} , phone: { value: phone = ""  } = {} , label: { show: setPrimary = "" , value: label = ""  } = {} , address2: streetNumber = "" , id =""  } = addr;
    const address = {
        firstName,
        lastName,
        streetName,
        streetNumber,
        postalCode,
        city,
        state: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getStateCode */ .jeb)(state, country, countries),
        country: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCountryCode */ .soW)(country, countries),
        email,
        phone,
        setPrimary,
        custom: {
            type: {
                typeId: "type",
                key: "custom-address"
            },
            fields: {
                label
            }
        },
        id
    };
    return address;
};
const mapCollapsedSku = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { itemSkus =[] , cart ={} , item =[] , isLineItems =false  } = data;
    const { generic: { globalConfig: { internationalization: { language ="en"  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState() || {};
    const skuQury = getSkusQuery(itemSkus);
    const url = "".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?fq=language_s:(").concat(language, ")&fq=sku_s:(").concat(skuQury, ")&rows=10&start=0&fl=sku_s,isCollapsedPDP_b,masterSKU_s&persona=GST&profilename=Search");
    const { data: { response: { docs: docsData = []  } = {}  } = {}  } = skuQury ? await _constants_api__WEBPACK_IMPORTED_MODULE_6__/* .apim.get */ .TH.get(url) : {};
    if (!docsData.length) {
        if (isLineItems) {
            return item;
        } else if (!cart.item) {
            cart.item = [];
            return cart;
        } else return cart;
    }
    var ref;
    const itemsData = isLineItems ? item : (ref = cart === null || cart === void 0 ? void 0 : cart.item) !== null && ref !== void 0 ? ref : [];
    const cartItemsMaped = itemsData.map((e)=>{
        var ref;
        const { isCollapsedPDP_b: isCollapsedPDP = false  } = (ref = docsData.find((el)=>{
            return "K-".concat(el.sku_s) === e.productInfo.productID;
        })) !== null && ref !== void 0 ? ref : {};
        e.productInfo.productSkuOption = isCollapsedPDP;
        return e;
    });
    cart.item = cartItemsMaped;
    return isLineItems ? cartItemsMaped : cart;
};
/**
 *
 * @param {Array} skus  Array
 * @return {String} '"22972-CP", "32380-CH05-BLL"'
 */ const getSkusQuery = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    return query;
};
/**
 * Returns the fixed value 613.19.
 *
 * @param {number} number
 * @return {number} - Returns the fixed value 613.19.
 */ const getSanitizedFloatingNumber = (number)=>{
    return number.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .SANITIZE_FLOAT_NUMBER_REGEX */ .SA, "");
};
/**
 * Returns the pure text value for <h3>Vibrant<sup>®</sup>&nbsp;Polished Nickel</h3>.
 *
 * @param {string} string
 * @return {string} - Returns the pure text without encoding entities (vibrant polished nickel).
 */ const sanitizedTextAndEntities = (str)=>{
    if (!str) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = str;
    return tempDiv.textContent.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .SPACE_REGEX */ .my, " ").trim();
};
const getDeviceId = ()=>{
    const { IGLOO: { getBlackbox  } = {}  } = window || {};
    const { blackbox  } = (getBlackbox === null || getBlackbox === void 0 ? void 0 : getBlackbox()) || {};
    return encodeURIComponent(blackbox !== null && blackbox !== void 0 ? blackbox : "");
};



/***/ }),

/***/ 97433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ validateZip; },
/* harmony export */   "BO": function() { return /* binding */ getUtilityStoreDetails; },
/* harmony export */   "OP": function() { return /* binding */ validateField; },
/* harmony export */   "Pp": function() { return /* binding */ getShortenedUrl; },
/* harmony export */   "e": function() { return /* binding */ getStoreDataById; },
/* harmony export */   "nY": function() { return /* binding */ validateInputField; },
/* harmony export */   "zO": function() { return /* binding */ getStoreDataByDistance; }
/* harmony export */ });
/* unused harmony exports getLocationUsingIP, getLocationUsingZipcode */
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20558);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88032);








// Get location using the public ip address of the client
const getLocationUsingIP = async ()=>{
    try {
        const ip = window === null || window === void 0 ? void 0 : window.sessionStorage["true-ip"];
        if (ip && ip !== "") {
            // {"23.100.225.115"}
            const res = await apim.get("".concat(locationIpEndPoint).concat(ip));
            return res;
        } else {
            return {};
        }
    } catch (err) {
        console.error("Failed to get location using IP address", err);
    }
};
// Get location using the zip code
const getLocationUsingZipcode = async (zip)=>{
    try {
        if (zip && zip !== "") {
            const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.locationZipEndPoint).concat(zip));
            return res;
        } else {
            return {};
        }
    } catch (err) {
        console.error("Failed to get location using zipcode", err);
    }
};
const validateField = async (field, value)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { regexPattern  } = config;
    const pattern = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(regexPattern, "map.".concat(field), "");
    const regex = new RegExp(pattern);
    const isValid = regex.test(value) ? true : false;
    return isValid;
};
const validateInputField = (field, value)=>{
    const { generic: { globalConfig: { regexPattern: { map  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_6__/* .store.getState */ .h.getState();
    const pattern = map[field];
    const regex = new RegExp(pattern);
    const isValid = regex.test(value);
    return isValid;
};
const validateZip = async (zip)=>{
    var ref, ref1, ref2, ref3, ref4;
    const res = await getLocationUsingZipcode(zip);
    if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.resourceSets) && ((ref3 = (ref2 = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.resourceSets[0]) === null || ref2 === void 0 ? void 0 : ref2.resources[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.address) === null || ref4 === void 0 ? void 0 : ref4.postalCode) === zip) return true;
    return false;
};
const getShortenedUrl = async (uUrl)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { general  } = config;
    var ref;
    const shortUrl = (ref = general === null || general === void 0 ? void 0 : general.shortendPagePath) !== null && ref !== void 0 ? ref : "";
    const htmlRegExp = new RegExp(".html", "g");
    const htmlRemovedUrl = "".concat(uUrl === null || uUrl === void 0 ? void 0 : uUrl.replace(htmlRegExp, ""));
    const shortUrlRegEx = new RegExp(shortUrl, "g");
    return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
};
const getStoreDataById = (param)=>{
    let { myStoreId , findStores , siteName  } = param;
    return new Promise((resolve, reject)=>{
        const selectQuery = _utils__WEBPACK_IMPORTED_MODULE_5__/* .findStoreUtilNavselectQuery */ .$H;
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(findStores)) {
            _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    $select: selectQuery,
                    $filter: "EntityID Eq ('".concat(myStoreId, "')")
                }
            }).then((response)=>{
                if (response && response.data) {
                    var ref;
                    resolve((ref = response.data.d.results[0]) !== null && ref !== void 0 ? ref : {});
                } else {
                    reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
                // log.error(
                //   "Find a nearest store: Error occured while fetching data from Get URL Property"
                // )
                }
            }).catch((err)=>{
                console.log({
                    err
                });
                reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
            });
        // .catch(err => log.error(err))
        } else {
        // log.error("Find a nearest store: Get API config not found")
        }
    });
};
const getStoreDataByDistance = (param)=>{
    let { utilityDistance =_constants__WEBPACK_IMPORTED_MODULE_2__.STORE_MIN_DISTANCE , findStores , userCity , siteName  } = param;
    return new Promise((resolve, reject)=>{
        // const locationStore = store.getState()?.location || ""
        // console.log({ locationStore })
        const selectQuery = "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality";
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(findStores)) {
            _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    spatialFilter: "nearby('".concat(userCity, "',").concat(utilityDistance, ")"),
                    $select: selectQuery,
                    $filter: "LocationType Eq ('KOHLER Store')"
                }
            }).then((response)=>{
                if (response && response.data) {
                    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(response.data.d.results[0])) {
                        const utilityData = response.data.d.results[0];
                        resolve(utilityData);
                    } else if (utilityDistance === 64) {
                        getStoreDataByDistance({
                            utilityDistance: _constants__WEBPACK_IMPORTED_MODULE_2__.STORE_MAX_DISTANCE,
                            findStores,
                            userCity
                        });
                    }
                } else {
                    reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
                // log.error(
                //   "Find a nearest store: Error occured while fetching data from Get URL Property"
                // )
                }
            }).catch((err)=>{
                console.log({
                    err
                });
            // log.error(err)
            });
        } else {
        // log.error("Find a nearest store: Get API config not found")
        }
    });
};
const getUtilityStoreDetails = async (param)=>{
    let { utilityStoreDetailsUrl  } = param;
    try {
        const response = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_3__/* .aemAxiosInstance */ .Gb)({
            url: _constants__WEBPACK_IMPORTED_MODULE_2__.STORE_DETAILS_API_ENDPOINT,
            params: {
                path: utilityStoreDetailsUrl
            }
        });
        if (response && response.data) {
            return response.data;
        // this.setState({
        //   utilityStoreDetails: response.data ?? {},
        // })
        } else {
        // log.error(
        //   "Store Details: Error occured while fetching data from Get URL Property"
        // )
        }
    } catch (error) {
    // log.error(error)
    }
};



/***/ }),

/***/ 61372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lK": function() { return /* binding */ createContextLogger; }
/* harmony export */ });
/* unused harmony exports initializeGlobalLogger, error, warn, info, debug, setLevel */
/* harmony import */ var _loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24747);
/* harmony import */ var _loggerUtils_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);
/* provided dependency */ var process = __webpack_require__(34155);
/**
 * Kohler Frontend Logger
 * - Console + Remote (Azure App Insights) logging
 * - Configurable levels, sanitization, and transports
 */ 

let getAppInsights;
let getCurrentPageViewId;
if (true) {
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55954)).then((module)=>{
        getAppInsights = module.getAppInsights;
        getCurrentPageViewId = module.getCurrentPageViewId;
    }).catch((error)=>{
        try {
            console && console.warn && console.warn("[KohlerLogger] Failed to load App Insights:", error);
        } catch (_) {
        // swallow
        }
    });
}
const defaultConfig = {
    /** Controls minimum log level to process - filters out noise in production */ level: (process.env.NEXT_PUBLIC_LOG_LEVEL || "INFO").toUpperCase(),
    /** Controls browser console output - disable in production for performance */ consoleEnabled: process.env.NEXT_PUBLIC_LOG_CONSOLE_ENABLED !== "false",
    /** Controls Azure App Insights telemetry - disable to prevent data collection */ remoteEnabled: process.env.NEXT_PUBLIC_LOG_REMOTE_ENABLED === "false" ? false : true,
    /** Prevents infinite recursion when logging complex nested objects */ maxDepth: 4,
    /** Prevents memory issues when logging large arrays - truncates for performance */ maxArrayLength: 50,
    /** Prevents log bloat from huge strings - truncates to keep logs readable */ maxStringLength: 1000,
    /** Adds consistent prefix to all log contexts for multi-app identification */ globalContext: "",
    /** Enables user tracking in logs for debugging user-specific issues */ getUserId: null,
    /** Allows extending logger with custom destinations (Slack, Sentry, etc.) */ transports: []
};
let runtimeConfig = {
    ...defaultConfig
};
/**
 * Updates the logger configuration with partial config object
 * @param {object} partial - Partial configuration object to merge with current config
 * @return {void}
 */ function setConfig(partial) {
    runtimeConfig = {
        ...runtimeConfig,
        ...partial
    };
}
/**
 * Builds structured log data with context, timestamp, and page information
 * @param {string} instanceContext - Logger instance context
 * @param {string} level - Log level
 * @param {string} message - Log message
 * @param {object} meta - Additional metadata
 * @return {object} Structured log data object
 */ function buildLogData(instanceContext, level, message, meta) {
    var ref;
    const page =  true && ((ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) ? window.location.pathname : "server";
    let pageViewId;
    try {
        pageViewId = getCurrentPageViewId ? getCurrentPageViewId() : undefined;
    } catch (_) {
        pageViewId = undefined;
    }
    const baseData = (0,_loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__.buildBaseLogData)(instanceContext, level, message, runtimeConfig, page);
    const sanitizedMeta = (0,_loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__.sanitize)(meta, 0, new WeakSet(), runtimeConfig);
    const reserved = new Set([
        "level",
        "message",
        "context",
        "timestamp",
        "page",
        "userId",
        "pageViewId",
        "user",
        "guestID"
    ]);
    const filteredMeta = {};
    if (sanitizedMeta && typeof sanitizedMeta === "object") {
        for (const [k, v] of Object.entries(sanitizedMeta)){
            if (!reserved.has(k)) filteredMeta[k] = v;
        }
    }
    let logData = {
        ...filteredMeta,
        ...baseData,
        pageViewId
    };
    // Enrich with user context if store is available
    if (_store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h && "object" !== "undefined") {
        logData = (0,_loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__.enrichWithUserContext)(logData, _store__WEBPACK_IMPORTED_MODULE_1__/* .store */ .h);
    }
    return logData;
}
/**
 * Sends log data to remote logging services (Azure App Insights) and custom transports
 * @param {string} level - Log level
 * @param {string} instanceContext - Logger instance context
 * @param {string} message - Log message
 * @param {object} logData - Structured log data
 * @param {object} rawMeta - Raw metadata (may contain Error objects)
 * @return {void}
 */ function remoteWrite(level, instanceContext, message, logData, rawMeta) {
    if (!runtimeConfig.remoteEnabled) return;
    try {
        const appInsights = getAppInsights ? getAppInsights() : null;
        const formattedMessage = "".concat(instanceContext ? "[".concat(instanceContext, "]") : "", " ").concat(message);
        if (appInsights) {
            if (level === "ERROR" && rawMeta && rawMeta.error instanceof Error) {
                appInsights.trackException({
                    exception: rawMeta.error,
                    properties: {
                        ...logData,
                        error: undefined
                    },
                    severityLevel: 3
                });
            } else {
                const severityMap = {
                    ERROR: 3,
                    WARN: 2,
                    INFO: 1,
                    DEBUG: 0
                };
                appInsights.trackTrace({
                    message: formattedMessage,
                    severityLevel: severityMap[level] || 1,
                    properties: logData
                });
            }
            if (level === "ERROR" && "production" === "development") {}
        }
        // Call custom transports regardless of App Insights status
        if (Array.isArray(runtimeConfig.transports)) {
            runtimeConfig.transports.forEach((fn)=>{
                try {
                    typeof fn === "function" && fn(level, message, logData);
                } catch (e) {
                    // Transport failures should not break app
                    try {
                        console && console.warn && console.warn("[KohlerLogger] transport failed", e);
                    } catch (_) {
                    // swallow
                    }
                }
            });
        }
    } catch (e) {
        try {
            console && console.warn && console.warn("[KohlerLogger] remote logging failed", e);
        } catch (_) {
        // swallow
        }
    }
}
/**
 * Internal logger implementation for global logger
 * @param {string} context - Context string for this logger instance
 * @return {object} Logger instance with methods
 */ function createLogger() {
    let context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const timers = new Map();
    /**
   * Internal logging method that handles both console and remote logging
   * @param {string} level - Log level
   * @param {string} message - Log message
   * @param {object} meta - Additional metadata
   * @return {void}
   */ function _log(level, message) {
        let meta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        try {
            if (!(0,_loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__.shouldLog)(level, runtimeConfig.level)) return;
            const contextStr = [
                runtimeConfig.globalContext,
                context
            ].filter(Boolean).join(":");
            let logData;
            try {
                logData = buildLogData(contextStr, level, message, meta);
            } catch (_) {
                // Ensure logging never throws due to data shaping
                logData = {
                    level,
                    message,
                    context: contextStr,
                    timestamp: new Date().toISOString()
                };
            }
            try {
                const { user , guestID  } = logData;
                const enrichedMeta = {
                    ...meta
                };
                if (user) enrichedMeta.user = user;
                if (guestID) enrichedMeta.guestID = guestID;
                (0,_loggerUtils_js__WEBPACK_IMPORTED_MODULE_0__.consoleWrite)(level, contextStr, message, enrichedMeta, runtimeConfig.consoleEnabled);
            } catch (_1) {
            // no-op
            }
            try {
                remoteWrite(level, context, message, logData, meta);
            } catch (_2) {
            // no-op
            }
        } catch (_3) {
            // Absolute last-resort guard: never let logging break the app
            try {
                console && console.log && console.log("[".concat(level, "] ").concat(message));
            } catch (__) {
            // no-op
            }
        }
    }
    return {
        // Core logging methods
        error: function(message) {
            let meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _log("ERROR", message, meta);
        },
        warn: function(message) {
            let meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _log("WARN", message, meta);
        },
        info: function(message) {
            let meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _log("INFO", message, meta);
        },
        debug: function(message) {
            let meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return _log("DEBUG", message, meta);
        },
        // Child logger creation
        child: (childContext)=>{
            const fullContext = [
                context,
                childContext
            ].filter(Boolean).join(":");
            return createLogger(fullContext);
        },
        // Timer methods
        timerStart: (label)=>timers.set(label, Date.now()),
        timerEnd: function(label) {
            let meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "INFO";
            const start = timers.get(label);
            if (start) {
                const durationMs = Date.now() - start;
                timers.delete(label);
                _log(level, "".concat(label, " duration"), {
                    ...meta,
                    durationMs
                });
            }
        },
        // Context getter
        getContext: ()=>[
                runtimeConfig.globalContext,
                context
            ].filter(Boolean).join(":")
    };
}
// Main logger instance
const logger = createLogger();
/**
 * Creates a new logger instance with the specified context
 * @param {string} contextName - Context name for the logger
 * @return {object} New logger instance
 */ const createContextLogger = (contextName)=>createLogger(contextName);
/**
 * Initializes the global logger on window.kohler.logger with various methods
 * @return {void}
 */ const initializeGlobalLogger = ()=>{
    if (true) {
        try {
            if (!window.kohler) window.kohler = {};
            window.kohler.logger = {
                // Core logging methods
                error: function(message) {
                    let metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return logger.error(message, metadata);
                },
                warn: function(message) {
                    let metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return logger.warn(message, metadata);
                },
                info: function(message) {
                    let metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return logger.info(message, metadata);
                },
                debug: function(message) {
                    let metadata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return logger.debug(message, metadata);
                },
                // Context-based logger creation
                createContextLogger: (contextName)=>createLogger(contextName),
                getLogger: (contextName)=>createLogger(contextName),
                // Auto page context logger
                getPageContextLogger: (componentName)=>{
                    var ref, ref1;
                    const currentPage = ((ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.pathname) === null || ref1 === void 0 ? void 0 : ref1.split("/").pop()) || "home";
                    const fullContext = componentName ? "".concat(currentPage, ":").concat(componentName) : currentPage;
                    return createLogger(fullContext);
                },
                // Configuration controls
                setLevel: (lvl)=>setConfig({
                        level: (lvl || "INFO").toUpperCase()
                    }),
                enableConsole: ()=>setConfig({
                        consoleEnabled: true
                    }),
                disableConsole: ()=>setConfig({
                        consoleEnabled: false
                    }),
                enableRemote: ()=>setConfig({
                        remoteEnabled: true
                    }),
                disableRemote: ()=>setConfig({
                        remoteEnabled: false
                    }),
                setGlobalContext: (ctx)=>setConfig({
                        globalContext: ctx || ""
                    }),
                setUserResolver: (fn)=>setConfig({
                        getUserId: typeof fn === "function" ? fn : null
                    }),
                addTransport: (fn)=>setConfig({
                        transports: [
                            ...runtimeConfig.transports,
                            fn
                        ].filter(Boolean)
                    }),
                getConfig: ()=>({
                        ...runtimeConfig
                    })
            };
            try {
                console && console.info && console.info("[KohlerLogger] Global logger initialized at window.kohler.logger");
            } catch (_) {
            // swallow
            }
        } catch (_1) {
        // swallow - global logger init must never break
        }
    }
};
if (true) {
    initializeGlobalLogger();
}
// Clean, short export functions for import usage (alternative to global logger)
/**
 * Shorthand for error logging using the main logger
 * @param {string} message - Error message to log
 * @param {object} metadata - Additional metadata
 * @return {void}
 */ const error = (message, metadata)=>logger.error(message, metadata);
/**
 * Shorthand for warning logging using the main logger
 * @param {string} message - Warning message to log
 * @param {object} metadata - Additional metadata
 * @return {void}
 */ const warn = (message, metadata)=>logger.warn(message, metadata);
/**
 * Shorthand for info logging using the main logger
 * @param {string} message - Info message to log
 * @param {object} metadata - Additional metadata
 * @return {void}
 */ const info = (message, metadata)=>logger.info(message, metadata);
/**
 * Shorthand for debug logging using the main logger
 * @param {string} message - Debug message to log
 * @param {object} metadata - Additional metadata
 * @return {void}
 */ const debug = (message, metadata)=>logger.debug(message, metadata);
/**
 * Shorthand for setting log level using the main logger
 * @param {string} level - Log level to set
 * @return {void}
 */ const setLevel = (level)=>setConfig({
        level: (level || "INFO").toUpperCase()
    });
// Default export
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (logger)));


/***/ }),

/***/ 24747:
/***/ (function(module, exports) {

"use strict";
/**
 * Shared utilities for client and server loggers
 * - Common constants, functions, and validation logic
 */ /**
 * Standard log levels in priority order (lower index = higher priority)
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LEVELS: ()=>LEVELS,
    shouldLog: ()=>shouldLog,
    sanitize: ()=>sanitize,
    consoleWrite: ()=>consoleWrite,
    buildBaseLogData: ()=>buildBaseLogData,
    redactEmail: ()=>redactEmail,
    getGuestIdFromToken: ()=>getGuestIdFromToken,
    enrichWithUserContext: ()=>enrichWithUserContext
});
const LEVELS = [
    "ERROR",
    "WARN",
    "INFO",
    "DEBUG"
];
/**
 * Determines if a message should be logged based on the current log level
 * @param {string} level - Log level to check (ERROR, WARN, INFO, DEBUG)
 * @param {string} configLevel - Current configured log level
 * @return {boolean} True if the message should be logged
 */ function shouldLog(level, configLevel) {
    const currentLevelIndex = LEVELS.indexOf(configLevel);
    const messageLevelIndex = LEVELS.indexOf(level);
    // If level not found, default to INFO (index 2)
    const currentIndex = currentLevelIndex >= 0 ? currentLevelIndex : 2;
    const messageIndex = messageLevelIndex >= 0 ? messageLevelIndex : 2;
    // Lower index = higher priority (ERROR=0 is highest, DEBUG=3 is lowest)
    return messageIndex <= currentIndex;
}
/**
 * Sanitizes data for logging by controlling depth/size and handling circular references
 * @param {any} value - Value to sanitize
 * @param {number} depth - Current depth in object traversal
 * @param {WeakSet} seen - Set to track circular references
 * @param {object} config - Configuration object with maxDepth, maxArrayLength, maxStringLength
 * @return {any} Sanitized value safe for logging
 */ function sanitize(value) {
    let depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, seen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new WeakSet(), config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const { maxDepth =4 , maxArrayLength =50 , maxStringLength =1000  } = config;
    try {
        if (value == null) return value;
        if (typeof value === "string") {
            if (value.length > maxStringLength) {
                return value.slice(0, maxStringLength) + "…";
            }
            return value;
        }
        if (typeof value === "number" || typeof value === "boolean") {
            return value;
        }
        if (value instanceof Error) {
            return {
                name: value.name,
                message: value.message,
                stack: value.stack
            };
        }
        if (typeof value === "function") {
            return "[Function ".concat(value.name || "anonymous", "]");
        }
        if (typeof value === "object") {
            if (seen.has(value)) return "[Circular]";
            seen.add(value);
            // Check depth limit for both arrays and objects
            if (depth >= maxDepth) {
                return Array.isArray(value) ? "[Array]" : "[Object]";
            }
            if (Array.isArray(value)) {
                const out = [];
                const len = Math.min(value.length, maxArrayLength);
                for(let i = 0; i < len; i++){
                    out.push(sanitize(value[i], depth + 1, seen, config));
                }
                if (value.length > maxArrayLength) {
                    out.push("[+".concat(value.length - maxArrayLength, " more]"));
                }
                return out;
            }
            // Check if object has toJSON method and call it if depth allows
            if (value.toJSON && typeof value.toJSON === "function") {
                try {
                    const jsonResult = value.toJSON();
                    // Replace the original object with the toJSON result
                    return sanitize(jsonResult, depth, seen, config);
                } catch (e) {
                // If toJSON fails, fall back to normal object serialization
                }
            }
            const out1 = {};
            for (const [k, v] of Object.entries(value)){
                out1[k] = sanitize(v, depth + 1, seen, config);
            }
            return out1;
        }
        return value;
    } catch (e1) {
        return "[Unserializable]";
    }
}
/**
 * Writes log message to console with appropriate console method based on level
 * @param {string} level - Log level (ERROR, WARN, INFO, DEBUG)
 * @param {string} contextStr - Context string for the log message
 * @param {string} message - Log message
 * @param {object} meta - Additional metadata to log
 * @param {boolean} consoleEnabled - Whether console logging is enabled
 * @return {void}
 */ function consoleWrite(level, contextStr, message, meta) {
    let consoleEnabled = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    if (!consoleEnabled) return;
    try {
        const consoleMessage = "[".concat(level, "]").concat(contextStr ? " [".concat(contextStr, "]") : "", " ").concat(message);
        switch(level){
            case "ERROR":
                console.error(consoleMessage, meta);
                break;
            case "WARN":
                console.warn(consoleMessage, meta);
                break;
            case "INFO":
                console.info(consoleMessage, meta);
                break;
            case "DEBUG":
                console.debug(consoleMessage, meta);
                break;
            default:
                console.log(consoleMessage, meta);
        }
    } catch (e) {
        // Never allow console issues to break the app
        try {
            // Best-effort minimal fallback
            console && console.log && console.log("[".concat(level, "] ").concat(message));
        } catch (_) {
        // no-op
        }
    }
}
/**
 * Redacts email for privacy - shows first/last char of local part only
 * @param {string} email - Email to redact
 * @return {string} Redacted email (e.g., "j***n@example.com")
 */ function redactEmail(email) {
    if (!(email === null || email === void 0 ? void 0 : email.includes("@"))) return "";
    const [localPart, domain] = email.split("@");
    if (!localPart || !domain) return "";
    const redactedLocalPart = localPart.charAt(0) + "***" + localPart.at(-1);
    return "".concat(redactedLocalPart, "@").concat(domain);
}
/**
 * Extracts guest ID from anonymous Okta token stored in localStorage
 * @return {string} Guest ID or empty string if not found/invalid
 */ function getGuestIdFromToken() {
    if (false) {}
    try {
        const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token");
        if (!anonymousOktaToken) return "";
        const [, payload] = anonymousOktaToken.split(".");
        if (!payload) return "";
        const oktaObject = JSON.parse(atob(payload)) || {};
        return oktaObject.gId || "";
    } catch (e) {
        try {
            var ref;
            console === null || console === void 0 ? void 0 : (ref = console.warn) === null || ref === void 0 ? void 0 : ref.call(console, "Anonymous Okta Token cannot be decoded:", e.message);
        } catch (_) {
        // swallow
        }
        return "";
    }
}
/**
 * Enriches log data with user identification (authenticated user or guest)
 * Requires Redux store to be passed in
 * @param {object} logData - Base log data to enrich
 * @param {object} store - Redux store instance
 * @return {object} Enriched log data with user/guestID field
 */ function enrichWithUserContext(logData, store) {
    if (!store) return logData;
    try {
        const state = (store === null || store === void 0 ? void 0 : store.getState()) || {};
        const { auth: { user: { lowercaseEmail =""  } = {} , isAuth =false  } = {}  } = state;
        if (isAuth && lowercaseEmail) {
            return {
                ...logData,
                user: redactEmail(lowercaseEmail)
            };
        } else {
            const guestID = getGuestIdFromToken();
            return guestID ? {
                ...logData,
                guestID
            } : logData;
        }
    } catch (e) {
        // Never let user context enrichment break logging
        return logData;
    }
}
/**
 * Builds base log data structure with common fields
 * @param {string} instanceContext - Logger instance context
 * @param {string} level - Log level
 * @param {string} message - Log message
 * @param {object} config - Configuration object with globalContext, getUserId
 * @param {string} pathname - Pathname for client
 * @return {object} Base structured log data object
 */ function buildBaseLogData(instanceContext, level, message, config, pathname) {
    const { globalContext ="" , getUserId =null  } = config;
    let userId;
    if (typeof getUserId === "function") {
        try {
            userId = getUserId();
        } catch (_) {
            // swallow user resolver errors
            userId = undefined;
        }
    }
    return {
        level,
        message,
        context: [
            globalContext,
            instanceContext
        ].filter(Boolean).join(":"),
        timestamp: new Date().toISOString(),
        page: pathname,
        userId
    };
}
// Export both CommonJS and ES module formats for compatibility
module.exports = {
    LEVELS,
    shouldLog,
    sanitize,
    consoleWrite,
    buildBaseLogData,
    redactEmail,
    getGuestIdFromToken,
    enrichWithUserContext
};


/***/ }),

/***/ 87864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ checkExpPayPal; },
/* harmony export */   "Xx": function() { return /* binding */ getAciPayPalPaymentStatus; },
/* harmony export */   "mR": function() { return /* binding */ aciPaymentWidgetsInit; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20558);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64757);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73350);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88751);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46201);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60475);










const getAciPayPalPaymentStatus = async (data)=>{
    const { genericError ="" , unverifiedAddressMsg ="" , outOfCountryAddressMsg ="" , expPayPalCallBackErrorMsg: expPayPalAuthorErrorMsg = "" , onNext =()=>{}  } = data || {};
    const isXpp = checkExpPayPal();
    const id = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getPayPalPaymentIdFromParams */ .qV)();
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(false));
    const { generic: { aciPaymentErrorMessagesPath ="" , globalConfig: { general: { checkoutPagePath ="/"  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState() || {};
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(true));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(""));
    const checkoutUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getShortenedUrlPath */ .mXk)(checkoutPagePath);
    const { activeCartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getCartIdParams */ .Uo)();
    if (!id) {
        window.history.replaceState(null, null, checkoutUrl);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        return false;
    }
    const apiUrl = "".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_4__/* .ACI_PAYMENT_CALLBACK_ENDPOINT */ .zG, "?cartId=").concat(activeCartId, "&sessionId=").concat(id, "&pm=").concat(isXpp ? "xpp" : "pp");
    try {
        const { data: data1 = {}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_5__/* .apim.get */ .TH.get(apiUrl);
        const { paymentInfo: { payments =[]  } = {} , isVerifiedAddress =false  } = data1;
        var ref;
        const { id: payPalpaymentId = "" , obj: { paymentMethodInfo: { method =""  } = {}  } = {}  } = (ref = payments[0]) !== null && ref !== void 0 ? ref : {};
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymetId */ .BR)(payPalpaymentId));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsPaymentInfoAction */ .hK)(true));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentMethodNameAction */ .I2)(method));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        onNext();
        if (isXpp) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsVerifiedAddress */ .Bp)(isVerifiedAddress));
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setCheckoutAction */ .BZ)(!isVerifiedAddress ? 0 : 3));
            if (!isVerifiedAddress) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPayPalCallBackErrorMsg */ .SB)(unverifiedAddressMsg));
            }
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_8__/* .getCart */ .dv)());
        }
        window.history.replaceState(null, null, "".concat(checkoutUrl).concat(isXpp ? "?pm=xpp" : ""));
    } catch (error) {
        const { response: { data: { errorCode , errorDesc ="" , isShipmentFromCart =true  } = {}  } = {}  } = error !== null && error !== void 0 ? error : {};
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(true));
        try {
            const { data: data2 = []  } = await _constants_api__WEBPACK_IMPORTED_MODULE_5__/* .aemAxiosInstance.get */ .Gb.get(_constants___WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath);
            const { value: errorMsg  } = data2.find((e)=>e.text === errorCode);
            onPayPalCallBackErorr({
                isXpp,
                genericError,
                errorMsg,
                errorDesc,
                expPayPalAuthorErrorMsg,
                outOfCountryAddressMsg,
                unverifiedAddressMsg,
                isShipmentFromCart
            });
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        } catch (e) {
            onPayPalCallBackErorr({
                isXpp,
                genericError,
                errorDesc,
                expPayPalAuthorErrorMsg,
                outOfCountryAddressMsg,
                unverifiedAddressMsg,
                isShipmentFromCart
            });
        }
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        window.history.replaceState(null, null, checkoutUrl);
    }
};
const onPayPalCallBackErorr = (data)=>{
    const { isXpp , genericError , errorMsg , errorDesc , expPayPalAuthorErrorMsg , outOfCountryAddressMsg , unverifiedAddressMsg , isShipmentFromCart  } = data;
    const isInvalidCountry = errorDesc === "invalid country";
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsInvalidCountryAction */ .Ds)(isInvalidCountry));
    const getErrorMessage = ()=>{
        if (isInvalidCountry) {
            return outOfCountryAddressMsg;
        }
        if (!isShipmentFromCart) {
            return unverifiedAddressMsg;
        }
        return errorMsg || expPayPalAuthorErrorMsg;
    };
    if (isXpp) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setCheckoutAction */ .BZ)(0));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setExpPayPalCheckout */ .gp)(false));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPayPalCallBackErrorMsg */ .SB)(getErrorMessage()));
    } else {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setCheckoutAction */ .BZ)(2));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentMethodNameAction */ .I2)("paypal"));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(errorMsg || errorDesc || genericError));
    }
};
const checkExpPayPal = ()=>{
    if (false) {}
    const urlParams = new URLSearchParams(window.location.search);
    const paymentType = urlParams.get("pm");
    return paymentType === "xpp";
};
const aciPaymentWidgetsInit = function() {
    let isInit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, checkoutId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const scriptElem = document.getElementById("aciPaymentWidget");
    if (isInit) {
        const script = document.createElement("script");
        script.src = "".concat("https://eu-prod.oppwa.com/v1/paymentWidgets.js", "?").concat(checkoutId ? "checkoutId=".concat(checkoutId) : "");
        script.id = "aciPaymentWidget";
        document.body.append(script);
    } else {
        scriptElem === null || scriptElem === void 0 ? void 0 : scriptElem.remove();
    }
};


/***/ }),

/***/ 29843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ls": function() { return /* binding */ getPromoTilePosition; },
/* harmony export */   "MO": function() { return /* binding */ getIsPresentOnDevice; },
/* harmony export */   "NM": function() { return /* binding */ getFilterBarProps; },
/* harmony export */   "Sv": function() { return /* binding */ redirectToPdp; },
/* harmony export */   "U9": function() { return /* binding */ getRowsInitialValue; },
/* harmony export */   "YG": function() { return /* binding */ getPromoClass; },
/* harmony export */   "Zj": function() { return /* binding */ removeFromCompareProduct; },
/* harmony export */   "dX": function() { return /* binding */ addToCompareProduct; },
/* harmony export */   "fi": function() { return /* binding */ getPromoColumns; },
/* harmony export */   "g6": function() { return /* binding */ getPromoType; },
/* harmony export */   "j6": function() { return /* binding */ addCollectionParam; },
/* harmony export */   "lH": function() { return /* binding */ placePromos; },
/* harmony export */   "mf": function() { return /* binding */ getProductDataFromSkus; },
/* harmony export */   "nx": function() { return /* binding */ formatListingData; },
/* harmony export */   "o1": function() { return /* binding */ handleWindowScroll; },
/* harmony export */   "rs": function() { return /* binding */ processPromos; }
/* harmony export */ });
/* unused harmony exports getListFromServer, getListFromClient, getPlpParams, getSearchItems, getProductDetailsFromServer, getBVReviewStatsData, getBVFullReviewData, setPLPCookie, scrollToSkuCard */
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85518);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39915);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88032);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);










const isServer = "object" === "undefined";
const addCollectionParam = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brandName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let endPoint = url;
    if ((brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()) !== _constants__WEBPACK_IMPORTED_MODULE_3__.EXCEPTIONAL_SITENAME) endPoint = "".concat(url, "&collections=").concat(brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase());
    return endPoint;
};
const getListFromServer = async function(profileName, persona) {
    let brandName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", locale = arguments.length > 3 ? arguments[3] : void 0;
    return new Promise(async (resolve, reject)=>{
        try {
            const url = addCollectionParam("".concat(apiBaseUrl).concat(PLP_END_POINT_SUBSCRIPTION_KEY, "?profilename=").concat(profileName, "&persona=").concat(persona), brandName);
            aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
            const { data: content  } = await aemAxiosInstance({
                url,
                params: {
                    fq: 'language_s:("'.concat(locale, '")'),
                    fl: SSR_PLP_FL.join(",")
                }
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getListFromClient = async function(profileName, persona, accessToken) {
    let brandName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return new Promise(async (resolve, reject)=>{
        try {
            const url = addCollectionParam("".concat(authorBaseUrl).concat(PLP_END_POINT, "?profilename=").concat(profileName, "&persona=").concat(persona), brandName);
            aemAxiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(accessToken);
            const { data: content  } = await aemAxiosInstance({
                url
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getPlpParams = (obj, targetKey)=>{
    let result = null;
    for(const key in obj){
        if (Object.hasOwn(obj, key)) {
            if (key === targetKey) {
                return obj[key];
            }
            if (typeof obj[key] === "object" && obj[key] !== null) {
                result = getPlpParams(obj[key], targetKey);
                if (result !== null) {
                    return result;
                }
            }
        }
    }
    return result;
};
const getSearchItems = async function(searchKey, accessToken) {
    let displayName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "SEARCH";
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(accessToken);
            const { data: content  } = await aemAxiosInstance({
                url: "".concat(authorBaseUrl).concat(PLP_END_POINT, "?displayname=").concat(displayName, "&q=").concat(searchKey)
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const formatListingData = async (data, stripResponse)=>{
    return new Promise((resolve, reject)=>{
        try {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getUserPersona */ .shu)();
            var ref6, ref7;
            const payload = {
                facets: data === null || data === void 0 ? void 0 : (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields,
                facetLabels: (ref6 = (ref1 = data.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) !== null && ref6 !== void 0 ? ref6 : [],
                grouped: (data === null || data === void 0 ? void 0 : (ref2 = data.fusion) === null || ref2 === void 0 ? void 0 : ref2.isCollapsePLP) === "true" || (data === null || data === void 0 ? void 0 : (ref3 = data.fusion) === null || ref3 === void 0 ? void 0 : ref3.isCollapsePLP) === true,
                fusion: data.fusion,
                PlpSwatches: (ref7 = data === null || data === void 0 ? void 0 : (ref4 = data.facet_counts) === null || ref4 === void 0 ? void 0 : ref4.Plp_Swatches) !== null && ref7 !== void 0 ? ref7 : []
            };
            // Get dynamic price range field
            const priceRange = getPriceRangeField(data, persona, payload.grouped);
            if (priceRange) {
                const gap = priceRange.gap;
                // eslint-disable-next-line camelcase
                payload.facets.Price_Range = priceRange.counts.map((item)=>typeof item === "string" ? "[".concat(parseInt(item), " TO ").concat(parseInt(item) + gap, "]") : item);
            }
            // mark multiselect
            payload.facets = formatMultiSelectFacets(data);
            var ref8;
            // set color swatches
            payload.colors = (ref8 = (ref5 = data.fusion) === null || ref5 === void 0 ? void 0 : ref5.color_swatch_labels) !== null && ref8 !== void 0 ? ref8 : {};
            if (data.response) {
                var ref9, ref10;
                if (stripResponse && data.response.docs.length > 3) {
                    payload.data = data.response.docs.slice(0, 3);
                } else {
                    payload.data = data.response.docs;
                }
                payload.total = data.response.numFound;
                payload.start = data.response.start;
                if (((ref9 = data.fusion) === null || ref9 === void 0 ? void 0 : ref9.isCollapsePLP) === "true" || ((ref10 = data.fusion) === null || ref10 === void 0 ? void 0 : ref10.isCollapsePLP) === true) {
                    payload.grouped = true;
                }
            } else {
                payload.data = data.grouped[Object.keys(data.grouped)[0]].groups.map((doc)=>doc.doclist.docs[0]);
                payload.total = data.grouped[Object.keys(data.grouped)[0]].groups.length;
                payload.start = 0;
                payload.grouped = true;
            }
            resolve(payload);
        } catch (error) {
            reject(error);
        }
    });
};
/**
 * Finds the appropriate price range field dynamically based on facet labels
 * @param {Object} data - The API response data
 * @param {string} persona - The current user persona
 * @param {boolean} isGrouped - Whether the PLP is grouped/collapsed
 * @return {Object|null} The price range field or null if not found
 */ const getPriceRangeField = (data, persona, isGrouped)=>{
    var ref, ref1;
    const facetRanges = data === null || data === void 0 ? void 0 : (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_ranges;
    if (!facetRanges) return null;
    // Find dynamic price field from facet labels
    const facetLabels = ((ref1 = data.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) || {};
    const dynamicPriceField = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getPriceFieldFromFacet */ .KF8)(facetLabels, persona);
    if (dynamicPriceField && facetRanges[dynamicPriceField]) {
        return facetRanges[dynamicPriceField];
    }
    // Fallback to hardcoded field names
    const fallbackField = isGrouped ? "discountedPriceStartingAt.".concat(persona, "_d") : "priceList.".concat(persona, ".finalPrice_d");
    return facetRanges[fallbackField] || null;
};
const formatMultiSelectFacets = (data)=>{
    var ref, ref1;
    var ref2;
    const facets = Object.entries((ref2 = (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) !== null && ref2 !== void 0 ? ref2 : {}).map((fields)=>({
            [fields[0]]: fields[1]
        }));
    let facetField = data === null || data === void 0 ? void 0 : (ref1 = data.fusion) === null || ref1 === void 0 ? void 0 : ref1["facet.field"];
    if (facetField) {
        if (typeof facetField === "string") facetField = [
            facetField
        ];
        facetField.forEach((item)=>{
            facets.forEach((filter, index)=>{
                if (filter[item]) {
                    const obj = {
                        ["**".concat(item)]: filter[item]
                    };
                    facets.splice(index, 1, obj);
                }
            });
        });
    }
    const result = Object.assign({}, ...facets);
    return result;
};
const getRowsInitialValue = ()=>{
    let rowsInitialValue = 30;
    if (!isServer) {
        rowsInitialValue = react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMobile */ .tq ? 30 : sessionStorage.rows && JSON.parse(sessionStorage.rows)[window.location.pathname] ? JSON.parse(sessionStorage.rows)[window.location.pathname] : 30;
    }
    return rowsInitialValue;
};
const addToCompareProduct = async function() {
    let sku = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, isBackOrder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, slug = arguments.length > 3 ? arguments[3] : void 0;
    try {
        var ref, ref1, ref2, ref3, ref4;
        _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .updateCompareStatus */ .Er)(true));
        var ref5;
        const isBackOrderable = (ref5 = isBackOrder || (data === null || data === void 0 ? void 0 : data.RegionIsBackOrderable_b) || (data === null || data === void 0 ? void 0 : data.regionIsBackOrderable)) !== null && ref5 !== void 0 ? ref5 : false;
        const category = (data === null || data === void 0 ? void 0 : data.Product_Category) || (data === null || data === void 0 ? void 0 : data.ProductLocalCategory_s) || data.category || "";
        const state = _store__WEBPACK_IMPORTED_MODULE_6__/* .store.getState */ .h.getState();
        const existingCompareSkus = ((ref = state.compare) === null || ref === void 0 ? void 0 : (ref1 = ref.comparedProducts) === null || ref1 === void 0 ? void 0 : ref1.map((p)=>p.compareSku || p.sku_s)) || [];
        const compareResult = await fetchCompareDetails(sku, existingCompareSkus, category);
        const compareData = (compareResult === null || compareResult === void 0 ? void 0 : (ref2 = compareResult.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.docs) === null || ref3 === void 0 ? void 0 : ref3.find((item)=>item.sku_s === sku)) || {};
        const compareLabels = compareResult === null || compareResult === void 0 ? void 0 : (ref4 = compareResult.fusion) === null || ref4 === void 0 ? void 0 : ref4.facet_labels;
        const productData = {
            ...data,
            compareData,
            compareLabels
        };
        _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .addCompareProducts */ .rI)({
            productData,
            backorder: isBackOrderable,
            compareSku: sku,
            slug
        }));
    } catch (error) {
        console.error("Error adding product to compare:", error);
        _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .updateCompareStatus */ .Er)(false));
    }
};
const fetchCompareDetails = async (sku, compareSkus, category)=>{
    const { general: { lwAppName =""  } , internationalization: { language ="en"  }  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
    const allSkus = [
        ...compareSkus,
        sku
    ].filter(Boolean);
    const encodedCategory = encodeURIComponent(category);
    const fq = [
        allSkus.length > 1 ? "sku_s:(".concat(allSkus.join(" OR "), ")") : "sku_s:(".concat(sku, ")"),
        'ProductLocalCategory_s: "'.concat(encodedCategory, '"'),
        'language_s: ("'.concat(language, '")')
    ];
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants__WEBPACK_IMPORTED_MODULE_3__.searchPlpEndPoint, {
        params: {
            q: "*:*",
            fq: fq,
            compare: true,
            collections: lwAppName,
            profilename: "profile_".concat(lwAppName, "_Search")
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    return res.data;
};
const getProductDataFromSkus = async function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    try {
        var ref, ref1;
        const { general: { lwAppName =""  }  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        if (!skus.length) return [];
        const quotedSkus = skus.map((sku)=>'"'.concat(sku, '"')).join(" ");
        const fq = "sku_s:(".concat(quotedSkus, ")");
        // Fetch product data
        const { data: { response: { docs: productDocs = []  } = {}  } = {}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants__WEBPACK_IMPORTED_MODULE_3__.searchPlpEndPoint, {
            params: {
                fl: _constants__WEBPACK_IMPORTED_MODULE_3__.SSR_PLP_FL.join(","),
                q: "*:*",
                fq,
                collections: lwAppName,
                profilename: "profile_".concat(lwAppName, "_General"),
                rows: skus.length
            },
            paramsSerializer: (params)=>qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                })
        });
        // Fetch compare data
        const compareResponse = await fetchCompareDetails("", skus, category);
        const compareDocs = (compareResponse === null || compareResponse === void 0 ? void 0 : (ref = compareResponse.response) === null || ref === void 0 ? void 0 : ref.docs) || [];
        const compareLabels = (compareResponse === null || compareResponse === void 0 ? void 0 : (ref1 = compareResponse.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) || {};
        // Helper to map compare data
        const mapProduct = (product)=>{
            const matchingCompareData = compareDocs.find((c)=>c.sku_s === product.sku_s);
            return {
                ...product,
                compareData: matchingCompareData,
                compareLabels
            };
        };
        return productDocs.map(mapProduct);
    } catch (error) {
        console.error("Error fetching product data:", error);
        return [];
    }
};
const removeFromCompareProduct = (sku)=>{
    _store__WEBPACK_IMPORTED_MODULE_6__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_5__/* .clearProduct */ .JY)(sku));
};
const getProductDetailsFromServer = async (profileName, collections, slug, locale)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
            const response = await aemAxiosInstance({
                url: "".concat(apiBaseUrl).concat(PDP_END_POINT_SUBSCRIPTION_KEY, "?profilename=").concat(profileName, "&collections=").concat(collections, "&slug=").concat(slug, '&fq=language_s:"').concat(locale, '"')
            });
            const { data: { response: { docs =[]  } = {}  } = {}  } = response;
            const { data: { fusion: { masterVariantDataResponse =[]  } = {}  } = {}  } = response;
            resolve(docs[0] ? {
                ...docs[0],
                ...{
                    masterVariantDataResponse
                }
            } : {});
        } catch (error) {
            reject(error);
        }
    });
};
const getBVReviewStatsData = async (sku)=>{
    try {
        var ref;
        const response = await axios.get("".concat(apiBVBaseUrl).concat(reviewStatsEndPoint, "?passkey=").concat(apiBVApiKey, "&apiversion=").concat(apiVersionBV, "&stats=").concat(reviews, "&Filter=ProductId:eq:").concat(sku));
        const { data: { Results =[]  } = {}  } = response;
        var ref1;
        const productStats = (ref1 = (ref = Results[0]) === null || ref === void 0 ? void 0 : ref.ProductStatistics) !== null && ref1 !== void 0 ? ref1 : {};
        var ref2;
        const reviewStatistics = (ref2 = productStats === null || productStats === void 0 ? void 0 : productStats.ReviewStatistics) !== null && ref2 !== void 0 ? ref2 : {};
        return reviewStatistics || {};
    } catch (error) {
        console.error("Error fetching BV review stats data:", error);
        return {};
    }
};
const getBVFullReviewData = async (sku)=>{
    try {
        const response = await axios.get("".concat(apiBVBaseUrl).concat(reviewDataEndPoint, "?passkey=").concat(apiBVApiKey, "&apiversion=").concat(apiVersionBV, "&stats=").concat(reviews, "&Filter=ProductId:eq:").concat(sku));
        const { data: { Results ={}  } = {}  } = response;
        return Results || {};
    } catch (error) {
        console.error("Error fetching BV full review data:", error);
        return {};
    }
};
/**
 * Calculates the columns consumed by a promo layout based on width.
 *
 * @param {number} width - The viewport width in pixels.
 * @return {Object} An object mapping promo layouts to column classes.
 */ const getPromoColumns = (width)=>{
    if (width < 640) {
        // Mobile (2-tile product layout): All promos occupy a full row
        return {
            "one-column": "promo-col-1",
            "two-column": "promo-col-1",
            "three-column": "promo-col-1"
        };
    } else if (width <= 1023) {
        return {
            "one-column": "promo-col-1",
            "two-column": "promo-col-2",
            "three-column": "promo-col-2"
        };
    } else {
        // Desktop (3-tile product layout)
        return {
            "one-column": "promo-col-1",
            "two-column": "promo-col-2",
            "three-column": "promo-col-3"
        };
    }
};
const getPromoType = (type)=>{
    if (type.includes("1")) {
        return "1-column";
    } else if (type.includes("2")) {
        return "2-column";
    } else if (type.includes("3")) {
        return "3-column";
    }
};
const redirectToPdp = (e, category, slug, sku, plpServletPath, general, router)=>{
    if (typeof e === "object") {
        e.preventDefault();
        e.stopPropagation();
    }
    if (!category || !slug) {
        return;
    }
    try {
        const url = plpServletPath.length > 0 ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getPDPUrlWithConfig */ .Upy)(category, slug, plpServletPath, general) : "";
        if (url) {
            router.push("".concat(url, "?skuId=").concat(sku));
        } else {
            console.error("Invalid URL generated for PDP redirection");
        }
    } catch (error) {
        console.error("Error in redirectToPdp:", error);
    }
};
const getIsPresentOnDevice = (isHideOnMobile)=>{
    if (isHideOnMobile === "true") {
        return false;
    }
    let showDefaultBehaviour = isHideOnMobile === undefined;
    showDefaultBehaviour = showDefaultBehaviour || isHideOnMobile === "false";
    if (showDefaultBehaviour) {
        return true;
    }
    // For server-side rendering, assume desktop view
    if (false) {}
};
const getFilterLabel = (showFilter, staticTexts)=>{
    if (showFilter) {
        return staticTexts.hideFilter;
    }
    if (window.innerWidth <= 1023) {
        return staticTexts.filterSort;
    }
    return staticTexts.showFilter;
};
const getFilterBarProps = (param)=>{
    let { totalResults , staticTexts , updatedKeyWord , handleSearchOnchange , onSearch , typeAheadResults , showFilter , addAnalyticsForShowHideFilter , sorts , getSortItemBasedOnURL , optionsPreparation , handleSort , getSortOptionByValue , handleDatalayer , type , page , searchPlaceholder , isFilterBarSticky , setIsFilterBarSticky  } = param;
    return {
        resultsCount: "".concat(totalResults, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results),
        mod: "white",
        searchInput: isFilterBarSticky ? {
            id: "search-result-input-sticky-scroll",
            value: updatedKeyWord,
            label: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchBrand, " ").concat(searchPlaceholder),
            onChange: (e)=>{
                handleSearchOnchange(e.target.value);
            },
            onKeyDown: (e)=>(e.key === "Enter" || e.keyCode === 13) && onSearch(updatedKeyWord),
            searchCTA: {
                text: staticTexts.searchText,
                onClick: ()=>{
                    (updatedKeyWord === null || updatedKeyWord === void 0 ? void 0 : updatedKeyWord.length) > 0 && onSearch(updatedKeyWord);
                }
            },
            results: {
                options: (updatedKeyWord === null || updatedKeyWord === void 0 ? void 0 : updatedKeyWord.length) > 2 ? typeAheadResults : [],
                onOptionSubmit: (e)=>{
                    onSearch(e.value);
                }
            },
            clearCTA: {
                onClick: ()=>{
                    handleSearchOnchange("");
                }
            }
        } : undefined,
        onStickyChange: (isSticky)=>{
            setIsFilterBarSticky(isSticky);
        },
        filtersCTA: {
            label: getFilterLabel(showFilter, staticTexts),
            onClick: ()=>addAnalyticsForShowHideFilter(showFilter)
        },
        sortDropdownProps: {
            defaultValue: getSortItemBasedOnURL(staticTexts, {
                name: staticTexts.featured
            }).query,
            options: optionsPreparation(sorts),
            className: "gbh-data-layer",
            onSelect: (e)=>{
                handleSort(getSortOptionByValue(sorts, e));
                handleDatalayer(getSortOptionByValue(sorts, e), {
                    type,
                    page
                });
            },
            placeholder: staticTexts.sort
        }
    };
};
const setPLPCookie = (key, value, pathName)=>{
    const cookie = new Cookie();
    const cookieExist = cookie.get(key);
    if (cookieExist && pathName) {
        if (key === "rows" || key === "scrollPosition") {
            const rowStorage = cookieExist;
            rowStorage[pathName] = value;
            cookie.set(key, JSON.stringify(rowStorage), {
                path: "/"
            });
        } else if (key === "plpsku") {
            cookie.update(key, value);
        } else {
            cookie.remove(key, {
                path: "/"
            });
        }
    } else {
        if (key === "rows" || key === "scrollPosition") {
            cookie.set(key, JSON.stringify({
                [window.location.pathname]: value
            }), {
                path: "/"
            });
        } else {
            cookie.set(key, value, {
                path: "/"
            });
        }
    }
};
const scrollToSkuCard = (sku)=>{
    if (!sku) return;
    const smoothScroll = ()=>{
        const element = document.getElementById(sku);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        } else {
            // Keep checking until the element is rendered
            requestAnimationFrame(smoothScroll);
        }
    };
    requestAnimationFrame(smoothScroll);
};
const handleWindowScroll = (plpsku)=>{
    if (plpsku) {
        scrollToSkuCard(plpsku);
    } else if (true) {
        const url = new URL(window.location.href);
        if (url.searchParams.has("facets") || url.searchParams.has("sort")) {
            var ref;
            const wrapper = (ref = document.getElementsByClassName("kohler-visual-filter-root")[0]) !== null && ref !== void 0 ? ref : document.getElementsByClassName("productListWrapper")[0];
            if (wrapper) {
                wrapper.scrollIntoView({
                    behavior: "instant"
                });
            }
        }
    }
};
const getPromoTilePosition = (desktopPlacement, layout, width)=>{
    const desktop = parseInt(desktopPlacement);
    if (width >= 1024) {
        if (layout === "one-column") return desktop * 3 - 1;
        if (layout === "two-column") return desktop * 3 - 2;
        if (layout === "three-column") return (desktop - 1) * 3;
    } else if (width >= 640 && width <= 1023) {
        if (layout === "one-column") return desktop * 2 - 1;
        else if (layout === "two-column") return desktop * 2 - 2;
        else return desktop * 2 - 2;
    } else {
        // width <= 639
        return desktop * 2 - 2;
    }
};
const getPromoSlotsBefore = (layout, width)=>{
    if (width < 640) {
        // Mobile: All promos take full row, so 0 slots before.
        return 0;
    }
    if (width < 1024) {
        // Tablet (2 Columns)
        // 1-col promo must be on the right side (Column 2) -> 1 product before
        if (layout === "1-column") return 1;
        // 2-col and 3-col promos take full row -> 0 products before
        return 0;
    }
    // Desktop (3 Columns)
    if (layout === "3-column") return 0;
    if (layout === "2-column") return 1;
    return 2 // Default one-column
    ;
};
const processPromos = (rawPromos)=>{
    const promoMap = {};
    if (!Array.isArray(rawPromos)) return promoMap;
    rawPromos.forEach((p)=>{
        const baseRow = parseInt(p.rowPlacement, 10);
        const promoData = {
            ...p,
            actualRow: baseRow
        };
        const placePromo = (row)=>{
            if (row > 0 && !promoMap[row]) {
                promoMap[row] = promoData;
            }
        };
        // Place initial promo
        placePromo(baseRow);
        // Place repeating promos
        if (p.repeatPromo === "true") {
            const interval = baseRow;
            // Max 50 rows for safety in the mock
            for(let r = baseRow + interval; r <= 50; r += interval){
                placePromo(r);
            }
        }
    });
    return promoMap;
};
const placePromos = (products, promoMap, width)=>{
    const finalGrid = [];
    let pIdx = 0;
    // CRITICAL: Determine COLUMNS based on width
    // 3 for desktop, 2 for tablet (640-1023) AND mobile (<640)
    const COLUMNS = width < 1024 ? 2 : 3;
    const allPromoRows = Object.keys(promoMap).map(Number).sort((a, b)=>a - b);
    const maxRowFromProducts = Math.ceil(products.length / COLUMNS);
    const maxRowToFill = Math.max(...allPromoRows, maxRowFromProducts, 1);
    for(let currentRow = 1; currentRow <= maxRowToFill; currentRow++){
        const promo = promoMap[currentRow];
        let slotsFilled = 0;
        if (promo && pIdx < products.length) {
            // A. Add products required *before* the promo
            const slotsBeforePromo = getPromoSlotsBefore(promo.promoLayout, width);
            const productsBefore = Math.min(slotsBeforePromo, products.length - pIdx);
            for(let i = 0; i < productsBefore; i++){
                finalGrid.push({
                    type: "product",
                    row: currentRow,
                    productCardProps: products[pIdx]
                });
                pIdx++;
                slotsFilled++;
            }
            // B. Add the promo tile
            if (pIdx <= products.length) {
                const promoColumnsConsumed = getPromoColumns(width)[promo.promoLayout];
                finalGrid.push({
                    ...promo,
                    type: "promo",
                    row: currentRow,
                    columnsConsumed: promoColumnsConsumed
                });
                slotsFilled += promoColumnsConsumed;
            }
            // C. Fill remaining slots in the row with products
            const remainingSlots = COLUMNS - slotsFilled;
            const productsAfter = Math.min(remainingSlots, products.length - pIdx);
            for(let i1 = 0; i1 < productsAfter; i1++){
                finalGrid.push({
                    type: "product",
                    row: currentRow,
                    productCardProps: products[pIdx]
                });
                pIdx++;
                slotsFilled++;
            }
        } else if (pIdx < products.length) {
            // 2. No promo in this row, fill the whole row
            const productsToFill = Math.min(COLUMNS, products.length - pIdx);
            for(let i2 = 0; i2 < productsToFill; i2++){
                finalGrid.push({
                    type: "product",
                    row: currentRow,
                    productCardProps: products[pIdx]
                });
                pIdx++;
            }
        }
        if (pIdx >= products.length && !allPromoRows.some((r)=>r > currentRow)) {
            break;
        }
    }
    return finalGrid;
};
const getPromoClass = (width, promoLayout)=>{
    if (width > 1023) {
        if (promoLayout === "1-column") return "promo-col-1";
        if (promoLayout === "2-column") return "promo-col-2";
        if (promoLayout === "3-column") return "promo-col-3";
    }
    if (width <= 1023 && width >= 640) {
        if (promoLayout === "1-column") return "promo-col-1";
        if (promoLayout === "2-column") return "promo-col-2";
        if (promoLayout === "3-column") return "promo-col-2";
    }
    if (width < 640) {
        // Mobile: Span full row
        return "promo-col-1";
    }
};



/***/ }),

/***/ 89299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ normalizePromoTextPlacement; },
/* harmony export */   "o": function() { return /* binding */ sanitizeText; }
/* harmony export */ });
const sanitizeText = (text)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!text) return "";
    return (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = text === null || text === void 0 ? void 0 : text.replace(/<[^>]*>/g, "") // Remove HTML tags
    ) === null || ref === void 0 ? void 0 : ref.replace(/&amp;/g, "&") // Convert &amp; to &
    ) === null || ref1 === void 0 ? void 0 : ref1.replace(/&lt;/g, "<") // Convert &lt; to <
    ) === null || ref2 === void 0 ? void 0 : ref2.replace(/&gt;/g, ">") // Convert &gt; to >
    ) === null || ref3 === void 0 ? void 0 : ref3.replace(/&quot;/g, '"') // Convert &quot; to "
    ) === null || ref4 === void 0 ? void 0 : ref4.replace(/&#039;/g, "'") // Convert &#039; to '
    ) === null || ref5 === void 0 ? void 0 : ref5.replace(/&#39;/g, "'") // Convert &#39; to '
    ) === null || ref6 === void 0 ? void 0 : ref6.replace(/&nbsp;/g, " ") // Convert &nbsp; to space
    ) === null || ref7 === void 0 ? void 0 : ref7.trim();
};
const normalizePromoTextPlacement = (contentPosition)=>{
    if (!contentPosition) return "";
    const sanitized = sanitizeText(contentPosition);
    if (!sanitized) return "";
    return sanitized === "dead-center" ? "center" : sanitized;
};


/***/ }),

/***/ 74565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ ActionIndicator; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ActionIndicator/ActionIndicator.module.css.mjs
var classes = {
    "root": "oz7PS"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/InternalLinkIcon.mjs
var InternalLinkIcon = __webpack_require__(33804);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ExternalLinkIcon.mjs
var ExternalLinkIcon = __webpack_require__(57537);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/DownloadIcon.mjs


const withoutBoundingBoxWidth = {
    large: 18,
    medium: 14,
    small: 10,
    xSmall: 8
};
const DownloadIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22 22.6204H8V21.6204H22V22.6204Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M18.1746 14.4618L18.8254 15.2211L15.5 18.0714V18.1204H15.4429L15 18.5L14.5571 18.1204H14.5V18.0714L11.1746 15.2211L11.8254 14.4618L14.5 16.754V7.12036H15.5V16.7539L18.1746 14.4618Z",
        fill: "currentColor"
    }));
};
DownloadIcon.iconName = "DownloadIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/EmailIcon.mjs
var EmailIcon = __webpack_require__(72712);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PrintIcon.mjs
var PrintIcon = __webpack_require__(86957);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ShareIcon.mjs
var ShareIcon = __webpack_require__(26721);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/EditIcon.mjs


const EditIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 16,
    small: 14,
    xSmall: 9
};
const EditIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : EditIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5.83239 12.9088L5.20297 13.5382L6.46181 14.797L7.09124 14.1676L5.83239 12.9088Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.77653 17H3V13.2235L12.4413 3.78215C13.4842 2.73928 15.175 2.73929 16.2179 3.78215C17.2607 4.82501 17.2607 6.51582 16.2179 7.55868L6.77653 17ZM3.89056 16.1094L6.40951 16.1094L15.5884 6.92925C16.2521 6.26561 16.2822 5.20839 15.6789 4.50897L15.5884 4.41156C14.9248 3.74793 13.8676 3.71776 13.1682 4.32107L13.0708 4.41156L3.89119 13.5923L3.89056 16.1094Z",
                    fill: "currentColor"
                }));
            case "large":
            case "medium":
            case "xSmall":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M10.3033 18.3743L9.59621 19.0815L11.0104 20.4957L11.7175 19.7886L10.3033 18.3743Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.364 22.9705H7.12134V18.7279L17.7279 8.12129C18.8995 6.94972 20.799 6.94972 21.9706 8.12129C23.1422 9.29287 23.1422 11.1924 21.9706 12.3639L11.364 22.9705ZM8.12182 21.97L10.9517 21.97L21.2635 11.6568C22.009 10.9113 22.0429 9.72357 21.3651 8.93782L21.2635 8.8284C20.5179 8.08285 19.3302 8.04896 18.5445 8.72673L18.4351 8.8284L8.12252 19.1423L8.12182 21.97Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
EditIcon.iconName = "EditIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteIcon.mjs
var FavoriteIcon = __webpack_require__(26215);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/AddToProjectIcon.mjs


const AddToProjectIcon_withoutBoundingBoxWidth = {
    large: 22,
    medium: 17,
    small: 14,
    xSmall: 9
};
const AddToProjectIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : AddToProjectIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M15.5 16V18H14.5V16H12.5V15H14.5V13H15.5V15H17.5V16H15.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.5 9H14.5L13.5 7H6.5V22H23.5V9ZM7.5 8H12.881L13.882 10H22.5V21H7.5V8Z",
        fill: "currentColor"
    }));
};
AddToProjectIcon.iconName = "AddToProjectIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlayIcon.mjs
var PlayIcon = __webpack_require__(2722);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CheckmarkIcon.mjs
var CheckmarkIcon = __webpack_require__(21421);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FilterIcon.mjs
var FilterIcon = __webpack_require__(15730);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/DropdownIcon.mjs
var DropdownIcon = __webpack_require__(66020);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PDFIcon.mjs


const PDFIcon_withoutBoundingBoxWidth = {
    large: 26,
    medium: 19,
    small: 14,
    xSmall: 10
};
const PDFIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : PDFIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.22455 3H17.5127L23.9085 9.39692V25.771H6.22455V21.676H7.22455L7.22395 24.771H22.9079V10.104H16.8432V4H7.22395L7.22455 13.063H6.22455V3ZM17.8432 4.74434L22.2019 9.10378L17.8429 9.103L17.8432 4.74434Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.30762 18.2174V20H5.49438V15.3548H7.54374C8.87095 15.3548 9.12468 16.2136 9.12468 16.7926C9.12468 17.3716 8.87095 18.2174 7.54374 18.2174H6.30762ZM6.30762 17.5538H7.4982C7.86253 17.5538 8.31143 17.3716 8.31143 16.7861C8.31143 16.1745 7.9406 16.0184 7.51121 16.0184H6.30762V17.5538Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7596 20C13.1909 20 13.8089 18.9591 13.8089 17.6774C13.8089 16.3957 13.1909 15.3548 11.7596 15.3548H9.83383V20H11.7596ZM10.6471 19.3364H11.4473C12.7224 19.3364 12.9957 18.6142 12.9957 17.6774C12.9957 16.7405 12.7224 16.0184 11.4473 16.0184H10.6471V19.3364Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M15.3443 20V17.9376H17.4457V17.274H15.3443V16.0574H17.7385V15.3548H14.5311V20H15.3443Z",
        fill: "currentColor"
    }));
};
PDFIcon.iconName = "PDFIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/BackToTopIcon.mjs
var BackToTopIcon = __webpack_require__(7673);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/BackIcon.mjs


const BackIcon_withoutBoundingBoxWidth = {
    large: 35,
    medium: 27,
    small: 17,
    xSmall: 14
};
const BackIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : BackIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.911 14.25L11.5 6.7L10.7963 6L2 14.75L10.7963 23.5L11.5 22.8L3.91099 15.25H27V14.25H3.911Z",
        fill: "currentColor"
    }));
};
BackIcon.iconName = "BackIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ActionIndicator/ActionIndicator.utils.mjs

const actionIndicatorIconPath = {
    "Copy link": {
        leftIcon: InternalLinkIcon/* InternalLinkIcon */.B
    },
    "External link": {
        leftIcon: ExternalLinkIcon/* ExternalLinkIcon */.h
    },
    Download: {
        leftIcon: DownloadIcon
    },
    Email: {
        leftIcon: EmailIcon/* EmailIcon */.L
    },
    Print: {
        leftIcon: PrintIcon/* PrintIcon */.L
    },
    Share: {
        leftIcon: ShareIcon/* ShareIcon */.a
    },
    Manage: {
        leftIcon: EditIcon
    },
    Favorites: {
        leftIcon: FavoriteIcon/* FavoriteIcon */.f
    },
    Projects: {
        leftIcon: AddToProjectIcon
    },
    "Video link": {
        leftIcon: PlayIcon/* PlayIcon */.o
    },
    Compare: {
        leftIcon: CheckmarkIcon/* CheckmarkIcon */.K
    },
    Filters: {
        rightIcon: FilterIcon/* FilterIcon */.k
    },
    Sort: {
        rightIcon: DropdownIcon/* DropdownIcon */.K
    },
    "PDF link": {
        leftIcon: PDFIcon
    },
    "PDF file": {
        leftIcon: PDFIcon
    },
    "Back to top": {
        rightIcon: BackToTopIcon/* BackToTopIcon */.d
    },
    Back: {
        leftIcon: BackIcon
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ActionIndicator/ActionIndicator.mjs








const ActionIndicator = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , type , label , showLabel =true , className , icon , iconPosition ="left" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-action-indicator-root", className, classes.root);
    if (type) console.warn("Property `type` will be deprecated soon. Please use `icon` instead. Example here: https://bold.kohler.com/components/buttons/action-indicator/code#basic-action-indicator-icon");
    const TypeIcon = type && actionIndicatorIconPath[type];
    const Icon = icon;
    const renderLeftIcon = iconPosition === "left";
    const renderRightIcon = iconPosition === "right";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component,
        type: component ? "button" : void 0,
        gap: 10,
        wrap: "nowrap",
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        width: "fit-content",
        align: "center",
        cursor: "pointer",
        whiteSpace: "nowrap",
        className: classNames,
        ref,
        ...rest
    }, Icon && renderLeftIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        withBoundingBox: false,
        size: "medium"
    }), !Icon && TypeIcon && TypeIcon.leftIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(TypeIcon.leftIcon, {
        withBoundingBox: false,
        size: "medium"
    }), showLabel && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "label-regular-m",
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        textDecoration: type === "PDF link" ? "underline" : void 0
    }, label ? label : type), Icon && renderRightIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        withBoundingBox: false,
        size: "medium"
    }), !Icon && TypeIcon && TypeIcon.rightIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(TypeIcon.rightIcon, {
        withBoundingBox: false,
        size: "medium"
    }));
});



/***/ }),

/***/ 58510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.module.css.mjs
var classes = {
    "buttonRoot": "GckgD",
    "label": "AheTB",
    "sections": "E54xC",
    "buttonSizeLarge": "_0qQpH",
    "buttonSizeMedium": "_0JISY",
    "buttonSizeSmall": "u12Wo",
    "buttonVariantPrimary": "f6Mqv",
    "buttonVariantSecondary": "BG-c7",
    "buttonVariantBrand": "WlIAM",
    "buttonHover": "L-dLx",
    "buttonFullWidth": "-ok9U",
    "iconButton": "iwgFy",
    "iconButtonSizeLarge": "ZBrOP",
    "iconButtonSizeMedium": "jgT9U",
    "iconButtonSizeSmall": "BEaHw"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.utils.mjs

const buttonSizeClasses = {
    small: classes.buttonSizeSmall,
    medium: classes.buttonSizeMedium,
    large: classes.buttonSizeLarge
};
const buttonVariantClasses = {
    primary: classes.buttonVariantPrimary,
    secondary: classes.buttonVariantSecondary,
    brand: classes.buttonVariantBrand
};
const buttonIconSizeClasses = {
    small: classes.iconButtonSizeSmall,
    medium: classes.iconButtonSizeMedium,
    large: classes.iconButtonSizeLarge
};
const buttonTypographySize = {
    small: "button-s",
    medium: "button-l",
    large: "button-l"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs







const Button = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , children , fullWidth , size ="medium" , leftSection , rightSection , disabled , variant ="primary" , className , icon , hasHoverEffect =true , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.buttonRoot, "kohler-button-root", className, size && !icon ? buttonSizeClasses[size] : buttonIconSizeClasses[size], icon && classes.iconButton, fullWidth && classes.buttonFullWidth, variant && buttonVariantClasses[variant], hasHoverEffect && classes.buttonHover);
    const Icon = icon || void 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        disabled,
        size: buttonTypographySize[size],
        ...rest
    }, leftSection && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-button-section", classes.sections)
    }, leftSection), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: classes.label
    }, Icon ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        size: size === "small" ? "small" : "medium",
        withBoundingBox: true
    }) : children), rightSection && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-button-section", classes.sections)
    }, rightSection));
});



/***/ }),

/***/ 34647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ ImageAction; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/radii.mjs
var radii = __webpack_require__(47230);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ImageAction/ImageAction.module.css.mjs
var classes = {
    "imageActionRoot": "-otTW"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ImageAction/ImageAction.mjs







const ImageAction = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , className , icon: Icon , type , label , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        component,
        type: component === "button" ? type || "button" : void 0,
        justify: "center",
        align: "center",
        gap: 10,
        cursor: "pointer",
        borderRadius: radii/* DsmRadius.S */.t.S,
        padding: label ? "6px 30px" : "3px",
        className: (0,clsx/* default */.Z)("kohler-image-action-root", classes.imageActionRoot, label ? classes.imageActionLabel : classes.imageActionWithoutLabel, className),
        ...rest
    }, Icon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        size: label ? "small" : "medium",
        withBoundingBox: !label,
        style: {
            flexShrink: 0
        }
    }), label && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "button-m"
    }, label));
});



/***/ }),

/***/ 3171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.module.css.mjs
var classes = {
    "root": "ieaVA",
    "linkUnderline": "KQtnJ",
    "icons": "XqqHZ"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.utils.mjs
const linkSizeText = {
    small: "button-s",
    medium: "button-m",
    large: "button-xl"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs







const Link = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="a" , children , size ="medium" , underline =true , className , leftIcon , rightIcon , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.root, "kohler-text-link-root", className, underline && classes.linkUnderline);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: classNames,
        component,
        ref,
        ...rest,
        size: linkSizeText[size]
    }, leftIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-text-link-icon", classes.icons)
    }, leftIcon), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span"
    }, children), rightIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-text-link-icon", classes.icons)
    }, rightIcon));
});



/***/ }),

/***/ 3345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/SearchResultsCard/ArticleResultCard/ArticleResultCard.utils.mjs

const highlightText = (text, highlight)=>{
    if (!highlight) return text;
    const regex = new RegExp("(".concat(highlight, ")"), "gi");
    return text.split(regex).map((part, index)=>part.toLowerCase() === highlight.toLowerCase() ? /* @__PURE__ */ /*#__PURE__*/ react.createElement("b", {
            key: index,
            style: {
                fontWeight: "bold"
            }
        }, part) : part);
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/ProductCard.module.css.mjs
var classes = {
    "productCardContainer": "UJheV"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var constants_colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/AccountCardInformation/AccountCardInformation.module.css.mjs
var AccountCardInformation_module_css_classes = {
    "accountCardInformation": "_8d26T"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/AccountCardInformation/AccountCardInformation.mjs
"use client";








const AccountCardInformation = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { title , description , price , slashedPrice , availableColors , brand , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        ...rest,
        className: AccountCardInformation_module_css_classes.accountCardInformation
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, brand && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(brand.text) ? "div" : brand.component || "p",
        ...(0,helpers/* omitText */.rW)(brand),
        size: "label-medium-s",
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, brand.text), title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "span",
        ...(0,helpers/* omitText */.rW)(title),
        textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "label-regular-l"
    }, title.text), description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        ...(0,helpers/* omitText */.rW)(description),
        size: "paragraph-medium",
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, description.text), availableColors && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(availableColors.text) ? "div" : availableColors.component || "p",
        ...(0,helpers/* omitText */.rW)(availableColors),
        size: "paragraph-medium",
        paddingTop: 5,
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, availableColors.text)), (price || slashedPrice) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column"
    }, price && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(price.text) ? "div" : price.component || "span",
        ...(0,helpers/* omitText */.rW)(price),
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        size: "label-medium-m"
    }, price.text), slashedPrice && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(slashedPrice.text) ? "div" : slashedPrice.component || "span",
        ...(0,helpers/* omitText */.rW)(slashedPrice),
        textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "label-regular-m",
        textDecoration: "line-through"
    }, slashedPrice.text)));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteFilledIcon.mjs


const withoutBoundingBoxWidth = {
    large: 24,
    medium: 15,
    small: 12,
    xSmall: 9
};
const FavoriteFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6406 9.68848L15.001 10.334L14.3616 9.68848C12.7924 8.10384 10.2463 8.10384 8.67709 9.68848C7.15124 11.2294 7.10377 13.7186 8.56434 15.297L8.67074 15.4086L15.0011 21.8015L21.3085 15.4322L21.4152 15.3211C22.8956 13.7217 22.854 11.2324 21.3251 9.68848C19.756 8.10384 17.2098 8.10384 15.6406 9.68848Z",
        fill: "currentColor"
    }));
};
FavoriteFilledIcon.iconName = "FavoriteFilledIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteIcon.mjs
var FavoriteIcon = __webpack_require__(26215);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ShareIcon.mjs
var ShareIcon = __webpack_require__(26721);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ImageAction/ImageAction.mjs + 1 modules
var ImageAction = __webpack_require__(34647);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 4 modules
var Image = __webpack_require__(26191);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs + 2 modules
var AspectRatioKeeper = __webpack_require__(66737);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/SharePopover/SharePopover.mjs + 9 modules
var SharePopover = __webpack_require__(61518);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ProductCardImage/ProductCardImage.module.css.mjs
var ProductCardImage_module_css_classes = {
    "productCardImageWrapper": "ruzMG",
    "quickViewButton": "c7vsI",
    "productCardActions": "Qj9yq",
    "shareButton": "lWEpv"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ProductCardImage/ProductCardImage.mjs
"use client";











const ProductCardImage = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1;
    const { hasLink , href , image , onSave , isSaved , onShare , saveCTA , shareCTA , quickViewCTA , sharePopover  } = props;
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    const shouldAutoClose = sharePopover === null || sharePopover === void 0 ? void 0 : sharePopover.autoCloseOnParentHoverOut;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio: "1:1",
        className: ProductCardImage_module_css_classes.productCardImageWrapper,
        ref,
        onMouseEnter: shouldAutoClose ? ()=>setIsHovered(true) : void 0,
        onMouseLeave: shouldAutoClose ? ()=>setIsHovered(false) : void 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: hasLink ? "a" : "figure",
        href,
        width: "100%"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), (onSave || onShare || saveCTA || shareCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: ProductCardImage_module_css_classes.productCardActions
    }, (saveCTA || onSave) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ImageAction/* ImageAction */.H, {
        icon: isSaved ? FavoriteFilledIcon : FavoriteIcon/* FavoriteIcon */.f,
        "aria-label": isSaved ? "remove from saved" : "add to favorite",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onSave === null || onSave === void 0 ? void 0 : onSave();
        },
        ...saveCTA
    }), (shareCTA || onShare) && !sharePopover && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ImageAction/* ImageAction */.H, {
        icon: ShareIcon/* ShareIcon */.a,
        "aria-label": "share product on social media",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onShare === null || onShare === void 0 ? void 0 : onShare();
        },
        ...shareCTA,
        className: (0,clsx/* default */.Z)(ProductCardImage_module_css_classes.shareButton, shareCTA === null || shareCTA === void 0 ? void 0 : shareCTA.className)
    }), shareCTA && sharePopover && /* @__PURE__ */ /*#__PURE__*/ react.createElement(SharePopover/* SharePopover */.C, {
        target: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ImageAction/* ImageAction */.H, {
            icon: ShareIcon/* ShareIcon */.a,
            "aria-label": "share product on social media",
            ...shareCTA,
            component: "div"
        }),
        withinPortal: false,
        withRoles: true,
        trapFocus: false,
        showDivider: !!(sharePopover.links && ((ref1 = sharePopover.links) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && (sharePopover.emailCTA || sharePopover.copyCTA)),
        width: "max-content",
        autoCloseOnParentHoverOut: shouldAutoClose,
        isParentHovered: shouldAutoClose ? isHovered : void 0,
        ...sharePopover,
        className: (0,clsx/* default */.Z)(ProductCardImage_module_css_classes.shareButton, sharePopover === null || sharePopover === void 0 ? void 0 : sharePopover.className)
    })), quickViewCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ImageAction/* ImageAction */.H, {
        position: "absolute",
        className: ProductCardImage_module_css_classes.quickViewButton,
        label: "Quick View",
        ...quickViewCTA,
        onClick: (e)=>{
            var ref;
            e.preventDefault();
            e.stopPropagation();
            (ref = quickViewCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(quickViewCTA, e);
        }
    }));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(3171);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.mjs + 1 modules
var Checkbox = __webpack_require__(39091);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Tag/Tag.module.css.mjs
var Tag_module_css_classes = {
    "root": "y1PCZ",
    "tagVariantDefault": "XiOLU",
    "tagVariantDiscontinued": "i6plJ",
    "tagVariantFilled": "mni-b"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Tag/Tag.utils.mjs

const tagVariantClasses = {
    default: Tag_module_css_classes.tagVariantDefault,
    discontinued: Tag_module_css_classes.tagVariantDiscontinued,
    filled: Tag_module_css_classes.tagVariantFilled
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Tag/Tag.mjs







const Tag = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , label , size ="small" , variant ="default" , className , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-tag-root", className, variant && tagVariantClasses[variant], Tag_module_css_classes.root);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "small",
        size: size === "small" ? "tag-s" : "tag-m"
    }, label));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/ColorSwatch.mjs + 1 modules
var ColorSwatch = __webpack_require__(34199);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(68064);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ColorSwatches/ColorSwatches.module.css.mjs
var ColorSwatches_module_css_classes = {
    "colorSwatchGroupColor": "hHICY"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ColorSwatches/useColorSwatchesLayout.mjs
"use client";

function useColorSwatchesLayout(total, explicitExtra) {
    const containerRef = (0,react.useRef)(null);
    const sampleSwatchRef = (0,react.useRef)(null);
    const hiddenPlusRef = (0,react.useRef)(null);
    const [visibleCount, setVisibleCount] = (0,react.useState)(total);
    const [computedExtra, setComputedExtra] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (explicitExtra !== void 0) {
            setVisibleCount(total);
            setComputedExtra(Number(explicitExtra) || 0);
        }
    }, [
        explicitExtra,
        total
    ]);
    (0,react.useLayoutEffect)(()=>{
        if (explicitExtra !== void 0) return;
        const el = containerRef.current;
        const sw = sampleSwatchRef.current;
        const plus = hiddenPlusRef.current;
        if (!el || !sw || !plus || total === 0) return;
        const compute = ()=>{
            const cw = el.getBoundingClientRect().width;
            if (!cw) return;
            const cs = getComputedStyle(el);
            const gapX = parseFloat(cs.columnGap || cs.gap || "5") || 5;
            const iw = sw.getBoundingClientRect().width;
            if (!iw) return;
            let n = Math.min(total, Math.floor((cw + gapX) / (iw + gapX)));
            if (n <= 0) n = 1;
            if (n >= total) {
                setVisibleCount(total);
                setComputedExtra(0);
                return;
            }
            const remainingBase = total - n;
            plus.textContent = "+".concat(remainingBase);
            const plusW = plus.getBoundingClientRect().width || 0;
            const used = n * iw + (n - 1) * gapX;
            let rem = cw - used;
            const needed = (n > 0 ? gapX : 0) + plusW;
            while(n > 0 && rem < needed){
                n -= 1;
                const used2 = n * iw + (n - 1) * gapX;
                rem = cw - used2;
            }
            const extra = Math.max(total - n, 0);
            setVisibleCount(n);
            setComputedExtra(extra);
        };
        compute();
        const ro = new ResizeObserver(()=>compute());
        ro.observe(el);
        return ()=>ro.disconnect();
    }, [
        explicitExtra,
        total
    ]);
    return {
        containerRef,
        sampleSwatchRef,
        hiddenPlusRef,
        visibleCount,
        computedExtra
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ColorSwatches/ColorSwatches.mjs
"use client";










const ColorSwatches = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , colors , extraColors , selectedColor , onColorSelected , className , ...rest } = props;
    const { containerRef , sampleSwatchRef , hiddenPlusRef , visibleCount , computedExtra  } = useColorSwatchesLayout(colors.length, extraColors);
    const mergedContainerRef = (0,use_merged_ref/* useMergedRef */.Yx)(containerRef, ref);
    const handleSelect = (color)=>{
        return onColorSelected === null || onColorSelected === void 0 ? void 0 : onColorSelected(selectedColor === color ? null : color);
    };
    const first = colors[0];
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        wrap: "wrap",
        ref: mergedContainerRef,
        className: (0,clsx/* default */.Z)(className),
        component,
        ...rest
    }, first && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ColorSwatch/* ColorSwatch */.b, {
        ref: sampleSwatchRef,
        className: ColorSwatches_module_css_classes.colorSwatchGroupColor,
        ...first,
        isSelected: selectedColor === first.colorName,
        onClick: ()=>handleSelect(first.colorName)
    })), colors.slice(1, visibleCount).map((color)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(ColorSwatch/* ColorSwatch */.b, {
            key: color.colorName,
            className: ColorSwatches_module_css_classes.colorSwatchGroupColor,
            ...color,
            isSelected: selectedColor === color.colorName,
            onClick: ()=>handleSelect(color.colorName)
        })), (computedExtra > 0 || Number(extraColors) > 0) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        size: "label-regular-m",
        component: "span"
    }, "+", extraColors !== null && extraColors !== void 0 ? extraColors : computedExtra), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ref: hiddenPlusRef,
        "aria-hidden": "true",
        size: "label-regular-m",
        component: "span",
        position: "absolute",
        whiteSpace: "nowrap",
        visibility: "hidden",
        style: {
            pointerEvents: "none"
        }
    }, "+99"));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ProductCardInformation/ProductCardInformation.module.css.mjs
var ProductCardInformation_module_css_classes = {
    "productCardInformation": "DHnbK",
    "leftPair": "HcQg9",
    "right": "_79xDp",
    "leftFull": "lv-uh",
    "rightFirst": "_766mG"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ProductCardInformation/ProductCardInformation.mjs
"use client";

















const ProductCardInformation = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { title , description , tags , bundleItems , SKU , taxesLabel , checkbox , additionalLink , colorSwatches , outOfStockLabel , price , slashedPrice , ...rest } = props;
    const leftNodes = [];
    if (colorSwatches) leftNodes.push({
        key: "colorSwatches",
        marginBottom: 15,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ColorSwatches, {
            ...colorSwatches
        })
    });
    if (tags && tags.length) leftNodes.push({
        key: "tags",
        marginBottom: 5,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            gap: 10,
            wrap: "wrap"
        }, tags.map((tag, i)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Tag, {
                key: i,
                ...tag
            })))
    });
    if (title) leftNodes.push({
        key: "title",
        marginBottom: 5,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            ...(0,helpers/* omitText */.rW)(title),
            textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
            style: {
                overflowWrap: "anywhere"
            },
            size: "label-regular-l",
            component: title.component || "span"
        }, title.text)
    });
    if (description) leftNodes.push({
        key: "description",
        marginBottom: 10,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            ...(0,helpers/* omitText */.rW)(description),
            size: "paragraph-medium",
            textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p"
        }, description.text)
    });
    if (SKU) leftNodes.push({
        key: "sku",
        marginBottom: 10,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(SKU.text) ? "div" : SKU.component || "span",
            ...(0,helpers/* omitText */.rW)(SKU),
            textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            size: "label-regular-s"
        }, SKU.text)
    });
    if (bundleItems) leftNodes.push({
        key: "bundleItems",
        marginBottom: 10,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(bundleItems.text) ? "div" : bundleItems.component || "span",
            ...(0,helpers/* omitText */.rW)(bundleItems),
            textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            size: "label-regular-s"
        }, bundleItems.text)
    });
    if (price || slashedPrice || taxesLabel) leftNodes.push({
        key: "prices",
        marginBottom: 10,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            direction: "column",
            gap: 5
        }, (price || slashedPrice) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            direction: "row",
            wrap: "wrap",
            gap: 5
        }, price && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(price.text) ? "div" : price.component || "span",
            ...(0,helpers/* omitText */.rW)(price),
            textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
            size: "label-medium-m"
        }, price.text), slashedPrice && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(slashedPrice.text) ? "div" : slashedPrice.component || "span",
            ...(0,helpers/* omitText */.rW)(slashedPrice),
            textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            size: "label-regular-m",
            textDecoration: "line-through"
        }, slashedPrice.text)), taxesLabel && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(taxesLabel.text) ? "div" : taxesLabel.component || "span",
            ...(0,helpers/* omitText */.rW)(taxesLabel),
            size: "label-medium-s",
            textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
            textTransform: "uppercase"
        }, taxesLabel.text))
    });
    if (outOfStockLabel) leftNodes.push({
        key: "oos",
        marginBottom: 10,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: /*#__PURE__*/ (0,react.isValidElement)(outOfStockLabel.text) ? "div" : outOfStockLabel.component || "span",
            ...(0,helpers/* omitText */.rW)(outOfStockLabel),
            textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            size: "paragraph-small"
        }, outOfStockLabel.text)
    });
    if (additionalLink) leftNodes.push({
        key: "additionalLink",
        node: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            component: additionalLink.onClick ? "button" : "a",
            className: ProductCardInformation_module_css_classes.productCardAdditionalLink,
            width: "fit-content",
            ...(0,helpers/* omitText */.rW)(additionalLink),
            size: "small"
        }, additionalLink.text)
    });
    const rightNodes = [];
    if (checkbox) rightNodes.push({
        key: "checkbox",
        marginLeft: 15,
        marginBottom: 10,
        node: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Checkbox/* Checkbox */.X, {
            textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            ...checkbox
        })
    });
    const pairCount = Math.min(leftNodes.length, rightNodes.length);
    const children = [];
    for(let i = 0; i < pairCount; i++){
        children.push(/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: leftNodes[i].key,
            marginBottom: leftNodes[i].marginBottom,
            className: ProductCardInformation_module_css_classes.leftPair
        }, leftNodes[i].node));
        children.push(/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: rightNodes[i].key,
            marginLeft: rightNodes[i].marginLeft,
            marginBottom: rightNodes[i].marginBottom,
            className: (0,clsx/* default */.Z)(ProductCardInformation_module_css_classes.right, i === 0 && ProductCardInformation_module_css_classes.rightFirst)
        }, rightNodes[i].node));
    }
    for(let i1 = pairCount; i1 < leftNodes.length; i1++){
        children.push(/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: leftNodes[i1].key,
            marginBottom: i1 !== leftNodes.length - 1 ? leftNodes[i1].marginBottom : void 0,
            className: ProductCardInformation_module_css_classes.leftFull
        }, leftNodes[i1].node));
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        ...rest,
        className: ProductCardInformation_module_css_classes.productCardInformation
    }, children);
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ProductListSliderInformation/ProductListSliderInformation.module.css.mjs
var ProductListSliderInformation_module_css_classes = {
    "productListSliderInformation": "eV5tf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ProductListSliderInformation/ProductListSliderInformation.mjs
"use client";








const ProductListSliderInformation = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { title , description , price , slashedPrice , availableColors , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        ...rest,
        className: ProductListSliderInformation_module_css_classes.productListSliderInformation
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "span",
        ...(0,helpers/* omitText */.rW)(title),
        textColor: constants_colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        size: "label-regular-l"
    }, title.text), description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        ...(0,helpers/* omitText */.rW)(description),
        size: "paragraph-medium",
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, description.text), availableColors && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(availableColors.text) ? "div" : availableColors.component || "p",
        ...(0,helpers/* omitText */.rW)(availableColors),
        size: "paragraph-medium",
        paddingTop: 5,
        textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, availableColors.text)), (price || slashedPrice) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column"
    }, price && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(price.text) ? "div" : price.component || "span",
        ...(0,helpers/* omitText */.rW)(price),
        textColor: constants_colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        size: "label-medium-m"
    }, price.text), slashedPrice && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(slashedPrice.text) ? "div" : slashedPrice.component || "span",
        ...(0,helpers/* omitText */.rW)(slashedPrice),
        textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "label-regular-m",
        textDecoration: "line-through"
    }, slashedPrice.text)));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/subcomponents/ShopTheRoomInformation/ShopTheRoomInformation.mjs
"use client";






const ShopTheRoomInformation = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { title , description , price , slashedPrice , brand , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 15,
        ref,
        ...rest
    }, (brand || title || description) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, brand && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(brand.text) ? "div" : brand.component || "p",
        ...(0,helpers/* omitText */.rW)(brand),
        size: "label-medium-s",
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, brand.text), title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "span",
        ...(0,helpers/* omitText */.rW)(title),
        textColor: constants_colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        size: "label-regular-l"
    }, title.text), description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        ...(0,helpers/* omitText */.rW)(description),
        size: "paragraph-medium",
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, description.text)), (price || slashedPrice) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        wrap: "wrap"
    }, price && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(price.text) ? "div" : price.component || "span",
        ...(0,helpers/* omitText */.rW)(price),
        textColor: constants_colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        size: "label-medium-m"
    }, price.text), slashedPrice && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(slashedPrice.text) ? "div" : slashedPrice.component || "span",
        ...(0,helpers/* omitText */.rW)(slashedPrice),
        textColor: constants_colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        size: "label-regular-m",
        textDecoration: "line-through"
    }, slashedPrice.text)));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/ProductCard.mjs











const ProductCard = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , image , isSaved , onSave , onShare , saveCTA , shareCTA , sharePopover , quickViewCTA , title , description , price , slashedPrice , type , href , productDetails , searchCopy , className , ...rest } = props;
    const isProductCard = type === "Product Card";
    const isAccountCard = type === "Account Card";
    const isProductListSlider = type === "Product List Slider";
    const isShopTheRoom = type === "Shop The Room";
    const hasLink = !!(href && isProductCard);
    const showProductInformation = productDetails || title || description || price || slashedPrice;
    if (onSave) console.warn("Property `onSave` will be deprecated soon. Please use `saveCTA` instead.");
    if (onShare) console.warn("Property `onShare` will be deprecated soon. Please use `shareCTA` instead.");
    let displayTitle;
    if (title) {
        displayTitle = searchCopy && typeof title.text === "string" ? {
            text: highlightText(title.text, searchCopy)
        } : title;
    }
    let displayDescription;
    if (description) {
        displayDescription = searchCopy && typeof description.text === "string" ? {
            text: highlightText(description.text, searchCopy)
        } : description;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)("kohler-product-card-root", className, classes.productCardContainer),
        component: hasLink ? "div" : component,
        href: !hasLink ? href : void 0,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ProductCardImage, {
        hasLink,
        href,
        image,
        onSave,
        isSaved,
        onShare,
        saveCTA,
        shareCTA,
        sharePopover,
        quickViewCTA
    }), showProductInformation && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, isProductCard && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ProductCardInformation, {
        title: displayTitle,
        description: displayDescription,
        price,
        slashedPrice,
        tags: productDetails === null || productDetails === void 0 ? void 0 : productDetails.tags,
        bundleItems: productDetails === null || productDetails === void 0 ? void 0 : productDetails.bundleItems,
        SKU: productDetails === null || productDetails === void 0 ? void 0 : productDetails.SKU,
        taxesLabel: productDetails === null || productDetails === void 0 ? void 0 : productDetails.taxesLabel,
        colorSwatches: productDetails === null || productDetails === void 0 ? void 0 : productDetails.colorSwatches,
        outOfStockLabel: productDetails === null || productDetails === void 0 ? void 0 : productDetails.outOfStockLabel,
        additionalLink: productDetails === null || productDetails === void 0 ? void 0 : productDetails.additionalLink,
        checkbox: productDetails === null || productDetails === void 0 ? void 0 : productDetails.checkbox
    }), isProductListSlider && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ProductListSliderInformation, {
        title: displayTitle,
        description: displayDescription,
        price,
        slashedPrice,
        availableColors: productDetails === null || productDetails === void 0 ? void 0 : productDetails.availableColors
    }), isShopTheRoom && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ShopTheRoomInformation, {
        title: displayTitle,
        description: displayDescription,
        price,
        slashedPrice,
        brand: productDetails === null || productDetails === void 0 ? void 0 : productDetails.brand
    }), isAccountCard && /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountCardInformation, {
        title: displayTitle,
        description: displayDescription,
        price,
        slashedPrice,
        availableColors: productDetails === null || productDetails === void 0 ? void 0 : productDetails.availableColors,
        brand: productDetails === null || productDetails === void 0 ? void 0 : productDetails.brand
    }))));
});



/***/ }),

/***/ 97987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightIcon.mjs
var ArrowRightIcon = __webpack_require__(51782);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlusIcon.mjs
var PlusIcon = __webpack_require__(35114);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownIcon.mjs
var ArrowDownIcon = __webpack_require__(62281);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(18657);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Accordion/Accordion.module.css.mjs
var classes = {
    "accordion": "VImUs",
    "accordionBorderTop": "PT0q5",
    "accordionDivider": "_0TA5j",
    "accordionButton": "r0wrC",
    "accordionButtonLarge": "WkUgy",
    "accordionButtonMedium": "mtHkE",
    "accordionButtonSmall": "n4aH9",
    "accordionButtonXSmall": "_1eUOJ",
    "accordionButtonInside": "X9hew",
    "accordionButtonIrregular": "W5h6a",
    "accordionContent": "NMB2A",
    "iconTransitionOpen": "rM8pu",
    "iconTransitionClosed": "jL8DR",
    "accordionContentOpen": "V75B3",
    "iconTransitionArrowClosed": "XHKaf",
    "iconTransitionArrowOpen": "_5lNCe",
    "iconTransition180DegOpen": "hEx23"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Accordion/Accordion.utils.mjs

const accordionSizeClassNames = {
    large: classes.accordionButtonLarge,
    medium: classes.accordionButtonMedium,
    small: classes.accordionButtonSmall,
    xSmall: classes.accordionButtonXSmall
};
const accordionSizeIconSize = {
    large: "large",
    medium: "medium",
    small: "medium",
    xSmall: "small"
};
const accordionTitleSize = {
    default: {
        large: "h5",
        medium: "h5",
        small: "title-m",
        xSmall: "label-medium-m"
    },
    inside: "label-medium-xl",
    irregular: "h5"
};
const getTitleSize = (type, size)=>{
    const titleSize = accordionTitleSize[type];
    if (type === "default") {
        return titleSize[size];
    }
    return titleSize;
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Accordion/Accordion.mjs
"use client";












const Accordion = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , divider =false , size ="medium" , type ="default" , title , children , className , isDefaultOpen =false , toggleCallback , toggleCTA , open , ...rest } = props;
    const buttonId = (0,use_id/* useId */.M)(toggleCTA === null || toggleCTA === void 0 ? void 0 : toggleCTA.id);
    const contentId = (0,use_id/* useId */.M)();
    const [isOpen, setIsOpen] = (0,use_uncontrolled/* useUncontrolled */.C)({
        value: open,
        defaultValue: isDefaultOpen !== null && isDefaultOpen !== void 0 ? isDefaultOpen : false,
        finalValue: false,
        onChange: (next)=>{
            toggleCallback === null || toggleCallback === void 0 ? void 0 : toggleCallback(next, title);
        }
    });
    const titleSize = getTitleSize(type, size);
    const toggleAccordion = ()=>{
        setIsOpen(!isOpen);
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        className: (0,clsx/* default */.Z)(classes.accordion, "kohler-accordion-root", divider && type === "default" && classes.accordionDivider, type === "default" && classes.accordionBorderTop, className),
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        className: (0,clsx/* default */.Z)(classes.accordionButton, type === "inside" && classes.accordionButtonInside, type === "irregular" && classes.accordionButtonIrregular, type === "default" && accordionSizeClassNames[size]),
        "aria-expanded": isOpen,
        id: buttonId,
        "aria-controls": contentId,
        ...toggleCTA,
        onClick: (e)=>{
            var ref;
            toggleAccordion();
            toggleCTA === null || toggleCTA === void 0 ? void 0 : (ref = toggleCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(toggleCTA, e);
        }
    }, type === "inside" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
        className: (0,clsx/* default */.Z)(!isOpen && classes.iconTransitionArrowClosed, isOpen && classes.iconTransitionArrowOpen),
        size: "medium",
        withBoundingBox: false
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ...(0,helpers/* omitText */.rW)(title),
        size: titleSize,
        component: title.component ? title.component : type === "default" ? "h2" : "h3",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, title.text), type === "default" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(PlusIcon/* PlusIcon */.p, {
        className: (0,clsx/* default */.Z)(!isOpen && classes.iconTransitionClosed, isOpen && classes.iconTransitionOpen),
        size: accordionSizeIconSize[size],
        withBoundingBox: false,
        role: "presentation"
    }), type === "irregular" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownIcon/* ArrowDownIcon */.v, {
        className: (0,clsx/* default */.Z)(!isOpen && classes.iconTransitionArrowClosed, isOpen && classes.iconTransition180DegOpen),
        size: "small",
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "paragraph-medium",
        component: "div",
        role: "region",
        "aria-hidden": !isOpen,
        id: contentId,
        "aria-labelledby": buttonId,
        display: isOpen ? "flex" : "none",
        className: (0,clsx/* default */.Z)(classes.accordionContent, classes.accordionContentOpen, "kohler-accordion-content-root")
    }, children));
});



/***/ }),

/***/ 49885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ ArrowControl; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/ArrowControl.module.css.mjs
var classes = {
    "arrowControl": "Q42Wr"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowLeftIcon.mjs
var ArrowLeftIcon = __webpack_require__(90751);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightIcon.mjs
var ArrowRightIcon = __webpack_require__(51782);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/subcomponent/SliderControl/SliderControl.module.css.mjs
var SliderControl_module_css_classes = {
    "sliderControl": "SpUMc",
    "sliderControlOnPhoto": "M7nQh",
    "sliderControlDefault": "_4lvou"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/subcomponent/SliderControl/SliderControl.mjs






const SliderControl = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , className , direction , isOnPhoto =false , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-slider-control-root", className, SliderControl_module_css_classes.sliderControl, isOnPhoto ? SliderControl_module_css_classes.sliderControlOnPhoto : SliderControl_module_css_classes.sliderControlDefault);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        "aria-label": rest["aria-label"] || direction === "left" ? "carousel arrow left" : "carousel arrow right",
        ...rest
    }, direction === "left" ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        withBoundingBox: true,
        size: isOnPhoto ? "medium" : "small"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
        withBoundingBox: true,
        size: isOnPhoto ? "medium" : "small"
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/subcomponent/CarouselControl/CarouselControl.module.css.mjs
var CarouselControl_module_css_classes = {
    "carouselControl": "_6AS-9"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/subcomponent/CarouselControl/CarouselControl.mjs






const CarouselControl = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , className , direction , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-carousel-control-root", className, CarouselControl_module_css_classes.carouselControl);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        "aria-label": rest["aria-label"] || direction === "left" ? "carousel arrow left" : "carousel arrow right",
        ...rest
    }, direction === "left" ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        withBoundingBox: false,
        size: "medium"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
        size: "medium",
        withBoundingBox: false
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/ArrowControl.mjs






const ArrowControl = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , variant ="carousel" , className , isOnPhoto , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-arrow-control-root", className, classes.arrowControl);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, variant === "carousel" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselControl, {
        ...rest,
        component,
        className: classNames,
        ref
    }), variant === "slider" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(SliderControl, {
        ...rest,
        component,
        isOnPhoto,
        className: classNames,
        ref
    }));
});



/***/ }),

/***/ 75513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCheckboxGroupContext; },
/* harmony export */   "z": function() { return /* binding */ CheckboxGroupProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const CheckboxGroupContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const CheckboxGroupProvider = CheckboxGroupContext.Provider;
const useCheckboxGroupContext = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CheckboxGroupContext);



/***/ }),

/***/ 39091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs + 2 modules
var Tooltip = __webpack_require__(23293);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.context.mjs
var Checkbox_context = __webpack_require__(75513);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.module.css.mjs
var classes = {
    "checkboxContainer": "xQrET",
    "checkboxInput": "_0FmnM",
    "checkboxInner": "qhpmx",
    "checkboxLabelWrapper": "WWTn2",
    "checkboxLabel": "eDKHW",
    "checkboxIcon": "GJS7K",
    "checkboxWrapper": "_48FCt"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/CheckboxIcon.mjs + 1 modules
var CheckboxIcon = __webpack_require__(97349);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.mjs
"use client";










const ConditionalWrapper = (param)=>{
    let { tooltip , className , children , ...rest } = param;
    if (tooltip) {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            className,
            ...rest
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tooltip/* Tooltip */.u, {
            ...tooltip
        }, children));
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className,
        ...rest
    }, children);
};
const Checkbox = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , style , id , label , disabled , onChange , indeterminate , checked , tooltip , ...rest } = props;
    const ctx = (0,Checkbox_context/* useCheckboxGroupContext */.J)();
    const inputId = (0,use_id/* useId */.M)(id);
    const contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: (event)=>{
            ctx.onChange(event);
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        }
    } : {};
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(ConditionalWrapper, {
        className: (0,clsx/* default */.Z)(className, "kohler-checkbox-root", classes.checkboxWrapper),
        style,
        "data-checked": contextProps.checked || checked || void 0,
        tooltip
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classes.checkboxContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)("kohler-checkbox-radio", classes.checkboxInner)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        onChange,
        className: (0,clsx/* default */.Z)("kohler-checkbox-radio-input", classes.checkboxInput),
        component: "input",
        ref,
        id: inputId,
        disabled,
        checked,
        ...rest,
        ...contextProps,
        type: "checkbox"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckboxIcon/* CheckboxIcon */.P, {
        "aria-hidden": true,
        className: classes.checkboxIcon,
        indeterminate
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        "data-disabled": disabled || void 0,
        className: classes.checkboxLabelWrapper
    }, label && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "label",
        htmlFor: inputId,
        size: "label-regular-m",
        className: classes.checkboxLabel,
        "data-disabled": disabled || void 0
    }, label))));
});



/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ CheckboxIcon; }
});

// UNUSED EXPORTS: CheckIcon

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CheckmarkIcon.mjs
var CheckmarkIcon = __webpack_require__(21421);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MinusIcon.mjs


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 20,
    small: 14,
    xSmall: 10
};
const MinusIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 19.5H35V20.5H5V19.5Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 19.5H35V20.5H5V19.5Z",
                    fill: "currentColor"
                }));
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 7.5H13V8.5H3V7.5Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 7.5H13V8.5H3V7.5Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 9.5H17V10.5H3V9.5Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 9.5H17V10.5H3V9.5Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 14.5H25V15.5H5V14.5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 14.5H25V15.5H5V14.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
MinusIcon.iconName = "MinusIcon";


// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/CheckboxIcon.mjs



function CheckIcon(param) {
    let { ...rest } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckmarkIcon/* CheckmarkIcon */.K, {
        size: "xSmall",
        withBoundingBox: true,
        className: (0,clsx/* default */.Z)(rest.className, "kohler-check-icon")
    });
}
function CheckboxIcon(param) {
    let { indeterminate , ...rest } = param;
    if (indeterminate) {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(MinusIcon, {
            size: "xSmall",
            withBoundingBox: true,
            className: (0,clsx/* default */.Z)(rest.className, "kohler-check-icon")
        });
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckIcon, {
        ...rest
    });
}



/***/ }),

/***/ 34199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ ColorSwatch; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 4 modules
var Image = __webpack_require__(26191);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/ColorSwatch.module.css.mjs
var classes = {
    "colorSwatchWrapper": "DyIx-",
    "selected": "Jg7Fq",
    "disabled": "Kobtb",
    "colorSwatch": "x1a-4",
    "square": "_0rhok",
    "rectangle": "rk3E-",
    "colorSwatchColor": "_4Aov8",
    "small": "EYjAD",
    "large": "vdJO6"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/ColorSwatch.mjs








const ColorSwatch = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , className , colorName , colorHex , shape ="square" , size ="small" , isSelected =false , onClick , image , label , disabled , ...rest } = props;
    const wrapperClassNames = (0,clsx/* default */.Z)(className, classes.colorSwatchWrapper, isSelected && classes.selected, "kohler-color-swatch-root", disabled && classes.disabled);
    const colorCardClassNames = (0,clsx/* default */.Z)(classes.colorSwatch, isSelected && classes.selected, classes[shape], classes[size], "kohler-color-swatch-tag", disabled && classes.disabled);
    const colorSwatchColorClassnames = (0,clsx/* default */.Z)("kohler-color-swatch-color", classes.colorSwatchColor, classes[shape], classes[size]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        type: component === "button" ? "button" : void 0,
        ref,
        className: wrapperClassNames,
        onClick,
        ...rest,
        textAlign: "start",
        name: colorName,
        disabled,
        "aria-label": colorName
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center",
        justify: "center",
        className: colorCardClassNames
    }, image ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: colorSwatchColorClassnames
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image,
        opacity: disabled ? 0.5 : 1
    })) : /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: colorSwatchColorClassnames,
        style: {
            backgroundColor: disabled ? "".concat(colorHex, "80") : colorHex
        }
    })), label && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        className: classes.colorSwatchLabel
    }, label));
});



/***/ }),

/***/ 81843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ ColorSwatchRadioGroup; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioGroup/RadioGroup.mjs + 1 modules
var RadioGroup = __webpack_require__(76851);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioButtonCard/RadioButtonCard.mjs + 2 modules
var RadioButtonCard = __webpack_require__(90843);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioGroup.context.mjs
var RadioGroup_context = __webpack_require__(53324);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/ColorSwatch.mjs + 1 modules
var ColorSwatch = __webpack_require__(34199);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/subcomponent/ColorSwatchRadioGroup/ColorSwatchRadioGroup.module.css.mjs
var classes = {
    "colorSwatchRadioGroupInputs": "esX8i",
    "colorSwatchRadioGroupInputsRow": "_2OENi",
    "disabled": "I3KGL"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/subcomponent/ColorSwatchRadioGroup/ColorSwatchRadioButton/ColorSwatchRadioButton.mjs






const ColorSwatchRadioButton = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { value , checked , label , disabled , ...rest } = props;
    const ctx = (0,RadioGroup_context/* useRadioGroupContext */.F)();
    const _checked = typeof checked === "boolean" ? checked : (ctx === null || ctx === void 0 ? void 0 : ctx.value.includes(value || "")) || false;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(RadioButtonCard/* RadioButtonCard */.A, {
        label,
        checked: _checked,
        ref,
        value,
        type: "button",
        disabled,
        "aria-disabled": disabled,
        className: disabled && classes.disabled
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ColorSwatch/* ColorSwatch */.b, {
        isSelected: _checked,
        component: "div",
        label,
        disabled,
        ...rest
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ColorSwatch/subcomponent/ColorSwatchRadioGroup/ColorSwatchRadioGroup.mjs







const ColorSwatchRadioGroup = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { defaultValue , onChange , value , colors , label , id , name , direction ="column" , radioGroupClassname , ["aria-label"]: ariaLabel , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "div",
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RadioGroup/* RadioGroup */.E, {
        label,
        value,
        defaultValue,
        onChange,
        id,
        "aria-label": ariaLabel,
        name,
        radioGroupClassname: (0,clsx/* default */.Z)(classes.colorSwatchRadioGroupInputs, radioGroupClassname, direction === "row" && classes.colorSwatchRadioGroupInputsRow)
    }, colors.map((color)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(ColorSwatchRadioButton, {
            key: color.value,
            shape: color.shape || "square",
            size: "small",
            ...color
        }))));
});



/***/ }),

/***/ 1872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useInputWrapperContext; },
/* harmony export */   "I": function() { return /* binding */ InputWrapperProvider; }
/* harmony export */ });
/* harmony import */ var _utils_hooks_create_optional_context_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48318);

const [InputWrapperProvider, useInputWrapperContext] = (0,_utils_hooks_create_optional_context_mjs__WEBPACK_IMPORTED_MODULE_0__/* .createOptionalContext */ .V)({
    describedBy: void 0,
    inputId: void 0,
    labelId: void 0,
    ariaLabel: void 0
});



/***/ }),

/***/ 50722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ InputsGroupFieldset; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _InputWrapper_context_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1872);


function InputsGroupFieldset(param) {
    let { children , role , ...rest } = param;
    const ctx = (0,_InputWrapper_context_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useInputWrapperContext */ .D)();
    if (!ctx) {
        return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        role,
        "aria-labelledby": ctx.labelId,
        "aria-label": ctx.ariaLabel,
        "aria-describedby": ctx.describedBy,
        ...rest
    }, children);
}



/***/ }),

/***/ 90843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ RadioButtonCard; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioGroup.context.mjs
var RadioGroup_context = __webpack_require__(53324);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/create-optional-context.mjs
var create_optional_context = __webpack_require__(48318);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioButtonCard/RadioButtonCard.context.mjs

const [RadioButtonCardProvider, useRadioButtonCardContext] = (0,create_optional_context/* createOptionalContext */.V)();


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioButtonCard/RadioButtonCard.module.css.mjs
var classes = {
    "radioButtonCard": "Er2e1"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioButtonCard/RadioButtonCard.mjs
"use client";







const RadioButtonCard = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , style , value , checked , onClick , onKeyDown , ...rest } = props;
    const ctx = (0,RadioGroup_context/* useRadioGroupContext */.F)();
    const _checked = typeof checked === "boolean" ? checked : (ctx === null || ctx === void 0 ? void 0 : ctx.value.includes(value || "")) || false;
    const handleKeyDown = (event)=>{
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if ([
            "ArrowDown",
            "ArrowUp",
            "ArrowLeft",
            "ArrowRight"
        ].includes(event.nativeEvent.code)) {
            event.preventDefault();
            const siblings = Array.from(document.querySelectorAll('[role="radio"]'));
            const currentIndex = siblings.findIndex((element)=>element === event.target);
            const nextIndex = currentIndex + 1 >= siblings.length ? 0 : currentIndex + 1;
            const prevIndex = currentIndex - 1 < 0 ? siblings.length - 1 : currentIndex - 1;
            if (event.nativeEvent.code === "ArrowDown") {
                siblings[nextIndex].focus();
                siblings[nextIndex].click();
            }
            if (event.nativeEvent.code === "ArrowUp") {
                siblings[prevIndex].focus();
                siblings[prevIndex].click();
            }
            if (event.nativeEvent.code === "ArrowLeft") {
                siblings[prevIndex].focus();
                siblings[prevIndex].click();
            }
            if (event.nativeEvent.code === "ArrowRight") {
                siblings[nextIndex].focus();
                siblings[nextIndex].click();
            }
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(RadioButtonCardProvider, {
        value: {
            checked: _checked
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        ref,
        role: "radio",
        type: "button",
        "aria-checked": _checked,
        onClick: (event)=>{
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
            ctx === null || ctx === void 0 ? void 0 : ctx.onChange(value || "");
        },
        ...rest,
        className: (0,clsx/* default */.Z)(className, "kohler-radio-button-card-root", classes.radioButtonCard, className),
        style,
        onKeyDown: handleKeyDown
    }));
});



/***/ }),

/***/ 53324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useRadioGroupContext; },
/* harmony export */   "X": function() { return /* binding */ RadioGroupProvider; }
/* harmony export */ });
/* harmony import */ var _utils_hooks_create_optional_context_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48318);

const [RadioGroupProvider, useRadioGroupContext] = (0,_utils_hooks_create_optional_context_mjs__WEBPACK_IMPORTED_MODULE_0__/* .createOptionalContext */ .V)();



/***/ }),

/***/ 76851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ RadioGroup; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(18657);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/InputsGroupFieldset/InputsGroupFieldset.mjs
var InputsGroupFieldset = __webpack_require__(50722);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/InputsGroupFieldset/InputWrapper.context.mjs
var InputWrapper_context = __webpack_require__(1872);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioGroup.context.mjs
var RadioGroup_context = __webpack_require__(53324);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioGroup/RadioGroup.module.css.mjs
var classes = {
    "radioGroupInputs": "EiUrp"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/RadioButton/RadioGroup/RadioGroup.mjs













const RadioGroup = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { value , defaultValue , onChange , children , name , label , error , id , radioGroupClassname , ["aria-label"]: ariaLabel , ...rest } = props;
    const [_value, setValue] = (0,use_uncontrolled/* useUncontrolled */.C)({
        value,
        defaultValue,
        finalValue: "",
        onChange
    });
    const idBase = (0,use_id/* useId */.M)(id);
    const inputId = idBase;
    const labelId = "".concat(idBase, "-label");
    const handleChange = (newValue)=>setValue(newValue);
    const groupAriaLabelledby = label ? labelId : void 0;
    const groupAriaLabel = !label ? ariaLabel || name : void 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(InputWrapper_context/* InputWrapperProvider */.I, {
        value: {
            describedBy: void 0,
            inputId,
            labelId: groupAriaLabelledby,
            ariaLabel: groupAriaLabel
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RadioGroup_context/* RadioGroupProvider */.X, {
        value: {
            value: _value,
            onChange: handleChange,
            name
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 20
    }, label && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "label",
        size: "label-medium-l",
        id: labelId,
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, label), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(InputsGroupFieldset/* InputsGroupFieldset */.m, {
        role: "radiogroup",
        className: (0,clsx/* default */.Z)(classes.radioGroupInputs, radioGroupClassname, "kohler-radio-group-fieldset")
    }, children)), error && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "paragraph-small",
        textColor: colors/* DsmColor.ContentError */.k.ContentError
    }, error))));
});



/***/ }),

/***/ 70276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useCarouselContext; },
/* harmony export */   "s": function() { return /* binding */ CarouselProvider; }
/* harmony export */ });
/* harmony import */ var _Popover_subcomponents_create_safe_context_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19975);

const [CarouselProvider, useCarouselContext] = (0,_Popover_subcomponents_create_safe_context_mjs__WEBPACK_IMPORTED_MODULE_0__/* .createSafeContext */ .R)("Carousel component was not found in tree");



/***/ }),

/***/ 83022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/embla-carousel-reactive-utils/esm/embla-carousel-reactive-utils.esm.js
function isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function isRecord(subject) {
  return isObject(subject) || Array.isArray(subject);
}
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function areOptionsEqual(optionsA, optionsB) {
  const optionsAKeys = Object.keys(optionsA);
  const optionsBKeys = Object.keys(optionsB);
  if (optionsAKeys.length !== optionsBKeys.length) return false;
  const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
  const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
  if (breakpointsA !== breakpointsB) return false;
  return optionsAKeys.every(key => {
    const valueA = optionsA[key];
    const valueB = optionsB[key];
    if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
    if (!isRecord(valueA) || !isRecord(valueB)) return valueA === valueB;
    return areOptionsEqual(valueA, valueB);
  });
}
function sortAndMapPluginToOptions(plugins) {
  return plugins.concat().sort((a, b) => a.name > b.name ? 1 : -1).map(plugin => plugin.options);
}
function arePluginsEqual(pluginsA, pluginsB) {
  if (pluginsA.length !== pluginsB.length) return false;
  const optionsA = sortAndMapPluginToOptions(pluginsA);
  const optionsB = sortAndMapPluginToOptions(pluginsB);
  return optionsA.every((optionA, index) => {
    const optionB = optionsB[index];
    return areOptionsEqual(optionA, optionB);
  });
}


//# sourceMappingURL=embla-carousel-reactive-utils.esm.js.map

;// CONCATENATED MODULE: ./node_modules/embla-carousel/esm/embla-carousel.esm.js
function isNumber(subject) {
  return typeof subject === 'number';
}
function isString(subject) {
  return typeof subject === 'string';
}
function isBoolean(subject) {
  return typeof subject === 'boolean';
}
function embla_carousel_esm_isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function roundToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
}
function arrayKeys(array) {
  return objectKeys(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function arrayIsLastIndex(array, index) {
  return index === arrayLastIndex(array);
}
function arrayFromNumber(n, startAt = 0) {
  return Array.from(Array(n), (_, i) => startAt + i);
}
function objectKeys(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce((mergedObjects, currentObject) => {
    objectKeys(currentObject).forEach(key => {
      const valueA = mergedObjects[key];
      const valueB = currentObject[key];
      const areObjects = embla_carousel_esm_isObject(valueA) && embla_carousel_esm_isObject(valueB);
      mergedObjects[key] = areObjects ? objectsMergeDeep(valueA, valueB) : valueB;
    });
    return mergedObjects;
  }, {});
}
function isMouseEvent(evt, ownerWindow) {
  return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}

function Alignment(align, viewSize) {
  const predefined = {
    start,
    center,
    end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function measure(n, index) {
    if (isString(align)) return predefined[align](n);
    return align(viewSize, n, index);
  }
  const self = {
    measure
  };
  return self;
}

function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = {
    passive: true
  }) {
    let removeListener;
    if ('addEventListener' in node) {
      node.addEventListener(type, handler, options);
      removeListener = () => node.removeEventListener(type, handler, options);
    } else {
      const legacyMediaQueryList = node;
      legacyMediaQueryList.addListener(handler);
      removeListener = () => legacyMediaQueryList.removeListener(handler);
    }
    listeners.push(removeListener);
    return self;
  }
  function clear() {
    listeners = listeners.filter(remove => remove());
  }
  const self = {
    add,
    clear
  };
  return self;
}

function Animations(ownerDocument, ownerWindow, update, render) {
  const documentVisibleHandler = EventStore();
  const fixedTimeStep = 1000 / 60;
  let lastTimeStamp = null;
  let accumulatedTime = 0;
  let animationId = 0;
  function init() {
    documentVisibleHandler.add(ownerDocument, 'visibilitychange', () => {
      if (ownerDocument.hidden) reset();
    });
  }
  function destroy() {
    stop();
    documentVisibleHandler.clear();
  }
  function animate(timeStamp) {
    if (!animationId) return;
    if (!lastTimeStamp) {
      lastTimeStamp = timeStamp;
      update();
      update();
    }
    const timeElapsed = timeStamp - lastTimeStamp;
    lastTimeStamp = timeStamp;
    accumulatedTime += timeElapsed;
    while (accumulatedTime >= fixedTimeStep) {
      update();
      accumulatedTime -= fixedTimeStep;
    }
    const alpha = accumulatedTime / fixedTimeStep;
    render(alpha);
    if (animationId) {
      animationId = ownerWindow.requestAnimationFrame(animate);
    }
  }
  function start() {
    if (animationId) return;
    animationId = ownerWindow.requestAnimationFrame(animate);
  }
  function stop() {
    ownerWindow.cancelAnimationFrame(animationId);
    lastTimeStamp = null;
    accumulatedTime = 0;
    animationId = 0;
  }
  function reset() {
    lastTimeStamp = null;
    accumulatedTime = 0;
  }
  const self = {
    init,
    destroy,
    start,
    stop,
    update,
    render
  };
  return self;
}

function Axis(axis, contentDirection) {
  const isRightToLeft = contentDirection === 'rtl';
  const isVertical = axis === 'y';
  const scroll = isVertical ? 'y' : 'x';
  const cross = isVertical ? 'x' : 'y';
  const sign = !isVertical && isRightToLeft ? -1 : 1;
  const startEdge = getStartEdge();
  const endEdge = getEndEdge();
  function measureSize(nodeRect) {
    const {
      height,
      width
    } = nodeRect;
    return isVertical ? height : width;
  }
  function getStartEdge() {
    if (isVertical) return 'top';
    return isRightToLeft ? 'right' : 'left';
  }
  function getEndEdge() {
    if (isVertical) return 'bottom';
    return isRightToLeft ? 'left' : 'right';
  }
  function direction(n) {
    return n * sign;
  }
  const self = {
    scroll,
    cross,
    startEdge,
    endEdge,
    measureSize,
    direction
  };
  return self;
}

function Limit(min = 0, max = 0) {
  const length = mathAbs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }
  const self = {
    length,
    max,
    min,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset
  };
  return self;
}

function Counter(max, start, loop) {
  const {
    constrain
  } = Limit(0, max);
  const loopEnd = max + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max, get(), loop);
  }
  const self = {
    get,
    set,
    add,
    clone
  };
  return self;
}

function DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
  const {
    cross: crossAxis,
    direction
  } = axis;
  const focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  const nonPassiveEvent = {
    passive: false
  };
  const initEvents = EventStore();
  const dragEvents = EventStore();
  const goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20));
  const snapForceBoost = {
    mouse: 300,
    touch: 400
  };
  const freeForceBoost = {
    mouse: 500,
    touch: 600
  };
  const baseSpeed = dragFree ? 43 : 25;
  let isMoving = false;
  let startScroll = 0;
  let startCross = 0;
  let pointerIsDown = false;
  let preventScroll = false;
  let preventClick = false;
  let isMouse = false;
  function init(emblaApi) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      if (isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
    }
    const node = rootNode;
    initEvents.add(node, 'dragstart', evt => evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', () => undefined, nonPassiveEvent).add(node, 'touchend', () => undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
  }
  function destroy() {
    initEvents.clear();
    dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || '';
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    const boost = dragFree ? freeForceBoost : snapForceBoost;
    const type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1);
    const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < goToNextThreshold) return baseForce;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    isMouse = isMouseEvt;
    preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
    isMoving = deltaAbs(target.get(), location.get()) >= 2;
    if (isMouseEvt && evt.button !== 0) return;
    if (isFocusNode(evt.target)) return;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    scrollBody.useFriction(0).useDuration(0);
    target.set(location);
    addDragEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    eventHandler.emit('pointerDown');
  }
  function move(evt) {
    const isTouchEvt = !isMouseEvent(evt, ownerWindow);
    if (isTouchEvt && evt.touches.length >= 2) return up(evt);
    const lastScroll = dragTracker.readPoint(evt);
    const lastCross = dragTracker.readPoint(evt, crossAxis);
    const diffScroll = deltaAbs(lastScroll, startScroll);
    const diffCross = deltaAbs(lastCross, startCross);
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll) return up(evt);
    }
    const diff = dragTracker.pointerMove(evt);
    if (diffScroll > dragThreshold) preventClick = true;
    scrollBody.useFriction(0.3).useDuration(0.75);
    animation.start();
    target.add(direction(diff));
    evt.preventDefault();
  }
  function up(evt) {
    const currentLocation = scrollTarget.byDistance(0, false);
    const targetChanged = currentLocation.index !== index.get();
    const rawForce = dragTracker.pointerUp(evt) * forceBoost();
    const force = allowedForce(direction(rawForce), targetChanged);
    const forceFactor = factorAbs(rawForce, force);
    const speed = baseSpeed - 10 * forceFactor;
    const friction = baseFriction + forceFactor / 50;
    preventScroll = false;
    pointerIsDown = false;
    dragEvents.clear();
    scrollBody.useDuration(speed).useFriction(friction);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    eventHandler.emit('pointerUp');
  }
  function click(evt) {
    if (preventClick) {
      evt.stopPropagation();
      evt.preventDefault();
      preventClick = false;
    }
  }
  function pointerDown() {
    return pointerIsDown;
  }
  const self = {
    init,
    destroy,
    pointerDown
  };
  return self;
}

function DragTracker(axis, ownerWindow) {
  const logInterval = 170;
  let startEvent;
  let lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const property = evtAxis || axis.scroll;
    const coord = `client${property === 'x' ? 'X' : 'Y'}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent);
    const expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    const diffTime = readTime(evt) - readTime(startEvent);
    const expired = readTime(evt) - readTime(lastEvent) > logInterval;
    const force = diffDrag / diffTime;
    const isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? force : 0;
  }
  const self = {
    pointerDown,
    pointerMove,
    pointerUp,
    readPoint
  };
  return self;
}

function NodeRects() {
  function measure(node) {
    const {
      offsetTop,
      offsetLeft,
      offsetWidth,
      offsetHeight
    } = node;
    const offset = {
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      left: offsetLeft,
      width: offsetWidth,
      height: offsetHeight
    };
    return offset;
  }
  const self = {
    measure
  };
  return self;
}

function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  const self = {
    measure
  };
  return self;
}

function ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
  const observeNodes = [container].concat(slides);
  let resizeObserver;
  let containerSize;
  let slideSizes = [];
  let destroyed = false;
  function readSize(node) {
    return axis.measureSize(nodeRects.measure(node));
  }
  function init(emblaApi) {
    if (!watchResize) return;
    containerSize = readSize(container);
    slideSizes = slides.map(readSize);
    function defaultCallback(entries) {
      for (const entry of entries) {
        if (destroyed) return;
        const isContainer = entry.target === container;
        const slideIndex = slides.indexOf(entry.target);
        const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
        const newSize = readSize(isContainer ? container : slides[slideIndex]);
        const diffSize = mathAbs(newSize - lastSize);
        if (diffSize >= 0.5) {
          emblaApi.reInit();
          eventHandler.emit('resize');
          break;
        }
      }
    }
    resizeObserver = new ResizeObserver(entries => {
      if (isBoolean(watchResize) || watchResize(emblaApi, entries)) {
        defaultCallback(entries);
      }
    });
    ownerWindow.requestAnimationFrame(() => {
      observeNodes.forEach(node => resizeObserver.observe(node));
    });
  }
  function destroy() {
    destroyed = true;
    if (resizeObserver) resizeObserver.disconnect();
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
  let scrollVelocity = 0;
  let scrollDirection = 0;
  let scrollDuration = baseDuration;
  let scrollFriction = baseFriction;
  let rawLocation = location.get();
  let rawLocationPrevious = 0;
  function seek() {
    const displacement = target.get() - location.get();
    const isInstant = !scrollDuration;
    let scrollDistance = 0;
    if (isInstant) {
      scrollVelocity = 0;
      previousLocation.set(target);
      location.set(target);
      scrollDistance = displacement;
    } else {
      previousLocation.set(location);
      scrollVelocity += displacement / scrollDuration;
      scrollVelocity *= scrollFriction;
      rawLocation += scrollVelocity;
      location.add(scrollVelocity);
      scrollDistance = rawLocation - rawLocationPrevious;
    }
    scrollDirection = mathSign(scrollDistance);
    rawLocationPrevious = rawLocation;
    return self;
  }
  function settled() {
    const diff = target.get() - offsetLocation.get();
    return mathAbs(diff) < 0.001;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return scrollVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    scrollDuration = n;
    return self;
  }
  function useFriction(n) {
    scrollFriction = n;
    return self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration
  };
  return self;
}

function ScrollBounds(limit, location, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10);
  const edgeOffsetTolerance = percentOfView.measure(50);
  const frictionLimit = Limit(0.1, 0.99);
  let disabled = false;
  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(location.get())) return false;
    return true;
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
    const diffToEdge = mathAbs(limit[edge] - location.get());
    const diffToTarget = target.get() - location.get();
    const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction);
    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useDuration(25).useBaseFriction();
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  const self = {
    shouldConstrain,
    constrain,
    toggleActive
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
  const scrollBounds = Limit(-contentSize + viewSize, 0);
  const snapsBounded = measureBounded();
  const scrollContainLimit = findScrollContainLimit();
  const snapsContained = measureContained();
  function usePixelTolerance(bound, snap) {
    return deltaAbs(bound, snap) <= 1;
  }
  function findScrollContainLimit() {
    const startSnap = snapsBounded[0];
    const endSnap = arrayLast(snapsBounded);
    const min = snapsBounded.lastIndexOf(startSnap);
    const max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }
  function measureBounded() {
    return snapsAligned.map((snapAligned, index) => {
      const {
        min,
        max
      } = scrollBounds;
      const snap = scrollBounds.constrain(snapAligned);
      const isFirst = !index;
      const isLast = arrayIsLastIndex(snapsAligned, index);
      if (isFirst) return max;
      if (isLast) return min;
      if (usePixelTolerance(min, snap)) return min;
      if (usePixelTolerance(max, snap)) return max;
      return snap;
    }).map(scrollBound => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize + pixelTolerance) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;
    const {
      min,
      max
    } = scrollContainLimit;
    return snapsBounded.slice(min, max);
  }
  const self = {
    snapsContained,
    scrollContainLimit
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max = scrollSnaps[0];
  const min = loop ? max - contentSize : arrayLast(scrollSnaps);
  const limit = Limit(min, max);
  const self = {
    limit
  };
  return self;
}

function ScrollLooper(contentSize, limit, location, vectors) {
  const jointSafety = 0.1;
  const min = limit.min + jointSafety;
  const max = limit.max + jointSafety;
  const {
    reachedMin,
    reachedMax
  } = Limit(min, max);
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(location.get());
    if (direction === -1) return reachedMin(location.get());
    return false;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach(v => v.add(loopDistance));
  }
  const self = {
    loop
  };
  return self;
}

function ScrollProgress(limit) {
  const {
    max,
    length
  } = limit;
  function get(n) {
    const currentLocation = n - max;
    return length ? currentLocation / -length : 0;
  }
  const self = {
    get
  };
  return self;
}

function ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
  const {
    startEdge,
    endEdge
  } = axis;
  const {
    groupSlides
  } = slidesToScroll;
  const alignments = measureSizes().map(alignment.measure);
  const snaps = measureUnaligned();
  const snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects).map(rects => arrayLast(rects)[endEdge] - rects[0][startEdge]).map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects.map(rect => containerRect[startEdge] - rect[startEdge]).map(snap => -mathAbs(snap));
  }
  function measureAligned() {
    return groupSlides(snaps).map(g => g[0]).map((snap, index) => snap + alignments[index]);
  }
  const self = {
    snaps,
    snapsAligned
  };
  return self;
}

function SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
  const {
    groupSlides
  } = slidesToScroll;
  const {
    min,
    max
  } = scrollContainLimit;
  const slideRegistry = createSlideRegistry();
  function createSlideRegistry() {
    const groupedSlideIndexes = groupSlides(slideIndexes);
    const doNotContain = !containSnaps || containScroll === 'keepSnaps';
    if (scrollSnaps.length === 1) return [slideIndexes];
    if (doNotContain) return groupedSlideIndexes;
    return groupedSlideIndexes.slice(min, max).map((group, index, groups) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(groups, index);
      if (isFirst) {
        const range = arrayLast(groups[0]) + 1;
        return arrayFromNumber(range);
      }
      if (isLast) {
        const range = arrayLastIndex(slideIndexes) - arrayLast(groups)[0] + 1;
        return arrayFromNumber(range, arrayLast(groups)[0]);
      }
      return group;
    });
  }
  const self = {
    slideRegistry
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const {
    reachedAny,
    removeOffset,
    constrain
  } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target);
    const ascDiffsToSnaps = scrollSnaps.map((snap, index) => ({
      diff: shortcut(snap - distance, 0),
      index
    })).sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff));
    const {
      index
    } = ascDiffsToSnaps[0];
    return {
      index,
      distance
    };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return target;
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter(t => mathSign(t) === direction);
    if (matchingTargets.length) return minDistance(matchingTargets);
    return arrayLast(targets) - contentSize;
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get();
    const distance = shortcut(diffToSnap, direction);
    return {
      index,
      distance
    };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance;
    const {
      index,
      distance: targetSnapDistance
    } = findTargetSnap(target);
    const reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index,
      distance
    };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance;
    const snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index,
      distance: snapDistance
    };
  }
  const self = {
    byDistance,
    byIndex,
    shortcut
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
  function scrollTo(target) {
    const distanceDiff = target.distance;
    const indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff);
    if (distanceDiff) {
      if (scrollBody.duration()) {
        animation.start();
      } else {
        animation.update();
        animation.render(1);
        animation.update();
      }
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      eventHandler.emit('select');
    }
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n);
    const target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  const self = {
    distance,
    index
  };
  return self;
}

function SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
  const focusListenerOptions = {
    passive: true,
    capture: true
  };
  let lastTabPressTime = 0;
  function init(emblaApi) {
    if (!watchFocus) return;
    function defaultCallback(index) {
      const nowTime = new Date().getTime();
      const diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      eventHandler.emit('slideFocusStart');
      root.scrollLeft = 0;
      const group = slideRegistry.findIndex(group => group.includes(index));
      if (!isNumber(group)) return;
      scrollBody.useDuration(0);
      scrollTo.index(group, 0);
      eventHandler.emit('slideFocus');
    }
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach((slide, slideIndex) => {
      eventStore.add(slide, 'focus', evt => {
        if (isBoolean(watchFocus) || watchFocus(emblaApi, evt)) {
          defaultCallback(slideIndex);
        }
      }, focusListenerOptions);
    });
  }
  function registerTabPress(event) {
    if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
  }
  const self = {
    init
  };
  return self;
}

function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  const self = {
    get,
    set,
    add,
    subtract
  };
  return self;
}

function Translate(axis, container) {
  const translate = axis.scroll === 'x' ? x : y;
  const containerStyle = container.style;
  let previousTarget = null;
  let disabled = false;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    if (disabled) return;
    const newTarget = roundToTwoDecimals(axis.direction(target));
    if (newTarget === previousTarget) return;
    containerStyle.transform = translate(newTarget);
    previousTarget = newTarget;
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    if (disabled) return;
    containerStyle.transform = '';
    if (!container.getAttribute('style')) container.removeAttribute('style');
  }
  const self = {
    clear,
    to,
    toggleActive
  };
  return self;
}

function SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
  const roundingSafety = 0.5;
  const ascItems = arrayKeys(slideSizesWithGaps);
  const descItems = arrayKeys(slideSizesWithGaps).reverse();
  const loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => {
      return a - slideSizesWithGaps[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce((a, i) => {
      const remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findSlideBounds(offset) {
    return snaps.map((snap, index) => ({
      start: snap - slideSizes[index] + roundingSafety + offset,
      end: snap + viewSize - roundingSafety + offset
    }));
  }
  function findLoopPoints(indexes, offset, isEndEdge) {
    const slideBounds = findSlideBounds(offset);
    return indexes.map(index => {
      const initial = isEndEdge ? 0 : -contentSize;
      const altered = isEndEdge ? contentSize : 0;
      const boundEdge = isEndEdge ? 'end' : 'start';
      const loopPoint = slideBounds[index][boundEdge];
      return {
        index,
        loopPoint,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, slides[index]),
        target: () => location.get() > loopPoint ? initial : altered
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0];
    const indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, contentSize, false);
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1;
    const indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, -contentSize, true);
  }
  function canLoop() {
    return loopPoints.every(({
      index
    }) => {
      const otherIndexes = ascItems.filter(i => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach(loopPoint => {
      const {
        target,
        translate,
        slideLocation
      } = loopPoint;
      const shiftLocation = target();
      if (shiftLocation === slideLocation.get()) return;
      translate.to(shiftLocation);
      slideLocation.set(shiftLocation);
    });
  }
  function clear() {
    loopPoints.forEach(loopPoint => loopPoint.translate.clear());
  }
  const self = {
    canLoop,
    clear,
    loop,
    loopPoints
  };
  return self;
}

function SlidesHandler(container, eventHandler, watchSlides) {
  let mutationObserver;
  let destroyed = false;
  function init(emblaApi) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          emblaApi.reInit();
          eventHandler.emit('slidesChanged');
          break;
        }
      }
    }
    mutationObserver = new MutationObserver(mutations => {
      if (destroyed) return;
      if (isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) {
        defaultCallback(mutations);
      }
    });
    mutationObserver.observe(container, {
      childList: true
    });
  }
  function destroy() {
    if (mutationObserver) mutationObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function SlidesInView(container, slides, eventHandler, threshold) {
  const intersectionEntryMap = {};
  let inViewCache = null;
  let notInViewCache = null;
  let intersectionObserver;
  let destroyed = false;
  function init() {
    intersectionObserver = new IntersectionObserver(entries => {
      if (destroyed) return;
      entries.forEach(entry => {
        const index = slides.indexOf(entry.target);
        intersectionEntryMap[index] = entry;
      });
      inViewCache = null;
      notInViewCache = null;
      eventHandler.emit('slidesInView');
    }, {
      root: container.parentElement,
      threshold
    });
    slides.forEach(slide => intersectionObserver.observe(slide));
  }
  function destroy() {
    if (intersectionObserver) intersectionObserver.disconnect();
    destroyed = true;
  }
  function createInViewList(inView) {
    return objectKeys(intersectionEntryMap).reduce((list, slideIndex) => {
      const index = parseInt(slideIndex);
      const {
        isIntersecting
      } = intersectionEntryMap[index];
      const inViewMatch = inView && isIntersecting;
      const notInViewMatch = !inView && !isIntersecting;
      if (inViewMatch || notInViewMatch) list.push(index);
      return list;
    }, []);
  }
  function get(inView = true) {
    if (inView && inViewCache) return inViewCache;
    if (!inView && notInViewCache) return notInViewCache;
    const slideIndexes = createInViewList(inView);
    if (inView) inViewCache = slideIndexes;
    if (!inView) notInViewCache = slideIndexes;
    return slideIndexes;
  }
  const self = {
    init,
    destroy,
    get
  };
  return self;
}

function SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
  const {
    measureSize,
    startEdge,
    endEdge
  } = axis;
  const withEdgeGap = slideRects[0] && readEdgeGap;
  const startGap = measureStartGap();
  const endGap = measureEndGap();
  const slideSizes = slideRects.map(measureSize);
  const slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects.map((rect, index, rects) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(rects, index);
      if (isFirst) return slideSizes[index] + startGap;
      if (isLast) return slideSizes[index] + endGap;
      return rects[index + 1][startEdge] - rect[startEdge];
    }).map(mathAbs);
  }
  const self = {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  };
  return self;
}

function SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
  const {
    startEdge,
    endEdge,
    direction
  } = axis;
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array).filter(i => i % groupSize === 0).map(i => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    if (!array.length) return [];
    return arrayKeys(array).reduce((groups, rectB, index) => {
      const rectA = arrayLast(groups) || 0;
      const isFirst = rectA === 0;
      const isLast = rectB === arrayLastIndex(array);
      const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
      const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
      const gapA = !loop && isFirst ? direction(startGap) : 0;
      const gapB = !loop && isLast ? direction(endGap) : 0;
      const chunkSize = mathAbs(edgeB - gapB - (edgeA + gapA));
      if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
      if (isLast) groups.push(array.length);
      return groups;
    }, []).map((currentSize, index, groups) => {
      const previousSize = Math.max(groups[index - 1] || 0);
      return array.slice(previousSize, currentSize);
    });
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  const self = {
    groupSlides
  };
  return self;
}

function Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
  // Options
  const {
    align,
    axis: scrollAxis,
    direction,
    startIndex,
    loop,
    duration,
    dragFree,
    dragThreshold,
    inViewThreshold,
    slidesToScroll: groupSlides,
    skipSnaps,
    containScroll,
    watchResize,
    watchSlides,
    watchDrag,
    watchFocus
  } = options;
  // Measurements
  const pixelTolerance = 2;
  const nodeRects = NodeRects();
  const containerRect = nodeRects.measure(container);
  const slideRects = slides.map(nodeRects.measure);
  const axis = Axis(scrollAxis, direction);
  const viewSize = axis.measureSize(containerRect);
  const percentOfView = PercentOfView(viewSize);
  const alignment = Alignment(align, viewSize);
  const containSnaps = !loop && !!containScroll;
  const readEdgeGap = loop || !!containScroll;
  const {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  } = SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
  const slidesToScroll = SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
  const {
    snaps,
    snapsAligned
  } = ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
  const contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  const {
    snapsContained,
    scrollContainLimit
  } = ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
  const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
  const {
    limit
  } = ScrollLimit(contentSize, scrollSnaps, loop);
  // Indexes
  const index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  const indexPrevious = index.clone();
  const slideIndexes = arrayKeys(slides);
  // Animation
  const update = ({
    dragHandler,
    scrollBody,
    scrollBounds,
    options: {
      loop
    }
  }) => {
    if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
    scrollBody.seek();
  };
  const render = ({
    scrollBody,
    translate,
    location,
    offsetLocation,
    previousLocation,
    scrollLooper,
    slideLooper,
    dragHandler,
    animation,
    eventHandler,
    scrollBounds,
    options: {
      loop
    }
  }, alpha) => {
    const shouldSettle = scrollBody.settled();
    const withinBounds = !scrollBounds.shouldConstrain();
    const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
    const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
    if (hasSettledAndIdle) animation.stop();
    const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
    offsetLocation.set(interpolatedLocation);
    if (loop) {
      scrollLooper.loop(scrollBody.direction());
      slideLooper.loop();
    }
    translate.to(offsetLocation.get());
    if (hasSettledAndIdle) eventHandler.emit('settle');
    if (!hasSettled) eventHandler.emit('scroll');
  };
  const animation = Animations(ownerDocument, ownerWindow, () => update(engine), alpha => render(engine, alpha));
  // Shared
  const friction = 0.68;
  const startLocation = scrollSnaps[index.get()];
  const location = Vector1D(startLocation);
  const previousLocation = Vector1D(startLocation);
  const offsetLocation = Vector1D(startLocation);
  const target = Vector1D(startLocation);
  const scrollBody = ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
  const scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  const scrollTo = ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
  const scrollProgress = ScrollProgress(limit);
  const eventStore = EventStore();
  const slidesInView = SlidesInView(container, slides, eventHandler, inViewThreshold);
  const {
    slideRegistry
  } = SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
  const slideFocus = SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
  // Engine
  const engine = {
    ownerDocument,
    ownerWindow,
    eventHandler,
    containerRect,
    slideRects,
    animation,
    axis,
    dragHandler: DragHandler(axis, root, ownerDocument, ownerWindow, target, DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
    eventStore,
    percentOfView,
    index,
    indexPrevious,
    limit,
    location,
    offsetLocation,
    previousLocation,
    options,
    resizeHandler: ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
    scrollBody,
    scrollBounds: ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
    scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [location, offsetLocation, previousLocation, target]),
    scrollProgress,
    scrollSnapList: scrollSnaps.map(scrollProgress.get),
    scrollSnaps,
    scrollTarget,
    scrollTo,
    slideLooper: SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
    slideFocus,
    slidesHandler: SlidesHandler(container, eventHandler, watchSlides),
    slidesInView,
    slideIndexes,
    slideRegistry,
    slidesToScroll,
    target,
    translate: Translate(axis, container)
  };
  return engine;
}

function EventHandler() {
  let listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    getListeners(evt).forEach(e => e(api, evt));
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(e => e !== cb);
    return self;
  }
  function clear() {
    listeners = {};
  }
  const self = {
    init,
    emit,
    off,
    on,
    clear
  };
  return self;
}

const defaultOptions = {
  align: 'center',
  axis: 'x',
  container: null,
  slides: null,
  containScroll: 'trimSnaps',
  direction: 'ltr',
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: false,
  dragThreshold: 10,
  loop: false,
  skipSnaps: false,
  duration: 25,
  startIndex: 0,
  active: true,
  watchDrag: true,
  watchResize: true,
  watchSlides: true,
  watchFocus: true
};

function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia = options.breakpoints || {};
    const matchedMediaOptions = objectKeys(optionsAtMedia).filter(media => ownerWindow.matchMedia(media).matches).map(media => optionsAtMedia[media]).reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList.map(options => objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries) => acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
  }
  const self = {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  };
  return self;
}

function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(emblaApi, plugins) {
    activePlugins = plugins.filter(({
      options
    }) => optionsHandler.optionsAtMedia(options).active !== false);
    activePlugins.forEach(plugin => plugin.init(emblaApi, optionsHandler));
    return plugins.reduce((map, plugin) => Object.assign(map, {
      [plugin.name]: plugin
    }), {});
  }
  function destroy() {
    activePlugins = activePlugins.filter(plugin => plugin.destroy());
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument;
  const ownerWindow = ownerDocument.defaultView;
  const optionsHandler = OptionsHandler(ownerWindow);
  const pluginsHandler = PluginsHandler(optionsHandler);
  const mediaHandlers = EventStore();
  const eventHandler = EventHandler();
  const {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  } = optionsHandler;
  const {
    on,
    off,
    emit
  } = eventHandler;
  const reInit = reActivate;
  let destroyed = false;
  let engine;
  let optionsBase = mergeOptions(defaultOptions, EmblaCarousel.globalOptions);
  let options = mergeOptions(optionsBase);
  let pluginList = [];
  let pluginApis;
  let container;
  let slides;
  function storeElements() {
    const {
      container: userContainer,
      slides: userSlides
    } = options;
    const customContainer = isString(userContainer) ? root.querySelector(userContainer) : userContainer;
    container = customContainer || root.children[0];
    const customSlides = isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options) {
    const engine = Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
    if (options.loop && !engine.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options, {
        loop: false
      });
      return createEngine(optionsWithoutLoop);
    }
    return engine;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    optionsBase = mergeOptions(optionsBase, withOptions);
    options = optionsAtMedia(optionsBase);
    pluginList = withPlugins || pluginList;
    storeElements();
    engine = createEngine(options);
    optionsMediaQueries([optionsBase, ...pluginList.map(({
      options
    }) => options)]).forEach(query => mediaHandlers.add(query, 'change', reActivate));
    if (!options.active) return;
    engine.translate.to(engine.location.get());
    engine.animation.init();
    engine.slidesInView.init();
    engine.slideFocus.init(self);
    engine.eventHandler.init(self);
    engine.resizeHandler.init(self);
    engine.slidesHandler.init(self);
    if (engine.options.loop) engine.slideLooper.loop();
    if (container.offsetParent && slides.length) engine.dragHandler.init(self);
    pluginApis = pluginsHandler.init(self, pluginList);
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate();
    activate(mergeOptions({
      startIndex
    }, withOptions), withPlugins);
    eventHandler.emit('reInit');
  }
  function deActivate() {
    engine.dragHandler.destroy();
    engine.eventStore.clear();
    engine.translate.clear();
    engine.slideLooper.clear();
    engine.resizeHandler.destroy();
    engine.slidesHandler.destroy();
    engine.slidesInView.destroy();
    engine.animation.destroy();
    pluginsHandler.destroy();
    mediaHandlers.clear();
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    mediaHandlers.clear();
    deActivate();
    eventHandler.emit('destroy');
    eventHandler.clear();
  }
  function scrollTo(index, jump, direction) {
    if (!options.active || destroyed) return;
    engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
    engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump, 1);
  }
  function canScrollNext() {
    const next = engine.index.add(1).get();
    return next !== selectedScrollSnap();
  }
  function canScrollPrev() {
    const prev = engine.index.add(-1).get();
    return prev !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnapList;
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.offsetLocation.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function slidesInView() {
    return engine.slidesInView.get();
  }
  function slidesNotInView() {
    return engine.slidesInView.get(false);
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView
  };
  activate(userOptions, userPlugins);
  setTimeout(() => eventHandler.emit('init'), 0);
  return self;
}
EmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel.esm.js.map

;// CONCATENATED MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js




function useEmblaCarousel(options = {}, plugins = []) {
  const storedOptions = (0,react.useRef)(options);
  const storedPlugins = (0,react.useRef)(plugins);
  const [emblaApi, setEmblaApi] = (0,react.useState)();
  const [viewport, setViewport] = (0,react.useState)();
  const reInit = (0,react.useCallback)(() => {
    if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
  }, [emblaApi]);
  (0,react.useEffect)(() => {
    if (areOptionsEqual(storedOptions.current, options)) return;
    storedOptions.current = options;
    reInit();
  }, [options, reInit]);
  (0,react.useEffect)(() => {
    if (arePluginsEqual(storedPlugins.current, plugins)) return;
    storedPlugins.current = plugins;
    reInit();
  }, [plugins, reInit]);
  (0,react.useEffect)(() => {
    if (canUseDOM() && viewport) {
      EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
      const newEmblaApi = EmblaCarousel(viewport, storedOptions.current, storedPlugins.current);
      setEmblaApi(newEmblaApi);
      return () => newEmblaApi.destroy();
    } else {
      setEmblaApi(undefined);
    }
  }, [viewport, setEmblaApi]);
  return [setViewport, emblaApi];
}
useEmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-react.esm.js.map

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/ArrowControl/ArrowControl.mjs + 5 modules
var ArrowControl = __webpack_require__(49885);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/SlashIcon.mjs


const withoutBoundingBoxWidth = {
    large: 11,
    medium: 9,
    small: 6,
    xSmall: 6
};
const SlashIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.5416 5L25.5 5.27708L15.4584 35L14.5 34.7229L24.5416 5Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6333 3L19.4001 3.22167L11.3669 27L10.6001 26.7783L18.6333 3Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.4772 1L13 1.16625L7.52279 19L7 18.8338L12.4772 1Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
SlashIcon.iconName = "SlashIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CarouselCounter/CarouselCounter.module.css.mjs
var classes = {
    "slashIcon": "oGjBK"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CarouselCounter/CarouselCounter.mjs








const CarouselCounter = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { current , total , className , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-carousel-counter-root", className);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center",
        className: classNames,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textColor: colors/* DsmColor.ContentPrimary */.k.ContentPrimary,
        component: "span",
        size: "h5",
        className: "kohler-carousel-counter-current"
    }, current), /* @__PURE__ */ /*#__PURE__*/ react.createElement(SlashIcon, {
        size: "large",
        withBoundingBox: true,
        className: (0,clsx/* default */.Z)(classes.slashIcon, "kohler-carousel-counter-slash")
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "h5",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        className: "kohler-carousel-counter-total"
    }, total));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.context.mjs
var Carousel_context = __webpack_require__(70276);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.module.css.mjs
var Carousel_module_css = __webpack_require__(75989);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.mjs
"use client";










const Carousel = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1, ref2;
    const { className , children , onNextSlide , onPreviousSlide , onSlideChange , orientation ="horizontal" , slideSize ="100%" , getEmblaApi , slideGap =0 , height ="auto" , align ="center" , slidesToScroll =1 , includeGapInSize =true , draggable =true , dragFree =false , loop =true , speed =25 , initialSlide =0 , inViewThreshold =0 , withControls =true , withIndicators =false , skipSnaps =false , containScroll , withKeyboardEvents =true , carouselControlProps , rightCarouselControlProps , leftCarouselControlProps , controlsOffset , customRightControl , customLeftControl , hideControlOnDisabled =true , dragIgnoreElementsList , plugins , style , ...rest } = props;
    const dir = "ltr";
    const [emblaRefElement, embla] = useEmblaCarousel({
        axis: orientation === "horizontal" ? "x" : "y",
        direction: orientation === "horizontal" ? dir : void 0,
        startIndex: initialSlide,
        loop,
        align,
        slidesToScroll,
        watchDrag: (_embla, evt)=>{
            if (!draggable) return false;
            if (!dragIgnoreElementsList || dragIgnoreElementsList.length === 0) {
                return true;
            }
            if (evt.type !== "mousedown") {
                return true;
            }
            const targetElement = evt.target;
            return targetElement ? !targetElement.closest(dragIgnoreElementsList.join(",")) : true;
        },
        dragFree,
        duration: speed,
        inViewThreshold,
        skipSnaps,
        containScroll
    }, plugins);
    const [selected, setSelected] = (0,react.useState)(0);
    const [slidesCount, setSlidesCount] = (0,react.useState)(0);
    const handleSelect = (0,react.useCallback)(()=>{
        if (!embla) return;
        const slide = embla.selectedScrollSnap();
        setSelected(slide);
        onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(slide);
    }, [
        embla,
        setSelected
    ]);
    const handlePrevious = (0,react.useCallback)(()=>{
        embla === null || embla === void 0 ? void 0 : embla.scrollPrev();
        onPreviousSlide === null || onPreviousSlide === void 0 ? void 0 : onPreviousSlide();
    }, [
        embla
    ]);
    const handleNext = (0,react.useCallback)(()=>{
        embla === null || embla === void 0 ? void 0 : embla.scrollNext();
        onNextSlide === null || onNextSlide === void 0 ? void 0 : onNextSlide();
    }, [
        embla
    ]);
    const handleKeydown = (0,react.useCallback)((event)=>{
        if (withKeyboardEvents) {
            if (event.key === "ArrowRight") {
                event.preventDefault();
                handleNext();
            }
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                handlePrevious();
            }
        }
    }, [
        embla
    ]);
    (0,react.useEffect)(()=>{
        if (embla) {
            getEmblaApi === null || getEmblaApi === void 0 ? void 0 : getEmblaApi(embla);
            handleSelect();
            setSlidesCount(embla.scrollSnapList().length);
            embla.on("select", handleSelect);
            return ()=>{
                embla.off("select", handleSelect);
            };
        }
        return void 0;
    }, [
        embla,
        slidesToScroll
    ]);
    (0,react.useEffect)(()=>{
        if (embla) {
            embla.reInit();
            setSlidesCount(embla.scrollSnapList().length);
            setSelected((currentSelected)=>(0,helpers/* clamp */.uZ)(currentSelected, 0, react.Children.toArray(children).length - 1));
        }
    }, [
        react.Children.toArray(children).length,
        slidesToScroll
    ]);
    const canScrollPrev = (embla === null || embla === void 0 ? void 0 : embla.canScrollPrev()) || false;
    const canScrollNext = (embla === null || embla === void 0 ? void 0 : embla.canScrollNext()) || false;
    const showLeftControl = embla && (canScrollPrev || loop);
    const showRightControl = embla && (canScrollNext || loop);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel_context/* CarouselProvider */.s, {
        value: {
            orientation
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.root */.Z.root, className, "kohler-carousel-root"),
        ...rest,
        onKeyDownCapture: handleKeydown,
        style: {
            "--carousel-height": height,
            "--carousel-slide-size": slideSize || void 0,
            "--carousel-slide-gap": slideGap,
            "--carousel-controls-offset": controlsOffset || void 0,
            ...style
        },
        "data-include-gap-in-size": includeGapInSize || void 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.viewport */.Z.viewport, "kohler-carousel-content"),
        ref: emblaRefElement
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.container */.Z.container, "kohler-carousel-container"),
        "data-orientation": orientation
    }, children)), withIndicators && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.indicators */.Z.indicators, "kohler-carousel-indicators"),
        "data-orientation": orientation
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselCounter, {
        total: slidesCount,
        current: selected + 1
    })), withControls && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.controls */.Z.controls, "kohler-carousel-controls"),
        "data-orientation": orientation
    }, customLeftControl ? /*#__PURE__*/ react.isValidElement(customLeftControl) ? /*#__PURE__*/ react.cloneElement(customLeftControl, {
        "data-inactive": !canScrollPrev || void 0,
        tabIndex: canScrollPrev ? 0 : -1,
        onClick: ()=>{
            handlePrevious();
        },
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.control */.Z.control, !showLeftControl && hideControlOnDisabled && Carousel_module_css/* default.controlLeftHidden */.Z.controlLeftHidden, (ref1 = customLeftControl.props) === null || ref1 === void 0 ? void 0 : ref1.className, carouselControlProps === null || carouselControlProps === void 0 ? void 0 : carouselControlProps.className),
        ...carouselControlProps,
        ...leftCarouselControlProps
    }) : customLeftControl : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowControl/* ArrowControl */.l, {
        variant: "carousel",
        direction: "left",
        "data-inactive": !canScrollPrev || void 0,
        tabIndex: canScrollPrev ? 0 : -1,
        onClick: handlePrevious,
        disabled: !hideControlOnDisabled && !canScrollPrev,
        ...carouselControlProps,
        ...leftCarouselControlProps,
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.control */.Z.control, !showLeftControl && hideControlOnDisabled && Carousel_module_css/* default.controlLeftHidden */.Z.controlLeftHidden, carouselControlProps === null || carouselControlProps === void 0 ? void 0 : carouselControlProps.className)
    }), customRightControl ? /*#__PURE__*/ react.isValidElement(customRightControl) ? /*#__PURE__*/ react.cloneElement(customRightControl, {
        "data-inactive": !canScrollNext || void 0,
        tabIndex: canScrollNext ? 0 : -1,
        onClick: ()=>{
            handleNext();
        },
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.control */.Z.control, !showRightControl && hideControlOnDisabled && Carousel_module_css/* default.controlRightHidden */.Z.controlRightHidden, (ref2 = customRightControl.props) === null || ref2 === void 0 ? void 0 : ref2.className, carouselControlProps === null || carouselControlProps === void 0 ? void 0 : carouselControlProps.className),
        ...carouselControlProps,
        ...rightCarouselControlProps
    }) : customRightControl : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowControl/* ArrowControl */.l, {
        variant: "carousel",
        direction: "right",
        "data-inactive": !canScrollNext || void 0,
        tabIndex: canScrollNext ? 0 : -1,
        onClick: handleNext,
        disabled: !hideControlOnDisabled && !canScrollNext,
        ...carouselControlProps,
        ...rightCarouselControlProps,
        className: (0,clsx/* default */.Z)(Carousel_module_css/* default.control */.Z.control, !showRightControl && hideControlOnDisabled && Carousel_module_css/* default.controlRightHidden */.Z.controlRightHidden, carouselControlProps === null || carouselControlProps === void 0 ? void 0 : carouselControlProps.className)
    }))));
});



/***/ }),

/***/ 75989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ classes; }
/* harmony export */ });
var classes = {
    "root": "ahc8m",
    "viewport": "LLE84",
    "container": "Le96v",
    "controls": "ietvU",
    "control": "ZfMAh",
    "controlLeftHidden": "_5fdcq",
    "controlRightHidden": "pIa3G",
    "indicators": "_0lOqX",
    "slide": "fSTQ-"
};



/***/ }),

/***/ 7749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ CarouselSlide; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _factory_factory_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99347);
/* harmony import */ var _Other_Box_Box_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3253);
/* harmony import */ var _Carousel_context_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70276);
/* harmony import */ var _Carousel_module_css_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75989);






const CarouselSlide = (0,_factory_factory_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .factory */ .d5)((props, ref)=>{
    const { className , ...rest } = props;
    const classNames = (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Carousel_module_css_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"].slide */ .Z.slide, className);
    const ctx = (0,_Carousel_context_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useCarouselContext */ .G)();
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Other_Box_Box_mjs__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
        ref,
        className: classNames,
        ...rest,
        "data-orientation": ctx.orientation
    });
});



/***/ }),

/***/ 26191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.constants.mjs
const DEFAULT_IMG_PLACEHOLDER = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mM8c/78fwAIhwOsMzWsOQAAAABJRU5ErkJggg==";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/RevealWhenReadyEnhancer.mjs
"use client";

function preload(src) {
    return new Promise((resolve, reject)=>{
        const i = new Image();
        i.onload = ()=>{
            var ref;
            return (ref = i.decode) === null || ref === void 0 ? void 0 : ref.call(i).catch(()=>{}).finally(()=>resolve());
        };
        i.onerror = ()=>reject();
        i.src = src;
    });
}
function RevealWhenReadyEnhancer(param) {
    let { children , inlineSwapActive =false , style  } = param;
    const containerRef = (0,react.useRef)(null);
    const [ready, setReady] = (0,react.useState)(false);
    const [errored, setErrored] = (0,react.useState)(false);
    const [swapActive, setSwapActive] = (0,react.useState)(Boolean(inlineSwapActive));
    const [inViewport, setInViewport] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        let observer = null;
        const handleIntersection = (entries)=>{
            if (entries[0].isIntersecting) {
                setInViewport(true);
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        };
        observer = new window.IntersectionObserver(handleIntersection, {
            root: null,
            threshold: 0.01
        });
        observer.observe(container);
        return ()=>{
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, []);
    (0,react.useEffect)(()=>{
        var ref;
        if (!inViewport) return;
        const container = containerRef.current;
        if (!container) return;
        const img = container.querySelector("img");
        if (!img) return;
        let cancelled = false;
        const finish = ()=>!cancelled && setReady(true);
        const fail = ()=>!cancelled && setErrored(true);
        var ref1;
        const dataSrc = (ref1 = (ref = img.dataset) === null || ref === void 0 ? void 0 : ref.src) !== null && ref1 !== void 0 ? ref1 : void 0;
        setSwapActive(Boolean(dataSrc));
        if (dataSrc) {
            preload(dataSrc).then(()=>{
                var ref;
                if (cancelled) return;
                img.src = dataSrc;
                img.removeAttribute("data-src");
                (ref = img.decode) === null || ref === void 0 ? void 0 : ref.call(img).catch(()=>{}).finally(finish);
            }).catch(fail);
            return ()=>{
                cancelled = true;
            };
        }
        const onLoad = ()=>{
            var ref;
            (ref = img.decode) === null || ref === void 0 ? void 0 : ref.call(img).catch(()=>{}).finally(finish);
        };
        if (img.complete && img.naturalWidth > 0) {
            onLoad();
            return ()=>{
                cancelled = true;
            };
        } else {
            img.addEventListener("load", onLoad, {
                once: true
            });
            img.addEventListener("error", fail, {
                once: true
            });
            return ()=>{
                cancelled = true;
                img.removeEventListener("load", onLoad);
                img.removeEventListener("error", fail);
            };
        }
    }, [
        inViewport
    ]);
    const invisible = !ready && !errored && !swapActive;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        ref: containerRef,
        "aria-busy": !ready ? true : void 0,
        style: {
            opacity: invisible ? 0 : 1,
            visibility: invisible ? "hidden" : "visible",
            pointerEvents: invisible ? "none" : "auto",
            transition: "opacity 180ms ease",
            height: "100%",
            width: "100%",
            ...style
        }
    }, children);
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.hook.mjs

function useS7SmartCrop(ref) {
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (!node || node.dataset.mode !== "smartcrop") return;
        const MAX_ATTEMPTS = 3;
        const INTERVAL = 3e3;
        const waitForS7 = ()=>new Promise((resolve, reject)=>{
                let attempts = 0;
                const check = ()=>{
                    if (typeof window.s7responsiveImage === "function") {
                        resolve();
                    } else if (++attempts < MAX_ATTEMPTS) {
                        setTimeout(check, INTERVAL);
                    } else {
                        reject(new Error("s7responsiveImage not available after 3 attempts"));
                    }
                };
                check();
            });
        const applySmartCrop = async ()=>{
            try {
                var ref;
                await waitForS7();
                (ref = window.s7responsiveImage) === null || ref === void 0 ? void 0 : ref.call(window, node);
            } catch (err) {
                console.warn(err.message);
            }
        };
        if (document.readyState === "complete") {
            applySmartCrop();
        } else {
            window.addEventListener("load", applySmartCrop);
            return ()=>window.removeEventListener("load", applySmartCrop);
        }
    }, [
        ref
    ]);
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/SmartCropS7Enhancer.mjs
"use client";


const SmartCropS7Enhancer = (param)=>{
    let { children  } = param;
    const ref = (0,react.useRef)(null);
    useS7SmartCrop(ref);
    return /*#__PURE__*/ react.cloneElement(children, {
        ref
    });
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs







const Image_Image = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="img" , src , srcSet , alt , className , width ="100%" , height ="100%" , objectFit ="cover" , position ="relative" , objectPosition ="center" , reveal ="default" , inlineSwap =false , placeholderSrc =DEFAULT_IMG_PLACEHOLDER , zIndex , inset , loading ="lazy" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-image-root", className);
    const isSmartCrop = rest["data-mode"] === "smartcrop";
    const shouldLazyLoad = loading === "lazy";
    const renderSrc = shouldLazyLoad && placeholderSrc ? placeholderSrc : src;
    const baseImg = /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        src: renderSrc,
        "data-src": shouldLazyLoad ? src : void 0,
        srcSet,
        alt,
        position,
        width,
        height,
        zIndex,
        inset,
        objectFit,
        objectPosition,
        loading,
        ...rest
    });
    const smart = isSmartCrop ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(SmartCropS7Enhancer, null, baseImg) : baseImg;
    if (shouldLazyLoad || reveal === "when-ready") {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(RevealWhenReadyEnhancer, {
            inlineSwapActive: inlineSwap,
            style: {
                zIndex,
                position,
                inset
            }
        }, smart);
    }
    return smart;
});



/***/ }),

/***/ 19770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ Video; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Video/useAutoplayInView.mjs

function useAutoplayInView(videoRef) {
    let { threshold =0.5 , rootMargin ="0px" , pauseWhenOutOfView =true , respectReducedMotion =true , pauseOnPageHide =true , retryOnPlayRejection =true  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const [inView, setInView] = (0,react.useState)(false);
    const [canAutoplay, setCanAutoplay] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        var ref;
        if (!respectReducedMotion) return;
        const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
        const update = ()=>setCanAutoplay(!mq.matches);
        update();
        (ref = mq.addEventListener) === null || ref === void 0 ? void 0 : ref.call(mq, "change", update);
        return ()=>{
            var ref;
            return (ref = mq.removeEventListener) === null || ref === void 0 ? void 0 : ref.call(mq, "change", update);
        };
    }, [
        respectReducedMotion
    ]);
    (0,react.useEffect)(()=>{
        if (!pauseOnPageHide) return;
        const onVis = ()=>{
            const el = videoRef.current;
            if (!el) return;
            if (document.visibilityState !== "visible") el.pause();
            else if (inView && canAutoplay && el.paused) {
                el.play().catch(()=>{});
            }
        };
        document.addEventListener("visibilitychange", onVis);
        return ()=>document.removeEventListener("visibilitychange", onVis);
    }, [
        pauseOnPageHide,
        inView,
        canAutoplay,
        videoRef
    ]);
    (0,react.useEffect)(()=>{
        const el = videoRef.current;
        if (!el) return;
        const io = new IntersectionObserver((param)=>{
            let [entry] = param;
            return setInView(entry.isIntersecting);
        }, {
            threshold,
            rootMargin
        });
        io.observe(el);
        return ()=>io.disconnect();
    }, [
        threshold,
        rootMargin,
        videoRef
    ]);
    (0,react.useEffect)(()=>{
        const el = videoRef.current;
        if (!el) return;
        const shouldPlay = inView && canAutoplay;
        if (shouldPlay) {
            el.play().catch(()=>{
                if (!retryOnPlayRejection) return;
            });
        } else if (pauseWhenOutOfView) {
            el.pause();
        }
    }, [
        inView,
        canAutoplay,
        pauseWhenOutOfView,
        retryOnPlayRejection,
        videoRef
    ]);
    return {
        inView,
        canAutoplay
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Video/Video.module.css.mjs
var classes = {
    "videoWrapper": "XvBsq",
    "posterImage": "_5oL-J",
    "video": "g5e3S"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Video/ClientAutoplayVideo.mjs
"use client";





const ClientAutoplayVideo = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { className , src , sources , poster , posterImages , controls =false , loop =false , muted =true , playsInline =true , decorative =true , describedByText , captions , autoplayOptions , forceAttributes =true , style , ...rest } = props;
    const videoRef = (0,react.useRef)(null);
    const descId = (0,react.useMemo)(()=>describedByText ? "vid-desc-".concat(Math.random().toString(36).slice(2)) : void 0, [
        describedByText
    ]);
    useAutoplayInView(videoRef, autoplayOptions);
    var ref1;
    (0,react.useImperativeHandle)(ref, ()=>{
        return {
            play: ()=>{
                var ref;
                return (ref1 = (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play()) !== null && ref1 !== void 0 ? ref1 : Promise.resolve();
            },
            pause: ()=>{
                var ref;
                return (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.pause();
            },
            toggle: ()=>videoRef.current ? videoRef.current.paused ? videoRef.current.play() : (videoRef.current.pause(), Promise.resolve()) : Promise.resolve(),
            element: videoRef.current
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!forceAttributes) return;
        const el = videoRef.current;
        if (!el) return;
        const toggleAttr = (name, on)=>{
            if (on) el.setAttribute(name, "");
            else el.removeAttribute(name);
        };
        toggleAttr("muted", muted);
        toggleAttr("controls", controls);
        toggleAttr("loop", loop);
        toggleAttr("playsinline", playsInline);
    }, [
        forceAttributes,
        muted,
        controls,
        loop,
        playsInline
    ]);
    const a11yProps = decorative ? {
        "aria-hidden": true,
        tabIndex: -1
    } : {
        "aria-describedby": descId
    };
    const hasSources = Array.isArray(sources) && sources.length > 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, describedByText && !decorative && /* @__PURE__ */ /*#__PURE__*/ react.createElement("span", {
        id: descId,
        className: "sr-only"
    }, describedByText), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)("kohler-video-wrapper", classes.videoWrapper)
    }, posterImages && /* @__PURE__ */ /*#__PURE__*/ react.createElement("picture", null, posterImages.map((source, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("source", {
            key: "".concat(source.src, "-").concat(index),
            ...source
        })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("img", {
        src: poster,
        alt: "",
        className: classes.posterImage
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("video", {
        ref: videoRef,
        className: (0,clsx/* default */.Z)("kohler-video-root", className),
        autoPlay: false,
        controls: decorative ? false : controls,
        loop,
        muted,
        playsInline,
        poster,
        src: hasSources ? void 0 : src,
        style,
        ...a11yProps,
        ...rest
    }, hasSources && (sources === null || sources === void 0 ? void 0 : sources.map((s)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("source", {
            key: s.src,
            ...s
        }))), captions && !decorative && /* @__PURE__ */ /*#__PURE__*/ react.createElement("track", {
        kind: "captions",
        src: captions.src,
        srcLang: captions.srclang,
        label: captions.label,
        ...captions.default ? {
            default: true
        } : {}
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Video/Video.mjs





const Video = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { src , sources , poster , posterImages , controls =true , autoPlay =false , loop =false , muted =false , playsInline =true , className , width ="100%" , height ="100%" , objectFit ="cover" , objectPosition ="center" , position ="relative" , autoplayInView =true , forceAttributes =true , captions , decorative =false , describedByText , left , right , top , bottom , zIndex =1 , ...rest } = props;
    if (autoplayInView) {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(ClientAutoplayVideo, {
            sources,
            src,
            loop,
            muted,
            controls,
            describedByText,
            poster,
            posterImages,
            style: {
                position,
                width,
                height,
                objectFit,
                objectPosition,
                left,
                right,
                top,
                bottom,
                zIndex
            },
            ...rest
        });
    }
    const classNames = (0,clsx/* default */.Z)("kohler-video-root", className, classes.video);
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,react.useEffect)(()=>{
        if (!forceAttributes) return;
        const el = innerRef.current;
        if (!el) return;
        const toggleAttr = (name, on)=>{
            if (on) el.setAttribute(name, "");
            else el.removeAttribute(name);
        };
        toggleAttr("muted", muted);
        toggleAttr("controls", controls);
        toggleAttr("autoplay", autoPlay);
        toggleAttr("loop", loop);
        toggleAttr("playsinline", playsInline);
    }, [
        forceAttributes,
        muted,
        controls,
        autoPlay,
        loop,
        playsInline
    ]);
    const descId = describedByText ? "video-desc-" + Math.random().toString(36).slice(2) : void 0;
    const hasSources = Array.isArray(sources) && sources.length > 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, describedByText && /* @__PURE__ */ /*#__PURE__*/ react.createElement("span", {
        id: descId,
        className: "sr-only"
    }, describedByText), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)("kohler-video-wrapper", classes.videoWrapper)
    }, posterImages && /* @__PURE__ */ /*#__PURE__*/ react.createElement("picture", null, posterImages.map((source)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("source", {
            key: source.src,
            ...source
        })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("img", {
        src: poster,
        alt: "",
        className: classes.posterImage
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("video", {
        ref: innerRef,
        className: classNames,
        src: hasSources ? void 0 : src,
        poster,
        controls: decorative ? false : controls,
        autoPlay,
        loop,
        muted,
        playsInline,
        "aria-hidden": decorative || void 0,
        tabIndex: decorative ? -1 : void 0,
        "aria-describedby": describedByText ? descId : void 0,
        style: {
            position,
            width,
            height,
            objectFit,
            objectPosition,
            left,
            right,
            top,
            bottom,
            zIndex
        },
        ...rest
    }, hasSources && (sources === null || sources === void 0 ? void 0 : sources.map((source)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("source", {
            key: source.src,
            ...source
        }))), captions && /* @__PURE__ */ /*#__PURE__*/ react.createElement("track", {
        kind: "captions",
        src: captions.src,
        srcLang: captions.srclang,
        label: captions.label,
        ...captions.default ? {
            default: true
        } : {}
    }))));
});



/***/ }),

/***/ 29705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ VideoPlayer; }
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlayIcon.mjs
var PlayIcon = __webpack_require__(2722);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PauseIcon.mjs


const withoutBoundingBoxWidth = {
    large: 14,
    medium: 8,
    small: 8,
    xSmall: 6
};
const PauseIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12 22V8H11V22H12Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M19 22V8H18V22H19Z",
        fill: "currentColor"
    }));
};
PauseIcon.iconName = "PauseIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/Rewind10SecondsIcon.mjs


const Rewind10SecondsIcon_withoutBoundingBoxWidth = {
    large: 35,
    medium: 26,
    small: 18,
    xSmall: 15
};
const Rewind10SecondsIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : Rewind10SecondsIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.85199 9.92659C6.20573 4.98163 11.6976 2.1959 17.1785 3.3609C23.6611 4.73882 27.7992 11.111 26.4213 17.5936C25.2975 22.8807 20.7978 26.7156 15.5027 27.0739L15.2022 27.0905L15.2447 28.0896C21.1224 27.8397 26.159 23.6373 27.3995 17.8015C28.8922 10.7787 24.4092 3.87549 17.3864 2.38275C11.4793 1.12715 5.56098 4.10719 2.98894 9.41373L2.98926 4.69824L1.98926 4.69824V10.9267H8.21773L8.21773 9.92672L3.85199 9.92659Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0925 20.14C17.5925 20.14 18.0009 20.025 18.3175 19.795C18.6342 19.565 18.8809 19.2717 19.0575 18.915C19.2342 18.5584 19.3542 18.1667 19.4175 17.74C19.4809 17.3134 19.5125 16.9 19.5125 16.5C19.5125 16.1 19.4809 15.6867 19.4175 15.26C19.3542 14.8334 19.2342 14.4417 19.0575 14.085C18.8809 13.7284 18.6342 13.435 18.3175 13.205C18.0009 12.975 17.5925 12.86 17.0925 12.86C16.5925 12.86 16.1842 12.975 15.8675 13.205C15.5509 13.435 15.3042 13.7284 15.1275 14.085C14.9509 14.4417 14.8309 14.8334 14.7675 15.26C14.7042 15.6867 14.6725 16.1 14.6725 16.5C14.6725 16.9 14.7042 17.3134 14.7675 17.74C14.8309 18.1667 14.9509 18.5584 15.1275 18.915C15.3042 19.2717 15.5509 19.565 15.8675 19.795C16.1842 20.025 16.5925 20.14 17.0925 20.14ZM16.4675 18.975C16.6309 19.1184 16.8392 19.19 17.0925 19.19C17.3392 19.19 17.5459 19.1184 17.7125 18.975C17.8792 18.8317 18.0109 18.6384 18.1075 18.395C18.2042 18.1517 18.2725 17.8667 18.3125 17.54C18.3525 17.2134 18.3725 16.8667 18.3725 16.5C18.3725 16.1334 18.3525 15.7884 18.3125 15.465C18.2725 15.1417 18.2042 14.8567 18.1075 14.61C18.0109 14.3634 17.8792 14.1684 17.7125 14.025C17.5459 13.8817 17.3392 13.81 17.0925 13.81C16.8392 13.81 16.6309 13.8817 16.4675 14.025C16.3042 14.1684 16.1742 14.3634 16.0775 14.61C15.9809 14.8567 15.9125 15.1417 15.8725 15.465C15.8325 15.7884 15.8125 16.1334 15.8125 16.5C15.8125 16.8667 15.8325 17.2134 15.8725 17.54C15.9125 17.8667 15.9809 18.1517 16.0775 18.395C16.1742 18.6384 16.3042 18.8317 16.4675 18.975Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.2525 20V13H11.3225C11.2825 13.2134 11.1975 13.3934 11.0675 13.54C10.9375 13.6867 10.7809 13.8067 10.5975 13.9C10.4142 13.9934 10.2092 14.06 9.98252 14.1C9.75586 14.14 9.52252 14.16 9.28252 14.16V15.06H11.0025V20H12.2525Z",
        fill: "currentColor"
    }));
};
Rewind10SecondsIcon.iconName = "Rewind10SecondsIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/Forward10SecondsIcon.mjs


const Forward10SecondsIcon_withoutBoundingBoxWidth = {
    large: 37,
    medium: 26,
    small: 19,
    xSmall: 15
};
const Forward10SecondsIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : Forward10SecondsIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M26.0113 9.4468C23.4479 4.11958 17.5173 1.12455 11.5979 2.38275C4.57511 3.87549 0.0921015 10.7787 1.58485 17.8015C2.82528 23.6373 7.86189 27.8397 13.7396 28.0896L13.7821 27.0905L13.4816 27.0739C8.18655 26.7156 3.68679 22.8807 2.56299 17.5936C1.18508 11.111 5.32323 4.73882 11.8058 3.3609C17.2866 2.19591 22.7784 4.98157 25.1322 9.92642L20.7824 9.92672V10.9267H27.0108V4.69824L26.0108 4.69824L26.0113 9.4468Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4676 20.14C16.9676 20.14 17.3759 20.025 17.6926 19.795C18.0092 19.565 18.2559 19.2717 18.4326 18.915C18.6092 18.5584 18.7292 18.1667 18.7926 17.74C18.8559 17.3134 18.8876 16.9 18.8876 16.5C18.8876 16.1 18.8559 15.6867 18.7926 15.26C18.7292 14.8334 18.6092 14.4417 18.4326 14.085C18.2559 13.7284 18.0092 13.435 17.6926 13.205C17.3759 12.975 16.9676 12.86 16.4676 12.86C15.9676 12.86 15.5592 12.975 15.2426 13.205C14.9259 13.435 14.6792 13.7284 14.5026 14.085C14.3259 14.4417 14.2059 14.8334 14.1426 15.26C14.0792 15.6867 14.0476 16.1 14.0476 16.5C14.0476 16.9 14.0792 17.3134 14.1426 17.74C14.2059 18.1667 14.3259 18.5584 14.5026 18.915C14.6792 19.2717 14.9259 19.565 15.2426 19.795C15.5592 20.025 15.9676 20.14 16.4676 20.14ZM15.8426 18.975C16.0059 19.1184 16.2142 19.19 16.4676 19.19C16.7142 19.19 16.9209 19.1184 17.0876 18.975C17.2542 18.8317 17.3859 18.6384 17.4826 18.395C17.5792 18.1517 17.6476 17.8667 17.6876 17.54C17.7276 17.2134 17.7476 16.8667 17.7476 16.5C17.7476 16.1334 17.7276 15.7884 17.6876 15.465C17.6476 15.1417 17.5792 14.8567 17.4826 14.61C17.3859 14.3634 17.2542 14.1684 17.0876 14.025C16.9209 13.8817 16.7142 13.81 16.4676 13.81C16.2142 13.81 16.0059 13.8817 15.8426 14.025C15.6792 14.1684 15.5492 14.3634 15.4526 14.61C15.3559 14.8567 15.2876 15.1417 15.2476 15.465C15.2076 15.7884 15.1876 16.1334 15.1876 16.5C15.1876 16.8667 15.2076 17.2134 15.2476 17.54C15.2876 17.8667 15.3559 18.1517 15.4526 18.395C15.5492 18.6384 15.6792 18.8317 15.8426 18.975Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.6276 20V13H10.6976C10.6576 13.2134 10.5726 13.3934 10.4426 13.54C10.3126 13.6867 10.1559 13.8067 9.97257 13.9C9.78923 13.9934 9.58423 14.06 9.35757 14.1C9.1309 14.14 8.89757 14.16 8.65757 14.16V15.06H10.3776V20H11.6276Z",
        fill: "currentColor"
    }));
};
Forward10SecondsIcon.iconName = "Forward10SecondsIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MuteIcon.mjs


const MuteIcon_withoutBoundingBoxWidth = {
    large: 39,
    medium: 29,
    small: 19,
    xSmall: 16
};
const MuteIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : MuteIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M0.5 9.3986L5.44133 9.3982L6.61255 10.3985L1.5 10.3981V19.6011L7.52837 19.6015L13.5 23.1241V16.281L14.5 17.135V24.8756L7.254 20.6011L0.5 20.6015V9.3986Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M13.5 6.87505V11.0206L14.5 11.8747V5.12455L9.82492 7.88179L10.6294 8.56886L13.5 6.87505Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M19.5808 16.2141L20.4501 16.9566C20.7137 16.358 20.86 15.6961 20.86 15.0001C20.86 12.9067 19.5365 11.1224 17.6806 10.4385L17.3071 11.4522C18.7506 11.9841 19.78 13.3719 19.78 15.0001C19.78 15.4247 19.71 15.8331 19.5808 16.2141Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M18.801 22.6027C19.2721 22.4291 19.7227 22.2129 20.148 21.9588L21.0091 22.6943C20.4383 23.0666 19.8236 23.3771 19.1744 23.6164L18.801 22.6027Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.978 19.1156L23.8103 19.8265C24.6787 18.4242 25.18 16.7707 25.18 15.0001C25.18 11.0459 22.68 7.67568 19.1744 6.38372L18.801 7.39741C21.8941 8.53737 24.1 11.5111 24.1 15.0001C24.1 16.5026 23.6909 17.9095 22.978 19.1156Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M20.2948 26.6574C21.4739 26.2229 22.569 25.6145 23.5488 24.8635L24.387 25.5794C23.2762 26.4612 22.0234 27.1717 20.6683 27.6711L20.2948 26.6574Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M26.2956 21.9491L27.1217 22.6546C28.6217 20.4793 29.5 17.8423 29.5 15.0001C29.5 9.18515 25.8236 4.22892 20.6683 2.32898L20.2948 3.34267C25.0377 5.09061 28.42 9.65034 28.42 15.0001C28.42 17.5744 27.6368 19.9659 26.2956 21.9491Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M1.44361 2.7952L0.795145 3.55644L28.5564 27.2049L29.2049 26.4437L1.44361 2.7952Z",
        fill: "currentColor"
    }));
};
MuteIcon.iconName = "MuteIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/UnMuteIcon.mjs


const UnMuteIcon_withoutBoundingBoxWidth = {
    large: 39,
    medium: 29,
    small: 19,
    xSmall: 16
};
const UnMuteIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : UnMuteIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M19.78 15.0001C19.78 13.3719 18.7506 11.9841 17.3071 11.4522L17.6806 10.4385C19.5365 11.1224 20.86 12.9067 20.86 15.0001C20.86 17.0934 19.5365 18.8777 17.6806 19.5616L17.3071 18.548C18.7506 18.016 19.78 16.6282 19.78 15.0001Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M19.1744 23.6164L18.801 22.6027C21.8941 21.4627 24.1 18.489 24.1 15.0001C24.1 11.5111 21.8941 8.53737 18.801 7.39741L19.1744 6.38372C22.68 7.67568 25.18 11.0459 25.18 15.0001C25.18 18.9542 22.68 22.3244 19.1744 23.6164Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M20.6683 27.6711L20.2948 26.6574C25.0377 24.9095 28.42 20.3498 28.42 15.0001C28.42 9.65034 25.0377 5.09061 20.2948 3.34267L20.6683 2.32898C25.8236 4.22892 29.5 9.18515 29.5 15.0001C29.5 20.815 25.8236 25.7712 20.6683 27.6711Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5 5.12455V24.8756L7.254 20.6011L0.5 20.6015V9.3986L7.254 9.39806L14.5 5.12455ZM13.5 23.1241V6.87505L7.52837 10.3986L1.5 10.3981V19.6011L7.52837 19.6015L13.5 23.1241Z",
        fill: "currentColor"
    }));
};
UnMuteIcon.iconName = "UnMuteIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/TriggerFullScreenIcon.mjs


const TriggerFullScreenIcon_withoutBoundingBoxWidth = {
    large: 22,
    medium: 17,
    small: 11,
    xSmall: 9
};
const TriggerFullScreenIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : TriggerFullScreenIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6985 16.2919L13.4056 16.999L8.46951 21.9341L12.7302 21.9341V22.9341H6.7793L6.7793 16.9832H7.7793L7.77937 21.2101L12.6985 16.2919ZM22.3215 6.76526V12.7162H21.3215L21.3203 8.48826L16.1524 13.6575L15.4453 12.9504L20.6303 7.76426L16.3706 7.76526V6.76526H22.3215Z",
        fill: "currentColor"
    }));
};
TriggerFullScreenIcon.iconName = "TriggerFullScreenIcon";


// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/PhotoOverlay/PhotoOverlay.mjs + 2 modules
var PhotoOverlay = __webpack_require__(3346);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/VideoPlayer/VideoPlayer.module.css.mjs
var classes = {
    "videoWrapper": "_9E7yp",
    "video": "RtGAn",
    "videoOverlayIcon": "fL19D",
    "videoControlsIcon": "YQafc",
    "videoControlsContainer": "HfuXK",
    "videoControlsPlayback": "C3QfO",
    "videoControlsVolume": "-gbIP",
    "videoControlRangeContainer": "_3r-Zs",
    "videoControlRange": "rAaFo",
    "videoControlRangeProgress": "z-i95",
    "videoControlOverlay": "rWoPA"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/VideoPlayer/VideoPlayer.mjs
"use client";







const VideoPlayer = (props)=>{
    const { className , sources , poster , autoPlay =false , muted =false , showPlayButton =false , displayControlsOnHover =true , ...rest } = props;
    const videoRef = (0,react.useRef)(null);
    const [isPlaying, setIsPlaying] = (0,react.useState)(autoPlay);
    const [isMuted, setIsMuted] = (0,react.useState)(muted);
    const [isFullscreen, setIsFullscreen] = (0,react.useState)(false);
    const [currentTime, setCurrentTime] = (0,react.useState)(0);
    const [duration, setDuration] = (0,react.useState)(0);
    const progress = currentTime / duration * 100;
    const togglePlay = ()=>{
        const video = videoRef.current;
        if (video) {
            if (isPlaying) {
                video.pause();
            } else {
                video.play();
            }
            setIsPlaying(!isPlaying);
        }
    };
    const toggleMute = ()=>{
        const video = videoRef.current;
        if (video) {
            video.muted = !isMuted;
            setIsMuted(!isMuted);
        }
    };
    (0,react.useEffect)(()=>{
        const video = videoRef.current;
        if (video) {
            video.addEventListener("loadedmetadata", ()=>{
                setDuration(video.duration);
            });
            video.addEventListener("timeupdate", ()=>{
                setCurrentTime(video.currentTime);
            });
            video.addEventListener("ended", ()=>{
                setIsPlaying(false);
            });
        }
    }, []);
    const toggleFullscreen = ()=>{
        const video = videoRef.current;
        if (video) {
            if (!isFullscreen) {
                video.requestFullscreen();
            } else {
                document.exitFullscreen();
            }
            setIsFullscreen(!isFullscreen);
        }
    };
    const handleVideoProgressUpdate = (e)=>{
        const video = videoRef.current;
        if (video) {
            const newPercentage = parseFloat(e.target.value);
            const seekTime = newPercentage * duration;
            video.currentTime = seekTime;
        }
    };
    const handleVideoRewind = ()=>{
        const video = videoRef.current;
        if (video) {
            video.currentTime = currentTime - 10;
        }
    };
    const handleVideoForward = ()=>{
        const video = videoRef.current;
        if (video) {
            video.currentTime = currentTime + 10;
        }
    };
    const classNames = (0,clsx/* default */.Z)(classes.videoWrapper, className, "kohler-video-player-root");
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames
    }, !isPlaying && showPlayButton && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "button",
        type: "button",
        onClick: togglePlay,
        className: classes.videoOverlayIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PlayIcon/* PlayIcon */.o, null)), /* @__PURE__ */ /*#__PURE__*/ react.createElement("video", {
        ref: videoRef,
        poster,
        autoPlay: isPlaying,
        muted: isMuted,
        className: classes.video,
        onClick: togglePlay,
        ...rest
    }, sources && sources.map((source, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("source", {
            key: index,
            src: source.src,
            type: source.type
        }))), displayControlsOnHover && /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhotoOverlay/* PhotoOverlay */.c, {
        className: classes.videoControlOverlay,
        direction: "bottom-top",
        opacity: 30
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: classes.videoControlsContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: classes.videoControlsPlayback
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: togglePlay
    }, isPlaying ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(PauseIcon, {
        className: classes.videoControlsIcon,
        "aria-label": "pause video"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(PlayIcon/* PlayIcon */.o, {
        className: classes.videoControlsIcon,
        "aria-label": "play video"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: handleVideoRewind,
        "aria-label": "rewind 10 seconds"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Rewind10SecondsIcon, {
        className: classes.videoControlsIcon,
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: handleVideoForward,
        "aria-label": "forward 10 seconds"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Forward10SecondsIcon, {
        className: classes.videoControlsIcon,
        withBoundingBox: false
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: classes.videoControlRangeContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("input", {
        type: "range",
        min: "0",
        max: "1",
        step: "0.01",
        value: progress || 0,
        onChange: handleVideoProgressUpdate,
        className: classes.videoControlRange,
        "aria-label": "video progress control"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classes.videoControlRangeProgress,
        style: {
            width: "".concat(progress, "%")
        }
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: classes.videoControlsVolume
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: toggleMute
    }, isMuted ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(MuteIcon, {
        className: classes.videoControlsIcon,
        withBoundingBox: false,
        "aria-label": "unmute video"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(UnMuteIcon, {
        className: classes.videoControlsIcon,
        withBoundingBox: false,
        "aria-label": "mute video"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: toggleFullscreen,
        "aria-label": "toggle fullscreen"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(TriggerFullScreenIcon, {
        className: classes.videoControlsIcon,
        withBoundingBox: false
    }))))));
};



/***/ }),

/***/ 3346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ PhotoOverlay; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/PhotoOverlay/PhotoOverlay.module.css.mjs
var classes = {
    "root": "gVsis"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/PhotoOverlay/PhotoOverlay.utils.mjs
const photoOverlayDirectionMap = {
    "bottom-top": "0deg",
    "top-bottom": "180deg",
    "left-right": "90deg",
    "right-left": "270deg",
    tint: ""
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/PhotoOverlay/PhotoOverlay.mjs






const PhotoOverlay = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , opacity , direction , style , ...rest } = props;
    const deg = direction ? photoOverlayDirectionMap[direction] : "tint";
    const bg = direction === "tint" ? "rgb(0 0 0 / ".concat(opacity !== null && opacity !== void 0 ? opacity : 0, "%)") : "linear-gradient(".concat(deg, ", rgb(0 0 0 / ").concat(opacity, "%) 0%, rgb(0 0 0 / 0%) 100%)");
    const classNames = (0,clsx/* default */.Z)("kohler-photo-overlay-root", className, classes.root);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        style: {
            "--photo-overlay-bg": bg,
            ...style
        },
        ...rest
    });
});



/***/ }),

/***/ 72905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.module.css.mjs
var classes = {
    "root": "dTpXP",
    "typographySizeH1": "_4VhMK",
    "typographySizeH2": "rhd5n",
    "typographySizeH3": "-XwLj",
    "typographySizeH4": "QtmrM",
    "typographySizeH5": "x-xNT",
    "typographySizeH6": "XCPqO",
    "typographySizeSmall": "_6Ovd0",
    "typographySizeMedium": "zJ-0f",
    "typographySizeLarge": "HDkX-",
    "typographySizeTitleL": "fCgbw",
    "typographySizeTitleM": "_8sPbT",
    "typographySizeTitleS": "vcyFX",
    "typographySizeLabelRegularXL": "jgb0M",
    "typographySizeLabelRegularL": "N6j3c",
    "typographySizeLabelRegularM": "D51Nl",
    "typographySizeLabelRegularS": "B6qqv",
    "typographySizeLabelRegularXS": "h5KJY",
    "typographySizeLabelMediumXL": "S4iBM",
    "typographySizeLabelMediumL": "_3UgoI",
    "typographySizeLabelMediumM": "liVBY",
    "typographySizeLabelMediumS": "bBUuT",
    "typographySizeLabelMediumXS": "Kil4C",
    "typographySizeLabelBoldL": "p1yGT",
    "typographySizeLabelBoldM": "konty",
    "typographySizeLabelBoldS": "_5VBYq",
    "typographySizeButtonXL": "v6t3t",
    "typographySizeButtonL": "UUATQ",
    "typographySizeButtonM": "_358uw",
    "typographySizeButtonS": "faKTj",
    "typographySizeTagM": "OLsuS",
    "typographySizeTagS": "M6Ttk",
    "typographySizeOverline": "bE0N7",
    "typographySizeCaptionM": "VwuCD",
    "typographySizeCaptionS": "_8LxoF",
    "typographySizeDisplayL": "Y-1s4",
    "typographySizeDisplayM": "bLMPG",
    "typographySizeNavigationBrandSwitcher": "TjkF6",
    "typographySizeNavigationOverlayTitle": "hR1uu",
    "typographySizeNavigationOverlayItemL": "Ni38f",
    "typographySizeNavigationOverlayItemM": "kZM2K",
    "typographySizeNavigationOverlayItemS": "_6C-0Q",
    "typographySizeNavigationOverlayItemMRegular": "NyMGn",
    "typographySizeNavigationOverlayItemMBold": "NWnLl",
    "typographySizeNavigationOverlayCategory": "QBa-z",
    "typographySizeNavigationL": "ba4A8",
    "typographySizeNavigationM": "pRuiV",
    "typographySizeNavigationS": "C7jwk",
    "typographySizeNavigationSelected": "_0AmT3",
    "typographySizeNavigationUnselected": "Y5FB-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.utils.mjs

const typographySizeClasses = {
    "display-l": classes.typographySizeDisplayL,
    "display-m": classes.typographySizeDisplayM,
    "paragraph-small": classes.typographySizeSmall,
    "paragraph-medium": classes.typographySizeMedium,
    "paragraph-large": classes.typographySizeLarge,
    h1: classes.typographySizeH1,
    h2: classes.typographySizeH2,
    h3: classes.typographySizeH3,
    h4: classes.typographySizeH4,
    h5: classes.typographySizeH5,
    h6: classes.typographySizeH6,
    "title-l": classes.typographySizeTitleL,
    "title-m": classes.typographySizeTitleM,
    "title-s": classes.typographySizeTitleS,
    "label-regular-xl": classes.typographySizeLabelRegularXL,
    "label-regular-l": classes.typographySizeLabelRegularL,
    "label-regular-m": classes.typographySizeLabelRegularM,
    "label-regular-s": classes.typographySizeLabelRegularS,
    "label-regular-xs": classes.typographySizeLabelRegularXS,
    "label-medium-xl": classes.typographySizeLabelMediumXL,
    "label-medium-l": classes.typographySizeLabelMediumL,
    "label-medium-m": classes.typographySizeLabelMediumM,
    "label-medium-s": classes.typographySizeLabelMediumS,
    "label-medium-xs": classes.typographySizeLabelMediumXS,
    "label-bold-l": classes.typographySizeLabelBoldL,
    "label-bold-m": classes.typographySizeLabelBoldM,
    "label-bold-s": classes.typographySizeLabelBoldS,
    "button-xl": classes.typographySizeButtonXL,
    "button-l": classes.typographySizeButtonL,
    "button-m": classes.typographySizeButtonM,
    "button-s": classes.typographySizeButtonS,
    "caption-m": classes.typographySizeCaptionM,
    "caption-s": classes.typographySizeCaptionS,
    "tag-m": classes.typographySizeTagM,
    "tag-s": classes.typographySizeTagS,
    overline: classes.typographySizeOverline,
    "navigation-brand-switcher": classes.typographySizeNavigationBrandSwitcher,
    "navigation-overlay-title": classes.typographySizeNavigationOverlayTitle,
    "navigation-overlay-item-l": classes.typographySizeNavigationOverlayItemL,
    "navigation-overlay-item-m": classes.typographySizeNavigationOverlayItemM,
    "navigation-overlay-item-s": classes.typographySizeNavigationOverlayItemS,
    "navigation-overlay-item-m-regular": classes.typographySizeNavigationOverlayItemMRegular,
    "navigation-overlay-item-m-bold": classes.typographySizeNavigationOverlayItemMBold,
    "navigation-overlay-category": classes.typographySizeNavigationOverlayCategory,
    "navigation-l": classes.typographySizeNavigationL,
    "navigation-m": classes.typographySizeNavigationM,
    "navigation-s": classes.typographySizeNavigationS,
    "navigation-selected": classes.typographySizeNavigationSelected,
    "navigation-unselected": classes.typographySizeNavigationUnselected
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs






const Typography = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { size ="paragraph-medium" , inherit , className , component , children , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.root, className, size && typographySizeClasses[size], "dsm-typography-".concat(typeof component === "string" ? component : "p", "-").concat(size).concat(rest.mod ? "-".concat(rest.mod) : ""));
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component: component || "p",
        ref,
        ...rest,
        ...{
            "data-inherit": inherit || void 0
        }
    }, children);
});



/***/ }),

/***/ 55268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ Calendar; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(18657);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DateInput.utils.mjs
var DateInput_utils = __webpack_require__(85904);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DatesProvider/use-dates-context.mjs + 1 modules
var use_dates_context = __webpack_require__(69573);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Day/Day.utils.mjs + 1 modules
var Day_utils = __webpack_require__(35867);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/LevelsGroup/LevelsGroup.module.css.mjs
var classes = {
    "levelsGroup": "cT9NJ"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/LevelsGroup/LevelsGroup.mjs





const LevelsGroup = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , ...others } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(className, classes.levelsGroup),
        ...others
    });
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowLeftIcon.mjs
var ArrowLeftIcon = __webpack_require__(90751);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightIcon.mjs
var ArrowRightIcon = __webpack_require__(51782);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/CalendarHeader/CalendarHeader.module.css.mjs
var CalendarHeader_module_css_classes = {
    "calendarHeader": "L6bnU",
    "calendarHeaderLabel": "SdH5x",
    "calendarHeaderControlsWrapper": "rNwsu"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/CalendarHeader/CalendarHeader.mjs








const CalendarHeader = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , onNext , onPrevious , onLevelClick , label , nextLabel ="next" , previousLabel ="previous" , nextDisabled =false , previousDisabled =false , hasNextLevel =true , levelControlAriaLabel , withNext =true , withPrevious =true , __preventFocus , __stopPropagation , ...rest } = props;
    const preventFocus = __preventFocus ? (event)=>event.preventDefault() : void 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(className, CalendarHeader_module_css_classes.calendarHeader),
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-l",
        className: CalendarHeader_module_css_classes.calendarHeaderLabel,
        component: hasNextLevel ? "button" : "div",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        onClick: hasNextLevel ? onLevelClick : void 0,
        onMouseDown: hasNextLevel ? preventFocus : void 0,
        disabled: !hasNextLevel,
        "data-static": !hasNextLevel || void 0,
        "aria-live": "polite",
        "aria-label": levelControlAriaLabel,
        tabIndex: __preventFocus || !hasNextLevel ? -1 : 0,
        "data-kohler-stop-propagation": __stopPropagation || void 0
    }, label), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: CalendarHeader_module_css_classes.calendarHeaderControlsWrapper
    }, withPrevious && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "data-direction": "previous",
        "aria-label": previousLabel,
        onClick: onPrevious,
        onMouseDown: preventFocus,
        disabled: previousDisabled,
        "data-disabled": previousDisabled || void 0,
        tabIndex: __preventFocus || previousDisabled ? -1 : 0,
        "data-kohler-stop-propagation": __stopPropagation || void 0,
        textColor: previousDisabled ? "var(--content-action-inactive)" : "var(--content-secondary)"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon/* ArrowLeftIcon */.Y, {
        "data-direction": "previous",
        size: "small",
        withBoundingBox: false
    })), withNext && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "data-direction": "next",
        "aria-label": nextLabel,
        onClick: onNext,
        onMouseDown: preventFocus,
        disabled: nextDisabled,
        "data-disabled": nextDisabled || void 0,
        tabIndex: __preventFocus || nextDisabled ? -1 : 0,
        "data-kohler-stop-propagation": __stopPropagation || void 0,
        textColor: nextDisabled ? "var(--content-action-inactive)" : "var(--content-secondary)"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
        size: "small",
        withBoundingBox: false,
        "data-direction": "next"
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Day/Day.module.css.mjs
var Day_module_css_classes = {
    "day": "H0seq"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Day/Day.mjs









const Day = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , style , date , disabled , weekend , outside , selected , renderDay , hidden , isStatic , ...rest } = props;
    const ctx = (0,use_dates_context/* useDatesContext */.e)();
    return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-s",
        className: (0,clsx/* default */.Z)(className, Day_module_css_classes.day),
        style: {
            ...style
        },
        component: isStatic ? "div" : "button",
        type: isStatic ? void 0 : "button",
        ref,
        disabled,
        "aria-disabled": disabled || void 0,
        "aria-selected": !disabled && selected || void 0,
        "data-today": dayjs_min_default()(date).isSame((0,Day_utils/* shiftTimezone */.w)("add", /* @__PURE__ */ new Date(), ctx.getTimezone()), "day") || void 0,
        "data-hidden": hidden || void 0,
        "data-disabled": disabled || void 0,
        "data-weekend": !disabled && !outside && weekend || void 0,
        "data-outside": !disabled && outside || void 0,
        "data-selected": !disabled && selected || void 0,
        "data-static": isStatic || void 0,
        ...rest
    }, (renderDay === null || renderDay === void 0 ? void 0 : renderDay(date)) || date.getDate()));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/WeekdaysRow/WeekdaysRow.module.css.mjs
var WeekdaysRow_module_css_classes = {
    "weekdaysRow": "WDBAj",
    "weekday": "KGjl9"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/WeekdaysRow/WeekdaysRow.utils.mjs

function getWeekdayNames(param) {
    let { locale , format ="dd" , firstDayOfWeek =1  } = param;
    const baseDate = dayjs_min_default()().day(firstDayOfWeek);
    const labels = [];
    for(let i = 0; i < 7; i += 1){
        if (typeof format === "string") {
            labels.push(dayjs_min_default()(baseDate).add(i, "days").locale(locale).format(format));
        } else {
            labels.push(format(dayjs_min_default()(baseDate).add(i, "days").toDate()));
        }
    }
    return labels;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/WeekdaysRow/WeekdaysRow.mjs










const WeekdaysRow = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , locale , firstDayOfWeek , weekdayFormat , cellComponent ="th" , ...rest } = props;
    const ctx = (0,use_dates_context/* useDatesContext */.e)();
    const weekdays = getWeekdayNames({
        locale: ctx.getLocale(locale),
        format: weekdayFormat,
        firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek)
    }).map((weekday, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: cellComponent,
            key: index,
            size: "label-regular-s",
            textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
            paddingBlock: 5,
            scope: "col",
            className: WeekdaysRow_module_css_classes.weekday
        }, weekday));
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(className, WeekdaysRow_module_css_classes.weekdaysRow),
        component: "tr",
        ref,
        ...rest
    }, weekdays);
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Month/Month.module.css.mjs
var Month_module_css_classes = {
    "month": "XpOy6",
    "tableRow": "Yq4Ex"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Month/Month.utils.mjs

function isSameMonth(date, comparison) {
    return date.getFullYear() === comparison.getFullYear() && date.getMonth() === comparison.getMonth();
}
function isBeforeMaxDate(date, maxDate) {
    return maxDate instanceof Date ? dayjs_min_default()(date).isBefore(dayjs_min_default()(maxDate).add(1, "day"), "day") : true;
}
function isAfterMinDate(date, minDate) {
    return minDate instanceof Date ? dayjs_min_default()(date).isAfter(dayjs_min_default()(minDate).subtract(1, "day"), "day") : true;
}
function getStartOfWeek(date) {
    let firstDayOfWeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const value = new Date(date);
    while(value.getDay() !== firstDayOfWeek){
        value.setDate(value.getDate() - 1);
    }
    return value;
}
function getMonthDays(param) {
    let { month , firstDayOfWeek =1 , consistentWeeks  } = param;
    const currentMonth = month.getMonth();
    const startOfMonth = new Date(month.getFullYear(), currentMonth, 1);
    const endOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
    const endDate = getEndOfWeek(endOfMonth, firstDayOfWeek);
    const date = getStartOfWeek(startOfMonth, firstDayOfWeek);
    const weeks = [];
    while(date <= endDate){
        const days = [];
        for(let i = 0; i < 7; i += 1){
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        weeks.push(days);
    }
    if (consistentWeeks && weeks.length < 6) {
        const lastWeek = weeks[weeks.length - 1];
        const lastDay = lastWeek[lastWeek.length - 1];
        const nextDay = new Date(lastDay);
        nextDay.setDate(nextDay.getDate() + 1);
        while(weeks.length < 6){
            const days1 = [];
            for(let i1 = 0; i1 < 7; i1 += 1){
                days1.push(new Date(nextDay));
                nextDay.setDate(nextDay.getDate() + 1);
            }
            weeks.push(days1);
        }
    }
    return weeks;
}
function getEndOfWeek(date) {
    let firstDayOfWeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const value = new Date(date);
    const lastDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
    while(value.getDay() !== lastDayOfWeek){
        value.setDate(value.getDate() + 1);
    }
    return value;
}
function getDateInTabOrder(dates, minDate, maxDate, getDateControlProps, excludeDate, hideOutsideDates, month) {
    const enabledDates = dates.flat().filter((date)=>{
        var ref;
        return isBeforeMaxDate(date, maxDate) && isAfterMinDate(date, minDate) && !(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate(date)) && !(getDateControlProps === null || getDateControlProps === void 0 ? void 0 : (ref = getDateControlProps(date)) === null || ref === void 0 ? void 0 : ref.disabled) && (!hideOutsideDates || isSameMonth(date, month));
    });
    const selectedDate = enabledDates.find((date)=>{
        var ref;
        return getDateControlProps === null || getDateControlProps === void 0 ? void 0 : (ref = getDateControlProps(date)) === null || ref === void 0 ? void 0 : ref.selected;
    });
    if (selectedDate) {
        return selectedDate;
    }
    const currentDate = enabledDates.find((date)=>dayjs_min_default()().isSame(date, "date"));
    if (currentDate) {
        return currentDate;
    }
    return enabledDates[0];
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Month/Month.mjs












const Month = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , locale , firstDayOfWeek , weekdayFormat , month , weekendDays , getDayProps , excludeDate , minDate , maxDate , renderDay , hideOutsideDates , hideWeekdays , getDayAriaLabel , isStatic , focusOutsideMonthDays , __getDayRef , __onDayKeyDown , __onDayClick , __onDayMouseEnter , __preventFocus , __stopPropagation , ...others } = props;
    const ctx = (0,use_dates_context/* useDatesContext */.e)();
    const dates = getMonthDays({
        month,
        firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek),
        consistentWeeks: ctx.consistentWeeks
    });
    const dateInTabOrder = getDateInTabOrder(dates, minDate, maxDate, getDayProps, excludeDate, hideOutsideDates, month);
    const rows = dates.map((row, rowIndex)=>{
        const cells = row.map((date, cellIndex)=>{
            const outside = !isSameMonth(date, month);
            const isToday = dayjs_min_default()(date).isSame((0,Day_utils/* shiftTimezone */.w)("add", /* @__PURE__ */ new Date(), ctx.getTimezone()), "day");
            const ariaText = (getDayAriaLabel === null || getDayAriaLabel === void 0 ? void 0 : getDayAriaLabel(date)) || dayjs_min_default()(date).locale(locale || ctx.locale).format("dddd, D MMMM YYYY");
            const dayProps = getDayProps === null || getDayProps === void 0 ? void 0 : getDayProps(date);
            const isDateInTabOrder = dayjs_min_default()(date).isSame(dateInTabOrder, "date");
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement("td", {
                key: date.toString(),
                className: Month_module_css_classes.monthCell
            }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Day, {
                "data-kohler-stop-propagation": __stopPropagation || void 0,
                renderDay,
                date,
                weekend: ctx.getWeekendDays(weekendDays).includes(date.getDay()),
                outside: focusOutsideMonthDays ? false : outside,
                hidden: hideOutsideDates ? outside : false,
                "aria-label": isToday ? "Today, ".concat(ariaText) : ariaText,
                "aria-current": isToday ? "date" : void 0,
                isStatic,
                disabled: (excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate(date)) || !isBeforeMaxDate(date, maxDate) || !isAfterMinDate(date, minDate),
                ref: (node)=>{
                    return __getDayRef === null || __getDayRef === void 0 ? void 0 : __getDayRef(rowIndex, cellIndex, node);
                },
                ...dayProps,
                onKeyDown: (event)=>{
                    var ref;
                    dayProps === null || dayProps === void 0 ? void 0 : (ref = dayProps.onKeyDown) === null || ref === void 0 ? void 0 : ref.call(dayProps, event);
                    __onDayKeyDown === null || __onDayKeyDown === void 0 ? void 0 : __onDayKeyDown(event, {
                        rowIndex,
                        cellIndex,
                        date
                    });
                },
                onMouseEnter: (event)=>{
                    var ref;
                    dayProps === null || dayProps === void 0 ? void 0 : (ref = dayProps.onMouseEnter) === null || ref === void 0 ? void 0 : ref.call(dayProps, event);
                    __onDayMouseEnter === null || __onDayMouseEnter === void 0 ? void 0 : __onDayMouseEnter(event, date);
                },
                onClick: (event)=>{
                    var ref;
                    dayProps === null || dayProps === void 0 ? void 0 : (ref = dayProps.onClick) === null || ref === void 0 ? void 0 : ref.call(dayProps, event);
                    __onDayClick === null || __onDayClick === void 0 ? void 0 : __onDayClick(event, date);
                },
                onMouseDown: (event)=>{
                    var ref;
                    dayProps === null || dayProps === void 0 ? void 0 : (ref = dayProps.onMouseDown) === null || ref === void 0 ? void 0 : ref.call(dayProps, event);
                    if (__preventFocus) {
                        event.preventDefault();
                    }
                },
                tabIndex: __preventFocus || !isDateInTabOrder ? -1 : 0
            }));
        });
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("tr", {
            key: rowIndex,
            className: Month_module_css_classes.tableRow
        }, cells);
    });
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "table",
        className: (0,clsx/* default */.Z)(className, Month_module_css_classes.month),
        ref,
        role: "grid",
        ...others
    }, !hideWeekdays && /* @__PURE__ */ /*#__PURE__*/ react.createElement("thead", null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(WeekdaysRow, {
        locale,
        firstDayOfWeek,
        weekdayFormat
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("tbody", null, rows));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/MonthLevel/MonthLevel.mjs








const MonthLevel = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { month , locale , firstDayOfWeek , weekdayFormat , weekendDays , getDayProps , excludeDate , minDate , maxDate , renderDay , hideOutsideDates , focusOutsideMonthDays , hideWeekdays , getDayAriaLabel , __getDayRef , __onDayKeyDown , __onDayClick , __onDayMouseEnter , __preventFocus , __stopPropagation , onNext , onPrevious , onLevelClick , nextDisabled , previousDisabled , hasNextLevel , levelControlAriaLabel , withNext , withPrevious , monthLabelFormat ="MMMM YYYY" , isStatic , nextLabel , previousLabel , ...rest } = props;
    const ctx = (0,use_dates_context/* useDatesContext */.e)();
    const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !dayjs_min_default()(month).endOf("month").isBefore(maxDate) : false;
    const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !dayjs_min_default()(month).startOf("month").isAfter(minDate) : false;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        "data-month-level": true,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CalendarHeader, {
        label: typeof monthLabelFormat === "function" ? monthLabelFormat(month) : dayjs_min_default()(month).locale(locale || ctx.locale).format(monthLabelFormat),
        __preventFocus,
        __stopPropagation,
        onNext,
        onPrevious,
        onLevelClick,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel,
        levelControlAriaLabel,
        withNext,
        withPrevious,
        nextLabel,
        previousLabel
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Month, {
        month,
        locale,
        firstDayOfWeek,
        weekdayFormat,
        weekendDays,
        getDayProps,
        excludeDate,
        minDate,
        maxDate,
        renderDay,
        hideOutsideDates,
        hideWeekdays,
        focusOutsideMonthDays,
        getDayAriaLabel,
        __getDayRef,
        __onDayKeyDown,
        __onDayClick,
        __onDayMouseEnter,
        __preventFocus,
        __stopPropagation,
        isStatic
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/MonthLevelGroup/MonthLevelGroup.utils.mjs
function getNextIndex(param) {
    let { direction , levelIndex , rowIndex , cellIndex , size  } = param;
    switch(direction){
        case "up":
            if (levelIndex === 0 && rowIndex === 0) {
                return null;
            }
            if (rowIndex === 0) {
                return {
                    levelIndex: levelIndex - 1,
                    rowIndex: cellIndex <= size[levelIndex - 1][size[levelIndex - 1].length - 1] - 1 ? size[levelIndex - 1].length - 1 : size[levelIndex - 1].length - 2,
                    cellIndex
                };
            }
            return {
                levelIndex,
                rowIndex: rowIndex - 1,
                cellIndex
            };
        case "down":
            if (rowIndex === size[levelIndex].length - 1) {
                return {
                    levelIndex: levelIndex + 1,
                    rowIndex: 0,
                    cellIndex
                };
            }
            if (rowIndex === size[levelIndex].length - 2 && cellIndex >= size[levelIndex][size[levelIndex].length - 1]) {
                return {
                    levelIndex: levelIndex + 1,
                    rowIndex: 0,
                    cellIndex
                };
            }
            return {
                levelIndex,
                rowIndex: rowIndex + 1,
                cellIndex
            };
        case "left":
            if (levelIndex === 0 && rowIndex === 0 && cellIndex === 0) {
                return null;
            }
            if (rowIndex === 0 && cellIndex === 0) {
                return {
                    levelIndex: levelIndex - 1,
                    rowIndex: size[levelIndex - 1].length - 1,
                    cellIndex: size[levelIndex - 1][size[levelIndex - 1].length - 1] - 1
                };
            }
            if (cellIndex === 0) {
                return {
                    levelIndex,
                    rowIndex: rowIndex - 1,
                    cellIndex: size[levelIndex][rowIndex - 1] - 1
                };
            }
            return {
                levelIndex,
                rowIndex,
                cellIndex: cellIndex - 1
            };
        case "right":
            if (rowIndex === size[levelIndex].length - 1 && cellIndex === size[levelIndex][rowIndex] - 1) {
                return {
                    levelIndex: levelIndex + 1,
                    rowIndex: 0,
                    cellIndex: 0
                };
            }
            if (cellIndex === size[levelIndex][rowIndex] - 1) {
                return {
                    levelIndex,
                    rowIndex: rowIndex + 1,
                    cellIndex: 0
                };
            }
            return {
                levelIndex,
                rowIndex,
                cellIndex: cellIndex + 1
            };
        default:
            return {
                levelIndex,
                rowIndex,
                cellIndex
            };
    }
}
function focusOnNextFocusableControl(param) {
    let { controlsRef , direction , levelIndex , rowIndex , cellIndex , size  } = param;
    var ref, ref1, ref2;
    const nextIndex = getNextIndex({
        direction,
        size,
        rowIndex,
        cellIndex,
        levelIndex
    });
    if (!nextIndex) {
        return;
    }
    const controlToFocus = (ref = controlsRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref[nextIndex.levelIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[nextIndex.rowIndex]) === null || ref2 === void 0 ? void 0 : ref2[nextIndex.cellIndex];
    if (!controlToFocus) {
        return;
    }
    if (controlToFocus.disabled || controlToFocus.getAttribute("data-hidden") || controlToFocus.getAttribute("data-outside")) {
        focusOnNextFocusableControl({
            controlsRef,
            direction,
            levelIndex: nextIndex.levelIndex,
            cellIndex: nextIndex.cellIndex,
            rowIndex: nextIndex.rowIndex,
            size
        });
    } else {
        controlToFocus.focus();
    }
}
function getDirection(key) {
    switch(key){
        case "ArrowDown":
            return "down";
        case "ArrowUp":
            return "up";
        case "ArrowRight":
            return "right";
        case "ArrowLeft":
            return "left";
        default:
            return null;
    }
}
function getControlsSize(controlsRef) {
    var ref;
    return (ref = controlsRef.current) === null || ref === void 0 ? void 0 : ref.map((column)=>column.map((row)=>row.length));
}
function handleControlKeyDown(param) {
    let { controlsRef , levelIndex , rowIndex , cellIndex , event  } = param;
    const direction = getDirection(event.key);
    if (direction) {
        event.preventDefault();
        const size = getControlsSize(controlsRef);
        focusOnNextFocusableControl({
            controlsRef,
            direction,
            levelIndex,
            rowIndex,
            cellIndex,
            size
        });
    }
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/MonthLevelGroup/MonthLevelGroup.mjs






const MonthLevelGroup = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { month , locale , firstDayOfWeek , weekdayFormat , weekendDays , getDayProps , excludeDate , minDate , maxDate , renderDay , hideOutsideDates , focusOutsideMonthDays , hideWeekdays , getDayAriaLabel , __onDayClick , __onDayMouseEnter , __preventFocus , onNext , onPrevious , onLevelClick , nextLabel , previousLabel , nextDisabled , previousDisabled , hasNextLevel , numberOfColumns =1 , levelControlAriaLabel , monthLabelFormat , __stopPropagation , isStatic , ...rest } = props;
    const daysRefs = (0,react.useRef)([]);
    const months = Array(numberOfColumns).fill(0).map((_, monthIndex)=>{
        const currentMonth = dayjs_min_default()(month).add(monthIndex, "months").toDate();
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(MonthLevel, {
            key: monthIndex,
            month: currentMonth,
            withNext: monthIndex === numberOfColumns - 1,
            withPrevious: monthIndex === 0,
            monthLabelFormat,
            __stopPropagation,
            __onDayClick,
            __onDayMouseEnter,
            __onDayKeyDown: (event, payload)=>handleControlKeyDown({
                    levelIndex: monthIndex,
                    rowIndex: payload.rowIndex,
                    cellIndex: payload.cellIndex,
                    event,
                    controlsRef: daysRefs
                }),
            __getDayRef: (rowIndex, cellIndex, node)=>{
                if (!Array.isArray(daysRefs.current[monthIndex])) {
                    daysRefs.current[monthIndex] = [];
                }
                if (!Array.isArray(daysRefs.current[monthIndex][rowIndex])) {
                    daysRefs.current[monthIndex][rowIndex] = [];
                }
                daysRefs.current[monthIndex][rowIndex][cellIndex] = node;
            },
            levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentMonth) : levelControlAriaLabel,
            locale,
            firstDayOfWeek,
            weekdayFormat,
            weekendDays,
            getDayProps,
            excludeDate,
            minDate,
            maxDate,
            renderDay,
            hideOutsideDates,
            hideWeekdays,
            focusOutsideMonthDays,
            getDayAriaLabel,
            __preventFocus,
            onNext,
            onPrevious,
            onLevelClick,
            nextDisabled,
            previousDisabled,
            hasNextLevel,
            nextLabel: nextLabel || "Next month",
            previousLabel: previousLabel || "Previous month",
            isStatic
        });
    });
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(LevelsGroup, {
        ref,
        ...rest
    }, months);
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Calendar/Calendar.utils.mjs


function levelToNumber(level, fallback) {
    if (!level) {
        return fallback || 0;
    }
    return level === "month" ? 0 : level === "year" ? 1 : 2;
}
function levelNumberToLevel(levelNumber) {
    return levelNumber === 0 ? "month" : levelNumber === 1 ? "year" : "decade";
}
function clampLevel(level, minLevel, maxLevel) {
    return levelNumberToLevel((0,helpers/* clamp */.uZ)(levelToNumber(level, 0), levelToNumber(minLevel, 0), levelToNumber(maxLevel, 2)));
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Calendar/Calendar.mjs












const Calendar = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { maxLevel ="month" , minLevel ="month" , defaultLevel , level , onLevelChange , date , defaultDate , onDateChange , numberOfColumns , columnsToScroll , ariaLabels , className , firstDayOfWeek , weekdayFormat , weekendDays , getDayProps , excludeDate , renderDay , hideOutsideDates , hideWeekdays , getDayAriaLabel , focusOutsideMonthDays , monthLabelFormat , __onDayClick , __onDayMouseEnter , minDate , maxDate , locale , __preventFocus , __stopPropagation , onNextMonth , onPreviousMonth , isStatic , __timezoneApplied , ...others } = props;
    const [_level, setLevel] = (0,use_uncontrolled/* useUncontrolled */.C)({
        value: level ? clampLevel(level, minLevel, maxLevel) : void 0,
        defaultValue: defaultLevel ? clampLevel(defaultLevel, minLevel, maxLevel) : void 0,
        finalValue: clampLevel(void 0, minLevel, maxLevel),
        onChange: onLevelChange
    });
    const [_date, setDate] = (0,DateInput_utils/* useUncontrolledDates */.lV)({
        type: "default",
        value: date,
        defaultValue: defaultDate,
        onChange: onDateChange,
        applyTimezone: !__timezoneApplied
    });
    const ctx = (0,use_dates_context/* useDatesContext */.e)();
    const _columnsToScroll = columnsToScroll || numberOfColumns || 1;
    const currentDate = _date || (0,Day_utils/* shiftTimezone */.w)("add", /* @__PURE__ */ new Date(), ctx.getTimezone());
    const handleNextMonth = ()=>{
        const nextDate = dayjs_min_default()(currentDate).add(_columnsToScroll, "month").toDate();
        onNextMonth === null || onNextMonth === void 0 ? void 0 : onNextMonth(nextDate);
        setDate(nextDate);
    };
    const handlePreviousMonth = ()=>{
        const nextDate = dayjs_min_default()(currentDate).subtract(_columnsToScroll, "month").toDate();
        onPreviousMonth === null || onPreviousMonth === void 0 ? void 0 : onPreviousMonth(nextDate);
        setDate(nextDate);
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        "data-calendar": true,
        className: (0,clsx/* default */.Z)(className, "kohler-calendar-root"),
        ...others
    }, _level === "month" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MonthLevelGroup, {
        month: currentDate,
        minDate,
        maxDate,
        firstDayOfWeek,
        weekdayFormat,
        weekendDays,
        getDayProps,
        excludeDate,
        renderDay,
        hideOutsideDates,
        hideWeekdays,
        focusOutsideMonthDays,
        getDayAriaLabel,
        onNext: handleNextMonth,
        onPrevious: handlePreviousMonth,
        hasNextLevel: maxLevel !== "month",
        onLevelClick: ()=>setLevel("year"),
        numberOfColumns,
        locale,
        levelControlAriaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.monthLevelControl,
        nextLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.nextMonth,
        previousLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.previousMonth,
        monthLabelFormat,
        __onDayClick,
        __onDayMouseEnter,
        __preventFocus,
        __stopPropagation,
        isStatic
    }));
});



/***/ }),

/***/ 85904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M2": function() { return /* binding */ pickCalendarProps; },
/* harmony export */   "Rp": function() { return /* binding */ isDateValid; },
/* harmony export */   "lV": function() { return /* binding */ useUncontrolledDates; },
/* harmony export */   "oH": function() { return /* binding */ assignTime; },
/* harmony export */   "xv": function() { return /* binding */ dateStringParser; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_hooks_use_uncontrolled_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18657);
/* harmony import */ var _DatesProvider_use_dates_context_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69573);
/* harmony import */ var _Day_Day_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35867);






const getEmptyValue = (type)=>type === "range" ? [
        null,
        null
    ] : type === "multiple" ? [] : null;
function useUncontrolledDates(param) {
    let { type , value , defaultValue , onChange , applyTimezone =true  } = param;
    const storedType = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(type);
    const ctx = (0,_DatesProvider_use_dates_context_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useDatesContext */ .e)();
    const [_value, _setValue, controlled] = (0,_utils_hooks_use_uncontrolled_mjs__WEBPACK_IMPORTED_MODULE_3__/* .useUncontrolled */ .C)({
        value: (0,_Day_Day_utils_mjs__WEBPACK_IMPORTED_MODULE_4__/* .shiftTimezone */ .w)("add", value, ctx.getTimezone(), !applyTimezone),
        defaultValue: (0,_Day_Day_utils_mjs__WEBPACK_IMPORTED_MODULE_4__/* .shiftTimezone */ .w)("add", defaultValue, ctx.getTimezone(), !applyTimezone),
        finalValue: getEmptyValue(type),
        onChange: (newDate)=>{
            onChange === null || onChange === void 0 ? void 0 : onChange((0,_Day_Day_utils_mjs__WEBPACK_IMPORTED_MODULE_4__/* .shiftTimezone */ .w)("remove", newDate, ctx.getTimezone(), !applyTimezone));
        }
    });
    let _finalValue = _value;
    if (storedType.current !== type) {
        storedType.current = type;
        if (value === void 0) {
            _finalValue = defaultValue !== void 0 ? defaultValue : getEmptyValue(type);
            _setValue(_finalValue);
        }
    }
    return [
        _finalValue,
        _setValue,
        controlled
    ];
}
function dateStringParser(dateString, timezone) {
    if (dateString === null) {
        return null;
    }
    const date = (0,_Day_Day_utils_mjs__WEBPACK_IMPORTED_MODULE_4__/* .shiftTimezone */ .w)("add", new Date(dateString), timezone);
    if (Number.isNaN(date.getTime()) || !dateString) {
        return null;
    }
    return date;
}
function isDateValid(param) {
    let { date , maxDate , minDate  } = param;
    if (date == null) {
        return false;
    }
    if (Number.isNaN(date.getTime())) {
        return false;
    }
    if (maxDate && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isAfter(maxDate, "date")) {
        return false;
    }
    if (minDate && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isBefore(minDate, "date")) {
        return false;
    }
    return true;
}
function pickCalendarProps(props) {
    const { maxLevel , minLevel , defaultLevel , level , onLevelChange , date , defaultDate , onDateChange , numberOfColumns , columnsToScroll , ariaLabels , onNextMonth , onPreviousMonth , // MonthLevelGroup props
    firstDayOfWeek , weekdayFormat , weekendDays , getDayProps , excludeDate , renderDay , hideOutsideDates , focusOutsideMonthDays , hideWeekdays , getDayAriaLabel , monthLabelFormat , // Other props
    minDate , maxDate , locale , ...others } = props;
    return {
        calendarProps: {
            maxLevel,
            minLevel,
            defaultLevel,
            level,
            onLevelChange,
            date,
            defaultDate,
            onDateChange,
            numberOfColumns,
            columnsToScroll,
            ariaLabels,
            onNextMonth,
            onPreviousMonth,
            // MonthLevelGroup props
            firstDayOfWeek,
            weekdayFormat,
            weekendDays,
            getDayProps,
            excludeDate,
            renderDay,
            hideOutsideDates,
            hideWeekdays,
            getDayAriaLabel,
            monthLabelFormat,
            focusOutsideMonthDays,
            // Other props
            minDate,
            maxDate,
            locale
        },
        others
    };
}
function assignTime(originalDate, resultDate) {
    if (!originalDate || !resultDate) {
        return resultDate;
    }
    const hours = originalDate.getHours();
    const minutes = originalDate.getMinutes();
    const seconds = originalDate.getSeconds();
    const ms = originalDate.getMilliseconds();
    const result = new Date(resultDate);
    result.setHours(hours);
    result.setMinutes(minutes);
    result.setSeconds(seconds);
    result.setMilliseconds(ms);
    return result;
}



/***/ }),

/***/ 69573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ useDatesContext; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DatesProvider/DatesProvider.mjs
"use client";

const DATES_PROVIDER_DEFAULT_SETTINGS = {
    locale: "en",
    timezone: null,
    firstDayOfWeek: 1,
    weekendDays: [
        0,
        6
    ],
    labelSeparator: "–",
    consistentWeeks: false
};
const DatesProviderContext = /*#__PURE__*/ (0,react.createContext)(DATES_PROVIDER_DEFAULT_SETTINGS);


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DatesProvider/use-dates-context.mjs


function useDatesContext() {
    const ctx = (0,react.useContext)(DatesProviderContext);
    const getLocale = (0,react.useCallback)((input)=>input || ctx.locale, [
        ctx.locale
    ]);
    const getTimezone = (0,react.useCallback)((input)=>input || ctx.timezone || void 0, [
        ctx.timezone
    ]);
    const getFirstDayOfWeek = (0,react.useCallback)((input)=>typeof input === "number" ? input : ctx.firstDayOfWeek, [
        ctx.firstDayOfWeek
    ]);
    const getWeekendDays = (0,react.useCallback)((input)=>Array.isArray(input) ? input : ctx.weekendDays, [
        ctx.weekendDays
    ]);
    const getLabelSeparator = (0,react.useCallback)((input)=>typeof input === "string" ? input : ctx.labelSeparator, [
        ctx.labelSeparator
    ]);
    return {
        ...ctx,
        getLocale,
        getTimezone,
        getFirstDayOfWeek,
        getWeekendDays,
        getLabelSeparator
    };
}



/***/ }),

/***/ 35867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ shiftTimezone; }
});

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(29387);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(70178);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Day/helpers/get-timezone-offset.mjs



dayjs_min_default().extend((utc_default()));
dayjs_min_default().extend((timezone_default()));
function getTimezoneOffset(date, timezone) {
    if (timezone) {
        return dayjs_min_default()(date).tz(timezone).utcOffset() + date.getTimezoneOffset();
    }
    return 0;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/Day/Day.utils.mjs


const updateTimezone = (date, timezone, direction)=>{
    if (!date) {
        return null;
    }
    if (!timezone) {
        return date;
    }
    let offset = getTimezoneOffset(date, timezone);
    if (direction === "remove") {
        offset *= -1;
    }
    return dayjs_min_default()(date).add(offset, "minutes").toDate();
};
function shiftTimezone(direction, date, timezone, disabled) {
    if (disabled || !date) {
        return date;
    }
    if (Array.isArray(date)) {
        return date.map((d)=>updateTimezone(d, timezone, direction));
    }
    return updateTimezone(date, timezone, direction);
}



/***/ }),

/***/ 45271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useId; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/FocusTrap/FocusTrap.utils.mjs
var FocusTrap_utils = __webpack_require__(78709);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(53724);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-react-id.mjs

function useReactId() {
    const id = (0,react.useId)();
    return id ? "kohler-".concat(id.replace(/:/g, "")) : "";
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs




function useId(staticId) {
    const reactId = useReactId();
    const [uuid, setUuid] = (0,react.useState)(reactId);
    (0,use_isomorphic_effect/* useIsomorphicEffect */.Y)(()=>{
        setUuid((0,FocusTrap_utils/* randomId */.kb)());
    }, []);
    if (typeof staticId === "string") {
        return staticId;
    }
    if (false) {}
    return uuid;
}



/***/ }),

/***/ 66737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AspectRatioKeeper; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.module.css.mjs
var classes = {
    "root": "-EXaH"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.utils.mjs
const aspectRatioKeeperClasses = {
    "1:1": "1/1",
    "5:4": "5/4",
    "4:5": "4/5",
    "4:3": "4/3",
    "3:4": "3/4",
    "3:2": "3/2",
    "2:3": "2/3",
    "16:10": "16/10",
    "10:16": "10/16",
    "Golden ratio": "1.618/1",
    "Golden ratio Portrait": "1/1.618",
    "16:9": "16/9",
    "9:16": "9/16",
    "2:1": "2/1",
    "1:2": "1/2",
    "21:9": "21/9",
    "9:21": "9/21",
    A4: "297/210",
    "A4 Portrait": "210/297",
    Letter: "11/8.5",
    "Letter Portrait": "8.5/11",
    "32:9": "32/9",
    none: "unset"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs






const AspectRatioKeeper = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="figure" , className , aspectRatio , style , ...rest } = props;
    const ar = aspectRatio ? aspectRatioKeeperClasses[aspectRatio] : void 0;
    const classNames = (0,clsx/* default */.Z)("kohler-aspect-ratio-keeper-root", className, classes.root);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: classNames,
        component,
        ref,
        style: ar ? {
            ...style,
            ["--ar"]: ar
        } : style,
        ...rest
    });
});



/***/ }),

/***/ 54112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ Flex; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 1 modules
var styleProps = __webpack_require__(79111);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.module.css.mjs
var classes = {
    "root": "VBOmU"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.utils.mjs
const FLEX_STYLE_PROPS_DATA = {
    gap: {
        type: "spacing",
        property: "gap"
    },
    rowGap: {
        type: "spacing",
        property: "rowGap"
    },
    columnGap: {
        type: "spacing",
        property: "columnGap"
    },
    align: {
        type: "identity",
        property: "alignItems"
    },
    justify: {
        type: "identity",
        property: "justifyContent"
    },
    wrap: {
        type: "identity",
        property: "flexWrap"
    },
    direction: {
        type: "identity",
        property: "flexDirection"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs










const Flex = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , gap , rowGap , columnGap , align , justify , wrap , direction , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: (0,helpers/* removeEmptyProps */.t_)({
            gap,
            rowGap,
            columnGap,
            align,
            justify,
            wrap,
            direction
        }),
        data: FLEX_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(classes.root, className, "kohler-flex-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
        ...style,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        style: parsedStyles,
        component,
        ...rest
    }));
});



/***/ }),

/***/ 40697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Grid; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 1 modules
var styleProps = __webpack_require__(79111);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.module.css.mjs
var Grid_module_css = __webpack_require__(59293);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.utils.mjs
const GRID_STYLE_PROPS_DATA = {
    rowGap: {
        type: "spacing",
        property: "rowGap"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs









const Grid = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , children , rowGap , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: {
            rowGap
        },
        data: GRID_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(Grid_module_css/* default.root */.Z.root, className, "kohler-grid-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
        ...style,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        ref,
        className: classNames,
        style: parsedStyles,
        ...rest
    }, children));
});



/***/ }),

/***/ 59293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ classes; }
/* harmony export */ });
var classes = {
    "root": "q1PW5",
    "gridColumnSpan": "LSXaq",
    "gridColumnSpanSmall": "H62Zj",
    "gridColumnFull": "vsBEc"
};



/***/ }),

/***/ 57237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ GridColumn; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 1 modules
var styleProps = __webpack_require__(79111);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.module.css.mjs
var Grid_module_css = __webpack_require__(59293);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.utils.mjs
const GRID_COLUMN_STYLE_PROPS_DATA = {
    gridColumn: {
        type: "identity",
        property: "gridColumn"
    },
    gridColumnEnd: {
        type: "identity",
        property: "gridColumnEnd"
    },
    gridColumnStart: {
        type: "identity",
        property: "gridColumnStart"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs









const GridColumn = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , span , spanSmall , gridColumnStart , gridColumn , gridColumnEnd , fullWidth =true , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: {
            gridColumn,
            gridColumnStart,
            gridColumnEnd
        },
        data: GRID_COLUMN_STYLE_PROPS_DATA
    });
    const styleVars = {
        ...span ? {
            ["--span"]: String(span)
        } : {},
        ...spanSmall ? {
            ["--span-small"]: String(spanSmall)
        } : {}
    };
    const parsedStyles = {
        ...style,
        ...styleVars,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    const classNames = (0,clsx/* default */.Z)(className, !span && !spanSmall && fullWidth && Grid_module_css/* default.gridColumnFull */.Z.gridColumnFull, span && Grid_module_css/* default.gridColumnSpan */.Z.gridColumnSpan, spanSmall && Grid_module_css/* default.gridColumnSpanSmall */.Z.gridColumnSpanSmall);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        ...rest,
        style: parsedStyles
    }));
});



/***/ }),

/***/ 38466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Spacer; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.module.css.mjs
var classes = {
    "root": "x2VyJ",
    "spacerSizeNone": "RKbVl",
    "spacerSizeXS": "B90g0",
    "spacerSizeS": "_6SiQS",
    "spacerSizeM": "VkwB2",
    "spacerSizeL": "_9OLrI",
    "spacerSizeXL": "a9aaf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.utils.mjs

const spacerSizeClasses = {
    none: classes.spacerSizeNone,
    xs: classes.spacerSizeXS,
    s: classes.spacerSizeS,
    m: classes.spacerSizeM,
    l: classes.spacerSizeL,
    xl: classes.spacerSizeXL
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.mjs






const Spacer = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , size ="xs" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-spacer-root", className, classes.root, spacerSizeClasses[size]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        ...rest
    });
});



/***/ }),

/***/ 3253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Box; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 1 modules
var utils_styleProps = __webpack_require__(79111);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.utils.mjs


const BOX_STYLE_PROPS_DATA = {
    margin: {
        type: "spacing",
        property: "margin"
    },
    marginTop: {
        type: "spacing",
        property: "marginTop"
    },
    marginBottom: {
        type: "spacing",
        property: "marginBottom"
    },
    marginLeft: {
        type: "spacing",
        property: "marginLeft"
    },
    marginRight: {
        type: "spacing",
        property: "marginRight"
    },
    marginInlineStart: {
        type: "spacing",
        property: "marginInlineStart"
    },
    marginInlineEnd: {
        type: "spacing",
        property: "marginInlineEnd"
    },
    marginInline: {
        type: "spacing",
        property: "marginInline"
    },
    marginBlock: {
        type: "spacing",
        property: "marginBlock"
    },
    padding: {
        type: "spacing",
        property: "padding"
    },
    paddingTop: {
        type: "spacing",
        property: "paddingTop"
    },
    paddingBottom: {
        type: "spacing",
        property: "paddingBottom"
    },
    paddingLeft: {
        type: "spacing",
        property: "paddingLeft"
    },
    paddingRight: {
        type: "spacing",
        property: "paddingRight"
    },
    paddingInlineStart: {
        type: "spacing",
        property: "paddingInlineStart"
    },
    paddingInlineEnd: {
        type: "spacing",
        property: "paddingInlineEnd"
    },
    paddingInline: {
        type: "spacing",
        property: "paddingInline"
    },
    paddingBlock: {
        type: "spacing",
        property: "paddingBlock"
    },
    backgroundColor: {
        type: "color",
        property: "background"
    },
    textColor: {
        type: "textColor",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    width: {
        type: "spacing",
        property: "width"
    },
    minWidth: {
        type: "spacing",
        property: "minWidth"
    },
    maxWidth: {
        type: "spacing",
        property: "maxWidth"
    },
    height: {
        type: "spacing",
        property: "height"
    },
    minHeight: {
        type: "spacing",
        property: "minHeight"
    },
    maxHeight: {
        type: "spacing",
        property: "maxHeight"
    },
    fontFamily: {
        type: "fontFamily",
        property: "fontFamily"
    },
    fontSize: {
        type: "fontSize",
        property: "fontSize"
    },
    fontWeight: {
        type: "identity",
        property: "fontWeight"
    },
    letterSpacing: {
        type: "size",
        property: "letterSpacing"
    },
    textAlign: {
        type: "identity",
        property: "textAlign"
    },
    lineHeight: {
        type: "lineHeight",
        property: "lineHeight"
    },
    fontStyle: {
        type: "identity",
        property: "fontStyle"
    },
    textTransform: {
        type: "identity",
        property: "textTransform"
    },
    textDecoration: {
        type: "identity",
        property: "textDecoration"
    },
    position: {
        type: "identity",
        property: "position"
    },
    display: {
        type: "identity",
        property: "display"
    },
    objectFit: {
        type: "identity",
        property: "objectFit"
    },
    objectPosition: {
        type: "identity",
        property: "objectPosition"
    },
    zIndex: {
        type: "identity",
        property: "zIndex"
    },
    left: {
        type: "spacing",
        property: "left"
    },
    right: {
        type: "spacing",
        property: "right"
    },
    top: {
        type: "spacing",
        property: "top"
    },
    bottom: {
        type: "spacing",
        property: "bottom"
    },
    border: {
        type: "identity",
        property: "border"
    },
    borderTop: {
        type: "identity",
        property: "borderTop"
    },
    borderBottom: {
        type: "identity",
        property: "borderBottom"
    },
    borderRight: {
        type: "identity",
        property: "borderRight"
    },
    borderLeft: {
        type: "identity",
        property: "borderLeft"
    },
    borderRadius: {
        type: "identity",
        property: "borderRadius"
    },
    borderColor: {
        type: "color",
        property: "borderColor"
    },
    justifyContent: {
        type: "identity",
        property: "justifyContent"
    },
    cursor: {
        type: "identity",
        property: "cursor"
    },
    whiteSpace: {
        type: "identity",
        property: "whiteSpace"
    },
    visibility: {
        type: "identity",
        property: "visibility"
    },
    boxShadow: {
        type: "identity",
        property: "boxShadow"
    }
};
function extractStyleProps(others) {
    const { margin , marginTop , marginBottom , marginLeft , marginRight , marginInlineStart , marginInlineEnd , marginInline , marginBlock , padding , paddingTop , paddingBottom , paddingLeft , paddingRight , paddingInlineStart , paddingInlineEnd , paddingInline , paddingBlock , opacity , width , minWidth , maxWidth , height , minHeight , maxHeight , display , textColor , backgroundColor , fontFamily , fontSize , fontWeight , letterSpacing , textAlign , textTransform , position , lineHeight , fontStyle , textDecoration , objectFit , objectPosition , zIndex , left , right , top , bottom , border , borderRight , borderTop , borderLeft , borderBottom , borderRadius , borderColor , justifyContent , cursor , whiteSpace , visibility , boxShadow , ...rest } = others;
    const styleProps = (0,helpers/* removeEmptyProps */.t_)({
        margin,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        marginInlineStart,
        marginInlineEnd,
        marginInline,
        marginBlock,
        padding,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingInlineStart,
        paddingInlineEnd,
        paddingInline,
        paddingBlock,
        opacity,
        width,
        minWidth,
        maxWidth,
        height,
        minHeight,
        maxHeight,
        display,
        textColor,
        backgroundColor,
        fontFamily,
        fontSize,
        fontWeight,
        letterSpacing,
        textAlign,
        textTransform,
        position,
        lineHeight,
        fontStyle,
        textDecoration,
        objectFit,
        objectPosition,
        zIndex,
        left,
        right,
        top,
        bottom,
        border,
        borderRight,
        borderTop,
        borderLeft,
        borderBottom,
        borderRadius,
        borderColor,
        justifyContent,
        cursor,
        whiteSpace,
        visibility,
        boxShadow
    });
    return {
        styleProps,
        rest
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs







const Box = (0,factory_utils/* createPolymorphicComponent */.Fm)(/*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { component , className , style , mod , renderRoot , trackingAttributes , ...rest } = param;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const { styleProps , rest: restFiltered  } = extractStyleProps(rest);
    const parsedStyleProps = (0,utils_styleProps/* parseStyleProps */.nM)({
        styleProps,
        data: BOX_STYLE_PROPS_DATA
    });
    const Element = component || "div";
    const props = {
        ref,
        className: (0,clsx/* default */.Z)(mod && "".concat(mod, "-mod"), className, parsedStyleProps.hasResponsiveStyles && responsiveClassName) || void 0,
        style: {
            ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {},
            ...style
        },
        ...restFiltered,
        ...trackingAttributes
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Element, {
        ...props
    }));
}));



/***/ }),

/***/ 36839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ InlineStyles; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.utils.mjs


function stylesToString(param) {
    let { selector , styles , media  } = param;
    const baseStyles = styles ? cssObjectToString(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>"@media ".concat(item.query, "{").concat(selector, "{").concat(cssObjectToString(item.styles), "}}"));
    return "".concat(baseStyles ? "".concat(selector, "{").concat(baseStyles, "}") : "").concat(mediaQueryStyles.join("")).trim();
}
function cssObjectToString(css) {
    return (0,helpers/* keys */.XP)(css).reduce((acc, rule)=>css[rule] !== void 0 ? "".concat(acc).concat((0,helpers/* camelToKebabCase */.Kh)(rule), ":").concat(css[rule], ";") : acc, "").trim();
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs


function InlineStyles(param) {
    let { selector , styles , media  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("style", {
        "data-kohler-styles": "inline",
        dangerouslySetInnerHTML: {
            __html: stylesToString({
                selector,
                styles,
                media
            })
        }
    });
}



/***/ }),

/***/ 80891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CloseIcon.mjs
var CloseIcon = __webpack_require__(61599);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/FocusTrap/FocusTrap.mjs
var FocusTrap = __webpack_require__(39003);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Portal/OptionalPortal.mjs
var OptionalPortal = __webpack_require__(94058);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Modal/Modal.module.css.mjs
var classes = {
    "modalRoot": "zPoVv",
    "modalOverlay": "yofGP",
    "modal": "Ofhw4",
    "modalContentWrapper": "PrKKC",
    "modalCloseIcon": "R9Ygy"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Modal/Modal.utils.mjs



function useLockScroll(param) {
    let { opened , transitionDuration  } = param;
    const [shouldLockScroll, setShouldLockScroll] = (0,react.useState)(opened);
    const timeout = (0,react.useRef)();
    const _transitionDuration = transitionDuration;
    (0,react.useEffect)(()=>{
        if (opened) {
            setShouldLockScroll(true);
            window.clearTimeout(timeout.current);
        } else if (_transitionDuration === 0) {
            setShouldLockScroll(false);
        } else {
            timeout.current = window.setTimeout(()=>setShouldLockScroll(false), _transitionDuration);
        }
        return ()=>window.clearTimeout(timeout.current);
    }, [
        opened,
        _transitionDuration
    ]);
    return shouldLockScroll;
}
function useFocusReturn(param) {
    let { opened , shouldReturnFocus =true  } = param;
    const lastActiveElement = (0,react.useRef)();
    const returnFocus = ()=>{
        if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") {
            var ref;
            (ref = lastActiveElement.current) === null || ref === void 0 ? void 0 : ref.focus({
                preventScroll: true
            });
        }
    };
    (0,hooks/* useDidUpdate */.lR)(()=>{
        let timeout = -1;
        const clearFocusTimeout = (event)=>{
            if (event.key === "Tab") {
                window.clearTimeout(timeout);
            }
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) {
            lastActiveElement.current = document.activeElement;
        } else if (shouldReturnFocus) {
            timeout = window.setTimeout(returnFocus, 10);
        }
        return ()=>{
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}
function useModal(param) {
    let { opened , onClose , transitionProps ={
        duration: 200,
        transition: "pop"
    } , trapFocus =true , closeOnEscape =true , returnFocus =true  } = param;
    const _id = (0,use_id/* useId */.M)();
    const [titleMounted, setTitleMounted] = (0,react.useState)(false);
    const [bodyMounted, setBodyMounted] = (0,react.useState)(false);
    const transitionDuration = typeof (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration) === "number" ? transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration : 200;
    const shouldLockScroll = useLockScroll({
        opened,
        transitionDuration
    });
    (0,hooks/* useWindowEvent */.sm)("keydown", (event)=>{
        if (event.key === "Escape" && closeOnEscape) {
            var ref;
            const shouldTrigger = ((ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("data-stop-propagation")) !== "true";
            if (shouldTrigger) {
                onClose();
            }
        }
    }, {
        capture: true
    });
    useFocusReturn({
        opened,
        shouldReturnFocus: trapFocus && returnFocus
    });
    return {
        _id,
        titleMounted,
        bodyMounted,
        shouldLockScroll,
        setTitleMounted,
        setBodyMounted
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Modal/Modal.mjs









const Modal = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { children , opened , onClose , title , zIndex =100 , closeOnClickOutside =true , className , modalContentProps , closeButtonProps , withinPortal =false , portalProps , closeCTA , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, classes.modalRoot, "kohler-modal-root");
    const { _id  } = useModal({
        opened,
        onClose
    });
    if (closeButtonProps) console.warn("Property `closeButtonProps` will be deprecated soon. Please use `closeCTA` instead.");
    const closeButtonAttr = closeCTA !== null && closeCTA !== void 0 ? closeCTA : closeButtonProps;
    const handleOutsideClick = (e)=>{
        if (!closeOnClickOutside) return;
        if (closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.onClick) {
            closeCTA.onClick(e);
        } else {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(OptionalPortal/* OptionalPortal */.q, {
        ...portalProps,
        withinPortal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ...rest,
        className: classNames,
        ref,
        mod: "white"
    }, opened && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(classes.modalOverlay, "kohler-modal-overlay"),
        style: {
            zIndex
        },
        onClick: (e)=>handleOutsideClick(e)
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classes.modal,
        style: {
            zIndex
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FocusTrap/* FocusTrap */.i, {
        active: opened
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "section",
        className: (0,clsx/* default */.Z)(classes.modalContentWrapper, "kohler-modal-content"),
        role: "dialog",
        "aria-modal": true,
        "aria-label": title,
        "aria-describedby": "".concat(_id, "-content"),
        tabIndex: -1,
        ...modalContentProps
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": "Close modal",
        onClick: onClose,
        ...closeButtonAttr,
        className: (0,clsx/* default */.Z)(classes.modalCloseIcon, closeButtonAttr === null || closeButtonAttr === void 0 ? void 0 : closeButtonAttr.className, "kohler-modal-close-button")
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        id: "".concat(_id, "-content")
    }, children)))))));
});



/***/ }),

/***/ 61518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ SharePopover; }
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/InternalLinkIcon.mjs
var InternalLinkIcon = __webpack_require__(33804);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/EmailIcon.mjs
var EmailIcon = __webpack_require__(72712);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/ActionIndicator/ActionIndicator.mjs + 7 modules
var ActionIndicator = __webpack_require__(74565);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs
var use_window_size = __webpack_require__(17677);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.mjs + 2 modules
var Popover = __webpack_require__(86138);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/SharePopover/SharePopover.module.css.mjs
var classes = {
    "sharePopoverRoot": "u1dWK",
    "sharePopoverWrapper": "eWwEb",
    "sharePopoverContent": "oF2MJ",
    "sharePopoverLinksContainer": "CrhCY",
    "sharePopoverDivider": "PNUty",
    "sharePopoverActionsContainer": "PcfBm",
    "sharePopoverLink": "rGYj3"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FacebookFilledIcon.mjs


const withoutBoundingBoxWidth = {
    large: 13,
    medium: 8,
    small: 7,
    xSmall: 5
};
const FacebookFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.788 23.2H12.595V15.099H11V12.3076H12.595V10.6318C12.595 8.35477 13.496 7 16.055 7H18.185V9.79236H16.854C15.858 9.79236 15.792 10.1824 15.792 10.9104L15.787 12.3076H18.2L17.918 15.099H15.787L15.788 23.2Z",
        fill: "currentColor"
    }));
};
FacebookFilledIcon.iconName = "FacebookFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/XIcon.mjs


const XIcon_withoutBoundingBoxWidth = {
    large: 22,
    medium: 16,
    small: 12,
    xSmall: 9
};
const XIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : XIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M16.5222 13.9238L22.4785 7H21.0671L15.8952 13.0118L11.7644 7H7L13.2466 16.0909L7 23.3516H8.41155L13.8732 17.0029L18.2356 23.3516H23L16.5218 13.9238H16.5222ZM14.5889 16.171L13.956 15.2658L8.92015 8.06259H11.0882L15.1522 13.8758L15.7851 14.7811L21.0677 22.3373H18.8997L14.5889 16.1714V16.171Z",
        fill: "currentColor"
    }));
};
XIcon.iconName = "XIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PinterestFilledIcon.mjs


const PinterestFilledIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 17,
    small: 12,
    xSmall: 9
};
const PinterestFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : PinterestFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 15.1C6.5 10.6261 10.127 7 14.601 7C19.074 7 22.7 10.6261 22.7 15.1C22.7 19.5729 19.074 23.2 14.601 23.2C13.803 23.2 13.033 23.0828 12.305 22.8676C12.612 22.3809 12.949 21.757 13.12 21.1331C13.22 20.7721 13.69 18.9062 13.69 18.9062C13.972 19.4434 14.794 19.9158 15.669 19.9158C18.273 19.9158 20.04 17.5422 20.04 14.3647C20.04 11.9625 18.004 9.72413 14.911 9.72413C11.062 9.72413 9.123 12.4835 9.123 14.7847C9.123 16.1773 9.65 17.4165 10.781 17.8794C10.967 17.9546 11.133 17.8813 11.187 17.6765C11.224 17.5346 11.314 17.1745 11.352 17.0269C11.406 16.8231 11.385 16.7516 11.235 16.5745C10.91 16.1896 10.701 15.6915 10.701 14.9857C10.701 12.9398 12.232 11.1072 14.69 11.1072C16.864 11.1072 18.059 12.4359 18.059 14.2104C18.059 16.5468 17.026 18.5166 15.492 18.5166C14.644 18.5166 14.01 17.8165 14.213 16.9574C14.456 15.9315 14.929 14.8238 14.929 14.0827C14.929 13.4198 14.572 12.8664 13.835 12.8664C12.969 12.8664 12.273 13.7627 12.273 14.9638C12.273 15.7277 12.532 16.2449 12.532 16.2449C12.532 16.2449 11.646 20.0015 11.49 20.6587C11.345 21.2741 11.326 21.9532 11.35 22.519C8.495 21.2664 6.5 18.4166 6.5 15.1Z",
        fill: "currentColor"
    }));
};
PinterestFilledIcon.iconName = "PinterestFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/HouzzFilledIcon.mjs


const HouzzFilledIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 15,
    small: 11,
    xSmall: 9
};
const HouzzFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : HouzzFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4444 24H22V14.2159L10.8889 10.9667V7H7V24H12.5556V18.3333H16.4444V24Z",
        fill: "currentColor"
    }));
};
HouzzFilledIcon.iconName = "HouzzFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/YoutubeFilledIcon.mjs


const YoutubeFilledIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 23,
    small: 16,
    xSmall: 12
};
const YoutubeFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : YoutubeFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 19.0734C26 23 22.2091 23 22.2091 23H7.78991C4 23 4 19.0734 4 19.0734V10.9266C4 7 7.78991 7 7.78991 7H22.2091C26 7 26 10.9266 26 10.9266V19.0734ZM19.2717 15.0114L12.0687 10.6292V19.3922L19.2717 15.0114Z",
        fill: "currentColor"
    }));
};
YoutubeFilledIcon.iconName = "YoutubeFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/InstagramFilledIcon.mjs


const InstagramFilledIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 18,
    small: 12,
    xSmall: 9
};
const InstagramFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : InstagramFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.4689 7C21.1949 7 22.5999 8.40397 22.5999 10.1308V20.0692C22.5999 21.796 21.1949 23.2 19.4689 23.2H9.5309C7.8049 23.2 6.3999 21.796 6.3999 20.0692V10.1308C6.3999 8.40397 7.8049 7 9.5309 7H19.4689ZM20.3669 8.86782L17.9789 8.87449L17.9879 11.6205L20.7249 11.6119V8.86591L20.3669 8.86782ZM12.1879 13.4369C11.8509 13.9056 11.6489 14.479 11.6489 15.1C11.6489 16.6716 12.9279 17.9508 14.4999 17.9508C16.0729 17.9508 17.3519 16.6716 17.3519 15.1C17.3519 14.479 17.1499 13.9056 16.8119 13.4369C16.2939 12.7188 15.4519 12.2482 14.4999 12.2482C13.5479 12.2482 12.7059 12.7188 12.1879 13.4369ZM21.0219 20.0692V13.437H18.6029C18.8109 13.9513 18.9299 14.5123 18.9299 15.1C18.9299 17.5422 16.9429 19.53 14.4999 19.53C12.0579 19.53 10.0709 17.5422 10.0709 15.1C10.0709 14.5123 10.1879 13.9513 10.3979 13.437H7.97791V20.0692C7.97791 20.9255 8.67491 21.6217 9.53091 21.6217H19.4689C20.3249 21.6217 21.0219 20.9255 21.0219 20.0692Z",
        fill: "currentColor"
    }));
};
InstagramFilledIcon.iconName = "InstagramFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/LinkedInFilledIcon.mjs


const LinkedInFilledIcon_withoutBoundingBoxWidth = {
    large: 28,
    medium: 20,
    small: 15,
    xSmall: 12
};
const LinkedInFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : LinkedInFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 5C6.79086 5 5 6.79086 5 9V21C5 23.2091 6.79086 25 9 25H21C23.2091 25 25 23.2091 25 21V9C25 6.79086 23.2091 5 21 5H9ZM10 10.1548C10 10.7926 10.5157 11.31 11.1556 11.31C11.7926 11.31 12.31 10.7926 12.31 10.1548C12.31 9.51739 11.7926 9 11.1556 9C10.5157 9 10 9.51739 10 10.1548ZM18.1726 19.395H20.395V15.6865C20.395 13.8652 19.9792 12.465 17.7286 12.465C16.6474 12.465 15.9225 13.0256 15.6261 13.5574H15.5956V12.6329H13.465V19.395H15.6851V16.0505C15.6851 15.1684 15.8616 14.3138 17.0178 14.3138C18.1585 14.3138 18.1726 15.3225 18.1726 16.1067V19.395ZM12.31 19.395H10V12.465H12.31V19.395Z",
        fill: "currentColor"
    }));
};
LinkedInFilledIcon.iconName = "LinkedInFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/SharePopover/SharePopover.utils.mjs

const sharePopoverIconMap = {
    facebook: FacebookFilledIcon,
    twitter: XIcon,
    x: XIcon,
    pinterest: PinterestFilledIcon,
    houzz: HouzzFilledIcon,
    youtube: YoutubeFilledIcon,
    instagram: InstagramFilledIcon,
    linkedin: LinkedInFilledIcon
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/SharePopover/SharePopover.mjs
"use client";














const SharePopover = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { target , links , cartNumberText , showDivider =true , copyCTA , emailCTA , className , withRoles , trapFocus , withinPortal , mod , width , autoCloseOnParentHoverOut , isParentHovered , ...rest } = props;
    const [dropdownOpened, setDropdownOpened] = (0,react.useState)(false);
    const { width: windowSize  } = (0,use_window_size/* useWindowSize */.i)();
    (0,react.useEffect)(()=>{
        if (autoCloseOnParentHoverOut && !isParentHovered && dropdownOpened && !(windowSize < 1024)) {
            setDropdownOpened(false);
        }
    }, [
        autoCloseOnParentHoverOut,
        isParentHovered,
        dropdownOpened
    ]);
    const classNames = (0,clsx/* default */.Z)(classes.sharePopoverRoot, "kohler-share-popover-root", className);
    const id = (0,use_id/* useId */.M)();
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        ...rest,
        ref
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover/* Popover */.J, {
        opened: dropdownOpened,
        trapFocus: trapFocus || false,
        position: "bottom-end",
        withinPortal: withinPortal || false,
        withRoles: withRoles || false,
        withArrow: false,
        id,
        onChange: setDropdownOpened
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover/* Popover.Target */.J.Target, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            setDropdownOpened((c)=>!c);
        },
        className: "kohler-share-popover-target",
        textColor: "inherit"
    }, target)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover/* Popover.Dropdown */.J.Dropdown, {
        onMouseDown: (event)=>event.preventDefault(),
        className: (0,clsx/* default */.Z)(classes.sharePopoverWrapper, "kohler-share-popover-wrapper"),
        mod
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classes.sharePopoverContent,
        width
    }, links && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: classes.sharePopoverLinksContainer
    }, links.map((param)=>{
        let { logo , ...rest2 } = param;
        const IconComponent = sharePopoverIconMap[logo];
        if (!IconComponent) return null;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "a",
            className: classes.sharePopoverLink,
            textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
            target: "_blank",
            "aria-label": "Share on ".concat(logo),
            key: "".concat(rest2.href, "-").concat(logo),
            ...rest2
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(IconComponent, {
            withBoundingBox: false
        }));
    })), cartNumberText && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: classes.sharePopoverCartNumber,
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary,
        size: "label-medium-s",
        component: "p",
        ...(0,helpers/* omitText */.rW)(cartNumberText)
    }, cartNumberText.text), showDivider && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: classes.sharePopoverDivider
    }), (copyCTA || emailCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: classes.sharePopoverActionsContainer
    }, copyCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ActionIndicator/* ActionIndicator */.R, {
        icon: InternalLinkIcon/* InternalLinkIcon */.B,
        label: "Copy link",
        ...copyCTA
    }), emailCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ActionIndicator/* ActionIndicator */.R, {
        icon: EmailIcon/* EmailIcon */.L,
        label: "Email",
        ...emailCTA
    }))))));
});



/***/ }),

/***/ 23293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/get-floating-position/get-floating-position.mjs
var get_floating_position = __webpack_require__(86286);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/FloatingArrow.mjs + 1 modules
var FloatingArrow = __webpack_require__(25292);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/PopoverTarget.utils.mjs
var PopoverTarget_utils = __webpack_require__(60169);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(68064);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.module.css.mjs
var classes = {
    "tooltip": "MX352",
    "tooltipOpened": "OFydy"
};


// EXTERNAL MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.mjs + 1 modules
var floating_ui_react = __webpack_require__(46504);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(1371);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/Dropdown/subcomponent/Combobox/use-id.mjs + 1 modules
var use_id = __webpack_require__(45271);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/use-floating-auto-update.mjs
var use_floating_auto_update = __webpack_require__(96228);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/use-tooltip.mjs






function useTooltip(settings) {
    var ref, ref1, ref2;
    const [uncontrolledOpened, setUncontrolledOpened] = (0,react.useState)(false);
    const controlled = typeof settings.opened === "boolean";
    const opened = controlled ? settings.opened : uncontrolledOpened;
    const uid = (0,use_id/* useId */.M)();
    const onChange = (0,react.useCallback)((_opened)=>{
        setUncontrolledOpened(_opened);
    }, [
        uid
    ]);
    const { x , y , context , refs , update , placement , middlewareData: { arrow: { x: arrowX , y: arrowY  } = {}  }  } = (0,floating_ui_react/* useFloating */.YF)({
        strategy: settings.strategy,
        placement: settings.position,
        open: opened,
        onOpenChange: onChange,
        middleware: [
            (0,floating_ui_react_dom/* offset */.cv)(settings.offset),
            (0,floating_ui_react_dom/* shift */.uY)({
                padding: 8
            }),
            (0,floating_ui_react_dom/* flip */.RR)(),
            (0,floating_ui_react_dom/* arrow */.x7)({
                element: settings.arrowRef,
                padding: settings.arrowOffset
            }),
            ...settings.inline ? [
                (0,floating_ui_react_dom/* inline */.Qo)()
            ] : []
        ]
    });
    const { getReferenceProps , getFloatingProps  } = (0,floating_ui_react/* useInteractions */.NI)([
        (0,floating_ui_react/* useHover */.XI)(context, {
            enabled: (ref = settings.events) === null || ref === void 0 ? void 0 : ref.hover,
            delay: {
                open: settings.openDelay,
                close: settings.closeDelay
            },
            mouseOnly: !((ref1 = settings.events) === null || ref1 === void 0 ? void 0 : ref1.touch)
        }),
        (0,floating_ui_react/* useFocus */.KK)(context, {
            enabled: (ref2 = settings.events) === null || ref2 === void 0 ? void 0 : ref2.focus,
            visibleOnly: true
        }),
        (0,floating_ui_react/* useRole */.qs)(context, {
            role: "tooltip"
        }),
        (0,floating_ui_react/* useDismiss */.bQ)(context, {
            enabled: typeof settings.opened === "undefined"
        })
    ]);
    (0,use_floating_auto_update/* useFloatingAutoUpdate */.L)({
        opened,
        position: settings.position,
        positionDependencies: settings.positionDependencies,
        floating: {
            refs,
            update
        }
    });
    (0,hooks/* useDidUpdate */.lR)(()=>{
        var ref;
        (ref = settings.onPositionChange) === null || ref === void 0 ? void 0 : ref.call(settings, placement);
    }, [
        placement
    ]);
    return {
        x,
        y,
        arrowX,
        arrowY,
        reference: refs.setReference,
        floating: refs.setFloating,
        getFloatingProps,
        getReferenceProps,
        isGroupPhase: false,
        opened,
        placement
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs
"use client";











const Tooltip = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { children , position , refProp ="ref" , label , onPositionChange , opened , className , multiline =true , zIndex , onClick , onMouseEnter , onMouseLeave , inline , offset =5 , ...rest } = props;
    const dir = "ltr";
    const events = {
        hover: true,
        focus: false,
        touch: false
    };
    const arrowSize = 16;
    const arrowRef = (0,react.useRef)(null);
    const withArrow = false;
    const arrowOffset = 5;
    const arrowPosition = "side";
    const tooltip = useTooltip({
        position: (0,get_floating_position/* getFloatingPosition */._)(dir, position),
        closeDelay: void 0,
        openDelay: void 0,
        onPositionChange,
        opened,
        events,
        arrowRef,
        arrowOffset: void 0,
        offset: typeof offset === "number" ? offset + 0 : offset,
        positionDependencies: [
            ...[],
            children
        ],
        inline,
        strategy: void 0
    });
    if (!(0,PopoverTarget_utils/* isElement */.k)(children)) {
        throw new Error("[@kohler/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
    }
    const targetRef = (0,use_merged_ref/* useMergedRef */.Yx)(tooltip.reference, children.ref, ref);
    var _y, _x;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "div",
        size: "paragraph-small",
        ...rest,
        ...tooltip.getFloatingProps({
            ref: tooltip.floating,
            className: (0,clsx/* default */.Z)(classes.tooltip, tooltip.opened && classes.tooltipOpened, className, "kohler-tooltip-root"),
            style: {
                zIndex,
                top: (_y = tooltip.y) !== null && _y !== void 0 ? _y : 0,
                left: (_x = tooltip.x) !== null && _x !== void 0 ? _x : 0
            }
        }),
        "data-multiline": multiline
    }, label, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FloatingArrow/* FloatingArrow */.Y, {
        ref: arrowRef,
        arrowX: tooltip.arrowX,
        arrowY: tooltip.arrowY,
        visible: withArrow,
        position: tooltip.placement,
        arrowSize,
        arrowOffset,
        arrowRadius: 0,
        arrowPosition
    })), /*#__PURE__*/ (0,react.cloneElement)(children, tooltip.getReferenceProps({
        onClick,
        onMouseEnter,
        onMouseLeave,
        onMouseMove: props.onMouseMove,
        onPointerDown: props.onPointerDown,
        onPointerEnter: props.onPointerEnter,
        [refProp]: targetRef,
        className: (0,clsx/* default */.Z)(children.props.className),
        ...children.props
    })));
});



/***/ }),

/***/ 25292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ FloatingArrow; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/get-arrow-position-styles.mjs
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") {
        return {
            top: arrowY
        };
    }
    if (placement === "end") {
        return {
            bottom: arrowOffset
        };
    }
    if (placement === "start") {
        return {
            top: arrowOffset
        };
    }
    return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") {
        return {
            left: arrowX
        };
    }
    if (placement === "end") {
        return {
            [dir === "ltr" ? "right" : "left"]: arrowOffset
        };
    }
    if (placement === "start") {
        return {
            [dir === "ltr" ? "left" : "right"]: arrowOffset
        };
    }
    return {};
}
const radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function getArrowPositionStyles(param) {
    let { position , arrowSize , arrowOffset , arrowRadius , arrowPosition , arrowX , arrowY , dir  } = param;
    const [side, placement = "center"] = position.split("-");
    const baseStyles = {
        width: arrowSize,
        height: arrowSize,
        transform: "rotate(45deg)",
        position: "absolute",
        [radiusByFloatingSide[side]]: arrowRadius
    };
    const arrowPlacement = -arrowSize / 4;
    if (side === "left") {
        return {
            ...baseStyles,
            ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
            right: arrowPlacement,
            borderLeftColor: "transparent",
            borderBottomColor: "transparent"
        };
    }
    if (side === "right") {
        return {
            ...baseStyles,
            ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
            left: arrowPlacement,
            borderRightColor: "transparent",
            borderTopColor: "transparent"
        };
    }
    if (side === "top") {
        return {
            ...baseStyles,
            ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
            bottom: arrowPlacement,
            borderTopColor: "transparent",
            borderLeftColor: "transparent"
        };
    }
    if (side === "bottom") {
        return {
            ...baseStyles,
            ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
            top: arrowPlacement,
            borderBottomColor: "transparent",
            borderRightColor: "transparent"
        };
    }
    return {};
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/FloatingArrow.mjs


const FloatingArrow = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { position , arrowSize , arrowOffset , arrowRadius , arrowPosition , visible , arrowX , arrowY , style , ...others } = param;
    const dir = "ltr";
    if (!visible) {
        return null;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        ...others,
        ref,
        style: {
            ...style,
            ...getArrowPositionStyles({
                position,
                arrowSize,
                arrowOffset,
                arrowRadius,
                arrowPosition,
                dir,
                arrowX,
                arrowY
            })
        }
    });
});



/***/ }),

/***/ 86286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getFloatingPosition; }
/* harmony export */ });
function getFloatingPosition(dir, position) {
    return position;
}



/***/ }),

/***/ 96228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useFloatingAutoUpdate; }
/* harmony export */ });
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24750);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_hooks_hooks_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55580);



function useFloatingAutoUpdate(param) {
    let { opened , floating , position , positionDependencies  } = param;
    const [delayedUpdate, setDelayedUpdate] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (floating.refs.reference.current && floating.refs.floating.current) {
            return (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .autoUpdate */ .Me)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
        }
        return void 0;
    }, [
        floating.refs.reference.current,
        floating.refs.floating.current,
        opened,
        delayedUpdate,
        position
    ]);
    (0,_utils_hooks_hooks_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useDidUpdate */ .lR)(()=>{
        floating.update();
    }, positionDependencies);
    (0,_utils_hooks_hooks_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useDidUpdate */ .lR)(()=>{
        setDelayedUpdate((c)=>c + 1);
    }, [
        opened
    ]);
}



/***/ }),

/***/ 39003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ FocusTrap; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Popover_PopoverTarget_PopoverTarget_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60169);
/* harmony import */ var _Popover_PopoverTarget_use_merged_ref_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68064);
/* harmony import */ var _FocusTrap_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78709);




function FocusTrap(param) {
    let { children , active =true , refProp ="ref"  } = param;
    const focusTrapRef = (0,_FocusTrap_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useFocusTrap */ .P5)(active);
    const ref = (0,_Popover_PopoverTarget_use_merged_ref_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMergedRef */ .Yx)(focusTrapRef, children === null || children === void 0 ? void 0 : children.ref);
    if (!(0,_Popover_PopoverTarget_PopoverTarget_utils_mjs__WEBPACK_IMPORTED_MODULE_3__/* .isElement */ .k)(children)) {
        return children;
    }
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
        [refProp]: ref
    });
}



/***/ }),

/***/ 78709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P5": function() { return /* binding */ useFocusTrap; },
/* harmony export */   "kb": function() { return /* binding */ randomId; }
/* harmony export */ });
/* unused harmony exports FOCUS_SELECTOR, findTabbableDescendants, focusable, scopeTab, tabbable */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const TABBABLE_NODES = /input|select|textarea|button|object/;
const FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function hidden(element) {
    return element.style.display === "none";
}
function visible(element) {
    const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
    if (isHidden) {
        return false;
    }
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) {
            break;
        }
        if (hidden(parentElement)) {
            return false;
        }
        parentElement = parentElement.parentNode;
    }
    return true;
}
function getElementTabIndex(element) {
    let tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) {
        tabIndex = void 0;
    }
    return parseInt(tabIndex, 10);
}
function randomId() {
    return "kohler-".concat(Math.random().toString(36).slice(2, 11));
}
function focusable(element) {
    const nodeName = element.nodeName.toLowerCase();
    const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
    const res = // @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition
    TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    const tabIndex = getElementTabIndex(element);
    const isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
    return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}
function scopeTab(node, event) {
    const tabbable2 = findTabbableDescendants(node);
    if (!tabbable2.length) {
        event.preventDefault();
        return;
    }
    const finalTabbable = tabbable2[event.shiftKey ? 0 : tabbable2.length - 1];
    const root = node.getRootNode();
    let leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
    const activeElement = root.activeElement;
    const activeElementIsRadio = activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio";
    if (activeElementIsRadio) {
        const activeRadioGroup = tabbable2.filter((element)=>element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name"));
        leavingFinalTabbable = activeRadioGroup.includes(finalTabbable);
    }
    if (!leavingFinalTabbable) {
        return;
    }
    event.preventDefault();
    const target = tabbable2[event.shiftKey ? tabbable2.length - 1 : 0];
    if (target) {
        target.focus();
    }
}
function useFocusTrap() {
    let active = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const restoreAria = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const focusNode = (node)=>{
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
            const children = Array.from(node.querySelectorAll(FOCUS_SELECTOR));
            focusElement = children.find(tabbable) || children.find(focusable) || null;
            if (!focusElement && focusable(node)) focusElement = node;
        }
        if (focusElement) {
            focusElement.focus({
                preventScroll: true
            });
        } else {
            console.warn("[@kohler-dsm-library/kohler-core/use-focus-trap] Failed to find focusable element within provided node", node);
        }
    };
    const setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((node)=>{
        if (!active) {
            return;
        }
        if (node === null) {
            if (restoreAria.current) {
                restoreAria.current();
                restoreAria.current = null;
            }
            return;
        }
        if (ref.current === node) {
            return;
        }
        if (node) {
            setTimeout(()=>{
                if (node.getRootNode()) {
                    focusNode(node);
                } else {
                    console.warn("[@kohler-dsm-library/kohler-core/use-focus-trap] Ref node is not part of the dom", node);
                }
            });
            ref.current = node;
        } else {
            ref.current = null;
        }
    }, [
        active
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!active) {
            return void 0;
        }
        if (ref.current) {
            setTimeout(()=>focusNode(ref.current));
        }
        const handleKeyDown = (event)=>{
            if (event.key === "Tab" && ref.current) {
                scopeTab(ref.current, event);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            if (restoreAria.current) {
                restoreAria.current();
            }
        };
    }, [
        active
    ]);
    return setRef;
}



/***/ }),

/***/ 69528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ usePopoverContext; },
/* harmony export */   "q": function() { return /* binding */ PopoverContextProvider; }
/* harmony export */ });
/* harmony import */ var _create_safe_context_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19975);

const [PopoverContextProvider, usePopoverContext] = (0,_create_safe_context_mjs__WEBPACK_IMPORTED_MODULE_0__/* .createSafeContext */ .R)("Popover component was not found in the tree");



/***/ }),

/***/ 86138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Popover; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-click-outside.mjs

const DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function useClickOutside(handler, events, nodes) {
    const ref = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            const { target  } = event !== null && event !== void 0 ? event : {};
            if (Array.isArray(nodes)) {
                const shouldIgnore = (target === null || target === void 0 ? void 0 : target.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(target) && target.tagName !== "HTML";
                const shouldTrigger = nodes.every((node)=>!!node && !event.composedPath().includes(node));
                if (shouldTrigger && !shouldIgnore) {
                    handler();
                }
            } else if (ref.current && !ref.current.contains(target)) {
                handler();
            }
        };
        (events || DEFAULT_EVENTS).forEach((fn)=>document.addEventListener(fn, listener));
        return ()=>{
            (events || DEFAULT_EVENTS).forEach((fn)=>document.removeEventListener(fn, listener));
        };
    }, [
        ref,
        handler,
        nodes
    ]);
    return ref;
}


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/get-floating-position/get-floating-position.mjs
var get_floating_position = __webpack_require__(86286);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.context.mjs
var Popover_context = __webpack_require__(69528);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(1371);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.mjs + 1 modules
var floating_ui_react = __webpack_require__(46504);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(18657);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/use-floating-auto-update.mjs
var use_floating_auto_update = __webpack_require__(96228);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.utils.mjs






function getPopoverMiddlewares(options, getFloating) {
    var ref, ref1, ref2, ref3;
    const middlewares = [
        (0,floating_ui_react_dom/* offset */.cv)(options.offset)
    ];
    if ((ref = options.middlewares) === null || ref === void 0 ? void 0 : ref.shift) {
        middlewares.push((0,floating_ui_react_dom/* shift */.uY)({
            limiter: (0,floating_ui_react_dom/* limitShift */.dr)()
        }));
    }
    if ((ref1 = options.middlewares) === null || ref1 === void 0 ? void 0 : ref1.flip) {
        middlewares.push((0,floating_ui_react_dom/* flip */.RR)());
    }
    if ((ref2 = options.middlewares) === null || ref2 === void 0 ? void 0 : ref2.inline) {
        middlewares.push((0,floating_ui_react_dom/* inline */.Qo)());
    }
    middlewares.push((0,floating_ui_react_dom/* arrow */.x7)({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    if (((ref3 = options.middlewares) === null || ref3 === void 0 ? void 0 : ref3.size) || options.width === "target") {
        middlewares.push((0,floating_ui_react_dom/* size */.dp)({
            apply (param) {
                let { rects , availableWidth , availableHeight  } = param;
                var ref, ref1;
                const floating = getFloating();
                var ref2;
                const styles = (ref2 = (ref = floating.refs.floating.current) === null || ref === void 0 ? void 0 : ref.style) !== null && ref2 !== void 0 ? ref2 : {};
                if ((ref1 = options.middlewares) === null || ref1 === void 0 ? void 0 : ref1.size) {
                    Object.assign(styles, {
                        maxWidth: "".concat(availableWidth, "px"),
                        maxHeight: "".concat(availableHeight, "px")
                    });
                }
                if (options.width === "target") {
                    Object.assign(styles, {
                        width: "".concat(rects.reference.width, "px")
                    });
                }
            }
        }));
    }
    return middlewares;
}
function usePopover(options) {
    const [_opened, setOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    });
    const onClose = ()=>{
        if (_opened) {
            var ref;
            (ref = options.onClose) === null || ref === void 0 ? void 0 : ref.call(options);
            setOpened(false);
        }
    };
    const onToggle = ()=>{
        if (_opened) {
            var ref;
            (ref = options.onClose) === null || ref === void 0 ? void 0 : ref.call(options);
            setOpened(false);
        } else {
            var ref1;
            (ref1 = options.onOpen) === null || ref1 === void 0 ? void 0 : ref1.call(options);
            setOpened(true);
        }
    };
    const floating = (0,floating_ui_react/* useFloating */.YF)({
        strategy: options.strategy,
        placement: options.position,
        middleware: getPopoverMiddlewares(options, ()=>floating)
    });
    (0,use_floating_auto_update/* useFloatingAutoUpdate */.L)({
        opened: options.opened,
        position: options.position,
        positionDependencies: options.positionDependencies || [],
        floating
    });
    (0,hooks/* useDidUpdate */.lR)(()=>{
        var ref;
        (ref = options.onPositionChange) === null || ref === void 0 ? void 0 : ref.call(options, floating.placement);
    }, [
        floating.placement
    ]);
    (0,hooks/* useDidUpdate */.lR)(()=>{
        if (!options.opened) {
            var ref;
            (ref = options.onClose) === null || ref === void 0 ? void 0 : ref.call(options);
        } else {
            var ref1;
            (ref1 = options.onOpen) === null || ref1 === void 0 ? void 0 : ref1.call(options);
        }
    }, [
        options.opened
    ]);
    return {
        floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose,
        onToggle
    };
}


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverDropdown/PopoverDropdown.mjs + 2 modules
var PopoverDropdown = __webpack_require__(77225);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/PopoverTarget.mjs
var PopoverTarget = __webpack_require__(77885);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.mjs
"use client";









function Popover(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { children , position ="bottom" , offset =8 , onPositionChange , opened , width ="max-content" , middlewares ={
        flip: true,
        shift: true,
        inline: false
    } , withArrow , arrowPosition ="side" , closeOnClickOutside =true , withinPortal =true , closeOnEscape =true , clickOutsideEvents =[
        "mousedown",
        "touchstart"
    ] , trapFocus =true , onClose , onOpen , onChange , zIndex =300 , id ="popover" , dropdownId , defaultOpened =false , withRoles =true , disabled , returnFocus =false , keepMounted , floatingStrategy , ...rest } = props;
    const positionDependencies = [];
    const arrowOffset = 15;
    const arrowSize = 12;
    const arrowRef = (0,react.useRef)(null);
    const [targetNode, setTargetNode] = (0,react.useState)(null);
    const [dropdownNode, setDropdownNode] = (0,react.useState)(null);
    const popover = usePopover({
        middlewares,
        width,
        position: (0,get_floating_position/* getFloatingPosition */._)("ltr", position),
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        arrowRef,
        arrowOffset,
        onPositionChange,
        positionDependencies,
        opened,
        defaultOpened,
        onChange,
        onOpen,
        onClose,
        strategy: floatingStrategy
    });
    useClickOutside(()=>closeOnClickOutside && popover.onClose(), clickOutsideEvents, [
        targetNode,
        dropdownNode
    ]);
    const reference = (0,react.useCallback)((node)=>{
        setTargetNode(node);
        popover.floating.refs.setReference(node);
    }, [
        popover.floating.refs.setReference
    ]);
    const floating = (0,react.useCallback)((node)=>{
        setDropdownNode(node);
        popover.floating.refs.setFloating(node);
    }, [
        popover.floating.refs.setFloating
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Popover_context/* PopoverContextProvider */.q, {
        value: {
            returnFocus,
            disabled,
            controlled: popover.controlled,
            reference,
            floating,
            x: popover.floating.x,
            y: popover.floating.y,
            arrowX: (ref = popover.floating) === null || ref === void 0 ? void 0 : (ref1 = ref.middlewareData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.arrow) === null || ref2 === void 0 ? void 0 : ref2.x,
            arrowY: (ref3 = popover.floating) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.middlewareData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.arrow) === null || ref5 === void 0 ? void 0 : ref5.y,
            opened: popover.opened,
            arrowRef,
            width,
            withArrow,
            arrowSize,
            arrowOffset,
            arrowRadius: 1,
            arrowPosition,
            placement: popover.floating.placement,
            trapFocus,
            withinPortal,
            zIndex,
            closeOnEscape,
            onClose: popover.onClose,
            onToggle: popover.onToggle,
            getTargetId: ()=>"".concat(id, "-target"),
            getDropdownId: ()=>dropdownId || "".concat(id, "-dropdown"),
            withRoles,
            targetProps: rest,
            keepMounted
        }
    }, children);
}
Popover.Target = PopoverTarget/* PopoverTarget */.n;
Popover.Dropdown = PopoverDropdown/* PopoverDropdown */.B;



/***/ }),

/***/ 77225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ PopoverDropdown; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/FloatingArrow.mjs + 1 modules
var FloatingArrow = __webpack_require__(25292);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/FocusTrap/FocusTrap.mjs
var FocusTrap = __webpack_require__(39003);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Portal/OptionalPortal.mjs
var OptionalPortal = __webpack_require__(94058);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.context.mjs
var Popover_context = __webpack_require__(69528);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/Popover.module.css.mjs
var classes = {
    "dropdown": "_93iye",
    "arrow": "_32-jt",
    "dropdownOpened": "_5LDb3"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(68064);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverDropdown/PopoverDropdown.utils.mjs
const noop = ()=>{};
function closeOnEscape(callback) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        active: true
    };
    if (typeof callback !== "function" || !options.active) {
        return options.onKeyDown || noop;
    }
    return (event)=>{
        if (event.key === "Escape") {
            var ref;
            callback(event);
            (ref = options.onTrigger) === null || ref === void 0 ? void 0 : ref.call(options);
        }
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverDropdown/PopoverDropdown.mjs













const PopoverDropdown = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { children , onKeyDownCapture , className , ...rest } = props;
    const ctx = (0,Popover_context/* usePopoverContext */.l)();
    const accessibleProps = ctx.withRoles ? {
        "aria-labelledby": ctx.getTargetId(),
        id: ctx.getDropdownId(),
        role: "dialog",
        tabIndex: -1
    } : {};
    const mergedRef = (0,use_merged_ref/* useMergedRef */.Yx)(ref, ctx.floating);
    if (ctx.disabled) {
        return null;
    }
    const getDropdownWidth = ()=>{
        if (ctx.width === "target" || ctx.width == null) return void 0;
        return typeof ctx.width === "number" ? "".concat(ctx.width, "px") : ctx.width;
    };
    var _y, _x;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(OptionalPortal/* OptionalPortal */.q, {
        ...ctx.portalProps,
        withinPortal: ctx.withinPortal
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FocusTrap/* FocusTrap */.i, {
        active: ctx.trapFocus && ctx.opened
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ...accessibleProps,
        ...rest,
        ref: mergedRef,
        onKeyDownCapture: closeOnEscape(ctx.onClose, {
            active: ctx.closeOnEscape,
            onKeyDown: onKeyDownCapture
        }),
        "data-position": ctx.placement,
        className: (0,clsx/* default */.Z)(classes.dropdown, ctx.opened && classes.dropdownOpened, className, "kohler-popover-dropdown"),
        style: {
            top: (_y = ctx.y) !== null && _y !== void 0 ? _y : 0,
            left: (_x = ctx.x) !== null && _x !== void 0 ? _x : 0,
            width: getDropdownWidth()
        }
    }, children, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FloatingArrow/* FloatingArrow */.Y, {
        ref: ctx.arrowRef,
        arrowX: ctx.arrowX,
        arrowY: ctx.arrowY,
        visible: ctx.withArrow,
        position: ctx.placement,
        arrowSize: ctx.arrowSize,
        arrowRadius: ctx.arrowRadius,
        arrowOffset: ctx.arrowOffset,
        arrowPosition: ctx.arrowPosition,
        className: (0,clsx/* default */.Z)(classes.arrow)
    }))));
});



/***/ }),

/***/ 77885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PopoverTarget; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _factory_factory_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99347);
/* harmony import */ var _Popover_context_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69528);
/* harmony import */ var _PopoverTarget_utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60169);
/* harmony import */ var _use_merged_ref_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68064);






const PopoverTarget = (0,_factory_factory_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .factory */ .d5)((props, ref)=>{
    const { children , refProp ="ref" , popupType ="dialog" , ...rest } = props;
    if (!(0,_PopoverTarget_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .k)(children)) {
        throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    }
    const forwardedProps = rest;
    const ctx = (0,_Popover_context_mjs__WEBPACK_IMPORTED_MODULE_3__/* .usePopoverContext */ .l)();
    const targetRef = (0,_use_merged_ref_mjs__WEBPACK_IMPORTED_MODULE_4__/* .useMergedRef */ .Yx)(ctx.reference, children.ref, ref);
    const accessibleProps = ctx.withRoles ? {
        "aria-haspopup": popupType,
        "aria-expanded": ctx.opened,
        "aria-controls": ctx.getDropdownId(),
        id: ctx.getTargetId()
    } : {};
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
        ...forwardedProps,
        ...accessibleProps,
        ...ctx.targetProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ctx.targetProps.className, forwardedProps.className, children.props.className, "kohler-popover-target"),
        [refProp]: targetRef,
        ...!ctx.controlled ? {
            onClick: ctx.onToggle
        } : null
    });
});



/***/ }),

/***/ 60169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ isElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isElement(value) {
    if (Array.isArray(value) || value === null) {
        return false;
    }
    if (typeof value === "object") {
        if (value.type === react__WEBPACK_IMPORTED_MODULE_0__.Fragment) {
            return false;
        }
        return true;
    }
    return false;
}



/***/ }),

/***/ 68064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yx": function() { return /* binding */ useMergedRef; }
/* harmony export */ });
/* unused harmony exports assignRef, mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function assignRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    } else if (typeof ref === "object" && ref !== null && "current" in ref) {
        ref.current = value;
    }
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (node)=>{
        refs.forEach((ref)=>assignRef(ref, node));
    };
}
function useMergedRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(mergeRefs(...refs), refs);
}



/***/ }),

/***/ 94058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ OptionalPortal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Portal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3713);


function OptionalPortal(param) {
    let { withinPortal =true , children , ...others } = param;
    if (withinPortal) {
        return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Portal */ .h, {
            ...others
        }, children);
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
}



/***/ }),

/***/ 3713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Portal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_helpers_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37892);
/* harmony import */ var _Portal_utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84914);




const Portal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref)=>{
    const { children , target , ...rest } = props;
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,_Portal_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicEffect */ .Y)(()=>{
        setMounted(true);
        nodeRef.current = !target ? (0,_Portal_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .createPortalNode */ .$)(rest) : typeof target === "string" ? document.querySelector(target) : target;
        (0,_utils_helpers_mjs__WEBPACK_IMPORTED_MODULE_3__/* .assignRef */ .kR)(ref, nodeRef.current);
        if (!target && nodeRef.current) {
            document.body.appendChild(nodeRef.current);
        }
        return ()=>{
            if (!target && nodeRef.current) {
                document.body.removeChild(nodeRef.current);
            }
        };
    }, [
        target
    ]);
    if (!mounted || !nodeRef.current) {
        return null;
    }
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(/* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children), nodeRef.current);
});



/***/ }),

/***/ 84914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ createPortalNode; },
/* harmony export */   "Y": function() { return /* binding */ useIsomorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createPortalNode(props) {
    const node = document.createElement("div");
    node.setAttribute("data-portal", "true");
    if (typeof props.className === "string") {
        node.classList.add(...props.className.split(" ").filter(Boolean));
    }
    if (typeof props.style === "object") {
        Object.assign(node.style, props.style);
    }
    if (typeof props.id === "string") {
        node.setAttribute("id", props.id);
    }
    return node;
}
const useIsomorphicEffect = typeof document !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;



/***/ }),

/***/ 19975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ createSafeContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createSafeContext(errorMessage) {
    const Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
    const useSafeContext = ()=>{
        const ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
        if (ctx === null) {
            throw new Error(errorMessage);
        }
        return ctx;
    };
    const Provider = (param)=>/* @__PURE__ */ /*#__PURE__*/ {
        let { children , value  } = param;
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
            value
        }, children);
    };
    return [
        Provider,
        useSafeContext
    ];
}



/***/ }),

/***/ 3726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Spinner; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/radii.mjs
var radii = __webpack_require__(47230);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/UIAnimations/Spinner/Spinner.module.css.mjs
var classes = {
    "spinnerCircle": "vbt4M"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/UIAnimations/Spinner/Spinner.mjs







const Spinner = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-spinner-root", className);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: 40,
        height: 40,
        padding: 4,
        borderRadius: radii/* DsmRadius.Full */.t.Full,
        backgroundColor: colors/* DsmColor.SurfacePermaBlack */.k.SurfacePermaBlack,
        className: classNames,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: 32,
        height: 32,
        borderRadius: radii/* DsmRadius.Full */.t.Full,
        className: classes.spinnerCircle
    }));
});



/***/ }),

/***/ 81060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ BREAKPOINTS; }
/* harmony export */ });
const BREAKPOINTS = {
    xl: 1920,
    l: 1600,
    m: 1024,
    s: 640,
    xs: 320
};



/***/ }),

/***/ 72531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ DsmColor; }
/* harmony export */ });
const DsmColor = {
    BackgroundPrimary: "var(--background-primary)",
    OverlayDark: "var(--overlay-dark)",
    OverlayMedium: "var(--overlay-medium)",
    OverlayLight: "var(--overlay-light)",
    ContentPrimary: "var(--content-primary)",
    ContentPrimaryHover: "var(--content-primary-hover)",
    ContentSecondary: "var(--content-secondary)",
    ContentTertiary: "var(--content-tertiary)",
    ContentError: "var(--content-error)",
    ContentWarning: "var(--content-warning)",
    ContentSuccess: "var(--content-success)",
    ContentInfo: "var(--content-info)",
    ContentBrand: "var(--content-brand)",
    ContentOnPhoto: "var(--content-on-photo)",
    ContentOnSurfaceBrand: "var(--content-on-surface-brand)",
    ContentOnSurfaceActionPrimary: "var(--content-on-surface-action-primary)",
    ContentOnSurfaceActionSecondary: "var(--content-on-surface-action-secondary)",
    ContentOnSurfaceInfo: "var(--content-on-surface-info)",
    ContentActionDefault: "var(--content-action-default)",
    ContentActionDefaultHover: "var(--content-action-default-hover)",
    ContentActionInactive: "var(--content-action-inactive)",
    ContentOnSurfaceActionInactive: "var(--content-on-surface-action-inactive)",
    ContentPermaWhite: "var(--content-perma-white)",
    ContentOnSurfacePermaWhite: "var(--content-on-surface-perma-white)",
    ContentOnSurfaceError: "var(--content-on-surface-error)",
    BorderPrimary: "var(--border-primary)",
    BorderSecondary: "var(--border-secondary)",
    BorderTertiary: "var(--border-tertiary)",
    BorderNeutralHighContrast: "var(--border-neutral-high-contrast)",
    BorderNeutralMediumContrast: "var(--border-neutral-medium-contrast)",
    BorderNeutralLowContrast: "var(--border-neutral-low-contrast)",
    BorderError: "var(--border-error)",
    BorderWarning: "var(--border-warning)",
    BorderSuccess: "var(--border-success)",
    BorderBrand: "var(--border-brand)",
    BorderPermaWhite: "var(--border-perma-white)",
    SurfacePermaWhite: "var(--surface-perma-white)",
    SurfacePermaDark: "var(--surface-perma-dark)",
    SurfacePermaBlack: "var(--surface-perma-black)",
    SurfaceTransparent: "var(--surface-transparent)",
    SurfaceActionPrimary: "var(--surface-action-primary)",
    SurfaceActionPrimaryHover: "var(--surface-action-primary-hover)",
    SurfaceActionSecondary: "var(--surface-action-secondary)",
    SurfaceActionSecondaryHover: "var(--surface-action-secondary-hover)",
    SurfaceActionBrand: "var(--surface-action-brand)",
    SurfaceActionBrandHover: "var(--surface-action-brand-hover)",
    SurfaceActionInactive: "var(--surface-action-inactive)",
    SurfaceActionInvert: "var(--surface-action-invert)",
    SurfaceActionInvertHover: "var(--surface-action-invert-hover)",
    SurfaceActionUnselected: "var(--surface-action-unselected)",
    SurfaceActionSelected: "var(--surface-action-selected)",
    SurfaceNeutralLowContrast: "var(--surface-neutral-low-contrast)",
    SurfaceNeutralMediumContrast: "var(--surface-neutral-medium-contrast)",
    SurfaceNeutralHighContrast: "var(--surface-neutral-high-contrast)",
    SurfaceError: "var(--surface-error)",
    SurfaceWarning: "var(--surface-warning)",
    SurfaceSuccess: "var(--surface-success)",
    SurfaceInfo: "var(--surface-info)",
    SurfaceHighlightLowContrast: "var(--surface-highlight-low-contrast)",
    SurfaceHighlightMediumContrast: "var(--surface-highlight-medium-contrast)",
    SurfaceColorSwatchDefault: "var(--surface-color-swatch-default)",
    SurfaceColorSwatch1: "var(--surface-color-swatch-1)",
    SurfaceColorSwatch2: "var(--surface-color-swatch-2)",
    SurfaceColorSwatch3: "var(--surface-color-swatch-3)",
    SurfaceColorSwatch4: "var(--surface-color-swatch-4)",
    SurfaceColorSwatch5: "var(--surface-color-swatch-5)",
    SurfaceColorSwatch6: "var(--surface-color-swatch-6)",
    SurfaceColorSwatch7: "var(--surface-color-swatch-7)",
    SurfaceColorSwatch8: "var(--surface-color-swatch-8)",
    SurfaceColorSwatch9: "var(--surface-color-swatch-9)"
};



/***/ }),

/***/ 47230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ DsmRadius; }
/* harmony export */ });
const DsmRadius = {
    None: "var(--radius-none)",
    Xs: "var(--radius-xs)",
    S: "var(--radius-s)",
    M: "var(--radius-m)",
    Full: "var(--radius-full)"
};



/***/ }),

/***/ 99347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ createPolymorphicComponent; },
/* harmony export */   "bq": function() { return /* binding */ polymorphicFactory; },
/* harmony export */   "d5": function() { return /* binding */ factory; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createPolymorphicComponent(component) {
    return component;
}
function polymorphicFactory(ui) {
    const Component = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ui);
    return Component;
}
function factory(ui) {
    const Component = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ui);
    return Component;
}



/***/ }),

/***/ 37892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "Kh": function() { return /* binding */ camelToKebabCase; },
/* harmony export */   "Q1": function() { return /* binding */ pxToRem; },
/* harmony export */   "XP": function() { return /* binding */ keys; },
/* harmony export */   "kR": function() { return /* binding */ assignRef; },
/* harmony export */   "rW": function() { return /* binding */ omitText; },
/* harmony export */   "t_": function() { return /* binding */ removeEmptyProps; },
/* harmony export */   "uZ": function() { return /* binding */ clamp; }
/* harmony export */ });
function camelToKebabCase(value) {
    return value.replace(/[A-Z]/g, (letter)=>"-".concat(letter.toLowerCase()));
}
function removeEmptyProps(obj) {
    return Object.fromEntries(Object.entries(obj).filter((param)=>{
        let [, v] = param;
        return v != null;
    }));
}
function pxToRem(pxValue) {
    let baseFontSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    if (typeof pxValue === "number") {
        pxValue = pxValue.toString() + "px";
    }
    if (pxValue.endsWith("px")) {
        const px = parseFloat(pxValue);
        const remValue = px / baseFontSize;
        return remValue + "rem";
    }
    return pxValue.toString();
}
function keys(object) {
    return Object.keys(object);
}
function assignRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    } else if (typeof ref === "object" && ref !== null && "current" in ref) {
        ref.current = value;
    }
}
function clamp(value, min, max) {
    if (min === void 0 && max === void 0) {
        return value;
    }
    if (min !== void 0 && max === void 0) {
        return Math.max(value, min);
    }
    if (min === void 0 && max !== void 0) {
        return Math.min(value, max);
    }
    return Math.min(Math.max(value, min), max);
}
function isObject(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function debounce(func, wait, options) {
    let lastArgs;
    let lastThis;
    let maxWait;
    let result;
    let timerId;
    let lastCallTime;
    let lastInvokeTime = 0;
    let leading = false;
    let maxing = false;
    let trailing = true;
    if (typeof func !== "function") {
        throw new TypeError("Expected a function");
    }
    wait = +wait || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        const args = lastArgs;
        const thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function startTimer(pendingFunc, milliseconds) {
        return setTimeout(pendingFunc, milliseconds);
    }
    function cancelTimer(id) {
        clearTimeout(id);
    }
    function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = startTimer(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        const timeSinceLastCall = time - (lastCallTime || 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        const timeWaiting = wait - timeSinceLastCall;
        return maxing ? Math.min(timeWaiting, (maxWait || 0) - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = time - (lastCallTime || 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= (maxWait || 0);
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        timerId = startTimer(timerExpired, remainingWait(time));
        return void 0;
    }
    function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
    }
    function cancel() {
        if (timerId !== void 0) {
            cancelTimer(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
        return timerId === void 0 ? result : trailingEdge(Date.now());
    }
    function pending() {
        return timerId !== void 0;
    }
    const debounced = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        lastArgs = args;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === void 0) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                timerId = startTimer(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === void 0) {
            timerId = startTimer(timerExpired, wait);
        }
        return result;
    };
    debounced.cancel = cancel;
    debounced.flush = flush;
    debounced.pending = pending;
    return debounced;
}
function omitText(obj) {
    const { text: _ , ...rest } = obj;
    return rest;
}



/***/ }),

/***/ 48318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ createOptionalContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createOptionalContext() {
    let initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    const Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
    const useOptionalContext = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
    const Provider = (param)=>/* @__PURE__ */ /*#__PURE__*/ {
        let { children , value  } = param;
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
            value
        }, children);
    };
    return [
        Provider,
        useOptionalContext
    ];
}



/***/ }),

/***/ 55580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "kw": function() { return /* binding */ useUnmount; },
/* harmony export */   "lR": function() { return /* binding */ useDidUpdate; },
/* harmony export */   "m2": function() { return /* binding */ useRandomClassName; },
/* harmony export */   "sm": function() { return /* binding */ useWindowEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useRandomClassName() {
    const randomId = Math.random().toString(36).substring(2, 10);
    return "__m__-".concat(randomId);
}
function useWindowEvent(type, listener, options) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        window.addEventListener(type, listener, options);
        return ()=>window.removeEventListener(type, listener, options);
    }, [
        type,
        listener
    ]);
}
function useDidUpdate(fn, dependencies) {
    const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (mounted.current) {
            return fn();
        }
        mounted.current = true;
        return void 0;
    }, dependencies);
}
const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
function useUnmount(func) {
    const funcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(func);
    funcRef.current = func;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}



/***/ }),

/***/ 53724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useIsomorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useIsomorphicEffect = typeof document !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;



/***/ }),

/***/ 18657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useUncontrolled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useUncontrolled(param) {
    let { value , defaultValue , finalValue , onChange =()=>{}  } = param;
    const [uncontrolledValue, setUncontrolledValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue !== void 0 ? defaultValue : finalValue);
    const handleUncontrolledChange = function(val) {
        for(var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            payload[_key - 1] = arguments[_key];
        }
        setUncontrolledValue(val);
        onChange === null || onChange === void 0 ? void 0 : onChange(val, ...payload);
    };
    if (value !== void 0) {
        return [
            value,
            onChange,
            true
        ];
    }
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
}



/***/ }),

/***/ 17677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55580);
/* harmony import */ var _use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53724);



const eventListenerOptions = {
    passive: true
};
function useWindowSize() {
    const getSize = ()=>({
            width:  true ? window.innerWidth : 0,
            height:  true ? window.innerHeight : 0
        });
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize);
    const updateSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        setWindowSize(getSize());
    }, []);
    (0,_hooks_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .sm)("resize", updateSize, eventListenerOptions);
    (0,_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicEffect */ .Y)(()=>{
        var ref;
        const orientation = (ref = window.screen) === null || ref === void 0 ? void 0 : ref.orientation;
        if (!orientation) return;
        orientation.addEventListener("change", updateSize);
        return ()=>orientation.removeEventListener("change", updateSize);
    }, [
        updateSize
    ]);
    (0,_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicEffect */ .Y)(()=>{
        updateSize();
    }, []);
    return windowSize;
}



/***/ }),

/***/ 46548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k0": function() { return /* binding */ spacingResolver; },
/* harmony export */   "s_": function() { return /* binding */ resolvers; }
/* harmony export */ });
/* unused harmony export sizeResolver */
/* harmony import */ var _helpers_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37892);

function colorResolver(color) {
    if (typeof color === "string") return color;
    return color;
}
function fontFamilyResolver(fontFamily) {
    const fontFamilyValues = {
        text: "var(--serif-font-family)"
    };
    if (typeof fontFamily === "string" && fontFamily in fontFamilyValues) {
        return fontFamilyValues[fontFamily];
    }
    return fontFamily;
}
function fontSizeResolver(value) {
    if (typeof value === "number") {
        return (0,_helpers_mjs__WEBPACK_IMPORTED_MODULE_0__/* .pxToRem */ .Q1)(value);
    }
    if (typeof value === "string") {
        if (value.endsWith("px")) {
            return (0,_helpers_mjs__WEBPACK_IMPORTED_MODULE_0__/* .pxToRem */ .Q1)(value);
        } else if (value.endsWith("rem")) {
            return value;
        }
    }
    return value;
}
function identityResolver(value) {
    return value;
}
function sizeResolver(value) {
    if (typeof value === "number") {
        return "".concat(value, "px");
    }
    return value;
}
function spacingResolver(value) {
    if (typeof value === "number" || !isNaN(Number(value))) {
        return "".concat(value, "px");
    }
    if (typeof value === "string") {
        return "".concat(value);
    }
    return value;
}
function lineHeightResolver(value) {
    if (typeof value === "number") {
        return "".concat(value, "px");
    }
    if (typeof value === "string") {
        return "".concat(value);
    }
    return value;
}
const resolvers = {
    identity: identityResolver,
    size: sizeResolver,
    spacing: spacingResolver,
    color: colorResolver,
    textColor: colorResolver,
    fontSize: fontSizeResolver,
    lineHeight: lineHeightResolver,
    fontFamily: fontFamilyResolver
};



/***/ }),

/***/ 79111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nM": function() { return /* binding */ parseStyleProps; }
});

// UNUSED EXPORTS: cssObjectToString, getBaseValue, getBreakpointKeys, getBreakpointValue, hasResponsiveStyles, stylesToString

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/breakpoints.mjs
var constants_breakpoints = __webpack_require__(81060);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/mediaQuery.mjs
function replaceMediaQuery(query) {
    return query.replace("(width <", "").replace("px)", "");
}
function sortMediaQueries(param) {
    let { media , ...props } = param;
    const breakpoints = Object.keys(media);
    const sortedMedia = breakpoints.sort((a, b)=>Number(replaceMediaQuery(b)) - Number(replaceMediaQuery(a))).map((query)=>({
            query,
            styles: media[query]
        }));
    return {
        ...props,
        media: sortedMedia
    };
}


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/resolvers.mjs
var resolvers = __webpack_require__(46548);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs




function stylesToString(param) {
    let { selector , styles , media  } = param;
    const baseStyles = styles ? cssObjectToString(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>"@media ".concat(item.query, "{").concat(selector, "{").concat(cssObjectToString(item.styles), "}}"));
    return "".concat(baseStyles ? "".concat(selector, "{").concat(baseStyles, "}") : "").concat(mediaQueryStyles.join("")).trim();
}
function cssObjectToString(css) {
    return keys(css).reduce((acc, rule)=>css[rule] !== void 0 ? "".concat(acc).concat(camelToKebabCase(rule), ":").concat(css[rule], ";") : acc, "").trim();
}
function hasResponsiveStyles(styleProp) {
    if (typeof styleProp !== "object" || styleProp === null) {
        return false;
    }
    const breakpoints = Object.keys(styleProp);
    if (breakpoints.length === 1 && breakpoints[0] === "base") {
        return false;
    }
    return true;
}
function getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) {
            return value.base;
        }
        return void 0;
    }
    return value;
}
function getBreakpointKeys(value) {
    if (typeof value === "object" && value !== null) {
        return (0,helpers/* keys */.XP)(value).filter((key)=>key !== "base");
    }
    return [];
}
function getBreakpointValue(value, breakpoint) {
    if (typeof value === "object" && value !== null && breakpoint in value) {
        return value[breakpoint];
    }
    return value;
}
function parseStyleProps(param) {
    let { styleProps , data  } = param;
    return sortMediaQueries((0,helpers/* keys */.XP)(styleProps).reduce((acc, styleProp)=>{
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [
            propertyData.property
        ];
        const baseValue = getBaseValue(styleProps[styleProp]);
        if (!hasResponsiveStyles(styleProps[styleProp])) {
            properties.forEach((property)=>{
                acc.inlineStyles[property] = resolvers/* resolvers */.s_[propertyData.type](baseValue);
            });
            return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = getBreakpointKeys(styleProps[styleProp]);
        if (baseValue !== void 0) {
            acc.styles[styleProp] = baseValue;
        }
        properties.forEach((property)=>{
            if (baseValue) {
                acc.styles[property] = resolvers/* resolvers */.s_[propertyData.type](baseValue);
            }
            breakpoints.forEach((breakpoint)=>{
                const bp = "(width < ".concat(constants_breakpoints/* BREAKPOINTS */.j[breakpoint], "px)");
                acc.media[bp] = {
                    ...acc.media[bp],
                    [property]: resolvers/* resolvers */.s_[propertyData.type](getBreakpointValue(styleProps[styleProp], breakpoint))
                };
            });
        });
        return acc;
    }, {
        hasResponsiveStyles: false,
        inlineStyles: {},
        styles: {},
        media: {}
    }));
}



/***/ }),

/***/ 60068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArrowDownBoldIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 22,
    small: 16,
    xSmall: 12
};
const ArrowDownBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 16 16",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
    }));
};
ArrowDownBoldIcon.iconName = "ArrowDownBoldIcon";



/***/ }),

/***/ 62281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ArrowDownIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 22,
    small: 16,
    xSmall: 10
};
const ArrowDownIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M34.2662 11L35 11.6545L20 29L5 11.6357L5.76447 11.0188L20 27.4463L34.2662 11Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 5.45996L17.8645 6.1439L9.99978 14.533L2.13501 6.1439L2.86455 5.45996L9.99978 13.0709L17.135 5.45996Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 5.45996L17.8645 6.1439L9.99978 14.533L2.13501 6.1439L2.86455 5.45996L9.99978 13.0709L17.135 5.45996Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.75258 9L4 9.6585L15 22L26 9.6396L25.216 9.0189L15 20.5472L4.75258 9Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowDownIcon.iconName = "ArrowDownIcon";



/***/ }),

/***/ 90751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ArrowLeftIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 13,
    small: 9,
    xSmall: 8
};
const ArrowLeftIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29 5.73378L28.3455 5L11 20L28.3643 35L28.9812 34.2355L12.5537 20L29 5.73378Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.533 17.135L13.849 17.8645L5.45996 9.99978L13.849 2.13501L14.533 2.86455L6.92202 9.99978L14.533 17.135Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.533 17.135L13.849 17.8645L5.45996 9.99978L13.849 2.13501L14.533 2.86455L6.92202 9.99978L14.533 17.135Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21 4.75258L20.3415 4L8.00001 15L20.3604 26L20.9811 25.216L9.45275 15L21 4.75258Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowLeftIcon.iconName = "ArrowLeftIcon";



/***/ }),

/***/ 64260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ArrowRightBoldIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 19,
    medium: 16,
    small: 12,
    xSmall: 9
};
const ArrowRightBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 16 16",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
    }));
};
ArrowRightBoldIcon.iconName = "ArrowRightBoldIcon";



/***/ }),

/***/ 51782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ArrowRightIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 18,
    medium: 13,
    small: 9,
    xSmall: 9
};
const ArrowRightIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 5.73378L11.6545 5L29 20L11.6357 35L11.0188 34.2355L27.4463 20L11 5.73378Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.45996 17.1399L6.1439 17.8694L14.533 10.0047L6.1439 2.13989L5.45996 2.86943L13.0709 10.0047L5.45996 17.1399Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.45996 17.1399L6.1439 17.8694L14.533 10.0047L6.1439 2.13989L5.45996 2.86943L13.0709 10.0047L5.45996 17.1399Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9 25.2474L9.6585 26L22 15L9.63961 4L9.0189 4.78404L20.5472 15L9 25.2474Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowRightIcon.iconName = "ArrowRightIcon";



/***/ }),

/***/ 7673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BackToTopIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 16,
    medium: 10,
    small: 10,
    xSmall: 6
};
const BackToTopIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M19.8995 10.9497L14.9497 6L10 10.9497L10.7071 11.6569L14.4497 7.91421V24.9497H15.4497V7.91421L19.1924 11.6569L19.8995 10.9497Z",
        fill: "currentColor"
    }));
};
BackToTopIcon.iconName = "BackToTopIcon";



/***/ }),

/***/ 21421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CheckmarkIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 24,
    medium: 14,
    small: 14,
    xSmall: 12
};
const CheckmarkIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.9601 3.27002L13.7127 3.92852L6.03151 12.707L2.30005 8.97556L3.00716 8.26845L5.98216 11.2436L12.9601 3.27002Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    fill: "none",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.2853 4.5L17 5.15557L8.59735 15.5L3 10.7495L3.57941 9.97664L8.46677 14.1253L16.2853 4.5Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "large":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.2853 9L22 9.65557L13.5973 20L8 15.2495L8.57941 14.4766L13.4668 18.6253L21.2853 9Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
CheckmarkIcon.iconName = "CheckmarkIcon";



/***/ }),

/***/ 61599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 17,
    small: 10,
    xSmall: 10
};
const CloseIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M20.3521 20.0021L33.7871 6.56709L33.08 5.85999L19.645 19.295L6.91707 6.56709L6.20996 7.2742L18.9379 20.0021L6.20996 32.73L6.91707 33.4371L19.645 20.7092L33.08 34.1443L33.7871 33.4371L20.3521 20.0021Z",
                    fill: "currentColor"
                }));
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M3.70428 3L12.8599 12.2857L12.1556 13L3 3.71429L3.70428 3Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M12.2957 3.00001L3.1401 12.2857L3.84438 13L13 3.71429L12.2957 3.00001Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M5.70428 5L14.8599 14.2857L14.1556 15L5 5.71429L5.70428 5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.2957 5.00001L5.1401 14.2857L5.84438 15L15 5.71429L14.2957 5.00001Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
CloseIcon.iconName = "CloseIcon";



/***/ }),

/***/ 66020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ DropdownIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 20,
    medium: 13,
    small: 10,
    xSmall: 8
};
const DropdownIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1814 11L21 11.6448L14.5 18.8179L8 11.6448L8.78228 11L14.5 17.2061L20.1814 11Z",
        fill: "white"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1814 11L21 11.6448L14.5 18.8179L8 11.6448L8.78228 11L14.5 17.2061L20.1814 11Z",
        fill: "currentColor"
    }));
};
DropdownIcon.iconName = "DropdownIcon";



/***/ }),

/***/ 72712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ EmailIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 21,
    small: 14,
    xSmall: 11
};
const EmailIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 7.5V22.5H4.5V7.5H25.5ZM6.34288 8.5L15 14.879L23.6571 8.5H6.34288ZM24.5 9.12108V21.5H5.5V9.12108L15 16.1211L24.5 9.12108Z",
        fill: "currentColor"
    }));
};
EmailIcon.iconName = "EmailIcon";



/***/ }),

/***/ 57537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ExternalLinkIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 22,
    medium: 15,
    small: 15,
    xSmall: 13
};
const ExternalLinkIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "xSmall":
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    fill: "none",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M17.5 2.4978V9.00231H16.5V4.20941L8.5 12.2094L7.79289 11.5023L15.7824 3.51282L11.0045 3.55614L10.9955 2.55618L17.5 2.4978Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M2.5 17.5023V2.49807L6.67089 2.55019L6.66244 3.55016L3.5 3.50531V16.5023H16.5V13.3356H17.5V17.5023H2.5Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "large":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M22.5 7.49548V14H21.5V9.20709L13.5 17.2071L12.7929 16.5L20.7824 8.5105L16.0045 8.55382L15.9955 7.55386L22.5 7.49548Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M7.5 22.5V7.49575L11.6709 7.54788L11.6624 8.54784L8.5 8.50299V21.5H21.5V18.3333H22.5V22.5H7.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ExternalLinkIcon.iconName = "ExternalLinkIcon";



/***/ }),

/***/ 26215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FavoriteIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 22,
    medium: 15,
    small: 14,
    xSmall: 9
};
const FavoriteIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6406 9.68848L15.001 10.334L14.3616 9.68848C12.7924 8.10384 10.2463 8.10384 8.67709 9.68848C7.15124 11.2294 7.10377 13.7186 8.56434 15.297L8.67074 15.4086L15.0011 21.8015L21.3085 15.4322L21.4152 15.3211C22.8956 13.7217 22.854 11.2324 21.3251 9.68848C19.756 8.10384 17.2098 8.10384 15.6406 9.68848ZM20.6146 10.3921C21.7667 11.5556 21.7981 13.4353 20.6876 14.6352L20.5925 14.7341L15.001 20.38L9.38766 14.7115L9.29297 14.6122C8.20195 13.433 8.2378 11.5533 9.38766 10.3921C10.5655 9.20263 12.4732 9.20263 13.651 10.3921L15.0011 11.7555L16.3512 10.3921C17.5291 9.20263 19.4367 9.20263 20.6146 10.3921Z",
        fill: "currentColor"
    }));
};
FavoriteIcon.iconName = "FavoriteIcon";



/***/ }),

/***/ 15730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ FilterIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 32,
    medium: 21,
    small: 15,
    xSmall: 12
};
const FilterIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12.5025C18.7917 12.5309 17.7375 11.6876 17.5 10.5025H4.5V9.50251H17.5C17.7366 8.33734 18.7611 7.5 19.95 7.5C21.1389 7.5 22.1634 8.33734 22.4 9.50251H25.5V10.5025H22.45C22.2159 11.6688 21.1896 12.5067 20 12.5025ZM20 8.50293C19.1716 8.50293 18.5 9.1745 18.5 10.0029C18.5 10.8314 19.1716 11.5029 20 11.5029C20.8284 11.5029 21.5 10.8314 21.5 10.0029C21.5 9.1745 20.8284 8.50293 20 8.50293Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 19.5278C7.7264 18.3507 8.75636 17.5 9.955 17.5C11.1536 17.5 12.1836 18.3507 12.41 19.5278H25.5V20.5278H12.45C12.2556 21.7579 11.1854 22.6572 9.94026 22.6371C8.69509 22.617 7.65459 21.6835 7.5 20.4478H4.5V19.4478L7.5 19.5278ZM9.95996 21.5273C10.7884 21.5273 11.46 20.8558 11.46 20.0273C11.46 19.1989 10.7884 18.5273 9.95996 18.5273C9.13153 18.5273 8.45996 19.1989 8.45996 20.0273C8.46517 20.4287 8.63103 20.8113 8.92045 21.0894C9.20987 21.3675 9.5987 21.5181 9.99996 21.5073L9.95996 21.5273Z",
        fill: "currentColor"
    }));
};
FilterIcon.iconName = "FilterIcon";



/***/ }),

/***/ 33804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InternalLinkIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 28,
    medium: 18,
    small: 13,
    xSmall: 11
};
const InternalLinkIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3536 13.1213L8.17157 16.3033C6.60948 17.8654 6.60948 20.3981 8.17157 21.9602C9.68633 23.4749 12.1137 23.5208 13.6838 22.0979L13.8284 21.9602L17.0104 18.7782L17.7175 19.4853L14.5355 22.6673C12.5829 24.6199 9.41709 24.6199 7.46447 22.6673C5.56323 20.766 5.5132 17.7146 7.31437 15.7528L7.46447 15.5962L10.6464 12.4142L11.3536 13.1213ZM18.7782 12.0607L12.4142 18.4246L11.7071 17.7175L18.0711 11.3536L18.7782 12.0607ZM22.6673 7.46447C24.5607 9.35792 24.6181 12.3922 22.8394 14.3547L22.6673 14.5355L19.4853 17.7175L18.7782 17.0104L21.9602 13.8284L22.0979 13.6838C23.5208 12.1137 23.4749 9.68633 21.9602 8.17157C20.4501 6.66155 18.0332 6.61121 16.4627 8.02057L16.3033 8.17157L13.1213 11.3536L12.4142 10.6464L15.5962 7.46447L15.7528 7.31437C17.7146 5.5132 20.766 5.56323 22.6673 7.46447Z",
        fill: "currentColor"
    }));
};
InternalLinkIcon.iconName = "InternalLinkIcon";



/***/ }),

/***/ 24665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MenuIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 26,
    medium: 20,
    small: 13,
    xSmall: 10
};
const MenuIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M5 7.5H25V8.5H5V7.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M5 14.5H25V15.5H5V14.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M25 21.5H5V22.5H25V21.5Z",
        fill: "currentColor"
    }));
};
MenuIcon.iconName = "MenuIcon";



/***/ }),

/***/ 2722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PlayIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 22,
    medium: 18,
    small: 12,
    xSmall: 9
};
const PlayIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4 3L16 10.0004L4 17V3ZM5 4.74001V15.259L14.015 10L5 4.74001Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "large":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.5 5V24.7098L24.0199 14.8549L6.5 5ZM7.5 6.70992L21.98 14.8549L7.5 22.9989V6.70992Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
PlayIcon.iconName = "PlayIcon";



/***/ }),

/***/ 35114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ PlusIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 20,
    small: 14,
    xSmall: 10
};
const PlusIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M19.5 5V35H20.5V5H19.5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M5 19.5H35V20.5H5V19.5Z",
                    fill: "currentColor"
                }));
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M7.64286 3V13H8.35714V3H7.64286Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M3 7.64286H13V8.35714H3V7.64286Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M9.5 3.5V17.5H10.5V3.5H9.5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M3 10H17V11H3V10Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.5 5V25H15.5V5H14.5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M5 14.5H25V15.5H5V14.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
PlusIcon.iconName = "PlusIcon";



/***/ }),

/***/ 86957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PrintIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 22,
    medium: 17,
    small: 12,
    xSmall: 9
};
const PrintIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5 6.5V10.5H23.5V18.5H20.5V23.5H9.5V18.5H6.5V10.5H9.5V6.5H20.5ZM7.5 17.5H22.5V11.5H20.5V14.5H9.5V11.5H7.5V17.5ZM19.5 18.5H10.5V22.5H19.5V18.5ZM19.5 7.5V13.5H10.5V7.5H19.5Z",
        fill: "currentColor"
    }));
};
PrintIcon.iconName = "PrintIcon";



/***/ }),

/***/ 72457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 24,
    medium: 18,
    small: 12,
    xSmall: 10
};
const SearchIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5312 6C9.37186 6 6 9.37186 6 13.5312C6 17.6906 9.37186 21.0625 13.5312 21.0625C15.431 21.0625 17.1665 20.3591 18.4914 19.1985L23.2558 23.9629L23.9629 23.2558L19.1985 18.4914C20.3591 17.1665 21.0625 15.431 21.0625 13.5312C21.0625 9.37186 17.6906 6 13.5312 6ZM13.5312 7C17.1384 7 20.0625 9.92414 20.0625 13.5312C20.0625 17.1384 17.1384 20.0625 13.5312 20.0625C9.92414 20.0625 7 17.1384 7 13.5312C7 9.92414 9.92414 7 13.5312 7Z",
        fill: "currentColor"
    }));
};
SearchIcon.iconName = "SearchIcon";



/***/ }),

/***/ 26721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ShareIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 20,
    medium: 14,
    small: 12,
    xSmall: 9
};
const ShareIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M18.1746 11.0382L18.8254 10.2789L15.5 7.42857V7.37963H15.4429L15 7L14.5571 7.37963H14.5V7.42857L11.1746 10.2789L11.8254 11.0382L14.5 8.74604V18.3796H15.5V8.74604L18.1746 11.0382Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M11.5 14.8796V13.8796H8V22.8796H22V13.8796H18.5V14.8796H21V21.8796H9V14.8796H11.5Z",
        fill: "currentColor"
    }));
};
ShareIcon.iconName = "ShareIcon";



/***/ }),

/***/ 62794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ TooltipInfoIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 23,
    small: 16,
    xSmall: 13
};
const TooltipInfoIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M20.8865 15.02V13.148H19.3565V15.02H20.8865Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M20.8865 26V16.694H19.3565V26H20.8865Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20 5C28.2843 5 35 11.7157 35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5ZM20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M11 5V7H9V5H11Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M11 14V8H9V14H11Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
TooltipInfoIcon.iconName = "TooltipInfoIcon";



/***/ }),

/***/ 15051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ VisualSearchIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 25,
    medium: 19,
    small: 14,
    xSmall: 10
};
const VisualSearchIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6.5 22C6.5 22.8284 7.17157 23.5 8 23.5H13V24.5H8C6.61929 24.5 5.5 23.3807 5.5 22V17H6.5V22Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M24.5 22C24.5 23.3807 23.3807 24.5 22 24.5H17V23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V17H24.5V22Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 10.5C17.4853 10.5 19.5 12.5147 19.5 15C19.5 17.4853 17.4853 19.5 15 19.5C12.5147 19.5 10.5 17.4853 10.5 15C10.5 12.5147 12.5147 10.5 15 10.5ZM15 11.5C13.067 11.5 11.5 13.067 11.5 15C11.5 16.933 13.067 18.5 15 18.5C16.933 18.5 18.5 16.933 18.5 15C18.5 13.067 16.933 11.5 15 11.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13 6.5H8C7.17157 6.5 6.5 7.17157 6.5 8V13H5.5V8C5.5 6.61929 6.61929 5.5 8 5.5H13V6.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M22 5.5C23.3807 5.5 24.5 6.61929 24.5 8V13H23.5V8C23.5 7.17157 22.8284 6.5 22 6.5H17V5.5H22Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M20.5 8.5C21.0523 8.5 21.5 8.94772 21.5 9.5C21.5 10.0523 21.0523 10.5 20.5 10.5C19.9477 10.5 19.5 10.0523 19.5 9.5C19.5 8.94772 19.9477 8.5 20.5 8.5Z",
        fill: "currentColor"
    }));
};
VisualSearchIcon.iconName = "VisualSearchIcon";



/***/ }),

/***/ 94802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ iconSize; }
/* harmony export */ });
const iconSize = {
    large: 40,
    medium: 30,
    small: 20,
    xSmall: 16
};



/***/ }),

/***/ 9421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FAQ; }
});

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.mjs + 2 modules
var Spacer = __webpack_require__(38466);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(3171);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Accordion/Accordion.mjs + 2 modules
var Accordion = __webpack_require__(97987);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/TextBlocks/FAQ/FAQ.module.css.mjs
var classes = {
    "faqContainer": "ljJ2u",
    "gridColumnContainer": "_89a06",
    "gridColumnContainerFull": "_2axci",
    "faqHeader": "Xt7Zu",
    "faqHeaderContent": "FGD3h",
    "faqButton": "Uv9Oz"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/TextBlocks/FAQ/FAQ.mjs




const FAQ = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { mod , heading , description , CTA , accordions , showHeader =true , topSpacer , bottomSpacer , CTALink , className , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mod,
        component: "div",
        className: (0,clsx/* default */.Z)("kohler-faq-root", className, classes.faqContainer),
        ref,
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary,
        ...rest
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: "center-grid"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(classes.gridColumnContainer, !showHeader && classes.gridColumnContainerFull)
    }, showHeader && (heading || description || CTA || CTALink) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: classes.faqHeader
    }, (heading || description || CTA || CTALink) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        className: classes.faqHeaderContent
    }, heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: heading.component || "h2",
        ...(0,helpers/* omitText */.rW)(heading),
        size: "h2",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary
    }, heading.text), (description || CTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 50
    }, description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        ...(0,helpers/* omitText */.rW)(description),
        size: "paragraph-large",
        textColor: colors/* DsmColor.ContentTertiary */.k.ContentTertiary
    }, description.text), CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        size: "large",
        variant: "secondary",
        component: "a",
        ...(0,helpers/* omitText */.rW)(CTA),
        className: classes.faqButton
    }, CTA.text)), CTALink && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        ...(0,helpers/* omitText */.rW)(CTALink),
        size: "large",
        width: "fit-content"
    }, CTALink.text))), accordions && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        margin: 0,
        component: "ul"
    }, accordions.map((accordion, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Accordion/* Accordion */.U, {
            ...accordion,
            key: "".concat(accordion.title.text, "-").concat(index),
            title: accordion.title,
            component: "li",
            type: "default",
            size: "large",
            divider: index + 1 === accordions.length,
            toggleCallback: accordion.toggleCallback
        }, accordion.children))))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});



/***/ }),

/***/ 92186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ChangePassword":"ChangePassword_ChangePassword__EXQIE","ChangePassword_ChangePassword__EXQIE":"ChangePassword_ChangePassword_ChangePassword__EXQIE__0iYCY","wrapper":"ChangePassword_wrapper__b7Otu","Button_buttonWrapper__9Vvy_":"ChangePassword_Button_buttonWrapper__9Vvy___2C3rT","button":"ChangePassword_button__PC3iI","large":"ChangePassword_large__vIg_s","kf-react-button":"ChangePassword_kf-react-button__094_k","Input_inputFieldWrapper__nt6o0":"ChangePassword_Input_inputFieldWrapper__nt6o0__V8Dub","input-field__value":"ChangePassword_input-field__value__RmQ0l","kf-change-re-password-wrapper":"ChangePassword_kf-change-re-password-wrapper__yNcoL"};

/***/ }),

/***/ 50238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authUtilityNavWrapper":"AuthUtilityNav_authUtilityNavWrapper__iJgYU"};

/***/ }),

/***/ 43419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CarouselSlickVertical":"CarouselSlick_CarouselSlickVertical__Ff6xM"};

/***/ }),

/***/ 19371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"countrySelectorMain":"CountryUtilNav_countrySelectorMain__0qrTO","fadeout":"CountryUtilNav_fadeout__5AsJW","fadein":"CountryUtilNav_fadein__g_qQo"};

/***/ }),

/***/ 31901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dynamicSearchViewWrapper":"DynamicSearch_view_dynamicSearchViewWrapper__QSYex"};

/***/ }),

/***/ 38326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoBannerWrapper":"v1_promoBannerWrapper__J4Pwk"};

/***/ }),

/***/ 81146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VideoControls":"VideoControls_VideoControls__NEYuS","playToggle":"VideoControls_playToggle__QYixk","progress":"VideoControls_progress__3AOQ7","progressSlider":"VideoControls_progressSlider__uFTlE","audioControls":"VideoControls_audioControls__DYUbh","screenReaderAnnouncement":"VideoControls_screenReaderAnnouncement__bFL4z","time":"VideoControls_time__NKclA","timeSeparator":"VideoControls_timeSeparator__GbO9a","captions":"VideoControls_captions__qqGSL","active":"VideoControls_active__GksDf","fullscreen":"VideoControls_fullscreen__LFS5p","videoControls":"VideoControls_videoControls__XHA3_"};

/***/ }),

/***/ 62271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findAProByZipWrapper":"v1_findAProByZipWrapper__9w7Jq"};

/***/ }),

/***/ 4201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findAStoreUtilNavWrapper":"v1_findAStoreUtilNavWrapper__zMdNe","findstore-util-nav__container":"v1_findstore-util-nav__container__jdVZe","findstore-util-nav__link-container":"v1_findstore-util-nav__link-container__3HSN5"};

/***/ }),

/***/ 56541:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ComingSoonContainer":"comingSoon_ComingSoonContainer___hgg7"};

/***/ }),

/***/ 204:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorFallBack_ErrorContainer__mwtxa"};

/***/ }),

/***/ 5835:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FileUploadContainer":"FileUpload_FileUploadContainer__TrwvS","DropzoneArea":"FileUpload_DropzoneArea__nwBAv","ImageUploadError":"FileUpload_ImageUploadError__UMUe3"};

/***/ }),

/***/ 13803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GlobalVisualSearchContainer":"GlobalVSContent_GlobalVisualSearchContainer__ApDQx","firstTimeVSContainer":"GlobalVSContent_firstTimeVSContainer__mC7eW","tooltipBoxNew":"GlobalVSContent_tooltipBoxNew__UbWfo","tooltipBoxCont":"GlobalVSContent_tooltipBoxCont__tF9ih","tooltipBoxContHead":"GlobalVSContent_tooltipBoxContHead__NCx8u","tooltipBoxCloseIcon":"GlobalVSContent_tooltipBoxCloseIcon__o1Wrd"};

/***/ }),

/***/ 24773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LoadingSpinnerContainer":"LoadingSpinner_LoadingSpinnerContainer__MWzSl"};

/***/ }),

/***/ 33369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SearchNotificationContainer":"SearchNotification_SearchNotificationContainer__Ot3bz"};

/***/ }),

/***/ 2843:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"UploadImageContainer":"UploadImageForGlobalVS_UploadImageContainer__wqqYu","slideUp":"UploadImageForGlobalVS_slideUp__PtJVn"};

/***/ }),

/***/ 2160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GlobalVisualSearchContainer":"globalvisualsearch_GlobalVisualSearchContainer__h41tV","ModalContent":"globalvisualsearch_ModalContent___7Y_5","ModalXPadding":"globalvisualsearch_ModalXPadding__2X9ZU","ResultPageNavigation":"globalvisualsearch_ResultPageNavigation__6dl8S","BackIconInMobileScreen":"globalvisualsearch_BackIconInMobileScreen__CLWvB","CloseIconInMobileScreen":"globalvisualsearch_CloseIconInMobileScreen__on8MX","mobile-search-text":"globalvisualsearch_mobile-search-text__jre3o","Title":"globalvisualsearch_Title__EfpMw","SubTitle":"globalvisualsearch_SubTitle__5bQ6q","ProductGrid":"globalvisualsearch_ProductGrid__RkOTJ","SubProductGrid":"globalvisualsearch_SubProductGrid__zsQwK","ProductItem":"globalvisualsearch_ProductItem__m9rQ0","comingSoonCard":"globalvisualsearch_comingSoonCard__gzmcH","HelpSection":"globalvisualsearch_HelpSection__s1V0b","QRSection":"globalvisualsearch_QRSection___lWXL"};

/***/ }),

/***/ 95816:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"helpSupportWrapper":"v1_helpSupportWrapper__iyvnc"};

/***/ }),

/***/ 2145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inPageSearchWrapper":"v1_inPageSearchWrapper__yAfDs"};

/***/ }),

/***/ 47486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ListConfirmationModalWrapper":"ListConfirmationModal_ListConfirmationModalWrapper___xKQ_"};

/***/ }),

/***/ 25443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LoaderComponent":"Loader_LoaderComponent__IQYdb"};

/***/ }),

/***/ 70033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ListInventoryCheckModalWrapper":"ListInventoryCheckModal_ListInventoryCheckModalWrapper__vt8au"};

/***/ }),

/***/ 73188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listRequiredItemModalWrapper":"ListRequiredItemModal_listRequiredItemModalWrapper__IH9_9"};

/***/ }),

/***/ 16214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CartModalViewer":"AddCart_CartModalViewer__w61Q_"};

/***/ }),

/***/ 35423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"NotifyContianer":"notify_NotifyContianer__Ht64s"};

/***/ }),

/***/ 3766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PartViewerFeedbackContainer":"feedback_PartViewerFeedbackContainer__UW8sd"};

/***/ }),

/***/ 32353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PrintShareWindow":"PrintShareWindow_PrintShareWindow__oorkb"};

/***/ }),

/***/ 36697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PrintModal":"PrintWindow_PrintModal__vIytV"};

/***/ }),

/***/ 9143:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ReplacementSection":"ReplacementParts_ReplacementSection__z2J88"};

/***/ }),

/***/ 83000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PrintShare":"PrintShare_PrintShare__LiGLM"};

/***/ }),

/***/ 22222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PartDiagramViewer":"partviewer_PartDiagramViewer__9cI0v"};

/***/ }),

/***/ 81881:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roomDetailWrapper":"v1_roomDetailWrapper__hARgi"};

/***/ }),

/***/ 89986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SaveToListWrapper":"SaveToList_SaveToListWrapper__GFfMQ"};

/***/ }),

/***/ 49443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShareListWrapper":"ShareList_ShareListWrapper__QXGk4","ShareListMoreOptionsWrapper":"ShareList_ShareListMoreOptionsWrapper__nfkkm"};

/***/ }),

/***/ 84793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShareListModalWrapper":"ShareListModal_ShareListModalWrapper__yWFH_"};

/***/ }),

/***/ 98260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"original-price":"DisplayDiscountPrice_original-price__F5tgu","discountprice":"DisplayDiscountPrice_discountprice__tpXQp","original-price-color":"DisplayDiscountPrice_original-price-color__EMxcw"};

/***/ }),

/***/ 73712:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericErrorWrapper":"ErrorBoundary_genericErrorWrapper__L7bus","Container":"ErrorBoundary_Container__YWJpS"};

/***/ }),

/***/ 52498:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerNavV3Wrapper":"HeaderNavTabs_headerNavV3Wrapper__HLJt6"};

/***/ }),

/***/ 62582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterFooter_wrapper__YlEqt","gbh-footer-news-letter":"NewsletterFooter_gbh-footer-news-letter__J0nKA","form-group":"NewsletterFooter_form-group__RUpge","form-control":"NewsletterFooter_form-control__cT7ti","btn":"NewsletterFooter_btn__VWVsj","fadeInDown":"NewsletterFooter_fadeInDown__DQU3a"};

/***/ }),

/***/ 76118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialShareWrapper":"socialShare_socialShareWrapper__75zX6"};

/***/ }),

/***/ 20079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"curatedProduct":"ProductCardForUpsell_curatedProduct__p6aK_"};

/***/ }),

/***/ 84181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityWidgetsWrapper":"UtilityWidgets_utilityWidgetsWrapper__Wz0ZS"};

/***/ }),

/***/ 3738:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalFooterWrapper":"Shared_additionalFooterWrapper__OtCXx","mainFooterWrapper":"Shared_mainFooterWrapper__gUYOZ","utilityNavHeaderWrapper":"Shared_utilityNavHeaderWrapper__F3u85"};

/***/ }),

/***/ 95179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shopTheRoomDetailWrapper":"v1_shopTheRoomDetailWrapper__2KLb_"};

/***/ }),

/***/ 98609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"modal_modalWrapper__ny6eQ"};

/***/ }),

/***/ 31201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"overlay_overlayWrapper__Wlipe"};

/***/ }),

/***/ 72681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeAppointMentWrapper":"v1_storeAppointMentWrapper__u0MDb"};

/***/ }),

/***/ 18682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CameraView":"cameraview_CameraView__B9zfz","CameraViewModalGVS":"cameraview_CameraViewModalGVS__itY2d","fade":"cameraview_fade___MpvA"};

/***/ }),

/***/ 53163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ComingSoonContainer":"comingSoon_ComingSoonContainer__gVWpu"};

/***/ }),

/***/ 16899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorFallBack_ErrorContainer__akLzn"};

/***/ }),

/***/ 3856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LoadingImage":"loadingdata_LoadingImage__2k9_d"};

/***/ }),

/***/ 9527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"QRCodeWrapper":"QRCode_QRCodeWrapper__WJi_L"};

/***/ }),

/***/ 20927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ImageCropperWrapper":"ImageCropper_ImageCropperWrapper__ZZhqC"};

/***/ }),

/***/ 42964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductDetail":"ProductDetail_ProductDetail__TRwWI"};

/***/ }),

/***/ 90996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DetailsProduct":"ProductDtls_DetailsProduct__sE_Si"};

/***/ }),

/***/ 53896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ResultWrapper":"ResultPage_ResultWrapper__qzfRL"};

/***/ }),

/***/ 71964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SelectProductCategoryWrapper":"SelectProductCategory_SelectProductCategoryWrapper__NFY_m"};

/***/ }),

/***/ 948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"UploadImageContainer":"uploadImage_UploadImageContainer__Ho5eB","slideUp":"uploadImage_slideUp__ZusDv"};

/***/ }),

/***/ 26657:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VisualSearchContainer":"visualsearch_VisualSearchContainer__jm5Jl"};

/***/ }),

/***/ 56387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"autoSuggetionWrapper":"v1_autoSuggetionWrapper__DHuiH"};

/***/ }),

/***/ 77529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Button_buttonWrapper__9Vvy_","load":"Button_load___Y_wM"};

/***/ }),

/***/ 43090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__Fv9jK","inlineCheckbox":"Checkbox_inlineCheckbox__s9vUb"};

/***/ }),

/***/ 21531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputFieldWrapper":"Input_inputFieldWrapper__nt6o0"};

/***/ }),

/***/ 43106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__asWMh"};

/***/ }),

/***/ 20889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderWrapper":"PageLoader_pageLoaderWrapper__0QMuD"};

/***/ }),

/***/ 81918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reCatichWrapper":"Recaptcha_reCatichWrapper__pIvbo"};

/***/ }),

/***/ 26075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__2DB1H"};

/***/ }),

/***/ 5417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hotspotProductCardWraper":"Hotspot_hotspotProductCardWraper__lT6qX"};

/***/ }),

/***/ 53613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v1_productCardWrapper__A0Nig"};

/***/ }),

/***/ 80597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v3_productCardWrapper__FIxaK"};

/***/ }),

/***/ 95828:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 96167:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77954:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 28380:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34571:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 63911:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 93054:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81076:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1864:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19749)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31551)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(63573)


/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 1861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ OverlayScrollbarsComponent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var overlayscrollbars__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45432);
/* harmony import */ var overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(overlayscrollbars__WEBPACK_IMPORTED_MODULE_1__);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

class OverlayScrollbarsComponent extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
    constructor(props) {
        super(props);
        this._osInstance = null;
        this._osTargetRef = react__WEBPACK_IMPORTED_MODULE_0__.createRef();
    }
    osInstance() {
        return this._osInstance;
    }
    osTarget() {
        return this._osTargetRef.current || null;
    }
    componentDidMount() {
        this._osInstance = overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default()(this.osTarget(), this.props.options || {}, this.props.extensions);
        mergeHostClassNames(this._osInstance, this.props.className);
    }
    componentWillUnmount() {
        if (overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default().valid(this._osInstance)) {
            this._osInstance.destroy();
            this._osInstance = null;
        }
    }
    componentDidUpdate(prevProps) {
        if (overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default().valid(this._osInstance)) {
            this._osInstance.options(this.props.options);
            if (prevProps.className !== this.props.className) {
                mergeHostClassNames(this._osInstance, this.props.className);
            }
        }
    }
    render() {
        const _a = this.props, divProps = __rest(_a, ["options", "extensions", "children", "className"]);
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", Object.assign({ className: "os-host" }, divProps, { ref: this._osTargetRef }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-resize-observer-host" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-padding" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-viewport" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-content" }, this.props.children))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar os-scrollbar-horizontal " },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-track" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-handle" }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar os-scrollbar-vertical" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-track" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-handle" }))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "os-scrollbar-corner" })));
    }
}
function mergeHostClassNames(osInstance, className) {
    if (overlayscrollbars__WEBPACK_IMPORTED_MODULE_1___default().valid(osInstance)) {
        const { host } = osInstance.getElements();
        const regex = new RegExp(`(^os-host([-_].+|)$)|${osInstance.options().className.replace(/\s/g, "$|")}$`, 'g');
        const osClassNames = host.className.split(' ')
            .filter(name => name.match(regex))
            .join(' ');
        host.className = `${osClassNames} ${className || ''}`;
    }
}


//# sourceMappingURL=overlayscrollbars-react.esm.js.map


/***/ }),

/***/ 45432:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * OverlayScrollbars
 * https://github.com/KingSora/OverlayScrollbars
 *
 * Version: 1.13.3
 *
 * Copyright KingSora | Rene Haas.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 * Date: 20.07.2022
 */

(function (global, factory) {
    if (true)
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return factory(global, global.document, undefined); }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    else {}
}(typeof window !== 'undefined' ? window : this,
    function (window, document, undefined) {
        'use strict';
        var PLUGINNAME = 'OverlayScrollbars';
        var TYPES = {
            o: 'object',
            f: 'function',
            a: 'array',
            s: 'string',
            b: 'boolean',
            n: 'number',
            u: 'undefined',
            z: 'null'
            //d : 'date',
            //e : 'error',
            //r : 'regexp',
            //y : 'symbol'
        };
        var LEXICON = {
            c: 'class',
            s: 'style',
            i: 'id',
            l: 'length',
            p: 'prototype',
            ti: 'tabindex',
            oH: 'offsetHeight',
            cH: 'clientHeight',
            sH: 'scrollHeight',
            oW: 'offsetWidth',
            cW: 'clientWidth',
            sW: 'scrollWidth',
            hOP: 'hasOwnProperty',
            bCR: 'getBoundingClientRect'
        };
        var VENDORS = (function () {
            //https://developer.mozilla.org/en-US/docs/Glossary/Vendor_Prefix
            var jsCache = {};
            var cssCache = {};
            var cssPrefixes = ['-webkit-', '-moz-', '-o-', '-ms-'];
            var jsPrefixes = ['WebKit', 'Moz', 'O', 'MS'];
            function firstLetterToUpper(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }

            return {
                _cssPrefixes: cssPrefixes,
                _jsPrefixes: jsPrefixes,
                _cssProperty: function (name) {
                    var result = cssCache[name];

                    if (cssCache[LEXICON.hOP](name))
                        return result;

                    var uppercasedName = firstLetterToUpper(name);
                    var elmStyle = document.createElement('div')[LEXICON.s];
                    var resultPossibilities;
                    var i = 0;
                    var v;
                    var currVendorWithoutDashes;

                    for (; i < cssPrefixes.length; i++) {
                        currVendorWithoutDashes = cssPrefixes[i].replace(/-/g, '');
                        resultPossibilities = [
                            name, //transition
                            cssPrefixes[i] + name, //-webkit-transition
                            currVendorWithoutDashes + uppercasedName, //webkitTransition
                            firstLetterToUpper(currVendorWithoutDashes) + uppercasedName //WebkitTransition
                        ];
                        for (v = 0; v < resultPossibilities[LEXICON.l]; v++) {
                            if (elmStyle[resultPossibilities[v]] !== undefined) {
                                result = resultPossibilities[v];
                                break;
                            }
                        }
                    }

                    cssCache[name] = result;
                    return result;
                },
                _cssPropertyValue: function (property, values, suffix) {
                    var name = property + ' ' + values;
                    var result = cssCache[name];

                    if (cssCache[LEXICON.hOP](name))
                        return result;

                    var dummyStyle = document.createElement('div')[LEXICON.s];
                    var possbleValues = values.split(' ');
                    var preparedSuffix = suffix || '';
                    var i = 0;
                    var v = -1;
                    var prop;

                    for (; i < possbleValues[LEXICON.l]; i++) {
                        for (; v < VENDORS._cssPrefixes[LEXICON.l]; v++) {
                            prop = v < 0 ? possbleValues[i] : VENDORS._cssPrefixes[v] + possbleValues[i];
                            dummyStyle.cssText = property + ':' + prop + preparedSuffix;
                            if (dummyStyle[LEXICON.l]) {
                                result = prop;
                                break;
                            }
                        }
                    }

                    cssCache[name] = result;
                    return result;
                },
                _jsAPI: function (name, isInterface, fallback) {
                    var i = 0;
                    var result = jsCache[name];

                    if (!jsCache[LEXICON.hOP](name)) {
                        result = window[name];
                        for (; i < jsPrefixes[LEXICON.l]; i++)
                            result = result || window[(isInterface ? jsPrefixes[i] : jsPrefixes[i].toLowerCase()) + firstLetterToUpper(name)];
                        jsCache[name] = result;
                    }
                    return result || fallback;
                }
            }
        })();
        var COMPATIBILITY = (function () {
            function windowSize(x) {
                return x ? window.innerWidth || document.documentElement[LEXICON.cW] || document.body[LEXICON.cW] : window.innerHeight || document.documentElement[LEXICON.cH] || document.body[LEXICON.cH];
            }
            function bind(func, thisObj) {
                if (typeof func != TYPES.f) {
                    throw "Can't bind function!";
                    // closest thing possible to the ECMAScript 5
                    // internal IsCallable function
                    //throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
                }
                var proto = LEXICON.p;
                var aArgs = Array[proto].slice.call(arguments, 2);
                var fNOP = function () { };
                var fBound = function () { return func.apply(this instanceof fNOP ? this : thisObj, aArgs.concat(Array[proto].slice.call(arguments))); };

                if (func[proto])
                    fNOP[proto] = func[proto]; // Function.prototype doesn't have a prototype property
                fBound[proto] = new fNOP();

                return fBound;
            }

            return {
                /**
                 * Gets the current window width.
                 * @returns {Number|number} The current window width in pixel.
                 */
                wW: bind(windowSize, 0, true),

                /**
                 * Gets the current window height.
                 * @returns {Number|number} The current window height in pixel.
                 */
                wH: bind(windowSize, 0),

                /**
                 * Gets the MutationObserver Object or undefined if not supported.
                 * @returns {MutationObserver|*|undefined} The MutationsObserver Object or undefined.
                 */
                mO: bind(VENDORS._jsAPI, 0, 'MutationObserver', true),

                /**
                 * Gets the ResizeObserver Object or undefined if not supported.
                 * @returns {MutationObserver|*|undefined} The ResizeObserver Object or undefined.
                 */
                rO: bind(VENDORS._jsAPI, 0, 'ResizeObserver', true),

                /**
                 * Gets the RequestAnimationFrame method or it's corresponding polyfill.
                 * @returns {*|Function} The RequestAnimationFrame method or it's corresponding polyfill.
                 */
                rAF: bind(VENDORS._jsAPI, 0, 'requestAnimationFrame', false, function (func) { return window.setTimeout(func, 1000 / 60); }),

                /**
                 * Gets the CancelAnimationFrame method or it's corresponding polyfill.
                 * @returns {*|Function} The CancelAnimationFrame method or it's corresponding polyfill.
                 */
                cAF: bind(VENDORS._jsAPI, 0, 'cancelAnimationFrame', false, function (id) { return window.clearTimeout(id); }),

                /**
                 * Gets the current time.
                 * @returns {number} The current time.
                 */
                now: function () {
                    return Date.now && Date.now() || new Date().getTime();
                },

                /**
                 * Stops the propagation of the given event.
                 * @param event The event of which the propagation shall be stoped.
                 */
                stpP: function (event) {
                    if (event.stopPropagation)
                        event.stopPropagation();
                    else
                        event.cancelBubble = true;
                },

                /**
                 * Prevents the default action of the given event.
                 * @param event The event of which the default action shall be prevented.
                 */
                prvD: function (event) {
                    if (event.preventDefault && event.cancelable)
                        event.preventDefault();
                    else
                        event.returnValue = false;
                },

                /**
                 * Gets the pageX and pageY values of the given mouse event.
                 * @param event The mouse event of which the pageX and pageX shall be got.
                 * @returns {{x: number, y: number}} x = pageX value, y = pageY value.
                 */
                page: function (event) {
                    event = event.originalEvent || event;

                    var strPage = 'page';
                    var strClient = 'client';
                    var strX = 'X';
                    var strY = 'Y';
                    var target = event.target || event.srcElement || document;
                    var eventDoc = target.ownerDocument || document;
                    var doc = eventDoc.documentElement;
                    var body = eventDoc.body;

                    //if touch event return return pageX/Y of it
                    if (event.touches !== undefined) {
                        var touch = event.touches[0];
                        return {
                            x: touch[strPage + strX],
                            y: touch[strPage + strY]
                        }
                    }

                    // Calculate pageX/Y if not native supported
                    if (!event[strPage + strX] && event[strClient + strX] && event[strClient + strX] != null) {

                        return {
                            x: event[strClient + strX] +
                                (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
                                (doc && doc.clientLeft || body && body.clientLeft || 0),
                            y: event[strClient + strY] +
                                (doc && doc.scrollTop || body && body.scrollTop || 0) -
                                (doc && doc.clientTop || body && body.clientTop || 0)
                        }
                    }
                    return {
                        x: event[strPage + strX],
                        y: event[strPage + strY]
                    };
                },

                /**
                 * Gets the clicked mouse button of the given mouse event.
                 * @param event The mouse event of which the clicked button shal be got.
                 * @returns {number} The number of the clicked mouse button. (0 : none | 1 : leftButton | 2 : middleButton | 3 : rightButton)
                 */
                mBtn: function (event) {
                    var button = event.button;
                    if (!event.which && button !== undefined)
                        return (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
                    else
                        return event.which;
                },

                /**
                 * Checks whether a item is in the given array and returns its index.
                 * @param item The item of which the position in the array shall be determined.
                 * @param arr The array.
                 * @returns {number} The zero based index of the item or -1 if the item isn't in the array.
                 */
                inA: function (item, arr) {
                    for (var i = 0; i < arr[LEXICON.l]; i++)
                        //Sometiems in IE a "SCRIPT70" Permission denied error occurs if HTML elements in a iFrame are compared
                        try {
                            if (arr[i] === item)
                                return i;
                        }
                        catch (e) { }
                    return -1;
                },

                /**
                 * Returns true if the given value is a array.
                 * @param arr The potential array.
                 * @returns {boolean} True if the given value is a array, false otherwise.
                 */
                isA: function (arr) {
                    var def = Array.isArray;
                    return def ? def(arr) : this.type(arr) == TYPES.a;
                },

                /**
                 * Determine the internal JavaScript [[Class]] of the given object.
                 * @param obj The object of which the type shall be determined.
                 * @returns {string} The type of the given object.
                 */
                type: function (obj) {
                    if (obj === undefined)
                        return obj + '';
                    if (obj === null)
                        return obj + '';
                    return Object[LEXICON.p].toString.call(obj).replace(/^\[object (.+)\]$/, '$1').toLowerCase();
                },


                bind: bind

                /**
                 * Gets the vendor-prefixed CSS property by the given name.
                 * For example the given name is "transform" and you're using a old Firefox browser then the returned value would be "-moz-transform".
                 * If the browser doesn't need a vendor-prefix, then the returned string is the given name.
                 * If the browser doesn't support the given property name at all (not even with a vendor-prefix) the returned value is null.
                 * @param propName The unprefixed CSS property name.
                 * @returns {string|null} The vendor-prefixed CSS property or null if the browser doesn't support the given CSS property.

                cssProp: function(propName) {
                    return VENDORS._cssProperty(propName);
                }
                */
            }
        })();


        var MATH = Math;
        var JQUERY = window.jQuery;
        var EASING = (function () {
            var _easingsMath = {
                p: MATH.PI,
                c: MATH.cos,
                s: MATH.sin,
                w: MATH.pow,
                t: MATH.sqrt,
                n: MATH.asin,
                a: MATH.abs,
                o: 1.70158
            };

            /*
             x : current percent (0 - 1),
             t : current time (duration * percent),
             b : start value (from),
             c : end value (to),
             d : duration

             easingName : function(x, t, b, c, d) { return easedValue; }
             */

            return {
                swing: function (x, t, b, c, d) {
                    return 0.5 - _easingsMath.c(x * _easingsMath.p) / 2;
                },
                linear: function (x, t, b, c, d) {
                    return x;
                },
                easeInQuad: function (x, t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function (x, t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t + b : -c / 2 * ((--t) * (t - 2) - 1) + b;
                },
                easeInCubic: function (x, t, b, c, d) {
                    return c * (t /= d) * t * t + b;
                },
                easeOutCubic: function (x, t, b, c, d) {
                    return c * ((t = t / d - 1) * t * t + 1) + b;
                },
                easeInOutCubic: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t * t + b : c / 2 * ((t -= 2) * t * t + 2) + b;
                },
                easeInQuart: function (x, t, b, c, d) {
                    return c * (t /= d) * t * t * t + b;
                },
                easeOutQuart: function (x, t, b, c, d) {
                    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
                },
                easeInOutQuart: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b;
                },
                easeInQuint: function (x, t, b, c, d) {
                    return c * (t /= d) * t * t * t * t + b;
                },
                easeOutQuint: function (x, t, b, c, d) {
                    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                },
                easeInOutQuint: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t * t * t * t + b : c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
                },
                easeInSine: function (x, t, b, c, d) {
                    return -c * _easingsMath.c(t / d * (_easingsMath.p / 2)) + c + b;
                },
                easeOutSine: function (x, t, b, c, d) {
                    return c * _easingsMath.s(t / d * (_easingsMath.p / 2)) + b;
                },
                easeInOutSine: function (x, t, b, c, d) {
                    return -c / 2 * (_easingsMath.c(_easingsMath.p * t / d) - 1) + b;
                },
                easeInExpo: function (x, t, b, c, d) {
                    return (t == 0) ? b : c * _easingsMath.w(2, 10 * (t / d - 1)) + b;
                },
                easeOutExpo: function (x, t, b, c, d) {
                    return (t == d) ? b + c : c * (-_easingsMath.w(2, -10 * t / d) + 1) + b;
                },
                easeInOutExpo: function (x, t, b, c, d) {
                    if (t == 0) return b;
                    if (t == d) return b + c;
                    if ((t /= d / 2) < 1) return c / 2 * _easingsMath.w(2, 10 * (t - 1)) + b;
                    return c / 2 * (-_easingsMath.w(2, -10 * --t) + 2) + b;
                },
                easeInCirc: function (x, t, b, c, d) {
                    return -c * (_easingsMath.t(1 - (t /= d) * t) - 1) + b;
                },
                easeOutCirc: function (x, t, b, c, d) {
                    return c * _easingsMath.t(1 - (t = t / d - 1) * t) + b;
                },
                easeInOutCirc: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? -c / 2 * (_easingsMath.t(1 - t * t) - 1) + b : c / 2 * (_easingsMath.t(1 - (t -= 2) * t) + 1) + b;
                },
                easeInElastic: function (x, t, b, c, d) {
                    var s = _easingsMath.o; var p = 0; var a = c;
                    if (t == 0) return b; if ((t /= d) == 1) return b + c; if (!p) p = d * .3;
                    if (a < _easingsMath.a(c)) { a = c; s = p / 4; }
                    else s = p / (2 * _easingsMath.p) * _easingsMath.n(c / a);
                    return -(a * _easingsMath.w(2, 10 * (t -= 1)) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p)) + b;
                },
                easeOutElastic: function (x, t, b, c, d) {
                    var s = _easingsMath.o; var p = 0; var a = c;
                    if (t == 0) return b;
                    if ((t /= d) == 1) return b + c;
                    if (!p) p = d * .3;
                    if (a < _easingsMath.a(c)) { a = c; s = p / 4; }
                    else s = p / (2 * _easingsMath.p) * _easingsMath.n(c / a);
                    return a * _easingsMath.w(2, -10 * t) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p) + c + b;
                },
                easeInOutElastic: function (x, t, b, c, d) {
                    var s = _easingsMath.o; var p = 0; var a = c;
                    if (t == 0) return b;
                    if ((t /= d / 2) == 2) return b + c;
                    if (!p) p = d * (.3 * 1.5);
                    if (a < _easingsMath.a(c)) { a = c; s = p / 4; }
                    else s = p / (2 * _easingsMath.p) * _easingsMath.n(c / a);
                    if (t < 1) return -.5 * (a * _easingsMath.w(2, 10 * (t -= 1)) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p)) + b;
                    return a * _easingsMath.w(2, -10 * (t -= 1)) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p) * .5 + c + b;
                },
                easeInBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return c * (t /= d) * t * ((s + 1) * t - s) + b;
                },
                easeOutBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
                },
                easeInOutBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return ((t /= d / 2) < 1) ? c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b : c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
                },
                easeInBounce: function (x, t, b, c, d) {
                    return c - this.easeOutBounce(x, d - t, 0, c, d) + b;
                },
                easeOutBounce: function (x, t, b, c, d) {
                    var o = 7.5625;
                    if ((t /= d) < (1 / 2.75)) {
                        return c * (o * t * t) + b;
                    } else if (t < (2 / 2.75)) {
                        return c * (o * (t -= (1.5 / 2.75)) * t + .75) + b;
                    } else if (t < (2.5 / 2.75)) {
                        return c * (o * (t -= (2.25 / 2.75)) * t + .9375) + b;
                    } else {
                        return c * (o * (t -= (2.625 / 2.75)) * t + .984375) + b;
                    }
                },
                easeInOutBounce: function (x, t, b, c, d) {
                    return (t < d / 2) ? this.easeInBounce(x, t * 2, 0, c, d) * .5 + b : this.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
                }
            };
            /*
             *
             * TERMS OF USE - EASING EQUATIONS
             * 
             * Open source under the BSD License. 
             * 
             * Copyright Â© 2001 Robert Penner
             * All rights reserved.
             * 
             * Redistribution and use in source and binary forms, with or without modification, 
             * are permitted provided that the following conditions are met:
             * 
             * Redistributions of source code must retain the above copyright notice, this list of 
             * conditions and the following disclaimer.
             * Redistributions in binary form must reproduce the above copyright notice, this list 
             * of conditions and the following disclaimer in the documentation and/or other materials 
             * provided with the distribution.
             * 
             * Neither the name of the author nor the names of contributors may be used to endorse 
             * or promote products derived from this software without specific prior written permission.
             * 
             * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
             * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
             * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
             *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
             *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
             *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
             * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
             *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
             * OF THE POSSIBILITY OF SUCH DAMAGE. 
             *
             */
        })();
        var FRAMEWORK = (function () {
            var _rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);
            var _strSpace = ' ';
            var _strEmpty = '';
            var _strScrollLeft = 'scrollLeft';
            var _strScrollTop = 'scrollTop';
            var _animations = [];
            var _type = COMPATIBILITY.type;
            var _cssNumber = {
                animationIterationCount: true,
                columnCount: true,
                fillOpacity: true,
                flexGrow: true,
                flexShrink: true,
                fontWeight: true,
                lineHeight: true,
                opacity: true,
                order: true,
                orphans: true,
                widows: true,
                zIndex: true,
                zoom: true
            };

            function extend() {
                var src, copyIsArray, copy, name, options, clone, target = arguments[0] || {},
                    i = 1,
                    length = arguments[LEXICON.l],
                    deep = false;

                // Handle a deep copy situation
                if (_type(target) == TYPES.b) {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }

                // Handle case when target is a string or something (possible in deep copy)
                if (_type(target) != TYPES.o && !_type(target) == TYPES.f) {
                    target = {};
                }

                // extend jQuery itself if only one argument is passed
                if (length === i) {
                    target = FakejQuery;
                    --i;
                }

                for (; i < length; i++) {
                    // Only deal with non-null/undefined values
                    if ((options = arguments[i]) != null) {
                        // Extend the base object
                        for (name in options) {
                            src = target[name];
                            copy = options[name];

                            // Prevent never-ending loop
                            if (target === copy) {
                                continue;
                            }

                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = COMPATIBILITY.isA(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && COMPATIBILITY.isA(src) ? src : [];

                                } else {
                                    clone = src && isPlainObject(src) ? src : {};
                                }

                                // Never move original objects, clone them
                                target[name] = extend(deep, clone, copy);

                                // Don't bring in undefined values
                            } else if (copy !== undefined) {
                                target[name] = copy;
                            }
                        }
                    }
                }

                // Return the modified object
                return target;
            };

            function inArray(item, arr, fromIndex) {
                for (var i = fromIndex || 0; i < arr[LEXICON.l]; i++)
                    if (arr[i] === item)
                        return i;
                return -1;
            }

            function isFunction(obj) {
                return _type(obj) == TYPES.f;
            };

            function isEmptyObject(obj) {
                for (var name in obj)
                    return false;
                return true;
            };

            function isPlainObject(obj) {
                if (!obj || _type(obj) != TYPES.o)
                    return false;

                var key;
                var proto = LEXICON.p;
                var hasOwnProperty = Object[proto].hasOwnProperty;
                var hasOwnConstructor = hasOwnProperty.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor[proto] && hasOwnProperty.call(obj.constructor[proto], 'isPrototypeOf');

                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
                    return false;
                }


                for (key in obj) { /**/ }

                return _type(key) == TYPES.u || hasOwnProperty.call(obj, key);
            };

            function each(obj, callback) {
                var i = 0;

                if (isArrayLike(obj)) {
                    for (; i < obj[LEXICON.l]; i++) {
                        if (callback.call(obj[i], i, obj[i]) === false)
                            break;
                    }
                }
                else {
                    for (i in obj) {
                        if (callback.call(obj[i], i, obj[i]) === false)
                            break;
                    }
                }

                return obj;
            };

            function isArrayLike(obj) {
                var length = !!obj && [LEXICON.l] in obj && obj[LEXICON.l];
                var t = _type(obj);
                return isFunction(t) ? false : (t == TYPES.a || length === 0 || _type(length) == TYPES.n && length > 0 && (length - 1) in obj);
            }

            function stripAndCollapse(value) {
                var tokens = value.match(_rnothtmlwhite) || [];
                return tokens.join(_strSpace);
            }

            function matches(elem, selector) {
                var nodeList = (elem.parentNode || document).querySelectorAll(selector) || [];
                var i = nodeList[LEXICON.l];

                while (i--)
                    if (nodeList[i] == elem)
                        return true;

                return false;
            }

            function insertAdjacentElement(el, strategy, child) {
                if (COMPATIBILITY.isA(child)) {
                    for (var i = 0; i < child[LEXICON.l]; i++)
                        insertAdjacentElement(el, strategy, child[i]);
                }
                else if (_type(child) == TYPES.s)
                    el.insertAdjacentHTML(strategy, child);
                else
                    el.insertAdjacentElement(strategy, child.nodeType ? child : child[0]);
            }

            function setCSSVal(el, prop, val) {
                try {
                    if (el[LEXICON.s][prop] !== undefined)
                        el[LEXICON.s][prop] = parseCSSVal(prop, val);
                } catch (e) { }
            }

            function parseCSSVal(prop, val) {
                if (!_cssNumber[prop.toLowerCase()] && _type(val) == TYPES.n)
                    val += 'px';
                return val;
            }

            function startNextAnimationInQ(animObj, removeFromQ) {
                var index;
                var nextAnim;
                if (removeFromQ !== false)
                    animObj.q.splice(0, 1);
                if (animObj.q[LEXICON.l] > 0) {
                    nextAnim = animObj.q[0];
                    animate(animObj.el, nextAnim.props, nextAnim.duration, nextAnim.easing, nextAnim.complete, true);
                }
                else {
                    index = inArray(animObj, _animations);
                    if (index > -1)
                        _animations.splice(index, 1);
                }
            }

            function setAnimationValue(el, prop, value) {
                if (prop === _strScrollLeft || prop === _strScrollTop)
                    el[prop] = value;
                else
                    setCSSVal(el, prop, value);
            }

            function animate(el, props, options, easing, complete, guaranteedNext) {
                var hasOptions = isPlainObject(options);
                var from = {};
                var to = {};
                var i = 0;
                var key;
                var animObj;
                var start;
                var progress;
                var step;
                var specialEasing;
                var duration;
                if (hasOptions) {
                    easing = options.easing;
                    start = options.start;
                    progress = options.progress;
                    step = options.step;
                    specialEasing = options.specialEasing;
                    complete = options.complete;
                    duration = options.duration;
                }
                else
                    duration = options;
                specialEasing = specialEasing || {};
                duration = duration || 400;
                easing = easing || 'swing';
                guaranteedNext = guaranteedNext || false;

                for (; i < _animations[LEXICON.l]; i++) {
                    if (_animations[i].el === el) {
                        animObj = _animations[i];
                        break;
                    }
                }

                if (!animObj) {
                    animObj = {
                        el: el,
                        q: []
                    };
                    _animations.push(animObj);
                }

                for (key in props) {
                    if (key === _strScrollLeft || key === _strScrollTop)
                        from[key] = el[key];
                    else
                        from[key] = FakejQuery(el).css(key);
                }

                for (key in from) {
                    if (from[key] !== props[key] && props[key] !== undefined)
                        to[key] = props[key];
                }

                if (!isEmptyObject(to)) {
                    var timeNow;
                    var end;
                    var percent;
                    var fromVal;
                    var toVal;
                    var easedVal;
                    var timeStart;
                    var frame;
                    var elapsed;
                    var qPos = guaranteedNext ? 0 : inArray(qObj, animObj.q);
                    var qObj = {
                        props: to,
                        duration: hasOptions ? options : duration,
                        easing: easing,
                        complete: complete
                    };
                    if (qPos === -1) {
                        qPos = animObj.q[LEXICON.l];
                        animObj.q.push(qObj);
                    }

                    if (qPos === 0) {
                        if (duration > 0) {
                            timeStart = COMPATIBILITY.now();
                            frame = function () {
                                timeNow = COMPATIBILITY.now();
                                elapsed = (timeNow - timeStart);
                                end = qObj.stop || elapsed >= duration;
                                percent = 1 - ((MATH.max(0, timeStart + duration - timeNow) / duration) || 0);

                                for (key in to) {
                                    fromVal = parseFloat(from[key]);
                                    toVal = parseFloat(to[key]);
                                    easedVal = (toVal - fromVal) * EASING[specialEasing[key] || easing](percent, percent * duration, 0, 1, duration) + fromVal;
                                    setAnimationValue(el, key, easedVal);
                                    if (isFunction(step)) {
                                        step(easedVal, {
                                            elem: el,
                                            prop: key,
                                            start: fromVal,
                                            now: easedVal,
                                            end: toVal,
                                            pos: percent,
                                            options: {
                                                easing: easing,
                                                speacialEasing: specialEasing,
                                                duration: duration,
                                                complete: complete,
                                                step: step
                                            },
                                            startTime: timeStart
                                        });
                                    }
                                }

                                if (isFunction(progress))
                                    progress({}, percent, MATH.max(0, duration - elapsed));

                                if (end) {
                                    startNextAnimationInQ(animObj);
                                    if (isFunction(complete))
                                        complete();
                                }
                                else
                                    qObj.frame = COMPATIBILITY.rAF()(frame);
                            };
                            qObj.frame = COMPATIBILITY.rAF()(frame);
                        }
                        else {
                            for (key in to)
                                setAnimationValue(el, key, to[key]);
                            startNextAnimationInQ(animObj);
                        }
                    }
                }
                else if (guaranteedNext)
                    startNextAnimationInQ(animObj);
            }

            function stop(el, clearQ, jumpToEnd) {
                var animObj;
                var qObj;
                var key;
                var i = 0;
                for (; i < _animations[LEXICON.l]; i++) {
                    animObj = _animations[i];
                    if (animObj.el === el) {
                        if (animObj.q[LEXICON.l] > 0) {
                            qObj = animObj.q[0];
                            qObj.stop = true;
                            COMPATIBILITY.cAF()(qObj.frame);
                            animObj.q.splice(0, 1);

                            if (jumpToEnd)
                                for (key in qObj.props)
                                    setAnimationValue(el, key, qObj.props[key]);

                            if (clearQ)
                                animObj.q = [];
                            else
                                startNextAnimationInQ(animObj, false);
                        }
                        break;
                    }
                }
            }

            function elementIsVisible(el) {
                return !!(el[LEXICON.oW] || el[LEXICON.oH] || el.getClientRects()[LEXICON.l]);
            }

            function FakejQuery(selector) {
                if (arguments[LEXICON.l] === 0)
                    return this;

                var base = new FakejQuery();
                var elements = selector;
                var i = 0;
                var elms;
                var el;

                if (_type(selector) == TYPES.s) {
                    elements = [];
                    if (selector.charAt(0) === '<') {
                        el = document.createElement('div');
                        el.innerHTML = selector;
                        elms = el.children;
                    }
                    else {
                        elms = document.querySelectorAll(selector);
                    }

                    for (; i < elms[LEXICON.l]; i++)
                        elements.push(elms[i]);
                }

                if (elements) {
                    if (_type(elements) != TYPES.s && (!isArrayLike(elements) || elements === window || elements === elements.self))
                        elements = [elements];

                    for (i = 0; i < elements[LEXICON.l]; i++)
                        base[i] = elements[i];

                    base[LEXICON.l] = elements[LEXICON.l];
                }

                return base;
            };

            FakejQuery[LEXICON.p] = {

                //EVENTS:

                on: function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];

                    var eventNameLength = eventName[LEXICON.l];
                    var i = 0;
                    var el;
                    return this.each(function () {
                        el = this;
                        try {
                            if (el.addEventListener) {
                                for (; i < eventNameLength; i++)
                                    el.addEventListener(eventName[i], handler);
                            }
                            else if (el.detachEvent) {
                                for (; i < eventNameLength; i++)
                                    el.attachEvent('on' + eventName[i], handler);
                            }
                        } catch (e) { }
                    });
                },

                off: function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];

                    var eventNameLength = eventName[LEXICON.l];
                    var i = 0;
                    var el;
                    return this.each(function () {
                        el = this;
                        try {
                            if (el.removeEventListener) {
                                for (; i < eventNameLength; i++)
                                    el.removeEventListener(eventName[i], handler);
                            }
                            else if (el.detachEvent) {
                                for (; i < eventNameLength; i++)
                                    el.detachEvent('on' + eventName[i], handler);
                            }
                        } catch (e) { }
                    });
                },

                one: function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];
                    return this.each(function () {
                        var el = FakejQuery(this);
                        FakejQuery.each(eventName, function (i, oneEventName) {
                            var oneHandler = function (e) {
                                handler.call(this, e);
                                el.off(oneEventName, oneHandler);
                            };
                            el.on(oneEventName, oneHandler);
                        });
                    });
                },

                trigger: function (eventName) {
                    var el;
                    var event;
                    return this.each(function () {
                        el = this;
                        if (document.createEvent) {
                            event = document.createEvent('HTMLEvents');
                            event.initEvent(eventName, true, false);
                            el.dispatchEvent(event);
                        }
                        else {
                            el.fireEvent('on' + eventName);
                        }
                    });
                },

                //DOM NODE INSERTING / REMOVING:

                append: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'beforeend', child); });
                },

                prepend: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'afterbegin', child); });
                },

                before: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'beforebegin', child); });
                },

                after: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'afterend', child); });
                },

                remove: function () {
                    return this.each(function () {
                        var el = this;
                        var parentNode = el.parentNode;
                        if (parentNode != null)
                            parentNode.removeChild(el);
                    });
                },

                unwrap: function () {
                    var parents = [];
                    var i;
                    var el;
                    var parent;

                    this.each(function () {
                        parent = this.parentNode;
                        if (inArray(parent, parents) === - 1)
                            parents.push(parent);
                    });

                    for (i = 0; i < parents[LEXICON.l]; i++) {
                        el = parents[i];
                        parent = el.parentNode;
                        while (el.firstChild)
                            parent.insertBefore(el.firstChild, el);
                        parent.removeChild(el);
                    }

                    return this;
                },

                wrapAll: function (wrapperHTML) {
                    var i;
                    var nodes = this;
                    var wrapper = FakejQuery(wrapperHTML)[0];
                    var deepest = wrapper;
                    var parent = nodes[0].parentNode;
                    var previousSibling = nodes[0].previousSibling;
                    while (deepest.childNodes[LEXICON.l] > 0)
                        deepest = deepest.childNodes[0];

                    for (i = 0; nodes[LEXICON.l] - i; deepest.firstChild === nodes[0] && i++)
                        deepest.appendChild(nodes[i]);

                    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
                    parent.insertBefore(wrapper, nextSibling);

                    return this;
                },

                wrapInner: function (wrapperHTML) {
                    return this.each(function () {
                        var el = FakejQuery(this);
                        var contents = el.contents();

                        if (contents[LEXICON.l])
                            contents.wrapAll(wrapperHTML);
                        else
                            el.append(wrapperHTML);
                    });
                },

                wrap: function (wrapperHTML) {
                    return this.each(function () { FakejQuery(this).wrapAll(wrapperHTML); });
                },


                //DOM NODE MANIPULATION / INFORMATION:

                css: function (styles, val) {
                    var el;
                    var key;
                    var cptStyle;
                    var getCptStyle = window.getComputedStyle;
                    if (_type(styles) == TYPES.s) {
                        if (val === undefined) {
                            el = this[0];
                            cptStyle = getCptStyle ? getCptStyle(el, null) : el.currentStyle[styles];

                            //https://bugzilla.mozilla.org/show_bug.cgi?id=548397 can be null sometimes if iframe with display: none (firefox only!)
                            return getCptStyle ? cptStyle != null ? cptStyle.getPropertyValue(styles) : el[LEXICON.s][styles] : cptStyle;
                        }
                        else {
                            return this.each(function () {
                                setCSSVal(this, styles, val);
                            });
                        }
                    }
                    else {
                        return this.each(function () {
                            for (key in styles)
                                setCSSVal(this, key, styles[key]);
                        });
                    }
                },

                hasClass: function (className) {
                    var elem, i = 0;
                    var classNamePrepared = _strSpace + className + _strSpace;
                    var classList;

                    while ((elem = this[i++])) {
                        classList = elem.classList;
                        if (classList && classList.contains(className))
                            return true;
                        else if (elem.nodeType === 1 && (_strSpace + stripAndCollapse(elem.className + _strEmpty) + _strSpace).indexOf(classNamePrepared) > -1)
                            return true;
                    }

                    return false;
                },

                addClass: function (className) {
                    var classes;
                    var elem;
                    var cur;
                    var curValue;
                    var clazz;
                    var finalValue;
                    var supportClassList;
                    var elmClassList;
                    var i = 0;
                    var v = 0;

                    if (className) {
                        classes = className.match(_rnothtmlwhite) || [];

                        while ((elem = this[i++])) {
                            elmClassList = elem.classList;
                            if (supportClassList === undefined)
                                supportClassList = elmClassList !== undefined;

                            if (supportClassList) {
                                while ((clazz = classes[v++]))
                                    elmClassList.add(clazz);
                            }
                            else {
                                curValue = elem.className + _strEmpty;
                                cur = elem.nodeType === 1 && (_strSpace + stripAndCollapse(curValue) + _strSpace);

                                if (cur) {
                                    while ((clazz = classes[v++]))
                                        if (cur.indexOf(_strSpace + clazz + _strSpace) < 0)
                                            cur += clazz + _strSpace;

                                    finalValue = stripAndCollapse(cur);
                                    if (curValue !== finalValue)
                                        elem.className = finalValue;
                                }
                            }
                        }
                    }

                    return this;
                },

                removeClass: function (className) {
                    var classes;
                    var elem;
                    var cur;
                    var curValue;
                    var clazz;
                    var finalValue;
                    var supportClassList;
                    var elmClassList;
                    var i = 0;
                    var v = 0;

                    if (className) {
                        classes = className.match(_rnothtmlwhite) || [];

                        while ((elem = this[i++])) {
                            elmClassList = elem.classList;
                            if (supportClassList === undefined)
                                supportClassList = elmClassList !== undefined;

                            if (supportClassList) {
                                while ((clazz = classes[v++]))
                                    elmClassList.remove(clazz);
                            }
                            else {
                                curValue = elem.className + _strEmpty;
                                cur = elem.nodeType === 1 && (_strSpace + stripAndCollapse(curValue) + _strSpace);

                                if (cur) {
                                    while ((clazz = classes[v++]))
                                        while (cur.indexOf(_strSpace + clazz + _strSpace) > -1)
                                            cur = cur.replace(_strSpace + clazz + _strSpace, _strSpace);

                                    finalValue = stripAndCollapse(cur);
                                    if (curValue !== finalValue)
                                        elem.className = finalValue;
                                }
                            }
                        }
                    }

                    return this;
                },

                hide: function () {
                    return this.each(function () { this[LEXICON.s].display = 'none'; });
                },

                show: function () {
                    return this.each(function () { this[LEXICON.s].display = 'block'; });
                },

                attr: function (attrName, value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if (value === undefined)
                            return el.getAttribute(attrName);
                        el.setAttribute(attrName, value);
                    }
                    return this;
                },

                removeAttr: function (attrName) {
                    return this.each(function () { this.removeAttribute(attrName); });
                },

                offset: function () {
                    var el = this[0];
                    var rect = el[LEXICON.bCR]();
                    var scrollLeft = window.pageXOffset || document.documentElement[_strScrollLeft];
                    var scrollTop = window.pageYOffset || document.documentElement[_strScrollTop];
                    return {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft
                    };
                },

                position: function () {
                    var el = this[0];
                    return {
                        top: el.offsetTop,
                        left: el.offsetLeft
                    };
                },

                scrollLeft: function (value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if (value === undefined)
                            return el[_strScrollLeft];
                        el[_strScrollLeft] = value;
                    }
                    return this;
                },

                scrollTop: function (value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if (value === undefined)
                            return el[_strScrollTop];
                        el[_strScrollTop] = value;
                    }
                    return this;
                },

                val: function (value) {
                    var el = this[0];
                    if (!value)
                        return el.value;
                    el.value = value;
                    return this;
                },


                //DOM TRAVERSAL / FILTERING:

                first: function () {
                    return this.eq(0);
                },

                last: function () {
                    return this.eq(-1);
                },

                eq: function (index) {
                    return FakejQuery(this[index >= 0 ? index : this[LEXICON.l] + index]);
                },

                find: function (selector) {
                    var children = [];
                    var i;
                    this.each(function () {
                        var el = this;
                        var ch = el.querySelectorAll(selector);
                        for (i = 0; i < ch[LEXICON.l]; i++)
                            children.push(ch[i]);
                    });
                    return FakejQuery(children);
                },

                children: function (selector) {
                    var children = [];
                    var el;
                    var ch;
                    var i;

                    this.each(function () {
                        ch = this.children;
                        for (i = 0; i < ch[LEXICON.l]; i++) {
                            el = ch[i];
                            if (selector) {
                                if ((el.matches && el.matches(selector)) || matches(el, selector))
                                    children.push(el);
                            }
                            else
                                children.push(el);
                        }
                    });
                    return FakejQuery(children);
                },

                parent: function (selector) {
                    var parents = [];
                    var parent;
                    this.each(function () {
                        parent = this.parentNode;
                        if (selector ? FakejQuery(parent).is(selector) : true)
                            parents.push(parent);
                    });
                    return FakejQuery(parents);
                },

                is: function (selector) {

                    var el;
                    var i;
                    for (i = 0; i < this[LEXICON.l]; i++) {
                        el = this[i];
                        if (selector === ':visible')
                            return elementIsVisible(el);
                        if (selector === ':hidden')
                            return !elementIsVisible(el);
                        if ((el.matches && el.matches(selector)) || matches(el, selector))
                            return true;
                    }
                    return false;
                },

                contents: function () {
                    var contents = [];
                    var childs;
                    var i;

                    this.each(function () {
                        childs = this.childNodes;
                        for (i = 0; i < childs[LEXICON.l]; i++)
                            contents.push(childs[i]);
                    });

                    return FakejQuery(contents);
                },

                each: function (callback) {
                    return each(this, callback);
                },


                //ANIMATION:

                animate: function (props, duration, easing, complete) {
                    return this.each(function () { animate(this, props, duration, easing, complete); });
                },

                stop: function (clearQ, jump) {
                    return this.each(function () { stop(this, clearQ, jump); });
                }
            };

            extend(FakejQuery, {
                extend: extend,
                inArray: inArray,
                isEmptyObject: isEmptyObject,
                isPlainObject: isPlainObject,
                each: each
            });

            return FakejQuery;
        })();
        var INSTANCES = (function () {
            var _targets = [];
            var _instancePropertyString = '__overlayScrollbars__';

            /**
             * Register, unregister or get a certain (or all) instances.
             * Register: Pass the target and the instance.
             * Unregister: Pass the target and null.
             * Get Instance: Pass the target from which the instance shall be got.
             * Get Targets: Pass no arguments.
             * @param target The target to which the instance shall be registered / from which the instance shall be unregistered / the instance shall be got
             * @param instance The instance.
             * @returns {*|void} Returns the instance from the given target.
             */
            return function (target, instance) {
                var argLen = arguments[LEXICON.l];
                if (argLen < 1) {
                    //return all targets
                    return _targets;
                }
                else {
                    if (instance) {
                        //register instance
                        target[_instancePropertyString] = instance;
                        _targets.push(target);
                    }
                    else {
                        var index = COMPATIBILITY.inA(target, _targets);
                        if (index > -1) {
                            if (argLen > 1) {
                                //unregister instance
                                delete target[_instancePropertyString];
                                _targets.splice(index, 1);
                            }
                            else {
                                //get instance from target
                                return _targets[index][_instancePropertyString];
                            }
                        }
                    }
                }
            }
        })();
        var PLUGIN = (function () {
            var _plugin;
            var _pluginsGlobals;
            var _pluginsAutoUpdateLoop;
            var _pluginsExtensions = [];
            var _pluginsOptions = (function () {
                var type = COMPATIBILITY.type;
                var possibleTemplateTypes = [
                    TYPES.b, //boolean
                    TYPES.n, //number
                    TYPES.s, //string
                    TYPES.a, //array
                    TYPES.o, //object
                    TYPES.f, //function
                    TYPES.z  //null
                ];
                var restrictedStringsSplit = ' ';
                var restrictedStringsPossibilitiesSplit = ':';
                var classNameAllowedValues = [TYPES.z, TYPES.s];
                var numberAllowedValues = TYPES.n;
                var booleanNullAllowedValues = [TYPES.z, TYPES.b];
                var booleanTrueTemplate = [true, TYPES.b];
                var booleanFalseTemplate = [false, TYPES.b];
                var callbackTemplate = [null, [TYPES.z, TYPES.f]];
                var updateOnLoadTemplate = [['img'], [TYPES.s, TYPES.a, TYPES.z]];
                var inheritedAttrsTemplate = [['style', 'class'], [TYPES.s, TYPES.a, TYPES.z]];
                var resizeAllowedValues = 'n:none b:both h:horizontal v:vertical';
                var overflowBehaviorAllowedValues = 'v-h:visible-hidden v-s:visible-scroll s:scroll h:hidden';
                var scrollbarsVisibilityAllowedValues = 'v:visible h:hidden a:auto';
                var scrollbarsAutoHideAllowedValues = 'n:never s:scroll l:leave m:move';
                var optionsDefaultsAndTemplate = {
                    className: ['os-theme-dark', classNameAllowedValues],                //null || string
                    resize: ['none', resizeAllowedValues],                               //none || both  || horizontal || vertical || n || b || h || v
                    sizeAutoCapable: booleanTrueTemplate,                                //true || false
                    clipAlways: booleanTrueTemplate,                                     //true || false
                    normalizeRTL: booleanTrueTemplate,                                   //true || false
                    paddingAbsolute: booleanFalseTemplate,                               //true || false
                    autoUpdate: [null, booleanNullAllowedValues],                        //true || false || null
                    autoUpdateInterval: [33, numberAllowedValues],                       //number
                    updateOnLoad: updateOnLoadTemplate,                                  //string || array || null
                    nativeScrollbarsOverlaid: {
                        showNativeScrollbars: booleanFalseTemplate,                      //true || false
                        initialize: booleanTrueTemplate                                  //true || false
                    },
                    overflowBehavior: {
                        x: ['scroll', overflowBehaviorAllowedValues],                    //visible-hidden  || visible-scroll || hidden || scroll || v-h || v-s || h || s
                        y: ['scroll', overflowBehaviorAllowedValues]                     //visible-hidden  || visible-scroll || hidden || scroll || v-h || v-s || h || s
                    },
                    scrollbars: {
                        visibility: ['auto', scrollbarsVisibilityAllowedValues],         //visible || hidden || auto || v || h || a
                        autoHide: ['never', scrollbarsAutoHideAllowedValues],            //never || scroll || leave || move || n || s || l || m
                        autoHideDelay: [800, numberAllowedValues],                       //number
                        dragScrolling: booleanTrueTemplate,                              //true || false
                        clickScrolling: booleanFalseTemplate,                            //true || false
                        touchSupport: booleanTrueTemplate,                               //true || false
                        snapHandle: booleanFalseTemplate                                 //true || false
                    },
                    textarea: {
                        dynWidth: booleanFalseTemplate,                                  //true || false
                        dynHeight: booleanFalseTemplate,                                 //true || false
                        inheritedAttrs: inheritedAttrsTemplate                           //string || array || null
                    },
                    callbacks: {
                        onInitialized: callbackTemplate,                                 //null || function
                        onInitializationWithdrawn: callbackTemplate,                     //null || function
                        onDestroyed: callbackTemplate,                                   //null || function
                        onScrollStart: callbackTemplate,                                 //null || function
                        onScroll: callbackTemplate,                                      //null || function
                        onScrollStop: callbackTemplate,                                  //null || function
                        onOverflowChanged: callbackTemplate,                             //null || function
                        onOverflowAmountChanged: callbackTemplate,                       //null || function
                        onDirectionChanged: callbackTemplate,                            //null || function
                        onContentSizeChanged: callbackTemplate,                          //null || function
                        onHostSizeChanged: callbackTemplate,                             //null || function
                        onUpdated: callbackTemplate                                      //null || function
                    }
                };
                var convert = function (template) {
                    var recursive = function (obj) {
                        var key;
                        var val;
                        var valType;
                        for (key in obj) {
                            if (!obj[LEXICON.hOP](key))
                                continue;
                            val = obj[key];
                            valType = type(val);
                            if (valType == TYPES.a)
                                obj[key] = val[template ? 1 : 0];
                            else if (valType == TYPES.o)
                                obj[key] = recursive(val);
                        }
                        return obj;
                    };
                    return recursive(FRAMEWORK.extend(true, {}, optionsDefaultsAndTemplate));
                };

                return {
                    _defaults: convert(),

                    _template: convert(true),

                    /**
                     * Validates the passed object by the passed template.
                     * @param obj The object which shall be validated.
                     * @param template The template which defines the allowed values and types.
                     * @param writeErrors True if errors shall be logged to the console.
                     * @param diffObj If a object is passed then only valid differences to this object will be returned.
                     * @returns {{}} A object which contains two objects called "default" and "prepared" which contains only the valid properties of the passed original object and discards not different values compared to the passed diffObj.
                     */
                    _validate: function (obj, template, writeErrors, diffObj) {
                        var validatedOptions = {};
                        var validatedOptionsPrepared = {};
                        var objectCopy = FRAMEWORK.extend(true, {}, obj);
                        var inArray = FRAMEWORK.inArray;
                        var isEmptyObj = FRAMEWORK.isEmptyObject;
                        var checkObjectProps = function (data, template, diffData, validatedOptions, validatedOptionsPrepared, prevPropName) {
                            for (var prop in template) {
                                if (template[LEXICON.hOP](prop) && data[LEXICON.hOP](prop)) {
                                    var isValid = false;
                                    var isDiff = false;
                                    var templateValue = template[prop];
                                    var templateValueType = type(templateValue);
                                    var templateIsComplex = templateValueType == TYPES.o;
                                    var templateTypes = !COMPATIBILITY.isA(templateValue) ? [templateValue] : templateValue;
                                    var dataDiffValue = diffData[prop];
                                    var dataValue = data[prop];
                                    var dataValueType = type(dataValue);
                                    var propPrefix = prevPropName ? prevPropName + '.' : '';
                                    var error = "The option \"" + propPrefix + prop + "\" wasn't set, because";
                                    var errorPossibleTypes = [];
                                    var errorRestrictedStrings = [];
                                    var restrictedStringValuesSplit;
                                    var restrictedStringValuesPossibilitiesSplit;
                                    var isRestrictedValue;
                                    var mainPossibility;
                                    var currType;
                                    var i;
                                    var v;
                                    var j;

                                    dataDiffValue = dataDiffValue === undefined ? {} : dataDiffValue;

                                    //if the template has a object as value, it means that the options are complex (verschachtelt)
                                    if (templateIsComplex && dataValueType == TYPES.o) {
                                        validatedOptions[prop] = {};
                                        validatedOptionsPrepared[prop] = {};
                                        checkObjectProps(dataValue, templateValue, dataDiffValue, validatedOptions[prop], validatedOptionsPrepared[prop], propPrefix + prop);
                                        FRAMEWORK.each([data, validatedOptions, validatedOptionsPrepared], function (index, value) {
                                            if (isEmptyObj(value[prop])) {
                                                delete value[prop];
                                            }
                                        });
                                    }
                                    else if (!templateIsComplex) {
                                        for (i = 0; i < templateTypes[LEXICON.l]; i++) {
                                            currType = templateTypes[i];
                                            templateValueType = type(currType);
                                            //if currtype is string and starts with restrictedStringPrefix and end with restrictedStringSuffix
                                            isRestrictedValue = templateValueType == TYPES.s && inArray(currType, possibleTemplateTypes) === -1;
                                            if (isRestrictedValue) {
                                                errorPossibleTypes.push(TYPES.s);

                                                //split it into a array which contains all possible values for example: ["y:yes", "n:no", "m:maybe"]
                                                restrictedStringValuesSplit = currType.split(restrictedStringsSplit);
                                                errorRestrictedStrings = errorRestrictedStrings.concat(restrictedStringValuesSplit);
                                                for (v = 0; v < restrictedStringValuesSplit[LEXICON.l]; v++) {
                                                    //split the possible values into their possibiliteis for example: ["y", "yes"] -> the first is always the mainPossibility
                                                    restrictedStringValuesPossibilitiesSplit = restrictedStringValuesSplit[v].split(restrictedStringsPossibilitiesSplit);
                                                    mainPossibility = restrictedStringValuesPossibilitiesSplit[0];
                                                    for (j = 0; j < restrictedStringValuesPossibilitiesSplit[LEXICON.l]; j++) {
                                                        //if any possibility matches with the dataValue, its valid
                                                        if (dataValue === restrictedStringValuesPossibilitiesSplit[j]) {
                                                            isValid = true;
                                                            break;
                                                        }
                                                    }
                                                    if (isValid)
                                                        break;
                                                }
                                            }
                                            else {
                                                errorPossibleTypes.push(currType);

                                                if (dataValueType === currType) {
                                                    isValid = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (isValid) {
                                            isDiff = dataValue !== dataDiffValue;

                                            if (isDiff)
                                                validatedOptions[prop] = dataValue;

                                            if (isRestrictedValue ? inArray(dataDiffValue, restrictedStringValuesPossibilitiesSplit) < 0 : isDiff)
                                                validatedOptionsPrepared[prop] = isRestrictedValue ? mainPossibility : dataValue;
                                        }
                                        else if (writeErrors) {
                                            console.warn(error + " it doesn't accept the type [ " + dataValueType.toUpperCase() + " ] with the value of \"" + dataValue + "\".\r\n" +
                                                "Accepted types are: [ " + errorPossibleTypes.join(', ').toUpperCase() + " ]." +
                                                (errorRestrictedStrings[length] > 0 ? "\r\nValid strings are: [ " + errorRestrictedStrings.join(', ').split(restrictedStringsPossibilitiesSplit).join(', ') + " ]." : ''));
                                        }
                                        delete data[prop];
                                    }
                                }
                            }
                        };
                        checkObjectProps(objectCopy, template, diffObj || {}, validatedOptions, validatedOptionsPrepared);

                        //add values which aren't specified in the template to the finished validated object to prevent them from being discarded
                        /*
                        if(keepForeignProps) {
                            FRAMEWORK.extend(true, validatedOptions, objectCopy);
                            FRAMEWORK.extend(true, validatedOptionsPrepared, objectCopy);
                        }
                        */

                        if (!isEmptyObj(objectCopy) && writeErrors)
                            console.warn('The following options are discarded due to invalidity:\r\n' + window.JSON.stringify(objectCopy, null, 2));

                        return {
                            _default: validatedOptions,
                            _prepared: validatedOptionsPrepared
                        };
                    }
                }
            }());

            /**
             * Initializes the object which contains global information about the plugin and each instance of it.
             */
            function initOverlayScrollbarsStatics() {
                if (!_pluginsGlobals)
                    _pluginsGlobals = new OverlayScrollbarsGlobals(_pluginsOptions._defaults);
                if (!_pluginsAutoUpdateLoop)
                    _pluginsAutoUpdateLoop = new OverlayScrollbarsAutoUpdateLoop(_pluginsGlobals);
            }

            /**
             * The global object for the OverlayScrollbars objects. It contains resources which every OverlayScrollbars object needs. This object is initialized only once: if the first OverlayScrollbars object gets initialized.
             * @param defaultOptions
             * @constructor
             */
            function OverlayScrollbarsGlobals(defaultOptions) {
                var _base = this;
                var strOverflow = 'overflow';
                var strHidden = 'hidden';
                var strScroll = 'scroll';
                var bodyElement = FRAMEWORK('body');
                var scrollbarDummyElement = FRAMEWORK('<div id="os-dummy-scrollbar-size"><div></div></div>');
                var scrollbarDummyElement0 = scrollbarDummyElement[0];
                var dummyContainerChild = FRAMEWORK(scrollbarDummyElement.children('div').eq(0));

                bodyElement.append(scrollbarDummyElement);
                scrollbarDummyElement.hide().show(); //fix IE8 bug (incorrect measuring)

                var nativeScrollbarSize = calcNativeScrollbarSize(scrollbarDummyElement0);
                var nativeScrollbarIsOverlaid = {
                    x: nativeScrollbarSize.x === 0,
                    y: nativeScrollbarSize.y === 0
                };
                var msie = (function () {
                    var ua = window.navigator.userAgent;
                    var strIndexOf = 'indexOf';
                    var strSubString = 'substring';
                    var msie = ua[strIndexOf]('MSIE ');
                    var trident = ua[strIndexOf]('Trident/');
                    var edge = ua[strIndexOf]('Edge/');
                    var rv = ua[strIndexOf]('rv:');
                    var result;
                    var parseIntFunc = parseInt;

                    // IE 10 or older => return version number
                    if (msie > 0)
                        result = parseIntFunc(ua[strSubString](msie + 5, ua[strIndexOf]('.', msie)), 10);

                    // IE 11 => return version number
                    else if (trident > 0)
                        result = parseIntFunc(ua[strSubString](rv + 3, ua[strIndexOf]('.', rv)), 10);

                    // Edge (IE 12+) => return version number
                    else if (edge > 0)
                        result = parseIntFunc(ua[strSubString](edge + 5, ua[strIndexOf]('.', edge)), 10);

                    // other browser
                    return result;
                })();

                FRAMEWORK.extend(_base, {
                    defaultOptions: defaultOptions,
                    msie: msie,
                    autoUpdateLoop: false,
                    autoUpdateRecommended: !COMPATIBILITY.mO(),
                    nativeScrollbarSize: nativeScrollbarSize,
                    nativeScrollbarIsOverlaid: nativeScrollbarIsOverlaid,
                    nativeScrollbarStyling: (function () {
                        var result = false;
                        scrollbarDummyElement.addClass('os-viewport-native-scrollbars-invisible');
                        try {
                            result = (scrollbarDummyElement.css('scrollbar-width') === 'none' && (msie > 9 || !msie)) || window.getComputedStyle(scrollbarDummyElement0, '::-webkit-scrollbar').getPropertyValue('display') === 'none';
                        } catch (ex) { }

                        //fix opera bug: scrollbar styles will only appear if overflow value is scroll or auto during the activation of the style.
                        //and set overflow to scroll
                        //scrollbarDummyElement.css(strOverflow, strHidden).hide().css(strOverflow, strScroll).show();
                        //return (scrollbarDummyElement0[LEXICON.oH] - scrollbarDummyElement0[LEXICON.cH]) === 0 && (scrollbarDummyElement0[LEXICON.oW] - scrollbarDummyElement0[LEXICON.cW]) === 0;

                        return result;
                    })(),
                    overlayScrollbarDummySize: { x: 30, y: 30 },
                    cssCalc: VENDORS._cssPropertyValue('width', 'calc', '(1px)') || null,
                    restrictedMeasuring: (function () {
                        //https://bugzilla.mozilla.org/show_bug.cgi?id=1439305
                        //since 1.11.0 always false -> fixed via CSS (hopefully)
                        scrollbarDummyElement.css(strOverflow, strHidden);
                        var scrollSize = {
                            w: scrollbarDummyElement0[LEXICON.sW],
                            h: scrollbarDummyElement0[LEXICON.sH]
                        };
                        scrollbarDummyElement.css(strOverflow, 'visible');
                        var scrollSize2 = {
                            w: scrollbarDummyElement0[LEXICON.sW],
                            h: scrollbarDummyElement0[LEXICON.sH]
                        };
                        return (scrollSize.w - scrollSize2.w) !== 0 || (scrollSize.h - scrollSize2.h) !== 0;
                    })(),
                    rtlScrollBehavior: (function () {
                        scrollbarDummyElement.css({ 'overflow-y': strHidden, 'overflow-x': strScroll, 'direction': 'rtl' }).scrollLeft(0);
                        var dummyContainerOffset = scrollbarDummyElement.offset();
                        var dummyContainerChildOffset = dummyContainerChild.offset();
                        //https://github.com/KingSora/OverlayScrollbars/issues/187
                        scrollbarDummyElement.scrollLeft(-999);
                        var dummyContainerChildOffsetAfterScroll = dummyContainerChild.offset();
                        return {
                            //origin direction = determines if the zero scroll position is on the left or right side
                            //'i' means 'invert' (i === true means that the axis must be inverted to be correct)
                            //true = on the left side
                            //false = on the right side
                            i: dummyContainerOffset.left === dummyContainerChildOffset.left,
                            //negative = determines if the maximum scroll is positive or negative
                            //'n' means 'negate' (n === true means that the axis must be negated to be correct)
                            //true = negative
                            //false = positive
                            n: dummyContainerChildOffset.left !== dummyContainerChildOffsetAfterScroll.left
                        };
                    })(),
                    supportTransform: !!VENDORS._cssProperty('transform'),
                    supportTransition: !!VENDORS._cssProperty('transition'),
                    supportPassiveEvents: (function () {
                        var supportsPassive = false;
                        try {
                            window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
                                get: function () {
                                    supportsPassive = true;
                                }
                            }));
                        } catch (e) { }
                        return supportsPassive;
                    })(),
                    supportResizeObserver: !!COMPATIBILITY.rO(),
                    supportMutationObserver: !!COMPATIBILITY.mO()
                });

                scrollbarDummyElement.removeAttr(LEXICON.s).remove();

                //Catch zoom event:
                (function () {
                    if (nativeScrollbarIsOverlaid.x && nativeScrollbarIsOverlaid.y)
                        return;

                    var abs = MATH.abs;
                    var windowWidth = COMPATIBILITY.wW();
                    var windowHeight = COMPATIBILITY.wH();
                    var windowDpr = getWindowDPR();
                    var onResize = function () {
                        if (INSTANCES().length > 0) {
                            var newW = COMPATIBILITY.wW();
                            var newH = COMPATIBILITY.wH();
                            var deltaW = newW - windowWidth;
                            var deltaH = newH - windowHeight;

                            if (deltaW === 0 && deltaH === 0)
                                return;

                            var deltaWRatio = MATH.round(newW / (windowWidth / 100.0));
                            var deltaHRatio = MATH.round(newH / (windowHeight / 100.0));
                            var absDeltaW = abs(deltaW);
                            var absDeltaH = abs(deltaH);
                            var absDeltaWRatio = abs(deltaWRatio);
                            var absDeltaHRatio = abs(deltaHRatio);
                            var newDPR = getWindowDPR();

                            var deltaIsBigger = absDeltaW > 2 && absDeltaH > 2;
                            var difference = !differenceIsBiggerThanOne(absDeltaWRatio, absDeltaHRatio);
                            var dprChanged = newDPR !== windowDpr && windowDpr > 0;
                            var isZoom = deltaIsBigger && difference && dprChanged;
                            var oldScrollbarSize = _base.nativeScrollbarSize;
                            var newScrollbarSize;

                            if (isZoom) {
                                bodyElement.append(scrollbarDummyElement);
                                newScrollbarSize = _base.nativeScrollbarSize = calcNativeScrollbarSize(scrollbarDummyElement[0]);
                                scrollbarDummyElement.remove();
                                if (oldScrollbarSize.x !== newScrollbarSize.x || oldScrollbarSize.y !== newScrollbarSize.y) {
                                    FRAMEWORK.each(INSTANCES(), function () {
                                        if (INSTANCES(this))
                                            INSTANCES(this).update('zoom');
                                    });
                                }
                            }

                            windowWidth = newW;
                            windowHeight = newH;
                            windowDpr = newDPR;
                        }
                    };

                    function differenceIsBiggerThanOne(valOne, valTwo) {
                        var absValOne = abs(valOne);
                        var absValTwo = abs(valTwo);
                        return !(absValOne === absValTwo || absValOne + 1 === absValTwo || absValOne - 1 === absValTwo);
                    }

                    function getWindowDPR() {
                        var dDPI = window.screen.deviceXDPI || 0;
                        var sDPI = window.screen.logicalXDPI || 1;
                        return window.devicePixelRatio || (dDPI / sDPI);
                    }

                    FRAMEWORK(window).on('resize', onResize);
                })();

                function calcNativeScrollbarSize(measureElement) {
                    return {
                        x: measureElement[LEXICON.oH] - measureElement[LEXICON.cH],
                        y: measureElement[LEXICON.oW] - measureElement[LEXICON.cW]
                    };
                }
            }

            /**
             * The object which manages the auto update loop for all OverlayScrollbars objects. This object is initialized only once: if the first OverlayScrollbars object gets initialized.
             * @constructor
             */
            function OverlayScrollbarsAutoUpdateLoop(globals) {
                var _base = this;
                var _inArray = FRAMEWORK.inArray;
                var _getNow = COMPATIBILITY.now;
                var _strAutoUpdate = 'autoUpdate';
                var _strAutoUpdateInterval = _strAutoUpdate + 'Interval';
                var _strLength = LEXICON.l;
                var _loopingInstances = [];
                var _loopingInstancesIntervalCache = [];
                var _loopIsActive = false;
                var _loopIntervalDefault = 33;
                var _loopInterval = _loopIntervalDefault;
                var _loopTimeOld = _getNow();
                var _loopID;


                /**
                 * The auto update loop which will run every 50 milliseconds or less if the update interval of a instance is lower than 50 milliseconds.
                 */
                var loop = function () {
                    if (_loopingInstances[_strLength] > 0 && _loopIsActive) {
                        _loopID = COMPATIBILITY.rAF()(function () {
                            loop();
                        });
                        var timeNew = _getNow();
                        var timeDelta = timeNew - _loopTimeOld;
                        var lowestInterval;
                        var instance;
                        var instanceOptions;
                        var instanceAutoUpdateAllowed;
                        var instanceAutoUpdateInterval;
                        var now;

                        if (timeDelta > _loopInterval) {
                            _loopTimeOld = timeNew - (timeDelta % _loopInterval);
                            lowestInterval = _loopIntervalDefault;
                            for (var i = 0; i < _loopingInstances[_strLength]; i++) {
                                instance = _loopingInstances[i];
                                if (instance !== undefined) {
                                    instanceOptions = instance.options();
                                    instanceAutoUpdateAllowed = instanceOptions[_strAutoUpdate];
                                    instanceAutoUpdateInterval = MATH.max(1, instanceOptions[_strAutoUpdateInterval]);
                                    now = _getNow();

                                    if ((instanceAutoUpdateAllowed === true || instanceAutoUpdateAllowed === null) && (now - _loopingInstancesIntervalCache[i]) > instanceAutoUpdateInterval) {
                                        instance.update('auto');
                                        _loopingInstancesIntervalCache[i] = new Date(now += instanceAutoUpdateInterval);
                                    }

                                    lowestInterval = MATH.max(1, MATH.min(lowestInterval, instanceAutoUpdateInterval));
                                }
                            }
                            _loopInterval = lowestInterval;
                        }
                    } else {
                        _loopInterval = _loopIntervalDefault;
                    }
                };

                /**
                 * Add OverlayScrollbars instance to the auto update loop. Only successful if the instance isn't already added.
                 * @param instance The instance which shall be updated in a loop automatically.
                 */
                _base.add = function (instance) {
                    if (_inArray(instance, _loopingInstances) === -1) {
                        _loopingInstances.push(instance);
                        _loopingInstancesIntervalCache.push(_getNow());
                        if (_loopingInstances[_strLength] > 0 && !_loopIsActive) {
                            _loopIsActive = true;
                            globals.autoUpdateLoop = _loopIsActive;
                            loop();
                        }
                    }
                };

                /**
                 * Remove OverlayScrollbars instance from the auto update loop. Only successful if the instance was added before.
                 * @param instance The instance which shall be updated in a loop automatically.
                 */
                _base.remove = function (instance) {
                    var index = _inArray(instance, _loopingInstances);
                    if (index > -1) {
                        //remove from loopingInstances list
                        _loopingInstancesIntervalCache.splice(index, 1);
                        _loopingInstances.splice(index, 1);

                        //correct update loop behavior
                        if (_loopingInstances[_strLength] === 0 && _loopIsActive) {
                            _loopIsActive = false;
                            globals.autoUpdateLoop = _loopIsActive;
                            if (_loopID !== undefined) {
                                COMPATIBILITY.cAF()(_loopID);
                                _loopID = -1;
                            }
                        }
                    }
                };
            }

            /**
             * A object which manages the scrollbars visibility of the target element.
             * @param pluginTargetElement The element from which the scrollbars shall be hidden.
             * @param options The custom options.
             * @param extensions The custom extensions.
             * @param globals
             * @param autoUpdateLoop
             * @returns {*}
             * @constructor
             */
            function OverlayScrollbarsInstance(pluginTargetElement, options, extensions, globals, autoUpdateLoop) {
                //shortcuts
                var type = COMPATIBILITY.type;
                var inArray = FRAMEWORK.inArray;
                var each = FRAMEWORK.each;

                //make correct instanceof
                var _base = new _plugin();
                var _frameworkProto = FRAMEWORK[LEXICON.p];

                //if passed element is no HTML element: skip and return
                if (!isHTMLElement(pluginTargetElement))
                    return;

                //if passed element is already initialized: set passed options if there are any and return its instance
                if (INSTANCES(pluginTargetElement)) {
                    var inst = INSTANCES(pluginTargetElement);
                    inst.options(options);
                    return inst;
                }

                //globals:
                var _nativeScrollbarIsOverlaid;
                var _overlayScrollbarDummySize;
                var _rtlScrollBehavior;
                var _autoUpdateRecommended;
                var _msieVersion;
                var _nativeScrollbarStyling;
                var _cssCalc;
                var _nativeScrollbarSize;
                var _supportTransition;
                var _supportTransform;
                var _supportPassiveEvents;
                var _supportResizeObserver;
                var _supportMutationObserver;
                var _restrictedMeasuring;

                //general readonly:
                var _initialized;
                var _destroyed;
                var _isTextarea;
                var _isBody;
                var _documentMixed;
                var _domExists;

                //general:
                var _isBorderBox;
                var _sizeAutoObserverAdded;
                var _paddingX;
                var _paddingY;
                var _borderX;
                var _borderY;
                var _marginX;
                var _marginY;
                var _isRTL;
                var _sleeping;
                var _contentBorderSize = {};
                var _scrollHorizontalInfo = {};
                var _scrollVerticalInfo = {};
                var _viewportSize = {};
                var _nativeScrollbarMinSize = {};

                //naming:	
                var _strMinusHidden = '-hidden';
                var _strMarginMinus = 'margin-';
                var _strPaddingMinus = 'padding-';
                var _strBorderMinus = 'border-';
                var _strTop = 'top';
                var _strRight = 'right';
                var _strBottom = 'bottom';
                var _strLeft = 'left';
                var _strMinMinus = 'min-';
                var _strMaxMinus = 'max-';
                var _strWidth = 'width';
                var _strHeight = 'height';
                var _strFloat = 'float';
                var _strEmpty = '';
                var _strAuto = 'auto';
                var _strSync = 'sync';
                var _strScroll = 'scroll';
                var _strHundredPercent = '100%';
                var _strX = 'x';
                var _strY = 'y';
                var _strDot = '.';
                var _strSpace = ' ';
                var _strScrollbar = 'scrollbar';
                var _strMinusHorizontal = '-horizontal';
                var _strMinusVertical = '-vertical';
                var _strScrollLeft = _strScroll + 'Left';
                var _strScrollTop = _strScroll + 'Top';
                var _strMouseTouchDownEvent = 'mousedown touchstart';
                var _strMouseTouchUpEvent = 'mouseup touchend touchcancel';
                var _strMouseTouchMoveEvent = 'mousemove touchmove';
                var _strMouseEnter = 'mouseenter';
                var _strMouseLeave = 'mouseleave';
                var _strKeyDownEvent = 'keydown';
                var _strKeyUpEvent = 'keyup';
                var _strSelectStartEvent = 'selectstart';
                var _strTransitionEndEvent = 'transitionend webkitTransitionEnd oTransitionEnd';
                var _strResizeObserverProperty = '__overlayScrollbarsRO__';

                //class names:	
                var _cassNamesPrefix = 'os-';
                var _classNameHTMLElement = _cassNamesPrefix + 'html';
                var _classNameHostElement = _cassNamesPrefix + 'host';
                var _classNameHostElementForeign = _classNameHostElement + '-foreign';
                var _classNameHostTextareaElement = _classNameHostElement + '-textarea';
                var _classNameHostScrollbarHorizontalHidden = _classNameHostElement + '-' + _strScrollbar + _strMinusHorizontal + _strMinusHidden;
                var _classNameHostScrollbarVerticalHidden = _classNameHostElement + '-' + _strScrollbar + _strMinusVertical + _strMinusHidden;
                var _classNameHostTransition = _classNameHostElement + '-transition';
                var _classNameHostRTL = _classNameHostElement + '-rtl';
                var _classNameHostResizeDisabled = _classNameHostElement + '-resize-disabled';
                var _classNameHostScrolling = _classNameHostElement + '-scrolling';
                var _classNameHostOverflow = _classNameHostElement + '-overflow';
                var _classNameHostOverflow = _classNameHostElement + '-overflow';
                var _classNameHostOverflowX = _classNameHostOverflow + '-x';
                var _classNameHostOverflowY = _classNameHostOverflow + '-y';
                var _classNameTextareaElement = _cassNamesPrefix + 'textarea';
                var _classNameTextareaCoverElement = _classNameTextareaElement + '-cover';
                var _classNamePaddingElement = _cassNamesPrefix + 'padding';
                var _classNameViewportElement = _cassNamesPrefix + 'viewport';
                var _classNameViewportNativeScrollbarsInvisible = _classNameViewportElement + '-native-scrollbars-invisible';
                var _classNameViewportNativeScrollbarsOverlaid = _classNameViewportElement + '-native-scrollbars-overlaid';
                var _classNameContentElement = _cassNamesPrefix + 'content';
                var _classNameContentArrangeElement = _cassNamesPrefix + 'content-arrange';
                var _classNameContentGlueElement = _cassNamesPrefix + 'content-glue';
                var _classNameSizeAutoObserverElement = _cassNamesPrefix + 'size-auto-observer';
                var _classNameResizeObserverElement = _cassNamesPrefix + 'resize-observer';
                var _classNameResizeObserverItemElement = _cassNamesPrefix + 'resize-observer-item';
                var _classNameResizeObserverItemFinalElement = _classNameResizeObserverItemElement + '-final';
                var _classNameTextInherit = _cassNamesPrefix + 'text-inherit';
                var _classNameScrollbar = _cassNamesPrefix + _strScrollbar;
                var _classNameScrollbarTrack = _classNameScrollbar + '-track';
                var _classNameScrollbarTrackOff = _classNameScrollbarTrack + '-off';
                var _classNameScrollbarHandle = _classNameScrollbar + '-handle';
                var _classNameScrollbarHandleOff = _classNameScrollbarHandle + '-off';
                var _classNameScrollbarUnusable = _classNameScrollbar + '-unusable';
                var _classNameScrollbarAutoHidden = _classNameScrollbar + '-' + _strAuto + _strMinusHidden;
                var _classNameScrollbarCorner = _classNameScrollbar + '-corner';
                var _classNameScrollbarCornerResize = _classNameScrollbarCorner + '-resize';
                var _classNameScrollbarCornerResizeB = _classNameScrollbarCornerResize + '-both';
                var _classNameScrollbarCornerResizeH = _classNameScrollbarCornerResize + _strMinusHorizontal;
                var _classNameScrollbarCornerResizeV = _classNameScrollbarCornerResize + _strMinusVertical;
                var _classNameScrollbarHorizontal = _classNameScrollbar + _strMinusHorizontal;
                var _classNameScrollbarVertical = _classNameScrollbar + _strMinusVertical;
                var _classNameDragging = _cassNamesPrefix + 'dragging';
                var _classNameThemeNone = _cassNamesPrefix + 'theme-none';
                var _classNamesDynamicDestroy = [
                    _classNameViewportNativeScrollbarsInvisible,
                    _classNameViewportNativeScrollbarsOverlaid,
                    _classNameScrollbarTrackOff,
                    _classNameScrollbarHandleOff,
                    _classNameScrollbarUnusable,
                    _classNameScrollbarAutoHidden,
                    _classNameScrollbarCornerResize,
                    _classNameScrollbarCornerResizeB,
                    _classNameScrollbarCornerResizeH,
                    _classNameScrollbarCornerResizeV,
                    _classNameDragging].join(_strSpace);

                //callbacks:	
                var _callbacksInitQeueue = [];

                //attrs viewport shall inherit from target	
                var _viewportAttrsFromTarget = [LEXICON.ti];

                //options:	
                var _defaultOptions;
                var _currentOptions;
                var _currentPreparedOptions;

                //extensions:	
                var _extensions = {};
                var _extensionsPrivateMethods = 'added removed on contract';

                //update	
                var _lastUpdateTime;
                var _swallowedUpdateHints = {};
                var _swallowedUpdateTimeout;
                var _swallowUpdateLag = 42;
                var _updateOnLoadEventName = 'load';
                var _updateOnLoadElms = [];

                //DOM elements:	
                var _windowElement;
                var _documentElement;
                var _htmlElement;
                var _bodyElement;
                var _targetElement;                     //the target element of this OverlayScrollbars object	
                var _hostElement;                       //the host element of this OverlayScrollbars object -> may be the same as targetElement	
                var _sizeAutoObserverElement;           //observes size auto changes	
                var _sizeObserverElement;               //observes size and padding changes	
                var _paddingElement;                    //manages the padding	
                var _viewportElement;                   //is the viewport of our scrollbar model	
                var _contentElement;                    //the element which holds the content	
                var _contentArrangeElement;             //is needed for correct sizing of the content element (only if native scrollbars are overlays)	
                var _contentGlueElement;                //has always the size of the content element	
                var _textareaCoverElement;              //only applied if target is a textarea element. Used for correct size calculation and for prevention of uncontrolled scrolling	
                var _scrollbarCornerElement;
                var _scrollbarHorizontalElement;
                var _scrollbarHorizontalTrackElement;
                var _scrollbarHorizontalHandleElement;
                var _scrollbarVerticalElement;
                var _scrollbarVerticalTrackElement;
                var _scrollbarVerticalHandleElement;
                var _windowElementNative;
                var _documentElementNative;
                var _targetElementNative;
                var _hostElementNative;
                var _sizeAutoObserverElementNative;
                var _sizeObserverElementNative;
                var _paddingElementNative;
                var _viewportElementNative;
                var _contentElementNative;

                //Cache:	
                var _hostSizeCache;
                var _contentScrollSizeCache;
                var _arrangeContentSizeCache;
                var _hasOverflowCache;
                var _hideOverflowCache;
                var _widthAutoCache;
                var _heightAutoCache;
                var _cssBoxSizingCache;
                var _cssPaddingCache;
                var _cssBorderCache;
                var _cssMarginCache;
                var _cssDirectionCache;
                var _cssDirectionDetectedCache;
                var _paddingAbsoluteCache;
                var _clipAlwaysCache;
                var _contentGlueSizeCache;
                var _overflowBehaviorCache;
                var _overflowAmountCache;
                var _ignoreOverlayScrollbarHidingCache;
                var _autoUpdateCache;
                var _sizeAutoCapableCache;
                var _contentElementScrollSizeChangeDetectedCache;
                var _hostElementSizeChangeDetectedCache;
                var _scrollbarsVisibilityCache;
                var _scrollbarsAutoHideCache;
                var _scrollbarsClickScrollingCache;
                var _scrollbarsDragScrollingCache;
                var _resizeCache;
                var _normalizeRTLCache;
                var _classNameCache;
                var _oldClassName;
                var _textareaAutoWrappingCache;
                var _textareaInfoCache;
                var _textareaSizeCache;
                var _textareaDynHeightCache;
                var _textareaDynWidthCache;
                var _bodyMinSizeCache;
                var _updateAutoCache = {};

                //MutationObserver:	
                var _mutationObserverHost;
                var _mutationObserverContent;
                var _mutationObserverHostCallback;
                var _mutationObserverContentCallback;
                var _mutationObserversConnected;
                var _mutationObserverAttrsTextarea = ['wrap', 'cols', 'rows'];
                var _mutationObserverAttrsHost = [LEXICON.i, LEXICON.c, LEXICON.s, 'open'].concat(_viewportAttrsFromTarget);

                //events:	
                var _destroyEvents = [];

                //textarea:	
                var _textareaHasFocus;

                //scrollbars:	
                var _scrollbarsAutoHideTimeoutId;
                var _scrollbarsAutoHideMoveTimeoutId;
                var _scrollbarsAutoHideDelay;
                var _scrollbarsAutoHideNever;
                var _scrollbarsAutoHideScroll;
                var _scrollbarsAutoHideMove;
                var _scrollbarsAutoHideLeave;
                var _scrollbarsHandleHovered;
                var _scrollbarsHandlesDefineScrollPos;

                //resize	
                var _resizeNone;
                var _resizeBoth;
                var _resizeHorizontal;
                var _resizeVertical;


                //==== Event Listener ====//	

                /**	
                 * Adds or removes a event listener from the given element. 	
                 * @param element The element to which the event listener shall be applied or removed.	
                 * @param eventNames The name(s) of the events.	
                 * @param listener The method which shall be called.	
                 * @param remove True if the handler shall be removed, false or undefined if the handler shall be added.	
                 * @param passiveOrOptions The options for the event.
                 */
                function setupResponsiveEventListener(element, eventNames, listener, remove, passiveOrOptions) {
                    var collected = COMPATIBILITY.isA(eventNames) && COMPATIBILITY.isA(listener);
                    var method = remove ? 'removeEventListener' : 'addEventListener';
                    var onOff = remove ? 'off' : 'on';
                    var events = collected ? false : eventNames.split(_strSpace)
                    var i = 0;

                    var passiveOrOptionsIsObj = FRAMEWORK.isPlainObject(passiveOrOptions);
                    var passive = (_supportPassiveEvents && (passiveOrOptionsIsObj ? (passiveOrOptions._passive) : passiveOrOptions)) || false;
                    var capture = passiveOrOptionsIsObj && (passiveOrOptions._capture || false);
                    var nativeParam = _supportPassiveEvents ? {
                        passive: passive,
                        capture: capture,
                    } : capture;

                    if (collected) {
                        for (; i < eventNames[LEXICON.l]; i++)
                            setupResponsiveEventListener(element, eventNames[i], listener[i], remove, passiveOrOptions);
                    }
                    else {
                        for (; i < events[LEXICON.l]; i++) {
                            if(_supportPassiveEvents) {
                                element[0][method](events[i], listener, nativeParam);
                            }
                            else {
                                element[onOff](events[i], listener);
                            }     
                        }
                    }
                }


                function addDestroyEventListener(element, eventNames, listener, passive) {
                    setupResponsiveEventListener(element, eventNames, listener, false, passive);
                    _destroyEvents.push(COMPATIBILITY.bind(setupResponsiveEventListener, 0, element, eventNames, listener, true, passive));
                }

                //==== Resize Observer ====//

                /**
                 * Adds or removes a resize observer from the given element.
                 * @param targetElement The element to which the resize observer shall be added or removed.
                 * @param onElementResizedCallback The callback which is fired every time the resize observer registers a size change or false / undefined if the resizeObserver shall be removed.
                 */
                function setupResizeObserver(targetElement, onElementResizedCallback) {
                    if (targetElement) {
                        var resizeObserver = COMPATIBILITY.rO();
                        var strAnimationStartEvent = 'animationstart mozAnimationStart webkitAnimationStart MSAnimationStart';
                        var strChildNodes = 'childNodes';
                        var constScroll = 3333333;
                        var callback = function () {
                            targetElement[_strScrollTop](constScroll)[_strScrollLeft](_isRTL ? _rtlScrollBehavior.n ? -constScroll : _rtlScrollBehavior.i ? 0 : constScroll : constScroll);
                            onElementResizedCallback();
                        };
                        //add resize observer:
                        if (onElementResizedCallback) {
                            if (_supportResizeObserver) {
                                var element = targetElement.addClass('observed').append(generateDiv(_classNameResizeObserverElement)).contents()[0];
                                var observer = element[_strResizeObserverProperty] = new resizeObserver(callback);
                                observer.observe(element);
                            }
                            else {
                                if (_msieVersion > 9 || !_autoUpdateRecommended) {
                                    targetElement.prepend(
                                        generateDiv(_classNameResizeObserverElement,
                                            generateDiv({ c: _classNameResizeObserverItemElement, dir: 'ltr' },
                                                generateDiv(_classNameResizeObserverItemElement,
                                                    generateDiv(_classNameResizeObserverItemFinalElement)
                                                ) +
                                                generateDiv(_classNameResizeObserverItemElement,
                                                    generateDiv({ c: _classNameResizeObserverItemFinalElement, style: 'width: 200%; height: 200%' })
                                                )
                                            )
                                        )
                                    );

                                    var observerElement = targetElement[0][strChildNodes][0][strChildNodes][0];
                                    var shrinkElement = FRAMEWORK(observerElement[strChildNodes][1]);
                                    var expandElement = FRAMEWORK(observerElement[strChildNodes][0]);
                                    var expandElementChild = FRAMEWORK(expandElement[0][strChildNodes][0]);
                                    var widthCache = observerElement[LEXICON.oW];
                                    var heightCache = observerElement[LEXICON.oH];
                                    var isDirty;
                                    var rAFId;
                                    var currWidth;
                                    var currHeight;
                                    var factor = 2;
                                    var nativeScrollbarSize = globals.nativeScrollbarSize; //care don't make changes to this object!!!
                                    var reset = function () {
                                        /*
                                         var sizeResetWidth = observerElement[LEXICON.oW] + nativeScrollbarSize.x * factor + nativeScrollbarSize.y * factor + _overlayScrollbarDummySize.x + _overlayScrollbarDummySize.y;
                                         var sizeResetHeight = observerElement[LEXICON.oH] + nativeScrollbarSize.x * factor + nativeScrollbarSize.y * factor + _overlayScrollbarDummySize.x + _overlayScrollbarDummySize.y;
                                         var expandChildCSS = {};
                                         expandChildCSS[_strWidth] = sizeResetWidth;
                                         expandChildCSS[_strHeight] = sizeResetHeight;
                                         expandElementChild.css(expandChildCSS);


                                         expandElement[_strScrollLeft](sizeResetWidth)[_strScrollTop](sizeResetHeight);
                                         shrinkElement[_strScrollLeft](sizeResetWidth)[_strScrollTop](sizeResetHeight);
                                         */
                                        expandElement[_strScrollLeft](constScroll)[_strScrollTop](constScroll);
                                        shrinkElement[_strScrollLeft](constScroll)[_strScrollTop](constScroll);
                                    };
                                    var onResized = function () {
                                        rAFId = 0;
                                        if (!isDirty)
                                            return;

                                        widthCache = currWidth;
                                        heightCache = currHeight;
                                        callback();
                                    };
                                    var onScroll = function (event) {
                                        currWidth = observerElement[LEXICON.oW];
                                        currHeight = observerElement[LEXICON.oH];
                                        isDirty = currWidth != widthCache || currHeight != heightCache;

                                        if (event && isDirty && !rAFId) {
                                            COMPATIBILITY.cAF()(rAFId);
                                            rAFId = COMPATIBILITY.rAF()(onResized);
                                        }
                                        else if (!event)
                                            onResized();

                                        reset();
                                        if (event) {
                                            COMPATIBILITY.prvD(event);
                                            COMPATIBILITY.stpP(event);
                                        }
                                        return false;
                                    };
                                    var expandChildCSS = {};
                                    var observerElementCSS = {};

                                    setTopRightBottomLeft(observerElementCSS, _strEmpty, [
                                        -((nativeScrollbarSize.y + 1) * factor),
                                        nativeScrollbarSize.x * -factor,
                                        nativeScrollbarSize.y * -factor,
                                        -((nativeScrollbarSize.x + 1) * factor)
                                    ]);

                                    FRAMEWORK(observerElement).css(observerElementCSS);
                                    expandElement.on(_strScroll, onScroll);
                                    shrinkElement.on(_strScroll, onScroll);
                                    targetElement.on(strAnimationStartEvent, function () {
                                        onScroll(false);
                                    });
                                    //lets assume that the divs will never be that large and a constant value is enough
                                    expandChildCSS[_strWidth] = constScroll;
                                    expandChildCSS[_strHeight] = constScroll;
                                    expandElementChild.css(expandChildCSS);

                                    reset();
                                }
                                else {
                                    var attachEvent = _documentElementNative.attachEvent;
                                    var isIE = _msieVersion !== undefined;
                                    if (attachEvent) {
                                        targetElement.prepend(generateDiv(_classNameResizeObserverElement));
                                        findFirst(targetElement, _strDot + _classNameResizeObserverElement)[0].attachEvent('onresize', callback);
                                    }
                                    else {
                                        var obj = _documentElementNative.createElement(TYPES.o);
                                        obj.setAttribute(LEXICON.ti, '-1');
                                        obj.setAttribute(LEXICON.c, _classNameResizeObserverElement);
                                        obj.onload = function () {
                                            var wnd = this.contentDocument.defaultView;
                                            wnd.addEventListener('resize', callback);
                                            wnd.document.documentElement.style.display = 'none';
                                        };
                                        obj.type = 'text/html';
                                        if (isIE)
                                            targetElement.prepend(obj);
                                        obj.data = 'about:blank';
                                        if (!isIE)
                                            targetElement.prepend(obj);
                                        targetElement.on(strAnimationStartEvent, callback);
                                    }
                                }
                            }

                            if (targetElement[0] === _sizeObserverElementNative) {
                                var directionChanged = function () {
                                    var dir = _hostElement.css('direction');
                                    var css = {};
                                    var scrollLeftValue = 0;
                                    var result = false;
                                    if (dir !== _cssDirectionDetectedCache) {
                                        if (dir === 'ltr') {
                                            css[_strLeft] = 0;
                                            css[_strRight] = _strAuto;
                                            scrollLeftValue = constScroll;
                                        }
                                        else {
                                            css[_strLeft] = _strAuto;
                                            css[_strRight] = 0;
                                            scrollLeftValue = _rtlScrollBehavior.n ? -constScroll : _rtlScrollBehavior.i ? 0 : constScroll;
                                        }
                                        //execution order is important for IE!!!
                                        _sizeObserverElement.children().eq(0).css(css);
                                        _sizeObserverElement[_strScrollLeft](scrollLeftValue)[_strScrollTop](constScroll);
                                        _cssDirectionDetectedCache = dir;
                                        result = true;
                                    }
                                    return result;
                                };
                                directionChanged();
                                addDestroyEventListener(targetElement, _strScroll, function (event) {
                                    if (directionChanged())
                                        update();
                                    COMPATIBILITY.prvD(event);
                                    COMPATIBILITY.stpP(event);
                                    return false;
                                });
                            }
                        }
                        //remove resize observer:
                        else {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                var resizeObserverObj = element[_strResizeObserverProperty];
                                if (resizeObserverObj) {
                                    resizeObserverObj.disconnect();
                                    delete element[_strResizeObserverProperty];
                                }
                            }
                            else {
                                remove(targetElement.children(_strDot + _classNameResizeObserverElement).eq(0));
                            }
                        }
                    }
                }

                /**
                 * Freezes or unfreezes the given resize observer.
                 * @param targetElement The element to which the target resize observer is applied.
                 * @param freeze True if the resize observer shall be frozen, false otherwise.
                 
                function freezeResizeObserver(targetElement, freeze) {
                    if (targetElement !== undefined) {
                        if(freeze) {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                element[_strResizeObserverProperty].unobserve(element);
                            }
                            else {
                                targetElement = targetElement.children(_strDot + _classNameResizeObserverElement).eq(0);
                                var w = targetElement.css(_strWidth);
                                var h = targetElement.css(_strHeight);
                                var css = {};
                                css[_strWidth] = w;
                                css[_strHeight] = h;
                                targetElement.css(css);
                            }
                        }
                        else {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                element[_strResizeObserverProperty].observe(element);
                            }
                            else {
                                var css = { };
                                css[_strHeight] = _strEmpty;
                                css[_strWidth] = _strEmpty;
                                targetElement.children(_strDot + _classNameResizeObserverElement).eq(0).css(css);
                            }
                        }
                    }
                }
                */


                //==== Mutation Observers ====//

                /**
                 * Creates MutationObservers for the host and content Element if they are supported.
                 */
                function createMutationObservers() {
                    if (_supportMutationObserver) {
                        var mutationObserverContentLag = 11;
                        var mutationObserver = COMPATIBILITY.mO();
                        var contentLastUpdate = COMPATIBILITY.now();
                        var mutationTarget;
                        var mutationAttrName;
                        var mutationIsClass;
                        var oldMutationVal;
                        var newClassVal;
                        var hostClassNameRegex;
                        var contentTimeout;
                        var now;
                        var sizeAuto;
                        var action;

                        _mutationObserverHostCallback = function (mutations) {

                            var doUpdate = false;
                            var doUpdateForce = false;
                            var mutation;
                            var mutatedAttrs = [];

                            if (_initialized && !_sleeping) {
                                each(mutations, function () {
                                    mutation = this;
                                    mutationTarget = mutation.target;
                                    mutationAttrName = mutation.attributeName;
                                    mutationIsClass = mutationAttrName === LEXICON.c;
                                    oldMutationVal = mutation.oldValue;
                                    newClassVal = mutationTarget.className;

                                    if (_domExists && mutationIsClass && !doUpdateForce) {
                                        // if old class value contains _classNameHostElementForeign and new class value doesn't
                                        if (oldMutationVal.indexOf(_classNameHostElementForeign) > -1 && newClassVal.indexOf(_classNameHostElementForeign) < 0) {
                                            hostClassNameRegex = createHostClassNameRegExp(true);
                                            _hostElementNative.className = newClassVal.split(_strSpace).concat(oldMutationVal.split(_strSpace).filter(function (name) {
                                                return name.match(hostClassNameRegex);
                                            })).join(_strSpace);
                                            doUpdate = doUpdateForce = true;
                                        }
                                    }

                                    if (!doUpdate) {
                                        doUpdate = mutationIsClass
                                            ? hostClassNamesChanged(oldMutationVal, newClassVal)
                                            : mutationAttrName === LEXICON.s
                                                ? oldMutationVal !== mutationTarget[LEXICON.s].cssText
                                                : true;
                                    }

                                    mutatedAttrs.push(mutationAttrName);
                                });

                                updateViewportAttrsFromTarget(mutatedAttrs);

                                if (doUpdate)
                                    _base.update(doUpdateForce || _strAuto);
                            }
                            return doUpdate;
                        };
                        _mutationObserverContentCallback = function (mutations) {
                            var doUpdate = false;
                            var mutation;

                            if (_initialized && !_sleeping) {
                                each(mutations, function () {
                                    mutation = this;
                                    doUpdate = isUnknownMutation(mutation);
                                    return !doUpdate;
                                });

                                if (doUpdate) {
                                    now = COMPATIBILITY.now();
                                    sizeAuto = (_heightAutoCache || _widthAutoCache);
                                    action = function () {
                                        if (!_destroyed) {
                                            contentLastUpdate = now;

                                            //if cols, rows or wrap attr was changed
                                            if (_isTextarea)
                                                textareaUpdate();

                                            if (sizeAuto)
                                                update();
                                            else
                                                _base.update(_strAuto);
                                        }
                                    };
                                    clearTimeout(contentTimeout);
                                    if (mutationObserverContentLag <= 0 || now - contentLastUpdate > mutationObserverContentLag || !sizeAuto)
                                        action();
                                    else
                                        contentTimeout = setTimeout(action, mutationObserverContentLag);
                                }
                            }
                            return doUpdate;
                        }

                        _mutationObserverHost = new mutationObserver(_mutationObserverHostCallback);
                        _mutationObserverContent = new mutationObserver(_mutationObserverContentCallback);
                    }
                }

                /**
                 * Connects the MutationObservers if they are supported.
                 */
                function connectMutationObservers() {
                    if (_supportMutationObserver && !_mutationObserversConnected) {
                        _mutationObserverHost.observe(_hostElementNative, {
                            attributes: true,
                            attributeOldValue: true,
                            attributeFilter: _mutationObserverAttrsHost
                        });

                        _mutationObserverContent.observe(_isTextarea ? _targetElementNative : _contentElementNative, {
                            attributes: true,
                            attributeOldValue: true,
                            subtree: !_isTextarea,
                            childList: !_isTextarea,
                            characterData: !_isTextarea,
                            attributeFilter: _isTextarea ? _mutationObserverAttrsTextarea : _mutationObserverAttrsHost
                        });

                        _mutationObserversConnected = true;
                    }
                }

                /**
                 * Disconnects the MutationObservers if they are supported.
                 */
                function disconnectMutationObservers() {
                    if (_supportMutationObserver && _mutationObserversConnected) {
                        _mutationObserverHost.disconnect();
                        _mutationObserverContent.disconnect();

                        _mutationObserversConnected = false;
                    }
                }


                //==== Events of elements ====//

                /**
                 * This method gets called every time the host element gets resized. IMPORTANT: Padding changes are detected too!!
                 * It refreshes the hostResizedEventArgs and the hostSizeResizeCache.
                 * If there are any size changes, the update method gets called.
                 */
                function hostOnResized() {
                    if (!_sleeping) {
                        var changed;
                        var hostSize = {
                            w: _sizeObserverElementNative[LEXICON.sW],
                            h: _sizeObserverElementNative[LEXICON.sH]
                        };

                        changed = checkCache(hostSize, _hostElementSizeChangeDetectedCache);
                        _hostElementSizeChangeDetectedCache = hostSize;
                        if (changed)
                            update({ _hostSizeChanged: true });
                    }
                }

                /**
                 * The mouse enter event of the host element. This event is only needed for the autoHide feature.
                 */
                function hostOnMouseEnter() {
                    if (_scrollbarsAutoHideLeave)
                        refreshScrollbarsAutoHide(true);
                }

                /**
                 * The mouse leave event of the host element. This event is only needed for the autoHide feature.
                 */
                function hostOnMouseLeave() {
                    if (_scrollbarsAutoHideLeave && !_bodyElement.hasClass(_classNameDragging))
                        refreshScrollbarsAutoHide(false);
                }

                /**
                 * The mouse move event of the host element. This event is only needed for the autoHide "move" feature.
                 */
                function hostOnMouseMove() {
                    if (_scrollbarsAutoHideMove) {
                        refreshScrollbarsAutoHide(true);
                        clearTimeout(_scrollbarsAutoHideMoveTimeoutId);
                        _scrollbarsAutoHideMoveTimeoutId = setTimeout(function () {
                            if (_scrollbarsAutoHideMove && !_destroyed)
                                refreshScrollbarsAutoHide(false);
                        }, 100);
                    }
                }

                /**
                 * Prevents text from deselection if attached to the document element on the mousedown event of a DOM element.
                 * @param event The select start event.
                 */
                function documentOnSelectStart(event) {
                    COMPATIBILITY.prvD(event);
                    return false;
                }

                /**	
                 * A callback which will be called after a element has loaded.	
                 */
                function updateOnLoadCallback(event) {
					if (!_destroyed) {
						var target = event.target;
						var elm = FRAMEWORK(event.target);
						var index = FRAMEWORK.inArray(target, _updateOnLoadElms);
						if (index > -1) {
							_updateOnLoadElms.splice(index, 1);
						}

						eachUpdateOnLoad(function (i, updateOnLoadSelector) {
							if (elm.is(updateOnLoadSelector)) {
								update({ _contentSizeChanged: true });
							}
						});
					}
                }

                /**
                * Adds or removes mouse & touch events of the host element. (for handling auto-hiding of the scrollbars)
                * @param destroy Indicates whether the events shall be added or removed.
                */
                function setupHostMouseTouchEvents(destroy) {
                    if (!destroy)
                        setupHostMouseTouchEvents(true);

                    setupResponsiveEventListener(_hostElement,
                        _strMouseTouchMoveEvent.split(_strSpace)[0],
                        hostOnMouseMove,
                        (!_scrollbarsAutoHideMove || destroy), true);
                    setupResponsiveEventListener(_hostElement,
                        [_strMouseEnter, _strMouseLeave],
                        [hostOnMouseEnter, hostOnMouseLeave],
                        (!_scrollbarsAutoHideLeave || destroy), true);

                    //if the plugin is initialized and the mouse is over the host element, make the scrollbars visible
                    if (!_initialized && !destroy)
                        _hostElement.one('mouseover', hostOnMouseEnter);
                }


                //==== Update Detection ====//

                /**
                 * Measures the min width and min height of the body element and refreshes the related cache.
                 * @returns {boolean} True if the min width or min height has changed, false otherwise.
                 */
                function bodyMinSizeChanged() {
                    var bodyMinSize = {};
                    if (_isBody && _contentArrangeElement) {
                        bodyMinSize.w = parseToZeroOrNumber(_contentArrangeElement.css(_strMinMinus + _strWidth));
                        bodyMinSize.h = parseToZeroOrNumber(_contentArrangeElement.css(_strMinMinus + _strHeight));
                        bodyMinSize.c = checkCache(bodyMinSize, _bodyMinSizeCache);
                        bodyMinSize.f = true; //flag for "measured at least once"
                    }
                    _bodyMinSizeCache = bodyMinSize;
                    return !!bodyMinSize.c;
                }

                /**
                 * Returns true if the class names really changed (new class without plugin host prefix)
                 * @param oldClassNames The old ClassName string or array.
                 * @param newClassNames The new ClassName string or array.
                 * @returns {boolean} True if the class names has really changed, false otherwise.
                 */
                function hostClassNamesChanged(oldClassNames, newClassNames) {
                    var currClasses = typeof newClassNames == TYPES.s ? newClassNames.split(_strSpace) : [];
                    var oldClasses = typeof oldClassNames == TYPES.s ? oldClassNames.split(_strSpace) : [];
                    var diff = getArrayDifferences(oldClasses, currClasses);

                    // remove none theme from diff list to prevent update
                    var idx = inArray(_classNameThemeNone, diff);
                    var i;
                    var regex;

                    if (idx > -1)
                        diff.splice(idx, 1);

                    if (diff[LEXICON.l] > 0) {
                        regex = createHostClassNameRegExp(true, true);
                        for (i = 0; i < diff.length; i++) {
                            if (!diff[i].match(regex)) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                /**
                 * Returns true if the given mutation is not from a from the plugin generated element. If the target element is a textarea the mutation is always unknown.
                 * @param mutation The mutation which shall be checked.
                 * @returns {boolean} True if the mutation is from a unknown element, false otherwise.
                 */
                function isUnknownMutation(mutation) {
                    var attributeName = mutation.attributeName;
                    var mutationTarget = mutation.target;
                    var mutationType = mutation.type;
                    var strClosest = 'closest';

                    if (mutationTarget === _contentElementNative)
                        return attributeName === null;
                    if (mutationType === 'attributes' && (attributeName === LEXICON.c || attributeName === LEXICON.s) && !_isTextarea) {
                        //ignore className changes by the plugin	
                        if (attributeName === LEXICON.c && FRAMEWORK(mutationTarget).hasClass(_classNameHostElement))
                            return hostClassNamesChanged(mutation.oldValue, mutationTarget.className);

                        //only do it of browser support it natively	
                        if (typeof mutationTarget[strClosest] != TYPES.f)
                            return true;
                        if (mutationTarget[strClosest](_strDot + _classNameResizeObserverElement) !== null ||
                            mutationTarget[strClosest](_strDot + _classNameScrollbar) !== null ||
                            mutationTarget[strClosest](_strDot + _classNameScrollbarCorner) !== null)
                            return false;
                    }
                    return true;
                }

                /**
                 * Returns true if the content size was changed since the last time this method was called.
                 * @returns {boolean} True if the content size was changed, false otherwise.
                 */
                function updateAutoContentSizeChanged() {
                    if (_sleeping)
                        return false;

                    var contentMeasureElement = getContentMeasureElement();
                    var textareaValueLength = _isTextarea && _widthAutoCache && !_textareaAutoWrappingCache ? _targetElement.val().length : 0;
                    var setCSS = !_mutationObserversConnected && _widthAutoCache && !_isTextarea;
                    var css = {};
                    var float;
                    var bodyMinSizeC;
                    var changed;
                    var contentElementScrollSize;

                    if (setCSS) {
                        float = _contentElement.css(_strFloat);
                        css[_strFloat] = _isRTL ? _strRight : _strLeft;
                        css[_strWidth] = _strAuto;
                        _contentElement.css(css);
                    }
                    contentElementScrollSize = {
                        w: contentMeasureElement[LEXICON.sW] + textareaValueLength,
                        h: contentMeasureElement[LEXICON.sH] + textareaValueLength
                    };
                    if (setCSS) {
                        css[_strFloat] = float;
                        css[_strWidth] = _strHundredPercent;
                        _contentElement.css(css);
                    }

                    bodyMinSizeC = bodyMinSizeChanged();
                    changed = checkCache(contentElementScrollSize, _contentElementScrollSizeChangeDetectedCache);

                    _contentElementScrollSizeChangeDetectedCache = contentElementScrollSize;

                    return changed || bodyMinSizeC;
                }

                /**
                 * Returns true when a attribute which the MutationObserver would observe has changed.  
                 * @returns {boolean} True if one of the attributes which a MutationObserver would observe has changed, false or undefined otherwise.
                 */
                function meaningfulAttrsChanged() {
                    if (_sleeping || _mutationObserversConnected)
                        return;

                    var elem;
                    var curr;
                    var cache;
                    var changedAttrs = [];
                    var checks = [
                        {
                            _elem: _hostElement,
                            _attrs: _mutationObserverAttrsHost.concat(':visible')
                        },
                        {
                            _elem: _isTextarea ? _targetElement : undefined,
                            _attrs: _mutationObserverAttrsTextarea
                        }
                    ];

                    each(checks, function (index, check) {
                        elem = check._elem;
                        if (elem) {
                            each(check._attrs, function (index, attr) {
                                curr = attr.charAt(0) === ':' ? elem.is(attr) : elem.attr(attr);
                                cache = _updateAutoCache[attr];

                                if (checkCache(curr, cache)) {
                                    changedAttrs.push(attr);
                                }

                                _updateAutoCache[attr] = curr;
                            });
                        }
                    });

                    updateViewportAttrsFromTarget(changedAttrs);

                    return changedAttrs[LEXICON.l] > 0;
                }

                /**
                 * Checks is a CSS Property of a child element is affecting the scroll size of the content.
                 * @param propertyName The CSS property name.
                 * @returns {boolean} True if the property is affecting the content scroll size, false otherwise.
                 */
                function isSizeAffectingCSSProperty(propertyName) {
                    if (!_initialized)
                        return true;
                    var flexGrow = 'flex-grow';
                    var flexShrink = 'flex-shrink';
                    var flexBasis = 'flex-basis';
                    var affectingPropsX = [
                        _strWidth,
                        _strMinMinus + _strWidth,
                        _strMaxMinus + _strWidth,
                        _strMarginMinus + _strLeft,
                        _strMarginMinus + _strRight,
                        _strLeft,
                        _strRight,
                        'font-weight',
                        'word-spacing',
                        flexGrow,
                        flexShrink,
                        flexBasis
                    ];
                    var affectingPropsXContentBox = [
                        _strPaddingMinus + _strLeft,
                        _strPaddingMinus + _strRight,
                        _strBorderMinus + _strLeft + _strWidth,
                        _strBorderMinus + _strRight + _strWidth
                    ];
                    var affectingPropsY = [
                        _strHeight,
                        _strMinMinus + _strHeight,
                        _strMaxMinus + _strHeight,
                        _strMarginMinus + _strTop,
                        _strMarginMinus + _strBottom,
                        _strTop,
                        _strBottom,
                        'line-height',
                        flexGrow,
                        flexShrink,
                        flexBasis
                    ];
                    var affectingPropsYContentBox = [
                        _strPaddingMinus + _strTop,
                        _strPaddingMinus + _strBottom,
                        _strBorderMinus + _strTop + _strWidth,
                        _strBorderMinus + _strBottom + _strWidth
                    ];
                    var _strS = 's';
                    var _strVS = 'v-s';
                    var checkX = _overflowBehaviorCache.x === _strS || _overflowBehaviorCache.x === _strVS;
                    var checkY = _overflowBehaviorCache.y === _strS || _overflowBehaviorCache.y === _strVS;
                    var sizeIsAffected = false;
                    var checkPropertyName = function (arr, name) {
                        for (var i = 0; i < arr[LEXICON.l]; i++) {
                            if (arr[i] === name)
                                return true;
                        }
                        return false;
                    };

                    if (checkY) {
                        sizeIsAffected = checkPropertyName(affectingPropsY, propertyName);
                        if (!sizeIsAffected && !_isBorderBox)
                            sizeIsAffected = checkPropertyName(affectingPropsYContentBox, propertyName);
                    }
                    if (checkX && !sizeIsAffected) {
                        sizeIsAffected = checkPropertyName(affectingPropsX, propertyName);
                        if (!sizeIsAffected && !_isBorderBox)
                            sizeIsAffected = checkPropertyName(affectingPropsXContentBox, propertyName);
                    }
                    return sizeIsAffected;
                }


                //==== Update ====//

                /**
                 * Sets the attribute values of the viewport element to the values from the target element.
                 * The value of a attribute is only set if the attribute is whitelisted.
                 * @attrs attrs The array of attributes which shall be set or undefined if all whitelisted shall be set.
                 */
                function updateViewportAttrsFromTarget(attrs) {
                    attrs = attrs || _viewportAttrsFromTarget;
                    each(attrs, function (index, attr) {
                        if (COMPATIBILITY.inA(attr, _viewportAttrsFromTarget) > -1) {
                            var targetAttr = _targetElement.attr(attr);
                            if (type(targetAttr) == TYPES.s) {
                                _viewportElement.attr(attr, targetAttr);
                            }
                            else {
                                _viewportElement.removeAttr(attr);
                            }
                        }
                    });
                }

                /**
                 * Updates the variables and size of the textarea element, and manages the scroll on new line or new character.
                 */
                function textareaUpdate() {
                    if (!_sleeping) {
                        var wrapAttrOff = !_textareaAutoWrappingCache;
                        var minWidth = _viewportSize.w;
                        var minHeight = _viewportSize.h;
                        var css = {};
                        var doMeasure = _widthAutoCache || wrapAttrOff;
                        var origWidth;
                        var width;
                        var origHeight;
                        var height;

                        //reset min size
                        css[_strMinMinus + _strWidth] = _strEmpty;
                        css[_strMinMinus + _strHeight] = _strEmpty;

                        //set width auto
                        css[_strWidth] = _strAuto;
                        _targetElement.css(css);

                        //measure width
                        origWidth = _targetElementNative[LEXICON.oW];
                        width = doMeasure ? MATH.max(origWidth, _targetElementNative[LEXICON.sW] - 1) : 1;
                        /*width += (_widthAutoCache ? _marginX + (!_isBorderBox ? wrapAttrOff ? 0 : _paddingX + _borderX : 0) : 0);*/

                        //set measured width
                        css[_strWidth] = _widthAutoCache ? _strAuto /*width*/ : _strHundredPercent;
                        css[_strMinMinus + _strWidth] = _strHundredPercent;

                        //set height auto
                        css[_strHeight] = _strAuto;
                        _targetElement.css(css);

                        //measure height
                        origHeight = _targetElementNative[LEXICON.oH];
                        height = MATH.max(origHeight, _targetElementNative[LEXICON.sH] - 1);

                        //append correct size values
                        css[_strWidth] = width;
                        css[_strHeight] = height;
                        _textareaCoverElement.css(css);

                        //apply min width / min height to prevent textarea collapsing
                        css[_strMinMinus + _strWidth] = minWidth /*+ (!_isBorderBox && _widthAutoCache ? _paddingX + _borderX : 0)*/;
                        css[_strMinMinus + _strHeight] = minHeight /*+ (!_isBorderBox && _heightAutoCache ? _paddingY + _borderY : 0)*/;
                        _targetElement.css(css);

                        return {
                            _originalWidth: origWidth,
                            _originalHeight: origHeight,
                            _dynamicWidth: width,
                            _dynamicHeight: height
                        };
                    }
                }

                /**
                 * Updates the plugin and DOM to the current options.
                 * This method should only be called if a update is 100% required.
                 * @param updateHints A objects which contains hints for this update:
                 * {
                 *   _hostSizeChanged : boolean,
                 *   _contentSizeChanged : boolean,
                 *   _force : boolean,                             == preventSwallowing
                 *   _changedOptions : { },                        == preventSwallowing && preventSleep
                *  }
                 */
                function update(updateHints) {
                    clearTimeout(_swallowedUpdateTimeout);
                    updateHints = updateHints || {};
                    _swallowedUpdateHints._hostSizeChanged |= updateHints._hostSizeChanged;
                    _swallowedUpdateHints._contentSizeChanged |= updateHints._contentSizeChanged;
                    _swallowedUpdateHints._force |= updateHints._force;

                    var now = COMPATIBILITY.now();
                    var hostSizeChanged = !!_swallowedUpdateHints._hostSizeChanged;
                    var contentSizeChanged = !!_swallowedUpdateHints._contentSizeChanged;
                    var force = !!_swallowedUpdateHints._force;
                    var changedOptions = updateHints._changedOptions;
                    var swallow = _swallowUpdateLag > 0 && _initialized && !_destroyed && !force && !changedOptions && (now - _lastUpdateTime) < _swallowUpdateLag && (!_heightAutoCache && !_widthAutoCache);
                    var displayIsHidden;

                    if (swallow)
                        _swallowedUpdateTimeout = setTimeout(update, _swallowUpdateLag);

                    //abort update due to:
                    //destroyed
                    //swallowing
                    //sleeping
                    //host is hidden or has false display
                    if (_destroyed || swallow || (_sleeping && !changedOptions) || (_initialized && !force && (displayIsHidden = _hostElement.is(':hidden'))) || _hostElement.css('display') === 'inline')
                        return;

                    _lastUpdateTime = now;
                    _swallowedUpdateHints = {};

                    //if scrollbar styling is possible and native scrollbars aren't overlaid the scrollbar styling will be applied which hides the native scrollbars completely.
                    if (_nativeScrollbarStyling && !(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)) {
                        //native scrollbars are hidden, so change the values to zero
                        _nativeScrollbarSize.x = 0;
                        _nativeScrollbarSize.y = 0;
                    }
                    else {
                        //refresh native scrollbar size (in case of zoom)
                        _nativeScrollbarSize = extendDeep({}, globals.nativeScrollbarSize);
                    }

                    // Scrollbar padding is needed for firefox, because firefox hides scrollbar automatically if the size of the div is too small.
                    // The calculation: [scrollbar size +3 *3]
                    // (+3 because of possible decoration e.g. borders, margins etc., but only if native scrollbar is NOT a overlaid scrollbar)
                    // (*3 because (1)increase / (2)decrease -button and (3)resize handle)
                    _nativeScrollbarMinSize = {
                        x: (_nativeScrollbarSize.x + (_nativeScrollbarIsOverlaid.x ? 0 : 3)) * 3,
                        y: (_nativeScrollbarSize.y + (_nativeScrollbarIsOverlaid.y ? 0 : 3)) * 3
                    };

                    changedOptions = changedOptions || {};
                    //freezeResizeObserver(_sizeObserverElement, true);
                    //freezeResizeObserver(_sizeAutoObserverElement, true);

                    var checkCacheAutoForce = function () {
                        return checkCache.apply(this, [].slice.call(arguments).concat([force]));
                    };

                    //save current scroll offset
                    var currScroll = {
                        x: _viewportElement[_strScrollLeft](),
                        y: _viewportElement[_strScrollTop]()
                    };

                    var currentPreparedOptionsScrollbars = _currentPreparedOptions.scrollbars;
                    var currentPreparedOptionsTextarea = _currentPreparedOptions.textarea;

                    //scrollbars visibility:
                    var scrollbarsVisibility = currentPreparedOptionsScrollbars.visibility;
                    var scrollbarsVisibilityChanged = checkCacheAutoForce(scrollbarsVisibility, _scrollbarsVisibilityCache);

                    //scrollbars autoHide:
                    var scrollbarsAutoHide = currentPreparedOptionsScrollbars.autoHide;
                    var scrollbarsAutoHideChanged = checkCacheAutoForce(scrollbarsAutoHide, _scrollbarsAutoHideCache);

                    //scrollbars click scrolling
                    var scrollbarsClickScrolling = currentPreparedOptionsScrollbars.clickScrolling;
                    var scrollbarsClickScrollingChanged = checkCacheAutoForce(scrollbarsClickScrolling, _scrollbarsClickScrollingCache);

                    //scrollbars drag scrolling
                    var scrollbarsDragScrolling = currentPreparedOptionsScrollbars.dragScrolling;
                    var scrollbarsDragScrollingChanged = checkCacheAutoForce(scrollbarsDragScrolling, _scrollbarsDragScrollingCache);

                    //className
                    var className = _currentPreparedOptions.className;
                    var classNameChanged = checkCacheAutoForce(className, _classNameCache);

                    //resize
                    var resize = _currentPreparedOptions.resize;
                    var resizeChanged = checkCacheAutoForce(resize, _resizeCache) && !_isBody; //body can't be resized since the window itself acts as resize possibility.

                    //paddingAbsolute
                    var paddingAbsolute = _currentPreparedOptions.paddingAbsolute;
                    var paddingAbsoluteChanged = checkCacheAutoForce(paddingAbsolute, _paddingAbsoluteCache);

                    //clipAlways
                    var clipAlways = _currentPreparedOptions.clipAlways;
                    var clipAlwaysChanged = checkCacheAutoForce(clipAlways, _clipAlwaysCache);

                    //sizeAutoCapable
                    var sizeAutoCapable = _currentPreparedOptions.sizeAutoCapable && !_isBody; //body can never be size auto, because it shall be always as big as the viewport.
                    var sizeAutoCapableChanged = checkCacheAutoForce(sizeAutoCapable, _sizeAutoCapableCache);

                    //showNativeScrollbars
                    var ignoreOverlayScrollbarHiding = _currentPreparedOptions.nativeScrollbarsOverlaid.showNativeScrollbars;
                    var ignoreOverlayScrollbarHidingChanged = checkCacheAutoForce(ignoreOverlayScrollbarHiding, _ignoreOverlayScrollbarHidingCache);

                    //autoUpdate
                    var autoUpdate = _currentPreparedOptions.autoUpdate;
                    var autoUpdateChanged = checkCacheAutoForce(autoUpdate, _autoUpdateCache);

                    //overflowBehavior
                    var overflowBehavior = _currentPreparedOptions.overflowBehavior;
                    var overflowBehaviorChanged = checkCacheAutoForce(overflowBehavior, _overflowBehaviorCache, force);

                    //dynWidth:
                    var textareaDynWidth = currentPreparedOptionsTextarea.dynWidth;
                    var textareaDynWidthChanged = checkCacheAutoForce(_textareaDynWidthCache, textareaDynWidth);

                    //dynHeight:
                    var textareaDynHeight = currentPreparedOptionsTextarea.dynHeight;
                    var textareaDynHeightChanged = checkCacheAutoForce(_textareaDynHeightCache, textareaDynHeight);

                    //scrollbars visibility
                    _scrollbarsAutoHideNever = scrollbarsAutoHide === 'n';
                    _scrollbarsAutoHideScroll = scrollbarsAutoHide === 's';
                    _scrollbarsAutoHideMove = scrollbarsAutoHide === 'm';
                    _scrollbarsAutoHideLeave = scrollbarsAutoHide === 'l';

                    //scrollbars autoHideDelay
                    _scrollbarsAutoHideDelay = currentPreparedOptionsScrollbars.autoHideDelay;

                    //old className
                    _oldClassName = _classNameCache;

                    //resize
                    _resizeNone = resize === 'n';
                    _resizeBoth = resize === 'b';
                    _resizeHorizontal = resize === 'h';
                    _resizeVertical = resize === 'v';

                    //normalizeRTL
                    _normalizeRTLCache = _currentPreparedOptions.normalizeRTL;

                    //ignore overlay scrollbar hiding
                    ignoreOverlayScrollbarHiding = ignoreOverlayScrollbarHiding && (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y);

                    //refresh options cache
                    _scrollbarsVisibilityCache = scrollbarsVisibility;
                    _scrollbarsAutoHideCache = scrollbarsAutoHide;
                    _scrollbarsClickScrollingCache = scrollbarsClickScrolling;
                    _scrollbarsDragScrollingCache = scrollbarsDragScrolling;
                    _classNameCache = className;
                    _resizeCache = resize;
                    _paddingAbsoluteCache = paddingAbsolute;
                    _clipAlwaysCache = clipAlways;
                    _sizeAutoCapableCache = sizeAutoCapable;
                    _ignoreOverlayScrollbarHidingCache = ignoreOverlayScrollbarHiding;
                    _autoUpdateCache = autoUpdate;
                    _overflowBehaviorCache = extendDeep({}, overflowBehavior);
                    _textareaDynWidthCache = textareaDynWidth;
                    _textareaDynHeightCache = textareaDynHeight;
                    _hasOverflowCache = _hasOverflowCache || { x: false, y: false };

                    //set correct class name to the host element
                    if (classNameChanged) {
                        removeClass(_hostElement, _oldClassName + _strSpace + _classNameThemeNone);
                        addClass(_hostElement, className !== undefined && className !== null && className.length > 0 ? className : _classNameThemeNone);
                    }

                    //set correct auto Update
                    if (autoUpdateChanged) {
                        if (autoUpdate === true || (autoUpdate === null && _autoUpdateRecommended)) {
                            disconnectMutationObservers();
                            autoUpdateLoop.add(_base);
                        }
                        else {
                            autoUpdateLoop.remove(_base);
                            connectMutationObservers();
                        }
                    }

                    //activate or deactivate size auto capability
                    if (sizeAutoCapableChanged) {
                        if (sizeAutoCapable) {
                            if (_contentGlueElement) {
                                _contentGlueElement.show();
                            }
                            else {
                                _contentGlueElement = FRAMEWORK(generateDiv(_classNameContentGlueElement));
                                _paddingElement.before(_contentGlueElement);
                            }
                            if (_sizeAutoObserverAdded) {
                                _sizeAutoObserverElement.show();
                            }
                            else {
                                _sizeAutoObserverElement = FRAMEWORK(generateDiv(_classNameSizeAutoObserverElement));
                                _sizeAutoObserverElementNative = _sizeAutoObserverElement[0];

                                _contentGlueElement.before(_sizeAutoObserverElement);
                                var oldSize = { w: -1, h: -1 };
                                setupResizeObserver(_sizeAutoObserverElement, function () {
                                    var newSize = {
                                        w: _sizeAutoObserverElementNative[LEXICON.oW],
                                        h: _sizeAutoObserverElementNative[LEXICON.oH]
                                    };
                                    if (checkCache(newSize, oldSize)) {
                                        if (_initialized && (_heightAutoCache && newSize.h > 0) || (_widthAutoCache && newSize.w > 0)) {
                                            update();
                                        }
                                        else if (_initialized && (!_heightAutoCache && newSize.h === 0) || (!_widthAutoCache && newSize.w === 0)) {
                                            update();
                                        }
                                    }
                                    oldSize = newSize;
                                });
                                _sizeAutoObserverAdded = true;
                                //fix heightAuto detector bug if height is fixed but contentHeight is 0.
                                //the probability this bug will ever happen is very very low, thats why its ok if we use calc which isn't supported in IE8.
                                if (_cssCalc !== null)
                                    _sizeAutoObserverElement.css(_strHeight, _cssCalc + '(100% + 1px)');
                            }
                        }
                        else {
                            if (_sizeAutoObserverAdded)
                                _sizeAutoObserverElement.hide();
                            if (_contentGlueElement)
                                _contentGlueElement.hide();
                        }
                    }

                    //if force, update all resizeObservers too
                    if (force) {
                        _sizeObserverElement.find('*').trigger(_strScroll);
                        if (_sizeAutoObserverAdded)
                            _sizeAutoObserverElement.find('*').trigger(_strScroll);
                    }

                    //display hidden:
                    displayIsHidden = displayIsHidden === undefined ? _hostElement.is(':hidden') : displayIsHidden;

                    //textarea AutoWrapping:
                    var textareaAutoWrapping = _isTextarea ? _targetElement.attr('wrap') !== 'off' : false;
                    var textareaAutoWrappingChanged = checkCacheAutoForce(textareaAutoWrapping, _textareaAutoWrappingCache);

                    //detect direction:
                    var cssDirection = _hostElement.css('direction');
                    var cssDirectionChanged = checkCacheAutoForce(cssDirection, _cssDirectionCache);

                    //detect box-sizing:
                    var boxSizing = _hostElement.css('box-sizing');
                    var boxSizingChanged = checkCacheAutoForce(boxSizing, _cssBoxSizingCache);

                    //detect padding:
                    var padding = getTopRightBottomLeftHost(_strPaddingMinus);

                    //width + height auto detecting var:
                    var sizeAutoObserverElementBCRect;
                    //exception occurs in IE8 sometimes (unknown exception)
                    try {
                        sizeAutoObserverElementBCRect = _sizeAutoObserverAdded ? _sizeAutoObserverElementNative[LEXICON.bCR]() : null;
                    } catch (ex) {
                        return;
                    }

                    _isRTL = cssDirection === 'rtl';
                    _isBorderBox = (boxSizing === 'border-box');
                    var isRTLLeft = _isRTL ? _strLeft : _strRight;
                    var isRTLRight = _isRTL ? _strRight : _strLeft;

                    //detect width auto:
                    var widthAutoResizeDetection = false;
                    var widthAutoObserverDetection = (_sizeAutoObserverAdded && (_hostElement.css(_strFloat) !== 'none' /*|| _isTextarea */)) ? (MATH.round(sizeAutoObserverElementBCRect.right - sizeAutoObserverElementBCRect.left) === 0) && (!paddingAbsolute ? (_hostElementNative[LEXICON.cW] - _paddingX) > 0 : true) : false;
                    if (sizeAutoCapable && !widthAutoObserverDetection) {
                        var tmpCurrHostWidth = _hostElementNative[LEXICON.oW];
                        var tmpCurrContentGlueWidth = _contentGlueElement.css(_strWidth);
                        _contentGlueElement.css(_strWidth, _strAuto);

                        var tmpNewHostWidth = _hostElementNative[LEXICON.oW];
                        _contentGlueElement.css(_strWidth, tmpCurrContentGlueWidth);
                        widthAutoResizeDetection = tmpCurrHostWidth !== tmpNewHostWidth;
                        if (!widthAutoResizeDetection) {
                            _contentGlueElement.css(_strWidth, tmpCurrHostWidth + 1);
                            tmpNewHostWidth = _hostElementNative[LEXICON.oW];
                            _contentGlueElement.css(_strWidth, tmpCurrContentGlueWidth);
                            widthAutoResizeDetection = tmpCurrHostWidth !== tmpNewHostWidth;
                        }
                    }
                    var widthAuto = (widthAutoObserverDetection || widthAutoResizeDetection) && sizeAutoCapable && !displayIsHidden;
                    var widthAutoChanged = checkCacheAutoForce(widthAuto, _widthAutoCache);
                    var wasWidthAuto = !widthAuto && _widthAutoCache;

                    //detect height auto:
                    var heightAuto = _sizeAutoObserverAdded && sizeAutoCapable && !displayIsHidden ? (MATH.round(sizeAutoObserverElementBCRect.bottom - sizeAutoObserverElementBCRect.top) === 0) /* && (!paddingAbsolute && (_msieVersion > 9 || !_msieVersion) ? true : true) */ : false;
                    var heightAutoChanged = checkCacheAutoForce(heightAuto, _heightAutoCache);
                    var wasHeightAuto = !heightAuto && _heightAutoCache;

                    //detect border:
                    //we need the border only if border box and auto size
                    var updateBorderX = (widthAuto && _isBorderBox) || !_isBorderBox;
                    var updateBorderY = (heightAuto && _isBorderBox) || !_isBorderBox;
                    var border = getTopRightBottomLeftHost(_strBorderMinus, '-' + _strWidth, !updateBorderX, !updateBorderY)

                    //detect margin:
                    var margin = getTopRightBottomLeftHost(_strMarginMinus);

                    //vars to apply correct css
                    var contentElementCSS = {};
                    var contentGlueElementCSS = {};

                    //funcs
                    var getHostSize = function () {
                        //has to be clientSize because offsetSize respect borders
                        return {
                            w: _hostElementNative[LEXICON.cW],
                            h: _hostElementNative[LEXICON.cH]
                        };
                    };
                    var getViewportSize = function () {
                        //viewport size is padding container because it never has padding, margin and a border
                        //determine zoom rounding error -> sometimes scrollWidth/Height is smaller than clientWidth/Height
                        //if this happens add the difference to the viewportSize to compensate the rounding error
                        return {
                            w: _paddingElementNative[LEXICON.oW] + MATH.max(0, _contentElementNative[LEXICON.cW] - _contentElementNative[LEXICON.sW]),
                            h: _paddingElementNative[LEXICON.oH] + MATH.max(0, _contentElementNative[LEXICON.cH] - _contentElementNative[LEXICON.sH])
                        };
                    };

                    //set info for padding
                    var paddingAbsoluteX = _paddingX = padding.l + padding.r;
                    var paddingAbsoluteY = _paddingY = padding.t + padding.b;
                    paddingAbsoluteX *= paddingAbsolute ? 1 : 0;
                    paddingAbsoluteY *= paddingAbsolute ? 1 : 0;
                    padding.c = checkCacheAutoForce(padding, _cssPaddingCache);

                    //set info for border
                    _borderX = border.l + border.r;
                    _borderY = border.t + border.b;
                    border.c = checkCacheAutoForce(border, _cssBorderCache);

                    //set info for margin
                    _marginX = margin.l + margin.r;
                    _marginY = margin.t + margin.b;
                    margin.c = checkCacheAutoForce(margin, _cssMarginCache);

                    //refresh cache
                    _textareaAutoWrappingCache = textareaAutoWrapping;
                    _cssDirectionCache = cssDirection;
                    _cssBoxSizingCache = boxSizing;
                    _widthAutoCache = widthAuto;
                    _heightAutoCache = heightAuto;
                    _cssPaddingCache = padding;
                    _cssBorderCache = border;
                    _cssMarginCache = margin;

                    //IEFix direction changed
                    if (cssDirectionChanged && _sizeAutoObserverAdded)
                        _sizeAutoObserverElement.css(_strFloat, isRTLRight);

                    //apply padding:
                    if (padding.c || cssDirectionChanged || paddingAbsoluteChanged || widthAutoChanged || heightAutoChanged || boxSizingChanged || sizeAutoCapableChanged) {
                        var paddingElementCSS = {};
                        var textareaCSS = {};
                        var paddingValues = [padding.t, padding.r, padding.b, padding.l];

                        setTopRightBottomLeft(contentGlueElementCSS, _strMarginMinus, [-padding.t, -padding.r, -padding.b, -padding.l]);
                        if (paddingAbsolute) {
                            setTopRightBottomLeft(paddingElementCSS, _strEmpty, paddingValues);
                            setTopRightBottomLeft(_isTextarea ? textareaCSS : contentElementCSS, _strPaddingMinus);
                        }
                        else {
                            setTopRightBottomLeft(paddingElementCSS, _strEmpty);
                            setTopRightBottomLeft(_isTextarea ? textareaCSS : contentElementCSS, _strPaddingMinus, paddingValues);
                        }

                        _paddingElement.css(paddingElementCSS);
                        _targetElement.css(textareaCSS);
                    }

                    //viewport size is padding container because it never has padding, margin and a border.
                    _viewportSize = getViewportSize();

                    //update Textarea
                    var textareaSize = _isTextarea ? textareaUpdate() : false;
                    var textareaSizeChanged = _isTextarea && checkCacheAutoForce(textareaSize, _textareaSizeCache);
                    var textareaDynOrigSize = _isTextarea && textareaSize ? {
                        w: textareaDynWidth ? textareaSize._dynamicWidth : textareaSize._originalWidth,
                        h: textareaDynHeight ? textareaSize._dynamicHeight : textareaSize._originalHeight
                    } : {};
                    _textareaSizeCache = textareaSize;

                    //fix height auto / width auto in cooperation with current padding & boxSizing behavior:
                    if (heightAuto && (heightAutoChanged || paddingAbsoluteChanged || boxSizingChanged || padding.c || border.c)) {
                        contentElementCSS[_strHeight] = _strAuto;
                    }
                    else if (heightAutoChanged || paddingAbsoluteChanged) {
                        contentElementCSS[_strHeight] = _strHundredPercent;
                    }
                    if (widthAuto && (widthAutoChanged || paddingAbsoluteChanged || boxSizingChanged || padding.c || border.c || cssDirectionChanged)) {
                        contentElementCSS[_strWidth] = _strAuto;
                        contentGlueElementCSS[_strMaxMinus + _strWidth] = _strHundredPercent; //IE Fix
                    }
                    else if (widthAutoChanged || paddingAbsoluteChanged) {
                        contentElementCSS[_strWidth] = _strHundredPercent;
                        contentElementCSS[_strFloat] = _strEmpty;
                        contentGlueElementCSS[_strMaxMinus + _strWidth] = _strEmpty; //IE Fix
                    }
                    if (widthAuto) {
                        //textareaDynOrigSize.w || _strAuto :: doesnt works because applied margin will shift width
                        contentGlueElementCSS[_strWidth] = _strAuto;

                        contentElementCSS[_strWidth] = VENDORS._cssPropertyValue(_strWidth, 'max-content intrinsic') || _strAuto;
                        contentElementCSS[_strFloat] = isRTLRight;
                    }
                    else {
                        contentGlueElementCSS[_strWidth] = _strEmpty;
                    }
                    if (heightAuto) {
                        //textareaDynOrigSize.h || _contentElementNative[LEXICON.cH] :: use for anti scroll jumping
                        contentGlueElementCSS[_strHeight] = textareaDynOrigSize.h || _contentElementNative[LEXICON.cH];
                    }
                    else {
                        contentGlueElementCSS[_strHeight] = _strEmpty;
                    }
                    if (sizeAutoCapable)
                        _contentGlueElement.css(contentGlueElementCSS);
                    _contentElement.css(contentElementCSS);

                    //CHECKPOINT HERE ~
                    contentElementCSS = {};
                    contentGlueElementCSS = {};

                    //if [content(host) client / scroll size, or target element direction, or content(host) max-sizes] changed, or force is true
                    if (hostSizeChanged || contentSizeChanged || textareaSizeChanged || cssDirectionChanged || boxSizingChanged || paddingAbsoluteChanged || widthAutoChanged || widthAuto || heightAutoChanged || heightAuto || ignoreOverlayScrollbarHidingChanged || overflowBehaviorChanged || clipAlwaysChanged || resizeChanged || scrollbarsVisibilityChanged || scrollbarsAutoHideChanged || scrollbarsDragScrollingChanged || scrollbarsClickScrollingChanged || textareaDynWidthChanged || textareaDynHeightChanged || textareaAutoWrappingChanged) {
                        var strOverflow = 'overflow';
                        var strOverflowX = strOverflow + '-x';
                        var strOverflowY = strOverflow + '-y';
                        var strHidden = 'hidden';
                        var strVisible = 'visible';

                        //Reset the viewport (very important for natively overlaid scrollbars and zoom change
                        //don't change the overflow prop as it is very expensive and affects performance !A LOT!
                        if (!_nativeScrollbarStyling) {
                            var viewportElementResetCSS = {};
                            var resetXTmp = _hasOverflowCache.y && _hideOverflowCache.ys && !ignoreOverlayScrollbarHiding ? (_nativeScrollbarIsOverlaid.y ? _viewportElement.css(isRTLLeft) : -_nativeScrollbarSize.y) : 0;
                            var resetBottomTmp = _hasOverflowCache.x && _hideOverflowCache.xs && !ignoreOverlayScrollbarHiding ? (_nativeScrollbarIsOverlaid.x ? _viewportElement.css(_strBottom) : -_nativeScrollbarSize.x) : 0;
                            setTopRightBottomLeft(viewportElementResetCSS, _strEmpty);
                            _viewportElement.css(viewportElementResetCSS);
                        }

                        //measure several sizes:
                        var contentMeasureElement = getContentMeasureElement();
                        //in Firefox content element has to have overflow hidden, else element margins aren't calculated properly, this element prevents this bug, but only if scrollbars aren't overlaid
                        var contentSize = {
                            //use clientSize because natively overlaidScrollbars add borders
                            w: textareaDynOrigSize.w || contentMeasureElement[LEXICON.cW],
                            h: textareaDynOrigSize.h || contentMeasureElement[LEXICON.cH]
                        };
                        var scrollSize = {
                            w: contentMeasureElement[LEXICON.sW],
                            h: contentMeasureElement[LEXICON.sH]
                        };

                        //apply the correct viewport style and measure viewport size
                        if (!_nativeScrollbarStyling) {
                            viewportElementResetCSS[_strBottom] = wasHeightAuto ? _strEmpty : resetBottomTmp;
                            viewportElementResetCSS[isRTLLeft] = wasWidthAuto ? _strEmpty : resetXTmp;
                            _viewportElement.css(viewportElementResetCSS);
                        }
                        _viewportSize = getViewportSize();

                        //measure and correct several sizes
                        var hostSize = getHostSize();
                        var hostAbsoluteRectSize = {
                            w: hostSize.w - _marginX - _borderX - (_isBorderBox ? 0 : _paddingX),
                            h: hostSize.h - _marginY - _borderY - (_isBorderBox ? 0 : _paddingY)
                        };
                        var contentGlueSize = {
                            //client/scrollSize + AbsolutePadding -> because padding is only applied to the paddingElement if its absolute, so you have to add it manually
                            //hostSize is clientSize -> so padding should be added manually, right? FALSE! Because content glue is inside hostElement, so we don't have to worry about padding
                            w: MATH.max((widthAuto ? contentSize.w : scrollSize.w) + paddingAbsoluteX, hostAbsoluteRectSize.w),
                            h: MATH.max((heightAuto ? contentSize.h : scrollSize.h) + paddingAbsoluteY, hostAbsoluteRectSize.h)
                        };
                        contentGlueSize.c = checkCacheAutoForce(contentGlueSize, _contentGlueSizeCache);
                        _contentGlueSizeCache = contentGlueSize;

                        //apply correct contentGlue size
                        if (sizeAutoCapable) {
                            //size contentGlue correctly to make sure the element has correct size if the sizing switches to auto
                            if (contentGlueSize.c || (heightAuto || widthAuto)) {
                                contentGlueElementCSS[_strWidth] = contentGlueSize.w;
                                contentGlueElementCSS[_strHeight] = contentGlueSize.h;

                                //textarea-sizes are already calculated correctly at this point
                                if (!_isTextarea) {
                                    contentSize = {
                                        //use clientSize because natively overlaidScrollbars add borders
                                        w: contentMeasureElement[LEXICON.cW],
                                        h: contentMeasureElement[LEXICON.cH]
                                    };
                                }
                            }
                            var textareaCoverCSS = {};
                            var setContentGlueElementCSSfunction = function (horizontal) {
                                var scrollbarVars = getScrollbarVars(horizontal);
                                var wh = scrollbarVars._w_h;
                                var strWH = scrollbarVars._width_height;
                                var autoSize = horizontal ? widthAuto : heightAuto;
                                var borderSize = horizontal ? _borderX : _borderY;
                                var paddingSize = horizontal ? _paddingX : _paddingY;
                                var marginSize = horizontal ? _marginX : _marginY;
                                var viewportSize = _viewportSize[wh] - borderSize - marginSize - (_isBorderBox ? 0 : paddingSize);

                                //make contentGlue size -1 if element is not auto sized, to make sure that a resize event happens when the element shrinks
                                if (!autoSize || (!autoSize && border.c))
                                    contentGlueElementCSS[strWH] = hostAbsoluteRectSize[wh] - 1;

                                //if size is auto and host is smaller than size as min size, make content glue size -1 to make sure size changes will be detected (this is only needed if padding is 0)
                                if (autoSize && (contentSize[wh] < viewportSize) && (horizontal && _isTextarea ? !textareaAutoWrapping : true)) {
                                    if (_isTextarea)
                                        textareaCoverCSS[strWH] = parseToZeroOrNumber(_textareaCoverElement.css(strWH)) - 1;
                                    contentGlueElementCSS[strWH] -= 1;
                                }

                                //make sure content glue size is at least 1
                                if (contentSize[wh] > 0)
                                    contentGlueElementCSS[strWH] = MATH.max(1, contentGlueElementCSS[strWH]);
                            };
                            setContentGlueElementCSSfunction(true);
                            setContentGlueElementCSSfunction(false);

                            if (_isTextarea)
                                _textareaCoverElement.css(textareaCoverCSS);
                            _contentGlueElement.css(contentGlueElementCSS);
                        }
                        if (widthAuto)
                            contentElementCSS[_strWidth] = _strHundredPercent;
                        if (widthAuto && !_isBorderBox && !_mutationObserversConnected)
                            contentElementCSS[_strFloat] = 'none';

                        //apply and reset content style
                        _contentElement.css(contentElementCSS);
                        contentElementCSS = {};

                        //measure again, but this time all correct sizes:
                        var contentScrollSize = {
                            w: contentMeasureElement[LEXICON.sW],
                            h: contentMeasureElement[LEXICON.sH],
                        };
                        contentScrollSize.c = contentSizeChanged = checkCacheAutoForce(contentScrollSize, _contentScrollSizeCache);
                        _contentScrollSizeCache = contentScrollSize;

                        //refresh viewport size after correct measuring
                        _viewportSize = getViewportSize();

                        hostSize = getHostSize();
                        hostSizeChanged = checkCacheAutoForce(hostSize, _hostSizeCache);
                        _hostSizeCache = hostSize;

                        var hideOverflowForceTextarea = _isTextarea && (_viewportSize.w === 0 || _viewportSize.h === 0);
                        var previousOverflowAmount = _overflowAmountCache;
                        var overflowBehaviorIsVS = {};
                        var overflowBehaviorIsVH = {};
                        var overflowBehaviorIsS = {};
                        var overflowAmount = {};
                        var hasOverflow = {};
                        var hideOverflow = {};
                        var canScroll = {};
                        var viewportRect = _paddingElementNative[LEXICON.bCR]();
                        var setOverflowVariables = function (horizontal) {
                            var scrollbarVars = getScrollbarVars(horizontal);
                            var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                            var xyI = scrollbarVarsInverted._x_y;
                            var xy = scrollbarVars._x_y;
                            var wh = scrollbarVars._w_h;
                            var widthHeight = scrollbarVars._width_height;
                            var scrollMax = _strScroll + scrollbarVars._Left_Top + 'Max';
                            var fractionalOverflowAmount = viewportRect[widthHeight] ? MATH.abs(viewportRect[widthHeight] - _viewportSize[wh]) : 0;
                            var checkFractionalOverflowAmount = previousOverflowAmount && previousOverflowAmount[xy] > 0 && _viewportElementNative[scrollMax] === 0;
                            overflowBehaviorIsVS[xy] = overflowBehavior[xy] === 'v-s';
                            overflowBehaviorIsVH[xy] = overflowBehavior[xy] === 'v-h';
                            overflowBehaviorIsS[xy] = overflowBehavior[xy] === 's';
                            overflowAmount[xy] = MATH.max(0, MATH.round((contentScrollSize[wh] - _viewportSize[wh]) * 100) / 100);
                            overflowAmount[xy] *= (hideOverflowForceTextarea || (checkFractionalOverflowAmount && fractionalOverflowAmount > 0 && fractionalOverflowAmount < 1)) ? 0 : 1;
                            hasOverflow[xy] = overflowAmount[xy] > 0;

                            //hideOverflow:
                            //x || y : true === overflow is hidden by "overflow: scroll" OR "overflow: hidden"
                            //xs || ys : true === overflow is hidden by "overflow: scroll"
                            hideOverflow[xy] = overflowBehaviorIsVS[xy] || overflowBehaviorIsVH[xy] ? (hasOverflow[xyI] && !overflowBehaviorIsVS[xyI] && !overflowBehaviorIsVH[xyI]) : hasOverflow[xy];
                            hideOverflow[xy + 's'] = hideOverflow[xy] ? (overflowBehaviorIsS[xy] || overflowBehaviorIsVS[xy]) : false;

                            canScroll[xy] = hasOverflow[xy] && hideOverflow[xy + 's'];
                        };
                        setOverflowVariables(true);
                        setOverflowVariables(false);

                        overflowAmount.c = checkCacheAutoForce(overflowAmount, _overflowAmountCache);
                        _overflowAmountCache = overflowAmount;
                        hasOverflow.c = checkCacheAutoForce(hasOverflow, _hasOverflowCache);
                        _hasOverflowCache = hasOverflow;
                        hideOverflow.c = checkCacheAutoForce(hideOverflow, _hideOverflowCache);
                        _hideOverflowCache = hideOverflow;

                        //if native scrollbar is overlay at x OR y axis, prepare DOM
                        if (_nativeScrollbarIsOverlaid.x || _nativeScrollbarIsOverlaid.y) {
                            var borderDesign = 'px solid transparent';
                            var contentArrangeElementCSS = {};
                            var arrangeContent = {};
                            var arrangeChanged = force;
                            var setContentElementCSS;

                            if (hasOverflow.x || hasOverflow.y) {
                                arrangeContent.w = _nativeScrollbarIsOverlaid.y && hasOverflow.y ? contentScrollSize.w + _overlayScrollbarDummySize.y : _strEmpty;
                                arrangeContent.h = _nativeScrollbarIsOverlaid.x && hasOverflow.x ? contentScrollSize.h + _overlayScrollbarDummySize.x : _strEmpty;
                                arrangeChanged = checkCacheAutoForce(arrangeContent, _arrangeContentSizeCache);
                                _arrangeContentSizeCache = arrangeContent;
                            }

                            if (hasOverflow.c || hideOverflow.c || contentScrollSize.c || cssDirectionChanged || widthAutoChanged || heightAutoChanged || widthAuto || heightAuto || ignoreOverlayScrollbarHidingChanged) {
                                contentElementCSS[_strMarginMinus + isRTLRight] = contentElementCSS[_strBorderMinus + isRTLRight] = _strEmpty;
                                setContentElementCSS = function (horizontal) {
                                    var scrollbarVars = getScrollbarVars(horizontal);
                                    var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                                    var xy = scrollbarVars._x_y;
                                    var strDirection = horizontal ? _strBottom : isRTLLeft;
                                    var invertedAutoSize = horizontal ? heightAuto : widthAuto;

                                    if (_nativeScrollbarIsOverlaid[xy] && hasOverflow[xy] && hideOverflow[xy + 's']) {
                                        contentElementCSS[_strMarginMinus + strDirection] = invertedAutoSize ? (ignoreOverlayScrollbarHiding ? _strEmpty : _overlayScrollbarDummySize[xy]) : _strEmpty;
                                        contentElementCSS[_strBorderMinus + strDirection] = ((horizontal ? !invertedAutoSize : true) && !ignoreOverlayScrollbarHiding) ? (_overlayScrollbarDummySize[xy] + borderDesign) : _strEmpty;
                                    }
                                    else {
                                        arrangeContent[scrollbarVarsInverted._w_h] =
                                            contentElementCSS[_strMarginMinus + strDirection] =
                                            contentElementCSS[_strBorderMinus + strDirection] = _strEmpty;
                                        arrangeChanged = true;
                                    }
                                };

                                if (_nativeScrollbarStyling) {
                                    addRemoveClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible, !ignoreOverlayScrollbarHiding)
                                }
                                else {
                                    setContentElementCSS(true);
                                    setContentElementCSS(false);
                                }
                            }
                            if (ignoreOverlayScrollbarHiding) {
                                arrangeContent.w = arrangeContent.h = _strEmpty;
                                arrangeChanged = true;
                            }
                            if (arrangeChanged && !_nativeScrollbarStyling) {
                                contentArrangeElementCSS[_strWidth] = hideOverflow.y ? arrangeContent.w : _strEmpty;
                                contentArrangeElementCSS[_strHeight] = hideOverflow.x ? arrangeContent.h : _strEmpty;

                                if (!_contentArrangeElement) {
                                    _contentArrangeElement = FRAMEWORK(generateDiv(_classNameContentArrangeElement));
                                    _viewportElement.prepend(_contentArrangeElement);
                                }
                                _contentArrangeElement.css(contentArrangeElementCSS);
                            }
                            _contentElement.css(contentElementCSS);
                        }

                        var viewportElementCSS = {};
                        var paddingElementCSS = {};
                        var setViewportCSS;
                        if (hostSizeChanged || hasOverflow.c || hideOverflow.c || contentScrollSize.c || overflowBehaviorChanged || boxSizingChanged || ignoreOverlayScrollbarHidingChanged || cssDirectionChanged || clipAlwaysChanged || heightAutoChanged) {
                            viewportElementCSS[isRTLRight] = _strEmpty;
                            setViewportCSS = function (horizontal) {
                                var scrollbarVars = getScrollbarVars(horizontal);
                                var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                                var xy = scrollbarVars._x_y;
                                var XY = scrollbarVars._X_Y;
                                var strDirection = horizontal ? _strBottom : isRTLLeft;

                                var reset = function () {
                                    viewportElementCSS[strDirection] = _strEmpty;
                                    _contentBorderSize[scrollbarVarsInverted._w_h] = 0;
                                };
                                if (hasOverflow[xy] && hideOverflow[xy + 's']) {
                                    viewportElementCSS[strOverflow + XY] = _strScroll;
                                    if (ignoreOverlayScrollbarHiding || _nativeScrollbarStyling) {
                                        reset();
                                    }
                                    else {
                                        viewportElementCSS[strDirection] = -(_nativeScrollbarIsOverlaid[xy] ? _overlayScrollbarDummySize[xy] : _nativeScrollbarSize[xy]);
                                        _contentBorderSize[scrollbarVarsInverted._w_h] = _nativeScrollbarIsOverlaid[xy] ? _overlayScrollbarDummySize[scrollbarVarsInverted._x_y] : 0;
                                    }
                                } else {
                                    viewportElementCSS[strOverflow + XY] = _strEmpty;
                                    reset();
                                }
                            };
                            setViewportCSS(true);
                            setViewportCSS(false);

                            // if the scroll container is too small and if there is any overflow with no overlay scrollbar (and scrollbar styling isn't possible), 
                            // make viewport element greater in size (Firefox hide Scrollbars fix)
                            // because firefox starts hiding scrollbars on too small elements
                            // with this behavior the overflow calculation may be incorrect or the scrollbars would appear suddenly
                            // https://bugzilla.mozilla.org/show_bug.cgi?id=292284
                            if (!_nativeScrollbarStyling
                                && (_viewportSize.h < _nativeScrollbarMinSize.x || _viewportSize.w < _nativeScrollbarMinSize.y)
                                && ((hasOverflow.x && hideOverflow.x && !_nativeScrollbarIsOverlaid.x) || (hasOverflow.y && hideOverflow.y && !_nativeScrollbarIsOverlaid.y))) {
                                viewportElementCSS[_strPaddingMinus + _strTop] = _nativeScrollbarMinSize.x;
                                viewportElementCSS[_strMarginMinus + _strTop] = -_nativeScrollbarMinSize.x;

                                viewportElementCSS[_strPaddingMinus + isRTLRight] = _nativeScrollbarMinSize.y;
                                viewportElementCSS[_strMarginMinus + isRTLRight] = -_nativeScrollbarMinSize.y;
                            }
                            else {
                                viewportElementCSS[_strPaddingMinus + _strTop] =
                                    viewportElementCSS[_strMarginMinus + _strTop] =
                                    viewportElementCSS[_strPaddingMinus + isRTLRight] =
                                    viewportElementCSS[_strMarginMinus + isRTLRight] = _strEmpty;
                            }
                            viewportElementCSS[_strPaddingMinus + isRTLLeft] =
                                viewportElementCSS[_strMarginMinus + isRTLLeft] = _strEmpty;

                            //if there is any overflow (x OR y axis) and this overflow shall be hidden, make overflow hidden, else overflow visible
                            if ((hasOverflow.x && hideOverflow.x) || (hasOverflow.y && hideOverflow.y) || hideOverflowForceTextarea) {
                                //only hide if is Textarea
                                if (_isTextarea && hideOverflowForceTextarea) {
                                    paddingElementCSS[strOverflowX] =
                                        paddingElementCSS[strOverflowY] = strHidden;
                                }
                            }
                            else {
                                if (!clipAlways || (overflowBehaviorIsVH.x || overflowBehaviorIsVS.x || overflowBehaviorIsVH.y || overflowBehaviorIsVS.y)) {
                                    //only un-hide if Textarea
                                    if (_isTextarea) {
                                        paddingElementCSS[strOverflowX] =
                                            paddingElementCSS[strOverflowY] = _strEmpty;
                                    }
                                    viewportElementCSS[strOverflowX] =
                                        viewportElementCSS[strOverflowY] = strVisible;
                                }
                            }

                            _paddingElement.css(paddingElementCSS);
                            _viewportElement.css(viewportElementCSS);
                            viewportElementCSS = {};

                            //force soft redraw in webkit because without the scrollbars will may appear because DOM wont be redrawn under special conditions
                            if ((hasOverflow.c || boxSizingChanged || widthAutoChanged || heightAutoChanged) && !(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)) {
                                var elementStyle = _contentElementNative[LEXICON.s];
                                var dump;
                                elementStyle.webkitTransform = 'scale(1)';
                                elementStyle.display = 'run-in';
                                dump = _contentElementNative[LEXICON.oH];
                                elementStyle.display = _strEmpty; //|| dump; //use dump to prevent it from deletion if minify
                                elementStyle.webkitTransform = _strEmpty;
                            }
                            /*
                            //force hard redraw in webkit if native overlaid scrollbars shall appear
                            if (ignoreOverlayScrollbarHidingChanged && ignoreOverlayScrollbarHiding) {
                                _hostElement.hide();
                                var dump = _hostElementNative[LEXICON.oH];
                                _hostElement.show();
                            }
                            */
                        }

                        //change to direction RTL and width auto Bugfix in Webkit
                        //without this fix, the DOM still thinks the scrollbar is LTR and thus the content is shifted to the left
                        contentElementCSS = {};
                        if (cssDirectionChanged || widthAutoChanged || heightAutoChanged) {
                            if (_isRTL && widthAuto) {
                                var floatTmp = _contentElement.css(_strFloat);
                                var posLeftWithoutFloat = MATH.round(_contentElement.css(_strFloat, _strEmpty).css(_strLeft, _strEmpty).position().left);
                                _contentElement.css(_strFloat, floatTmp);
                                var posLeftWithFloat = MATH.round(_contentElement.position().left);

                                if (posLeftWithoutFloat !== posLeftWithFloat)
                                    contentElementCSS[_strLeft] = posLeftWithoutFloat;
                            }
                            else {
                                contentElementCSS[_strLeft] = _strEmpty;
                            }
                        }
                        _contentElement.css(contentElementCSS);

                        //handle scroll position
                        if (_isTextarea && contentSizeChanged) {
                            var textareaInfo = getTextareaInfo();
                            if (textareaInfo) {
                                var textareaRowsChanged = _textareaInfoCache === undefined ? true : textareaInfo._rows !== _textareaInfoCache._rows;
                                var cursorRow = textareaInfo._cursorRow;
                                var cursorCol = textareaInfo._cursorColumn;
                                var widestRow = textareaInfo._widestRow;
                                var lastRow = textareaInfo._rows;
                                var lastCol = textareaInfo._columns;
                                var cursorPos = textareaInfo._cursorPosition;
                                var cursorMax = textareaInfo._cursorMax;
                                var cursorIsLastPosition = (cursorPos >= cursorMax && _textareaHasFocus);
                                var textareaScrollAmount = {
                                    x: (!textareaAutoWrapping && (cursorCol === lastCol && cursorRow === widestRow)) ? _overflowAmountCache.x : -1,
                                    y: (textareaAutoWrapping ? cursorIsLastPosition || textareaRowsChanged && (previousOverflowAmount ? (currScroll.y === previousOverflowAmount.y) : false) : (cursorIsLastPosition || textareaRowsChanged) && cursorRow === lastRow) ? _overflowAmountCache.y : -1
                                };
                                currScroll.x = textareaScrollAmount.x > -1 ? (_isRTL && _normalizeRTLCache && _rtlScrollBehavior.i ? 0 : textareaScrollAmount.x) : currScroll.x; //if inverted, scroll to 0 -> normalized this means to max scroll offset.
                                currScroll.y = textareaScrollAmount.y > -1 ? textareaScrollAmount.y : currScroll.y;
                            }
                            _textareaInfoCache = textareaInfo;
                        }
                        if (_isRTL && _rtlScrollBehavior.i && _nativeScrollbarIsOverlaid.y && hasOverflow.x && _normalizeRTLCache)
                            currScroll.x += _contentBorderSize.w || 0;
                        if (widthAuto)
                            _hostElement[_strScrollLeft](0);
                        if (heightAuto)
                            _hostElement[_strScrollTop](0);
                        _viewportElement[_strScrollLeft](currScroll.x)[_strScrollTop](currScroll.y);

                        //scrollbars management:
                        var scrollbarsVisibilityVisible = scrollbarsVisibility === 'v';
                        var scrollbarsVisibilityHidden = scrollbarsVisibility === 'h';
                        var scrollbarsVisibilityAuto = scrollbarsVisibility === 'a';
                        var refreshScrollbarsVisibility = function (showX, showY) {
                            showY = showY === undefined ? showX : showY;
                            refreshScrollbarAppearance(true, showX, canScroll.x)
                            refreshScrollbarAppearance(false, showY, canScroll.y)
                        };

                        //manage class name which indicates scrollable overflow
                        addRemoveClass(_hostElement, _classNameHostOverflow, hideOverflow.x || hideOverflow.y);
                        addRemoveClass(_hostElement, _classNameHostOverflowX, hideOverflow.x);
                        addRemoveClass(_hostElement, _classNameHostOverflowY, hideOverflow.y);

                        //add or remove rtl class name for styling purposes except when its body, then the scrollbar stays
                        if (cssDirectionChanged && !_isBody) {
                            addRemoveClass(_hostElement, _classNameHostRTL, _isRTL);
                        }

                        //manage the resize feature (CSS3 resize "polyfill" for this plugin)
                        if (_isBody)
                            addClass(_hostElement, _classNameHostResizeDisabled);
                        if (resizeChanged) {
                            addRemoveClass(_hostElement, _classNameHostResizeDisabled, _resizeNone);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResize, !_resizeNone);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeB, _resizeBoth);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeH, _resizeHorizontal);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeV, _resizeVertical);
                        }

                        //manage the scrollbars general visibility + the scrollbar interactivity (unusable class name)
                        if (scrollbarsVisibilityChanged || overflowBehaviorChanged || hideOverflow.c || hasOverflow.c || ignoreOverlayScrollbarHidingChanged) {
                            if (ignoreOverlayScrollbarHiding) {
                                if (ignoreOverlayScrollbarHidingChanged) {
                                    removeClass(_hostElement, _classNameHostScrolling);
                                    if (ignoreOverlayScrollbarHiding) {
                                        refreshScrollbarsVisibility(false);
                                    }
                                }
                            }
                            else if (scrollbarsVisibilityAuto) {
                                refreshScrollbarsVisibility(canScroll.x, canScroll.y);
                            }
                            else if (scrollbarsVisibilityVisible) {
                                refreshScrollbarsVisibility(true);
                            }
                            else if (scrollbarsVisibilityHidden) {
                                refreshScrollbarsVisibility(false);
                            }
                        }

                        //manage the scrollbars auto hide feature (auto hide them after specific actions)
                        if (scrollbarsAutoHideChanged || ignoreOverlayScrollbarHidingChanged) {
                            setupHostMouseTouchEvents(!_scrollbarsAutoHideLeave && !_scrollbarsAutoHideMove);
                            refreshScrollbarsAutoHide(_scrollbarsAutoHideNever, !_scrollbarsAutoHideNever);
                        }

                        //manage scrollbars handle length & offset - don't remove!
                        if (hostSizeChanged || overflowAmount.c || heightAutoChanged || widthAutoChanged || resizeChanged || boxSizingChanged || paddingAbsoluteChanged || ignoreOverlayScrollbarHidingChanged || cssDirectionChanged) {
                            refreshScrollbarHandleLength(true);
                            refreshScrollbarHandleOffset(true);
                            refreshScrollbarHandleLength(false);
                            refreshScrollbarHandleOffset(false);
                        }

                        //manage interactivity
                        if (scrollbarsClickScrollingChanged)
                            refreshScrollbarsInteractive(true, scrollbarsClickScrolling);
                        if (scrollbarsDragScrollingChanged)
                            refreshScrollbarsInteractive(false, scrollbarsDragScrolling);

                        //callbacks:
                        dispatchCallback('onDirectionChanged', {
                            isRTL: _isRTL,
                            dir: cssDirection
                        }, cssDirectionChanged);
                        dispatchCallback('onHostSizeChanged', {
                            width: _hostSizeCache.w,
                            height: _hostSizeCache.h
                        }, hostSizeChanged);
                        dispatchCallback('onContentSizeChanged', {
                            width: _contentScrollSizeCache.w,
                            height: _contentScrollSizeCache.h
                        }, contentSizeChanged);
                        dispatchCallback('onOverflowChanged', {
                            x: hasOverflow.x,
                            y: hasOverflow.y,
                            xScrollable: hideOverflow.xs,
                            yScrollable: hideOverflow.ys,
                            clipped: hideOverflow.x || hideOverflow.y
                        }, hasOverflow.c || hideOverflow.c);
                        dispatchCallback('onOverflowAmountChanged', {
                            x: overflowAmount.x,
                            y: overflowAmount.y
                        }, overflowAmount.c);
                    }

                    //fix body min size
                    if (_isBody && _bodyMinSizeCache && (_hasOverflowCache.c || _bodyMinSizeCache.c)) {
                        //its possible that no min size was measured until now, because the content arrange element was just added now, in this case, measure now the min size.
                        if (!_bodyMinSizeCache.f)
                            bodyMinSizeChanged();
                        if (_nativeScrollbarIsOverlaid.y && _hasOverflowCache.x)
                            _contentElement.css(_strMinMinus + _strWidth, _bodyMinSizeCache.w + _overlayScrollbarDummySize.y);
                        if (_nativeScrollbarIsOverlaid.x && _hasOverflowCache.y)
                            _contentElement.css(_strMinMinus + _strHeight, _bodyMinSizeCache.h + _overlayScrollbarDummySize.x);
                        _bodyMinSizeCache.c = false;
                    }

                    if (_initialized && changedOptions.updateOnLoad) {
                        updateElementsOnLoad();
                    }

                    //freezeResizeObserver(_sizeObserverElement, false);
                    //freezeResizeObserver(_sizeAutoObserverElement, false);

                    dispatchCallback('onUpdated', { forced: force });
                }

                /**
                 * Updates the found elements of which the load event shall be handled.
                 */
                function updateElementsOnLoad() {
                    if (!_isTextarea) {
                        eachUpdateOnLoad(function (i, updateOnLoadSelector) {
                            _contentElement.find(updateOnLoadSelector).each(function (i, el) {
                                // if element doesn't have a updateOnLoadCallback applied
                                if (COMPATIBILITY.inA(el, _updateOnLoadElms) < 0) {
                                    _updateOnLoadElms.push(el);
                                    FRAMEWORK(el)
                                        .off(_updateOnLoadEventName, updateOnLoadCallback)
                                        .on(_updateOnLoadEventName, updateOnLoadCallback);
                                }
                            });
                        });
                    }
                }

                //==== Options ====//

                /**
                 * Sets new options but doesn't call the update method.
                 * @param newOptions The object which contains the new options.
                 * @returns {*} A object which contains the changed options.
                 */
                function setOptions(newOptions) {
                    var validatedOpts = _pluginsOptions._validate(newOptions, _pluginsOptions._template, true, _currentOptions)

                    _currentOptions = extendDeep({}, _currentOptions, validatedOpts._default);
                    _currentPreparedOptions = extendDeep({}, _currentPreparedOptions, validatedOpts._prepared);

                    return validatedOpts._prepared;
                }


                //==== Structure ====//

                /**
                 * Builds or destroys the wrapper and helper DOM elements.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                /**
                 * Builds or destroys the wrapper and helper DOM elements.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupStructureDOM(destroy) {
                    var strParent = 'parent';
                    var classNameResizeObserverHost = 'os-resize-observer-host';
                    var classNameTextareaElementFull = _classNameTextareaElement + _strSpace + _classNameTextInherit;
                    var textareaClass = _isTextarea ? _strSpace + _classNameTextInherit : _strEmpty;
                    var adoptAttrs = _currentPreparedOptions.textarea.inheritedAttrs;
                    var adoptAttrsMap = {};
                    var applyAdoptedAttrs = function () {
                        var applyAdoptedAttrsElm = destroy ? _targetElement : _hostElement;
                        each(adoptAttrsMap, function (key, value) {
                            if (type(value) == TYPES.s) {
                                if (key == LEXICON.c)
                                    applyAdoptedAttrsElm.addClass(value);
                                else
                                    applyAdoptedAttrsElm.attr(key, value);
                            }
                        });
                    };
                    var hostElementClassNames = [
                        _classNameHostElement,
                        _classNameHostElementForeign,
                        _classNameHostTextareaElement,
                        _classNameHostResizeDisabled,
                        _classNameHostRTL,
                        _classNameHostScrollbarHorizontalHidden,
                        _classNameHostScrollbarVerticalHidden,
                        _classNameHostTransition,
                        _classNameHostScrolling,
                        _classNameHostOverflow,
                        _classNameHostOverflowX,
                        _classNameHostOverflowY,
                        _classNameThemeNone,
                        _classNameTextareaElement,
                        _classNameTextInherit,
                        _classNameCache].join(_strSpace);
                    var hostElementCSS = {};

                    //get host element as first element, because that's the most upper element and required for the other elements
                    _hostElement = _hostElement || (_isTextarea ? (_domExists ? _targetElement[strParent]()[strParent]()[strParent]()[strParent]() : FRAMEWORK(generateDiv(_classNameHostTextareaElement))) : _targetElement);
                    _contentElement = _contentElement || selectOrGenerateDivByClass(_classNameContentElement + textareaClass);
                    _viewportElement = _viewportElement || selectOrGenerateDivByClass(_classNameViewportElement + textareaClass);
                    _paddingElement = _paddingElement || selectOrGenerateDivByClass(_classNamePaddingElement + textareaClass);
                    _sizeObserverElement = _sizeObserverElement || selectOrGenerateDivByClass(classNameResizeObserverHost);
                    _textareaCoverElement = _textareaCoverElement || (_isTextarea ? selectOrGenerateDivByClass(_classNameTextareaCoverElement) : undefined);

                    //add this class to workaround class changing issues with UI frameworks especially Vue
                    if (_domExists)
                        addClass(_hostElement, _classNameHostElementForeign);

                    //on destroy, remove all generated class names from the host element before collecting the adopted attributes 
                    //to prevent adopting generated class names
                    if (destroy)
                        removeClass(_hostElement, hostElementClassNames);

                    //collect all adopted attributes
                    adoptAttrs = type(adoptAttrs) == TYPES.s ? adoptAttrs.split(_strSpace) : adoptAttrs;
                    if (COMPATIBILITY.isA(adoptAttrs) && _isTextarea) {
                        each(adoptAttrs, function (i, v) {
                            if (type(v) == TYPES.s) {
                                adoptAttrsMap[v] = destroy ? _hostElement.attr(v) : _targetElement.attr(v);
                            }
                        });
                    }

                    if (!destroy) {
                        if (_isTextarea) {
                            if (!_currentPreparedOptions.sizeAutoCapable) {
                                hostElementCSS[_strWidth] = _targetElement.css(_strWidth);
                                hostElementCSS[_strHeight] = _targetElement.css(_strHeight);
                            }

                            if (!_domExists)
                                _targetElement.addClass(_classNameTextInherit).wrap(_hostElement);

                            //jQuery clones elements in wrap functions, so we have to select them again
                            _hostElement = _targetElement[strParent]().css(hostElementCSS);
                        }

                        if (!_domExists) {
                            //add the correct class to the target element
                            addClass(_targetElement, _isTextarea ? classNameTextareaElementFull : _classNameHostElement);

                            //wrap the content into the generated elements to create the required DOM
                            _hostElement.wrapInner(_contentElement)
                                .wrapInner(_viewportElement)
                                .wrapInner(_paddingElement)
                                .prepend(_sizeObserverElement);

                            //jQuery clones elements in wrap functions, so we have to select them again
                            _contentElement = findFirst(_hostElement, _strDot + _classNameContentElement);
                            _viewportElement = findFirst(_hostElement, _strDot + _classNameViewportElement);
                            _paddingElement = findFirst(_hostElement, _strDot + _classNamePaddingElement);

                            if (_isTextarea) {
                                _contentElement.prepend(_textareaCoverElement);
                                applyAdoptedAttrs();
                            }
                        }

                        if (_nativeScrollbarStyling)
                            addClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible);
                        if (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)
                            addClass(_viewportElement, _classNameViewportNativeScrollbarsOverlaid);
                        if (_isBody)
                            addClass(_htmlElement, _classNameHTMLElement);

                        _sizeObserverElementNative = _sizeObserverElement[0];
                        _hostElementNative = _hostElement[0];
                        _paddingElementNative = _paddingElement[0];
                        _viewportElementNative = _viewportElement[0];
                        _contentElementNative = _contentElement[0];

                        updateViewportAttrsFromTarget();
                    }
                    else {
                        if (_domExists && _initialized) {
                            //clear size observer
                            _sizeObserverElement.children().remove();

                            //remove the style property and classes from already generated elements
                            each([_paddingElement, _viewportElement, _contentElement, _textareaCoverElement], function (i, elm) {
                                if (elm) {
                                    removeClass(elm.removeAttr(LEXICON.s), _classNamesDynamicDestroy);
                                }
                            });

                            //add classes to the host element which was removed previously to match the expected DOM
                            addClass(_hostElement, _isTextarea ? _classNameHostTextareaElement : _classNameHostElement);
                        }
                        else {
                            //remove size observer
                            remove(_sizeObserverElement);

                            //unwrap the content to restore DOM
                            _contentElement.contents()
                                .unwrap()
                                .unwrap()
                                .unwrap();

                            if (_isTextarea) {
                                _targetElement.unwrap();
                                remove(_hostElement);
                                remove(_textareaCoverElement);
                                applyAdoptedAttrs();
                            }
                        }

                        if (_isTextarea)
                            _targetElement.removeAttr(LEXICON.s);

                        if (_isBody)
                            removeClass(_htmlElement, _classNameHTMLElement);
                    }
                }

                /**
                 * Adds or removes all wrapper elements interactivity events.
                 * @param destroy Indicates whether the Events shall be added or removed.
                 */
                function setupStructureEvents() {
                    var textareaKeyDownRestrictedKeyCodes = [
                        112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 123,    //F1 to F12
                        33, 34,                                                   //page up, page down
                        37, 38, 39, 40,                                           //left, up, right, down arrows
                        16, 17, 18, 19, 20, 144                                   //Shift, Ctrl, Alt, Pause, CapsLock, NumLock
                    ];
                    var textareaKeyDownKeyCodesList = [];
                    var textareaUpdateIntervalID;
                    var scrollStopTimeoutId;
                    var scrollStopDelay = 175;
                    var strFocus = 'focus';

                    function updateTextarea(doClearInterval) {
                        textareaUpdate();
                        _base.update(_strAuto);
                        if (doClearInterval && _autoUpdateRecommended)
                            clearInterval(textareaUpdateIntervalID);
                    }
                    function textareaOnScroll(event) {
                        _targetElement[_strScrollLeft](_rtlScrollBehavior.i && _normalizeRTLCache ? 9999999 : 0);
                        _targetElement[_strScrollTop](0);
                        COMPATIBILITY.prvD(event);
                        COMPATIBILITY.stpP(event);
                        return false;
                    }
                    function textareaOnDrop(event) {
                        setTimeout(function () {
                            if (!_destroyed)
                                updateTextarea();
                        }, 50);
                    }
                    function textareaOnFocus() {
                        _textareaHasFocus = true;
                        addClass(_hostElement, strFocus);
                    }
                    function textareaOnFocusout() {
                        _textareaHasFocus = false;
                        textareaKeyDownKeyCodesList = [];
                        removeClass(_hostElement, strFocus);
                        updateTextarea(true);
                    }
                    function textareaOnKeyDown(event) {
                        var keyCode = event.keyCode;

                        if (inArray(keyCode, textareaKeyDownRestrictedKeyCodes) < 0) {
                            if (!textareaKeyDownKeyCodesList[LEXICON.l]) {
                                updateTextarea();
                                textareaUpdateIntervalID = setInterval(updateTextarea, 1000 / 60);
                            }
                            if (inArray(keyCode, textareaKeyDownKeyCodesList) < 0)
                                textareaKeyDownKeyCodesList.push(keyCode);
                        }
                    }
                    function textareaOnKeyUp(event) {
                        var keyCode = event.keyCode;
                        var index = inArray(keyCode, textareaKeyDownKeyCodesList);

                        if (inArray(keyCode, textareaKeyDownRestrictedKeyCodes) < 0) {
                            if (index > -1)
                                textareaKeyDownKeyCodesList.splice(index, 1);
                            if (!textareaKeyDownKeyCodesList[LEXICON.l])
                                updateTextarea(true);
                        }
                    }
                    function contentOnTransitionEnd(event) {
                        if (_autoUpdateCache === true)
                            return;
                        event = event.originalEvent || event;
                        if (isSizeAffectingCSSProperty(event.propertyName))
                            _base.update(_strAuto);
                    }
                    function viewportOnScroll(event) {
                        if (!_sleeping) {
                            if (scrollStopTimeoutId !== undefined)
                                clearTimeout(scrollStopTimeoutId);
                            else {
                                if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                    refreshScrollbarsAutoHide(true);

                                if (!nativeOverlayScrollbarsAreActive())
                                    addClass(_hostElement, _classNameHostScrolling);

                                dispatchCallback('onScrollStart', event);
                            }

                            //if a scrollbars handle gets dragged, the mousemove event is responsible for refreshing the handle offset
                            //because if CSS scroll-snap is used, the handle offset gets only refreshed on every snap point
                            //this looks laggy & clunky, it looks much better if the offset refreshes with the mousemove
                            if (!_scrollbarsHandlesDefineScrollPos) {
                                refreshScrollbarHandleOffset(true);
                                refreshScrollbarHandleOffset(false);
                            }
                            dispatchCallback('onScroll', event);

                            scrollStopTimeoutId = setTimeout(function () {
                                if (!_destroyed) {
                                    //OnScrollStop:
                                    clearTimeout(scrollStopTimeoutId);
                                    scrollStopTimeoutId = undefined;

                                    if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                        refreshScrollbarsAutoHide(false);

                                    if (!nativeOverlayScrollbarsAreActive())
                                        removeClass(_hostElement, _classNameHostScrolling);

                                    dispatchCallback('onScrollStop', event);
                                }
                            }, scrollStopDelay);
                        }
                    }


                    if (_isTextarea) {
                        if (_msieVersion > 9 || !_autoUpdateRecommended) {
                            addDestroyEventListener(_targetElement, 'input', updateTextarea);
                        }
                        else {
                            addDestroyEventListener(_targetElement,
                                [_strKeyDownEvent, _strKeyUpEvent],
                                [textareaOnKeyDown, textareaOnKeyUp]);
                        }

                        addDestroyEventListener(_targetElement,
                            [_strScroll, 'drop', strFocus, strFocus + 'out'],
                            [textareaOnScroll, textareaOnDrop, textareaOnFocus, textareaOnFocusout]);
                    }
                    else {
                        addDestroyEventListener(_contentElement, _strTransitionEndEvent, contentOnTransitionEnd);
                    }
                    addDestroyEventListener(_viewportElement, _strScroll, viewportOnScroll, true);
                }


                //==== Scrollbars ====//

                /**
                 * Builds or destroys all scrollbar DOM elements (scrollbar, track, handle)
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupScrollbarsDOM(destroy) {
                    var selectOrGenerateScrollbarDOM = function (isHorizontal) {
                        var scrollbarClassName = isHorizontal ? _classNameScrollbarHorizontal : _classNameScrollbarVertical;
                        var scrollbar = selectOrGenerateDivByClass(_classNameScrollbar + _strSpace + scrollbarClassName, true);
                        var track = selectOrGenerateDivByClass(_classNameScrollbarTrack, scrollbar);
                        var handle = selectOrGenerateDivByClass(_classNameScrollbarHandle, scrollbar);

                        if (!_domExists && !destroy) {
                            scrollbar.append(track);
                            track.append(handle);
                        }

                        return {
                            _scrollbar: scrollbar,
                            _track: track,
                            _handle: handle
                        };
                    };
                    function resetScrollbarDOM(isHorizontal) {
                        var scrollbarVars = getScrollbarVars(isHorizontal);
                        var scrollbar = scrollbarVars._scrollbar;
                        var track = scrollbarVars._track;
                        var handle = scrollbarVars._handle;

                        if (_domExists && _initialized) {
                            each([scrollbar, track, handle], function (i, elm) {
                                removeClass(elm.removeAttr(LEXICON.s), _classNamesDynamicDestroy);
                            });
                        }
                        else {
                            remove(scrollbar || selectOrGenerateScrollbarDOM(isHorizontal)._scrollbar);
                        }
                    }
                    var horizontalElements;
                    var verticalElements;

                    if (!destroy) {
                        horizontalElements = selectOrGenerateScrollbarDOM(true);
                        verticalElements = selectOrGenerateScrollbarDOM();

                        _scrollbarHorizontalElement = horizontalElements._scrollbar;
                        _scrollbarHorizontalTrackElement = horizontalElements._track;
                        _scrollbarHorizontalHandleElement = horizontalElements._handle;
                        _scrollbarVerticalElement = verticalElements._scrollbar;
                        _scrollbarVerticalTrackElement = verticalElements._track;
                        _scrollbarVerticalHandleElement = verticalElements._handle;

                        if (!_domExists) {
                            _paddingElement.after(_scrollbarVerticalElement);
                            _paddingElement.after(_scrollbarHorizontalElement);
                        }
                    }
                    else {
                        resetScrollbarDOM(true);
                        resetScrollbarDOM();
                    }
                }

                /**
                 * Initializes all scrollbar interactivity events. (track and handle dragging, clicking, scrolling)
                 * @param isHorizontal True if the target scrollbar is the horizontal scrollbar, false if the target scrollbar is the vertical scrollbar.
                 */
                function setupScrollbarEvents(isHorizontal) {
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var insideIFrame = _windowElementNative.top !== _windowElementNative;
                    var xy = scrollbarVars._x_y;
                    var XY = scrollbarVars._X_Y;
                    var scroll = _strScroll + scrollbarVars._Left_Top;
                    var strActive = 'active';
                    var strSnapHandle = 'snapHandle';
                    var strClickEvent = 'click';
                    var scrollDurationFactor = 1;
                    var increaseDecreaseScrollAmountKeyCodes = [16, 17]; //shift, ctrl
                    var trackTimeout;
                    var mouseDownScroll;
                    var mouseDownOffset;
                    var mouseDownInvertedScale;

                    function getPointerPosition(event) {
                        return _msieVersion && insideIFrame ? event['screen' + XY] : COMPATIBILITY.page(event)[xy]; //use screen coordinates in EDGE & IE because the page values are incorrect in frames.
                    }
                    function getPreparedScrollbarsOption(name) {
                        return _currentPreparedOptions.scrollbars[name];
                    }
                    function increaseTrackScrollAmount() {
                        scrollDurationFactor = 0.5;
                    }
                    function decreaseTrackScrollAmount() {
                        scrollDurationFactor = 1;
                    }
                    function stopClickEventPropagation(event) {
                        COMPATIBILITY.stpP(event);
                    }
                    function documentKeyDown(event) {
                        if (inArray(event.keyCode, increaseDecreaseScrollAmountKeyCodes) > -1)
                            increaseTrackScrollAmount();
                    }
                    function documentKeyUp(event) {
                        if (inArray(event.keyCode, increaseDecreaseScrollAmountKeyCodes) > -1)
                            decreaseTrackScrollAmount();
                    }
                    function onMouseTouchDownContinue(event) {
                        var originalEvent = event.originalEvent || event;
                        var isTouchEvent = originalEvent.touches !== undefined;
                        return _sleeping || _destroyed || nativeOverlayScrollbarsAreActive() || !_scrollbarsDragScrollingCache || (isTouchEvent && !getPreparedScrollbarsOption('touchSupport')) ? false : COMPATIBILITY.mBtn(event) === 1 || isTouchEvent;
                    }
                    function documentDragMove(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var trackLength = scrollbarVarsInfo._trackLength;
                            var handleLength = scrollbarVarsInfo._handleLength;
                            var scrollRange = scrollbarVarsInfo._maxScroll;
                            var scrollRaw = (getPointerPosition(event) - mouseDownOffset) * mouseDownInvertedScale;
                            var scrollDeltaPercent = scrollRaw / (trackLength - handleLength);
                            var scrollDelta = (scrollRange * scrollDeltaPercent);
                            scrollDelta = isFinite(scrollDelta) ? scrollDelta : 0;
                            if (_isRTL && isHorizontal && !_rtlScrollBehavior.i)
                                scrollDelta *= -1;

                            _viewportElement[scroll](MATH.round(mouseDownScroll + scrollDelta));

                            if (_scrollbarsHandlesDefineScrollPos)
                                refreshScrollbarHandleOffset(isHorizontal, mouseDownScroll + scrollDelta);

                            if (!_supportPassiveEvents)
                                COMPATIBILITY.prvD(event);
                        }
                        else
                            documentMouseTouchUp(event);
                    }
                    function documentMouseTouchUp(event) {
                        event = event || event.originalEvent;

                        setupResponsiveEventListener(_documentElement,
                            [_strMouseTouchMoveEvent, _strMouseTouchUpEvent, _strKeyDownEvent, _strKeyUpEvent, _strSelectStartEvent],
                            [documentDragMove, documentMouseTouchUp, documentKeyDown, documentKeyUp, documentOnSelectStart],
                            true);
                        COMPATIBILITY.rAF()(function() {
                            setupResponsiveEventListener(_documentElement, strClickEvent, stopClickEventPropagation, true, { _capture: true });
                        });
                        
                            
                        if (_scrollbarsHandlesDefineScrollPos)
                            refreshScrollbarHandleOffset(isHorizontal, true);

                        _scrollbarsHandlesDefineScrollPos = false;
                        removeClass(_bodyElement, _classNameDragging);
                        removeClass(scrollbarVars._handle, strActive);
                        removeClass(scrollbarVars._track, strActive);
                        removeClass(scrollbarVars._scrollbar, strActive);

                        mouseDownScroll = undefined;
                        mouseDownOffset = undefined;
                        mouseDownInvertedScale = 1;

                        decreaseTrackScrollAmount();

                        if (trackTimeout !== undefined) {
                            _base.scrollStop();
                            clearTimeout(trackTimeout);
                            trackTimeout = undefined;
                        }

                        if (event) {
                            var rect = _hostElementNative[LEXICON.bCR]();
                            var mouseInsideHost = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;

                            //if mouse is outside host element
                            if (!mouseInsideHost)
                                hostOnMouseLeave();

                            if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                refreshScrollbarsAutoHide(false);
                        }
                    }
                    function onHandleMouseTouchDown(event) {
                        if (onMouseTouchDownContinue(event))
                            onHandleMouseTouchDownAction(event);
                    }
                    function onHandleMouseTouchDownAction(event) {
                        mouseDownScroll = _viewportElement[scroll]();
                        mouseDownScroll = isNaN(mouseDownScroll) ? 0 : mouseDownScroll;
                        if (_isRTL && isHorizontal && !_rtlScrollBehavior.n || !_isRTL)
                            mouseDownScroll = mouseDownScroll < 0 ? 0 : mouseDownScroll;

                        mouseDownInvertedScale = getHostElementInvertedScale()[xy];
                        mouseDownOffset = getPointerPosition(event);

                        _scrollbarsHandlesDefineScrollPos = !getPreparedScrollbarsOption(strSnapHandle);
                        addClass(_bodyElement, _classNameDragging);
                        addClass(scrollbarVars._handle, strActive);
                        addClass(scrollbarVars._scrollbar, strActive);

                        setupResponsiveEventListener(_documentElement,
                            [_strMouseTouchMoveEvent, _strMouseTouchUpEvent, _strSelectStartEvent],
                            [documentDragMove, documentMouseTouchUp, documentOnSelectStart]);
                        COMPATIBILITY.rAF()(function() {
                            setupResponsiveEventListener(_documentElement, strClickEvent, stopClickEventPropagation, false, { _capture: true });
                        });
                        

                        if (_msieVersion || !_documentMixed)
                            COMPATIBILITY.prvD(event);
                        COMPATIBILITY.stpP(event);
                    }
                    function onTrackMouseTouchDown(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var handleToViewportRatio = scrollbarVars._info._handleLength / Math.round(MATH.min(1, _viewportSize[scrollbarVars._w_h] / _contentScrollSizeCache[scrollbarVars._w_h]) * scrollbarVars._info._trackLength);
                            var scrollDistance = MATH.round(_viewportSize[scrollbarVars._w_h] * handleToViewportRatio);
                            var scrollBaseDuration = 270 * handleToViewportRatio;
                            var scrollFirstIterationDelay = 400 * handleToViewportRatio;
                            var trackOffset = scrollbarVars._track.offset()[scrollbarVars._left_top];
                            var ctrlKey = event.ctrlKey;
                            var instantScroll = event.shiftKey;
                            var instantScrollTransition = instantScroll && ctrlKey;
                            var isFirstIteration = true;
                            var easing = 'linear';
                            var decreaseScroll;
                            var finishedCondition;
                            var scrollActionFinsished = function (transition) {
                                if (_scrollbarsHandlesDefineScrollPos)
                                    refreshScrollbarHandleOffset(isHorizontal, transition);
                            };
                            var scrollActionInstantFinished = function () {
                                scrollActionFinsished();
                                onHandleMouseTouchDownAction(event);
                            };
                            var scrollAction = function () {
                                if (!_destroyed) {
                                    var mouseOffset = (mouseDownOffset - trackOffset) * mouseDownInvertedScale;
                                    var handleOffset = scrollbarVarsInfo._handleOffset;
                                    var trackLength = scrollbarVarsInfo._trackLength;
                                    var handleLength = scrollbarVarsInfo._handleLength;
                                    var scrollRange = scrollbarVarsInfo._maxScroll;
                                    var currScroll = scrollbarVarsInfo._currentScroll;
                                    var scrollDuration = scrollBaseDuration * scrollDurationFactor;
                                    var timeoutDelay = isFirstIteration ? MATH.max(scrollFirstIterationDelay, scrollDuration) : scrollDuration;
                                    var instantScrollPosition = scrollRange * ((mouseOffset - (handleLength / 2)) / (trackLength - handleLength)); // 100% * positionPercent
                                    var rtlIsNormal = _isRTL && isHorizontal && ((!_rtlScrollBehavior.i && !_rtlScrollBehavior.n) || _normalizeRTLCache);
                                    var decreaseScrollCondition = rtlIsNormal ? handleOffset < mouseOffset : handleOffset > mouseOffset;
                                    var scrollObj = {};
                                    var animationObj = {
                                        easing: easing,
                                        step: function (now) {
                                            if (_scrollbarsHandlesDefineScrollPos) {
                                                _viewportElement[scroll](now); //https://github.com/jquery/jquery/issues/4340
                                                refreshScrollbarHandleOffset(isHorizontal, now);
                                            }
                                        }
                                    };
                                    instantScrollPosition = isFinite(instantScrollPosition) ? instantScrollPosition : 0;
                                    instantScrollPosition = _isRTL && isHorizontal && !_rtlScrollBehavior.i ? (scrollRange - instantScrollPosition) : instantScrollPosition;

                                    //_base.scrollStop();

                                    if (instantScroll) {
                                        _viewportElement[scroll](instantScrollPosition); //scroll instantly to new position
                                        if (instantScrollTransition) {
                                            //get the scroll position after instant scroll (in case CSS Snap Points are used) to get the correct snapped scroll position
                                            //and the animation stops at the correct point
                                            instantScrollPosition = _viewportElement[scroll]();
                                            //scroll back to the position before instant scrolling so animation can be performed
                                            _viewportElement[scroll](currScroll);

                                            instantScrollPosition = rtlIsNormal && _rtlScrollBehavior.i ? (scrollRange - instantScrollPosition) : instantScrollPosition;
                                            instantScrollPosition = rtlIsNormal && _rtlScrollBehavior.n ? -instantScrollPosition : instantScrollPosition;

                                            scrollObj[xy] = instantScrollPosition;
                                            _base.scroll(scrollObj, extendDeep(animationObj, {
                                                duration: 130,
                                                complete: scrollActionInstantFinished
                                            }));
                                        }
                                        else
                                            scrollActionInstantFinished();
                                    }
                                    else {
                                        decreaseScroll = isFirstIteration ? decreaseScrollCondition : decreaseScroll;
                                        finishedCondition = rtlIsNormal
                                            ? (decreaseScroll ? handleOffset + handleLength >= mouseOffset : handleOffset <= mouseOffset)
                                            : (decreaseScroll ? handleOffset <= mouseOffset : handleOffset + handleLength >= mouseOffset);

                                        if (finishedCondition) {
                                            clearTimeout(trackTimeout);
                                            _base.scrollStop();
                                            trackTimeout = undefined;
                                            scrollActionFinsished(true);
                                        }
                                        else {
                                            trackTimeout = setTimeout(scrollAction, timeoutDelay);

                                            scrollObj[xy] = (decreaseScroll ? '-=' : '+=') + scrollDistance;
                                            _base.scroll(scrollObj, extendDeep(animationObj, {
                                                duration: scrollDuration
                                            }));
                                        }
                                        isFirstIteration = false;
                                    }
                                }
                            };
                            if (ctrlKey)
                                increaseTrackScrollAmount();

                            mouseDownInvertedScale = getHostElementInvertedScale()[xy];
                            mouseDownOffset = COMPATIBILITY.page(event)[xy];

                            _scrollbarsHandlesDefineScrollPos = !getPreparedScrollbarsOption(strSnapHandle);
                            addClass(_bodyElement, _classNameDragging);
                            addClass(scrollbarVars._track, strActive);
                            addClass(scrollbarVars._scrollbar, strActive);

                            setupResponsiveEventListener(_documentElement,
                                [_strMouseTouchUpEvent, _strKeyDownEvent, _strKeyUpEvent, _strSelectStartEvent],
                                [documentMouseTouchUp, documentKeyDown, documentKeyUp, documentOnSelectStart]);

                            scrollAction();
                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                        }
                    }
                    function onTrackMouseTouchEnter(event) {
                        //make sure both scrollbars will stay visible if one scrollbar is hovered if autoHide is "scroll" or "move".
                        _scrollbarsHandleHovered = true;
                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                            refreshScrollbarsAutoHide(true);
                    }
                    function onTrackMouseTouchLeave(event) {
                        _scrollbarsHandleHovered = false;
                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                            refreshScrollbarsAutoHide(false);
                    }
                    function onScrollbarMouseTouchDown(event) {
                        COMPATIBILITY.stpP(event);
                    }

                    addDestroyEventListener(scrollbarVars._handle,
                        _strMouseTouchDownEvent,
                        onHandleMouseTouchDown);
                    addDestroyEventListener(scrollbarVars._track,
                        [_strMouseTouchDownEvent, _strMouseEnter, _strMouseLeave],
                        [onTrackMouseTouchDown, onTrackMouseTouchEnter, onTrackMouseTouchLeave]);
                    addDestroyEventListener(scrollbarVars._scrollbar,
                        _strMouseTouchDownEvent,
                        onScrollbarMouseTouchDown);

                    if (_supportTransition) {
                        addDestroyEventListener(scrollbarVars._scrollbar, _strTransitionEndEvent, function (event) {
                            if (event.target !== scrollbarVars._scrollbar[0])
                                return;
                            refreshScrollbarHandleLength(isHorizontal);
                            refreshScrollbarHandleOffset(isHorizontal);
                        });
                    }
                }

                /**
                 * Shows or hides the given scrollbar and applied a class name which indicates if the scrollbar is scrollable or not.
                 * @param isHorizontal True if the horizontal scrollbar is the target, false if the vertical scrollbar is the target.
                 * @param shallBeVisible True if the scrollbar shall be shown, false if hidden.
                 * @param canScroll True if the scrollbar is scrollable, false otherwise.
                 */
                function refreshScrollbarAppearance(isHorizontal, shallBeVisible, canScroll) {
                    var scrollbarHiddenClassName = isHorizontal ? _classNameHostScrollbarHorizontalHidden : _classNameHostScrollbarVerticalHidden;
                    var scrollbarElement = isHorizontal ? _scrollbarHorizontalElement : _scrollbarVerticalElement;

                    addRemoveClass(_hostElement, scrollbarHiddenClassName, !shallBeVisible);
                    addRemoveClass(scrollbarElement, _classNameScrollbarUnusable, !canScroll);
                }

                /**
                 * Autoshows / autohides both scrollbars with.
                 * @param shallBeVisible True if the scrollbars shall be autoshown (only the case if they are hidden by a autohide), false if the shall be auto hidden.
                 * @param delayfree True if the scrollbars shall be hidden without a delay, false or undefined otherwise.
                 */
                function refreshScrollbarsAutoHide(shallBeVisible, delayfree) {
                    clearTimeout(_scrollbarsAutoHideTimeoutId);
                    if (shallBeVisible) {
                        //if(_hasOverflowCache.x && _hideOverflowCache.xs)
                        removeClass(_scrollbarHorizontalElement, _classNameScrollbarAutoHidden);
                        //if(_hasOverflowCache.y && _hideOverflowCache.ys)
                        removeClass(_scrollbarVerticalElement, _classNameScrollbarAutoHidden);
                    }
                    else {
                        var anyActive;
                        var strActive = 'active';
                        var hide = function () {
                            if (!_scrollbarsHandleHovered && !_destroyed) {
                                anyActive = _scrollbarHorizontalHandleElement.hasClass(strActive) || _scrollbarVerticalHandleElement.hasClass(strActive);
                                if (!anyActive && (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove || _scrollbarsAutoHideLeave))
                                    addClass(_scrollbarHorizontalElement, _classNameScrollbarAutoHidden);
                                if (!anyActive && (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove || _scrollbarsAutoHideLeave))
                                    addClass(_scrollbarVerticalElement, _classNameScrollbarAutoHidden);
                            }
                        };
                        if (_scrollbarsAutoHideDelay > 0 && delayfree !== true)
                            _scrollbarsAutoHideTimeoutId = setTimeout(hide, _scrollbarsAutoHideDelay);
                        else
                            hide();
                    }
                }

                /**
                 * Refreshes the handle length of the given scrollbar.
                 * @param isHorizontal True if the horizontal scrollbar handle shall be refreshed, false if the vertical one shall be refreshed.
                 */
                function refreshScrollbarHandleLength(isHorizontal) {
                    var handleCSS = {};
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var digit = 1000000;
                    //get and apply intended handle length
                    var handleRatio = MATH.min(1, _viewportSize[scrollbarVars._w_h] / _contentScrollSizeCache[scrollbarVars._w_h]);
                    handleCSS[scrollbarVars._width_height] = (MATH.floor(handleRatio * 100 * digit) / digit) + '%'; //the last * digit / digit is for flooring to the 4th digit

                    if (!nativeOverlayScrollbarsAreActive())
                        scrollbarVars._handle.css(handleCSS);

                    //measure the handle length to respect min & max length
                    scrollbarVarsInfo._handleLength = scrollbarVars._handle[0]['offset' + scrollbarVars._Width_Height];
                    scrollbarVarsInfo._handleLengthRatio = handleRatio;
                }

                /**
                 * Refreshes the handle offset of the given scrollbar.
                 * @param isHorizontal True if the horizontal scrollbar handle shall be refreshed, false if the vertical one shall be refreshed.
                 * @param scrollOrTransition The scroll position of the given scrollbar axis to which the handle shall be moved or a boolean which indicates whether a transition shall be applied. If undefined or boolean if the current scroll-offset is taken. (if isHorizontal ? scrollLeft : scrollTop)
                 */
                function refreshScrollbarHandleOffset(isHorizontal, scrollOrTransition) {
                    var transition = type(scrollOrTransition) == TYPES.b;
                    var transitionDuration = 250;
                    var isRTLisHorizontal = _isRTL && isHorizontal;
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var strTranslateBrace = 'translate(';
                    var strTransform = VENDORS._cssProperty('transform');
                    var strTransition = VENDORS._cssProperty('transition');
                    var nativeScroll = isHorizontal ? _viewportElement[_strScrollLeft]() : _viewportElement[_strScrollTop]();
                    var currentScroll = scrollOrTransition === undefined || transition ? nativeScroll : scrollOrTransition;

                    //measure the handle length to respect min & max length
                    var handleLength = scrollbarVarsInfo._handleLength;
                    var trackLength = scrollbarVars._track[0]['offset' + scrollbarVars._Width_Height];
                    var handleTrackDiff = trackLength - handleLength;
                    var handleCSS = {};
                    var transformOffset;
                    var translateValue;

                    //DONT use the variable '_contentScrollSizeCache[scrollbarVars._w_h]' instead of '_viewportElement[0]['scroll' + scrollbarVars._Width_Height]'
                    // because its a bit behind during the small delay when content size updates
                    //(delay = mutationObserverContentLag, if its 0 then this var could be used)
                    var maxScroll = (_viewportElementNative[_strScroll + scrollbarVars._Width_Height] - _viewportElementNative['client' + scrollbarVars._Width_Height]) * (_rtlScrollBehavior.n && isRTLisHorizontal ? -1 : 1); //* -1 if rtl scroll max is negative
                    var getScrollRatio = function (base) {
                        return isNaN(base / maxScroll) ? 0 : MATH.max(0, MATH.min(1, base / maxScroll));
                    };
                    var getHandleOffset = function (scrollRatio) {
                        var offset = handleTrackDiff * scrollRatio;
                        offset = isNaN(offset) ? 0 : offset;
                        offset = (isRTLisHorizontal && !_rtlScrollBehavior.i) ? (trackLength - handleLength - offset) : offset;
                        offset = MATH.max(0, offset);
                        return offset;
                    };
                    var scrollRatio = getScrollRatio(nativeScroll);
                    var unsnappedScrollRatio = getScrollRatio(currentScroll);
                    var handleOffset = getHandleOffset(unsnappedScrollRatio);
                    var snappedHandleOffset = getHandleOffset(scrollRatio);

                    scrollbarVarsInfo._maxScroll = maxScroll;
                    scrollbarVarsInfo._currentScroll = nativeScroll;
                    scrollbarVarsInfo._currentScrollRatio = scrollRatio;

                    if (_supportTransform) {
                        transformOffset = isRTLisHorizontal ? -(trackLength - handleLength - handleOffset) : handleOffset; //in px
                        //transformOffset = (transformOffset / trackLength * 100) * (trackLength / handleLength); //in %
                        translateValue = isHorizontal ? strTranslateBrace + transformOffset + 'px, 0)' : strTranslateBrace + '0, ' + transformOffset + 'px)';

                        handleCSS[strTransform] = translateValue;

                        //apply or clear up transition
                        if (_supportTransition)
                            handleCSS[strTransition] = transition && MATH.abs(handleOffset - scrollbarVarsInfo._handleOffset) > 1 ? getCSSTransitionString(scrollbarVars._handle) + ', ' + (strTransform + _strSpace + transitionDuration + 'ms') : _strEmpty;
                    }
                    else
                        handleCSS[scrollbarVars._left_top] = handleOffset;


                    //only apply css if offset has changed and overflow exists.
                    if (!nativeOverlayScrollbarsAreActive()) {
                        scrollbarVars._handle.css(handleCSS);

                        //clear up transition
                        if (_supportTransform && _supportTransition && transition) {
                            scrollbarVars._handle.one(_strTransitionEndEvent, function () {
                                if (!_destroyed)
                                    scrollbarVars._handle.css(strTransition, _strEmpty);
                            });
                        }
                    }

                    scrollbarVarsInfo._handleOffset = handleOffset;
                    scrollbarVarsInfo._snappedHandleOffset = snappedHandleOffset;
                    scrollbarVarsInfo._trackLength = trackLength;
                }

                /**
                 * Refreshes the interactivity of the given scrollbar element.
                 * @param isTrack True if the track element is the target, false if the handle element is the target.
                 * @param value True for interactivity false for no interactivity.
                 */
                function refreshScrollbarsInteractive(isTrack, value) {
                    var action = value ? 'removeClass' : 'addClass';
                    var element1 = isTrack ? _scrollbarHorizontalTrackElement : _scrollbarHorizontalHandleElement;
                    var element2 = isTrack ? _scrollbarVerticalTrackElement : _scrollbarVerticalHandleElement;
                    var className = isTrack ? _classNameScrollbarTrackOff : _classNameScrollbarHandleOff;

                    element1[action](className);
                    element2[action](className);
                }

                /**
                 * Returns a object which is used for fast access for specific variables.
                 * @param isHorizontal True if the horizontal scrollbar vars shall be accessed, false if the vertical scrollbar vars shall be accessed.
                 * @returns {{wh: string, WH: string, lt: string, _wh: string, _lt: string, t: *, h: *, c: {}, s: *}}
                 */
                function getScrollbarVars(isHorizontal) {
                    return {
                        _width_height: isHorizontal ? _strWidth : _strHeight,
                        _Width_Height: isHorizontal ? 'Width' : 'Height',
                        _left_top: isHorizontal ? _strLeft : _strTop,
                        _Left_Top: isHorizontal ? 'Left' : 'Top',
                        _x_y: isHorizontal ? _strX : _strY,
                        _X_Y: isHorizontal ? 'X' : 'Y',
                        _w_h: isHorizontal ? 'w' : 'h',
                        _l_t: isHorizontal ? 'l' : 't',
                        _track: isHorizontal ? _scrollbarHorizontalTrackElement : _scrollbarVerticalTrackElement,
                        _handle: isHorizontal ? _scrollbarHorizontalHandleElement : _scrollbarVerticalHandleElement,
                        _scrollbar: isHorizontal ? _scrollbarHorizontalElement : _scrollbarVerticalElement,
                        _info: isHorizontal ? _scrollHorizontalInfo : _scrollVerticalInfo
                    };
                }


                //==== Scrollbar Corner ====//

                /**
                 * Builds or destroys the scrollbar corner DOM element.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupScrollbarCornerDOM(destroy) {
                    _scrollbarCornerElement = _scrollbarCornerElement || selectOrGenerateDivByClass(_classNameScrollbarCorner, true);

                    if (!destroy) {
                        if (!_domExists) {
                            _hostElement.append(_scrollbarCornerElement);
                        }
                    }
                    else {
                        if (_domExists && _initialized) {
                            removeClass(_scrollbarCornerElement.removeAttr(LEXICON.s), _classNamesDynamicDestroy);
                        }
                        else {
                            remove(_scrollbarCornerElement);
                        }
                    }
                }

                /**
                 * Initializes all scrollbar corner interactivity events.
                 */
                function setupScrollbarCornerEvents() {
                    var insideIFrame = _windowElementNative.top !== _windowElementNative;
                    var mouseDownPosition = {};
                    var mouseDownSize = {};
                    var mouseDownInvertedScale = {};
                    var reconnectMutationObserver;

                    function documentDragMove(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var pageOffset = getCoordinates(event);
                            var hostElementCSS = {};
                            if (_resizeHorizontal || _resizeBoth)
                                hostElementCSS[_strWidth] = (mouseDownSize.w + (pageOffset.x - mouseDownPosition.x) * mouseDownInvertedScale.x);
                            if (_resizeVertical || _resizeBoth)
                                hostElementCSS[_strHeight] = (mouseDownSize.h + (pageOffset.y - mouseDownPosition.y) * mouseDownInvertedScale.y);
                            _hostElement.css(hostElementCSS);
                            COMPATIBILITY.stpP(event);
                        }
                        else {
                            documentMouseTouchUp(event);
                        }
                    }
                    function documentMouseTouchUp(event) {
                        var eventIsTrusted = event !== undefined;

                        setupResponsiveEventListener(_documentElement,
                            [_strSelectStartEvent, _strMouseTouchMoveEvent, _strMouseTouchUpEvent],
                            [documentOnSelectStart, documentDragMove, documentMouseTouchUp],
                            true);

                        removeClass(_bodyElement, _classNameDragging);
                        if (_scrollbarCornerElement.releaseCapture)
                            _scrollbarCornerElement.releaseCapture();

                        if (eventIsTrusted) {
                            if (reconnectMutationObserver)
                                connectMutationObservers();
                            _base.update(_strAuto);
                        }
                        reconnectMutationObserver = false;
                    }
                    function onMouseTouchDownContinue(event) {
                        var originalEvent = event.originalEvent || event;
                        var isTouchEvent = originalEvent.touches !== undefined;
                        return _sleeping || _destroyed ? false : COMPATIBILITY.mBtn(event) === 1 || isTouchEvent;
                    }
                    function getCoordinates(event) {
                        return _msieVersion && insideIFrame ? { x: event.screenX, y: event.screenY } : COMPATIBILITY.page(event);
                    }

                    addDestroyEventListener(_scrollbarCornerElement, _strMouseTouchDownEvent, function (event) {
                        if (onMouseTouchDownContinue(event) && !_resizeNone) {
                            if (_mutationObserversConnected) {
                                reconnectMutationObserver = true;
                                disconnectMutationObservers();
                            }

                            mouseDownPosition = getCoordinates(event);

                            mouseDownSize.w = _hostElementNative[LEXICON.oW] - (!_isBorderBox ? _paddingX : 0);
                            mouseDownSize.h = _hostElementNative[LEXICON.oH] - (!_isBorderBox ? _paddingY : 0);
                            mouseDownInvertedScale = getHostElementInvertedScale();

                            setupResponsiveEventListener(_documentElement,
                                [_strSelectStartEvent, _strMouseTouchMoveEvent, _strMouseTouchUpEvent],
                                [documentOnSelectStart, documentDragMove, documentMouseTouchUp]);

                            addClass(_bodyElement, _classNameDragging);
                            if (_scrollbarCornerElement.setCapture)
                                _scrollbarCornerElement.setCapture();

                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                        }
                    });
                }


                //==== Utils ====//

                /**
                 * Calls the callback with the given name. The Context of this callback is always _base (this).
                 * @param name The name of the target which shall be called.
                 * @param args The args with which the callback shall be called.
                 * @param dependent Boolean which decides whether the callback shall be fired, undefined is like a "true" value.
                 */
                function dispatchCallback(name, args, dependent) {
                    if (dependent === false)
                        return;
                    if (_initialized) {
                        var callback = _currentPreparedOptions.callbacks[name];
                        var extensionOnName = name;
                        var ext;

                        if (extensionOnName.substr(0, 2) === 'on')
                            extensionOnName = extensionOnName.substr(2, 1).toLowerCase() + extensionOnName.substr(3);

                        if (type(callback) == TYPES.f)
                            callback.call(_base, args);

                        each(_extensions, function () {
                            ext = this;
                            if (type(ext.on) == TYPES.f)
                                ext.on(extensionOnName, args);
                        });
                    }
                    else if (!_destroyed)
                        _callbacksInitQeueue.push({ n: name, a: args });
                }

                /**
                 * Sets the "top, right, bottom, left" properties, with a given prefix, of the given css object.
                 * @param targetCSSObject The css object to which the values shall be applied.
                 * @param prefix The prefix of the "top, right, bottom, left" css properties. (example: 'padding-' is a valid prefix)
                 * @param values A array of values which shall be applied to the "top, right, bottom, left" -properties. The array order is [top, right, bottom, left].
                 * If this argument is undefined the value '' (empty string) will be applied to all properties.
                 */
                function setTopRightBottomLeft(targetCSSObject, prefix, values) {
                    prefix = prefix || _strEmpty;
                    values = values || [_strEmpty, _strEmpty, _strEmpty, _strEmpty];

                    targetCSSObject[prefix + _strTop] = values[0];
                    targetCSSObject[prefix + _strRight] = values[1];
                    targetCSSObject[prefix + _strBottom] = values[2];
                    targetCSSObject[prefix + _strLeft] = values[3];
                }

                /**
                 * Gets the "top, right, bottom, left" CSS properties of the CSS property with the given prefix from the host element.
                 * @param prefix The prefix of the "top, right, bottom, left" css properties. (example: 'padding-' is a valid prefix)
                 * @param suffix The suffix of the "top, right, bottom, left" css properties. (example: 'border-' is a valid prefix with '-width' is a valid suffix)
                 * @param zeroX True if the x axis shall be 0.
                 * @param zeroY True if the y axis shall be 0.
                 * @returns {{}} The object which contains the numbers of the read CSS properties.
                 */
                function getTopRightBottomLeftHost(prefix, suffix, zeroX, zeroY) {
                    suffix = suffix || _strEmpty;
                    prefix = prefix || _strEmpty;
                    return {
                        t: zeroY ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strTop + suffix)),
                        r: zeroX ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strRight + suffix)),
                        b: zeroY ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strBottom + suffix)),
                        l: zeroX ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strLeft + suffix))
                    };
                }

                /**
                 * Returns the computed CSS transition string from the given element.
                 * @param element The element from which the transition string shall be returned.
                 * @returns {string} The CSS transition string from the given element.
                 */
                function getCSSTransitionString(element) {
                    var transitionStr = VENDORS._cssProperty('transition');
                    var assembledValue = element.css(transitionStr);
                    if (assembledValue)
                        return assembledValue;
                    var regExpString = '\\s*(' + '([^,(]+(\\(.+?\\))?)+' + ')[\\s,]*';
                    var regExpMain = new RegExp(regExpString);
                    var regExpValidate = new RegExp('^(' + regExpString + ')+$');
                    var properties = 'property duration timing-function delay'.split(' ');
                    var result = [];
                    var strResult;
                    var valueArray;
                    var i = 0;
                    var j;
                    var splitCssStyleByComma = function (str) {
                        strResult = [];
                        if (!str.match(regExpValidate))
                            return str;
                        while (str.match(regExpMain)) {
                            strResult.push(RegExp.$1);
                            str = str.replace(regExpMain, _strEmpty);
                        }

                        return strResult;
                    };
                    for (; i < properties[LEXICON.l]; i++) {
                        valueArray = splitCssStyleByComma(element.css(transitionStr + '-' + properties[i]));
                        for (j = 0; j < valueArray[LEXICON.l]; j++)
                            result[j] = (result[j] ? result[j] + _strSpace : _strEmpty) + valueArray[j];
                    }
                    return result.join(', ');
                }

                /**
                 * Generates a Regular Expression which matches with a string which starts with 'os-host'.
                 * @param {boolean} withCurrClassNameOption The Regular Expression also matches if the string is the current ClassName option (multiple values splitted by space possible).
                 * @param {boolean} withOldClassNameOption The Regular Expression also matches if the string is the old ClassName option (multiple values splitted by space possible).
                 */
                function createHostClassNameRegExp(withCurrClassNameOption, withOldClassNameOption) {
                    var i;
                    var split;
                    var appendix;
                    var appendClasses = function (classes, condition) {
                        appendix = '';
                        if (condition && typeof classes == TYPES.s) {
                            split = classes.split(_strSpace);
                            for (i = 0; i < split[LEXICON.l]; i++)
                                appendix += '|' + split[i] + '$';
                            // split[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') for escaping regex characters
                        }
                        return appendix;
                    };

                    return new RegExp(
                        '(^' + _classNameHostElement + '([-_].+|)$)' +
                        appendClasses(_classNameCache, withCurrClassNameOption) +
                        appendClasses(_oldClassName, withOldClassNameOption), 'g');
                }

                /**
                 * Calculates the host-elements inverted scale. (invertedScale = 1 / scale)
                 * @returns {{x: number, y: number}} The scale of the host-element.
                 */
                function getHostElementInvertedScale() {
                    var rect = _paddingElementNative[LEXICON.bCR]();
                    return {
                        x: _supportTransform ? 1 / (MATH.round(rect.width) / _paddingElementNative[LEXICON.oW]) || 1 : 1,
                        y: _supportTransform ? 1 / (MATH.round(rect.height) / _paddingElementNative[LEXICON.oH]) || 1 : 1
                    };
                }

                /**
                 * Checks whether the given object is a HTMLElement.
                 * @param o The object which shall be checked.
                 * @returns {boolean} True the given object is a HTMLElement, false otherwise.
                 */
                function isHTMLElement(o) {
                    var strOwnerDocument = 'ownerDocument';
                    var strHTMLElement = 'HTMLElement';
                    var wnd = o && o[strOwnerDocument] ? (o[strOwnerDocument].parentWindow || window) : window;
                    return (
                        typeof wnd[strHTMLElement] == TYPES.o ? o instanceof wnd[strHTMLElement] : //DOM2
                            o && typeof o == TYPES.o && o !== null && o.nodeType === 1 && typeof o.nodeName == TYPES.s
                    );
                }

                /**
                 * Compares 2 arrays and returns the differences between them as a array.
                 * @param a1 The first array which shall be compared.
                 * @param a2 The second array which shall be compared.
                 * @returns {Array} The differences between the two arrays.
                 */
                function getArrayDifferences(a1, a2) {
                    var a = [];
                    var diff = [];
                    var i;
                    var k;
                    for (i = 0; i < a1.length; i++)
                        a[a1[i]] = true;
                    for (i = 0; i < a2.length; i++) {
                        if (a[a2[i]])
                            delete a[a2[i]];
                        else
                            a[a2[i]] = true;
                    }
                    for (k in a)
                        diff.push(k);
                    return diff;
                }

                /**
                 * Returns Zero or the number to which the value can be parsed.
                 * @param value The value which shall be parsed.
                 * @param toFloat Indicates whether the number shall be parsed to a float.
                 */
                function parseToZeroOrNumber(value, toFloat) {
                    var num = toFloat ? parseFloat(value) : parseInt(value, 10);
                    return isNaN(num) ? 0 : num;
                }

                /**
                 * Gets several information of the textarea and returns them as a object or undefined if the browser doesn't support it.
                 * @returns {{cursorRow: Number, cursorCol, rows: Number, cols: number, wRow: number, pos: number, max : number}} or undefined if not supported.
                 */
                function getTextareaInfo() {
                    //read needed values
                    var textareaCursorPosition = _targetElementNative.selectionStart;
                    if (textareaCursorPosition === undefined)
                        return;

                    var textareaValue = _targetElement.val();
                    var textareaLength = textareaValue[LEXICON.l];
                    var textareaRowSplit = textareaValue.split('\n');
                    var textareaLastRow = textareaRowSplit[LEXICON.l];
                    var textareaCurrentCursorRowSplit = textareaValue.substr(0, textareaCursorPosition).split('\n');
                    var widestRow = 0;
                    var textareaLastCol = 0;
                    var cursorRow = textareaCurrentCursorRowSplit[LEXICON.l];
                    var cursorCol = textareaCurrentCursorRowSplit[textareaCurrentCursorRowSplit[LEXICON.l] - 1][LEXICON.l];
                    var rowCols;
                    var i;

                    //get widest Row and the last column of the textarea
                    for (i = 0; i < textareaRowSplit[LEXICON.l]; i++) {
                        rowCols = textareaRowSplit[i][LEXICON.l];
                        if (rowCols > textareaLastCol) {
                            widestRow = i + 1;
                            textareaLastCol = rowCols;
                        }
                    }

                    return {
                        _cursorRow: cursorRow, //cursorRow
                        _cursorColumn: cursorCol, //cursorCol
                        _rows: textareaLastRow, //rows
                        _columns: textareaLastCol, //cols
                        _widestRow: widestRow, //wRow
                        _cursorPosition: textareaCursorPosition, //pos
                        _cursorMax: textareaLength //max
                    };
                }

                /**
                 * Determines whether native overlay scrollbars are active.
                 * @returns {boolean} True if native overlay scrollbars are active, false otherwise.
                 */
                function nativeOverlayScrollbarsAreActive() {
                    return (_ignoreOverlayScrollbarHidingCache && (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y));
                }

                /**
                 * Gets the element which is used to measure the content size.
                 * @returns {*} TextareaCover if target element is textarea else the ContentElement.
                 */
                function getContentMeasureElement() {
                    return _isTextarea ? _textareaCoverElement[0] : _contentElementNative;
                }

                /**
                 * Generates a string which represents a HTML div with the given classes or attributes.
                 * @param classesOrAttrs The class of the div as string or a object which represents the attributes of the div. (The class attribute can also be written as "className".)
                 * @param content The content of the div as string.
                 * @returns {string} The concated string which represents a HTML div and its content.
                 */
                function generateDiv(classesOrAttrs, content) {
                    return '<div ' + (classesOrAttrs ? type(classesOrAttrs) == TYPES.s ?
                        'class="' + classesOrAttrs + '"' :
                        (function () {
                            var key;
                            var attrs = _strEmpty;
                            if (FRAMEWORK.isPlainObject(classesOrAttrs)) {
                                for (key in classesOrAttrs)
                                    attrs += (key === 'c' ? 'class' : key) + '="' + classesOrAttrs[key] + '" ';
                            }
                            return attrs;
                        })() :
                        _strEmpty) +
                        '>' +
                        (content || _strEmpty) +
                        '</div>';
                }

                /**
                 * Selects or generates a div with the given class attribute.
                 * @param className The class names (divided by spaces) of the div which shall be selected or generated.
                 * @param selectParentOrOnlyChildren The parent element from which of the element shall be selected. (if undefined or boolean its hostElement)
                 * If its a boolean it decides whether only the children of the host element shall be selected.
                 * @returns {*} The generated or selected element.
                 */
                function selectOrGenerateDivByClass(className, selectParentOrOnlyChildren) {
                    var onlyChildren = type(selectParentOrOnlyChildren) == TYPES.b;
                    var selectParent = onlyChildren ? _hostElement : (selectParentOrOnlyChildren || _hostElement);

                    return (_domExists && !selectParent[LEXICON.l])
                        ? null
                        : _domExists
                            ? selectParent[onlyChildren ? 'children' : 'find'](_strDot + className.replace(/\s/g, _strDot)).eq(0)
                            : FRAMEWORK(generateDiv(className))
                }

                /**
                 * Gets the value of the given property from the given object.
                 * @param obj The object from which the property value shall be got.
                 * @param path The property of which the value shall be got.
                 * @returns {*} Returns the value of the searched property or undefined of the property wasn't found.
                 */
                function getObjectPropVal(obj, path) {
                    var splits = path.split(_strDot);
                    var i = 0;
                    var val;
                    for (; i < splits.length; i++) {
                        if (!obj[LEXICON.hOP](splits[i]))
                            return;
                        val = obj[splits[i]];
                        if (i < splits.length && type(val) == TYPES.o)
                            obj = val;
                    }
                    return val;
                }

                /**
                 * Sets the value of the given property from the given object.
                 * @param obj The object from which the property value shall be set.
                 * @param path The property of which the value shall be set.
                 * @param val The value of the property which shall be set.
                 */
                function setObjectPropVal(obj, path, val) {
                    var splits = path.split(_strDot);
                    var splitsLength = splits.length;
                    var i = 0;
                    var extendObj = {};
                    var extendObjRoot = extendObj;
                    for (; i < splitsLength; i++)
                        extendObj = extendObj[splits[i]] = i + 1 < splitsLength ? {} : val;
                    FRAMEWORK.extend(obj, extendObjRoot, true);
                }

                /**	
                 * Runs a action for each selector inside the updateOnLoad option.	
                 * @param {Function} action The action for each updateOnLoad selector, the arguments the function takes is the index and the value (the selector).	
                 */
                function eachUpdateOnLoad(action) {
                    var updateOnLoad = _currentPreparedOptions.updateOnLoad;
                    updateOnLoad = type(updateOnLoad) == TYPES.s ? updateOnLoad.split(_strSpace) : updateOnLoad;

                    if (COMPATIBILITY.isA(updateOnLoad) && !_destroyed) {
                        each(updateOnLoad, action);
                    }
                }


                //==== Utils Cache ====//

                /**
                 * Compares two values or objects and returns true if they aren't equal.
                 * @param current The first value or object which shall be compared.
                 * @param cache The second value or object which shall be compared.
                 * @param force If true the returned value is always true.
                 * @returns {boolean} True if both values or objects aren't equal or force is true, false otherwise.
                 */
                function checkCache(current, cache, force) {
                    if (force)
                        return force;
                    if (type(current) == TYPES.o && type(cache) == TYPES.o) {
                        for (var prop in current) {
                            if (prop !== 'c') {
                                if (current[LEXICON.hOP](prop) && cache[LEXICON.hOP](prop)) {
                                    if (checkCache(current[prop], cache[prop]))
                                        return true;
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                    }
                    else {
                        return current !== cache;
                    }
                    return false;
                }


                //==== Shortcuts ====//

                /**
                 * jQuery extend method shortcut with a appended "true" as first argument.
                 */
                function extendDeep() {
                    return FRAMEWORK.extend.apply(this, [true].concat([].slice.call(arguments)));
                }

                /**
                 * jQuery addClass method shortcut.
                 */
                function addClass(el, classes) {
                    return _frameworkProto.addClass.call(el, classes);
                }

                /**
                 * jQuery removeClass method shortcut.
                 */
                function removeClass(el, classes) {
                    return _frameworkProto.removeClass.call(el, classes);
                }

                /**
                 * Adds or removes the given classes dependent on the boolean value. True for add, false for remove.
                 */
                function addRemoveClass(el, classes, doAdd) {
                    return doAdd ? addClass(el, classes) : removeClass(el, classes);
                }

                /**
                 * jQuery remove method shortcut.
                 */
                function remove(el) {
                    return _frameworkProto.remove.call(el);
                }

                /**
                 * Finds the first child element with the given selector of the given element.
                 * @param el The root element from which the selector shall be valid.
                 * @param selector The selector of the searched element.
                 * @returns {*} The first element which is a child of the given element and matches the givens selector.
                 */
                function findFirst(el, selector) {
                    return _frameworkProto.find.call(el, selector).eq(0);
                }


                //==== API ====//

                /**
                 * Puts the instance to sleep. It wont respond to any changes in the DOM and won't update. Scrollbar Interactivity is also disabled as well as the resize handle.
                 * This behavior can be reset by calling the update method.
                 */
                _base.sleep = function () {
                    _sleeping = true;
                };

                /**
                 * Updates the plugin and DOM to the current options.
                 * This method should only be called if a update is 100% required.
                 * @param force True if every property shall be updated and the cache shall be ignored.
                 * !INTERNAL USAGE! : force can be a string "auto", "sync" or "zoom" too
                 * if "auto" then before a real update the content size and host element attributes gets checked, and if they changed only then the update method will be called.
                 * if "sync" then the async update process (MutationObserver or UpdateLoop) gets synchronized and a corresponding update takes place if one was needed due to pending changes.
                 * if "zoom" then a update takes place where it's assumed that content and host size changed
                 * @returns {boolean|undefined} 
                 * If force is "sync" then a boolean is returned which indicates whether a update was needed due to pending changes.
                 * If force is "auto" then a boolean is returned whether a update was needed due to attribute or size changes.
                 * undefined otherwise.
                 */
                _base.update = function (force) {
                    if (_destroyed)
                        return;

                    var attrsChanged;
                    var contentSizeC;
                    var isString = type(force) == TYPES.s;
                    var doUpdateAuto;
                    var mutHost;
                    var mutContent;

                    if (isString) {
                        if (force === _strAuto) {
                            attrsChanged = meaningfulAttrsChanged();
                            contentSizeC = updateAutoContentSizeChanged();
                            doUpdateAuto = attrsChanged || contentSizeC;
                            if (doUpdateAuto) {
                                update({
                                    _contentSizeChanged: contentSizeC,
                                    _changedOptions: _initialized ? undefined : _currentPreparedOptions
                                });
                            }
                        }
                        else if (force === _strSync) {
                            if (_mutationObserversConnected) {
                                mutHost = _mutationObserverHostCallback(_mutationObserverHost.takeRecords());
                                mutContent = _mutationObserverContentCallback(_mutationObserverContent.takeRecords());
                            }
                            else {
                                mutHost = _base.update(_strAuto);
                            }
                        }
                        else if (force === 'zoom') {
                            update({
                                _hostSizeChanged: true,
                                _contentSizeChanged: true
                            });
                        }
                    }
                    else {
                        force = _sleeping || force;
                        _sleeping = false;
                        if (!_base.update(_strSync) || force)
                            update({ _force: force });
                    }

                    updateElementsOnLoad();

                    return doUpdateAuto || mutHost || mutContent;
                };

                /**
                 Gets or sets the current options. The update method will be called automatically if new options were set.
                 * @param newOptions If new options are given, then the new options will be set, if new options aren't given (undefined or a not a plain object) then the current options will be returned.
                 * @param value If new options is a property path string, then this value will be used to set the option to which the property path string leads.
                 * @returns {*}
                 */
                _base.options = function (newOptions, value) {
                    var option = {};
                    var changedOps;

                    //return current options if newOptions are undefined or empty
                    if (FRAMEWORK.isEmptyObject(newOptions) || !FRAMEWORK.isPlainObject(newOptions)) {
                        if (type(newOptions) == TYPES.s) {
                            if (arguments.length > 1) {
                                setObjectPropVal(option, newOptions, value);
                                changedOps = setOptions(option);
                            }
                            else
                                return getObjectPropVal(_currentOptions, newOptions);
                        }
                        else
                            return _currentOptions;
                    }
                    else {
                        changedOps = setOptions(newOptions);
                    }

                    if (!FRAMEWORK.isEmptyObject(changedOps)) {
                        update({ _changedOptions: changedOps });
                    }
                };

                /**
                 * Restore the DOM, disconnects all observers, remove all resize observers and put the instance to sleep.
                 */
                _base.destroy = function () {
                    if (_destroyed)
                        return;

                    //remove this instance from auto update loop
                    autoUpdateLoop.remove(_base);

                    //disconnect all mutation observers
                    disconnectMutationObservers();

                    //remove all resize observers
                    setupResizeObserver(_sizeObserverElement);
                    setupResizeObserver(_sizeAutoObserverElement);

                    //remove all extensions
                    for (var extName in _extensions)
                        _base.removeExt(extName);

                    //remove all 'destroy' events
                    while (_destroyEvents[LEXICON.l] > 0)
                        _destroyEvents.pop()();

                    //remove all events from host element
                    setupHostMouseTouchEvents(true);

                    //remove all helper / detection elements
                    if (_contentGlueElement)
                        remove(_contentGlueElement);
                    if (_contentArrangeElement)
                        remove(_contentArrangeElement);
                    if (_sizeAutoObserverAdded)
                        remove(_sizeAutoObserverElement);

                    //remove all generated DOM
                    setupScrollbarsDOM(true);
                    setupScrollbarCornerDOM(true);
                    setupStructureDOM(true);

                    //remove all generated image load events
                    for (var i = 0; i < _updateOnLoadElms[LEXICON.l]; i++)
                        FRAMEWORK(_updateOnLoadElms[i]).off(_updateOnLoadEventName, updateOnLoadCallback);
                    _updateOnLoadElms = undefined;

                    _destroyed = true;
                    _sleeping = true;

                    //remove this instance from the instances list
                    INSTANCES(pluginTargetElement, 0);
                    dispatchCallback('onDestroyed');

                    //remove all properties and methods
                    //for (var property in _base)
                    //    delete _base[property];
                    //_base = undefined;
                };

                /**
                 * Scrolls to a given position or element.
                 * @param coordinates
                 * 1. Can be "coordinates" which looks like:
                 *    { x : ?, y : ? } OR          Object with x and y properties
                 *    { left : ?, top : ? } OR     Object with left and top properties
                 *    { l : ?, t : ? } OR          Object with l and t properties
                 *    [ ?, ? ] OR                  Array where the first two element are the coordinates (first is x, second is y)
                 *    ?                            A single value which stays for both axis
                 *    A value can be a number, a string or a calculation.
                 *
                 *    Operators:
                 *    [NONE]  The current scroll will be overwritten by the value.
                 *    '+='    The value will be added to the current scroll offset
                 *    '-='    The value will be subtracted from the current scroll offset
                 *    '*='    The current scroll wil be multiplicated by the value.
                 *    '/='    The current scroll wil be divided by the value.
                 *
                 *    Units:
                 *    [NONE]  The value is the final scroll amount.                   final = (value * 1)
                 *    'px'    Same as none
                 *    '%'     The value is dependent on the current scroll value.     final = ((currentScrollValue / 100) * value)
                 *    'vw'    The value is multiplicated by the viewport width.       final = (value * viewportWidth)
                 *    'vh'    The value is multiplicated by the viewport height.      final = (value * viewportHeight)
                 *
                 *    example final values:
                 *    200, '200px', '50%', '1vw', '1vh', '+=200', '/=1vw', '*=2px', '-=5vh', '+=33%', '+= 50% - 2px', '-= 1vw - 50%'
                 *
                 * 2. Can be a HTML or jQuery element:
                 *    The final scroll offset is the offset (without margin) of the given HTML / jQuery element.
                 *
                 * 3. Can be a object with a HTML or jQuery element with additional settings:
                 *    {
                 *      el : [HTMLElement, jQuery element],             MUST be specified, else this object isn't valid.
                 *      scroll : [string, array, object],               Default value is 'always'.
                 *      block : [string, array, object],                Default value is 'begin'.
                 *      margin : [number, boolean, array, object]       Default value is false.
                 *    }
                 *
                 *    Possible scroll settings are:
                 *    'always'      Scrolls always.
                 *    'ifneeded'    Scrolls only if the element isnt fully in view.
                 *    'never'       Scrolls never.
                 *
                 *    Possible block settings are:
                 *    'begin'   Both axis shall be docked to the "begin" edge. - The element will be docked to the top and left edge of the viewport.
                 *    'end'     Both axis shall be docked to the "end" edge. - The element will be docked to the bottom and right edge of the viewport. (If direction is RTL to the bottom and left edge.)
                 *    'center'  Both axis shall be docked to "center". - The element will be centered in the viewport.
                 *    'nearest' The element will be docked to the nearest edge(s).
                 *
                 *    Possible margin settings are: -- The actual margin of the element wont be affect, this option affects only the final scroll offset.
                 *    [BOOLEAN]                                         If true the css margin of the element will be used, if false no margin will be used.
                 *    [NUMBER]                                          The margin will be used for all edges.
                 *
                 * @param duration The duration of the scroll animation, OR a jQuery animation configuration object.
                 * @param easing The animation easing.
                 * @param complete The animation complete callback.
                 * @returns {{
                 *   position: {x: number, y: number},
                 *   ratio: {x: number, y: number},
                 *   max: {x: number, y: number},
                 *   handleOffset: {x: number, y: number},
                 *   handleLength: {x: number, y: number},
                 *   handleLengthRatio: {x: number, y: number}, t
                 *   rackLength: {x: number, y: number},
                 *   isRTL: boolean,
                 *   isRTLNormalized: boolean
                 *  }}
                 */
                _base.scroll = function (coordinates, duration, easing, complete) {
                    if (arguments.length === 0 || coordinates === undefined) {
                        var infoX = _scrollHorizontalInfo;
                        var infoY = _scrollVerticalInfo;
                        var normalizeInvert = _normalizeRTLCache && _isRTL && _rtlScrollBehavior.i;
                        var normalizeNegate = _normalizeRTLCache && _isRTL && _rtlScrollBehavior.n;
                        var scrollX = infoX._currentScroll;
                        var scrollXRatio = infoX._currentScrollRatio;
                        var maxScrollX = infoX._maxScroll;
                        scrollXRatio = normalizeInvert ? 1 - scrollXRatio : scrollXRatio;
                        scrollX = normalizeInvert ? maxScrollX - scrollX : scrollX;
                        scrollX *= normalizeNegate ? -1 : 1;
                        maxScrollX *= normalizeNegate ? -1 : 1;

                        return {
                            position: {
                                x: scrollX,
                                y: infoY._currentScroll
                            },
                            ratio: {
                                x: scrollXRatio,
                                y: infoY._currentScrollRatio
                            },
                            max: {
                                x: maxScrollX,
                                y: infoY._maxScroll
                            },
                            handleOffset: {
                                x: infoX._handleOffset,
                                y: infoY._handleOffset
                            },
                            handleLength: {
                                x: infoX._handleLength,
                                y: infoY._handleLength
                            },
                            handleLengthRatio: {
                                x: infoX._handleLengthRatio,
                                y: infoY._handleLengthRatio
                            },
                            trackLength: {
                                x: infoX._trackLength,
                                y: infoY._trackLength
                            },
                            snappedHandleOffset: {
                                x: infoX._snappedHandleOffset,
                                y: infoY._snappedHandleOffset
                            },
                            isRTL: _isRTL,
                            isRTLNormalized: _normalizeRTLCache
                        };
                    }

                    _base.update(_strSync);

                    var normalizeRTL = _normalizeRTLCache;
                    var coordinatesXAxisProps = [_strX, _strLeft, 'l'];
                    var coordinatesYAxisProps = [_strY, _strTop, 't'];
                    var coordinatesOperators = ['+=', '-=', '*=', '/='];
                    var durationIsObject = type(duration) == TYPES.o;
                    var completeCallback = durationIsObject ? duration.complete : complete;
                    var i;
                    var finalScroll = {};
                    var specialEasing = {};
                    var doScrollLeft;
                    var doScrollTop;
                    var animationOptions;
                    var strEnd = 'end';
                    var strBegin = 'begin';
                    var strCenter = 'center';
                    var strNearest = 'nearest';
                    var strAlways = 'always';
                    var strNever = 'never';
                    var strIfNeeded = 'ifneeded';
                    var strLength = LEXICON.l;
                    var settingsAxis;
                    var settingsScroll;
                    var settingsBlock;
                    var settingsMargin;
                    var finalElement;
                    var elementObjSettingsAxisValues = [_strX, _strY, 'xy', 'yx'];
                    var elementObjSettingsBlockValues = [strBegin, strEnd, strCenter, strNearest];
                    var elementObjSettingsScrollValues = [strAlways, strNever, strIfNeeded];
                    var coordinatesIsElementObj = coordinates[LEXICON.hOP]('el');
                    var possibleElement = coordinatesIsElementObj ? coordinates.el : coordinates;
                    var possibleElementIsJQuery = possibleElement instanceof FRAMEWORK || JQUERY ? possibleElement instanceof JQUERY : false;
                    var possibleElementIsHTMLElement = possibleElementIsJQuery ? false : isHTMLElement(possibleElement);
                    var updateScrollbarInfos = function () {
                        if (doScrollLeft)
                            refreshScrollbarHandleOffset(true);
                        if (doScrollTop)
                            refreshScrollbarHandleOffset(false);
                    };
                    var proxyCompleteCallback = type(completeCallback) != TYPES.f ? undefined : function () {
                        updateScrollbarInfos();
                        completeCallback();
                    };
                    function checkSettingsStringValue(currValue, allowedValues) {
                        for (i = 0; i < allowedValues[strLength]; i++) {
                            if (currValue === allowedValues[i])
                                return true;
                        }
                        return false;
                    }
                    function getRawScroll(isX, coordinates) {
                        var coordinateProps = isX ? coordinatesXAxisProps : coordinatesYAxisProps;
                        coordinates = type(coordinates) == TYPES.s || type(coordinates) == TYPES.n ? [coordinates, coordinates] : coordinates;

                        if (COMPATIBILITY.isA(coordinates))
                            return isX ? coordinates[0] : coordinates[1];
                        else if (type(coordinates) == TYPES.o) {
                            //decides RTL normalization "hack" with .n
                            //normalizeRTL = type(coordinates.n) == TYPES.b ? coordinates.n : normalizeRTL; 
                            for (i = 0; i < coordinateProps[strLength]; i++)
                                if (coordinateProps[i] in coordinates)
                                    return coordinates[coordinateProps[i]];
                        }
                    }
                    function getFinalScroll(isX, rawScroll) {
                        var isString = type(rawScroll) == TYPES.s;
                        var operator;
                        var amount;
                        var scrollInfo = isX ? _scrollHorizontalInfo : _scrollVerticalInfo;
                        var currScroll = scrollInfo._currentScroll;
                        var maxScroll = scrollInfo._maxScroll;
                        var mult = ' * ';
                        var finalValue;
                        var isRTLisX = _isRTL && isX;
                        var normalizeShortcuts = isRTLisX && _rtlScrollBehavior.n && !normalizeRTL;
                        var strReplace = 'replace';
                        var evalFunc = eval;
                        var possibleOperator;
                        if (isString) {
                            //check operator
                            if (rawScroll[strLength] > 2) {
                                possibleOperator = rawScroll.substr(0, 2);
                                if (inArray(possibleOperator, coordinatesOperators) > -1)
                                    operator = possibleOperator;
                            }

                            //calculate units and shortcuts
                            rawScroll = operator ? rawScroll.substr(2) : rawScroll;
                            rawScroll = rawScroll
                            [strReplace](/min/g, 0) //'min' = 0%
                            [strReplace](/</g, 0)   //'<'   = 0%
                            [strReplace](/max/g, (normalizeShortcuts ? '-' : _strEmpty) + _strHundredPercent)    //'max' = 100%
                            [strReplace](/>/g, (normalizeShortcuts ? '-' : _strEmpty) + _strHundredPercent)      //'>'   = 100%
                            [strReplace](/px/g, _strEmpty)
                            [strReplace](/%/g, mult + (maxScroll * (isRTLisX && _rtlScrollBehavior.n ? -1 : 1) / 100.0))
                            [strReplace](/vw/g, mult + _viewportSize.w)
                            [strReplace](/vh/g, mult + _viewportSize.h);
                            amount = parseToZeroOrNumber(isNaN(rawScroll) ? parseToZeroOrNumber(evalFunc(rawScroll), true).toFixed() : rawScroll);
                        }
                        else {
                            amount = rawScroll;
                        }

                        if (amount !== undefined && !isNaN(amount) && type(amount) == TYPES.n) {
                            var normalizeIsRTLisX = normalizeRTL && isRTLisX;
                            var operatorCurrScroll = currScroll * (normalizeIsRTLisX && _rtlScrollBehavior.n ? -1 : 1);
                            var invert = normalizeIsRTLisX && _rtlScrollBehavior.i;
                            var negate = normalizeIsRTLisX && _rtlScrollBehavior.n;
                            operatorCurrScroll = invert ? (maxScroll - operatorCurrScroll) : operatorCurrScroll;
                            switch (operator) {
                                case '+=':
                                    finalValue = operatorCurrScroll + amount;
                                    break;
                                case '-=':
                                    finalValue = operatorCurrScroll - amount;
                                    break;
                                case '*=':
                                    finalValue = operatorCurrScroll * amount;
                                    break;
                                case '/=':
                                    finalValue = operatorCurrScroll / amount;
                                    break;
                                default:
                                    finalValue = amount;
                                    break;
                            }
                            finalValue = invert ? maxScroll - finalValue : finalValue;
                            finalValue *= negate ? -1 : 1;
                            finalValue = isRTLisX && _rtlScrollBehavior.n ? MATH.min(0, MATH.max(maxScroll, finalValue)) : MATH.max(0, MATH.min(maxScroll, finalValue));
                        }
                        return finalValue === currScroll ? undefined : finalValue;
                    }
                    function getPerAxisValue(value, valueInternalType, defaultValue, allowedValues) {
                        var resultDefault = [defaultValue, defaultValue];
                        var valueType = type(value);
                        var valueArrLength;
                        var valueArrItem;

                        //value can be [ string, or array of two strings ]
                        if (valueType == valueInternalType) {
                            value = [value, value];
                        }
                        else if (valueType == TYPES.a) {
                            valueArrLength = value[strLength];
                            if (valueArrLength > 2 || valueArrLength < 1)
                                value = resultDefault;
                            else {
                                if (valueArrLength === 1)
                                    value[1] = defaultValue;
                                for (i = 0; i < valueArrLength; i++) {
                                    valueArrItem = value[i];
                                    if (type(valueArrItem) != valueInternalType || !checkSettingsStringValue(valueArrItem, allowedValues)) {
                                        value = resultDefault;
                                        break;
                                    }
                                }
                            }
                        }
                        else if (valueType == TYPES.o)
                            value = [value[_strX] || defaultValue, value[_strY] || defaultValue];
                        else
                            value = resultDefault;
                        return { x: value[0], y: value[1] };
                    }
                    function generateMargin(marginTopRightBottomLeftArray) {
                        var result = [];
                        var currValue;
                        var currValueType;
                        var valueDirections = [_strTop, _strRight, _strBottom, _strLeft];
                        for (i = 0; i < marginTopRightBottomLeftArray[strLength]; i++) {
                            if (i === valueDirections[strLength])
                                break;
                            currValue = marginTopRightBottomLeftArray[i];
                            currValueType = type(currValue);
                            if (currValueType == TYPES.b)
                                result.push(currValue ? parseToZeroOrNumber(finalElement.css(_strMarginMinus + valueDirections[i])) : 0);
                            else
                                result.push(currValueType == TYPES.n ? currValue : 0);
                        }
                        return result;
                    }

                    if (possibleElementIsJQuery || possibleElementIsHTMLElement) {
                        //get settings
                        var margin = coordinatesIsElementObj ? coordinates.margin : 0;
                        var axis = coordinatesIsElementObj ? coordinates.axis : 0;
                        var scroll = coordinatesIsElementObj ? coordinates.scroll : 0;
                        var block = coordinatesIsElementObj ? coordinates.block : 0;
                        var marginDefault = [0, 0, 0, 0];
                        var marginType = type(margin);
                        var marginLength;
                        finalElement = possibleElementIsJQuery ? possibleElement : FRAMEWORK(possibleElement);

                        if (finalElement[strLength] > 0) {
                            //margin can be [ boolean, number, array of 2, array of 4, object ]
                            if (marginType == TYPES.n || marginType == TYPES.b)
                                margin = generateMargin([margin, margin, margin, margin]);
                            else if (marginType == TYPES.a) {
                                marginLength = margin[strLength];
                                if (marginLength === 2)
                                    margin = generateMargin([margin[0], margin[1], margin[0], margin[1]]);
                                else if (marginLength >= 4)
                                    margin = generateMargin(margin);
                                else
                                    margin = marginDefault;
                            }
                            else if (marginType == TYPES.o)
                                margin = generateMargin([margin[_strTop], margin[_strRight], margin[_strBottom], margin[_strLeft]]);
                            else
                                margin = marginDefault;

                            //block = type(block) === TYPES.b ? block ? [ strNearest, strBegin ] : [ strNearest, strEnd ] : block;
                            settingsAxis = checkSettingsStringValue(axis, elementObjSettingsAxisValues) ? axis : 'xy';
                            settingsScroll = getPerAxisValue(scroll, TYPES.s, strAlways, elementObjSettingsScrollValues);
                            settingsBlock = getPerAxisValue(block, TYPES.s, strBegin, elementObjSettingsBlockValues);
                            settingsMargin = margin;

                            var viewportScroll = {
                                l: _scrollHorizontalInfo._currentScroll,
                                t: _scrollVerticalInfo._currentScroll
                            };
                            // use padding element instead of viewport element because padding element has never padding, margin or position applied.
                            var viewportOffset = _paddingElement.offset();

                            //get coordinates
                            var elementOffset = finalElement.offset();
                            var doNotScroll = {
                                x: settingsScroll.x == strNever || settingsAxis == _strY,
                                y: settingsScroll.y == strNever || settingsAxis == _strX
                            };
                            elementOffset[_strTop] -= settingsMargin[0];
                            elementOffset[_strLeft] -= settingsMargin[3];
                            var elementScrollCoordinates = {
                                x: MATH.round(elementOffset[_strLeft] - viewportOffset[_strLeft] + viewportScroll.l),
                                y: MATH.round(elementOffset[_strTop] - viewportOffset[_strTop] + viewportScroll.t)
                            };
                            if (_isRTL) {
                                if (!_rtlScrollBehavior.n && !_rtlScrollBehavior.i)
                                    elementScrollCoordinates.x = MATH.round(viewportOffset[_strLeft] - elementOffset[_strLeft] + viewportScroll.l);
                                if (_rtlScrollBehavior.n && normalizeRTL)
                                    elementScrollCoordinates.x *= -1;
                                if (_rtlScrollBehavior.i && normalizeRTL)
                                    elementScrollCoordinates.x = MATH.round(viewportOffset[_strLeft] - elementOffset[_strLeft] + (_scrollHorizontalInfo._maxScroll - viewportScroll.l));
                            }

                            //measuring is required
                            if (settingsBlock.x != strBegin || settingsBlock.y != strBegin || settingsScroll.x == strIfNeeded || settingsScroll.y == strIfNeeded || _isRTL) {
                                var measuringElm = finalElement[0];
                                var rawElementSize = _supportTransform ? measuringElm[LEXICON.bCR]() : {
                                    width: measuringElm[LEXICON.oW],
                                    height: measuringElm[LEXICON.oH]
                                };
                                var elementSize = {
                                    w: rawElementSize[_strWidth] + settingsMargin[3] + settingsMargin[1],
                                    h: rawElementSize[_strHeight] + settingsMargin[0] + settingsMargin[2]
                                };
                                var finalizeBlock = function (isX) {
                                    var vars = getScrollbarVars(isX);
                                    var wh = vars._w_h;
                                    var lt = vars._left_top;
                                    var xy = vars._x_y;
                                    var blockIsEnd = settingsBlock[xy] == (isX ? _isRTL ? strBegin : strEnd : strEnd);
                                    var blockIsCenter = settingsBlock[xy] == strCenter;
                                    var blockIsNearest = settingsBlock[xy] == strNearest;
                                    var scrollNever = settingsScroll[xy] == strNever;
                                    var scrollIfNeeded = settingsScroll[xy] == strIfNeeded;
                                    var vpSize = _viewportSize[wh];
                                    var vpOffset = viewportOffset[lt];
                                    var elSize = elementSize[wh];
                                    var elOffset = elementOffset[lt];
                                    var divide = blockIsCenter ? 2 : 1;
                                    var elementCenterOffset = elOffset + (elSize / 2);
                                    var viewportCenterOffset = vpOffset + (vpSize / 2);
                                    var isInView =
                                        elSize <= vpSize
                                        && elOffset >= vpOffset
                                        && elOffset + elSize <= vpOffset + vpSize;

                                    if (scrollNever)
                                        doNotScroll[xy] = true;
                                    else if (!doNotScroll[xy]) {
                                        if (blockIsNearest || scrollIfNeeded) {
                                            doNotScroll[xy] = scrollIfNeeded ? isInView : false;
                                            blockIsEnd = elSize < vpSize ? elementCenterOffset > viewportCenterOffset : elementCenterOffset < viewportCenterOffset;
                                        }
                                        elementScrollCoordinates[xy] -= blockIsEnd || blockIsCenter ? ((vpSize / divide) - (elSize / divide)) * (isX && _isRTL && normalizeRTL ? -1 : 1) : 0;
                                    }
                                };
                                finalizeBlock(true);
                                finalizeBlock(false);
                            }

                            if (doNotScroll.y)
                                delete elementScrollCoordinates.y;
                            if (doNotScroll.x)
                                delete elementScrollCoordinates.x;

                            coordinates = elementScrollCoordinates;
                        }
                    }

                    finalScroll[_strScrollLeft] = getFinalScroll(true, getRawScroll(true, coordinates));
                    finalScroll[_strScrollTop] = getFinalScroll(false, getRawScroll(false, coordinates));
                    doScrollLeft = finalScroll[_strScrollLeft] !== undefined;
                    doScrollTop = finalScroll[_strScrollTop] !== undefined;

                    if ((doScrollLeft || doScrollTop) && (duration > 0 || durationIsObject)) {
                        if (durationIsObject) {
                            duration.complete = proxyCompleteCallback;
                            _viewportElement.animate(finalScroll, duration);
                        }
                        else {
                            animationOptions = {
                                duration: duration,
                                complete: proxyCompleteCallback
                            };
                            if (COMPATIBILITY.isA(easing) || FRAMEWORK.isPlainObject(easing)) {
                                specialEasing[_strScrollLeft] = easing[0] || easing.x;
                                specialEasing[_strScrollTop] = easing[1] || easing.y;
                                animationOptions.specialEasing = specialEasing;
                            }
                            else {
                                animationOptions.easing = easing;
                            }
                            _viewportElement.animate(finalScroll, animationOptions);
                        }
                    }
                    else {
                        if (doScrollLeft)
                            _viewportElement[_strScrollLeft](finalScroll[_strScrollLeft]);
                        if (doScrollTop)
                            _viewportElement[_strScrollTop](finalScroll[_strScrollTop]);
                        updateScrollbarInfos();
                    }
                };

                /**
                 * Stops all scroll animations.
                 * @returns {*} The current OverlayScrollbars instance (for chaining).
                 */
                _base.scrollStop = function (param1, param2, param3) {
                    _viewportElement.stop(param1, param2, param3);
                    return _base;
                };

                /**
                 * Returns all relevant elements.
                 * @param elementName The name of the element which shall be returned.
                 * @returns {{target: *, host: *, padding: *, viewport: *, content: *, scrollbarHorizontal: {scrollbar: *, track: *, handle: *}, scrollbarVertical: {scrollbar: *, track: *, handle: *}, scrollbarCorner: *} | *}
                 */
                _base.getElements = function (elementName) {
                    var obj = {
                        target: _targetElementNative,
                        host: _hostElementNative,
                        padding: _paddingElementNative,
                        viewport: _viewportElementNative,
                        content: _contentElementNative,
                        scrollbarHorizontal: {
                            scrollbar: _scrollbarHorizontalElement[0],
                            track: _scrollbarHorizontalTrackElement[0],
                            handle: _scrollbarHorizontalHandleElement[0]
                        },
                        scrollbarVertical: {
                            scrollbar: _scrollbarVerticalElement[0],
                            track: _scrollbarVerticalTrackElement[0],
                            handle: _scrollbarVerticalHandleElement[0]
                        },
                        scrollbarCorner: _scrollbarCornerElement[0]
                    };
                    return type(elementName) == TYPES.s ? getObjectPropVal(obj, elementName) : obj;
                };

                /**
                 * Returns a object which describes the current state of this instance.
                 * @param stateProperty A specific property from the state object which shall be returned.
                 * @returns {{widthAuto, heightAuto, overflowAmount, hideOverflow, hasOverflow, contentScrollSize, viewportSize, hostSize, autoUpdate} | *}
                 */
                _base.getState = function (stateProperty) {
                    function prepare(obj) {
                        if (!FRAMEWORK.isPlainObject(obj))
                            return obj;
                        var extended = extendDeep({}, obj);
                        var changePropertyName = function (from, to) {
                            if (extended[LEXICON.hOP](from)) {
                                extended[to] = extended[from];
                                delete extended[from];
                            }
                        };
                        changePropertyName('w', _strWidth); //change w to width
                        changePropertyName('h', _strHeight); //change h to height
                        delete extended.c; //delete c (the 'changed' prop)
                        return extended;
                    };
                    var obj = {
                        destroyed: !!prepare(_destroyed),
                        sleeping: !!prepare(_sleeping),
                        autoUpdate: prepare(!_mutationObserversConnected),
                        widthAuto: prepare(_widthAutoCache),
                        heightAuto: prepare(_heightAutoCache),
                        padding: prepare(_cssPaddingCache),
                        overflowAmount: prepare(_overflowAmountCache),
                        hideOverflow: prepare(_hideOverflowCache),
                        hasOverflow: prepare(_hasOverflowCache),
                        contentScrollSize: prepare(_contentScrollSizeCache),
                        viewportSize: prepare(_viewportSize),
                        hostSize: prepare(_hostSizeCache),
                        documentMixed: prepare(_documentMixed)
                    };
                    return type(stateProperty) == TYPES.s ? getObjectPropVal(obj, stateProperty) : obj;
                };

                /**
                 * Gets all or specific extension instance.
                 * @param extName The name of the extension from which the instance shall be got.
                 * @returns {{}} The instance of the extension with the given name or undefined if the instance couldn't be found.
                 */
                _base.ext = function (extName) {
                    var result;
                    var privateMethods = _extensionsPrivateMethods.split(' ');
                    var i = 0;
                    if (type(extName) == TYPES.s) {
                        if (_extensions[LEXICON.hOP](extName)) {
                            result = extendDeep({}, _extensions[extName]);
                            for (; i < privateMethods.length; i++)
                                delete result[privateMethods[i]];
                        }
                    }
                    else {
                        result = {};
                        for (i in _extensions)
                            result[i] = extendDeep({}, _base.ext(i));
                    }
                    return result;
                };

                /**
                 * Adds a extension to this instance.
                 * @param extName The name of the extension which shall be added.
                 * @param extensionOptions The extension options which shall be used.
                 * @returns {{}} The instance of the added extension or undefined if the extension couldn't be added properly.
                 */
                _base.addExt = function (extName, extensionOptions) {
                    var registeredExtensionObj = _plugin.extension(extName);
                    var instance;
                    var instanceAdded;
                    var instanceContract;
                    var contractResult;
                    var contractFulfilled = true;
                    if (registeredExtensionObj) {
                        if (!_extensions[LEXICON.hOP](extName)) {
                            instance = registeredExtensionObj.extensionFactory.call(_base,
                                extendDeep({}, registeredExtensionObj.defaultOptions),
                                FRAMEWORK,
                                COMPATIBILITY);

                            if (instance) {
                                instanceContract = instance.contract;
                                if (type(instanceContract) == TYPES.f) {
                                    contractResult = instanceContract(window);
                                    contractFulfilled = type(contractResult) == TYPES.b ? contractResult : contractFulfilled;
                                }
                                if (contractFulfilled) {
                                    _extensions[extName] = instance;
                                    instanceAdded = instance.added;
                                    if (type(instanceAdded) == TYPES.f)
                                        instanceAdded(extensionOptions);

                                    return _base.ext(extName);
                                }
                            }
                        }
                        else
                            return _base.ext(extName);
                    }
                    else
                        console.warn("A extension with the name \"" + extName + "\" isn't registered.");
                };

                /**
                 * Removes a extension from this instance.
                 * @param extName The name of the extension which shall be removed.
                 * @returns {boolean} True if the extension was removed, false otherwise e.g. if the extension wasn't added before.
                 */
                _base.removeExt = function (extName) {
                    var instance = _extensions[extName];
                    var instanceRemoved;
                    if (instance) {
                        delete _extensions[extName];

                        instanceRemoved = instance.removed;
                        if (type(instanceRemoved) == TYPES.f)
                            instanceRemoved();

                        return true;
                    }
                    return false;
                };

                /**
                 * Constructs the plugin.
                 * @param targetElement The element to which the plugin shall be applied.
                 * @param options The initial options of the plugin.
                 * @param extensions The extension(s) which shall be added right after the initialization.
                 * @returns {boolean} True if the plugin was successfully initialized, false otherwise.
                 */
                function construct(targetElement, options, extensions) {
                    _defaultOptions = globals.defaultOptions;
                    _nativeScrollbarStyling = globals.nativeScrollbarStyling;
                    _nativeScrollbarSize = extendDeep({}, globals.nativeScrollbarSize);
                    _nativeScrollbarIsOverlaid = extendDeep({}, globals.nativeScrollbarIsOverlaid);
                    _overlayScrollbarDummySize = extendDeep({}, globals.overlayScrollbarDummySize);
                    _rtlScrollBehavior = extendDeep({}, globals.rtlScrollBehavior);

                    //parse & set options but don't update
                    setOptions(extendDeep({}, _defaultOptions, options));

                    _cssCalc = globals.cssCalc;
                    _msieVersion = globals.msie;
                    _autoUpdateRecommended = globals.autoUpdateRecommended;
                    _supportTransition = globals.supportTransition;
                    _supportTransform = globals.supportTransform;
                    _supportPassiveEvents = globals.supportPassiveEvents;
                    _supportResizeObserver = globals.supportResizeObserver;
                    _supportMutationObserver = globals.supportMutationObserver;
                    _restrictedMeasuring = globals.restrictedMeasuring;
                    _documentElement = FRAMEWORK(targetElement.ownerDocument);
                    _documentElementNative = _documentElement[0];
                    _windowElement = FRAMEWORK(_documentElementNative.defaultView || _documentElementNative.parentWindow);
                    _windowElementNative = _windowElement[0];
                    _htmlElement = findFirst(_documentElement, 'html');
                    _bodyElement = findFirst(_htmlElement, 'body');
                    _targetElement = FRAMEWORK(targetElement);
                    _targetElementNative = _targetElement[0];
                    _isTextarea = _targetElement.is('textarea');
                    _isBody = _targetElement.is('body');
                    _documentMixed = _documentElementNative !== document;

                    /* On a div Element The if checks only whether:
                     * - the targetElement has the class "os-host"
                     * - the targetElement has a a child with the class "os-padding"
                     * 
                     * If that's the case, its assumed the DOM has already the following structure:
                     * (The ".os-host" element is the targetElement)
                     *
                     *  <div class="os-host">
                     *      <div class="os-resize-observer-host"></div>
                     *      <div class="os-padding">
                     *          <div class="os-viewport">
                     *              <div class="os-content"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-horizontal ">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-vertical">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar-corner"></div>
                     *  </div>
                     *
                     * =====================================================================================
                     * 
                     * On a Textarea Element The if checks only whether:
                     * - the targetElement has the class "os-textarea" 
                     * - the targetElement is inside a element with the class "os-content" 
                     * 
                     * If that's the case, its assumed the DOM has already the following structure:
                     * (The ".os-textarea" (textarea) element is the targetElement)
                     *
                     *  <div class="os-host-textarea">
                     *      <div class="os-resize-observer-host"></div>
                     *      <div class="os-padding os-text-inherit">
                     *          <div class="os-viewport os-text-inherit">
                     *              <div class="os-content os-text-inherit">
                     *                  <div class="os-textarea-cover"></div>
                     *                  <textarea class="os-textarea os-text-inherit"></textarea>
                     *              </div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-horizontal ">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-vertical">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar-corner"></div>
                     *  </div>
                     */
                    _domExists = _isTextarea
                        ? _targetElement.hasClass(_classNameTextareaElement) && _targetElement.parent().hasClass(_classNameContentElement)
                        : _targetElement.hasClass(_classNameHostElement) && _targetElement.children(_strDot + _classNamePaddingElement)[LEXICON.l];

                    var initBodyScroll;
                    var bodyMouseTouchDownListener;

                    //check if the plugin hasn't to be initialized
                    if (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y && !_currentPreparedOptions.nativeScrollbarsOverlaid.initialize) {
                        _initialized = true; // workaround so the onInitializationWithdrawn callback below is fired
                        dispatchCallback('onInitializationWithdrawn');
                        if (_domExists) {
                            setupStructureDOM(true);
                            setupScrollbarsDOM(true);
                            setupScrollbarCornerDOM(true);
                        }

                        _initialized = false;
                        _destroyed = true;
                        _sleeping = true;

                        return _base;
                    }

                    if (_isBody) {
                        initBodyScroll = {};
                        initBodyScroll.l = MATH.max(_targetElement[_strScrollLeft](), _htmlElement[_strScrollLeft](), _windowElement[_strScrollLeft]());
                        initBodyScroll.t = MATH.max(_targetElement[_strScrollTop](), _htmlElement[_strScrollTop](), _windowElement[_strScrollTop]());

                        bodyMouseTouchDownListener = function () {
                            _viewportElement.removeAttr(LEXICON.ti);
                            setupResponsiveEventListener(_viewportElement, _strMouseTouchDownEvent, bodyMouseTouchDownListener, true, true);
                        }
                    }

                    //build OverlayScrollbars DOM
                    setupStructureDOM();
                    setupScrollbarsDOM();
                    setupScrollbarCornerDOM();

                    //create OverlayScrollbars events
                    setupStructureEvents();
                    setupScrollbarEvents(true);
                    setupScrollbarEvents(false);
                    setupScrollbarCornerEvents();

                    //create mutation observers
                    createMutationObservers();

                    //build resize observer for the host element
                    setupResizeObserver(_sizeObserverElement, hostOnResized);

                    if (_isBody) {
                        //apply the body scroll to handle it right in the update method
                        _viewportElement[_strScrollLeft](initBodyScroll.l)[_strScrollTop](initBodyScroll.t);

                        //set the focus on the viewport element so you dont have to click on the page to use keyboard keys (up / down / space) for scrolling
                        if (document.activeElement == targetElement && _viewportElementNative.focus) {
                            //set a tabindex to make the viewportElement focusable
                            _viewportElement.attr(LEXICON.ti, '-1');
                            _viewportElementNative.focus();

                            /* the tabindex has to be removed due to;
                             * If you set the tabindex attribute on an <div>, then its child content cannot be scrolled with the arrow keys unless you set tabindex on the content, too
                             * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
                             */
                            setupResponsiveEventListener(_viewportElement, _strMouseTouchDownEvent, bodyMouseTouchDownListener, false, true);
                        }
                    }

                    //update for the first time & initialize cache
                    _base.update(_strAuto);

                    //the plugin is initialized now!
                    _initialized = true;
                    dispatchCallback('onInitialized');

                    //call all callbacks which would fire before the initialized was complete
                    each(_callbacksInitQeueue, function (index, value) { dispatchCallback(value.n, value.a); });
                    _callbacksInitQeueue = [];

                    //add extensions
                    if (type(extensions) == TYPES.s)
                        extensions = [extensions];
                    if (COMPATIBILITY.isA(extensions))
                        each(extensions, function (index, value) { _base.addExt(value); });
                    else if (FRAMEWORK.isPlainObject(extensions))
                        each(extensions, function (key, value) { _base.addExt(key, value); });

                    //add the transition class for transitions AFTER the first update & AFTER the applied extensions (for preventing unwanted transitions)
                    setTimeout(function () {
                        if (_supportTransition && !_destroyed)
                            addClass(_hostElement, _classNameHostTransition);
                    }, 333);

                    return _base;
                }

                if (_plugin.valid(construct(pluginTargetElement, options, extensions))) {
                    INSTANCES(pluginTargetElement, _base);
                }

                return _base;
            }

            /**
             * Initializes a new OverlayScrollbarsInstance object or changes options if already initialized or returns the current instance.
             * @param pluginTargetElements The elements to which the Plugin shall be initialized.
             * @param options The custom options with which the plugin shall be initialized.
             * @param extensions The extension(s) which shall be added right after initialization.
             * @returns {*}
             */
            _plugin = window[PLUGINNAME] = function (pluginTargetElements, options, extensions) {
                if (arguments[LEXICON.l] === 0)
                    return this;

                var arr = [];
                var optsIsPlainObj = FRAMEWORK.isPlainObject(options);
                var inst;
                var result;

                //pluginTargetElements is null or undefined
                if (!pluginTargetElements)
                    return optsIsPlainObj || !options ? result : arr;

                /*
                   pluginTargetElements will be converted to:
                   1. A jQueryElement Array
                   2. A HTMLElement Array
                   3. A Array with a single HTML Element
                   so pluginTargetElements is always a array.
                */
                pluginTargetElements = pluginTargetElements[LEXICON.l] != undefined ? pluginTargetElements : [pluginTargetElements[0] || pluginTargetElements];
                initOverlayScrollbarsStatics();

                if (pluginTargetElements[LEXICON.l] > 0) {
                    if (optsIsPlainObj) {
                        FRAMEWORK.each(pluginTargetElements, function (i, v) {
                            inst = v;
                            if (inst !== undefined)
                                arr.push(OverlayScrollbarsInstance(inst, options, extensions, _pluginsGlobals, _pluginsAutoUpdateLoop));
                        });
                    }
                    else {
                        FRAMEWORK.each(pluginTargetElements, function (i, v) {
                            inst = INSTANCES(v);
                            if ((options === '!' && _plugin.valid(inst)) || (COMPATIBILITY.type(options) == TYPES.f && options(v, inst)))
                                arr.push(inst);
                            else if (options === undefined)
                                arr.push(inst);
                        });
                    }
                    result = arr[LEXICON.l] === 1 ? arr[0] : arr;
                }
                return result;
            };

            /**
             * Returns a object which contains global information about the plugin and each instance of it.
             * The returned object is just a copy, that means that changes to the returned object won't have any effect to the original object.
             */
            _plugin.globals = function () {
                initOverlayScrollbarsStatics();
                var globals = FRAMEWORK.extend(true, {}, _pluginsGlobals);
                delete globals['msie'];
                return globals;
            };

            /**
             * Gets or Sets the default options for each new plugin initialization.
             * @param newDefaultOptions The object with which the default options shall be extended.
             */
            _plugin.defaultOptions = function (newDefaultOptions) {
                initOverlayScrollbarsStatics();
                var currDefaultOptions = _pluginsGlobals.defaultOptions;
                if (newDefaultOptions === undefined)
                    return FRAMEWORK.extend(true, {}, currDefaultOptions);

                //set the new default options
                _pluginsGlobals.defaultOptions = FRAMEWORK.extend(true, {}, currDefaultOptions, _pluginsOptions._validate(newDefaultOptions, _pluginsOptions._template, true, currDefaultOptions)._default);
            };

            /**
             * Checks whether the passed instance is a non-destroyed OverlayScrollbars instance.
             * @param osInstance The potential OverlayScrollbars instance which shall be checked.
             * @returns {boolean} True if the passed value is a non-destroyed OverlayScrollbars instance, false otherwise.
             */
            _plugin.valid = function (osInstance) {
                return osInstance instanceof _plugin && !osInstance.getState().destroyed;
            };

            /**
             * Registers, Unregisters or returns a extension.
             * Register: Pass the name and the extension. (defaultOptions is optional)
             * Unregister: Pass the name and anything except a function as extension parameter.
             * Get extension: Pass the name of the extension which shall be got.
             * Get all extensions: Pass no arguments.
             * @param extensionName The name of the extension which shall be registered, unregistered or returned.
             * @param extension A function which generates the instance of the extension or anything other to remove a already registered extension.
             * @param defaultOptions The default options which shall be used for the registered extension.
             */
            _plugin.extension = function (extensionName, extension, defaultOptions) {
                var extNameTypeString = COMPATIBILITY.type(extensionName) == TYPES.s;
                var argLen = arguments[LEXICON.l];
                var i = 0;
                if (argLen < 1 || !extNameTypeString) {
                    //return a copy of all extension objects
                    return FRAMEWORK.extend(true, { length: _pluginsExtensions[LEXICON.l] }, _pluginsExtensions);
                }
                else if (extNameTypeString) {
                    if (COMPATIBILITY.type(extension) == TYPES.f) {
                        //register extension
                        _pluginsExtensions.push({
                            name: extensionName,
                            extensionFactory: extension,
                            defaultOptions: defaultOptions
                        });
                    }
                    else {
                        for (; i < _pluginsExtensions[LEXICON.l]; i++) {
                            if (_pluginsExtensions[i].name === extensionName) {
                                if (argLen > 1)
                                    _pluginsExtensions.splice(i, 1); //remove extension
                                else
                                    return FRAMEWORK.extend(true, {}, _pluginsExtensions[i]); //return extension with the given name
                            }
                        }
                    }
                }
            };

            return _plugin;
        })();

        if (JQUERY && JQUERY.fn) {
            /**
             * The jQuery initialization interface.
             * @param options The initial options for the construction of the plugin. To initialize the plugin, this option has to be a object! If it isn't a object, the instance(s) are returned and the plugin wont be initialized.
             * @param extensions The extension(s) which shall be added right after initialization.
             * @returns {*} After initialization it returns the jQuery element array, else it returns the instance(s) of the elements which are selected.
             */
            JQUERY.fn.overlayScrollbars = function (options, extensions) {
                var _elements = this;
                if (JQUERY.isPlainObject(options)) {
                    JQUERY.each(_elements, function () { PLUGIN(this, options, extensions); });
                    return _elements;
                }
                else
                    return PLUGIN(_elements, options);
            };
        }
        return PLUGIN;
    }
));

/***/ }),

/***/ 80341:
/***/ (function(module) {

"use strict";


class CancelError extends Error {
	constructor(reason) {
		super(reason || 'Promise was canceled');
		this.name = 'CancelError';
	}

	get isCanceled() {
		return true;
	}
}

class PCancelable {
	static fn(userFn) {
		return (...arguments_) => {
			return new PCancelable((resolve, reject, onCancel) => {
				arguments_.push(onCancel);
				// eslint-disable-next-line promise/prefer-await-to-then
				userFn(...arguments_).then(resolve, reject);
			});
		};
	}

	constructor(executor) {
		this._cancelHandlers = [];
		this._isPending = true;
		this._isCanceled = false;
		this._rejectOnCancel = true;

		this._promise = new Promise((resolve, reject) => {
			this._reject = reject;

			const onResolve = value => {
				if (!this._isCanceled || !onCancel.shouldReject) {
					this._isPending = false;
					resolve(value);
				}
			};

			const onReject = error => {
				this._isPending = false;
				reject(error);
			};

			const onCancel = handler => {
				if (!this._isPending) {
					throw new Error('The `onCancel` handler was attached after the promise settled.');
				}

				this._cancelHandlers.push(handler);
			};

			Object.defineProperties(onCancel, {
				shouldReject: {
					get: () => this._rejectOnCancel,
					set: boolean => {
						this._rejectOnCancel = boolean;
					}
				}
			});

			return executor(onResolve, onReject, onCancel);
		});
	}

	then(onFulfilled, onRejected) {
		// eslint-disable-next-line promise/prefer-await-to-then
		return this._promise.then(onFulfilled, onRejected);
	}

	catch(onRejected) {
		return this._promise.catch(onRejected);
	}

	finally(onFinally) {
		return this._promise.finally(onFinally);
	}

	cancel(reason) {
		if (!this._isPending || this._isCanceled) {
			return;
		}

		this._isCanceled = true;

		if (this._cancelHandlers.length > 0) {
			try {
				for (const handler of this._cancelHandlers) {
					handler();
				}
			} catch (error) {
				this._reject(error);
				return;
			}
		}

		if (this._rejectOnCancel) {
			this._reject(new CancelError(reason));
		}
	}

	get isCanceled() {
		return this._isCanceled;
	}
}

Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);

module.exports = PCancelable;
module.exports.CancelError = CancelError;


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 3655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mode = __webpack_require__(32792);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),

/***/ 27321:
/***/ (function(module) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),

/***/ 49381:
/***/ (function(module) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),

/***/ 32832:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var math = __webpack_require__(11518);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),

/***/ 14450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var BitByte = __webpack_require__(3655);
var RSBlock = __webpack_require__(17611);
var BitBuffer = __webpack_require__(27321);
var util = __webpack_require__(93160);
var Polynomial = __webpack_require__(32832);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),

/***/ 17611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(49381);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),

/***/ 11518:
/***/ (function(module) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),

/***/ 32792:
/***/ (function(module) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),

/***/ 93160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Mode = __webpack_require__(32792);
var Polynomial = __webpack_require__(32832);
var math = __webpack_require__(11518);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    var keys = [];

    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = parent;
    }

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;

        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = segment[1];
    }

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }

    return keys;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);
var getSideChannel = __webpack_require__(37478);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) {
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) {
                return [target, source];
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, getMaxIndex(source));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = { obj: obj, prop: key };
                refs[refs.length] = val;
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 97893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){if(true)module.exports=t(__webpack_require__(67294));else { var r, n; }}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=4)}([function(e,t,n){e.exports=n(2)()},function(t,n){t.exports=e},function(e,t,n){"use strict";var r=n(3);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,s){if(s!==r){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var n={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";n.r(t);var r=n(1),o=n.n(r),i=n(0),s=n.n(i),a=function(e){return 0!==e};function l(){return(l=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function c(e){return(c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function u(e,t){return(u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function g(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=d(e);if(t){var o=d(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){if(t&&("object"===c(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return h(e)}function h(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function b(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var m=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&u(e,t)}(s,e);var t,n,r,i=g(s);function s(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),b(h(t=i.call(this,e)),"continueOpenCollapsible",(function(){var e=h(t).innerRef;t.setState({height:e.scrollHeight,transition:"height ".concat(t.props.transitionTime,"ms ").concat(t.props.easing),isClosed:!1,hasBeenOpened:!0,inTransition:a(e.scrollHeight),shouldOpenOnNextCycle:!1})})),b(h(t),"handleTriggerClick",(function(e){t.props.triggerDisabled||t.state.inTransition||(e.preventDefault(),t.props.handleTriggerClick?t.props.handleTriggerClick(t.props.accordionPosition):!0===t.state.isClosed?(t.openCollapsible(),t.props.onOpening(),t.props.onTriggerOpening()):(t.closeCollapsible(),t.props.onClosing(),t.props.onTriggerClosing()))})),b(h(t),"handleTransitionEnd",(function(e){e.target===t.innerRef&&(t.state.isClosed?(t.setState({inTransition:!1}),t.props.onClose()):(t.setState({height:"auto",overflow:t.props.overflowWhenOpen,inTransition:!1}),t.props.onOpen()))})),b(h(t),"setInnerRef",(function(e){return t.innerRef=e})),t.timeout=void 0,t.contentId=e.contentElementId||"collapsible-content-".concat(Date.now()),t.triggerId=e.triggerElementProps.id||"collapsible-trigger-".concat(Date.now()),e.open?t.state={isClosed:!1,shouldSwitchAutoOnNextCycle:!1,height:"auto",transition:"none",hasBeenOpened:!0,overflow:e.overflowWhenOpen,inTransition:!1}:t.state={isClosed:!0,shouldSwitchAutoOnNextCycle:!1,height:0,transition:"height ".concat(e.transitionTime,"ms ").concat(e.easing),hasBeenOpened:!1,overflow:"hidden",inTransition:!1},t}return t=s,(n=[{key:"componentDidUpdate",value:function(e,t){var n=this;this.state.shouldOpenOnNextCycle&&this.continueOpenCollapsible(),"auto"!==t.height&&0!==t.height||!0!==this.state.shouldSwitchAutoOnNextCycle||(window.clearTimeout(this.timeout),this.timeout=window.setTimeout((function(){n.setState({height:0,overflow:"hidden",isClosed:!0,shouldSwitchAutoOnNextCycle:!1})}),50)),e.open!==this.props.open&&(!0===this.props.open?(this.openCollapsible(),this.props.onOpening()):(this.closeCollapsible(),this.props.onClosing()))}},{key:"componentWillUnmount",value:function(){window.clearTimeout(this.timeout)}},{key:"closeCollapsible",value:function(){var e=this.innerRef;this.setState({shouldSwitchAutoOnNextCycle:!0,height:e.scrollHeight,transition:"height ".concat(this.props.transitionCloseTime?this.props.transitionCloseTime:this.props.transitionTime,"ms ").concat(this.props.easing),inTransition:a(e.scrollHeight)})}},{key:"openCollapsible",value:function(){this.setState({inTransition:a(this.innerRef.scrollHeight),shouldOpenOnNextCycle:!0})}},{key:"renderNonClickableTriggerElement",value:function(){var e=this.props,t=e.triggerSibling,n=e.classParentString;if(!t)return null;switch(c(t)){case"string":return o.a.createElement("span",{className:"".concat(n,"__trigger-sibling")},t);case"function":return t();case"object":return t;default:return null}}},{key:"render",value:function(){var e=this,t={height:this.state.height,WebkitTransition:this.state.transition,msTransition:this.state.transition,transition:this.state.transition,overflow:this.state.overflow},n=this.state.isClosed?"is-closed":"is-open",r=this.props.triggerDisabled?"is-disabled":"",i=!1===this.state.isClosed&&void 0!==this.props.triggerWhenOpen?this.props.triggerWhenOpen:this.props.trigger,s=this.props.contentContainerTagName,a=this.props.triggerTagName,c=this.props.lazyRender&&!this.state.hasBeenOpened&&this.state.isClosed&&!this.state.inTransition?null:this.props.children,p=this.props,u=p.classParentString,g=p.contentOuterClassName,f=p.contentInnerClassName,h="".concat(u,"__trigger ").concat(n," ").concat(r," ").concat(this.state.isClosed?this.props.triggerClassName:this.props.triggerOpenedClassName),d="".concat(u," ").concat(this.state.isClosed?this.props.className:this.props.openedClassName),b="".concat(u,"__contentOuter ").concat(g),m="".concat(u,"__contentInner ").concat(f);return o.a.createElement(s,l({className:d.trim()},this.props.containerElementProps),o.a.createElement(a,l({id:this.triggerId,className:h.trim(),onClick:this.handleTriggerClick,style:this.props.triggerStyle&&this.props.triggerStyle,onKeyPress:function(t){var n=t.key;(" "===n&&"button"!==e.props.triggerTagName.toLowerCase()||"Enter"===n)&&e.handleTriggerClick(t)},tabIndex:this.props.tabIndex&&this.props.tabIndex,"aria-expanded":!this.state.isClosed,"aria-disabled":this.props.triggerDisabled,"aria-controls":this.contentId,role:"button"},this.props.triggerElementProps),i),this.renderNonClickableTriggerElement(),o.a.createElement("div",{id:this.contentId,className:b.trim(),style:t,onTransitionEnd:this.handleTransitionEnd,ref:this.setInnerRef,hidden:this.props.contentHiddenWhenClosed&&this.state.isClosed&&!this.state.inTransition,role:"region","aria-labelledby":this.triggerId},o.a.createElement("div",{className:m.trim()},c)))}}])&&p(t.prototype,n),r&&p(t,r),Object.defineProperty(t,"prototype",{writable:!1}),s}(r.Component);m.propTypes={transitionTime:s.a.number,transitionCloseTime:s.a.number,triggerTagName:s.a.string,easing:s.a.string,open:s.a.bool,containerElementProps:s.a.object,triggerElementProps:s.a.object,contentElementId:s.a.string,classParentString:s.a.string,className:s.a.string,openedClassName:s.a.string,triggerStyle:s.a.object,triggerClassName:s.a.string,triggerOpenedClassName:s.a.string,contentOuterClassName:s.a.string,contentInnerClassName:s.a.string,accordionPosition:s.a.oneOfType([s.a.string,s.a.number]),handleTriggerClick:s.a.func,onOpen:s.a.func,onClose:s.a.func,onOpening:s.a.func,onClosing:s.a.func,onTriggerOpening:s.a.func,onTriggerClosing:s.a.func,trigger:s.a.oneOfType([s.a.string,s.a.element]),triggerWhenOpen:s.a.oneOfType([s.a.string,s.a.element]),triggerDisabled:s.a.bool,lazyRender:s.a.bool,overflowWhenOpen:s.a.oneOf(["hidden","visible","auto","scroll","inherit","initial","unset"]),contentHiddenWhenClosed:s.a.bool,triggerSibling:s.a.oneOfType([s.a.string,s.a.element,s.a.func]),tabIndex:s.a.number,contentContainerTagName:s.a.string,children:s.a.oneOfType([s.a.string,s.a.element])},m.defaultProps={transitionTime:400,transitionCloseTime:null,triggerTagName:"span",easing:"linear",open:!1,classParentString:"Collapsible",triggerDisabled:!1,lazyRender:!1,overflowWhenOpen:"hidden",contentHiddenWhenClosed:!1,openedClassName:"",triggerStyle:null,triggerClassName:"",triggerOpenedClassName:"",contentOuterClassName:"",contentInnerClassName:"",className:"",triggerSibling:null,onOpen:function(){},onClose:function(){},onOpening:function(){},onClosing:function(){},onTriggerOpening:function(){},onTriggerClosing:function(){},tabIndex:null,contentContainerTagName:"div",triggerElementProps:{}};t.default=m}])}));

/***/ }),

/***/ 85518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(60335);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
exports.I3 = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
__webpack_unused_export__ = browserName;
__webpack_unused_export__ = browserVersion;
__webpack_unused_export__ = deviceDetect;
__webpack_unused_export__ = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
__webpack_unused_export__ = isAndroid;
__webpack_unused_export__ = isBrowser;
__webpack_unused_export__ = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
__webpack_unused_export__ = isDesktop;
__webpack_unused_export__ = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
__webpack_unused_export__ = isFirefox;
__webpack_unused_export__ = isIE;
exports.gn = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
__webpack_unused_export__ = isMacOs;
exports.tq = isMobile;
__webpack_unused_export__ = isMobileOnly;
__webpack_unused_export__ = isMobileSafari;
__webpack_unused_export__ = isOpera;
exports.G6 = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
exports.Em = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
__webpack_unused_export__ = osName;
__webpack_unused_export__ = osVersion;
__webpack_unused_export__ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
exports.Qe = withOrientationChange;


/***/ }),

/***/ 60335:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.41",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HONOR="Honor",HUAWEI="Huawei",LENOVO="Lenovo",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",NVIDIA="Nvidia",ONEPLUS="OnePlus",OPERA="Opera",OPPO="OPPO",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/(daum)apps[\/ ]([\w\.]+)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/\b(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i,/\b((i[346]|x)86)(pc)?\b/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],[[ARCHITECTURE,"arm"]],[/((ppc|powerpc)(64)?)( mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/ sun4\w[;\)]/i],[[ARCHITECTURE,"sparc"]],[/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],[MODEL,[VENDOR,HONOR],[TYPE,TABLET]],[/honor([-\w ]+)[;\)]/i],[MODEL,[VENDOR,HONOR],[TYPE,MOBILE]],[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,/\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,/ ([\w ]+) miui\/v?\d/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,OPPO],[TYPE,MOBILE]],[/\b(opd2(\d{3}a?))(?: bui|\))/i],[MODEL,[VENDOR,strMapper,{OnePlus:["304","403","203"],"*":OPPO}],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,/lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],[MODEL,[VENDOR,LENOVO],[TYPE,TABLET]],[/(nokia) (t[12][01])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,/nokia[-_ ]?(([-\w\. ]*))/i],[[MODEL,/_/g," "],[TYPE,MOBILE],[VENDOR,"Nokia"]],[/(pixel (c|tablet))\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,/archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,TABLET]],[/archos ([\w ]+)( b|\))/i,/; (ac[3-6]\d\w{2,8})( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(infinix) (x1101b?)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (hmd|imo) ([\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/(shield \w+ tv)/i],[MODEL,[VENDOR,NVIDIA],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mi(tv|box)-?\w+) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],[MODEL,[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield)( bui|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,CONSOLE]],[/(playstation \w+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i,/(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(ow(?:19|20)?we?[1-3]{1,3})/i],[MODEL,[VENDOR,OPPO],[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/(opwwe\d{3})/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,WEARABLE]],[/(moto 360)/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,WEARABLE]],[/(smartwatch 3)/i],[MODEL,[VENDOR,SONY],[TYPE,WEARABLE]],[/(g watch r)/i],[MODEL,[VENDOR,LG],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/(homepod).+mac os/i],[MODEL,[VENDOR,APPLE],[TYPE,EMBEDDED]],[/windows iot/i],[[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/droid .+?; ([\w\. -]+)( bui|\))/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/ladybird\//i],[[NAME,"LibWeb"]],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(ubuntu) ([\w\.]+) like android/i],[[NAME,/(.+)/,"$1 Touch"],VERSION],[/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 96120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*! For license information please see ReactCrop.min.js.LICENSE.txt */
!function(e,t){ true?module.exports=t(__webpack_require__(67294)):0}(this,(function(e){return(()=>{"use strict";var t={418:e=>{var t=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable;function o(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},r=0;r<10;r++)t["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(t).map((function(e){return t[e]})).join(""))return!1;var i={};return"abcdefghijklmnopqrst".split("").forEach((function(e){i[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},i)).join("")}catch(e){return!1}}()?Object.assign:function(e,n){for(var s,a,h=o(e),d=1;d<arguments.length;d++){for(var c in s=Object(arguments[d]))r.call(s,c)&&(h[c]=s[c]);if(t){a=t(s);for(var p=0;p<a.length;p++)i.call(s,a[p])&&(h[a[p]]=s[a[p]])}}return h}},251:(e,t,r)=>{r(418);var i=r(899),o=60103;if(t.Fragment=60107,"function"==typeof Symbol&&Symbol.for){var n=Symbol.for;o=n("react.element"),t.Fragment=n("react.fragment")}var s=i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,a=Object.prototype.hasOwnProperty,h={key:!0,ref:!0,__self:!0,__source:!0};function d(e,t,r){var i,n={},d=null,c=null;for(i in void 0!==r&&(d=""+r),void 0!==t.key&&(d=""+t.key),void 0!==t.ref&&(c=t.ref),t)a.call(t,i)&&!h.hasOwnProperty(i)&&(n[i]=t[i]);if(e&&e.defaultProps)for(i in t=e.defaultProps)void 0===n[i]&&(n[i]=t[i]);return{$$typeof:o,type:e,key:d,ref:c,props:n,_owner:s.current}}t.jsx=d,t.jsxs=d},893:(e,t,r)=>{e.exports=r(251)},899:t=>{t.exports=e}},r={};function i(e){var o=r[e];if(void 0!==o)return o.exports;var n=r[e]={exports:{}};return t[e](n,n.exports,i),n.exports}i.d=(e,t)=>{for(var r in t)i.o(t,r)&&!i.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},i.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),i.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{i.r(o),i.d(o,{Component:()=>f,areCropsEqual:()=>h,clamp:()=>s,convertToPercentCrop:()=>c,convertToPixelCrop:()=>p,default:()=>f,defaultCrop:()=>n,getMaxCrop:()=>g,getMinCrop:()=>w,isCropValid:()=>a,makeAspectCrop:()=>d,resolveCrop:()=>l});var e=i(893),t=i(899);function r(e){var t,i,o="";if("string"==typeof e||"number"==typeof e)o+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(i=r(e[t]))&&(o&&(o+=" "),o+=i);else for(t in e)e[t]&&(o&&(o+=" "),o+=t);return o}const n={x:0,y:0,width:0,height:0,unit:"px"};function s(e,t,r){return Math.min(Math.max(e,t),r)}function a(e){return e&&e.width&&!isNaN(e.width)&&e.height&&!isNaN(e.height)}function h(e,t){return e.width===t.width&&e.height===t.height&&e.x===t.x&&e.y===t.y&&e.aspect===t.aspect&&e.unit===t.unit}function d(e,t,r){if(!e.aspect||isNaN(e.aspect))return console.error("`crop.aspect` should be a number.",e),{...n,...e};const i={unit:"px",x:e.x||0,y:e.y||0,width:e.width||0,height:e.height||0,aspect:e.aspect};return e.width&&(i.height=i.width/e.aspect),e.height&&(i.width=i.height*e.aspect),i.y+i.height>r&&(i.height=r-i.y,i.width=i.height*e.aspect),i.x+i.width>t&&(i.width=t-i.x,i.height=i.width/e.aspect),i}function c(e,t,r){return"%"===e.unit?{...n,...e}:{unit:"%",aspect:e.aspect,x:e.x?e.x/t*100:0,y:e.y?e.y/r*100:0,width:e.width?e.width/t*100:0,height:e.height?e.height/r*100:0}}function p(e,t,r){return e.unit?"px"===e.unit?{...n,...e}:{unit:"px",aspect:e.aspect,x:e.x?e.x*t/100:0,y:e.y?e.y*r/100:0,width:e.width?e.width*t/100:0,height:e.height?e.height*r/100:0}:{...n,...e,unit:"px"}}function l(e,t,r){return!e.aspect||e.width&&e.height?e:d(e,t,r)}function w(e,t,r=0,i=0){const o={...e};return o.aspect?r<i?(o.width=r,o.height=o.width/o.aspect):(o.width=i*o.aspect,o.height=i):(o.width=r,o.height=i),"n"===t||"ne"===t?o.y+=e.height-o.height:"sw"===t?o.x+=e.width-o.width:"nw"===t?(o.x+=e.width-o.width,o.y+=e.height-o.height):"w"===t&&(o.x+=e.width-o.width),o}function g(e,t,r,i,o=r,n=i){const s={...e},a=()=>Math.min(o,s.x+s.width),h=()=>Math.min(n,s.y+s.height),d=()=>Math.min(o,r-s.x),c=()=>Math.min(n,i-s.y);if(s.aspect){let r=0,i=0;"ne"===t?(r=d(),i=h()):"se"===t?(r=d(),i=c()):"sw"===t?(r=a(),i=c()):"nw"===t&&(r=a(),i=h());const o=r/s.width,n=i/s.height,p=Math.min(o,n),l=s.width*p,w=l/s.aspect;"ne"===t?s.y=s.y+(e.height-w):"sw"===t?s.x=s.x+(e.width-l):"nw"===t&&(s.x=s.x+(e.width-l),s.y=s.y+(e.height-w)),s.width=l,s.height=w}else if("n"===t){const e=h();s.y-=e-s.height,s.height=e}else if("ne"===t){const e=h();s.y-=e-s.height,s.height=e,s.width=d()}else if("e"===t)s.width=d();else if("se"===t)s.width=d(),s.height=c();else if("s"===t)s.height=c();else if("sw"===t){const e=a();s.x-=e-s.width,s.width=e,s.height=c()}else if("w"===t){const e=a();s.x-=e-s.width,s.width=e}else if("nw"===t){const e=h();s.y-=e-s.height,s.height=e;const t=a();s.x-=t-s.width,s.width=t}return s}const u={capture:!0,passive:!1};class f extends t.PureComponent{constructor(){super(...arguments),this.keysDown=new Set,this.docMoveBound=!1,this.mouseDownOnCrop=!1,this.dragStarted=!1,this.evData={clientStartX:0,clientStartY:0,cropStartWidth:0,cropStartHeight:0,cropStartX:0,cropStartY:0,xDiff:0,yDiff:0,xInversed:!1,yInversed:!1,xCrossOver:!1,yCrossOver:!1,lastYCrossover:!1,startXCrossOver:!1,startYCrossOver:!1,isResize:!0,ord:"nw"},this.componentRef=(0,t.createRef)(),this.mediaWrapperRef=(0,t.createRef)(),this.imageRef=(0,t.createRef)(),this.cropSelectRef=(0,t.createRef)(),this.state={cropIsActive:!1,newCropIsBeingDrawn:!1},this.onCropPointerDown=e=>{const{crop:t,disabled:r}=this.props,{width:i,height:o}=this.mediaDimensions,n=p(t,i,o);if(r)return;e.cancelable&&e.preventDefault(),this.bindDocMove(),this.componentRef.current.focus({preventScroll:!0});const{ord:s}=e.target.dataset,a="nw"===s||"w"===s||"sw"===s,h="nw"===s||"n"===s||"ne"===s;this.evData={clientStartX:e.clientX,clientStartY:e.clientY,cropStartWidth:n.width,cropStartHeight:n.height,cropStartX:a?n.x+n.width:n.x,cropStartY:h?n.y+n.height:n.y,xDiff:0,yDiff:0,xInversed:a,yInversed:h,xCrossOver:a,yCrossOver:h,lastYCrossover:h,startXCrossOver:a,startYCrossOver:h,isResize:Boolean(s),ord:s||"ne"},this.mouseDownOnCrop=!0,this.setState({cropIsActive:!0})},this.onComponentPointerDown=e=>{const{crop:t,disabled:r,locked:i,keepSelection:o,onChange:n,zoom:s=1,spin:h=0}=this.props,d=this.mediaWrapperRef.current.firstChild;if(e.target!==d||!d.contains(e.target))return;if(r||i||o&&a(t))return;e.cancelable&&e.preventDefault(),this.bindDocMove(),this.componentRef.current.focus({preventScroll:!0});const l=this.mediaWrapperRef.current.getBoundingClientRect();let w=0,g=0,u=(e.clientX-l.left)/s,f=(e.clientY-l.top)/s,y=h,m=Math.abs(y*Math.PI/180);y>-45&&y<=45||Math.abs(y)>135&&Math.abs(y)<=180?(w=u*Math.cos(m),g=f*Math.cos(m)):y>45&&y<=135?(w=f*Math.sin(m),g=u*Math.sin(m)*-1):y>-135&&y<=-45&&(w=f*Math.sin(m)*-1,g=u*Math.sin(m));const v={unit:"px",aspect:t?t.aspect:void 0,x:w,y:g,width:0,height:0},{width:x,height:C}=this.mediaDimensions;this.evData={clientStartX:e.clientX,clientStartY:e.clientY,cropStartWidth:v.width,cropStartHeight:v.height,cropStartX:v.x,cropStartY:v.y,xDiff:0,yDiff:0,xInversed:!1,yInversed:!1,xCrossOver:!1,yCrossOver:!1,lastYCrossover:!1,startXCrossOver:!1,startYCrossOver:!1,isResize:!0,ord:"nw"},this.mouseDownOnCrop=!0,n(p(v,x,C),c(v,x,C)),this.setState({cropIsActive:!0,newCropIsBeingDrawn:!0})},this.onDocPointerMove=e=>{const{crop:t,disabled:r,onChange:i,onDragStart:o,zoom:n=1,spin:s=0}=this.props;if(r)return;if(!this.mouseDownOnCrop)return;e.cancelable&&e.preventDefault(),this.dragStarted||(this.dragStarted=!0,o&&o(e));const{evData:a}=this;let h,d=(e.clientX-a.clientStartX)/n,l=(e.clientY-a.clientStartY)/n,w=s,g=Math.abs(w*Math.PI/180);if(w>-45&&w<=45||Math.abs(w)>135&&Math.abs(w)<=180?(a.xDiff=d*Math.cos(g),a.yDiff=l*Math.cos(g)):w>45&&w<=135?(a.xDiff=l*Math.sin(g),a.yDiff=d*Math.sin(g)*-1):w>-135&&w<=-45&&(a.xDiff=l*Math.sin(g)*-1,a.yDiff=d*Math.sin(g)),h=a.isResize?this.resizeCrop():this.dragCrop(),h!==t){const{width:e,height:t}=this.mediaDimensions;i(p(h,e,t),c(h,e,t))}},this.onComponentKeyDown=e=>{const{crop:t,disabled:r,onChange:i,onComplete:o}=this.props;if(r)return;this.keysDown.add(e.key);let n=!1;if(!a(t))return;const h=this.makeNewCrop(),d=(navigator.platform.match("Mac")?e.metaKey:e.ctrlKey)?f.nudgeStepLarge:e.shiftKey?f.nudgeStepMedium:f.nudgeStep;if(this.keysDown.has("ArrowLeft")&&(h.x-=d,n=!0),this.keysDown.has("ArrowRight")&&(h.x+=d,n=!0),this.keysDown.has("ArrowUp")&&(h.y-=d,n=!0),this.keysDown.has("ArrowDown")&&(h.y+=d,n=!0),n){e.cancelable&&e.preventDefault();const{width:t,height:r}=this.mediaDimensions;h.x=s(h.x,0,t-h.width),h.y=s(h.y,0,r-h.height);const n=p(h,t,r),a=c(h,t,r);i(n,a),o&&o(n,a)}},this.onHandlerKeyDown=(e,t)=>{const{crop:r,disabled:i,minWidth:o,minHeight:n,maxWidth:s,maxHeight:d,onChange:l,onComplete:u}=this.props,{width:y,height:m}=this.mediaDimensions;if(i)return;if(!a(r))return;if("ArrowUp"!==e.key&&"ArrowDown"!==e.key&&"ArrowLeft"!==e.key&&"ArrowRight"!==e.key)return;e.stopPropagation(),e.preventDefault();const v=p(r,y,m),x=g(v,t,y,m,s,d),C=w(v,t,o,n),D=(navigator.platform.match("Mac")?e.metaKey:e.ctrlKey)?f.nudgeStepLarge:e.shiftKey?f.nudgeStepMedium:f.nudgeStep;let b=!1,S=!1;if("ArrowLeft"===e.key?"nw"===t||"w"===t||"sw"===t?(b=!0,v.x=Math.max(x.x,v.x-D),v.width=Math.min(x.width,v.width+D)):"ne"!==t&&"e"!==t&&"se"!==t||(b=!0,v.width=Math.max(C.width,v.width-D)):"ArrowRight"===e.key&&("nw"===t||"w"===t||"sw"===t?(b=!0,v.x=Math.min(C.x,v.x+D),v.width=Math.max(C.width,v.width-D)):"ne"!==t&&"e"!==t&&"se"!==t||(b=!0,v.width=Math.min(x.width,v.width+D))),"ArrowUp"===e.key?"nw"===t||"n"===t||"ne"===t?(S=!0,v.y=Math.max(x.y,Math.max(0,v.y-D)),v.height=Math.min(x.height,v.height+D)):"sw"!==t&&"s"!==t&&"se"!==t||(S=!0,v.height=Math.max(C.height,v.height-D)):"ArrowDown"===e.key&&("nw"===t||"n"===t||"ne"===t?(S=!0,v.y=Math.min(C.y,v.y+D),v.height=Math.max(C.height,v.height-D)):"sw"!==t&&"s"!==t&&"se"!==t||(S=!0,v.height=Math.min(x.height,v.height+D))),v.aspect)if(b)v.height=v.width/v.aspect;else if(S){const e=v.width;v.width=v.height*v.aspect,"nw"!==t&&"sw"!==t||(v.x-=v.width-e)}if(!h(r,v)){const e=c(v,y,m);l(v,e),u&&u(v,e)}},this.onComponentKeyUp=e=>{this.keysDown.delete(e.key)},this.onDocPointerDone=e=>{const{crop:t,disabled:r,onComplete:i,onDragEnd:o}=this.props;if(this.unbindDocMove(),!r&&this.mouseDownOnCrop){this.mouseDownOnCrop=!1,this.dragStarted=!1;const{width:r,height:n}=this.mediaDimensions;o&&o(e),i&&i(p(t,r,n),c(t,r,n)),this.setState({cropIsActive:!1,newCropIsBeingDrawn:!1})}},this.onMediaLoaded=()=>{const{onComplete:e,onChange:t}=this.props,{pixelCrop:r,percentCrop:i}=this.createNewCrop();t(r,i),e&&e(r,i)},this.onImageLoad=e=>{const{onComplete:t,onChange:r,onImageLoaded:i}=this.props;if(!1!==(!i||i(e.currentTarget))){const{pixelCrop:e,percentCrop:i}=this.createNewCrop();r(e,i),t&&t(e,i)}}}componentDidMount(){this.componentRef.current&&this.componentRef.current.addEventListener("medialoaded",this.onMediaLoaded)}componentWillUnmount(){this.componentRef.current&&this.componentRef.current.removeEventListener("medialoaded",this.onMediaLoaded)}componentDidUpdate(e){const{crop:t,onChange:r,onComplete:i}=this.props;if(this.imageRef.current&&t&&e.crop!==t&&t.aspect&&(t.width&&!t.height||!t.width&&t.height)){const{width:e,height:t}=this.imageRef.current,o=d(this.makeNewCrop(),e,t),n=p(o,e,t),s=c(o,e,t);r(n,s),i&&i(n,s)}}bindDocMove(){this.docMoveBound||(document.addEventListener("pointermove",this.onDocPointerMove,u),document.addEventListener("pointerup",this.onDocPointerDone,u),document.addEventListener("pointercancel",this.onDocPointerDone,u),this.docMoveBound=!0)}unbindDocMove(){this.docMoveBound&&(document.removeEventListener("pointermove",this.onDocPointerMove,u),document.removeEventListener("pointerup",this.onDocPointerDone,u),document.removeEventListener("pointercancel",this.onDocPointerDone,u),this.docMoveBound=!1)}createNewCrop(){const{width:e,height:t}=this.mediaDimensions,r=l(this.makeNewCrop(),e,t);return{pixelCrop:p(r,e,t),percentCrop:c(r,e,t)}}get mediaDimensions(){const e=this.mediaWrapperRef.current;if(e){const{width:t,height:r}=e.getBoundingClientRect();return{width:t,height:r}}return{width:0,height:0}}getCropStyle(){const e=this.makeNewCrop(this.props.crop?this.props.crop.unit:"px");return{top:`${e.y}${e.unit}`,left:`${e.x}${e.unit}`,width:`${e.width}${e.unit}`,height:`${e.height}${e.unit}`}}getNewSize(){const{crop:e,minWidth:t=0,maxWidth:r,minHeight:i=0,maxHeight:o}=this.props,{evData:n}=this,{width:a,height:h}=this.mediaDimensions;let d,c=n.cropStartWidth+n.xDiff;return n.xCrossOver&&(c=Math.abs(c)),c=s(c,t,r||a),d=e.aspect?c/e.aspect:n.cropStartHeight+n.yDiff,n.yCrossOver&&(d=Math.min(Math.abs(d),n.cropStartY)),d=s(d,i,o||h),e.aspect&&(c=s(d*e.aspect,0,a)),{width:c,height:d}}dragCrop(){const e=this.makeNewCrop(),{evData:t}=this,{width:r,height:i}=this.mediaDimensions;return e.x=s(t.cropStartX+t.xDiff,0,r-e.width),e.y=s(t.cropStartY+t.yDiff,0,i-e.height),e}resizeCrop(){const{evData:e}=this,{crop:t,minWidth:r=0,minHeight:i=0}=this.props,o=this.makeNewCrop(),{ord:n}=e;e.xInversed&&(e.xDiff-=2*e.cropStartWidth),e.yInversed&&(e.yDiff-=2*e.cropStartHeight);const s=this.getNewSize();let a=e.cropStartX,h=e.cropStartY;e.xCrossOver&&(a=o.x+(o.width-s.width)),e.yCrossOver&&(h=!1===e.lastYCrossover?o.y-s.height:o.y+(o.height-s.height));const{width:d,height:c}=this.mediaDimensions,l=function(e,t,r,i){const o=p(t,r,i),n=p(e,r,i);return o.aspect?(o.x<0?(o.width=o.x+o.width,o.x=0,o.height=o.width/o.aspect):o.x+o.width>r&&(o.width=r-o.x,o.height=o.width/o.aspect),n.y>o.y&&(o.x+o.width>=r||o.x<=0)&&(o.height+=n.height-o.height,o.y=n.y),o.y<0?(o.height=o.y+o.height,o.y=0,o.width=o.height*o.aspect):o.y+o.height>i&&(o.height=i-o.y,o.width=o.height*o.aspect),o.x<n.x&&o.y+o.height>=i&&(o.width+=n.width-o.width,o.x=n.x),o):(o.x<0?(o.width+=o.x,o.x=0):o.x+o.width>r&&(o.width=r-o.x),o.y+o.height>i&&(o.height=i-o.y),o)}(this.props.crop,{unit:o.unit,x:a,y:h,width:s.width,height:s.height,aspect:o.aspect},d,c);return o.aspect||f.xyOrds.indexOf(n)>-1?(o.x=l.x,o.y=l.y,o.width=l.width,o.height=l.height):f.xOrds.indexOf(n)>-1?(o.x=l.x,o.width=l.width):f.yOrds.indexOf(n)>-1&&(o.y=l.y,o.height=l.height),e.lastYCrossover=e.yCrossOver,this.crossOverCheck(),o.width<r||o.height<i?t:o}getRotatedCursor(e,t){if(t>-135&&t<=-45||t>45&&t<=135)switch(e){case"nw":return{cursor:"ne-resize"};case"n":return{cursor:"w-resize"};case"ne":return{cursor:"nw-resize"};case"e":return{cursor:"s-resize"};case"se":return{cursor:"sw-resize"};case"s":return{cursor:"e-resize"};case"sw":return{cursor:"se-resize"};case"w":return{cursor:"n-resize"}}}createCropSelection(){const{ariaLabels:t,disabled:r,locked:i,renderSelectionAddon:o,ruleOfThirds:n,crop:s,spin:h=0}=this.props,d=this.getCropStyle();return(0,e.jsxs)("div",{style:d,className:"ReactCrop__crop-selection",onPointerDown:this.onCropPointerDown,"aria-label":this.props.ariaLabels&&this.props.ariaLabels.cropArea?this.props.ariaLabels.cropArea:"Use the arrow keys to move the crop selection area",tabIndex:0,onKeyDown:this.onComponentKeyDown,onKeyUp:this.onComponentKeyUp,children:[!r&&!i&&(0,e.jsxs)("div",{className:"ReactCrop__drag-elements",children:[(0,e.jsx)("div",{className:"ReactCrop__drag-bar ord-n","data-ord":"n"},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-bar ord-e","data-ord":"e"},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-bar ord-s","data-ord":"s"},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-bar ord-w","data-ord":"w"},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-nw","data-ord":"nw",style:this.getRotatedCursor("nw",h),tabIndex:0,"aria-label":(null==t?void 0:t.nwDragHandle)||"Use the arrow keys to move the north west drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"nw")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-n","data-ord":"n",style:this.getRotatedCursor("n",h),tabIndex:0,"aria-label":(null==t?void 0:t.nDragHandle)||"Use the up and down arrow keys to move the north drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"n")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-ne","data-ord":"ne",style:this.getRotatedCursor("ne",h),tabIndex:0,"aria-label":(null==t?void 0:t.neDragHandle)||"Use the arrow keys to move the north east drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"ne")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-e","data-ord":"e",style:this.getRotatedCursor("e",h),tabIndex:0,"aria-label":(null==t?void 0:t.eDragHandle)||"Use the up and down arrow keys to move the east drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"e")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-se","data-ord":"se",style:this.getRotatedCursor("se",h),tabIndex:0,"aria-label":(null==t?void 0:t.seDragHandle)||"Use the arrow keys to move the south east drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"se")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-s","data-ord":"s",style:this.getRotatedCursor("s",h),tabIndex:0,"aria-label":(null==t?void 0:t.sDragHandle)||"Use the up and down arrow keys to move the south drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"s")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-sw","data-ord":"sw",style:this.getRotatedCursor("sw",h),tabIndex:0,"aria-label":(null==t?void 0:t.swDragHandle)||"Use the arrow keys to move the south west drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"sw")}},void 0),(0,e.jsx)("div",{className:"ReactCrop__drag-handle ord-w","data-ord":"w",style:this.getRotatedCursor("w",h),tabIndex:0,"aria-label":(null==t?void 0:t.wDragHandle)||"Use the up and down arrow keys to move the west drag handle to change the crop selection area",onKeyDown:e=>{this.onHandlerKeyDown(e,"w")}},void 0)]},void 0),o&&a(s)&&(0,e.jsx)("div",{className:"ReactCrop__selection-addon",onMouseDown:e=>e.stopPropagation(),children:o(this.state)},void 0),n&&(0,e.jsxs)(e.Fragment,{children:[(0,e.jsx)("div",{className:"ReactCrop__rule-of-thirds-hz"},void 0),(0,e.jsx)("div",{className:"ReactCrop__rule-of-thirds-vt"},void 0)]},void 0)]},void 0)}makeNewCrop(e="px"){const t={...n,...this.props.crop||{}},{width:r,height:i}=this.mediaDimensions;return"px"===e?p(t,r,i):c(t,r,i)}crossOverCheck(){const{evData:e}=this,{minWidth:t,minHeight:r}=this.props;!t&&(!e.xCrossOver&&-Math.abs(e.cropStartWidth)-e.xDiff>=0||e.xCrossOver&&-Math.abs(e.cropStartWidth)-e.xDiff<=0)&&(e.xCrossOver=!e.xCrossOver),!r&&(!e.yCrossOver&&-Math.abs(e.cropStartHeight)-e.yDiff>=0||e.yCrossOver&&-Math.abs(e.cropStartHeight)-e.yDiff<=0)&&(e.yCrossOver=!e.yCrossOver)}render(){const{children:t,circularCrop:i,className:o,crossorigin:n,crop:s,disabled:h,imageStyle:d,locked:c,imageAlt:p,onImageError:l,renderComponent:w,scale:g=1,src:u,style:f,rotate:y=0,ruleOfThirds:m}=this.props,{cropIsActive:v,newCropIsBeingDrawn:x}=this.state,C=a(s)&&this.componentRef?this.createCropSelection():null,D=function(){for(var e,t,i=0,o="";i<arguments.length;)(e=arguments[i++])&&(t=r(e))&&(o&&(o+=" "),o+=t);return o}("ReactCrop",o,{"ReactCrop--active":v,"ReactCrop--disabled":h,"ReactCrop--locked":c,"ReactCrop--new-crop":x,"ReactCrop--fixed-aspect":s&&s.aspect,"ReactCrop--circular-crop":s&&i,"ReactCrop--rule-of-thirds":s&&m,"ReactCrop--invisible-crop":!this.dragStarted&&s&&!s.width&&!s.height});return(0,e.jsxs)("div",{ref:this.componentRef,className:D,style:f,onPointerDown:this.onComponentPointerDown,children:[(0,e.jsx)("div",{ref:this.mediaWrapperRef,style:{transform:`scale(${g}) rotate(${y}deg)`},children:w||(0,e.jsx)("img",{ref:this.imageRef,crossOrigin:n,className:"ReactCrop__image",style:d,src:u,onLoad:this.onImageLoad,onError:l,alt:p},void 0)},void 0),t,C]},void 0)}}f.xOrds=["e","w"],f.yOrds=["n","s"],f.xyOrds=["nw","ne","se","sw"],f.nudgeStep=1,f.nudgeStepMedium=10,f.nudgeStepLarge=100})(),o})()}));

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(69921);
} else {}


/***/ }),

/***/ 57333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h3": function() { return /* binding */ NumericFormat; }
/* harmony export */ });
/* unused harmony exports NumberFormatBase, PatternFormat, getNumericCaretBoundary, getPatternCaretBoundary, numericFormatter, patternFormatter, removeNumericFormat, removePatternFormat, useNumericFormat, usePatternFormat */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * react-number-format - 5.4.5
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2026 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) { if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        { t[p] = s[p]; } }
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        { for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                { t[p[i]] = s[p[i]]; }
        } }
    return t;
}

var SourceType;
(function (SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})(SourceType || (SourceType = {}));

// basic noop function
function noop() { }
function memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        if (lastArgs &&
            args.length === lastArgs.length &&
            args.every(function (value, index) { return value === lastArgs[index]; })) {
            return lastValue;
        }
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function charIsNumber(char) {
    return !!(char || '').match(/\d/);
}
function isNil(val) {
    return val === null || val === undefined;
}
function isNanValue(val) {
    return typeof val === 'number' && isNaN(val);
}
function isNotValidValue(val) {
    return isNil(val) || isNanValue(val) || (typeof val === 'number' && !isFinite(val));
}
function escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
function getThousandsGroupRegex(thousandsGroupStyle) {
    switch (thousandsGroupStyle) {
        case 'lakh':
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case 'wan':
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case 'thousand':
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return (str.substring(0, index) +
        str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator));
}
function usePersistentCallback(cb) {
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */
    var persistentCbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr, allowNegative) {
    if ( allowNegative === void 0 ) allowNegative = true;

    var hasNegation = numStr[0] === '-';
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation,
    };
}
function fixLeadingZero(numStr) {
    if (!numStr)
        { return numStr; }
    var isNegative = numStr[0] === '-';
    if (isNegative)
        { numStr = numStr.substring(1, numStr.length); }
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for (var i = 0; i <= scale - 1; i++) {
        str += numStr[i] || filler;
    }
    return str;
}
function repeat(str, count) {
    return Array(count + 1).join(str);
}
function toNumericString(num) {
    var _num = num + ''; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === '-' ? '-' : '';
    if (sign)
        { _num = _num.substring(1); }
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent)
        { return sign + coefficient; }
    coefficient = coefficient.replace('.', '');
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */
    var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) {
        // if decimal index is less then 0 add preceding 0s
        // add 1 as join will have
        coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
    }
    else if (decimalIndex >= coffiecientLn) {
        // if decimal index is less then 0 add leading 0s
        coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
    }
    else {
        // else add decimal point at proper index
        coefficient =
            (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
    }
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if (['', '-'].indexOf(numStr) !== -1)
        { return numStr; }
    var shouldHaveDecimalSeparator = (numStr.indexOf('.') !== -1 || fixedDecimalScale) && scale;
    var ref = splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat(("0." + (afterDecimal || '0')));
    var floatValueStr = afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split('.');
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) {
        intPart = beforeDecimal
            .split('')
            .reverse()
            .reduce(function (roundedStr, current, idx) {
            if (roundedStr.length > idx) {
                return ((Number(roundedStr[0]) + Number(current)).toString() +
                    roundedStr.substring(1, roundedStr.length));
            }
            return current + roundedStr;
        }, roundedDecimalParts[0]);
    }
    var decimalPart = limitToScale(roundedDecimalParts[1] || '', scale, fixedDecimalScale);
    var negation = hasNegation ? '-' : '';
    var decimalSeparator = shouldHaveDecimalSeparator ? '.' : '';
    return ("" + negation + intPart + decimalSeparator + decimalPart);
}
/** set the caret positon in an input field **/
function setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */
        if (el.createTextRange) {
            /* @ts-ignore */
            var range = el.createTextRange();
            range.move('character', caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
 * TODO: remove dependency of findChangeRange, findChangedRangeFromCaretPositions is better way to find what is changed
 * currently this is mostly required by test and isCharacterSame util
 * Given previous value and newValue it returns the index
 * start - end to which values have changed.
 * This function makes assumption about only consecutive
 * characters are changed which is correct assumption for caret input.
 */
var findChangeRange = memoizeOnce(function (prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while (prevValue[i] === newValue[i] && i < prevLength)
        { i++; }
    //check what has been changed from last
    while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
        newLength - j > i &&
        prevLength - j > i) {
        j++;
    }
    return {
        from: { start: i, end: prevLength - j },
        to: { start: i, end: newLength - j },
    };
});
var findChangedRangeFromCaretPositions = function (lastCaretPositions, currentCaretPosition) {
    var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
    return {
        from: { start: startPosition, end: lastCaretPositions.selectionEnd },
        to: { start: startPosition, end: currentCaretPosition },
    };
};
/*
  Returns a number whose value is limited to the given range
*/
function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
    return Math.max(el.selectionStart, el.selectionEnd);
}
function addInputMode() {
    return (typeof navigator !== 'undefined' &&
        !(navigator.platform && /iPhone|iPod/.test(navigator.platform)));
}
function getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0,
        },
        to: {
            start: 0,
            end: value.length,
        },
        lastValue: '',
    };
}
function getMaskAtIndex(mask, index) {
    if ( mask === void 0 ) mask = ' ';

    if (typeof mask === 'string') {
        return mask;
    }
    return mask[index] || ' ';
}
function defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;

    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, 
/**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */
isCharacterSame) {
    if ( isCharacterSame === void 0 ) isCharacterSame = defaultIsCharacterSame;

    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */
    var firstAllowedPosition = boundary.findIndex(function (b) { return b; });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for (var i = 0; i < curValLn; i++) {
        indexMap[i] = -1;
        for (var j = 0, jLn = formattedValueLn; j < jLn; j++) {
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j,
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */
    var pos = curCaretPos;
    while (pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos]))) {
        pos++;
    }
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while (pos > 0 && indexMap[pos] === -1)
        { pos--; }
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */
    if (startIndex > endIndex)
        { return endIndex; }
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */
    return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */
function getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = clamp(caretPos, 0, valLn);
    if (direction === 'left') {
        while (caretPos >= 0 && !boundary[caretPos])
            { caretPos--; }
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1)
            { caretPos = boundary.indexOf(true); }
    }
    else {
        while (caretPos <= valLn && !boundary[caretPos])
            { caretPos++; }
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn)
            { caretPos = boundary.lastIndexOf(true); }
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1)
        { caretPos = valLn; }
    return caretPos;
}
function caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function () { return true; });
    for (var i = 0, ln = boundaryAry.length; i < ln; i++) {
        // consider caret to be in boundary if it is before or after numeric value
        boundaryAry[i] = Boolean(charIsNumber(formattedValue[i]) || charIsNumber(formattedValue[i - 1]));
    }
    return boundaryAry;
}
function useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if ( onValueChange === void 0 ) onValueChange = noop;

    var getValues = usePersistentCallback(function (value, valueIsNumericString) {
        var formattedValue, numAsString;
        if (isNotValidValue(value)) {
            numAsString = '';
            formattedValue = '';
        }
        else if (typeof value === 'number' || valueIsNumericString) {
            numAsString = typeof value === 'number' ? toNumericString(value) : value;
            formattedValue = format(numAsString);
        }
        else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return { formattedValue: formattedValue, numAsString: numAsString };
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return getValues(isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = usePersistentCallback(function (newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) {
            setValues({
                formattedValue: newValues.formattedValue,
                numAsString: newValues.value,
            });
        }
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    });
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if (isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        setValues(newValues);
    }, [newValues.formattedValue]);
    /**
     * When only a defaultValue is provided (value prop is nil), the initial formatted value is
     * derived by the library — the parent has not yet been informed of this formatted result.
     * Fire onValueChange once on mount so the parent can sync to the formatted value.
     */
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!isNil(defaultValue) && isNil(value) && values.formattedValue !== '') {
            var floatValue = parseFloat(values.numAsString);
            _onValueChange({
                formattedValue: values.formattedValue,
                value: values.numAsString,
                floatValue: isNaN(floatValue) ? undefined : floatValue,
            }, { event: undefined, source: SourceType.props });
        }
    }, []);
    return [values, _onValueChange];
}

function defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, '');
}
function defaultFormat(value) {
    return value;
}
function NumberFormatBase(props) {
    var type = props.type; if ( type === void 0 ) type = 'text';
    var displayType = props.displayType; if ( displayType === void 0 ) displayType = 'input';
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format; if ( format === void 0 ) format = defaultFormat;
    var removeFormatting = props.removeFormatting; if ( removeFormatting === void 0 ) removeFormatting = defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange; if ( onChange === void 0 ) onChange = noop;
    var onKeyDown = props.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = noop;
    var onMouseUp = props.onMouseUp; if ( onMouseUp === void 0 ) onMouseUp = noop;
    var onFocus = props.onFocus; if ( onFocus === void 0 ) onFocus = noop;
    var onBlur = props.onBlur; if ( onBlur === void 0 ) onBlur = noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary; if ( getCaretBoundary === void 0 ) getCaretBoundary = caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter; if ( isValidInputCharacter === void 0 ) isValidInputCharacter = charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = __rest(props, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]);
    var ref = useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var caretPositionBeforeChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var lastUpdatedValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({ formattedValue: formattedValue, numAsString: numAsString });
    var _onValueChange = function (values, source) {
        lastUpdatedValue.current = { formattedValue: values.formattedValue, numAsString: values.value };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        setCaretTimeout: null,
        focusTimeout: null,
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        setMounted(true);
        return function () {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function (formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue,
        };
    };
    var setPatchedCaretPosition = function (el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length)
            { return; }
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */
        setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function () {
            if (el.value === currentValue && el.selectionStart !== caretPos) {
                setCaretPosition(el, caretPos);
            }
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */
    var correctCaretPosition = function (value, caretPos, direction) {
        return getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function (inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function (params) {
        var newFormattedValue = params.formattedValue; if ( newFormattedValue === void 0 ) newFormattedValue = '';
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */
            input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) {
                setPatchedCaretPosition(input, caretPos, newFormattedValue);
            }
        }
        if (newFormattedValue !== formattedValue) {
            // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
            _onValueChange(getValueObject(newFormattedValue, numAsString), { event: event, source: source });
        }
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) {
            _onValueChange(getValueObject(formattedValue, numAsString), {
                event: undefined,
                source: SourceType.props,
            });
        }
    }, [formattedValue, numAsString]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current
        ? geInputCaretPosition(focusedElm.current)
        : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
    useIsomorphicLayoutEffect(function () {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */
            input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [formattedValue]);
    var formatInputValue = function (inputValue, event, source) {
        var input = event.target;
        var changeRange = caretPositionBeforeChange.current
            ? findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd)
            : findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), { lastValue: formattedValue });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input$1 = event.target;
            var currentCaretPosition = geInputCaretPosition(input$1);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input$1.value = formattedValue;
            setPatchedCaretPosition(input$1, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target,
        });
        return true;
    };
    var setCaretPositionInfoBeforeChange = function (el, endOffset) {
        if ( endOffset === void 0 ) endOffset = 0;

        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        caretPositionBeforeChange.current = { selectionStart: selectionStart, selectionEnd: selectionEnd + endOffset };
    };
    var _onChange = function (e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, SourceType.event);
        if (changed)
            { onChange(e); }
        // reset the position, as we have already handled the caret position
        caretPositionBeforeChange.current = undefined;
    };
    var _onKeyDown = function (e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value; if ( value === void 0 ) value = '';
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === 'ArrowLeft' || key === 'Backspace') {
            expectedCaretPosition = Math.max(selectionStart - 1, 0);
        }
        else if (key === 'ArrowRight') {
            expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        }
        else if (key === 'Delete') {
            expectedCaretPosition = selectionStart;
        }
        // if key is delete and text is not selected keep the end offset to 1, as it deletes one character
        // this is required as selection is not changed on delete case, which changes the change range calculation
        var endOffset = 0;
        if (key === 'Delete' && selectionStart === selectionEnd) {
            endOffset = 1;
        }
        var isArrowKey = key === 'ArrowLeft' || key === 'ArrowRight';
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || (selectionStart !== selectionEnd && !isArrowKey)) {
            onKeyDown(e);
            // keep information of what was the caret position before keyDown
            // set it after onKeyDown, in case parent updates the position manually
            setCaretPositionInfoBeforeChange(el, endOffset);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (isArrowKey) {
            var direction = key === 'ArrowLeft' ? 'left' : 'right';
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) {
                e.preventDefault();
            }
        }
        else if (key === 'Delete' && !isValidInputCharacter(value[expectedCaretPosition])) {
            // in case of delete go to closest caret boundary on the right side
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'right');
        }
        else if (key === 'Backspace' && !isValidInputCharacter(value[expectedCaretPosition])) {
            // in case of backspace go to closest caret boundary on the left side
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'left');
        }
        if (newCaretPosition !== expectedCaretPosition) {
            setPatchedCaretPosition(el, newCaretPosition, value);
        }
        onKeyDown(e);
        setCaretPositionInfoBeforeChange(el, endOffset);
    };
    /** required to handle the caret position when click anywhere within the input **/
    var _onMouseUp = function (e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */
        var correctCaretPositionIfRequired = function () {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value; if ( value === void 0 ) value = '';
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) {
                    setPatchedCaretPosition(el, caretPosition, value);
                }
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function () {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
        setCaretPositionInfoBeforeChange(el);
    };
    var _onFocus = function (e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist)
            { e.persist(); }
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function () {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value; if ( value === void 0 ) value = '';
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart &&
                !(selectionStart === 0 && selectionEnd === value.length)) {
                setPatchedCaretPosition(el, caretPosition, value);
            }
            onFocus(Object.assign(Object.assign({}, e), { currentTarget: currentTarget }));
        }, 0);
    };
    var _onBlur = function (e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode() ? 'numeric' : undefined;
    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur,
    });
    if (displayType === 'text') {
        return renderText ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderText(formattedValue, otherProps) || null)) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({}, otherProps, { ref: getInputRef }), formattedValue));
    }
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", Object.assign({}, inputProps, { ref: getInputRef }));
}

function format(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var suffix = props.suffix; if ( suffix === void 0 ) suffix = '';
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle; if ( thousandsGroupStyle === void 0 ) thousandsGroupStyle = 'thousand';
    // don't apply formatting on empty string or '-'
    if (numStr === '' || numStr === '-') {
        return numStr;
    }
    var ref = getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */
    var hasDecimalSeparator = (decimalScale !== 0 && numStr.indexOf('.') !== -1) || (decimalScale && fixedDecimalScale);
    var ref$1 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
        afterDecimal = limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    }
    if (thousandSeparator) {
        beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }
    //add prefix and suffix when there is a number present
    if (prefix)
        { beforeDecimal = prefix + beforeDecimal; }
    if (suffix)
        { afterDecimal = afterDecimal + suffix; }
    //restore negation sign
    if (addNegation)
        { beforeDecimal = '-' + beforeDecimal; }
    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;
    return numStr;
}
function getSeparators(props) {
    var decimalSeparator = props.decimalSeparator; if ( decimalSeparator === void 0 ) decimalSeparator = '.';
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) {
        thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
        allowedDecimalSeparators = [decimalSeparator, '.'];
    }
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators,
    };
}
function handleNegation(value, allowNegative) {
    if ( value === void 0 ) value = '';

    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, '');
    if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
    }
    return value;
}
function getNumberRegex(decimalSeparator, global) {
    return new RegExp(("(^-)|[0-9]|" + (escapeRegExp(decimalSeparator))), global ? 'g' : undefined);
}
function isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === '')
        { return true; }
    return (!(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === 'string' && !isNaN(Number(val)));
}
function removeFormatting(value, changeMeta, props) {
    var assign;

    if ( changeMeta === void 0 ) changeMeta = getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var suffix = props.suffix; if ( suffix === void 0 ) suffix = '';
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */
    if (charIsNumber(value) &&
        (value === prefix || value === suffix) &&
        changeMeta.lastValue === '') {
        return value;
    }
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? '' : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function (value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */
        var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith('-')) {
            hasNegation = false;
        }
        else if (value.startsWith('--')) {
            hasNegation = false;
            hasDoubleNegation = true;
        }
        else if (suffix.startsWith('-') && value.length === suffix.length) {
            hasNegation = false;
        }
        else if (value[0] === '-') {
            hasNegation = true;
        }
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation)
            { charsToRemove = 2; }
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return { value: value, start: start, end: end, hasNegation: hasNegation };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    ((assign = toMetadata, value = assign.value, start = assign.start, end = assign.end));
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length &&
        lastValue.length &&
        (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) &&
        !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) {
        value = lastValue;
    }
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */
    var startIndex = 0;
    if (value.startsWith(prefix))
        { startIndex += prefix.length; }
    else if (start < prefix.length)
        { startIndex = start; }
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */
    var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix))
        { endIndex = suffixStartIndex; }
    // if the suffix is removed from the end
    else if (end > suffixStartIndex)
        { endIndex = end; }
    // if the suffix is removed from start
    else if (end > value.length - suffix.length)
        { endIndex = end; }
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = handleNegation(hasNegation ? ("-" + value) : value, allowNegative);
    // remove non numeric characters
    value = (value.match(getNumberRegex(decimalSeparator, true)) || []).join('');
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), function (match, index) {
        return index === firstIndex ? '.' : '';
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start &&
        beforeDecimal === '' &&
        isBeforeDecimalSeparator &&
        !parseFloat(afterDecimal)) {
        value = addNegation ? '-' : '';
    }
    return value;
}
function getCaretBoundary(formattedValue, props) {
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var suffix = props.suffix; if ( suffix === void 0 ) suffix = '';
    var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function () { return true; });
    var hasNegation = formattedValue[0] === '-';
    // fill for prefix and negation
    // Cap the fill range so we never exceed the array length when the formatted value
    // is just '-' (negation only, e.g. during intermediate typing with a multi-char prefix)
    boundaryAry.fill(false, 0, Math.min(prefix.length + (hasNegation ? 1 : 0), formattedValue.length));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function validateAndUpdateProps(props) {
    var ref = getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var allowNegative = props.allowNegative; if ( allowNegative === void 0 ) allowNegative = true;
    if (thousandSeparator === decimalSeparator) {
        throw new Error(("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n        decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n     "));
    }
    if (prefix.startsWith('-') && allowNegative) {
        // TODO: throw error in next major version
        console.error(("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    "));
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), { allowNegative: allowNegative });
}
function useNumericFormat(props) {
    // validate props
    props = validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = noop;
    var onBlur = props.onBlur; if ( onBlur === void 0 ) onBlur = noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = __rest(props, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function (numStr) { return format(numStr, props); };
    var _removeFormatting = function (inputValue, changeMeta) { return removeFormatting(inputValue, changeMeta, props); };
    var _value = isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString(_value, prefix, suffix);
    if (!isNil(value)) {
        _valueIsNumericString = _valueIsNumericString || typeof value === 'number';
    }
    else if (!isNil(defaultValue)) {
        _valueIsNumericString = _valueIsNumericString || typeof defaultValue === 'number';
    }
    var roundIncomingValueToPrecision = function (value) {
        if (isNotValidValue(value))
            { return value; }
        if (typeof value === 'number') {
            value = toNumericString(value);
        }
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */
        if (_valueIsNumericString && typeof decimalScale === 'number') {
            return roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        }
        return value;
    };
    var ref$1 = useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function (e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value; if ( value === void 0 ) value = '';
        // if user tries to delete partial prefix then ignore it
        // Exception: when value is just '-' (negation-only, no prefix shown yet), the cursor
        // is at position 1 which is < prefix.length for multi-char prefixes — we must allow
        // backspace to delete the lone negation sign in this state
        if ((key === 'Backspace' || key === 'Delete') && selectionEnd < prefix.length && value !== '-') {
            e.preventDefault();
            return;
        }
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === 'Backspace' &&
            value[0] === '-' &&
            selectionStart === prefix.length + 1 &&
            allowNegative) {
            // bring the cursor to after negation
            setCaretPosition(el, 1);
        }
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === 'Backspace' && value[selectionStart - 1] === decimalSeparator) {
                setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            }
            else if (key === 'Delete' && value[selectionStart] === decimalSeparator) {
                e.preventDefault();
            }
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) {
            setCaretPosition(el, selectionStart + 1);
        }
        var _thousandSeparator = thousandSeparator === true ? ',' : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === 'Backspace' && value[selectionStart - 1] === _thousandSeparator) {
            setCaretPosition(el, selectionStart - 1);
        }
        if (key === 'Delete' && value[selectionStart] === _thousandSeparator) {
            setCaretPosition(el, selectionStart + 1);
        }
        onKeyDown(e);
    };
    var _onBlur = function (e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) {
            _value = '';
        }
        // clear leading 0s
        if (!allowLeadingZeros) {
            _value = fixLeadingZero(_value);
        }
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) {
            _value = roundToPrecision(_value, decimalScale, fixedDecimalScale);
        }
        if (_value !== numAsString) {
            var formattedValue = format(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value),
            }, {
                event: e,
                source: SourceType.event,
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function (inputChar) {
        if (inputChar === decimalSeparator)
            { return true; }
        return charIsNumber(inputChar);
    };
    var isCharacterSame = function (ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;

        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */
        var typedRange = findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        // handle corner case where if we user types a decimal separator with fixedDecimalScale
        // and pass back float value the cursor jumps. #851
        var getDecimalSeparatorIndex = function (value) {
            return _removeFormatting(value).indexOf('.') + prefix.length;
        };
        if (value === 0 &&
            fixedDecimalScale &&
            decimalScale &&
            currentValue[to.start] === decimalSeparator &&
            getDecimalSeparatorIndex(currentValue) < currentValueIndex &&
            getDecimalSeparatorIndex(formattedValue) > formattedValueIndex) {
            return false;
        }
        if (currentValueIndex >= to.start &&
            currentValueIndex < to.end &&
            allowedDecimalSeparators &&
            allowedDecimalSeparators.includes(curChar) &&
            newChar === decimalSeparator) {
            return true;
        }
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), { value: formattedValue, valueIsNumericString: false, isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame, onValueChange: _onValueChange, format: _format, removeFormatting: _removeFormatting, getCaretBoundary: function (formattedValue) { return getCaretBoundary(formattedValue, props); }, onKeyDown: _onKeyDown, onBlur: _onBlur });
}
function NumericFormat(props) {
    var numericFormatProps = useNumericFormat(props);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(NumberFormatBase, Object.assign({}, numericFormatProps));
}

function format$1(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    if (numStr === '' && !allowEmptyFormatting)
        { return ''; }
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === patternChar) {
            formattedNumberAry[i] = numStr[hashCount] || getMaskAtIndex(mask, hashCount);
            hashCount += 1;
        }
    }
    return formattedNumberAry.join('');
}
function removeFormatting$1(value, changeMeta, props) {
    if ( changeMeta === void 0 ) changeMeta = getDefaultChangeMeta(value);

    var format = props.format;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue; if ( lastValue === void 0 ) lastValue = '';
    var isNumericSlot = function (caretPos) { return format[caretPos] === patternChar; };
    var removeFormatChar = function (string, startIndex) {
        var str = '';
        for (var i = 0; i < string.length; i++) {
            if (isNumericSlot(startIndex + i) && charIsNumber(string[i])) {
                str += string[i];
            }
        }
        return str;
    };
    var extractNumbers = function (str) { return str.replace(/[^0-9]/g, ''); };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) {
        return extractNumbers(value);
    }
    /**
     * if user paste the whole formatted text in an empty input or doing select all and paste, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */
    if ((lastValue === '' || from.end - from.start === lastValue.length) &&
        value.length === format.length) {
        var str = '';
        for (var i = 0; i < value.length; i++) {
            if (isNumericSlot(i)) {
                if (charIsNumber(value[i])) {
                    str += value[i];
                }
            }
            else if (value[i] !== format[i]) {
                // if there is a mismatch on the pattern, do plane number extract
                return extractNumbers(value);
            }
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */
    var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return ("" + (removeFormatChar(firstSection, 0)) + (extractNumbers(middleSection)) + (removeFormatChar(lastSection, from.end)));
}
function getCaretBoundary$1(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function () { return true; });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split('').forEach(function (char, index) {
        var maskAtIndex = undefined;
        if (char === patternChar) {
            hashCount++;
            maskAtIndex = getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) {
                firstEmptySlot = index;
            }
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function (pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for (var i = 0, ln = boundaryAry.length; i < ln; i++) {
        // consider caret to be in boundary if it is before or after numeric value
        // Note: on pattern based format its denoted by patternCharacter
        // we should also allow user to put cursor on first empty slot
        boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    }
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) {
            throw new Error(("Mask " + mask + " should not contain numeric character;"));
        }
    }
}
function isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === '')
        { return true; }
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === 'string' && (!!val.match(/^\d+$/) || val === '');
}
function usePatternFormat(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode; if ( inputMode === void 0 ) inputMode = 'numeric';
    var onKeyDown = props.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = noop;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = __rest(props, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
    // validate props
    validateProps(props);
    var _getCaretBoundary = function (formattedValue) {
        return getCaretBoundary$1(formattedValue, props);
    };
    var _onKeyDown = function (e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === 'Backspace' || key === 'Delete') {
            var direction = 'right';
            if (key === 'Backspace') {
                while (caretPos > 0 && formatProp[caretPos - 1] !== patternChar) {
                    caretPos--;
                }
                direction = 'left';
            }
            else {
                var formatLn = formatProp.length;
                while (caretPos < formatLn && formatProp[caretPos] !== patternChar) {
                    caretPos++;
                }
                direction = 'right';
            }
            caretPos = getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        }
        else if (formatProp[caretPos] !== patternChar &&
            key !== 'ArrowLeft' &&
            key !== 'ArrowRight') {
            // if user is typing on format character position, bring user to next allowed caret position
            caretPos = getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), 'right');
        }
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) {
            setCaretPosition(el, caretPos);
        }
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), { valueIsNumericString: isValueNumericString });
    return Object.assign(Object.assign({}, restProps), { value: value,
        defaultValue: defaultValue, valueIsNumericString: isValueNumericString, inputMode: inputMode, format: function (numStr) { return format$1(numStr, _props); }, removeFormatting: function (inputValue, changeMeta) { return removeFormatting$1(inputValue, changeMeta, _props); }, getCaretBoundary: _getCaretBoundary, onKeyDown: _onKeyDown });
}
function PatternFormat(props) {
    var patternFormatProps = usePatternFormat(props);
    return React.createElement(NumberFormatBase, Object.assign({}, patternFormatProps));
}




/***/ }),

/***/ 57744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];

  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function capitalize(token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

var _require = __webpack_require__(78229),
    CAMELCASE = _require.CAMELCASE,
    SAME = _require.SAME,
    possibleStandardNamesOptimized = _require.possibleStandardNames;

var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */

var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];

  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }

  return accumulator;
}, {});

exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, exports) {

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;

exports.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};


/***/ }),

/***/ 88632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
  bgD: _propTypes2.default.string.isRequired,
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
  fgD: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.number.isRequired,
  title: _propTypes2.default.string,
  viewBoxSize: _propTypes2.default.number.isRequired,
  xmlns: _propTypes2.default.string
};

var QRCodeSvg = (0, _react.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      bgD = _ref.bgD,
      fgD = _ref.fgD,
      fgColor = _ref.fgColor,
      size = _ref.size,
      title = _ref.title,
      viewBoxSize = _ref.viewBoxSize,
      _ref$xmlns = _ref.xmlns,
      xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns,
      props = _objectWithoutProperties(_ref, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize", "xmlns"]);

  return _react2.default.createElement(
    "svg",
    _extends({}, props, { height: size, ref: ref, viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize, width: size, xmlns: xmlns }),
    title ? _react2.default.createElement(
      "title",
      null,
      title
    ) : null,
    _react2.default.createElement("path", { d: bgD, fill: bgColor }),
    _react2.default.createElement("path", { d: fgD, fill: fgColor })
  );
});

QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes;

exports["default"] = QRCodeSvg;

/***/ }),

/***/ 1653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.s_ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorCorrectLevel = __webpack_require__(49381);

var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);

var _QRCode = __webpack_require__(14450);

var _QRCode2 = _interopRequireDefault(_QRCode);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _QRCodeSvg = __webpack_require__(88632);

var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


function bytesToBinaryString(bytes) {
  return bytes.map(function (b) {
    return String.fromCharCode(b & 0xff);
  }).join("");
}

function encodeStringToUtf8Bytes(input) {
  return Array.from(new TextEncoder().encode(input));
}

var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var QRCode = (0, _react.forwardRef)(function (_ref, ref) {
  var _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor,
      _ref$fgColor = _ref.fgColor,
      fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? "L" : _ref$level,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 256 : _ref$size,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  var utf8Bytes = encodeStringToUtf8Bytes(value);
  var binaryString = bytesToBinaryString(utf8Bytes);
  qrcode.addData(binaryString, "Byte");
  qrcode.make();
  var cells = qrcode.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
    bgColor: bgColor,
    bgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    fgColor: fgColor,
    fgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: ref,
    size: size,
    viewBoxSize: cells.length
  }));
});

exports.s_ = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;

__webpack_unused_export__ = QRCode;

/***/ }),

/***/ 9473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; },
  "oR": function() { return /* reexport */ useStore_useStore; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connect, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual

// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(61688);
// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis :
/* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
{};

function getContext() {
  var _gT$ContextKey;

  if (!react.createContext) return {};
  const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
  let realContext = contextMap.get(react.createContext);

  if (!realContext) {
    realContext = react.createContext(null);

    if (false) {}

    contextMap.set(react.createContext, realContext);
  }

  return realContext;
}

const Context_ReactReduxContext = /*#__PURE__*/getContext();
/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */
function createReduxContextHook(context = Context_ReactReduxContext) {
  return function useReduxContext() {
    const contextValue = (0,react.useContext)(context);

    if (false) {}

    return contextValue;
  };
}
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

const useReduxContext_useReduxContext = /*#__PURE__*/createReduxContextHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useSyncExternalStore.js
const useSyncExternalStore_notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = useSyncExternalStore_notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};

const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context = Context_ReactReduxContext) {
  const useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : createReduxContextHook(context);
  return function useSelector(selector, equalityFnOrOptions = {}) {
    const {
      equalityFn = refEquality,
      stabilityCheck = undefined,
      noopCheck = undefined
    } = typeof equalityFnOrOptions === 'function' ? {
      equalityFn: equalityFnOrOptions
    } : equalityFnOrOptions;

    if (false) {}

    const {
      store,
      subscription,
      getServerState,
      stabilityCheck: globalStabilityCheck,
      noopCheck: globalNoopCheck
    } = useReduxContext();
    const firstRun = (0,react.useRef)(true);
    const wrappedSelector = (0,react.useCallback)({
      [selector.name](state) {
        const selected = selector(state);

        if (false) {}

        return selected;
      }

    }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },

    notify() {
      batch(() => {
        let listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },

    get() {
      let listeners = [];
      let listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },

    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }

  };
}

const nullListeners = {
  notify() {},

  get: () => []
};
function Subscription_createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners; // Reasons to keep the subscription active

  let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)

  let selfSubscribed = false;

  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener); // cleanup nested sub

    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return selfSubscribed;
  }

  function trySubscribe() {
    subscriptionsAmount++;

    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    subscriptionsAmount--;

    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }

  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }

  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connect.js


const _excluded = (/* unused pure expression or super */ null && (["reactReduxForwardedRef"]));

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = (/* unused pure expression or super */ null && (notInitialized));
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null])); // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage


function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, // actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.


function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, // forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it


    const latestStoreState = store.getState();
    let newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer


const initStateUpdates = () => EMPTY_ARRAY;

function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */


let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}

  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);

  const wrapWithConnect = WrappedComponent => {
    if (false) {}

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };

    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = React.useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
          reactReduxForwardedRef
        } = props,
              wrapperProps = _objectWithoutPropertiesLoose(props, _excluded);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = React.useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && // @ts-ignore
        isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = React.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = React.useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return defaultSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = React.useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = React.useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = React.useRef();
      const lastWrapperProps = React.useRef(wrapperProps);
      const childPropsFromStoreUpdate = React.useRef();
      const renderIsScheduled = React.useRef(false);
      const isProcessingDispatch = React.useRef(false);
      const isMounted = React.useRef(false);
      const latestSubscriptionCallbackError = React.useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = React.useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.


          return childPropsSelector(store.getState(), wrapperProps);
        };

        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = React.useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }

          return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };

        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;

      try {
        actualChildProps = useSyncExternalStore( // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }

        throw err;
      }

      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = React.useMemo(() => {
        return (
          /*#__PURE__*/
          // @ts-ignore
          React.createElement(WrappedComponent, _extends({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = React.useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }

    const _Connect = React.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      const _forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/React.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };

  return wrapWithConnect;
}

/* harmony default export */ var components_connect = ((/* unused pure expression or super */ null && (connect)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





function Provider({
  store,
  context,
  children,
  serverState,
  stabilityCheck = 'once',
  noopCheck = 'once'
}) {
  const contextValue = react.useMemo(() => {
    const subscription = Subscription_createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined,
      stabilityCheck,
      noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  const previousState = react.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || Context_ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js


/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = Context_ReactReduxContext) {
  const useReduxContext = // @ts-ignore
  context === Context_ReactReduxContext ? useReduxContext_useReduxContext : // @ts-ignore
  createReduxContextHook(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = Context_ReactReduxContext) {
  const useStore = // @ts-ignore
  context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 48477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ 35343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` and `name` from props
      var newProps = _extends({}, this.props);
      delete newProps.name;
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports["default"] = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ 66261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.OK = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _Link = __webpack_require__(68939);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(48477);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(35343);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(98482);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_unused_export__ = _Link2.default;
__webpack_unused_export__ = _Button2.default;
__webpack_unused_export__ = _Element2.default;
exports.OK = _scroller2.default;
__webpack_unused_export__ = _scrollEvents2.default;
__webpack_unused_export__ = _scrollSpy2.default;
__webpack_unused_export__ = _animateScroll2.default;
__webpack_unused_export__ = _scrollLink2.default;
__webpack_unused_export__ = _scrollElement2.default;
__webpack_unused_export__ = _Helpers2.default;
exports.ZP = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ 98482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(67294);
var ReactDOM = __webpack_require__(73935);

var utils = __webpack_require__(54259);
var scrollSpy = __webpack_require__(87606);
var defaultScroller = __webpack_require__(82628);
var PropTypes = __webpack_require__(45697);
var scrollHash = __webpack_require__(29678);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ 53200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(89765);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(50140);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  var setCancel = function setCancel() {
    options.data.cancel = true;
  };
  _cancelEvents2.default.subscribe(setCancel);

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports["default"] = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 50140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var events = ['mousedown', 'wheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 55236:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var listenerName = listener.name;
  if (!listenerName) {
    listenerName = eventName;
    console.warn('Listener must be a named function.');
  }

  if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, new Set());
  var listeners = attachedListeners.get(eventName);
  if (listeners.has(listenerName)) return;

  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
  listeners.add(listenerName);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
  attachedListeners.get(eventName).delete(listener.name || eventName);
};

var attachedListeners = new Map();

/***/ }),

/***/ 18000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports["default"] = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ 64592:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 29678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports["default"] = scrollHash;

/***/ }),

/***/ 31093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(29678);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports["default"] = function (Component, customScroller) {
  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      _this.beforeUnmountCallbacks = [];
      return _this;
    }

    _createClass(Link, [{
      key: "getScrollSpyContainer",
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            var fn = _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
            this.beforeUnmountCallbacks.push(fn);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
        this.beforeUnmountCallbacks.forEach(function (fn) {
          return fn();
        });
      }
    }, {
      key: "render",
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends({}, this.props.style);
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {
      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();

          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;

        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ 87606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _lodash = __webpack_require__(93096);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(55236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
      return function () {
        (0, _passiveEventListeners.removePassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
        scrollSpy.scrollSpyContainers.splice(scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer), 1);
      };
    }
    return function () {};
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.scrollY !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.scrollX : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.scrollX !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.scrollY : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports["default"] = scrollSpy;

/***/ }),

/***/ 82628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports["default"] = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 54259:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 23492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 16329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 46066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _slider = _interopRequireDefault(__webpack_require__(5798));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports.Z = _default;

/***/ }),

/***/ 46948:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 58517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _initialState = _interopRequireDefault(__webpack_require__(46948));

var _lodash = _interopRequireDefault(__webpack_require__(91296));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

var _track = __webpack_require__(64740);

var _dots = __webpack_require__(16329);

var _arrows = __webpack_require__(8205);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(91033));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 5798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _innerSlider = __webpack_require__(58517);

var _json2mq = _interopRequireDefault(__webpack_require__(80973));

var _defaultProps = _interopRequireDefault(__webpack_require__(23492));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(24974);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 64740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide cmp-carousel-slick__item": true,
    "slick-active cmp-carousel-slick__item--active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 15518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
exports.clamp = clamp;
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 59162:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultProps = void 0;
const react_1 = __importDefault(__webpack_require__(67294));
const render_props_version_1 = __importDefault(__webpack_require__(13854));
exports.defaultProps = Object.assign(Object.assign({}, render_props_version_1.default.defaultProps), { stickyClassName: 'sticky', wrapperClassName: '', stickyStyle: {} });
function Sticky(props) {
    const _a = Object.assign(Object.assign({}, exports.defaultProps), props), { 
    // props for StickyRenderProp
    mode, onFixedToggle, hideOnBoundaryHit, offsetTransforms, disabled, boundaryElement, scrollElement, bottomOffset, topOffset, positionRecheckInterval, children, isIOSFixEnabled, dontUpdateHolderHeightWhenSticky, 
    // own props
    wrapperClassName, stickyClassName, stickyStyle } = _a, 
    // rest of the props that we will forward to wrapper
    rest = __rest(_a, ["mode", "onFixedToggle", "hideOnBoundaryHit", "offsetTransforms", "disabled", "boundaryElement", "scrollElement", "bottomOffset", "topOffset", "positionRecheckInterval", "children", "isIOSFixEnabled", "dontUpdateHolderHeightWhenSticky", "wrapperClassName", "stickyClassName", "stickyStyle"]);
    return react_1.default.createElement(render_props_version_1.default, { mode: mode, onFixedToggle: onFixedToggle, hideOnBoundaryHit: hideOnBoundaryHit, offsetTransforms: offsetTransforms, disabled: disabled, boundaryElement: boundaryElement, scrollElement: scrollElement, bottomOffset: bottomOffset, topOffset: topOffset, positionRecheckInterval: positionRecheckInterval, isIOSFixEnabled: isIOSFixEnabled, dontUpdateHolderHeightWhenSticky: dontUpdateHolderHeightWhenSticky }, ({ isFixed, wrapperStyles, wrapperRef, holderStyles, holderRef }) => (react_1.default.createElement("div", Object.assign({}, rest, { ref: holderRef, style: holderStyles }),
        react_1.default.createElement("div", Object.assign({}, rest, { className: `${wrapperClassName} ${isFixed ? stickyClassName : ''}`, style: isFixed ? Object.assign(Object.assign({}, wrapperStyles), stickyStyle) : wrapperStyles, ref: wrapperRef }), children))));
}
exports["default"] = Sticky;


/***/ }),

/***/ 22442:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unlisten = exports.listen = void 0;
const elementsWithListeners = [];
const registeredListeners = [];
function createListener(el) {
    return ({
        el,
        callbacks: {},
        realCallbacks: {},
        realListenersCnt: 0
    });
}
function addCallback(listener, event, cb) {
    if (listener.callbacks[event]) {
        if (listener.callbacks[event].indexOf(cb) === -1) {
            listener.callbacks[event].push(cb);
        }
        return;
    }
    listener.callbacks[event] = [cb];
    listener.realCallbacks[event] = (e) => {
        for (let i = 0, l = listener.callbacks[event].length; i < l; i += 1) {
            listener.callbacks[event][i](e);
        }
    };
    listener.el.addEventListener(event, listener.realCallbacks[event]);
    listener.realListenersCnt += 1;
}
function removeCallback(listener, event, cb) {
    if (!listener.callbacks[event]) {
        return;
    }
    const idx = listener.callbacks[event].indexOf(cb);
    if (idx === -1) {
        return;
    }
    listener.callbacks[event].splice(idx, 1);
    if (listener.callbacks[event].length > 0) {
        return;
    }
    // no more listeners, lets clean up
    listener.el.removeEventListener(event, listener.realCallbacks[event]);
    delete listener.callbacks[event];
    delete listener.realCallbacks[event];
    listener.realListenersCnt -= 1;
}
function addListener(el, event, cb) {
    let idx = elementsWithListeners.indexOf(el);
    if (idx === -1) {
        idx = elementsWithListeners.length;
        elementsWithListeners.push(el);
        registeredListeners.push(createListener(el));
    }
    const listener = registeredListeners[idx];
    addCallback(listener, event, cb);
}
function removeListener(el, event, cb) {
    const idx = elementsWithListeners.indexOf(el);
    if (idx === -1) {
        return;
    }
    const listener = registeredListeners[idx];
    removeCallback(listener, event, cb);
    if (listener.realListenersCnt > 0) {
        return;
    }
    // no more listeners lets clean up
    elementsWithListeners.splice(idx, 1);
    registeredListeners.splice(idx, 1);
}
/**
 * Subscribe cb to events list
 * @param  {HTMLListenable}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be called
 */
function listen(el, events, cb) {
    for (let i = 0, l = events.length; i < l; i += 1) {
        addListener(el, events[i], cb);
    }
}
exports.listen = listen;
/**
 * Unsubscribe cb from events list
 * @param  {HTMLListenable}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be unsubscribed
 */
function unlisten(el, events, cb) {
    for (let i = 0, l = events.length; i < l; i += 1) {
        removeListener(el, events[i], cb);
    }
}
exports.unlisten = unlisten;


/***/ }),

/***/ 92771:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
const basicSelectors = {};
if (typeof document !== 'undefined') {
    basicSelectors.body = document.body;
    basicSelectors.window = window;
    basicSelectors.document = document;
}
const matchesMethodName = (() => {
    if (typeof document !== 'undefined' && document.body) {
        const body = document.body;
        return typeof (body.matches) === 'function' ? 'matches' :
            typeof (body.webkitMatchesSelector) === 'function' ? 'webkitMatchesSelector' : //webkit
                // @ts-expect-error - ts doesn't like vendors, so do I, but we have to support such case
                typeof (body.mozMatchesSelector) === 'function' ? 'mozMatchesSelector' : //mozilla
                    // @ts-expect-error - ts doesn't like vendors, so do I, but we have to support such case
                    typeof (body.msMatchesSelector) === 'function' ? 'msMatchesSelector' : //ie
                        // @ts-expect-error - ts doesn't like vendors, so do I, but we have to support such case
                        typeof (body.oMatchesSelector) === 'function' ? 'oMatchesSelector' : //old opera
                            null;
    }
    return null;
})();
function find(selector, el) {
    if (!selector) {
        return null;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (basicSelectors.hasOwnProperty(selector)) {
        return basicSelectors[selector];
    }
    // select by id
    if (selector[0] === '#') {
        return document.getElementById(selector.slice(1));
    }
    if (matchesMethodName === null) {
        return null;
    }
    let temp = el;
    // eslint-disable-next-line no-cond-assign
    while (temp = temp.parentElement) {
        // @ts-expect-error - ts does not approve it, but it works fine :)
        if (temp[matchesMethodName](selector)) {
            return temp || null;
        }
    }
    // nothing has been found :(
    return null;
}
exports["default"] = find;


/***/ }),

/***/ 81738:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
function getClosestTransformedParent(el) {
    do {
        const style = window.getComputedStyle(el);
        if (style.transform !== 'none' || style.webkitTransform !== 'none')
            return el;
        // @ts-expect-error - this is fine we don't need a new variable
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
}
exports["default"] = getClosestTransformedParent;


/***/ }),

/***/ 61596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isIntersecting = exports.getRect = exports.infiniteRect = void 0;
exports.infiniteRect = { top: -Infinity, bottom: Infinity, height: Infinity, left: -Infinity, right: Infinity, width: Infinity };
function getRect(el) {
    if (el && ('getBoundingClientRect' in el) && typeof (el.getBoundingClientRect) === 'function') {
        return el.getBoundingClientRect();
    }
    if (el === window || el === document) {
        return {
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            height: window.innerHeight,
            width: window.innerWidth,
            right: window.innerWidth
        };
    }
    return { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
}
exports.getRect = getRect;
function isIntersecting(r1, r2, topOffset, bottomOffset) {
    const r1Top = r1.top + topOffset, r1Bottom = r1.bottom + bottomOffset;
    return (r1Top >= r2.top && r1Top <= r2.bottom)
        || (r1Bottom >= r2.top && r1Bottom <= r2.bottom)
        || (r1Bottom >= r2.bottom && r1Top <= r2.top);
}
exports.isIntersecting = isIntersecting;


/***/ }),

/***/ 75198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenderPropSticky = void 0;
const render_props_version_1 = __importDefault(__webpack_require__(13854));
exports.RenderPropSticky = render_props_version_1.default;
const basic_version_1 = __importDefault(__webpack_require__(59162));
exports["default"] = basic_version_1.default;


/***/ }),

/***/ 13854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// @flow strict
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(67294);
const events_1 = __webpack_require__(22442);
const find_1 = __importDefault(__webpack_require__(92771));
const getClosestTransformedParent_1 = __importDefault(__webpack_require__(81738));
const rect_1 = __webpack_require__(61596);
const buildTopStyles = (container, props) => {
    const { bottomOffset, hideOnBoundaryHit } = props;
    const { top, height, width, boundaryBottom } = container;
    // above boundary
    if (hideOnBoundaryHit || (top + height + bottomOffset < boundaryBottom)) {
        return { top: `${top}px`, width: `${width}px`, position: 'fixed' };
    }
    // reaching boundary
    if (!hideOnBoundaryHit && boundaryBottom > 0) {
        return { top: `${boundaryBottom - height - bottomOffset}px`, width: `${width}px`, position: 'fixed' };
    }
    // below boundary
    return { width: `${width}px`, bottom: `${bottomOffset}px`, position: 'absolute' };
};
const buildBottomStyles = (container, props) => {
    const { bottomOffset, hideOnBoundaryHit } = props;
    const { bottom, height, width, boundaryTop } = container;
    if (hideOnBoundaryHit || (bottom - height - bottomOffset > boundaryTop)) {
        return { width: `${width}px`, top: `${bottom - height}px`, position: 'fixed' };
    }
    return { width: `${width}px`, top: `${bottomOffset}px`, position: 'absolute' };
};
const buildStickyStyle = (mode, props, container) => (mode === 'top' ? buildTopStyles : buildBottomStyles)(container, props);
const isEqual = (obj1, obj2) => {
    const styles1 = obj1.wrapperStyles;
    const styles2 = obj2.wrapperStyles;
    if (obj1.isFixed !== obj2.isFixed ||
        obj1.height !== obj2.height ||
        (!styles1 && styles2) ||
        (styles1 && !styles2)) {
        return false;
    }
    if (!styles2) {
        return true;
    }
    for (const field in styles1) {
        // @ts-expect-error - ts doesn't like that `field` is a string
        // eslint-disable-next-line no-prototype-builtins
        if (styles1.hasOwnProperty(field) && styles1[field] !== styles2[field]) {
            return false;
        }
    }
    return true;
};
class Sticky extends react_1.Component {
    constructor() {
        super(...arguments);
        this.holderEl = null;
        this.wrapperEl = null;
        this.el = null;
        this.scrollEl = null;
        this.boundaryEl = null;
        this.disabled = false;
        this.checkPositionIntervalId = null;
        this.lastMinHeight = null;
        this.state = {
            isFixed: false,
            wrapperStyles: undefined,
            holderStyles: undefined,
            height: 0
        };
        this.holderRef = (holderEl) => {
            if (holderEl === this.holderEl) {
                return;
            }
            this.holderEl = holderEl;
        };
        this.wrapperRef = (wrapperEl) => {
            if (wrapperEl === this.wrapperEl) {
                return;
            }
            this.wrapperEl = wrapperEl;
            this.updateScrollEl();
            this.updateBoundaryEl();
        };
        this.checkPosition = () => {
            const { holderEl, wrapperEl, boundaryEl, scrollEl, disabled } = this;
            if (!scrollEl || !holderEl || !wrapperEl) {
                console.error("Missing required elements:", {
                    scrollEl,
                    holderEl,
                    wrapperEl
                });
                return;
            }
            const { mode, onFixedToggle, offsetTransforms, isIOSFixEnabled, dontUpdateHolderHeightWhenSticky } = this.props;
            if (disabled) {
                if (this.state.isFixed) {
                    this.setState({ isFixed: false, wrapperStyles: {} });
                }
                return;
            }
            if (!holderEl.getBoundingClientRect || !wrapperEl.getBoundingClientRect) {
                return;
            }
            const holderRect = holderEl.getBoundingClientRect();
            const wrapperRect = wrapperEl.getBoundingClientRect();
            const boundaryRect = boundaryEl ? (0, rect_1.getRect)(boundaryEl) : rect_1.infiniteRect;
            const scrollRect = (0, rect_1.getRect)(scrollEl);
            const isFixed = this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);
            let offsets = null;
            if (offsetTransforms && isFixed && scrollEl instanceof HTMLElement) {
                const closestTransformedParent = (0, getClosestTransformedParent_1.default)(scrollEl);
                if (closestTransformedParent) {
                    offsets = (0, rect_1.getRect)(closestTransformedParent);
                }
            }
            const minHeight = this.state.isFixed && dontUpdateHolderHeightWhenSticky && this.lastMinHeight ? this.lastMinHeight : wrapperRect.height;
            this.lastMinHeight = minHeight;
            // To ensure that this component becomes sticky immediately on mobile devices instead
            // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
            // to 'kick' rendering of this element to the GPU
            // @see http://stackoverflow.com/questions/32875046
            const iosRenderingFixStyles = isIOSFixEnabled ? {
                transform: 'translateZ(0)',
                WebkitTransform: 'translateZ(0)'
            } : undefined;
            const newState = {
                isFixed,
                height: wrapperRect.height,
                holderStyles: { minHeight: `${minHeight}px` },
                wrapperStyles: isFixed ? Object.assign(Object.assign({}, iosRenderingFixStyles), buildStickyStyle(mode, this.props, {
                    boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
                    boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
                    top: mode === 'top' ? scrollRect.top - (offsets ? offsets.top : 0) : 0,
                    bottom: mode === 'bottom' ? scrollRect.bottom - (offsets ? offsets.bottom : 0) : 0,
                    width: holderRect.width,
                    height: wrapperRect.height
                })) : iosRenderingFixStyles
            };
            if (isFixed !== this.state.isFixed && onFixedToggle && typeof onFixedToggle === 'function') {
                onFixedToggle(isFixed);
            }
            if (!isEqual(this.state, newState)) {
                this.setState(newState);
            }
        };
    }
    isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
        const { hideOnBoundaryHit, bottomOffset, topOffset, mode } = this.props;
        if (this.disabled) {
            return false;
        }
        if (hideOnBoundaryHit && boundaryRect && !(0, rect_1.isIntersecting)(boundaryRect, scrollRect, topOffset, bottomOffset)) {
            return false;
        }
        const hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;
        if (mode === 'top') {
            return (holderRect.top + topOffset < scrollRect.top)
                && (scrollRect.top + hideOffset <= boundaryRect.bottom);
        }
        return (holderRect.bottom - topOffset > scrollRect.bottom)
            && (scrollRect.bottom - hideOffset >= boundaryRect.top);
    }
    updateScrollEl() {
        if (!this.wrapperEl) {
            return;
        }
        if (this.scrollEl) {
            (0, events_1.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
            this.scrollEl = null;
        }
        const { scrollElement } = this.props;
        if (typeof scrollElement === 'string') {
            this.scrollEl = (0, find_1.default)(scrollElement, this.wrapperEl);
        }
        else {
            this.scrollEl = scrollElement;
        }
        if (this.scrollEl) {
            (0, events_1.listen)(this.scrollEl, ['scroll'], this.checkPosition);
        }
        else {
            console.error('Cannot find scrollElement ' + (typeof scrollElement === 'string' ? scrollElement : 'unknown'));
        }
    }
    updateBoundaryEl() {
        if (!this.wrapperEl) {
            return;
        }
        const { boundaryElement } = this.props;
        this.boundaryEl = (0, find_1.default)(boundaryElement, this.wrapperEl);
        if (this.boundaryEl === window || this.boundaryEl === document) {
            // such objects can't be used as boundary
            // and in fact there is no point in such a case
            this.boundaryEl = null;
        }
    }
    initialize() {
        const { positionRecheckInterval, disabled } = this.props;
        this.disabled = disabled;
        // we should always listen to window events because they will affect the layout of the whole page
        (0, events_1.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
        this.checkPosition();
        if (positionRecheckInterval) {
            this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
        }
    }
    componentDidUpdate({ scrollElement, boundaryElement, disabled }) {
        if (scrollElement !== this.props.scrollElement || this.scrollEl === null) {
            this.updateScrollEl();
        }
        if (boundaryElement !== this.props.boundaryElement || this.boundaryEl === null) {
            this.updateBoundaryEl();
        }
        if (disabled !== this.props.disabled) {
            this.disabled = this.props.disabled;
            this.checkPosition();
        }
    }
    componentDidMount() {
        this.initialize();
        if (this.wrapperEl === null) {
            console.error("Wrapper element is missing, please make sure that you have assigned refs correctly");
        }
    }
    componentWillUnmount() {
        if (this.scrollEl) {
            (0, events_1.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
        }
        (0, events_1.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
        this.boundaryEl = null;
        this.scrollEl = null;
        if (this.checkPositionIntervalId) {
            clearInterval(this.checkPositionIntervalId);
        }
    }
    render() {
        const { holderRef, wrapperRef } = this;
        const { isFixed, wrapperStyles, holderStyles } = this.state;
        return this.props.children({
            holderRef,
            wrapperRef,
            isFixed,
            wrapperStyles,
            holderStyles
        });
    }
}
Sticky.defaultProps = {
    mode: 'top',
    topOffset: 0,
    bottomOffset: 0,
    isIOSFixEnabled: true,
    offsetTransforms: true,
    disabled: false,
    onFixedToggle: undefined,
    boundaryElement: undefined,
    hideOnBoundaryHit: true,
    scrollElement: 'window',
    dontUpdateHolderHeightWhenSticky: false,
};
exports["default"] = Sticky;


/***/ }),

/***/ 38551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_unused_export__ = createFilter;
__webpack_unused_export__ = createWhitelistFilter;
__webpack_unused_export__ = createBlacklistFilter;
__webpack_unused_export__ = persistFilter;

var _reduxPersist = __webpack_require__(97568);

var _lodash = __webpack_require__(29208);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(31468);

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__(96633);

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = __webpack_require__(16040);

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = __webpack_require__(99245);

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = __webpack_require__(60790);

var _lodash12 = _interopRequireDefault(_lodash11);

var _lodash13 = __webpack_require__(83465);

var _lodash14 = _interopRequireDefault(_lodash13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createFilter(reducerName, inboundPaths, outboundPaths) {
	var transformType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'whitelist';

	return (0, _reduxPersist.createTransform)(
	// inbound
	function (inboundState, key) {
		return inboundPaths ? persistFilter(inboundState, inboundPaths, transformType) : inboundState;
	},

	// outbound
	function (outboundState, key) {
		return outboundPaths ? persistFilter(outboundState, outboundPaths, transformType) : outboundState;
	}, { 'whitelist': [reducerName] });
};

function createWhitelistFilter(reducerName, inboundPaths, outboundPaths) {
	return createFilter(reducerName, inboundPaths, outboundPaths, 'whitelist');
}

function createBlacklistFilter(reducerName, inboundPaths, outboundPaths) {
	return createFilter(reducerName, inboundPaths, outboundPaths, 'blacklist');
}

function filterObject(_ref, state) {
	var path = _ref.path,
	    _ref$filterFunction = _ref.filterFunction,
	    filterFunction = _ref$filterFunction === undefined ? function () {
		return true;
	} : _ref$filterFunction;

	var value = (0, _lodash2.default)(state, path, state);

	if (value instanceof Array) {
		return value.filter(filterFunction);
	}

	return (0, _lodash8.default)(value, filterFunction);
}

function persistFilter(state) {
	var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var transformType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'whitelist';

	var subset = {};

	// support only one key
	if (typeof paths === 'string') {
		paths = [paths];
	}

	if (transformType === 'whitelist') {
		paths.forEach(function (path) {
			if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && !(path instanceof Array)) {
				var value = filterObject(path, state);

				if (!(0, _lodash10.default)(value)) {
					(0, _lodash4.default)(subset, path.path, value);
				}
			} else {
				var _value = (0, _lodash2.default)(state, path);

				if (typeof _value !== 'undefined') {
					(0, _lodash4.default)(subset, path, _value);
				}
			}
		});
	} else if (transformType === 'blacklist') {
		subset = (0, _lodash14.default)(state);
		paths.forEach(function (path) {
			if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && !(path instanceof Array)) {
				var value = filterObject(path, state);

				if (!(0, _lodash10.default)(value)) {
					if (value instanceof Array) {
						(0, _lodash4.default)(subset, path.path, (0, _lodash2.default)(subset, path.path, subset).filter(function (x) {
							return false;
						}));
					} else {
						(0, _lodash12.default)(value, function (value, key) {
							(0, _lodash6.default)(subset, path.path + '[' + key + ']');
						});
					}
				} else {
					subset = value;
				}
			} else {
				var _value2 = (0, _lodash2.default)(state, path);

				if (typeof _value2 !== 'undefined') {
					(0, _lodash6.default)(subset, path);
				}
			}
		});
	} else {
		subset = state;
	}

	return subset;
}

exports.ZP = createFilter;


/***/ }),

/***/ 97568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_VERSION": function() { return /* reexport */ DEFAULT_VERSION; },
  "FLUSH": function() { return /* reexport */ FLUSH; },
  "KEY_PREFIX": function() { return /* reexport */ KEY_PREFIX; },
  "PAUSE": function() { return /* reexport */ PAUSE; },
  "PERSIST": function() { return /* reexport */ PERSIST; },
  "PURGE": function() { return /* reexport */ PURGE; },
  "REGISTER": function() { return /* reexport */ REGISTER; },
  "REHYDRATE": function() { return /* reexport */ REHYDRATE; },
  "createMigrate": function() { return /* reexport */ createMigrate; },
  "createPersistoid": function() { return /* reexport */ createPersistoid; },
  "createTransform": function() { return /* reexport */ createTransform; },
  "getStoredState": function() { return /* reexport */ getStoredState_getStoredState; },
  "persistCombineReducers": function() { return /* reexport */ persistCombineReducers; },
  "persistReducer": function() { return /* reexport */ persistReducer; },
  "persistStore": function() { return /* reexport */ persistStore; },
  "purgeStoredState": function() { return /* reexport */ purgeStoredState; }
});

;// CONCATENATED MODULE: ./node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel1.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/
function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      } // otherwise hard set the new value


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createPersistoid.js

// @TODO remove once flow < 0.63 support is no longer required.
function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var serialize;

  if (config.serialize === false) {
    serialize = function serialize(x) {
      return x;
    };
  } else if (typeof config.serialize === 'function') {
    serialize = config.serialize;
  } else {
    serialize = defaultSerialize;
  }

  var writeFailHandler = config.writeFailHandler || null; // initialize stateful values

  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop

      if (lastState[key] === state[key]) return; // value unchanged? noop

      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop

      keysToProcess.push(key); // add key to queue
    }); //if any key is missing in the new state which was present in the lastState,
    //add it for processing too

    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) {
        keysToProcess.push(key);
      }
    }); // start the time iterator if not running (read: throttle)

    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });
    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (writeFailHandler) writeFailHandler(err);

    if (err && "production" !== 'production') {}
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }

    return writePromise || Promise.resolve();
  }; // return `persistoid`


  return {
    update: update,
    flush: flush
  };
} // @NOTE in the future this may be exposed via config

function defaultSerialize(data) {
  return JSON.stringify(data);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/getStoredState.js

function getStoredState_getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;

  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }

  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) {}
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/purgeStoredState.js

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {}
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistReducer.js
function persistReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistReducer_ownKeys(source, true).forEach(function (key) { persistReducer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistReducer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistReducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/

function persistReducer(config, baseReducer) {
  if (false) {}

  var version = config.version !== undefined ? config.version : DEFAULT_VERSION;
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? autoMergeLevel1 : config.stateReconciler;
  var getStoredState = config.getStoredState || getStoredState_getStoredState;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;

  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ["_persist"]); // $FlowIgnore need to update State type


    var restState = rest;

    if (action.type === PERSIST) {
      var _sealed = false;

      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) {} // only rehydrate if we are not already sealed

        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };

      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
      }, timeout); // @NOTE PERSIST resumes if paused.

      _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set

      if (!_persistoid) _persistoid = createPersistoid(config); // @NOTE PERSIST can be called multiple times, noop after the first

      if (_persist) {
        // We still need to call the base reducer because there might be nested
        // uses of persistReducer which need to be aware of the PERSIST action
        return persistReducer_objectSpread({}, baseReducer(restState, action), {
          _persist: _persist
        });
      }

      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
      action.register(config.key);
      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };

        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) {}

          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: {
          version: version,
          rehydrated: false
        }
      });
    } else if (action.type === PURGE) {
      _purge = true;
      action.result(purgeStoredState(config));
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === PAUSE) {
      _paused = true;
    } else if (action.type === REHYDRATE) {
      // noop on restState if purging
      if (_purge) return persistReducer_objectSpread({}, restState, {
        _persist: persistReducer_objectSpread({}, _persist, {
          rehydrated: true
        }) // @NOTE if key does not match, will continue to default else below

      });

      if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined

        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = persistReducer_objectSpread({}, reconciledRest, {
          _persist: persistReducer_objectSpread({}, _persist, {
            rehydrated: true
          })
        });

        return conditionalUpdate(_newState);
      }
    } // if we have not already handled PERSIST, straight passthrough


    if (!_persist) return baseReducer(state, action); // run base reducer:
    // is state modified ? return original : return updated

    var newState = baseReducer(restState, action);
    if (newState === restState) return state;
    return conditionalUpdate(persistReducer_objectSpread({}, newState, {
      _persist: _persist
    }));
  };
}
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel2.js
function autoMergeLevel2_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { autoMergeLevel2_typeof = function _typeof(obj) { return typeof obj; }; } else { autoMergeLevel2_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return autoMergeLevel2_typeof(obj); }

function autoMergeLevel2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function autoMergeLevel2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { autoMergeLevel2_ownKeys(source, true).forEach(function (key) { autoMergeLevel2_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { autoMergeLevel2_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function autoMergeLevel2_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = autoMergeLevel2_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && autoMergeLevel2_typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = autoMergeLevel2_objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && autoMergeLevel2_typeof(o) === 'object';
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistCombineReducers.js



// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? autoMergeLevel2 : config.stateReconciler;
  return persistReducer(config, (0,redux/* combineReducers */.UY)(reducers));
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistStore.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function persistStore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistStore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistStore_ownKeys(source, true).forEach(function (key) { persistStore_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistStore_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistStore_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case REGISTER:
      return persistStore_objectSpread({}, state, {
        registry: [].concat(_toConsumableArray(state.registry), [action.key])
      });

    case REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);

      var registry = _toConsumableArray(state.registry);

      registry.splice(firstIndex, 1);
      return persistStore_objectSpread({}, state, {
        registry: registry,
        bootstrapped: registry.length === 0
      });

    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) { var bannedKeys, optionsToTest; }

  var boostrappedCb = cb || false;

  var _pStore = (0,redux/* createStore */.MT)(persistorReducer, initialState, options && options.enhancer ? options.enhancer : undefined);

  var register = function register(key) {
    _pStore.dispatch({
      type: REGISTER,
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: REHYDRATE,
      payload: payload,
      err: err,
      key: key // dispatch to `store` to rehydrate and `persistor` to track result

    };
    store.dispatch(rehydrateAction);

    _pStore.dispatch(rehydrateAction);

    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = persistStore_objectSpread({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({
        type: PERSIST,
        register: register,
        rehydrate: rehydrate
      });
    }
  });

  if (!(options && options.manualPersist)) {
    persistor.persist();
  }

  return persistor;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createMigrate.js

function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) {}
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : DEFAULT_VERSION;

    if (inboundVersion === currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    if (inboundVersion > currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });
    if (false) {}

    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) {}
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createTransform.js
function createTransform( // @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound, // @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/index.js










/***/ }),

/***/ 1190:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = autoMergeLevel2;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && _typeof(o) === 'object';
}

/***/ }),

/***/ 23488:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = createWebStorage;

var _getStorage = _interopRequireDefault(__webpack_require__(77290));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),

/***/ 77290:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = getStorage;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === "undefined" ? "undefined" : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = "redux-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) {}
    return false;
  }

  return true;
}

function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {}

    return noopStorage;
  }
}

/***/ }),

/***/ 45217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "md": function() { return /* binding */ applyMiddleware; },
  "UY": function() { return /* binding */ combineReducers; },
  "qC": function() { return /* binding */ compose; },
  "MT": function() { return /* binding */ createStore; }
});

// UNUSED EXPORTS: __DO_NOT_USE__ActionTypes, bindActionCreators, legacy_createStore

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),

/***/ 91033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 35747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var deletedNode = listDelete($o, key);
			if (deletedNode && $o && !$o.next) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	return channel;
};


/***/ }),

/***/ 23595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 71169:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 41476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(__webpack_require__(57848));
var utilities_1 = __webpack_require__(26678);
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;


/***/ }),

/***/ 26678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;


/***/ }),

/***/ 57848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18139);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 74279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ 65885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ }),

/***/ 83:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 26251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(61688);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(83);
} else {}


/***/ }),

/***/ 52798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(26251);
} else {}


/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 199:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 7638:
/***/ (function(module, exports, __webpack_require__) {

var fetchApi = typeof fetch === 'function' ? fetch : undefined
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch
}

if ( true && typeof window === 'undefined') {
  var f = fetchApi || __webpack_require__(54098)
  if (f.default) f = f.default
  exports["default"] = f
  module.exports = exports.default
}


/***/ }),

/***/ 78122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var _request = _interopRequireDefault(__webpack_require__(93183));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: _request.default,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  return _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options || {}), options);
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        var timer = setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
        if (_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = (0, _utils.makePromise)(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message) {
          var errorMessage = err.message.toLowerCase();
          var isNetworkError = ['failed', 'fetch', 'network', 'load'].find(function (term) {
            return errorMessage.indexOf(term) > -1;
          });
          if (isNetworkError) {
            return callback('failed loading ' + url + ': ' + err.message, true);
          }
        }
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
}();
Backend.type = 'backend';
var _default = exports["default"] = Backend;
module.exports = exports.default;

/***/ }),

/***/ 93183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var fetchNode = _interopRequireWildcard(__webpack_require__(7638));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch;
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch;
}
var XmlHttpRequestApi;
if ((0, _utils.hasXMLHttpRequest)()) {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.XMLHttpRequest) {
    XmlHttpRequestApi = __webpack_require__.g.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.ActiveXObject) {
    ActiveXObjectApi = __webpack_require__.g.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = fetchNode.default || fetchNode;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && _typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
  var resolver = function resolver(response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  };
  if (altFetch) {
    var altResponse = altFetch(url, fetchOptions);
    if (altResponse instanceof Promise) {
      altResponse.then(resolver).catch(callback);
      return;
    }
  }
  if (typeof fetch === 'function') {
    fetch(url, fetchOptions).then(resolver).catch(callback);
  } else {
    fetchApi(url, fetchOptions).then(resolver).catch(callback);
  }
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = _objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (typeof window === 'undefined' && typeof __webpack_require__.g !== 'undefined' && typeof __webpack_require__.g.process !== 'undefined' && __webpack_require__.g.process.versions && __webpack_require__.g.process.versions.node) {
    headers['User-Agent'] = "i18next-http-backend (node/".concat(__webpack_require__.g.process.version, "; ").concat(__webpack_require__.g.process.platform, " ").concat(__webpack_require__.g.process.arch, ")");
  }
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = _objectSpread({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
  try {
    fetchIt(url, fetchOptions, callback, altFetch);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback, altFetch);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && _typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if ((0, _utils.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
var _default = exports["default"] = request;
module.exports = exports.default;

/***/ }),

/***/ 58144:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaults = defaults;
exports.hasXMLHttpRequest = hasXMLHttpRequest;
exports.makePromise = makePromise;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, e);
}


/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 24750:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x7": function() { return /* binding */ floating_ui_dom_arrow; },
  "Me": function() { return /* binding */ autoUpdate; },
  "oo": function() { return /* binding */ floating_ui_dom_computePosition; },
  "RR": function() { return /* binding */ floating_ui_dom_flip; },
  "Qo": function() { return /* binding */ floating_ui_dom_inline; },
  "dr": function() { return /* binding */ floating_ui_dom_limitShift; },
  "cv": function() { return /* binding */ floating_ui_dom_offset; },
  "uY": function() { return /* binding */ floating_ui_dom_shift; },
  "dp": function() { return /* binding */ floating_ui_dom_size; }
});

// UNUSED EXPORTS: autoPlacement, detectOverflow, getOverflowAncestors, hide, platform

;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const floating_ui_utils_sides = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (floating_ui_utils_sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const lrPlacement = ['left', 'right'];
const rlPlacement = ['right', 'left'];
const tbPlacement = ['top', 'bottom'];
const btPlacement = ['bottom', 'top'];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case 'left':
    case 'right':
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  const side = floating_ui_utils_getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = floating_ui_utils_getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (floating_ui_utils_getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = floating_ui_utils_evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const MAX_RESET_COUNT = 50;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const platformWithDetectOverflow = platform.detectOverflow ? platform : {
    ...platform,
    detectOverflow
  };
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData[name] = {
      ...middlewareData[name],
      ...data
    };
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = floating_ui_utils_evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && floating_ui_utils_getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = floating_ui_utils_getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = floating_ui_utils_getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = floating_ui_utils_getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow ||
          // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every(d => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            // Try next placement and re-run the lifecycle.
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects,
        platform
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await platform.detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await platform.detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = floating_ui_utils_evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = floating_ui_utils_getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = floating_ui_utils_getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

const originSides = /*#__PURE__*/new Set(['left', 'top']);

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = floating_ui_utils_getSide(placement);
  const alignment = floating_ui_utils_getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = floating_ui_utils_evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement,
        platform
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(floating_ui_utils_getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = floating_ui_utils_evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = originSides.has(floating_ui_utils_getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const overflow = await platform.detectOverflow(state, detectOverflowOptions);
      const side = floating_ui_utils_getSide(placement);
      const alignment = floating_ui_utils_getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(37317);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs





function getCssDimensions(element) {
  const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !(0,floating_ui_utils_dom/* isElement */.kK)(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if (!(0,floating_ui_utils_dom/* isWebKit */.Pf)() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0,floating_ui_utils_dom/* getWindow */.Jj)(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(domElement);
    const offsetWin = offsetParent && (0,floating_ui_utils_dom/* isElement */.kK)(offsetParent) ? (0,floating_ui_utils_dom/* getWindow */.Jj)(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = (0,floating_ui_utils_dom/* getWindow */.Jj)(currentIFrame);
      currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const topLayer = elements ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if ((0,floating_ui_utils_dom/* getComputedStyle */.Dx)(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = (0,floating_ui_utils_dom/* isWebKit */.Pf)();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
  // visual width of the <html> but this is not considered in the size
  // of `html.clientWidth`.
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element));
  } else if ((0,floating_ui_utils_dom/* isElement */.kK)(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
  if (parentNode === stopNode || !(0,floating_ui_utils_dom/* isElement */.kK)(parentNode) || (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(parentNode)) {
    return false;
  }
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(element, [], false).filter(el => (0,floating_ui_utils_dom/* isElement */.kK)(el) && (0,floating_ui_utils_dom/* getNodeName */.wk)(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed';
  let currentNode = elementIsFixed ? (0,floating_ui_utils_dom/* getParentNode */.Ow)(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while ((0,floating_ui_utils_dom/* isElement */.kK)(currentNode) && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(currentNode)) {
    const computedStyle = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentNode);
    const currentNodeIsContaining = (0,floating_ui_utils_dom/* isContainingBlock */.hT)(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top = firstRect.top;
  let right = firstRect.right;
  let bottom = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
    top = max(rect.top, top);
    right = min(rect.right, right);
    bottom = min(rect.bottom, bottom);
    left = max(rect.left, left);
  }
  return {
    width: right - left,
    height: bottom - top,
    x: left,
    y: top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);

  // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
  // Firefox with layout.scrollbar.side = 3 in about:config to test this.
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) || (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if ((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if ((0,floating_ui_utils_dom/* isTopLayer */.tR)(element)) {
    return win;
  }
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element)) {
    let svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
    while (svgOffsetParent && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(svgOffsetParent)) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && (0,floating_ui_utils_dom/* isTableElement */.Ze)(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(offsetParent) && isStaticPositioned(offsetParent) && !(0,floating_ui_utils_dom/* isContainingBlock */.hT)(offsetParent)) {
    return win;
  }
  return offsetParent || (0,floating_ui_utils_dom/* getContainingBlock */.gQ)(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: floating_ui_utils_dom/* getDocumentElement */.tF,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: floating_ui_utils_dom/* isElement */.kK,
  isRTL
};

function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(referenceEl) : []), ...(floating ? (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(floating) : [])] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const floating_ui_dom_detectOverflow = (/* unused pure expression or super */ null && (detectOverflow$1));

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_dom_offset = offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = (/* unused pure expression or super */ null && (autoPlacement$1));

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = (/* unused pure expression or super */ null && (hide$1));

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = limitShift;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};




/***/ }),

/***/ 1371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qo": function() { return /* binding */ inline; },
/* harmony export */   "RR": function() { return /* binding */ flip; },
/* harmony export */   "YF": function() { return /* binding */ useFloating; },
/* harmony export */   "cv": function() { return /* binding */ offset; },
/* harmony export */   "dp": function() { return /* binding */ size; },
/* harmony export */   "dr": function() { return /* binding */ limitShift; },
/* harmony export */   "uY": function() { return /* binding */ shift; },
/* harmony export */   "x7": function() { return /* binding */ arrow; }
/* harmony export */ });
/* unused harmony exports autoPlacement, hide */
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24750);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);






var isClient = typeof document !== 'undefined';

var noop = function noop() {};
var index = isClient ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : noop;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react__WEBPACK_IMPORTED_MODULE_0__.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const [_floating, _setFloating] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const setReference = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const floatingRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const openRef = useLatestRef(open);
  const update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .computePosition */ .oo)(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .offset */ .cv)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .shift */ .uY)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .limitShift */ .dr)(options);
  return {
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .flip */ .RR)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = (options, deps) => {
  const result = autoPlacement$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = (options, deps) => {
  const result = hide$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = (options, deps) => {
  const result = (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .inline */ .Qo)(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = (options, deps) => {
  const result = arrow$1(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};




/***/ }),

/***/ 46504:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bQ": function() { return /* binding */ useDismiss; },
  "YF": function() { return /* binding */ useFloating; },
  "KK": function() { return /* binding */ useFocus; },
  "XI": function() { return /* binding */ useHover; },
  "NI": function() { return /* binding */ useInteractions; },
  "qs": function() { return /* binding */ useRole; }
});

// UNUSED EXPORTS: Composite, CompositeItem, FloatingArrow, FloatingDelayGroup, FloatingFocusManager, FloatingList, FloatingNode, FloatingOverlay, FloatingPortal, FloatingTree, NextFloatingDelayGroup, arrow, autoPlacement, autoUpdate, computePosition, detectOverflow, flip, getOverflowAncestors, hide, inline, inner, limitShift, offset, platform, safePolygon, shift, size, useClick, useClientPoint, useDelayGroup, useDelayGroupContext, useFloatingNodeId, useFloatingParentNodeId, useFloatingPortalNode, useFloatingRootContext, useFloatingTree, useId, useInnerOffset, useListItem, useListNavigation, useMergeRefs, useNextDelayGroup, useTransitionStatus, useTransitionStyles, useTypeahead

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(37317);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs






// Avoid Chrome DevTools blue warning.
function floating_ui_react_utils_getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function floating_ui_react_utils_getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}
function floating_ui_react_utils_isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(floating_ui_react_utils_getPlatform()) || re.test(floating_ui_react_utils_getUserAgent());
}
function isMac() {
  return floating_ui_react_utils_getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return floating_ui_react_utils_getUserAgent().includes('jsdom/');
}

const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';

function floating_ui_react_utils_activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && (0,floating_ui_utils_dom/* isShadowRoot */.Zq)(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function floating_ui_react_utils_isTypeableElement(element) {
  return (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) && element.matches(TYPEABLE_SELECTOR);
}
function floating_ui_react_utils_isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && floating_ui_react_utils_isTypeableElement(element);
}
function matchesFocusVisible(element) {
  // We don't want to block focus from working with `visibleOnly`
  // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
  if (!element || isJSDOM()) return true;
  try {
    return element.matches(':focus-visible');
  } catch (_e) {
    return true;
  }
}
function floating_ui_react_utils_getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  // Try to find the element that has `{...getFloatingProps()}` spread on it.
  // This indicates the floating element is acting as a positioning wrapper, and
  // so focus should be managed on the child element with the event handlers and
  // aria props.
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}

function getNodeChildren(nodes, id, onlyOpenChildren) {
  if (onlyOpenChildren === void 0) {
    onlyOpenChildren = true;
  }
  const directChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
  });
  return directChildren.flatMap(child => [child, ...getNodeChildren(nodes, child.id, onlyOpenChildren)]);
}
function floating_ui_react_utils_getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getNodeChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}
function floating_ui_react_utils_getNodeAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function floating_ui_react_utils_stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function floating_ui_react_utils_isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function floating_ui_react_utils_isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function floating_ui_react_utils_isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}

var isClient = typeof document !== 'undefined';

var noop = function noop() {};
var index = isClient ? react.useLayoutEffect : noop;

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
  ...react_namespaceObject
};

function floating_ui_react_utils_useLatestRef(value) {
  const ref = react.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function floating_ui_react_utils_useEffectEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

function isDifferentGridRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function floating_ui_react_utils_isIndexOutOfListBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function floating_ui_react_utils_getMinListIndex(listRef, disabledIndices) {
  return floating_ui_react_utils_findNonDisabledListIndex(listRef, {
    disabledIndices
  });
}
function floating_ui_react_utils_getMaxListIndex(listRef, disabledIndices) {
  return floating_ui_react_utils_findNonDisabledListIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function floating_ui_react_utils_findNonDisabledListIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= listRef.current.length - 1 && floating_ui_react_utils_isListIndexDisabled(listRef, index, disabledIndices));
  return index;
}
function floating_ui_react_utils_getGridNavigatedIndex(listRef, _ref) {
  let {
    event,
    orientation,
    loop,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && floating_ui_react_utils_stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (floating_ui_react_utils_isIndexOutOfListBounds(listRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && floating_ui_react_utils_stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (floating_ui_react_utils_isIndexOutOfListBounds(listRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = floor(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      stop && floating_ui_react_utils_stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      stop && floating_ui_react_utils_stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = floating_ui_react_utils_findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (floating_ui_react_utils_isIndexOutOfListBounds(listRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : floating_ui_react_utils_findNonDisabledListIndex(listRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function floating_ui_react_utils_createGridCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (false) {}
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] == null)) {
        targetCells.forEach(cell => {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function floating_ui_react_utils_getGridCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  const sizeItem = sizes[index];
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case 'bl':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function floating_ui_react_utils_getGridCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}
function floating_ui_react_utils_isListIndexDisabled(listRef, index, disabledIndices) {
  if (typeof disabledIndices === 'function') {
    return disabledIndices(index);
  } else if (disabledIndices) {
    return disabledIndices.includes(index);
  }
  const element = listRef.current[index];
  return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}

const floating_ui_react_utils_getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, dir) {
  const list = tabbable(container, floating_ui_react_utils_getTabbableOptions());
  const len = list.length;
  if (len === 0) return;
  const active = floating_ui_react_utils_activeElement(getDocument(container));
  const index = list.indexOf(active);
  const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
  return list[nextIndex];
}
function floating_ui_react_utils_getNextTabbable(referenceElement) {
  return getTabbableIn(getDocument(referenceElement).body, 1) || referenceElement;
}
function floating_ui_react_utils_getPreviousTabbable(referenceElement) {
  return getTabbableIn(getDocument(referenceElement).body, -1) || referenceElement;
}
function floating_ui_react_utils_isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function floating_ui_react_utils_disableFocusInside(container) {
  const tabbableElements = tabbable(container, floating_ui_react_utils_getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function floating_ui_react_utils_enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}



// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(1371);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.mjs










/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
function useMergeRefs(refs) {
  const cleanupRef = React.useRef(undefined);
  const refEffect = React.useCallback(instance => {
    const cleanups = refs.map(ref => {
      if (ref == null) {
        return;
      }
      if (typeof ref === 'function') {
        const refCallback = ref;
        const refCleanup = refCallback(instance);
        return typeof refCleanup === 'function' ? refCleanup : () => {
          refCallback(null);
        };
      }
      ref.current = instance;
      return () => {
        ref.current = null;
      };
    });
    return () => {
      cleanups.forEach(refCleanup => refCleanup == null ? void 0 : refCleanup());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
  return React.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = undefined;
      }
      if (value != null) {
        cleanupRef.current = refEffect(value);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

function sortByDocumentPosition(a, b) {
  const position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
const FloatingListContext = /*#__PURE__*/react.createContext({
  register: () => {},
  unregister: () => {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(props) {
  const {
    children,
    elementsRef,
    labelsRef
  } = props;
  const [nodes, setNodes] = React.useState(() => new Set());
  const register = React.useCallback(node => {
    setNodes(prevSet => new Set(prevSet).add(node));
  }, []);
  const unregister = React.useCallback(node => {
    setNodes(prevSet => {
      const set = new Set(prevSet);
      set.delete(node);
      return set;
    });
  }, []);
  const map = React.useMemo(() => {
    const newMap = new Map();
    const sortedNodes = Array.from(nodes.keys()).sort(sortByDocumentPosition);
    sortedNodes.forEach((node, index) => {
      newMap.set(node, index);
    });
    return newMap;
  }, [nodes]);
  return /*#__PURE__*/jsx(FloatingListContext.Provider, {
    value: React.useMemo(() => ({
      register,
      unregister,
      map,
      elementsRef,
      labelsRef
    }), [register, unregister, map, elementsRef, labelsRef]),
    children: children
  });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */
function useListItem(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    label
  } = props;
  const {
    register,
    unregister,
    map,
    elementsRef,
    labelsRef
  } = React.useContext(FloatingListContext);
  const [index, setIndex] = React.useState(null);
  const componentRef = React.useRef(null);
  const ref = React.useCallback(node => {
    componentRef.current = node;
    if (index !== null) {
      elementsRef.current[index] = node;
      if (labelsRef) {
        var _node$textContent;
        const isLabelDefined = label !== undefined;
        labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index, elementsRef, labelsRef, label]);
  useModernLayoutEffect(() => {
    const node = componentRef.current;
    if (node) {
      register(node);
      return () => {
        unregister(node);
      };
    }
  }, [register, unregister]);
  useModernLayoutEffect(() => {
    const index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return React.useMemo(() => ({
    ref,
    index: index == null ? -1 : index
  }), [index, ref]);
}

const floating_ui_react_FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
const floating_ui_react_ARROW_LEFT = 'ArrowLeft';
const floating_ui_react_ARROW_RIGHT = 'ArrowRight';
const floating_ui_react_ARROW_UP = 'ArrowUp';
const floating_ui_react_ARROW_DOWN = 'ArrowDown';

function renderJsx(render, computedProps) {
  if (typeof render === 'function') {
    return render(computedProps);
  }
  if (render) {
    return /*#__PURE__*/React.cloneElement(render, computedProps);
  }
  return /*#__PURE__*/jsx("div", {
    ...computedProps
  });
}
const CompositeContext = /*#__PURE__*/react.createContext({
  activeIndex: 0,
  onNavigate: () => {}
});
const horizontalKeys = [floating_ui_react_ARROW_LEFT, floating_ui_react_ARROW_RIGHT];
const verticalKeys = [floating_ui_react_ARROW_UP, floating_ui_react_ARROW_DOWN];
const allKeys = [...horizontalKeys, ...verticalKeys];

/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */
const Composite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Composite(props, forwardedRef) {
  const {
    render,
    orientation = 'both',
    loop = true,
    rtl = false,
    cols = 1,
    disabledIndices,
    activeIndex: externalActiveIndex,
    onNavigate: externalSetActiveIndex,
    itemSizes,
    dense = false,
    ...domProps
  } = props;
  const [internalActiveIndex, internalSetActiveIndex] = React.useState(0);
  const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
  const onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
  const elementsRef = React.useRef([]);
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const contextValue = React.useMemo(() => ({
    activeIndex,
    onNavigate
  }), [activeIndex, onNavigate]);
  const isGrid = cols > 1;
  function handleKeyDown(event) {
    if (!allKeys.includes(event.key)) return;
    let nextIndex = activeIndex;
    const minIndex = getMinListIndex(elementsRef, disabledIndices);
    const maxIndex = getMaxListIndex(elementsRef, disabledIndices);
    const horizontalEndKey = rtl ? floating_ui_react_ARROW_LEFT : floating_ui_react_ARROW_RIGHT;
    const horizontalStartKey = rtl ? floating_ui_react_ARROW_RIGHT : floating_ui_react_ARROW_LEFT;
    if (isGrid) {
      const sizes = itemSizes || Array.from({
        length: elementsRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = createGridCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isListIndexDisabled(elementsRef, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isListIndexDisabled(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const maybeNextIndex = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex ? elementsRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getGridCellIndices([...((typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index) => isListIndexDisabled(elementsRef, index, disabledIndices) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getGridCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction we're
        // moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === floating_ui_react_ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
      })];
      if (maybeNextIndex != null) {
        nextIndex = maybeNextIndex;
      }
    }
    const toEndKeys = {
      horizontal: [horizontalEndKey],
      vertical: [floating_ui_react_ARROW_DOWN],
      both: [horizontalEndKey, floating_ui_react_ARROW_DOWN]
    }[orientation];
    const toStartKeys = {
      horizontal: [horizontalStartKey],
      vertical: [floating_ui_react_ARROW_UP],
      both: [horizontalStartKey, floating_ui_react_ARROW_UP]
    }[orientation];
    const preventedKeys = isGrid ? allKeys : {
      horizontal: horizontalKeys,
      vertical: verticalKeys,
      both: allKeys
    }[orientation];
    if (nextIndex === activeIndex && [...toEndKeys, ...toStartKeys].includes(event.key)) {
      if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) {
        nextIndex = minIndex;
      } else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) {
        nextIndex = maxIndex;
      } else {
        nextIndex = findNonDisabledListIndex(elementsRef, {
          startingIndex: nextIndex,
          decrement: toStartKeys.includes(event.key),
          disabledIndices
        });
      }
    }
    if (nextIndex !== activeIndex && !isIndexOutOfListBounds(elementsRef, nextIndex)) {
      var _elementsRef$current$;
      event.stopPropagation();
      if (preventedKeys.includes(event.key)) {
        event.preventDefault();
      }
      onNavigate(nextIndex);
      (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
    }
  }
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: forwardedRef,
    'aria-orientation': orientation === 'both' ? undefined : orientation,
    onKeyDown(e) {
      domProps.onKeyDown == null || domProps.onKeyDown(e);
      renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
      handleKeyDown(e);
    }
  };
  return /*#__PURE__*/jsx(CompositeContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsx(FloatingList, {
      elementsRef: elementsRef,
      children: renderJsx(render, computedProps)
    })
  });
})));
/**
 * @see https://floating-ui.com/docs/Composite
 */
const CompositeItem = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CompositeItem(props, forwardedRef) {
  const {
    render,
    ...domProps
  } = props;
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const {
    activeIndex,
    onNavigate
  } = React.useContext(CompositeContext);
  const {
    ref,
    index
  } = useListItem();
  const mergedRef = useMergeRefs([ref, forwardedRef, renderElementProps.ref]);
  const isActive = activeIndex === index;
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: mergedRef,
    tabIndex: isActive ? 0 : -1,
    'data-active': isActive ? '' : undefined,
    onFocus(e) {
      domProps.onFocus == null || domProps.onFocus(e);
      renderElementProps.onFocus == null || renderElementProps.onFocus(e);
      onNavigate(index);
    }
  };
  return renderJsx(render, computedProps);
})));

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const floating_ui_react_SafeReact = {
  ...react_namespaceObject
};

let serverHandoffComplete = false;
let count = 0;
const genId = () => // Ensure the id is unique with multiple independent versions of Floating UI
// on <React 18
"floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  react.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = floating_ui_react_SafeReact.useId;

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
const useId = useReactId || useFloatingId;

let devMessageSet;
if (false) {}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingArrow(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow,
        shift
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (false) {}
  const clipPathId = useId();
  const [isRTL, setIsRTL] = React.useState(false);

  // https://github.com/floating-ui/floating-ui/issues/2932
  useModernLayoutEffect(() => {
    if (!floating) return;
    const isRTL = getComputedStyle(floating).direction === 'rtl';
    if (isRTL) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split('-');
  const isVerticalSide = side === 'top' || side === 'bottom';
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) {
    computedStaticOffset = null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
  if (computedStaticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/jsxs("svg", {
    ...rest,
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter(t => !!t).join(' '),
      ...restStyle
    },
    children: [computedStrokeWidth > 0 && /*#__PURE__*/jsx("path", {
      clipPath: "url(#" + clipPathId + ")",
      fill: "none",
      stroke: stroke
      // Account for the stroke on the fill path rendered below.
      ,
      strokeWidth: computedStrokeWidth + (d ? 0 : 1),
      d: dValue
    }), /*#__PURE__*/jsx("path", {
      stroke: computedStrokeWidth && !d ? rest.fill : 'none',
      d: dValue
    }), /*#__PURE__*/jsx("clipPath", {
      id: clipPathId,
      children: /*#__PURE__*/jsx("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
      })
    })]
  });
})));

function createEventEmitter() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(listener => listener(data));
    },
    on(event, listener) {
      if (!map.has(event)) {
        map.set(event, new Set());
      }
      map.get(event).add(listener);
    },
    off(event, listener) {
      var _map$get2;
      (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  useModernLayoutEffect(() => {
    if (!id) return;
    const node = {
      id,
      parentId
    };
    tree == null || tree.addNode(node);
    return () => {
      tree == null || tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(props) {
  const {
    children,
    id
  } = props;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/jsx(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id,
      parentId
    }), [id, parentId]),
    children: children
  });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(props) {
  const {
    children
  } = props;
  const nodesRef = React.useRef([]);
  const addNode = React.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = React.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const [events] = React.useState(() => createEventEmitter());
  return /*#__PURE__*/jsx(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [addNode, removeNode, events]),
    children: children
  });
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function clearTimeoutIfSet(timeoutRef) {
  if (timeoutRef.current !== -1) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = -1;
  }
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !floating_ui_react_utils_isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'function') {
    const result = value();
    if (typeof result === 'number') {
      return result;
    }
    return result == null ? void 0 : result[prop];
  }
  return value == null ? void 0 : value[prop];
}
function getRestMs(value) {
  if (typeof value === 'function') {
    return value();
  }
  return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = floating_ui_react_utils_useLatestRef(handleClose);
  const delayRef = floating_ui_react_utils_useLatestRef(delay);
  const openRef = floating_ui_react_utils_useLatestRef(open);
  const restMsRef = floating_ui_react_utils_useLatestRef(restMs);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef(-1);
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef(-1);
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const restTimeoutPendingRef = react.useRef(false);
  const isHoverOpen = floating_ui_react_utils_useEffectEvent(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  });

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        open
      } = _ref;
      if (!open) {
        clearTimeoutIfSet(timeoutRef);
        clearTimeoutIfSet(restTimeoutRef);
        blockMouseMoveRef.current = true;
        restTimeoutPendingRef.current = false;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled) return;
    if (!handleCloseRef.current) return;
    if (!open) return;
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    const html = getDocument(elements.floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [elements.floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeoutIfSet(timeoutRef);
      timeoutRef.current = window.setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeoutIfSet(timeoutRef);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = floating_ui_react_utils_useEffectEvent(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  });
  const clearPointerEvents = floating_ui_react_utils_useEffectEvent(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(elements.floating).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  });
  const isClickLikeOpenEvent = floating_ui_react_utils_useEffectEvent(() => {
    return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
  });

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) return;
    function onReferenceMouseEnter(event) {
      clearTimeoutIfSet(timeoutRef);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !floating_ui_react_utils_isMouseLikePointerType(pointerTypeRef.current) || getRestMs(restMsRef.current) > 0 && !getDelay(delayRef.current, 'open')) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = window.setTimeout(() => {
          if (!openRef.current) {
            onOpenChange(true, event, 'hover');
          }
        }, openDelay);
      } else if (!open) {
        onOpenChange(true, event, 'hover');
      }
    }
    function onReferenceMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        clearPointerEvents();
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(elements.floating);
      clearTimeoutIfSet(restTimeoutRef);
      restTimeoutPendingRef.current = false;
      if (handleCloseRef.current && dataRef.current.floatingContext) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeoutIfSet(timeoutRef);
        }
        handlerRef.current = handleCloseRef.current({
          ...dataRef.current.floatingContext,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            if (!isClickLikeOpenEvent()) {
              closeWithDelay(event, true, 'safe-polygon');
            }
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(elements.floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      if (!dataRef.current.floatingContext) return;
      handleCloseRef.current == null || handleCloseRef.current({
        ...dataRef.current.floatingContext,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          if (!isClickLikeOpenEvent()) {
            closeWithDelay(event);
          }
        }
      })(event);
    }
    function onFloatingMouseEnter() {
      clearTimeoutIfSet(timeoutRef);
    }
    function onFloatingMouseLeave(event) {
      if (!isClickLikeOpenEvent()) {
        closeWithDelay(event, false);
      }
    }
    if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference)) {
      const reference = elements.domReference;
      const floating = elements.floating;
      if (open) {
        reference.addEventListener('mouseleave', onScrollMouseLeave);
      }
      if (move) {
        reference.addEventListener('mousemove', onReferenceMouseEnter, {
          once: true
        });
      }
      reference.addEventListener('mouseenter', onReferenceMouseEnter);
      reference.addEventListener('mouseleave', onReferenceMouseLeave);
      if (floating) {
        floating.addEventListener('mouseleave', onScrollMouseLeave);
        floating.addEventListener('mouseenter', onFloatingMouseEnter);
        floating.addEventListener('mouseleave', onFloatingMouseLeave);
      }
      return () => {
        if (open) {
          reference.removeEventListener('mouseleave', onScrollMouseLeave);
        }
        if (move) {
          reference.removeEventListener('mousemove', onReferenceMouseEnter);
        }
        reference.removeEventListener('mouseenter', onReferenceMouseEnter);
        reference.removeEventListener('mouseleave', onReferenceMouseLeave);
        if (floating) {
          floating.removeEventListener('mouseleave', onScrollMouseLeave);
          floating.removeEventListener('mouseenter', onFloatingMouseEnter);
          floating.removeEventListener('mouseleave', onFloatingMouseLeave);
        }
      };
    }
  }, [elements, enabled, context, mouseOnly, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, openRef, tree, delayRef, handleCloseRef, dataRef, isClickLikeOpenEvent, restMsRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(() => {
    var _handleCloseRef$curre;
    if (!enabled) return;
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
      performedPointerEventsMutationRef.current = true;
      const floatingEl = elements.floating;
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference) && floatingEl) {
        var _tree$nodesRef$curren;
        const body = getDocument(elements.floating).body;
        body.setAttribute(safePolygonIdentifier, '');
        const ref = elements.domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        body.style.pointerEvents = 'none';
        ref.style.pointerEvents = 'auto';
        floatingEl.style.pointerEvents = 'auto';
        return () => {
          body.style.pointerEvents = '';
          ref.style.pointerEvents = '';
          floatingEl.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, elements, tree, handleCloseRef, isHoverOpen]);
  index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      restTimeoutPendingRef.current = false;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeoutIfSet(timeoutRef);
      clearTimeoutIfSet(restTimeoutRef);
      clearPointerEvents();
    };
  }, [enabled, elements.domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  const reference = react.useMemo(() => {
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      onPointerDown: setPointerRef,
      onPointerEnter: setPointerRef,
      onMouseMove(event) {
        const {
          nativeEvent
        } = event;
        function handleMouseMove() {
          if (!blockMouseMoveRef.current && !openRef.current) {
            onOpenChange(true, nativeEvent, 'hover');
          }
        }
        if (mouseOnly && !floating_ui_react_utils_isMouseLikePointerType(pointerTypeRef.current)) {
          return;
        }
        if (open || getRestMs(restMsRef.current) === 0) {
          return;
        }

        // Ignore insignificant movements to account for tremors.
        if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) {
          return;
        }
        clearTimeoutIfSet(restTimeoutRef);
        if (pointerTypeRef.current === 'touch') {
          handleMouseMove();
        } else {
          restTimeoutPendingRef.current = true;
          restTimeoutRef.current = window.setTimeout(handleMouseMove, getRestMs(restMsRef.current));
        }
      }
    };
  }, [mouseOnly, onOpenChange, open, openRef, restMsRef]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

const NOOP = () => {};
const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: NOOP,
  setState: NOOP,
  isInstantPhase: false
});

/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */
const useDelayGroupContext = () => React.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function FloatingDelayGroup(props) {
  const {
    children,
    delay,
    timeoutMs = 0
  } = props;
  const [state, setState] = React.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = React.useRef(null);
  const setCurrentId = React.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  useModernLayoutEffect(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else if (!state.isInstantPhase) {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      if (state.isInstantPhase) {
        setState({
          isInstantPhase: false
        });
      }
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId, state.isInstantPhase]);
  return /*#__PURE__*/jsx(FloatingDelayGroupContext.Provider, {
    value: React.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setCurrentId]),
    children: children
  });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    id: optionId,
    enabled = true
  } = options;
  const id = optionId != null ? optionId : floatingId;
  const groupContext = useDelayGroupContext();
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = groupContext;
  useModernLayoutEffect(() => {
    if (!enabled) return;
    if (!currentId) return;
    setState({
      delay: {
        open: 1,
        close: getDelay(initialDelay, 'close')
      }
    });
    if (currentId !== id) {
      onOpenChange(false);
    }
  }, [enabled, id, onOpenChange, setState, currentId, initialDelay]);
  useModernLayoutEffect(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!enabled) return;
    if (!currentId) return;
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [enabled, open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  useModernLayoutEffect(() => {
    if (!enabled) return;
    if (setCurrentId === NOOP || !open) return;
    setCurrentId(id);
  }, [enabled, open, setCurrentId, id]);
  return groupContext;
}

const NextFloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  hasProvider: false,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeoutIdRef: {
    current: -1
  },
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function NextFloatingDelayGroup(props) {
  const {
    children,
    delay,
    timeoutMs = 0
  } = props;
  const delayRef = React.useRef(delay);
  const initialDelayRef = React.useRef(delay);
  const currentIdRef = React.useRef(null);
  const currentContextRef = React.useRef(null);
  const timeoutIdRef = React.useRef(-1);
  return /*#__PURE__*/jsx(NextFloatingDelayGroupContext.Provider, {
    value: React.useMemo(() => ({
      hasProvider: true,
      delayRef,
      initialDelayRef,
      currentIdRef,
      timeoutMs,
      currentContextRef,
      timeoutIdRef
    }), [timeoutMs]),
    children: children
  });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useNextDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    enabled = true
  } = options;
  const groupContext = React.useContext(NextFloatingDelayGroupContext);
  const {
    currentIdRef,
    delayRef,
    timeoutMs,
    initialDelayRef,
    currentContextRef,
    hasProvider,
    timeoutIdRef
  } = groupContext;
  const [isInstantPhase, setIsInstantPhase] = React.useState(false);
  useModernLayoutEffect(() => {
    function unset() {
      var _currentContextRef$cu;
      setIsInstantPhase(false);
      (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
      currentIdRef.current = null;
      currentContextRef.current = null;
      delayRef.current = initialDelayRef.current;
    }
    if (!enabled) return;
    if (!currentIdRef.current) return;
    if (!open && currentIdRef.current === floatingId) {
      setIsInstantPhase(false);
      if (timeoutMs) {
        timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeoutIdRef.current);
        };
      }
      unset();
    }
  }, [enabled, open, floatingId, currentIdRef, delayRef, timeoutMs, initialDelayRef, currentContextRef, timeoutIdRef]);
  useModernLayoutEffect(() => {
    if (!enabled) return;
    if (!open) return;
    const prevContext = currentContextRef.current;
    const prevId = currentIdRef.current;
    currentContextRef.current = {
      onOpenChange,
      setIsInstantPhase
    };
    currentIdRef.current = floatingId;
    delayRef.current = {
      open: 0,
      close: getDelay(initialDelayRef.current, 'close')
    };
    if (prevId !== null && prevId !== floatingId) {
      clearTimeoutIfSet(timeoutIdRef);
      setIsInstantPhase(true);
      prevContext == null || prevContext.setIsInstantPhase(true);
      prevContext == null || prevContext.onOpenChange(false);
    } else {
      setIsInstantPhase(false);
      prevContext == null || prevContext.setIsInstantPhase(false);
    }
  }, [enabled, open, floatingId, onOpenChange, currentIdRef, delayRef, timeoutMs, initialDelayRef, currentContextRef, timeoutIdRef]);
  useModernLayoutEffect(() => {
    return () => {
      currentContextRef.current = null;
    };
  }, [currentContextRef]);
  return React.useMemo(() => ({
    hasProvider,
    delayRef,
    isInstantPhase
  }), [hasProvider, delayRef, isInstantPhase]);
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

function floating_ui_react_contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
function floating_ui_react_getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
function floating_ui_react_getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const counters = {
  inert: /*#__PURE__*/new WeakMap(),
  'aria-hidden': /*#__PURE__*/new WeakMap(),
  none: /*#__PURE__*/new WeakMap()
};
function getCounterMap(control) {
  if (control === 'inert') return counters.inert;
  if (control === 'aria-hidden') return counters['aria-hidden'];
  return counters.none;
}
let uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function unwrapHost(node) {
  if (!node) {
    return null;
  }
  return isShadowRoot(node) ? node.host : unwrapHost(node.parentNode);
}
const correctElements = (parent, targets) => targets.map(target => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter(x => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = 'data-floating-ui-inert';
  const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    [].forEach.call(parent.children, node => {
      if (getNodeName(node) === 'script') return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr !== null && attr !== 'false';
        const counterMap = getCounterMap(controlAttribute);
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
        }
      }
    });
  }
  lockCount$1++;
  return () => {
    hiddenElements.forEach(element => {
      const counterMap = getCounterMap(controlAttribute);
      const currentCounterValue = counterMap.get(element) || 0;
      const counterValue = currentCounterValue - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount$1--;
    if (!lockCount$1) {
      counters.inert = new WeakMap();
      counters['aria-hidden'] = new WeakMap();
      counters.none = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = floating_ui_react_getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
const FocusGuard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = React.useState();
  useModernLayoutEffect(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/jsx("span", {
    ...props,
    ...restProps
  });
})));

const HIDDEN_OWNER_STYLES = {
  clipPath: 'inset(50%)',
  position: 'fixed',
  top: 0,
  left: 0
};
const PortalContext = /*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext(null)));
const attr = /*#__PURE__*/(/* unused pure expression or super */ null && (createAttribute('portal')));
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    id,
    root
  } = props;
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const [portalNode, setPortalNode] = React.useState(null);
  const portalNodeRef = React.useRef(null);
  useModernLayoutEffect(() => {
    return () => {
      portalNode == null || portalNode.remove();
      // Allow the subsequent layout effects to create a new node on updates.
      // The portal node will still be cleaned up on unmount.
      // https://github.com/floating-ui/floating-ui/issues/2454
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  useModernLayoutEffect(() => {
    // Wait for the uniqueId to be generated before creating the portal node in
    // React <18 (using `useFloatingId` instead of the native `useId`).
    // https://github.com/floating-ui/floating-ui/issues/2778
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  useModernLayoutEffect(() => {
    // Wait for the root to exist before creating the portal node. The root must
    // be stored in state, not a ref, for this to work reactively.
    if (root === null) return;
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isNode(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement('div');
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(props) {
  const {
    children,
    id,
    root,
    preserveTabOrder = true
  } = props;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React.useState(null);
  const beforeOutsideRef = React.useRef(null);
  const afterOutsideRef = React.useRef(null);
  const beforeInsideRef = React.useRef(null);
  const afterInsideRef = React.useRef(null);
  const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
  const open = focusManagerState == null ? void 0 : focusManagerState.open;
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React.useEffect(() => {
    if (!portalNode || !preserveTabOrder || modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, modal]);
  React.useEffect(() => {
    if (!portalNode) return;
    if (open) return;
    enableFocusInside(portalNode);
  }, [open, portalNode]);
  return /*#__PURE__*/jsxs(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode]),
    children: [shouldRenderGuards && portalNode && /*#__PURE__*/jsx(FocusGuard, {
      "data-type": "outside",
      ref: beforeOutsideRef,
      onFocus: event => {
        if (isOutsideEvent(event, portalNode)) {
          var _beforeInsideRef$curr;
          (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
        } else {
          const domReference = focusManagerState ? focusManagerState.domReference : null;
          const prevTabbable = getPreviousTabbable(domReference);
          prevTabbable == null || prevTabbable.focus();
        }
      }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/jsx("span", {
      "aria-owns": portalNode.id,
      style: HIDDEN_OWNER_STYLES
    }), portalNode && /*#__PURE__*/ReactDOM.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/jsx(FocusGuard, {
      "data-type": "outside",
      ref: afterOutsideRef,
      onFocus: event => {
        if (isOutsideEvent(event, portalNode)) {
          var _afterInsideRef$curre;
          (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
        } else {
          const domReference = focusManagerState ? focusManagerState.domReference : null;
          const nextTabbable = getNextTabbable(domReference);
          nextTabbable == null || nextTabbable.focus();
          (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
        }
      }
    })]
  });
}
const usePortalContext = () => React.useContext(PortalContext);

function useLiteMergeRefs(refs) {
  return React.useMemo(() => {
    return value => {
      refs.forEach(ref => {
        if (ref) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

const LIST_LIMIT = 20;
let previouslyFocusedElements = (/* unused pure expression or super */ null && ([]));
function clearDisconnectedPreviouslyFocusedElements() {
  previouslyFocusedElements = previouslyFocusedElements.filter(elementRef => {
    var _elementRef$deref;
    return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
  });
}
function addPreviouslyFocusedElement(element) {
  clearDisconnectedPreviouslyFocusedElements();
  if (element && getNodeName(element) !== 'body') {
    previouslyFocusedElements.push(new WeakRef(element));
    if (previouslyFocusedElements.length > LIST_LIMIT) {
      previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
    }
  }
}
function getPreviouslyFocusedElement() {
  clearDisconnectedPreviouslyFocusedElements();
  const elementRef = previouslyFocusedElements[previouslyFocusedElements.length - 1];
  return elementRef == null ? void 0 : elementRef.deref();
}
function getFirstTabbableElement(container) {
  const tabbableOptions = getTabbableOptions();
  if (isTabbable(container, tabbableOptions)) {
    return container;
  }
  return tabbable(container, tabbableOptions)[0] || container;
}
function handleTabIndex(floatingFocusElement, orderRef) {
  var _floatingFocusElement;
  if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) {
    return;
  }
  const options = getTabbableOptions();
  const focusableElements = focusable(floatingFocusElement, options);
  const tabbableContent = focusableElements.filter(element => {
    const dataTabIndex = element.getAttribute('data-tabindex') || '';
    return isTabbable(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
  });
  const tabIndex = floatingFocusElement.getAttribute('tabindex');
  if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
    if (tabIndex !== '0') {
      floatingFocusElement.setAttribute('tabindex', '0');
    }
  } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
    floatingFocusElement.setAttribute('tabindex', '-1');
    floatingFocusElement.setAttribute('data-tabindex', '-1');
  }
}
const VisuallyHiddenDismiss = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/jsx("button", {
    ...props,
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  });
})));
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true,
    outsideElementsInert = false,
    getInsideElements: _getInsideElements = () => []
  } = props;
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const getNodeId = useEffectEvent(() => {
    var _dataRef$current$floa;
    return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
  });
  const getInsideElements = useEffectEvent(_getInsideElements);
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const inertSupported = supportsInert();
  const guards = inertSupported ? _guards : true;
  const useInert = !guards || inertSupported && outsideElementsInert;
  const orderRef = useLatestRef(order);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = React.useRef(null);
  const endDismissButtonRef = React.useRef(null);
  const preventReturnFocusRef = React.useRef(false);
  const isPointerDownRef = React.useRef(false);
  const tabbableIndexRef = React.useRef(-1);
  const blurTimeoutRef = React.useRef(-1);
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useEffectEvent(function (container) {
    if (container === void 0) {
      container = floatingFocusElement;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  const getTabbableElements = useEffectEvent(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floatingFocusElement && type === 'floating') {
        return floatingFocusElement;
      }
      return content;
    }).filter(Boolean).flat();
  });
  React.useEffect(() => {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains$1(floatingFocusElement, activeElement(getDocument$1(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget$1(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument$1(floatingFocusElement);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floatingFocusElement, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  React.useEffect(() => {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      const target = getTarget$1(event);
      const tabbableContent = getTabbableContent();
      const tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener('focusin', handleFocusIn);
    return () => {
      floating.removeEventListener('focusin', handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  React.useEffect(() => {
    if (disabled) return;
    if (!closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      const currentTarget = event.currentTarget;
      const target = getTarget$1(event);
      queueMicrotask(() => {
        const nodeId = getNodeId();
        const movedToUnrelatedNode = !(contains$1(domReference, relatedTarget) || contains$1(floating, relatedTarget) || contains$1(relatedTarget, floating) || contains$1(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getNodeChildren$1(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains$1((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains$1((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getNodeAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4, _node$context5;
          return [(_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating, getFloatingFocusElement((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
        })));
        if (currentTarget === domReference && floatingFocusElement) {
          handleTabIndex(floatingFocusElement, orderRef);
        }

        // Restore focus to the previous tabbable element index to prevent
        // focus from being lost outside the floating tree.
        if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && activeElement(getDocument$1(floatingFocusElement)) === getDocument$1(floatingFocusElement).body) {
          // Let `FloatingPortal` effect knows that focus is still inside the
          // floating tree.
          if (isHTMLElement(floatingFocusElement)) {
            floatingFocusElement.focus();
          }
          const prevTabbableIndex = tabbableIndexRef.current;
          const tabbableContent = getTabbableContent();
          const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }

        // https://github.com/floating-ui/floating-ui/issues/3060
        if (dataRef.current.insideReactTree) {
          dataRef.current.insideReactTree = false;
          return;
        }

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event, 'focus-out');
        }
      });
    }
    const shouldHandleBlurCapture = Boolean(!tree && portalContext);
    function markInsideReactTree() {
      clearTimeoutIfSet(blurTimeoutRef);
      dataRef.current.insideReactTree = true;
      blurTimeoutRef.current = window.setTimeout(() => {
        dataRef.current.insideReactTree = false;
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      floating.addEventListener('focusout', handleFocusOutside);
      if (shouldHandleBlurCapture) {
        floating.addEventListener('focusout', markInsideReactTree, true);
      }
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        floating.removeEventListener('focusout', handleFocusOutside);
        if (shouldHandleBlurCapture) {
          floating.removeEventListener('focusout', markInsideReactTree, true);
        }
      };
    }
  }, [disabled, domReference, floating, floatingFocusElement, modal, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox, getNodeId, orderRef, dataRef]);
  const beforeGuardRef = React.useRef(null);
  const afterGuardRef = React.useRef(null);
  const mergedBeforeGuardRef = useLiteMergeRefs([beforeGuardRef, portalContext == null ? void 0 : portalContext.beforeInsideRef]);
  const mergedAfterGuardRef = useLiteMergeRefs([afterGuardRef, portalContext == null ? void 0 : portalContext.afterInsideRef]);
  React.useEffect(() => {
    var _portalContext$portal, _ancestors$find;
    if (disabled) return;
    if (!floating) return;

    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    const ancestors = tree ? getNodeAncestors(tree.nodesRef.current, getNodeId()) : [];
    const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find(node => {
      var _node$context6;
      return isTypeableCombobox(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
    })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
    const insideElements = [floating, rootAncestorComboboxDomReference, ...portalNodes, ...getInsideElements(), startDismissButtonRef.current, endDismissButtonRef.current, beforeGuardRef.current, afterGuardRef.current, portalContext == null ? void 0 : portalContext.beforeOutsideRef.current, portalContext == null ? void 0 : portalContext.afterOutsideRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null].filter(x => x != null);
    const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, !useInert, useInert) : markOthers(insideElements);
    return () => {
      cleanup();
    };
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards, useInert, tree, getNodeId, getInsideElements]);
  useModernLayoutEffect(() => {
    if (disabled || !isHTMLElement(floatingFocusElement)) return;
    const doc = getDocument$1(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floatingFocusElement);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
      const focusAlreadyInsideFloatingEl = contains$1(floatingFocusElement, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusElement
        });
      }
    });
  }, [disabled, open, floatingFocusElement, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  useModernLayoutEffect(() => {
    if (disabled || !floatingFocusElement) return;
    const doc = getDocument$1(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      let {
        reason,
        event,
        nested
      } = _ref;
      if (['hover', 'safe-polygon'].includes(reason) && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
      } else if (isVirtualClick(event) || isVirtualPointerEvent(event)) {
        preventReturnFocusRef.current = false;
      } else {
        let isPreventScrollSupported = false;
        document.createElement('div').focus({
          get preventScroll() {
            isPreventScrollSupported = true;
            return false;
          }
        });
        if (isPreventScrollSupported) {
          preventReturnFocusRef.current = false;
        } else {
          preventReturnFocusRef.current = true;
        }
      }
    }
    events.on('openchange', onOpenChange);
    const fallbackEl = doc.createElement('span');
    fallbackEl.setAttribute('tabindex', '-1');
    fallbackEl.setAttribute('aria-hidden', 'true');
    Object.assign(fallbackEl.style, HIDDEN_STYLES);
    if (isInsidePortal && domReference) {
      domReference.insertAdjacentElement('afterend', fallbackEl);
    }
    function getReturnElement() {
      if (typeof returnFocusRef.current === 'boolean') {
        const el = domReference || getPreviouslyFocusedElement();
        return el && el.isConnected ? el : fallbackEl;
      }
      return returnFocusRef.current.current || fallbackEl;
    }
    return () => {
      events.off('openchange', onOpenChange);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains$1(floating, activeEl) || tree && getNodeChildren$1(tree.nodesRef.current, getNodeId(), false).some(node => {
        var _node$context7;
        return contains$1((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
      });
      const returnElement = getReturnElement();
      queueMicrotask(() => {
        // This is `returnElement`, if it's tabbable, or its first tabbable child.
        const tabbableReturnElement = getFirstTabbableElement(returnElement);
        if (
        // eslint-disable-next-line react-hooks/exhaustive-deps
        returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(tabbableReturnElement) && (
        // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
          tabbableReturnElement.focus({
            preventScroll: true
          });
        }
        fallbackEl.remove();
      });
    };
  }, [disabled, floating, floatingFocusElement, returnFocusRef, dataRef, events, tree, isInsidePortal, domReference, getNodeId]);
  React.useEffect(() => {
    // The `returnFocus` cleanup behavior is inside a microtask; ensure we
    // wait for it to complete before resetting the flag.
    queueMicrotask(() => {
      preventReturnFocusRef.current = false;
    });
    return () => {
      queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
    };
  }, [disabled]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  useModernLayoutEffect(() => {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      domReference
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, closeOnFocusOut, domReference]);
  useModernLayoutEffect(() => {
    if (disabled) return;
    if (!floatingFocusElement) return;
    handleTabIndex(floatingFocusElement, orderRef);
  }, [disabled, floatingFocusElement, orderRef]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/jsx(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent),
      children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
    });
  }
  const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [shouldRenderGuards && /*#__PURE__*/jsx(FocusGuard, {
      "data-type": "inside",
      ref: mergedBeforeGuardRef,
      onFocus: event => {
        if (modal) {
          const els = getTabbableElements();
          enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          preventReturnFocusRef.current = false;
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const nextTabbable = getNextTabbable(domReference);
            nextTabbable == null || nextTabbable.focus();
          } else {
            var _portalContext$before;
            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
          }
        }
      }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/jsx(FocusGuard, {
      "data-type": "inside",
      ref: mergedAfterGuardRef,
      onFocus: event => {
        if (modal) {
          enqueueFocus(getTabbableElements()[0]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          if (closeOnFocusOut) {
            preventReturnFocusRef.current = true;
          }
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const prevTabbable = getPreviousTabbable(domReference);
            prevTabbable == null || prevTabbable.focus();
          } else {
            var _portalContext$afterO;
            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
          }
        }
      }
    })]
  });
}

let lockCount = 0;
const scrollbarProperty = '--floating-ui-scrollbar-width';
function enableScrollLock() {
  const platform = getPlatform();
  const isIOS = /iP(hone|ad|od)|iOS/.test(platform) ||
  // iPads can claim to be MacIntel
  platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const bodyStyle = document.body.style;
  // RTL <body> scrollbar
  const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = 'hidden';
  bodyStyle.setProperty(scrollbarProperty, scrollbarWidth + "px");
  if (scrollbarWidth) {
    bodyStyle[paddingProp] = scrollbarWidth + "px";
  }

  // Only iOS doesn't respect `overflow: hidden` on document.body, and this
  // technique has fewer side effects.
  if (isIOS) {
    var _window$visualViewpor, _window$visualViewpor2;
    // iOS 12 does not support `visualViewport`.
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    Object.assign(bodyStyle, {
      position: 'fixed',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0'
    });
  }
  return () => {
    Object.assign(bodyStyle, {
      overflow: '',
      [paddingProp]: ''
    });
    bodyStyle.removeProperty(scrollbarProperty);
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: '',
        top: '',
        left: '',
        right: ''
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
let cleanup = () => {};

/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingOverlay(props, ref) {
  const {
    lockScroll = false,
    ...rest
  } = props;
  useModernLayoutEffect(() => {
    if (!lockScroll) return;
    lockCount++;
    if (lockCount === 1) {
      cleanup = enableScrollLock();
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        cleanup();
      }
    };
  }, [lockScroll]);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    ...rest,
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  });
})));

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isAnchorTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'A';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true,
    stickIfOpen = true
  } = props;
  const pointerTypeRef = React.useRef();
  const didKeyDownRef = React.useRef(false);
  const reference = React.useMemo(() => ({
    onPointerDown(event) {
      pointerTypeRef.current = event.pointerType;
    },
    onMouseDown(event) {
      const pointerType = pointerTypeRef.current;

      // Ignore all buttons except for the "main" button.
      // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
      if (event.button !== 0) return;
      if (eventOption === 'click') return;
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        // Prevent stealing focus from the floating element
        event.preventDefault();
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onClick(event) {
      const pointerType = pointerTypeRef.current;
      if (eventOption === 'mousedown' && pointerTypeRef.current) {
        pointerTypeRef.current = undefined;
        return;
      }
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onKeyDown(event) {
      pointerTypeRef.current = undefined;
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
        return;
      }
      if (event.key === ' ' && !isSpaceIgnored(domReference)) {
        // Prevent scrolling
        event.preventDefault();
        didKeyDownRef.current = true;
      }
      if (isAnchorTarget(event)) {
        return;
      }
      if (event.key === 'Enter') {
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    },
    onKeyUp(event) {
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
        return;
      }
      if (event.key === ' ' && didKeyDownRef.current) {
        didKeyDownRef.current = false;
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    }
  }), [dataRef, domReference, eventOption, ignoreMouse, keyboardHandlers, onOpenChange, open, stickIfOpen, toggle]);
  return React.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

function createVirtualElement(domElement, data) {
  let offsetX = null;
  let offsetY = null;
  let isAutoUpdateEvent = false;
  return {
    contextElement: domElement || undefined,
    getBoundingClientRect() {
      var _data$dataRef$current;
      const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      const isXAxis = data.axis === 'x' || data.axis === 'both';
      const isYAxis = data.axis === 'y' || data.axis === 'both';
      const canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      let width = domRect.width;
      let height = domRect.height;
      let x = domRect.x;
      let y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width,
        height,
        x,
        y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    dataRef,
    elements: {
      floating,
      domReference
    },
    refs
  } = context;
  const {
    enabled = true,
    axis = 'both',
    x = null,
    y = null
  } = props;
  const initialRef = React.useRef(false);
  const cleanupListenerRef = React.useRef(null);
  const [pointerType, setPointerType] = React.useState();
  const [reactive, setReactive] = React.useState([]);
  const setReference = useEffectEvent((x, y) => {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(domReference, {
      x,
      y,
      axis,
      dataRef,
      pointerType
    }));
  });
  const handleReferenceEnterOrMove = useEffectEvent(event => {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  const openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  const addListener = React.useCallback(() => {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    const win = getWindow(floating);
    function handleMouseMove(event) {
      const target = getTarget$1(event);
      if (!contains$1(floating, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      const cleanup = () => {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(domReference);
  }, [openCheck, enabled, x, y, floating, dataRef, refs, domReference, setReference]);
  React.useEffect(() => {
    return addListener();
  }, [addListener, reactive]);
  React.useEffect(() => {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  React.useEffect(() => {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  useModernLayoutEffect(() => {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  const reference = React.useMemo(() => {
    function setPointerTypeRef(_ref) {
      let {
        pointerType
      } = _ref;
      setPointerType(pointerType);
    }
    return {
      onPointerDown: setPointerTypeRef,
      onPointerEnter: setPointerTypeRef,
      onMouseMove: handleReferenceEnterOrMove,
      onMouseEnter: handleReferenceEnterOrMove
    };
  }, [handleReferenceEnterOrMove]);
  return React.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    elements,
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = floating_ui_react_utils_useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const endedOrStartedInsideRef = react.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const isComposingRef = react.useRef(false);
  const closeOnEscapeKeyDown = floating_ui_react_utils_useEffectEvent(event => {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }

    // Wait until IME is settled. Pressing `Escape` while composing should
    // close the compose menu, but not the floating element.
    if (isComposingRef.current) {
      return;
    }
    const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    const children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = floating_ui_react_utils_useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = floating_ui_react_utils_useEffectEvent(event => {
    var _dataRef$current$floa2;
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = dataRef.current.insideReactTree;
    dataRef.current.insideReactTree = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = getDocument(elements.floating).querySelectorAll(inertSelector);
    let targetRootAncestor = (0,floating_ui_utils_dom/* isElement */.kK)(target) ? target : null;
    while (targetRootAncestor && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(targetRootAncestor)) {
      const nextParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(targetRootAncestor);
      if ((0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(nextParent) || !(0,floating_ui_utils_dom/* isElement */.kK)(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && (0,floating_ui_utils_dom/* isElement */.kK)(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, elements.floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(target) && floating) {
      const lastTraversableNode = (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(target);
      const style = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(target);
      const scrollRe = /auto|scroll/;
      const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
      const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
      const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      const isRTL = style.direction === 'rtl';

      // Check click position relative to scrollbar.
      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
      const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
      if (pressedVerticalScrollbar || pressedHorizontalScrollbar) {
        return;
      }
    }
    const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    const targetIsInsideChildren = tree && getNodeChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = floating_ui_react_utils_useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  react.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    let compositionTimeout = -1;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    function handleCompositionStart() {
      window.clearTimeout(compositionTimeout);
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      // Safari fires `compositionend` before `keydown`, so we need to wait
      // until the next tick to set `isComposing` to `false`.
      // https://bugs.webkit.org/show_bug.cgi?id=165004
      compositionTimeout = window.setTimeout(() => {
        isComposingRef.current = false;
      },
      // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
      // Only apply to WebKit for the test to remain 0ms.
      (0,floating_ui_utils_dom/* isWebKit */.Pf)() ? 5 : 0);
    }
    const doc = getDocument(elements.floating);
    if (escapeKey) {
      doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      doc.addEventListener('compositionstart', handleCompositionStart);
      doc.addEventListener('compositionend', handleCompositionEnd);
    }
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference)) {
        ancestors = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.domReference);
      }
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.floating)) {
        ancestors = ancestors.concat((0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.floating));
      }
      if (!(0,floating_ui_utils_dom/* isElement */.kK)(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat((0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      if (escapeKey) {
        doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        doc.removeEventListener('compositionstart', handleCompositionStart);
        doc.removeEventListener('compositionend', handleCompositionEnd);
      }
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
      window.clearTimeout(compositionTimeout);
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  react.useEffect(() => {
    dataRef.current.insideReactTree = false;
  }, [dataRef, outsidePress, outsidePressEvent]);
  const reference = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    ...(referencePress && {
      [bubbleHandlerKeys[referencePressEvent]]: event => {
        onOpenChange(false, event.nativeEvent, 'reference-press');
      },
      ...(referencePressEvent !== 'click' && {
        onClick(event) {
          onOpenChange(false, event.nativeEvent, 'reference-press');
        }
      })
    })
  }), [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  const floating = react.useMemo(() => {
    function setMouseDownOrUpInside(event) {
      if (event.button !== 0) {
        return;
      }
      endedOrStartedInsideRef.current = true;
    }
    return {
      onKeyDown: closeOnEscapeKeyDown,
      onMouseDown: setMouseDownOrUpInside,
      onMouseUp: setMouseDownOrUpInside,
      [captureHandlerKeys[outsidePressEvent]]: () => {
        dataRef.current.insideReactTree = true;
      }
    };
  }, [closeOnEscapeKeyDown, outsidePressEvent, dataRef]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = react.useRef({});
  const [events] = react.useState(() => createEventEmitter());
  const nested = useFloatingParentNodeId() != null;
  if (false) {}
  const [positionReference, setPositionReference] = react.useState(elementsProp.reference);
  const onOpenChange = floating_ui_react_utils_useEffectEvent((open, event, reason) => {
    dataRef.current.openEvent = open ? event : undefined;
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
  });
  const refs = react.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = react.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return react.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = react.useState(null);
  const [positionReference, _setPositionReference] = react.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = react.useRef(null);
  const tree = useFloatingTree();
  index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = (0,floating_ui_react_dom/* useFloating */.YF)({
    ...options,
    elements: {
      ...computedElements,
      ...(positionReference && {
        reference: positionReference
      })
    }
  });
  const setPositionReference = react.useCallback(node => {
    const computedPositionReference = (0,floating_ui_utils_dom/* isElement */.kK)(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      getClientRects: () => node.getClientRects(),
      contextElement: node
    } : node;
    // Store the positionReference in state if the DOM reference is specified externally via the
    // `elements.reference` option. This ensures that it won't be overridden on future renders.
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if ((0,floating_ui_utils_dom/* isElement */.kK)(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if ((0,floating_ui_utils_dom/* isElement */.kK)(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !(0,floating_ui_utils_dom/* isElement */.kK)(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = react.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

function isMacSafari() {
  return isMac() && floating_ui_react_utils_isSafari();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = react.useRef(false);
  const timeoutRef = react.useRef(-1);
  const keyboardModalityRef = react.useRef(true);
  react.useEffect(() => {
    if (!enabled) return;
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(elements.domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && (0,floating_ui_utils_dom/* isHTMLElement */.Re)(elements.domReference) && elements.domReference === floating_ui_react_utils_activeElement(getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    function onPointerDown() {
      keyboardModalityRef.current = false;
    }
    win.addEventListener('blur', onBlur);
    if (isMacSafari()) {
      win.addEventListener('keydown', onKeyDown, true);
      win.addEventListener('pointerdown', onPointerDown, true);
    }
    return () => {
      win.removeEventListener('blur', onBlur);
      if (isMacSafari()) {
        win.removeEventListener('keydown', onKeyDown, true);
        win.removeEventListener('pointerdown', onPointerDown, true);
      }
    };
  }, [elements.domReference, open, enabled]);
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        reason
      } = _ref;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  react.useEffect(() => {
    return () => {
      clearTimeoutIfSet(timeoutRef);
    };
  }, []);
  const reference = react.useMemo(() => ({
    onMouseLeave() {
      blockFocusRef.current = false;
    },
    onFocus(event) {
      if (blockFocusRef.current) return;
      const target = getTarget(event.nativeEvent);
      if (visibleOnly && (0,floating_ui_utils_dom/* isElement */.kK)(target)) {
        // Safari fails to match `:focus-visible` if focus was initially
        // outside the document.
        if (isMacSafari() && !event.relatedTarget) {
          if (!keyboardModalityRef.current && !floating_ui_react_utils_isTypeableElement(target)) {
            return;
          }
        } else if (!matchesFocusVisible(target)) {
          return;
        }
      }
      onOpenChange(true, event.nativeEvent, 'focus');
    },
    onBlur(event) {
      blockFocusRef.current = false;
      const relatedTarget = event.relatedTarget;
      const nativeEvent = event.nativeEvent;

      // Hit the non-modal focus management portal guard. Focus will be
      // moved into the floating element immediately after.
      const movedToFocusGuard = (0,floating_ui_utils_dom/* isElement */.kK)(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

      // Wait for the window blur listener to fire.
      timeoutRef.current = window.setTimeout(() => {
        var _dataRef$current$floa;
        const activeEl = floating_ui_react_utils_activeElement(elements.domReference ? elements.domReference.ownerDocument : document);

        // Focus left the page, keep it open.
        if (!relatedTarget && activeEl === elements.domReference) return;

        // When focusing the reference element (e.g. regular click), then
        // clicking into the floating element, prevent it from hiding.
        // Note: it must be focusable, e.g. `tabindex="-1"`.
        // We can not rely on relatedTarget to point to the correct element
        // as it will only point to the shadow host of the newly focused element
        // and not the element that actually has received focus if it is located
        // inside a shadow root.
        if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) {
          return;
        }
        onOpenChange(false, nativeEvent, 'focus');
      });
    }
  }), [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1,
      [floating_ui_react_FOCUSABLE_ATTRIBUTE]: ''
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map(key => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map(key => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map(key => key == null ? void 0 : key.item);
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  referenceDeps);
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  floatingDeps);
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  itemDeps);
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

const ESCAPE = 'Escape';
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === floating_ui_react_ARROW_UP || key === floating_ui_react_ARROW_DOWN;
  const horizontal = key === floating_ui_react_ARROW_LEFT || key === floating_ui_react_ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === floating_ui_react_ARROW_DOWN;
  const horizontal = rtl ? key === floating_ui_react_ARROW_LEFT : key === floating_ui_react_ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === floating_ui_react_ARROW_LEFT : key === floating_ui_react_ARROW_RIGHT;
  const horizontal = key === floating_ui_react_ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl, cols) {
  const vertical = rtl ? key === floating_ui_react_ARROW_RIGHT : key === floating_ui_react_ARROW_LEFT;
  const horizontal = key === floating_ui_react_ARROW_UP;
  if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) {
    return key === ESCAPE;
  }
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    elements,
    floatingId
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    parentOrientation,
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (false) {}
  const floatingFocusElement = getFloatingFocusElement(elements.floating);
  const floatingFocusElementRef = useLatestRef(floatingFocusElement);
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  useModernLayoutEffect(() => {
    context.dataRef.current.orientation = orientation;
  }, [context, orientation]);
  const onNavigate = useEffectEvent(() => {
    unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
  });
  const typeableComboboxReference = isTypeableCombobox(elements.domReference);
  const focusItemOnOpenRef = React.useRef(focusItemOnOpen);
  const indexRef = React.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = React.useRef(null);
  const isPointerModalityRef = React.useRef(true);
  const previousOnNavigateRef = React.useRef(onNavigate);
  const previousMountedRef = React.useRef(!!elements.floating);
  const previousOpenRef = React.useRef(open);
  const forceSyncFocusRef = React.useRef(false);
  const forceScrollIntoViewRef = React.useRef(false);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const latestOpenRef = useLatestRef(open);
  const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  const selectedIndexRef = useLatestRef(selectedIndex);
  const [activeId, setActiveId] = React.useState();
  const [virtualId, setVirtualId] = React.useState();
  const focusItem = useEffectEvent(() => {
    function runFocus(item) {
      if (virtual) {
        var _item$id;
        if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) {
          item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
        }
        setActiveId(item.id);
        tree == null || tree.events.emit('virtualfocus', item);
        if (virtualItemRef) {
          virtualItemRef.current = item;
        }
      } else {
        enqueueFocus(item, {
          sync: forceSyncFocusRef.current,
          preventScroll: true
        });
      }
    }
    const initialItem = listRef.current[indexRef.current];
    const forceScrollIntoView = forceScrollIntoViewRef.current;
    if (initialItem) {
      runFocus(initialItem);
    }
    const scheduler = forceSyncFocusRef.current ? v => v() : requestAnimationFrame;
    scheduler(() => {
      const waitedItem = listRef.current[indexRef.current] || initialItem;
      if (!waitedItem) return;
      if (!initialItem) {
        runFocus(waitedItem);
      }
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  useModernLayoutEffect(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate();
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current();
    }
  }, [enabled, open, elements.floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  useModernLayoutEffect(() => {
    if (!enabled) return;
    if (!open) return;
    if (!elements.floating) return;
    if (activeIndex == null) {
      forceSyncFocusRef.current = false;
      if (selectedIndexRef.current != null) {
        return;
      }

      // Reset while the floating element was open (e.g. the list changed).
      if (previousMountedRef.current) {
        indexRef.current = -1;
        focusItem();
      }

      // Initial sync.
      if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
        let runs = 0;
        const waitForListPopulated = () => {
          if (listRef.current[0] == null) {
            // Avoid letting the browser paint if possible on the first try,
            // otherwise use rAF. Don't try more than twice, since something
            // is wrong otherwise.
            if (runs < 2) {
              const scheduler = runs ? requestAnimationFrame : queueMicrotask;
              scheduler(waitForListPopulated);
            }
            runs++;
          } else {
            indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinListIndex(listRef, disabledIndicesRef.current) : getMaxListIndex(listRef, disabledIndicesRef.current);
            keyRef.current = null;
            onNavigate();
          }
        };
        waitForListPopulated();
      }
    } else if (!isIndexOutOfListBounds(listRef, activeIndex)) {
      indexRef.current = activeIndex;
      focusItem();
      forceScrollIntoViewRef.current = false;
    }
  }, [enabled, open, elements.floating, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  useModernLayoutEffect(() => {
    var _nodes$find;
    if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument$1(elements.floating));
    const treeContainsActiveEl = nodes.some(node => node.context && contains$1(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, elements.floating, tree, parentId, virtual]);
  useModernLayoutEffect(() => {
    if (!enabled) return;
    if (!tree) return;
    if (!virtual) return;
    if (parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return () => {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  useModernLayoutEffect(() => {
    previousOnNavigateRef.current = onNavigate;
    previousOpenRef.current = open;
    previousMountedRef.current = !!elements.floating;
  });
  useModernLayoutEffect(() => {
    if (!open) {
      keyRef.current = null;
      focusItemOnOpenRef.current = focusItemOnOpen;
    }
  }, [open, focusItemOnOpen]);
  const hasActiveIndex = activeIndex != null;
  const item = React.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!latestOpenRef.current) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1 && indexRef.current !== index) {
        indexRef.current = index;
        onNavigate();
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        forceSyncFocusRef.current = true;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      onMouseMove(_ref3) {
        let {
          currentTarget
        } = _ref3;
        forceSyncFocusRef.current = true;
        forceScrollIntoViewRef.current = false;
        if (focusItemOnHover) {
          syncCurrentTarget(currentTarget);
        }
      },
      onPointerLeave(_ref4) {
        let {
          pointerType
        } = _ref4;
        if (!isPointerModalityRef.current || pointerType === 'touch') {
          return;
        }
        forceSyncFocusRef.current = true;
        if (!focusItemOnHover) {
          return;
        }
        indexRef.current = -1;
        onNavigate();
        if (!virtual) {
          var _floatingFocusElement;
          (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
            preventScroll: true
          });
        }
      }
    };
    return props;
  }, [latestOpenRef, floatingFocusElementRef, focusItemOnHover, listRef, onNavigate, virtual]);
  const getParentOrientation = React.useCallback(() => {
    var _tree$nodesRef$curren;
    return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
  }, [parentId, tree, parentOrientation]);
  const commonOnKeyDown = useEffectEvent(event => {
    isPointerModalityRef.current = false;
    forceSyncFocusRef.current = true;

    // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
    // don't appear to suffer from this. `event.isComposing` is avoided due to
    // Safari not supporting it properly (although it's not needed in the first
    // place for Safari, just avoiding any possible issues).
    if (event.which === 229) {
      return;
    }

    // If the floating element is animating out, ignore navigation. Otherwise,
    // the `activeIndex` gets set to 0 despite not being open so the next time
    // the user ArrowDowns, the first item won't be focused.
    if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
      // If the nested list's close key is also the parent navigation key,
      // let the parent navigate. Otherwise, stop propagating the event.
      if (!isMainOrientationKey(event.key, getParentOrientation())) {
        stopEvent(event);
      }
      onOpenChange(false, event.nativeEvent, 'list-navigation');
      if (isHTMLElement(elements.domReference)) {
        if (virtual) {
          tree == null || tree.events.emit('virtualfocus', elements.domReference);
        } else {
          elements.domReference.focus();
        }
      }
      return;
    }
    const currentIndex = indexRef.current;
    const minIndex = getMinListIndex(listRef, disabledIndices);
    const maxIndex = getMaxListIndex(listRef, disabledIndices);
    if (!typeableComboboxReference) {
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate();
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate();
      }
    }

    // Grid navigation.
    if (cols > 1) {
      const sizes = itemSizes || Array.from({
        length: listRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = createGridCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isListIndexDisabled(listRef, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isListIndexDisabled(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const index = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex != null ? listRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getGridCellIndices([...((typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index) => isListIndexDisabled(listRef, index, disabledIndices) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getGridCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction
        // we're moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === floating_ui_react_ARROW_DOWN ? 'bl' : event.key === (rtl ? floating_ui_react_ARROW_LEFT : floating_ui_react_ARROW_RIGHT) ? 'tr' : 'tl'),
        stopEvent: true
      })];
      if (index != null) {
        indexRef.current = index;
        onNavigate();
      }
      if (orientation === 'both') {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);

      // Reset the index if no item is focused.
      if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate();
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loop) {
          indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          });
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          }));
        }
      } else {
        if (loop) {
          indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          });
        } else {
          indexRef.current = Math.max(minIndex, findNonDisabledListIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          }));
        }
      }
      if (isIndexOutOfListBounds(listRef, indexRef.current)) {
        indexRef.current = -1;
      }
      onNavigate();
    }
  });
  const ariaActiveDescendantProp = React.useMemo(() => {
    return virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
  }, [virtual, open, hasActiveIndex, virtualId, activeId]);
  const floating = React.useMemo(() => {
    return {
      'aria-orientation': orientation === 'both' ? undefined : orientation,
      ...(!typeableComboboxReference ? ariaActiveDescendantProp : {}),
      onKeyDown: commonOnKeyDown,
      onPointerMove() {
        isPointerModalityRef.current = true;
      }
    };
  }, [ariaActiveDescendantProp, commonOnKeyDown, orientation, typeableComboboxReference]);
  const reference = React.useMemo(() => {
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return {
      ...ariaActiveDescendantProp,
      onKeyDown(event) {
        isPointerModalityRef.current = false;
        const isArrowKey = event.key.startsWith('Arrow');
        const isHomeOrEndKey = ['Home', 'End'].includes(event.key);
        const isMoveKey = isArrowKey || isHomeOrEndKey;
        const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
        const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
        const isParentCrossOpenKey = isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
        const isMainKey = isMainOrientationKey(event.key, orientation);
        const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
        if (virtual && open) {
          const rootNode = tree == null ? void 0 : tree.nodesRef.current.find(node => node.parentId == null);
          const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
          if (isMoveKey && deepestNode && virtualItemRef) {
            const eventObject = new KeyboardEvent('keydown', {
              key: event.key,
              bubbles: true
            });
            if (isCrossOpenKey || isCrossCloseKey) {
              var _deepestNode$context, _deepestNode$context2;
              const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
              const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(item => (item == null ? void 0 : item.id) === activeId) : null;
              if (dispatchItem) {
                stopEvent(event);
                dispatchItem.dispatchEvent(eventObject);
                setVirtualId(undefined);
              }
            }
            if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
              if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                var _deepestNode$context$;
                stopEvent(event);
                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                return;
              }
            }
          }
          return commonOnKeyDown(event);
        }
        // If a floating element should not open on arrow key down, avoid
        // setting `activeIndex` while it's closed.
        if (!open && !openOnArrowKeyDown && isArrowKey) {
          return;
        }
        if (isNavigationKey) {
          const isParentMainKey = isMainOrientationKey(event.key, getParentOrientation());
          keyRef.current = nested && isParentMainKey ? null : event.key;
        }
        if (nested) {
          if (isParentCrossOpenKey) {
            stopEvent(event);
            if (open) {
              indexRef.current = getMinListIndex(listRef, disabledIndicesRef.current);
              onNavigate();
            } else {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            }
          }
          return;
        }
        if (isMainKey) {
          if (selectedIndex != null) {
            indexRef.current = selectedIndex;
          }
          stopEvent(event);
          if (!open && openOnArrowKeyDown) {
            onOpenChange(true, event.nativeEvent, 'list-navigation');
          } else {
            commonOnKeyDown(event);
          }
          if (open) {
            onNavigate();
          }
        }
      },
      onFocus() {
        if (open && !virtual) {
          indexRef.current = -1;
          onNavigate();
        }
      },
      onPointerDown: checkVirtualPointer,
      onPointerEnter: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    };
  }, [activeId, ariaActiveDescendantProp, cols, commonOnKeyDown, disabledIndicesRef, focusItemOnOpen, listRef, nested, onNavigate, onOpenChange, open, openOnArrowKeyDown, orientation, getParentOrientation, rtl, selectedIndex, tree, virtual, virtualItemRef]);
  return React.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

const componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _elements$domReferenc, _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements,
    floatingId: defaultFloatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const defaultReferenceId = useId();
  const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
  const floatingId = react.useMemo(() => {
    var _getFloatingFocusElem;
    return ((_getFloatingFocusElem = floating_ui_react_utils_getFloatingFocusElement(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
  }, [elements.floating, defaultFloatingId]);
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  const reference = react.useMemo(() => {
    if (ariaRole === 'tooltip' || role === 'label') {
      return {
        ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
      };
    }
    return {
      'aria-expanded': open ? 'true' : 'false',
      'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
      'aria-controls': open ? floatingId : undefined,
      ...(ariaRole === 'listbox' && {
        role: 'combobox'
      }),
      ...(ariaRole === 'menu' && {
        id: referenceId
      }),
      ...(ariaRole === 'menu' && isNested && {
        role: 'menuitem'
      }),
      ...(role === 'select' && {
        'aria-autocomplete': 'none'
      }),
      ...(role === 'combobox' && {
        'aria-autocomplete': 'list'
      })
    };
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  const floating = react.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      ...(ariaRole && {
        role: ariaRole
      })
    };
    if (ariaRole === 'tooltip' || role === 'label') {
      return floatingProps;
    }
    return {
      ...floatingProps,
      ...(ariaRole === 'menu' && {
        'aria-labelledby': referenceId
      })
    };
  }, [ariaRole, floatingId, referenceId, role]);
  const item = react.useCallback(_ref => {
    let {
      active,
      selected
    } = _ref;
    const commonProps = {
      role: 'option',
      ...(active && {
        id: floatingId + "-fui-option"
      })
    };

    // For `menu`, we are unable to tell if the item is a `menuitemradio`
    // or `menuitemcheckbox`. For backwards-compatibility reasons, also
    // avoid defaulting to `menuitem` as it may overwrite custom role props.
    switch (role) {
      case 'select':
      case 'combobox':
        return {
          ...commonProps,
          'aria-selected': selected
        };
    }
    return {};
  }, [floatingId, role]);
  return react.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(() => {
    if (!open && isMounted) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [status, setStatus] = React.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === 'close') {
    setStatus('unmounted');
  }
  useModernLayoutEffect(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        // Ensure it opens before paint. With `FloatingDelayGroup`,
        // this avoids a flicker when moving between floating elements
        // to ensure one is always open with no missing frames.
        ReactDOM.flushSync(() => {
          setStatus('open');
        });
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setStatus('close');
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = React.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = React.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  useModernLayoutEffect(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  const {
    open,
    dataRef
  } = context;
  const {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch,
    onTypingChange: unstable_onTypingChange,
    enabled = true,
    findMatch = null,
    resetMs = 750,
    ignoreKeys = [],
    selectedIndex = null
  } = props;
  const timeoutIdRef = React.useRef(-1);
  const stringRef = React.useRef('');
  const prevIndexRef = React.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  const matchIndexRef = React.useRef(null);
  const onMatch = useEffectEvent(unstable_onMatch);
  const onTypingChange = useEffectEvent(unstable_onTypingChange);
  const findMatchRef = useLatestRef(findMatch);
  const ignoreKeysRef = useLatestRef(ignoreKeys);
  useModernLayoutEffect(() => {
    if (open) {
      clearTimeoutIfSet(timeoutIdRef);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  useModernLayoutEffect(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  const setTypingChange = useEffectEvent(value => {
    if (value) {
      if (!dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    } else {
      if (dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    }
  });
  const onKeyDown = useEffectEvent(event => {
    function getMatchingIndex(list, orderedList, string) {
      const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
      return str ? list.indexOf(str) : -1;
    }
    const listContent = listRef.current;
    if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
      if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
        setTypingChange(false);
      } else if (event.key === ' ') {
        stopEvent(event);
      }
    }
    if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
    // Character key.
    event.key.length !== 1 ||
    // Modifier key.
    event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (open && event.key !== ' ') {
      stopEvent(event);
      setTypingChange(true);
    }

    // Bail out if the list contains a word like "llama" or "aaron". TODO:
    // allow it in this case, too.
    const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
      var _text$, _text$2;
      return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
    });

    // Allows the user to cycle through items that start with the same letter
    // in rapid succession.
    if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
    }
    stringRef.current += event.key;
    clearTimeoutIfSet(timeoutIdRef);
    timeoutIdRef.current = window.setTimeout(() => {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
      setTypingChange(false);
    }, resetMs);
    const prevIndex = prevIndexRef.current;
    const index = getMatchingIndex(listContent, [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)], stringRef.current);
    if (index !== -1) {
      onMatch(index);
      matchIndexRef.current = index;
    } else if (event.key !== ' ') {
      stringRef.current = '';
      setTypingChange(false);
    }
  });
  const reference = React.useMemo(() => ({
    onKeyDown
  }), [onKeyDown]);
  const floating = React.useMemo(() => {
    return {
      onKeyDown,
      onKeyUp(event) {
        if (event.key === ' ') {
          setTypingChange(false);
        }
      }
    };
  }, [onKeyDown, setTypingChange]);
  return React.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = evaluate(props, state);
    const {
      rects,
      platform,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;

    // Valid combinations:
    // 1. Floating element is the scrollRef and has a border (default)
    // 2. Floating element is not the scrollRef, floating element has a border
    // 3. Floating element is not the scrollRef, scrollRef has a border
    // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
    // allowed as VoiceOver doesn't work.
    const clientTop = floating.clientTop || scrollEl.clientTop;
    const floatingIsBordered = floating.clientTop !== 0;
    const scrollElIsBordered = scrollEl.clientTop !== 0;
    const floatingIsScrollEl = floating === scrollEl;
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const overflow = await platform.detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
    const refOverflow = await platform.detectOverflow(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
    const rounder = isScrollable ? v => v : round;
    const maxHeight = rounder(max(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - max(0, overflow.bottom)));
    scrollEl.style.maxHeight = maxHeight + "px";
    scrollEl.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * min(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
      ReactDOM.flushSync(() => onFallbackChange(shouldFallback));
    }
    if (overflowRef) {
      overflowRef.current = await platform.detectOverflow(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = React.useRef(false);
  const prevScrollTopRef = React.useRef(null);
  const initialOverflowRef = React.useRef(null);
  React.useEffect(() => {
    if (!enabled) return;
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        ReactDOM.flushSync(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  const floating = React.useMemo(() => ({
    onKeyDown() {
      controlledScrollingRef.current = true;
    },
    onWheel() {
      controlledScrollingRef.current = false;
    },
    onPointerMove() {
      controlledScrollingRef.current = false;
    },
    onScroll() {
      const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
      if (!overflowRef.current || !el || !controlledScrollingRef.current) {
        return;
      }
      if (prevScrollTopRef.current !== null) {
        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
          ReactDOM.flushSync(() => onChange(d => d + scrollDiff));
        }
      }

      // [Firefox] Wait for the height change to have been applied.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
      });
    }
  }), [elements.floating, onChange, overflowRef, scrollRef]);
  return React.useMemo(() => enabled ? {
    floating
  } : {}, [enabled, floating]);
}

function floating_ui_react_getNodeChildren(nodes, id, onlyOpenChildren) {
  if (onlyOpenChildren === void 0) {
    onlyOpenChildren = true;
  }
  const directChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
  });
  return directChildren.flatMap(child => [child, ...floating_ui_react_getNodeChildren(nodes, child.id, onlyOpenChildren)]);
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  const timeoutRef = {
    current: -1
  };
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeoutIfSet(timeoutRef);
        onClose();
      }
      clearTimeoutIfSet(timeoutRef);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = floating_ui_react_getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = floating_ui_react_contains(elements.floating, target);
      const isOverReferenceEl = floating_ui_react_contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && floating_ui_react_contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && floating_ui_react_getNodeChildren(tree.nodesRef.current, nodeId).length) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref2) {
        let [x, y] = _ref2;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutRef.current = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}




/***/ }),

/***/ 37317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ getComputedStyle; },
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Kx": function() { return /* binding */ getOverflowAncestors; },
/* harmony export */   "Lw": function() { return /* binding */ getNodeScroll; },
/* harmony export */   "Ow": function() { return /* binding */ getParentNode; },
/* harmony export */   "Pf": function() { return /* binding */ isWebKit; },
/* harmony export */   "Py": function() { return /* binding */ isLastTraversableNode; },
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "Ze": function() { return /* binding */ isTableElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; },
/* harmony export */   "ao": function() { return /* binding */ isOverflowElement; },
/* harmony export */   "gQ": function() { return /* binding */ getContainingBlock; },
/* harmony export */   "hT": function() { return /* binding */ isContainingBlock; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "tF": function() { return /* binding */ getDocumentElement; },
/* harmony export */   "tR": function() { return /* binding */ isTopLayer; },
/* harmony export */   "wK": function() { return /* binding */ getFrameElement; },
/* harmony export */   "wk": function() { return /* binding */ getNodeName; }
/* harmony export */ });
/* unused harmony exports getNearestOverflowAncestor, isNode */
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
  return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(':popover-open')) {
      return true;
    }
  } catch (_e) {
    // no-op
  }
  try {
    return element.matches(':modal');
  } catch (_e) {
    return false;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = value => !!value && value !== 'none';
let isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}




/***/ }),

/***/ 90512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f)}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 37238:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ buildFormatLongFn; }
/* harmony export */ });
function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}


/***/ }),

/***/ 65580:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ buildLocalizeFn; }
/* harmony export */ });
/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}


/***/ }),

/***/ 95021:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ buildMatchFn; }
/* harmony export */ });
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}


/***/ }),

/***/ 6898:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ buildMatchPatternFn; }
/* harmony export */ });
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}


/***/ }),

/***/ 45459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32841);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (startOfDay)));


/***/ }),

/***/ 32841:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ toDate; }
/* harmony export */ });
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (toDate)));


/***/ }),

/***/ 25935:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "du": function() { return /* binding */ domToReact; }
/* harmony export */ });
/* unused harmony exports htmlToDOM, attributesToProps, Comment, Element, ProcessingInstruction, Text */
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30488);


var domToReact = _index_js__WEBPACK_IMPORTED_MODULE_0__.domToReact;
var htmlToDOM = _index_js__WEBPACK_IMPORTED_MODULE_0__.htmlToDOM;
var attributesToProps = _index_js__WEBPACK_IMPORTED_MODULE_0__.attributesToProps;

// domhandler
var Comment = _index_js__WEBPACK_IMPORTED_MODULE_0__.Comment;
var Element = _index_js__WEBPACK_IMPORTED_MODULE_0__.Element;
var ProcessingInstruction = _index_js__WEBPACK_IMPORTED_MODULE_0__.ProcessingInstruction;
var Text = _index_js__WEBPACK_IMPORTED_MODULE_0__.Text;

/* harmony default export */ __webpack_exports__["ZP"] = (_index_js__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ 12002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uI": function() { return /* binding */ useDropzone; }
});

// UNUSED EXPORTS: ErrorCode, default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});

;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es2015/file.js
const COMMON_MIME_TYPES = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    ['1km', 'application/vnd.1000minds.decision-model+xml'],
    ['3dml', 'text/vnd.in3d.3dml'],
    ['3ds', 'image/x-3ds'],
    ['3g2', 'video/3gpp2'],
    ['3gp', 'video/3gp'],
    ['3gpp', 'video/3gpp'],
    ['3mf', 'model/3mf'],
    ['7z', 'application/x-7z-compressed'],
    ['7zip', 'application/x-7z-compressed'],
    ['123', 'application/vnd.lotus-1-2-3'],
    ['aab', 'application/x-authorware-bin'],
    ['aac', 'audio/x-acc'],
    ['aam', 'application/x-authorware-map'],
    ['aas', 'application/x-authorware-seg'],
    ['abw', 'application/x-abiword'],
    ['ac', 'application/vnd.nokia.n-gage.ac+xml'],
    ['ac3', 'audio/ac3'],
    ['acc', 'application/vnd.americandynamics.acc'],
    ['ace', 'application/x-ace-compressed'],
    ['acu', 'application/vnd.acucobol'],
    ['acutc', 'application/vnd.acucorp'],
    ['adp', 'audio/adpcm'],
    ['aep', 'application/vnd.audiograph'],
    ['afm', 'application/x-font-type1'],
    ['afp', 'application/vnd.ibm.modcap'],
    ['ahead', 'application/vnd.ahead.space'],
    ['ai', 'application/pdf'],
    ['aif', 'audio/x-aiff'],
    ['aifc', 'audio/x-aiff'],
    ['aiff', 'audio/x-aiff'],
    ['air', 'application/vnd.adobe.air-application-installer-package+zip'],
    ['ait', 'application/vnd.dvb.ait'],
    ['ami', 'application/vnd.amiga.ami'],
    ['amr', 'audio/amr'],
    ['apk', 'application/vnd.android.package-archive'],
    ['apng', 'image/apng'],
    ['appcache', 'text/cache-manifest'],
    ['application', 'application/x-ms-application'],
    ['apr', 'application/vnd.lotus-approach'],
    ['arc', 'application/x-freearc'],
    ['arj', 'application/x-arj'],
    ['asc', 'application/pgp-signature'],
    ['asf', 'video/x-ms-asf'],
    ['asm', 'text/x-asm'],
    ['aso', 'application/vnd.accpac.simply.aso'],
    ['asx', 'video/x-ms-asf'],
    ['atc', 'application/vnd.acucorp'],
    ['atom', 'application/atom+xml'],
    ['atomcat', 'application/atomcat+xml'],
    ['atomdeleted', 'application/atomdeleted+xml'],
    ['atomsvc', 'application/atomsvc+xml'],
    ['atx', 'application/vnd.antix.game-component'],
    ['au', 'audio/x-au'],
    ['avi', 'video/x-msvideo'],
    ['avif', 'image/avif'],
    ['aw', 'application/applixware'],
    ['azf', 'application/vnd.airzip.filesecure.azf'],
    ['azs', 'application/vnd.airzip.filesecure.azs'],
    ['azv', 'image/vnd.airzip.accelerator.azv'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['b16', 'image/vnd.pco.b16'],
    ['bat', 'application/x-msdownload'],
    ['bcpio', 'application/x-bcpio'],
    ['bdf', 'application/x-font-bdf'],
    ['bdm', 'application/vnd.syncml.dm+wbxml'],
    ['bdoc', 'application/x-bdoc'],
    ['bed', 'application/vnd.realvnc.bed'],
    ['bh2', 'application/vnd.fujitsu.oasysprs'],
    ['bin', 'application/octet-stream'],
    ['blb', 'application/x-blorb'],
    ['blorb', 'application/x-blorb'],
    ['bmi', 'application/vnd.bmi'],
    ['bmml', 'application/vnd.balsamiq.bmml+xml'],
    ['bmp', 'image/bmp'],
    ['book', 'application/vnd.framemaker'],
    ['box', 'application/vnd.previewsystems.box'],
    ['boz', 'application/x-bzip2'],
    ['bpk', 'application/octet-stream'],
    ['bpmn', 'application/octet-stream'],
    ['bsp', 'model/vnd.valve.source.compiled-map'],
    ['btif', 'image/prs.btif'],
    ['buffer', 'application/octet-stream'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['c', 'text/x-c'],
    ['c4d', 'application/vnd.clonk.c4group'],
    ['c4f', 'application/vnd.clonk.c4group'],
    ['c4g', 'application/vnd.clonk.c4group'],
    ['c4p', 'application/vnd.clonk.c4group'],
    ['c4u', 'application/vnd.clonk.c4group'],
    ['c11amc', 'application/vnd.cluetrust.cartomobile-config'],
    ['c11amz', 'application/vnd.cluetrust.cartomobile-config-pkg'],
    ['cab', 'application/vnd.ms-cab-compressed'],
    ['caf', 'audio/x-caf'],
    ['cap', 'application/vnd.tcpdump.pcap'],
    ['car', 'application/vnd.curl.car'],
    ['cat', 'application/vnd.ms-pki.seccat'],
    ['cb7', 'application/x-cbr'],
    ['cba', 'application/x-cbr'],
    ['cbr', 'application/x-cbr'],
    ['cbt', 'application/x-cbr'],
    ['cbz', 'application/x-cbr'],
    ['cc', 'text/x-c'],
    ['cco', 'application/x-cocoa'],
    ['cct', 'application/x-director'],
    ['ccxml', 'application/ccxml+xml'],
    ['cdbcmsg', 'application/vnd.contact.cmsg'],
    ['cda', 'application/x-cdf'],
    ['cdf', 'application/x-netcdf'],
    ['cdfx', 'application/cdfx+xml'],
    ['cdkey', 'application/vnd.mediastation.cdkey'],
    ['cdmia', 'application/cdmi-capability'],
    ['cdmic', 'application/cdmi-container'],
    ['cdmid', 'application/cdmi-domain'],
    ['cdmio', 'application/cdmi-object'],
    ['cdmiq', 'application/cdmi-queue'],
    ['cdr', 'application/cdr'],
    ['cdx', 'chemical/x-cdx'],
    ['cdxml', 'application/vnd.chemdraw+xml'],
    ['cdy', 'application/vnd.cinderella'],
    ['cer', 'application/pkix-cert'],
    ['cfs', 'application/x-cfs-compressed'],
    ['cgm', 'image/cgm'],
    ['chat', 'application/x-chat'],
    ['chm', 'application/vnd.ms-htmlhelp'],
    ['chrt', 'application/vnd.kde.kchart'],
    ['cif', 'chemical/x-cif'],
    ['cii', 'application/vnd.anser-web-certificate-issue-initiation'],
    ['cil', 'application/vnd.ms-artgalry'],
    ['cjs', 'application/node'],
    ['cla', 'application/vnd.claymore'],
    ['class', 'application/octet-stream'],
    ['clkk', 'application/vnd.crick.clicker.keyboard'],
    ['clkp', 'application/vnd.crick.clicker.palette'],
    ['clkt', 'application/vnd.crick.clicker.template'],
    ['clkw', 'application/vnd.crick.clicker.wordbank'],
    ['clkx', 'application/vnd.crick.clicker'],
    ['clp', 'application/x-msclip'],
    ['cmc', 'application/vnd.cosmocaller'],
    ['cmdf', 'chemical/x-cmdf'],
    ['cml', 'chemical/x-cml'],
    ['cmp', 'application/vnd.yellowriver-custom-menu'],
    ['cmx', 'image/x-cmx'],
    ['cod', 'application/vnd.rim.cod'],
    ['coffee', 'text/coffeescript'],
    ['com', 'application/x-msdownload'],
    ['conf', 'text/plain'],
    ['cpio', 'application/x-cpio'],
    ['cpp', 'text/x-c'],
    ['cpt', 'application/mac-compactpro'],
    ['crd', 'application/x-mscardfile'],
    ['crl', 'application/pkix-crl'],
    ['crt', 'application/x-x509-ca-cert'],
    ['crx', 'application/x-chrome-extension'],
    ['cryptonote', 'application/vnd.rig.cryptonote'],
    ['csh', 'application/x-csh'],
    ['csl', 'application/vnd.citationstyles.style+xml'],
    ['csml', 'chemical/x-csml'],
    ['csp', 'application/vnd.commonspace'],
    ['csr', 'application/octet-stream'],
    ['css', 'text/css'],
    ['cst', 'application/x-director'],
    ['csv', 'text/csv'],
    ['cu', 'application/cu-seeme'],
    ['curl', 'text/vnd.curl'],
    ['cww', 'application/prs.cww'],
    ['cxt', 'application/x-director'],
    ['cxx', 'text/x-c'],
    ['dae', 'model/vnd.collada+xml'],
    ['daf', 'application/vnd.mobius.daf'],
    ['dart', 'application/vnd.dart'],
    ['dataless', 'application/vnd.fdsn.seed'],
    ['davmount', 'application/davmount+xml'],
    ['dbf', 'application/vnd.dbf'],
    ['dbk', 'application/docbook+xml'],
    ['dcr', 'application/x-director'],
    ['dcurl', 'text/vnd.curl.dcurl'],
    ['dd2', 'application/vnd.oma.dd2+xml'],
    ['ddd', 'application/vnd.fujixerox.ddd'],
    ['ddf', 'application/vnd.syncml.dmddf+xml'],
    ['dds', 'image/vnd.ms-dds'],
    ['deb', 'application/x-debian-package'],
    ['def', 'text/plain'],
    ['deploy', 'application/octet-stream'],
    ['der', 'application/x-x509-ca-cert'],
    ['dfac', 'application/vnd.dreamfactory'],
    ['dgc', 'application/x-dgc-compressed'],
    ['dic', 'text/x-c'],
    ['dir', 'application/x-director'],
    ['dis', 'application/vnd.mobius.dis'],
    ['disposition-notification', 'message/disposition-notification'],
    ['dist', 'application/octet-stream'],
    ['distz', 'application/octet-stream'],
    ['djv', 'image/vnd.djvu'],
    ['djvu', 'image/vnd.djvu'],
    ['dll', 'application/octet-stream'],
    ['dmg', 'application/x-apple-diskimage'],
    ['dmn', 'application/octet-stream'],
    ['dmp', 'application/vnd.tcpdump.pcap'],
    ['dms', 'application/octet-stream'],
    ['dna', 'application/vnd.dna'],
    ['doc', 'application/msword'],
    ['docm', 'application/vnd.ms-word.template.macroEnabled.12'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['dot', 'application/msword'],
    ['dotm', 'application/vnd.ms-word.template.macroEnabled.12'],
    ['dotx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'],
    ['dp', 'application/vnd.osgi.dp'],
    ['dpg', 'application/vnd.dpgraph'],
    ['dra', 'audio/vnd.dra'],
    ['drle', 'image/dicom-rle'],
    ['dsc', 'text/prs.lines.tag'],
    ['dssc', 'application/dssc+der'],
    ['dtb', 'application/x-dtbook+xml'],
    ['dtd', 'application/xml-dtd'],
    ['dts', 'audio/vnd.dts'],
    ['dtshd', 'audio/vnd.dts.hd'],
    ['dump', 'application/octet-stream'],
    ['dvb', 'video/vnd.dvb.file'],
    ['dvi', 'application/x-dvi'],
    ['dwd', 'application/atsc-dwd+xml'],
    ['dwf', 'model/vnd.dwf'],
    ['dwg', 'image/vnd.dwg'],
    ['dxf', 'image/vnd.dxf'],
    ['dxp', 'application/vnd.spotfire.dxp'],
    ['dxr', 'application/x-director'],
    ['ear', 'application/java-archive'],
    ['ecelp4800', 'audio/vnd.nuera.ecelp4800'],
    ['ecelp7470', 'audio/vnd.nuera.ecelp7470'],
    ['ecelp9600', 'audio/vnd.nuera.ecelp9600'],
    ['ecma', 'application/ecmascript'],
    ['edm', 'application/vnd.novadigm.edm'],
    ['edx', 'application/vnd.novadigm.edx'],
    ['efif', 'application/vnd.picsel'],
    ['ei6', 'application/vnd.pg.osasli'],
    ['elc', 'application/octet-stream'],
    ['emf', 'image/emf'],
    ['eml', 'message/rfc822'],
    ['emma', 'application/emma+xml'],
    ['emotionml', 'application/emotionml+xml'],
    ['emz', 'application/x-msmetafile'],
    ['eol', 'audio/vnd.digital-winds'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['eps', 'application/postscript'],
    ['epub', 'application/epub+zip'],
    ['es', 'application/ecmascript'],
    ['es3', 'application/vnd.eszigno3+xml'],
    ['esa', 'application/vnd.osgi.subsystem'],
    ['esf', 'application/vnd.epson.esf'],
    ['et3', 'application/vnd.eszigno3+xml'],
    ['etx', 'text/x-setext'],
    ['eva', 'application/x-eva'],
    ['evy', 'application/x-envoy'],
    ['exe', 'application/octet-stream'],
    ['exi', 'application/exi'],
    ['exp', 'application/express'],
    ['exr', 'image/aces'],
    ['ext', 'application/vnd.novadigm.ext'],
    ['ez', 'application/andrew-inset'],
    ['ez2', 'application/vnd.ezpix-album'],
    ['ez3', 'application/vnd.ezpix-package'],
    ['f', 'text/x-fortran'],
    ['f4v', 'video/mp4'],
    ['f77', 'text/x-fortran'],
    ['f90', 'text/x-fortran'],
    ['fbs', 'image/vnd.fastbidsheet'],
    ['fcdt', 'application/vnd.adobe.formscentral.fcdt'],
    ['fcs', 'application/vnd.isac.fcs'],
    ['fdf', 'application/vnd.fdf'],
    ['fdt', 'application/fdt+xml'],
    ['fe_launch', 'application/vnd.denovo.fcselayout-link'],
    ['fg5', 'application/vnd.fujitsu.oasysgp'],
    ['fgd', 'application/x-director'],
    ['fh', 'image/x-freehand'],
    ['fh4', 'image/x-freehand'],
    ['fh5', 'image/x-freehand'],
    ['fh7', 'image/x-freehand'],
    ['fhc', 'image/x-freehand'],
    ['fig', 'application/x-xfig'],
    ['fits', 'image/fits'],
    ['flac', 'audio/x-flac'],
    ['fli', 'video/x-fli'],
    ['flo', 'application/vnd.micrografx.flo'],
    ['flv', 'video/x-flv'],
    ['flw', 'application/vnd.kde.kivio'],
    ['flx', 'text/vnd.fmi.flexstor'],
    ['fly', 'text/vnd.fly'],
    ['fm', 'application/vnd.framemaker'],
    ['fnc', 'application/vnd.frogans.fnc'],
    ['fo', 'application/vnd.software602.filler.form+xml'],
    ['for', 'text/x-fortran'],
    ['fpx', 'image/vnd.fpx'],
    ['frame', 'application/vnd.framemaker'],
    ['fsc', 'application/vnd.fsc.weblaunch'],
    ['fst', 'image/vnd.fst'],
    ['ftc', 'application/vnd.fluxtime.clip'],
    ['fti', 'application/vnd.anser-web-funds-transfer-initiation'],
    ['fvt', 'video/vnd.fvt'],
    ['fxp', 'application/vnd.adobe.fxp'],
    ['fxpl', 'application/vnd.adobe.fxp'],
    ['fzs', 'application/vnd.fuzzysheet'],
    ['g2w', 'application/vnd.geoplan'],
    ['g3', 'image/g3fax'],
    ['g3w', 'application/vnd.geospace'],
    ['gac', 'application/vnd.groove-account'],
    ['gam', 'application/x-tads'],
    ['gbr', 'application/rpki-ghostbusters'],
    ['gca', 'application/x-gca-compressed'],
    ['gdl', 'model/vnd.gdl'],
    ['gdoc', 'application/vnd.google-apps.document'],
    ['geo', 'application/vnd.dynageo'],
    ['geojson', 'application/geo+json'],
    ['gex', 'application/vnd.geometry-explorer'],
    ['ggb', 'application/vnd.geogebra.file'],
    ['ggt', 'application/vnd.geogebra.tool'],
    ['ghf', 'application/vnd.groove-help'],
    ['gif', 'image/gif'],
    ['gim', 'application/vnd.groove-identity-message'],
    ['glb', 'model/gltf-binary'],
    ['gltf', 'model/gltf+json'],
    ['gml', 'application/gml+xml'],
    ['gmx', 'application/vnd.gmx'],
    ['gnumeric', 'application/x-gnumeric'],
    ['gpg', 'application/gpg-keys'],
    ['gph', 'application/vnd.flographit'],
    ['gpx', 'application/gpx+xml'],
    ['gqf', 'application/vnd.grafeq'],
    ['gqs', 'application/vnd.grafeq'],
    ['gram', 'application/srgs'],
    ['gramps', 'application/x-gramps-xml'],
    ['gre', 'application/vnd.geometry-explorer'],
    ['grv', 'application/vnd.groove-injector'],
    ['grxml', 'application/srgs+xml'],
    ['gsf', 'application/x-font-ghostscript'],
    ['gsheet', 'application/vnd.google-apps.spreadsheet'],
    ['gslides', 'application/vnd.google-apps.presentation'],
    ['gtar', 'application/x-gtar'],
    ['gtm', 'application/vnd.groove-tool-message'],
    ['gtw', 'model/vnd.gtw'],
    ['gv', 'text/vnd.graphviz'],
    ['gxf', 'application/gxf'],
    ['gxt', 'application/vnd.geonext'],
    ['gz', 'application/gzip'],
    ['gzip', 'application/gzip'],
    ['h', 'text/x-c'],
    ['h261', 'video/h261'],
    ['h263', 'video/h263'],
    ['h264', 'video/h264'],
    ['hal', 'application/vnd.hal+xml'],
    ['hbci', 'application/vnd.hbci'],
    ['hbs', 'text/x-handlebars-template'],
    ['hdd', 'application/x-virtualbox-hdd'],
    ['hdf', 'application/x-hdf'],
    ['heic', 'image/heic'],
    ['heics', 'image/heic-sequence'],
    ['heif', 'image/heif'],
    ['heifs', 'image/heif-sequence'],
    ['hej2', 'image/hej2k'],
    ['held', 'application/atsc-held+xml'],
    ['hh', 'text/x-c'],
    ['hjson', 'application/hjson'],
    ['hlp', 'application/winhlp'],
    ['hpgl', 'application/vnd.hp-hpgl'],
    ['hpid', 'application/vnd.hp-hpid'],
    ['hps', 'application/vnd.hp-hps'],
    ['hqx', 'application/mac-binhex40'],
    ['hsj2', 'image/hsj2'],
    ['htc', 'text/x-component'],
    ['htke', 'application/vnd.kenameaapp'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['hvd', 'application/vnd.yamaha.hv-dic'],
    ['hvp', 'application/vnd.yamaha.hv-voice'],
    ['hvs', 'application/vnd.yamaha.hv-script'],
    ['i2g', 'application/vnd.intergeo'],
    ['icc', 'application/vnd.iccprofile'],
    ['ice', 'x-conference/x-cooltalk'],
    ['icm', 'application/vnd.iccprofile'],
    ['ico', 'image/x-icon'],
    ['ics', 'text/calendar'],
    ['ief', 'image/ief'],
    ['ifb', 'text/calendar'],
    ['ifm', 'application/vnd.shana.informed.formdata'],
    ['iges', 'model/iges'],
    ['igl', 'application/vnd.igloader'],
    ['igm', 'application/vnd.insors.igm'],
    ['igs', 'model/iges'],
    ['igx', 'application/vnd.micrografx.igx'],
    ['iif', 'application/vnd.shana.informed.interchange'],
    ['img', 'application/octet-stream'],
    ['imp', 'application/vnd.accpac.simply.imp'],
    ['ims', 'application/vnd.ms-ims'],
    ['in', 'text/plain'],
    ['ini', 'text/plain'],
    ['ink', 'application/inkml+xml'],
    ['inkml', 'application/inkml+xml'],
    ['install', 'application/x-install-instructions'],
    ['iota', 'application/vnd.astraea-software.iota'],
    ['ipfix', 'application/ipfix'],
    ['ipk', 'application/vnd.shana.informed.package'],
    ['irm', 'application/vnd.ibm.rights-management'],
    ['irp', 'application/vnd.irepository.package+xml'],
    ['iso', 'application/x-iso9660-image'],
    ['itp', 'application/vnd.shana.informed.formtemplate'],
    ['its', 'application/its+xml'],
    ['ivp', 'application/vnd.immervision-ivp'],
    ['ivu', 'application/vnd.immervision-ivu'],
    ['jad', 'text/vnd.sun.j2me.app-descriptor'],
    ['jade', 'text/jade'],
    ['jam', 'application/vnd.jam'],
    ['jar', 'application/java-archive'],
    ['jardiff', 'application/x-java-archive-diff'],
    ['java', 'text/x-java-source'],
    ['jhc', 'image/jphc'],
    ['jisp', 'application/vnd.jisp'],
    ['jls', 'image/jls'],
    ['jlt', 'application/vnd.hp-jlyt'],
    ['jng', 'image/x-jng'],
    ['jnlp', 'application/x-java-jnlp-file'],
    ['joda', 'application/vnd.joost.joda-archive'],
    ['jp2', 'image/jp2'],
    ['jpe', 'image/jpeg'],
    ['jpeg', 'image/jpeg'],
    ['jpf', 'image/jpx'],
    ['jpg', 'image/jpeg'],
    ['jpg2', 'image/jp2'],
    ['jpgm', 'video/jpm'],
    ['jpgv', 'video/jpeg'],
    ['jph', 'image/jph'],
    ['jpm', 'video/jpm'],
    ['jpx', 'image/jpx'],
    ['js', 'application/javascript'],
    ['json', 'application/json'],
    ['json5', 'application/json5'],
    ['jsonld', 'application/ld+json'],
    // https://jsonlines.org/
    ['jsonl', 'application/jsonl'],
    ['jsonml', 'application/jsonml+json'],
    ['jsx', 'text/jsx'],
    ['jxr', 'image/jxr'],
    ['jxra', 'image/jxra'],
    ['jxrs', 'image/jxrs'],
    ['jxs', 'image/jxs'],
    ['jxsc', 'image/jxsc'],
    ['jxsi', 'image/jxsi'],
    ['jxss', 'image/jxss'],
    ['kar', 'audio/midi'],
    ['karbon', 'application/vnd.kde.karbon'],
    ['kdb', 'application/octet-stream'],
    ['kdbx', 'application/x-keepass2'],
    ['key', 'application/x-iwork-keynote-sffkey'],
    ['kfo', 'application/vnd.kde.kformula'],
    ['kia', 'application/vnd.kidspiration'],
    ['kml', 'application/vnd.google-earth.kml+xml'],
    ['kmz', 'application/vnd.google-earth.kmz'],
    ['kne', 'application/vnd.kinar'],
    ['knp', 'application/vnd.kinar'],
    ['kon', 'application/vnd.kde.kontour'],
    ['kpr', 'application/vnd.kde.kpresenter'],
    ['kpt', 'application/vnd.kde.kpresenter'],
    ['kpxx', 'application/vnd.ds-keypoint'],
    ['ksp', 'application/vnd.kde.kspread'],
    ['ktr', 'application/vnd.kahootz'],
    ['ktx', 'image/ktx'],
    ['ktx2', 'image/ktx2'],
    ['ktz', 'application/vnd.kahootz'],
    ['kwd', 'application/vnd.kde.kword'],
    ['kwt', 'application/vnd.kde.kword'],
    ['lasxml', 'application/vnd.las.las+xml'],
    ['latex', 'application/x-latex'],
    ['lbd', 'application/vnd.llamagraphics.life-balance.desktop'],
    ['lbe', 'application/vnd.llamagraphics.life-balance.exchange+xml'],
    ['les', 'application/vnd.hhe.lesson-player'],
    ['less', 'text/less'],
    ['lgr', 'application/lgr+xml'],
    ['lha', 'application/octet-stream'],
    ['link66', 'application/vnd.route66.link66+xml'],
    ['list', 'text/plain'],
    ['list3820', 'application/vnd.ibm.modcap'],
    ['listafp', 'application/vnd.ibm.modcap'],
    ['litcoffee', 'text/coffeescript'],
    ['lnk', 'application/x-ms-shortcut'],
    ['log', 'text/plain'],
    ['lostxml', 'application/lost+xml'],
    ['lrf', 'application/octet-stream'],
    ['lrm', 'application/vnd.ms-lrm'],
    ['ltf', 'application/vnd.frogans.ltf'],
    ['lua', 'text/x-lua'],
    ['luac', 'application/x-lua-bytecode'],
    ['lvp', 'audio/vnd.lucent.voice'],
    ['lwp', 'application/vnd.lotus-wordpro'],
    ['lzh', 'application/octet-stream'],
    ['m1v', 'video/mpeg'],
    ['m2a', 'audio/mpeg'],
    ['m2v', 'video/mpeg'],
    ['m3a', 'audio/mpeg'],
    ['m3u', 'text/plain'],
    ['m3u8', 'application/vnd.apple.mpegurl'],
    ['m4a', 'audio/x-m4a'],
    ['m4p', 'application/mp4'],
    ['m4s', 'video/iso.segment'],
    ['m4u', 'application/vnd.mpegurl'],
    ['m4v', 'video/x-m4v'],
    ['m13', 'application/x-msmediaview'],
    ['m14', 'application/x-msmediaview'],
    ['m21', 'application/mp21'],
    ['ma', 'application/mathematica'],
    ['mads', 'application/mads+xml'],
    ['maei', 'application/mmt-aei+xml'],
    ['mag', 'application/vnd.ecowin.chart'],
    ['maker', 'application/vnd.framemaker'],
    ['man', 'text/troff'],
    ['manifest', 'text/cache-manifest'],
    ['map', 'application/json'],
    ['mar', 'application/octet-stream'],
    ['markdown', 'text/markdown'],
    ['mathml', 'application/mathml+xml'],
    ['mb', 'application/mathematica'],
    ['mbk', 'application/vnd.mobius.mbk'],
    ['mbox', 'application/mbox'],
    ['mc1', 'application/vnd.medcalcdata'],
    ['mcd', 'application/vnd.mcd'],
    ['mcurl', 'text/vnd.curl.mcurl'],
    ['md', 'text/markdown'],
    ['mdb', 'application/x-msaccess'],
    ['mdi', 'image/vnd.ms-modi'],
    ['mdx', 'text/mdx'],
    ['me', 'text/troff'],
    ['mesh', 'model/mesh'],
    ['meta4', 'application/metalink4+xml'],
    ['metalink', 'application/metalink+xml'],
    ['mets', 'application/mets+xml'],
    ['mfm', 'application/vnd.mfmp'],
    ['mft', 'application/rpki-manifest'],
    ['mgp', 'application/vnd.osgeo.mapguide.package'],
    ['mgz', 'application/vnd.proteus.magazine'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mie', 'application/x-mie'],
    ['mif', 'application/vnd.mif'],
    ['mime', 'message/rfc822'],
    ['mj2', 'video/mj2'],
    ['mjp2', 'video/mj2'],
    ['mjs', 'application/javascript'],
    ['mk3d', 'video/x-matroska'],
    ['mka', 'audio/x-matroska'],
    ['mkd', 'text/x-markdown'],
    ['mks', 'video/x-matroska'],
    ['mkv', 'video/x-matroska'],
    ['mlp', 'application/vnd.dolby.mlp'],
    ['mmd', 'application/vnd.chipnuts.karaoke-mmd'],
    ['mmf', 'application/vnd.smaf'],
    ['mml', 'text/mathml'],
    ['mmr', 'image/vnd.fujixerox.edmics-mmr'],
    ['mng', 'video/x-mng'],
    ['mny', 'application/x-msmoney'],
    ['mobi', 'application/x-mobipocket-ebook'],
    ['mods', 'application/mods+xml'],
    ['mov', 'video/quicktime'],
    ['movie', 'video/x-sgi-movie'],
    ['mp2', 'audio/mpeg'],
    ['mp2a', 'audio/mpeg'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mp4a', 'audio/mp4'],
    ['mp4s', 'application/mp4'],
    ['mp4v', 'video/mp4'],
    ['mp21', 'application/mp21'],
    ['mpc', 'application/vnd.mophun.certificate'],
    ['mpd', 'application/dash+xml'],
    ['mpe', 'video/mpeg'],
    ['mpeg', 'video/mpeg'],
    ['mpg', 'video/mpeg'],
    ['mpg4', 'video/mp4'],
    ['mpga', 'audio/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['mpm', 'application/vnd.blueice.multipass'],
    ['mpn', 'application/vnd.mophun.application'],
    ['mpp', 'application/vnd.ms-project'],
    ['mpt', 'application/vnd.ms-project'],
    ['mpy', 'application/vnd.ibm.minipay'],
    ['mqy', 'application/vnd.mobius.mqy'],
    ['mrc', 'application/marc'],
    ['mrcx', 'application/marcxml+xml'],
    ['ms', 'text/troff'],
    ['mscml', 'application/mediaservercontrol+xml'],
    ['mseed', 'application/vnd.fdsn.mseed'],
    ['mseq', 'application/vnd.mseq'],
    ['msf', 'application/vnd.epson.msf'],
    ['msg', 'application/vnd.ms-outlook'],
    ['msh', 'model/mesh'],
    ['msi', 'application/x-msdownload'],
    ['msl', 'application/vnd.mobius.msl'],
    ['msm', 'application/octet-stream'],
    ['msp', 'application/octet-stream'],
    ['msty', 'application/vnd.muvee.style'],
    ['mtl', 'model/mtl'],
    ['mts', 'model/vnd.mts'],
    ['mus', 'application/vnd.musician'],
    ['musd', 'application/mmt-usd+xml'],
    ['musicxml', 'application/vnd.recordare.musicxml+xml'],
    ['mvb', 'application/x-msmediaview'],
    ['mvt', 'application/vnd.mapbox-vector-tile'],
    ['mwf', 'application/vnd.mfer'],
    ['mxf', 'application/mxf'],
    ['mxl', 'application/vnd.recordare.musicxml'],
    ['mxmf', 'audio/mobile-xmf'],
    ['mxml', 'application/xv+xml'],
    ['mxs', 'application/vnd.triscape.mxs'],
    ['mxu', 'video/vnd.mpegurl'],
    ['n-gage', 'application/vnd.nokia.n-gage.symbian.install'],
    ['n3', 'text/n3'],
    ['nb', 'application/mathematica'],
    ['nbp', 'application/vnd.wolfram.player'],
    ['nc', 'application/x-netcdf'],
    ['ncx', 'application/x-dtbncx+xml'],
    ['nfo', 'text/x-nfo'],
    ['ngdat', 'application/vnd.nokia.n-gage.data'],
    ['nitf', 'application/vnd.nitf'],
    ['nlu', 'application/vnd.neurolanguage.nlu'],
    ['nml', 'application/vnd.enliven'],
    ['nnd', 'application/vnd.noblenet-directory'],
    ['nns', 'application/vnd.noblenet-sealer'],
    ['nnw', 'application/vnd.noblenet-web'],
    ['npx', 'image/vnd.net-fpx'],
    ['nq', 'application/n-quads'],
    ['nsc', 'application/x-conference'],
    ['nsf', 'application/vnd.lotus-notes'],
    ['nt', 'application/n-triples'],
    ['ntf', 'application/vnd.nitf'],
    ['numbers', 'application/x-iwork-numbers-sffnumbers'],
    ['nzb', 'application/x-nzb'],
    ['oa2', 'application/vnd.fujitsu.oasys2'],
    ['oa3', 'application/vnd.fujitsu.oasys3'],
    ['oas', 'application/vnd.fujitsu.oasys'],
    ['obd', 'application/x-msbinder'],
    ['obgx', 'application/vnd.openblox.game+xml'],
    ['obj', 'model/obj'],
    ['oda', 'application/oda'],
    ['odb', 'application/vnd.oasis.opendocument.database'],
    ['odc', 'application/vnd.oasis.opendocument.chart'],
    ['odf', 'application/vnd.oasis.opendocument.formula'],
    ['odft', 'application/vnd.oasis.opendocument.formula-template'],
    ['odg', 'application/vnd.oasis.opendocument.graphics'],
    ['odi', 'application/vnd.oasis.opendocument.image'],
    ['odm', 'application/vnd.oasis.opendocument.text-master'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogex', 'model/vnd.opengex'],
    ['ogg', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['omdoc', 'application/omdoc+xml'],
    ['onepkg', 'application/onenote'],
    ['onetmp', 'application/onenote'],
    ['onetoc', 'application/onenote'],
    ['onetoc2', 'application/onenote'],
    ['opf', 'application/oebps-package+xml'],
    ['opml', 'text/x-opml'],
    ['oprc', 'application/vnd.palm'],
    ['opus', 'audio/ogg'],
    ['org', 'text/x-org'],
    ['osf', 'application/vnd.yamaha.openscoreformat'],
    ['osfpvg', 'application/vnd.yamaha.openscoreformat.osfpvg+xml'],
    ['osm', 'application/vnd.openstreetmap.data+xml'],
    ['otc', 'application/vnd.oasis.opendocument.chart-template'],
    ['otf', 'font/otf'],
    ['otg', 'application/vnd.oasis.opendocument.graphics-template'],
    ['oth', 'application/vnd.oasis.opendocument.text-web'],
    ['oti', 'application/vnd.oasis.opendocument.image-template'],
    ['otp', 'application/vnd.oasis.opendocument.presentation-template'],
    ['ots', 'application/vnd.oasis.opendocument.spreadsheet-template'],
    ['ott', 'application/vnd.oasis.opendocument.text-template'],
    ['ova', 'application/x-virtualbox-ova'],
    ['ovf', 'application/x-virtualbox-ovf'],
    ['owl', 'application/rdf+xml'],
    ['oxps', 'application/oxps'],
    ['oxt', 'application/vnd.openofficeorg.extension'],
    ['p', 'text/x-pascal'],
    ['p7a', 'application/x-pkcs7-signature'],
    ['p7b', 'application/x-pkcs7-certificates'],
    ['p7c', 'application/pkcs7-mime'],
    ['p7m', 'application/pkcs7-mime'],
    ['p7r', 'application/x-pkcs7-certreqresp'],
    ['p7s', 'application/pkcs7-signature'],
    ['p8', 'application/pkcs8'],
    ['p10', 'application/x-pkcs10'],
    ['p12', 'application/x-pkcs12'],
    ['pac', 'application/x-ns-proxy-autoconfig'],
    ['pages', 'application/x-iwork-pages-sffpages'],
    ['pas', 'text/x-pascal'],
    ['paw', 'application/vnd.pawaafile'],
    ['pbd', 'application/vnd.powerbuilder6'],
    ['pbm', 'image/x-portable-bitmap'],
    ['pcap', 'application/vnd.tcpdump.pcap'],
    ['pcf', 'application/x-font-pcf'],
    ['pcl', 'application/vnd.hp-pcl'],
    ['pclxl', 'application/vnd.hp-pclxl'],
    ['pct', 'image/x-pict'],
    ['pcurl', 'application/vnd.curl.pcurl'],
    ['pcx', 'image/x-pcx'],
    ['pdb', 'application/x-pilot'],
    ['pde', 'text/x-processing'],
    ['pdf', 'application/pdf'],
    ['pem', 'application/x-x509-user-cert'],
    ['pfa', 'application/x-font-type1'],
    ['pfb', 'application/x-font-type1'],
    ['pfm', 'application/x-font-type1'],
    ['pfr', 'application/font-tdpfr'],
    ['pfx', 'application/x-pkcs12'],
    ['pgm', 'image/x-portable-graymap'],
    ['pgn', 'application/x-chess-pgn'],
    ['pgp', 'application/pgp'],
    ['php', 'application/x-httpd-php'],
    ['php3', 'application/x-httpd-php'],
    ['php4', 'application/x-httpd-php'],
    ['phps', 'application/x-httpd-php-source'],
    ['phtml', 'application/x-httpd-php'],
    ['pic', 'image/x-pict'],
    ['pkg', 'application/octet-stream'],
    ['pki', 'application/pkixcmp'],
    ['pkipath', 'application/pkix-pkipath'],
    ['pkpass', 'application/vnd.apple.pkpass'],
    ['pl', 'application/x-perl'],
    ['plb', 'application/vnd.3gpp.pic-bw-large'],
    ['plc', 'application/vnd.mobius.plc'],
    ['plf', 'application/vnd.pocketlearn'],
    ['pls', 'application/pls+xml'],
    ['pm', 'application/x-perl'],
    ['pml', 'application/vnd.ctc-posml'],
    ['png', 'image/png'],
    ['pnm', 'image/x-portable-anymap'],
    ['portpkg', 'application/vnd.macports.portpkg'],
    ['pot', 'application/vnd.ms-powerpoint'],
    ['potm', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
    ['potx', 'application/vnd.openxmlformats-officedocument.presentationml.template'],
    ['ppa', 'application/vnd.ms-powerpoint'],
    ['ppam', 'application/vnd.ms-powerpoint.addin.macroEnabled.12'],
    ['ppd', 'application/vnd.cups-ppd'],
    ['ppm', 'image/x-portable-pixmap'],
    ['pps', 'application/vnd.ms-powerpoint'],
    ['ppsm', 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'],
    ['ppsx', 'application/vnd.openxmlformats-officedocument.presentationml.slideshow'],
    ['ppt', 'application/powerpoint'],
    ['pptm', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['pqa', 'application/vnd.palm'],
    ['prc', 'application/x-pilot'],
    ['pre', 'application/vnd.lotus-freelance'],
    ['prf', 'application/pics-rules'],
    ['provx', 'application/provenance+xml'],
    ['ps', 'application/postscript'],
    ['psb', 'application/vnd.3gpp.pic-bw-small'],
    ['psd', 'application/x-photoshop'],
    ['psf', 'application/x-font-linux-psf'],
    ['pskcxml', 'application/pskc+xml'],
    ['pti', 'image/prs.pti'],
    ['ptid', 'application/vnd.pvi.ptid1'],
    ['pub', 'application/x-mspublisher'],
    ['pvb', 'application/vnd.3gpp.pic-bw-var'],
    ['pwn', 'application/vnd.3m.post-it-notes'],
    ['pya', 'audio/vnd.ms-playready.media.pya'],
    ['pyv', 'video/vnd.ms-playready.media.pyv'],
    ['qam', 'application/vnd.epson.quickanime'],
    ['qbo', 'application/vnd.intu.qbo'],
    ['qfx', 'application/vnd.intu.qfx'],
    ['qps', 'application/vnd.publishare-delta-tree'],
    ['qt', 'video/quicktime'],
    ['qwd', 'application/vnd.quark.quarkxpress'],
    ['qwt', 'application/vnd.quark.quarkxpress'],
    ['qxb', 'application/vnd.quark.quarkxpress'],
    ['qxd', 'application/vnd.quark.quarkxpress'],
    ['qxl', 'application/vnd.quark.quarkxpress'],
    ['qxt', 'application/vnd.quark.quarkxpress'],
    ['ra', 'audio/x-realaudio'],
    ['ram', 'audio/x-pn-realaudio'],
    ['raml', 'application/raml+yaml'],
    ['rapd', 'application/route-apd+xml'],
    ['rar', 'application/x-rar'],
    ['ras', 'image/x-cmu-raster'],
    ['rcprofile', 'application/vnd.ipunplugged.rcprofile'],
    ['rdf', 'application/rdf+xml'],
    ['rdz', 'application/vnd.data-vision.rdz'],
    ['relo', 'application/p2p-overlay+xml'],
    ['rep', 'application/vnd.businessobjects'],
    ['res', 'application/x-dtbresource+xml'],
    ['rgb', 'image/x-rgb'],
    ['rif', 'application/reginfo+xml'],
    ['rip', 'audio/vnd.rip'],
    ['ris', 'application/x-research-info-systems'],
    ['rl', 'application/resource-lists+xml'],
    ['rlc', 'image/vnd.fujixerox.edmics-rlc'],
    ['rld', 'application/resource-lists-diff+xml'],
    ['rm', 'audio/x-pn-realaudio'],
    ['rmi', 'audio/midi'],
    ['rmp', 'audio/x-pn-realaudio-plugin'],
    ['rms', 'application/vnd.jcp.javame.midlet-rms'],
    ['rmvb', 'application/vnd.rn-realmedia-vbr'],
    ['rnc', 'application/relax-ng-compact-syntax'],
    ['rng', 'application/xml'],
    ['roa', 'application/rpki-roa'],
    ['roff', 'text/troff'],
    ['rp9', 'application/vnd.cloanto.rp9'],
    ['rpm', 'audio/x-pn-realaudio-plugin'],
    ['rpss', 'application/vnd.nokia.radio-presets'],
    ['rpst', 'application/vnd.nokia.radio-preset'],
    ['rq', 'application/sparql-query'],
    ['rs', 'application/rls-services+xml'],
    ['rsa', 'application/x-pkcs7'],
    ['rsat', 'application/atsc-rsat+xml'],
    ['rsd', 'application/rsd+xml'],
    ['rsheet', 'application/urc-ressheet+xml'],
    ['rss', 'application/rss+xml'],
    ['rtf', 'text/rtf'],
    ['rtx', 'text/richtext'],
    ['run', 'application/x-makeself'],
    ['rusd', 'application/route-usd+xml'],
    ['rv', 'video/vnd.rn-realvideo'],
    ['s', 'text/x-asm'],
    ['s3m', 'audio/s3m'],
    ['saf', 'application/vnd.yamaha.smaf-audio'],
    ['sass', 'text/x-sass'],
    ['sbml', 'application/sbml+xml'],
    ['sc', 'application/vnd.ibm.secure-container'],
    ['scd', 'application/x-msschedule'],
    ['scm', 'application/vnd.lotus-screencam'],
    ['scq', 'application/scvp-cv-request'],
    ['scs', 'application/scvp-cv-response'],
    ['scss', 'text/x-scss'],
    ['scurl', 'text/vnd.curl.scurl'],
    ['sda', 'application/vnd.stardivision.draw'],
    ['sdc', 'application/vnd.stardivision.calc'],
    ['sdd', 'application/vnd.stardivision.impress'],
    ['sdkd', 'application/vnd.solent.sdkm+xml'],
    ['sdkm', 'application/vnd.solent.sdkm+xml'],
    ['sdp', 'application/sdp'],
    ['sdw', 'application/vnd.stardivision.writer'],
    ['sea', 'application/octet-stream'],
    ['see', 'application/vnd.seemail'],
    ['seed', 'application/vnd.fdsn.seed'],
    ['sema', 'application/vnd.sema'],
    ['semd', 'application/vnd.semd'],
    ['semf', 'application/vnd.semf'],
    ['senmlx', 'application/senml+xml'],
    ['sensmlx', 'application/sensml+xml'],
    ['ser', 'application/java-serialized-object'],
    ['setpay', 'application/set-payment-initiation'],
    ['setreg', 'application/set-registration-initiation'],
    ['sfd-hdstx', 'application/vnd.hydrostatix.sof-data'],
    ['sfs', 'application/vnd.spotfire.sfs'],
    ['sfv', 'text/x-sfv'],
    ['sgi', 'image/sgi'],
    ['sgl', 'application/vnd.stardivision.writer-global'],
    ['sgm', 'text/sgml'],
    ['sgml', 'text/sgml'],
    ['sh', 'application/x-sh'],
    ['shar', 'application/x-shar'],
    ['shex', 'text/shex'],
    ['shf', 'application/shf+xml'],
    ['shtml', 'text/html'],
    ['sid', 'image/x-mrsid-image'],
    ['sieve', 'application/sieve'],
    ['sig', 'application/pgp-signature'],
    ['sil', 'audio/silk'],
    ['silo', 'model/mesh'],
    ['sis', 'application/vnd.symbian.install'],
    ['sisx', 'application/vnd.symbian.install'],
    ['sit', 'application/x-stuffit'],
    ['sitx', 'application/x-stuffitx'],
    ['siv', 'application/sieve'],
    ['skd', 'application/vnd.koan'],
    ['skm', 'application/vnd.koan'],
    ['skp', 'application/vnd.koan'],
    ['skt', 'application/vnd.koan'],
    ['sldm', 'application/vnd.ms-powerpoint.slide.macroenabled.12'],
    ['sldx', 'application/vnd.openxmlformats-officedocument.presentationml.slide'],
    ['slim', 'text/slim'],
    ['slm', 'text/slim'],
    ['sls', 'application/route-s-tsid+xml'],
    ['slt', 'application/vnd.epson.salt'],
    ['sm', 'application/vnd.stepmania.stepchart'],
    ['smf', 'application/vnd.stardivision.math'],
    ['smi', 'application/smil'],
    ['smil', 'application/smil'],
    ['smv', 'video/x-smv'],
    ['smzip', 'application/vnd.stepmania.package'],
    ['snd', 'audio/basic'],
    ['snf', 'application/x-font-snf'],
    ['so', 'application/octet-stream'],
    ['spc', 'application/x-pkcs7-certificates'],
    ['spdx', 'text/spdx'],
    ['spf', 'application/vnd.yamaha.smaf-phrase'],
    ['spl', 'application/x-futuresplash'],
    ['spot', 'text/vnd.in3d.spot'],
    ['spp', 'application/scvp-vp-response'],
    ['spq', 'application/scvp-vp-request'],
    ['spx', 'audio/ogg'],
    ['sql', 'application/x-sql'],
    ['src', 'application/x-wais-source'],
    ['srt', 'application/x-subrip'],
    ['sru', 'application/sru+xml'],
    ['srx', 'application/sparql-results+xml'],
    ['ssdl', 'application/ssdl+xml'],
    ['sse', 'application/vnd.kodak-descriptor'],
    ['ssf', 'application/vnd.epson.ssf'],
    ['ssml', 'application/ssml+xml'],
    ['sst', 'application/octet-stream'],
    ['st', 'application/vnd.sailingtracker.track'],
    ['stc', 'application/vnd.sun.xml.calc.template'],
    ['std', 'application/vnd.sun.xml.draw.template'],
    ['stf', 'application/vnd.wt.stf'],
    ['sti', 'application/vnd.sun.xml.impress.template'],
    ['stk', 'application/hyperstudio'],
    ['stl', 'model/stl'],
    ['stpx', 'model/step+xml'],
    ['stpxz', 'model/step-xml+zip'],
    ['stpz', 'model/step+zip'],
    ['str', 'application/vnd.pg.format'],
    ['stw', 'application/vnd.sun.xml.writer.template'],
    ['styl', 'text/stylus'],
    ['stylus', 'text/stylus'],
    ['sub', 'text/vnd.dvb.subtitle'],
    ['sus', 'application/vnd.sus-calendar'],
    ['susp', 'application/vnd.sus-calendar'],
    ['sv4cpio', 'application/x-sv4cpio'],
    ['sv4crc', 'application/x-sv4crc'],
    ['svc', 'application/vnd.dvb.service'],
    ['svd', 'application/vnd.svd'],
    ['svg', 'image/svg+xml'],
    ['svgz', 'image/svg+xml'],
    ['swa', 'application/x-director'],
    ['swf', 'application/x-shockwave-flash'],
    ['swi', 'application/vnd.aristanetworks.swi'],
    ['swidtag', 'application/swid+xml'],
    ['sxc', 'application/vnd.sun.xml.calc'],
    ['sxd', 'application/vnd.sun.xml.draw'],
    ['sxg', 'application/vnd.sun.xml.writer.global'],
    ['sxi', 'application/vnd.sun.xml.impress'],
    ['sxm', 'application/vnd.sun.xml.math'],
    ['sxw', 'application/vnd.sun.xml.writer'],
    ['t', 'text/troff'],
    ['t3', 'application/x-t3vm-image'],
    ['t38', 'image/t38'],
    ['taglet', 'application/vnd.mynfc'],
    ['tao', 'application/vnd.tao.intent-module-archive'],
    ['tap', 'image/vnd.tencent.tap'],
    ['tar', 'application/x-tar'],
    ['tcap', 'application/vnd.3gpp2.tcap'],
    ['tcl', 'application/x-tcl'],
    ['td', 'application/urc-targetdesc+xml'],
    ['teacher', 'application/vnd.smart.teacher'],
    ['tei', 'application/tei+xml'],
    ['teicorpus', 'application/tei+xml'],
    ['tex', 'application/x-tex'],
    ['texi', 'application/x-texinfo'],
    ['texinfo', 'application/x-texinfo'],
    ['text', 'text/plain'],
    ['tfi', 'application/thraud+xml'],
    ['tfm', 'application/x-tex-tfm'],
    ['tfx', 'image/tiff-fx'],
    ['tga', 'image/x-tga'],
    ['tgz', 'application/x-tar'],
    ['thmx', 'application/vnd.ms-officetheme'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['tk', 'application/x-tcl'],
    ['tmo', 'application/vnd.tmobile-livetv'],
    ['toml', 'application/toml'],
    ['torrent', 'application/x-bittorrent'],
    ['tpl', 'application/vnd.groove-tool-template'],
    ['tpt', 'application/vnd.trid.tpt'],
    ['tr', 'text/troff'],
    ['tra', 'application/vnd.trueapp'],
    ['trig', 'application/trig'],
    ['trm', 'application/x-msterminal'],
    ['ts', 'video/mp2t'],
    ['tsd', 'application/timestamped-data'],
    ['tsv', 'text/tab-separated-values'],
    ['ttc', 'font/collection'],
    ['ttf', 'font/ttf'],
    ['ttl', 'text/turtle'],
    ['ttml', 'application/ttml+xml'],
    ['twd', 'application/vnd.simtech-mindmapper'],
    ['twds', 'application/vnd.simtech-mindmapper'],
    ['txd', 'application/vnd.genomatix.tuxedo'],
    ['txf', 'application/vnd.mobius.txf'],
    ['txt', 'text/plain'],
    ['u8dsn', 'message/global-delivery-status'],
    ['u8hdr', 'message/global-headers'],
    ['u8mdn', 'message/global-disposition-notification'],
    ['u8msg', 'message/global'],
    ['u32', 'application/x-authorware-bin'],
    ['ubj', 'application/ubjson'],
    ['udeb', 'application/x-debian-package'],
    ['ufd', 'application/vnd.ufdl'],
    ['ufdl', 'application/vnd.ufdl'],
    ['ulx', 'application/x-glulx'],
    ['umj', 'application/vnd.umajin'],
    ['unityweb', 'application/vnd.unity'],
    ['uoml', 'application/vnd.uoml+xml'],
    ['uri', 'text/uri-list'],
    ['uris', 'text/uri-list'],
    ['urls', 'text/uri-list'],
    ['usdz', 'model/vnd.usdz+zip'],
    ['ustar', 'application/x-ustar'],
    ['utz', 'application/vnd.uiq.theme'],
    ['uu', 'text/x-uuencode'],
    ['uva', 'audio/vnd.dece.audio'],
    ['uvd', 'application/vnd.dece.data'],
    ['uvf', 'application/vnd.dece.data'],
    ['uvg', 'image/vnd.dece.graphic'],
    ['uvh', 'video/vnd.dece.hd'],
    ['uvi', 'image/vnd.dece.graphic'],
    ['uvm', 'video/vnd.dece.mobile'],
    ['uvp', 'video/vnd.dece.pd'],
    ['uvs', 'video/vnd.dece.sd'],
    ['uvt', 'application/vnd.dece.ttml+xml'],
    ['uvu', 'video/vnd.uvvu.mp4'],
    ['uvv', 'video/vnd.dece.video'],
    ['uvva', 'audio/vnd.dece.audio'],
    ['uvvd', 'application/vnd.dece.data'],
    ['uvvf', 'application/vnd.dece.data'],
    ['uvvg', 'image/vnd.dece.graphic'],
    ['uvvh', 'video/vnd.dece.hd'],
    ['uvvi', 'image/vnd.dece.graphic'],
    ['uvvm', 'video/vnd.dece.mobile'],
    ['uvvp', 'video/vnd.dece.pd'],
    ['uvvs', 'video/vnd.dece.sd'],
    ['uvvt', 'application/vnd.dece.ttml+xml'],
    ['uvvu', 'video/vnd.uvvu.mp4'],
    ['uvvv', 'video/vnd.dece.video'],
    ['uvvx', 'application/vnd.dece.unspecified'],
    ['uvvz', 'application/vnd.dece.zip'],
    ['uvx', 'application/vnd.dece.unspecified'],
    ['uvz', 'application/vnd.dece.zip'],
    ['vbox', 'application/x-virtualbox-vbox'],
    ['vbox-extpack', 'application/x-virtualbox-vbox-extpack'],
    ['vcard', 'text/vcard'],
    ['vcd', 'application/x-cdlink'],
    ['vcf', 'text/x-vcard'],
    ['vcg', 'application/vnd.groove-vcard'],
    ['vcs', 'text/x-vcalendar'],
    ['vcx', 'application/vnd.vcx'],
    ['vdi', 'application/x-virtualbox-vdi'],
    ['vds', 'model/vnd.sap.vds'],
    ['vhd', 'application/x-virtualbox-vhd'],
    ['vis', 'application/vnd.visionary'],
    ['viv', 'video/vnd.vivo'],
    ['vlc', 'application/videolan'],
    ['vmdk', 'application/x-virtualbox-vmdk'],
    ['vob', 'video/x-ms-vob'],
    ['vor', 'application/vnd.stardivision.writer'],
    ['vox', 'application/x-authorware-bin'],
    ['vrml', 'model/vrml'],
    ['vsd', 'application/vnd.visio'],
    ['vsf', 'application/vnd.vsf'],
    ['vss', 'application/vnd.visio'],
    ['vst', 'application/vnd.visio'],
    ['vsw', 'application/vnd.visio'],
    ['vtf', 'image/vnd.valve.source.texture'],
    ['vtt', 'text/vtt'],
    ['vtu', 'model/vnd.vtu'],
    ['vxml', 'application/voicexml+xml'],
    ['w3d', 'application/x-director'],
    ['wad', 'application/x-doom'],
    ['wadl', 'application/vnd.sun.wadl+xml'],
    ['war', 'application/java-archive'],
    ['wasm', 'application/wasm'],
    ['wav', 'audio/x-wav'],
    ['wax', 'audio/x-ms-wax'],
    ['wbmp', 'image/vnd.wap.wbmp'],
    ['wbs', 'application/vnd.criticaltools.wbs+xml'],
    ['wbxml', 'application/wbxml'],
    ['wcm', 'application/vnd.ms-works'],
    ['wdb', 'application/vnd.ms-works'],
    ['wdp', 'image/vnd.ms-photo'],
    ['weba', 'audio/webm'],
    ['webapp', 'application/x-web-app-manifest+json'],
    ['webm', 'video/webm'],
    ['webmanifest', 'application/manifest+json'],
    ['webp', 'image/webp'],
    ['wg', 'application/vnd.pmi.widget'],
    ['wgt', 'application/widget'],
    ['wks', 'application/vnd.ms-works'],
    ['wm', 'video/x-ms-wm'],
    ['wma', 'audio/x-ms-wma'],
    ['wmd', 'application/x-ms-wmd'],
    ['wmf', 'image/wmf'],
    ['wml', 'text/vnd.wap.wml'],
    ['wmlc', 'application/wmlc'],
    ['wmls', 'text/vnd.wap.wmlscript'],
    ['wmlsc', 'application/vnd.wap.wmlscriptc'],
    ['wmv', 'video/x-ms-wmv'],
    ['wmx', 'video/x-ms-wmx'],
    ['wmz', 'application/x-msmetafile'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['word', 'application/msword'],
    ['wpd', 'application/vnd.wordperfect'],
    ['wpl', 'application/vnd.ms-wpl'],
    ['wps', 'application/vnd.ms-works'],
    ['wqd', 'application/vnd.wqd'],
    ['wri', 'application/x-mswrite'],
    ['wrl', 'model/vrml'],
    ['wsc', 'message/vnd.wfa.wsc'],
    ['wsdl', 'application/wsdl+xml'],
    ['wspolicy', 'application/wspolicy+xml'],
    ['wtb', 'application/vnd.webturbo'],
    ['wvx', 'video/x-ms-wvx'],
    ['x3d', 'model/x3d+xml'],
    ['x3db', 'model/x3d+fastinfoset'],
    ['x3dbz', 'model/x3d+binary'],
    ['x3dv', 'model/x3d-vrml'],
    ['x3dvz', 'model/x3d+vrml'],
    ['x3dz', 'model/x3d+xml'],
    ['x32', 'application/x-authorware-bin'],
    ['x_b', 'model/vnd.parasolid.transmit.binary'],
    ['x_t', 'model/vnd.parasolid.transmit.text'],
    ['xaml', 'application/xaml+xml'],
    ['xap', 'application/x-silverlight-app'],
    ['xar', 'application/vnd.xara'],
    ['xav', 'application/xcap-att+xml'],
    ['xbap', 'application/x-ms-xbap'],
    ['xbd', 'application/vnd.fujixerox.docuworks.binder'],
    ['xbm', 'image/x-xbitmap'],
    ['xca', 'application/xcap-caps+xml'],
    ['xcs', 'application/calendar+xml'],
    ['xdf', 'application/xcap-diff+xml'],
    ['xdm', 'application/vnd.syncml.dm+xml'],
    ['xdp', 'application/vnd.adobe.xdp+xml'],
    ['xdssc', 'application/dssc+xml'],
    ['xdw', 'application/vnd.fujixerox.docuworks'],
    ['xel', 'application/xcap-el+xml'],
    ['xenc', 'application/xenc+xml'],
    ['xer', 'application/patch-ops-error+xml'],
    ['xfdf', 'application/vnd.adobe.xfdf'],
    ['xfdl', 'application/vnd.xfdl'],
    ['xht', 'application/xhtml+xml'],
    ['xhtml', 'application/xhtml+xml'],
    ['xhvml', 'application/xv+xml'],
    ['xif', 'image/vnd.xiff'],
    ['xl', 'application/excel'],
    ['xla', 'application/vnd.ms-excel'],
    ['xlam', 'application/vnd.ms-excel.addin.macroEnabled.12'],
    ['xlc', 'application/vnd.ms-excel'],
    ['xlf', 'application/xliff+xml'],
    ['xlm', 'application/vnd.ms-excel'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsb', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'],
    ['xlsm', 'application/vnd.ms-excel.sheet.macroEnabled.12'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xlt', 'application/vnd.ms-excel'],
    ['xltm', 'application/vnd.ms-excel.template.macroEnabled.12'],
    ['xltx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'],
    ['xlw', 'application/vnd.ms-excel'],
    ['xm', 'audio/xm'],
    ['xml', 'application/xml'],
    ['xns', 'application/xcap-ns+xml'],
    ['xo', 'application/vnd.olpc-sugar'],
    ['xop', 'application/xop+xml'],
    ['xpi', 'application/x-xpinstall'],
    ['xpl', 'application/xproc+xml'],
    ['xpm', 'image/x-xpixmap'],
    ['xpr', 'application/vnd.is-xpr'],
    ['xps', 'application/vnd.ms-xpsdocument'],
    ['xpw', 'application/vnd.intercon.formnet'],
    ['xpx', 'application/vnd.intercon.formnet'],
    ['xsd', 'application/xml'],
    ['xsl', 'application/xml'],
    ['xslt', 'application/xslt+xml'],
    ['xsm', 'application/vnd.syncml+xml'],
    ['xspf', 'application/xspf+xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['xvm', 'application/xv+xml'],
    ['xvml', 'application/xv+xml'],
    ['xwd', 'image/x-xwindowdump'],
    ['xyz', 'chemical/x-xyz'],
    ['xz', 'application/x-xz'],
    ['yaml', 'text/yaml'],
    ['yang', 'application/yang'],
    ['yin', 'application/yin+xml'],
    ['yml', 'text/yaml'],
    ['ymp', 'text/x-suse-ymp'],
    ['z', 'application/x-compress'],
    ['z1', 'application/x-zmachine'],
    ['z2', 'application/x-zmachine'],
    ['z3', 'application/x-zmachine'],
    ['z4', 'application/x-zmachine'],
    ['z5', 'application/x-zmachine'],
    ['z6', 'application/x-zmachine'],
    ['z7', 'application/x-zmachine'],
    ['z8', 'application/x-zmachine'],
    ['zaz', 'application/vnd.zzazz.deck+xml'],
    ['zip', 'application/zip'],
    ['zir', 'application/vnd.zul'],
    ['zirz', 'application/vnd.zul'],
    ['zmm', 'application/vnd.handheld-entertainment+xml'],
    ['zsh', 'text/x-scriptzsh']
]);
function toFileWithPath(file, path, h) {
    const f = withMimeType(file);
    const { webkitRelativePath } = file;
    const p = typeof path === 'string'
        ? path
        // If <input webkitdirectory> is set,
        // the File will have a {webkitRelativePath} property
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
        : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
            ? webkitRelativePath
            : `./${file.name}`;
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        setObjProp(f, 'path', p);
    }
    if (h !== undefined) {
        Object.defineProperty(f, 'handle', {
            value: h,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    // Always populate a relative path so that even electron apps have access to a relativePath value
    setObjProp(f, 'relativePath', p);
    return f;
}
function withMimeType(file) {
    const { name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.')
            .pop().toLowerCase();
        const type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
function setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}
//# sourceMappingURL=file.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es2015/file-selector.js


const FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store', // macOs
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
            return getDataTransferFiles(evt.dataTransfer, evt.type);
        }
        else if (isChangeEvt(evt)) {
            return getInputFiles(evt);
        }
        else if (Array.isArray(evt) && evt.every(item => 'getFile' in item && typeof item.getFile === 'function')) {
            return getFsHandleFiles(evt);
        }
        return [];
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(file => toFileWithPath(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function* () {
        const files = yield Promise.all(handles.map(h => h.getFile()));
        return files.map(file => toFileWithPath(file));
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function* () {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = fromList(dt.items)
                .filter(item => item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') {
                return items;
            }
            const files = yield Promise.all(items.map(toFilePromises));
            return noIgnoredFiles(flatten(files));
        }
        return noIgnoredFiles(fromList(dt.files)
            .map(file => toFileWithPath(file)));
    });
}
function noIgnoredFiles(files) {
    return files.filter(file => FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    const files = [];
    // tslint:disable: prefer-for-of
    for (let i = 0; i < items.length; i++) {
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item, entry);
}
function flatten(items) {
    return items.reduce((acc, files) => [
        ...acc,
        ...(Array.isArray(files) ? flatten(files) : [files])
    ], []);
}
function fromDataTransferItem(item, entry) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) {
                throw new Error(`${item} is not a File`);
            }
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return toFileWithPath(file);
            }
        }
        const file = item.getAsFile();
        if (!file) {
            throw new Error(`${item} is not a File`);
        }
        const fwp = toFileWithPath(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function* () {
        return entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject) => {
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch) => __awaiter(this, void 0, void 0, function* () {
                if (!batch.length) {
                    // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    }
                    catch (err) {
                        reject(err);
                    }
                }
                else {
                    const items = Promise.all(batch.map(fromEntry));
                    entries.push(items);
                    // Continue reading
                    readEntries();
                }
            }), (err) => {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            entry.file((file) => {
                const fwp = toFileWithPath(file, entry.fullPath);
                resolve(fwp);
            }, (err) => {
                reject(err);
            });
        });
    });
}
//# sourceMappingURL=file-selector.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es2015/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/es/index.js
var es = __webpack_require__(58363);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var accepts = typeof es === "function" ? es : es["default"]; // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
};
/**
 *
 * @param {string} accept
 */

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr() {
  var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var acceptArr = accept.split(",");
  var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(msg)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
/**
 * Check if the given file is a DataTransferItem with an empty type.
 *
 * During drag events, browsers may return DataTransferItem objects instead of File objects.
 * Some browsers (e.g., Chrome) return an empty MIME type for certain file types (like .md files)
 * on DataTransferItem during drag events, even though the type is correctly set during drop.
 *
 * This function detects such cases by checking for:
 * 1. Empty type string
 * 2. Presence of getAsFile method (indicates it's a DataTransferItem, not a File)
 *
 * We accept these during drag to provide proper UI feedback, while maintaining
 * strict validation during drop when real File objects are available.
 *
 * @param {File | DataTransferItem} file
 * @returns {boolean}
 */

function isDataTransferItemWithEmptyType(file) {
  return file.type === "" && typeof file.getAsFile === "function";
}
/**
 * Check if file is accepted.
 *
 * Firefox versions prior to 53 return a bogus MIME type for every file drag,
 * so dragovers with that MIME type will always be accepted.
 *
 * Chrome/other browsers may return an empty MIME type for files during drag events,
 * so we accept those as well (we'll validate properly on drop).
 *
 * @param {File} file
 * @param {string} accept
 * @returns
 */

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept) || isDataTransferItemWithEmptyType(file);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function isKindFile(item) {
  return _typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray(a), [mimeType], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function es_toConsumableArray(arr) { return es_arrayWithoutHoles(arr) || es_iterableToArray(arr) || es_unsupportedIterableToArray(arr) || es_nonIterableSpread(); }

function es_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function es_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return es_arrayLikeToArray(arr); }

function es_slicedToArray(arr, i) { return es_arrayWithHoles(arr) || es_iterableToArrayLimit(arr, i) || es_unsupportedIterableToArray(arr, i) || es_nonIterableRest(); }

function es_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return es_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return es_arrayLikeToArray(o, minLen); }

function es_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function es_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function es_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es_ownKeys(Object(source), !0).forEach(function (key) { es_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  (0,react.useImperativeHandle)(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/react.createElement(react.Fragment, null, children(es_objectSpread(es_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: prop_types.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: prop_types.objectOf(prop_types.arrayOf(prop_types.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: prop_types.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: prop_types.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: prop_types.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: prop_types.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: prop_types.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: prop_types.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: prop_types.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: prop_types.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: prop_types.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: prop_types.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: prop_types.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: prop_types.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: prop_types.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: prop_types.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: prop_types.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: prop_types.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: prop_types.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: prop_types.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: prop_types.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: prop_types.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: prop_types.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: prop_types.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: prop_types.func
};
/* harmony default export */ var dist_es = ((/* unused pure expression or super */ null && (Dropzone)));
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {boolean} isDragGlobal Files are being dragged anywhere on the document
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  isDragGlobal: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = es_objectSpread(es_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = (0,react.useMemo)(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = (0,react.useMemo)(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = (0,react.useMemo)(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = (0,react.useMemo)(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = es_slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = (0,react.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = (0,react.useRef)([]);
  var globalDragTargetsRef = (0,react.useRef)([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  (0,react.useEffect)(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Track global drag state for document-level drag events

  (0,react.useEffect)(function () {
    var onDocumentDragEnter = function onDocumentDragEnter(event) {
      globalDragTargetsRef.current = [].concat(es_toConsumableArray(globalDragTargetsRef.current), [event.target]);

      if (isEvtWithFiles(event)) {
        dispatch({
          isDragGlobal: true,
          type: "setDragGlobal"
        });
      }
    };

    var onDocumentDragLeave = function onDocumentDragLeave(event) {
      // Only deactivate once we've left all children
      globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function (el) {
        return el !== event.target && el !== null;
      });

      if (globalDragTargetsRef.current.length > 0) {
        return;
      }

      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };

    var onDocumentDragEnd = function onDocumentDragEnd() {
      globalDragTargetsRef.current = [];
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };

    var onDocumentDropGlobal = function onDocumentDropGlobal() {
      globalDragTargetsRef.current = [];
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };

    document.addEventListener("dragenter", onDocumentDragEnter, false);
    document.addEventListener("dragleave", onDocumentDragLeave, false);
    document.addEventListener("dragend", onDocumentDragEnd, false);
    document.addEventListener("drop", onDocumentDropGlobal, false);
    return function () {
      document.removeEventListener("dragenter", onDocumentDragEnter);
      document.removeEventListener("dragleave", onDocumentDragLeave);
      document.removeEventListener("dragend", onDocumentDragEnd);
      document.removeEventListener("drop", onDocumentDropGlobal);
    };
  }, [rootRef]); // Auto focus the root when autoFocus is true

  (0,react.useEffect)(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = (0,react.useCallback)(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(es_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = (0,react.useCallback)(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = es_slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = es_slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      isDragReject: fileRejections.length > 0,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = (0,react.useCallback)(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = (0,react.useCallback)(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = (0,react.useCallback)(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = (0,react.useCallback)(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = (0,react.useCallback)(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = (0,react.useMemo)(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return es_objectSpread(es_objectSpread(es_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0,react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0,react.useMemo)(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = es_defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return es_objectSpread(es_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return es_objectSpread(es_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return es_objectSpread(es_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections,
        isDragReject: action.isDragReject
      });

    case "setDragGlobal":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isDragGlobal: action.isDragGlobal
      });

    case "reset":
      return es_objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}



/***/ }),

/***/ 67421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$G": function() { return /* reexport */ useTranslation_useTranslation; },
  "Zh": function() { return /* reexport */ withTranslation; }
});

// UNUSED EXPORTS: I18nContext, I18nextProvider, Trans, TransWithoutContext, Translation, composeInitialProps, date, getDefaults, getI18n, getInitialProps, initReactI18next, number, plural, select, selectOrdinal, setDefaults, setI18n, time, useSSR, withSSR

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  utils_warn.apply(void 0, args);
}

var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  };
};

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function utils_getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/defaults.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function defaults_getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/TransWithoutContext.js



var _excluded = (/* unused pure expression or super */ null && (["format"])),
    _excluded2 = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function TransWithoutContext_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TransWithoutContext_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TransWithoutContext_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TransWithoutContext_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = TransWithoutContext_objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof(child) === 'object') {
      var format = child.format,
          clone = _objectWithoutProperties(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof(child) === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = HTML.parse("<0>".concat(targetString, "</0>"));

  var opts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, _excluded2);

  var i18n = i18nFromProps || getI18n();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, getDefaults()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/i18nInstance.js
var i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function i18nInstance_getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/initReactI18next.js


var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function context_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function context_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { context_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { context_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var context_I18nContext = (0,react.createContext)();
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function context_composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(context_objectSpread(context_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js


var Trans_excluded = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function Trans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Trans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Trans_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Trans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function Trans_Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, Trans_excluded);

  var _ref2 = useContext(I18nContext) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  var t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext(Trans_objectSpread({
    children: children,
    count: count,
    parent: parent,
    i18nKey: i18nKey,
    context: context,
    tOptions: tOptions,
    values: values,
    defaults: defaults,
    components: components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n: i18n,
    t: tFromProps,
    shouldUnescape: shouldUnescape
  }, additionalProps));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js




function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation_useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context_I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || i18nInstance_getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    utils_warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && (0,esm_typeof/* default */.Z)(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) utils_warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, defaults_getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      }
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, function () {
        return resolve();
      });
    } else {
      loadNamespaces(i18n, namespaces, function () {
        return resolve();
      });
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



var withTranslation_excluded = ["forwardedRef"];

function withTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref, withTranslation_excluded);

      var _useTranslation = useTranslation_useTranslation(ns, withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = (0,slicedToArray/* default */.Z)(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return (0,react.createElement)(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(utils_getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return (0,react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? (0,react.forwardRef)(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Translation.js


var Translation_excluded = (/* unused pure expression or super */ null && (["ns", "children"]));

function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = _objectWithoutProperties(props, Translation_excluded);

  var _useTranslation = useTranslation(ns, options),
      _useTranslation2 = _slicedToArray(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = useMemo(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useSSR.js


function useSSR_useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withSSR.js


var withSSR_excluded = (/* unused pure expression or super */ null && (["initialI18nStore", "initialLanguage"]));

function withSSR_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withSSR_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withSSR_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withSSR_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = _objectWithoutProperties(_ref, withSSR_excluded);

      useSSR(initialI18nStore, initialLanguage);
      return createElement(WrappedComponent, withSSR_objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/index.js












var date = function date() {
  return '';
};
var time = function time() {
  return '';
};
var number = function number() {
  return '';
};
var es_select = function select() {
  return '';
};
var plural = function plural() {
  return '';
};
var selectOrdinal = function selectOrdinal() {
  return '';
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(23837), __webpack_exec__(80880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);